const NumberToInt = (name: string, x: number) => {
  const ret = Math.round(x);
  if(Math.abs(ret - x) > 0.001) {
    console.warn(`Expected int32 but was double for ${name}:`, x, 'became', ret);
  }
  return ret;
};
export type JsonNumber = number | 'NaN' | 'Infinity' | '-Infinity'
const AsNum = (x: JsonNumber) => {
  if(x === 'NaN') return Number.NaN
  if(x === 'Infinity') return Number.POSITIVE_INFINITY
  if(x === '-Infinity') return Number.NEGATIVE_INFINITY
  return x;
};
const AsJsonNum = (x: number) => {
  if(Number.isNaN(x)) return 'NaN'
  if(x === Number.POSITIVE_INFINITY) return 'Infinity'
  if(x === Number.NEGATIVE_INFINITY) return '-Infinity'
  return x;
};


// Defined in solve.proto
export namespace SOLVE {
    export enum res {
        displacements = 0,
        reactions = 1,
        stresses = 2,
        section_forces = 3,
        temperatures = 4,
        section_props = 5
    }
    export const res_FromObject = (src: unknown): res => {
        if (typeof src == 'string') { src = src.trim(); }
        switch (src) {
            case 0:
            case 'displacements':
                return res.displacements;
            case 1:
            case 'reactions':
                return res.reactions;
            case 2:
            case 'stresses':
                return res.stresses;
            case 3:
            case 'section_forces':
                return res.section_forces;
            case 4:
            case 'temperatures':
                return res.temperatures;
            case 5:
            case 'section_props':
                return res.section_props;
            default:
                console.log('Unhandled value for res:' + src + '. ' + typeof(src));
                return res.displacements;
        }
    };
    export const res_ToObject = (src: res): string | null => {
        switch (src) {
            case res.displacements:
                return 'displacements';
            case res.reactions:
                return 'reactions';
            case res.stresses:
                return 'stresses';
            case res.section_forces:
                return 'section_forces';
            case res.temperatures:
                return 'temperatures';
            case res.section_props:
                return 'section_props';
            default:
                console.error(`BUG TYPE ERROR: Expected enum for res, but got [${src}] a ${typeof src}!!!!`);
                return null;
        }
    };


    export type XYZ_keys = 'x' | 'y' | 'z';
    export interface XYZ_createType {
        x?: number,
        y?: number,
        z?: number,
    }
    export interface XYZ_json {
        x?: JsonNumber;
        y?: JsonNumber;
        z?: JsonNumber;
    }
    interface XYZ_json_in {
        __proto_name?: unknown;
        x?: unknown;
        y?: unknown;
        z?: unknown;
    }
    export class XYZ {
        __proto_name = "SOLVE.XYZ";
        x: number = 0;
        y: number = 0;
        z: number = 0;

        static fromObject(src_unknown: unknown): XYZ {
            const dst = new XYZ();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted XYZ but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as XYZ_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for XYZ but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.x !== undefined && src.x !== null) {
                if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                    dst.x = AsNum(src.x);
                }
                else {
                    console.log('Expected x of XYZ to be a number but was ', typeof src.x, src.x)
                }
            }
            if (src.y !== undefined && src.y !== null) {
                if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                    dst.y = AsNum(src.y);
                }
                else {
                    console.log('Expected y of XYZ to be a number but was ', typeof src.y, src.y)
                }
            }
            if (src.z !== undefined && src.z !== null) {
                if (typeof src.z === "number" || src.z === 'NaN' || src.z === 'Infinity' || src.z === '-Infinity') {
                    dst.z = AsNum(src.z);
                }
                else {
                    console.log('Expected z of XYZ to be a number but was ', typeof src.z, src.z)
                }
            }
            return dst;
        }

        static toObject(src: XYZ | null | undefined): XYZ_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.XYZ is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.XYZ") {
                console.error('Expected SOLVE.XYZ but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : XYZ_json = {
                x: AsJsonNum(src.x),
                y: AsJsonNum(src.y),
                z: AsJsonNum(src.z),
            };
            return dst;
        }

        static create(src?: XYZ_createType) {
            const dst = new XYZ();
            if (src === undefined) {
                return dst;
            }
            if (src.x !== undefined) {
                dst.x = src.x;
            }
            if (src.y !== undefined) {
                dst.y = src.y;
            }
            if (src.z !== undefined) {
                dst.z = src.z;
            }
            return dst;
        }

        shallowClone() {
            const dst = new XYZ();
            dst.x = this.x;
            dst.y = this.y;
            dst.z = this.z;
            return dst;
        }

        deepClone() {
            const json = XYZ.toObject(this);
            const dst = XYZ.fromObject(json);
            return dst;
        }
    }
    export type IXYZ = XYZ;


    export type RM_keys = 'r' | 'm' | 'lcid';
    export interface RM_createType {
        r?: SOLVE.XYZ[],
        m?: SOLVE.XYZ[],
        lcid?: string,
    }
    export interface RM_json {
        r: SOLVE.XYZ_json[];
        m: SOLVE.XYZ_json[];
        lcid?: string;
    }
    interface RM_json_in {
        __proto_name?: unknown;
        r?: unknown;
        m?: unknown;
        lcid?: unknown;
    }
    export class RM {
        __proto_name = "SOLVE.RM";
        r: SOLVE.XYZ[] = [];
        m: SOLVE.XYZ[] = [];
        lcid: string = "";

        static fromObject(src_unknown: unknown): RM {
            const dst = new RM();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted RM but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as RM_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for RM but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.r !== undefined && src.r !== null) {
                if (Array.isArray(src.r)) {
                    for (const element of src.r) {
                        dst.r.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected r of RM to be a array but was ', typeof src.r, src.r)
                }
            }
            if (src.m !== undefined && src.m !== null) {
                if (Array.isArray(src.m)) {
                    for (const element of src.m) {
                        dst.m.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected m of RM to be a array but was ', typeof src.m, src.m)
                }
            }
            if (src.lcid !== undefined && src.lcid !== null) {
                if (typeof src.lcid === "string") {
                    dst.lcid = src.lcid;
                }
                else {
                    console.log('Expected lcid of RM to be a string but was ', typeof src.lcid, src.lcid)
                }
            }
            return dst;
        }

        static toObject(src: RM | null | undefined): RM_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.RM is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.RM") {
                console.error('Expected SOLVE.RM but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : RM_json = {
                r: new Array<SOLVE.XYZ_json>(),
                m: new Array<SOLVE.XYZ_json>(),
                lcid: src.lcid,
            };
            if (src.r !== null) {
                for (const element of src.r) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.r.push(parsed);
                }
            }
            if (src.m !== null) {
                for (const element of src.m) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.m.push(parsed);
                }
            }
            return dst;
        }

        static create(src?: RM_createType) {
            const dst = new RM();
            if (src === undefined) {
                return dst;
            }
            if (src.r !== undefined) {
                dst.r = src.r;
            }
            if (src.m !== undefined) {
                dst.m = src.m;
            }
            if (src.lcid !== undefined) {
                dst.lcid = src.lcid;
            }
            return dst;
        }

        shallowClone() {
            const dst = new RM();
            dst.r = this.r;
            dst.m = this.m;
            dst.lcid = this.lcid;
            return dst;
        }

        deepClone() {
            const json = RM.toObject(this);
            const dst = RM.fromObject(json);
            return dst;
        }
    }
    export type IRM = RM;


    export type U_keys = 'trans' | 'rot' | 't' | 'lcid';
    export interface U_createType {
        trans?: SOLVE.XYZ[],
        rot?: SOLVE.XYZ[],
        t?: number[],
        lcid?: string,
    }
    export interface U_json {
        trans: SOLVE.XYZ_json[];
        rot: SOLVE.XYZ_json[];
        t: JsonNumber[];
        lcid?: string;
    }
    interface U_json_in {
        __proto_name?: unknown;
        trans?: unknown;
        rot?: unknown;
        t?: unknown;
        lcid?: unknown;
    }
    export class U {
        __proto_name = "SOLVE.U";
        trans: SOLVE.XYZ[] = [];
        rot: SOLVE.XYZ[] = [];
        t: number[] = [];
        lcid: string = "";

        static fromObject(src_unknown: unknown): U {
            const dst = new U();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted U but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as U_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for U but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.trans !== undefined && src.trans !== null) {
                if (Array.isArray(src.trans)) {
                    for (const element of src.trans) {
                        dst.trans.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected trans of U to be a array but was ', typeof src.trans, src.trans)
                }
            }
            if (src.rot !== undefined && src.rot !== null) {
                if (Array.isArray(src.rot)) {
                    for (const element of src.rot) {
                        dst.rot.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected rot of U to be a array but was ', typeof src.rot, src.rot)
                }
            }
            if (src.t !== undefined && src.t !== null) {
                if (Array.isArray(src.t)) {
                    for (const [index, element] of src.t.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.t.push(AsNum(element));
                        }
                        else {
                            console.log('Expected t of U[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected t of U to be a array but was ', typeof src.t, src.t)
                }
            }
            if (src.lcid !== undefined && src.lcid !== null) {
                if (typeof src.lcid === "string") {
                    dst.lcid = src.lcid;
                }
                else {
                    console.log('Expected lcid of U to be a string but was ', typeof src.lcid, src.lcid)
                }
            }
            return dst;
        }

        static toObject(src: U | null | undefined): U_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.U is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.U") {
                console.error('Expected SOLVE.U but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : U_json = {
                trans: new Array<SOLVE.XYZ_json>(),
                rot: new Array<SOLVE.XYZ_json>(),
                t: new Array<JsonNumber>(),
                lcid: src.lcid,
            };
            if (src.trans !== null) {
                for (const element of src.trans) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.trans.push(parsed);
                }
            }
            if (src.rot !== null) {
                for (const element of src.rot) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.rot.push(parsed);
                }
            }
            if (src.t !== null) {
                for (const element of src.t) {
                    dst.t.push(AsJsonNum(element));
                }
            }
            return dst;
        }

        static create(src?: U_createType) {
            const dst = new U();
            if (src === undefined) {
                return dst;
            }
            if (src.trans !== undefined) {
                dst.trans = src.trans;
            }
            if (src.rot !== undefined) {
                dst.rot = src.rot;
            }
            if (src.t !== undefined) {
                dst.t = src.t;
            }
            if (src.lcid !== undefined) {
                dst.lcid = src.lcid;
            }
            return dst;
        }

        shallowClone() {
            const dst = new U();
            dst.trans = this.trans;
            dst.rot = this.rot;
            dst.t = this.t;
            dst.lcid = this.lcid;
            return dst;
        }

        deepClone() {
            const json = U.toObject(this);
            const dst = U.fromObject(json);
            return dst;
        }
    }
    export type IU = U;


    export type ITER_keys = 'prevQX' | 'QX' | 'eps';
    export interface ITER_createType {
        prevQX?: number,
        QX?: number,
        eps?: number,
    }
    export interface ITER_json {
        prevQX?: JsonNumber;
        QX?: JsonNumber;
        eps?: JsonNumber;
    }
    interface ITER_json_in {
        __proto_name?: unknown;
        prevQX?: unknown;
        QX?: unknown;
        eps?: unknown;
    }
    export class ITER {
        __proto_name = "SOLVE.ITER";
        prevQX: number = 0;
        QX: number = 0;
        eps: number = 0;

        static fromObject(src_unknown: unknown): ITER {
            const dst = new ITER();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted ITER but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as ITER_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for ITER but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.prevQX !== undefined && src.prevQX !== null) {
                if (typeof src.prevQX === "number" || src.prevQX === 'NaN' || src.prevQX === 'Infinity' || src.prevQX === '-Infinity') {
                    dst.prevQX = AsNum(src.prevQX);
                }
                else {
                    console.log('Expected prevQX of ITER to be a number but was ', typeof src.prevQX, src.prevQX)
                }
            }
            if (src.QX !== undefined && src.QX !== null) {
                if (typeof src.QX === "number" || src.QX === 'NaN' || src.QX === 'Infinity' || src.QX === '-Infinity') {
                    dst.QX = AsNum(src.QX);
                }
                else {
                    console.log('Expected QX of ITER to be a number but was ', typeof src.QX, src.QX)
                }
            }
            if (src.eps !== undefined && src.eps !== null) {
                if (typeof src.eps === "number" || src.eps === 'NaN' || src.eps === 'Infinity' || src.eps === '-Infinity') {
                    dst.eps = AsNum(src.eps);
                }
                else {
                    console.log('Expected eps of ITER to be a number but was ', typeof src.eps, src.eps)
                }
            }
            return dst;
        }

        static toObject(src: ITER | null | undefined): ITER_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.ITER is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.ITER") {
                console.error('Expected SOLVE.ITER but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : ITER_json = {
                prevQX: AsJsonNum(src.prevQX),
                QX: AsJsonNum(src.QX),
                eps: AsJsonNum(src.eps),
            };
            return dst;
        }

        static create(src?: ITER_createType) {
            const dst = new ITER();
            if (src === undefined) {
                return dst;
            }
            if (src.prevQX !== undefined) {
                dst.prevQX = src.prevQX;
            }
            if (src.QX !== undefined) {
                dst.QX = src.QX;
            }
            if (src.eps !== undefined) {
                dst.eps = src.eps;
            }
            return dst;
        }

        shallowClone() {
            const dst = new ITER();
            dst.prevQX = this.prevQX;
            dst.QX = this.QX;
            dst.eps = this.eps;
            return dst;
        }

        deepClone() {
            const json = ITER.toObject(this);
            const dst = ITER.fromObject(json);
            return dst;
        }
    }
    export type IITER = ITER;


    export type BucklingRes_keys = 'bucklingLoad' | 'beta' | 'vals' | 'modes' | 'freqs' | 'dofs';
    export interface BucklingRes_createType {
        bucklingLoad?: number,
        beta?: number,
        vals?: number[],
        modes?: SOLVE.BucklingRes.mode[],
        freqs?: number[],
        dofs?: number[],
    }
    export interface BucklingRes_json {
        bucklingLoad?: JsonNumber;
        beta?: JsonNumber;
        vals: JsonNumber[];
        modes: SOLVE.BucklingRes.mode_json[];
        freqs: JsonNumber[];
        dofs: JsonNumber[];
    }
    interface BucklingRes_json_in {
        __proto_name?: unknown;
        bucklingLoad?: unknown;
        beta?: unknown;
        vals?: unknown;
        modes?: unknown;
        freqs?: unknown;
        dofs?: unknown;
    }
    export class BucklingRes {
        __proto_name = "SOLVE.BucklingRes";
        bucklingLoad: number = 0;
        beta: number = 0;
        vals: number[] = [];
        modes: SOLVE.BucklingRes.mode[] = [];
        freqs: number[] = [];
        dofs: number[] = [];

        static fromObject(src_unknown: unknown): BucklingRes {
            const dst = new BucklingRes();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted BucklingRes but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as BucklingRes_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for BucklingRes but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.bucklingLoad !== undefined && src.bucklingLoad !== null) {
                if (typeof src.bucklingLoad === "number" || src.bucklingLoad === 'NaN' || src.bucklingLoad === 'Infinity' || src.bucklingLoad === '-Infinity') {
                    dst.bucklingLoad = AsNum(src.bucklingLoad);
                }
                else {
                    console.log('Expected bucklingLoad of BucklingRes to be a number but was ', typeof src.bucklingLoad, src.bucklingLoad)
                }
            }
            if (src.beta !== undefined && src.beta !== null) {
                if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                    dst.beta = AsNum(src.beta);
                }
                else {
                    console.log('Expected beta of BucklingRes to be a number but was ', typeof src.beta, src.beta)
                }
            }
            if (src.vals !== undefined && src.vals !== null) {
                if (Array.isArray(src.vals)) {
                    for (const [index, element] of src.vals.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.vals.push(AsNum(element));
                        }
                        else {
                            console.log('Expected vals of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected vals of BucklingRes to be a array but was ', typeof src.vals, src.vals)
                }
            }
            if (src.modes !== undefined && src.modes !== null) {
                if (Array.isArray(src.modes)) {
                    for (const element of src.modes) {
                        dst.modes.push(SOLVE.BucklingRes.mode.fromObject(element));
                    }
                }
                else {
                    console.log('Expected modes of BucklingRes to be a array but was ', typeof src.modes, src.modes)
                }
            }
            if (src.freqs !== undefined && src.freqs !== null) {
                if (Array.isArray(src.freqs)) {
                    for (const [index, element] of src.freqs.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.freqs.push(AsNum(element));
                        }
                        else {
                            console.log('Expected freqs of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected freqs of BucklingRes to be a array but was ', typeof src.freqs, src.freqs)
                }
            }
            if (src.dofs !== undefined && src.dofs !== null) {
                if (Array.isArray(src.dofs)) {
                    for (const [index, element] of src.dofs.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.dofs.push(NumberToInt("SOLVE.BucklingRes.dofs", AsNum(element)));
                        }
                        else {
                            console.log('Expected dofs of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected dofs of BucklingRes to be a array but was ', typeof src.dofs, src.dofs)
                }
            }
            return dst;
        }

        static toObject(src: BucklingRes | null | undefined): BucklingRes_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.BucklingRes is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.BucklingRes") {
                console.error('Expected SOLVE.BucklingRes but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : BucklingRes_json = {
                bucklingLoad: AsJsonNum(src.bucklingLoad),
                beta: AsJsonNum(src.beta),
                vals: new Array<JsonNumber>(),
                modes: new Array<SOLVE.BucklingRes.mode_json>(),
                freqs: new Array<JsonNumber>(),
                dofs: new Array<JsonNumber>(),
            };
            if (src.vals !== null) {
                for (const element of src.vals) {
                    dst.vals.push(AsJsonNum(element));
                }
            }
            if (src.modes !== null) {
                for (const element of src.modes) {
                    const parsed = SOLVE.BucklingRes.mode.toObject(element);
                    if(parsed === null) return null;
                    dst.modes.push(parsed);
                }
            }
            if (src.freqs !== null) {
                for (const element of src.freqs) {
                    dst.freqs.push(AsJsonNum(element));
                }
            }
            if (src.dofs !== null) {
                for (const element of src.dofs) {
                    dst.dofs.push(AsJsonNum(NumberToInt("SOLVE.BucklingRes.dofs", element)));
                }
            }
            return dst;
        }

        static create(src?: BucklingRes_createType) {
            const dst = new BucklingRes();
            if (src === undefined) {
                return dst;
            }
            if (src.bucklingLoad !== undefined) {
                dst.bucklingLoad = src.bucklingLoad;
            }
            if (src.beta !== undefined) {
                dst.beta = src.beta;
            }
            if (src.vals !== undefined) {
                dst.vals = src.vals;
            }
            if (src.modes !== undefined) {
                dst.modes = src.modes;
            }
            if (src.freqs !== undefined) {
                dst.freqs = src.freqs;
            }
            if (src.dofs !== undefined) {
                dst.dofs = src.dofs;
            }
            return dst;
        }

        shallowClone() {
            const dst = new BucklingRes();
            dst.bucklingLoad = this.bucklingLoad;
            dst.beta = this.beta;
            dst.vals = this.vals;
            dst.modes = this.modes;
            dst.freqs = this.freqs;
            dst.dofs = this.dofs;
            return dst;
        }

        deepClone() {
            const json = BucklingRes.toObject(this);
            const dst = BucklingRes.fromObject(json);
            return dst;
        }
    }
    export type IBucklingRes = BucklingRes;


    export type Res_keys = 'id' | 'numOfOutputs' | 'n' | 'v1' | 'v2' | 't' | 'm1' | 'm2' | 'trans' | 'rot' | 'temp' | 'epsNorm' | 'epsShear' | 'sigmaNorm' | 'sigmaShear' | 'epsNormTop' | 'epsShearTop' | 'sigmaNormTop' | 'sigmaShearTop' | 'epsNormBtm' | 'epsShearBtm' | 'sigmaNormBtm' | 'sigmaShearBtm' | 'bucklingRes' | 'iter';
    export interface Res_createType {
        id?: number,
        numOfOutputs?: number,
        n?: number[],
        v1?: number[],
        v2?: number[],
        t?: number[],
        m1?: number[],
        m2?: number[],
        trans?: SOLVE.XYZ[],
        rot?: SOLVE.XYZ[],
        temp?: number[],
        epsNorm?: SOLVE.XYZ[],
        epsShear?: SOLVE.XYZ[],
        sigmaNorm?: SOLVE.XYZ[],
        sigmaShear?: SOLVE.XYZ[],
        epsNormTop?: SOLVE.XYZ[],
        epsShearTop?: SOLVE.XYZ[],
        sigmaNormTop?: SOLVE.XYZ[],
        sigmaShearTop?: SOLVE.XYZ[],
        epsNormBtm?: SOLVE.XYZ[],
        epsShearBtm?: SOLVE.XYZ[],
        sigmaNormBtm?: SOLVE.XYZ[],
        sigmaShearBtm?: SOLVE.XYZ[],
        bucklingRes?: SOLVE.BucklingRes[],
        iter?: SOLVE.ITER | null,
    }
    export interface Res_json {
        id?: JsonNumber;
        numOfOutputs?: JsonNumber;
        n: JsonNumber[];
        v1: JsonNumber[];
        v2: JsonNumber[];
        t: JsonNumber[];
        m1: JsonNumber[];
        m2: JsonNumber[];
        trans: SOLVE.XYZ_json[];
        rot: SOLVE.XYZ_json[];
        temp: JsonNumber[];
        epsNorm: SOLVE.XYZ_json[];
        epsShear: SOLVE.XYZ_json[];
        sigmaNorm: SOLVE.XYZ_json[];
        sigmaShear: SOLVE.XYZ_json[];
        epsNormTop: SOLVE.XYZ_json[];
        epsShearTop: SOLVE.XYZ_json[];
        sigmaNormTop: SOLVE.XYZ_json[];
        sigmaShearTop: SOLVE.XYZ_json[];
        epsNormBtm: SOLVE.XYZ_json[];
        epsShearBtm: SOLVE.XYZ_json[];
        sigmaNormBtm: SOLVE.XYZ_json[];
        sigmaShearBtm: SOLVE.XYZ_json[];
        bucklingRes: SOLVE.BucklingRes_json[];
        iter?: SOLVE.ITER_json;
    }
    interface Res_json_in {
        __proto_name?: unknown;
        id?: unknown;
        numOfOutputs?: unknown;
        n?: unknown;
        v1?: unknown;
        v2?: unknown;
        t?: unknown;
        m1?: unknown;
        m2?: unknown;
        trans?: unknown;
        rot?: unknown;
        temp?: unknown;
        epsNorm?: unknown;
        epsShear?: unknown;
        sigmaNorm?: unknown;
        sigmaShear?: unknown;
        epsNormTop?: unknown;
        epsShearTop?: unknown;
        sigmaNormTop?: unknown;
        sigmaShearTop?: unknown;
        epsNormBtm?: unknown;
        epsShearBtm?: unknown;
        sigmaNormBtm?: unknown;
        sigmaShearBtm?: unknown;
        bucklingRes?: unknown;
        iter?: unknown;
    }
    export class Res {
        __proto_name = "SOLVE.Res";
        id: number = 0;
        numOfOutputs: number = 0;
        n: number[] = [];
        v1: number[] = [];
        v2: number[] = [];
        t: number[] = [];
        m1: number[] = [];
        m2: number[] = [];
        trans: SOLVE.XYZ[] = [];
        rot: SOLVE.XYZ[] = [];
        temp: number[] = [];
        epsNorm: SOLVE.XYZ[] = [];
        epsShear: SOLVE.XYZ[] = [];
        sigmaNorm: SOLVE.XYZ[] = [];
        sigmaShear: SOLVE.XYZ[] = [];
        epsNormTop: SOLVE.XYZ[] = [];
        epsShearTop: SOLVE.XYZ[] = [];
        sigmaNormTop: SOLVE.XYZ[] = [];
        sigmaShearTop: SOLVE.XYZ[] = [];
        epsNormBtm: SOLVE.XYZ[] = [];
        epsShearBtm: SOLVE.XYZ[] = [];
        sigmaNormBtm: SOLVE.XYZ[] = [];
        sigmaShearBtm: SOLVE.XYZ[] = [];
        bucklingRes: SOLVE.BucklingRes[] = [];
        iter: SOLVE.ITER | null = null;

        static fromObject(src_unknown: unknown): Res {
            const dst = new Res();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Res but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Res_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Res but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "number" || src.id === 'NaN' || src.id === 'Infinity' || src.id === '-Infinity') {
                    dst.id = NumberToInt("SOLVE.Res.id", AsNum(src.id));
                }
                else {
                    console.log('Expected id of Res to be a number but was ', typeof src.id, src.id)
                }
            }
            if (src.numOfOutputs !== undefined && src.numOfOutputs !== null) {
                if (typeof src.numOfOutputs === "number" || src.numOfOutputs === 'NaN' || src.numOfOutputs === 'Infinity' || src.numOfOutputs === '-Infinity') {
                    dst.numOfOutputs = NumberToInt("SOLVE.Res.numOfOutputs", AsNum(src.numOfOutputs));
                }
                else {
                    console.log('Expected numOfOutputs of Res to be a number but was ', typeof src.numOfOutputs, src.numOfOutputs)
                }
            }
            if (src.n !== undefined && src.n !== null) {
                if (Array.isArray(src.n)) {
                    for (const [index, element] of src.n.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.n.push(AsNum(element));
                        }
                        else {
                            console.log('Expected n of Res[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected n of Res to be a array but was ', typeof src.n, src.n)
                }
            }
            if (src.v1 !== undefined && src.v1 !== null) {
                if (Array.isArray(src.v1)) {
                    for (const [index, element] of src.v1.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.v1.push(AsNum(element));
                        }
                        else {
                            console.log('Expected v1 of Res[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected v1 of Res to be a array but was ', typeof src.v1, src.v1)
                }
            }
            if (src.v2 !== undefined && src.v2 !== null) {
                if (Array.isArray(src.v2)) {
                    for (const [index, element] of src.v2.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.v2.push(AsNum(element));
                        }
                        else {
                            console.log('Expected v2 of Res[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected v2 of Res to be a array but was ', typeof src.v2, src.v2)
                }
            }
            if (src.t !== undefined && src.t !== null) {
                if (Array.isArray(src.t)) {
                    for (const [index, element] of src.t.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.t.push(AsNum(element));
                        }
                        else {
                            console.log('Expected t of Res[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected t of Res to be a array but was ', typeof src.t, src.t)
                }
            }
            if (src.m1 !== undefined && src.m1 !== null) {
                if (Array.isArray(src.m1)) {
                    for (const [index, element] of src.m1.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.m1.push(AsNum(element));
                        }
                        else {
                            console.log('Expected m1 of Res[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected m1 of Res to be a array but was ', typeof src.m1, src.m1)
                }
            }
            if (src.m2 !== undefined && src.m2 !== null) {
                if (Array.isArray(src.m2)) {
                    for (const [index, element] of src.m2.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.m2.push(AsNum(element));
                        }
                        else {
                            console.log('Expected m2 of Res[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected m2 of Res to be a array but was ', typeof src.m2, src.m2)
                }
            }
            if (src.trans !== undefined && src.trans !== null) {
                if (Array.isArray(src.trans)) {
                    for (const element of src.trans) {
                        dst.trans.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected trans of Res to be a array but was ', typeof src.trans, src.trans)
                }
            }
            if (src.rot !== undefined && src.rot !== null) {
                if (Array.isArray(src.rot)) {
                    for (const element of src.rot) {
                        dst.rot.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected rot of Res to be a array but was ', typeof src.rot, src.rot)
                }
            }
            if (src.temp !== undefined && src.temp !== null) {
                if (Array.isArray(src.temp)) {
                    for (const [index, element] of src.temp.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.temp.push(AsNum(element));
                        }
                        else {
                            console.log('Expected temp of Res[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected temp of Res to be a array but was ', typeof src.temp, src.temp)
                }
            }
            if (src.epsNorm !== undefined && src.epsNorm !== null) {
                if (Array.isArray(src.epsNorm)) {
                    for (const element of src.epsNorm) {
                        dst.epsNorm.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected epsNorm of Res to be a array but was ', typeof src.epsNorm, src.epsNorm)
                }
            }
            if (src.epsShear !== undefined && src.epsShear !== null) {
                if (Array.isArray(src.epsShear)) {
                    for (const element of src.epsShear) {
                        dst.epsShear.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected epsShear of Res to be a array but was ', typeof src.epsShear, src.epsShear)
                }
            }
            if (src.sigmaNorm !== undefined && src.sigmaNorm !== null) {
                if (Array.isArray(src.sigmaNorm)) {
                    for (const element of src.sigmaNorm) {
                        dst.sigmaNorm.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected sigmaNorm of Res to be a array but was ', typeof src.sigmaNorm, src.sigmaNorm)
                }
            }
            if (src.sigmaShear !== undefined && src.sigmaShear !== null) {
                if (Array.isArray(src.sigmaShear)) {
                    for (const element of src.sigmaShear) {
                        dst.sigmaShear.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected sigmaShear of Res to be a array but was ', typeof src.sigmaShear, src.sigmaShear)
                }
            }
            if (src.epsNormTop !== undefined && src.epsNormTop !== null) {
                if (Array.isArray(src.epsNormTop)) {
                    for (const element of src.epsNormTop) {
                        dst.epsNormTop.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected epsNormTop of Res to be a array but was ', typeof src.epsNormTop, src.epsNormTop)
                }
            }
            if (src.epsShearTop !== undefined && src.epsShearTop !== null) {
                if (Array.isArray(src.epsShearTop)) {
                    for (const element of src.epsShearTop) {
                        dst.epsShearTop.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected epsShearTop of Res to be a array but was ', typeof src.epsShearTop, src.epsShearTop)
                }
            }
            if (src.sigmaNormTop !== undefined && src.sigmaNormTop !== null) {
                if (Array.isArray(src.sigmaNormTop)) {
                    for (const element of src.sigmaNormTop) {
                        dst.sigmaNormTop.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected sigmaNormTop of Res to be a array but was ', typeof src.sigmaNormTop, src.sigmaNormTop)
                }
            }
            if (src.sigmaShearTop !== undefined && src.sigmaShearTop !== null) {
                if (Array.isArray(src.sigmaShearTop)) {
                    for (const element of src.sigmaShearTop) {
                        dst.sigmaShearTop.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected sigmaShearTop of Res to be a array but was ', typeof src.sigmaShearTop, src.sigmaShearTop)
                }
            }
            if (src.epsNormBtm !== undefined && src.epsNormBtm !== null) {
                if (Array.isArray(src.epsNormBtm)) {
                    for (const element of src.epsNormBtm) {
                        dst.epsNormBtm.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected epsNormBtm of Res to be a array but was ', typeof src.epsNormBtm, src.epsNormBtm)
                }
            }
            if (src.epsShearBtm !== undefined && src.epsShearBtm !== null) {
                if (Array.isArray(src.epsShearBtm)) {
                    for (const element of src.epsShearBtm) {
                        dst.epsShearBtm.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected epsShearBtm of Res to be a array but was ', typeof src.epsShearBtm, src.epsShearBtm)
                }
            }
            if (src.sigmaNormBtm !== undefined && src.sigmaNormBtm !== null) {
                if (Array.isArray(src.sigmaNormBtm)) {
                    for (const element of src.sigmaNormBtm) {
                        dst.sigmaNormBtm.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected sigmaNormBtm of Res to be a array but was ', typeof src.sigmaNormBtm, src.sigmaNormBtm)
                }
            }
            if (src.sigmaShearBtm !== undefined && src.sigmaShearBtm !== null) {
                if (Array.isArray(src.sigmaShearBtm)) {
                    for (const element of src.sigmaShearBtm) {
                        dst.sigmaShearBtm.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected sigmaShearBtm of Res to be a array but was ', typeof src.sigmaShearBtm, src.sigmaShearBtm)
                }
            }
            if (src.bucklingRes !== undefined && src.bucklingRes !== null) {
                if (Array.isArray(src.bucklingRes)) {
                    for (const element of src.bucklingRes) {
                        dst.bucklingRes.push(SOLVE.BucklingRes.fromObject(element));
                    }
                }
                else {
                    console.log('Expected bucklingRes of Res to be a array but was ', typeof src.bucklingRes, src.bucklingRes)
                }
            }
            if (src.iter !== undefined && src.iter !== null) {
                dst.iter = SOLVE.ITER.fromObject(src.iter);
            }
            return dst;
        }

        static toObject(src: Res | null | undefined): Res_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Res is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Res") {
                console.error('Expected SOLVE.Res but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Res_json = {
                id: AsJsonNum(NumberToInt("SOLVE.Res.id", src.id)),
                numOfOutputs: AsJsonNum(NumberToInt("SOLVE.Res.numOfOutputs", src.numOfOutputs)),
                n: new Array<JsonNumber>(),
                v1: new Array<JsonNumber>(),
                v2: new Array<JsonNumber>(),
                t: new Array<JsonNumber>(),
                m1: new Array<JsonNumber>(),
                m2: new Array<JsonNumber>(),
                trans: new Array<SOLVE.XYZ_json>(),
                rot: new Array<SOLVE.XYZ_json>(),
                temp: new Array<JsonNumber>(),
                epsNorm: new Array<SOLVE.XYZ_json>(),
                epsShear: new Array<SOLVE.XYZ_json>(),
                sigmaNorm: new Array<SOLVE.XYZ_json>(),
                sigmaShear: new Array<SOLVE.XYZ_json>(),
                epsNormTop: new Array<SOLVE.XYZ_json>(),
                epsShearTop: new Array<SOLVE.XYZ_json>(),
                sigmaNormTop: new Array<SOLVE.XYZ_json>(),
                sigmaShearTop: new Array<SOLVE.XYZ_json>(),
                epsNormBtm: new Array<SOLVE.XYZ_json>(),
                epsShearBtm: new Array<SOLVE.XYZ_json>(),
                sigmaNormBtm: new Array<SOLVE.XYZ_json>(),
                sigmaShearBtm: new Array<SOLVE.XYZ_json>(),
                bucklingRes: new Array<SOLVE.BucklingRes_json>(),
            };
            if (src.n !== null) {
                for (const element of src.n) {
                    dst.n.push(AsJsonNum(element));
                }
            }
            if (src.v1 !== null) {
                for (const element of src.v1) {
                    dst.v1.push(AsJsonNum(element));
                }
            }
            if (src.v2 !== null) {
                for (const element of src.v2) {
                    dst.v2.push(AsJsonNum(element));
                }
            }
            if (src.t !== null) {
                for (const element of src.t) {
                    dst.t.push(AsJsonNum(element));
                }
            }
            if (src.m1 !== null) {
                for (const element of src.m1) {
                    dst.m1.push(AsJsonNum(element));
                }
            }
            if (src.m2 !== null) {
                for (const element of src.m2) {
                    dst.m2.push(AsJsonNum(element));
                }
            }
            if (src.trans !== null) {
                for (const element of src.trans) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.trans.push(parsed);
                }
            }
            if (src.rot !== null) {
                for (const element of src.rot) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.rot.push(parsed);
                }
            }
            if (src.temp !== null) {
                for (const element of src.temp) {
                    dst.temp.push(AsJsonNum(element));
                }
            }
            if (src.epsNorm !== null) {
                for (const element of src.epsNorm) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.epsNorm.push(parsed);
                }
            }
            if (src.epsShear !== null) {
                for (const element of src.epsShear) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.epsShear.push(parsed);
                }
            }
            if (src.sigmaNorm !== null) {
                for (const element of src.sigmaNorm) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.sigmaNorm.push(parsed);
                }
            }
            if (src.sigmaShear !== null) {
                for (const element of src.sigmaShear) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.sigmaShear.push(parsed);
                }
            }
            if (src.epsNormTop !== null) {
                for (const element of src.epsNormTop) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.epsNormTop.push(parsed);
                }
            }
            if (src.epsShearTop !== null) {
                for (const element of src.epsShearTop) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.epsShearTop.push(parsed);
                }
            }
            if (src.sigmaNormTop !== null) {
                for (const element of src.sigmaNormTop) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.sigmaNormTop.push(parsed);
                }
            }
            if (src.sigmaShearTop !== null) {
                for (const element of src.sigmaShearTop) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.sigmaShearTop.push(parsed);
                }
            }
            if (src.epsNormBtm !== null) {
                for (const element of src.epsNormBtm) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.epsNormBtm.push(parsed);
                }
            }
            if (src.epsShearBtm !== null) {
                for (const element of src.epsShearBtm) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.epsShearBtm.push(parsed);
                }
            }
            if (src.sigmaNormBtm !== null) {
                for (const element of src.sigmaNormBtm) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.sigmaNormBtm.push(parsed);
                }
            }
            if (src.sigmaShearBtm !== null) {
                for (const element of src.sigmaShearBtm) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.sigmaShearBtm.push(parsed);
                }
            }
            if (src.bucklingRes !== null) {
                for (const element of src.bucklingRes) {
                    const parsed = SOLVE.BucklingRes.toObject(element);
                    if(parsed === null) return null;
                    dst.bucklingRes.push(parsed);
                }
            }
            if(src.iter !== null)
            {
                const parsed = SOLVE.ITER.toObject(src.iter);
                if(parsed === null) return null;
                dst.iter = parsed;
            }
            return dst;
        }

        static create(src?: Res_createType) {
            const dst = new Res();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.numOfOutputs !== undefined) {
                dst.numOfOutputs = src.numOfOutputs;
            }
            if (src.n !== undefined) {
                dst.n = src.n;
            }
            if (src.v1 !== undefined) {
                dst.v1 = src.v1;
            }
            if (src.v2 !== undefined) {
                dst.v2 = src.v2;
            }
            if (src.t !== undefined) {
                dst.t = src.t;
            }
            if (src.m1 !== undefined) {
                dst.m1 = src.m1;
            }
            if (src.m2 !== undefined) {
                dst.m2 = src.m2;
            }
            if (src.trans !== undefined) {
                dst.trans = src.trans;
            }
            if (src.rot !== undefined) {
                dst.rot = src.rot;
            }
            if (src.temp !== undefined) {
                dst.temp = src.temp;
            }
            if (src.epsNorm !== undefined) {
                dst.epsNorm = src.epsNorm;
            }
            if (src.epsShear !== undefined) {
                dst.epsShear = src.epsShear;
            }
            if (src.sigmaNorm !== undefined) {
                dst.sigmaNorm = src.sigmaNorm;
            }
            if (src.sigmaShear !== undefined) {
                dst.sigmaShear = src.sigmaShear;
            }
            if (src.epsNormTop !== undefined) {
                dst.epsNormTop = src.epsNormTop;
            }
            if (src.epsShearTop !== undefined) {
                dst.epsShearTop = src.epsShearTop;
            }
            if (src.sigmaNormTop !== undefined) {
                dst.sigmaNormTop = src.sigmaNormTop;
            }
            if (src.sigmaShearTop !== undefined) {
                dst.sigmaShearTop = src.sigmaShearTop;
            }
            if (src.epsNormBtm !== undefined) {
                dst.epsNormBtm = src.epsNormBtm;
            }
            if (src.epsShearBtm !== undefined) {
                dst.epsShearBtm = src.epsShearBtm;
            }
            if (src.sigmaNormBtm !== undefined) {
                dst.sigmaNormBtm = src.sigmaNormBtm;
            }
            if (src.sigmaShearBtm !== undefined) {
                dst.sigmaShearBtm = src.sigmaShearBtm;
            }
            if (src.bucklingRes !== undefined) {
                dst.bucklingRes = src.bucklingRes;
            }
            if (src.iter !== undefined) {
                dst.iter = src.iter;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Res();
            dst.id = this.id;
            dst.numOfOutputs = this.numOfOutputs;
            dst.n = this.n;
            dst.v1 = this.v1;
            dst.v2 = this.v2;
            dst.t = this.t;
            dst.m1 = this.m1;
            dst.m2 = this.m2;
            dst.trans = this.trans;
            dst.rot = this.rot;
            dst.temp = this.temp;
            dst.epsNorm = this.epsNorm;
            dst.epsShear = this.epsShear;
            dst.sigmaNorm = this.sigmaNorm;
            dst.sigmaShear = this.sigmaShear;
            dst.epsNormTop = this.epsNormTop;
            dst.epsShearTop = this.epsShearTop;
            dst.sigmaNormTop = this.sigmaNormTop;
            dst.sigmaShearTop = this.sigmaShearTop;
            dst.epsNormBtm = this.epsNormBtm;
            dst.epsShearBtm = this.epsShearBtm;
            dst.sigmaNormBtm = this.sigmaNormBtm;
            dst.sigmaShearBtm = this.sigmaShearBtm;
            dst.bucklingRes = this.bucklingRes;
            dst.iter = this.iter;
            return dst;
        }

        deepClone() {
            const json = Res.toObject(this);
            const dst = Res.fromObject(json);
            return dst;
        }
    }
    export type IRes = Res;


    export type ElemResVec_keys = 'elemRes' | 'lcid';
    export interface ElemResVec_createType {
        elemRes?: SOLVE.Res[],
        lcid?: string,
    }
    export interface ElemResVec_json {
        elemRes: SOLVE.Res_json[];
        lcid?: string;
    }
    interface ElemResVec_json_in {
        __proto_name?: unknown;
        elemRes?: unknown;
        lcid?: unknown;
    }
    export class ElemResVec {
        __proto_name = "SOLVE.ElemResVec";
        elemRes: SOLVE.Res[] = [];
        lcid: string = "";

        static fromObject(src_unknown: unknown): ElemResVec {
            const dst = new ElemResVec();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted ElemResVec but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as ElemResVec_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for ElemResVec but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.elemRes !== undefined && src.elemRes !== null) {
                if (Array.isArray(src.elemRes)) {
                    for (const element of src.elemRes) {
                        dst.elemRes.push(SOLVE.Res.fromObject(element));
                    }
                }
                else {
                    console.log('Expected elemRes of ElemResVec to be a array but was ', typeof src.elemRes, src.elemRes)
                }
            }
            if (src.lcid !== undefined && src.lcid !== null) {
                if (typeof src.lcid === "string") {
                    dst.lcid = src.lcid;
                }
                else {
                    console.log('Expected lcid of ElemResVec to be a string but was ', typeof src.lcid, src.lcid)
                }
            }
            return dst;
        }

        static toObject(src: ElemResVec | null | undefined): ElemResVec_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.ElemResVec is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.ElemResVec") {
                console.error('Expected SOLVE.ElemResVec but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : ElemResVec_json = {
                elemRes: new Array<SOLVE.Res_json>(),
                lcid: src.lcid,
            };
            if (src.elemRes !== null) {
                for (const element of src.elemRes) {
                    const parsed = SOLVE.Res.toObject(element);
                    if(parsed === null) return null;
                    dst.elemRes.push(parsed);
                }
            }
            return dst;
        }

        static create(src?: ElemResVec_createType) {
            const dst = new ElemResVec();
            if (src === undefined) {
                return dst;
            }
            if (src.elemRes !== undefined) {
                dst.elemRes = src.elemRes;
            }
            if (src.lcid !== undefined) {
                dst.lcid = src.lcid;
            }
            return dst;
        }

        shallowClone() {
            const dst = new ElemResVec();
            dst.elemRes = this.elemRes;
            dst.lcid = this.lcid;
            return dst;
        }

        deepClone() {
            const json = ElemResVec.toObject(this);
            const dst = ElemResVec.fromObject(json);
            return dst;
        }
    }
    export type IElemResVec = ElemResVec;


    export type Analysis_keys = 'staticSettings' | 'dynamicSettings' | 'eigenValsSettings' | 'bucklingSettings' | 'tol';
    export interface Analysis_createType {
        staticSettings?: SOLVE.Analysis.Static | null,
        dynamicSettings?: SOLVE.Analysis.Dynamic | null,
        eigenValsSettings?: SOLVE.Analysis.EigenVals | null,
        bucklingSettings?: SOLVE.Analysis.Buckling | null,
        tol?: number,
    }
    export interface Analysis_json {
        staticSettings?: SOLVE.Analysis.Static_json;
        dynamicSettings?: SOLVE.Analysis.Dynamic_json;
        eigenValsSettings?: SOLVE.Analysis.EigenVals_json;
        bucklingSettings?: SOLVE.Analysis.Buckling_json;
        tol?: JsonNumber;
    }
    interface Analysis_json_in {
        __proto_name?: unknown;
        staticSettings?: unknown;
        dynamicSettings?: unknown;
        eigenValsSettings?: unknown;
        bucklingSettings?: unknown;
        tol?: unknown;
    }
    export class Analysis {
        __proto_name = "SOLVE.Analysis";
        // this is a one of
        type: {type: 'staticSettings'; staticSettings: SOLVE.Analysis.Static} | {type: 'dynamicSettings'; dynamicSettings: SOLVE.Analysis.Dynamic} | {type: 'eigenValsSettings'; eigenValsSettings: SOLVE.Analysis.EigenVals} | {type: 'bucklingSettings'; bucklingSettings: SOLVE.Analysis.Buckling} | null = null;
        tol: number = 0;

        /** Gets the `StaticSettings` value (or null) from the oneof `type` */
        getStaticSettings(): SOLVE.Analysis.Static | null {
            if(this.type === null) return null;
            if(this.type.type !== 'staticSettings') return null;
            return this.type.staticSettings;
        }

        /** Sets the `StaticSettings` value for the oneof `type`*/
        setStaticSettings(value: SOLVE.Analysis.Static | null) {
            if(value !== null) {
                this.type = {type: 'staticSettings', staticSettings:value};
            }
            else {
                this.type = null;
            }
        }

        /** Gets the `DynamicSettings` value (or null) from the oneof `type` */
        getDynamicSettings(): SOLVE.Analysis.Dynamic | null {
            if(this.type === null) return null;
            if(this.type.type !== 'dynamicSettings') return null;
            return this.type.dynamicSettings;
        }

        /** Sets the `DynamicSettings` value for the oneof `type`*/
        setDynamicSettings(value: SOLVE.Analysis.Dynamic | null) {
            if(value !== null) {
                this.type = {type: 'dynamicSettings', dynamicSettings:value};
            }
            else {
                this.type = null;
            }
        }

        /** Gets the `EigenValsSettings` value (or null) from the oneof `type` */
        getEigenValsSettings(): SOLVE.Analysis.EigenVals | null {
            if(this.type === null) return null;
            if(this.type.type !== 'eigenValsSettings') return null;
            return this.type.eigenValsSettings;
        }

        /** Sets the `EigenValsSettings` value for the oneof `type`*/
        setEigenValsSettings(value: SOLVE.Analysis.EigenVals | null) {
            if(value !== null) {
                this.type = {type: 'eigenValsSettings', eigenValsSettings:value};
            }
            else {
                this.type = null;
            }
        }

        /** Gets the `BucklingSettings` value (or null) from the oneof `type` */
        getBucklingSettings(): SOLVE.Analysis.Buckling | null {
            if(this.type === null) return null;
            if(this.type.type !== 'bucklingSettings') return null;
            return this.type.bucklingSettings;
        }

        /** Sets the `BucklingSettings` value for the oneof `type`*/
        setBucklingSettings(value: SOLVE.Analysis.Buckling | null) {
            if(value !== null) {
                this.type = {type: 'bucklingSettings', bucklingSettings:value};
            }
            else {
                this.type = null;
            }
        }

        static fromObject(src_unknown: unknown): Analysis {
            const dst = new Analysis();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Analysis but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Analysis_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Analysis but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.staticSettings !== undefined && src.staticSettings !== null) {
                dst.setStaticSettings(SOLVE.Analysis.Static.fromObject(src.staticSettings));
            }
            if (src.dynamicSettings !== undefined && src.dynamicSettings !== null) {
                dst.setDynamicSettings(SOLVE.Analysis.Dynamic.fromObject(src.dynamicSettings));
            }
            if (src.eigenValsSettings !== undefined && src.eigenValsSettings !== null) {
                dst.setEigenValsSettings(SOLVE.Analysis.EigenVals.fromObject(src.eigenValsSettings));
            }
            if (src.bucklingSettings !== undefined && src.bucklingSettings !== null) {
                dst.setBucklingSettings(SOLVE.Analysis.Buckling.fromObject(src.bucklingSettings));
            }
            if (src.tol !== undefined && src.tol !== null) {
                if (typeof src.tol === "number" || src.tol === 'NaN' || src.tol === 'Infinity' || src.tol === '-Infinity') {
                    dst.tol = AsNum(src.tol);
                }
                else {
                    console.log('Expected tol of Analysis to be a number but was ', typeof src.tol, src.tol)
                }
            }
            return dst;
        }

        static toObject(src: Analysis | null | undefined): Analysis_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Analysis is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Analysis") {
                console.error('Expected SOLVE.Analysis but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Analysis_json = {
                tol: AsJsonNum(src.tol),
            };
            const staticSettings = src.getStaticSettings();
            if(staticSettings !== null)
            {
                const parsed = SOLVE.Analysis.Static.toObject(staticSettings);
                if(parsed === null) return null;
                dst.staticSettings = parsed;
            }
            const dynamicSettings = src.getDynamicSettings();
            if(dynamicSettings !== null)
            {
                const parsed = SOLVE.Analysis.Dynamic.toObject(dynamicSettings);
                if(parsed === null) return null;
                dst.dynamicSettings = parsed;
            }
            const eigenValsSettings = src.getEigenValsSettings();
            if(eigenValsSettings !== null)
            {
                const parsed = SOLVE.Analysis.EigenVals.toObject(eigenValsSettings);
                if(parsed === null) return null;
                dst.eigenValsSettings = parsed;
            }
            const bucklingSettings = src.getBucklingSettings();
            if(bucklingSettings !== null)
            {
                const parsed = SOLVE.Analysis.Buckling.toObject(bucklingSettings);
                if(parsed === null) return null;
                dst.bucklingSettings = parsed;
            }
            return dst;
        }

        static create(src?: Analysis_createType) {
            const dst = new Analysis();
            if (src === undefined) {
                return dst;
            }
            // part of the type oneof 
            if (src.staticSettings !== undefined && src.staticSettings !== null) {
                dst.setStaticSettings(src.staticSettings);
            }
            // part of the type oneof 
            if (src.dynamicSettings !== undefined && src.dynamicSettings !== null) {
                dst.setDynamicSettings(src.dynamicSettings);
            }
            // part of the type oneof 
            if (src.eigenValsSettings !== undefined && src.eigenValsSettings !== null) {
                dst.setEigenValsSettings(src.eigenValsSettings);
            }
            // part of the type oneof 
            if (src.bucklingSettings !== undefined && src.bucklingSettings !== null) {
                dst.setBucklingSettings(src.bucklingSettings);
            }
            if (src.tol !== undefined) {
                dst.tol = src.tol;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Analysis();
            dst.type = this.type;
            dst.tol = this.tol;
            return dst;
        }

        deepClone() {
            const json = Analysis.toObject(this);
            const dst = Analysis.fromObject(json);
            return dst;
        }
    }
    export type IAnalysis = Analysis;


    export type Node_keys = 'id' | 'pnt' | 'guid';
    export interface Node_createType {
        id?: number,
        pnt?: SOLVE.XYZ | null,
        guid?: string,
    }
    export interface Node_json {
        id?: JsonNumber;
        pnt?: SOLVE.XYZ_json;
        guid?: string;
    }
    interface Node_json_in {
        __proto_name?: unknown;
        id?: unknown;
        pnt?: unknown;
        guid?: unknown;
    }
    export class Node {
        __proto_name = "SOLVE.Node";
        id: number = 0;
        pnt: SOLVE.XYZ | null = null;
        guid: string = "";

        static fromObject(src_unknown: unknown): Node {
            const dst = new Node();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Node but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Node_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Node but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "number" || src.id === 'NaN' || src.id === 'Infinity' || src.id === '-Infinity') {
                    dst.id = NumberToInt("SOLVE.Node.id", AsNum(src.id));
                }
                else {
                    console.log('Expected id of Node to be a number but was ', typeof src.id, src.id)
                }
            }
            if (src.pnt !== undefined && src.pnt !== null) {
                dst.pnt = SOLVE.XYZ.fromObject(src.pnt);
            }
            if (src.guid !== undefined && src.guid !== null) {
                if (typeof src.guid === "string") {
                    dst.guid = src.guid;
                }
                else {
                    console.log('Expected guid of Node to be a string but was ', typeof src.guid, src.guid)
                }
            }
            return dst;
        }

        static toObject(src: Node | null | undefined): Node_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Node is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Node") {
                console.error('Expected SOLVE.Node but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Node_json = {
                id: AsJsonNum(NumberToInt("SOLVE.Node.id", src.id)),
                guid: src.guid,
            };
            if(src.pnt !== null)
            {
                const parsed = SOLVE.XYZ.toObject(src.pnt);
                if(parsed === null) return null;
                dst.pnt = parsed;
            }
            return dst;
        }

        static create(src?: Node_createType) {
            const dst = new Node();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.pnt !== undefined) {
                dst.pnt = src.pnt;
            }
            if (src.guid !== undefined) {
                dst.guid = src.guid;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Node();
            dst.id = this.id;
            dst.pnt = this.pnt;
            dst.guid = this.guid;
            return dst;
        }

        deepClone() {
            const json = Node.toObject(this);
            const dst = Node.fromObject(json);
            return dst;
        }
    }
    export type INode = Node;


    export type Bc_keys = 'node' | 'dof1' | 'dof2' | 'mag' | 'local' | 'n1' | 'n2';
    export interface Bc_createType {
        node?: number,
        dof1?: number,
        dof2?: number,
        mag?: number,
        local?: boolean,
        n1?: SOLVE.XYZ | null,
        n2?: SOLVE.XYZ | null,
    }
    export interface Bc_json {
        node?: JsonNumber;
        dof1?: JsonNumber;
        dof2?: JsonNumber;
        mag?: JsonNumber;
        local?: boolean;
        n1?: SOLVE.XYZ_json;
        n2?: SOLVE.XYZ_json;
    }
    interface Bc_json_in {
        __proto_name?: unknown;
        node?: unknown;
        dof1?: unknown;
        dof2?: unknown;
        mag?: unknown;
        local?: unknown;
        n1?: unknown;
        n2?: unknown;
    }
    export class Bc {
        __proto_name = "SOLVE.Bc";
        node: number = 0;
        dof1: number = 0;
        dof2: number = 0;
        mag: number = 0;
        local: boolean = false;
        n1: SOLVE.XYZ | null = null;
        n2: SOLVE.XYZ | null = null;

        static fromObject(src_unknown: unknown): Bc {
            const dst = new Bc();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Bc but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Bc_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Bc but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.node !== undefined && src.node !== null) {
                if (typeof src.node === "number" || src.node === 'NaN' || src.node === 'Infinity' || src.node === '-Infinity') {
                    dst.node = NumberToInt("SOLVE.Bc.node", AsNum(src.node));
                }
                else {
                    console.log('Expected node of Bc to be a number but was ', typeof src.node, src.node)
                }
            }
            if (src.dof1 !== undefined && src.dof1 !== null) {
                if (typeof src.dof1 === "number" || src.dof1 === 'NaN' || src.dof1 === 'Infinity' || src.dof1 === '-Infinity') {
                    dst.dof1 = NumberToInt("SOLVE.Bc.dof1", AsNum(src.dof1));
                }
                else {
                    console.log('Expected dof1 of Bc to be a number but was ', typeof src.dof1, src.dof1)
                }
            }
            if (src.dof2 !== undefined && src.dof2 !== null) {
                if (typeof src.dof2 === "number" || src.dof2 === 'NaN' || src.dof2 === 'Infinity' || src.dof2 === '-Infinity') {
                    dst.dof2 = NumberToInt("SOLVE.Bc.dof2", AsNum(src.dof2));
                }
                else {
                    console.log('Expected dof2 of Bc to be a number but was ', typeof src.dof2, src.dof2)
                }
            }
            if (src.mag !== undefined && src.mag !== null) {
                if (typeof src.mag === "number" || src.mag === 'NaN' || src.mag === 'Infinity' || src.mag === '-Infinity') {
                    dst.mag = AsNum(src.mag);
                }
                else {
                    console.log('Expected mag of Bc to be a number but was ', typeof src.mag, src.mag)
                }
            }
            if (src.local !== undefined && src.local !== null) {
                if (typeof src.local === "boolean") {
                    dst.local = src.local;
                }
                else {
                    console.log('Expected local of Bc to be a boolean but was ', typeof src.local, src.local)
                }
            }
            if (src.n1 !== undefined && src.n1 !== null) {
                dst.n1 = SOLVE.XYZ.fromObject(src.n1);
            }
            if (src.n2 !== undefined && src.n2 !== null) {
                dst.n2 = SOLVE.XYZ.fromObject(src.n2);
            }
            return dst;
        }

        static toObject(src: Bc | null | undefined): Bc_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Bc is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Bc") {
                console.error('Expected SOLVE.Bc but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Bc_json = {
                node: AsJsonNum(NumberToInt("SOLVE.Bc.node", src.node)),
                dof1: AsJsonNum(NumberToInt("SOLVE.Bc.dof1", src.dof1)),
                dof2: AsJsonNum(NumberToInt("SOLVE.Bc.dof2", src.dof2)),
                mag: AsJsonNum(src.mag),
                local: src.local,
            };
            if(src.n1 !== null)
            {
                const parsed = SOLVE.XYZ.toObject(src.n1);
                if(parsed === null) return null;
                dst.n1 = parsed;
            }
            if(src.n2 !== null)
            {
                const parsed = SOLVE.XYZ.toObject(src.n2);
                if(parsed === null) return null;
                dst.n2 = parsed;
            }
            return dst;
        }

        static create(src?: Bc_createType) {
            const dst = new Bc();
            if (src === undefined) {
                return dst;
            }
            if (src.node !== undefined) {
                dst.node = src.node;
            }
            if (src.dof1 !== undefined) {
                dst.dof1 = src.dof1;
            }
            if (src.dof2 !== undefined) {
                dst.dof2 = src.dof2;
            }
            if (src.mag !== undefined) {
                dst.mag = src.mag;
            }
            if (src.local !== undefined) {
                dst.local = src.local;
            }
            if (src.n1 !== undefined) {
                dst.n1 = src.n1;
            }
            if (src.n2 !== undefined) {
                dst.n2 = src.n2;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Bc();
            dst.node = this.node;
            dst.dof1 = this.dof1;
            dst.dof2 = this.dof2;
            dst.mag = this.mag;
            dst.local = this.local;
            dst.n1 = this.n1;
            dst.n2 = this.n2;
            return dst;
        }

        deepClone() {
            const json = Bc.toObject(this);
            const dst = Bc.fromObject(json);
            return dst;
        }
    }
    export type IBc = Bc;


    export type Elem_keys = 'id' | 'type' | 'nodes' | 'n1' | 'n2' | 'n3' | 'mtrlID' | 'secID' | 'k' | 'l' | 'bcs' | 'dofs' | 'outCoords' | 'guid' | 'normalForceAtNode1' | 'normalForceAtNode2';
    export interface Elem_createType {
        id?: number,
        type?: string,
        nodes?: number[],
        n1?: SOLVE.XYZ | null,
        n2?: SOLVE.XYZ | null,
        n3?: SOLVE.XYZ | null,
        mtrlID?: string,
        secID?: string,
        k?: number[],
        l?: number,
        bcs?: SOLVE.Bc[],
        dofs?: number[],
        outCoords?: SOLVE.XYZ[],
        guid?: string,
        normalForceAtNode1?: number,
        normalForceAtNode2?: number,
    }
    export interface Elem_json {
        id?: JsonNumber;
        type?: string;
        nodes: JsonNumber[];
        n1?: SOLVE.XYZ_json;
        n2?: SOLVE.XYZ_json;
        n3?: SOLVE.XYZ_json;
        mtrlID?: string;
        secID?: string;
        k: JsonNumber[];
        l?: JsonNumber;
        bcs: SOLVE.Bc_json[];
        dofs: JsonNumber[];
        outCoords: SOLVE.XYZ_json[];
        guid?: string;
        normalForceAtNode1?: JsonNumber;
        normalForceAtNode2?: JsonNumber;
    }
    interface Elem_json_in {
        __proto_name?: unknown;
        id?: unknown;
        type?: unknown;
        nodes?: unknown;
        n1?: unknown;
        n2?: unknown;
        n3?: unknown;
        mtrlID?: unknown;
        secID?: unknown;
        k?: unknown;
        l?: unknown;
        bcs?: unknown;
        dofs?: unknown;
        outCoords?: unknown;
        guid?: unknown;
        normalForceAtNode1?: unknown;
        normalForceAtNode2?: unknown;
    }
    export class Elem {
        __proto_name = "SOLVE.Elem";
        id: number = 0;
        type: string = "";
        nodes: number[] = [];
        n1: SOLVE.XYZ | null = null;
        n2: SOLVE.XYZ | null = null;
        n3: SOLVE.XYZ | null = null;
        mtrlID: string = "";
        secID: string = "";
        k: number[] = [];
        l: number = 0;
        bcs: SOLVE.Bc[] = [];
        dofs: number[] = [];
        outCoords: SOLVE.XYZ[] = [];
        guid: string = "";
        normalForceAtNode1: number = 0;
        normalForceAtNode2: number = 0;

        static fromObject(src_unknown: unknown): Elem {
            const dst = new Elem();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Elem but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Elem_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Elem but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "number" || src.id === 'NaN' || src.id === 'Infinity' || src.id === '-Infinity') {
                    dst.id = NumberToInt("SOLVE.Elem.id", AsNum(src.id));
                }
                else {
                    console.log('Expected id of Elem to be a number but was ', typeof src.id, src.id)
                }
            }
            if (src.type !== undefined && src.type !== null) {
                if (typeof src.type === "string") {
                    dst.type = src.type;
                }
                else {
                    console.log('Expected type of Elem to be a string but was ', typeof src.type, src.type)
                }
            }
            if (src.nodes !== undefined && src.nodes !== null) {
                if (Array.isArray(src.nodes)) {
                    for (const [index, element] of src.nodes.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.nodes.push(NumberToInt("SOLVE.Elem.nodes", AsNum(element)));
                        }
                        else {
                            console.log('Expected nodes of Elem[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected nodes of Elem to be a array but was ', typeof src.nodes, src.nodes)
                }
            }
            if (src.n1 !== undefined && src.n1 !== null) {
                dst.n1 = SOLVE.XYZ.fromObject(src.n1);
            }
            if (src.n2 !== undefined && src.n2 !== null) {
                dst.n2 = SOLVE.XYZ.fromObject(src.n2);
            }
            if (src.n3 !== undefined && src.n3 !== null) {
                dst.n3 = SOLVE.XYZ.fromObject(src.n3);
            }
            if (src.mtrlID !== undefined && src.mtrlID !== null) {
                if (typeof src.mtrlID === "string") {
                    dst.mtrlID = src.mtrlID;
                }
                else {
                    console.log('Expected mtrlID of Elem to be a string but was ', typeof src.mtrlID, src.mtrlID)
                }
            }
            if (src.secID !== undefined && src.secID !== null) {
                if (typeof src.secID === "string") {
                    dst.secID = src.secID;
                }
                else {
                    console.log('Expected secID of Elem to be a string but was ', typeof src.secID, src.secID)
                }
            }
            if (src.k !== undefined && src.k !== null) {
                if (Array.isArray(src.k)) {
                    for (const [index, element] of src.k.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.k.push(AsNum(element));
                        }
                        else {
                            console.log('Expected k of Elem[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected k of Elem to be a array but was ', typeof src.k, src.k)
                }
            }
            if (src.l !== undefined && src.l !== null) {
                if (typeof src.l === "number" || src.l === 'NaN' || src.l === 'Infinity' || src.l === '-Infinity') {
                    dst.l = AsNum(src.l);
                }
                else {
                    console.log('Expected l of Elem to be a number but was ', typeof src.l, src.l)
                }
            }
            if (src.bcs !== undefined && src.bcs !== null) {
                if (Array.isArray(src.bcs)) {
                    for (const element of src.bcs) {
                        dst.bcs.push(SOLVE.Bc.fromObject(element));
                    }
                }
                else {
                    console.log('Expected bcs of Elem to be a array but was ', typeof src.bcs, src.bcs)
                }
            }
            if (src.dofs !== undefined && src.dofs !== null) {
                if (Array.isArray(src.dofs)) {
                    for (const [index, element] of src.dofs.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.dofs.push(NumberToInt("SOLVE.Elem.dofs", AsNum(element)));
                        }
                        else {
                            console.log('Expected dofs of Elem[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected dofs of Elem to be a array but was ', typeof src.dofs, src.dofs)
                }
            }
            if (src.outCoords !== undefined && src.outCoords !== null) {
                if (Array.isArray(src.outCoords)) {
                    for (const element of src.outCoords) {
                        dst.outCoords.push(SOLVE.XYZ.fromObject(element));
                    }
                }
                else {
                    console.log('Expected outCoords of Elem to be a array but was ', typeof src.outCoords, src.outCoords)
                }
            }
            if (src.guid !== undefined && src.guid !== null) {
                if (typeof src.guid === "string") {
                    dst.guid = src.guid;
                }
                else {
                    console.log('Expected guid of Elem to be a string but was ', typeof src.guid, src.guid)
                }
            }
            if (src.normalForceAtNode1 !== undefined && src.normalForceAtNode1 !== null) {
                if (typeof src.normalForceAtNode1 === "number" || src.normalForceAtNode1 === 'NaN' || src.normalForceAtNode1 === 'Infinity' || src.normalForceAtNode1 === '-Infinity') {
                    dst.normalForceAtNode1 = AsNum(src.normalForceAtNode1);
                }
                else {
                    console.log('Expected normalForceAtNode1 of Elem to be a number but was ', typeof src.normalForceAtNode1, src.normalForceAtNode1)
                }
            }
            if (src.normalForceAtNode2 !== undefined && src.normalForceAtNode2 !== null) {
                if (typeof src.normalForceAtNode2 === "number" || src.normalForceAtNode2 === 'NaN' || src.normalForceAtNode2 === 'Infinity' || src.normalForceAtNode2 === '-Infinity') {
                    dst.normalForceAtNode2 = AsNum(src.normalForceAtNode2);
                }
                else {
                    console.log('Expected normalForceAtNode2 of Elem to be a number but was ', typeof src.normalForceAtNode2, src.normalForceAtNode2)
                }
            }
            return dst;
        }

        static toObject(src: Elem | null | undefined): Elem_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Elem is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Elem") {
                console.error('Expected SOLVE.Elem but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Elem_json = {
                id: AsJsonNum(NumberToInt("SOLVE.Elem.id", src.id)),
                type: src.type,
                nodes: new Array<JsonNumber>(),
                mtrlID: src.mtrlID,
                secID: src.secID,
                k: new Array<JsonNumber>(),
                l: AsJsonNum(src.l),
                bcs: new Array<SOLVE.Bc_json>(),
                dofs: new Array<JsonNumber>(),
                outCoords: new Array<SOLVE.XYZ_json>(),
                guid: src.guid,
                normalForceAtNode1: AsJsonNum(src.normalForceAtNode1),
                normalForceAtNode2: AsJsonNum(src.normalForceAtNode2),
            };
            if (src.nodes !== null) {
                for (const element of src.nodes) {
                    dst.nodes.push(AsJsonNum(NumberToInt("SOLVE.Elem.nodes", element)));
                }
            }
            if(src.n1 !== null)
            {
                const parsed = SOLVE.XYZ.toObject(src.n1);
                if(parsed === null) return null;
                dst.n1 = parsed;
            }
            if(src.n2 !== null)
            {
                const parsed = SOLVE.XYZ.toObject(src.n2);
                if(parsed === null) return null;
                dst.n2 = parsed;
            }
            if(src.n3 !== null)
            {
                const parsed = SOLVE.XYZ.toObject(src.n3);
                if(parsed === null) return null;
                dst.n3 = parsed;
            }
            if (src.k !== null) {
                for (const element of src.k) {
                    dst.k.push(AsJsonNum(element));
                }
            }
            if (src.bcs !== null) {
                for (const element of src.bcs) {
                    const parsed = SOLVE.Bc.toObject(element);
                    if(parsed === null) return null;
                    dst.bcs.push(parsed);
                }
            }
            if (src.dofs !== null) {
                for (const element of src.dofs) {
                    dst.dofs.push(AsJsonNum(NumberToInt("SOLVE.Elem.dofs", element)));
                }
            }
            if (src.outCoords !== null) {
                for (const element of src.outCoords) {
                    const parsed = SOLVE.XYZ.toObject(element);
                    if(parsed === null) return null;
                    dst.outCoords.push(parsed);
                }
            }
            return dst;
        }

        static create(src?: Elem_createType) {
            const dst = new Elem();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.type !== undefined) {
                dst.type = src.type;
            }
            if (src.nodes !== undefined) {
                dst.nodes = src.nodes;
            }
            if (src.n1 !== undefined) {
                dst.n1 = src.n1;
            }
            if (src.n2 !== undefined) {
                dst.n2 = src.n2;
            }
            if (src.n3 !== undefined) {
                dst.n3 = src.n3;
            }
            if (src.mtrlID !== undefined) {
                dst.mtrlID = src.mtrlID;
            }
            if (src.secID !== undefined) {
                dst.secID = src.secID;
            }
            if (src.k !== undefined) {
                dst.k = src.k;
            }
            if (src.l !== undefined) {
                dst.l = src.l;
            }
            if (src.bcs !== undefined) {
                dst.bcs = src.bcs;
            }
            if (src.dofs !== undefined) {
                dst.dofs = src.dofs;
            }
            if (src.outCoords !== undefined) {
                dst.outCoords = src.outCoords;
            }
            if (src.guid !== undefined) {
                dst.guid = src.guid;
            }
            if (src.normalForceAtNode1 !== undefined) {
                dst.normalForceAtNode1 = src.normalForceAtNode1;
            }
            if (src.normalForceAtNode2 !== undefined) {
                dst.normalForceAtNode2 = src.normalForceAtNode2;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Elem();
            dst.id = this.id;
            dst.type = this.type;
            dst.nodes = this.nodes;
            dst.n1 = this.n1;
            dst.n2 = this.n2;
            dst.n3 = this.n3;
            dst.mtrlID = this.mtrlID;
            dst.secID = this.secID;
            dst.k = this.k;
            dst.l = this.l;
            dst.bcs = this.bcs;
            dst.dofs = this.dofs;
            dst.outCoords = this.outCoords;
            dst.guid = this.guid;
            dst.normalForceAtNode1 = this.normalForceAtNode1;
            dst.normalForceAtNode2 = this.normalForceAtNode2;
            return dst;
        }

        deepClone() {
            const json = Elem.toObject(this);
            const dst = Elem.fromObject(json);
            return dst;
        }
    }
    export type IElem = Elem;


    export type Nset_keys = 'id' | 'nodes';
    export interface Nset_createType {
        id?: string,
        nodes?: number[],
    }
    export interface Nset_json {
        id?: string;
        nodes: JsonNumber[];
    }
    interface Nset_json_in {
        __proto_name?: unknown;
        id?: unknown;
        nodes?: unknown;
    }
    export class Nset {
        __proto_name = "SOLVE.Nset";
        id: string = "";
        nodes: number[] = [];

        static fromObject(src_unknown: unknown): Nset {
            const dst = new Nset();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Nset but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Nset_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Nset but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "string") {
                    dst.id = src.id;
                }
                else {
                    console.log('Expected id of Nset to be a string but was ', typeof src.id, src.id)
                }
            }
            if (src.nodes !== undefined && src.nodes !== null) {
                if (Array.isArray(src.nodes)) {
                    for (const [index, element] of src.nodes.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.nodes.push(NumberToInt("SOLVE.Nset.nodes", AsNum(element)));
                        }
                        else {
                            console.log('Expected nodes of Nset[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected nodes of Nset to be a array but was ', typeof src.nodes, src.nodes)
                }
            }
            return dst;
        }

        static toObject(src: Nset | null | undefined): Nset_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Nset is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Nset") {
                console.error('Expected SOLVE.Nset but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Nset_json = {
                id: src.id,
                nodes: new Array<JsonNumber>(),
            };
            if (src.nodes !== null) {
                for (const element of src.nodes) {
                    dst.nodes.push(AsJsonNum(NumberToInt("SOLVE.Nset.nodes", element)));
                }
            }
            return dst;
        }

        static create(src?: Nset_createType) {
            const dst = new Nset();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.nodes !== undefined) {
                dst.nodes = src.nodes;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Nset();
            dst.id = this.id;
            dst.nodes = this.nodes;
            return dst;
        }

        deepClone() {
            const json = Nset.toObject(this);
            const dst = Nset.fromObject(json);
            return dst;
        }
    }
    export type INset = Nset;


    export type Elset_keys = 'id' | 'elems';
    export interface Elset_createType {
        id?: string,
        elems?: number[],
    }
    export interface Elset_json {
        id?: string;
        elems: JsonNumber[];
    }
    interface Elset_json_in {
        __proto_name?: unknown;
        id?: unknown;
        elems?: unknown;
    }
    export class Elset {
        __proto_name = "SOLVE.Elset";
        id: string = "";
        elems: number[] = [];

        static fromObject(src_unknown: unknown): Elset {
            const dst = new Elset();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Elset but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Elset_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Elset but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "string") {
                    dst.id = src.id;
                }
                else {
                    console.log('Expected id of Elset to be a string but was ', typeof src.id, src.id)
                }
            }
            if (src.elems !== undefined && src.elems !== null) {
                if (Array.isArray(src.elems)) {
                    for (const [index, element] of src.elems.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.elems.push(NumberToInt("SOLVE.Elset.elems", AsNum(element)));
                        }
                        else {
                            console.log('Expected elems of Elset[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected elems of Elset to be a array but was ', typeof src.elems, src.elems)
                }
            }
            return dst;
        }

        static toObject(src: Elset | null | undefined): Elset_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Elset is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Elset") {
                console.error('Expected SOLVE.Elset but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Elset_json = {
                id: src.id,
                elems: new Array<JsonNumber>(),
            };
            if (src.elems !== null) {
                for (const element of src.elems) {
                    dst.elems.push(AsJsonNum(NumberToInt("SOLVE.Elset.elems", element)));
                }
            }
            return dst;
        }

        static create(src?: Elset_createType) {
            const dst = new Elset();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.elems !== undefined) {
                dst.elems = src.elems;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Elset();
            dst.id = this.id;
            dst.elems = this.elems;
            return dst;
        }

        deepClone() {
            const json = Elset.toObject(this);
            const dst = Elset.fromObject(json);
            return dst;
        }
    }
    export type IElset = Elset;


    export type Mtrl_keys = 'id' | 'E' | 'G' | 'nu' | 'rho' | 'c' | 'k1';
    export interface Mtrl_createType {
        id?: string,
        E?: number,
        G?: number,
        nu?: number,
        rho?: number,
        c?: number,
        k1?: number,
    }
    export interface Mtrl_json {
        id?: string;
        E?: JsonNumber;
        G?: JsonNumber;
        nu?: JsonNumber;
        rho?: JsonNumber;
        c?: JsonNumber;
        k1?: JsonNumber;
    }
    interface Mtrl_json_in {
        __proto_name?: unknown;
        id?: unknown;
        E?: unknown;
        G?: unknown;
        nu?: unknown;
        rho?: unknown;
        c?: unknown;
        k1?: unknown;
    }
    export class Mtrl {
        __proto_name = "SOLVE.Mtrl";
        id: string = "";
        E: number = 0;
        G: number = 0;
        nu: number = 0;
        rho: number = 0;
        c: number = 0;
        k1: number = 0;

        static fromObject(src_unknown: unknown): Mtrl {
            const dst = new Mtrl();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Mtrl but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Mtrl_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Mtrl but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "string") {
                    dst.id = src.id;
                }
                else {
                    console.log('Expected id of Mtrl to be a string but was ', typeof src.id, src.id)
                }
            }
            if (src.E !== undefined && src.E !== null) {
                if (typeof src.E === "number" || src.E === 'NaN' || src.E === 'Infinity' || src.E === '-Infinity') {
                    dst.E = AsNum(src.E);
                }
                else {
                    console.log('Expected E of Mtrl to be a number but was ', typeof src.E, src.E)
                }
            }
            if (src.G !== undefined && src.G !== null) {
                if (typeof src.G === "number" || src.G === 'NaN' || src.G === 'Infinity' || src.G === '-Infinity') {
                    dst.G = AsNum(src.G);
                }
                else {
                    console.log('Expected G of Mtrl to be a number but was ', typeof src.G, src.G)
                }
            }
            if (src.nu !== undefined && src.nu !== null) {
                if (typeof src.nu === "number" || src.nu === 'NaN' || src.nu === 'Infinity' || src.nu === '-Infinity') {
                    dst.nu = AsNum(src.nu);
                }
                else {
                    console.log('Expected nu of Mtrl to be a number but was ', typeof src.nu, src.nu)
                }
            }
            if (src.rho !== undefined && src.rho !== null) {
                if (typeof src.rho === "number" || src.rho === 'NaN' || src.rho === 'Infinity' || src.rho === '-Infinity') {
                    dst.rho = AsNum(src.rho);
                }
                else {
                    console.log('Expected rho of Mtrl to be a number but was ', typeof src.rho, src.rho)
                }
            }
            if (src.c !== undefined && src.c !== null) {
                if (typeof src.c === "number" || src.c === 'NaN' || src.c === 'Infinity' || src.c === '-Infinity') {
                    dst.c = AsNum(src.c);
                }
                else {
                    console.log('Expected c of Mtrl to be a number but was ', typeof src.c, src.c)
                }
            }
            if (src.k1 !== undefined && src.k1 !== null) {
                if (typeof src.k1 === "number" || src.k1 === 'NaN' || src.k1 === 'Infinity' || src.k1 === '-Infinity') {
                    dst.k1 = AsNum(src.k1);
                }
                else {
                    console.log('Expected k1 of Mtrl to be a number but was ', typeof src.k1, src.k1)
                }
            }
            return dst;
        }

        static toObject(src: Mtrl | null | undefined): Mtrl_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Mtrl is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Mtrl") {
                console.error('Expected SOLVE.Mtrl but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Mtrl_json = {
                id: src.id,
                E: AsJsonNum(src.E),
                G: AsJsonNum(src.G),
                nu: AsJsonNum(src.nu),
                rho: AsJsonNum(src.rho),
                c: AsJsonNum(src.c),
                k1: AsJsonNum(src.k1),
            };
            return dst;
        }

        static create(src?: Mtrl_createType) {
            const dst = new Mtrl();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.E !== undefined) {
                dst.E = src.E;
            }
            if (src.G !== undefined) {
                dst.G = src.G;
            }
            if (src.nu !== undefined) {
                dst.nu = src.nu;
            }
            if (src.rho !== undefined) {
                dst.rho = src.rho;
            }
            if (src.c !== undefined) {
                dst.c = src.c;
            }
            if (src.k1 !== undefined) {
                dst.k1 = src.k1;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Mtrl();
            dst.id = this.id;
            dst.E = this.E;
            dst.G = this.G;
            dst.nu = this.nu;
            dst.rho = this.rho;
            dst.c = this.c;
            dst.k1 = this.k1;
            return dst;
        }

        deepClone() {
            const json = Mtrl.toObject(this);
            const dst = Mtrl.fromObject(json);
            return dst;
        }
    }
    export type IMtrl = Mtrl;


    export type Sec_keys = 'id' | 'A' | 'I1' | 'I2' | 'I12' | 'J' | 'T' | 'n2';
    export interface Sec_createType {
        id?: string,
        A?: number,
        I1?: number,
        I2?: number,
        I12?: number,
        J?: number,
        T?: number,
        n2?: SOLVE.XYZ | null,
    }
    export interface Sec_json {
        id?: string;
        A?: JsonNumber;
        I1?: JsonNumber;
        I2?: JsonNumber;
        I12?: JsonNumber;
        J?: JsonNumber;
        T?: JsonNumber;
        n2?: SOLVE.XYZ_json;
    }
    interface Sec_json_in {
        __proto_name?: unknown;
        id?: unknown;
        A?: unknown;
        I1?: unknown;
        I2?: unknown;
        I12?: unknown;
        J?: unknown;
        T?: unknown;
        n2?: unknown;
    }
    export class Sec {
        __proto_name = "SOLVE.Sec";
        id: string = "";
        A: number = 0;
        I1: number = 0;
        I2: number = 0;
        I12: number = 0;
        J: number = 0;
        T: number = 0;
        n2: SOLVE.XYZ | null = null;

        static fromObject(src_unknown: unknown): Sec {
            const dst = new Sec();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Sec but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Sec_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Sec but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "string") {
                    dst.id = src.id;
                }
                else {
                    console.log('Expected id of Sec to be a string but was ', typeof src.id, src.id)
                }
            }
            if (src.A !== undefined && src.A !== null) {
                if (typeof src.A === "number" || src.A === 'NaN' || src.A === 'Infinity' || src.A === '-Infinity') {
                    dst.A = AsNum(src.A);
                }
                else {
                    console.log('Expected A of Sec to be a number but was ', typeof src.A, src.A)
                }
            }
            if (src.I1 !== undefined && src.I1 !== null) {
                if (typeof src.I1 === "number" || src.I1 === 'NaN' || src.I1 === 'Infinity' || src.I1 === '-Infinity') {
                    dst.I1 = AsNum(src.I1);
                }
                else {
                    console.log('Expected I1 of Sec to be a number but was ', typeof src.I1, src.I1)
                }
            }
            if (src.I2 !== undefined && src.I2 !== null) {
                if (typeof src.I2 === "number" || src.I2 === 'NaN' || src.I2 === 'Infinity' || src.I2 === '-Infinity') {
                    dst.I2 = AsNum(src.I2);
                }
                else {
                    console.log('Expected I2 of Sec to be a number but was ', typeof src.I2, src.I2)
                }
            }
            if (src.I12 !== undefined && src.I12 !== null) {
                if (typeof src.I12 === "number" || src.I12 === 'NaN' || src.I12 === 'Infinity' || src.I12 === '-Infinity') {
                    dst.I12 = AsNum(src.I12);
                }
                else {
                    console.log('Expected I12 of Sec to be a number but was ', typeof src.I12, src.I12)
                }
            }
            if (src.J !== undefined && src.J !== null) {
                if (typeof src.J === "number" || src.J === 'NaN' || src.J === 'Infinity' || src.J === '-Infinity') {
                    dst.J = AsNum(src.J);
                }
                else {
                    console.log('Expected J of Sec to be a number but was ', typeof src.J, src.J)
                }
            }
            if (src.T !== undefined && src.T !== null) {
                if (typeof src.T === "number" || src.T === 'NaN' || src.T === 'Infinity' || src.T === '-Infinity') {
                    dst.T = AsNum(src.T);
                }
                else {
                    console.log('Expected T of Sec to be a number but was ', typeof src.T, src.T)
                }
            }
            if (src.n2 !== undefined && src.n2 !== null) {
                dst.n2 = SOLVE.XYZ.fromObject(src.n2);
            }
            return dst;
        }

        static toObject(src: Sec | null | undefined): Sec_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Sec is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Sec") {
                console.error('Expected SOLVE.Sec but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Sec_json = {
                id: src.id,
                A: AsJsonNum(src.A),
                I1: AsJsonNum(src.I1),
                I2: AsJsonNum(src.I2),
                I12: AsJsonNum(src.I12),
                J: AsJsonNum(src.J),
                T: AsJsonNum(src.T),
            };
            if(src.n2 !== null)
            {
                const parsed = SOLVE.XYZ.toObject(src.n2);
                if(parsed === null) return null;
                dst.n2 = parsed;
            }
            return dst;
        }

        static create(src?: Sec_createType) {
            const dst = new Sec();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.A !== undefined) {
                dst.A = src.A;
            }
            if (src.I1 !== undefined) {
                dst.I1 = src.I1;
            }
            if (src.I2 !== undefined) {
                dst.I2 = src.I2;
            }
            if (src.I12 !== undefined) {
                dst.I12 = src.I12;
            }
            if (src.J !== undefined) {
                dst.J = src.J;
            }
            if (src.T !== undefined) {
                dst.T = src.T;
            }
            if (src.n2 !== undefined) {
                dst.n2 = src.n2;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Sec();
            dst.id = this.id;
            dst.A = this.A;
            dst.I1 = this.I1;
            dst.I2 = this.I2;
            dst.I12 = this.I12;
            dst.J = this.J;
            dst.T = this.T;
            dst.n2 = this.n2;
            return dst;
        }

        deepClone() {
            const json = Sec.toObject(this);
            const dst = Sec.fromObject(json);
            return dst;
        }
    }
    export type ISec = Sec;


    export type Load_keys = 'type1' | 'type2' | 'id' | 'dof' | 'mag1' | 'mag2' | 'x1' | 'x2' | 'magvec' | 'tInf';
    export interface Load_createType {
        type1?: string,
        type2?: string,
        id?: number,
        dof?: number,
        mag1?: number,
        mag2?: number,
        x1?: number,
        x2?: number,
        magvec?: number[],
        tInf?: number,
    }
    export interface Load_json {
        type1?: string;
        type2?: string;
        id?: JsonNumber;
        dof?: JsonNumber;
        mag1?: JsonNumber;
        mag2?: JsonNumber;
        x1?: JsonNumber;
        x2?: JsonNumber;
        magvec: JsonNumber[];
        tInf?: JsonNumber;
    }
    interface Load_json_in {
        __proto_name?: unknown;
        type1?: unknown;
        type2?: unknown;
        id?: unknown;
        dof?: unknown;
        mag1?: unknown;
        mag2?: unknown;
        x1?: unknown;
        x2?: unknown;
        magvec?: unknown;
        tInf?: unknown;
    }
    export class Load {
        __proto_name = "SOLVE.Load";
        type1: string = "";
        type2: string = "";
        id: number = 0;
        dof: number = 0;
        mag1: number = 0;
        mag2: number = 0;
        x1: number = 0;
        x2: number = 0;
        magvec: number[] = [];
        tInf: number = 0;

        static fromObject(src_unknown: unknown): Load {
            const dst = new Load();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Load but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Load_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Load but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.type1 !== undefined && src.type1 !== null) {
                if (typeof src.type1 === "string") {
                    dst.type1 = src.type1;
                }
                else {
                    console.log('Expected type1 of Load to be a string but was ', typeof src.type1, src.type1)
                }
            }
            if (src.type2 !== undefined && src.type2 !== null) {
                if (typeof src.type2 === "string") {
                    dst.type2 = src.type2;
                }
                else {
                    console.log('Expected type2 of Load to be a string but was ', typeof src.type2, src.type2)
                }
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "number" || src.id === 'NaN' || src.id === 'Infinity' || src.id === '-Infinity') {
                    dst.id = NumberToInt("SOLVE.Load.id", AsNum(src.id));
                }
                else {
                    console.log('Expected id of Load to be a number but was ', typeof src.id, src.id)
                }
            }
            if (src.dof !== undefined && src.dof !== null) {
                if (typeof src.dof === "number" || src.dof === 'NaN' || src.dof === 'Infinity' || src.dof === '-Infinity') {
                    dst.dof = NumberToInt("SOLVE.Load.dof", AsNum(src.dof));
                }
                else {
                    console.log('Expected dof of Load to be a number but was ', typeof src.dof, src.dof)
                }
            }
            if (src.mag1 !== undefined && src.mag1 !== null) {
                if (typeof src.mag1 === "number" || src.mag1 === 'NaN' || src.mag1 === 'Infinity' || src.mag1 === '-Infinity') {
                    dst.mag1 = AsNum(src.mag1);
                }
                else {
                    console.log('Expected mag1 of Load to be a number but was ', typeof src.mag1, src.mag1)
                }
            }
            if (src.mag2 !== undefined && src.mag2 !== null) {
                if (typeof src.mag2 === "number" || src.mag2 === 'NaN' || src.mag2 === 'Infinity' || src.mag2 === '-Infinity') {
                    dst.mag2 = AsNum(src.mag2);
                }
                else {
                    console.log('Expected mag2 of Load to be a number but was ', typeof src.mag2, src.mag2)
                }
            }
            if (src.x1 !== undefined && src.x1 !== null) {
                if (typeof src.x1 === "number" || src.x1 === 'NaN' || src.x1 === 'Infinity' || src.x1 === '-Infinity') {
                    dst.x1 = AsNum(src.x1);
                }
                else {
                    console.log('Expected x1 of Load to be a number but was ', typeof src.x1, src.x1)
                }
            }
            if (src.x2 !== undefined && src.x2 !== null) {
                if (typeof src.x2 === "number" || src.x2 === 'NaN' || src.x2 === 'Infinity' || src.x2 === '-Infinity') {
                    dst.x2 = AsNum(src.x2);
                }
                else {
                    console.log('Expected x2 of Load to be a number but was ', typeof src.x2, src.x2)
                }
            }
            if (src.magvec !== undefined && src.magvec !== null) {
                if (Array.isArray(src.magvec)) {
                    for (const [index, element] of src.magvec.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.magvec.push(AsNum(element));
                        }
                        else {
                            console.log('Expected magvec of Load[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected magvec of Load to be a array but was ', typeof src.magvec, src.magvec)
                }
            }
            if (src.tInf !== undefined && src.tInf !== null) {
                if (typeof src.tInf === "number" || src.tInf === 'NaN' || src.tInf === 'Infinity' || src.tInf === '-Infinity') {
                    dst.tInf = AsNum(src.tInf);
                }
                else {
                    console.log('Expected tInf of Load to be a number but was ', typeof src.tInf, src.tInf)
                }
            }
            return dst;
        }

        static toObject(src: Load | null | undefined): Load_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Load is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Load") {
                console.error('Expected SOLVE.Load but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Load_json = {
                type1: src.type1,
                type2: src.type2,
                id: AsJsonNum(NumberToInt("SOLVE.Load.id", src.id)),
                dof: AsJsonNum(NumberToInt("SOLVE.Load.dof", src.dof)),
                mag1: AsJsonNum(src.mag1),
                mag2: AsJsonNum(src.mag2),
                x1: AsJsonNum(src.x1),
                x2: AsJsonNum(src.x2),
                magvec: new Array<JsonNumber>(),
                tInf: AsJsonNum(src.tInf),
            };
            if (src.magvec !== null) {
                for (const element of src.magvec) {
                    dst.magvec.push(AsJsonNum(element));
                }
            }
            return dst;
        }

        static create(src?: Load_createType) {
            const dst = new Load();
            if (src === undefined) {
                return dst;
            }
            if (src.type1 !== undefined) {
                dst.type1 = src.type1;
            }
            if (src.type2 !== undefined) {
                dst.type2 = src.type2;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.dof !== undefined) {
                dst.dof = src.dof;
            }
            if (src.mag1 !== undefined) {
                dst.mag1 = src.mag1;
            }
            if (src.mag2 !== undefined) {
                dst.mag2 = src.mag2;
            }
            if (src.x1 !== undefined) {
                dst.x1 = src.x1;
            }
            if (src.x2 !== undefined) {
                dst.x2 = src.x2;
            }
            if (src.magvec !== undefined) {
                dst.magvec = src.magvec;
            }
            if (src.tInf !== undefined) {
                dst.tInf = src.tInf;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Load();
            dst.type1 = this.type1;
            dst.type2 = this.type2;
            dst.id = this.id;
            dst.dof = this.dof;
            dst.mag1 = this.mag1;
            dst.mag2 = this.mag2;
            dst.x1 = this.x1;
            dst.x2 = this.x2;
            dst.magvec = this.magvec;
            dst.tInf = this.tInf;
            return dst;
        }

        deepClone() {
            const json = Load.toObject(this);
            const dst = Load.fromObject(json);
            return dst;
        }
    }
    export type ILoad = Load;


    export type Loadcase_keys = 'id' | 'loads' | 'fixForces';
    export interface Loadcase_createType {
        id?: string,
        loads?: SOLVE.Load[],
        fixForces?: number[],
    }
    export interface Loadcase_json {
        id?: string;
        loads: SOLVE.Load_json[];
        fixForces: JsonNumber[];
    }
    interface Loadcase_json_in {
        __proto_name?: unknown;
        id?: unknown;
        loads?: unknown;
        fixForces?: unknown;
    }
    export class Loadcase {
        __proto_name = "SOLVE.Loadcase";
        id: string = "";
        loads: SOLVE.Load[] = [];
        fixForces: number[] = [];

        static fromObject(src_unknown: unknown): Loadcase {
            const dst = new Loadcase();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Loadcase but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Loadcase_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Loadcase but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.id !== undefined && src.id !== null) {
                if (typeof src.id === "string") {
                    dst.id = src.id;
                }
                else {
                    console.log('Expected id of Loadcase to be a string but was ', typeof src.id, src.id)
                }
            }
            if (src.loads !== undefined && src.loads !== null) {
                if (Array.isArray(src.loads)) {
                    for (const element of src.loads) {
                        dst.loads.push(SOLVE.Load.fromObject(element));
                    }
                }
                else {
                    console.log('Expected loads of Loadcase to be a array but was ', typeof src.loads, src.loads)
                }
            }
            if (src.fixForces !== undefined && src.fixForces !== null) {
                if (Array.isArray(src.fixForces)) {
                    for (const [index, element] of src.fixForces.entries()) {
                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                            dst.fixForces.push(AsNum(element));
                        }
                        else {
                            console.log('Expected fixForces of Loadcase[', index, '] to be a number but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected fixForces of Loadcase to be a array but was ', typeof src.fixForces, src.fixForces)
                }
            }
            return dst;
        }

        static toObject(src: Loadcase | null | undefined): Loadcase_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Loadcase is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Loadcase") {
                console.error('Expected SOLVE.Loadcase but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Loadcase_json = {
                id: src.id,
                loads: new Array<SOLVE.Load_json>(),
                fixForces: new Array<JsonNumber>(),
            };
            if (src.loads !== null) {
                for (const element of src.loads) {
                    const parsed = SOLVE.Load.toObject(element);
                    if(parsed === null) return null;
                    dst.loads.push(parsed);
                }
            }
            if (src.fixForces !== null) {
                for (const element of src.fixForces) {
                    dst.fixForces.push(AsJsonNum(element));
                }
            }
            return dst;
        }

        static create(src?: Loadcase_createType) {
            const dst = new Loadcase();
            if (src === undefined) {
                return dst;
            }
            if (src.id !== undefined) {
                dst.id = src.id;
            }
            if (src.loads !== undefined) {
                dst.loads = src.loads;
            }
            if (src.fixForces !== undefined) {
                dst.fixForces = src.fixForces;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Loadcase();
            dst.id = this.id;
            dst.loads = this.loads;
            dst.fixForces = this.fixForces;
            return dst;
        }

        deepClone() {
            const json = Loadcase.toObject(this);
            const dst = Loadcase.fromObject(json);
            return dst;
        }
    }
    export type ILoadcase = Loadcase;


    export type Model_keys = 'analysis' | 'nodes' | 'elems' | 'nsets' | 'elsets' | 'bcs' | 'mtrls' | 'secs' | 'lcs' | 'ics' | 'info';
    export interface Model_createType {
        analysis?: SOLVE.Analysis | null,
        nodes?: SOLVE.Node[],
        elems?: SOLVE.Elem[],
        nsets?: SOLVE.Nset[],
        elsets?: SOLVE.Elset[],
        bcs?: SOLVE.Bc[],
        mtrls?: SOLVE.Mtrl[],
        secs?: SOLVE.Sec[],
        lcs?: SOLVE.Loadcase[],
        ics?: SOLVE.Bc[],
        info?: SOLVE.res[],
    }
    export interface Model_json {
        analysis?: SOLVE.Analysis_json;
        nodes: SOLVE.Node_json[];
        elems: SOLVE.Elem_json[];
        nsets: SOLVE.Nset_json[];
        elsets: SOLVE.Elset_json[];
        bcs: SOLVE.Bc_json[];
        mtrls: SOLVE.Mtrl_json[];
        secs: SOLVE.Sec_json[];
        lcs: SOLVE.Loadcase_json[];
        ics: SOLVE.Bc_json[];
        info: string[];
    }
    interface Model_json_in {
        __proto_name?: unknown;
        analysis?: unknown;
        nodes?: unknown;
        elems?: unknown;
        nsets?: unknown;
        elsets?: unknown;
        bcs?: unknown;
        mtrls?: unknown;
        secs?: unknown;
        lcs?: unknown;
        ics?: unknown;
        info?: unknown;
    }
    export class Model {
        __proto_name = "SOLVE.Model";
        analysis: SOLVE.Analysis | null = null;
        nodes: SOLVE.Node[] = [];
        elems: SOLVE.Elem[] = [];
        nsets: SOLVE.Nset[] = [];
        elsets: SOLVE.Elset[] = [];
        bcs: SOLVE.Bc[] = [];
        mtrls: SOLVE.Mtrl[] = [];
        secs: SOLVE.Sec[] = [];
        lcs: SOLVE.Loadcase[] = [];
        ics: SOLVE.Bc[] = [];
        info: SOLVE.res[] = [];

        static fromObject(src_unknown: unknown): Model {
            const dst = new Model();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Model but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Model_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Model but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.analysis !== undefined && src.analysis !== null) {
                dst.analysis = SOLVE.Analysis.fromObject(src.analysis);
            }
            if (src.nodes !== undefined && src.nodes !== null) {
                if (Array.isArray(src.nodes)) {
                    for (const element of src.nodes) {
                        dst.nodes.push(SOLVE.Node.fromObject(element));
                    }
                }
                else {
                    console.log('Expected nodes of Model to be a array but was ', typeof src.nodes, src.nodes)
                }
            }
            if (src.elems !== undefined && src.elems !== null) {
                if (Array.isArray(src.elems)) {
                    for (const element of src.elems) {
                        dst.elems.push(SOLVE.Elem.fromObject(element));
                    }
                }
                else {
                    console.log('Expected elems of Model to be a array but was ', typeof src.elems, src.elems)
                }
            }
            if (src.nsets !== undefined && src.nsets !== null) {
                if (Array.isArray(src.nsets)) {
                    for (const element of src.nsets) {
                        dst.nsets.push(SOLVE.Nset.fromObject(element));
                    }
                }
                else {
                    console.log('Expected nsets of Model to be a array but was ', typeof src.nsets, src.nsets)
                }
            }
            if (src.elsets !== undefined && src.elsets !== null) {
                if (Array.isArray(src.elsets)) {
                    for (const element of src.elsets) {
                        dst.elsets.push(SOLVE.Elset.fromObject(element));
                    }
                }
                else {
                    console.log('Expected elsets of Model to be a array but was ', typeof src.elsets, src.elsets)
                }
            }
            if (src.bcs !== undefined && src.bcs !== null) {
                if (Array.isArray(src.bcs)) {
                    for (const element of src.bcs) {
                        dst.bcs.push(SOLVE.Bc.fromObject(element));
                    }
                }
                else {
                    console.log('Expected bcs of Model to be a array but was ', typeof src.bcs, src.bcs)
                }
            }
            if (src.mtrls !== undefined && src.mtrls !== null) {
                if (Array.isArray(src.mtrls)) {
                    for (const element of src.mtrls) {
                        dst.mtrls.push(SOLVE.Mtrl.fromObject(element));
                    }
                }
                else {
                    console.log('Expected mtrls of Model to be a array but was ', typeof src.mtrls, src.mtrls)
                }
            }
            if (src.secs !== undefined && src.secs !== null) {
                if (Array.isArray(src.secs)) {
                    for (const element of src.secs) {
                        dst.secs.push(SOLVE.Sec.fromObject(element));
                    }
                }
                else {
                    console.log('Expected secs of Model to be a array but was ', typeof src.secs, src.secs)
                }
            }
            if (src.lcs !== undefined && src.lcs !== null) {
                if (Array.isArray(src.lcs)) {
                    for (const element of src.lcs) {
                        dst.lcs.push(SOLVE.Loadcase.fromObject(element));
                    }
                }
                else {
                    console.log('Expected lcs of Model to be a array but was ', typeof src.lcs, src.lcs)
                }
            }
            if (src.ics !== undefined && src.ics !== null) {
                if (Array.isArray(src.ics)) {
                    for (const element of src.ics) {
                        dst.ics.push(SOLVE.Bc.fromObject(element));
                    }
                }
                else {
                    console.log('Expected ics of Model to be a array but was ', typeof src.ics, src.ics)
                }
            }
            if (src.info !== undefined && src.info !== null) {
                if (Array.isArray(src.info)) {
                    for (const element of src.info) {
                        dst.info.push(SOLVE.res_FromObject(element));
                    }
                }
                else {
                    console.log('Expected info of Model to be a array but was ', typeof src.info, src.info)
                }
            }
            return dst;
        }

        static toObject(src: Model | null | undefined): Model_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Model is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Model") {
                console.error('Expected SOLVE.Model but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Model_json = {
                nodes: new Array<SOLVE.Node_json>(),
                elems: new Array<SOLVE.Elem_json>(),
                nsets: new Array<SOLVE.Nset_json>(),
                elsets: new Array<SOLVE.Elset_json>(),
                bcs: new Array<SOLVE.Bc_json>(),
                mtrls: new Array<SOLVE.Mtrl_json>(),
                secs: new Array<SOLVE.Sec_json>(),
                lcs: new Array<SOLVE.Loadcase_json>(),
                ics: new Array<SOLVE.Bc_json>(),
                info: new Array<string>(),
            };
            if(src.analysis !== null)
            {
                const parsed = SOLVE.Analysis.toObject(src.analysis);
                if(parsed === null) return null;
                dst.analysis = parsed;
            }
            if (src.nodes !== null) {
                for (const element of src.nodes) {
                    const parsed = SOLVE.Node.toObject(element);
                    if(parsed === null) return null;
                    dst.nodes.push(parsed);
                }
            }
            if (src.elems !== null) {
                for (const element of src.elems) {
                    const parsed = SOLVE.Elem.toObject(element);
                    if(parsed === null) return null;
                    dst.elems.push(parsed);
                }
            }
            if (src.nsets !== null) {
                for (const element of src.nsets) {
                    const parsed = SOLVE.Nset.toObject(element);
                    if(parsed === null) return null;
                    dst.nsets.push(parsed);
                }
            }
            if (src.elsets !== null) {
                for (const element of src.elsets) {
                    const parsed = SOLVE.Elset.toObject(element);
                    if(parsed === null) return null;
                    dst.elsets.push(parsed);
                }
            }
            if (src.bcs !== null) {
                for (const element of src.bcs) {
                    const parsed = SOLVE.Bc.toObject(element);
                    if(parsed === null) return null;
                    dst.bcs.push(parsed);
                }
            }
            if (src.mtrls !== null) {
                for (const element of src.mtrls) {
                    const parsed = SOLVE.Mtrl.toObject(element);
                    if(parsed === null) return null;
                    dst.mtrls.push(parsed);
                }
            }
            if (src.secs !== null) {
                for (const element of src.secs) {
                    const parsed = SOLVE.Sec.toObject(element);
                    if(parsed === null) return null;
                    dst.secs.push(parsed);
                }
            }
            if (src.lcs !== null) {
                for (const element of src.lcs) {
                    const parsed = SOLVE.Loadcase.toObject(element);
                    if(parsed === null) return null;
                    dst.lcs.push(parsed);
                }
            }
            if (src.ics !== null) {
                for (const element of src.ics) {
                    const parsed = SOLVE.Bc.toObject(element);
                    if(parsed === null) return null;
                    dst.ics.push(parsed);
                }
            }
            if (src.info !== null) {
                for (const element of src.info) {
                    const parsed = SOLVE.res_ToObject(element);
                    if(parsed === null) return null;
                    dst.info.push(parsed);
                }
            }
            return dst;
        }

        static create(src?: Model_createType) {
            const dst = new Model();
            if (src === undefined) {
                return dst;
            }
            if (src.analysis !== undefined) {
                dst.analysis = src.analysis;
            }
            if (src.nodes !== undefined) {
                dst.nodes = src.nodes;
            }
            if (src.elems !== undefined) {
                dst.elems = src.elems;
            }
            if (src.nsets !== undefined) {
                dst.nsets = src.nsets;
            }
            if (src.elsets !== undefined) {
                dst.elsets = src.elsets;
            }
            if (src.bcs !== undefined) {
                dst.bcs = src.bcs;
            }
            if (src.mtrls !== undefined) {
                dst.mtrls = src.mtrls;
            }
            if (src.secs !== undefined) {
                dst.secs = src.secs;
            }
            if (src.lcs !== undefined) {
                dst.lcs = src.lcs;
            }
            if (src.ics !== undefined) {
                dst.ics = src.ics;
            }
            if (src.info !== undefined) {
                dst.info = src.info;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Model();
            dst.analysis = this.analysis;
            dst.nodes = this.nodes;
            dst.elems = this.elems;
            dst.nsets = this.nsets;
            dst.elsets = this.elsets;
            dst.bcs = this.bcs;
            dst.mtrls = this.mtrls;
            dst.secs = this.secs;
            dst.lcs = this.lcs;
            dst.ics = this.ics;
            dst.info = this.info;
            return dst;
        }

        deepClone() {
            const json = Model.toObject(this);
            const dst = Model.fromObject(json);
            return dst;
        }
    }
    export type IModel = Model;


    export type NodalRes_keys = 'reac' | 'u';
    export interface NodalRes_createType {
        reac?: SOLVE.RM[],
        u?: SOLVE.U[],
    }
    export interface NodalRes_json {
        reac: SOLVE.RM_json[];
        u: SOLVE.U_json[];
    }
    interface NodalRes_json_in {
        __proto_name?: unknown;
        reac?: unknown;
        u?: unknown;
    }
    export class NodalRes {
        __proto_name = "SOLVE.NodalRes";
        reac: SOLVE.RM[] = [];
        u: SOLVE.U[] = [];

        static fromObject(src_unknown: unknown): NodalRes {
            const dst = new NodalRes();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted NodalRes but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as NodalRes_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for NodalRes but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.reac !== undefined && src.reac !== null) {
                if (Array.isArray(src.reac)) {
                    for (const element of src.reac) {
                        dst.reac.push(SOLVE.RM.fromObject(element));
                    }
                }
                else {
                    console.log('Expected reac of NodalRes to be a array but was ', typeof src.reac, src.reac)
                }
            }
            if (src.u !== undefined && src.u !== null) {
                if (Array.isArray(src.u)) {
                    for (const element of src.u) {
                        dst.u.push(SOLVE.U.fromObject(element));
                    }
                }
                else {
                    console.log('Expected u of NodalRes to be a array but was ', typeof src.u, src.u)
                }
            }
            return dst;
        }

        static toObject(src: NodalRes | null | undefined): NodalRes_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.NodalRes is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.NodalRes") {
                console.error('Expected SOLVE.NodalRes but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : NodalRes_json = {
                reac: new Array<SOLVE.RM_json>(),
                u: new Array<SOLVE.U_json>(),
            };
            if (src.reac !== null) {
                for (const element of src.reac) {
                    const parsed = SOLVE.RM.toObject(element);
                    if(parsed === null) return null;
                    dst.reac.push(parsed);
                }
            }
            if (src.u !== null) {
                for (const element of src.u) {
                    const parsed = SOLVE.U.toObject(element);
                    if(parsed === null) return null;
                    dst.u.push(parsed);
                }
            }
            return dst;
        }

        static create(src?: NodalRes_createType) {
            const dst = new NodalRes();
            if (src === undefined) {
                return dst;
            }
            if (src.reac !== undefined) {
                dst.reac = src.reac;
            }
            if (src.u !== undefined) {
                dst.u = src.u;
            }
            return dst;
        }

        shallowClone() {
            const dst = new NodalRes();
            dst.reac = this.reac;
            dst.u = this.u;
            return dst;
        }

        deepClone() {
            const json = NodalRes.toObject(this);
            const dst = NodalRes.fromObject(json);
            return dst;
        }
    }
    export type INodalRes = NodalRes;


    export type ElemRes_keys = 'resVec';
    export interface ElemRes_createType {
        resVec?: SOLVE.ElemResVec[],
    }
    export interface ElemRes_json {
        resVec: SOLVE.ElemResVec_json[];
    }
    interface ElemRes_json_in {
        __proto_name?: unknown;
        resVec?: unknown;
    }
    export class ElemRes {
        __proto_name = "SOLVE.ElemRes";
        resVec: SOLVE.ElemResVec[] = [];

        static fromObject(src_unknown: unknown): ElemRes {
            const dst = new ElemRes();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted ElemRes but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as ElemRes_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for ElemRes but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.resVec !== undefined && src.resVec !== null) {
                if (Array.isArray(src.resVec)) {
                    for (const element of src.resVec) {
                        dst.resVec.push(SOLVE.ElemResVec.fromObject(element));
                    }
                }
                else {
                    console.log('Expected resVec of ElemRes to be a array but was ', typeof src.resVec, src.resVec)
                }
            }
            return dst;
        }

        static toObject(src: ElemRes | null | undefined): ElemRes_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.ElemRes is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.ElemRes") {
                console.error('Expected SOLVE.ElemRes but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : ElemRes_json = {
                resVec: new Array<SOLVE.ElemResVec_json>(),
            };
            if (src.resVec !== null) {
                for (const element of src.resVec) {
                    const parsed = SOLVE.ElemResVec.toObject(element);
                    if(parsed === null) return null;
                    dst.resVec.push(parsed);
                }
            }
            return dst;
        }

        static create(src?: ElemRes_createType) {
            const dst = new ElemRes();
            if (src === undefined) {
                return dst;
            }
            if (src.resVec !== undefined) {
                dst.resVec = src.resVec;
            }
            return dst;
        }

        shallowClone() {
            const dst = new ElemRes();
            dst.resVec = this.resVec;
            return dst;
        }

        deepClone() {
            const json = ElemRes.toObject(this);
            const dst = ElemRes.fromObject(json);
            return dst;
        }
    }
    export type IElemRes = ElemRes;


    export type SecData_keys = 'a' | 'p' | 'xc' | 'yc' | 'xs' | 'ys' | 'iX' | 'wX' | 'zX' | 'smX' | 'irX' | 'emaxY' | 'eminY' | 'iY' | 'wY' | 'zY' | 'smY' | 'irY' | 'emaxX' | 'eminX' | 'j' | 'iT' | 'wT' | 'iW' | 'iXy' | 'betaOmega' | 'i1' | 'w1' | 'z1' | 'sm1' | 'ir1' | 'emax2' | 'emin2' | 'rho1' | 'c1' | 'beta1' | 'sh1' | 'ang1' | 'i2' | 'w2' | 'z2' | 'sm2' | 'ir2' | 'emax1' | 'emin1' | 'rho2' | 'c2' | 'beta2' | 'sh2' | 'ang2';
    export interface SecData_createType {
        a?: number,
        p?: number,
        xc?: number,
        yc?: number,
        xs?: number,
        ys?: number,
        iX?: number,
        wX?: number,
        zX?: number,
        smX?: number,
        irX?: number,
        emaxY?: number,
        eminY?: number,
        iY?: number,
        wY?: number,
        zY?: number,
        smY?: number,
        irY?: number,
        emaxX?: number,
        eminX?: number,
        j?: number,
        iT?: number,
        wT?: number,
        iW?: number,
        iXy?: number,
        betaOmega?: number,
        i1?: number,
        w1?: number,
        z1?: number,
        sm1?: number,
        ir1?: number,
        emax2?: number,
        emin2?: number,
        rho1?: number,
        c1?: number,
        beta1?: number,
        sh1?: number,
        ang1?: number,
        i2?: number,
        w2?: number,
        z2?: number,
        sm2?: number,
        ir2?: number,
        emax1?: number,
        emin1?: number,
        rho2?: number,
        c2?: number,
        beta2?: number,
        sh2?: number,
        ang2?: number,
    }
    export interface SecData_json {
        a?: JsonNumber;
        p?: JsonNumber;
        xc?: JsonNumber;
        yc?: JsonNumber;
        xs?: JsonNumber;
        ys?: JsonNumber;
        iX?: JsonNumber;
        wX?: JsonNumber;
        zX?: JsonNumber;
        smX?: JsonNumber;
        irX?: JsonNumber;
        emaxY?: JsonNumber;
        eminY?: JsonNumber;
        iY?: JsonNumber;
        wY?: JsonNumber;
        zY?: JsonNumber;
        smY?: JsonNumber;
        irY?: JsonNumber;
        emaxX?: JsonNumber;
        eminX?: JsonNumber;
        j?: JsonNumber;
        iT?: JsonNumber;
        wT?: JsonNumber;
        iW?: JsonNumber;
        iXy?: JsonNumber;
        betaOmega?: JsonNumber;
        i1?: JsonNumber;
        w1?: JsonNumber;
        z1?: JsonNumber;
        sm1?: JsonNumber;
        ir1?: JsonNumber;
        emax2?: JsonNumber;
        emin2?: JsonNumber;
        rho1?: JsonNumber;
        c1?: JsonNumber;
        beta1?: JsonNumber;
        sh1?: JsonNumber;
        ang1?: JsonNumber;
        i2?: JsonNumber;
        w2?: JsonNumber;
        z2?: JsonNumber;
        sm2?: JsonNumber;
        ir2?: JsonNumber;
        emax1?: JsonNumber;
        emin1?: JsonNumber;
        rho2?: JsonNumber;
        c2?: JsonNumber;
        beta2?: JsonNumber;
        sh2?: JsonNumber;
        ang2?: JsonNumber;
    }
    interface SecData_json_in {
        __proto_name?: unknown;
        a?: unknown;
        p?: unknown;
        xc?: unknown;
        yc?: unknown;
        xs?: unknown;
        ys?: unknown;
        iX?: unknown;
        wX?: unknown;
        zX?: unknown;
        smX?: unknown;
        irX?: unknown;
        emaxY?: unknown;
        eminY?: unknown;
        iY?: unknown;
        wY?: unknown;
        zY?: unknown;
        smY?: unknown;
        irY?: unknown;
        emaxX?: unknown;
        eminX?: unknown;
        j?: unknown;
        iT?: unknown;
        wT?: unknown;
        iW?: unknown;
        iXy?: unknown;
        betaOmega?: unknown;
        i1?: unknown;
        w1?: unknown;
        z1?: unknown;
        sm1?: unknown;
        ir1?: unknown;
        emax2?: unknown;
        emin2?: unknown;
        rho1?: unknown;
        c1?: unknown;
        beta1?: unknown;
        sh1?: unknown;
        ang1?: unknown;
        i2?: unknown;
        w2?: unknown;
        z2?: unknown;
        sm2?: unknown;
        ir2?: unknown;
        emax1?: unknown;
        emin1?: unknown;
        rho2?: unknown;
        c2?: unknown;
        beta2?: unknown;
        sh2?: unknown;
        ang2?: unknown;
    }
    export class SecData {
        __proto_name = "SOLVE.SecData";
        a: number = 0;
        p: number = 0;
        xc: number = 0;
        yc: number = 0;
        xs: number = 0;
        ys: number = 0;
        iX: number = 0;
        wX: number = 0;
        zX: number = 0;
        smX: number = 0;
        irX: number = 0;
        emaxY: number = 0;
        eminY: number = 0;
        iY: number = 0;
        wY: number = 0;
        zY: number = 0;
        smY: number = 0;
        irY: number = 0;
        emaxX: number = 0;
        eminX: number = 0;
        j: number = 0;
        iT: number = 0;
        wT: number = 0;
        iW: number = 0;
        iXy: number = 0;
        betaOmega: number = 0;
        i1: number = 0;
        w1: number = 0;
        z1: number = 0;
        sm1: number = 0;
        ir1: number = 0;
        emax2: number = 0;
        emin2: number = 0;
        rho1: number = 0;
        c1: number = 0;
        beta1: number = 0;
        sh1: number = 0;
        ang1: number = 0;
        i2: number = 0;
        w2: number = 0;
        z2: number = 0;
        sm2: number = 0;
        ir2: number = 0;
        emax1: number = 0;
        emin1: number = 0;
        rho2: number = 0;
        c2: number = 0;
        beta2: number = 0;
        sh2: number = 0;
        ang2: number = 0;

        static fromObject(src_unknown: unknown): SecData {
            const dst = new SecData();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted SecData but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as SecData_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for SecData but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.a !== undefined && src.a !== null) {
                if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                    dst.a = AsNum(src.a);
                }
                else {
                    console.log('Expected a of SecData to be a number but was ', typeof src.a, src.a)
                }
            }
            if (src.p !== undefined && src.p !== null) {
                if (typeof src.p === "number" || src.p === 'NaN' || src.p === 'Infinity' || src.p === '-Infinity') {
                    dst.p = AsNum(src.p);
                }
                else {
                    console.log('Expected p of SecData to be a number but was ', typeof src.p, src.p)
                }
            }
            if (src.xc !== undefined && src.xc !== null) {
                if (typeof src.xc === "number" || src.xc === 'NaN' || src.xc === 'Infinity' || src.xc === '-Infinity') {
                    dst.xc = AsNum(src.xc);
                }
                else {
                    console.log('Expected xc of SecData to be a number but was ', typeof src.xc, src.xc)
                }
            }
            if (src.yc !== undefined && src.yc !== null) {
                if (typeof src.yc === "number" || src.yc === 'NaN' || src.yc === 'Infinity' || src.yc === '-Infinity') {
                    dst.yc = AsNum(src.yc);
                }
                else {
                    console.log('Expected yc of SecData to be a number but was ', typeof src.yc, src.yc)
                }
            }
            if (src.xs !== undefined && src.xs !== null) {
                if (typeof src.xs === "number" || src.xs === 'NaN' || src.xs === 'Infinity' || src.xs === '-Infinity') {
                    dst.xs = AsNum(src.xs);
                }
                else {
                    console.log('Expected xs of SecData to be a number but was ', typeof src.xs, src.xs)
                }
            }
            if (src.ys !== undefined && src.ys !== null) {
                if (typeof src.ys === "number" || src.ys === 'NaN' || src.ys === 'Infinity' || src.ys === '-Infinity') {
                    dst.ys = AsNum(src.ys);
                }
                else {
                    console.log('Expected ys of SecData to be a number but was ', typeof src.ys, src.ys)
                }
            }
            if (src.iX !== undefined && src.iX !== null) {
                if (typeof src.iX === "number" || src.iX === 'NaN' || src.iX === 'Infinity' || src.iX === '-Infinity') {
                    dst.iX = AsNum(src.iX);
                }
                else {
                    console.log('Expected iX of SecData to be a number but was ', typeof src.iX, src.iX)
                }
            }
            if (src.wX !== undefined && src.wX !== null) {
                if (typeof src.wX === "number" || src.wX === 'NaN' || src.wX === 'Infinity' || src.wX === '-Infinity') {
                    dst.wX = AsNum(src.wX);
                }
                else {
                    console.log('Expected wX of SecData to be a number but was ', typeof src.wX, src.wX)
                }
            }
            if (src.zX !== undefined && src.zX !== null) {
                if (typeof src.zX === "number" || src.zX === 'NaN' || src.zX === 'Infinity' || src.zX === '-Infinity') {
                    dst.zX = AsNum(src.zX);
                }
                else {
                    console.log('Expected zX of SecData to be a number but was ', typeof src.zX, src.zX)
                }
            }
            if (src.smX !== undefined && src.smX !== null) {
                if (typeof src.smX === "number" || src.smX === 'NaN' || src.smX === 'Infinity' || src.smX === '-Infinity') {
                    dst.smX = AsNum(src.smX);
                }
                else {
                    console.log('Expected smX of SecData to be a number but was ', typeof src.smX, src.smX)
                }
            }
            if (src.irX !== undefined && src.irX !== null) {
                if (typeof src.irX === "number" || src.irX === 'NaN' || src.irX === 'Infinity' || src.irX === '-Infinity') {
                    dst.irX = AsNum(src.irX);
                }
                else {
                    console.log('Expected irX of SecData to be a number but was ', typeof src.irX, src.irX)
                }
            }
            if (src.emaxY !== undefined && src.emaxY !== null) {
                if (typeof src.emaxY === "number" || src.emaxY === 'NaN' || src.emaxY === 'Infinity' || src.emaxY === '-Infinity') {
                    dst.emaxY = AsNum(src.emaxY);
                }
                else {
                    console.log('Expected emaxY of SecData to be a number but was ', typeof src.emaxY, src.emaxY)
                }
            }
            if (src.eminY !== undefined && src.eminY !== null) {
                if (typeof src.eminY === "number" || src.eminY === 'NaN' || src.eminY === 'Infinity' || src.eminY === '-Infinity') {
                    dst.eminY = AsNum(src.eminY);
                }
                else {
                    console.log('Expected eminY of SecData to be a number but was ', typeof src.eminY, src.eminY)
                }
            }
            if (src.iY !== undefined && src.iY !== null) {
                if (typeof src.iY === "number" || src.iY === 'NaN' || src.iY === 'Infinity' || src.iY === '-Infinity') {
                    dst.iY = AsNum(src.iY);
                }
                else {
                    console.log('Expected iY of SecData to be a number but was ', typeof src.iY, src.iY)
                }
            }
            if (src.wY !== undefined && src.wY !== null) {
                if (typeof src.wY === "number" || src.wY === 'NaN' || src.wY === 'Infinity' || src.wY === '-Infinity') {
                    dst.wY = AsNum(src.wY);
                }
                else {
                    console.log('Expected wY of SecData to be a number but was ', typeof src.wY, src.wY)
                }
            }
            if (src.zY !== undefined && src.zY !== null) {
                if (typeof src.zY === "number" || src.zY === 'NaN' || src.zY === 'Infinity' || src.zY === '-Infinity') {
                    dst.zY = AsNum(src.zY);
                }
                else {
                    console.log('Expected zY of SecData to be a number but was ', typeof src.zY, src.zY)
                }
            }
            if (src.smY !== undefined && src.smY !== null) {
                if (typeof src.smY === "number" || src.smY === 'NaN' || src.smY === 'Infinity' || src.smY === '-Infinity') {
                    dst.smY = AsNum(src.smY);
                }
                else {
                    console.log('Expected smY of SecData to be a number but was ', typeof src.smY, src.smY)
                }
            }
            if (src.irY !== undefined && src.irY !== null) {
                if (typeof src.irY === "number" || src.irY === 'NaN' || src.irY === 'Infinity' || src.irY === '-Infinity') {
                    dst.irY = AsNum(src.irY);
                }
                else {
                    console.log('Expected irY of SecData to be a number but was ', typeof src.irY, src.irY)
                }
            }
            if (src.emaxX !== undefined && src.emaxX !== null) {
                if (typeof src.emaxX === "number" || src.emaxX === 'NaN' || src.emaxX === 'Infinity' || src.emaxX === '-Infinity') {
                    dst.emaxX = AsNum(src.emaxX);
                }
                else {
                    console.log('Expected emaxX of SecData to be a number but was ', typeof src.emaxX, src.emaxX)
                }
            }
            if (src.eminX !== undefined && src.eminX !== null) {
                if (typeof src.eminX === "number" || src.eminX === 'NaN' || src.eminX === 'Infinity' || src.eminX === '-Infinity') {
                    dst.eminX = AsNum(src.eminX);
                }
                else {
                    console.log('Expected eminX of SecData to be a number but was ', typeof src.eminX, src.eminX)
                }
            }
            if (src.j !== undefined && src.j !== null) {
                if (typeof src.j === "number" || src.j === 'NaN' || src.j === 'Infinity' || src.j === '-Infinity') {
                    dst.j = AsNum(src.j);
                }
                else {
                    console.log('Expected j of SecData to be a number but was ', typeof src.j, src.j)
                }
            }
            if (src.iT !== undefined && src.iT !== null) {
                if (typeof src.iT === "number" || src.iT === 'NaN' || src.iT === 'Infinity' || src.iT === '-Infinity') {
                    dst.iT = AsNum(src.iT);
                }
                else {
                    console.log('Expected iT of SecData to be a number but was ', typeof src.iT, src.iT)
                }
            }
            if (src.wT !== undefined && src.wT !== null) {
                if (typeof src.wT === "number" || src.wT === 'NaN' || src.wT === 'Infinity' || src.wT === '-Infinity') {
                    dst.wT = AsNum(src.wT);
                }
                else {
                    console.log('Expected wT of SecData to be a number but was ', typeof src.wT, src.wT)
                }
            }
            if (src.iW !== undefined && src.iW !== null) {
                if (typeof src.iW === "number" || src.iW === 'NaN' || src.iW === 'Infinity' || src.iW === '-Infinity') {
                    dst.iW = AsNum(src.iW);
                }
                else {
                    console.log('Expected iW of SecData to be a number but was ', typeof src.iW, src.iW)
                }
            }
            if (src.iXy !== undefined && src.iXy !== null) {
                if (typeof src.iXy === "number" || src.iXy === 'NaN' || src.iXy === 'Infinity' || src.iXy === '-Infinity') {
                    dst.iXy = AsNum(src.iXy);
                }
                else {
                    console.log('Expected iXy of SecData to be a number but was ', typeof src.iXy, src.iXy)
                }
            }
            if (src.betaOmega !== undefined && src.betaOmega !== null) {
                if (typeof src.betaOmega === "number" || src.betaOmega === 'NaN' || src.betaOmega === 'Infinity' || src.betaOmega === '-Infinity') {
                    dst.betaOmega = AsNum(src.betaOmega);
                }
                else {
                    console.log('Expected betaOmega of SecData to be a number but was ', typeof src.betaOmega, src.betaOmega)
                }
            }
            if (src.i1 !== undefined && src.i1 !== null) {
                if (typeof src.i1 === "number" || src.i1 === 'NaN' || src.i1 === 'Infinity' || src.i1 === '-Infinity') {
                    dst.i1 = AsNum(src.i1);
                }
                else {
                    console.log('Expected i1 of SecData to be a number but was ', typeof src.i1, src.i1)
                }
            }
            if (src.w1 !== undefined && src.w1 !== null) {
                if (typeof src.w1 === "number" || src.w1 === 'NaN' || src.w1 === 'Infinity' || src.w1 === '-Infinity') {
                    dst.w1 = AsNum(src.w1);
                }
                else {
                    console.log('Expected w1 of SecData to be a number but was ', typeof src.w1, src.w1)
                }
            }
            if (src.z1 !== undefined && src.z1 !== null) {
                if (typeof src.z1 === "number" || src.z1 === 'NaN' || src.z1 === 'Infinity' || src.z1 === '-Infinity') {
                    dst.z1 = AsNum(src.z1);
                }
                else {
                    console.log('Expected z1 of SecData to be a number but was ', typeof src.z1, src.z1)
                }
            }
            if (src.sm1 !== undefined && src.sm1 !== null) {
                if (typeof src.sm1 === "number" || src.sm1 === 'NaN' || src.sm1 === 'Infinity' || src.sm1 === '-Infinity') {
                    dst.sm1 = AsNum(src.sm1);
                }
                else {
                    console.log('Expected sm1 of SecData to be a number but was ', typeof src.sm1, src.sm1)
                }
            }
            if (src.ir1 !== undefined && src.ir1 !== null) {
                if (typeof src.ir1 === "number" || src.ir1 === 'NaN' || src.ir1 === 'Infinity' || src.ir1 === '-Infinity') {
                    dst.ir1 = AsNum(src.ir1);
                }
                else {
                    console.log('Expected ir1 of SecData to be a number but was ', typeof src.ir1, src.ir1)
                }
            }
            if (src.emax2 !== undefined && src.emax2 !== null) {
                if (typeof src.emax2 === "number" || src.emax2 === 'NaN' || src.emax2 === 'Infinity' || src.emax2 === '-Infinity') {
                    dst.emax2 = AsNum(src.emax2);
                }
                else {
                    console.log('Expected emax2 of SecData to be a number but was ', typeof src.emax2, src.emax2)
                }
            }
            if (src.emin2 !== undefined && src.emin2 !== null) {
                if (typeof src.emin2 === "number" || src.emin2 === 'NaN' || src.emin2 === 'Infinity' || src.emin2 === '-Infinity') {
                    dst.emin2 = AsNum(src.emin2);
                }
                else {
                    console.log('Expected emin2 of SecData to be a number but was ', typeof src.emin2, src.emin2)
                }
            }
            if (src.rho1 !== undefined && src.rho1 !== null) {
                if (typeof src.rho1 === "number" || src.rho1 === 'NaN' || src.rho1 === 'Infinity' || src.rho1 === '-Infinity') {
                    dst.rho1 = AsNum(src.rho1);
                }
                else {
                    console.log('Expected rho1 of SecData to be a number but was ', typeof src.rho1, src.rho1)
                }
            }
            if (src.c1 !== undefined && src.c1 !== null) {
                if (typeof src.c1 === "number" || src.c1 === 'NaN' || src.c1 === 'Infinity' || src.c1 === '-Infinity') {
                    dst.c1 = AsNum(src.c1);
                }
                else {
                    console.log('Expected c1 of SecData to be a number but was ', typeof src.c1, src.c1)
                }
            }
            if (src.beta1 !== undefined && src.beta1 !== null) {
                if (typeof src.beta1 === "number" || src.beta1 === 'NaN' || src.beta1 === 'Infinity' || src.beta1 === '-Infinity') {
                    dst.beta1 = AsNum(src.beta1);
                }
                else {
                    console.log('Expected beta1 of SecData to be a number but was ', typeof src.beta1, src.beta1)
                }
            }
            if (src.sh1 !== undefined && src.sh1 !== null) {
                if (typeof src.sh1 === "number" || src.sh1 === 'NaN' || src.sh1 === 'Infinity' || src.sh1 === '-Infinity') {
                    dst.sh1 = AsNum(src.sh1);
                }
                else {
                    console.log('Expected sh1 of SecData to be a number but was ', typeof src.sh1, src.sh1)
                }
            }
            if (src.ang1 !== undefined && src.ang1 !== null) {
                if (typeof src.ang1 === "number" || src.ang1 === 'NaN' || src.ang1 === 'Infinity' || src.ang1 === '-Infinity') {
                    dst.ang1 = AsNum(src.ang1);
                }
                else {
                    console.log('Expected ang1 of SecData to be a number but was ', typeof src.ang1, src.ang1)
                }
            }
            if (src.i2 !== undefined && src.i2 !== null) {
                if (typeof src.i2 === "number" || src.i2 === 'NaN' || src.i2 === 'Infinity' || src.i2 === '-Infinity') {
                    dst.i2 = AsNum(src.i2);
                }
                else {
                    console.log('Expected i2 of SecData to be a number but was ', typeof src.i2, src.i2)
                }
            }
            if (src.w2 !== undefined && src.w2 !== null) {
                if (typeof src.w2 === "number" || src.w2 === 'NaN' || src.w2 === 'Infinity' || src.w2 === '-Infinity') {
                    dst.w2 = AsNum(src.w2);
                }
                else {
                    console.log('Expected w2 of SecData to be a number but was ', typeof src.w2, src.w2)
                }
            }
            if (src.z2 !== undefined && src.z2 !== null) {
                if (typeof src.z2 === "number" || src.z2 === 'NaN' || src.z2 === 'Infinity' || src.z2 === '-Infinity') {
                    dst.z2 = AsNum(src.z2);
                }
                else {
                    console.log('Expected z2 of SecData to be a number but was ', typeof src.z2, src.z2)
                }
            }
            if (src.sm2 !== undefined && src.sm2 !== null) {
                if (typeof src.sm2 === "number" || src.sm2 === 'NaN' || src.sm2 === 'Infinity' || src.sm2 === '-Infinity') {
                    dst.sm2 = AsNum(src.sm2);
                }
                else {
                    console.log('Expected sm2 of SecData to be a number but was ', typeof src.sm2, src.sm2)
                }
            }
            if (src.ir2 !== undefined && src.ir2 !== null) {
                if (typeof src.ir2 === "number" || src.ir2 === 'NaN' || src.ir2 === 'Infinity' || src.ir2 === '-Infinity') {
                    dst.ir2 = AsNum(src.ir2);
                }
                else {
                    console.log('Expected ir2 of SecData to be a number but was ', typeof src.ir2, src.ir2)
                }
            }
            if (src.emax1 !== undefined && src.emax1 !== null) {
                if (typeof src.emax1 === "number" || src.emax1 === 'NaN' || src.emax1 === 'Infinity' || src.emax1 === '-Infinity') {
                    dst.emax1 = AsNum(src.emax1);
                }
                else {
                    console.log('Expected emax1 of SecData to be a number but was ', typeof src.emax1, src.emax1)
                }
            }
            if (src.emin1 !== undefined && src.emin1 !== null) {
                if (typeof src.emin1 === "number" || src.emin1 === 'NaN' || src.emin1 === 'Infinity' || src.emin1 === '-Infinity') {
                    dst.emin1 = AsNum(src.emin1);
                }
                else {
                    console.log('Expected emin1 of SecData to be a number but was ', typeof src.emin1, src.emin1)
                }
            }
            if (src.rho2 !== undefined && src.rho2 !== null) {
                if (typeof src.rho2 === "number" || src.rho2 === 'NaN' || src.rho2 === 'Infinity' || src.rho2 === '-Infinity') {
                    dst.rho2 = AsNum(src.rho2);
                }
                else {
                    console.log('Expected rho2 of SecData to be a number but was ', typeof src.rho2, src.rho2)
                }
            }
            if (src.c2 !== undefined && src.c2 !== null) {
                if (typeof src.c2 === "number" || src.c2 === 'NaN' || src.c2 === 'Infinity' || src.c2 === '-Infinity') {
                    dst.c2 = AsNum(src.c2);
                }
                else {
                    console.log('Expected c2 of SecData to be a number but was ', typeof src.c2, src.c2)
                }
            }
            if (src.beta2 !== undefined && src.beta2 !== null) {
                if (typeof src.beta2 === "number" || src.beta2 === 'NaN' || src.beta2 === 'Infinity' || src.beta2 === '-Infinity') {
                    dst.beta2 = AsNum(src.beta2);
                }
                else {
                    console.log('Expected beta2 of SecData to be a number but was ', typeof src.beta2, src.beta2)
                }
            }
            if (src.sh2 !== undefined && src.sh2 !== null) {
                if (typeof src.sh2 === "number" || src.sh2 === 'NaN' || src.sh2 === 'Infinity' || src.sh2 === '-Infinity') {
                    dst.sh2 = AsNum(src.sh2);
                }
                else {
                    console.log('Expected sh2 of SecData to be a number but was ', typeof src.sh2, src.sh2)
                }
            }
            if (src.ang2 !== undefined && src.ang2 !== null) {
                if (typeof src.ang2 === "number" || src.ang2 === 'NaN' || src.ang2 === 'Infinity' || src.ang2 === '-Infinity') {
                    dst.ang2 = AsNum(src.ang2);
                }
                else {
                    console.log('Expected ang2 of SecData to be a number but was ', typeof src.ang2, src.ang2)
                }
            }
            return dst;
        }

        static toObject(src: SecData | null | undefined): SecData_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.SecData is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.SecData") {
                console.error('Expected SOLVE.SecData but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : SecData_json = {
                a: AsJsonNum(src.a),
                p: AsJsonNum(src.p),
                xc: AsJsonNum(src.xc),
                yc: AsJsonNum(src.yc),
                xs: AsJsonNum(src.xs),
                ys: AsJsonNum(src.ys),
                iX: AsJsonNum(src.iX),
                wX: AsJsonNum(src.wX),
                zX: AsJsonNum(src.zX),
                smX: AsJsonNum(src.smX),
                irX: AsJsonNum(src.irX),
                emaxY: AsJsonNum(src.emaxY),
                eminY: AsJsonNum(src.eminY),
                iY: AsJsonNum(src.iY),
                wY: AsJsonNum(src.wY),
                zY: AsJsonNum(src.zY),
                smY: AsJsonNum(src.smY),
                irY: AsJsonNum(src.irY),
                emaxX: AsJsonNum(src.emaxX),
                eminX: AsJsonNum(src.eminX),
                j: AsJsonNum(src.j),
                iT: AsJsonNum(src.iT),
                wT: AsJsonNum(src.wT),
                iW: AsJsonNum(src.iW),
                iXy: AsJsonNum(src.iXy),
                betaOmega: AsJsonNum(src.betaOmega),
                i1: AsJsonNum(src.i1),
                w1: AsJsonNum(src.w1),
                z1: AsJsonNum(src.z1),
                sm1: AsJsonNum(src.sm1),
                ir1: AsJsonNum(src.ir1),
                emax2: AsJsonNum(src.emax2),
                emin2: AsJsonNum(src.emin2),
                rho1: AsJsonNum(src.rho1),
                c1: AsJsonNum(src.c1),
                beta1: AsJsonNum(src.beta1),
                sh1: AsJsonNum(src.sh1),
                ang1: AsJsonNum(src.ang1),
                i2: AsJsonNum(src.i2),
                w2: AsJsonNum(src.w2),
                z2: AsJsonNum(src.z2),
                sm2: AsJsonNum(src.sm2),
                ir2: AsJsonNum(src.ir2),
                emax1: AsJsonNum(src.emax1),
                emin1: AsJsonNum(src.emin1),
                rho2: AsJsonNum(src.rho2),
                c2: AsJsonNum(src.c2),
                beta2: AsJsonNum(src.beta2),
                sh2: AsJsonNum(src.sh2),
                ang2: AsJsonNum(src.ang2),
            };
            return dst;
        }

        static create(src?: SecData_createType) {
            const dst = new SecData();
            if (src === undefined) {
                return dst;
            }
            if (src.a !== undefined) {
                dst.a = src.a;
            }
            if (src.p !== undefined) {
                dst.p = src.p;
            }
            if (src.xc !== undefined) {
                dst.xc = src.xc;
            }
            if (src.yc !== undefined) {
                dst.yc = src.yc;
            }
            if (src.xs !== undefined) {
                dst.xs = src.xs;
            }
            if (src.ys !== undefined) {
                dst.ys = src.ys;
            }
            if (src.iX !== undefined) {
                dst.iX = src.iX;
            }
            if (src.wX !== undefined) {
                dst.wX = src.wX;
            }
            if (src.zX !== undefined) {
                dst.zX = src.zX;
            }
            if (src.smX !== undefined) {
                dst.smX = src.smX;
            }
            if (src.irX !== undefined) {
                dst.irX = src.irX;
            }
            if (src.emaxY !== undefined) {
                dst.emaxY = src.emaxY;
            }
            if (src.eminY !== undefined) {
                dst.eminY = src.eminY;
            }
            if (src.iY !== undefined) {
                dst.iY = src.iY;
            }
            if (src.wY !== undefined) {
                dst.wY = src.wY;
            }
            if (src.zY !== undefined) {
                dst.zY = src.zY;
            }
            if (src.smY !== undefined) {
                dst.smY = src.smY;
            }
            if (src.irY !== undefined) {
                dst.irY = src.irY;
            }
            if (src.emaxX !== undefined) {
                dst.emaxX = src.emaxX;
            }
            if (src.eminX !== undefined) {
                dst.eminX = src.eminX;
            }
            if (src.j !== undefined) {
                dst.j = src.j;
            }
            if (src.iT !== undefined) {
                dst.iT = src.iT;
            }
            if (src.wT !== undefined) {
                dst.wT = src.wT;
            }
            if (src.iW !== undefined) {
                dst.iW = src.iW;
            }
            if (src.iXy !== undefined) {
                dst.iXy = src.iXy;
            }
            if (src.betaOmega !== undefined) {
                dst.betaOmega = src.betaOmega;
            }
            if (src.i1 !== undefined) {
                dst.i1 = src.i1;
            }
            if (src.w1 !== undefined) {
                dst.w1 = src.w1;
            }
            if (src.z1 !== undefined) {
                dst.z1 = src.z1;
            }
            if (src.sm1 !== undefined) {
                dst.sm1 = src.sm1;
            }
            if (src.ir1 !== undefined) {
                dst.ir1 = src.ir1;
            }
            if (src.emax2 !== undefined) {
                dst.emax2 = src.emax2;
            }
            if (src.emin2 !== undefined) {
                dst.emin2 = src.emin2;
            }
            if (src.rho1 !== undefined) {
                dst.rho1 = src.rho1;
            }
            if (src.c1 !== undefined) {
                dst.c1 = src.c1;
            }
            if (src.beta1 !== undefined) {
                dst.beta1 = src.beta1;
            }
            if (src.sh1 !== undefined) {
                dst.sh1 = src.sh1;
            }
            if (src.ang1 !== undefined) {
                dst.ang1 = src.ang1;
            }
            if (src.i2 !== undefined) {
                dst.i2 = src.i2;
            }
            if (src.w2 !== undefined) {
                dst.w2 = src.w2;
            }
            if (src.z2 !== undefined) {
                dst.z2 = src.z2;
            }
            if (src.sm2 !== undefined) {
                dst.sm2 = src.sm2;
            }
            if (src.ir2 !== undefined) {
                dst.ir2 = src.ir2;
            }
            if (src.emax1 !== undefined) {
                dst.emax1 = src.emax1;
            }
            if (src.emin1 !== undefined) {
                dst.emin1 = src.emin1;
            }
            if (src.rho2 !== undefined) {
                dst.rho2 = src.rho2;
            }
            if (src.c2 !== undefined) {
                dst.c2 = src.c2;
            }
            if (src.beta2 !== undefined) {
                dst.beta2 = src.beta2;
            }
            if (src.sh2 !== undefined) {
                dst.sh2 = src.sh2;
            }
            if (src.ang2 !== undefined) {
                dst.ang2 = src.ang2;
            }
            return dst;
        }

        shallowClone() {
            const dst = new SecData();
            dst.a = this.a;
            dst.p = this.p;
            dst.xc = this.xc;
            dst.yc = this.yc;
            dst.xs = this.xs;
            dst.ys = this.ys;
            dst.iX = this.iX;
            dst.wX = this.wX;
            dst.zX = this.zX;
            dst.smX = this.smX;
            dst.irX = this.irX;
            dst.emaxY = this.emaxY;
            dst.eminY = this.eminY;
            dst.iY = this.iY;
            dst.wY = this.wY;
            dst.zY = this.zY;
            dst.smY = this.smY;
            dst.irY = this.irY;
            dst.emaxX = this.emaxX;
            dst.eminX = this.eminX;
            dst.j = this.j;
            dst.iT = this.iT;
            dst.wT = this.wT;
            dst.iW = this.iW;
            dst.iXy = this.iXy;
            dst.betaOmega = this.betaOmega;
            dst.i1 = this.i1;
            dst.w1 = this.w1;
            dst.z1 = this.z1;
            dst.sm1 = this.sm1;
            dst.ir1 = this.ir1;
            dst.emax2 = this.emax2;
            dst.emin2 = this.emin2;
            dst.rho1 = this.rho1;
            dst.c1 = this.c1;
            dst.beta1 = this.beta1;
            dst.sh1 = this.sh1;
            dst.ang1 = this.ang1;
            dst.i2 = this.i2;
            dst.w2 = this.w2;
            dst.z2 = this.z2;
            dst.sm2 = this.sm2;
            dst.ir2 = this.ir2;
            dst.emax1 = this.emax1;
            dst.emin1 = this.emin1;
            dst.rho2 = this.rho2;
            dst.c2 = this.c2;
            dst.beta2 = this.beta2;
            dst.sh2 = this.sh2;
            dst.ang2 = this.ang2;
            return dst;
        }

        deepClone() {
            const json = SecData.toObject(this);
            const dst = SecData.fromObject(json);
            return dst;
        }
    }
    export type ISecData = SecData;


    export type Result_keys = 'nodeRes' | 'elemRes' | 'secData' | 'error' | 'warning' | 'info' | 'debug' | 'nodeResSndOrd' | 'elemResSndOrd';
    export interface Result_createType {
        nodeRes?: SOLVE.NodalRes | null,
        elemRes?: SOLVE.ElemRes | null,
        secData?: SOLVE.SecData | null,
        error?: string[],
        warning?: string[],
        info?: string[],
        debug?: string[],
        nodeResSndOrd?: SOLVE.NodalRes | null,
        elemResSndOrd?: SOLVE.ElemRes | null,
    }
    export interface Result_json {
        nodeRes?: SOLVE.NodalRes_json;
        elemRes?: SOLVE.ElemRes_json;
        secData?: SOLVE.SecData_json;
        error: string[];
        warning: string[];
        info: string[];
        debug: string[];
        nodeResSndOrd?: SOLVE.NodalRes_json;
        elemResSndOrd?: SOLVE.ElemRes_json;
    }
    interface Result_json_in {
        __proto_name?: unknown;
        nodeRes?: unknown;
        elemRes?: unknown;
        secData?: unknown;
        error?: unknown;
        warning?: unknown;
        info?: unknown;
        debug?: unknown;
        nodeResSndOrd?: unknown;
        elemResSndOrd?: unknown;
    }
    export class Result {
        __proto_name = "SOLVE.Result";
        nodeRes: SOLVE.NodalRes | null = null;
        elemRes: SOLVE.ElemRes | null = null;
        secData: SOLVE.SecData | null = null;
        error: string[] = [];
        warning: string[] = [];
        info: string[] = [];
        debug: string[] = [];
        nodeResSndOrd: SOLVE.NodalRes | null = null;
        elemResSndOrd: SOLVE.ElemRes | null = null;

        static fromObject(src_unknown: unknown): Result {
            const dst = new Result();
            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                console.log('Wanted Result but it was not a object: ', src_unknown);
                return dst;
            }
            const src = src_unknown as Result_json_in;
            if (src.__proto_name !== undefined) {
                console.log('Wanted a generic json structure for Result but found a ', src.__proto_name);
                console.trace();
                return dst;
            }
            if (src.nodeRes !== undefined && src.nodeRes !== null) {
                dst.nodeRes = SOLVE.NodalRes.fromObject(src.nodeRes);
            }
            if (src.elemRes !== undefined && src.elemRes !== null) {
                dst.elemRes = SOLVE.ElemRes.fromObject(src.elemRes);
            }
            if (src.secData !== undefined && src.secData !== null) {
                dst.secData = SOLVE.SecData.fromObject(src.secData);
            }
            if (src.error !== undefined && src.error !== null) {
                if (Array.isArray(src.error)) {
                    for (const [index, element] of src.error.entries()) {
                        if (typeof element === "string") {
                            dst.error.push(element);
                        }
                        else {
                            console.log('Expected error of Result[', index, '] to be a string but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected error of Result to be a array but was ', typeof src.error, src.error)
                }
            }
            if (src.warning !== undefined && src.warning !== null) {
                if (Array.isArray(src.warning)) {
                    for (const [index, element] of src.warning.entries()) {
                        if (typeof element === "string") {
                            dst.warning.push(element);
                        }
                        else {
                            console.log('Expected warning of Result[', index, '] to be a string but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected warning of Result to be a array but was ', typeof src.warning, src.warning)
                }
            }
            if (src.info !== undefined && src.info !== null) {
                if (Array.isArray(src.info)) {
                    for (const [index, element] of src.info.entries()) {
                        if (typeof element === "string") {
                            dst.info.push(element);
                        }
                        else {
                            console.log('Expected info of Result[', index, '] to be a string but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected info of Result to be a array but was ', typeof src.info, src.info)
                }
            }
            if (src.debug !== undefined && src.debug !== null) {
                if (Array.isArray(src.debug)) {
                    for (const [index, element] of src.debug.entries()) {
                        if (typeof element === "string") {
                            dst.debug.push(element);
                        }
                        else {
                            console.log('Expected debug of Result[', index, '] to be a string but was ', typeof element, element)
                        }
                    }
                }
                else {
                    console.log('Expected debug of Result to be a array but was ', typeof src.debug, src.debug)
                }
            }
            if (src.nodeResSndOrd !== undefined && src.nodeResSndOrd !== null) {
                dst.nodeResSndOrd = SOLVE.NodalRes.fromObject(src.nodeResSndOrd);
            }
            if (src.elemResSndOrd !== undefined && src.elemResSndOrd !== null) {
                dst.elemResSndOrd = SOLVE.ElemRes.fromObject(src.elemResSndOrd);
            }
            return dst;
        }

        static toObject(src: Result | null | undefined): Result_json | null {
            if (src === null) { return null; }
            if (src === undefined) { console.warn('SOLVE.Result is undefined!!!'); return null; }
            if (src.__proto_name !== "SOLVE.Result") {
                console.error('Expected SOLVE.Result but got ', src.__proto_name);
                console.trace();
                return null;
            }
            const dst : Result_json = {
                error: new Array<string>(),
                warning: new Array<string>(),
                info: new Array<string>(),
                debug: new Array<string>(),
            };
            if(src.nodeRes !== null)
            {
                const parsed = SOLVE.NodalRes.toObject(src.nodeRes);
                if(parsed === null) return null;
                dst.nodeRes = parsed;
            }
            if(src.elemRes !== null)
            {
                const parsed = SOLVE.ElemRes.toObject(src.elemRes);
                if(parsed === null) return null;
                dst.elemRes = parsed;
            }
            if(src.secData !== null)
            {
                const parsed = SOLVE.SecData.toObject(src.secData);
                if(parsed === null) return null;
                dst.secData = parsed;
            }
            if (src.error !== null) {
                for (const element of src.error) {
                    dst.error.push(element);
                }
            }
            if (src.warning !== null) {
                for (const element of src.warning) {
                    dst.warning.push(element);
                }
            }
            if (src.info !== null) {
                for (const element of src.info) {
                    dst.info.push(element);
                }
            }
            if (src.debug !== null) {
                for (const element of src.debug) {
                    dst.debug.push(element);
                }
            }
            if(src.nodeResSndOrd !== null)
            {
                const parsed = SOLVE.NodalRes.toObject(src.nodeResSndOrd);
                if(parsed === null) return null;
                dst.nodeResSndOrd = parsed;
            }
            if(src.elemResSndOrd !== null)
            {
                const parsed = SOLVE.ElemRes.toObject(src.elemResSndOrd);
                if(parsed === null) return null;
                dst.elemResSndOrd = parsed;
            }
            return dst;
        }

        static create(src?: Result_createType) {
            const dst = new Result();
            if (src === undefined) {
                return dst;
            }
            if (src.nodeRes !== undefined) {
                dst.nodeRes = src.nodeRes;
            }
            if (src.elemRes !== undefined) {
                dst.elemRes = src.elemRes;
            }
            if (src.secData !== undefined) {
                dst.secData = src.secData;
            }
            if (src.error !== undefined) {
                dst.error = src.error;
            }
            if (src.warning !== undefined) {
                dst.warning = src.warning;
            }
            if (src.info !== undefined) {
                dst.info = src.info;
            }
            if (src.debug !== undefined) {
                dst.debug = src.debug;
            }
            if (src.nodeResSndOrd !== undefined) {
                dst.nodeResSndOrd = src.nodeResSndOrd;
            }
            if (src.elemResSndOrd !== undefined) {
                dst.elemResSndOrd = src.elemResSndOrd;
            }
            return dst;
        }

        shallowClone() {
            const dst = new Result();
            dst.nodeRes = this.nodeRes;
            dst.elemRes = this.elemRes;
            dst.secData = this.secData;
            dst.error = this.error;
            dst.warning = this.warning;
            dst.info = this.info;
            dst.debug = this.debug;
            dst.nodeResSndOrd = this.nodeResSndOrd;
            dst.elemResSndOrd = this.elemResSndOrd;
            return dst;
        }

        deepClone() {
            const json = Result.toObject(this);
            const dst = Result.fromObject(json);
            return dst;
        }
    }
    export type IResult = Result;


    // Defined in solve.proto
    export namespace BucklingRes {
        export type mode_keys = 'v' | 'r';
        export interface mode_createType {
            v?: number[],
            r?: number[],
        }
        export interface mode_json {
            v: JsonNumber[];
            r: JsonNumber[];
        }
        interface mode_json_in {
            __proto_name?: unknown;
            v?: unknown;
            r?: unknown;
        }
        export class mode {
            __proto_name = "SOLVE.BucklingRes.mode";
            v: number[] = [];
            r: number[] = [];

            static fromObject(src_unknown: unknown): mode {
                const dst = new mode();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted mode but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as mode_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for mode but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.v !== undefined && src.v !== null) {
                    if (Array.isArray(src.v)) {
                        for (const [index, element] of src.v.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.v.push(AsNum(element));
                            }
                            else {
                                console.log('Expected v of mode[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected v of mode to be a array but was ', typeof src.v, src.v)
                    }
                }
                if (src.r !== undefined && src.r !== null) {
                    if (Array.isArray(src.r)) {
                        for (const [index, element] of src.r.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.r.push(AsNum(element));
                            }
                            else {
                                console.log('Expected r of mode[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected r of mode to be a array but was ', typeof src.r, src.r)
                    }
                }
                return dst;
            }

            static toObject(src: mode | null | undefined): mode_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('SOLVE.BucklingRes.mode is undefined!!!'); return null; }
                if (src.__proto_name !== "SOLVE.BucklingRes.mode") {
                    console.error('Expected SOLVE.BucklingRes.mode but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : mode_json = {
                    v: new Array<JsonNumber>(),
                    r: new Array<JsonNumber>(),
                };
                if (src.v !== null) {
                    for (const element of src.v) {
                        dst.v.push(AsJsonNum(element));
                    }
                }
                if (src.r !== null) {
                    for (const element of src.r) {
                        dst.r.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: mode_createType) {
                const dst = new mode();
                if (src === undefined) {
                    return dst;
                }
                if (src.v !== undefined) {
                    dst.v = src.v;
                }
                if (src.r !== undefined) {
                    dst.r = src.r;
                }
                return dst;
            }

            shallowClone() {
                const dst = new mode();
                dst.v = this.v;
                dst.r = this.r;
                return dst;
            }

            deepClone() {
                const json = mode.toObject(this);
                const dst = mode.fromObject(json);
                return dst;
            }
        }
        export type Imode = mode;
    } // namespace BucklingRes


    // Defined in solve.proto
    export namespace Analysis {
        export type Static_keys = 'secondOrder';
        export interface Static_createType {
            secondOrder?: boolean,
        }
        export interface Static_json {
            secondOrder?: boolean;
        }
        interface Static_json_in {
            __proto_name?: unknown;
            secondOrder?: unknown;
        }
        export class Static {
            __proto_name = "SOLVE.Analysis.Static";
            secondOrder: boolean = false;

            static fromObject(src_unknown: unknown): Static {
                const dst = new Static();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Static but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Static_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Static but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.secondOrder !== undefined && src.secondOrder !== null) {
                    if (typeof src.secondOrder === "boolean") {
                        dst.secondOrder = src.secondOrder;
                    }
                    else {
                        console.log('Expected secondOrder of Static to be a boolean but was ', typeof src.secondOrder, src.secondOrder)
                    }
                }
                return dst;
            }

            static toObject(src: Static | null | undefined): Static_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('SOLVE.Analysis.Static is undefined!!!'); return null; }
                if (src.__proto_name !== "SOLVE.Analysis.Static") {
                    console.error('Expected SOLVE.Analysis.Static but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Static_json = {
                    secondOrder: src.secondOrder,
                };
                return dst;
            }

            static create(src?: Static_createType) {
                const dst = new Static();
                if (src === undefined) {
                    return dst;
                }
                if (src.secondOrder !== undefined) {
                    dst.secondOrder = src.secondOrder;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Static();
                dst.secondOrder = this.secondOrder;
                return dst;
            }

            deepClone() {
                const json = Static.toObject(this);
                const dst = Static.fromObject(json);
                return dst;
            }
        }
        export type IStatic = Static;


        export type Dynamic_keys = 'dt' | 't' | 'w';
        export interface Dynamic_createType {
            dt?: number,
            t?: number,
            w?: number,
        }
        export interface Dynamic_json {
            dt?: JsonNumber;
            t?: JsonNumber;
            w?: JsonNumber;
        }
        interface Dynamic_json_in {
            __proto_name?: unknown;
            dt?: unknown;
            t?: unknown;
            w?: unknown;
        }
        export class Dynamic {
            __proto_name = "SOLVE.Analysis.Dynamic";
            dt: number = 0;
            t: number = 0;
            w: number = 0;

            static fromObject(src_unknown: unknown): Dynamic {
                const dst = new Dynamic();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Dynamic but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Dynamic_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Dynamic but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.dt !== undefined && src.dt !== null) {
                    if (typeof src.dt === "number" || src.dt === 'NaN' || src.dt === 'Infinity' || src.dt === '-Infinity') {
                        dst.dt = NumberToInt("SOLVE.Analysis.Dynamic.dt", AsNum(src.dt));
                    }
                    else {
                        console.log('Expected dt of Dynamic to be a number but was ', typeof src.dt, src.dt)
                    }
                }
                if (src.t !== undefined && src.t !== null) {
                    if (typeof src.t === "number" || src.t === 'NaN' || src.t === 'Infinity' || src.t === '-Infinity') {
                        dst.t = NumberToInt("SOLVE.Analysis.Dynamic.t", AsNum(src.t));
                    }
                    else {
                        console.log('Expected t of Dynamic to be a number but was ', typeof src.t, src.t)
                    }
                }
                if (src.w !== undefined && src.w !== null) {
                    if (typeof src.w === "number" || src.w === 'NaN' || src.w === 'Infinity' || src.w === '-Infinity') {
                        dst.w = AsNum(src.w);
                    }
                    else {
                        console.log('Expected w of Dynamic to be a number but was ', typeof src.w, src.w)
                    }
                }
                return dst;
            }

            static toObject(src: Dynamic | null | undefined): Dynamic_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('SOLVE.Analysis.Dynamic is undefined!!!'); return null; }
                if (src.__proto_name !== "SOLVE.Analysis.Dynamic") {
                    console.error('Expected SOLVE.Analysis.Dynamic but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Dynamic_json = {
                    dt: AsJsonNum(NumberToInt("SOLVE.Analysis.Dynamic.dt", src.dt)),
                    t: AsJsonNum(NumberToInt("SOLVE.Analysis.Dynamic.t", src.t)),
                    w: AsJsonNum(src.w),
                };
                return dst;
            }

            static create(src?: Dynamic_createType) {
                const dst = new Dynamic();
                if (src === undefined) {
                    return dst;
                }
                if (src.dt !== undefined) {
                    dst.dt = src.dt;
                }
                if (src.t !== undefined) {
                    dst.t = src.t;
                }
                if (src.w !== undefined) {
                    dst.w = src.w;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Dynamic();
                dst.dt = this.dt;
                dst.t = this.t;
                dst.w = this.w;
                return dst;
            }

            deepClone() {
                const json = Dynamic.toObject(this);
                const dst = Dynamic.fromObject(json);
                return dst;
            }
        }
        export type IDynamic = Dynamic;


        export type EigenVals_keys = 'numOfVals';
        export interface EigenVals_createType {
            numOfVals?: number,
        }
        export interface EigenVals_json {
            numOfVals?: JsonNumber;
        }
        interface EigenVals_json_in {
            __proto_name?: unknown;
            numOfVals?: unknown;
        }
        export class EigenVals {
            __proto_name = "SOLVE.Analysis.EigenVals";
            numOfVals: number = 0;

            static fromObject(src_unknown: unknown): EigenVals {
                const dst = new EigenVals();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted EigenVals but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as EigenVals_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for EigenVals but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.numOfVals !== undefined && src.numOfVals !== null) {
                    if (typeof src.numOfVals === "number" || src.numOfVals === 'NaN' || src.numOfVals === 'Infinity' || src.numOfVals === '-Infinity') {
                        dst.numOfVals = NumberToInt("SOLVE.Analysis.EigenVals.numOfVals", AsNum(src.numOfVals));
                    }
                    else {
                        console.log('Expected numOfVals of EigenVals to be a number but was ', typeof src.numOfVals, src.numOfVals)
                    }
                }
                return dst;
            }

            static toObject(src: EigenVals | null | undefined): EigenVals_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('SOLVE.Analysis.EigenVals is undefined!!!'); return null; }
                if (src.__proto_name !== "SOLVE.Analysis.EigenVals") {
                    console.error('Expected SOLVE.Analysis.EigenVals but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : EigenVals_json = {
                    numOfVals: AsJsonNum(NumberToInt("SOLVE.Analysis.EigenVals.numOfVals", src.numOfVals)),
                };
                return dst;
            }

            static create(src?: EigenVals_createType) {
                const dst = new EigenVals();
                if (src === undefined) {
                    return dst;
                }
                if (src.numOfVals !== undefined) {
                    dst.numOfVals = src.numOfVals;
                }
                return dst;
            }

            shallowClone() {
                const dst = new EigenVals();
                dst.numOfVals = this.numOfVals;
                return dst;
            }

            deepClone() {
                const json = EigenVals.toObject(this);
                const dst = EigenVals.fromObject(json);
                return dst;
            }
        }
        export type IEigenVals = EigenVals;


        export type Buckling_keys = 'plane';
        export interface Buckling_createType {
            plane?: number,
        }
        export interface Buckling_json {
            plane?: JsonNumber;
        }
        interface Buckling_json_in {
            __proto_name?: unknown;
            plane?: unknown;
        }
        export class Buckling {
            __proto_name = "SOLVE.Analysis.Buckling";
            plane: number = 0;

            static fromObject(src_unknown: unknown): Buckling {
                const dst = new Buckling();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Buckling but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Buckling_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Buckling but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.plane !== undefined && src.plane !== null) {
                    if (typeof src.plane === "number" || src.plane === 'NaN' || src.plane === 'Infinity' || src.plane === '-Infinity') {
                        dst.plane = NumberToInt("SOLVE.Analysis.Buckling.plane", AsNum(src.plane));
                    }
                    else {
                        console.log('Expected plane of Buckling to be a number but was ', typeof src.plane, src.plane)
                    }
                }
                return dst;
            }

            static toObject(src: Buckling | null | undefined): Buckling_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('SOLVE.Analysis.Buckling is undefined!!!'); return null; }
                if (src.__proto_name !== "SOLVE.Analysis.Buckling") {
                    console.error('Expected SOLVE.Analysis.Buckling but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Buckling_json = {
                    plane: AsJsonNum(NumberToInt("SOLVE.Analysis.Buckling.plane", src.plane)),
                };
                return dst;
            }

            static create(src?: Buckling_createType) {
                const dst = new Buckling();
                if (src === undefined) {
                    return dst;
                }
                if (src.plane !== undefined) {
                    dst.plane = src.plane;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Buckling();
                dst.plane = this.plane;
                return dst;
            }

            deepClone() {
                const json = Buckling.toObject(this);
                const dst = Buckling.fromObject(json);
                return dst;
            }
        }
        export type IBuckling = Buckling;
    } // namespace Analysis
} // namespace SOLVE


// Defined in 78 files
export namespace ng {
    // Defined in Utils/topology.proto
    export namespace topology {
        export enum StiffnessType {
            STIFFNESS_TYPE_UNSPECIFIED = 0,
            STIFFNESS_TYPE_RIGID = 1,
            STIFFNESS_TYPE_FREE = 2,
            STIFFNESS_TYPE_SPRING = 3
        }
        export const StiffnessType_FromObject = (src: unknown): StiffnessType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'STIFFNESS_TYPE_UNSPECIFIED':
                    return StiffnessType.STIFFNESS_TYPE_UNSPECIFIED;
                case 1:
                case 'STIFFNESS_TYPE_RIGID':
                    return StiffnessType.STIFFNESS_TYPE_RIGID;
                case 2:
                case 'STIFFNESS_TYPE_FREE':
                    return StiffnessType.STIFFNESS_TYPE_FREE;
                case 3:
                case 'STIFFNESS_TYPE_SPRING':
                    return StiffnessType.STIFFNESS_TYPE_SPRING;
                default:
                    console.log('Unhandled value for StiffnessType:' + src + '. ' + typeof(src));
                    return StiffnessType.STIFFNESS_TYPE_UNSPECIFIED;
            }
        };
        export const StiffnessType_ToObject = (src: StiffnessType): string | null => {
            switch (src) {
                case StiffnessType.STIFFNESS_TYPE_UNSPECIFIED:
                    return 'STIFFNESS_TYPE_UNSPECIFIED';
                case StiffnessType.STIFFNESS_TYPE_RIGID:
                    return 'STIFFNESS_TYPE_RIGID';
                case StiffnessType.STIFFNESS_TYPE_FREE:
                    return 'STIFFNESS_TYPE_FREE';
                case StiffnessType.STIFFNESS_TYPE_SPRING:
                    return 'STIFFNESS_TYPE_SPRING';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for StiffnessType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type ElementNode_keys = 'id' | 'coord';
        export interface ElementNode_createType {
            id?: ng.utils.ID | null,
            coord?: ng.geometry.Point3D | null,
        }
        export interface ElementNode_json {
            id?: ng.utils.ID_json;
            coord?: ng.geometry.Point3D_json;
        }
        interface ElementNode_json_in {
            __proto_name?: unknown;
            id?: unknown;
            coord?: unknown;
        }
        export class ElementNode {
            __proto_name = "ng.topology.ElementNode";
            id: ng.utils.ID | null = null;
            coord: ng.geometry.Point3D | null = null;

            static fromObject(src_unknown: unknown): ElementNode {
                const dst = new ElementNode();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ElementNode but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ElementNode_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ElementNode but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.coord !== undefined && src.coord !== null) {
                    dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                }
                return dst;
            }

            static toObject(src: ElementNode | null | undefined): ElementNode_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.ElementNode is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.ElementNode") {
                    console.error('Expected ng.topology.ElementNode but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ElementNode_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.coord !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.coord);
                    if(parsed === null) return null;
                    dst.coord = parsed;
                }
                return dst;
            }

            static create(src?: ElementNode_createType) {
                const dst = new ElementNode();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.coord !== undefined) {
                    dst.coord = src.coord;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ElementNode();
                dst.id = this.id;
                dst.coord = this.coord;
                return dst;
            }

            deepClone() {
                const json = ElementNode.toObject(this);
                const dst = ElementNode.fromObject(json);
                return dst;
            }
        }
        export type IElementNode = ElementNode;


        export type ConNode_keys = 'id' | 'coord' | 'guids';
        export interface ConNode_createType {
            id?: ng.utils.ID | null,
            coord?: ng.geometry.Point3D | null,
            guids?: string[],
        }
        export interface ConNode_json {
            id?: ng.utils.ID_json;
            coord?: ng.geometry.Point3D_json;
            guids: string[];
        }
        interface ConNode_json_in {
            __proto_name?: unknown;
            id?: unknown;
            coord?: unknown;
            guids?: unknown;
        }
        export class ConNode {
            __proto_name = "ng.topology.ConNode";
            id: ng.utils.ID | null = null;
            coord: ng.geometry.Point3D | null = null;
            guids: string[] = [];

            static fromObject(src_unknown: unknown): ConNode {
                const dst = new ConNode();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ConNode but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ConNode_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ConNode but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.coord !== undefined && src.coord !== null) {
                    dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                }
                if (src.guids !== undefined && src.guids !== null) {
                    if (Array.isArray(src.guids)) {
                        for (const [index, element] of src.guids.entries()) {
                            if (typeof element === "string") {
                                dst.guids.push(element);
                            }
                            else {
                                console.log('Expected guids of ConNode[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected guids of ConNode to be a array but was ', typeof src.guids, src.guids)
                    }
                }
                return dst;
            }

            static toObject(src: ConNode | null | undefined): ConNode_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.ConNode is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.ConNode") {
                    console.error('Expected ng.topology.ConNode but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ConNode_json = {
                    guids: new Array<string>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.coord !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.coord);
                    if(parsed === null) return null;
                    dst.coord = parsed;
                }
                if (src.guids !== null) {
                    for (const element of src.guids) {
                        dst.guids.push(element);
                    }
                }
                return dst;
            }

            static create(src?: ConNode_createType) {
                const dst = new ConNode();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.coord !== undefined) {
                    dst.coord = src.coord;
                }
                if (src.guids !== undefined) {
                    dst.guids = src.guids;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ConNode();
                dst.id = this.id;
                dst.coord = this.coord;
                dst.guids = this.guids;
                return dst;
            }

            deepClone() {
                const json = ConNode.toObject(this);
                const dst = ConNode.fromObject(json);
                return dst;
            }
        }
        export type IConNode = ConNode;


        export type Stiffness_keys = 'value' | 'type';
        export interface Stiffness_createType {
            value?: number,
            type?: ng.topology.StiffnessType,
        }
        export interface Stiffness_json {
            value?: JsonNumber;
            type?: string;
        }
        interface Stiffness_json_in {
            __proto_name?: unknown;
            value?: unknown;
            type?: unknown;
        }
        export class Stiffness {
            __proto_name = "ng.topology.Stiffness";
            value: number = 0;
            type: ng.topology.StiffnessType = ng.topology.StiffnessType.STIFFNESS_TYPE_UNSPECIFIED;

            static fromObject(src_unknown: unknown): Stiffness {
                const dst = new Stiffness();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Stiffness but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Stiffness_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Stiffness but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.value !== undefined && src.value !== null) {
                    if (typeof src.value === "number" || src.value === 'NaN' || src.value === 'Infinity' || src.value === '-Infinity') {
                        dst.value = AsNum(src.value);
                    }
                    else {
                        console.log('Expected value of Stiffness to be a number but was ', typeof src.value, src.value)
                    }
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.topology.StiffnessType_FromObject(src.type);
                }
                return dst;
            }

            static toObject(src: Stiffness | null | undefined): Stiffness_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.Stiffness is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.Stiffness") {
                    console.error('Expected ng.topology.Stiffness but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.topology.StiffnessType_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : Stiffness_json = {
                    value: AsJsonNum(src.value),
                    type: type_obj,
                };
                return dst;
            }

            static create(src?: Stiffness_createType) {
                const dst = new Stiffness();
                if (src === undefined) {
                    return dst;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Stiffness();
                dst.value = this.value;
                dst.type = this.type;
                return dst;
            }

            deepClone() {
                const json = Stiffness.toObject(this);
                const dst = Stiffness.fromObject(json);
                return dst;
            }
        }
        export type IStiffness = Stiffness;


        export type Connectivity_keys = 'localCoordSys' | 'transX' | 'transY' | 'transZ' | 'rotX' | 'rotY' | 'rotZ';
        export interface Connectivity_createType {
            localCoordSys?: ng.geometry.Orientation | null,
            transX?: ng.topology.Stiffness | null,
            transY?: ng.topology.Stiffness | null,
            transZ?: ng.topology.Stiffness | null,
            rotX?: ng.topology.Stiffness | null,
            rotY?: ng.topology.Stiffness | null,
            rotZ?: ng.topology.Stiffness | null,
        }
        export interface Connectivity_json {
            localCoordSys?: ng.geometry.Orientation_json;
            transX?: ng.topology.Stiffness_json;
            transY?: ng.topology.Stiffness_json;
            transZ?: ng.topology.Stiffness_json;
            rotX?: ng.topology.Stiffness_json;
            rotY?: ng.topology.Stiffness_json;
            rotZ?: ng.topology.Stiffness_json;
        }
        interface Connectivity_json_in {
            __proto_name?: unknown;
            localCoordSys?: unknown;
            transX?: unknown;
            transY?: unknown;
            transZ?: unknown;
            rotX?: unknown;
            rotY?: unknown;
            rotZ?: unknown;
        }
        export class Connectivity {
            __proto_name = "ng.topology.Connectivity";
            localCoordSys: ng.geometry.Orientation | null = null;
            transX: ng.topology.Stiffness | null = null;
            transY: ng.topology.Stiffness | null = null;
            transZ: ng.topology.Stiffness | null = null;
            rotX: ng.topology.Stiffness | null = null;
            rotY: ng.topology.Stiffness | null = null;
            rotZ: ng.topology.Stiffness | null = null;

            static fromObject(src_unknown: unknown): Connectivity {
                const dst = new Connectivity();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Connectivity but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Connectivity_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Connectivity but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.localCoordSys !== undefined && src.localCoordSys !== null) {
                    dst.localCoordSys = ng.geometry.Orientation.fromObject(src.localCoordSys);
                }
                if (src.transX !== undefined && src.transX !== null) {
                    dst.transX = ng.topology.Stiffness.fromObject(src.transX);
                }
                if (src.transY !== undefined && src.transY !== null) {
                    dst.transY = ng.topology.Stiffness.fromObject(src.transY);
                }
                if (src.transZ !== undefined && src.transZ !== null) {
                    dst.transZ = ng.topology.Stiffness.fromObject(src.transZ);
                }
                if (src.rotX !== undefined && src.rotX !== null) {
                    dst.rotX = ng.topology.Stiffness.fromObject(src.rotX);
                }
                if (src.rotY !== undefined && src.rotY !== null) {
                    dst.rotY = ng.topology.Stiffness.fromObject(src.rotY);
                }
                if (src.rotZ !== undefined && src.rotZ !== null) {
                    dst.rotZ = ng.topology.Stiffness.fromObject(src.rotZ);
                }
                return dst;
            }

            static toObject(src: Connectivity | null | undefined): Connectivity_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.Connectivity is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.Connectivity") {
                    console.error('Expected ng.topology.Connectivity but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Connectivity_json = {
                };
                if(src.localCoordSys !== null)
                {
                    const parsed = ng.geometry.Orientation.toObject(src.localCoordSys);
                    if(parsed === null) return null;
                    dst.localCoordSys = parsed;
                }
                if(src.transX !== null)
                {
                    const parsed = ng.topology.Stiffness.toObject(src.transX);
                    if(parsed === null) return null;
                    dst.transX = parsed;
                }
                if(src.transY !== null)
                {
                    const parsed = ng.topology.Stiffness.toObject(src.transY);
                    if(parsed === null) return null;
                    dst.transY = parsed;
                }
                if(src.transZ !== null)
                {
                    const parsed = ng.topology.Stiffness.toObject(src.transZ);
                    if(parsed === null) return null;
                    dst.transZ = parsed;
                }
                if(src.rotX !== null)
                {
                    const parsed = ng.topology.Stiffness.toObject(src.rotX);
                    if(parsed === null) return null;
                    dst.rotX = parsed;
                }
                if(src.rotY !== null)
                {
                    const parsed = ng.topology.Stiffness.toObject(src.rotY);
                    if(parsed === null) return null;
                    dst.rotY = parsed;
                }
                if(src.rotZ !== null)
                {
                    const parsed = ng.topology.Stiffness.toObject(src.rotZ);
                    if(parsed === null) return null;
                    dst.rotZ = parsed;
                }
                return dst;
            }

            static create(src?: Connectivity_createType) {
                const dst = new Connectivity();
                if (src === undefined) {
                    return dst;
                }
                if (src.localCoordSys !== undefined) {
                    dst.localCoordSys = src.localCoordSys;
                }
                if (src.transX !== undefined) {
                    dst.transX = src.transX;
                }
                if (src.transY !== undefined) {
                    dst.transY = src.transY;
                }
                if (src.transZ !== undefined) {
                    dst.transZ = src.transZ;
                }
                if (src.rotX !== undefined) {
                    dst.rotX = src.rotX;
                }
                if (src.rotY !== undefined) {
                    dst.rotY = src.rotY;
                }
                if (src.rotZ !== undefined) {
                    dst.rotZ = src.rotZ;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Connectivity();
                dst.localCoordSys = this.localCoordSys;
                dst.transX = this.transX;
                dst.transY = this.transY;
                dst.transZ = this.transZ;
                dst.rotX = this.rotX;
                dst.rotY = this.rotY;
                dst.rotZ = this.rotZ;
                return dst;
            }

            deepClone() {
                const json = Connectivity.toObject(this);
                const dst = Connectivity.fromObject(json);
                return dst;
            }
        }
        export type IConnectivity = Connectivity;


        export type Data_keys = 'id' | 'line' | 'polyline' | 'face' | 'block';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            line?: ng.topology.Line | null,
            polyline?: ng.topology.PolyLine | null,
            face?: ng.topology.Face | null,
            block?: ng.topology.Block | null,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            line?: ng.topology.Line_json;
            polyline?: ng.topology.PolyLine_json;
            face?: ng.topology.Face_json;
            block?: ng.topology.Block_json;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            line?: unknown;
            polyline?: unknown;
            face?: unknown;
            block?: unknown;
        }
        export class Data {
            __proto_name = "ng.topology.Data";
            id: ng.utils.ID | null = null;
            // this is a one of
            element: {type: 'line'; line: ng.topology.Line} | {type: 'polyline'; polyline: ng.topology.PolyLine} | {type: 'face'; face: ng.topology.Face} | {type: 'block'; block: ng.topology.Block} | null = null;

            /** Gets the `Line` value (or null) from the oneof `element` */
            getLine(): ng.topology.Line | null {
                if(this.element === null) return null;
                if(this.element.type !== 'line') return null;
                return this.element.line;
            }

            /** Sets the `Line` value for the oneof `element`*/
            setLine(value: ng.topology.Line | null) {
                if(value !== null) {
                    this.element = {type: 'line', line:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Polyline` value (or null) from the oneof `element` */
            getPolyline(): ng.topology.PolyLine | null {
                if(this.element === null) return null;
                if(this.element.type !== 'polyline') return null;
                return this.element.polyline;
            }

            /** Sets the `Polyline` value for the oneof `element`*/
            setPolyline(value: ng.topology.PolyLine | null) {
                if(value !== null) {
                    this.element = {type: 'polyline', polyline:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Face` value (or null) from the oneof `element` */
            getFace(): ng.topology.Face | null {
                if(this.element === null) return null;
                if(this.element.type !== 'face') return null;
                return this.element.face;
            }

            /** Sets the `Face` value for the oneof `element`*/
            setFace(value: ng.topology.Face | null) {
                if(value !== null) {
                    this.element = {type: 'face', face:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Block` value (or null) from the oneof `element` */
            getBlock(): ng.topology.Block | null {
                if(this.element === null) return null;
                if(this.element.type !== 'block') return null;
                return this.element.block;
            }

            /** Sets the `Block` value for the oneof `element`*/
            setBlock(value: ng.topology.Block | null) {
                if(value !== null) {
                    this.element = {type: 'block', block:value};
                }
                else {
                    this.element = null;
                }
            }

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.line !== undefined && src.line !== null) {
                    dst.setLine(ng.topology.Line.fromObject(src.line));
                }
                if (src.polyline !== undefined && src.polyline !== null) {
                    dst.setPolyline(ng.topology.PolyLine.fromObject(src.polyline));
                }
                if (src.face !== undefined && src.face !== null) {
                    dst.setFace(ng.topology.Face.fromObject(src.face));
                }
                if (src.block !== undefined && src.block !== null) {
                    dst.setBlock(ng.topology.Block.fromObject(src.block));
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.Data") {
                    console.error('Expected ng.topology.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const line = src.getLine();
                if(line !== null)
                {
                    const parsed = ng.topology.Line.toObject(line);
                    if(parsed === null) return null;
                    dst.line = parsed;
                }
                const polyline = src.getPolyline();
                if(polyline !== null)
                {
                    const parsed = ng.topology.PolyLine.toObject(polyline);
                    if(parsed === null) return null;
                    dst.polyline = parsed;
                }
                const face = src.getFace();
                if(face !== null)
                {
                    const parsed = ng.topology.Face.toObject(face);
                    if(parsed === null) return null;
                    dst.face = parsed;
                }
                const block = src.getBlock();
                if(block !== null)
                {
                    const parsed = ng.topology.Block.toObject(block);
                    if(parsed === null) return null;
                    dst.block = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                // part of the element oneof 
                if (src.line !== undefined && src.line !== null) {
                    dst.setLine(src.line);
                }
                // part of the element oneof 
                if (src.polyline !== undefined && src.polyline !== null) {
                    dst.setPolyline(src.polyline);
                }
                // part of the element oneof 
                if (src.face !== undefined && src.face !== null) {
                    dst.setFace(src.face);
                }
                // part of the element oneof 
                if (src.block !== undefined && src.block !== null) {
                    dst.setBlock(src.block);
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.element = this.element;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;


        export type Line_keys = 'id' | 'startNodeGuid' | 'endNodeGuid';
        export interface Line_createType {
            id?: ng.utils.ID | null,
            startNodeGuid?: string,
            endNodeGuid?: string,
        }
        export interface Line_json {
            id?: ng.utils.ID_json;
            startNodeGuid?: string;
            endNodeGuid?: string;
        }
        interface Line_json_in {
            __proto_name?: unknown;
            id?: unknown;
            startNodeGuid?: unknown;
            endNodeGuid?: unknown;
        }
        export class Line {
            __proto_name = "ng.topology.Line";
            id: ng.utils.ID | null = null;
            startNodeGuid: string = "";
            endNodeGuid: string = "";

            static fromObject(src_unknown: unknown): Line {
                const dst = new Line();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Line but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Line_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Line but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.startNodeGuid !== undefined && src.startNodeGuid !== null) {
                    if (typeof src.startNodeGuid === "string") {
                        dst.startNodeGuid = src.startNodeGuid;
                    }
                    else {
                        console.log('Expected startNodeGuid of Line to be a string but was ', typeof src.startNodeGuid, src.startNodeGuid)
                    }
                }
                if (src.endNodeGuid !== undefined && src.endNodeGuid !== null) {
                    if (typeof src.endNodeGuid === "string") {
                        dst.endNodeGuid = src.endNodeGuid;
                    }
                    else {
                        console.log('Expected endNodeGuid of Line to be a string but was ', typeof src.endNodeGuid, src.endNodeGuid)
                    }
                }
                return dst;
            }

            static toObject(src: Line | null | undefined): Line_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.Line is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.Line") {
                    console.error('Expected ng.topology.Line but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Line_json = {
                    startNodeGuid: src.startNodeGuid,
                    endNodeGuid: src.endNodeGuid,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                return dst;
            }

            static create(src?: Line_createType) {
                const dst = new Line();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.startNodeGuid !== undefined) {
                    dst.startNodeGuid = src.startNodeGuid;
                }
                if (src.endNodeGuid !== undefined) {
                    dst.endNodeGuid = src.endNodeGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Line();
                dst.id = this.id;
                dst.startNodeGuid = this.startNodeGuid;
                dst.endNodeGuid = this.endNodeGuid;
                return dst;
            }

            deepClone() {
                const json = Line.toObject(this);
                const dst = Line.fromObject(json);
                return dst;
            }
        }
        export type ILine = Line;


        export type PolyLine_keys = 'id' | 'nodeGuids';
        export interface PolyLine_createType {
            id?: ng.utils.ID | null,
            nodeGuids?: string[],
        }
        export interface PolyLine_json {
            id?: ng.utils.ID_json;
            nodeGuids: string[];
        }
        interface PolyLine_json_in {
            __proto_name?: unknown;
            id?: unknown;
            nodeGuids?: unknown;
        }
        export class PolyLine {
            __proto_name = "ng.topology.PolyLine";
            id: ng.utils.ID | null = null;
            nodeGuids: string[] = [];

            static fromObject(src_unknown: unknown): PolyLine {
                const dst = new PolyLine();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PolyLine but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PolyLine_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PolyLine but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.nodeGuids !== undefined && src.nodeGuids !== null) {
                    if (Array.isArray(src.nodeGuids)) {
                        for (const [index, element] of src.nodeGuids.entries()) {
                            if (typeof element === "string") {
                                dst.nodeGuids.push(element);
                            }
                            else {
                                console.log('Expected nodeGuids of PolyLine[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected nodeGuids of PolyLine to be a array but was ', typeof src.nodeGuids, src.nodeGuids)
                    }
                }
                return dst;
            }

            static toObject(src: PolyLine | null | undefined): PolyLine_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.PolyLine is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.PolyLine") {
                    console.error('Expected ng.topology.PolyLine but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PolyLine_json = {
                    nodeGuids: new Array<string>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.nodeGuids !== null) {
                    for (const element of src.nodeGuids) {
                        dst.nodeGuids.push(element);
                    }
                }
                return dst;
            }

            static create(src?: PolyLine_createType) {
                const dst = new PolyLine();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.nodeGuids !== undefined) {
                    dst.nodeGuids = src.nodeGuids;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PolyLine();
                dst.id = this.id;
                dst.nodeGuids = this.nodeGuids;
                return dst;
            }

            deepClone() {
                const json = PolyLine.toObject(this);
                const dst = PolyLine.fromObject(json);
                return dst;
            }
        }
        export type IPolyLine = PolyLine;


        export type Face_keys = 'id' | 'perimeter' | 'holes' | 'orientation';
        export interface Face_createType {
            id?: ng.utils.ID | null,
            perimeter?: ng.topology.PolyLine | null,
            holes?: ng.topology.PolyLine[],
            orientation?: ng.geometry.Orientation | null,
        }
        export interface Face_json {
            id?: ng.utils.ID_json;
            perimeter?: ng.topology.PolyLine_json;
            holes: ng.topology.PolyLine_json[];
            orientation?: ng.geometry.Orientation_json;
        }
        interface Face_json_in {
            __proto_name?: unknown;
            id?: unknown;
            perimeter?: unknown;
            holes?: unknown;
            orientation?: unknown;
        }
        export class Face {
            __proto_name = "ng.topology.Face";
            id: ng.utils.ID | null = null;
            perimeter: ng.topology.PolyLine | null = null;
            holes: ng.topology.PolyLine[] = [];
            orientation: ng.geometry.Orientation | null = null;

            static fromObject(src_unknown: unknown): Face {
                const dst = new Face();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Face but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Face_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Face but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.perimeter !== undefined && src.perimeter !== null) {
                    dst.perimeter = ng.topology.PolyLine.fromObject(src.perimeter);
                }
                if (src.holes !== undefined && src.holes !== null) {
                    if (Array.isArray(src.holes)) {
                        for (const element of src.holes) {
                            dst.holes.push(ng.topology.PolyLine.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected holes of Face to be a array but was ', typeof src.holes, src.holes)
                    }
                }
                if (src.orientation !== undefined && src.orientation !== null) {
                    dst.orientation = ng.geometry.Orientation.fromObject(src.orientation);
                }
                return dst;
            }

            static toObject(src: Face | null | undefined): Face_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.Face is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.Face") {
                    console.error('Expected ng.topology.Face but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Face_json = {
                    holes: new Array<ng.topology.PolyLine_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.perimeter !== null)
                {
                    const parsed = ng.topology.PolyLine.toObject(src.perimeter);
                    if(parsed === null) return null;
                    dst.perimeter = parsed;
                }
                if (src.holes !== null) {
                    for (const element of src.holes) {
                        const parsed = ng.topology.PolyLine.toObject(element);
                        if(parsed === null) return null;
                        dst.holes.push(parsed);
                    }
                }
                if(src.orientation !== null)
                {
                    const parsed = ng.geometry.Orientation.toObject(src.orientation);
                    if(parsed === null) return null;
                    dst.orientation = parsed;
                }
                return dst;
            }

            static create(src?: Face_createType) {
                const dst = new Face();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.perimeter !== undefined) {
                    dst.perimeter = src.perimeter;
                }
                if (src.holes !== undefined) {
                    dst.holes = src.holes;
                }
                if (src.orientation !== undefined) {
                    dst.orientation = src.orientation;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Face();
                dst.id = this.id;
                dst.perimeter = this.perimeter;
                dst.holes = this.holes;
                dst.orientation = this.orientation;
                return dst;
            }

            deepClone() {
                const json = Face.toObject(this);
                const dst = Face.fromObject(json);
                return dst;
            }
        }
        export type IFace = Face;


        export type Surface_keys = 'id' | 'shells';
        export interface Surface_createType {
            id?: ng.utils.ID | null,
            shells?: ng.topology.PolyLine[],
        }
        export interface Surface_json {
            id?: ng.utils.ID_json;
            shells: ng.topology.PolyLine_json[];
        }
        interface Surface_json_in {
            __proto_name?: unknown;
            id?: unknown;
            shells?: unknown;
        }
        export class Surface {
            __proto_name = "ng.topology.Surface";
            id: ng.utils.ID | null = null;
            shells: ng.topology.PolyLine[] = [];

            static fromObject(src_unknown: unknown): Surface {
                const dst = new Surface();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Surface but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Surface_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Surface but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.shells !== undefined && src.shells !== null) {
                    if (Array.isArray(src.shells)) {
                        for (const element of src.shells) {
                            dst.shells.push(ng.topology.PolyLine.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected shells of Surface to be a array but was ', typeof src.shells, src.shells)
                    }
                }
                return dst;
            }

            static toObject(src: Surface | null | undefined): Surface_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.Surface is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.Surface") {
                    console.error('Expected ng.topology.Surface but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Surface_json = {
                    shells: new Array<ng.topology.PolyLine_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.shells !== null) {
                    for (const element of src.shells) {
                        const parsed = ng.topology.PolyLine.toObject(element);
                        if(parsed === null) return null;
                        dst.shells.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Surface_createType) {
                const dst = new Surface();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.shells !== undefined) {
                    dst.shells = src.shells;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Surface();
                dst.id = this.id;
                dst.shells = this.shells;
                return dst;
            }

            deepClone() {
                const json = Surface.toObject(this);
                const dst = Surface.fromObject(json);
                return dst;
            }
        }
        export type ISurface = Surface;


        export type Block_keys = 'id' | 'surface';
        export interface Block_createType {
            id?: ng.utils.ID | null,
            surface?: ng.topology.Surface | null,
        }
        export interface Block_json {
            id?: ng.utils.ID_json;
            surface?: ng.topology.Surface_json;
        }
        interface Block_json_in {
            __proto_name?: unknown;
            id?: unknown;
            surface?: unknown;
        }
        export class Block {
            __proto_name = "ng.topology.Block";
            id: ng.utils.ID | null = null;
            surface: ng.topology.Surface | null = null;

            static fromObject(src_unknown: unknown): Block {
                const dst = new Block();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Block but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Block_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Block but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.surface !== undefined && src.surface !== null) {
                    dst.surface = ng.topology.Surface.fromObject(src.surface);
                }
                return dst;
            }

            static toObject(src: Block | null | undefined): Block_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.topology.Block is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.topology.Block") {
                    console.error('Expected ng.topology.Block but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Block_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.surface !== null)
                {
                    const parsed = ng.topology.Surface.toObject(src.surface);
                    if(parsed === null) return null;
                    dst.surface = parsed;
                }
                return dst;
            }

            static create(src?: Block_createType) {
                const dst = new Block();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.surface !== undefined) {
                    dst.surface = src.surface;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Block();
                dst.id = this.id;
                dst.surface = this.surface;
                return dst;
            }

            deepClone() {
                const json = Block.toObject(this);
                const dst = Block.fromObject(json);
                return dst;
            }
        }
        export type IBlock = Block;
    } // namespace topology


    // Defined in Utils/log.proto
    export namespace log {
        export enum LogType {
            LOG_TYPE_UNSPECIFIED = 0,
            LOG_TYPE_INFORMATION = 1,
            LOG_TYPE_WARNING = 2,
            LOG_TYPE_ERROR = 3
        }
        export const LogType_FromObject = (src: unknown): LogType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'LOG_TYPE_UNSPECIFIED':
                    return LogType.LOG_TYPE_UNSPECIFIED;
                case 1:
                case 'LOG_TYPE_INFORMATION':
                    return LogType.LOG_TYPE_INFORMATION;
                case 2:
                case 'LOG_TYPE_WARNING':
                    return LogType.LOG_TYPE_WARNING;
                case 3:
                case 'LOG_TYPE_ERROR':
                    return LogType.LOG_TYPE_ERROR;
                default:
                    console.log('Unhandled value for LogType:' + src + '. ' + typeof(src));
                    return LogType.LOG_TYPE_UNSPECIFIED;
            }
        };
        export const LogType_ToObject = (src: LogType): string | null => {
            switch (src) {
                case LogType.LOG_TYPE_UNSPECIFIED:
                    return 'LOG_TYPE_UNSPECIFIED';
                case LogType.LOG_TYPE_INFORMATION:
                    return 'LOG_TYPE_INFORMATION';
                case LogType.LOG_TYPE_WARNING:
                    return 'LOG_TYPE_WARNING';
                case LogType.LOG_TYPE_ERROR:
                    return 'LOG_TYPE_ERROR';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for LogType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type LogValue_keys = 'key' | 'integerValue' | 'doubleValue' | 'stringValue' | 'boolValue';
        export interface LogValue_createType {
            key?: string,
            integerValue?: number,
            doubleValue?: number,
            stringValue?: string,
            boolValue?: boolean,
        }
        export interface LogValue_json {
            key?: string;
            integerValue?: JsonNumber;
            doubleValue?: JsonNumber;
            stringValue?: string;
            boolValue?: boolean;
        }
        interface LogValue_json_in {
            __proto_name?: unknown;
            key?: unknown;
            integerValue?: unknown;
            doubleValue?: unknown;
            stringValue?: unknown;
            boolValue?: unknown;
        }
        export class LogValue {
            __proto_name = "ng.log.LogValue";
            key: string = "";
            // this is a one of
            value: {type: 'integerValue'; integerValue: number} | {type: 'doubleValue'; doubleValue: number} | {type: 'stringValue'; stringValue: string} | {type: 'boolValue'; boolValue: boolean} | null = null;

            /** Gets the `IntegerValue` value (or null) from the oneof `value` */
            getIntegerValue(): number | null {
                if(this.value === null) return null;
                if(this.value.type !== 'integerValue') return null;
                return this.value.integerValue;
            }

            /** Sets the `IntegerValue` value for the oneof `value`*/
            setIntegerValue(value: number | null) {
                if(value !== null) {
                    this.value = {type: 'integerValue', integerValue:value};
                }
                else {
                    this.value = null;
                }
            }

            /** Gets the `DoubleValue` value (or null) from the oneof `value` */
            getDoubleValue(): number | null {
                if(this.value === null) return null;
                if(this.value.type !== 'doubleValue') return null;
                return this.value.doubleValue;
            }

            /** Sets the `DoubleValue` value for the oneof `value`*/
            setDoubleValue(value: number | null) {
                if(value !== null) {
                    this.value = {type: 'doubleValue', doubleValue:value};
                }
                else {
                    this.value = null;
                }
            }

            /** Gets the `StringValue` value (or null) from the oneof `value` */
            getStringValue(): string | null {
                if(this.value === null) return null;
                if(this.value.type !== 'stringValue') return null;
                return this.value.stringValue;
            }

            /** Sets the `StringValue` value for the oneof `value`*/
            setStringValue(value: string | null) {
                if(value !== null) {
                    this.value = {type: 'stringValue', stringValue:value};
                }
                else {
                    this.value = null;
                }
            }

            /** Gets the `BoolValue` value (or null) from the oneof `value` */
            getBoolValue(): boolean | null {
                if(this.value === null) return null;
                if(this.value.type !== 'boolValue') return null;
                return this.value.boolValue;
            }

            /** Sets the `BoolValue` value for the oneof `value`*/
            setBoolValue(value: boolean | null) {
                if(value !== null) {
                    this.value = {type: 'boolValue', boolValue:value};
                }
                else {
                    this.value = null;
                }
            }

            static fromObject(src_unknown: unknown): LogValue {
                const dst = new LogValue();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LogValue but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LogValue_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LogValue but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.key !== undefined && src.key !== null) {
                    if (typeof src.key === "string") {
                        dst.key = src.key;
                    }
                    else {
                        console.log('Expected key of LogValue to be a string but was ', typeof src.key, src.key)
                    }
                }
                if (src.integerValue !== undefined && src.integerValue !== null) {
                    if (typeof src.integerValue === "number" || src.integerValue === 'NaN' || src.integerValue === 'Infinity' || src.integerValue === '-Infinity') {
                        dst.setIntegerValue(NumberToInt("ng.log.LogValue.integer_value", AsNum(src.integerValue)));
                    }
                    else {
                        console.log('Expected integerValue of LogValue to be a number but was ', typeof src.integerValue, src.integerValue)
                    }
                }
                if (src.doubleValue !== undefined && src.doubleValue !== null) {
                    if (typeof src.doubleValue === "number" || src.doubleValue === 'NaN' || src.doubleValue === 'Infinity' || src.doubleValue === '-Infinity') {
                        dst.setDoubleValue(AsNum(src.doubleValue));
                    }
                    else {
                        console.log('Expected doubleValue of LogValue to be a number but was ', typeof src.doubleValue, src.doubleValue)
                    }
                }
                if (src.stringValue !== undefined && src.stringValue !== null) {
                    if (typeof src.stringValue === "string") {
                        dst.setStringValue(src.stringValue);
                    }
                    else {
                        console.log('Expected stringValue of LogValue to be a string but was ', typeof src.stringValue, src.stringValue)
                    }
                }
                if (src.boolValue !== undefined && src.boolValue !== null) {
                    if (typeof src.boolValue === "boolean") {
                        dst.setBoolValue(src.boolValue);
                    }
                    else {
                        console.log('Expected boolValue of LogValue to be a boolean but was ', typeof src.boolValue, src.boolValue)
                    }
                }
                return dst;
            }

            static toObject(src: LogValue | null | undefined): LogValue_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.log.LogValue is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.log.LogValue") {
                    console.error('Expected ng.log.LogValue but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LogValue_json = {
                    key: src.key,
                };
                const integerValue = src.getIntegerValue();
                if(integerValue !== null)
                {
                    const parsed = AsJsonNum(NumberToInt("ng.log.LogValue.integer_value", integerValue));
                    if(parsed === null) return null;
                    dst.integerValue = parsed;
                }
                const doubleValue = src.getDoubleValue();
                if(doubleValue !== null)
                {
                    const parsed = AsJsonNum(doubleValue);
                    if(parsed === null) return null;
                    dst.doubleValue = parsed;
                }
                const stringValue = src.getStringValue();
                if(stringValue !== null)
                {
                    const parsed = stringValue;
                    if(parsed === null) return null;
                    dst.stringValue = parsed;
                }
                const boolValue = src.getBoolValue();
                if(boolValue !== null)
                {
                    const parsed = boolValue;
                    if(parsed === null) return null;
                    dst.boolValue = parsed;
                }
                return dst;
            }

            static create(src?: LogValue_createType) {
                const dst = new LogValue();
                if (src === undefined) {
                    return dst;
                }
                if (src.key !== undefined) {
                    dst.key = src.key;
                }
                // part of the value oneof 
                if (src.integerValue !== undefined && src.integerValue !== null) {
                    dst.setIntegerValue(src.integerValue);
                }
                // part of the value oneof 
                if (src.doubleValue !== undefined && src.doubleValue !== null) {
                    dst.setDoubleValue(src.doubleValue);
                }
                // part of the value oneof 
                if (src.stringValue !== undefined && src.stringValue !== null) {
                    dst.setStringValue(src.stringValue);
                }
                // part of the value oneof 
                if (src.boolValue !== undefined && src.boolValue !== null) {
                    dst.setBoolValue(src.boolValue);
                }
                return dst;
            }

            shallowClone() {
                const dst = new LogValue();
                dst.key = this.key;
                dst.value = this.value;
                return dst;
            }

            deepClone() {
                const json = LogValue.toObject(this);
                const dst = LogValue.fromObject(json);
                return dst;
            }
        }
        export type ILogValue = LogValue;


        export type LogEntry_keys = 'type' | 'text' | 'values' | 'label';
        export interface LogEntry_createType {
            type?: ng.log.LogType,
            text?: string,
            values?: ng.log.LogValue[],
            label?: string,
        }
        export interface LogEntry_json {
            type?: string;
            text?: string;
            values: ng.log.LogValue_json[];
            label?: string;
        }
        interface LogEntry_json_in {
            __proto_name?: unknown;
            type?: unknown;
            text?: unknown;
            values?: unknown;
            label?: unknown;
        }
        export class LogEntry {
            __proto_name = "ng.log.LogEntry";
            type: ng.log.LogType = ng.log.LogType.LOG_TYPE_UNSPECIFIED;
            text: string = "";
            values: ng.log.LogValue[] = [];
            label: string = "";

            static fromObject(src_unknown: unknown): LogEntry {
                const dst = new LogEntry();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LogEntry but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LogEntry_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LogEntry but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.log.LogType_FromObject(src.type);
                }
                if (src.text !== undefined && src.text !== null) {
                    if (typeof src.text === "string") {
                        dst.text = src.text;
                    }
                    else {
                        console.log('Expected text of LogEntry to be a string but was ', typeof src.text, src.text)
                    }
                }
                if (src.values !== undefined && src.values !== null) {
                    if (Array.isArray(src.values)) {
                        for (const element of src.values) {
                            dst.values.push(ng.log.LogValue.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected values of LogEntry to be a array but was ', typeof src.values, src.values)
                    }
                }
                if (src.label !== undefined && src.label !== null) {
                    if (typeof src.label === "string") {
                        dst.label = src.label;
                    }
                    else {
                        console.log('Expected label of LogEntry to be a string but was ', typeof src.label, src.label)
                    }
                }
                return dst;
            }

            static toObject(src: LogEntry | null | undefined): LogEntry_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.log.LogEntry is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.log.LogEntry") {
                    console.error('Expected ng.log.LogEntry but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.log.LogType_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : LogEntry_json = {
                    type: type_obj,
                    text: src.text,
                    values: new Array<ng.log.LogValue_json>(),
                    label: src.label,
                };
                if (src.values !== null) {
                    for (const element of src.values) {
                        const parsed = ng.log.LogValue.toObject(element);
                        if(parsed === null) return null;
                        dst.values.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: LogEntry_createType) {
                const dst = new LogEntry();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.text !== undefined) {
                    dst.text = src.text;
                }
                if (src.values !== undefined) {
                    dst.values = src.values;
                }
                if (src.label !== undefined) {
                    dst.label = src.label;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LogEntry();
                dst.type = this.type;
                dst.text = this.text;
                dst.values = this.values;
                dst.label = this.label;
                return dst;
            }

            deepClone() {
                const json = LogEntry.toObject(this);
                const dst = LogEntry.fromObject(json);
                return dst;
            }
        }
        export type ILogEntry = LogEntry;


        export type Log_keys = 'entries';
        export interface Log_createType {
            entries?: ng.log.LogEntry[],
        }
        export interface Log_json {
            entries: ng.log.LogEntry_json[];
        }
        interface Log_json_in {
            __proto_name?: unknown;
            entries?: unknown;
        }
        export class Log {
            __proto_name = "ng.log.Log";
            entries: ng.log.LogEntry[] = [];

            static fromObject(src_unknown: unknown): Log {
                const dst = new Log();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Log but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Log_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Log but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.entries !== undefined && src.entries !== null) {
                    if (Array.isArray(src.entries)) {
                        for (const element of src.entries) {
                            dst.entries.push(ng.log.LogEntry.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected entries of Log to be a array but was ', typeof src.entries, src.entries)
                    }
                }
                return dst;
            }

            static toObject(src: Log | null | undefined): Log_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.log.Log is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.log.Log") {
                    console.error('Expected ng.log.Log but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Log_json = {
                    entries: new Array<ng.log.LogEntry_json>(),
                };
                if (src.entries !== null) {
                    for (const element of src.entries) {
                        const parsed = ng.log.LogEntry.toObject(element);
                        if(parsed === null) return null;
                        dst.entries.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Log_createType) {
                const dst = new Log();
                if (src === undefined) {
                    return dst;
                }
                if (src.entries !== undefined) {
                    dst.entries = src.entries;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Log();
                dst.entries = this.entries;
                return dst;
            }

            deepClone() {
                const json = Log.toObject(this);
                const dst = Log.fromObject(json);
                return dst;
            }
        }
        export type ILog = Log;
    } // namespace log


    // Defined in Utils/eurocode.proto
    export namespace eurocode {
        export enum Annex {
            ANNEX_UNSPECIFIED = 0,
            ANNEX_COMMON = 1,
            ANNEX_HUNGARY = 2,
            ANNEX_ROMANIA = 3,
            ANNEX_DENMARK = 4,
            ANNEX_SWEDEN = 5,
            ANNEX_NORWAY = 6,
            ANNEX_FINLAND = 7,
            ANNEX_GREAT_BRITAIN = 8,
            ANNEX_GERMANY = 9,
            ANNEX_POLAND = 10,
            ANNEX_TURKEY = 11,
            ANNEX_ESTONIA = 12,
            ANNEX_LATVIA = 13,
            ANNEX_BELGIUM = 14,
            ANNEX_NETHERLAND = 15,
            ANNEX_SPAIN = 16
        }
        export const Annex_FromObject = (src: unknown): Annex => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'ANNEX_UNSPECIFIED':
                    return Annex.ANNEX_UNSPECIFIED;
                case 1:
                case 'ANNEX_COMMON':
                    return Annex.ANNEX_COMMON;
                case 2:
                case 'ANNEX_HUNGARY':
                    return Annex.ANNEX_HUNGARY;
                case 3:
                case 'ANNEX_ROMANIA':
                    return Annex.ANNEX_ROMANIA;
                case 4:
                case 'ANNEX_DENMARK':
                    return Annex.ANNEX_DENMARK;
                case 5:
                case 'ANNEX_SWEDEN':
                    return Annex.ANNEX_SWEDEN;
                case 6:
                case 'ANNEX_NORWAY':
                    return Annex.ANNEX_NORWAY;
                case 7:
                case 'ANNEX_FINLAND':
                    return Annex.ANNEX_FINLAND;
                case 8:
                case 'ANNEX_GREAT_BRITAIN':
                    return Annex.ANNEX_GREAT_BRITAIN;
                case 9:
                case 'ANNEX_GERMANY':
                    return Annex.ANNEX_GERMANY;
                case 10:
                case 'ANNEX_POLAND':
                    return Annex.ANNEX_POLAND;
                case 11:
                case 'ANNEX_TURKEY':
                    return Annex.ANNEX_TURKEY;
                case 12:
                case 'ANNEX_ESTONIA':
                    return Annex.ANNEX_ESTONIA;
                case 13:
                case 'ANNEX_LATVIA':
                    return Annex.ANNEX_LATVIA;
                case 14:
                case 'ANNEX_BELGIUM':
                    return Annex.ANNEX_BELGIUM;
                case 15:
                case 'ANNEX_NETHERLAND':
                    return Annex.ANNEX_NETHERLAND;
                case 16:
                case 'ANNEX_SPAIN':
                    return Annex.ANNEX_SPAIN;
                default:
                    console.log('Unhandled value for Annex:' + src + '. ' + typeof(src));
                    return Annex.ANNEX_UNSPECIFIED;
            }
        };
        export const Annex_ToObject = (src: Annex): string | null => {
            switch (src) {
                case Annex.ANNEX_UNSPECIFIED:
                    return 'ANNEX_UNSPECIFIED';
                case Annex.ANNEX_COMMON:
                    return 'ANNEX_COMMON';
                case Annex.ANNEX_HUNGARY:
                    return 'ANNEX_HUNGARY';
                case Annex.ANNEX_ROMANIA:
                    return 'ANNEX_ROMANIA';
                case Annex.ANNEX_DENMARK:
                    return 'ANNEX_DENMARK';
                case Annex.ANNEX_SWEDEN:
                    return 'ANNEX_SWEDEN';
                case Annex.ANNEX_NORWAY:
                    return 'ANNEX_NORWAY';
                case Annex.ANNEX_FINLAND:
                    return 'ANNEX_FINLAND';
                case Annex.ANNEX_GREAT_BRITAIN:
                    return 'ANNEX_GREAT_BRITAIN';
                case Annex.ANNEX_GERMANY:
                    return 'ANNEX_GERMANY';
                case Annex.ANNEX_POLAND:
                    return 'ANNEX_POLAND';
                case Annex.ANNEX_TURKEY:
                    return 'ANNEX_TURKEY';
                case Annex.ANNEX_ESTONIA:
                    return 'ANNEX_ESTONIA';
                case Annex.ANNEX_LATVIA:
                    return 'ANNEX_LATVIA';
                case Annex.ANNEX_BELGIUM:
                    return 'ANNEX_BELGIUM';
                case Annex.ANNEX_NETHERLAND:
                    return 'ANNEX_NETHERLAND';
                case Annex.ANNEX_SPAIN:
                    return 'ANNEX_SPAIN';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Annex, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum Generation {
            GENERATION_UNSPECIFIED = 0,
            GENERATION_1 = 1,
            GENERATION_2 = 2
        }
        export const Generation_FromObject = (src: unknown): Generation => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'GENERATION_UNSPECIFIED':
                    return Generation.GENERATION_UNSPECIFIED;
                case 1:
                case 'GENERATION_1':
                    return Generation.GENERATION_1;
                case 2:
                case 'GENERATION_2':
                    return Generation.GENERATION_2;
                default:
                    console.log('Unhandled value for Generation:' + src + '. ' + typeof(src));
                    return Generation.GENERATION_UNSPECIFIED;
            }
        };
        export const Generation_ToObject = (src: Generation): string | null => {
            switch (src) {
                case Generation.GENERATION_UNSPECIFIED:
                    return 'GENERATION_UNSPECIFIED';
                case Generation.GENERATION_1:
                    return 'GENERATION_1';
                case Generation.GENERATION_2:
                    return 'GENERATION_2';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Generation, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type DesignConfiguration_keys = 'nationalAnnex' | 'altitude' | 'snowLoad' | 'generation';
        export interface DesignConfiguration_createType {
            nationalAnnex?: ng.eurocode.Annex,
            altitude?: number,
            snowLoad?: number,
            generation?: ng.eurocode.Generation,
        }
        export interface DesignConfiguration_json {
            nationalAnnex?: string;
            altitude?: JsonNumber;
            snowLoad?: JsonNumber;
            generation?: string;
        }
        interface DesignConfiguration_json_in {
            __proto_name?: unknown;
            nationalAnnex?: unknown;
            altitude?: unknown;
            snowLoad?: unknown;
            generation?: unknown;
        }
        export class DesignConfiguration {
            __proto_name = "ng.eurocode.DesignConfiguration";
            nationalAnnex: ng.eurocode.Annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;
            altitude: number = 0;
            snowLoad: number = 0;
            generation: ng.eurocode.Generation = ng.eurocode.Generation.GENERATION_UNSPECIFIED;

            static fromObject(src_unknown: unknown): DesignConfiguration {
                const dst = new DesignConfiguration();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted DesignConfiguration but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as DesignConfiguration_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for DesignConfiguration but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.nationalAnnex !== undefined && src.nationalAnnex !== null) {
                    dst.nationalAnnex = ng.eurocode.Annex_FromObject(src.nationalAnnex);
                }
                if (src.altitude !== undefined && src.altitude !== null) {
                    if (typeof src.altitude === "number" || src.altitude === 'NaN' || src.altitude === 'Infinity' || src.altitude === '-Infinity') {
                        dst.altitude = AsNum(src.altitude);
                    }
                    else {
                        console.log('Expected altitude of DesignConfiguration to be a number but was ', typeof src.altitude, src.altitude)
                    }
                }
                if (src.snowLoad !== undefined && src.snowLoad !== null) {
                    if (typeof src.snowLoad === "number" || src.snowLoad === 'NaN' || src.snowLoad === 'Infinity' || src.snowLoad === '-Infinity') {
                        dst.snowLoad = AsNum(src.snowLoad);
                    }
                    else {
                        console.log('Expected snowLoad of DesignConfiguration to be a number but was ', typeof src.snowLoad, src.snowLoad)
                    }
                }
                if (src.generation !== undefined && src.generation !== null) {
                    dst.generation = ng.eurocode.Generation_FromObject(src.generation);
                }
                return dst;
            }

            static toObject(src: DesignConfiguration | null | undefined): DesignConfiguration_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.eurocode.DesignConfiguration is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.eurocode.DesignConfiguration") {
                    console.error('Expected ng.eurocode.DesignConfiguration but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const nationalAnnex_obj = ng.eurocode.Annex_ToObject(src.nationalAnnex);
                if(nationalAnnex_obj === null) return null;

                const generation_obj = ng.eurocode.Generation_ToObject(src.generation);
                if(generation_obj === null) return null;

                const dst : DesignConfiguration_json = {
                    nationalAnnex: nationalAnnex_obj,
                    altitude: AsJsonNum(src.altitude),
                    snowLoad: AsJsonNum(src.snowLoad),
                    generation: generation_obj,
                };
                return dst;
            }

            static create(src?: DesignConfiguration_createType) {
                const dst = new DesignConfiguration();
                if (src === undefined) {
                    return dst;
                }
                if (src.nationalAnnex !== undefined) {
                    dst.nationalAnnex = src.nationalAnnex;
                }
                if (src.altitude !== undefined) {
                    dst.altitude = src.altitude;
                }
                if (src.snowLoad !== undefined) {
                    dst.snowLoad = src.snowLoad;
                }
                if (src.generation !== undefined) {
                    dst.generation = src.generation;
                }
                return dst;
            }

            shallowClone() {
                const dst = new DesignConfiguration();
                dst.nationalAnnex = this.nationalAnnex;
                dst.altitude = this.altitude;
                dst.snowLoad = this.snowLoad;
                dst.generation = this.generation;
                return dst;
            }

            deepClone() {
                const json = DesignConfiguration.toObject(this);
                const dst = DesignConfiguration.fromObject(json);
                return dst;
            }
        }
        export type IDesignConfiguration = DesignConfiguration;
    } // namespace eurocode


    // Defined in Utils/utils.proto
    export namespace utils {
        export enum Owner {
            OWNER_UNSPECIFIED = 0,
            OWNER_STRUSOFT = 1,
            OWNER_USER = 2,
            OWNER_OFFICE = 3,
            OWNER_COMPANY = 4
        }
        export const Owner_FromObject = (src: unknown): Owner => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'OWNER_UNSPECIFIED':
                    return Owner.OWNER_UNSPECIFIED;
                case 1:
                case 'OWNER_STRUSOFT':
                    return Owner.OWNER_STRUSOFT;
                case 2:
                case 'OWNER_USER':
                    return Owner.OWNER_USER;
                case 3:
                case 'OWNER_OFFICE':
                    return Owner.OWNER_OFFICE;
                case 4:
                case 'OWNER_COMPANY':
                    return Owner.OWNER_COMPANY;
                default:
                    console.log('Unhandled value for Owner:' + src + '. ' + typeof(src));
                    return Owner.OWNER_UNSPECIFIED;
            }
        };
        export const Owner_ToObject = (src: Owner): string | null => {
            switch (src) {
                case Owner.OWNER_UNSPECIFIED:
                    return 'OWNER_UNSPECIFIED';
                case Owner.OWNER_STRUSOFT:
                    return 'OWNER_STRUSOFT';
                case Owner.OWNER_USER:
                    return 'OWNER_USER';
                case Owner.OWNER_OFFICE:
                    return 'OWNER_OFFICE';
                case Owner.OWNER_COMPANY:
                    return 'OWNER_COMPANY';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Owner, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type SemVer_keys = 'majorVersion' | 'minorVersion' | 'patchVersion';
        export interface SemVer_createType {
            majorVersion?: number,
            minorVersion?: number,
            patchVersion?: number,
        }
        export interface SemVer_json {
            majorVersion?: JsonNumber;
            minorVersion?: JsonNumber;
            patchVersion?: JsonNumber;
        }
        interface SemVer_json_in {
            __proto_name?: unknown;
            majorVersion?: unknown;
            minorVersion?: unknown;
            patchVersion?: unknown;
        }
        export class SemVer {
            __proto_name = "ng.utils.SemVer";
            majorVersion: number = 0;
            minorVersion: number = 0;
            patchVersion: number = 0;

            static fromObject(src_unknown: unknown): SemVer {
                const dst = new SemVer();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SemVer but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SemVer_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SemVer but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.majorVersion !== undefined && src.majorVersion !== null) {
                    if (typeof src.majorVersion === "number" || src.majorVersion === 'NaN' || src.majorVersion === 'Infinity' || src.majorVersion === '-Infinity') {
                        dst.majorVersion = NumberToInt("ng.utils.SemVer.major_version", AsNum(src.majorVersion));
                    }
                    else {
                        console.log('Expected majorVersion of SemVer to be a number but was ', typeof src.majorVersion, src.majorVersion)
                    }
                }
                if (src.minorVersion !== undefined && src.minorVersion !== null) {
                    if (typeof src.minorVersion === "number" || src.minorVersion === 'NaN' || src.minorVersion === 'Infinity' || src.minorVersion === '-Infinity') {
                        dst.minorVersion = NumberToInt("ng.utils.SemVer.minor_version", AsNum(src.minorVersion));
                    }
                    else {
                        console.log('Expected minorVersion of SemVer to be a number but was ', typeof src.minorVersion, src.minorVersion)
                    }
                }
                if (src.patchVersion !== undefined && src.patchVersion !== null) {
                    if (typeof src.patchVersion === "number" || src.patchVersion === 'NaN' || src.patchVersion === 'Infinity' || src.patchVersion === '-Infinity') {
                        dst.patchVersion = NumberToInt("ng.utils.SemVer.patch_version", AsNum(src.patchVersion));
                    }
                    else {
                        console.log('Expected patchVersion of SemVer to be a number but was ', typeof src.patchVersion, src.patchVersion)
                    }
                }
                return dst;
            }

            static toObject(src: SemVer | null | undefined): SemVer_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.utils.SemVer is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.utils.SemVer") {
                    console.error('Expected ng.utils.SemVer but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SemVer_json = {
                    majorVersion: AsJsonNum(NumberToInt("ng.utils.SemVer.major_version", src.majorVersion)),
                    minorVersion: AsJsonNum(NumberToInt("ng.utils.SemVer.minor_version", src.minorVersion)),
                    patchVersion: AsJsonNum(NumberToInt("ng.utils.SemVer.patch_version", src.patchVersion)),
                };
                return dst;
            }

            static create(src?: SemVer_createType) {
                const dst = new SemVer();
                if (src === undefined) {
                    return dst;
                }
                if (src.majorVersion !== undefined) {
                    dst.majorVersion = src.majorVersion;
                }
                if (src.minorVersion !== undefined) {
                    dst.minorVersion = src.minorVersion;
                }
                if (src.patchVersion !== undefined) {
                    dst.patchVersion = src.patchVersion;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SemVer();
                dst.majorVersion = this.majorVersion;
                dst.minorVersion = this.minorVersion;
                dst.patchVersion = this.patchVersion;
                return dst;
            }

            deepClone() {
                const json = SemVer.toObject(this);
                const dst = SemVer.fromObject(json);
                return dst;
            }
        }
        export type ISemVer = SemVer;


        export type ID_keys = 'guid' | 'name' | 'eTag' | 'version';
        export interface ID_createType {
            guid?: string,
            name?: string,
            eTag?: string,
            version?: ng.utils.SemVer | null,
        }
        export interface ID_json {
            guid?: string;
            name?: string;
            eTag?: string;
            version?: ng.utils.SemVer_json;
        }
        interface ID_json_in {
            __proto_name?: unknown;
            guid?: unknown;
            name?: unknown;
            eTag?: unknown;
            version?: unknown;
        }
        export class ID {
            __proto_name = "ng.utils.ID";
            guid: string = "";
            name: string = "";
            eTag: string = "";
            version: ng.utils.SemVer | null = null;

            static fromObject(src_unknown: unknown): ID {
                const dst = new ID();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ID but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ID_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ID but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.guid !== undefined && src.guid !== null) {
                    if (typeof src.guid === "string") {
                        dst.guid = src.guid;
                    }
                    else {
                        console.log('Expected guid of ID to be a string but was ', typeof src.guid, src.guid)
                    }
                }
                if (src.name !== undefined && src.name !== null) {
                    if (typeof src.name === "string") {
                        dst.name = src.name;
                    }
                    else {
                        console.log('Expected name of ID to be a string but was ', typeof src.name, src.name)
                    }
                }
                if (src.eTag !== undefined && src.eTag !== null) {
                    if (typeof src.eTag === "string") {
                        dst.eTag = src.eTag;
                    }
                    else {
                        console.log('Expected eTag of ID to be a string but was ', typeof src.eTag, src.eTag)
                    }
                }
                if (src.version !== undefined && src.version !== null) {
                    dst.version = ng.utils.SemVer.fromObject(src.version);
                }
                return dst;
            }

            static toObject(src: ID | null | undefined): ID_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.utils.ID is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.utils.ID") {
                    console.error('Expected ng.utils.ID but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ID_json = {
                    guid: src.guid,
                    name: src.name,
                    eTag: src.eTag,
                };
                if(src.version !== null)
                {
                    const parsed = ng.utils.SemVer.toObject(src.version);
                    if(parsed === null) return null;
                    dst.version = parsed;
                }
                return dst;
            }

            static create(src?: ID_createType) {
                const dst = new ID();
                if (src === undefined) {
                    return dst;
                }
                if (src.guid !== undefined) {
                    dst.guid = src.guid;
                }
                if (src.name !== undefined) {
                    dst.name = src.name;
                }
                if (src.eTag !== undefined) {
                    dst.eTag = src.eTag;
                }
                if (src.version !== undefined) {
                    dst.version = src.version;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ID();
                dst.guid = this.guid;
                dst.name = this.name;
                dst.eTag = this.eTag;
                dst.version = this.version;
                return dst;
            }

            deepClone() {
                const json = ID.toObject(this);
                const dst = ID.fromObject(json);
                return dst;
            }
        }
        export type IID = ID;
    } // namespace utils


    // Defined in 10 files
    export namespace material {
        // defined in Material/material.proto
        export enum Mtrl {
            MTRL_UNSPECIFIED = 0,
            MTRL_STEEL = 1,
            MTRL_CONCRETE = 2,
            MTRL_TIMBER = 3,
            MTRL_SOIL = 4,
            MTRL_REINFORCEMENT = 5,
            MTRL_FIRE_PROTECTION_STEEL = 6,
            MTRL_FIRE_PROTECTION_TIMBER = 7,
            MTRL_MASONRY = 8,
            MTRL_CUSTOM = 9
        }
        export const Mtrl_FromObject = (src: unknown): Mtrl => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'MTRL_UNSPECIFIED':
                    return Mtrl.MTRL_UNSPECIFIED;
                case 1:
                case 'MTRL_STEEL':
                    return Mtrl.MTRL_STEEL;
                case 2:
                case 'MTRL_CONCRETE':
                    return Mtrl.MTRL_CONCRETE;
                case 3:
                case 'MTRL_TIMBER':
                    return Mtrl.MTRL_TIMBER;
                case 4:
                case 'MTRL_SOIL':
                    return Mtrl.MTRL_SOIL;
                case 5:
                case 'MTRL_REINFORCEMENT':
                    return Mtrl.MTRL_REINFORCEMENT;
                case 6:
                case 'MTRL_FIRE_PROTECTION_STEEL':
                    return Mtrl.MTRL_FIRE_PROTECTION_STEEL;
                case 7:
                case 'MTRL_FIRE_PROTECTION_TIMBER':
                    return Mtrl.MTRL_FIRE_PROTECTION_TIMBER;
                case 8:
                case 'MTRL_MASONRY':
                    return Mtrl.MTRL_MASONRY;
                case 9:
                case 'MTRL_CUSTOM':
                    return Mtrl.MTRL_CUSTOM;
                default:
                    console.log('Unhandled value for Mtrl:' + src + '. ' + typeof(src));
                    return Mtrl.MTRL_UNSPECIFIED;
            }
        };
        export const Mtrl_ToObject = (src: Mtrl): string | null => {
            switch (src) {
                case Mtrl.MTRL_UNSPECIFIED:
                    return 'MTRL_UNSPECIFIED';
                case Mtrl.MTRL_STEEL:
                    return 'MTRL_STEEL';
                case Mtrl.MTRL_CONCRETE:
                    return 'MTRL_CONCRETE';
                case Mtrl.MTRL_TIMBER:
                    return 'MTRL_TIMBER';
                case Mtrl.MTRL_SOIL:
                    return 'MTRL_SOIL';
                case Mtrl.MTRL_REINFORCEMENT:
                    return 'MTRL_REINFORCEMENT';
                case Mtrl.MTRL_FIRE_PROTECTION_STEEL:
                    return 'MTRL_FIRE_PROTECTION_STEEL';
                case Mtrl.MTRL_FIRE_PROTECTION_TIMBER:
                    return 'MTRL_FIRE_PROTECTION_TIMBER';
                case Mtrl.MTRL_MASONRY:
                    return 'MTRL_MASONRY';
                case Mtrl.MTRL_CUSTOM:
                    return 'MTRL_CUSTOM';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Mtrl, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        // defined in Material/material.proto
        export type Data_keys = 'id' | 'type' | 'conData' | 'steelData' | 'timberData' | 'soilData' | 'reinforcementData' | 'fireSteelData' | 'fireTimberData' | 'masonryData' | 'customData' | 'ownerType' | 'ownerName';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            type?: ng.material.Mtrl,
            conData?: ng.material.concrete.Data | null,
            steelData?: ng.material.steel.Data | null,
            timberData?: ng.material.timber.Data | null,
            soilData?: ng.material.soil.Data | null,
            reinforcementData?: ng.material.reinforcement.Data | null,
            fireSteelData?: ng.fire_protection.steel.Data | null,
            fireTimberData?: ng.fire_protection.timber.Data | null,
            masonryData?: ng.material.masonry.Data | null,
            customData?: ng.material.custom.Data | null,
            ownerType?: ng.utils.Owner,
            ownerName?: string,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            type?: string;
            conData?: ng.material.concrete.Data_json;
            steelData?: ng.material.steel.Data_json;
            timberData?: ng.material.timber.Data_json;
            soilData?: ng.material.soil.Data_json;
            reinforcementData?: ng.material.reinforcement.Data_json;
            fireSteelData?: ng.fire_protection.steel.Data_json;
            fireTimberData?: ng.fire_protection.timber.Data_json;
            masonryData?: ng.material.masonry.Data_json;
            customData?: ng.material.custom.Data_json;
            ownerType?: string;
            ownerName?: string;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            type?: unknown;
            conData?: unknown;
            steelData?: unknown;
            timberData?: unknown;
            soilData?: unknown;
            reinforcementData?: unknown;
            fireSteelData?: unknown;
            fireTimberData?: unknown;
            masonryData?: unknown;
            customData?: unknown;
            ownerType?: unknown;
            ownerName?: unknown;
        }
        export class Data {
            __proto_name = "ng.material.Data";
            id: ng.utils.ID | null = null;
            type: ng.material.Mtrl = ng.material.Mtrl.MTRL_UNSPECIFIED;
            // this is a one of
            properties: {type: 'conData'; conData: ng.material.concrete.Data} | {type: 'steelData'; steelData: ng.material.steel.Data} | {type: 'timberData'; timberData: ng.material.timber.Data} | {type: 'soilData'; soilData: ng.material.soil.Data} | {type: 'reinforcementData'; reinforcementData: ng.material.reinforcement.Data} | {type: 'fireSteelData'; fireSteelData: ng.fire_protection.steel.Data} | {type: 'fireTimberData'; fireTimberData: ng.fire_protection.timber.Data} | {type: 'masonryData'; masonryData: ng.material.masonry.Data} | {type: 'customData'; customData: ng.material.custom.Data} | null = null;
            ownerType: ng.utils.Owner = ng.utils.Owner.OWNER_UNSPECIFIED;
            ownerName: string = "";

            /** Gets the `ConData` value (or null) from the oneof `properties` */
            getConData(): ng.material.concrete.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'conData') return null;
                return this.properties.conData;
            }

            /** Sets the `ConData` value for the oneof `properties`*/
            setConData(value: ng.material.concrete.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'conData', conData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `SteelData` value (or null) from the oneof `properties` */
            getSteelData(): ng.material.steel.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'steelData') return null;
                return this.properties.steelData;
            }

            /** Sets the `SteelData` value for the oneof `properties`*/
            setSteelData(value: ng.material.steel.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'steelData', steelData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `TimberData` value (or null) from the oneof `properties` */
            getTimberData(): ng.material.timber.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'timberData') return null;
                return this.properties.timberData;
            }

            /** Sets the `TimberData` value for the oneof `properties`*/
            setTimberData(value: ng.material.timber.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'timberData', timberData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `SoilData` value (or null) from the oneof `properties` */
            getSoilData(): ng.material.soil.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'soilData') return null;
                return this.properties.soilData;
            }

            /** Sets the `SoilData` value for the oneof `properties`*/
            setSoilData(value: ng.material.soil.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'soilData', soilData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `ReinforcementData` value (or null) from the oneof `properties` */
            getReinforcementData(): ng.material.reinforcement.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'reinforcementData') return null;
                return this.properties.reinforcementData;
            }

            /** Sets the `ReinforcementData` value for the oneof `properties`*/
            setReinforcementData(value: ng.material.reinforcement.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'reinforcementData', reinforcementData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `FireSteelData` value (or null) from the oneof `properties` */
            getFireSteelData(): ng.fire_protection.steel.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'fireSteelData') return null;
                return this.properties.fireSteelData;
            }

            /** Sets the `FireSteelData` value for the oneof `properties`*/
            setFireSteelData(value: ng.fire_protection.steel.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'fireSteelData', fireSteelData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `FireTimberData` value (or null) from the oneof `properties` */
            getFireTimberData(): ng.fire_protection.timber.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'fireTimberData') return null;
                return this.properties.fireTimberData;
            }

            /** Sets the `FireTimberData` value for the oneof `properties`*/
            setFireTimberData(value: ng.fire_protection.timber.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'fireTimberData', fireTimberData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `MasonryData` value (or null) from the oneof `properties` */
            getMasonryData(): ng.material.masonry.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'masonryData') return null;
                return this.properties.masonryData;
            }

            /** Sets the `MasonryData` value for the oneof `properties`*/
            setMasonryData(value: ng.material.masonry.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'masonryData', masonryData:value};
                }
                else {
                    this.properties = null;
                }
            }

            /** Gets the `CustomData` value (or null) from the oneof `properties` */
            getCustomData(): ng.material.custom.Data | null {
                if(this.properties === null) return null;
                if(this.properties.type !== 'customData') return null;
                return this.properties.customData;
            }

            /** Sets the `CustomData` value for the oneof `properties`*/
            setCustomData(value: ng.material.custom.Data | null) {
                if(value !== null) {
                    this.properties = {type: 'customData', customData:value};
                }
                else {
                    this.properties = null;
                }
            }

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.material.Mtrl_FromObject(src.type);
                }
                if (src.conData !== undefined && src.conData !== null) {
                    dst.setConData(ng.material.concrete.Data.fromObject(src.conData));
                }
                if (src.steelData !== undefined && src.steelData !== null) {
                    dst.setSteelData(ng.material.steel.Data.fromObject(src.steelData));
                }
                if (src.timberData !== undefined && src.timberData !== null) {
                    dst.setTimberData(ng.material.timber.Data.fromObject(src.timberData));
                }
                if (src.soilData !== undefined && src.soilData !== null) {
                    dst.setSoilData(ng.material.soil.Data.fromObject(src.soilData));
                }
                if (src.reinforcementData !== undefined && src.reinforcementData !== null) {
                    dst.setReinforcementData(ng.material.reinforcement.Data.fromObject(src.reinforcementData));
                }
                if (src.fireSteelData !== undefined && src.fireSteelData !== null) {
                    dst.setFireSteelData(ng.fire_protection.steel.Data.fromObject(src.fireSteelData));
                }
                if (src.fireTimberData !== undefined && src.fireTimberData !== null) {
                    dst.setFireTimberData(ng.fire_protection.timber.Data.fromObject(src.fireTimberData));
                }
                if (src.masonryData !== undefined && src.masonryData !== null) {
                    dst.setMasonryData(ng.material.masonry.Data.fromObject(src.masonryData));
                }
                if (src.customData !== undefined && src.customData !== null) {
                    dst.setCustomData(ng.material.custom.Data.fromObject(src.customData));
                }
                if (src.ownerType !== undefined && src.ownerType !== null) {
                    dst.ownerType = ng.utils.Owner_FromObject(src.ownerType);
                }
                if (src.ownerName !== undefined && src.ownerName !== null) {
                    if (typeof src.ownerName === "string") {
                        dst.ownerName = src.ownerName;
                    }
                    else {
                        console.log('Expected ownerName of Data to be a string but was ', typeof src.ownerName, src.ownerName)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.material.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.material.Data") {
                    console.error('Expected ng.material.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.material.Mtrl_ToObject(src.type);
                if(type_obj === null) return null;

                const ownerType_obj = ng.utils.Owner_ToObject(src.ownerType);
                if(ownerType_obj === null) return null;

                const dst : Data_json = {
                    type: type_obj,
                    ownerType: ownerType_obj,
                    ownerName: src.ownerName,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const conData = src.getConData();
                if(conData !== null)
                {
                    const parsed = ng.material.concrete.Data.toObject(conData);
                    if(parsed === null) return null;
                    dst.conData = parsed;
                }
                const steelData = src.getSteelData();
                if(steelData !== null)
                {
                    const parsed = ng.material.steel.Data.toObject(steelData);
                    if(parsed === null) return null;
                    dst.steelData = parsed;
                }
                const timberData = src.getTimberData();
                if(timberData !== null)
                {
                    const parsed = ng.material.timber.Data.toObject(timberData);
                    if(parsed === null) return null;
                    dst.timberData = parsed;
                }
                const soilData = src.getSoilData();
                if(soilData !== null)
                {
                    const parsed = ng.material.soil.Data.toObject(soilData);
                    if(parsed === null) return null;
                    dst.soilData = parsed;
                }
                const reinforcementData = src.getReinforcementData();
                if(reinforcementData !== null)
                {
                    const parsed = ng.material.reinforcement.Data.toObject(reinforcementData);
                    if(parsed === null) return null;
                    dst.reinforcementData = parsed;
                }
                const fireSteelData = src.getFireSteelData();
                if(fireSteelData !== null)
                {
                    const parsed = ng.fire_protection.steel.Data.toObject(fireSteelData);
                    if(parsed === null) return null;
                    dst.fireSteelData = parsed;
                }
                const fireTimberData = src.getFireTimberData();
                if(fireTimberData !== null)
                {
                    const parsed = ng.fire_protection.timber.Data.toObject(fireTimberData);
                    if(parsed === null) return null;
                    dst.fireTimberData = parsed;
                }
                const masonryData = src.getMasonryData();
                if(masonryData !== null)
                {
                    const parsed = ng.material.masonry.Data.toObject(masonryData);
                    if(parsed === null) return null;
                    dst.masonryData = parsed;
                }
                const customData = src.getCustomData();
                if(customData !== null)
                {
                    const parsed = ng.material.custom.Data.toObject(customData);
                    if(parsed === null) return null;
                    dst.customData = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                // part of the properties oneof 
                if (src.conData !== undefined && src.conData !== null) {
                    dst.setConData(src.conData);
                }
                // part of the properties oneof 
                if (src.steelData !== undefined && src.steelData !== null) {
                    dst.setSteelData(src.steelData);
                }
                // part of the properties oneof 
                if (src.timberData !== undefined && src.timberData !== null) {
                    dst.setTimberData(src.timberData);
                }
                // part of the properties oneof 
                if (src.soilData !== undefined && src.soilData !== null) {
                    dst.setSoilData(src.soilData);
                }
                // part of the properties oneof 
                if (src.reinforcementData !== undefined && src.reinforcementData !== null) {
                    dst.setReinforcementData(src.reinforcementData);
                }
                // part of the properties oneof 
                if (src.fireSteelData !== undefined && src.fireSteelData !== null) {
                    dst.setFireSteelData(src.fireSteelData);
                }
                // part of the properties oneof 
                if (src.fireTimberData !== undefined && src.fireTimberData !== null) {
                    dst.setFireTimberData(src.fireTimberData);
                }
                // part of the properties oneof 
                if (src.masonryData !== undefined && src.masonryData !== null) {
                    dst.setMasonryData(src.masonryData);
                }
                // part of the properties oneof 
                if (src.customData !== undefined && src.customData !== null) {
                    dst.setCustomData(src.customData);
                }
                if (src.ownerType !== undefined) {
                    dst.ownerType = src.ownerType;
                }
                if (src.ownerName !== undefined) {
                    dst.ownerName = src.ownerName;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.type = this.type;
                dst.properties = this.properties;
                dst.ownerType = this.ownerType;
                dst.ownerName = this.ownerName;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;


        // Defined in Material/concrete.proto
        export namespace concrete {
            export enum Type {
                TYPE_UNSPECIFIED = 0,
                TYPE_REGULAR = 1,
                TYPE_LIGHT = 2
            }
            export const Type_FromObject = (src: unknown): Type => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'TYPE_UNSPECIFIED':
                        return Type.TYPE_UNSPECIFIED;
                    case 1:
                    case 'TYPE_REGULAR':
                        return Type.TYPE_REGULAR;
                    case 2:
                    case 'TYPE_LIGHT':
                        return Type.TYPE_LIGHT;
                    default:
                        console.log('Unhandled value for Type:' + src + '. ' + typeof(src));
                        return Type.TYPE_UNSPECIFIED;
                }
            };
            export const Type_ToObject = (src: Type): string | null => {
                switch (src) {
                    case Type.TYPE_UNSPECIFIED:
                        return 'TYPE_UNSPECIFIED';
                    case Type.TYPE_REGULAR:
                        return 'TYPE_REGULAR';
                    case Type.TYPE_LIGHT:
                        return 'TYPE_LIGHT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Type, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum DensityClass {
                DENSITY_CLASS_UNSPECIFIED = 0,
                DENSITY_CLASS_REGULAR = 1,
                DENSITY_CLASS_LIGHT10 = 2,
                DENSITY_CLASS_LIGHT12 = 3,
                DENSITY_CLASS_LIGHT14 = 4,
                DENSITY_CLASS_LIGHT16 = 5,
                DENSITY_CLASS_LIGHT18 = 6,
                DENSITY_CLASS_LIGHT20 = 7
            }
            export const DensityClass_FromObject = (src: unknown): DensityClass => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'DENSITY_CLASS_UNSPECIFIED':
                        return DensityClass.DENSITY_CLASS_UNSPECIFIED;
                    case 1:
                    case 'DENSITY_CLASS_REGULAR':
                        return DensityClass.DENSITY_CLASS_REGULAR;
                    case 2:
                    case 'DENSITY_CLASS_LIGHT10':
                        return DensityClass.DENSITY_CLASS_LIGHT10;
                    case 3:
                    case 'DENSITY_CLASS_LIGHT12':
                        return DensityClass.DENSITY_CLASS_LIGHT12;
                    case 4:
                    case 'DENSITY_CLASS_LIGHT14':
                        return DensityClass.DENSITY_CLASS_LIGHT14;
                    case 5:
                    case 'DENSITY_CLASS_LIGHT16':
                        return DensityClass.DENSITY_CLASS_LIGHT16;
                    case 6:
                    case 'DENSITY_CLASS_LIGHT18':
                        return DensityClass.DENSITY_CLASS_LIGHT18;
                    case 7:
                    case 'DENSITY_CLASS_LIGHT20':
                        return DensityClass.DENSITY_CLASS_LIGHT20;
                    default:
                        console.log('Unhandled value for DensityClass:' + src + '. ' + typeof(src));
                        return DensityClass.DENSITY_CLASS_UNSPECIFIED;
                }
            };
            export const DensityClass_ToObject = (src: DensityClass): string | null => {
                switch (src) {
                    case DensityClass.DENSITY_CLASS_UNSPECIFIED:
                        return 'DENSITY_CLASS_UNSPECIFIED';
                    case DensityClass.DENSITY_CLASS_REGULAR:
                        return 'DENSITY_CLASS_REGULAR';
                    case DensityClass.DENSITY_CLASS_LIGHT10:
                        return 'DENSITY_CLASS_LIGHT10';
                    case DensityClass.DENSITY_CLASS_LIGHT12:
                        return 'DENSITY_CLASS_LIGHT12';
                    case DensityClass.DENSITY_CLASS_LIGHT14:
                        return 'DENSITY_CLASS_LIGHT14';
                    case DensityClass.DENSITY_CLASS_LIGHT16:
                        return 'DENSITY_CLASS_LIGHT16';
                    case DensityClass.DENSITY_CLASS_LIGHT18:
                        return 'DENSITY_CLASS_LIGHT18';
                    case DensityClass.DENSITY_CLASS_LIGHT20:
                        return 'DENSITY_CLASS_LIGHT20';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for DensityClass, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type CharacteristicData_keys = 'compression' | 'compressionCube' | 'compressionMean' | 'tensionMean' | 'tension05' | 'tension95' | 'elasticityModulus' | 'compressiveStrain1' | 'ultimateCompressiveStrain1' | 'compressiveStrain2' | 'ultimateCompressiveStrain2' | 'n' | 'compressiveStrain3' | 'ultimateCompressiveStrain3' | 'poissonsRatio' | 'alpha' | 'density' | 'densityClass';
            export interface CharacteristicData_createType {
                compression?: number,
                compressionCube?: number,
                compressionMean?: number,
                tensionMean?: number,
                tension05?: number,
                tension95?: number,
                elasticityModulus?: number,
                compressiveStrain1?: number,
                ultimateCompressiveStrain1?: number,
                compressiveStrain2?: number,
                ultimateCompressiveStrain2?: number,
                n?: number,
                compressiveStrain3?: number,
                ultimateCompressiveStrain3?: number,
                poissonsRatio?: number,
                alpha?: number,
                density?: number,
                densityClass?: ng.material.concrete.DensityClass,
            }
            export interface CharacteristicData_json {
                compression?: JsonNumber;
                compressionCube?: JsonNumber;
                compressionMean?: JsonNumber;
                tensionMean?: JsonNumber;
                tension05?: JsonNumber;
                tension95?: JsonNumber;
                elasticityModulus?: JsonNumber;
                compressiveStrain1?: JsonNumber;
                ultimateCompressiveStrain1?: JsonNumber;
                compressiveStrain2?: JsonNumber;
                ultimateCompressiveStrain2?: JsonNumber;
                n?: JsonNumber;
                compressiveStrain3?: JsonNumber;
                ultimateCompressiveStrain3?: JsonNumber;
                poissonsRatio?: JsonNumber;
                alpha?: JsonNumber;
                density?: JsonNumber;
                densityClass?: string;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                compression?: unknown;
                compressionCube?: unknown;
                compressionMean?: unknown;
                tensionMean?: unknown;
                tension05?: unknown;
                tension95?: unknown;
                elasticityModulus?: unknown;
                compressiveStrain1?: unknown;
                ultimateCompressiveStrain1?: unknown;
                compressiveStrain2?: unknown;
                ultimateCompressiveStrain2?: unknown;
                n?: unknown;
                compressiveStrain3?: unknown;
                ultimateCompressiveStrain3?: unknown;
                poissonsRatio?: unknown;
                alpha?: unknown;
                density?: unknown;
                densityClass?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.material.concrete.CharacteristicData";
                compression: number = 0;
                compressionCube: number = 0;
                compressionMean: number = 0;
                tensionMean: number = 0;
                tension05: number = 0;
                tension95: number = 0;
                elasticityModulus: number = 0;
                compressiveStrain1: number = 0;
                ultimateCompressiveStrain1: number = 0;
                compressiveStrain2: number = 0;
                ultimateCompressiveStrain2: number = 0;
                n: number = 0;
                compressiveStrain3: number = 0;
                ultimateCompressiveStrain3: number = 0;
                poissonsRatio: number = 0;
                alpha: number = 0;
                density: number = 0;
                densityClass: ng.material.concrete.DensityClass = ng.material.concrete.DensityClass.DENSITY_CLASS_UNSPECIFIED;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.compression !== undefined && src.compression !== null) {
                        if (typeof src.compression === "number" || src.compression === 'NaN' || src.compression === 'Infinity' || src.compression === '-Infinity') {
                            dst.compression = AsNum(src.compression);
                        }
                        else {
                            console.log('Expected compression of CharacteristicData to be a number but was ', typeof src.compression, src.compression)
                        }
                    }
                    if (src.compressionCube !== undefined && src.compressionCube !== null) {
                        if (typeof src.compressionCube === "number" || src.compressionCube === 'NaN' || src.compressionCube === 'Infinity' || src.compressionCube === '-Infinity') {
                            dst.compressionCube = AsNum(src.compressionCube);
                        }
                        else {
                            console.log('Expected compressionCube of CharacteristicData to be a number but was ', typeof src.compressionCube, src.compressionCube)
                        }
                    }
                    if (src.compressionMean !== undefined && src.compressionMean !== null) {
                        if (typeof src.compressionMean === "number" || src.compressionMean === 'NaN' || src.compressionMean === 'Infinity' || src.compressionMean === '-Infinity') {
                            dst.compressionMean = AsNum(src.compressionMean);
                        }
                        else {
                            console.log('Expected compressionMean of CharacteristicData to be a number but was ', typeof src.compressionMean, src.compressionMean)
                        }
                    }
                    if (src.tensionMean !== undefined && src.tensionMean !== null) {
                        if (typeof src.tensionMean === "number" || src.tensionMean === 'NaN' || src.tensionMean === 'Infinity' || src.tensionMean === '-Infinity') {
                            dst.tensionMean = AsNum(src.tensionMean);
                        }
                        else {
                            console.log('Expected tensionMean of CharacteristicData to be a number but was ', typeof src.tensionMean, src.tensionMean)
                        }
                    }
                    if (src.tension05 !== undefined && src.tension05 !== null) {
                        if (typeof src.tension05 === "number" || src.tension05 === 'NaN' || src.tension05 === 'Infinity' || src.tension05 === '-Infinity') {
                            dst.tension05 = AsNum(src.tension05);
                        }
                        else {
                            console.log('Expected tension05 of CharacteristicData to be a number but was ', typeof src.tension05, src.tension05)
                        }
                    }
                    if (src.tension95 !== undefined && src.tension95 !== null) {
                        if (typeof src.tension95 === "number" || src.tension95 === 'NaN' || src.tension95 === 'Infinity' || src.tension95 === '-Infinity') {
                            dst.tension95 = AsNum(src.tension95);
                        }
                        else {
                            console.log('Expected tension95 of CharacteristicData to be a number but was ', typeof src.tension95, src.tension95)
                        }
                    }
                    if (src.elasticityModulus !== undefined && src.elasticityModulus !== null) {
                        if (typeof src.elasticityModulus === "number" || src.elasticityModulus === 'NaN' || src.elasticityModulus === 'Infinity' || src.elasticityModulus === '-Infinity') {
                            dst.elasticityModulus = AsNum(src.elasticityModulus);
                        }
                        else {
                            console.log('Expected elasticityModulus of CharacteristicData to be a number but was ', typeof src.elasticityModulus, src.elasticityModulus)
                        }
                    }
                    if (src.compressiveStrain1 !== undefined && src.compressiveStrain1 !== null) {
                        if (typeof src.compressiveStrain1 === "number" || src.compressiveStrain1 === 'NaN' || src.compressiveStrain1 === 'Infinity' || src.compressiveStrain1 === '-Infinity') {
                            dst.compressiveStrain1 = AsNum(src.compressiveStrain1);
                        }
                        else {
                            console.log('Expected compressiveStrain1 of CharacteristicData to be a number but was ', typeof src.compressiveStrain1, src.compressiveStrain1)
                        }
                    }
                    if (src.ultimateCompressiveStrain1 !== undefined && src.ultimateCompressiveStrain1 !== null) {
                        if (typeof src.ultimateCompressiveStrain1 === "number" || src.ultimateCompressiveStrain1 === 'NaN' || src.ultimateCompressiveStrain1 === 'Infinity' || src.ultimateCompressiveStrain1 === '-Infinity') {
                            dst.ultimateCompressiveStrain1 = AsNum(src.ultimateCompressiveStrain1);
                        }
                        else {
                            console.log('Expected ultimateCompressiveStrain1 of CharacteristicData to be a number but was ', typeof src.ultimateCompressiveStrain1, src.ultimateCompressiveStrain1)
                        }
                    }
                    if (src.compressiveStrain2 !== undefined && src.compressiveStrain2 !== null) {
                        if (typeof src.compressiveStrain2 === "number" || src.compressiveStrain2 === 'NaN' || src.compressiveStrain2 === 'Infinity' || src.compressiveStrain2 === '-Infinity') {
                            dst.compressiveStrain2 = AsNum(src.compressiveStrain2);
                        }
                        else {
                            console.log('Expected compressiveStrain2 of CharacteristicData to be a number but was ', typeof src.compressiveStrain2, src.compressiveStrain2)
                        }
                    }
                    if (src.ultimateCompressiveStrain2 !== undefined && src.ultimateCompressiveStrain2 !== null) {
                        if (typeof src.ultimateCompressiveStrain2 === "number" || src.ultimateCompressiveStrain2 === 'NaN' || src.ultimateCompressiveStrain2 === 'Infinity' || src.ultimateCompressiveStrain2 === '-Infinity') {
                            dst.ultimateCompressiveStrain2 = AsNum(src.ultimateCompressiveStrain2);
                        }
                        else {
                            console.log('Expected ultimateCompressiveStrain2 of CharacteristicData to be a number but was ', typeof src.ultimateCompressiveStrain2, src.ultimateCompressiveStrain2)
                        }
                    }
                    if (src.n !== undefined && src.n !== null) {
                        if (typeof src.n === "number" || src.n === 'NaN' || src.n === 'Infinity' || src.n === '-Infinity') {
                            dst.n = AsNum(src.n);
                        }
                        else {
                            console.log('Expected n of CharacteristicData to be a number but was ', typeof src.n, src.n)
                        }
                    }
                    if (src.compressiveStrain3 !== undefined && src.compressiveStrain3 !== null) {
                        if (typeof src.compressiveStrain3 === "number" || src.compressiveStrain3 === 'NaN' || src.compressiveStrain3 === 'Infinity' || src.compressiveStrain3 === '-Infinity') {
                            dst.compressiveStrain3 = AsNum(src.compressiveStrain3);
                        }
                        else {
                            console.log('Expected compressiveStrain3 of CharacteristicData to be a number but was ', typeof src.compressiveStrain3, src.compressiveStrain3)
                        }
                    }
                    if (src.ultimateCompressiveStrain3 !== undefined && src.ultimateCompressiveStrain3 !== null) {
                        if (typeof src.ultimateCompressiveStrain3 === "number" || src.ultimateCompressiveStrain3 === 'NaN' || src.ultimateCompressiveStrain3 === 'Infinity' || src.ultimateCompressiveStrain3 === '-Infinity') {
                            dst.ultimateCompressiveStrain3 = AsNum(src.ultimateCompressiveStrain3);
                        }
                        else {
                            console.log('Expected ultimateCompressiveStrain3 of CharacteristicData to be a number but was ', typeof src.ultimateCompressiveStrain3, src.ultimateCompressiveStrain3)
                        }
                    }
                    if (src.poissonsRatio !== undefined && src.poissonsRatio !== null) {
                        if (typeof src.poissonsRatio === "number" || src.poissonsRatio === 'NaN' || src.poissonsRatio === 'Infinity' || src.poissonsRatio === '-Infinity') {
                            dst.poissonsRatio = AsNum(src.poissonsRatio);
                        }
                        else {
                            console.log('Expected poissonsRatio of CharacteristicData to be a number but was ', typeof src.poissonsRatio, src.poissonsRatio)
                        }
                    }
                    if (src.alpha !== undefined && src.alpha !== null) {
                        if (typeof src.alpha === "number" || src.alpha === 'NaN' || src.alpha === 'Infinity' || src.alpha === '-Infinity') {
                            dst.alpha = AsNum(src.alpha);
                        }
                        else {
                            console.log('Expected alpha of CharacteristicData to be a number but was ', typeof src.alpha, src.alpha)
                        }
                    }
                    if (src.density !== undefined && src.density !== null) {
                        if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                            dst.density = AsNum(src.density);
                        }
                        else {
                            console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                        }
                    }
                    if (src.densityClass !== undefined && src.densityClass !== null) {
                        dst.densityClass = ng.material.concrete.DensityClass_FromObject(src.densityClass);
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.concrete.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.concrete.CharacteristicData") {
                        console.error('Expected ng.material.concrete.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const densityClass_obj = ng.material.concrete.DensityClass_ToObject(src.densityClass);
                    if(densityClass_obj === null) return null;

                    const dst : CharacteristicData_json = {
                        compression: AsJsonNum(src.compression),
                        compressionCube: AsJsonNum(src.compressionCube),
                        compressionMean: AsJsonNum(src.compressionMean),
                        tensionMean: AsJsonNum(src.tensionMean),
                        tension05: AsJsonNum(src.tension05),
                        tension95: AsJsonNum(src.tension95),
                        elasticityModulus: AsJsonNum(src.elasticityModulus),
                        compressiveStrain1: AsJsonNum(src.compressiveStrain1),
                        ultimateCompressiveStrain1: AsJsonNum(src.ultimateCompressiveStrain1),
                        compressiveStrain2: AsJsonNum(src.compressiveStrain2),
                        ultimateCompressiveStrain2: AsJsonNum(src.ultimateCompressiveStrain2),
                        n: AsJsonNum(src.n),
                        compressiveStrain3: AsJsonNum(src.compressiveStrain3),
                        ultimateCompressiveStrain3: AsJsonNum(src.ultimateCompressiveStrain3),
                        poissonsRatio: AsJsonNum(src.poissonsRatio),
                        alpha: AsJsonNum(src.alpha),
                        density: AsJsonNum(src.density),
                        densityClass: densityClass_obj,
                    };
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.compression !== undefined) {
                        dst.compression = src.compression;
                    }
                    if (src.compressionCube !== undefined) {
                        dst.compressionCube = src.compressionCube;
                    }
                    if (src.compressionMean !== undefined) {
                        dst.compressionMean = src.compressionMean;
                    }
                    if (src.tensionMean !== undefined) {
                        dst.tensionMean = src.tensionMean;
                    }
                    if (src.tension05 !== undefined) {
                        dst.tension05 = src.tension05;
                    }
                    if (src.tension95 !== undefined) {
                        dst.tension95 = src.tension95;
                    }
                    if (src.elasticityModulus !== undefined) {
                        dst.elasticityModulus = src.elasticityModulus;
                    }
                    if (src.compressiveStrain1 !== undefined) {
                        dst.compressiveStrain1 = src.compressiveStrain1;
                    }
                    if (src.ultimateCompressiveStrain1 !== undefined) {
                        dst.ultimateCompressiveStrain1 = src.ultimateCompressiveStrain1;
                    }
                    if (src.compressiveStrain2 !== undefined) {
                        dst.compressiveStrain2 = src.compressiveStrain2;
                    }
                    if (src.ultimateCompressiveStrain2 !== undefined) {
                        dst.ultimateCompressiveStrain2 = src.ultimateCompressiveStrain2;
                    }
                    if (src.n !== undefined) {
                        dst.n = src.n;
                    }
                    if (src.compressiveStrain3 !== undefined) {
                        dst.compressiveStrain3 = src.compressiveStrain3;
                    }
                    if (src.ultimateCompressiveStrain3 !== undefined) {
                        dst.ultimateCompressiveStrain3 = src.ultimateCompressiveStrain3;
                    }
                    if (src.poissonsRatio !== undefined) {
                        dst.poissonsRatio = src.poissonsRatio;
                    }
                    if (src.alpha !== undefined) {
                        dst.alpha = src.alpha;
                    }
                    if (src.density !== undefined) {
                        dst.density = src.density;
                    }
                    if (src.densityClass !== undefined) {
                        dst.densityClass = src.densityClass;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.compression = this.compression;
                    dst.compressionCube = this.compressionCube;
                    dst.compressionMean = this.compressionMean;
                    dst.tensionMean = this.tensionMean;
                    dst.tension05 = this.tension05;
                    dst.tension95 = this.tension95;
                    dst.elasticityModulus = this.elasticityModulus;
                    dst.compressiveStrain1 = this.compressiveStrain1;
                    dst.ultimateCompressiveStrain1 = this.ultimateCompressiveStrain1;
                    dst.compressiveStrain2 = this.compressiveStrain2;
                    dst.ultimateCompressiveStrain2 = this.ultimateCompressiveStrain2;
                    dst.n = this.n;
                    dst.compressiveStrain3 = this.compressiveStrain3;
                    dst.ultimateCompressiveStrain3 = this.ultimateCompressiveStrain3;
                    dst.poissonsRatio = this.poissonsRatio;
                    dst.alpha = this.alpha;
                    dst.density = this.density;
                    dst.densityClass = this.densityClass;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type Data_keys = 'id' | 'type' | 'properties';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                type?: ng.material.concrete.Type,
                properties?: ng.material.concrete.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                type?: string;
                properties?: ng.material.concrete.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                type?: unknown;
                properties?: unknown;
            }
            export class Data {
                __proto_name = "ng.material.concrete.Data";
                id: ng.utils.ID | null = null;
                type: ng.material.concrete.Type = ng.material.concrete.Type.TYPE_UNSPECIFIED;
                properties: ng.material.concrete.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.type !== undefined && src.type !== null) {
                        dst.type = ng.material.concrete.Type_FromObject(src.type);
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.material.concrete.CharacteristicData.fromObject(src.properties);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.concrete.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.concrete.Data") {
                        console.error('Expected ng.material.concrete.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const type_obj = ng.material.concrete.Type_ToObject(src.type);
                    if(type_obj === null) return null;

                    const dst : Data_json = {
                        type: type_obj,
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.material.concrete.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.type !== undefined) {
                        dst.type = src.type;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.type = this.type;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace concrete


        // Defined in Material/steel.proto
        export namespace steel {
            export enum Product {
                PRODUCT_UNSPECIFIED = 0,
                PRODUCT_PLAIN = 1,
                PRODUCT_REINFORCEMENT = 2
            }
            export const Product_FromObject = (src: unknown): Product => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRODUCT_UNSPECIFIED':
                        return Product.PRODUCT_UNSPECIFIED;
                    case 1:
                    case 'PRODUCT_PLAIN':
                        return Product.PRODUCT_PLAIN;
                    case 2:
                    case 'PRODUCT_REINFORCEMENT':
                        return Product.PRODUCT_REINFORCEMENT;
                    default:
                        console.log('Unhandled value for Product:' + src + '. ' + typeof(src));
                        return Product.PRODUCT_UNSPECIFIED;
                }
            };
            export const Product_ToObject = (src: Product): string | null => {
                switch (src) {
                    case Product.PRODUCT_UNSPECIFIED:
                        return 'PRODUCT_UNSPECIFIED';
                    case Product.PRODUCT_PLAIN:
                        return 'PRODUCT_PLAIN';
                    case Product.PRODUCT_REINFORCEMENT:
                        return 'PRODUCT_REINFORCEMENT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Product, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Sort {
                SORT_UNSPECIFIED = 0,
                SORT_REGULAR = 1,
                SORT_STAINLESS = 2
            }
            export const Sort_FromObject = (src: unknown): Sort => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SORT_UNSPECIFIED':
                        return Sort.SORT_UNSPECIFIED;
                    case 1:
                    case 'SORT_REGULAR':
                        return Sort.SORT_REGULAR;
                    case 2:
                    case 'SORT_STAINLESS':
                        return Sort.SORT_STAINLESS;
                    default:
                        console.log('Unhandled value for Sort:' + src + '. ' + typeof(src));
                        return Sort.SORT_UNSPECIFIED;
                }
            };
            export const Sort_ToObject = (src: Sort): string | null => {
                switch (src) {
                    case Sort.SORT_UNSPECIFIED:
                        return 'SORT_UNSPECIFIED';
                    case Sort.SORT_REGULAR:
                        return 'SORT_REGULAR';
                    case Sort.SORT_STAINLESS:
                        return 'SORT_STAINLESS';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Sort, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ProductionType {
                PRODUCTION_TYPE_UNSPECIFIED = 0,
                PRODUCTION_TYPE_ROLLED = 1,
                PRODUCTION_TYPE_COLD_WORKED = 2,
                PRODUCTION_TYPE_WELDED = 3
            }
            export const ProductionType_FromObject = (src: unknown): ProductionType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRODUCTION_TYPE_UNSPECIFIED':
                        return ProductionType.PRODUCTION_TYPE_UNSPECIFIED;
                    case 1:
                    case 'PRODUCTION_TYPE_ROLLED':
                        return ProductionType.PRODUCTION_TYPE_ROLLED;
                    case 2:
                    case 'PRODUCTION_TYPE_COLD_WORKED':
                        return ProductionType.PRODUCTION_TYPE_COLD_WORKED;
                    case 3:
                    case 'PRODUCTION_TYPE_WELDED':
                        return ProductionType.PRODUCTION_TYPE_WELDED;
                    default:
                        console.log('Unhandled value for ProductionType:' + src + '. ' + typeof(src));
                        return ProductionType.PRODUCTION_TYPE_UNSPECIFIED;
                }
            };
            export const ProductionType_ToObject = (src: ProductionType): string | null => {
                switch (src) {
                    case ProductionType.PRODUCTION_TYPE_UNSPECIFIED:
                        return 'PRODUCTION_TYPE_UNSPECIFIED';
                    case ProductionType.PRODUCTION_TYPE_ROLLED:
                        return 'PRODUCTION_TYPE_ROLLED';
                    case ProductionType.PRODUCTION_TYPE_COLD_WORKED:
                        return 'PRODUCTION_TYPE_COLD_WORKED';
                    case ProductionType.PRODUCTION_TYPE_WELDED:
                        return 'PRODUCTION_TYPE_WELDED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ProductionType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum DuctilityClass {
                DUCTILITY_CLASS_UNSPECIFIED = 0,
                DUCTILITY_CLASS_A = 1,
                DUCTILITY_CLASS_B = 2,
                DUCTILITY_CLASS_C = 3
            }
            export const DuctilityClass_FromObject = (src: unknown): DuctilityClass => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'DUCTILITY_CLASS_UNSPECIFIED':
                        return DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED;
                    case 1:
                    case 'DUCTILITY_CLASS_A':
                        return DuctilityClass.DUCTILITY_CLASS_A;
                    case 2:
                    case 'DUCTILITY_CLASS_B':
                        return DuctilityClass.DUCTILITY_CLASS_B;
                    case 3:
                    case 'DUCTILITY_CLASS_C':
                        return DuctilityClass.DUCTILITY_CLASS_C;
                    default:
                        console.log('Unhandled value for DuctilityClass:' + src + '. ' + typeof(src));
                        return DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED;
                }
            };
            export const DuctilityClass_ToObject = (src: DuctilityClass): string | null => {
                switch (src) {
                    case DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED:
                        return 'DUCTILITY_CLASS_UNSPECIFIED';
                    case DuctilityClass.DUCTILITY_CLASS_A:
                        return 'DUCTILITY_CLASS_A';
                    case DuctilityClass.DUCTILITY_CLASS_B:
                        return 'DUCTILITY_CLASS_B';
                    case DuctilityClass.DUCTILITY_CLASS_C:
                        return 'DUCTILITY_CLASS_C';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for DuctilityClass, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type Type_keys = 'sort' | 'production' | 'product';
            export interface Type_createType {
                sort?: ng.material.steel.Sort,
                production?: ng.material.steel.ProductionType,
                product?: ng.material.steel.Product,
            }
            export interface Type_json {
                sort?: string;
                production?: string;
                product?: string;
            }
            interface Type_json_in {
                __proto_name?: unknown;
                sort?: unknown;
                production?: unknown;
                product?: unknown;
            }
            export class Type {
                __proto_name = "ng.material.steel.Type";
                sort: ng.material.steel.Sort = ng.material.steel.Sort.SORT_UNSPECIFIED;
                production: ng.material.steel.ProductionType = ng.material.steel.ProductionType.PRODUCTION_TYPE_UNSPECIFIED;
                product: ng.material.steel.Product = ng.material.steel.Product.PRODUCT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): Type {
                    const dst = new Type();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Type but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Type_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Type but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sort !== undefined && src.sort !== null) {
                        dst.sort = ng.material.steel.Sort_FromObject(src.sort);
                    }
                    if (src.production !== undefined && src.production !== null) {
                        dst.production = ng.material.steel.ProductionType_FromObject(src.production);
                    }
                    if (src.product !== undefined && src.product !== null) {
                        dst.product = ng.material.steel.Product_FromObject(src.product);
                    }
                    return dst;
                }

                static toObject(src: Type | null | undefined): Type_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.steel.Type is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.steel.Type") {
                        console.error('Expected ng.material.steel.Type but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const sort_obj = ng.material.steel.Sort_ToObject(src.sort);
                    if(sort_obj === null) return null;

                    const production_obj = ng.material.steel.ProductionType_ToObject(src.production);
                    if(production_obj === null) return null;

                    const product_obj = ng.material.steel.Product_ToObject(src.product);
                    if(product_obj === null) return null;

                    const dst : Type_json = {
                        sort: sort_obj,
                        production: production_obj,
                        product: product_obj,
                    };
                    return dst;
                }

                static create(src?: Type_createType) {
                    const dst = new Type();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sort !== undefined) {
                        dst.sort = src.sort;
                    }
                    if (src.production !== undefined) {
                        dst.production = src.production;
                    }
                    if (src.product !== undefined) {
                        dst.product = src.product;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Type();
                    dst.sort = this.sort;
                    dst.production = this.production;
                    dst.product = this.product;
                    return dst;
                }

                deepClone() {
                    const json = Type.toObject(this);
                    const dst = Type.fromObject(json);
                    return dst;
                }
            }
            export type IType = Type;


            export type CharacteristicData_keys = 'elasticityModulus' | 'shearModulus' | 'yieldStrain' | 'ultimateStrain' | 'failureStrain' | 'poissonsRatio' | 'density' | 'alpha' | 'k' | 'yieldStrengths' | 'ultimateTensileStrengths' | 'hardeningStrain' | 'c1' | 'c2';
            export interface CharacteristicData_createType {
                elasticityModulus?: number,
                shearModulus?: number,
                yieldStrain?: number,
                ultimateStrain?: number,
                failureStrain?: number,
                poissonsRatio?: number,
                density?: number,
                alpha?: number,
                k?: number,
                yieldStrengths?: ng.material.steel.StrengthValue[],
                ultimateTensileStrengths?: ng.material.steel.StrengthValue[],
                hardeningStrain?: number,
                c1?: number,
                c2?: number,
            }
            export interface CharacteristicData_json {
                elasticityModulus?: JsonNumber;
                shearModulus?: JsonNumber;
                yieldStrain?: JsonNumber;
                ultimateStrain?: JsonNumber;
                failureStrain?: JsonNumber;
                poissonsRatio?: JsonNumber;
                density?: JsonNumber;
                alpha?: JsonNumber;
                k?: JsonNumber;
                yieldStrengths: ng.material.steel.StrengthValue_json[];
                ultimateTensileStrengths: ng.material.steel.StrengthValue_json[];
                hardeningStrain?: JsonNumber;
                c1?: JsonNumber;
                c2?: JsonNumber;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                elasticityModulus?: unknown;
                shearModulus?: unknown;
                yieldStrain?: unknown;
                ultimateStrain?: unknown;
                failureStrain?: unknown;
                poissonsRatio?: unknown;
                density?: unknown;
                alpha?: unknown;
                k?: unknown;
                yieldStrengths?: unknown;
                ultimateTensileStrengths?: unknown;
                hardeningStrain?: unknown;
                c1?: unknown;
                c2?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.material.steel.CharacteristicData";
                elasticityModulus: number = 0;
                shearModulus: number = 0;
                yieldStrain: number = 0;
                ultimateStrain: number = 0;
                failureStrain: number = 0;
                poissonsRatio: number = 0;
                density: number = 0;
                alpha: number = 0;
                k: number = 0;
                yieldStrengths: ng.material.steel.StrengthValue[] = [];
                ultimateTensileStrengths: ng.material.steel.StrengthValue[] = [];
                hardeningStrain: number = 0;
                c1: number = 0;
                c2: number = 0;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elasticityModulus !== undefined && src.elasticityModulus !== null) {
                        if (typeof src.elasticityModulus === "number" || src.elasticityModulus === 'NaN' || src.elasticityModulus === 'Infinity' || src.elasticityModulus === '-Infinity') {
                            dst.elasticityModulus = AsNum(src.elasticityModulus);
                        }
                        else {
                            console.log('Expected elasticityModulus of CharacteristicData to be a number but was ', typeof src.elasticityModulus, src.elasticityModulus)
                        }
                    }
                    if (src.shearModulus !== undefined && src.shearModulus !== null) {
                        if (typeof src.shearModulus === "number" || src.shearModulus === 'NaN' || src.shearModulus === 'Infinity' || src.shearModulus === '-Infinity') {
                            dst.shearModulus = AsNum(src.shearModulus);
                        }
                        else {
                            console.log('Expected shearModulus of CharacteristicData to be a number but was ', typeof src.shearModulus, src.shearModulus)
                        }
                    }
                    if (src.yieldStrain !== undefined && src.yieldStrain !== null) {
                        if (typeof src.yieldStrain === "number" || src.yieldStrain === 'NaN' || src.yieldStrain === 'Infinity' || src.yieldStrain === '-Infinity') {
                            dst.yieldStrain = AsNum(src.yieldStrain);
                        }
                        else {
                            console.log('Expected yieldStrain of CharacteristicData to be a number but was ', typeof src.yieldStrain, src.yieldStrain)
                        }
                    }
                    if (src.ultimateStrain !== undefined && src.ultimateStrain !== null) {
                        if (typeof src.ultimateStrain === "number" || src.ultimateStrain === 'NaN' || src.ultimateStrain === 'Infinity' || src.ultimateStrain === '-Infinity') {
                            dst.ultimateStrain = AsNum(src.ultimateStrain);
                        }
                        else {
                            console.log('Expected ultimateStrain of CharacteristicData to be a number but was ', typeof src.ultimateStrain, src.ultimateStrain)
                        }
                    }
                    if (src.failureStrain !== undefined && src.failureStrain !== null) {
                        if (typeof src.failureStrain === "number" || src.failureStrain === 'NaN' || src.failureStrain === 'Infinity' || src.failureStrain === '-Infinity') {
                            dst.failureStrain = AsNum(src.failureStrain);
                        }
                        else {
                            console.log('Expected failureStrain of CharacteristicData to be a number but was ', typeof src.failureStrain, src.failureStrain)
                        }
                    }
                    if (src.poissonsRatio !== undefined && src.poissonsRatio !== null) {
                        if (typeof src.poissonsRatio === "number" || src.poissonsRatio === 'NaN' || src.poissonsRatio === 'Infinity' || src.poissonsRatio === '-Infinity') {
                            dst.poissonsRatio = AsNum(src.poissonsRatio);
                        }
                        else {
                            console.log('Expected poissonsRatio of CharacteristicData to be a number but was ', typeof src.poissonsRatio, src.poissonsRatio)
                        }
                    }
                    if (src.density !== undefined && src.density !== null) {
                        if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                            dst.density = AsNum(src.density);
                        }
                        else {
                            console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                        }
                    }
                    if (src.alpha !== undefined && src.alpha !== null) {
                        if (typeof src.alpha === "number" || src.alpha === 'NaN' || src.alpha === 'Infinity' || src.alpha === '-Infinity') {
                            dst.alpha = AsNum(src.alpha);
                        }
                        else {
                            console.log('Expected alpha of CharacteristicData to be a number but was ', typeof src.alpha, src.alpha)
                        }
                    }
                    if (src.k !== undefined && src.k !== null) {
                        if (typeof src.k === "number" || src.k === 'NaN' || src.k === 'Infinity' || src.k === '-Infinity') {
                            dst.k = AsNum(src.k);
                        }
                        else {
                            console.log('Expected k of CharacteristicData to be a number but was ', typeof src.k, src.k)
                        }
                    }
                    if (src.yieldStrengths !== undefined && src.yieldStrengths !== null) {
                        if (Array.isArray(src.yieldStrengths)) {
                            for (const element of src.yieldStrengths) {
                                dst.yieldStrengths.push(ng.material.steel.StrengthValue.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected yieldStrengths of CharacteristicData to be a array but was ', typeof src.yieldStrengths, src.yieldStrengths)
                        }
                    }
                    if (src.ultimateTensileStrengths !== undefined && src.ultimateTensileStrengths !== null) {
                        if (Array.isArray(src.ultimateTensileStrengths)) {
                            for (const element of src.ultimateTensileStrengths) {
                                dst.ultimateTensileStrengths.push(ng.material.steel.StrengthValue.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected ultimateTensileStrengths of CharacteristicData to be a array but was ', typeof src.ultimateTensileStrengths, src.ultimateTensileStrengths)
                        }
                    }
                    if (src.hardeningStrain !== undefined && src.hardeningStrain !== null) {
                        if (typeof src.hardeningStrain === "number" || src.hardeningStrain === 'NaN' || src.hardeningStrain === 'Infinity' || src.hardeningStrain === '-Infinity') {
                            dst.hardeningStrain = AsNum(src.hardeningStrain);
                        }
                        else {
                            console.log('Expected hardeningStrain of CharacteristicData to be a number but was ', typeof src.hardeningStrain, src.hardeningStrain)
                        }
                    }
                    if (src.c1 !== undefined && src.c1 !== null) {
                        if (typeof src.c1 === "number" || src.c1 === 'NaN' || src.c1 === 'Infinity' || src.c1 === '-Infinity') {
                            dst.c1 = AsNum(src.c1);
                        }
                        else {
                            console.log('Expected c1 of CharacteristicData to be a number but was ', typeof src.c1, src.c1)
                        }
                    }
                    if (src.c2 !== undefined && src.c2 !== null) {
                        if (typeof src.c2 === "number" || src.c2 === 'NaN' || src.c2 === 'Infinity' || src.c2 === '-Infinity') {
                            dst.c2 = AsNum(src.c2);
                        }
                        else {
                            console.log('Expected c2 of CharacteristicData to be a number but was ', typeof src.c2, src.c2)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.steel.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.steel.CharacteristicData") {
                        console.error('Expected ng.material.steel.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CharacteristicData_json = {
                        elasticityModulus: AsJsonNum(src.elasticityModulus),
                        shearModulus: AsJsonNum(src.shearModulus),
                        yieldStrain: AsJsonNum(src.yieldStrain),
                        ultimateStrain: AsJsonNum(src.ultimateStrain),
                        failureStrain: AsJsonNum(src.failureStrain),
                        poissonsRatio: AsJsonNum(src.poissonsRatio),
                        density: AsJsonNum(src.density),
                        alpha: AsJsonNum(src.alpha),
                        k: AsJsonNum(src.k),
                        yieldStrengths: new Array<ng.material.steel.StrengthValue_json>(),
                        ultimateTensileStrengths: new Array<ng.material.steel.StrengthValue_json>(),
                        hardeningStrain: AsJsonNum(src.hardeningStrain),
                        c1: AsJsonNum(src.c1),
                        c2: AsJsonNum(src.c2),
                    };
                    if (src.yieldStrengths !== null) {
                        for (const element of src.yieldStrengths) {
                            const parsed = ng.material.steel.StrengthValue.toObject(element);
                            if(parsed === null) return null;
                            dst.yieldStrengths.push(parsed);
                        }
                    }
                    if (src.ultimateTensileStrengths !== null) {
                        for (const element of src.ultimateTensileStrengths) {
                            const parsed = ng.material.steel.StrengthValue.toObject(element);
                            if(parsed === null) return null;
                            dst.ultimateTensileStrengths.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elasticityModulus !== undefined) {
                        dst.elasticityModulus = src.elasticityModulus;
                    }
                    if (src.shearModulus !== undefined) {
                        dst.shearModulus = src.shearModulus;
                    }
                    if (src.yieldStrain !== undefined) {
                        dst.yieldStrain = src.yieldStrain;
                    }
                    if (src.ultimateStrain !== undefined) {
                        dst.ultimateStrain = src.ultimateStrain;
                    }
                    if (src.failureStrain !== undefined) {
                        dst.failureStrain = src.failureStrain;
                    }
                    if (src.poissonsRatio !== undefined) {
                        dst.poissonsRatio = src.poissonsRatio;
                    }
                    if (src.density !== undefined) {
                        dst.density = src.density;
                    }
                    if (src.alpha !== undefined) {
                        dst.alpha = src.alpha;
                    }
                    if (src.k !== undefined) {
                        dst.k = src.k;
                    }
                    if (src.yieldStrengths !== undefined) {
                        dst.yieldStrengths = src.yieldStrengths;
                    }
                    if (src.ultimateTensileStrengths !== undefined) {
                        dst.ultimateTensileStrengths = src.ultimateTensileStrengths;
                    }
                    if (src.hardeningStrain !== undefined) {
                        dst.hardeningStrain = src.hardeningStrain;
                    }
                    if (src.c1 !== undefined) {
                        dst.c1 = src.c1;
                    }
                    if (src.c2 !== undefined) {
                        dst.c2 = src.c2;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.elasticityModulus = this.elasticityModulus;
                    dst.shearModulus = this.shearModulus;
                    dst.yieldStrain = this.yieldStrain;
                    dst.ultimateStrain = this.ultimateStrain;
                    dst.failureStrain = this.failureStrain;
                    dst.poissonsRatio = this.poissonsRatio;
                    dst.density = this.density;
                    dst.alpha = this.alpha;
                    dst.k = this.k;
                    dst.yieldStrengths = this.yieldStrengths;
                    dst.ultimateTensileStrengths = this.ultimateTensileStrengths;
                    dst.hardeningStrain = this.hardeningStrain;
                    dst.c1 = this.c1;
                    dst.c2 = this.c2;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type StrengthValue_keys = 'thickness' | 'strength';
            export interface StrengthValue_createType {
                thickness?: number,
                strength?: number,
            }
            export interface StrengthValue_json {
                thickness?: JsonNumber;
                strength?: JsonNumber;
            }
            interface StrengthValue_json_in {
                __proto_name?: unknown;
                thickness?: unknown;
                strength?: unknown;
            }
            export class StrengthValue {
                __proto_name = "ng.material.steel.StrengthValue";
                thickness: number = 0;
                strength: number = 0;

                static fromObject(src_unknown: unknown): StrengthValue {
                    const dst = new StrengthValue();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StrengthValue but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StrengthValue_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StrengthValue but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.thickness !== undefined && src.thickness !== null) {
                        if (typeof src.thickness === "number" || src.thickness === 'NaN' || src.thickness === 'Infinity' || src.thickness === '-Infinity') {
                            dst.thickness = AsNum(src.thickness);
                        }
                        else {
                            console.log('Expected thickness of StrengthValue to be a number but was ', typeof src.thickness, src.thickness)
                        }
                    }
                    if (src.strength !== undefined && src.strength !== null) {
                        if (typeof src.strength === "number" || src.strength === 'NaN' || src.strength === 'Infinity' || src.strength === '-Infinity') {
                            dst.strength = AsNum(src.strength);
                        }
                        else {
                            console.log('Expected strength of StrengthValue to be a number but was ', typeof src.strength, src.strength)
                        }
                    }
                    return dst;
                }

                static toObject(src: StrengthValue | null | undefined): StrengthValue_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.steel.StrengthValue is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.steel.StrengthValue") {
                        console.error('Expected ng.material.steel.StrengthValue but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : StrengthValue_json = {
                        thickness: AsJsonNum(src.thickness),
                        strength: AsJsonNum(src.strength),
                    };
                    return dst;
                }

                static create(src?: StrengthValue_createType) {
                    const dst = new StrengthValue();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.thickness !== undefined) {
                        dst.thickness = src.thickness;
                    }
                    if (src.strength !== undefined) {
                        dst.strength = src.strength;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StrengthValue();
                    dst.thickness = this.thickness;
                    dst.strength = this.strength;
                    return dst;
                }

                deepClone() {
                    const json = StrengthValue.toObject(this);
                    const dst = StrengthValue.fromObject(json);
                    return dst;
                }
            }
            export type IStrengthValue = StrengthValue;


            export type Data_keys = 'id' | 'type' | 'class' | 'properties';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                type?: ng.material.steel.Type | null,
                class?: ng.material.steel.DuctilityClass,
                properties?: ng.material.steel.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                type?: ng.material.steel.Type_json;
                class?: string;
                properties?: ng.material.steel.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                type?: unknown;
                class?: unknown;
                properties?: unknown;
            }
            export class Data {
                __proto_name = "ng.material.steel.Data";
                id: ng.utils.ID | null = null;
                type: ng.material.steel.Type | null = null;
                class: ng.material.steel.DuctilityClass = ng.material.steel.DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED;
                properties: ng.material.steel.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.type !== undefined && src.type !== null) {
                        dst.type = ng.material.steel.Type.fromObject(src.type);
                    }
                    if (src.class !== undefined && src.class !== null) {
                        dst.class = ng.material.steel.DuctilityClass_FromObject(src.class);
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.material.steel.CharacteristicData.fromObject(src.properties);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.steel.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.steel.Data") {
                        console.error('Expected ng.material.steel.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const class_obj = ng.material.steel.DuctilityClass_ToObject(src.class);
                    if(class_obj === null) return null;

                    const dst : Data_json = {
                        class: class_obj,
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.type !== null)
                    {
                        const parsed = ng.material.steel.Type.toObject(src.type);
                        if(parsed === null) return null;
                        dst.type = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.material.steel.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.type !== undefined) {
                        dst.type = src.type;
                    }
                    if (src.class !== undefined) {
                        dst.class = src.class;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.type = this.type;
                    dst.class = this.class;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace steel


        // Defined in 3 files
        export namespace timber {
            // defined in Material/timber.proto
            export enum ProductType {
                PRODUCT_TYPE_UNSPECIFIED = 0,
                PRODUCT_TYPE_REGULAR = 1,
                PRODUCT_TYPE_GL = 2,
                PRODUCT_TYPE_LVL = 3,
                PRODUCT_TYPE_OSB2 = 4,
                PRODUCT_TYPE_OSB3 = 5,
                PRODUCT_TYPE_OSB4 = 6,
                PRODUCT_TYPE_KERTO = 7
            }
            export const ProductType_FromObject = (src: unknown): ProductType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRODUCT_TYPE_UNSPECIFIED':
                        return ProductType.PRODUCT_TYPE_UNSPECIFIED;
                    case 1:
                    case 'PRODUCT_TYPE_REGULAR':
                        return ProductType.PRODUCT_TYPE_REGULAR;
                    case 2:
                    case 'PRODUCT_TYPE_GL':
                        return ProductType.PRODUCT_TYPE_GL;
                    case 3:
                    case 'PRODUCT_TYPE_LVL':
                        return ProductType.PRODUCT_TYPE_LVL;
                    case 4:
                    case 'PRODUCT_TYPE_OSB2':
                        return ProductType.PRODUCT_TYPE_OSB2;
                    case 5:
                    case 'PRODUCT_TYPE_OSB3':
                        return ProductType.PRODUCT_TYPE_OSB3;
                    case 6:
                    case 'PRODUCT_TYPE_OSB4':
                        return ProductType.PRODUCT_TYPE_OSB4;
                    case 7:
                    case 'PRODUCT_TYPE_KERTO':
                        return ProductType.PRODUCT_TYPE_KERTO;
                    default:
                        console.log('Unhandled value for ProductType:' + src + '. ' + typeof(src));
                        return ProductType.PRODUCT_TYPE_UNSPECIFIED;
                }
            };
            export const ProductType_ToObject = (src: ProductType): string | null => {
                switch (src) {
                    case ProductType.PRODUCT_TYPE_UNSPECIFIED:
                        return 'PRODUCT_TYPE_UNSPECIFIED';
                    case ProductType.PRODUCT_TYPE_REGULAR:
                        return 'PRODUCT_TYPE_REGULAR';
                    case ProductType.PRODUCT_TYPE_GL:
                        return 'PRODUCT_TYPE_GL';
                    case ProductType.PRODUCT_TYPE_LVL:
                        return 'PRODUCT_TYPE_LVL';
                    case ProductType.PRODUCT_TYPE_OSB2:
                        return 'PRODUCT_TYPE_OSB2';
                    case ProductType.PRODUCT_TYPE_OSB3:
                        return 'PRODUCT_TYPE_OSB3';
                    case ProductType.PRODUCT_TYPE_OSB4:
                        return 'PRODUCT_TYPE_OSB4';
                    case ProductType.PRODUCT_TYPE_KERTO:
                        return 'PRODUCT_TYPE_KERTO';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ProductType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            // defined in Material/timber.proto
            export enum WoodType {
                WOOD_TYPE_UNSPECIFIED = 0,
                WOOD_TYPE_PINE = 1,
                WOOD_TYPE_ASH = 2,
                WOOD_TYPE_BIRCH = 3,
                WOOD_TYPE_OAK = 4
            }
            export const WoodType_FromObject = (src: unknown): WoodType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'WOOD_TYPE_UNSPECIFIED':
                        return WoodType.WOOD_TYPE_UNSPECIFIED;
                    case 1:
                    case 'WOOD_TYPE_PINE':
                        return WoodType.WOOD_TYPE_PINE;
                    case 2:
                    case 'WOOD_TYPE_ASH':
                        return WoodType.WOOD_TYPE_ASH;
                    case 3:
                    case 'WOOD_TYPE_BIRCH':
                        return WoodType.WOOD_TYPE_BIRCH;
                    case 4:
                    case 'WOOD_TYPE_OAK':
                        return WoodType.WOOD_TYPE_OAK;
                    default:
                        console.log('Unhandled value for WoodType:' + src + '. ' + typeof(src));
                        return WoodType.WOOD_TYPE_UNSPECIFIED;
                }
            };
            export const WoodType_ToObject = (src: WoodType): string | null => {
                switch (src) {
                    case WoodType.WOOD_TYPE_UNSPECIFIED:
                        return 'WOOD_TYPE_UNSPECIFIED';
                    case WoodType.WOOD_TYPE_PINE:
                        return 'WOOD_TYPE_PINE';
                    case WoodType.WOOD_TYPE_ASH:
                        return 'WOOD_TYPE_ASH';
                    case WoodType.WOOD_TYPE_BIRCH:
                        return 'WOOD_TYPE_BIRCH';
                    case WoodType.WOOD_TYPE_OAK:
                        return 'WOOD_TYPE_OAK';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for WoodType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            // defined in Material/timber.proto
            export type Data_keys = 'id' | 'product' | 'wood' | 'boardData' | 'solidData';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                product?: ng.material.timber.ProductType,
                wood?: ng.material.timber.WoodType,
                boardData?: ng.material.timber.board.CharacteristicData | null,
                solidData?: ng.material.timber.solid.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                product?: string;
                wood?: string;
                boardData?: ng.material.timber.board.CharacteristicData_json;
                solidData?: ng.material.timber.solid.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                product?: unknown;
                wood?: unknown;
                boardData?: unknown;
                solidData?: unknown;
            }
            export class Data {
                __proto_name = "ng.material.timber.Data";
                id: ng.utils.ID | null = null;
                product: ng.material.timber.ProductType = ng.material.timber.ProductType.PRODUCT_TYPE_UNSPECIFIED;
                wood: ng.material.timber.WoodType = ng.material.timber.WoodType.WOOD_TYPE_UNSPECIFIED;
                // this is a one of
                properties: {type: 'boardData'; boardData: ng.material.timber.board.CharacteristicData} | {type: 'solidData'; solidData: ng.material.timber.solid.CharacteristicData} | null = null;

                /** Gets the `BoardData` value (or null) from the oneof `properties` */
                getBoardData(): ng.material.timber.board.CharacteristicData | null {
                    if(this.properties === null) return null;
                    if(this.properties.type !== 'boardData') return null;
                    return this.properties.boardData;
                }

                /** Sets the `BoardData` value for the oneof `properties`*/
                setBoardData(value: ng.material.timber.board.CharacteristicData | null) {
                    if(value !== null) {
                        this.properties = {type: 'boardData', boardData:value};
                    }
                    else {
                        this.properties = null;
                    }
                }

                /** Gets the `SolidData` value (or null) from the oneof `properties` */
                getSolidData(): ng.material.timber.solid.CharacteristicData | null {
                    if(this.properties === null) return null;
                    if(this.properties.type !== 'solidData') return null;
                    return this.properties.solidData;
                }

                /** Sets the `SolidData` value for the oneof `properties`*/
                setSolidData(value: ng.material.timber.solid.CharacteristicData | null) {
                    if(value !== null) {
                        this.properties = {type: 'solidData', solidData:value};
                    }
                    else {
                        this.properties = null;
                    }
                }

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.product !== undefined && src.product !== null) {
                        dst.product = ng.material.timber.ProductType_FromObject(src.product);
                    }
                    if (src.wood !== undefined && src.wood !== null) {
                        dst.wood = ng.material.timber.WoodType_FromObject(src.wood);
                    }
                    if (src.boardData !== undefined && src.boardData !== null) {
                        dst.setBoardData(ng.material.timber.board.CharacteristicData.fromObject(src.boardData));
                    }
                    if (src.solidData !== undefined && src.solidData !== null) {
                        dst.setSolidData(ng.material.timber.solid.CharacteristicData.fromObject(src.solidData));
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.timber.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.timber.Data") {
                        console.error('Expected ng.material.timber.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const product_obj = ng.material.timber.ProductType_ToObject(src.product);
                    if(product_obj === null) return null;

                    const wood_obj = ng.material.timber.WoodType_ToObject(src.wood);
                    if(wood_obj === null) return null;

                    const dst : Data_json = {
                        product: product_obj,
                        wood: wood_obj,
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    const boardData = src.getBoardData();
                    if(boardData !== null)
                    {
                        const parsed = ng.material.timber.board.CharacteristicData.toObject(boardData);
                        if(parsed === null) return null;
                        dst.boardData = parsed;
                    }
                    const solidData = src.getSolidData();
                    if(solidData !== null)
                    {
                        const parsed = ng.material.timber.solid.CharacteristicData.toObject(solidData);
                        if(parsed === null) return null;
                        dst.solidData = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.product !== undefined) {
                        dst.product = src.product;
                    }
                    if (src.wood !== undefined) {
                        dst.wood = src.wood;
                    }
                    // part of the properties oneof 
                    if (src.boardData !== undefined && src.boardData !== null) {
                        dst.setBoardData(src.boardData);
                    }
                    // part of the properties oneof 
                    if (src.solidData !== undefined && src.solidData !== null) {
                        dst.setSolidData(src.solidData);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.product = this.product;
                    dst.wood = this.wood;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;


            // Defined in Material/timber_solid.proto
            export namespace solid {
                export type CharacteristicData_keys = 'bending' | 'tensionParallel' | 'tensionPerpendicular' | 'compressionParallel' | 'compressionPerpendicular' | 'shear' | 'meanElasticityParallel' | 'elasticity05' | 'meanElasticityPerpendicular' | 'shearModulus' | 'shearModulus05' | 'density' | 'meanDensity';
                export interface CharacteristicData_createType {
                    bending?: number,
                    tensionParallel?: number,
                    tensionPerpendicular?: number,
                    compressionParallel?: number,
                    compressionPerpendicular?: number,
                    shear?: number,
                    meanElasticityParallel?: number,
                    elasticity05?: number,
                    meanElasticityPerpendicular?: number,
                    shearModulus?: number,
                    shearModulus05?: number,
                    density?: number,
                    meanDensity?: number,
                }
                export interface CharacteristicData_json {
                    bending?: JsonNumber;
                    tensionParallel?: JsonNumber;
                    tensionPerpendicular?: JsonNumber;
                    compressionParallel?: JsonNumber;
                    compressionPerpendicular?: JsonNumber;
                    shear?: JsonNumber;
                    meanElasticityParallel?: JsonNumber;
                    elasticity05?: JsonNumber;
                    meanElasticityPerpendicular?: JsonNumber;
                    shearModulus?: JsonNumber;
                    shearModulus05?: JsonNumber;
                    density?: JsonNumber;
                    meanDensity?: JsonNumber;
                }
                interface CharacteristicData_json_in {
                    __proto_name?: unknown;
                    bending?: unknown;
                    tensionParallel?: unknown;
                    tensionPerpendicular?: unknown;
                    compressionParallel?: unknown;
                    compressionPerpendicular?: unknown;
                    shear?: unknown;
                    meanElasticityParallel?: unknown;
                    elasticity05?: unknown;
                    meanElasticityPerpendicular?: unknown;
                    shearModulus?: unknown;
                    shearModulus05?: unknown;
                    density?: unknown;
                    meanDensity?: unknown;
                }
                export class CharacteristicData {
                    __proto_name = "ng.material.timber.solid.CharacteristicData";
                    bending: number = 0;
                    tensionParallel: number = 0;
                    tensionPerpendicular: number = 0;
                    compressionParallel: number = 0;
                    compressionPerpendicular: number = 0;
                    shear: number = 0;
                    meanElasticityParallel: number = 0;
                    elasticity05: number = 0;
                    meanElasticityPerpendicular: number = 0;
                    shearModulus: number = 0;
                    shearModulus05: number = 0;
                    density: number = 0;
                    meanDensity: number = 0;

                    static fromObject(src_unknown: unknown): CharacteristicData {
                        const dst = new CharacteristicData();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as CharacteristicData_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.bending !== undefined && src.bending !== null) {
                            if (typeof src.bending === "number" || src.bending === 'NaN' || src.bending === 'Infinity' || src.bending === '-Infinity') {
                                dst.bending = AsNum(src.bending);
                            }
                            else {
                                console.log('Expected bending of CharacteristicData to be a number but was ', typeof src.bending, src.bending)
                            }
                        }
                        if (src.tensionParallel !== undefined && src.tensionParallel !== null) {
                            if (typeof src.tensionParallel === "number" || src.tensionParallel === 'NaN' || src.tensionParallel === 'Infinity' || src.tensionParallel === '-Infinity') {
                                dst.tensionParallel = AsNum(src.tensionParallel);
                            }
                            else {
                                console.log('Expected tensionParallel of CharacteristicData to be a number but was ', typeof src.tensionParallel, src.tensionParallel)
                            }
                        }
                        if (src.tensionPerpendicular !== undefined && src.tensionPerpendicular !== null) {
                            if (typeof src.tensionPerpendicular === "number" || src.tensionPerpendicular === 'NaN' || src.tensionPerpendicular === 'Infinity' || src.tensionPerpendicular === '-Infinity') {
                                dst.tensionPerpendicular = AsNum(src.tensionPerpendicular);
                            }
                            else {
                                console.log('Expected tensionPerpendicular of CharacteristicData to be a number but was ', typeof src.tensionPerpendicular, src.tensionPerpendicular)
                            }
                        }
                        if (src.compressionParallel !== undefined && src.compressionParallel !== null) {
                            if (typeof src.compressionParallel === "number" || src.compressionParallel === 'NaN' || src.compressionParallel === 'Infinity' || src.compressionParallel === '-Infinity') {
                                dst.compressionParallel = AsNum(src.compressionParallel);
                            }
                            else {
                                console.log('Expected compressionParallel of CharacteristicData to be a number but was ', typeof src.compressionParallel, src.compressionParallel)
                            }
                        }
                        if (src.compressionPerpendicular !== undefined && src.compressionPerpendicular !== null) {
                            if (typeof src.compressionPerpendicular === "number" || src.compressionPerpendicular === 'NaN' || src.compressionPerpendicular === 'Infinity' || src.compressionPerpendicular === '-Infinity') {
                                dst.compressionPerpendicular = AsNum(src.compressionPerpendicular);
                            }
                            else {
                                console.log('Expected compressionPerpendicular of CharacteristicData to be a number but was ', typeof src.compressionPerpendicular, src.compressionPerpendicular)
                            }
                        }
                        if (src.shear !== undefined && src.shear !== null) {
                            if (typeof src.shear === "number" || src.shear === 'NaN' || src.shear === 'Infinity' || src.shear === '-Infinity') {
                                dst.shear = AsNum(src.shear);
                            }
                            else {
                                console.log('Expected shear of CharacteristicData to be a number but was ', typeof src.shear, src.shear)
                            }
                        }
                        if (src.meanElasticityParallel !== undefined && src.meanElasticityParallel !== null) {
                            if (typeof src.meanElasticityParallel === "number" || src.meanElasticityParallel === 'NaN' || src.meanElasticityParallel === 'Infinity' || src.meanElasticityParallel === '-Infinity') {
                                dst.meanElasticityParallel = AsNum(src.meanElasticityParallel);
                            }
                            else {
                                console.log('Expected meanElasticityParallel of CharacteristicData to be a number but was ', typeof src.meanElasticityParallel, src.meanElasticityParallel)
                            }
                        }
                        if (src.elasticity05 !== undefined && src.elasticity05 !== null) {
                            if (typeof src.elasticity05 === "number" || src.elasticity05 === 'NaN' || src.elasticity05 === 'Infinity' || src.elasticity05 === '-Infinity') {
                                dst.elasticity05 = AsNum(src.elasticity05);
                            }
                            else {
                                console.log('Expected elasticity05 of CharacteristicData to be a number but was ', typeof src.elasticity05, src.elasticity05)
                            }
                        }
                        if (src.meanElasticityPerpendicular !== undefined && src.meanElasticityPerpendicular !== null) {
                            if (typeof src.meanElasticityPerpendicular === "number" || src.meanElasticityPerpendicular === 'NaN' || src.meanElasticityPerpendicular === 'Infinity' || src.meanElasticityPerpendicular === '-Infinity') {
                                dst.meanElasticityPerpendicular = AsNum(src.meanElasticityPerpendicular);
                            }
                            else {
                                console.log('Expected meanElasticityPerpendicular of CharacteristicData to be a number but was ', typeof src.meanElasticityPerpendicular, src.meanElasticityPerpendicular)
                            }
                        }
                        if (src.shearModulus !== undefined && src.shearModulus !== null) {
                            if (typeof src.shearModulus === "number" || src.shearModulus === 'NaN' || src.shearModulus === 'Infinity' || src.shearModulus === '-Infinity') {
                                dst.shearModulus = AsNum(src.shearModulus);
                            }
                            else {
                                console.log('Expected shearModulus of CharacteristicData to be a number but was ', typeof src.shearModulus, src.shearModulus)
                            }
                        }
                        if (src.shearModulus05 !== undefined && src.shearModulus05 !== null) {
                            if (typeof src.shearModulus05 === "number" || src.shearModulus05 === 'NaN' || src.shearModulus05 === 'Infinity' || src.shearModulus05 === '-Infinity') {
                                dst.shearModulus05 = AsNum(src.shearModulus05);
                            }
                            else {
                                console.log('Expected shearModulus05 of CharacteristicData to be a number but was ', typeof src.shearModulus05, src.shearModulus05)
                            }
                        }
                        if (src.density !== undefined && src.density !== null) {
                            if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                                dst.density = AsNum(src.density);
                            }
                            else {
                                console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                            }
                        }
                        if (src.meanDensity !== undefined && src.meanDensity !== null) {
                            if (typeof src.meanDensity === "number" || src.meanDensity === 'NaN' || src.meanDensity === 'Infinity' || src.meanDensity === '-Infinity') {
                                dst.meanDensity = AsNum(src.meanDensity);
                            }
                            else {
                                console.log('Expected meanDensity of CharacteristicData to be a number but was ', typeof src.meanDensity, src.meanDensity)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.material.timber.solid.CharacteristicData is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.material.timber.solid.CharacteristicData") {
                            console.error('Expected ng.material.timber.solid.CharacteristicData but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : CharacteristicData_json = {
                            bending: AsJsonNum(src.bending),
                            tensionParallel: AsJsonNum(src.tensionParallel),
                            tensionPerpendicular: AsJsonNum(src.tensionPerpendicular),
                            compressionParallel: AsJsonNum(src.compressionParallel),
                            compressionPerpendicular: AsJsonNum(src.compressionPerpendicular),
                            shear: AsJsonNum(src.shear),
                            meanElasticityParallel: AsJsonNum(src.meanElasticityParallel),
                            elasticity05: AsJsonNum(src.elasticity05),
                            meanElasticityPerpendicular: AsJsonNum(src.meanElasticityPerpendicular),
                            shearModulus: AsJsonNum(src.shearModulus),
                            shearModulus05: AsJsonNum(src.shearModulus05),
                            density: AsJsonNum(src.density),
                            meanDensity: AsJsonNum(src.meanDensity),
                        };
                        return dst;
                    }

                    static create(src?: CharacteristicData_createType) {
                        const dst = new CharacteristicData();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.bending !== undefined) {
                            dst.bending = src.bending;
                        }
                        if (src.tensionParallel !== undefined) {
                            dst.tensionParallel = src.tensionParallel;
                        }
                        if (src.tensionPerpendicular !== undefined) {
                            dst.tensionPerpendicular = src.tensionPerpendicular;
                        }
                        if (src.compressionParallel !== undefined) {
                            dst.compressionParallel = src.compressionParallel;
                        }
                        if (src.compressionPerpendicular !== undefined) {
                            dst.compressionPerpendicular = src.compressionPerpendicular;
                        }
                        if (src.shear !== undefined) {
                            dst.shear = src.shear;
                        }
                        if (src.meanElasticityParallel !== undefined) {
                            dst.meanElasticityParallel = src.meanElasticityParallel;
                        }
                        if (src.elasticity05 !== undefined) {
                            dst.elasticity05 = src.elasticity05;
                        }
                        if (src.meanElasticityPerpendicular !== undefined) {
                            dst.meanElasticityPerpendicular = src.meanElasticityPerpendicular;
                        }
                        if (src.shearModulus !== undefined) {
                            dst.shearModulus = src.shearModulus;
                        }
                        if (src.shearModulus05 !== undefined) {
                            dst.shearModulus05 = src.shearModulus05;
                        }
                        if (src.density !== undefined) {
                            dst.density = src.density;
                        }
                        if (src.meanDensity !== undefined) {
                            dst.meanDensity = src.meanDensity;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new CharacteristicData();
                        dst.bending = this.bending;
                        dst.tensionParallel = this.tensionParallel;
                        dst.tensionPerpendicular = this.tensionPerpendicular;
                        dst.compressionParallel = this.compressionParallel;
                        dst.compressionPerpendicular = this.compressionPerpendicular;
                        dst.shear = this.shear;
                        dst.meanElasticityParallel = this.meanElasticityParallel;
                        dst.elasticity05 = this.elasticity05;
                        dst.meanElasticityPerpendicular = this.meanElasticityPerpendicular;
                        dst.shearModulus = this.shearModulus;
                        dst.shearModulus05 = this.shearModulus05;
                        dst.density = this.density;
                        dst.meanDensity = this.meanDensity;
                        return dst;
                    }

                    deepClone() {
                        const json = CharacteristicData.toObject(this);
                        const dst = CharacteristicData.fromObject(json);
                        return dst;
                    }
                }
                export type ICharacteristicData = CharacteristicData;
            } // namespace solid


            // Defined in Material/timber_board.proto
            export namespace board {
                export type CharacteristicData_keys = 'bendingParallel' | 'bendingPerpendicular' | 'tensionParallel' | 'tensionPerpendicular' | 'compressionParallel' | 'compressionPerpendicular' | 'panelShear' | 'planarShear' | 'elasticityBendingParallel' | 'elasticityBendingPerpendicular' | 'elasticityTensionParallel' | 'elasticityTensionPerpendicular' | 'elasticityCompressionParallel' | 'elasticityCompressionPerpendicular' | 'panelShearModulus' | 'planarShearModulus' | 'density';
                export interface CharacteristicData_createType {
                    bendingParallel?: number,
                    bendingPerpendicular?: number,
                    tensionParallel?: number,
                    tensionPerpendicular?: number,
                    compressionParallel?: number,
                    compressionPerpendicular?: number,
                    panelShear?: number,
                    planarShear?: number,
                    elasticityBendingParallel?: number,
                    elasticityBendingPerpendicular?: number,
                    elasticityTensionParallel?: number,
                    elasticityTensionPerpendicular?: number,
                    elasticityCompressionParallel?: number,
                    elasticityCompressionPerpendicular?: number,
                    panelShearModulus?: number,
                    planarShearModulus?: number,
                    density?: number,
                }
                export interface CharacteristicData_json {
                    bendingParallel?: JsonNumber;
                    bendingPerpendicular?: JsonNumber;
                    tensionParallel?: JsonNumber;
                    tensionPerpendicular?: JsonNumber;
                    compressionParallel?: JsonNumber;
                    compressionPerpendicular?: JsonNumber;
                    panelShear?: JsonNumber;
                    planarShear?: JsonNumber;
                    elasticityBendingParallel?: JsonNumber;
                    elasticityBendingPerpendicular?: JsonNumber;
                    elasticityTensionParallel?: JsonNumber;
                    elasticityTensionPerpendicular?: JsonNumber;
                    elasticityCompressionParallel?: JsonNumber;
                    elasticityCompressionPerpendicular?: JsonNumber;
                    panelShearModulus?: JsonNumber;
                    planarShearModulus?: JsonNumber;
                    density?: JsonNumber;
                }
                interface CharacteristicData_json_in {
                    __proto_name?: unknown;
                    bendingParallel?: unknown;
                    bendingPerpendicular?: unknown;
                    tensionParallel?: unknown;
                    tensionPerpendicular?: unknown;
                    compressionParallel?: unknown;
                    compressionPerpendicular?: unknown;
                    panelShear?: unknown;
                    planarShear?: unknown;
                    elasticityBendingParallel?: unknown;
                    elasticityBendingPerpendicular?: unknown;
                    elasticityTensionParallel?: unknown;
                    elasticityTensionPerpendicular?: unknown;
                    elasticityCompressionParallel?: unknown;
                    elasticityCompressionPerpendicular?: unknown;
                    panelShearModulus?: unknown;
                    planarShearModulus?: unknown;
                    density?: unknown;
                }
                export class CharacteristicData {
                    __proto_name = "ng.material.timber.board.CharacteristicData";
                    bendingParallel: number = 0;
                    bendingPerpendicular: number = 0;
                    tensionParallel: number = 0;
                    tensionPerpendicular: number = 0;
                    compressionParallel: number = 0;
                    compressionPerpendicular: number = 0;
                    panelShear: number = 0;
                    planarShear: number = 0;
                    elasticityBendingParallel: number = 0;
                    elasticityBendingPerpendicular: number = 0;
                    elasticityTensionParallel: number = 0;
                    elasticityTensionPerpendicular: number = 0;
                    elasticityCompressionParallel: number = 0;
                    elasticityCompressionPerpendicular: number = 0;
                    panelShearModulus: number = 0;
                    planarShearModulus: number = 0;
                    density: number = 0;

                    static fromObject(src_unknown: unknown): CharacteristicData {
                        const dst = new CharacteristicData();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as CharacteristicData_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.bendingParallel !== undefined && src.bendingParallel !== null) {
                            if (typeof src.bendingParallel === "number" || src.bendingParallel === 'NaN' || src.bendingParallel === 'Infinity' || src.bendingParallel === '-Infinity') {
                                dst.bendingParallel = AsNum(src.bendingParallel);
                            }
                            else {
                                console.log('Expected bendingParallel of CharacteristicData to be a number but was ', typeof src.bendingParallel, src.bendingParallel)
                            }
                        }
                        if (src.bendingPerpendicular !== undefined && src.bendingPerpendicular !== null) {
                            if (typeof src.bendingPerpendicular === "number" || src.bendingPerpendicular === 'NaN' || src.bendingPerpendicular === 'Infinity' || src.bendingPerpendicular === '-Infinity') {
                                dst.bendingPerpendicular = AsNum(src.bendingPerpendicular);
                            }
                            else {
                                console.log('Expected bendingPerpendicular of CharacteristicData to be a number but was ', typeof src.bendingPerpendicular, src.bendingPerpendicular)
                            }
                        }
                        if (src.tensionParallel !== undefined && src.tensionParallel !== null) {
                            if (typeof src.tensionParallel === "number" || src.tensionParallel === 'NaN' || src.tensionParallel === 'Infinity' || src.tensionParallel === '-Infinity') {
                                dst.tensionParallel = AsNum(src.tensionParallel);
                            }
                            else {
                                console.log('Expected tensionParallel of CharacteristicData to be a number but was ', typeof src.tensionParallel, src.tensionParallel)
                            }
                        }
                        if (src.tensionPerpendicular !== undefined && src.tensionPerpendicular !== null) {
                            if (typeof src.tensionPerpendicular === "number" || src.tensionPerpendicular === 'NaN' || src.tensionPerpendicular === 'Infinity' || src.tensionPerpendicular === '-Infinity') {
                                dst.tensionPerpendicular = AsNum(src.tensionPerpendicular);
                            }
                            else {
                                console.log('Expected tensionPerpendicular of CharacteristicData to be a number but was ', typeof src.tensionPerpendicular, src.tensionPerpendicular)
                            }
                        }
                        if (src.compressionParallel !== undefined && src.compressionParallel !== null) {
                            if (typeof src.compressionParallel === "number" || src.compressionParallel === 'NaN' || src.compressionParallel === 'Infinity' || src.compressionParallel === '-Infinity') {
                                dst.compressionParallel = AsNum(src.compressionParallel);
                            }
                            else {
                                console.log('Expected compressionParallel of CharacteristicData to be a number but was ', typeof src.compressionParallel, src.compressionParallel)
                            }
                        }
                        if (src.compressionPerpendicular !== undefined && src.compressionPerpendicular !== null) {
                            if (typeof src.compressionPerpendicular === "number" || src.compressionPerpendicular === 'NaN' || src.compressionPerpendicular === 'Infinity' || src.compressionPerpendicular === '-Infinity') {
                                dst.compressionPerpendicular = AsNum(src.compressionPerpendicular);
                            }
                            else {
                                console.log('Expected compressionPerpendicular of CharacteristicData to be a number but was ', typeof src.compressionPerpendicular, src.compressionPerpendicular)
                            }
                        }
                        if (src.panelShear !== undefined && src.panelShear !== null) {
                            if (typeof src.panelShear === "number" || src.panelShear === 'NaN' || src.panelShear === 'Infinity' || src.panelShear === '-Infinity') {
                                dst.panelShear = AsNum(src.panelShear);
                            }
                            else {
                                console.log('Expected panelShear of CharacteristicData to be a number but was ', typeof src.panelShear, src.panelShear)
                            }
                        }
                        if (src.planarShear !== undefined && src.planarShear !== null) {
                            if (typeof src.planarShear === "number" || src.planarShear === 'NaN' || src.planarShear === 'Infinity' || src.planarShear === '-Infinity') {
                                dst.planarShear = AsNum(src.planarShear);
                            }
                            else {
                                console.log('Expected planarShear of CharacteristicData to be a number but was ', typeof src.planarShear, src.planarShear)
                            }
                        }
                        if (src.elasticityBendingParallel !== undefined && src.elasticityBendingParallel !== null) {
                            if (typeof src.elasticityBendingParallel === "number" || src.elasticityBendingParallel === 'NaN' || src.elasticityBendingParallel === 'Infinity' || src.elasticityBendingParallel === '-Infinity') {
                                dst.elasticityBendingParallel = AsNum(src.elasticityBendingParallel);
                            }
                            else {
                                console.log('Expected elasticityBendingParallel of CharacteristicData to be a number but was ', typeof src.elasticityBendingParallel, src.elasticityBendingParallel)
                            }
                        }
                        if (src.elasticityBendingPerpendicular !== undefined && src.elasticityBendingPerpendicular !== null) {
                            if (typeof src.elasticityBendingPerpendicular === "number" || src.elasticityBendingPerpendicular === 'NaN' || src.elasticityBendingPerpendicular === 'Infinity' || src.elasticityBendingPerpendicular === '-Infinity') {
                                dst.elasticityBendingPerpendicular = AsNum(src.elasticityBendingPerpendicular);
                            }
                            else {
                                console.log('Expected elasticityBendingPerpendicular of CharacteristicData to be a number but was ', typeof src.elasticityBendingPerpendicular, src.elasticityBendingPerpendicular)
                            }
                        }
                        if (src.elasticityTensionParallel !== undefined && src.elasticityTensionParallel !== null) {
                            if (typeof src.elasticityTensionParallel === "number" || src.elasticityTensionParallel === 'NaN' || src.elasticityTensionParallel === 'Infinity' || src.elasticityTensionParallel === '-Infinity') {
                                dst.elasticityTensionParallel = AsNum(src.elasticityTensionParallel);
                            }
                            else {
                                console.log('Expected elasticityTensionParallel of CharacteristicData to be a number but was ', typeof src.elasticityTensionParallel, src.elasticityTensionParallel)
                            }
                        }
                        if (src.elasticityTensionPerpendicular !== undefined && src.elasticityTensionPerpendicular !== null) {
                            if (typeof src.elasticityTensionPerpendicular === "number" || src.elasticityTensionPerpendicular === 'NaN' || src.elasticityTensionPerpendicular === 'Infinity' || src.elasticityTensionPerpendicular === '-Infinity') {
                                dst.elasticityTensionPerpendicular = AsNum(src.elasticityTensionPerpendicular);
                            }
                            else {
                                console.log('Expected elasticityTensionPerpendicular of CharacteristicData to be a number but was ', typeof src.elasticityTensionPerpendicular, src.elasticityTensionPerpendicular)
                            }
                        }
                        if (src.elasticityCompressionParallel !== undefined && src.elasticityCompressionParallel !== null) {
                            if (typeof src.elasticityCompressionParallel === "number" || src.elasticityCompressionParallel === 'NaN' || src.elasticityCompressionParallel === 'Infinity' || src.elasticityCompressionParallel === '-Infinity') {
                                dst.elasticityCompressionParallel = AsNum(src.elasticityCompressionParallel);
                            }
                            else {
                                console.log('Expected elasticityCompressionParallel of CharacteristicData to be a number but was ', typeof src.elasticityCompressionParallel, src.elasticityCompressionParallel)
                            }
                        }
                        if (src.elasticityCompressionPerpendicular !== undefined && src.elasticityCompressionPerpendicular !== null) {
                            if (typeof src.elasticityCompressionPerpendicular === "number" || src.elasticityCompressionPerpendicular === 'NaN' || src.elasticityCompressionPerpendicular === 'Infinity' || src.elasticityCompressionPerpendicular === '-Infinity') {
                                dst.elasticityCompressionPerpendicular = AsNum(src.elasticityCompressionPerpendicular);
                            }
                            else {
                                console.log('Expected elasticityCompressionPerpendicular of CharacteristicData to be a number but was ', typeof src.elasticityCompressionPerpendicular, src.elasticityCompressionPerpendicular)
                            }
                        }
                        if (src.panelShearModulus !== undefined && src.panelShearModulus !== null) {
                            if (typeof src.panelShearModulus === "number" || src.panelShearModulus === 'NaN' || src.panelShearModulus === 'Infinity' || src.panelShearModulus === '-Infinity') {
                                dst.panelShearModulus = AsNum(src.panelShearModulus);
                            }
                            else {
                                console.log('Expected panelShearModulus of CharacteristicData to be a number but was ', typeof src.panelShearModulus, src.panelShearModulus)
                            }
                        }
                        if (src.planarShearModulus !== undefined && src.planarShearModulus !== null) {
                            if (typeof src.planarShearModulus === "number" || src.planarShearModulus === 'NaN' || src.planarShearModulus === 'Infinity' || src.planarShearModulus === '-Infinity') {
                                dst.planarShearModulus = AsNum(src.planarShearModulus);
                            }
                            else {
                                console.log('Expected planarShearModulus of CharacteristicData to be a number but was ', typeof src.planarShearModulus, src.planarShearModulus)
                            }
                        }
                        if (src.density !== undefined && src.density !== null) {
                            if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                                dst.density = AsNum(src.density);
                            }
                            else {
                                console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.material.timber.board.CharacteristicData is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.material.timber.board.CharacteristicData") {
                            console.error('Expected ng.material.timber.board.CharacteristicData but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : CharacteristicData_json = {
                            bendingParallel: AsJsonNum(src.bendingParallel),
                            bendingPerpendicular: AsJsonNum(src.bendingPerpendicular),
                            tensionParallel: AsJsonNum(src.tensionParallel),
                            tensionPerpendicular: AsJsonNum(src.tensionPerpendicular),
                            compressionParallel: AsJsonNum(src.compressionParallel),
                            compressionPerpendicular: AsJsonNum(src.compressionPerpendicular),
                            panelShear: AsJsonNum(src.panelShear),
                            planarShear: AsJsonNum(src.planarShear),
                            elasticityBendingParallel: AsJsonNum(src.elasticityBendingParallel),
                            elasticityBendingPerpendicular: AsJsonNum(src.elasticityBendingPerpendicular),
                            elasticityTensionParallel: AsJsonNum(src.elasticityTensionParallel),
                            elasticityTensionPerpendicular: AsJsonNum(src.elasticityTensionPerpendicular),
                            elasticityCompressionParallel: AsJsonNum(src.elasticityCompressionParallel),
                            elasticityCompressionPerpendicular: AsJsonNum(src.elasticityCompressionPerpendicular),
                            panelShearModulus: AsJsonNum(src.panelShearModulus),
                            planarShearModulus: AsJsonNum(src.planarShearModulus),
                            density: AsJsonNum(src.density),
                        };
                        return dst;
                    }

                    static create(src?: CharacteristicData_createType) {
                        const dst = new CharacteristicData();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.bendingParallel !== undefined) {
                            dst.bendingParallel = src.bendingParallel;
                        }
                        if (src.bendingPerpendicular !== undefined) {
                            dst.bendingPerpendicular = src.bendingPerpendicular;
                        }
                        if (src.tensionParallel !== undefined) {
                            dst.tensionParallel = src.tensionParallel;
                        }
                        if (src.tensionPerpendicular !== undefined) {
                            dst.tensionPerpendicular = src.tensionPerpendicular;
                        }
                        if (src.compressionParallel !== undefined) {
                            dst.compressionParallel = src.compressionParallel;
                        }
                        if (src.compressionPerpendicular !== undefined) {
                            dst.compressionPerpendicular = src.compressionPerpendicular;
                        }
                        if (src.panelShear !== undefined) {
                            dst.panelShear = src.panelShear;
                        }
                        if (src.planarShear !== undefined) {
                            dst.planarShear = src.planarShear;
                        }
                        if (src.elasticityBendingParallel !== undefined) {
                            dst.elasticityBendingParallel = src.elasticityBendingParallel;
                        }
                        if (src.elasticityBendingPerpendicular !== undefined) {
                            dst.elasticityBendingPerpendicular = src.elasticityBendingPerpendicular;
                        }
                        if (src.elasticityTensionParallel !== undefined) {
                            dst.elasticityTensionParallel = src.elasticityTensionParallel;
                        }
                        if (src.elasticityTensionPerpendicular !== undefined) {
                            dst.elasticityTensionPerpendicular = src.elasticityTensionPerpendicular;
                        }
                        if (src.elasticityCompressionParallel !== undefined) {
                            dst.elasticityCompressionParallel = src.elasticityCompressionParallel;
                        }
                        if (src.elasticityCompressionPerpendicular !== undefined) {
                            dst.elasticityCompressionPerpendicular = src.elasticityCompressionPerpendicular;
                        }
                        if (src.panelShearModulus !== undefined) {
                            dst.panelShearModulus = src.panelShearModulus;
                        }
                        if (src.planarShearModulus !== undefined) {
                            dst.planarShearModulus = src.planarShearModulus;
                        }
                        if (src.density !== undefined) {
                            dst.density = src.density;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new CharacteristicData();
                        dst.bendingParallel = this.bendingParallel;
                        dst.bendingPerpendicular = this.bendingPerpendicular;
                        dst.tensionParallel = this.tensionParallel;
                        dst.tensionPerpendicular = this.tensionPerpendicular;
                        dst.compressionParallel = this.compressionParallel;
                        dst.compressionPerpendicular = this.compressionPerpendicular;
                        dst.panelShear = this.panelShear;
                        dst.planarShear = this.planarShear;
                        dst.elasticityBendingParallel = this.elasticityBendingParallel;
                        dst.elasticityBendingPerpendicular = this.elasticityBendingPerpendicular;
                        dst.elasticityTensionParallel = this.elasticityTensionParallel;
                        dst.elasticityTensionPerpendicular = this.elasticityTensionPerpendicular;
                        dst.elasticityCompressionParallel = this.elasticityCompressionParallel;
                        dst.elasticityCompressionPerpendicular = this.elasticityCompressionPerpendicular;
                        dst.panelShearModulus = this.panelShearModulus;
                        dst.planarShearModulus = this.planarShearModulus;
                        dst.density = this.density;
                        return dst;
                    }

                    deepClone() {
                        const json = CharacteristicData.toObject(this);
                        const dst = CharacteristicData.fromObject(json);
                        return dst;
                    }
                }
                export type ICharacteristicData = CharacteristicData;
            } // namespace board
        } // namespace timber


        // Defined in Material/soil.proto
        export namespace soil {
            export enum Behaviour {
                BEHAVIOUR_UNSPECIFIED = 0,
                BEHAVIOUR_UNDRAINED = 1,
                BEHAVIOUR_DRAINED = 2,
                BEHAVIOUR_COMBINED = 3,
                BEHAVIOUR_ROCK = 4,
                BEHAVIOUR_ROCK_PLANE_GRINDED = 5
            }
            export const Behaviour_FromObject = (src: unknown): Behaviour => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'BEHAVIOUR_UNSPECIFIED':
                        return Behaviour.BEHAVIOUR_UNSPECIFIED;
                    case 1:
                    case 'BEHAVIOUR_UNDRAINED':
                        return Behaviour.BEHAVIOUR_UNDRAINED;
                    case 2:
                    case 'BEHAVIOUR_DRAINED':
                        return Behaviour.BEHAVIOUR_DRAINED;
                    case 3:
                    case 'BEHAVIOUR_COMBINED':
                        return Behaviour.BEHAVIOUR_COMBINED;
                    case 4:
                    case 'BEHAVIOUR_ROCK':
                        return Behaviour.BEHAVIOUR_ROCK;
                    case 5:
                    case 'BEHAVIOUR_ROCK_PLANE_GRINDED':
                        return Behaviour.BEHAVIOUR_ROCK_PLANE_GRINDED;
                    default:
                        console.log('Unhandled value for Behaviour:' + src + '. ' + typeof(src));
                        return Behaviour.BEHAVIOUR_UNSPECIFIED;
                }
            };
            export const Behaviour_ToObject = (src: Behaviour): string | null => {
                switch (src) {
                    case Behaviour.BEHAVIOUR_UNSPECIFIED:
                        return 'BEHAVIOUR_UNSPECIFIED';
                    case Behaviour.BEHAVIOUR_UNDRAINED:
                        return 'BEHAVIOUR_UNDRAINED';
                    case Behaviour.BEHAVIOUR_DRAINED:
                        return 'BEHAVIOUR_DRAINED';
                    case Behaviour.BEHAVIOUR_COMBINED:
                        return 'BEHAVIOUR_COMBINED';
                    case Behaviour.BEHAVIOUR_ROCK:
                        return 'BEHAVIOUR_ROCK';
                    case Behaviour.BEHAVIOUR_ROCK_PLANE_GRINDED:
                        return 'BEHAVIOUR_ROCK_PLANE_GRINDED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Behaviour, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum MaterialModel {
                MATERIAL_MODEL_UNSPECIFIED = 0,
                MATERIAL_MODEL_NOSETTLEMENT = 1,
                MATERIAL_MODEL_LINEAR = 2,
                MATERIAL_MODEL_LOG = 3,
                MATERIAL_MODEL_OVERCONSOLIDATED = 4,
                MATERIAL_MODEL_GENERIC = 5,
                MATERIAL_MODEL_CPT = 6
            }
            export const MaterialModel_FromObject = (src: unknown): MaterialModel => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'MATERIAL_MODEL_UNSPECIFIED':
                        return MaterialModel.MATERIAL_MODEL_UNSPECIFIED;
                    case 1:
                    case 'MATERIAL_MODEL_NOSETTLEMENT':
                        return MaterialModel.MATERIAL_MODEL_NOSETTLEMENT;
                    case 2:
                    case 'MATERIAL_MODEL_LINEAR':
                        return MaterialModel.MATERIAL_MODEL_LINEAR;
                    case 3:
                    case 'MATERIAL_MODEL_LOG':
                        return MaterialModel.MATERIAL_MODEL_LOG;
                    case 4:
                    case 'MATERIAL_MODEL_OVERCONSOLIDATED':
                        return MaterialModel.MATERIAL_MODEL_OVERCONSOLIDATED;
                    case 5:
                    case 'MATERIAL_MODEL_GENERIC':
                        return MaterialModel.MATERIAL_MODEL_GENERIC;
                    case 6:
                    case 'MATERIAL_MODEL_CPT':
                        return MaterialModel.MATERIAL_MODEL_CPT;
                    default:
                        console.log('Unhandled value for MaterialModel:' + src + '. ' + typeof(src));
                        return MaterialModel.MATERIAL_MODEL_UNSPECIFIED;
                }
            };
            export const MaterialModel_ToObject = (src: MaterialModel): string | null => {
                switch (src) {
                    case MaterialModel.MATERIAL_MODEL_UNSPECIFIED:
                        return 'MATERIAL_MODEL_UNSPECIFIED';
                    case MaterialModel.MATERIAL_MODEL_NOSETTLEMENT:
                        return 'MATERIAL_MODEL_NOSETTLEMENT';
                    case MaterialModel.MATERIAL_MODEL_LINEAR:
                        return 'MATERIAL_MODEL_LINEAR';
                    case MaterialModel.MATERIAL_MODEL_LOG:
                        return 'MATERIAL_MODEL_LOG';
                    case MaterialModel.MATERIAL_MODEL_OVERCONSOLIDATED:
                        return 'MATERIAL_MODEL_OVERCONSOLIDATED';
                    case MaterialModel.MATERIAL_MODEL_GENERIC:
                        return 'MATERIAL_MODEL_GENERIC';
                    case MaterialModel.MATERIAL_MODEL_CPT:
                        return 'MATERIAL_MODEL_CPT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for MaterialModel, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type Generic_keys = 'sigma' | 'p' | 'pD' | 'm' | 'mD';
            export interface Generic_createType {
                sigma?: number,
                p?: number,
                pD?: number,
                m?: number,
                mD?: number,
            }
            export interface Generic_json {
                sigma?: JsonNumber;
                p?: JsonNumber;
                pD?: JsonNumber;
                m?: JsonNumber;
                mD?: JsonNumber;
            }
            interface Generic_json_in {
                __proto_name?: unknown;
                sigma?: unknown;
                p?: unknown;
                pD?: unknown;
                m?: unknown;
                mD?: unknown;
            }
            export class Generic {
                __proto_name = "ng.material.soil.Generic";
                sigma: number = 0;
                p: number = 0;
                pD: number = 0;
                m: number = 0;
                mD: number = 0;

                static fromObject(src_unknown: unknown): Generic {
                    const dst = new Generic();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Generic but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Generic_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Generic but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sigma !== undefined && src.sigma !== null) {
                        if (typeof src.sigma === "number" || src.sigma === 'NaN' || src.sigma === 'Infinity' || src.sigma === '-Infinity') {
                            dst.sigma = AsNum(src.sigma);
                        }
                        else {
                            console.log('Expected sigma of Generic to be a number but was ', typeof src.sigma, src.sigma)
                        }
                    }
                    if (src.p !== undefined && src.p !== null) {
                        if (typeof src.p === "number" || src.p === 'NaN' || src.p === 'Infinity' || src.p === '-Infinity') {
                            dst.p = AsNum(src.p);
                        }
                        else {
                            console.log('Expected p of Generic to be a number but was ', typeof src.p, src.p)
                        }
                    }
                    if (src.pD !== undefined && src.pD !== null) {
                        if (typeof src.pD === "number" || src.pD === 'NaN' || src.pD === 'Infinity' || src.pD === '-Infinity') {
                            dst.pD = AsNum(src.pD);
                        }
                        else {
                            console.log('Expected pD of Generic to be a number but was ', typeof src.pD, src.pD)
                        }
                    }
                    if (src.m !== undefined && src.m !== null) {
                        if (typeof src.m === "number" || src.m === 'NaN' || src.m === 'Infinity' || src.m === '-Infinity') {
                            dst.m = AsNum(src.m);
                        }
                        else {
                            console.log('Expected m of Generic to be a number but was ', typeof src.m, src.m)
                        }
                    }
                    if (src.mD !== undefined && src.mD !== null) {
                        if (typeof src.mD === "number" || src.mD === 'NaN' || src.mD === 'Infinity' || src.mD === '-Infinity') {
                            dst.mD = AsNum(src.mD);
                        }
                        else {
                            console.log('Expected mD of Generic to be a number but was ', typeof src.mD, src.mD)
                        }
                    }
                    return dst;
                }

                static toObject(src: Generic | null | undefined): Generic_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.soil.Generic is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.soil.Generic") {
                        console.error('Expected ng.material.soil.Generic but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Generic_json = {
                        sigma: AsJsonNum(src.sigma),
                        p: AsJsonNum(src.p),
                        pD: AsJsonNum(src.pD),
                        m: AsJsonNum(src.m),
                        mD: AsJsonNum(src.mD),
                    };
                    return dst;
                }

                static create(src?: Generic_createType) {
                    const dst = new Generic();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sigma !== undefined) {
                        dst.sigma = src.sigma;
                    }
                    if (src.p !== undefined) {
                        dst.p = src.p;
                    }
                    if (src.pD !== undefined) {
                        dst.pD = src.pD;
                    }
                    if (src.m !== undefined) {
                        dst.m = src.m;
                    }
                    if (src.mD !== undefined) {
                        dst.mD = src.mD;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Generic();
                    dst.sigma = this.sigma;
                    dst.p = this.p;
                    dst.pD = this.pD;
                    dst.m = this.m;
                    dst.mD = this.mD;
                    return dst;
                }

                deepClone() {
                    const json = Generic.toObject(this);
                    const dst = Generic.fromObject(json);
                    return dst;
                }
            }
            export type IGeneric = Generic;


            export type CharacteristicData_keys = 'cuk' | 'cukD' | 'ck' | 'ckD' | 'phiK' | 'phiCvk' | 'rk' | 'gamma' | 'gammaEffective' | 'm0' | 'm0D' | 'mu' | 'muD' | 'ml' | 'mlD' | 'm' | 'mD' | 'sigmaC' | 'pc' | 'pcD' | 'sigmaL' | 'pl' | 'plD' | 'poissonsRatio' | 'q' | 'generic' | 'a' | 's' | 'mb' | 'consCpt' | 'wallStrength' | 'alfa' | 'beta' | 'Nc' | 'Nq' | 'NcD' | 'qsdMax' | 'qbdMax' | 'ksigma';
            export interface CharacteristicData_createType {
                cuk?: number,
                cukD?: number,
                ck?: number,
                ckD?: number,
                phiK?: number,
                phiCvk?: number,
                rk?: number,
                gamma?: number,
                gammaEffective?: number,
                m0?: number,
                m0D?: number,
                mu?: number,
                muD?: number,
                ml?: number,
                mlD?: number,
                m?: number,
                mD?: number,
                sigmaC?: number,
                pc?: number,
                pcD?: number,
                sigmaL?: number,
                pl?: number,
                plD?: number,
                poissonsRatio?: number,
                q?: number,
                generic?: ng.material.soil.Generic[],
                a?: number,
                s?: number,
                mb?: number,
                consCpt?: ng.material.soil.ConsolidationCpt | null,
                wallStrength?: ng.material.soil.WallStrength | null,
                alfa?: ng.material.soil.PileShaftResistance | null,
                beta?: ng.material.soil.PileShaftResistance | null,
                Nc?: number,
                Nq?: number,
                NcD?: number,
                qsdMax?: number,
                qbdMax?: number,
                ksigma?: number,
            }
            export interface CharacteristicData_json {
                cuk?: JsonNumber;
                cukD?: JsonNumber;
                ck?: JsonNumber;
                ckD?: JsonNumber;
                phiK?: JsonNumber;
                phiCvk?: JsonNumber;
                rk?: JsonNumber;
                gamma?: JsonNumber;
                gammaEffective?: JsonNumber;
                m0?: JsonNumber;
                m0D?: JsonNumber;
                mu?: JsonNumber;
                muD?: JsonNumber;
                ml?: JsonNumber;
                mlD?: JsonNumber;
                m?: JsonNumber;
                mD?: JsonNumber;
                sigmaC?: JsonNumber;
                pc?: JsonNumber;
                pcD?: JsonNumber;
                sigmaL?: JsonNumber;
                pl?: JsonNumber;
                plD?: JsonNumber;
                poissonsRatio?: JsonNumber;
                q?: JsonNumber;
                generic: ng.material.soil.Generic_json[];
                a?: JsonNumber;
                s?: JsonNumber;
                mb?: JsonNumber;
                consCpt?: ng.material.soil.ConsolidationCpt_json;
                wallStrength?: ng.material.soil.WallStrength_json;
                alfa?: ng.material.soil.PileShaftResistance_json;
                beta?: ng.material.soil.PileShaftResistance_json;
                Nc?: JsonNumber;
                Nq?: JsonNumber;
                NcD?: JsonNumber;
                qsdMax?: JsonNumber;
                qbdMax?: JsonNumber;
                ksigma?: JsonNumber;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                cuk?: unknown;
                cukD?: unknown;
                ck?: unknown;
                ckD?: unknown;
                phiK?: unknown;
                phiCvk?: unknown;
                rk?: unknown;
                gamma?: unknown;
                gammaEffective?: unknown;
                m0?: unknown;
                m0D?: unknown;
                mu?: unknown;
                muD?: unknown;
                ml?: unknown;
                mlD?: unknown;
                m?: unknown;
                mD?: unknown;
                sigmaC?: unknown;
                pc?: unknown;
                pcD?: unknown;
                sigmaL?: unknown;
                pl?: unknown;
                plD?: unknown;
                poissonsRatio?: unknown;
                q?: unknown;
                generic?: unknown;
                a?: unknown;
                s?: unknown;
                mb?: unknown;
                consCpt?: unknown;
                wallStrength?: unknown;
                alfa?: unknown;
                beta?: unknown;
                Nc?: unknown;
                Nq?: unknown;
                NcD?: unknown;
                qsdMax?: unknown;
                qbdMax?: unknown;
                ksigma?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.material.soil.CharacteristicData";
                cuk: number = 0;
                cukD: number = 0;
                ck: number = 0;
                ckD: number = 0;
                phiK: number = 0;
                phiCvk: number = 0;
                rk: number = 0;
                gamma: number = 0;
                gammaEffective: number = 0;
                m0: number = 0;
                m0D: number = 0;
                mu: number = 0;
                muD: number = 0;
                ml: number = 0;
                mlD: number = 0;
                m: number = 0;
                mD: number = 0;
                sigmaC: number = 0;
                pc: number = 0;
                pcD: number = 0;
                sigmaL: number = 0;
                pl: number = 0;
                plD: number = 0;
                poissonsRatio: number = 0;
                q: number = 0;
                generic: ng.material.soil.Generic[] = [];
                a: number = 0;
                s: number = 0;
                mb: number = 0;
                consCpt: ng.material.soil.ConsolidationCpt | null = null;
                wallStrength: ng.material.soil.WallStrength | null = null;
                alfa: ng.material.soil.PileShaftResistance | null = null;
                beta: ng.material.soil.PileShaftResistance | null = null;
                Nc: number = 0;
                Nq: number = 0;
                NcD: number = 0;
                qsdMax: number = 0;
                qbdMax: number = 0;
                ksigma: number = 0;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.cuk !== undefined && src.cuk !== null) {
                        if (typeof src.cuk === "number" || src.cuk === 'NaN' || src.cuk === 'Infinity' || src.cuk === '-Infinity') {
                            dst.cuk = AsNum(src.cuk);
                        }
                        else {
                            console.log('Expected cuk of CharacteristicData to be a number but was ', typeof src.cuk, src.cuk)
                        }
                    }
                    if (src.cukD !== undefined && src.cukD !== null) {
                        if (typeof src.cukD === "number" || src.cukD === 'NaN' || src.cukD === 'Infinity' || src.cukD === '-Infinity') {
                            dst.cukD = AsNum(src.cukD);
                        }
                        else {
                            console.log('Expected cukD of CharacteristicData to be a number but was ', typeof src.cukD, src.cukD)
                        }
                    }
                    if (src.ck !== undefined && src.ck !== null) {
                        if (typeof src.ck === "number" || src.ck === 'NaN' || src.ck === 'Infinity' || src.ck === '-Infinity') {
                            dst.ck = AsNum(src.ck);
                        }
                        else {
                            console.log('Expected ck of CharacteristicData to be a number but was ', typeof src.ck, src.ck)
                        }
                    }
                    if (src.ckD !== undefined && src.ckD !== null) {
                        if (typeof src.ckD === "number" || src.ckD === 'NaN' || src.ckD === 'Infinity' || src.ckD === '-Infinity') {
                            dst.ckD = AsNum(src.ckD);
                        }
                        else {
                            console.log('Expected ckD of CharacteristicData to be a number but was ', typeof src.ckD, src.ckD)
                        }
                    }
                    if (src.phiK !== undefined && src.phiK !== null) {
                        if (typeof src.phiK === "number" || src.phiK === 'NaN' || src.phiK === 'Infinity' || src.phiK === '-Infinity') {
                            dst.phiK = AsNum(src.phiK);
                        }
                        else {
                            console.log('Expected phiK of CharacteristicData to be a number but was ', typeof src.phiK, src.phiK)
                        }
                    }
                    if (src.phiCvk !== undefined && src.phiCvk !== null) {
                        if (typeof src.phiCvk === "number" || src.phiCvk === 'NaN' || src.phiCvk === 'Infinity' || src.phiCvk === '-Infinity') {
                            dst.phiCvk = AsNum(src.phiCvk);
                        }
                        else {
                            console.log('Expected phiCvk of CharacteristicData to be a number but was ', typeof src.phiCvk, src.phiCvk)
                        }
                    }
                    if (src.rk !== undefined && src.rk !== null) {
                        if (typeof src.rk === "number" || src.rk === 'NaN' || src.rk === 'Infinity' || src.rk === '-Infinity') {
                            dst.rk = AsNum(src.rk);
                        }
                        else {
                            console.log('Expected rk of CharacteristicData to be a number but was ', typeof src.rk, src.rk)
                        }
                    }
                    if (src.gamma !== undefined && src.gamma !== null) {
                        if (typeof src.gamma === "number" || src.gamma === 'NaN' || src.gamma === 'Infinity' || src.gamma === '-Infinity') {
                            dst.gamma = AsNum(src.gamma);
                        }
                        else {
                            console.log('Expected gamma of CharacteristicData to be a number but was ', typeof src.gamma, src.gamma)
                        }
                    }
                    if (src.gammaEffective !== undefined && src.gammaEffective !== null) {
                        if (typeof src.gammaEffective === "number" || src.gammaEffective === 'NaN' || src.gammaEffective === 'Infinity' || src.gammaEffective === '-Infinity') {
                            dst.gammaEffective = AsNum(src.gammaEffective);
                        }
                        else {
                            console.log('Expected gammaEffective of CharacteristicData to be a number but was ', typeof src.gammaEffective, src.gammaEffective)
                        }
                    }
                    if (src.m0 !== undefined && src.m0 !== null) {
                        if (typeof src.m0 === "number" || src.m0 === 'NaN' || src.m0 === 'Infinity' || src.m0 === '-Infinity') {
                            dst.m0 = AsNum(src.m0);
                        }
                        else {
                            console.log('Expected m0 of CharacteristicData to be a number but was ', typeof src.m0, src.m0)
                        }
                    }
                    if (src.m0D !== undefined && src.m0D !== null) {
                        if (typeof src.m0D === "number" || src.m0D === 'NaN' || src.m0D === 'Infinity' || src.m0D === '-Infinity') {
                            dst.m0D = AsNum(src.m0D);
                        }
                        else {
                            console.log('Expected m0D of CharacteristicData to be a number but was ', typeof src.m0D, src.m0D)
                        }
                    }
                    if (src.mu !== undefined && src.mu !== null) {
                        if (typeof src.mu === "number" || src.mu === 'NaN' || src.mu === 'Infinity' || src.mu === '-Infinity') {
                            dst.mu = AsNum(src.mu);
                        }
                        else {
                            console.log('Expected mu of CharacteristicData to be a number but was ', typeof src.mu, src.mu)
                        }
                    }
                    if (src.muD !== undefined && src.muD !== null) {
                        if (typeof src.muD === "number" || src.muD === 'NaN' || src.muD === 'Infinity' || src.muD === '-Infinity') {
                            dst.muD = AsNum(src.muD);
                        }
                        else {
                            console.log('Expected muD of CharacteristicData to be a number but was ', typeof src.muD, src.muD)
                        }
                    }
                    if (src.ml !== undefined && src.ml !== null) {
                        if (typeof src.ml === "number" || src.ml === 'NaN' || src.ml === 'Infinity' || src.ml === '-Infinity') {
                            dst.ml = AsNum(src.ml);
                        }
                        else {
                            console.log('Expected ml of CharacteristicData to be a number but was ', typeof src.ml, src.ml)
                        }
                    }
                    if (src.mlD !== undefined && src.mlD !== null) {
                        if (typeof src.mlD === "number" || src.mlD === 'NaN' || src.mlD === 'Infinity' || src.mlD === '-Infinity') {
                            dst.mlD = AsNum(src.mlD);
                        }
                        else {
                            console.log('Expected mlD of CharacteristicData to be a number but was ', typeof src.mlD, src.mlD)
                        }
                    }
                    if (src.m !== undefined && src.m !== null) {
                        if (typeof src.m === "number" || src.m === 'NaN' || src.m === 'Infinity' || src.m === '-Infinity') {
                            dst.m = AsNum(src.m);
                        }
                        else {
                            console.log('Expected m of CharacteristicData to be a number but was ', typeof src.m, src.m)
                        }
                    }
                    if (src.mD !== undefined && src.mD !== null) {
                        if (typeof src.mD === "number" || src.mD === 'NaN' || src.mD === 'Infinity' || src.mD === '-Infinity') {
                            dst.mD = AsNum(src.mD);
                        }
                        else {
                            console.log('Expected mD of CharacteristicData to be a number but was ', typeof src.mD, src.mD)
                        }
                    }
                    if (src.sigmaC !== undefined && src.sigmaC !== null) {
                        if (typeof src.sigmaC === "number" || src.sigmaC === 'NaN' || src.sigmaC === 'Infinity' || src.sigmaC === '-Infinity') {
                            dst.sigmaC = AsNum(src.sigmaC);
                        }
                        else {
                            console.log('Expected sigmaC of CharacteristicData to be a number but was ', typeof src.sigmaC, src.sigmaC)
                        }
                    }
                    if (src.pc !== undefined && src.pc !== null) {
                        if (typeof src.pc === "number" || src.pc === 'NaN' || src.pc === 'Infinity' || src.pc === '-Infinity') {
                            dst.pc = AsNum(src.pc);
                        }
                        else {
                            console.log('Expected pc of CharacteristicData to be a number but was ', typeof src.pc, src.pc)
                        }
                    }
                    if (src.pcD !== undefined && src.pcD !== null) {
                        if (typeof src.pcD === "number" || src.pcD === 'NaN' || src.pcD === 'Infinity' || src.pcD === '-Infinity') {
                            dst.pcD = AsNum(src.pcD);
                        }
                        else {
                            console.log('Expected pcD of CharacteristicData to be a number but was ', typeof src.pcD, src.pcD)
                        }
                    }
                    if (src.sigmaL !== undefined && src.sigmaL !== null) {
                        if (typeof src.sigmaL === "number" || src.sigmaL === 'NaN' || src.sigmaL === 'Infinity' || src.sigmaL === '-Infinity') {
                            dst.sigmaL = AsNum(src.sigmaL);
                        }
                        else {
                            console.log('Expected sigmaL of CharacteristicData to be a number but was ', typeof src.sigmaL, src.sigmaL)
                        }
                    }
                    if (src.pl !== undefined && src.pl !== null) {
                        if (typeof src.pl === "number" || src.pl === 'NaN' || src.pl === 'Infinity' || src.pl === '-Infinity') {
                            dst.pl = AsNum(src.pl);
                        }
                        else {
                            console.log('Expected pl of CharacteristicData to be a number but was ', typeof src.pl, src.pl)
                        }
                    }
                    if (src.plD !== undefined && src.plD !== null) {
                        if (typeof src.plD === "number" || src.plD === 'NaN' || src.plD === 'Infinity' || src.plD === '-Infinity') {
                            dst.plD = AsNum(src.plD);
                        }
                        else {
                            console.log('Expected plD of CharacteristicData to be a number but was ', typeof src.plD, src.plD)
                        }
                    }
                    if (src.poissonsRatio !== undefined && src.poissonsRatio !== null) {
                        if (typeof src.poissonsRatio === "number" || src.poissonsRatio === 'NaN' || src.poissonsRatio === 'Infinity' || src.poissonsRatio === '-Infinity') {
                            dst.poissonsRatio = AsNum(src.poissonsRatio);
                        }
                        else {
                            console.log('Expected poissonsRatio of CharacteristicData to be a number but was ', typeof src.poissonsRatio, src.poissonsRatio)
                        }
                    }
                    if (src.q !== undefined && src.q !== null) {
                        if (typeof src.q === "number" || src.q === 'NaN' || src.q === 'Infinity' || src.q === '-Infinity') {
                            dst.q = AsNum(src.q);
                        }
                        else {
                            console.log('Expected q of CharacteristicData to be a number but was ', typeof src.q, src.q)
                        }
                    }
                    if (src.generic !== undefined && src.generic !== null) {
                        if (Array.isArray(src.generic)) {
                            for (const element of src.generic) {
                                dst.generic.push(ng.material.soil.Generic.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected generic of CharacteristicData to be a array but was ', typeof src.generic, src.generic)
                        }
                    }
                    if (src.a !== undefined && src.a !== null) {
                        if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                            dst.a = AsNum(src.a);
                        }
                        else {
                            console.log('Expected a of CharacteristicData to be a number but was ', typeof src.a, src.a)
                        }
                    }
                    if (src.s !== undefined && src.s !== null) {
                        if (typeof src.s === "number" || src.s === 'NaN' || src.s === 'Infinity' || src.s === '-Infinity') {
                            dst.s = AsNum(src.s);
                        }
                        else {
                            console.log('Expected s of CharacteristicData to be a number but was ', typeof src.s, src.s)
                        }
                    }
                    if (src.mb !== undefined && src.mb !== null) {
                        if (typeof src.mb === "number" || src.mb === 'NaN' || src.mb === 'Infinity' || src.mb === '-Infinity') {
                            dst.mb = AsNum(src.mb);
                        }
                        else {
                            console.log('Expected mb of CharacteristicData to be a number but was ', typeof src.mb, src.mb)
                        }
                    }
                    if (src.consCpt !== undefined && src.consCpt !== null) {
                        dst.consCpt = ng.material.soil.ConsolidationCpt.fromObject(src.consCpt);
                    }
                    if (src.wallStrength !== undefined && src.wallStrength !== null) {
                        dst.wallStrength = ng.material.soil.WallStrength.fromObject(src.wallStrength);
                    }
                    if (src.alfa !== undefined && src.alfa !== null) {
                        dst.alfa = ng.material.soil.PileShaftResistance.fromObject(src.alfa);
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        dst.beta = ng.material.soil.PileShaftResistance.fromObject(src.beta);
                    }
                    if (src.Nc !== undefined && src.Nc !== null) {
                        if (typeof src.Nc === "number" || src.Nc === 'NaN' || src.Nc === 'Infinity' || src.Nc === '-Infinity') {
                            dst.Nc = AsNum(src.Nc);
                        }
                        else {
                            console.log('Expected Nc of CharacteristicData to be a number but was ', typeof src.Nc, src.Nc)
                        }
                    }
                    if (src.Nq !== undefined && src.Nq !== null) {
                        if (typeof src.Nq === "number" || src.Nq === 'NaN' || src.Nq === 'Infinity' || src.Nq === '-Infinity') {
                            dst.Nq = AsNum(src.Nq);
                        }
                        else {
                            console.log('Expected Nq of CharacteristicData to be a number but was ', typeof src.Nq, src.Nq)
                        }
                    }
                    if (src.NcD !== undefined && src.NcD !== null) {
                        if (typeof src.NcD === "number" || src.NcD === 'NaN' || src.NcD === 'Infinity' || src.NcD === '-Infinity') {
                            dst.NcD = AsNum(src.NcD);
                        }
                        else {
                            console.log('Expected NcD of CharacteristicData to be a number but was ', typeof src.NcD, src.NcD)
                        }
                    }
                    if (src.qsdMax !== undefined && src.qsdMax !== null) {
                        if (typeof src.qsdMax === "number" || src.qsdMax === 'NaN' || src.qsdMax === 'Infinity' || src.qsdMax === '-Infinity') {
                            dst.qsdMax = AsNum(src.qsdMax);
                        }
                        else {
                            console.log('Expected qsdMax of CharacteristicData to be a number but was ', typeof src.qsdMax, src.qsdMax)
                        }
                    }
                    if (src.qbdMax !== undefined && src.qbdMax !== null) {
                        if (typeof src.qbdMax === "number" || src.qbdMax === 'NaN' || src.qbdMax === 'Infinity' || src.qbdMax === '-Infinity') {
                            dst.qbdMax = AsNum(src.qbdMax);
                        }
                        else {
                            console.log('Expected qbdMax of CharacteristicData to be a number but was ', typeof src.qbdMax, src.qbdMax)
                        }
                    }
                    if (src.ksigma !== undefined && src.ksigma !== null) {
                        if (typeof src.ksigma === "number" || src.ksigma === 'NaN' || src.ksigma === 'Infinity' || src.ksigma === '-Infinity') {
                            dst.ksigma = AsNum(src.ksigma);
                        }
                        else {
                            console.log('Expected ksigma of CharacteristicData to be a number but was ', typeof src.ksigma, src.ksigma)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.soil.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.soil.CharacteristicData") {
                        console.error('Expected ng.material.soil.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CharacteristicData_json = {
                        cuk: AsJsonNum(src.cuk),
                        cukD: AsJsonNum(src.cukD),
                        ck: AsJsonNum(src.ck),
                        ckD: AsJsonNum(src.ckD),
                        phiK: AsJsonNum(src.phiK),
                        phiCvk: AsJsonNum(src.phiCvk),
                        rk: AsJsonNum(src.rk),
                        gamma: AsJsonNum(src.gamma),
                        gammaEffective: AsJsonNum(src.gammaEffective),
                        m0: AsJsonNum(src.m0),
                        m0D: AsJsonNum(src.m0D),
                        mu: AsJsonNum(src.mu),
                        muD: AsJsonNum(src.muD),
                        ml: AsJsonNum(src.ml),
                        mlD: AsJsonNum(src.mlD),
                        m: AsJsonNum(src.m),
                        mD: AsJsonNum(src.mD),
                        sigmaC: AsJsonNum(src.sigmaC),
                        pc: AsJsonNum(src.pc),
                        pcD: AsJsonNum(src.pcD),
                        sigmaL: AsJsonNum(src.sigmaL),
                        pl: AsJsonNum(src.pl),
                        plD: AsJsonNum(src.plD),
                        poissonsRatio: AsJsonNum(src.poissonsRatio),
                        q: AsJsonNum(src.q),
                        generic: new Array<ng.material.soil.Generic_json>(),
                        a: AsJsonNum(src.a),
                        s: AsJsonNum(src.s),
                        mb: AsJsonNum(src.mb),
                        Nc: AsJsonNum(src.Nc),
                        Nq: AsJsonNum(src.Nq),
                        NcD: AsJsonNum(src.NcD),
                        qsdMax: AsJsonNum(src.qsdMax),
                        qbdMax: AsJsonNum(src.qbdMax),
                        ksigma: AsJsonNum(src.ksigma),
                    };
                    if (src.generic !== null) {
                        for (const element of src.generic) {
                            const parsed = ng.material.soil.Generic.toObject(element);
                            if(parsed === null) return null;
                            dst.generic.push(parsed);
                        }
                    }
                    if(src.consCpt !== null)
                    {
                        const parsed = ng.material.soil.ConsolidationCpt.toObject(src.consCpt);
                        if(parsed === null) return null;
                        dst.consCpt = parsed;
                    }
                    if(src.wallStrength !== null)
                    {
                        const parsed = ng.material.soil.WallStrength.toObject(src.wallStrength);
                        if(parsed === null) return null;
                        dst.wallStrength = parsed;
                    }
                    if(src.alfa !== null)
                    {
                        const parsed = ng.material.soil.PileShaftResistance.toObject(src.alfa);
                        if(parsed === null) return null;
                        dst.alfa = parsed;
                    }
                    if(src.beta !== null)
                    {
                        const parsed = ng.material.soil.PileShaftResistance.toObject(src.beta);
                        if(parsed === null) return null;
                        dst.beta = parsed;
                    }
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.cuk !== undefined) {
                        dst.cuk = src.cuk;
                    }
                    if (src.cukD !== undefined) {
                        dst.cukD = src.cukD;
                    }
                    if (src.ck !== undefined) {
                        dst.ck = src.ck;
                    }
                    if (src.ckD !== undefined) {
                        dst.ckD = src.ckD;
                    }
                    if (src.phiK !== undefined) {
                        dst.phiK = src.phiK;
                    }
                    if (src.phiCvk !== undefined) {
                        dst.phiCvk = src.phiCvk;
                    }
                    if (src.rk !== undefined) {
                        dst.rk = src.rk;
                    }
                    if (src.gamma !== undefined) {
                        dst.gamma = src.gamma;
                    }
                    if (src.gammaEffective !== undefined) {
                        dst.gammaEffective = src.gammaEffective;
                    }
                    if (src.m0 !== undefined) {
                        dst.m0 = src.m0;
                    }
                    if (src.m0D !== undefined) {
                        dst.m0D = src.m0D;
                    }
                    if (src.mu !== undefined) {
                        dst.mu = src.mu;
                    }
                    if (src.muD !== undefined) {
                        dst.muD = src.muD;
                    }
                    if (src.ml !== undefined) {
                        dst.ml = src.ml;
                    }
                    if (src.mlD !== undefined) {
                        dst.mlD = src.mlD;
                    }
                    if (src.m !== undefined) {
                        dst.m = src.m;
                    }
                    if (src.mD !== undefined) {
                        dst.mD = src.mD;
                    }
                    if (src.sigmaC !== undefined) {
                        dst.sigmaC = src.sigmaC;
                    }
                    if (src.pc !== undefined) {
                        dst.pc = src.pc;
                    }
                    if (src.pcD !== undefined) {
                        dst.pcD = src.pcD;
                    }
                    if (src.sigmaL !== undefined) {
                        dst.sigmaL = src.sigmaL;
                    }
                    if (src.pl !== undefined) {
                        dst.pl = src.pl;
                    }
                    if (src.plD !== undefined) {
                        dst.plD = src.plD;
                    }
                    if (src.poissonsRatio !== undefined) {
                        dst.poissonsRatio = src.poissonsRatio;
                    }
                    if (src.q !== undefined) {
                        dst.q = src.q;
                    }
                    if (src.generic !== undefined) {
                        dst.generic = src.generic;
                    }
                    if (src.a !== undefined) {
                        dst.a = src.a;
                    }
                    if (src.s !== undefined) {
                        dst.s = src.s;
                    }
                    if (src.mb !== undefined) {
                        dst.mb = src.mb;
                    }
                    if (src.consCpt !== undefined) {
                        dst.consCpt = src.consCpt;
                    }
                    if (src.wallStrength !== undefined) {
                        dst.wallStrength = src.wallStrength;
                    }
                    if (src.alfa !== undefined) {
                        dst.alfa = src.alfa;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    if (src.Nc !== undefined) {
                        dst.Nc = src.Nc;
                    }
                    if (src.Nq !== undefined) {
                        dst.Nq = src.Nq;
                    }
                    if (src.NcD !== undefined) {
                        dst.NcD = src.NcD;
                    }
                    if (src.qsdMax !== undefined) {
                        dst.qsdMax = src.qsdMax;
                    }
                    if (src.qbdMax !== undefined) {
                        dst.qbdMax = src.qbdMax;
                    }
                    if (src.ksigma !== undefined) {
                        dst.ksigma = src.ksigma;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.cuk = this.cuk;
                    dst.cukD = this.cukD;
                    dst.ck = this.ck;
                    dst.ckD = this.ckD;
                    dst.phiK = this.phiK;
                    dst.phiCvk = this.phiCvk;
                    dst.rk = this.rk;
                    dst.gamma = this.gamma;
                    dst.gammaEffective = this.gammaEffective;
                    dst.m0 = this.m0;
                    dst.m0D = this.m0D;
                    dst.mu = this.mu;
                    dst.muD = this.muD;
                    dst.ml = this.ml;
                    dst.mlD = this.mlD;
                    dst.m = this.m;
                    dst.mD = this.mD;
                    dst.sigmaC = this.sigmaC;
                    dst.pc = this.pc;
                    dst.pcD = this.pcD;
                    dst.sigmaL = this.sigmaL;
                    dst.pl = this.pl;
                    dst.plD = this.plD;
                    dst.poissonsRatio = this.poissonsRatio;
                    dst.q = this.q;
                    dst.generic = this.generic;
                    dst.a = this.a;
                    dst.s = this.s;
                    dst.mb = this.mb;
                    dst.consCpt = this.consCpt;
                    dst.wallStrength = this.wallStrength;
                    dst.alfa = this.alfa;
                    dst.beta = this.beta;
                    dst.Nc = this.Nc;
                    dst.Nq = this.Nq;
                    dst.NcD = this.NcD;
                    dst.qsdMax = this.qsdMax;
                    dst.qbdMax = this.qbdMax;
                    dst.ksigma = this.ksigma;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type WallStrength_keys = 'phik' | 'ck';
            export interface WallStrength_createType {
                phik?: number,
                ck?: number,
            }
            export interface WallStrength_json {
                phik?: JsonNumber;
                ck?: JsonNumber;
            }
            interface WallStrength_json_in {
                __proto_name?: unknown;
                phik?: unknown;
                ck?: unknown;
            }
            export class WallStrength {
                __proto_name = "ng.material.soil.WallStrength";
                phik: number = 0;
                ck: number = 0;

                static fromObject(src_unknown: unknown): WallStrength {
                    const dst = new WallStrength();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted WallStrength but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as WallStrength_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for WallStrength but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.phik !== undefined && src.phik !== null) {
                        if (typeof src.phik === "number" || src.phik === 'NaN' || src.phik === 'Infinity' || src.phik === '-Infinity') {
                            dst.phik = AsNum(src.phik);
                        }
                        else {
                            console.log('Expected phik of WallStrength to be a number but was ', typeof src.phik, src.phik)
                        }
                    }
                    if (src.ck !== undefined && src.ck !== null) {
                        if (typeof src.ck === "number" || src.ck === 'NaN' || src.ck === 'Infinity' || src.ck === '-Infinity') {
                            dst.ck = AsNum(src.ck);
                        }
                        else {
                            console.log('Expected ck of WallStrength to be a number but was ', typeof src.ck, src.ck)
                        }
                    }
                    return dst;
                }

                static toObject(src: WallStrength | null | undefined): WallStrength_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.soil.WallStrength is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.soil.WallStrength") {
                        console.error('Expected ng.material.soil.WallStrength but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : WallStrength_json = {
                        phik: AsJsonNum(src.phik),
                        ck: AsJsonNum(src.ck),
                    };
                    return dst;
                }

                static create(src?: WallStrength_createType) {
                    const dst = new WallStrength();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.phik !== undefined) {
                        dst.phik = src.phik;
                    }
                    if (src.ck !== undefined) {
                        dst.ck = src.ck;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new WallStrength();
                    dst.phik = this.phik;
                    dst.ck = this.ck;
                    return dst;
                }

                deepClone() {
                    const json = WallStrength.toObject(this);
                    const dst = WallStrength.fromObject(json);
                    return dst;
                }
            }
            export type IWallStrength = WallStrength;


            export type PileShaftResistance_keys = 'compression' | 'tension' | 'negative';
            export interface PileShaftResistance_createType {
                compression?: number,
                tension?: number,
                negative?: number,
            }
            export interface PileShaftResistance_json {
                compression?: JsonNumber;
                tension?: JsonNumber;
                negative?: JsonNumber;
            }
            interface PileShaftResistance_json_in {
                __proto_name?: unknown;
                compression?: unknown;
                tension?: unknown;
                negative?: unknown;
            }
            export class PileShaftResistance {
                __proto_name = "ng.material.soil.PileShaftResistance";
                compression: number = 0;
                tension: number = 0;
                negative: number = 0;

                static fromObject(src_unknown: unknown): PileShaftResistance {
                    const dst = new PileShaftResistance();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PileShaftResistance but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PileShaftResistance_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PileShaftResistance but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.compression !== undefined && src.compression !== null) {
                        if (typeof src.compression === "number" || src.compression === 'NaN' || src.compression === 'Infinity' || src.compression === '-Infinity') {
                            dst.compression = AsNum(src.compression);
                        }
                        else {
                            console.log('Expected compression of PileShaftResistance to be a number but was ', typeof src.compression, src.compression)
                        }
                    }
                    if (src.tension !== undefined && src.tension !== null) {
                        if (typeof src.tension === "number" || src.tension === 'NaN' || src.tension === 'Infinity' || src.tension === '-Infinity') {
                            dst.tension = AsNum(src.tension);
                        }
                        else {
                            console.log('Expected tension of PileShaftResistance to be a number but was ', typeof src.tension, src.tension)
                        }
                    }
                    if (src.negative !== undefined && src.negative !== null) {
                        if (typeof src.negative === "number" || src.negative === 'NaN' || src.negative === 'Infinity' || src.negative === '-Infinity') {
                            dst.negative = AsNum(src.negative);
                        }
                        else {
                            console.log('Expected negative of PileShaftResistance to be a number but was ', typeof src.negative, src.negative)
                        }
                    }
                    return dst;
                }

                static toObject(src: PileShaftResistance | null | undefined): PileShaftResistance_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.soil.PileShaftResistance is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.soil.PileShaftResistance") {
                        console.error('Expected ng.material.soil.PileShaftResistance but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PileShaftResistance_json = {
                        compression: AsJsonNum(src.compression),
                        tension: AsJsonNum(src.tension),
                        negative: AsJsonNum(src.negative),
                    };
                    return dst;
                }

                static create(src?: PileShaftResistance_createType) {
                    const dst = new PileShaftResistance();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.compression !== undefined) {
                        dst.compression = src.compression;
                    }
                    if (src.tension !== undefined) {
                        dst.tension = src.tension;
                    }
                    if (src.negative !== undefined) {
                        dst.negative = src.negative;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PileShaftResistance();
                    dst.compression = this.compression;
                    dst.tension = this.tension;
                    dst.negative = this.negative;
                    return dst;
                }

                deepClone() {
                    const json = PileShaftResistance.toObject(this);
                    const dst = PileShaftResistance.fromObject(json);
                    return dst;
                }
            }
            export type IPileShaftResistance = PileShaftResistance;


            export type ConsolidationCpt_keys = 'cc' | 'cs' | 'cp' | 'ca' | 'csw';
            export interface ConsolidationCpt_createType {
                cc?: number,
                cs?: number,
                cp?: number,
                ca?: number,
                csw?: number,
            }
            export interface ConsolidationCpt_json {
                cc?: JsonNumber;
                cs?: JsonNumber;
                cp?: JsonNumber;
                ca?: JsonNumber;
                csw?: JsonNumber;
            }
            interface ConsolidationCpt_json_in {
                __proto_name?: unknown;
                cc?: unknown;
                cs?: unknown;
                cp?: unknown;
                ca?: unknown;
                csw?: unknown;
            }
            export class ConsolidationCpt {
                __proto_name = "ng.material.soil.ConsolidationCpt";
                cc: number = 0;
                cs: number = 0;
                cp: number = 0;
                ca: number = 0;
                csw: number = 0;

                static fromObject(src_unknown: unknown): ConsolidationCpt {
                    const dst = new ConsolidationCpt();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ConsolidationCpt but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ConsolidationCpt_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ConsolidationCpt but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.cc !== undefined && src.cc !== null) {
                        if (typeof src.cc === "number" || src.cc === 'NaN' || src.cc === 'Infinity' || src.cc === '-Infinity') {
                            dst.cc = AsNum(src.cc);
                        }
                        else {
                            console.log('Expected cc of ConsolidationCpt to be a number but was ', typeof src.cc, src.cc)
                        }
                    }
                    if (src.cs !== undefined && src.cs !== null) {
                        if (typeof src.cs === "number" || src.cs === 'NaN' || src.cs === 'Infinity' || src.cs === '-Infinity') {
                            dst.cs = AsNum(src.cs);
                        }
                        else {
                            console.log('Expected cs of ConsolidationCpt to be a number but was ', typeof src.cs, src.cs)
                        }
                    }
                    if (src.cp !== undefined && src.cp !== null) {
                        if (typeof src.cp === "number" || src.cp === 'NaN' || src.cp === 'Infinity' || src.cp === '-Infinity') {
                            dst.cp = AsNum(src.cp);
                        }
                        else {
                            console.log('Expected cp of ConsolidationCpt to be a number but was ', typeof src.cp, src.cp)
                        }
                    }
                    if (src.ca !== undefined && src.ca !== null) {
                        if (typeof src.ca === "number" || src.ca === 'NaN' || src.ca === 'Infinity' || src.ca === '-Infinity') {
                            dst.ca = AsNum(src.ca);
                        }
                        else {
                            console.log('Expected ca of ConsolidationCpt to be a number but was ', typeof src.ca, src.ca)
                        }
                    }
                    if (src.csw !== undefined && src.csw !== null) {
                        if (typeof src.csw === "number" || src.csw === 'NaN' || src.csw === 'Infinity' || src.csw === '-Infinity') {
                            dst.csw = AsNum(src.csw);
                        }
                        else {
                            console.log('Expected csw of ConsolidationCpt to be a number but was ', typeof src.csw, src.csw)
                        }
                    }
                    return dst;
                }

                static toObject(src: ConsolidationCpt | null | undefined): ConsolidationCpt_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.soil.ConsolidationCpt is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.soil.ConsolidationCpt") {
                        console.error('Expected ng.material.soil.ConsolidationCpt but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ConsolidationCpt_json = {
                        cc: AsJsonNum(src.cc),
                        cs: AsJsonNum(src.cs),
                        cp: AsJsonNum(src.cp),
                        ca: AsJsonNum(src.ca),
                        csw: AsJsonNum(src.csw),
                    };
                    return dst;
                }

                static create(src?: ConsolidationCpt_createType) {
                    const dst = new ConsolidationCpt();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.cc !== undefined) {
                        dst.cc = src.cc;
                    }
                    if (src.cs !== undefined) {
                        dst.cs = src.cs;
                    }
                    if (src.cp !== undefined) {
                        dst.cp = src.cp;
                    }
                    if (src.ca !== undefined) {
                        dst.ca = src.ca;
                    }
                    if (src.csw !== undefined) {
                        dst.csw = src.csw;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ConsolidationCpt();
                    dst.cc = this.cc;
                    dst.cs = this.cs;
                    dst.cp = this.cp;
                    dst.ca = this.ca;
                    dst.csw = this.csw;
                    return dst;
                }

                deepClone() {
                    const json = ConsolidationCpt.toObject(this);
                    const dst = ConsolidationCpt.fromObject(json);
                    return dst;
                }
            }
            export type IConsolidationCpt = ConsolidationCpt;


            export type Data_keys = 'id' | 'behaviour' | 'materialModel' | 'referenceLevel' | 'properties';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                behaviour?: ng.material.soil.Behaviour,
                materialModel?: ng.material.soil.MaterialModel,
                referenceLevel?: number,
                properties?: ng.material.soil.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                behaviour?: string;
                materialModel?: string;
                referenceLevel?: JsonNumber;
                properties?: ng.material.soil.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                behaviour?: unknown;
                materialModel?: unknown;
                referenceLevel?: unknown;
                properties?: unknown;
            }
            export class Data {
                __proto_name = "ng.material.soil.Data";
                id: ng.utils.ID | null = null;
                behaviour: ng.material.soil.Behaviour = ng.material.soil.Behaviour.BEHAVIOUR_UNSPECIFIED;
                materialModel: ng.material.soil.MaterialModel = ng.material.soil.MaterialModel.MATERIAL_MODEL_UNSPECIFIED;
                referenceLevel: number = 0;
                properties: ng.material.soil.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.behaviour !== undefined && src.behaviour !== null) {
                        dst.behaviour = ng.material.soil.Behaviour_FromObject(src.behaviour);
                    }
                    if (src.materialModel !== undefined && src.materialModel !== null) {
                        dst.materialModel = ng.material.soil.MaterialModel_FromObject(src.materialModel);
                    }
                    if (src.referenceLevel !== undefined && src.referenceLevel !== null) {
                        if (typeof src.referenceLevel === "number" || src.referenceLevel === 'NaN' || src.referenceLevel === 'Infinity' || src.referenceLevel === '-Infinity') {
                            dst.referenceLevel = AsNum(src.referenceLevel);
                        }
                        else {
                            console.log('Expected referenceLevel of Data to be a number but was ', typeof src.referenceLevel, src.referenceLevel)
                        }
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.material.soil.CharacteristicData.fromObject(src.properties);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.soil.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.soil.Data") {
                        console.error('Expected ng.material.soil.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const behaviour_obj = ng.material.soil.Behaviour_ToObject(src.behaviour);
                    if(behaviour_obj === null) return null;

                    const materialModel_obj = ng.material.soil.MaterialModel_ToObject(src.materialModel);
                    if(materialModel_obj === null) return null;

                    const dst : Data_json = {
                        behaviour: behaviour_obj,
                        materialModel: materialModel_obj,
                        referenceLevel: AsJsonNum(src.referenceLevel),
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.material.soil.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.behaviour !== undefined) {
                        dst.behaviour = src.behaviour;
                    }
                    if (src.materialModel !== undefined) {
                        dst.materialModel = src.materialModel;
                    }
                    if (src.referenceLevel !== undefined) {
                        dst.referenceLevel = src.referenceLevel;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.behaviour = this.behaviour;
                    dst.materialModel = this.materialModel;
                    dst.referenceLevel = this.referenceLevel;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace soil


        // Defined in Material/masonry.proto
        export namespace masonry {
            export enum Product {
                PRODUCT_UNSPECIFIED = 0,
                PRODUCT_CLAY_BLOCKS = 1,
                PRODUCT_HOLE_BRICKS = 2,
                PRODUCT_SOLID_BRICKS = 3,
                PRODUCT_CALCIUM_SILICATE_BRICKS = 4,
                PRODUCT_CONCRETE_BRICKS = 5,
                PRODUCT_CONCRETE_HOLE_BLOCKS = 6,
                PRODUCT_SOLID_CONCRETE_BLOCKS = 7,
                PRODUCT_LIGHTWEIGHT_CONCRETE_BLOCKS = 8,
                PRODUCT_AUTOCLAVED_AERATED_CONCRETE_BLOCKS = 9,
                PRODUCT_LIGHT_EXPANDED_CLAY_AGGREGATE_BLOCKS = 10
            }
            export const Product_FromObject = (src: unknown): Product => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRODUCT_UNSPECIFIED':
                        return Product.PRODUCT_UNSPECIFIED;
                    case 1:
                    case 'PRODUCT_CLAY_BLOCKS':
                        return Product.PRODUCT_CLAY_BLOCKS;
                    case 2:
                    case 'PRODUCT_HOLE_BRICKS':
                        return Product.PRODUCT_HOLE_BRICKS;
                    case 3:
                    case 'PRODUCT_SOLID_BRICKS':
                        return Product.PRODUCT_SOLID_BRICKS;
                    case 4:
                    case 'PRODUCT_CALCIUM_SILICATE_BRICKS':
                        return Product.PRODUCT_CALCIUM_SILICATE_BRICKS;
                    case 5:
                    case 'PRODUCT_CONCRETE_BRICKS':
                        return Product.PRODUCT_CONCRETE_BRICKS;
                    case 6:
                    case 'PRODUCT_CONCRETE_HOLE_BLOCKS':
                        return Product.PRODUCT_CONCRETE_HOLE_BLOCKS;
                    case 7:
                    case 'PRODUCT_SOLID_CONCRETE_BLOCKS':
                        return Product.PRODUCT_SOLID_CONCRETE_BLOCKS;
                    case 8:
                    case 'PRODUCT_LIGHTWEIGHT_CONCRETE_BLOCKS':
                        return Product.PRODUCT_LIGHTWEIGHT_CONCRETE_BLOCKS;
                    case 9:
                    case 'PRODUCT_AUTOCLAVED_AERATED_CONCRETE_BLOCKS':
                        return Product.PRODUCT_AUTOCLAVED_AERATED_CONCRETE_BLOCKS;
                    case 10:
                    case 'PRODUCT_LIGHT_EXPANDED_CLAY_AGGREGATE_BLOCKS':
                        return Product.PRODUCT_LIGHT_EXPANDED_CLAY_AGGREGATE_BLOCKS;
                    default:
                        console.log('Unhandled value for Product:' + src + '. ' + typeof(src));
                        return Product.PRODUCT_UNSPECIFIED;
                }
            };
            export const Product_ToObject = (src: Product): string | null => {
                switch (src) {
                    case Product.PRODUCT_UNSPECIFIED:
                        return 'PRODUCT_UNSPECIFIED';
                    case Product.PRODUCT_CLAY_BLOCKS:
                        return 'PRODUCT_CLAY_BLOCKS';
                    case Product.PRODUCT_HOLE_BRICKS:
                        return 'PRODUCT_HOLE_BRICKS';
                    case Product.PRODUCT_SOLID_BRICKS:
                        return 'PRODUCT_SOLID_BRICKS';
                    case Product.PRODUCT_CALCIUM_SILICATE_BRICKS:
                        return 'PRODUCT_CALCIUM_SILICATE_BRICKS';
                    case Product.PRODUCT_CONCRETE_BRICKS:
                        return 'PRODUCT_CONCRETE_BRICKS';
                    case Product.PRODUCT_CONCRETE_HOLE_BLOCKS:
                        return 'PRODUCT_CONCRETE_HOLE_BLOCKS';
                    case Product.PRODUCT_SOLID_CONCRETE_BLOCKS:
                        return 'PRODUCT_SOLID_CONCRETE_BLOCKS';
                    case Product.PRODUCT_LIGHTWEIGHT_CONCRETE_BLOCKS:
                        return 'PRODUCT_LIGHTWEIGHT_CONCRETE_BLOCKS';
                    case Product.PRODUCT_AUTOCLAVED_AERATED_CONCRETE_BLOCKS:
                        return 'PRODUCT_AUTOCLAVED_AERATED_CONCRETE_BLOCKS';
                    case Product.PRODUCT_LIGHT_EXPANDED_CLAY_AGGREGATE_BLOCKS:
                        return 'PRODUCT_LIGHT_EXPANDED_CLAY_AGGREGATE_BLOCKS';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Product, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Manner {
                MANNER_UNSPECIFIED = 0,
                MANNER_FJM = 1,
                MANNER_UMV = 2,
                MANNER_SBM = 3
            }
            export const Manner_FromObject = (src: unknown): Manner => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'MANNER_UNSPECIFIED':
                        return Manner.MANNER_UNSPECIFIED;
                    case 1:
                    case 'MANNER_FJM':
                        return Manner.MANNER_FJM;
                    case 2:
                    case 'MANNER_UMV':
                        return Manner.MANNER_UMV;
                    case 3:
                    case 'MANNER_SBM':
                        return Manner.MANNER_SBM;
                    default:
                        console.log('Unhandled value for Manner:' + src + '. ' + typeof(src));
                        return Manner.MANNER_UNSPECIFIED;
                }
            };
            export const Manner_ToObject = (src: Manner): string | null => {
                switch (src) {
                    case Manner.MANNER_UNSPECIFIED:
                        return 'MANNER_UNSPECIFIED';
                    case Manner.MANNER_FJM:
                        return 'MANNER_FJM';
                    case Manner.MANNER_UMV:
                        return 'MANNER_UMV';
                    case Manner.MANNER_SBM:
                        return 'MANNER_SBM';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Manner, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Group {
                GROUP_UNSPECIFIED = 0,
                GROUP_1 = 1,
                GROUP_2 = 2,
                GROUP_3 = 3,
                GROUP_4 = 4
            }
            export const Group_FromObject = (src: unknown): Group => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'GROUP_UNSPECIFIED':
                        return Group.GROUP_UNSPECIFIED;
                    case 1:
                    case 'GROUP_1':
                        return Group.GROUP_1;
                    case 2:
                    case 'GROUP_2':
                        return Group.GROUP_2;
                    case 3:
                    case 'GROUP_3':
                        return Group.GROUP_3;
                    case 4:
                    case 'GROUP_4':
                        return Group.GROUP_4;
                    default:
                        console.log('Unhandled value for Group:' + src + '. ' + typeof(src));
                        return Group.GROUP_UNSPECIFIED;
                }
            };
            export const Group_ToObject = (src: Group): string | null => {
                switch (src) {
                    case Group.GROUP_UNSPECIFIED:
                        return 'GROUP_UNSPECIFIED';
                    case Group.GROUP_1:
                        return 'GROUP_1';
                    case Group.GROUP_2:
                        return 'GROUP_2';
                    case Group.GROUP_3:
                        return 'GROUP_3';
                    case Group.GROUP_4:
                        return 'GROUP_4';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Group, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Class {
                CLASS_UNSPECIFIED = 0,
                CLASS_25 = 1
            }
            export const Class_FromObject = (src: unknown): Class => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CLASS_UNSPECIFIED':
                        return Class.CLASS_UNSPECIFIED;
                    case 1:
                    case 'CLASS_25':
                        return Class.CLASS_25;
                    default:
                        console.log('Unhandled value for Class:' + src + '. ' + typeof(src));
                        return Class.CLASS_UNSPECIFIED;
                }
            };
            export const Class_ToObject = (src: Class): string | null => {
                switch (src) {
                    case Class.CLASS_UNSPECIFIED:
                        return 'CLASS_UNSPECIFIED';
                    case Class.CLASS_25:
                        return 'CLASS_25';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Class, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Category {
                CATEGORY_UNSPECIFIED = 0,
                CATEGORY_DESIGNED_MORTAR_CATEGORY1 = 1,
                CATEGORY_PRESCRIBED_MORTAR_CATEGORY1 = 2,
                CATEGORY_ANY_MORTAR_CATEGORY2 = 3
            }
            export const Category_FromObject = (src: unknown): Category => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CATEGORY_UNSPECIFIED':
                        return Category.CATEGORY_UNSPECIFIED;
                    case 1:
                    case 'CATEGORY_DESIGNED_MORTAR_CATEGORY1':
                        return Category.CATEGORY_DESIGNED_MORTAR_CATEGORY1;
                    case 2:
                    case 'CATEGORY_PRESCRIBED_MORTAR_CATEGORY1':
                        return Category.CATEGORY_PRESCRIBED_MORTAR_CATEGORY1;
                    case 3:
                    case 'CATEGORY_ANY_MORTAR_CATEGORY2':
                        return Category.CATEGORY_ANY_MORTAR_CATEGORY2;
                    default:
                        console.log('Unhandled value for Category:' + src + '. ' + typeof(src));
                        return Category.CATEGORY_UNSPECIFIED;
                }
            };
            export const Category_ToObject = (src: Category): string | null => {
                switch (src) {
                    case Category.CATEGORY_UNSPECIFIED:
                        return 'CATEGORY_UNSPECIFIED';
                    case Category.CATEGORY_DESIGNED_MORTAR_CATEGORY1:
                        return 'CATEGORY_DESIGNED_MORTAR_CATEGORY1';
                    case Category.CATEGORY_PRESCRIBED_MORTAR_CATEGORY1:
                        return 'CATEGORY_PRESCRIBED_MORTAR_CATEGORY1';
                    case Category.CATEGORY_ANY_MORTAR_CATEGORY2:
                        return 'CATEGORY_ANY_MORTAR_CATEGORY2';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Category, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type CharacteristicData_keys = 'fkx' | 'fky' | 'fxk1' | 'fxk2' | 'fvk0' | 'fvlt' | 'fb' | 'fm' | 'fmxk1' | 'Ex' | 'Ey' | 'density';
            export interface CharacteristicData_createType {
                fkx?: number,
                fky?: number,
                fxk1?: number,
                fxk2?: number,
                fvk0?: number,
                fvlt?: number,
                fb?: number,
                fm?: number,
                fmxk1?: number,
                Ex?: number,
                Ey?: number,
                density?: number,
            }
            export interface CharacteristicData_json {
                fkx?: JsonNumber;
                fky?: JsonNumber;
                fxk1?: JsonNumber;
                fxk2?: JsonNumber;
                fvk0?: JsonNumber;
                fvlt?: JsonNumber;
                fb?: JsonNumber;
                fm?: JsonNumber;
                fmxk1?: JsonNumber;
                Ex?: JsonNumber;
                Ey?: JsonNumber;
                density?: JsonNumber;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                fkx?: unknown;
                fky?: unknown;
                fxk1?: unknown;
                fxk2?: unknown;
                fvk0?: unknown;
                fvlt?: unknown;
                fb?: unknown;
                fm?: unknown;
                fmxk1?: unknown;
                Ex?: unknown;
                Ey?: unknown;
                density?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.material.masonry.CharacteristicData";
                fkx: number = 0;
                fky: number = 0;
                fxk1: number = 0;
                fxk2: number = 0;
                fvk0: number = 0;
                fvlt: number = 0;
                fb: number = 0;
                fm: number = 0;
                fmxk1: number = 0;
                Ex: number = 0;
                Ey: number = 0;
                density: number = 0;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fkx !== undefined && src.fkx !== null) {
                        if (typeof src.fkx === "number" || src.fkx === 'NaN' || src.fkx === 'Infinity' || src.fkx === '-Infinity') {
                            dst.fkx = AsNum(src.fkx);
                        }
                        else {
                            console.log('Expected fkx of CharacteristicData to be a number but was ', typeof src.fkx, src.fkx)
                        }
                    }
                    if (src.fky !== undefined && src.fky !== null) {
                        if (typeof src.fky === "number" || src.fky === 'NaN' || src.fky === 'Infinity' || src.fky === '-Infinity') {
                            dst.fky = AsNum(src.fky);
                        }
                        else {
                            console.log('Expected fky of CharacteristicData to be a number but was ', typeof src.fky, src.fky)
                        }
                    }
                    if (src.fxk1 !== undefined && src.fxk1 !== null) {
                        if (typeof src.fxk1 === "number" || src.fxk1 === 'NaN' || src.fxk1 === 'Infinity' || src.fxk1 === '-Infinity') {
                            dst.fxk1 = AsNum(src.fxk1);
                        }
                        else {
                            console.log('Expected fxk1 of CharacteristicData to be a number but was ', typeof src.fxk1, src.fxk1)
                        }
                    }
                    if (src.fxk2 !== undefined && src.fxk2 !== null) {
                        if (typeof src.fxk2 === "number" || src.fxk2 === 'NaN' || src.fxk2 === 'Infinity' || src.fxk2 === '-Infinity') {
                            dst.fxk2 = AsNum(src.fxk2);
                        }
                        else {
                            console.log('Expected fxk2 of CharacteristicData to be a number but was ', typeof src.fxk2, src.fxk2)
                        }
                    }
                    if (src.fvk0 !== undefined && src.fvk0 !== null) {
                        if (typeof src.fvk0 === "number" || src.fvk0 === 'NaN' || src.fvk0 === 'Infinity' || src.fvk0 === '-Infinity') {
                            dst.fvk0 = AsNum(src.fvk0);
                        }
                        else {
                            console.log('Expected fvk0 of CharacteristicData to be a number but was ', typeof src.fvk0, src.fvk0)
                        }
                    }
                    if (src.fvlt !== undefined && src.fvlt !== null) {
                        if (typeof src.fvlt === "number" || src.fvlt === 'NaN' || src.fvlt === 'Infinity' || src.fvlt === '-Infinity') {
                            dst.fvlt = AsNum(src.fvlt);
                        }
                        else {
                            console.log('Expected fvlt of CharacteristicData to be a number but was ', typeof src.fvlt, src.fvlt)
                        }
                    }
                    if (src.fb !== undefined && src.fb !== null) {
                        if (typeof src.fb === "number" || src.fb === 'NaN' || src.fb === 'Infinity' || src.fb === '-Infinity') {
                            dst.fb = AsNum(src.fb);
                        }
                        else {
                            console.log('Expected fb of CharacteristicData to be a number but was ', typeof src.fb, src.fb)
                        }
                    }
                    if (src.fm !== undefined && src.fm !== null) {
                        if (typeof src.fm === "number" || src.fm === 'NaN' || src.fm === 'Infinity' || src.fm === '-Infinity') {
                            dst.fm = AsNum(src.fm);
                        }
                        else {
                            console.log('Expected fm of CharacteristicData to be a number but was ', typeof src.fm, src.fm)
                        }
                    }
                    if (src.fmxk1 !== undefined && src.fmxk1 !== null) {
                        if (typeof src.fmxk1 === "number" || src.fmxk1 === 'NaN' || src.fmxk1 === 'Infinity' || src.fmxk1 === '-Infinity') {
                            dst.fmxk1 = AsNum(src.fmxk1);
                        }
                        else {
                            console.log('Expected fmxk1 of CharacteristicData to be a number but was ', typeof src.fmxk1, src.fmxk1)
                        }
                    }
                    if (src.Ex !== undefined && src.Ex !== null) {
                        if (typeof src.Ex === "number" || src.Ex === 'NaN' || src.Ex === 'Infinity' || src.Ex === '-Infinity') {
                            dst.Ex = AsNum(src.Ex);
                        }
                        else {
                            console.log('Expected Ex of CharacteristicData to be a number but was ', typeof src.Ex, src.Ex)
                        }
                    }
                    if (src.Ey !== undefined && src.Ey !== null) {
                        if (typeof src.Ey === "number" || src.Ey === 'NaN' || src.Ey === 'Infinity' || src.Ey === '-Infinity') {
                            dst.Ey = AsNum(src.Ey);
                        }
                        else {
                            console.log('Expected Ey of CharacteristicData to be a number but was ', typeof src.Ey, src.Ey)
                        }
                    }
                    if (src.density !== undefined && src.density !== null) {
                        if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                            dst.density = AsNum(src.density);
                        }
                        else {
                            console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.masonry.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.masonry.CharacteristicData") {
                        console.error('Expected ng.material.masonry.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CharacteristicData_json = {
                        fkx: AsJsonNum(src.fkx),
                        fky: AsJsonNum(src.fky),
                        fxk1: AsJsonNum(src.fxk1),
                        fxk2: AsJsonNum(src.fxk2),
                        fvk0: AsJsonNum(src.fvk0),
                        fvlt: AsJsonNum(src.fvlt),
                        fb: AsJsonNum(src.fb),
                        fm: AsJsonNum(src.fm),
                        fmxk1: AsJsonNum(src.fmxk1),
                        Ex: AsJsonNum(src.Ex),
                        Ey: AsJsonNum(src.Ey),
                        density: AsJsonNum(src.density),
                    };
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fkx !== undefined) {
                        dst.fkx = src.fkx;
                    }
                    if (src.fky !== undefined) {
                        dst.fky = src.fky;
                    }
                    if (src.fxk1 !== undefined) {
                        dst.fxk1 = src.fxk1;
                    }
                    if (src.fxk2 !== undefined) {
                        dst.fxk2 = src.fxk2;
                    }
                    if (src.fvk0 !== undefined) {
                        dst.fvk0 = src.fvk0;
                    }
                    if (src.fvlt !== undefined) {
                        dst.fvlt = src.fvlt;
                    }
                    if (src.fb !== undefined) {
                        dst.fb = src.fb;
                    }
                    if (src.fm !== undefined) {
                        dst.fm = src.fm;
                    }
                    if (src.fmxk1 !== undefined) {
                        dst.fmxk1 = src.fmxk1;
                    }
                    if (src.Ex !== undefined) {
                        dst.Ex = src.Ex;
                    }
                    if (src.Ey !== undefined) {
                        dst.Ey = src.Ey;
                    }
                    if (src.density !== undefined) {
                        dst.density = src.density;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.fkx = this.fkx;
                    dst.fky = this.fky;
                    dst.fxk1 = this.fxk1;
                    dst.fxk2 = this.fxk2;
                    dst.fvk0 = this.fvk0;
                    dst.fvlt = this.fvlt;
                    dst.fb = this.fb;
                    dst.fm = this.fm;
                    dst.fmxk1 = this.fmxk1;
                    dst.Ex = this.Ex;
                    dst.Ey = this.Ey;
                    dst.density = this.density;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type Data_keys = 'id' | 'product' | 'manner' | 'group' | 'class' | 'category' | 'strengthClass' | 'mortarSlipWidth' | 'properties';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                product?: ng.material.masonry.Product,
                manner?: ng.material.masonry.Manner,
                group?: ng.material.masonry.Group,
                class?: ng.material.masonry.Class,
                category?: ng.material.masonry.Category,
                strengthClass?: number,
                mortarSlipWidth?: number,
                properties?: ng.material.masonry.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                product?: string;
                manner?: string;
                group?: string;
                class?: string;
                category?: string;
                strengthClass?: JsonNumber;
                mortarSlipWidth?: JsonNumber;
                properties?: ng.material.masonry.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                product?: unknown;
                manner?: unknown;
                group?: unknown;
                class?: unknown;
                category?: unknown;
                strengthClass?: unknown;
                mortarSlipWidth?: unknown;
                properties?: unknown;
            }
            export class Data {
                __proto_name = "ng.material.masonry.Data";
                id: ng.utils.ID | null = null;
                product: ng.material.masonry.Product = ng.material.masonry.Product.PRODUCT_UNSPECIFIED;
                manner: ng.material.masonry.Manner = ng.material.masonry.Manner.MANNER_UNSPECIFIED;
                group: ng.material.masonry.Group = ng.material.masonry.Group.GROUP_UNSPECIFIED;
                class: ng.material.masonry.Class = ng.material.masonry.Class.CLASS_UNSPECIFIED;
                category: ng.material.masonry.Category = ng.material.masonry.Category.CATEGORY_UNSPECIFIED;
                strengthClass: number = 0;
                mortarSlipWidth: number = 0;
                properties: ng.material.masonry.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.product !== undefined && src.product !== null) {
                        dst.product = ng.material.masonry.Product_FromObject(src.product);
                    }
                    if (src.manner !== undefined && src.manner !== null) {
                        dst.manner = ng.material.masonry.Manner_FromObject(src.manner);
                    }
                    if (src.group !== undefined && src.group !== null) {
                        dst.group = ng.material.masonry.Group_FromObject(src.group);
                    }
                    if (src.class !== undefined && src.class !== null) {
                        dst.class = ng.material.masonry.Class_FromObject(src.class);
                    }
                    if (src.category !== undefined && src.category !== null) {
                        dst.category = ng.material.masonry.Category_FromObject(src.category);
                    }
                    if (src.strengthClass !== undefined && src.strengthClass !== null) {
                        if (typeof src.strengthClass === "number" || src.strengthClass === 'NaN' || src.strengthClass === 'Infinity' || src.strengthClass === '-Infinity') {
                            dst.strengthClass = NumberToInt("ng.material.masonry.Data.strength_class", AsNum(src.strengthClass));
                        }
                        else {
                            console.log('Expected strengthClass of Data to be a number but was ', typeof src.strengthClass, src.strengthClass)
                        }
                    }
                    if (src.mortarSlipWidth !== undefined && src.mortarSlipWidth !== null) {
                        if (typeof src.mortarSlipWidth === "number" || src.mortarSlipWidth === 'NaN' || src.mortarSlipWidth === 'Infinity' || src.mortarSlipWidth === '-Infinity') {
                            dst.mortarSlipWidth = AsNum(src.mortarSlipWidth);
                        }
                        else {
                            console.log('Expected mortarSlipWidth of Data to be a number but was ', typeof src.mortarSlipWidth, src.mortarSlipWidth)
                        }
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.material.masonry.CharacteristicData.fromObject(src.properties);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.masonry.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.masonry.Data") {
                        console.error('Expected ng.material.masonry.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const product_obj = ng.material.masonry.Product_ToObject(src.product);
                    if(product_obj === null) return null;

                    const manner_obj = ng.material.masonry.Manner_ToObject(src.manner);
                    if(manner_obj === null) return null;

                    const group_obj = ng.material.masonry.Group_ToObject(src.group);
                    if(group_obj === null) return null;

                    const class_obj = ng.material.masonry.Class_ToObject(src.class);
                    if(class_obj === null) return null;

                    const category_obj = ng.material.masonry.Category_ToObject(src.category);
                    if(category_obj === null) return null;

                    const dst : Data_json = {
                        product: product_obj,
                        manner: manner_obj,
                        group: group_obj,
                        class: class_obj,
                        category: category_obj,
                        strengthClass: AsJsonNum(NumberToInt("ng.material.masonry.Data.strength_class", src.strengthClass)),
                        mortarSlipWidth: AsJsonNum(src.mortarSlipWidth),
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.material.masonry.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.product !== undefined) {
                        dst.product = src.product;
                    }
                    if (src.manner !== undefined) {
                        dst.manner = src.manner;
                    }
                    if (src.group !== undefined) {
                        dst.group = src.group;
                    }
                    if (src.class !== undefined) {
                        dst.class = src.class;
                    }
                    if (src.category !== undefined) {
                        dst.category = src.category;
                    }
                    if (src.strengthClass !== undefined) {
                        dst.strengthClass = src.strengthClass;
                    }
                    if (src.mortarSlipWidth !== undefined) {
                        dst.mortarSlipWidth = src.mortarSlipWidth;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.product = this.product;
                    dst.manner = this.manner;
                    dst.group = this.group;
                    dst.class = this.class;
                    dst.category = this.category;
                    dst.strengthClass = this.strengthClass;
                    dst.mortarSlipWidth = this.mortarSlipWidth;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace masonry


        // Defined in Material/reinforcement.proto
        export namespace reinforcement {
            export type CharacteristicData_keys = 'elasticityModulus' | 'yieldStrength' | 'ultimateStrength' | 'density' | 'k' | 'epsilonUltimate' | 'epsilonFailure';
            export interface CharacteristicData_createType {
                elasticityModulus?: number,
                yieldStrength?: number,
                ultimateStrength?: number,
                density?: number,
                k?: number,
                epsilonUltimate?: number,
                epsilonFailure?: number,
            }
            export interface CharacteristicData_json {
                elasticityModulus?: JsonNumber;
                yieldStrength?: JsonNumber;
                ultimateStrength?: JsonNumber;
                density?: JsonNumber;
                k?: JsonNumber;
                epsilonUltimate?: JsonNumber;
                epsilonFailure?: JsonNumber;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                elasticityModulus?: unknown;
                yieldStrength?: unknown;
                ultimateStrength?: unknown;
                density?: unknown;
                k?: unknown;
                epsilonUltimate?: unknown;
                epsilonFailure?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.material.reinforcement.CharacteristicData";
                elasticityModulus: number = 0;
                yieldStrength: number = 0;
                ultimateStrength: number = 0;
                density: number = 0;
                k: number = 0;
                epsilonUltimate: number = 0;
                epsilonFailure: number = 0;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elasticityModulus !== undefined && src.elasticityModulus !== null) {
                        if (typeof src.elasticityModulus === "number" || src.elasticityModulus === 'NaN' || src.elasticityModulus === 'Infinity' || src.elasticityModulus === '-Infinity') {
                            dst.elasticityModulus = AsNum(src.elasticityModulus);
                        }
                        else {
                            console.log('Expected elasticityModulus of CharacteristicData to be a number but was ', typeof src.elasticityModulus, src.elasticityModulus)
                        }
                    }
                    if (src.yieldStrength !== undefined && src.yieldStrength !== null) {
                        if (typeof src.yieldStrength === "number" || src.yieldStrength === 'NaN' || src.yieldStrength === 'Infinity' || src.yieldStrength === '-Infinity') {
                            dst.yieldStrength = AsNum(src.yieldStrength);
                        }
                        else {
                            console.log('Expected yieldStrength of CharacteristicData to be a number but was ', typeof src.yieldStrength, src.yieldStrength)
                        }
                    }
                    if (src.ultimateStrength !== undefined && src.ultimateStrength !== null) {
                        if (typeof src.ultimateStrength === "number" || src.ultimateStrength === 'NaN' || src.ultimateStrength === 'Infinity' || src.ultimateStrength === '-Infinity') {
                            dst.ultimateStrength = AsNum(src.ultimateStrength);
                        }
                        else {
                            console.log('Expected ultimateStrength of CharacteristicData to be a number but was ', typeof src.ultimateStrength, src.ultimateStrength)
                        }
                    }
                    if (src.density !== undefined && src.density !== null) {
                        if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                            dst.density = AsNum(src.density);
                        }
                        else {
                            console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                        }
                    }
                    if (src.k !== undefined && src.k !== null) {
                        if (typeof src.k === "number" || src.k === 'NaN' || src.k === 'Infinity' || src.k === '-Infinity') {
                            dst.k = AsNum(src.k);
                        }
                        else {
                            console.log('Expected k of CharacteristicData to be a number but was ', typeof src.k, src.k)
                        }
                    }
                    if (src.epsilonUltimate !== undefined && src.epsilonUltimate !== null) {
                        if (typeof src.epsilonUltimate === "number" || src.epsilonUltimate === 'NaN' || src.epsilonUltimate === 'Infinity' || src.epsilonUltimate === '-Infinity') {
                            dst.epsilonUltimate = AsNum(src.epsilonUltimate);
                        }
                        else {
                            console.log('Expected epsilonUltimate of CharacteristicData to be a number but was ', typeof src.epsilonUltimate, src.epsilonUltimate)
                        }
                    }
                    if (src.epsilonFailure !== undefined && src.epsilonFailure !== null) {
                        if (typeof src.epsilonFailure === "number" || src.epsilonFailure === 'NaN' || src.epsilonFailure === 'Infinity' || src.epsilonFailure === '-Infinity') {
                            dst.epsilonFailure = AsNum(src.epsilonFailure);
                        }
                        else {
                            console.log('Expected epsilonFailure of CharacteristicData to be a number but was ', typeof src.epsilonFailure, src.epsilonFailure)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.reinforcement.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.reinforcement.CharacteristicData") {
                        console.error('Expected ng.material.reinforcement.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CharacteristicData_json = {
                        elasticityModulus: AsJsonNum(src.elasticityModulus),
                        yieldStrength: AsJsonNum(src.yieldStrength),
                        ultimateStrength: AsJsonNum(src.ultimateStrength),
                        density: AsJsonNum(src.density),
                        k: AsJsonNum(src.k),
                        epsilonUltimate: AsJsonNum(src.epsilonUltimate),
                        epsilonFailure: AsJsonNum(src.epsilonFailure),
                    };
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elasticityModulus !== undefined) {
                        dst.elasticityModulus = src.elasticityModulus;
                    }
                    if (src.yieldStrength !== undefined) {
                        dst.yieldStrength = src.yieldStrength;
                    }
                    if (src.ultimateStrength !== undefined) {
                        dst.ultimateStrength = src.ultimateStrength;
                    }
                    if (src.density !== undefined) {
                        dst.density = src.density;
                    }
                    if (src.k !== undefined) {
                        dst.k = src.k;
                    }
                    if (src.epsilonUltimate !== undefined) {
                        dst.epsilonUltimate = src.epsilonUltimate;
                    }
                    if (src.epsilonFailure !== undefined) {
                        dst.epsilonFailure = src.epsilonFailure;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.elasticityModulus = this.elasticityModulus;
                    dst.yieldStrength = this.yieldStrength;
                    dst.ultimateStrength = this.ultimateStrength;
                    dst.density = this.density;
                    dst.k = this.k;
                    dst.epsilonUltimate = this.epsilonUltimate;
                    dst.epsilonFailure = this.epsilonFailure;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type DiameterItem_keys = 'diameter' | 'barArea';
            export interface DiameterItem_createType {
                diameter?: number,
                barArea?: number,
            }
            export interface DiameterItem_json {
                diameter?: JsonNumber;
                barArea?: JsonNumber;
            }
            interface DiameterItem_json_in {
                __proto_name?: unknown;
                diameter?: unknown;
                barArea?: unknown;
            }
            export class DiameterItem {
                __proto_name = "ng.material.reinforcement.DiameterItem";
                diameter: number = 0;
                barArea: number = 0;

                static fromObject(src_unknown: unknown): DiameterItem {
                    const dst = new DiameterItem();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DiameterItem but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DiameterItem_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DiameterItem but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.diameter !== undefined && src.diameter !== null) {
                        if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                            dst.diameter = AsNum(src.diameter);
                        }
                        else {
                            console.log('Expected diameter of DiameterItem to be a number but was ', typeof src.diameter, src.diameter)
                        }
                    }
                    if (src.barArea !== undefined && src.barArea !== null) {
                        if (typeof src.barArea === "number" || src.barArea === 'NaN' || src.barArea === 'Infinity' || src.barArea === '-Infinity') {
                            dst.barArea = AsNum(src.barArea);
                        }
                        else {
                            console.log('Expected barArea of DiameterItem to be a number but was ', typeof src.barArea, src.barArea)
                        }
                    }
                    return dst;
                }

                static toObject(src: DiameterItem | null | undefined): DiameterItem_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.reinforcement.DiameterItem is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.reinforcement.DiameterItem") {
                        console.error('Expected ng.material.reinforcement.DiameterItem but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DiameterItem_json = {
                        diameter: AsJsonNum(src.diameter),
                        barArea: AsJsonNum(src.barArea),
                    };
                    return dst;
                }

                static create(src?: DiameterItem_createType) {
                    const dst = new DiameterItem();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.diameter !== undefined) {
                        dst.diameter = src.diameter;
                    }
                    if (src.barArea !== undefined) {
                        dst.barArea = src.barArea;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DiameterItem();
                    dst.diameter = this.diameter;
                    dst.barArea = this.barArea;
                    return dst;
                }

                deepClone() {
                    const json = DiameterItem.toObject(this);
                    const dst = DiameterItem.fromObject(json);
                    return dst;
                }
            }
            export type IDiameterItem = DiameterItem;


            export type Data_keys = 'id' | 'properties' | 'diameters' | 'barProfile' | 'wireProfile' | 'ductilityClass';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                properties?: ng.material.reinforcement.CharacteristicData | null,
                diameters?: ng.material.reinforcement.DiameterItem[],
                barProfile?: ng.reinf.BarProfile,
                wireProfile?: ng.reinf.WireProfile,
                ductilityClass?: ng.reinf.DuctilityClass,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                properties?: ng.material.reinforcement.CharacteristicData_json;
                diameters: ng.material.reinforcement.DiameterItem_json[];
                barProfile?: string;
                wireProfile?: string;
                ductilityClass?: string;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                properties?: unknown;
                diameters?: unknown;
                barProfile?: unknown;
                wireProfile?: unknown;
                ductilityClass?: unknown;
            }
            export class Data {
                __proto_name = "ng.material.reinforcement.Data";
                id: ng.utils.ID | null = null;
                properties: ng.material.reinforcement.CharacteristicData | null = null;
                diameters: ng.material.reinforcement.DiameterItem[] = [];
                // this is a one of
                profile: {type: 'barProfile'; barProfile: ng.reinf.BarProfile} | {type: 'wireProfile'; wireProfile: ng.reinf.WireProfile} | null = null;
                ductilityClass: ng.reinf.DuctilityClass = ng.reinf.DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED;

                /** Gets the `BarProfile` value (or null) from the oneof `profile` */
                getBarProfile(): ng.reinf.BarProfile | null {
                    if(this.profile === null) return null;
                    if(this.profile.type !== 'barProfile') return null;
                    return this.profile.barProfile;
                }

                /** Sets the `BarProfile` value for the oneof `profile`*/
                setBarProfile(value: ng.reinf.BarProfile | null) {
                    if(value !== null) {
                        this.profile = {type: 'barProfile', barProfile:value};
                    }
                    else {
                        this.profile = null;
                    }
                }

                /** Gets the `WireProfile` value (or null) from the oneof `profile` */
                getWireProfile(): ng.reinf.WireProfile | null {
                    if(this.profile === null) return null;
                    if(this.profile.type !== 'wireProfile') return null;
                    return this.profile.wireProfile;
                }

                /** Sets the `WireProfile` value for the oneof `profile`*/
                setWireProfile(value: ng.reinf.WireProfile | null) {
                    if(value !== null) {
                        this.profile = {type: 'wireProfile', wireProfile:value};
                    }
                    else {
                        this.profile = null;
                    }
                }

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.material.reinforcement.CharacteristicData.fromObject(src.properties);
                    }
                    if (src.diameters !== undefined && src.diameters !== null) {
                        if (Array.isArray(src.diameters)) {
                            for (const element of src.diameters) {
                                dst.diameters.push(ng.material.reinforcement.DiameterItem.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected diameters of Data to be a array but was ', typeof src.diameters, src.diameters)
                        }
                    }
                    if (src.barProfile !== undefined && src.barProfile !== null) {
                        dst.setBarProfile(ng.reinf.BarProfile_FromObject(src.barProfile));
                    }
                    if (src.wireProfile !== undefined && src.wireProfile !== null) {
                        dst.setWireProfile(ng.reinf.WireProfile_FromObject(src.wireProfile));
                    }
                    if (src.ductilityClass !== undefined && src.ductilityClass !== null) {
                        dst.ductilityClass = ng.reinf.DuctilityClass_FromObject(src.ductilityClass);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.reinforcement.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.reinforcement.Data") {
                        console.error('Expected ng.material.reinforcement.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const ductilityClass_obj = ng.reinf.DuctilityClass_ToObject(src.ductilityClass);
                    if(ductilityClass_obj === null) return null;

                    const dst : Data_json = {
                        diameters: new Array<ng.material.reinforcement.DiameterItem_json>(),
                        ductilityClass: ductilityClass_obj,
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.material.reinforcement.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    if (src.diameters !== null) {
                        for (const element of src.diameters) {
                            const parsed = ng.material.reinforcement.DiameterItem.toObject(element);
                            if(parsed === null) return null;
                            dst.diameters.push(parsed);
                        }
                    }
                    const barProfile = src.getBarProfile();
                    if(barProfile !== null)
                    {
                        const parsed = ng.reinf.BarProfile_ToObject(barProfile);
                        if(parsed === null) return null;
                        dst.barProfile = parsed;
                    }
                    const wireProfile = src.getWireProfile();
                    if(wireProfile !== null)
                    {
                        const parsed = ng.reinf.WireProfile_ToObject(wireProfile);
                        if(parsed === null) return null;
                        dst.wireProfile = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    if (src.diameters !== undefined) {
                        dst.diameters = src.diameters;
                    }
                    // part of the profile oneof 
                    if (src.barProfile !== undefined && src.barProfile !== null) {
                        dst.setBarProfile(src.barProfile);
                    }
                    // part of the profile oneof 
                    if (src.wireProfile !== undefined && src.wireProfile !== null) {
                        dst.setWireProfile(src.wireProfile);
                    }
                    if (src.ductilityClass !== undefined) {
                        dst.ductilityClass = src.ductilityClass;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.properties = this.properties;
                    dst.diameters = this.diameters;
                    dst.profile = this.profile;
                    dst.ductilityClass = this.ductilityClass;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace reinforcement


        // Defined in Material/custom.proto
        export namespace custom {
            export type CharacteristicData_keys = 'density' | 'elasticityModulus' | 'poissonsRatio' | 'alpha';
            export interface CharacteristicData_createType {
                density?: number,
                elasticityModulus?: number,
                poissonsRatio?: number,
                alpha?: number,
            }
            export interface CharacteristicData_json {
                density?: JsonNumber;
                elasticityModulus?: JsonNumber;
                poissonsRatio?: JsonNumber;
                alpha?: JsonNumber;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                density?: unknown;
                elasticityModulus?: unknown;
                poissonsRatio?: unknown;
                alpha?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.material.custom.CharacteristicData";
                density: number = 0;
                elasticityModulus: number = 0;
                poissonsRatio: number = 0;
                alpha: number = 0;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.density !== undefined && src.density !== null) {
                        if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                            dst.density = AsNum(src.density);
                        }
                        else {
                            console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                        }
                    }
                    if (src.elasticityModulus !== undefined && src.elasticityModulus !== null) {
                        if (typeof src.elasticityModulus === "number" || src.elasticityModulus === 'NaN' || src.elasticityModulus === 'Infinity' || src.elasticityModulus === '-Infinity') {
                            dst.elasticityModulus = AsNum(src.elasticityModulus);
                        }
                        else {
                            console.log('Expected elasticityModulus of CharacteristicData to be a number but was ', typeof src.elasticityModulus, src.elasticityModulus)
                        }
                    }
                    if (src.poissonsRatio !== undefined && src.poissonsRatio !== null) {
                        if (typeof src.poissonsRatio === "number" || src.poissonsRatio === 'NaN' || src.poissonsRatio === 'Infinity' || src.poissonsRatio === '-Infinity') {
                            dst.poissonsRatio = AsNum(src.poissonsRatio);
                        }
                        else {
                            console.log('Expected poissonsRatio of CharacteristicData to be a number but was ', typeof src.poissonsRatio, src.poissonsRatio)
                        }
                    }
                    if (src.alpha !== undefined && src.alpha !== null) {
                        if (typeof src.alpha === "number" || src.alpha === 'NaN' || src.alpha === 'Infinity' || src.alpha === '-Infinity') {
                            dst.alpha = AsNum(src.alpha);
                        }
                        else {
                            console.log('Expected alpha of CharacteristicData to be a number but was ', typeof src.alpha, src.alpha)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.custom.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.custom.CharacteristicData") {
                        console.error('Expected ng.material.custom.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CharacteristicData_json = {
                        density: AsJsonNum(src.density),
                        elasticityModulus: AsJsonNum(src.elasticityModulus),
                        poissonsRatio: AsJsonNum(src.poissonsRatio),
                        alpha: AsJsonNum(src.alpha),
                    };
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.density !== undefined) {
                        dst.density = src.density;
                    }
                    if (src.elasticityModulus !== undefined) {
                        dst.elasticityModulus = src.elasticityModulus;
                    }
                    if (src.poissonsRatio !== undefined) {
                        dst.poissonsRatio = src.poissonsRatio;
                    }
                    if (src.alpha !== undefined) {
                        dst.alpha = src.alpha;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.density = this.density;
                    dst.elasticityModulus = this.elasticityModulus;
                    dst.poissonsRatio = this.poissonsRatio;
                    dst.alpha = this.alpha;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type Data_keys = 'id' | 'properties';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                properties?: ng.material.custom.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                properties?: ng.material.custom.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                properties?: unknown;
            }
            export class Data {
                __proto_name = "ng.material.custom.Data";
                id: ng.utils.ID | null = null;
                properties: ng.material.custom.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.material.custom.CharacteristicData.fromObject(src.properties);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.material.custom.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.material.custom.Data") {
                        console.error('Expected ng.material.custom.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.material.custom.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace custom
    } // namespace material


    // Defined in sections.proto
    export namespace sections {
        export enum MaterialCategory {
            MATERIAL_CATEGORY_UNSPECIFIED = 0,
            MATERIAL_CATEGORY_CONCRETE = 1,
            MATERIAL_CATEGORY_STEEL = 2,
            MATERIAL_CATEGORY_TIMBER = 3
        }
        export const MaterialCategory_FromObject = (src: unknown): MaterialCategory => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'MATERIAL_CATEGORY_UNSPECIFIED':
                    return MaterialCategory.MATERIAL_CATEGORY_UNSPECIFIED;
                case 1:
                case 'MATERIAL_CATEGORY_CONCRETE':
                    return MaterialCategory.MATERIAL_CATEGORY_CONCRETE;
                case 2:
                case 'MATERIAL_CATEGORY_STEEL':
                    return MaterialCategory.MATERIAL_CATEGORY_STEEL;
                case 3:
                case 'MATERIAL_CATEGORY_TIMBER':
                    return MaterialCategory.MATERIAL_CATEGORY_TIMBER;
                default:
                    console.log('Unhandled value for MaterialCategory:' + src + '. ' + typeof(src));
                    return MaterialCategory.MATERIAL_CATEGORY_UNSPECIFIED;
            }
        };
        export const MaterialCategory_ToObject = (src: MaterialCategory): string | null => {
            switch (src) {
                case MaterialCategory.MATERIAL_CATEGORY_UNSPECIFIED:
                    return 'MATERIAL_CATEGORY_UNSPECIFIED';
                case MaterialCategory.MATERIAL_CATEGORY_CONCRETE:
                    return 'MATERIAL_CATEGORY_CONCRETE';
                case MaterialCategory.MATERIAL_CATEGORY_STEEL:
                    return 'MATERIAL_CATEGORY_STEEL';
                case MaterialCategory.MATERIAL_CATEGORY_TIMBER:
                    return 'MATERIAL_CATEGORY_TIMBER';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for MaterialCategory, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum SectionType {
            SECTION_TYPE_UNSPECIFIED = 0,
            SECTION_TYPE_CUSTOM = 1,
            SECTION_TYPE_R = 2,
            SECTION_TYPE_SAWN_LUMBER = 3,
            SECTION_TYPE_DESSED_LUMBER = 4,
            SECTION_TYPE_GLULAM = 5,
            SECTION_TYPE_VR = 6,
            SECTION_TYPE_T = 7,
            SECTION_TYPE_TPS = 8,
            SECTION_TYPE_VT = 9,
            SECTION_TYPE_F = 10,
            SECTION_TYPE_KB = 11,
            SECTION_TYPE_KBE = 12,
            SECTION_TYPE_C = 13,
            SECTION_TYPE_I = 14,
            SECTION_TYPE_HEA = 15,
            SECTION_TYPE_HEB = 16,
            SECTION_TYPE_HEM = 17,
            SECTION_TYPE_IPE = 18,
            SECTION_TYPE_UKB = 19,
            SECTION_TYPE_UKC = 20,
            SECTION_TYPE_IV = 21,
            SECTION_TYPE_L = 22,
            SECTION_TYPE_LE = 23,
            SECTION_TYPE_LU = 24,
            SECTION_TYPE_CO = 25,
            SECTION_TYPE_CHS = 26,
            SECTION_TYPE_KCKR = 27,
            SECTION_TYPE_VCKR = 28,
            SECTION_TYPE_U = 29,
            SECTION_TYPE_UAP = 30,
            SECTION_TYPE_UPE_DIN = 31,
            SECTION_TYPE_UPE_NEN = 32,
            SECTION_TYPE_UPE_SWE = 33,
            SECTION_TYPE_RHS = 34,
            SECTION_TYPE_KKR = 35,
            SECTION_TYPE_VKR = 36,
            SECTION_TYPE_Z = 37,
            SECTION_TYPE_TOPPING = 38,
            SECTION_TYPE_HDX = 39,
            SECTION_TYPE_UB = 40,
            SECTION_TYPE_UBP = 41,
            SECTION_TYPE_UC = 42,
            SECTION_TYPE_PFC = 43,
            SECTION_TYPE_EA = 44,
            SECTION_TYPE_UA = 45,
            SECTION_TYPE_ASB = 46,
            SECTION_TYPE_KERTO = 47,
            SECTION_TYPE_PLATE = 48,
            SECTION_TYPE_HSQ = 49,
            SECTION_TYPE_UX = 50,
            SECTION_TYPE_ZX = 51,
            SECTION_TYPE_S = 52
        }
        export const SectionType_FromObject = (src: unknown): SectionType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'SECTION_TYPE_UNSPECIFIED':
                    return SectionType.SECTION_TYPE_UNSPECIFIED;
                case 1:
                case 'SECTION_TYPE_CUSTOM':
                    return SectionType.SECTION_TYPE_CUSTOM;
                case 2:
                case 'SECTION_TYPE_R':
                    return SectionType.SECTION_TYPE_R;
                case 3:
                case 'SECTION_TYPE_SAWN_LUMBER':
                    return SectionType.SECTION_TYPE_SAWN_LUMBER;
                case 4:
                case 'SECTION_TYPE_DESSED_LUMBER':
                    return SectionType.SECTION_TYPE_DESSED_LUMBER;
                case 5:
                case 'SECTION_TYPE_GLULAM':
                    return SectionType.SECTION_TYPE_GLULAM;
                case 6:
                case 'SECTION_TYPE_VR':
                    return SectionType.SECTION_TYPE_VR;
                case 7:
                case 'SECTION_TYPE_T':
                    return SectionType.SECTION_TYPE_T;
                case 8:
                case 'SECTION_TYPE_TPS':
                    return SectionType.SECTION_TYPE_TPS;
                case 9:
                case 'SECTION_TYPE_VT':
                    return SectionType.SECTION_TYPE_VT;
                case 10:
                case 'SECTION_TYPE_F':
                    return SectionType.SECTION_TYPE_F;
                case 11:
                case 'SECTION_TYPE_KB':
                    return SectionType.SECTION_TYPE_KB;
                case 12:
                case 'SECTION_TYPE_KBE':
                    return SectionType.SECTION_TYPE_KBE;
                case 13:
                case 'SECTION_TYPE_C':
                    return SectionType.SECTION_TYPE_C;
                case 14:
                case 'SECTION_TYPE_I':
                    return SectionType.SECTION_TYPE_I;
                case 15:
                case 'SECTION_TYPE_HEA':
                    return SectionType.SECTION_TYPE_HEA;
                case 16:
                case 'SECTION_TYPE_HEB':
                    return SectionType.SECTION_TYPE_HEB;
                case 17:
                case 'SECTION_TYPE_HEM':
                    return SectionType.SECTION_TYPE_HEM;
                case 18:
                case 'SECTION_TYPE_IPE':
                    return SectionType.SECTION_TYPE_IPE;
                case 19:
                case 'SECTION_TYPE_UKB':
                    return SectionType.SECTION_TYPE_UKB;
                case 20:
                case 'SECTION_TYPE_UKC':
                    return SectionType.SECTION_TYPE_UKC;
                case 21:
                case 'SECTION_TYPE_IV':
                    return SectionType.SECTION_TYPE_IV;
                case 22:
                case 'SECTION_TYPE_L':
                    return SectionType.SECTION_TYPE_L;
                case 23:
                case 'SECTION_TYPE_LE':
                    return SectionType.SECTION_TYPE_LE;
                case 24:
                case 'SECTION_TYPE_LU':
                    return SectionType.SECTION_TYPE_LU;
                case 25:
                case 'SECTION_TYPE_CO':
                    return SectionType.SECTION_TYPE_CO;
                case 26:
                case 'SECTION_TYPE_CHS':
                    return SectionType.SECTION_TYPE_CHS;
                case 27:
                case 'SECTION_TYPE_KCKR':
                    return SectionType.SECTION_TYPE_KCKR;
                case 28:
                case 'SECTION_TYPE_VCKR':
                    return SectionType.SECTION_TYPE_VCKR;
                case 29:
                case 'SECTION_TYPE_U':
                    return SectionType.SECTION_TYPE_U;
                case 30:
                case 'SECTION_TYPE_UAP':
                    return SectionType.SECTION_TYPE_UAP;
                case 31:
                case 'SECTION_TYPE_UPE_DIN':
                    return SectionType.SECTION_TYPE_UPE_DIN;
                case 32:
                case 'SECTION_TYPE_UPE_NEN':
                    return SectionType.SECTION_TYPE_UPE_NEN;
                case 33:
                case 'SECTION_TYPE_UPE_SWE':
                    return SectionType.SECTION_TYPE_UPE_SWE;
                case 34:
                case 'SECTION_TYPE_RHS':
                    return SectionType.SECTION_TYPE_RHS;
                case 35:
                case 'SECTION_TYPE_KKR':
                    return SectionType.SECTION_TYPE_KKR;
                case 36:
                case 'SECTION_TYPE_VKR':
                    return SectionType.SECTION_TYPE_VKR;
                case 37:
                case 'SECTION_TYPE_Z':
                    return SectionType.SECTION_TYPE_Z;
                case 38:
                case 'SECTION_TYPE_TOPPING':
                    return SectionType.SECTION_TYPE_TOPPING;
                case 39:
                case 'SECTION_TYPE_HDX':
                    return SectionType.SECTION_TYPE_HDX;
                case 40:
                case 'SECTION_TYPE_UB':
                    return SectionType.SECTION_TYPE_UB;
                case 41:
                case 'SECTION_TYPE_UBP':
                    return SectionType.SECTION_TYPE_UBP;
                case 42:
                case 'SECTION_TYPE_UC':
                    return SectionType.SECTION_TYPE_UC;
                case 43:
                case 'SECTION_TYPE_PFC':
                    return SectionType.SECTION_TYPE_PFC;
                case 44:
                case 'SECTION_TYPE_EA':
                    return SectionType.SECTION_TYPE_EA;
                case 45:
                case 'SECTION_TYPE_UA':
                    return SectionType.SECTION_TYPE_UA;
                case 46:
                case 'SECTION_TYPE_ASB':
                    return SectionType.SECTION_TYPE_ASB;
                case 47:
                case 'SECTION_TYPE_KERTO':
                    return SectionType.SECTION_TYPE_KERTO;
                case 48:
                case 'SECTION_TYPE_PLATE':
                    return SectionType.SECTION_TYPE_PLATE;
                case 49:
                case 'SECTION_TYPE_HSQ':
                    return SectionType.SECTION_TYPE_HSQ;
                case 50:
                case 'SECTION_TYPE_UX':
                    return SectionType.SECTION_TYPE_UX;
                case 51:
                case 'SECTION_TYPE_ZX':
                    return SectionType.SECTION_TYPE_ZX;
                case 52:
                case 'SECTION_TYPE_S':
                    return SectionType.SECTION_TYPE_S;
                default:
                    console.log('Unhandled value for SectionType:' + src + '. ' + typeof(src));
                    return SectionType.SECTION_TYPE_UNSPECIFIED;
            }
        };
        export const SectionType_ToObject = (src: SectionType): string | null => {
            switch (src) {
                case SectionType.SECTION_TYPE_UNSPECIFIED:
                    return 'SECTION_TYPE_UNSPECIFIED';
                case SectionType.SECTION_TYPE_CUSTOM:
                    return 'SECTION_TYPE_CUSTOM';
                case SectionType.SECTION_TYPE_R:
                    return 'SECTION_TYPE_R';
                case SectionType.SECTION_TYPE_SAWN_LUMBER:
                    return 'SECTION_TYPE_SAWN_LUMBER';
                case SectionType.SECTION_TYPE_DESSED_LUMBER:
                    return 'SECTION_TYPE_DESSED_LUMBER';
                case SectionType.SECTION_TYPE_GLULAM:
                    return 'SECTION_TYPE_GLULAM';
                case SectionType.SECTION_TYPE_VR:
                    return 'SECTION_TYPE_VR';
                case SectionType.SECTION_TYPE_T:
                    return 'SECTION_TYPE_T';
                case SectionType.SECTION_TYPE_TPS:
                    return 'SECTION_TYPE_TPS';
                case SectionType.SECTION_TYPE_VT:
                    return 'SECTION_TYPE_VT';
                case SectionType.SECTION_TYPE_F:
                    return 'SECTION_TYPE_F';
                case SectionType.SECTION_TYPE_KB:
                    return 'SECTION_TYPE_KB';
                case SectionType.SECTION_TYPE_KBE:
                    return 'SECTION_TYPE_KBE';
                case SectionType.SECTION_TYPE_C:
                    return 'SECTION_TYPE_C';
                case SectionType.SECTION_TYPE_I:
                    return 'SECTION_TYPE_I';
                case SectionType.SECTION_TYPE_HEA:
                    return 'SECTION_TYPE_HEA';
                case SectionType.SECTION_TYPE_HEB:
                    return 'SECTION_TYPE_HEB';
                case SectionType.SECTION_TYPE_HEM:
                    return 'SECTION_TYPE_HEM';
                case SectionType.SECTION_TYPE_IPE:
                    return 'SECTION_TYPE_IPE';
                case SectionType.SECTION_TYPE_UKB:
                    return 'SECTION_TYPE_UKB';
                case SectionType.SECTION_TYPE_UKC:
                    return 'SECTION_TYPE_UKC';
                case SectionType.SECTION_TYPE_IV:
                    return 'SECTION_TYPE_IV';
                case SectionType.SECTION_TYPE_L:
                    return 'SECTION_TYPE_L';
                case SectionType.SECTION_TYPE_LE:
                    return 'SECTION_TYPE_LE';
                case SectionType.SECTION_TYPE_LU:
                    return 'SECTION_TYPE_LU';
                case SectionType.SECTION_TYPE_CO:
                    return 'SECTION_TYPE_CO';
                case SectionType.SECTION_TYPE_CHS:
                    return 'SECTION_TYPE_CHS';
                case SectionType.SECTION_TYPE_KCKR:
                    return 'SECTION_TYPE_KCKR';
                case SectionType.SECTION_TYPE_VCKR:
                    return 'SECTION_TYPE_VCKR';
                case SectionType.SECTION_TYPE_U:
                    return 'SECTION_TYPE_U';
                case SectionType.SECTION_TYPE_UAP:
                    return 'SECTION_TYPE_UAP';
                case SectionType.SECTION_TYPE_UPE_DIN:
                    return 'SECTION_TYPE_UPE_DIN';
                case SectionType.SECTION_TYPE_UPE_NEN:
                    return 'SECTION_TYPE_UPE_NEN';
                case SectionType.SECTION_TYPE_UPE_SWE:
                    return 'SECTION_TYPE_UPE_SWE';
                case SectionType.SECTION_TYPE_RHS:
                    return 'SECTION_TYPE_RHS';
                case SectionType.SECTION_TYPE_KKR:
                    return 'SECTION_TYPE_KKR';
                case SectionType.SECTION_TYPE_VKR:
                    return 'SECTION_TYPE_VKR';
                case SectionType.SECTION_TYPE_Z:
                    return 'SECTION_TYPE_Z';
                case SectionType.SECTION_TYPE_TOPPING:
                    return 'SECTION_TYPE_TOPPING';
                case SectionType.SECTION_TYPE_HDX:
                    return 'SECTION_TYPE_HDX';
                case SectionType.SECTION_TYPE_UB:
                    return 'SECTION_TYPE_UB';
                case SectionType.SECTION_TYPE_UBP:
                    return 'SECTION_TYPE_UBP';
                case SectionType.SECTION_TYPE_UC:
                    return 'SECTION_TYPE_UC';
                case SectionType.SECTION_TYPE_PFC:
                    return 'SECTION_TYPE_PFC';
                case SectionType.SECTION_TYPE_EA:
                    return 'SECTION_TYPE_EA';
                case SectionType.SECTION_TYPE_UA:
                    return 'SECTION_TYPE_UA';
                case SectionType.SECTION_TYPE_ASB:
                    return 'SECTION_TYPE_ASB';
                case SectionType.SECTION_TYPE_KERTO:
                    return 'SECTION_TYPE_KERTO';
                case SectionType.SECTION_TYPE_PLATE:
                    return 'SECTION_TYPE_PLATE';
                case SectionType.SECTION_TYPE_HSQ:
                    return 'SECTION_TYPE_HSQ';
                case SectionType.SECTION_TYPE_UX:
                    return 'SECTION_TYPE_UX';
                case SectionType.SECTION_TYPE_ZX:
                    return 'SECTION_TYPE_ZX';
                case SectionType.SECTION_TYPE_S:
                    return 'SECTION_TYPE_S';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for SectionType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum SectionSide {
            SECTION_SIDE_UNSPECIFIED = 0,
            SECTION_SIDE_LEFT = 1,
            SECTION_SIDE_RIGHT = 2
        }
        export const SectionSide_FromObject = (src: unknown): SectionSide => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'SECTION_SIDE_UNSPECIFIED':
                    return SectionSide.SECTION_SIDE_UNSPECIFIED;
                case 1:
                case 'SECTION_SIDE_LEFT':
                    return SectionSide.SECTION_SIDE_LEFT;
                case 2:
                case 'SECTION_SIDE_RIGHT':
                    return SectionSide.SECTION_SIDE_RIGHT;
                default:
                    console.log('Unhandled value for SectionSide:' + src + '. ' + typeof(src));
                    return SectionSide.SECTION_SIDE_UNSPECIFIED;
            }
        };
        export const SectionSide_ToObject = (src: SectionSide): string | null => {
            switch (src) {
                case SectionSide.SECTION_SIDE_UNSPECIFIED:
                    return 'SECTION_SIDE_UNSPECIFIED';
                case SectionSide.SECTION_SIDE_LEFT:
                    return 'SECTION_SIDE_LEFT';
                case SectionSide.SECTION_SIDE_RIGHT:
                    return 'SECTION_SIDE_RIGHT';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for SectionSide, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type CustomParams_keys = 'height' | 'width' | 'topWebHeight' | 'topWebWidth' | 'topInnerWebWidth' | 'topFlangeHeightLft' | 'topFlangeHeightRgt' | 'topFlangeWidthLft' | 'topFlangeWidthRgt' | 'topFlangeTopWidth' | 'topFlangeInclinationLft' | 'topFlangeInclinationRgt' | 'btmWebHeight' | 'btmInnerWebWidth' | 'btmWebWidth' | 'btmFlangeHeightLft' | 'btmFlangeHeightRgt' | 'btmFlangeWidthLft' | 'btmFlangeWidthRgt' | 'btmFlangeBtmWidth' | 'btmFlangeInclinationLft' | 'btmFlangeInclinationRgt' | 'radius' | 'thickness' | 'innerRadius';
        export interface CustomParams_createType {
            height?: number,
            width?: number,
            topWebHeight?: number,
            topWebWidth?: number,
            topInnerWebWidth?: number,
            topFlangeHeightLft?: number,
            topFlangeHeightRgt?: number,
            topFlangeWidthLft?: number,
            topFlangeWidthRgt?: number,
            topFlangeTopWidth?: number,
            topFlangeInclinationLft?: number,
            topFlangeInclinationRgt?: number,
            btmWebHeight?: number,
            btmInnerWebWidth?: number,
            btmWebWidth?: number,
            btmFlangeHeightLft?: number,
            btmFlangeHeightRgt?: number,
            btmFlangeWidthLft?: number,
            btmFlangeWidthRgt?: number,
            btmFlangeBtmWidth?: number,
            btmFlangeInclinationLft?: number,
            btmFlangeInclinationRgt?: number,
            radius?: number,
            thickness?: number,
            innerRadius?: number,
        }
        export interface CustomParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
            topWebHeight?: JsonNumber;
            topWebWidth?: JsonNumber;
            topInnerWebWidth?: JsonNumber;
            topFlangeHeightLft?: JsonNumber;
            topFlangeHeightRgt?: JsonNumber;
            topFlangeWidthLft?: JsonNumber;
            topFlangeWidthRgt?: JsonNumber;
            topFlangeTopWidth?: JsonNumber;
            topFlangeInclinationLft?: JsonNumber;
            topFlangeInclinationRgt?: JsonNumber;
            btmWebHeight?: JsonNumber;
            btmInnerWebWidth?: JsonNumber;
            btmWebWidth?: JsonNumber;
            btmFlangeHeightLft?: JsonNumber;
            btmFlangeHeightRgt?: JsonNumber;
            btmFlangeWidthLft?: JsonNumber;
            btmFlangeWidthRgt?: JsonNumber;
            btmFlangeBtmWidth?: JsonNumber;
            btmFlangeInclinationLft?: JsonNumber;
            btmFlangeInclinationRgt?: JsonNumber;
            radius?: JsonNumber;
            thickness?: JsonNumber;
            innerRadius?: JsonNumber;
        }
        interface CustomParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
            topWebHeight?: unknown;
            topWebWidth?: unknown;
            topInnerWebWidth?: unknown;
            topFlangeHeightLft?: unknown;
            topFlangeHeightRgt?: unknown;
            topFlangeWidthLft?: unknown;
            topFlangeWidthRgt?: unknown;
            topFlangeTopWidth?: unknown;
            topFlangeInclinationLft?: unknown;
            topFlangeInclinationRgt?: unknown;
            btmWebHeight?: unknown;
            btmInnerWebWidth?: unknown;
            btmWebWidth?: unknown;
            btmFlangeHeightLft?: unknown;
            btmFlangeHeightRgt?: unknown;
            btmFlangeWidthLft?: unknown;
            btmFlangeWidthRgt?: unknown;
            btmFlangeBtmWidth?: unknown;
            btmFlangeInclinationLft?: unknown;
            btmFlangeInclinationRgt?: unknown;
            radius?: unknown;
            thickness?: unknown;
            innerRadius?: unknown;
        }
        export class CustomParams {
            __proto_name = "ng.sections.CustomParams";
            height: number = 0;
            width: number = 0;
            topWebHeight: number = 0;
            topWebWidth: number = 0;
            topInnerWebWidth: number = 0;
            topFlangeHeightLft: number = 0;
            topFlangeHeightRgt: number = 0;
            topFlangeWidthLft: number = 0;
            topFlangeWidthRgt: number = 0;
            topFlangeTopWidth: number = 0;
            topFlangeInclinationLft: number = 0;
            topFlangeInclinationRgt: number = 0;
            btmWebHeight: number = 0;
            btmInnerWebWidth: number = 0;
            btmWebWidth: number = 0;
            btmFlangeHeightLft: number = 0;
            btmFlangeHeightRgt: number = 0;
            btmFlangeWidthLft: number = 0;
            btmFlangeWidthRgt: number = 0;
            btmFlangeBtmWidth: number = 0;
            btmFlangeInclinationLft: number = 0;
            btmFlangeInclinationRgt: number = 0;
            radius: number = 0;
            thickness: number = 0;
            innerRadius: number = 0;

            static fromObject(src_unknown: unknown): CustomParams {
                const dst = new CustomParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted CustomParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as CustomParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for CustomParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of CustomParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of CustomParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.topWebHeight !== undefined && src.topWebHeight !== null) {
                    if (typeof src.topWebHeight === "number" || src.topWebHeight === 'NaN' || src.topWebHeight === 'Infinity' || src.topWebHeight === '-Infinity') {
                        dst.topWebHeight = AsNum(src.topWebHeight);
                    }
                    else {
                        console.log('Expected topWebHeight of CustomParams to be a number but was ', typeof src.topWebHeight, src.topWebHeight)
                    }
                }
                if (src.topWebWidth !== undefined && src.topWebWidth !== null) {
                    if (typeof src.topWebWidth === "number" || src.topWebWidth === 'NaN' || src.topWebWidth === 'Infinity' || src.topWebWidth === '-Infinity') {
                        dst.topWebWidth = AsNum(src.topWebWidth);
                    }
                    else {
                        console.log('Expected topWebWidth of CustomParams to be a number but was ', typeof src.topWebWidth, src.topWebWidth)
                    }
                }
                if (src.topInnerWebWidth !== undefined && src.topInnerWebWidth !== null) {
                    if (typeof src.topInnerWebWidth === "number" || src.topInnerWebWidth === 'NaN' || src.topInnerWebWidth === 'Infinity' || src.topInnerWebWidth === '-Infinity') {
                        dst.topInnerWebWidth = AsNum(src.topInnerWebWidth);
                    }
                    else {
                        console.log('Expected topInnerWebWidth of CustomParams to be a number but was ', typeof src.topInnerWebWidth, src.topInnerWebWidth)
                    }
                }
                if (src.topFlangeHeightLft !== undefined && src.topFlangeHeightLft !== null) {
                    if (typeof src.topFlangeHeightLft === "number" || src.topFlangeHeightLft === 'NaN' || src.topFlangeHeightLft === 'Infinity' || src.topFlangeHeightLft === '-Infinity') {
                        dst.topFlangeHeightLft = AsNum(src.topFlangeHeightLft);
                    }
                    else {
                        console.log('Expected topFlangeHeightLft of CustomParams to be a number but was ', typeof src.topFlangeHeightLft, src.topFlangeHeightLft)
                    }
                }
                if (src.topFlangeHeightRgt !== undefined && src.topFlangeHeightRgt !== null) {
                    if (typeof src.topFlangeHeightRgt === "number" || src.topFlangeHeightRgt === 'NaN' || src.topFlangeHeightRgt === 'Infinity' || src.topFlangeHeightRgt === '-Infinity') {
                        dst.topFlangeHeightRgt = AsNum(src.topFlangeHeightRgt);
                    }
                    else {
                        console.log('Expected topFlangeHeightRgt of CustomParams to be a number but was ', typeof src.topFlangeHeightRgt, src.topFlangeHeightRgt)
                    }
                }
                if (src.topFlangeWidthLft !== undefined && src.topFlangeWidthLft !== null) {
                    if (typeof src.topFlangeWidthLft === "number" || src.topFlangeWidthLft === 'NaN' || src.topFlangeWidthLft === 'Infinity' || src.topFlangeWidthLft === '-Infinity') {
                        dst.topFlangeWidthLft = AsNum(src.topFlangeWidthLft);
                    }
                    else {
                        console.log('Expected topFlangeWidthLft of CustomParams to be a number but was ', typeof src.topFlangeWidthLft, src.topFlangeWidthLft)
                    }
                }
                if (src.topFlangeWidthRgt !== undefined && src.topFlangeWidthRgt !== null) {
                    if (typeof src.topFlangeWidthRgt === "number" || src.topFlangeWidthRgt === 'NaN' || src.topFlangeWidthRgt === 'Infinity' || src.topFlangeWidthRgt === '-Infinity') {
                        dst.topFlangeWidthRgt = AsNum(src.topFlangeWidthRgt);
                    }
                    else {
                        console.log('Expected topFlangeWidthRgt of CustomParams to be a number but was ', typeof src.topFlangeWidthRgt, src.topFlangeWidthRgt)
                    }
                }
                if (src.topFlangeTopWidth !== undefined && src.topFlangeTopWidth !== null) {
                    if (typeof src.topFlangeTopWidth === "number" || src.topFlangeTopWidth === 'NaN' || src.topFlangeTopWidth === 'Infinity' || src.topFlangeTopWidth === '-Infinity') {
                        dst.topFlangeTopWidth = AsNum(src.topFlangeTopWidth);
                    }
                    else {
                        console.log('Expected topFlangeTopWidth of CustomParams to be a number but was ', typeof src.topFlangeTopWidth, src.topFlangeTopWidth)
                    }
                }
                if (src.topFlangeInclinationLft !== undefined && src.topFlangeInclinationLft !== null) {
                    if (typeof src.topFlangeInclinationLft === "number" || src.topFlangeInclinationLft === 'NaN' || src.topFlangeInclinationLft === 'Infinity' || src.topFlangeInclinationLft === '-Infinity') {
                        dst.topFlangeInclinationLft = NumberToInt("ng.sections.CustomParams.top_flange_inclination_lft", AsNum(src.topFlangeInclinationLft));
                    }
                    else {
                        console.log('Expected topFlangeInclinationLft of CustomParams to be a number but was ', typeof src.topFlangeInclinationLft, src.topFlangeInclinationLft)
                    }
                }
                if (src.topFlangeInclinationRgt !== undefined && src.topFlangeInclinationRgt !== null) {
                    if (typeof src.topFlangeInclinationRgt === "number" || src.topFlangeInclinationRgt === 'NaN' || src.topFlangeInclinationRgt === 'Infinity' || src.topFlangeInclinationRgt === '-Infinity') {
                        dst.topFlangeInclinationRgt = NumberToInt("ng.sections.CustomParams.top_flange_inclination_rgt", AsNum(src.topFlangeInclinationRgt));
                    }
                    else {
                        console.log('Expected topFlangeInclinationRgt of CustomParams to be a number but was ', typeof src.topFlangeInclinationRgt, src.topFlangeInclinationRgt)
                    }
                }
                if (src.btmWebHeight !== undefined && src.btmWebHeight !== null) {
                    if (typeof src.btmWebHeight === "number" || src.btmWebHeight === 'NaN' || src.btmWebHeight === 'Infinity' || src.btmWebHeight === '-Infinity') {
                        dst.btmWebHeight = AsNum(src.btmWebHeight);
                    }
                    else {
                        console.log('Expected btmWebHeight of CustomParams to be a number but was ', typeof src.btmWebHeight, src.btmWebHeight)
                    }
                }
                if (src.btmInnerWebWidth !== undefined && src.btmInnerWebWidth !== null) {
                    if (typeof src.btmInnerWebWidth === "number" || src.btmInnerWebWidth === 'NaN' || src.btmInnerWebWidth === 'Infinity' || src.btmInnerWebWidth === '-Infinity') {
                        dst.btmInnerWebWidth = AsNum(src.btmInnerWebWidth);
                    }
                    else {
                        console.log('Expected btmInnerWebWidth of CustomParams to be a number but was ', typeof src.btmInnerWebWidth, src.btmInnerWebWidth)
                    }
                }
                if (src.btmWebWidth !== undefined && src.btmWebWidth !== null) {
                    if (typeof src.btmWebWidth === "number" || src.btmWebWidth === 'NaN' || src.btmWebWidth === 'Infinity' || src.btmWebWidth === '-Infinity') {
                        dst.btmWebWidth = AsNum(src.btmWebWidth);
                    }
                    else {
                        console.log('Expected btmWebWidth of CustomParams to be a number but was ', typeof src.btmWebWidth, src.btmWebWidth)
                    }
                }
                if (src.btmFlangeHeightLft !== undefined && src.btmFlangeHeightLft !== null) {
                    if (typeof src.btmFlangeHeightLft === "number" || src.btmFlangeHeightLft === 'NaN' || src.btmFlangeHeightLft === 'Infinity' || src.btmFlangeHeightLft === '-Infinity') {
                        dst.btmFlangeHeightLft = AsNum(src.btmFlangeHeightLft);
                    }
                    else {
                        console.log('Expected btmFlangeHeightLft of CustomParams to be a number but was ', typeof src.btmFlangeHeightLft, src.btmFlangeHeightLft)
                    }
                }
                if (src.btmFlangeHeightRgt !== undefined && src.btmFlangeHeightRgt !== null) {
                    if (typeof src.btmFlangeHeightRgt === "number" || src.btmFlangeHeightRgt === 'NaN' || src.btmFlangeHeightRgt === 'Infinity' || src.btmFlangeHeightRgt === '-Infinity') {
                        dst.btmFlangeHeightRgt = AsNum(src.btmFlangeHeightRgt);
                    }
                    else {
                        console.log('Expected btmFlangeHeightRgt of CustomParams to be a number but was ', typeof src.btmFlangeHeightRgt, src.btmFlangeHeightRgt)
                    }
                }
                if (src.btmFlangeWidthLft !== undefined && src.btmFlangeWidthLft !== null) {
                    if (typeof src.btmFlangeWidthLft === "number" || src.btmFlangeWidthLft === 'NaN' || src.btmFlangeWidthLft === 'Infinity' || src.btmFlangeWidthLft === '-Infinity') {
                        dst.btmFlangeWidthLft = AsNum(src.btmFlangeWidthLft);
                    }
                    else {
                        console.log('Expected btmFlangeWidthLft of CustomParams to be a number but was ', typeof src.btmFlangeWidthLft, src.btmFlangeWidthLft)
                    }
                }
                if (src.btmFlangeWidthRgt !== undefined && src.btmFlangeWidthRgt !== null) {
                    if (typeof src.btmFlangeWidthRgt === "number" || src.btmFlangeWidthRgt === 'NaN' || src.btmFlangeWidthRgt === 'Infinity' || src.btmFlangeWidthRgt === '-Infinity') {
                        dst.btmFlangeWidthRgt = AsNum(src.btmFlangeWidthRgt);
                    }
                    else {
                        console.log('Expected btmFlangeWidthRgt of CustomParams to be a number but was ', typeof src.btmFlangeWidthRgt, src.btmFlangeWidthRgt)
                    }
                }
                if (src.btmFlangeBtmWidth !== undefined && src.btmFlangeBtmWidth !== null) {
                    if (typeof src.btmFlangeBtmWidth === "number" || src.btmFlangeBtmWidth === 'NaN' || src.btmFlangeBtmWidth === 'Infinity' || src.btmFlangeBtmWidth === '-Infinity') {
                        dst.btmFlangeBtmWidth = AsNum(src.btmFlangeBtmWidth);
                    }
                    else {
                        console.log('Expected btmFlangeBtmWidth of CustomParams to be a number but was ', typeof src.btmFlangeBtmWidth, src.btmFlangeBtmWidth)
                    }
                }
                if (src.btmFlangeInclinationLft !== undefined && src.btmFlangeInclinationLft !== null) {
                    if (typeof src.btmFlangeInclinationLft === "number" || src.btmFlangeInclinationLft === 'NaN' || src.btmFlangeInclinationLft === 'Infinity' || src.btmFlangeInclinationLft === '-Infinity') {
                        dst.btmFlangeInclinationLft = NumberToInt("ng.sections.CustomParams.btm_flange_inclination_lft", AsNum(src.btmFlangeInclinationLft));
                    }
                    else {
                        console.log('Expected btmFlangeInclinationLft of CustomParams to be a number but was ', typeof src.btmFlangeInclinationLft, src.btmFlangeInclinationLft)
                    }
                }
                if (src.btmFlangeInclinationRgt !== undefined && src.btmFlangeInclinationRgt !== null) {
                    if (typeof src.btmFlangeInclinationRgt === "number" || src.btmFlangeInclinationRgt === 'NaN' || src.btmFlangeInclinationRgt === 'Infinity' || src.btmFlangeInclinationRgt === '-Infinity') {
                        dst.btmFlangeInclinationRgt = NumberToInt("ng.sections.CustomParams.btm_flange_inclination_rgt", AsNum(src.btmFlangeInclinationRgt));
                    }
                    else {
                        console.log('Expected btmFlangeInclinationRgt of CustomParams to be a number but was ', typeof src.btmFlangeInclinationRgt, src.btmFlangeInclinationRgt)
                    }
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of CustomParams to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                if (src.thickness !== undefined && src.thickness !== null) {
                    if (typeof src.thickness === "number" || src.thickness === 'NaN' || src.thickness === 'Infinity' || src.thickness === '-Infinity') {
                        dst.thickness = AsNum(src.thickness);
                    }
                    else {
                        console.log('Expected thickness of CustomParams to be a number but was ', typeof src.thickness, src.thickness)
                    }
                }
                if (src.innerRadius !== undefined && src.innerRadius !== null) {
                    if (typeof src.innerRadius === "number" || src.innerRadius === 'NaN' || src.innerRadius === 'Infinity' || src.innerRadius === '-Infinity') {
                        dst.innerRadius = AsNum(src.innerRadius);
                    }
                    else {
                        console.log('Expected innerRadius of CustomParams to be a number but was ', typeof src.innerRadius, src.innerRadius)
                    }
                }
                return dst;
            }

            static toObject(src: CustomParams | null | undefined): CustomParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.CustomParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.CustomParams") {
                    console.error('Expected ng.sections.CustomParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : CustomParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                    topWebHeight: AsJsonNum(src.topWebHeight),
                    topWebWidth: AsJsonNum(src.topWebWidth),
                    topInnerWebWidth: AsJsonNum(src.topInnerWebWidth),
                    topFlangeHeightLft: AsJsonNum(src.topFlangeHeightLft),
                    topFlangeHeightRgt: AsJsonNum(src.topFlangeHeightRgt),
                    topFlangeWidthLft: AsJsonNum(src.topFlangeWidthLft),
                    topFlangeWidthRgt: AsJsonNum(src.topFlangeWidthRgt),
                    topFlangeTopWidth: AsJsonNum(src.topFlangeTopWidth),
                    topFlangeInclinationLft: AsJsonNum(NumberToInt("ng.sections.CustomParams.top_flange_inclination_lft", src.topFlangeInclinationLft)),
                    topFlangeInclinationRgt: AsJsonNum(NumberToInt("ng.sections.CustomParams.top_flange_inclination_rgt", src.topFlangeInclinationRgt)),
                    btmWebHeight: AsJsonNum(src.btmWebHeight),
                    btmInnerWebWidth: AsJsonNum(src.btmInnerWebWidth),
                    btmWebWidth: AsJsonNum(src.btmWebWidth),
                    btmFlangeHeightLft: AsJsonNum(src.btmFlangeHeightLft),
                    btmFlangeHeightRgt: AsJsonNum(src.btmFlangeHeightRgt),
                    btmFlangeWidthLft: AsJsonNum(src.btmFlangeWidthLft),
                    btmFlangeWidthRgt: AsJsonNum(src.btmFlangeWidthRgt),
                    btmFlangeBtmWidth: AsJsonNum(src.btmFlangeBtmWidth),
                    btmFlangeInclinationLft: AsJsonNum(NumberToInt("ng.sections.CustomParams.btm_flange_inclination_lft", src.btmFlangeInclinationLft)),
                    btmFlangeInclinationRgt: AsJsonNum(NumberToInt("ng.sections.CustomParams.btm_flange_inclination_rgt", src.btmFlangeInclinationRgt)),
                    radius: AsJsonNum(src.radius),
                    thickness: AsJsonNum(src.thickness),
                    innerRadius: AsJsonNum(src.innerRadius),
                };
                return dst;
            }

            static create(src?: CustomParams_createType) {
                const dst = new CustomParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.topWebHeight !== undefined) {
                    dst.topWebHeight = src.topWebHeight;
                }
                if (src.topWebWidth !== undefined) {
                    dst.topWebWidth = src.topWebWidth;
                }
                if (src.topInnerWebWidth !== undefined) {
                    dst.topInnerWebWidth = src.topInnerWebWidth;
                }
                if (src.topFlangeHeightLft !== undefined) {
                    dst.topFlangeHeightLft = src.topFlangeHeightLft;
                }
                if (src.topFlangeHeightRgt !== undefined) {
                    dst.topFlangeHeightRgt = src.topFlangeHeightRgt;
                }
                if (src.topFlangeWidthLft !== undefined) {
                    dst.topFlangeWidthLft = src.topFlangeWidthLft;
                }
                if (src.topFlangeWidthRgt !== undefined) {
                    dst.topFlangeWidthRgt = src.topFlangeWidthRgt;
                }
                if (src.topFlangeTopWidth !== undefined) {
                    dst.topFlangeTopWidth = src.topFlangeTopWidth;
                }
                if (src.topFlangeInclinationLft !== undefined) {
                    dst.topFlangeInclinationLft = src.topFlangeInclinationLft;
                }
                if (src.topFlangeInclinationRgt !== undefined) {
                    dst.topFlangeInclinationRgt = src.topFlangeInclinationRgt;
                }
                if (src.btmWebHeight !== undefined) {
                    dst.btmWebHeight = src.btmWebHeight;
                }
                if (src.btmInnerWebWidth !== undefined) {
                    dst.btmInnerWebWidth = src.btmInnerWebWidth;
                }
                if (src.btmWebWidth !== undefined) {
                    dst.btmWebWidth = src.btmWebWidth;
                }
                if (src.btmFlangeHeightLft !== undefined) {
                    dst.btmFlangeHeightLft = src.btmFlangeHeightLft;
                }
                if (src.btmFlangeHeightRgt !== undefined) {
                    dst.btmFlangeHeightRgt = src.btmFlangeHeightRgt;
                }
                if (src.btmFlangeWidthLft !== undefined) {
                    dst.btmFlangeWidthLft = src.btmFlangeWidthLft;
                }
                if (src.btmFlangeWidthRgt !== undefined) {
                    dst.btmFlangeWidthRgt = src.btmFlangeWidthRgt;
                }
                if (src.btmFlangeBtmWidth !== undefined) {
                    dst.btmFlangeBtmWidth = src.btmFlangeBtmWidth;
                }
                if (src.btmFlangeInclinationLft !== undefined) {
                    dst.btmFlangeInclinationLft = src.btmFlangeInclinationLft;
                }
                if (src.btmFlangeInclinationRgt !== undefined) {
                    dst.btmFlangeInclinationRgt = src.btmFlangeInclinationRgt;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                if (src.thickness !== undefined) {
                    dst.thickness = src.thickness;
                }
                if (src.innerRadius !== undefined) {
                    dst.innerRadius = src.innerRadius;
                }
                return dst;
            }

            shallowClone() {
                const dst = new CustomParams();
                dst.height = this.height;
                dst.width = this.width;
                dst.topWebHeight = this.topWebHeight;
                dst.topWebWidth = this.topWebWidth;
                dst.topInnerWebWidth = this.topInnerWebWidth;
                dst.topFlangeHeightLft = this.topFlangeHeightLft;
                dst.topFlangeHeightRgt = this.topFlangeHeightRgt;
                dst.topFlangeWidthLft = this.topFlangeWidthLft;
                dst.topFlangeWidthRgt = this.topFlangeWidthRgt;
                dst.topFlangeTopWidth = this.topFlangeTopWidth;
                dst.topFlangeInclinationLft = this.topFlangeInclinationLft;
                dst.topFlangeInclinationRgt = this.topFlangeInclinationRgt;
                dst.btmWebHeight = this.btmWebHeight;
                dst.btmInnerWebWidth = this.btmInnerWebWidth;
                dst.btmWebWidth = this.btmWebWidth;
                dst.btmFlangeHeightLft = this.btmFlangeHeightLft;
                dst.btmFlangeHeightRgt = this.btmFlangeHeightRgt;
                dst.btmFlangeWidthLft = this.btmFlangeWidthLft;
                dst.btmFlangeWidthRgt = this.btmFlangeWidthRgt;
                dst.btmFlangeBtmWidth = this.btmFlangeBtmWidth;
                dst.btmFlangeInclinationLft = this.btmFlangeInclinationLft;
                dst.btmFlangeInclinationRgt = this.btmFlangeInclinationRgt;
                dst.radius = this.radius;
                dst.thickness = this.thickness;
                dst.innerRadius = this.innerRadius;
                return dst;
            }

            deepClone() {
                const json = CustomParams.toObject(this);
                const dst = CustomParams.fromObject(json);
                return dst;
            }
        }
        export type ICustomParams = CustomParams;


        export type RParams_keys = 'height' | 'width';
        export interface RParams_createType {
            height?: number,
            width?: number,
        }
        export interface RParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
        }
        interface RParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
        }
        export class RParams {
            __proto_name = "ng.sections.RParams";
            height: number = 0;
            width: number = 0;

            static fromObject(src_unknown: unknown): RParams {
                const dst = new RParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted RParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as RParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for RParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of RParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of RParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                return dst;
            }

            static toObject(src: RParams | null | undefined): RParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.RParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.RParams") {
                    console.error('Expected ng.sections.RParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : RParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                };
                return dst;
            }

            static create(src?: RParams_createType) {
                const dst = new RParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                return dst;
            }

            shallowClone() {
                const dst = new RParams();
                dst.height = this.height;
                dst.width = this.width;
                return dst;
            }

            deepClone() {
                const json = RParams.toObject(this);
                const dst = RParams.fromObject(json);
                return dst;
            }
        }
        export type IRParams = RParams;


        export type VRParams_keys = 'height' | 'topWidth' | 'bottomWidth';
        export interface VRParams_createType {
            height?: number,
            topWidth?: number,
            bottomWidth?: number,
        }
        export interface VRParams_json {
            height?: JsonNumber;
            topWidth?: JsonNumber;
            bottomWidth?: JsonNumber;
        }
        interface VRParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            topWidth?: unknown;
            bottomWidth?: unknown;
        }
        export class VRParams {
            __proto_name = "ng.sections.VRParams";
            height: number = 0;
            topWidth: number = 0;
            bottomWidth: number = 0;

            static fromObject(src_unknown: unknown): VRParams {
                const dst = new VRParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted VRParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as VRParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for VRParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of VRParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.topWidth !== undefined && src.topWidth !== null) {
                    if (typeof src.topWidth === "number" || src.topWidth === 'NaN' || src.topWidth === 'Infinity' || src.topWidth === '-Infinity') {
                        dst.topWidth = AsNum(src.topWidth);
                    }
                    else {
                        console.log('Expected topWidth of VRParams to be a number but was ', typeof src.topWidth, src.topWidth)
                    }
                }
                if (src.bottomWidth !== undefined && src.bottomWidth !== null) {
                    if (typeof src.bottomWidth === "number" || src.bottomWidth === 'NaN' || src.bottomWidth === 'Infinity' || src.bottomWidth === '-Infinity') {
                        dst.bottomWidth = AsNum(src.bottomWidth);
                    }
                    else {
                        console.log('Expected bottomWidth of VRParams to be a number but was ', typeof src.bottomWidth, src.bottomWidth)
                    }
                }
                return dst;
            }

            static toObject(src: VRParams | null | undefined): VRParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.VRParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.VRParams") {
                    console.error('Expected ng.sections.VRParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : VRParams_json = {
                    height: AsJsonNum(src.height),
                    topWidth: AsJsonNum(src.topWidth),
                    bottomWidth: AsJsonNum(src.bottomWidth),
                };
                return dst;
            }

            static create(src?: VRParams_createType) {
                const dst = new VRParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.topWidth !== undefined) {
                    dst.topWidth = src.topWidth;
                }
                if (src.bottomWidth !== undefined) {
                    dst.bottomWidth = src.bottomWidth;
                }
                return dst;
            }

            shallowClone() {
                const dst = new VRParams();
                dst.height = this.height;
                dst.topWidth = this.topWidth;
                dst.bottomWidth = this.bottomWidth;
                return dst;
            }

            deepClone() {
                const json = VRParams.toObject(this);
                const dst = VRParams.fromObject(json);
                return dst;
            }
        }
        export type IVRParams = VRParams;


        export type TParams_keys = 'height' | 'flangeHeight' | 'flangeWidth' | 'webWidth';
        export interface TParams_createType {
            height?: number,
            flangeHeight?: number,
            flangeWidth?: number,
            webWidth?: number,
        }
        export interface TParams_json {
            height?: JsonNumber;
            flangeHeight?: JsonNumber;
            flangeWidth?: JsonNumber;
            webWidth?: JsonNumber;
        }
        interface TParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            flangeHeight?: unknown;
            flangeWidth?: unknown;
            webWidth?: unknown;
        }
        export class TParams {
            __proto_name = "ng.sections.TParams";
            height: number = 0;
            flangeHeight: number = 0;
            flangeWidth: number = 0;
            webWidth: number = 0;

            static fromObject(src_unknown: unknown): TParams {
                const dst = new TParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted TParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as TParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for TParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of TParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.flangeHeight !== undefined && src.flangeHeight !== null) {
                    if (typeof src.flangeHeight === "number" || src.flangeHeight === 'NaN' || src.flangeHeight === 'Infinity' || src.flangeHeight === '-Infinity') {
                        dst.flangeHeight = AsNum(src.flangeHeight);
                    }
                    else {
                        console.log('Expected flangeHeight of TParams to be a number but was ', typeof src.flangeHeight, src.flangeHeight)
                    }
                }
                if (src.flangeWidth !== undefined && src.flangeWidth !== null) {
                    if (typeof src.flangeWidth === "number" || src.flangeWidth === 'NaN' || src.flangeWidth === 'Infinity' || src.flangeWidth === '-Infinity') {
                        dst.flangeWidth = AsNum(src.flangeWidth);
                    }
                    else {
                        console.log('Expected flangeWidth of TParams to be a number but was ', typeof src.flangeWidth, src.flangeWidth)
                    }
                }
                if (src.webWidth !== undefined && src.webWidth !== null) {
                    if (typeof src.webWidth === "number" || src.webWidth === 'NaN' || src.webWidth === 'Infinity' || src.webWidth === '-Infinity') {
                        dst.webWidth = AsNum(src.webWidth);
                    }
                    else {
                        console.log('Expected webWidth of TParams to be a number but was ', typeof src.webWidth, src.webWidth)
                    }
                }
                return dst;
            }

            static toObject(src: TParams | null | undefined): TParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.TParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.TParams") {
                    console.error('Expected ng.sections.TParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : TParams_json = {
                    height: AsJsonNum(src.height),
                    flangeHeight: AsJsonNum(src.flangeHeight),
                    flangeWidth: AsJsonNum(src.flangeWidth),
                    webWidth: AsJsonNum(src.webWidth),
                };
                return dst;
            }

            static create(src?: TParams_createType) {
                const dst = new TParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.flangeHeight !== undefined) {
                    dst.flangeHeight = src.flangeHeight;
                }
                if (src.flangeWidth !== undefined) {
                    dst.flangeWidth = src.flangeWidth;
                }
                if (src.webWidth !== undefined) {
                    dst.webWidth = src.webWidth;
                }
                return dst;
            }

            shallowClone() {
                const dst = new TParams();
                dst.height = this.height;
                dst.flangeHeight = this.flangeHeight;
                dst.flangeWidth = this.flangeWidth;
                dst.webWidth = this.webWidth;
                return dst;
            }

            deepClone() {
                const json = TParams.toObject(this);
                const dst = TParams.fromObject(json);
                return dst;
            }
        }
        export type ITParams = TParams;


        export type VTParams_keys = 'height' | 'flangeHeight' | 'flangeWidth' | 'topWebWidth' | 'bottomWebWidth';
        export interface VTParams_createType {
            height?: number,
            flangeHeight?: number,
            flangeWidth?: number,
            topWebWidth?: number,
            bottomWebWidth?: number,
        }
        export interface VTParams_json {
            height?: JsonNumber;
            flangeHeight?: JsonNumber;
            flangeWidth?: JsonNumber;
            topWebWidth?: JsonNumber;
            bottomWebWidth?: JsonNumber;
        }
        interface VTParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            flangeHeight?: unknown;
            flangeWidth?: unknown;
            topWebWidth?: unknown;
            bottomWebWidth?: unknown;
        }
        export class VTParams {
            __proto_name = "ng.sections.VTParams";
            height: number = 0;
            flangeHeight: number = 0;
            flangeWidth: number = 0;
            topWebWidth: number = 0;
            bottomWebWidth: number = 0;

            static fromObject(src_unknown: unknown): VTParams {
                const dst = new VTParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted VTParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as VTParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for VTParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of VTParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.flangeHeight !== undefined && src.flangeHeight !== null) {
                    if (typeof src.flangeHeight === "number" || src.flangeHeight === 'NaN' || src.flangeHeight === 'Infinity' || src.flangeHeight === '-Infinity') {
                        dst.flangeHeight = AsNum(src.flangeHeight);
                    }
                    else {
                        console.log('Expected flangeHeight of VTParams to be a number but was ', typeof src.flangeHeight, src.flangeHeight)
                    }
                }
                if (src.flangeWidth !== undefined && src.flangeWidth !== null) {
                    if (typeof src.flangeWidth === "number" || src.flangeWidth === 'NaN' || src.flangeWidth === 'Infinity' || src.flangeWidth === '-Infinity') {
                        dst.flangeWidth = AsNum(src.flangeWidth);
                    }
                    else {
                        console.log('Expected flangeWidth of VTParams to be a number but was ', typeof src.flangeWidth, src.flangeWidth)
                    }
                }
                if (src.topWebWidth !== undefined && src.topWebWidth !== null) {
                    if (typeof src.topWebWidth === "number" || src.topWebWidth === 'NaN' || src.topWebWidth === 'Infinity' || src.topWebWidth === '-Infinity') {
                        dst.topWebWidth = AsNum(src.topWebWidth);
                    }
                    else {
                        console.log('Expected topWebWidth of VTParams to be a number but was ', typeof src.topWebWidth, src.topWebWidth)
                    }
                }
                if (src.bottomWebWidth !== undefined && src.bottomWebWidth !== null) {
                    if (typeof src.bottomWebWidth === "number" || src.bottomWebWidth === 'NaN' || src.bottomWebWidth === 'Infinity' || src.bottomWebWidth === '-Infinity') {
                        dst.bottomWebWidth = AsNum(src.bottomWebWidth);
                    }
                    else {
                        console.log('Expected bottomWebWidth of VTParams to be a number but was ', typeof src.bottomWebWidth, src.bottomWebWidth)
                    }
                }
                return dst;
            }

            static toObject(src: VTParams | null | undefined): VTParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.VTParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.VTParams") {
                    console.error('Expected ng.sections.VTParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : VTParams_json = {
                    height: AsJsonNum(src.height),
                    flangeHeight: AsJsonNum(src.flangeHeight),
                    flangeWidth: AsJsonNum(src.flangeWidth),
                    topWebWidth: AsJsonNum(src.topWebWidth),
                    bottomWebWidth: AsJsonNum(src.bottomWebWidth),
                };
                return dst;
            }

            static create(src?: VTParams_createType) {
                const dst = new VTParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.flangeHeight !== undefined) {
                    dst.flangeHeight = src.flangeHeight;
                }
                if (src.flangeWidth !== undefined) {
                    dst.flangeWidth = src.flangeWidth;
                }
                if (src.topWebWidth !== undefined) {
                    dst.topWebWidth = src.topWebWidth;
                }
                if (src.bottomWebWidth !== undefined) {
                    dst.bottomWebWidth = src.bottomWebWidth;
                }
                return dst;
            }

            shallowClone() {
                const dst = new VTParams();
                dst.height = this.height;
                dst.flangeHeight = this.flangeHeight;
                dst.flangeWidth = this.flangeWidth;
                dst.topWebWidth = this.topWebWidth;
                dst.bottomWebWidth = this.bottomWebWidth;
                return dst;
            }

            deepClone() {
                const json = VTParams.toObject(this);
                const dst = VTParams.fromObject(json);
                return dst;
            }
        }
        export type IVTParams = VTParams;


        export type FParams_keys = 'height' | 'flangeHeight' | 'flangeWidth' | 'webWidth';
        export interface FParams_createType {
            height?: number,
            flangeHeight?: number,
            flangeWidth?: number,
            webWidth?: number,
        }
        export interface FParams_json {
            height?: JsonNumber;
            flangeHeight?: JsonNumber;
            flangeWidth?: JsonNumber;
            webWidth?: JsonNumber;
        }
        interface FParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            flangeHeight?: unknown;
            flangeWidth?: unknown;
            webWidth?: unknown;
        }
        export class FParams {
            __proto_name = "ng.sections.FParams";
            height: number = 0;
            flangeHeight: number = 0;
            flangeWidth: number = 0;
            webWidth: number = 0;

            static fromObject(src_unknown: unknown): FParams {
                const dst = new FParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted FParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as FParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for FParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of FParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.flangeHeight !== undefined && src.flangeHeight !== null) {
                    if (typeof src.flangeHeight === "number" || src.flangeHeight === 'NaN' || src.flangeHeight === 'Infinity' || src.flangeHeight === '-Infinity') {
                        dst.flangeHeight = AsNum(src.flangeHeight);
                    }
                    else {
                        console.log('Expected flangeHeight of FParams to be a number but was ', typeof src.flangeHeight, src.flangeHeight)
                    }
                }
                if (src.flangeWidth !== undefined && src.flangeWidth !== null) {
                    if (typeof src.flangeWidth === "number" || src.flangeWidth === 'NaN' || src.flangeWidth === 'Infinity' || src.flangeWidth === '-Infinity') {
                        dst.flangeWidth = AsNum(src.flangeWidth);
                    }
                    else {
                        console.log('Expected flangeWidth of FParams to be a number but was ', typeof src.flangeWidth, src.flangeWidth)
                    }
                }
                if (src.webWidth !== undefined && src.webWidth !== null) {
                    if (typeof src.webWidth === "number" || src.webWidth === 'NaN' || src.webWidth === 'Infinity' || src.webWidth === '-Infinity') {
                        dst.webWidth = AsNum(src.webWidth);
                    }
                    else {
                        console.log('Expected webWidth of FParams to be a number but was ', typeof src.webWidth, src.webWidth)
                    }
                }
                return dst;
            }

            static toObject(src: FParams | null | undefined): FParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.FParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.FParams") {
                    console.error('Expected ng.sections.FParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : FParams_json = {
                    height: AsJsonNum(src.height),
                    flangeHeight: AsJsonNum(src.flangeHeight),
                    flangeWidth: AsJsonNum(src.flangeWidth),
                    webWidth: AsJsonNum(src.webWidth),
                };
                return dst;
            }

            static create(src?: FParams_createType) {
                const dst = new FParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.flangeHeight !== undefined) {
                    dst.flangeHeight = src.flangeHeight;
                }
                if (src.flangeWidth !== undefined) {
                    dst.flangeWidth = src.flangeWidth;
                }
                if (src.webWidth !== undefined) {
                    dst.webWidth = src.webWidth;
                }
                return dst;
            }

            shallowClone() {
                const dst = new FParams();
                dst.height = this.height;
                dst.flangeHeight = this.flangeHeight;
                dst.flangeWidth = this.flangeWidth;
                dst.webWidth = this.webWidth;
                return dst;
            }

            deepClone() {
                const json = FParams.toObject(this);
                const dst = FParams.fromObject(json);
                return dst;
            }
        }
        export type IFParams = FParams;


        export type KBParams_keys = 'height' | 'leftFlangeHeight' | 'rightFlangeHeight' | 'inclinationLeftFlange' | 'inclinationRightFlange' | 'bottomWidth' | 'leftSupportWidth' | 'rightSupportWidth';
        export interface KBParams_createType {
            height?: number,
            leftFlangeHeight?: number,
            rightFlangeHeight?: number,
            inclinationLeftFlange?: number,
            inclinationRightFlange?: number,
            bottomWidth?: number,
            leftSupportWidth?: number,
            rightSupportWidth?: number,
        }
        export interface KBParams_json {
            height?: JsonNumber;
            leftFlangeHeight?: JsonNumber;
            rightFlangeHeight?: JsonNumber;
            inclinationLeftFlange?: JsonNumber;
            inclinationRightFlange?: JsonNumber;
            bottomWidth?: JsonNumber;
            leftSupportWidth?: JsonNumber;
            rightSupportWidth?: JsonNumber;
        }
        interface KBParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            leftFlangeHeight?: unknown;
            rightFlangeHeight?: unknown;
            inclinationLeftFlange?: unknown;
            inclinationRightFlange?: unknown;
            bottomWidth?: unknown;
            leftSupportWidth?: unknown;
            rightSupportWidth?: unknown;
        }
        export class KBParams {
            __proto_name = "ng.sections.KBParams";
            height: number = 0;
            leftFlangeHeight: number = 0;
            rightFlangeHeight: number = 0;
            inclinationLeftFlange: number = 0;
            inclinationRightFlange: number = 0;
            bottomWidth: number = 0;
            leftSupportWidth: number = 0;
            rightSupportWidth: number = 0;

            static fromObject(src_unknown: unknown): KBParams {
                const dst = new KBParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted KBParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as KBParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for KBParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of KBParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.leftFlangeHeight !== undefined && src.leftFlangeHeight !== null) {
                    if (typeof src.leftFlangeHeight === "number" || src.leftFlangeHeight === 'NaN' || src.leftFlangeHeight === 'Infinity' || src.leftFlangeHeight === '-Infinity') {
                        dst.leftFlangeHeight = AsNum(src.leftFlangeHeight);
                    }
                    else {
                        console.log('Expected leftFlangeHeight of KBParams to be a number but was ', typeof src.leftFlangeHeight, src.leftFlangeHeight)
                    }
                }
                if (src.rightFlangeHeight !== undefined && src.rightFlangeHeight !== null) {
                    if (typeof src.rightFlangeHeight === "number" || src.rightFlangeHeight === 'NaN' || src.rightFlangeHeight === 'Infinity' || src.rightFlangeHeight === '-Infinity') {
                        dst.rightFlangeHeight = AsNum(src.rightFlangeHeight);
                    }
                    else {
                        console.log('Expected rightFlangeHeight of KBParams to be a number but was ', typeof src.rightFlangeHeight, src.rightFlangeHeight)
                    }
                }
                if (src.inclinationLeftFlange !== undefined && src.inclinationLeftFlange !== null) {
                    if (typeof src.inclinationLeftFlange === "number" || src.inclinationLeftFlange === 'NaN' || src.inclinationLeftFlange === 'Infinity' || src.inclinationLeftFlange === '-Infinity') {
                        dst.inclinationLeftFlange = AsNum(src.inclinationLeftFlange);
                    }
                    else {
                        console.log('Expected inclinationLeftFlange of KBParams to be a number but was ', typeof src.inclinationLeftFlange, src.inclinationLeftFlange)
                    }
                }
                if (src.inclinationRightFlange !== undefined && src.inclinationRightFlange !== null) {
                    if (typeof src.inclinationRightFlange === "number" || src.inclinationRightFlange === 'NaN' || src.inclinationRightFlange === 'Infinity' || src.inclinationRightFlange === '-Infinity') {
                        dst.inclinationRightFlange = AsNum(src.inclinationRightFlange);
                    }
                    else {
                        console.log('Expected inclinationRightFlange of KBParams to be a number but was ', typeof src.inclinationRightFlange, src.inclinationRightFlange)
                    }
                }
                if (src.bottomWidth !== undefined && src.bottomWidth !== null) {
                    if (typeof src.bottomWidth === "number" || src.bottomWidth === 'NaN' || src.bottomWidth === 'Infinity' || src.bottomWidth === '-Infinity') {
                        dst.bottomWidth = AsNum(src.bottomWidth);
                    }
                    else {
                        console.log('Expected bottomWidth of KBParams to be a number but was ', typeof src.bottomWidth, src.bottomWidth)
                    }
                }
                if (src.leftSupportWidth !== undefined && src.leftSupportWidth !== null) {
                    if (typeof src.leftSupportWidth === "number" || src.leftSupportWidth === 'NaN' || src.leftSupportWidth === 'Infinity' || src.leftSupportWidth === '-Infinity') {
                        dst.leftSupportWidth = AsNum(src.leftSupportWidth);
                    }
                    else {
                        console.log('Expected leftSupportWidth of KBParams to be a number but was ', typeof src.leftSupportWidth, src.leftSupportWidth)
                    }
                }
                if (src.rightSupportWidth !== undefined && src.rightSupportWidth !== null) {
                    if (typeof src.rightSupportWidth === "number" || src.rightSupportWidth === 'NaN' || src.rightSupportWidth === 'Infinity' || src.rightSupportWidth === '-Infinity') {
                        dst.rightSupportWidth = AsNum(src.rightSupportWidth);
                    }
                    else {
                        console.log('Expected rightSupportWidth of KBParams to be a number but was ', typeof src.rightSupportWidth, src.rightSupportWidth)
                    }
                }
                return dst;
            }

            static toObject(src: KBParams | null | undefined): KBParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.KBParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.KBParams") {
                    console.error('Expected ng.sections.KBParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : KBParams_json = {
                    height: AsJsonNum(src.height),
                    leftFlangeHeight: AsJsonNum(src.leftFlangeHeight),
                    rightFlangeHeight: AsJsonNum(src.rightFlangeHeight),
                    inclinationLeftFlange: AsJsonNum(src.inclinationLeftFlange),
                    inclinationRightFlange: AsJsonNum(src.inclinationRightFlange),
                    bottomWidth: AsJsonNum(src.bottomWidth),
                    leftSupportWidth: AsJsonNum(src.leftSupportWidth),
                    rightSupportWidth: AsJsonNum(src.rightSupportWidth),
                };
                return dst;
            }

            static create(src?: KBParams_createType) {
                const dst = new KBParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.leftFlangeHeight !== undefined) {
                    dst.leftFlangeHeight = src.leftFlangeHeight;
                }
                if (src.rightFlangeHeight !== undefined) {
                    dst.rightFlangeHeight = src.rightFlangeHeight;
                }
                if (src.inclinationLeftFlange !== undefined) {
                    dst.inclinationLeftFlange = src.inclinationLeftFlange;
                }
                if (src.inclinationRightFlange !== undefined) {
                    dst.inclinationRightFlange = src.inclinationRightFlange;
                }
                if (src.bottomWidth !== undefined) {
                    dst.bottomWidth = src.bottomWidth;
                }
                if (src.leftSupportWidth !== undefined) {
                    dst.leftSupportWidth = src.leftSupportWidth;
                }
                if (src.rightSupportWidth !== undefined) {
                    dst.rightSupportWidth = src.rightSupportWidth;
                }
                return dst;
            }

            shallowClone() {
                const dst = new KBParams();
                dst.height = this.height;
                dst.leftFlangeHeight = this.leftFlangeHeight;
                dst.rightFlangeHeight = this.rightFlangeHeight;
                dst.inclinationLeftFlange = this.inclinationLeftFlange;
                dst.inclinationRightFlange = this.inclinationRightFlange;
                dst.bottomWidth = this.bottomWidth;
                dst.leftSupportWidth = this.leftSupportWidth;
                dst.rightSupportWidth = this.rightSupportWidth;
                return dst;
            }

            deepClone() {
                const json = KBParams.toObject(this);
                const dst = KBParams.fromObject(json);
                return dst;
            }
        }
        export type IKBParams = KBParams;


        export type KBEParams_keys = 'height' | 'flangeHeight' | 'webWidth' | 'bottomWidth' | 'supportWidth' | 'side';
        export interface KBEParams_createType {
            height?: number,
            flangeHeight?: number,
            webWidth?: number,
            bottomWidth?: number,
            supportWidth?: number,
            side?: ng.sections.SectionSide,
        }
        export interface KBEParams_json {
            height?: JsonNumber;
            flangeHeight?: JsonNumber;
            webWidth?: JsonNumber;
            bottomWidth?: JsonNumber;
            supportWidth?: JsonNumber;
            side?: string;
        }
        interface KBEParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            flangeHeight?: unknown;
            webWidth?: unknown;
            bottomWidth?: unknown;
            supportWidth?: unknown;
            side?: unknown;
        }
        export class KBEParams {
            __proto_name = "ng.sections.KBEParams";
            height: number = 0;
            flangeHeight: number = 0;
            webWidth: number = 0;
            bottomWidth: number = 0;
            supportWidth: number = 0;
            side: ng.sections.SectionSide = ng.sections.SectionSide.SECTION_SIDE_UNSPECIFIED;

            static fromObject(src_unknown: unknown): KBEParams {
                const dst = new KBEParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted KBEParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as KBEParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for KBEParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of KBEParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.flangeHeight !== undefined && src.flangeHeight !== null) {
                    if (typeof src.flangeHeight === "number" || src.flangeHeight === 'NaN' || src.flangeHeight === 'Infinity' || src.flangeHeight === '-Infinity') {
                        dst.flangeHeight = AsNum(src.flangeHeight);
                    }
                    else {
                        console.log('Expected flangeHeight of KBEParams to be a number but was ', typeof src.flangeHeight, src.flangeHeight)
                    }
                }
                if (src.webWidth !== undefined && src.webWidth !== null) {
                    if (typeof src.webWidth === "number" || src.webWidth === 'NaN' || src.webWidth === 'Infinity' || src.webWidth === '-Infinity') {
                        dst.webWidth = AsNum(src.webWidth);
                    }
                    else {
                        console.log('Expected webWidth of KBEParams to be a number but was ', typeof src.webWidth, src.webWidth)
                    }
                }
                if (src.bottomWidth !== undefined && src.bottomWidth !== null) {
                    if (typeof src.bottomWidth === "number" || src.bottomWidth === 'NaN' || src.bottomWidth === 'Infinity' || src.bottomWidth === '-Infinity') {
                        dst.bottomWidth = AsNum(src.bottomWidth);
                    }
                    else {
                        console.log('Expected bottomWidth of KBEParams to be a number but was ', typeof src.bottomWidth, src.bottomWidth)
                    }
                }
                if (src.supportWidth !== undefined && src.supportWidth !== null) {
                    if (typeof src.supportWidth === "number" || src.supportWidth === 'NaN' || src.supportWidth === 'Infinity' || src.supportWidth === '-Infinity') {
                        dst.supportWidth = AsNum(src.supportWidth);
                    }
                    else {
                        console.log('Expected supportWidth of KBEParams to be a number but was ', typeof src.supportWidth, src.supportWidth)
                    }
                }
                if (src.side !== undefined && src.side !== null) {
                    dst.side = ng.sections.SectionSide_FromObject(src.side);
                }
                return dst;
            }

            static toObject(src: KBEParams | null | undefined): KBEParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.KBEParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.KBEParams") {
                    console.error('Expected ng.sections.KBEParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const side_obj = ng.sections.SectionSide_ToObject(src.side);
                if(side_obj === null) return null;

                const dst : KBEParams_json = {
                    height: AsJsonNum(src.height),
                    flangeHeight: AsJsonNum(src.flangeHeight),
                    webWidth: AsJsonNum(src.webWidth),
                    bottomWidth: AsJsonNum(src.bottomWidth),
                    supportWidth: AsJsonNum(src.supportWidth),
                    side: side_obj,
                };
                return dst;
            }

            static create(src?: KBEParams_createType) {
                const dst = new KBEParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.flangeHeight !== undefined) {
                    dst.flangeHeight = src.flangeHeight;
                }
                if (src.webWidth !== undefined) {
                    dst.webWidth = src.webWidth;
                }
                if (src.bottomWidth !== undefined) {
                    dst.bottomWidth = src.bottomWidth;
                }
                if (src.supportWidth !== undefined) {
                    dst.supportWidth = src.supportWidth;
                }
                if (src.side !== undefined) {
                    dst.side = src.side;
                }
                return dst;
            }

            shallowClone() {
                const dst = new KBEParams();
                dst.height = this.height;
                dst.flangeHeight = this.flangeHeight;
                dst.webWidth = this.webWidth;
                dst.bottomWidth = this.bottomWidth;
                dst.supportWidth = this.supportWidth;
                dst.side = this.side;
                return dst;
            }

            deepClone() {
                const json = KBEParams.toObject(this);
                const dst = KBEParams.fromObject(json);
                return dst;
            }
        }
        export type IKBEParams = KBEParams;


        export type CParams_keys = 'diameter';
        export interface CParams_createType {
            diameter?: number,
        }
        export interface CParams_json {
            diameter?: JsonNumber;
        }
        interface CParams_json_in {
            __proto_name?: unknown;
            diameter?: unknown;
        }
        export class CParams {
            __proto_name = "ng.sections.CParams";
            diameter: number = 0;

            static fromObject(src_unknown: unknown): CParams {
                const dst = new CParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted CParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as CParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for CParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.diameter !== undefined && src.diameter !== null) {
                    if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                        dst.diameter = AsNum(src.diameter);
                    }
                    else {
                        console.log('Expected diameter of CParams to be a number but was ', typeof src.diameter, src.diameter)
                    }
                }
                return dst;
            }

            static toObject(src: CParams | null | undefined): CParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.CParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.CParams") {
                    console.error('Expected ng.sections.CParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : CParams_json = {
                    diameter: AsJsonNum(src.diameter),
                };
                return dst;
            }

            static create(src?: CParams_createType) {
                const dst = new CParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.diameter !== undefined) {
                    dst.diameter = src.diameter;
                }
                return dst;
            }

            shallowClone() {
                const dst = new CParams();
                dst.diameter = this.diameter;
                return dst;
            }

            deepClone() {
                const json = CParams.toObject(this);
                const dst = CParams.fromObject(json);
                return dst;
            }
        }
        export type ICParams = CParams;


        export type IParams_keys = 'height' | 'topFlangeHeight' | 'topWebHeight' | 'bottomWebHeight' | 'bottomFlangeHeight' | 'topFlangeWidth' | 'webWidth' | 'bottomFlangeWidth';
        export interface IParams_createType {
            height?: number,
            topFlangeHeight?: number,
            topWebHeight?: number,
            bottomWebHeight?: number,
            bottomFlangeHeight?: number,
            topFlangeWidth?: number,
            webWidth?: number,
            bottomFlangeWidth?: number,
        }
        export interface IParams_json {
            height?: JsonNumber;
            topFlangeHeight?: JsonNumber;
            topWebHeight?: JsonNumber;
            bottomWebHeight?: JsonNumber;
            bottomFlangeHeight?: JsonNumber;
            topFlangeWidth?: JsonNumber;
            webWidth?: JsonNumber;
            bottomFlangeWidth?: JsonNumber;
        }
        interface IParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            topFlangeHeight?: unknown;
            topWebHeight?: unknown;
            bottomWebHeight?: unknown;
            bottomFlangeHeight?: unknown;
            topFlangeWidth?: unknown;
            webWidth?: unknown;
            bottomFlangeWidth?: unknown;
        }
        export class IParams {
            __proto_name = "ng.sections.IParams";
            height: number = 0;
            topFlangeHeight: number = 0;
            topWebHeight: number = 0;
            bottomWebHeight: number = 0;
            bottomFlangeHeight: number = 0;
            topFlangeWidth: number = 0;
            webWidth: number = 0;
            bottomFlangeWidth: number = 0;

            static fromObject(src_unknown: unknown): IParams {
                const dst = new IParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted IParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as IParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for IParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of IParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.topFlangeHeight !== undefined && src.topFlangeHeight !== null) {
                    if (typeof src.topFlangeHeight === "number" || src.topFlangeHeight === 'NaN' || src.topFlangeHeight === 'Infinity' || src.topFlangeHeight === '-Infinity') {
                        dst.topFlangeHeight = AsNum(src.topFlangeHeight);
                    }
                    else {
                        console.log('Expected topFlangeHeight of IParams to be a number but was ', typeof src.topFlangeHeight, src.topFlangeHeight)
                    }
                }
                if (src.topWebHeight !== undefined && src.topWebHeight !== null) {
                    if (typeof src.topWebHeight === "number" || src.topWebHeight === 'NaN' || src.topWebHeight === 'Infinity' || src.topWebHeight === '-Infinity') {
                        dst.topWebHeight = AsNum(src.topWebHeight);
                    }
                    else {
                        console.log('Expected topWebHeight of IParams to be a number but was ', typeof src.topWebHeight, src.topWebHeight)
                    }
                }
                if (src.bottomWebHeight !== undefined && src.bottomWebHeight !== null) {
                    if (typeof src.bottomWebHeight === "number" || src.bottomWebHeight === 'NaN' || src.bottomWebHeight === 'Infinity' || src.bottomWebHeight === '-Infinity') {
                        dst.bottomWebHeight = AsNum(src.bottomWebHeight);
                    }
                    else {
                        console.log('Expected bottomWebHeight of IParams to be a number but was ', typeof src.bottomWebHeight, src.bottomWebHeight)
                    }
                }
                if (src.bottomFlangeHeight !== undefined && src.bottomFlangeHeight !== null) {
                    if (typeof src.bottomFlangeHeight === "number" || src.bottomFlangeHeight === 'NaN' || src.bottomFlangeHeight === 'Infinity' || src.bottomFlangeHeight === '-Infinity') {
                        dst.bottomFlangeHeight = AsNum(src.bottomFlangeHeight);
                    }
                    else {
                        console.log('Expected bottomFlangeHeight of IParams to be a number but was ', typeof src.bottomFlangeHeight, src.bottomFlangeHeight)
                    }
                }
                if (src.topFlangeWidth !== undefined && src.topFlangeWidth !== null) {
                    if (typeof src.topFlangeWidth === "number" || src.topFlangeWidth === 'NaN' || src.topFlangeWidth === 'Infinity' || src.topFlangeWidth === '-Infinity') {
                        dst.topFlangeWidth = AsNum(src.topFlangeWidth);
                    }
                    else {
                        console.log('Expected topFlangeWidth of IParams to be a number but was ', typeof src.topFlangeWidth, src.topFlangeWidth)
                    }
                }
                if (src.webWidth !== undefined && src.webWidth !== null) {
                    if (typeof src.webWidth === "number" || src.webWidth === 'NaN' || src.webWidth === 'Infinity' || src.webWidth === '-Infinity') {
                        dst.webWidth = AsNum(src.webWidth);
                    }
                    else {
                        console.log('Expected webWidth of IParams to be a number but was ', typeof src.webWidth, src.webWidth)
                    }
                }
                if (src.bottomFlangeWidth !== undefined && src.bottomFlangeWidth !== null) {
                    if (typeof src.bottomFlangeWidth === "number" || src.bottomFlangeWidth === 'NaN' || src.bottomFlangeWidth === 'Infinity' || src.bottomFlangeWidth === '-Infinity') {
                        dst.bottomFlangeWidth = AsNum(src.bottomFlangeWidth);
                    }
                    else {
                        console.log('Expected bottomFlangeWidth of IParams to be a number but was ', typeof src.bottomFlangeWidth, src.bottomFlangeWidth)
                    }
                }
                return dst;
            }

            static toObject(src: IParams | null | undefined): IParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.IParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.IParams") {
                    console.error('Expected ng.sections.IParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : IParams_json = {
                    height: AsJsonNum(src.height),
                    topFlangeHeight: AsJsonNum(src.topFlangeHeight),
                    topWebHeight: AsJsonNum(src.topWebHeight),
                    bottomWebHeight: AsJsonNum(src.bottomWebHeight),
                    bottomFlangeHeight: AsJsonNum(src.bottomFlangeHeight),
                    topFlangeWidth: AsJsonNum(src.topFlangeWidth),
                    webWidth: AsJsonNum(src.webWidth),
                    bottomFlangeWidth: AsJsonNum(src.bottomFlangeWidth),
                };
                return dst;
            }

            static create(src?: IParams_createType) {
                const dst = new IParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.topFlangeHeight !== undefined) {
                    dst.topFlangeHeight = src.topFlangeHeight;
                }
                if (src.topWebHeight !== undefined) {
                    dst.topWebHeight = src.topWebHeight;
                }
                if (src.bottomWebHeight !== undefined) {
                    dst.bottomWebHeight = src.bottomWebHeight;
                }
                if (src.bottomFlangeHeight !== undefined) {
                    dst.bottomFlangeHeight = src.bottomFlangeHeight;
                }
                if (src.topFlangeWidth !== undefined) {
                    dst.topFlangeWidth = src.topFlangeWidth;
                }
                if (src.webWidth !== undefined) {
                    dst.webWidth = src.webWidth;
                }
                if (src.bottomFlangeWidth !== undefined) {
                    dst.bottomFlangeWidth = src.bottomFlangeWidth;
                }
                return dst;
            }

            shallowClone() {
                const dst = new IParams();
                dst.height = this.height;
                dst.topFlangeHeight = this.topFlangeHeight;
                dst.topWebHeight = this.topWebHeight;
                dst.bottomWebHeight = this.bottomWebHeight;
                dst.bottomFlangeHeight = this.bottomFlangeHeight;
                dst.topFlangeWidth = this.topFlangeWidth;
                dst.webWidth = this.webWidth;
                dst.bottomFlangeWidth = this.bottomFlangeWidth;
                return dst;
            }

            deepClone() {
                const json = IParams.toObject(this);
                const dst = IParams.fromObject(json);
                return dst;
            }
        }
        export type IIParams = IParams;


        export type IVParams_keys = 'height' | 'topFlangeHeight' | 'topWebHeight' | 'bottomWebHeight' | 'bottomFlangeHeight' | 'topFlangeWidth' | 'topWebWidth' | 'topInnerWebWidth' | 'bottomInnerWebWidth' | 'bottomWebWidth' | 'bottomFlangeWidth';
        export interface IVParams_createType {
            height?: number,
            topFlangeHeight?: number,
            topWebHeight?: number,
            bottomWebHeight?: number,
            bottomFlangeHeight?: number,
            topFlangeWidth?: number,
            topWebWidth?: number,
            topInnerWebWidth?: number,
            bottomInnerWebWidth?: number,
            bottomWebWidth?: number,
            bottomFlangeWidth?: number,
        }
        export interface IVParams_json {
            height?: JsonNumber;
            topFlangeHeight?: JsonNumber;
            topWebHeight?: JsonNumber;
            bottomWebHeight?: JsonNumber;
            bottomFlangeHeight?: JsonNumber;
            topFlangeWidth?: JsonNumber;
            topWebWidth?: JsonNumber;
            topInnerWebWidth?: JsonNumber;
            bottomInnerWebWidth?: JsonNumber;
            bottomWebWidth?: JsonNumber;
            bottomFlangeWidth?: JsonNumber;
        }
        interface IVParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            topFlangeHeight?: unknown;
            topWebHeight?: unknown;
            bottomWebHeight?: unknown;
            bottomFlangeHeight?: unknown;
            topFlangeWidth?: unknown;
            topWebWidth?: unknown;
            topInnerWebWidth?: unknown;
            bottomInnerWebWidth?: unknown;
            bottomWebWidth?: unknown;
            bottomFlangeWidth?: unknown;
        }
        export class IVParams {
            __proto_name = "ng.sections.IVParams";
            height: number = 0;
            topFlangeHeight: number = 0;
            topWebHeight: number = 0;
            bottomWebHeight: number = 0;
            bottomFlangeHeight: number = 0;
            topFlangeWidth: number = 0;
            topWebWidth: number = 0;
            topInnerWebWidth: number = 0;
            bottomInnerWebWidth: number = 0;
            bottomWebWidth: number = 0;
            bottomFlangeWidth: number = 0;

            static fromObject(src_unknown: unknown): IVParams {
                const dst = new IVParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted IVParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as IVParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for IVParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of IVParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.topFlangeHeight !== undefined && src.topFlangeHeight !== null) {
                    if (typeof src.topFlangeHeight === "number" || src.topFlangeHeight === 'NaN' || src.topFlangeHeight === 'Infinity' || src.topFlangeHeight === '-Infinity') {
                        dst.topFlangeHeight = AsNum(src.topFlangeHeight);
                    }
                    else {
                        console.log('Expected topFlangeHeight of IVParams to be a number but was ', typeof src.topFlangeHeight, src.topFlangeHeight)
                    }
                }
                if (src.topWebHeight !== undefined && src.topWebHeight !== null) {
                    if (typeof src.topWebHeight === "number" || src.topWebHeight === 'NaN' || src.topWebHeight === 'Infinity' || src.topWebHeight === '-Infinity') {
                        dst.topWebHeight = AsNum(src.topWebHeight);
                    }
                    else {
                        console.log('Expected topWebHeight of IVParams to be a number but was ', typeof src.topWebHeight, src.topWebHeight)
                    }
                }
                if (src.bottomWebHeight !== undefined && src.bottomWebHeight !== null) {
                    if (typeof src.bottomWebHeight === "number" || src.bottomWebHeight === 'NaN' || src.bottomWebHeight === 'Infinity' || src.bottomWebHeight === '-Infinity') {
                        dst.bottomWebHeight = AsNum(src.bottomWebHeight);
                    }
                    else {
                        console.log('Expected bottomWebHeight of IVParams to be a number but was ', typeof src.bottomWebHeight, src.bottomWebHeight)
                    }
                }
                if (src.bottomFlangeHeight !== undefined && src.bottomFlangeHeight !== null) {
                    if (typeof src.bottomFlangeHeight === "number" || src.bottomFlangeHeight === 'NaN' || src.bottomFlangeHeight === 'Infinity' || src.bottomFlangeHeight === '-Infinity') {
                        dst.bottomFlangeHeight = AsNum(src.bottomFlangeHeight);
                    }
                    else {
                        console.log('Expected bottomFlangeHeight of IVParams to be a number but was ', typeof src.bottomFlangeHeight, src.bottomFlangeHeight)
                    }
                }
                if (src.topFlangeWidth !== undefined && src.topFlangeWidth !== null) {
                    if (typeof src.topFlangeWidth === "number" || src.topFlangeWidth === 'NaN' || src.topFlangeWidth === 'Infinity' || src.topFlangeWidth === '-Infinity') {
                        dst.topFlangeWidth = AsNum(src.topFlangeWidth);
                    }
                    else {
                        console.log('Expected topFlangeWidth of IVParams to be a number but was ', typeof src.topFlangeWidth, src.topFlangeWidth)
                    }
                }
                if (src.topWebWidth !== undefined && src.topWebWidth !== null) {
                    if (typeof src.topWebWidth === "number" || src.topWebWidth === 'NaN' || src.topWebWidth === 'Infinity' || src.topWebWidth === '-Infinity') {
                        dst.topWebWidth = AsNum(src.topWebWidth);
                    }
                    else {
                        console.log('Expected topWebWidth of IVParams to be a number but was ', typeof src.topWebWidth, src.topWebWidth)
                    }
                }
                if (src.topInnerWebWidth !== undefined && src.topInnerWebWidth !== null) {
                    if (typeof src.topInnerWebWidth === "number" || src.topInnerWebWidth === 'NaN' || src.topInnerWebWidth === 'Infinity' || src.topInnerWebWidth === '-Infinity') {
                        dst.topInnerWebWidth = AsNum(src.topInnerWebWidth);
                    }
                    else {
                        console.log('Expected topInnerWebWidth of IVParams to be a number but was ', typeof src.topInnerWebWidth, src.topInnerWebWidth)
                    }
                }
                if (src.bottomInnerWebWidth !== undefined && src.bottomInnerWebWidth !== null) {
                    if (typeof src.bottomInnerWebWidth === "number" || src.bottomInnerWebWidth === 'NaN' || src.bottomInnerWebWidth === 'Infinity' || src.bottomInnerWebWidth === '-Infinity') {
                        dst.bottomInnerWebWidth = AsNum(src.bottomInnerWebWidth);
                    }
                    else {
                        console.log('Expected bottomInnerWebWidth of IVParams to be a number but was ', typeof src.bottomInnerWebWidth, src.bottomInnerWebWidth)
                    }
                }
                if (src.bottomWebWidth !== undefined && src.bottomWebWidth !== null) {
                    if (typeof src.bottomWebWidth === "number" || src.bottomWebWidth === 'NaN' || src.bottomWebWidth === 'Infinity' || src.bottomWebWidth === '-Infinity') {
                        dst.bottomWebWidth = AsNum(src.bottomWebWidth);
                    }
                    else {
                        console.log('Expected bottomWebWidth of IVParams to be a number but was ', typeof src.bottomWebWidth, src.bottomWebWidth)
                    }
                }
                if (src.bottomFlangeWidth !== undefined && src.bottomFlangeWidth !== null) {
                    if (typeof src.bottomFlangeWidth === "number" || src.bottomFlangeWidth === 'NaN' || src.bottomFlangeWidth === 'Infinity' || src.bottomFlangeWidth === '-Infinity') {
                        dst.bottomFlangeWidth = AsNum(src.bottomFlangeWidth);
                    }
                    else {
                        console.log('Expected bottomFlangeWidth of IVParams to be a number but was ', typeof src.bottomFlangeWidth, src.bottomFlangeWidth)
                    }
                }
                return dst;
            }

            static toObject(src: IVParams | null | undefined): IVParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.IVParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.IVParams") {
                    console.error('Expected ng.sections.IVParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : IVParams_json = {
                    height: AsJsonNum(src.height),
                    topFlangeHeight: AsJsonNum(src.topFlangeHeight),
                    topWebHeight: AsJsonNum(src.topWebHeight),
                    bottomWebHeight: AsJsonNum(src.bottomWebHeight),
                    bottomFlangeHeight: AsJsonNum(src.bottomFlangeHeight),
                    topFlangeWidth: AsJsonNum(src.topFlangeWidth),
                    topWebWidth: AsJsonNum(src.topWebWidth),
                    topInnerWebWidth: AsJsonNum(src.topInnerWebWidth),
                    bottomInnerWebWidth: AsJsonNum(src.bottomInnerWebWidth),
                    bottomWebWidth: AsJsonNum(src.bottomWebWidth),
                    bottomFlangeWidth: AsJsonNum(src.bottomFlangeWidth),
                };
                return dst;
            }

            static create(src?: IVParams_createType) {
                const dst = new IVParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.topFlangeHeight !== undefined) {
                    dst.topFlangeHeight = src.topFlangeHeight;
                }
                if (src.topWebHeight !== undefined) {
                    dst.topWebHeight = src.topWebHeight;
                }
                if (src.bottomWebHeight !== undefined) {
                    dst.bottomWebHeight = src.bottomWebHeight;
                }
                if (src.bottomFlangeHeight !== undefined) {
                    dst.bottomFlangeHeight = src.bottomFlangeHeight;
                }
                if (src.topFlangeWidth !== undefined) {
                    dst.topFlangeWidth = src.topFlangeWidth;
                }
                if (src.topWebWidth !== undefined) {
                    dst.topWebWidth = src.topWebWidth;
                }
                if (src.topInnerWebWidth !== undefined) {
                    dst.topInnerWebWidth = src.topInnerWebWidth;
                }
                if (src.bottomInnerWebWidth !== undefined) {
                    dst.bottomInnerWebWidth = src.bottomInnerWebWidth;
                }
                if (src.bottomWebWidth !== undefined) {
                    dst.bottomWebWidth = src.bottomWebWidth;
                }
                if (src.bottomFlangeWidth !== undefined) {
                    dst.bottomFlangeWidth = src.bottomFlangeWidth;
                }
                return dst;
            }

            shallowClone() {
                const dst = new IVParams();
                dst.height = this.height;
                dst.topFlangeHeight = this.topFlangeHeight;
                dst.topWebHeight = this.topWebHeight;
                dst.bottomWebHeight = this.bottomWebHeight;
                dst.bottomFlangeHeight = this.bottomFlangeHeight;
                dst.topFlangeWidth = this.topFlangeWidth;
                dst.topWebWidth = this.topWebWidth;
                dst.topInnerWebWidth = this.topInnerWebWidth;
                dst.bottomInnerWebWidth = this.bottomInnerWebWidth;
                dst.bottomWebWidth = this.bottomWebWidth;
                dst.bottomFlangeWidth = this.bottomFlangeWidth;
                return dst;
            }

            deepClone() {
                const json = IVParams.toObject(this);
                const dst = IVParams.fromObject(json);
                return dst;
            }
        }
        export type IIVParams = IVParams;


        export type LParams_keys = 'height' | 'flangeHeight' | 'flangeWidth' | 'webWidth' | 'side';
        export interface LParams_createType {
            height?: number,
            flangeHeight?: number,
            flangeWidth?: number,
            webWidth?: number,
            side?: ng.sections.SectionSide,
        }
        export interface LParams_json {
            height?: JsonNumber;
            flangeHeight?: JsonNumber;
            flangeWidth?: JsonNumber;
            webWidth?: JsonNumber;
            side?: string;
        }
        interface LParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            flangeHeight?: unknown;
            flangeWidth?: unknown;
            webWidth?: unknown;
            side?: unknown;
        }
        export class LParams {
            __proto_name = "ng.sections.LParams";
            height: number = 0;
            flangeHeight: number = 0;
            flangeWidth: number = 0;
            webWidth: number = 0;
            side: ng.sections.SectionSide = ng.sections.SectionSide.SECTION_SIDE_UNSPECIFIED;

            static fromObject(src_unknown: unknown): LParams {
                const dst = new LParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of LParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.flangeHeight !== undefined && src.flangeHeight !== null) {
                    if (typeof src.flangeHeight === "number" || src.flangeHeight === 'NaN' || src.flangeHeight === 'Infinity' || src.flangeHeight === '-Infinity') {
                        dst.flangeHeight = AsNum(src.flangeHeight);
                    }
                    else {
                        console.log('Expected flangeHeight of LParams to be a number but was ', typeof src.flangeHeight, src.flangeHeight)
                    }
                }
                if (src.flangeWidth !== undefined && src.flangeWidth !== null) {
                    if (typeof src.flangeWidth === "number" || src.flangeWidth === 'NaN' || src.flangeWidth === 'Infinity' || src.flangeWidth === '-Infinity') {
                        dst.flangeWidth = AsNum(src.flangeWidth);
                    }
                    else {
                        console.log('Expected flangeWidth of LParams to be a number but was ', typeof src.flangeWidth, src.flangeWidth)
                    }
                }
                if (src.webWidth !== undefined && src.webWidth !== null) {
                    if (typeof src.webWidth === "number" || src.webWidth === 'NaN' || src.webWidth === 'Infinity' || src.webWidth === '-Infinity') {
                        dst.webWidth = AsNum(src.webWidth);
                    }
                    else {
                        console.log('Expected webWidth of LParams to be a number but was ', typeof src.webWidth, src.webWidth)
                    }
                }
                if (src.side !== undefined && src.side !== null) {
                    dst.side = ng.sections.SectionSide_FromObject(src.side);
                }
                return dst;
            }

            static toObject(src: LParams | null | undefined): LParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.LParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.LParams") {
                    console.error('Expected ng.sections.LParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const side_obj = ng.sections.SectionSide_ToObject(src.side);
                if(side_obj === null) return null;

                const dst : LParams_json = {
                    height: AsJsonNum(src.height),
                    flangeHeight: AsJsonNum(src.flangeHeight),
                    flangeWidth: AsJsonNum(src.flangeWidth),
                    webWidth: AsJsonNum(src.webWidth),
                    side: side_obj,
                };
                return dst;
            }

            static create(src?: LParams_createType) {
                const dst = new LParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.flangeHeight !== undefined) {
                    dst.flangeHeight = src.flangeHeight;
                }
                if (src.flangeWidth !== undefined) {
                    dst.flangeWidth = src.flangeWidth;
                }
                if (src.webWidth !== undefined) {
                    dst.webWidth = src.webWidth;
                }
                if (src.side !== undefined) {
                    dst.side = src.side;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LParams();
                dst.height = this.height;
                dst.flangeHeight = this.flangeHeight;
                dst.flangeWidth = this.flangeWidth;
                dst.webWidth = this.webWidth;
                dst.side = this.side;
                return dst;
            }

            deepClone() {
                const json = LParams.toObject(this);
                const dst = LParams.fromObject(json);
                return dst;
            }
        }
        export type ILParams = LParams;


        export type COParams_keys = 'diameter' | 'thickness';
        export interface COParams_createType {
            diameter?: number,
            thickness?: number,
        }
        export interface COParams_json {
            diameter?: JsonNumber;
            thickness?: JsonNumber;
        }
        interface COParams_json_in {
            __proto_name?: unknown;
            diameter?: unknown;
            thickness?: unknown;
        }
        export class COParams {
            __proto_name = "ng.sections.COParams";
            diameter: number = 0;
            thickness: number = 0;

            static fromObject(src_unknown: unknown): COParams {
                const dst = new COParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted COParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as COParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for COParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.diameter !== undefined && src.diameter !== null) {
                    if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                        dst.diameter = AsNum(src.diameter);
                    }
                    else {
                        console.log('Expected diameter of COParams to be a number but was ', typeof src.diameter, src.diameter)
                    }
                }
                if (src.thickness !== undefined && src.thickness !== null) {
                    if (typeof src.thickness === "number" || src.thickness === 'NaN' || src.thickness === 'Infinity' || src.thickness === '-Infinity') {
                        dst.thickness = AsNum(src.thickness);
                    }
                    else {
                        console.log('Expected thickness of COParams to be a number but was ', typeof src.thickness, src.thickness)
                    }
                }
                return dst;
            }

            static toObject(src: COParams | null | undefined): COParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.COParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.COParams") {
                    console.error('Expected ng.sections.COParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : COParams_json = {
                    diameter: AsJsonNum(src.diameter),
                    thickness: AsJsonNum(src.thickness),
                };
                return dst;
            }

            static create(src?: COParams_createType) {
                const dst = new COParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.diameter !== undefined) {
                    dst.diameter = src.diameter;
                }
                if (src.thickness !== undefined) {
                    dst.thickness = src.thickness;
                }
                return dst;
            }

            shallowClone() {
                const dst = new COParams();
                dst.diameter = this.diameter;
                dst.thickness = this.thickness;
                return dst;
            }

            deepClone() {
                const json = COParams.toObject(this);
                const dst = COParams.fromObject(json);
                return dst;
            }
        }
        export type ICOParams = COParams;


        export type HDXParams_keys = 'maxWidth' | 'widthUp' | 'height' | 'nbrOfHcs' | 'nbrOfHcsSidesUp' | 'nbrOfHcsSidesDown' | 'hcWidthUp' | 'hcWidthDown' | 'hcHeight' | 'hcSpacing' | 'hcDistUp' | 'hcRadiusUp' | 'radiusDistUp' | 'hcRadiusDown' | 'radiusDistDown' | 'flangeWidthUp' | 'flangeHeight1Up' | 'flangeHeight2Up' | 'flangeWidthDown' | 'flangeHeight1Down' | 'flangeHeight2Down';
        export interface HDXParams_createType {
            maxWidth?: number,
            widthUp?: number,
            height?: number,
            nbrOfHcs?: number,
            nbrOfHcsSidesUp?: number,
            nbrOfHcsSidesDown?: number,
            hcWidthUp?: number,
            hcWidthDown?: number,
            hcHeight?: number,
            hcSpacing?: number,
            hcDistUp?: number,
            hcRadiusUp?: number,
            radiusDistUp?: number,
            hcRadiusDown?: number,
            radiusDistDown?: number,
            flangeWidthUp?: number,
            flangeHeight1Up?: number,
            flangeHeight2Up?: number,
            flangeWidthDown?: number,
            flangeHeight1Down?: number,
            flangeHeight2Down?: number,
        }
        export interface HDXParams_json {
            maxWidth?: JsonNumber;
            widthUp?: JsonNumber;
            height?: JsonNumber;
            nbrOfHcs?: JsonNumber;
            nbrOfHcsSidesUp?: JsonNumber;
            nbrOfHcsSidesDown?: JsonNumber;
            hcWidthUp?: JsonNumber;
            hcWidthDown?: JsonNumber;
            hcHeight?: JsonNumber;
            hcSpacing?: JsonNumber;
            hcDistUp?: JsonNumber;
            hcRadiusUp?: JsonNumber;
            radiusDistUp?: JsonNumber;
            hcRadiusDown?: JsonNumber;
            radiusDistDown?: JsonNumber;
            flangeWidthUp?: JsonNumber;
            flangeHeight1Up?: JsonNumber;
            flangeHeight2Up?: JsonNumber;
            flangeWidthDown?: JsonNumber;
            flangeHeight1Down?: JsonNumber;
            flangeHeight2Down?: JsonNumber;
        }
        interface HDXParams_json_in {
            __proto_name?: unknown;
            maxWidth?: unknown;
            widthUp?: unknown;
            height?: unknown;
            nbrOfHcs?: unknown;
            nbrOfHcsSidesUp?: unknown;
            nbrOfHcsSidesDown?: unknown;
            hcWidthUp?: unknown;
            hcWidthDown?: unknown;
            hcHeight?: unknown;
            hcSpacing?: unknown;
            hcDistUp?: unknown;
            hcRadiusUp?: unknown;
            radiusDistUp?: unknown;
            hcRadiusDown?: unknown;
            radiusDistDown?: unknown;
            flangeWidthUp?: unknown;
            flangeHeight1Up?: unknown;
            flangeHeight2Up?: unknown;
            flangeWidthDown?: unknown;
            flangeHeight1Down?: unknown;
            flangeHeight2Down?: unknown;
        }
        export class HDXParams {
            __proto_name = "ng.sections.HDXParams";
            maxWidth: number = 0;
            widthUp: number = 0;
            height: number = 0;
            nbrOfHcs: number = 0;
            nbrOfHcsSidesUp: number = 0;
            nbrOfHcsSidesDown: number = 0;
            hcWidthUp: number = 0;
            hcWidthDown: number = 0;
            hcHeight: number = 0;
            hcSpacing: number = 0;
            hcDistUp: number = 0;
            hcRadiusUp: number = 0;
            radiusDistUp: number = 0;
            hcRadiusDown: number = 0;
            radiusDistDown: number = 0;
            flangeWidthUp: number = 0;
            flangeHeight1Up: number = 0;
            flangeHeight2Up: number = 0;
            flangeWidthDown: number = 0;
            flangeHeight1Down: number = 0;
            flangeHeight2Down: number = 0;

            static fromObject(src_unknown: unknown): HDXParams {
                const dst = new HDXParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted HDXParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as HDXParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for HDXParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.maxWidth !== undefined && src.maxWidth !== null) {
                    if (typeof src.maxWidth === "number" || src.maxWidth === 'NaN' || src.maxWidth === 'Infinity' || src.maxWidth === '-Infinity') {
                        dst.maxWidth = AsNum(src.maxWidth);
                    }
                    else {
                        console.log('Expected maxWidth of HDXParams to be a number but was ', typeof src.maxWidth, src.maxWidth)
                    }
                }
                if (src.widthUp !== undefined && src.widthUp !== null) {
                    if (typeof src.widthUp === "number" || src.widthUp === 'NaN' || src.widthUp === 'Infinity' || src.widthUp === '-Infinity') {
                        dst.widthUp = AsNum(src.widthUp);
                    }
                    else {
                        console.log('Expected widthUp of HDXParams to be a number but was ', typeof src.widthUp, src.widthUp)
                    }
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of HDXParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.nbrOfHcs !== undefined && src.nbrOfHcs !== null) {
                    if (typeof src.nbrOfHcs === "number" || src.nbrOfHcs === 'NaN' || src.nbrOfHcs === 'Infinity' || src.nbrOfHcs === '-Infinity') {
                        dst.nbrOfHcs = NumberToInt("ng.sections.HDXParams.nbr_of_hcs", AsNum(src.nbrOfHcs));
                    }
                    else {
                        console.log('Expected nbrOfHcs of HDXParams to be a number but was ', typeof src.nbrOfHcs, src.nbrOfHcs)
                    }
                }
                if (src.nbrOfHcsSidesUp !== undefined && src.nbrOfHcsSidesUp !== null) {
                    if (typeof src.nbrOfHcsSidesUp === "number" || src.nbrOfHcsSidesUp === 'NaN' || src.nbrOfHcsSidesUp === 'Infinity' || src.nbrOfHcsSidesUp === '-Infinity') {
                        dst.nbrOfHcsSidesUp = NumberToInt("ng.sections.HDXParams.nbr_of_hcs_sides_up", AsNum(src.nbrOfHcsSidesUp));
                    }
                    else {
                        console.log('Expected nbrOfHcsSidesUp of HDXParams to be a number but was ', typeof src.nbrOfHcsSidesUp, src.nbrOfHcsSidesUp)
                    }
                }
                if (src.nbrOfHcsSidesDown !== undefined && src.nbrOfHcsSidesDown !== null) {
                    if (typeof src.nbrOfHcsSidesDown === "number" || src.nbrOfHcsSidesDown === 'NaN' || src.nbrOfHcsSidesDown === 'Infinity' || src.nbrOfHcsSidesDown === '-Infinity') {
                        dst.nbrOfHcsSidesDown = NumberToInt("ng.sections.HDXParams.nbr_of_hcs_sides_down", AsNum(src.nbrOfHcsSidesDown));
                    }
                    else {
                        console.log('Expected nbrOfHcsSidesDown of HDXParams to be a number but was ', typeof src.nbrOfHcsSidesDown, src.nbrOfHcsSidesDown)
                    }
                }
                if (src.hcWidthUp !== undefined && src.hcWidthUp !== null) {
                    if (typeof src.hcWidthUp === "number" || src.hcWidthUp === 'NaN' || src.hcWidthUp === 'Infinity' || src.hcWidthUp === '-Infinity') {
                        dst.hcWidthUp = AsNum(src.hcWidthUp);
                    }
                    else {
                        console.log('Expected hcWidthUp of HDXParams to be a number but was ', typeof src.hcWidthUp, src.hcWidthUp)
                    }
                }
                if (src.hcWidthDown !== undefined && src.hcWidthDown !== null) {
                    if (typeof src.hcWidthDown === "number" || src.hcWidthDown === 'NaN' || src.hcWidthDown === 'Infinity' || src.hcWidthDown === '-Infinity') {
                        dst.hcWidthDown = AsNum(src.hcWidthDown);
                    }
                    else {
                        console.log('Expected hcWidthDown of HDXParams to be a number but was ', typeof src.hcWidthDown, src.hcWidthDown)
                    }
                }
                if (src.hcHeight !== undefined && src.hcHeight !== null) {
                    if (typeof src.hcHeight === "number" || src.hcHeight === 'NaN' || src.hcHeight === 'Infinity' || src.hcHeight === '-Infinity') {
                        dst.hcHeight = AsNum(src.hcHeight);
                    }
                    else {
                        console.log('Expected hcHeight of HDXParams to be a number but was ', typeof src.hcHeight, src.hcHeight)
                    }
                }
                if (src.hcSpacing !== undefined && src.hcSpacing !== null) {
                    if (typeof src.hcSpacing === "number" || src.hcSpacing === 'NaN' || src.hcSpacing === 'Infinity' || src.hcSpacing === '-Infinity') {
                        dst.hcSpacing = AsNum(src.hcSpacing);
                    }
                    else {
                        console.log('Expected hcSpacing of HDXParams to be a number but was ', typeof src.hcSpacing, src.hcSpacing)
                    }
                }
                if (src.hcDistUp !== undefined && src.hcDistUp !== null) {
                    if (typeof src.hcDistUp === "number" || src.hcDistUp === 'NaN' || src.hcDistUp === 'Infinity' || src.hcDistUp === '-Infinity') {
                        dst.hcDistUp = AsNum(src.hcDistUp);
                    }
                    else {
                        console.log('Expected hcDistUp of HDXParams to be a number but was ', typeof src.hcDistUp, src.hcDistUp)
                    }
                }
                if (src.hcRadiusUp !== undefined && src.hcRadiusUp !== null) {
                    if (typeof src.hcRadiusUp === "number" || src.hcRadiusUp === 'NaN' || src.hcRadiusUp === 'Infinity' || src.hcRadiusUp === '-Infinity') {
                        dst.hcRadiusUp = AsNum(src.hcRadiusUp);
                    }
                    else {
                        console.log('Expected hcRadiusUp of HDXParams to be a number but was ', typeof src.hcRadiusUp, src.hcRadiusUp)
                    }
                }
                if (src.radiusDistUp !== undefined && src.radiusDistUp !== null) {
                    if (typeof src.radiusDistUp === "number" || src.radiusDistUp === 'NaN' || src.radiusDistUp === 'Infinity' || src.radiusDistUp === '-Infinity') {
                        dst.radiusDistUp = AsNum(src.radiusDistUp);
                    }
                    else {
                        console.log('Expected radiusDistUp of HDXParams to be a number but was ', typeof src.radiusDistUp, src.radiusDistUp)
                    }
                }
                if (src.hcRadiusDown !== undefined && src.hcRadiusDown !== null) {
                    if (typeof src.hcRadiusDown === "number" || src.hcRadiusDown === 'NaN' || src.hcRadiusDown === 'Infinity' || src.hcRadiusDown === '-Infinity') {
                        dst.hcRadiusDown = AsNum(src.hcRadiusDown);
                    }
                    else {
                        console.log('Expected hcRadiusDown of HDXParams to be a number but was ', typeof src.hcRadiusDown, src.hcRadiusDown)
                    }
                }
                if (src.radiusDistDown !== undefined && src.radiusDistDown !== null) {
                    if (typeof src.radiusDistDown === "number" || src.radiusDistDown === 'NaN' || src.radiusDistDown === 'Infinity' || src.radiusDistDown === '-Infinity') {
                        dst.radiusDistDown = AsNum(src.radiusDistDown);
                    }
                    else {
                        console.log('Expected radiusDistDown of HDXParams to be a number but was ', typeof src.radiusDistDown, src.radiusDistDown)
                    }
                }
                if (src.flangeWidthUp !== undefined && src.flangeWidthUp !== null) {
                    if (typeof src.flangeWidthUp === "number" || src.flangeWidthUp === 'NaN' || src.flangeWidthUp === 'Infinity' || src.flangeWidthUp === '-Infinity') {
                        dst.flangeWidthUp = AsNum(src.flangeWidthUp);
                    }
                    else {
                        console.log('Expected flangeWidthUp of HDXParams to be a number but was ', typeof src.flangeWidthUp, src.flangeWidthUp)
                    }
                }
                if (src.flangeHeight1Up !== undefined && src.flangeHeight1Up !== null) {
                    if (typeof src.flangeHeight1Up === "number" || src.flangeHeight1Up === 'NaN' || src.flangeHeight1Up === 'Infinity' || src.flangeHeight1Up === '-Infinity') {
                        dst.flangeHeight1Up = AsNum(src.flangeHeight1Up);
                    }
                    else {
                        console.log('Expected flangeHeight1Up of HDXParams to be a number but was ', typeof src.flangeHeight1Up, src.flangeHeight1Up)
                    }
                }
                if (src.flangeHeight2Up !== undefined && src.flangeHeight2Up !== null) {
                    if (typeof src.flangeHeight2Up === "number" || src.flangeHeight2Up === 'NaN' || src.flangeHeight2Up === 'Infinity' || src.flangeHeight2Up === '-Infinity') {
                        dst.flangeHeight2Up = AsNum(src.flangeHeight2Up);
                    }
                    else {
                        console.log('Expected flangeHeight2Up of HDXParams to be a number but was ', typeof src.flangeHeight2Up, src.flangeHeight2Up)
                    }
                }
                if (src.flangeWidthDown !== undefined && src.flangeWidthDown !== null) {
                    if (typeof src.flangeWidthDown === "number" || src.flangeWidthDown === 'NaN' || src.flangeWidthDown === 'Infinity' || src.flangeWidthDown === '-Infinity') {
                        dst.flangeWidthDown = AsNum(src.flangeWidthDown);
                    }
                    else {
                        console.log('Expected flangeWidthDown of HDXParams to be a number but was ', typeof src.flangeWidthDown, src.flangeWidthDown)
                    }
                }
                if (src.flangeHeight1Down !== undefined && src.flangeHeight1Down !== null) {
                    if (typeof src.flangeHeight1Down === "number" || src.flangeHeight1Down === 'NaN' || src.flangeHeight1Down === 'Infinity' || src.flangeHeight1Down === '-Infinity') {
                        dst.flangeHeight1Down = AsNum(src.flangeHeight1Down);
                    }
                    else {
                        console.log('Expected flangeHeight1Down of HDXParams to be a number but was ', typeof src.flangeHeight1Down, src.flangeHeight1Down)
                    }
                }
                if (src.flangeHeight2Down !== undefined && src.flangeHeight2Down !== null) {
                    if (typeof src.flangeHeight2Down === "number" || src.flangeHeight2Down === 'NaN' || src.flangeHeight2Down === 'Infinity' || src.flangeHeight2Down === '-Infinity') {
                        dst.flangeHeight2Down = AsNum(src.flangeHeight2Down);
                    }
                    else {
                        console.log('Expected flangeHeight2Down of HDXParams to be a number but was ', typeof src.flangeHeight2Down, src.flangeHeight2Down)
                    }
                }
                return dst;
            }

            static toObject(src: HDXParams | null | undefined): HDXParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.HDXParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.HDXParams") {
                    console.error('Expected ng.sections.HDXParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : HDXParams_json = {
                    maxWidth: AsJsonNum(src.maxWidth),
                    widthUp: AsJsonNum(src.widthUp),
                    height: AsJsonNum(src.height),
                    nbrOfHcs: AsJsonNum(NumberToInt("ng.sections.HDXParams.nbr_of_hcs", src.nbrOfHcs)),
                    nbrOfHcsSidesUp: AsJsonNum(NumberToInt("ng.sections.HDXParams.nbr_of_hcs_sides_up", src.nbrOfHcsSidesUp)),
                    nbrOfHcsSidesDown: AsJsonNum(NumberToInt("ng.sections.HDXParams.nbr_of_hcs_sides_down", src.nbrOfHcsSidesDown)),
                    hcWidthUp: AsJsonNum(src.hcWidthUp),
                    hcWidthDown: AsJsonNum(src.hcWidthDown),
                    hcHeight: AsJsonNum(src.hcHeight),
                    hcSpacing: AsJsonNum(src.hcSpacing),
                    hcDistUp: AsJsonNum(src.hcDistUp),
                    hcRadiusUp: AsJsonNum(src.hcRadiusUp),
                    radiusDistUp: AsJsonNum(src.radiusDistUp),
                    hcRadiusDown: AsJsonNum(src.hcRadiusDown),
                    radiusDistDown: AsJsonNum(src.radiusDistDown),
                    flangeWidthUp: AsJsonNum(src.flangeWidthUp),
                    flangeHeight1Up: AsJsonNum(src.flangeHeight1Up),
                    flangeHeight2Up: AsJsonNum(src.flangeHeight2Up),
                    flangeWidthDown: AsJsonNum(src.flangeWidthDown),
                    flangeHeight1Down: AsJsonNum(src.flangeHeight1Down),
                    flangeHeight2Down: AsJsonNum(src.flangeHeight2Down),
                };
                return dst;
            }

            static create(src?: HDXParams_createType) {
                const dst = new HDXParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.maxWidth !== undefined) {
                    dst.maxWidth = src.maxWidth;
                }
                if (src.widthUp !== undefined) {
                    dst.widthUp = src.widthUp;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.nbrOfHcs !== undefined) {
                    dst.nbrOfHcs = src.nbrOfHcs;
                }
                if (src.nbrOfHcsSidesUp !== undefined) {
                    dst.nbrOfHcsSidesUp = src.nbrOfHcsSidesUp;
                }
                if (src.nbrOfHcsSidesDown !== undefined) {
                    dst.nbrOfHcsSidesDown = src.nbrOfHcsSidesDown;
                }
                if (src.hcWidthUp !== undefined) {
                    dst.hcWidthUp = src.hcWidthUp;
                }
                if (src.hcWidthDown !== undefined) {
                    dst.hcWidthDown = src.hcWidthDown;
                }
                if (src.hcHeight !== undefined) {
                    dst.hcHeight = src.hcHeight;
                }
                if (src.hcSpacing !== undefined) {
                    dst.hcSpacing = src.hcSpacing;
                }
                if (src.hcDistUp !== undefined) {
                    dst.hcDistUp = src.hcDistUp;
                }
                if (src.hcRadiusUp !== undefined) {
                    dst.hcRadiusUp = src.hcRadiusUp;
                }
                if (src.radiusDistUp !== undefined) {
                    dst.radiusDistUp = src.radiusDistUp;
                }
                if (src.hcRadiusDown !== undefined) {
                    dst.hcRadiusDown = src.hcRadiusDown;
                }
                if (src.radiusDistDown !== undefined) {
                    dst.radiusDistDown = src.radiusDistDown;
                }
                if (src.flangeWidthUp !== undefined) {
                    dst.flangeWidthUp = src.flangeWidthUp;
                }
                if (src.flangeHeight1Up !== undefined) {
                    dst.flangeHeight1Up = src.flangeHeight1Up;
                }
                if (src.flangeHeight2Up !== undefined) {
                    dst.flangeHeight2Up = src.flangeHeight2Up;
                }
                if (src.flangeWidthDown !== undefined) {
                    dst.flangeWidthDown = src.flangeWidthDown;
                }
                if (src.flangeHeight1Down !== undefined) {
                    dst.flangeHeight1Down = src.flangeHeight1Down;
                }
                if (src.flangeHeight2Down !== undefined) {
                    dst.flangeHeight2Down = src.flangeHeight2Down;
                }
                return dst;
            }

            shallowClone() {
                const dst = new HDXParams();
                dst.maxWidth = this.maxWidth;
                dst.widthUp = this.widthUp;
                dst.height = this.height;
                dst.nbrOfHcs = this.nbrOfHcs;
                dst.nbrOfHcsSidesUp = this.nbrOfHcsSidesUp;
                dst.nbrOfHcsSidesDown = this.nbrOfHcsSidesDown;
                dst.hcWidthUp = this.hcWidthUp;
                dst.hcWidthDown = this.hcWidthDown;
                dst.hcHeight = this.hcHeight;
                dst.hcSpacing = this.hcSpacing;
                dst.hcDistUp = this.hcDistUp;
                dst.hcRadiusUp = this.hcRadiusUp;
                dst.radiusDistUp = this.radiusDistUp;
                dst.hcRadiusDown = this.hcRadiusDown;
                dst.radiusDistDown = this.radiusDistDown;
                dst.flangeWidthUp = this.flangeWidthUp;
                dst.flangeHeight1Up = this.flangeHeight1Up;
                dst.flangeHeight2Up = this.flangeHeight2Up;
                dst.flangeWidthDown = this.flangeWidthDown;
                dst.flangeHeight1Down = this.flangeHeight1Down;
                dst.flangeHeight2Down = this.flangeHeight2Down;
                return dst;
            }

            deepClone() {
                const json = HDXParams.toObject(this);
                const dst = HDXParams.fromObject(json);
                return dst;
            }
        }
        export type IHDXParams = HDXParams;


        export type UParams_keys = 'height' | 'width' | 'webThickness' | 'flangeThickness' | 'radius';
        export interface UParams_createType {
            height?: number,
            width?: number,
            webThickness?: number,
            flangeThickness?: number,
            radius?: number,
        }
        export interface UParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
            webThickness?: JsonNumber;
            flangeThickness?: JsonNumber;
            radius?: JsonNumber;
        }
        interface UParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
            webThickness?: unknown;
            flangeThickness?: unknown;
            radius?: unknown;
        }
        export class UParams {
            __proto_name = "ng.sections.UParams";
            height: number = 0;
            width: number = 0;
            webThickness: number = 0;
            flangeThickness: number = 0;
            radius: number = 0;

            static fromObject(src_unknown: unknown): UParams {
                const dst = new UParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted UParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as UParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for UParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of UParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of UParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.webThickness !== undefined && src.webThickness !== null) {
                    if (typeof src.webThickness === "number" || src.webThickness === 'NaN' || src.webThickness === 'Infinity' || src.webThickness === '-Infinity') {
                        dst.webThickness = AsNum(src.webThickness);
                    }
                    else {
                        console.log('Expected webThickness of UParams to be a number but was ', typeof src.webThickness, src.webThickness)
                    }
                }
                if (src.flangeThickness !== undefined && src.flangeThickness !== null) {
                    if (typeof src.flangeThickness === "number" || src.flangeThickness === 'NaN' || src.flangeThickness === 'Infinity' || src.flangeThickness === '-Infinity') {
                        dst.flangeThickness = AsNum(src.flangeThickness);
                    }
                    else {
                        console.log('Expected flangeThickness of UParams to be a number but was ', typeof src.flangeThickness, src.flangeThickness)
                    }
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of UParams to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                return dst;
            }

            static toObject(src: UParams | null | undefined): UParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.UParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.UParams") {
                    console.error('Expected ng.sections.UParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : UParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                    webThickness: AsJsonNum(src.webThickness),
                    flangeThickness: AsJsonNum(src.flangeThickness),
                    radius: AsJsonNum(src.radius),
                };
                return dst;
            }

            static create(src?: UParams_createType) {
                const dst = new UParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.webThickness !== undefined) {
                    dst.webThickness = src.webThickness;
                }
                if (src.flangeThickness !== undefined) {
                    dst.flangeThickness = src.flangeThickness;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                return dst;
            }

            shallowClone() {
                const dst = new UParams();
                dst.height = this.height;
                dst.width = this.width;
                dst.webThickness = this.webThickness;
                dst.flangeThickness = this.flangeThickness;
                dst.radius = this.radius;
                return dst;
            }

            deepClone() {
                const json = UParams.toObject(this);
                const dst = UParams.fromObject(json);
                return dst;
            }
        }
        export type IUParams = UParams;


        export type ZParams_keys = 'height' | 'width' | 'webThickness' | 'flangeThickness' | 'radius';
        export interface ZParams_createType {
            height?: number,
            width?: number,
            webThickness?: number,
            flangeThickness?: number,
            radius?: number,
        }
        export interface ZParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
            webThickness?: JsonNumber;
            flangeThickness?: JsonNumber;
            radius?: JsonNumber;
        }
        interface ZParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
            webThickness?: unknown;
            flangeThickness?: unknown;
            radius?: unknown;
        }
        export class ZParams {
            __proto_name = "ng.sections.ZParams";
            height: number = 0;
            width: number = 0;
            webThickness: number = 0;
            flangeThickness: number = 0;
            radius: number = 0;

            static fromObject(src_unknown: unknown): ZParams {
                const dst = new ZParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ZParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ZParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ZParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of ZParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of ZParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.webThickness !== undefined && src.webThickness !== null) {
                    if (typeof src.webThickness === "number" || src.webThickness === 'NaN' || src.webThickness === 'Infinity' || src.webThickness === '-Infinity') {
                        dst.webThickness = AsNum(src.webThickness);
                    }
                    else {
                        console.log('Expected webThickness of ZParams to be a number but was ', typeof src.webThickness, src.webThickness)
                    }
                }
                if (src.flangeThickness !== undefined && src.flangeThickness !== null) {
                    if (typeof src.flangeThickness === "number" || src.flangeThickness === 'NaN' || src.flangeThickness === 'Infinity' || src.flangeThickness === '-Infinity') {
                        dst.flangeThickness = AsNum(src.flangeThickness);
                    }
                    else {
                        console.log('Expected flangeThickness of ZParams to be a number but was ', typeof src.flangeThickness, src.flangeThickness)
                    }
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of ZParams to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                return dst;
            }

            static toObject(src: ZParams | null | undefined): ZParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.ZParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.ZParams") {
                    console.error('Expected ng.sections.ZParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ZParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                    webThickness: AsJsonNum(src.webThickness),
                    flangeThickness: AsJsonNum(src.flangeThickness),
                    radius: AsJsonNum(src.radius),
                };
                return dst;
            }

            static create(src?: ZParams_createType) {
                const dst = new ZParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.webThickness !== undefined) {
                    dst.webThickness = src.webThickness;
                }
                if (src.flangeThickness !== undefined) {
                    dst.flangeThickness = src.flangeThickness;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ZParams();
                dst.height = this.height;
                dst.width = this.width;
                dst.webThickness = this.webThickness;
                dst.flangeThickness = this.flangeThickness;
                dst.radius = this.radius;
                return dst;
            }

            deepClone() {
                const json = ZParams.toObject(this);
                const dst = ZParams.fromObject(json);
                return dst;
            }
        }
        export type IZParams = ZParams;


        export type RHSParams_keys = 'height' | 'width' | 'thickness' | 'radius';
        export interface RHSParams_createType {
            height?: number,
            width?: number,
            thickness?: number,
            radius?: number,
        }
        export interface RHSParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
            thickness?: JsonNumber;
            radius?: JsonNumber;
        }
        interface RHSParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
            thickness?: unknown;
            radius?: unknown;
        }
        export class RHSParams {
            __proto_name = "ng.sections.RHSParams";
            height: number = 0;
            width: number = 0;
            thickness: number = 0;
            radius: number = 0;

            static fromObject(src_unknown: unknown): RHSParams {
                const dst = new RHSParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted RHSParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as RHSParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for RHSParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of RHSParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of RHSParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.thickness !== undefined && src.thickness !== null) {
                    if (typeof src.thickness === "number" || src.thickness === 'NaN' || src.thickness === 'Infinity' || src.thickness === '-Infinity') {
                        dst.thickness = AsNum(src.thickness);
                    }
                    else {
                        console.log('Expected thickness of RHSParams to be a number but was ', typeof src.thickness, src.thickness)
                    }
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of RHSParams to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                return dst;
            }

            static toObject(src: RHSParams | null | undefined): RHSParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.RHSParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.RHSParams") {
                    console.error('Expected ng.sections.RHSParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : RHSParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                    thickness: AsJsonNum(src.thickness),
                    radius: AsJsonNum(src.radius),
                };
                return dst;
            }

            static create(src?: RHSParams_createType) {
                const dst = new RHSParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.thickness !== undefined) {
                    dst.thickness = src.thickness;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                return dst;
            }

            shallowClone() {
                const dst = new RHSParams();
                dst.height = this.height;
                dst.width = this.width;
                dst.thickness = this.thickness;
                dst.radius = this.radius;
                return dst;
            }

            deepClone() {
                const json = RHSParams.toObject(this);
                const dst = RHSParams.fromObject(json);
                return dst;
            }
        }
        export type IRHSParams = RHSParams;


        export type ToppingParams_keys = 'maxWidthLft' | 'widthOfMaxThicknessLft' | 'widthOfSlopeLft' | 'maxWidthRgt' | 'widthOfMaxThicknessRgt' | 'widthOfSlopeRgt' | 'thicknessAboveBeam' | 'minThicknessLft' | 'slopeThicknessLft' | 'minThicknessRgt' | 'slopeThicknessRgt' | 'widthAboveBeam';
        export interface ToppingParams_createType {
            maxWidthLft?: number,
            widthOfMaxThicknessLft?: number,
            widthOfSlopeLft?: number,
            maxWidthRgt?: number,
            widthOfMaxThicknessRgt?: number,
            widthOfSlopeRgt?: number,
            thicknessAboveBeam?: number,
            minThicknessLft?: number,
            slopeThicknessLft?: number,
            minThicknessRgt?: number,
            slopeThicknessRgt?: number,
            widthAboveBeam?: number,
        }
        export interface ToppingParams_json {
            maxWidthLft?: JsonNumber;
            widthOfMaxThicknessLft?: JsonNumber;
            widthOfSlopeLft?: JsonNumber;
            maxWidthRgt?: JsonNumber;
            widthOfMaxThicknessRgt?: JsonNumber;
            widthOfSlopeRgt?: JsonNumber;
            thicknessAboveBeam?: JsonNumber;
            minThicknessLft?: JsonNumber;
            slopeThicknessLft?: JsonNumber;
            minThicknessRgt?: JsonNumber;
            slopeThicknessRgt?: JsonNumber;
            widthAboveBeam?: JsonNumber;
        }
        interface ToppingParams_json_in {
            __proto_name?: unknown;
            maxWidthLft?: unknown;
            widthOfMaxThicknessLft?: unknown;
            widthOfSlopeLft?: unknown;
            maxWidthRgt?: unknown;
            widthOfMaxThicknessRgt?: unknown;
            widthOfSlopeRgt?: unknown;
            thicknessAboveBeam?: unknown;
            minThicknessLft?: unknown;
            slopeThicknessLft?: unknown;
            minThicknessRgt?: unknown;
            slopeThicknessRgt?: unknown;
            widthAboveBeam?: unknown;
        }
        export class ToppingParams {
            __proto_name = "ng.sections.ToppingParams";
            maxWidthLft: number = 0;
            widthOfMaxThicknessLft: number = 0;
            widthOfSlopeLft: number = 0;
            maxWidthRgt: number = 0;
            widthOfMaxThicknessRgt: number = 0;
            widthOfSlopeRgt: number = 0;
            thicknessAboveBeam: number = 0;
            minThicknessLft: number = 0;
            slopeThicknessLft: number = 0;
            minThicknessRgt: number = 0;
            slopeThicknessRgt: number = 0;
            widthAboveBeam: number = 0;

            static fromObject(src_unknown: unknown): ToppingParams {
                const dst = new ToppingParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ToppingParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ToppingParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ToppingParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.maxWidthLft !== undefined && src.maxWidthLft !== null) {
                    if (typeof src.maxWidthLft === "number" || src.maxWidthLft === 'NaN' || src.maxWidthLft === 'Infinity' || src.maxWidthLft === '-Infinity') {
                        dst.maxWidthLft = AsNum(src.maxWidthLft);
                    }
                    else {
                        console.log('Expected maxWidthLft of ToppingParams to be a number but was ', typeof src.maxWidthLft, src.maxWidthLft)
                    }
                }
                if (src.widthOfMaxThicknessLft !== undefined && src.widthOfMaxThicknessLft !== null) {
                    if (typeof src.widthOfMaxThicknessLft === "number" || src.widthOfMaxThicknessLft === 'NaN' || src.widthOfMaxThicknessLft === 'Infinity' || src.widthOfMaxThicknessLft === '-Infinity') {
                        dst.widthOfMaxThicknessLft = AsNum(src.widthOfMaxThicknessLft);
                    }
                    else {
                        console.log('Expected widthOfMaxThicknessLft of ToppingParams to be a number but was ', typeof src.widthOfMaxThicknessLft, src.widthOfMaxThicknessLft)
                    }
                }
                if (src.widthOfSlopeLft !== undefined && src.widthOfSlopeLft !== null) {
                    if (typeof src.widthOfSlopeLft === "number" || src.widthOfSlopeLft === 'NaN' || src.widthOfSlopeLft === 'Infinity' || src.widthOfSlopeLft === '-Infinity') {
                        dst.widthOfSlopeLft = AsNum(src.widthOfSlopeLft);
                    }
                    else {
                        console.log('Expected widthOfSlopeLft of ToppingParams to be a number but was ', typeof src.widthOfSlopeLft, src.widthOfSlopeLft)
                    }
                }
                if (src.maxWidthRgt !== undefined && src.maxWidthRgt !== null) {
                    if (typeof src.maxWidthRgt === "number" || src.maxWidthRgt === 'NaN' || src.maxWidthRgt === 'Infinity' || src.maxWidthRgt === '-Infinity') {
                        dst.maxWidthRgt = AsNum(src.maxWidthRgt);
                    }
                    else {
                        console.log('Expected maxWidthRgt of ToppingParams to be a number but was ', typeof src.maxWidthRgt, src.maxWidthRgt)
                    }
                }
                if (src.widthOfMaxThicknessRgt !== undefined && src.widthOfMaxThicknessRgt !== null) {
                    if (typeof src.widthOfMaxThicknessRgt === "number" || src.widthOfMaxThicknessRgt === 'NaN' || src.widthOfMaxThicknessRgt === 'Infinity' || src.widthOfMaxThicknessRgt === '-Infinity') {
                        dst.widthOfMaxThicknessRgt = AsNum(src.widthOfMaxThicknessRgt);
                    }
                    else {
                        console.log('Expected widthOfMaxThicknessRgt of ToppingParams to be a number but was ', typeof src.widthOfMaxThicknessRgt, src.widthOfMaxThicknessRgt)
                    }
                }
                if (src.widthOfSlopeRgt !== undefined && src.widthOfSlopeRgt !== null) {
                    if (typeof src.widthOfSlopeRgt === "number" || src.widthOfSlopeRgt === 'NaN' || src.widthOfSlopeRgt === 'Infinity' || src.widthOfSlopeRgt === '-Infinity') {
                        dst.widthOfSlopeRgt = AsNum(src.widthOfSlopeRgt);
                    }
                    else {
                        console.log('Expected widthOfSlopeRgt of ToppingParams to be a number but was ', typeof src.widthOfSlopeRgt, src.widthOfSlopeRgt)
                    }
                }
                if (src.thicknessAboveBeam !== undefined && src.thicknessAboveBeam !== null) {
                    if (typeof src.thicknessAboveBeam === "number" || src.thicknessAboveBeam === 'NaN' || src.thicknessAboveBeam === 'Infinity' || src.thicknessAboveBeam === '-Infinity') {
                        dst.thicknessAboveBeam = AsNum(src.thicknessAboveBeam);
                    }
                    else {
                        console.log('Expected thicknessAboveBeam of ToppingParams to be a number but was ', typeof src.thicknessAboveBeam, src.thicknessAboveBeam)
                    }
                }
                if (src.minThicknessLft !== undefined && src.minThicknessLft !== null) {
                    if (typeof src.minThicknessLft === "number" || src.minThicknessLft === 'NaN' || src.minThicknessLft === 'Infinity' || src.minThicknessLft === '-Infinity') {
                        dst.minThicknessLft = AsNum(src.minThicknessLft);
                    }
                    else {
                        console.log('Expected minThicknessLft of ToppingParams to be a number but was ', typeof src.minThicknessLft, src.minThicknessLft)
                    }
                }
                if (src.slopeThicknessLft !== undefined && src.slopeThicknessLft !== null) {
                    if (typeof src.slopeThicknessLft === "number" || src.slopeThicknessLft === 'NaN' || src.slopeThicknessLft === 'Infinity' || src.slopeThicknessLft === '-Infinity') {
                        dst.slopeThicknessLft = AsNum(src.slopeThicknessLft);
                    }
                    else {
                        console.log('Expected slopeThicknessLft of ToppingParams to be a number but was ', typeof src.slopeThicknessLft, src.slopeThicknessLft)
                    }
                }
                if (src.minThicknessRgt !== undefined && src.minThicknessRgt !== null) {
                    if (typeof src.minThicknessRgt === "number" || src.minThicknessRgt === 'NaN' || src.minThicknessRgt === 'Infinity' || src.minThicknessRgt === '-Infinity') {
                        dst.minThicknessRgt = AsNum(src.minThicknessRgt);
                    }
                    else {
                        console.log('Expected minThicknessRgt of ToppingParams to be a number but was ', typeof src.minThicknessRgt, src.minThicknessRgt)
                    }
                }
                if (src.slopeThicknessRgt !== undefined && src.slopeThicknessRgt !== null) {
                    if (typeof src.slopeThicknessRgt === "number" || src.slopeThicknessRgt === 'NaN' || src.slopeThicknessRgt === 'Infinity' || src.slopeThicknessRgt === '-Infinity') {
                        dst.slopeThicknessRgt = AsNum(src.slopeThicknessRgt);
                    }
                    else {
                        console.log('Expected slopeThicknessRgt of ToppingParams to be a number but was ', typeof src.slopeThicknessRgt, src.slopeThicknessRgt)
                    }
                }
                if (src.widthAboveBeam !== undefined && src.widthAboveBeam !== null) {
                    if (typeof src.widthAboveBeam === "number" || src.widthAboveBeam === 'NaN' || src.widthAboveBeam === 'Infinity' || src.widthAboveBeam === '-Infinity') {
                        dst.widthAboveBeam = AsNum(src.widthAboveBeam);
                    }
                    else {
                        console.log('Expected widthAboveBeam of ToppingParams to be a number but was ', typeof src.widthAboveBeam, src.widthAboveBeam)
                    }
                }
                return dst;
            }

            static toObject(src: ToppingParams | null | undefined): ToppingParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.ToppingParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.ToppingParams") {
                    console.error('Expected ng.sections.ToppingParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ToppingParams_json = {
                    maxWidthLft: AsJsonNum(src.maxWidthLft),
                    widthOfMaxThicknessLft: AsJsonNum(src.widthOfMaxThicknessLft),
                    widthOfSlopeLft: AsJsonNum(src.widthOfSlopeLft),
                    maxWidthRgt: AsJsonNum(src.maxWidthRgt),
                    widthOfMaxThicknessRgt: AsJsonNum(src.widthOfMaxThicknessRgt),
                    widthOfSlopeRgt: AsJsonNum(src.widthOfSlopeRgt),
                    thicknessAboveBeam: AsJsonNum(src.thicknessAboveBeam),
                    minThicknessLft: AsJsonNum(src.minThicknessLft),
                    slopeThicknessLft: AsJsonNum(src.slopeThicknessLft),
                    minThicknessRgt: AsJsonNum(src.minThicknessRgt),
                    slopeThicknessRgt: AsJsonNum(src.slopeThicknessRgt),
                    widthAboveBeam: AsJsonNum(src.widthAboveBeam),
                };
                return dst;
            }

            static create(src?: ToppingParams_createType) {
                const dst = new ToppingParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.maxWidthLft !== undefined) {
                    dst.maxWidthLft = src.maxWidthLft;
                }
                if (src.widthOfMaxThicknessLft !== undefined) {
                    dst.widthOfMaxThicknessLft = src.widthOfMaxThicknessLft;
                }
                if (src.widthOfSlopeLft !== undefined) {
                    dst.widthOfSlopeLft = src.widthOfSlopeLft;
                }
                if (src.maxWidthRgt !== undefined) {
                    dst.maxWidthRgt = src.maxWidthRgt;
                }
                if (src.widthOfMaxThicknessRgt !== undefined) {
                    dst.widthOfMaxThicknessRgt = src.widthOfMaxThicknessRgt;
                }
                if (src.widthOfSlopeRgt !== undefined) {
                    dst.widthOfSlopeRgt = src.widthOfSlopeRgt;
                }
                if (src.thicknessAboveBeam !== undefined) {
                    dst.thicknessAboveBeam = src.thicknessAboveBeam;
                }
                if (src.minThicknessLft !== undefined) {
                    dst.minThicknessLft = src.minThicknessLft;
                }
                if (src.slopeThicknessLft !== undefined) {
                    dst.slopeThicknessLft = src.slopeThicknessLft;
                }
                if (src.minThicknessRgt !== undefined) {
                    dst.minThicknessRgt = src.minThicknessRgt;
                }
                if (src.slopeThicknessRgt !== undefined) {
                    dst.slopeThicknessRgt = src.slopeThicknessRgt;
                }
                if (src.widthAboveBeam !== undefined) {
                    dst.widthAboveBeam = src.widthAboveBeam;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ToppingParams();
                dst.maxWidthLft = this.maxWidthLft;
                dst.widthOfMaxThicknessLft = this.widthOfMaxThicknessLft;
                dst.widthOfSlopeLft = this.widthOfSlopeLft;
                dst.maxWidthRgt = this.maxWidthRgt;
                dst.widthOfMaxThicknessRgt = this.widthOfMaxThicknessRgt;
                dst.widthOfSlopeRgt = this.widthOfSlopeRgt;
                dst.thicknessAboveBeam = this.thicknessAboveBeam;
                dst.minThicknessLft = this.minThicknessLft;
                dst.slopeThicknessLft = this.slopeThicknessLft;
                dst.minThicknessRgt = this.minThicknessRgt;
                dst.slopeThicknessRgt = this.slopeThicknessRgt;
                dst.widthAboveBeam = this.widthAboveBeam;
                return dst;
            }

            deepClone() {
                const json = ToppingParams.toObject(this);
                const dst = ToppingParams.fromObject(json);
                return dst;
            }
        }
        export type IToppingParams = ToppingParams;


        export type HEParams_keys = 'height' | 'width' | 'flangeThickness' | 'webThickness' | 'radius';
        export interface HEParams_createType {
            height?: number,
            width?: number,
            flangeThickness?: number,
            webThickness?: number,
            radius?: number,
        }
        export interface HEParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
            flangeThickness?: JsonNumber;
            webThickness?: JsonNumber;
            radius?: JsonNumber;
        }
        interface HEParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
            flangeThickness?: unknown;
            webThickness?: unknown;
            radius?: unknown;
        }
        export class HEParams {
            __proto_name = "ng.sections.HEParams";
            height: number = 0;
            width: number = 0;
            flangeThickness: number = 0;
            webThickness: number = 0;
            radius: number = 0;

            static fromObject(src_unknown: unknown): HEParams {
                const dst = new HEParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted HEParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as HEParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for HEParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of HEParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of HEParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.flangeThickness !== undefined && src.flangeThickness !== null) {
                    if (typeof src.flangeThickness === "number" || src.flangeThickness === 'NaN' || src.flangeThickness === 'Infinity' || src.flangeThickness === '-Infinity') {
                        dst.flangeThickness = AsNum(src.flangeThickness);
                    }
                    else {
                        console.log('Expected flangeThickness of HEParams to be a number but was ', typeof src.flangeThickness, src.flangeThickness)
                    }
                }
                if (src.webThickness !== undefined && src.webThickness !== null) {
                    if (typeof src.webThickness === "number" || src.webThickness === 'NaN' || src.webThickness === 'Infinity' || src.webThickness === '-Infinity') {
                        dst.webThickness = AsNum(src.webThickness);
                    }
                    else {
                        console.log('Expected webThickness of HEParams to be a number but was ', typeof src.webThickness, src.webThickness)
                    }
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of HEParams to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                return dst;
            }

            static toObject(src: HEParams | null | undefined): HEParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.HEParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.HEParams") {
                    console.error('Expected ng.sections.HEParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : HEParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                    flangeThickness: AsJsonNum(src.flangeThickness),
                    webThickness: AsJsonNum(src.webThickness),
                    radius: AsJsonNum(src.radius),
                };
                return dst;
            }

            static create(src?: HEParams_createType) {
                const dst = new HEParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.flangeThickness !== undefined) {
                    dst.flangeThickness = src.flangeThickness;
                }
                if (src.webThickness !== undefined) {
                    dst.webThickness = src.webThickness;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                return dst;
            }

            shallowClone() {
                const dst = new HEParams();
                dst.height = this.height;
                dst.width = this.width;
                dst.flangeThickness = this.flangeThickness;
                dst.webThickness = this.webThickness;
                dst.radius = this.radius;
                return dst;
            }

            deepClone() {
                const json = HEParams.toObject(this);
                const dst = HEParams.fromObject(json);
                return dst;
            }
        }
        export type IHEParams = HEParams;


        export type HSQParams_keys = 'cutOff' | 'height' | 'topWidth' | 'width' | 'topFlangeThickness' | 'bottomFlangeThickness' | 'webThickness' | 'indent' | 'indentCut';
        export interface HSQParams_createType {
            cutOff?: number,
            height?: number,
            topWidth?: number,
            width?: number,
            topFlangeThickness?: number,
            bottomFlangeThickness?: number,
            webThickness?: number,
            indent?: number,
            indentCut?: number,
        }
        export interface HSQParams_json {
            cutOff?: JsonNumber;
            height?: JsonNumber;
            topWidth?: JsonNumber;
            width?: JsonNumber;
            topFlangeThickness?: JsonNumber;
            bottomFlangeThickness?: JsonNumber;
            webThickness?: JsonNumber;
            indent?: JsonNumber;
            indentCut?: JsonNumber;
        }
        interface HSQParams_json_in {
            __proto_name?: unknown;
            cutOff?: unknown;
            height?: unknown;
            topWidth?: unknown;
            width?: unknown;
            topFlangeThickness?: unknown;
            bottomFlangeThickness?: unknown;
            webThickness?: unknown;
            indent?: unknown;
            indentCut?: unknown;
        }
        export class HSQParams {
            __proto_name = "ng.sections.HSQParams";
            cutOff: number = 0;
            height: number = 0;
            topWidth: number = 0;
            width: number = 0;
            topFlangeThickness: number = 0;
            bottomFlangeThickness: number = 0;
            webThickness: number = 0;
            indent: number = 0;
            indentCut: number = 0;

            static fromObject(src_unknown: unknown): HSQParams {
                const dst = new HSQParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted HSQParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as HSQParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for HSQParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.cutOff !== undefined && src.cutOff !== null) {
                    if (typeof src.cutOff === "number" || src.cutOff === 'NaN' || src.cutOff === 'Infinity' || src.cutOff === '-Infinity') {
                        dst.cutOff = NumberToInt("ng.sections.HSQParams.cut_off", AsNum(src.cutOff));
                    }
                    else {
                        console.log('Expected cutOff of HSQParams to be a number but was ', typeof src.cutOff, src.cutOff)
                    }
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of HSQParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.topWidth !== undefined && src.topWidth !== null) {
                    if (typeof src.topWidth === "number" || src.topWidth === 'NaN' || src.topWidth === 'Infinity' || src.topWidth === '-Infinity') {
                        dst.topWidth = AsNum(src.topWidth);
                    }
                    else {
                        console.log('Expected topWidth of HSQParams to be a number but was ', typeof src.topWidth, src.topWidth)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of HSQParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.topFlangeThickness !== undefined && src.topFlangeThickness !== null) {
                    if (typeof src.topFlangeThickness === "number" || src.topFlangeThickness === 'NaN' || src.topFlangeThickness === 'Infinity' || src.topFlangeThickness === '-Infinity') {
                        dst.topFlangeThickness = AsNum(src.topFlangeThickness);
                    }
                    else {
                        console.log('Expected topFlangeThickness of HSQParams to be a number but was ', typeof src.topFlangeThickness, src.topFlangeThickness)
                    }
                }
                if (src.bottomFlangeThickness !== undefined && src.bottomFlangeThickness !== null) {
                    if (typeof src.bottomFlangeThickness === "number" || src.bottomFlangeThickness === 'NaN' || src.bottomFlangeThickness === 'Infinity' || src.bottomFlangeThickness === '-Infinity') {
                        dst.bottomFlangeThickness = AsNum(src.bottomFlangeThickness);
                    }
                    else {
                        console.log('Expected bottomFlangeThickness of HSQParams to be a number but was ', typeof src.bottomFlangeThickness, src.bottomFlangeThickness)
                    }
                }
                if (src.webThickness !== undefined && src.webThickness !== null) {
                    if (typeof src.webThickness === "number" || src.webThickness === 'NaN' || src.webThickness === 'Infinity' || src.webThickness === '-Infinity') {
                        dst.webThickness = AsNum(src.webThickness);
                    }
                    else {
                        console.log('Expected webThickness of HSQParams to be a number but was ', typeof src.webThickness, src.webThickness)
                    }
                }
                if (src.indent !== undefined && src.indent !== null) {
                    if (typeof src.indent === "number" || src.indent === 'NaN' || src.indent === 'Infinity' || src.indent === '-Infinity') {
                        dst.indent = AsNum(src.indent);
                    }
                    else {
                        console.log('Expected indent of HSQParams to be a number but was ', typeof src.indent, src.indent)
                    }
                }
                if (src.indentCut !== undefined && src.indentCut !== null) {
                    if (typeof src.indentCut === "number" || src.indentCut === 'NaN' || src.indentCut === 'Infinity' || src.indentCut === '-Infinity') {
                        dst.indentCut = AsNum(src.indentCut);
                    }
                    else {
                        console.log('Expected indentCut of HSQParams to be a number but was ', typeof src.indentCut, src.indentCut)
                    }
                }
                return dst;
            }

            static toObject(src: HSQParams | null | undefined): HSQParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.HSQParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.HSQParams") {
                    console.error('Expected ng.sections.HSQParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : HSQParams_json = {
                    cutOff: AsJsonNum(NumberToInt("ng.sections.HSQParams.cut_off", src.cutOff)),
                    height: AsJsonNum(src.height),
                    topWidth: AsJsonNum(src.topWidth),
                    width: AsJsonNum(src.width),
                    topFlangeThickness: AsJsonNum(src.topFlangeThickness),
                    bottomFlangeThickness: AsJsonNum(src.bottomFlangeThickness),
                    webThickness: AsJsonNum(src.webThickness),
                    indent: AsJsonNum(src.indent),
                    indentCut: AsJsonNum(src.indentCut),
                };
                return dst;
            }

            static create(src?: HSQParams_createType) {
                const dst = new HSQParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.cutOff !== undefined) {
                    dst.cutOff = src.cutOff;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.topWidth !== undefined) {
                    dst.topWidth = src.topWidth;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.topFlangeThickness !== undefined) {
                    dst.topFlangeThickness = src.topFlangeThickness;
                }
                if (src.bottomFlangeThickness !== undefined) {
                    dst.bottomFlangeThickness = src.bottomFlangeThickness;
                }
                if (src.webThickness !== undefined) {
                    dst.webThickness = src.webThickness;
                }
                if (src.indent !== undefined) {
                    dst.indent = src.indent;
                }
                if (src.indentCut !== undefined) {
                    dst.indentCut = src.indentCut;
                }
                return dst;
            }

            shallowClone() {
                const dst = new HSQParams();
                dst.cutOff = this.cutOff;
                dst.height = this.height;
                dst.topWidth = this.topWidth;
                dst.width = this.width;
                dst.topFlangeThickness = this.topFlangeThickness;
                dst.bottomFlangeThickness = this.bottomFlangeThickness;
                dst.webThickness = this.webThickness;
                dst.indent = this.indent;
                dst.indentCut = this.indentCut;
                return dst;
            }

            deepClone() {
                const json = HSQParams.toObject(this);
                const dst = HSQParams.fromObject(json);
                return dst;
            }
        }
        export type IHSQParams = HSQParams;


        export type UXParams_keys = 'height' | 'width' | 'webThickness' | 'flangeThickness';
        export interface UXParams_createType {
            height?: number,
            width?: number,
            webThickness?: number,
            flangeThickness?: number,
        }
        export interface UXParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
            webThickness?: JsonNumber;
            flangeThickness?: JsonNumber;
        }
        interface UXParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
            webThickness?: unknown;
            flangeThickness?: unknown;
        }
        export class UXParams {
            __proto_name = "ng.sections.UXParams";
            height: number = 0;
            width: number = 0;
            webThickness: number = 0;
            flangeThickness: number = 0;

            static fromObject(src_unknown: unknown): UXParams {
                const dst = new UXParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted UXParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as UXParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for UXParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of UXParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of UXParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.webThickness !== undefined && src.webThickness !== null) {
                    if (typeof src.webThickness === "number" || src.webThickness === 'NaN' || src.webThickness === 'Infinity' || src.webThickness === '-Infinity') {
                        dst.webThickness = AsNum(src.webThickness);
                    }
                    else {
                        console.log('Expected webThickness of UXParams to be a number but was ', typeof src.webThickness, src.webThickness)
                    }
                }
                if (src.flangeThickness !== undefined && src.flangeThickness !== null) {
                    if (typeof src.flangeThickness === "number" || src.flangeThickness === 'NaN' || src.flangeThickness === 'Infinity' || src.flangeThickness === '-Infinity') {
                        dst.flangeThickness = AsNum(src.flangeThickness);
                    }
                    else {
                        console.log('Expected flangeThickness of UXParams to be a number but was ', typeof src.flangeThickness, src.flangeThickness)
                    }
                }
                return dst;
            }

            static toObject(src: UXParams | null | undefined): UXParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.UXParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.UXParams") {
                    console.error('Expected ng.sections.UXParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : UXParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                    webThickness: AsJsonNum(src.webThickness),
                    flangeThickness: AsJsonNum(src.flangeThickness),
                };
                return dst;
            }

            static create(src?: UXParams_createType) {
                const dst = new UXParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.webThickness !== undefined) {
                    dst.webThickness = src.webThickness;
                }
                if (src.flangeThickness !== undefined) {
                    dst.flangeThickness = src.flangeThickness;
                }
                return dst;
            }

            shallowClone() {
                const dst = new UXParams();
                dst.height = this.height;
                dst.width = this.width;
                dst.webThickness = this.webThickness;
                dst.flangeThickness = this.flangeThickness;
                return dst;
            }

            deepClone() {
                const json = UXParams.toObject(this);
                const dst = UXParams.fromObject(json);
                return dst;
            }
        }
        export type IUXParams = UXParams;


        export type ZXParams_keys = 'height' | 'width' | 'webThickness' | 'flangeThickness';
        export interface ZXParams_createType {
            height?: number,
            width?: number,
            webThickness?: number,
            flangeThickness?: number,
        }
        export interface ZXParams_json {
            height?: JsonNumber;
            width?: JsonNumber;
            webThickness?: JsonNumber;
            flangeThickness?: JsonNumber;
        }
        interface ZXParams_json_in {
            __proto_name?: unknown;
            height?: unknown;
            width?: unknown;
            webThickness?: unknown;
            flangeThickness?: unknown;
        }
        export class ZXParams {
            __proto_name = "ng.sections.ZXParams";
            height: number = 0;
            width: number = 0;
            webThickness: number = 0;
            flangeThickness: number = 0;

            static fromObject(src_unknown: unknown): ZXParams {
                const dst = new ZXParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ZXParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ZXParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ZXParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of ZXParams to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of ZXParams to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.webThickness !== undefined && src.webThickness !== null) {
                    if (typeof src.webThickness === "number" || src.webThickness === 'NaN' || src.webThickness === 'Infinity' || src.webThickness === '-Infinity') {
                        dst.webThickness = AsNum(src.webThickness);
                    }
                    else {
                        console.log('Expected webThickness of ZXParams to be a number but was ', typeof src.webThickness, src.webThickness)
                    }
                }
                if (src.flangeThickness !== undefined && src.flangeThickness !== null) {
                    if (typeof src.flangeThickness === "number" || src.flangeThickness === 'NaN' || src.flangeThickness === 'Infinity' || src.flangeThickness === '-Infinity') {
                        dst.flangeThickness = AsNum(src.flangeThickness);
                    }
                    else {
                        console.log('Expected flangeThickness of ZXParams to be a number but was ', typeof src.flangeThickness, src.flangeThickness)
                    }
                }
                return dst;
            }

            static toObject(src: ZXParams | null | undefined): ZXParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.ZXParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.ZXParams") {
                    console.error('Expected ng.sections.ZXParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ZXParams_json = {
                    height: AsJsonNum(src.height),
                    width: AsJsonNum(src.width),
                    webThickness: AsJsonNum(src.webThickness),
                    flangeThickness: AsJsonNum(src.flangeThickness),
                };
                return dst;
            }

            static create(src?: ZXParams_createType) {
                const dst = new ZXParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.webThickness !== undefined) {
                    dst.webThickness = src.webThickness;
                }
                if (src.flangeThickness !== undefined) {
                    dst.flangeThickness = src.flangeThickness;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ZXParams();
                dst.height = this.height;
                dst.width = this.width;
                dst.webThickness = this.webThickness;
                dst.flangeThickness = this.flangeThickness;
                return dst;
            }

            deepClone() {
                const json = ZXParams.toObject(this);
                const dst = ZXParams.fromObject(json);
                return dst;
            }
        }
        export type IZXParams = ZXParams;


        export type SParams_keys = 'side';
        export interface SParams_createType {
            side?: number,
        }
        export interface SParams_json {
            side?: JsonNumber;
        }
        interface SParams_json_in {
            __proto_name?: unknown;
            side?: unknown;
        }
        export class SParams {
            __proto_name = "ng.sections.SParams";
            side: number = 0;

            static fromObject(src_unknown: unknown): SParams {
                const dst = new SParams();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SParams but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SParams_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SParams but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.side !== undefined && src.side !== null) {
                    if (typeof src.side === "number" || src.side === 'NaN' || src.side === 'Infinity' || src.side === '-Infinity') {
                        dst.side = AsNum(src.side);
                    }
                    else {
                        console.log('Expected side of SParams to be a number but was ', typeof src.side, src.side)
                    }
                }
                return dst;
            }

            static toObject(src: SParams | null | undefined): SParams_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.SParams is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.SParams") {
                    console.error('Expected ng.sections.SParams but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SParams_json = {
                    side: AsJsonNum(src.side),
                };
                return dst;
            }

            static create(src?: SParams_createType) {
                const dst = new SParams();
                if (src === undefined) {
                    return dst;
                }
                if (src.side !== undefined) {
                    dst.side = src.side;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SParams();
                dst.side = this.side;
                return dst;
            }

            deepClone() {
                const json = SParams.toObject(this);
                const dst = SParams.fromObject(json);
                return dst;
            }
        }
        export type ISParams = SParams;


        export type SectionUnits_keys = 'a' | 'p' | 'xc' | 'yc' | 'xs' | 'ys' | 'iX' | 'wX' | 'zX' | 'smX' | 'irX' | 'emaxY' | 'eminY' | 'iY' | 'wY' | 'zY' | 'smY' | 'irY' | 'emaxX' | 'eminX' | 'j' | 'iT' | 'wT' | 'iW' | 'iXy' | 'betaOmega' | 'i1' | 'w1' | 'z1' | 'sm1' | 'ir1' | 'emax2' | 'emin2' | 'rho1' | 'c1' | 'beta1' | 'sh1' | 'ang1' | 'i2' | 'w2' | 'z2' | 'sm2' | 'ir2' | 'emax1' | 'emin1' | 'rho2' | 'c2' | 'beta2' | 'sh2' | 'ang2' | 'cog';
        export interface SectionUnits_createType {
            a?: number,
            p?: number,
            xc?: number,
            yc?: number,
            xs?: number,
            ys?: number,
            iX?: number,
            wX?: number,
            zX?: number,
            smX?: number,
            irX?: number,
            emaxY?: number,
            eminY?: number,
            iY?: number,
            wY?: number,
            zY?: number,
            smY?: number,
            irY?: number,
            emaxX?: number,
            eminX?: number,
            j?: number,
            iT?: number,
            wT?: number,
            iW?: number,
            iXy?: number,
            betaOmega?: number,
            i1?: number,
            w1?: number,
            z1?: number,
            sm1?: number,
            ir1?: number,
            emax2?: number,
            emin2?: number,
            rho1?: number,
            c1?: number,
            beta1?: number,
            sh1?: number,
            ang1?: number,
            i2?: number,
            w2?: number,
            z2?: number,
            sm2?: number,
            ir2?: number,
            emax1?: number,
            emin1?: number,
            rho2?: number,
            c2?: number,
            beta2?: number,
            sh2?: number,
            ang2?: number,
            cog?: ng.geometry.Point2D | null,
        }
        export interface SectionUnits_json {
            a?: JsonNumber;
            p?: JsonNumber;
            xc?: JsonNumber;
            yc?: JsonNumber;
            xs?: JsonNumber;
            ys?: JsonNumber;
            iX?: JsonNumber;
            wX?: JsonNumber;
            zX?: JsonNumber;
            smX?: JsonNumber;
            irX?: JsonNumber;
            emaxY?: JsonNumber;
            eminY?: JsonNumber;
            iY?: JsonNumber;
            wY?: JsonNumber;
            zY?: JsonNumber;
            smY?: JsonNumber;
            irY?: JsonNumber;
            emaxX?: JsonNumber;
            eminX?: JsonNumber;
            j?: JsonNumber;
            iT?: JsonNumber;
            wT?: JsonNumber;
            iW?: JsonNumber;
            iXy?: JsonNumber;
            betaOmega?: JsonNumber;
            i1?: JsonNumber;
            w1?: JsonNumber;
            z1?: JsonNumber;
            sm1?: JsonNumber;
            ir1?: JsonNumber;
            emax2?: JsonNumber;
            emin2?: JsonNumber;
            rho1?: JsonNumber;
            c1?: JsonNumber;
            beta1?: JsonNumber;
            sh1?: JsonNumber;
            ang1?: JsonNumber;
            i2?: JsonNumber;
            w2?: JsonNumber;
            z2?: JsonNumber;
            sm2?: JsonNumber;
            ir2?: JsonNumber;
            emax1?: JsonNumber;
            emin1?: JsonNumber;
            rho2?: JsonNumber;
            c2?: JsonNumber;
            beta2?: JsonNumber;
            sh2?: JsonNumber;
            ang2?: JsonNumber;
            cog?: ng.geometry.Point2D_json;
        }
        interface SectionUnits_json_in {
            __proto_name?: unknown;
            a?: unknown;
            p?: unknown;
            xc?: unknown;
            yc?: unknown;
            xs?: unknown;
            ys?: unknown;
            iX?: unknown;
            wX?: unknown;
            zX?: unknown;
            smX?: unknown;
            irX?: unknown;
            emaxY?: unknown;
            eminY?: unknown;
            iY?: unknown;
            wY?: unknown;
            zY?: unknown;
            smY?: unknown;
            irY?: unknown;
            emaxX?: unknown;
            eminX?: unknown;
            j?: unknown;
            iT?: unknown;
            wT?: unknown;
            iW?: unknown;
            iXy?: unknown;
            betaOmega?: unknown;
            i1?: unknown;
            w1?: unknown;
            z1?: unknown;
            sm1?: unknown;
            ir1?: unknown;
            emax2?: unknown;
            emin2?: unknown;
            rho1?: unknown;
            c1?: unknown;
            beta1?: unknown;
            sh1?: unknown;
            ang1?: unknown;
            i2?: unknown;
            w2?: unknown;
            z2?: unknown;
            sm2?: unknown;
            ir2?: unknown;
            emax1?: unknown;
            emin1?: unknown;
            rho2?: unknown;
            c2?: unknown;
            beta2?: unknown;
            sh2?: unknown;
            ang2?: unknown;
            cog?: unknown;
        }
        export class SectionUnits {
            __proto_name = "ng.sections.SectionUnits";
            a: number = 0;
            p: number = 0;
            xc: number = 0;
            yc: number = 0;
            xs: number = 0;
            ys: number = 0;
            iX: number = 0;
            wX: number = 0;
            zX: number = 0;
            smX: number = 0;
            irX: number = 0;
            emaxY: number = 0;
            eminY: number = 0;
            iY: number = 0;
            wY: number = 0;
            zY: number = 0;
            smY: number = 0;
            irY: number = 0;
            emaxX: number = 0;
            eminX: number = 0;
            j: number = 0;
            iT: number = 0;
            wT: number = 0;
            iW: number = 0;
            iXy: number = 0;
            betaOmega: number = 0;
            i1: number = 0;
            w1: number = 0;
            z1: number = 0;
            sm1: number = 0;
            ir1: number = 0;
            emax2: number = 0;
            emin2: number = 0;
            rho1: number = 0;
            c1: number = 0;
            beta1: number = 0;
            sh1: number = 0;
            ang1: number = 0;
            i2: number = 0;
            w2: number = 0;
            z2: number = 0;
            sm2: number = 0;
            ir2: number = 0;
            emax1: number = 0;
            emin1: number = 0;
            rho2: number = 0;
            c2: number = 0;
            beta2: number = 0;
            sh2: number = 0;
            ang2: number = 0;
            cog: ng.geometry.Point2D | null = null;

            static fromObject(src_unknown: unknown): SectionUnits {
                const dst = new SectionUnits();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SectionUnits but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SectionUnits_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SectionUnits but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.a !== undefined && src.a !== null) {
                    if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                        dst.a = AsNum(src.a);
                    }
                    else {
                        console.log('Expected a of SectionUnits to be a number but was ', typeof src.a, src.a)
                    }
                }
                if (src.p !== undefined && src.p !== null) {
                    if (typeof src.p === "number" || src.p === 'NaN' || src.p === 'Infinity' || src.p === '-Infinity') {
                        dst.p = AsNum(src.p);
                    }
                    else {
                        console.log('Expected p of SectionUnits to be a number but was ', typeof src.p, src.p)
                    }
                }
                if (src.xc !== undefined && src.xc !== null) {
                    if (typeof src.xc === "number" || src.xc === 'NaN' || src.xc === 'Infinity' || src.xc === '-Infinity') {
                        dst.xc = AsNum(src.xc);
                    }
                    else {
                        console.log('Expected xc of SectionUnits to be a number but was ', typeof src.xc, src.xc)
                    }
                }
                if (src.yc !== undefined && src.yc !== null) {
                    if (typeof src.yc === "number" || src.yc === 'NaN' || src.yc === 'Infinity' || src.yc === '-Infinity') {
                        dst.yc = AsNum(src.yc);
                    }
                    else {
                        console.log('Expected yc of SectionUnits to be a number but was ', typeof src.yc, src.yc)
                    }
                }
                if (src.xs !== undefined && src.xs !== null) {
                    if (typeof src.xs === "number" || src.xs === 'NaN' || src.xs === 'Infinity' || src.xs === '-Infinity') {
                        dst.xs = AsNum(src.xs);
                    }
                    else {
                        console.log('Expected xs of SectionUnits to be a number but was ', typeof src.xs, src.xs)
                    }
                }
                if (src.ys !== undefined && src.ys !== null) {
                    if (typeof src.ys === "number" || src.ys === 'NaN' || src.ys === 'Infinity' || src.ys === '-Infinity') {
                        dst.ys = AsNum(src.ys);
                    }
                    else {
                        console.log('Expected ys of SectionUnits to be a number but was ', typeof src.ys, src.ys)
                    }
                }
                if (src.iX !== undefined && src.iX !== null) {
                    if (typeof src.iX === "number" || src.iX === 'NaN' || src.iX === 'Infinity' || src.iX === '-Infinity') {
                        dst.iX = AsNum(src.iX);
                    }
                    else {
                        console.log('Expected iX of SectionUnits to be a number but was ', typeof src.iX, src.iX)
                    }
                }
                if (src.wX !== undefined && src.wX !== null) {
                    if (typeof src.wX === "number" || src.wX === 'NaN' || src.wX === 'Infinity' || src.wX === '-Infinity') {
                        dst.wX = AsNum(src.wX);
                    }
                    else {
                        console.log('Expected wX of SectionUnits to be a number but was ', typeof src.wX, src.wX)
                    }
                }
                if (src.zX !== undefined && src.zX !== null) {
                    if (typeof src.zX === "number" || src.zX === 'NaN' || src.zX === 'Infinity' || src.zX === '-Infinity') {
                        dst.zX = AsNum(src.zX);
                    }
                    else {
                        console.log('Expected zX of SectionUnits to be a number but was ', typeof src.zX, src.zX)
                    }
                }
                if (src.smX !== undefined && src.smX !== null) {
                    if (typeof src.smX === "number" || src.smX === 'NaN' || src.smX === 'Infinity' || src.smX === '-Infinity') {
                        dst.smX = AsNum(src.smX);
                    }
                    else {
                        console.log('Expected smX of SectionUnits to be a number but was ', typeof src.smX, src.smX)
                    }
                }
                if (src.irX !== undefined && src.irX !== null) {
                    if (typeof src.irX === "number" || src.irX === 'NaN' || src.irX === 'Infinity' || src.irX === '-Infinity') {
                        dst.irX = AsNum(src.irX);
                    }
                    else {
                        console.log('Expected irX of SectionUnits to be a number but was ', typeof src.irX, src.irX)
                    }
                }
                if (src.emaxY !== undefined && src.emaxY !== null) {
                    if (typeof src.emaxY === "number" || src.emaxY === 'NaN' || src.emaxY === 'Infinity' || src.emaxY === '-Infinity') {
                        dst.emaxY = AsNum(src.emaxY);
                    }
                    else {
                        console.log('Expected emaxY of SectionUnits to be a number but was ', typeof src.emaxY, src.emaxY)
                    }
                }
                if (src.eminY !== undefined && src.eminY !== null) {
                    if (typeof src.eminY === "number" || src.eminY === 'NaN' || src.eminY === 'Infinity' || src.eminY === '-Infinity') {
                        dst.eminY = AsNum(src.eminY);
                    }
                    else {
                        console.log('Expected eminY of SectionUnits to be a number but was ', typeof src.eminY, src.eminY)
                    }
                }
                if (src.iY !== undefined && src.iY !== null) {
                    if (typeof src.iY === "number" || src.iY === 'NaN' || src.iY === 'Infinity' || src.iY === '-Infinity') {
                        dst.iY = AsNum(src.iY);
                    }
                    else {
                        console.log('Expected iY of SectionUnits to be a number but was ', typeof src.iY, src.iY)
                    }
                }
                if (src.wY !== undefined && src.wY !== null) {
                    if (typeof src.wY === "number" || src.wY === 'NaN' || src.wY === 'Infinity' || src.wY === '-Infinity') {
                        dst.wY = AsNum(src.wY);
                    }
                    else {
                        console.log('Expected wY of SectionUnits to be a number but was ', typeof src.wY, src.wY)
                    }
                }
                if (src.zY !== undefined && src.zY !== null) {
                    if (typeof src.zY === "number" || src.zY === 'NaN' || src.zY === 'Infinity' || src.zY === '-Infinity') {
                        dst.zY = AsNum(src.zY);
                    }
                    else {
                        console.log('Expected zY of SectionUnits to be a number but was ', typeof src.zY, src.zY)
                    }
                }
                if (src.smY !== undefined && src.smY !== null) {
                    if (typeof src.smY === "number" || src.smY === 'NaN' || src.smY === 'Infinity' || src.smY === '-Infinity') {
                        dst.smY = AsNum(src.smY);
                    }
                    else {
                        console.log('Expected smY of SectionUnits to be a number but was ', typeof src.smY, src.smY)
                    }
                }
                if (src.irY !== undefined && src.irY !== null) {
                    if (typeof src.irY === "number" || src.irY === 'NaN' || src.irY === 'Infinity' || src.irY === '-Infinity') {
                        dst.irY = AsNum(src.irY);
                    }
                    else {
                        console.log('Expected irY of SectionUnits to be a number but was ', typeof src.irY, src.irY)
                    }
                }
                if (src.emaxX !== undefined && src.emaxX !== null) {
                    if (typeof src.emaxX === "number" || src.emaxX === 'NaN' || src.emaxX === 'Infinity' || src.emaxX === '-Infinity') {
                        dst.emaxX = AsNum(src.emaxX);
                    }
                    else {
                        console.log('Expected emaxX of SectionUnits to be a number but was ', typeof src.emaxX, src.emaxX)
                    }
                }
                if (src.eminX !== undefined && src.eminX !== null) {
                    if (typeof src.eminX === "number" || src.eminX === 'NaN' || src.eminX === 'Infinity' || src.eminX === '-Infinity') {
                        dst.eminX = AsNum(src.eminX);
                    }
                    else {
                        console.log('Expected eminX of SectionUnits to be a number but was ', typeof src.eminX, src.eminX)
                    }
                }
                if (src.j !== undefined && src.j !== null) {
                    if (typeof src.j === "number" || src.j === 'NaN' || src.j === 'Infinity' || src.j === '-Infinity') {
                        dst.j = AsNum(src.j);
                    }
                    else {
                        console.log('Expected j of SectionUnits to be a number but was ', typeof src.j, src.j)
                    }
                }
                if (src.iT !== undefined && src.iT !== null) {
                    if (typeof src.iT === "number" || src.iT === 'NaN' || src.iT === 'Infinity' || src.iT === '-Infinity') {
                        dst.iT = AsNum(src.iT);
                    }
                    else {
                        console.log('Expected iT of SectionUnits to be a number but was ', typeof src.iT, src.iT)
                    }
                }
                if (src.wT !== undefined && src.wT !== null) {
                    if (typeof src.wT === "number" || src.wT === 'NaN' || src.wT === 'Infinity' || src.wT === '-Infinity') {
                        dst.wT = AsNum(src.wT);
                    }
                    else {
                        console.log('Expected wT of SectionUnits to be a number but was ', typeof src.wT, src.wT)
                    }
                }
                if (src.iW !== undefined && src.iW !== null) {
                    if (typeof src.iW === "number" || src.iW === 'NaN' || src.iW === 'Infinity' || src.iW === '-Infinity') {
                        dst.iW = AsNum(src.iW);
                    }
                    else {
                        console.log('Expected iW of SectionUnits to be a number but was ', typeof src.iW, src.iW)
                    }
                }
                if (src.iXy !== undefined && src.iXy !== null) {
                    if (typeof src.iXy === "number" || src.iXy === 'NaN' || src.iXy === 'Infinity' || src.iXy === '-Infinity') {
                        dst.iXy = AsNum(src.iXy);
                    }
                    else {
                        console.log('Expected iXy of SectionUnits to be a number but was ', typeof src.iXy, src.iXy)
                    }
                }
                if (src.betaOmega !== undefined && src.betaOmega !== null) {
                    if (typeof src.betaOmega === "number" || src.betaOmega === 'NaN' || src.betaOmega === 'Infinity' || src.betaOmega === '-Infinity') {
                        dst.betaOmega = AsNum(src.betaOmega);
                    }
                    else {
                        console.log('Expected betaOmega of SectionUnits to be a number but was ', typeof src.betaOmega, src.betaOmega)
                    }
                }
                if (src.i1 !== undefined && src.i1 !== null) {
                    if (typeof src.i1 === "number" || src.i1 === 'NaN' || src.i1 === 'Infinity' || src.i1 === '-Infinity') {
                        dst.i1 = AsNum(src.i1);
                    }
                    else {
                        console.log('Expected i1 of SectionUnits to be a number but was ', typeof src.i1, src.i1)
                    }
                }
                if (src.w1 !== undefined && src.w1 !== null) {
                    if (typeof src.w1 === "number" || src.w1 === 'NaN' || src.w1 === 'Infinity' || src.w1 === '-Infinity') {
                        dst.w1 = AsNum(src.w1);
                    }
                    else {
                        console.log('Expected w1 of SectionUnits to be a number but was ', typeof src.w1, src.w1)
                    }
                }
                if (src.z1 !== undefined && src.z1 !== null) {
                    if (typeof src.z1 === "number" || src.z1 === 'NaN' || src.z1 === 'Infinity' || src.z1 === '-Infinity') {
                        dst.z1 = AsNum(src.z1);
                    }
                    else {
                        console.log('Expected z1 of SectionUnits to be a number but was ', typeof src.z1, src.z1)
                    }
                }
                if (src.sm1 !== undefined && src.sm1 !== null) {
                    if (typeof src.sm1 === "number" || src.sm1 === 'NaN' || src.sm1 === 'Infinity' || src.sm1 === '-Infinity') {
                        dst.sm1 = AsNum(src.sm1);
                    }
                    else {
                        console.log('Expected sm1 of SectionUnits to be a number but was ', typeof src.sm1, src.sm1)
                    }
                }
                if (src.ir1 !== undefined && src.ir1 !== null) {
                    if (typeof src.ir1 === "number" || src.ir1 === 'NaN' || src.ir1 === 'Infinity' || src.ir1 === '-Infinity') {
                        dst.ir1 = AsNum(src.ir1);
                    }
                    else {
                        console.log('Expected ir1 of SectionUnits to be a number but was ', typeof src.ir1, src.ir1)
                    }
                }
                if (src.emax2 !== undefined && src.emax2 !== null) {
                    if (typeof src.emax2 === "number" || src.emax2 === 'NaN' || src.emax2 === 'Infinity' || src.emax2 === '-Infinity') {
                        dst.emax2 = AsNum(src.emax2);
                    }
                    else {
                        console.log('Expected emax2 of SectionUnits to be a number but was ', typeof src.emax2, src.emax2)
                    }
                }
                if (src.emin2 !== undefined && src.emin2 !== null) {
                    if (typeof src.emin2 === "number" || src.emin2 === 'NaN' || src.emin2 === 'Infinity' || src.emin2 === '-Infinity') {
                        dst.emin2 = AsNum(src.emin2);
                    }
                    else {
                        console.log('Expected emin2 of SectionUnits to be a number but was ', typeof src.emin2, src.emin2)
                    }
                }
                if (src.rho1 !== undefined && src.rho1 !== null) {
                    if (typeof src.rho1 === "number" || src.rho1 === 'NaN' || src.rho1 === 'Infinity' || src.rho1 === '-Infinity') {
                        dst.rho1 = AsNum(src.rho1);
                    }
                    else {
                        console.log('Expected rho1 of SectionUnits to be a number but was ', typeof src.rho1, src.rho1)
                    }
                }
                if (src.c1 !== undefined && src.c1 !== null) {
                    if (typeof src.c1 === "number" || src.c1 === 'NaN' || src.c1 === 'Infinity' || src.c1 === '-Infinity') {
                        dst.c1 = AsNum(src.c1);
                    }
                    else {
                        console.log('Expected c1 of SectionUnits to be a number but was ', typeof src.c1, src.c1)
                    }
                }
                if (src.beta1 !== undefined && src.beta1 !== null) {
                    if (typeof src.beta1 === "number" || src.beta1 === 'NaN' || src.beta1 === 'Infinity' || src.beta1 === '-Infinity') {
                        dst.beta1 = AsNum(src.beta1);
                    }
                    else {
                        console.log('Expected beta1 of SectionUnits to be a number but was ', typeof src.beta1, src.beta1)
                    }
                }
                if (src.sh1 !== undefined && src.sh1 !== null) {
                    if (typeof src.sh1 === "number" || src.sh1 === 'NaN' || src.sh1 === 'Infinity' || src.sh1 === '-Infinity') {
                        dst.sh1 = AsNum(src.sh1);
                    }
                    else {
                        console.log('Expected sh1 of SectionUnits to be a number but was ', typeof src.sh1, src.sh1)
                    }
                }
                if (src.ang1 !== undefined && src.ang1 !== null) {
                    if (typeof src.ang1 === "number" || src.ang1 === 'NaN' || src.ang1 === 'Infinity' || src.ang1 === '-Infinity') {
                        dst.ang1 = AsNum(src.ang1);
                    }
                    else {
                        console.log('Expected ang1 of SectionUnits to be a number but was ', typeof src.ang1, src.ang1)
                    }
                }
                if (src.i2 !== undefined && src.i2 !== null) {
                    if (typeof src.i2 === "number" || src.i2 === 'NaN' || src.i2 === 'Infinity' || src.i2 === '-Infinity') {
                        dst.i2 = AsNum(src.i2);
                    }
                    else {
                        console.log('Expected i2 of SectionUnits to be a number but was ', typeof src.i2, src.i2)
                    }
                }
                if (src.w2 !== undefined && src.w2 !== null) {
                    if (typeof src.w2 === "number" || src.w2 === 'NaN' || src.w2 === 'Infinity' || src.w2 === '-Infinity') {
                        dst.w2 = AsNum(src.w2);
                    }
                    else {
                        console.log('Expected w2 of SectionUnits to be a number but was ', typeof src.w2, src.w2)
                    }
                }
                if (src.z2 !== undefined && src.z2 !== null) {
                    if (typeof src.z2 === "number" || src.z2 === 'NaN' || src.z2 === 'Infinity' || src.z2 === '-Infinity') {
                        dst.z2 = AsNum(src.z2);
                    }
                    else {
                        console.log('Expected z2 of SectionUnits to be a number but was ', typeof src.z2, src.z2)
                    }
                }
                if (src.sm2 !== undefined && src.sm2 !== null) {
                    if (typeof src.sm2 === "number" || src.sm2 === 'NaN' || src.sm2 === 'Infinity' || src.sm2 === '-Infinity') {
                        dst.sm2 = AsNum(src.sm2);
                    }
                    else {
                        console.log('Expected sm2 of SectionUnits to be a number but was ', typeof src.sm2, src.sm2)
                    }
                }
                if (src.ir2 !== undefined && src.ir2 !== null) {
                    if (typeof src.ir2 === "number" || src.ir2 === 'NaN' || src.ir2 === 'Infinity' || src.ir2 === '-Infinity') {
                        dst.ir2 = AsNum(src.ir2);
                    }
                    else {
                        console.log('Expected ir2 of SectionUnits to be a number but was ', typeof src.ir2, src.ir2)
                    }
                }
                if (src.emax1 !== undefined && src.emax1 !== null) {
                    if (typeof src.emax1 === "number" || src.emax1 === 'NaN' || src.emax1 === 'Infinity' || src.emax1 === '-Infinity') {
                        dst.emax1 = AsNum(src.emax1);
                    }
                    else {
                        console.log('Expected emax1 of SectionUnits to be a number but was ', typeof src.emax1, src.emax1)
                    }
                }
                if (src.emin1 !== undefined && src.emin1 !== null) {
                    if (typeof src.emin1 === "number" || src.emin1 === 'NaN' || src.emin1 === 'Infinity' || src.emin1 === '-Infinity') {
                        dst.emin1 = AsNum(src.emin1);
                    }
                    else {
                        console.log('Expected emin1 of SectionUnits to be a number but was ', typeof src.emin1, src.emin1)
                    }
                }
                if (src.rho2 !== undefined && src.rho2 !== null) {
                    if (typeof src.rho2 === "number" || src.rho2 === 'NaN' || src.rho2 === 'Infinity' || src.rho2 === '-Infinity') {
                        dst.rho2 = AsNum(src.rho2);
                    }
                    else {
                        console.log('Expected rho2 of SectionUnits to be a number but was ', typeof src.rho2, src.rho2)
                    }
                }
                if (src.c2 !== undefined && src.c2 !== null) {
                    if (typeof src.c2 === "number" || src.c2 === 'NaN' || src.c2 === 'Infinity' || src.c2 === '-Infinity') {
                        dst.c2 = AsNum(src.c2);
                    }
                    else {
                        console.log('Expected c2 of SectionUnits to be a number but was ', typeof src.c2, src.c2)
                    }
                }
                if (src.beta2 !== undefined && src.beta2 !== null) {
                    if (typeof src.beta2 === "number" || src.beta2 === 'NaN' || src.beta2 === 'Infinity' || src.beta2 === '-Infinity') {
                        dst.beta2 = AsNum(src.beta2);
                    }
                    else {
                        console.log('Expected beta2 of SectionUnits to be a number but was ', typeof src.beta2, src.beta2)
                    }
                }
                if (src.sh2 !== undefined && src.sh2 !== null) {
                    if (typeof src.sh2 === "number" || src.sh2 === 'NaN' || src.sh2 === 'Infinity' || src.sh2 === '-Infinity') {
                        dst.sh2 = AsNum(src.sh2);
                    }
                    else {
                        console.log('Expected sh2 of SectionUnits to be a number but was ', typeof src.sh2, src.sh2)
                    }
                }
                if (src.ang2 !== undefined && src.ang2 !== null) {
                    if (typeof src.ang2 === "number" || src.ang2 === 'NaN' || src.ang2 === 'Infinity' || src.ang2 === '-Infinity') {
                        dst.ang2 = AsNum(src.ang2);
                    }
                    else {
                        console.log('Expected ang2 of SectionUnits to be a number but was ', typeof src.ang2, src.ang2)
                    }
                }
                if (src.cog !== undefined && src.cog !== null) {
                    dst.cog = ng.geometry.Point2D.fromObject(src.cog);
                }
                return dst;
            }

            static toObject(src: SectionUnits | null | undefined): SectionUnits_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.SectionUnits is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.SectionUnits") {
                    console.error('Expected ng.sections.SectionUnits but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SectionUnits_json = {
                    a: AsJsonNum(src.a),
                    p: AsJsonNum(src.p),
                    xc: AsJsonNum(src.xc),
                    yc: AsJsonNum(src.yc),
                    xs: AsJsonNum(src.xs),
                    ys: AsJsonNum(src.ys),
                    iX: AsJsonNum(src.iX),
                    wX: AsJsonNum(src.wX),
                    zX: AsJsonNum(src.zX),
                    smX: AsJsonNum(src.smX),
                    irX: AsJsonNum(src.irX),
                    emaxY: AsJsonNum(src.emaxY),
                    eminY: AsJsonNum(src.eminY),
                    iY: AsJsonNum(src.iY),
                    wY: AsJsonNum(src.wY),
                    zY: AsJsonNum(src.zY),
                    smY: AsJsonNum(src.smY),
                    irY: AsJsonNum(src.irY),
                    emaxX: AsJsonNum(src.emaxX),
                    eminX: AsJsonNum(src.eminX),
                    j: AsJsonNum(src.j),
                    iT: AsJsonNum(src.iT),
                    wT: AsJsonNum(src.wT),
                    iW: AsJsonNum(src.iW),
                    iXy: AsJsonNum(src.iXy),
                    betaOmega: AsJsonNum(src.betaOmega),
                    i1: AsJsonNum(src.i1),
                    w1: AsJsonNum(src.w1),
                    z1: AsJsonNum(src.z1),
                    sm1: AsJsonNum(src.sm1),
                    ir1: AsJsonNum(src.ir1),
                    emax2: AsJsonNum(src.emax2),
                    emin2: AsJsonNum(src.emin2),
                    rho1: AsJsonNum(src.rho1),
                    c1: AsJsonNum(src.c1),
                    beta1: AsJsonNum(src.beta1),
                    sh1: AsJsonNum(src.sh1),
                    ang1: AsJsonNum(src.ang1),
                    i2: AsJsonNum(src.i2),
                    w2: AsJsonNum(src.w2),
                    z2: AsJsonNum(src.z2),
                    sm2: AsJsonNum(src.sm2),
                    ir2: AsJsonNum(src.ir2),
                    emax1: AsJsonNum(src.emax1),
                    emin1: AsJsonNum(src.emin1),
                    rho2: AsJsonNum(src.rho2),
                    c2: AsJsonNum(src.c2),
                    beta2: AsJsonNum(src.beta2),
                    sh2: AsJsonNum(src.sh2),
                    ang2: AsJsonNum(src.ang2),
                };
                if(src.cog !== null)
                {
                    const parsed = ng.geometry.Point2D.toObject(src.cog);
                    if(parsed === null) return null;
                    dst.cog = parsed;
                }
                return dst;
            }

            static create(src?: SectionUnits_createType) {
                const dst = new SectionUnits();
                if (src === undefined) {
                    return dst;
                }
                if (src.a !== undefined) {
                    dst.a = src.a;
                }
                if (src.p !== undefined) {
                    dst.p = src.p;
                }
                if (src.xc !== undefined) {
                    dst.xc = src.xc;
                }
                if (src.yc !== undefined) {
                    dst.yc = src.yc;
                }
                if (src.xs !== undefined) {
                    dst.xs = src.xs;
                }
                if (src.ys !== undefined) {
                    dst.ys = src.ys;
                }
                if (src.iX !== undefined) {
                    dst.iX = src.iX;
                }
                if (src.wX !== undefined) {
                    dst.wX = src.wX;
                }
                if (src.zX !== undefined) {
                    dst.zX = src.zX;
                }
                if (src.smX !== undefined) {
                    dst.smX = src.smX;
                }
                if (src.irX !== undefined) {
                    dst.irX = src.irX;
                }
                if (src.emaxY !== undefined) {
                    dst.emaxY = src.emaxY;
                }
                if (src.eminY !== undefined) {
                    dst.eminY = src.eminY;
                }
                if (src.iY !== undefined) {
                    dst.iY = src.iY;
                }
                if (src.wY !== undefined) {
                    dst.wY = src.wY;
                }
                if (src.zY !== undefined) {
                    dst.zY = src.zY;
                }
                if (src.smY !== undefined) {
                    dst.smY = src.smY;
                }
                if (src.irY !== undefined) {
                    dst.irY = src.irY;
                }
                if (src.emaxX !== undefined) {
                    dst.emaxX = src.emaxX;
                }
                if (src.eminX !== undefined) {
                    dst.eminX = src.eminX;
                }
                if (src.j !== undefined) {
                    dst.j = src.j;
                }
                if (src.iT !== undefined) {
                    dst.iT = src.iT;
                }
                if (src.wT !== undefined) {
                    dst.wT = src.wT;
                }
                if (src.iW !== undefined) {
                    dst.iW = src.iW;
                }
                if (src.iXy !== undefined) {
                    dst.iXy = src.iXy;
                }
                if (src.betaOmega !== undefined) {
                    dst.betaOmega = src.betaOmega;
                }
                if (src.i1 !== undefined) {
                    dst.i1 = src.i1;
                }
                if (src.w1 !== undefined) {
                    dst.w1 = src.w1;
                }
                if (src.z1 !== undefined) {
                    dst.z1 = src.z1;
                }
                if (src.sm1 !== undefined) {
                    dst.sm1 = src.sm1;
                }
                if (src.ir1 !== undefined) {
                    dst.ir1 = src.ir1;
                }
                if (src.emax2 !== undefined) {
                    dst.emax2 = src.emax2;
                }
                if (src.emin2 !== undefined) {
                    dst.emin2 = src.emin2;
                }
                if (src.rho1 !== undefined) {
                    dst.rho1 = src.rho1;
                }
                if (src.c1 !== undefined) {
                    dst.c1 = src.c1;
                }
                if (src.beta1 !== undefined) {
                    dst.beta1 = src.beta1;
                }
                if (src.sh1 !== undefined) {
                    dst.sh1 = src.sh1;
                }
                if (src.ang1 !== undefined) {
                    dst.ang1 = src.ang1;
                }
                if (src.i2 !== undefined) {
                    dst.i2 = src.i2;
                }
                if (src.w2 !== undefined) {
                    dst.w2 = src.w2;
                }
                if (src.z2 !== undefined) {
                    dst.z2 = src.z2;
                }
                if (src.sm2 !== undefined) {
                    dst.sm2 = src.sm2;
                }
                if (src.ir2 !== undefined) {
                    dst.ir2 = src.ir2;
                }
                if (src.emax1 !== undefined) {
                    dst.emax1 = src.emax1;
                }
                if (src.emin1 !== undefined) {
                    dst.emin1 = src.emin1;
                }
                if (src.rho2 !== undefined) {
                    dst.rho2 = src.rho2;
                }
                if (src.c2 !== undefined) {
                    dst.c2 = src.c2;
                }
                if (src.beta2 !== undefined) {
                    dst.beta2 = src.beta2;
                }
                if (src.sh2 !== undefined) {
                    dst.sh2 = src.sh2;
                }
                if (src.ang2 !== undefined) {
                    dst.ang2 = src.ang2;
                }
                if (src.cog !== undefined) {
                    dst.cog = src.cog;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SectionUnits();
                dst.a = this.a;
                dst.p = this.p;
                dst.xc = this.xc;
                dst.yc = this.yc;
                dst.xs = this.xs;
                dst.ys = this.ys;
                dst.iX = this.iX;
                dst.wX = this.wX;
                dst.zX = this.zX;
                dst.smX = this.smX;
                dst.irX = this.irX;
                dst.emaxY = this.emaxY;
                dst.eminY = this.eminY;
                dst.iY = this.iY;
                dst.wY = this.wY;
                dst.zY = this.zY;
                dst.smY = this.smY;
                dst.irY = this.irY;
                dst.emaxX = this.emaxX;
                dst.eminX = this.eminX;
                dst.j = this.j;
                dst.iT = this.iT;
                dst.wT = this.wT;
                dst.iW = this.iW;
                dst.iXy = this.iXy;
                dst.betaOmega = this.betaOmega;
                dst.i1 = this.i1;
                dst.w1 = this.w1;
                dst.z1 = this.z1;
                dst.sm1 = this.sm1;
                dst.ir1 = this.ir1;
                dst.emax2 = this.emax2;
                dst.emin2 = this.emin2;
                dst.rho1 = this.rho1;
                dst.c1 = this.c1;
                dst.beta1 = this.beta1;
                dst.sh1 = this.sh1;
                dst.ang1 = this.ang1;
                dst.i2 = this.i2;
                dst.w2 = this.w2;
                dst.z2 = this.z2;
                dst.sm2 = this.sm2;
                dst.ir2 = this.ir2;
                dst.emax1 = this.emax1;
                dst.emin1 = this.emin1;
                dst.rho2 = this.rho2;
                dst.c2 = this.c2;
                dst.beta2 = this.beta2;
                dst.sh2 = this.sh2;
                dst.ang2 = this.ang2;
                dst.cog = this.cog;
                return dst;
            }

            deepClone() {
                const json = SectionUnits.toObject(this);
                const dst = SectionUnits.fromObject(json);
                return dst;
            }
        }
        export type ISectionUnits = SectionUnits;


        export type Section_keys = 'id' | 'type' | 'units' | 'polylines' | 'polycurves' | 'materialCategory' | 'orientation' | 'customParams' | 'rParams' | 'vrParams' | 'tParams' | 'vtParams' | 'fParams' | 'kbParams' | 'kbeParams' | 'cParams' | 'iParams' | 'ivParams' | 'lParams' | 'coParams' | 'hdxParams' | 'toppingParams' | 'uParams' | 'zParams' | 'rhsParams' | 'heParams' | 'hsqParams' | 'uxParams' | 'zxParams' | 'sParams' | 'ownerType' | 'ownerName';
        export interface Section_createType {
            id?: ng.utils.ID | null,
            type?: ng.sections.SectionType,
            units?: ng.sections.SectionUnits | null,
            polylines?: ng.geometry.LineFace2D | null,
            polycurves?: ng.geometry.CurveFace2D | null,
            materialCategory?: ng.sections.MaterialCategory,
            orientation?: ng.geometry.Orientation | null,
            customParams?: ng.sections.CustomParams | null,
            rParams?: ng.sections.RParams | null,
            vrParams?: ng.sections.VRParams | null,
            tParams?: ng.sections.TParams | null,
            vtParams?: ng.sections.VTParams | null,
            fParams?: ng.sections.FParams | null,
            kbParams?: ng.sections.KBParams | null,
            kbeParams?: ng.sections.KBEParams | null,
            cParams?: ng.sections.CParams | null,
            iParams?: ng.sections.IParams | null,
            ivParams?: ng.sections.IVParams | null,
            lParams?: ng.sections.LParams | null,
            coParams?: ng.sections.COParams | null,
            hdxParams?: ng.sections.HDXParams | null,
            toppingParams?: ng.sections.ToppingParams | null,
            uParams?: ng.sections.UParams | null,
            zParams?: ng.sections.ZParams | null,
            rhsParams?: ng.sections.RHSParams | null,
            heParams?: ng.sections.HEParams | null,
            hsqParams?: ng.sections.HSQParams | null,
            uxParams?: ng.sections.UXParams | null,
            zxParams?: ng.sections.ZXParams | null,
            sParams?: ng.sections.SParams | null,
            ownerType?: ng.utils.Owner,
            ownerName?: string,
        }
        export interface Section_json {
            id?: ng.utils.ID_json;
            type?: string;
            units?: ng.sections.SectionUnits_json;
            polylines?: ng.geometry.LineFace2D_json;
            polycurves?: ng.geometry.CurveFace2D_json;
            materialCategory?: string;
            orientation?: ng.geometry.Orientation_json;
            customParams?: ng.sections.CustomParams_json;
            rParams?: ng.sections.RParams_json;
            vrParams?: ng.sections.VRParams_json;
            tParams?: ng.sections.TParams_json;
            vtParams?: ng.sections.VTParams_json;
            fParams?: ng.sections.FParams_json;
            kbParams?: ng.sections.KBParams_json;
            kbeParams?: ng.sections.KBEParams_json;
            cParams?: ng.sections.CParams_json;
            iParams?: ng.sections.IParams_json;
            ivParams?: ng.sections.IVParams_json;
            lParams?: ng.sections.LParams_json;
            coParams?: ng.sections.COParams_json;
            hdxParams?: ng.sections.HDXParams_json;
            toppingParams?: ng.sections.ToppingParams_json;
            uParams?: ng.sections.UParams_json;
            zParams?: ng.sections.ZParams_json;
            rhsParams?: ng.sections.RHSParams_json;
            heParams?: ng.sections.HEParams_json;
            hsqParams?: ng.sections.HSQParams_json;
            uxParams?: ng.sections.UXParams_json;
            zxParams?: ng.sections.ZXParams_json;
            sParams?: ng.sections.SParams_json;
            ownerType?: string;
            ownerName?: string;
        }
        interface Section_json_in {
            __proto_name?: unknown;
            id?: unknown;
            type?: unknown;
            units?: unknown;
            polylines?: unknown;
            polycurves?: unknown;
            materialCategory?: unknown;
            orientation?: unknown;
            customParams?: unknown;
            rParams?: unknown;
            vrParams?: unknown;
            tParams?: unknown;
            vtParams?: unknown;
            fParams?: unknown;
            kbParams?: unknown;
            kbeParams?: unknown;
            cParams?: unknown;
            iParams?: unknown;
            ivParams?: unknown;
            lParams?: unknown;
            coParams?: unknown;
            hdxParams?: unknown;
            toppingParams?: unknown;
            uParams?: unknown;
            zParams?: unknown;
            rhsParams?: unknown;
            heParams?: unknown;
            hsqParams?: unknown;
            uxParams?: unknown;
            zxParams?: unknown;
            sParams?: unknown;
            ownerType?: unknown;
            ownerName?: unknown;
        }
        export class Section {
            __proto_name = "ng.sections.Section";
            id: ng.utils.ID | null = null;
            type: ng.sections.SectionType = ng.sections.SectionType.SECTION_TYPE_UNSPECIFIED;
            units: ng.sections.SectionUnits | null = null;
            polylines: ng.geometry.LineFace2D | null = null;
            polycurves: ng.geometry.CurveFace2D | null = null;
            materialCategory: ng.sections.MaterialCategory = ng.sections.MaterialCategory.MATERIAL_CATEGORY_UNSPECIFIED;
            orientation: ng.geometry.Orientation | null = null;
            // this is a one of
            params: {type: 'customParams'; customParams: ng.sections.CustomParams} | {type: 'rParams'; rParams: ng.sections.RParams} | {type: 'vrParams'; vrParams: ng.sections.VRParams} | {type: 'tParams'; tParams: ng.sections.TParams} | {type: 'vtParams'; vtParams: ng.sections.VTParams} | {type: 'fParams'; fParams: ng.sections.FParams} | {type: 'kbParams'; kbParams: ng.sections.KBParams} | {type: 'kbeParams'; kbeParams: ng.sections.KBEParams} | {type: 'cParams'; cParams: ng.sections.CParams} | {type: 'iParams'; iParams: ng.sections.IParams} | {type: 'ivParams'; ivParams: ng.sections.IVParams} | {type: 'lParams'; lParams: ng.sections.LParams} | {type: 'coParams'; coParams: ng.sections.COParams} | {type: 'hdxParams'; hdxParams: ng.sections.HDXParams} | {type: 'toppingParams'; toppingParams: ng.sections.ToppingParams} | {type: 'uParams'; uParams: ng.sections.UParams} | {type: 'zParams'; zParams: ng.sections.ZParams} | {type: 'rhsParams'; rhsParams: ng.sections.RHSParams} | {type: 'heParams'; heParams: ng.sections.HEParams} | {type: 'hsqParams'; hsqParams: ng.sections.HSQParams} | {type: 'uxParams'; uxParams: ng.sections.UXParams} | {type: 'zxParams'; zxParams: ng.sections.ZXParams} | {type: 'sParams'; sParams: ng.sections.SParams} | null = null;
            ownerType: ng.utils.Owner = ng.utils.Owner.OWNER_UNSPECIFIED;
            ownerName: string = "";

            /** Gets the `CustomParams` value (or null) from the oneof `params` */
            getCustomParams(): ng.sections.CustomParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'customParams') return null;
                return this.params.customParams;
            }

            /** Sets the `CustomParams` value for the oneof `params`*/
            setCustomParams(value: ng.sections.CustomParams | null) {
                if(value !== null) {
                    this.params = {type: 'customParams', customParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `RParams` value (or null) from the oneof `params` */
            getRParams(): ng.sections.RParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'rParams') return null;
                return this.params.rParams;
            }

            /** Sets the `RParams` value for the oneof `params`*/
            setRParams(value: ng.sections.RParams | null) {
                if(value !== null) {
                    this.params = {type: 'rParams', rParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `VrParams` value (or null) from the oneof `params` */
            getVrParams(): ng.sections.VRParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'vrParams') return null;
                return this.params.vrParams;
            }

            /** Sets the `VrParams` value for the oneof `params`*/
            setVrParams(value: ng.sections.VRParams | null) {
                if(value !== null) {
                    this.params = {type: 'vrParams', vrParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `TParams` value (or null) from the oneof `params` */
            getTParams(): ng.sections.TParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'tParams') return null;
                return this.params.tParams;
            }

            /** Sets the `TParams` value for the oneof `params`*/
            setTParams(value: ng.sections.TParams | null) {
                if(value !== null) {
                    this.params = {type: 'tParams', tParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `VtParams` value (or null) from the oneof `params` */
            getVtParams(): ng.sections.VTParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'vtParams') return null;
                return this.params.vtParams;
            }

            /** Sets the `VtParams` value for the oneof `params`*/
            setVtParams(value: ng.sections.VTParams | null) {
                if(value !== null) {
                    this.params = {type: 'vtParams', vtParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `FParams` value (or null) from the oneof `params` */
            getFParams(): ng.sections.FParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'fParams') return null;
                return this.params.fParams;
            }

            /** Sets the `FParams` value for the oneof `params`*/
            setFParams(value: ng.sections.FParams | null) {
                if(value !== null) {
                    this.params = {type: 'fParams', fParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `KbParams` value (or null) from the oneof `params` */
            getKbParams(): ng.sections.KBParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'kbParams') return null;
                return this.params.kbParams;
            }

            /** Sets the `KbParams` value for the oneof `params`*/
            setKbParams(value: ng.sections.KBParams | null) {
                if(value !== null) {
                    this.params = {type: 'kbParams', kbParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `KbeParams` value (or null) from the oneof `params` */
            getKbeParams(): ng.sections.KBEParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'kbeParams') return null;
                return this.params.kbeParams;
            }

            /** Sets the `KbeParams` value for the oneof `params`*/
            setKbeParams(value: ng.sections.KBEParams | null) {
                if(value !== null) {
                    this.params = {type: 'kbeParams', kbeParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `CParams` value (or null) from the oneof `params` */
            getCParams(): ng.sections.CParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'cParams') return null;
                return this.params.cParams;
            }

            /** Sets the `CParams` value for the oneof `params`*/
            setCParams(value: ng.sections.CParams | null) {
                if(value !== null) {
                    this.params = {type: 'cParams', cParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `IParams` value (or null) from the oneof `params` */
            getIParams(): ng.sections.IParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'iParams') return null;
                return this.params.iParams;
            }

            /** Sets the `IParams` value for the oneof `params`*/
            setIParams(value: ng.sections.IParams | null) {
                if(value !== null) {
                    this.params = {type: 'iParams', iParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `IvParams` value (or null) from the oneof `params` */
            getIvParams(): ng.sections.IVParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'ivParams') return null;
                return this.params.ivParams;
            }

            /** Sets the `IvParams` value for the oneof `params`*/
            setIvParams(value: ng.sections.IVParams | null) {
                if(value !== null) {
                    this.params = {type: 'ivParams', ivParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `LParams` value (or null) from the oneof `params` */
            getLParams(): ng.sections.LParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'lParams') return null;
                return this.params.lParams;
            }

            /** Sets the `LParams` value for the oneof `params`*/
            setLParams(value: ng.sections.LParams | null) {
                if(value !== null) {
                    this.params = {type: 'lParams', lParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `CoParams` value (or null) from the oneof `params` */
            getCoParams(): ng.sections.COParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'coParams') return null;
                return this.params.coParams;
            }

            /** Sets the `CoParams` value for the oneof `params`*/
            setCoParams(value: ng.sections.COParams | null) {
                if(value !== null) {
                    this.params = {type: 'coParams', coParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `HdxParams` value (or null) from the oneof `params` */
            getHdxParams(): ng.sections.HDXParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'hdxParams') return null;
                return this.params.hdxParams;
            }

            /** Sets the `HdxParams` value for the oneof `params`*/
            setHdxParams(value: ng.sections.HDXParams | null) {
                if(value !== null) {
                    this.params = {type: 'hdxParams', hdxParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `ToppingParams` value (or null) from the oneof `params` */
            getToppingParams(): ng.sections.ToppingParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'toppingParams') return null;
                return this.params.toppingParams;
            }

            /** Sets the `ToppingParams` value for the oneof `params`*/
            setToppingParams(value: ng.sections.ToppingParams | null) {
                if(value !== null) {
                    this.params = {type: 'toppingParams', toppingParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `UParams` value (or null) from the oneof `params` */
            getUParams(): ng.sections.UParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'uParams') return null;
                return this.params.uParams;
            }

            /** Sets the `UParams` value for the oneof `params`*/
            setUParams(value: ng.sections.UParams | null) {
                if(value !== null) {
                    this.params = {type: 'uParams', uParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `ZParams` value (or null) from the oneof `params` */
            getZParams(): ng.sections.ZParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'zParams') return null;
                return this.params.zParams;
            }

            /** Sets the `ZParams` value for the oneof `params`*/
            setZParams(value: ng.sections.ZParams | null) {
                if(value !== null) {
                    this.params = {type: 'zParams', zParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `RhsParams` value (or null) from the oneof `params` */
            getRhsParams(): ng.sections.RHSParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'rhsParams') return null;
                return this.params.rhsParams;
            }

            /** Sets the `RhsParams` value for the oneof `params`*/
            setRhsParams(value: ng.sections.RHSParams | null) {
                if(value !== null) {
                    this.params = {type: 'rhsParams', rhsParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `HeParams` value (or null) from the oneof `params` */
            getHeParams(): ng.sections.HEParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'heParams') return null;
                return this.params.heParams;
            }

            /** Sets the `HeParams` value for the oneof `params`*/
            setHeParams(value: ng.sections.HEParams | null) {
                if(value !== null) {
                    this.params = {type: 'heParams', heParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `HsqParams` value (or null) from the oneof `params` */
            getHsqParams(): ng.sections.HSQParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'hsqParams') return null;
                return this.params.hsqParams;
            }

            /** Sets the `HsqParams` value for the oneof `params`*/
            setHsqParams(value: ng.sections.HSQParams | null) {
                if(value !== null) {
                    this.params = {type: 'hsqParams', hsqParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `UxParams` value (or null) from the oneof `params` */
            getUxParams(): ng.sections.UXParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'uxParams') return null;
                return this.params.uxParams;
            }

            /** Sets the `UxParams` value for the oneof `params`*/
            setUxParams(value: ng.sections.UXParams | null) {
                if(value !== null) {
                    this.params = {type: 'uxParams', uxParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `ZxParams` value (or null) from the oneof `params` */
            getZxParams(): ng.sections.ZXParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'zxParams') return null;
                return this.params.zxParams;
            }

            /** Sets the `ZxParams` value for the oneof `params`*/
            setZxParams(value: ng.sections.ZXParams | null) {
                if(value !== null) {
                    this.params = {type: 'zxParams', zxParams:value};
                }
                else {
                    this.params = null;
                }
            }

            /** Gets the `SParams` value (or null) from the oneof `params` */
            getSParams(): ng.sections.SParams | null {
                if(this.params === null) return null;
                if(this.params.type !== 'sParams') return null;
                return this.params.sParams;
            }

            /** Sets the `SParams` value for the oneof `params`*/
            setSParams(value: ng.sections.SParams | null) {
                if(value !== null) {
                    this.params = {type: 'sParams', sParams:value};
                }
                else {
                    this.params = null;
                }
            }

            static fromObject(src_unknown: unknown): Section {
                const dst = new Section();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Section but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Section_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Section but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.sections.SectionType_FromObject(src.type);
                }
                if (src.units !== undefined && src.units !== null) {
                    dst.units = ng.sections.SectionUnits.fromObject(src.units);
                }
                if (src.polylines !== undefined && src.polylines !== null) {
                    dst.polylines = ng.geometry.LineFace2D.fromObject(src.polylines);
                }
                if (src.polycurves !== undefined && src.polycurves !== null) {
                    dst.polycurves = ng.geometry.CurveFace2D.fromObject(src.polycurves);
                }
                if (src.materialCategory !== undefined && src.materialCategory !== null) {
                    dst.materialCategory = ng.sections.MaterialCategory_FromObject(src.materialCategory);
                }
                if (src.orientation !== undefined && src.orientation !== null) {
                    dst.orientation = ng.geometry.Orientation.fromObject(src.orientation);
                }
                if (src.customParams !== undefined && src.customParams !== null) {
                    dst.setCustomParams(ng.sections.CustomParams.fromObject(src.customParams));
                }
                if (src.rParams !== undefined && src.rParams !== null) {
                    dst.setRParams(ng.sections.RParams.fromObject(src.rParams));
                }
                if (src.vrParams !== undefined && src.vrParams !== null) {
                    dst.setVrParams(ng.sections.VRParams.fromObject(src.vrParams));
                }
                if (src.tParams !== undefined && src.tParams !== null) {
                    dst.setTParams(ng.sections.TParams.fromObject(src.tParams));
                }
                if (src.vtParams !== undefined && src.vtParams !== null) {
                    dst.setVtParams(ng.sections.VTParams.fromObject(src.vtParams));
                }
                if (src.fParams !== undefined && src.fParams !== null) {
                    dst.setFParams(ng.sections.FParams.fromObject(src.fParams));
                }
                if (src.kbParams !== undefined && src.kbParams !== null) {
                    dst.setKbParams(ng.sections.KBParams.fromObject(src.kbParams));
                }
                if (src.kbeParams !== undefined && src.kbeParams !== null) {
                    dst.setKbeParams(ng.sections.KBEParams.fromObject(src.kbeParams));
                }
                if (src.cParams !== undefined && src.cParams !== null) {
                    dst.setCParams(ng.sections.CParams.fromObject(src.cParams));
                }
                if (src.iParams !== undefined && src.iParams !== null) {
                    dst.setIParams(ng.sections.IParams.fromObject(src.iParams));
                }
                if (src.ivParams !== undefined && src.ivParams !== null) {
                    dst.setIvParams(ng.sections.IVParams.fromObject(src.ivParams));
                }
                if (src.lParams !== undefined && src.lParams !== null) {
                    dst.setLParams(ng.sections.LParams.fromObject(src.lParams));
                }
                if (src.coParams !== undefined && src.coParams !== null) {
                    dst.setCoParams(ng.sections.COParams.fromObject(src.coParams));
                }
                if (src.hdxParams !== undefined && src.hdxParams !== null) {
                    dst.setHdxParams(ng.sections.HDXParams.fromObject(src.hdxParams));
                }
                if (src.toppingParams !== undefined && src.toppingParams !== null) {
                    dst.setToppingParams(ng.sections.ToppingParams.fromObject(src.toppingParams));
                }
                if (src.uParams !== undefined && src.uParams !== null) {
                    dst.setUParams(ng.sections.UParams.fromObject(src.uParams));
                }
                if (src.zParams !== undefined && src.zParams !== null) {
                    dst.setZParams(ng.sections.ZParams.fromObject(src.zParams));
                }
                if (src.rhsParams !== undefined && src.rhsParams !== null) {
                    dst.setRhsParams(ng.sections.RHSParams.fromObject(src.rhsParams));
                }
                if (src.heParams !== undefined && src.heParams !== null) {
                    dst.setHeParams(ng.sections.HEParams.fromObject(src.heParams));
                }
                if (src.hsqParams !== undefined && src.hsqParams !== null) {
                    dst.setHsqParams(ng.sections.HSQParams.fromObject(src.hsqParams));
                }
                if (src.uxParams !== undefined && src.uxParams !== null) {
                    dst.setUxParams(ng.sections.UXParams.fromObject(src.uxParams));
                }
                if (src.zxParams !== undefined && src.zxParams !== null) {
                    dst.setZxParams(ng.sections.ZXParams.fromObject(src.zxParams));
                }
                if (src.sParams !== undefined && src.sParams !== null) {
                    dst.setSParams(ng.sections.SParams.fromObject(src.sParams));
                }
                if (src.ownerType !== undefined && src.ownerType !== null) {
                    dst.ownerType = ng.utils.Owner_FromObject(src.ownerType);
                }
                if (src.ownerName !== undefined && src.ownerName !== null) {
                    if (typeof src.ownerName === "string") {
                        dst.ownerName = src.ownerName;
                    }
                    else {
                        console.log('Expected ownerName of Section to be a string but was ', typeof src.ownerName, src.ownerName)
                    }
                }
                return dst;
            }

            static toObject(src: Section | null | undefined): Section_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.sections.Section is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.sections.Section") {
                    console.error('Expected ng.sections.Section but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.sections.SectionType_ToObject(src.type);
                if(type_obj === null) return null;

                const materialCategory_obj = ng.sections.MaterialCategory_ToObject(src.materialCategory);
                if(materialCategory_obj === null) return null;

                const ownerType_obj = ng.utils.Owner_ToObject(src.ownerType);
                if(ownerType_obj === null) return null;

                const dst : Section_json = {
                    type: type_obj,
                    materialCategory: materialCategory_obj,
                    ownerType: ownerType_obj,
                    ownerName: src.ownerName,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.units !== null)
                {
                    const parsed = ng.sections.SectionUnits.toObject(src.units);
                    if(parsed === null) return null;
                    dst.units = parsed;
                }
                if(src.polylines !== null)
                {
                    const parsed = ng.geometry.LineFace2D.toObject(src.polylines);
                    if(parsed === null) return null;
                    dst.polylines = parsed;
                }
                if(src.polycurves !== null)
                {
                    const parsed = ng.geometry.CurveFace2D.toObject(src.polycurves);
                    if(parsed === null) return null;
                    dst.polycurves = parsed;
                }
                if(src.orientation !== null)
                {
                    const parsed = ng.geometry.Orientation.toObject(src.orientation);
                    if(parsed === null) return null;
                    dst.orientation = parsed;
                }
                const customParams = src.getCustomParams();
                if(customParams !== null)
                {
                    const parsed = ng.sections.CustomParams.toObject(customParams);
                    if(parsed === null) return null;
                    dst.customParams = parsed;
                }
                const rParams = src.getRParams();
                if(rParams !== null)
                {
                    const parsed = ng.sections.RParams.toObject(rParams);
                    if(parsed === null) return null;
                    dst.rParams = parsed;
                }
                const vrParams = src.getVrParams();
                if(vrParams !== null)
                {
                    const parsed = ng.sections.VRParams.toObject(vrParams);
                    if(parsed === null) return null;
                    dst.vrParams = parsed;
                }
                const tParams = src.getTParams();
                if(tParams !== null)
                {
                    const parsed = ng.sections.TParams.toObject(tParams);
                    if(parsed === null) return null;
                    dst.tParams = parsed;
                }
                const vtParams = src.getVtParams();
                if(vtParams !== null)
                {
                    const parsed = ng.sections.VTParams.toObject(vtParams);
                    if(parsed === null) return null;
                    dst.vtParams = parsed;
                }
                const fParams = src.getFParams();
                if(fParams !== null)
                {
                    const parsed = ng.sections.FParams.toObject(fParams);
                    if(parsed === null) return null;
                    dst.fParams = parsed;
                }
                const kbParams = src.getKbParams();
                if(kbParams !== null)
                {
                    const parsed = ng.sections.KBParams.toObject(kbParams);
                    if(parsed === null) return null;
                    dst.kbParams = parsed;
                }
                const kbeParams = src.getKbeParams();
                if(kbeParams !== null)
                {
                    const parsed = ng.sections.KBEParams.toObject(kbeParams);
                    if(parsed === null) return null;
                    dst.kbeParams = parsed;
                }
                const cParams = src.getCParams();
                if(cParams !== null)
                {
                    const parsed = ng.sections.CParams.toObject(cParams);
                    if(parsed === null) return null;
                    dst.cParams = parsed;
                }
                const iParams = src.getIParams();
                if(iParams !== null)
                {
                    const parsed = ng.sections.IParams.toObject(iParams);
                    if(parsed === null) return null;
                    dst.iParams = parsed;
                }
                const ivParams = src.getIvParams();
                if(ivParams !== null)
                {
                    const parsed = ng.sections.IVParams.toObject(ivParams);
                    if(parsed === null) return null;
                    dst.ivParams = parsed;
                }
                const lParams = src.getLParams();
                if(lParams !== null)
                {
                    const parsed = ng.sections.LParams.toObject(lParams);
                    if(parsed === null) return null;
                    dst.lParams = parsed;
                }
                const coParams = src.getCoParams();
                if(coParams !== null)
                {
                    const parsed = ng.sections.COParams.toObject(coParams);
                    if(parsed === null) return null;
                    dst.coParams = parsed;
                }
                const hdxParams = src.getHdxParams();
                if(hdxParams !== null)
                {
                    const parsed = ng.sections.HDXParams.toObject(hdxParams);
                    if(parsed === null) return null;
                    dst.hdxParams = parsed;
                }
                const toppingParams = src.getToppingParams();
                if(toppingParams !== null)
                {
                    const parsed = ng.sections.ToppingParams.toObject(toppingParams);
                    if(parsed === null) return null;
                    dst.toppingParams = parsed;
                }
                const uParams = src.getUParams();
                if(uParams !== null)
                {
                    const parsed = ng.sections.UParams.toObject(uParams);
                    if(parsed === null) return null;
                    dst.uParams = parsed;
                }
                const zParams = src.getZParams();
                if(zParams !== null)
                {
                    const parsed = ng.sections.ZParams.toObject(zParams);
                    if(parsed === null) return null;
                    dst.zParams = parsed;
                }
                const rhsParams = src.getRhsParams();
                if(rhsParams !== null)
                {
                    const parsed = ng.sections.RHSParams.toObject(rhsParams);
                    if(parsed === null) return null;
                    dst.rhsParams = parsed;
                }
                const heParams = src.getHeParams();
                if(heParams !== null)
                {
                    const parsed = ng.sections.HEParams.toObject(heParams);
                    if(parsed === null) return null;
                    dst.heParams = parsed;
                }
                const hsqParams = src.getHsqParams();
                if(hsqParams !== null)
                {
                    const parsed = ng.sections.HSQParams.toObject(hsqParams);
                    if(parsed === null) return null;
                    dst.hsqParams = parsed;
                }
                const uxParams = src.getUxParams();
                if(uxParams !== null)
                {
                    const parsed = ng.sections.UXParams.toObject(uxParams);
                    if(parsed === null) return null;
                    dst.uxParams = parsed;
                }
                const zxParams = src.getZxParams();
                if(zxParams !== null)
                {
                    const parsed = ng.sections.ZXParams.toObject(zxParams);
                    if(parsed === null) return null;
                    dst.zxParams = parsed;
                }
                const sParams = src.getSParams();
                if(sParams !== null)
                {
                    const parsed = ng.sections.SParams.toObject(sParams);
                    if(parsed === null) return null;
                    dst.sParams = parsed;
                }
                return dst;
            }

            static create(src?: Section_createType) {
                const dst = new Section();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.units !== undefined) {
                    dst.units = src.units;
                }
                if (src.polylines !== undefined) {
                    dst.polylines = src.polylines;
                }
                if (src.polycurves !== undefined) {
                    dst.polycurves = src.polycurves;
                }
                if (src.materialCategory !== undefined) {
                    dst.materialCategory = src.materialCategory;
                }
                if (src.orientation !== undefined) {
                    dst.orientation = src.orientation;
                }
                // part of the params oneof 
                if (src.customParams !== undefined && src.customParams !== null) {
                    dst.setCustomParams(src.customParams);
                }
                // part of the params oneof 
                if (src.rParams !== undefined && src.rParams !== null) {
                    dst.setRParams(src.rParams);
                }
                // part of the params oneof 
                if (src.vrParams !== undefined && src.vrParams !== null) {
                    dst.setVrParams(src.vrParams);
                }
                // part of the params oneof 
                if (src.tParams !== undefined && src.tParams !== null) {
                    dst.setTParams(src.tParams);
                }
                // part of the params oneof 
                if (src.vtParams !== undefined && src.vtParams !== null) {
                    dst.setVtParams(src.vtParams);
                }
                // part of the params oneof 
                if (src.fParams !== undefined && src.fParams !== null) {
                    dst.setFParams(src.fParams);
                }
                // part of the params oneof 
                if (src.kbParams !== undefined && src.kbParams !== null) {
                    dst.setKbParams(src.kbParams);
                }
                // part of the params oneof 
                if (src.kbeParams !== undefined && src.kbeParams !== null) {
                    dst.setKbeParams(src.kbeParams);
                }
                // part of the params oneof 
                if (src.cParams !== undefined && src.cParams !== null) {
                    dst.setCParams(src.cParams);
                }
                // part of the params oneof 
                if (src.iParams !== undefined && src.iParams !== null) {
                    dst.setIParams(src.iParams);
                }
                // part of the params oneof 
                if (src.ivParams !== undefined && src.ivParams !== null) {
                    dst.setIvParams(src.ivParams);
                }
                // part of the params oneof 
                if (src.lParams !== undefined && src.lParams !== null) {
                    dst.setLParams(src.lParams);
                }
                // part of the params oneof 
                if (src.coParams !== undefined && src.coParams !== null) {
                    dst.setCoParams(src.coParams);
                }
                // part of the params oneof 
                if (src.hdxParams !== undefined && src.hdxParams !== null) {
                    dst.setHdxParams(src.hdxParams);
                }
                // part of the params oneof 
                if (src.toppingParams !== undefined && src.toppingParams !== null) {
                    dst.setToppingParams(src.toppingParams);
                }
                // part of the params oneof 
                if (src.uParams !== undefined && src.uParams !== null) {
                    dst.setUParams(src.uParams);
                }
                // part of the params oneof 
                if (src.zParams !== undefined && src.zParams !== null) {
                    dst.setZParams(src.zParams);
                }
                // part of the params oneof 
                if (src.rhsParams !== undefined && src.rhsParams !== null) {
                    dst.setRhsParams(src.rhsParams);
                }
                // part of the params oneof 
                if (src.heParams !== undefined && src.heParams !== null) {
                    dst.setHeParams(src.heParams);
                }
                // part of the params oneof 
                if (src.hsqParams !== undefined && src.hsqParams !== null) {
                    dst.setHsqParams(src.hsqParams);
                }
                // part of the params oneof 
                if (src.uxParams !== undefined && src.uxParams !== null) {
                    dst.setUxParams(src.uxParams);
                }
                // part of the params oneof 
                if (src.zxParams !== undefined && src.zxParams !== null) {
                    dst.setZxParams(src.zxParams);
                }
                // part of the params oneof 
                if (src.sParams !== undefined && src.sParams !== null) {
                    dst.setSParams(src.sParams);
                }
                if (src.ownerType !== undefined) {
                    dst.ownerType = src.ownerType;
                }
                if (src.ownerName !== undefined) {
                    dst.ownerName = src.ownerName;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Section();
                dst.id = this.id;
                dst.type = this.type;
                dst.units = this.units;
                dst.polylines = this.polylines;
                dst.polycurves = this.polycurves;
                dst.materialCategory = this.materialCategory;
                dst.orientation = this.orientation;
                dst.params = this.params;
                dst.ownerType = this.ownerType;
                dst.ownerName = this.ownerName;
                return dst;
            }

            deepClone() {
                const json = Section.toObject(this);
                const dst = Section.fromObject(json);
                return dst;
            }
        }
        export type ISection = Section;
    } // namespace sections


    // Defined in Soilmodel/cpt.proto
    export namespace geotechnical {
        // Defined in Soilmodel/cpt.proto
        export namespace cpt {
            export enum ConeType {
                CONE_TYPE_UNSPECIFIED = 0,
                CONE_TYPE_ELECTRICAL = 1,
                CONE_TYPE_MECHANICAL = 2
            }
            export const ConeType_FromObject = (src: unknown): ConeType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CONE_TYPE_UNSPECIFIED':
                        return ConeType.CONE_TYPE_UNSPECIFIED;
                    case 1:
                    case 'CONE_TYPE_ELECTRICAL':
                        return ConeType.CONE_TYPE_ELECTRICAL;
                    case 2:
                    case 'CONE_TYPE_MECHANICAL':
                        return ConeType.CONE_TYPE_MECHANICAL;
                    default:
                        console.log('Unhandled value for ConeType:' + src + '. ' + typeof(src));
                        return ConeType.CONE_TYPE_UNSPECIFIED;
                }
            };
            export const ConeType_ToObject = (src: ConeType): string | null => {
                switch (src) {
                    case ConeType.CONE_TYPE_UNSPECIFIED:
                        return 'CONE_TYPE_UNSPECIFIED';
                    case ConeType.CONE_TYPE_ELECTRICAL:
                        return 'CONE_TYPE_ELECTRICAL';
                    case ConeType.CONE_TYPE_MECHANICAL:
                        return 'CONE_TYPE_MECHANICAL';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ConeType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum CohesionMethod {
                COHESION_METHOD_UNDEFINED = 0,
                COHESION_METHOD_C_ONLY = 1,
                COHESION_METHOD_C_AND_FUNDR = 2
            }
            export const CohesionMethod_FromObject = (src: unknown): CohesionMethod => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'COHESION_METHOD_UNDEFINED':
                        return CohesionMethod.COHESION_METHOD_UNDEFINED;
                    case 1:
                    case 'COHESION_METHOD_C_ONLY':
                        return CohesionMethod.COHESION_METHOD_C_ONLY;
                    case 2:
                    case 'COHESION_METHOD_C_AND_FUNDR':
                        return CohesionMethod.COHESION_METHOD_C_AND_FUNDR;
                    default:
                        console.log('Unhandled value for CohesionMethod:' + src + '. ' + typeof(src));
                        return CohesionMethod.COHESION_METHOD_UNDEFINED;
                }
            };
            export const CohesionMethod_ToObject = (src: CohesionMethod): string | null => {
                switch (src) {
                    case CohesionMethod.COHESION_METHOD_UNDEFINED:
                        return 'COHESION_METHOD_UNDEFINED';
                    case CohesionMethod.COHESION_METHOD_C_ONLY:
                        return 'COHESION_METHOD_C_ONLY';
                    case CohesionMethod.COHESION_METHOD_C_AND_FUNDR:
                        return 'COHESION_METHOD_C_AND_FUNDR';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for CohesionMethod, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SoilName {
                SOIL_NAME_UNDEF = 0,
                SOIL_NAME_GRAVEL = 1,
                SOIL_NAME_SAND = 2,
                SOIL_NAME_LOAM = 3,
                SOIL_NAME_CLAY = 4,
                SOIL_NAME_PEAT = 5
            }
            export const SoilName_FromObject = (src: unknown): SoilName => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SOIL_NAME_UNDEF':
                        return SoilName.SOIL_NAME_UNDEF;
                    case 1:
                    case 'SOIL_NAME_GRAVEL':
                        return SoilName.SOIL_NAME_GRAVEL;
                    case 2:
                    case 'SOIL_NAME_SAND':
                        return SoilName.SOIL_NAME_SAND;
                    case 3:
                    case 'SOIL_NAME_LOAM':
                        return SoilName.SOIL_NAME_LOAM;
                    case 4:
                    case 'SOIL_NAME_CLAY':
                        return SoilName.SOIL_NAME_CLAY;
                    case 5:
                    case 'SOIL_NAME_PEAT':
                        return SoilName.SOIL_NAME_PEAT;
                    default:
                        console.log('Unhandled value for SoilName:' + src + '. ' + typeof(src));
                        return SoilName.SOIL_NAME_UNDEF;
                }
            };
            export const SoilName_ToObject = (src: SoilName): string | null => {
                switch (src) {
                    case SoilName.SOIL_NAME_UNDEF:
                        return 'SOIL_NAME_UNDEF';
                    case SoilName.SOIL_NAME_GRAVEL:
                        return 'SOIL_NAME_GRAVEL';
                    case SoilName.SOIL_NAME_SAND:
                        return 'SOIL_NAME_SAND';
                    case SoilName.SOIL_NAME_LOAM:
                        return 'SOIL_NAME_LOAM';
                    case SoilName.SOIL_NAME_CLAY:
                        return 'SOIL_NAME_CLAY';
                    case SoilName.SOIL_NAME_PEAT:
                        return 'SOIL_NAME_PEAT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SoilName, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SoilMixture {
                SOIL_MIXTURE_UNDEF = 0,
                SOIL_MIXTURE_WEAK_SILTY = 1,
                SOIL_MIXTURE_VERY_SILTY = 2,
                SOIL_MIXTURE_CLEAN = 3,
                SOIL_MIXTURE_WEAK_SILTY_CLAYEY = 4,
                SOIL_MIXTURE_VERY_SILTY_CLAYEY = 5,
                SOIL_MIXTURE_WEAK_SANDY = 6,
                SOIL_MIXTURE_VERY_SANDY = 7,
                SOIL_MIXTURE_ORGANIC = 8,
                SOIL_MIXTURE_NOT_PRELOADED = 9,
                SOIL_MIXTURE_LITTLE_PRELOADED = 10
            }
            export const SoilMixture_FromObject = (src: unknown): SoilMixture => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SOIL_MIXTURE_UNDEF':
                        return SoilMixture.SOIL_MIXTURE_UNDEF;
                    case 1:
                    case 'SOIL_MIXTURE_WEAK_SILTY':
                        return SoilMixture.SOIL_MIXTURE_WEAK_SILTY;
                    case 2:
                    case 'SOIL_MIXTURE_VERY_SILTY':
                        return SoilMixture.SOIL_MIXTURE_VERY_SILTY;
                    case 3:
                    case 'SOIL_MIXTURE_CLEAN':
                        return SoilMixture.SOIL_MIXTURE_CLEAN;
                    case 4:
                    case 'SOIL_MIXTURE_WEAK_SILTY_CLAYEY':
                        return SoilMixture.SOIL_MIXTURE_WEAK_SILTY_CLAYEY;
                    case 5:
                    case 'SOIL_MIXTURE_VERY_SILTY_CLAYEY':
                        return SoilMixture.SOIL_MIXTURE_VERY_SILTY_CLAYEY;
                    case 6:
                    case 'SOIL_MIXTURE_WEAK_SANDY':
                        return SoilMixture.SOIL_MIXTURE_WEAK_SANDY;
                    case 7:
                    case 'SOIL_MIXTURE_VERY_SANDY':
                        return SoilMixture.SOIL_MIXTURE_VERY_SANDY;
                    case 8:
                    case 'SOIL_MIXTURE_ORGANIC':
                        return SoilMixture.SOIL_MIXTURE_ORGANIC;
                    case 9:
                    case 'SOIL_MIXTURE_NOT_PRELOADED':
                        return SoilMixture.SOIL_MIXTURE_NOT_PRELOADED;
                    case 10:
                    case 'SOIL_MIXTURE_LITTLE_PRELOADED':
                        return SoilMixture.SOIL_MIXTURE_LITTLE_PRELOADED;
                    default:
                        console.log('Unhandled value for SoilMixture:' + src + '. ' + typeof(src));
                        return SoilMixture.SOIL_MIXTURE_UNDEF;
                }
            };
            export const SoilMixture_ToObject = (src: SoilMixture): string | null => {
                switch (src) {
                    case SoilMixture.SOIL_MIXTURE_UNDEF:
                        return 'SOIL_MIXTURE_UNDEF';
                    case SoilMixture.SOIL_MIXTURE_WEAK_SILTY:
                        return 'SOIL_MIXTURE_WEAK_SILTY';
                    case SoilMixture.SOIL_MIXTURE_VERY_SILTY:
                        return 'SOIL_MIXTURE_VERY_SILTY';
                    case SoilMixture.SOIL_MIXTURE_CLEAN:
                        return 'SOIL_MIXTURE_CLEAN';
                    case SoilMixture.SOIL_MIXTURE_WEAK_SILTY_CLAYEY:
                        return 'SOIL_MIXTURE_WEAK_SILTY_CLAYEY';
                    case SoilMixture.SOIL_MIXTURE_VERY_SILTY_CLAYEY:
                        return 'SOIL_MIXTURE_VERY_SILTY_CLAYEY';
                    case SoilMixture.SOIL_MIXTURE_WEAK_SANDY:
                        return 'SOIL_MIXTURE_WEAK_SANDY';
                    case SoilMixture.SOIL_MIXTURE_VERY_SANDY:
                        return 'SOIL_MIXTURE_VERY_SANDY';
                    case SoilMixture.SOIL_MIXTURE_ORGANIC:
                        return 'SOIL_MIXTURE_ORGANIC';
                    case SoilMixture.SOIL_MIXTURE_NOT_PRELOADED:
                        return 'SOIL_MIXTURE_NOT_PRELOADED';
                    case SoilMixture.SOIL_MIXTURE_LITTLE_PRELOADED:
                        return 'SOIL_MIXTURE_LITTLE_PRELOADED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SoilMixture, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SoilConsistence {
                SOIL_CONSISTENCE_UNSPECIFIED = 0,
                SOIL_CONSISTENCE_UNDEF = 1,
                SOIL_CONSISTENCE_LOOSE = 2,
                SOIL_CONSISTENCE_MODERATE = 3,
                SOIL_CONSISTENCE_FIXED = 4,
                SOIL_CONSISTENCE_WEAK = 5
            }
            export const SoilConsistence_FromObject = (src: unknown): SoilConsistence => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SOIL_CONSISTENCE_UNSPECIFIED':
                        return SoilConsistence.SOIL_CONSISTENCE_UNSPECIFIED;
                    case 1:
                    case 'SOIL_CONSISTENCE_UNDEF':
                        return SoilConsistence.SOIL_CONSISTENCE_UNDEF;
                    case 2:
                    case 'SOIL_CONSISTENCE_LOOSE':
                        return SoilConsistence.SOIL_CONSISTENCE_LOOSE;
                    case 3:
                    case 'SOIL_CONSISTENCE_MODERATE':
                        return SoilConsistence.SOIL_CONSISTENCE_MODERATE;
                    case 4:
                    case 'SOIL_CONSISTENCE_FIXED':
                        return SoilConsistence.SOIL_CONSISTENCE_FIXED;
                    case 5:
                    case 'SOIL_CONSISTENCE_WEAK':
                        return SoilConsistence.SOIL_CONSISTENCE_WEAK;
                    default:
                        console.log('Unhandled value for SoilConsistence:' + src + '. ' + typeof(src));
                        return SoilConsistence.SOIL_CONSISTENCE_UNSPECIFIED;
                }
            };
            export const SoilConsistence_ToObject = (src: SoilConsistence): string | null => {
                switch (src) {
                    case SoilConsistence.SOIL_CONSISTENCE_UNSPECIFIED:
                        return 'SOIL_CONSISTENCE_UNSPECIFIED';
                    case SoilConsistence.SOIL_CONSISTENCE_UNDEF:
                        return 'SOIL_CONSISTENCE_UNDEF';
                    case SoilConsistence.SOIL_CONSISTENCE_LOOSE:
                        return 'SOIL_CONSISTENCE_LOOSE';
                    case SoilConsistence.SOIL_CONSISTENCE_MODERATE:
                        return 'SOIL_CONSISTENCE_MODERATE';
                    case SoilConsistence.SOIL_CONSISTENCE_FIXED:
                        return 'SOIL_CONSISTENCE_FIXED';
                    case SoilConsistence.SOIL_CONSISTENCE_WEAK:
                        return 'SOIL_CONSISTENCE_WEAK';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SoilConsistence, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum GeoDbMode {
                GEO_DB_MODE_DEFAULT = 0,
                GEO_DB_MODE_USER = 1,
                GEO_DB_MODE_SOIL_PROFILE = 2,
                GEO_DB_MODE_LOG_FILE = 3
            }
            export const GeoDbMode_FromObject = (src: unknown): GeoDbMode => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'GEO_DB_MODE_DEFAULT':
                        return GeoDbMode.GEO_DB_MODE_DEFAULT;
                    case 1:
                    case 'GEO_DB_MODE_USER':
                        return GeoDbMode.GEO_DB_MODE_USER;
                    case 2:
                    case 'GEO_DB_MODE_SOIL_PROFILE':
                        return GeoDbMode.GEO_DB_MODE_SOIL_PROFILE;
                    case 3:
                    case 'GEO_DB_MODE_LOG_FILE':
                        return GeoDbMode.GEO_DB_MODE_LOG_FILE;
                    default:
                        console.log('Unhandled value for GeoDbMode:' + src + '. ' + typeof(src));
                        return GeoDbMode.GEO_DB_MODE_DEFAULT;
                }
            };
            export const GeoDbMode_ToObject = (src: GeoDbMode): string | null => {
                switch (src) {
                    case GeoDbMode.GEO_DB_MODE_DEFAULT:
                        return 'GEO_DB_MODE_DEFAULT';
                    case GeoDbMode.GEO_DB_MODE_USER:
                        return 'GEO_DB_MODE_USER';
                    case GeoDbMode.GEO_DB_MODE_SOIL_PROFILE:
                        return 'GEO_DB_MODE_SOIL_PROFILE';
                    case GeoDbMode.GEO_DB_MODE_LOG_FILE:
                        return 'GEO_DB_MODE_LOG_FILE';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for GeoDbMode, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum GroundLevelType {
                GROUND_LEVEL_TYPE_UNDEF = 0,
                GROUND_LEVEL_TYPE_NAP = 1,
                GROUND_LEVEL_TYPE_FIXED = 2,
                GROUND_LEVEL_TYPE_GROUND = 3
            }
            export const GroundLevelType_FromObject = (src: unknown): GroundLevelType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'GROUND_LEVEL_TYPE_UNDEF':
                        return GroundLevelType.GROUND_LEVEL_TYPE_UNDEF;
                    case 1:
                    case 'GROUND_LEVEL_TYPE_NAP':
                        return GroundLevelType.GROUND_LEVEL_TYPE_NAP;
                    case 2:
                    case 'GROUND_LEVEL_TYPE_FIXED':
                        return GroundLevelType.GROUND_LEVEL_TYPE_FIXED;
                    case 3:
                    case 'GROUND_LEVEL_TYPE_GROUND':
                        return GroundLevelType.GROUND_LEVEL_TYPE_GROUND;
                    default:
                        console.log('Unhandled value for GroundLevelType:' + src + '. ' + typeof(src));
                        return GroundLevelType.GROUND_LEVEL_TYPE_UNDEF;
                }
            };
            export const GroundLevelType_ToObject = (src: GroundLevelType): string | null => {
                switch (src) {
                    case GroundLevelType.GROUND_LEVEL_TYPE_UNDEF:
                        return 'GROUND_LEVEL_TYPE_UNDEF';
                    case GroundLevelType.GROUND_LEVEL_TYPE_NAP:
                        return 'GROUND_LEVEL_TYPE_NAP';
                    case GroundLevelType.GROUND_LEVEL_TYPE_FIXED:
                        return 'GROUND_LEVEL_TYPE_FIXED';
                    case GroundLevelType.GROUND_LEVEL_TYPE_GROUND:
                        return 'GROUND_LEVEL_TYPE_GROUND';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for GroundLevelType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum AnalysisType {
                ANALYSIS_TYPE_UNSPECIFIED = 0,
                ANALYSIS_TYPE_USER_DEFINED = 1,
                ANALYSIS_TYPE_CONE_USE_QC = 2,
                ANALYSIS_TYPE_CONE_QC_INF_QC_SUP = 3,
                ANALYSIS_TYPE_CONE_IGNORE_BOUNDARY = 4,
                ANALYSIS_TYPE_FRICTION = 5,
                ANALYSIS_TYPE_FRICTION_IGNORE_BOUNDARY = 6
            }
            export const AnalysisType_FromObject = (src: unknown): AnalysisType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ANALYSIS_TYPE_UNSPECIFIED':
                        return AnalysisType.ANALYSIS_TYPE_UNSPECIFIED;
                    case 1:
                    case 'ANALYSIS_TYPE_USER_DEFINED':
                        return AnalysisType.ANALYSIS_TYPE_USER_DEFINED;
                    case 2:
                    case 'ANALYSIS_TYPE_CONE_USE_QC':
                        return AnalysisType.ANALYSIS_TYPE_CONE_USE_QC;
                    case 3:
                    case 'ANALYSIS_TYPE_CONE_QC_INF_QC_SUP':
                        return AnalysisType.ANALYSIS_TYPE_CONE_QC_INF_QC_SUP;
                    case 4:
                    case 'ANALYSIS_TYPE_CONE_IGNORE_BOUNDARY':
                        return AnalysisType.ANALYSIS_TYPE_CONE_IGNORE_BOUNDARY;
                    case 5:
                    case 'ANALYSIS_TYPE_FRICTION':
                        return AnalysisType.ANALYSIS_TYPE_FRICTION;
                    case 6:
                    case 'ANALYSIS_TYPE_FRICTION_IGNORE_BOUNDARY':
                        return AnalysisType.ANALYSIS_TYPE_FRICTION_IGNORE_BOUNDARY;
                    default:
                        console.log('Unhandled value for AnalysisType:' + src + '. ' + typeof(src));
                        return AnalysisType.ANALYSIS_TYPE_UNSPECIFIED;
                }
            };
            export const AnalysisType_ToObject = (src: AnalysisType): string | null => {
                switch (src) {
                    case AnalysisType.ANALYSIS_TYPE_UNSPECIFIED:
                        return 'ANALYSIS_TYPE_UNSPECIFIED';
                    case AnalysisType.ANALYSIS_TYPE_USER_DEFINED:
                        return 'ANALYSIS_TYPE_USER_DEFINED';
                    case AnalysisType.ANALYSIS_TYPE_CONE_USE_QC:
                        return 'ANALYSIS_TYPE_CONE_USE_QC';
                    case AnalysisType.ANALYSIS_TYPE_CONE_QC_INF_QC_SUP:
                        return 'ANALYSIS_TYPE_CONE_QC_INF_QC_SUP';
                    case AnalysisType.ANALYSIS_TYPE_CONE_IGNORE_BOUNDARY:
                        return 'ANALYSIS_TYPE_CONE_IGNORE_BOUNDARY';
                    case AnalysisType.ANALYSIS_TYPE_FRICTION:
                        return 'ANALYSIS_TYPE_FRICTION';
                    case AnalysisType.ANALYSIS_TYPE_FRICTION_IGNORE_BOUNDARY:
                        return 'ANALYSIS_TYPE_FRICTION_IGNORE_BOUNDARY';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for AnalysisType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type CptDataPoint_keys = 'depth' | 'frictionValue' | 'coneResistance';
            export interface CptDataPoint_createType {
                depth?: number,
                frictionValue?: number,
                coneResistance?: number,
            }
            export interface CptDataPoint_json {
                depth?: JsonNumber;
                frictionValue?: JsonNumber;
                coneResistance?: JsonNumber;
            }
            interface CptDataPoint_json_in {
                __proto_name?: unknown;
                depth?: unknown;
                frictionValue?: unknown;
                coneResistance?: unknown;
            }
            export class CptDataPoint {
                __proto_name = "ng.geotechnical.cpt.CptDataPoint";
                depth: number = 0;
                frictionValue: number = 0;
                coneResistance: number = 0;

                static fromObject(src_unknown: unknown): CptDataPoint {
                    const dst = new CptDataPoint();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CptDataPoint but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CptDataPoint_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CptDataPoint but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.depth !== undefined && src.depth !== null) {
                        if (typeof src.depth === "number" || src.depth === 'NaN' || src.depth === 'Infinity' || src.depth === '-Infinity') {
                            dst.depth = AsNum(src.depth);
                        }
                        else {
                            console.log('Expected depth of CptDataPoint to be a number but was ', typeof src.depth, src.depth)
                        }
                    }
                    if (src.frictionValue !== undefined && src.frictionValue !== null) {
                        if (typeof src.frictionValue === "number" || src.frictionValue === 'NaN' || src.frictionValue === 'Infinity' || src.frictionValue === '-Infinity') {
                            dst.frictionValue = AsNum(src.frictionValue);
                        }
                        else {
                            console.log('Expected frictionValue of CptDataPoint to be a number but was ', typeof src.frictionValue, src.frictionValue)
                        }
                    }
                    if (src.coneResistance !== undefined && src.coneResistance !== null) {
                        if (typeof src.coneResistance === "number" || src.coneResistance === 'NaN' || src.coneResistance === 'Infinity' || src.coneResistance === '-Infinity') {
                            dst.coneResistance = AsNum(src.coneResistance);
                        }
                        else {
                            console.log('Expected coneResistance of CptDataPoint to be a number but was ', typeof src.coneResistance, src.coneResistance)
                        }
                    }
                    return dst;
                }

                static toObject(src: CptDataPoint | null | undefined): CptDataPoint_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.CptDataPoint is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.CptDataPoint") {
                        console.error('Expected ng.geotechnical.cpt.CptDataPoint but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CptDataPoint_json = {
                        depth: AsJsonNum(src.depth),
                        frictionValue: AsJsonNum(src.frictionValue),
                        coneResistance: AsJsonNum(src.coneResistance),
                    };
                    return dst;
                }

                static create(src?: CptDataPoint_createType) {
                    const dst = new CptDataPoint();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.depth !== undefined) {
                        dst.depth = src.depth;
                    }
                    if (src.frictionValue !== undefined) {
                        dst.frictionValue = src.frictionValue;
                    }
                    if (src.coneResistance !== undefined) {
                        dst.coneResistance = src.coneResistance;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CptDataPoint();
                    dst.depth = this.depth;
                    dst.frictionValue = this.frictionValue;
                    dst.coneResistance = this.coneResistance;
                    return dst;
                }

                deepClone() {
                    const json = CptDataPoint.toObject(this);
                    const dst = CptDataPoint.fromObject(json);
                    return dst;
                }
            }
            export type ICptDataPoint = CptDataPoint;


            export type CptDiagram_keys = 'points';
            export interface CptDiagram_createType {
                points?: ng.geotechnical.cpt.CptDataPoint[],
            }
            export interface CptDiagram_json {
                points: ng.geotechnical.cpt.CptDataPoint_json[];
            }
            interface CptDiagram_json_in {
                __proto_name?: unknown;
                points?: unknown;
            }
            export class CptDiagram {
                __proto_name = "ng.geotechnical.cpt.CptDiagram";
                points: ng.geotechnical.cpt.CptDataPoint[] = [];

                static fromObject(src_unknown: unknown): CptDiagram {
                    const dst = new CptDiagram();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CptDiagram but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CptDiagram_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CptDiagram but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.points !== undefined && src.points !== null) {
                        if (Array.isArray(src.points)) {
                            for (const element of src.points) {
                                dst.points.push(ng.geotechnical.cpt.CptDataPoint.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected points of CptDiagram to be a array but was ', typeof src.points, src.points)
                        }
                    }
                    return dst;
                }

                static toObject(src: CptDiagram | null | undefined): CptDiagram_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.CptDiagram is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.CptDiagram") {
                        console.error('Expected ng.geotechnical.cpt.CptDiagram but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CptDiagram_json = {
                        points: new Array<ng.geotechnical.cpt.CptDataPoint_json>(),
                    };
                    if (src.points !== null) {
                        for (const element of src.points) {
                            const parsed = ng.geotechnical.cpt.CptDataPoint.toObject(element);
                            if(parsed === null) return null;
                            dst.points.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CptDiagram_createType) {
                    const dst = new CptDiagram();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.points !== undefined) {
                        dst.points = src.points;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CptDiagram();
                    dst.points = this.points;
                    return dst;
                }

                deepClone() {
                    const json = CptDiagram.toObject(this);
                    const dst = CptDiagram.fromObject(json);
                    return dst;
                }
            }
            export type ICptDiagram = CptDiagram;


            export type CptJobInfo_keys = 'cptName' | 'measComments' | 'date' | 'location' | 'street' | 'houseNumber' | 'postalCode' | 'place' | 'xCoord' | 'yCoord' | 'coneType';
            export interface CptJobInfo_createType {
                cptName?: string,
                measComments?: string,
                date?: string,
                location?: string,
                street?: string,
                houseNumber?: string,
                postalCode?: string,
                place?: string,
                xCoord?: number,
                yCoord?: number,
                coneType?: ng.geotechnical.cpt.ConeType,
            }
            export interface CptJobInfo_json {
                cptName?: string;
                measComments?: string;
                date?: string;
                location?: string;
                street?: string;
                houseNumber?: string;
                postalCode?: string;
                place?: string;
                xCoord?: JsonNumber;
                yCoord?: JsonNumber;
                coneType?: string;
            }
            interface CptJobInfo_json_in {
                __proto_name?: unknown;
                cptName?: unknown;
                measComments?: unknown;
                date?: unknown;
                location?: unknown;
                street?: unknown;
                houseNumber?: unknown;
                postalCode?: unknown;
                place?: unknown;
                xCoord?: unknown;
                yCoord?: unknown;
                coneType?: unknown;
            }
            export class CptJobInfo {
                __proto_name = "ng.geotechnical.cpt.CptJobInfo";
                cptName: string = "";
                measComments: string = "";
                date: string = "";
                location: string = "";
                street: string = "";
                houseNumber: string = "";
                postalCode: string = "";
                place: string = "";
                xCoord: number = 0;
                yCoord: number = 0;
                coneType: ng.geotechnical.cpt.ConeType = ng.geotechnical.cpt.ConeType.CONE_TYPE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): CptJobInfo {
                    const dst = new CptJobInfo();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CptJobInfo but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CptJobInfo_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CptJobInfo but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.cptName !== undefined && src.cptName !== null) {
                        if (typeof src.cptName === "string") {
                            dst.cptName = src.cptName;
                        }
                        else {
                            console.log('Expected cptName of CptJobInfo to be a string but was ', typeof src.cptName, src.cptName)
                        }
                    }
                    if (src.measComments !== undefined && src.measComments !== null) {
                        if (typeof src.measComments === "string") {
                            dst.measComments = src.measComments;
                        }
                        else {
                            console.log('Expected measComments of CptJobInfo to be a string but was ', typeof src.measComments, src.measComments)
                        }
                    }
                    if (src.date !== undefined && src.date !== null) {
                        if (typeof src.date === "string") {
                            dst.date = src.date;
                        }
                        else {
                            console.log('Expected date of CptJobInfo to be a string but was ', typeof src.date, src.date)
                        }
                    }
                    if (src.location !== undefined && src.location !== null) {
                        if (typeof src.location === "string") {
                            dst.location = src.location;
                        }
                        else {
                            console.log('Expected location of CptJobInfo to be a string but was ', typeof src.location, src.location)
                        }
                    }
                    if (src.street !== undefined && src.street !== null) {
                        if (typeof src.street === "string") {
                            dst.street = src.street;
                        }
                        else {
                            console.log('Expected street of CptJobInfo to be a string but was ', typeof src.street, src.street)
                        }
                    }
                    if (src.houseNumber !== undefined && src.houseNumber !== null) {
                        if (typeof src.houseNumber === "string") {
                            dst.houseNumber = src.houseNumber;
                        }
                        else {
                            console.log('Expected houseNumber of CptJobInfo to be a string but was ', typeof src.houseNumber, src.houseNumber)
                        }
                    }
                    if (src.postalCode !== undefined && src.postalCode !== null) {
                        if (typeof src.postalCode === "string") {
                            dst.postalCode = src.postalCode;
                        }
                        else {
                            console.log('Expected postalCode of CptJobInfo to be a string but was ', typeof src.postalCode, src.postalCode)
                        }
                    }
                    if (src.place !== undefined && src.place !== null) {
                        if (typeof src.place === "string") {
                            dst.place = src.place;
                        }
                        else {
                            console.log('Expected place of CptJobInfo to be a string but was ', typeof src.place, src.place)
                        }
                    }
                    if (src.xCoord !== undefined && src.xCoord !== null) {
                        if (typeof src.xCoord === "number" || src.xCoord === 'NaN' || src.xCoord === 'Infinity' || src.xCoord === '-Infinity') {
                            dst.xCoord = AsNum(src.xCoord);
                        }
                        else {
                            console.log('Expected xCoord of CptJobInfo to be a number but was ', typeof src.xCoord, src.xCoord)
                        }
                    }
                    if (src.yCoord !== undefined && src.yCoord !== null) {
                        if (typeof src.yCoord === "number" || src.yCoord === 'NaN' || src.yCoord === 'Infinity' || src.yCoord === '-Infinity') {
                            dst.yCoord = AsNum(src.yCoord);
                        }
                        else {
                            console.log('Expected yCoord of CptJobInfo to be a number but was ', typeof src.yCoord, src.yCoord)
                        }
                    }
                    if (src.coneType !== undefined && src.coneType !== null) {
                        dst.coneType = ng.geotechnical.cpt.ConeType_FromObject(src.coneType);
                    }
                    return dst;
                }

                static toObject(src: CptJobInfo | null | undefined): CptJobInfo_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.CptJobInfo is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.CptJobInfo") {
                        console.error('Expected ng.geotechnical.cpt.CptJobInfo but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const coneType_obj = ng.geotechnical.cpt.ConeType_ToObject(src.coneType);
                    if(coneType_obj === null) return null;

                    const dst : CptJobInfo_json = {
                        cptName: src.cptName,
                        measComments: src.measComments,
                        date: src.date,
                        location: src.location,
                        street: src.street,
                        houseNumber: src.houseNumber,
                        postalCode: src.postalCode,
                        place: src.place,
                        xCoord: AsJsonNum(src.xCoord),
                        yCoord: AsJsonNum(src.yCoord),
                        coneType: coneType_obj,
                    };
                    return dst;
                }

                static create(src?: CptJobInfo_createType) {
                    const dst = new CptJobInfo();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.cptName !== undefined) {
                        dst.cptName = src.cptName;
                    }
                    if (src.measComments !== undefined) {
                        dst.measComments = src.measComments;
                    }
                    if (src.date !== undefined) {
                        dst.date = src.date;
                    }
                    if (src.location !== undefined) {
                        dst.location = src.location;
                    }
                    if (src.street !== undefined) {
                        dst.street = src.street;
                    }
                    if (src.houseNumber !== undefined) {
                        dst.houseNumber = src.houseNumber;
                    }
                    if (src.postalCode !== undefined) {
                        dst.postalCode = src.postalCode;
                    }
                    if (src.place !== undefined) {
                        dst.place = src.place;
                    }
                    if (src.xCoord !== undefined) {
                        dst.xCoord = src.xCoord;
                    }
                    if (src.yCoord !== undefined) {
                        dst.yCoord = src.yCoord;
                    }
                    if (src.coneType !== undefined) {
                        dst.coneType = src.coneType;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CptJobInfo();
                    dst.cptName = this.cptName;
                    dst.measComments = this.measComments;
                    dst.date = this.date;
                    dst.location = this.location;
                    dst.street = this.street;
                    dst.houseNumber = this.houseNumber;
                    dst.postalCode = this.postalCode;
                    dst.place = this.place;
                    dst.xCoord = this.xCoord;
                    dst.yCoord = this.yCoord;
                    dst.coneType = this.coneType;
                    return dst;
                }

                deepClone() {
                    const json = CptJobInfo.toObject(this);
                    const dst = CptJobInfo.fromObject(json);
                    return dst;
                }
            }
            export type ICptJobInfo = CptJobInfo;


            export type FrictionValue_keys = 'begin' | 'end' | 'value';
            export interface FrictionValue_createType {
                begin?: number,
                end?: number,
                value?: number,
            }
            export interface FrictionValue_json {
                begin?: JsonNumber;
                end?: JsonNumber;
                value?: JsonNumber;
            }
            interface FrictionValue_json_in {
                __proto_name?: unknown;
                begin?: unknown;
                end?: unknown;
                value?: unknown;
            }
            export class FrictionValue {
                __proto_name = "ng.geotechnical.cpt.FrictionValue";
                begin: number = 0;
                end: number = 0;
                value: number = 0;

                static fromObject(src_unknown: unknown): FrictionValue {
                    const dst = new FrictionValue();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FrictionValue but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FrictionValue_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FrictionValue but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.begin !== undefined && src.begin !== null) {
                        if (typeof src.begin === "number" || src.begin === 'NaN' || src.begin === 'Infinity' || src.begin === '-Infinity') {
                            dst.begin = AsNum(src.begin);
                        }
                        else {
                            console.log('Expected begin of FrictionValue to be a number but was ', typeof src.begin, src.begin)
                        }
                    }
                    if (src.end !== undefined && src.end !== null) {
                        if (typeof src.end === "number" || src.end === 'NaN' || src.end === 'Infinity' || src.end === '-Infinity') {
                            dst.end = AsNum(src.end);
                        }
                        else {
                            console.log('Expected end of FrictionValue to be a number but was ', typeof src.end, src.end)
                        }
                    }
                    if (src.value !== undefined && src.value !== null) {
                        if (typeof src.value === "number" || src.value === 'NaN' || src.value === 'Infinity' || src.value === '-Infinity') {
                            dst.value = AsNum(src.value);
                        }
                        else {
                            console.log('Expected value of FrictionValue to be a number but was ', typeof src.value, src.value)
                        }
                    }
                    return dst;
                }

                static toObject(src: FrictionValue | null | undefined): FrictionValue_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.FrictionValue is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.FrictionValue") {
                        console.error('Expected ng.geotechnical.cpt.FrictionValue but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FrictionValue_json = {
                        begin: AsJsonNum(src.begin),
                        end: AsJsonNum(src.end),
                        value: AsJsonNum(src.value),
                    };
                    return dst;
                }

                static create(src?: FrictionValue_createType) {
                    const dst = new FrictionValue();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.begin !== undefined) {
                        dst.begin = src.begin;
                    }
                    if (src.end !== undefined) {
                        dst.end = src.end;
                    }
                    if (src.value !== undefined) {
                        dst.value = src.value;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FrictionValue();
                    dst.begin = this.begin;
                    dst.end = this.end;
                    dst.value = this.value;
                    return dst;
                }

                deepClone() {
                    const json = FrictionValue.toObject(this);
                    const dst = FrictionValue.fromObject(json);
                    return dst;
                }
            }
            export type IFrictionValue = FrictionValue;


            export type FrictionOverride_keys = 'values';
            export interface FrictionOverride_createType {
                values?: ng.geotechnical.cpt.FrictionValue[],
            }
            export interface FrictionOverride_json {
                values: ng.geotechnical.cpt.FrictionValue_json[];
            }
            interface FrictionOverride_json_in {
                __proto_name?: unknown;
                values?: unknown;
            }
            export class FrictionOverride {
                __proto_name = "ng.geotechnical.cpt.FrictionOverride";
                values: ng.geotechnical.cpt.FrictionValue[] = [];

                static fromObject(src_unknown: unknown): FrictionOverride {
                    const dst = new FrictionOverride();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FrictionOverride but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FrictionOverride_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FrictionOverride but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.values !== undefined && src.values !== null) {
                        if (Array.isArray(src.values)) {
                            for (const element of src.values) {
                                dst.values.push(ng.geotechnical.cpt.FrictionValue.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected values of FrictionOverride to be a array but was ', typeof src.values, src.values)
                        }
                    }
                    return dst;
                }

                static toObject(src: FrictionOverride | null | undefined): FrictionOverride_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.FrictionOverride is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.FrictionOverride") {
                        console.error('Expected ng.geotechnical.cpt.FrictionOverride but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FrictionOverride_json = {
                        values: new Array<ng.geotechnical.cpt.FrictionValue_json>(),
                    };
                    if (src.values !== null) {
                        for (const element of src.values) {
                            const parsed = ng.geotechnical.cpt.FrictionValue.toObject(element);
                            if(parsed === null) return null;
                            dst.values.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: FrictionOverride_createType) {
                    const dst = new FrictionOverride();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.values !== undefined) {
                        dst.values = src.values;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FrictionOverride();
                    dst.values = this.values;
                    return dst;
                }

                deepClone() {
                    const json = FrictionOverride.toObject(this);
                    const dst = FrictionOverride.fromObject(json);
                    return dst;
                }
            }
            export type IFrictionOverride = FrictionOverride;


            export type CptLog_keys = 'depth' | 'qcOrig' | 'sigmaV' | 'qcDig' | 'sigmaVDig';
            export interface CptLog_createType {
                depth?: number,
                qcOrig?: number,
                sigmaV?: number,
                qcDig?: number,
                sigmaVDig?: number,
            }
            export interface CptLog_json {
                depth?: JsonNumber;
                qcOrig?: JsonNumber;
                sigmaV?: JsonNumber;
                qcDig?: JsonNumber;
                sigmaVDig?: JsonNumber;
            }
            interface CptLog_json_in {
                __proto_name?: unknown;
                depth?: unknown;
                qcOrig?: unknown;
                sigmaV?: unknown;
                qcDig?: unknown;
                sigmaVDig?: unknown;
            }
            export class CptLog {
                __proto_name = "ng.geotechnical.cpt.CptLog";
                depth: number = 0;
                qcOrig: number = 0;
                sigmaV: number = 0;
                qcDig: number = 0;
                sigmaVDig: number = 0;

                static fromObject(src_unknown: unknown): CptLog {
                    const dst = new CptLog();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CptLog but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CptLog_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CptLog but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.depth !== undefined && src.depth !== null) {
                        if (typeof src.depth === "number" || src.depth === 'NaN' || src.depth === 'Infinity' || src.depth === '-Infinity') {
                            dst.depth = AsNum(src.depth);
                        }
                        else {
                            console.log('Expected depth of CptLog to be a number but was ', typeof src.depth, src.depth)
                        }
                    }
                    if (src.qcOrig !== undefined && src.qcOrig !== null) {
                        if (typeof src.qcOrig === "number" || src.qcOrig === 'NaN' || src.qcOrig === 'Infinity' || src.qcOrig === '-Infinity') {
                            dst.qcOrig = AsNum(src.qcOrig);
                        }
                        else {
                            console.log('Expected qcOrig of CptLog to be a number but was ', typeof src.qcOrig, src.qcOrig)
                        }
                    }
                    if (src.sigmaV !== undefined && src.sigmaV !== null) {
                        if (typeof src.sigmaV === "number" || src.sigmaV === 'NaN' || src.sigmaV === 'Infinity' || src.sigmaV === '-Infinity') {
                            dst.sigmaV = AsNum(src.sigmaV);
                        }
                        else {
                            console.log('Expected sigmaV of CptLog to be a number but was ', typeof src.sigmaV, src.sigmaV)
                        }
                    }
                    if (src.qcDig !== undefined && src.qcDig !== null) {
                        if (typeof src.qcDig === "number" || src.qcDig === 'NaN' || src.qcDig === 'Infinity' || src.qcDig === '-Infinity') {
                            dst.qcDig = AsNum(src.qcDig);
                        }
                        else {
                            console.log('Expected qcDig of CptLog to be a number but was ', typeof src.qcDig, src.qcDig)
                        }
                    }
                    if (src.sigmaVDig !== undefined && src.sigmaVDig !== null) {
                        if (typeof src.sigmaVDig === "number" || src.sigmaVDig === 'NaN' || src.sigmaVDig === 'Infinity' || src.sigmaVDig === '-Infinity') {
                            dst.sigmaVDig = AsNum(src.sigmaVDig);
                        }
                        else {
                            console.log('Expected sigmaVDig of CptLog to be a number but was ', typeof src.sigmaVDig, src.sigmaVDig)
                        }
                    }
                    return dst;
                }

                static toObject(src: CptLog | null | undefined): CptLog_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.CptLog is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.CptLog") {
                        console.error('Expected ng.geotechnical.cpt.CptLog but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CptLog_json = {
                        depth: AsJsonNum(src.depth),
                        qcOrig: AsJsonNum(src.qcOrig),
                        sigmaV: AsJsonNum(src.sigmaV),
                        qcDig: AsJsonNum(src.qcDig),
                        sigmaVDig: AsJsonNum(src.sigmaVDig),
                    };
                    return dst;
                }

                static create(src?: CptLog_createType) {
                    const dst = new CptLog();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.depth !== undefined) {
                        dst.depth = src.depth;
                    }
                    if (src.qcOrig !== undefined) {
                        dst.qcOrig = src.qcOrig;
                    }
                    if (src.sigmaV !== undefined) {
                        dst.sigmaV = src.sigmaV;
                    }
                    if (src.qcDig !== undefined) {
                        dst.qcDig = src.qcDig;
                    }
                    if (src.sigmaVDig !== undefined) {
                        dst.sigmaVDig = src.sigmaVDig;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CptLog();
                    dst.depth = this.depth;
                    dst.qcOrig = this.qcOrig;
                    dst.sigmaV = this.sigmaV;
                    dst.qcDig = this.qcDig;
                    dst.sigmaVDig = this.sigmaVDig;
                    return dst;
                }

                deepClone() {
                    const json = CptLog.toObject(this);
                    const dst = CptLog.fromObject(json);
                    return dst;
                }
            }
            export type ICptLog = CptLog;


            export type CptSettings_keys = 'delayCalc' | 'useAutoRanges' | 'minDepth' | 'maxDepth' | 'drawDepthInc' | 'minFric' | 'maxFric' | 'fricInc' | 'minCone' | 'maxCone' | 'coneInc' | 'maxSoilLayers' | 'maxIterations' | 'layerThickness' | 'depthAutoInc' | 'gammaW' | 'digitizerMaxCone' | 'digitizerMaxFriction' | 'digitizerMaxDepth' | 'comQbLimNenEn' | 'comQbLimNenGem' | 'comQsLim' | 'comQcLim' | 'com7JLess' | 'com7JMore' | 'tensQsLim' | 'tensQcLim' | 'tens7JLess' | 'tens7JMore' | 'tensCohesive' | 'tensRtd' | 'detailedStep' | 'widthStep' | 'cohesionMethod' | 'cohesionMin' | 'cohesionDistanceBelow' | 'loadTop';
            export interface CptSettings_createType {
                delayCalc?: boolean,
                useAutoRanges?: boolean,
                minDepth?: number,
                maxDepth?: number,
                drawDepthInc?: number,
                minFric?: number,
                maxFric?: number,
                fricInc?: number,
                minCone?: number,
                maxCone?: number,
                coneInc?: number,
                maxSoilLayers?: number,
                maxIterations?: number,
                layerThickness?: number,
                depthAutoInc?: number,
                gammaW?: number,
                digitizerMaxCone?: number,
                digitizerMaxFriction?: number,
                digitizerMaxDepth?: number,
                comQbLimNenEn?: number,
                comQbLimNenGem?: number,
                comQsLim?: number,
                comQcLim?: number,
                com7JLess?: number,
                com7JMore?: number,
                tensQsLim?: number,
                tensQcLim?: number,
                tens7JLess?: number,
                tens7JMore?: number,
                tensCohesive?: number,
                tensRtd?: number,
                detailedStep?: number,
                widthStep?: number,
                cohesionMethod?: ng.geotechnical.cpt.CohesionMethod,
                cohesionMin?: number,
                cohesionDistanceBelow?: number,
                loadTop?: boolean,
            }
            export interface CptSettings_json {
                delayCalc?: boolean;
                useAutoRanges?: boolean;
                minDepth?: JsonNumber;
                maxDepth?: JsonNumber;
                drawDepthInc?: JsonNumber;
                minFric?: JsonNumber;
                maxFric?: JsonNumber;
                fricInc?: JsonNumber;
                minCone?: JsonNumber;
                maxCone?: JsonNumber;
                coneInc?: JsonNumber;
                maxSoilLayers?: JsonNumber;
                maxIterations?: JsonNumber;
                layerThickness?: JsonNumber;
                depthAutoInc?: JsonNumber;
                gammaW?: JsonNumber;
                digitizerMaxCone?: JsonNumber;
                digitizerMaxFriction?: JsonNumber;
                digitizerMaxDepth?: JsonNumber;
                comQbLimNenEn?: JsonNumber;
                comQbLimNenGem?: JsonNumber;
                comQsLim?: JsonNumber;
                comQcLim?: JsonNumber;
                com7JLess?: JsonNumber;
                com7JMore?: JsonNumber;
                tensQsLim?: JsonNumber;
                tensQcLim?: JsonNumber;
                tens7JLess?: JsonNumber;
                tens7JMore?: JsonNumber;
                tensCohesive?: JsonNumber;
                tensRtd?: JsonNumber;
                detailedStep?: JsonNumber;
                widthStep?: JsonNumber;
                cohesionMethod?: string;
                cohesionMin?: JsonNumber;
                cohesionDistanceBelow?: JsonNumber;
                loadTop?: boolean;
            }
            interface CptSettings_json_in {
                __proto_name?: unknown;
                delayCalc?: unknown;
                useAutoRanges?: unknown;
                minDepth?: unknown;
                maxDepth?: unknown;
                drawDepthInc?: unknown;
                minFric?: unknown;
                maxFric?: unknown;
                fricInc?: unknown;
                minCone?: unknown;
                maxCone?: unknown;
                coneInc?: unknown;
                maxSoilLayers?: unknown;
                maxIterations?: unknown;
                layerThickness?: unknown;
                depthAutoInc?: unknown;
                gammaW?: unknown;
                digitizerMaxCone?: unknown;
                digitizerMaxFriction?: unknown;
                digitizerMaxDepth?: unknown;
                comQbLimNenEn?: unknown;
                comQbLimNenGem?: unknown;
                comQsLim?: unknown;
                comQcLim?: unknown;
                com7JLess?: unknown;
                com7JMore?: unknown;
                tensQsLim?: unknown;
                tensQcLim?: unknown;
                tens7JLess?: unknown;
                tens7JMore?: unknown;
                tensCohesive?: unknown;
                tensRtd?: unknown;
                detailedStep?: unknown;
                widthStep?: unknown;
                cohesionMethod?: unknown;
                cohesionMin?: unknown;
                cohesionDistanceBelow?: unknown;
                loadTop?: unknown;
            }
            export class CptSettings {
                __proto_name = "ng.geotechnical.cpt.CptSettings";
                delayCalc: boolean = false;
                useAutoRanges: boolean = false;
                minDepth: number = 0;
                maxDepth: number = 0;
                drawDepthInc: number = 0;
                minFric: number = 0;
                maxFric: number = 0;
                fricInc: number = 0;
                minCone: number = 0;
                maxCone: number = 0;
                coneInc: number = 0;
                maxSoilLayers: number = 0;
                maxIterations: number = 0;
                layerThickness: number = 0;
                depthAutoInc: number = 0;
                gammaW: number = 0;
                digitizerMaxCone: number = 0;
                digitizerMaxFriction: number = 0;
                digitizerMaxDepth: number = 0;
                comQbLimNenEn: number = 0;
                comQbLimNenGem: number = 0;
                comQsLim: number = 0;
                comQcLim: number = 0;
                com7JLess: number = 0;
                com7JMore: number = 0;
                tensQsLim: number = 0;
                tensQcLim: number = 0;
                tens7JLess: number = 0;
                tens7JMore: number = 0;
                tensCohesive: number = 0;
                tensRtd: number = 0;
                detailedStep: number = 0;
                widthStep: number = 0;
                cohesionMethod: ng.geotechnical.cpt.CohesionMethod = ng.geotechnical.cpt.CohesionMethod.COHESION_METHOD_UNDEFINED;
                cohesionMin: number = 0;
                cohesionDistanceBelow: number = 0;
                loadTop: boolean = false;

                static fromObject(src_unknown: unknown): CptSettings {
                    const dst = new CptSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CptSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CptSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CptSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.delayCalc !== undefined && src.delayCalc !== null) {
                        if (typeof src.delayCalc === "boolean") {
                            dst.delayCalc = src.delayCalc;
                        }
                        else {
                            console.log('Expected delayCalc of CptSettings to be a boolean but was ', typeof src.delayCalc, src.delayCalc)
                        }
                    }
                    if (src.useAutoRanges !== undefined && src.useAutoRanges !== null) {
                        if (typeof src.useAutoRanges === "boolean") {
                            dst.useAutoRanges = src.useAutoRanges;
                        }
                        else {
                            console.log('Expected useAutoRanges of CptSettings to be a boolean but was ', typeof src.useAutoRanges, src.useAutoRanges)
                        }
                    }
                    if (src.minDepth !== undefined && src.minDepth !== null) {
                        if (typeof src.minDepth === "number" || src.minDepth === 'NaN' || src.minDepth === 'Infinity' || src.minDepth === '-Infinity') {
                            dst.minDepth = AsNum(src.minDepth);
                        }
                        else {
                            console.log('Expected minDepth of CptSettings to be a number but was ', typeof src.minDepth, src.minDepth)
                        }
                    }
                    if (src.maxDepth !== undefined && src.maxDepth !== null) {
                        if (typeof src.maxDepth === "number" || src.maxDepth === 'NaN' || src.maxDepth === 'Infinity' || src.maxDepth === '-Infinity') {
                            dst.maxDepth = AsNum(src.maxDepth);
                        }
                        else {
                            console.log('Expected maxDepth of CptSettings to be a number but was ', typeof src.maxDepth, src.maxDepth)
                        }
                    }
                    if (src.drawDepthInc !== undefined && src.drawDepthInc !== null) {
                        if (typeof src.drawDepthInc === "number" || src.drawDepthInc === 'NaN' || src.drawDepthInc === 'Infinity' || src.drawDepthInc === '-Infinity') {
                            dst.drawDepthInc = AsNum(src.drawDepthInc);
                        }
                        else {
                            console.log('Expected drawDepthInc of CptSettings to be a number but was ', typeof src.drawDepthInc, src.drawDepthInc)
                        }
                    }
                    if (src.minFric !== undefined && src.minFric !== null) {
                        if (typeof src.minFric === "number" || src.minFric === 'NaN' || src.minFric === 'Infinity' || src.minFric === '-Infinity') {
                            dst.minFric = AsNum(src.minFric);
                        }
                        else {
                            console.log('Expected minFric of CptSettings to be a number but was ', typeof src.minFric, src.minFric)
                        }
                    }
                    if (src.maxFric !== undefined && src.maxFric !== null) {
                        if (typeof src.maxFric === "number" || src.maxFric === 'NaN' || src.maxFric === 'Infinity' || src.maxFric === '-Infinity') {
                            dst.maxFric = AsNum(src.maxFric);
                        }
                        else {
                            console.log('Expected maxFric of CptSettings to be a number but was ', typeof src.maxFric, src.maxFric)
                        }
                    }
                    if (src.fricInc !== undefined && src.fricInc !== null) {
                        if (typeof src.fricInc === "number" || src.fricInc === 'NaN' || src.fricInc === 'Infinity' || src.fricInc === '-Infinity') {
                            dst.fricInc = AsNum(src.fricInc);
                        }
                        else {
                            console.log('Expected fricInc of CptSettings to be a number but was ', typeof src.fricInc, src.fricInc)
                        }
                    }
                    if (src.minCone !== undefined && src.minCone !== null) {
                        if (typeof src.minCone === "number" || src.minCone === 'NaN' || src.minCone === 'Infinity' || src.minCone === '-Infinity') {
                            dst.minCone = AsNum(src.minCone);
                        }
                        else {
                            console.log('Expected minCone of CptSettings to be a number but was ', typeof src.minCone, src.minCone)
                        }
                    }
                    if (src.maxCone !== undefined && src.maxCone !== null) {
                        if (typeof src.maxCone === "number" || src.maxCone === 'NaN' || src.maxCone === 'Infinity' || src.maxCone === '-Infinity') {
                            dst.maxCone = AsNum(src.maxCone);
                        }
                        else {
                            console.log('Expected maxCone of CptSettings to be a number but was ', typeof src.maxCone, src.maxCone)
                        }
                    }
                    if (src.coneInc !== undefined && src.coneInc !== null) {
                        if (typeof src.coneInc === "number" || src.coneInc === 'NaN' || src.coneInc === 'Infinity' || src.coneInc === '-Infinity') {
                            dst.coneInc = AsNum(src.coneInc);
                        }
                        else {
                            console.log('Expected coneInc of CptSettings to be a number but was ', typeof src.coneInc, src.coneInc)
                        }
                    }
                    if (src.maxSoilLayers !== undefined && src.maxSoilLayers !== null) {
                        if (typeof src.maxSoilLayers === "number" || src.maxSoilLayers === 'NaN' || src.maxSoilLayers === 'Infinity' || src.maxSoilLayers === '-Infinity') {
                            dst.maxSoilLayers = NumberToInt("ng.geotechnical.cpt.CptSettings.max_soil_layers", AsNum(src.maxSoilLayers));
                        }
                        else {
                            console.log('Expected maxSoilLayers of CptSettings to be a number but was ', typeof src.maxSoilLayers, src.maxSoilLayers)
                        }
                    }
                    if (src.maxIterations !== undefined && src.maxIterations !== null) {
                        if (typeof src.maxIterations === "number" || src.maxIterations === 'NaN' || src.maxIterations === 'Infinity' || src.maxIterations === '-Infinity') {
                            dst.maxIterations = NumberToInt("ng.geotechnical.cpt.CptSettings.max_iterations", AsNum(src.maxIterations));
                        }
                        else {
                            console.log('Expected maxIterations of CptSettings to be a number but was ', typeof src.maxIterations, src.maxIterations)
                        }
                    }
                    if (src.layerThickness !== undefined && src.layerThickness !== null) {
                        if (typeof src.layerThickness === "number" || src.layerThickness === 'NaN' || src.layerThickness === 'Infinity' || src.layerThickness === '-Infinity') {
                            dst.layerThickness = AsNum(src.layerThickness);
                        }
                        else {
                            console.log('Expected layerThickness of CptSettings to be a number but was ', typeof src.layerThickness, src.layerThickness)
                        }
                    }
                    if (src.depthAutoInc !== undefined && src.depthAutoInc !== null) {
                        if (typeof src.depthAutoInc === "number" || src.depthAutoInc === 'NaN' || src.depthAutoInc === 'Infinity' || src.depthAutoInc === '-Infinity') {
                            dst.depthAutoInc = AsNum(src.depthAutoInc);
                        }
                        else {
                            console.log('Expected depthAutoInc of CptSettings to be a number but was ', typeof src.depthAutoInc, src.depthAutoInc)
                        }
                    }
                    if (src.gammaW !== undefined && src.gammaW !== null) {
                        if (typeof src.gammaW === "number" || src.gammaW === 'NaN' || src.gammaW === 'Infinity' || src.gammaW === '-Infinity') {
                            dst.gammaW = AsNum(src.gammaW);
                        }
                        else {
                            console.log('Expected gammaW of CptSettings to be a number but was ', typeof src.gammaW, src.gammaW)
                        }
                    }
                    if (src.digitizerMaxCone !== undefined && src.digitizerMaxCone !== null) {
                        if (typeof src.digitizerMaxCone === "number" || src.digitizerMaxCone === 'NaN' || src.digitizerMaxCone === 'Infinity' || src.digitizerMaxCone === '-Infinity') {
                            dst.digitizerMaxCone = AsNum(src.digitizerMaxCone);
                        }
                        else {
                            console.log('Expected digitizerMaxCone of CptSettings to be a number but was ', typeof src.digitizerMaxCone, src.digitizerMaxCone)
                        }
                    }
                    if (src.digitizerMaxFriction !== undefined && src.digitizerMaxFriction !== null) {
                        if (typeof src.digitizerMaxFriction === "number" || src.digitizerMaxFriction === 'NaN' || src.digitizerMaxFriction === 'Infinity' || src.digitizerMaxFriction === '-Infinity') {
                            dst.digitizerMaxFriction = AsNum(src.digitizerMaxFriction);
                        }
                        else {
                            console.log('Expected digitizerMaxFriction of CptSettings to be a number but was ', typeof src.digitizerMaxFriction, src.digitizerMaxFriction)
                        }
                    }
                    if (src.digitizerMaxDepth !== undefined && src.digitizerMaxDepth !== null) {
                        if (typeof src.digitizerMaxDepth === "number" || src.digitizerMaxDepth === 'NaN' || src.digitizerMaxDepth === 'Infinity' || src.digitizerMaxDepth === '-Infinity') {
                            dst.digitizerMaxDepth = AsNum(src.digitizerMaxDepth);
                        }
                        else {
                            console.log('Expected digitizerMaxDepth of CptSettings to be a number but was ', typeof src.digitizerMaxDepth, src.digitizerMaxDepth)
                        }
                    }
                    if (src.comQbLimNenEn !== undefined && src.comQbLimNenEn !== null) {
                        if (typeof src.comQbLimNenEn === "number" || src.comQbLimNenEn === 'NaN' || src.comQbLimNenEn === 'Infinity' || src.comQbLimNenEn === '-Infinity') {
                            dst.comQbLimNenEn = AsNum(src.comQbLimNenEn);
                        }
                        else {
                            console.log('Expected comQbLimNenEn of CptSettings to be a number but was ', typeof src.comQbLimNenEn, src.comQbLimNenEn)
                        }
                    }
                    if (src.comQbLimNenGem !== undefined && src.comQbLimNenGem !== null) {
                        if (typeof src.comQbLimNenGem === "number" || src.comQbLimNenGem === 'NaN' || src.comQbLimNenGem === 'Infinity' || src.comQbLimNenGem === '-Infinity') {
                            dst.comQbLimNenGem = AsNum(src.comQbLimNenGem);
                        }
                        else {
                            console.log('Expected comQbLimNenGem of CptSettings to be a number but was ', typeof src.comQbLimNenGem, src.comQbLimNenGem)
                        }
                    }
                    if (src.comQsLim !== undefined && src.comQsLim !== null) {
                        if (typeof src.comQsLim === "number" || src.comQsLim === 'NaN' || src.comQsLim === 'Infinity' || src.comQsLim === '-Infinity') {
                            dst.comQsLim = AsNum(src.comQsLim);
                        }
                        else {
                            console.log('Expected comQsLim of CptSettings to be a number but was ', typeof src.comQsLim, src.comQsLim)
                        }
                    }
                    if (src.comQcLim !== undefined && src.comQcLim !== null) {
                        if (typeof src.comQcLim === "number" || src.comQcLim === 'NaN' || src.comQcLim === 'Infinity' || src.comQcLim === '-Infinity') {
                            dst.comQcLim = AsNum(src.comQcLim);
                        }
                        else {
                            console.log('Expected comQcLim of CptSettings to be a number but was ', typeof src.comQcLim, src.comQcLim)
                        }
                    }
                    if (src.com7JLess !== undefined && src.com7JLess !== null) {
                        if (typeof src.com7JLess === "number" || src.com7JLess === 'NaN' || src.com7JLess === 'Infinity' || src.com7JLess === '-Infinity') {
                            dst.com7JLess = AsNum(src.com7JLess);
                        }
                        else {
                            console.log('Expected com7JLess of CptSettings to be a number but was ', typeof src.com7JLess, src.com7JLess)
                        }
                    }
                    if (src.com7JMore !== undefined && src.com7JMore !== null) {
                        if (typeof src.com7JMore === "number" || src.com7JMore === 'NaN' || src.com7JMore === 'Infinity' || src.com7JMore === '-Infinity') {
                            dst.com7JMore = AsNum(src.com7JMore);
                        }
                        else {
                            console.log('Expected com7JMore of CptSettings to be a number but was ', typeof src.com7JMore, src.com7JMore)
                        }
                    }
                    if (src.tensQsLim !== undefined && src.tensQsLim !== null) {
                        if (typeof src.tensQsLim === "number" || src.tensQsLim === 'NaN' || src.tensQsLim === 'Infinity' || src.tensQsLim === '-Infinity') {
                            dst.tensQsLim = AsNum(src.tensQsLim);
                        }
                        else {
                            console.log('Expected tensQsLim of CptSettings to be a number but was ', typeof src.tensQsLim, src.tensQsLim)
                        }
                    }
                    if (src.tensQcLim !== undefined && src.tensQcLim !== null) {
                        if (typeof src.tensQcLim === "number" || src.tensQcLim === 'NaN' || src.tensQcLim === 'Infinity' || src.tensQcLim === '-Infinity') {
                            dst.tensQcLim = AsNum(src.tensQcLim);
                        }
                        else {
                            console.log('Expected tensQcLim of CptSettings to be a number but was ', typeof src.tensQcLim, src.tensQcLim)
                        }
                    }
                    if (src.tens7JLess !== undefined && src.tens7JLess !== null) {
                        if (typeof src.tens7JLess === "number" || src.tens7JLess === 'NaN' || src.tens7JLess === 'Infinity' || src.tens7JLess === '-Infinity') {
                            dst.tens7JLess = AsNum(src.tens7JLess);
                        }
                        else {
                            console.log('Expected tens7JLess of CptSettings to be a number but was ', typeof src.tens7JLess, src.tens7JLess)
                        }
                    }
                    if (src.tens7JMore !== undefined && src.tens7JMore !== null) {
                        if (typeof src.tens7JMore === "number" || src.tens7JMore === 'NaN' || src.tens7JMore === 'Infinity' || src.tens7JMore === '-Infinity') {
                            dst.tens7JMore = AsNum(src.tens7JMore);
                        }
                        else {
                            console.log('Expected tens7JMore of CptSettings to be a number but was ', typeof src.tens7JMore, src.tens7JMore)
                        }
                    }
                    if (src.tensCohesive !== undefined && src.tensCohesive !== null) {
                        if (typeof src.tensCohesive === "number" || src.tensCohesive === 'NaN' || src.tensCohesive === 'Infinity' || src.tensCohesive === '-Infinity') {
                            dst.tensCohesive = AsNum(src.tensCohesive);
                        }
                        else {
                            console.log('Expected tensCohesive of CptSettings to be a number but was ', typeof src.tensCohesive, src.tensCohesive)
                        }
                    }
                    if (src.tensRtd !== undefined && src.tensRtd !== null) {
                        if (typeof src.tensRtd === "number" || src.tensRtd === 'NaN' || src.tensRtd === 'Infinity' || src.tensRtd === '-Infinity') {
                            dst.tensRtd = AsNum(src.tensRtd);
                        }
                        else {
                            console.log('Expected tensRtd of CptSettings to be a number but was ', typeof src.tensRtd, src.tensRtd)
                        }
                    }
                    if (src.detailedStep !== undefined && src.detailedStep !== null) {
                        if (typeof src.detailedStep === "number" || src.detailedStep === 'NaN' || src.detailedStep === 'Infinity' || src.detailedStep === '-Infinity') {
                            dst.detailedStep = AsNum(src.detailedStep);
                        }
                        else {
                            console.log('Expected detailedStep of CptSettings to be a number but was ', typeof src.detailedStep, src.detailedStep)
                        }
                    }
                    if (src.widthStep !== undefined && src.widthStep !== null) {
                        if (typeof src.widthStep === "number" || src.widthStep === 'NaN' || src.widthStep === 'Infinity' || src.widthStep === '-Infinity') {
                            dst.widthStep = AsNum(src.widthStep);
                        }
                        else {
                            console.log('Expected widthStep of CptSettings to be a number but was ', typeof src.widthStep, src.widthStep)
                        }
                    }
                    if (src.cohesionMethod !== undefined && src.cohesionMethod !== null) {
                        dst.cohesionMethod = ng.geotechnical.cpt.CohesionMethod_FromObject(src.cohesionMethod);
                    }
                    if (src.cohesionMin !== undefined && src.cohesionMin !== null) {
                        if (typeof src.cohesionMin === "number" || src.cohesionMin === 'NaN' || src.cohesionMin === 'Infinity' || src.cohesionMin === '-Infinity') {
                            dst.cohesionMin = AsNum(src.cohesionMin);
                        }
                        else {
                            console.log('Expected cohesionMin of CptSettings to be a number but was ', typeof src.cohesionMin, src.cohesionMin)
                        }
                    }
                    if (src.cohesionDistanceBelow !== undefined && src.cohesionDistanceBelow !== null) {
                        if (typeof src.cohesionDistanceBelow === "number" || src.cohesionDistanceBelow === 'NaN' || src.cohesionDistanceBelow === 'Infinity' || src.cohesionDistanceBelow === '-Infinity') {
                            dst.cohesionDistanceBelow = AsNum(src.cohesionDistanceBelow);
                        }
                        else {
                            console.log('Expected cohesionDistanceBelow of CptSettings to be a number but was ', typeof src.cohesionDistanceBelow, src.cohesionDistanceBelow)
                        }
                    }
                    if (src.loadTop !== undefined && src.loadTop !== null) {
                        if (typeof src.loadTop === "boolean") {
                            dst.loadTop = src.loadTop;
                        }
                        else {
                            console.log('Expected loadTop of CptSettings to be a boolean but was ', typeof src.loadTop, src.loadTop)
                        }
                    }
                    return dst;
                }

                static toObject(src: CptSettings | null | undefined): CptSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.CptSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.CptSettings") {
                        console.error('Expected ng.geotechnical.cpt.CptSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const cohesionMethod_obj = ng.geotechnical.cpt.CohesionMethod_ToObject(src.cohesionMethod);
                    if(cohesionMethod_obj === null) return null;

                    const dst : CptSettings_json = {
                        delayCalc: src.delayCalc,
                        useAutoRanges: src.useAutoRanges,
                        minDepth: AsJsonNum(src.minDepth),
                        maxDepth: AsJsonNum(src.maxDepth),
                        drawDepthInc: AsJsonNum(src.drawDepthInc),
                        minFric: AsJsonNum(src.minFric),
                        maxFric: AsJsonNum(src.maxFric),
                        fricInc: AsJsonNum(src.fricInc),
                        minCone: AsJsonNum(src.minCone),
                        maxCone: AsJsonNum(src.maxCone),
                        coneInc: AsJsonNum(src.coneInc),
                        maxSoilLayers: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptSettings.max_soil_layers", src.maxSoilLayers)),
                        maxIterations: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptSettings.max_iterations", src.maxIterations)),
                        layerThickness: AsJsonNum(src.layerThickness),
                        depthAutoInc: AsJsonNum(src.depthAutoInc),
                        gammaW: AsJsonNum(src.gammaW),
                        digitizerMaxCone: AsJsonNum(src.digitizerMaxCone),
                        digitizerMaxFriction: AsJsonNum(src.digitizerMaxFriction),
                        digitizerMaxDepth: AsJsonNum(src.digitizerMaxDepth),
                        comQbLimNenEn: AsJsonNum(src.comQbLimNenEn),
                        comQbLimNenGem: AsJsonNum(src.comQbLimNenGem),
                        comQsLim: AsJsonNum(src.comQsLim),
                        comQcLim: AsJsonNum(src.comQcLim),
                        com7JLess: AsJsonNum(src.com7JLess),
                        com7JMore: AsJsonNum(src.com7JMore),
                        tensQsLim: AsJsonNum(src.tensQsLim),
                        tensQcLim: AsJsonNum(src.tensQcLim),
                        tens7JLess: AsJsonNum(src.tens7JLess),
                        tens7JMore: AsJsonNum(src.tens7JMore),
                        tensCohesive: AsJsonNum(src.tensCohesive),
                        tensRtd: AsJsonNum(src.tensRtd),
                        detailedStep: AsJsonNum(src.detailedStep),
                        widthStep: AsJsonNum(src.widthStep),
                        cohesionMethod: cohesionMethod_obj,
                        cohesionMin: AsJsonNum(src.cohesionMin),
                        cohesionDistanceBelow: AsJsonNum(src.cohesionDistanceBelow),
                        loadTop: src.loadTop,
                    };
                    return dst;
                }

                static create(src?: CptSettings_createType) {
                    const dst = new CptSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.delayCalc !== undefined) {
                        dst.delayCalc = src.delayCalc;
                    }
                    if (src.useAutoRanges !== undefined) {
                        dst.useAutoRanges = src.useAutoRanges;
                    }
                    if (src.minDepth !== undefined) {
                        dst.minDepth = src.minDepth;
                    }
                    if (src.maxDepth !== undefined) {
                        dst.maxDepth = src.maxDepth;
                    }
                    if (src.drawDepthInc !== undefined) {
                        dst.drawDepthInc = src.drawDepthInc;
                    }
                    if (src.minFric !== undefined) {
                        dst.minFric = src.minFric;
                    }
                    if (src.maxFric !== undefined) {
                        dst.maxFric = src.maxFric;
                    }
                    if (src.fricInc !== undefined) {
                        dst.fricInc = src.fricInc;
                    }
                    if (src.minCone !== undefined) {
                        dst.minCone = src.minCone;
                    }
                    if (src.maxCone !== undefined) {
                        dst.maxCone = src.maxCone;
                    }
                    if (src.coneInc !== undefined) {
                        dst.coneInc = src.coneInc;
                    }
                    if (src.maxSoilLayers !== undefined) {
                        dst.maxSoilLayers = src.maxSoilLayers;
                    }
                    if (src.maxIterations !== undefined) {
                        dst.maxIterations = src.maxIterations;
                    }
                    if (src.layerThickness !== undefined) {
                        dst.layerThickness = src.layerThickness;
                    }
                    if (src.depthAutoInc !== undefined) {
                        dst.depthAutoInc = src.depthAutoInc;
                    }
                    if (src.gammaW !== undefined) {
                        dst.gammaW = src.gammaW;
                    }
                    if (src.digitizerMaxCone !== undefined) {
                        dst.digitizerMaxCone = src.digitizerMaxCone;
                    }
                    if (src.digitizerMaxFriction !== undefined) {
                        dst.digitizerMaxFriction = src.digitizerMaxFriction;
                    }
                    if (src.digitizerMaxDepth !== undefined) {
                        dst.digitizerMaxDepth = src.digitizerMaxDepth;
                    }
                    if (src.comQbLimNenEn !== undefined) {
                        dst.comQbLimNenEn = src.comQbLimNenEn;
                    }
                    if (src.comQbLimNenGem !== undefined) {
                        dst.comQbLimNenGem = src.comQbLimNenGem;
                    }
                    if (src.comQsLim !== undefined) {
                        dst.comQsLim = src.comQsLim;
                    }
                    if (src.comQcLim !== undefined) {
                        dst.comQcLim = src.comQcLim;
                    }
                    if (src.com7JLess !== undefined) {
                        dst.com7JLess = src.com7JLess;
                    }
                    if (src.com7JMore !== undefined) {
                        dst.com7JMore = src.com7JMore;
                    }
                    if (src.tensQsLim !== undefined) {
                        dst.tensQsLim = src.tensQsLim;
                    }
                    if (src.tensQcLim !== undefined) {
                        dst.tensQcLim = src.tensQcLim;
                    }
                    if (src.tens7JLess !== undefined) {
                        dst.tens7JLess = src.tens7JLess;
                    }
                    if (src.tens7JMore !== undefined) {
                        dst.tens7JMore = src.tens7JMore;
                    }
                    if (src.tensCohesive !== undefined) {
                        dst.tensCohesive = src.tensCohesive;
                    }
                    if (src.tensRtd !== undefined) {
                        dst.tensRtd = src.tensRtd;
                    }
                    if (src.detailedStep !== undefined) {
                        dst.detailedStep = src.detailedStep;
                    }
                    if (src.widthStep !== undefined) {
                        dst.widthStep = src.widthStep;
                    }
                    if (src.cohesionMethod !== undefined) {
                        dst.cohesionMethod = src.cohesionMethod;
                    }
                    if (src.cohesionMin !== undefined) {
                        dst.cohesionMin = src.cohesionMin;
                    }
                    if (src.cohesionDistanceBelow !== undefined) {
                        dst.cohesionDistanceBelow = src.cohesionDistanceBelow;
                    }
                    if (src.loadTop !== undefined) {
                        dst.loadTop = src.loadTop;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CptSettings();
                    dst.delayCalc = this.delayCalc;
                    dst.useAutoRanges = this.useAutoRanges;
                    dst.minDepth = this.minDepth;
                    dst.maxDepth = this.maxDepth;
                    dst.drawDepthInc = this.drawDepthInc;
                    dst.minFric = this.minFric;
                    dst.maxFric = this.maxFric;
                    dst.fricInc = this.fricInc;
                    dst.minCone = this.minCone;
                    dst.maxCone = this.maxCone;
                    dst.coneInc = this.coneInc;
                    dst.maxSoilLayers = this.maxSoilLayers;
                    dst.maxIterations = this.maxIterations;
                    dst.layerThickness = this.layerThickness;
                    dst.depthAutoInc = this.depthAutoInc;
                    dst.gammaW = this.gammaW;
                    dst.digitizerMaxCone = this.digitizerMaxCone;
                    dst.digitizerMaxFriction = this.digitizerMaxFriction;
                    dst.digitizerMaxDepth = this.digitizerMaxDepth;
                    dst.comQbLimNenEn = this.comQbLimNenEn;
                    dst.comQbLimNenGem = this.comQbLimNenGem;
                    dst.comQsLim = this.comQsLim;
                    dst.comQcLim = this.comQcLim;
                    dst.com7JLess = this.com7JLess;
                    dst.com7JMore = this.com7JMore;
                    dst.tensQsLim = this.tensQsLim;
                    dst.tensQcLim = this.tensQcLim;
                    dst.tens7JLess = this.tens7JLess;
                    dst.tens7JMore = this.tens7JMore;
                    dst.tensCohesive = this.tensCohesive;
                    dst.tensRtd = this.tensRtd;
                    dst.detailedStep = this.detailedStep;
                    dst.widthStep = this.widthStep;
                    dst.cohesionMethod = this.cohesionMethod;
                    dst.cohesionMin = this.cohesionMin;
                    dst.cohesionDistanceBelow = this.cohesionDistanceBelow;
                    dst.loadTop = this.loadTop;
                    return dst;
                }

                deepClone() {
                    const json = CptSettings.toObject(this);
                    const dst = CptSettings.fromObject(json);
                    return dst;
                }
            }
            export type ICptSettings = CptSettings;


            export type DiagramModificationSettings_keys = 'ocr' | 'vibration' | 'userReduction' | 'userReductionPercentage' | 'qcLim' | 'gammaW' | 'gammaY' | 'groundLevelOriginal' | 'groundLevelDig' | 'waterLevelOriginal' | 'waterLevelDig' | 'limit7JLess' | 'limit7JMore';
            export interface DiagramModificationSettings_createType {
                ocr?: number,
                vibration?: boolean,
                userReduction?: boolean,
                userReductionPercentage?: number,
                qcLim?: number,
                gammaW?: number,
                gammaY?: number,
                groundLevelOriginal?: number,
                groundLevelDig?: number,
                waterLevelOriginal?: number,
                waterLevelDig?: number,
                limit7JLess?: number,
                limit7JMore?: number,
            }
            export interface DiagramModificationSettings_json {
                ocr?: JsonNumber;
                vibration?: boolean;
                userReduction?: boolean;
                userReductionPercentage?: JsonNumber;
                qcLim?: JsonNumber;
                gammaW?: JsonNumber;
                gammaY?: JsonNumber;
                groundLevelOriginal?: JsonNumber;
                groundLevelDig?: JsonNumber;
                waterLevelOriginal?: JsonNumber;
                waterLevelDig?: JsonNumber;
                limit7JLess?: JsonNumber;
                limit7JMore?: JsonNumber;
            }
            interface DiagramModificationSettings_json_in {
                __proto_name?: unknown;
                ocr?: unknown;
                vibration?: unknown;
                userReduction?: unknown;
                userReductionPercentage?: unknown;
                qcLim?: unknown;
                gammaW?: unknown;
                gammaY?: unknown;
                groundLevelOriginal?: unknown;
                groundLevelDig?: unknown;
                waterLevelOriginal?: unknown;
                waterLevelDig?: unknown;
                limit7JLess?: unknown;
                limit7JMore?: unknown;
            }
            export class DiagramModificationSettings {
                __proto_name = "ng.geotechnical.cpt.DiagramModificationSettings";
                ocr: number = 0;
                vibration: boolean = false;
                userReduction: boolean = false;
                userReductionPercentage: number = 0;
                qcLim: number = 0;
                gammaW: number = 0;
                gammaY: number = 0;
                groundLevelOriginal: number = 0;
                groundLevelDig: number = 0;
                waterLevelOriginal: number = 0;
                waterLevelDig: number = 0;
                limit7JLess: number = 0;
                limit7JMore: number = 0;

                static fromObject(src_unknown: unknown): DiagramModificationSettings {
                    const dst = new DiagramModificationSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DiagramModificationSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DiagramModificationSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DiagramModificationSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ocr !== undefined && src.ocr !== null) {
                        if (typeof src.ocr === "number" || src.ocr === 'NaN' || src.ocr === 'Infinity' || src.ocr === '-Infinity') {
                            dst.ocr = AsNum(src.ocr);
                        }
                        else {
                            console.log('Expected ocr of DiagramModificationSettings to be a number but was ', typeof src.ocr, src.ocr)
                        }
                    }
                    if (src.vibration !== undefined && src.vibration !== null) {
                        if (typeof src.vibration === "boolean") {
                            dst.vibration = src.vibration;
                        }
                        else {
                            console.log('Expected vibration of DiagramModificationSettings to be a boolean but was ', typeof src.vibration, src.vibration)
                        }
                    }
                    if (src.userReduction !== undefined && src.userReduction !== null) {
                        if (typeof src.userReduction === "boolean") {
                            dst.userReduction = src.userReduction;
                        }
                        else {
                            console.log('Expected userReduction of DiagramModificationSettings to be a boolean but was ', typeof src.userReduction, src.userReduction)
                        }
                    }
                    if (src.userReductionPercentage !== undefined && src.userReductionPercentage !== null) {
                        if (typeof src.userReductionPercentage === "number" || src.userReductionPercentage === 'NaN' || src.userReductionPercentage === 'Infinity' || src.userReductionPercentage === '-Infinity') {
                            dst.userReductionPercentage = AsNum(src.userReductionPercentage);
                        }
                        else {
                            console.log('Expected userReductionPercentage of DiagramModificationSettings to be a number but was ', typeof src.userReductionPercentage, src.userReductionPercentage)
                        }
                    }
                    if (src.qcLim !== undefined && src.qcLim !== null) {
                        if (typeof src.qcLim === "number" || src.qcLim === 'NaN' || src.qcLim === 'Infinity' || src.qcLim === '-Infinity') {
                            dst.qcLim = AsNum(src.qcLim);
                        }
                        else {
                            console.log('Expected qcLim of DiagramModificationSettings to be a number but was ', typeof src.qcLim, src.qcLim)
                        }
                    }
                    if (src.gammaW !== undefined && src.gammaW !== null) {
                        if (typeof src.gammaW === "number" || src.gammaW === 'NaN' || src.gammaW === 'Infinity' || src.gammaW === '-Infinity') {
                            dst.gammaW = AsNum(src.gammaW);
                        }
                        else {
                            console.log('Expected gammaW of DiagramModificationSettings to be a number but was ', typeof src.gammaW, src.gammaW)
                        }
                    }
                    if (src.gammaY !== undefined && src.gammaY !== null) {
                        if (typeof src.gammaY === "number" || src.gammaY === 'NaN' || src.gammaY === 'Infinity' || src.gammaY === '-Infinity') {
                            dst.gammaY = AsNum(src.gammaY);
                        }
                        else {
                            console.log('Expected gammaY of DiagramModificationSettings to be a number but was ', typeof src.gammaY, src.gammaY)
                        }
                    }
                    if (src.groundLevelOriginal !== undefined && src.groundLevelOriginal !== null) {
                        if (typeof src.groundLevelOriginal === "number" || src.groundLevelOriginal === 'NaN' || src.groundLevelOriginal === 'Infinity' || src.groundLevelOriginal === '-Infinity') {
                            dst.groundLevelOriginal = AsNum(src.groundLevelOriginal);
                        }
                        else {
                            console.log('Expected groundLevelOriginal of DiagramModificationSettings to be a number but was ', typeof src.groundLevelOriginal, src.groundLevelOriginal)
                        }
                    }
                    if (src.groundLevelDig !== undefined && src.groundLevelDig !== null) {
                        if (typeof src.groundLevelDig === "number" || src.groundLevelDig === 'NaN' || src.groundLevelDig === 'Infinity' || src.groundLevelDig === '-Infinity') {
                            dst.groundLevelDig = AsNum(src.groundLevelDig);
                        }
                        else {
                            console.log('Expected groundLevelDig of DiagramModificationSettings to be a number but was ', typeof src.groundLevelDig, src.groundLevelDig)
                        }
                    }
                    if (src.waterLevelOriginal !== undefined && src.waterLevelOriginal !== null) {
                        if (typeof src.waterLevelOriginal === "number" || src.waterLevelOriginal === 'NaN' || src.waterLevelOriginal === 'Infinity' || src.waterLevelOriginal === '-Infinity') {
                            dst.waterLevelOriginal = AsNum(src.waterLevelOriginal);
                        }
                        else {
                            console.log('Expected waterLevelOriginal of DiagramModificationSettings to be a number but was ', typeof src.waterLevelOriginal, src.waterLevelOriginal)
                        }
                    }
                    if (src.waterLevelDig !== undefined && src.waterLevelDig !== null) {
                        if (typeof src.waterLevelDig === "number" || src.waterLevelDig === 'NaN' || src.waterLevelDig === 'Infinity' || src.waterLevelDig === '-Infinity') {
                            dst.waterLevelDig = AsNum(src.waterLevelDig);
                        }
                        else {
                            console.log('Expected waterLevelDig of DiagramModificationSettings to be a number but was ', typeof src.waterLevelDig, src.waterLevelDig)
                        }
                    }
                    if (src.limit7JLess !== undefined && src.limit7JLess !== null) {
                        if (typeof src.limit7JLess === "number" || src.limit7JLess === 'NaN' || src.limit7JLess === 'Infinity' || src.limit7JLess === '-Infinity') {
                            dst.limit7JLess = AsNum(src.limit7JLess);
                        }
                        else {
                            console.log('Expected limit7JLess of DiagramModificationSettings to be a number but was ', typeof src.limit7JLess, src.limit7JLess)
                        }
                    }
                    if (src.limit7JMore !== undefined && src.limit7JMore !== null) {
                        if (typeof src.limit7JMore === "number" || src.limit7JMore === 'NaN' || src.limit7JMore === 'Infinity' || src.limit7JMore === '-Infinity') {
                            dst.limit7JMore = AsNum(src.limit7JMore);
                        }
                        else {
                            console.log('Expected limit7JMore of DiagramModificationSettings to be a number but was ', typeof src.limit7JMore, src.limit7JMore)
                        }
                    }
                    return dst;
                }

                static toObject(src: DiagramModificationSettings | null | undefined): DiagramModificationSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.DiagramModificationSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.DiagramModificationSettings") {
                        console.error('Expected ng.geotechnical.cpt.DiagramModificationSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DiagramModificationSettings_json = {
                        ocr: AsJsonNum(src.ocr),
                        vibration: src.vibration,
                        userReduction: src.userReduction,
                        userReductionPercentage: AsJsonNum(src.userReductionPercentage),
                        qcLim: AsJsonNum(src.qcLim),
                        gammaW: AsJsonNum(src.gammaW),
                        gammaY: AsJsonNum(src.gammaY),
                        groundLevelOriginal: AsJsonNum(src.groundLevelOriginal),
                        groundLevelDig: AsJsonNum(src.groundLevelDig),
                        waterLevelOriginal: AsJsonNum(src.waterLevelOriginal),
                        waterLevelDig: AsJsonNum(src.waterLevelDig),
                        limit7JLess: AsJsonNum(src.limit7JLess),
                        limit7JMore: AsJsonNum(src.limit7JMore),
                    };
                    return dst;
                }

                static create(src?: DiagramModificationSettings_createType) {
                    const dst = new DiagramModificationSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ocr !== undefined) {
                        dst.ocr = src.ocr;
                    }
                    if (src.vibration !== undefined) {
                        dst.vibration = src.vibration;
                    }
                    if (src.userReduction !== undefined) {
                        dst.userReduction = src.userReduction;
                    }
                    if (src.userReductionPercentage !== undefined) {
                        dst.userReductionPercentage = src.userReductionPercentage;
                    }
                    if (src.qcLim !== undefined) {
                        dst.qcLim = src.qcLim;
                    }
                    if (src.gammaW !== undefined) {
                        dst.gammaW = src.gammaW;
                    }
                    if (src.gammaY !== undefined) {
                        dst.gammaY = src.gammaY;
                    }
                    if (src.groundLevelOriginal !== undefined) {
                        dst.groundLevelOriginal = src.groundLevelOriginal;
                    }
                    if (src.groundLevelDig !== undefined) {
                        dst.groundLevelDig = src.groundLevelDig;
                    }
                    if (src.waterLevelOriginal !== undefined) {
                        dst.waterLevelOriginal = src.waterLevelOriginal;
                    }
                    if (src.waterLevelDig !== undefined) {
                        dst.waterLevelDig = src.waterLevelDig;
                    }
                    if (src.limit7JLess !== undefined) {
                        dst.limit7JLess = src.limit7JLess;
                    }
                    if (src.limit7JMore !== undefined) {
                        dst.limit7JMore = src.limit7JMore;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DiagramModificationSettings();
                    dst.ocr = this.ocr;
                    dst.vibration = this.vibration;
                    dst.userReduction = this.userReduction;
                    dst.userReductionPercentage = this.userReductionPercentage;
                    dst.qcLim = this.qcLim;
                    dst.gammaW = this.gammaW;
                    dst.gammaY = this.gammaY;
                    dst.groundLevelOriginal = this.groundLevelOriginal;
                    dst.groundLevelDig = this.groundLevelDig;
                    dst.waterLevelOriginal = this.waterLevelOriginal;
                    dst.waterLevelDig = this.waterLevelDig;
                    dst.limit7JLess = this.limit7JLess;
                    dst.limit7JMore = this.limit7JMore;
                    return dst;
                }

                deepClone() {
                    const json = DiagramModificationSettings.toObject(this);
                    const dst = DiagramModificationSettings.fromObject(json);
                    return dst;
                }
            }
            export type IDiagramModificationSettings = DiagramModificationSettings;


            export type CptSoilLayer_keys = 'soilName' | 'soilMixture' | 'soilConsistence' | 'table' | 'generatedFlag' | 'color' | 'wcInf' | 'wcSup' | 'qcInf' | 'qcSup' | 'gamma' | 'gammaSat' | 'qc' | 'cp' | 'cs' | 'cc' | 'ca' | 'csw' | 'e100' | 'phi' | 'c' | 'cu' | 'a' | 'begin' | 'end' | 'friction' | 'cohesiveLayer' | 'qcModification' | 'regionGuid' | 'soilGuid';
            export interface CptSoilLayer_createType {
                soilName?: ng.geotechnical.cpt.SoilName,
                soilMixture?: ng.geotechnical.cpt.SoilMixture,
                soilConsistence?: ng.geotechnical.cpt.SoilConsistence,
                table?: ng.geotechnical.cpt.GeoDbMode,
                generatedFlag?: number,
                color?: number,
                wcInf?: number,
                wcSup?: number,
                qcInf?: number,
                qcSup?: number,
                gamma?: number,
                gammaSat?: number,
                qc?: number,
                cp?: number,
                cs?: number,
                cc?: number,
                ca?: number,
                csw?: number,
                e100?: number,
                phi?: number,
                c?: number,
                cu?: number,
                a?: number,
                begin?: number,
                end?: number,
                friction?: number,
                cohesiveLayer?: number,
                qcModification?: number,
                regionGuid?: string,
                soilGuid?: string,
            }
            export interface CptSoilLayer_json {
                soilName?: string;
                soilMixture?: string;
                soilConsistence?: string;
                table?: string;
                generatedFlag?: JsonNumber;
                color?: JsonNumber;
                wcInf?: JsonNumber;
                wcSup?: JsonNumber;
                qcInf?: JsonNumber;
                qcSup?: JsonNumber;
                gamma?: JsonNumber;
                gammaSat?: JsonNumber;
                qc?: JsonNumber;
                cp?: JsonNumber;
                cs?: JsonNumber;
                cc?: JsonNumber;
                ca?: JsonNumber;
                csw?: JsonNumber;
                e100?: JsonNumber;
                phi?: JsonNumber;
                c?: JsonNumber;
                cu?: JsonNumber;
                a?: JsonNumber;
                begin?: JsonNumber;
                end?: JsonNumber;
                friction?: JsonNumber;
                cohesiveLayer?: JsonNumber;
                qcModification?: JsonNumber;
                regionGuid?: string;
                soilGuid?: string;
            }
            interface CptSoilLayer_json_in {
                __proto_name?: unknown;
                soilName?: unknown;
                soilMixture?: unknown;
                soilConsistence?: unknown;
                table?: unknown;
                generatedFlag?: unknown;
                color?: unknown;
                wcInf?: unknown;
                wcSup?: unknown;
                qcInf?: unknown;
                qcSup?: unknown;
                gamma?: unknown;
                gammaSat?: unknown;
                qc?: unknown;
                cp?: unknown;
                cs?: unknown;
                cc?: unknown;
                ca?: unknown;
                csw?: unknown;
                e100?: unknown;
                phi?: unknown;
                c?: unknown;
                cu?: unknown;
                a?: unknown;
                begin?: unknown;
                end?: unknown;
                friction?: unknown;
                cohesiveLayer?: unknown;
                qcModification?: unknown;
                regionGuid?: unknown;
                soilGuid?: unknown;
            }
            export class CptSoilLayer {
                __proto_name = "ng.geotechnical.cpt.CptSoilLayer";
                soilName: ng.geotechnical.cpt.SoilName = ng.geotechnical.cpt.SoilName.SOIL_NAME_UNDEF;
                soilMixture: ng.geotechnical.cpt.SoilMixture = ng.geotechnical.cpt.SoilMixture.SOIL_MIXTURE_UNDEF;
                soilConsistence: ng.geotechnical.cpt.SoilConsistence = ng.geotechnical.cpt.SoilConsistence.SOIL_CONSISTENCE_UNSPECIFIED;
                table: ng.geotechnical.cpt.GeoDbMode = ng.geotechnical.cpt.GeoDbMode.GEO_DB_MODE_DEFAULT;
                generatedFlag: number = 0;
                color: number = 0;
                wcInf: number = 0;
                wcSup: number = 0;
                qcInf: number = 0;
                qcSup: number = 0;
                gamma: number = 0;
                gammaSat: number = 0;
                qc: number = 0;
                cp: number = 0;
                cs: number = 0;
                cc: number = 0;
                ca: number = 0;
                csw: number = 0;
                e100: number = 0;
                phi: number = 0;
                c: number = 0;
                cu: number = 0;
                a: number = 0;
                begin: number = 0;
                end: number = 0;
                friction: number = 0;
                cohesiveLayer: number = 0;
                qcModification: number = 0;
                regionGuid: string = "";
                soilGuid: string = "";

                static fromObject(src_unknown: unknown): CptSoilLayer {
                    const dst = new CptSoilLayer();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CptSoilLayer but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CptSoilLayer_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CptSoilLayer but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.soilName !== undefined && src.soilName !== null) {
                        dst.soilName = ng.geotechnical.cpt.SoilName_FromObject(src.soilName);
                    }
                    if (src.soilMixture !== undefined && src.soilMixture !== null) {
                        dst.soilMixture = ng.geotechnical.cpt.SoilMixture_FromObject(src.soilMixture);
                    }
                    if (src.soilConsistence !== undefined && src.soilConsistence !== null) {
                        dst.soilConsistence = ng.geotechnical.cpt.SoilConsistence_FromObject(src.soilConsistence);
                    }
                    if (src.table !== undefined && src.table !== null) {
                        dst.table = ng.geotechnical.cpt.GeoDbMode_FromObject(src.table);
                    }
                    if (src.generatedFlag !== undefined && src.generatedFlag !== null) {
                        if (typeof src.generatedFlag === "number" || src.generatedFlag === 'NaN' || src.generatedFlag === 'Infinity' || src.generatedFlag === '-Infinity') {
                            dst.generatedFlag = NumberToInt("ng.geotechnical.cpt.CptSoilLayer.generated_flag", AsNum(src.generatedFlag));
                        }
                        else {
                            console.log('Expected generatedFlag of CptSoilLayer to be a number but was ', typeof src.generatedFlag, src.generatedFlag)
                        }
                    }
                    if (src.color !== undefined && src.color !== null) {
                        if (typeof src.color === "number" || src.color === 'NaN' || src.color === 'Infinity' || src.color === '-Infinity') {
                            dst.color = NumberToInt("ng.geotechnical.cpt.CptSoilLayer.color", AsNum(src.color));
                        }
                        else {
                            console.log('Expected color of CptSoilLayer to be a number but was ', typeof src.color, src.color)
                        }
                    }
                    if (src.wcInf !== undefined && src.wcInf !== null) {
                        if (typeof src.wcInf === "number" || src.wcInf === 'NaN' || src.wcInf === 'Infinity' || src.wcInf === '-Infinity') {
                            dst.wcInf = AsNum(src.wcInf);
                        }
                        else {
                            console.log('Expected wcInf of CptSoilLayer to be a number but was ', typeof src.wcInf, src.wcInf)
                        }
                    }
                    if (src.wcSup !== undefined && src.wcSup !== null) {
                        if (typeof src.wcSup === "number" || src.wcSup === 'NaN' || src.wcSup === 'Infinity' || src.wcSup === '-Infinity') {
                            dst.wcSup = AsNum(src.wcSup);
                        }
                        else {
                            console.log('Expected wcSup of CptSoilLayer to be a number but was ', typeof src.wcSup, src.wcSup)
                        }
                    }
                    if (src.qcInf !== undefined && src.qcInf !== null) {
                        if (typeof src.qcInf === "number" || src.qcInf === 'NaN' || src.qcInf === 'Infinity' || src.qcInf === '-Infinity') {
                            dst.qcInf = AsNum(src.qcInf);
                        }
                        else {
                            console.log('Expected qcInf of CptSoilLayer to be a number but was ', typeof src.qcInf, src.qcInf)
                        }
                    }
                    if (src.qcSup !== undefined && src.qcSup !== null) {
                        if (typeof src.qcSup === "number" || src.qcSup === 'NaN' || src.qcSup === 'Infinity' || src.qcSup === '-Infinity') {
                            dst.qcSup = AsNum(src.qcSup);
                        }
                        else {
                            console.log('Expected qcSup of CptSoilLayer to be a number but was ', typeof src.qcSup, src.qcSup)
                        }
                    }
                    if (src.gamma !== undefined && src.gamma !== null) {
                        if (typeof src.gamma === "number" || src.gamma === 'NaN' || src.gamma === 'Infinity' || src.gamma === '-Infinity') {
                            dst.gamma = AsNum(src.gamma);
                        }
                        else {
                            console.log('Expected gamma of CptSoilLayer to be a number but was ', typeof src.gamma, src.gamma)
                        }
                    }
                    if (src.gammaSat !== undefined && src.gammaSat !== null) {
                        if (typeof src.gammaSat === "number" || src.gammaSat === 'NaN' || src.gammaSat === 'Infinity' || src.gammaSat === '-Infinity') {
                            dst.gammaSat = AsNum(src.gammaSat);
                        }
                        else {
                            console.log('Expected gammaSat of CptSoilLayer to be a number but was ', typeof src.gammaSat, src.gammaSat)
                        }
                    }
                    if (src.qc !== undefined && src.qc !== null) {
                        if (typeof src.qc === "number" || src.qc === 'NaN' || src.qc === 'Infinity' || src.qc === '-Infinity') {
                            dst.qc = AsNum(src.qc);
                        }
                        else {
                            console.log('Expected qc of CptSoilLayer to be a number but was ', typeof src.qc, src.qc)
                        }
                    }
                    if (src.cp !== undefined && src.cp !== null) {
                        if (typeof src.cp === "number" || src.cp === 'NaN' || src.cp === 'Infinity' || src.cp === '-Infinity') {
                            dst.cp = AsNum(src.cp);
                        }
                        else {
                            console.log('Expected cp of CptSoilLayer to be a number but was ', typeof src.cp, src.cp)
                        }
                    }
                    if (src.cs !== undefined && src.cs !== null) {
                        if (typeof src.cs === "number" || src.cs === 'NaN' || src.cs === 'Infinity' || src.cs === '-Infinity') {
                            dst.cs = AsNum(src.cs);
                        }
                        else {
                            console.log('Expected cs of CptSoilLayer to be a number but was ', typeof src.cs, src.cs)
                        }
                    }
                    if (src.cc !== undefined && src.cc !== null) {
                        if (typeof src.cc === "number" || src.cc === 'NaN' || src.cc === 'Infinity' || src.cc === '-Infinity') {
                            dst.cc = AsNum(src.cc);
                        }
                        else {
                            console.log('Expected cc of CptSoilLayer to be a number but was ', typeof src.cc, src.cc)
                        }
                    }
                    if (src.ca !== undefined && src.ca !== null) {
                        if (typeof src.ca === "number" || src.ca === 'NaN' || src.ca === 'Infinity' || src.ca === '-Infinity') {
                            dst.ca = AsNum(src.ca);
                        }
                        else {
                            console.log('Expected ca of CptSoilLayer to be a number but was ', typeof src.ca, src.ca)
                        }
                    }
                    if (src.csw !== undefined && src.csw !== null) {
                        if (typeof src.csw === "number" || src.csw === 'NaN' || src.csw === 'Infinity' || src.csw === '-Infinity') {
                            dst.csw = AsNum(src.csw);
                        }
                        else {
                            console.log('Expected csw of CptSoilLayer to be a number but was ', typeof src.csw, src.csw)
                        }
                    }
                    if (src.e100 !== undefined && src.e100 !== null) {
                        if (typeof src.e100 === "number" || src.e100 === 'NaN' || src.e100 === 'Infinity' || src.e100 === '-Infinity') {
                            dst.e100 = AsNum(src.e100);
                        }
                        else {
                            console.log('Expected e100 of CptSoilLayer to be a number but was ', typeof src.e100, src.e100)
                        }
                    }
                    if (src.phi !== undefined && src.phi !== null) {
                        if (typeof src.phi === "number" || src.phi === 'NaN' || src.phi === 'Infinity' || src.phi === '-Infinity') {
                            dst.phi = AsNum(src.phi);
                        }
                        else {
                            console.log('Expected phi of CptSoilLayer to be a number but was ', typeof src.phi, src.phi)
                        }
                    }
                    if (src.c !== undefined && src.c !== null) {
                        if (typeof src.c === "number" || src.c === 'NaN' || src.c === 'Infinity' || src.c === '-Infinity') {
                            dst.c = AsNum(src.c);
                        }
                        else {
                            console.log('Expected c of CptSoilLayer to be a number but was ', typeof src.c, src.c)
                        }
                    }
                    if (src.cu !== undefined && src.cu !== null) {
                        if (typeof src.cu === "number" || src.cu === 'NaN' || src.cu === 'Infinity' || src.cu === '-Infinity') {
                            dst.cu = AsNum(src.cu);
                        }
                        else {
                            console.log('Expected cu of CptSoilLayer to be a number but was ', typeof src.cu, src.cu)
                        }
                    }
                    if (src.a !== undefined && src.a !== null) {
                        if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                            dst.a = AsNum(src.a);
                        }
                        else {
                            console.log('Expected a of CptSoilLayer to be a number but was ', typeof src.a, src.a)
                        }
                    }
                    if (src.begin !== undefined && src.begin !== null) {
                        if (typeof src.begin === "number" || src.begin === 'NaN' || src.begin === 'Infinity' || src.begin === '-Infinity') {
                            dst.begin = AsNum(src.begin);
                        }
                        else {
                            console.log('Expected begin of CptSoilLayer to be a number but was ', typeof src.begin, src.begin)
                        }
                    }
                    if (src.end !== undefined && src.end !== null) {
                        if (typeof src.end === "number" || src.end === 'NaN' || src.end === 'Infinity' || src.end === '-Infinity') {
                            dst.end = AsNum(src.end);
                        }
                        else {
                            console.log('Expected end of CptSoilLayer to be a number but was ', typeof src.end, src.end)
                        }
                    }
                    if (src.friction !== undefined && src.friction !== null) {
                        if (typeof src.friction === "number" || src.friction === 'NaN' || src.friction === 'Infinity' || src.friction === '-Infinity') {
                            dst.friction = AsNum(src.friction);
                        }
                        else {
                            console.log('Expected friction of CptSoilLayer to be a number but was ', typeof src.friction, src.friction)
                        }
                    }
                    if (src.cohesiveLayer !== undefined && src.cohesiveLayer !== null) {
                        if (typeof src.cohesiveLayer === "number" || src.cohesiveLayer === 'NaN' || src.cohesiveLayer === 'Infinity' || src.cohesiveLayer === '-Infinity') {
                            dst.cohesiveLayer = NumberToInt("ng.geotechnical.cpt.CptSoilLayer.cohesive_layer", AsNum(src.cohesiveLayer));
                        }
                        else {
                            console.log('Expected cohesiveLayer of CptSoilLayer to be a number but was ', typeof src.cohesiveLayer, src.cohesiveLayer)
                        }
                    }
                    if (src.qcModification !== undefined && src.qcModification !== null) {
                        if (typeof src.qcModification === "number" || src.qcModification === 'NaN' || src.qcModification === 'Infinity' || src.qcModification === '-Infinity') {
                            dst.qcModification = NumberToInt("ng.geotechnical.cpt.CptSoilLayer.qc_modification", AsNum(src.qcModification));
                        }
                        else {
                            console.log('Expected qcModification of CptSoilLayer to be a number but was ', typeof src.qcModification, src.qcModification)
                        }
                    }
                    if (src.regionGuid !== undefined && src.regionGuid !== null) {
                        if (typeof src.regionGuid === "string") {
                            dst.regionGuid = src.regionGuid;
                        }
                        else {
                            console.log('Expected regionGuid of CptSoilLayer to be a string but was ', typeof src.regionGuid, src.regionGuid)
                        }
                    }
                    if (src.soilGuid !== undefined && src.soilGuid !== null) {
                        if (typeof src.soilGuid === "string") {
                            dst.soilGuid = src.soilGuid;
                        }
                        else {
                            console.log('Expected soilGuid of CptSoilLayer to be a string but was ', typeof src.soilGuid, src.soilGuid)
                        }
                    }
                    return dst;
                }

                static toObject(src: CptSoilLayer | null | undefined): CptSoilLayer_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.CptSoilLayer is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.CptSoilLayer") {
                        console.error('Expected ng.geotechnical.cpt.CptSoilLayer but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const soilName_obj = ng.geotechnical.cpt.SoilName_ToObject(src.soilName);
                    if(soilName_obj === null) return null;

                    const soilMixture_obj = ng.geotechnical.cpt.SoilMixture_ToObject(src.soilMixture);
                    if(soilMixture_obj === null) return null;

                    const soilConsistence_obj = ng.geotechnical.cpt.SoilConsistence_ToObject(src.soilConsistence);
                    if(soilConsistence_obj === null) return null;

                    const table_obj = ng.geotechnical.cpt.GeoDbMode_ToObject(src.table);
                    if(table_obj === null) return null;

                    const dst : CptSoilLayer_json = {
                        soilName: soilName_obj,
                        soilMixture: soilMixture_obj,
                        soilConsistence: soilConsistence_obj,
                        table: table_obj,
                        generatedFlag: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptSoilLayer.generated_flag", src.generatedFlag)),
                        color: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptSoilLayer.color", src.color)),
                        wcInf: AsJsonNum(src.wcInf),
                        wcSup: AsJsonNum(src.wcSup),
                        qcInf: AsJsonNum(src.qcInf),
                        qcSup: AsJsonNum(src.qcSup),
                        gamma: AsJsonNum(src.gamma),
                        gammaSat: AsJsonNum(src.gammaSat),
                        qc: AsJsonNum(src.qc),
                        cp: AsJsonNum(src.cp),
                        cs: AsJsonNum(src.cs),
                        cc: AsJsonNum(src.cc),
                        ca: AsJsonNum(src.ca),
                        csw: AsJsonNum(src.csw),
                        e100: AsJsonNum(src.e100),
                        phi: AsJsonNum(src.phi),
                        c: AsJsonNum(src.c),
                        cu: AsJsonNum(src.cu),
                        a: AsJsonNum(src.a),
                        begin: AsJsonNum(src.begin),
                        end: AsJsonNum(src.end),
                        friction: AsJsonNum(src.friction),
                        cohesiveLayer: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptSoilLayer.cohesive_layer", src.cohesiveLayer)),
                        qcModification: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptSoilLayer.qc_modification", src.qcModification)),
                        regionGuid: src.regionGuid,
                        soilGuid: src.soilGuid,
                    };
                    return dst;
                }

                static create(src?: CptSoilLayer_createType) {
                    const dst = new CptSoilLayer();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.soilName !== undefined) {
                        dst.soilName = src.soilName;
                    }
                    if (src.soilMixture !== undefined) {
                        dst.soilMixture = src.soilMixture;
                    }
                    if (src.soilConsistence !== undefined) {
                        dst.soilConsistence = src.soilConsistence;
                    }
                    if (src.table !== undefined) {
                        dst.table = src.table;
                    }
                    if (src.generatedFlag !== undefined) {
                        dst.generatedFlag = src.generatedFlag;
                    }
                    if (src.color !== undefined) {
                        dst.color = src.color;
                    }
                    if (src.wcInf !== undefined) {
                        dst.wcInf = src.wcInf;
                    }
                    if (src.wcSup !== undefined) {
                        dst.wcSup = src.wcSup;
                    }
                    if (src.qcInf !== undefined) {
                        dst.qcInf = src.qcInf;
                    }
                    if (src.qcSup !== undefined) {
                        dst.qcSup = src.qcSup;
                    }
                    if (src.gamma !== undefined) {
                        dst.gamma = src.gamma;
                    }
                    if (src.gammaSat !== undefined) {
                        dst.gammaSat = src.gammaSat;
                    }
                    if (src.qc !== undefined) {
                        dst.qc = src.qc;
                    }
                    if (src.cp !== undefined) {
                        dst.cp = src.cp;
                    }
                    if (src.cs !== undefined) {
                        dst.cs = src.cs;
                    }
                    if (src.cc !== undefined) {
                        dst.cc = src.cc;
                    }
                    if (src.ca !== undefined) {
                        dst.ca = src.ca;
                    }
                    if (src.csw !== undefined) {
                        dst.csw = src.csw;
                    }
                    if (src.e100 !== undefined) {
                        dst.e100 = src.e100;
                    }
                    if (src.phi !== undefined) {
                        dst.phi = src.phi;
                    }
                    if (src.c !== undefined) {
                        dst.c = src.c;
                    }
                    if (src.cu !== undefined) {
                        dst.cu = src.cu;
                    }
                    if (src.a !== undefined) {
                        dst.a = src.a;
                    }
                    if (src.begin !== undefined) {
                        dst.begin = src.begin;
                    }
                    if (src.end !== undefined) {
                        dst.end = src.end;
                    }
                    if (src.friction !== undefined) {
                        dst.friction = src.friction;
                    }
                    if (src.cohesiveLayer !== undefined) {
                        dst.cohesiveLayer = src.cohesiveLayer;
                    }
                    if (src.qcModification !== undefined) {
                        dst.qcModification = src.qcModification;
                    }
                    if (src.regionGuid !== undefined) {
                        dst.regionGuid = src.regionGuid;
                    }
                    if (src.soilGuid !== undefined) {
                        dst.soilGuid = src.soilGuid;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CptSoilLayer();
                    dst.soilName = this.soilName;
                    dst.soilMixture = this.soilMixture;
                    dst.soilConsistence = this.soilConsistence;
                    dst.table = this.table;
                    dst.generatedFlag = this.generatedFlag;
                    dst.color = this.color;
                    dst.wcInf = this.wcInf;
                    dst.wcSup = this.wcSup;
                    dst.qcInf = this.qcInf;
                    dst.qcSup = this.qcSup;
                    dst.gamma = this.gamma;
                    dst.gammaSat = this.gammaSat;
                    dst.qc = this.qc;
                    dst.cp = this.cp;
                    dst.cs = this.cs;
                    dst.cc = this.cc;
                    dst.ca = this.ca;
                    dst.csw = this.csw;
                    dst.e100 = this.e100;
                    dst.phi = this.phi;
                    dst.c = this.c;
                    dst.cu = this.cu;
                    dst.a = this.a;
                    dst.begin = this.begin;
                    dst.end = this.end;
                    dst.friction = this.friction;
                    dst.cohesiveLayer = this.cohesiveLayer;
                    dst.qcModification = this.qcModification;
                    dst.regionGuid = this.regionGuid;
                    dst.soilGuid = this.soilGuid;
                    return dst;
                }

                deepClone() {
                    const json = CptSoilLayer.toObject(this);
                    const dst = CptSoilLayer.fromObject(json);
                    return dst;
                }
            }
            export type ICptSoilLayer = CptSoilLayer;


            export type CptMember_keys = 'id' | 'groundLevelUser' | 'groundLevel' | 'waterLevel' | 'lastFricValState' | 'lastAlphaZValState' | 'groundLevelType' | 'analysisType' | 'regionGuid' | 'regionLabel' | 'diagram' | 'diagramPurpose1' | 'diagramPurpose2' | 'frictionOverride' | 'jobInfo' | 'selConePurpose' | 'conePurpose1' | 'conePurpose2' | 'drawDepthResults' | 'drawFrictionData' | 'selectedValue' | 'diggingLog' | 'soilProfile' | 'materialsFromRegion';
            export interface CptMember_createType {
                id?: ng.utils.ID | null,
                groundLevelUser?: boolean,
                groundLevel?: number,
                waterLevel?: number,
                lastFricValState?: number,
                lastAlphaZValState?: number,
                groundLevelType?: ng.geotechnical.cpt.GroundLevelType,
                analysisType?: ng.geotechnical.cpt.AnalysisType,
                regionGuid?: string,
                regionLabel?: string,
                diagram?: ng.geotechnical.cpt.CptDiagram | null,
                diagramPurpose1?: ng.geotechnical.cpt.CptDiagram | null,
                diagramPurpose2?: ng.geotechnical.cpt.CptDiagram | null,
                frictionOverride?: ng.geotechnical.cpt.FrictionOverride | null,
                jobInfo?: ng.geotechnical.cpt.CptJobInfo | null,
                selConePurpose?: number,
                conePurpose1?: number,
                conePurpose2?: number,
                drawDepthResults?: boolean,
                drawFrictionData?: boolean,
                selectedValue?: number,
                diggingLog?: ng.geotechnical.cpt.CptLog[],
                soilProfile?: ng.geotechnical.cpt.CptSoilLayer[],
                materialsFromRegion?: ng.geotechnical.cpt.CptSoilLayer[],
            }
            export interface CptMember_json {
                id?: ng.utils.ID_json;
                groundLevelUser?: boolean;
                groundLevel?: JsonNumber;
                waterLevel?: JsonNumber;
                lastFricValState?: JsonNumber;
                lastAlphaZValState?: JsonNumber;
                groundLevelType?: string;
                analysisType?: string;
                regionGuid?: string;
                regionLabel?: string;
                diagram?: ng.geotechnical.cpt.CptDiagram_json;
                diagramPurpose1?: ng.geotechnical.cpt.CptDiagram_json;
                diagramPurpose2?: ng.geotechnical.cpt.CptDiagram_json;
                frictionOverride?: ng.geotechnical.cpt.FrictionOverride_json;
                jobInfo?: ng.geotechnical.cpt.CptJobInfo_json;
                selConePurpose?: JsonNumber;
                conePurpose1?: JsonNumber;
                conePurpose2?: JsonNumber;
                drawDepthResults?: boolean;
                drawFrictionData?: boolean;
                selectedValue?: JsonNumber;
                diggingLog: ng.geotechnical.cpt.CptLog_json[];
                soilProfile: ng.geotechnical.cpt.CptSoilLayer_json[];
                materialsFromRegion: ng.geotechnical.cpt.CptSoilLayer_json[];
            }
            interface CptMember_json_in {
                __proto_name?: unknown;
                id?: unknown;
                groundLevelUser?: unknown;
                groundLevel?: unknown;
                waterLevel?: unknown;
                lastFricValState?: unknown;
                lastAlphaZValState?: unknown;
                groundLevelType?: unknown;
                analysisType?: unknown;
                regionGuid?: unknown;
                regionLabel?: unknown;
                diagram?: unknown;
                diagramPurpose1?: unknown;
                diagramPurpose2?: unknown;
                frictionOverride?: unknown;
                jobInfo?: unknown;
                selConePurpose?: unknown;
                conePurpose1?: unknown;
                conePurpose2?: unknown;
                drawDepthResults?: unknown;
                drawFrictionData?: unknown;
                selectedValue?: unknown;
                diggingLog?: unknown;
                soilProfile?: unknown;
                materialsFromRegion?: unknown;
            }
            export class CptMember {
                __proto_name = "ng.geotechnical.cpt.CptMember";
                id: ng.utils.ID | null = null;
                groundLevelUser: boolean = false;
                groundLevel: number = 0;
                waterLevel: number = 0;
                lastFricValState: number = 0;
                lastAlphaZValState: number = 0;
                groundLevelType: ng.geotechnical.cpt.GroundLevelType = ng.geotechnical.cpt.GroundLevelType.GROUND_LEVEL_TYPE_UNDEF;
                analysisType: ng.geotechnical.cpt.AnalysisType = ng.geotechnical.cpt.AnalysisType.ANALYSIS_TYPE_UNSPECIFIED;
                regionGuid: string = "";
                regionLabel: string = "";
                diagram: ng.geotechnical.cpt.CptDiagram | null = null;
                diagramPurpose1: ng.geotechnical.cpt.CptDiagram | null = null;
                diagramPurpose2: ng.geotechnical.cpt.CptDiagram | null = null;
                frictionOverride: ng.geotechnical.cpt.FrictionOverride | null = null;
                jobInfo: ng.geotechnical.cpt.CptJobInfo | null = null;
                selConePurpose: number = 0;
                conePurpose1: number = 0;
                conePurpose2: number = 0;
                drawDepthResults: boolean = false;
                drawFrictionData: boolean = false;
                selectedValue: number = 0;
                diggingLog: ng.geotechnical.cpt.CptLog[] = [];
                soilProfile: ng.geotechnical.cpt.CptSoilLayer[] = [];
                materialsFromRegion: ng.geotechnical.cpt.CptSoilLayer[] = [];

                static fromObject(src_unknown: unknown): CptMember {
                    const dst = new CptMember();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CptMember but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CptMember_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CptMember but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.groundLevelUser !== undefined && src.groundLevelUser !== null) {
                        if (typeof src.groundLevelUser === "boolean") {
                            dst.groundLevelUser = src.groundLevelUser;
                        }
                        else {
                            console.log('Expected groundLevelUser of CptMember to be a boolean but was ', typeof src.groundLevelUser, src.groundLevelUser)
                        }
                    }
                    if (src.groundLevel !== undefined && src.groundLevel !== null) {
                        if (typeof src.groundLevel === "number" || src.groundLevel === 'NaN' || src.groundLevel === 'Infinity' || src.groundLevel === '-Infinity') {
                            dst.groundLevel = AsNum(src.groundLevel);
                        }
                        else {
                            console.log('Expected groundLevel of CptMember to be a number but was ', typeof src.groundLevel, src.groundLevel)
                        }
                    }
                    if (src.waterLevel !== undefined && src.waterLevel !== null) {
                        if (typeof src.waterLevel === "number" || src.waterLevel === 'NaN' || src.waterLevel === 'Infinity' || src.waterLevel === '-Infinity') {
                            dst.waterLevel = AsNum(src.waterLevel);
                        }
                        else {
                            console.log('Expected waterLevel of CptMember to be a number but was ', typeof src.waterLevel, src.waterLevel)
                        }
                    }
                    if (src.lastFricValState !== undefined && src.lastFricValState !== null) {
                        if (typeof src.lastFricValState === "number" || src.lastFricValState === 'NaN' || src.lastFricValState === 'Infinity' || src.lastFricValState === '-Infinity') {
                            dst.lastFricValState = AsNum(src.lastFricValState);
                        }
                        else {
                            console.log('Expected lastFricValState of CptMember to be a number but was ', typeof src.lastFricValState, src.lastFricValState)
                        }
                    }
                    if (src.lastAlphaZValState !== undefined && src.lastAlphaZValState !== null) {
                        if (typeof src.lastAlphaZValState === "number" || src.lastAlphaZValState === 'NaN' || src.lastAlphaZValState === 'Infinity' || src.lastAlphaZValState === '-Infinity') {
                            dst.lastAlphaZValState = AsNum(src.lastAlphaZValState);
                        }
                        else {
                            console.log('Expected lastAlphaZValState of CptMember to be a number but was ', typeof src.lastAlphaZValState, src.lastAlphaZValState)
                        }
                    }
                    if (src.groundLevelType !== undefined && src.groundLevelType !== null) {
                        dst.groundLevelType = ng.geotechnical.cpt.GroundLevelType_FromObject(src.groundLevelType);
                    }
                    if (src.analysisType !== undefined && src.analysisType !== null) {
                        dst.analysisType = ng.geotechnical.cpt.AnalysisType_FromObject(src.analysisType);
                    }
                    if (src.regionGuid !== undefined && src.regionGuid !== null) {
                        if (typeof src.regionGuid === "string") {
                            dst.regionGuid = src.regionGuid;
                        }
                        else {
                            console.log('Expected regionGuid of CptMember to be a string but was ', typeof src.regionGuid, src.regionGuid)
                        }
                    }
                    if (src.regionLabel !== undefined && src.regionLabel !== null) {
                        if (typeof src.regionLabel === "string") {
                            dst.regionLabel = src.regionLabel;
                        }
                        else {
                            console.log('Expected regionLabel of CptMember to be a string but was ', typeof src.regionLabel, src.regionLabel)
                        }
                    }
                    if (src.diagram !== undefined && src.diagram !== null) {
                        dst.diagram = ng.geotechnical.cpt.CptDiagram.fromObject(src.diagram);
                    }
                    if (src.diagramPurpose1 !== undefined && src.diagramPurpose1 !== null) {
                        dst.diagramPurpose1 = ng.geotechnical.cpt.CptDiagram.fromObject(src.diagramPurpose1);
                    }
                    if (src.diagramPurpose2 !== undefined && src.diagramPurpose2 !== null) {
                        dst.diagramPurpose2 = ng.geotechnical.cpt.CptDiagram.fromObject(src.diagramPurpose2);
                    }
                    if (src.frictionOverride !== undefined && src.frictionOverride !== null) {
                        dst.frictionOverride = ng.geotechnical.cpt.FrictionOverride.fromObject(src.frictionOverride);
                    }
                    if (src.jobInfo !== undefined && src.jobInfo !== null) {
                        dst.jobInfo = ng.geotechnical.cpt.CptJobInfo.fromObject(src.jobInfo);
                    }
                    if (src.selConePurpose !== undefined && src.selConePurpose !== null) {
                        if (typeof src.selConePurpose === "number" || src.selConePurpose === 'NaN' || src.selConePurpose === 'Infinity' || src.selConePurpose === '-Infinity') {
                            dst.selConePurpose = NumberToInt("ng.geotechnical.cpt.CptMember.sel_cone_purpose", AsNum(src.selConePurpose));
                        }
                        else {
                            console.log('Expected selConePurpose of CptMember to be a number but was ', typeof src.selConePurpose, src.selConePurpose)
                        }
                    }
                    if (src.conePurpose1 !== undefined && src.conePurpose1 !== null) {
                        if (typeof src.conePurpose1 === "number" || src.conePurpose1 === 'NaN' || src.conePurpose1 === 'Infinity' || src.conePurpose1 === '-Infinity') {
                            dst.conePurpose1 = NumberToInt("ng.geotechnical.cpt.CptMember.cone_purpose1", AsNum(src.conePurpose1));
                        }
                        else {
                            console.log('Expected conePurpose1 of CptMember to be a number but was ', typeof src.conePurpose1, src.conePurpose1)
                        }
                    }
                    if (src.conePurpose2 !== undefined && src.conePurpose2 !== null) {
                        if (typeof src.conePurpose2 === "number" || src.conePurpose2 === 'NaN' || src.conePurpose2 === 'Infinity' || src.conePurpose2 === '-Infinity') {
                            dst.conePurpose2 = NumberToInt("ng.geotechnical.cpt.CptMember.cone_purpose2", AsNum(src.conePurpose2));
                        }
                        else {
                            console.log('Expected conePurpose2 of CptMember to be a number but was ', typeof src.conePurpose2, src.conePurpose2)
                        }
                    }
                    if (src.drawDepthResults !== undefined && src.drawDepthResults !== null) {
                        if (typeof src.drawDepthResults === "boolean") {
                            dst.drawDepthResults = src.drawDepthResults;
                        }
                        else {
                            console.log('Expected drawDepthResults of CptMember to be a boolean but was ', typeof src.drawDepthResults, src.drawDepthResults)
                        }
                    }
                    if (src.drawFrictionData !== undefined && src.drawFrictionData !== null) {
                        if (typeof src.drawFrictionData === "boolean") {
                            dst.drawFrictionData = src.drawFrictionData;
                        }
                        else {
                            console.log('Expected drawFrictionData of CptMember to be a boolean but was ', typeof src.drawFrictionData, src.drawFrictionData)
                        }
                    }
                    if (src.selectedValue !== undefined && src.selectedValue !== null) {
                        if (typeof src.selectedValue === "number" || src.selectedValue === 'NaN' || src.selectedValue === 'Infinity' || src.selectedValue === '-Infinity') {
                            dst.selectedValue = AsNum(src.selectedValue);
                        }
                        else {
                            console.log('Expected selectedValue of CptMember to be a number but was ', typeof src.selectedValue, src.selectedValue)
                        }
                    }
                    if (src.diggingLog !== undefined && src.diggingLog !== null) {
                        if (Array.isArray(src.diggingLog)) {
                            for (const element of src.diggingLog) {
                                dst.diggingLog.push(ng.geotechnical.cpt.CptLog.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected diggingLog of CptMember to be a array but was ', typeof src.diggingLog, src.diggingLog)
                        }
                    }
                    if (src.soilProfile !== undefined && src.soilProfile !== null) {
                        if (Array.isArray(src.soilProfile)) {
                            for (const element of src.soilProfile) {
                                dst.soilProfile.push(ng.geotechnical.cpt.CptSoilLayer.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected soilProfile of CptMember to be a array but was ', typeof src.soilProfile, src.soilProfile)
                        }
                    }
                    if (src.materialsFromRegion !== undefined && src.materialsFromRegion !== null) {
                        if (Array.isArray(src.materialsFromRegion)) {
                            for (const element of src.materialsFromRegion) {
                                dst.materialsFromRegion.push(ng.geotechnical.cpt.CptSoilLayer.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected materialsFromRegion of CptMember to be a array but was ', typeof src.materialsFromRegion, src.materialsFromRegion)
                        }
                    }
                    return dst;
                }

                static toObject(src: CptMember | null | undefined): CptMember_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.geotechnical.cpt.CptMember is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.geotechnical.cpt.CptMember") {
                        console.error('Expected ng.geotechnical.cpt.CptMember but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const groundLevelType_obj = ng.geotechnical.cpt.GroundLevelType_ToObject(src.groundLevelType);
                    if(groundLevelType_obj === null) return null;

                    const analysisType_obj = ng.geotechnical.cpt.AnalysisType_ToObject(src.analysisType);
                    if(analysisType_obj === null) return null;

                    const dst : CptMember_json = {
                        groundLevelUser: src.groundLevelUser,
                        groundLevel: AsJsonNum(src.groundLevel),
                        waterLevel: AsJsonNum(src.waterLevel),
                        lastFricValState: AsJsonNum(src.lastFricValState),
                        lastAlphaZValState: AsJsonNum(src.lastAlphaZValState),
                        groundLevelType: groundLevelType_obj,
                        analysisType: analysisType_obj,
                        regionGuid: src.regionGuid,
                        regionLabel: src.regionLabel,
                        selConePurpose: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptMember.sel_cone_purpose", src.selConePurpose)),
                        conePurpose1: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptMember.cone_purpose1", src.conePurpose1)),
                        conePurpose2: AsJsonNum(NumberToInt("ng.geotechnical.cpt.CptMember.cone_purpose2", src.conePurpose2)),
                        drawDepthResults: src.drawDepthResults,
                        drawFrictionData: src.drawFrictionData,
                        selectedValue: AsJsonNum(src.selectedValue),
                        diggingLog: new Array<ng.geotechnical.cpt.CptLog_json>(),
                        soilProfile: new Array<ng.geotechnical.cpt.CptSoilLayer_json>(),
                        materialsFromRegion: new Array<ng.geotechnical.cpt.CptSoilLayer_json>(),
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.diagram !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptDiagram.toObject(src.diagram);
                        if(parsed === null) return null;
                        dst.diagram = parsed;
                    }
                    if(src.diagramPurpose1 !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptDiagram.toObject(src.diagramPurpose1);
                        if(parsed === null) return null;
                        dst.diagramPurpose1 = parsed;
                    }
                    if(src.diagramPurpose2 !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptDiagram.toObject(src.diagramPurpose2);
                        if(parsed === null) return null;
                        dst.diagramPurpose2 = parsed;
                    }
                    if(src.frictionOverride !== null)
                    {
                        const parsed = ng.geotechnical.cpt.FrictionOverride.toObject(src.frictionOverride);
                        if(parsed === null) return null;
                        dst.frictionOverride = parsed;
                    }
                    if(src.jobInfo !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptJobInfo.toObject(src.jobInfo);
                        if(parsed === null) return null;
                        dst.jobInfo = parsed;
                    }
                    if (src.diggingLog !== null) {
                        for (const element of src.diggingLog) {
                            const parsed = ng.geotechnical.cpt.CptLog.toObject(element);
                            if(parsed === null) return null;
                            dst.diggingLog.push(parsed);
                        }
                    }
                    if (src.soilProfile !== null) {
                        for (const element of src.soilProfile) {
                            const parsed = ng.geotechnical.cpt.CptSoilLayer.toObject(element);
                            if(parsed === null) return null;
                            dst.soilProfile.push(parsed);
                        }
                    }
                    if (src.materialsFromRegion !== null) {
                        for (const element of src.materialsFromRegion) {
                            const parsed = ng.geotechnical.cpt.CptSoilLayer.toObject(element);
                            if(parsed === null) return null;
                            dst.materialsFromRegion.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CptMember_createType) {
                    const dst = new CptMember();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.groundLevelUser !== undefined) {
                        dst.groundLevelUser = src.groundLevelUser;
                    }
                    if (src.groundLevel !== undefined) {
                        dst.groundLevel = src.groundLevel;
                    }
                    if (src.waterLevel !== undefined) {
                        dst.waterLevel = src.waterLevel;
                    }
                    if (src.lastFricValState !== undefined) {
                        dst.lastFricValState = src.lastFricValState;
                    }
                    if (src.lastAlphaZValState !== undefined) {
                        dst.lastAlphaZValState = src.lastAlphaZValState;
                    }
                    if (src.groundLevelType !== undefined) {
                        dst.groundLevelType = src.groundLevelType;
                    }
                    if (src.analysisType !== undefined) {
                        dst.analysisType = src.analysisType;
                    }
                    if (src.regionGuid !== undefined) {
                        dst.regionGuid = src.regionGuid;
                    }
                    if (src.regionLabel !== undefined) {
                        dst.regionLabel = src.regionLabel;
                    }
                    if (src.diagram !== undefined) {
                        dst.diagram = src.diagram;
                    }
                    if (src.diagramPurpose1 !== undefined) {
                        dst.diagramPurpose1 = src.diagramPurpose1;
                    }
                    if (src.diagramPurpose2 !== undefined) {
                        dst.diagramPurpose2 = src.diagramPurpose2;
                    }
                    if (src.frictionOverride !== undefined) {
                        dst.frictionOverride = src.frictionOverride;
                    }
                    if (src.jobInfo !== undefined) {
                        dst.jobInfo = src.jobInfo;
                    }
                    if (src.selConePurpose !== undefined) {
                        dst.selConePurpose = src.selConePurpose;
                    }
                    if (src.conePurpose1 !== undefined) {
                        dst.conePurpose1 = src.conePurpose1;
                    }
                    if (src.conePurpose2 !== undefined) {
                        dst.conePurpose2 = src.conePurpose2;
                    }
                    if (src.drawDepthResults !== undefined) {
                        dst.drawDepthResults = src.drawDepthResults;
                    }
                    if (src.drawFrictionData !== undefined) {
                        dst.drawFrictionData = src.drawFrictionData;
                    }
                    if (src.selectedValue !== undefined) {
                        dst.selectedValue = src.selectedValue;
                    }
                    if (src.diggingLog !== undefined) {
                        dst.diggingLog = src.diggingLog;
                    }
                    if (src.soilProfile !== undefined) {
                        dst.soilProfile = src.soilProfile;
                    }
                    if (src.materialsFromRegion !== undefined) {
                        dst.materialsFromRegion = src.materialsFromRegion;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CptMember();
                    dst.id = this.id;
                    dst.groundLevelUser = this.groundLevelUser;
                    dst.groundLevel = this.groundLevel;
                    dst.waterLevel = this.waterLevel;
                    dst.lastFricValState = this.lastFricValState;
                    dst.lastAlphaZValState = this.lastAlphaZValState;
                    dst.groundLevelType = this.groundLevelType;
                    dst.analysisType = this.analysisType;
                    dst.regionGuid = this.regionGuid;
                    dst.regionLabel = this.regionLabel;
                    dst.diagram = this.diagram;
                    dst.diagramPurpose1 = this.diagramPurpose1;
                    dst.diagramPurpose2 = this.diagramPurpose2;
                    dst.frictionOverride = this.frictionOverride;
                    dst.jobInfo = this.jobInfo;
                    dst.selConePurpose = this.selConePurpose;
                    dst.conePurpose1 = this.conePurpose1;
                    dst.conePurpose2 = this.conePurpose2;
                    dst.drawDepthResults = this.drawDepthResults;
                    dst.drawFrictionData = this.drawFrictionData;
                    dst.selectedValue = this.selectedValue;
                    dst.diggingLog = this.diggingLog;
                    dst.soilProfile = this.soilProfile;
                    dst.materialsFromRegion = this.materialsFromRegion;
                    return dst;
                }

                deepClone() {
                    const json = CptMember.toObject(this);
                    const dst = CptMember.fromObject(json);
                    return dst;
                }
            }
            export type ICptMember = CptMember;
        } // namespace cpt
    } // namespace geotechnical


    // Defined in 9 files
    export namespace result {
        // defined in Result/result.proto
        export enum Force {
            FORCE_UNSPECIFIED = 0,
            FORCE_N = 1,
            FORCE_V1 = 2,
            FORCE_V2 = 3,
            FORCE_T = 4,
            FORCE_M1 = 5,
            FORCE_M2 = 6,
            FORCE_RX = 7,
            FORCE_RY = 8,
            FORCE_RZ = 9,
            FORCE_MX = 10,
            FORCE_MY = 11,
            FORCE_MZ = 12
        }
        export const Force_FromObject = (src: unknown): Force => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'FORCE_UNSPECIFIED':
                    return Force.FORCE_UNSPECIFIED;
                case 1:
                case 'FORCE_N':
                    return Force.FORCE_N;
                case 2:
                case 'FORCE_V1':
                    return Force.FORCE_V1;
                case 3:
                case 'FORCE_V2':
                    return Force.FORCE_V2;
                case 4:
                case 'FORCE_T':
                    return Force.FORCE_T;
                case 5:
                case 'FORCE_M1':
                    return Force.FORCE_M1;
                case 6:
                case 'FORCE_M2':
                    return Force.FORCE_M2;
                case 7:
                case 'FORCE_RX':
                    return Force.FORCE_RX;
                case 8:
                case 'FORCE_RY':
                    return Force.FORCE_RY;
                case 9:
                case 'FORCE_RZ':
                    return Force.FORCE_RZ;
                case 10:
                case 'FORCE_MX':
                    return Force.FORCE_MX;
                case 11:
                case 'FORCE_MY':
                    return Force.FORCE_MY;
                case 12:
                case 'FORCE_MZ':
                    return Force.FORCE_MZ;
                default:
                    console.log('Unhandled value for Force:' + src + '. ' + typeof(src));
                    return Force.FORCE_UNSPECIFIED;
            }
        };
        export const Force_ToObject = (src: Force): string | null => {
            switch (src) {
                case Force.FORCE_UNSPECIFIED:
                    return 'FORCE_UNSPECIFIED';
                case Force.FORCE_N:
                    return 'FORCE_N';
                case Force.FORCE_V1:
                    return 'FORCE_V1';
                case Force.FORCE_V2:
                    return 'FORCE_V2';
                case Force.FORCE_T:
                    return 'FORCE_T';
                case Force.FORCE_M1:
                    return 'FORCE_M1';
                case Force.FORCE_M2:
                    return 'FORCE_M2';
                case Force.FORCE_RX:
                    return 'FORCE_RX';
                case Force.FORCE_RY:
                    return 'FORCE_RY';
                case Force.FORCE_RZ:
                    return 'FORCE_RZ';
                case Force.FORCE_MX:
                    return 'FORCE_MX';
                case Force.FORCE_MY:
                    return 'FORCE_MY';
                case Force.FORCE_MZ:
                    return 'FORCE_MZ';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Force, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        // defined in Result/result.proto
        export enum Displacement {
            DISPLACEMENT_UNSPECIFIED = 0,
            DISPLACEMENT_U = 1,
            DISPLACEMENT_V = 2,
            DISPLACEMENT_W = 3,
            DISPLACEMENT_RU = 4,
            DISPLACEMENT_RV = 5,
            DISPLACEMENT_RW = 6,
            DISPLACEMENT_X = 7,
            DISPLACEMENT_Y = 8,
            DISPLACEMENT_Z = 9,
            DISPLACEMENT_RX = 10,
            DISPLACEMENT_RY = 11,
            DISPLACEMENT_RZ = 12
        }
        export const Displacement_FromObject = (src: unknown): Displacement => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DISPLACEMENT_UNSPECIFIED':
                    return Displacement.DISPLACEMENT_UNSPECIFIED;
                case 1:
                case 'DISPLACEMENT_U':
                    return Displacement.DISPLACEMENT_U;
                case 2:
                case 'DISPLACEMENT_V':
                    return Displacement.DISPLACEMENT_V;
                case 3:
                case 'DISPLACEMENT_W':
                    return Displacement.DISPLACEMENT_W;
                case 4:
                case 'DISPLACEMENT_RU':
                    return Displacement.DISPLACEMENT_RU;
                case 5:
                case 'DISPLACEMENT_RV':
                    return Displacement.DISPLACEMENT_RV;
                case 6:
                case 'DISPLACEMENT_RW':
                    return Displacement.DISPLACEMENT_RW;
                case 7:
                case 'DISPLACEMENT_X':
                    return Displacement.DISPLACEMENT_X;
                case 8:
                case 'DISPLACEMENT_Y':
                    return Displacement.DISPLACEMENT_Y;
                case 9:
                case 'DISPLACEMENT_Z':
                    return Displacement.DISPLACEMENT_Z;
                case 10:
                case 'DISPLACEMENT_RX':
                    return Displacement.DISPLACEMENT_RX;
                case 11:
                case 'DISPLACEMENT_RY':
                    return Displacement.DISPLACEMENT_RY;
                case 12:
                case 'DISPLACEMENT_RZ':
                    return Displacement.DISPLACEMENT_RZ;
                default:
                    console.log('Unhandled value for Displacement:' + src + '. ' + typeof(src));
                    return Displacement.DISPLACEMENT_UNSPECIFIED;
            }
        };
        export const Displacement_ToObject = (src: Displacement): string | null => {
            switch (src) {
                case Displacement.DISPLACEMENT_UNSPECIFIED:
                    return 'DISPLACEMENT_UNSPECIFIED';
                case Displacement.DISPLACEMENT_U:
                    return 'DISPLACEMENT_U';
                case Displacement.DISPLACEMENT_V:
                    return 'DISPLACEMENT_V';
                case Displacement.DISPLACEMENT_W:
                    return 'DISPLACEMENT_W';
                case Displacement.DISPLACEMENT_RU:
                    return 'DISPLACEMENT_RU';
                case Displacement.DISPLACEMENT_RV:
                    return 'DISPLACEMENT_RV';
                case Displacement.DISPLACEMENT_RW:
                    return 'DISPLACEMENT_RW';
                case Displacement.DISPLACEMENT_X:
                    return 'DISPLACEMENT_X';
                case Displacement.DISPLACEMENT_Y:
                    return 'DISPLACEMENT_Y';
                case Displacement.DISPLACEMENT_Z:
                    return 'DISPLACEMENT_Z';
                case Displacement.DISPLACEMENT_RX:
                    return 'DISPLACEMENT_RX';
                case Displacement.DISPLACEMENT_RY:
                    return 'DISPLACEMENT_RY';
                case Displacement.DISPLACEMENT_RZ:
                    return 'DISPLACEMENT_RZ';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Displacement, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        // defined in Result/result.proto
        export enum Stress {
            STRESS_UNSPECIFIED = 0,
            STRESS_S11 = 1,
            STRESS_S22 = 2,
            STRESS_S12 = 3,
            STRESS_SP1 = 4,
            STRESS_SP2 = 5,
            STRESS_MISES = 6
        }
        export const Stress_FromObject = (src: unknown): Stress => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'STRESS_UNSPECIFIED':
                    return Stress.STRESS_UNSPECIFIED;
                case 1:
                case 'STRESS_S11':
                    return Stress.STRESS_S11;
                case 2:
                case 'STRESS_S22':
                    return Stress.STRESS_S22;
                case 3:
                case 'STRESS_S12':
                    return Stress.STRESS_S12;
                case 4:
                case 'STRESS_SP1':
                    return Stress.STRESS_SP1;
                case 5:
                case 'STRESS_SP2':
                    return Stress.STRESS_SP2;
                case 6:
                case 'STRESS_MISES':
                    return Stress.STRESS_MISES;
                default:
                    console.log('Unhandled value for Stress:' + src + '. ' + typeof(src));
                    return Stress.STRESS_UNSPECIFIED;
            }
        };
        export const Stress_ToObject = (src: Stress): string | null => {
            switch (src) {
                case Stress.STRESS_UNSPECIFIED:
                    return 'STRESS_UNSPECIFIED';
                case Stress.STRESS_S11:
                    return 'STRESS_S11';
                case Stress.STRESS_S22:
                    return 'STRESS_S22';
                case Stress.STRESS_S12:
                    return 'STRESS_S12';
                case Stress.STRESS_SP1:
                    return 'STRESS_SP1';
                case Stress.STRESS_SP2:
                    return 'STRESS_SP2';
                case Stress.STRESS_MISES:
                    return 'STRESS_MISES';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Stress, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        // defined in Result/result.proto
        export type ForceData_keys = 'globalCoordsys' | 'type' | 'value';
        export interface ForceData_createType {
            globalCoordsys?: boolean,
            type?: ng.result.Force[],
            value?: number[],
        }
        export interface ForceData_json {
            globalCoordsys?: boolean;
            type: string[];
            value: JsonNumber[];
        }
        interface ForceData_json_in {
            __proto_name?: unknown;
            globalCoordsys?: unknown;
            type?: unknown;
            value?: unknown;
        }
        export class ForceData {
            __proto_name = "ng.result.ForceData";
            globalCoordsys: boolean = false;
            type: ng.result.Force[] = [];
            value: number[] = [];

            static fromObject(src_unknown: unknown): ForceData {
                const dst = new ForceData();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ForceData but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ForceData_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ForceData but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.globalCoordsys !== undefined && src.globalCoordsys !== null) {
                    if (typeof src.globalCoordsys === "boolean") {
                        dst.globalCoordsys = src.globalCoordsys;
                    }
                    else {
                        console.log('Expected globalCoordsys of ForceData to be a boolean but was ', typeof src.globalCoordsys, src.globalCoordsys)
                    }
                }
                if (src.type !== undefined && src.type !== null) {
                    if (Array.isArray(src.type)) {
                        for (const element of src.type) {
                            dst.type.push(ng.result.Force_FromObject(element));
                        }
                    }
                    else {
                        console.log('Expected type of ForceData to be a array but was ', typeof src.type, src.type)
                    }
                }
                if (src.value !== undefined && src.value !== null) {
                    if (Array.isArray(src.value)) {
                        for (const [index, element] of src.value.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.value.push(AsNum(element));
                            }
                            else {
                                console.log('Expected value of ForceData[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected value of ForceData to be a array but was ', typeof src.value, src.value)
                    }
                }
                return dst;
            }

            static toObject(src: ForceData | null | undefined): ForceData_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.ForceData is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.ForceData") {
                    console.error('Expected ng.result.ForceData but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ForceData_json = {
                    globalCoordsys: src.globalCoordsys,
                    type: new Array<string>(),
                    value: new Array<JsonNumber>(),
                };
                if (src.type !== null) {
                    for (const element of src.type) {
                        const parsed = ng.result.Force_ToObject(element);
                        if(parsed === null) return null;
                        dst.type.push(parsed);
                    }
                }
                if (src.value !== null) {
                    for (const element of src.value) {
                        dst.value.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: ForceData_createType) {
                const dst = new ForceData();
                if (src === undefined) {
                    return dst;
                }
                if (src.globalCoordsys !== undefined) {
                    dst.globalCoordsys = src.globalCoordsys;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ForceData();
                dst.globalCoordsys = this.globalCoordsys;
                dst.type = this.type;
                dst.value = this.value;
                return dst;
            }

            deepClone() {
                const json = ForceData.toObject(this);
                const dst = ForceData.fromObject(json);
                return dst;
            }
        }
        export type IForceData = ForceData;


        // defined in Result/result.proto
        export type DisplacementData_keys = 'globalCoordsys' | 'type' | 'value';
        export interface DisplacementData_createType {
            globalCoordsys?: boolean,
            type?: ng.result.Displacement[],
            value?: number[],
        }
        export interface DisplacementData_json {
            globalCoordsys?: boolean;
            type: string[];
            value: JsonNumber[];
        }
        interface DisplacementData_json_in {
            __proto_name?: unknown;
            globalCoordsys?: unknown;
            type?: unknown;
            value?: unknown;
        }
        export class DisplacementData {
            __proto_name = "ng.result.DisplacementData";
            globalCoordsys: boolean = false;
            type: ng.result.Displacement[] = [];
            value: number[] = [];

            static fromObject(src_unknown: unknown): DisplacementData {
                const dst = new DisplacementData();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted DisplacementData but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as DisplacementData_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for DisplacementData but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.globalCoordsys !== undefined && src.globalCoordsys !== null) {
                    if (typeof src.globalCoordsys === "boolean") {
                        dst.globalCoordsys = src.globalCoordsys;
                    }
                    else {
                        console.log('Expected globalCoordsys of DisplacementData to be a boolean but was ', typeof src.globalCoordsys, src.globalCoordsys)
                    }
                }
                if (src.type !== undefined && src.type !== null) {
                    if (Array.isArray(src.type)) {
                        for (const element of src.type) {
                            dst.type.push(ng.result.Displacement_FromObject(element));
                        }
                    }
                    else {
                        console.log('Expected type of DisplacementData to be a array but was ', typeof src.type, src.type)
                    }
                }
                if (src.value !== undefined && src.value !== null) {
                    if (Array.isArray(src.value)) {
                        for (const [index, element] of src.value.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.value.push(AsNum(element));
                            }
                            else {
                                console.log('Expected value of DisplacementData[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected value of DisplacementData to be a array but was ', typeof src.value, src.value)
                    }
                }
                return dst;
            }

            static toObject(src: DisplacementData | null | undefined): DisplacementData_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.DisplacementData is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.DisplacementData") {
                    console.error('Expected ng.result.DisplacementData but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : DisplacementData_json = {
                    globalCoordsys: src.globalCoordsys,
                    type: new Array<string>(),
                    value: new Array<JsonNumber>(),
                };
                if (src.type !== null) {
                    for (const element of src.type) {
                        const parsed = ng.result.Displacement_ToObject(element);
                        if(parsed === null) return null;
                        dst.type.push(parsed);
                    }
                }
                if (src.value !== null) {
                    for (const element of src.value) {
                        dst.value.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: DisplacementData_createType) {
                const dst = new DisplacementData();
                if (src === undefined) {
                    return dst;
                }
                if (src.globalCoordsys !== undefined) {
                    dst.globalCoordsys = src.globalCoordsys;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                return dst;
            }

            shallowClone() {
                const dst = new DisplacementData();
                dst.globalCoordsys = this.globalCoordsys;
                dst.type = this.type;
                dst.value = this.value;
                return dst;
            }

            deepClone() {
                const json = DisplacementData.toObject(this);
                const dst = DisplacementData.fromObject(json);
                return dst;
            }
        }
        export type IDisplacementData = DisplacementData;


        // defined in Result/result.proto
        export type StressData_keys = 'type' | 'value';
        export interface StressData_createType {
            type?: ng.result.Stress[],
            value?: number[],
        }
        export interface StressData_json {
            type: string[];
            value: JsonNumber[];
        }
        interface StressData_json_in {
            __proto_name?: unknown;
            type?: unknown;
            value?: unknown;
        }
        export class StressData {
            __proto_name = "ng.result.StressData";
            type: ng.result.Stress[] = [];
            value: number[] = [];

            static fromObject(src_unknown: unknown): StressData {
                const dst = new StressData();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted StressData but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as StressData_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for StressData but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    if (Array.isArray(src.type)) {
                        for (const element of src.type) {
                            dst.type.push(ng.result.Stress_FromObject(element));
                        }
                    }
                    else {
                        console.log('Expected type of StressData to be a array but was ', typeof src.type, src.type)
                    }
                }
                if (src.value !== undefined && src.value !== null) {
                    if (Array.isArray(src.value)) {
                        for (const [index, element] of src.value.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.value.push(AsNum(element));
                            }
                            else {
                                console.log('Expected value of StressData[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected value of StressData to be a array but was ', typeof src.value, src.value)
                    }
                }
                return dst;
            }

            static toObject(src: StressData | null | undefined): StressData_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.StressData is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.StressData") {
                    console.error('Expected ng.result.StressData but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : StressData_json = {
                    type: new Array<string>(),
                    value: new Array<JsonNumber>(),
                };
                if (src.type !== null) {
                    for (const element of src.type) {
                        const parsed = ng.result.Stress_ToObject(element);
                        if(parsed === null) return null;
                        dst.type.push(parsed);
                    }
                }
                if (src.value !== null) {
                    for (const element of src.value) {
                        dst.value.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: StressData_createType) {
                const dst = new StressData();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                return dst;
            }

            shallowClone() {
                const dst = new StressData();
                dst.type = this.type;
                dst.value = this.value;
                return dst;
            }

            deepClone() {
                const json = StressData.toObject(this);
                const dst = StressData.fromObject(json);
                return dst;
            }
        }
        export type IStressData = StressData;


        // defined in Result/result.proto
        export type TemperatureData_keys = 't';
        export interface TemperatureData_createType {
            t?: number,
        }
        export interface TemperatureData_json {
            t?: JsonNumber;
        }
        interface TemperatureData_json_in {
            __proto_name?: unknown;
            t?: unknown;
        }
        export class TemperatureData {
            __proto_name = "ng.result.TemperatureData";
            t: number = 0;

            static fromObject(src_unknown: unknown): TemperatureData {
                const dst = new TemperatureData();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted TemperatureData but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as TemperatureData_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for TemperatureData but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.t !== undefined && src.t !== null) {
                    if (typeof src.t === "number" || src.t === 'NaN' || src.t === 'Infinity' || src.t === '-Infinity') {
                        dst.t = AsNum(src.t);
                    }
                    else {
                        console.log('Expected t of TemperatureData to be a number but was ', typeof src.t, src.t)
                    }
                }
                return dst;
            }

            static toObject(src: TemperatureData | null | undefined): TemperatureData_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.TemperatureData is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.TemperatureData") {
                    console.error('Expected ng.result.TemperatureData but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : TemperatureData_json = {
                    t: AsJsonNum(src.t),
                };
                return dst;
            }

            static create(src?: TemperatureData_createType) {
                const dst = new TemperatureData();
                if (src === undefined) {
                    return dst;
                }
                if (src.t !== undefined) {
                    dst.t = src.t;
                }
                return dst;
            }

            shallowClone() {
                const dst = new TemperatureData();
                dst.t = this.t;
                return dst;
            }

            deepClone() {
                const json = TemperatureData.toObject(this);
                const dst = TemperatureData.fromObject(json);
                return dst;
            }
        }
        export type ITemperatureData = TemperatureData;


        // defined in Result/result.proto
        export type Data_keys = 'displacement' | 'force' | 'stress' | 'temperature';
        export interface Data_createType {
            displacement?: ng.result.DisplacementData | null,
            force?: ng.result.ForceData | null,
            stress?: ng.result.StressData | null,
            temperature?: ng.result.TemperatureData | null,
        }
        export interface Data_json {
            displacement?: ng.result.DisplacementData_json;
            force?: ng.result.ForceData_json;
            stress?: ng.result.StressData_json;
            temperature?: ng.result.TemperatureData_json;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            displacement?: unknown;
            force?: unknown;
            stress?: unknown;
            temperature?: unknown;
        }
        export class Data {
            __proto_name = "ng.result.Data";
            displacement: ng.result.DisplacementData | null = null;
            force: ng.result.ForceData | null = null;
            stress: ng.result.StressData | null = null;
            temperature: ng.result.TemperatureData | null = null;

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.displacement !== undefined && src.displacement !== null) {
                    dst.displacement = ng.result.DisplacementData.fromObject(src.displacement);
                }
                if (src.force !== undefined && src.force !== null) {
                    dst.force = ng.result.ForceData.fromObject(src.force);
                }
                if (src.stress !== undefined && src.stress !== null) {
                    dst.stress = ng.result.StressData.fromObject(src.stress);
                }
                if (src.temperature !== undefined && src.temperature !== null) {
                    dst.temperature = ng.result.TemperatureData.fromObject(src.temperature);
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.Data") {
                    console.error('Expected ng.result.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                };
                if(src.displacement !== null)
                {
                    const parsed = ng.result.DisplacementData.toObject(src.displacement);
                    if(parsed === null) return null;
                    dst.displacement = parsed;
                }
                if(src.force !== null)
                {
                    const parsed = ng.result.ForceData.toObject(src.force);
                    if(parsed === null) return null;
                    dst.force = parsed;
                }
                if(src.stress !== null)
                {
                    const parsed = ng.result.StressData.toObject(src.stress);
                    if(parsed === null) return null;
                    dst.stress = parsed;
                }
                if(src.temperature !== null)
                {
                    const parsed = ng.result.TemperatureData.toObject(src.temperature);
                    if(parsed === null) return null;
                    dst.temperature = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.displacement !== undefined) {
                    dst.displacement = src.displacement;
                }
                if (src.force !== undefined) {
                    dst.force = src.force;
                }
                if (src.stress !== undefined) {
                    dst.stress = src.stress;
                }
                if (src.temperature !== undefined) {
                    dst.temperature = src.temperature;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.displacement = this.displacement;
                dst.force = this.force;
                dst.stress = this.stress;
                dst.temperature = this.temperature;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;


        // defined in Result/result.proto
        export type PositionResult_keys = 'id' | 'distance' | 'position2d' | 'position3d' | 'results' | 'resultsBowImp' | 'results2nd' | 'rc' | 'steel' | 'timber' | 'foundation' | 'pile' | 'retainingWall' | 'groupName';
        export interface PositionResult_createType {
            id?: ng.utils.ID | null,
            distance?: number,
            position2d?: ng.geometry.Point2D | null,
            position3d?: ng.geometry.Point3D | null,
            results?: ng.result.Data | null,
            resultsBowImp?: ng.result.Data | null,
            results2nd?: ng.result.Data | null,
            rc?: ng.result.concrete.Data | null,
            steel?: ng.result.steel.Data | null,
            timber?: ng.result.timber.Data | null,
            foundation?: ng.result.foundation.Data | null,
            pile?: ng.result.pile.Data | null,
            retainingWall?: ng.result.retaining_wall.Data | null,
            groupName?: string,
        }
        export interface PositionResult_json {
            id?: ng.utils.ID_json;
            distance?: JsonNumber;
            position2d?: ng.geometry.Point2D_json;
            position3d?: ng.geometry.Point3D_json;
            results?: ng.result.Data_json;
            resultsBowImp?: ng.result.Data_json;
            results2nd?: ng.result.Data_json;
            rc?: ng.result.concrete.Data_json;
            steel?: ng.result.steel.Data_json;
            timber?: ng.result.timber.Data_json;
            foundation?: ng.result.foundation.Data_json;
            pile?: ng.result.pile.Data_json;
            retainingWall?: ng.result.retaining_wall.Data_json;
            groupName?: string;
        }
        interface PositionResult_json_in {
            __proto_name?: unknown;
            id?: unknown;
            distance?: unknown;
            position2d?: unknown;
            position3d?: unknown;
            results?: unknown;
            resultsBowImp?: unknown;
            results2nd?: unknown;
            rc?: unknown;
            steel?: unknown;
            timber?: unknown;
            foundation?: unknown;
            pile?: unknown;
            retainingWall?: unknown;
            groupName?: unknown;
        }
        export class PositionResult {
            __proto_name = "ng.result.PositionResult";
            id: ng.utils.ID | null = null;
            // this is a one of
            position: {type: 'distance'; distance: number} | {type: 'position2d'; position2d: ng.geometry.Point2D} | {type: 'position3d'; position3d: ng.geometry.Point3D} | null = null;
            results: ng.result.Data | null = null;
            resultsBowImp: ng.result.Data | null = null;
            results2nd: ng.result.Data | null = null;
            // this is a one of
            design: {type: 'rc'; rc: ng.result.concrete.Data} | {type: 'steel'; steel: ng.result.steel.Data} | {type: 'timber'; timber: ng.result.timber.Data} | {type: 'foundation'; foundation: ng.result.foundation.Data} | {type: 'pile'; pile: ng.result.pile.Data} | {type: 'retainingWall'; retainingWall: ng.result.retaining_wall.Data} | null = null;
            groupName: string = "";

            /** Gets the `Distance` value (or null) from the oneof `position` */
            getDistance(): number | null {
                if(this.position === null) return null;
                if(this.position.type !== 'distance') return null;
                return this.position.distance;
            }

            /** Sets the `Distance` value for the oneof `position`*/
            setDistance(value: number | null) {
                if(value !== null) {
                    this.position = {type: 'distance', distance:value};
                }
                else {
                    this.position = null;
                }
            }

            /** Gets the `Position2d` value (or null) from the oneof `position` */
            getPosition2d(): ng.geometry.Point2D | null {
                if(this.position === null) return null;
                if(this.position.type !== 'position2d') return null;
                return this.position.position2d;
            }

            /** Sets the `Position2d` value for the oneof `position`*/
            setPosition2d(value: ng.geometry.Point2D | null) {
                if(value !== null) {
                    this.position = {type: 'position2d', position2d:value};
                }
                else {
                    this.position = null;
                }
            }

            /** Gets the `Position3d` value (or null) from the oneof `position` */
            getPosition3d(): ng.geometry.Point3D | null {
                if(this.position === null) return null;
                if(this.position.type !== 'position3d') return null;
                return this.position.position3d;
            }

            /** Sets the `Position3d` value for the oneof `position`*/
            setPosition3d(value: ng.geometry.Point3D | null) {
                if(value !== null) {
                    this.position = {type: 'position3d', position3d:value};
                }
                else {
                    this.position = null;
                }
            }
            /** Gets the `Rc` value (or null) from the oneof `design` */
            getRc(): ng.result.concrete.Data | null {
                if(this.design === null) return null;
                if(this.design.type !== 'rc') return null;
                return this.design.rc;
            }

            /** Sets the `Rc` value for the oneof `design`*/
            setRc(value: ng.result.concrete.Data | null) {
                if(value !== null) {
                    this.design = {type: 'rc', rc:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Steel` value (or null) from the oneof `design` */
            getSteel(): ng.result.steel.Data | null {
                if(this.design === null) return null;
                if(this.design.type !== 'steel') return null;
                return this.design.steel;
            }

            /** Sets the `Steel` value for the oneof `design`*/
            setSteel(value: ng.result.steel.Data | null) {
                if(value !== null) {
                    this.design = {type: 'steel', steel:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Timber` value (or null) from the oneof `design` */
            getTimber(): ng.result.timber.Data | null {
                if(this.design === null) return null;
                if(this.design.type !== 'timber') return null;
                return this.design.timber;
            }

            /** Sets the `Timber` value for the oneof `design`*/
            setTimber(value: ng.result.timber.Data | null) {
                if(value !== null) {
                    this.design = {type: 'timber', timber:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Foundation` value (or null) from the oneof `design` */
            getFoundation(): ng.result.foundation.Data | null {
                if(this.design === null) return null;
                if(this.design.type !== 'foundation') return null;
                return this.design.foundation;
            }

            /** Sets the `Foundation` value for the oneof `design`*/
            setFoundation(value: ng.result.foundation.Data | null) {
                if(value !== null) {
                    this.design = {type: 'foundation', foundation:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Pile` value (or null) from the oneof `design` */
            getPile(): ng.result.pile.Data | null {
                if(this.design === null) return null;
                if(this.design.type !== 'pile') return null;
                return this.design.pile;
            }

            /** Sets the `Pile` value for the oneof `design`*/
            setPile(value: ng.result.pile.Data | null) {
                if(value !== null) {
                    this.design = {type: 'pile', pile:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `RetainingWall` value (or null) from the oneof `design` */
            getRetainingWall(): ng.result.retaining_wall.Data | null {
                if(this.design === null) return null;
                if(this.design.type !== 'retainingWall') return null;
                return this.design.retainingWall;
            }

            /** Sets the `RetainingWall` value for the oneof `design`*/
            setRetainingWall(value: ng.result.retaining_wall.Data | null) {
                if(value !== null) {
                    this.design = {type: 'retainingWall', retainingWall:value};
                }
                else {
                    this.design = null;
                }
            }

            static fromObject(src_unknown: unknown): PositionResult {
                const dst = new PositionResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PositionResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PositionResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PositionResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.distance !== undefined && src.distance !== null) {
                    if (typeof src.distance === "number" || src.distance === 'NaN' || src.distance === 'Infinity' || src.distance === '-Infinity') {
                        dst.setDistance(AsNum(src.distance));
                    }
                    else {
                        console.log('Expected distance of PositionResult to be a number but was ', typeof src.distance, src.distance)
                    }
                }
                if (src.position2d !== undefined && src.position2d !== null) {
                    dst.setPosition2d(ng.geometry.Point2D.fromObject(src.position2d));
                }
                if (src.position3d !== undefined && src.position3d !== null) {
                    dst.setPosition3d(ng.geometry.Point3D.fromObject(src.position3d));
                }
                if (src.results !== undefined && src.results !== null) {
                    dst.results = ng.result.Data.fromObject(src.results);
                }
                if (src.resultsBowImp !== undefined && src.resultsBowImp !== null) {
                    dst.resultsBowImp = ng.result.Data.fromObject(src.resultsBowImp);
                }
                if (src.results2nd !== undefined && src.results2nd !== null) {
                    dst.results2nd = ng.result.Data.fromObject(src.results2nd);
                }
                if (src.rc !== undefined && src.rc !== null) {
                    dst.setRc(ng.result.concrete.Data.fromObject(src.rc));
                }
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(ng.result.steel.Data.fromObject(src.steel));
                }
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(ng.result.timber.Data.fromObject(src.timber));
                }
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(ng.result.foundation.Data.fromObject(src.foundation));
                }
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(ng.result.pile.Data.fromObject(src.pile));
                }
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(ng.result.retaining_wall.Data.fromObject(src.retainingWall));
                }
                if (src.groupName !== undefined && src.groupName !== null) {
                    if (typeof src.groupName === "string") {
                        dst.groupName = src.groupName;
                    }
                    else {
                        console.log('Expected groupName of PositionResult to be a string but was ', typeof src.groupName, src.groupName)
                    }
                }
                return dst;
            }

            static toObject(src: PositionResult | null | undefined): PositionResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.PositionResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.PositionResult") {
                    console.error('Expected ng.result.PositionResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PositionResult_json = {
                    groupName: src.groupName,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const distance = src.getDistance();
                if(distance !== null)
                {
                    const parsed = AsJsonNum(distance);
                    if(parsed === null) return null;
                    dst.distance = parsed;
                }
                const position2d = src.getPosition2d();
                if(position2d !== null)
                {
                    const parsed = ng.geometry.Point2D.toObject(position2d);
                    if(parsed === null) return null;
                    dst.position2d = parsed;
                }
                const position3d = src.getPosition3d();
                if(position3d !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(position3d);
                    if(parsed === null) return null;
                    dst.position3d = parsed;
                }
                if(src.results !== null)
                {
                    const parsed = ng.result.Data.toObject(src.results);
                    if(parsed === null) return null;
                    dst.results = parsed;
                }
                if(src.resultsBowImp !== null)
                {
                    const parsed = ng.result.Data.toObject(src.resultsBowImp);
                    if(parsed === null) return null;
                    dst.resultsBowImp = parsed;
                }
                if(src.results2nd !== null)
                {
                    const parsed = ng.result.Data.toObject(src.results2nd);
                    if(parsed === null) return null;
                    dst.results2nd = parsed;
                }
                const rc = src.getRc();
                if(rc !== null)
                {
                    const parsed = ng.result.concrete.Data.toObject(rc);
                    if(parsed === null) return null;
                    dst.rc = parsed;
                }
                const steel = src.getSteel();
                if(steel !== null)
                {
                    const parsed = ng.result.steel.Data.toObject(steel);
                    if(parsed === null) return null;
                    dst.steel = parsed;
                }
                const timber = src.getTimber();
                if(timber !== null)
                {
                    const parsed = ng.result.timber.Data.toObject(timber);
                    if(parsed === null) return null;
                    dst.timber = parsed;
                }
                const foundation = src.getFoundation();
                if(foundation !== null)
                {
                    const parsed = ng.result.foundation.Data.toObject(foundation);
                    if(parsed === null) return null;
                    dst.foundation = parsed;
                }
                const pile = src.getPile();
                if(pile !== null)
                {
                    const parsed = ng.result.pile.Data.toObject(pile);
                    if(parsed === null) return null;
                    dst.pile = parsed;
                }
                const retainingWall = src.getRetainingWall();
                if(retainingWall !== null)
                {
                    const parsed = ng.result.retaining_wall.Data.toObject(retainingWall);
                    if(parsed === null) return null;
                    dst.retainingWall = parsed;
                }
                return dst;
            }

            static create(src?: PositionResult_createType) {
                const dst = new PositionResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                // part of the position oneof 
                if (src.distance !== undefined && src.distance !== null) {
                    dst.setDistance(src.distance);
                }
                // part of the position oneof 
                if (src.position2d !== undefined && src.position2d !== null) {
                    dst.setPosition2d(src.position2d);
                }
                // part of the position oneof 
                if (src.position3d !== undefined && src.position3d !== null) {
                    dst.setPosition3d(src.position3d);
                }
                if (src.results !== undefined) {
                    dst.results = src.results;
                }
                if (src.resultsBowImp !== undefined) {
                    dst.resultsBowImp = src.resultsBowImp;
                }
                if (src.results2nd !== undefined) {
                    dst.results2nd = src.results2nd;
                }
                // part of the design oneof 
                if (src.rc !== undefined && src.rc !== null) {
                    dst.setRc(src.rc);
                }
                // part of the design oneof 
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(src.steel);
                }
                // part of the design oneof 
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(src.timber);
                }
                // part of the design oneof 
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(src.foundation);
                }
                // part of the design oneof 
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(src.pile);
                }
                // part of the design oneof 
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(src.retainingWall);
                }
                if (src.groupName !== undefined) {
                    dst.groupName = src.groupName;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PositionResult();
                dst.id = this.id;
                dst.position = this.position;
                dst.results = this.results;
                dst.resultsBowImp = this.resultsBowImp;
                dst.results2nd = this.results2nd;
                dst.design = this.design;
                dst.groupName = this.groupName;
                return dst;
            }

            deepClone() {
                const json = PositionResult.toObject(this);
                const dst = PositionResult.fromObject(json);
                return dst;
            }
        }
        export type IPositionResult = PositionResult;


        // defined in Result/result.proto
        export type ElementResult_keys = 'rc' | 'steel' | 'timber' | 'foundation' | 'pile' | 'retainingWall';
        export interface ElementResult_createType {
            rc?: ng.result.concrete.Element | null,
            steel?: ng.result.steel.Element | null,
            timber?: ng.result.timber.Element | null,
            foundation?: ng.result.foundation.Element | null,
            pile?: ng.result.pile.Element | null,
            retainingWall?: ng.result.retaining_wall.Element | null,
        }
        export interface ElementResult_json {
            rc?: ng.result.concrete.Element_json;
            steel?: ng.result.steel.Element_json;
            timber?: ng.result.timber.Element_json;
            foundation?: ng.result.foundation.Element_json;
            pile?: ng.result.pile.Element_json;
            retainingWall?: ng.result.retaining_wall.Element_json;
        }
        interface ElementResult_json_in {
            __proto_name?: unknown;
            rc?: unknown;
            steel?: unknown;
            timber?: unknown;
            foundation?: unknown;
            pile?: unknown;
            retainingWall?: unknown;
        }
        export class ElementResult {
            __proto_name = "ng.result.ElementResult";
            // this is a one of
            design: {type: 'rc'; rc: ng.result.concrete.Element} | {type: 'steel'; steel: ng.result.steel.Element} | {type: 'timber'; timber: ng.result.timber.Element} | {type: 'foundation'; foundation: ng.result.foundation.Element} | {type: 'pile'; pile: ng.result.pile.Element} | {type: 'retainingWall'; retainingWall: ng.result.retaining_wall.Element} | null = null;

            /** Gets the `Rc` value (or null) from the oneof `design` */
            getRc(): ng.result.concrete.Element | null {
                if(this.design === null) return null;
                if(this.design.type !== 'rc') return null;
                return this.design.rc;
            }

            /** Sets the `Rc` value for the oneof `design`*/
            setRc(value: ng.result.concrete.Element | null) {
                if(value !== null) {
                    this.design = {type: 'rc', rc:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Steel` value (or null) from the oneof `design` */
            getSteel(): ng.result.steel.Element | null {
                if(this.design === null) return null;
                if(this.design.type !== 'steel') return null;
                return this.design.steel;
            }

            /** Sets the `Steel` value for the oneof `design`*/
            setSteel(value: ng.result.steel.Element | null) {
                if(value !== null) {
                    this.design = {type: 'steel', steel:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Timber` value (or null) from the oneof `design` */
            getTimber(): ng.result.timber.Element | null {
                if(this.design === null) return null;
                if(this.design.type !== 'timber') return null;
                return this.design.timber;
            }

            /** Sets the `Timber` value for the oneof `design`*/
            setTimber(value: ng.result.timber.Element | null) {
                if(value !== null) {
                    this.design = {type: 'timber', timber:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Foundation` value (or null) from the oneof `design` */
            getFoundation(): ng.result.foundation.Element | null {
                if(this.design === null) return null;
                if(this.design.type !== 'foundation') return null;
                return this.design.foundation;
            }

            /** Sets the `Foundation` value for the oneof `design`*/
            setFoundation(value: ng.result.foundation.Element | null) {
                if(value !== null) {
                    this.design = {type: 'foundation', foundation:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `Pile` value (or null) from the oneof `design` */
            getPile(): ng.result.pile.Element | null {
                if(this.design === null) return null;
                if(this.design.type !== 'pile') return null;
                return this.design.pile;
            }

            /** Sets the `Pile` value for the oneof `design`*/
            setPile(value: ng.result.pile.Element | null) {
                if(value !== null) {
                    this.design = {type: 'pile', pile:value};
                }
                else {
                    this.design = null;
                }
            }

            /** Gets the `RetainingWall` value (or null) from the oneof `design` */
            getRetainingWall(): ng.result.retaining_wall.Element | null {
                if(this.design === null) return null;
                if(this.design.type !== 'retainingWall') return null;
                return this.design.retainingWall;
            }

            /** Sets the `RetainingWall` value for the oneof `design`*/
            setRetainingWall(value: ng.result.retaining_wall.Element | null) {
                if(value !== null) {
                    this.design = {type: 'retainingWall', retainingWall:value};
                }
                else {
                    this.design = null;
                }
            }

            static fromObject(src_unknown: unknown): ElementResult {
                const dst = new ElementResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ElementResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ElementResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ElementResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.rc !== undefined && src.rc !== null) {
                    dst.setRc(ng.result.concrete.Element.fromObject(src.rc));
                }
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(ng.result.steel.Element.fromObject(src.steel));
                }
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(ng.result.timber.Element.fromObject(src.timber));
                }
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(ng.result.foundation.Element.fromObject(src.foundation));
                }
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(ng.result.pile.Element.fromObject(src.pile));
                }
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(ng.result.retaining_wall.Element.fromObject(src.retainingWall));
                }
                return dst;
            }

            static toObject(src: ElementResult | null | undefined): ElementResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.ElementResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.ElementResult") {
                    console.error('Expected ng.result.ElementResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ElementResult_json = {
                };
                const rc = src.getRc();
                if(rc !== null)
                {
                    const parsed = ng.result.concrete.Element.toObject(rc);
                    if(parsed === null) return null;
                    dst.rc = parsed;
                }
                const steel = src.getSteel();
                if(steel !== null)
                {
                    const parsed = ng.result.steel.Element.toObject(steel);
                    if(parsed === null) return null;
                    dst.steel = parsed;
                }
                const timber = src.getTimber();
                if(timber !== null)
                {
                    const parsed = ng.result.timber.Element.toObject(timber);
                    if(parsed === null) return null;
                    dst.timber = parsed;
                }
                const foundation = src.getFoundation();
                if(foundation !== null)
                {
                    const parsed = ng.result.foundation.Element.toObject(foundation);
                    if(parsed === null) return null;
                    dst.foundation = parsed;
                }
                const pile = src.getPile();
                if(pile !== null)
                {
                    const parsed = ng.result.pile.Element.toObject(pile);
                    if(parsed === null) return null;
                    dst.pile = parsed;
                }
                const retainingWall = src.getRetainingWall();
                if(retainingWall !== null)
                {
                    const parsed = ng.result.retaining_wall.Element.toObject(retainingWall);
                    if(parsed === null) return null;
                    dst.retainingWall = parsed;
                }
                return dst;
            }

            static create(src?: ElementResult_createType) {
                const dst = new ElementResult();
                if (src === undefined) {
                    return dst;
                }
                // part of the design oneof 
                if (src.rc !== undefined && src.rc !== null) {
                    dst.setRc(src.rc);
                }
                // part of the design oneof 
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(src.steel);
                }
                // part of the design oneof 
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(src.timber);
                }
                // part of the design oneof 
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(src.foundation);
                }
                // part of the design oneof 
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(src.pile);
                }
                // part of the design oneof 
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(src.retainingWall);
                }
                return dst;
            }

            shallowClone() {
                const dst = new ElementResult();
                dst.design = this.design;
                return dst;
            }

            deepClone() {
                const json = ElementResult.toObject(this);
                const dst = ElementResult.fromObject(json);
                return dst;
            }
        }
        export type IElementResult = ElementResult;


        // defined in Result/result.proto
        export type Element_keys = 'id' | 'positions' | 'introducedPositions' | 'result';
        export interface Element_createType {
            id?: ng.utils.ID | null,
            positions?: ng.result.PositionResult[],
            introducedPositions?: ng.result.PositionResult[],
            result?: ng.result.ElementResult | null,
        }
        export interface Element_json {
            id?: ng.utils.ID_json;
            positions: ng.result.PositionResult_json[];
            introducedPositions: ng.result.PositionResult_json[];
            result?: ng.result.ElementResult_json;
        }
        interface Element_json_in {
            __proto_name?: unknown;
            id?: unknown;
            positions?: unknown;
            introducedPositions?: unknown;
            result?: unknown;
        }
        export class Element {
            __proto_name = "ng.result.Element";
            id: ng.utils.ID | null = null;
            positions: ng.result.PositionResult[] = [];
            introducedPositions: ng.result.PositionResult[] = [];
            result: ng.result.ElementResult | null = null;

            static fromObject(src_unknown: unknown): Element {
                const dst = new Element();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Element but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Element_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.positions !== undefined && src.positions !== null) {
                    if (Array.isArray(src.positions)) {
                        for (const element of src.positions) {
                            dst.positions.push(ng.result.PositionResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected positions of Element to be a array but was ', typeof src.positions, src.positions)
                    }
                }
                if (src.introducedPositions !== undefined && src.introducedPositions !== null) {
                    if (Array.isArray(src.introducedPositions)) {
                        for (const element of src.introducedPositions) {
                            dst.introducedPositions.push(ng.result.PositionResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected introducedPositions of Element to be a array but was ', typeof src.introducedPositions, src.introducedPositions)
                    }
                }
                if (src.result !== undefined && src.result !== null) {
                    dst.result = ng.result.ElementResult.fromObject(src.result);
                }
                return dst;
            }

            static toObject(src: Element | null | undefined): Element_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.Element is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.Element") {
                    console.error('Expected ng.result.Element but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Element_json = {
                    positions: new Array<ng.result.PositionResult_json>(),
                    introducedPositions: new Array<ng.result.PositionResult_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.positions !== null) {
                    for (const element of src.positions) {
                        const parsed = ng.result.PositionResult.toObject(element);
                        if(parsed === null) return null;
                        dst.positions.push(parsed);
                    }
                }
                if (src.introducedPositions !== null) {
                    for (const element of src.introducedPositions) {
                        const parsed = ng.result.PositionResult.toObject(element);
                        if(parsed === null) return null;
                        dst.introducedPositions.push(parsed);
                    }
                }
                if(src.result !== null)
                {
                    const parsed = ng.result.ElementResult.toObject(src.result);
                    if(parsed === null) return null;
                    dst.result = parsed;
                }
                return dst;
            }

            static create(src?: Element_createType) {
                const dst = new Element();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.positions !== undefined) {
                    dst.positions = src.positions;
                }
                if (src.introducedPositions !== undefined) {
                    dst.introducedPositions = src.introducedPositions;
                }
                if (src.result !== undefined) {
                    dst.result = src.result;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Element();
                dst.id = this.id;
                dst.positions = this.positions;
                dst.introducedPositions = this.introducedPositions;
                dst.result = this.result;
                return dst;
            }

            deepClone() {
                const json = Element.toObject(this);
                const dst = Element.fromObject(json);
                return dst;
            }
        }
        export type IElement = Element;


        // defined in Result/result.proto
        export type Node_keys = 'results' | 'resultsBowImp' | 'results2nd';
        export interface Node_createType {
            results?: ng.result.Data | null,
            resultsBowImp?: ng.result.Data | null,
            results2nd?: ng.result.Data | null,
        }
        export interface Node_json {
            results?: ng.result.Data_json;
            resultsBowImp?: ng.result.Data_json;
            results2nd?: ng.result.Data_json;
        }
        interface Node_json_in {
            __proto_name?: unknown;
            results?: unknown;
            resultsBowImp?: unknown;
            results2nd?: unknown;
        }
        export class Node {
            __proto_name = "ng.result.Node";
            results: ng.result.Data | null = null;
            resultsBowImp: ng.result.Data | null = null;
            results2nd: ng.result.Data | null = null;

            static fromObject(src_unknown: unknown): Node {
                const dst = new Node();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Node but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Node_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Node but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.results !== undefined && src.results !== null) {
                    dst.results = ng.result.Data.fromObject(src.results);
                }
                if (src.resultsBowImp !== undefined && src.resultsBowImp !== null) {
                    dst.resultsBowImp = ng.result.Data.fromObject(src.resultsBowImp);
                }
                if (src.results2nd !== undefined && src.results2nd !== null) {
                    dst.results2nd = ng.result.Data.fromObject(src.results2nd);
                }
                return dst;
            }

            static toObject(src: Node | null | undefined): Node_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.result.Node is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.result.Node") {
                    console.error('Expected ng.result.Node but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Node_json = {
                };
                if(src.results !== null)
                {
                    const parsed = ng.result.Data.toObject(src.results);
                    if(parsed === null) return null;
                    dst.results = parsed;
                }
                if(src.resultsBowImp !== null)
                {
                    const parsed = ng.result.Data.toObject(src.resultsBowImp);
                    if(parsed === null) return null;
                    dst.resultsBowImp = parsed;
                }
                if(src.results2nd !== null)
                {
                    const parsed = ng.result.Data.toObject(src.results2nd);
                    if(parsed === null) return null;
                    dst.results2nd = parsed;
                }
                return dst;
            }

            static create(src?: Node_createType) {
                const dst = new Node();
                if (src === undefined) {
                    return dst;
                }
                if (src.results !== undefined) {
                    dst.results = src.results;
                }
                if (src.resultsBowImp !== undefined) {
                    dst.resultsBowImp = src.resultsBowImp;
                }
                if (src.results2nd !== undefined) {
                    dst.results2nd = src.results2nd;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Node();
                dst.results = this.results;
                dst.resultsBowImp = this.resultsBowImp;
                dst.results2nd = this.results2nd;
                return dst;
            }

            deepClone() {
                const json = Node.toObject(this);
                const dst = Node.fromObject(json);
                return dst;
            }
        }
        export type INode = Node;


        // Defined in Result/timber.proto
        export namespace timber {
            export enum StatSys {
                STAT_SYS_UNSPECIFIED = 0,
                STAT_SYS_SIMPLE_SUPPORTED = 1,
                STAT_SYS_CANTILEVER = 2
            }
            export const StatSys_FromObject = (src: unknown): StatSys => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'STAT_SYS_UNSPECIFIED':
                        return StatSys.STAT_SYS_UNSPECIFIED;
                    case 1:
                    case 'STAT_SYS_SIMPLE_SUPPORTED':
                        return StatSys.STAT_SYS_SIMPLE_SUPPORTED;
                    case 2:
                    case 'STAT_SYS_CANTILEVER':
                        return StatSys.STAT_SYS_CANTILEVER;
                    default:
                        console.log('Unhandled value for StatSys:' + src + '. ' + typeof(src));
                        return StatSys.STAT_SYS_UNSPECIFIED;
                }
            };
            export const StatSys_ToObject = (src: StatSys): string | null => {
                switch (src) {
                    case StatSys.STAT_SYS_UNSPECIFIED:
                        return 'STAT_SYS_UNSPECIFIED';
                    case StatSys.STAT_SYS_SIMPLE_SUPPORTED:
                        return 'STAT_SYS_SIMPLE_SUPPORTED';
                    case StatSys.STAT_SYS_CANTILEVER:
                        return 'STAT_SYS_CANTILEVER';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for StatSys, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type Tension_keys = 'utilizationMy' | 'utilizationMz';
            export interface Tension_createType {
                utilizationMy?: number,
                utilizationMz?: number,
            }
            export interface Tension_json {
                utilizationMy?: JsonNumber;
                utilizationMz?: JsonNumber;
            }
            interface Tension_json_in {
                __proto_name?: unknown;
                utilizationMy?: unknown;
                utilizationMz?: unknown;
            }
            export class Tension {
                __proto_name = "ng.result.timber.Tension";
                utilizationMy: number = 0;
                utilizationMz: number = 0;

                static fromObject(src_unknown: unknown): Tension {
                    const dst = new Tension();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Tension but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Tension_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Tension but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.utilizationMy !== undefined && src.utilizationMy !== null) {
                        if (typeof src.utilizationMy === "number" || src.utilizationMy === 'NaN' || src.utilizationMy === 'Infinity' || src.utilizationMy === '-Infinity') {
                            dst.utilizationMy = AsNum(src.utilizationMy);
                        }
                        else {
                            console.log('Expected utilizationMy of Tension to be a number but was ', typeof src.utilizationMy, src.utilizationMy)
                        }
                    }
                    if (src.utilizationMz !== undefined && src.utilizationMz !== null) {
                        if (typeof src.utilizationMz === "number" || src.utilizationMz === 'NaN' || src.utilizationMz === 'Infinity' || src.utilizationMz === '-Infinity') {
                            dst.utilizationMz = AsNum(src.utilizationMz);
                        }
                        else {
                            console.log('Expected utilizationMz of Tension to be a number but was ', typeof src.utilizationMz, src.utilizationMz)
                        }
                    }
                    return dst;
                }

                static toObject(src: Tension | null | undefined): Tension_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.Tension is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.Tension") {
                        console.error('Expected ng.result.timber.Tension but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Tension_json = {
                        utilizationMy: AsJsonNum(src.utilizationMy),
                        utilizationMz: AsJsonNum(src.utilizationMz),
                    };
                    return dst;
                }

                static create(src?: Tension_createType) {
                    const dst = new Tension();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.utilizationMy !== undefined) {
                        dst.utilizationMy = src.utilizationMy;
                    }
                    if (src.utilizationMz !== undefined) {
                        dst.utilizationMz = src.utilizationMz;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Tension();
                    dst.utilizationMy = this.utilizationMy;
                    dst.utilizationMz = this.utilizationMz;
                    return dst;
                }

                deepClone() {
                    const json = Tension.toObject(this);
                    const dst = Tension.fromObject(json);
                    return dst;
                }
            }
            export type ITension = Tension;


            export type Compression_keys = 'utilizationN' | 'utilizationMy' | 'utilizationMz';
            export interface Compression_createType {
                utilizationN?: number,
                utilizationMy?: number,
                utilizationMz?: number,
            }
            export interface Compression_json {
                utilizationN?: JsonNumber;
                utilizationMy?: JsonNumber;
                utilizationMz?: JsonNumber;
            }
            interface Compression_json_in {
                __proto_name?: unknown;
                utilizationN?: unknown;
                utilizationMy?: unknown;
                utilizationMz?: unknown;
            }
            export class Compression {
                __proto_name = "ng.result.timber.Compression";
                utilizationN: number = 0;
                utilizationMy: number = 0;
                utilizationMz: number = 0;

                static fromObject(src_unknown: unknown): Compression {
                    const dst = new Compression();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Compression but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Compression_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Compression but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.utilizationN !== undefined && src.utilizationN !== null) {
                        if (typeof src.utilizationN === "number" || src.utilizationN === 'NaN' || src.utilizationN === 'Infinity' || src.utilizationN === '-Infinity') {
                            dst.utilizationN = AsNum(src.utilizationN);
                        }
                        else {
                            console.log('Expected utilizationN of Compression to be a number but was ', typeof src.utilizationN, src.utilizationN)
                        }
                    }
                    if (src.utilizationMy !== undefined && src.utilizationMy !== null) {
                        if (typeof src.utilizationMy === "number" || src.utilizationMy === 'NaN' || src.utilizationMy === 'Infinity' || src.utilizationMy === '-Infinity') {
                            dst.utilizationMy = AsNum(src.utilizationMy);
                        }
                        else {
                            console.log('Expected utilizationMy of Compression to be a number but was ', typeof src.utilizationMy, src.utilizationMy)
                        }
                    }
                    if (src.utilizationMz !== undefined && src.utilizationMz !== null) {
                        if (typeof src.utilizationMz === "number" || src.utilizationMz === 'NaN' || src.utilizationMz === 'Infinity' || src.utilizationMz === '-Infinity') {
                            dst.utilizationMz = AsNum(src.utilizationMz);
                        }
                        else {
                            console.log('Expected utilizationMz of Compression to be a number but was ', typeof src.utilizationMz, src.utilizationMz)
                        }
                    }
                    return dst;
                }

                static toObject(src: Compression | null | undefined): Compression_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.Compression is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.Compression") {
                        console.error('Expected ng.result.timber.Compression but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Compression_json = {
                        utilizationN: AsJsonNum(src.utilizationN),
                        utilizationMy: AsJsonNum(src.utilizationMy),
                        utilizationMz: AsJsonNum(src.utilizationMz),
                    };
                    return dst;
                }

                static create(src?: Compression_createType) {
                    const dst = new Compression();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.utilizationN !== undefined) {
                        dst.utilizationN = src.utilizationN;
                    }
                    if (src.utilizationMy !== undefined) {
                        dst.utilizationMy = src.utilizationMy;
                    }
                    if (src.utilizationMz !== undefined) {
                        dst.utilizationMz = src.utilizationMz;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Compression();
                    dst.utilizationN = this.utilizationN;
                    dst.utilizationMy = this.utilizationMy;
                    dst.utilizationMz = this.utilizationMz;
                    return dst;
                }

                deepClone() {
                    const json = Compression.toObject(this);
                    const dst = Compression.fromObject(json);
                    return dst;
                }
            }
            export type ICompression = Compression;


            export type Shear_keys = 'tauD' | 'utilization';
            export interface Shear_createType {
                tauD?: number,
                utilization?: number,
            }
            export interface Shear_json {
                tauD?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface Shear_json_in {
                __proto_name?: unknown;
                tauD?: unknown;
                utilization?: unknown;
            }
            export class Shear {
                __proto_name = "ng.result.timber.Shear";
                tauD: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): Shear {
                    const dst = new Shear();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Shear but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Shear_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Shear but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.tauD !== undefined && src.tauD !== null) {
                        if (typeof src.tauD === "number" || src.tauD === 'NaN' || src.tauD === 'Infinity' || src.tauD === '-Infinity') {
                            dst.tauD = AsNum(src.tauD);
                        }
                        else {
                            console.log('Expected tauD of Shear to be a number but was ', typeof src.tauD, src.tauD)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Shear to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: Shear | null | undefined): Shear_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.Shear is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.Shear") {
                        console.error('Expected ng.result.timber.Shear but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Shear_json = {
                        tauD: AsJsonNum(src.tauD),
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: Shear_createType) {
                    const dst = new Shear();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.tauD !== undefined) {
                        dst.tauD = src.tauD;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Shear();
                    dst.tauD = this.tauD;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = Shear.toObject(this);
                    const dst = Shear.fromObject(json);
                    return dst;
                }
            }
            export type IShear = Shear;


            export type FlexuralBuckling_keys = 'kc' | 'utilization' | 'flexuralBucklingParameters';
            export interface FlexuralBuckling_createType {
                kc?: number,
                utilization?: number,
                flexuralBucklingParameters?: ng.result.timber.FlexBucklingParameters | null,
            }
            export interface FlexuralBuckling_json {
                kc?: JsonNumber;
                utilization?: JsonNumber;
                flexuralBucklingParameters?: ng.result.timber.FlexBucklingParameters_json;
            }
            interface FlexuralBuckling_json_in {
                __proto_name?: unknown;
                kc?: unknown;
                utilization?: unknown;
                flexuralBucklingParameters?: unknown;
            }
            export class FlexuralBuckling {
                __proto_name = "ng.result.timber.FlexuralBuckling";
                kc: number = 0;
                utilization: number = 0;
                flexuralBucklingParameters: ng.result.timber.FlexBucklingParameters | null = null;

                static fromObject(src_unknown: unknown): FlexuralBuckling {
                    const dst = new FlexuralBuckling();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FlexuralBuckling but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FlexuralBuckling_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FlexuralBuckling but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kc !== undefined && src.kc !== null) {
                        if (typeof src.kc === "number" || src.kc === 'NaN' || src.kc === 'Infinity' || src.kc === '-Infinity') {
                            dst.kc = AsNum(src.kc);
                        }
                        else {
                            console.log('Expected kc of FlexuralBuckling to be a number but was ', typeof src.kc, src.kc)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of FlexuralBuckling to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.flexuralBucklingParameters !== undefined && src.flexuralBucklingParameters !== null) {
                        dst.flexuralBucklingParameters = ng.result.timber.FlexBucklingParameters.fromObject(src.flexuralBucklingParameters);
                    }
                    return dst;
                }

                static toObject(src: FlexuralBuckling | null | undefined): FlexuralBuckling_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.FlexuralBuckling is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.FlexuralBuckling") {
                        console.error('Expected ng.result.timber.FlexuralBuckling but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FlexuralBuckling_json = {
                        kc: AsJsonNum(src.kc),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.flexuralBucklingParameters !== null)
                    {
                        const parsed = ng.result.timber.FlexBucklingParameters.toObject(src.flexuralBucklingParameters);
                        if(parsed === null) return null;
                        dst.flexuralBucklingParameters = parsed;
                    }
                    return dst;
                }

                static create(src?: FlexuralBuckling_createType) {
                    const dst = new FlexuralBuckling();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kc !== undefined) {
                        dst.kc = src.kc;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.flexuralBucklingParameters !== undefined) {
                        dst.flexuralBucklingParameters = src.flexuralBucklingParameters;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FlexuralBuckling();
                    dst.kc = this.kc;
                    dst.utilization = this.utilization;
                    dst.flexuralBucklingParameters = this.flexuralBucklingParameters;
                    return dst;
                }

                deepClone() {
                    const json = FlexuralBuckling.toObject(this);
                    const dst = FlexuralBuckling.fromObject(json);
                    return dst;
                }
            }
            export type IFlexuralBuckling = FlexuralBuckling;


            export type TorsionalBuckling_keys = 'kcrit' | 'utilization' | 'torsionalBucklingParameters' | 'torsionalBucklingStrength';
            export interface TorsionalBuckling_createType {
                kcrit?: number,
                utilization?: ng.geometry.Vector2D | null,
                torsionalBucklingParameters?: ng.result.timber.TorsionalBucklingParameters | null,
                torsionalBucklingStrength?: ng.result.timber.TorsionalBucklingStrength | null,
            }
            export interface TorsionalBuckling_json {
                kcrit?: JsonNumber;
                utilization?: ng.geometry.Vector2D_json;
                torsionalBucklingParameters?: ng.result.timber.TorsionalBucklingParameters_json;
                torsionalBucklingStrength?: ng.result.timber.TorsionalBucklingStrength_json;
            }
            interface TorsionalBuckling_json_in {
                __proto_name?: unknown;
                kcrit?: unknown;
                utilization?: unknown;
                torsionalBucklingParameters?: unknown;
                torsionalBucklingStrength?: unknown;
            }
            export class TorsionalBuckling {
                __proto_name = "ng.result.timber.TorsionalBuckling";
                kcrit: number = 0;
                utilization: ng.geometry.Vector2D | null = null;
                torsionalBucklingParameters: ng.result.timber.TorsionalBucklingParameters | null = null;
                torsionalBucklingStrength: ng.result.timber.TorsionalBucklingStrength | null = null;

                static fromObject(src_unknown: unknown): TorsionalBuckling {
                    const dst = new TorsionalBuckling();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TorsionalBuckling but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TorsionalBuckling_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TorsionalBuckling but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kcrit !== undefined && src.kcrit !== null) {
                        if (typeof src.kcrit === "number" || src.kcrit === 'NaN' || src.kcrit === 'Infinity' || src.kcrit === '-Infinity') {
                            dst.kcrit = AsNum(src.kcrit);
                        }
                        else {
                            console.log('Expected kcrit of TorsionalBuckling to be a number but was ', typeof src.kcrit, src.kcrit)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        dst.utilization = ng.geometry.Vector2D.fromObject(src.utilization);
                    }
                    if (src.torsionalBucklingParameters !== undefined && src.torsionalBucklingParameters !== null) {
                        dst.torsionalBucklingParameters = ng.result.timber.TorsionalBucklingParameters.fromObject(src.torsionalBucklingParameters);
                    }
                    if (src.torsionalBucklingStrength !== undefined && src.torsionalBucklingStrength !== null) {
                        dst.torsionalBucklingStrength = ng.result.timber.TorsionalBucklingStrength.fromObject(src.torsionalBucklingStrength);
                    }
                    return dst;
                }

                static toObject(src: TorsionalBuckling | null | undefined): TorsionalBuckling_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.TorsionalBuckling is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.TorsionalBuckling") {
                        console.error('Expected ng.result.timber.TorsionalBuckling but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : TorsionalBuckling_json = {
                        kcrit: AsJsonNum(src.kcrit),
                    };
                    if(src.utilization !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.utilization);
                        if(parsed === null) return null;
                        dst.utilization = parsed;
                    }
                    if(src.torsionalBucklingParameters !== null)
                    {
                        const parsed = ng.result.timber.TorsionalBucklingParameters.toObject(src.torsionalBucklingParameters);
                        if(parsed === null) return null;
                        dst.torsionalBucklingParameters = parsed;
                    }
                    if(src.torsionalBucklingStrength !== null)
                    {
                        const parsed = ng.result.timber.TorsionalBucklingStrength.toObject(src.torsionalBucklingStrength);
                        if(parsed === null) return null;
                        dst.torsionalBucklingStrength = parsed;
                    }
                    return dst;
                }

                static create(src?: TorsionalBuckling_createType) {
                    const dst = new TorsionalBuckling();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kcrit !== undefined) {
                        dst.kcrit = src.kcrit;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.torsionalBucklingParameters !== undefined) {
                        dst.torsionalBucklingParameters = src.torsionalBucklingParameters;
                    }
                    if (src.torsionalBucklingStrength !== undefined) {
                        dst.torsionalBucklingStrength = src.torsionalBucklingStrength;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TorsionalBuckling();
                    dst.kcrit = this.kcrit;
                    dst.utilization = this.utilization;
                    dst.torsionalBucklingParameters = this.torsionalBucklingParameters;
                    dst.torsionalBucklingStrength = this.torsionalBucklingStrength;
                    return dst;
                }

                deepClone() {
                    const json = TorsionalBuckling.toObject(this);
                    const dst = TorsionalBuckling.fromObject(json);
                    return dst;
                }
            }
            export type ITorsionalBuckling = TorsionalBuckling;


            export type Apex_keys = 'fRelevantBending' | 'fRelevantTension' | 'mAp' | 'sigmamd' | 'sigmat90d' | 'utilization';
            export interface Apex_createType {
                fRelevantBending?: boolean,
                fRelevantTension?: boolean,
                mAp?: number,
                sigmamd?: number,
                sigmat90d?: number,
                utilization?: ng.geometry.Vector2D | null,
            }
            export interface Apex_json {
                fRelevantBending?: boolean;
                fRelevantTension?: boolean;
                mAp?: JsonNumber;
                sigmamd?: JsonNumber;
                sigmat90d?: JsonNumber;
                utilization?: ng.geometry.Vector2D_json;
            }
            interface Apex_json_in {
                __proto_name?: unknown;
                fRelevantBending?: unknown;
                fRelevantTension?: unknown;
                mAp?: unknown;
                sigmamd?: unknown;
                sigmat90d?: unknown;
                utilization?: unknown;
            }
            export class Apex {
                __proto_name = "ng.result.timber.Apex";
                fRelevantBending: boolean = false;
                fRelevantTension: boolean = false;
                mAp: number = 0;
                sigmamd: number = 0;
                sigmat90d: number = 0;
                utilization: ng.geometry.Vector2D | null = null;

                static fromObject(src_unknown: unknown): Apex {
                    const dst = new Apex();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Apex but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Apex_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Apex but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevantBending !== undefined && src.fRelevantBending !== null) {
                        if (typeof src.fRelevantBending === "boolean") {
                            dst.fRelevantBending = src.fRelevantBending;
                        }
                        else {
                            console.log('Expected fRelevantBending of Apex to be a boolean but was ', typeof src.fRelevantBending, src.fRelevantBending)
                        }
                    }
                    if (src.fRelevantTension !== undefined && src.fRelevantTension !== null) {
                        if (typeof src.fRelevantTension === "boolean") {
                            dst.fRelevantTension = src.fRelevantTension;
                        }
                        else {
                            console.log('Expected fRelevantTension of Apex to be a boolean but was ', typeof src.fRelevantTension, src.fRelevantTension)
                        }
                    }
                    if (src.mAp !== undefined && src.mAp !== null) {
                        if (typeof src.mAp === "number" || src.mAp === 'NaN' || src.mAp === 'Infinity' || src.mAp === '-Infinity') {
                            dst.mAp = AsNum(src.mAp);
                        }
                        else {
                            console.log('Expected mAp of Apex to be a number but was ', typeof src.mAp, src.mAp)
                        }
                    }
                    if (src.sigmamd !== undefined && src.sigmamd !== null) {
                        if (typeof src.sigmamd === "number" || src.sigmamd === 'NaN' || src.sigmamd === 'Infinity' || src.sigmamd === '-Infinity') {
                            dst.sigmamd = AsNum(src.sigmamd);
                        }
                        else {
                            console.log('Expected sigmamd of Apex to be a number but was ', typeof src.sigmamd, src.sigmamd)
                        }
                    }
                    if (src.sigmat90d !== undefined && src.sigmat90d !== null) {
                        if (typeof src.sigmat90d === "number" || src.sigmat90d === 'NaN' || src.sigmat90d === 'Infinity' || src.sigmat90d === '-Infinity') {
                            dst.sigmat90d = AsNum(src.sigmat90d);
                        }
                        else {
                            console.log('Expected sigmat90d of Apex to be a number but was ', typeof src.sigmat90d, src.sigmat90d)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        dst.utilization = ng.geometry.Vector2D.fromObject(src.utilization);
                    }
                    return dst;
                }

                static toObject(src: Apex | null | undefined): Apex_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.Apex is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.Apex") {
                        console.error('Expected ng.result.timber.Apex but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Apex_json = {
                        fRelevantBending: src.fRelevantBending,
                        fRelevantTension: src.fRelevantTension,
                        mAp: AsJsonNum(src.mAp),
                        sigmamd: AsJsonNum(src.sigmamd),
                        sigmat90d: AsJsonNum(src.sigmat90d),
                    };
                    if(src.utilization !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.utilization);
                        if(parsed === null) return null;
                        dst.utilization = parsed;
                    }
                    return dst;
                }

                static create(src?: Apex_createType) {
                    const dst = new Apex();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevantBending !== undefined) {
                        dst.fRelevantBending = src.fRelevantBending;
                    }
                    if (src.fRelevantTension !== undefined) {
                        dst.fRelevantTension = src.fRelevantTension;
                    }
                    if (src.mAp !== undefined) {
                        dst.mAp = src.mAp;
                    }
                    if (src.sigmamd !== undefined) {
                        dst.sigmamd = src.sigmamd;
                    }
                    if (src.sigmat90d !== undefined) {
                        dst.sigmat90d = src.sigmat90d;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Apex();
                    dst.fRelevantBending = this.fRelevantBending;
                    dst.fRelevantTension = this.fRelevantTension;
                    dst.mAp = this.mAp;
                    dst.sigmamd = this.sigmamd;
                    dst.sigmat90d = this.sigmat90d;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = Apex.toObject(this);
                    const dst = Apex.fromObject(json);
                    return dst;
                }
            }
            export type IApex = Apex;


            export type Taper_keys = 'kmalpha';
            export interface Taper_createType {
                kmalpha?: number,
            }
            export interface Taper_json {
                kmalpha?: JsonNumber;
            }
            interface Taper_json_in {
                __proto_name?: unknown;
                kmalpha?: unknown;
            }
            export class Taper {
                __proto_name = "ng.result.timber.Taper";
                kmalpha: number = 0;

                static fromObject(src_unknown: unknown): Taper {
                    const dst = new Taper();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Taper but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Taper_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Taper but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kmalpha !== undefined && src.kmalpha !== null) {
                        if (typeof src.kmalpha === "number" || src.kmalpha === 'NaN' || src.kmalpha === 'Infinity' || src.kmalpha === '-Infinity') {
                            dst.kmalpha = AsNum(src.kmalpha);
                        }
                        else {
                            console.log('Expected kmalpha of Taper to be a number but was ', typeof src.kmalpha, src.kmalpha)
                        }
                    }
                    return dst;
                }

                static toObject(src: Taper | null | undefined): Taper_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.Taper is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.Taper") {
                        console.error('Expected ng.result.timber.Taper but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Taper_json = {
                        kmalpha: AsJsonNum(src.kmalpha),
                    };
                    return dst;
                }

                static create(src?: Taper_createType) {
                    const dst = new Taper();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kmalpha !== undefined) {
                        dst.kmalpha = src.kmalpha;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Taper();
                    dst.kmalpha = this.kmalpha;
                    return dst;
                }

                deepClone() {
                    const json = Taper.toObject(this);
                    const dst = Taper.fromObject(json);
                    return dst;
                }
            }
            export type ITaper = Taper;


            export type SectionResult_keys = 'tension' | 'compression' | 'shear' | 'flexuralBuckling1' | 'flexuralBuckling2' | 'torsionalBuckling' | 'apex' | 'taper' | 'sigmad0' | 'sigmayd' | 'sigmaz0' | 'kmod' | 'designStrength' | 'controlData';
            export interface SectionResult_createType {
                tension?: ng.result.timber.Tension | null,
                compression?: ng.result.timber.Compression | null,
                shear?: ng.result.timber.Shear | null,
                flexuralBuckling1?: ng.result.timber.FlexuralBuckling | null,
                flexuralBuckling2?: ng.result.timber.FlexuralBuckling | null,
                torsionalBuckling?: ng.result.timber.TorsionalBuckling | null,
                apex?: ng.result.timber.Apex | null,
                taper?: ng.result.timber.Taper | null,
                sigmad0?: number,
                sigmayd?: number,
                sigmaz0?: number,
                kmod?: number,
                designStrength?: ng.result.timber.DesignStrength | null,
                controlData?: ng.result.control.ControlData[],
            }
            export interface SectionResult_json {
                tension?: ng.result.timber.Tension_json;
                compression?: ng.result.timber.Compression_json;
                shear?: ng.result.timber.Shear_json;
                flexuralBuckling1?: ng.result.timber.FlexuralBuckling_json;
                flexuralBuckling2?: ng.result.timber.FlexuralBuckling_json;
                torsionalBuckling?: ng.result.timber.TorsionalBuckling_json;
                apex?: ng.result.timber.Apex_json;
                taper?: ng.result.timber.Taper_json;
                sigmad0?: JsonNumber;
                sigmayd?: JsonNumber;
                sigmaz0?: JsonNumber;
                kmod?: JsonNumber;
                designStrength?: ng.result.timber.DesignStrength_json;
                controlData: ng.result.control.ControlData_json[];
            }
            interface SectionResult_json_in {
                __proto_name?: unknown;
                tension?: unknown;
                compression?: unknown;
                shear?: unknown;
                flexuralBuckling1?: unknown;
                flexuralBuckling2?: unknown;
                torsionalBuckling?: unknown;
                apex?: unknown;
                taper?: unknown;
                sigmad0?: unknown;
                sigmayd?: unknown;
                sigmaz0?: unknown;
                kmod?: unknown;
                designStrength?: unknown;
                controlData?: unknown;
            }
            export class SectionResult {
                __proto_name = "ng.result.timber.SectionResult";
                tension: ng.result.timber.Tension | null = null;
                compression: ng.result.timber.Compression | null = null;
                shear: ng.result.timber.Shear | null = null;
                flexuralBuckling1: ng.result.timber.FlexuralBuckling | null = null;
                flexuralBuckling2: ng.result.timber.FlexuralBuckling | null = null;
                torsionalBuckling: ng.result.timber.TorsionalBuckling | null = null;
                apex: ng.result.timber.Apex | null = null;
                taper: ng.result.timber.Taper | null = null;
                sigmad0: number = 0;
                sigmayd: number = 0;
                sigmaz0: number = 0;
                kmod: number = 0;
                designStrength: ng.result.timber.DesignStrength | null = null;
                controlData: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): SectionResult {
                    const dst = new SectionResult();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionResult but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionResult_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionResult but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.tension !== undefined && src.tension !== null) {
                        dst.tension = ng.result.timber.Tension.fromObject(src.tension);
                    }
                    if (src.compression !== undefined && src.compression !== null) {
                        dst.compression = ng.result.timber.Compression.fromObject(src.compression);
                    }
                    if (src.shear !== undefined && src.shear !== null) {
                        dst.shear = ng.result.timber.Shear.fromObject(src.shear);
                    }
                    if (src.flexuralBuckling1 !== undefined && src.flexuralBuckling1 !== null) {
                        dst.flexuralBuckling1 = ng.result.timber.FlexuralBuckling.fromObject(src.flexuralBuckling1);
                    }
                    if (src.flexuralBuckling2 !== undefined && src.flexuralBuckling2 !== null) {
                        dst.flexuralBuckling2 = ng.result.timber.FlexuralBuckling.fromObject(src.flexuralBuckling2);
                    }
                    if (src.torsionalBuckling !== undefined && src.torsionalBuckling !== null) {
                        dst.torsionalBuckling = ng.result.timber.TorsionalBuckling.fromObject(src.torsionalBuckling);
                    }
                    if (src.apex !== undefined && src.apex !== null) {
                        dst.apex = ng.result.timber.Apex.fromObject(src.apex);
                    }
                    if (src.taper !== undefined && src.taper !== null) {
                        dst.taper = ng.result.timber.Taper.fromObject(src.taper);
                    }
                    if (src.sigmad0 !== undefined && src.sigmad0 !== null) {
                        if (typeof src.sigmad0 === "number" || src.sigmad0 === 'NaN' || src.sigmad0 === 'Infinity' || src.sigmad0 === '-Infinity') {
                            dst.sigmad0 = AsNum(src.sigmad0);
                        }
                        else {
                            console.log('Expected sigmad0 of SectionResult to be a number but was ', typeof src.sigmad0, src.sigmad0)
                        }
                    }
                    if (src.sigmayd !== undefined && src.sigmayd !== null) {
                        if (typeof src.sigmayd === "number" || src.sigmayd === 'NaN' || src.sigmayd === 'Infinity' || src.sigmayd === '-Infinity') {
                            dst.sigmayd = AsNum(src.sigmayd);
                        }
                        else {
                            console.log('Expected sigmayd of SectionResult to be a number but was ', typeof src.sigmayd, src.sigmayd)
                        }
                    }
                    if (src.sigmaz0 !== undefined && src.sigmaz0 !== null) {
                        if (typeof src.sigmaz0 === "number" || src.sigmaz0 === 'NaN' || src.sigmaz0 === 'Infinity' || src.sigmaz0 === '-Infinity') {
                            dst.sigmaz0 = AsNum(src.sigmaz0);
                        }
                        else {
                            console.log('Expected sigmaz0 of SectionResult to be a number but was ', typeof src.sigmaz0, src.sigmaz0)
                        }
                    }
                    if (src.kmod !== undefined && src.kmod !== null) {
                        if (typeof src.kmod === "number" || src.kmod === 'NaN' || src.kmod === 'Infinity' || src.kmod === '-Infinity') {
                            dst.kmod = AsNum(src.kmod);
                        }
                        else {
                            console.log('Expected kmod of SectionResult to be a number but was ', typeof src.kmod, src.kmod)
                        }
                    }
                    if (src.designStrength !== undefined && src.designStrength !== null) {
                        dst.designStrength = ng.result.timber.DesignStrength.fromObject(src.designStrength);
                    }
                    if (src.controlData !== undefined && src.controlData !== null) {
                        if (Array.isArray(src.controlData)) {
                            for (const element of src.controlData) {
                                dst.controlData.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controlData of SectionResult to be a array but was ', typeof src.controlData, src.controlData)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionResult | null | undefined): SectionResult_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.SectionResult is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.SectionResult") {
                        console.error('Expected ng.result.timber.SectionResult but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionResult_json = {
                        sigmad0: AsJsonNum(src.sigmad0),
                        sigmayd: AsJsonNum(src.sigmayd),
                        sigmaz0: AsJsonNum(src.sigmaz0),
                        kmod: AsJsonNum(src.kmod),
                        controlData: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.tension !== null)
                    {
                        const parsed = ng.result.timber.Tension.toObject(src.tension);
                        if(parsed === null) return null;
                        dst.tension = parsed;
                    }
                    if(src.compression !== null)
                    {
                        const parsed = ng.result.timber.Compression.toObject(src.compression);
                        if(parsed === null) return null;
                        dst.compression = parsed;
                    }
                    if(src.shear !== null)
                    {
                        const parsed = ng.result.timber.Shear.toObject(src.shear);
                        if(parsed === null) return null;
                        dst.shear = parsed;
                    }
                    if(src.flexuralBuckling1 !== null)
                    {
                        const parsed = ng.result.timber.FlexuralBuckling.toObject(src.flexuralBuckling1);
                        if(parsed === null) return null;
                        dst.flexuralBuckling1 = parsed;
                    }
                    if(src.flexuralBuckling2 !== null)
                    {
                        const parsed = ng.result.timber.FlexuralBuckling.toObject(src.flexuralBuckling2);
                        if(parsed === null) return null;
                        dst.flexuralBuckling2 = parsed;
                    }
                    if(src.torsionalBuckling !== null)
                    {
                        const parsed = ng.result.timber.TorsionalBuckling.toObject(src.torsionalBuckling);
                        if(parsed === null) return null;
                        dst.torsionalBuckling = parsed;
                    }
                    if(src.apex !== null)
                    {
                        const parsed = ng.result.timber.Apex.toObject(src.apex);
                        if(parsed === null) return null;
                        dst.apex = parsed;
                    }
                    if(src.taper !== null)
                    {
                        const parsed = ng.result.timber.Taper.toObject(src.taper);
                        if(parsed === null) return null;
                        dst.taper = parsed;
                    }
                    if(src.designStrength !== null)
                    {
                        const parsed = ng.result.timber.DesignStrength.toObject(src.designStrength);
                        if(parsed === null) return null;
                        dst.designStrength = parsed;
                    }
                    if (src.controlData !== null) {
                        for (const element of src.controlData) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controlData.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: SectionResult_createType) {
                    const dst = new SectionResult();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.tension !== undefined) {
                        dst.tension = src.tension;
                    }
                    if (src.compression !== undefined) {
                        dst.compression = src.compression;
                    }
                    if (src.shear !== undefined) {
                        dst.shear = src.shear;
                    }
                    if (src.flexuralBuckling1 !== undefined) {
                        dst.flexuralBuckling1 = src.flexuralBuckling1;
                    }
                    if (src.flexuralBuckling2 !== undefined) {
                        dst.flexuralBuckling2 = src.flexuralBuckling2;
                    }
                    if (src.torsionalBuckling !== undefined) {
                        dst.torsionalBuckling = src.torsionalBuckling;
                    }
                    if (src.apex !== undefined) {
                        dst.apex = src.apex;
                    }
                    if (src.taper !== undefined) {
                        dst.taper = src.taper;
                    }
                    if (src.sigmad0 !== undefined) {
                        dst.sigmad0 = src.sigmad0;
                    }
                    if (src.sigmayd !== undefined) {
                        dst.sigmayd = src.sigmayd;
                    }
                    if (src.sigmaz0 !== undefined) {
                        dst.sigmaz0 = src.sigmaz0;
                    }
                    if (src.kmod !== undefined) {
                        dst.kmod = src.kmod;
                    }
                    if (src.designStrength !== undefined) {
                        dst.designStrength = src.designStrength;
                    }
                    if (src.controlData !== undefined) {
                        dst.controlData = src.controlData;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionResult();
                    dst.tension = this.tension;
                    dst.compression = this.compression;
                    dst.shear = this.shear;
                    dst.flexuralBuckling1 = this.flexuralBuckling1;
                    dst.flexuralBuckling2 = this.flexuralBuckling2;
                    dst.torsionalBuckling = this.torsionalBuckling;
                    dst.apex = this.apex;
                    dst.taper = this.taper;
                    dst.sigmad0 = this.sigmad0;
                    dst.sigmayd = this.sigmayd;
                    dst.sigmaz0 = this.sigmaz0;
                    dst.kmod = this.kmod;
                    dst.designStrength = this.designStrength;
                    dst.controlData = this.controlData;
                    return dst;
                }

                deepClone() {
                    const json = SectionResult.toObject(this);
                    const dst = SectionResult.fromObject(json);
                    return dst;
                }
            }
            export type ISectionResult = SectionResult;


            export type MaterialParameters_keys = 'km' | 'ft0k' | 'fm1k' | 'fm2k';
            export interface MaterialParameters_createType {
                km?: number,
                ft0k?: number,
                fm1k?: number,
                fm2k?: number,
            }
            export interface MaterialParameters_json {
                km?: JsonNumber;
                ft0k?: JsonNumber;
                fm1k?: JsonNumber;
                fm2k?: JsonNumber;
            }
            interface MaterialParameters_json_in {
                __proto_name?: unknown;
                km?: unknown;
                ft0k?: unknown;
                fm1k?: unknown;
                fm2k?: unknown;
            }
            export class MaterialParameters {
                __proto_name = "ng.result.timber.MaterialParameters";
                km: number = 0;
                ft0k: number = 0;
                fm1k: number = 0;
                fm2k: number = 0;

                static fromObject(src_unknown: unknown): MaterialParameters {
                    const dst = new MaterialParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MaterialParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MaterialParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MaterialParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.km !== undefined && src.km !== null) {
                        if (typeof src.km === "number" || src.km === 'NaN' || src.km === 'Infinity' || src.km === '-Infinity') {
                            dst.km = AsNum(src.km);
                        }
                        else {
                            console.log('Expected km of MaterialParameters to be a number but was ', typeof src.km, src.km)
                        }
                    }
                    if (src.ft0k !== undefined && src.ft0k !== null) {
                        if (typeof src.ft0k === "number" || src.ft0k === 'NaN' || src.ft0k === 'Infinity' || src.ft0k === '-Infinity') {
                            dst.ft0k = AsNum(src.ft0k);
                        }
                        else {
                            console.log('Expected ft0k of MaterialParameters to be a number but was ', typeof src.ft0k, src.ft0k)
                        }
                    }
                    if (src.fm1k !== undefined && src.fm1k !== null) {
                        if (typeof src.fm1k === "number" || src.fm1k === 'NaN' || src.fm1k === 'Infinity' || src.fm1k === '-Infinity') {
                            dst.fm1k = AsNum(src.fm1k);
                        }
                        else {
                            console.log('Expected fm1k of MaterialParameters to be a number but was ', typeof src.fm1k, src.fm1k)
                        }
                    }
                    if (src.fm2k !== undefined && src.fm2k !== null) {
                        if (typeof src.fm2k === "number" || src.fm2k === 'NaN' || src.fm2k === 'Infinity' || src.fm2k === '-Infinity') {
                            dst.fm2k = AsNum(src.fm2k);
                        }
                        else {
                            console.log('Expected fm2k of MaterialParameters to be a number but was ', typeof src.fm2k, src.fm2k)
                        }
                    }
                    return dst;
                }

                static toObject(src: MaterialParameters | null | undefined): MaterialParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.MaterialParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.MaterialParameters") {
                        console.error('Expected ng.result.timber.MaterialParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MaterialParameters_json = {
                        km: AsJsonNum(src.km),
                        ft0k: AsJsonNum(src.ft0k),
                        fm1k: AsJsonNum(src.fm1k),
                        fm2k: AsJsonNum(src.fm2k),
                    };
                    return dst;
                }

                static create(src?: MaterialParameters_createType) {
                    const dst = new MaterialParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.km !== undefined) {
                        dst.km = src.km;
                    }
                    if (src.ft0k !== undefined) {
                        dst.ft0k = src.ft0k;
                    }
                    if (src.fm1k !== undefined) {
                        dst.fm1k = src.fm1k;
                    }
                    if (src.fm2k !== undefined) {
                        dst.fm2k = src.fm2k;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MaterialParameters();
                    dst.km = this.km;
                    dst.ft0k = this.ft0k;
                    dst.fm1k = this.fm1k;
                    dst.fm2k = this.fm2k;
                    return dst;
                }

                deepClone() {
                    const json = MaterialParameters.toObject(this);
                    const dst = MaterialParameters.fromObject(json);
                    return dst;
                }
            }
            export type IMaterialParameters = MaterialParameters;


            export type SectionParameters_keys = 'w' | 'h' | 'a' | 'w1' | 'w2' | 'beta' | 'ir1' | 'ir2' | 'I1' | 'I2' | 'It';
            export interface SectionParameters_createType {
                w?: number,
                h?: number,
                a?: number,
                w1?: number,
                w2?: number,
                beta?: number,
                ir1?: number,
                ir2?: number,
                I1?: number,
                I2?: number,
                It?: number,
            }
            export interface SectionParameters_json {
                w?: JsonNumber;
                h?: JsonNumber;
                a?: JsonNumber;
                w1?: JsonNumber;
                w2?: JsonNumber;
                beta?: JsonNumber;
                ir1?: JsonNumber;
                ir2?: JsonNumber;
                I1?: JsonNumber;
                I2?: JsonNumber;
                It?: JsonNumber;
            }
            interface SectionParameters_json_in {
                __proto_name?: unknown;
                w?: unknown;
                h?: unknown;
                a?: unknown;
                w1?: unknown;
                w2?: unknown;
                beta?: unknown;
                ir1?: unknown;
                ir2?: unknown;
                I1?: unknown;
                I2?: unknown;
                It?: unknown;
            }
            export class SectionParameters {
                __proto_name = "ng.result.timber.SectionParameters";
                w: number = 0;
                h: number = 0;
                a: number = 0;
                w1: number = 0;
                w2: number = 0;
                beta: number = 0;
                ir1: number = 0;
                ir2: number = 0;
                I1: number = 0;
                I2: number = 0;
                It: number = 0;

                static fromObject(src_unknown: unknown): SectionParameters {
                    const dst = new SectionParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.w !== undefined && src.w !== null) {
                        if (typeof src.w === "number" || src.w === 'NaN' || src.w === 'Infinity' || src.w === '-Infinity') {
                            dst.w = AsNum(src.w);
                        }
                        else {
                            console.log('Expected w of SectionParameters to be a number but was ', typeof src.w, src.w)
                        }
                    }
                    if (src.h !== undefined && src.h !== null) {
                        if (typeof src.h === "number" || src.h === 'NaN' || src.h === 'Infinity' || src.h === '-Infinity') {
                            dst.h = AsNum(src.h);
                        }
                        else {
                            console.log('Expected h of SectionParameters to be a number but was ', typeof src.h, src.h)
                        }
                    }
                    if (src.a !== undefined && src.a !== null) {
                        if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                            dst.a = AsNum(src.a);
                        }
                        else {
                            console.log('Expected a of SectionParameters to be a number but was ', typeof src.a, src.a)
                        }
                    }
                    if (src.w1 !== undefined && src.w1 !== null) {
                        if (typeof src.w1 === "number" || src.w1 === 'NaN' || src.w1 === 'Infinity' || src.w1 === '-Infinity') {
                            dst.w1 = AsNum(src.w1);
                        }
                        else {
                            console.log('Expected w1 of SectionParameters to be a number but was ', typeof src.w1, src.w1)
                        }
                    }
                    if (src.w2 !== undefined && src.w2 !== null) {
                        if (typeof src.w2 === "number" || src.w2 === 'NaN' || src.w2 === 'Infinity' || src.w2 === '-Infinity') {
                            dst.w2 = AsNum(src.w2);
                        }
                        else {
                            console.log('Expected w2 of SectionParameters to be a number but was ', typeof src.w2, src.w2)
                        }
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                            dst.beta = AsNum(src.beta);
                        }
                        else {
                            console.log('Expected beta of SectionParameters to be a number but was ', typeof src.beta, src.beta)
                        }
                    }
                    if (src.ir1 !== undefined && src.ir1 !== null) {
                        if (typeof src.ir1 === "number" || src.ir1 === 'NaN' || src.ir1 === 'Infinity' || src.ir1 === '-Infinity') {
                            dst.ir1 = AsNum(src.ir1);
                        }
                        else {
                            console.log('Expected ir1 of SectionParameters to be a number but was ', typeof src.ir1, src.ir1)
                        }
                    }
                    if (src.ir2 !== undefined && src.ir2 !== null) {
                        if (typeof src.ir2 === "number" || src.ir2 === 'NaN' || src.ir2 === 'Infinity' || src.ir2 === '-Infinity') {
                            dst.ir2 = AsNum(src.ir2);
                        }
                        else {
                            console.log('Expected ir2 of SectionParameters to be a number but was ', typeof src.ir2, src.ir2)
                        }
                    }
                    if (src.I1 !== undefined && src.I1 !== null) {
                        if (typeof src.I1 === "number" || src.I1 === 'NaN' || src.I1 === 'Infinity' || src.I1 === '-Infinity') {
                            dst.I1 = AsNum(src.I1);
                        }
                        else {
                            console.log('Expected I1 of SectionParameters to be a number but was ', typeof src.I1, src.I1)
                        }
                    }
                    if (src.I2 !== undefined && src.I2 !== null) {
                        if (typeof src.I2 === "number" || src.I2 === 'NaN' || src.I2 === 'Infinity' || src.I2 === '-Infinity') {
                            dst.I2 = AsNum(src.I2);
                        }
                        else {
                            console.log('Expected I2 of SectionParameters to be a number but was ', typeof src.I2, src.I2)
                        }
                    }
                    if (src.It !== undefined && src.It !== null) {
                        if (typeof src.It === "number" || src.It === 'NaN' || src.It === 'Infinity' || src.It === '-Infinity') {
                            dst.It = AsNum(src.It);
                        }
                        else {
                            console.log('Expected It of SectionParameters to be a number but was ', typeof src.It, src.It)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionParameters | null | undefined): SectionParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.SectionParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.SectionParameters") {
                        console.error('Expected ng.result.timber.SectionParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionParameters_json = {
                        w: AsJsonNum(src.w),
                        h: AsJsonNum(src.h),
                        a: AsJsonNum(src.a),
                        w1: AsJsonNum(src.w1),
                        w2: AsJsonNum(src.w2),
                        beta: AsJsonNum(src.beta),
                        ir1: AsJsonNum(src.ir1),
                        ir2: AsJsonNum(src.ir2),
                        I1: AsJsonNum(src.I1),
                        I2: AsJsonNum(src.I2),
                        It: AsJsonNum(src.It),
                    };
                    return dst;
                }

                static create(src?: SectionParameters_createType) {
                    const dst = new SectionParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.w !== undefined) {
                        dst.w = src.w;
                    }
                    if (src.h !== undefined) {
                        dst.h = src.h;
                    }
                    if (src.a !== undefined) {
                        dst.a = src.a;
                    }
                    if (src.w1 !== undefined) {
                        dst.w1 = src.w1;
                    }
                    if (src.w2 !== undefined) {
                        dst.w2 = src.w2;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    if (src.ir1 !== undefined) {
                        dst.ir1 = src.ir1;
                    }
                    if (src.ir2 !== undefined) {
                        dst.ir2 = src.ir2;
                    }
                    if (src.I1 !== undefined) {
                        dst.I1 = src.I1;
                    }
                    if (src.I2 !== undefined) {
                        dst.I2 = src.I2;
                    }
                    if (src.It !== undefined) {
                        dst.It = src.It;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionParameters();
                    dst.w = this.w;
                    dst.h = this.h;
                    dst.a = this.a;
                    dst.w1 = this.w1;
                    dst.w2 = this.w2;
                    dst.beta = this.beta;
                    dst.ir1 = this.ir1;
                    dst.ir2 = this.ir2;
                    dst.I1 = this.I1;
                    dst.I2 = this.I2;
                    dst.It = this.It;
                    return dst;
                }

                deepClone() {
                    const json = SectionParameters.toObject(this);
                    const dst = SectionParameters.fromObject(json);
                    return dst;
                }
            }
            export type ISectionParameters = SectionParameters;


            export type TorsionalBucklingParameters_keys = 'relevant' | 'xs' | 'xe' | 'statSys' | 'loadPos';
            export interface TorsionalBucklingParameters_createType {
                relevant?: boolean,
                xs?: number,
                xe?: number,
                statSys?: ng.result.timber.StatSys,
                loadPos?: ng.beam.Alignment,
            }
            export interface TorsionalBucklingParameters_json {
                relevant?: boolean;
                xs?: JsonNumber;
                xe?: JsonNumber;
                statSys?: string;
                loadPos?: string;
            }
            interface TorsionalBucklingParameters_json_in {
                __proto_name?: unknown;
                relevant?: unknown;
                xs?: unknown;
                xe?: unknown;
                statSys?: unknown;
                loadPos?: unknown;
            }
            export class TorsionalBucklingParameters {
                __proto_name = "ng.result.timber.TorsionalBucklingParameters";
                relevant: boolean = false;
                xs: number = 0;
                xe: number = 0;
                statSys: ng.result.timber.StatSys = ng.result.timber.StatSys.STAT_SYS_UNSPECIFIED;
                loadPos: ng.beam.Alignment = ng.beam.Alignment.ALIGNMENT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): TorsionalBucklingParameters {
                    const dst = new TorsionalBucklingParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TorsionalBucklingParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TorsionalBucklingParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TorsionalBucklingParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.relevant !== undefined && src.relevant !== null) {
                        if (typeof src.relevant === "boolean") {
                            dst.relevant = src.relevant;
                        }
                        else {
                            console.log('Expected relevant of TorsionalBucklingParameters to be a boolean but was ', typeof src.relevant, src.relevant)
                        }
                    }
                    if (src.xs !== undefined && src.xs !== null) {
                        if (typeof src.xs === "number" || src.xs === 'NaN' || src.xs === 'Infinity' || src.xs === '-Infinity') {
                            dst.xs = AsNum(src.xs);
                        }
                        else {
                            console.log('Expected xs of TorsionalBucklingParameters to be a number but was ', typeof src.xs, src.xs)
                        }
                    }
                    if (src.xe !== undefined && src.xe !== null) {
                        if (typeof src.xe === "number" || src.xe === 'NaN' || src.xe === 'Infinity' || src.xe === '-Infinity') {
                            dst.xe = AsNum(src.xe);
                        }
                        else {
                            console.log('Expected xe of TorsionalBucklingParameters to be a number but was ', typeof src.xe, src.xe)
                        }
                    }
                    if (src.statSys !== undefined && src.statSys !== null) {
                        dst.statSys = ng.result.timber.StatSys_FromObject(src.statSys);
                    }
                    if (src.loadPos !== undefined && src.loadPos !== null) {
                        dst.loadPos = ng.beam.Alignment_FromObject(src.loadPos);
                    }
                    return dst;
                }

                static toObject(src: TorsionalBucklingParameters | null | undefined): TorsionalBucklingParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.TorsionalBucklingParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.TorsionalBucklingParameters") {
                        console.error('Expected ng.result.timber.TorsionalBucklingParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const statSys_obj = ng.result.timber.StatSys_ToObject(src.statSys);
                    if(statSys_obj === null) return null;

                    const loadPos_obj = ng.beam.Alignment_ToObject(src.loadPos);
                    if(loadPos_obj === null) return null;

                    const dst : TorsionalBucklingParameters_json = {
                        relevant: src.relevant,
                        xs: AsJsonNum(src.xs),
                        xe: AsJsonNum(src.xe),
                        statSys: statSys_obj,
                        loadPos: loadPos_obj,
                    };
                    return dst;
                }

                static create(src?: TorsionalBucklingParameters_createType) {
                    const dst = new TorsionalBucklingParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.relevant !== undefined) {
                        dst.relevant = src.relevant;
                    }
                    if (src.xs !== undefined) {
                        dst.xs = src.xs;
                    }
                    if (src.xe !== undefined) {
                        dst.xe = src.xe;
                    }
                    if (src.statSys !== undefined) {
                        dst.statSys = src.statSys;
                    }
                    if (src.loadPos !== undefined) {
                        dst.loadPos = src.loadPos;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TorsionalBucklingParameters();
                    dst.relevant = this.relevant;
                    dst.xs = this.xs;
                    dst.xe = this.xe;
                    dst.statSys = this.statSys;
                    dst.loadPos = this.loadPos;
                    return dst;
                }

                deepClone() {
                    const json = TorsionalBucklingParameters.toObject(this);
                    const dst = TorsionalBucklingParameters.fromObject(json);
                    return dst;
                }
            }
            export type ITorsionalBucklingParameters = TorsionalBucklingParameters;


            export type FlexBucklingParameters_keys = 'xs' | 'xe' | 'l0' | 'i0' | 'lambda' | 'lambdaRel' | 'betac' | 'k' | 'kc';
            export interface FlexBucklingParameters_createType {
                xs?: number,
                xe?: number,
                l0?: number,
                i0?: number,
                lambda?: number,
                lambdaRel?: number,
                betac?: number,
                k?: number,
                kc?: number,
            }
            export interface FlexBucklingParameters_json {
                xs?: JsonNumber;
                xe?: JsonNumber;
                l0?: JsonNumber;
                i0?: JsonNumber;
                lambda?: JsonNumber;
                lambdaRel?: JsonNumber;
                betac?: JsonNumber;
                k?: JsonNumber;
                kc?: JsonNumber;
            }
            interface FlexBucklingParameters_json_in {
                __proto_name?: unknown;
                xs?: unknown;
                xe?: unknown;
                l0?: unknown;
                i0?: unknown;
                lambda?: unknown;
                lambdaRel?: unknown;
                betac?: unknown;
                k?: unknown;
                kc?: unknown;
            }
            export class FlexBucklingParameters {
                __proto_name = "ng.result.timber.FlexBucklingParameters";
                xs: number = 0;
                xe: number = 0;
                l0: number = 0;
                i0: number = 0;
                lambda: number = 0;
                lambdaRel: number = 0;
                betac: number = 0;
                k: number = 0;
                kc: number = 0;

                static fromObject(src_unknown: unknown): FlexBucklingParameters {
                    const dst = new FlexBucklingParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FlexBucklingParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FlexBucklingParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FlexBucklingParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.xs !== undefined && src.xs !== null) {
                        if (typeof src.xs === "number" || src.xs === 'NaN' || src.xs === 'Infinity' || src.xs === '-Infinity') {
                            dst.xs = AsNum(src.xs);
                        }
                        else {
                            console.log('Expected xs of FlexBucklingParameters to be a number but was ', typeof src.xs, src.xs)
                        }
                    }
                    if (src.xe !== undefined && src.xe !== null) {
                        if (typeof src.xe === "number" || src.xe === 'NaN' || src.xe === 'Infinity' || src.xe === '-Infinity') {
                            dst.xe = AsNum(src.xe);
                        }
                        else {
                            console.log('Expected xe of FlexBucklingParameters to be a number but was ', typeof src.xe, src.xe)
                        }
                    }
                    if (src.l0 !== undefined && src.l0 !== null) {
                        if (typeof src.l0 === "number" || src.l0 === 'NaN' || src.l0 === 'Infinity' || src.l0 === '-Infinity') {
                            dst.l0 = AsNum(src.l0);
                        }
                        else {
                            console.log('Expected l0 of FlexBucklingParameters to be a number but was ', typeof src.l0, src.l0)
                        }
                    }
                    if (src.i0 !== undefined && src.i0 !== null) {
                        if (typeof src.i0 === "number" || src.i0 === 'NaN' || src.i0 === 'Infinity' || src.i0 === '-Infinity') {
                            dst.i0 = AsNum(src.i0);
                        }
                        else {
                            console.log('Expected i0 of FlexBucklingParameters to be a number but was ', typeof src.i0, src.i0)
                        }
                    }
                    if (src.lambda !== undefined && src.lambda !== null) {
                        if (typeof src.lambda === "number" || src.lambda === 'NaN' || src.lambda === 'Infinity' || src.lambda === '-Infinity') {
                            dst.lambda = AsNum(src.lambda);
                        }
                        else {
                            console.log('Expected lambda of FlexBucklingParameters to be a number but was ', typeof src.lambda, src.lambda)
                        }
                    }
                    if (src.lambdaRel !== undefined && src.lambdaRel !== null) {
                        if (typeof src.lambdaRel === "number" || src.lambdaRel === 'NaN' || src.lambdaRel === 'Infinity' || src.lambdaRel === '-Infinity') {
                            dst.lambdaRel = AsNum(src.lambdaRel);
                        }
                        else {
                            console.log('Expected lambdaRel of FlexBucklingParameters to be a number but was ', typeof src.lambdaRel, src.lambdaRel)
                        }
                    }
                    if (src.betac !== undefined && src.betac !== null) {
                        if (typeof src.betac === "number" || src.betac === 'NaN' || src.betac === 'Infinity' || src.betac === '-Infinity') {
                            dst.betac = AsNum(src.betac);
                        }
                        else {
                            console.log('Expected betac of FlexBucklingParameters to be a number but was ', typeof src.betac, src.betac)
                        }
                    }
                    if (src.k !== undefined && src.k !== null) {
                        if (typeof src.k === "number" || src.k === 'NaN' || src.k === 'Infinity' || src.k === '-Infinity') {
                            dst.k = AsNum(src.k);
                        }
                        else {
                            console.log('Expected k of FlexBucklingParameters to be a number but was ', typeof src.k, src.k)
                        }
                    }
                    if (src.kc !== undefined && src.kc !== null) {
                        if (typeof src.kc === "number" || src.kc === 'NaN' || src.kc === 'Infinity' || src.kc === '-Infinity') {
                            dst.kc = AsNum(src.kc);
                        }
                        else {
                            console.log('Expected kc of FlexBucklingParameters to be a number but was ', typeof src.kc, src.kc)
                        }
                    }
                    return dst;
                }

                static toObject(src: FlexBucklingParameters | null | undefined): FlexBucklingParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.FlexBucklingParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.FlexBucklingParameters") {
                        console.error('Expected ng.result.timber.FlexBucklingParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FlexBucklingParameters_json = {
                        xs: AsJsonNum(src.xs),
                        xe: AsJsonNum(src.xe),
                        l0: AsJsonNum(src.l0),
                        i0: AsJsonNum(src.i0),
                        lambda: AsJsonNum(src.lambda),
                        lambdaRel: AsJsonNum(src.lambdaRel),
                        betac: AsJsonNum(src.betac),
                        k: AsJsonNum(src.k),
                        kc: AsJsonNum(src.kc),
                    };
                    return dst;
                }

                static create(src?: FlexBucklingParameters_createType) {
                    const dst = new FlexBucklingParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.xs !== undefined) {
                        dst.xs = src.xs;
                    }
                    if (src.xe !== undefined) {
                        dst.xe = src.xe;
                    }
                    if (src.l0 !== undefined) {
                        dst.l0 = src.l0;
                    }
                    if (src.i0 !== undefined) {
                        dst.i0 = src.i0;
                    }
                    if (src.lambda !== undefined) {
                        dst.lambda = src.lambda;
                    }
                    if (src.lambdaRel !== undefined) {
                        dst.lambdaRel = src.lambdaRel;
                    }
                    if (src.betac !== undefined) {
                        dst.betac = src.betac;
                    }
                    if (src.k !== undefined) {
                        dst.k = src.k;
                    }
                    if (src.kc !== undefined) {
                        dst.kc = src.kc;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FlexBucklingParameters();
                    dst.xs = this.xs;
                    dst.xe = this.xe;
                    dst.l0 = this.l0;
                    dst.i0 = this.i0;
                    dst.lambda = this.lambda;
                    dst.lambdaRel = this.lambdaRel;
                    dst.betac = this.betac;
                    dst.k = this.k;
                    dst.kc = this.kc;
                    return dst;
                }

                deepClone() {
                    const json = FlexBucklingParameters.toObject(this);
                    const dst = FlexBucklingParameters.fromObject(json);
                    return dst;
                }
            }
            export type IFlexBucklingParameters = FlexBucklingParameters;


            export type TaperParameters_keys = 'alphaTap' | 'h' | 'b';
            export interface TaperParameters_createType {
                alphaTap?: number,
                h?: number,
                b?: number,
            }
            export interface TaperParameters_json {
                alphaTap?: JsonNumber;
                h?: JsonNumber;
                b?: JsonNumber;
            }
            interface TaperParameters_json_in {
                __proto_name?: unknown;
                alphaTap?: unknown;
                h?: unknown;
                b?: unknown;
            }
            export class TaperParameters {
                __proto_name = "ng.result.timber.TaperParameters";
                alphaTap: number = 0;
                h: number = 0;
                b: number = 0;

                static fromObject(src_unknown: unknown): TaperParameters {
                    const dst = new TaperParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TaperParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TaperParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TaperParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.alphaTap !== undefined && src.alphaTap !== null) {
                        if (typeof src.alphaTap === "number" || src.alphaTap === 'NaN' || src.alphaTap === 'Infinity' || src.alphaTap === '-Infinity') {
                            dst.alphaTap = AsNum(src.alphaTap);
                        }
                        else {
                            console.log('Expected alphaTap of TaperParameters to be a number but was ', typeof src.alphaTap, src.alphaTap)
                        }
                    }
                    if (src.h !== undefined && src.h !== null) {
                        if (typeof src.h === "number" || src.h === 'NaN' || src.h === 'Infinity' || src.h === '-Infinity') {
                            dst.h = AsNum(src.h);
                        }
                        else {
                            console.log('Expected h of TaperParameters to be a number but was ', typeof src.h, src.h)
                        }
                    }
                    if (src.b !== undefined && src.b !== null) {
                        if (typeof src.b === "number" || src.b === 'NaN' || src.b === 'Infinity' || src.b === '-Infinity') {
                            dst.b = AsNum(src.b);
                        }
                        else {
                            console.log('Expected b of TaperParameters to be a number but was ', typeof src.b, src.b)
                        }
                    }
                    return dst;
                }

                static toObject(src: TaperParameters | null | undefined): TaperParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.TaperParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.TaperParameters") {
                        console.error('Expected ng.result.timber.TaperParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : TaperParameters_json = {
                        alphaTap: AsJsonNum(src.alphaTap),
                        h: AsJsonNum(src.h),
                        b: AsJsonNum(src.b),
                    };
                    return dst;
                }

                static create(src?: TaperParameters_createType) {
                    const dst = new TaperParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.alphaTap !== undefined) {
                        dst.alphaTap = src.alphaTap;
                    }
                    if (src.h !== undefined) {
                        dst.h = src.h;
                    }
                    if (src.b !== undefined) {
                        dst.b = src.b;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TaperParameters();
                    dst.alphaTap = this.alphaTap;
                    dst.h = this.h;
                    dst.b = this.b;
                    return dst;
                }

                deepClone() {
                    const json = TaperParameters.toObject(this);
                    const dst = TaperParameters.fromObject(json);
                    return dst;
                }
            }
            export type ITaperParameters = TaperParameters;


            export type ApexParameters_keys = 'positiveMomentCausesTension' | 'alphaAp' | 'hAp' | 'b' | 'kr' | 'kl' | 'kdis' | 'kvol' | 'kp' | 'k' | 'volumeAp' | 'rIn' | 'r';
            export interface ApexParameters_createType {
                positiveMomentCausesTension?: boolean,
                alphaAp?: number,
                hAp?: number,
                b?: number,
                kr?: number,
                kl?: number,
                kdis?: number,
                kvol?: number,
                kp?: number,
                k?: number[],
                volumeAp?: number,
                rIn?: number,
                r?: number,
            }
            export interface ApexParameters_json {
                positiveMomentCausesTension?: boolean;
                alphaAp?: JsonNumber;
                hAp?: JsonNumber;
                b?: JsonNumber;
                kr?: JsonNumber;
                kl?: JsonNumber;
                kdis?: JsonNumber;
                kvol?: JsonNumber;
                kp?: JsonNumber;
                k: JsonNumber[];
                volumeAp?: JsonNumber;
                rIn?: JsonNumber;
                r?: JsonNumber;
            }
            interface ApexParameters_json_in {
                __proto_name?: unknown;
                positiveMomentCausesTension?: unknown;
                alphaAp?: unknown;
                hAp?: unknown;
                b?: unknown;
                kr?: unknown;
                kl?: unknown;
                kdis?: unknown;
                kvol?: unknown;
                kp?: unknown;
                k?: unknown;
                volumeAp?: unknown;
                rIn?: unknown;
                r?: unknown;
            }
            export class ApexParameters {
                __proto_name = "ng.result.timber.ApexParameters";
                positiveMomentCausesTension: boolean = false;
                alphaAp: number = 0;
                hAp: number = 0;
                b: number = 0;
                kr: number = 0;
                kl: number = 0;
                kdis: number = 0;
                kvol: number = 0;
                kp: number = 0;
                k: number[] = [];
                volumeAp: number = 0;
                rIn: number = 0;
                r: number = 0;

                static fromObject(src_unknown: unknown): ApexParameters {
                    const dst = new ApexParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ApexParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ApexParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ApexParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.positiveMomentCausesTension !== undefined && src.positiveMomentCausesTension !== null) {
                        if (typeof src.positiveMomentCausesTension === "boolean") {
                            dst.positiveMomentCausesTension = src.positiveMomentCausesTension;
                        }
                        else {
                            console.log('Expected positiveMomentCausesTension of ApexParameters to be a boolean but was ', typeof src.positiveMomentCausesTension, src.positiveMomentCausesTension)
                        }
                    }
                    if (src.alphaAp !== undefined && src.alphaAp !== null) {
                        if (typeof src.alphaAp === "number" || src.alphaAp === 'NaN' || src.alphaAp === 'Infinity' || src.alphaAp === '-Infinity') {
                            dst.alphaAp = AsNum(src.alphaAp);
                        }
                        else {
                            console.log('Expected alphaAp of ApexParameters to be a number but was ', typeof src.alphaAp, src.alphaAp)
                        }
                    }
                    if (src.hAp !== undefined && src.hAp !== null) {
                        if (typeof src.hAp === "number" || src.hAp === 'NaN' || src.hAp === 'Infinity' || src.hAp === '-Infinity') {
                            dst.hAp = AsNum(src.hAp);
                        }
                        else {
                            console.log('Expected hAp of ApexParameters to be a number but was ', typeof src.hAp, src.hAp)
                        }
                    }
                    if (src.b !== undefined && src.b !== null) {
                        if (typeof src.b === "number" || src.b === 'NaN' || src.b === 'Infinity' || src.b === '-Infinity') {
                            dst.b = AsNum(src.b);
                        }
                        else {
                            console.log('Expected b of ApexParameters to be a number but was ', typeof src.b, src.b)
                        }
                    }
                    if (src.kr !== undefined && src.kr !== null) {
                        if (typeof src.kr === "number" || src.kr === 'NaN' || src.kr === 'Infinity' || src.kr === '-Infinity') {
                            dst.kr = AsNum(src.kr);
                        }
                        else {
                            console.log('Expected kr of ApexParameters to be a number but was ', typeof src.kr, src.kr)
                        }
                    }
                    if (src.kl !== undefined && src.kl !== null) {
                        if (typeof src.kl === "number" || src.kl === 'NaN' || src.kl === 'Infinity' || src.kl === '-Infinity') {
                            dst.kl = AsNum(src.kl);
                        }
                        else {
                            console.log('Expected kl of ApexParameters to be a number but was ', typeof src.kl, src.kl)
                        }
                    }
                    if (src.kdis !== undefined && src.kdis !== null) {
                        if (typeof src.kdis === "number" || src.kdis === 'NaN' || src.kdis === 'Infinity' || src.kdis === '-Infinity') {
                            dst.kdis = AsNum(src.kdis);
                        }
                        else {
                            console.log('Expected kdis of ApexParameters to be a number but was ', typeof src.kdis, src.kdis)
                        }
                    }
                    if (src.kvol !== undefined && src.kvol !== null) {
                        if (typeof src.kvol === "number" || src.kvol === 'NaN' || src.kvol === 'Infinity' || src.kvol === '-Infinity') {
                            dst.kvol = AsNum(src.kvol);
                        }
                        else {
                            console.log('Expected kvol of ApexParameters to be a number but was ', typeof src.kvol, src.kvol)
                        }
                    }
                    if (src.kp !== undefined && src.kp !== null) {
                        if (typeof src.kp === "number" || src.kp === 'NaN' || src.kp === 'Infinity' || src.kp === '-Infinity') {
                            dst.kp = AsNum(src.kp);
                        }
                        else {
                            console.log('Expected kp of ApexParameters to be a number but was ', typeof src.kp, src.kp)
                        }
                    }
                    if (src.k !== undefined && src.k !== null) {
                        if (Array.isArray(src.k)) {
                            for (const [index, element] of src.k.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.k.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected k of ApexParameters[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected k of ApexParameters to be a array but was ', typeof src.k, src.k)
                        }
                    }
                    if (src.volumeAp !== undefined && src.volumeAp !== null) {
                        if (typeof src.volumeAp === "number" || src.volumeAp === 'NaN' || src.volumeAp === 'Infinity' || src.volumeAp === '-Infinity') {
                            dst.volumeAp = AsNum(src.volumeAp);
                        }
                        else {
                            console.log('Expected volumeAp of ApexParameters to be a number but was ', typeof src.volumeAp, src.volumeAp)
                        }
                    }
                    if (src.rIn !== undefined && src.rIn !== null) {
                        if (typeof src.rIn === "number" || src.rIn === 'NaN' || src.rIn === 'Infinity' || src.rIn === '-Infinity') {
                            dst.rIn = AsNum(src.rIn);
                        }
                        else {
                            console.log('Expected rIn of ApexParameters to be a number but was ', typeof src.rIn, src.rIn)
                        }
                    }
                    if (src.r !== undefined && src.r !== null) {
                        if (typeof src.r === "number" || src.r === 'NaN' || src.r === 'Infinity' || src.r === '-Infinity') {
                            dst.r = AsNum(src.r);
                        }
                        else {
                            console.log('Expected r of ApexParameters to be a number but was ', typeof src.r, src.r)
                        }
                    }
                    return dst;
                }

                static toObject(src: ApexParameters | null | undefined): ApexParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.ApexParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.ApexParameters") {
                        console.error('Expected ng.result.timber.ApexParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ApexParameters_json = {
                        positiveMomentCausesTension: src.positiveMomentCausesTension,
                        alphaAp: AsJsonNum(src.alphaAp),
                        hAp: AsJsonNum(src.hAp),
                        b: AsJsonNum(src.b),
                        kr: AsJsonNum(src.kr),
                        kl: AsJsonNum(src.kl),
                        kdis: AsJsonNum(src.kdis),
                        kvol: AsJsonNum(src.kvol),
                        kp: AsJsonNum(src.kp),
                        k: new Array<JsonNumber>(),
                        volumeAp: AsJsonNum(src.volumeAp),
                        rIn: AsJsonNum(src.rIn),
                        r: AsJsonNum(src.r),
                    };
                    if (src.k !== null) {
                        for (const element of src.k) {
                            dst.k.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: ApexParameters_createType) {
                    const dst = new ApexParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.positiveMomentCausesTension !== undefined) {
                        dst.positiveMomentCausesTension = src.positiveMomentCausesTension;
                    }
                    if (src.alphaAp !== undefined) {
                        dst.alphaAp = src.alphaAp;
                    }
                    if (src.hAp !== undefined) {
                        dst.hAp = src.hAp;
                    }
                    if (src.b !== undefined) {
                        dst.b = src.b;
                    }
                    if (src.kr !== undefined) {
                        dst.kr = src.kr;
                    }
                    if (src.kl !== undefined) {
                        dst.kl = src.kl;
                    }
                    if (src.kdis !== undefined) {
                        dst.kdis = src.kdis;
                    }
                    if (src.kvol !== undefined) {
                        dst.kvol = src.kvol;
                    }
                    if (src.kp !== undefined) {
                        dst.kp = src.kp;
                    }
                    if (src.k !== undefined) {
                        dst.k = src.k;
                    }
                    if (src.volumeAp !== undefined) {
                        dst.volumeAp = src.volumeAp;
                    }
                    if (src.rIn !== undefined) {
                        dst.rIn = src.rIn;
                    }
                    if (src.r !== undefined) {
                        dst.r = src.r;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ApexParameters();
                    dst.positiveMomentCausesTension = this.positiveMomentCausesTension;
                    dst.alphaAp = this.alphaAp;
                    dst.hAp = this.hAp;
                    dst.b = this.b;
                    dst.kr = this.kr;
                    dst.kl = this.kl;
                    dst.kdis = this.kdis;
                    dst.kvol = this.kvol;
                    dst.kp = this.kp;
                    dst.k = this.k;
                    dst.volumeAp = this.volumeAp;
                    dst.rIn = this.rIn;
                    dst.r = this.r;
                    return dst;
                }

                deepClone() {
                    const json = ApexParameters.toObject(this);
                    const dst = ApexParameters.fromObject(json);
                    return dst;
                }
            }
            export type IApexParameters = ApexParameters;


            export type ExtraParameters_keys = 'extraSections' | 'extraMaterials' | 'taperData' | 'apexData';
            export interface ExtraParameters_createType {
                extraSections?: ng.result.timber.SectionParameters | null,
                extraMaterials?: ng.result.timber.MaterialParameters | null,
                taperData?: ng.result.timber.TaperParameters | null,
                apexData?: ng.result.timber.ApexParameters | null,
            }
            export interface ExtraParameters_json {
                extraSections?: ng.result.timber.SectionParameters_json;
                extraMaterials?: ng.result.timber.MaterialParameters_json;
                taperData?: ng.result.timber.TaperParameters_json;
                apexData?: ng.result.timber.ApexParameters_json;
            }
            interface ExtraParameters_json_in {
                __proto_name?: unknown;
                extraSections?: unknown;
                extraMaterials?: unknown;
                taperData?: unknown;
                apexData?: unknown;
            }
            export class ExtraParameters {
                __proto_name = "ng.result.timber.ExtraParameters";
                extraSections: ng.result.timber.SectionParameters | null = null;
                extraMaterials: ng.result.timber.MaterialParameters | null = null;
                taperData: ng.result.timber.TaperParameters | null = null;
                apexData: ng.result.timber.ApexParameters | null = null;

                static fromObject(src_unknown: unknown): ExtraParameters {
                    const dst = new ExtraParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ExtraParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ExtraParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ExtraParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.extraSections !== undefined && src.extraSections !== null) {
                        dst.extraSections = ng.result.timber.SectionParameters.fromObject(src.extraSections);
                    }
                    if (src.extraMaterials !== undefined && src.extraMaterials !== null) {
                        dst.extraMaterials = ng.result.timber.MaterialParameters.fromObject(src.extraMaterials);
                    }
                    if (src.taperData !== undefined && src.taperData !== null) {
                        dst.taperData = ng.result.timber.TaperParameters.fromObject(src.taperData);
                    }
                    if (src.apexData !== undefined && src.apexData !== null) {
                        dst.apexData = ng.result.timber.ApexParameters.fromObject(src.apexData);
                    }
                    return dst;
                }

                static toObject(src: ExtraParameters | null | undefined): ExtraParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.ExtraParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.ExtraParameters") {
                        console.error('Expected ng.result.timber.ExtraParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ExtraParameters_json = {
                    };
                    if(src.extraSections !== null)
                    {
                        const parsed = ng.result.timber.SectionParameters.toObject(src.extraSections);
                        if(parsed === null) return null;
                        dst.extraSections = parsed;
                    }
                    if(src.extraMaterials !== null)
                    {
                        const parsed = ng.result.timber.MaterialParameters.toObject(src.extraMaterials);
                        if(parsed === null) return null;
                        dst.extraMaterials = parsed;
                    }
                    if(src.taperData !== null)
                    {
                        const parsed = ng.result.timber.TaperParameters.toObject(src.taperData);
                        if(parsed === null) return null;
                        dst.taperData = parsed;
                    }
                    if(src.apexData !== null)
                    {
                        const parsed = ng.result.timber.ApexParameters.toObject(src.apexData);
                        if(parsed === null) return null;
                        dst.apexData = parsed;
                    }
                    return dst;
                }

                static create(src?: ExtraParameters_createType) {
                    const dst = new ExtraParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.extraSections !== undefined) {
                        dst.extraSections = src.extraSections;
                    }
                    if (src.extraMaterials !== undefined) {
                        dst.extraMaterials = src.extraMaterials;
                    }
                    if (src.taperData !== undefined) {
                        dst.taperData = src.taperData;
                    }
                    if (src.apexData !== undefined) {
                        dst.apexData = src.apexData;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ExtraParameters();
                    dst.extraSections = this.extraSections;
                    dst.extraMaterials = this.extraMaterials;
                    dst.taperData = this.taperData;
                    dst.apexData = this.apexData;
                    return dst;
                }

                deepClone() {
                    const json = ExtraParameters.toObject(this);
                    const dst = ExtraParameters.fromObject(json);
                    return dst;
                }
            }
            export type IExtraParameters = ExtraParameters;


            export type DesignStrength_keys = 'ft0d' | 'ft90d' | 'fc0d' | 'fc90d' | 'fm1d' | 'fm2d' | 'fvd';
            export interface DesignStrength_createType {
                ft0d?: number,
                ft90d?: number,
                fc0d?: number,
                fc90d?: number,
                fm1d?: number,
                fm2d?: number,
                fvd?: number,
            }
            export interface DesignStrength_json {
                ft0d?: JsonNumber;
                ft90d?: JsonNumber;
                fc0d?: JsonNumber;
                fc90d?: JsonNumber;
                fm1d?: JsonNumber;
                fm2d?: JsonNumber;
                fvd?: JsonNumber;
            }
            interface DesignStrength_json_in {
                __proto_name?: unknown;
                ft0d?: unknown;
                ft90d?: unknown;
                fc0d?: unknown;
                fc90d?: unknown;
                fm1d?: unknown;
                fm2d?: unknown;
                fvd?: unknown;
            }
            export class DesignStrength {
                __proto_name = "ng.result.timber.DesignStrength";
                ft0d: number = 0;
                ft90d: number = 0;
                fc0d: number = 0;
                fc90d: number = 0;
                fm1d: number = 0;
                fm2d: number = 0;
                fvd: number = 0;

                static fromObject(src_unknown: unknown): DesignStrength {
                    const dst = new DesignStrength();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignStrength but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignStrength_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignStrength but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ft0d !== undefined && src.ft0d !== null) {
                        if (typeof src.ft0d === "number" || src.ft0d === 'NaN' || src.ft0d === 'Infinity' || src.ft0d === '-Infinity') {
                            dst.ft0d = AsNum(src.ft0d);
                        }
                        else {
                            console.log('Expected ft0d of DesignStrength to be a number but was ', typeof src.ft0d, src.ft0d)
                        }
                    }
                    if (src.ft90d !== undefined && src.ft90d !== null) {
                        if (typeof src.ft90d === "number" || src.ft90d === 'NaN' || src.ft90d === 'Infinity' || src.ft90d === '-Infinity') {
                            dst.ft90d = AsNum(src.ft90d);
                        }
                        else {
                            console.log('Expected ft90d of DesignStrength to be a number but was ', typeof src.ft90d, src.ft90d)
                        }
                    }
                    if (src.fc0d !== undefined && src.fc0d !== null) {
                        if (typeof src.fc0d === "number" || src.fc0d === 'NaN' || src.fc0d === 'Infinity' || src.fc0d === '-Infinity') {
                            dst.fc0d = AsNum(src.fc0d);
                        }
                        else {
                            console.log('Expected fc0d of DesignStrength to be a number but was ', typeof src.fc0d, src.fc0d)
                        }
                    }
                    if (src.fc90d !== undefined && src.fc90d !== null) {
                        if (typeof src.fc90d === "number" || src.fc90d === 'NaN' || src.fc90d === 'Infinity' || src.fc90d === '-Infinity') {
                            dst.fc90d = AsNum(src.fc90d);
                        }
                        else {
                            console.log('Expected fc90d of DesignStrength to be a number but was ', typeof src.fc90d, src.fc90d)
                        }
                    }
                    if (src.fm1d !== undefined && src.fm1d !== null) {
                        if (typeof src.fm1d === "number" || src.fm1d === 'NaN' || src.fm1d === 'Infinity' || src.fm1d === '-Infinity') {
                            dst.fm1d = AsNum(src.fm1d);
                        }
                        else {
                            console.log('Expected fm1d of DesignStrength to be a number but was ', typeof src.fm1d, src.fm1d)
                        }
                    }
                    if (src.fm2d !== undefined && src.fm2d !== null) {
                        if (typeof src.fm2d === "number" || src.fm2d === 'NaN' || src.fm2d === 'Infinity' || src.fm2d === '-Infinity') {
                            dst.fm2d = AsNum(src.fm2d);
                        }
                        else {
                            console.log('Expected fm2d of DesignStrength to be a number but was ', typeof src.fm2d, src.fm2d)
                        }
                    }
                    if (src.fvd !== undefined && src.fvd !== null) {
                        if (typeof src.fvd === "number" || src.fvd === 'NaN' || src.fvd === 'Infinity' || src.fvd === '-Infinity') {
                            dst.fvd = AsNum(src.fvd);
                        }
                        else {
                            console.log('Expected fvd of DesignStrength to be a number but was ', typeof src.fvd, src.fvd)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignStrength | null | undefined): DesignStrength_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.DesignStrength is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.DesignStrength") {
                        console.error('Expected ng.result.timber.DesignStrength but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DesignStrength_json = {
                        ft0d: AsJsonNum(src.ft0d),
                        ft90d: AsJsonNum(src.ft90d),
                        fc0d: AsJsonNum(src.fc0d),
                        fc90d: AsJsonNum(src.fc90d),
                        fm1d: AsJsonNum(src.fm1d),
                        fm2d: AsJsonNum(src.fm2d),
                        fvd: AsJsonNum(src.fvd),
                    };
                    return dst;
                }

                static create(src?: DesignStrength_createType) {
                    const dst = new DesignStrength();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ft0d !== undefined) {
                        dst.ft0d = src.ft0d;
                    }
                    if (src.ft90d !== undefined) {
                        dst.ft90d = src.ft90d;
                    }
                    if (src.fc0d !== undefined) {
                        dst.fc0d = src.fc0d;
                    }
                    if (src.fc90d !== undefined) {
                        dst.fc90d = src.fc90d;
                    }
                    if (src.fm1d !== undefined) {
                        dst.fm1d = src.fm1d;
                    }
                    if (src.fm2d !== undefined) {
                        dst.fm2d = src.fm2d;
                    }
                    if (src.fvd !== undefined) {
                        dst.fvd = src.fvd;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignStrength();
                    dst.ft0d = this.ft0d;
                    dst.ft90d = this.ft90d;
                    dst.fc0d = this.fc0d;
                    dst.fc90d = this.fc90d;
                    dst.fm1d = this.fm1d;
                    dst.fm2d = this.fm2d;
                    dst.fvd = this.fvd;
                    return dst;
                }

                deepClone() {
                    const json = DesignStrength.toObject(this);
                    const dst = DesignStrength.fromObject(json);
                    return dst;
                }
            }
            export type IDesignStrength = DesignStrength;


            export type TorsionalBucklingStrength_keys = 'relevant' | 'statSys' | 'loadPos' | 'mMax' | 'm' | 'beta' | 'h' | 'lef' | 'sigmamcrit' | 'lambdarelm' | 'kcrit';
            export interface TorsionalBucklingStrength_createType {
                relevant?: boolean,
                statSys?: ng.result.timber.StatSys,
                loadPos?: ng.beam.Alignment,
                mMax?: number,
                m?: number[],
                beta?: number,
                h?: number,
                lef?: number,
                sigmamcrit?: number,
                lambdarelm?: number,
                kcrit?: number,
            }
            export interface TorsionalBucklingStrength_json {
                relevant?: boolean;
                statSys?: string;
                loadPos?: string;
                mMax?: JsonNumber;
                m: JsonNumber[];
                beta?: JsonNumber;
                h?: JsonNumber;
                lef?: JsonNumber;
                sigmamcrit?: JsonNumber;
                lambdarelm?: JsonNumber;
                kcrit?: JsonNumber;
            }
            interface TorsionalBucklingStrength_json_in {
                __proto_name?: unknown;
                relevant?: unknown;
                statSys?: unknown;
                loadPos?: unknown;
                mMax?: unknown;
                m?: unknown;
                beta?: unknown;
                h?: unknown;
                lef?: unknown;
                sigmamcrit?: unknown;
                lambdarelm?: unknown;
                kcrit?: unknown;
            }
            export class TorsionalBucklingStrength {
                __proto_name = "ng.result.timber.TorsionalBucklingStrength";
                relevant: boolean = false;
                statSys: ng.result.timber.StatSys = ng.result.timber.StatSys.STAT_SYS_UNSPECIFIED;
                loadPos: ng.beam.Alignment = ng.beam.Alignment.ALIGNMENT_UNSPECIFIED;
                mMax: number = 0;
                m: number[] = [];
                beta: number = 0;
                h: number = 0;
                lef: number = 0;
                sigmamcrit: number = 0;
                lambdarelm: number = 0;
                kcrit: number = 0;

                static fromObject(src_unknown: unknown): TorsionalBucklingStrength {
                    const dst = new TorsionalBucklingStrength();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TorsionalBucklingStrength but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TorsionalBucklingStrength_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TorsionalBucklingStrength but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.relevant !== undefined && src.relevant !== null) {
                        if (typeof src.relevant === "boolean") {
                            dst.relevant = src.relevant;
                        }
                        else {
                            console.log('Expected relevant of TorsionalBucklingStrength to be a boolean but was ', typeof src.relevant, src.relevant)
                        }
                    }
                    if (src.statSys !== undefined && src.statSys !== null) {
                        dst.statSys = ng.result.timber.StatSys_FromObject(src.statSys);
                    }
                    if (src.loadPos !== undefined && src.loadPos !== null) {
                        dst.loadPos = ng.beam.Alignment_FromObject(src.loadPos);
                    }
                    if (src.mMax !== undefined && src.mMax !== null) {
                        if (typeof src.mMax === "number" || src.mMax === 'NaN' || src.mMax === 'Infinity' || src.mMax === '-Infinity') {
                            dst.mMax = AsNum(src.mMax);
                        }
                        else {
                            console.log('Expected mMax of TorsionalBucklingStrength to be a number but was ', typeof src.mMax, src.mMax)
                        }
                    }
                    if (src.m !== undefined && src.m !== null) {
                        if (Array.isArray(src.m)) {
                            for (const [index, element] of src.m.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.m.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected m of TorsionalBucklingStrength[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected m of TorsionalBucklingStrength to be a array but was ', typeof src.m, src.m)
                        }
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                            dst.beta = AsNum(src.beta);
                        }
                        else {
                            console.log('Expected beta of TorsionalBucklingStrength to be a number but was ', typeof src.beta, src.beta)
                        }
                    }
                    if (src.h !== undefined && src.h !== null) {
                        if (typeof src.h === "number" || src.h === 'NaN' || src.h === 'Infinity' || src.h === '-Infinity') {
                            dst.h = AsNum(src.h);
                        }
                        else {
                            console.log('Expected h of TorsionalBucklingStrength to be a number but was ', typeof src.h, src.h)
                        }
                    }
                    if (src.lef !== undefined && src.lef !== null) {
                        if (typeof src.lef === "number" || src.lef === 'NaN' || src.lef === 'Infinity' || src.lef === '-Infinity') {
                            dst.lef = AsNum(src.lef);
                        }
                        else {
                            console.log('Expected lef of TorsionalBucklingStrength to be a number but was ', typeof src.lef, src.lef)
                        }
                    }
                    if (src.sigmamcrit !== undefined && src.sigmamcrit !== null) {
                        if (typeof src.sigmamcrit === "number" || src.sigmamcrit === 'NaN' || src.sigmamcrit === 'Infinity' || src.sigmamcrit === '-Infinity') {
                            dst.sigmamcrit = AsNum(src.sigmamcrit);
                        }
                        else {
                            console.log('Expected sigmamcrit of TorsionalBucklingStrength to be a number but was ', typeof src.sigmamcrit, src.sigmamcrit)
                        }
                    }
                    if (src.lambdarelm !== undefined && src.lambdarelm !== null) {
                        if (typeof src.lambdarelm === "number" || src.lambdarelm === 'NaN' || src.lambdarelm === 'Infinity' || src.lambdarelm === '-Infinity') {
                            dst.lambdarelm = AsNum(src.lambdarelm);
                        }
                        else {
                            console.log('Expected lambdarelm of TorsionalBucklingStrength to be a number but was ', typeof src.lambdarelm, src.lambdarelm)
                        }
                    }
                    if (src.kcrit !== undefined && src.kcrit !== null) {
                        if (typeof src.kcrit === "number" || src.kcrit === 'NaN' || src.kcrit === 'Infinity' || src.kcrit === '-Infinity') {
                            dst.kcrit = AsNum(src.kcrit);
                        }
                        else {
                            console.log('Expected kcrit of TorsionalBucklingStrength to be a number but was ', typeof src.kcrit, src.kcrit)
                        }
                    }
                    return dst;
                }

                static toObject(src: TorsionalBucklingStrength | null | undefined): TorsionalBucklingStrength_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.TorsionalBucklingStrength is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.TorsionalBucklingStrength") {
                        console.error('Expected ng.result.timber.TorsionalBucklingStrength but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const statSys_obj = ng.result.timber.StatSys_ToObject(src.statSys);
                    if(statSys_obj === null) return null;

                    const loadPos_obj = ng.beam.Alignment_ToObject(src.loadPos);
                    if(loadPos_obj === null) return null;

                    const dst : TorsionalBucklingStrength_json = {
                        relevant: src.relevant,
                        statSys: statSys_obj,
                        loadPos: loadPos_obj,
                        mMax: AsJsonNum(src.mMax),
                        m: new Array<JsonNumber>(),
                        beta: AsJsonNum(src.beta),
                        h: AsJsonNum(src.h),
                        lef: AsJsonNum(src.lef),
                        sigmamcrit: AsJsonNum(src.sigmamcrit),
                        lambdarelm: AsJsonNum(src.lambdarelm),
                        kcrit: AsJsonNum(src.kcrit),
                    };
                    if (src.m !== null) {
                        for (const element of src.m) {
                            dst.m.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: TorsionalBucklingStrength_createType) {
                    const dst = new TorsionalBucklingStrength();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.relevant !== undefined) {
                        dst.relevant = src.relevant;
                    }
                    if (src.statSys !== undefined) {
                        dst.statSys = src.statSys;
                    }
                    if (src.loadPos !== undefined) {
                        dst.loadPos = src.loadPos;
                    }
                    if (src.mMax !== undefined) {
                        dst.mMax = src.mMax;
                    }
                    if (src.m !== undefined) {
                        dst.m = src.m;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    if (src.h !== undefined) {
                        dst.h = src.h;
                    }
                    if (src.lef !== undefined) {
                        dst.lef = src.lef;
                    }
                    if (src.sigmamcrit !== undefined) {
                        dst.sigmamcrit = src.sigmamcrit;
                    }
                    if (src.lambdarelm !== undefined) {
                        dst.lambdarelm = src.lambdarelm;
                    }
                    if (src.kcrit !== undefined) {
                        dst.kcrit = src.kcrit;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TorsionalBucklingStrength();
                    dst.relevant = this.relevant;
                    dst.statSys = this.statSys;
                    dst.loadPos = this.loadPos;
                    dst.mMax = this.mMax;
                    dst.m = this.m;
                    dst.beta = this.beta;
                    dst.h = this.h;
                    dst.lef = this.lef;
                    dst.sigmamcrit = this.sigmamcrit;
                    dst.lambdarelm = this.lambdarelm;
                    dst.kcrit = this.kcrit;
                    return dst;
                }

                deepClone() {
                    const json = TorsionalBucklingStrength.toObject(this);
                    const dst = TorsionalBucklingStrength.fromObject(json);
                    return dst;
                }
            }
            export type ITorsionalBucklingStrength = TorsionalBucklingStrength;


            export type Data_keys = 'sectionResult';
            export interface Data_createType {
                sectionResult?: ng.result.timber.SectionResult | null,
            }
            export interface Data_json {
                sectionResult?: ng.result.timber.SectionResult_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                sectionResult?: unknown;
            }
            export class Data {
                __proto_name = "ng.result.timber.Data";
                sectionResult: ng.result.timber.SectionResult | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sectionResult !== undefined && src.sectionResult !== null) {
                        dst.sectionResult = ng.result.timber.SectionResult.fromObject(src.sectionResult);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.Data") {
                        console.error('Expected ng.result.timber.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                    };
                    if(src.sectionResult !== null)
                    {
                        const parsed = ng.result.timber.SectionResult.toObject(src.sectionResult);
                        if(parsed === null) return null;
                        dst.sectionResult = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sectionResult !== undefined) {
                        dst.sectionResult = src.sectionResult;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.sectionResult = this.sectionResult;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;


            export type Element_keys = 'maxOfControls';
            export interface Element_createType {
                maxOfControls?: ng.result.control.ControlData[],
            }
            export interface Element_json {
                maxOfControls: ng.result.control.ControlData_json[];
            }
            interface Element_json_in {
                __proto_name?: unknown;
                maxOfControls?: unknown;
            }
            export class Element {
                __proto_name = "ng.result.timber.Element";
                maxOfControls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): Element {
                    const dst = new Element();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Element but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Element_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.maxOfControls !== undefined && src.maxOfControls !== null) {
                        if (Array.isArray(src.maxOfControls)) {
                            for (const element of src.maxOfControls) {
                                dst.maxOfControls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected maxOfControls of Element to be a array but was ', typeof src.maxOfControls, src.maxOfControls)
                        }
                    }
                    return dst;
                }

                static toObject(src: Element | null | undefined): Element_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.Element is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.Element") {
                        console.error('Expected ng.result.timber.Element but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Element_json = {
                        maxOfControls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if (src.maxOfControls !== null) {
                        for (const element of src.maxOfControls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.maxOfControls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: Element_createType) {
                    const dst = new Element();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.maxOfControls !== undefined) {
                        dst.maxOfControls = src.maxOfControls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Element();
                    dst.maxOfControls = this.maxOfControls;
                    return dst;
                }

                deepClone() {
                    const json = Element.toObject(this);
                    const dst = Element.fromObject(json);
                    return dst;
                }
            }
            export type IElement = Element;


            export type DesignSummary_keys = 'elemGuid' | 'varyingBar' | 'isCharredSectionTooSmall' | 'extraParameters' | 'extraParametersFire' | 'controls';
            export interface DesignSummary_createType {
                elemGuid?: string,
                varyingBar?: ng.result.steel.BarSectionType,
                isCharredSectionTooSmall?: boolean,
                extraParameters?: ng.result.timber.ExtraParameters[],
                extraParametersFire?: ng.result.timber.ExtraParameters[],
                controls?: ng.result.control.ControlData[],
            }
            export interface DesignSummary_json {
                elemGuid?: string;
                varyingBar?: string;
                isCharredSectionTooSmall?: boolean;
                extraParameters: ng.result.timber.ExtraParameters_json[];
                extraParametersFire: ng.result.timber.ExtraParameters_json[];
                controls: ng.result.control.ControlData_json[];
            }
            interface DesignSummary_json_in {
                __proto_name?: unknown;
                elemGuid?: unknown;
                varyingBar?: unknown;
                isCharredSectionTooSmall?: unknown;
                extraParameters?: unknown;
                extraParametersFire?: unknown;
                controls?: unknown;
            }
            export class DesignSummary {
                __proto_name = "ng.result.timber.DesignSummary";
                elemGuid: string = "";
                varyingBar: ng.result.steel.BarSectionType = ng.result.steel.BarSectionType.BAR_SECTION_TYPE_UNSPECIFIED;
                isCharredSectionTooSmall: boolean = false;
                extraParameters: ng.result.timber.ExtraParameters[] = [];
                extraParametersFire: ng.result.timber.ExtraParameters[] = [];
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): DesignSummary {
                    const dst = new DesignSummary();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignSummary but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignSummary_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignSummary but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elemGuid !== undefined && src.elemGuid !== null) {
                        if (typeof src.elemGuid === "string") {
                            dst.elemGuid = src.elemGuid;
                        }
                        else {
                            console.log('Expected elemGuid of DesignSummary to be a string but was ', typeof src.elemGuid, src.elemGuid)
                        }
                    }
                    if (src.varyingBar !== undefined && src.varyingBar !== null) {
                        dst.varyingBar = ng.result.steel.BarSectionType_FromObject(src.varyingBar);
                    }
                    if (src.isCharredSectionTooSmall !== undefined && src.isCharredSectionTooSmall !== null) {
                        if (typeof src.isCharredSectionTooSmall === "boolean") {
                            dst.isCharredSectionTooSmall = src.isCharredSectionTooSmall;
                        }
                        else {
                            console.log('Expected isCharredSectionTooSmall of DesignSummary to be a boolean but was ', typeof src.isCharredSectionTooSmall, src.isCharredSectionTooSmall)
                        }
                    }
                    if (src.extraParameters !== undefined && src.extraParameters !== null) {
                        if (Array.isArray(src.extraParameters)) {
                            for (const element of src.extraParameters) {
                                dst.extraParameters.push(ng.result.timber.ExtraParameters.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected extraParameters of DesignSummary to be a array but was ', typeof src.extraParameters, src.extraParameters)
                        }
                    }
                    if (src.extraParametersFire !== undefined && src.extraParametersFire !== null) {
                        if (Array.isArray(src.extraParametersFire)) {
                            for (const element of src.extraParametersFire) {
                                dst.extraParametersFire.push(ng.result.timber.ExtraParameters.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected extraParametersFire of DesignSummary to be a array but was ', typeof src.extraParametersFire, src.extraParametersFire)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of DesignSummary to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignSummary | null | undefined): DesignSummary_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.timber.DesignSummary is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.timber.DesignSummary") {
                        console.error('Expected ng.result.timber.DesignSummary but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const varyingBar_obj = ng.result.steel.BarSectionType_ToObject(src.varyingBar);
                    if(varyingBar_obj === null) return null;

                    const dst : DesignSummary_json = {
                        elemGuid: src.elemGuid,
                        varyingBar: varyingBar_obj,
                        isCharredSectionTooSmall: src.isCharredSectionTooSmall,
                        extraParameters: new Array<ng.result.timber.ExtraParameters_json>(),
                        extraParametersFire: new Array<ng.result.timber.ExtraParameters_json>(),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if (src.extraParameters !== null) {
                        for (const element of src.extraParameters) {
                            const parsed = ng.result.timber.ExtraParameters.toObject(element);
                            if(parsed === null) return null;
                            dst.extraParameters.push(parsed);
                        }
                    }
                    if (src.extraParametersFire !== null) {
                        for (const element of src.extraParametersFire) {
                            const parsed = ng.result.timber.ExtraParameters.toObject(element);
                            if(parsed === null) return null;
                            dst.extraParametersFire.push(parsed);
                        }
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: DesignSummary_createType) {
                    const dst = new DesignSummary();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elemGuid !== undefined) {
                        dst.elemGuid = src.elemGuid;
                    }
                    if (src.varyingBar !== undefined) {
                        dst.varyingBar = src.varyingBar;
                    }
                    if (src.isCharredSectionTooSmall !== undefined) {
                        dst.isCharredSectionTooSmall = src.isCharredSectionTooSmall;
                    }
                    if (src.extraParameters !== undefined) {
                        dst.extraParameters = src.extraParameters;
                    }
                    if (src.extraParametersFire !== undefined) {
                        dst.extraParametersFire = src.extraParametersFire;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignSummary();
                    dst.elemGuid = this.elemGuid;
                    dst.varyingBar = this.varyingBar;
                    dst.isCharredSectionTooSmall = this.isCharredSectionTooSmall;
                    dst.extraParameters = this.extraParameters;
                    dst.extraParametersFire = this.extraParametersFire;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = DesignSummary.toObject(this);
                    const dst = DesignSummary.fromObject(json);
                    return dst;
                }
            }
            export type IDesignSummary = DesignSummary;
        } // namespace timber


        // Defined in Result/steel.proto
        export namespace steel {
            export enum BarSectionType {
                BAR_SECTION_TYPE_UNSPECIFIED = 0,
                BAR_SECTION_TYPE_UNIFORM = 1,
                BAR_SECTION_TYPE_VARIABLE = 2
            }
            export const BarSectionType_FromObject = (src: unknown): BarSectionType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'BAR_SECTION_TYPE_UNSPECIFIED':
                        return BarSectionType.BAR_SECTION_TYPE_UNSPECIFIED;
                    case 1:
                    case 'BAR_SECTION_TYPE_UNIFORM':
                        return BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                    case 2:
                    case 'BAR_SECTION_TYPE_VARIABLE':
                        return BarSectionType.BAR_SECTION_TYPE_VARIABLE;
                    default:
                        console.log('Unhandled value for BarSectionType:' + src + '. ' + typeof(src));
                        return BarSectionType.BAR_SECTION_TYPE_UNSPECIFIED;
                }
            };
            export const BarSectionType_ToObject = (src: BarSectionType): string | null => {
                switch (src) {
                    case BarSectionType.BAR_SECTION_TYPE_UNSPECIFIED:
                        return 'BAR_SECTION_TYPE_UNSPECIFIED';
                    case BarSectionType.BAR_SECTION_TYPE_UNIFORM:
                        return 'BAR_SECTION_TYPE_UNIFORM';
                    case BarSectionType.BAR_SECTION_TYPE_VARIABLE:
                        return 'BAR_SECTION_TYPE_VARIABLE';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for BarSectionType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Curve {
                CURVE_UNSPECIFIED = 0,
                CURVE_A0 = 1,
                CURVE_A = 2,
                CURVE_B = 3,
                CURVE_C = 4,
                CURVE_D = 5
            }
            export const Curve_FromObject = (src: unknown): Curve => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CURVE_UNSPECIFIED':
                        return Curve.CURVE_UNSPECIFIED;
                    case 1:
                    case 'CURVE_A0':
                        return Curve.CURVE_A0;
                    case 2:
                    case 'CURVE_A':
                        return Curve.CURVE_A;
                    case 3:
                    case 'CURVE_B':
                        return Curve.CURVE_B;
                    case 4:
                    case 'CURVE_C':
                        return Curve.CURVE_C;
                    case 5:
                    case 'CURVE_D':
                        return Curve.CURVE_D;
                    default:
                        console.log('Unhandled value for Curve:' + src + '. ' + typeof(src));
                        return Curve.CURVE_UNSPECIFIED;
                }
            };
            export const Curve_ToObject = (src: Curve): string | null => {
                switch (src) {
                    case Curve.CURVE_UNSPECIFIED:
                        return 'CURVE_UNSPECIFIED';
                    case Curve.CURVE_A0:
                        return 'CURVE_A0';
                    case Curve.CURVE_A:
                        return 'CURVE_A';
                    case Curve.CURVE_B:
                        return 'CURVE_B';
                    case Curve.CURVE_C:
                        return 'CURVE_C';
                    case Curve.CURVE_D:
                        return 'CURVE_D';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Curve, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum CurveLT {
                CURVE_LT_UNSPECIFIED = 0,
                CURVE_L_T_A = 1,
                CURVE_L_T_B = 2,
                CURVE_L_T_C = 3,
                CURVE_L_T_D = 4
            }
            export const CurveLT_FromObject = (src: unknown): CurveLT => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CURVE_LT_UNSPECIFIED':
                        return CurveLT.CURVE_LT_UNSPECIFIED;
                    case 1:
                    case 'CURVE_L_T_A':
                        return CurveLT.CURVE_L_T_A;
                    case 2:
                    case 'CURVE_L_T_B':
                        return CurveLT.CURVE_L_T_B;
                    case 3:
                    case 'CURVE_L_T_C':
                        return CurveLT.CURVE_L_T_C;
                    case 4:
                    case 'CURVE_L_T_D':
                        return CurveLT.CURVE_L_T_D;
                    default:
                        console.log('Unhandled value for CurveLT:' + src + '. ' + typeof(src));
                        return CurveLT.CURVE_LT_UNSPECIFIED;
                }
            };
            export const CurveLT_ToObject = (src: CurveLT): string | null => {
                switch (src) {
                    case CurveLT.CURVE_LT_UNSPECIFIED:
                        return 'CURVE_LT_UNSPECIFIED';
                    case CurveLT.CURVE_L_T_A:
                        return 'CURVE_L_T_A';
                    case CurveLT.CURVE_L_T_B:
                        return 'CURVE_L_T_B';
                    case CurveLT.CURVE_L_T_C:
                        return 'CURVE_L_T_C';
                    case CurveLT.CURVE_L_T_D:
                        return 'CURVE_L_T_D';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for CurveLT, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum StBarWebRelevant {
                ST_BAR_WEB_RELEVANT_UNSPECIFIED = 0,
                ST_BAR_WEB_RELEVANT_NO = 1,
                ST_BAR_WEB_RELEVANT_YES = 2,
                ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT = 3,
                ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT = 4
            }
            export const StBarWebRelevant_FromObject = (src: unknown): StBarWebRelevant => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ST_BAR_WEB_RELEVANT_UNSPECIFIED':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_UNSPECIFIED;
                    case 1:
                    case 'ST_BAR_WEB_RELEVANT_NO':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO;
                    case 2:
                    case 'ST_BAR_WEB_RELEVANT_YES':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_YES;
                    case 3:
                    case 'ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT;
                    case 4:
                    case 'ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT;
                    default:
                        console.log('Unhandled value for StBarWebRelevant:' + src + '. ' + typeof(src));
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_UNSPECIFIED;
                }
            };
            export const StBarWebRelevant_ToObject = (src: StBarWebRelevant): string | null => {
                switch (src) {
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_UNSPECIFIED:
                        return 'ST_BAR_WEB_RELEVANT_UNSPECIFIED';
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO:
                        return 'ST_BAR_WEB_RELEVANT_NO';
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_YES:
                        return 'ST_BAR_WEB_RELEVANT_YES';
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT:
                        return 'ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT';
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT:
                        return 'ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for StBarWebRelevant, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ShearResistanceEnum {
                SHEAR_RESISTANCE_UNSPECIFIED = 0,
                SHEAR_RESISTANCE_NONE = 1,
                SHEAR_RESISTANCE_I_LIKE = 2,
                SHEAR_RESISTANCE_U_LIKE = 3,
                SHEAR_RESISTANCE_HOLLOW = 4
            }
            export const ShearResistanceEnum_FromObject = (src: unknown): ShearResistanceEnum => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SHEAR_RESISTANCE_UNSPECIFIED':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED;
                    case 1:
                    case 'SHEAR_RESISTANCE_NONE':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_NONE;
                    case 2:
                    case 'SHEAR_RESISTANCE_I_LIKE':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_I_LIKE;
                    case 3:
                    case 'SHEAR_RESISTANCE_U_LIKE':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_U_LIKE;
                    case 4:
                    case 'SHEAR_RESISTANCE_HOLLOW':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_HOLLOW;
                    default:
                        console.log('Unhandled value for ShearResistanceEnum:' + src + '. ' + typeof(src));
                        return ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED;
                }
            };
            export const ShearResistanceEnum_ToObject = (src: ShearResistanceEnum): string | null => {
                switch (src) {
                    case ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED:
                        return 'SHEAR_RESISTANCE_UNSPECIFIED';
                    case ShearResistanceEnum.SHEAR_RESISTANCE_NONE:
                        return 'SHEAR_RESISTANCE_NONE';
                    case ShearResistanceEnum.SHEAR_RESISTANCE_I_LIKE:
                        return 'SHEAR_RESISTANCE_I_LIKE';
                    case ShearResistanceEnum.SHEAR_RESISTANCE_U_LIKE:
                        return 'SHEAR_RESISTANCE_U_LIKE';
                    case ShearResistanceEnum.SHEAR_RESISTANCE_HOLLOW:
                        return 'SHEAR_RESISTANCE_HOLLOW';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ShearResistanceEnum, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type TVPointW_keys = 'numberOfPoints' | 'coordinates';
            export interface TVPointW_createType {
                numberOfPoints?: number,
                coordinates?: ng.geometry.Vector2D[],
            }
            export interface TVPointW_json {
                numberOfPoints?: JsonNumber;
                coordinates: ng.geometry.Vector2D_json[];
            }
            interface TVPointW_json_in {
                __proto_name?: unknown;
                numberOfPoints?: unknown;
                coordinates?: unknown;
            }
            export class TVPointW {
                __proto_name = "ng.result.steel.TVPointW";
                numberOfPoints: number = 0;
                coordinates: ng.geometry.Vector2D[] = [];

                static fromObject(src_unknown: unknown): TVPointW {
                    const dst = new TVPointW();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TVPointW but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TVPointW_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TVPointW but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.numberOfPoints !== undefined && src.numberOfPoints !== null) {
                        if (typeof src.numberOfPoints === "number" || src.numberOfPoints === 'NaN' || src.numberOfPoints === 'Infinity' || src.numberOfPoints === '-Infinity') {
                            dst.numberOfPoints = NumberToInt("ng.result.steel.TVPointW.number_of_points", AsNum(src.numberOfPoints));
                        }
                        else {
                            console.log('Expected numberOfPoints of TVPointW to be a number but was ', typeof src.numberOfPoints, src.numberOfPoints)
                        }
                    }
                    if (src.coordinates !== undefined && src.coordinates !== null) {
                        if (Array.isArray(src.coordinates)) {
                            for (const element of src.coordinates) {
                                dst.coordinates.push(ng.geometry.Vector2D.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected coordinates of TVPointW to be a array but was ', typeof src.coordinates, src.coordinates)
                        }
                    }
                    return dst;
                }

                static toObject(src: TVPointW | null | undefined): TVPointW_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.TVPointW is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.TVPointW") {
                        console.error('Expected ng.result.steel.TVPointW but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : TVPointW_json = {
                        numberOfPoints: AsJsonNum(NumberToInt("ng.result.steel.TVPointW.number_of_points", src.numberOfPoints)),
                        coordinates: new Array<ng.geometry.Vector2D_json>(),
                    };
                    if (src.coordinates !== null) {
                        for (const element of src.coordinates) {
                            const parsed = ng.geometry.Vector2D.toObject(element);
                            if(parsed === null) return null;
                            dst.coordinates.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: TVPointW_createType) {
                    const dst = new TVPointW();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.numberOfPoints !== undefined) {
                        dst.numberOfPoints = src.numberOfPoints;
                    }
                    if (src.coordinates !== undefined) {
                        dst.coordinates = src.coordinates;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TVPointW();
                    dst.numberOfPoints = this.numberOfPoints;
                    dst.coordinates = this.coordinates;
                    return dst;
                }

                deepClone() {
                    const json = TVPointW.toObject(this);
                    const dst = TVPointW.fromObject(json);
                    return dst;
                }
            }
            export type ITVPointW = TVPointW;


            export type BucklingShapes_keys = 'flexural1' | 'flexural2' | 'flexuralTorsional' | 'lateralTorsionalTop' | 'lateralTorsionalBottom';
            export interface BucklingShapes_createType {
                flexural1?: ng.result.steel.Curve,
                flexural2?: ng.result.steel.Curve,
                flexuralTorsional?: ng.result.steel.Curve,
                lateralTorsionalTop?: ng.result.steel.CurveLT,
                lateralTorsionalBottom?: ng.result.steel.CurveLT,
            }
            export interface BucklingShapes_json {
                flexural1?: string;
                flexural2?: string;
                flexuralTorsional?: string;
                lateralTorsionalTop?: string;
                lateralTorsionalBottom?: string;
            }
            interface BucklingShapes_json_in {
                __proto_name?: unknown;
                flexural1?: unknown;
                flexural2?: unknown;
                flexuralTorsional?: unknown;
                lateralTorsionalTop?: unknown;
                lateralTorsionalBottom?: unknown;
            }
            export class BucklingShapes {
                __proto_name = "ng.result.steel.BucklingShapes";
                flexural1: ng.result.steel.Curve = ng.result.steel.Curve.CURVE_UNSPECIFIED;
                flexural2: ng.result.steel.Curve = ng.result.steel.Curve.CURVE_UNSPECIFIED;
                flexuralTorsional: ng.result.steel.Curve = ng.result.steel.Curve.CURVE_UNSPECIFIED;
                lateralTorsionalTop: ng.result.steel.CurveLT = ng.result.steel.CurveLT.CURVE_LT_UNSPECIFIED;
                lateralTorsionalBottom: ng.result.steel.CurveLT = ng.result.steel.CurveLT.CURVE_LT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): BucklingShapes {
                    const dst = new BucklingShapes();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BucklingShapes but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BucklingShapes_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BucklingShapes but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.flexural1 !== undefined && src.flexural1 !== null) {
                        dst.flexural1 = ng.result.steel.Curve_FromObject(src.flexural1);
                    }
                    if (src.flexural2 !== undefined && src.flexural2 !== null) {
                        dst.flexural2 = ng.result.steel.Curve_FromObject(src.flexural2);
                    }
                    if (src.flexuralTorsional !== undefined && src.flexuralTorsional !== null) {
                        dst.flexuralTorsional = ng.result.steel.Curve_FromObject(src.flexuralTorsional);
                    }
                    if (src.lateralTorsionalTop !== undefined && src.lateralTorsionalTop !== null) {
                        dst.lateralTorsionalTop = ng.result.steel.CurveLT_FromObject(src.lateralTorsionalTop);
                    }
                    if (src.lateralTorsionalBottom !== undefined && src.lateralTorsionalBottom !== null) {
                        dst.lateralTorsionalBottom = ng.result.steel.CurveLT_FromObject(src.lateralTorsionalBottom);
                    }
                    return dst;
                }

                static toObject(src: BucklingShapes | null | undefined): BucklingShapes_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.BucklingShapes is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.BucklingShapes") {
                        console.error('Expected ng.result.steel.BucklingShapes but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const flexural1_obj = ng.result.steel.Curve_ToObject(src.flexural1);
                    if(flexural1_obj === null) return null;

                    const flexural2_obj = ng.result.steel.Curve_ToObject(src.flexural2);
                    if(flexural2_obj === null) return null;

                    const flexuralTorsional_obj = ng.result.steel.Curve_ToObject(src.flexuralTorsional);
                    if(flexuralTorsional_obj === null) return null;

                    const lateralTorsionalTop_obj = ng.result.steel.CurveLT_ToObject(src.lateralTorsionalTop);
                    if(lateralTorsionalTop_obj === null) return null;

                    const lateralTorsionalBottom_obj = ng.result.steel.CurveLT_ToObject(src.lateralTorsionalBottom);
                    if(lateralTorsionalBottom_obj === null) return null;

                    const dst : BucklingShapes_json = {
                        flexural1: flexural1_obj,
                        flexural2: flexural2_obj,
                        flexuralTorsional: flexuralTorsional_obj,
                        lateralTorsionalTop: lateralTorsionalTop_obj,
                        lateralTorsionalBottom: lateralTorsionalBottom_obj,
                    };
                    return dst;
                }

                static create(src?: BucklingShapes_createType) {
                    const dst = new BucklingShapes();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.flexural1 !== undefined) {
                        dst.flexural1 = src.flexural1;
                    }
                    if (src.flexural2 !== undefined) {
                        dst.flexural2 = src.flexural2;
                    }
                    if (src.flexuralTorsional !== undefined) {
                        dst.flexuralTorsional = src.flexuralTorsional;
                    }
                    if (src.lateralTorsionalTop !== undefined) {
                        dst.lateralTorsionalTop = src.lateralTorsionalTop;
                    }
                    if (src.lateralTorsionalBottom !== undefined) {
                        dst.lateralTorsionalBottom = src.lateralTorsionalBottom;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BucklingShapes();
                    dst.flexural1 = this.flexural1;
                    dst.flexural2 = this.flexural2;
                    dst.flexuralTorsional = this.flexuralTorsional;
                    dst.lateralTorsionalTop = this.lateralTorsionalTop;
                    dst.lateralTorsionalBottom = this.lateralTorsionalBottom;
                    return dst;
                }

                deepClone() {
                    const json = BucklingShapes.toObject(this);
                    const dst = BucklingShapes.fromObject(json);
                    return dst;
                }
            }
            export type IBucklingShapes = BucklingShapes;


            export type SteelDesignNationalAnnexValues_keys = 'kfl' | 'etawb' | 'lambdaLT0' | 'beta';
            export interface SteelDesignNationalAnnexValues_createType {
                kfl?: number,
                etawb?: number,
                lambdaLT0?: number,
                beta?: number,
            }
            export interface SteelDesignNationalAnnexValues_json {
                kfl?: JsonNumber;
                etawb?: JsonNumber;
                lambdaLT0?: JsonNumber;
                beta?: JsonNumber;
            }
            interface SteelDesignNationalAnnexValues_json_in {
                __proto_name?: unknown;
                kfl?: unknown;
                etawb?: unknown;
                lambdaLT0?: unknown;
                beta?: unknown;
            }
            export class SteelDesignNationalAnnexValues {
                __proto_name = "ng.result.steel.SteelDesignNationalAnnexValues";
                kfl: number = 0;
                etawb: number = 0;
                lambdaLT0: number = 0;
                beta: number = 0;

                static fromObject(src_unknown: unknown): SteelDesignNationalAnnexValues {
                    const dst = new SteelDesignNationalAnnexValues();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SteelDesignNationalAnnexValues but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SteelDesignNationalAnnexValues_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SteelDesignNationalAnnexValues but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kfl !== undefined && src.kfl !== null) {
                        if (typeof src.kfl === "number" || src.kfl === 'NaN' || src.kfl === 'Infinity' || src.kfl === '-Infinity') {
                            dst.kfl = AsNum(src.kfl);
                        }
                        else {
                            console.log('Expected kfl of SteelDesignNationalAnnexValues to be a number but was ', typeof src.kfl, src.kfl)
                        }
                    }
                    if (src.etawb !== undefined && src.etawb !== null) {
                        if (typeof src.etawb === "number" || src.etawb === 'NaN' || src.etawb === 'Infinity' || src.etawb === '-Infinity') {
                            dst.etawb = AsNum(src.etawb);
                        }
                        else {
                            console.log('Expected etawb of SteelDesignNationalAnnexValues to be a number but was ', typeof src.etawb, src.etawb)
                        }
                    }
                    if (src.lambdaLT0 !== undefined && src.lambdaLT0 !== null) {
                        if (typeof src.lambdaLT0 === "number" || src.lambdaLT0 === 'NaN' || src.lambdaLT0 === 'Infinity' || src.lambdaLT0 === '-Infinity') {
                            dst.lambdaLT0 = AsNum(src.lambdaLT0);
                        }
                        else {
                            console.log('Expected lambdaLT0 of SteelDesignNationalAnnexValues to be a number but was ', typeof src.lambdaLT0, src.lambdaLT0)
                        }
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                            dst.beta = AsNum(src.beta);
                        }
                        else {
                            console.log('Expected beta of SteelDesignNationalAnnexValues to be a number but was ', typeof src.beta, src.beta)
                        }
                    }
                    return dst;
                }

                static toObject(src: SteelDesignNationalAnnexValues | null | undefined): SteelDesignNationalAnnexValues_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.SteelDesignNationalAnnexValues is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.SteelDesignNationalAnnexValues") {
                        console.error('Expected ng.result.steel.SteelDesignNationalAnnexValues but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SteelDesignNationalAnnexValues_json = {
                        kfl: AsJsonNum(src.kfl),
                        etawb: AsJsonNum(src.etawb),
                        lambdaLT0: AsJsonNum(src.lambdaLT0),
                        beta: AsJsonNum(src.beta),
                    };
                    return dst;
                }

                static create(src?: SteelDesignNationalAnnexValues_createType) {
                    const dst = new SteelDesignNationalAnnexValues();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kfl !== undefined) {
                        dst.kfl = src.kfl;
                    }
                    if (src.etawb !== undefined) {
                        dst.etawb = src.etawb;
                    }
                    if (src.lambdaLT0 !== undefined) {
                        dst.lambdaLT0 = src.lambdaLT0;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SteelDesignNationalAnnexValues();
                    dst.kfl = this.kfl;
                    dst.etawb = this.etawb;
                    dst.lambdaLT0 = this.lambdaLT0;
                    dst.beta = this.beta;
                    return dst;
                }

                deepClone() {
                    const json = SteelDesignNationalAnnexValues.toObject(this);
                    const dst = SteelDesignNationalAnnexValues.fromObject(json);
                    return dst;
                }
            }
            export type ISteelDesignNationalAnnexValues = SteelDesignNationalAnnexValues;


            export type Boolean2D_keys = 'one' | 'two';
            export interface Boolean2D_createType {
                one?: boolean,
                two?: boolean,
            }
            export interface Boolean2D_json {
                one?: boolean;
                two?: boolean;
            }
            interface Boolean2D_json_in {
                __proto_name?: unknown;
                one?: unknown;
                two?: unknown;
            }
            export class Boolean2D {
                __proto_name = "ng.result.steel.Boolean2D";
                one: boolean = false;
                two: boolean = false;

                static fromObject(src_unknown: unknown): Boolean2D {
                    const dst = new Boolean2D();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Boolean2D but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Boolean2D_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Boolean2D but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.one !== undefined && src.one !== null) {
                        if (typeof src.one === "boolean") {
                            dst.one = src.one;
                        }
                        else {
                            console.log('Expected one of Boolean2D to be a boolean but was ', typeof src.one, src.one)
                        }
                    }
                    if (src.two !== undefined && src.two !== null) {
                        if (typeof src.two === "boolean") {
                            dst.two = src.two;
                        }
                        else {
                            console.log('Expected two of Boolean2D to be a boolean but was ', typeof src.two, src.two)
                        }
                    }
                    return dst;
                }

                static toObject(src: Boolean2D | null | undefined): Boolean2D_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Boolean2D is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Boolean2D") {
                        console.error('Expected ng.result.steel.Boolean2D but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Boolean2D_json = {
                        one: src.one,
                        two: src.two,
                    };
                    return dst;
                }

                static create(src?: Boolean2D_createType) {
                    const dst = new Boolean2D();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.one !== undefined) {
                        dst.one = src.one;
                    }
                    if (src.two !== undefined) {
                        dst.two = src.two;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Boolean2D();
                    dst.one = this.one;
                    dst.two = this.two;
                    return dst;
                }

                deepClone() {
                    const json = Boolean2D.toObject(this);
                    const dst = Boolean2D.fromObject(json);
                    return dst;
                }
            }
            export type IBoolean2D = Boolean2D;


            export type VirtualStiffeners_keys = 'start' | 'end';
            export interface VirtualStiffeners_createType {
                start?: boolean,
                end?: boolean,
            }
            export interface VirtualStiffeners_json {
                start?: boolean;
                end?: boolean;
            }
            interface VirtualStiffeners_json_in {
                __proto_name?: unknown;
                start?: unknown;
                end?: unknown;
            }
            export class VirtualStiffeners {
                __proto_name = "ng.result.steel.VirtualStiffeners";
                start: boolean = false;
                end: boolean = false;

                static fromObject(src_unknown: unknown): VirtualStiffeners {
                    const dst = new VirtualStiffeners();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted VirtualStiffeners but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as VirtualStiffeners_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for VirtualStiffeners but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.start !== undefined && src.start !== null) {
                        if (typeof src.start === "boolean") {
                            dst.start = src.start;
                        }
                        else {
                            console.log('Expected start of VirtualStiffeners to be a boolean but was ', typeof src.start, src.start)
                        }
                    }
                    if (src.end !== undefined && src.end !== null) {
                        if (typeof src.end === "boolean") {
                            dst.end = src.end;
                        }
                        else {
                            console.log('Expected end of VirtualStiffeners to be a boolean but was ', typeof src.end, src.end)
                        }
                    }
                    return dst;
                }

                static toObject(src: VirtualStiffeners | null | undefined): VirtualStiffeners_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.VirtualStiffeners is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.VirtualStiffeners") {
                        console.error('Expected ng.result.steel.VirtualStiffeners but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : VirtualStiffeners_json = {
                        start: src.start,
                        end: src.end,
                    };
                    return dst;
                }

                static create(src?: VirtualStiffeners_createType) {
                    const dst = new VirtualStiffeners();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.start !== undefined) {
                        dst.start = src.start;
                    }
                    if (src.end !== undefined) {
                        dst.end = src.end;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new VirtualStiffeners();
                    dst.start = this.start;
                    dst.end = this.end;
                    return dst;
                }

                deepClone() {
                    const json = VirtualStiffeners.toObject(this);
                    const dst = VirtualStiffeners.fromObject(json);
                    return dst;
                }
            }
            export type IVirtualStiffeners = VirtualStiffeners;


            export type SectionClass_keys = 'sClassGenN' | 'sClassGenM1' | 'sClassGenM2' | 'sClassGenMax';
            export interface SectionClass_createType {
                sClassGenN?: number,
                sClassGenM1?: number,
                sClassGenM2?: number,
                sClassGenMax?: number,
            }
            export interface SectionClass_json {
                sClassGenN?: JsonNumber;
                sClassGenM1?: JsonNumber;
                sClassGenM2?: JsonNumber;
                sClassGenMax?: JsonNumber;
            }
            interface SectionClass_json_in {
                __proto_name?: unknown;
                sClassGenN?: unknown;
                sClassGenM1?: unknown;
                sClassGenM2?: unknown;
                sClassGenMax?: unknown;
            }
            export class SectionClass {
                __proto_name = "ng.result.steel.SectionClass";
                sClassGenN: number = 0;
                sClassGenM1: number = 0;
                sClassGenM2: number = 0;
                sClassGenMax: number = 0;

                static fromObject(src_unknown: unknown): SectionClass {
                    const dst = new SectionClass();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionClass but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionClass_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionClass but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sClassGenN !== undefined && src.sClassGenN !== null) {
                        if (typeof src.sClassGenN === "number" || src.sClassGenN === 'NaN' || src.sClassGenN === 'Infinity' || src.sClassGenN === '-Infinity') {
                            dst.sClassGenN = NumberToInt("ng.result.steel.SectionClass.s_class_gen_n", AsNum(src.sClassGenN));
                        }
                        else {
                            console.log('Expected sClassGenN of SectionClass to be a number but was ', typeof src.sClassGenN, src.sClassGenN)
                        }
                    }
                    if (src.sClassGenM1 !== undefined && src.sClassGenM1 !== null) {
                        if (typeof src.sClassGenM1 === "number" || src.sClassGenM1 === 'NaN' || src.sClassGenM1 === 'Infinity' || src.sClassGenM1 === '-Infinity') {
                            dst.sClassGenM1 = NumberToInt("ng.result.steel.SectionClass.s_class_gen_m1", AsNum(src.sClassGenM1));
                        }
                        else {
                            console.log('Expected sClassGenM1 of SectionClass to be a number but was ', typeof src.sClassGenM1, src.sClassGenM1)
                        }
                    }
                    if (src.sClassGenM2 !== undefined && src.sClassGenM2 !== null) {
                        if (typeof src.sClassGenM2 === "number" || src.sClassGenM2 === 'NaN' || src.sClassGenM2 === 'Infinity' || src.sClassGenM2 === '-Infinity') {
                            dst.sClassGenM2 = NumberToInt("ng.result.steel.SectionClass.s_class_gen_m2", AsNum(src.sClassGenM2));
                        }
                        else {
                            console.log('Expected sClassGenM2 of SectionClass to be a number but was ', typeof src.sClassGenM2, src.sClassGenM2)
                        }
                    }
                    if (src.sClassGenMax !== undefined && src.sClassGenMax !== null) {
                        if (typeof src.sClassGenMax === "number" || src.sClassGenMax === 'NaN' || src.sClassGenMax === 'Infinity' || src.sClassGenMax === '-Infinity') {
                            dst.sClassGenMax = NumberToInt("ng.result.steel.SectionClass.s_class_gen_max", AsNum(src.sClassGenMax));
                        }
                        else {
                            console.log('Expected sClassGenMax of SectionClass to be a number but was ', typeof src.sClassGenMax, src.sClassGenMax)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionClass | null | undefined): SectionClass_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.SectionClass is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.SectionClass") {
                        console.error('Expected ng.result.steel.SectionClass but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionClass_json = {
                        sClassGenN: AsJsonNum(NumberToInt("ng.result.steel.SectionClass.s_class_gen_n", src.sClassGenN)),
                        sClassGenM1: AsJsonNum(NumberToInt("ng.result.steel.SectionClass.s_class_gen_m1", src.sClassGenM1)),
                        sClassGenM2: AsJsonNum(NumberToInt("ng.result.steel.SectionClass.s_class_gen_m2", src.sClassGenM2)),
                        sClassGenMax: AsJsonNum(NumberToInt("ng.result.steel.SectionClass.s_class_gen_max", src.sClassGenMax)),
                    };
                    return dst;
                }

                static create(src?: SectionClass_createType) {
                    const dst = new SectionClass();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sClassGenN !== undefined) {
                        dst.sClassGenN = src.sClassGenN;
                    }
                    if (src.sClassGenM1 !== undefined) {
                        dst.sClassGenM1 = src.sClassGenM1;
                    }
                    if (src.sClassGenM2 !== undefined) {
                        dst.sClassGenM2 = src.sClassGenM2;
                    }
                    if (src.sClassGenMax !== undefined) {
                        dst.sClassGenMax = src.sClassGenMax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionClass();
                    dst.sClassGenN = this.sClassGenN;
                    dst.sClassGenM1 = this.sClassGenM1;
                    dst.sClassGenM2 = this.sClassGenM2;
                    dst.sClassGenMax = this.sClassGenMax;
                    return dst;
                }

                deepClone() {
                    const json = SectionClass.toObject(this);
                    const dst = SectionClass.fromObject(json);
                    return dst;
                }
            }
            export type ISectionClass = SectionClass;


            export type EffectiveClassFour_keys = 'aEff' | 'iEff' | 'eNEff' | 'wcEff' | 'wtEff';
            export interface EffectiveClassFour_createType {
                aEff?: number,
                iEff?: ng.geometry.Vector2D | null,
                eNEff?: ng.geometry.Vector2D | null,
                wcEff?: ng.geometry.Vector2D | null,
                wtEff?: ng.geometry.Vector2D | null,
            }
            export interface EffectiveClassFour_json {
                aEff?: JsonNumber;
                iEff?: ng.geometry.Vector2D_json;
                eNEff?: ng.geometry.Vector2D_json;
                wcEff?: ng.geometry.Vector2D_json;
                wtEff?: ng.geometry.Vector2D_json;
            }
            interface EffectiveClassFour_json_in {
                __proto_name?: unknown;
                aEff?: unknown;
                iEff?: unknown;
                eNEff?: unknown;
                wcEff?: unknown;
                wtEff?: unknown;
            }
            export class EffectiveClassFour {
                __proto_name = "ng.result.steel.EffectiveClassFour";
                aEff: number = 0;
                iEff: ng.geometry.Vector2D | null = null;
                eNEff: ng.geometry.Vector2D | null = null;
                wcEff: ng.geometry.Vector2D | null = null;
                wtEff: ng.geometry.Vector2D | null = null;

                static fromObject(src_unknown: unknown): EffectiveClassFour {
                    const dst = new EffectiveClassFour();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EffectiveClassFour but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EffectiveClassFour_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EffectiveClassFour but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.aEff !== undefined && src.aEff !== null) {
                        if (typeof src.aEff === "number" || src.aEff === 'NaN' || src.aEff === 'Infinity' || src.aEff === '-Infinity') {
                            dst.aEff = AsNum(src.aEff);
                        }
                        else {
                            console.log('Expected aEff of EffectiveClassFour to be a number but was ', typeof src.aEff, src.aEff)
                        }
                    }
                    if (src.iEff !== undefined && src.iEff !== null) {
                        dst.iEff = ng.geometry.Vector2D.fromObject(src.iEff);
                    }
                    if (src.eNEff !== undefined && src.eNEff !== null) {
                        dst.eNEff = ng.geometry.Vector2D.fromObject(src.eNEff);
                    }
                    if (src.wcEff !== undefined && src.wcEff !== null) {
                        dst.wcEff = ng.geometry.Vector2D.fromObject(src.wcEff);
                    }
                    if (src.wtEff !== undefined && src.wtEff !== null) {
                        dst.wtEff = ng.geometry.Vector2D.fromObject(src.wtEff);
                    }
                    return dst;
                }

                static toObject(src: EffectiveClassFour | null | undefined): EffectiveClassFour_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.EffectiveClassFour is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.EffectiveClassFour") {
                        console.error('Expected ng.result.steel.EffectiveClassFour but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EffectiveClassFour_json = {
                        aEff: AsJsonNum(src.aEff),
                    };
                    if(src.iEff !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.iEff);
                        if(parsed === null) return null;
                        dst.iEff = parsed;
                    }
                    if(src.eNEff !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.eNEff);
                        if(parsed === null) return null;
                        dst.eNEff = parsed;
                    }
                    if(src.wcEff !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.wcEff);
                        if(parsed === null) return null;
                        dst.wcEff = parsed;
                    }
                    if(src.wtEff !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.wtEff);
                        if(parsed === null) return null;
                        dst.wtEff = parsed;
                    }
                    return dst;
                }

                static create(src?: EffectiveClassFour_createType) {
                    const dst = new EffectiveClassFour();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.aEff !== undefined) {
                        dst.aEff = src.aEff;
                    }
                    if (src.iEff !== undefined) {
                        dst.iEff = src.iEff;
                    }
                    if (src.eNEff !== undefined) {
                        dst.eNEff = src.eNEff;
                    }
                    if (src.wcEff !== undefined) {
                        dst.wcEff = src.wcEff;
                    }
                    if (src.wtEff !== undefined) {
                        dst.wtEff = src.wtEff;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EffectiveClassFour();
                    dst.aEff = this.aEff;
                    dst.iEff = this.iEff;
                    dst.eNEff = this.eNEff;
                    dst.wcEff = this.wcEff;
                    dst.wtEff = this.wtEff;
                    return dst;
                }

                deepClone() {
                    const json = EffectiveClassFour.toObject(this);
                    const dst = EffectiveClassFour.fromObject(json);
                    return dst;
                }
            }
            export type IEffectiveClassFour = EffectiveClassFour;


            export type BucklingFactors_keys = 'chi' | 'phi' | 'alfa' | 'lambdaOver' | 'lcr' | 'ncr' | 'lambdaTheta';
            export interface BucklingFactors_createType {
                chi?: number,
                phi?: number,
                alfa?: number,
                lambdaOver?: number,
                lcr?: number,
                ncr?: number,
                lambdaTheta?: number,
            }
            export interface BucklingFactors_json {
                chi?: JsonNumber;
                phi?: JsonNumber;
                alfa?: JsonNumber;
                lambdaOver?: JsonNumber;
                lcr?: JsonNumber;
                ncr?: JsonNumber;
                lambdaTheta?: JsonNumber;
            }
            interface BucklingFactors_json_in {
                __proto_name?: unknown;
                chi?: unknown;
                phi?: unknown;
                alfa?: unknown;
                lambdaOver?: unknown;
                lcr?: unknown;
                ncr?: unknown;
                lambdaTheta?: unknown;
            }
            export class BucklingFactors {
                __proto_name = "ng.result.steel.BucklingFactors";
                chi: number = 0;
                phi: number = 0;
                alfa: number = 0;
                lambdaOver: number = 0;
                lcr: number = 0;
                ncr: number = 0;
                lambdaTheta: number = 0;

                static fromObject(src_unknown: unknown): BucklingFactors {
                    const dst = new BucklingFactors();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BucklingFactors but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BucklingFactors_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BucklingFactors but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.chi !== undefined && src.chi !== null) {
                        if (typeof src.chi === "number" || src.chi === 'NaN' || src.chi === 'Infinity' || src.chi === '-Infinity') {
                            dst.chi = AsNum(src.chi);
                        }
                        else {
                            console.log('Expected chi of BucklingFactors to be a number but was ', typeof src.chi, src.chi)
                        }
                    }
                    if (src.phi !== undefined && src.phi !== null) {
                        if (typeof src.phi === "number" || src.phi === 'NaN' || src.phi === 'Infinity' || src.phi === '-Infinity') {
                            dst.phi = AsNum(src.phi);
                        }
                        else {
                            console.log('Expected phi of BucklingFactors to be a number but was ', typeof src.phi, src.phi)
                        }
                    }
                    if (src.alfa !== undefined && src.alfa !== null) {
                        if (typeof src.alfa === "number" || src.alfa === 'NaN' || src.alfa === 'Infinity' || src.alfa === '-Infinity') {
                            dst.alfa = AsNum(src.alfa);
                        }
                        else {
                            console.log('Expected alfa of BucklingFactors to be a number but was ', typeof src.alfa, src.alfa)
                        }
                    }
                    if (src.lambdaOver !== undefined && src.lambdaOver !== null) {
                        if (typeof src.lambdaOver === "number" || src.lambdaOver === 'NaN' || src.lambdaOver === 'Infinity' || src.lambdaOver === '-Infinity') {
                            dst.lambdaOver = AsNum(src.lambdaOver);
                        }
                        else {
                            console.log('Expected lambdaOver of BucklingFactors to be a number but was ', typeof src.lambdaOver, src.lambdaOver)
                        }
                    }
                    if (src.lcr !== undefined && src.lcr !== null) {
                        if (typeof src.lcr === "number" || src.lcr === 'NaN' || src.lcr === 'Infinity' || src.lcr === '-Infinity') {
                            dst.lcr = AsNum(src.lcr);
                        }
                        else {
                            console.log('Expected lcr of BucklingFactors to be a number but was ', typeof src.lcr, src.lcr)
                        }
                    }
                    if (src.ncr !== undefined && src.ncr !== null) {
                        if (typeof src.ncr === "number" || src.ncr === 'NaN' || src.ncr === 'Infinity' || src.ncr === '-Infinity') {
                            dst.ncr = AsNum(src.ncr);
                        }
                        else {
                            console.log('Expected ncr of BucklingFactors to be a number but was ', typeof src.ncr, src.ncr)
                        }
                    }
                    if (src.lambdaTheta !== undefined && src.lambdaTheta !== null) {
                        if (typeof src.lambdaTheta === "number" || src.lambdaTheta === 'NaN' || src.lambdaTheta === 'Infinity' || src.lambdaTheta === '-Infinity') {
                            dst.lambdaTheta = AsNum(src.lambdaTheta);
                        }
                        else {
                            console.log('Expected lambdaTheta of BucklingFactors to be a number but was ', typeof src.lambdaTheta, src.lambdaTheta)
                        }
                    }
                    return dst;
                }

                static toObject(src: BucklingFactors | null | undefined): BucklingFactors_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.BucklingFactors is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.BucklingFactors") {
                        console.error('Expected ng.result.steel.BucklingFactors but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BucklingFactors_json = {
                        chi: AsJsonNum(src.chi),
                        phi: AsJsonNum(src.phi),
                        alfa: AsJsonNum(src.alfa),
                        lambdaOver: AsJsonNum(src.lambdaOver),
                        lcr: AsJsonNum(src.lcr),
                        ncr: AsJsonNum(src.ncr),
                        lambdaTheta: AsJsonNum(src.lambdaTheta),
                    };
                    return dst;
                }

                static create(src?: BucklingFactors_createType) {
                    const dst = new BucklingFactors();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.chi !== undefined) {
                        dst.chi = src.chi;
                    }
                    if (src.phi !== undefined) {
                        dst.phi = src.phi;
                    }
                    if (src.alfa !== undefined) {
                        dst.alfa = src.alfa;
                    }
                    if (src.lambdaOver !== undefined) {
                        dst.lambdaOver = src.lambdaOver;
                    }
                    if (src.lcr !== undefined) {
                        dst.lcr = src.lcr;
                    }
                    if (src.ncr !== undefined) {
                        dst.ncr = src.ncr;
                    }
                    if (src.lambdaTheta !== undefined) {
                        dst.lambdaTheta = src.lambdaTheta;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BucklingFactors();
                    dst.chi = this.chi;
                    dst.phi = this.phi;
                    dst.alfa = this.alfa;
                    dst.lambdaOver = this.lambdaOver;
                    dst.lcr = this.lcr;
                    dst.ncr = this.ncr;
                    dst.lambdaTheta = this.lambdaTheta;
                    return dst;
                }

                deepClone() {
                    const json = BucklingFactors.toObject(this);
                    const dst = BucklingFactors.fromObject(json);
                    return dst;
                }
            }
            export type IBucklingFactors = BucklingFactors;


            export type BucklingTorsionalFactors_keys = 'ncrT' | 'ncrTF';
            export interface BucklingTorsionalFactors_createType {
                ncrT?: number,
                ncrTF?: number,
            }
            export interface BucklingTorsionalFactors_json {
                ncrT?: JsonNumber;
                ncrTF?: JsonNumber;
            }
            interface BucklingTorsionalFactors_json_in {
                __proto_name?: unknown;
                ncrT?: unknown;
                ncrTF?: unknown;
            }
            export class BucklingTorsionalFactors {
                __proto_name = "ng.result.steel.BucklingTorsionalFactors";
                ncrT: number = 0;
                ncrTF: number = 0;

                static fromObject(src_unknown: unknown): BucklingTorsionalFactors {
                    const dst = new BucklingTorsionalFactors();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BucklingTorsionalFactors but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BucklingTorsionalFactors_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BucklingTorsionalFactors but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ncrT !== undefined && src.ncrT !== null) {
                        if (typeof src.ncrT === "number" || src.ncrT === 'NaN' || src.ncrT === 'Infinity' || src.ncrT === '-Infinity') {
                            dst.ncrT = AsNum(src.ncrT);
                        }
                        else {
                            console.log('Expected ncrT of BucklingTorsionalFactors to be a number but was ', typeof src.ncrT, src.ncrT)
                        }
                    }
                    if (src.ncrTF !== undefined && src.ncrTF !== null) {
                        if (typeof src.ncrTF === "number" || src.ncrTF === 'NaN' || src.ncrTF === 'Infinity' || src.ncrTF === '-Infinity') {
                            dst.ncrTF = AsNum(src.ncrTF);
                        }
                        else {
                            console.log('Expected ncrTF of BucklingTorsionalFactors to be a number but was ', typeof src.ncrTF, src.ncrTF)
                        }
                    }
                    return dst;
                }

                static toObject(src: BucklingTorsionalFactors | null | undefined): BucklingTorsionalFactors_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.BucklingTorsionalFactors is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.BucklingTorsionalFactors") {
                        console.error('Expected ng.result.steel.BucklingTorsionalFactors but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BucklingTorsionalFactors_json = {
                        ncrT: AsJsonNum(src.ncrT),
                        ncrTF: AsJsonNum(src.ncrTF),
                    };
                    return dst;
                }

                static create(src?: BucklingTorsionalFactors_createType) {
                    const dst = new BucklingTorsionalFactors();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ncrT !== undefined) {
                        dst.ncrT = src.ncrT;
                    }
                    if (src.ncrTF !== undefined) {
                        dst.ncrTF = src.ncrTF;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BucklingTorsionalFactors();
                    dst.ncrT = this.ncrT;
                    dst.ncrTF = this.ncrTF;
                    return dst;
                }

                deepClone() {
                    const json = BucklingTorsionalFactors.toObject(this);
                    const dst = BucklingTorsionalFactors.fromObject(json);
                    return dst;
                }
            }
            export type IBucklingTorsionalFactors = BucklingTorsionalFactors;


            export type LateralTorsionalIFactors_keys = 'chiLTMod' | 'kc' | 'factorf';
            export interface LateralTorsionalIFactors_createType {
                chiLTMod?: number,
                kc?: number,
                factorf?: number,
            }
            export interface LateralTorsionalIFactors_json {
                chiLTMod?: JsonNumber;
                kc?: JsonNumber;
                factorf?: JsonNumber;
            }
            interface LateralTorsionalIFactors_json_in {
                __proto_name?: unknown;
                chiLTMod?: unknown;
                kc?: unknown;
                factorf?: unknown;
            }
            export class LateralTorsionalIFactors {
                __proto_name = "ng.result.steel.LateralTorsionalIFactors";
                chiLTMod: number = 0;
                kc: number = 0;
                factorf: number = 0;

                static fromObject(src_unknown: unknown): LateralTorsionalIFactors {
                    const dst = new LateralTorsionalIFactors();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LateralTorsionalIFactors but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LateralTorsionalIFactors_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LateralTorsionalIFactors but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.chiLTMod !== undefined && src.chiLTMod !== null) {
                        if (typeof src.chiLTMod === "number" || src.chiLTMod === 'NaN' || src.chiLTMod === 'Infinity' || src.chiLTMod === '-Infinity') {
                            dst.chiLTMod = AsNum(src.chiLTMod);
                        }
                        else {
                            console.log('Expected chiLTMod of LateralTorsionalIFactors to be a number but was ', typeof src.chiLTMod, src.chiLTMod)
                        }
                    }
                    if (src.kc !== undefined && src.kc !== null) {
                        if (typeof src.kc === "number" || src.kc === 'NaN' || src.kc === 'Infinity' || src.kc === '-Infinity') {
                            dst.kc = AsNum(src.kc);
                        }
                        else {
                            console.log('Expected kc of LateralTorsionalIFactors to be a number but was ', typeof src.kc, src.kc)
                        }
                    }
                    if (src.factorf !== undefined && src.factorf !== null) {
                        if (typeof src.factorf === "number" || src.factorf === 'NaN' || src.factorf === 'Infinity' || src.factorf === '-Infinity') {
                            dst.factorf = AsNum(src.factorf);
                        }
                        else {
                            console.log('Expected factorf of LateralTorsionalIFactors to be a number but was ', typeof src.factorf, src.factorf)
                        }
                    }
                    return dst;
                }

                static toObject(src: LateralTorsionalIFactors | null | undefined): LateralTorsionalIFactors_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.LateralTorsionalIFactors is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.LateralTorsionalIFactors") {
                        console.error('Expected ng.result.steel.LateralTorsionalIFactors but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LateralTorsionalIFactors_json = {
                        chiLTMod: AsJsonNum(src.chiLTMod),
                        kc: AsJsonNum(src.kc),
                        factorf: AsJsonNum(src.factorf),
                    };
                    return dst;
                }

                static create(src?: LateralTorsionalIFactors_createType) {
                    const dst = new LateralTorsionalIFactors();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.chiLTMod !== undefined) {
                        dst.chiLTMod = src.chiLTMod;
                    }
                    if (src.kc !== undefined) {
                        dst.kc = src.kc;
                    }
                    if (src.factorf !== undefined) {
                        dst.factorf = src.factorf;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LateralTorsionalIFactors();
                    dst.chiLTMod = this.chiLTMod;
                    dst.kc = this.kc;
                    dst.factorf = this.factorf;
                    return dst;
                }

                deepClone() {
                    const json = LateralTorsionalIFactors.toObject(this);
                    const dst = LateralTorsionalIFactors.fromObject(json);
                    return dst;
                }
            }
            export type ILateralTorsionalIFactors = LateralTorsionalIFactors;


            export type LateralTorsionalSimplyfied_keys = 'kc' | 'ifz' | 'lambdaF' | 'mycrd';
            export interface LateralTorsionalSimplyfied_createType {
                kc?: number,
                ifz?: number,
                lambdaF?: number,
                mycrd?: number,
            }
            export interface LateralTorsionalSimplyfied_json {
                kc?: JsonNumber;
                ifz?: JsonNumber;
                lambdaF?: JsonNumber;
                mycrd?: JsonNumber;
            }
            interface LateralTorsionalSimplyfied_json_in {
                __proto_name?: unknown;
                kc?: unknown;
                ifz?: unknown;
                lambdaF?: unknown;
                mycrd?: unknown;
            }
            export class LateralTorsionalSimplyfied {
                __proto_name = "ng.result.steel.LateralTorsionalSimplyfied";
                kc: number = 0;
                ifz: number = 0;
                lambdaF: number = 0;
                mycrd: number = 0;

                static fromObject(src_unknown: unknown): LateralTorsionalSimplyfied {
                    const dst = new LateralTorsionalSimplyfied();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LateralTorsionalSimplyfied but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LateralTorsionalSimplyfied_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LateralTorsionalSimplyfied but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kc !== undefined && src.kc !== null) {
                        if (typeof src.kc === "number" || src.kc === 'NaN' || src.kc === 'Infinity' || src.kc === '-Infinity') {
                            dst.kc = AsNum(src.kc);
                        }
                        else {
                            console.log('Expected kc of LateralTorsionalSimplyfied to be a number but was ', typeof src.kc, src.kc)
                        }
                    }
                    if (src.ifz !== undefined && src.ifz !== null) {
                        if (typeof src.ifz === "number" || src.ifz === 'NaN' || src.ifz === 'Infinity' || src.ifz === '-Infinity') {
                            dst.ifz = AsNum(src.ifz);
                        }
                        else {
                            console.log('Expected ifz of LateralTorsionalSimplyfied to be a number but was ', typeof src.ifz, src.ifz)
                        }
                    }
                    if (src.lambdaF !== undefined && src.lambdaF !== null) {
                        if (typeof src.lambdaF === "number" || src.lambdaF === 'NaN' || src.lambdaF === 'Infinity' || src.lambdaF === '-Infinity') {
                            dst.lambdaF = AsNum(src.lambdaF);
                        }
                        else {
                            console.log('Expected lambdaF of LateralTorsionalSimplyfied to be a number but was ', typeof src.lambdaF, src.lambdaF)
                        }
                    }
                    if (src.mycrd !== undefined && src.mycrd !== null) {
                        if (typeof src.mycrd === "number" || src.mycrd === 'NaN' || src.mycrd === 'Infinity' || src.mycrd === '-Infinity') {
                            dst.mycrd = AsNum(src.mycrd);
                        }
                        else {
                            console.log('Expected mycrd of LateralTorsionalSimplyfied to be a number but was ', typeof src.mycrd, src.mycrd)
                        }
                    }
                    return dst;
                }

                static toObject(src: LateralTorsionalSimplyfied | null | undefined): LateralTorsionalSimplyfied_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.LateralTorsionalSimplyfied is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.LateralTorsionalSimplyfied") {
                        console.error('Expected ng.result.steel.LateralTorsionalSimplyfied but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LateralTorsionalSimplyfied_json = {
                        kc: AsJsonNum(src.kc),
                        ifz: AsJsonNum(src.ifz),
                        lambdaF: AsJsonNum(src.lambdaF),
                        mycrd: AsJsonNum(src.mycrd),
                    };
                    return dst;
                }

                static create(src?: LateralTorsionalSimplyfied_createType) {
                    const dst = new LateralTorsionalSimplyfied();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kc !== undefined) {
                        dst.kc = src.kc;
                    }
                    if (src.ifz !== undefined) {
                        dst.ifz = src.ifz;
                    }
                    if (src.lambdaF !== undefined) {
                        dst.lambdaF = src.lambdaF;
                    }
                    if (src.mycrd !== undefined) {
                        dst.mycrd = src.mycrd;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LateralTorsionalSimplyfied();
                    dst.kc = this.kc;
                    dst.ifz = this.ifz;
                    dst.lambdaF = this.lambdaF;
                    dst.mycrd = this.mycrd;
                    return dst;
                }

                deepClone() {
                    const json = LateralTorsionalSimplyfied.toObject(this);
                    const dst = LateralTorsionalSimplyfied.fromObject(json);
                    return dst;
                }
            }
            export type ILateralTorsionalSimplyfied = LateralTorsionalSimplyfied;


            export type Mcr_keys = 'psi' | 'psiF' | 'c1' | 'c2' | 'c3' | 'kz' | 'kw' | 'loadPos' | 'zg' | 'zj' | 'c2zgC3zj' | 'mcr';
            export interface Mcr_createType {
                psi?: number,
                psiF?: number,
                c1?: number,
                c2?: number,
                c3?: number,
                kz?: number,
                kw?: number,
                loadPos?: ng.beam.Alignment,
                zg?: number,
                zj?: number,
                c2zgC3zj?: number,
                mcr?: number,
            }
            export interface Mcr_json {
                psi?: JsonNumber;
                psiF?: JsonNumber;
                c1?: JsonNumber;
                c2?: JsonNumber;
                c3?: JsonNumber;
                kz?: JsonNumber;
                kw?: JsonNumber;
                loadPos?: string;
                zg?: JsonNumber;
                zj?: JsonNumber;
                c2zgC3zj?: JsonNumber;
                mcr?: JsonNumber;
            }
            interface Mcr_json_in {
                __proto_name?: unknown;
                psi?: unknown;
                psiF?: unknown;
                c1?: unknown;
                c2?: unknown;
                c3?: unknown;
                kz?: unknown;
                kw?: unknown;
                loadPos?: unknown;
                zg?: unknown;
                zj?: unknown;
                c2zgC3zj?: unknown;
                mcr?: unknown;
            }
            export class Mcr {
                __proto_name = "ng.result.steel.Mcr";
                psi: number = 0;
                psiF: number = 0;
                c1: number = 0;
                c2: number = 0;
                c3: number = 0;
                kz: number = 0;
                kw: number = 0;
                loadPos: ng.beam.Alignment = ng.beam.Alignment.ALIGNMENT_UNSPECIFIED;
                zg: number = 0;
                zj: number = 0;
                c2zgC3zj: number = 0;
                mcr: number = 0;

                static fromObject(src_unknown: unknown): Mcr {
                    const dst = new Mcr();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Mcr but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Mcr_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Mcr but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.psi !== undefined && src.psi !== null) {
                        if (typeof src.psi === "number" || src.psi === 'NaN' || src.psi === 'Infinity' || src.psi === '-Infinity') {
                            dst.psi = AsNum(src.psi);
                        }
                        else {
                            console.log('Expected psi of Mcr to be a number but was ', typeof src.psi, src.psi)
                        }
                    }
                    if (src.psiF !== undefined && src.psiF !== null) {
                        if (typeof src.psiF === "number" || src.psiF === 'NaN' || src.psiF === 'Infinity' || src.psiF === '-Infinity') {
                            dst.psiF = AsNum(src.psiF);
                        }
                        else {
                            console.log('Expected psiF of Mcr to be a number but was ', typeof src.psiF, src.psiF)
                        }
                    }
                    if (src.c1 !== undefined && src.c1 !== null) {
                        if (typeof src.c1 === "number" || src.c1 === 'NaN' || src.c1 === 'Infinity' || src.c1 === '-Infinity') {
                            dst.c1 = AsNum(src.c1);
                        }
                        else {
                            console.log('Expected c1 of Mcr to be a number but was ', typeof src.c1, src.c1)
                        }
                    }
                    if (src.c2 !== undefined && src.c2 !== null) {
                        if (typeof src.c2 === "number" || src.c2 === 'NaN' || src.c2 === 'Infinity' || src.c2 === '-Infinity') {
                            dst.c2 = AsNum(src.c2);
                        }
                        else {
                            console.log('Expected c2 of Mcr to be a number but was ', typeof src.c2, src.c2)
                        }
                    }
                    if (src.c3 !== undefined && src.c3 !== null) {
                        if (typeof src.c3 === "number" || src.c3 === 'NaN' || src.c3 === 'Infinity' || src.c3 === '-Infinity') {
                            dst.c3 = AsNum(src.c3);
                        }
                        else {
                            console.log('Expected c3 of Mcr to be a number but was ', typeof src.c3, src.c3)
                        }
                    }
                    if (src.kz !== undefined && src.kz !== null) {
                        if (typeof src.kz === "number" || src.kz === 'NaN' || src.kz === 'Infinity' || src.kz === '-Infinity') {
                            dst.kz = AsNum(src.kz);
                        }
                        else {
                            console.log('Expected kz of Mcr to be a number but was ', typeof src.kz, src.kz)
                        }
                    }
                    if (src.kw !== undefined && src.kw !== null) {
                        if (typeof src.kw === "number" || src.kw === 'NaN' || src.kw === 'Infinity' || src.kw === '-Infinity') {
                            dst.kw = AsNum(src.kw);
                        }
                        else {
                            console.log('Expected kw of Mcr to be a number but was ', typeof src.kw, src.kw)
                        }
                    }
                    if (src.loadPos !== undefined && src.loadPos !== null) {
                        dst.loadPos = ng.beam.Alignment_FromObject(src.loadPos);
                    }
                    if (src.zg !== undefined && src.zg !== null) {
                        if (typeof src.zg === "number" || src.zg === 'NaN' || src.zg === 'Infinity' || src.zg === '-Infinity') {
                            dst.zg = AsNum(src.zg);
                        }
                        else {
                            console.log('Expected zg of Mcr to be a number but was ', typeof src.zg, src.zg)
                        }
                    }
                    if (src.zj !== undefined && src.zj !== null) {
                        if (typeof src.zj === "number" || src.zj === 'NaN' || src.zj === 'Infinity' || src.zj === '-Infinity') {
                            dst.zj = AsNum(src.zj);
                        }
                        else {
                            console.log('Expected zj of Mcr to be a number but was ', typeof src.zj, src.zj)
                        }
                    }
                    if (src.c2zgC3zj !== undefined && src.c2zgC3zj !== null) {
                        if (typeof src.c2zgC3zj === "number" || src.c2zgC3zj === 'NaN' || src.c2zgC3zj === 'Infinity' || src.c2zgC3zj === '-Infinity') {
                            dst.c2zgC3zj = AsNum(src.c2zgC3zj);
                        }
                        else {
                            console.log('Expected c2zgC3zj of Mcr to be a number but was ', typeof src.c2zgC3zj, src.c2zgC3zj)
                        }
                    }
                    if (src.mcr !== undefined && src.mcr !== null) {
                        if (typeof src.mcr === "number" || src.mcr === 'NaN' || src.mcr === 'Infinity' || src.mcr === '-Infinity') {
                            dst.mcr = AsNum(src.mcr);
                        }
                        else {
                            console.log('Expected mcr of Mcr to be a number but was ', typeof src.mcr, src.mcr)
                        }
                    }
                    return dst;
                }

                static toObject(src: Mcr | null | undefined): Mcr_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Mcr is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Mcr") {
                        console.error('Expected ng.result.steel.Mcr but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const loadPos_obj = ng.beam.Alignment_ToObject(src.loadPos);
                    if(loadPos_obj === null) return null;

                    const dst : Mcr_json = {
                        psi: AsJsonNum(src.psi),
                        psiF: AsJsonNum(src.psiF),
                        c1: AsJsonNum(src.c1),
                        c2: AsJsonNum(src.c2),
                        c3: AsJsonNum(src.c3),
                        kz: AsJsonNum(src.kz),
                        kw: AsJsonNum(src.kw),
                        loadPos: loadPos_obj,
                        zg: AsJsonNum(src.zg),
                        zj: AsJsonNum(src.zj),
                        c2zgC3zj: AsJsonNum(src.c2zgC3zj),
                        mcr: AsJsonNum(src.mcr),
                    };
                    return dst;
                }

                static create(src?: Mcr_createType) {
                    const dst = new Mcr();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.psi !== undefined) {
                        dst.psi = src.psi;
                    }
                    if (src.psiF !== undefined) {
                        dst.psiF = src.psiF;
                    }
                    if (src.c1 !== undefined) {
                        dst.c1 = src.c1;
                    }
                    if (src.c2 !== undefined) {
                        dst.c2 = src.c2;
                    }
                    if (src.c3 !== undefined) {
                        dst.c3 = src.c3;
                    }
                    if (src.kz !== undefined) {
                        dst.kz = src.kz;
                    }
                    if (src.kw !== undefined) {
                        dst.kw = src.kw;
                    }
                    if (src.loadPos !== undefined) {
                        dst.loadPos = src.loadPos;
                    }
                    if (src.zg !== undefined) {
                        dst.zg = src.zg;
                    }
                    if (src.zj !== undefined) {
                        dst.zj = src.zj;
                    }
                    if (src.c2zgC3zj !== undefined) {
                        dst.c2zgC3zj = src.c2zgC3zj;
                    }
                    if (src.mcr !== undefined) {
                        dst.mcr = src.mcr;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Mcr();
                    dst.psi = this.psi;
                    dst.psiF = this.psiF;
                    dst.c1 = this.c1;
                    dst.c2 = this.c2;
                    dst.c3 = this.c3;
                    dst.kz = this.kz;
                    dst.kw = this.kw;
                    dst.loadPos = this.loadPos;
                    dst.zg = this.zg;
                    dst.zj = this.zj;
                    dst.c2zgC3zj = this.c2zgC3zj;
                    dst.mcr = this.mcr;
                    return dst;
                }

                deepClone() {
                    const json = Mcr.toObject(this);
                    const dst = Mcr.fromObject(json);
                    return dst;
                }
            }
            export type IMcr = Mcr;


            export type SectionGeometry_keys = 'hw' | 't' | 'aF' | 'tf' | 'bf' | 'c';
            export interface SectionGeometry_createType {
                hw?: number,
                t?: number,
                aF?: ng.geometry.Vector2D | null,
                tf?: number,
                bf?: number,
                c?: number,
            }
            export interface SectionGeometry_json {
                hw?: JsonNumber;
                t?: JsonNumber;
                aF?: ng.geometry.Vector2D_json;
                tf?: JsonNumber;
                bf?: JsonNumber;
                c?: JsonNumber;
            }
            interface SectionGeometry_json_in {
                __proto_name?: unknown;
                hw?: unknown;
                t?: unknown;
                aF?: unknown;
                tf?: unknown;
                bf?: unknown;
                c?: unknown;
            }
            export class SectionGeometry {
                __proto_name = "ng.result.steel.SectionGeometry";
                hw: number = 0;
                t: number = 0;
                aF: ng.geometry.Vector2D | null = null;
                tf: number = 0;
                bf: number = 0;
                c: number = 0;

                static fromObject(src_unknown: unknown): SectionGeometry {
                    const dst = new SectionGeometry();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionGeometry but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionGeometry_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionGeometry but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.hw !== undefined && src.hw !== null) {
                        if (typeof src.hw === "number" || src.hw === 'NaN' || src.hw === 'Infinity' || src.hw === '-Infinity') {
                            dst.hw = AsNum(src.hw);
                        }
                        else {
                            console.log('Expected hw of SectionGeometry to be a number but was ', typeof src.hw, src.hw)
                        }
                    }
                    if (src.t !== undefined && src.t !== null) {
                        if (typeof src.t === "number" || src.t === 'NaN' || src.t === 'Infinity' || src.t === '-Infinity') {
                            dst.t = AsNum(src.t);
                        }
                        else {
                            console.log('Expected t of SectionGeometry to be a number but was ', typeof src.t, src.t)
                        }
                    }
                    if (src.aF !== undefined && src.aF !== null) {
                        dst.aF = ng.geometry.Vector2D.fromObject(src.aF);
                    }
                    if (src.tf !== undefined && src.tf !== null) {
                        if (typeof src.tf === "number" || src.tf === 'NaN' || src.tf === 'Infinity' || src.tf === '-Infinity') {
                            dst.tf = AsNum(src.tf);
                        }
                        else {
                            console.log('Expected tf of SectionGeometry to be a number but was ', typeof src.tf, src.tf)
                        }
                    }
                    if (src.bf !== undefined && src.bf !== null) {
                        if (typeof src.bf === "number" || src.bf === 'NaN' || src.bf === 'Infinity' || src.bf === '-Infinity') {
                            dst.bf = AsNum(src.bf);
                        }
                        else {
                            console.log('Expected bf of SectionGeometry to be a number but was ', typeof src.bf, src.bf)
                        }
                    }
                    if (src.c !== undefined && src.c !== null) {
                        if (typeof src.c === "number" || src.c === 'NaN' || src.c === 'Infinity' || src.c === '-Infinity') {
                            dst.c = AsNum(src.c);
                        }
                        else {
                            console.log('Expected c of SectionGeometry to be a number but was ', typeof src.c, src.c)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionGeometry | null | undefined): SectionGeometry_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.SectionGeometry is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.SectionGeometry") {
                        console.error('Expected ng.result.steel.SectionGeometry but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionGeometry_json = {
                        hw: AsJsonNum(src.hw),
                        t: AsJsonNum(src.t),
                        tf: AsJsonNum(src.tf),
                        bf: AsJsonNum(src.bf),
                        c: AsJsonNum(src.c),
                    };
                    if(src.aF !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.aF);
                        if(parsed === null) return null;
                        dst.aF = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionGeometry_createType) {
                    const dst = new SectionGeometry();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.hw !== undefined) {
                        dst.hw = src.hw;
                    }
                    if (src.t !== undefined) {
                        dst.t = src.t;
                    }
                    if (src.aF !== undefined) {
                        dst.aF = src.aF;
                    }
                    if (src.tf !== undefined) {
                        dst.tf = src.tf;
                    }
                    if (src.bf !== undefined) {
                        dst.bf = src.bf;
                    }
                    if (src.c !== undefined) {
                        dst.c = src.c;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionGeometry();
                    dst.hw = this.hw;
                    dst.t = this.t;
                    dst.aF = this.aF;
                    dst.tf = this.tf;
                    dst.bf = this.bf;
                    dst.c = this.c;
                    return dst;
                }

                deepClone() {
                    const json = SectionGeometry.toObject(this);
                    const dst = SectionGeometry.fromObject(json);
                    return dst;
                }
            }
            export type ISectionGeometry = SectionGeometry;


            export type WebFactors_keys = 'kTau' | 'sigmaE' | 'lambdaW' | 'chi';
            export interface WebFactors_createType {
                kTau?: number,
                sigmaE?: number,
                lambdaW?: number,
                chi?: number,
            }
            export interface WebFactors_json {
                kTau?: JsonNumber;
                sigmaE?: JsonNumber;
                lambdaW?: JsonNumber;
                chi?: JsonNumber;
            }
            interface WebFactors_json_in {
                __proto_name?: unknown;
                kTau?: unknown;
                sigmaE?: unknown;
                lambdaW?: unknown;
                chi?: unknown;
            }
            export class WebFactors {
                __proto_name = "ng.result.steel.WebFactors";
                kTau: number = 0;
                sigmaE: number = 0;
                lambdaW: number = 0;
                chi: number = 0;

                static fromObject(src_unknown: unknown): WebFactors {
                    const dst = new WebFactors();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted WebFactors but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as WebFactors_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for WebFactors but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kTau !== undefined && src.kTau !== null) {
                        if (typeof src.kTau === "number" || src.kTau === 'NaN' || src.kTau === 'Infinity' || src.kTau === '-Infinity') {
                            dst.kTau = AsNum(src.kTau);
                        }
                        else {
                            console.log('Expected kTau of WebFactors to be a number but was ', typeof src.kTau, src.kTau)
                        }
                    }
                    if (src.sigmaE !== undefined && src.sigmaE !== null) {
                        if (typeof src.sigmaE === "number" || src.sigmaE === 'NaN' || src.sigmaE === 'Infinity' || src.sigmaE === '-Infinity') {
                            dst.sigmaE = AsNum(src.sigmaE);
                        }
                        else {
                            console.log('Expected sigmaE of WebFactors to be a number but was ', typeof src.sigmaE, src.sigmaE)
                        }
                    }
                    if (src.lambdaW !== undefined && src.lambdaW !== null) {
                        if (typeof src.lambdaW === "number" || src.lambdaW === 'NaN' || src.lambdaW === 'Infinity' || src.lambdaW === '-Infinity') {
                            dst.lambdaW = AsNum(src.lambdaW);
                        }
                        else {
                            console.log('Expected lambdaW of WebFactors to be a number but was ', typeof src.lambdaW, src.lambdaW)
                        }
                    }
                    if (src.chi !== undefined && src.chi !== null) {
                        if (typeof src.chi === "number" || src.chi === 'NaN' || src.chi === 'Infinity' || src.chi === '-Infinity') {
                            dst.chi = AsNum(src.chi);
                        }
                        else {
                            console.log('Expected chi of WebFactors to be a number but was ', typeof src.chi, src.chi)
                        }
                    }
                    return dst;
                }

                static toObject(src: WebFactors | null | undefined): WebFactors_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.WebFactors is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.WebFactors") {
                        console.error('Expected ng.result.steel.WebFactors but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : WebFactors_json = {
                        kTau: AsJsonNum(src.kTau),
                        sigmaE: AsJsonNum(src.sigmaE),
                        lambdaW: AsJsonNum(src.lambdaW),
                        chi: AsJsonNum(src.chi),
                    };
                    return dst;
                }

                static create(src?: WebFactors_createType) {
                    const dst = new WebFactors();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kTau !== undefined) {
                        dst.kTau = src.kTau;
                    }
                    if (src.sigmaE !== undefined) {
                        dst.sigmaE = src.sigmaE;
                    }
                    if (src.lambdaW !== undefined) {
                        dst.lambdaW = src.lambdaW;
                    }
                    if (src.chi !== undefined) {
                        dst.chi = src.chi;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new WebFactors();
                    dst.kTau = this.kTau;
                    dst.sigmaE = this.sigmaE;
                    dst.lambdaW = this.lambdaW;
                    dst.chi = this.chi;
                    return dst;
                }

                deepClone() {
                    const json = WebFactors.toObject(this);
                    const dst = WebFactors.fromObject(json);
                    return dst;
                }
            }
            export type IWebFactors = WebFactors;


            export type WebCapacities_keys = 'vBwRd' | 'vBwRdFi' | 'vBfRd' | 'vBRd' | 'mfRd' | 'mfk';
            export interface WebCapacities_createType {
                vBwRd?: number,
                vBwRdFi?: number,
                vBfRd?: number,
                vBRd?: number,
                mfRd?: number,
                mfk?: number,
            }
            export interface WebCapacities_json {
                vBwRd?: JsonNumber;
                vBwRdFi?: JsonNumber;
                vBfRd?: JsonNumber;
                vBRd?: JsonNumber;
                mfRd?: JsonNumber;
                mfk?: JsonNumber;
            }
            interface WebCapacities_json_in {
                __proto_name?: unknown;
                vBwRd?: unknown;
                vBwRdFi?: unknown;
                vBfRd?: unknown;
                vBRd?: unknown;
                mfRd?: unknown;
                mfk?: unknown;
            }
            export class WebCapacities {
                __proto_name = "ng.result.steel.WebCapacities";
                vBwRd: number = 0;
                vBwRdFi: number = 0;
                vBfRd: number = 0;
                vBRd: number = 0;
                mfRd: number = 0;
                mfk: number = 0;

                static fromObject(src_unknown: unknown): WebCapacities {
                    const dst = new WebCapacities();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted WebCapacities but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as WebCapacities_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for WebCapacities but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.vBwRd !== undefined && src.vBwRd !== null) {
                        if (typeof src.vBwRd === "number" || src.vBwRd === 'NaN' || src.vBwRd === 'Infinity' || src.vBwRd === '-Infinity') {
                            dst.vBwRd = AsNum(src.vBwRd);
                        }
                        else {
                            console.log('Expected vBwRd of WebCapacities to be a number but was ', typeof src.vBwRd, src.vBwRd)
                        }
                    }
                    if (src.vBwRdFi !== undefined && src.vBwRdFi !== null) {
                        if (typeof src.vBwRdFi === "number" || src.vBwRdFi === 'NaN' || src.vBwRdFi === 'Infinity' || src.vBwRdFi === '-Infinity') {
                            dst.vBwRdFi = AsNum(src.vBwRdFi);
                        }
                        else {
                            console.log('Expected vBwRdFi of WebCapacities to be a number but was ', typeof src.vBwRdFi, src.vBwRdFi)
                        }
                    }
                    if (src.vBfRd !== undefined && src.vBfRd !== null) {
                        if (typeof src.vBfRd === "number" || src.vBfRd === 'NaN' || src.vBfRd === 'Infinity' || src.vBfRd === '-Infinity') {
                            dst.vBfRd = AsNum(src.vBfRd);
                        }
                        else {
                            console.log('Expected vBfRd of WebCapacities to be a number but was ', typeof src.vBfRd, src.vBfRd)
                        }
                    }
                    if (src.vBRd !== undefined && src.vBRd !== null) {
                        if (typeof src.vBRd === "number" || src.vBRd === 'NaN' || src.vBRd === 'Infinity' || src.vBRd === '-Infinity') {
                            dst.vBRd = AsNum(src.vBRd);
                        }
                        else {
                            console.log('Expected vBRd of WebCapacities to be a number but was ', typeof src.vBRd, src.vBRd)
                        }
                    }
                    if (src.mfRd !== undefined && src.mfRd !== null) {
                        if (typeof src.mfRd === "number" || src.mfRd === 'NaN' || src.mfRd === 'Infinity' || src.mfRd === '-Infinity') {
                            dst.mfRd = AsNum(src.mfRd);
                        }
                        else {
                            console.log('Expected mfRd of WebCapacities to be a number but was ', typeof src.mfRd, src.mfRd)
                        }
                    }
                    if (src.mfk !== undefined && src.mfk !== null) {
                        if (typeof src.mfk === "number" || src.mfk === 'NaN' || src.mfk === 'Infinity' || src.mfk === '-Infinity') {
                            dst.mfk = AsNum(src.mfk);
                        }
                        else {
                            console.log('Expected mfk of WebCapacities to be a number but was ', typeof src.mfk, src.mfk)
                        }
                    }
                    return dst;
                }

                static toObject(src: WebCapacities | null | undefined): WebCapacities_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.WebCapacities is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.WebCapacities") {
                        console.error('Expected ng.result.steel.WebCapacities but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : WebCapacities_json = {
                        vBwRd: AsJsonNum(src.vBwRd),
                        vBwRdFi: AsJsonNum(src.vBwRdFi),
                        vBfRd: AsJsonNum(src.vBfRd),
                        vBRd: AsJsonNum(src.vBRd),
                        mfRd: AsJsonNum(src.mfRd),
                        mfk: AsJsonNum(src.mfk),
                    };
                    return dst;
                }

                static create(src?: WebCapacities_createType) {
                    const dst = new WebCapacities();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.vBwRd !== undefined) {
                        dst.vBwRd = src.vBwRd;
                    }
                    if (src.vBwRdFi !== undefined) {
                        dst.vBwRdFi = src.vBwRdFi;
                    }
                    if (src.vBfRd !== undefined) {
                        dst.vBfRd = src.vBfRd;
                    }
                    if (src.vBRd !== undefined) {
                        dst.vBRd = src.vBRd;
                    }
                    if (src.mfRd !== undefined) {
                        dst.mfRd = src.mfRd;
                    }
                    if (src.mfk !== undefined) {
                        dst.mfk = src.mfk;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new WebCapacities();
                    dst.vBwRd = this.vBwRd;
                    dst.vBwRdFi = this.vBwRdFi;
                    dst.vBfRd = this.vBfRd;
                    dst.vBRd = this.vBRd;
                    dst.mfRd = this.mfRd;
                    dst.mfk = this.mfk;
                    return dst;
                }

                deepClone() {
                    const json = WebCapacities.toObject(this);
                    const dst = WebCapacities.fromObject(json);
                    return dst;
                }
            }
            export type IWebCapacities = WebCapacities;


            export type Flexural_keys = 'bucklingFactors' | 'nbRd' | 'curve' | 'utilization';
            export interface Flexural_createType {
                bucklingFactors?: ng.result.steel.BucklingFactors | null,
                nbRd?: number,
                curve?: ng.result.steel.Curve,
                utilization?: number,
            }
            export interface Flexural_json {
                bucklingFactors?: ng.result.steel.BucklingFactors_json;
                nbRd?: JsonNumber;
                curve?: string;
                utilization?: JsonNumber;
            }
            interface Flexural_json_in {
                __proto_name?: unknown;
                bucklingFactors?: unknown;
                nbRd?: unknown;
                curve?: unknown;
                utilization?: unknown;
            }
            export class Flexural {
                __proto_name = "ng.result.steel.Flexural";
                bucklingFactors: ng.result.steel.BucklingFactors | null = null;
                nbRd: number = 0;
                curve: ng.result.steel.Curve = ng.result.steel.Curve.CURVE_UNSPECIFIED;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): Flexural {
                    const dst = new Flexural();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Flexural but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Flexural_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Flexural but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.bucklingFactors !== undefined && src.bucklingFactors !== null) {
                        dst.bucklingFactors = ng.result.steel.BucklingFactors.fromObject(src.bucklingFactors);
                    }
                    if (src.nbRd !== undefined && src.nbRd !== null) {
                        if (typeof src.nbRd === "number" || src.nbRd === 'NaN' || src.nbRd === 'Infinity' || src.nbRd === '-Infinity') {
                            dst.nbRd = AsNum(src.nbRd);
                        }
                        else {
                            console.log('Expected nbRd of Flexural to be a number but was ', typeof src.nbRd, src.nbRd)
                        }
                    }
                    if (src.curve !== undefined && src.curve !== null) {
                        dst.curve = ng.result.steel.Curve_FromObject(src.curve);
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Flexural to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: Flexural | null | undefined): Flexural_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Flexural is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Flexural") {
                        console.error('Expected ng.result.steel.Flexural but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const curve_obj = ng.result.steel.Curve_ToObject(src.curve);
                    if(curve_obj === null) return null;

                    const dst : Flexural_json = {
                        nbRd: AsJsonNum(src.nbRd),
                        curve: curve_obj,
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.bucklingFactors !== null)
                    {
                        const parsed = ng.result.steel.BucklingFactors.toObject(src.bucklingFactors);
                        if(parsed === null) return null;
                        dst.bucklingFactors = parsed;
                    }
                    return dst;
                }

                static create(src?: Flexural_createType) {
                    const dst = new Flexural();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.bucklingFactors !== undefined) {
                        dst.bucklingFactors = src.bucklingFactors;
                    }
                    if (src.nbRd !== undefined) {
                        dst.nbRd = src.nbRd;
                    }
                    if (src.curve !== undefined) {
                        dst.curve = src.curve;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Flexural();
                    dst.bucklingFactors = this.bucklingFactors;
                    dst.nbRd = this.nbRd;
                    dst.curve = this.curve;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = Flexural.toObject(this);
                    const dst = Flexural.fromObject(json);
                    return dst;
                }
            }
            export type IFlexural = Flexural;


            export type FlexuralTorsional_keys = 'bucklingFactors' | 'nbRdT' | 'bucklingTorsionalFactors' | 'curve' | 'utilization';
            export interface FlexuralTorsional_createType {
                bucklingFactors?: ng.result.steel.BucklingFactors | null,
                nbRdT?: number,
                bucklingTorsionalFactors?: ng.result.steel.BucklingTorsionalFactors | null,
                curve?: ng.result.steel.Curve,
                utilization?: number,
            }
            export interface FlexuralTorsional_json {
                bucklingFactors?: ng.result.steel.BucklingFactors_json;
                nbRdT?: JsonNumber;
                bucklingTorsionalFactors?: ng.result.steel.BucklingTorsionalFactors_json;
                curve?: string;
                utilization?: JsonNumber;
            }
            interface FlexuralTorsional_json_in {
                __proto_name?: unknown;
                bucklingFactors?: unknown;
                nbRdT?: unknown;
                bucklingTorsionalFactors?: unknown;
                curve?: unknown;
                utilization?: unknown;
            }
            export class FlexuralTorsional {
                __proto_name = "ng.result.steel.FlexuralTorsional";
                bucklingFactors: ng.result.steel.BucklingFactors | null = null;
                nbRdT: number = 0;
                bucklingTorsionalFactors: ng.result.steel.BucklingTorsionalFactors | null = null;
                curve: ng.result.steel.Curve = ng.result.steel.Curve.CURVE_UNSPECIFIED;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): FlexuralTorsional {
                    const dst = new FlexuralTorsional();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FlexuralTorsional but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FlexuralTorsional_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FlexuralTorsional but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.bucklingFactors !== undefined && src.bucklingFactors !== null) {
                        dst.bucklingFactors = ng.result.steel.BucklingFactors.fromObject(src.bucklingFactors);
                    }
                    if (src.nbRdT !== undefined && src.nbRdT !== null) {
                        if (typeof src.nbRdT === "number" || src.nbRdT === 'NaN' || src.nbRdT === 'Infinity' || src.nbRdT === '-Infinity') {
                            dst.nbRdT = AsNum(src.nbRdT);
                        }
                        else {
                            console.log('Expected nbRdT of FlexuralTorsional to be a number but was ', typeof src.nbRdT, src.nbRdT)
                        }
                    }
                    if (src.bucklingTorsionalFactors !== undefined && src.bucklingTorsionalFactors !== null) {
                        dst.bucklingTorsionalFactors = ng.result.steel.BucklingTorsionalFactors.fromObject(src.bucklingTorsionalFactors);
                    }
                    if (src.curve !== undefined && src.curve !== null) {
                        dst.curve = ng.result.steel.Curve_FromObject(src.curve);
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of FlexuralTorsional to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: FlexuralTorsional | null | undefined): FlexuralTorsional_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.FlexuralTorsional is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.FlexuralTorsional") {
                        console.error('Expected ng.result.steel.FlexuralTorsional but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const curve_obj = ng.result.steel.Curve_ToObject(src.curve);
                    if(curve_obj === null) return null;

                    const dst : FlexuralTorsional_json = {
                        nbRdT: AsJsonNum(src.nbRdT),
                        curve: curve_obj,
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.bucklingFactors !== null)
                    {
                        const parsed = ng.result.steel.BucklingFactors.toObject(src.bucklingFactors);
                        if(parsed === null) return null;
                        dst.bucklingFactors = parsed;
                    }
                    if(src.bucklingTorsionalFactors !== null)
                    {
                        const parsed = ng.result.steel.BucklingTorsionalFactors.toObject(src.bucklingTorsionalFactors);
                        if(parsed === null) return null;
                        dst.bucklingTorsionalFactors = parsed;
                    }
                    return dst;
                }

                static create(src?: FlexuralTorsional_createType) {
                    const dst = new FlexuralTorsional();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.bucklingFactors !== undefined) {
                        dst.bucklingFactors = src.bucklingFactors;
                    }
                    if (src.nbRdT !== undefined) {
                        dst.nbRdT = src.nbRdT;
                    }
                    if (src.bucklingTorsionalFactors !== undefined) {
                        dst.bucklingTorsionalFactors = src.bucklingTorsionalFactors;
                    }
                    if (src.curve !== undefined) {
                        dst.curve = src.curve;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FlexuralTorsional();
                    dst.bucklingFactors = this.bucklingFactors;
                    dst.nbRdT = this.nbRdT;
                    dst.bucklingTorsionalFactors = this.bucklingTorsionalFactors;
                    dst.curve = this.curve;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = FlexuralTorsional.toObject(this);
                    const dst = FlexuralTorsional.fromObject(json);
                    return dst;
                }
            }
            export type IFlexuralTorsional = FlexuralTorsional;


            export type LateralTorsional_keys = 'lateralTorsionalMethod' | 'bucklingFactors' | 'mbRd' | 'mcr' | 'lateralTorsionalIFactors' | 'lateralTorsionalSimFactors' | 'curveLT' | 'utilization';
            export interface LateralTorsional_createType {
                lateralTorsionalMethod?: ng.design.steel.LateralTorsionalMethod,
                bucklingFactors?: ng.result.steel.BucklingFactors | null,
                mbRd?: number,
                mcr?: ng.result.steel.Mcr | null,
                lateralTorsionalIFactors?: ng.result.steel.LateralTorsionalIFactors | null,
                lateralTorsionalSimFactors?: ng.result.steel.LateralTorsionalSimplyfied | null,
                curveLT?: ng.result.steel.CurveLT,
                utilization?: number,
            }
            export interface LateralTorsional_json {
                lateralTorsionalMethod?: string;
                bucklingFactors?: ng.result.steel.BucklingFactors_json;
                mbRd?: JsonNumber;
                mcr?: ng.result.steel.Mcr_json;
                lateralTorsionalIFactors?: ng.result.steel.LateralTorsionalIFactors_json;
                lateralTorsionalSimFactors?: ng.result.steel.LateralTorsionalSimplyfied_json;
                curveLT?: string;
                utilization?: JsonNumber;
            }
            interface LateralTorsional_json_in {
                __proto_name?: unknown;
                lateralTorsionalMethod?: unknown;
                bucklingFactors?: unknown;
                mbRd?: unknown;
                mcr?: unknown;
                lateralTorsionalIFactors?: unknown;
                lateralTorsionalSimFactors?: unknown;
                curveLT?: unknown;
                utilization?: unknown;
            }
            export class LateralTorsional {
                __proto_name = "ng.result.steel.LateralTorsional";
                lateralTorsionalMethod: ng.design.steel.LateralTorsionalMethod = ng.design.steel.LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_UNSPECIFIED;
                bucklingFactors: ng.result.steel.BucklingFactors | null = null;
                mbRd: number = 0;
                mcr: ng.result.steel.Mcr | null = null;
                lateralTorsionalIFactors: ng.result.steel.LateralTorsionalIFactors | null = null;
                lateralTorsionalSimFactors: ng.result.steel.LateralTorsionalSimplyfied | null = null;
                curveLT: ng.result.steel.CurveLT = ng.result.steel.CurveLT.CURVE_LT_UNSPECIFIED;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): LateralTorsional {
                    const dst = new LateralTorsional();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LateralTorsional but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LateralTorsional_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LateralTorsional but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.lateralTorsionalMethod !== undefined && src.lateralTorsionalMethod !== null) {
                        dst.lateralTorsionalMethod = ng.design.steel.LateralTorsionalMethod_FromObject(src.lateralTorsionalMethod);
                    }
                    if (src.bucklingFactors !== undefined && src.bucklingFactors !== null) {
                        dst.bucklingFactors = ng.result.steel.BucklingFactors.fromObject(src.bucklingFactors);
                    }
                    if (src.mbRd !== undefined && src.mbRd !== null) {
                        if (typeof src.mbRd === "number" || src.mbRd === 'NaN' || src.mbRd === 'Infinity' || src.mbRd === '-Infinity') {
                            dst.mbRd = AsNum(src.mbRd);
                        }
                        else {
                            console.log('Expected mbRd of LateralTorsional to be a number but was ', typeof src.mbRd, src.mbRd)
                        }
                    }
                    if (src.mcr !== undefined && src.mcr !== null) {
                        dst.mcr = ng.result.steel.Mcr.fromObject(src.mcr);
                    }
                    if (src.lateralTorsionalIFactors !== undefined && src.lateralTorsionalIFactors !== null) {
                        dst.lateralTorsionalIFactors = ng.result.steel.LateralTorsionalIFactors.fromObject(src.lateralTorsionalIFactors);
                    }
                    if (src.lateralTorsionalSimFactors !== undefined && src.lateralTorsionalSimFactors !== null) {
                        dst.lateralTorsionalSimFactors = ng.result.steel.LateralTorsionalSimplyfied.fromObject(src.lateralTorsionalSimFactors);
                    }
                    if (src.curveLT !== undefined && src.curveLT !== null) {
                        dst.curveLT = ng.result.steel.CurveLT_FromObject(src.curveLT);
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of LateralTorsional to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: LateralTorsional | null | undefined): LateralTorsional_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.LateralTorsional is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.LateralTorsional") {
                        console.error('Expected ng.result.steel.LateralTorsional but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const lateralTorsionalMethod_obj = ng.design.steel.LateralTorsionalMethod_ToObject(src.lateralTorsionalMethod);
                    if(lateralTorsionalMethod_obj === null) return null;

                    const curveLT_obj = ng.result.steel.CurveLT_ToObject(src.curveLT);
                    if(curveLT_obj === null) return null;

                    const dst : LateralTorsional_json = {
                        lateralTorsionalMethod: lateralTorsionalMethod_obj,
                        mbRd: AsJsonNum(src.mbRd),
                        curveLT: curveLT_obj,
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.bucklingFactors !== null)
                    {
                        const parsed = ng.result.steel.BucklingFactors.toObject(src.bucklingFactors);
                        if(parsed === null) return null;
                        dst.bucklingFactors = parsed;
                    }
                    if(src.mcr !== null)
                    {
                        const parsed = ng.result.steel.Mcr.toObject(src.mcr);
                        if(parsed === null) return null;
                        dst.mcr = parsed;
                    }
                    if(src.lateralTorsionalIFactors !== null)
                    {
                        const parsed = ng.result.steel.LateralTorsionalIFactors.toObject(src.lateralTorsionalIFactors);
                        if(parsed === null) return null;
                        dst.lateralTorsionalIFactors = parsed;
                    }
                    if(src.lateralTorsionalSimFactors !== null)
                    {
                        const parsed = ng.result.steel.LateralTorsionalSimplyfied.toObject(src.lateralTorsionalSimFactors);
                        if(parsed === null) return null;
                        dst.lateralTorsionalSimFactors = parsed;
                    }
                    return dst;
                }

                static create(src?: LateralTorsional_createType) {
                    const dst = new LateralTorsional();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.lateralTorsionalMethod !== undefined) {
                        dst.lateralTorsionalMethod = src.lateralTorsionalMethod;
                    }
                    if (src.bucklingFactors !== undefined) {
                        dst.bucklingFactors = src.bucklingFactors;
                    }
                    if (src.mbRd !== undefined) {
                        dst.mbRd = src.mbRd;
                    }
                    if (src.mcr !== undefined) {
                        dst.mcr = src.mcr;
                    }
                    if (src.lateralTorsionalIFactors !== undefined) {
                        dst.lateralTorsionalIFactors = src.lateralTorsionalIFactors;
                    }
                    if (src.lateralTorsionalSimFactors !== undefined) {
                        dst.lateralTorsionalSimFactors = src.lateralTorsionalSimFactors;
                    }
                    if (src.curveLT !== undefined) {
                        dst.curveLT = src.curveLT;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LateralTorsional();
                    dst.lateralTorsionalMethod = this.lateralTorsionalMethod;
                    dst.bucklingFactors = this.bucklingFactors;
                    dst.mbRd = this.mbRd;
                    dst.mcr = this.mcr;
                    dst.lateralTorsionalIFactors = this.lateralTorsionalIFactors;
                    dst.lateralTorsionalSimFactors = this.lateralTorsionalSimFactors;
                    dst.curveLT = this.curveLT;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = LateralTorsional.toObject(this);
                    const dst = LateralTorsional.fromObject(json);
                    return dst;
                }
            }
            export type ILateralTorsional = LateralTorsional;


            export type Web_keys = 'capacity' | 'factors' | 'geometry' | 'relevant' | 'a' | 'utilization';
            export interface Web_createType {
                capacity?: ng.result.steel.WebCapacities | null,
                factors?: ng.result.steel.WebFactors | null,
                geometry?: ng.result.steel.SectionGeometry | null,
                relevant?: ng.result.steel.StBarWebRelevant,
                a?: number,
                utilization?: number,
            }
            export interface Web_json {
                capacity?: ng.result.steel.WebCapacities_json;
                factors?: ng.result.steel.WebFactors_json;
                geometry?: ng.result.steel.SectionGeometry_json;
                relevant?: string;
                a?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface Web_json_in {
                __proto_name?: unknown;
                capacity?: unknown;
                factors?: unknown;
                geometry?: unknown;
                relevant?: unknown;
                a?: unknown;
                utilization?: unknown;
            }
            export class Web {
                __proto_name = "ng.result.steel.Web";
                capacity: ng.result.steel.WebCapacities | null = null;
                factors: ng.result.steel.WebFactors | null = null;
                geometry: ng.result.steel.SectionGeometry | null = null;
                relevant: ng.result.steel.StBarWebRelevant = ng.result.steel.StBarWebRelevant.ST_BAR_WEB_RELEVANT_UNSPECIFIED;
                a: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): Web {
                    const dst = new Web();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Web but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Web_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Web but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.capacity !== undefined && src.capacity !== null) {
                        dst.capacity = ng.result.steel.WebCapacities.fromObject(src.capacity);
                    }
                    if (src.factors !== undefined && src.factors !== null) {
                        dst.factors = ng.result.steel.WebFactors.fromObject(src.factors);
                    }
                    if (src.geometry !== undefined && src.geometry !== null) {
                        dst.geometry = ng.result.steel.SectionGeometry.fromObject(src.geometry);
                    }
                    if (src.relevant !== undefined && src.relevant !== null) {
                        dst.relevant = ng.result.steel.StBarWebRelevant_FromObject(src.relevant);
                    }
                    if (src.a !== undefined && src.a !== null) {
                        if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                            dst.a = AsNum(src.a);
                        }
                        else {
                            console.log('Expected a of Web to be a number but was ', typeof src.a, src.a)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Web to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: Web | null | undefined): Web_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Web is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Web") {
                        console.error('Expected ng.result.steel.Web but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const relevant_obj = ng.result.steel.StBarWebRelevant_ToObject(src.relevant);
                    if(relevant_obj === null) return null;

                    const dst : Web_json = {
                        relevant: relevant_obj,
                        a: AsJsonNum(src.a),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.capacity !== null)
                    {
                        const parsed = ng.result.steel.WebCapacities.toObject(src.capacity);
                        if(parsed === null) return null;
                        dst.capacity = parsed;
                    }
                    if(src.factors !== null)
                    {
                        const parsed = ng.result.steel.WebFactors.toObject(src.factors);
                        if(parsed === null) return null;
                        dst.factors = parsed;
                    }
                    if(src.geometry !== null)
                    {
                        const parsed = ng.result.steel.SectionGeometry.toObject(src.geometry);
                        if(parsed === null) return null;
                        dst.geometry = parsed;
                    }
                    return dst;
                }

                static create(src?: Web_createType) {
                    const dst = new Web();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.capacity !== undefined) {
                        dst.capacity = src.capacity;
                    }
                    if (src.factors !== undefined) {
                        dst.factors = src.factors;
                    }
                    if (src.geometry !== undefined) {
                        dst.geometry = src.geometry;
                    }
                    if (src.relevant !== undefined) {
                        dst.relevant = src.relevant;
                    }
                    if (src.a !== undefined) {
                        dst.a = src.a;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Web();
                    dst.capacity = this.capacity;
                    dst.factors = this.factors;
                    dst.geometry = this.geometry;
                    dst.relevant = this.relevant;
                    dst.a = this.a;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = Web.toObject(this);
                    const dst = Web.fromObject(json);
                    return dst;
                }
            }
            export type IWeb = Web;


            export type ShearResistance_keys = 'vPlTRd' | 'vPlTRdFi' | 'vPlRd' | 'vPlRdFi' | 'aV' | 'rho' | 'utilization';
            export interface ShearResistance_createType {
                vPlTRd?: number,
                vPlTRdFi?: number,
                vPlRd?: number,
                vPlRdFi?: number,
                aV?: number,
                rho?: number,
                utilization?: number,
            }
            export interface ShearResistance_json {
                vPlTRd?: JsonNumber;
                vPlTRdFi?: JsonNumber;
                vPlRd?: JsonNumber;
                vPlRdFi?: JsonNumber;
                aV?: JsonNumber;
                rho?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface ShearResistance_json_in {
                __proto_name?: unknown;
                vPlTRd?: unknown;
                vPlTRdFi?: unknown;
                vPlRd?: unknown;
                vPlRdFi?: unknown;
                aV?: unknown;
                rho?: unknown;
                utilization?: unknown;
            }
            export class ShearResistance {
                __proto_name = "ng.result.steel.ShearResistance";
                vPlTRd: number = 0;
                vPlTRdFi: number = 0;
                vPlRd: number = 0;
                vPlRdFi: number = 0;
                aV: number = 0;
                rho: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): ShearResistance {
                    const dst = new ShearResistance();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ShearResistance but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ShearResistance_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ShearResistance but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.vPlTRd !== undefined && src.vPlTRd !== null) {
                        if (typeof src.vPlTRd === "number" || src.vPlTRd === 'NaN' || src.vPlTRd === 'Infinity' || src.vPlTRd === '-Infinity') {
                            dst.vPlTRd = AsNum(src.vPlTRd);
                        }
                        else {
                            console.log('Expected vPlTRd of ShearResistance to be a number but was ', typeof src.vPlTRd, src.vPlTRd)
                        }
                    }
                    if (src.vPlTRdFi !== undefined && src.vPlTRdFi !== null) {
                        if (typeof src.vPlTRdFi === "number" || src.vPlTRdFi === 'NaN' || src.vPlTRdFi === 'Infinity' || src.vPlTRdFi === '-Infinity') {
                            dst.vPlTRdFi = AsNum(src.vPlTRdFi);
                        }
                        else {
                            console.log('Expected vPlTRdFi of ShearResistance to be a number but was ', typeof src.vPlTRdFi, src.vPlTRdFi)
                        }
                    }
                    if (src.vPlRd !== undefined && src.vPlRd !== null) {
                        if (typeof src.vPlRd === "number" || src.vPlRd === 'NaN' || src.vPlRd === 'Infinity' || src.vPlRd === '-Infinity') {
                            dst.vPlRd = AsNum(src.vPlRd);
                        }
                        else {
                            console.log('Expected vPlRd of ShearResistance to be a number but was ', typeof src.vPlRd, src.vPlRd)
                        }
                    }
                    if (src.vPlRdFi !== undefined && src.vPlRdFi !== null) {
                        if (typeof src.vPlRdFi === "number" || src.vPlRdFi === 'NaN' || src.vPlRdFi === 'Infinity' || src.vPlRdFi === '-Infinity') {
                            dst.vPlRdFi = AsNum(src.vPlRdFi);
                        }
                        else {
                            console.log('Expected vPlRdFi of ShearResistance to be a number but was ', typeof src.vPlRdFi, src.vPlRdFi)
                        }
                    }
                    if (src.aV !== undefined && src.aV !== null) {
                        if (typeof src.aV === "number" || src.aV === 'NaN' || src.aV === 'Infinity' || src.aV === '-Infinity') {
                            dst.aV = AsNum(src.aV);
                        }
                        else {
                            console.log('Expected aV of ShearResistance to be a number but was ', typeof src.aV, src.aV)
                        }
                    }
                    if (src.rho !== undefined && src.rho !== null) {
                        if (typeof src.rho === "number" || src.rho === 'NaN' || src.rho === 'Infinity' || src.rho === '-Infinity') {
                            dst.rho = AsNum(src.rho);
                        }
                        else {
                            console.log('Expected rho of ShearResistance to be a number but was ', typeof src.rho, src.rho)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of ShearResistance to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: ShearResistance | null | undefined): ShearResistance_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.ShearResistance is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.ShearResistance") {
                        console.error('Expected ng.result.steel.ShearResistance but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ShearResistance_json = {
                        vPlTRd: AsJsonNum(src.vPlTRd),
                        vPlTRdFi: AsJsonNum(src.vPlTRdFi),
                        vPlRd: AsJsonNum(src.vPlRd),
                        vPlRdFi: AsJsonNum(src.vPlRdFi),
                        aV: AsJsonNum(src.aV),
                        rho: AsJsonNum(src.rho),
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: ShearResistance_createType) {
                    const dst = new ShearResistance();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.vPlTRd !== undefined) {
                        dst.vPlTRd = src.vPlTRd;
                    }
                    if (src.vPlTRdFi !== undefined) {
                        dst.vPlTRdFi = src.vPlTRdFi;
                    }
                    if (src.vPlRd !== undefined) {
                        dst.vPlRd = src.vPlRd;
                    }
                    if (src.vPlRdFi !== undefined) {
                        dst.vPlRdFi = src.vPlRdFi;
                    }
                    if (src.aV !== undefined) {
                        dst.aV = src.aV;
                    }
                    if (src.rho !== undefined) {
                        dst.rho = src.rho;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ShearResistance();
                    dst.vPlTRd = this.vPlTRd;
                    dst.vPlTRdFi = this.vPlTRdFi;
                    dst.vPlRd = this.vPlRd;
                    dst.vPlRdFi = this.vPlRdFi;
                    dst.aV = this.aV;
                    dst.rho = this.rho;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = ShearResistance.toObject(this);
                    const dst = ShearResistance.fromObject(json);
                    return dst;
                }
            }
            export type IShearResistance = ShearResistance;


            export type TorsionalResistance_keys = 'tRd' | 'tRdFi' | 'tauTEd' | 'utilization';
            export interface TorsionalResistance_createType {
                tRd?: number,
                tRdFi?: number,
                tauTEd?: number,
                utilization?: number,
            }
            export interface TorsionalResistance_json {
                tRd?: JsonNumber;
                tRdFi?: JsonNumber;
                tauTEd?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface TorsionalResistance_json_in {
                __proto_name?: unknown;
                tRd?: unknown;
                tRdFi?: unknown;
                tauTEd?: unknown;
                utilization?: unknown;
            }
            export class TorsionalResistance {
                __proto_name = "ng.result.steel.TorsionalResistance";
                tRd: number = 0;
                tRdFi: number = 0;
                tauTEd: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): TorsionalResistance {
                    const dst = new TorsionalResistance();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TorsionalResistance but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TorsionalResistance_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TorsionalResistance but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.tRd !== undefined && src.tRd !== null) {
                        if (typeof src.tRd === "number" || src.tRd === 'NaN' || src.tRd === 'Infinity' || src.tRd === '-Infinity') {
                            dst.tRd = AsNum(src.tRd);
                        }
                        else {
                            console.log('Expected tRd of TorsionalResistance to be a number but was ', typeof src.tRd, src.tRd)
                        }
                    }
                    if (src.tRdFi !== undefined && src.tRdFi !== null) {
                        if (typeof src.tRdFi === "number" || src.tRdFi === 'NaN' || src.tRdFi === 'Infinity' || src.tRdFi === '-Infinity') {
                            dst.tRdFi = AsNum(src.tRdFi);
                        }
                        else {
                            console.log('Expected tRdFi of TorsionalResistance to be a number but was ', typeof src.tRdFi, src.tRdFi)
                        }
                    }
                    if (src.tauTEd !== undefined && src.tauTEd !== null) {
                        if (typeof src.tauTEd === "number" || src.tauTEd === 'NaN' || src.tauTEd === 'Infinity' || src.tauTEd === '-Infinity') {
                            dst.tauTEd = AsNum(src.tauTEd);
                        }
                        else {
                            console.log('Expected tauTEd of TorsionalResistance to be a number but was ', typeof src.tauTEd, src.tauTEd)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of TorsionalResistance to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: TorsionalResistance | null | undefined): TorsionalResistance_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.TorsionalResistance is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.TorsionalResistance") {
                        console.error('Expected ng.result.steel.TorsionalResistance but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : TorsionalResistance_json = {
                        tRd: AsJsonNum(src.tRd),
                        tRdFi: AsJsonNum(src.tRdFi),
                        tauTEd: AsJsonNum(src.tauTEd),
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: TorsionalResistance_createType) {
                    const dst = new TorsionalResistance();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.tRd !== undefined) {
                        dst.tRd = src.tRd;
                    }
                    if (src.tRdFi !== undefined) {
                        dst.tRdFi = src.tRdFi;
                    }
                    if (src.tauTEd !== undefined) {
                        dst.tauTEd = src.tauTEd;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TorsionalResistance();
                    dst.tRd = this.tRd;
                    dst.tRdFi = this.tRdFi;
                    dst.tauTEd = this.tauTEd;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = TorsionalResistance.toObject(this);
                    const dst = TorsionalResistance.fromObject(json);
                    return dst;
                }
            }
            export type ITorsionalResistance = TorsionalResistance;


            export type ShearStress_keys = 'tauEd' | 'tauRd' | 'tauRdFi' | 'utilization';
            export interface ShearStress_createType {
                tauEd?: number,
                tauRd?: number,
                tauRdFi?: number,
                utilization?: number,
            }
            export interface ShearStress_json {
                tauEd?: JsonNumber;
                tauRd?: JsonNumber;
                tauRdFi?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface ShearStress_json_in {
                __proto_name?: unknown;
                tauEd?: unknown;
                tauRd?: unknown;
                tauRdFi?: unknown;
                utilization?: unknown;
            }
            export class ShearStress {
                __proto_name = "ng.result.steel.ShearStress";
                tauEd: number = 0;
                tauRd: number = 0;
                tauRdFi: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): ShearStress {
                    const dst = new ShearStress();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ShearStress but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ShearStress_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ShearStress but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.tauEd !== undefined && src.tauEd !== null) {
                        if (typeof src.tauEd === "number" || src.tauEd === 'NaN' || src.tauEd === 'Infinity' || src.tauEd === '-Infinity') {
                            dst.tauEd = AsNum(src.tauEd);
                        }
                        else {
                            console.log('Expected tauEd of ShearStress to be a number but was ', typeof src.tauEd, src.tauEd)
                        }
                    }
                    if (src.tauRd !== undefined && src.tauRd !== null) {
                        if (typeof src.tauRd === "number" || src.tauRd === 'NaN' || src.tauRd === 'Infinity' || src.tauRd === '-Infinity') {
                            dst.tauRd = AsNum(src.tauRd);
                        }
                        else {
                            console.log('Expected tauRd of ShearStress to be a number but was ', typeof src.tauRd, src.tauRd)
                        }
                    }
                    if (src.tauRdFi !== undefined && src.tauRdFi !== null) {
                        if (typeof src.tauRdFi === "number" || src.tauRdFi === 'NaN' || src.tauRdFi === 'Infinity' || src.tauRdFi === '-Infinity') {
                            dst.tauRdFi = AsNum(src.tauRdFi);
                        }
                        else {
                            console.log('Expected tauRdFi of ShearStress to be a number but was ', typeof src.tauRdFi, src.tauRdFi)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of ShearStress to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: ShearStress | null | undefined): ShearStress_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.ShearStress is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.ShearStress") {
                        console.error('Expected ng.result.steel.ShearStress but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ShearStress_json = {
                        tauEd: AsJsonNum(src.tauEd),
                        tauRd: AsJsonNum(src.tauRd),
                        tauRdFi: AsJsonNum(src.tauRdFi),
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: ShearStress_createType) {
                    const dst = new ShearStress();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.tauEd !== undefined) {
                        dst.tauEd = src.tauEd;
                    }
                    if (src.tauRd !== undefined) {
                        dst.tauRd = src.tauRd;
                    }
                    if (src.tauRdFi !== undefined) {
                        dst.tauRdFi = src.tauRdFi;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ShearStress();
                    dst.tauEd = this.tauEd;
                    dst.tauRd = this.tauRd;
                    dst.tauRdFi = this.tauRdFi;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = ShearStress.toObject(this);
                    const dst = ShearStress.fromObject(json);
                    return dst;
                }
            }
            export type IShearStress = ShearStress;


            export type NormalStress_keys = 'sigmaEd' | 'utilization';
            export interface NormalStress_createType {
                sigmaEd?: number,
                utilization?: number,
            }
            export interface NormalStress_json {
                sigmaEd?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface NormalStress_json_in {
                __proto_name?: unknown;
                sigmaEd?: unknown;
                utilization?: unknown;
            }
            export class NormalStress {
                __proto_name = "ng.result.steel.NormalStress";
                sigmaEd: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): NormalStress {
                    const dst = new NormalStress();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted NormalStress but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as NormalStress_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for NormalStress but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sigmaEd !== undefined && src.sigmaEd !== null) {
                        if (typeof src.sigmaEd === "number" || src.sigmaEd === 'NaN' || src.sigmaEd === 'Infinity' || src.sigmaEd === '-Infinity') {
                            dst.sigmaEd = AsNum(src.sigmaEd);
                        }
                        else {
                            console.log('Expected sigmaEd of NormalStress to be a number but was ', typeof src.sigmaEd, src.sigmaEd)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of NormalStress to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: NormalStress | null | undefined): NormalStress_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.NormalStress is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.NormalStress") {
                        console.error('Expected ng.result.steel.NormalStress but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : NormalStress_json = {
                        sigmaEd: AsJsonNum(src.sigmaEd),
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: NormalStress_createType) {
                    const dst = new NormalStress();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sigmaEd !== undefined) {
                        dst.sigmaEd = src.sigmaEd;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new NormalStress();
                    dst.sigmaEd = this.sigmaEd;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = NormalStress.toObject(this);
                    const dst = NormalStress.fromObject(json);
                    return dst;
                }
            }
            export type INormalStress = NormalStress;


            export type PureNormalResistance_keys = 'nPlVRd' | 'utilization';
            export interface PureNormalResistance_createType {
                nPlVRd?: number,
                utilization?: number,
            }
            export interface PureNormalResistance_json {
                nPlVRd?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface PureNormalResistance_json_in {
                __proto_name?: unknown;
                nPlVRd?: unknown;
                utilization?: unknown;
            }
            export class PureNormalResistance {
                __proto_name = "ng.result.steel.PureNormalResistance";
                nPlVRd: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): PureNormalResistance {
                    const dst = new PureNormalResistance();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PureNormalResistance but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PureNormalResistance_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PureNormalResistance but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.nPlVRd !== undefined && src.nPlVRd !== null) {
                        if (typeof src.nPlVRd === "number" || src.nPlVRd === 'NaN' || src.nPlVRd === 'Infinity' || src.nPlVRd === '-Infinity') {
                            dst.nPlVRd = AsNum(src.nPlVRd);
                        }
                        else {
                            console.log('Expected nPlVRd of PureNormalResistance to be a number but was ', typeof src.nPlVRd, src.nPlVRd)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of PureNormalResistance to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: PureNormalResistance | null | undefined): PureNormalResistance_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.PureNormalResistance is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.PureNormalResistance") {
                        console.error('Expected ng.result.steel.PureNormalResistance but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PureNormalResistance_json = {
                        nPlVRd: AsJsonNum(src.nPlVRd),
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: PureNormalResistance_createType) {
                    const dst = new PureNormalResistance();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.nPlVRd !== undefined) {
                        dst.nPlVRd = src.nPlVRd;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PureNormalResistance();
                    dst.nPlVRd = this.nPlVRd;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = PureNormalResistance.toObject(this);
                    const dst = PureNormalResistance.fromObject(json);
                    return dst;
                }
            }
            export type IPureNormalResistance = PureNormalResistance;


            export type NormalCapacity_keys = 'with641' | 'nplVRd' | 'nwplVRd' | 'n' | 'nEdLim' | 'mnVRd' | 'alfa' | 'beta' | 'mNRdReduced' | 'utilization';
            export interface NormalCapacity_createType {
                with641?: boolean,
                nplVRd?: number,
                nwplVRd?: number,
                n?: number,
                nEdLim?: ng.geometry.Vector2D | null,
                mnVRd?: ng.geometry.Vector2D | null,
                alfa?: number,
                beta?: number,
                mNRdReduced?: ng.result.steel.Boolean2D | null,
                utilization?: number,
            }
            export interface NormalCapacity_json {
                with641?: boolean;
                nplVRd?: JsonNumber;
                nwplVRd?: JsonNumber;
                n?: JsonNumber;
                nEdLim?: ng.geometry.Vector2D_json;
                mnVRd?: ng.geometry.Vector2D_json;
                alfa?: JsonNumber;
                beta?: JsonNumber;
                mNRdReduced?: ng.result.steel.Boolean2D_json;
                utilization?: JsonNumber;
            }
            interface NormalCapacity_json_in {
                __proto_name?: unknown;
                with641?: unknown;
                nplVRd?: unknown;
                nwplVRd?: unknown;
                n?: unknown;
                nEdLim?: unknown;
                mnVRd?: unknown;
                alfa?: unknown;
                beta?: unknown;
                mNRdReduced?: unknown;
                utilization?: unknown;
            }
            export class NormalCapacity {
                __proto_name = "ng.result.steel.NormalCapacity";
                with641: boolean = false;
                nplVRd: number = 0;
                nwplVRd: number = 0;
                n: number = 0;
                nEdLim: ng.geometry.Vector2D | null = null;
                mnVRd: ng.geometry.Vector2D | null = null;
                alfa: number = 0;
                beta: number = 0;
                mNRdReduced: ng.result.steel.Boolean2D | null = null;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): NormalCapacity {
                    const dst = new NormalCapacity();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted NormalCapacity but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as NormalCapacity_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for NormalCapacity but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.with641 !== undefined && src.with641 !== null) {
                        if (typeof src.with641 === "boolean") {
                            dst.with641 = src.with641;
                        }
                        else {
                            console.log('Expected with641 of NormalCapacity to be a boolean but was ', typeof src.with641, src.with641)
                        }
                    }
                    if (src.nplVRd !== undefined && src.nplVRd !== null) {
                        if (typeof src.nplVRd === "number" || src.nplVRd === 'NaN' || src.nplVRd === 'Infinity' || src.nplVRd === '-Infinity') {
                            dst.nplVRd = AsNum(src.nplVRd);
                        }
                        else {
                            console.log('Expected nplVRd of NormalCapacity to be a number but was ', typeof src.nplVRd, src.nplVRd)
                        }
                    }
                    if (src.nwplVRd !== undefined && src.nwplVRd !== null) {
                        if (typeof src.nwplVRd === "number" || src.nwplVRd === 'NaN' || src.nwplVRd === 'Infinity' || src.nwplVRd === '-Infinity') {
                            dst.nwplVRd = AsNum(src.nwplVRd);
                        }
                        else {
                            console.log('Expected nwplVRd of NormalCapacity to be a number but was ', typeof src.nwplVRd, src.nwplVRd)
                        }
                    }
                    if (src.n !== undefined && src.n !== null) {
                        if (typeof src.n === "number" || src.n === 'NaN' || src.n === 'Infinity' || src.n === '-Infinity') {
                            dst.n = AsNum(src.n);
                        }
                        else {
                            console.log('Expected n of NormalCapacity to be a number but was ', typeof src.n, src.n)
                        }
                    }
                    if (src.nEdLim !== undefined && src.nEdLim !== null) {
                        dst.nEdLim = ng.geometry.Vector2D.fromObject(src.nEdLim);
                    }
                    if (src.mnVRd !== undefined && src.mnVRd !== null) {
                        dst.mnVRd = ng.geometry.Vector2D.fromObject(src.mnVRd);
                    }
                    if (src.alfa !== undefined && src.alfa !== null) {
                        if (typeof src.alfa === "number" || src.alfa === 'NaN' || src.alfa === 'Infinity' || src.alfa === '-Infinity') {
                            dst.alfa = AsNum(src.alfa);
                        }
                        else {
                            console.log('Expected alfa of NormalCapacity to be a number but was ', typeof src.alfa, src.alfa)
                        }
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                            dst.beta = AsNum(src.beta);
                        }
                        else {
                            console.log('Expected beta of NormalCapacity to be a number but was ', typeof src.beta, src.beta)
                        }
                    }
                    if (src.mNRdReduced !== undefined && src.mNRdReduced !== null) {
                        dst.mNRdReduced = ng.result.steel.Boolean2D.fromObject(src.mNRdReduced);
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of NormalCapacity to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: NormalCapacity | null | undefined): NormalCapacity_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.NormalCapacity is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.NormalCapacity") {
                        console.error('Expected ng.result.steel.NormalCapacity but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : NormalCapacity_json = {
                        with641: src.with641,
                        nplVRd: AsJsonNum(src.nplVRd),
                        nwplVRd: AsJsonNum(src.nwplVRd),
                        n: AsJsonNum(src.n),
                        alfa: AsJsonNum(src.alfa),
                        beta: AsJsonNum(src.beta),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.nEdLim !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.nEdLim);
                        if(parsed === null) return null;
                        dst.nEdLim = parsed;
                    }
                    if(src.mnVRd !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.mnVRd);
                        if(parsed === null) return null;
                        dst.mnVRd = parsed;
                    }
                    if(src.mNRdReduced !== null)
                    {
                        const parsed = ng.result.steel.Boolean2D.toObject(src.mNRdReduced);
                        if(parsed === null) return null;
                        dst.mNRdReduced = parsed;
                    }
                    return dst;
                }

                static create(src?: NormalCapacity_createType) {
                    const dst = new NormalCapacity();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.with641 !== undefined) {
                        dst.with641 = src.with641;
                    }
                    if (src.nplVRd !== undefined) {
                        dst.nplVRd = src.nplVRd;
                    }
                    if (src.nwplVRd !== undefined) {
                        dst.nwplVRd = src.nwplVRd;
                    }
                    if (src.n !== undefined) {
                        dst.n = src.n;
                    }
                    if (src.nEdLim !== undefined) {
                        dst.nEdLim = src.nEdLim;
                    }
                    if (src.mnVRd !== undefined) {
                        dst.mnVRd = src.mnVRd;
                    }
                    if (src.alfa !== undefined) {
                        dst.alfa = src.alfa;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    if (src.mNRdReduced !== undefined) {
                        dst.mNRdReduced = src.mNRdReduced;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new NormalCapacity();
                    dst.with641 = this.with641;
                    dst.nplVRd = this.nplVRd;
                    dst.nwplVRd = this.nwplVRd;
                    dst.n = this.n;
                    dst.nEdLim = this.nEdLim;
                    dst.mnVRd = this.mnVRd;
                    dst.alfa = this.alfa;
                    dst.beta = this.beta;
                    dst.mNRdReduced = this.mNRdReduced;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = NormalCapacity.toObject(this);
                    const dst = NormalCapacity.fromObject(json);
                    return dst;
                }
            }
            export type INormalCapacity = NormalCapacity;


            export type Force_keys = 'ned' | 'nedComp' | 'ted' | 'm1Ed' | 'm2Ed' | 'v1Ed' | 'v2Ed';
            export interface Force_createType {
                ned?: number,
                nedComp?: number,
                ted?: number,
                m1Ed?: number,
                m2Ed?: number,
                v1Ed?: number,
                v2Ed?: number,
            }
            export interface Force_json {
                ned?: JsonNumber;
                nedComp?: JsonNumber;
                ted?: JsonNumber;
                m1Ed?: JsonNumber;
                m2Ed?: JsonNumber;
                v1Ed?: JsonNumber;
                v2Ed?: JsonNumber;
            }
            interface Force_json_in {
                __proto_name?: unknown;
                ned?: unknown;
                nedComp?: unknown;
                ted?: unknown;
                m1Ed?: unknown;
                m2Ed?: unknown;
                v1Ed?: unknown;
                v2Ed?: unknown;
            }
            export class Force {
                __proto_name = "ng.result.steel.Force";
                ned: number = 0;
                nedComp: number = 0;
                ted: number = 0;
                m1Ed: number = 0;
                m2Ed: number = 0;
                v1Ed: number = 0;
                v2Ed: number = 0;

                static fromObject(src_unknown: unknown): Force {
                    const dst = new Force();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Force but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Force_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Force but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ned !== undefined && src.ned !== null) {
                        if (typeof src.ned === "number" || src.ned === 'NaN' || src.ned === 'Infinity' || src.ned === '-Infinity') {
                            dst.ned = AsNum(src.ned);
                        }
                        else {
                            console.log('Expected ned of Force to be a number but was ', typeof src.ned, src.ned)
                        }
                    }
                    if (src.nedComp !== undefined && src.nedComp !== null) {
                        if (typeof src.nedComp === "number" || src.nedComp === 'NaN' || src.nedComp === 'Infinity' || src.nedComp === '-Infinity') {
                            dst.nedComp = AsNum(src.nedComp);
                        }
                        else {
                            console.log('Expected nedComp of Force to be a number but was ', typeof src.nedComp, src.nedComp)
                        }
                    }
                    if (src.ted !== undefined && src.ted !== null) {
                        if (typeof src.ted === "number" || src.ted === 'NaN' || src.ted === 'Infinity' || src.ted === '-Infinity') {
                            dst.ted = AsNum(src.ted);
                        }
                        else {
                            console.log('Expected ted of Force to be a number but was ', typeof src.ted, src.ted)
                        }
                    }
                    if (src.m1Ed !== undefined && src.m1Ed !== null) {
                        if (typeof src.m1Ed === "number" || src.m1Ed === 'NaN' || src.m1Ed === 'Infinity' || src.m1Ed === '-Infinity') {
                            dst.m1Ed = AsNum(src.m1Ed);
                        }
                        else {
                            console.log('Expected m1Ed of Force to be a number but was ', typeof src.m1Ed, src.m1Ed)
                        }
                    }
                    if (src.m2Ed !== undefined && src.m2Ed !== null) {
                        if (typeof src.m2Ed === "number" || src.m2Ed === 'NaN' || src.m2Ed === 'Infinity' || src.m2Ed === '-Infinity') {
                            dst.m2Ed = AsNum(src.m2Ed);
                        }
                        else {
                            console.log('Expected m2Ed of Force to be a number but was ', typeof src.m2Ed, src.m2Ed)
                        }
                    }
                    if (src.v1Ed !== undefined && src.v1Ed !== null) {
                        if (typeof src.v1Ed === "number" || src.v1Ed === 'NaN' || src.v1Ed === 'Infinity' || src.v1Ed === '-Infinity') {
                            dst.v1Ed = AsNum(src.v1Ed);
                        }
                        else {
                            console.log('Expected v1Ed of Force to be a number but was ', typeof src.v1Ed, src.v1Ed)
                        }
                    }
                    if (src.v2Ed !== undefined && src.v2Ed !== null) {
                        if (typeof src.v2Ed === "number" || src.v2Ed === 'NaN' || src.v2Ed === 'Infinity' || src.v2Ed === '-Infinity') {
                            dst.v2Ed = AsNum(src.v2Ed);
                        }
                        else {
                            console.log('Expected v2Ed of Force to be a number but was ', typeof src.v2Ed, src.v2Ed)
                        }
                    }
                    return dst;
                }

                static toObject(src: Force | null | undefined): Force_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Force is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Force") {
                        console.error('Expected ng.result.steel.Force but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Force_json = {
                        ned: AsJsonNum(src.ned),
                        nedComp: AsJsonNum(src.nedComp),
                        ted: AsJsonNum(src.ted),
                        m1Ed: AsJsonNum(src.m1Ed),
                        m2Ed: AsJsonNum(src.m2Ed),
                        v1Ed: AsJsonNum(src.v1Ed),
                        v2Ed: AsJsonNum(src.v2Ed),
                    };
                    return dst;
                }

                static create(src?: Force_createType) {
                    const dst = new Force();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ned !== undefined) {
                        dst.ned = src.ned;
                    }
                    if (src.nedComp !== undefined) {
                        dst.nedComp = src.nedComp;
                    }
                    if (src.ted !== undefined) {
                        dst.ted = src.ted;
                    }
                    if (src.m1Ed !== undefined) {
                        dst.m1Ed = src.m1Ed;
                    }
                    if (src.m2Ed !== undefined) {
                        dst.m2Ed = src.m2Ed;
                    }
                    if (src.v1Ed !== undefined) {
                        dst.v1Ed = src.v1Ed;
                    }
                    if (src.v2Ed !== undefined) {
                        dst.v2Ed = src.v2Ed;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Force();
                    dst.ned = this.ned;
                    dst.nedComp = this.nedComp;
                    dst.ted = this.ted;
                    dst.m1Ed = this.m1Ed;
                    dst.m2Ed = this.m2Ed;
                    dst.v1Ed = this.v1Ed;
                    dst.v2Ed = this.v2Ed;
                    return dst;
                }

                deepClone() {
                    const json = Force.toObject(this);
                    const dst = Force.fromObject(json);
                    return dst;
                }
            }
            export type IForce = Force;


            export type Interaction_keys = 'deltaX' | 'deltaMEd' | 'cm' | 'alfam' | 'psim' | 'cy' | 'cz' | 'k' | 'mRk' | 'utilization' | 'betaM' | 'kFire';
            export interface Interaction_createType {
                deltaX?: ng.geometry.Vector2D | null,
                deltaMEd?: ng.geometry.Vector2D | null,
                cm?: ng.geometry.VectorYZLT | null,
                alfam?: ng.geometry.VectorYZLT | null,
                psim?: ng.geometry.VectorYZLT | null,
                cy?: ng.geometry.VectorYZ | null,
                cz?: ng.geometry.VectorYZ | null,
                k?: ng.geometry.Vector2D | null,
                mRk?: ng.geometry.Vector2D | null,
                utilization?: number,
                betaM?: ng.geometry.VectorYZLT | null,
                kFire?: ng.geometry.VectorYZLT | null,
            }
            export interface Interaction_json {
                deltaX?: ng.geometry.Vector2D_json;
                deltaMEd?: ng.geometry.Vector2D_json;
                cm?: ng.geometry.VectorYZLT_json;
                alfam?: ng.geometry.VectorYZLT_json;
                psim?: ng.geometry.VectorYZLT_json;
                cy?: ng.geometry.VectorYZ_json;
                cz?: ng.geometry.VectorYZ_json;
                k?: ng.geometry.Vector2D_json;
                mRk?: ng.geometry.Vector2D_json;
                utilization?: JsonNumber;
                betaM?: ng.geometry.VectorYZLT_json;
                kFire?: ng.geometry.VectorYZLT_json;
            }
            interface Interaction_json_in {
                __proto_name?: unknown;
                deltaX?: unknown;
                deltaMEd?: unknown;
                cm?: unknown;
                alfam?: unknown;
                psim?: unknown;
                cy?: unknown;
                cz?: unknown;
                k?: unknown;
                mRk?: unknown;
                utilization?: unknown;
                betaM?: unknown;
                kFire?: unknown;
            }
            export class Interaction {
                __proto_name = "ng.result.steel.Interaction";
                deltaX: ng.geometry.Vector2D | null = null;
                deltaMEd: ng.geometry.Vector2D | null = null;
                cm: ng.geometry.VectorYZLT | null = null;
                alfam: ng.geometry.VectorYZLT | null = null;
                psim: ng.geometry.VectorYZLT | null = null;
                cy: ng.geometry.VectorYZ | null = null;
                cz: ng.geometry.VectorYZ | null = null;
                k: ng.geometry.Vector2D | null = null;
                mRk: ng.geometry.Vector2D | null = null;
                utilization: number = 0;
                betaM: ng.geometry.VectorYZLT | null = null;
                kFire: ng.geometry.VectorYZLT | null = null;

                static fromObject(src_unknown: unknown): Interaction {
                    const dst = new Interaction();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Interaction but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Interaction_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Interaction but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.deltaX !== undefined && src.deltaX !== null) {
                        dst.deltaX = ng.geometry.Vector2D.fromObject(src.deltaX);
                    }
                    if (src.deltaMEd !== undefined && src.deltaMEd !== null) {
                        dst.deltaMEd = ng.geometry.Vector2D.fromObject(src.deltaMEd);
                    }
                    if (src.cm !== undefined && src.cm !== null) {
                        dst.cm = ng.geometry.VectorYZLT.fromObject(src.cm);
                    }
                    if (src.alfam !== undefined && src.alfam !== null) {
                        dst.alfam = ng.geometry.VectorYZLT.fromObject(src.alfam);
                    }
                    if (src.psim !== undefined && src.psim !== null) {
                        dst.psim = ng.geometry.VectorYZLT.fromObject(src.psim);
                    }
                    if (src.cy !== undefined && src.cy !== null) {
                        dst.cy = ng.geometry.VectorYZ.fromObject(src.cy);
                    }
                    if (src.cz !== undefined && src.cz !== null) {
                        dst.cz = ng.geometry.VectorYZ.fromObject(src.cz);
                    }
                    if (src.k !== undefined && src.k !== null) {
                        dst.k = ng.geometry.Vector2D.fromObject(src.k);
                    }
                    if (src.mRk !== undefined && src.mRk !== null) {
                        dst.mRk = ng.geometry.Vector2D.fromObject(src.mRk);
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Interaction to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.betaM !== undefined && src.betaM !== null) {
                        dst.betaM = ng.geometry.VectorYZLT.fromObject(src.betaM);
                    }
                    if (src.kFire !== undefined && src.kFire !== null) {
                        dst.kFire = ng.geometry.VectorYZLT.fromObject(src.kFire);
                    }
                    return dst;
                }

                static toObject(src: Interaction | null | undefined): Interaction_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Interaction is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Interaction") {
                        console.error('Expected ng.result.steel.Interaction but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Interaction_json = {
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.deltaX !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.deltaX);
                        if(parsed === null) return null;
                        dst.deltaX = parsed;
                    }
                    if(src.deltaMEd !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.deltaMEd);
                        if(parsed === null) return null;
                        dst.deltaMEd = parsed;
                    }
                    if(src.cm !== null)
                    {
                        const parsed = ng.geometry.VectorYZLT.toObject(src.cm);
                        if(parsed === null) return null;
                        dst.cm = parsed;
                    }
                    if(src.alfam !== null)
                    {
                        const parsed = ng.geometry.VectorYZLT.toObject(src.alfam);
                        if(parsed === null) return null;
                        dst.alfam = parsed;
                    }
                    if(src.psim !== null)
                    {
                        const parsed = ng.geometry.VectorYZLT.toObject(src.psim);
                        if(parsed === null) return null;
                        dst.psim = parsed;
                    }
                    if(src.cy !== null)
                    {
                        const parsed = ng.geometry.VectorYZ.toObject(src.cy);
                        if(parsed === null) return null;
                        dst.cy = parsed;
                    }
                    if(src.cz !== null)
                    {
                        const parsed = ng.geometry.VectorYZ.toObject(src.cz);
                        if(parsed === null) return null;
                        dst.cz = parsed;
                    }
                    if(src.k !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.k);
                        if(parsed === null) return null;
                        dst.k = parsed;
                    }
                    if(src.mRk !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.mRk);
                        if(parsed === null) return null;
                        dst.mRk = parsed;
                    }
                    if(src.betaM !== null)
                    {
                        const parsed = ng.geometry.VectorYZLT.toObject(src.betaM);
                        if(parsed === null) return null;
                        dst.betaM = parsed;
                    }
                    if(src.kFire !== null)
                    {
                        const parsed = ng.geometry.VectorYZLT.toObject(src.kFire);
                        if(parsed === null) return null;
                        dst.kFire = parsed;
                    }
                    return dst;
                }

                static create(src?: Interaction_createType) {
                    const dst = new Interaction();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.deltaX !== undefined) {
                        dst.deltaX = src.deltaX;
                    }
                    if (src.deltaMEd !== undefined) {
                        dst.deltaMEd = src.deltaMEd;
                    }
                    if (src.cm !== undefined) {
                        dst.cm = src.cm;
                    }
                    if (src.alfam !== undefined) {
                        dst.alfam = src.alfam;
                    }
                    if (src.psim !== undefined) {
                        dst.psim = src.psim;
                    }
                    if (src.cy !== undefined) {
                        dst.cy = src.cy;
                    }
                    if (src.cz !== undefined) {
                        dst.cz = src.cz;
                    }
                    if (src.k !== undefined) {
                        dst.k = src.k;
                    }
                    if (src.mRk !== undefined) {
                        dst.mRk = src.mRk;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.betaM !== undefined) {
                        dst.betaM = src.betaM;
                    }
                    if (src.kFire !== undefined) {
                        dst.kFire = src.kFire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Interaction();
                    dst.deltaX = this.deltaX;
                    dst.deltaMEd = this.deltaMEd;
                    dst.cm = this.cm;
                    dst.alfam = this.alfam;
                    dst.psim = this.psim;
                    dst.cy = this.cy;
                    dst.cz = this.cz;
                    dst.k = this.k;
                    dst.mRk = this.mRk;
                    dst.utilization = this.utilization;
                    dst.betaM = this.betaM;
                    dst.kFire = this.kFire;
                    return dst;
                }

                deepClone() {
                    const json = Interaction.toObject(this);
                    const dst = Interaction.fromObject(json);
                    return dst;
                }
            }
            export type IInteraction = Interaction;


            export type Interaction2nd_keys = 'utilization';
            export interface Interaction2nd_createType {
                utilization?: number,
            }
            export interface Interaction2nd_json {
                utilization?: JsonNumber;
            }
            interface Interaction2nd_json_in {
                __proto_name?: unknown;
                utilization?: unknown;
            }
            export class Interaction2nd {
                __proto_name = "ng.result.steel.Interaction2nd";
                utilization: number = 0;

                static fromObject(src_unknown: unknown): Interaction2nd {
                    const dst = new Interaction2nd();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Interaction2nd but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Interaction2nd_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Interaction2nd but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Interaction2nd to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: Interaction2nd | null | undefined): Interaction2nd_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Interaction2nd is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Interaction2nd") {
                        console.error('Expected ng.result.steel.Interaction2nd but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Interaction2nd_json = {
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: Interaction2nd_createType) {
                    const dst = new Interaction2nd();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Interaction2nd();
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = Interaction2nd.toObject(this);
                    const dst = Interaction2nd.fromObject(json);
                    return dst;
                }
            }
            export type IInteraction2nd = Interaction2nd;


            export type SectionResult_keys = 'effectiveClassFour' | 'shear1' | 'shear2' | 'torsional' | 'shearStress' | 'normalStress' | 'pureNormalResistance' | 'normal' | 'flexural1' | 'flexural2' | 'flexuralTorsional' | 'lateralTorsionalTop' | 'lateralTorsionalBottom' | 'interaction1' | 'interaction2' | 'interaction2nd' | 'web' | 'controlData';
            export interface SectionResult_createType {
                effectiveClassFour?: ng.result.steel.EffectiveClassFour | null,
                shear1?: ng.result.steel.ShearResistance | null,
                shear2?: ng.result.steel.ShearResistance | null,
                torsional?: ng.result.steel.TorsionalResistance | null,
                shearStress?: ng.result.steel.ShearStress | null,
                normalStress?: ng.result.steel.NormalStress | null,
                pureNormalResistance?: ng.result.steel.PureNormalResistance | null,
                normal?: ng.result.steel.NormalCapacity | null,
                flexural1?: ng.result.steel.Flexural | null,
                flexural2?: ng.result.steel.Flexural | null,
                flexuralTorsional?: ng.result.steel.FlexuralTorsional | null,
                lateralTorsionalTop?: ng.result.steel.LateralTorsional | null,
                lateralTorsionalBottom?: ng.result.steel.LateralTorsional | null,
                interaction1?: ng.result.steel.Interaction | null,
                interaction2?: ng.result.steel.Interaction | null,
                interaction2nd?: ng.result.steel.Interaction2nd | null,
                web?: ng.result.steel.Web | null,
                controlData?: ng.result.control.ControlData[],
            }
            export interface SectionResult_json {
                effectiveClassFour?: ng.result.steel.EffectiveClassFour_json;
                shear1?: ng.result.steel.ShearResistance_json;
                shear2?: ng.result.steel.ShearResistance_json;
                torsional?: ng.result.steel.TorsionalResistance_json;
                shearStress?: ng.result.steel.ShearStress_json;
                normalStress?: ng.result.steel.NormalStress_json;
                pureNormalResistance?: ng.result.steel.PureNormalResistance_json;
                normal?: ng.result.steel.NormalCapacity_json;
                flexural1?: ng.result.steel.Flexural_json;
                flexural2?: ng.result.steel.Flexural_json;
                flexuralTorsional?: ng.result.steel.FlexuralTorsional_json;
                lateralTorsionalTop?: ng.result.steel.LateralTorsional_json;
                lateralTorsionalBottom?: ng.result.steel.LateralTorsional_json;
                interaction1?: ng.result.steel.Interaction_json;
                interaction2?: ng.result.steel.Interaction_json;
                interaction2nd?: ng.result.steel.Interaction2nd_json;
                web?: ng.result.steel.Web_json;
                controlData: ng.result.control.ControlData_json[];
            }
            interface SectionResult_json_in {
                __proto_name?: unknown;
                effectiveClassFour?: unknown;
                shear1?: unknown;
                shear2?: unknown;
                torsional?: unknown;
                shearStress?: unknown;
                normalStress?: unknown;
                pureNormalResistance?: unknown;
                normal?: unknown;
                flexural1?: unknown;
                flexural2?: unknown;
                flexuralTorsional?: unknown;
                lateralTorsionalTop?: unknown;
                lateralTorsionalBottom?: unknown;
                interaction1?: unknown;
                interaction2?: unknown;
                interaction2nd?: unknown;
                web?: unknown;
                controlData?: unknown;
            }
            export class SectionResult {
                __proto_name = "ng.result.steel.SectionResult";
                effectiveClassFour: ng.result.steel.EffectiveClassFour | null = null;
                shear1: ng.result.steel.ShearResistance | null = null;
                shear2: ng.result.steel.ShearResistance | null = null;
                torsional: ng.result.steel.TorsionalResistance | null = null;
                shearStress: ng.result.steel.ShearStress | null = null;
                normalStress: ng.result.steel.NormalStress | null = null;
                pureNormalResistance: ng.result.steel.PureNormalResistance | null = null;
                normal: ng.result.steel.NormalCapacity | null = null;
                flexural1: ng.result.steel.Flexural | null = null;
                flexural2: ng.result.steel.Flexural | null = null;
                flexuralTorsional: ng.result.steel.FlexuralTorsional | null = null;
                lateralTorsionalTop: ng.result.steel.LateralTorsional | null = null;
                lateralTorsionalBottom: ng.result.steel.LateralTorsional | null = null;
                interaction1: ng.result.steel.Interaction | null = null;
                interaction2: ng.result.steel.Interaction | null = null;
                interaction2nd: ng.result.steel.Interaction2nd | null = null;
                web: ng.result.steel.Web | null = null;
                controlData: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): SectionResult {
                    const dst = new SectionResult();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionResult but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionResult_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionResult but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.effectiveClassFour !== undefined && src.effectiveClassFour !== null) {
                        dst.effectiveClassFour = ng.result.steel.EffectiveClassFour.fromObject(src.effectiveClassFour);
                    }
                    if (src.shear1 !== undefined && src.shear1 !== null) {
                        dst.shear1 = ng.result.steel.ShearResistance.fromObject(src.shear1);
                    }
                    if (src.shear2 !== undefined && src.shear2 !== null) {
                        dst.shear2 = ng.result.steel.ShearResistance.fromObject(src.shear2);
                    }
                    if (src.torsional !== undefined && src.torsional !== null) {
                        dst.torsional = ng.result.steel.TorsionalResistance.fromObject(src.torsional);
                    }
                    if (src.shearStress !== undefined && src.shearStress !== null) {
                        dst.shearStress = ng.result.steel.ShearStress.fromObject(src.shearStress);
                    }
                    if (src.normalStress !== undefined && src.normalStress !== null) {
                        dst.normalStress = ng.result.steel.NormalStress.fromObject(src.normalStress);
                    }
                    if (src.pureNormalResistance !== undefined && src.pureNormalResistance !== null) {
                        dst.pureNormalResistance = ng.result.steel.PureNormalResistance.fromObject(src.pureNormalResistance);
                    }
                    if (src.normal !== undefined && src.normal !== null) {
                        dst.normal = ng.result.steel.NormalCapacity.fromObject(src.normal);
                    }
                    if (src.flexural1 !== undefined && src.flexural1 !== null) {
                        dst.flexural1 = ng.result.steel.Flexural.fromObject(src.flexural1);
                    }
                    if (src.flexural2 !== undefined && src.flexural2 !== null) {
                        dst.flexural2 = ng.result.steel.Flexural.fromObject(src.flexural2);
                    }
                    if (src.flexuralTorsional !== undefined && src.flexuralTorsional !== null) {
                        dst.flexuralTorsional = ng.result.steel.FlexuralTorsional.fromObject(src.flexuralTorsional);
                    }
                    if (src.lateralTorsionalTop !== undefined && src.lateralTorsionalTop !== null) {
                        dst.lateralTorsionalTop = ng.result.steel.LateralTorsional.fromObject(src.lateralTorsionalTop);
                    }
                    if (src.lateralTorsionalBottom !== undefined && src.lateralTorsionalBottom !== null) {
                        dst.lateralTorsionalBottom = ng.result.steel.LateralTorsional.fromObject(src.lateralTorsionalBottom);
                    }
                    if (src.interaction1 !== undefined && src.interaction1 !== null) {
                        dst.interaction1 = ng.result.steel.Interaction.fromObject(src.interaction1);
                    }
                    if (src.interaction2 !== undefined && src.interaction2 !== null) {
                        dst.interaction2 = ng.result.steel.Interaction.fromObject(src.interaction2);
                    }
                    if (src.interaction2nd !== undefined && src.interaction2nd !== null) {
                        dst.interaction2nd = ng.result.steel.Interaction2nd.fromObject(src.interaction2nd);
                    }
                    if (src.web !== undefined && src.web !== null) {
                        dst.web = ng.result.steel.Web.fromObject(src.web);
                    }
                    if (src.controlData !== undefined && src.controlData !== null) {
                        if (Array.isArray(src.controlData)) {
                            for (const element of src.controlData) {
                                dst.controlData.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controlData of SectionResult to be a array but was ', typeof src.controlData, src.controlData)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionResult | null | undefined): SectionResult_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.SectionResult is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.SectionResult") {
                        console.error('Expected ng.result.steel.SectionResult but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionResult_json = {
                        controlData: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.effectiveClassFour !== null)
                    {
                        const parsed = ng.result.steel.EffectiveClassFour.toObject(src.effectiveClassFour);
                        if(parsed === null) return null;
                        dst.effectiveClassFour = parsed;
                    }
                    if(src.shear1 !== null)
                    {
                        const parsed = ng.result.steel.ShearResistance.toObject(src.shear1);
                        if(parsed === null) return null;
                        dst.shear1 = parsed;
                    }
                    if(src.shear2 !== null)
                    {
                        const parsed = ng.result.steel.ShearResistance.toObject(src.shear2);
                        if(parsed === null) return null;
                        dst.shear2 = parsed;
                    }
                    if(src.torsional !== null)
                    {
                        const parsed = ng.result.steel.TorsionalResistance.toObject(src.torsional);
                        if(parsed === null) return null;
                        dst.torsional = parsed;
                    }
                    if(src.shearStress !== null)
                    {
                        const parsed = ng.result.steel.ShearStress.toObject(src.shearStress);
                        if(parsed === null) return null;
                        dst.shearStress = parsed;
                    }
                    if(src.normalStress !== null)
                    {
                        const parsed = ng.result.steel.NormalStress.toObject(src.normalStress);
                        if(parsed === null) return null;
                        dst.normalStress = parsed;
                    }
                    if(src.pureNormalResistance !== null)
                    {
                        const parsed = ng.result.steel.PureNormalResistance.toObject(src.pureNormalResistance);
                        if(parsed === null) return null;
                        dst.pureNormalResistance = parsed;
                    }
                    if(src.normal !== null)
                    {
                        const parsed = ng.result.steel.NormalCapacity.toObject(src.normal);
                        if(parsed === null) return null;
                        dst.normal = parsed;
                    }
                    if(src.flexural1 !== null)
                    {
                        const parsed = ng.result.steel.Flexural.toObject(src.flexural1);
                        if(parsed === null) return null;
                        dst.flexural1 = parsed;
                    }
                    if(src.flexural2 !== null)
                    {
                        const parsed = ng.result.steel.Flexural.toObject(src.flexural2);
                        if(parsed === null) return null;
                        dst.flexural2 = parsed;
                    }
                    if(src.flexuralTorsional !== null)
                    {
                        const parsed = ng.result.steel.FlexuralTorsional.toObject(src.flexuralTorsional);
                        if(parsed === null) return null;
                        dst.flexuralTorsional = parsed;
                    }
                    if(src.lateralTorsionalTop !== null)
                    {
                        const parsed = ng.result.steel.LateralTorsional.toObject(src.lateralTorsionalTop);
                        if(parsed === null) return null;
                        dst.lateralTorsionalTop = parsed;
                    }
                    if(src.lateralTorsionalBottom !== null)
                    {
                        const parsed = ng.result.steel.LateralTorsional.toObject(src.lateralTorsionalBottom);
                        if(parsed === null) return null;
                        dst.lateralTorsionalBottom = parsed;
                    }
                    if(src.interaction1 !== null)
                    {
                        const parsed = ng.result.steel.Interaction.toObject(src.interaction1);
                        if(parsed === null) return null;
                        dst.interaction1 = parsed;
                    }
                    if(src.interaction2 !== null)
                    {
                        const parsed = ng.result.steel.Interaction.toObject(src.interaction2);
                        if(parsed === null) return null;
                        dst.interaction2 = parsed;
                    }
                    if(src.interaction2nd !== null)
                    {
                        const parsed = ng.result.steel.Interaction2nd.toObject(src.interaction2nd);
                        if(parsed === null) return null;
                        dst.interaction2nd = parsed;
                    }
                    if(src.web !== null)
                    {
                        const parsed = ng.result.steel.Web.toObject(src.web);
                        if(parsed === null) return null;
                        dst.web = parsed;
                    }
                    if (src.controlData !== null) {
                        for (const element of src.controlData) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controlData.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: SectionResult_createType) {
                    const dst = new SectionResult();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.effectiveClassFour !== undefined) {
                        dst.effectiveClassFour = src.effectiveClassFour;
                    }
                    if (src.shear1 !== undefined) {
                        dst.shear1 = src.shear1;
                    }
                    if (src.shear2 !== undefined) {
                        dst.shear2 = src.shear2;
                    }
                    if (src.torsional !== undefined) {
                        dst.torsional = src.torsional;
                    }
                    if (src.shearStress !== undefined) {
                        dst.shearStress = src.shearStress;
                    }
                    if (src.normalStress !== undefined) {
                        dst.normalStress = src.normalStress;
                    }
                    if (src.pureNormalResistance !== undefined) {
                        dst.pureNormalResistance = src.pureNormalResistance;
                    }
                    if (src.normal !== undefined) {
                        dst.normal = src.normal;
                    }
                    if (src.flexural1 !== undefined) {
                        dst.flexural1 = src.flexural1;
                    }
                    if (src.flexural2 !== undefined) {
                        dst.flexural2 = src.flexural2;
                    }
                    if (src.flexuralTorsional !== undefined) {
                        dst.flexuralTorsional = src.flexuralTorsional;
                    }
                    if (src.lateralTorsionalTop !== undefined) {
                        dst.lateralTorsionalTop = src.lateralTorsionalTop;
                    }
                    if (src.lateralTorsionalBottom !== undefined) {
                        dst.lateralTorsionalBottom = src.lateralTorsionalBottom;
                    }
                    if (src.interaction1 !== undefined) {
                        dst.interaction1 = src.interaction1;
                    }
                    if (src.interaction2 !== undefined) {
                        dst.interaction2 = src.interaction2;
                    }
                    if (src.interaction2nd !== undefined) {
                        dst.interaction2nd = src.interaction2nd;
                    }
                    if (src.web !== undefined) {
                        dst.web = src.web;
                    }
                    if (src.controlData !== undefined) {
                        dst.controlData = src.controlData;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionResult();
                    dst.effectiveClassFour = this.effectiveClassFour;
                    dst.shear1 = this.shear1;
                    dst.shear2 = this.shear2;
                    dst.torsional = this.torsional;
                    dst.shearStress = this.shearStress;
                    dst.normalStress = this.normalStress;
                    dst.pureNormalResistance = this.pureNormalResistance;
                    dst.normal = this.normal;
                    dst.flexural1 = this.flexural1;
                    dst.flexural2 = this.flexural2;
                    dst.flexuralTorsional = this.flexuralTorsional;
                    dst.lateralTorsionalTop = this.lateralTorsionalTop;
                    dst.lateralTorsionalBottom = this.lateralTorsionalBottom;
                    dst.interaction1 = this.interaction1;
                    dst.interaction2 = this.interaction2;
                    dst.interaction2nd = this.interaction2nd;
                    dst.web = this.web;
                    dst.controlData = this.controlData;
                    return dst;
                }

                deepClone() {
                    const json = SectionResult.toObject(this);
                    const dst = SectionResult.fromObject(json);
                    return dst;
                }
            }
            export type ISectionResult = SectionResult;


            export type SectionParameters_keys = 'sectionUnits' | 'iy' | 'iz' | 'y0' | 'z0' | 'i0' | 'a';
            export interface SectionParameters_createType {
                sectionUnits?: ng.sections.SectionUnits | null,
                iy?: number,
                iz?: number,
                y0?: number,
                z0?: number,
                i0?: number,
                a?: ng.geometry.Vector2D | null,
            }
            export interface SectionParameters_json {
                sectionUnits?: ng.sections.SectionUnits_json;
                iy?: JsonNumber;
                iz?: JsonNumber;
                y0?: JsonNumber;
                z0?: JsonNumber;
                i0?: JsonNumber;
                a?: ng.geometry.Vector2D_json;
            }
            interface SectionParameters_json_in {
                __proto_name?: unknown;
                sectionUnits?: unknown;
                iy?: unknown;
                iz?: unknown;
                y0?: unknown;
                z0?: unknown;
                i0?: unknown;
                a?: unknown;
            }
            export class SectionParameters {
                __proto_name = "ng.result.steel.SectionParameters";
                sectionUnits: ng.sections.SectionUnits | null = null;
                iy: number = 0;
                iz: number = 0;
                y0: number = 0;
                z0: number = 0;
                i0: number = 0;
                a: ng.geometry.Vector2D | null = null;

                static fromObject(src_unknown: unknown): SectionParameters {
                    const dst = new SectionParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sectionUnits !== undefined && src.sectionUnits !== null) {
                        dst.sectionUnits = ng.sections.SectionUnits.fromObject(src.sectionUnits);
                    }
                    if (src.iy !== undefined && src.iy !== null) {
                        if (typeof src.iy === "number" || src.iy === 'NaN' || src.iy === 'Infinity' || src.iy === '-Infinity') {
                            dst.iy = AsNum(src.iy);
                        }
                        else {
                            console.log('Expected iy of SectionParameters to be a number but was ', typeof src.iy, src.iy)
                        }
                    }
                    if (src.iz !== undefined && src.iz !== null) {
                        if (typeof src.iz === "number" || src.iz === 'NaN' || src.iz === 'Infinity' || src.iz === '-Infinity') {
                            dst.iz = AsNum(src.iz);
                        }
                        else {
                            console.log('Expected iz of SectionParameters to be a number but was ', typeof src.iz, src.iz)
                        }
                    }
                    if (src.y0 !== undefined && src.y0 !== null) {
                        if (typeof src.y0 === "number" || src.y0 === 'NaN' || src.y0 === 'Infinity' || src.y0 === '-Infinity') {
                            dst.y0 = AsNum(src.y0);
                        }
                        else {
                            console.log('Expected y0 of SectionParameters to be a number but was ', typeof src.y0, src.y0)
                        }
                    }
                    if (src.z0 !== undefined && src.z0 !== null) {
                        if (typeof src.z0 === "number" || src.z0 === 'NaN' || src.z0 === 'Infinity' || src.z0 === '-Infinity') {
                            dst.z0 = AsNum(src.z0);
                        }
                        else {
                            console.log('Expected z0 of SectionParameters to be a number but was ', typeof src.z0, src.z0)
                        }
                    }
                    if (src.i0 !== undefined && src.i0 !== null) {
                        if (typeof src.i0 === "number" || src.i0 === 'NaN' || src.i0 === 'Infinity' || src.i0 === '-Infinity') {
                            dst.i0 = AsNum(src.i0);
                        }
                        else {
                            console.log('Expected i0 of SectionParameters to be a number but was ', typeof src.i0, src.i0)
                        }
                    }
                    if (src.a !== undefined && src.a !== null) {
                        dst.a = ng.geometry.Vector2D.fromObject(src.a);
                    }
                    return dst;
                }

                static toObject(src: SectionParameters | null | undefined): SectionParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.SectionParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.SectionParameters") {
                        console.error('Expected ng.result.steel.SectionParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionParameters_json = {
                        iy: AsJsonNum(src.iy),
                        iz: AsJsonNum(src.iz),
                        y0: AsJsonNum(src.y0),
                        z0: AsJsonNum(src.z0),
                        i0: AsJsonNum(src.i0),
                    };
                    if(src.sectionUnits !== null)
                    {
                        const parsed = ng.sections.SectionUnits.toObject(src.sectionUnits);
                        if(parsed === null) return null;
                        dst.sectionUnits = parsed;
                    }
                    if(src.a !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.a);
                        if(parsed === null) return null;
                        dst.a = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionParameters_createType) {
                    const dst = new SectionParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sectionUnits !== undefined) {
                        dst.sectionUnits = src.sectionUnits;
                    }
                    if (src.iy !== undefined) {
                        dst.iy = src.iy;
                    }
                    if (src.iz !== undefined) {
                        dst.iz = src.iz;
                    }
                    if (src.y0 !== undefined) {
                        dst.y0 = src.y0;
                    }
                    if (src.z0 !== undefined) {
                        dst.z0 = src.z0;
                    }
                    if (src.i0 !== undefined) {
                        dst.i0 = src.i0;
                    }
                    if (src.a !== undefined) {
                        dst.a = src.a;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionParameters();
                    dst.sectionUnits = this.sectionUnits;
                    dst.iy = this.iy;
                    dst.iz = this.iz;
                    dst.y0 = this.y0;
                    dst.z0 = this.z0;
                    dst.i0 = this.i0;
                    dst.a = this.a;
                    return dst;
                }

                deepClone() {
                    const json = SectionParameters.toObject(this);
                    const dst = SectionParameters.fromObject(json);
                    return dst;
                }
            }
            export type ISectionParameters = SectionParameters;


            export type CharacteristicValues_keys = 'elasticityModulus' | 'yieldStrength' | 'ultimateStrength' | 'shearModulus';
            export interface CharacteristicValues_createType {
                elasticityModulus?: number,
                yieldStrength?: number,
                ultimateStrength?: number,
                shearModulus?: number,
            }
            export interface CharacteristicValues_json {
                elasticityModulus?: JsonNumber;
                yieldStrength?: JsonNumber;
                ultimateStrength?: JsonNumber;
                shearModulus?: JsonNumber;
            }
            interface CharacteristicValues_json_in {
                __proto_name?: unknown;
                elasticityModulus?: unknown;
                yieldStrength?: unknown;
                ultimateStrength?: unknown;
                shearModulus?: unknown;
            }
            export class CharacteristicValues {
                __proto_name = "ng.result.steel.CharacteristicValues";
                elasticityModulus: number = 0;
                yieldStrength: number = 0;
                ultimateStrength: number = 0;
                shearModulus: number = 0;

                static fromObject(src_unknown: unknown): CharacteristicValues {
                    const dst = new CharacteristicValues();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicValues but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicValues_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicValues but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elasticityModulus !== undefined && src.elasticityModulus !== null) {
                        if (typeof src.elasticityModulus === "number" || src.elasticityModulus === 'NaN' || src.elasticityModulus === 'Infinity' || src.elasticityModulus === '-Infinity') {
                            dst.elasticityModulus = AsNum(src.elasticityModulus);
                        }
                        else {
                            console.log('Expected elasticityModulus of CharacteristicValues to be a number but was ', typeof src.elasticityModulus, src.elasticityModulus)
                        }
                    }
                    if (src.yieldStrength !== undefined && src.yieldStrength !== null) {
                        if (typeof src.yieldStrength === "number" || src.yieldStrength === 'NaN' || src.yieldStrength === 'Infinity' || src.yieldStrength === '-Infinity') {
                            dst.yieldStrength = AsNum(src.yieldStrength);
                        }
                        else {
                            console.log('Expected yieldStrength of CharacteristicValues to be a number but was ', typeof src.yieldStrength, src.yieldStrength)
                        }
                    }
                    if (src.ultimateStrength !== undefined && src.ultimateStrength !== null) {
                        if (typeof src.ultimateStrength === "number" || src.ultimateStrength === 'NaN' || src.ultimateStrength === 'Infinity' || src.ultimateStrength === '-Infinity') {
                            dst.ultimateStrength = AsNum(src.ultimateStrength);
                        }
                        else {
                            console.log('Expected ultimateStrength of CharacteristicValues to be a number but was ', typeof src.ultimateStrength, src.ultimateStrength)
                        }
                    }
                    if (src.shearModulus !== undefined && src.shearModulus !== null) {
                        if (typeof src.shearModulus === "number" || src.shearModulus === 'NaN' || src.shearModulus === 'Infinity' || src.shearModulus === '-Infinity') {
                            dst.shearModulus = AsNum(src.shearModulus);
                        }
                        else {
                            console.log('Expected shearModulus of CharacteristicValues to be a number but was ', typeof src.shearModulus, src.shearModulus)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharacteristicValues | null | undefined): CharacteristicValues_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.CharacteristicValues is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.CharacteristicValues") {
                        console.error('Expected ng.result.steel.CharacteristicValues but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CharacteristicValues_json = {
                        elasticityModulus: AsJsonNum(src.elasticityModulus),
                        yieldStrength: AsJsonNum(src.yieldStrength),
                        ultimateStrength: AsJsonNum(src.ultimateStrength),
                        shearModulus: AsJsonNum(src.shearModulus),
                    };
                    return dst;
                }

                static create(src?: CharacteristicValues_createType) {
                    const dst = new CharacteristicValues();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elasticityModulus !== undefined) {
                        dst.elasticityModulus = src.elasticityModulus;
                    }
                    if (src.yieldStrength !== undefined) {
                        dst.yieldStrength = src.yieldStrength;
                    }
                    if (src.ultimateStrength !== undefined) {
                        dst.ultimateStrength = src.ultimateStrength;
                    }
                    if (src.shearModulus !== undefined) {
                        dst.shearModulus = src.shearModulus;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicValues();
                    dst.elasticityModulus = this.elasticityModulus;
                    dst.yieldStrength = this.yieldStrength;
                    dst.ultimateStrength = this.ultimateStrength;
                    dst.shearModulus = this.shearModulus;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicValues.toObject(this);
                    const dst = CharacteristicValues.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicValues = CharacteristicValues;


            export type MaterialParameters_keys = 'materialSteel' | 'lambda1' | 'epsilon' | 'epsilonFi';
            export interface MaterialParameters_createType {
                materialSteel?: ng.result.steel.CharacteristicValues | null,
                lambda1?: number,
                epsilon?: number,
                epsilonFi?: number,
            }
            export interface MaterialParameters_json {
                materialSteel?: ng.result.steel.CharacteristicValues_json;
                lambda1?: JsonNumber;
                epsilon?: JsonNumber;
                epsilonFi?: JsonNumber;
            }
            interface MaterialParameters_json_in {
                __proto_name?: unknown;
                materialSteel?: unknown;
                lambda1?: unknown;
                epsilon?: unknown;
                epsilonFi?: unknown;
            }
            export class MaterialParameters {
                __proto_name = "ng.result.steel.MaterialParameters";
                materialSteel: ng.result.steel.CharacteristicValues | null = null;
                lambda1: number = 0;
                epsilon: number = 0;
                epsilonFi: number = 0;

                static fromObject(src_unknown: unknown): MaterialParameters {
                    const dst = new MaterialParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MaterialParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MaterialParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MaterialParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.materialSteel !== undefined && src.materialSteel !== null) {
                        dst.materialSteel = ng.result.steel.CharacteristicValues.fromObject(src.materialSteel);
                    }
                    if (src.lambda1 !== undefined && src.lambda1 !== null) {
                        if (typeof src.lambda1 === "number" || src.lambda1 === 'NaN' || src.lambda1 === 'Infinity' || src.lambda1 === '-Infinity') {
                            dst.lambda1 = AsNum(src.lambda1);
                        }
                        else {
                            console.log('Expected lambda1 of MaterialParameters to be a number but was ', typeof src.lambda1, src.lambda1)
                        }
                    }
                    if (src.epsilon !== undefined && src.epsilon !== null) {
                        if (typeof src.epsilon === "number" || src.epsilon === 'NaN' || src.epsilon === 'Infinity' || src.epsilon === '-Infinity') {
                            dst.epsilon = AsNum(src.epsilon);
                        }
                        else {
                            console.log('Expected epsilon of MaterialParameters to be a number but was ', typeof src.epsilon, src.epsilon)
                        }
                    }
                    if (src.epsilonFi !== undefined && src.epsilonFi !== null) {
                        if (typeof src.epsilonFi === "number" || src.epsilonFi === 'NaN' || src.epsilonFi === 'Infinity' || src.epsilonFi === '-Infinity') {
                            dst.epsilonFi = AsNum(src.epsilonFi);
                        }
                        else {
                            console.log('Expected epsilonFi of MaterialParameters to be a number but was ', typeof src.epsilonFi, src.epsilonFi)
                        }
                    }
                    return dst;
                }

                static toObject(src: MaterialParameters | null | undefined): MaterialParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.MaterialParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.MaterialParameters") {
                        console.error('Expected ng.result.steel.MaterialParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MaterialParameters_json = {
                        lambda1: AsJsonNum(src.lambda1),
                        epsilon: AsJsonNum(src.epsilon),
                        epsilonFi: AsJsonNum(src.epsilonFi),
                    };
                    if(src.materialSteel !== null)
                    {
                        const parsed = ng.result.steel.CharacteristicValues.toObject(src.materialSteel);
                        if(parsed === null) return null;
                        dst.materialSteel = parsed;
                    }
                    return dst;
                }

                static create(src?: MaterialParameters_createType) {
                    const dst = new MaterialParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.materialSteel !== undefined) {
                        dst.materialSteel = src.materialSteel;
                    }
                    if (src.lambda1 !== undefined) {
                        dst.lambda1 = src.lambda1;
                    }
                    if (src.epsilon !== undefined) {
                        dst.epsilon = src.epsilon;
                    }
                    if (src.epsilonFi !== undefined) {
                        dst.epsilonFi = src.epsilonFi;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MaterialParameters();
                    dst.materialSteel = this.materialSteel;
                    dst.lambda1 = this.lambda1;
                    dst.epsilon = this.epsilon;
                    dst.epsilonFi = this.epsilonFi;
                    return dst;
                }

                deepClone() {
                    const json = MaterialParameters.toObject(this);
                    const dst = MaterialParameters.fromObject(json);
                    return dst;
                }
            }
            export type IMaterialParameters = MaterialParameters;


            export type MaterialFireParameters_keys = 'kyTheta' | 'kpTheta' | 'kp02Theta' | 'kE';
            export interface MaterialFireParameters_createType {
                kyTheta?: number,
                kpTheta?: number,
                kp02Theta?: number,
                kE?: number,
            }
            export interface MaterialFireParameters_json {
                kyTheta?: JsonNumber;
                kpTheta?: JsonNumber;
                kp02Theta?: JsonNumber;
                kE?: JsonNumber;
            }
            interface MaterialFireParameters_json_in {
                __proto_name?: unknown;
                kyTheta?: unknown;
                kpTheta?: unknown;
                kp02Theta?: unknown;
                kE?: unknown;
            }
            export class MaterialFireParameters {
                __proto_name = "ng.result.steel.MaterialFireParameters";
                kyTheta: number = 0;
                kpTheta: number = 0;
                kp02Theta: number = 0;
                kE: number = 0;

                static fromObject(src_unknown: unknown): MaterialFireParameters {
                    const dst = new MaterialFireParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MaterialFireParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MaterialFireParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MaterialFireParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kyTheta !== undefined && src.kyTheta !== null) {
                        if (typeof src.kyTheta === "number" || src.kyTheta === 'NaN' || src.kyTheta === 'Infinity' || src.kyTheta === '-Infinity') {
                            dst.kyTheta = AsNum(src.kyTheta);
                        }
                        else {
                            console.log('Expected kyTheta of MaterialFireParameters to be a number but was ', typeof src.kyTheta, src.kyTheta)
                        }
                    }
                    if (src.kpTheta !== undefined && src.kpTheta !== null) {
                        if (typeof src.kpTheta === "number" || src.kpTheta === 'NaN' || src.kpTheta === 'Infinity' || src.kpTheta === '-Infinity') {
                            dst.kpTheta = AsNum(src.kpTheta);
                        }
                        else {
                            console.log('Expected kpTheta of MaterialFireParameters to be a number but was ', typeof src.kpTheta, src.kpTheta)
                        }
                    }
                    if (src.kp02Theta !== undefined && src.kp02Theta !== null) {
                        if (typeof src.kp02Theta === "number" || src.kp02Theta === 'NaN' || src.kp02Theta === 'Infinity' || src.kp02Theta === '-Infinity') {
                            dst.kp02Theta = AsNum(src.kp02Theta);
                        }
                        else {
                            console.log('Expected kp02Theta of MaterialFireParameters to be a number but was ', typeof src.kp02Theta, src.kp02Theta)
                        }
                    }
                    if (src.kE !== undefined && src.kE !== null) {
                        if (typeof src.kE === "number" || src.kE === 'NaN' || src.kE === 'Infinity' || src.kE === '-Infinity') {
                            dst.kE = AsNum(src.kE);
                        }
                        else {
                            console.log('Expected kE of MaterialFireParameters to be a number but was ', typeof src.kE, src.kE)
                        }
                    }
                    return dst;
                }

                static toObject(src: MaterialFireParameters | null | undefined): MaterialFireParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.MaterialFireParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.MaterialFireParameters") {
                        console.error('Expected ng.result.steel.MaterialFireParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MaterialFireParameters_json = {
                        kyTheta: AsJsonNum(src.kyTheta),
                        kpTheta: AsJsonNum(src.kpTheta),
                        kp02Theta: AsJsonNum(src.kp02Theta),
                        kE: AsJsonNum(src.kE),
                    };
                    return dst;
                }

                static create(src?: MaterialFireParameters_createType) {
                    const dst = new MaterialFireParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kyTheta !== undefined) {
                        dst.kyTheta = src.kyTheta;
                    }
                    if (src.kpTheta !== undefined) {
                        dst.kpTheta = src.kpTheta;
                    }
                    if (src.kp02Theta !== undefined) {
                        dst.kp02Theta = src.kp02Theta;
                    }
                    if (src.kE !== undefined) {
                        dst.kE = src.kE;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MaterialFireParameters();
                    dst.kyTheta = this.kyTheta;
                    dst.kpTheta = this.kpTheta;
                    dst.kp02Theta = this.kp02Theta;
                    dst.kE = this.kE;
                    return dst;
                }

                deepClone() {
                    const json = MaterialFireParameters.toObject(this);
                    const dst = MaterialFireParameters.fromObject(json);
                    return dst;
                }
            }
            export type IMaterialFireParameters = MaterialFireParameters;


            export type GasTemperature_keys = 'tempCurve' | 'parametric' | 'graphGasTemp' | 'treq' | 'tempGas' | 'sectionExposion';
            export interface GasTemperature_createType {
                tempCurve?: ng.design.general.TemperatureCurve,
                parametric?: ng.result.steel.Parametric | null,
                graphGasTemp?: ng.result.steel.TVPointW | null,
                treq?: number,
                tempGas?: number,
                sectionExposion?: ng.design.steel.SectionExposure,
            }
            export interface GasTemperature_json {
                tempCurve?: string;
                parametric?: ng.result.steel.Parametric_json;
                graphGasTemp?: ng.result.steel.TVPointW_json;
                treq?: JsonNumber;
                tempGas?: JsonNumber;
                sectionExposion?: string;
            }
            interface GasTemperature_json_in {
                __proto_name?: unknown;
                tempCurve?: unknown;
                parametric?: unknown;
                graphGasTemp?: unknown;
                treq?: unknown;
                tempGas?: unknown;
                sectionExposion?: unknown;
            }
            export class GasTemperature {
                __proto_name = "ng.result.steel.GasTemperature";
                tempCurve: ng.design.general.TemperatureCurve = ng.design.general.TemperatureCurve.TEMPERATURE_CURVE_UNSPECIFIED;
                parametric: ng.result.steel.Parametric | null = null;
                graphGasTemp: ng.result.steel.TVPointW | null = null;
                treq: number = 0;
                tempGas: number = 0;
                sectionExposion: ng.design.steel.SectionExposure = ng.design.steel.SectionExposure.SECTION_EXPOSURE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): GasTemperature {
                    const dst = new GasTemperature();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GasTemperature but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GasTemperature_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GasTemperature but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.tempCurve !== undefined && src.tempCurve !== null) {
                        dst.tempCurve = ng.design.general.TemperatureCurve_FromObject(src.tempCurve);
                    }
                    if (src.parametric !== undefined && src.parametric !== null) {
                        dst.parametric = ng.result.steel.Parametric.fromObject(src.parametric);
                    }
                    if (src.graphGasTemp !== undefined && src.graphGasTemp !== null) {
                        dst.graphGasTemp = ng.result.steel.TVPointW.fromObject(src.graphGasTemp);
                    }
                    if (src.treq !== undefined && src.treq !== null) {
                        if (typeof src.treq === "number" || src.treq === 'NaN' || src.treq === 'Infinity' || src.treq === '-Infinity') {
                            dst.treq = AsNum(src.treq);
                        }
                        else {
                            console.log('Expected treq of GasTemperature to be a number but was ', typeof src.treq, src.treq)
                        }
                    }
                    if (src.tempGas !== undefined && src.tempGas !== null) {
                        if (typeof src.tempGas === "number" || src.tempGas === 'NaN' || src.tempGas === 'Infinity' || src.tempGas === '-Infinity') {
                            dst.tempGas = AsNum(src.tempGas);
                        }
                        else {
                            console.log('Expected tempGas of GasTemperature to be a number but was ', typeof src.tempGas, src.tempGas)
                        }
                    }
                    if (src.sectionExposion !== undefined && src.sectionExposion !== null) {
                        dst.sectionExposion = ng.design.steel.SectionExposure_FromObject(src.sectionExposion);
                    }
                    return dst;
                }

                static toObject(src: GasTemperature | null | undefined): GasTemperature_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.GasTemperature is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.GasTemperature") {
                        console.error('Expected ng.result.steel.GasTemperature but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const tempCurve_obj = ng.design.general.TemperatureCurve_ToObject(src.tempCurve);
                    if(tempCurve_obj === null) return null;

                    const sectionExposion_obj = ng.design.steel.SectionExposure_ToObject(src.sectionExposion);
                    if(sectionExposion_obj === null) return null;

                    const dst : GasTemperature_json = {
                        tempCurve: tempCurve_obj,
                        treq: AsJsonNum(src.treq),
                        tempGas: AsJsonNum(src.tempGas),
                        sectionExposion: sectionExposion_obj,
                    };
                    if(src.parametric !== null)
                    {
                        const parsed = ng.result.steel.Parametric.toObject(src.parametric);
                        if(parsed === null) return null;
                        dst.parametric = parsed;
                    }
                    if(src.graphGasTemp !== null)
                    {
                        const parsed = ng.result.steel.TVPointW.toObject(src.graphGasTemp);
                        if(parsed === null) return null;
                        dst.graphGasTemp = parsed;
                    }
                    return dst;
                }

                static create(src?: GasTemperature_createType) {
                    const dst = new GasTemperature();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.tempCurve !== undefined) {
                        dst.tempCurve = src.tempCurve;
                    }
                    if (src.parametric !== undefined) {
                        dst.parametric = src.parametric;
                    }
                    if (src.graphGasTemp !== undefined) {
                        dst.graphGasTemp = src.graphGasTemp;
                    }
                    if (src.treq !== undefined) {
                        dst.treq = src.treq;
                    }
                    if (src.tempGas !== undefined) {
                        dst.tempGas = src.tempGas;
                    }
                    if (src.sectionExposion !== undefined) {
                        dst.sectionExposion = src.sectionExposion;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GasTemperature();
                    dst.tempCurve = this.tempCurve;
                    dst.parametric = this.parametric;
                    dst.graphGasTemp = this.graphGasTemp;
                    dst.treq = this.treq;
                    dst.tempGas = this.tempGas;
                    dst.sectionExposion = this.sectionExposion;
                    return dst;
                }

                deepClone() {
                    const json = GasTemperature.toObject(this);
                    const dst = GasTemperature.fromObject(json);
                    return dst;
                }
            }
            export type IGasTemperature = GasTemperature;


            export type Parametric_keys = 'parametricO' | 'parametricB' | 'parametricQtd' | 'parametricTlim' | 'parametricGamma' | 'parametricTmaxA7' | 'parametricFuelControlled' | 'parametricTmaxAsterisk' | 'parametricThetaMax' | 'parametricOlim' | 'parametricGammaLim' | 'parametricK' | 'parametricTxmaxA12' | 'parametricX';
            export interface Parametric_createType {
                parametricO?: number,
                parametricB?: number,
                parametricQtd?: number,
                parametricTlim?: number,
                parametricGamma?: number,
                parametricTmaxA7?: number,
                parametricFuelControlled?: boolean,
                parametricTmaxAsterisk?: number,
                parametricThetaMax?: number,
                parametricOlim?: number,
                parametricGammaLim?: number,
                parametricK?: number,
                parametricTxmaxA12?: number,
                parametricX?: number,
            }
            export interface Parametric_json {
                parametricO?: JsonNumber;
                parametricB?: JsonNumber;
                parametricQtd?: JsonNumber;
                parametricTlim?: JsonNumber;
                parametricGamma?: JsonNumber;
                parametricTmaxA7?: JsonNumber;
                parametricFuelControlled?: boolean;
                parametricTmaxAsterisk?: JsonNumber;
                parametricThetaMax?: JsonNumber;
                parametricOlim?: JsonNumber;
                parametricGammaLim?: JsonNumber;
                parametricK?: JsonNumber;
                parametricTxmaxA12?: JsonNumber;
                parametricX?: JsonNumber;
            }
            interface Parametric_json_in {
                __proto_name?: unknown;
                parametricO?: unknown;
                parametricB?: unknown;
                parametricQtd?: unknown;
                parametricTlim?: unknown;
                parametricGamma?: unknown;
                parametricTmaxA7?: unknown;
                parametricFuelControlled?: unknown;
                parametricTmaxAsterisk?: unknown;
                parametricThetaMax?: unknown;
                parametricOlim?: unknown;
                parametricGammaLim?: unknown;
                parametricK?: unknown;
                parametricTxmaxA12?: unknown;
                parametricX?: unknown;
            }
            export class Parametric {
                __proto_name = "ng.result.steel.Parametric";
                parametricO: number = 0;
                parametricB: number = 0;
                parametricQtd: number = 0;
                parametricTlim: number = 0;
                parametricGamma: number = 0;
                parametricTmaxA7: number = 0;
                parametricFuelControlled: boolean = false;
                parametricTmaxAsterisk: number = 0;
                parametricThetaMax: number = 0;
                parametricOlim: number = 0;
                parametricGammaLim: number = 0;
                parametricK: number = 0;
                parametricTxmaxA12: number = 0;
                parametricX: number = 0;

                static fromObject(src_unknown: unknown): Parametric {
                    const dst = new Parametric();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Parametric but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Parametric_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Parametric but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.parametricO !== undefined && src.parametricO !== null) {
                        if (typeof src.parametricO === "number" || src.parametricO === 'NaN' || src.parametricO === 'Infinity' || src.parametricO === '-Infinity') {
                            dst.parametricO = AsNum(src.parametricO);
                        }
                        else {
                            console.log('Expected parametricO of Parametric to be a number but was ', typeof src.parametricO, src.parametricO)
                        }
                    }
                    if (src.parametricB !== undefined && src.parametricB !== null) {
                        if (typeof src.parametricB === "number" || src.parametricB === 'NaN' || src.parametricB === 'Infinity' || src.parametricB === '-Infinity') {
                            dst.parametricB = AsNum(src.parametricB);
                        }
                        else {
                            console.log('Expected parametricB of Parametric to be a number but was ', typeof src.parametricB, src.parametricB)
                        }
                    }
                    if (src.parametricQtd !== undefined && src.parametricQtd !== null) {
                        if (typeof src.parametricQtd === "number" || src.parametricQtd === 'NaN' || src.parametricQtd === 'Infinity' || src.parametricQtd === '-Infinity') {
                            dst.parametricQtd = AsNum(src.parametricQtd);
                        }
                        else {
                            console.log('Expected parametricQtd of Parametric to be a number but was ', typeof src.parametricQtd, src.parametricQtd)
                        }
                    }
                    if (src.parametricTlim !== undefined && src.parametricTlim !== null) {
                        if (typeof src.parametricTlim === "number" || src.parametricTlim === 'NaN' || src.parametricTlim === 'Infinity' || src.parametricTlim === '-Infinity') {
                            dst.parametricTlim = AsNum(src.parametricTlim);
                        }
                        else {
                            console.log('Expected parametricTlim of Parametric to be a number but was ', typeof src.parametricTlim, src.parametricTlim)
                        }
                    }
                    if (src.parametricGamma !== undefined && src.parametricGamma !== null) {
                        if (typeof src.parametricGamma === "number" || src.parametricGamma === 'NaN' || src.parametricGamma === 'Infinity' || src.parametricGamma === '-Infinity') {
                            dst.parametricGamma = AsNum(src.parametricGamma);
                        }
                        else {
                            console.log('Expected parametricGamma of Parametric to be a number but was ', typeof src.parametricGamma, src.parametricGamma)
                        }
                    }
                    if (src.parametricTmaxA7 !== undefined && src.parametricTmaxA7 !== null) {
                        if (typeof src.parametricTmaxA7 === "number" || src.parametricTmaxA7 === 'NaN' || src.parametricTmaxA7 === 'Infinity' || src.parametricTmaxA7 === '-Infinity') {
                            dst.parametricTmaxA7 = AsNum(src.parametricTmaxA7);
                        }
                        else {
                            console.log('Expected parametricTmaxA7 of Parametric to be a number but was ', typeof src.parametricTmaxA7, src.parametricTmaxA7)
                        }
                    }
                    if (src.parametricFuelControlled !== undefined && src.parametricFuelControlled !== null) {
                        if (typeof src.parametricFuelControlled === "boolean") {
                            dst.parametricFuelControlled = src.parametricFuelControlled;
                        }
                        else {
                            console.log('Expected parametricFuelControlled of Parametric to be a boolean but was ', typeof src.parametricFuelControlled, src.parametricFuelControlled)
                        }
                    }
                    if (src.parametricTmaxAsterisk !== undefined && src.parametricTmaxAsterisk !== null) {
                        if (typeof src.parametricTmaxAsterisk === "number" || src.parametricTmaxAsterisk === 'NaN' || src.parametricTmaxAsterisk === 'Infinity' || src.parametricTmaxAsterisk === '-Infinity') {
                            dst.parametricTmaxAsterisk = AsNum(src.parametricTmaxAsterisk);
                        }
                        else {
                            console.log('Expected parametricTmaxAsterisk of Parametric to be a number but was ', typeof src.parametricTmaxAsterisk, src.parametricTmaxAsterisk)
                        }
                    }
                    if (src.parametricThetaMax !== undefined && src.parametricThetaMax !== null) {
                        if (typeof src.parametricThetaMax === "number" || src.parametricThetaMax === 'NaN' || src.parametricThetaMax === 'Infinity' || src.parametricThetaMax === '-Infinity') {
                            dst.parametricThetaMax = AsNum(src.parametricThetaMax);
                        }
                        else {
                            console.log('Expected parametricThetaMax of Parametric to be a number but was ', typeof src.parametricThetaMax, src.parametricThetaMax)
                        }
                    }
                    if (src.parametricOlim !== undefined && src.parametricOlim !== null) {
                        if (typeof src.parametricOlim === "number" || src.parametricOlim === 'NaN' || src.parametricOlim === 'Infinity' || src.parametricOlim === '-Infinity') {
                            dst.parametricOlim = AsNum(src.parametricOlim);
                        }
                        else {
                            console.log('Expected parametricOlim of Parametric to be a number but was ', typeof src.parametricOlim, src.parametricOlim)
                        }
                    }
                    if (src.parametricGammaLim !== undefined && src.parametricGammaLim !== null) {
                        if (typeof src.parametricGammaLim === "number" || src.parametricGammaLim === 'NaN' || src.parametricGammaLim === 'Infinity' || src.parametricGammaLim === '-Infinity') {
                            dst.parametricGammaLim = AsNum(src.parametricGammaLim);
                        }
                        else {
                            console.log('Expected parametricGammaLim of Parametric to be a number but was ', typeof src.parametricGammaLim, src.parametricGammaLim)
                        }
                    }
                    if (src.parametricK !== undefined && src.parametricK !== null) {
                        if (typeof src.parametricK === "number" || src.parametricK === 'NaN' || src.parametricK === 'Infinity' || src.parametricK === '-Infinity') {
                            dst.parametricK = AsNum(src.parametricK);
                        }
                        else {
                            console.log('Expected parametricK of Parametric to be a number but was ', typeof src.parametricK, src.parametricK)
                        }
                    }
                    if (src.parametricTxmaxA12 !== undefined && src.parametricTxmaxA12 !== null) {
                        if (typeof src.parametricTxmaxA12 === "number" || src.parametricTxmaxA12 === 'NaN' || src.parametricTxmaxA12 === 'Infinity' || src.parametricTxmaxA12 === '-Infinity') {
                            dst.parametricTxmaxA12 = AsNum(src.parametricTxmaxA12);
                        }
                        else {
                            console.log('Expected parametricTxmaxA12 of Parametric to be a number but was ', typeof src.parametricTxmaxA12, src.parametricTxmaxA12)
                        }
                    }
                    if (src.parametricX !== undefined && src.parametricX !== null) {
                        if (typeof src.parametricX === "number" || src.parametricX === 'NaN' || src.parametricX === 'Infinity' || src.parametricX === '-Infinity') {
                            dst.parametricX = AsNum(src.parametricX);
                        }
                        else {
                            console.log('Expected parametricX of Parametric to be a number but was ', typeof src.parametricX, src.parametricX)
                        }
                    }
                    return dst;
                }

                static toObject(src: Parametric | null | undefined): Parametric_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Parametric is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Parametric") {
                        console.error('Expected ng.result.steel.Parametric but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Parametric_json = {
                        parametricO: AsJsonNum(src.parametricO),
                        parametricB: AsJsonNum(src.parametricB),
                        parametricQtd: AsJsonNum(src.parametricQtd),
                        parametricTlim: AsJsonNum(src.parametricTlim),
                        parametricGamma: AsJsonNum(src.parametricGamma),
                        parametricTmaxA7: AsJsonNum(src.parametricTmaxA7),
                        parametricFuelControlled: src.parametricFuelControlled,
                        parametricTmaxAsterisk: AsJsonNum(src.parametricTmaxAsterisk),
                        parametricThetaMax: AsJsonNum(src.parametricThetaMax),
                        parametricOlim: AsJsonNum(src.parametricOlim),
                        parametricGammaLim: AsJsonNum(src.parametricGammaLim),
                        parametricK: AsJsonNum(src.parametricK),
                        parametricTxmaxA12: AsJsonNum(src.parametricTxmaxA12),
                        parametricX: AsJsonNum(src.parametricX),
                    };
                    return dst;
                }

                static create(src?: Parametric_createType) {
                    const dst = new Parametric();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.parametricO !== undefined) {
                        dst.parametricO = src.parametricO;
                    }
                    if (src.parametricB !== undefined) {
                        dst.parametricB = src.parametricB;
                    }
                    if (src.parametricQtd !== undefined) {
                        dst.parametricQtd = src.parametricQtd;
                    }
                    if (src.parametricTlim !== undefined) {
                        dst.parametricTlim = src.parametricTlim;
                    }
                    if (src.parametricGamma !== undefined) {
                        dst.parametricGamma = src.parametricGamma;
                    }
                    if (src.parametricTmaxA7 !== undefined) {
                        dst.parametricTmaxA7 = src.parametricTmaxA7;
                    }
                    if (src.parametricFuelControlled !== undefined) {
                        dst.parametricFuelControlled = src.parametricFuelControlled;
                    }
                    if (src.parametricTmaxAsterisk !== undefined) {
                        dst.parametricTmaxAsterisk = src.parametricTmaxAsterisk;
                    }
                    if (src.parametricThetaMax !== undefined) {
                        dst.parametricThetaMax = src.parametricThetaMax;
                    }
                    if (src.parametricOlim !== undefined) {
                        dst.parametricOlim = src.parametricOlim;
                    }
                    if (src.parametricGammaLim !== undefined) {
                        dst.parametricGammaLim = src.parametricGammaLim;
                    }
                    if (src.parametricK !== undefined) {
                        dst.parametricK = src.parametricK;
                    }
                    if (src.parametricTxmaxA12 !== undefined) {
                        dst.parametricTxmaxA12 = src.parametricTxmaxA12;
                    }
                    if (src.parametricX !== undefined) {
                        dst.parametricX = src.parametricX;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Parametric();
                    dst.parametricO = this.parametricO;
                    dst.parametricB = this.parametricB;
                    dst.parametricQtd = this.parametricQtd;
                    dst.parametricTlim = this.parametricTlim;
                    dst.parametricGamma = this.parametricGamma;
                    dst.parametricTmaxA7 = this.parametricTmaxA7;
                    dst.parametricFuelControlled = this.parametricFuelControlled;
                    dst.parametricTmaxAsterisk = this.parametricTmaxAsterisk;
                    dst.parametricThetaMax = this.parametricThetaMax;
                    dst.parametricOlim = this.parametricOlim;
                    dst.parametricGammaLim = this.parametricGammaLim;
                    dst.parametricK = this.parametricK;
                    dst.parametricTxmaxA12 = this.parametricTxmaxA12;
                    dst.parametricX = this.parametricX;
                    return dst;
                }

                deepClone() {
                    const json = Parametric.toObject(this);
                    const dst = Parametric.fromObject(json);
                    return dst;
                }
            }
            export type IParametric = Parametric;


            export type MemberTemperatureUnprotected_keys = 'ksh' | 'am' | 'v' | 'amV' | 'amb' | 'amVb' | 'deltat' | 'rhoa' | 'sectionI' | 'sectionConvex' | 'epsm' | 'epsf' | 'alphac' | 'phi' | 'deflectionCritEssential';
            export interface MemberTemperatureUnprotected_createType {
                ksh?: number,
                am?: number,
                v?: number,
                amV?: number,
                amb?: number,
                amVb?: number,
                deltat?: number,
                rhoa?: number,
                sectionI?: boolean,
                sectionConvex?: boolean,
                epsm?: number,
                epsf?: number,
                alphac?: number,
                phi?: number,
                deflectionCritEssential?: boolean,
            }
            export interface MemberTemperatureUnprotected_json {
                ksh?: JsonNumber;
                am?: JsonNumber;
                v?: JsonNumber;
                amV?: JsonNumber;
                amb?: JsonNumber;
                amVb?: JsonNumber;
                deltat?: JsonNumber;
                rhoa?: JsonNumber;
                sectionI?: boolean;
                sectionConvex?: boolean;
                epsm?: JsonNumber;
                epsf?: JsonNumber;
                alphac?: JsonNumber;
                phi?: JsonNumber;
                deflectionCritEssential?: boolean;
            }
            interface MemberTemperatureUnprotected_json_in {
                __proto_name?: unknown;
                ksh?: unknown;
                am?: unknown;
                v?: unknown;
                amV?: unknown;
                amb?: unknown;
                amVb?: unknown;
                deltat?: unknown;
                rhoa?: unknown;
                sectionI?: unknown;
                sectionConvex?: unknown;
                epsm?: unknown;
                epsf?: unknown;
                alphac?: unknown;
                phi?: unknown;
                deflectionCritEssential?: unknown;
            }
            export class MemberTemperatureUnprotected {
                __proto_name = "ng.result.steel.MemberTemperatureUnprotected";
                ksh: number = 0;
                am: number = 0;
                v: number = 0;
                amV: number = 0;
                amb: number = 0;
                amVb: number = 0;
                deltat: number = 0;
                rhoa: number = 0;
                sectionI: boolean = false;
                sectionConvex: boolean = false;
                epsm: number = 0;
                epsf: number = 0;
                alphac: number = 0;
                phi: number = 0;
                deflectionCritEssential: boolean = false;

                static fromObject(src_unknown: unknown): MemberTemperatureUnprotected {
                    const dst = new MemberTemperatureUnprotected();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MemberTemperatureUnprotected but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MemberTemperatureUnprotected_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MemberTemperatureUnprotected but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ksh !== undefined && src.ksh !== null) {
                        if (typeof src.ksh === "number" || src.ksh === 'NaN' || src.ksh === 'Infinity' || src.ksh === '-Infinity') {
                            dst.ksh = AsNum(src.ksh);
                        }
                        else {
                            console.log('Expected ksh of MemberTemperatureUnprotected to be a number but was ', typeof src.ksh, src.ksh)
                        }
                    }
                    if (src.am !== undefined && src.am !== null) {
                        if (typeof src.am === "number" || src.am === 'NaN' || src.am === 'Infinity' || src.am === '-Infinity') {
                            dst.am = AsNum(src.am);
                        }
                        else {
                            console.log('Expected am of MemberTemperatureUnprotected to be a number but was ', typeof src.am, src.am)
                        }
                    }
                    if (src.v !== undefined && src.v !== null) {
                        if (typeof src.v === "number" || src.v === 'NaN' || src.v === 'Infinity' || src.v === '-Infinity') {
                            dst.v = AsNum(src.v);
                        }
                        else {
                            console.log('Expected v of MemberTemperatureUnprotected to be a number but was ', typeof src.v, src.v)
                        }
                    }
                    if (src.amV !== undefined && src.amV !== null) {
                        if (typeof src.amV === "number" || src.amV === 'NaN' || src.amV === 'Infinity' || src.amV === '-Infinity') {
                            dst.amV = AsNum(src.amV);
                        }
                        else {
                            console.log('Expected amV of MemberTemperatureUnprotected to be a number but was ', typeof src.amV, src.amV)
                        }
                    }
                    if (src.amb !== undefined && src.amb !== null) {
                        if (typeof src.amb === "number" || src.amb === 'NaN' || src.amb === 'Infinity' || src.amb === '-Infinity') {
                            dst.amb = AsNum(src.amb);
                        }
                        else {
                            console.log('Expected amb of MemberTemperatureUnprotected to be a number but was ', typeof src.amb, src.amb)
                        }
                    }
                    if (src.amVb !== undefined && src.amVb !== null) {
                        if (typeof src.amVb === "number" || src.amVb === 'NaN' || src.amVb === 'Infinity' || src.amVb === '-Infinity') {
                            dst.amVb = AsNum(src.amVb);
                        }
                        else {
                            console.log('Expected amVb of MemberTemperatureUnprotected to be a number but was ', typeof src.amVb, src.amVb)
                        }
                    }
                    if (src.deltat !== undefined && src.deltat !== null) {
                        if (typeof src.deltat === "number" || src.deltat === 'NaN' || src.deltat === 'Infinity' || src.deltat === '-Infinity') {
                            dst.deltat = AsNum(src.deltat);
                        }
                        else {
                            console.log('Expected deltat of MemberTemperatureUnprotected to be a number but was ', typeof src.deltat, src.deltat)
                        }
                    }
                    if (src.rhoa !== undefined && src.rhoa !== null) {
                        if (typeof src.rhoa === "number" || src.rhoa === 'NaN' || src.rhoa === 'Infinity' || src.rhoa === '-Infinity') {
                            dst.rhoa = AsNum(src.rhoa);
                        }
                        else {
                            console.log('Expected rhoa of MemberTemperatureUnprotected to be a number but was ', typeof src.rhoa, src.rhoa)
                        }
                    }
                    if (src.sectionI !== undefined && src.sectionI !== null) {
                        if (typeof src.sectionI === "boolean") {
                            dst.sectionI = src.sectionI;
                        }
                        else {
                            console.log('Expected sectionI of MemberTemperatureUnprotected to be a boolean but was ', typeof src.sectionI, src.sectionI)
                        }
                    }
                    if (src.sectionConvex !== undefined && src.sectionConvex !== null) {
                        if (typeof src.sectionConvex === "boolean") {
                            dst.sectionConvex = src.sectionConvex;
                        }
                        else {
                            console.log('Expected sectionConvex of MemberTemperatureUnprotected to be a boolean but was ', typeof src.sectionConvex, src.sectionConvex)
                        }
                    }
                    if (src.epsm !== undefined && src.epsm !== null) {
                        if (typeof src.epsm === "number" || src.epsm === 'NaN' || src.epsm === 'Infinity' || src.epsm === '-Infinity') {
                            dst.epsm = AsNum(src.epsm);
                        }
                        else {
                            console.log('Expected epsm of MemberTemperatureUnprotected to be a number but was ', typeof src.epsm, src.epsm)
                        }
                    }
                    if (src.epsf !== undefined && src.epsf !== null) {
                        if (typeof src.epsf === "number" || src.epsf === 'NaN' || src.epsf === 'Infinity' || src.epsf === '-Infinity') {
                            dst.epsf = AsNum(src.epsf);
                        }
                        else {
                            console.log('Expected epsf of MemberTemperatureUnprotected to be a number but was ', typeof src.epsf, src.epsf)
                        }
                    }
                    if (src.alphac !== undefined && src.alphac !== null) {
                        if (typeof src.alphac === "number" || src.alphac === 'NaN' || src.alphac === 'Infinity' || src.alphac === '-Infinity') {
                            dst.alphac = AsNum(src.alphac);
                        }
                        else {
                            console.log('Expected alphac of MemberTemperatureUnprotected to be a number but was ', typeof src.alphac, src.alphac)
                        }
                    }
                    if (src.phi !== undefined && src.phi !== null) {
                        if (typeof src.phi === "number" || src.phi === 'NaN' || src.phi === 'Infinity' || src.phi === '-Infinity') {
                            dst.phi = AsNum(src.phi);
                        }
                        else {
                            console.log('Expected phi of MemberTemperatureUnprotected to be a number but was ', typeof src.phi, src.phi)
                        }
                    }
                    if (src.deflectionCritEssential !== undefined && src.deflectionCritEssential !== null) {
                        if (typeof src.deflectionCritEssential === "boolean") {
                            dst.deflectionCritEssential = src.deflectionCritEssential;
                        }
                        else {
                            console.log('Expected deflectionCritEssential of MemberTemperatureUnprotected to be a boolean but was ', typeof src.deflectionCritEssential, src.deflectionCritEssential)
                        }
                    }
                    return dst;
                }

                static toObject(src: MemberTemperatureUnprotected | null | undefined): MemberTemperatureUnprotected_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.MemberTemperatureUnprotected is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.MemberTemperatureUnprotected") {
                        console.error('Expected ng.result.steel.MemberTemperatureUnprotected but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MemberTemperatureUnprotected_json = {
                        ksh: AsJsonNum(src.ksh),
                        am: AsJsonNum(src.am),
                        v: AsJsonNum(src.v),
                        amV: AsJsonNum(src.amV),
                        amb: AsJsonNum(src.amb),
                        amVb: AsJsonNum(src.amVb),
                        deltat: AsJsonNum(src.deltat),
                        rhoa: AsJsonNum(src.rhoa),
                        sectionI: src.sectionI,
                        sectionConvex: src.sectionConvex,
                        epsm: AsJsonNum(src.epsm),
                        epsf: AsJsonNum(src.epsf),
                        alphac: AsJsonNum(src.alphac),
                        phi: AsJsonNum(src.phi),
                        deflectionCritEssential: src.deflectionCritEssential,
                    };
                    return dst;
                }

                static create(src?: MemberTemperatureUnprotected_createType) {
                    const dst = new MemberTemperatureUnprotected();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ksh !== undefined) {
                        dst.ksh = src.ksh;
                    }
                    if (src.am !== undefined) {
                        dst.am = src.am;
                    }
                    if (src.v !== undefined) {
                        dst.v = src.v;
                    }
                    if (src.amV !== undefined) {
                        dst.amV = src.amV;
                    }
                    if (src.amb !== undefined) {
                        dst.amb = src.amb;
                    }
                    if (src.amVb !== undefined) {
                        dst.amVb = src.amVb;
                    }
                    if (src.deltat !== undefined) {
                        dst.deltat = src.deltat;
                    }
                    if (src.rhoa !== undefined) {
                        dst.rhoa = src.rhoa;
                    }
                    if (src.sectionI !== undefined) {
                        dst.sectionI = src.sectionI;
                    }
                    if (src.sectionConvex !== undefined) {
                        dst.sectionConvex = src.sectionConvex;
                    }
                    if (src.epsm !== undefined) {
                        dst.epsm = src.epsm;
                    }
                    if (src.epsf !== undefined) {
                        dst.epsf = src.epsf;
                    }
                    if (src.alphac !== undefined) {
                        dst.alphac = src.alphac;
                    }
                    if (src.phi !== undefined) {
                        dst.phi = src.phi;
                    }
                    if (src.deflectionCritEssential !== undefined) {
                        dst.deflectionCritEssential = src.deflectionCritEssential;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MemberTemperatureUnprotected();
                    dst.ksh = this.ksh;
                    dst.am = this.am;
                    dst.v = this.v;
                    dst.amV = this.amV;
                    dst.amb = this.amb;
                    dst.amVb = this.amVb;
                    dst.deltat = this.deltat;
                    dst.rhoa = this.rhoa;
                    dst.sectionI = this.sectionI;
                    dst.sectionConvex = this.sectionConvex;
                    dst.epsm = this.epsm;
                    dst.epsf = this.epsf;
                    dst.alphac = this.alphac;
                    dst.phi = this.phi;
                    dst.deflectionCritEssential = this.deflectionCritEssential;
                    return dst;
                }

                deepClone() {
                    const json = MemberTemperatureUnprotected.toObject(this);
                    const dst = MemberTemperatureUnprotected.fromObject(json);
                    return dst;
                }
            }
            export type IMemberTemperatureUnprotected = MemberTemperatureUnprotected;


            export type MemberTemperatureProtected_keys = 'deltap' | 'fireProtectionGuid' | 'ap' | 'apV' | 'graphMemberTemp' | 'tempMember';
            export interface MemberTemperatureProtected_createType {
                deltap?: number,
                fireProtectionGuid?: string,
                ap?: number,
                apV?: number,
                graphMemberTemp?: ng.result.steel.TVPointW | null,
                tempMember?: number,
            }
            export interface MemberTemperatureProtected_json {
                deltap?: JsonNumber;
                fireProtectionGuid?: string;
                ap?: JsonNumber;
                apV?: JsonNumber;
                graphMemberTemp?: ng.result.steel.TVPointW_json;
                tempMember?: JsonNumber;
            }
            interface MemberTemperatureProtected_json_in {
                __proto_name?: unknown;
                deltap?: unknown;
                fireProtectionGuid?: unknown;
                ap?: unknown;
                apV?: unknown;
                graphMemberTemp?: unknown;
                tempMember?: unknown;
            }
            export class MemberTemperatureProtected {
                __proto_name = "ng.result.steel.MemberTemperatureProtected";
                deltap: number = 0;
                fireProtectionGuid: string = "";
                ap: number = 0;
                apV: number = 0;
                graphMemberTemp: ng.result.steel.TVPointW | null = null;
                tempMember: number = 0;

                static fromObject(src_unknown: unknown): MemberTemperatureProtected {
                    const dst = new MemberTemperatureProtected();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MemberTemperatureProtected but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MemberTemperatureProtected_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MemberTemperatureProtected but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.deltap !== undefined && src.deltap !== null) {
                        if (typeof src.deltap === "number" || src.deltap === 'NaN' || src.deltap === 'Infinity' || src.deltap === '-Infinity') {
                            dst.deltap = AsNum(src.deltap);
                        }
                        else {
                            console.log('Expected deltap of MemberTemperatureProtected to be a number but was ', typeof src.deltap, src.deltap)
                        }
                    }
                    if (src.fireProtectionGuid !== undefined && src.fireProtectionGuid !== null) {
                        if (typeof src.fireProtectionGuid === "string") {
                            dst.fireProtectionGuid = src.fireProtectionGuid;
                        }
                        else {
                            console.log('Expected fireProtectionGuid of MemberTemperatureProtected to be a string but was ', typeof src.fireProtectionGuid, src.fireProtectionGuid)
                        }
                    }
                    if (src.ap !== undefined && src.ap !== null) {
                        if (typeof src.ap === "number" || src.ap === 'NaN' || src.ap === 'Infinity' || src.ap === '-Infinity') {
                            dst.ap = AsNum(src.ap);
                        }
                        else {
                            console.log('Expected ap of MemberTemperatureProtected to be a number but was ', typeof src.ap, src.ap)
                        }
                    }
                    if (src.apV !== undefined && src.apV !== null) {
                        if (typeof src.apV === "number" || src.apV === 'NaN' || src.apV === 'Infinity' || src.apV === '-Infinity') {
                            dst.apV = AsNum(src.apV);
                        }
                        else {
                            console.log('Expected apV of MemberTemperatureProtected to be a number but was ', typeof src.apV, src.apV)
                        }
                    }
                    if (src.graphMemberTemp !== undefined && src.graphMemberTemp !== null) {
                        dst.graphMemberTemp = ng.result.steel.TVPointW.fromObject(src.graphMemberTemp);
                    }
                    if (src.tempMember !== undefined && src.tempMember !== null) {
                        if (typeof src.tempMember === "number" || src.tempMember === 'NaN' || src.tempMember === 'Infinity' || src.tempMember === '-Infinity') {
                            dst.tempMember = AsNum(src.tempMember);
                        }
                        else {
                            console.log('Expected tempMember of MemberTemperatureProtected to be a number but was ', typeof src.tempMember, src.tempMember)
                        }
                    }
                    return dst;
                }

                static toObject(src: MemberTemperatureProtected | null | undefined): MemberTemperatureProtected_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.MemberTemperatureProtected is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.MemberTemperatureProtected") {
                        console.error('Expected ng.result.steel.MemberTemperatureProtected but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MemberTemperatureProtected_json = {
                        deltap: AsJsonNum(src.deltap),
                        fireProtectionGuid: src.fireProtectionGuid,
                        ap: AsJsonNum(src.ap),
                        apV: AsJsonNum(src.apV),
                        tempMember: AsJsonNum(src.tempMember),
                    };
                    if(src.graphMemberTemp !== null)
                    {
                        const parsed = ng.result.steel.TVPointW.toObject(src.graphMemberTemp);
                        if(parsed === null) return null;
                        dst.graphMemberTemp = parsed;
                    }
                    return dst;
                }

                static create(src?: MemberTemperatureProtected_createType) {
                    const dst = new MemberTemperatureProtected();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.deltap !== undefined) {
                        dst.deltap = src.deltap;
                    }
                    if (src.fireProtectionGuid !== undefined) {
                        dst.fireProtectionGuid = src.fireProtectionGuid;
                    }
                    if (src.ap !== undefined) {
                        dst.ap = src.ap;
                    }
                    if (src.apV !== undefined) {
                        dst.apV = src.apV;
                    }
                    if (src.graphMemberTemp !== undefined) {
                        dst.graphMemberTemp = src.graphMemberTemp;
                    }
                    if (src.tempMember !== undefined) {
                        dst.tempMember = src.tempMember;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MemberTemperatureProtected();
                    dst.deltap = this.deltap;
                    dst.fireProtectionGuid = this.fireProtectionGuid;
                    dst.ap = this.ap;
                    dst.apV = this.apV;
                    dst.graphMemberTemp = this.graphMemberTemp;
                    dst.tempMember = this.tempMember;
                    return dst;
                }

                deepClone() {
                    const json = MemberTemperatureProtected.toObject(this);
                    const dst = MemberTemperatureProtected.fromObject(json);
                    return dst;
                }
            }
            export type IMemberTemperatureProtected = MemberTemperatureProtected;


            export type FireParameters_keys = 'unprotected' | 'protected';
            export interface FireParameters_createType {
                unprotected?: ng.result.steel.MemberTemperatureUnprotected | null,
                protected?: ng.result.steel.MemberTemperatureProtected | null,
            }
            export interface FireParameters_json {
                unprotected?: ng.result.steel.MemberTemperatureUnprotected_json;
                protected?: ng.result.steel.MemberTemperatureProtected_json;
            }
            interface FireParameters_json_in {
                __proto_name?: unknown;
                unprotected?: unknown;
                protected?: unknown;
            }
            export class FireParameters {
                __proto_name = "ng.result.steel.FireParameters";
                unprotected: ng.result.steel.MemberTemperatureUnprotected | null = null;
                protected: ng.result.steel.MemberTemperatureProtected | null = null;

                static fromObject(src_unknown: unknown): FireParameters {
                    const dst = new FireParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FireParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FireParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FireParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.unprotected !== undefined && src.unprotected !== null) {
                        dst.unprotected = ng.result.steel.MemberTemperatureUnprotected.fromObject(src.unprotected);
                    }
                    if (src.protected !== undefined && src.protected !== null) {
                        dst.protected = ng.result.steel.MemberTemperatureProtected.fromObject(src.protected);
                    }
                    return dst;
                }

                static toObject(src: FireParameters | null | undefined): FireParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.FireParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.FireParameters") {
                        console.error('Expected ng.result.steel.FireParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FireParameters_json = {
                    };
                    if(src.unprotected !== null)
                    {
                        const parsed = ng.result.steel.MemberTemperatureUnprotected.toObject(src.unprotected);
                        if(parsed === null) return null;
                        dst.unprotected = parsed;
                    }
                    if(src.protected !== null)
                    {
                        const parsed = ng.result.steel.MemberTemperatureProtected.toObject(src.protected);
                        if(parsed === null) return null;
                        dst.protected = parsed;
                    }
                    return dst;
                }

                static create(src?: FireParameters_createType) {
                    const dst = new FireParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.unprotected !== undefined) {
                        dst.unprotected = src.unprotected;
                    }
                    if (src.protected !== undefined) {
                        dst.protected = src.protected;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FireParameters();
                    dst.unprotected = this.unprotected;
                    dst.protected = this.protected;
                    return dst;
                }

                deepClone() {
                    const json = FireParameters.toObject(this);
                    const dst = FireParameters.fromObject(json);
                    return dst;
                }
            }
            export type IFireParameters = FireParameters;


            export type ExtraParameters_keys = 'extraSections' | 'extraMaterials' | 'extraFire' | 'extraMaterialsFire';
            export interface ExtraParameters_createType {
                extraSections?: ng.result.steel.SectionParameters | null,
                extraMaterials?: ng.result.steel.MaterialParameters | null,
                extraFire?: ng.result.steel.FireParameters | null,
                extraMaterialsFire?: ng.result.steel.MaterialFireParameters | null,
            }
            export interface ExtraParameters_json {
                extraSections?: ng.result.steel.SectionParameters_json;
                extraMaterials?: ng.result.steel.MaterialParameters_json;
                extraFire?: ng.result.steel.FireParameters_json;
                extraMaterialsFire?: ng.result.steel.MaterialFireParameters_json;
            }
            interface ExtraParameters_json_in {
                __proto_name?: unknown;
                extraSections?: unknown;
                extraMaterials?: unknown;
                extraFire?: unknown;
                extraMaterialsFire?: unknown;
            }
            export class ExtraParameters {
                __proto_name = "ng.result.steel.ExtraParameters";
                extraSections: ng.result.steel.SectionParameters | null = null;
                extraMaterials: ng.result.steel.MaterialParameters | null = null;
                extraFire: ng.result.steel.FireParameters | null = null;
                extraMaterialsFire: ng.result.steel.MaterialFireParameters | null = null;

                static fromObject(src_unknown: unknown): ExtraParameters {
                    const dst = new ExtraParameters();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ExtraParameters but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ExtraParameters_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ExtraParameters but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.extraSections !== undefined && src.extraSections !== null) {
                        dst.extraSections = ng.result.steel.SectionParameters.fromObject(src.extraSections);
                    }
                    if (src.extraMaterials !== undefined && src.extraMaterials !== null) {
                        dst.extraMaterials = ng.result.steel.MaterialParameters.fromObject(src.extraMaterials);
                    }
                    if (src.extraFire !== undefined && src.extraFire !== null) {
                        dst.extraFire = ng.result.steel.FireParameters.fromObject(src.extraFire);
                    }
                    if (src.extraMaterialsFire !== undefined && src.extraMaterialsFire !== null) {
                        dst.extraMaterialsFire = ng.result.steel.MaterialFireParameters.fromObject(src.extraMaterialsFire);
                    }
                    return dst;
                }

                static toObject(src: ExtraParameters | null | undefined): ExtraParameters_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.ExtraParameters is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.ExtraParameters") {
                        console.error('Expected ng.result.steel.ExtraParameters but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ExtraParameters_json = {
                    };
                    if(src.extraSections !== null)
                    {
                        const parsed = ng.result.steel.SectionParameters.toObject(src.extraSections);
                        if(parsed === null) return null;
                        dst.extraSections = parsed;
                    }
                    if(src.extraMaterials !== null)
                    {
                        const parsed = ng.result.steel.MaterialParameters.toObject(src.extraMaterials);
                        if(parsed === null) return null;
                        dst.extraMaterials = parsed;
                    }
                    if(src.extraFire !== null)
                    {
                        const parsed = ng.result.steel.FireParameters.toObject(src.extraFire);
                        if(parsed === null) return null;
                        dst.extraFire = parsed;
                    }
                    if(src.extraMaterialsFire !== null)
                    {
                        const parsed = ng.result.steel.MaterialFireParameters.toObject(src.extraMaterialsFire);
                        if(parsed === null) return null;
                        dst.extraMaterialsFire = parsed;
                    }
                    return dst;
                }

                static create(src?: ExtraParameters_createType) {
                    const dst = new ExtraParameters();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.extraSections !== undefined) {
                        dst.extraSections = src.extraSections;
                    }
                    if (src.extraMaterials !== undefined) {
                        dst.extraMaterials = src.extraMaterials;
                    }
                    if (src.extraFire !== undefined) {
                        dst.extraFire = src.extraFire;
                    }
                    if (src.extraMaterialsFire !== undefined) {
                        dst.extraMaterialsFire = src.extraMaterialsFire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ExtraParameters();
                    dst.extraSections = this.extraSections;
                    dst.extraMaterials = this.extraMaterials;
                    dst.extraFire = this.extraFire;
                    dst.extraMaterialsFire = this.extraMaterialsFire;
                    return dst;
                }

                deepClone() {
                    const json = ExtraParameters.toObject(this);
                    const dst = ExtraParameters.fromObject(json);
                    return dst;
                }
            }
            export type IExtraParameters = ExtraParameters;


            export type Data_keys = 'sectionClass' | 'sectionResult';
            export interface Data_createType {
                sectionClass?: ng.result.steel.SectionClass | null,
                sectionResult?: ng.result.steel.SectionResult | null,
            }
            export interface Data_json {
                sectionClass?: ng.result.steel.SectionClass_json;
                sectionResult?: ng.result.steel.SectionResult_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                sectionClass?: unknown;
                sectionResult?: unknown;
            }
            export class Data {
                __proto_name = "ng.result.steel.Data";
                sectionClass: ng.result.steel.SectionClass | null = null;
                sectionResult: ng.result.steel.SectionResult | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sectionClass !== undefined && src.sectionClass !== null) {
                        dst.sectionClass = ng.result.steel.SectionClass.fromObject(src.sectionClass);
                    }
                    if (src.sectionResult !== undefined && src.sectionResult !== null) {
                        dst.sectionResult = ng.result.steel.SectionResult.fromObject(src.sectionResult);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Data") {
                        console.error('Expected ng.result.steel.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                    };
                    if(src.sectionClass !== null)
                    {
                        const parsed = ng.result.steel.SectionClass.toObject(src.sectionClass);
                        if(parsed === null) return null;
                        dst.sectionClass = parsed;
                    }
                    if(src.sectionResult !== null)
                    {
                        const parsed = ng.result.steel.SectionResult.toObject(src.sectionResult);
                        if(parsed === null) return null;
                        dst.sectionResult = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sectionClass !== undefined) {
                        dst.sectionClass = src.sectionClass;
                    }
                    if (src.sectionResult !== undefined) {
                        dst.sectionResult = src.sectionResult;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.sectionClass = this.sectionClass;
                    dst.sectionResult = this.sectionResult;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;


            export type Element_keys = 'maxOfControls';
            export interface Element_createType {
                maxOfControls?: ng.result.control.ControlData[],
            }
            export interface Element_json {
                maxOfControls: ng.result.control.ControlData_json[];
            }
            interface Element_json_in {
                __proto_name?: unknown;
                maxOfControls?: unknown;
            }
            export class Element {
                __proto_name = "ng.result.steel.Element";
                maxOfControls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): Element {
                    const dst = new Element();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Element but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Element_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.maxOfControls !== undefined && src.maxOfControls !== null) {
                        if (Array.isArray(src.maxOfControls)) {
                            for (const element of src.maxOfControls) {
                                dst.maxOfControls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected maxOfControls of Element to be a array but was ', typeof src.maxOfControls, src.maxOfControls)
                        }
                    }
                    return dst;
                }

                static toObject(src: Element | null | undefined): Element_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.Element is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.Element") {
                        console.error('Expected ng.result.steel.Element but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Element_json = {
                        maxOfControls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if (src.maxOfControls !== null) {
                        for (const element of src.maxOfControls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.maxOfControls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: Element_createType) {
                    const dst = new Element();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.maxOfControls !== undefined) {
                        dst.maxOfControls = src.maxOfControls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Element();
                    dst.maxOfControls = this.maxOfControls;
                    return dst;
                }

                deepClone() {
                    const json = Element.toObject(this);
                    const dst = Element.fromObject(json);
                    return dst;
                }
            }
            export type IElement = Element;


            export type DesignSummary_keys = 'elemGuid' | 'varyingBar' | 'virtualStiffeners' | 'bucklingShapes' | 'torsionalSharpe' | 'nAValues' | 'interactionMethod' | 'gasTemperature' | 'kappa' | 'extraParameters' | 'controls';
            export interface DesignSummary_createType {
                elemGuid?: string,
                varyingBar?: ng.result.steel.BarSectionType,
                virtualStiffeners?: ng.result.steel.VirtualStiffeners | null,
                bucklingShapes?: ng.result.steel.BucklingShapes | null,
                torsionalSharpe?: ng.result.steel.ShearResistanceEnum,
                nAValues?: ng.result.steel.SteelDesignNationalAnnexValues | null,
                interactionMethod?: ng.design.steel.InteractionMethod,
                gasTemperature?: ng.result.steel.GasTemperature | null,
                kappa?: ng.geometry.Vector2D | null,
                extraParameters?: ng.result.steel.ExtraParameters[],
                controls?: ng.result.control.ControlData[],
            }
            export interface DesignSummary_json {
                elemGuid?: string;
                varyingBar?: string;
                virtualStiffeners?: ng.result.steel.VirtualStiffeners_json;
                bucklingShapes?: ng.result.steel.BucklingShapes_json;
                torsionalSharpe?: string;
                nAValues?: ng.result.steel.SteelDesignNationalAnnexValues_json;
                interactionMethod?: string;
                gasTemperature?: ng.result.steel.GasTemperature_json;
                kappa?: ng.geometry.Vector2D_json;
                extraParameters: ng.result.steel.ExtraParameters_json[];
                controls: ng.result.control.ControlData_json[];
            }
            interface DesignSummary_json_in {
                __proto_name?: unknown;
                elemGuid?: unknown;
                varyingBar?: unknown;
                virtualStiffeners?: unknown;
                bucklingShapes?: unknown;
                torsionalSharpe?: unknown;
                nAValues?: unknown;
                interactionMethod?: unknown;
                gasTemperature?: unknown;
                kappa?: unknown;
                extraParameters?: unknown;
                controls?: unknown;
            }
            export class DesignSummary {
                __proto_name = "ng.result.steel.DesignSummary";
                elemGuid: string = "";
                varyingBar: ng.result.steel.BarSectionType = ng.result.steel.BarSectionType.BAR_SECTION_TYPE_UNSPECIFIED;
                virtualStiffeners: ng.result.steel.VirtualStiffeners | null = null;
                bucklingShapes: ng.result.steel.BucklingShapes | null = null;
                torsionalSharpe: ng.result.steel.ShearResistanceEnum = ng.result.steel.ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED;
                nAValues: ng.result.steel.SteelDesignNationalAnnexValues | null = null;
                interactionMethod: ng.design.steel.InteractionMethod = ng.design.steel.InteractionMethod.INTERACTION_METHOD_UNSPECIFIED;
                gasTemperature: ng.result.steel.GasTemperature | null = null;
                kappa: ng.geometry.Vector2D | null = null;
                extraParameters: ng.result.steel.ExtraParameters[] = [];
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): DesignSummary {
                    const dst = new DesignSummary();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignSummary but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignSummary_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignSummary but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elemGuid !== undefined && src.elemGuid !== null) {
                        if (typeof src.elemGuid === "string") {
                            dst.elemGuid = src.elemGuid;
                        }
                        else {
                            console.log('Expected elemGuid of DesignSummary to be a string but was ', typeof src.elemGuid, src.elemGuid)
                        }
                    }
                    if (src.varyingBar !== undefined && src.varyingBar !== null) {
                        dst.varyingBar = ng.result.steel.BarSectionType_FromObject(src.varyingBar);
                    }
                    if (src.virtualStiffeners !== undefined && src.virtualStiffeners !== null) {
                        dst.virtualStiffeners = ng.result.steel.VirtualStiffeners.fromObject(src.virtualStiffeners);
                    }
                    if (src.bucklingShapes !== undefined && src.bucklingShapes !== null) {
                        dst.bucklingShapes = ng.result.steel.BucklingShapes.fromObject(src.bucklingShapes);
                    }
                    if (src.torsionalSharpe !== undefined && src.torsionalSharpe !== null) {
                        dst.torsionalSharpe = ng.result.steel.ShearResistanceEnum_FromObject(src.torsionalSharpe);
                    }
                    if (src.nAValues !== undefined && src.nAValues !== null) {
                        dst.nAValues = ng.result.steel.SteelDesignNationalAnnexValues.fromObject(src.nAValues);
                    }
                    if (src.interactionMethod !== undefined && src.interactionMethod !== null) {
                        dst.interactionMethod = ng.design.steel.InteractionMethod_FromObject(src.interactionMethod);
                    }
                    if (src.gasTemperature !== undefined && src.gasTemperature !== null) {
                        dst.gasTemperature = ng.result.steel.GasTemperature.fromObject(src.gasTemperature);
                    }
                    if (src.kappa !== undefined && src.kappa !== null) {
                        dst.kappa = ng.geometry.Vector2D.fromObject(src.kappa);
                    }
                    if (src.extraParameters !== undefined && src.extraParameters !== null) {
                        if (Array.isArray(src.extraParameters)) {
                            for (const element of src.extraParameters) {
                                dst.extraParameters.push(ng.result.steel.ExtraParameters.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected extraParameters of DesignSummary to be a array but was ', typeof src.extraParameters, src.extraParameters)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of DesignSummary to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignSummary | null | undefined): DesignSummary_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.steel.DesignSummary is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.steel.DesignSummary") {
                        console.error('Expected ng.result.steel.DesignSummary but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const varyingBar_obj = ng.result.steel.BarSectionType_ToObject(src.varyingBar);
                    if(varyingBar_obj === null) return null;

                    const torsionalSharpe_obj = ng.result.steel.ShearResistanceEnum_ToObject(src.torsionalSharpe);
                    if(torsionalSharpe_obj === null) return null;

                    const interactionMethod_obj = ng.design.steel.InteractionMethod_ToObject(src.interactionMethod);
                    if(interactionMethod_obj === null) return null;

                    const dst : DesignSummary_json = {
                        elemGuid: src.elemGuid,
                        varyingBar: varyingBar_obj,
                        torsionalSharpe: torsionalSharpe_obj,
                        interactionMethod: interactionMethod_obj,
                        extraParameters: new Array<ng.result.steel.ExtraParameters_json>(),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.virtualStiffeners !== null)
                    {
                        const parsed = ng.result.steel.VirtualStiffeners.toObject(src.virtualStiffeners);
                        if(parsed === null) return null;
                        dst.virtualStiffeners = parsed;
                    }
                    if(src.bucklingShapes !== null)
                    {
                        const parsed = ng.result.steel.BucklingShapes.toObject(src.bucklingShapes);
                        if(parsed === null) return null;
                        dst.bucklingShapes = parsed;
                    }
                    if(src.nAValues !== null)
                    {
                        const parsed = ng.result.steel.SteelDesignNationalAnnexValues.toObject(src.nAValues);
                        if(parsed === null) return null;
                        dst.nAValues = parsed;
                    }
                    if(src.gasTemperature !== null)
                    {
                        const parsed = ng.result.steel.GasTemperature.toObject(src.gasTemperature);
                        if(parsed === null) return null;
                        dst.gasTemperature = parsed;
                    }
                    if(src.kappa !== null)
                    {
                        const parsed = ng.geometry.Vector2D.toObject(src.kappa);
                        if(parsed === null) return null;
                        dst.kappa = parsed;
                    }
                    if (src.extraParameters !== null) {
                        for (const element of src.extraParameters) {
                            const parsed = ng.result.steel.ExtraParameters.toObject(element);
                            if(parsed === null) return null;
                            dst.extraParameters.push(parsed);
                        }
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: DesignSummary_createType) {
                    const dst = new DesignSummary();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elemGuid !== undefined) {
                        dst.elemGuid = src.elemGuid;
                    }
                    if (src.varyingBar !== undefined) {
                        dst.varyingBar = src.varyingBar;
                    }
                    if (src.virtualStiffeners !== undefined) {
                        dst.virtualStiffeners = src.virtualStiffeners;
                    }
                    if (src.bucklingShapes !== undefined) {
                        dst.bucklingShapes = src.bucklingShapes;
                    }
                    if (src.torsionalSharpe !== undefined) {
                        dst.torsionalSharpe = src.torsionalSharpe;
                    }
                    if (src.nAValues !== undefined) {
                        dst.nAValues = src.nAValues;
                    }
                    if (src.interactionMethod !== undefined) {
                        dst.interactionMethod = src.interactionMethod;
                    }
                    if (src.gasTemperature !== undefined) {
                        dst.gasTemperature = src.gasTemperature;
                    }
                    if (src.kappa !== undefined) {
                        dst.kappa = src.kappa;
                    }
                    if (src.extraParameters !== undefined) {
                        dst.extraParameters = src.extraParameters;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignSummary();
                    dst.elemGuid = this.elemGuid;
                    dst.varyingBar = this.varyingBar;
                    dst.virtualStiffeners = this.virtualStiffeners;
                    dst.bucklingShapes = this.bucklingShapes;
                    dst.torsionalSharpe = this.torsionalSharpe;
                    dst.nAValues = this.nAValues;
                    dst.interactionMethod = this.interactionMethod;
                    dst.gasTemperature = this.gasTemperature;
                    dst.kappa = this.kappa;
                    dst.extraParameters = this.extraParameters;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = DesignSummary.toObject(this);
                    const dst = DesignSummary.fromObject(json);
                    return dst;
                }
            }
            export type IDesignSummary = DesignSummary;
        } // namespace steel


        // Defined in Result/pile.proto
        export namespace pile {
            export enum ControlType {
                CONTROL_TYPE_UNSPECIFIED = 0,
                CONTROL_TYPE_OVERALL = 1,
                CONTROL_TYPE_TENSION = 2,
                CONTROL_TYPE_COMPRESSION = 3
            }
            export const ControlType_FromObject = (src: unknown): ControlType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CONTROL_TYPE_UNSPECIFIED':
                        return ControlType.CONTROL_TYPE_UNSPECIFIED;
                    case 1:
                    case 'CONTROL_TYPE_OVERALL':
                        return ControlType.CONTROL_TYPE_OVERALL;
                    case 2:
                    case 'CONTROL_TYPE_TENSION':
                        return ControlType.CONTROL_TYPE_TENSION;
                    case 3:
                    case 'CONTROL_TYPE_COMPRESSION':
                        return ControlType.CONTROL_TYPE_COMPRESSION;
                    default:
                        console.log('Unhandled value for ControlType:' + src + '. ' + typeof(src));
                        return ControlType.CONTROL_TYPE_UNSPECIFIED;
                }
            };
            export const ControlType_ToObject = (src: ControlType): string | null => {
                switch (src) {
                    case ControlType.CONTROL_TYPE_UNSPECIFIED:
                        return 'CONTROL_TYPE_UNSPECIFIED';
                    case ControlType.CONTROL_TYPE_OVERALL:
                        return 'CONTROL_TYPE_OVERALL';
                    case ControlType.CONTROL_TYPE_TENSION:
                        return 'CONTROL_TYPE_TENSION';
                    case ControlType.CONTROL_TYPE_COMPRESSION:
                        return 'CONTROL_TYPE_COMPRESSION';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ControlType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum AnalysisType {
                ANALYSIS_TYPE_UNSPECIFIED = 0,
                ANALYSIS_TYPE_NORMAL = 1,
                ANALYSIS_TYPE_SOIL_PUNCHING = 2
            }
            export const AnalysisType_FromObject = (src: unknown): AnalysisType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ANALYSIS_TYPE_UNSPECIFIED':
                        return AnalysisType.ANALYSIS_TYPE_UNSPECIFIED;
                    case 1:
                    case 'ANALYSIS_TYPE_NORMAL':
                        return AnalysisType.ANALYSIS_TYPE_NORMAL;
                    case 2:
                    case 'ANALYSIS_TYPE_SOIL_PUNCHING':
                        return AnalysisType.ANALYSIS_TYPE_SOIL_PUNCHING;
                    default:
                        console.log('Unhandled value for AnalysisType:' + src + '. ' + typeof(src));
                        return AnalysisType.ANALYSIS_TYPE_UNSPECIFIED;
                }
            };
            export const AnalysisType_ToObject = (src: AnalysisType): string | null => {
                switch (src) {
                    case AnalysisType.ANALYSIS_TYPE_UNSPECIFIED:
                        return 'ANALYSIS_TYPE_UNSPECIFIED';
                    case AnalysisType.ANALYSIS_TYPE_NORMAL:
                        return 'ANALYSIS_TYPE_NORMAL';
                    case AnalysisType.ANALYSIS_TYPE_SOIL_PUNCHING:
                        return 'ANALYSIS_TYPE_SOIL_PUNCHING';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for AnalysisType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum DesignType {
                DESIGN_TYPE_UNSPECIFIED = 0,
                DESIGN_TYPE_UNDRAINED = 1,
                DESIGN_TYPE_DRAINED = 2,
                DESIGN_TYPE_ROCK = 3
            }
            export const DesignType_FromObject = (src: unknown): DesignType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'DESIGN_TYPE_UNSPECIFIED':
                        return DesignType.DESIGN_TYPE_UNSPECIFIED;
                    case 1:
                    case 'DESIGN_TYPE_UNDRAINED':
                        return DesignType.DESIGN_TYPE_UNDRAINED;
                    case 2:
                    case 'DESIGN_TYPE_DRAINED':
                        return DesignType.DESIGN_TYPE_DRAINED;
                    case 3:
                    case 'DESIGN_TYPE_ROCK':
                        return DesignType.DESIGN_TYPE_ROCK;
                    default:
                        console.log('Unhandled value for DesignType:' + src + '. ' + typeof(src));
                        return DesignType.DESIGN_TYPE_UNSPECIFIED;
                }
            };
            export const DesignType_ToObject = (src: DesignType): string | null => {
                switch (src) {
                    case DesignType.DESIGN_TYPE_UNSPECIFIED:
                        return 'DESIGN_TYPE_UNSPECIFIED';
                    case DesignType.DESIGN_TYPE_UNDRAINED:
                        return 'DESIGN_TYPE_UNDRAINED';
                    case DesignType.DESIGN_TYPE_DRAINED:
                        return 'DESIGN_TYPE_DRAINED';
                    case DesignType.DESIGN_TYPE_ROCK:
                        return 'DESIGN_TYPE_ROCK';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for DesignType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type ControlData_keys = 'localCoordsys' | 'type' | 'value';
            export interface ControlData_createType {
                localCoordsys?: boolean,
                type?: ng.result.pile.ControlType[],
                value?: number[],
            }
            export interface ControlData_json {
                localCoordsys?: boolean;
                type: string[];
                value: JsonNumber[];
            }
            interface ControlData_json_in {
                __proto_name?: unknown;
                localCoordsys?: unknown;
                type?: unknown;
                value?: unknown;
            }
            export class ControlData {
                __proto_name = "ng.result.pile.ControlData";
                localCoordsys: boolean = false;
                type: ng.result.pile.ControlType[] = [];
                value: number[] = [];

                static fromObject(src_unknown: unknown): ControlData {
                    const dst = new ControlData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ControlData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ControlData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ControlData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.localCoordsys !== undefined && src.localCoordsys !== null) {
                        if (typeof src.localCoordsys === "boolean") {
                            dst.localCoordsys = src.localCoordsys;
                        }
                        else {
                            console.log('Expected localCoordsys of ControlData to be a boolean but was ', typeof src.localCoordsys, src.localCoordsys)
                        }
                    }
                    if (src.type !== undefined && src.type !== null) {
                        if (Array.isArray(src.type)) {
                            for (const element of src.type) {
                                dst.type.push(ng.result.pile.ControlType_FromObject(element));
                            }
                        }
                        else {
                            console.log('Expected type of ControlData to be a array but was ', typeof src.type, src.type)
                        }
                    }
                    if (src.value !== undefined && src.value !== null) {
                        if (Array.isArray(src.value)) {
                            for (const [index, element] of src.value.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.value.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected value of ControlData[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected value of ControlData to be a array but was ', typeof src.value, src.value)
                        }
                    }
                    return dst;
                }

                static toObject(src: ControlData | null | undefined): ControlData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.ControlData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.ControlData") {
                        console.error('Expected ng.result.pile.ControlData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ControlData_json = {
                        localCoordsys: src.localCoordsys,
                        type: new Array<string>(),
                        value: new Array<JsonNumber>(),
                    };
                    if (src.type !== null) {
                        for (const element of src.type) {
                            const parsed = ng.result.pile.ControlType_ToObject(element);
                            if(parsed === null) return null;
                            dst.type.push(parsed);
                        }
                    }
                    if (src.value !== null) {
                        for (const element of src.value) {
                            dst.value.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: ControlData_createType) {
                    const dst = new ControlData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.localCoordsys !== undefined) {
                        dst.localCoordsys = src.localCoordsys;
                    }
                    if (src.type !== undefined) {
                        dst.type = src.type;
                    }
                    if (src.value !== undefined) {
                        dst.value = src.value;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ControlData();
                    dst.localCoordsys = this.localCoordsys;
                    dst.type = this.type;
                    dst.value = this.value;
                    return dst;
                }

                deepClone() {
                    const json = ControlData.toObject(this);
                    const dst = ControlData.fromObject(json);
                    return dst;
                }
            }
            export type IControlData = ControlData;


            export type ControlCapacities_keys = 'data';
            export interface ControlCapacities_createType {
                data?: ng.result.pile.ControlData | null,
            }
            export interface ControlCapacities_json {
                data?: ng.result.pile.ControlData_json;
            }
            interface ControlCapacities_json_in {
                __proto_name?: unknown;
                data?: unknown;
            }
            export class ControlCapacities {
                __proto_name = "ng.result.pile.ControlCapacities";
                data: ng.result.pile.ControlData | null = null;

                static fromObject(src_unknown: unknown): ControlCapacities {
                    const dst = new ControlCapacities();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ControlCapacities but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ControlCapacities_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ControlCapacities but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.data !== undefined && src.data !== null) {
                        dst.data = ng.result.pile.ControlData.fromObject(src.data);
                    }
                    return dst;
                }

                static toObject(src: ControlCapacities | null | undefined): ControlCapacities_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.ControlCapacities is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.ControlCapacities") {
                        console.error('Expected ng.result.pile.ControlCapacities but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ControlCapacities_json = {
                    };
                    if(src.data !== null)
                    {
                        const parsed = ng.result.pile.ControlData.toObject(src.data);
                        if(parsed === null) return null;
                        dst.data = parsed;
                    }
                    return dst;
                }

                static create(src?: ControlCapacities_createType) {
                    const dst = new ControlCapacities();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.data !== undefined) {
                        dst.data = src.data;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ControlCapacities();
                    dst.data = this.data;
                    return dst;
                }

                deepClone() {
                    const json = ControlCapacities.toObject(this);
                    const dst = ControlCapacities.fromObject(json);
                    return dst;
                }
            }
            export type IControlCapacities = ControlCapacities;


            export type ControlUtilization_keys = 'forces';
            export interface ControlUtilization_createType {
                forces?: ng.result.pile.ControlData | null,
            }
            export interface ControlUtilization_json {
                forces?: ng.result.pile.ControlData_json;
            }
            interface ControlUtilization_json_in {
                __proto_name?: unknown;
                forces?: unknown;
            }
            export class ControlUtilization {
                __proto_name = "ng.result.pile.ControlUtilization";
                forces: ng.result.pile.ControlData | null = null;

                static fromObject(src_unknown: unknown): ControlUtilization {
                    const dst = new ControlUtilization();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ControlUtilization but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ControlUtilization_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ControlUtilization but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.forces !== undefined && src.forces !== null) {
                        dst.forces = ng.result.pile.ControlData.fromObject(src.forces);
                    }
                    return dst;
                }

                static toObject(src: ControlUtilization | null | undefined): ControlUtilization_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.ControlUtilization is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.ControlUtilization") {
                        console.error('Expected ng.result.pile.ControlUtilization but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ControlUtilization_json = {
                    };
                    if(src.forces !== null)
                    {
                        const parsed = ng.result.pile.ControlData.toObject(src.forces);
                        if(parsed === null) return null;
                        dst.forces = parsed;
                    }
                    return dst;
                }

                static create(src?: ControlUtilization_createType) {
                    const dst = new ControlUtilization();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.forces !== undefined) {
                        dst.forces = src.forces;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ControlUtilization();
                    dst.forces = this.forces;
                    return dst;
                }

                deepClone() {
                    const json = ControlUtilization.toObject(this);
                    const dst = ControlUtilization.fromObject(json);
                    return dst;
                }
            }
            export type IControlUtilization = ControlUtilization;


            export type ControlDistribution_keys = 'capacities' | 'utilizations';
            export interface ControlDistribution_createType {
                capacities?: ng.result.pile.ControlCapacities | null,
                utilizations?: ng.result.pile.ControlUtilization | null,
            }
            export interface ControlDistribution_json {
                capacities?: ng.result.pile.ControlCapacities_json;
                utilizations?: ng.result.pile.ControlUtilization_json;
            }
            interface ControlDistribution_json_in {
                __proto_name?: unknown;
                capacities?: unknown;
                utilizations?: unknown;
            }
            export class ControlDistribution {
                __proto_name = "ng.result.pile.ControlDistribution";
                capacities: ng.result.pile.ControlCapacities | null = null;
                utilizations: ng.result.pile.ControlUtilization | null = null;

                static fromObject(src_unknown: unknown): ControlDistribution {
                    const dst = new ControlDistribution();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ControlDistribution but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ControlDistribution_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ControlDistribution but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.capacities !== undefined && src.capacities !== null) {
                        dst.capacities = ng.result.pile.ControlCapacities.fromObject(src.capacities);
                    }
                    if (src.utilizations !== undefined && src.utilizations !== null) {
                        dst.utilizations = ng.result.pile.ControlUtilization.fromObject(src.utilizations);
                    }
                    return dst;
                }

                static toObject(src: ControlDistribution | null | undefined): ControlDistribution_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.ControlDistribution is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.ControlDistribution") {
                        console.error('Expected ng.result.pile.ControlDistribution but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ControlDistribution_json = {
                    };
                    if(src.capacities !== null)
                    {
                        const parsed = ng.result.pile.ControlCapacities.toObject(src.capacities);
                        if(parsed === null) return null;
                        dst.capacities = parsed;
                    }
                    if(src.utilizations !== null)
                    {
                        const parsed = ng.result.pile.ControlUtilization.toObject(src.utilizations);
                        if(parsed === null) return null;
                        dst.utilizations = parsed;
                    }
                    return dst;
                }

                static create(src?: ControlDistribution_createType) {
                    const dst = new ControlDistribution();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.capacities !== undefined) {
                        dst.capacities = src.capacities;
                    }
                    if (src.utilizations !== undefined) {
                        dst.utilizations = src.utilizations;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ControlDistribution();
                    dst.capacities = this.capacities;
                    dst.utilizations = this.utilizations;
                    return dst;
                }

                deepClone() {
                    const json = ControlDistribution.toObject(this);
                    const dst = ControlDistribution.fromObject(json);
                    return dst;
                }
            }
            export type IControlDistribution = ControlDistribution;


            export type DesignSummary_keys = 'elemGuid';
            export interface DesignSummary_createType {
                elemGuid?: string,
            }
            export interface DesignSummary_json {
                elemGuid?: string;
            }
            interface DesignSummary_json_in {
                __proto_name?: unknown;
                elemGuid?: unknown;
            }
            export class DesignSummary {
                __proto_name = "ng.result.pile.DesignSummary";
                elemGuid: string = "";

                static fromObject(src_unknown: unknown): DesignSummary {
                    const dst = new DesignSummary();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignSummary but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignSummary_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignSummary but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elemGuid !== undefined && src.elemGuid !== null) {
                        if (typeof src.elemGuid === "string") {
                            dst.elemGuid = src.elemGuid;
                        }
                        else {
                            console.log('Expected elemGuid of DesignSummary to be a string but was ', typeof src.elemGuid, src.elemGuid)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignSummary | null | undefined): DesignSummary_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.DesignSummary is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.DesignSummary") {
                        console.error('Expected ng.result.pile.DesignSummary but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DesignSummary_json = {
                        elemGuid: src.elemGuid,
                    };
                    return dst;
                }

                static create(src?: DesignSummary_createType) {
                    const dst = new DesignSummary();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elemGuid !== undefined) {
                        dst.elemGuid = src.elemGuid;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignSummary();
                    dst.elemGuid = this.elemGuid;
                    return dst;
                }

                deepClone() {
                    const json = DesignSummary.toObject(this);
                    const dst = DesignSummary.fromObject(json);
                    return dst;
                }
            }
            export type IDesignSummary = DesignSummary;


            export type FoundationForce_keys = 'hx' | 'hy' | 'v' | 'mx' | 'my' | 't';
            export interface FoundationForce_createType {
                hx?: number,
                hy?: number,
                v?: number,
                mx?: number,
                my?: number,
                t?: number,
            }
            export interface FoundationForce_json {
                hx?: JsonNumber;
                hy?: JsonNumber;
                v?: JsonNumber;
                mx?: JsonNumber;
                my?: JsonNumber;
                t?: JsonNumber;
            }
            interface FoundationForce_json_in {
                __proto_name?: unknown;
                hx?: unknown;
                hy?: unknown;
                v?: unknown;
                mx?: unknown;
                my?: unknown;
                t?: unknown;
            }
            export class FoundationForce {
                __proto_name = "ng.result.pile.FoundationForce";
                hx: number = 0;
                hy: number = 0;
                v: number = 0;
                mx: number = 0;
                my: number = 0;
                t: number = 0;

                static fromObject(src_unknown: unknown): FoundationForce {
                    const dst = new FoundationForce();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FoundationForce but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FoundationForce_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FoundationForce but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.hx !== undefined && src.hx !== null) {
                        if (typeof src.hx === "number" || src.hx === 'NaN' || src.hx === 'Infinity' || src.hx === '-Infinity') {
                            dst.hx = AsNum(src.hx);
                        }
                        else {
                            console.log('Expected hx of FoundationForce to be a number but was ', typeof src.hx, src.hx)
                        }
                    }
                    if (src.hy !== undefined && src.hy !== null) {
                        if (typeof src.hy === "number" || src.hy === 'NaN' || src.hy === 'Infinity' || src.hy === '-Infinity') {
                            dst.hy = AsNum(src.hy);
                        }
                        else {
                            console.log('Expected hy of FoundationForce to be a number but was ', typeof src.hy, src.hy)
                        }
                    }
                    if (src.v !== undefined && src.v !== null) {
                        if (typeof src.v === "number" || src.v === 'NaN' || src.v === 'Infinity' || src.v === '-Infinity') {
                            dst.v = AsNum(src.v);
                        }
                        else {
                            console.log('Expected v of FoundationForce to be a number but was ', typeof src.v, src.v)
                        }
                    }
                    if (src.mx !== undefined && src.mx !== null) {
                        if (typeof src.mx === "number" || src.mx === 'NaN' || src.mx === 'Infinity' || src.mx === '-Infinity') {
                            dst.mx = AsNum(src.mx);
                        }
                        else {
                            console.log('Expected mx of FoundationForce to be a number but was ', typeof src.mx, src.mx)
                        }
                    }
                    if (src.my !== undefined && src.my !== null) {
                        if (typeof src.my === "number" || src.my === 'NaN' || src.my === 'Infinity' || src.my === '-Infinity') {
                            dst.my = AsNum(src.my);
                        }
                        else {
                            console.log('Expected my of FoundationForce to be a number but was ', typeof src.my, src.my)
                        }
                    }
                    if (src.t !== undefined && src.t !== null) {
                        if (typeof src.t === "number" || src.t === 'NaN' || src.t === 'Infinity' || src.t === '-Infinity') {
                            dst.t = AsNum(src.t);
                        }
                        else {
                            console.log('Expected t of FoundationForce to be a number but was ', typeof src.t, src.t)
                        }
                    }
                    return dst;
                }

                static toObject(src: FoundationForce | null | undefined): FoundationForce_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.FoundationForce is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.FoundationForce") {
                        console.error('Expected ng.result.pile.FoundationForce but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FoundationForce_json = {
                        hx: AsJsonNum(src.hx),
                        hy: AsJsonNum(src.hy),
                        v: AsJsonNum(src.v),
                        mx: AsJsonNum(src.mx),
                        my: AsJsonNum(src.my),
                        t: AsJsonNum(src.t),
                    };
                    return dst;
                }

                static create(src?: FoundationForce_createType) {
                    const dst = new FoundationForce();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.hx !== undefined) {
                        dst.hx = src.hx;
                    }
                    if (src.hy !== undefined) {
                        dst.hy = src.hy;
                    }
                    if (src.v !== undefined) {
                        dst.v = src.v;
                    }
                    if (src.mx !== undefined) {
                        dst.mx = src.mx;
                    }
                    if (src.my !== undefined) {
                        dst.my = src.my;
                    }
                    if (src.t !== undefined) {
                        dst.t = src.t;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FoundationForce();
                    dst.hx = this.hx;
                    dst.hy = this.hy;
                    dst.v = this.v;
                    dst.mx = this.mx;
                    dst.my = this.my;
                    dst.t = this.t;
                    return dst;
                }

                deepClone() {
                    const json = FoundationForce.toObject(this);
                    const dst = FoundationForce.fromObject(json);
                    return dst;
                }
            }
            export type IFoundationForce = FoundationForce;


            export type DetailedPileAnalysis_keys = 'id' | 'analysisType' | 'load' | 'selfweight' | 'selfweightEffective' | 'foundationForce' | 'settlement';
            export interface DetailedPileAnalysis_createType {
                id?: ng.utils.ID | null,
                analysisType?: ng.result.pile.AnalysisType,
                load?: ng.result.foundation.FoundationForce | null,
                selfweight?: ng.result.foundation.FoundationForce | null,
                selfweightEffective?: ng.result.foundation.FoundationForce | null,
                foundationForce?: ng.result.foundation.FoundationForce | null,
                settlement?: number,
            }
            export interface DetailedPileAnalysis_json {
                id?: ng.utils.ID_json;
                analysisType?: string;
                load?: ng.result.foundation.FoundationForce_json;
                selfweight?: ng.result.foundation.FoundationForce_json;
                selfweightEffective?: ng.result.foundation.FoundationForce_json;
                foundationForce?: ng.result.foundation.FoundationForce_json;
                settlement?: JsonNumber;
            }
            interface DetailedPileAnalysis_json_in {
                __proto_name?: unknown;
                id?: unknown;
                analysisType?: unknown;
                load?: unknown;
                selfweight?: unknown;
                selfweightEffective?: unknown;
                foundationForce?: unknown;
                settlement?: unknown;
            }
            export class DetailedPileAnalysis {
                __proto_name = "ng.result.pile.DetailedPileAnalysis";
                id: ng.utils.ID | null = null;
                analysisType: ng.result.pile.AnalysisType = ng.result.pile.AnalysisType.ANALYSIS_TYPE_UNSPECIFIED;
                load: ng.result.foundation.FoundationForce | null = null;
                selfweight: ng.result.foundation.FoundationForce | null = null;
                selfweightEffective: ng.result.foundation.FoundationForce | null = null;
                foundationForce: ng.result.foundation.FoundationForce | null = null;
                settlement: number = 0;

                static fromObject(src_unknown: unknown): DetailedPileAnalysis {
                    const dst = new DetailedPileAnalysis();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DetailedPileAnalysis but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DetailedPileAnalysis_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DetailedPileAnalysis but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.analysisType !== undefined && src.analysisType !== null) {
                        dst.analysisType = ng.result.pile.AnalysisType_FromObject(src.analysisType);
                    }
                    if (src.load !== undefined && src.load !== null) {
                        dst.load = ng.result.foundation.FoundationForce.fromObject(src.load);
                    }
                    if (src.selfweight !== undefined && src.selfweight !== null) {
                        dst.selfweight = ng.result.foundation.FoundationForce.fromObject(src.selfweight);
                    }
                    if (src.selfweightEffective !== undefined && src.selfweightEffective !== null) {
                        dst.selfweightEffective = ng.result.foundation.FoundationForce.fromObject(src.selfweightEffective);
                    }
                    if (src.foundationForce !== undefined && src.foundationForce !== null) {
                        dst.foundationForce = ng.result.foundation.FoundationForce.fromObject(src.foundationForce);
                    }
                    if (src.settlement !== undefined && src.settlement !== null) {
                        if (typeof src.settlement === "number" || src.settlement === 'NaN' || src.settlement === 'Infinity' || src.settlement === '-Infinity') {
                            dst.settlement = AsNum(src.settlement);
                        }
                        else {
                            console.log('Expected settlement of DetailedPileAnalysis to be a number but was ', typeof src.settlement, src.settlement)
                        }
                    }
                    return dst;
                }

                static toObject(src: DetailedPileAnalysis | null | undefined): DetailedPileAnalysis_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.DetailedPileAnalysis is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.DetailedPileAnalysis") {
                        console.error('Expected ng.result.pile.DetailedPileAnalysis but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const analysisType_obj = ng.result.pile.AnalysisType_ToObject(src.analysisType);
                    if(analysisType_obj === null) return null;

                    const dst : DetailedPileAnalysis_json = {
                        analysisType: analysisType_obj,
                        settlement: AsJsonNum(src.settlement),
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.load !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.load);
                        if(parsed === null) return null;
                        dst.load = parsed;
                    }
                    if(src.selfweight !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.selfweight);
                        if(parsed === null) return null;
                        dst.selfweight = parsed;
                    }
                    if(src.selfweightEffective !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.selfweightEffective);
                        if(parsed === null) return null;
                        dst.selfweightEffective = parsed;
                    }
                    if(src.foundationForce !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.foundationForce);
                        if(parsed === null) return null;
                        dst.foundationForce = parsed;
                    }
                    return dst;
                }

                static create(src?: DetailedPileAnalysis_createType) {
                    const dst = new DetailedPileAnalysis();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.analysisType !== undefined) {
                        dst.analysisType = src.analysisType;
                    }
                    if (src.load !== undefined) {
                        dst.load = src.load;
                    }
                    if (src.selfweight !== undefined) {
                        dst.selfweight = src.selfweight;
                    }
                    if (src.selfweightEffective !== undefined) {
                        dst.selfweightEffective = src.selfweightEffective;
                    }
                    if (src.foundationForce !== undefined) {
                        dst.foundationForce = src.foundationForce;
                    }
                    if (src.settlement !== undefined) {
                        dst.settlement = src.settlement;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DetailedPileAnalysis();
                    dst.id = this.id;
                    dst.analysisType = this.analysisType;
                    dst.load = this.load;
                    dst.selfweight = this.selfweight;
                    dst.selfweightEffective = this.selfweightEffective;
                    dst.foundationForce = this.foundationForce;
                    dst.settlement = this.settlement;
                    return dst;
                }

                deepClone() {
                    const json = DetailedPileAnalysis.toObject(this);
                    const dst = DetailedPileAnalysis.fromObject(json);
                    return dst;
                }
            }
            export type IDetailedPileAnalysis = DetailedPileAnalysis;


            export type DesignStrength_keys = 'cuk' | 'phik' | 'phid' | 'nc' | 'nq' | 'rk';
            export interface DesignStrength_createType {
                cuk?: number,
                phik?: number,
                phid?: number,
                nc?: number,
                nq?: number,
                rk?: number,
            }
            export interface DesignStrength_json {
                cuk?: JsonNumber;
                phik?: JsonNumber;
                phid?: JsonNumber;
                nc?: JsonNumber;
                nq?: JsonNumber;
                rk?: JsonNumber;
            }
            interface DesignStrength_json_in {
                __proto_name?: unknown;
                cuk?: unknown;
                phik?: unknown;
                phid?: unknown;
                nc?: unknown;
                nq?: unknown;
                rk?: unknown;
            }
            export class DesignStrength {
                __proto_name = "ng.result.pile.DesignStrength";
                cuk: number = 0;
                phik: number = 0;
                phid: number = 0;
                nc: number = 0;
                nq: number = 0;
                rk: number = 0;

                static fromObject(src_unknown: unknown): DesignStrength {
                    const dst = new DesignStrength();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignStrength but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignStrength_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignStrength but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.cuk !== undefined && src.cuk !== null) {
                        if (typeof src.cuk === "number" || src.cuk === 'NaN' || src.cuk === 'Infinity' || src.cuk === '-Infinity') {
                            dst.cuk = AsNum(src.cuk);
                        }
                        else {
                            console.log('Expected cuk of DesignStrength to be a number but was ', typeof src.cuk, src.cuk)
                        }
                    }
                    if (src.phik !== undefined && src.phik !== null) {
                        if (typeof src.phik === "number" || src.phik === 'NaN' || src.phik === 'Infinity' || src.phik === '-Infinity') {
                            dst.phik = AsNum(src.phik);
                        }
                        else {
                            console.log('Expected phik of DesignStrength to be a number but was ', typeof src.phik, src.phik)
                        }
                    }
                    if (src.phid !== undefined && src.phid !== null) {
                        if (typeof src.phid === "number" || src.phid === 'NaN' || src.phid === 'Infinity' || src.phid === '-Infinity') {
                            dst.phid = AsNum(src.phid);
                        }
                        else {
                            console.log('Expected phid of DesignStrength to be a number but was ', typeof src.phid, src.phid)
                        }
                    }
                    if (src.nc !== undefined && src.nc !== null) {
                        if (typeof src.nc === "number" || src.nc === 'NaN' || src.nc === 'Infinity' || src.nc === '-Infinity') {
                            dst.nc = AsNum(src.nc);
                        }
                        else {
                            console.log('Expected nc of DesignStrength to be a number but was ', typeof src.nc, src.nc)
                        }
                    }
                    if (src.nq !== undefined && src.nq !== null) {
                        if (typeof src.nq === "number" || src.nq === 'NaN' || src.nq === 'Infinity' || src.nq === '-Infinity') {
                            dst.nq = AsNum(src.nq);
                        }
                        else {
                            console.log('Expected nq of DesignStrength to be a number but was ', typeof src.nq, src.nq)
                        }
                    }
                    if (src.rk !== undefined && src.rk !== null) {
                        if (typeof src.rk === "number" || src.rk === 'NaN' || src.rk === 'Infinity' || src.rk === '-Infinity') {
                            dst.rk = AsNum(src.rk);
                        }
                        else {
                            console.log('Expected rk of DesignStrength to be a number but was ', typeof src.rk, src.rk)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignStrength | null | undefined): DesignStrength_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.DesignStrength is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.DesignStrength") {
                        console.error('Expected ng.result.pile.DesignStrength but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DesignStrength_json = {
                        cuk: AsJsonNum(src.cuk),
                        phik: AsJsonNum(src.phik),
                        phid: AsJsonNum(src.phid),
                        nc: AsJsonNum(src.nc),
                        nq: AsJsonNum(src.nq),
                        rk: AsJsonNum(src.rk),
                    };
                    return dst;
                }

                static create(src?: DesignStrength_createType) {
                    const dst = new DesignStrength();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.cuk !== undefined) {
                        dst.cuk = src.cuk;
                    }
                    if (src.phik !== undefined) {
                        dst.phik = src.phik;
                    }
                    if (src.phid !== undefined) {
                        dst.phid = src.phid;
                    }
                    if (src.nc !== undefined) {
                        dst.nc = src.nc;
                    }
                    if (src.nq !== undefined) {
                        dst.nq = src.nq;
                    }
                    if (src.rk !== undefined) {
                        dst.rk = src.rk;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignStrength();
                    dst.cuk = this.cuk;
                    dst.phik = this.phik;
                    dst.phid = this.phid;
                    dst.nc = this.nc;
                    dst.nq = this.nq;
                    dst.rk = this.rk;
                    return dst;
                }

                deepClone() {
                    const json = DesignStrength.toObject(this);
                    const dst = DesignStrength.fromObject(json);
                    return dst;
                }
            }
            export type IDesignStrength = DesignStrength;


            export type PileResDetailed_keys = 'qc' | 'qt' | 'qb' | 'qsc' | 'qst' | 'negLoad' | 'qscLayer' | 'qstLayer' | 'negLoadLayer';
            export interface PileResDetailed_createType {
                qc?: number,
                qt?: number,
                qb?: number,
                qsc?: number,
                qst?: number,
                negLoad?: number,
                qscLayer?: number[],
                qstLayer?: number[],
                negLoadLayer?: number[],
            }
            export interface PileResDetailed_json {
                qc?: JsonNumber;
                qt?: JsonNumber;
                qb?: JsonNumber;
                qsc?: JsonNumber;
                qst?: JsonNumber;
                negLoad?: JsonNumber;
                qscLayer: JsonNumber[];
                qstLayer: JsonNumber[];
                negLoadLayer: JsonNumber[];
            }
            interface PileResDetailed_json_in {
                __proto_name?: unknown;
                qc?: unknown;
                qt?: unknown;
                qb?: unknown;
                qsc?: unknown;
                qst?: unknown;
                negLoad?: unknown;
                qscLayer?: unknown;
                qstLayer?: unknown;
                negLoadLayer?: unknown;
            }
            export class PileResDetailed {
                __proto_name = "ng.result.pile.PileResDetailed";
                qc: number = 0;
                qt: number = 0;
                qb: number = 0;
                qsc: number = 0;
                qst: number = 0;
                negLoad: number = 0;
                qscLayer: number[] = [];
                qstLayer: number[] = [];
                negLoadLayer: number[] = [];

                static fromObject(src_unknown: unknown): PileResDetailed {
                    const dst = new PileResDetailed();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PileResDetailed but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PileResDetailed_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PileResDetailed but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.qc !== undefined && src.qc !== null) {
                        if (typeof src.qc === "number" || src.qc === 'NaN' || src.qc === 'Infinity' || src.qc === '-Infinity') {
                            dst.qc = AsNum(src.qc);
                        }
                        else {
                            console.log('Expected qc of PileResDetailed to be a number but was ', typeof src.qc, src.qc)
                        }
                    }
                    if (src.qt !== undefined && src.qt !== null) {
                        if (typeof src.qt === "number" || src.qt === 'NaN' || src.qt === 'Infinity' || src.qt === '-Infinity') {
                            dst.qt = AsNum(src.qt);
                        }
                        else {
                            console.log('Expected qt of PileResDetailed to be a number but was ', typeof src.qt, src.qt)
                        }
                    }
                    if (src.qb !== undefined && src.qb !== null) {
                        if (typeof src.qb === "number" || src.qb === 'NaN' || src.qb === 'Infinity' || src.qb === '-Infinity') {
                            dst.qb = AsNum(src.qb);
                        }
                        else {
                            console.log('Expected qb of PileResDetailed to be a number but was ', typeof src.qb, src.qb)
                        }
                    }
                    if (src.qsc !== undefined && src.qsc !== null) {
                        if (typeof src.qsc === "number" || src.qsc === 'NaN' || src.qsc === 'Infinity' || src.qsc === '-Infinity') {
                            dst.qsc = AsNum(src.qsc);
                        }
                        else {
                            console.log('Expected qsc of PileResDetailed to be a number but was ', typeof src.qsc, src.qsc)
                        }
                    }
                    if (src.qst !== undefined && src.qst !== null) {
                        if (typeof src.qst === "number" || src.qst === 'NaN' || src.qst === 'Infinity' || src.qst === '-Infinity') {
                            dst.qst = AsNum(src.qst);
                        }
                        else {
                            console.log('Expected qst of PileResDetailed to be a number but was ', typeof src.qst, src.qst)
                        }
                    }
                    if (src.negLoad !== undefined && src.negLoad !== null) {
                        if (typeof src.negLoad === "number" || src.negLoad === 'NaN' || src.negLoad === 'Infinity' || src.negLoad === '-Infinity') {
                            dst.negLoad = AsNum(src.negLoad);
                        }
                        else {
                            console.log('Expected negLoad of PileResDetailed to be a number but was ', typeof src.negLoad, src.negLoad)
                        }
                    }
                    if (src.qscLayer !== undefined && src.qscLayer !== null) {
                        if (Array.isArray(src.qscLayer)) {
                            for (const [index, element] of src.qscLayer.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.qscLayer.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected qscLayer of PileResDetailed[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected qscLayer of PileResDetailed to be a array but was ', typeof src.qscLayer, src.qscLayer)
                        }
                    }
                    if (src.qstLayer !== undefined && src.qstLayer !== null) {
                        if (Array.isArray(src.qstLayer)) {
                            for (const [index, element] of src.qstLayer.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.qstLayer.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected qstLayer of PileResDetailed[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected qstLayer of PileResDetailed to be a array but was ', typeof src.qstLayer, src.qstLayer)
                        }
                    }
                    if (src.negLoadLayer !== undefined && src.negLoadLayer !== null) {
                        if (Array.isArray(src.negLoadLayer)) {
                            for (const [index, element] of src.negLoadLayer.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.negLoadLayer.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected negLoadLayer of PileResDetailed[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected negLoadLayer of PileResDetailed to be a array but was ', typeof src.negLoadLayer, src.negLoadLayer)
                        }
                    }
                    return dst;
                }

                static toObject(src: PileResDetailed | null | undefined): PileResDetailed_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.PileResDetailed is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.PileResDetailed") {
                        console.error('Expected ng.result.pile.PileResDetailed but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PileResDetailed_json = {
                        qc: AsJsonNum(src.qc),
                        qt: AsJsonNum(src.qt),
                        qb: AsJsonNum(src.qb),
                        qsc: AsJsonNum(src.qsc),
                        qst: AsJsonNum(src.qst),
                        negLoad: AsJsonNum(src.negLoad),
                        qscLayer: new Array<JsonNumber>(),
                        qstLayer: new Array<JsonNumber>(),
                        negLoadLayer: new Array<JsonNumber>(),
                    };
                    if (src.qscLayer !== null) {
                        for (const element of src.qscLayer) {
                            dst.qscLayer.push(AsJsonNum(element));
                        }
                    }
                    if (src.qstLayer !== null) {
                        for (const element of src.qstLayer) {
                            dst.qstLayer.push(AsJsonNum(element));
                        }
                    }
                    if (src.negLoadLayer !== null) {
                        for (const element of src.negLoadLayer) {
                            dst.negLoadLayer.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: PileResDetailed_createType) {
                    const dst = new PileResDetailed();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.qc !== undefined) {
                        dst.qc = src.qc;
                    }
                    if (src.qt !== undefined) {
                        dst.qt = src.qt;
                    }
                    if (src.qb !== undefined) {
                        dst.qb = src.qb;
                    }
                    if (src.qsc !== undefined) {
                        dst.qsc = src.qsc;
                    }
                    if (src.qst !== undefined) {
                        dst.qst = src.qst;
                    }
                    if (src.negLoad !== undefined) {
                        dst.negLoad = src.negLoad;
                    }
                    if (src.qscLayer !== undefined) {
                        dst.qscLayer = src.qscLayer;
                    }
                    if (src.qstLayer !== undefined) {
                        dst.qstLayer = src.qstLayer;
                    }
                    if (src.negLoadLayer !== undefined) {
                        dst.negLoadLayer = src.negLoadLayer;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PileResDetailed();
                    dst.qc = this.qc;
                    dst.qt = this.qt;
                    dst.qb = this.qb;
                    dst.qsc = this.qsc;
                    dst.qst = this.qst;
                    dst.negLoad = this.negLoad;
                    dst.qscLayer = this.qscLayer;
                    dst.qstLayer = this.qstLayer;
                    dst.negLoadLayer = this.negLoadLayer;
                    return dst;
                }

                deepClone() {
                    const json = PileResDetailed.toObject(this);
                    const dst = PileResDetailed.fromObject(json);
                    return dst;
                }
            }
            export type IPileResDetailed = PileResDetailed;


            export type PileRes_keys = 'caracteristicPileResult' | 'designPileResult' | 'utilization' | 'qsNegLoad' | 'qsNegLoadLayer';
            export interface PileRes_createType {
                caracteristicPileResult?: ng.result.pile.PileResDetailed | null,
                designPileResult?: ng.result.pile.PileResDetailed | null,
                utilization?: number,
                qsNegLoad?: number,
                qsNegLoadLayer?: number[],
            }
            export interface PileRes_json {
                caracteristicPileResult?: ng.result.pile.PileResDetailed_json;
                designPileResult?: ng.result.pile.PileResDetailed_json;
                utilization?: JsonNumber;
                qsNegLoad?: JsonNumber;
                qsNegLoadLayer: JsonNumber[];
            }
            interface PileRes_json_in {
                __proto_name?: unknown;
                caracteristicPileResult?: unknown;
                designPileResult?: unknown;
                utilization?: unknown;
                qsNegLoad?: unknown;
                qsNegLoadLayer?: unknown;
            }
            export class PileRes {
                __proto_name = "ng.result.pile.PileRes";
                caracteristicPileResult: ng.result.pile.PileResDetailed | null = null;
                designPileResult: ng.result.pile.PileResDetailed | null = null;
                utilization: number = 0;
                qsNegLoad: number = 0;
                qsNegLoadLayer: number[] = [];

                static fromObject(src_unknown: unknown): PileRes {
                    const dst = new PileRes();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PileRes but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PileRes_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PileRes but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.caracteristicPileResult !== undefined && src.caracteristicPileResult !== null) {
                        dst.caracteristicPileResult = ng.result.pile.PileResDetailed.fromObject(src.caracteristicPileResult);
                    }
                    if (src.designPileResult !== undefined && src.designPileResult !== null) {
                        dst.designPileResult = ng.result.pile.PileResDetailed.fromObject(src.designPileResult);
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of PileRes to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.qsNegLoad !== undefined && src.qsNegLoad !== null) {
                        if (typeof src.qsNegLoad === "number" || src.qsNegLoad === 'NaN' || src.qsNegLoad === 'Infinity' || src.qsNegLoad === '-Infinity') {
                            dst.qsNegLoad = AsNum(src.qsNegLoad);
                        }
                        else {
                            console.log('Expected qsNegLoad of PileRes to be a number but was ', typeof src.qsNegLoad, src.qsNegLoad)
                        }
                    }
                    if (src.qsNegLoadLayer !== undefined && src.qsNegLoadLayer !== null) {
                        if (Array.isArray(src.qsNegLoadLayer)) {
                            for (const [index, element] of src.qsNegLoadLayer.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.qsNegLoadLayer.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected qsNegLoadLayer of PileRes[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected qsNegLoadLayer of PileRes to be a array but was ', typeof src.qsNegLoadLayer, src.qsNegLoadLayer)
                        }
                    }
                    return dst;
                }

                static toObject(src: PileRes | null | undefined): PileRes_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.PileRes is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.PileRes") {
                        console.error('Expected ng.result.pile.PileRes but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PileRes_json = {
                        utilization: AsJsonNum(src.utilization),
                        qsNegLoad: AsJsonNum(src.qsNegLoad),
                        qsNegLoadLayer: new Array<JsonNumber>(),
                    };
                    if(src.caracteristicPileResult !== null)
                    {
                        const parsed = ng.result.pile.PileResDetailed.toObject(src.caracteristicPileResult);
                        if(parsed === null) return null;
                        dst.caracteristicPileResult = parsed;
                    }
                    if(src.designPileResult !== null)
                    {
                        const parsed = ng.result.pile.PileResDetailed.toObject(src.designPileResult);
                        if(parsed === null) return null;
                        dst.designPileResult = parsed;
                    }
                    if (src.qsNegLoadLayer !== null) {
                        for (const element of src.qsNegLoadLayer) {
                            dst.qsNegLoadLayer.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: PileRes_createType) {
                    const dst = new PileRes();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.caracteristicPileResult !== undefined) {
                        dst.caracteristicPileResult = src.caracteristicPileResult;
                    }
                    if (src.designPileResult !== undefined) {
                        dst.designPileResult = src.designPileResult;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.qsNegLoad !== undefined) {
                        dst.qsNegLoad = src.qsNegLoad;
                    }
                    if (src.qsNegLoadLayer !== undefined) {
                        dst.qsNegLoadLayer = src.qsNegLoadLayer;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PileRes();
                    dst.caracteristicPileResult = this.caracteristicPileResult;
                    dst.designPileResult = this.designPileResult;
                    dst.utilization = this.utilization;
                    dst.qsNegLoad = this.qsNegLoad;
                    dst.qsNegLoadLayer = this.qsNegLoadLayer;
                    return dst;
                }

                deepClone() {
                    const json = PileRes.toObject(this);
                    const dst = PileRes.fromObject(json);
                    return dst;
                }
            }
            export type IPileRes = PileRes;


            export type DetailedPileDesign_keys = 'id' | 'analysisType' | 'designType' | 'bearingResult' | 'designStrength' | 'controls';
            export interface DetailedPileDesign_createType {
                id?: ng.utils.ID | null,
                analysisType?: ng.result.pile.AnalysisType,
                designType?: ng.result.pile.DesignType,
                bearingResult?: ng.result.pile.PileRes | null,
                designStrength?: ng.result.pile.DesignStrength | null,
                controls?: ng.result.pile.ControlDistribution | null,
            }
            export interface DetailedPileDesign_json {
                id?: ng.utils.ID_json;
                analysisType?: string;
                designType?: string;
                bearingResult?: ng.result.pile.PileRes_json;
                designStrength?: ng.result.pile.DesignStrength_json;
                controls?: ng.result.pile.ControlDistribution_json;
            }
            interface DetailedPileDesign_json_in {
                __proto_name?: unknown;
                id?: unknown;
                analysisType?: unknown;
                designType?: unknown;
                bearingResult?: unknown;
                designStrength?: unknown;
                controls?: unknown;
            }
            export class DetailedPileDesign {
                __proto_name = "ng.result.pile.DetailedPileDesign";
                id: ng.utils.ID | null = null;
                analysisType: ng.result.pile.AnalysisType = ng.result.pile.AnalysisType.ANALYSIS_TYPE_UNSPECIFIED;
                designType: ng.result.pile.DesignType = ng.result.pile.DesignType.DESIGN_TYPE_UNSPECIFIED;
                bearingResult: ng.result.pile.PileRes | null = null;
                designStrength: ng.result.pile.DesignStrength | null = null;
                controls: ng.result.pile.ControlDistribution | null = null;

                static fromObject(src_unknown: unknown): DetailedPileDesign {
                    const dst = new DetailedPileDesign();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DetailedPileDesign but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DetailedPileDesign_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DetailedPileDesign but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.analysisType !== undefined && src.analysisType !== null) {
                        dst.analysisType = ng.result.pile.AnalysisType_FromObject(src.analysisType);
                    }
                    if (src.designType !== undefined && src.designType !== null) {
                        dst.designType = ng.result.pile.DesignType_FromObject(src.designType);
                    }
                    if (src.bearingResult !== undefined && src.bearingResult !== null) {
                        dst.bearingResult = ng.result.pile.PileRes.fromObject(src.bearingResult);
                    }
                    if (src.designStrength !== undefined && src.designStrength !== null) {
                        dst.designStrength = ng.result.pile.DesignStrength.fromObject(src.designStrength);
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        dst.controls = ng.result.pile.ControlDistribution.fromObject(src.controls);
                    }
                    return dst;
                }

                static toObject(src: DetailedPileDesign | null | undefined): DetailedPileDesign_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.DetailedPileDesign is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.DetailedPileDesign") {
                        console.error('Expected ng.result.pile.DetailedPileDesign but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const analysisType_obj = ng.result.pile.AnalysisType_ToObject(src.analysisType);
                    if(analysisType_obj === null) return null;

                    const designType_obj = ng.result.pile.DesignType_ToObject(src.designType);
                    if(designType_obj === null) return null;

                    const dst : DetailedPileDesign_json = {
                        analysisType: analysisType_obj,
                        designType: designType_obj,
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.bearingResult !== null)
                    {
                        const parsed = ng.result.pile.PileRes.toObject(src.bearingResult);
                        if(parsed === null) return null;
                        dst.bearingResult = parsed;
                    }
                    if(src.designStrength !== null)
                    {
                        const parsed = ng.result.pile.DesignStrength.toObject(src.designStrength);
                        if(parsed === null) return null;
                        dst.designStrength = parsed;
                    }
                    if(src.controls !== null)
                    {
                        const parsed = ng.result.pile.ControlDistribution.toObject(src.controls);
                        if(parsed === null) return null;
                        dst.controls = parsed;
                    }
                    return dst;
                }

                static create(src?: DetailedPileDesign_createType) {
                    const dst = new DetailedPileDesign();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.analysisType !== undefined) {
                        dst.analysisType = src.analysisType;
                    }
                    if (src.designType !== undefined) {
                        dst.designType = src.designType;
                    }
                    if (src.bearingResult !== undefined) {
                        dst.bearingResult = src.bearingResult;
                    }
                    if (src.designStrength !== undefined) {
                        dst.designStrength = src.designStrength;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DetailedPileDesign();
                    dst.id = this.id;
                    dst.analysisType = this.analysisType;
                    dst.designType = this.designType;
                    dst.bearingResult = this.bearingResult;
                    dst.designStrength = this.designStrength;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = DetailedPileDesign.toObject(this);
                    const dst = DetailedPileDesign.fromObject(json);
                    return dst;
                }
            }
            export type IDetailedPileDesign = DetailedPileDesign;


            export type Data_keys = 'resultAnalysis' | 'resultDesign' | 'utilization';
            export interface Data_createType {
                resultAnalysis?: ng.result.pile.DetailedPileAnalysis[],
                resultDesign?: ng.result.pile.DetailedPileDesign[],
                utilization?: number,
            }
            export interface Data_json {
                resultAnalysis: ng.result.pile.DetailedPileAnalysis_json[];
                resultDesign: ng.result.pile.DetailedPileDesign_json[];
                utilization?: JsonNumber;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                resultAnalysis?: unknown;
                resultDesign?: unknown;
                utilization?: unknown;
            }
            export class Data {
                __proto_name = "ng.result.pile.Data";
                resultAnalysis: ng.result.pile.DetailedPileAnalysis[] = [];
                resultDesign: ng.result.pile.DetailedPileDesign[] = [];
                utilization: number = 0;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.resultAnalysis !== undefined && src.resultAnalysis !== null) {
                        if (Array.isArray(src.resultAnalysis)) {
                            for (const element of src.resultAnalysis) {
                                dst.resultAnalysis.push(ng.result.pile.DetailedPileAnalysis.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultAnalysis of Data to be a array but was ', typeof src.resultAnalysis, src.resultAnalysis)
                        }
                    }
                    if (src.resultDesign !== undefined && src.resultDesign !== null) {
                        if (Array.isArray(src.resultDesign)) {
                            for (const element of src.resultDesign) {
                                dst.resultDesign.push(ng.result.pile.DetailedPileDesign.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultDesign of Data to be a array but was ', typeof src.resultDesign, src.resultDesign)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Data to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.Data") {
                        console.error('Expected ng.result.pile.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                        resultAnalysis: new Array<ng.result.pile.DetailedPileAnalysis_json>(),
                        resultDesign: new Array<ng.result.pile.DetailedPileDesign_json>(),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if (src.resultAnalysis !== null) {
                        for (const element of src.resultAnalysis) {
                            const parsed = ng.result.pile.DetailedPileAnalysis.toObject(element);
                            if(parsed === null) return null;
                            dst.resultAnalysis.push(parsed);
                        }
                    }
                    if (src.resultDesign !== null) {
                        for (const element of src.resultDesign) {
                            const parsed = ng.result.pile.DetailedPileDesign.toObject(element);
                            if(parsed === null) return null;
                            dst.resultDesign.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.resultAnalysis !== undefined) {
                        dst.resultAnalysis = src.resultAnalysis;
                    }
                    if (src.resultDesign !== undefined) {
                        dst.resultDesign = src.resultDesign;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.resultAnalysis = this.resultAnalysis;
                    dst.resultDesign = this.resultDesign;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;


            export type Element_keys = unknown;
            export interface Element_createType {
            }
            export interface Element_json {
            }
            interface Element_json_in {
                __proto_name?: unknown;
            }
            export class Element {
                __proto_name = "ng.result.pile.Element";

                static fromObject(src_unknown: unknown): Element {
                    const dst = new Element();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Element but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Element_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: Element | null | undefined): Element_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.pile.Element is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.pile.Element") {
                        console.error('Expected ng.result.pile.Element but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Element_json = {
                    };
                    return dst;
                }

                static create(src?: Element_createType) {
                    const dst = new Element();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Element();
                    return dst;
                }

                deepClone() {
                    const json = Element.toObject(this);
                    const dst = Element.fromObject(json);
                    return dst;
                }
            }
            export type IElement = Element;
        } // namespace pile


        // Defined in Result/control.proto
        export namespace control {
            export enum AnalysisTypeFoundation {
                ANALYSIS_TYPE_UNSPECIFIED = 0,
                ANALYSIS_TYPE_NORMAL = 1,
                ANALYSIS_TYPE_SOIL_PUNCHING = 2
            }
            export const AnalysisTypeFoundation_FromObject = (src: unknown): AnalysisTypeFoundation => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ANALYSIS_TYPE_UNSPECIFIED':
                        return AnalysisTypeFoundation.ANALYSIS_TYPE_UNSPECIFIED;
                    case 1:
                    case 'ANALYSIS_TYPE_NORMAL':
                        return AnalysisTypeFoundation.ANALYSIS_TYPE_NORMAL;
                    case 2:
                    case 'ANALYSIS_TYPE_SOIL_PUNCHING':
                        return AnalysisTypeFoundation.ANALYSIS_TYPE_SOIL_PUNCHING;
                    default:
                        console.log('Unhandled value for AnalysisTypeFoundation:' + src + '. ' + typeof(src));
                        return AnalysisTypeFoundation.ANALYSIS_TYPE_UNSPECIFIED;
                }
            };
            export const AnalysisTypeFoundation_ToObject = (src: AnalysisTypeFoundation): string | null => {
                switch (src) {
                    case AnalysisTypeFoundation.ANALYSIS_TYPE_UNSPECIFIED:
                        return 'ANALYSIS_TYPE_UNSPECIFIED';
                    case AnalysisTypeFoundation.ANALYSIS_TYPE_NORMAL:
                        return 'ANALYSIS_TYPE_NORMAL';
                    case AnalysisTypeFoundation.ANALYSIS_TYPE_SOIL_PUNCHING:
                        return 'ANALYSIS_TYPE_SOIL_PUNCHING';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for AnalysisTypeFoundation, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum DesignTypeFoundation {
                DESIGN_TYPE_UNSPECIFIED = 0,
                DESIGN_TYPE_UNDRAINED = 1,
                DESIGN_TYPE_DRAINED = 2,
                DESIGN_TYPE_ROCK = 3,
                DESIGN_TYPE_ALLOWEDSOILPRESSURE = 4,
                DESIGN_TYPE_UNDRAINED_PUNCHING = 5,
                DESIGN_TYPE_DRAINED_PUNCHNING_B6 = 6,
                DESIGN_TYPE_DRAINED_PUNCHNING_ALT = 7
            }
            export const DesignTypeFoundation_FromObject = (src: unknown): DesignTypeFoundation => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'DESIGN_TYPE_UNSPECIFIED':
                        return DesignTypeFoundation.DESIGN_TYPE_UNSPECIFIED;
                    case 1:
                    case 'DESIGN_TYPE_UNDRAINED':
                        return DesignTypeFoundation.DESIGN_TYPE_UNDRAINED;
                    case 2:
                    case 'DESIGN_TYPE_DRAINED':
                        return DesignTypeFoundation.DESIGN_TYPE_DRAINED;
                    case 3:
                    case 'DESIGN_TYPE_ROCK':
                        return DesignTypeFoundation.DESIGN_TYPE_ROCK;
                    case 4:
                    case 'DESIGN_TYPE_ALLOWEDSOILPRESSURE':
                        return DesignTypeFoundation.DESIGN_TYPE_ALLOWEDSOILPRESSURE;
                    case 5:
                    case 'DESIGN_TYPE_UNDRAINED_PUNCHING':
                        return DesignTypeFoundation.DESIGN_TYPE_UNDRAINED_PUNCHING;
                    case 6:
                    case 'DESIGN_TYPE_DRAINED_PUNCHNING_B6':
                        return DesignTypeFoundation.DESIGN_TYPE_DRAINED_PUNCHNING_B6;
                    case 7:
                    case 'DESIGN_TYPE_DRAINED_PUNCHNING_ALT':
                        return DesignTypeFoundation.DESIGN_TYPE_DRAINED_PUNCHNING_ALT;
                    default:
                        console.log('Unhandled value for DesignTypeFoundation:' + src + '. ' + typeof(src));
                        return DesignTypeFoundation.DESIGN_TYPE_UNSPECIFIED;
                }
            };
            export const DesignTypeFoundation_ToObject = (src: DesignTypeFoundation): string | null => {
                switch (src) {
                    case DesignTypeFoundation.DESIGN_TYPE_UNSPECIFIED:
                        return 'DESIGN_TYPE_UNSPECIFIED';
                    case DesignTypeFoundation.DESIGN_TYPE_UNDRAINED:
                        return 'DESIGN_TYPE_UNDRAINED';
                    case DesignTypeFoundation.DESIGN_TYPE_DRAINED:
                        return 'DESIGN_TYPE_DRAINED';
                    case DesignTypeFoundation.DESIGN_TYPE_ROCK:
                        return 'DESIGN_TYPE_ROCK';
                    case DesignTypeFoundation.DESIGN_TYPE_ALLOWEDSOILPRESSURE:
                        return 'DESIGN_TYPE_ALLOWEDSOILPRESSURE';
                    case DesignTypeFoundation.DESIGN_TYPE_UNDRAINED_PUNCHING:
                        return 'DESIGN_TYPE_UNDRAINED_PUNCHING';
                    case DesignTypeFoundation.DESIGN_TYPE_DRAINED_PUNCHNING_B6:
                        return 'DESIGN_TYPE_DRAINED_PUNCHNING_B6';
                    case DesignTypeFoundation.DESIGN_TYPE_DRAINED_PUNCHNING_ALT:
                        return 'DESIGN_TYPE_DRAINED_PUNCHNING_ALT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for DesignTypeFoundation, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum EccentricityTypeFoundation {
                ECCENTRICITY_TYPE_UNSPECIFIED = 0,
                ECCENTRICITY_TYPE_NORMAL = 1,
                ECCENTRICITY_TYPE_HIGH = 2
            }
            export const EccentricityTypeFoundation_FromObject = (src: unknown): EccentricityTypeFoundation => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ECCENTRICITY_TYPE_UNSPECIFIED':
                        return EccentricityTypeFoundation.ECCENTRICITY_TYPE_UNSPECIFIED;
                    case 1:
                    case 'ECCENTRICITY_TYPE_NORMAL':
                        return EccentricityTypeFoundation.ECCENTRICITY_TYPE_NORMAL;
                    case 2:
                    case 'ECCENTRICITY_TYPE_HIGH':
                        return EccentricityTypeFoundation.ECCENTRICITY_TYPE_HIGH;
                    default:
                        console.log('Unhandled value for EccentricityTypeFoundation:' + src + '. ' + typeof(src));
                        return EccentricityTypeFoundation.ECCENTRICITY_TYPE_UNSPECIFIED;
                }
            };
            export const EccentricityTypeFoundation_ToObject = (src: EccentricityTypeFoundation): string | null => {
                switch (src) {
                    case EccentricityTypeFoundation.ECCENTRICITY_TYPE_UNSPECIFIED:
                        return 'ECCENTRICITY_TYPE_UNSPECIFIED';
                    case EccentricityTypeFoundation.ECCENTRICITY_TYPE_NORMAL:
                        return 'ECCENTRICITY_TYPE_NORMAL';
                    case EccentricityTypeFoundation.ECCENTRICITY_TYPE_HIGH:
                        return 'ECCENTRICITY_TYPE_HIGH';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for EccentricityTypeFoundation, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum CtrlTypeFoundation {
                CONTROL_TYPE_FOUNDATION_UNSPECIFIED = 0,
                CONTROL_TYPE_FOUNDATION_OVERALL = 1,
                CONTROL_TYPE_FOUNDATION_BEARING = 2,
                CONTROL_TYPE_FOUNDATION_SLIDING = 3,
                CONTROL_TYPE_FOUNDATION_SETTLEMENT = 4,
                CONTROL_TYPE_FOUNDATION_UPLIFT = 5,
                CONTROL_TYPE_FOUNDATION_OVERTURNING = 6,
                CONTROL_TYPE_FOUNDATION_UNREINFORCED = 7
            }
            export const CtrlTypeFoundation_FromObject = (src: unknown): CtrlTypeFoundation => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CONTROL_TYPE_FOUNDATION_UNSPECIFIED':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UNSPECIFIED;
                    case 1:
                    case 'CONTROL_TYPE_FOUNDATION_OVERALL':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_OVERALL;
                    case 2:
                    case 'CONTROL_TYPE_FOUNDATION_BEARING':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_BEARING;
                    case 3:
                    case 'CONTROL_TYPE_FOUNDATION_SLIDING':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_SLIDING;
                    case 4:
                    case 'CONTROL_TYPE_FOUNDATION_SETTLEMENT':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_SETTLEMENT;
                    case 5:
                    case 'CONTROL_TYPE_FOUNDATION_UPLIFT':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UPLIFT;
                    case 6:
                    case 'CONTROL_TYPE_FOUNDATION_OVERTURNING':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_OVERTURNING;
                    case 7:
                    case 'CONTROL_TYPE_FOUNDATION_UNREINFORCED':
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UNREINFORCED;
                    default:
                        console.log('Unhandled value for CtrlTypeFoundation:' + src + '. ' + typeof(src));
                        return CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UNSPECIFIED;
                }
            };
            export const CtrlTypeFoundation_ToObject = (src: CtrlTypeFoundation): string | null => {
                switch (src) {
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UNSPECIFIED:
                        return 'CONTROL_TYPE_FOUNDATION_UNSPECIFIED';
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_OVERALL:
                        return 'CONTROL_TYPE_FOUNDATION_OVERALL';
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_BEARING:
                        return 'CONTROL_TYPE_FOUNDATION_BEARING';
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_SLIDING:
                        return 'CONTROL_TYPE_FOUNDATION_SLIDING';
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_SETTLEMENT:
                        return 'CONTROL_TYPE_FOUNDATION_SETTLEMENT';
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UPLIFT:
                        return 'CONTROL_TYPE_FOUNDATION_UPLIFT';
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_OVERTURNING:
                        return 'CONTROL_TYPE_FOUNDATION_OVERTURNING';
                    case CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UNREINFORCED:
                        return 'CONTROL_TYPE_FOUNDATION_UNREINFORCED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for CtrlTypeFoundation, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ControlTypeConcrete {
                CONTROL_TYPE_CONCRETE_UNSPECIFIED = 0,
                CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M1 = 1,
                CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M1 = 2,
                CONTROL_TYPE_CONCRETE_MOMENT_M2 = 3,
                CONTROL_TYPE_CONCRETE_BIAXIAL_MOMENT = 4,
                CONTROL_TYPE_CONCRETE_AXIAL_FORCE = 5,
                CONTROL_TYPE_CONCRETE_SHEAR_FORCE = 6,
                CONTROL_TYPE_CONCRETE_SHEAR_FORCE_TOPPING = 7,
                CONTROL_TYPE_CONCRETE_TOPPING_JOINT = 8,
                CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH = 9,
                CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH = 10,
                CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS = 11,
                CONTROL_TYPE_CONCRETE_INITIAL_PRESTRESS = 12,
                CONTROL_TYPE_CONCRETE_STRESS_AFTER_RELEASE = 13,
                CONTROL_TYPE_CONCRETE_HOLLOWCORE_SPALLING = 14,
                CONTROL_TYPE_CONCRETE_TORSION_TRANSVERSE = 15,
                CONTROL_TYPE_CONCRETE_TORSION_LONGITUDINAL = 16,
                CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_TRANSVERSE = 17,
                CONTROL_TYPE_CONCRETE_TORSION_TENSION_TRANSVERSE = 18,
                CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_LONGITUDINAL = 19,
                CONTROL_TYPE_CONCRETE_COMPRESSION_COVER_CHECK = 20,
                CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS = 21,
                CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_TOPPING = 22,
                CONTROL_TYPE_CONCRETE_ANCHORAGE_TOP = 23,
                CONTROL_TYPE_CONCRETE_ANCHORAGE_BTM = 24,
                CONTROL_TYPE_CONCRETE_PUNCHING_COLUMN = 25,
                CONTROL_TYPE_CONCRETE_PUNCHING_PERIMETER = 26,
                CONTROL_TYPE_CONCRETE_DEFLECTION = 27,
                CONTROL_TYPE_CONCRETE_DSSSE = 28,
                CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M2 = 29,
                CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M2 = 30,
                CONTROL_TYPE_CONCRETE_SHEAR_FORCE_2 = 31,
                CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH_2 = 32,
                CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH_2 = 33,
                CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS_2 = 34,
                CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_2 = 35,
                CONTROL_TYPE_CONCRETE_DEFLECTION_2 = 36,
                CONTROL_TYPE_CONCRETE_MOMENT_M1 = 37
            }
            export const ControlTypeConcrete_FromObject = (src: unknown): ControlTypeConcrete => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CONTROL_TYPE_CONCRETE_UNSPECIFIED':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_UNSPECIFIED;
                    case 1:
                    case 'CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M1':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M1;
                    case 2:
                    case 'CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M1':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M1;
                    case 3:
                    case 'CONTROL_TYPE_CONCRETE_MOMENT_M2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_MOMENT_M2;
                    case 4:
                    case 'CONTROL_TYPE_CONCRETE_BIAXIAL_MOMENT':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_BIAXIAL_MOMENT;
                    case 5:
                    case 'CONTROL_TYPE_CONCRETE_AXIAL_FORCE':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_AXIAL_FORCE;
                    case 6:
                    case 'CONTROL_TYPE_CONCRETE_SHEAR_FORCE':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_FORCE;
                    case 7:
                    case 'CONTROL_TYPE_CONCRETE_SHEAR_FORCE_TOPPING':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_FORCE_TOPPING;
                    case 8:
                    case 'CONTROL_TYPE_CONCRETE_TOPPING_JOINT':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TOPPING_JOINT;
                    case 9:
                    case 'CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH;
                    case 10:
                    case 'CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH;
                    case 11:
                    case 'CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS;
                    case 12:
                    case 'CONTROL_TYPE_CONCRETE_INITIAL_PRESTRESS':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_INITIAL_PRESTRESS;
                    case 13:
                    case 'CONTROL_TYPE_CONCRETE_STRESS_AFTER_RELEASE':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_STRESS_AFTER_RELEASE;
                    case 14:
                    case 'CONTROL_TYPE_CONCRETE_HOLLOWCORE_SPALLING':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_HOLLOWCORE_SPALLING;
                    case 15:
                    case 'CONTROL_TYPE_CONCRETE_TORSION_TRANSVERSE':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_TRANSVERSE;
                    case 16:
                    case 'CONTROL_TYPE_CONCRETE_TORSION_LONGITUDINAL':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_LONGITUDINAL;
                    case 17:
                    case 'CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_TRANSVERSE':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_TRANSVERSE;
                    case 18:
                    case 'CONTROL_TYPE_CONCRETE_TORSION_TENSION_TRANSVERSE':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_TENSION_TRANSVERSE;
                    case 19:
                    case 'CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_LONGITUDINAL':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_LONGITUDINAL;
                    case 20:
                    case 'CONTROL_TYPE_CONCRETE_COMPRESSION_COVER_CHECK':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_COMPRESSION_COVER_CHECK;
                    case 21:
                    case 'CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS;
                    case 22:
                    case 'CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_TOPPING':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_TOPPING;
                    case 23:
                    case 'CONTROL_TYPE_CONCRETE_ANCHORAGE_TOP':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_ANCHORAGE_TOP;
                    case 24:
                    case 'CONTROL_TYPE_CONCRETE_ANCHORAGE_BTM':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_ANCHORAGE_BTM;
                    case 25:
                    case 'CONTROL_TYPE_CONCRETE_PUNCHING_COLUMN':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_PUNCHING_COLUMN;
                    case 26:
                    case 'CONTROL_TYPE_CONCRETE_PUNCHING_PERIMETER':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_PUNCHING_PERIMETER;
                    case 27:
                    case 'CONTROL_TYPE_CONCRETE_DEFLECTION':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_DEFLECTION;
                    case 28:
                    case 'CONTROL_TYPE_CONCRETE_DSSSE':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_DSSSE;
                    case 29:
                    case 'CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M2;
                    case 30:
                    case 'CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M2;
                    case 31:
                    case 'CONTROL_TYPE_CONCRETE_SHEAR_FORCE_2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_FORCE_2;
                    case 32:
                    case 'CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH_2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH_2;
                    case 33:
                    case 'CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH_2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH_2;
                    case 34:
                    case 'CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS_2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS_2;
                    case 35:
                    case 'CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_2;
                    case 36:
                    case 'CONTROL_TYPE_CONCRETE_DEFLECTION_2':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_DEFLECTION_2;
                    case 37:
                    case 'CONTROL_TYPE_CONCRETE_MOMENT_M1':
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_MOMENT_M1;
                    default:
                        console.log('Unhandled value for ControlTypeConcrete:' + src + '. ' + typeof(src));
                        return ControlTypeConcrete.CONTROL_TYPE_CONCRETE_UNSPECIFIED;
                }
            };
            export const ControlTypeConcrete_ToObject = (src: ControlTypeConcrete): string | null => {
                switch (src) {
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_UNSPECIFIED:
                        return 'CONTROL_TYPE_CONCRETE_UNSPECIFIED';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M1:
                        return 'CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M1';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M1:
                        return 'CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M1';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_MOMENT_M2:
                        return 'CONTROL_TYPE_CONCRETE_MOMENT_M2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_BIAXIAL_MOMENT:
                        return 'CONTROL_TYPE_CONCRETE_BIAXIAL_MOMENT';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_AXIAL_FORCE:
                        return 'CONTROL_TYPE_CONCRETE_AXIAL_FORCE';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_FORCE:
                        return 'CONTROL_TYPE_CONCRETE_SHEAR_FORCE';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_FORCE_TOPPING:
                        return 'CONTROL_TYPE_CONCRETE_SHEAR_FORCE_TOPPING';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TOPPING_JOINT:
                        return 'CONTROL_TYPE_CONCRETE_TOPPING_JOINT';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH:
                        return 'CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH:
                        return 'CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS:
                        return 'CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_INITIAL_PRESTRESS:
                        return 'CONTROL_TYPE_CONCRETE_INITIAL_PRESTRESS';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_STRESS_AFTER_RELEASE:
                        return 'CONTROL_TYPE_CONCRETE_STRESS_AFTER_RELEASE';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_HOLLOWCORE_SPALLING:
                        return 'CONTROL_TYPE_CONCRETE_HOLLOWCORE_SPALLING';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_TRANSVERSE:
                        return 'CONTROL_TYPE_CONCRETE_TORSION_TRANSVERSE';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_LONGITUDINAL:
                        return 'CONTROL_TYPE_CONCRETE_TORSION_LONGITUDINAL';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_TRANSVERSE:
                        return 'CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_TRANSVERSE';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_TENSION_TRANSVERSE:
                        return 'CONTROL_TYPE_CONCRETE_TORSION_TENSION_TRANSVERSE';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_LONGITUDINAL:
                        return 'CONTROL_TYPE_CONCRETE_TORSION_COMPRESSION_LONGITUDINAL';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_COMPRESSION_COVER_CHECK:
                        return 'CONTROL_TYPE_CONCRETE_COMPRESSION_COVER_CHECK';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS:
                        return 'CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_TOPPING:
                        return 'CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_TOPPING';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_ANCHORAGE_TOP:
                        return 'CONTROL_TYPE_CONCRETE_ANCHORAGE_TOP';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_ANCHORAGE_BTM:
                        return 'CONTROL_TYPE_CONCRETE_ANCHORAGE_BTM';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_PUNCHING_COLUMN:
                        return 'CONTROL_TYPE_CONCRETE_PUNCHING_COLUMN';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_PUNCHING_PERIMETER:
                        return 'CONTROL_TYPE_CONCRETE_PUNCHING_PERIMETER';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_DEFLECTION:
                        return 'CONTROL_TYPE_CONCRETE_DEFLECTION';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_DSSSE:
                        return 'CONTROL_TYPE_CONCRETE_DSSSE';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M2:
                        return 'CONTROL_TYPE_CONCRETE_POSITIVE_MOMENT_M2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M2:
                        return 'CONTROL_TYPE_CONCRETE_NEGATIVE_MOMENT_M2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_FORCE_2:
                        return 'CONTROL_TYPE_CONCRETE_SHEAR_FORCE_2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH_2:
                        return 'CONTROL_TYPE_CONCRETE_POSITIVE_CRACK_WIDTH_2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH_2:
                        return 'CONTROL_TYPE_CONCRETE_NEGATIVE_CRACK_WIDTH_2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS_2:
                        return 'CONTROL_TYPE_CONCRETE_COMPRESSION_STRESS_2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_2:
                        return 'CONTROL_TYPE_CONCRETE_SHEAR_STIRRUPS_2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_DEFLECTION_2:
                        return 'CONTROL_TYPE_CONCRETE_DEFLECTION_2';
                    case ControlTypeConcrete.CONTROL_TYPE_CONCRETE_MOMENT_M1:
                        return 'CONTROL_TYPE_CONCRETE_MOMENT_M1';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ControlTypeConcrete, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ControlTypeSteel {
                CONTROL_TYPE_STEEL_UNSPECIFIED = 0,
                CONTROL_TYPE_STEEL_OVERALL = 1,
                CONTROL_TYPE_STEEL_N = 2,
                CONTROL_TYPE_STEEL_N_FIRE = 3,
                CONTROL_TYPE_STEEL_M1 = 4,
                CONTROL_TYPE_STEEL_M2 = 5,
                CONTROL_TYPE_STEEL_M1_FIRE = 6,
                CONTROL_TYPE_STEEL_M2_FIRE = 7,
                CONTROL_TYPE_STEEL_V1 = 8,
                CONTROL_TYPE_STEEL_V2 = 9,
                CONTROL_TYPE_STEEL_T = 10,
                CONTROL_TYPE_STEEL_NORMAL = 11,
                CONTROL_TYPE_STEEL_PURE_NORMAL = 12,
                CONTROL_TYPE_STEEL_TAU = 13,
                CONTROL_TYPE_STEEL_SIGMA = 14,
                CONTROL_TYPE_STEEL_FB1 = 15,
                CONTROL_TYPE_STEEL_FB2 = 16,
                CONTROL_TYPE_STEEL_FTB = 17,
                CONTROL_TYPE_STEEL_LTB_TOP = 18,
                CONTROL_TYPE_STEEL_LTB_BOTTOM = 19,
                CONTROL_TYPE_STEEL_WEB = 20,
                CONTROL_TYPE_STEEL_IA1 = 21,
                CONTROL_TYPE_STEEL_IA2 = 22,
                CONTROL_TYPE_STEEL_IA2ND = 23,
                CONTROL_TYPE_STEEL_DEFLECTION = 24
            }
            export const ControlTypeSteel_FromObject = (src: unknown): ControlTypeSteel => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CONTROL_TYPE_STEEL_UNSPECIFIED':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_UNSPECIFIED;
                    case 1:
                    case 'CONTROL_TYPE_STEEL_OVERALL':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_OVERALL;
                    case 2:
                    case 'CONTROL_TYPE_STEEL_N':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_N;
                    case 3:
                    case 'CONTROL_TYPE_STEEL_N_FIRE':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_N_FIRE;
                    case 4:
                    case 'CONTROL_TYPE_STEEL_M1':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_M1;
                    case 5:
                    case 'CONTROL_TYPE_STEEL_M2':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_M2;
                    case 6:
                    case 'CONTROL_TYPE_STEEL_M1_FIRE':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_M1_FIRE;
                    case 7:
                    case 'CONTROL_TYPE_STEEL_M2_FIRE':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_M2_FIRE;
                    case 8:
                    case 'CONTROL_TYPE_STEEL_V1':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_V1;
                    case 9:
                    case 'CONTROL_TYPE_STEEL_V2':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_V2;
                    case 10:
                    case 'CONTROL_TYPE_STEEL_T':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_T;
                    case 11:
                    case 'CONTROL_TYPE_STEEL_NORMAL':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_NORMAL;
                    case 12:
                    case 'CONTROL_TYPE_STEEL_PURE_NORMAL':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_PURE_NORMAL;
                    case 13:
                    case 'CONTROL_TYPE_STEEL_TAU':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_TAU;
                    case 14:
                    case 'CONTROL_TYPE_STEEL_SIGMA':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_SIGMA;
                    case 15:
                    case 'CONTROL_TYPE_STEEL_FB1':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_FB1;
                    case 16:
                    case 'CONTROL_TYPE_STEEL_FB2':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_FB2;
                    case 17:
                    case 'CONTROL_TYPE_STEEL_FTB':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_FTB;
                    case 18:
                    case 'CONTROL_TYPE_STEEL_LTB_TOP':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_LTB_TOP;
                    case 19:
                    case 'CONTROL_TYPE_STEEL_LTB_BOTTOM':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_LTB_BOTTOM;
                    case 20:
                    case 'CONTROL_TYPE_STEEL_WEB':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_WEB;
                    case 21:
                    case 'CONTROL_TYPE_STEEL_IA1':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_IA1;
                    case 22:
                    case 'CONTROL_TYPE_STEEL_IA2':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_IA2;
                    case 23:
                    case 'CONTROL_TYPE_STEEL_IA2ND':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_IA2ND;
                    case 24:
                    case 'CONTROL_TYPE_STEEL_DEFLECTION':
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_DEFLECTION;
                    default:
                        console.log('Unhandled value for ControlTypeSteel:' + src + '. ' + typeof(src));
                        return ControlTypeSteel.CONTROL_TYPE_STEEL_UNSPECIFIED;
                }
            };
            export const ControlTypeSteel_ToObject = (src: ControlTypeSteel): string | null => {
                switch (src) {
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_UNSPECIFIED:
                        return 'CONTROL_TYPE_STEEL_UNSPECIFIED';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_OVERALL:
                        return 'CONTROL_TYPE_STEEL_OVERALL';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_N:
                        return 'CONTROL_TYPE_STEEL_N';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_N_FIRE:
                        return 'CONTROL_TYPE_STEEL_N_FIRE';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_M1:
                        return 'CONTROL_TYPE_STEEL_M1';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_M2:
                        return 'CONTROL_TYPE_STEEL_M2';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_M1_FIRE:
                        return 'CONTROL_TYPE_STEEL_M1_FIRE';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_M2_FIRE:
                        return 'CONTROL_TYPE_STEEL_M2_FIRE';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_V1:
                        return 'CONTROL_TYPE_STEEL_V1';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_V2:
                        return 'CONTROL_TYPE_STEEL_V2';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_T:
                        return 'CONTROL_TYPE_STEEL_T';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_NORMAL:
                        return 'CONTROL_TYPE_STEEL_NORMAL';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_PURE_NORMAL:
                        return 'CONTROL_TYPE_STEEL_PURE_NORMAL';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_TAU:
                        return 'CONTROL_TYPE_STEEL_TAU';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_SIGMA:
                        return 'CONTROL_TYPE_STEEL_SIGMA';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_FB1:
                        return 'CONTROL_TYPE_STEEL_FB1';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_FB2:
                        return 'CONTROL_TYPE_STEEL_FB2';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_FTB:
                        return 'CONTROL_TYPE_STEEL_FTB';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_LTB_TOP:
                        return 'CONTROL_TYPE_STEEL_LTB_TOP';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_LTB_BOTTOM:
                        return 'CONTROL_TYPE_STEEL_LTB_BOTTOM';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_WEB:
                        return 'CONTROL_TYPE_STEEL_WEB';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_IA1:
                        return 'CONTROL_TYPE_STEEL_IA1';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_IA2:
                        return 'CONTROL_TYPE_STEEL_IA2';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_IA2ND:
                        return 'CONTROL_TYPE_STEEL_IA2ND';
                    case ControlTypeSteel.CONTROL_TYPE_STEEL_DEFLECTION:
                        return 'CONTROL_TYPE_STEEL_DEFLECTION';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ControlTypeSteel, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ControlTypeTimber {
                CONTROL_TYPE_TIMBER_UNSPECIFIED = 0,
                CONTROL_TYPE_TIMBER_OVERALL = 1,
                CONTROL_TYPE_TIMBER_TENSION = 2,
                CONTROL_TYPE_TIMBER_COMPRESSION = 3,
                CONTROL_TYPE_TIMBER_SHEAR = 4,
                CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING1 = 5,
                CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING2 = 6,
                CONTROL_TYPE_TIMBER_TORSIONAL_BUCKLING = 7,
                CONTROL_TYPE_TIMBER_APEX = 8,
                CONTROL_TYPE_TIMBER_DEFLECTION = 9
            }
            export const ControlTypeTimber_FromObject = (src: unknown): ControlTypeTimber => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CONTROL_TYPE_TIMBER_UNSPECIFIED':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_UNSPECIFIED;
                    case 1:
                    case 'CONTROL_TYPE_TIMBER_OVERALL':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_OVERALL;
                    case 2:
                    case 'CONTROL_TYPE_TIMBER_TENSION':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_TENSION;
                    case 3:
                    case 'CONTROL_TYPE_TIMBER_COMPRESSION':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_COMPRESSION;
                    case 4:
                    case 'CONTROL_TYPE_TIMBER_SHEAR':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_SHEAR;
                    case 5:
                    case 'CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING1':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING1;
                    case 6:
                    case 'CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING2':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING2;
                    case 7:
                    case 'CONTROL_TYPE_TIMBER_TORSIONAL_BUCKLING':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_TORSIONAL_BUCKLING;
                    case 8:
                    case 'CONTROL_TYPE_TIMBER_APEX':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_APEX;
                    case 9:
                    case 'CONTROL_TYPE_TIMBER_DEFLECTION':
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_DEFLECTION;
                    default:
                        console.log('Unhandled value for ControlTypeTimber:' + src + '. ' + typeof(src));
                        return ControlTypeTimber.CONTROL_TYPE_TIMBER_UNSPECIFIED;
                }
            };
            export const ControlTypeTimber_ToObject = (src: ControlTypeTimber): string | null => {
                switch (src) {
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_UNSPECIFIED:
                        return 'CONTROL_TYPE_TIMBER_UNSPECIFIED';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_OVERALL:
                        return 'CONTROL_TYPE_TIMBER_OVERALL';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_TENSION:
                        return 'CONTROL_TYPE_TIMBER_TENSION';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_COMPRESSION:
                        return 'CONTROL_TYPE_TIMBER_COMPRESSION';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_SHEAR:
                        return 'CONTROL_TYPE_TIMBER_SHEAR';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING1:
                        return 'CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING1';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING2:
                        return 'CONTROL_TYPE_TIMBER_FLEXURAL_BUCKLING2';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_TORSIONAL_BUCKLING:
                        return 'CONTROL_TYPE_TIMBER_TORSIONAL_BUCKLING';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_APEX:
                        return 'CONTROL_TYPE_TIMBER_APEX';
                    case ControlTypeTimber.CONTROL_TYPE_TIMBER_DEFLECTION:
                        return 'CONTROL_TYPE_TIMBER_DEFLECTION';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ControlTypeTimber, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type ControlTypeFoundation_keys = 'type' | 'analysisType' | 'designType' | 'eccentricityType';
            export interface ControlTypeFoundation_createType {
                type?: ng.result.control.CtrlTypeFoundation,
                analysisType?: ng.result.control.AnalysisTypeFoundation,
                designType?: ng.result.control.DesignTypeFoundation,
                eccentricityType?: ng.result.control.EccentricityTypeFoundation,
            }
            export interface ControlTypeFoundation_json {
                type?: string;
                analysisType?: string;
                designType?: string;
                eccentricityType?: string;
            }
            interface ControlTypeFoundation_json_in {
                __proto_name?: unknown;
                type?: unknown;
                analysisType?: unknown;
                designType?: unknown;
                eccentricityType?: unknown;
            }
            export class ControlTypeFoundation {
                __proto_name = "ng.result.control.ControlTypeFoundation";
                type: ng.result.control.CtrlTypeFoundation = ng.result.control.CtrlTypeFoundation.CONTROL_TYPE_FOUNDATION_UNSPECIFIED;
                analysisType: ng.result.control.AnalysisTypeFoundation = ng.result.control.AnalysisTypeFoundation.ANALYSIS_TYPE_UNSPECIFIED;
                designType: ng.result.control.DesignTypeFoundation = ng.result.control.DesignTypeFoundation.DESIGN_TYPE_UNSPECIFIED;
                eccentricityType: ng.result.control.EccentricityTypeFoundation = ng.result.control.EccentricityTypeFoundation.ECCENTRICITY_TYPE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): ControlTypeFoundation {
                    const dst = new ControlTypeFoundation();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ControlTypeFoundation but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ControlTypeFoundation_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ControlTypeFoundation but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.type !== undefined && src.type !== null) {
                        dst.type = ng.result.control.CtrlTypeFoundation_FromObject(src.type);
                    }
                    if (src.analysisType !== undefined && src.analysisType !== null) {
                        dst.analysisType = ng.result.control.AnalysisTypeFoundation_FromObject(src.analysisType);
                    }
                    if (src.designType !== undefined && src.designType !== null) {
                        dst.designType = ng.result.control.DesignTypeFoundation_FromObject(src.designType);
                    }
                    if (src.eccentricityType !== undefined && src.eccentricityType !== null) {
                        dst.eccentricityType = ng.result.control.EccentricityTypeFoundation_FromObject(src.eccentricityType);
                    }
                    return dst;
                }

                static toObject(src: ControlTypeFoundation | null | undefined): ControlTypeFoundation_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.control.ControlTypeFoundation is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.control.ControlTypeFoundation") {
                        console.error('Expected ng.result.control.ControlTypeFoundation but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const type_obj = ng.result.control.CtrlTypeFoundation_ToObject(src.type);
                    if(type_obj === null) return null;

                    const analysisType_obj = ng.result.control.AnalysisTypeFoundation_ToObject(src.analysisType);
                    if(analysisType_obj === null) return null;

                    const designType_obj = ng.result.control.DesignTypeFoundation_ToObject(src.designType);
                    if(designType_obj === null) return null;

                    const eccentricityType_obj = ng.result.control.EccentricityTypeFoundation_ToObject(src.eccentricityType);
                    if(eccentricityType_obj === null) return null;

                    const dst : ControlTypeFoundation_json = {
                        type: type_obj,
                        analysisType: analysisType_obj,
                        designType: designType_obj,
                        eccentricityType: eccentricityType_obj,
                    };
                    return dst;
                }

                static create(src?: ControlTypeFoundation_createType) {
                    const dst = new ControlTypeFoundation();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.type !== undefined) {
                        dst.type = src.type;
                    }
                    if (src.analysisType !== undefined) {
                        dst.analysisType = src.analysisType;
                    }
                    if (src.designType !== undefined) {
                        dst.designType = src.designType;
                    }
                    if (src.eccentricityType !== undefined) {
                        dst.eccentricityType = src.eccentricityType;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ControlTypeFoundation();
                    dst.type = this.type;
                    dst.analysisType = this.analysisType;
                    dst.designType = this.designType;
                    dst.eccentricityType = this.eccentricityType;
                    return dst;
                }

                deepClone() {
                    const json = ControlTypeFoundation.toObject(this);
                    const dst = ControlTypeFoundation.fromObject(json);
                    return dst;
                }
            }
            export type IControlTypeFoundation = ControlTypeFoundation;


            export type ControlData_keys = 'title' | 'lcName' | 'x' | 'utilization' | 'mathml' | 'mathmlShort' | 'values' | 'concreteType' | 'steelType' | 'timberType' | 'foundationType';
            export interface ControlData_createType {
                title?: string,
                lcName?: string,
                x?: number,
                utilization?: number,
                mathml?: string,
                mathmlShort?: string,
                values?: Map<string, number> | null,
                concreteType?: ng.result.control.ControlTypeConcrete,
                steelType?: ng.result.control.ControlTypeSteel,
                timberType?: ng.result.control.ControlTypeTimber,
                foundationType?: ng.result.control.ControlTypeFoundation | null,
            }
            export interface ControlData_json {
                title?: string;
                lcName?: string;
                x?: JsonNumber;
                utilization?: JsonNumber;
                mathml?: string;
                mathmlShort?: string;
                values?: { [key:string]: JsonNumber };
                concreteType?: string;
                steelType?: string;
                timberType?: string;
                foundationType?: ng.result.control.ControlTypeFoundation_json;
            }
            interface ControlData_json_in {
                __proto_name?: unknown;
                title?: unknown;
                lcName?: unknown;
                x?: unknown;
                utilization?: unknown;
                mathml?: unknown;
                mathmlShort?: unknown;
                values?: unknown;
                concreteType?: unknown;
                steelType?: unknown;
                timberType?: unknown;
                foundationType?: unknown;
            }
            export class ControlData {
                __proto_name = "ng.result.control.ControlData";
                title: string = "";
                lcName: string = "";
                x: number = 0;
                utilization: number = 0;
                mathml: string = "";
                mathmlShort: string = "";
                values: Map<string, number> | null = null;
                // this is a one of
                type: {type: 'concreteType'; concreteType: ng.result.control.ControlTypeConcrete} | {type: 'steelType'; steelType: ng.result.control.ControlTypeSteel} | {type: 'timberType'; timberType: ng.result.control.ControlTypeTimber} | {type: 'foundationType'; foundationType: ng.result.control.ControlTypeFoundation} | null = null;

                /** Gets the `ConcreteType` value (or null) from the oneof `type` */
                getConcreteType(): ng.result.control.ControlTypeConcrete | null {
                    if(this.type === null) return null;
                    if(this.type.type !== 'concreteType') return null;
                    return this.type.concreteType;
                }

                /** Sets the `ConcreteType` value for the oneof `type`*/
                setConcreteType(value: ng.result.control.ControlTypeConcrete | null) {
                    if(value !== null) {
                        this.type = {type: 'concreteType', concreteType:value};
                    }
                    else {
                        this.type = null;
                    }
                }

                /** Gets the `SteelType` value (or null) from the oneof `type` */
                getSteelType(): ng.result.control.ControlTypeSteel | null {
                    if(this.type === null) return null;
                    if(this.type.type !== 'steelType') return null;
                    return this.type.steelType;
                }

                /** Sets the `SteelType` value for the oneof `type`*/
                setSteelType(value: ng.result.control.ControlTypeSteel | null) {
                    if(value !== null) {
                        this.type = {type: 'steelType', steelType:value};
                    }
                    else {
                        this.type = null;
                    }
                }

                /** Gets the `TimberType` value (or null) from the oneof `type` */
                getTimberType(): ng.result.control.ControlTypeTimber | null {
                    if(this.type === null) return null;
                    if(this.type.type !== 'timberType') return null;
                    return this.type.timberType;
                }

                /** Sets the `TimberType` value for the oneof `type`*/
                setTimberType(value: ng.result.control.ControlTypeTimber | null) {
                    if(value !== null) {
                        this.type = {type: 'timberType', timberType:value};
                    }
                    else {
                        this.type = null;
                    }
                }

                /** Gets the `FoundationType` value (or null) from the oneof `type` */
                getFoundationType(): ng.result.control.ControlTypeFoundation | null {
                    if(this.type === null) return null;
                    if(this.type.type !== 'foundationType') return null;
                    return this.type.foundationType;
                }

                /** Sets the `FoundationType` value for the oneof `type`*/
                setFoundationType(value: ng.result.control.ControlTypeFoundation | null) {
                    if(value !== null) {
                        this.type = {type: 'foundationType', foundationType:value};
                    }
                    else {
                        this.type = null;
                    }
                }

                static fromObject(src_unknown: unknown): ControlData {
                    const dst = new ControlData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ControlData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ControlData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ControlData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.title !== undefined && src.title !== null) {
                        if (typeof src.title === "string") {
                            dst.title = src.title;
                        }
                        else {
                            console.log('Expected title of ControlData to be a string but was ', typeof src.title, src.title)
                        }
                    }
                    if (src.lcName !== undefined && src.lcName !== null) {
                        if (typeof src.lcName === "string") {
                            dst.lcName = src.lcName;
                        }
                        else {
                            console.log('Expected lcName of ControlData to be a string but was ', typeof src.lcName, src.lcName)
                        }
                    }
                    if (src.x !== undefined && src.x !== null) {
                        if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                            dst.x = AsNum(src.x);
                        }
                        else {
                            console.log('Expected x of ControlData to be a number but was ', typeof src.x, src.x)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of ControlData to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.mathml !== undefined && src.mathml !== null) {
                        if (typeof src.mathml === "string") {
                            dst.mathml = src.mathml;
                        }
                        else {
                            console.log('Expected mathml of ControlData to be a string but was ', typeof src.mathml, src.mathml)
                        }
                    }
                    if (src.mathmlShort !== undefined && src.mathmlShort !== null) {
                        if (typeof src.mathmlShort === "string") {
                            dst.mathmlShort = src.mathmlShort;
                        }
                        else {
                            console.log('Expected mathmlShort of ControlData to be a string but was ', typeof src.mathmlShort, src.mathmlShort)
                        }
                    }
                    if (src.values !== undefined && src.values !== null) {
                        dst.values = new Map<string, number>();
                        if(typeof src.values === 'object') {
                            for(const [key, val] of Object.entries(src.values)) {
                                if(typeof val === 'number'){
                                    dst.values.set(key, val);
                                }
                                else {
                                    console.warn(`Expected ${key} to be a number but was a ${typeof val}: ${val}`);
                                }
                            }
                        }
                        else {
                            console.warn('Expected values of ControlData to be a object (map) but was ', typeof src.values, src.values)
                        }
                    }
                    if (src.concreteType !== undefined && src.concreteType !== null) {
                        dst.setConcreteType(ng.result.control.ControlTypeConcrete_FromObject(src.concreteType));
                    }
                    if (src.steelType !== undefined && src.steelType !== null) {
                        dst.setSteelType(ng.result.control.ControlTypeSteel_FromObject(src.steelType));
                    }
                    if (src.timberType !== undefined && src.timberType !== null) {
                        dst.setTimberType(ng.result.control.ControlTypeTimber_FromObject(src.timberType));
                    }
                    if (src.foundationType !== undefined && src.foundationType !== null) {
                        dst.setFoundationType(ng.result.control.ControlTypeFoundation.fromObject(src.foundationType));
                    }
                    return dst;
                }

                static toObject(src: ControlData | null | undefined): ControlData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.control.ControlData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.control.ControlData") {
                        console.error('Expected ng.result.control.ControlData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ControlData_json = {
                        title: src.title,
                        lcName: src.lcName,
                        x: AsJsonNum(src.x),
                        utilization: AsJsonNum(src.utilization),
                        mathml: src.mathml,
                        mathmlShort: src.mathmlShort,
                    };
                    if(src.values !== null)
                    {
                        dst.values = {};
                        for(const [key, value] of src.values.entries()) {
                            dst.values[key] = value;
                        }
                    }
                    const concreteType = src.getConcreteType();
                    if(concreteType !== null)
                    {
                        const parsed = ng.result.control.ControlTypeConcrete_ToObject(concreteType);
                        if(parsed === null) return null;
                        dst.concreteType = parsed;
                    }
                    const steelType = src.getSteelType();
                    if(steelType !== null)
                    {
                        const parsed = ng.result.control.ControlTypeSteel_ToObject(steelType);
                        if(parsed === null) return null;
                        dst.steelType = parsed;
                    }
                    const timberType = src.getTimberType();
                    if(timberType !== null)
                    {
                        const parsed = ng.result.control.ControlTypeTimber_ToObject(timberType);
                        if(parsed === null) return null;
                        dst.timberType = parsed;
                    }
                    const foundationType = src.getFoundationType();
                    if(foundationType !== null)
                    {
                        const parsed = ng.result.control.ControlTypeFoundation.toObject(foundationType);
                        if(parsed === null) return null;
                        dst.foundationType = parsed;
                    }
                    return dst;
                }

                static create(src?: ControlData_createType) {
                    const dst = new ControlData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.title !== undefined) {
                        dst.title = src.title;
                    }
                    if (src.lcName !== undefined) {
                        dst.lcName = src.lcName;
                    }
                    if (src.x !== undefined) {
                        dst.x = src.x;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.mathml !== undefined) {
                        dst.mathml = src.mathml;
                    }
                    if (src.mathmlShort !== undefined) {
                        dst.mathmlShort = src.mathmlShort;
                    }
                    if (src.values !== undefined) {
                        dst.values = src.values;
                    }
                    // part of the type oneof 
                    if (src.concreteType !== undefined && src.concreteType !== null) {
                        dst.setConcreteType(src.concreteType);
                    }
                    // part of the type oneof 
                    if (src.steelType !== undefined && src.steelType !== null) {
                        dst.setSteelType(src.steelType);
                    }
                    // part of the type oneof 
                    if (src.timberType !== undefined && src.timberType !== null) {
                        dst.setTimberType(src.timberType);
                    }
                    // part of the type oneof 
                    if (src.foundationType !== undefined && src.foundationType !== null) {
                        dst.setFoundationType(src.foundationType);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ControlData();
                    dst.title = this.title;
                    dst.lcName = this.lcName;
                    dst.x = this.x;
                    dst.utilization = this.utilization;
                    dst.mathml = this.mathml;
                    dst.mathmlShort = this.mathmlShort;
                    dst.values = this.values;
                    dst.type = this.type;
                    return dst;
                }

                deepClone() {
                    const json = ControlData.toObject(this);
                    const dst = ControlData.fromObject(json);
                    return dst;
                }
            }
            export type IControlData = ControlData;
        } // namespace control


        // Defined in Result/retainingwall.proto
        export namespace retaining_wall {
            export type DesignSummary_keys = 'elemGuid' | 'concreteInput';
            export interface DesignSummary_createType {
                elemGuid?: string,
                concreteInput?: ng.result.retaining_wall.ConcreteInput | null,
            }
            export interface DesignSummary_json {
                elemGuid?: string;
                concreteInput?: ng.result.retaining_wall.ConcreteInput_json;
            }
            interface DesignSummary_json_in {
                __proto_name?: unknown;
                elemGuid?: unknown;
                concreteInput?: unknown;
            }
            export class DesignSummary {
                __proto_name = "ng.result.retaining_wall.DesignSummary";
                elemGuid: string = "";
                concreteInput: ng.result.retaining_wall.ConcreteInput | null = null;

                static fromObject(src_unknown: unknown): DesignSummary {
                    const dst = new DesignSummary();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignSummary but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignSummary_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignSummary but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elemGuid !== undefined && src.elemGuid !== null) {
                        if (typeof src.elemGuid === "string") {
                            dst.elemGuid = src.elemGuid;
                        }
                        else {
                            console.log('Expected elemGuid of DesignSummary to be a string but was ', typeof src.elemGuid, src.elemGuid)
                        }
                    }
                    if (src.concreteInput !== undefined && src.concreteInput !== null) {
                        dst.concreteInput = ng.result.retaining_wall.ConcreteInput.fromObject(src.concreteInput);
                    }
                    return dst;
                }

                static toObject(src: DesignSummary | null | undefined): DesignSummary_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.retaining_wall.DesignSummary is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.retaining_wall.DesignSummary") {
                        console.error('Expected ng.result.retaining_wall.DesignSummary but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DesignSummary_json = {
                        elemGuid: src.elemGuid,
                    };
                    if(src.concreteInput !== null)
                    {
                        const parsed = ng.result.retaining_wall.ConcreteInput.toObject(src.concreteInput);
                        if(parsed === null) return null;
                        dst.concreteInput = parsed;
                    }
                    return dst;
                }

                static create(src?: DesignSummary_createType) {
                    const dst = new DesignSummary();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elemGuid !== undefined) {
                        dst.elemGuid = src.elemGuid;
                    }
                    if (src.concreteInput !== undefined) {
                        dst.concreteInput = src.concreteInput;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignSummary();
                    dst.elemGuid = this.elemGuid;
                    dst.concreteInput = this.concreteInput;
                    return dst;
                }

                deepClone() {
                    const json = DesignSummary.toObject(this);
                    const dst = DesignSummary.fromObject(json);
                    return dst;
                }
            }
            export type IDesignSummary = DesignSummary;


            export type ConcreteInput_keys = 'concreteWall' | 'concreteHaunch' | 'concreteToe' | 'concreteHeel' | 'nodes' | 'secWallTop' | 'secWallBottom' | 'secHaunchBottom' | 'secToeLeft' | 'secToeRight' | 'secHeelLeft' | 'secHeelRight';
            export interface ConcreteInput_createType {
                concreteWall?: ng.element.Data | null,
                concreteHaunch?: ng.element.Data | null,
                concreteToe?: ng.element.Data | null,
                concreteHeel?: ng.element.Data | null,
                nodes?: ng.topology.ElementNode[],
                secWallTop?: ng.sections.Section | null,
                secWallBottom?: ng.sections.Section | null,
                secHaunchBottom?: ng.sections.Section | null,
                secToeLeft?: ng.sections.Section | null,
                secToeRight?: ng.sections.Section | null,
                secHeelLeft?: ng.sections.Section | null,
                secHeelRight?: ng.sections.Section | null,
            }
            export interface ConcreteInput_json {
                concreteWall?: ng.element.Data_json;
                concreteHaunch?: ng.element.Data_json;
                concreteToe?: ng.element.Data_json;
                concreteHeel?: ng.element.Data_json;
                nodes: ng.topology.ElementNode_json[];
                secWallTop?: ng.sections.Section_json;
                secWallBottom?: ng.sections.Section_json;
                secHaunchBottom?: ng.sections.Section_json;
                secToeLeft?: ng.sections.Section_json;
                secToeRight?: ng.sections.Section_json;
                secHeelLeft?: ng.sections.Section_json;
                secHeelRight?: ng.sections.Section_json;
            }
            interface ConcreteInput_json_in {
                __proto_name?: unknown;
                concreteWall?: unknown;
                concreteHaunch?: unknown;
                concreteToe?: unknown;
                concreteHeel?: unknown;
                nodes?: unknown;
                secWallTop?: unknown;
                secWallBottom?: unknown;
                secHaunchBottom?: unknown;
                secToeLeft?: unknown;
                secToeRight?: unknown;
                secHeelLeft?: unknown;
                secHeelRight?: unknown;
            }
            export class ConcreteInput {
                __proto_name = "ng.result.retaining_wall.ConcreteInput";
                concreteWall: ng.element.Data | null = null;
                concreteHaunch: ng.element.Data | null = null;
                concreteToe: ng.element.Data | null = null;
                concreteHeel: ng.element.Data | null = null;
                nodes: ng.topology.ElementNode[] = [];
                secWallTop: ng.sections.Section | null = null;
                secWallBottom: ng.sections.Section | null = null;
                secHaunchBottom: ng.sections.Section | null = null;
                secToeLeft: ng.sections.Section | null = null;
                secToeRight: ng.sections.Section | null = null;
                secHeelLeft: ng.sections.Section | null = null;
                secHeelRight: ng.sections.Section | null = null;

                static fromObject(src_unknown: unknown): ConcreteInput {
                    const dst = new ConcreteInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ConcreteInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ConcreteInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ConcreteInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.concreteWall !== undefined && src.concreteWall !== null) {
                        dst.concreteWall = ng.element.Data.fromObject(src.concreteWall);
                    }
                    if (src.concreteHaunch !== undefined && src.concreteHaunch !== null) {
                        dst.concreteHaunch = ng.element.Data.fromObject(src.concreteHaunch);
                    }
                    if (src.concreteToe !== undefined && src.concreteToe !== null) {
                        dst.concreteToe = ng.element.Data.fromObject(src.concreteToe);
                    }
                    if (src.concreteHeel !== undefined && src.concreteHeel !== null) {
                        dst.concreteHeel = ng.element.Data.fromObject(src.concreteHeel);
                    }
                    if (src.nodes !== undefined && src.nodes !== null) {
                        if (Array.isArray(src.nodes)) {
                            for (const element of src.nodes) {
                                dst.nodes.push(ng.topology.ElementNode.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected nodes of ConcreteInput to be a array but was ', typeof src.nodes, src.nodes)
                        }
                    }
                    if (src.secWallTop !== undefined && src.secWallTop !== null) {
                        dst.secWallTop = ng.sections.Section.fromObject(src.secWallTop);
                    }
                    if (src.secWallBottom !== undefined && src.secWallBottom !== null) {
                        dst.secWallBottom = ng.sections.Section.fromObject(src.secWallBottom);
                    }
                    if (src.secHaunchBottom !== undefined && src.secHaunchBottom !== null) {
                        dst.secHaunchBottom = ng.sections.Section.fromObject(src.secHaunchBottom);
                    }
                    if (src.secToeLeft !== undefined && src.secToeLeft !== null) {
                        dst.secToeLeft = ng.sections.Section.fromObject(src.secToeLeft);
                    }
                    if (src.secToeRight !== undefined && src.secToeRight !== null) {
                        dst.secToeRight = ng.sections.Section.fromObject(src.secToeRight);
                    }
                    if (src.secHeelLeft !== undefined && src.secHeelLeft !== null) {
                        dst.secHeelLeft = ng.sections.Section.fromObject(src.secHeelLeft);
                    }
                    if (src.secHeelRight !== undefined && src.secHeelRight !== null) {
                        dst.secHeelRight = ng.sections.Section.fromObject(src.secHeelRight);
                    }
                    return dst;
                }

                static toObject(src: ConcreteInput | null | undefined): ConcreteInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.retaining_wall.ConcreteInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.retaining_wall.ConcreteInput") {
                        console.error('Expected ng.result.retaining_wall.ConcreteInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ConcreteInput_json = {
                        nodes: new Array<ng.topology.ElementNode_json>(),
                    };
                    if(src.concreteWall !== null)
                    {
                        const parsed = ng.element.Data.toObject(src.concreteWall);
                        if(parsed === null) return null;
                        dst.concreteWall = parsed;
                    }
                    if(src.concreteHaunch !== null)
                    {
                        const parsed = ng.element.Data.toObject(src.concreteHaunch);
                        if(parsed === null) return null;
                        dst.concreteHaunch = parsed;
                    }
                    if(src.concreteToe !== null)
                    {
                        const parsed = ng.element.Data.toObject(src.concreteToe);
                        if(parsed === null) return null;
                        dst.concreteToe = parsed;
                    }
                    if(src.concreteHeel !== null)
                    {
                        const parsed = ng.element.Data.toObject(src.concreteHeel);
                        if(parsed === null) return null;
                        dst.concreteHeel = parsed;
                    }
                    if (src.nodes !== null) {
                        for (const element of src.nodes) {
                            const parsed = ng.topology.ElementNode.toObject(element);
                            if(parsed === null) return null;
                            dst.nodes.push(parsed);
                        }
                    }
                    if(src.secWallTop !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secWallTop);
                        if(parsed === null) return null;
                        dst.secWallTop = parsed;
                    }
                    if(src.secWallBottom !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secWallBottom);
                        if(parsed === null) return null;
                        dst.secWallBottom = parsed;
                    }
                    if(src.secHaunchBottom !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secHaunchBottom);
                        if(parsed === null) return null;
                        dst.secHaunchBottom = parsed;
                    }
                    if(src.secToeLeft !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secToeLeft);
                        if(parsed === null) return null;
                        dst.secToeLeft = parsed;
                    }
                    if(src.secToeRight !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secToeRight);
                        if(parsed === null) return null;
                        dst.secToeRight = parsed;
                    }
                    if(src.secHeelLeft !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secHeelLeft);
                        if(parsed === null) return null;
                        dst.secHeelLeft = parsed;
                    }
                    if(src.secHeelRight !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secHeelRight);
                        if(parsed === null) return null;
                        dst.secHeelRight = parsed;
                    }
                    return dst;
                }

                static create(src?: ConcreteInput_createType) {
                    const dst = new ConcreteInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.concreteWall !== undefined) {
                        dst.concreteWall = src.concreteWall;
                    }
                    if (src.concreteHaunch !== undefined) {
                        dst.concreteHaunch = src.concreteHaunch;
                    }
                    if (src.concreteToe !== undefined) {
                        dst.concreteToe = src.concreteToe;
                    }
                    if (src.concreteHeel !== undefined) {
                        dst.concreteHeel = src.concreteHeel;
                    }
                    if (src.nodes !== undefined) {
                        dst.nodes = src.nodes;
                    }
                    if (src.secWallTop !== undefined) {
                        dst.secWallTop = src.secWallTop;
                    }
                    if (src.secWallBottom !== undefined) {
                        dst.secWallBottom = src.secWallBottom;
                    }
                    if (src.secHaunchBottom !== undefined) {
                        dst.secHaunchBottom = src.secHaunchBottom;
                    }
                    if (src.secToeLeft !== undefined) {
                        dst.secToeLeft = src.secToeLeft;
                    }
                    if (src.secToeRight !== undefined) {
                        dst.secToeRight = src.secToeRight;
                    }
                    if (src.secHeelLeft !== undefined) {
                        dst.secHeelLeft = src.secHeelLeft;
                    }
                    if (src.secHeelRight !== undefined) {
                        dst.secHeelRight = src.secHeelRight;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ConcreteInput();
                    dst.concreteWall = this.concreteWall;
                    dst.concreteHaunch = this.concreteHaunch;
                    dst.concreteToe = this.concreteToe;
                    dst.concreteHeel = this.concreteHeel;
                    dst.nodes = this.nodes;
                    dst.secWallTop = this.secWallTop;
                    dst.secWallBottom = this.secWallBottom;
                    dst.secHaunchBottom = this.secHaunchBottom;
                    dst.secToeLeft = this.secToeLeft;
                    dst.secToeRight = this.secToeRight;
                    dst.secHeelLeft = this.secHeelLeft;
                    dst.secHeelRight = this.secHeelRight;
                    return dst;
                }

                deepClone() {
                    const json = ConcreteInput.toObject(this);
                    const dst = ConcreteInput.fromObject(json);
                    return dst;
                }
            }
            export type IConcreteInput = ConcreteInput;


            export type Data_keys = 'resultAnalysis' | 'resultDesign' | 'utilization';
            export interface Data_createType {
                resultAnalysis?: ng.result.foundation.DetailedFoundationAnalysis[],
                resultDesign?: ng.result.foundation.DetailedFoundationDesign[],
                utilization?: number,
            }
            export interface Data_json {
                resultAnalysis: ng.result.foundation.DetailedFoundationAnalysis_json[];
                resultDesign: ng.result.foundation.DetailedFoundationDesign_json[];
                utilization?: JsonNumber;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                resultAnalysis?: unknown;
                resultDesign?: unknown;
                utilization?: unknown;
            }
            export class Data {
                __proto_name = "ng.result.retaining_wall.Data";
                resultAnalysis: ng.result.foundation.DetailedFoundationAnalysis[] = [];
                resultDesign: ng.result.foundation.DetailedFoundationDesign[] = [];
                utilization: number = 0;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.resultAnalysis !== undefined && src.resultAnalysis !== null) {
                        if (Array.isArray(src.resultAnalysis)) {
                            for (const element of src.resultAnalysis) {
                                dst.resultAnalysis.push(ng.result.foundation.DetailedFoundationAnalysis.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultAnalysis of Data to be a array but was ', typeof src.resultAnalysis, src.resultAnalysis)
                        }
                    }
                    if (src.resultDesign !== undefined && src.resultDesign !== null) {
                        if (Array.isArray(src.resultDesign)) {
                            for (const element of src.resultDesign) {
                                dst.resultDesign.push(ng.result.foundation.DetailedFoundationDesign.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultDesign of Data to be a array but was ', typeof src.resultDesign, src.resultDesign)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Data to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.retaining_wall.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.retaining_wall.Data") {
                        console.error('Expected ng.result.retaining_wall.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                        resultAnalysis: new Array<ng.result.foundation.DetailedFoundationAnalysis_json>(),
                        resultDesign: new Array<ng.result.foundation.DetailedFoundationDesign_json>(),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if (src.resultAnalysis !== null) {
                        for (const element of src.resultAnalysis) {
                            const parsed = ng.result.foundation.DetailedFoundationAnalysis.toObject(element);
                            if(parsed === null) return null;
                            dst.resultAnalysis.push(parsed);
                        }
                    }
                    if (src.resultDesign !== null) {
                        for (const element of src.resultDesign) {
                            const parsed = ng.result.foundation.DetailedFoundationDesign.toObject(element);
                            if(parsed === null) return null;
                            dst.resultDesign.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.resultAnalysis !== undefined) {
                        dst.resultAnalysis = src.resultAnalysis;
                    }
                    if (src.resultDesign !== undefined) {
                        dst.resultDesign = src.resultDesign;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.resultAnalysis = this.resultAnalysis;
                    dst.resultDesign = this.resultDesign;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;


            export type Element_keys = unknown;
            export interface Element_createType {
            }
            export interface Element_json {
            }
            interface Element_json_in {
                __proto_name?: unknown;
            }
            export class Element {
                __proto_name = "ng.result.retaining_wall.Element";

                static fromObject(src_unknown: unknown): Element {
                    const dst = new Element();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Element but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Element_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: Element | null | undefined): Element_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.retaining_wall.Element is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.retaining_wall.Element") {
                        console.error('Expected ng.result.retaining_wall.Element but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Element_json = {
                    };
                    return dst;
                }

                static create(src?: Element_createType) {
                    const dst = new Element();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Element();
                    return dst;
                }

                deepClone() {
                    const json = Element.toObject(this);
                    const dst = Element.fromObject(json);
                    return dst;
                }
            }
            export type IElement = Element;
        } // namespace retaining_wall


        // Defined in Result/interaction_diagram.proto
        export namespace interaction_diagram {
            export type Curve_keys = 'normalForce' | 'moment';
            export interface Curve_createType {
                normalForce?: number[],
                moment?: number[],
            }
            export interface Curve_json {
                normalForce: JsonNumber[];
                moment: JsonNumber[];
            }
            interface Curve_json_in {
                __proto_name?: unknown;
                normalForce?: unknown;
                moment?: unknown;
            }
            export class Curve {
                __proto_name = "ng.result.interaction_diagram.Curve";
                normalForce: number[] = [];
                moment: number[] = [];

                static fromObject(src_unknown: unknown): Curve {
                    const dst = new Curve();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Curve but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Curve_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Curve but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.normalForce !== undefined && src.normalForce !== null) {
                        if (Array.isArray(src.normalForce)) {
                            for (const [index, element] of src.normalForce.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.normalForce.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected normalForce of Curve[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected normalForce of Curve to be a array but was ', typeof src.normalForce, src.normalForce)
                        }
                    }
                    if (src.moment !== undefined && src.moment !== null) {
                        if (Array.isArray(src.moment)) {
                            for (const [index, element] of src.moment.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.moment.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected moment of Curve[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected moment of Curve to be a array but was ', typeof src.moment, src.moment)
                        }
                    }
                    return dst;
                }

                static toObject(src: Curve | null | undefined): Curve_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.interaction_diagram.Curve is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.interaction_diagram.Curve") {
                        console.error('Expected ng.result.interaction_diagram.Curve but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Curve_json = {
                        normalForce: new Array<JsonNumber>(),
                        moment: new Array<JsonNumber>(),
                    };
                    if (src.normalForce !== null) {
                        for (const element of src.normalForce) {
                            dst.normalForce.push(AsJsonNum(element));
                        }
                    }
                    if (src.moment !== null) {
                        for (const element of src.moment) {
                            dst.moment.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: Curve_createType) {
                    const dst = new Curve();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.normalForce !== undefined) {
                        dst.normalForce = src.normalForce;
                    }
                    if (src.moment !== undefined) {
                        dst.moment = src.moment;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Curve();
                    dst.normalForce = this.normalForce;
                    dst.moment = this.moment;
                    return dst;
                }

                deepClone() {
                    const json = Curve.toObject(this);
                    const dst = Curve.fromObject(json);
                    return dst;
                }
            }
            export type ICurve = Curve;


            export type Result_keys = 'elemGuid' | 'lcombGuid' | 'yAxis' | 'zAxis' | 'yAxisBiaxial' | 'zAxisBiaxial';
            export interface Result_createType {
                elemGuid?: string,
                lcombGuid?: string,
                yAxis?: ng.result.interaction_diagram.Curve | null,
                zAxis?: ng.result.interaction_diagram.Curve | null,
                yAxisBiaxial?: ng.result.interaction_diagram.Curve | null,
                zAxisBiaxial?: ng.result.interaction_diagram.Curve | null,
            }
            export interface Result_json {
                elemGuid?: string;
                lcombGuid?: string;
                yAxis?: ng.result.interaction_diagram.Curve_json;
                zAxis?: ng.result.interaction_diagram.Curve_json;
                yAxisBiaxial?: ng.result.interaction_diagram.Curve_json;
                zAxisBiaxial?: ng.result.interaction_diagram.Curve_json;
            }
            interface Result_json_in {
                __proto_name?: unknown;
                elemGuid?: unknown;
                lcombGuid?: unknown;
                yAxis?: unknown;
                zAxis?: unknown;
                yAxisBiaxial?: unknown;
                zAxisBiaxial?: unknown;
            }
            export class Result {
                __proto_name = "ng.result.interaction_diagram.Result";
                elemGuid: string = "";
                lcombGuid: string = "";
                yAxis: ng.result.interaction_diagram.Curve | null = null;
                zAxis: ng.result.interaction_diagram.Curve | null = null;
                yAxisBiaxial: ng.result.interaction_diagram.Curve | null = null;
                zAxisBiaxial: ng.result.interaction_diagram.Curve | null = null;

                static fromObject(src_unknown: unknown): Result {
                    const dst = new Result();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Result but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Result_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Result but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elemGuid !== undefined && src.elemGuid !== null) {
                        if (typeof src.elemGuid === "string") {
                            dst.elemGuid = src.elemGuid;
                        }
                        else {
                            console.log('Expected elemGuid of Result to be a string but was ', typeof src.elemGuid, src.elemGuid)
                        }
                    }
                    if (src.lcombGuid !== undefined && src.lcombGuid !== null) {
                        if (typeof src.lcombGuid === "string") {
                            dst.lcombGuid = src.lcombGuid;
                        }
                        else {
                            console.log('Expected lcombGuid of Result to be a string but was ', typeof src.lcombGuid, src.lcombGuid)
                        }
                    }
                    if (src.yAxis !== undefined && src.yAxis !== null) {
                        dst.yAxis = ng.result.interaction_diagram.Curve.fromObject(src.yAxis);
                    }
                    if (src.zAxis !== undefined && src.zAxis !== null) {
                        dst.zAxis = ng.result.interaction_diagram.Curve.fromObject(src.zAxis);
                    }
                    if (src.yAxisBiaxial !== undefined && src.yAxisBiaxial !== null) {
                        dst.yAxisBiaxial = ng.result.interaction_diagram.Curve.fromObject(src.yAxisBiaxial);
                    }
                    if (src.zAxisBiaxial !== undefined && src.zAxisBiaxial !== null) {
                        dst.zAxisBiaxial = ng.result.interaction_diagram.Curve.fromObject(src.zAxisBiaxial);
                    }
                    return dst;
                }

                static toObject(src: Result | null | undefined): Result_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.interaction_diagram.Result is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.interaction_diagram.Result") {
                        console.error('Expected ng.result.interaction_diagram.Result but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Result_json = {
                        elemGuid: src.elemGuid,
                        lcombGuid: src.lcombGuid,
                    };
                    if(src.yAxis !== null)
                    {
                        const parsed = ng.result.interaction_diagram.Curve.toObject(src.yAxis);
                        if(parsed === null) return null;
                        dst.yAxis = parsed;
                    }
                    if(src.zAxis !== null)
                    {
                        const parsed = ng.result.interaction_diagram.Curve.toObject(src.zAxis);
                        if(parsed === null) return null;
                        dst.zAxis = parsed;
                    }
                    if(src.yAxisBiaxial !== null)
                    {
                        const parsed = ng.result.interaction_diagram.Curve.toObject(src.yAxisBiaxial);
                        if(parsed === null) return null;
                        dst.yAxisBiaxial = parsed;
                    }
                    if(src.zAxisBiaxial !== null)
                    {
                        const parsed = ng.result.interaction_diagram.Curve.toObject(src.zAxisBiaxial);
                        if(parsed === null) return null;
                        dst.zAxisBiaxial = parsed;
                    }
                    return dst;
                }

                static create(src?: Result_createType) {
                    const dst = new Result();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elemGuid !== undefined) {
                        dst.elemGuid = src.elemGuid;
                    }
                    if (src.lcombGuid !== undefined) {
                        dst.lcombGuid = src.lcombGuid;
                    }
                    if (src.yAxis !== undefined) {
                        dst.yAxis = src.yAxis;
                    }
                    if (src.zAxis !== undefined) {
                        dst.zAxis = src.zAxis;
                    }
                    if (src.yAxisBiaxial !== undefined) {
                        dst.yAxisBiaxial = src.yAxisBiaxial;
                    }
                    if (src.zAxisBiaxial !== undefined) {
                        dst.zAxisBiaxial = src.zAxisBiaxial;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Result();
                    dst.elemGuid = this.elemGuid;
                    dst.lcombGuid = this.lcombGuid;
                    dst.yAxis = this.yAxis;
                    dst.zAxis = this.zAxis;
                    dst.yAxisBiaxial = this.yAxisBiaxial;
                    dst.zAxisBiaxial = this.zAxisBiaxial;
                    return dst;
                }

                deepClone() {
                    const json = Result.toObject(this);
                    const dst = Result.fromObject(json);
                    return dst;
                }
            }
            export type IResult = Result;
        } // namespace interaction_diagram


        // Defined in Result/foundation.proto
        export namespace foundation {
            export type ConcreteInput_keys = 'concreteWidth' | 'concreteLength' | 'nodes' | 'secWidth' | 'secLength';
            export interface ConcreteInput_createType {
                concreteWidth?: ng.element.Data | null,
                concreteLength?: ng.element.Data | null,
                nodes?: ng.topology.ElementNode[],
                secWidth?: ng.sections.Section | null,
                secLength?: ng.sections.Section | null,
            }
            export interface ConcreteInput_json {
                concreteWidth?: ng.element.Data_json;
                concreteLength?: ng.element.Data_json;
                nodes: ng.topology.ElementNode_json[];
                secWidth?: ng.sections.Section_json;
                secLength?: ng.sections.Section_json;
            }
            interface ConcreteInput_json_in {
                __proto_name?: unknown;
                concreteWidth?: unknown;
                concreteLength?: unknown;
                nodes?: unknown;
                secWidth?: unknown;
                secLength?: unknown;
            }
            export class ConcreteInput {
                __proto_name = "ng.result.foundation.ConcreteInput";
                concreteWidth: ng.element.Data | null = null;
                concreteLength: ng.element.Data | null = null;
                nodes: ng.topology.ElementNode[] = [];
                secWidth: ng.sections.Section | null = null;
                secLength: ng.sections.Section | null = null;

                static fromObject(src_unknown: unknown): ConcreteInput {
                    const dst = new ConcreteInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ConcreteInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ConcreteInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ConcreteInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.concreteWidth !== undefined && src.concreteWidth !== null) {
                        dst.concreteWidth = ng.element.Data.fromObject(src.concreteWidth);
                    }
                    if (src.concreteLength !== undefined && src.concreteLength !== null) {
                        dst.concreteLength = ng.element.Data.fromObject(src.concreteLength);
                    }
                    if (src.nodes !== undefined && src.nodes !== null) {
                        if (Array.isArray(src.nodes)) {
                            for (const element of src.nodes) {
                                dst.nodes.push(ng.topology.ElementNode.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected nodes of ConcreteInput to be a array but was ', typeof src.nodes, src.nodes)
                        }
                    }
                    if (src.secWidth !== undefined && src.secWidth !== null) {
                        dst.secWidth = ng.sections.Section.fromObject(src.secWidth);
                    }
                    if (src.secLength !== undefined && src.secLength !== null) {
                        dst.secLength = ng.sections.Section.fromObject(src.secLength);
                    }
                    return dst;
                }

                static toObject(src: ConcreteInput | null | undefined): ConcreteInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.ConcreteInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.ConcreteInput") {
                        console.error('Expected ng.result.foundation.ConcreteInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ConcreteInput_json = {
                        nodes: new Array<ng.topology.ElementNode_json>(),
                    };
                    if(src.concreteWidth !== null)
                    {
                        const parsed = ng.element.Data.toObject(src.concreteWidth);
                        if(parsed === null) return null;
                        dst.concreteWidth = parsed;
                    }
                    if(src.concreteLength !== null)
                    {
                        const parsed = ng.element.Data.toObject(src.concreteLength);
                        if(parsed === null) return null;
                        dst.concreteLength = parsed;
                    }
                    if (src.nodes !== null) {
                        for (const element of src.nodes) {
                            const parsed = ng.topology.ElementNode.toObject(element);
                            if(parsed === null) return null;
                            dst.nodes.push(parsed);
                        }
                    }
                    if(src.secWidth !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secWidth);
                        if(parsed === null) return null;
                        dst.secWidth = parsed;
                    }
                    if(src.secLength !== null)
                    {
                        const parsed = ng.sections.Section.toObject(src.secLength);
                        if(parsed === null) return null;
                        dst.secLength = parsed;
                    }
                    return dst;
                }

                static create(src?: ConcreteInput_createType) {
                    const dst = new ConcreteInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.concreteWidth !== undefined) {
                        dst.concreteWidth = src.concreteWidth;
                    }
                    if (src.concreteLength !== undefined) {
                        dst.concreteLength = src.concreteLength;
                    }
                    if (src.nodes !== undefined) {
                        dst.nodes = src.nodes;
                    }
                    if (src.secWidth !== undefined) {
                        dst.secWidth = src.secWidth;
                    }
                    if (src.secLength !== undefined) {
                        dst.secLength = src.secLength;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ConcreteInput();
                    dst.concreteWidth = this.concreteWidth;
                    dst.concreteLength = this.concreteLength;
                    dst.nodes = this.nodes;
                    dst.secWidth = this.secWidth;
                    dst.secLength = this.secLength;
                    return dst;
                }

                deepClone() {
                    const json = ConcreteInput.toObject(this);
                    const dst = ConcreteInput.fromObject(json);
                    return dst;
                }
            }
            export type IConcreteInput = ConcreteInput;


            export type EffectiveGeometry_keys = 'width' | 'length' | 'effectiveWidth' | 'effectiveLength' | 'effectiveArea' | 'eWidth' | 'eLength' | 'eccentricityFactor' | 'effectiveStress' | 'navierWidth' | 'navierLength' | 'plasticWidth' | 'plasticLength';
            export interface EffectiveGeometry_createType {
                width?: number,
                length?: number,
                effectiveWidth?: number,
                effectiveLength?: number,
                effectiveArea?: number,
                eWidth?: number,
                eLength?: number,
                eccentricityFactor?: number,
                effectiveStress?: number,
                navierWidth?: ng.result.foundation.Stress | null,
                navierLength?: ng.result.foundation.Stress | null,
                plasticWidth?: ng.result.foundation.Stress | null,
                plasticLength?: ng.result.foundation.Stress | null,
            }
            export interface EffectiveGeometry_json {
                width?: JsonNumber;
                length?: JsonNumber;
                effectiveWidth?: JsonNumber;
                effectiveLength?: JsonNumber;
                effectiveArea?: JsonNumber;
                eWidth?: JsonNumber;
                eLength?: JsonNumber;
                eccentricityFactor?: JsonNumber;
                effectiveStress?: JsonNumber;
                navierWidth?: ng.result.foundation.Stress_json;
                navierLength?: ng.result.foundation.Stress_json;
                plasticWidth?: ng.result.foundation.Stress_json;
                plasticLength?: ng.result.foundation.Stress_json;
            }
            interface EffectiveGeometry_json_in {
                __proto_name?: unknown;
                width?: unknown;
                length?: unknown;
                effectiveWidth?: unknown;
                effectiveLength?: unknown;
                effectiveArea?: unknown;
                eWidth?: unknown;
                eLength?: unknown;
                eccentricityFactor?: unknown;
                effectiveStress?: unknown;
                navierWidth?: unknown;
                navierLength?: unknown;
                plasticWidth?: unknown;
                plasticLength?: unknown;
            }
            export class EffectiveGeometry {
                __proto_name = "ng.result.foundation.EffectiveGeometry";
                width: number = 0;
                length: number = 0;
                effectiveWidth: number = 0;
                effectiveLength: number = 0;
                effectiveArea: number = 0;
                eWidth: number = 0;
                eLength: number = 0;
                eccentricityFactor: number = 0;
                effectiveStress: number = 0;
                navierWidth: ng.result.foundation.Stress | null = null;
                navierLength: ng.result.foundation.Stress | null = null;
                plasticWidth: ng.result.foundation.Stress | null = null;
                plasticLength: ng.result.foundation.Stress | null = null;

                static fromObject(src_unknown: unknown): EffectiveGeometry {
                    const dst = new EffectiveGeometry();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EffectiveGeometry but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EffectiveGeometry_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EffectiveGeometry but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.width !== undefined && src.width !== null) {
                        if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                            dst.width = AsNum(src.width);
                        }
                        else {
                            console.log('Expected width of EffectiveGeometry to be a number but was ', typeof src.width, src.width)
                        }
                    }
                    if (src.length !== undefined && src.length !== null) {
                        if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                            dst.length = AsNum(src.length);
                        }
                        else {
                            console.log('Expected length of EffectiveGeometry to be a number but was ', typeof src.length, src.length)
                        }
                    }
                    if (src.effectiveWidth !== undefined && src.effectiveWidth !== null) {
                        if (typeof src.effectiveWidth === "number" || src.effectiveWidth === 'NaN' || src.effectiveWidth === 'Infinity' || src.effectiveWidth === '-Infinity') {
                            dst.effectiveWidth = AsNum(src.effectiveWidth);
                        }
                        else {
                            console.log('Expected effectiveWidth of EffectiveGeometry to be a number but was ', typeof src.effectiveWidth, src.effectiveWidth)
                        }
                    }
                    if (src.effectiveLength !== undefined && src.effectiveLength !== null) {
                        if (typeof src.effectiveLength === "number" || src.effectiveLength === 'NaN' || src.effectiveLength === 'Infinity' || src.effectiveLength === '-Infinity') {
                            dst.effectiveLength = AsNum(src.effectiveLength);
                        }
                        else {
                            console.log('Expected effectiveLength of EffectiveGeometry to be a number but was ', typeof src.effectiveLength, src.effectiveLength)
                        }
                    }
                    if (src.effectiveArea !== undefined && src.effectiveArea !== null) {
                        if (typeof src.effectiveArea === "number" || src.effectiveArea === 'NaN' || src.effectiveArea === 'Infinity' || src.effectiveArea === '-Infinity') {
                            dst.effectiveArea = AsNum(src.effectiveArea);
                        }
                        else {
                            console.log('Expected effectiveArea of EffectiveGeometry to be a number but was ', typeof src.effectiveArea, src.effectiveArea)
                        }
                    }
                    if (src.eWidth !== undefined && src.eWidth !== null) {
                        if (typeof src.eWidth === "number" || src.eWidth === 'NaN' || src.eWidth === 'Infinity' || src.eWidth === '-Infinity') {
                            dst.eWidth = AsNum(src.eWidth);
                        }
                        else {
                            console.log('Expected eWidth of EffectiveGeometry to be a number but was ', typeof src.eWidth, src.eWidth)
                        }
                    }
                    if (src.eLength !== undefined && src.eLength !== null) {
                        if (typeof src.eLength === "number" || src.eLength === 'NaN' || src.eLength === 'Infinity' || src.eLength === '-Infinity') {
                            dst.eLength = AsNum(src.eLength);
                        }
                        else {
                            console.log('Expected eLength of EffectiveGeometry to be a number but was ', typeof src.eLength, src.eLength)
                        }
                    }
                    if (src.eccentricityFactor !== undefined && src.eccentricityFactor !== null) {
                        if (typeof src.eccentricityFactor === "number" || src.eccentricityFactor === 'NaN' || src.eccentricityFactor === 'Infinity' || src.eccentricityFactor === '-Infinity') {
                            dst.eccentricityFactor = AsNum(src.eccentricityFactor);
                        }
                        else {
                            console.log('Expected eccentricityFactor of EffectiveGeometry to be a number but was ', typeof src.eccentricityFactor, src.eccentricityFactor)
                        }
                    }
                    if (src.effectiveStress !== undefined && src.effectiveStress !== null) {
                        if (typeof src.effectiveStress === "number" || src.effectiveStress === 'NaN' || src.effectiveStress === 'Infinity' || src.effectiveStress === '-Infinity') {
                            dst.effectiveStress = AsNum(src.effectiveStress);
                        }
                        else {
                            console.log('Expected effectiveStress of EffectiveGeometry to be a number but was ', typeof src.effectiveStress, src.effectiveStress)
                        }
                    }
                    if (src.navierWidth !== undefined && src.navierWidth !== null) {
                        dst.navierWidth = ng.result.foundation.Stress.fromObject(src.navierWidth);
                    }
                    if (src.navierLength !== undefined && src.navierLength !== null) {
                        dst.navierLength = ng.result.foundation.Stress.fromObject(src.navierLength);
                    }
                    if (src.plasticWidth !== undefined && src.plasticWidth !== null) {
                        dst.plasticWidth = ng.result.foundation.Stress.fromObject(src.plasticWidth);
                    }
                    if (src.plasticLength !== undefined && src.plasticLength !== null) {
                        dst.plasticLength = ng.result.foundation.Stress.fromObject(src.plasticLength);
                    }
                    return dst;
                }

                static toObject(src: EffectiveGeometry | null | undefined): EffectiveGeometry_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.EffectiveGeometry is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.EffectiveGeometry") {
                        console.error('Expected ng.result.foundation.EffectiveGeometry but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EffectiveGeometry_json = {
                        width: AsJsonNum(src.width),
                        length: AsJsonNum(src.length),
                        effectiveWidth: AsJsonNum(src.effectiveWidth),
                        effectiveLength: AsJsonNum(src.effectiveLength),
                        effectiveArea: AsJsonNum(src.effectiveArea),
                        eWidth: AsJsonNum(src.eWidth),
                        eLength: AsJsonNum(src.eLength),
                        eccentricityFactor: AsJsonNum(src.eccentricityFactor),
                        effectiveStress: AsJsonNum(src.effectiveStress),
                    };
                    if(src.navierWidth !== null)
                    {
                        const parsed = ng.result.foundation.Stress.toObject(src.navierWidth);
                        if(parsed === null) return null;
                        dst.navierWidth = parsed;
                    }
                    if(src.navierLength !== null)
                    {
                        const parsed = ng.result.foundation.Stress.toObject(src.navierLength);
                        if(parsed === null) return null;
                        dst.navierLength = parsed;
                    }
                    if(src.plasticWidth !== null)
                    {
                        const parsed = ng.result.foundation.Stress.toObject(src.plasticWidth);
                        if(parsed === null) return null;
                        dst.plasticWidth = parsed;
                    }
                    if(src.plasticLength !== null)
                    {
                        const parsed = ng.result.foundation.Stress.toObject(src.plasticLength);
                        if(parsed === null) return null;
                        dst.plasticLength = parsed;
                    }
                    return dst;
                }

                static create(src?: EffectiveGeometry_createType) {
                    const dst = new EffectiveGeometry();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.width !== undefined) {
                        dst.width = src.width;
                    }
                    if (src.length !== undefined) {
                        dst.length = src.length;
                    }
                    if (src.effectiveWidth !== undefined) {
                        dst.effectiveWidth = src.effectiveWidth;
                    }
                    if (src.effectiveLength !== undefined) {
                        dst.effectiveLength = src.effectiveLength;
                    }
                    if (src.effectiveArea !== undefined) {
                        dst.effectiveArea = src.effectiveArea;
                    }
                    if (src.eWidth !== undefined) {
                        dst.eWidth = src.eWidth;
                    }
                    if (src.eLength !== undefined) {
                        dst.eLength = src.eLength;
                    }
                    if (src.eccentricityFactor !== undefined) {
                        dst.eccentricityFactor = src.eccentricityFactor;
                    }
                    if (src.effectiveStress !== undefined) {
                        dst.effectiveStress = src.effectiveStress;
                    }
                    if (src.navierWidth !== undefined) {
                        dst.navierWidth = src.navierWidth;
                    }
                    if (src.navierLength !== undefined) {
                        dst.navierLength = src.navierLength;
                    }
                    if (src.plasticWidth !== undefined) {
                        dst.plasticWidth = src.plasticWidth;
                    }
                    if (src.plasticLength !== undefined) {
                        dst.plasticLength = src.plasticLength;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EffectiveGeometry();
                    dst.width = this.width;
                    dst.length = this.length;
                    dst.effectiveWidth = this.effectiveWidth;
                    dst.effectiveLength = this.effectiveLength;
                    dst.effectiveArea = this.effectiveArea;
                    dst.eWidth = this.eWidth;
                    dst.eLength = this.eLength;
                    dst.eccentricityFactor = this.eccentricityFactor;
                    dst.effectiveStress = this.effectiveStress;
                    dst.navierWidth = this.navierWidth;
                    dst.navierLength = this.navierLength;
                    dst.plasticWidth = this.plasticWidth;
                    dst.plasticLength = this.plasticLength;
                    return dst;
                }

                deepClone() {
                    const json = EffectiveGeometry.toObject(this);
                    const dst = EffectiveGeometry.fromObject(json);
                    return dst;
                }
            }
            export type IEffectiveGeometry = EffectiveGeometry;


            export type Stress_keys = 'x1' | 'x2' | 'stress1' | 'stress2';
            export interface Stress_createType {
                x1?: number,
                x2?: number,
                stress1?: number,
                stress2?: number,
            }
            export interface Stress_json {
                x1?: JsonNumber;
                x2?: JsonNumber;
                stress1?: JsonNumber;
                stress2?: JsonNumber;
            }
            interface Stress_json_in {
                __proto_name?: unknown;
                x1?: unknown;
                x2?: unknown;
                stress1?: unknown;
                stress2?: unknown;
            }
            export class Stress {
                __proto_name = "ng.result.foundation.Stress";
                x1: number = 0;
                x2: number = 0;
                stress1: number = 0;
                stress2: number = 0;

                static fromObject(src_unknown: unknown): Stress {
                    const dst = new Stress();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Stress but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Stress_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Stress but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.x1 !== undefined && src.x1 !== null) {
                        if (typeof src.x1 === "number" || src.x1 === 'NaN' || src.x1 === 'Infinity' || src.x1 === '-Infinity') {
                            dst.x1 = AsNum(src.x1);
                        }
                        else {
                            console.log('Expected x1 of Stress to be a number but was ', typeof src.x1, src.x1)
                        }
                    }
                    if (src.x2 !== undefined && src.x2 !== null) {
                        if (typeof src.x2 === "number" || src.x2 === 'NaN' || src.x2 === 'Infinity' || src.x2 === '-Infinity') {
                            dst.x2 = AsNum(src.x2);
                        }
                        else {
                            console.log('Expected x2 of Stress to be a number but was ', typeof src.x2, src.x2)
                        }
                    }
                    if (src.stress1 !== undefined && src.stress1 !== null) {
                        if (typeof src.stress1 === "number" || src.stress1 === 'NaN' || src.stress1 === 'Infinity' || src.stress1 === '-Infinity') {
                            dst.stress1 = AsNum(src.stress1);
                        }
                        else {
                            console.log('Expected stress1 of Stress to be a number but was ', typeof src.stress1, src.stress1)
                        }
                    }
                    if (src.stress2 !== undefined && src.stress2 !== null) {
                        if (typeof src.stress2 === "number" || src.stress2 === 'NaN' || src.stress2 === 'Infinity' || src.stress2 === '-Infinity') {
                            dst.stress2 = AsNum(src.stress2);
                        }
                        else {
                            console.log('Expected stress2 of Stress to be a number but was ', typeof src.stress2, src.stress2)
                        }
                    }
                    return dst;
                }

                static toObject(src: Stress | null | undefined): Stress_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.Stress is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.Stress") {
                        console.error('Expected ng.result.foundation.Stress but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Stress_json = {
                        x1: AsJsonNum(src.x1),
                        x2: AsJsonNum(src.x2),
                        stress1: AsJsonNum(src.stress1),
                        stress2: AsJsonNum(src.stress2),
                    };
                    return dst;
                }

                static create(src?: Stress_createType) {
                    const dst = new Stress();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.x1 !== undefined) {
                        dst.x1 = src.x1;
                    }
                    if (src.x2 !== undefined) {
                        dst.x2 = src.x2;
                    }
                    if (src.stress1 !== undefined) {
                        dst.stress1 = src.stress1;
                    }
                    if (src.stress2 !== undefined) {
                        dst.stress2 = src.stress2;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Stress();
                    dst.x1 = this.x1;
                    dst.x2 = this.x2;
                    dst.stress1 = this.stress1;
                    dst.stress2 = this.stress2;
                    return dst;
                }

                deepClone() {
                    const json = Stress.toObject(this);
                    const dst = Stress.fromObject(json);
                    return dst;
                }
            }
            export type IStress = Stress;


            export type FoundationForce_keys = 'hx' | 'hy' | 'v' | 'mx' | 'my' | 't';
            export interface FoundationForce_createType {
                hx?: number,
                hy?: number,
                v?: number,
                mx?: number,
                my?: number,
                t?: number,
            }
            export interface FoundationForce_json {
                hx?: JsonNumber;
                hy?: JsonNumber;
                v?: JsonNumber;
                mx?: JsonNumber;
                my?: JsonNumber;
                t?: JsonNumber;
            }
            interface FoundationForce_json_in {
                __proto_name?: unknown;
                hx?: unknown;
                hy?: unknown;
                v?: unknown;
                mx?: unknown;
                my?: unknown;
                t?: unknown;
            }
            export class FoundationForce {
                __proto_name = "ng.result.foundation.FoundationForce";
                hx: number = 0;
                hy: number = 0;
                v: number = 0;
                mx: number = 0;
                my: number = 0;
                t: number = 0;

                static fromObject(src_unknown: unknown): FoundationForce {
                    const dst = new FoundationForce();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FoundationForce but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FoundationForce_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FoundationForce but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.hx !== undefined && src.hx !== null) {
                        if (typeof src.hx === "number" || src.hx === 'NaN' || src.hx === 'Infinity' || src.hx === '-Infinity') {
                            dst.hx = AsNum(src.hx);
                        }
                        else {
                            console.log('Expected hx of FoundationForce to be a number but was ', typeof src.hx, src.hx)
                        }
                    }
                    if (src.hy !== undefined && src.hy !== null) {
                        if (typeof src.hy === "number" || src.hy === 'NaN' || src.hy === 'Infinity' || src.hy === '-Infinity') {
                            dst.hy = AsNum(src.hy);
                        }
                        else {
                            console.log('Expected hy of FoundationForce to be a number but was ', typeof src.hy, src.hy)
                        }
                    }
                    if (src.v !== undefined && src.v !== null) {
                        if (typeof src.v === "number" || src.v === 'NaN' || src.v === 'Infinity' || src.v === '-Infinity') {
                            dst.v = AsNum(src.v);
                        }
                        else {
                            console.log('Expected v of FoundationForce to be a number but was ', typeof src.v, src.v)
                        }
                    }
                    if (src.mx !== undefined && src.mx !== null) {
                        if (typeof src.mx === "number" || src.mx === 'NaN' || src.mx === 'Infinity' || src.mx === '-Infinity') {
                            dst.mx = AsNum(src.mx);
                        }
                        else {
                            console.log('Expected mx of FoundationForce to be a number but was ', typeof src.mx, src.mx)
                        }
                    }
                    if (src.my !== undefined && src.my !== null) {
                        if (typeof src.my === "number" || src.my === 'NaN' || src.my === 'Infinity' || src.my === '-Infinity') {
                            dst.my = AsNum(src.my);
                        }
                        else {
                            console.log('Expected my of FoundationForce to be a number but was ', typeof src.my, src.my)
                        }
                    }
                    if (src.t !== undefined && src.t !== null) {
                        if (typeof src.t === "number" || src.t === 'NaN' || src.t === 'Infinity' || src.t === '-Infinity') {
                            dst.t = AsNum(src.t);
                        }
                        else {
                            console.log('Expected t of FoundationForce to be a number but was ', typeof src.t, src.t)
                        }
                    }
                    return dst;
                }

                static toObject(src: FoundationForce | null | undefined): FoundationForce_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.FoundationForce is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.FoundationForce") {
                        console.error('Expected ng.result.foundation.FoundationForce but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FoundationForce_json = {
                        hx: AsJsonNum(src.hx),
                        hy: AsJsonNum(src.hy),
                        v: AsJsonNum(src.v),
                        mx: AsJsonNum(src.mx),
                        my: AsJsonNum(src.my),
                        t: AsJsonNum(src.t),
                    };
                    return dst;
                }

                static create(src?: FoundationForce_createType) {
                    const dst = new FoundationForce();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.hx !== undefined) {
                        dst.hx = src.hx;
                    }
                    if (src.hy !== undefined) {
                        dst.hy = src.hy;
                    }
                    if (src.v !== undefined) {
                        dst.v = src.v;
                    }
                    if (src.mx !== undefined) {
                        dst.mx = src.mx;
                    }
                    if (src.my !== undefined) {
                        dst.my = src.my;
                    }
                    if (src.t !== undefined) {
                        dst.t = src.t;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FoundationForce();
                    dst.hx = this.hx;
                    dst.hy = this.hy;
                    dst.v = this.v;
                    dst.mx = this.mx;
                    dst.my = this.my;
                    dst.t = this.t;
                    return dst;
                }

                deepClone() {
                    const json = FoundationForce.toObject(this);
                    const dst = FoundationForce.fromObject(json);
                    return dst;
                }
            }
            export type IFoundationForce = FoundationForce;


            export type SoilWaterLoads_keys = 'passiveWaterPressure' | 'activeWaterPressure' | 'passiveEarthPressure' | 'activeEarthPressure' | 'generatedPointLineLoads';
            export interface SoilWaterLoads_createType {
                passiveWaterPressure?: ng.load.Data | null,
                activeWaterPressure?: ng.load.Data | null,
                passiveEarthPressure?: ng.load.Data[],
                activeEarthPressure?: ng.load.Data[],
                generatedPointLineLoads?: ng.load.Data[],
            }
            export interface SoilWaterLoads_json {
                passiveWaterPressure?: ng.load.Data_json;
                activeWaterPressure?: ng.load.Data_json;
                passiveEarthPressure: ng.load.Data_json[];
                activeEarthPressure: ng.load.Data_json[];
                generatedPointLineLoads: ng.load.Data_json[];
            }
            interface SoilWaterLoads_json_in {
                __proto_name?: unknown;
                passiveWaterPressure?: unknown;
                activeWaterPressure?: unknown;
                passiveEarthPressure?: unknown;
                activeEarthPressure?: unknown;
                generatedPointLineLoads?: unknown;
            }
            export class SoilWaterLoads {
                __proto_name = "ng.result.foundation.SoilWaterLoads";
                passiveWaterPressure: ng.load.Data | null = null;
                activeWaterPressure: ng.load.Data | null = null;
                passiveEarthPressure: ng.load.Data[] = [];
                activeEarthPressure: ng.load.Data[] = [];
                generatedPointLineLoads: ng.load.Data[] = [];

                static fromObject(src_unknown: unknown): SoilWaterLoads {
                    const dst = new SoilWaterLoads();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SoilWaterLoads but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SoilWaterLoads_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SoilWaterLoads but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.passiveWaterPressure !== undefined && src.passiveWaterPressure !== null) {
                        dst.passiveWaterPressure = ng.load.Data.fromObject(src.passiveWaterPressure);
                    }
                    if (src.activeWaterPressure !== undefined && src.activeWaterPressure !== null) {
                        dst.activeWaterPressure = ng.load.Data.fromObject(src.activeWaterPressure);
                    }
                    if (src.passiveEarthPressure !== undefined && src.passiveEarthPressure !== null) {
                        if (Array.isArray(src.passiveEarthPressure)) {
                            for (const element of src.passiveEarthPressure) {
                                dst.passiveEarthPressure.push(ng.load.Data.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected passiveEarthPressure of SoilWaterLoads to be a array but was ', typeof src.passiveEarthPressure, src.passiveEarthPressure)
                        }
                    }
                    if (src.activeEarthPressure !== undefined && src.activeEarthPressure !== null) {
                        if (Array.isArray(src.activeEarthPressure)) {
                            for (const element of src.activeEarthPressure) {
                                dst.activeEarthPressure.push(ng.load.Data.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected activeEarthPressure of SoilWaterLoads to be a array but was ', typeof src.activeEarthPressure, src.activeEarthPressure)
                        }
                    }
                    if (src.generatedPointLineLoads !== undefined && src.generatedPointLineLoads !== null) {
                        if (Array.isArray(src.generatedPointLineLoads)) {
                            for (const element of src.generatedPointLineLoads) {
                                dst.generatedPointLineLoads.push(ng.load.Data.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected generatedPointLineLoads of SoilWaterLoads to be a array but was ', typeof src.generatedPointLineLoads, src.generatedPointLineLoads)
                        }
                    }
                    return dst;
                }

                static toObject(src: SoilWaterLoads | null | undefined): SoilWaterLoads_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.SoilWaterLoads is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.SoilWaterLoads") {
                        console.error('Expected ng.result.foundation.SoilWaterLoads but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SoilWaterLoads_json = {
                        passiveEarthPressure: new Array<ng.load.Data_json>(),
                        activeEarthPressure: new Array<ng.load.Data_json>(),
                        generatedPointLineLoads: new Array<ng.load.Data_json>(),
                    };
                    if(src.passiveWaterPressure !== null)
                    {
                        const parsed = ng.load.Data.toObject(src.passiveWaterPressure);
                        if(parsed === null) return null;
                        dst.passiveWaterPressure = parsed;
                    }
                    if(src.activeWaterPressure !== null)
                    {
                        const parsed = ng.load.Data.toObject(src.activeWaterPressure);
                        if(parsed === null) return null;
                        dst.activeWaterPressure = parsed;
                    }
                    if (src.passiveEarthPressure !== null) {
                        for (const element of src.passiveEarthPressure) {
                            const parsed = ng.load.Data.toObject(element);
                            if(parsed === null) return null;
                            dst.passiveEarthPressure.push(parsed);
                        }
                    }
                    if (src.activeEarthPressure !== null) {
                        for (const element of src.activeEarthPressure) {
                            const parsed = ng.load.Data.toObject(element);
                            if(parsed === null) return null;
                            dst.activeEarthPressure.push(parsed);
                        }
                    }
                    if (src.generatedPointLineLoads !== null) {
                        for (const element of src.generatedPointLineLoads) {
                            const parsed = ng.load.Data.toObject(element);
                            if(parsed === null) return null;
                            dst.generatedPointLineLoads.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: SoilWaterLoads_createType) {
                    const dst = new SoilWaterLoads();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.passiveWaterPressure !== undefined) {
                        dst.passiveWaterPressure = src.passiveWaterPressure;
                    }
                    if (src.activeWaterPressure !== undefined) {
                        dst.activeWaterPressure = src.activeWaterPressure;
                    }
                    if (src.passiveEarthPressure !== undefined) {
                        dst.passiveEarthPressure = src.passiveEarthPressure;
                    }
                    if (src.activeEarthPressure !== undefined) {
                        dst.activeEarthPressure = src.activeEarthPressure;
                    }
                    if (src.generatedPointLineLoads !== undefined) {
                        dst.generatedPointLineLoads = src.generatedPointLineLoads;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SoilWaterLoads();
                    dst.passiveWaterPressure = this.passiveWaterPressure;
                    dst.activeWaterPressure = this.activeWaterPressure;
                    dst.passiveEarthPressure = this.passiveEarthPressure;
                    dst.activeEarthPressure = this.activeEarthPressure;
                    dst.generatedPointLineLoads = this.generatedPointLineLoads;
                    return dst;
                }

                deepClone() {
                    const json = SoilWaterLoads.toObject(this);
                    const dst = SoilWaterLoads.fromObject(json);
                    return dst;
                }
            }
            export type ISoilWaterLoads = SoilWaterLoads;


            export type EarthPressureCoef_keys = 'kp' | 'kgamma' | 'kc' | 'k0' | 'mathml';
            export interface EarthPressureCoef_createType {
                kp?: number,
                kgamma?: number,
                kc?: number,
                k0?: number,
                mathml?: string,
            }
            export interface EarthPressureCoef_json {
                kp?: JsonNumber;
                kgamma?: JsonNumber;
                kc?: JsonNumber;
                k0?: JsonNumber;
                mathml?: string;
            }
            interface EarthPressureCoef_json_in {
                __proto_name?: unknown;
                kp?: unknown;
                kgamma?: unknown;
                kc?: unknown;
                k0?: unknown;
                mathml?: unknown;
            }
            export class EarthPressureCoef {
                __proto_name = "ng.result.foundation.EarthPressureCoef";
                kp: number = 0;
                kgamma: number = 0;
                kc: number = 0;
                k0: number = 0;
                mathml: string = "";

                static fromObject(src_unknown: unknown): EarthPressureCoef {
                    const dst = new EarthPressureCoef();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EarthPressureCoef but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EarthPressureCoef_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EarthPressureCoef but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.kp !== undefined && src.kp !== null) {
                        if (typeof src.kp === "number" || src.kp === 'NaN' || src.kp === 'Infinity' || src.kp === '-Infinity') {
                            dst.kp = AsNum(src.kp);
                        }
                        else {
                            console.log('Expected kp of EarthPressureCoef to be a number but was ', typeof src.kp, src.kp)
                        }
                    }
                    if (src.kgamma !== undefined && src.kgamma !== null) {
                        if (typeof src.kgamma === "number" || src.kgamma === 'NaN' || src.kgamma === 'Infinity' || src.kgamma === '-Infinity') {
                            dst.kgamma = AsNum(src.kgamma);
                        }
                        else {
                            console.log('Expected kgamma of EarthPressureCoef to be a number but was ', typeof src.kgamma, src.kgamma)
                        }
                    }
                    if (src.kc !== undefined && src.kc !== null) {
                        if (typeof src.kc === "number" || src.kc === 'NaN' || src.kc === 'Infinity' || src.kc === '-Infinity') {
                            dst.kc = AsNum(src.kc);
                        }
                        else {
                            console.log('Expected kc of EarthPressureCoef to be a number but was ', typeof src.kc, src.kc)
                        }
                    }
                    if (src.k0 !== undefined && src.k0 !== null) {
                        if (typeof src.k0 === "number" || src.k0 === 'NaN' || src.k0 === 'Infinity' || src.k0 === '-Infinity') {
                            dst.k0 = AsNum(src.k0);
                        }
                        else {
                            console.log('Expected k0 of EarthPressureCoef to be a number but was ', typeof src.k0, src.k0)
                        }
                    }
                    if (src.mathml !== undefined && src.mathml !== null) {
                        if (typeof src.mathml === "string") {
                            dst.mathml = src.mathml;
                        }
                        else {
                            console.log('Expected mathml of EarthPressureCoef to be a string but was ', typeof src.mathml, src.mathml)
                        }
                    }
                    return dst;
                }

                static toObject(src: EarthPressureCoef | null | undefined): EarthPressureCoef_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.EarthPressureCoef is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.EarthPressureCoef") {
                        console.error('Expected ng.result.foundation.EarthPressureCoef but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EarthPressureCoef_json = {
                        kp: AsJsonNum(src.kp),
                        kgamma: AsJsonNum(src.kgamma),
                        kc: AsJsonNum(src.kc),
                        k0: AsJsonNum(src.k0),
                        mathml: src.mathml,
                    };
                    return dst;
                }

                static create(src?: EarthPressureCoef_createType) {
                    const dst = new EarthPressureCoef();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.kp !== undefined) {
                        dst.kp = src.kp;
                    }
                    if (src.kgamma !== undefined) {
                        dst.kgamma = src.kgamma;
                    }
                    if (src.kc !== undefined) {
                        dst.kc = src.kc;
                    }
                    if (src.k0 !== undefined) {
                        dst.k0 = src.k0;
                    }
                    if (src.mathml !== undefined) {
                        dst.mathml = src.mathml;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EarthPressureCoef();
                    dst.kp = this.kp;
                    dst.kgamma = this.kgamma;
                    dst.kc = this.kc;
                    dst.k0 = this.k0;
                    dst.mathml = this.mathml;
                    return dst;
                }

                deepClone() {
                    const json = EarthPressureCoef.toObject(this);
                    const dst = EarthPressureCoef.fromObject(json);
                    return dst;
                }
            }
            export type IEarthPressureCoef = EarthPressureCoef;


            export type DetailedFoundationAnalysis_keys = 'id' | 'analysisType' | 'load' | 'selfweight' | 'selfweightEffective' | 'foundationForce' | 'effectiveGeometry' | 'settlement' | 'selfweightEffectiveConcrete' | 'selfweightEffectiveSoil' | 'utilizationPassive' | 'passiveWaterPressure' | 'activeWaterPressure' | 'passiveSoilWeight' | 'activeSoilWeight' | 'passiveSoilPressure' | 'activeSoilPressure' | 'activeOverload' | 'soilWaterLoadsLoadcase' | 'soilWaterLoads' | 'activeEarthPressureCoef' | 'passiveEarthPressureCoef';
            export interface DetailedFoundationAnalysis_createType {
                id?: ng.utils.ID | null,
                analysisType?: ng.result.control.AnalysisTypeFoundation,
                load?: ng.result.foundation.FoundationForce | null,
                selfweight?: ng.result.foundation.FoundationForce | null,
                selfweightEffective?: ng.result.foundation.FoundationForce | null,
                foundationForce?: ng.result.foundation.FoundationForce | null,
                effectiveGeometry?: ng.result.foundation.EffectiveGeometry | null,
                settlement?: number,
                selfweightEffectiveConcrete?: ng.result.foundation.FoundationForce | null,
                selfweightEffectiveSoil?: ng.result.foundation.FoundationForce | null,
                utilizationPassive?: number,
                passiveWaterPressure?: ng.result.foundation.FoundationForce | null,
                activeWaterPressure?: ng.result.foundation.FoundationForce | null,
                passiveSoilWeight?: ng.result.foundation.FoundationForce | null,
                activeSoilWeight?: ng.result.foundation.FoundationForce | null,
                passiveSoilPressure?: ng.result.foundation.FoundationForce | null,
                activeSoilPressure?: ng.result.foundation.FoundationForce | null,
                activeOverload?: ng.result.foundation.FoundationForce | null,
                soilWaterLoadsLoadcase?: ng.loadcase.Data | null,
                soilWaterLoads?: ng.result.foundation.SoilWaterLoads | null,
                activeEarthPressureCoef?: ng.result.foundation.EarthPressureCoef[],
                passiveEarthPressureCoef?: ng.result.foundation.EarthPressureCoef[],
            }
            export interface DetailedFoundationAnalysis_json {
                id?: ng.utils.ID_json;
                analysisType?: string;
                load?: ng.result.foundation.FoundationForce_json;
                selfweight?: ng.result.foundation.FoundationForce_json;
                selfweightEffective?: ng.result.foundation.FoundationForce_json;
                foundationForce?: ng.result.foundation.FoundationForce_json;
                effectiveGeometry?: ng.result.foundation.EffectiveGeometry_json;
                settlement?: JsonNumber;
                selfweightEffectiveConcrete?: ng.result.foundation.FoundationForce_json;
                selfweightEffectiveSoil?: ng.result.foundation.FoundationForce_json;
                utilizationPassive?: JsonNumber;
                passiveWaterPressure?: ng.result.foundation.FoundationForce_json;
                activeWaterPressure?: ng.result.foundation.FoundationForce_json;
                passiveSoilWeight?: ng.result.foundation.FoundationForce_json;
                activeSoilWeight?: ng.result.foundation.FoundationForce_json;
                passiveSoilPressure?: ng.result.foundation.FoundationForce_json;
                activeSoilPressure?: ng.result.foundation.FoundationForce_json;
                activeOverload?: ng.result.foundation.FoundationForce_json;
                soilWaterLoadsLoadcase?: ng.loadcase.Data_json;
                soilWaterLoads?: ng.result.foundation.SoilWaterLoads_json;
                activeEarthPressureCoef: ng.result.foundation.EarthPressureCoef_json[];
                passiveEarthPressureCoef: ng.result.foundation.EarthPressureCoef_json[];
            }
            interface DetailedFoundationAnalysis_json_in {
                __proto_name?: unknown;
                id?: unknown;
                analysisType?: unknown;
                load?: unknown;
                selfweight?: unknown;
                selfweightEffective?: unknown;
                foundationForce?: unknown;
                effectiveGeometry?: unknown;
                settlement?: unknown;
                selfweightEffectiveConcrete?: unknown;
                selfweightEffectiveSoil?: unknown;
                utilizationPassive?: unknown;
                passiveWaterPressure?: unknown;
                activeWaterPressure?: unknown;
                passiveSoilWeight?: unknown;
                activeSoilWeight?: unknown;
                passiveSoilPressure?: unknown;
                activeSoilPressure?: unknown;
                activeOverload?: unknown;
                soilWaterLoadsLoadcase?: unknown;
                soilWaterLoads?: unknown;
                activeEarthPressureCoef?: unknown;
                passiveEarthPressureCoef?: unknown;
            }
            export class DetailedFoundationAnalysis {
                __proto_name = "ng.result.foundation.DetailedFoundationAnalysis";
                id: ng.utils.ID | null = null;
                analysisType: ng.result.control.AnalysisTypeFoundation = ng.result.control.AnalysisTypeFoundation.ANALYSIS_TYPE_UNSPECIFIED;
                load: ng.result.foundation.FoundationForce | null = null;
                selfweight: ng.result.foundation.FoundationForce | null = null;
                selfweightEffective: ng.result.foundation.FoundationForce | null = null;
                foundationForce: ng.result.foundation.FoundationForce | null = null;
                effectiveGeometry: ng.result.foundation.EffectiveGeometry | null = null;
                settlement: number = 0;
                selfweightEffectiveConcrete: ng.result.foundation.FoundationForce | null = null;
                selfweightEffectiveSoil: ng.result.foundation.FoundationForce | null = null;
                utilizationPassive: number = 0;
                passiveWaterPressure: ng.result.foundation.FoundationForce | null = null;
                activeWaterPressure: ng.result.foundation.FoundationForce | null = null;
                passiveSoilWeight: ng.result.foundation.FoundationForce | null = null;
                activeSoilWeight: ng.result.foundation.FoundationForce | null = null;
                passiveSoilPressure: ng.result.foundation.FoundationForce | null = null;
                activeSoilPressure: ng.result.foundation.FoundationForce | null = null;
                activeOverload: ng.result.foundation.FoundationForce | null = null;
                soilWaterLoadsLoadcase: ng.loadcase.Data | null = null;
                soilWaterLoads: ng.result.foundation.SoilWaterLoads | null = null;
                activeEarthPressureCoef: ng.result.foundation.EarthPressureCoef[] = [];
                passiveEarthPressureCoef: ng.result.foundation.EarthPressureCoef[] = [];

                static fromObject(src_unknown: unknown): DetailedFoundationAnalysis {
                    const dst = new DetailedFoundationAnalysis();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DetailedFoundationAnalysis but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DetailedFoundationAnalysis_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DetailedFoundationAnalysis but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.analysisType !== undefined && src.analysisType !== null) {
                        dst.analysisType = ng.result.control.AnalysisTypeFoundation_FromObject(src.analysisType);
                    }
                    if (src.load !== undefined && src.load !== null) {
                        dst.load = ng.result.foundation.FoundationForce.fromObject(src.load);
                    }
                    if (src.selfweight !== undefined && src.selfweight !== null) {
                        dst.selfweight = ng.result.foundation.FoundationForce.fromObject(src.selfweight);
                    }
                    if (src.selfweightEffective !== undefined && src.selfweightEffective !== null) {
                        dst.selfweightEffective = ng.result.foundation.FoundationForce.fromObject(src.selfweightEffective);
                    }
                    if (src.foundationForce !== undefined && src.foundationForce !== null) {
                        dst.foundationForce = ng.result.foundation.FoundationForce.fromObject(src.foundationForce);
                    }
                    if (src.effectiveGeometry !== undefined && src.effectiveGeometry !== null) {
                        dst.effectiveGeometry = ng.result.foundation.EffectiveGeometry.fromObject(src.effectiveGeometry);
                    }
                    if (src.settlement !== undefined && src.settlement !== null) {
                        if (typeof src.settlement === "number" || src.settlement === 'NaN' || src.settlement === 'Infinity' || src.settlement === '-Infinity') {
                            dst.settlement = AsNum(src.settlement);
                        }
                        else {
                            console.log('Expected settlement of DetailedFoundationAnalysis to be a number but was ', typeof src.settlement, src.settlement)
                        }
                    }
                    if (src.selfweightEffectiveConcrete !== undefined && src.selfweightEffectiveConcrete !== null) {
                        dst.selfweightEffectiveConcrete = ng.result.foundation.FoundationForce.fromObject(src.selfweightEffectiveConcrete);
                    }
                    if (src.selfweightEffectiveSoil !== undefined && src.selfweightEffectiveSoil !== null) {
                        dst.selfweightEffectiveSoil = ng.result.foundation.FoundationForce.fromObject(src.selfweightEffectiveSoil);
                    }
                    if (src.utilizationPassive !== undefined && src.utilizationPassive !== null) {
                        if (typeof src.utilizationPassive === "number" || src.utilizationPassive === 'NaN' || src.utilizationPassive === 'Infinity' || src.utilizationPassive === '-Infinity') {
                            dst.utilizationPassive = AsNum(src.utilizationPassive);
                        }
                        else {
                            console.log('Expected utilizationPassive of DetailedFoundationAnalysis to be a number but was ', typeof src.utilizationPassive, src.utilizationPassive)
                        }
                    }
                    if (src.passiveWaterPressure !== undefined && src.passiveWaterPressure !== null) {
                        dst.passiveWaterPressure = ng.result.foundation.FoundationForce.fromObject(src.passiveWaterPressure);
                    }
                    if (src.activeWaterPressure !== undefined && src.activeWaterPressure !== null) {
                        dst.activeWaterPressure = ng.result.foundation.FoundationForce.fromObject(src.activeWaterPressure);
                    }
                    if (src.passiveSoilWeight !== undefined && src.passiveSoilWeight !== null) {
                        dst.passiveSoilWeight = ng.result.foundation.FoundationForce.fromObject(src.passiveSoilWeight);
                    }
                    if (src.activeSoilWeight !== undefined && src.activeSoilWeight !== null) {
                        dst.activeSoilWeight = ng.result.foundation.FoundationForce.fromObject(src.activeSoilWeight);
                    }
                    if (src.passiveSoilPressure !== undefined && src.passiveSoilPressure !== null) {
                        dst.passiveSoilPressure = ng.result.foundation.FoundationForce.fromObject(src.passiveSoilPressure);
                    }
                    if (src.activeSoilPressure !== undefined && src.activeSoilPressure !== null) {
                        dst.activeSoilPressure = ng.result.foundation.FoundationForce.fromObject(src.activeSoilPressure);
                    }
                    if (src.activeOverload !== undefined && src.activeOverload !== null) {
                        dst.activeOverload = ng.result.foundation.FoundationForce.fromObject(src.activeOverload);
                    }
                    if (src.soilWaterLoadsLoadcase !== undefined && src.soilWaterLoadsLoadcase !== null) {
                        dst.soilWaterLoadsLoadcase = ng.loadcase.Data.fromObject(src.soilWaterLoadsLoadcase);
                    }
                    if (src.soilWaterLoads !== undefined && src.soilWaterLoads !== null) {
                        dst.soilWaterLoads = ng.result.foundation.SoilWaterLoads.fromObject(src.soilWaterLoads);
                    }
                    if (src.activeEarthPressureCoef !== undefined && src.activeEarthPressureCoef !== null) {
                        if (Array.isArray(src.activeEarthPressureCoef)) {
                            for (const element of src.activeEarthPressureCoef) {
                                dst.activeEarthPressureCoef.push(ng.result.foundation.EarthPressureCoef.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected activeEarthPressureCoef of DetailedFoundationAnalysis to be a array but was ', typeof src.activeEarthPressureCoef, src.activeEarthPressureCoef)
                        }
                    }
                    if (src.passiveEarthPressureCoef !== undefined && src.passiveEarthPressureCoef !== null) {
                        if (Array.isArray(src.passiveEarthPressureCoef)) {
                            for (const element of src.passiveEarthPressureCoef) {
                                dst.passiveEarthPressureCoef.push(ng.result.foundation.EarthPressureCoef.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected passiveEarthPressureCoef of DetailedFoundationAnalysis to be a array but was ', typeof src.passiveEarthPressureCoef, src.passiveEarthPressureCoef)
                        }
                    }
                    return dst;
                }

                static toObject(src: DetailedFoundationAnalysis | null | undefined): DetailedFoundationAnalysis_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.DetailedFoundationAnalysis is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.DetailedFoundationAnalysis") {
                        console.error('Expected ng.result.foundation.DetailedFoundationAnalysis but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const analysisType_obj = ng.result.control.AnalysisTypeFoundation_ToObject(src.analysisType);
                    if(analysisType_obj === null) return null;

                    const dst : DetailedFoundationAnalysis_json = {
                        analysisType: analysisType_obj,
                        settlement: AsJsonNum(src.settlement),
                        utilizationPassive: AsJsonNum(src.utilizationPassive),
                        activeEarthPressureCoef: new Array<ng.result.foundation.EarthPressureCoef_json>(),
                        passiveEarthPressureCoef: new Array<ng.result.foundation.EarthPressureCoef_json>(),
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.load !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.load);
                        if(parsed === null) return null;
                        dst.load = parsed;
                    }
                    if(src.selfweight !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.selfweight);
                        if(parsed === null) return null;
                        dst.selfweight = parsed;
                    }
                    if(src.selfweightEffective !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.selfweightEffective);
                        if(parsed === null) return null;
                        dst.selfweightEffective = parsed;
                    }
                    if(src.foundationForce !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.foundationForce);
                        if(parsed === null) return null;
                        dst.foundationForce = parsed;
                    }
                    if(src.effectiveGeometry !== null)
                    {
                        const parsed = ng.result.foundation.EffectiveGeometry.toObject(src.effectiveGeometry);
                        if(parsed === null) return null;
                        dst.effectiveGeometry = parsed;
                    }
                    if(src.selfweightEffectiveConcrete !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.selfweightEffectiveConcrete);
                        if(parsed === null) return null;
                        dst.selfweightEffectiveConcrete = parsed;
                    }
                    if(src.selfweightEffectiveSoil !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.selfweightEffectiveSoil);
                        if(parsed === null) return null;
                        dst.selfweightEffectiveSoil = parsed;
                    }
                    if(src.passiveWaterPressure !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.passiveWaterPressure);
                        if(parsed === null) return null;
                        dst.passiveWaterPressure = parsed;
                    }
                    if(src.activeWaterPressure !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.activeWaterPressure);
                        if(parsed === null) return null;
                        dst.activeWaterPressure = parsed;
                    }
                    if(src.passiveSoilWeight !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.passiveSoilWeight);
                        if(parsed === null) return null;
                        dst.passiveSoilWeight = parsed;
                    }
                    if(src.activeSoilWeight !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.activeSoilWeight);
                        if(parsed === null) return null;
                        dst.activeSoilWeight = parsed;
                    }
                    if(src.passiveSoilPressure !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.passiveSoilPressure);
                        if(parsed === null) return null;
                        dst.passiveSoilPressure = parsed;
                    }
                    if(src.activeSoilPressure !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.activeSoilPressure);
                        if(parsed === null) return null;
                        dst.activeSoilPressure = parsed;
                    }
                    if(src.activeOverload !== null)
                    {
                        const parsed = ng.result.foundation.FoundationForce.toObject(src.activeOverload);
                        if(parsed === null) return null;
                        dst.activeOverload = parsed;
                    }
                    if(src.soilWaterLoadsLoadcase !== null)
                    {
                        const parsed = ng.loadcase.Data.toObject(src.soilWaterLoadsLoadcase);
                        if(parsed === null) return null;
                        dst.soilWaterLoadsLoadcase = parsed;
                    }
                    if(src.soilWaterLoads !== null)
                    {
                        const parsed = ng.result.foundation.SoilWaterLoads.toObject(src.soilWaterLoads);
                        if(parsed === null) return null;
                        dst.soilWaterLoads = parsed;
                    }
                    if (src.activeEarthPressureCoef !== null) {
                        for (const element of src.activeEarthPressureCoef) {
                            const parsed = ng.result.foundation.EarthPressureCoef.toObject(element);
                            if(parsed === null) return null;
                            dst.activeEarthPressureCoef.push(parsed);
                        }
                    }
                    if (src.passiveEarthPressureCoef !== null) {
                        for (const element of src.passiveEarthPressureCoef) {
                            const parsed = ng.result.foundation.EarthPressureCoef.toObject(element);
                            if(parsed === null) return null;
                            dst.passiveEarthPressureCoef.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: DetailedFoundationAnalysis_createType) {
                    const dst = new DetailedFoundationAnalysis();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.analysisType !== undefined) {
                        dst.analysisType = src.analysisType;
                    }
                    if (src.load !== undefined) {
                        dst.load = src.load;
                    }
                    if (src.selfweight !== undefined) {
                        dst.selfweight = src.selfweight;
                    }
                    if (src.selfweightEffective !== undefined) {
                        dst.selfweightEffective = src.selfweightEffective;
                    }
                    if (src.foundationForce !== undefined) {
                        dst.foundationForce = src.foundationForce;
                    }
                    if (src.effectiveGeometry !== undefined) {
                        dst.effectiveGeometry = src.effectiveGeometry;
                    }
                    if (src.settlement !== undefined) {
                        dst.settlement = src.settlement;
                    }
                    if (src.selfweightEffectiveConcrete !== undefined) {
                        dst.selfweightEffectiveConcrete = src.selfweightEffectiveConcrete;
                    }
                    if (src.selfweightEffectiveSoil !== undefined) {
                        dst.selfweightEffectiveSoil = src.selfweightEffectiveSoil;
                    }
                    if (src.utilizationPassive !== undefined) {
                        dst.utilizationPassive = src.utilizationPassive;
                    }
                    if (src.passiveWaterPressure !== undefined) {
                        dst.passiveWaterPressure = src.passiveWaterPressure;
                    }
                    if (src.activeWaterPressure !== undefined) {
                        dst.activeWaterPressure = src.activeWaterPressure;
                    }
                    if (src.passiveSoilWeight !== undefined) {
                        dst.passiveSoilWeight = src.passiveSoilWeight;
                    }
                    if (src.activeSoilWeight !== undefined) {
                        dst.activeSoilWeight = src.activeSoilWeight;
                    }
                    if (src.passiveSoilPressure !== undefined) {
                        dst.passiveSoilPressure = src.passiveSoilPressure;
                    }
                    if (src.activeSoilPressure !== undefined) {
                        dst.activeSoilPressure = src.activeSoilPressure;
                    }
                    if (src.activeOverload !== undefined) {
                        dst.activeOverload = src.activeOverload;
                    }
                    if (src.soilWaterLoadsLoadcase !== undefined) {
                        dst.soilWaterLoadsLoadcase = src.soilWaterLoadsLoadcase;
                    }
                    if (src.soilWaterLoads !== undefined) {
                        dst.soilWaterLoads = src.soilWaterLoads;
                    }
                    if (src.activeEarthPressureCoef !== undefined) {
                        dst.activeEarthPressureCoef = src.activeEarthPressureCoef;
                    }
                    if (src.passiveEarthPressureCoef !== undefined) {
                        dst.passiveEarthPressureCoef = src.passiveEarthPressureCoef;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DetailedFoundationAnalysis();
                    dst.id = this.id;
                    dst.analysisType = this.analysisType;
                    dst.load = this.load;
                    dst.selfweight = this.selfweight;
                    dst.selfweightEffective = this.selfweightEffective;
                    dst.foundationForce = this.foundationForce;
                    dst.effectiveGeometry = this.effectiveGeometry;
                    dst.settlement = this.settlement;
                    dst.selfweightEffectiveConcrete = this.selfweightEffectiveConcrete;
                    dst.selfweightEffectiveSoil = this.selfweightEffectiveSoil;
                    dst.utilizationPassive = this.utilizationPassive;
                    dst.passiveWaterPressure = this.passiveWaterPressure;
                    dst.activeWaterPressure = this.activeWaterPressure;
                    dst.passiveSoilWeight = this.passiveSoilWeight;
                    dst.activeSoilWeight = this.activeSoilWeight;
                    dst.passiveSoilPressure = this.passiveSoilPressure;
                    dst.activeSoilPressure = this.activeSoilPressure;
                    dst.activeOverload = this.activeOverload;
                    dst.soilWaterLoadsLoadcase = this.soilWaterLoadsLoadcase;
                    dst.soilWaterLoads = this.soilWaterLoads;
                    dst.activeEarthPressureCoef = this.activeEarthPressureCoef;
                    dst.passiveEarthPressureCoef = this.passiveEarthPressureCoef;
                    return dst;
                }

                deepClone() {
                    const json = DetailedFoundationAnalysis.toObject(this);
                    const dst = DetailedFoundationAnalysis.fromObject(json);
                    return dst;
                }
            }
            export type IDetailedFoundationAnalysis = DetailedFoundationAnalysis;


            export type BearingRes_keys = 'gamma' | 'q' | 'd' | 'b' | 'l' | 'sc' | 'ic' | 'gc' | 'bc' | 'dc' | 'etac' | 'sq' | 'iq' | 'gq' | 'bq' | 'dq' | 'etaq' | 'sGamma' | 'iGamma' | 'gGamma' | 'bGamma' | 'dGamma' | 'etaGamma' | 'k1' | 'lambda' | 'kps' | 'm' | 'mB' | 'mL' | 'nc' | 'nq' | 'nGamma' | 'rDCat' | 'rDMax' | 'rD' | 'vd' | 'utilization' | 'control';
            export interface BearingRes_createType {
                gamma?: number,
                q?: number,
                d?: number,
                b?: number,
                l?: number,
                sc?: number,
                ic?: number,
                gc?: number,
                bc?: number,
                dc?: number,
                etac?: number,
                sq?: number,
                iq?: number,
                gq?: number,
                bq?: number,
                dq?: number,
                etaq?: number,
                sGamma?: number,
                iGamma?: number,
                gGamma?: number,
                bGamma?: number,
                dGamma?: number,
                etaGamma?: number,
                k1?: number,
                lambda?: number,
                kps?: number,
                m?: number,
                mB?: number,
                mL?: number,
                nc?: number,
                nq?: number,
                nGamma?: number,
                rDCat?: number,
                rDMax?: number,
                rD?: number,
                vd?: number,
                utilization?: number,
                control?: ng.result.control.ControlData | null,
            }
            export interface BearingRes_json {
                gamma?: JsonNumber;
                q?: JsonNumber;
                d?: JsonNumber;
                b?: JsonNumber;
                l?: JsonNumber;
                sc?: JsonNumber;
                ic?: JsonNumber;
                gc?: JsonNumber;
                bc?: JsonNumber;
                dc?: JsonNumber;
                etac?: JsonNumber;
                sq?: JsonNumber;
                iq?: JsonNumber;
                gq?: JsonNumber;
                bq?: JsonNumber;
                dq?: JsonNumber;
                etaq?: JsonNumber;
                sGamma?: JsonNumber;
                iGamma?: JsonNumber;
                gGamma?: JsonNumber;
                bGamma?: JsonNumber;
                dGamma?: JsonNumber;
                etaGamma?: JsonNumber;
                k1?: JsonNumber;
                lambda?: JsonNumber;
                kps?: JsonNumber;
                m?: JsonNumber;
                mB?: JsonNumber;
                mL?: JsonNumber;
                nc?: JsonNumber;
                nq?: JsonNumber;
                nGamma?: JsonNumber;
                rDCat?: JsonNumber;
                rDMax?: JsonNumber;
                rD?: JsonNumber;
                vd?: JsonNumber;
                utilization?: JsonNumber;
                control?: ng.result.control.ControlData_json;
            }
            interface BearingRes_json_in {
                __proto_name?: unknown;
                gamma?: unknown;
                q?: unknown;
                d?: unknown;
                b?: unknown;
                l?: unknown;
                sc?: unknown;
                ic?: unknown;
                gc?: unknown;
                bc?: unknown;
                dc?: unknown;
                etac?: unknown;
                sq?: unknown;
                iq?: unknown;
                gq?: unknown;
                bq?: unknown;
                dq?: unknown;
                etaq?: unknown;
                sGamma?: unknown;
                iGamma?: unknown;
                gGamma?: unknown;
                bGamma?: unknown;
                dGamma?: unknown;
                etaGamma?: unknown;
                k1?: unknown;
                lambda?: unknown;
                kps?: unknown;
                m?: unknown;
                mB?: unknown;
                mL?: unknown;
                nc?: unknown;
                nq?: unknown;
                nGamma?: unknown;
                rDCat?: unknown;
                rDMax?: unknown;
                rD?: unknown;
                vd?: unknown;
                utilization?: unknown;
                control?: unknown;
            }
            export class BearingRes {
                __proto_name = "ng.result.foundation.BearingRes";
                gamma: number = 0;
                q: number = 0;
                d: number = 0;
                b: number = 0;
                l: number = 0;
                sc: number = 0;
                ic: number = 0;
                gc: number = 0;
                bc: number = 0;
                dc: number = 0;
                etac: number = 0;
                sq: number = 0;
                iq: number = 0;
                gq: number = 0;
                bq: number = 0;
                dq: number = 0;
                etaq: number = 0;
                sGamma: number = 0;
                iGamma: number = 0;
                gGamma: number = 0;
                bGamma: number = 0;
                dGamma: number = 0;
                etaGamma: number = 0;
                k1: number = 0;
                lambda: number = 0;
                kps: number = 0;
                m: number = 0;
                mB: number = 0;
                mL: number = 0;
                nc: number = 0;
                nq: number = 0;
                nGamma: number = 0;
                rDCat: number = 0;
                rDMax: number = 0;
                rD: number = 0;
                vd: number = 0;
                utilization: number = 0;
                control: ng.result.control.ControlData | null = null;

                static fromObject(src_unknown: unknown): BearingRes {
                    const dst = new BearingRes();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BearingRes but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BearingRes_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BearingRes but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gamma !== undefined && src.gamma !== null) {
                        if (typeof src.gamma === "number" || src.gamma === 'NaN' || src.gamma === 'Infinity' || src.gamma === '-Infinity') {
                            dst.gamma = AsNum(src.gamma);
                        }
                        else {
                            console.log('Expected gamma of BearingRes to be a number but was ', typeof src.gamma, src.gamma)
                        }
                    }
                    if (src.q !== undefined && src.q !== null) {
                        if (typeof src.q === "number" || src.q === 'NaN' || src.q === 'Infinity' || src.q === '-Infinity') {
                            dst.q = AsNum(src.q);
                        }
                        else {
                            console.log('Expected q of BearingRes to be a number but was ', typeof src.q, src.q)
                        }
                    }
                    if (src.d !== undefined && src.d !== null) {
                        if (typeof src.d === "number" || src.d === 'NaN' || src.d === 'Infinity' || src.d === '-Infinity') {
                            dst.d = AsNum(src.d);
                        }
                        else {
                            console.log('Expected d of BearingRes to be a number but was ', typeof src.d, src.d)
                        }
                    }
                    if (src.b !== undefined && src.b !== null) {
                        if (typeof src.b === "number" || src.b === 'NaN' || src.b === 'Infinity' || src.b === '-Infinity') {
                            dst.b = AsNum(src.b);
                        }
                        else {
                            console.log('Expected b of BearingRes to be a number but was ', typeof src.b, src.b)
                        }
                    }
                    if (src.l !== undefined && src.l !== null) {
                        if (typeof src.l === "number" || src.l === 'NaN' || src.l === 'Infinity' || src.l === '-Infinity') {
                            dst.l = AsNum(src.l);
                        }
                        else {
                            console.log('Expected l of BearingRes to be a number but was ', typeof src.l, src.l)
                        }
                    }
                    if (src.sc !== undefined && src.sc !== null) {
                        if (typeof src.sc === "number" || src.sc === 'NaN' || src.sc === 'Infinity' || src.sc === '-Infinity') {
                            dst.sc = AsNum(src.sc);
                        }
                        else {
                            console.log('Expected sc of BearingRes to be a number but was ', typeof src.sc, src.sc)
                        }
                    }
                    if (src.ic !== undefined && src.ic !== null) {
                        if (typeof src.ic === "number" || src.ic === 'NaN' || src.ic === 'Infinity' || src.ic === '-Infinity') {
                            dst.ic = AsNum(src.ic);
                        }
                        else {
                            console.log('Expected ic of BearingRes to be a number but was ', typeof src.ic, src.ic)
                        }
                    }
                    if (src.gc !== undefined && src.gc !== null) {
                        if (typeof src.gc === "number" || src.gc === 'NaN' || src.gc === 'Infinity' || src.gc === '-Infinity') {
                            dst.gc = AsNum(src.gc);
                        }
                        else {
                            console.log('Expected gc of BearingRes to be a number but was ', typeof src.gc, src.gc)
                        }
                    }
                    if (src.bc !== undefined && src.bc !== null) {
                        if (typeof src.bc === "number" || src.bc === 'NaN' || src.bc === 'Infinity' || src.bc === '-Infinity') {
                            dst.bc = AsNum(src.bc);
                        }
                        else {
                            console.log('Expected bc of BearingRes to be a number but was ', typeof src.bc, src.bc)
                        }
                    }
                    if (src.dc !== undefined && src.dc !== null) {
                        if (typeof src.dc === "number" || src.dc === 'NaN' || src.dc === 'Infinity' || src.dc === '-Infinity') {
                            dst.dc = AsNum(src.dc);
                        }
                        else {
                            console.log('Expected dc of BearingRes to be a number but was ', typeof src.dc, src.dc)
                        }
                    }
                    if (src.etac !== undefined && src.etac !== null) {
                        if (typeof src.etac === "number" || src.etac === 'NaN' || src.etac === 'Infinity' || src.etac === '-Infinity') {
                            dst.etac = AsNum(src.etac);
                        }
                        else {
                            console.log('Expected etac of BearingRes to be a number but was ', typeof src.etac, src.etac)
                        }
                    }
                    if (src.sq !== undefined && src.sq !== null) {
                        if (typeof src.sq === "number" || src.sq === 'NaN' || src.sq === 'Infinity' || src.sq === '-Infinity') {
                            dst.sq = AsNum(src.sq);
                        }
                        else {
                            console.log('Expected sq of BearingRes to be a number but was ', typeof src.sq, src.sq)
                        }
                    }
                    if (src.iq !== undefined && src.iq !== null) {
                        if (typeof src.iq === "number" || src.iq === 'NaN' || src.iq === 'Infinity' || src.iq === '-Infinity') {
                            dst.iq = AsNum(src.iq);
                        }
                        else {
                            console.log('Expected iq of BearingRes to be a number but was ', typeof src.iq, src.iq)
                        }
                    }
                    if (src.gq !== undefined && src.gq !== null) {
                        if (typeof src.gq === "number" || src.gq === 'NaN' || src.gq === 'Infinity' || src.gq === '-Infinity') {
                            dst.gq = AsNum(src.gq);
                        }
                        else {
                            console.log('Expected gq of BearingRes to be a number but was ', typeof src.gq, src.gq)
                        }
                    }
                    if (src.bq !== undefined && src.bq !== null) {
                        if (typeof src.bq === "number" || src.bq === 'NaN' || src.bq === 'Infinity' || src.bq === '-Infinity') {
                            dst.bq = AsNum(src.bq);
                        }
                        else {
                            console.log('Expected bq of BearingRes to be a number but was ', typeof src.bq, src.bq)
                        }
                    }
                    if (src.dq !== undefined && src.dq !== null) {
                        if (typeof src.dq === "number" || src.dq === 'NaN' || src.dq === 'Infinity' || src.dq === '-Infinity') {
                            dst.dq = AsNum(src.dq);
                        }
                        else {
                            console.log('Expected dq of BearingRes to be a number but was ', typeof src.dq, src.dq)
                        }
                    }
                    if (src.etaq !== undefined && src.etaq !== null) {
                        if (typeof src.etaq === "number" || src.etaq === 'NaN' || src.etaq === 'Infinity' || src.etaq === '-Infinity') {
                            dst.etaq = AsNum(src.etaq);
                        }
                        else {
                            console.log('Expected etaq of BearingRes to be a number but was ', typeof src.etaq, src.etaq)
                        }
                    }
                    if (src.sGamma !== undefined && src.sGamma !== null) {
                        if (typeof src.sGamma === "number" || src.sGamma === 'NaN' || src.sGamma === 'Infinity' || src.sGamma === '-Infinity') {
                            dst.sGamma = AsNum(src.sGamma);
                        }
                        else {
                            console.log('Expected sGamma of BearingRes to be a number but was ', typeof src.sGamma, src.sGamma)
                        }
                    }
                    if (src.iGamma !== undefined && src.iGamma !== null) {
                        if (typeof src.iGamma === "number" || src.iGamma === 'NaN' || src.iGamma === 'Infinity' || src.iGamma === '-Infinity') {
                            dst.iGamma = AsNum(src.iGamma);
                        }
                        else {
                            console.log('Expected iGamma of BearingRes to be a number but was ', typeof src.iGamma, src.iGamma)
                        }
                    }
                    if (src.gGamma !== undefined && src.gGamma !== null) {
                        if (typeof src.gGamma === "number" || src.gGamma === 'NaN' || src.gGamma === 'Infinity' || src.gGamma === '-Infinity') {
                            dst.gGamma = AsNum(src.gGamma);
                        }
                        else {
                            console.log('Expected gGamma of BearingRes to be a number but was ', typeof src.gGamma, src.gGamma)
                        }
                    }
                    if (src.bGamma !== undefined && src.bGamma !== null) {
                        if (typeof src.bGamma === "number" || src.bGamma === 'NaN' || src.bGamma === 'Infinity' || src.bGamma === '-Infinity') {
                            dst.bGamma = AsNum(src.bGamma);
                        }
                        else {
                            console.log('Expected bGamma of BearingRes to be a number but was ', typeof src.bGamma, src.bGamma)
                        }
                    }
                    if (src.dGamma !== undefined && src.dGamma !== null) {
                        if (typeof src.dGamma === "number" || src.dGamma === 'NaN' || src.dGamma === 'Infinity' || src.dGamma === '-Infinity') {
                            dst.dGamma = AsNum(src.dGamma);
                        }
                        else {
                            console.log('Expected dGamma of BearingRes to be a number but was ', typeof src.dGamma, src.dGamma)
                        }
                    }
                    if (src.etaGamma !== undefined && src.etaGamma !== null) {
                        if (typeof src.etaGamma === "number" || src.etaGamma === 'NaN' || src.etaGamma === 'Infinity' || src.etaGamma === '-Infinity') {
                            dst.etaGamma = AsNum(src.etaGamma);
                        }
                        else {
                            console.log('Expected etaGamma of BearingRes to be a number but was ', typeof src.etaGamma, src.etaGamma)
                        }
                    }
                    if (src.k1 !== undefined && src.k1 !== null) {
                        if (typeof src.k1 === "number" || src.k1 === 'NaN' || src.k1 === 'Infinity' || src.k1 === '-Infinity') {
                            dst.k1 = AsNum(src.k1);
                        }
                        else {
                            console.log('Expected k1 of BearingRes to be a number but was ', typeof src.k1, src.k1)
                        }
                    }
                    if (src.lambda !== undefined && src.lambda !== null) {
                        if (typeof src.lambda === "number" || src.lambda === 'NaN' || src.lambda === 'Infinity' || src.lambda === '-Infinity') {
                            dst.lambda = AsNum(src.lambda);
                        }
                        else {
                            console.log('Expected lambda of BearingRes to be a number but was ', typeof src.lambda, src.lambda)
                        }
                    }
                    if (src.kps !== undefined && src.kps !== null) {
                        if (typeof src.kps === "number" || src.kps === 'NaN' || src.kps === 'Infinity' || src.kps === '-Infinity') {
                            dst.kps = AsNum(src.kps);
                        }
                        else {
                            console.log('Expected kps of BearingRes to be a number but was ', typeof src.kps, src.kps)
                        }
                    }
                    if (src.m !== undefined && src.m !== null) {
                        if (typeof src.m === "number" || src.m === 'NaN' || src.m === 'Infinity' || src.m === '-Infinity') {
                            dst.m = AsNum(src.m);
                        }
                        else {
                            console.log('Expected m of BearingRes to be a number but was ', typeof src.m, src.m)
                        }
                    }
                    if (src.mB !== undefined && src.mB !== null) {
                        if (typeof src.mB === "number" || src.mB === 'NaN' || src.mB === 'Infinity' || src.mB === '-Infinity') {
                            dst.mB = AsNum(src.mB);
                        }
                        else {
                            console.log('Expected mB of BearingRes to be a number but was ', typeof src.mB, src.mB)
                        }
                    }
                    if (src.mL !== undefined && src.mL !== null) {
                        if (typeof src.mL === "number" || src.mL === 'NaN' || src.mL === 'Infinity' || src.mL === '-Infinity') {
                            dst.mL = AsNum(src.mL);
                        }
                        else {
                            console.log('Expected mL of BearingRes to be a number but was ', typeof src.mL, src.mL)
                        }
                    }
                    if (src.nc !== undefined && src.nc !== null) {
                        if (typeof src.nc === "number" || src.nc === 'NaN' || src.nc === 'Infinity' || src.nc === '-Infinity') {
                            dst.nc = AsNum(src.nc);
                        }
                        else {
                            console.log('Expected nc of BearingRes to be a number but was ', typeof src.nc, src.nc)
                        }
                    }
                    if (src.nq !== undefined && src.nq !== null) {
                        if (typeof src.nq === "number" || src.nq === 'NaN' || src.nq === 'Infinity' || src.nq === '-Infinity') {
                            dst.nq = AsNum(src.nq);
                        }
                        else {
                            console.log('Expected nq of BearingRes to be a number but was ', typeof src.nq, src.nq)
                        }
                    }
                    if (src.nGamma !== undefined && src.nGamma !== null) {
                        if (typeof src.nGamma === "number" || src.nGamma === 'NaN' || src.nGamma === 'Infinity' || src.nGamma === '-Infinity') {
                            dst.nGamma = AsNum(src.nGamma);
                        }
                        else {
                            console.log('Expected nGamma of BearingRes to be a number but was ', typeof src.nGamma, src.nGamma)
                        }
                    }
                    if (src.rDCat !== undefined && src.rDCat !== null) {
                        if (typeof src.rDCat === "number" || src.rDCat === 'NaN' || src.rDCat === 'Infinity' || src.rDCat === '-Infinity') {
                            dst.rDCat = AsNum(src.rDCat);
                        }
                        else {
                            console.log('Expected rDCat of BearingRes to be a number but was ', typeof src.rDCat, src.rDCat)
                        }
                    }
                    if (src.rDMax !== undefined && src.rDMax !== null) {
                        if (typeof src.rDMax === "number" || src.rDMax === 'NaN' || src.rDMax === 'Infinity' || src.rDMax === '-Infinity') {
                            dst.rDMax = AsNum(src.rDMax);
                        }
                        else {
                            console.log('Expected rDMax of BearingRes to be a number but was ', typeof src.rDMax, src.rDMax)
                        }
                    }
                    if (src.rD !== undefined && src.rD !== null) {
                        if (typeof src.rD === "number" || src.rD === 'NaN' || src.rD === 'Infinity' || src.rD === '-Infinity') {
                            dst.rD = AsNum(src.rD);
                        }
                        else {
                            console.log('Expected rD of BearingRes to be a number but was ', typeof src.rD, src.rD)
                        }
                    }
                    if (src.vd !== undefined && src.vd !== null) {
                        if (typeof src.vd === "number" || src.vd === 'NaN' || src.vd === 'Infinity' || src.vd === '-Infinity') {
                            dst.vd = AsNum(src.vd);
                        }
                        else {
                            console.log('Expected vd of BearingRes to be a number but was ', typeof src.vd, src.vd)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of BearingRes to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.control !== undefined && src.control !== null) {
                        dst.control = ng.result.control.ControlData.fromObject(src.control);
                    }
                    return dst;
                }

                static toObject(src: BearingRes | null | undefined): BearingRes_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.BearingRes is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.BearingRes") {
                        console.error('Expected ng.result.foundation.BearingRes but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BearingRes_json = {
                        gamma: AsJsonNum(src.gamma),
                        q: AsJsonNum(src.q),
                        d: AsJsonNum(src.d),
                        b: AsJsonNum(src.b),
                        l: AsJsonNum(src.l),
                        sc: AsJsonNum(src.sc),
                        ic: AsJsonNum(src.ic),
                        gc: AsJsonNum(src.gc),
                        bc: AsJsonNum(src.bc),
                        dc: AsJsonNum(src.dc),
                        etac: AsJsonNum(src.etac),
                        sq: AsJsonNum(src.sq),
                        iq: AsJsonNum(src.iq),
                        gq: AsJsonNum(src.gq),
                        bq: AsJsonNum(src.bq),
                        dq: AsJsonNum(src.dq),
                        etaq: AsJsonNum(src.etaq),
                        sGamma: AsJsonNum(src.sGamma),
                        iGamma: AsJsonNum(src.iGamma),
                        gGamma: AsJsonNum(src.gGamma),
                        bGamma: AsJsonNum(src.bGamma),
                        dGamma: AsJsonNum(src.dGamma),
                        etaGamma: AsJsonNum(src.etaGamma),
                        k1: AsJsonNum(src.k1),
                        lambda: AsJsonNum(src.lambda),
                        kps: AsJsonNum(src.kps),
                        m: AsJsonNum(src.m),
                        mB: AsJsonNum(src.mB),
                        mL: AsJsonNum(src.mL),
                        nc: AsJsonNum(src.nc),
                        nq: AsJsonNum(src.nq),
                        nGamma: AsJsonNum(src.nGamma),
                        rDCat: AsJsonNum(src.rDCat),
                        rDMax: AsJsonNum(src.rDMax),
                        rD: AsJsonNum(src.rD),
                        vd: AsJsonNum(src.vd),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.control !== null)
                    {
                        const parsed = ng.result.control.ControlData.toObject(src.control);
                        if(parsed === null) return null;
                        dst.control = parsed;
                    }
                    return dst;
                }

                static create(src?: BearingRes_createType) {
                    const dst = new BearingRes();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gamma !== undefined) {
                        dst.gamma = src.gamma;
                    }
                    if (src.q !== undefined) {
                        dst.q = src.q;
                    }
                    if (src.d !== undefined) {
                        dst.d = src.d;
                    }
                    if (src.b !== undefined) {
                        dst.b = src.b;
                    }
                    if (src.l !== undefined) {
                        dst.l = src.l;
                    }
                    if (src.sc !== undefined) {
                        dst.sc = src.sc;
                    }
                    if (src.ic !== undefined) {
                        dst.ic = src.ic;
                    }
                    if (src.gc !== undefined) {
                        dst.gc = src.gc;
                    }
                    if (src.bc !== undefined) {
                        dst.bc = src.bc;
                    }
                    if (src.dc !== undefined) {
                        dst.dc = src.dc;
                    }
                    if (src.etac !== undefined) {
                        dst.etac = src.etac;
                    }
                    if (src.sq !== undefined) {
                        dst.sq = src.sq;
                    }
                    if (src.iq !== undefined) {
                        dst.iq = src.iq;
                    }
                    if (src.gq !== undefined) {
                        dst.gq = src.gq;
                    }
                    if (src.bq !== undefined) {
                        dst.bq = src.bq;
                    }
                    if (src.dq !== undefined) {
                        dst.dq = src.dq;
                    }
                    if (src.etaq !== undefined) {
                        dst.etaq = src.etaq;
                    }
                    if (src.sGamma !== undefined) {
                        dst.sGamma = src.sGamma;
                    }
                    if (src.iGamma !== undefined) {
                        dst.iGamma = src.iGamma;
                    }
                    if (src.gGamma !== undefined) {
                        dst.gGamma = src.gGamma;
                    }
                    if (src.bGamma !== undefined) {
                        dst.bGamma = src.bGamma;
                    }
                    if (src.dGamma !== undefined) {
                        dst.dGamma = src.dGamma;
                    }
                    if (src.etaGamma !== undefined) {
                        dst.etaGamma = src.etaGamma;
                    }
                    if (src.k1 !== undefined) {
                        dst.k1 = src.k1;
                    }
                    if (src.lambda !== undefined) {
                        dst.lambda = src.lambda;
                    }
                    if (src.kps !== undefined) {
                        dst.kps = src.kps;
                    }
                    if (src.m !== undefined) {
                        dst.m = src.m;
                    }
                    if (src.mB !== undefined) {
                        dst.mB = src.mB;
                    }
                    if (src.mL !== undefined) {
                        dst.mL = src.mL;
                    }
                    if (src.nc !== undefined) {
                        dst.nc = src.nc;
                    }
                    if (src.nq !== undefined) {
                        dst.nq = src.nq;
                    }
                    if (src.nGamma !== undefined) {
                        dst.nGamma = src.nGamma;
                    }
                    if (src.rDCat !== undefined) {
                        dst.rDCat = src.rDCat;
                    }
                    if (src.rDMax !== undefined) {
                        dst.rDMax = src.rDMax;
                    }
                    if (src.rD !== undefined) {
                        dst.rD = src.rD;
                    }
                    if (src.vd !== undefined) {
                        dst.vd = src.vd;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.control !== undefined) {
                        dst.control = src.control;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BearingRes();
                    dst.gamma = this.gamma;
                    dst.q = this.q;
                    dst.d = this.d;
                    dst.b = this.b;
                    dst.l = this.l;
                    dst.sc = this.sc;
                    dst.ic = this.ic;
                    dst.gc = this.gc;
                    dst.bc = this.bc;
                    dst.dc = this.dc;
                    dst.etac = this.etac;
                    dst.sq = this.sq;
                    dst.iq = this.iq;
                    dst.gq = this.gq;
                    dst.bq = this.bq;
                    dst.dq = this.dq;
                    dst.etaq = this.etaq;
                    dst.sGamma = this.sGamma;
                    dst.iGamma = this.iGamma;
                    dst.gGamma = this.gGamma;
                    dst.bGamma = this.bGamma;
                    dst.dGamma = this.dGamma;
                    dst.etaGamma = this.etaGamma;
                    dst.k1 = this.k1;
                    dst.lambda = this.lambda;
                    dst.kps = this.kps;
                    dst.m = this.m;
                    dst.mB = this.mB;
                    dst.mL = this.mL;
                    dst.nc = this.nc;
                    dst.nq = this.nq;
                    dst.nGamma = this.nGamma;
                    dst.rDCat = this.rDCat;
                    dst.rDMax = this.rDMax;
                    dst.rD = this.rD;
                    dst.vd = this.vd;
                    dst.utilization = this.utilization;
                    dst.control = this.control;
                    return dst;
                }

                deepClone() {
                    const json = BearingRes.toObject(this);
                    const dst = BearingRes.fromObject(json);
                    return dst;
                }
            }
            export type IBearingRes = BearingRes;


            export type BearingResFormula_keys = 'sc' | 'ic' | 'gc' | 'bc' | 'dc' | 'sq' | 'iq' | 'gq' | 'bq' | 'dq' | 'sGamma' | 'iGamma' | 'gGamma' | 'bGamma' | 'dGamma' | 'm' | 'mB' | 'mL' | 'nc' | 'nq' | 'nGamma' | 'rdmax';
            export interface BearingResFormula_createType {
                sc?: string,
                ic?: string,
                gc?: string,
                bc?: string,
                dc?: string,
                sq?: string,
                iq?: string,
                gq?: string,
                bq?: string,
                dq?: string,
                sGamma?: string,
                iGamma?: string,
                gGamma?: string,
                bGamma?: string,
                dGamma?: string,
                m?: string,
                mB?: string,
                mL?: string,
                nc?: string,
                nq?: string,
                nGamma?: string,
                rdmax?: string,
            }
            export interface BearingResFormula_json {
                sc?: string;
                ic?: string;
                gc?: string;
                bc?: string;
                dc?: string;
                sq?: string;
                iq?: string;
                gq?: string;
                bq?: string;
                dq?: string;
                sGamma?: string;
                iGamma?: string;
                gGamma?: string;
                bGamma?: string;
                dGamma?: string;
                m?: string;
                mB?: string;
                mL?: string;
                nc?: string;
                nq?: string;
                nGamma?: string;
                rdmax?: string;
            }
            interface BearingResFormula_json_in {
                __proto_name?: unknown;
                sc?: unknown;
                ic?: unknown;
                gc?: unknown;
                bc?: unknown;
                dc?: unknown;
                sq?: unknown;
                iq?: unknown;
                gq?: unknown;
                bq?: unknown;
                dq?: unknown;
                sGamma?: unknown;
                iGamma?: unknown;
                gGamma?: unknown;
                bGamma?: unknown;
                dGamma?: unknown;
                m?: unknown;
                mB?: unknown;
                mL?: unknown;
                nc?: unknown;
                nq?: unknown;
                nGamma?: unknown;
                rdmax?: unknown;
            }
            export class BearingResFormula {
                __proto_name = "ng.result.foundation.BearingResFormula";
                sc: string = "";
                ic: string = "";
                gc: string = "";
                bc: string = "";
                dc: string = "";
                sq: string = "";
                iq: string = "";
                gq: string = "";
                bq: string = "";
                dq: string = "";
                sGamma: string = "";
                iGamma: string = "";
                gGamma: string = "";
                bGamma: string = "";
                dGamma: string = "";
                m: string = "";
                mB: string = "";
                mL: string = "";
                nc: string = "";
                nq: string = "";
                nGamma: string = "";
                rdmax: string = "";

                static fromObject(src_unknown: unknown): BearingResFormula {
                    const dst = new BearingResFormula();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BearingResFormula but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BearingResFormula_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BearingResFormula but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sc !== undefined && src.sc !== null) {
                        if (typeof src.sc === "string") {
                            dst.sc = src.sc;
                        }
                        else {
                            console.log('Expected sc of BearingResFormula to be a string but was ', typeof src.sc, src.sc)
                        }
                    }
                    if (src.ic !== undefined && src.ic !== null) {
                        if (typeof src.ic === "string") {
                            dst.ic = src.ic;
                        }
                        else {
                            console.log('Expected ic of BearingResFormula to be a string but was ', typeof src.ic, src.ic)
                        }
                    }
                    if (src.gc !== undefined && src.gc !== null) {
                        if (typeof src.gc === "string") {
                            dst.gc = src.gc;
                        }
                        else {
                            console.log('Expected gc of BearingResFormula to be a string but was ', typeof src.gc, src.gc)
                        }
                    }
                    if (src.bc !== undefined && src.bc !== null) {
                        if (typeof src.bc === "string") {
                            dst.bc = src.bc;
                        }
                        else {
                            console.log('Expected bc of BearingResFormula to be a string but was ', typeof src.bc, src.bc)
                        }
                    }
                    if (src.dc !== undefined && src.dc !== null) {
                        if (typeof src.dc === "string") {
                            dst.dc = src.dc;
                        }
                        else {
                            console.log('Expected dc of BearingResFormula to be a string but was ', typeof src.dc, src.dc)
                        }
                    }
                    if (src.sq !== undefined && src.sq !== null) {
                        if (typeof src.sq === "string") {
                            dst.sq = src.sq;
                        }
                        else {
                            console.log('Expected sq of BearingResFormula to be a string but was ', typeof src.sq, src.sq)
                        }
                    }
                    if (src.iq !== undefined && src.iq !== null) {
                        if (typeof src.iq === "string") {
                            dst.iq = src.iq;
                        }
                        else {
                            console.log('Expected iq of BearingResFormula to be a string but was ', typeof src.iq, src.iq)
                        }
                    }
                    if (src.gq !== undefined && src.gq !== null) {
                        if (typeof src.gq === "string") {
                            dst.gq = src.gq;
                        }
                        else {
                            console.log('Expected gq of BearingResFormula to be a string but was ', typeof src.gq, src.gq)
                        }
                    }
                    if (src.bq !== undefined && src.bq !== null) {
                        if (typeof src.bq === "string") {
                            dst.bq = src.bq;
                        }
                        else {
                            console.log('Expected bq of BearingResFormula to be a string but was ', typeof src.bq, src.bq)
                        }
                    }
                    if (src.dq !== undefined && src.dq !== null) {
                        if (typeof src.dq === "string") {
                            dst.dq = src.dq;
                        }
                        else {
                            console.log('Expected dq of BearingResFormula to be a string but was ', typeof src.dq, src.dq)
                        }
                    }
                    if (src.sGamma !== undefined && src.sGamma !== null) {
                        if (typeof src.sGamma === "string") {
                            dst.sGamma = src.sGamma;
                        }
                        else {
                            console.log('Expected sGamma of BearingResFormula to be a string but was ', typeof src.sGamma, src.sGamma)
                        }
                    }
                    if (src.iGamma !== undefined && src.iGamma !== null) {
                        if (typeof src.iGamma === "string") {
                            dst.iGamma = src.iGamma;
                        }
                        else {
                            console.log('Expected iGamma of BearingResFormula to be a string but was ', typeof src.iGamma, src.iGamma)
                        }
                    }
                    if (src.gGamma !== undefined && src.gGamma !== null) {
                        if (typeof src.gGamma === "string") {
                            dst.gGamma = src.gGamma;
                        }
                        else {
                            console.log('Expected gGamma of BearingResFormula to be a string but was ', typeof src.gGamma, src.gGamma)
                        }
                    }
                    if (src.bGamma !== undefined && src.bGamma !== null) {
                        if (typeof src.bGamma === "string") {
                            dst.bGamma = src.bGamma;
                        }
                        else {
                            console.log('Expected bGamma of BearingResFormula to be a string but was ', typeof src.bGamma, src.bGamma)
                        }
                    }
                    if (src.dGamma !== undefined && src.dGamma !== null) {
                        if (typeof src.dGamma === "string") {
                            dst.dGamma = src.dGamma;
                        }
                        else {
                            console.log('Expected dGamma of BearingResFormula to be a string but was ', typeof src.dGamma, src.dGamma)
                        }
                    }
                    if (src.m !== undefined && src.m !== null) {
                        if (typeof src.m === "string") {
                            dst.m = src.m;
                        }
                        else {
                            console.log('Expected m of BearingResFormula to be a string but was ', typeof src.m, src.m)
                        }
                    }
                    if (src.mB !== undefined && src.mB !== null) {
                        if (typeof src.mB === "string") {
                            dst.mB = src.mB;
                        }
                        else {
                            console.log('Expected mB of BearingResFormula to be a string but was ', typeof src.mB, src.mB)
                        }
                    }
                    if (src.mL !== undefined && src.mL !== null) {
                        if (typeof src.mL === "string") {
                            dst.mL = src.mL;
                        }
                        else {
                            console.log('Expected mL of BearingResFormula to be a string but was ', typeof src.mL, src.mL)
                        }
                    }
                    if (src.nc !== undefined && src.nc !== null) {
                        if (typeof src.nc === "string") {
                            dst.nc = src.nc;
                        }
                        else {
                            console.log('Expected nc of BearingResFormula to be a string but was ', typeof src.nc, src.nc)
                        }
                    }
                    if (src.nq !== undefined && src.nq !== null) {
                        if (typeof src.nq === "string") {
                            dst.nq = src.nq;
                        }
                        else {
                            console.log('Expected nq of BearingResFormula to be a string but was ', typeof src.nq, src.nq)
                        }
                    }
                    if (src.nGamma !== undefined && src.nGamma !== null) {
                        if (typeof src.nGamma === "string") {
                            dst.nGamma = src.nGamma;
                        }
                        else {
                            console.log('Expected nGamma of BearingResFormula to be a string but was ', typeof src.nGamma, src.nGamma)
                        }
                    }
                    if (src.rdmax !== undefined && src.rdmax !== null) {
                        if (typeof src.rdmax === "string") {
                            dst.rdmax = src.rdmax;
                        }
                        else {
                            console.log('Expected rdmax of BearingResFormula to be a string but was ', typeof src.rdmax, src.rdmax)
                        }
                    }
                    return dst;
                }

                static toObject(src: BearingResFormula | null | undefined): BearingResFormula_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.BearingResFormula is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.BearingResFormula") {
                        console.error('Expected ng.result.foundation.BearingResFormula but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BearingResFormula_json = {
                        sc: src.sc,
                        ic: src.ic,
                        gc: src.gc,
                        bc: src.bc,
                        dc: src.dc,
                        sq: src.sq,
                        iq: src.iq,
                        gq: src.gq,
                        bq: src.bq,
                        dq: src.dq,
                        sGamma: src.sGamma,
                        iGamma: src.iGamma,
                        gGamma: src.gGamma,
                        bGamma: src.bGamma,
                        dGamma: src.dGamma,
                        m: src.m,
                        mB: src.mB,
                        mL: src.mL,
                        nc: src.nc,
                        nq: src.nq,
                        nGamma: src.nGamma,
                        rdmax: src.rdmax,
                    };
                    return dst;
                }

                static create(src?: BearingResFormula_createType) {
                    const dst = new BearingResFormula();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sc !== undefined) {
                        dst.sc = src.sc;
                    }
                    if (src.ic !== undefined) {
                        dst.ic = src.ic;
                    }
                    if (src.gc !== undefined) {
                        dst.gc = src.gc;
                    }
                    if (src.bc !== undefined) {
                        dst.bc = src.bc;
                    }
                    if (src.dc !== undefined) {
                        dst.dc = src.dc;
                    }
                    if (src.sq !== undefined) {
                        dst.sq = src.sq;
                    }
                    if (src.iq !== undefined) {
                        dst.iq = src.iq;
                    }
                    if (src.gq !== undefined) {
                        dst.gq = src.gq;
                    }
                    if (src.bq !== undefined) {
                        dst.bq = src.bq;
                    }
                    if (src.dq !== undefined) {
                        dst.dq = src.dq;
                    }
                    if (src.sGamma !== undefined) {
                        dst.sGamma = src.sGamma;
                    }
                    if (src.iGamma !== undefined) {
                        dst.iGamma = src.iGamma;
                    }
                    if (src.gGamma !== undefined) {
                        dst.gGamma = src.gGamma;
                    }
                    if (src.bGamma !== undefined) {
                        dst.bGamma = src.bGamma;
                    }
                    if (src.dGamma !== undefined) {
                        dst.dGamma = src.dGamma;
                    }
                    if (src.m !== undefined) {
                        dst.m = src.m;
                    }
                    if (src.mB !== undefined) {
                        dst.mB = src.mB;
                    }
                    if (src.mL !== undefined) {
                        dst.mL = src.mL;
                    }
                    if (src.nc !== undefined) {
                        dst.nc = src.nc;
                    }
                    if (src.nq !== undefined) {
                        dst.nq = src.nq;
                    }
                    if (src.nGamma !== undefined) {
                        dst.nGamma = src.nGamma;
                    }
                    if (src.rdmax !== undefined) {
                        dst.rdmax = src.rdmax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BearingResFormula();
                    dst.sc = this.sc;
                    dst.ic = this.ic;
                    dst.gc = this.gc;
                    dst.bc = this.bc;
                    dst.dc = this.dc;
                    dst.sq = this.sq;
                    dst.iq = this.iq;
                    dst.gq = this.gq;
                    dst.bq = this.bq;
                    dst.dq = this.dq;
                    dst.sGamma = this.sGamma;
                    dst.iGamma = this.iGamma;
                    dst.gGamma = this.gGamma;
                    dst.bGamma = this.bGamma;
                    dst.dGamma = this.dGamma;
                    dst.m = this.m;
                    dst.mB = this.mB;
                    dst.mL = this.mL;
                    dst.nc = this.nc;
                    dst.nq = this.nq;
                    dst.nGamma = this.nGamma;
                    dst.rdmax = this.rdmax;
                    return dst;
                }

                deepClone() {
                    const json = BearingResFormula.toObject(this);
                    const dst = BearingResFormula.fromObject(json);
                    return dst;
                }
            }
            export type IBearingResFormula = BearingResFormula;


            export type DesignStrength_keys = 'cud' | 'cd' | 'phid' | 'deltad' | 'ad' | 'rk' | 'cu2d' | 'rocka' | 'rocks' | 'rockmb';
            export interface DesignStrength_createType {
                cud?: number,
                cd?: number,
                phid?: number,
                deltad?: number,
                ad?: number,
                rk?: number,
                cu2d?: number,
                rocka?: number,
                rocks?: number,
                rockmb?: number,
            }
            export interface DesignStrength_json {
                cud?: JsonNumber;
                cd?: JsonNumber;
                phid?: JsonNumber;
                deltad?: JsonNumber;
                ad?: JsonNumber;
                rk?: JsonNumber;
                cu2d?: JsonNumber;
                rocka?: JsonNumber;
                rocks?: JsonNumber;
                rockmb?: JsonNumber;
            }
            interface DesignStrength_json_in {
                __proto_name?: unknown;
                cud?: unknown;
                cd?: unknown;
                phid?: unknown;
                deltad?: unknown;
                ad?: unknown;
                rk?: unknown;
                cu2d?: unknown;
                rocka?: unknown;
                rocks?: unknown;
                rockmb?: unknown;
            }
            export class DesignStrength {
                __proto_name = "ng.result.foundation.DesignStrength";
                cud: number = 0;
                cd: number = 0;
                phid: number = 0;
                deltad: number = 0;
                ad: number = 0;
                rk: number = 0;
                cu2d: number = 0;
                rocka: number = 0;
                rocks: number = 0;
                rockmb: number = 0;

                static fromObject(src_unknown: unknown): DesignStrength {
                    const dst = new DesignStrength();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignStrength but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignStrength_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignStrength but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.cud !== undefined && src.cud !== null) {
                        if (typeof src.cud === "number" || src.cud === 'NaN' || src.cud === 'Infinity' || src.cud === '-Infinity') {
                            dst.cud = AsNum(src.cud);
                        }
                        else {
                            console.log('Expected cud of DesignStrength to be a number but was ', typeof src.cud, src.cud)
                        }
                    }
                    if (src.cd !== undefined && src.cd !== null) {
                        if (typeof src.cd === "number" || src.cd === 'NaN' || src.cd === 'Infinity' || src.cd === '-Infinity') {
                            dst.cd = AsNum(src.cd);
                        }
                        else {
                            console.log('Expected cd of DesignStrength to be a number but was ', typeof src.cd, src.cd)
                        }
                    }
                    if (src.phid !== undefined && src.phid !== null) {
                        if (typeof src.phid === "number" || src.phid === 'NaN' || src.phid === 'Infinity' || src.phid === '-Infinity') {
                            dst.phid = AsNum(src.phid);
                        }
                        else {
                            console.log('Expected phid of DesignStrength to be a number but was ', typeof src.phid, src.phid)
                        }
                    }
                    if (src.deltad !== undefined && src.deltad !== null) {
                        if (typeof src.deltad === "number" || src.deltad === 'NaN' || src.deltad === 'Infinity' || src.deltad === '-Infinity') {
                            dst.deltad = AsNum(src.deltad);
                        }
                        else {
                            console.log('Expected deltad of DesignStrength to be a number but was ', typeof src.deltad, src.deltad)
                        }
                    }
                    if (src.ad !== undefined && src.ad !== null) {
                        if (typeof src.ad === "number" || src.ad === 'NaN' || src.ad === 'Infinity' || src.ad === '-Infinity') {
                            dst.ad = AsNum(src.ad);
                        }
                        else {
                            console.log('Expected ad of DesignStrength to be a number but was ', typeof src.ad, src.ad)
                        }
                    }
                    if (src.rk !== undefined && src.rk !== null) {
                        if (typeof src.rk === "number" || src.rk === 'NaN' || src.rk === 'Infinity' || src.rk === '-Infinity') {
                            dst.rk = AsNum(src.rk);
                        }
                        else {
                            console.log('Expected rk of DesignStrength to be a number but was ', typeof src.rk, src.rk)
                        }
                    }
                    if (src.cu2d !== undefined && src.cu2d !== null) {
                        if (typeof src.cu2d === "number" || src.cu2d === 'NaN' || src.cu2d === 'Infinity' || src.cu2d === '-Infinity') {
                            dst.cu2d = AsNum(src.cu2d);
                        }
                        else {
                            console.log('Expected cu2d of DesignStrength to be a number but was ', typeof src.cu2d, src.cu2d)
                        }
                    }
                    if (src.rocka !== undefined && src.rocka !== null) {
                        if (typeof src.rocka === "number" || src.rocka === 'NaN' || src.rocka === 'Infinity' || src.rocka === '-Infinity') {
                            dst.rocka = AsNum(src.rocka);
                        }
                        else {
                            console.log('Expected rocka of DesignStrength to be a number but was ', typeof src.rocka, src.rocka)
                        }
                    }
                    if (src.rocks !== undefined && src.rocks !== null) {
                        if (typeof src.rocks === "number" || src.rocks === 'NaN' || src.rocks === 'Infinity' || src.rocks === '-Infinity') {
                            dst.rocks = AsNum(src.rocks);
                        }
                        else {
                            console.log('Expected rocks of DesignStrength to be a number but was ', typeof src.rocks, src.rocks)
                        }
                    }
                    if (src.rockmb !== undefined && src.rockmb !== null) {
                        if (typeof src.rockmb === "number" || src.rockmb === 'NaN' || src.rockmb === 'Infinity' || src.rockmb === '-Infinity') {
                            dst.rockmb = AsNum(src.rockmb);
                        }
                        else {
                            console.log('Expected rockmb of DesignStrength to be a number but was ', typeof src.rockmb, src.rockmb)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignStrength | null | undefined): DesignStrength_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.DesignStrength is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.DesignStrength") {
                        console.error('Expected ng.result.foundation.DesignStrength but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DesignStrength_json = {
                        cud: AsJsonNum(src.cud),
                        cd: AsJsonNum(src.cd),
                        phid: AsJsonNum(src.phid),
                        deltad: AsJsonNum(src.deltad),
                        ad: AsJsonNum(src.ad),
                        rk: AsJsonNum(src.rk),
                        cu2d: AsJsonNum(src.cu2d),
                        rocka: AsJsonNum(src.rocka),
                        rocks: AsJsonNum(src.rocks),
                        rockmb: AsJsonNum(src.rockmb),
                    };
                    return dst;
                }

                static create(src?: DesignStrength_createType) {
                    const dst = new DesignStrength();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.cud !== undefined) {
                        dst.cud = src.cud;
                    }
                    if (src.cd !== undefined) {
                        dst.cd = src.cd;
                    }
                    if (src.phid !== undefined) {
                        dst.phid = src.phid;
                    }
                    if (src.deltad !== undefined) {
                        dst.deltad = src.deltad;
                    }
                    if (src.ad !== undefined) {
                        dst.ad = src.ad;
                    }
                    if (src.rk !== undefined) {
                        dst.rk = src.rk;
                    }
                    if (src.cu2d !== undefined) {
                        dst.cu2d = src.cu2d;
                    }
                    if (src.rocka !== undefined) {
                        dst.rocka = src.rocka;
                    }
                    if (src.rocks !== undefined) {
                        dst.rocks = src.rocks;
                    }
                    if (src.rockmb !== undefined) {
                        dst.rockmb = src.rockmb;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignStrength();
                    dst.cud = this.cud;
                    dst.cd = this.cd;
                    dst.phid = this.phid;
                    dst.deltad = this.deltad;
                    dst.ad = this.ad;
                    dst.rk = this.rk;
                    dst.cu2d = this.cu2d;
                    dst.rocka = this.rocka;
                    dst.rocks = this.rocks;
                    dst.rockmb = this.rockmb;
                    return dst;
                }

                deepClone() {
                    const json = DesignStrength.toObject(this);
                    const dst = DesignStrength.fromObject(json);
                    return dst;
                }
            }
            export type IDesignStrength = DesignStrength;


            export type SlidingRes_keys = 'rD' | 'utilization' | 'hd' | 'hxd' | 'hyd' | 'control';
            export interface SlidingRes_createType {
                rD?: number,
                utilization?: number,
                hd?: number,
                hxd?: number,
                hyd?: number,
                control?: ng.result.control.ControlData | null,
            }
            export interface SlidingRes_json {
                rD?: JsonNumber;
                utilization?: JsonNumber;
                hd?: JsonNumber;
                hxd?: JsonNumber;
                hyd?: JsonNumber;
                control?: ng.result.control.ControlData_json;
            }
            interface SlidingRes_json_in {
                __proto_name?: unknown;
                rD?: unknown;
                utilization?: unknown;
                hd?: unknown;
                hxd?: unknown;
                hyd?: unknown;
                control?: unknown;
            }
            export class SlidingRes {
                __proto_name = "ng.result.foundation.SlidingRes";
                rD: number = 0;
                utilization: number = 0;
                hd: number = 0;
                hxd: number = 0;
                hyd: number = 0;
                control: ng.result.control.ControlData | null = null;

                static fromObject(src_unknown: unknown): SlidingRes {
                    const dst = new SlidingRes();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SlidingRes but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SlidingRes_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SlidingRes but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rD !== undefined && src.rD !== null) {
                        if (typeof src.rD === "number" || src.rD === 'NaN' || src.rD === 'Infinity' || src.rD === '-Infinity') {
                            dst.rD = AsNum(src.rD);
                        }
                        else {
                            console.log('Expected rD of SlidingRes to be a number but was ', typeof src.rD, src.rD)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of SlidingRes to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.hd !== undefined && src.hd !== null) {
                        if (typeof src.hd === "number" || src.hd === 'NaN' || src.hd === 'Infinity' || src.hd === '-Infinity') {
                            dst.hd = AsNum(src.hd);
                        }
                        else {
                            console.log('Expected hd of SlidingRes to be a number but was ', typeof src.hd, src.hd)
                        }
                    }
                    if (src.hxd !== undefined && src.hxd !== null) {
                        if (typeof src.hxd === "number" || src.hxd === 'NaN' || src.hxd === 'Infinity' || src.hxd === '-Infinity') {
                            dst.hxd = AsNum(src.hxd);
                        }
                        else {
                            console.log('Expected hxd of SlidingRes to be a number but was ', typeof src.hxd, src.hxd)
                        }
                    }
                    if (src.hyd !== undefined && src.hyd !== null) {
                        if (typeof src.hyd === "number" || src.hyd === 'NaN' || src.hyd === 'Infinity' || src.hyd === '-Infinity') {
                            dst.hyd = AsNum(src.hyd);
                        }
                        else {
                            console.log('Expected hyd of SlidingRes to be a number but was ', typeof src.hyd, src.hyd)
                        }
                    }
                    if (src.control !== undefined && src.control !== null) {
                        dst.control = ng.result.control.ControlData.fromObject(src.control);
                    }
                    return dst;
                }

                static toObject(src: SlidingRes | null | undefined): SlidingRes_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.SlidingRes is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.SlidingRes") {
                        console.error('Expected ng.result.foundation.SlidingRes but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SlidingRes_json = {
                        rD: AsJsonNum(src.rD),
                        utilization: AsJsonNum(src.utilization),
                        hd: AsJsonNum(src.hd),
                        hxd: AsJsonNum(src.hxd),
                        hyd: AsJsonNum(src.hyd),
                    };
                    if(src.control !== null)
                    {
                        const parsed = ng.result.control.ControlData.toObject(src.control);
                        if(parsed === null) return null;
                        dst.control = parsed;
                    }
                    return dst;
                }

                static create(src?: SlidingRes_createType) {
                    const dst = new SlidingRes();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rD !== undefined) {
                        dst.rD = src.rD;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.hd !== undefined) {
                        dst.hd = src.hd;
                    }
                    if (src.hxd !== undefined) {
                        dst.hxd = src.hxd;
                    }
                    if (src.hyd !== undefined) {
                        dst.hyd = src.hyd;
                    }
                    if (src.control !== undefined) {
                        dst.control = src.control;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SlidingRes();
                    dst.rD = this.rD;
                    dst.utilization = this.utilization;
                    dst.hd = this.hd;
                    dst.hxd = this.hxd;
                    dst.hyd = this.hyd;
                    dst.control = this.control;
                    return dst;
                }

                deepClone() {
                    const json = SlidingRes.toObject(this);
                    const dst = SlidingRes.fromObject(json);
                    return dst;
                }
            }
            export type ISlidingRes = SlidingRes;


            export type SlidingResFormula_keys = unknown;
            export interface SlidingResFormula_createType {
            }
            export interface SlidingResFormula_json {
            }
            interface SlidingResFormula_json_in {
                __proto_name?: unknown;
            }
            export class SlidingResFormula {
                __proto_name = "ng.result.foundation.SlidingResFormula";

                static fromObject(src_unknown: unknown): SlidingResFormula {
                    const dst = new SlidingResFormula();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SlidingResFormula but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SlidingResFormula_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SlidingResFormula but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: SlidingResFormula | null | undefined): SlidingResFormula_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.SlidingResFormula is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.SlidingResFormula") {
                        console.error('Expected ng.result.foundation.SlidingResFormula but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SlidingResFormula_json = {
                    };
                    return dst;
                }

                static create(src?: SlidingResFormula_createType) {
                    const dst = new SlidingResFormula();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SlidingResFormula();
                    return dst;
                }

                deepClone() {
                    const json = SlidingResFormula.toObject(this);
                    const dst = SlidingResFormula.fromObject(json);
                    return dst;
                }
            }
            export type ISlidingResFormula = SlidingResFormula;


            export type DetailedFoundationDesign_keys = 'id' | 'analysisType' | 'designType' | 'eccentricityType' | 'bearingResult' | 'slidingResult' | 'designStrength' | 'punchingLevel' | 'materialName';
            export interface DetailedFoundationDesign_createType {
                id?: ng.utils.ID | null,
                analysisType?: ng.result.control.AnalysisTypeFoundation,
                designType?: ng.result.control.DesignTypeFoundation,
                eccentricityType?: ng.result.control.EccentricityTypeFoundation,
                bearingResult?: ng.result.foundation.BearingRes | null,
                slidingResult?: ng.result.foundation.SlidingRes | null,
                designStrength?: ng.result.foundation.DesignStrength | null,
                punchingLevel?: number,
                materialName?: string,
            }
            export interface DetailedFoundationDesign_json {
                id?: ng.utils.ID_json;
                analysisType?: string;
                designType?: string;
                eccentricityType?: string;
                bearingResult?: ng.result.foundation.BearingRes_json;
                slidingResult?: ng.result.foundation.SlidingRes_json;
                designStrength?: ng.result.foundation.DesignStrength_json;
                punchingLevel?: JsonNumber;
                materialName?: string;
            }
            interface DetailedFoundationDesign_json_in {
                __proto_name?: unknown;
                id?: unknown;
                analysisType?: unknown;
                designType?: unknown;
                eccentricityType?: unknown;
                bearingResult?: unknown;
                slidingResult?: unknown;
                designStrength?: unknown;
                punchingLevel?: unknown;
                materialName?: unknown;
            }
            export class DetailedFoundationDesign {
                __proto_name = "ng.result.foundation.DetailedFoundationDesign";
                id: ng.utils.ID | null = null;
                analysisType: ng.result.control.AnalysisTypeFoundation = ng.result.control.AnalysisTypeFoundation.ANALYSIS_TYPE_UNSPECIFIED;
                designType: ng.result.control.DesignTypeFoundation = ng.result.control.DesignTypeFoundation.DESIGN_TYPE_UNSPECIFIED;
                eccentricityType: ng.result.control.EccentricityTypeFoundation = ng.result.control.EccentricityTypeFoundation.ECCENTRICITY_TYPE_UNSPECIFIED;
                bearingResult: ng.result.foundation.BearingRes | null = null;
                slidingResult: ng.result.foundation.SlidingRes | null = null;
                designStrength: ng.result.foundation.DesignStrength | null = null;
                punchingLevel: number = 0;
                materialName: string = "";

                static fromObject(src_unknown: unknown): DetailedFoundationDesign {
                    const dst = new DetailedFoundationDesign();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DetailedFoundationDesign but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DetailedFoundationDesign_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DetailedFoundationDesign but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.analysisType !== undefined && src.analysisType !== null) {
                        dst.analysisType = ng.result.control.AnalysisTypeFoundation_FromObject(src.analysisType);
                    }
                    if (src.designType !== undefined && src.designType !== null) {
                        dst.designType = ng.result.control.DesignTypeFoundation_FromObject(src.designType);
                    }
                    if (src.eccentricityType !== undefined && src.eccentricityType !== null) {
                        dst.eccentricityType = ng.result.control.EccentricityTypeFoundation_FromObject(src.eccentricityType);
                    }
                    if (src.bearingResult !== undefined && src.bearingResult !== null) {
                        dst.bearingResult = ng.result.foundation.BearingRes.fromObject(src.bearingResult);
                    }
                    if (src.slidingResult !== undefined && src.slidingResult !== null) {
                        dst.slidingResult = ng.result.foundation.SlidingRes.fromObject(src.slidingResult);
                    }
                    if (src.designStrength !== undefined && src.designStrength !== null) {
                        dst.designStrength = ng.result.foundation.DesignStrength.fromObject(src.designStrength);
                    }
                    if (src.punchingLevel !== undefined && src.punchingLevel !== null) {
                        if (typeof src.punchingLevel === "number" || src.punchingLevel === 'NaN' || src.punchingLevel === 'Infinity' || src.punchingLevel === '-Infinity') {
                            dst.punchingLevel = AsNum(src.punchingLevel);
                        }
                        else {
                            console.log('Expected punchingLevel of DetailedFoundationDesign to be a number but was ', typeof src.punchingLevel, src.punchingLevel)
                        }
                    }
                    if (src.materialName !== undefined && src.materialName !== null) {
                        if (typeof src.materialName === "string") {
                            dst.materialName = src.materialName;
                        }
                        else {
                            console.log('Expected materialName of DetailedFoundationDesign to be a string but was ', typeof src.materialName, src.materialName)
                        }
                    }
                    return dst;
                }

                static toObject(src: DetailedFoundationDesign | null | undefined): DetailedFoundationDesign_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.DetailedFoundationDesign is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.DetailedFoundationDesign") {
                        console.error('Expected ng.result.foundation.DetailedFoundationDesign but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const analysisType_obj = ng.result.control.AnalysisTypeFoundation_ToObject(src.analysisType);
                    if(analysisType_obj === null) return null;

                    const designType_obj = ng.result.control.DesignTypeFoundation_ToObject(src.designType);
                    if(designType_obj === null) return null;

                    const eccentricityType_obj = ng.result.control.EccentricityTypeFoundation_ToObject(src.eccentricityType);
                    if(eccentricityType_obj === null) return null;

                    const dst : DetailedFoundationDesign_json = {
                        analysisType: analysisType_obj,
                        designType: designType_obj,
                        eccentricityType: eccentricityType_obj,
                        punchingLevel: AsJsonNum(src.punchingLevel),
                        materialName: src.materialName,
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.bearingResult !== null)
                    {
                        const parsed = ng.result.foundation.BearingRes.toObject(src.bearingResult);
                        if(parsed === null) return null;
                        dst.bearingResult = parsed;
                    }
                    if(src.slidingResult !== null)
                    {
                        const parsed = ng.result.foundation.SlidingRes.toObject(src.slidingResult);
                        if(parsed === null) return null;
                        dst.slidingResult = parsed;
                    }
                    if(src.designStrength !== null)
                    {
                        const parsed = ng.result.foundation.DesignStrength.toObject(src.designStrength);
                        if(parsed === null) return null;
                        dst.designStrength = parsed;
                    }
                    return dst;
                }

                static create(src?: DetailedFoundationDesign_createType) {
                    const dst = new DetailedFoundationDesign();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.analysisType !== undefined) {
                        dst.analysisType = src.analysisType;
                    }
                    if (src.designType !== undefined) {
                        dst.designType = src.designType;
                    }
                    if (src.eccentricityType !== undefined) {
                        dst.eccentricityType = src.eccentricityType;
                    }
                    if (src.bearingResult !== undefined) {
                        dst.bearingResult = src.bearingResult;
                    }
                    if (src.slidingResult !== undefined) {
                        dst.slidingResult = src.slidingResult;
                    }
                    if (src.designStrength !== undefined) {
                        dst.designStrength = src.designStrength;
                    }
                    if (src.punchingLevel !== undefined) {
                        dst.punchingLevel = src.punchingLevel;
                    }
                    if (src.materialName !== undefined) {
                        dst.materialName = src.materialName;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DetailedFoundationDesign();
                    dst.id = this.id;
                    dst.analysisType = this.analysisType;
                    dst.designType = this.designType;
                    dst.eccentricityType = this.eccentricityType;
                    dst.bearingResult = this.bearingResult;
                    dst.slidingResult = this.slidingResult;
                    dst.designStrength = this.designStrength;
                    dst.punchingLevel = this.punchingLevel;
                    dst.materialName = this.materialName;
                    return dst;
                }

                deepClone() {
                    const json = DetailedFoundationDesign.toObject(this);
                    const dst = DetailedFoundationDesign.fromObject(json);
                    return dst;
                }
            }
            export type IDetailedFoundationDesign = DetailedFoundationDesign;


            export type RCPunchingCheckConcreteCompression_keys = 'beta' | 'dy' | 'dz' | 'deff' | 'rhol' | 'rholx' | 'rholy' | 'u0' | 'perimeterPointsU0' | 'a' | 'u1' | 'perimeterPointsU1' | 'nu' | 'VEd0' | 'VEd1' | 'vEd' | 'vRdmax' | 'vRdc' | 'nyRdmax' | 'nyRdc' | 'nyMin' | 'nyEd0' | 'nyEd1' | 'k' | 'k1' | 'crdc' | 'eta' | 'densityclass' | 'utilization' | 'utilization0' | 'utilization1' | 'punchZone' | 'perimeterNo' | 'shapeNo' | 'V' | 'M1' | 'M2' | 'sigmacp' | 'dBx' | 'dBy' | 'ddg' | 'kpb' | 'gammaShear';
            export interface RCPunchingCheckConcreteCompression_createType {
                beta?: number,
                dy?: number,
                dz?: number,
                deff?: number,
                rhol?: number,
                rholx?: number,
                rholy?: number,
                u0?: number,
                perimeterPointsU0?: ng.geometry.Point2D[],
                a?: number,
                u1?: number,
                perimeterPointsU1?: ng.geometry.Point2D[],
                nu?: number,
                VEd0?: number,
                VEd1?: number,
                vEd?: number,
                vRdmax?: number,
                vRdc?: number,
                nyRdmax?: number,
                nyRdc?: number,
                nyMin?: number,
                nyEd0?: number,
                nyEd1?: number,
                k?: number,
                k1?: number,
                crdc?: number,
                eta?: number,
                densityclass?: number,
                utilization?: number,
                utilization0?: number,
                utilization1?: number,
                punchZone?: number,
                perimeterNo?: number,
                shapeNo?: number,
                V?: number,
                M1?: number,
                M2?: number,
                sigmacp?: number,
                dBx?: number,
                dBy?: number,
                ddg?: number,
                kpb?: number,
                gammaShear?: number,
            }
            export interface RCPunchingCheckConcreteCompression_json {
                beta?: JsonNumber;
                dy?: JsonNumber;
                dz?: JsonNumber;
                deff?: JsonNumber;
                rhol?: JsonNumber;
                rholx?: JsonNumber;
                rholy?: JsonNumber;
                u0?: JsonNumber;
                perimeterPointsU0: ng.geometry.Point2D_json[];
                a?: JsonNumber;
                u1?: JsonNumber;
                perimeterPointsU1: ng.geometry.Point2D_json[];
                nu?: JsonNumber;
                VEd0?: JsonNumber;
                VEd1?: JsonNumber;
                vEd?: JsonNumber;
                vRdmax?: JsonNumber;
                vRdc?: JsonNumber;
                nyRdmax?: JsonNumber;
                nyRdc?: JsonNumber;
                nyMin?: JsonNumber;
                nyEd0?: JsonNumber;
                nyEd1?: JsonNumber;
                k?: JsonNumber;
                k1?: JsonNumber;
                crdc?: JsonNumber;
                eta?: JsonNumber;
                densityclass?: JsonNumber;
                utilization?: JsonNumber;
                utilization0?: JsonNumber;
                utilization1?: JsonNumber;
                punchZone?: JsonNumber;
                perimeterNo?: JsonNumber;
                shapeNo?: JsonNumber;
                V?: JsonNumber;
                M1?: JsonNumber;
                M2?: JsonNumber;
                sigmacp?: JsonNumber;
                dBx?: JsonNumber;
                dBy?: JsonNumber;
                ddg?: JsonNumber;
                kpb?: JsonNumber;
                gammaShear?: JsonNumber;
            }
            interface RCPunchingCheckConcreteCompression_json_in {
                __proto_name?: unknown;
                beta?: unknown;
                dy?: unknown;
                dz?: unknown;
                deff?: unknown;
                rhol?: unknown;
                rholx?: unknown;
                rholy?: unknown;
                u0?: unknown;
                perimeterPointsU0?: unknown;
                a?: unknown;
                u1?: unknown;
                perimeterPointsU1?: unknown;
                nu?: unknown;
                VEd0?: unknown;
                VEd1?: unknown;
                vEd?: unknown;
                vRdmax?: unknown;
                vRdc?: unknown;
                nyRdmax?: unknown;
                nyRdc?: unknown;
                nyMin?: unknown;
                nyEd0?: unknown;
                nyEd1?: unknown;
                k?: unknown;
                k1?: unknown;
                crdc?: unknown;
                eta?: unknown;
                densityclass?: unknown;
                utilization?: unknown;
                utilization0?: unknown;
                utilization1?: unknown;
                punchZone?: unknown;
                perimeterNo?: unknown;
                shapeNo?: unknown;
                V?: unknown;
                M1?: unknown;
                M2?: unknown;
                sigmacp?: unknown;
                dBx?: unknown;
                dBy?: unknown;
                ddg?: unknown;
                kpb?: unknown;
                gammaShear?: unknown;
            }
            export class RCPunchingCheckConcreteCompression {
                __proto_name = "ng.result.foundation.RCPunchingCheckConcreteCompression";
                beta: number = 0;
                dy: number = 0;
                dz: number = 0;
                deff: number = 0;
                rhol: number = 0;
                rholx: number = 0;
                rholy: number = 0;
                u0: number = 0;
                perimeterPointsU0: ng.geometry.Point2D[] = [];
                a: number = 0;
                u1: number = 0;
                perimeterPointsU1: ng.geometry.Point2D[] = [];
                nu: number = 0;
                VEd0: number = 0;
                VEd1: number = 0;
                vEd: number = 0;
                vRdmax: number = 0;
                vRdc: number = 0;
                nyRdmax: number = 0;
                nyRdc: number = 0;
                nyMin: number = 0;
                nyEd0: number = 0;
                nyEd1: number = 0;
                k: number = 0;
                k1: number = 0;
                crdc: number = 0;
                eta: number = 0;
                densityclass: number = 0;
                utilization: number = 0;
                utilization0: number = 0;
                utilization1: number = 0;
                punchZone: number = 0;
                perimeterNo: number = 0;
                shapeNo: number = 0;
                V: number = 0;
                M1: number = 0;
                M2: number = 0;
                sigmacp: number = 0;
                dBx: number = 0;
                dBy: number = 0;
                ddg: number = 0;
                kpb: number = 0;
                gammaShear: number = 0;

                static fromObject(src_unknown: unknown): RCPunchingCheckConcreteCompression {
                    const dst = new RCPunchingCheckConcreteCompression();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted RCPunchingCheckConcreteCompression but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as RCPunchingCheckConcreteCompression_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for RCPunchingCheckConcreteCompression but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                            dst.beta = AsNum(src.beta);
                        }
                        else {
                            console.log('Expected beta of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.beta, src.beta)
                        }
                    }
                    if (src.dy !== undefined && src.dy !== null) {
                        if (typeof src.dy === "number" || src.dy === 'NaN' || src.dy === 'Infinity' || src.dy === '-Infinity') {
                            dst.dy = AsNum(src.dy);
                        }
                        else {
                            console.log('Expected dy of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.dy, src.dy)
                        }
                    }
                    if (src.dz !== undefined && src.dz !== null) {
                        if (typeof src.dz === "number" || src.dz === 'NaN' || src.dz === 'Infinity' || src.dz === '-Infinity') {
                            dst.dz = AsNum(src.dz);
                        }
                        else {
                            console.log('Expected dz of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.dz, src.dz)
                        }
                    }
                    if (src.deff !== undefined && src.deff !== null) {
                        if (typeof src.deff === "number" || src.deff === 'NaN' || src.deff === 'Infinity' || src.deff === '-Infinity') {
                            dst.deff = AsNum(src.deff);
                        }
                        else {
                            console.log('Expected deff of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.deff, src.deff)
                        }
                    }
                    if (src.rhol !== undefined && src.rhol !== null) {
                        if (typeof src.rhol === "number" || src.rhol === 'NaN' || src.rhol === 'Infinity' || src.rhol === '-Infinity') {
                            dst.rhol = AsNum(src.rhol);
                        }
                        else {
                            console.log('Expected rhol of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.rhol, src.rhol)
                        }
                    }
                    if (src.rholx !== undefined && src.rholx !== null) {
                        if (typeof src.rholx === "number" || src.rholx === 'NaN' || src.rholx === 'Infinity' || src.rholx === '-Infinity') {
                            dst.rholx = AsNum(src.rholx);
                        }
                        else {
                            console.log('Expected rholx of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.rholx, src.rholx)
                        }
                    }
                    if (src.rholy !== undefined && src.rholy !== null) {
                        if (typeof src.rholy === "number" || src.rholy === 'NaN' || src.rholy === 'Infinity' || src.rholy === '-Infinity') {
                            dst.rholy = AsNum(src.rholy);
                        }
                        else {
                            console.log('Expected rholy of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.rholy, src.rholy)
                        }
                    }
                    if (src.u0 !== undefined && src.u0 !== null) {
                        if (typeof src.u0 === "number" || src.u0 === 'NaN' || src.u0 === 'Infinity' || src.u0 === '-Infinity') {
                            dst.u0 = AsNum(src.u0);
                        }
                        else {
                            console.log('Expected u0 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.u0, src.u0)
                        }
                    }
                    if (src.perimeterPointsU0 !== undefined && src.perimeterPointsU0 !== null) {
                        if (Array.isArray(src.perimeterPointsU0)) {
                            for (const element of src.perimeterPointsU0) {
                                dst.perimeterPointsU0.push(ng.geometry.Point2D.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected perimeterPointsU0 of RCPunchingCheckConcreteCompression to be a array but was ', typeof src.perimeterPointsU0, src.perimeterPointsU0)
                        }
                    }
                    if (src.a !== undefined && src.a !== null) {
                        if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                            dst.a = AsNum(src.a);
                        }
                        else {
                            console.log('Expected a of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.a, src.a)
                        }
                    }
                    if (src.u1 !== undefined && src.u1 !== null) {
                        if (typeof src.u1 === "number" || src.u1 === 'NaN' || src.u1 === 'Infinity' || src.u1 === '-Infinity') {
                            dst.u1 = AsNum(src.u1);
                        }
                        else {
                            console.log('Expected u1 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.u1, src.u1)
                        }
                    }
                    if (src.perimeterPointsU1 !== undefined && src.perimeterPointsU1 !== null) {
                        if (Array.isArray(src.perimeterPointsU1)) {
                            for (const element of src.perimeterPointsU1) {
                                dst.perimeterPointsU1.push(ng.geometry.Point2D.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected perimeterPointsU1 of RCPunchingCheckConcreteCompression to be a array but was ', typeof src.perimeterPointsU1, src.perimeterPointsU1)
                        }
                    }
                    if (src.nu !== undefined && src.nu !== null) {
                        if (typeof src.nu === "number" || src.nu === 'NaN' || src.nu === 'Infinity' || src.nu === '-Infinity') {
                            dst.nu = AsNum(src.nu);
                        }
                        else {
                            console.log('Expected nu of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.nu, src.nu)
                        }
                    }
                    if (src.VEd0 !== undefined && src.VEd0 !== null) {
                        if (typeof src.VEd0 === "number" || src.VEd0 === 'NaN' || src.VEd0 === 'Infinity' || src.VEd0 === '-Infinity') {
                            dst.VEd0 = AsNum(src.VEd0);
                        }
                        else {
                            console.log('Expected VEd0 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.VEd0, src.VEd0)
                        }
                    }
                    if (src.VEd1 !== undefined && src.VEd1 !== null) {
                        if (typeof src.VEd1 === "number" || src.VEd1 === 'NaN' || src.VEd1 === 'Infinity' || src.VEd1 === '-Infinity') {
                            dst.VEd1 = AsNum(src.VEd1);
                        }
                        else {
                            console.log('Expected VEd1 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.VEd1, src.VEd1)
                        }
                    }
                    if (src.vEd !== undefined && src.vEd !== null) {
                        if (typeof src.vEd === "number" || src.vEd === 'NaN' || src.vEd === 'Infinity' || src.vEd === '-Infinity') {
                            dst.vEd = AsNum(src.vEd);
                        }
                        else {
                            console.log('Expected vEd of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.vEd, src.vEd)
                        }
                    }
                    if (src.vRdmax !== undefined && src.vRdmax !== null) {
                        if (typeof src.vRdmax === "number" || src.vRdmax === 'NaN' || src.vRdmax === 'Infinity' || src.vRdmax === '-Infinity') {
                            dst.vRdmax = AsNum(src.vRdmax);
                        }
                        else {
                            console.log('Expected vRdmax of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.vRdmax, src.vRdmax)
                        }
                    }
                    if (src.vRdc !== undefined && src.vRdc !== null) {
                        if (typeof src.vRdc === "number" || src.vRdc === 'NaN' || src.vRdc === 'Infinity' || src.vRdc === '-Infinity') {
                            dst.vRdc = AsNum(src.vRdc);
                        }
                        else {
                            console.log('Expected vRdc of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.vRdc, src.vRdc)
                        }
                    }
                    if (src.nyRdmax !== undefined && src.nyRdmax !== null) {
                        if (typeof src.nyRdmax === "number" || src.nyRdmax === 'NaN' || src.nyRdmax === 'Infinity' || src.nyRdmax === '-Infinity') {
                            dst.nyRdmax = AsNum(src.nyRdmax);
                        }
                        else {
                            console.log('Expected nyRdmax of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.nyRdmax, src.nyRdmax)
                        }
                    }
                    if (src.nyRdc !== undefined && src.nyRdc !== null) {
                        if (typeof src.nyRdc === "number" || src.nyRdc === 'NaN' || src.nyRdc === 'Infinity' || src.nyRdc === '-Infinity') {
                            dst.nyRdc = AsNum(src.nyRdc);
                        }
                        else {
                            console.log('Expected nyRdc of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.nyRdc, src.nyRdc)
                        }
                    }
                    if (src.nyMin !== undefined && src.nyMin !== null) {
                        if (typeof src.nyMin === "number" || src.nyMin === 'NaN' || src.nyMin === 'Infinity' || src.nyMin === '-Infinity') {
                            dst.nyMin = AsNum(src.nyMin);
                        }
                        else {
                            console.log('Expected nyMin of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.nyMin, src.nyMin)
                        }
                    }
                    if (src.nyEd0 !== undefined && src.nyEd0 !== null) {
                        if (typeof src.nyEd0 === "number" || src.nyEd0 === 'NaN' || src.nyEd0 === 'Infinity' || src.nyEd0 === '-Infinity') {
                            dst.nyEd0 = AsNum(src.nyEd0);
                        }
                        else {
                            console.log('Expected nyEd0 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.nyEd0, src.nyEd0)
                        }
                    }
                    if (src.nyEd1 !== undefined && src.nyEd1 !== null) {
                        if (typeof src.nyEd1 === "number" || src.nyEd1 === 'NaN' || src.nyEd1 === 'Infinity' || src.nyEd1 === '-Infinity') {
                            dst.nyEd1 = AsNum(src.nyEd1);
                        }
                        else {
                            console.log('Expected nyEd1 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.nyEd1, src.nyEd1)
                        }
                    }
                    if (src.k !== undefined && src.k !== null) {
                        if (typeof src.k === "number" || src.k === 'NaN' || src.k === 'Infinity' || src.k === '-Infinity') {
                            dst.k = AsNum(src.k);
                        }
                        else {
                            console.log('Expected k of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.k, src.k)
                        }
                    }
                    if (src.k1 !== undefined && src.k1 !== null) {
                        if (typeof src.k1 === "number" || src.k1 === 'NaN' || src.k1 === 'Infinity' || src.k1 === '-Infinity') {
                            dst.k1 = AsNum(src.k1);
                        }
                        else {
                            console.log('Expected k1 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.k1, src.k1)
                        }
                    }
                    if (src.crdc !== undefined && src.crdc !== null) {
                        if (typeof src.crdc === "number" || src.crdc === 'NaN' || src.crdc === 'Infinity' || src.crdc === '-Infinity') {
                            dst.crdc = AsNum(src.crdc);
                        }
                        else {
                            console.log('Expected crdc of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.crdc, src.crdc)
                        }
                    }
                    if (src.eta !== undefined && src.eta !== null) {
                        if (typeof src.eta === "number" || src.eta === 'NaN' || src.eta === 'Infinity' || src.eta === '-Infinity') {
                            dst.eta = AsNum(src.eta);
                        }
                        else {
                            console.log('Expected eta of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.eta, src.eta)
                        }
                    }
                    if (src.densityclass !== undefined && src.densityclass !== null) {
                        if (typeof src.densityclass === "number" || src.densityclass === 'NaN' || src.densityclass === 'Infinity' || src.densityclass === '-Infinity') {
                            dst.densityclass = NumberToInt("ng.result.foundation.RCPunchingCheckConcreteCompression.densityclass", AsNum(src.densityclass));
                        }
                        else {
                            console.log('Expected densityclass of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.densityclass, src.densityclass)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.utilization0 !== undefined && src.utilization0 !== null) {
                        if (typeof src.utilization0 === "number" || src.utilization0 === 'NaN' || src.utilization0 === 'Infinity' || src.utilization0 === '-Infinity') {
                            dst.utilization0 = AsNum(src.utilization0);
                        }
                        else {
                            console.log('Expected utilization0 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.utilization0, src.utilization0)
                        }
                    }
                    if (src.utilization1 !== undefined && src.utilization1 !== null) {
                        if (typeof src.utilization1 === "number" || src.utilization1 === 'NaN' || src.utilization1 === 'Infinity' || src.utilization1 === '-Infinity') {
                            dst.utilization1 = AsNum(src.utilization1);
                        }
                        else {
                            console.log('Expected utilization1 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.utilization1, src.utilization1)
                        }
                    }
                    if (src.punchZone !== undefined && src.punchZone !== null) {
                        if (typeof src.punchZone === "number" || src.punchZone === 'NaN' || src.punchZone === 'Infinity' || src.punchZone === '-Infinity') {
                            dst.punchZone = AsNum(src.punchZone);
                        }
                        else {
                            console.log('Expected punchZone of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.punchZone, src.punchZone)
                        }
                    }
                    if (src.perimeterNo !== undefined && src.perimeterNo !== null) {
                        if (typeof src.perimeterNo === "number" || src.perimeterNo === 'NaN' || src.perimeterNo === 'Infinity' || src.perimeterNo === '-Infinity') {
                            dst.perimeterNo = NumberToInt("ng.result.foundation.RCPunchingCheckConcreteCompression.perimeter_no", AsNum(src.perimeterNo));
                        }
                        else {
                            console.log('Expected perimeterNo of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.perimeterNo, src.perimeterNo)
                        }
                    }
                    if (src.shapeNo !== undefined && src.shapeNo !== null) {
                        if (typeof src.shapeNo === "number" || src.shapeNo === 'NaN' || src.shapeNo === 'Infinity' || src.shapeNo === '-Infinity') {
                            dst.shapeNo = NumberToInt("ng.result.foundation.RCPunchingCheckConcreteCompression.shape_no", AsNum(src.shapeNo));
                        }
                        else {
                            console.log('Expected shapeNo of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.shapeNo, src.shapeNo)
                        }
                    }
                    if (src.V !== undefined && src.V !== null) {
                        if (typeof src.V === "number" || src.V === 'NaN' || src.V === 'Infinity' || src.V === '-Infinity') {
                            dst.V = AsNum(src.V);
                        }
                        else {
                            console.log('Expected V of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.V, src.V)
                        }
                    }
                    if (src.M1 !== undefined && src.M1 !== null) {
                        if (typeof src.M1 === "number" || src.M1 === 'NaN' || src.M1 === 'Infinity' || src.M1 === '-Infinity') {
                            dst.M1 = AsNum(src.M1);
                        }
                        else {
                            console.log('Expected M1 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.M1, src.M1)
                        }
                    }
                    if (src.M2 !== undefined && src.M2 !== null) {
                        if (typeof src.M2 === "number" || src.M2 === 'NaN' || src.M2 === 'Infinity' || src.M2 === '-Infinity') {
                            dst.M2 = AsNum(src.M2);
                        }
                        else {
                            console.log('Expected M2 of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.M2, src.M2)
                        }
                    }
                    if (src.sigmacp !== undefined && src.sigmacp !== null) {
                        if (typeof src.sigmacp === "number" || src.sigmacp === 'NaN' || src.sigmacp === 'Infinity' || src.sigmacp === '-Infinity') {
                            dst.sigmacp = AsNum(src.sigmacp);
                        }
                        else {
                            console.log('Expected sigmacp of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.sigmacp, src.sigmacp)
                        }
                    }
                    if (src.dBx !== undefined && src.dBx !== null) {
                        if (typeof src.dBx === "number" || src.dBx === 'NaN' || src.dBx === 'Infinity' || src.dBx === '-Infinity') {
                            dst.dBx = AsNum(src.dBx);
                        }
                        else {
                            console.log('Expected dBx of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.dBx, src.dBx)
                        }
                    }
                    if (src.dBy !== undefined && src.dBy !== null) {
                        if (typeof src.dBy === "number" || src.dBy === 'NaN' || src.dBy === 'Infinity' || src.dBy === '-Infinity') {
                            dst.dBy = AsNum(src.dBy);
                        }
                        else {
                            console.log('Expected dBy of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.dBy, src.dBy)
                        }
                    }
                    if (src.ddg !== undefined && src.ddg !== null) {
                        if (typeof src.ddg === "number" || src.ddg === 'NaN' || src.ddg === 'Infinity' || src.ddg === '-Infinity') {
                            dst.ddg = AsNum(src.ddg);
                        }
                        else {
                            console.log('Expected ddg of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.ddg, src.ddg)
                        }
                    }
                    if (src.kpb !== undefined && src.kpb !== null) {
                        if (typeof src.kpb === "number" || src.kpb === 'NaN' || src.kpb === 'Infinity' || src.kpb === '-Infinity') {
                            dst.kpb = AsNum(src.kpb);
                        }
                        else {
                            console.log('Expected kpb of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.kpb, src.kpb)
                        }
                    }
                    if (src.gammaShear !== undefined && src.gammaShear !== null) {
                        if (typeof src.gammaShear === "number" || src.gammaShear === 'NaN' || src.gammaShear === 'Infinity' || src.gammaShear === '-Infinity') {
                            dst.gammaShear = AsNum(src.gammaShear);
                        }
                        else {
                            console.log('Expected gammaShear of RCPunchingCheckConcreteCompression to be a number but was ', typeof src.gammaShear, src.gammaShear)
                        }
                    }
                    return dst;
                }

                static toObject(src: RCPunchingCheckConcreteCompression | null | undefined): RCPunchingCheckConcreteCompression_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.RCPunchingCheckConcreteCompression is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.RCPunchingCheckConcreteCompression") {
                        console.error('Expected ng.result.foundation.RCPunchingCheckConcreteCompression but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : RCPunchingCheckConcreteCompression_json = {
                        beta: AsJsonNum(src.beta),
                        dy: AsJsonNum(src.dy),
                        dz: AsJsonNum(src.dz),
                        deff: AsJsonNum(src.deff),
                        rhol: AsJsonNum(src.rhol),
                        rholx: AsJsonNum(src.rholx),
                        rholy: AsJsonNum(src.rholy),
                        u0: AsJsonNum(src.u0),
                        perimeterPointsU0: new Array<ng.geometry.Point2D_json>(),
                        a: AsJsonNum(src.a),
                        u1: AsJsonNum(src.u1),
                        perimeterPointsU1: new Array<ng.geometry.Point2D_json>(),
                        nu: AsJsonNum(src.nu),
                        VEd0: AsJsonNum(src.VEd0),
                        VEd1: AsJsonNum(src.VEd1),
                        vEd: AsJsonNum(src.vEd),
                        vRdmax: AsJsonNum(src.vRdmax),
                        vRdc: AsJsonNum(src.vRdc),
                        nyRdmax: AsJsonNum(src.nyRdmax),
                        nyRdc: AsJsonNum(src.nyRdc),
                        nyMin: AsJsonNum(src.nyMin),
                        nyEd0: AsJsonNum(src.nyEd0),
                        nyEd1: AsJsonNum(src.nyEd1),
                        k: AsJsonNum(src.k),
                        k1: AsJsonNum(src.k1),
                        crdc: AsJsonNum(src.crdc),
                        eta: AsJsonNum(src.eta),
                        densityclass: AsJsonNum(NumberToInt("ng.result.foundation.RCPunchingCheckConcreteCompression.densityclass", src.densityclass)),
                        utilization: AsJsonNum(src.utilization),
                        utilization0: AsJsonNum(src.utilization0),
                        utilization1: AsJsonNum(src.utilization1),
                        punchZone: AsJsonNum(src.punchZone),
                        perimeterNo: AsJsonNum(NumberToInt("ng.result.foundation.RCPunchingCheckConcreteCompression.perimeter_no", src.perimeterNo)),
                        shapeNo: AsJsonNum(NumberToInt("ng.result.foundation.RCPunchingCheckConcreteCompression.shape_no", src.shapeNo)),
                        V: AsJsonNum(src.V),
                        M1: AsJsonNum(src.M1),
                        M2: AsJsonNum(src.M2),
                        sigmacp: AsJsonNum(src.sigmacp),
                        dBx: AsJsonNum(src.dBx),
                        dBy: AsJsonNum(src.dBy),
                        ddg: AsJsonNum(src.ddg),
                        kpb: AsJsonNum(src.kpb),
                        gammaShear: AsJsonNum(src.gammaShear),
                    };
                    if (src.perimeterPointsU0 !== null) {
                        for (const element of src.perimeterPointsU0) {
                            const parsed = ng.geometry.Point2D.toObject(element);
                            if(parsed === null) return null;
                            dst.perimeterPointsU0.push(parsed);
                        }
                    }
                    if (src.perimeterPointsU1 !== null) {
                        for (const element of src.perimeterPointsU1) {
                            const parsed = ng.geometry.Point2D.toObject(element);
                            if(parsed === null) return null;
                            dst.perimeterPointsU1.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: RCPunchingCheckConcreteCompression_createType) {
                    const dst = new RCPunchingCheckConcreteCompression();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    if (src.dy !== undefined) {
                        dst.dy = src.dy;
                    }
                    if (src.dz !== undefined) {
                        dst.dz = src.dz;
                    }
                    if (src.deff !== undefined) {
                        dst.deff = src.deff;
                    }
                    if (src.rhol !== undefined) {
                        dst.rhol = src.rhol;
                    }
                    if (src.rholx !== undefined) {
                        dst.rholx = src.rholx;
                    }
                    if (src.rholy !== undefined) {
                        dst.rholy = src.rholy;
                    }
                    if (src.u0 !== undefined) {
                        dst.u0 = src.u0;
                    }
                    if (src.perimeterPointsU0 !== undefined) {
                        dst.perimeterPointsU0 = src.perimeterPointsU0;
                    }
                    if (src.a !== undefined) {
                        dst.a = src.a;
                    }
                    if (src.u1 !== undefined) {
                        dst.u1 = src.u1;
                    }
                    if (src.perimeterPointsU1 !== undefined) {
                        dst.perimeterPointsU1 = src.perimeterPointsU1;
                    }
                    if (src.nu !== undefined) {
                        dst.nu = src.nu;
                    }
                    if (src.VEd0 !== undefined) {
                        dst.VEd0 = src.VEd0;
                    }
                    if (src.VEd1 !== undefined) {
                        dst.VEd1 = src.VEd1;
                    }
                    if (src.vEd !== undefined) {
                        dst.vEd = src.vEd;
                    }
                    if (src.vRdmax !== undefined) {
                        dst.vRdmax = src.vRdmax;
                    }
                    if (src.vRdc !== undefined) {
                        dst.vRdc = src.vRdc;
                    }
                    if (src.nyRdmax !== undefined) {
                        dst.nyRdmax = src.nyRdmax;
                    }
                    if (src.nyRdc !== undefined) {
                        dst.nyRdc = src.nyRdc;
                    }
                    if (src.nyMin !== undefined) {
                        dst.nyMin = src.nyMin;
                    }
                    if (src.nyEd0 !== undefined) {
                        dst.nyEd0 = src.nyEd0;
                    }
                    if (src.nyEd1 !== undefined) {
                        dst.nyEd1 = src.nyEd1;
                    }
                    if (src.k !== undefined) {
                        dst.k = src.k;
                    }
                    if (src.k1 !== undefined) {
                        dst.k1 = src.k1;
                    }
                    if (src.crdc !== undefined) {
                        dst.crdc = src.crdc;
                    }
                    if (src.eta !== undefined) {
                        dst.eta = src.eta;
                    }
                    if (src.densityclass !== undefined) {
                        dst.densityclass = src.densityclass;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.utilization0 !== undefined) {
                        dst.utilization0 = src.utilization0;
                    }
                    if (src.utilization1 !== undefined) {
                        dst.utilization1 = src.utilization1;
                    }
                    if (src.punchZone !== undefined) {
                        dst.punchZone = src.punchZone;
                    }
                    if (src.perimeterNo !== undefined) {
                        dst.perimeterNo = src.perimeterNo;
                    }
                    if (src.shapeNo !== undefined) {
                        dst.shapeNo = src.shapeNo;
                    }
                    if (src.V !== undefined) {
                        dst.V = src.V;
                    }
                    if (src.M1 !== undefined) {
                        dst.M1 = src.M1;
                    }
                    if (src.M2 !== undefined) {
                        dst.M2 = src.M2;
                    }
                    if (src.sigmacp !== undefined) {
                        dst.sigmacp = src.sigmacp;
                    }
                    if (src.dBx !== undefined) {
                        dst.dBx = src.dBx;
                    }
                    if (src.dBy !== undefined) {
                        dst.dBy = src.dBy;
                    }
                    if (src.ddg !== undefined) {
                        dst.ddg = src.ddg;
                    }
                    if (src.kpb !== undefined) {
                        dst.kpb = src.kpb;
                    }
                    if (src.gammaShear !== undefined) {
                        dst.gammaShear = src.gammaShear;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new RCPunchingCheckConcreteCompression();
                    dst.beta = this.beta;
                    dst.dy = this.dy;
                    dst.dz = this.dz;
                    dst.deff = this.deff;
                    dst.rhol = this.rhol;
                    dst.rholx = this.rholx;
                    dst.rholy = this.rholy;
                    dst.u0 = this.u0;
                    dst.perimeterPointsU0 = this.perimeterPointsU0;
                    dst.a = this.a;
                    dst.u1 = this.u1;
                    dst.perimeterPointsU1 = this.perimeterPointsU1;
                    dst.nu = this.nu;
                    dst.VEd0 = this.VEd0;
                    dst.VEd1 = this.VEd1;
                    dst.vEd = this.vEd;
                    dst.vRdmax = this.vRdmax;
                    dst.vRdc = this.vRdc;
                    dst.nyRdmax = this.nyRdmax;
                    dst.nyRdc = this.nyRdc;
                    dst.nyMin = this.nyMin;
                    dst.nyEd0 = this.nyEd0;
                    dst.nyEd1 = this.nyEd1;
                    dst.k = this.k;
                    dst.k1 = this.k1;
                    dst.crdc = this.crdc;
                    dst.eta = this.eta;
                    dst.densityclass = this.densityclass;
                    dst.utilization = this.utilization;
                    dst.utilization0 = this.utilization0;
                    dst.utilization1 = this.utilization1;
                    dst.punchZone = this.punchZone;
                    dst.perimeterNo = this.perimeterNo;
                    dst.shapeNo = this.shapeNo;
                    dst.V = this.V;
                    dst.M1 = this.M1;
                    dst.M2 = this.M2;
                    dst.sigmacp = this.sigmacp;
                    dst.dBx = this.dBx;
                    dst.dBy = this.dBy;
                    dst.ddg = this.ddg;
                    dst.kpb = this.kpb;
                    dst.gammaShear = this.gammaShear;
                    return dst;
                }

                deepClone() {
                    const json = RCPunchingCheckConcreteCompression.toObject(this);
                    const dst = RCPunchingCheckConcreteCompression.fromObject(json);
                    return dst;
                }
            }
            export type IRCPunchingCheckConcreteCompression = RCPunchingCheckConcreteCompression;


            export type RCPunchingCheckConcreteShear_keys = 'concShear' | 'sr' | 'capacity' | 'vRdsw' | 'vRdcs' | 'vRdcsw' | 'CRdcSw';
            export interface RCPunchingCheckConcreteShear_createType {
                concShear?: ng.result.foundation.RCPunchingCheckConcreteShear | null,
                sr?: number,
                capacity?: number,
                vRdsw?: number,
                vRdcs?: number,
                vRdcsw?: number,
                CRdcSw?: number,
            }
            export interface RCPunchingCheckConcreteShear_json {
                concShear?: ng.result.foundation.RCPunchingCheckConcreteShear_json;
                sr?: JsonNumber;
                capacity?: JsonNumber;
                vRdsw?: JsonNumber;
                vRdcs?: JsonNumber;
                vRdcsw?: JsonNumber;
                CRdcSw?: JsonNumber;
            }
            interface RCPunchingCheckConcreteShear_json_in {
                __proto_name?: unknown;
                concShear?: unknown;
                sr?: unknown;
                capacity?: unknown;
                vRdsw?: unknown;
                vRdcs?: unknown;
                vRdcsw?: unknown;
                CRdcSw?: unknown;
            }
            export class RCPunchingCheckConcreteShear {
                __proto_name = "ng.result.foundation.RCPunchingCheckConcreteShear";
                concShear: ng.result.foundation.RCPunchingCheckConcreteShear | null = null;
                sr: number = 0;
                capacity: number = 0;
                vRdsw: number = 0;
                vRdcs: number = 0;
                vRdcsw: number = 0;
                CRdcSw: number = 0;

                static fromObject(src_unknown: unknown): RCPunchingCheckConcreteShear {
                    const dst = new RCPunchingCheckConcreteShear();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted RCPunchingCheckConcreteShear but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as RCPunchingCheckConcreteShear_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for RCPunchingCheckConcreteShear but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.concShear !== undefined && src.concShear !== null) {
                        dst.concShear = ng.result.foundation.RCPunchingCheckConcreteShear.fromObject(src.concShear);
                    }
                    if (src.sr !== undefined && src.sr !== null) {
                        if (typeof src.sr === "number" || src.sr === 'NaN' || src.sr === 'Infinity' || src.sr === '-Infinity') {
                            dst.sr = AsNum(src.sr);
                        }
                        else {
                            console.log('Expected sr of RCPunchingCheckConcreteShear to be a number but was ', typeof src.sr, src.sr)
                        }
                    }
                    if (src.capacity !== undefined && src.capacity !== null) {
                        if (typeof src.capacity === "number" || src.capacity === 'NaN' || src.capacity === 'Infinity' || src.capacity === '-Infinity') {
                            dst.capacity = AsNum(src.capacity);
                        }
                        else {
                            console.log('Expected capacity of RCPunchingCheckConcreteShear to be a number but was ', typeof src.capacity, src.capacity)
                        }
                    }
                    if (src.vRdsw !== undefined && src.vRdsw !== null) {
                        if (typeof src.vRdsw === "number" || src.vRdsw === 'NaN' || src.vRdsw === 'Infinity' || src.vRdsw === '-Infinity') {
                            dst.vRdsw = AsNum(src.vRdsw);
                        }
                        else {
                            console.log('Expected vRdsw of RCPunchingCheckConcreteShear to be a number but was ', typeof src.vRdsw, src.vRdsw)
                        }
                    }
                    if (src.vRdcs !== undefined && src.vRdcs !== null) {
                        if (typeof src.vRdcs === "number" || src.vRdcs === 'NaN' || src.vRdcs === 'Infinity' || src.vRdcs === '-Infinity') {
                            dst.vRdcs = AsNum(src.vRdcs);
                        }
                        else {
                            console.log('Expected vRdcs of RCPunchingCheckConcreteShear to be a number but was ', typeof src.vRdcs, src.vRdcs)
                        }
                    }
                    if (src.vRdcsw !== undefined && src.vRdcsw !== null) {
                        if (typeof src.vRdcsw === "number" || src.vRdcsw === 'NaN' || src.vRdcsw === 'Infinity' || src.vRdcsw === '-Infinity') {
                            dst.vRdcsw = AsNum(src.vRdcsw);
                        }
                        else {
                            console.log('Expected vRdcsw of RCPunchingCheckConcreteShear to be a number but was ', typeof src.vRdcsw, src.vRdcsw)
                        }
                    }
                    if (src.CRdcSw !== undefined && src.CRdcSw !== null) {
                        if (typeof src.CRdcSw === "number" || src.CRdcSw === 'NaN' || src.CRdcSw === 'Infinity' || src.CRdcSw === '-Infinity') {
                            dst.CRdcSw = AsNum(src.CRdcSw);
                        }
                        else {
                            console.log('Expected CRdcSw of RCPunchingCheckConcreteShear to be a number but was ', typeof src.CRdcSw, src.CRdcSw)
                        }
                    }
                    return dst;
                }

                static toObject(src: RCPunchingCheckConcreteShear | null | undefined): RCPunchingCheckConcreteShear_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.RCPunchingCheckConcreteShear is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.RCPunchingCheckConcreteShear") {
                        console.error('Expected ng.result.foundation.RCPunchingCheckConcreteShear but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : RCPunchingCheckConcreteShear_json = {
                        sr: AsJsonNum(src.sr),
                        capacity: AsJsonNum(src.capacity),
                        vRdsw: AsJsonNum(src.vRdsw),
                        vRdcs: AsJsonNum(src.vRdcs),
                        vRdcsw: AsJsonNum(src.vRdcsw),
                        CRdcSw: AsJsonNum(src.CRdcSw),
                    };
                    if(src.concShear !== null)
                    {
                        const parsed = ng.result.foundation.RCPunchingCheckConcreteShear.toObject(src.concShear);
                        if(parsed === null) return null;
                        dst.concShear = parsed;
                    }
                    return dst;
                }

                static create(src?: RCPunchingCheckConcreteShear_createType) {
                    const dst = new RCPunchingCheckConcreteShear();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.concShear !== undefined) {
                        dst.concShear = src.concShear;
                    }
                    if (src.sr !== undefined) {
                        dst.sr = src.sr;
                    }
                    if (src.capacity !== undefined) {
                        dst.capacity = src.capacity;
                    }
                    if (src.vRdsw !== undefined) {
                        dst.vRdsw = src.vRdsw;
                    }
                    if (src.vRdcs !== undefined) {
                        dst.vRdcs = src.vRdcs;
                    }
                    if (src.vRdcsw !== undefined) {
                        dst.vRdcsw = src.vRdcsw;
                    }
                    if (src.CRdcSw !== undefined) {
                        dst.CRdcSw = src.CRdcSw;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new RCPunchingCheckConcreteShear();
                    dst.concShear = this.concShear;
                    dst.sr = this.sr;
                    dst.capacity = this.capacity;
                    dst.vRdsw = this.vRdsw;
                    dst.vRdcs = this.vRdcs;
                    dst.vRdcsw = this.vRdcsw;
                    dst.CRdcSw = this.CRdcSw;
                    return dst;
                }

                deepClone() {
                    const json = RCPunchingCheckConcreteShear.toObject(this);
                    const dst = RCPunchingCheckConcreteShear.fromObject(json);
                    return dst;
                }
            }
            export type IRCPunchingCheckConcreteShear = RCPunchingCheckConcreteShear;


            export type RCUnreinforced_keys = 'unreinforced' | 'utilization';
            export interface RCUnreinforced_createType {
                unreinforced?: boolean,
                utilization?: number,
            }
            export interface RCUnreinforced_json {
                unreinforced?: boolean;
                utilization?: JsonNumber;
            }
            interface RCUnreinforced_json_in {
                __proto_name?: unknown;
                unreinforced?: unknown;
                utilization?: unknown;
            }
            export class RCUnreinforced {
                __proto_name = "ng.result.foundation.RCUnreinforced";
                unreinforced: boolean = false;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): RCUnreinforced {
                    const dst = new RCUnreinforced();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted RCUnreinforced but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as RCUnreinforced_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for RCUnreinforced but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.unreinforced !== undefined && src.unreinforced !== null) {
                        if (typeof src.unreinforced === "boolean") {
                            dst.unreinforced = src.unreinforced;
                        }
                        else {
                            console.log('Expected unreinforced of RCUnreinforced to be a boolean but was ', typeof src.unreinforced, src.unreinforced)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of RCUnreinforced to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: RCUnreinforced | null | undefined): RCUnreinforced_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.RCUnreinforced is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.RCUnreinforced") {
                        console.error('Expected ng.result.foundation.RCUnreinforced but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : RCUnreinforced_json = {
                        unreinforced: src.unreinforced,
                        utilization: AsJsonNum(src.utilization),
                    };
                    return dst;
                }

                static create(src?: RCUnreinforced_createType) {
                    const dst = new RCUnreinforced();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.unreinforced !== undefined) {
                        dst.unreinforced = src.unreinforced;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new RCUnreinforced();
                    dst.unreinforced = this.unreinforced;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = RCUnreinforced.toObject(this);
                    const dst = RCUnreinforced.fromObject(json);
                    return dst;
                }
            }
            export type IRCUnreinforced = RCUnreinforced;


            export type RCDSSSE_keys = 'mrdx' | 'mrdy' | 'm' | 'my' | 'a' | 'l' | 'lb' | 'lbminBottum' | 'v' | 'utilization' | 'utilizationAnchorage';
            export interface RCDSSSE_createType {
                mrdx?: number,
                mrdy?: number,
                m?: number,
                my?: number,
                a?: number,
                l?: number,
                lb?: number,
                lbminBottum?: number,
                v?: number,
                utilization?: number,
                utilizationAnchorage?: number,
            }
            export interface RCDSSSE_json {
                mrdx?: JsonNumber;
                mrdy?: JsonNumber;
                m?: JsonNumber;
                my?: JsonNumber;
                a?: JsonNumber;
                l?: JsonNumber;
                lb?: JsonNumber;
                lbminBottum?: JsonNumber;
                v?: JsonNumber;
                utilization?: JsonNumber;
                utilizationAnchorage?: JsonNumber;
            }
            interface RCDSSSE_json_in {
                __proto_name?: unknown;
                mrdx?: unknown;
                mrdy?: unknown;
                m?: unknown;
                my?: unknown;
                a?: unknown;
                l?: unknown;
                lb?: unknown;
                lbminBottum?: unknown;
                v?: unknown;
                utilization?: unknown;
                utilizationAnchorage?: unknown;
            }
            export class RCDSSSE {
                __proto_name = "ng.result.foundation.RCDSSSE";
                mrdx: number = 0;
                mrdy: number = 0;
                m: number = 0;
                my: number = 0;
                a: number = 0;
                l: number = 0;
                lb: number = 0;
                lbminBottum: number = 0;
                v: number = 0;
                utilization: number = 0;
                utilizationAnchorage: number = 0;

                static fromObject(src_unknown: unknown): RCDSSSE {
                    const dst = new RCDSSSE();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted RCDSSSE but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as RCDSSSE_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for RCDSSSE but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.mrdx !== undefined && src.mrdx !== null) {
                        if (typeof src.mrdx === "number" || src.mrdx === 'NaN' || src.mrdx === 'Infinity' || src.mrdx === '-Infinity') {
                            dst.mrdx = AsNum(src.mrdx);
                        }
                        else {
                            console.log('Expected mrdx of RCDSSSE to be a number but was ', typeof src.mrdx, src.mrdx)
                        }
                    }
                    if (src.mrdy !== undefined && src.mrdy !== null) {
                        if (typeof src.mrdy === "number" || src.mrdy === 'NaN' || src.mrdy === 'Infinity' || src.mrdy === '-Infinity') {
                            dst.mrdy = AsNum(src.mrdy);
                        }
                        else {
                            console.log('Expected mrdy of RCDSSSE to be a number but was ', typeof src.mrdy, src.mrdy)
                        }
                    }
                    if (src.m !== undefined && src.m !== null) {
                        if (typeof src.m === "number" || src.m === 'NaN' || src.m === 'Infinity' || src.m === '-Infinity') {
                            dst.m = AsNum(src.m);
                        }
                        else {
                            console.log('Expected m of RCDSSSE to be a number but was ', typeof src.m, src.m)
                        }
                    }
                    if (src.my !== undefined && src.my !== null) {
                        if (typeof src.my === "number" || src.my === 'NaN' || src.my === 'Infinity' || src.my === '-Infinity') {
                            dst.my = AsNum(src.my);
                        }
                        else {
                            console.log('Expected my of RCDSSSE to be a number but was ', typeof src.my, src.my)
                        }
                    }
                    if (src.a !== undefined && src.a !== null) {
                        if (typeof src.a === "number" || src.a === 'NaN' || src.a === 'Infinity' || src.a === '-Infinity') {
                            dst.a = AsNum(src.a);
                        }
                        else {
                            console.log('Expected a of RCDSSSE to be a number but was ', typeof src.a, src.a)
                        }
                    }
                    if (src.l !== undefined && src.l !== null) {
                        if (typeof src.l === "number" || src.l === 'NaN' || src.l === 'Infinity' || src.l === '-Infinity') {
                            dst.l = AsNum(src.l);
                        }
                        else {
                            console.log('Expected l of RCDSSSE to be a number but was ', typeof src.l, src.l)
                        }
                    }
                    if (src.lb !== undefined && src.lb !== null) {
                        if (typeof src.lb === "number" || src.lb === 'NaN' || src.lb === 'Infinity' || src.lb === '-Infinity') {
                            dst.lb = AsNum(src.lb);
                        }
                        else {
                            console.log('Expected lb of RCDSSSE to be a number but was ', typeof src.lb, src.lb)
                        }
                    }
                    if (src.lbminBottum !== undefined && src.lbminBottum !== null) {
                        if (typeof src.lbminBottum === "number" || src.lbminBottum === 'NaN' || src.lbminBottum === 'Infinity' || src.lbminBottum === '-Infinity') {
                            dst.lbminBottum = AsNum(src.lbminBottum);
                        }
                        else {
                            console.log('Expected lbminBottum of RCDSSSE to be a number but was ', typeof src.lbminBottum, src.lbminBottum)
                        }
                    }
                    if (src.v !== undefined && src.v !== null) {
                        if (typeof src.v === "number" || src.v === 'NaN' || src.v === 'Infinity' || src.v === '-Infinity') {
                            dst.v = AsNum(src.v);
                        }
                        else {
                            console.log('Expected v of RCDSSSE to be a number but was ', typeof src.v, src.v)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of RCDSSSE to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.utilizationAnchorage !== undefined && src.utilizationAnchorage !== null) {
                        if (typeof src.utilizationAnchorage === "number" || src.utilizationAnchorage === 'NaN' || src.utilizationAnchorage === 'Infinity' || src.utilizationAnchorage === '-Infinity') {
                            dst.utilizationAnchorage = AsNum(src.utilizationAnchorage);
                        }
                        else {
                            console.log('Expected utilizationAnchorage of RCDSSSE to be a number but was ', typeof src.utilizationAnchorage, src.utilizationAnchorage)
                        }
                    }
                    return dst;
                }

                static toObject(src: RCDSSSE | null | undefined): RCDSSSE_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.RCDSSSE is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.RCDSSSE") {
                        console.error('Expected ng.result.foundation.RCDSSSE but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : RCDSSSE_json = {
                        mrdx: AsJsonNum(src.mrdx),
                        mrdy: AsJsonNum(src.mrdy),
                        m: AsJsonNum(src.m),
                        my: AsJsonNum(src.my),
                        a: AsJsonNum(src.a),
                        l: AsJsonNum(src.l),
                        lb: AsJsonNum(src.lb),
                        lbminBottum: AsJsonNum(src.lbminBottum),
                        v: AsJsonNum(src.v),
                        utilization: AsJsonNum(src.utilization),
                        utilizationAnchorage: AsJsonNum(src.utilizationAnchorage),
                    };
                    return dst;
                }

                static create(src?: RCDSSSE_createType) {
                    const dst = new RCDSSSE();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.mrdx !== undefined) {
                        dst.mrdx = src.mrdx;
                    }
                    if (src.mrdy !== undefined) {
                        dst.mrdy = src.mrdy;
                    }
                    if (src.m !== undefined) {
                        dst.m = src.m;
                    }
                    if (src.my !== undefined) {
                        dst.my = src.my;
                    }
                    if (src.a !== undefined) {
                        dst.a = src.a;
                    }
                    if (src.l !== undefined) {
                        dst.l = src.l;
                    }
                    if (src.lb !== undefined) {
                        dst.lb = src.lb;
                    }
                    if (src.lbminBottum !== undefined) {
                        dst.lbminBottum = src.lbminBottum;
                    }
                    if (src.v !== undefined) {
                        dst.v = src.v;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.utilizationAnchorage !== undefined) {
                        dst.utilizationAnchorage = src.utilizationAnchorage;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new RCDSSSE();
                    dst.mrdx = this.mrdx;
                    dst.mrdy = this.mrdy;
                    dst.m = this.m;
                    dst.my = this.my;
                    dst.a = this.a;
                    dst.l = this.l;
                    dst.lb = this.lb;
                    dst.lbminBottum = this.lbminBottum;
                    dst.v = this.v;
                    dst.utilization = this.utilization;
                    dst.utilizationAnchorage = this.utilizationAnchorage;
                    return dst;
                }

                deepClone() {
                    const json = RCDSSSE.toObject(this);
                    const dst = RCDSSSE.fromObject(json);
                    return dst;
                }
            }
            export type IRCDSSSE = RCDSSSE;


            export type Data_keys = 'resultAnalysis' | 'resultDesign' | 'utilization' | 'resultPunching' | 'resultUnreinforced' | 'resultDssse';
            export interface Data_createType {
                resultAnalysis?: ng.result.foundation.DetailedFoundationAnalysis[],
                resultDesign?: ng.result.foundation.DetailedFoundationDesign[],
                utilization?: number,
                resultPunching?: ng.result.foundation.RCPunchingCheckConcreteCompression | null,
                resultUnreinforced?: ng.result.foundation.RCUnreinforced | null,
                resultDssse?: ng.result.foundation.RCDSSSE | null,
            }
            export interface Data_json {
                resultAnalysis: ng.result.foundation.DetailedFoundationAnalysis_json[];
                resultDesign: ng.result.foundation.DetailedFoundationDesign_json[];
                utilization?: JsonNumber;
                resultPunching?: ng.result.foundation.RCPunchingCheckConcreteCompression_json;
                resultUnreinforced?: ng.result.foundation.RCUnreinforced_json;
                resultDssse?: ng.result.foundation.RCDSSSE_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                resultAnalysis?: unknown;
                resultDesign?: unknown;
                utilization?: unknown;
                resultPunching?: unknown;
                resultUnreinforced?: unknown;
                resultDssse?: unknown;
            }
            export class Data {
                __proto_name = "ng.result.foundation.Data";
                resultAnalysis: ng.result.foundation.DetailedFoundationAnalysis[] = [];
                resultDesign: ng.result.foundation.DetailedFoundationDesign[] = [];
                utilization: number = 0;
                resultPunching: ng.result.foundation.RCPunchingCheckConcreteCompression | null = null;
                resultUnreinforced: ng.result.foundation.RCUnreinforced | null = null;
                resultDssse: ng.result.foundation.RCDSSSE | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.resultAnalysis !== undefined && src.resultAnalysis !== null) {
                        if (Array.isArray(src.resultAnalysis)) {
                            for (const element of src.resultAnalysis) {
                                dst.resultAnalysis.push(ng.result.foundation.DetailedFoundationAnalysis.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultAnalysis of Data to be a array but was ', typeof src.resultAnalysis, src.resultAnalysis)
                        }
                    }
                    if (src.resultDesign !== undefined && src.resultDesign !== null) {
                        if (Array.isArray(src.resultDesign)) {
                            for (const element of src.resultDesign) {
                                dst.resultDesign.push(ng.result.foundation.DetailedFoundationDesign.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultDesign of Data to be a array but was ', typeof src.resultDesign, src.resultDesign)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of Data to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.resultPunching !== undefined && src.resultPunching !== null) {
                        dst.resultPunching = ng.result.foundation.RCPunchingCheckConcreteCompression.fromObject(src.resultPunching);
                    }
                    if (src.resultUnreinforced !== undefined && src.resultUnreinforced !== null) {
                        dst.resultUnreinforced = ng.result.foundation.RCUnreinforced.fromObject(src.resultUnreinforced);
                    }
                    if (src.resultDssse !== undefined && src.resultDssse !== null) {
                        dst.resultDssse = ng.result.foundation.RCDSSSE.fromObject(src.resultDssse);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.Data") {
                        console.error('Expected ng.result.foundation.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                        resultAnalysis: new Array<ng.result.foundation.DetailedFoundationAnalysis_json>(),
                        resultDesign: new Array<ng.result.foundation.DetailedFoundationDesign_json>(),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if (src.resultAnalysis !== null) {
                        for (const element of src.resultAnalysis) {
                            const parsed = ng.result.foundation.DetailedFoundationAnalysis.toObject(element);
                            if(parsed === null) return null;
                            dst.resultAnalysis.push(parsed);
                        }
                    }
                    if (src.resultDesign !== null) {
                        for (const element of src.resultDesign) {
                            const parsed = ng.result.foundation.DetailedFoundationDesign.toObject(element);
                            if(parsed === null) return null;
                            dst.resultDesign.push(parsed);
                        }
                    }
                    if(src.resultPunching !== null)
                    {
                        const parsed = ng.result.foundation.RCPunchingCheckConcreteCompression.toObject(src.resultPunching);
                        if(parsed === null) return null;
                        dst.resultPunching = parsed;
                    }
                    if(src.resultUnreinforced !== null)
                    {
                        const parsed = ng.result.foundation.RCUnreinforced.toObject(src.resultUnreinforced);
                        if(parsed === null) return null;
                        dst.resultUnreinforced = parsed;
                    }
                    if(src.resultDssse !== null)
                    {
                        const parsed = ng.result.foundation.RCDSSSE.toObject(src.resultDssse);
                        if(parsed === null) return null;
                        dst.resultDssse = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.resultAnalysis !== undefined) {
                        dst.resultAnalysis = src.resultAnalysis;
                    }
                    if (src.resultDesign !== undefined) {
                        dst.resultDesign = src.resultDesign;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.resultPunching !== undefined) {
                        dst.resultPunching = src.resultPunching;
                    }
                    if (src.resultUnreinforced !== undefined) {
                        dst.resultUnreinforced = src.resultUnreinforced;
                    }
                    if (src.resultDssse !== undefined) {
                        dst.resultDssse = src.resultDssse;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.resultAnalysis = this.resultAnalysis;
                    dst.resultDesign = this.resultDesign;
                    dst.utilization = this.utilization;
                    dst.resultPunching = this.resultPunching;
                    dst.resultUnreinforced = this.resultUnreinforced;
                    dst.resultDssse = this.resultDssse;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;


            export type Element_keys = 'maxOfControls';
            export interface Element_createType {
                maxOfControls?: ng.result.control.ControlData[],
            }
            export interface Element_json {
                maxOfControls: ng.result.control.ControlData_json[];
            }
            interface Element_json_in {
                __proto_name?: unknown;
                maxOfControls?: unknown;
            }
            export class Element {
                __proto_name = "ng.result.foundation.Element";
                maxOfControls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): Element {
                    const dst = new Element();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Element but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Element_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.maxOfControls !== undefined && src.maxOfControls !== null) {
                        if (Array.isArray(src.maxOfControls)) {
                            for (const element of src.maxOfControls) {
                                dst.maxOfControls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected maxOfControls of Element to be a array but was ', typeof src.maxOfControls, src.maxOfControls)
                        }
                    }
                    return dst;
                }

                static toObject(src: Element | null | undefined): Element_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.Element is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.Element") {
                        console.error('Expected ng.result.foundation.Element but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Element_json = {
                        maxOfControls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if (src.maxOfControls !== null) {
                        for (const element of src.maxOfControls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.maxOfControls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: Element_createType) {
                    const dst = new Element();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.maxOfControls !== undefined) {
                        dst.maxOfControls = src.maxOfControls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Element();
                    dst.maxOfControls = this.maxOfControls;
                    return dst;
                }

                deepClone() {
                    const json = Element.toObject(this);
                    const dst = Element.fromObject(json);
                    return dst;
                }
            }
            export type IElement = Element;


            export type DesignSummary_keys = 'elemGuid' | 'concreteInput' | 'controls';
            export interface DesignSummary_createType {
                elemGuid?: string,
                concreteInput?: ng.result.foundation.ConcreteInput | null,
                controls?: ng.result.control.ControlData[],
            }
            export interface DesignSummary_json {
                elemGuid?: string;
                concreteInput?: ng.result.foundation.ConcreteInput_json;
                controls: ng.result.control.ControlData_json[];
            }
            interface DesignSummary_json_in {
                __proto_name?: unknown;
                elemGuid?: unknown;
                concreteInput?: unknown;
                controls?: unknown;
            }
            export class DesignSummary {
                __proto_name = "ng.result.foundation.DesignSummary";
                elemGuid: string = "";
                concreteInput: ng.result.foundation.ConcreteInput | null = null;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): DesignSummary {
                    const dst = new DesignSummary();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignSummary but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignSummary_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignSummary but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elemGuid !== undefined && src.elemGuid !== null) {
                        if (typeof src.elemGuid === "string") {
                            dst.elemGuid = src.elemGuid;
                        }
                        else {
                            console.log('Expected elemGuid of DesignSummary to be a string but was ', typeof src.elemGuid, src.elemGuid)
                        }
                    }
                    if (src.concreteInput !== undefined && src.concreteInput !== null) {
                        dst.concreteInput = ng.result.foundation.ConcreteInput.fromObject(src.concreteInput);
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of DesignSummary to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignSummary | null | undefined): DesignSummary_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.foundation.DesignSummary is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.foundation.DesignSummary") {
                        console.error('Expected ng.result.foundation.DesignSummary but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DesignSummary_json = {
                        elemGuid: src.elemGuid,
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.concreteInput !== null)
                    {
                        const parsed = ng.result.foundation.ConcreteInput.toObject(src.concreteInput);
                        if(parsed === null) return null;
                        dst.concreteInput = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: DesignSummary_createType) {
                    const dst = new DesignSummary();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elemGuid !== undefined) {
                        dst.elemGuid = src.elemGuid;
                    }
                    if (src.concreteInput !== undefined) {
                        dst.concreteInput = src.concreteInput;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignSummary();
                    dst.elemGuid = this.elemGuid;
                    dst.concreteInput = this.concreteInput;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = DesignSummary.toObject(this);
                    const dst = DesignSummary.fromObject(json);
                    return dst;
                }
            }
            export type IDesignSummary = DesignSummary;
        } // namespace foundation


        // Defined in Result/concrete.proto
        export namespace concrete {
            export type BendingDataSLS_keys = 'coord' | 'extNormalForce' | 'intNormalForce' | 'extMoment' | 'intMoment' | 'crkMoment' | 'deflection' | 'crackWidth' | 'crackWidth2' | 'sigmaCTop' | 'sigmaCBtm' | 'sigmaSTop' | 'sigmaSBtm' | 'crkStageTop' | 'crkStageBtm' | 'crkStageLeft' | 'crkStageRight' | 'eigenfreqUncrk' | 'effArea' | 'effMomentOfInertiaY' | 'avgCrkDist' | 'minReqReinfArea' | 'curReinfArea' | 'zeta' | 'crackWidthLimit' | 'compressionStress' | 'compressionStressFactor' | 'compressionStrength' | 'minReqReinfAreaEc' | 'controls';
            export interface BendingDataSLS_createType {
                coord?: ng.geometry.Point3D | null,
                extNormalForce?: number,
                intNormalForce?: number,
                extMoment?: number,
                intMoment?: number,
                crkMoment?: number,
                deflection?: number,
                crackWidth?: number,
                crackWidth2?: number,
                sigmaCTop?: number,
                sigmaCBtm?: number,
                sigmaSTop?: number,
                sigmaSBtm?: number,
                crkStageTop?: number,
                crkStageBtm?: number,
                crkStageLeft?: number,
                crkStageRight?: number,
                eigenfreqUncrk?: number,
                effArea?: number,
                effMomentOfInertiaY?: number,
                avgCrkDist?: number,
                minReqReinfArea?: number,
                curReinfArea?: number,
                zeta?: number,
                crackWidthLimit?: number,
                compressionStress?: number,
                compressionStressFactor?: number,
                compressionStrength?: number,
                minReqReinfAreaEc?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface BendingDataSLS_json {
                coord?: ng.geometry.Point3D_json;
                extNormalForce?: JsonNumber;
                intNormalForce?: JsonNumber;
                extMoment?: JsonNumber;
                intMoment?: JsonNumber;
                crkMoment?: JsonNumber;
                deflection?: JsonNumber;
                crackWidth?: JsonNumber;
                crackWidth2?: JsonNumber;
                sigmaCTop?: JsonNumber;
                sigmaCBtm?: JsonNumber;
                sigmaSTop?: JsonNumber;
                sigmaSBtm?: JsonNumber;
                crkStageTop?: JsonNumber;
                crkStageBtm?: JsonNumber;
                crkStageLeft?: JsonNumber;
                crkStageRight?: JsonNumber;
                eigenfreqUncrk?: JsonNumber;
                effArea?: JsonNumber;
                effMomentOfInertiaY?: JsonNumber;
                avgCrkDist?: JsonNumber;
                minReqReinfArea?: JsonNumber;
                curReinfArea?: JsonNumber;
                zeta?: JsonNumber;
                crackWidthLimit?: JsonNumber;
                compressionStress?: JsonNumber;
                compressionStressFactor?: JsonNumber;
                compressionStrength?: JsonNumber;
                minReqReinfAreaEc?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface BendingDataSLS_json_in {
                __proto_name?: unknown;
                coord?: unknown;
                extNormalForce?: unknown;
                intNormalForce?: unknown;
                extMoment?: unknown;
                intMoment?: unknown;
                crkMoment?: unknown;
                deflection?: unknown;
                crackWidth?: unknown;
                crackWidth2?: unknown;
                sigmaCTop?: unknown;
                sigmaCBtm?: unknown;
                sigmaSTop?: unknown;
                sigmaSBtm?: unknown;
                crkStageTop?: unknown;
                crkStageBtm?: unknown;
                crkStageLeft?: unknown;
                crkStageRight?: unknown;
                eigenfreqUncrk?: unknown;
                effArea?: unknown;
                effMomentOfInertiaY?: unknown;
                avgCrkDist?: unknown;
                minReqReinfArea?: unknown;
                curReinfArea?: unknown;
                zeta?: unknown;
                crackWidthLimit?: unknown;
                compressionStress?: unknown;
                compressionStressFactor?: unknown;
                compressionStrength?: unknown;
                minReqReinfAreaEc?: unknown;
                controls?: unknown;
            }
            export class BendingDataSLS {
                __proto_name = "ng.result.concrete.BendingDataSLS";
                coord: ng.geometry.Point3D | null = null;
                extNormalForce: number = 0;
                intNormalForce: number = 0;
                extMoment: number = 0;
                intMoment: number = 0;
                crkMoment: number = 0;
                deflection: number = 0;
                crackWidth: number = 0;
                crackWidth2: number = 0;
                sigmaCTop: number = 0;
                sigmaCBtm: number = 0;
                sigmaSTop: number = 0;
                sigmaSBtm: number = 0;
                crkStageTop: number = 0;
                crkStageBtm: number = 0;
                crkStageLeft: number = 0;
                crkStageRight: number = 0;
                eigenfreqUncrk: number = 0;
                effArea: number = 0;
                effMomentOfInertiaY: number = 0;
                avgCrkDist: number = 0;
                minReqReinfArea: number = 0;
                curReinfArea: number = 0;
                zeta: number = 0;
                crackWidthLimit: number = 0;
                compressionStress: number = 0;
                compressionStressFactor: number = 0;
                compressionStrength: number = 0;
                minReqReinfAreaEc: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): BendingDataSLS {
                    const dst = new BendingDataSLS();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BendingDataSLS but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BendingDataSLS_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BendingDataSLS but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coord !== undefined && src.coord !== null) {
                        dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                    }
                    if (src.extNormalForce !== undefined && src.extNormalForce !== null) {
                        if (typeof src.extNormalForce === "number" || src.extNormalForce === 'NaN' || src.extNormalForce === 'Infinity' || src.extNormalForce === '-Infinity') {
                            dst.extNormalForce = AsNum(src.extNormalForce);
                        }
                        else {
                            console.log('Expected extNormalForce of BendingDataSLS to be a number but was ', typeof src.extNormalForce, src.extNormalForce)
                        }
                    }
                    if (src.intNormalForce !== undefined && src.intNormalForce !== null) {
                        if (typeof src.intNormalForce === "number" || src.intNormalForce === 'NaN' || src.intNormalForce === 'Infinity' || src.intNormalForce === '-Infinity') {
                            dst.intNormalForce = AsNum(src.intNormalForce);
                        }
                        else {
                            console.log('Expected intNormalForce of BendingDataSLS to be a number but was ', typeof src.intNormalForce, src.intNormalForce)
                        }
                    }
                    if (src.extMoment !== undefined && src.extMoment !== null) {
                        if (typeof src.extMoment === "number" || src.extMoment === 'NaN' || src.extMoment === 'Infinity' || src.extMoment === '-Infinity') {
                            dst.extMoment = AsNum(src.extMoment);
                        }
                        else {
                            console.log('Expected extMoment of BendingDataSLS to be a number but was ', typeof src.extMoment, src.extMoment)
                        }
                    }
                    if (src.intMoment !== undefined && src.intMoment !== null) {
                        if (typeof src.intMoment === "number" || src.intMoment === 'NaN' || src.intMoment === 'Infinity' || src.intMoment === '-Infinity') {
                            dst.intMoment = AsNum(src.intMoment);
                        }
                        else {
                            console.log('Expected intMoment of BendingDataSLS to be a number but was ', typeof src.intMoment, src.intMoment)
                        }
                    }
                    if (src.crkMoment !== undefined && src.crkMoment !== null) {
                        if (typeof src.crkMoment === "number" || src.crkMoment === 'NaN' || src.crkMoment === 'Infinity' || src.crkMoment === '-Infinity') {
                            dst.crkMoment = AsNum(src.crkMoment);
                        }
                        else {
                            console.log('Expected crkMoment of BendingDataSLS to be a number but was ', typeof src.crkMoment, src.crkMoment)
                        }
                    }
                    if (src.deflection !== undefined && src.deflection !== null) {
                        if (typeof src.deflection === "number" || src.deflection === 'NaN' || src.deflection === 'Infinity' || src.deflection === '-Infinity') {
                            dst.deflection = AsNum(src.deflection);
                        }
                        else {
                            console.log('Expected deflection of BendingDataSLS to be a number but was ', typeof src.deflection, src.deflection)
                        }
                    }
                    if (src.crackWidth !== undefined && src.crackWidth !== null) {
                        if (typeof src.crackWidth === "number" || src.crackWidth === 'NaN' || src.crackWidth === 'Infinity' || src.crackWidth === '-Infinity') {
                            dst.crackWidth = AsNum(src.crackWidth);
                        }
                        else {
                            console.log('Expected crackWidth of BendingDataSLS to be a number but was ', typeof src.crackWidth, src.crackWidth)
                        }
                    }
                    if (src.crackWidth2 !== undefined && src.crackWidth2 !== null) {
                        if (typeof src.crackWidth2 === "number" || src.crackWidth2 === 'NaN' || src.crackWidth2 === 'Infinity' || src.crackWidth2 === '-Infinity') {
                            dst.crackWidth2 = AsNum(src.crackWidth2);
                        }
                        else {
                            console.log('Expected crackWidth2 of BendingDataSLS to be a number but was ', typeof src.crackWidth2, src.crackWidth2)
                        }
                    }
                    if (src.sigmaCTop !== undefined && src.sigmaCTop !== null) {
                        if (typeof src.sigmaCTop === "number" || src.sigmaCTop === 'NaN' || src.sigmaCTop === 'Infinity' || src.sigmaCTop === '-Infinity') {
                            dst.sigmaCTop = AsNum(src.sigmaCTop);
                        }
                        else {
                            console.log('Expected sigmaCTop of BendingDataSLS to be a number but was ', typeof src.sigmaCTop, src.sigmaCTop)
                        }
                    }
                    if (src.sigmaCBtm !== undefined && src.sigmaCBtm !== null) {
                        if (typeof src.sigmaCBtm === "number" || src.sigmaCBtm === 'NaN' || src.sigmaCBtm === 'Infinity' || src.sigmaCBtm === '-Infinity') {
                            dst.sigmaCBtm = AsNum(src.sigmaCBtm);
                        }
                        else {
                            console.log('Expected sigmaCBtm of BendingDataSLS to be a number but was ', typeof src.sigmaCBtm, src.sigmaCBtm)
                        }
                    }
                    if (src.sigmaSTop !== undefined && src.sigmaSTop !== null) {
                        if (typeof src.sigmaSTop === "number" || src.sigmaSTop === 'NaN' || src.sigmaSTop === 'Infinity' || src.sigmaSTop === '-Infinity') {
                            dst.sigmaSTop = AsNum(src.sigmaSTop);
                        }
                        else {
                            console.log('Expected sigmaSTop of BendingDataSLS to be a number but was ', typeof src.sigmaSTop, src.sigmaSTop)
                        }
                    }
                    if (src.sigmaSBtm !== undefined && src.sigmaSBtm !== null) {
                        if (typeof src.sigmaSBtm === "number" || src.sigmaSBtm === 'NaN' || src.sigmaSBtm === 'Infinity' || src.sigmaSBtm === '-Infinity') {
                            dst.sigmaSBtm = AsNum(src.sigmaSBtm);
                        }
                        else {
                            console.log('Expected sigmaSBtm of BendingDataSLS to be a number but was ', typeof src.sigmaSBtm, src.sigmaSBtm)
                        }
                    }
                    if (src.crkStageTop !== undefined && src.crkStageTop !== null) {
                        if (typeof src.crkStageTop === "number" || src.crkStageTop === 'NaN' || src.crkStageTop === 'Infinity' || src.crkStageTop === '-Infinity') {
                            dst.crkStageTop = NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_top", AsNum(src.crkStageTop));
                        }
                        else {
                            console.log('Expected crkStageTop of BendingDataSLS to be a number but was ', typeof src.crkStageTop, src.crkStageTop)
                        }
                    }
                    if (src.crkStageBtm !== undefined && src.crkStageBtm !== null) {
                        if (typeof src.crkStageBtm === "number" || src.crkStageBtm === 'NaN' || src.crkStageBtm === 'Infinity' || src.crkStageBtm === '-Infinity') {
                            dst.crkStageBtm = NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_btm", AsNum(src.crkStageBtm));
                        }
                        else {
                            console.log('Expected crkStageBtm of BendingDataSLS to be a number but was ', typeof src.crkStageBtm, src.crkStageBtm)
                        }
                    }
                    if (src.crkStageLeft !== undefined && src.crkStageLeft !== null) {
                        if (typeof src.crkStageLeft === "number" || src.crkStageLeft === 'NaN' || src.crkStageLeft === 'Infinity' || src.crkStageLeft === '-Infinity') {
                            dst.crkStageLeft = NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_left", AsNum(src.crkStageLeft));
                        }
                        else {
                            console.log('Expected crkStageLeft of BendingDataSLS to be a number but was ', typeof src.crkStageLeft, src.crkStageLeft)
                        }
                    }
                    if (src.crkStageRight !== undefined && src.crkStageRight !== null) {
                        if (typeof src.crkStageRight === "number" || src.crkStageRight === 'NaN' || src.crkStageRight === 'Infinity' || src.crkStageRight === '-Infinity') {
                            dst.crkStageRight = NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_right", AsNum(src.crkStageRight));
                        }
                        else {
                            console.log('Expected crkStageRight of BendingDataSLS to be a number but was ', typeof src.crkStageRight, src.crkStageRight)
                        }
                    }
                    if (src.eigenfreqUncrk !== undefined && src.eigenfreqUncrk !== null) {
                        if (typeof src.eigenfreqUncrk === "number" || src.eigenfreqUncrk === 'NaN' || src.eigenfreqUncrk === 'Infinity' || src.eigenfreqUncrk === '-Infinity') {
                            dst.eigenfreqUncrk = AsNum(src.eigenfreqUncrk);
                        }
                        else {
                            console.log('Expected eigenfreqUncrk of BendingDataSLS to be a number but was ', typeof src.eigenfreqUncrk, src.eigenfreqUncrk)
                        }
                    }
                    if (src.effArea !== undefined && src.effArea !== null) {
                        if (typeof src.effArea === "number" || src.effArea === 'NaN' || src.effArea === 'Infinity' || src.effArea === '-Infinity') {
                            dst.effArea = AsNum(src.effArea);
                        }
                        else {
                            console.log('Expected effArea of BendingDataSLS to be a number but was ', typeof src.effArea, src.effArea)
                        }
                    }
                    if (src.effMomentOfInertiaY !== undefined && src.effMomentOfInertiaY !== null) {
                        if (typeof src.effMomentOfInertiaY === "number" || src.effMomentOfInertiaY === 'NaN' || src.effMomentOfInertiaY === 'Infinity' || src.effMomentOfInertiaY === '-Infinity') {
                            dst.effMomentOfInertiaY = AsNum(src.effMomentOfInertiaY);
                        }
                        else {
                            console.log('Expected effMomentOfInertiaY of BendingDataSLS to be a number but was ', typeof src.effMomentOfInertiaY, src.effMomentOfInertiaY)
                        }
                    }
                    if (src.avgCrkDist !== undefined && src.avgCrkDist !== null) {
                        if (typeof src.avgCrkDist === "number" || src.avgCrkDist === 'NaN' || src.avgCrkDist === 'Infinity' || src.avgCrkDist === '-Infinity') {
                            dst.avgCrkDist = AsNum(src.avgCrkDist);
                        }
                        else {
                            console.log('Expected avgCrkDist of BendingDataSLS to be a number but was ', typeof src.avgCrkDist, src.avgCrkDist)
                        }
                    }
                    if (src.minReqReinfArea !== undefined && src.minReqReinfArea !== null) {
                        if (typeof src.minReqReinfArea === "number" || src.minReqReinfArea === 'NaN' || src.minReqReinfArea === 'Infinity' || src.minReqReinfArea === '-Infinity') {
                            dst.minReqReinfArea = AsNum(src.minReqReinfArea);
                        }
                        else {
                            console.log('Expected minReqReinfArea of BendingDataSLS to be a number but was ', typeof src.minReqReinfArea, src.minReqReinfArea)
                        }
                    }
                    if (src.curReinfArea !== undefined && src.curReinfArea !== null) {
                        if (typeof src.curReinfArea === "number" || src.curReinfArea === 'NaN' || src.curReinfArea === 'Infinity' || src.curReinfArea === '-Infinity') {
                            dst.curReinfArea = AsNum(src.curReinfArea);
                        }
                        else {
                            console.log('Expected curReinfArea of BendingDataSLS to be a number but was ', typeof src.curReinfArea, src.curReinfArea)
                        }
                    }
                    if (src.zeta !== undefined && src.zeta !== null) {
                        if (typeof src.zeta === "number" || src.zeta === 'NaN' || src.zeta === 'Infinity' || src.zeta === '-Infinity') {
                            dst.zeta = AsNum(src.zeta);
                        }
                        else {
                            console.log('Expected zeta of BendingDataSLS to be a number but was ', typeof src.zeta, src.zeta)
                        }
                    }
                    if (src.crackWidthLimit !== undefined && src.crackWidthLimit !== null) {
                        if (typeof src.crackWidthLimit === "number" || src.crackWidthLimit === 'NaN' || src.crackWidthLimit === 'Infinity' || src.crackWidthLimit === '-Infinity') {
                            dst.crackWidthLimit = AsNum(src.crackWidthLimit);
                        }
                        else {
                            console.log('Expected crackWidthLimit of BendingDataSLS to be a number but was ', typeof src.crackWidthLimit, src.crackWidthLimit)
                        }
                    }
                    if (src.compressionStress !== undefined && src.compressionStress !== null) {
                        if (typeof src.compressionStress === "number" || src.compressionStress === 'NaN' || src.compressionStress === 'Infinity' || src.compressionStress === '-Infinity') {
                            dst.compressionStress = AsNum(src.compressionStress);
                        }
                        else {
                            console.log('Expected compressionStress of BendingDataSLS to be a number but was ', typeof src.compressionStress, src.compressionStress)
                        }
                    }
                    if (src.compressionStressFactor !== undefined && src.compressionStressFactor !== null) {
                        if (typeof src.compressionStressFactor === "number" || src.compressionStressFactor === 'NaN' || src.compressionStressFactor === 'Infinity' || src.compressionStressFactor === '-Infinity') {
                            dst.compressionStressFactor = AsNum(src.compressionStressFactor);
                        }
                        else {
                            console.log('Expected compressionStressFactor of BendingDataSLS to be a number but was ', typeof src.compressionStressFactor, src.compressionStressFactor)
                        }
                    }
                    if (src.compressionStrength !== undefined && src.compressionStrength !== null) {
                        if (typeof src.compressionStrength === "number" || src.compressionStrength === 'NaN' || src.compressionStrength === 'Infinity' || src.compressionStrength === '-Infinity') {
                            dst.compressionStrength = AsNum(src.compressionStrength);
                        }
                        else {
                            console.log('Expected compressionStrength of BendingDataSLS to be a number but was ', typeof src.compressionStrength, src.compressionStrength)
                        }
                    }
                    if (src.minReqReinfAreaEc !== undefined && src.minReqReinfAreaEc !== null) {
                        if (typeof src.minReqReinfAreaEc === "number" || src.minReqReinfAreaEc === 'NaN' || src.minReqReinfAreaEc === 'Infinity' || src.minReqReinfAreaEc === '-Infinity') {
                            dst.minReqReinfAreaEc = AsNum(src.minReqReinfAreaEc);
                        }
                        else {
                            console.log('Expected minReqReinfAreaEc of BendingDataSLS to be a number but was ', typeof src.minReqReinfAreaEc, src.minReqReinfAreaEc)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of BendingDataSLS to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: BendingDataSLS | null | undefined): BendingDataSLS_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.BendingDataSLS is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.BendingDataSLS") {
                        console.error('Expected ng.result.concrete.BendingDataSLS but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BendingDataSLS_json = {
                        extNormalForce: AsJsonNum(src.extNormalForce),
                        intNormalForce: AsJsonNum(src.intNormalForce),
                        extMoment: AsJsonNum(src.extMoment),
                        intMoment: AsJsonNum(src.intMoment),
                        crkMoment: AsJsonNum(src.crkMoment),
                        deflection: AsJsonNum(src.deflection),
                        crackWidth: AsJsonNum(src.crackWidth),
                        crackWidth2: AsJsonNum(src.crackWidth2),
                        sigmaCTop: AsJsonNum(src.sigmaCTop),
                        sigmaCBtm: AsJsonNum(src.sigmaCBtm),
                        sigmaSTop: AsJsonNum(src.sigmaSTop),
                        sigmaSBtm: AsJsonNum(src.sigmaSBtm),
                        crkStageTop: AsJsonNum(NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_top", src.crkStageTop)),
                        crkStageBtm: AsJsonNum(NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_btm", src.crkStageBtm)),
                        crkStageLeft: AsJsonNum(NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_left", src.crkStageLeft)),
                        crkStageRight: AsJsonNum(NumberToInt("ng.result.concrete.BendingDataSLS.crk_stage_right", src.crkStageRight)),
                        eigenfreqUncrk: AsJsonNum(src.eigenfreqUncrk),
                        effArea: AsJsonNum(src.effArea),
                        effMomentOfInertiaY: AsJsonNum(src.effMomentOfInertiaY),
                        avgCrkDist: AsJsonNum(src.avgCrkDist),
                        minReqReinfArea: AsJsonNum(src.minReqReinfArea),
                        curReinfArea: AsJsonNum(src.curReinfArea),
                        zeta: AsJsonNum(src.zeta),
                        crackWidthLimit: AsJsonNum(src.crackWidthLimit),
                        compressionStress: AsJsonNum(src.compressionStress),
                        compressionStressFactor: AsJsonNum(src.compressionStressFactor),
                        compressionStrength: AsJsonNum(src.compressionStrength),
                        minReqReinfAreaEc: AsJsonNum(src.minReqReinfAreaEc),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.coord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.coord);
                        if(parsed === null) return null;
                        dst.coord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: BendingDataSLS_createType) {
                    const dst = new BendingDataSLS();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coord !== undefined) {
                        dst.coord = src.coord;
                    }
                    if (src.extNormalForce !== undefined) {
                        dst.extNormalForce = src.extNormalForce;
                    }
                    if (src.intNormalForce !== undefined) {
                        dst.intNormalForce = src.intNormalForce;
                    }
                    if (src.extMoment !== undefined) {
                        dst.extMoment = src.extMoment;
                    }
                    if (src.intMoment !== undefined) {
                        dst.intMoment = src.intMoment;
                    }
                    if (src.crkMoment !== undefined) {
                        dst.crkMoment = src.crkMoment;
                    }
                    if (src.deflection !== undefined) {
                        dst.deflection = src.deflection;
                    }
                    if (src.crackWidth !== undefined) {
                        dst.crackWidth = src.crackWidth;
                    }
                    if (src.crackWidth2 !== undefined) {
                        dst.crackWidth2 = src.crackWidth2;
                    }
                    if (src.sigmaCTop !== undefined) {
                        dst.sigmaCTop = src.sigmaCTop;
                    }
                    if (src.sigmaCBtm !== undefined) {
                        dst.sigmaCBtm = src.sigmaCBtm;
                    }
                    if (src.sigmaSTop !== undefined) {
                        dst.sigmaSTop = src.sigmaSTop;
                    }
                    if (src.sigmaSBtm !== undefined) {
                        dst.sigmaSBtm = src.sigmaSBtm;
                    }
                    if (src.crkStageTop !== undefined) {
                        dst.crkStageTop = src.crkStageTop;
                    }
                    if (src.crkStageBtm !== undefined) {
                        dst.crkStageBtm = src.crkStageBtm;
                    }
                    if (src.crkStageLeft !== undefined) {
                        dst.crkStageLeft = src.crkStageLeft;
                    }
                    if (src.crkStageRight !== undefined) {
                        dst.crkStageRight = src.crkStageRight;
                    }
                    if (src.eigenfreqUncrk !== undefined) {
                        dst.eigenfreqUncrk = src.eigenfreqUncrk;
                    }
                    if (src.effArea !== undefined) {
                        dst.effArea = src.effArea;
                    }
                    if (src.effMomentOfInertiaY !== undefined) {
                        dst.effMomentOfInertiaY = src.effMomentOfInertiaY;
                    }
                    if (src.avgCrkDist !== undefined) {
                        dst.avgCrkDist = src.avgCrkDist;
                    }
                    if (src.minReqReinfArea !== undefined) {
                        dst.minReqReinfArea = src.minReqReinfArea;
                    }
                    if (src.curReinfArea !== undefined) {
                        dst.curReinfArea = src.curReinfArea;
                    }
                    if (src.zeta !== undefined) {
                        dst.zeta = src.zeta;
                    }
                    if (src.crackWidthLimit !== undefined) {
                        dst.crackWidthLimit = src.crackWidthLimit;
                    }
                    if (src.compressionStress !== undefined) {
                        dst.compressionStress = src.compressionStress;
                    }
                    if (src.compressionStressFactor !== undefined) {
                        dst.compressionStressFactor = src.compressionStressFactor;
                    }
                    if (src.compressionStrength !== undefined) {
                        dst.compressionStrength = src.compressionStrength;
                    }
                    if (src.minReqReinfAreaEc !== undefined) {
                        dst.minReqReinfAreaEc = src.minReqReinfAreaEc;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BendingDataSLS();
                    dst.coord = this.coord;
                    dst.extNormalForce = this.extNormalForce;
                    dst.intNormalForce = this.intNormalForce;
                    dst.extMoment = this.extMoment;
                    dst.intMoment = this.intMoment;
                    dst.crkMoment = this.crkMoment;
                    dst.deflection = this.deflection;
                    dst.crackWidth = this.crackWidth;
                    dst.crackWidth2 = this.crackWidth2;
                    dst.sigmaCTop = this.sigmaCTop;
                    dst.sigmaCBtm = this.sigmaCBtm;
                    dst.sigmaSTop = this.sigmaSTop;
                    dst.sigmaSBtm = this.sigmaSBtm;
                    dst.crkStageTop = this.crkStageTop;
                    dst.crkStageBtm = this.crkStageBtm;
                    dst.crkStageLeft = this.crkStageLeft;
                    dst.crkStageRight = this.crkStageRight;
                    dst.eigenfreqUncrk = this.eigenfreqUncrk;
                    dst.effArea = this.effArea;
                    dst.effMomentOfInertiaY = this.effMomentOfInertiaY;
                    dst.avgCrkDist = this.avgCrkDist;
                    dst.minReqReinfArea = this.minReqReinfArea;
                    dst.curReinfArea = this.curReinfArea;
                    dst.zeta = this.zeta;
                    dst.crackWidthLimit = this.crackWidthLimit;
                    dst.compressionStress = this.compressionStress;
                    dst.compressionStressFactor = this.compressionStressFactor;
                    dst.compressionStrength = this.compressionStrength;
                    dst.minReqReinfAreaEc = this.minReqReinfAreaEc;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = BendingDataSLS.toObject(this);
                    const dst = BendingDataSLS.fromObject(json);
                    return dst;
                }
            }
            export type IBendingDataSLS = BendingDataSLS;


            export type BendingDataULS_keys = 'coord' | 'moment' | 'momentCapa' | 'utilization' | 'normalForce' | 'intLever' | 'compZoneHeight' | 'epsC' | 'epsS' | 'sigmaSc' | 'sigmaSt' | 'eigenfreqUncrk' | 'hasAdjFactorMoment' | 'adjFactorMoment' | 'normalForceCapacity' | 'moment2' | 'moment2Capacity' | 'biax' | 'crkMoment' | 'crkStageTop' | 'crkStageBtm' | 'reqMinReinfArea' | 'reqReinfArea' | 'curReinfArea' | 'anchorageLength' | 'normalCapacityPureCompression' | 'normalCapacitySlender' | 'slendernessFactor' | 'slendernessFactorMax' | 'radiusOfIntertia' | 'bucklingLength' | 'additionalMoment' | 'additionalMoment2' | 'minEccMoment' | 'minEccMoment2' | 'codeGeneration' | 'controls';
            export interface BendingDataULS_createType {
                coord?: ng.geometry.Point3D | null,
                moment?: number,
                momentCapa?: number,
                utilization?: number,
                normalForce?: number,
                intLever?: number,
                compZoneHeight?: number,
                epsC?: number,
                epsS?: number,
                sigmaSc?: number,
                sigmaSt?: number,
                eigenfreqUncrk?: number,
                hasAdjFactorMoment?: boolean,
                adjFactorMoment?: number,
                normalForceCapacity?: number,
                moment2?: number,
                moment2Capacity?: number,
                biax?: number,
                crkMoment?: number,
                crkStageTop?: number,
                crkStageBtm?: number,
                reqMinReinfArea?: number,
                reqReinfArea?: number,
                curReinfArea?: number,
                anchorageLength?: ng.result.concrete.AnchorageLength[],
                normalCapacityPureCompression?: number,
                normalCapacitySlender?: number,
                slendernessFactor?: number,
                slendernessFactorMax?: number,
                radiusOfIntertia?: number,
                bucklingLength?: number,
                additionalMoment?: number,
                additionalMoment2?: number,
                minEccMoment?: number,
                minEccMoment2?: number,
                codeGeneration?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface BendingDataULS_json {
                coord?: ng.geometry.Point3D_json;
                moment?: JsonNumber;
                momentCapa?: JsonNumber;
                utilization?: JsonNumber;
                normalForce?: JsonNumber;
                intLever?: JsonNumber;
                compZoneHeight?: JsonNumber;
                epsC?: JsonNumber;
                epsS?: JsonNumber;
                sigmaSc?: JsonNumber;
                sigmaSt?: JsonNumber;
                eigenfreqUncrk?: JsonNumber;
                hasAdjFactorMoment?: boolean;
                adjFactorMoment?: JsonNumber;
                normalForceCapacity?: JsonNumber;
                moment2?: JsonNumber;
                moment2Capacity?: JsonNumber;
                biax?: JsonNumber;
                crkMoment?: JsonNumber;
                crkStageTop?: JsonNumber;
                crkStageBtm?: JsonNumber;
                reqMinReinfArea?: JsonNumber;
                reqReinfArea?: JsonNumber;
                curReinfArea?: JsonNumber;
                anchorageLength: ng.result.concrete.AnchorageLength_json[];
                normalCapacityPureCompression?: JsonNumber;
                normalCapacitySlender?: JsonNumber;
                slendernessFactor?: JsonNumber;
                slendernessFactorMax?: JsonNumber;
                radiusOfIntertia?: JsonNumber;
                bucklingLength?: JsonNumber;
                additionalMoment?: JsonNumber;
                additionalMoment2?: JsonNumber;
                minEccMoment?: JsonNumber;
                minEccMoment2?: JsonNumber;
                codeGeneration?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface BendingDataULS_json_in {
                __proto_name?: unknown;
                coord?: unknown;
                moment?: unknown;
                momentCapa?: unknown;
                utilization?: unknown;
                normalForce?: unknown;
                intLever?: unknown;
                compZoneHeight?: unknown;
                epsC?: unknown;
                epsS?: unknown;
                sigmaSc?: unknown;
                sigmaSt?: unknown;
                eigenfreqUncrk?: unknown;
                hasAdjFactorMoment?: unknown;
                adjFactorMoment?: unknown;
                normalForceCapacity?: unknown;
                moment2?: unknown;
                moment2Capacity?: unknown;
                biax?: unknown;
                crkMoment?: unknown;
                crkStageTop?: unknown;
                crkStageBtm?: unknown;
                reqMinReinfArea?: unknown;
                reqReinfArea?: unknown;
                curReinfArea?: unknown;
                anchorageLength?: unknown;
                normalCapacityPureCompression?: unknown;
                normalCapacitySlender?: unknown;
                slendernessFactor?: unknown;
                slendernessFactorMax?: unknown;
                radiusOfIntertia?: unknown;
                bucklingLength?: unknown;
                additionalMoment?: unknown;
                additionalMoment2?: unknown;
                minEccMoment?: unknown;
                minEccMoment2?: unknown;
                codeGeneration?: unknown;
                controls?: unknown;
            }
            export class BendingDataULS {
                __proto_name = "ng.result.concrete.BendingDataULS";
                coord: ng.geometry.Point3D | null = null;
                moment: number = 0;
                momentCapa: number = 0;
                utilization: number = 0;
                normalForce: number = 0;
                intLever: number = 0;
                compZoneHeight: number = 0;
                epsC: number = 0;
                epsS: number = 0;
                sigmaSc: number = 0;
                sigmaSt: number = 0;
                eigenfreqUncrk: number = 0;
                hasAdjFactorMoment: boolean = false;
                adjFactorMoment: number = 0;
                normalForceCapacity: number = 0;
                moment2: number = 0;
                moment2Capacity: number = 0;
                biax: number = 0;
                crkMoment: number = 0;
                crkStageTop: number = 0;
                crkStageBtm: number = 0;
                reqMinReinfArea: number = 0;
                reqReinfArea: number = 0;
                curReinfArea: number = 0;
                anchorageLength: ng.result.concrete.AnchorageLength[] = [];
                normalCapacityPureCompression: number = 0;
                normalCapacitySlender: number = 0;
                slendernessFactor: number = 0;
                slendernessFactorMax: number = 0;
                radiusOfIntertia: number = 0;
                bucklingLength: number = 0;
                additionalMoment: number = 0;
                additionalMoment2: number = 0;
                minEccMoment: number = 0;
                minEccMoment2: number = 0;
                codeGeneration: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): BendingDataULS {
                    const dst = new BendingDataULS();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BendingDataULS but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BendingDataULS_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BendingDataULS but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coord !== undefined && src.coord !== null) {
                        dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                    }
                    if (src.moment !== undefined && src.moment !== null) {
                        if (typeof src.moment === "number" || src.moment === 'NaN' || src.moment === 'Infinity' || src.moment === '-Infinity') {
                            dst.moment = AsNum(src.moment);
                        }
                        else {
                            console.log('Expected moment of BendingDataULS to be a number but was ', typeof src.moment, src.moment)
                        }
                    }
                    if (src.momentCapa !== undefined && src.momentCapa !== null) {
                        if (typeof src.momentCapa === "number" || src.momentCapa === 'NaN' || src.momentCapa === 'Infinity' || src.momentCapa === '-Infinity') {
                            dst.momentCapa = AsNum(src.momentCapa);
                        }
                        else {
                            console.log('Expected momentCapa of BendingDataULS to be a number but was ', typeof src.momentCapa, src.momentCapa)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of BendingDataULS to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.normalForce !== undefined && src.normalForce !== null) {
                        if (typeof src.normalForce === "number" || src.normalForce === 'NaN' || src.normalForce === 'Infinity' || src.normalForce === '-Infinity') {
                            dst.normalForce = AsNum(src.normalForce);
                        }
                        else {
                            console.log('Expected normalForce of BendingDataULS to be a number but was ', typeof src.normalForce, src.normalForce)
                        }
                    }
                    if (src.intLever !== undefined && src.intLever !== null) {
                        if (typeof src.intLever === "number" || src.intLever === 'NaN' || src.intLever === 'Infinity' || src.intLever === '-Infinity') {
                            dst.intLever = AsNum(src.intLever);
                        }
                        else {
                            console.log('Expected intLever of BendingDataULS to be a number but was ', typeof src.intLever, src.intLever)
                        }
                    }
                    if (src.compZoneHeight !== undefined && src.compZoneHeight !== null) {
                        if (typeof src.compZoneHeight === "number" || src.compZoneHeight === 'NaN' || src.compZoneHeight === 'Infinity' || src.compZoneHeight === '-Infinity') {
                            dst.compZoneHeight = AsNum(src.compZoneHeight);
                        }
                        else {
                            console.log('Expected compZoneHeight of BendingDataULS to be a number but was ', typeof src.compZoneHeight, src.compZoneHeight)
                        }
                    }
                    if (src.epsC !== undefined && src.epsC !== null) {
                        if (typeof src.epsC === "number" || src.epsC === 'NaN' || src.epsC === 'Infinity' || src.epsC === '-Infinity') {
                            dst.epsC = AsNum(src.epsC);
                        }
                        else {
                            console.log('Expected epsC of BendingDataULS to be a number but was ', typeof src.epsC, src.epsC)
                        }
                    }
                    if (src.epsS !== undefined && src.epsS !== null) {
                        if (typeof src.epsS === "number" || src.epsS === 'NaN' || src.epsS === 'Infinity' || src.epsS === '-Infinity') {
                            dst.epsS = AsNum(src.epsS);
                        }
                        else {
                            console.log('Expected epsS of BendingDataULS to be a number but was ', typeof src.epsS, src.epsS)
                        }
                    }
                    if (src.sigmaSc !== undefined && src.sigmaSc !== null) {
                        if (typeof src.sigmaSc === "number" || src.sigmaSc === 'NaN' || src.sigmaSc === 'Infinity' || src.sigmaSc === '-Infinity') {
                            dst.sigmaSc = AsNum(src.sigmaSc);
                        }
                        else {
                            console.log('Expected sigmaSc of BendingDataULS to be a number but was ', typeof src.sigmaSc, src.sigmaSc)
                        }
                    }
                    if (src.sigmaSt !== undefined && src.sigmaSt !== null) {
                        if (typeof src.sigmaSt === "number" || src.sigmaSt === 'NaN' || src.sigmaSt === 'Infinity' || src.sigmaSt === '-Infinity') {
                            dst.sigmaSt = AsNum(src.sigmaSt);
                        }
                        else {
                            console.log('Expected sigmaSt of BendingDataULS to be a number but was ', typeof src.sigmaSt, src.sigmaSt)
                        }
                    }
                    if (src.eigenfreqUncrk !== undefined && src.eigenfreqUncrk !== null) {
                        if (typeof src.eigenfreqUncrk === "number" || src.eigenfreqUncrk === 'NaN' || src.eigenfreqUncrk === 'Infinity' || src.eigenfreqUncrk === '-Infinity') {
                            dst.eigenfreqUncrk = AsNum(src.eigenfreqUncrk);
                        }
                        else {
                            console.log('Expected eigenfreqUncrk of BendingDataULS to be a number but was ', typeof src.eigenfreqUncrk, src.eigenfreqUncrk)
                        }
                    }
                    if (src.hasAdjFactorMoment !== undefined && src.hasAdjFactorMoment !== null) {
                        if (typeof src.hasAdjFactorMoment === "boolean") {
                            dst.hasAdjFactorMoment = src.hasAdjFactorMoment;
                        }
                        else {
                            console.log('Expected hasAdjFactorMoment of BendingDataULS to be a boolean but was ', typeof src.hasAdjFactorMoment, src.hasAdjFactorMoment)
                        }
                    }
                    if (src.adjFactorMoment !== undefined && src.adjFactorMoment !== null) {
                        if (typeof src.adjFactorMoment === "number" || src.adjFactorMoment === 'NaN' || src.adjFactorMoment === 'Infinity' || src.adjFactorMoment === '-Infinity') {
                            dst.adjFactorMoment = AsNum(src.adjFactorMoment);
                        }
                        else {
                            console.log('Expected adjFactorMoment of BendingDataULS to be a number but was ', typeof src.adjFactorMoment, src.adjFactorMoment)
                        }
                    }
                    if (src.normalForceCapacity !== undefined && src.normalForceCapacity !== null) {
                        if (typeof src.normalForceCapacity === "number" || src.normalForceCapacity === 'NaN' || src.normalForceCapacity === 'Infinity' || src.normalForceCapacity === '-Infinity') {
                            dst.normalForceCapacity = AsNum(src.normalForceCapacity);
                        }
                        else {
                            console.log('Expected normalForceCapacity of BendingDataULS to be a number but was ', typeof src.normalForceCapacity, src.normalForceCapacity)
                        }
                    }
                    if (src.moment2 !== undefined && src.moment2 !== null) {
                        if (typeof src.moment2 === "number" || src.moment2 === 'NaN' || src.moment2 === 'Infinity' || src.moment2 === '-Infinity') {
                            dst.moment2 = AsNum(src.moment2);
                        }
                        else {
                            console.log('Expected moment2 of BendingDataULS to be a number but was ', typeof src.moment2, src.moment2)
                        }
                    }
                    if (src.moment2Capacity !== undefined && src.moment2Capacity !== null) {
                        if (typeof src.moment2Capacity === "number" || src.moment2Capacity === 'NaN' || src.moment2Capacity === 'Infinity' || src.moment2Capacity === '-Infinity') {
                            dst.moment2Capacity = AsNum(src.moment2Capacity);
                        }
                        else {
                            console.log('Expected moment2Capacity of BendingDataULS to be a number but was ', typeof src.moment2Capacity, src.moment2Capacity)
                        }
                    }
                    if (src.biax !== undefined && src.biax !== null) {
                        if (typeof src.biax === "number" || src.biax === 'NaN' || src.biax === 'Infinity' || src.biax === '-Infinity') {
                            dst.biax = AsNum(src.biax);
                        }
                        else {
                            console.log('Expected biax of BendingDataULS to be a number but was ', typeof src.biax, src.biax)
                        }
                    }
                    if (src.crkMoment !== undefined && src.crkMoment !== null) {
                        if (typeof src.crkMoment === "number" || src.crkMoment === 'NaN' || src.crkMoment === 'Infinity' || src.crkMoment === '-Infinity') {
                            dst.crkMoment = AsNum(src.crkMoment);
                        }
                        else {
                            console.log('Expected crkMoment of BendingDataULS to be a number but was ', typeof src.crkMoment, src.crkMoment)
                        }
                    }
                    if (src.crkStageTop !== undefined && src.crkStageTop !== null) {
                        if (typeof src.crkStageTop === "number" || src.crkStageTop === 'NaN' || src.crkStageTop === 'Infinity' || src.crkStageTop === '-Infinity') {
                            dst.crkStageTop = NumberToInt("ng.result.concrete.BendingDataULS.crk_stage_top", AsNum(src.crkStageTop));
                        }
                        else {
                            console.log('Expected crkStageTop of BendingDataULS to be a number but was ', typeof src.crkStageTop, src.crkStageTop)
                        }
                    }
                    if (src.crkStageBtm !== undefined && src.crkStageBtm !== null) {
                        if (typeof src.crkStageBtm === "number" || src.crkStageBtm === 'NaN' || src.crkStageBtm === 'Infinity' || src.crkStageBtm === '-Infinity') {
                            dst.crkStageBtm = NumberToInt("ng.result.concrete.BendingDataULS.crk_stage_btm", AsNum(src.crkStageBtm));
                        }
                        else {
                            console.log('Expected crkStageBtm of BendingDataULS to be a number but was ', typeof src.crkStageBtm, src.crkStageBtm)
                        }
                    }
                    if (src.reqMinReinfArea !== undefined && src.reqMinReinfArea !== null) {
                        if (typeof src.reqMinReinfArea === "number" || src.reqMinReinfArea === 'NaN' || src.reqMinReinfArea === 'Infinity' || src.reqMinReinfArea === '-Infinity') {
                            dst.reqMinReinfArea = AsNum(src.reqMinReinfArea);
                        }
                        else {
                            console.log('Expected reqMinReinfArea of BendingDataULS to be a number but was ', typeof src.reqMinReinfArea, src.reqMinReinfArea)
                        }
                    }
                    if (src.reqReinfArea !== undefined && src.reqReinfArea !== null) {
                        if (typeof src.reqReinfArea === "number" || src.reqReinfArea === 'NaN' || src.reqReinfArea === 'Infinity' || src.reqReinfArea === '-Infinity') {
                            dst.reqReinfArea = AsNum(src.reqReinfArea);
                        }
                        else {
                            console.log('Expected reqReinfArea of BendingDataULS to be a number but was ', typeof src.reqReinfArea, src.reqReinfArea)
                        }
                    }
                    if (src.curReinfArea !== undefined && src.curReinfArea !== null) {
                        if (typeof src.curReinfArea === "number" || src.curReinfArea === 'NaN' || src.curReinfArea === 'Infinity' || src.curReinfArea === '-Infinity') {
                            dst.curReinfArea = AsNum(src.curReinfArea);
                        }
                        else {
                            console.log('Expected curReinfArea of BendingDataULS to be a number but was ', typeof src.curReinfArea, src.curReinfArea)
                        }
                    }
                    if (src.anchorageLength !== undefined && src.anchorageLength !== null) {
                        if (Array.isArray(src.anchorageLength)) {
                            for (const element of src.anchorageLength) {
                                dst.anchorageLength.push(ng.result.concrete.AnchorageLength.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected anchorageLength of BendingDataULS to be a array but was ', typeof src.anchorageLength, src.anchorageLength)
                        }
                    }
                    if (src.normalCapacityPureCompression !== undefined && src.normalCapacityPureCompression !== null) {
                        if (typeof src.normalCapacityPureCompression === "number" || src.normalCapacityPureCompression === 'NaN' || src.normalCapacityPureCompression === 'Infinity' || src.normalCapacityPureCompression === '-Infinity') {
                            dst.normalCapacityPureCompression = AsNum(src.normalCapacityPureCompression);
                        }
                        else {
                            console.log('Expected normalCapacityPureCompression of BendingDataULS to be a number but was ', typeof src.normalCapacityPureCompression, src.normalCapacityPureCompression)
                        }
                    }
                    if (src.normalCapacitySlender !== undefined && src.normalCapacitySlender !== null) {
                        if (typeof src.normalCapacitySlender === "number" || src.normalCapacitySlender === 'NaN' || src.normalCapacitySlender === 'Infinity' || src.normalCapacitySlender === '-Infinity') {
                            dst.normalCapacitySlender = AsNum(src.normalCapacitySlender);
                        }
                        else {
                            console.log('Expected normalCapacitySlender of BendingDataULS to be a number but was ', typeof src.normalCapacitySlender, src.normalCapacitySlender)
                        }
                    }
                    if (src.slendernessFactor !== undefined && src.slendernessFactor !== null) {
                        if (typeof src.slendernessFactor === "number" || src.slendernessFactor === 'NaN' || src.slendernessFactor === 'Infinity' || src.slendernessFactor === '-Infinity') {
                            dst.slendernessFactor = AsNum(src.slendernessFactor);
                        }
                        else {
                            console.log('Expected slendernessFactor of BendingDataULS to be a number but was ', typeof src.slendernessFactor, src.slendernessFactor)
                        }
                    }
                    if (src.slendernessFactorMax !== undefined && src.slendernessFactorMax !== null) {
                        if (typeof src.slendernessFactorMax === "number" || src.slendernessFactorMax === 'NaN' || src.slendernessFactorMax === 'Infinity' || src.slendernessFactorMax === '-Infinity') {
                            dst.slendernessFactorMax = AsNum(src.slendernessFactorMax);
                        }
                        else {
                            console.log('Expected slendernessFactorMax of BendingDataULS to be a number but was ', typeof src.slendernessFactorMax, src.slendernessFactorMax)
                        }
                    }
                    if (src.radiusOfIntertia !== undefined && src.radiusOfIntertia !== null) {
                        if (typeof src.radiusOfIntertia === "number" || src.radiusOfIntertia === 'NaN' || src.radiusOfIntertia === 'Infinity' || src.radiusOfIntertia === '-Infinity') {
                            dst.radiusOfIntertia = AsNum(src.radiusOfIntertia);
                        }
                        else {
                            console.log('Expected radiusOfIntertia of BendingDataULS to be a number but was ', typeof src.radiusOfIntertia, src.radiusOfIntertia)
                        }
                    }
                    if (src.bucklingLength !== undefined && src.bucklingLength !== null) {
                        if (typeof src.bucklingLength === "number" || src.bucklingLength === 'NaN' || src.bucklingLength === 'Infinity' || src.bucklingLength === '-Infinity') {
                            dst.bucklingLength = AsNum(src.bucklingLength);
                        }
                        else {
                            console.log('Expected bucklingLength of BendingDataULS to be a number but was ', typeof src.bucklingLength, src.bucklingLength)
                        }
                    }
                    if (src.additionalMoment !== undefined && src.additionalMoment !== null) {
                        if (typeof src.additionalMoment === "number" || src.additionalMoment === 'NaN' || src.additionalMoment === 'Infinity' || src.additionalMoment === '-Infinity') {
                            dst.additionalMoment = AsNum(src.additionalMoment);
                        }
                        else {
                            console.log('Expected additionalMoment of BendingDataULS to be a number but was ', typeof src.additionalMoment, src.additionalMoment)
                        }
                    }
                    if (src.additionalMoment2 !== undefined && src.additionalMoment2 !== null) {
                        if (typeof src.additionalMoment2 === "number" || src.additionalMoment2 === 'NaN' || src.additionalMoment2 === 'Infinity' || src.additionalMoment2 === '-Infinity') {
                            dst.additionalMoment2 = AsNum(src.additionalMoment2);
                        }
                        else {
                            console.log('Expected additionalMoment2 of BendingDataULS to be a number but was ', typeof src.additionalMoment2, src.additionalMoment2)
                        }
                    }
                    if (src.minEccMoment !== undefined && src.minEccMoment !== null) {
                        if (typeof src.minEccMoment === "number" || src.minEccMoment === 'NaN' || src.minEccMoment === 'Infinity' || src.minEccMoment === '-Infinity') {
                            dst.minEccMoment = AsNum(src.minEccMoment);
                        }
                        else {
                            console.log('Expected minEccMoment of BendingDataULS to be a number but was ', typeof src.minEccMoment, src.minEccMoment)
                        }
                    }
                    if (src.minEccMoment2 !== undefined && src.minEccMoment2 !== null) {
                        if (typeof src.minEccMoment2 === "number" || src.minEccMoment2 === 'NaN' || src.minEccMoment2 === 'Infinity' || src.minEccMoment2 === '-Infinity') {
                            dst.minEccMoment2 = AsNum(src.minEccMoment2);
                        }
                        else {
                            console.log('Expected minEccMoment2 of BendingDataULS to be a number but was ', typeof src.minEccMoment2, src.minEccMoment2)
                        }
                    }
                    if (src.codeGeneration !== undefined && src.codeGeneration !== null) {
                        if (typeof src.codeGeneration === "number" || src.codeGeneration === 'NaN' || src.codeGeneration === 'Infinity' || src.codeGeneration === '-Infinity') {
                            dst.codeGeneration = NumberToInt("ng.result.concrete.BendingDataULS.code_generation", AsNum(src.codeGeneration));
                        }
                        else {
                            console.log('Expected codeGeneration of BendingDataULS to be a number but was ', typeof src.codeGeneration, src.codeGeneration)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of BendingDataULS to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: BendingDataULS | null | undefined): BendingDataULS_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.BendingDataULS is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.BendingDataULS") {
                        console.error('Expected ng.result.concrete.BendingDataULS but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BendingDataULS_json = {
                        moment: AsJsonNum(src.moment),
                        momentCapa: AsJsonNum(src.momentCapa),
                        utilization: AsJsonNum(src.utilization),
                        normalForce: AsJsonNum(src.normalForce),
                        intLever: AsJsonNum(src.intLever),
                        compZoneHeight: AsJsonNum(src.compZoneHeight),
                        epsC: AsJsonNum(src.epsC),
                        epsS: AsJsonNum(src.epsS),
                        sigmaSc: AsJsonNum(src.sigmaSc),
                        sigmaSt: AsJsonNum(src.sigmaSt),
                        eigenfreqUncrk: AsJsonNum(src.eigenfreqUncrk),
                        hasAdjFactorMoment: src.hasAdjFactorMoment,
                        adjFactorMoment: AsJsonNum(src.adjFactorMoment),
                        normalForceCapacity: AsJsonNum(src.normalForceCapacity),
                        moment2: AsJsonNum(src.moment2),
                        moment2Capacity: AsJsonNum(src.moment2Capacity),
                        biax: AsJsonNum(src.biax),
                        crkMoment: AsJsonNum(src.crkMoment),
                        crkStageTop: AsJsonNum(NumberToInt("ng.result.concrete.BendingDataULS.crk_stage_top", src.crkStageTop)),
                        crkStageBtm: AsJsonNum(NumberToInt("ng.result.concrete.BendingDataULS.crk_stage_btm", src.crkStageBtm)),
                        reqMinReinfArea: AsJsonNum(src.reqMinReinfArea),
                        reqReinfArea: AsJsonNum(src.reqReinfArea),
                        curReinfArea: AsJsonNum(src.curReinfArea),
                        anchorageLength: new Array<ng.result.concrete.AnchorageLength_json>(),
                        normalCapacityPureCompression: AsJsonNum(src.normalCapacityPureCompression),
                        normalCapacitySlender: AsJsonNum(src.normalCapacitySlender),
                        slendernessFactor: AsJsonNum(src.slendernessFactor),
                        slendernessFactorMax: AsJsonNum(src.slendernessFactorMax),
                        radiusOfIntertia: AsJsonNum(src.radiusOfIntertia),
                        bucklingLength: AsJsonNum(src.bucklingLength),
                        additionalMoment: AsJsonNum(src.additionalMoment),
                        additionalMoment2: AsJsonNum(src.additionalMoment2),
                        minEccMoment: AsJsonNum(src.minEccMoment),
                        minEccMoment2: AsJsonNum(src.minEccMoment2),
                        codeGeneration: AsJsonNum(NumberToInt("ng.result.concrete.BendingDataULS.code_generation", src.codeGeneration)),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.coord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.coord);
                        if(parsed === null) return null;
                        dst.coord = parsed;
                    }
                    if (src.anchorageLength !== null) {
                        for (const element of src.anchorageLength) {
                            const parsed = ng.result.concrete.AnchorageLength.toObject(element);
                            if(parsed === null) return null;
                            dst.anchorageLength.push(parsed);
                        }
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: BendingDataULS_createType) {
                    const dst = new BendingDataULS();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coord !== undefined) {
                        dst.coord = src.coord;
                    }
                    if (src.moment !== undefined) {
                        dst.moment = src.moment;
                    }
                    if (src.momentCapa !== undefined) {
                        dst.momentCapa = src.momentCapa;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.normalForce !== undefined) {
                        dst.normalForce = src.normalForce;
                    }
                    if (src.intLever !== undefined) {
                        dst.intLever = src.intLever;
                    }
                    if (src.compZoneHeight !== undefined) {
                        dst.compZoneHeight = src.compZoneHeight;
                    }
                    if (src.epsC !== undefined) {
                        dst.epsC = src.epsC;
                    }
                    if (src.epsS !== undefined) {
                        dst.epsS = src.epsS;
                    }
                    if (src.sigmaSc !== undefined) {
                        dst.sigmaSc = src.sigmaSc;
                    }
                    if (src.sigmaSt !== undefined) {
                        dst.sigmaSt = src.sigmaSt;
                    }
                    if (src.eigenfreqUncrk !== undefined) {
                        dst.eigenfreqUncrk = src.eigenfreqUncrk;
                    }
                    if (src.hasAdjFactorMoment !== undefined) {
                        dst.hasAdjFactorMoment = src.hasAdjFactorMoment;
                    }
                    if (src.adjFactorMoment !== undefined) {
                        dst.adjFactorMoment = src.adjFactorMoment;
                    }
                    if (src.normalForceCapacity !== undefined) {
                        dst.normalForceCapacity = src.normalForceCapacity;
                    }
                    if (src.moment2 !== undefined) {
                        dst.moment2 = src.moment2;
                    }
                    if (src.moment2Capacity !== undefined) {
                        dst.moment2Capacity = src.moment2Capacity;
                    }
                    if (src.biax !== undefined) {
                        dst.biax = src.biax;
                    }
                    if (src.crkMoment !== undefined) {
                        dst.crkMoment = src.crkMoment;
                    }
                    if (src.crkStageTop !== undefined) {
                        dst.crkStageTop = src.crkStageTop;
                    }
                    if (src.crkStageBtm !== undefined) {
                        dst.crkStageBtm = src.crkStageBtm;
                    }
                    if (src.reqMinReinfArea !== undefined) {
                        dst.reqMinReinfArea = src.reqMinReinfArea;
                    }
                    if (src.reqReinfArea !== undefined) {
                        dst.reqReinfArea = src.reqReinfArea;
                    }
                    if (src.curReinfArea !== undefined) {
                        dst.curReinfArea = src.curReinfArea;
                    }
                    if (src.anchorageLength !== undefined) {
                        dst.anchorageLength = src.anchorageLength;
                    }
                    if (src.normalCapacityPureCompression !== undefined) {
                        dst.normalCapacityPureCompression = src.normalCapacityPureCompression;
                    }
                    if (src.normalCapacitySlender !== undefined) {
                        dst.normalCapacitySlender = src.normalCapacitySlender;
                    }
                    if (src.slendernessFactor !== undefined) {
                        dst.slendernessFactor = src.slendernessFactor;
                    }
                    if (src.slendernessFactorMax !== undefined) {
                        dst.slendernessFactorMax = src.slendernessFactorMax;
                    }
                    if (src.radiusOfIntertia !== undefined) {
                        dst.radiusOfIntertia = src.radiusOfIntertia;
                    }
                    if (src.bucklingLength !== undefined) {
                        dst.bucklingLength = src.bucklingLength;
                    }
                    if (src.additionalMoment !== undefined) {
                        dst.additionalMoment = src.additionalMoment;
                    }
                    if (src.additionalMoment2 !== undefined) {
                        dst.additionalMoment2 = src.additionalMoment2;
                    }
                    if (src.minEccMoment !== undefined) {
                        dst.minEccMoment = src.minEccMoment;
                    }
                    if (src.minEccMoment2 !== undefined) {
                        dst.minEccMoment2 = src.minEccMoment2;
                    }
                    if (src.codeGeneration !== undefined) {
                        dst.codeGeneration = src.codeGeneration;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BendingDataULS();
                    dst.coord = this.coord;
                    dst.moment = this.moment;
                    dst.momentCapa = this.momentCapa;
                    dst.utilization = this.utilization;
                    dst.normalForce = this.normalForce;
                    dst.intLever = this.intLever;
                    dst.compZoneHeight = this.compZoneHeight;
                    dst.epsC = this.epsC;
                    dst.epsS = this.epsS;
                    dst.sigmaSc = this.sigmaSc;
                    dst.sigmaSt = this.sigmaSt;
                    dst.eigenfreqUncrk = this.eigenfreqUncrk;
                    dst.hasAdjFactorMoment = this.hasAdjFactorMoment;
                    dst.adjFactorMoment = this.adjFactorMoment;
                    dst.normalForceCapacity = this.normalForceCapacity;
                    dst.moment2 = this.moment2;
                    dst.moment2Capacity = this.moment2Capacity;
                    dst.biax = this.biax;
                    dst.crkMoment = this.crkMoment;
                    dst.crkStageTop = this.crkStageTop;
                    dst.crkStageBtm = this.crkStageBtm;
                    dst.reqMinReinfArea = this.reqMinReinfArea;
                    dst.reqReinfArea = this.reqReinfArea;
                    dst.curReinfArea = this.curReinfArea;
                    dst.anchorageLength = this.anchorageLength;
                    dst.normalCapacityPureCompression = this.normalCapacityPureCompression;
                    dst.normalCapacitySlender = this.normalCapacitySlender;
                    dst.slendernessFactor = this.slendernessFactor;
                    dst.slendernessFactorMax = this.slendernessFactorMax;
                    dst.radiusOfIntertia = this.radiusOfIntertia;
                    dst.bucklingLength = this.bucklingLength;
                    dst.additionalMoment = this.additionalMoment;
                    dst.additionalMoment2 = this.additionalMoment2;
                    dst.minEccMoment = this.minEccMoment;
                    dst.minEccMoment2 = this.minEccMoment2;
                    dst.codeGeneration = this.codeGeneration;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = BendingDataULS.toObject(this);
                    const dst = BendingDataULS.fromObject(json);
                    return dst;
                }
            }
            export type IBendingDataULS = BendingDataULS;


            export type ShearData_keys = 'coord' | 'shearForce' | 'shearCapaForce' | 'utilizationForce' | 'torque' | 'shearCapaMax' | 'shearCapaWeb' | 'shearCapaBend' | 'shearCapaNormalForce' | 'shearCapaSectionDepth' | 'shearCapaCoreFilling' | 'shearCapaTorsion' | 'webWidth' | 'effDepth' | 'shearStress' | 'shearCapaStress' | 'utilizationStress' | 'shearResistReq' | 'hasCoreFilling' | 'hasTorsion' | 'useShearStressCtrl' | 'useShearCapaWeb' | 'vrdEqStr' | 'adjFactorShear' | 'hasAdjFactorShear' | 'shearFieldStart' | 'shearFieldEnd' | 'CRdC' | 'k' | 'ASl' | 'rhoL' | 'fCk' | 'k1' | 'sigmaCp' | 'vMin' | 'I' | 'S' | 'sigmaCpAlphaL' | 'fCtd' | 'v' | 'fCd' | 'closeToSuppFactor' | 'tauEd' | 'tauRdc' | 'tauRdcMin' | 'tauRdcMax' | 'dDg' | 'gammaV' | 'aCs' | 'kVp' | 'NEd' | 'fCtkGammaC' | 'codeGeneration' | 'controls';
            export interface ShearData_createType {
                coord?: ng.geometry.Point3D | null,
                shearForce?: number,
                shearCapaForce?: number,
                utilizationForce?: number,
                torque?: number,
                shearCapaMax?: number,
                shearCapaWeb?: number,
                shearCapaBend?: number,
                shearCapaNormalForce?: number,
                shearCapaSectionDepth?: number,
                shearCapaCoreFilling?: number,
                shearCapaTorsion?: number,
                webWidth?: number,
                effDepth?: number,
                shearStress?: number,
                shearCapaStress?: number,
                utilizationStress?: number,
                shearResistReq?: boolean,
                hasCoreFilling?: boolean,
                hasTorsion?: boolean,
                useShearStressCtrl?: boolean,
                useShearCapaWeb?: boolean,
                vrdEqStr?: string,
                adjFactorShear?: number,
                hasAdjFactorShear?: boolean,
                shearFieldStart?: number,
                shearFieldEnd?: number,
                CRdC?: number,
                k?: number,
                ASl?: number,
                rhoL?: number,
                fCk?: number,
                k1?: number,
                sigmaCp?: number,
                vMin?: number,
                I?: number,
                S?: number,
                sigmaCpAlphaL?: number,
                fCtd?: number,
                v?: number,
                fCd?: number,
                closeToSuppFactor?: number,
                tauEd?: number,
                tauRdc?: number,
                tauRdcMin?: number,
                tauRdcMax?: number,
                dDg?: number,
                gammaV?: number,
                aCs?: number,
                kVp?: number,
                NEd?: number,
                fCtkGammaC?: number,
                codeGeneration?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface ShearData_json {
                coord?: ng.geometry.Point3D_json;
                shearForce?: JsonNumber;
                shearCapaForce?: JsonNumber;
                utilizationForce?: JsonNumber;
                torque?: JsonNumber;
                shearCapaMax?: JsonNumber;
                shearCapaWeb?: JsonNumber;
                shearCapaBend?: JsonNumber;
                shearCapaNormalForce?: JsonNumber;
                shearCapaSectionDepth?: JsonNumber;
                shearCapaCoreFilling?: JsonNumber;
                shearCapaTorsion?: JsonNumber;
                webWidth?: JsonNumber;
                effDepth?: JsonNumber;
                shearStress?: JsonNumber;
                shearCapaStress?: JsonNumber;
                utilizationStress?: JsonNumber;
                shearResistReq?: boolean;
                hasCoreFilling?: boolean;
                hasTorsion?: boolean;
                useShearStressCtrl?: boolean;
                useShearCapaWeb?: boolean;
                vrdEqStr?: string;
                adjFactorShear?: JsonNumber;
                hasAdjFactorShear?: boolean;
                shearFieldStart?: JsonNumber;
                shearFieldEnd?: JsonNumber;
                CRdC?: JsonNumber;
                k?: JsonNumber;
                ASl?: JsonNumber;
                rhoL?: JsonNumber;
                fCk?: JsonNumber;
                k1?: JsonNumber;
                sigmaCp?: JsonNumber;
                vMin?: JsonNumber;
                I?: JsonNumber;
                S?: JsonNumber;
                sigmaCpAlphaL?: JsonNumber;
                fCtd?: JsonNumber;
                v?: JsonNumber;
                fCd?: JsonNumber;
                closeToSuppFactor?: JsonNumber;
                tauEd?: JsonNumber;
                tauRdc?: JsonNumber;
                tauRdcMin?: JsonNumber;
                tauRdcMax?: JsonNumber;
                dDg?: JsonNumber;
                gammaV?: JsonNumber;
                aCs?: JsonNumber;
                kVp?: JsonNumber;
                NEd?: JsonNumber;
                fCtkGammaC?: JsonNumber;
                codeGeneration?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface ShearData_json_in {
                __proto_name?: unknown;
                coord?: unknown;
                shearForce?: unknown;
                shearCapaForce?: unknown;
                utilizationForce?: unknown;
                torque?: unknown;
                shearCapaMax?: unknown;
                shearCapaWeb?: unknown;
                shearCapaBend?: unknown;
                shearCapaNormalForce?: unknown;
                shearCapaSectionDepth?: unknown;
                shearCapaCoreFilling?: unknown;
                shearCapaTorsion?: unknown;
                webWidth?: unknown;
                effDepth?: unknown;
                shearStress?: unknown;
                shearCapaStress?: unknown;
                utilizationStress?: unknown;
                shearResistReq?: unknown;
                hasCoreFilling?: unknown;
                hasTorsion?: unknown;
                useShearStressCtrl?: unknown;
                useShearCapaWeb?: unknown;
                vrdEqStr?: unknown;
                adjFactorShear?: unknown;
                hasAdjFactorShear?: unknown;
                shearFieldStart?: unknown;
                shearFieldEnd?: unknown;
                CRdC?: unknown;
                k?: unknown;
                ASl?: unknown;
                rhoL?: unknown;
                fCk?: unknown;
                k1?: unknown;
                sigmaCp?: unknown;
                vMin?: unknown;
                I?: unknown;
                S?: unknown;
                sigmaCpAlphaL?: unknown;
                fCtd?: unknown;
                v?: unknown;
                fCd?: unknown;
                closeToSuppFactor?: unknown;
                tauEd?: unknown;
                tauRdc?: unknown;
                tauRdcMin?: unknown;
                tauRdcMax?: unknown;
                dDg?: unknown;
                gammaV?: unknown;
                aCs?: unknown;
                kVp?: unknown;
                NEd?: unknown;
                fCtkGammaC?: unknown;
                codeGeneration?: unknown;
                controls?: unknown;
            }
            export class ShearData {
                __proto_name = "ng.result.concrete.ShearData";
                coord: ng.geometry.Point3D | null = null;
                shearForce: number = 0;
                shearCapaForce: number = 0;
                utilizationForce: number = 0;
                torque: number = 0;
                shearCapaMax: number = 0;
                shearCapaWeb: number = 0;
                shearCapaBend: number = 0;
                shearCapaNormalForce: number = 0;
                shearCapaSectionDepth: number = 0;
                shearCapaCoreFilling: number = 0;
                shearCapaTorsion: number = 0;
                webWidth: number = 0;
                effDepth: number = 0;
                shearStress: number = 0;
                shearCapaStress: number = 0;
                utilizationStress: number = 0;
                shearResistReq: boolean = false;
                hasCoreFilling: boolean = false;
                hasTorsion: boolean = false;
                useShearStressCtrl: boolean = false;
                useShearCapaWeb: boolean = false;
                vrdEqStr: string = "";
                adjFactorShear: number = 0;
                hasAdjFactorShear: boolean = false;
                shearFieldStart: number = 0;
                shearFieldEnd: number = 0;
                CRdC: number = 0;
                k: number = 0;
                ASl: number = 0;
                rhoL: number = 0;
                fCk: number = 0;
                k1: number = 0;
                sigmaCp: number = 0;
                vMin: number = 0;
                I: number = 0;
                S: number = 0;
                sigmaCpAlphaL: number = 0;
                fCtd: number = 0;
                v: number = 0;
                fCd: number = 0;
                closeToSuppFactor: number = 0;
                tauEd: number = 0;
                tauRdc: number = 0;
                tauRdcMin: number = 0;
                tauRdcMax: number = 0;
                dDg: number = 0;
                gammaV: number = 0;
                aCs: number = 0;
                kVp: number = 0;
                NEd: number = 0;
                fCtkGammaC: number = 0;
                codeGeneration: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): ShearData {
                    const dst = new ShearData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ShearData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ShearData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ShearData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coord !== undefined && src.coord !== null) {
                        dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                    }
                    if (src.shearForce !== undefined && src.shearForce !== null) {
                        if (typeof src.shearForce === "number" || src.shearForce === 'NaN' || src.shearForce === 'Infinity' || src.shearForce === '-Infinity') {
                            dst.shearForce = AsNum(src.shearForce);
                        }
                        else {
                            console.log('Expected shearForce of ShearData to be a number but was ', typeof src.shearForce, src.shearForce)
                        }
                    }
                    if (src.shearCapaForce !== undefined && src.shearCapaForce !== null) {
                        if (typeof src.shearCapaForce === "number" || src.shearCapaForce === 'NaN' || src.shearCapaForce === 'Infinity' || src.shearCapaForce === '-Infinity') {
                            dst.shearCapaForce = AsNum(src.shearCapaForce);
                        }
                        else {
                            console.log('Expected shearCapaForce of ShearData to be a number but was ', typeof src.shearCapaForce, src.shearCapaForce)
                        }
                    }
                    if (src.utilizationForce !== undefined && src.utilizationForce !== null) {
                        if (typeof src.utilizationForce === "number" || src.utilizationForce === 'NaN' || src.utilizationForce === 'Infinity' || src.utilizationForce === '-Infinity') {
                            dst.utilizationForce = AsNum(src.utilizationForce);
                        }
                        else {
                            console.log('Expected utilizationForce of ShearData to be a number but was ', typeof src.utilizationForce, src.utilizationForce)
                        }
                    }
                    if (src.torque !== undefined && src.torque !== null) {
                        if (typeof src.torque === "number" || src.torque === 'NaN' || src.torque === 'Infinity' || src.torque === '-Infinity') {
                            dst.torque = AsNum(src.torque);
                        }
                        else {
                            console.log('Expected torque of ShearData to be a number but was ', typeof src.torque, src.torque)
                        }
                    }
                    if (src.shearCapaMax !== undefined && src.shearCapaMax !== null) {
                        if (typeof src.shearCapaMax === "number" || src.shearCapaMax === 'NaN' || src.shearCapaMax === 'Infinity' || src.shearCapaMax === '-Infinity') {
                            dst.shearCapaMax = AsNum(src.shearCapaMax);
                        }
                        else {
                            console.log('Expected shearCapaMax of ShearData to be a number but was ', typeof src.shearCapaMax, src.shearCapaMax)
                        }
                    }
                    if (src.shearCapaWeb !== undefined && src.shearCapaWeb !== null) {
                        if (typeof src.shearCapaWeb === "number" || src.shearCapaWeb === 'NaN' || src.shearCapaWeb === 'Infinity' || src.shearCapaWeb === '-Infinity') {
                            dst.shearCapaWeb = AsNum(src.shearCapaWeb);
                        }
                        else {
                            console.log('Expected shearCapaWeb of ShearData to be a number but was ', typeof src.shearCapaWeb, src.shearCapaWeb)
                        }
                    }
                    if (src.shearCapaBend !== undefined && src.shearCapaBend !== null) {
                        if (typeof src.shearCapaBend === "number" || src.shearCapaBend === 'NaN' || src.shearCapaBend === 'Infinity' || src.shearCapaBend === '-Infinity') {
                            dst.shearCapaBend = AsNum(src.shearCapaBend);
                        }
                        else {
                            console.log('Expected shearCapaBend of ShearData to be a number but was ', typeof src.shearCapaBend, src.shearCapaBend)
                        }
                    }
                    if (src.shearCapaNormalForce !== undefined && src.shearCapaNormalForce !== null) {
                        if (typeof src.shearCapaNormalForce === "number" || src.shearCapaNormalForce === 'NaN' || src.shearCapaNormalForce === 'Infinity' || src.shearCapaNormalForce === '-Infinity') {
                            dst.shearCapaNormalForce = AsNum(src.shearCapaNormalForce);
                        }
                        else {
                            console.log('Expected shearCapaNormalForce of ShearData to be a number but was ', typeof src.shearCapaNormalForce, src.shearCapaNormalForce)
                        }
                    }
                    if (src.shearCapaSectionDepth !== undefined && src.shearCapaSectionDepth !== null) {
                        if (typeof src.shearCapaSectionDepth === "number" || src.shearCapaSectionDepth === 'NaN' || src.shearCapaSectionDepth === 'Infinity' || src.shearCapaSectionDepth === '-Infinity') {
                            dst.shearCapaSectionDepth = AsNum(src.shearCapaSectionDepth);
                        }
                        else {
                            console.log('Expected shearCapaSectionDepth of ShearData to be a number but was ', typeof src.shearCapaSectionDepth, src.shearCapaSectionDepth)
                        }
                    }
                    if (src.shearCapaCoreFilling !== undefined && src.shearCapaCoreFilling !== null) {
                        if (typeof src.shearCapaCoreFilling === "number" || src.shearCapaCoreFilling === 'NaN' || src.shearCapaCoreFilling === 'Infinity' || src.shearCapaCoreFilling === '-Infinity') {
                            dst.shearCapaCoreFilling = AsNum(src.shearCapaCoreFilling);
                        }
                        else {
                            console.log('Expected shearCapaCoreFilling of ShearData to be a number but was ', typeof src.shearCapaCoreFilling, src.shearCapaCoreFilling)
                        }
                    }
                    if (src.shearCapaTorsion !== undefined && src.shearCapaTorsion !== null) {
                        if (typeof src.shearCapaTorsion === "number" || src.shearCapaTorsion === 'NaN' || src.shearCapaTorsion === 'Infinity' || src.shearCapaTorsion === '-Infinity') {
                            dst.shearCapaTorsion = AsNum(src.shearCapaTorsion);
                        }
                        else {
                            console.log('Expected shearCapaTorsion of ShearData to be a number but was ', typeof src.shearCapaTorsion, src.shearCapaTorsion)
                        }
                    }
                    if (src.webWidth !== undefined && src.webWidth !== null) {
                        if (typeof src.webWidth === "number" || src.webWidth === 'NaN' || src.webWidth === 'Infinity' || src.webWidth === '-Infinity') {
                            dst.webWidth = AsNum(src.webWidth);
                        }
                        else {
                            console.log('Expected webWidth of ShearData to be a number but was ', typeof src.webWidth, src.webWidth)
                        }
                    }
                    if (src.effDepth !== undefined && src.effDepth !== null) {
                        if (typeof src.effDepth === "number" || src.effDepth === 'NaN' || src.effDepth === 'Infinity' || src.effDepth === '-Infinity') {
                            dst.effDepth = AsNum(src.effDepth);
                        }
                        else {
                            console.log('Expected effDepth of ShearData to be a number but was ', typeof src.effDepth, src.effDepth)
                        }
                    }
                    if (src.shearStress !== undefined && src.shearStress !== null) {
                        if (typeof src.shearStress === "number" || src.shearStress === 'NaN' || src.shearStress === 'Infinity' || src.shearStress === '-Infinity') {
                            dst.shearStress = AsNum(src.shearStress);
                        }
                        else {
                            console.log('Expected shearStress of ShearData to be a number but was ', typeof src.shearStress, src.shearStress)
                        }
                    }
                    if (src.shearCapaStress !== undefined && src.shearCapaStress !== null) {
                        if (typeof src.shearCapaStress === "number" || src.shearCapaStress === 'NaN' || src.shearCapaStress === 'Infinity' || src.shearCapaStress === '-Infinity') {
                            dst.shearCapaStress = AsNum(src.shearCapaStress);
                        }
                        else {
                            console.log('Expected shearCapaStress of ShearData to be a number but was ', typeof src.shearCapaStress, src.shearCapaStress)
                        }
                    }
                    if (src.utilizationStress !== undefined && src.utilizationStress !== null) {
                        if (typeof src.utilizationStress === "number" || src.utilizationStress === 'NaN' || src.utilizationStress === 'Infinity' || src.utilizationStress === '-Infinity') {
                            dst.utilizationStress = AsNum(src.utilizationStress);
                        }
                        else {
                            console.log('Expected utilizationStress of ShearData to be a number but was ', typeof src.utilizationStress, src.utilizationStress)
                        }
                    }
                    if (src.shearResistReq !== undefined && src.shearResistReq !== null) {
                        if (typeof src.shearResistReq === "boolean") {
                            dst.shearResistReq = src.shearResistReq;
                        }
                        else {
                            console.log('Expected shearResistReq of ShearData to be a boolean but was ', typeof src.shearResistReq, src.shearResistReq)
                        }
                    }
                    if (src.hasCoreFilling !== undefined && src.hasCoreFilling !== null) {
                        if (typeof src.hasCoreFilling === "boolean") {
                            dst.hasCoreFilling = src.hasCoreFilling;
                        }
                        else {
                            console.log('Expected hasCoreFilling of ShearData to be a boolean but was ', typeof src.hasCoreFilling, src.hasCoreFilling)
                        }
                    }
                    if (src.hasTorsion !== undefined && src.hasTorsion !== null) {
                        if (typeof src.hasTorsion === "boolean") {
                            dst.hasTorsion = src.hasTorsion;
                        }
                        else {
                            console.log('Expected hasTorsion of ShearData to be a boolean but was ', typeof src.hasTorsion, src.hasTorsion)
                        }
                    }
                    if (src.useShearStressCtrl !== undefined && src.useShearStressCtrl !== null) {
                        if (typeof src.useShearStressCtrl === "boolean") {
                            dst.useShearStressCtrl = src.useShearStressCtrl;
                        }
                        else {
                            console.log('Expected useShearStressCtrl of ShearData to be a boolean but was ', typeof src.useShearStressCtrl, src.useShearStressCtrl)
                        }
                    }
                    if (src.useShearCapaWeb !== undefined && src.useShearCapaWeb !== null) {
                        if (typeof src.useShearCapaWeb === "boolean") {
                            dst.useShearCapaWeb = src.useShearCapaWeb;
                        }
                        else {
                            console.log('Expected useShearCapaWeb of ShearData to be a boolean but was ', typeof src.useShearCapaWeb, src.useShearCapaWeb)
                        }
                    }
                    if (src.vrdEqStr !== undefined && src.vrdEqStr !== null) {
                        if (typeof src.vrdEqStr === "string") {
                            dst.vrdEqStr = src.vrdEqStr;
                        }
                        else {
                            console.log('Expected vrdEqStr of ShearData to be a string but was ', typeof src.vrdEqStr, src.vrdEqStr)
                        }
                    }
                    if (src.adjFactorShear !== undefined && src.adjFactorShear !== null) {
                        if (typeof src.adjFactorShear === "number" || src.adjFactorShear === 'NaN' || src.adjFactorShear === 'Infinity' || src.adjFactorShear === '-Infinity') {
                            dst.adjFactorShear = AsNum(src.adjFactorShear);
                        }
                        else {
                            console.log('Expected adjFactorShear of ShearData to be a number but was ', typeof src.adjFactorShear, src.adjFactorShear)
                        }
                    }
                    if (src.hasAdjFactorShear !== undefined && src.hasAdjFactorShear !== null) {
                        if (typeof src.hasAdjFactorShear === "boolean") {
                            dst.hasAdjFactorShear = src.hasAdjFactorShear;
                        }
                        else {
                            console.log('Expected hasAdjFactorShear of ShearData to be a boolean but was ', typeof src.hasAdjFactorShear, src.hasAdjFactorShear)
                        }
                    }
                    if (src.shearFieldStart !== undefined && src.shearFieldStart !== null) {
                        if (typeof src.shearFieldStart === "number" || src.shearFieldStart === 'NaN' || src.shearFieldStart === 'Infinity' || src.shearFieldStart === '-Infinity') {
                            dst.shearFieldStart = AsNum(src.shearFieldStart);
                        }
                        else {
                            console.log('Expected shearFieldStart of ShearData to be a number but was ', typeof src.shearFieldStart, src.shearFieldStart)
                        }
                    }
                    if (src.shearFieldEnd !== undefined && src.shearFieldEnd !== null) {
                        if (typeof src.shearFieldEnd === "number" || src.shearFieldEnd === 'NaN' || src.shearFieldEnd === 'Infinity' || src.shearFieldEnd === '-Infinity') {
                            dst.shearFieldEnd = AsNum(src.shearFieldEnd);
                        }
                        else {
                            console.log('Expected shearFieldEnd of ShearData to be a number but was ', typeof src.shearFieldEnd, src.shearFieldEnd)
                        }
                    }
                    if (src.CRdC !== undefined && src.CRdC !== null) {
                        if (typeof src.CRdC === "number" || src.CRdC === 'NaN' || src.CRdC === 'Infinity' || src.CRdC === '-Infinity') {
                            dst.CRdC = AsNum(src.CRdC);
                        }
                        else {
                            console.log('Expected CRdC of ShearData to be a number but was ', typeof src.CRdC, src.CRdC)
                        }
                    }
                    if (src.k !== undefined && src.k !== null) {
                        if (typeof src.k === "number" || src.k === 'NaN' || src.k === 'Infinity' || src.k === '-Infinity') {
                            dst.k = AsNum(src.k);
                        }
                        else {
                            console.log('Expected k of ShearData to be a number but was ', typeof src.k, src.k)
                        }
                    }
                    if (src.ASl !== undefined && src.ASl !== null) {
                        if (typeof src.ASl === "number" || src.ASl === 'NaN' || src.ASl === 'Infinity' || src.ASl === '-Infinity') {
                            dst.ASl = AsNum(src.ASl);
                        }
                        else {
                            console.log('Expected ASl of ShearData to be a number but was ', typeof src.ASl, src.ASl)
                        }
                    }
                    if (src.rhoL !== undefined && src.rhoL !== null) {
                        if (typeof src.rhoL === "number" || src.rhoL === 'NaN' || src.rhoL === 'Infinity' || src.rhoL === '-Infinity') {
                            dst.rhoL = AsNum(src.rhoL);
                        }
                        else {
                            console.log('Expected rhoL of ShearData to be a number but was ', typeof src.rhoL, src.rhoL)
                        }
                    }
                    if (src.fCk !== undefined && src.fCk !== null) {
                        if (typeof src.fCk === "number" || src.fCk === 'NaN' || src.fCk === 'Infinity' || src.fCk === '-Infinity') {
                            dst.fCk = AsNum(src.fCk);
                        }
                        else {
                            console.log('Expected fCk of ShearData to be a number but was ', typeof src.fCk, src.fCk)
                        }
                    }
                    if (src.k1 !== undefined && src.k1 !== null) {
                        if (typeof src.k1 === "number" || src.k1 === 'NaN' || src.k1 === 'Infinity' || src.k1 === '-Infinity') {
                            dst.k1 = AsNum(src.k1);
                        }
                        else {
                            console.log('Expected k1 of ShearData to be a number but was ', typeof src.k1, src.k1)
                        }
                    }
                    if (src.sigmaCp !== undefined && src.sigmaCp !== null) {
                        if (typeof src.sigmaCp === "number" || src.sigmaCp === 'NaN' || src.sigmaCp === 'Infinity' || src.sigmaCp === '-Infinity') {
                            dst.sigmaCp = AsNum(src.sigmaCp);
                        }
                        else {
                            console.log('Expected sigmaCp of ShearData to be a number but was ', typeof src.sigmaCp, src.sigmaCp)
                        }
                    }
                    if (src.vMin !== undefined && src.vMin !== null) {
                        if (typeof src.vMin === "number" || src.vMin === 'NaN' || src.vMin === 'Infinity' || src.vMin === '-Infinity') {
                            dst.vMin = AsNum(src.vMin);
                        }
                        else {
                            console.log('Expected vMin of ShearData to be a number but was ', typeof src.vMin, src.vMin)
                        }
                    }
                    if (src.I !== undefined && src.I !== null) {
                        if (typeof src.I === "number" || src.I === 'NaN' || src.I === 'Infinity' || src.I === '-Infinity') {
                            dst.I = AsNum(src.I);
                        }
                        else {
                            console.log('Expected I of ShearData to be a number but was ', typeof src.I, src.I)
                        }
                    }
                    if (src.S !== undefined && src.S !== null) {
                        if (typeof src.S === "number" || src.S === 'NaN' || src.S === 'Infinity' || src.S === '-Infinity') {
                            dst.S = AsNum(src.S);
                        }
                        else {
                            console.log('Expected S of ShearData to be a number but was ', typeof src.S, src.S)
                        }
                    }
                    if (src.sigmaCpAlphaL !== undefined && src.sigmaCpAlphaL !== null) {
                        if (typeof src.sigmaCpAlphaL === "number" || src.sigmaCpAlphaL === 'NaN' || src.sigmaCpAlphaL === 'Infinity' || src.sigmaCpAlphaL === '-Infinity') {
                            dst.sigmaCpAlphaL = AsNum(src.sigmaCpAlphaL);
                        }
                        else {
                            console.log('Expected sigmaCpAlphaL of ShearData to be a number but was ', typeof src.sigmaCpAlphaL, src.sigmaCpAlphaL)
                        }
                    }
                    if (src.fCtd !== undefined && src.fCtd !== null) {
                        if (typeof src.fCtd === "number" || src.fCtd === 'NaN' || src.fCtd === 'Infinity' || src.fCtd === '-Infinity') {
                            dst.fCtd = AsNum(src.fCtd);
                        }
                        else {
                            console.log('Expected fCtd of ShearData to be a number but was ', typeof src.fCtd, src.fCtd)
                        }
                    }
                    if (src.v !== undefined && src.v !== null) {
                        if (typeof src.v === "number" || src.v === 'NaN' || src.v === 'Infinity' || src.v === '-Infinity') {
                            dst.v = AsNum(src.v);
                        }
                        else {
                            console.log('Expected v of ShearData to be a number but was ', typeof src.v, src.v)
                        }
                    }
                    if (src.fCd !== undefined && src.fCd !== null) {
                        if (typeof src.fCd === "number" || src.fCd === 'NaN' || src.fCd === 'Infinity' || src.fCd === '-Infinity') {
                            dst.fCd = AsNum(src.fCd);
                        }
                        else {
                            console.log('Expected fCd of ShearData to be a number but was ', typeof src.fCd, src.fCd)
                        }
                    }
                    if (src.closeToSuppFactor !== undefined && src.closeToSuppFactor !== null) {
                        if (typeof src.closeToSuppFactor === "number" || src.closeToSuppFactor === 'NaN' || src.closeToSuppFactor === 'Infinity' || src.closeToSuppFactor === '-Infinity') {
                            dst.closeToSuppFactor = AsNum(src.closeToSuppFactor);
                        }
                        else {
                            console.log('Expected closeToSuppFactor of ShearData to be a number but was ', typeof src.closeToSuppFactor, src.closeToSuppFactor)
                        }
                    }
                    if (src.tauEd !== undefined && src.tauEd !== null) {
                        if (typeof src.tauEd === "number" || src.tauEd === 'NaN' || src.tauEd === 'Infinity' || src.tauEd === '-Infinity') {
                            dst.tauEd = AsNum(src.tauEd);
                        }
                        else {
                            console.log('Expected tauEd of ShearData to be a number but was ', typeof src.tauEd, src.tauEd)
                        }
                    }
                    if (src.tauRdc !== undefined && src.tauRdc !== null) {
                        if (typeof src.tauRdc === "number" || src.tauRdc === 'NaN' || src.tauRdc === 'Infinity' || src.tauRdc === '-Infinity') {
                            dst.tauRdc = AsNum(src.tauRdc);
                        }
                        else {
                            console.log('Expected tauRdc of ShearData to be a number but was ', typeof src.tauRdc, src.tauRdc)
                        }
                    }
                    if (src.tauRdcMin !== undefined && src.tauRdcMin !== null) {
                        if (typeof src.tauRdcMin === "number" || src.tauRdcMin === 'NaN' || src.tauRdcMin === 'Infinity' || src.tauRdcMin === '-Infinity') {
                            dst.tauRdcMin = AsNum(src.tauRdcMin);
                        }
                        else {
                            console.log('Expected tauRdcMin of ShearData to be a number but was ', typeof src.tauRdcMin, src.tauRdcMin)
                        }
                    }
                    if (src.tauRdcMax !== undefined && src.tauRdcMax !== null) {
                        if (typeof src.tauRdcMax === "number" || src.tauRdcMax === 'NaN' || src.tauRdcMax === 'Infinity' || src.tauRdcMax === '-Infinity') {
                            dst.tauRdcMax = AsNum(src.tauRdcMax);
                        }
                        else {
                            console.log('Expected tauRdcMax of ShearData to be a number but was ', typeof src.tauRdcMax, src.tauRdcMax)
                        }
                    }
                    if (src.dDg !== undefined && src.dDg !== null) {
                        if (typeof src.dDg === "number" || src.dDg === 'NaN' || src.dDg === 'Infinity' || src.dDg === '-Infinity') {
                            dst.dDg = AsNum(src.dDg);
                        }
                        else {
                            console.log('Expected dDg of ShearData to be a number but was ', typeof src.dDg, src.dDg)
                        }
                    }
                    if (src.gammaV !== undefined && src.gammaV !== null) {
                        if (typeof src.gammaV === "number" || src.gammaV === 'NaN' || src.gammaV === 'Infinity' || src.gammaV === '-Infinity') {
                            dst.gammaV = AsNum(src.gammaV);
                        }
                        else {
                            console.log('Expected gammaV of ShearData to be a number but was ', typeof src.gammaV, src.gammaV)
                        }
                    }
                    if (src.aCs !== undefined && src.aCs !== null) {
                        if (typeof src.aCs === "number" || src.aCs === 'NaN' || src.aCs === 'Infinity' || src.aCs === '-Infinity') {
                            dst.aCs = AsNum(src.aCs);
                        }
                        else {
                            console.log('Expected aCs of ShearData to be a number but was ', typeof src.aCs, src.aCs)
                        }
                    }
                    if (src.kVp !== undefined && src.kVp !== null) {
                        if (typeof src.kVp === "number" || src.kVp === 'NaN' || src.kVp === 'Infinity' || src.kVp === '-Infinity') {
                            dst.kVp = AsNum(src.kVp);
                        }
                        else {
                            console.log('Expected kVp of ShearData to be a number but was ', typeof src.kVp, src.kVp)
                        }
                    }
                    if (src.NEd !== undefined && src.NEd !== null) {
                        if (typeof src.NEd === "number" || src.NEd === 'NaN' || src.NEd === 'Infinity' || src.NEd === '-Infinity') {
                            dst.NEd = AsNum(src.NEd);
                        }
                        else {
                            console.log('Expected NEd of ShearData to be a number but was ', typeof src.NEd, src.NEd)
                        }
                    }
                    if (src.fCtkGammaC !== undefined && src.fCtkGammaC !== null) {
                        if (typeof src.fCtkGammaC === "number" || src.fCtkGammaC === 'NaN' || src.fCtkGammaC === 'Infinity' || src.fCtkGammaC === '-Infinity') {
                            dst.fCtkGammaC = AsNum(src.fCtkGammaC);
                        }
                        else {
                            console.log('Expected fCtkGammaC of ShearData to be a number but was ', typeof src.fCtkGammaC, src.fCtkGammaC)
                        }
                    }
                    if (src.codeGeneration !== undefined && src.codeGeneration !== null) {
                        if (typeof src.codeGeneration === "number" || src.codeGeneration === 'NaN' || src.codeGeneration === 'Infinity' || src.codeGeneration === '-Infinity') {
                            dst.codeGeneration = NumberToInt("ng.result.concrete.ShearData.code_generation", AsNum(src.codeGeneration));
                        }
                        else {
                            console.log('Expected codeGeneration of ShearData to be a number but was ', typeof src.codeGeneration, src.codeGeneration)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of ShearData to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: ShearData | null | undefined): ShearData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.ShearData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.ShearData") {
                        console.error('Expected ng.result.concrete.ShearData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ShearData_json = {
                        shearForce: AsJsonNum(src.shearForce),
                        shearCapaForce: AsJsonNum(src.shearCapaForce),
                        utilizationForce: AsJsonNum(src.utilizationForce),
                        torque: AsJsonNum(src.torque),
                        shearCapaMax: AsJsonNum(src.shearCapaMax),
                        shearCapaWeb: AsJsonNum(src.shearCapaWeb),
                        shearCapaBend: AsJsonNum(src.shearCapaBend),
                        shearCapaNormalForce: AsJsonNum(src.shearCapaNormalForce),
                        shearCapaSectionDepth: AsJsonNum(src.shearCapaSectionDepth),
                        shearCapaCoreFilling: AsJsonNum(src.shearCapaCoreFilling),
                        shearCapaTorsion: AsJsonNum(src.shearCapaTorsion),
                        webWidth: AsJsonNum(src.webWidth),
                        effDepth: AsJsonNum(src.effDepth),
                        shearStress: AsJsonNum(src.shearStress),
                        shearCapaStress: AsJsonNum(src.shearCapaStress),
                        utilizationStress: AsJsonNum(src.utilizationStress),
                        shearResistReq: src.shearResistReq,
                        hasCoreFilling: src.hasCoreFilling,
                        hasTorsion: src.hasTorsion,
                        useShearStressCtrl: src.useShearStressCtrl,
                        useShearCapaWeb: src.useShearCapaWeb,
                        vrdEqStr: src.vrdEqStr,
                        adjFactorShear: AsJsonNum(src.adjFactorShear),
                        hasAdjFactorShear: src.hasAdjFactorShear,
                        shearFieldStart: AsJsonNum(src.shearFieldStart),
                        shearFieldEnd: AsJsonNum(src.shearFieldEnd),
                        CRdC: AsJsonNum(src.CRdC),
                        k: AsJsonNum(src.k),
                        ASl: AsJsonNum(src.ASl),
                        rhoL: AsJsonNum(src.rhoL),
                        fCk: AsJsonNum(src.fCk),
                        k1: AsJsonNum(src.k1),
                        sigmaCp: AsJsonNum(src.sigmaCp),
                        vMin: AsJsonNum(src.vMin),
                        I: AsJsonNum(src.I),
                        S: AsJsonNum(src.S),
                        sigmaCpAlphaL: AsJsonNum(src.sigmaCpAlphaL),
                        fCtd: AsJsonNum(src.fCtd),
                        v: AsJsonNum(src.v),
                        fCd: AsJsonNum(src.fCd),
                        closeToSuppFactor: AsJsonNum(src.closeToSuppFactor),
                        tauEd: AsJsonNum(src.tauEd),
                        tauRdc: AsJsonNum(src.tauRdc),
                        tauRdcMin: AsJsonNum(src.tauRdcMin),
                        tauRdcMax: AsJsonNum(src.tauRdcMax),
                        dDg: AsJsonNum(src.dDg),
                        gammaV: AsJsonNum(src.gammaV),
                        aCs: AsJsonNum(src.aCs),
                        kVp: AsJsonNum(src.kVp),
                        NEd: AsJsonNum(src.NEd),
                        fCtkGammaC: AsJsonNum(src.fCtkGammaC),
                        codeGeneration: AsJsonNum(NumberToInt("ng.result.concrete.ShearData.code_generation", src.codeGeneration)),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.coord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.coord);
                        if(parsed === null) return null;
                        dst.coord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: ShearData_createType) {
                    const dst = new ShearData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coord !== undefined) {
                        dst.coord = src.coord;
                    }
                    if (src.shearForce !== undefined) {
                        dst.shearForce = src.shearForce;
                    }
                    if (src.shearCapaForce !== undefined) {
                        dst.shearCapaForce = src.shearCapaForce;
                    }
                    if (src.utilizationForce !== undefined) {
                        dst.utilizationForce = src.utilizationForce;
                    }
                    if (src.torque !== undefined) {
                        dst.torque = src.torque;
                    }
                    if (src.shearCapaMax !== undefined) {
                        dst.shearCapaMax = src.shearCapaMax;
                    }
                    if (src.shearCapaWeb !== undefined) {
                        dst.shearCapaWeb = src.shearCapaWeb;
                    }
                    if (src.shearCapaBend !== undefined) {
                        dst.shearCapaBend = src.shearCapaBend;
                    }
                    if (src.shearCapaNormalForce !== undefined) {
                        dst.shearCapaNormalForce = src.shearCapaNormalForce;
                    }
                    if (src.shearCapaSectionDepth !== undefined) {
                        dst.shearCapaSectionDepth = src.shearCapaSectionDepth;
                    }
                    if (src.shearCapaCoreFilling !== undefined) {
                        dst.shearCapaCoreFilling = src.shearCapaCoreFilling;
                    }
                    if (src.shearCapaTorsion !== undefined) {
                        dst.shearCapaTorsion = src.shearCapaTorsion;
                    }
                    if (src.webWidth !== undefined) {
                        dst.webWidth = src.webWidth;
                    }
                    if (src.effDepth !== undefined) {
                        dst.effDepth = src.effDepth;
                    }
                    if (src.shearStress !== undefined) {
                        dst.shearStress = src.shearStress;
                    }
                    if (src.shearCapaStress !== undefined) {
                        dst.shearCapaStress = src.shearCapaStress;
                    }
                    if (src.utilizationStress !== undefined) {
                        dst.utilizationStress = src.utilizationStress;
                    }
                    if (src.shearResistReq !== undefined) {
                        dst.shearResistReq = src.shearResistReq;
                    }
                    if (src.hasCoreFilling !== undefined) {
                        dst.hasCoreFilling = src.hasCoreFilling;
                    }
                    if (src.hasTorsion !== undefined) {
                        dst.hasTorsion = src.hasTorsion;
                    }
                    if (src.useShearStressCtrl !== undefined) {
                        dst.useShearStressCtrl = src.useShearStressCtrl;
                    }
                    if (src.useShearCapaWeb !== undefined) {
                        dst.useShearCapaWeb = src.useShearCapaWeb;
                    }
                    if (src.vrdEqStr !== undefined) {
                        dst.vrdEqStr = src.vrdEqStr;
                    }
                    if (src.adjFactorShear !== undefined) {
                        dst.adjFactorShear = src.adjFactorShear;
                    }
                    if (src.hasAdjFactorShear !== undefined) {
                        dst.hasAdjFactorShear = src.hasAdjFactorShear;
                    }
                    if (src.shearFieldStart !== undefined) {
                        dst.shearFieldStart = src.shearFieldStart;
                    }
                    if (src.shearFieldEnd !== undefined) {
                        dst.shearFieldEnd = src.shearFieldEnd;
                    }
                    if (src.CRdC !== undefined) {
                        dst.CRdC = src.CRdC;
                    }
                    if (src.k !== undefined) {
                        dst.k = src.k;
                    }
                    if (src.ASl !== undefined) {
                        dst.ASl = src.ASl;
                    }
                    if (src.rhoL !== undefined) {
                        dst.rhoL = src.rhoL;
                    }
                    if (src.fCk !== undefined) {
                        dst.fCk = src.fCk;
                    }
                    if (src.k1 !== undefined) {
                        dst.k1 = src.k1;
                    }
                    if (src.sigmaCp !== undefined) {
                        dst.sigmaCp = src.sigmaCp;
                    }
                    if (src.vMin !== undefined) {
                        dst.vMin = src.vMin;
                    }
                    if (src.I !== undefined) {
                        dst.I = src.I;
                    }
                    if (src.S !== undefined) {
                        dst.S = src.S;
                    }
                    if (src.sigmaCpAlphaL !== undefined) {
                        dst.sigmaCpAlphaL = src.sigmaCpAlphaL;
                    }
                    if (src.fCtd !== undefined) {
                        dst.fCtd = src.fCtd;
                    }
                    if (src.v !== undefined) {
                        dst.v = src.v;
                    }
                    if (src.fCd !== undefined) {
                        dst.fCd = src.fCd;
                    }
                    if (src.closeToSuppFactor !== undefined) {
                        dst.closeToSuppFactor = src.closeToSuppFactor;
                    }
                    if (src.tauEd !== undefined) {
                        dst.tauEd = src.tauEd;
                    }
                    if (src.tauRdc !== undefined) {
                        dst.tauRdc = src.tauRdc;
                    }
                    if (src.tauRdcMin !== undefined) {
                        dst.tauRdcMin = src.tauRdcMin;
                    }
                    if (src.tauRdcMax !== undefined) {
                        dst.tauRdcMax = src.tauRdcMax;
                    }
                    if (src.dDg !== undefined) {
                        dst.dDg = src.dDg;
                    }
                    if (src.gammaV !== undefined) {
                        dst.gammaV = src.gammaV;
                    }
                    if (src.aCs !== undefined) {
                        dst.aCs = src.aCs;
                    }
                    if (src.kVp !== undefined) {
                        dst.kVp = src.kVp;
                    }
                    if (src.NEd !== undefined) {
                        dst.NEd = src.NEd;
                    }
                    if (src.fCtkGammaC !== undefined) {
                        dst.fCtkGammaC = src.fCtkGammaC;
                    }
                    if (src.codeGeneration !== undefined) {
                        dst.codeGeneration = src.codeGeneration;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ShearData();
                    dst.coord = this.coord;
                    dst.shearForce = this.shearForce;
                    dst.shearCapaForce = this.shearCapaForce;
                    dst.utilizationForce = this.utilizationForce;
                    dst.torque = this.torque;
                    dst.shearCapaMax = this.shearCapaMax;
                    dst.shearCapaWeb = this.shearCapaWeb;
                    dst.shearCapaBend = this.shearCapaBend;
                    dst.shearCapaNormalForce = this.shearCapaNormalForce;
                    dst.shearCapaSectionDepth = this.shearCapaSectionDepth;
                    dst.shearCapaCoreFilling = this.shearCapaCoreFilling;
                    dst.shearCapaTorsion = this.shearCapaTorsion;
                    dst.webWidth = this.webWidth;
                    dst.effDepth = this.effDepth;
                    dst.shearStress = this.shearStress;
                    dst.shearCapaStress = this.shearCapaStress;
                    dst.utilizationStress = this.utilizationStress;
                    dst.shearResistReq = this.shearResistReq;
                    dst.hasCoreFilling = this.hasCoreFilling;
                    dst.hasTorsion = this.hasTorsion;
                    dst.useShearStressCtrl = this.useShearStressCtrl;
                    dst.useShearCapaWeb = this.useShearCapaWeb;
                    dst.vrdEqStr = this.vrdEqStr;
                    dst.adjFactorShear = this.adjFactorShear;
                    dst.hasAdjFactorShear = this.hasAdjFactorShear;
                    dst.shearFieldStart = this.shearFieldStart;
                    dst.shearFieldEnd = this.shearFieldEnd;
                    dst.CRdC = this.CRdC;
                    dst.k = this.k;
                    dst.ASl = this.ASl;
                    dst.rhoL = this.rhoL;
                    dst.fCk = this.fCk;
                    dst.k1 = this.k1;
                    dst.sigmaCp = this.sigmaCp;
                    dst.vMin = this.vMin;
                    dst.I = this.I;
                    dst.S = this.S;
                    dst.sigmaCpAlphaL = this.sigmaCpAlphaL;
                    dst.fCtd = this.fCtd;
                    dst.v = this.v;
                    dst.fCd = this.fCd;
                    dst.closeToSuppFactor = this.closeToSuppFactor;
                    dst.tauEd = this.tauEd;
                    dst.tauRdc = this.tauRdc;
                    dst.tauRdcMin = this.tauRdcMin;
                    dst.tauRdcMax = this.tauRdcMax;
                    dst.dDg = this.dDg;
                    dst.gammaV = this.gammaV;
                    dst.aCs = this.aCs;
                    dst.kVp = this.kVp;
                    dst.NEd = this.NEd;
                    dst.fCtkGammaC = this.fCtkGammaC;
                    dst.codeGeneration = this.codeGeneration;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = ShearData.toObject(this);
                    const dst = ShearData.fromObject(json);
                    return dst;
                }
            }
            export type IShearData = ShearData;


            export type StirrupData_keys = 'coord' | 'shearForceStirrups' | 'shearForceStirrups2' | 'shearCapaForce' | 'utilizationForce' | 'shearFieldForce' | 'shearFieldForce2' | 'shearCapaStirrups' | 'shearCapaMax' | 'curReinfArea' | 'reqReinfArea' | 'minReqReinfArea' | 'webWidth' | 'intLever' | 'shearResultReq' | 'hasTorsion' | 'vrdEqStr' | 'adjFactorShear' | 'hasAdjFactorShear' | 'shearFieldStart' | 'shearFieldEnd' | 'shearFieldStart2' | 'shearFieldEnd2' | 'ASw' | 'S' | 'fYwd' | 'cotTheta' | 'cotAlpha' | 'sinAlpha' | 'alphaCw' | 'nu1' | 'fCd' | 'tauEd' | 'tauRdSy' | 'tauRdMax' | 'codeGeneration' | 'tauRdC' | 'VEd' | 'controls';
            export interface StirrupData_createType {
                coord?: ng.geometry.Point3D | null,
                shearForceStirrups?: number,
                shearForceStirrups2?: number,
                shearCapaForce?: number,
                utilizationForce?: number,
                shearFieldForce?: number,
                shearFieldForce2?: number,
                shearCapaStirrups?: number,
                shearCapaMax?: number,
                curReinfArea?: number,
                reqReinfArea?: number,
                minReqReinfArea?: number,
                webWidth?: number,
                intLever?: number,
                shearResultReq?: boolean,
                hasTorsion?: boolean,
                vrdEqStr?: string,
                adjFactorShear?: number,
                hasAdjFactorShear?: boolean,
                shearFieldStart?: number,
                shearFieldEnd?: number,
                shearFieldStart2?: number,
                shearFieldEnd2?: number,
                ASw?: number,
                S?: number,
                fYwd?: number,
                cotTheta?: number,
                cotAlpha?: number,
                sinAlpha?: number,
                alphaCw?: number,
                nu1?: number,
                fCd?: number,
                tauEd?: number,
                tauRdSy?: number,
                tauRdMax?: number,
                codeGeneration?: number,
                tauRdC?: number,
                VEd?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface StirrupData_json {
                coord?: ng.geometry.Point3D_json;
                shearForceStirrups?: JsonNumber;
                shearForceStirrups2?: JsonNumber;
                shearCapaForce?: JsonNumber;
                utilizationForce?: JsonNumber;
                shearFieldForce?: JsonNumber;
                shearFieldForce2?: JsonNumber;
                shearCapaStirrups?: JsonNumber;
                shearCapaMax?: JsonNumber;
                curReinfArea?: JsonNumber;
                reqReinfArea?: JsonNumber;
                minReqReinfArea?: JsonNumber;
                webWidth?: JsonNumber;
                intLever?: JsonNumber;
                shearResultReq?: boolean;
                hasTorsion?: boolean;
                vrdEqStr?: string;
                adjFactorShear?: JsonNumber;
                hasAdjFactorShear?: boolean;
                shearFieldStart?: JsonNumber;
                shearFieldEnd?: JsonNumber;
                shearFieldStart2?: JsonNumber;
                shearFieldEnd2?: JsonNumber;
                ASw?: JsonNumber;
                S?: JsonNumber;
                fYwd?: JsonNumber;
                cotTheta?: JsonNumber;
                cotAlpha?: JsonNumber;
                sinAlpha?: JsonNumber;
                alphaCw?: JsonNumber;
                nu1?: JsonNumber;
                fCd?: JsonNumber;
                tauEd?: JsonNumber;
                tauRdSy?: JsonNumber;
                tauRdMax?: JsonNumber;
                codeGeneration?: JsonNumber;
                tauRdC?: JsonNumber;
                VEd?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface StirrupData_json_in {
                __proto_name?: unknown;
                coord?: unknown;
                shearForceStirrups?: unknown;
                shearForceStirrups2?: unknown;
                shearCapaForce?: unknown;
                utilizationForce?: unknown;
                shearFieldForce?: unknown;
                shearFieldForce2?: unknown;
                shearCapaStirrups?: unknown;
                shearCapaMax?: unknown;
                curReinfArea?: unknown;
                reqReinfArea?: unknown;
                minReqReinfArea?: unknown;
                webWidth?: unknown;
                intLever?: unknown;
                shearResultReq?: unknown;
                hasTorsion?: unknown;
                vrdEqStr?: unknown;
                adjFactorShear?: unknown;
                hasAdjFactorShear?: unknown;
                shearFieldStart?: unknown;
                shearFieldEnd?: unknown;
                shearFieldStart2?: unknown;
                shearFieldEnd2?: unknown;
                ASw?: unknown;
                S?: unknown;
                fYwd?: unknown;
                cotTheta?: unknown;
                cotAlpha?: unknown;
                sinAlpha?: unknown;
                alphaCw?: unknown;
                nu1?: unknown;
                fCd?: unknown;
                tauEd?: unknown;
                tauRdSy?: unknown;
                tauRdMax?: unknown;
                codeGeneration?: unknown;
                tauRdC?: unknown;
                VEd?: unknown;
                controls?: unknown;
            }
            export class StirrupData {
                __proto_name = "ng.result.concrete.StirrupData";
                coord: ng.geometry.Point3D | null = null;
                shearForceStirrups: number = 0;
                shearForceStirrups2: number = 0;
                shearCapaForce: number = 0;
                utilizationForce: number = 0;
                shearFieldForce: number = 0;
                shearFieldForce2: number = 0;
                shearCapaStirrups: number = 0;
                shearCapaMax: number = 0;
                curReinfArea: number = 0;
                reqReinfArea: number = 0;
                minReqReinfArea: number = 0;
                webWidth: number = 0;
                intLever: number = 0;
                shearResultReq: boolean = false;
                hasTorsion: boolean = false;
                vrdEqStr: string = "";
                adjFactorShear: number = 0;
                hasAdjFactorShear: boolean = false;
                shearFieldStart: number = 0;
                shearFieldEnd: number = 0;
                shearFieldStart2: number = 0;
                shearFieldEnd2: number = 0;
                ASw: number = 0;
                S: number = 0;
                fYwd: number = 0;
                cotTheta: number = 0;
                cotAlpha: number = 0;
                sinAlpha: number = 0;
                alphaCw: number = 0;
                nu1: number = 0;
                fCd: number = 0;
                tauEd: number = 0;
                tauRdSy: number = 0;
                tauRdMax: number = 0;
                codeGeneration: number = 0;
                tauRdC: number = 0;
                VEd: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): StirrupData {
                    const dst = new StirrupData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StirrupData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StirrupData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StirrupData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coord !== undefined && src.coord !== null) {
                        dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                    }
                    if (src.shearForceStirrups !== undefined && src.shearForceStirrups !== null) {
                        if (typeof src.shearForceStirrups === "number" || src.shearForceStirrups === 'NaN' || src.shearForceStirrups === 'Infinity' || src.shearForceStirrups === '-Infinity') {
                            dst.shearForceStirrups = AsNum(src.shearForceStirrups);
                        }
                        else {
                            console.log('Expected shearForceStirrups of StirrupData to be a number but was ', typeof src.shearForceStirrups, src.shearForceStirrups)
                        }
                    }
                    if (src.shearForceStirrups2 !== undefined && src.shearForceStirrups2 !== null) {
                        if (typeof src.shearForceStirrups2 === "number" || src.shearForceStirrups2 === 'NaN' || src.shearForceStirrups2 === 'Infinity' || src.shearForceStirrups2 === '-Infinity') {
                            dst.shearForceStirrups2 = AsNum(src.shearForceStirrups2);
                        }
                        else {
                            console.log('Expected shearForceStirrups2 of StirrupData to be a number but was ', typeof src.shearForceStirrups2, src.shearForceStirrups2)
                        }
                    }
                    if (src.shearCapaForce !== undefined && src.shearCapaForce !== null) {
                        if (typeof src.shearCapaForce === "number" || src.shearCapaForce === 'NaN' || src.shearCapaForce === 'Infinity' || src.shearCapaForce === '-Infinity') {
                            dst.shearCapaForce = AsNum(src.shearCapaForce);
                        }
                        else {
                            console.log('Expected shearCapaForce of StirrupData to be a number but was ', typeof src.shearCapaForce, src.shearCapaForce)
                        }
                    }
                    if (src.utilizationForce !== undefined && src.utilizationForce !== null) {
                        if (typeof src.utilizationForce === "number" || src.utilizationForce === 'NaN' || src.utilizationForce === 'Infinity' || src.utilizationForce === '-Infinity') {
                            dst.utilizationForce = AsNum(src.utilizationForce);
                        }
                        else {
                            console.log('Expected utilizationForce of StirrupData to be a number but was ', typeof src.utilizationForce, src.utilizationForce)
                        }
                    }
                    if (src.shearFieldForce !== undefined && src.shearFieldForce !== null) {
                        if (typeof src.shearFieldForce === "number" || src.shearFieldForce === 'NaN' || src.shearFieldForce === 'Infinity' || src.shearFieldForce === '-Infinity') {
                            dst.shearFieldForce = AsNum(src.shearFieldForce);
                        }
                        else {
                            console.log('Expected shearFieldForce of StirrupData to be a number but was ', typeof src.shearFieldForce, src.shearFieldForce)
                        }
                    }
                    if (src.shearFieldForce2 !== undefined && src.shearFieldForce2 !== null) {
                        if (typeof src.shearFieldForce2 === "number" || src.shearFieldForce2 === 'NaN' || src.shearFieldForce2 === 'Infinity' || src.shearFieldForce2 === '-Infinity') {
                            dst.shearFieldForce2 = AsNum(src.shearFieldForce2);
                        }
                        else {
                            console.log('Expected shearFieldForce2 of StirrupData to be a number but was ', typeof src.shearFieldForce2, src.shearFieldForce2)
                        }
                    }
                    if (src.shearCapaStirrups !== undefined && src.shearCapaStirrups !== null) {
                        if (typeof src.shearCapaStirrups === "number" || src.shearCapaStirrups === 'NaN' || src.shearCapaStirrups === 'Infinity' || src.shearCapaStirrups === '-Infinity') {
                            dst.shearCapaStirrups = AsNum(src.shearCapaStirrups);
                        }
                        else {
                            console.log('Expected shearCapaStirrups of StirrupData to be a number but was ', typeof src.shearCapaStirrups, src.shearCapaStirrups)
                        }
                    }
                    if (src.shearCapaMax !== undefined && src.shearCapaMax !== null) {
                        if (typeof src.shearCapaMax === "number" || src.shearCapaMax === 'NaN' || src.shearCapaMax === 'Infinity' || src.shearCapaMax === '-Infinity') {
                            dst.shearCapaMax = AsNum(src.shearCapaMax);
                        }
                        else {
                            console.log('Expected shearCapaMax of StirrupData to be a number but was ', typeof src.shearCapaMax, src.shearCapaMax)
                        }
                    }
                    if (src.curReinfArea !== undefined && src.curReinfArea !== null) {
                        if (typeof src.curReinfArea === "number" || src.curReinfArea === 'NaN' || src.curReinfArea === 'Infinity' || src.curReinfArea === '-Infinity') {
                            dst.curReinfArea = AsNum(src.curReinfArea);
                        }
                        else {
                            console.log('Expected curReinfArea of StirrupData to be a number but was ', typeof src.curReinfArea, src.curReinfArea)
                        }
                    }
                    if (src.reqReinfArea !== undefined && src.reqReinfArea !== null) {
                        if (typeof src.reqReinfArea === "number" || src.reqReinfArea === 'NaN' || src.reqReinfArea === 'Infinity' || src.reqReinfArea === '-Infinity') {
                            dst.reqReinfArea = AsNum(src.reqReinfArea);
                        }
                        else {
                            console.log('Expected reqReinfArea of StirrupData to be a number but was ', typeof src.reqReinfArea, src.reqReinfArea)
                        }
                    }
                    if (src.minReqReinfArea !== undefined && src.minReqReinfArea !== null) {
                        if (typeof src.minReqReinfArea === "number" || src.minReqReinfArea === 'NaN' || src.minReqReinfArea === 'Infinity' || src.minReqReinfArea === '-Infinity') {
                            dst.minReqReinfArea = AsNum(src.minReqReinfArea);
                        }
                        else {
                            console.log('Expected minReqReinfArea of StirrupData to be a number but was ', typeof src.minReqReinfArea, src.minReqReinfArea)
                        }
                    }
                    if (src.webWidth !== undefined && src.webWidth !== null) {
                        if (typeof src.webWidth === "number" || src.webWidth === 'NaN' || src.webWidth === 'Infinity' || src.webWidth === '-Infinity') {
                            dst.webWidth = AsNum(src.webWidth);
                        }
                        else {
                            console.log('Expected webWidth of StirrupData to be a number but was ', typeof src.webWidth, src.webWidth)
                        }
                    }
                    if (src.intLever !== undefined && src.intLever !== null) {
                        if (typeof src.intLever === "number" || src.intLever === 'NaN' || src.intLever === 'Infinity' || src.intLever === '-Infinity') {
                            dst.intLever = AsNum(src.intLever);
                        }
                        else {
                            console.log('Expected intLever of StirrupData to be a number but was ', typeof src.intLever, src.intLever)
                        }
                    }
                    if (src.shearResultReq !== undefined && src.shearResultReq !== null) {
                        if (typeof src.shearResultReq === "boolean") {
                            dst.shearResultReq = src.shearResultReq;
                        }
                        else {
                            console.log('Expected shearResultReq of StirrupData to be a boolean but was ', typeof src.shearResultReq, src.shearResultReq)
                        }
                    }
                    if (src.hasTorsion !== undefined && src.hasTorsion !== null) {
                        if (typeof src.hasTorsion === "boolean") {
                            dst.hasTorsion = src.hasTorsion;
                        }
                        else {
                            console.log('Expected hasTorsion of StirrupData to be a boolean but was ', typeof src.hasTorsion, src.hasTorsion)
                        }
                    }
                    if (src.vrdEqStr !== undefined && src.vrdEqStr !== null) {
                        if (typeof src.vrdEqStr === "string") {
                            dst.vrdEqStr = src.vrdEqStr;
                        }
                        else {
                            console.log('Expected vrdEqStr of StirrupData to be a string but was ', typeof src.vrdEqStr, src.vrdEqStr)
                        }
                    }
                    if (src.adjFactorShear !== undefined && src.adjFactorShear !== null) {
                        if (typeof src.adjFactorShear === "number" || src.adjFactorShear === 'NaN' || src.adjFactorShear === 'Infinity' || src.adjFactorShear === '-Infinity') {
                            dst.adjFactorShear = AsNum(src.adjFactorShear);
                        }
                        else {
                            console.log('Expected adjFactorShear of StirrupData to be a number but was ', typeof src.adjFactorShear, src.adjFactorShear)
                        }
                    }
                    if (src.hasAdjFactorShear !== undefined && src.hasAdjFactorShear !== null) {
                        if (typeof src.hasAdjFactorShear === "boolean") {
                            dst.hasAdjFactorShear = src.hasAdjFactorShear;
                        }
                        else {
                            console.log('Expected hasAdjFactorShear of StirrupData to be a boolean but was ', typeof src.hasAdjFactorShear, src.hasAdjFactorShear)
                        }
                    }
                    if (src.shearFieldStart !== undefined && src.shearFieldStart !== null) {
                        if (typeof src.shearFieldStart === "number" || src.shearFieldStart === 'NaN' || src.shearFieldStart === 'Infinity' || src.shearFieldStart === '-Infinity') {
                            dst.shearFieldStart = AsNum(src.shearFieldStart);
                        }
                        else {
                            console.log('Expected shearFieldStart of StirrupData to be a number but was ', typeof src.shearFieldStart, src.shearFieldStart)
                        }
                    }
                    if (src.shearFieldEnd !== undefined && src.shearFieldEnd !== null) {
                        if (typeof src.shearFieldEnd === "number" || src.shearFieldEnd === 'NaN' || src.shearFieldEnd === 'Infinity' || src.shearFieldEnd === '-Infinity') {
                            dst.shearFieldEnd = AsNum(src.shearFieldEnd);
                        }
                        else {
                            console.log('Expected shearFieldEnd of StirrupData to be a number but was ', typeof src.shearFieldEnd, src.shearFieldEnd)
                        }
                    }
                    if (src.shearFieldStart2 !== undefined && src.shearFieldStart2 !== null) {
                        if (typeof src.shearFieldStart2 === "number" || src.shearFieldStart2 === 'NaN' || src.shearFieldStart2 === 'Infinity' || src.shearFieldStart2 === '-Infinity') {
                            dst.shearFieldStart2 = AsNum(src.shearFieldStart2);
                        }
                        else {
                            console.log('Expected shearFieldStart2 of StirrupData to be a number but was ', typeof src.shearFieldStart2, src.shearFieldStart2)
                        }
                    }
                    if (src.shearFieldEnd2 !== undefined && src.shearFieldEnd2 !== null) {
                        if (typeof src.shearFieldEnd2 === "number" || src.shearFieldEnd2 === 'NaN' || src.shearFieldEnd2 === 'Infinity' || src.shearFieldEnd2 === '-Infinity') {
                            dst.shearFieldEnd2 = AsNum(src.shearFieldEnd2);
                        }
                        else {
                            console.log('Expected shearFieldEnd2 of StirrupData to be a number but was ', typeof src.shearFieldEnd2, src.shearFieldEnd2)
                        }
                    }
                    if (src.ASw !== undefined && src.ASw !== null) {
                        if (typeof src.ASw === "number" || src.ASw === 'NaN' || src.ASw === 'Infinity' || src.ASw === '-Infinity') {
                            dst.ASw = AsNum(src.ASw);
                        }
                        else {
                            console.log('Expected ASw of StirrupData to be a number but was ', typeof src.ASw, src.ASw)
                        }
                    }
                    if (src.S !== undefined && src.S !== null) {
                        if (typeof src.S === "number" || src.S === 'NaN' || src.S === 'Infinity' || src.S === '-Infinity') {
                            dst.S = AsNum(src.S);
                        }
                        else {
                            console.log('Expected S of StirrupData to be a number but was ', typeof src.S, src.S)
                        }
                    }
                    if (src.fYwd !== undefined && src.fYwd !== null) {
                        if (typeof src.fYwd === "number" || src.fYwd === 'NaN' || src.fYwd === 'Infinity' || src.fYwd === '-Infinity') {
                            dst.fYwd = AsNum(src.fYwd);
                        }
                        else {
                            console.log('Expected fYwd of StirrupData to be a number but was ', typeof src.fYwd, src.fYwd)
                        }
                    }
                    if (src.cotTheta !== undefined && src.cotTheta !== null) {
                        if (typeof src.cotTheta === "number" || src.cotTheta === 'NaN' || src.cotTheta === 'Infinity' || src.cotTheta === '-Infinity') {
                            dst.cotTheta = AsNum(src.cotTheta);
                        }
                        else {
                            console.log('Expected cotTheta of StirrupData to be a number but was ', typeof src.cotTheta, src.cotTheta)
                        }
                    }
                    if (src.cotAlpha !== undefined && src.cotAlpha !== null) {
                        if (typeof src.cotAlpha === "number" || src.cotAlpha === 'NaN' || src.cotAlpha === 'Infinity' || src.cotAlpha === '-Infinity') {
                            dst.cotAlpha = AsNum(src.cotAlpha);
                        }
                        else {
                            console.log('Expected cotAlpha of StirrupData to be a number but was ', typeof src.cotAlpha, src.cotAlpha)
                        }
                    }
                    if (src.sinAlpha !== undefined && src.sinAlpha !== null) {
                        if (typeof src.sinAlpha === "number" || src.sinAlpha === 'NaN' || src.sinAlpha === 'Infinity' || src.sinAlpha === '-Infinity') {
                            dst.sinAlpha = AsNum(src.sinAlpha);
                        }
                        else {
                            console.log('Expected sinAlpha of StirrupData to be a number but was ', typeof src.sinAlpha, src.sinAlpha)
                        }
                    }
                    if (src.alphaCw !== undefined && src.alphaCw !== null) {
                        if (typeof src.alphaCw === "number" || src.alphaCw === 'NaN' || src.alphaCw === 'Infinity' || src.alphaCw === '-Infinity') {
                            dst.alphaCw = AsNum(src.alphaCw);
                        }
                        else {
                            console.log('Expected alphaCw of StirrupData to be a number but was ', typeof src.alphaCw, src.alphaCw)
                        }
                    }
                    if (src.nu1 !== undefined && src.nu1 !== null) {
                        if (typeof src.nu1 === "number" || src.nu1 === 'NaN' || src.nu1 === 'Infinity' || src.nu1 === '-Infinity') {
                            dst.nu1 = AsNum(src.nu1);
                        }
                        else {
                            console.log('Expected nu1 of StirrupData to be a number but was ', typeof src.nu1, src.nu1)
                        }
                    }
                    if (src.fCd !== undefined && src.fCd !== null) {
                        if (typeof src.fCd === "number" || src.fCd === 'NaN' || src.fCd === 'Infinity' || src.fCd === '-Infinity') {
                            dst.fCd = AsNum(src.fCd);
                        }
                        else {
                            console.log('Expected fCd of StirrupData to be a number but was ', typeof src.fCd, src.fCd)
                        }
                    }
                    if (src.tauEd !== undefined && src.tauEd !== null) {
                        if (typeof src.tauEd === "number" || src.tauEd === 'NaN' || src.tauEd === 'Infinity' || src.tauEd === '-Infinity') {
                            dst.tauEd = AsNum(src.tauEd);
                        }
                        else {
                            console.log('Expected tauEd of StirrupData to be a number but was ', typeof src.tauEd, src.tauEd)
                        }
                    }
                    if (src.tauRdSy !== undefined && src.tauRdSy !== null) {
                        if (typeof src.tauRdSy === "number" || src.tauRdSy === 'NaN' || src.tauRdSy === 'Infinity' || src.tauRdSy === '-Infinity') {
                            dst.tauRdSy = AsNum(src.tauRdSy);
                        }
                        else {
                            console.log('Expected tauRdSy of StirrupData to be a number but was ', typeof src.tauRdSy, src.tauRdSy)
                        }
                    }
                    if (src.tauRdMax !== undefined && src.tauRdMax !== null) {
                        if (typeof src.tauRdMax === "number" || src.tauRdMax === 'NaN' || src.tauRdMax === 'Infinity' || src.tauRdMax === '-Infinity') {
                            dst.tauRdMax = AsNum(src.tauRdMax);
                        }
                        else {
                            console.log('Expected tauRdMax of StirrupData to be a number but was ', typeof src.tauRdMax, src.tauRdMax)
                        }
                    }
                    if (src.codeGeneration !== undefined && src.codeGeneration !== null) {
                        if (typeof src.codeGeneration === "number" || src.codeGeneration === 'NaN' || src.codeGeneration === 'Infinity' || src.codeGeneration === '-Infinity') {
                            dst.codeGeneration = NumberToInt("ng.result.concrete.StirrupData.code_generation", AsNum(src.codeGeneration));
                        }
                        else {
                            console.log('Expected codeGeneration of StirrupData to be a number but was ', typeof src.codeGeneration, src.codeGeneration)
                        }
                    }
                    if (src.tauRdC !== undefined && src.tauRdC !== null) {
                        if (typeof src.tauRdC === "number" || src.tauRdC === 'NaN' || src.tauRdC === 'Infinity' || src.tauRdC === '-Infinity') {
                            dst.tauRdC = AsNum(src.tauRdC);
                        }
                        else {
                            console.log('Expected tauRdC of StirrupData to be a number but was ', typeof src.tauRdC, src.tauRdC)
                        }
                    }
                    if (src.VEd !== undefined && src.VEd !== null) {
                        if (typeof src.VEd === "number" || src.VEd === 'NaN' || src.VEd === 'Infinity' || src.VEd === '-Infinity') {
                            dst.VEd = AsNum(src.VEd);
                        }
                        else {
                            console.log('Expected VEd of StirrupData to be a number but was ', typeof src.VEd, src.VEd)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of StirrupData to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: StirrupData | null | undefined): StirrupData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.StirrupData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.StirrupData") {
                        console.error('Expected ng.result.concrete.StirrupData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : StirrupData_json = {
                        shearForceStirrups: AsJsonNum(src.shearForceStirrups),
                        shearForceStirrups2: AsJsonNum(src.shearForceStirrups2),
                        shearCapaForce: AsJsonNum(src.shearCapaForce),
                        utilizationForce: AsJsonNum(src.utilizationForce),
                        shearFieldForce: AsJsonNum(src.shearFieldForce),
                        shearFieldForce2: AsJsonNum(src.shearFieldForce2),
                        shearCapaStirrups: AsJsonNum(src.shearCapaStirrups),
                        shearCapaMax: AsJsonNum(src.shearCapaMax),
                        curReinfArea: AsJsonNum(src.curReinfArea),
                        reqReinfArea: AsJsonNum(src.reqReinfArea),
                        minReqReinfArea: AsJsonNum(src.minReqReinfArea),
                        webWidth: AsJsonNum(src.webWidth),
                        intLever: AsJsonNum(src.intLever),
                        shearResultReq: src.shearResultReq,
                        hasTorsion: src.hasTorsion,
                        vrdEqStr: src.vrdEqStr,
                        adjFactorShear: AsJsonNum(src.adjFactorShear),
                        hasAdjFactorShear: src.hasAdjFactorShear,
                        shearFieldStart: AsJsonNum(src.shearFieldStart),
                        shearFieldEnd: AsJsonNum(src.shearFieldEnd),
                        shearFieldStart2: AsJsonNum(src.shearFieldStart2),
                        shearFieldEnd2: AsJsonNum(src.shearFieldEnd2),
                        ASw: AsJsonNum(src.ASw),
                        S: AsJsonNum(src.S),
                        fYwd: AsJsonNum(src.fYwd),
                        cotTheta: AsJsonNum(src.cotTheta),
                        cotAlpha: AsJsonNum(src.cotAlpha),
                        sinAlpha: AsJsonNum(src.sinAlpha),
                        alphaCw: AsJsonNum(src.alphaCw),
                        nu1: AsJsonNum(src.nu1),
                        fCd: AsJsonNum(src.fCd),
                        tauEd: AsJsonNum(src.tauEd),
                        tauRdSy: AsJsonNum(src.tauRdSy),
                        tauRdMax: AsJsonNum(src.tauRdMax),
                        codeGeneration: AsJsonNum(NumberToInt("ng.result.concrete.StirrupData.code_generation", src.codeGeneration)),
                        tauRdC: AsJsonNum(src.tauRdC),
                        VEd: AsJsonNum(src.VEd),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.coord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.coord);
                        if(parsed === null) return null;
                        dst.coord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: StirrupData_createType) {
                    const dst = new StirrupData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coord !== undefined) {
                        dst.coord = src.coord;
                    }
                    if (src.shearForceStirrups !== undefined) {
                        dst.shearForceStirrups = src.shearForceStirrups;
                    }
                    if (src.shearForceStirrups2 !== undefined) {
                        dst.shearForceStirrups2 = src.shearForceStirrups2;
                    }
                    if (src.shearCapaForce !== undefined) {
                        dst.shearCapaForce = src.shearCapaForce;
                    }
                    if (src.utilizationForce !== undefined) {
                        dst.utilizationForce = src.utilizationForce;
                    }
                    if (src.shearFieldForce !== undefined) {
                        dst.shearFieldForce = src.shearFieldForce;
                    }
                    if (src.shearFieldForce2 !== undefined) {
                        dst.shearFieldForce2 = src.shearFieldForce2;
                    }
                    if (src.shearCapaStirrups !== undefined) {
                        dst.shearCapaStirrups = src.shearCapaStirrups;
                    }
                    if (src.shearCapaMax !== undefined) {
                        dst.shearCapaMax = src.shearCapaMax;
                    }
                    if (src.curReinfArea !== undefined) {
                        dst.curReinfArea = src.curReinfArea;
                    }
                    if (src.reqReinfArea !== undefined) {
                        dst.reqReinfArea = src.reqReinfArea;
                    }
                    if (src.minReqReinfArea !== undefined) {
                        dst.minReqReinfArea = src.minReqReinfArea;
                    }
                    if (src.webWidth !== undefined) {
                        dst.webWidth = src.webWidth;
                    }
                    if (src.intLever !== undefined) {
                        dst.intLever = src.intLever;
                    }
                    if (src.shearResultReq !== undefined) {
                        dst.shearResultReq = src.shearResultReq;
                    }
                    if (src.hasTorsion !== undefined) {
                        dst.hasTorsion = src.hasTorsion;
                    }
                    if (src.vrdEqStr !== undefined) {
                        dst.vrdEqStr = src.vrdEqStr;
                    }
                    if (src.adjFactorShear !== undefined) {
                        dst.adjFactorShear = src.adjFactorShear;
                    }
                    if (src.hasAdjFactorShear !== undefined) {
                        dst.hasAdjFactorShear = src.hasAdjFactorShear;
                    }
                    if (src.shearFieldStart !== undefined) {
                        dst.shearFieldStart = src.shearFieldStart;
                    }
                    if (src.shearFieldEnd !== undefined) {
                        dst.shearFieldEnd = src.shearFieldEnd;
                    }
                    if (src.shearFieldStart2 !== undefined) {
                        dst.shearFieldStart2 = src.shearFieldStart2;
                    }
                    if (src.shearFieldEnd2 !== undefined) {
                        dst.shearFieldEnd2 = src.shearFieldEnd2;
                    }
                    if (src.ASw !== undefined) {
                        dst.ASw = src.ASw;
                    }
                    if (src.S !== undefined) {
                        dst.S = src.S;
                    }
                    if (src.fYwd !== undefined) {
                        dst.fYwd = src.fYwd;
                    }
                    if (src.cotTheta !== undefined) {
                        dst.cotTheta = src.cotTheta;
                    }
                    if (src.cotAlpha !== undefined) {
                        dst.cotAlpha = src.cotAlpha;
                    }
                    if (src.sinAlpha !== undefined) {
                        dst.sinAlpha = src.sinAlpha;
                    }
                    if (src.alphaCw !== undefined) {
                        dst.alphaCw = src.alphaCw;
                    }
                    if (src.nu1 !== undefined) {
                        dst.nu1 = src.nu1;
                    }
                    if (src.fCd !== undefined) {
                        dst.fCd = src.fCd;
                    }
                    if (src.tauEd !== undefined) {
                        dst.tauEd = src.tauEd;
                    }
                    if (src.tauRdSy !== undefined) {
                        dst.tauRdSy = src.tauRdSy;
                    }
                    if (src.tauRdMax !== undefined) {
                        dst.tauRdMax = src.tauRdMax;
                    }
                    if (src.codeGeneration !== undefined) {
                        dst.codeGeneration = src.codeGeneration;
                    }
                    if (src.tauRdC !== undefined) {
                        dst.tauRdC = src.tauRdC;
                    }
                    if (src.VEd !== undefined) {
                        dst.VEd = src.VEd;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StirrupData();
                    dst.coord = this.coord;
                    dst.shearForceStirrups = this.shearForceStirrups;
                    dst.shearForceStirrups2 = this.shearForceStirrups2;
                    dst.shearCapaForce = this.shearCapaForce;
                    dst.utilizationForce = this.utilizationForce;
                    dst.shearFieldForce = this.shearFieldForce;
                    dst.shearFieldForce2 = this.shearFieldForce2;
                    dst.shearCapaStirrups = this.shearCapaStirrups;
                    dst.shearCapaMax = this.shearCapaMax;
                    dst.curReinfArea = this.curReinfArea;
                    dst.reqReinfArea = this.reqReinfArea;
                    dst.minReqReinfArea = this.minReqReinfArea;
                    dst.webWidth = this.webWidth;
                    dst.intLever = this.intLever;
                    dst.shearResultReq = this.shearResultReq;
                    dst.hasTorsion = this.hasTorsion;
                    dst.vrdEqStr = this.vrdEqStr;
                    dst.adjFactorShear = this.adjFactorShear;
                    dst.hasAdjFactorShear = this.hasAdjFactorShear;
                    dst.shearFieldStart = this.shearFieldStart;
                    dst.shearFieldEnd = this.shearFieldEnd;
                    dst.shearFieldStart2 = this.shearFieldStart2;
                    dst.shearFieldEnd2 = this.shearFieldEnd2;
                    dst.ASw = this.ASw;
                    dst.S = this.S;
                    dst.fYwd = this.fYwd;
                    dst.cotTheta = this.cotTheta;
                    dst.cotAlpha = this.cotAlpha;
                    dst.sinAlpha = this.sinAlpha;
                    dst.alphaCw = this.alphaCw;
                    dst.nu1 = this.nu1;
                    dst.fCd = this.fCd;
                    dst.tauEd = this.tauEd;
                    dst.tauRdSy = this.tauRdSy;
                    dst.tauRdMax = this.tauRdMax;
                    dst.codeGeneration = this.codeGeneration;
                    dst.tauRdC = this.tauRdC;
                    dst.VEd = this.VEd;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = StirrupData.toObject(this);
                    const dst = StirrupData.fromObject(json);
                    return dst;
                }
            }
            export type IStirrupData = StirrupData;


            export type TorsionData_keys = 'coord' | 'torque' | 'torqueCapa' | 'utilization' | 'shearForce' | 'shearFieldForce' | 'shearCapaStirrups' | 'utilizationShearForce' | 'reqReinfAreaShear' | 'curReinfArea' | 'reqReinfAreaTorsion' | 'enclosedArea' | 'enclosedPerimeter' | 'shearRatio' | 'controls';
            export interface TorsionData_createType {
                coord?: ng.geometry.Point3D | null,
                torque?: number,
                torqueCapa?: number,
                utilization?: number,
                shearForce?: number,
                shearFieldForce?: number,
                shearCapaStirrups?: number,
                utilizationShearForce?: number,
                reqReinfAreaShear?: number,
                curReinfArea?: number,
                reqReinfAreaTorsion?: number,
                enclosedArea?: number,
                enclosedPerimeter?: number,
                shearRatio?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface TorsionData_json {
                coord?: ng.geometry.Point3D_json;
                torque?: JsonNumber;
                torqueCapa?: JsonNumber;
                utilization?: JsonNumber;
                shearForce?: JsonNumber;
                shearFieldForce?: JsonNumber;
                shearCapaStirrups?: JsonNumber;
                utilizationShearForce?: JsonNumber;
                reqReinfAreaShear?: JsonNumber;
                curReinfArea?: JsonNumber;
                reqReinfAreaTorsion?: JsonNumber;
                enclosedArea?: JsonNumber;
                enclosedPerimeter?: JsonNumber;
                shearRatio?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface TorsionData_json_in {
                __proto_name?: unknown;
                coord?: unknown;
                torque?: unknown;
                torqueCapa?: unknown;
                utilization?: unknown;
                shearForce?: unknown;
                shearFieldForce?: unknown;
                shearCapaStirrups?: unknown;
                utilizationShearForce?: unknown;
                reqReinfAreaShear?: unknown;
                curReinfArea?: unknown;
                reqReinfAreaTorsion?: unknown;
                enclosedArea?: unknown;
                enclosedPerimeter?: unknown;
                shearRatio?: unknown;
                controls?: unknown;
            }
            export class TorsionData {
                __proto_name = "ng.result.concrete.TorsionData";
                coord: ng.geometry.Point3D | null = null;
                torque: number = 0;
                torqueCapa: number = 0;
                utilization: number = 0;
                shearForce: number = 0;
                shearFieldForce: number = 0;
                shearCapaStirrups: number = 0;
                utilizationShearForce: number = 0;
                reqReinfAreaShear: number = 0;
                curReinfArea: number = 0;
                reqReinfAreaTorsion: number = 0;
                enclosedArea: number = 0;
                enclosedPerimeter: number = 0;
                shearRatio: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): TorsionData {
                    const dst = new TorsionData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TorsionData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TorsionData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TorsionData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coord !== undefined && src.coord !== null) {
                        dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                    }
                    if (src.torque !== undefined && src.torque !== null) {
                        if (typeof src.torque === "number" || src.torque === 'NaN' || src.torque === 'Infinity' || src.torque === '-Infinity') {
                            dst.torque = AsNum(src.torque);
                        }
                        else {
                            console.log('Expected torque of TorsionData to be a number but was ', typeof src.torque, src.torque)
                        }
                    }
                    if (src.torqueCapa !== undefined && src.torqueCapa !== null) {
                        if (typeof src.torqueCapa === "number" || src.torqueCapa === 'NaN' || src.torqueCapa === 'Infinity' || src.torqueCapa === '-Infinity') {
                            dst.torqueCapa = AsNum(src.torqueCapa);
                        }
                        else {
                            console.log('Expected torqueCapa of TorsionData to be a number but was ', typeof src.torqueCapa, src.torqueCapa)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of TorsionData to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.shearForce !== undefined && src.shearForce !== null) {
                        if (typeof src.shearForce === "number" || src.shearForce === 'NaN' || src.shearForce === 'Infinity' || src.shearForce === '-Infinity') {
                            dst.shearForce = AsNum(src.shearForce);
                        }
                        else {
                            console.log('Expected shearForce of TorsionData to be a number but was ', typeof src.shearForce, src.shearForce)
                        }
                    }
                    if (src.shearFieldForce !== undefined && src.shearFieldForce !== null) {
                        if (typeof src.shearFieldForce === "number" || src.shearFieldForce === 'NaN' || src.shearFieldForce === 'Infinity' || src.shearFieldForce === '-Infinity') {
                            dst.shearFieldForce = AsNum(src.shearFieldForce);
                        }
                        else {
                            console.log('Expected shearFieldForce of TorsionData to be a number but was ', typeof src.shearFieldForce, src.shearFieldForce)
                        }
                    }
                    if (src.shearCapaStirrups !== undefined && src.shearCapaStirrups !== null) {
                        if (typeof src.shearCapaStirrups === "number" || src.shearCapaStirrups === 'NaN' || src.shearCapaStirrups === 'Infinity' || src.shearCapaStirrups === '-Infinity') {
                            dst.shearCapaStirrups = AsNum(src.shearCapaStirrups);
                        }
                        else {
                            console.log('Expected shearCapaStirrups of TorsionData to be a number but was ', typeof src.shearCapaStirrups, src.shearCapaStirrups)
                        }
                    }
                    if (src.utilizationShearForce !== undefined && src.utilizationShearForce !== null) {
                        if (typeof src.utilizationShearForce === "number" || src.utilizationShearForce === 'NaN' || src.utilizationShearForce === 'Infinity' || src.utilizationShearForce === '-Infinity') {
                            dst.utilizationShearForce = AsNum(src.utilizationShearForce);
                        }
                        else {
                            console.log('Expected utilizationShearForce of TorsionData to be a number but was ', typeof src.utilizationShearForce, src.utilizationShearForce)
                        }
                    }
                    if (src.reqReinfAreaShear !== undefined && src.reqReinfAreaShear !== null) {
                        if (typeof src.reqReinfAreaShear === "number" || src.reqReinfAreaShear === 'NaN' || src.reqReinfAreaShear === 'Infinity' || src.reqReinfAreaShear === '-Infinity') {
                            dst.reqReinfAreaShear = AsNum(src.reqReinfAreaShear);
                        }
                        else {
                            console.log('Expected reqReinfAreaShear of TorsionData to be a number but was ', typeof src.reqReinfAreaShear, src.reqReinfAreaShear)
                        }
                    }
                    if (src.curReinfArea !== undefined && src.curReinfArea !== null) {
                        if (typeof src.curReinfArea === "number" || src.curReinfArea === 'NaN' || src.curReinfArea === 'Infinity' || src.curReinfArea === '-Infinity') {
                            dst.curReinfArea = AsNum(src.curReinfArea);
                        }
                        else {
                            console.log('Expected curReinfArea of TorsionData to be a number but was ', typeof src.curReinfArea, src.curReinfArea)
                        }
                    }
                    if (src.reqReinfAreaTorsion !== undefined && src.reqReinfAreaTorsion !== null) {
                        if (typeof src.reqReinfAreaTorsion === "number" || src.reqReinfAreaTorsion === 'NaN' || src.reqReinfAreaTorsion === 'Infinity' || src.reqReinfAreaTorsion === '-Infinity') {
                            dst.reqReinfAreaTorsion = AsNum(src.reqReinfAreaTorsion);
                        }
                        else {
                            console.log('Expected reqReinfAreaTorsion of TorsionData to be a number but was ', typeof src.reqReinfAreaTorsion, src.reqReinfAreaTorsion)
                        }
                    }
                    if (src.enclosedArea !== undefined && src.enclosedArea !== null) {
                        if (typeof src.enclosedArea === "number" || src.enclosedArea === 'NaN' || src.enclosedArea === 'Infinity' || src.enclosedArea === '-Infinity') {
                            dst.enclosedArea = AsNum(src.enclosedArea);
                        }
                        else {
                            console.log('Expected enclosedArea of TorsionData to be a number but was ', typeof src.enclosedArea, src.enclosedArea)
                        }
                    }
                    if (src.enclosedPerimeter !== undefined && src.enclosedPerimeter !== null) {
                        if (typeof src.enclosedPerimeter === "number" || src.enclosedPerimeter === 'NaN' || src.enclosedPerimeter === 'Infinity' || src.enclosedPerimeter === '-Infinity') {
                            dst.enclosedPerimeter = AsNum(src.enclosedPerimeter);
                        }
                        else {
                            console.log('Expected enclosedPerimeter of TorsionData to be a number but was ', typeof src.enclosedPerimeter, src.enclosedPerimeter)
                        }
                    }
                    if (src.shearRatio !== undefined && src.shearRatio !== null) {
                        if (typeof src.shearRatio === "number" || src.shearRatio === 'NaN' || src.shearRatio === 'Infinity' || src.shearRatio === '-Infinity') {
                            dst.shearRatio = AsNum(src.shearRatio);
                        }
                        else {
                            console.log('Expected shearRatio of TorsionData to be a number but was ', typeof src.shearRatio, src.shearRatio)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of TorsionData to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: TorsionData | null | undefined): TorsionData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.TorsionData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.TorsionData") {
                        console.error('Expected ng.result.concrete.TorsionData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : TorsionData_json = {
                        torque: AsJsonNum(src.torque),
                        torqueCapa: AsJsonNum(src.torqueCapa),
                        utilization: AsJsonNum(src.utilization),
                        shearForce: AsJsonNum(src.shearForce),
                        shearFieldForce: AsJsonNum(src.shearFieldForce),
                        shearCapaStirrups: AsJsonNum(src.shearCapaStirrups),
                        utilizationShearForce: AsJsonNum(src.utilizationShearForce),
                        reqReinfAreaShear: AsJsonNum(src.reqReinfAreaShear),
                        curReinfArea: AsJsonNum(src.curReinfArea),
                        reqReinfAreaTorsion: AsJsonNum(src.reqReinfAreaTorsion),
                        enclosedArea: AsJsonNum(src.enclosedArea),
                        enclosedPerimeter: AsJsonNum(src.enclosedPerimeter),
                        shearRatio: AsJsonNum(src.shearRatio),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.coord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.coord);
                        if(parsed === null) return null;
                        dst.coord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: TorsionData_createType) {
                    const dst = new TorsionData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coord !== undefined) {
                        dst.coord = src.coord;
                    }
                    if (src.torque !== undefined) {
                        dst.torque = src.torque;
                    }
                    if (src.torqueCapa !== undefined) {
                        dst.torqueCapa = src.torqueCapa;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.shearForce !== undefined) {
                        dst.shearForce = src.shearForce;
                    }
                    if (src.shearFieldForce !== undefined) {
                        dst.shearFieldForce = src.shearFieldForce;
                    }
                    if (src.shearCapaStirrups !== undefined) {
                        dst.shearCapaStirrups = src.shearCapaStirrups;
                    }
                    if (src.utilizationShearForce !== undefined) {
                        dst.utilizationShearForce = src.utilizationShearForce;
                    }
                    if (src.reqReinfAreaShear !== undefined) {
                        dst.reqReinfAreaShear = src.reqReinfAreaShear;
                    }
                    if (src.curReinfArea !== undefined) {
                        dst.curReinfArea = src.curReinfArea;
                    }
                    if (src.reqReinfAreaTorsion !== undefined) {
                        dst.reqReinfAreaTorsion = src.reqReinfAreaTorsion;
                    }
                    if (src.enclosedArea !== undefined) {
                        dst.enclosedArea = src.enclosedArea;
                    }
                    if (src.enclosedPerimeter !== undefined) {
                        dst.enclosedPerimeter = src.enclosedPerimeter;
                    }
                    if (src.shearRatio !== undefined) {
                        dst.shearRatio = src.shearRatio;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TorsionData();
                    dst.coord = this.coord;
                    dst.torque = this.torque;
                    dst.torqueCapa = this.torqueCapa;
                    dst.utilization = this.utilization;
                    dst.shearForce = this.shearForce;
                    dst.shearFieldForce = this.shearFieldForce;
                    dst.shearCapaStirrups = this.shearCapaStirrups;
                    dst.utilizationShearForce = this.utilizationShearForce;
                    dst.reqReinfAreaShear = this.reqReinfAreaShear;
                    dst.curReinfArea = this.curReinfArea;
                    dst.reqReinfAreaTorsion = this.reqReinfAreaTorsion;
                    dst.enclosedArea = this.enclosedArea;
                    dst.enclosedPerimeter = this.enclosedPerimeter;
                    dst.shearRatio = this.shearRatio;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = TorsionData.toObject(this);
                    const dst = TorsionData.fromObject(json);
                    return dst;
                }
            }
            export type ITorsionData = TorsionData;


            export type ToppingData_keys = 'coord' | 'shearForce' | 'jointForce' | 'jointStress' | 'jointWidth' | 'jointCapaForce' | 'curShearReinfArea' | 'reqShearReinfArea' | 'controls';
            export interface ToppingData_createType {
                coord?: ng.geometry.Point3D | null,
                shearForce?: number,
                jointForce?: number,
                jointStress?: number,
                jointWidth?: number,
                jointCapaForce?: number,
                curShearReinfArea?: number,
                reqShearReinfArea?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface ToppingData_json {
                coord?: ng.geometry.Point3D_json;
                shearForce?: JsonNumber;
                jointForce?: JsonNumber;
                jointStress?: JsonNumber;
                jointWidth?: JsonNumber;
                jointCapaForce?: JsonNumber;
                curShearReinfArea?: JsonNumber;
                reqShearReinfArea?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface ToppingData_json_in {
                __proto_name?: unknown;
                coord?: unknown;
                shearForce?: unknown;
                jointForce?: unknown;
                jointStress?: unknown;
                jointWidth?: unknown;
                jointCapaForce?: unknown;
                curShearReinfArea?: unknown;
                reqShearReinfArea?: unknown;
                controls?: unknown;
            }
            export class ToppingData {
                __proto_name = "ng.result.concrete.ToppingData";
                coord: ng.geometry.Point3D | null = null;
                shearForce: number = 0;
                jointForce: number = 0;
                jointStress: number = 0;
                jointWidth: number = 0;
                jointCapaForce: number = 0;
                curShearReinfArea: number = 0;
                reqShearReinfArea: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): ToppingData {
                    const dst = new ToppingData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ToppingData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ToppingData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ToppingData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coord !== undefined && src.coord !== null) {
                        dst.coord = ng.geometry.Point3D.fromObject(src.coord);
                    }
                    if (src.shearForce !== undefined && src.shearForce !== null) {
                        if (typeof src.shearForce === "number" || src.shearForce === 'NaN' || src.shearForce === 'Infinity' || src.shearForce === '-Infinity') {
                            dst.shearForce = AsNum(src.shearForce);
                        }
                        else {
                            console.log('Expected shearForce of ToppingData to be a number but was ', typeof src.shearForce, src.shearForce)
                        }
                    }
                    if (src.jointForce !== undefined && src.jointForce !== null) {
                        if (typeof src.jointForce === "number" || src.jointForce === 'NaN' || src.jointForce === 'Infinity' || src.jointForce === '-Infinity') {
                            dst.jointForce = AsNum(src.jointForce);
                        }
                        else {
                            console.log('Expected jointForce of ToppingData to be a number but was ', typeof src.jointForce, src.jointForce)
                        }
                    }
                    if (src.jointStress !== undefined && src.jointStress !== null) {
                        if (typeof src.jointStress === "number" || src.jointStress === 'NaN' || src.jointStress === 'Infinity' || src.jointStress === '-Infinity') {
                            dst.jointStress = AsNum(src.jointStress);
                        }
                        else {
                            console.log('Expected jointStress of ToppingData to be a number but was ', typeof src.jointStress, src.jointStress)
                        }
                    }
                    if (src.jointWidth !== undefined && src.jointWidth !== null) {
                        if (typeof src.jointWidth === "number" || src.jointWidth === 'NaN' || src.jointWidth === 'Infinity' || src.jointWidth === '-Infinity') {
                            dst.jointWidth = AsNum(src.jointWidth);
                        }
                        else {
                            console.log('Expected jointWidth of ToppingData to be a number but was ', typeof src.jointWidth, src.jointWidth)
                        }
                    }
                    if (src.jointCapaForce !== undefined && src.jointCapaForce !== null) {
                        if (typeof src.jointCapaForce === "number" || src.jointCapaForce === 'NaN' || src.jointCapaForce === 'Infinity' || src.jointCapaForce === '-Infinity') {
                            dst.jointCapaForce = AsNum(src.jointCapaForce);
                        }
                        else {
                            console.log('Expected jointCapaForce of ToppingData to be a number but was ', typeof src.jointCapaForce, src.jointCapaForce)
                        }
                    }
                    if (src.curShearReinfArea !== undefined && src.curShearReinfArea !== null) {
                        if (typeof src.curShearReinfArea === "number" || src.curShearReinfArea === 'NaN' || src.curShearReinfArea === 'Infinity' || src.curShearReinfArea === '-Infinity') {
                            dst.curShearReinfArea = AsNum(src.curShearReinfArea);
                        }
                        else {
                            console.log('Expected curShearReinfArea of ToppingData to be a number but was ', typeof src.curShearReinfArea, src.curShearReinfArea)
                        }
                    }
                    if (src.reqShearReinfArea !== undefined && src.reqShearReinfArea !== null) {
                        if (typeof src.reqShearReinfArea === "number" || src.reqShearReinfArea === 'NaN' || src.reqShearReinfArea === 'Infinity' || src.reqShearReinfArea === '-Infinity') {
                            dst.reqShearReinfArea = AsNum(src.reqShearReinfArea);
                        }
                        else {
                            console.log('Expected reqShearReinfArea of ToppingData to be a number but was ', typeof src.reqShearReinfArea, src.reqShearReinfArea)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of ToppingData to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: ToppingData | null | undefined): ToppingData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.ToppingData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.ToppingData") {
                        console.error('Expected ng.result.concrete.ToppingData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ToppingData_json = {
                        shearForce: AsJsonNum(src.shearForce),
                        jointForce: AsJsonNum(src.jointForce),
                        jointStress: AsJsonNum(src.jointStress),
                        jointWidth: AsJsonNum(src.jointWidth),
                        jointCapaForce: AsJsonNum(src.jointCapaForce),
                        curShearReinfArea: AsJsonNum(src.curShearReinfArea),
                        reqShearReinfArea: AsJsonNum(src.reqShearReinfArea),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.coord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.coord);
                        if(parsed === null) return null;
                        dst.coord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: ToppingData_createType) {
                    const dst = new ToppingData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coord !== undefined) {
                        dst.coord = src.coord;
                    }
                    if (src.shearForce !== undefined) {
                        dst.shearForce = src.shearForce;
                    }
                    if (src.jointForce !== undefined) {
                        dst.jointForce = src.jointForce;
                    }
                    if (src.jointStress !== undefined) {
                        dst.jointStress = src.jointStress;
                    }
                    if (src.jointWidth !== undefined) {
                        dst.jointWidth = src.jointWidth;
                    }
                    if (src.jointCapaForce !== undefined) {
                        dst.jointCapaForce = src.jointCapaForce;
                    }
                    if (src.curShearReinfArea !== undefined) {
                        dst.curShearReinfArea = src.curShearReinfArea;
                    }
                    if (src.reqShearReinfArea !== undefined) {
                        dst.reqShearReinfArea = src.reqShearReinfArea;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ToppingData();
                    dst.coord = this.coord;
                    dst.shearForce = this.shearForce;
                    dst.jointForce = this.jointForce;
                    dst.jointStress = this.jointStress;
                    dst.jointWidth = this.jointWidth;
                    dst.jointCapaForce = this.jointCapaForce;
                    dst.curShearReinfArea = this.curShearReinfArea;
                    dst.reqShearReinfArea = this.reqShearReinfArea;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = ToppingData.toObject(this);
                    const dst = ToppingData.fromObject(json);
                    return dst;
                }
            }
            export type IToppingData = ToppingData;


            export type FlangeReinf_keys = 'stirrup' | 'startCoord' | 'endCoord' | 'area' | 'controls';
            export interface FlangeReinf_createType {
                stirrup?: ng.link.Data | null,
                startCoord?: ng.geometry.Point3D | null,
                endCoord?: ng.geometry.Point3D | null,
                area?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface FlangeReinf_json {
                stirrup?: ng.link.Data_json;
                startCoord?: ng.geometry.Point3D_json;
                endCoord?: ng.geometry.Point3D_json;
                area?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface FlangeReinf_json_in {
                __proto_name?: unknown;
                stirrup?: unknown;
                startCoord?: unknown;
                endCoord?: unknown;
                area?: unknown;
                controls?: unknown;
            }
            export class FlangeReinf {
                __proto_name = "ng.result.concrete.FlangeReinf";
                stirrup: ng.link.Data | null = null;
                startCoord: ng.geometry.Point3D | null = null;
                endCoord: ng.geometry.Point3D | null = null;
                area: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): FlangeReinf {
                    const dst = new FlangeReinf();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FlangeReinf but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FlangeReinf_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FlangeReinf but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.stirrup !== undefined && src.stirrup !== null) {
                        dst.stirrup = ng.link.Data.fromObject(src.stirrup);
                    }
                    if (src.startCoord !== undefined && src.startCoord !== null) {
                        dst.startCoord = ng.geometry.Point3D.fromObject(src.startCoord);
                    }
                    if (src.endCoord !== undefined && src.endCoord !== null) {
                        dst.endCoord = ng.geometry.Point3D.fromObject(src.endCoord);
                    }
                    if (src.area !== undefined && src.area !== null) {
                        if (typeof src.area === "number" || src.area === 'NaN' || src.area === 'Infinity' || src.area === '-Infinity') {
                            dst.area = AsNum(src.area);
                        }
                        else {
                            console.log('Expected area of FlangeReinf to be a number but was ', typeof src.area, src.area)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of FlangeReinf to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: FlangeReinf | null | undefined): FlangeReinf_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.FlangeReinf is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.FlangeReinf") {
                        console.error('Expected ng.result.concrete.FlangeReinf but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FlangeReinf_json = {
                        area: AsJsonNum(src.area),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.stirrup !== null)
                    {
                        const parsed = ng.link.Data.toObject(src.stirrup);
                        if(parsed === null) return null;
                        dst.stirrup = parsed;
                    }
                    if(src.startCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.startCoord);
                        if(parsed === null) return null;
                        dst.startCoord = parsed;
                    }
                    if(src.endCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.endCoord);
                        if(parsed === null) return null;
                        dst.endCoord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: FlangeReinf_createType) {
                    const dst = new FlangeReinf();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.stirrup !== undefined) {
                        dst.stirrup = src.stirrup;
                    }
                    if (src.startCoord !== undefined) {
                        dst.startCoord = src.startCoord;
                    }
                    if (src.endCoord !== undefined) {
                        dst.endCoord = src.endCoord;
                    }
                    if (src.area !== undefined) {
                        dst.area = src.area;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FlangeReinf();
                    dst.stirrup = this.stirrup;
                    dst.startCoord = this.startCoord;
                    dst.endCoord = this.endCoord;
                    dst.area = this.area;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = FlangeReinf.toObject(this);
                    const dst = FlangeReinf.fromObject(json);
                    return dst;
                }
            }
            export type IFlangeReinf = FlangeReinf;


            export type SpallingReinf_keys = 'stirrup' | 'startCoord' | 'endCoord' | 'area' | 'controls';
            export interface SpallingReinf_createType {
                stirrup?: ng.link.Data | null,
                startCoord?: ng.geometry.Point3D | null,
                endCoord?: ng.geometry.Point3D | null,
                area?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface SpallingReinf_json {
                stirrup?: ng.link.Data_json;
                startCoord?: ng.geometry.Point3D_json;
                endCoord?: ng.geometry.Point3D_json;
                area?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface SpallingReinf_json_in {
                __proto_name?: unknown;
                stirrup?: unknown;
                startCoord?: unknown;
                endCoord?: unknown;
                area?: unknown;
                controls?: unknown;
            }
            export class SpallingReinf {
                __proto_name = "ng.result.concrete.SpallingReinf";
                stirrup: ng.link.Data | null = null;
                startCoord: ng.geometry.Point3D | null = null;
                endCoord: ng.geometry.Point3D | null = null;
                area: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): SpallingReinf {
                    const dst = new SpallingReinf();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SpallingReinf but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SpallingReinf_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SpallingReinf but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.stirrup !== undefined && src.stirrup !== null) {
                        dst.stirrup = ng.link.Data.fromObject(src.stirrup);
                    }
                    if (src.startCoord !== undefined && src.startCoord !== null) {
                        dst.startCoord = ng.geometry.Point3D.fromObject(src.startCoord);
                    }
                    if (src.endCoord !== undefined && src.endCoord !== null) {
                        dst.endCoord = ng.geometry.Point3D.fromObject(src.endCoord);
                    }
                    if (src.area !== undefined && src.area !== null) {
                        if (typeof src.area === "number" || src.area === 'NaN' || src.area === 'Infinity' || src.area === '-Infinity') {
                            dst.area = AsNum(src.area);
                        }
                        else {
                            console.log('Expected area of SpallingReinf to be a number but was ', typeof src.area, src.area)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of SpallingReinf to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: SpallingReinf | null | undefined): SpallingReinf_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.SpallingReinf is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.SpallingReinf") {
                        console.error('Expected ng.result.concrete.SpallingReinf but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SpallingReinf_json = {
                        area: AsJsonNum(src.area),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.stirrup !== null)
                    {
                        const parsed = ng.link.Data.toObject(src.stirrup);
                        if(parsed === null) return null;
                        dst.stirrup = parsed;
                    }
                    if(src.startCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.startCoord);
                        if(parsed === null) return null;
                        dst.startCoord = parsed;
                    }
                    if(src.endCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.endCoord);
                        if(parsed === null) return null;
                        dst.endCoord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: SpallingReinf_createType) {
                    const dst = new SpallingReinf();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.stirrup !== undefined) {
                        dst.stirrup = src.stirrup;
                    }
                    if (src.startCoord !== undefined) {
                        dst.startCoord = src.startCoord;
                    }
                    if (src.endCoord !== undefined) {
                        dst.endCoord = src.endCoord;
                    }
                    if (src.area !== undefined) {
                        dst.area = src.area;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SpallingReinf();
                    dst.stirrup = this.stirrup;
                    dst.startCoord = this.startCoord;
                    dst.endCoord = this.endCoord;
                    dst.area = this.area;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = SpallingReinf.toObject(this);
                    const dst = SpallingReinf.fromObject(json);
                    return dst;
                }
            }
            export type ISpallingReinf = SpallingReinf;


            export type BurstingReinf_keys = 'stirrup' | 'startCoord' | 'endCoord' | 'area' | 'controls';
            export interface BurstingReinf_createType {
                stirrup?: ng.link.Data | null,
                startCoord?: ng.geometry.Point3D | null,
                endCoord?: ng.geometry.Point3D | null,
                area?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface BurstingReinf_json {
                stirrup?: ng.link.Data_json;
                startCoord?: ng.geometry.Point3D_json;
                endCoord?: ng.geometry.Point3D_json;
                area?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface BurstingReinf_json_in {
                __proto_name?: unknown;
                stirrup?: unknown;
                startCoord?: unknown;
                endCoord?: unknown;
                area?: unknown;
                controls?: unknown;
            }
            export class BurstingReinf {
                __proto_name = "ng.result.concrete.BurstingReinf";
                stirrup: ng.link.Data | null = null;
                startCoord: ng.geometry.Point3D | null = null;
                endCoord: ng.geometry.Point3D | null = null;
                area: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): BurstingReinf {
                    const dst = new BurstingReinf();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BurstingReinf but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BurstingReinf_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BurstingReinf but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.stirrup !== undefined && src.stirrup !== null) {
                        dst.stirrup = ng.link.Data.fromObject(src.stirrup);
                    }
                    if (src.startCoord !== undefined && src.startCoord !== null) {
                        dst.startCoord = ng.geometry.Point3D.fromObject(src.startCoord);
                    }
                    if (src.endCoord !== undefined && src.endCoord !== null) {
                        dst.endCoord = ng.geometry.Point3D.fromObject(src.endCoord);
                    }
                    if (src.area !== undefined && src.area !== null) {
                        if (typeof src.area === "number" || src.area === 'NaN' || src.area === 'Infinity' || src.area === '-Infinity') {
                            dst.area = AsNum(src.area);
                        }
                        else {
                            console.log('Expected area of BurstingReinf to be a number but was ', typeof src.area, src.area)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of BurstingReinf to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: BurstingReinf | null | undefined): BurstingReinf_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.BurstingReinf is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.BurstingReinf") {
                        console.error('Expected ng.result.concrete.BurstingReinf but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BurstingReinf_json = {
                        area: AsJsonNum(src.area),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.stirrup !== null)
                    {
                        const parsed = ng.link.Data.toObject(src.stirrup);
                        if(parsed === null) return null;
                        dst.stirrup = parsed;
                    }
                    if(src.startCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.startCoord);
                        if(parsed === null) return null;
                        dst.startCoord = parsed;
                    }
                    if(src.endCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.endCoord);
                        if(parsed === null) return null;
                        dst.endCoord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: BurstingReinf_createType) {
                    const dst = new BurstingReinf();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.stirrup !== undefined) {
                        dst.stirrup = src.stirrup;
                    }
                    if (src.startCoord !== undefined) {
                        dst.startCoord = src.startCoord;
                    }
                    if (src.endCoord !== undefined) {
                        dst.endCoord = src.endCoord;
                    }
                    if (src.area !== undefined) {
                        dst.area = src.area;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BurstingReinf();
                    dst.stirrup = this.stirrup;
                    dst.startCoord = this.startCoord;
                    dst.endCoord = this.endCoord;
                    dst.area = this.area;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = BurstingReinf.toObject(this);
                    const dst = BurstingReinf.fromObject(json);
                    return dst;
                }
            }
            export type IBurstingReinf = BurstingReinf;


            export type SplittingReinf_keys = 'stirrup' | 'startCoord' | 'endCoord' | 'area' | 'controls';
            export interface SplittingReinf_createType {
                stirrup?: ng.link.Data | null,
                startCoord?: ng.geometry.Point3D | null,
                endCoord?: ng.geometry.Point3D | null,
                area?: number,
                controls?: ng.result.control.ControlData[],
            }
            export interface SplittingReinf_json {
                stirrup?: ng.link.Data_json;
                startCoord?: ng.geometry.Point3D_json;
                endCoord?: ng.geometry.Point3D_json;
                area?: JsonNumber;
                controls: ng.result.control.ControlData_json[];
            }
            interface SplittingReinf_json_in {
                __proto_name?: unknown;
                stirrup?: unknown;
                startCoord?: unknown;
                endCoord?: unknown;
                area?: unknown;
                controls?: unknown;
            }
            export class SplittingReinf {
                __proto_name = "ng.result.concrete.SplittingReinf";
                stirrup: ng.link.Data | null = null;
                startCoord: ng.geometry.Point3D | null = null;
                endCoord: ng.geometry.Point3D | null = null;
                area: number = 0;
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): SplittingReinf {
                    const dst = new SplittingReinf();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SplittingReinf but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SplittingReinf_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SplittingReinf but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.stirrup !== undefined && src.stirrup !== null) {
                        dst.stirrup = ng.link.Data.fromObject(src.stirrup);
                    }
                    if (src.startCoord !== undefined && src.startCoord !== null) {
                        dst.startCoord = ng.geometry.Point3D.fromObject(src.startCoord);
                    }
                    if (src.endCoord !== undefined && src.endCoord !== null) {
                        dst.endCoord = ng.geometry.Point3D.fromObject(src.endCoord);
                    }
                    if (src.area !== undefined && src.area !== null) {
                        if (typeof src.area === "number" || src.area === 'NaN' || src.area === 'Infinity' || src.area === '-Infinity') {
                            dst.area = AsNum(src.area);
                        }
                        else {
                            console.log('Expected area of SplittingReinf to be a number but was ', typeof src.area, src.area)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of SplittingReinf to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: SplittingReinf | null | undefined): SplittingReinf_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.SplittingReinf is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.SplittingReinf") {
                        console.error('Expected ng.result.concrete.SplittingReinf but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SplittingReinf_json = {
                        area: AsJsonNum(src.area),
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if(src.stirrup !== null)
                    {
                        const parsed = ng.link.Data.toObject(src.stirrup);
                        if(parsed === null) return null;
                        dst.stirrup = parsed;
                    }
                    if(src.startCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.startCoord);
                        if(parsed === null) return null;
                        dst.startCoord = parsed;
                    }
                    if(src.endCoord !== null)
                    {
                        const parsed = ng.geometry.Point3D.toObject(src.endCoord);
                        if(parsed === null) return null;
                        dst.endCoord = parsed;
                    }
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: SplittingReinf_createType) {
                    const dst = new SplittingReinf();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.stirrup !== undefined) {
                        dst.stirrup = src.stirrup;
                    }
                    if (src.startCoord !== undefined) {
                        dst.startCoord = src.startCoord;
                    }
                    if (src.endCoord !== undefined) {
                        dst.endCoord = src.endCoord;
                    }
                    if (src.area !== undefined) {
                        dst.area = src.area;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SplittingReinf();
                    dst.stirrup = this.stirrup;
                    dst.startCoord = this.startCoord;
                    dst.endCoord = this.endCoord;
                    dst.area = this.area;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = SplittingReinf.toObject(this);
                    const dst = SplittingReinf.fromObject(json);
                    return dst;
                }
            }
            export type ISplittingReinf = SplittingReinf;


            export type EndReinf_keys = 'spalling' | 'bursting' | 'splittingReinf';
            export interface EndReinf_createType {
                spalling?: ng.result.concrete.SpallingReinf | null,
                bursting?: ng.result.concrete.BurstingReinf | null,
                splittingReinf?: ng.result.concrete.SplittingReinf | null,
            }
            export interface EndReinf_json {
                spalling?: ng.result.concrete.SpallingReinf_json;
                bursting?: ng.result.concrete.BurstingReinf_json;
                splittingReinf?: ng.result.concrete.SplittingReinf_json;
            }
            interface EndReinf_json_in {
                __proto_name?: unknown;
                spalling?: unknown;
                bursting?: unknown;
                splittingReinf?: unknown;
            }
            export class EndReinf {
                __proto_name = "ng.result.concrete.EndReinf";
                spalling: ng.result.concrete.SpallingReinf | null = null;
                bursting: ng.result.concrete.BurstingReinf | null = null;
                splittingReinf: ng.result.concrete.SplittingReinf | null = null;

                static fromObject(src_unknown: unknown): EndReinf {
                    const dst = new EndReinf();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EndReinf but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EndReinf_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EndReinf but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.spalling !== undefined && src.spalling !== null) {
                        dst.spalling = ng.result.concrete.SpallingReinf.fromObject(src.spalling);
                    }
                    if (src.bursting !== undefined && src.bursting !== null) {
                        dst.bursting = ng.result.concrete.BurstingReinf.fromObject(src.bursting);
                    }
                    if (src.splittingReinf !== undefined && src.splittingReinf !== null) {
                        dst.splittingReinf = ng.result.concrete.SplittingReinf.fromObject(src.splittingReinf);
                    }
                    return dst;
                }

                static toObject(src: EndReinf | null | undefined): EndReinf_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.EndReinf is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.EndReinf") {
                        console.error('Expected ng.result.concrete.EndReinf but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EndReinf_json = {
                    };
                    if(src.spalling !== null)
                    {
                        const parsed = ng.result.concrete.SpallingReinf.toObject(src.spalling);
                        if(parsed === null) return null;
                        dst.spalling = parsed;
                    }
                    if(src.bursting !== null)
                    {
                        const parsed = ng.result.concrete.BurstingReinf.toObject(src.bursting);
                        if(parsed === null) return null;
                        dst.bursting = parsed;
                    }
                    if(src.splittingReinf !== null)
                    {
                        const parsed = ng.result.concrete.SplittingReinf.toObject(src.splittingReinf);
                        if(parsed === null) return null;
                        dst.splittingReinf = parsed;
                    }
                    return dst;
                }

                static create(src?: EndReinf_createType) {
                    const dst = new EndReinf();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.spalling !== undefined) {
                        dst.spalling = src.spalling;
                    }
                    if (src.bursting !== undefined) {
                        dst.bursting = src.bursting;
                    }
                    if (src.splittingReinf !== undefined) {
                        dst.splittingReinf = src.splittingReinf;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EndReinf();
                    dst.spalling = this.spalling;
                    dst.bursting = this.bursting;
                    dst.splittingReinf = this.splittingReinf;
                    return dst;
                }

                deepClone() {
                    const json = EndReinf.toObject(this);
                    const dst = EndReinf.fromObject(json);
                    return dst;
                }
            }
            export type IEndReinf = EndReinf;


            export type AnchorageLength_keys = 'groupId' | 'lbd';
            export interface AnchorageLength_createType {
                groupId?: string,
                lbd?: number,
            }
            export interface AnchorageLength_json {
                groupId?: string;
                lbd?: JsonNumber;
            }
            interface AnchorageLength_json_in {
                __proto_name?: unknown;
                groupId?: unknown;
                lbd?: unknown;
            }
            export class AnchorageLength {
                __proto_name = "ng.result.concrete.AnchorageLength";
                groupId: string = "";
                lbd: number = 0;

                static fromObject(src_unknown: unknown): AnchorageLength {
                    const dst = new AnchorageLength();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AnchorageLength but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AnchorageLength_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AnchorageLength but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.groupId !== undefined && src.groupId !== null) {
                        if (typeof src.groupId === "string") {
                            dst.groupId = src.groupId;
                        }
                        else {
                            console.log('Expected groupId of AnchorageLength to be a string but was ', typeof src.groupId, src.groupId)
                        }
                    }
                    if (src.lbd !== undefined && src.lbd !== null) {
                        if (typeof src.lbd === "number" || src.lbd === 'NaN' || src.lbd === 'Infinity' || src.lbd === '-Infinity') {
                            dst.lbd = AsNum(src.lbd);
                        }
                        else {
                            console.log('Expected lbd of AnchorageLength to be a number but was ', typeof src.lbd, src.lbd)
                        }
                    }
                    return dst;
                }

                static toObject(src: AnchorageLength | null | undefined): AnchorageLength_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.AnchorageLength is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.AnchorageLength") {
                        console.error('Expected ng.result.concrete.AnchorageLength but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AnchorageLength_json = {
                        groupId: src.groupId,
                        lbd: AsJsonNum(src.lbd),
                    };
                    return dst;
                }

                static create(src?: AnchorageLength_createType) {
                    const dst = new AnchorageLength();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.groupId !== undefined) {
                        dst.groupId = src.groupId;
                    }
                    if (src.lbd !== undefined) {
                        dst.lbd = src.lbd;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AnchorageLength();
                    dst.groupId = this.groupId;
                    dst.lbd = this.lbd;
                    return dst;
                }

                deepClone() {
                    const json = AnchorageLength.toObject(this);
                    const dst = AnchorageLength.fromObject(json);
                    return dst;
                }
            }
            export type IAnchorageLength = AnchorageLength;


            export type Anchorage_keys = 'groupId' | 'start' | 'end';
            export interface Anchorage_createType {
                groupId?: string,
                start?: number,
                end?: number,
            }
            export interface Anchorage_json {
                groupId?: string;
                start?: JsonNumber;
                end?: JsonNumber;
            }
            interface Anchorage_json_in {
                __proto_name?: unknown;
                groupId?: unknown;
                start?: unknown;
                end?: unknown;
            }
            export class Anchorage {
                __proto_name = "ng.result.concrete.Anchorage";
                groupId: string = "";
                start: number = 0;
                end: number = 0;

                static fromObject(src_unknown: unknown): Anchorage {
                    const dst = new Anchorage();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Anchorage but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Anchorage_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Anchorage but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.groupId !== undefined && src.groupId !== null) {
                        if (typeof src.groupId === "string") {
                            dst.groupId = src.groupId;
                        }
                        else {
                            console.log('Expected groupId of Anchorage to be a string but was ', typeof src.groupId, src.groupId)
                        }
                    }
                    if (src.start !== undefined && src.start !== null) {
                        if (typeof src.start === "number" || src.start === 'NaN' || src.start === 'Infinity' || src.start === '-Infinity') {
                            dst.start = AsNum(src.start);
                        }
                        else {
                            console.log('Expected start of Anchorage to be a number but was ', typeof src.start, src.start)
                        }
                    }
                    if (src.end !== undefined && src.end !== null) {
                        if (typeof src.end === "number" || src.end === 'NaN' || src.end === 'Infinity' || src.end === '-Infinity') {
                            dst.end = AsNum(src.end);
                        }
                        else {
                            console.log('Expected end of Anchorage to be a number but was ', typeof src.end, src.end)
                        }
                    }
                    return dst;
                }

                static toObject(src: Anchorage | null | undefined): Anchorage_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.Anchorage is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.Anchorage") {
                        console.error('Expected ng.result.concrete.Anchorage but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Anchorage_json = {
                        groupId: src.groupId,
                        start: AsJsonNum(src.start),
                        end: AsJsonNum(src.end),
                    };
                    return dst;
                }

                static create(src?: Anchorage_createType) {
                    const dst = new Anchorage();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.groupId !== undefined) {
                        dst.groupId = src.groupId;
                    }
                    if (src.start !== undefined) {
                        dst.start = src.start;
                    }
                    if (src.end !== undefined) {
                        dst.end = src.end;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Anchorage();
                    dst.groupId = this.groupId;
                    dst.start = this.start;
                    dst.end = this.end;
                    return dst;
                }

                deepClone() {
                    const json = Anchorage.toObject(this);
                    const dst = Anchorage.fromObject(json);
                    return dst;
                }
            }
            export type IAnchorage = Anchorage;


            export type Data_keys = 'bendSls' | 'bendUls' | 'shear' | 'stirrup' | 'torsion' | 'topping';
            export interface Data_createType {
                bendSls?: ng.result.concrete.BendingDataSLS | null,
                bendUls?: ng.result.concrete.BendingDataULS | null,
                shear?: ng.result.concrete.ShearData | null,
                stirrup?: ng.result.concrete.StirrupData | null,
                torsion?: ng.result.concrete.TorsionData | null,
                topping?: ng.result.concrete.ToppingData | null,
            }
            export interface Data_json {
                bendSls?: ng.result.concrete.BendingDataSLS_json;
                bendUls?: ng.result.concrete.BendingDataULS_json;
                shear?: ng.result.concrete.ShearData_json;
                stirrup?: ng.result.concrete.StirrupData_json;
                torsion?: ng.result.concrete.TorsionData_json;
                topping?: ng.result.concrete.ToppingData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                bendSls?: unknown;
                bendUls?: unknown;
                shear?: unknown;
                stirrup?: unknown;
                torsion?: unknown;
                topping?: unknown;
            }
            export class Data {
                __proto_name = "ng.result.concrete.Data";
                bendSls: ng.result.concrete.BendingDataSLS | null = null;
                bendUls: ng.result.concrete.BendingDataULS | null = null;
                shear: ng.result.concrete.ShearData | null = null;
                stirrup: ng.result.concrete.StirrupData | null = null;
                torsion: ng.result.concrete.TorsionData | null = null;
                topping: ng.result.concrete.ToppingData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.bendSls !== undefined && src.bendSls !== null) {
                        dst.bendSls = ng.result.concrete.BendingDataSLS.fromObject(src.bendSls);
                    }
                    if (src.bendUls !== undefined && src.bendUls !== null) {
                        dst.bendUls = ng.result.concrete.BendingDataULS.fromObject(src.bendUls);
                    }
                    if (src.shear !== undefined && src.shear !== null) {
                        dst.shear = ng.result.concrete.ShearData.fromObject(src.shear);
                    }
                    if (src.stirrup !== undefined && src.stirrup !== null) {
                        dst.stirrup = ng.result.concrete.StirrupData.fromObject(src.stirrup);
                    }
                    if (src.torsion !== undefined && src.torsion !== null) {
                        dst.torsion = ng.result.concrete.TorsionData.fromObject(src.torsion);
                    }
                    if (src.topping !== undefined && src.topping !== null) {
                        dst.topping = ng.result.concrete.ToppingData.fromObject(src.topping);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.Data") {
                        console.error('Expected ng.result.concrete.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                    };
                    if(src.bendSls !== null)
                    {
                        const parsed = ng.result.concrete.BendingDataSLS.toObject(src.bendSls);
                        if(parsed === null) return null;
                        dst.bendSls = parsed;
                    }
                    if(src.bendUls !== null)
                    {
                        const parsed = ng.result.concrete.BendingDataULS.toObject(src.bendUls);
                        if(parsed === null) return null;
                        dst.bendUls = parsed;
                    }
                    if(src.shear !== null)
                    {
                        const parsed = ng.result.concrete.ShearData.toObject(src.shear);
                        if(parsed === null) return null;
                        dst.shear = parsed;
                    }
                    if(src.stirrup !== null)
                    {
                        const parsed = ng.result.concrete.StirrupData.toObject(src.stirrup);
                        if(parsed === null) return null;
                        dst.stirrup = parsed;
                    }
                    if(src.torsion !== null)
                    {
                        const parsed = ng.result.concrete.TorsionData.toObject(src.torsion);
                        if(parsed === null) return null;
                        dst.torsion = parsed;
                    }
                    if(src.topping !== null)
                    {
                        const parsed = ng.result.concrete.ToppingData.toObject(src.topping);
                        if(parsed === null) return null;
                        dst.topping = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.bendSls !== undefined) {
                        dst.bendSls = src.bendSls;
                    }
                    if (src.bendUls !== undefined) {
                        dst.bendUls = src.bendUls;
                    }
                    if (src.shear !== undefined) {
                        dst.shear = src.shear;
                    }
                    if (src.stirrup !== undefined) {
                        dst.stirrup = src.stirrup;
                    }
                    if (src.torsion !== undefined) {
                        dst.torsion = src.torsion;
                    }
                    if (src.topping !== undefined) {
                        dst.topping = src.topping;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.bendSls = this.bendSls;
                    dst.bendUls = this.bendUls;
                    dst.shear = this.shear;
                    dst.stirrup = this.stirrup;
                    dst.torsion = this.torsion;
                    dst.topping = this.topping;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;


            export type Element_keys = 'anchorages' | 'flangeReinf' | 'endReinf' | 'maxOfControls';
            export interface Element_createType {
                anchorages?: ng.result.concrete.Anchorage[],
                flangeReinf?: ng.result.concrete.FlangeReinf | null,
                endReinf?: ng.result.concrete.EndReinf | null,
                maxOfControls?: ng.result.control.ControlData[],
            }
            export interface Element_json {
                anchorages: ng.result.concrete.Anchorage_json[];
                flangeReinf?: ng.result.concrete.FlangeReinf_json;
                endReinf?: ng.result.concrete.EndReinf_json;
                maxOfControls: ng.result.control.ControlData_json[];
            }
            interface Element_json_in {
                __proto_name?: unknown;
                anchorages?: unknown;
                flangeReinf?: unknown;
                endReinf?: unknown;
                maxOfControls?: unknown;
            }
            export class Element {
                __proto_name = "ng.result.concrete.Element";
                anchorages: ng.result.concrete.Anchorage[] = [];
                flangeReinf: ng.result.concrete.FlangeReinf | null = null;
                endReinf: ng.result.concrete.EndReinf | null = null;
                maxOfControls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): Element {
                    const dst = new Element();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Element but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Element_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.anchorages !== undefined && src.anchorages !== null) {
                        if (Array.isArray(src.anchorages)) {
                            for (const element of src.anchorages) {
                                dst.anchorages.push(ng.result.concrete.Anchorage.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected anchorages of Element to be a array but was ', typeof src.anchorages, src.anchorages)
                        }
                    }
                    if (src.flangeReinf !== undefined && src.flangeReinf !== null) {
                        dst.flangeReinf = ng.result.concrete.FlangeReinf.fromObject(src.flangeReinf);
                    }
                    if (src.endReinf !== undefined && src.endReinf !== null) {
                        dst.endReinf = ng.result.concrete.EndReinf.fromObject(src.endReinf);
                    }
                    if (src.maxOfControls !== undefined && src.maxOfControls !== null) {
                        if (Array.isArray(src.maxOfControls)) {
                            for (const element of src.maxOfControls) {
                                dst.maxOfControls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected maxOfControls of Element to be a array but was ', typeof src.maxOfControls, src.maxOfControls)
                        }
                    }
                    return dst;
                }

                static toObject(src: Element | null | undefined): Element_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.Element is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.Element") {
                        console.error('Expected ng.result.concrete.Element but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Element_json = {
                        anchorages: new Array<ng.result.concrete.Anchorage_json>(),
                        maxOfControls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if (src.anchorages !== null) {
                        for (const element of src.anchorages) {
                            const parsed = ng.result.concrete.Anchorage.toObject(element);
                            if(parsed === null) return null;
                            dst.anchorages.push(parsed);
                        }
                    }
                    if(src.flangeReinf !== null)
                    {
                        const parsed = ng.result.concrete.FlangeReinf.toObject(src.flangeReinf);
                        if(parsed === null) return null;
                        dst.flangeReinf = parsed;
                    }
                    if(src.endReinf !== null)
                    {
                        const parsed = ng.result.concrete.EndReinf.toObject(src.endReinf);
                        if(parsed === null) return null;
                        dst.endReinf = parsed;
                    }
                    if (src.maxOfControls !== null) {
                        for (const element of src.maxOfControls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.maxOfControls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: Element_createType) {
                    const dst = new Element();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.anchorages !== undefined) {
                        dst.anchorages = src.anchorages;
                    }
                    if (src.flangeReinf !== undefined) {
                        dst.flangeReinf = src.flangeReinf;
                    }
                    if (src.endReinf !== undefined) {
                        dst.endReinf = src.endReinf;
                    }
                    if (src.maxOfControls !== undefined) {
                        dst.maxOfControls = src.maxOfControls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Element();
                    dst.anchorages = this.anchorages;
                    dst.flangeReinf = this.flangeReinf;
                    dst.endReinf = this.endReinf;
                    dst.maxOfControls = this.maxOfControls;
                    return dst;
                }

                deepClone() {
                    const json = Element.toObject(this);
                    const dst = Element.fromObject(json);
                    return dst;
                }
            }
            export type IElement = Element;


            export type DesignSummary_keys = 'elemGuid' | 'controls';
            export interface DesignSummary_createType {
                elemGuid?: string,
                controls?: ng.result.control.ControlData[],
            }
            export interface DesignSummary_json {
                elemGuid?: string;
                controls: ng.result.control.ControlData_json[];
            }
            interface DesignSummary_json_in {
                __proto_name?: unknown;
                elemGuid?: unknown;
                controls?: unknown;
            }
            export class DesignSummary {
                __proto_name = "ng.result.concrete.DesignSummary";
                elemGuid: string = "";
                controls: ng.result.control.ControlData[] = [];

                static fromObject(src_unknown: unknown): DesignSummary {
                    const dst = new DesignSummary();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted DesignSummary but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as DesignSummary_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for DesignSummary but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elemGuid !== undefined && src.elemGuid !== null) {
                        if (typeof src.elemGuid === "string") {
                            dst.elemGuid = src.elemGuid;
                        }
                        else {
                            console.log('Expected elemGuid of DesignSummary to be a string but was ', typeof src.elemGuid, src.elemGuid)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of DesignSummary to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    return dst;
                }

                static toObject(src: DesignSummary | null | undefined): DesignSummary_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.result.concrete.DesignSummary is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.result.concrete.DesignSummary") {
                        console.error('Expected ng.result.concrete.DesignSummary but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : DesignSummary_json = {
                        elemGuid: src.elemGuid,
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: DesignSummary_createType) {
                    const dst = new DesignSummary();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elemGuid !== undefined) {
                        dst.elemGuid = src.elemGuid;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new DesignSummary();
                    dst.elemGuid = this.elemGuid;
                    dst.controls = this.controls;
                    return dst;
                }

                deepClone() {
                    const json = DesignSummary.toObject(this);
                    const dst = DesignSummary.fromObject(json);
                    return dst;
                }
            }
            export type IDesignSummary = DesignSummary;
        } // namespace concrete
    } // namespace result


    // Defined in Geometry/beam.proto
    export namespace beam {
        export enum Alignment {
            ALIGNMENT_UNSPECIFIED = 0,
            ALIGNMENT_TOP = 1,
            ALIGNMENT_CENTER = 2,
            ALIGNMENT_BOTTOM = 3
        }
        export const Alignment_FromObject = (src: unknown): Alignment => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'ALIGNMENT_UNSPECIFIED':
                    return Alignment.ALIGNMENT_UNSPECIFIED;
                case 1:
                case 'ALIGNMENT_TOP':
                    return Alignment.ALIGNMENT_TOP;
                case 2:
                case 'ALIGNMENT_CENTER':
                    return Alignment.ALIGNMENT_CENTER;
                case 3:
                case 'ALIGNMENT_BOTTOM':
                    return Alignment.ALIGNMENT_BOTTOM;
                default:
                    console.log('Unhandled value for Alignment:' + src + '. ' + typeof(src));
                    return Alignment.ALIGNMENT_UNSPECIFIED;
            }
        };
        export const Alignment_ToObject = (src: Alignment): string | null => {
            switch (src) {
                case Alignment.ALIGNMENT_UNSPECIFIED:
                    return 'ALIGNMENT_UNSPECIFIED';
                case Alignment.ALIGNMENT_TOP:
                    return 'ALIGNMENT_TOP';
                case Alignment.ALIGNMENT_CENTER:
                    return 'ALIGNMENT_CENTER';
                case Alignment.ALIGNMENT_BOTTOM:
                    return 'ALIGNMENT_BOTTOM';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Alignment, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum ConcreteBeamType {
            CONCRETE_BEAM_TYPE_UNSPECIFIED = 0,
            CONCRETE_BEAM_TYPE_CONSTANT = 1,
            CONCRETE_BEAM_TYPE_SIB = 2,
            CONCRETE_BEAM_TYPE_IB = 3,
            CONCRETE_BEAM_TYPE_STT = 4,
            CONCRETE_BEAM_TYPE_RBX = 5,
            CONCRETE_BEAM_TYPE_CUSTOM = 6
        }
        export const ConcreteBeamType_FromObject = (src: unknown): ConcreteBeamType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'CONCRETE_BEAM_TYPE_UNSPECIFIED':
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_UNSPECIFIED;
                case 1:
                case 'CONCRETE_BEAM_TYPE_CONSTANT':
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_CONSTANT;
                case 2:
                case 'CONCRETE_BEAM_TYPE_SIB':
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_SIB;
                case 3:
                case 'CONCRETE_BEAM_TYPE_IB':
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_IB;
                case 4:
                case 'CONCRETE_BEAM_TYPE_STT':
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_STT;
                case 5:
                case 'CONCRETE_BEAM_TYPE_RBX':
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_RBX;
                case 6:
                case 'CONCRETE_BEAM_TYPE_CUSTOM':
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_CUSTOM;
                default:
                    console.log('Unhandled value for ConcreteBeamType:' + src + '. ' + typeof(src));
                    return ConcreteBeamType.CONCRETE_BEAM_TYPE_UNSPECIFIED;
            }
        };
        export const ConcreteBeamType_ToObject = (src: ConcreteBeamType): string | null => {
            switch (src) {
                case ConcreteBeamType.CONCRETE_BEAM_TYPE_UNSPECIFIED:
                    return 'CONCRETE_BEAM_TYPE_UNSPECIFIED';
                case ConcreteBeamType.CONCRETE_BEAM_TYPE_CONSTANT:
                    return 'CONCRETE_BEAM_TYPE_CONSTANT';
                case ConcreteBeamType.CONCRETE_BEAM_TYPE_SIB:
                    return 'CONCRETE_BEAM_TYPE_SIB';
                case ConcreteBeamType.CONCRETE_BEAM_TYPE_IB:
                    return 'CONCRETE_BEAM_TYPE_IB';
                case ConcreteBeamType.CONCRETE_BEAM_TYPE_STT:
                    return 'CONCRETE_BEAM_TYPE_STT';
                case ConcreteBeamType.CONCRETE_BEAM_TYPE_RBX:
                    return 'CONCRETE_BEAM_TYPE_RBX';
                case ConcreteBeamType.CONCRETE_BEAM_TYPE_CUSTOM:
                    return 'CONCRETE_BEAM_TYPE_CUSTOM';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for ConcreteBeamType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum SupportCondition {
            SUPPORT_CONDITION_UNSPECIFIED = 0,
            SUPPORT_CONDITION_CANTILEVER = 1,
            SUPPORT_CONDITION_SIMPLY = 2
        }
        export const SupportCondition_FromObject = (src: unknown): SupportCondition => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'SUPPORT_CONDITION_UNSPECIFIED':
                    return SupportCondition.SUPPORT_CONDITION_UNSPECIFIED;
                case 1:
                case 'SUPPORT_CONDITION_CANTILEVER':
                    return SupportCondition.SUPPORT_CONDITION_CANTILEVER;
                case 2:
                case 'SUPPORT_CONDITION_SIMPLY':
                    return SupportCondition.SUPPORT_CONDITION_SIMPLY;
                default:
                    console.log('Unhandled value for SupportCondition:' + src + '. ' + typeof(src));
                    return SupportCondition.SUPPORT_CONDITION_UNSPECIFIED;
            }
        };
        export const SupportCondition_ToObject = (src: SupportCondition): string | null => {
            switch (src) {
                case SupportCondition.SUPPORT_CONDITION_UNSPECIFIED:
                    return 'SUPPORT_CONDITION_UNSPECIFIED';
                case SupportCondition.SUPPORT_CONDITION_CANTILEVER:
                    return 'SUPPORT_CONDITION_CANTILEVER';
                case SupportCondition.SUPPORT_CONDITION_SIMPLY:
                    return 'SUPPORT_CONDITION_SIMPLY';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for SupportCondition, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum BucklingType {
            BUCKLING_TYPE_UNSPECIFIED = 0,
            BUCKLING_TYPE_FLEXURAL_WEAK = 1,
            BUCKLING_TYPE_FLEXURAL_STIFF = 2,
            BUCKLING_TYPE_PRESSURED_TOP_FLANGE = 3,
            BUCKLING_TYPE_PRESSURED_BOTTOM_FLANGE = 4,
            BUCKLING_TYPE_LATERAL_TORSIONAL = 5
        }
        export const BucklingType_FromObject = (src: unknown): BucklingType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'BUCKLING_TYPE_UNSPECIFIED':
                    return BucklingType.BUCKLING_TYPE_UNSPECIFIED;
                case 1:
                case 'BUCKLING_TYPE_FLEXURAL_WEAK':
                    return BucklingType.BUCKLING_TYPE_FLEXURAL_WEAK;
                case 2:
                case 'BUCKLING_TYPE_FLEXURAL_STIFF':
                    return BucklingType.BUCKLING_TYPE_FLEXURAL_STIFF;
                case 3:
                case 'BUCKLING_TYPE_PRESSURED_TOP_FLANGE':
                    return BucklingType.BUCKLING_TYPE_PRESSURED_TOP_FLANGE;
                case 4:
                case 'BUCKLING_TYPE_PRESSURED_BOTTOM_FLANGE':
                    return BucklingType.BUCKLING_TYPE_PRESSURED_BOTTOM_FLANGE;
                case 5:
                case 'BUCKLING_TYPE_LATERAL_TORSIONAL':
                    return BucklingType.BUCKLING_TYPE_LATERAL_TORSIONAL;
                default:
                    console.log('Unhandled value for BucklingType:' + src + '. ' + typeof(src));
                    return BucklingType.BUCKLING_TYPE_UNSPECIFIED;
            }
        };
        export const BucklingType_ToObject = (src: BucklingType): string | null => {
            switch (src) {
                case BucklingType.BUCKLING_TYPE_UNSPECIFIED:
                    return 'BUCKLING_TYPE_UNSPECIFIED';
                case BucklingType.BUCKLING_TYPE_FLEXURAL_WEAK:
                    return 'BUCKLING_TYPE_FLEXURAL_WEAK';
                case BucklingType.BUCKLING_TYPE_FLEXURAL_STIFF:
                    return 'BUCKLING_TYPE_FLEXURAL_STIFF';
                case BucklingType.BUCKLING_TYPE_PRESSURED_TOP_FLANGE:
                    return 'BUCKLING_TYPE_PRESSURED_TOP_FLANGE';
                case BucklingType.BUCKLING_TYPE_PRESSURED_BOTTOM_FLANGE:
                    return 'BUCKLING_TYPE_PRESSURED_BOTTOM_FLANGE';
                case BucklingType.BUCKLING_TYPE_LATERAL_TORSIONAL:
                    return 'BUCKLING_TYPE_LATERAL_TORSIONAL';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for BucklingType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum ActionType {
            ACTION_TYPE_UNSPECIFIED = 0,
            ACTION_TYPE_BEAM = 1,
            ACTION_TYPE_COLUMN = 2,
            ACTION_TYPE_BAR = 3
        }
        export const ActionType_FromObject = (src: unknown): ActionType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'ACTION_TYPE_UNSPECIFIED':
                    return ActionType.ACTION_TYPE_UNSPECIFIED;
                case 1:
                case 'ACTION_TYPE_BEAM':
                    return ActionType.ACTION_TYPE_BEAM;
                case 2:
                case 'ACTION_TYPE_COLUMN':
                    return ActionType.ACTION_TYPE_COLUMN;
                case 3:
                case 'ACTION_TYPE_BAR':
                    return ActionType.ACTION_TYPE_BAR;
                default:
                    console.log('Unhandled value for ActionType:' + src + '. ' + typeof(src));
                    return ActionType.ACTION_TYPE_UNSPECIFIED;
            }
        };
        export const ActionType_ToObject = (src: ActionType): string | null => {
            switch (src) {
                case ActionType.ACTION_TYPE_UNSPECIFIED:
                    return 'ACTION_TYPE_UNSPECIFIED';
                case ActionType.ACTION_TYPE_BEAM:
                    return 'ACTION_TYPE_BEAM';
                case ActionType.ACTION_TYPE_COLUMN:
                    return 'ACTION_TYPE_COLUMN';
                case ActionType.ACTION_TYPE_BAR:
                    return 'ACTION_TYPE_BAR';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for ActionType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum BowImperfectionDirectionForBeam {
            DIR_UNSPECIFIED = 0,
            DIR_X = 1,
            DIR_Y = 2,
            DIR_Z = 3
        }
        export const BowImperfectionDirectionForBeam_FromObject = (src: unknown): BowImperfectionDirectionForBeam => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DIR_UNSPECIFIED':
                    return BowImperfectionDirectionForBeam.DIR_UNSPECIFIED;
                case 1:
                case 'DIR_X':
                    return BowImperfectionDirectionForBeam.DIR_X;
                case 2:
                case 'DIR_Y':
                    return BowImperfectionDirectionForBeam.DIR_Y;
                case 3:
                case 'DIR_Z':
                    return BowImperfectionDirectionForBeam.DIR_Z;
                default:
                    console.log('Unhandled value for BowImperfectionDirectionForBeam:' + src + '. ' + typeof(src));
                    return BowImperfectionDirectionForBeam.DIR_UNSPECIFIED;
            }
        };
        export const BowImperfectionDirectionForBeam_ToObject = (src: BowImperfectionDirectionForBeam): string | null => {
            switch (src) {
                case BowImperfectionDirectionForBeam.DIR_UNSPECIFIED:
                    return 'DIR_UNSPECIFIED';
                case BowImperfectionDirectionForBeam.DIR_X:
                    return 'DIR_X';
                case BowImperfectionDirectionForBeam.DIR_Y:
                    return 'DIR_Y';
                case BowImperfectionDirectionForBeam.DIR_Z:
                    return 'DIR_Z';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for BowImperfectionDirectionForBeam, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type ConcreteElement_keys = 'type' | 'rebars' | 'strands' | 'links' | 'topping' | 'fbWeak' | 'fbStiff' | 'distances';
        export interface ConcreteElement_createType {
            type?: ng.beam.ConcreteBeamType,
            rebars?: ng.rebar.Data | null,
            strands?: ng.strand.Data | null,
            links?: ng.link.Data | null,
            topping?: ng.beam.ConcreteElement.Topping | null,
            fbWeak?: ng.beam.FlexBuckling | null,
            fbStiff?: ng.beam.FlexBuckling | null,
            distances?: ng.design.concrete.CoverAndSpace[],
        }
        export interface ConcreteElement_json {
            type?: string;
            rebars?: ng.rebar.Data_json;
            strands?: ng.strand.Data_json;
            links?: ng.link.Data_json;
            topping?: ng.beam.ConcreteElement.Topping_json;
            fbWeak?: ng.beam.FlexBuckling_json;
            fbStiff?: ng.beam.FlexBuckling_json;
            distances: ng.design.concrete.CoverAndSpace_json[];
        }
        interface ConcreteElement_json_in {
            __proto_name?: unknown;
            type?: unknown;
            rebars?: unknown;
            strands?: unknown;
            links?: unknown;
            topping?: unknown;
            fbWeak?: unknown;
            fbStiff?: unknown;
            distances?: unknown;
        }
        export class ConcreteElement {
            __proto_name = "ng.beam.ConcreteElement";
            type: ng.beam.ConcreteBeamType = ng.beam.ConcreteBeamType.CONCRETE_BEAM_TYPE_UNSPECIFIED;
            rebars: ng.rebar.Data | null = null;
            strands: ng.strand.Data | null = null;
            links: ng.link.Data | null = null;
            topping: ng.beam.ConcreteElement.Topping | null = null;
            fbWeak: ng.beam.FlexBuckling | null = null;
            fbStiff: ng.beam.FlexBuckling | null = null;
            distances: ng.design.concrete.CoverAndSpace[] = [];

            static fromObject(src_unknown: unknown): ConcreteElement {
                const dst = new ConcreteElement();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ConcreteElement but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ConcreteElement_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ConcreteElement but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.beam.ConcreteBeamType_FromObject(src.type);
                }
                if (src.rebars !== undefined && src.rebars !== null) {
                    dst.rebars = ng.rebar.Data.fromObject(src.rebars);
                }
                if (src.strands !== undefined && src.strands !== null) {
                    dst.strands = ng.strand.Data.fromObject(src.strands);
                }
                if (src.links !== undefined && src.links !== null) {
                    dst.links = ng.link.Data.fromObject(src.links);
                }
                if (src.topping !== undefined && src.topping !== null) {
                    dst.topping = ng.beam.ConcreteElement.Topping.fromObject(src.topping);
                }
                if (src.fbWeak !== undefined && src.fbWeak !== null) {
                    dst.fbWeak = ng.beam.FlexBuckling.fromObject(src.fbWeak);
                }
                if (src.fbStiff !== undefined && src.fbStiff !== null) {
                    dst.fbStiff = ng.beam.FlexBuckling.fromObject(src.fbStiff);
                }
                if (src.distances !== undefined && src.distances !== null) {
                    if (Array.isArray(src.distances)) {
                        for (const element of src.distances) {
                            dst.distances.push(ng.design.concrete.CoverAndSpace.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected distances of ConcreteElement to be a array but was ', typeof src.distances, src.distances)
                    }
                }
                return dst;
            }

            static toObject(src: ConcreteElement | null | undefined): ConcreteElement_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.ConcreteElement is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.ConcreteElement") {
                    console.error('Expected ng.beam.ConcreteElement but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.beam.ConcreteBeamType_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : ConcreteElement_json = {
                    type: type_obj,
                    distances: new Array<ng.design.concrete.CoverAndSpace_json>(),
                };
                if(src.rebars !== null)
                {
                    const parsed = ng.rebar.Data.toObject(src.rebars);
                    if(parsed === null) return null;
                    dst.rebars = parsed;
                }
                if(src.strands !== null)
                {
                    const parsed = ng.strand.Data.toObject(src.strands);
                    if(parsed === null) return null;
                    dst.strands = parsed;
                }
                if(src.links !== null)
                {
                    const parsed = ng.link.Data.toObject(src.links);
                    if(parsed === null) return null;
                    dst.links = parsed;
                }
                if(src.topping !== null)
                {
                    const parsed = ng.beam.ConcreteElement.Topping.toObject(src.topping);
                    if(parsed === null) return null;
                    dst.topping = parsed;
                }
                if(src.fbWeak !== null)
                {
                    const parsed = ng.beam.FlexBuckling.toObject(src.fbWeak);
                    if(parsed === null) return null;
                    dst.fbWeak = parsed;
                }
                if(src.fbStiff !== null)
                {
                    const parsed = ng.beam.FlexBuckling.toObject(src.fbStiff);
                    if(parsed === null) return null;
                    dst.fbStiff = parsed;
                }
                if (src.distances !== null) {
                    for (const element of src.distances) {
                        const parsed = ng.design.concrete.CoverAndSpace.toObject(element);
                        if(parsed === null) return null;
                        dst.distances.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: ConcreteElement_createType) {
                const dst = new ConcreteElement();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.rebars !== undefined) {
                    dst.rebars = src.rebars;
                }
                if (src.strands !== undefined) {
                    dst.strands = src.strands;
                }
                if (src.links !== undefined) {
                    dst.links = src.links;
                }
                if (src.topping !== undefined) {
                    dst.topping = src.topping;
                }
                if (src.fbWeak !== undefined) {
                    dst.fbWeak = src.fbWeak;
                }
                if (src.fbStiff !== undefined) {
                    dst.fbStiff = src.fbStiff;
                }
                if (src.distances !== undefined) {
                    dst.distances = src.distances;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ConcreteElement();
                dst.type = this.type;
                dst.rebars = this.rebars;
                dst.strands = this.strands;
                dst.links = this.links;
                dst.topping = this.topping;
                dst.fbWeak = this.fbWeak;
                dst.fbStiff = this.fbStiff;
                dst.distances = this.distances;
                return dst;
            }

            deepClone() {
                const json = ConcreteElement.toObject(this);
                const dst = ConcreteElement.fromObject(json);
                return dst;
            }
        }
        export type IConcreteElement = ConcreteElement;


        export type Stiffener_keys = 'pos' | 'lft' | 'rgt' | 't';
        export interface Stiffener_createType {
            pos?: number,
            lft?: boolean,
            rgt?: boolean,
            t?: number,
        }
        export interface Stiffener_json {
            pos?: JsonNumber;
            lft?: boolean;
            rgt?: boolean;
            t?: JsonNumber;
        }
        interface Stiffener_json_in {
            __proto_name?: unknown;
            pos?: unknown;
            lft?: unknown;
            rgt?: unknown;
            t?: unknown;
        }
        export class Stiffener {
            __proto_name = "ng.beam.Stiffener";
            pos: number = 0;
            lft: boolean = false;
            rgt: boolean = false;
            t: number = 0;

            static fromObject(src_unknown: unknown): Stiffener {
                const dst = new Stiffener();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Stiffener but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Stiffener_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Stiffener but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.pos !== undefined && src.pos !== null) {
                    if (typeof src.pos === "number" || src.pos === 'NaN' || src.pos === 'Infinity' || src.pos === '-Infinity') {
                        dst.pos = AsNum(src.pos);
                    }
                    else {
                        console.log('Expected pos of Stiffener to be a number but was ', typeof src.pos, src.pos)
                    }
                }
                if (src.lft !== undefined && src.lft !== null) {
                    if (typeof src.lft === "boolean") {
                        dst.lft = src.lft;
                    }
                    else {
                        console.log('Expected lft of Stiffener to be a boolean but was ', typeof src.lft, src.lft)
                    }
                }
                if (src.rgt !== undefined && src.rgt !== null) {
                    if (typeof src.rgt === "boolean") {
                        dst.rgt = src.rgt;
                    }
                    else {
                        console.log('Expected rgt of Stiffener to be a boolean but was ', typeof src.rgt, src.rgt)
                    }
                }
                if (src.t !== undefined && src.t !== null) {
                    if (typeof src.t === "number" || src.t === 'NaN' || src.t === 'Infinity' || src.t === '-Infinity') {
                        dst.t = AsNum(src.t);
                    }
                    else {
                        console.log('Expected t of Stiffener to be a number but was ', typeof src.t, src.t)
                    }
                }
                return dst;
            }

            static toObject(src: Stiffener | null | undefined): Stiffener_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.Stiffener is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.Stiffener") {
                    console.error('Expected ng.beam.Stiffener but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Stiffener_json = {
                    pos: AsJsonNum(src.pos),
                    lft: src.lft,
                    rgt: src.rgt,
                    t: AsJsonNum(src.t),
                };
                return dst;
            }

            static create(src?: Stiffener_createType) {
                const dst = new Stiffener();
                if (src === undefined) {
                    return dst;
                }
                if (src.pos !== undefined) {
                    dst.pos = src.pos;
                }
                if (src.lft !== undefined) {
                    dst.lft = src.lft;
                }
                if (src.rgt !== undefined) {
                    dst.rgt = src.rgt;
                }
                if (src.t !== undefined) {
                    dst.t = src.t;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Stiffener();
                dst.pos = this.pos;
                dst.lft = this.lft;
                dst.rgt = this.rgt;
                dst.t = this.t;
                return dst;
            }

            deepClone() {
                const json = Stiffener.toObject(this);
                const dst = Stiffener.fromObject(json);
                return dst;
            }
        }
        export type IStiffener = Stiffener;


        export type BucklingSpan_keys = 'start' | 'end';
        export interface BucklingSpan_createType {
            start?: number,
            end?: number,
        }
        export interface BucklingSpan_json {
            start?: JsonNumber;
            end?: JsonNumber;
        }
        interface BucklingSpan_json_in {
            __proto_name?: unknown;
            start?: unknown;
            end?: unknown;
        }
        export class BucklingSpan {
            __proto_name = "ng.beam.BucklingSpan";
            start: number = 0;
            end: number = 0;

            static fromObject(src_unknown: unknown): BucklingSpan {
                const dst = new BucklingSpan();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted BucklingSpan but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as BucklingSpan_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for BucklingSpan but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.start !== undefined && src.start !== null) {
                    if (typeof src.start === "number" || src.start === 'NaN' || src.start === 'Infinity' || src.start === '-Infinity') {
                        dst.start = AsNum(src.start);
                    }
                    else {
                        console.log('Expected start of BucklingSpan to be a number but was ', typeof src.start, src.start)
                    }
                }
                if (src.end !== undefined && src.end !== null) {
                    if (typeof src.end === "number" || src.end === 'NaN' || src.end === 'Infinity' || src.end === '-Infinity') {
                        dst.end = AsNum(src.end);
                    }
                    else {
                        console.log('Expected end of BucklingSpan to be a number but was ', typeof src.end, src.end)
                    }
                }
                return dst;
            }

            static toObject(src: BucklingSpan | null | undefined): BucklingSpan_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.BucklingSpan is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.BucklingSpan") {
                    console.error('Expected ng.beam.BucklingSpan but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : BucklingSpan_json = {
                    start: AsJsonNum(src.start),
                    end: AsJsonNum(src.end),
                };
                return dst;
            }

            static create(src?: BucklingSpan_createType) {
                const dst = new BucklingSpan();
                if (src === undefined) {
                    return dst;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.end !== undefined) {
                    dst.end = src.end;
                }
                return dst;
            }

            shallowClone() {
                const dst = new BucklingSpan();
                dst.start = this.start;
                dst.end = this.end;
                return dst;
            }

            deepClone() {
                const json = BucklingSpan.toObject(this);
                const dst = BucklingSpan.fromObject(json);
                return dst;
            }
        }
        export type IBucklingSpan = BucklingSpan;


        export type BucklingData_keys = 'position' | 'beta' | 'supportCondition';
        export interface BucklingData_createType {
            position?: ng.beam.BucklingSpan | null,
            beta?: number,
            supportCondition?: ng.beam.SupportCondition,
        }
        export interface BucklingData_json {
            position?: ng.beam.BucklingSpan_json;
            beta?: JsonNumber;
            supportCondition?: string;
        }
        interface BucklingData_json_in {
            __proto_name?: unknown;
            position?: unknown;
            beta?: unknown;
            supportCondition?: unknown;
        }
        export class BucklingData {
            __proto_name = "ng.beam.BucklingData";
            position: ng.beam.BucklingSpan | null = null;
            // this is a one of
            factor: {type: 'beta'; beta: number} | {type: 'supportCondition'; supportCondition: ng.beam.SupportCondition} | null = null;

            /** Gets the `Beta` value (or null) from the oneof `factor` */
            getBeta(): number | null {
                if(this.factor === null) return null;
                if(this.factor.type !== 'beta') return null;
                return this.factor.beta;
            }

            /** Sets the `Beta` value for the oneof `factor`*/
            setBeta(value: number | null) {
                if(value !== null) {
                    this.factor = {type: 'beta', beta:value};
                }
                else {
                    this.factor = null;
                }
            }

            /** Gets the `SupportCondition` value (or null) from the oneof `factor` */
            getSupportCondition(): ng.beam.SupportCondition | null {
                if(this.factor === null) return null;
                if(this.factor.type !== 'supportCondition') return null;
                return this.factor.supportCondition;
            }

            /** Sets the `SupportCondition` value for the oneof `factor`*/
            setSupportCondition(value: ng.beam.SupportCondition | null) {
                if(value !== null) {
                    this.factor = {type: 'supportCondition', supportCondition:value};
                }
                else {
                    this.factor = null;
                }
            }

            static fromObject(src_unknown: unknown): BucklingData {
                const dst = new BucklingData();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted BucklingData but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as BucklingData_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for BucklingData but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.position !== undefined && src.position !== null) {
                    dst.position = ng.beam.BucklingSpan.fromObject(src.position);
                }
                if (src.beta !== undefined && src.beta !== null) {
                    if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                        dst.setBeta(AsNum(src.beta));
                    }
                    else {
                        console.log('Expected beta of BucklingData to be a number but was ', typeof src.beta, src.beta)
                    }
                }
                if (src.supportCondition !== undefined && src.supportCondition !== null) {
                    dst.setSupportCondition(ng.beam.SupportCondition_FromObject(src.supportCondition));
                }
                return dst;
            }

            static toObject(src: BucklingData | null | undefined): BucklingData_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.BucklingData is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.BucklingData") {
                    console.error('Expected ng.beam.BucklingData but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : BucklingData_json = {
                };
                if(src.position !== null)
                {
                    const parsed = ng.beam.BucklingSpan.toObject(src.position);
                    if(parsed === null) return null;
                    dst.position = parsed;
                }
                const beta = src.getBeta();
                if(beta !== null)
                {
                    const parsed = AsJsonNum(beta);
                    if(parsed === null) return null;
                    dst.beta = parsed;
                }
                const supportCondition = src.getSupportCondition();
                if(supportCondition !== null)
                {
                    const parsed = ng.beam.SupportCondition_ToObject(supportCondition);
                    if(parsed === null) return null;
                    dst.supportCondition = parsed;
                }
                return dst;
            }

            static create(src?: BucklingData_createType) {
                const dst = new BucklingData();
                if (src === undefined) {
                    return dst;
                }
                if (src.position !== undefined) {
                    dst.position = src.position;
                }
                // part of the factor oneof 
                if (src.beta !== undefined && src.beta !== null) {
                    dst.setBeta(src.beta);
                }
                // part of the factor oneof 
                if (src.supportCondition !== undefined && src.supportCondition !== null) {
                    dst.setSupportCondition(src.supportCondition);
                }
                return dst;
            }

            shallowClone() {
                const dst = new BucklingData();
                dst.position = this.position;
                dst.factor = this.factor;
                return dst;
            }

            deepClone() {
                const json = BucklingData.toObject(this);
                const dst = BucklingData.fromObject(json);
                return dst;
            }
        }
        export type IBucklingData = BucklingData;


        export type BucklingRes_keys = 'bucklingLoad' | 'lc' | 'vals' | 'modes' | 'freqs';
        export interface BucklingRes_createType {
            bucklingLoad?: number,
            lc?: number,
            vals?: number[],
            modes?: ng.beam.BucklingRes.mode[],
            freqs?: number[],
        }
        export interface BucklingRes_json {
            bucklingLoad?: JsonNumber;
            lc?: JsonNumber;
            vals: JsonNumber[];
            modes: ng.beam.BucklingRes.mode_json[];
            freqs: JsonNumber[];
        }
        interface BucklingRes_json_in {
            __proto_name?: unknown;
            bucklingLoad?: unknown;
            lc?: unknown;
            vals?: unknown;
            modes?: unknown;
            freqs?: unknown;
        }
        export class BucklingRes {
            __proto_name = "ng.beam.BucklingRes";
            bucklingLoad: number = 0;
            lc: number = 0;
            vals: number[] = [];
            modes: ng.beam.BucklingRes.mode[] = [];
            freqs: number[] = [];

            static fromObject(src_unknown: unknown): BucklingRes {
                const dst = new BucklingRes();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted BucklingRes but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as BucklingRes_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for BucklingRes but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.bucklingLoad !== undefined && src.bucklingLoad !== null) {
                    if (typeof src.bucklingLoad === "number" || src.bucklingLoad === 'NaN' || src.bucklingLoad === 'Infinity' || src.bucklingLoad === '-Infinity') {
                        dst.bucklingLoad = AsNum(src.bucklingLoad);
                    }
                    else {
                        console.log('Expected bucklingLoad of BucklingRes to be a number but was ', typeof src.bucklingLoad, src.bucklingLoad)
                    }
                }
                if (src.lc !== undefined && src.lc !== null) {
                    if (typeof src.lc === "number" || src.lc === 'NaN' || src.lc === 'Infinity' || src.lc === '-Infinity') {
                        dst.lc = AsNum(src.lc);
                    }
                    else {
                        console.log('Expected lc of BucklingRes to be a number but was ', typeof src.lc, src.lc)
                    }
                }
                if (src.vals !== undefined && src.vals !== null) {
                    if (Array.isArray(src.vals)) {
                        for (const [index, element] of src.vals.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.vals.push(AsNum(element));
                            }
                            else {
                                console.log('Expected vals of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected vals of BucklingRes to be a array but was ', typeof src.vals, src.vals)
                    }
                }
                if (src.modes !== undefined && src.modes !== null) {
                    if (Array.isArray(src.modes)) {
                        for (const element of src.modes) {
                            dst.modes.push(ng.beam.BucklingRes.mode.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected modes of BucklingRes to be a array but was ', typeof src.modes, src.modes)
                    }
                }
                if (src.freqs !== undefined && src.freqs !== null) {
                    if (Array.isArray(src.freqs)) {
                        for (const [index, element] of src.freqs.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.freqs.push(AsNum(element));
                            }
                            else {
                                console.log('Expected freqs of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected freqs of BucklingRes to be a array but was ', typeof src.freqs, src.freqs)
                    }
                }
                return dst;
            }

            static toObject(src: BucklingRes | null | undefined): BucklingRes_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.BucklingRes is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.BucklingRes") {
                    console.error('Expected ng.beam.BucklingRes but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : BucklingRes_json = {
                    bucklingLoad: AsJsonNum(src.bucklingLoad),
                    lc: AsJsonNum(src.lc),
                    vals: new Array<JsonNumber>(),
                    modes: new Array<ng.beam.BucklingRes.mode_json>(),
                    freqs: new Array<JsonNumber>(),
                };
                if (src.vals !== null) {
                    for (const element of src.vals) {
                        dst.vals.push(AsJsonNum(element));
                    }
                }
                if (src.modes !== null) {
                    for (const element of src.modes) {
                        const parsed = ng.beam.BucklingRes.mode.toObject(element);
                        if(parsed === null) return null;
                        dst.modes.push(parsed);
                    }
                }
                if (src.freqs !== null) {
                    for (const element of src.freqs) {
                        dst.freqs.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: BucklingRes_createType) {
                const dst = new BucklingRes();
                if (src === undefined) {
                    return dst;
                }
                if (src.bucklingLoad !== undefined) {
                    dst.bucklingLoad = src.bucklingLoad;
                }
                if (src.lc !== undefined) {
                    dst.lc = src.lc;
                }
                if (src.vals !== undefined) {
                    dst.vals = src.vals;
                }
                if (src.modes !== undefined) {
                    dst.modes = src.modes;
                }
                if (src.freqs !== undefined) {
                    dst.freqs = src.freqs;
                }
                return dst;
            }

            shallowClone() {
                const dst = new BucklingRes();
                dst.bucklingLoad = this.bucklingLoad;
                dst.lc = this.lc;
                dst.vals = this.vals;
                dst.modes = this.modes;
                dst.freqs = this.freqs;
                return dst;
            }

            deepClone() {
                const json = BucklingRes.toObject(this);
                const dst = BucklingRes.fromObject(json);
                return dst;
            }
        }
        export type IBucklingRes = BucklingRes;


        export type FlexBuckling_keys = 'type' | 'sway' | 'betas' | 'data' | 'bucklingRes';
        export interface FlexBuckling_createType {
            type?: ng.beam.BucklingType,
            sway?: boolean,
            betas?: number[],
            data?: ng.beam.BucklingData[],
            bucklingRes?: ng.beam.BucklingRes | null,
        }
        export interface FlexBuckling_json {
            type?: string;
            sway?: boolean;
            betas: JsonNumber[];
            data: ng.beam.BucklingData_json[];
            bucklingRes?: ng.beam.BucklingRes_json;
        }
        interface FlexBuckling_json_in {
            __proto_name?: unknown;
            type?: unknown;
            sway?: unknown;
            betas?: unknown;
            data?: unknown;
            bucklingRes?: unknown;
        }
        export class FlexBuckling {
            __proto_name = "ng.beam.FlexBuckling";
            type: ng.beam.BucklingType = ng.beam.BucklingType.BUCKLING_TYPE_UNSPECIFIED;
            sway: boolean = false;
            betas: number[] = [];
            data: ng.beam.BucklingData[] = [];
            bucklingRes: ng.beam.BucklingRes | null = null;

            static fromObject(src_unknown: unknown): FlexBuckling {
                const dst = new FlexBuckling();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted FlexBuckling but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as FlexBuckling_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for FlexBuckling but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.beam.BucklingType_FromObject(src.type);
                }
                if (src.sway !== undefined && src.sway !== null) {
                    if (typeof src.sway === "boolean") {
                        dst.sway = src.sway;
                    }
                    else {
                        console.log('Expected sway of FlexBuckling to be a boolean but was ', typeof src.sway, src.sway)
                    }
                }
                if (src.betas !== undefined && src.betas !== null) {
                    if (Array.isArray(src.betas)) {
                        for (const [index, element] of src.betas.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.betas.push(AsNum(element));
                            }
                            else {
                                console.log('Expected betas of FlexBuckling[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected betas of FlexBuckling to be a array but was ', typeof src.betas, src.betas)
                    }
                }
                if (src.data !== undefined && src.data !== null) {
                    if (Array.isArray(src.data)) {
                        for (const element of src.data) {
                            dst.data.push(ng.beam.BucklingData.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected data of FlexBuckling to be a array but was ', typeof src.data, src.data)
                    }
                }
                if (src.bucklingRes !== undefined && src.bucklingRes !== null) {
                    dst.bucklingRes = ng.beam.BucklingRes.fromObject(src.bucklingRes);
                }
                return dst;
            }

            static toObject(src: FlexBuckling | null | undefined): FlexBuckling_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.FlexBuckling is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.FlexBuckling") {
                    console.error('Expected ng.beam.FlexBuckling but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.beam.BucklingType_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : FlexBuckling_json = {
                    type: type_obj,
                    sway: src.sway,
                    betas: new Array<JsonNumber>(),
                    data: new Array<ng.beam.BucklingData_json>(),
                };
                if (src.betas !== null) {
                    for (const element of src.betas) {
                        dst.betas.push(AsJsonNum(element));
                    }
                }
                if (src.data !== null) {
                    for (const element of src.data) {
                        const parsed = ng.beam.BucklingData.toObject(element);
                        if(parsed === null) return null;
                        dst.data.push(parsed);
                    }
                }
                if(src.bucklingRes !== null)
                {
                    const parsed = ng.beam.BucklingRes.toObject(src.bucklingRes);
                    if(parsed === null) return null;
                    dst.bucklingRes = parsed;
                }
                return dst;
            }

            static create(src?: FlexBuckling_createType) {
                const dst = new FlexBuckling();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.sway !== undefined) {
                    dst.sway = src.sway;
                }
                if (src.betas !== undefined) {
                    dst.betas = src.betas;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                if (src.bucklingRes !== undefined) {
                    dst.bucklingRes = src.bucklingRes;
                }
                return dst;
            }

            shallowClone() {
                const dst = new FlexBuckling();
                dst.type = this.type;
                dst.sway = this.sway;
                dst.betas = this.betas;
                dst.data = this.data;
                dst.bucklingRes = this.bucklingRes;
                return dst;
            }

            deepClone() {
                const json = FlexBuckling.toObject(this);
                const dst = FlexBuckling.fromObject(json);
                return dst;
            }
        }
        export type IFlexBuckling = FlexBuckling;


        export type LTBuckling_keys = 'type' | 'continouslyRestrained' | 'betas' | 'data' | 'bucklingRes';
        export interface LTBuckling_createType {
            type?: ng.beam.BucklingType,
            continouslyRestrained?: boolean,
            betas?: number[],
            data?: ng.beam.BucklingData[],
            bucklingRes?: ng.beam.BucklingRes | null,
        }
        export interface LTBuckling_json {
            type?: string;
            continouslyRestrained?: boolean;
            betas: JsonNumber[];
            data: ng.beam.BucklingData_json[];
            bucklingRes?: ng.beam.BucklingRes_json;
        }
        interface LTBuckling_json_in {
            __proto_name?: unknown;
            type?: unknown;
            continouslyRestrained?: unknown;
            betas?: unknown;
            data?: unknown;
            bucklingRes?: unknown;
        }
        export class LTBuckling {
            __proto_name = "ng.beam.LTBuckling";
            type: ng.beam.BucklingType = ng.beam.BucklingType.BUCKLING_TYPE_UNSPECIFIED;
            continouslyRestrained: boolean = false;
            betas: number[] = [];
            data: ng.beam.BucklingData[] = [];
            bucklingRes: ng.beam.BucklingRes | null = null;

            static fromObject(src_unknown: unknown): LTBuckling {
                const dst = new LTBuckling();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LTBuckling but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LTBuckling_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LTBuckling but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.beam.BucklingType_FromObject(src.type);
                }
                if (src.continouslyRestrained !== undefined && src.continouslyRestrained !== null) {
                    if (typeof src.continouslyRestrained === "boolean") {
                        dst.continouslyRestrained = src.continouslyRestrained;
                    }
                    else {
                        console.log('Expected continouslyRestrained of LTBuckling to be a boolean but was ', typeof src.continouslyRestrained, src.continouslyRestrained)
                    }
                }
                if (src.betas !== undefined && src.betas !== null) {
                    if (Array.isArray(src.betas)) {
                        for (const [index, element] of src.betas.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.betas.push(AsNum(element));
                            }
                            else {
                                console.log('Expected betas of LTBuckling[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected betas of LTBuckling to be a array but was ', typeof src.betas, src.betas)
                    }
                }
                if (src.data !== undefined && src.data !== null) {
                    if (Array.isArray(src.data)) {
                        for (const element of src.data) {
                            dst.data.push(ng.beam.BucklingData.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected data of LTBuckling to be a array but was ', typeof src.data, src.data)
                    }
                }
                if (src.bucklingRes !== undefined && src.bucklingRes !== null) {
                    dst.bucklingRes = ng.beam.BucklingRes.fromObject(src.bucklingRes);
                }
                return dst;
            }

            static toObject(src: LTBuckling | null | undefined): LTBuckling_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.LTBuckling is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.LTBuckling") {
                    console.error('Expected ng.beam.LTBuckling but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.beam.BucklingType_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : LTBuckling_json = {
                    type: type_obj,
                    continouslyRestrained: src.continouslyRestrained,
                    betas: new Array<JsonNumber>(),
                    data: new Array<ng.beam.BucklingData_json>(),
                };
                if (src.betas !== null) {
                    for (const element of src.betas) {
                        dst.betas.push(AsJsonNum(element));
                    }
                }
                if (src.data !== null) {
                    for (const element of src.data) {
                        const parsed = ng.beam.BucklingData.toObject(element);
                        if(parsed === null) return null;
                        dst.data.push(parsed);
                    }
                }
                if(src.bucklingRes !== null)
                {
                    const parsed = ng.beam.BucklingRes.toObject(src.bucklingRes);
                    if(parsed === null) return null;
                    dst.bucklingRes = parsed;
                }
                return dst;
            }

            static create(src?: LTBuckling_createType) {
                const dst = new LTBuckling();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.continouslyRestrained !== undefined) {
                    dst.continouslyRestrained = src.continouslyRestrained;
                }
                if (src.betas !== undefined) {
                    dst.betas = src.betas;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                if (src.bucklingRes !== undefined) {
                    dst.bucklingRes = src.bucklingRes;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LTBuckling();
                dst.type = this.type;
                dst.continouslyRestrained = this.continouslyRestrained;
                dst.betas = this.betas;
                dst.data = this.data;
                dst.bucklingRes = this.bucklingRes;
                return dst;
            }

            deepClone() {
                const json = LTBuckling.toObject(this);
                const dst = LTBuckling.fromObject(json);
                return dst;
            }
        }
        export type ILTBuckling = LTBuckling;


        export type LTSBuckling_keys = 'continouslyRestrained' | 'supportConditions' | 'data' | 'bucklingRes';
        export interface LTSBuckling_createType {
            continouslyRestrained?: boolean,
            supportConditions?: ng.beam.SupportCondition[],
            data?: ng.beam.BucklingData[],
            bucklingRes?: ng.beam.BucklingRes | null,
        }
        export interface LTSBuckling_json {
            continouslyRestrained?: boolean;
            supportConditions: string[];
            data: ng.beam.BucklingData_json[];
            bucklingRes?: ng.beam.BucklingRes_json;
        }
        interface LTSBuckling_json_in {
            __proto_name?: unknown;
            continouslyRestrained?: unknown;
            supportConditions?: unknown;
            data?: unknown;
            bucklingRes?: unknown;
        }
        export class LTSBuckling {
            __proto_name = "ng.beam.LTSBuckling";
            continouslyRestrained: boolean = false;
            supportConditions: ng.beam.SupportCondition[] = [];
            data: ng.beam.BucklingData[] = [];
            bucklingRes: ng.beam.BucklingRes | null = null;

            static fromObject(src_unknown: unknown): LTSBuckling {
                const dst = new LTSBuckling();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LTSBuckling but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LTSBuckling_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LTSBuckling but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.continouslyRestrained !== undefined && src.continouslyRestrained !== null) {
                    if (typeof src.continouslyRestrained === "boolean") {
                        dst.continouslyRestrained = src.continouslyRestrained;
                    }
                    else {
                        console.log('Expected continouslyRestrained of LTSBuckling to be a boolean but was ', typeof src.continouslyRestrained, src.continouslyRestrained)
                    }
                }
                if (src.supportConditions !== undefined && src.supportConditions !== null) {
                    if (Array.isArray(src.supportConditions)) {
                        for (const element of src.supportConditions) {
                            dst.supportConditions.push(ng.beam.SupportCondition_FromObject(element));
                        }
                    }
                    else {
                        console.log('Expected supportConditions of LTSBuckling to be a array but was ', typeof src.supportConditions, src.supportConditions)
                    }
                }
                if (src.data !== undefined && src.data !== null) {
                    if (Array.isArray(src.data)) {
                        for (const element of src.data) {
                            dst.data.push(ng.beam.BucklingData.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected data of LTSBuckling to be a array but was ', typeof src.data, src.data)
                    }
                }
                if (src.bucklingRes !== undefined && src.bucklingRes !== null) {
                    dst.bucklingRes = ng.beam.BucklingRes.fromObject(src.bucklingRes);
                }
                return dst;
            }

            static toObject(src: LTSBuckling | null | undefined): LTSBuckling_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.LTSBuckling is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.LTSBuckling") {
                    console.error('Expected ng.beam.LTSBuckling but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LTSBuckling_json = {
                    continouslyRestrained: src.continouslyRestrained,
                    supportConditions: new Array<string>(),
                    data: new Array<ng.beam.BucklingData_json>(),
                };
                if (src.supportConditions !== null) {
                    for (const element of src.supportConditions) {
                        const parsed = ng.beam.SupportCondition_ToObject(element);
                        if(parsed === null) return null;
                        dst.supportConditions.push(parsed);
                    }
                }
                if (src.data !== null) {
                    for (const element of src.data) {
                        const parsed = ng.beam.BucklingData.toObject(element);
                        if(parsed === null) return null;
                        dst.data.push(parsed);
                    }
                }
                if(src.bucklingRes !== null)
                {
                    const parsed = ng.beam.BucklingRes.toObject(src.bucklingRes);
                    if(parsed === null) return null;
                    dst.bucklingRes = parsed;
                }
                return dst;
            }

            static create(src?: LTSBuckling_createType) {
                const dst = new LTSBuckling();
                if (src === undefined) {
                    return dst;
                }
                if (src.continouslyRestrained !== undefined) {
                    dst.continouslyRestrained = src.continouslyRestrained;
                }
                if (src.supportConditions !== undefined) {
                    dst.supportConditions = src.supportConditions;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                if (src.bucklingRes !== undefined) {
                    dst.bucklingRes = src.bucklingRes;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LTSBuckling();
                dst.continouslyRestrained = this.continouslyRestrained;
                dst.supportConditions = this.supportConditions;
                dst.data = this.data;
                dst.bucklingRes = this.bucklingRes;
                return dst;
            }

            deepClone() {
                const json = LTSBuckling.toObject(this);
                const dst = LTSBuckling.fromObject(json);
                return dst;
            }
        }
        export type ILTSBuckling = LTSBuckling;


        export type SteelElement_keys = 'stiffeners' | 'fbWeak' | 'fbStiff' | 'ltbTop' | 'ltbBtm' | 'loadPosition';
        export interface SteelElement_createType {
            stiffeners?: ng.beam.Stiffener[],
            fbWeak?: ng.beam.FlexBuckling | null,
            fbStiff?: ng.beam.FlexBuckling | null,
            ltbTop?: ng.beam.LTBuckling | null,
            ltbBtm?: ng.beam.LTBuckling | null,
            loadPosition?: ng.beam.Alignment,
        }
        export interface SteelElement_json {
            stiffeners: ng.beam.Stiffener_json[];
            fbWeak?: ng.beam.FlexBuckling_json;
            fbStiff?: ng.beam.FlexBuckling_json;
            ltbTop?: ng.beam.LTBuckling_json;
            ltbBtm?: ng.beam.LTBuckling_json;
            loadPosition?: string;
        }
        interface SteelElement_json_in {
            __proto_name?: unknown;
            stiffeners?: unknown;
            fbWeak?: unknown;
            fbStiff?: unknown;
            ltbTop?: unknown;
            ltbBtm?: unknown;
            loadPosition?: unknown;
        }
        export class SteelElement {
            __proto_name = "ng.beam.SteelElement";
            stiffeners: ng.beam.Stiffener[] = [];
            fbWeak: ng.beam.FlexBuckling | null = null;
            fbStiff: ng.beam.FlexBuckling | null = null;
            ltbTop: ng.beam.LTBuckling | null = null;
            ltbBtm: ng.beam.LTBuckling | null = null;
            loadPosition: ng.beam.Alignment = ng.beam.Alignment.ALIGNMENT_UNSPECIFIED;

            static fromObject(src_unknown: unknown): SteelElement {
                const dst = new SteelElement();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SteelElement but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SteelElement_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SteelElement but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.stiffeners !== undefined && src.stiffeners !== null) {
                    if (Array.isArray(src.stiffeners)) {
                        for (const element of src.stiffeners) {
                            dst.stiffeners.push(ng.beam.Stiffener.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected stiffeners of SteelElement to be a array but was ', typeof src.stiffeners, src.stiffeners)
                    }
                }
                if (src.fbWeak !== undefined && src.fbWeak !== null) {
                    dst.fbWeak = ng.beam.FlexBuckling.fromObject(src.fbWeak);
                }
                if (src.fbStiff !== undefined && src.fbStiff !== null) {
                    dst.fbStiff = ng.beam.FlexBuckling.fromObject(src.fbStiff);
                }
                if (src.ltbTop !== undefined && src.ltbTop !== null) {
                    dst.ltbTop = ng.beam.LTBuckling.fromObject(src.ltbTop);
                }
                if (src.ltbBtm !== undefined && src.ltbBtm !== null) {
                    dst.ltbBtm = ng.beam.LTBuckling.fromObject(src.ltbBtm);
                }
                if (src.loadPosition !== undefined && src.loadPosition !== null) {
                    dst.loadPosition = ng.beam.Alignment_FromObject(src.loadPosition);
                }
                return dst;
            }

            static toObject(src: SteelElement | null | undefined): SteelElement_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.SteelElement is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.SteelElement") {
                    console.error('Expected ng.beam.SteelElement but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const loadPosition_obj = ng.beam.Alignment_ToObject(src.loadPosition);
                if(loadPosition_obj === null) return null;

                const dst : SteelElement_json = {
                    stiffeners: new Array<ng.beam.Stiffener_json>(),
                    loadPosition: loadPosition_obj,
                };
                if (src.stiffeners !== null) {
                    for (const element of src.stiffeners) {
                        const parsed = ng.beam.Stiffener.toObject(element);
                        if(parsed === null) return null;
                        dst.stiffeners.push(parsed);
                    }
                }
                if(src.fbWeak !== null)
                {
                    const parsed = ng.beam.FlexBuckling.toObject(src.fbWeak);
                    if(parsed === null) return null;
                    dst.fbWeak = parsed;
                }
                if(src.fbStiff !== null)
                {
                    const parsed = ng.beam.FlexBuckling.toObject(src.fbStiff);
                    if(parsed === null) return null;
                    dst.fbStiff = parsed;
                }
                if(src.ltbTop !== null)
                {
                    const parsed = ng.beam.LTBuckling.toObject(src.ltbTop);
                    if(parsed === null) return null;
                    dst.ltbTop = parsed;
                }
                if(src.ltbBtm !== null)
                {
                    const parsed = ng.beam.LTBuckling.toObject(src.ltbBtm);
                    if(parsed === null) return null;
                    dst.ltbBtm = parsed;
                }
                return dst;
            }

            static create(src?: SteelElement_createType) {
                const dst = new SteelElement();
                if (src === undefined) {
                    return dst;
                }
                if (src.stiffeners !== undefined) {
                    dst.stiffeners = src.stiffeners;
                }
                if (src.fbWeak !== undefined) {
                    dst.fbWeak = src.fbWeak;
                }
                if (src.fbStiff !== undefined) {
                    dst.fbStiff = src.fbStiff;
                }
                if (src.ltbTop !== undefined) {
                    dst.ltbTop = src.ltbTop;
                }
                if (src.ltbBtm !== undefined) {
                    dst.ltbBtm = src.ltbBtm;
                }
                if (src.loadPosition !== undefined) {
                    dst.loadPosition = src.loadPosition;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SteelElement();
                dst.stiffeners = this.stiffeners;
                dst.fbWeak = this.fbWeak;
                dst.fbStiff = this.fbStiff;
                dst.ltbTop = this.ltbTop;
                dst.ltbBtm = this.ltbBtm;
                dst.loadPosition = this.loadPosition;
                return dst;
            }

            deepClone() {
                const json = SteelElement.toObject(this);
                const dst = SteelElement.fromObject(json);
                return dst;
            }
        }
        export type ISteelElement = SteelElement;


        export type TimberElement_keys = 'fbWeak' | 'fbStiff' | 'ltsb' | 'loadPosition';
        export interface TimberElement_createType {
            fbWeak?: ng.beam.FlexBuckling | null,
            fbStiff?: ng.beam.FlexBuckling | null,
            ltsb?: ng.beam.LTSBuckling | null,
            loadPosition?: ng.beam.Alignment,
        }
        export interface TimberElement_json {
            fbWeak?: ng.beam.FlexBuckling_json;
            fbStiff?: ng.beam.FlexBuckling_json;
            ltsb?: ng.beam.LTSBuckling_json;
            loadPosition?: string;
        }
        interface TimberElement_json_in {
            __proto_name?: unknown;
            fbWeak?: unknown;
            fbStiff?: unknown;
            ltsb?: unknown;
            loadPosition?: unknown;
        }
        export class TimberElement {
            __proto_name = "ng.beam.TimberElement";
            fbWeak: ng.beam.FlexBuckling | null = null;
            fbStiff: ng.beam.FlexBuckling | null = null;
            ltsb: ng.beam.LTSBuckling | null = null;
            loadPosition: ng.beam.Alignment = ng.beam.Alignment.ALIGNMENT_UNSPECIFIED;

            static fromObject(src_unknown: unknown): TimberElement {
                const dst = new TimberElement();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted TimberElement but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as TimberElement_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for TimberElement but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.fbWeak !== undefined && src.fbWeak !== null) {
                    dst.fbWeak = ng.beam.FlexBuckling.fromObject(src.fbWeak);
                }
                if (src.fbStiff !== undefined && src.fbStiff !== null) {
                    dst.fbStiff = ng.beam.FlexBuckling.fromObject(src.fbStiff);
                }
                if (src.ltsb !== undefined && src.ltsb !== null) {
                    dst.ltsb = ng.beam.LTSBuckling.fromObject(src.ltsb);
                }
                if (src.loadPosition !== undefined && src.loadPosition !== null) {
                    dst.loadPosition = ng.beam.Alignment_FromObject(src.loadPosition);
                }
                return dst;
            }

            static toObject(src: TimberElement | null | undefined): TimberElement_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.TimberElement is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.TimberElement") {
                    console.error('Expected ng.beam.TimberElement but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const loadPosition_obj = ng.beam.Alignment_ToObject(src.loadPosition);
                if(loadPosition_obj === null) return null;

                const dst : TimberElement_json = {
                    loadPosition: loadPosition_obj,
                };
                if(src.fbWeak !== null)
                {
                    const parsed = ng.beam.FlexBuckling.toObject(src.fbWeak);
                    if(parsed === null) return null;
                    dst.fbWeak = parsed;
                }
                if(src.fbStiff !== null)
                {
                    const parsed = ng.beam.FlexBuckling.toObject(src.fbStiff);
                    if(parsed === null) return null;
                    dst.fbStiff = parsed;
                }
                if(src.ltsb !== null)
                {
                    const parsed = ng.beam.LTSBuckling.toObject(src.ltsb);
                    if(parsed === null) return null;
                    dst.ltsb = parsed;
                }
                return dst;
            }

            static create(src?: TimberElement_createType) {
                const dst = new TimberElement();
                if (src === undefined) {
                    return dst;
                }
                if (src.fbWeak !== undefined) {
                    dst.fbWeak = src.fbWeak;
                }
                if (src.fbStiff !== undefined) {
                    dst.fbStiff = src.fbStiff;
                }
                if (src.ltsb !== undefined) {
                    dst.ltsb = src.ltsb;
                }
                if (src.loadPosition !== undefined) {
                    dst.loadPosition = src.loadPosition;
                }
                return dst;
            }

            shallowClone() {
                const dst = new TimberElement();
                dst.fbWeak = this.fbWeak;
                dst.fbStiff = this.fbStiff;
                dst.ltsb = this.ltsb;
                dst.loadPosition = this.loadPosition;
                return dst;
            }

            deepClone() {
                const json = TimberElement.toObject(this);
                const dst = TimberElement.fromObject(json);
                return dst;
            }
        }
        export type ITimberElement = TimberElement;


        export type MultiLayerSegment_keys = 'length' | 'layer' | 'id';
        export interface MultiLayerSegment_createType {
            length?: number,
            layer?: ng.beam.MultiLayer[],
            id?: ng.utils.ID | null,
        }
        export interface MultiLayerSegment_json {
            length?: JsonNumber;
            layer: ng.beam.MultiLayer_json[];
            id?: ng.utils.ID_json;
        }
        interface MultiLayerSegment_json_in {
            __proto_name?: unknown;
            length?: unknown;
            layer?: unknown;
            id?: unknown;
        }
        export class MultiLayerSegment {
            __proto_name = "ng.beam.MultiLayerSegment";
            length: number = 0;
            layer: ng.beam.MultiLayer[] = [];
            id: ng.utils.ID | null = null;

            static fromObject(src_unknown: unknown): MultiLayerSegment {
                const dst = new MultiLayerSegment();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted MultiLayerSegment but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as MultiLayerSegment_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for MultiLayerSegment but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.length !== undefined && src.length !== null) {
                    if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                        dst.length = AsNum(src.length);
                    }
                    else {
                        console.log('Expected length of MultiLayerSegment to be a number but was ', typeof src.length, src.length)
                    }
                }
                if (src.layer !== undefined && src.layer !== null) {
                    if (Array.isArray(src.layer)) {
                        for (const element of src.layer) {
                            dst.layer.push(ng.beam.MultiLayer.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected layer of MultiLayerSegment to be a array but was ', typeof src.layer, src.layer)
                    }
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                return dst;
            }

            static toObject(src: MultiLayerSegment | null | undefined): MultiLayerSegment_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.MultiLayerSegment is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.MultiLayerSegment") {
                    console.error('Expected ng.beam.MultiLayerSegment but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : MultiLayerSegment_json = {
                    length: AsJsonNum(src.length),
                    layer: new Array<ng.beam.MultiLayer_json>(),
                };
                if (src.layer !== null) {
                    for (const element of src.layer) {
                        const parsed = ng.beam.MultiLayer.toObject(element);
                        if(parsed === null) return null;
                        dst.layer.push(parsed);
                    }
                }
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                return dst;
            }

            static create(src?: MultiLayerSegment_createType) {
                const dst = new MultiLayerSegment();
                if (src === undefined) {
                    return dst;
                }
                if (src.length !== undefined) {
                    dst.length = src.length;
                }
                if (src.layer !== undefined) {
                    dst.layer = src.layer;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                return dst;
            }

            shallowClone() {
                const dst = new MultiLayerSegment();
                dst.length = this.length;
                dst.layer = this.layer;
                dst.id = this.id;
                return dst;
            }

            deepClone() {
                const json = MultiLayerSegment.toObject(this);
                const dst = MultiLayerSegment.fromObject(json);
                return dst;
            }
        }
        export type IMultiLayerSegment = MultiLayerSegment;


        export type Segment_keys = 'length' | 'layer' | 'id';
        export interface Segment_createType {
            length?: number,
            layer?: ng.beam.Layer | null,
            id?: ng.utils.ID | null,
        }
        export interface Segment_json {
            length?: JsonNumber;
            layer?: ng.beam.Layer_json;
            id?: ng.utils.ID_json;
        }
        interface Segment_json_in {
            __proto_name?: unknown;
            length?: unknown;
            layer?: unknown;
            id?: unknown;
        }
        export class Segment {
            __proto_name = "ng.beam.Segment";
            length: number = 0;
            layer: ng.beam.Layer | null = null;
            id: ng.utils.ID | null = null;

            static fromObject(src_unknown: unknown): Segment {
                const dst = new Segment();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Segment but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Segment_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Segment but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.length !== undefined && src.length !== null) {
                    if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                        dst.length = AsNum(src.length);
                    }
                    else {
                        console.log('Expected length of Segment to be a number but was ', typeof src.length, src.length)
                    }
                }
                if (src.layer !== undefined && src.layer !== null) {
                    dst.layer = ng.beam.Layer.fromObject(src.layer);
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                return dst;
            }

            static toObject(src: Segment | null | undefined): Segment_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.Segment is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.Segment") {
                    console.error('Expected ng.beam.Segment but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Segment_json = {
                    length: AsJsonNum(src.length),
                };
                if(src.layer !== null)
                {
                    const parsed = ng.beam.Layer.toObject(src.layer);
                    if(parsed === null) return null;
                    dst.layer = parsed;
                }
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                return dst;
            }

            static create(src?: Segment_createType) {
                const dst = new Segment();
                if (src === undefined) {
                    return dst;
                }
                if (src.length !== undefined) {
                    dst.length = src.length;
                }
                if (src.layer !== undefined) {
                    dst.layer = src.layer;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Segment();
                dst.length = this.length;
                dst.layer = this.layer;
                dst.id = this.id;
                return dst;
            }

            deepClone() {
                const json = Segment.toObject(this);
                const dst = Segment.fromObject(json);
                return dst;
            }
        }
        export type ISegment = Segment;


        export type Layer_keys = 'start' | 'end';
        export interface Layer_createType {
            start?: ng.beam.SecInPlane | null,
            end?: ng.beam.SecInPlane | null,
        }
        export interface Layer_json {
            start?: ng.beam.SecInPlane_json;
            end?: ng.beam.SecInPlane_json;
        }
        interface Layer_json_in {
            __proto_name?: unknown;
            start?: unknown;
            end?: unknown;
        }
        export class Layer {
            __proto_name = "ng.beam.Layer";
            start: ng.beam.SecInPlane | null = null;
            end: ng.beam.SecInPlane | null = null;

            static fromObject(src_unknown: unknown): Layer {
                const dst = new Layer();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Layer but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Layer_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Layer but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.start !== undefined && src.start !== null) {
                    dst.start = ng.beam.SecInPlane.fromObject(src.start);
                }
                if (src.end !== undefined && src.end !== null) {
                    dst.end = ng.beam.SecInPlane.fromObject(src.end);
                }
                return dst;
            }

            static toObject(src: Layer | null | undefined): Layer_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.Layer is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.Layer") {
                    console.error('Expected ng.beam.Layer but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Layer_json = {
                };
                if(src.start !== null)
                {
                    const parsed = ng.beam.SecInPlane.toObject(src.start);
                    if(parsed === null) return null;
                    dst.start = parsed;
                }
                if(src.end !== null)
                {
                    const parsed = ng.beam.SecInPlane.toObject(src.end);
                    if(parsed === null) return null;
                    dst.end = parsed;
                }
                return dst;
            }

            static create(src?: Layer_createType) {
                const dst = new Layer();
                if (src === undefined) {
                    return dst;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.end !== undefined) {
                    dst.end = src.end;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Layer();
                dst.start = this.start;
                dst.end = this.end;
                return dst;
            }

            deepClone() {
                const json = Layer.toObject(this);
                const dst = Layer.fromObject(json);
                return dst;
            }
        }
        export type ILayer = Layer;


        export type MultiLayer_keys = 'start' | 'end' | 'mtrlGuid';
        export interface MultiLayer_createType {
            start?: ng.beam.SecInPlane | null,
            end?: ng.beam.SecInPlane | null,
            mtrlGuid?: string,
        }
        export interface MultiLayer_json {
            start?: ng.beam.SecInPlane_json;
            end?: ng.beam.SecInPlane_json;
            mtrlGuid?: string;
        }
        interface MultiLayer_json_in {
            __proto_name?: unknown;
            start?: unknown;
            end?: unknown;
            mtrlGuid?: unknown;
        }
        export class MultiLayer {
            __proto_name = "ng.beam.MultiLayer";
            start: ng.beam.SecInPlane | null = null;
            end: ng.beam.SecInPlane | null = null;
            mtrlGuid: string = "";

            static fromObject(src_unknown: unknown): MultiLayer {
                const dst = new MultiLayer();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted MultiLayer but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as MultiLayer_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for MultiLayer but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.start !== undefined && src.start !== null) {
                    dst.start = ng.beam.SecInPlane.fromObject(src.start);
                }
                if (src.end !== undefined && src.end !== null) {
                    dst.end = ng.beam.SecInPlane.fromObject(src.end);
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of MultiLayer to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                return dst;
            }

            static toObject(src: MultiLayer | null | undefined): MultiLayer_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.MultiLayer is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.MultiLayer") {
                    console.error('Expected ng.beam.MultiLayer but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : MultiLayer_json = {
                    mtrlGuid: src.mtrlGuid,
                };
                if(src.start !== null)
                {
                    const parsed = ng.beam.SecInPlane.toObject(src.start);
                    if(parsed === null) return null;
                    dst.start = parsed;
                }
                if(src.end !== null)
                {
                    const parsed = ng.beam.SecInPlane.toObject(src.end);
                    if(parsed === null) return null;
                    dst.end = parsed;
                }
                return dst;
            }

            static create(src?: MultiLayer_createType) {
                const dst = new MultiLayer();
                if (src === undefined) {
                    return dst;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.end !== undefined) {
                    dst.end = src.end;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new MultiLayer();
                dst.start = this.start;
                dst.end = this.end;
                dst.mtrlGuid = this.mtrlGuid;
                return dst;
            }

            deepClone() {
                const json = MultiLayer.toObject(this);
                const dst = MultiLayer.fromObject(json);
                return dst;
            }
        }
        export type IMultiLayer = MultiLayer;


        export type SecInPlane_keys = 'secGuid' | 'localDx' | 'localDy';
        export interface SecInPlane_createType {
            secGuid?: string,
            localDx?: number,
            localDy?: number,
        }
        export interface SecInPlane_json {
            secGuid?: string;
            localDx?: JsonNumber;
            localDy?: JsonNumber;
        }
        interface SecInPlane_json_in {
            __proto_name?: unknown;
            secGuid?: unknown;
            localDx?: unknown;
            localDy?: unknown;
        }
        export class SecInPlane {
            __proto_name = "ng.beam.SecInPlane";
            secGuid: string = "";
            localDx: number = 0;
            localDy: number = 0;

            static fromObject(src_unknown: unknown): SecInPlane {
                const dst = new SecInPlane();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SecInPlane but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SecInPlane_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SecInPlane but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.secGuid !== undefined && src.secGuid !== null) {
                    if (typeof src.secGuid === "string") {
                        dst.secGuid = src.secGuid;
                    }
                    else {
                        console.log('Expected secGuid of SecInPlane to be a string but was ', typeof src.secGuid, src.secGuid)
                    }
                }
                if (src.localDx !== undefined && src.localDx !== null) {
                    if (typeof src.localDx === "number" || src.localDx === 'NaN' || src.localDx === 'Infinity' || src.localDx === '-Infinity') {
                        dst.localDx = AsNum(src.localDx);
                    }
                    else {
                        console.log('Expected localDx of SecInPlane to be a number but was ', typeof src.localDx, src.localDx)
                    }
                }
                if (src.localDy !== undefined && src.localDy !== null) {
                    if (typeof src.localDy === "number" || src.localDy === 'NaN' || src.localDy === 'Infinity' || src.localDy === '-Infinity') {
                        dst.localDy = AsNum(src.localDy);
                    }
                    else {
                        console.log('Expected localDy of SecInPlane to be a number but was ', typeof src.localDy, src.localDy)
                    }
                }
                return dst;
            }

            static toObject(src: SecInPlane | null | undefined): SecInPlane_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.SecInPlane is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.SecInPlane") {
                    console.error('Expected ng.beam.SecInPlane but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SecInPlane_json = {
                    secGuid: src.secGuid,
                    localDx: AsJsonNum(src.localDx),
                    localDy: AsJsonNum(src.localDy),
                };
                return dst;
            }

            static create(src?: SecInPlane_createType) {
                const dst = new SecInPlane();
                if (src === undefined) {
                    return dst;
                }
                if (src.secGuid !== undefined) {
                    dst.secGuid = src.secGuid;
                }
                if (src.localDx !== undefined) {
                    dst.localDx = src.localDx;
                }
                if (src.localDy !== undefined) {
                    dst.localDy = src.localDy;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SecInPlane();
                dst.secGuid = this.secGuid;
                dst.localDx = this.localDx;
                dst.localDy = this.localDy;
                return dst;
            }

            deepClone() {
                const json = SecInPlane.toObject(this);
                const dst = SecInPlane.fromObject(json);
                return dst;
            }
        }
        export type ISecInPlane = SecInPlane;


        export type Data_keys = 'startNodeGuid' | 'endNodeGuid' | 'segments' | 'actionType' | 'n' | 'initialBowCoef' | 'dirForBowImp' | 'mtrlGuid' | 'concrete' | 'steel' | 'timber' | 'activeBoreholeGuid';
        export interface Data_createType {
            startNodeGuid?: string,
            endNodeGuid?: string,
            segments?: ng.beam.Segment[],
            actionType?: ng.beam.ActionType,
            n?: ng.geometry.Vector2D | null,
            initialBowCoef?: number,
            dirForBowImp?: ng.beam.BowImperfectionDirectionForBeam,
            mtrlGuid?: string,
            concrete?: ng.beam.ConcreteElement | null,
            steel?: ng.beam.SteelElement | null,
            timber?: ng.beam.TimberElement | null,
            activeBoreholeGuid?: string,
        }
        export interface Data_json {
            startNodeGuid?: string;
            endNodeGuid?: string;
            segments: ng.beam.Segment_json[];
            actionType?: string;
            n?: ng.geometry.Vector2D_json;
            initialBowCoef?: JsonNumber;
            dirForBowImp?: string;
            mtrlGuid?: string;
            concrete?: ng.beam.ConcreteElement_json;
            steel?: ng.beam.SteelElement_json;
            timber?: ng.beam.TimberElement_json;
            activeBoreholeGuid?: string;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            startNodeGuid?: unknown;
            endNodeGuid?: unknown;
            segments?: unknown;
            actionType?: unknown;
            n?: unknown;
            initialBowCoef?: unknown;
            dirForBowImp?: unknown;
            mtrlGuid?: unknown;
            concrete?: unknown;
            steel?: unknown;
            timber?: unknown;
            activeBoreholeGuid?: unknown;
        }
        export class Data {
            __proto_name = "ng.beam.Data";
            startNodeGuid: string = "";
            endNodeGuid: string = "";
            segments: ng.beam.Segment[] = [];
            actionType: ng.beam.ActionType = ng.beam.ActionType.ACTION_TYPE_UNSPECIFIED;
            n: ng.geometry.Vector2D | null = null;
            initialBowCoef: number = 0;
            dirForBowImp: ng.beam.BowImperfectionDirectionForBeam = ng.beam.BowImperfectionDirectionForBeam.DIR_UNSPECIFIED;
            mtrlGuid: string = "";
            // this is a one of
            element: {type: 'concrete'; concrete: ng.beam.ConcreteElement} | {type: 'steel'; steel: ng.beam.SteelElement} | {type: 'timber'; timber: ng.beam.TimberElement} | null = null;
            activeBoreholeGuid: string = "";

            /** Gets the `Concrete` value (or null) from the oneof `element` */
            getConcrete(): ng.beam.ConcreteElement | null {
                if(this.element === null) return null;
                if(this.element.type !== 'concrete') return null;
                return this.element.concrete;
            }

            /** Sets the `Concrete` value for the oneof `element`*/
            setConcrete(value: ng.beam.ConcreteElement | null) {
                if(value !== null) {
                    this.element = {type: 'concrete', concrete:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Steel` value (or null) from the oneof `element` */
            getSteel(): ng.beam.SteelElement | null {
                if(this.element === null) return null;
                if(this.element.type !== 'steel') return null;
                return this.element.steel;
            }

            /** Sets the `Steel` value for the oneof `element`*/
            setSteel(value: ng.beam.SteelElement | null) {
                if(value !== null) {
                    this.element = {type: 'steel', steel:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Timber` value (or null) from the oneof `element` */
            getTimber(): ng.beam.TimberElement | null {
                if(this.element === null) return null;
                if(this.element.type !== 'timber') return null;
                return this.element.timber;
            }

            /** Sets the `Timber` value for the oneof `element`*/
            setTimber(value: ng.beam.TimberElement | null) {
                if(value !== null) {
                    this.element = {type: 'timber', timber:value};
                }
                else {
                    this.element = null;
                }
            }

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.startNodeGuid !== undefined && src.startNodeGuid !== null) {
                    if (typeof src.startNodeGuid === "string") {
                        dst.startNodeGuid = src.startNodeGuid;
                    }
                    else {
                        console.log('Expected startNodeGuid of Data to be a string but was ', typeof src.startNodeGuid, src.startNodeGuid)
                    }
                }
                if (src.endNodeGuid !== undefined && src.endNodeGuid !== null) {
                    if (typeof src.endNodeGuid === "string") {
                        dst.endNodeGuid = src.endNodeGuid;
                    }
                    else {
                        console.log('Expected endNodeGuid of Data to be a string but was ', typeof src.endNodeGuid, src.endNodeGuid)
                    }
                }
                if (src.segments !== undefined && src.segments !== null) {
                    if (Array.isArray(src.segments)) {
                        for (const element of src.segments) {
                            dst.segments.push(ng.beam.Segment.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected segments of Data to be a array but was ', typeof src.segments, src.segments)
                    }
                }
                if (src.actionType !== undefined && src.actionType !== null) {
                    dst.actionType = ng.beam.ActionType_FromObject(src.actionType);
                }
                if (src.n !== undefined && src.n !== null) {
                    dst.n = ng.geometry.Vector2D.fromObject(src.n);
                }
                if (src.initialBowCoef !== undefined && src.initialBowCoef !== null) {
                    if (typeof src.initialBowCoef === "number" || src.initialBowCoef === 'NaN' || src.initialBowCoef === 'Infinity' || src.initialBowCoef === '-Infinity') {
                        dst.initialBowCoef = AsNum(src.initialBowCoef);
                    }
                    else {
                        console.log('Expected initialBowCoef of Data to be a number but was ', typeof src.initialBowCoef, src.initialBowCoef)
                    }
                }
                if (src.dirForBowImp !== undefined && src.dirForBowImp !== null) {
                    dst.dirForBowImp = ng.beam.BowImperfectionDirectionForBeam_FromObject(src.dirForBowImp);
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of Data to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                if (src.concrete !== undefined && src.concrete !== null) {
                    dst.setConcrete(ng.beam.ConcreteElement.fromObject(src.concrete));
                }
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(ng.beam.SteelElement.fromObject(src.steel));
                }
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(ng.beam.TimberElement.fromObject(src.timber));
                }
                if (src.activeBoreholeGuid !== undefined && src.activeBoreholeGuid !== null) {
                    if (typeof src.activeBoreholeGuid === "string") {
                        dst.activeBoreholeGuid = src.activeBoreholeGuid;
                    }
                    else {
                        console.log('Expected activeBoreholeGuid of Data to be a string but was ', typeof src.activeBoreholeGuid, src.activeBoreholeGuid)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.beam.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.beam.Data") {
                    console.error('Expected ng.beam.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const actionType_obj = ng.beam.ActionType_ToObject(src.actionType);
                if(actionType_obj === null) return null;

                const dirForBowImp_obj = ng.beam.BowImperfectionDirectionForBeam_ToObject(src.dirForBowImp);
                if(dirForBowImp_obj === null) return null;

                const dst : Data_json = {
                    startNodeGuid: src.startNodeGuid,
                    endNodeGuid: src.endNodeGuid,
                    segments: new Array<ng.beam.Segment_json>(),
                    actionType: actionType_obj,
                    initialBowCoef: AsJsonNum(src.initialBowCoef),
                    dirForBowImp: dirForBowImp_obj,
                    mtrlGuid: src.mtrlGuid,
                    activeBoreholeGuid: src.activeBoreholeGuid,
                };
                if (src.segments !== null) {
                    for (const element of src.segments) {
                        const parsed = ng.beam.Segment.toObject(element);
                        if(parsed === null) return null;
                        dst.segments.push(parsed);
                    }
                }
                if(src.n !== null)
                {
                    const parsed = ng.geometry.Vector2D.toObject(src.n);
                    if(parsed === null) return null;
                    dst.n = parsed;
                }
                const concrete = src.getConcrete();
                if(concrete !== null)
                {
                    const parsed = ng.beam.ConcreteElement.toObject(concrete);
                    if(parsed === null) return null;
                    dst.concrete = parsed;
                }
                const steel = src.getSteel();
                if(steel !== null)
                {
                    const parsed = ng.beam.SteelElement.toObject(steel);
                    if(parsed === null) return null;
                    dst.steel = parsed;
                }
                const timber = src.getTimber();
                if(timber !== null)
                {
                    const parsed = ng.beam.TimberElement.toObject(timber);
                    if(parsed === null) return null;
                    dst.timber = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.startNodeGuid !== undefined) {
                    dst.startNodeGuid = src.startNodeGuid;
                }
                if (src.endNodeGuid !== undefined) {
                    dst.endNodeGuid = src.endNodeGuid;
                }
                if (src.segments !== undefined) {
                    dst.segments = src.segments;
                }
                if (src.actionType !== undefined) {
                    dst.actionType = src.actionType;
                }
                if (src.n !== undefined) {
                    dst.n = src.n;
                }
                if (src.initialBowCoef !== undefined) {
                    dst.initialBowCoef = src.initialBowCoef;
                }
                if (src.dirForBowImp !== undefined) {
                    dst.dirForBowImp = src.dirForBowImp;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                // part of the element oneof 
                if (src.concrete !== undefined && src.concrete !== null) {
                    dst.setConcrete(src.concrete);
                }
                // part of the element oneof 
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(src.steel);
                }
                // part of the element oneof 
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(src.timber);
                }
                if (src.activeBoreholeGuid !== undefined) {
                    dst.activeBoreholeGuid = src.activeBoreholeGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.startNodeGuid = this.startNodeGuid;
                dst.endNodeGuid = this.endNodeGuid;
                dst.segments = this.segments;
                dst.actionType = this.actionType;
                dst.n = this.n;
                dst.initialBowCoef = this.initialBowCoef;
                dst.dirForBowImp = this.dirForBowImp;
                dst.mtrlGuid = this.mtrlGuid;
                dst.element = this.element;
                dst.activeBoreholeGuid = this.activeBoreholeGuid;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;


        // Defined in Geometry/beam.proto
        export namespace ConcreteElement {
            export type Topping_keys = 'segments' | 'mtrlGuid' | 'rebars' | 'strands' | 'links';
            export interface Topping_createType {
                segments?: ng.beam.ConcreteElement.Topping.Segment[],
                mtrlGuid?: string,
                rebars?: ng.rebar.Data | null,
                strands?: ng.strand.Data | null,
                links?: ng.link.Data | null,
            }
            export interface Topping_json {
                segments: ng.beam.ConcreteElement.Topping.Segment_json[];
                mtrlGuid?: string;
                rebars?: ng.rebar.Data_json;
                strands?: ng.strand.Data_json;
                links?: ng.link.Data_json;
            }
            interface Topping_json_in {
                __proto_name?: unknown;
                segments?: unknown;
                mtrlGuid?: unknown;
                rebars?: unknown;
                strands?: unknown;
                links?: unknown;
            }
            export class Topping {
                __proto_name = "ng.beam.ConcreteElement.Topping";
                segments: ng.beam.ConcreteElement.Topping.Segment[] = [];
                mtrlGuid: string = "";
                rebars: ng.rebar.Data | null = null;
                strands: ng.strand.Data | null = null;
                links: ng.link.Data | null = null;

                static fromObject(src_unknown: unknown): Topping {
                    const dst = new Topping();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Topping but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Topping_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Topping but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.segments !== undefined && src.segments !== null) {
                        if (Array.isArray(src.segments)) {
                            for (const element of src.segments) {
                                dst.segments.push(ng.beam.ConcreteElement.Topping.Segment.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected segments of Topping to be a array but was ', typeof src.segments, src.segments)
                        }
                    }
                    if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                        if (typeof src.mtrlGuid === "string") {
                            dst.mtrlGuid = src.mtrlGuid;
                        }
                        else {
                            console.log('Expected mtrlGuid of Topping to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                        }
                    }
                    if (src.rebars !== undefined && src.rebars !== null) {
                        dst.rebars = ng.rebar.Data.fromObject(src.rebars);
                    }
                    if (src.strands !== undefined && src.strands !== null) {
                        dst.strands = ng.strand.Data.fromObject(src.strands);
                    }
                    if (src.links !== undefined && src.links !== null) {
                        dst.links = ng.link.Data.fromObject(src.links);
                    }
                    return dst;
                }

                static toObject(src: Topping | null | undefined): Topping_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.beam.ConcreteElement.Topping is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.beam.ConcreteElement.Topping") {
                        console.error('Expected ng.beam.ConcreteElement.Topping but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Topping_json = {
                        segments: new Array<ng.beam.ConcreteElement.Topping.Segment_json>(),
                        mtrlGuid: src.mtrlGuid,
                    };
                    if (src.segments !== null) {
                        for (const element of src.segments) {
                            const parsed = ng.beam.ConcreteElement.Topping.Segment.toObject(element);
                            if(parsed === null) return null;
                            dst.segments.push(parsed);
                        }
                    }
                    if(src.rebars !== null)
                    {
                        const parsed = ng.rebar.Data.toObject(src.rebars);
                        if(parsed === null) return null;
                        dst.rebars = parsed;
                    }
                    if(src.strands !== null)
                    {
                        const parsed = ng.strand.Data.toObject(src.strands);
                        if(parsed === null) return null;
                        dst.strands = parsed;
                    }
                    if(src.links !== null)
                    {
                        const parsed = ng.link.Data.toObject(src.links);
                        if(parsed === null) return null;
                        dst.links = parsed;
                    }
                    return dst;
                }

                static create(src?: Topping_createType) {
                    const dst = new Topping();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.segments !== undefined) {
                        dst.segments = src.segments;
                    }
                    if (src.mtrlGuid !== undefined) {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    if (src.rebars !== undefined) {
                        dst.rebars = src.rebars;
                    }
                    if (src.strands !== undefined) {
                        dst.strands = src.strands;
                    }
                    if (src.links !== undefined) {
                        dst.links = src.links;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Topping();
                    dst.segments = this.segments;
                    dst.mtrlGuid = this.mtrlGuid;
                    dst.rebars = this.rebars;
                    dst.strands = this.strands;
                    dst.links = this.links;
                    return dst;
                }

                deepClone() {
                    const json = Topping.toObject(this);
                    const dst = Topping.fromObject(json);
                    return dst;
                }
            }
            export type ITopping = Topping;


            // Defined in Geometry/beam.proto
            export namespace Topping {
                export type Segment_keys = 'length' | 'layer' | 'active';
                export interface Segment_createType {
                    length?: number,
                    layer?: ng.beam.Layer | null,
                    active?: boolean,
                }
                export interface Segment_json {
                    length?: JsonNumber;
                    layer?: ng.beam.Layer_json;
                    active?: boolean;
                }
                interface Segment_json_in {
                    __proto_name?: unknown;
                    length?: unknown;
                    layer?: unknown;
                    active?: unknown;
                }
                export class Segment {
                    __proto_name = "ng.beam.ConcreteElement.Topping.Segment";
                    length: number = 0;
                    layer: ng.beam.Layer | null = null;
                    active: boolean = false;

                    static fromObject(src_unknown: unknown): Segment {
                        const dst = new Segment();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted Segment but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as Segment_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for Segment but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.length !== undefined && src.length !== null) {
                            if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                                dst.length = AsNum(src.length);
                            }
                            else {
                                console.log('Expected length of Segment to be a number but was ', typeof src.length, src.length)
                            }
                        }
                        if (src.layer !== undefined && src.layer !== null) {
                            dst.layer = ng.beam.Layer.fromObject(src.layer);
                        }
                        if (src.active !== undefined && src.active !== null) {
                            if (typeof src.active === "boolean") {
                                dst.active = src.active;
                            }
                            else {
                                console.log('Expected active of Segment to be a boolean but was ', typeof src.active, src.active)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: Segment | null | undefined): Segment_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.beam.ConcreteElement.Topping.Segment is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.beam.ConcreteElement.Topping.Segment") {
                            console.error('Expected ng.beam.ConcreteElement.Topping.Segment but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : Segment_json = {
                            length: AsJsonNum(src.length),
                            active: src.active,
                        };
                        if(src.layer !== null)
                        {
                            const parsed = ng.beam.Layer.toObject(src.layer);
                            if(parsed === null) return null;
                            dst.layer = parsed;
                        }
                        return dst;
                    }

                    static create(src?: Segment_createType) {
                        const dst = new Segment();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.length !== undefined) {
                            dst.length = src.length;
                        }
                        if (src.layer !== undefined) {
                            dst.layer = src.layer;
                        }
                        if (src.active !== undefined) {
                            dst.active = src.active;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new Segment();
                        dst.length = this.length;
                        dst.layer = this.layer;
                        dst.active = this.active;
                        return dst;
                    }

                    deepClone() {
                        const json = Segment.toObject(this);
                        const dst = Segment.fromObject(json);
                        return dst;
                    }
                }
                export type ISegment = Segment;
            } // namespace Topping
        } // namespace ConcreteElement


        // Defined in Geometry/beam.proto
        export namespace BucklingRes {
            export type mode_keys = 'v' | 'r';
            export interface mode_createType {
                v?: number[],
                r?: number[],
            }
            export interface mode_json {
                v: JsonNumber[];
                r: JsonNumber[];
            }
            interface mode_json_in {
                __proto_name?: unknown;
                v?: unknown;
                r?: unknown;
            }
            export class mode {
                __proto_name = "ng.beam.BucklingRes.mode";
                v: number[] = [];
                r: number[] = [];

                static fromObject(src_unknown: unknown): mode {
                    const dst = new mode();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted mode but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as mode_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for mode but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.v !== undefined && src.v !== null) {
                        if (Array.isArray(src.v)) {
                            for (const [index, element] of src.v.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.v.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected v of mode[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected v of mode to be a array but was ', typeof src.v, src.v)
                        }
                    }
                    if (src.r !== undefined && src.r !== null) {
                        if (Array.isArray(src.r)) {
                            for (const [index, element] of src.r.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.r.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected r of mode[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected r of mode to be a array but was ', typeof src.r, src.r)
                        }
                    }
                    return dst;
                }

                static toObject(src: mode | null | undefined): mode_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.beam.BucklingRes.mode is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.beam.BucklingRes.mode") {
                        console.error('Expected ng.beam.BucklingRes.mode but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : mode_json = {
                        v: new Array<JsonNumber>(),
                        r: new Array<JsonNumber>(),
                    };
                    if (src.v !== null) {
                        for (const element of src.v) {
                            dst.v.push(AsJsonNum(element));
                        }
                    }
                    if (src.r !== null) {
                        for (const element of src.r) {
                            dst.r.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: mode_createType) {
                    const dst = new mode();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.v !== undefined) {
                        dst.v = src.v;
                    }
                    if (src.r !== undefined) {
                        dst.r = src.r;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new mode();
                    dst.v = this.v;
                    dst.r = this.r;
                    return dst;
                }

                deepClone() {
                    const json = mode.toObject(this);
                    const dst = mode.fromObject(json);
                    return dst;
                }
            }
            export type Imode = mode;
        } // namespace BucklingRes
    } // namespace beam


    // Defined in 7 files
    export namespace design {
        // defined in Design/design.proto
        export type ElementDesignSettings_keys = 'load' | 'rc' | 'steel' | 'timber' | 'soil' | 'general';
        export interface ElementDesignSettings_createType {
            load?: ng.design.concrete.ElementDesignSettings | null,
            rc?: ng.design.concrete.ElementDesignSettings | null,
            steel?: ng.design.steel.ElementDesignSettings | null,
            timber?: ng.design.timber.ElementDesignSettings | null,
            soil?: ng.design.soil.ElementDesignSettings | null,
            general?: ng.design.general.ElementDesignSettings | null,
        }
        export interface ElementDesignSettings_json {
            load?: ng.design.concrete.ElementDesignSettings_json;
            rc?: ng.design.concrete.ElementDesignSettings_json;
            steel?: ng.design.steel.ElementDesignSettings_json;
            timber?: ng.design.timber.ElementDesignSettings_json;
            soil?: ng.design.soil.ElementDesignSettings_json;
            general?: ng.design.general.ElementDesignSettings_json;
        }
        interface ElementDesignSettings_json_in {
            __proto_name?: unknown;
            load?: unknown;
            rc?: unknown;
            steel?: unknown;
            timber?: unknown;
            soil?: unknown;
            general?: unknown;
        }
        export class ElementDesignSettings {
            __proto_name = "ng.design.ElementDesignSettings";
            load: ng.design.concrete.ElementDesignSettings | null = null;
            rc: ng.design.concrete.ElementDesignSettings | null = null;
            steel: ng.design.steel.ElementDesignSettings | null = null;
            timber: ng.design.timber.ElementDesignSettings | null = null;
            soil: ng.design.soil.ElementDesignSettings | null = null;
            general: ng.design.general.ElementDesignSettings | null = null;

            static fromObject(src_unknown: unknown): ElementDesignSettings {
                const dst = new ElementDesignSettings();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ElementDesignSettings but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ElementDesignSettings_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ElementDesignSettings but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.load !== undefined && src.load !== null) {
                    dst.load = ng.design.concrete.ElementDesignSettings.fromObject(src.load);
                }
                if (src.rc !== undefined && src.rc !== null) {
                    dst.rc = ng.design.concrete.ElementDesignSettings.fromObject(src.rc);
                }
                if (src.steel !== undefined && src.steel !== null) {
                    dst.steel = ng.design.steel.ElementDesignSettings.fromObject(src.steel);
                }
                if (src.timber !== undefined && src.timber !== null) {
                    dst.timber = ng.design.timber.ElementDesignSettings.fromObject(src.timber);
                }
                if (src.soil !== undefined && src.soil !== null) {
                    dst.soil = ng.design.soil.ElementDesignSettings.fromObject(src.soil);
                }
                if (src.general !== undefined && src.general !== null) {
                    dst.general = ng.design.general.ElementDesignSettings.fromObject(src.general);
                }
                return dst;
            }

            static toObject(src: ElementDesignSettings | null | undefined): ElementDesignSettings_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.design.ElementDesignSettings is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.design.ElementDesignSettings") {
                    console.error('Expected ng.design.ElementDesignSettings but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ElementDesignSettings_json = {
                };
                if(src.load !== null)
                {
                    const parsed = ng.design.concrete.ElementDesignSettings.toObject(src.load);
                    if(parsed === null) return null;
                    dst.load = parsed;
                }
                if(src.rc !== null)
                {
                    const parsed = ng.design.concrete.ElementDesignSettings.toObject(src.rc);
                    if(parsed === null) return null;
                    dst.rc = parsed;
                }
                if(src.steel !== null)
                {
                    const parsed = ng.design.steel.ElementDesignSettings.toObject(src.steel);
                    if(parsed === null) return null;
                    dst.steel = parsed;
                }
                if(src.timber !== null)
                {
                    const parsed = ng.design.timber.ElementDesignSettings.toObject(src.timber);
                    if(parsed === null) return null;
                    dst.timber = parsed;
                }
                if(src.soil !== null)
                {
                    const parsed = ng.design.soil.ElementDesignSettings.toObject(src.soil);
                    if(parsed === null) return null;
                    dst.soil = parsed;
                }
                if(src.general !== null)
                {
                    const parsed = ng.design.general.ElementDesignSettings.toObject(src.general);
                    if(parsed === null) return null;
                    dst.general = parsed;
                }
                return dst;
            }

            static create(src?: ElementDesignSettings_createType) {
                const dst = new ElementDesignSettings();
                if (src === undefined) {
                    return dst;
                }
                if (src.load !== undefined) {
                    dst.load = src.load;
                }
                if (src.rc !== undefined) {
                    dst.rc = src.rc;
                }
                if (src.steel !== undefined) {
                    dst.steel = src.steel;
                }
                if (src.timber !== undefined) {
                    dst.timber = src.timber;
                }
                if (src.soil !== undefined) {
                    dst.soil = src.soil;
                }
                if (src.general !== undefined) {
                    dst.general = src.general;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ElementDesignSettings();
                dst.load = this.load;
                dst.rc = this.rc;
                dst.steel = this.steel;
                dst.timber = this.timber;
                dst.soil = this.soil;
                dst.general = this.general;
                return dst;
            }

            deepClone() {
                const json = ElementDesignSettings.toObject(this);
                const dst = ElementDesignSettings.fromObject(json);
                return dst;
            }
        }
        export type IElementDesignSettings = ElementDesignSettings;


        // defined in Design/design.proto
        export type GeneralDesignSettings_keys = 'load' | 'rc' | 'steel' | 'timber' | 'soil' | 'general';
        export interface GeneralDesignSettings_createType {
            load?: ng.design.load.GeneralDesignSettings | null,
            rc?: ng.design.concrete.GeneralDesignSettings | null,
            steel?: ng.design.steel.GeneralDesignSettings | null,
            timber?: ng.design.timber.GeneralDesignSettings | null,
            soil?: ng.design.soil.GeneralDesignSettings | null,
            general?: ng.design.general.GeneralDesignSettings | null,
        }
        export interface GeneralDesignSettings_json {
            load?: ng.design.load.GeneralDesignSettings_json;
            rc?: ng.design.concrete.GeneralDesignSettings_json;
            steel?: ng.design.steel.GeneralDesignSettings_json;
            timber?: ng.design.timber.GeneralDesignSettings_json;
            soil?: ng.design.soil.GeneralDesignSettings_json;
            general?: ng.design.general.GeneralDesignSettings_json;
        }
        interface GeneralDesignSettings_json_in {
            __proto_name?: unknown;
            load?: unknown;
            rc?: unknown;
            steel?: unknown;
            timber?: unknown;
            soil?: unknown;
            general?: unknown;
        }
        export class GeneralDesignSettings {
            __proto_name = "ng.design.GeneralDesignSettings";
            load: ng.design.load.GeneralDesignSettings | null = null;
            rc: ng.design.concrete.GeneralDesignSettings | null = null;
            steel: ng.design.steel.GeneralDesignSettings | null = null;
            timber: ng.design.timber.GeneralDesignSettings | null = null;
            soil: ng.design.soil.GeneralDesignSettings | null = null;
            general: ng.design.general.GeneralDesignSettings | null = null;

            static fromObject(src_unknown: unknown): GeneralDesignSettings {
                const dst = new GeneralDesignSettings();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted GeneralDesignSettings but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as GeneralDesignSettings_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for GeneralDesignSettings but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.load !== undefined && src.load !== null) {
                    dst.load = ng.design.load.GeneralDesignSettings.fromObject(src.load);
                }
                if (src.rc !== undefined && src.rc !== null) {
                    dst.rc = ng.design.concrete.GeneralDesignSettings.fromObject(src.rc);
                }
                if (src.steel !== undefined && src.steel !== null) {
                    dst.steel = ng.design.steel.GeneralDesignSettings.fromObject(src.steel);
                }
                if (src.timber !== undefined && src.timber !== null) {
                    dst.timber = ng.design.timber.GeneralDesignSettings.fromObject(src.timber);
                }
                if (src.soil !== undefined && src.soil !== null) {
                    dst.soil = ng.design.soil.GeneralDesignSettings.fromObject(src.soil);
                }
                if (src.general !== undefined && src.general !== null) {
                    dst.general = ng.design.general.GeneralDesignSettings.fromObject(src.general);
                }
                return dst;
            }

            static toObject(src: GeneralDesignSettings | null | undefined): GeneralDesignSettings_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.design.GeneralDesignSettings is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.design.GeneralDesignSettings") {
                    console.error('Expected ng.design.GeneralDesignSettings but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : GeneralDesignSettings_json = {
                };
                if(src.load !== null)
                {
                    const parsed = ng.design.load.GeneralDesignSettings.toObject(src.load);
                    if(parsed === null) return null;
                    dst.load = parsed;
                }
                if(src.rc !== null)
                {
                    const parsed = ng.design.concrete.GeneralDesignSettings.toObject(src.rc);
                    if(parsed === null) return null;
                    dst.rc = parsed;
                }
                if(src.steel !== null)
                {
                    const parsed = ng.design.steel.GeneralDesignSettings.toObject(src.steel);
                    if(parsed === null) return null;
                    dst.steel = parsed;
                }
                if(src.timber !== null)
                {
                    const parsed = ng.design.timber.GeneralDesignSettings.toObject(src.timber);
                    if(parsed === null) return null;
                    dst.timber = parsed;
                }
                if(src.soil !== null)
                {
                    const parsed = ng.design.soil.GeneralDesignSettings.toObject(src.soil);
                    if(parsed === null) return null;
                    dst.soil = parsed;
                }
                if(src.general !== null)
                {
                    const parsed = ng.design.general.GeneralDesignSettings.toObject(src.general);
                    if(parsed === null) return null;
                    dst.general = parsed;
                }
                return dst;
            }

            static create(src?: GeneralDesignSettings_createType) {
                const dst = new GeneralDesignSettings();
                if (src === undefined) {
                    return dst;
                }
                if (src.load !== undefined) {
                    dst.load = src.load;
                }
                if (src.rc !== undefined) {
                    dst.rc = src.rc;
                }
                if (src.steel !== undefined) {
                    dst.steel = src.steel;
                }
                if (src.timber !== undefined) {
                    dst.timber = src.timber;
                }
                if (src.soil !== undefined) {
                    dst.soil = src.soil;
                }
                if (src.general !== undefined) {
                    dst.general = src.general;
                }
                return dst;
            }

            shallowClone() {
                const dst = new GeneralDesignSettings();
                dst.load = this.load;
                dst.rc = this.rc;
                dst.steel = this.steel;
                dst.timber = this.timber;
                dst.soil = this.soil;
                dst.general = this.general;
                return dst;
            }

            deepClone() {
                const json = GeneralDesignSettings.toObject(this);
                const dst = GeneralDesignSettings.fromObject(json);
                return dst;
            }
        }
        export type IGeneralDesignSettings = GeneralDesignSettings;


        // Defined in Design/steel.proto
        export namespace steel {
            export enum LateralTorsionalMethod {
                LATERAL_TORSIONAL_METHOD_UNSPECIFIED = 0,
                LATERAL_TORSIONAL_METHOD_GENERAL = 1,
                LATERAL_TORSIONAL_METHOD_GENERAL_SPEC_FOR_I = 2,
                LATERAL_TORSIONAL_METHOD_SIMPLIFIED = 3
            }
            export const LateralTorsionalMethod_FromObject = (src: unknown): LateralTorsionalMethod => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'LATERAL_TORSIONAL_METHOD_UNSPECIFIED':
                        return LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_UNSPECIFIED;
                    case 1:
                    case 'LATERAL_TORSIONAL_METHOD_GENERAL':
                        return LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_GENERAL;
                    case 2:
                    case 'LATERAL_TORSIONAL_METHOD_GENERAL_SPEC_FOR_I':
                        return LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_GENERAL_SPEC_FOR_I;
                    case 3:
                    case 'LATERAL_TORSIONAL_METHOD_SIMPLIFIED':
                        return LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_SIMPLIFIED;
                    default:
                        console.log('Unhandled value for LateralTorsionalMethod:' + src + '. ' + typeof(src));
                        return LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_UNSPECIFIED;
                }
            };
            export const LateralTorsionalMethod_ToObject = (src: LateralTorsionalMethod): string | null => {
                switch (src) {
                    case LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_UNSPECIFIED:
                        return 'LATERAL_TORSIONAL_METHOD_UNSPECIFIED';
                    case LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_GENERAL:
                        return 'LATERAL_TORSIONAL_METHOD_GENERAL';
                    case LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_GENERAL_SPEC_FOR_I:
                        return 'LATERAL_TORSIONAL_METHOD_GENERAL_SPEC_FOR_I';
                    case LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_SIMPLIFIED:
                        return 'LATERAL_TORSIONAL_METHOD_SIMPLIFIED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for LateralTorsionalMethod, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SectionExposure {
                SECTION_EXPOSURE_UNSPECIFIED = 0,
                SECTION_EXPOSURE_ALL_SIDES = 1,
                SECTION_EXPOSURE_THREE_SIDES = 2,
                SECTION_EXPOSURE_FLANGE_ONLY = 3
            }
            export const SectionExposure_FromObject = (src: unknown): SectionExposure => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SECTION_EXPOSURE_UNSPECIFIED':
                        return SectionExposure.SECTION_EXPOSURE_UNSPECIFIED;
                    case 1:
                    case 'SECTION_EXPOSURE_ALL_SIDES':
                        return SectionExposure.SECTION_EXPOSURE_ALL_SIDES;
                    case 2:
                    case 'SECTION_EXPOSURE_THREE_SIDES':
                        return SectionExposure.SECTION_EXPOSURE_THREE_SIDES;
                    case 3:
                    case 'SECTION_EXPOSURE_FLANGE_ONLY':
                        return SectionExposure.SECTION_EXPOSURE_FLANGE_ONLY;
                    default:
                        console.log('Unhandled value for SectionExposure:' + src + '. ' + typeof(src));
                        return SectionExposure.SECTION_EXPOSURE_UNSPECIFIED;
                }
            };
            export const SectionExposure_ToObject = (src: SectionExposure): string | null => {
                switch (src) {
                    case SectionExposure.SECTION_EXPOSURE_UNSPECIFIED:
                        return 'SECTION_EXPOSURE_UNSPECIFIED';
                    case SectionExposure.SECTION_EXPOSURE_ALL_SIDES:
                        return 'SECTION_EXPOSURE_ALL_SIDES';
                    case SectionExposure.SECTION_EXPOSURE_THREE_SIDES:
                        return 'SECTION_EXPOSURE_THREE_SIDES';
                    case SectionExposure.SECTION_EXPOSURE_FLANGE_ONLY:
                        return 'SECTION_EXPOSURE_FLANGE_ONLY';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SectionExposure, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum InteractionMethod {
                INTERACTION_METHOD_UNSPECIFIED = 0,
                INTERACTION_METHOD_METHOD1 = 1,
                INTERACTION_METHOD_METHOD2 = 2
            }
            export const InteractionMethod_FromObject = (src: unknown): InteractionMethod => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'INTERACTION_METHOD_UNSPECIFIED':
                        return InteractionMethod.INTERACTION_METHOD_UNSPECIFIED;
                    case 1:
                    case 'INTERACTION_METHOD_METHOD1':
                        return InteractionMethod.INTERACTION_METHOD_METHOD1;
                    case 2:
                    case 'INTERACTION_METHOD_METHOD2':
                        return InteractionMethod.INTERACTION_METHOD_METHOD2;
                    default:
                        console.log('Unhandled value for InteractionMethod:' + src + '. ' + typeof(src));
                        return InteractionMethod.INTERACTION_METHOD_UNSPECIFIED;
                }
            };
            export const InteractionMethod_ToObject = (src: InteractionMethod): string | null => {
                switch (src) {
                    case InteractionMethod.INTERACTION_METHOD_UNSPECIFIED:
                        return 'INTERACTION_METHOD_UNSPECIFIED';
                    case InteractionMethod.INTERACTION_METHOD_METHOD1:
                        return 'INTERACTION_METHOD_METHOD1';
                    case InteractionMethod.INTERACTION_METHOD_METHOD2:
                        return 'INTERACTION_METHOD_METHOD2';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for InteractionMethod, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SecondOrderAnalysis {
                SECOND_ORDER_ANALYSIS_UNSPECIFIED = 0,
                SECOND_ORDER_ANALYSIS_IGNORE = 1,
                SECOND_ORDER_ANALYSIS_CONSIDER = 2,
                SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN = 3
            }
            export const SecondOrderAnalysis_FromObject = (src: unknown): SecondOrderAnalysis => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SECOND_ORDER_ANALYSIS_UNSPECIFIED':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED;
                    case 1:
                    case 'SECOND_ORDER_ANALYSIS_IGNORE':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_IGNORE;
                    case 2:
                    case 'SECOND_ORDER_ANALYSIS_CONSIDER':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_CONSIDER;
                    case 3:
                    case 'SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN;
                    default:
                        console.log('Unhandled value for SecondOrderAnalysis:' + src + '. ' + typeof(src));
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED;
                }
            };
            export const SecondOrderAnalysis_ToObject = (src: SecondOrderAnalysis): string | null => {
                switch (src) {
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED:
                        return 'SECOND_ORDER_ANALYSIS_UNSPECIFIED';
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_IGNORE:
                        return 'SECOND_ORDER_ANALYSIS_IGNORE';
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_CONSIDER:
                        return 'SECOND_ORDER_ANALYSIS_CONSIDER';
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN:
                        return 'SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SecondOrderAnalysis, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum BucklingCurveFlexural {
                BUCKLING_CURVE_FLEXURAL_UNSPECIFIED = 0,
                BUCKLING_CURVE_FLEXURAL_AUTO = 1,
                BUCKLING_CURVE_FLEXURAL_A0 = 2,
                BUCKLING_CURVE_FLEXURAL_A = 3,
                BUCKLING_CURVE_FLEXURAL_B = 4,
                BUCKLING_CURVE_FLEXURAL_C = 5,
                BUCKLING_CURVE_FLEXURAL_D = 6
            }
            export const BucklingCurveFlexural_FromObject = (src: unknown): BucklingCurveFlexural => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'BUCKLING_CURVE_FLEXURAL_UNSPECIFIED':
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_UNSPECIFIED;
                    case 1:
                    case 'BUCKLING_CURVE_FLEXURAL_AUTO':
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_AUTO;
                    case 2:
                    case 'BUCKLING_CURVE_FLEXURAL_A0':
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_A0;
                    case 3:
                    case 'BUCKLING_CURVE_FLEXURAL_A':
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_A;
                    case 4:
                    case 'BUCKLING_CURVE_FLEXURAL_B':
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_B;
                    case 5:
                    case 'BUCKLING_CURVE_FLEXURAL_C':
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_C;
                    case 6:
                    case 'BUCKLING_CURVE_FLEXURAL_D':
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_D;
                    default:
                        console.log('Unhandled value for BucklingCurveFlexural:' + src + '. ' + typeof(src));
                        return BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_UNSPECIFIED;
                }
            };
            export const BucklingCurveFlexural_ToObject = (src: BucklingCurveFlexural): string | null => {
                switch (src) {
                    case BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_UNSPECIFIED:
                        return 'BUCKLING_CURVE_FLEXURAL_UNSPECIFIED';
                    case BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_AUTO:
                        return 'BUCKLING_CURVE_FLEXURAL_AUTO';
                    case BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_A0:
                        return 'BUCKLING_CURVE_FLEXURAL_A0';
                    case BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_A:
                        return 'BUCKLING_CURVE_FLEXURAL_A';
                    case BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_B:
                        return 'BUCKLING_CURVE_FLEXURAL_B';
                    case BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_C:
                        return 'BUCKLING_CURVE_FLEXURAL_C';
                    case BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_D:
                        return 'BUCKLING_CURVE_FLEXURAL_D';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for BucklingCurveFlexural, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum BucklingCurveLateral {
                BUCKLING_CURVE_LATERAL_UNSPECIFIED = 0,
                BUCKLING_CURVE_LATERAL_AUTO = 1,
                BUCKLING_CURVE_LATERAL_A = 2,
                BUCKLING_CURVE_LATERAL_B = 3,
                BUCKLING_CURVE_LATERAL_C = 4,
                BUCKLING_CURVE_LATERAL_D = 5
            }
            export const BucklingCurveLateral_FromObject = (src: unknown): BucklingCurveLateral => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'BUCKLING_CURVE_LATERAL_UNSPECIFIED':
                        return BucklingCurveLateral.BUCKLING_CURVE_LATERAL_UNSPECIFIED;
                    case 1:
                    case 'BUCKLING_CURVE_LATERAL_AUTO':
                        return BucklingCurveLateral.BUCKLING_CURVE_LATERAL_AUTO;
                    case 2:
                    case 'BUCKLING_CURVE_LATERAL_A':
                        return BucklingCurveLateral.BUCKLING_CURVE_LATERAL_A;
                    case 3:
                    case 'BUCKLING_CURVE_LATERAL_B':
                        return BucklingCurveLateral.BUCKLING_CURVE_LATERAL_B;
                    case 4:
                    case 'BUCKLING_CURVE_LATERAL_C':
                        return BucklingCurveLateral.BUCKLING_CURVE_LATERAL_C;
                    case 5:
                    case 'BUCKLING_CURVE_LATERAL_D':
                        return BucklingCurveLateral.BUCKLING_CURVE_LATERAL_D;
                    default:
                        console.log('Unhandled value for BucklingCurveLateral:' + src + '. ' + typeof(src));
                        return BucklingCurveLateral.BUCKLING_CURVE_LATERAL_UNSPECIFIED;
                }
            };
            export const BucklingCurveLateral_ToObject = (src: BucklingCurveLateral): string | null => {
                switch (src) {
                    case BucklingCurveLateral.BUCKLING_CURVE_LATERAL_UNSPECIFIED:
                        return 'BUCKLING_CURVE_LATERAL_UNSPECIFIED';
                    case BucklingCurveLateral.BUCKLING_CURVE_LATERAL_AUTO:
                        return 'BUCKLING_CURVE_LATERAL_AUTO';
                    case BucklingCurveLateral.BUCKLING_CURVE_LATERAL_A:
                        return 'BUCKLING_CURVE_LATERAL_A';
                    case BucklingCurveLateral.BUCKLING_CURVE_LATERAL_B:
                        return 'BUCKLING_CURVE_LATERAL_B';
                    case BucklingCurveLateral.BUCKLING_CURVE_LATERAL_C:
                        return 'BUCKLING_CURVE_LATERAL_C';
                    case BucklingCurveLateral.BUCKLING_CURVE_LATERAL_D:
                        return 'BUCKLING_CURVE_LATERAL_D';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for BucklingCurveLateral, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PartialCoefficient_keys = 'gammaM0' | 'gammaM1' | 'gammaM2' | 'gammaM5';
            export interface PartialCoefficient_createType {
                gammaM0?: number,
                gammaM1?: number,
                gammaM2?: number,
                gammaM5?: number,
            }
            export interface PartialCoefficient_json {
                gammaM0?: JsonNumber;
                gammaM1?: JsonNumber;
                gammaM2?: JsonNumber;
                gammaM5?: JsonNumber;
            }
            interface PartialCoefficient_json_in {
                __proto_name?: unknown;
                gammaM0?: unknown;
                gammaM1?: unknown;
                gammaM2?: unknown;
                gammaM5?: unknown;
            }
            export class PartialCoefficient {
                __proto_name = "ng.design.steel.PartialCoefficient";
                gammaM0: number = 0;
                gammaM1: number = 0;
                gammaM2: number = 0;
                gammaM5: number = 0;

                static fromObject(src_unknown: unknown): PartialCoefficient {
                    const dst = new PartialCoefficient();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficient but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficient_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficient but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaM0 !== undefined && src.gammaM0 !== null) {
                        if (typeof src.gammaM0 === "number" || src.gammaM0 === 'NaN' || src.gammaM0 === 'Infinity' || src.gammaM0 === '-Infinity') {
                            dst.gammaM0 = AsNum(src.gammaM0);
                        }
                        else {
                            console.log('Expected gammaM0 of PartialCoefficient to be a number but was ', typeof src.gammaM0, src.gammaM0)
                        }
                    }
                    if (src.gammaM1 !== undefined && src.gammaM1 !== null) {
                        if (typeof src.gammaM1 === "number" || src.gammaM1 === 'NaN' || src.gammaM1 === 'Infinity' || src.gammaM1 === '-Infinity') {
                            dst.gammaM1 = AsNum(src.gammaM1);
                        }
                        else {
                            console.log('Expected gammaM1 of PartialCoefficient to be a number but was ', typeof src.gammaM1, src.gammaM1)
                        }
                    }
                    if (src.gammaM2 !== undefined && src.gammaM2 !== null) {
                        if (typeof src.gammaM2 === "number" || src.gammaM2 === 'NaN' || src.gammaM2 === 'Infinity' || src.gammaM2 === '-Infinity') {
                            dst.gammaM2 = AsNum(src.gammaM2);
                        }
                        else {
                            console.log('Expected gammaM2 of PartialCoefficient to be a number but was ', typeof src.gammaM2, src.gammaM2)
                        }
                    }
                    if (src.gammaM5 !== undefined && src.gammaM5 !== null) {
                        if (typeof src.gammaM5 === "number" || src.gammaM5 === 'NaN' || src.gammaM5 === 'Infinity' || src.gammaM5 === '-Infinity') {
                            dst.gammaM5 = AsNum(src.gammaM5);
                        }
                        else {
                            console.log('Expected gammaM5 of PartialCoefficient to be a number but was ', typeof src.gammaM5, src.gammaM5)
                        }
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficient | null | undefined): PartialCoefficient_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.steel.PartialCoefficient is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.steel.PartialCoefficient") {
                        console.error('Expected ng.design.steel.PartialCoefficient but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficient_json = {
                        gammaM0: AsJsonNum(src.gammaM0),
                        gammaM1: AsJsonNum(src.gammaM1),
                        gammaM2: AsJsonNum(src.gammaM2),
                        gammaM5: AsJsonNum(src.gammaM5),
                    };
                    return dst;
                }

                static create(src?: PartialCoefficient_createType) {
                    const dst = new PartialCoefficient();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaM0 !== undefined) {
                        dst.gammaM0 = src.gammaM0;
                    }
                    if (src.gammaM1 !== undefined) {
                        dst.gammaM1 = src.gammaM1;
                    }
                    if (src.gammaM2 !== undefined) {
                        dst.gammaM2 = src.gammaM2;
                    }
                    if (src.gammaM5 !== undefined) {
                        dst.gammaM5 = src.gammaM5;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficient();
                    dst.gammaM0 = this.gammaM0;
                    dst.gammaM1 = this.gammaM1;
                    dst.gammaM2 = this.gammaM2;
                    dst.gammaM5 = this.gammaM5;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficient.toObject(this);
                    const dst = PartialCoefficient.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficient = PartialCoefficient;


            export type PartialCoefficients_keys = 'ultimate' | 'accidental' | 'gammaFire';
            export interface PartialCoefficients_createType {
                ultimate?: ng.design.steel.PartialCoefficient | null,
                accidental?: ng.design.steel.PartialCoefficient | null,
                gammaFire?: number,
            }
            export interface PartialCoefficients_json {
                ultimate?: ng.design.steel.PartialCoefficient_json;
                accidental?: ng.design.steel.PartialCoefficient_json;
                gammaFire?: JsonNumber;
            }
            interface PartialCoefficients_json_in {
                __proto_name?: unknown;
                ultimate?: unknown;
                accidental?: unknown;
                gammaFire?: unknown;
            }
            export class PartialCoefficients {
                __proto_name = "ng.design.steel.PartialCoefficients";
                ultimate: ng.design.steel.PartialCoefficient | null = null;
                accidental: ng.design.steel.PartialCoefficient | null = null;
                gammaFire: number = 0;

                static fromObject(src_unknown: unknown): PartialCoefficients {
                    const dst = new PartialCoefficients();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficients but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficients_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficients but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ultimate !== undefined && src.ultimate !== null) {
                        dst.ultimate = ng.design.steel.PartialCoefficient.fromObject(src.ultimate);
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        dst.accidental = ng.design.steel.PartialCoefficient.fromObject(src.accidental);
                    }
                    if (src.gammaFire !== undefined && src.gammaFire !== null) {
                        if (typeof src.gammaFire === "number" || src.gammaFire === 'NaN' || src.gammaFire === 'Infinity' || src.gammaFire === '-Infinity') {
                            dst.gammaFire = AsNum(src.gammaFire);
                        }
                        else {
                            console.log('Expected gammaFire of PartialCoefficients to be a number but was ', typeof src.gammaFire, src.gammaFire)
                        }
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficients | null | undefined): PartialCoefficients_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.steel.PartialCoefficients is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.steel.PartialCoefficients") {
                        console.error('Expected ng.design.steel.PartialCoefficients but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficients_json = {
                        gammaFire: AsJsonNum(src.gammaFire),
                    };
                    if(src.ultimate !== null)
                    {
                        const parsed = ng.design.steel.PartialCoefficient.toObject(src.ultimate);
                        if(parsed === null) return null;
                        dst.ultimate = parsed;
                    }
                    if(src.accidental !== null)
                    {
                        const parsed = ng.design.steel.PartialCoefficient.toObject(src.accidental);
                        if(parsed === null) return null;
                        dst.accidental = parsed;
                    }
                    return dst;
                }

                static create(src?: PartialCoefficients_createType) {
                    const dst = new PartialCoefficients();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ultimate !== undefined) {
                        dst.ultimate = src.ultimate;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    if (src.gammaFire !== undefined) {
                        dst.gammaFire = src.gammaFire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficients();
                    dst.ultimate = this.ultimate;
                    dst.accidental = this.accidental;
                    dst.gammaFire = this.gammaFire;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficients.toObject(this);
                    const dst = PartialCoefficients.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficients = PartialCoefficients;


            export type GeneralDesignSettings_keys = 'partialCoeffs' | 'interactionMethod' | 'kappa2' | 'memberSurfaceEmissivityCarbonSteel' | 'memberSurfaceEmissivityStrainlessSteel';
            export interface GeneralDesignSettings_createType {
                partialCoeffs?: ng.design.steel.PartialCoefficients | null,
                interactionMethod?: ng.design.steel.InteractionMethod,
                kappa2?: number,
                memberSurfaceEmissivityCarbonSteel?: number,
                memberSurfaceEmissivityStrainlessSteel?: number,
            }
            export interface GeneralDesignSettings_json {
                partialCoeffs?: ng.design.steel.PartialCoefficients_json;
                interactionMethod?: string;
                kappa2?: JsonNumber;
                memberSurfaceEmissivityCarbonSteel?: JsonNumber;
                memberSurfaceEmissivityStrainlessSteel?: JsonNumber;
            }
            interface GeneralDesignSettings_json_in {
                __proto_name?: unknown;
                partialCoeffs?: unknown;
                interactionMethod?: unknown;
                kappa2?: unknown;
                memberSurfaceEmissivityCarbonSteel?: unknown;
                memberSurfaceEmissivityStrainlessSteel?: unknown;
            }
            export class GeneralDesignSettings {
                __proto_name = "ng.design.steel.GeneralDesignSettings";
                partialCoeffs: ng.design.steel.PartialCoefficients | null = null;
                interactionMethod: ng.design.steel.InteractionMethod = ng.design.steel.InteractionMethod.INTERACTION_METHOD_UNSPECIFIED;
                kappa2: number = 0;
                memberSurfaceEmissivityCarbonSteel: number = 0;
                memberSurfaceEmissivityStrainlessSteel: number = 0;

                static fromObject(src_unknown: unknown): GeneralDesignSettings {
                    const dst = new GeneralDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined && src.partialCoeffs !== null) {
                        dst.partialCoeffs = ng.design.steel.PartialCoefficients.fromObject(src.partialCoeffs);
                    }
                    if (src.interactionMethod !== undefined && src.interactionMethod !== null) {
                        dst.interactionMethod = ng.design.steel.InteractionMethod_FromObject(src.interactionMethod);
                    }
                    if (src.kappa2 !== undefined && src.kappa2 !== null) {
                        if (typeof src.kappa2 === "number" || src.kappa2 === 'NaN' || src.kappa2 === 'Infinity' || src.kappa2 === '-Infinity') {
                            dst.kappa2 = AsNum(src.kappa2);
                        }
                        else {
                            console.log('Expected kappa2 of GeneralDesignSettings to be a number but was ', typeof src.kappa2, src.kappa2)
                        }
                    }
                    if (src.memberSurfaceEmissivityCarbonSteel !== undefined && src.memberSurfaceEmissivityCarbonSteel !== null) {
                        if (typeof src.memberSurfaceEmissivityCarbonSteel === "number" || src.memberSurfaceEmissivityCarbonSteel === 'NaN' || src.memberSurfaceEmissivityCarbonSteel === 'Infinity' || src.memberSurfaceEmissivityCarbonSteel === '-Infinity') {
                            dst.memberSurfaceEmissivityCarbonSteel = AsNum(src.memberSurfaceEmissivityCarbonSteel);
                        }
                        else {
                            console.log('Expected memberSurfaceEmissivityCarbonSteel of GeneralDesignSettings to be a number but was ', typeof src.memberSurfaceEmissivityCarbonSteel, src.memberSurfaceEmissivityCarbonSteel)
                        }
                    }
                    if (src.memberSurfaceEmissivityStrainlessSteel !== undefined && src.memberSurfaceEmissivityStrainlessSteel !== null) {
                        if (typeof src.memberSurfaceEmissivityStrainlessSteel === "number" || src.memberSurfaceEmissivityStrainlessSteel === 'NaN' || src.memberSurfaceEmissivityStrainlessSteel === 'Infinity' || src.memberSurfaceEmissivityStrainlessSteel === '-Infinity') {
                            dst.memberSurfaceEmissivityStrainlessSteel = AsNum(src.memberSurfaceEmissivityStrainlessSteel);
                        }
                        else {
                            console.log('Expected memberSurfaceEmissivityStrainlessSteel of GeneralDesignSettings to be a number but was ', typeof src.memberSurfaceEmissivityStrainlessSteel, src.memberSurfaceEmissivityStrainlessSteel)
                        }
                    }
                    return dst;
                }

                static toObject(src: GeneralDesignSettings | null | undefined): GeneralDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.steel.GeneralDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.steel.GeneralDesignSettings") {
                        console.error('Expected ng.design.steel.GeneralDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const interactionMethod_obj = ng.design.steel.InteractionMethod_ToObject(src.interactionMethod);
                    if(interactionMethod_obj === null) return null;

                    const dst : GeneralDesignSettings_json = {
                        interactionMethod: interactionMethod_obj,
                        kappa2: AsJsonNum(src.kappa2),
                        memberSurfaceEmissivityCarbonSteel: AsJsonNum(src.memberSurfaceEmissivityCarbonSteel),
                        memberSurfaceEmissivityStrainlessSteel: AsJsonNum(src.memberSurfaceEmissivityStrainlessSteel),
                    };
                    if(src.partialCoeffs !== null)
                    {
                        const parsed = ng.design.steel.PartialCoefficients.toObject(src.partialCoeffs);
                        if(parsed === null) return null;
                        dst.partialCoeffs = parsed;
                    }
                    return dst;
                }

                static create(src?: GeneralDesignSettings_createType) {
                    const dst = new GeneralDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined) {
                        dst.partialCoeffs = src.partialCoeffs;
                    }
                    if (src.interactionMethod !== undefined) {
                        dst.interactionMethod = src.interactionMethod;
                    }
                    if (src.kappa2 !== undefined) {
                        dst.kappa2 = src.kappa2;
                    }
                    if (src.memberSurfaceEmissivityCarbonSteel !== undefined) {
                        dst.memberSurfaceEmissivityCarbonSteel = src.memberSurfaceEmissivityCarbonSteel;
                    }
                    if (src.memberSurfaceEmissivityStrainlessSteel !== undefined) {
                        dst.memberSurfaceEmissivityStrainlessSteel = src.memberSurfaceEmissivityStrainlessSteel;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralDesignSettings();
                    dst.partialCoeffs = this.partialCoeffs;
                    dst.interactionMethod = this.interactionMethod;
                    dst.kappa2 = this.kappa2;
                    dst.memberSurfaceEmissivityCarbonSteel = this.memberSurfaceEmissivityCarbonSteel;
                    dst.memberSurfaceEmissivityStrainlessSteel = this.memberSurfaceEmissivityStrainlessSteel;
                    return dst;
                }

                deepClone() {
                    const json = GeneralDesignSettings.toObject(this);
                    const dst = GeneralDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralDesignSettings = GeneralDesignSettings;


            export type BeamSettings_keys = 'secondOrderAnalysis' | 'plasticCalculationNotAllowed' | 'use641' | 'class4NotAllowed' | 'lateralTorsionalMethod' | 'checkResistanceOnly' | 'fbCurveStiff' | 'fbCurveWeak' | 'ftCurve' | 'ltbCurveTop' | 'ltbCurveBtm';
            export interface BeamSettings_createType {
                secondOrderAnalysis?: ng.design.steel.SecondOrderAnalysis,
                plasticCalculationNotAllowed?: boolean,
                use641?: boolean,
                class4NotAllowed?: boolean,
                lateralTorsionalMethod?: ng.design.steel.LateralTorsionalMethod,
                checkResistanceOnly?: boolean,
                fbCurveStiff?: ng.design.steel.BucklingCurveFlexural,
                fbCurveWeak?: ng.design.steel.BucklingCurveFlexural,
                ftCurve?: ng.design.steel.BucklingCurveFlexural,
                ltbCurveTop?: ng.design.steel.BucklingCurveLateral,
                ltbCurveBtm?: ng.design.steel.BucklingCurveLateral,
            }
            export interface BeamSettings_json {
                secondOrderAnalysis?: string;
                plasticCalculationNotAllowed?: boolean;
                use641?: boolean;
                class4NotAllowed?: boolean;
                lateralTorsionalMethod?: string;
                checkResistanceOnly?: boolean;
                fbCurveStiff?: string;
                fbCurveWeak?: string;
                ftCurve?: string;
                ltbCurveTop?: string;
                ltbCurveBtm?: string;
            }
            interface BeamSettings_json_in {
                __proto_name?: unknown;
                secondOrderAnalysis?: unknown;
                plasticCalculationNotAllowed?: unknown;
                use641?: unknown;
                class4NotAllowed?: unknown;
                lateralTorsionalMethod?: unknown;
                checkResistanceOnly?: unknown;
                fbCurveStiff?: unknown;
                fbCurveWeak?: unknown;
                ftCurve?: unknown;
                ltbCurveTop?: unknown;
                ltbCurveBtm?: unknown;
            }
            export class BeamSettings {
                __proto_name = "ng.design.steel.BeamSettings";
                secondOrderAnalysis: ng.design.steel.SecondOrderAnalysis = ng.design.steel.SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED;
                plasticCalculationNotAllowed: boolean = false;
                use641: boolean = false;
                class4NotAllowed: boolean = false;
                lateralTorsionalMethod: ng.design.steel.LateralTorsionalMethod = ng.design.steel.LateralTorsionalMethod.LATERAL_TORSIONAL_METHOD_UNSPECIFIED;
                checkResistanceOnly: boolean = false;
                fbCurveStiff: ng.design.steel.BucklingCurveFlexural = ng.design.steel.BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_UNSPECIFIED;
                fbCurveWeak: ng.design.steel.BucklingCurveFlexural = ng.design.steel.BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_UNSPECIFIED;
                ftCurve: ng.design.steel.BucklingCurveFlexural = ng.design.steel.BucklingCurveFlexural.BUCKLING_CURVE_FLEXURAL_UNSPECIFIED;
                ltbCurveTop: ng.design.steel.BucklingCurveLateral = ng.design.steel.BucklingCurveLateral.BUCKLING_CURVE_LATERAL_UNSPECIFIED;
                ltbCurveBtm: ng.design.steel.BucklingCurveLateral = ng.design.steel.BucklingCurveLateral.BUCKLING_CURVE_LATERAL_UNSPECIFIED;

                static fromObject(src_unknown: unknown): BeamSettings {
                    const dst = new BeamSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BeamSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BeamSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BeamSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.secondOrderAnalysis !== undefined && src.secondOrderAnalysis !== null) {
                        dst.secondOrderAnalysis = ng.design.steel.SecondOrderAnalysis_FromObject(src.secondOrderAnalysis);
                    }
                    if (src.plasticCalculationNotAllowed !== undefined && src.plasticCalculationNotAllowed !== null) {
                        if (typeof src.plasticCalculationNotAllowed === "boolean") {
                            dst.plasticCalculationNotAllowed = src.plasticCalculationNotAllowed;
                        }
                        else {
                            console.log('Expected plasticCalculationNotAllowed of BeamSettings to be a boolean but was ', typeof src.plasticCalculationNotAllowed, src.plasticCalculationNotAllowed)
                        }
                    }
                    if (src.use641 !== undefined && src.use641 !== null) {
                        if (typeof src.use641 === "boolean") {
                            dst.use641 = src.use641;
                        }
                        else {
                            console.log('Expected use641 of BeamSettings to be a boolean but was ', typeof src.use641, src.use641)
                        }
                    }
                    if (src.class4NotAllowed !== undefined && src.class4NotAllowed !== null) {
                        if (typeof src.class4NotAllowed === "boolean") {
                            dst.class4NotAllowed = src.class4NotAllowed;
                        }
                        else {
                            console.log('Expected class4NotAllowed of BeamSettings to be a boolean but was ', typeof src.class4NotAllowed, src.class4NotAllowed)
                        }
                    }
                    if (src.lateralTorsionalMethod !== undefined && src.lateralTorsionalMethod !== null) {
                        dst.lateralTorsionalMethod = ng.design.steel.LateralTorsionalMethod_FromObject(src.lateralTorsionalMethod);
                    }
                    if (src.checkResistanceOnly !== undefined && src.checkResistanceOnly !== null) {
                        if (typeof src.checkResistanceOnly === "boolean") {
                            dst.checkResistanceOnly = src.checkResistanceOnly;
                        }
                        else {
                            console.log('Expected checkResistanceOnly of BeamSettings to be a boolean but was ', typeof src.checkResistanceOnly, src.checkResistanceOnly)
                        }
                    }
                    if (src.fbCurveStiff !== undefined && src.fbCurveStiff !== null) {
                        dst.fbCurveStiff = ng.design.steel.BucklingCurveFlexural_FromObject(src.fbCurveStiff);
                    }
                    if (src.fbCurveWeak !== undefined && src.fbCurveWeak !== null) {
                        dst.fbCurveWeak = ng.design.steel.BucklingCurveFlexural_FromObject(src.fbCurveWeak);
                    }
                    if (src.ftCurve !== undefined && src.ftCurve !== null) {
                        dst.ftCurve = ng.design.steel.BucklingCurveFlexural_FromObject(src.ftCurve);
                    }
                    if (src.ltbCurveTop !== undefined && src.ltbCurveTop !== null) {
                        dst.ltbCurveTop = ng.design.steel.BucklingCurveLateral_FromObject(src.ltbCurveTop);
                    }
                    if (src.ltbCurveBtm !== undefined && src.ltbCurveBtm !== null) {
                        dst.ltbCurveBtm = ng.design.steel.BucklingCurveLateral_FromObject(src.ltbCurveBtm);
                    }
                    return dst;
                }

                static toObject(src: BeamSettings | null | undefined): BeamSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.steel.BeamSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.steel.BeamSettings") {
                        console.error('Expected ng.design.steel.BeamSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const secondOrderAnalysis_obj = ng.design.steel.SecondOrderAnalysis_ToObject(src.secondOrderAnalysis);
                    if(secondOrderAnalysis_obj === null) return null;

                    const lateralTorsionalMethod_obj = ng.design.steel.LateralTorsionalMethod_ToObject(src.lateralTorsionalMethod);
                    if(lateralTorsionalMethod_obj === null) return null;

                    const fbCurveStiff_obj = ng.design.steel.BucklingCurveFlexural_ToObject(src.fbCurveStiff);
                    if(fbCurveStiff_obj === null) return null;

                    const fbCurveWeak_obj = ng.design.steel.BucklingCurveFlexural_ToObject(src.fbCurveWeak);
                    if(fbCurveWeak_obj === null) return null;

                    const ftCurve_obj = ng.design.steel.BucklingCurveFlexural_ToObject(src.ftCurve);
                    if(ftCurve_obj === null) return null;

                    const ltbCurveTop_obj = ng.design.steel.BucklingCurveLateral_ToObject(src.ltbCurveTop);
                    if(ltbCurveTop_obj === null) return null;

                    const ltbCurveBtm_obj = ng.design.steel.BucklingCurveLateral_ToObject(src.ltbCurveBtm);
                    if(ltbCurveBtm_obj === null) return null;

                    const dst : BeamSettings_json = {
                        secondOrderAnalysis: secondOrderAnalysis_obj,
                        plasticCalculationNotAllowed: src.plasticCalculationNotAllowed,
                        use641: src.use641,
                        class4NotAllowed: src.class4NotAllowed,
                        lateralTorsionalMethod: lateralTorsionalMethod_obj,
                        checkResistanceOnly: src.checkResistanceOnly,
                        fbCurveStiff: fbCurveStiff_obj,
                        fbCurveWeak: fbCurveWeak_obj,
                        ftCurve: ftCurve_obj,
                        ltbCurveTop: ltbCurveTop_obj,
                        ltbCurveBtm: ltbCurveBtm_obj,
                    };
                    return dst;
                }

                static create(src?: BeamSettings_createType) {
                    const dst = new BeamSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.secondOrderAnalysis !== undefined) {
                        dst.secondOrderAnalysis = src.secondOrderAnalysis;
                    }
                    if (src.plasticCalculationNotAllowed !== undefined) {
                        dst.plasticCalculationNotAllowed = src.plasticCalculationNotAllowed;
                    }
                    if (src.use641 !== undefined) {
                        dst.use641 = src.use641;
                    }
                    if (src.class4NotAllowed !== undefined) {
                        dst.class4NotAllowed = src.class4NotAllowed;
                    }
                    if (src.lateralTorsionalMethod !== undefined) {
                        dst.lateralTorsionalMethod = src.lateralTorsionalMethod;
                    }
                    if (src.checkResistanceOnly !== undefined) {
                        dst.checkResistanceOnly = src.checkResistanceOnly;
                    }
                    if (src.fbCurveStiff !== undefined) {
                        dst.fbCurveStiff = src.fbCurveStiff;
                    }
                    if (src.fbCurveWeak !== undefined) {
                        dst.fbCurveWeak = src.fbCurveWeak;
                    }
                    if (src.ftCurve !== undefined) {
                        dst.ftCurve = src.ftCurve;
                    }
                    if (src.ltbCurveTop !== undefined) {
                        dst.ltbCurveTop = src.ltbCurveTop;
                    }
                    if (src.ltbCurveBtm !== undefined) {
                        dst.ltbCurveBtm = src.ltbCurveBtm;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BeamSettings();
                    dst.secondOrderAnalysis = this.secondOrderAnalysis;
                    dst.plasticCalculationNotAllowed = this.plasticCalculationNotAllowed;
                    dst.use641 = this.use641;
                    dst.class4NotAllowed = this.class4NotAllowed;
                    dst.lateralTorsionalMethod = this.lateralTorsionalMethod;
                    dst.checkResistanceOnly = this.checkResistanceOnly;
                    dst.fbCurveStiff = this.fbCurveStiff;
                    dst.fbCurveWeak = this.fbCurveWeak;
                    dst.ftCurve = this.ftCurve;
                    dst.ltbCurveTop = this.ltbCurveTop;
                    dst.ltbCurveBtm = this.ltbCurveBtm;
                    return dst;
                }

                deepClone() {
                    const json = BeamSettings.toObject(this);
                    const dst = BeamSettings.fromObject(json);
                    return dst;
                }
            }
            export type IBeamSettings = BeamSettings;


            export type ProtectingMaterial_keys = 'guid' | 'thickness';
            export interface ProtectingMaterial_createType {
                guid?: string,
                thickness?: number,
            }
            export interface ProtectingMaterial_json {
                guid?: string;
                thickness?: JsonNumber;
            }
            interface ProtectingMaterial_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                thickness?: unknown;
            }
            export class ProtectingMaterial {
                __proto_name = "ng.design.steel.ProtectingMaterial";
                guid: string = "";
                thickness: number = 0;

                static fromObject(src_unknown: unknown): ProtectingMaterial {
                    const dst = new ProtectingMaterial();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ProtectingMaterial but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ProtectingMaterial_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ProtectingMaterial but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of ProtectingMaterial to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.thickness !== undefined && src.thickness !== null) {
                        if (typeof src.thickness === "number" || src.thickness === 'NaN' || src.thickness === 'Infinity' || src.thickness === '-Infinity') {
                            dst.thickness = AsNum(src.thickness);
                        }
                        else {
                            console.log('Expected thickness of ProtectingMaterial to be a number but was ', typeof src.thickness, src.thickness)
                        }
                    }
                    return dst;
                }

                static toObject(src: ProtectingMaterial | null | undefined): ProtectingMaterial_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.steel.ProtectingMaterial is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.steel.ProtectingMaterial") {
                        console.error('Expected ng.design.steel.ProtectingMaterial but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ProtectingMaterial_json = {
                        guid: src.guid,
                        thickness: AsJsonNum(src.thickness),
                    };
                    return dst;
                }

                static create(src?: ProtectingMaterial_createType) {
                    const dst = new ProtectingMaterial();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.thickness !== undefined) {
                        dst.thickness = src.thickness;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ProtectingMaterial();
                    dst.guid = this.guid;
                    dst.thickness = this.thickness;
                    return dst;
                }

                deepClone() {
                    const json = ProtectingMaterial.toObject(this);
                    const dst = ProtectingMaterial.fromObject(json);
                    return dst;
                }
            }
            export type IProtectingMaterial = ProtectingMaterial;


            export type Fire_keys = 'critDeflection' | 'protected' | 'protectingMaterial' | 'temperature' | 'sectionExposure';
            export interface Fire_createType {
                critDeflection?: boolean,
                protected?: boolean,
                protectingMaterial?: ng.design.steel.ProtectingMaterial | null,
                temperature?: number,
                sectionExposure?: ng.design.steel.SectionExposure,
            }
            export interface Fire_json {
                critDeflection?: boolean;
                protected?: boolean;
                protectingMaterial?: ng.design.steel.ProtectingMaterial_json;
                temperature?: JsonNumber;
                sectionExposure?: string;
            }
            interface Fire_json_in {
                __proto_name?: unknown;
                critDeflection?: unknown;
                protected?: unknown;
                protectingMaterial?: unknown;
                temperature?: unknown;
                sectionExposure?: unknown;
            }
            export class Fire {
                __proto_name = "ng.design.steel.Fire";
                critDeflection: boolean = false;
                protected: boolean = false;
                // this is a one of
                protection_type: {type: 'protectingMaterial'; protectingMaterial: ng.design.steel.ProtectingMaterial} | {type: 'temperature'; temperature: number} | null = null;
                sectionExposure: ng.design.steel.SectionExposure = ng.design.steel.SectionExposure.SECTION_EXPOSURE_UNSPECIFIED;

                /** Gets the `ProtectingMaterial` value (or null) from the oneof `protection_type` */
                getProtectingMaterial(): ng.design.steel.ProtectingMaterial | null {
                    if(this.protection_type === null) return null;
                    if(this.protection_type.type !== 'protectingMaterial') return null;
                    return this.protection_type.protectingMaterial;
                }

                /** Sets the `ProtectingMaterial` value for the oneof `protection_type`*/
                setProtectingMaterial(value: ng.design.steel.ProtectingMaterial | null) {
                    if(value !== null) {
                        this.protection_type = {type: 'protectingMaterial', protectingMaterial:value};
                    }
                    else {
                        this.protection_type = null;
                    }
                }

                /** Gets the `Temperature` value (or null) from the oneof `protection_type` */
                getTemperature(): number | null {
                    if(this.protection_type === null) return null;
                    if(this.protection_type.type !== 'temperature') return null;
                    return this.protection_type.temperature;
                }

                /** Sets the `Temperature` value for the oneof `protection_type`*/
                setTemperature(value: number | null) {
                    if(value !== null) {
                        this.protection_type = {type: 'temperature', temperature:value};
                    }
                    else {
                        this.protection_type = null;
                    }
                }

                static fromObject(src_unknown: unknown): Fire {
                    const dst = new Fire();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Fire but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Fire_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Fire but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.critDeflection !== undefined && src.critDeflection !== null) {
                        if (typeof src.critDeflection === "boolean") {
                            dst.critDeflection = src.critDeflection;
                        }
                        else {
                            console.log('Expected critDeflection of Fire to be a boolean but was ', typeof src.critDeflection, src.critDeflection)
                        }
                    }
                    if (src.protected !== undefined && src.protected !== null) {
                        if (typeof src.protected === "boolean") {
                            dst.protected = src.protected;
                        }
                        else {
                            console.log('Expected protected of Fire to be a boolean but was ', typeof src.protected, src.protected)
                        }
                    }
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.setProtectingMaterial(ng.design.steel.ProtectingMaterial.fromObject(src.protectingMaterial));
                    }
                    if (src.temperature !== undefined && src.temperature !== null) {
                        if (typeof src.temperature === "number" || src.temperature === 'NaN' || src.temperature === 'Infinity' || src.temperature === '-Infinity') {
                            dst.setTemperature(AsNum(src.temperature));
                        }
                        else {
                            console.log('Expected temperature of Fire to be a number but was ', typeof src.temperature, src.temperature)
                        }
                    }
                    if (src.sectionExposure !== undefined && src.sectionExposure !== null) {
                        dst.sectionExposure = ng.design.steel.SectionExposure_FromObject(src.sectionExposure);
                    }
                    return dst;
                }

                static toObject(src: Fire | null | undefined): Fire_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.steel.Fire is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.steel.Fire") {
                        console.error('Expected ng.design.steel.Fire but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const sectionExposure_obj = ng.design.steel.SectionExposure_ToObject(src.sectionExposure);
                    if(sectionExposure_obj === null) return null;

                    const dst : Fire_json = {
                        critDeflection: src.critDeflection,
                        protected: src.protected,
                        sectionExposure: sectionExposure_obj,
                    };
                    const protectingMaterial = src.getProtectingMaterial();
                    if(protectingMaterial !== null)
                    {
                        const parsed = ng.design.steel.ProtectingMaterial.toObject(protectingMaterial);
                        if(parsed === null) return null;
                        dst.protectingMaterial = parsed;
                    }
                    const temperature = src.getTemperature();
                    if(temperature !== null)
                    {
                        const parsed = AsJsonNum(temperature);
                        if(parsed === null) return null;
                        dst.temperature = parsed;
                    }
                    return dst;
                }

                static create(src?: Fire_createType) {
                    const dst = new Fire();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.critDeflection !== undefined) {
                        dst.critDeflection = src.critDeflection;
                    }
                    if (src.protected !== undefined) {
                        dst.protected = src.protected;
                    }
                    // part of the protection_type oneof 
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.setProtectingMaterial(src.protectingMaterial);
                    }
                    // part of the protection_type oneof 
                    if (src.temperature !== undefined && src.temperature !== null) {
                        dst.setTemperature(src.temperature);
                    }
                    if (src.sectionExposure !== undefined) {
                        dst.sectionExposure = src.sectionExposure;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Fire();
                    dst.critDeflection = this.critDeflection;
                    dst.protected = this.protected;
                    dst.protection_type = this.protection_type;
                    dst.sectionExposure = this.sectionExposure;
                    return dst;
                }

                deepClone() {
                    const json = Fire.toObject(this);
                    const dst = Fire.fromObject(json);
                    return dst;
                }
            }
            export type IFire = Fire;


            export type ElementDesignSettings_keys = 'beam' | 'fire';
            export interface ElementDesignSettings_createType {
                beam?: ng.design.steel.BeamSettings | null,
                fire?: ng.design.steel.Fire | null,
            }
            export interface ElementDesignSettings_json {
                beam?: ng.design.steel.BeamSettings_json;
                fire?: ng.design.steel.Fire_json;
            }
            interface ElementDesignSettings_json_in {
                __proto_name?: unknown;
                beam?: unknown;
                fire?: unknown;
            }
            export class ElementDesignSettings {
                __proto_name = "ng.design.steel.ElementDesignSettings";
                beam: ng.design.steel.BeamSettings | null = null;
                fire: ng.design.steel.Fire | null = null;

                static fromObject(src_unknown: unknown): ElementDesignSettings {
                    const dst = new ElementDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ElementDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ElementDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ElementDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.beam = ng.design.steel.BeamSettings.fromObject(src.beam);
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.steel.Fire.fromObject(src.fire);
                    }
                    return dst;
                }

                static toObject(src: ElementDesignSettings | null | undefined): ElementDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.steel.ElementDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.steel.ElementDesignSettings") {
                        console.error('Expected ng.design.steel.ElementDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ElementDesignSettings_json = {
                    };
                    if(src.beam !== null)
                    {
                        const parsed = ng.design.steel.BeamSettings.toObject(src.beam);
                        if(parsed === null) return null;
                        dst.beam = parsed;
                    }
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.steel.Fire.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: ElementDesignSettings_createType) {
                    const dst = new ElementDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.beam !== undefined) {
                        dst.beam = src.beam;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ElementDesignSettings();
                    dst.beam = this.beam;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = ElementDesignSettings.toObject(this);
                    const dst = ElementDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IElementDesignSettings = ElementDesignSettings;
        } // namespace steel


        // Defined in Design/general.proto
        export namespace general {
            export enum TemperatureCurve {
                TEMPERATURE_CURVE_UNSPECIFIED = 0,
                TEMPERATURE_CURVE_STANDARD = 1,
                TEMPERATURE_CURVE_EXTERNAL = 2,
                TEMPERATURE_CURVE_HYDROCARBON = 3,
                TEMPERATURE_CURVE_PARAMETRIC = 4
            }
            export const TemperatureCurve_FromObject = (src: unknown): TemperatureCurve => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'TEMPERATURE_CURVE_UNSPECIFIED':
                        return TemperatureCurve.TEMPERATURE_CURVE_UNSPECIFIED;
                    case 1:
                    case 'TEMPERATURE_CURVE_STANDARD':
                        return TemperatureCurve.TEMPERATURE_CURVE_STANDARD;
                    case 2:
                    case 'TEMPERATURE_CURVE_EXTERNAL':
                        return TemperatureCurve.TEMPERATURE_CURVE_EXTERNAL;
                    case 3:
                    case 'TEMPERATURE_CURVE_HYDROCARBON':
                        return TemperatureCurve.TEMPERATURE_CURVE_HYDROCARBON;
                    case 4:
                    case 'TEMPERATURE_CURVE_PARAMETRIC':
                        return TemperatureCurve.TEMPERATURE_CURVE_PARAMETRIC;
                    default:
                        console.log('Unhandled value for TemperatureCurve:' + src + '. ' + typeof(src));
                        return TemperatureCurve.TEMPERATURE_CURVE_UNSPECIFIED;
                }
            };
            export const TemperatureCurve_ToObject = (src: TemperatureCurve): string | null => {
                switch (src) {
                    case TemperatureCurve.TEMPERATURE_CURVE_UNSPECIFIED:
                        return 'TEMPERATURE_CURVE_UNSPECIFIED';
                    case TemperatureCurve.TEMPERATURE_CURVE_STANDARD:
                        return 'TEMPERATURE_CURVE_STANDARD';
                    case TemperatureCurve.TEMPERATURE_CURVE_EXTERNAL:
                        return 'TEMPERATURE_CURVE_EXTERNAL';
                    case TemperatureCurve.TEMPERATURE_CURVE_HYDROCARBON:
                        return 'TEMPERATURE_CURVE_HYDROCARBON';
                    case TemperatureCurve.TEMPERATURE_CURVE_PARAMETRIC:
                        return 'TEMPERATURE_CURVE_PARAMETRIC';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for TemperatureCurve, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PartialCoefficient_keys = 'gammaFactorInspectionLevelRelaxed' | 'gammaFactorInspectionLevelNormal' | 'gammaFactorInspectionLevelTightened' | 'gammaFactorCritical';
            export interface PartialCoefficient_createType {
                gammaFactorInspectionLevelRelaxed?: number,
                gammaFactorInspectionLevelNormal?: number,
                gammaFactorInspectionLevelTightened?: number,
                gammaFactorCritical?: number,
            }
            export interface PartialCoefficient_json {
                gammaFactorInspectionLevelRelaxed?: JsonNumber;
                gammaFactorInspectionLevelNormal?: JsonNumber;
                gammaFactorInspectionLevelTightened?: JsonNumber;
                gammaFactorCritical?: JsonNumber;
            }
            interface PartialCoefficient_json_in {
                __proto_name?: unknown;
                gammaFactorInspectionLevelRelaxed?: unknown;
                gammaFactorInspectionLevelNormal?: unknown;
                gammaFactorInspectionLevelTightened?: unknown;
                gammaFactorCritical?: unknown;
            }
            export class PartialCoefficient {
                __proto_name = "ng.design.general.PartialCoefficient";
                gammaFactorInspectionLevelRelaxed: number = 0;
                gammaFactorInspectionLevelNormal: number = 0;
                gammaFactorInspectionLevelTightened: number = 0;
                gammaFactorCritical: number = 0;

                static fromObject(src_unknown: unknown): PartialCoefficient {
                    const dst = new PartialCoefficient();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficient but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficient_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficient but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaFactorInspectionLevelRelaxed !== undefined && src.gammaFactorInspectionLevelRelaxed !== null) {
                        if (typeof src.gammaFactorInspectionLevelRelaxed === "number" || src.gammaFactorInspectionLevelRelaxed === 'NaN' || src.gammaFactorInspectionLevelRelaxed === 'Infinity' || src.gammaFactorInspectionLevelRelaxed === '-Infinity') {
                            dst.gammaFactorInspectionLevelRelaxed = AsNum(src.gammaFactorInspectionLevelRelaxed);
                        }
                        else {
                            console.log('Expected gammaFactorInspectionLevelRelaxed of PartialCoefficient to be a number but was ', typeof src.gammaFactorInspectionLevelRelaxed, src.gammaFactorInspectionLevelRelaxed)
                        }
                    }
                    if (src.gammaFactorInspectionLevelNormal !== undefined && src.gammaFactorInspectionLevelNormal !== null) {
                        if (typeof src.gammaFactorInspectionLevelNormal === "number" || src.gammaFactorInspectionLevelNormal === 'NaN' || src.gammaFactorInspectionLevelNormal === 'Infinity' || src.gammaFactorInspectionLevelNormal === '-Infinity') {
                            dst.gammaFactorInspectionLevelNormal = AsNum(src.gammaFactorInspectionLevelNormal);
                        }
                        else {
                            console.log('Expected gammaFactorInspectionLevelNormal of PartialCoefficient to be a number but was ', typeof src.gammaFactorInspectionLevelNormal, src.gammaFactorInspectionLevelNormal)
                        }
                    }
                    if (src.gammaFactorInspectionLevelTightened !== undefined && src.gammaFactorInspectionLevelTightened !== null) {
                        if (typeof src.gammaFactorInspectionLevelTightened === "number" || src.gammaFactorInspectionLevelTightened === 'NaN' || src.gammaFactorInspectionLevelTightened === 'Infinity' || src.gammaFactorInspectionLevelTightened === '-Infinity') {
                            dst.gammaFactorInspectionLevelTightened = AsNum(src.gammaFactorInspectionLevelTightened);
                        }
                        else {
                            console.log('Expected gammaFactorInspectionLevelTightened of PartialCoefficient to be a number but was ', typeof src.gammaFactorInspectionLevelTightened, src.gammaFactorInspectionLevelTightened)
                        }
                    }
                    if (src.gammaFactorCritical !== undefined && src.gammaFactorCritical !== null) {
                        if (typeof src.gammaFactorCritical === "number" || src.gammaFactorCritical === 'NaN' || src.gammaFactorCritical === 'Infinity' || src.gammaFactorCritical === '-Infinity') {
                            dst.gammaFactorCritical = AsNum(src.gammaFactorCritical);
                        }
                        else {
                            console.log('Expected gammaFactorCritical of PartialCoefficient to be a number but was ', typeof src.gammaFactorCritical, src.gammaFactorCritical)
                        }
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficient | null | undefined): PartialCoefficient_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.general.PartialCoefficient is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.general.PartialCoefficient") {
                        console.error('Expected ng.design.general.PartialCoefficient but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficient_json = {
                        gammaFactorInspectionLevelRelaxed: AsJsonNum(src.gammaFactorInspectionLevelRelaxed),
                        gammaFactorInspectionLevelNormal: AsJsonNum(src.gammaFactorInspectionLevelNormal),
                        gammaFactorInspectionLevelTightened: AsJsonNum(src.gammaFactorInspectionLevelTightened),
                        gammaFactorCritical: AsJsonNum(src.gammaFactorCritical),
                    };
                    return dst;
                }

                static create(src?: PartialCoefficient_createType) {
                    const dst = new PartialCoefficient();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaFactorInspectionLevelRelaxed !== undefined) {
                        dst.gammaFactorInspectionLevelRelaxed = src.gammaFactorInspectionLevelRelaxed;
                    }
                    if (src.gammaFactorInspectionLevelNormal !== undefined) {
                        dst.gammaFactorInspectionLevelNormal = src.gammaFactorInspectionLevelNormal;
                    }
                    if (src.gammaFactorInspectionLevelTightened !== undefined) {
                        dst.gammaFactorInspectionLevelTightened = src.gammaFactorInspectionLevelTightened;
                    }
                    if (src.gammaFactorCritical !== undefined) {
                        dst.gammaFactorCritical = src.gammaFactorCritical;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficient();
                    dst.gammaFactorInspectionLevelRelaxed = this.gammaFactorInspectionLevelRelaxed;
                    dst.gammaFactorInspectionLevelNormal = this.gammaFactorInspectionLevelNormal;
                    dst.gammaFactorInspectionLevelTightened = this.gammaFactorInspectionLevelTightened;
                    dst.gammaFactorCritical = this.gammaFactorCritical;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficient.toObject(this);
                    const dst = PartialCoefficient.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficient = PartialCoefficient;


            export type PartialCoefficients_keys = 'ultimate' | 'accidental';
            export interface PartialCoefficients_createType {
                ultimate?: ng.design.general.PartialCoefficient | null,
                accidental?: ng.design.general.PartialCoefficient | null,
            }
            export interface PartialCoefficients_json {
                ultimate?: ng.design.general.PartialCoefficient_json;
                accidental?: ng.design.general.PartialCoefficient_json;
            }
            interface PartialCoefficients_json_in {
                __proto_name?: unknown;
                ultimate?: unknown;
                accidental?: unknown;
            }
            export class PartialCoefficients {
                __proto_name = "ng.design.general.PartialCoefficients";
                ultimate: ng.design.general.PartialCoefficient | null = null;
                accidental: ng.design.general.PartialCoefficient | null = null;

                static fromObject(src_unknown: unknown): PartialCoefficients {
                    const dst = new PartialCoefficients();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficients but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficients_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficients but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ultimate !== undefined && src.ultimate !== null) {
                        dst.ultimate = ng.design.general.PartialCoefficient.fromObject(src.ultimate);
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        dst.accidental = ng.design.general.PartialCoefficient.fromObject(src.accidental);
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficients | null | undefined): PartialCoefficients_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.general.PartialCoefficients is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.general.PartialCoefficients") {
                        console.error('Expected ng.design.general.PartialCoefficients but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficients_json = {
                    };
                    if(src.ultimate !== null)
                    {
                        const parsed = ng.design.general.PartialCoefficient.toObject(src.ultimate);
                        if(parsed === null) return null;
                        dst.ultimate = parsed;
                    }
                    if(src.accidental !== null)
                    {
                        const parsed = ng.design.general.PartialCoefficient.toObject(src.accidental);
                        if(parsed === null) return null;
                        dst.accidental = parsed;
                    }
                    return dst;
                }

                static create(src?: PartialCoefficients_createType) {
                    const dst = new PartialCoefficients();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ultimate !== undefined) {
                        dst.ultimate = src.ultimate;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficients();
                    dst.ultimate = this.ultimate;
                    dst.accidental = this.accidental;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficients.toObject(this);
                    const dst = PartialCoefficients.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficients = PartialCoefficients;


            export type FireGeneral_keys = 'durationOfFire' | 'timeStep' | 'temperatureCurve' | 'gammaParametric';
            export interface FireGeneral_createType {
                durationOfFire?: number,
                timeStep?: number,
                temperatureCurve?: ng.design.general.TemperatureCurve,
                gammaParametric?: number,
            }
            export interface FireGeneral_json {
                durationOfFire?: JsonNumber;
                timeStep?: JsonNumber;
                temperatureCurve?: string;
                gammaParametric?: JsonNumber;
            }
            interface FireGeneral_json_in {
                __proto_name?: unknown;
                durationOfFire?: unknown;
                timeStep?: unknown;
                temperatureCurve?: unknown;
                gammaParametric?: unknown;
            }
            export class FireGeneral {
                __proto_name = "ng.design.general.FireGeneral";
                durationOfFire: number = 0;
                timeStep: number = 0;
                temperatureCurve: ng.design.general.TemperatureCurve = ng.design.general.TemperatureCurve.TEMPERATURE_CURVE_UNSPECIFIED;
                gammaParametric: number = 0;

                static fromObject(src_unknown: unknown): FireGeneral {
                    const dst = new FireGeneral();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FireGeneral but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FireGeneral_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FireGeneral but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.durationOfFire !== undefined && src.durationOfFire !== null) {
                        if (typeof src.durationOfFire === "number" || src.durationOfFire === 'NaN' || src.durationOfFire === 'Infinity' || src.durationOfFire === '-Infinity') {
                            dst.durationOfFire = AsNum(src.durationOfFire);
                        }
                        else {
                            console.log('Expected durationOfFire of FireGeneral to be a number but was ', typeof src.durationOfFire, src.durationOfFire)
                        }
                    }
                    if (src.timeStep !== undefined && src.timeStep !== null) {
                        if (typeof src.timeStep === "number" || src.timeStep === 'NaN' || src.timeStep === 'Infinity' || src.timeStep === '-Infinity') {
                            dst.timeStep = AsNum(src.timeStep);
                        }
                        else {
                            console.log('Expected timeStep of FireGeneral to be a number but was ', typeof src.timeStep, src.timeStep)
                        }
                    }
                    if (src.temperatureCurve !== undefined && src.temperatureCurve !== null) {
                        dst.temperatureCurve = ng.design.general.TemperatureCurve_FromObject(src.temperatureCurve);
                    }
                    if (src.gammaParametric !== undefined && src.gammaParametric !== null) {
                        if (typeof src.gammaParametric === "number" || src.gammaParametric === 'NaN' || src.gammaParametric === 'Infinity' || src.gammaParametric === '-Infinity') {
                            dst.gammaParametric = AsNum(src.gammaParametric);
                        }
                        else {
                            console.log('Expected gammaParametric of FireGeneral to be a number but was ', typeof src.gammaParametric, src.gammaParametric)
                        }
                    }
                    return dst;
                }

                static toObject(src: FireGeneral | null | undefined): FireGeneral_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.general.FireGeneral is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.general.FireGeneral") {
                        console.error('Expected ng.design.general.FireGeneral but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const temperatureCurve_obj = ng.design.general.TemperatureCurve_ToObject(src.temperatureCurve);
                    if(temperatureCurve_obj === null) return null;

                    const dst : FireGeneral_json = {
                        durationOfFire: AsJsonNum(src.durationOfFire),
                        timeStep: AsJsonNum(src.timeStep),
                        temperatureCurve: temperatureCurve_obj,
                        gammaParametric: AsJsonNum(src.gammaParametric),
                    };
                    return dst;
                }

                static create(src?: FireGeneral_createType) {
                    const dst = new FireGeneral();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.durationOfFire !== undefined) {
                        dst.durationOfFire = src.durationOfFire;
                    }
                    if (src.timeStep !== undefined) {
                        dst.timeStep = src.timeStep;
                    }
                    if (src.temperatureCurve !== undefined) {
                        dst.temperatureCurve = src.temperatureCurve;
                    }
                    if (src.gammaParametric !== undefined) {
                        dst.gammaParametric = src.gammaParametric;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FireGeneral();
                    dst.durationOfFire = this.durationOfFire;
                    dst.timeStep = this.timeStep;
                    dst.temperatureCurve = this.temperatureCurve;
                    dst.gammaParametric = this.gammaParametric;
                    return dst;
                }

                deepClone() {
                    const json = FireGeneral.toObject(this);
                    const dst = FireGeneral.fromObject(json);
                    return dst;
                }
            }
            export type IFireGeneral = FireGeneral;


            export type FireRadiativeHeatFlux_keys = 'configurationFactor' | 'fireEmissivity';
            export interface FireRadiativeHeatFlux_createType {
                configurationFactor?: number,
                fireEmissivity?: number,
            }
            export interface FireRadiativeHeatFlux_json {
                configurationFactor?: JsonNumber;
                fireEmissivity?: JsonNumber;
            }
            interface FireRadiativeHeatFlux_json_in {
                __proto_name?: unknown;
                configurationFactor?: unknown;
                fireEmissivity?: unknown;
            }
            export class FireRadiativeHeatFlux {
                __proto_name = "ng.design.general.FireRadiativeHeatFlux";
                configurationFactor: number = 0;
                fireEmissivity: number = 0;

                static fromObject(src_unknown: unknown): FireRadiativeHeatFlux {
                    const dst = new FireRadiativeHeatFlux();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FireRadiativeHeatFlux but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FireRadiativeHeatFlux_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FireRadiativeHeatFlux but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.configurationFactor !== undefined && src.configurationFactor !== null) {
                        if (typeof src.configurationFactor === "number" || src.configurationFactor === 'NaN' || src.configurationFactor === 'Infinity' || src.configurationFactor === '-Infinity') {
                            dst.configurationFactor = AsNum(src.configurationFactor);
                        }
                        else {
                            console.log('Expected configurationFactor of FireRadiativeHeatFlux to be a number but was ', typeof src.configurationFactor, src.configurationFactor)
                        }
                    }
                    if (src.fireEmissivity !== undefined && src.fireEmissivity !== null) {
                        if (typeof src.fireEmissivity === "number" || src.fireEmissivity === 'NaN' || src.fireEmissivity === 'Infinity' || src.fireEmissivity === '-Infinity') {
                            dst.fireEmissivity = AsNum(src.fireEmissivity);
                        }
                        else {
                            console.log('Expected fireEmissivity of FireRadiativeHeatFlux to be a number but was ', typeof src.fireEmissivity, src.fireEmissivity)
                        }
                    }
                    return dst;
                }

                static toObject(src: FireRadiativeHeatFlux | null | undefined): FireRadiativeHeatFlux_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.general.FireRadiativeHeatFlux is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.general.FireRadiativeHeatFlux") {
                        console.error('Expected ng.design.general.FireRadiativeHeatFlux but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FireRadiativeHeatFlux_json = {
                        configurationFactor: AsJsonNum(src.configurationFactor),
                        fireEmissivity: AsJsonNum(src.fireEmissivity),
                    };
                    return dst;
                }

                static create(src?: FireRadiativeHeatFlux_createType) {
                    const dst = new FireRadiativeHeatFlux();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.configurationFactor !== undefined) {
                        dst.configurationFactor = src.configurationFactor;
                    }
                    if (src.fireEmissivity !== undefined) {
                        dst.fireEmissivity = src.fireEmissivity;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FireRadiativeHeatFlux();
                    dst.configurationFactor = this.configurationFactor;
                    dst.fireEmissivity = this.fireEmissivity;
                    return dst;
                }

                deepClone() {
                    const json = FireRadiativeHeatFlux.toObject(this);
                    const dst = FireRadiativeHeatFlux.fromObject(json);
                    return dst;
                }
            }
            export type IFireRadiativeHeatFlux = FireRadiativeHeatFlux;


            export type ElementDesignSettings_keys = 'generalFire' | 'deflectionCheck' | 'deflectionLimit' | 'deflectionLimitFactor';
            export interface ElementDesignSettings_createType {
                generalFire?: ng.design.general.FireGeneral | null,
                deflectionCheck?: boolean,
                deflectionLimit?: number,
                deflectionLimitFactor?: number,
            }
            export interface ElementDesignSettings_json {
                generalFire?: ng.design.general.FireGeneral_json;
                deflectionCheck?: boolean;
                deflectionLimit?: JsonNumber;
                deflectionLimitFactor?: JsonNumber;
            }
            interface ElementDesignSettings_json_in {
                __proto_name?: unknown;
                generalFire?: unknown;
                deflectionCheck?: unknown;
                deflectionLimit?: unknown;
                deflectionLimitFactor?: unknown;
            }
            export class ElementDesignSettings {
                __proto_name = "ng.design.general.ElementDesignSettings";
                generalFire: ng.design.general.FireGeneral | null = null;
                deflectionCheck: boolean = false;
                // this is a one of
                Deflection: {type: 'deflectionLimit'; deflectionLimit: number} | {type: 'deflectionLimitFactor'; deflectionLimitFactor: number} | null = null;

                /** Gets the `DeflectionLimit` value (or null) from the oneof `Deflection` */
                getDeflectionLimit(): number | null {
                    if(this.Deflection === null) return null;
                    if(this.Deflection.type !== 'deflectionLimit') return null;
                    return this.Deflection.deflectionLimit;
                }

                /** Sets the `DeflectionLimit` value for the oneof `Deflection`*/
                setDeflectionLimit(value: number | null) {
                    if(value !== null) {
                        this.Deflection = {type: 'deflectionLimit', deflectionLimit:value};
                    }
                    else {
                        this.Deflection = null;
                    }
                }

                /** Gets the `DeflectionLimitFactor` value (or null) from the oneof `Deflection` */
                getDeflectionLimitFactor(): number | null {
                    if(this.Deflection === null) return null;
                    if(this.Deflection.type !== 'deflectionLimitFactor') return null;
                    return this.Deflection.deflectionLimitFactor;
                }

                /** Sets the `DeflectionLimitFactor` value for the oneof `Deflection`*/
                setDeflectionLimitFactor(value: number | null) {
                    if(value !== null) {
                        this.Deflection = {type: 'deflectionLimitFactor', deflectionLimitFactor:value};
                    }
                    else {
                        this.Deflection = null;
                    }
                }

                static fromObject(src_unknown: unknown): ElementDesignSettings {
                    const dst = new ElementDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ElementDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ElementDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ElementDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.generalFire !== undefined && src.generalFire !== null) {
                        dst.generalFire = ng.design.general.FireGeneral.fromObject(src.generalFire);
                    }
                    if (src.deflectionCheck !== undefined && src.deflectionCheck !== null) {
                        if (typeof src.deflectionCheck === "boolean") {
                            dst.deflectionCheck = src.deflectionCheck;
                        }
                        else {
                            console.log('Expected deflectionCheck of ElementDesignSettings to be a boolean but was ', typeof src.deflectionCheck, src.deflectionCheck)
                        }
                    }
                    if (src.deflectionLimit !== undefined && src.deflectionLimit !== null) {
                        if (typeof src.deflectionLimit === "number" || src.deflectionLimit === 'NaN' || src.deflectionLimit === 'Infinity' || src.deflectionLimit === '-Infinity') {
                            dst.setDeflectionLimit(AsNum(src.deflectionLimit));
                        }
                        else {
                            console.log('Expected deflectionLimit of ElementDesignSettings to be a number but was ', typeof src.deflectionLimit, src.deflectionLimit)
                        }
                    }
                    if (src.deflectionLimitFactor !== undefined && src.deflectionLimitFactor !== null) {
                        if (typeof src.deflectionLimitFactor === "number" || src.deflectionLimitFactor === 'NaN' || src.deflectionLimitFactor === 'Infinity' || src.deflectionLimitFactor === '-Infinity') {
                            dst.setDeflectionLimitFactor(AsNum(src.deflectionLimitFactor));
                        }
                        else {
                            console.log('Expected deflectionLimitFactor of ElementDesignSettings to be a number but was ', typeof src.deflectionLimitFactor, src.deflectionLimitFactor)
                        }
                    }
                    return dst;
                }

                static toObject(src: ElementDesignSettings | null | undefined): ElementDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.general.ElementDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.general.ElementDesignSettings") {
                        console.error('Expected ng.design.general.ElementDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ElementDesignSettings_json = {
                        deflectionCheck: src.deflectionCheck,
                    };
                    if(src.generalFire !== null)
                    {
                        const parsed = ng.design.general.FireGeneral.toObject(src.generalFire);
                        if(parsed === null) return null;
                        dst.generalFire = parsed;
                    }
                    const deflectionLimit = src.getDeflectionLimit();
                    if(deflectionLimit !== null)
                    {
                        const parsed = AsJsonNum(deflectionLimit);
                        if(parsed === null) return null;
                        dst.deflectionLimit = parsed;
                    }
                    const deflectionLimitFactor = src.getDeflectionLimitFactor();
                    if(deflectionLimitFactor !== null)
                    {
                        const parsed = AsJsonNum(deflectionLimitFactor);
                        if(parsed === null) return null;
                        dst.deflectionLimitFactor = parsed;
                    }
                    return dst;
                }

                static create(src?: ElementDesignSettings_createType) {
                    const dst = new ElementDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.generalFire !== undefined) {
                        dst.generalFire = src.generalFire;
                    }
                    if (src.deflectionCheck !== undefined) {
                        dst.deflectionCheck = src.deflectionCheck;
                    }
                    // part of the Deflection oneof 
                    if (src.deflectionLimit !== undefined && src.deflectionLimit !== null) {
                        dst.setDeflectionLimit(src.deflectionLimit);
                    }
                    // part of the Deflection oneof 
                    if (src.deflectionLimitFactor !== undefined && src.deflectionLimitFactor !== null) {
                        dst.setDeflectionLimitFactor(src.deflectionLimitFactor);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ElementDesignSettings();
                    dst.generalFire = this.generalFire;
                    dst.deflectionCheck = this.deflectionCheck;
                    dst.Deflection = this.Deflection;
                    return dst;
                }

                deepClone() {
                    const json = ElementDesignSettings.toObject(this);
                    const dst = ElementDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IElementDesignSettings = ElementDesignSettings;


            export type GeneralDesignSettings_keys = 'partialCoeffs' | 'heatFlux';
            export interface GeneralDesignSettings_createType {
                partialCoeffs?: ng.design.general.PartialCoefficients | null,
                heatFlux?: ng.design.general.FireRadiativeHeatFlux | null,
            }
            export interface GeneralDesignSettings_json {
                partialCoeffs?: ng.design.general.PartialCoefficients_json;
                heatFlux?: ng.design.general.FireRadiativeHeatFlux_json;
            }
            interface GeneralDesignSettings_json_in {
                __proto_name?: unknown;
                partialCoeffs?: unknown;
                heatFlux?: unknown;
            }
            export class GeneralDesignSettings {
                __proto_name = "ng.design.general.GeneralDesignSettings";
                partialCoeffs: ng.design.general.PartialCoefficients | null = null;
                heatFlux: ng.design.general.FireRadiativeHeatFlux | null = null;

                static fromObject(src_unknown: unknown): GeneralDesignSettings {
                    const dst = new GeneralDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined && src.partialCoeffs !== null) {
                        dst.partialCoeffs = ng.design.general.PartialCoefficients.fromObject(src.partialCoeffs);
                    }
                    if (src.heatFlux !== undefined && src.heatFlux !== null) {
                        dst.heatFlux = ng.design.general.FireRadiativeHeatFlux.fromObject(src.heatFlux);
                    }
                    return dst;
                }

                static toObject(src: GeneralDesignSettings | null | undefined): GeneralDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.general.GeneralDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.general.GeneralDesignSettings") {
                        console.error('Expected ng.design.general.GeneralDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GeneralDesignSettings_json = {
                    };
                    if(src.partialCoeffs !== null)
                    {
                        const parsed = ng.design.general.PartialCoefficients.toObject(src.partialCoeffs);
                        if(parsed === null) return null;
                        dst.partialCoeffs = parsed;
                    }
                    if(src.heatFlux !== null)
                    {
                        const parsed = ng.design.general.FireRadiativeHeatFlux.toObject(src.heatFlux);
                        if(parsed === null) return null;
                        dst.heatFlux = parsed;
                    }
                    return dst;
                }

                static create(src?: GeneralDesignSettings_createType) {
                    const dst = new GeneralDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined) {
                        dst.partialCoeffs = src.partialCoeffs;
                    }
                    if (src.heatFlux !== undefined) {
                        dst.heatFlux = src.heatFlux;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralDesignSettings();
                    dst.partialCoeffs = this.partialCoeffs;
                    dst.heatFlux = this.heatFlux;
                    return dst;
                }

                deepClone() {
                    const json = GeneralDesignSettings.toObject(this);
                    const dst = GeneralDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralDesignSettings = GeneralDesignSettings;
        } // namespace general


        // Defined in Design/soil.proto
        export namespace soil {
            export enum ActiveEarthPressureType {
                ACTIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED = 0,
                ACTIVE_EARTH_PRESSURE_TYPE_PRESSURE = 1,
                ACTIVE_EARTH_PRESSURE_TYPE_REST = 2,
                ACTIVE_EARTH_PRESSURE_TYPE_COMPACTION = 3
            }
            export const ActiveEarthPressureType_FromObject = (src: unknown): ActiveEarthPressureType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ACTIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED':
                        return ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED;
                    case 1:
                    case 'ACTIVE_EARTH_PRESSURE_TYPE_PRESSURE':
                        return ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_PRESSURE;
                    case 2:
                    case 'ACTIVE_EARTH_PRESSURE_TYPE_REST':
                        return ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_REST;
                    case 3:
                    case 'ACTIVE_EARTH_PRESSURE_TYPE_COMPACTION':
                        return ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_COMPACTION;
                    default:
                        console.log('Unhandled value for ActiveEarthPressureType:' + src + '. ' + typeof(src));
                        return ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED;
                }
            };
            export const ActiveEarthPressureType_ToObject = (src: ActiveEarthPressureType): string | null => {
                switch (src) {
                    case ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED:
                        return 'ACTIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED';
                    case ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_PRESSURE:
                        return 'ACTIVE_EARTH_PRESSURE_TYPE_PRESSURE';
                    case ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_REST:
                        return 'ACTIVE_EARTH_PRESSURE_TYPE_REST';
                    case ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_COMPACTION:
                        return 'ACTIVE_EARTH_PRESSURE_TYPE_COMPACTION';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ActiveEarthPressureType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum PassiveEarthPressureType {
                PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED = 0,
                PASSIVE_EARTH_PRESSURE_TYPE_PRESSURE = 1,
                PASSIVE_EARTH_PRESSURE_TYPE_REST = 2
            }
            export const PassiveEarthPressureType_FromObject = (src: unknown): PassiveEarthPressureType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED':
                        return PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED;
                    case 1:
                    case 'PASSIVE_EARTH_PRESSURE_TYPE_PRESSURE':
                        return PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_PRESSURE;
                    case 2:
                    case 'PASSIVE_EARTH_PRESSURE_TYPE_REST':
                        return PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_REST;
                    default:
                        console.log('Unhandled value for PassiveEarthPressureType:' + src + '. ' + typeof(src));
                        return PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED;
                }
            };
            export const PassiveEarthPressureType_ToObject = (src: PassiveEarthPressureType): string | null => {
                switch (src) {
                    case PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED:
                        return 'PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED';
                    case PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_PRESSURE:
                        return 'PASSIVE_EARTH_PRESSURE_TYPE_PRESSURE';
                    case PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_REST:
                        return 'PASSIVE_EARTH_PRESSURE_TYPE_REST';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PassiveEarthPressureType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum DesignApproach {
                DESIGN_APPROACH_UNSPECIFIED = 0,
                DESIGN_APPROACH_1 = 1,
                DESIGN_APPROACH_2 = 2,
                DESIGN_APPROACH_3 = 3,
                MATERIAL_MODEL_BOTH_COMB = 4,
                MATERIAL_MODEL_SINGLE_COMB = 5,
                RESISTANCE_MODEL = 6
            }
            export const DesignApproach_FromObject = (src: unknown): DesignApproach => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'DESIGN_APPROACH_UNSPECIFIED':
                        return DesignApproach.DESIGN_APPROACH_UNSPECIFIED;
                    case 1:
                    case 'DESIGN_APPROACH_1':
                        return DesignApproach.DESIGN_APPROACH_1;
                    case 2:
                    case 'DESIGN_APPROACH_2':
                        return DesignApproach.DESIGN_APPROACH_2;
                    case 3:
                    case 'DESIGN_APPROACH_3':
                        return DesignApproach.DESIGN_APPROACH_3;
                    case 4:
                    case 'MATERIAL_MODEL_BOTH_COMB':
                        return DesignApproach.MATERIAL_MODEL_BOTH_COMB;
                    case 5:
                    case 'MATERIAL_MODEL_SINGLE_COMB':
                        return DesignApproach.MATERIAL_MODEL_SINGLE_COMB;
                    case 6:
                    case 'RESISTANCE_MODEL':
                        return DesignApproach.RESISTANCE_MODEL;
                    default:
                        console.log('Unhandled value for DesignApproach:' + src + '. ' + typeof(src));
                        return DesignApproach.DESIGN_APPROACH_UNSPECIFIED;
                }
            };
            export const DesignApproach_ToObject = (src: DesignApproach): string | null => {
                switch (src) {
                    case DesignApproach.DESIGN_APPROACH_UNSPECIFIED:
                        return 'DESIGN_APPROACH_UNSPECIFIED';
                    case DesignApproach.DESIGN_APPROACH_1:
                        return 'DESIGN_APPROACH_1';
                    case DesignApproach.DESIGN_APPROACH_2:
                        return 'DESIGN_APPROACH_2';
                    case DesignApproach.DESIGN_APPROACH_3:
                        return 'DESIGN_APPROACH_3';
                    case DesignApproach.MATERIAL_MODEL_BOTH_COMB:
                        return 'MATERIAL_MODEL_BOTH_COMB';
                    case DesignApproach.MATERIAL_MODEL_SINGLE_COMB:
                        return 'MATERIAL_MODEL_SINGLE_COMB';
                    case DesignApproach.RESISTANCE_MODEL:
                        return 'RESISTANCE_MODEL';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for DesignApproach, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum MaxValues {
                MAX_VALUES_UNSPECIFIED = 0,
                MAX_VALUES_ALPHA = 1,
                MAX_VALUES_BETA = 2,
                MAX_VALUES_DELTA_L = 3,
                MAX_VALUES_DELTA_S = 4,
                MAX_VALUES_THETA = 5,
                MAX_VALUES_OMEGA = 6
            }
            export const MaxValues_FromObject = (src: unknown): MaxValues => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'MAX_VALUES_UNSPECIFIED':
                        return MaxValues.MAX_VALUES_UNSPECIFIED;
                    case 1:
                    case 'MAX_VALUES_ALPHA':
                        return MaxValues.MAX_VALUES_ALPHA;
                    case 2:
                    case 'MAX_VALUES_BETA':
                        return MaxValues.MAX_VALUES_BETA;
                    case 3:
                    case 'MAX_VALUES_DELTA_L':
                        return MaxValues.MAX_VALUES_DELTA_L;
                    case 4:
                    case 'MAX_VALUES_DELTA_S':
                        return MaxValues.MAX_VALUES_DELTA_S;
                    case 5:
                    case 'MAX_VALUES_THETA':
                        return MaxValues.MAX_VALUES_THETA;
                    case 6:
                    case 'MAX_VALUES_OMEGA':
                        return MaxValues.MAX_VALUES_OMEGA;
                    default:
                        console.log('Unhandled value for MaxValues:' + src + '. ' + typeof(src));
                        return MaxValues.MAX_VALUES_UNSPECIFIED;
                }
            };
            export const MaxValues_ToObject = (src: MaxValues): string | null => {
                switch (src) {
                    case MaxValues.MAX_VALUES_UNSPECIFIED:
                        return 'MAX_VALUES_UNSPECIFIED';
                    case MaxValues.MAX_VALUES_ALPHA:
                        return 'MAX_VALUES_ALPHA';
                    case MaxValues.MAX_VALUES_BETA:
                        return 'MAX_VALUES_BETA';
                    case MaxValues.MAX_VALUES_DELTA_L:
                        return 'MAX_VALUES_DELTA_L';
                    case MaxValues.MAX_VALUES_DELTA_S:
                        return 'MAX_VALUES_DELTA_S';
                    case MaxValues.MAX_VALUES_THETA:
                        return 'MAX_VALUES_THETA';
                    case MaxValues.MAX_VALUES_OMEGA:
                        return 'MAX_VALUES_OMEGA';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for MaxValues, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SoilPunchingType {
                SOIL_PUNCHING_TYPE_UNSPECIFIED = 0,
                SOIL_PUNCHING_TYPE_WIDTH_1_2 = 1,
                SOIL_PUNCHING_TYPE_1_2 = 2,
                SOIL_PUNCHING_TYPE_1_3 = 3,
                SOIL_PUNCHING_TYPE_1_4 = 4,
                SOIL_PUNCHING_TYPE_8_DEGREE = 5
            }
            export const SoilPunchingType_FromObject = (src: unknown): SoilPunchingType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SOIL_PUNCHING_TYPE_UNSPECIFIED':
                        return SoilPunchingType.SOIL_PUNCHING_TYPE_UNSPECIFIED;
                    case 1:
                    case 'SOIL_PUNCHING_TYPE_WIDTH_1_2':
                        return SoilPunchingType.SOIL_PUNCHING_TYPE_WIDTH_1_2;
                    case 2:
                    case 'SOIL_PUNCHING_TYPE_1_2':
                        return SoilPunchingType.SOIL_PUNCHING_TYPE_1_2;
                    case 3:
                    case 'SOIL_PUNCHING_TYPE_1_3':
                        return SoilPunchingType.SOIL_PUNCHING_TYPE_1_3;
                    case 4:
                    case 'SOIL_PUNCHING_TYPE_1_4':
                        return SoilPunchingType.SOIL_PUNCHING_TYPE_1_4;
                    case 5:
                    case 'SOIL_PUNCHING_TYPE_8_DEGREE':
                        return SoilPunchingType.SOIL_PUNCHING_TYPE_8_DEGREE;
                    default:
                        console.log('Unhandled value for SoilPunchingType:' + src + '. ' + typeof(src));
                        return SoilPunchingType.SOIL_PUNCHING_TYPE_UNSPECIFIED;
                }
            };
            export const SoilPunchingType_ToObject = (src: SoilPunchingType): string | null => {
                switch (src) {
                    case SoilPunchingType.SOIL_PUNCHING_TYPE_UNSPECIFIED:
                        return 'SOIL_PUNCHING_TYPE_UNSPECIFIED';
                    case SoilPunchingType.SOIL_PUNCHING_TYPE_WIDTH_1_2:
                        return 'SOIL_PUNCHING_TYPE_WIDTH_1_2';
                    case SoilPunchingType.SOIL_PUNCHING_TYPE_1_2:
                        return 'SOIL_PUNCHING_TYPE_1_2';
                    case SoilPunchingType.SOIL_PUNCHING_TYPE_1_3:
                        return 'SOIL_PUNCHING_TYPE_1_3';
                    case SoilPunchingType.SOIL_PUNCHING_TYPE_1_4:
                        return 'SOIL_PUNCHING_TYPE_1_4';
                    case SoilPunchingType.SOIL_PUNCHING_TYPE_8_DEGREE:
                        return 'SOIL_PUNCHING_TYPE_8_DEGREE';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SoilPunchingType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum FoundationDistribution {
                FOUNDATION_DISTRIBUTION_UNSPECIFIED = 0,
                FOUNDATION_DISTRIBUTION_ELASTIC = 1,
                FOUNDATION_DISTRIBUTION_PLASTIC = 2
            }
            export const FoundationDistribution_FromObject = (src: unknown): FoundationDistribution => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'FOUNDATION_DISTRIBUTION_UNSPECIFIED':
                        return FoundationDistribution.FOUNDATION_DISTRIBUTION_UNSPECIFIED;
                    case 1:
                    case 'FOUNDATION_DISTRIBUTION_ELASTIC':
                        return FoundationDistribution.FOUNDATION_DISTRIBUTION_ELASTIC;
                    case 2:
                    case 'FOUNDATION_DISTRIBUTION_PLASTIC':
                        return FoundationDistribution.FOUNDATION_DISTRIBUTION_PLASTIC;
                    default:
                        console.log('Unhandled value for FoundationDistribution:' + src + '. ' + typeof(src));
                        return FoundationDistribution.FOUNDATION_DISTRIBUTION_UNSPECIFIED;
                }
            };
            export const FoundationDistribution_ToObject = (src: FoundationDistribution): string | null => {
                switch (src) {
                    case FoundationDistribution.FOUNDATION_DISTRIBUTION_UNSPECIFIED:
                        return 'FOUNDATION_DISTRIBUTION_UNSPECIFIED';
                    case FoundationDistribution.FOUNDATION_DISTRIBUTION_ELASTIC:
                        return 'FOUNDATION_DISTRIBUTION_ELASTIC';
                    case FoundationDistribution.FOUNDATION_DISTRIBUTION_PLASTIC:
                        return 'FOUNDATION_DISTRIBUTION_PLASTIC';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for FoundationDistribution, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum GeotechnicalCategory {
                GEOTECHNICAL_CATEGORY_UNSPECIFIED = 0,
                GEOTECHNICAL_CATEGORY_1 = 1,
                GEOTECHNICAL_CATEGORY_2 = 2,
                GEOTECHNICAL_CATEGORY_3 = 3
            }
            export const GeotechnicalCategory_FromObject = (src: unknown): GeotechnicalCategory => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'GEOTECHNICAL_CATEGORY_UNSPECIFIED':
                        return GeotechnicalCategory.GEOTECHNICAL_CATEGORY_UNSPECIFIED;
                    case 1:
                    case 'GEOTECHNICAL_CATEGORY_1':
                        return GeotechnicalCategory.GEOTECHNICAL_CATEGORY_1;
                    case 2:
                    case 'GEOTECHNICAL_CATEGORY_2':
                        return GeotechnicalCategory.GEOTECHNICAL_CATEGORY_2;
                    case 3:
                    case 'GEOTECHNICAL_CATEGORY_3':
                        return GeotechnicalCategory.GEOTECHNICAL_CATEGORY_3;
                    default:
                        console.log('Unhandled value for GeotechnicalCategory:' + src + '. ' + typeof(src));
                        return GeotechnicalCategory.GEOTECHNICAL_CATEGORY_UNSPECIFIED;
                }
            };
            export const GeotechnicalCategory_ToObject = (src: GeotechnicalCategory): string | null => {
                switch (src) {
                    case GeotechnicalCategory.GEOTECHNICAL_CATEGORY_UNSPECIFIED:
                        return 'GEOTECHNICAL_CATEGORY_UNSPECIFIED';
                    case GeotechnicalCategory.GEOTECHNICAL_CATEGORY_1:
                        return 'GEOTECHNICAL_CATEGORY_1';
                    case GeotechnicalCategory.GEOTECHNICAL_CATEGORY_2:
                        return 'GEOTECHNICAL_CATEGORY_2';
                    case GeotechnicalCategory.GEOTECHNICAL_CATEGORY_3:
                        return 'GEOTECHNICAL_CATEGORY_3';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for GeotechnicalCategory, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type GammaSoil_keys = 'gammaCu' | 'gammaC' | 'gammaPhi' | 'gammaGamma' | 'gammaQu';
            export interface GammaSoil_createType {
                gammaCu?: number,
                gammaC?: number,
                gammaPhi?: number,
                gammaGamma?: number,
                gammaQu?: number,
            }
            export interface GammaSoil_json {
                gammaCu?: JsonNumber;
                gammaC?: JsonNumber;
                gammaPhi?: JsonNumber;
                gammaGamma?: JsonNumber;
                gammaQu?: JsonNumber;
            }
            interface GammaSoil_json_in {
                __proto_name?: unknown;
                gammaCu?: unknown;
                gammaC?: unknown;
                gammaPhi?: unknown;
                gammaGamma?: unknown;
                gammaQu?: unknown;
            }
            export class GammaSoil {
                __proto_name = "ng.design.soil.GammaSoil";
                gammaCu: number = 0;
                gammaC: number = 0;
                gammaPhi: number = 0;
                gammaGamma: number = 0;
                gammaQu: number = 0;

                static fromObject(src_unknown: unknown): GammaSoil {
                    const dst = new GammaSoil();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaSoil but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaSoil_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaSoil but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaCu !== undefined && src.gammaCu !== null) {
                        if (typeof src.gammaCu === "number" || src.gammaCu === 'NaN' || src.gammaCu === 'Infinity' || src.gammaCu === '-Infinity') {
                            dst.gammaCu = AsNum(src.gammaCu);
                        }
                        else {
                            console.log('Expected gammaCu of GammaSoil to be a number but was ', typeof src.gammaCu, src.gammaCu)
                        }
                    }
                    if (src.gammaC !== undefined && src.gammaC !== null) {
                        if (typeof src.gammaC === "number" || src.gammaC === 'NaN' || src.gammaC === 'Infinity' || src.gammaC === '-Infinity') {
                            dst.gammaC = AsNum(src.gammaC);
                        }
                        else {
                            console.log('Expected gammaC of GammaSoil to be a number but was ', typeof src.gammaC, src.gammaC)
                        }
                    }
                    if (src.gammaPhi !== undefined && src.gammaPhi !== null) {
                        if (typeof src.gammaPhi === "number" || src.gammaPhi === 'NaN' || src.gammaPhi === 'Infinity' || src.gammaPhi === '-Infinity') {
                            dst.gammaPhi = AsNum(src.gammaPhi);
                        }
                        else {
                            console.log('Expected gammaPhi of GammaSoil to be a number but was ', typeof src.gammaPhi, src.gammaPhi)
                        }
                    }
                    if (src.gammaGamma !== undefined && src.gammaGamma !== null) {
                        if (typeof src.gammaGamma === "number" || src.gammaGamma === 'NaN' || src.gammaGamma === 'Infinity' || src.gammaGamma === '-Infinity') {
                            dst.gammaGamma = AsNum(src.gammaGamma);
                        }
                        else {
                            console.log('Expected gammaGamma of GammaSoil to be a number but was ', typeof src.gammaGamma, src.gammaGamma)
                        }
                    }
                    if (src.gammaQu !== undefined && src.gammaQu !== null) {
                        if (typeof src.gammaQu === "number" || src.gammaQu === 'NaN' || src.gammaQu === 'Infinity' || src.gammaQu === '-Infinity') {
                            dst.gammaQu = AsNum(src.gammaQu);
                        }
                        else {
                            console.log('Expected gammaQu of GammaSoil to be a number but was ', typeof src.gammaQu, src.gammaQu)
                        }
                    }
                    return dst;
                }

                static toObject(src: GammaSoil | null | undefined): GammaSoil_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.GammaSoil is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.GammaSoil") {
                        console.error('Expected ng.design.soil.GammaSoil but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaSoil_json = {
                        gammaCu: AsJsonNum(src.gammaCu),
                        gammaC: AsJsonNum(src.gammaC),
                        gammaPhi: AsJsonNum(src.gammaPhi),
                        gammaGamma: AsJsonNum(src.gammaGamma),
                        gammaQu: AsJsonNum(src.gammaQu),
                    };
                    return dst;
                }

                static create(src?: GammaSoil_createType) {
                    const dst = new GammaSoil();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaCu !== undefined) {
                        dst.gammaCu = src.gammaCu;
                    }
                    if (src.gammaC !== undefined) {
                        dst.gammaC = src.gammaC;
                    }
                    if (src.gammaPhi !== undefined) {
                        dst.gammaPhi = src.gammaPhi;
                    }
                    if (src.gammaGamma !== undefined) {
                        dst.gammaGamma = src.gammaGamma;
                    }
                    if (src.gammaQu !== undefined) {
                        dst.gammaQu = src.gammaQu;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaSoil();
                    dst.gammaCu = this.gammaCu;
                    dst.gammaC = this.gammaC;
                    dst.gammaPhi = this.gammaPhi;
                    dst.gammaGamma = this.gammaGamma;
                    dst.gammaQu = this.gammaQu;
                    return dst;
                }

                deepClone() {
                    const json = GammaSoil.toObject(this);
                    const dst = GammaSoil.fromObject(json);
                    return dst;
                }
            }
            export type IGammaSoil = GammaSoil;


            export type GammaResistance_keys = 'gammaRv' | 'gammaRh';
            export interface GammaResistance_createType {
                gammaRv?: number,
                gammaRh?: number,
            }
            export interface GammaResistance_json {
                gammaRv?: JsonNumber;
                gammaRh?: JsonNumber;
            }
            interface GammaResistance_json_in {
                __proto_name?: unknown;
                gammaRv?: unknown;
                gammaRh?: unknown;
            }
            export class GammaResistance {
                __proto_name = "ng.design.soil.GammaResistance";
                gammaRv: number = 0;
                gammaRh: number = 0;

                static fromObject(src_unknown: unknown): GammaResistance {
                    const dst = new GammaResistance();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaResistance but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaResistance_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaResistance but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaRv !== undefined && src.gammaRv !== null) {
                        if (typeof src.gammaRv === "number" || src.gammaRv === 'NaN' || src.gammaRv === 'Infinity' || src.gammaRv === '-Infinity') {
                            dst.gammaRv = AsNum(src.gammaRv);
                        }
                        else {
                            console.log('Expected gammaRv of GammaResistance to be a number but was ', typeof src.gammaRv, src.gammaRv)
                        }
                    }
                    if (src.gammaRh !== undefined && src.gammaRh !== null) {
                        if (typeof src.gammaRh === "number" || src.gammaRh === 'NaN' || src.gammaRh === 'Infinity' || src.gammaRh === '-Infinity') {
                            dst.gammaRh = AsNum(src.gammaRh);
                        }
                        else {
                            console.log('Expected gammaRh of GammaResistance to be a number but was ', typeof src.gammaRh, src.gammaRh)
                        }
                    }
                    return dst;
                }

                static toObject(src: GammaResistance | null | undefined): GammaResistance_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.GammaResistance is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.GammaResistance") {
                        console.error('Expected ng.design.soil.GammaResistance but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaResistance_json = {
                        gammaRv: AsJsonNum(src.gammaRv),
                        gammaRh: AsJsonNum(src.gammaRh),
                    };
                    return dst;
                }

                static create(src?: GammaResistance_createType) {
                    const dst = new GammaResistance();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaRv !== undefined) {
                        dst.gammaRv = src.gammaRv;
                    }
                    if (src.gammaRh !== undefined) {
                        dst.gammaRh = src.gammaRh;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaResistance();
                    dst.gammaRv = this.gammaRv;
                    dst.gammaRh = this.gammaRh;
                    return dst;
                }

                deepClone() {
                    const json = GammaResistance.toObject(this);
                    const dst = GammaResistance.fromObject(json);
                    return dst;
                }
            }
            export type IGammaResistance = GammaResistance;


            export type GammaPile_keys = 'gammaSc' | 'gammaSt' | 'gammaB' | 'gammaT';
            export interface GammaPile_createType {
                gammaSc?: number,
                gammaSt?: number,
                gammaB?: number,
                gammaT?: number,
            }
            export interface GammaPile_json {
                gammaSc?: JsonNumber;
                gammaSt?: JsonNumber;
                gammaB?: JsonNumber;
                gammaT?: JsonNumber;
            }
            interface GammaPile_json_in {
                __proto_name?: unknown;
                gammaSc?: unknown;
                gammaSt?: unknown;
                gammaB?: unknown;
                gammaT?: unknown;
            }
            export class GammaPile {
                __proto_name = "ng.design.soil.GammaPile";
                gammaSc: number = 0;
                gammaSt: number = 0;
                gammaB: number = 0;
                gammaT: number = 0;

                static fromObject(src_unknown: unknown): GammaPile {
                    const dst = new GammaPile();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaPile but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaPile_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaPile but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaSc !== undefined && src.gammaSc !== null) {
                        if (typeof src.gammaSc === "number" || src.gammaSc === 'NaN' || src.gammaSc === 'Infinity' || src.gammaSc === '-Infinity') {
                            dst.gammaSc = AsNum(src.gammaSc);
                        }
                        else {
                            console.log('Expected gammaSc of GammaPile to be a number but was ', typeof src.gammaSc, src.gammaSc)
                        }
                    }
                    if (src.gammaSt !== undefined && src.gammaSt !== null) {
                        if (typeof src.gammaSt === "number" || src.gammaSt === 'NaN' || src.gammaSt === 'Infinity' || src.gammaSt === '-Infinity') {
                            dst.gammaSt = AsNum(src.gammaSt);
                        }
                        else {
                            console.log('Expected gammaSt of GammaPile to be a number but was ', typeof src.gammaSt, src.gammaSt)
                        }
                    }
                    if (src.gammaB !== undefined && src.gammaB !== null) {
                        if (typeof src.gammaB === "number" || src.gammaB === 'NaN' || src.gammaB === 'Infinity' || src.gammaB === '-Infinity') {
                            dst.gammaB = AsNum(src.gammaB);
                        }
                        else {
                            console.log('Expected gammaB of GammaPile to be a number but was ', typeof src.gammaB, src.gammaB)
                        }
                    }
                    if (src.gammaT !== undefined && src.gammaT !== null) {
                        if (typeof src.gammaT === "number" || src.gammaT === 'NaN' || src.gammaT === 'Infinity' || src.gammaT === '-Infinity') {
                            dst.gammaT = AsNum(src.gammaT);
                        }
                        else {
                            console.log('Expected gammaT of GammaPile to be a number but was ', typeof src.gammaT, src.gammaT)
                        }
                    }
                    return dst;
                }

                static toObject(src: GammaPile | null | undefined): GammaPile_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.GammaPile is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.GammaPile") {
                        console.error('Expected ng.design.soil.GammaPile but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaPile_json = {
                        gammaSc: AsJsonNum(src.gammaSc),
                        gammaSt: AsJsonNum(src.gammaSt),
                        gammaB: AsJsonNum(src.gammaB),
                        gammaT: AsJsonNum(src.gammaT),
                    };
                    return dst;
                }

                static create(src?: GammaPile_createType) {
                    const dst = new GammaPile();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaSc !== undefined) {
                        dst.gammaSc = src.gammaSc;
                    }
                    if (src.gammaSt !== undefined) {
                        dst.gammaSt = src.gammaSt;
                    }
                    if (src.gammaB !== undefined) {
                        dst.gammaB = src.gammaB;
                    }
                    if (src.gammaT !== undefined) {
                        dst.gammaT = src.gammaT;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaPile();
                    dst.gammaSc = this.gammaSc;
                    dst.gammaSt = this.gammaSt;
                    dst.gammaB = this.gammaB;
                    dst.gammaT = this.gammaT;
                    return dst;
                }

                deepClone() {
                    const json = GammaPile.toObject(this);
                    const dst = GammaPile.fromObject(json);
                    return dst;
                }
            }
            export type IGammaPile = GammaPile;


            export type GammaPiles_keys = 'driven' | 'cfa' | 'bored';
            export interface GammaPiles_createType {
                driven?: ng.design.soil.GammaPile | null,
                cfa?: ng.design.soil.GammaPile | null,
                bored?: ng.design.soil.GammaPile | null,
            }
            export interface GammaPiles_json {
                driven?: ng.design.soil.GammaPile_json;
                cfa?: ng.design.soil.GammaPile_json;
                bored?: ng.design.soil.GammaPile_json;
            }
            interface GammaPiles_json_in {
                __proto_name?: unknown;
                driven?: unknown;
                cfa?: unknown;
                bored?: unknown;
            }
            export class GammaPiles {
                __proto_name = "ng.design.soil.GammaPiles";
                driven: ng.design.soil.GammaPile | null = null;
                cfa: ng.design.soil.GammaPile | null = null;
                bored: ng.design.soil.GammaPile | null = null;

                static fromObject(src_unknown: unknown): GammaPiles {
                    const dst = new GammaPiles();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaPiles but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaPiles_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaPiles but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.driven !== undefined && src.driven !== null) {
                        dst.driven = ng.design.soil.GammaPile.fromObject(src.driven);
                    }
                    if (src.cfa !== undefined && src.cfa !== null) {
                        dst.cfa = ng.design.soil.GammaPile.fromObject(src.cfa);
                    }
                    if (src.bored !== undefined && src.bored !== null) {
                        dst.bored = ng.design.soil.GammaPile.fromObject(src.bored);
                    }
                    return dst;
                }

                static toObject(src: GammaPiles | null | undefined): GammaPiles_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.GammaPiles is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.GammaPiles") {
                        console.error('Expected ng.design.soil.GammaPiles but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaPiles_json = {
                    };
                    if(src.driven !== null)
                    {
                        const parsed = ng.design.soil.GammaPile.toObject(src.driven);
                        if(parsed === null) return null;
                        dst.driven = parsed;
                    }
                    if(src.cfa !== null)
                    {
                        const parsed = ng.design.soil.GammaPile.toObject(src.cfa);
                        if(parsed === null) return null;
                        dst.cfa = parsed;
                    }
                    if(src.bored !== null)
                    {
                        const parsed = ng.design.soil.GammaPile.toObject(src.bored);
                        if(parsed === null) return null;
                        dst.bored = parsed;
                    }
                    return dst;
                }

                static create(src?: GammaPiles_createType) {
                    const dst = new GammaPiles();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.driven !== undefined) {
                        dst.driven = src.driven;
                    }
                    if (src.cfa !== undefined) {
                        dst.cfa = src.cfa;
                    }
                    if (src.bored !== undefined) {
                        dst.bored = src.bored;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaPiles();
                    dst.driven = this.driven;
                    dst.cfa = this.cfa;
                    dst.bored = this.bored;
                    return dst;
                }

                deepClone() {
                    const json = GammaPiles.toObject(this);
                    const dst = GammaPiles.fromObject(json);
                    return dst;
                }
            }
            export type IGammaPiles = GammaPiles;


            export type GammaPermanent_keys = 'unfavorable';
            export interface GammaPermanent_createType {
                unfavorable?: number,
            }
            export interface GammaPermanent_json {
                unfavorable?: JsonNumber;
            }
            interface GammaPermanent_json_in {
                __proto_name?: unknown;
                unfavorable?: unknown;
            }
            export class GammaPermanent {
                __proto_name = "ng.design.soil.GammaPermanent";
                unfavorable: number = 0;

                static fromObject(src_unknown: unknown): GammaPermanent {
                    const dst = new GammaPermanent();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaPermanent but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaPermanent_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaPermanent but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.unfavorable !== undefined && src.unfavorable !== null) {
                        if (typeof src.unfavorable === "number" || src.unfavorable === 'NaN' || src.unfavorable === 'Infinity' || src.unfavorable === '-Infinity') {
                            dst.unfavorable = AsNum(src.unfavorable);
                        }
                        else {
                            console.log('Expected unfavorable of GammaPermanent to be a number but was ', typeof src.unfavorable, src.unfavorable)
                        }
                    }
                    return dst;
                }

                static toObject(src: GammaPermanent | null | undefined): GammaPermanent_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.GammaPermanent is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.GammaPermanent") {
                        console.error('Expected ng.design.soil.GammaPermanent but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaPermanent_json = {
                        unfavorable: AsJsonNum(src.unfavorable),
                    };
                    return dst;
                }

                static create(src?: GammaPermanent_createType) {
                    const dst = new GammaPermanent();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.unfavorable !== undefined) {
                        dst.unfavorable = src.unfavorable;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaPermanent();
                    dst.unfavorable = this.unfavorable;
                    return dst;
                }

                deepClone() {
                    const json = GammaPermanent.toObject(this);
                    const dst = GammaPermanent.fromObject(json);
                    return dst;
                }
            }
            export type IGammaPermanent = GammaPermanent;


            export type PartialCoefficient_keys = 'm1' | 'm2' | 'r1' | 'r2' | 'r3' | 'a1' | 'a2' | 'gammaFactorGeotechnicalCategoryOne' | 'p1' | 'p2' | 'p3' | 'p4';
            export interface PartialCoefficient_createType {
                m1?: ng.design.soil.GammaSoil | null,
                m2?: ng.design.soil.GammaSoil | null,
                r1?: ng.design.soil.GammaResistance | null,
                r2?: ng.design.soil.GammaResistance | null,
                r3?: ng.design.soil.GammaResistance | null,
                a1?: ng.design.soil.GammaPermanent | null,
                a2?: ng.design.soil.GammaPermanent | null,
                gammaFactorGeotechnicalCategoryOne?: number,
                p1?: ng.design.soil.GammaPiles | null,
                p2?: ng.design.soil.GammaPiles | null,
                p3?: ng.design.soil.GammaPiles | null,
                p4?: ng.design.soil.GammaPiles | null,
            }
            export interface PartialCoefficient_json {
                m1?: ng.design.soil.GammaSoil_json;
                m2?: ng.design.soil.GammaSoil_json;
                r1?: ng.design.soil.GammaResistance_json;
                r2?: ng.design.soil.GammaResistance_json;
                r3?: ng.design.soil.GammaResistance_json;
                a1?: ng.design.soil.GammaPermanent_json;
                a2?: ng.design.soil.GammaPermanent_json;
                gammaFactorGeotechnicalCategoryOne?: JsonNumber;
                p1?: ng.design.soil.GammaPiles_json;
                p2?: ng.design.soil.GammaPiles_json;
                p3?: ng.design.soil.GammaPiles_json;
                p4?: ng.design.soil.GammaPiles_json;
            }
            interface PartialCoefficient_json_in {
                __proto_name?: unknown;
                m1?: unknown;
                m2?: unknown;
                r1?: unknown;
                r2?: unknown;
                r3?: unknown;
                a1?: unknown;
                a2?: unknown;
                gammaFactorGeotechnicalCategoryOne?: unknown;
                p1?: unknown;
                p2?: unknown;
                p3?: unknown;
                p4?: unknown;
            }
            export class PartialCoefficient {
                __proto_name = "ng.design.soil.PartialCoefficient";
                m1: ng.design.soil.GammaSoil | null = null;
                m2: ng.design.soil.GammaSoil | null = null;
                r1: ng.design.soil.GammaResistance | null = null;
                r2: ng.design.soil.GammaResistance | null = null;
                r3: ng.design.soil.GammaResistance | null = null;
                a1: ng.design.soil.GammaPermanent | null = null;
                a2: ng.design.soil.GammaPermanent | null = null;
                gammaFactorGeotechnicalCategoryOne: number = 0;
                p1: ng.design.soil.GammaPiles | null = null;
                p2: ng.design.soil.GammaPiles | null = null;
                p3: ng.design.soil.GammaPiles | null = null;
                p4: ng.design.soil.GammaPiles | null = null;

                static fromObject(src_unknown: unknown): PartialCoefficient {
                    const dst = new PartialCoefficient();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficient but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficient_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficient but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.m1 !== undefined && src.m1 !== null) {
                        dst.m1 = ng.design.soil.GammaSoil.fromObject(src.m1);
                    }
                    if (src.m2 !== undefined && src.m2 !== null) {
                        dst.m2 = ng.design.soil.GammaSoil.fromObject(src.m2);
                    }
                    if (src.r1 !== undefined && src.r1 !== null) {
                        dst.r1 = ng.design.soil.GammaResistance.fromObject(src.r1);
                    }
                    if (src.r2 !== undefined && src.r2 !== null) {
                        dst.r2 = ng.design.soil.GammaResistance.fromObject(src.r2);
                    }
                    if (src.r3 !== undefined && src.r3 !== null) {
                        dst.r3 = ng.design.soil.GammaResistance.fromObject(src.r3);
                    }
                    if (src.a1 !== undefined && src.a1 !== null) {
                        dst.a1 = ng.design.soil.GammaPermanent.fromObject(src.a1);
                    }
                    if (src.a2 !== undefined && src.a2 !== null) {
                        dst.a2 = ng.design.soil.GammaPermanent.fromObject(src.a2);
                    }
                    if (src.gammaFactorGeotechnicalCategoryOne !== undefined && src.gammaFactorGeotechnicalCategoryOne !== null) {
                        if (typeof src.gammaFactorGeotechnicalCategoryOne === "number" || src.gammaFactorGeotechnicalCategoryOne === 'NaN' || src.gammaFactorGeotechnicalCategoryOne === 'Infinity' || src.gammaFactorGeotechnicalCategoryOne === '-Infinity') {
                            dst.gammaFactorGeotechnicalCategoryOne = AsNum(src.gammaFactorGeotechnicalCategoryOne);
                        }
                        else {
                            console.log('Expected gammaFactorGeotechnicalCategoryOne of PartialCoefficient to be a number but was ', typeof src.gammaFactorGeotechnicalCategoryOne, src.gammaFactorGeotechnicalCategoryOne)
                        }
                    }
                    if (src.p1 !== undefined && src.p1 !== null) {
                        dst.p1 = ng.design.soil.GammaPiles.fromObject(src.p1);
                    }
                    if (src.p2 !== undefined && src.p2 !== null) {
                        dst.p2 = ng.design.soil.GammaPiles.fromObject(src.p2);
                    }
                    if (src.p3 !== undefined && src.p3 !== null) {
                        dst.p3 = ng.design.soil.GammaPiles.fromObject(src.p3);
                    }
                    if (src.p4 !== undefined && src.p4 !== null) {
                        dst.p4 = ng.design.soil.GammaPiles.fromObject(src.p4);
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficient | null | undefined): PartialCoefficient_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.PartialCoefficient is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.PartialCoefficient") {
                        console.error('Expected ng.design.soil.PartialCoefficient but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficient_json = {
                        gammaFactorGeotechnicalCategoryOne: AsJsonNum(src.gammaFactorGeotechnicalCategoryOne),
                    };
                    if(src.m1 !== null)
                    {
                        const parsed = ng.design.soil.GammaSoil.toObject(src.m1);
                        if(parsed === null) return null;
                        dst.m1 = parsed;
                    }
                    if(src.m2 !== null)
                    {
                        const parsed = ng.design.soil.GammaSoil.toObject(src.m2);
                        if(parsed === null) return null;
                        dst.m2 = parsed;
                    }
                    if(src.r1 !== null)
                    {
                        const parsed = ng.design.soil.GammaResistance.toObject(src.r1);
                        if(parsed === null) return null;
                        dst.r1 = parsed;
                    }
                    if(src.r2 !== null)
                    {
                        const parsed = ng.design.soil.GammaResistance.toObject(src.r2);
                        if(parsed === null) return null;
                        dst.r2 = parsed;
                    }
                    if(src.r3 !== null)
                    {
                        const parsed = ng.design.soil.GammaResistance.toObject(src.r3);
                        if(parsed === null) return null;
                        dst.r3 = parsed;
                    }
                    if(src.a1 !== null)
                    {
                        const parsed = ng.design.soil.GammaPermanent.toObject(src.a1);
                        if(parsed === null) return null;
                        dst.a1 = parsed;
                    }
                    if(src.a2 !== null)
                    {
                        const parsed = ng.design.soil.GammaPermanent.toObject(src.a2);
                        if(parsed === null) return null;
                        dst.a2 = parsed;
                    }
                    if(src.p1 !== null)
                    {
                        const parsed = ng.design.soil.GammaPiles.toObject(src.p1);
                        if(parsed === null) return null;
                        dst.p1 = parsed;
                    }
                    if(src.p2 !== null)
                    {
                        const parsed = ng.design.soil.GammaPiles.toObject(src.p2);
                        if(parsed === null) return null;
                        dst.p2 = parsed;
                    }
                    if(src.p3 !== null)
                    {
                        const parsed = ng.design.soil.GammaPiles.toObject(src.p3);
                        if(parsed === null) return null;
                        dst.p3 = parsed;
                    }
                    if(src.p4 !== null)
                    {
                        const parsed = ng.design.soil.GammaPiles.toObject(src.p4);
                        if(parsed === null) return null;
                        dst.p4 = parsed;
                    }
                    return dst;
                }

                static create(src?: PartialCoefficient_createType) {
                    const dst = new PartialCoefficient();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.m1 !== undefined) {
                        dst.m1 = src.m1;
                    }
                    if (src.m2 !== undefined) {
                        dst.m2 = src.m2;
                    }
                    if (src.r1 !== undefined) {
                        dst.r1 = src.r1;
                    }
                    if (src.r2 !== undefined) {
                        dst.r2 = src.r2;
                    }
                    if (src.r3 !== undefined) {
                        dst.r3 = src.r3;
                    }
                    if (src.a1 !== undefined) {
                        dst.a1 = src.a1;
                    }
                    if (src.a2 !== undefined) {
                        dst.a2 = src.a2;
                    }
                    if (src.gammaFactorGeotechnicalCategoryOne !== undefined) {
                        dst.gammaFactorGeotechnicalCategoryOne = src.gammaFactorGeotechnicalCategoryOne;
                    }
                    if (src.p1 !== undefined) {
                        dst.p1 = src.p1;
                    }
                    if (src.p2 !== undefined) {
                        dst.p2 = src.p2;
                    }
                    if (src.p3 !== undefined) {
                        dst.p3 = src.p3;
                    }
                    if (src.p4 !== undefined) {
                        dst.p4 = src.p4;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficient();
                    dst.m1 = this.m1;
                    dst.m2 = this.m2;
                    dst.r1 = this.r1;
                    dst.r2 = this.r2;
                    dst.r3 = this.r3;
                    dst.a1 = this.a1;
                    dst.a2 = this.a2;
                    dst.gammaFactorGeotechnicalCategoryOne = this.gammaFactorGeotechnicalCategoryOne;
                    dst.p1 = this.p1;
                    dst.p2 = this.p2;
                    dst.p3 = this.p3;
                    dst.p4 = this.p4;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficient.toObject(this);
                    const dst = PartialCoefficient.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficient = PartialCoefficient;


            export type PartialCoefficients_keys = 'ultimate' | 'accidental' | 'seismic';
            export interface PartialCoefficients_createType {
                ultimate?: ng.design.soil.PartialCoefficient | null,
                accidental?: ng.design.soil.PartialCoefficient | null,
                seismic?: ng.design.soil.PartialCoefficient | null,
            }
            export interface PartialCoefficients_json {
                ultimate?: ng.design.soil.PartialCoefficient_json;
                accidental?: ng.design.soil.PartialCoefficient_json;
                seismic?: ng.design.soil.PartialCoefficient_json;
            }
            interface PartialCoefficients_json_in {
                __proto_name?: unknown;
                ultimate?: unknown;
                accidental?: unknown;
                seismic?: unknown;
            }
            export class PartialCoefficients {
                __proto_name = "ng.design.soil.PartialCoefficients";
                ultimate: ng.design.soil.PartialCoefficient | null = null;
                accidental: ng.design.soil.PartialCoefficient | null = null;
                seismic: ng.design.soil.PartialCoefficient | null = null;

                static fromObject(src_unknown: unknown): PartialCoefficients {
                    const dst = new PartialCoefficients();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficients but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficients_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficients but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ultimate !== undefined && src.ultimate !== null) {
                        dst.ultimate = ng.design.soil.PartialCoefficient.fromObject(src.ultimate);
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        dst.accidental = ng.design.soil.PartialCoefficient.fromObject(src.accidental);
                    }
                    if (src.seismic !== undefined && src.seismic !== null) {
                        dst.seismic = ng.design.soil.PartialCoefficient.fromObject(src.seismic);
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficients | null | undefined): PartialCoefficients_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.PartialCoefficients is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.PartialCoefficients") {
                        console.error('Expected ng.design.soil.PartialCoefficients but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficients_json = {
                    };
                    if(src.ultimate !== null)
                    {
                        const parsed = ng.design.soil.PartialCoefficient.toObject(src.ultimate);
                        if(parsed === null) return null;
                        dst.ultimate = parsed;
                    }
                    if(src.accidental !== null)
                    {
                        const parsed = ng.design.soil.PartialCoefficient.toObject(src.accidental);
                        if(parsed === null) return null;
                        dst.accidental = parsed;
                    }
                    if(src.seismic !== null)
                    {
                        const parsed = ng.design.soil.PartialCoefficient.toObject(src.seismic);
                        if(parsed === null) return null;
                        dst.seismic = parsed;
                    }
                    return dst;
                }

                static create(src?: PartialCoefficients_createType) {
                    const dst = new PartialCoefficients();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ultimate !== undefined) {
                        dst.ultimate = src.ultimate;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    if (src.seismic !== undefined) {
                        dst.seismic = src.seismic;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficients();
                    dst.ultimate = this.ultimate;
                    dst.accidental = this.accidental;
                    dst.seismic = this.seismic;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficients.toObject(this);
                    const dst = PartialCoefficients.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficients = PartialCoefficients;


            export type SettlementSetup_keys = 'limitType' | 'limitValue';
            export interface SettlementSetup_createType {
                limitType?: ng.design.soil.MaxValues,
                limitValue?: number,
            }
            export interface SettlementSetup_json {
                limitType?: string;
                limitValue?: JsonNumber;
            }
            interface SettlementSetup_json_in {
                __proto_name?: unknown;
                limitType?: unknown;
                limitValue?: unknown;
            }
            export class SettlementSetup {
                __proto_name = "ng.design.soil.SettlementSetup";
                limitType: ng.design.soil.MaxValues = ng.design.soil.MaxValues.MAX_VALUES_UNSPECIFIED;
                limitValue: number = 0;

                static fromObject(src_unknown: unknown): SettlementSetup {
                    const dst = new SettlementSetup();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SettlementSetup but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SettlementSetup_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SettlementSetup but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.limitType !== undefined && src.limitType !== null) {
                        dst.limitType = ng.design.soil.MaxValues_FromObject(src.limitType);
                    }
                    if (src.limitValue !== undefined && src.limitValue !== null) {
                        if (typeof src.limitValue === "number" || src.limitValue === 'NaN' || src.limitValue === 'Infinity' || src.limitValue === '-Infinity') {
                            dst.limitValue = AsNum(src.limitValue);
                        }
                        else {
                            console.log('Expected limitValue of SettlementSetup to be a number but was ', typeof src.limitValue, src.limitValue)
                        }
                    }
                    return dst;
                }

                static toObject(src: SettlementSetup | null | undefined): SettlementSetup_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.SettlementSetup is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.SettlementSetup") {
                        console.error('Expected ng.design.soil.SettlementSetup but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const limitType_obj = ng.design.soil.MaxValues_ToObject(src.limitType);
                    if(limitType_obj === null) return null;

                    const dst : SettlementSetup_json = {
                        limitType: limitType_obj,
                        limitValue: AsJsonNum(src.limitValue),
                    };
                    return dst;
                }

                static create(src?: SettlementSetup_createType) {
                    const dst = new SettlementSetup();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.limitType !== undefined) {
                        dst.limitType = src.limitType;
                    }
                    if (src.limitValue !== undefined) {
                        dst.limitValue = src.limitValue;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SettlementSetup();
                    dst.limitType = this.limitType;
                    dst.limitValue = this.limitValue;
                    return dst;
                }

                deepClone() {
                    const json = SettlementSetup.toObject(this);
                    const dst = SettlementSetup.fromObject(json);
                    return dst;
                }
            }
            export type ISettlementSetup = SettlementSetup;


            export type MaterialFactors_keys = 'mConcrete' | 'mTimber' | 'mSteel' | 'mOther';
            export interface MaterialFactors_createType {
                mConcrete?: number,
                mTimber?: number,
                mSteel?: number,
                mOther?: number,
            }
            export interface MaterialFactors_json {
                mConcrete?: JsonNumber;
                mTimber?: JsonNumber;
                mSteel?: JsonNumber;
                mOther?: JsonNumber;
            }
            interface MaterialFactors_json_in {
                __proto_name?: unknown;
                mConcrete?: unknown;
                mTimber?: unknown;
                mSteel?: unknown;
                mOther?: unknown;
            }
            export class MaterialFactors {
                __proto_name = "ng.design.soil.MaterialFactors";
                mConcrete: number = 0;
                mTimber: number = 0;
                mSteel: number = 0;
                mOther: number = 0;

                static fromObject(src_unknown: unknown): MaterialFactors {
                    const dst = new MaterialFactors();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MaterialFactors but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MaterialFactors_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MaterialFactors but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.mConcrete !== undefined && src.mConcrete !== null) {
                        if (typeof src.mConcrete === "number" || src.mConcrete === 'NaN' || src.mConcrete === 'Infinity' || src.mConcrete === '-Infinity') {
                            dst.mConcrete = AsNum(src.mConcrete);
                        }
                        else {
                            console.log('Expected mConcrete of MaterialFactors to be a number but was ', typeof src.mConcrete, src.mConcrete)
                        }
                    }
                    if (src.mTimber !== undefined && src.mTimber !== null) {
                        if (typeof src.mTimber === "number" || src.mTimber === 'NaN' || src.mTimber === 'Infinity' || src.mTimber === '-Infinity') {
                            dst.mTimber = AsNum(src.mTimber);
                        }
                        else {
                            console.log('Expected mTimber of MaterialFactors to be a number but was ', typeof src.mTimber, src.mTimber)
                        }
                    }
                    if (src.mSteel !== undefined && src.mSteel !== null) {
                        if (typeof src.mSteel === "number" || src.mSteel === 'NaN' || src.mSteel === 'Infinity' || src.mSteel === '-Infinity') {
                            dst.mSteel = AsNum(src.mSteel);
                        }
                        else {
                            console.log('Expected mSteel of MaterialFactors to be a number but was ', typeof src.mSteel, src.mSteel)
                        }
                    }
                    if (src.mOther !== undefined && src.mOther !== null) {
                        if (typeof src.mOther === "number" || src.mOther === 'NaN' || src.mOther === 'Infinity' || src.mOther === '-Infinity') {
                            dst.mOther = AsNum(src.mOther);
                        }
                        else {
                            console.log('Expected mOther of MaterialFactors to be a number but was ', typeof src.mOther, src.mOther)
                        }
                    }
                    return dst;
                }

                static toObject(src: MaterialFactors | null | undefined): MaterialFactors_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.MaterialFactors is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.MaterialFactors") {
                        console.error('Expected ng.design.soil.MaterialFactors but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MaterialFactors_json = {
                        mConcrete: AsJsonNum(src.mConcrete),
                        mTimber: AsJsonNum(src.mTimber),
                        mSteel: AsJsonNum(src.mSteel),
                        mOther: AsJsonNum(src.mOther),
                    };
                    return dst;
                }

                static create(src?: MaterialFactors_createType) {
                    const dst = new MaterialFactors();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.mConcrete !== undefined) {
                        dst.mConcrete = src.mConcrete;
                    }
                    if (src.mTimber !== undefined) {
                        dst.mTimber = src.mTimber;
                    }
                    if (src.mSteel !== undefined) {
                        dst.mSteel = src.mSteel;
                    }
                    if (src.mOther !== undefined) {
                        dst.mOther = src.mOther;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MaterialFactors();
                    dst.mConcrete = this.mConcrete;
                    dst.mTimber = this.mTimber;
                    dst.mSteel = this.mSteel;
                    dst.mOther = this.mOther;
                    return dst;
                }

                deepClone() {
                    const json = MaterialFactors.toObject(this);
                    const dst = MaterialFactors.fromObject(json);
                    return dst;
                }
            }
            export type IMaterialFactors = MaterialFactors;


            export type ModelFactor_keys = 'gammaBeta' | 'gammaAlfaDrained' | 'gammaAlfaUndrained' | 'gammaRock';
            export interface ModelFactor_createType {
                gammaBeta?: number,
                gammaAlfaDrained?: number,
                gammaAlfaUndrained?: number,
                gammaRock?: number,
            }
            export interface ModelFactor_json {
                gammaBeta?: JsonNumber;
                gammaAlfaDrained?: JsonNumber;
                gammaAlfaUndrained?: JsonNumber;
                gammaRock?: JsonNumber;
            }
            interface ModelFactor_json_in {
                __proto_name?: unknown;
                gammaBeta?: unknown;
                gammaAlfaDrained?: unknown;
                gammaAlfaUndrained?: unknown;
                gammaRock?: unknown;
            }
            export class ModelFactor {
                __proto_name = "ng.design.soil.ModelFactor";
                gammaBeta: number = 0;
                gammaAlfaDrained: number = 0;
                gammaAlfaUndrained: number = 0;
                gammaRock: number = 0;

                static fromObject(src_unknown: unknown): ModelFactor {
                    const dst = new ModelFactor();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ModelFactor but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ModelFactor_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ModelFactor but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaBeta !== undefined && src.gammaBeta !== null) {
                        if (typeof src.gammaBeta === "number" || src.gammaBeta === 'NaN' || src.gammaBeta === 'Infinity' || src.gammaBeta === '-Infinity') {
                            dst.gammaBeta = AsNum(src.gammaBeta);
                        }
                        else {
                            console.log('Expected gammaBeta of ModelFactor to be a number but was ', typeof src.gammaBeta, src.gammaBeta)
                        }
                    }
                    if (src.gammaAlfaDrained !== undefined && src.gammaAlfaDrained !== null) {
                        if (typeof src.gammaAlfaDrained === "number" || src.gammaAlfaDrained === 'NaN' || src.gammaAlfaDrained === 'Infinity' || src.gammaAlfaDrained === '-Infinity') {
                            dst.gammaAlfaDrained = AsNum(src.gammaAlfaDrained);
                        }
                        else {
                            console.log('Expected gammaAlfaDrained of ModelFactor to be a number but was ', typeof src.gammaAlfaDrained, src.gammaAlfaDrained)
                        }
                    }
                    if (src.gammaAlfaUndrained !== undefined && src.gammaAlfaUndrained !== null) {
                        if (typeof src.gammaAlfaUndrained === "number" || src.gammaAlfaUndrained === 'NaN' || src.gammaAlfaUndrained === 'Infinity' || src.gammaAlfaUndrained === '-Infinity') {
                            dst.gammaAlfaUndrained = AsNum(src.gammaAlfaUndrained);
                        }
                        else {
                            console.log('Expected gammaAlfaUndrained of ModelFactor to be a number but was ', typeof src.gammaAlfaUndrained, src.gammaAlfaUndrained)
                        }
                    }
                    if (src.gammaRock !== undefined && src.gammaRock !== null) {
                        if (typeof src.gammaRock === "number" || src.gammaRock === 'NaN' || src.gammaRock === 'Infinity' || src.gammaRock === '-Infinity') {
                            dst.gammaRock = AsNum(src.gammaRock);
                        }
                        else {
                            console.log('Expected gammaRock of ModelFactor to be a number but was ', typeof src.gammaRock, src.gammaRock)
                        }
                    }
                    return dst;
                }

                static toObject(src: ModelFactor | null | undefined): ModelFactor_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.ModelFactor is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.ModelFactor") {
                        console.error('Expected ng.design.soil.ModelFactor but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ModelFactor_json = {
                        gammaBeta: AsJsonNum(src.gammaBeta),
                        gammaAlfaDrained: AsJsonNum(src.gammaAlfaDrained),
                        gammaAlfaUndrained: AsJsonNum(src.gammaAlfaUndrained),
                        gammaRock: AsJsonNum(src.gammaRock),
                    };
                    return dst;
                }

                static create(src?: ModelFactor_createType) {
                    const dst = new ModelFactor();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaBeta !== undefined) {
                        dst.gammaBeta = src.gammaBeta;
                    }
                    if (src.gammaAlfaDrained !== undefined) {
                        dst.gammaAlfaDrained = src.gammaAlfaDrained;
                    }
                    if (src.gammaAlfaUndrained !== undefined) {
                        dst.gammaAlfaUndrained = src.gammaAlfaUndrained;
                    }
                    if (src.gammaRock !== undefined) {
                        dst.gammaRock = src.gammaRock;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ModelFactor();
                    dst.gammaBeta = this.gammaBeta;
                    dst.gammaAlfaDrained = this.gammaAlfaDrained;
                    dst.gammaAlfaUndrained = this.gammaAlfaUndrained;
                    dst.gammaRock = this.gammaRock;
                    return dst;
                }

                deepClone() {
                    const json = ModelFactor.toObject(this);
                    const dst = ModelFactor.fromObject(json);
                    return dst;
                }
            }
            export type IModelFactor = ModelFactor;


            export type ModelFactors_keys = 'modelfactorSc' | 'modelfactorSt' | 'modelfactorB';
            export interface ModelFactors_createType {
                modelfactorSc?: ng.design.soil.ModelFactor | null,
                modelfactorSt?: ng.design.soil.ModelFactor | null,
                modelfactorB?: ng.design.soil.ModelFactor | null,
            }
            export interface ModelFactors_json {
                modelfactorSc?: ng.design.soil.ModelFactor_json;
                modelfactorSt?: ng.design.soil.ModelFactor_json;
                modelfactorB?: ng.design.soil.ModelFactor_json;
            }
            interface ModelFactors_json_in {
                __proto_name?: unknown;
                modelfactorSc?: unknown;
                modelfactorSt?: unknown;
                modelfactorB?: unknown;
            }
            export class ModelFactors {
                __proto_name = "ng.design.soil.ModelFactors";
                modelfactorSc: ng.design.soil.ModelFactor | null = null;
                modelfactorSt: ng.design.soil.ModelFactor | null = null;
                modelfactorB: ng.design.soil.ModelFactor | null = null;

                static fromObject(src_unknown: unknown): ModelFactors {
                    const dst = new ModelFactors();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ModelFactors but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ModelFactors_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ModelFactors but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.modelfactorSc !== undefined && src.modelfactorSc !== null) {
                        dst.modelfactorSc = ng.design.soil.ModelFactor.fromObject(src.modelfactorSc);
                    }
                    if (src.modelfactorSt !== undefined && src.modelfactorSt !== null) {
                        dst.modelfactorSt = ng.design.soil.ModelFactor.fromObject(src.modelfactorSt);
                    }
                    if (src.modelfactorB !== undefined && src.modelfactorB !== null) {
                        dst.modelfactorB = ng.design.soil.ModelFactor.fromObject(src.modelfactorB);
                    }
                    return dst;
                }

                static toObject(src: ModelFactors | null | undefined): ModelFactors_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.ModelFactors is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.ModelFactors") {
                        console.error('Expected ng.design.soil.ModelFactors but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ModelFactors_json = {
                    };
                    if(src.modelfactorSc !== null)
                    {
                        const parsed = ng.design.soil.ModelFactor.toObject(src.modelfactorSc);
                        if(parsed === null) return null;
                        dst.modelfactorSc = parsed;
                    }
                    if(src.modelfactorSt !== null)
                    {
                        const parsed = ng.design.soil.ModelFactor.toObject(src.modelfactorSt);
                        if(parsed === null) return null;
                        dst.modelfactorSt = parsed;
                    }
                    if(src.modelfactorB !== null)
                    {
                        const parsed = ng.design.soil.ModelFactor.toObject(src.modelfactorB);
                        if(parsed === null) return null;
                        dst.modelfactorB = parsed;
                    }
                    return dst;
                }

                static create(src?: ModelFactors_createType) {
                    const dst = new ModelFactors();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.modelfactorSc !== undefined) {
                        dst.modelfactorSc = src.modelfactorSc;
                    }
                    if (src.modelfactorSt !== undefined) {
                        dst.modelfactorSt = src.modelfactorSt;
                    }
                    if (src.modelfactorB !== undefined) {
                        dst.modelfactorB = src.modelfactorB;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ModelFactors();
                    dst.modelfactorSc = this.modelfactorSc;
                    dst.modelfactorSt = this.modelfactorSt;
                    dst.modelfactorB = this.modelfactorB;
                    return dst;
                }

                deepClone() {
                    const json = ModelFactors.toObject(this);
                    const dst = ModelFactors.fromObject(json);
                    return dst;
                }
            }
            export type IModelFactors = ModelFactors;


            export type SettlementConfiguration_keys = 'checkAbsoluteSettlement' | 'absoluteSettlement';
            export interface SettlementConfiguration_createType {
                checkAbsoluteSettlement?: boolean,
                absoluteSettlement?: number,
            }
            export interface SettlementConfiguration_json {
                checkAbsoluteSettlement?: boolean;
                absoluteSettlement?: JsonNumber;
            }
            interface SettlementConfiguration_json_in {
                __proto_name?: unknown;
                checkAbsoluteSettlement?: unknown;
                absoluteSettlement?: unknown;
            }
            export class SettlementConfiguration {
                __proto_name = "ng.design.soil.SettlementConfiguration";
                checkAbsoluteSettlement: boolean = false;
                absoluteSettlement: number = 0;

                static fromObject(src_unknown: unknown): SettlementConfiguration {
                    const dst = new SettlementConfiguration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SettlementConfiguration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SettlementConfiguration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SettlementConfiguration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.checkAbsoluteSettlement !== undefined && src.checkAbsoluteSettlement !== null) {
                        if (typeof src.checkAbsoluteSettlement === "boolean") {
                            dst.checkAbsoluteSettlement = src.checkAbsoluteSettlement;
                        }
                        else {
                            console.log('Expected checkAbsoluteSettlement of SettlementConfiguration to be a boolean but was ', typeof src.checkAbsoluteSettlement, src.checkAbsoluteSettlement)
                        }
                    }
                    if (src.absoluteSettlement !== undefined && src.absoluteSettlement !== null) {
                        if (typeof src.absoluteSettlement === "number" || src.absoluteSettlement === 'NaN' || src.absoluteSettlement === 'Infinity' || src.absoluteSettlement === '-Infinity') {
                            dst.absoluteSettlement = AsNum(src.absoluteSettlement);
                        }
                        else {
                            console.log('Expected absoluteSettlement of SettlementConfiguration to be a number but was ', typeof src.absoluteSettlement, src.absoluteSettlement)
                        }
                    }
                    return dst;
                }

                static toObject(src: SettlementConfiguration | null | undefined): SettlementConfiguration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.SettlementConfiguration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.SettlementConfiguration") {
                        console.error('Expected ng.design.soil.SettlementConfiguration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SettlementConfiguration_json = {
                        checkAbsoluteSettlement: src.checkAbsoluteSettlement,
                        absoluteSettlement: AsJsonNum(src.absoluteSettlement),
                    };
                    return dst;
                }

                static create(src?: SettlementConfiguration_createType) {
                    const dst = new SettlementConfiguration();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.checkAbsoluteSettlement !== undefined) {
                        dst.checkAbsoluteSettlement = src.checkAbsoluteSettlement;
                    }
                    if (src.absoluteSettlement !== undefined) {
                        dst.absoluteSettlement = src.absoluteSettlement;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SettlementConfiguration();
                    dst.checkAbsoluteSettlement = this.checkAbsoluteSettlement;
                    dst.absoluteSettlement = this.absoluteSettlement;
                    return dst;
                }

                deepClone() {
                    const json = SettlementConfiguration.toObject(this);
                    const dst = SettlementConfiguration.fromObject(json);
                    return dst;
                }
            }
            export type ISettlementConfiguration = SettlementConfiguration;


            export type FoundationConfiguration_keys = 'designApproach';
            export interface FoundationConfiguration_createType {
                designApproach?: ng.design.soil.DesignApproach,
            }
            export interface FoundationConfiguration_json {
                designApproach?: string;
            }
            interface FoundationConfiguration_json_in {
                __proto_name?: unknown;
                designApproach?: unknown;
            }
            export class FoundationConfiguration {
                __proto_name = "ng.design.soil.FoundationConfiguration";
                designApproach: ng.design.soil.DesignApproach = ng.design.soil.DesignApproach.DESIGN_APPROACH_UNSPECIFIED;

                static fromObject(src_unknown: unknown): FoundationConfiguration {
                    const dst = new FoundationConfiguration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FoundationConfiguration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FoundationConfiguration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FoundationConfiguration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.designApproach !== undefined && src.designApproach !== null) {
                        dst.designApproach = ng.design.soil.DesignApproach_FromObject(src.designApproach);
                    }
                    return dst;
                }

                static toObject(src: FoundationConfiguration | null | undefined): FoundationConfiguration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.FoundationConfiguration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.FoundationConfiguration") {
                        console.error('Expected ng.design.soil.FoundationConfiguration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const designApproach_obj = ng.design.soil.DesignApproach_ToObject(src.designApproach);
                    if(designApproach_obj === null) return null;

                    const dst : FoundationConfiguration_json = {
                        designApproach: designApproach_obj,
                    };
                    return dst;
                }

                static create(src?: FoundationConfiguration_createType) {
                    const dst = new FoundationConfiguration();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.designApproach !== undefined) {
                        dst.designApproach = src.designApproach;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FoundationConfiguration();
                    dst.designApproach = this.designApproach;
                    return dst;
                }

                deepClone() {
                    const json = FoundationConfiguration.toObject(this);
                    const dst = FoundationConfiguration.fromObject(json);
                    return dst;
                }
            }
            export type IFoundationConfiguration = FoundationConfiguration;


            export type Compaction_keys = 'zp' | 'pcmax';
            export interface Compaction_createType {
                zp?: number,
                pcmax?: number,
            }
            export interface Compaction_json {
                zp?: JsonNumber;
                pcmax?: JsonNumber;
            }
            interface Compaction_json_in {
                __proto_name?: unknown;
                zp?: unknown;
                pcmax?: unknown;
            }
            export class Compaction {
                __proto_name = "ng.design.soil.Compaction";
                zp: number = 0;
                pcmax: number = 0;

                static fromObject(src_unknown: unknown): Compaction {
                    const dst = new Compaction();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Compaction but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Compaction_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Compaction but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.zp !== undefined && src.zp !== null) {
                        if (typeof src.zp === "number" || src.zp === 'NaN' || src.zp === 'Infinity' || src.zp === '-Infinity') {
                            dst.zp = AsNum(src.zp);
                        }
                        else {
                            console.log('Expected zp of Compaction to be a number but was ', typeof src.zp, src.zp)
                        }
                    }
                    if (src.pcmax !== undefined && src.pcmax !== null) {
                        if (typeof src.pcmax === "number" || src.pcmax === 'NaN' || src.pcmax === 'Infinity' || src.pcmax === '-Infinity') {
                            dst.pcmax = AsNum(src.pcmax);
                        }
                        else {
                            console.log('Expected pcmax of Compaction to be a number but was ', typeof src.pcmax, src.pcmax)
                        }
                    }
                    return dst;
                }

                static toObject(src: Compaction | null | undefined): Compaction_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.Compaction is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.Compaction") {
                        console.error('Expected ng.design.soil.Compaction but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Compaction_json = {
                        zp: AsJsonNum(src.zp),
                        pcmax: AsJsonNum(src.pcmax),
                    };
                    return dst;
                }

                static create(src?: Compaction_createType) {
                    const dst = new Compaction();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.zp !== undefined) {
                        dst.zp = src.zp;
                    }
                    if (src.pcmax !== undefined) {
                        dst.pcmax = src.pcmax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Compaction();
                    dst.zp = this.zp;
                    dst.pcmax = this.pcmax;
                    return dst;
                }

                deepClone() {
                    const json = Compaction.toObject(this);
                    const dst = Compaction.fromObject(json);
                    return dst;
                }
            }
            export type ICompaction = Compaction;


            export type FoundationElementConfiguration_keys = 'settlementConfiguration' | 'soilPunchingType' | 'foundationDistribution' | 'dephtFactor' | 'useB6' | 'noWaterInterface' | 'dssseMethod';
            export interface FoundationElementConfiguration_createType {
                settlementConfiguration?: ng.design.soil.SettlementConfiguration | null,
                soilPunchingType?: ng.design.soil.SoilPunchingType,
                foundationDistribution?: ng.design.soil.FoundationDistribution,
                dephtFactor?: boolean,
                useB6?: boolean,
                noWaterInterface?: boolean,
                dssseMethod?: boolean,
            }
            export interface FoundationElementConfiguration_json {
                settlementConfiguration?: ng.design.soil.SettlementConfiguration_json;
                soilPunchingType?: string;
                foundationDistribution?: string;
                dephtFactor?: boolean;
                useB6?: boolean;
                noWaterInterface?: boolean;
                dssseMethod?: boolean;
            }
            interface FoundationElementConfiguration_json_in {
                __proto_name?: unknown;
                settlementConfiguration?: unknown;
                soilPunchingType?: unknown;
                foundationDistribution?: unknown;
                dephtFactor?: unknown;
                useB6?: unknown;
                noWaterInterface?: unknown;
                dssseMethod?: unknown;
            }
            export class FoundationElementConfiguration {
                __proto_name = "ng.design.soil.FoundationElementConfiguration";
                settlementConfiguration: ng.design.soil.SettlementConfiguration | null = null;
                soilPunchingType: ng.design.soil.SoilPunchingType = ng.design.soil.SoilPunchingType.SOIL_PUNCHING_TYPE_UNSPECIFIED;
                foundationDistribution: ng.design.soil.FoundationDistribution = ng.design.soil.FoundationDistribution.FOUNDATION_DISTRIBUTION_UNSPECIFIED;
                dephtFactor: boolean = false;
                useB6: boolean = false;
                noWaterInterface: boolean = false;
                dssseMethod: boolean = false;

                static fromObject(src_unknown: unknown): FoundationElementConfiguration {
                    const dst = new FoundationElementConfiguration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FoundationElementConfiguration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FoundationElementConfiguration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FoundationElementConfiguration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.settlementConfiguration !== undefined && src.settlementConfiguration !== null) {
                        dst.settlementConfiguration = ng.design.soil.SettlementConfiguration.fromObject(src.settlementConfiguration);
                    }
                    if (src.soilPunchingType !== undefined && src.soilPunchingType !== null) {
                        dst.soilPunchingType = ng.design.soil.SoilPunchingType_FromObject(src.soilPunchingType);
                    }
                    if (src.foundationDistribution !== undefined && src.foundationDistribution !== null) {
                        dst.foundationDistribution = ng.design.soil.FoundationDistribution_FromObject(src.foundationDistribution);
                    }
                    if (src.dephtFactor !== undefined && src.dephtFactor !== null) {
                        if (typeof src.dephtFactor === "boolean") {
                            dst.dephtFactor = src.dephtFactor;
                        }
                        else {
                            console.log('Expected dephtFactor of FoundationElementConfiguration to be a boolean but was ', typeof src.dephtFactor, src.dephtFactor)
                        }
                    }
                    if (src.useB6 !== undefined && src.useB6 !== null) {
                        if (typeof src.useB6 === "boolean") {
                            dst.useB6 = src.useB6;
                        }
                        else {
                            console.log('Expected useB6 of FoundationElementConfiguration to be a boolean but was ', typeof src.useB6, src.useB6)
                        }
                    }
                    if (src.noWaterInterface !== undefined && src.noWaterInterface !== null) {
                        if (typeof src.noWaterInterface === "boolean") {
                            dst.noWaterInterface = src.noWaterInterface;
                        }
                        else {
                            console.log('Expected noWaterInterface of FoundationElementConfiguration to be a boolean but was ', typeof src.noWaterInterface, src.noWaterInterface)
                        }
                    }
                    if (src.dssseMethod !== undefined && src.dssseMethod !== null) {
                        if (typeof src.dssseMethod === "boolean") {
                            dst.dssseMethod = src.dssseMethod;
                        }
                        else {
                            console.log('Expected dssseMethod of FoundationElementConfiguration to be a boolean but was ', typeof src.dssseMethod, src.dssseMethod)
                        }
                    }
                    return dst;
                }

                static toObject(src: FoundationElementConfiguration | null | undefined): FoundationElementConfiguration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.FoundationElementConfiguration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.FoundationElementConfiguration") {
                        console.error('Expected ng.design.soil.FoundationElementConfiguration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const soilPunchingType_obj = ng.design.soil.SoilPunchingType_ToObject(src.soilPunchingType);
                    if(soilPunchingType_obj === null) return null;

                    const foundationDistribution_obj = ng.design.soil.FoundationDistribution_ToObject(src.foundationDistribution);
                    if(foundationDistribution_obj === null) return null;

                    const dst : FoundationElementConfiguration_json = {
                        soilPunchingType: soilPunchingType_obj,
                        foundationDistribution: foundationDistribution_obj,
                        dephtFactor: src.dephtFactor,
                        useB6: src.useB6,
                        noWaterInterface: src.noWaterInterface,
                        dssseMethod: src.dssseMethod,
                    };
                    if(src.settlementConfiguration !== null)
                    {
                        const parsed = ng.design.soil.SettlementConfiguration.toObject(src.settlementConfiguration);
                        if(parsed === null) return null;
                        dst.settlementConfiguration = parsed;
                    }
                    return dst;
                }

                static create(src?: FoundationElementConfiguration_createType) {
                    const dst = new FoundationElementConfiguration();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.settlementConfiguration !== undefined) {
                        dst.settlementConfiguration = src.settlementConfiguration;
                    }
                    if (src.soilPunchingType !== undefined) {
                        dst.soilPunchingType = src.soilPunchingType;
                    }
                    if (src.foundationDistribution !== undefined) {
                        dst.foundationDistribution = src.foundationDistribution;
                    }
                    if (src.dephtFactor !== undefined) {
                        dst.dephtFactor = src.dephtFactor;
                    }
                    if (src.useB6 !== undefined) {
                        dst.useB6 = src.useB6;
                    }
                    if (src.noWaterInterface !== undefined) {
                        dst.noWaterInterface = src.noWaterInterface;
                    }
                    if (src.dssseMethod !== undefined) {
                        dst.dssseMethod = src.dssseMethod;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FoundationElementConfiguration();
                    dst.settlementConfiguration = this.settlementConfiguration;
                    dst.soilPunchingType = this.soilPunchingType;
                    dst.foundationDistribution = this.foundationDistribution;
                    dst.dephtFactor = this.dephtFactor;
                    dst.useB6 = this.useB6;
                    dst.noWaterInterface = this.noWaterInterface;
                    dst.dssseMethod = this.dssseMethod;
                    return dst;
                }

                deepClone() {
                    const json = FoundationElementConfiguration.toObject(this);
                    const dst = FoundationElementConfiguration.fromObject(json);
                    return dst;
                }
            }
            export type IFoundationElementConfiguration = FoundationElementConfiguration;


            export type EarthPressureConfiguration_keys = unknown;
            export interface EarthPressureConfiguration_createType {
            }
            export interface EarthPressureConfiguration_json {
            }
            interface EarthPressureConfiguration_json_in {
                __proto_name?: unknown;
            }
            export class EarthPressureConfiguration {
                __proto_name = "ng.design.soil.EarthPressureConfiguration";

                static fromObject(src_unknown: unknown): EarthPressureConfiguration {
                    const dst = new EarthPressureConfiguration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EarthPressureConfiguration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EarthPressureConfiguration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EarthPressureConfiguration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: EarthPressureConfiguration | null | undefined): EarthPressureConfiguration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.EarthPressureConfiguration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.EarthPressureConfiguration") {
                        console.error('Expected ng.design.soil.EarthPressureConfiguration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EarthPressureConfiguration_json = {
                    };
                    return dst;
                }

                static create(src?: EarthPressureConfiguration_createType) {
                    const dst = new EarthPressureConfiguration();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EarthPressureConfiguration();
                    return dst;
                }

                deepClone() {
                    const json = EarthPressureConfiguration.toObject(this);
                    const dst = EarthPressureConfiguration.fromObject(json);
                    return dst;
                }
            }
            export type IEarthPressureConfiguration = EarthPressureConfiguration;


            export type EarthPressureElementConfiguration_keys = 'activeSoilFrictionCoef' | 'lambda' | 'lambdaAutocalculated' | 'compaction' | 'passiveEarthPressureType';
            export interface EarthPressureElementConfiguration_createType {
                activeSoilFrictionCoef?: number,
                lambda?: number,
                lambdaAutocalculated?: boolean,
                compaction?: ng.design.soil.Compaction | null,
                passiveEarthPressureType?: ng.design.soil.PassiveEarthPressureType,
            }
            export interface EarthPressureElementConfiguration_json {
                activeSoilFrictionCoef?: JsonNumber;
                lambda?: JsonNumber;
                lambdaAutocalculated?: boolean;
                compaction?: ng.design.soil.Compaction_json;
                passiveEarthPressureType?: string;
            }
            interface EarthPressureElementConfiguration_json_in {
                __proto_name?: unknown;
                activeSoilFrictionCoef?: unknown;
                lambda?: unknown;
                lambdaAutocalculated?: unknown;
                compaction?: unknown;
                passiveEarthPressureType?: unknown;
            }
            export class EarthPressureElementConfiguration {
                __proto_name = "ng.design.soil.EarthPressureElementConfiguration";
                activeSoilFrictionCoef: number = 0;
                lambda: number = 0;
                lambdaAutocalculated: boolean = false;
                compaction: ng.design.soil.Compaction | null = null;
                passiveEarthPressureType: ng.design.soil.PassiveEarthPressureType = ng.design.soil.PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): EarthPressureElementConfiguration {
                    const dst = new EarthPressureElementConfiguration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EarthPressureElementConfiguration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EarthPressureElementConfiguration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EarthPressureElementConfiguration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.activeSoilFrictionCoef !== undefined && src.activeSoilFrictionCoef !== null) {
                        if (typeof src.activeSoilFrictionCoef === "number" || src.activeSoilFrictionCoef === 'NaN' || src.activeSoilFrictionCoef === 'Infinity' || src.activeSoilFrictionCoef === '-Infinity') {
                            dst.activeSoilFrictionCoef = AsNum(src.activeSoilFrictionCoef);
                        }
                        else {
                            console.log('Expected activeSoilFrictionCoef of EarthPressureElementConfiguration to be a number but was ', typeof src.activeSoilFrictionCoef, src.activeSoilFrictionCoef)
                        }
                    }
                    if (src.lambda !== undefined && src.lambda !== null) {
                        if (typeof src.lambda === "number" || src.lambda === 'NaN' || src.lambda === 'Infinity' || src.lambda === '-Infinity') {
                            dst.lambda = AsNum(src.lambda);
                        }
                        else {
                            console.log('Expected lambda of EarthPressureElementConfiguration to be a number but was ', typeof src.lambda, src.lambda)
                        }
                    }
                    if (src.lambdaAutocalculated !== undefined && src.lambdaAutocalculated !== null) {
                        if (typeof src.lambdaAutocalculated === "boolean") {
                            dst.lambdaAutocalculated = src.lambdaAutocalculated;
                        }
                        else {
                            console.log('Expected lambdaAutocalculated of EarthPressureElementConfiguration to be a boolean but was ', typeof src.lambdaAutocalculated, src.lambdaAutocalculated)
                        }
                    }
                    if (src.compaction !== undefined && src.compaction !== null) {
                        dst.compaction = ng.design.soil.Compaction.fromObject(src.compaction);
                    }
                    if (src.passiveEarthPressureType !== undefined && src.passiveEarthPressureType !== null) {
                        dst.passiveEarthPressureType = ng.design.soil.PassiveEarthPressureType_FromObject(src.passiveEarthPressureType);
                    }
                    return dst;
                }

                static toObject(src: EarthPressureElementConfiguration | null | undefined): EarthPressureElementConfiguration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.EarthPressureElementConfiguration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.EarthPressureElementConfiguration") {
                        console.error('Expected ng.design.soil.EarthPressureElementConfiguration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const passiveEarthPressureType_obj = ng.design.soil.PassiveEarthPressureType_ToObject(src.passiveEarthPressureType);
                    if(passiveEarthPressureType_obj === null) return null;

                    const dst : EarthPressureElementConfiguration_json = {
                        activeSoilFrictionCoef: AsJsonNum(src.activeSoilFrictionCoef),
                        lambda: AsJsonNum(src.lambda),
                        lambdaAutocalculated: src.lambdaAutocalculated,
                        passiveEarthPressureType: passiveEarthPressureType_obj,
                    };
                    if(src.compaction !== null)
                    {
                        const parsed = ng.design.soil.Compaction.toObject(src.compaction);
                        if(parsed === null) return null;
                        dst.compaction = parsed;
                    }
                    return dst;
                }

                static create(src?: EarthPressureElementConfiguration_createType) {
                    const dst = new EarthPressureElementConfiguration();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.activeSoilFrictionCoef !== undefined) {
                        dst.activeSoilFrictionCoef = src.activeSoilFrictionCoef;
                    }
                    if (src.lambda !== undefined) {
                        dst.lambda = src.lambda;
                    }
                    if (src.lambdaAutocalculated !== undefined) {
                        dst.lambdaAutocalculated = src.lambdaAutocalculated;
                    }
                    if (src.compaction !== undefined) {
                        dst.compaction = src.compaction;
                    }
                    if (src.passiveEarthPressureType !== undefined) {
                        dst.passiveEarthPressureType = src.passiveEarthPressureType;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EarthPressureElementConfiguration();
                    dst.activeSoilFrictionCoef = this.activeSoilFrictionCoef;
                    dst.lambda = this.lambda;
                    dst.lambdaAutocalculated = this.lambdaAutocalculated;
                    dst.compaction = this.compaction;
                    dst.passiveEarthPressureType = this.passiveEarthPressureType;
                    return dst;
                }

                deepClone() {
                    const json = EarthPressureElementConfiguration.toObject(this);
                    const dst = EarthPressureElementConfiguration.fromObject(json);
                    return dst;
                }
            }
            export type IEarthPressureElementConfiguration = EarthPressureElementConfiguration;


            export type PileConfiguration_keys = 'designApproach' | 'materialFactors' | 'modelFactors';
            export interface PileConfiguration_createType {
                designApproach?: ng.design.soil.DesignApproach,
                materialFactors?: ng.design.soil.MaterialFactors | null,
                modelFactors?: ng.design.soil.ModelFactors | null,
            }
            export interface PileConfiguration_json {
                designApproach?: string;
                materialFactors?: ng.design.soil.MaterialFactors_json;
                modelFactors?: ng.design.soil.ModelFactors_json;
            }
            interface PileConfiguration_json_in {
                __proto_name?: unknown;
                designApproach?: unknown;
                materialFactors?: unknown;
                modelFactors?: unknown;
            }
            export class PileConfiguration {
                __proto_name = "ng.design.soil.PileConfiguration";
                designApproach: ng.design.soil.DesignApproach = ng.design.soil.DesignApproach.DESIGN_APPROACH_UNSPECIFIED;
                materialFactors: ng.design.soil.MaterialFactors | null = null;
                modelFactors: ng.design.soil.ModelFactors | null = null;

                static fromObject(src_unknown: unknown): PileConfiguration {
                    const dst = new PileConfiguration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PileConfiguration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PileConfiguration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PileConfiguration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.designApproach !== undefined && src.designApproach !== null) {
                        dst.designApproach = ng.design.soil.DesignApproach_FromObject(src.designApproach);
                    }
                    if (src.materialFactors !== undefined && src.materialFactors !== null) {
                        dst.materialFactors = ng.design.soil.MaterialFactors.fromObject(src.materialFactors);
                    }
                    if (src.modelFactors !== undefined && src.modelFactors !== null) {
                        dst.modelFactors = ng.design.soil.ModelFactors.fromObject(src.modelFactors);
                    }
                    return dst;
                }

                static toObject(src: PileConfiguration | null | undefined): PileConfiguration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.PileConfiguration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.PileConfiguration") {
                        console.error('Expected ng.design.soil.PileConfiguration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const designApproach_obj = ng.design.soil.DesignApproach_ToObject(src.designApproach);
                    if(designApproach_obj === null) return null;

                    const dst : PileConfiguration_json = {
                        designApproach: designApproach_obj,
                    };
                    if(src.materialFactors !== null)
                    {
                        const parsed = ng.design.soil.MaterialFactors.toObject(src.materialFactors);
                        if(parsed === null) return null;
                        dst.materialFactors = parsed;
                    }
                    if(src.modelFactors !== null)
                    {
                        const parsed = ng.design.soil.ModelFactors.toObject(src.modelFactors);
                        if(parsed === null) return null;
                        dst.modelFactors = parsed;
                    }
                    return dst;
                }

                static create(src?: PileConfiguration_createType) {
                    const dst = new PileConfiguration();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.designApproach !== undefined) {
                        dst.designApproach = src.designApproach;
                    }
                    if (src.materialFactors !== undefined) {
                        dst.materialFactors = src.materialFactors;
                    }
                    if (src.modelFactors !== undefined) {
                        dst.modelFactors = src.modelFactors;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PileConfiguration();
                    dst.designApproach = this.designApproach;
                    dst.materialFactors = this.materialFactors;
                    dst.modelFactors = this.modelFactors;
                    return dst;
                }

                deepClone() {
                    const json = PileConfiguration.toObject(this);
                    const dst = PileConfiguration.fromObject(json);
                    return dst;
                }
            }
            export type IPileConfiguration = PileConfiguration;


            export type PileElementConfiguration_keys = 'coorolationFactor';
            export interface PileElementConfiguration_createType {
                coorolationFactor?: number,
            }
            export interface PileElementConfiguration_json {
                coorolationFactor?: JsonNumber;
            }
            interface PileElementConfiguration_json_in {
                __proto_name?: unknown;
                coorolationFactor?: unknown;
            }
            export class PileElementConfiguration {
                __proto_name = "ng.design.soil.PileElementConfiguration";
                coorolationFactor: number = 0;

                static fromObject(src_unknown: unknown): PileElementConfiguration {
                    const dst = new PileElementConfiguration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PileElementConfiguration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PileElementConfiguration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PileElementConfiguration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coorolationFactor !== undefined && src.coorolationFactor !== null) {
                        if (typeof src.coorolationFactor === "number" || src.coorolationFactor === 'NaN' || src.coorolationFactor === 'Infinity' || src.coorolationFactor === '-Infinity') {
                            dst.coorolationFactor = AsNum(src.coorolationFactor);
                        }
                        else {
                            console.log('Expected coorolationFactor of PileElementConfiguration to be a number but was ', typeof src.coorolationFactor, src.coorolationFactor)
                        }
                    }
                    return dst;
                }

                static toObject(src: PileElementConfiguration | null | undefined): PileElementConfiguration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.PileElementConfiguration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.PileElementConfiguration") {
                        console.error('Expected ng.design.soil.PileElementConfiguration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PileElementConfiguration_json = {
                        coorolationFactor: AsJsonNum(src.coorolationFactor),
                    };
                    return dst;
                }

                static create(src?: PileElementConfiguration_createType) {
                    const dst = new PileElementConfiguration();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coorolationFactor !== undefined) {
                        dst.coorolationFactor = src.coorolationFactor;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PileElementConfiguration();
                    dst.coorolationFactor = this.coorolationFactor;
                    return dst;
                }

                deepClone() {
                    const json = PileElementConfiguration.toObject(this);
                    const dst = PileElementConfiguration.fromObject(json);
                    return dst;
                }
            }
            export type IPileElementConfiguration = PileElementConfiguration;


            export type GeneralDesignSettings_keys = 'partialCoeffs' | 'geotechnicalCategory' | 'settlementSetup' | 'foundationConfiguration' | 'earthPressureConfiguration' | 'pileConfiguration';
            export interface GeneralDesignSettings_createType {
                partialCoeffs?: ng.design.soil.PartialCoefficients | null,
                geotechnicalCategory?: ng.design.soil.GeotechnicalCategory,
                settlementSetup?: ng.design.soil.SettlementSetup[],
                foundationConfiguration?: ng.design.soil.FoundationConfiguration | null,
                earthPressureConfiguration?: ng.design.soil.EarthPressureConfiguration | null,
                pileConfiguration?: ng.design.soil.PileConfiguration | null,
            }
            export interface GeneralDesignSettings_json {
                partialCoeffs?: ng.design.soil.PartialCoefficients_json;
                geotechnicalCategory?: string;
                settlementSetup: ng.design.soil.SettlementSetup_json[];
                foundationConfiguration?: ng.design.soil.FoundationConfiguration_json;
                earthPressureConfiguration?: ng.design.soil.EarthPressureConfiguration_json;
                pileConfiguration?: ng.design.soil.PileConfiguration_json;
            }
            interface GeneralDesignSettings_json_in {
                __proto_name?: unknown;
                partialCoeffs?: unknown;
                geotechnicalCategory?: unknown;
                settlementSetup?: unknown;
                foundationConfiguration?: unknown;
                earthPressureConfiguration?: unknown;
                pileConfiguration?: unknown;
            }
            export class GeneralDesignSettings {
                __proto_name = "ng.design.soil.GeneralDesignSettings";
                partialCoeffs: ng.design.soil.PartialCoefficients | null = null;
                geotechnicalCategory: ng.design.soil.GeotechnicalCategory = ng.design.soil.GeotechnicalCategory.GEOTECHNICAL_CATEGORY_UNSPECIFIED;
                settlementSetup: ng.design.soil.SettlementSetup[] = [];
                foundationConfiguration: ng.design.soil.FoundationConfiguration | null = null;
                earthPressureConfiguration: ng.design.soil.EarthPressureConfiguration | null = null;
                pileConfiguration: ng.design.soil.PileConfiguration | null = null;

                static fromObject(src_unknown: unknown): GeneralDesignSettings {
                    const dst = new GeneralDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined && src.partialCoeffs !== null) {
                        dst.partialCoeffs = ng.design.soil.PartialCoefficients.fromObject(src.partialCoeffs);
                    }
                    if (src.geotechnicalCategory !== undefined && src.geotechnicalCategory !== null) {
                        dst.geotechnicalCategory = ng.design.soil.GeotechnicalCategory_FromObject(src.geotechnicalCategory);
                    }
                    if (src.settlementSetup !== undefined && src.settlementSetup !== null) {
                        if (Array.isArray(src.settlementSetup)) {
                            for (const element of src.settlementSetup) {
                                dst.settlementSetup.push(ng.design.soil.SettlementSetup.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected settlementSetup of GeneralDesignSettings to be a array but was ', typeof src.settlementSetup, src.settlementSetup)
                        }
                    }
                    if (src.foundationConfiguration !== undefined && src.foundationConfiguration !== null) {
                        dst.foundationConfiguration = ng.design.soil.FoundationConfiguration.fromObject(src.foundationConfiguration);
                    }
                    if (src.earthPressureConfiguration !== undefined && src.earthPressureConfiguration !== null) {
                        dst.earthPressureConfiguration = ng.design.soil.EarthPressureConfiguration.fromObject(src.earthPressureConfiguration);
                    }
                    if (src.pileConfiguration !== undefined && src.pileConfiguration !== null) {
                        dst.pileConfiguration = ng.design.soil.PileConfiguration.fromObject(src.pileConfiguration);
                    }
                    return dst;
                }

                static toObject(src: GeneralDesignSettings | null | undefined): GeneralDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.GeneralDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.GeneralDesignSettings") {
                        console.error('Expected ng.design.soil.GeneralDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const geotechnicalCategory_obj = ng.design.soil.GeotechnicalCategory_ToObject(src.geotechnicalCategory);
                    if(geotechnicalCategory_obj === null) return null;

                    const dst : GeneralDesignSettings_json = {
                        geotechnicalCategory: geotechnicalCategory_obj,
                        settlementSetup: new Array<ng.design.soil.SettlementSetup_json>(),
                    };
                    if(src.partialCoeffs !== null)
                    {
                        const parsed = ng.design.soil.PartialCoefficients.toObject(src.partialCoeffs);
                        if(parsed === null) return null;
                        dst.partialCoeffs = parsed;
                    }
                    if (src.settlementSetup !== null) {
                        for (const element of src.settlementSetup) {
                            const parsed = ng.design.soil.SettlementSetup.toObject(element);
                            if(parsed === null) return null;
                            dst.settlementSetup.push(parsed);
                        }
                    }
                    if(src.foundationConfiguration !== null)
                    {
                        const parsed = ng.design.soil.FoundationConfiguration.toObject(src.foundationConfiguration);
                        if(parsed === null) return null;
                        dst.foundationConfiguration = parsed;
                    }
                    if(src.earthPressureConfiguration !== null)
                    {
                        const parsed = ng.design.soil.EarthPressureConfiguration.toObject(src.earthPressureConfiguration);
                        if(parsed === null) return null;
                        dst.earthPressureConfiguration = parsed;
                    }
                    if(src.pileConfiguration !== null)
                    {
                        const parsed = ng.design.soil.PileConfiguration.toObject(src.pileConfiguration);
                        if(parsed === null) return null;
                        dst.pileConfiguration = parsed;
                    }
                    return dst;
                }

                static create(src?: GeneralDesignSettings_createType) {
                    const dst = new GeneralDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined) {
                        dst.partialCoeffs = src.partialCoeffs;
                    }
                    if (src.geotechnicalCategory !== undefined) {
                        dst.geotechnicalCategory = src.geotechnicalCategory;
                    }
                    if (src.settlementSetup !== undefined) {
                        dst.settlementSetup = src.settlementSetup;
                    }
                    if (src.foundationConfiguration !== undefined) {
                        dst.foundationConfiguration = src.foundationConfiguration;
                    }
                    if (src.earthPressureConfiguration !== undefined) {
                        dst.earthPressureConfiguration = src.earthPressureConfiguration;
                    }
                    if (src.pileConfiguration !== undefined) {
                        dst.pileConfiguration = src.pileConfiguration;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralDesignSettings();
                    dst.partialCoeffs = this.partialCoeffs;
                    dst.geotechnicalCategory = this.geotechnicalCategory;
                    dst.settlementSetup = this.settlementSetup;
                    dst.foundationConfiguration = this.foundationConfiguration;
                    dst.earthPressureConfiguration = this.earthPressureConfiguration;
                    dst.pileConfiguration = this.pileConfiguration;
                    return dst;
                }

                deepClone() {
                    const json = GeneralDesignSettings.toObject(this);
                    const dst = GeneralDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralDesignSettings = GeneralDesignSettings;


            export type ElementDesignSettings_keys = 'foundationElementConfiguration' | 'earthPressureElementConfiguration' | 'pileElementConfiguration';
            export interface ElementDesignSettings_createType {
                foundationElementConfiguration?: ng.design.soil.FoundationElementConfiguration | null,
                earthPressureElementConfiguration?: ng.design.soil.EarthPressureElementConfiguration | null,
                pileElementConfiguration?: ng.design.soil.PileElementConfiguration | null,
            }
            export interface ElementDesignSettings_json {
                foundationElementConfiguration?: ng.design.soil.FoundationElementConfiguration_json;
                earthPressureElementConfiguration?: ng.design.soil.EarthPressureElementConfiguration_json;
                pileElementConfiguration?: ng.design.soil.PileElementConfiguration_json;
            }
            interface ElementDesignSettings_json_in {
                __proto_name?: unknown;
                foundationElementConfiguration?: unknown;
                earthPressureElementConfiguration?: unknown;
                pileElementConfiguration?: unknown;
            }
            export class ElementDesignSettings {
                __proto_name = "ng.design.soil.ElementDesignSettings";
                foundationElementConfiguration: ng.design.soil.FoundationElementConfiguration | null = null;
                earthPressureElementConfiguration: ng.design.soil.EarthPressureElementConfiguration | null = null;
                pileElementConfiguration: ng.design.soil.PileElementConfiguration | null = null;

                static fromObject(src_unknown: unknown): ElementDesignSettings {
                    const dst = new ElementDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ElementDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ElementDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ElementDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.foundationElementConfiguration !== undefined && src.foundationElementConfiguration !== null) {
                        dst.foundationElementConfiguration = ng.design.soil.FoundationElementConfiguration.fromObject(src.foundationElementConfiguration);
                    }
                    if (src.earthPressureElementConfiguration !== undefined && src.earthPressureElementConfiguration !== null) {
                        dst.earthPressureElementConfiguration = ng.design.soil.EarthPressureElementConfiguration.fromObject(src.earthPressureElementConfiguration);
                    }
                    if (src.pileElementConfiguration !== undefined && src.pileElementConfiguration !== null) {
                        dst.pileElementConfiguration = ng.design.soil.PileElementConfiguration.fromObject(src.pileElementConfiguration);
                    }
                    return dst;
                }

                static toObject(src: ElementDesignSettings | null | undefined): ElementDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.soil.ElementDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.soil.ElementDesignSettings") {
                        console.error('Expected ng.design.soil.ElementDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ElementDesignSettings_json = {
                    };
                    if(src.foundationElementConfiguration !== null)
                    {
                        const parsed = ng.design.soil.FoundationElementConfiguration.toObject(src.foundationElementConfiguration);
                        if(parsed === null) return null;
                        dst.foundationElementConfiguration = parsed;
                    }
                    if(src.earthPressureElementConfiguration !== null)
                    {
                        const parsed = ng.design.soil.EarthPressureElementConfiguration.toObject(src.earthPressureElementConfiguration);
                        if(parsed === null) return null;
                        dst.earthPressureElementConfiguration = parsed;
                    }
                    if(src.pileElementConfiguration !== null)
                    {
                        const parsed = ng.design.soil.PileElementConfiguration.toObject(src.pileElementConfiguration);
                        if(parsed === null) return null;
                        dst.pileElementConfiguration = parsed;
                    }
                    return dst;
                }

                static create(src?: ElementDesignSettings_createType) {
                    const dst = new ElementDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.foundationElementConfiguration !== undefined) {
                        dst.foundationElementConfiguration = src.foundationElementConfiguration;
                    }
                    if (src.earthPressureElementConfiguration !== undefined) {
                        dst.earthPressureElementConfiguration = src.earthPressureElementConfiguration;
                    }
                    if (src.pileElementConfiguration !== undefined) {
                        dst.pileElementConfiguration = src.pileElementConfiguration;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ElementDesignSettings();
                    dst.foundationElementConfiguration = this.foundationElementConfiguration;
                    dst.earthPressureElementConfiguration = this.earthPressureElementConfiguration;
                    dst.pileElementConfiguration = this.pileElementConfiguration;
                    return dst;
                }

                deepClone() {
                    const json = ElementDesignSettings.toObject(this);
                    const dst = ElementDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IElementDesignSettings = ElementDesignSettings;
        } // namespace soil


        // Defined in Design/concrete.proto
        export namespace concrete {
            export enum BeamSide {
                BEAM_SIDE_UNSPECIFIED = 0,
                BEAM_SIDE_START = 1,
                BEAM_SIDE_END = 2,
                BEAM_SIDE_BOTTOM = 3,
                BEAM_SIDE_RIGHT = 4,
                BEAM_SIDE_TOP = 5,
                BEAM_SIDE_LEFT = 6
            }
            export const BeamSide_FromObject = (src: unknown): BeamSide => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'BEAM_SIDE_UNSPECIFIED':
                        return BeamSide.BEAM_SIDE_UNSPECIFIED;
                    case 1:
                    case 'BEAM_SIDE_START':
                        return BeamSide.BEAM_SIDE_START;
                    case 2:
                    case 'BEAM_SIDE_END':
                        return BeamSide.BEAM_SIDE_END;
                    case 3:
                    case 'BEAM_SIDE_BOTTOM':
                        return BeamSide.BEAM_SIDE_BOTTOM;
                    case 4:
                    case 'BEAM_SIDE_RIGHT':
                        return BeamSide.BEAM_SIDE_RIGHT;
                    case 5:
                    case 'BEAM_SIDE_TOP':
                        return BeamSide.BEAM_SIDE_TOP;
                    case 6:
                    case 'BEAM_SIDE_LEFT':
                        return BeamSide.BEAM_SIDE_LEFT;
                    default:
                        console.log('Unhandled value for BeamSide:' + src + '. ' + typeof(src));
                        return BeamSide.BEAM_SIDE_UNSPECIFIED;
                }
            };
            export const BeamSide_ToObject = (src: BeamSide): string | null => {
                switch (src) {
                    case BeamSide.BEAM_SIDE_UNSPECIFIED:
                        return 'BEAM_SIDE_UNSPECIFIED';
                    case BeamSide.BEAM_SIDE_START:
                        return 'BEAM_SIDE_START';
                    case BeamSide.BEAM_SIDE_END:
                        return 'BEAM_SIDE_END';
                    case BeamSide.BEAM_SIDE_BOTTOM:
                        return 'BEAM_SIDE_BOTTOM';
                    case BeamSide.BEAM_SIDE_RIGHT:
                        return 'BEAM_SIDE_RIGHT';
                    case BeamSide.BEAM_SIDE_TOP:
                        return 'BEAM_SIDE_TOP';
                    case BeamSide.BEAM_SIDE_LEFT:
                        return 'BEAM_SIDE_LEFT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for BeamSide, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Aggregates {
                AGGREGATE_UNSPECIFIED = 0,
                AGGREGATE_SILICEOUS = 1,
                AGGREGATE_CALCAREOUS = 2,
                AGGREGATE_DK_SILICEOUS = 3,
                AGGREGATE_DK_CALCAREOUS = 4
            }
            export const Aggregates_FromObject = (src: unknown): Aggregates => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'AGGREGATE_UNSPECIFIED':
                        return Aggregates.AGGREGATE_UNSPECIFIED;
                    case 1:
                    case 'AGGREGATE_SILICEOUS':
                        return Aggregates.AGGREGATE_SILICEOUS;
                    case 2:
                    case 'AGGREGATE_CALCAREOUS':
                        return Aggregates.AGGREGATE_CALCAREOUS;
                    case 3:
                    case 'AGGREGATE_DK_SILICEOUS':
                        return Aggregates.AGGREGATE_DK_SILICEOUS;
                    case 4:
                    case 'AGGREGATE_DK_CALCAREOUS':
                        return Aggregates.AGGREGATE_DK_CALCAREOUS;
                    default:
                        console.log('Unhandled value for Aggregates:' + src + '. ' + typeof(src));
                        return Aggregates.AGGREGATE_UNSPECIFIED;
                }
            };
            export const Aggregates_ToObject = (src: Aggregates): string | null => {
                switch (src) {
                    case Aggregates.AGGREGATE_UNSPECIFIED:
                        return 'AGGREGATE_UNSPECIFIED';
                    case Aggregates.AGGREGATE_SILICEOUS:
                        return 'AGGREGATE_SILICEOUS';
                    case Aggregates.AGGREGATE_CALCAREOUS:
                        return 'AGGREGATE_CALCAREOUS';
                    case Aggregates.AGGREGATE_DK_SILICEOUS:
                        return 'AGGREGATE_DK_SILICEOUS';
                    case Aggregates.AGGREGATE_DK_CALCAREOUS:
                        return 'AGGREGATE_DK_CALCAREOUS';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Aggregates, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ManufacturingType {
                MANUFACTURING_TYPE_UNSPECIFIED = 0,
                MANUFACTURING_TYPE_HOT_ROLLED = 1,
                MANUFACTURING_TYPE_QUENCHED = 2,
                MANUFACTURING_TYPE_COLD_WORKED = 3,
                MANUFACTURING_TYPE_MIN_Q_C = 4,
                MANUFACTURING_TYPE_MIN_Q_C_AC = 5,
                MANUFACTURING_TYPE_COLD_WORKED_PRESTRESSED = 6,
                MANUFACTURING_TYPE_QUENCHED_TEMPERED_PRESTRESSED = 7
            }
            export const ManufacturingType_FromObject = (src: unknown): ManufacturingType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'MANUFACTURING_TYPE_UNSPECIFIED':
                        return ManufacturingType.MANUFACTURING_TYPE_UNSPECIFIED;
                    case 1:
                    case 'MANUFACTURING_TYPE_HOT_ROLLED':
                        return ManufacturingType.MANUFACTURING_TYPE_HOT_ROLLED;
                    case 2:
                    case 'MANUFACTURING_TYPE_QUENCHED':
                        return ManufacturingType.MANUFACTURING_TYPE_QUENCHED;
                    case 3:
                    case 'MANUFACTURING_TYPE_COLD_WORKED':
                        return ManufacturingType.MANUFACTURING_TYPE_COLD_WORKED;
                    case 4:
                    case 'MANUFACTURING_TYPE_MIN_Q_C':
                        return ManufacturingType.MANUFACTURING_TYPE_MIN_Q_C;
                    case 5:
                    case 'MANUFACTURING_TYPE_MIN_Q_C_AC':
                        return ManufacturingType.MANUFACTURING_TYPE_MIN_Q_C_AC;
                    case 6:
                    case 'MANUFACTURING_TYPE_COLD_WORKED_PRESTRESSED':
                        return ManufacturingType.MANUFACTURING_TYPE_COLD_WORKED_PRESTRESSED;
                    case 7:
                    case 'MANUFACTURING_TYPE_QUENCHED_TEMPERED_PRESTRESSED':
                        return ManufacturingType.MANUFACTURING_TYPE_QUENCHED_TEMPERED_PRESTRESSED;
                    default:
                        console.log('Unhandled value for ManufacturingType:' + src + '. ' + typeof(src));
                        return ManufacturingType.MANUFACTURING_TYPE_UNSPECIFIED;
                }
            };
            export const ManufacturingType_ToObject = (src: ManufacturingType): string | null => {
                switch (src) {
                    case ManufacturingType.MANUFACTURING_TYPE_UNSPECIFIED:
                        return 'MANUFACTURING_TYPE_UNSPECIFIED';
                    case ManufacturingType.MANUFACTURING_TYPE_HOT_ROLLED:
                        return 'MANUFACTURING_TYPE_HOT_ROLLED';
                    case ManufacturingType.MANUFACTURING_TYPE_QUENCHED:
                        return 'MANUFACTURING_TYPE_QUENCHED';
                    case ManufacturingType.MANUFACTURING_TYPE_COLD_WORKED:
                        return 'MANUFACTURING_TYPE_COLD_WORKED';
                    case ManufacturingType.MANUFACTURING_TYPE_MIN_Q_C:
                        return 'MANUFACTURING_TYPE_MIN_Q_C';
                    case ManufacturingType.MANUFACTURING_TYPE_MIN_Q_C_AC:
                        return 'MANUFACTURING_TYPE_MIN_Q_C_AC';
                    case ManufacturingType.MANUFACTURING_TYPE_COLD_WORKED_PRESTRESSED:
                        return 'MANUFACTURING_TYPE_COLD_WORKED_PRESTRESSED';
                    case ManufacturingType.MANUFACTURING_TYPE_QUENCHED_TEMPERED_PRESTRESSED:
                        return 'MANUFACTURING_TYPE_QUENCHED_TEMPERED_PRESTRESSED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ManufacturingType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SurfaceType {
                SURFACE_TYPE_UNSPECIFIED = 0,
                SURFACE_TYPE_VERY_SMOOTH = 1,
                SURFACE_TYPE_SMOOTH = 2,
                SURFACE_TYPE_ROUGH = 3,
                SURFACE_TYPE_INDENTED = 4
            }
            export const SurfaceType_FromObject = (src: unknown): SurfaceType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SURFACE_TYPE_UNSPECIFIED':
                        return SurfaceType.SURFACE_TYPE_UNSPECIFIED;
                    case 1:
                    case 'SURFACE_TYPE_VERY_SMOOTH':
                        return SurfaceType.SURFACE_TYPE_VERY_SMOOTH;
                    case 2:
                    case 'SURFACE_TYPE_SMOOTH':
                        return SurfaceType.SURFACE_TYPE_SMOOTH;
                    case 3:
                    case 'SURFACE_TYPE_ROUGH':
                        return SurfaceType.SURFACE_TYPE_ROUGH;
                    case 4:
                    case 'SURFACE_TYPE_INDENTED':
                        return SurfaceType.SURFACE_TYPE_INDENTED;
                    default:
                        console.log('Unhandled value for SurfaceType:' + src + '. ' + typeof(src));
                        return SurfaceType.SURFACE_TYPE_UNSPECIFIED;
                }
            };
            export const SurfaceType_ToObject = (src: SurfaceType): string | null => {
                switch (src) {
                    case SurfaceType.SURFACE_TYPE_UNSPECIFIED:
                        return 'SURFACE_TYPE_UNSPECIFIED';
                    case SurfaceType.SURFACE_TYPE_VERY_SMOOTH:
                        return 'SURFACE_TYPE_VERY_SMOOTH';
                    case SurfaceType.SURFACE_TYPE_SMOOTH:
                        return 'SURFACE_TYPE_SMOOTH';
                    case SurfaceType.SURFACE_TYPE_ROUGH:
                        return 'SURFACE_TYPE_ROUGH';
                    case SurfaceType.SURFACE_TYPE_INDENTED:
                        return 'SURFACE_TYPE_INDENTED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SurfaceType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ShearDesignType {
                SHEAR_DESIGN_TYPE_UNSPECIFIED = 0,
                SHEAR_DESIGN_TYPE_WITHOUT_SHEAR_REINFORCEMENT = 1,
                SHEAR_DESIGN_TYPE_WITH_SHEAR_REINFORCEMENT = 2
            }
            export const ShearDesignType_FromObject = (src: unknown): ShearDesignType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SHEAR_DESIGN_TYPE_UNSPECIFIED':
                        return ShearDesignType.SHEAR_DESIGN_TYPE_UNSPECIFIED;
                    case 1:
                    case 'SHEAR_DESIGN_TYPE_WITHOUT_SHEAR_REINFORCEMENT':
                        return ShearDesignType.SHEAR_DESIGN_TYPE_WITHOUT_SHEAR_REINFORCEMENT;
                    case 2:
                    case 'SHEAR_DESIGN_TYPE_WITH_SHEAR_REINFORCEMENT':
                        return ShearDesignType.SHEAR_DESIGN_TYPE_WITH_SHEAR_REINFORCEMENT;
                    default:
                        console.log('Unhandled value for ShearDesignType:' + src + '. ' + typeof(src));
                        return ShearDesignType.SHEAR_DESIGN_TYPE_UNSPECIFIED;
                }
            };
            export const ShearDesignType_ToObject = (src: ShearDesignType): string | null => {
                switch (src) {
                    case ShearDesignType.SHEAR_DESIGN_TYPE_UNSPECIFIED:
                        return 'SHEAR_DESIGN_TYPE_UNSPECIFIED';
                    case ShearDesignType.SHEAR_DESIGN_TYPE_WITHOUT_SHEAR_REINFORCEMENT:
                        return 'SHEAR_DESIGN_TYPE_WITHOUT_SHEAR_REINFORCEMENT';
                    case ShearDesignType.SHEAR_DESIGN_TYPE_WITH_SHEAR_REINFORCEMENT:
                        return 'SHEAR_DESIGN_TYPE_WITH_SHEAR_REINFORCEMENT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ShearDesignType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum SecondOrderMethod {
                SECOND_ORDER_METHOD_UNSPECIFIED = 0,
                SECOND_ORDER_METHOD_STIFFNESS = 1,
                SECOND_ORDER_METHOD_CURVATURE = 2
            }
            export const SecondOrderMethod_FromObject = (src: unknown): SecondOrderMethod => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SECOND_ORDER_METHOD_UNSPECIFIED':
                        return SecondOrderMethod.SECOND_ORDER_METHOD_UNSPECIFIED;
                    case 1:
                    case 'SECOND_ORDER_METHOD_STIFFNESS':
                        return SecondOrderMethod.SECOND_ORDER_METHOD_STIFFNESS;
                    case 2:
                    case 'SECOND_ORDER_METHOD_CURVATURE':
                        return SecondOrderMethod.SECOND_ORDER_METHOD_CURVATURE;
                    default:
                        console.log('Unhandled value for SecondOrderMethod:' + src + '. ' + typeof(src));
                        return SecondOrderMethod.SECOND_ORDER_METHOD_UNSPECIFIED;
                }
            };
            export const SecondOrderMethod_ToObject = (src: SecondOrderMethod): string | null => {
                switch (src) {
                    case SecondOrderMethod.SECOND_ORDER_METHOD_UNSPECIFIED:
                        return 'SECOND_ORDER_METHOD_UNSPECIFIED';
                    case SecondOrderMethod.SECOND_ORDER_METHOD_STIFFNESS:
                        return 'SECOND_ORDER_METHOD_STIFFNESS';
                    case SecondOrderMethod.SECOND_ORDER_METHOD_CURVATURE:
                        return 'SECOND_ORDER_METHOD_CURVATURE';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SecondOrderMethod, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum WebShearCapacityMethod {
                WEB_SHEAR_CAPACITY_METHOD_UNSPECIFIED = 0,
                WEB_SHEAR_CAPACITY_METHOD_STANDARD = 1,
                WEB_SHEAR_CAPACITY_METHOD_ADVANCED = 2,
                WEB_SHEAR_CAPACITY_METHOD_SIMPLIFIED = 3
            }
            export const WebShearCapacityMethod_FromObject = (src: unknown): WebShearCapacityMethod => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'WEB_SHEAR_CAPACITY_METHOD_UNSPECIFIED':
                        return WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_UNSPECIFIED;
                    case 1:
                    case 'WEB_SHEAR_CAPACITY_METHOD_STANDARD':
                        return WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_STANDARD;
                    case 2:
                    case 'WEB_SHEAR_CAPACITY_METHOD_ADVANCED':
                        return WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_ADVANCED;
                    case 3:
                    case 'WEB_SHEAR_CAPACITY_METHOD_SIMPLIFIED':
                        return WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_SIMPLIFIED;
                    default:
                        console.log('Unhandled value for WebShearCapacityMethod:' + src + '. ' + typeof(src));
                        return WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_UNSPECIFIED;
                }
            };
            export const WebShearCapacityMethod_ToObject = (src: WebShearCapacityMethod): string | null => {
                switch (src) {
                    case WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_UNSPECIFIED:
                        return 'WEB_SHEAR_CAPACITY_METHOD_UNSPECIFIED';
                    case WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_STANDARD:
                        return 'WEB_SHEAR_CAPACITY_METHOD_STANDARD';
                    case WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_ADVANCED:
                        return 'WEB_SHEAR_CAPACITY_METHOD_ADVANCED';
                    case WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_SIMPLIFIED:
                        return 'WEB_SHEAR_CAPACITY_METHOD_SIMPLIFIED';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for WebShearCapacityMethod, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Fabrication {
                FABRICATION_UNSPECIFIED = 0,
                FABRICATION_IN_SITU = 1,
                FABRICATION_PREFAB = 2
            }
            export const Fabrication_FromObject = (src: unknown): Fabrication => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'FABRICATION_UNSPECIFIED':
                        return Fabrication.FABRICATION_UNSPECIFIED;
                    case 1:
                    case 'FABRICATION_IN_SITU':
                        return Fabrication.FABRICATION_IN_SITU;
                    case 2:
                    case 'FABRICATION_PREFAB':
                        return Fabrication.FABRICATION_PREFAB;
                    default:
                        console.log('Unhandled value for Fabrication:' + src + '. ' + typeof(src));
                        return Fabrication.FABRICATION_UNSPECIFIED;
                }
            };
            export const Fabrication_ToObject = (src: Fabrication): string | null => {
                switch (src) {
                    case Fabrication.FABRICATION_UNSPECIFIED:
                        return 'FABRICATION_UNSPECIFIED';
                    case Fabrication.FABRICATION_IN_SITU:
                        return 'FABRICATION_IN_SITU';
                    case Fabrication.FABRICATION_PREFAB:
                        return 'FABRICATION_PREFAB';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Fabrication, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ConstructionClass {
                CONSTRUCTION_CLASS_UNSPECIFIED = 0,
                CONSTRUCTION_CLASS_1 = 1,
                CONSTRUCTION_CLASS_2 = 2
            }
            export const ConstructionClass_FromObject = (src: unknown): ConstructionClass => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CONSTRUCTION_CLASS_UNSPECIFIED':
                        return ConstructionClass.CONSTRUCTION_CLASS_UNSPECIFIED;
                    case 1:
                    case 'CONSTRUCTION_CLASS_1':
                        return ConstructionClass.CONSTRUCTION_CLASS_1;
                    case 2:
                    case 'CONSTRUCTION_CLASS_2':
                        return ConstructionClass.CONSTRUCTION_CLASS_2;
                    default:
                        console.log('Unhandled value for ConstructionClass:' + src + '. ' + typeof(src));
                        return ConstructionClass.CONSTRUCTION_CLASS_UNSPECIFIED;
                }
            };
            export const ConstructionClass_ToObject = (src: ConstructionClass): string | null => {
                switch (src) {
                    case ConstructionClass.CONSTRUCTION_CLASS_UNSPECIFIED:
                        return 'CONSTRUCTION_CLASS_UNSPECIFIED';
                    case ConstructionClass.CONSTRUCTION_CLASS_1:
                        return 'CONSTRUCTION_CLASS_1';
                    case ConstructionClass.CONSTRUCTION_CLASS_2:
                        return 'CONSTRUCTION_CLASS_2';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ConstructionClass, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum FctmType {
                FCTM_TYPE_UNSPECIFIED = 0,
                FCTM_TYPE_FCTM = 1,
                FCTM_TYPE_FCTM_FL = 2,
                FCTM_TYPE_FCTM_XI = 3
            }
            export const FctmType_FromObject = (src: unknown): FctmType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'FCTM_TYPE_UNSPECIFIED':
                        return FctmType.FCTM_TYPE_UNSPECIFIED;
                    case 1:
                    case 'FCTM_TYPE_FCTM':
                        return FctmType.FCTM_TYPE_FCTM;
                    case 2:
                    case 'FCTM_TYPE_FCTM_FL':
                        return FctmType.FCTM_TYPE_FCTM_FL;
                    case 3:
                    case 'FCTM_TYPE_FCTM_XI':
                        return FctmType.FCTM_TYPE_FCTM_XI;
                    default:
                        console.log('Unhandled value for FctmType:' + src + '. ' + typeof(src));
                        return FctmType.FCTM_TYPE_UNSPECIFIED;
                }
            };
            export const FctmType_ToObject = (src: FctmType): string | null => {
                switch (src) {
                    case FctmType.FCTM_TYPE_UNSPECIFIED:
                        return 'FCTM_TYPE_UNSPECIFIED';
                    case FctmType.FCTM_TYPE_FCTM:
                        return 'FCTM_TYPE_FCTM';
                    case FctmType.FCTM_TYPE_FCTM_FL:
                        return 'FCTM_TYPE_FCTM_FL';
                    case FctmType.FCTM_TYPE_FCTM_XI:
                        return 'FCTM_TYPE_FCTM_XI';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for FctmType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Commands {
                COMMANDS_UNSPECIFIED = 0,
                COMMANDS_STIRRUP_DESIGN = 1,
                COMMANDS_PUNCHING_CHECK = 2,
                COMMANDS_SPALLING_CHECK = 3
            }
            export const Commands_FromObject = (src: unknown): Commands => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'COMMANDS_UNSPECIFIED':
                        return Commands.COMMANDS_UNSPECIFIED;
                    case 1:
                    case 'COMMANDS_STIRRUP_DESIGN':
                        return Commands.COMMANDS_STIRRUP_DESIGN;
                    case 2:
                    case 'COMMANDS_PUNCHING_CHECK':
                        return Commands.COMMANDS_PUNCHING_CHECK;
                    case 3:
                    case 'COMMANDS_SPALLING_CHECK':
                        return Commands.COMMANDS_SPALLING_CHECK;
                    default:
                        console.log('Unhandled value for Commands:' + src + '. ' + typeof(src));
                        return Commands.COMMANDS_UNSPECIFIED;
                }
            };
            export const Commands_ToObject = (src: Commands): string | null => {
                switch (src) {
                    case Commands.COMMANDS_UNSPECIFIED:
                        return 'COMMANDS_UNSPECIFIED';
                    case Commands.COMMANDS_STIRRUP_DESIGN:
                        return 'COMMANDS_STIRRUP_DESIGN';
                    case Commands.COMMANDS_PUNCHING_CHECK:
                        return 'COMMANDS_PUNCHING_CHECK';
                    case Commands.COMMANDS_SPALLING_CHECK:
                        return 'COMMANDS_SPALLING_CHECK';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Commands, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PartialCoefficient_keys = 'gammaCompression' | 'gammaTension' | 'gammaReinforcement' | 'gammaCe' | 'alfaCc' | 'alfaCt' | 'gammaShear';
            export interface PartialCoefficient_createType {
                gammaCompression?: number,
                gammaTension?: number,
                gammaReinforcement?: number,
                gammaCe?: number,
                alfaCc?: number,
                alfaCt?: number,
                gammaShear?: number,
            }
            export interface PartialCoefficient_json {
                gammaCompression?: JsonNumber;
                gammaTension?: JsonNumber;
                gammaReinforcement?: JsonNumber;
                gammaCe?: JsonNumber;
                alfaCc?: JsonNumber;
                alfaCt?: JsonNumber;
                gammaShear?: JsonNumber;
            }
            interface PartialCoefficient_json_in {
                __proto_name?: unknown;
                gammaCompression?: unknown;
                gammaTension?: unknown;
                gammaReinforcement?: unknown;
                gammaCe?: unknown;
                alfaCc?: unknown;
                alfaCt?: unknown;
                gammaShear?: unknown;
            }
            export class PartialCoefficient {
                __proto_name = "ng.design.concrete.PartialCoefficient";
                gammaCompression: number = 0;
                gammaTension: number = 0;
                gammaReinforcement: number = 0;
                gammaCe: number = 0;
                alfaCc: number = 0;
                alfaCt: number = 0;
                gammaShear: number = 0;

                static fromObject(src_unknown: unknown): PartialCoefficient {
                    const dst = new PartialCoefficient();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficient but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficient_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficient but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaCompression !== undefined && src.gammaCompression !== null) {
                        if (typeof src.gammaCompression === "number" || src.gammaCompression === 'NaN' || src.gammaCompression === 'Infinity' || src.gammaCompression === '-Infinity') {
                            dst.gammaCompression = AsNum(src.gammaCompression);
                        }
                        else {
                            console.log('Expected gammaCompression of PartialCoefficient to be a number but was ', typeof src.gammaCompression, src.gammaCompression)
                        }
                    }
                    if (src.gammaTension !== undefined && src.gammaTension !== null) {
                        if (typeof src.gammaTension === "number" || src.gammaTension === 'NaN' || src.gammaTension === 'Infinity' || src.gammaTension === '-Infinity') {
                            dst.gammaTension = AsNum(src.gammaTension);
                        }
                        else {
                            console.log('Expected gammaTension of PartialCoefficient to be a number but was ', typeof src.gammaTension, src.gammaTension)
                        }
                    }
                    if (src.gammaReinforcement !== undefined && src.gammaReinforcement !== null) {
                        if (typeof src.gammaReinforcement === "number" || src.gammaReinforcement === 'NaN' || src.gammaReinforcement === 'Infinity' || src.gammaReinforcement === '-Infinity') {
                            dst.gammaReinforcement = AsNum(src.gammaReinforcement);
                        }
                        else {
                            console.log('Expected gammaReinforcement of PartialCoefficient to be a number but was ', typeof src.gammaReinforcement, src.gammaReinforcement)
                        }
                    }
                    if (src.gammaCe !== undefined && src.gammaCe !== null) {
                        if (typeof src.gammaCe === "number" || src.gammaCe === 'NaN' || src.gammaCe === 'Infinity' || src.gammaCe === '-Infinity') {
                            dst.gammaCe = AsNum(src.gammaCe);
                        }
                        else {
                            console.log('Expected gammaCe of PartialCoefficient to be a number but was ', typeof src.gammaCe, src.gammaCe)
                        }
                    }
                    if (src.alfaCc !== undefined && src.alfaCc !== null) {
                        if (typeof src.alfaCc === "number" || src.alfaCc === 'NaN' || src.alfaCc === 'Infinity' || src.alfaCc === '-Infinity') {
                            dst.alfaCc = AsNum(src.alfaCc);
                        }
                        else {
                            console.log('Expected alfaCc of PartialCoefficient to be a number but was ', typeof src.alfaCc, src.alfaCc)
                        }
                    }
                    if (src.alfaCt !== undefined && src.alfaCt !== null) {
                        if (typeof src.alfaCt === "number" || src.alfaCt === 'NaN' || src.alfaCt === 'Infinity' || src.alfaCt === '-Infinity') {
                            dst.alfaCt = AsNum(src.alfaCt);
                        }
                        else {
                            console.log('Expected alfaCt of PartialCoefficient to be a number but was ', typeof src.alfaCt, src.alfaCt)
                        }
                    }
                    if (src.gammaShear !== undefined && src.gammaShear !== null) {
                        if (typeof src.gammaShear === "number" || src.gammaShear === 'NaN' || src.gammaShear === 'Infinity' || src.gammaShear === '-Infinity') {
                            dst.gammaShear = AsNum(src.gammaShear);
                        }
                        else {
                            console.log('Expected gammaShear of PartialCoefficient to be a number but was ', typeof src.gammaShear, src.gammaShear)
                        }
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficient | null | undefined): PartialCoefficient_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.PartialCoefficient is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.PartialCoefficient") {
                        console.error('Expected ng.design.concrete.PartialCoefficient but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficient_json = {
                        gammaCompression: AsJsonNum(src.gammaCompression),
                        gammaTension: AsJsonNum(src.gammaTension),
                        gammaReinforcement: AsJsonNum(src.gammaReinforcement),
                        gammaCe: AsJsonNum(src.gammaCe),
                        alfaCc: AsJsonNum(src.alfaCc),
                        alfaCt: AsJsonNum(src.alfaCt),
                        gammaShear: AsJsonNum(src.gammaShear),
                    };
                    return dst;
                }

                static create(src?: PartialCoefficient_createType) {
                    const dst = new PartialCoefficient();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaCompression !== undefined) {
                        dst.gammaCompression = src.gammaCompression;
                    }
                    if (src.gammaTension !== undefined) {
                        dst.gammaTension = src.gammaTension;
                    }
                    if (src.gammaReinforcement !== undefined) {
                        dst.gammaReinforcement = src.gammaReinforcement;
                    }
                    if (src.gammaCe !== undefined) {
                        dst.gammaCe = src.gammaCe;
                    }
                    if (src.alfaCc !== undefined) {
                        dst.alfaCc = src.alfaCc;
                    }
                    if (src.alfaCt !== undefined) {
                        dst.alfaCt = src.alfaCt;
                    }
                    if (src.gammaShear !== undefined) {
                        dst.gammaShear = src.gammaShear;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficient();
                    dst.gammaCompression = this.gammaCompression;
                    dst.gammaTension = this.gammaTension;
                    dst.gammaReinforcement = this.gammaReinforcement;
                    dst.gammaCe = this.gammaCe;
                    dst.alfaCc = this.alfaCc;
                    dst.alfaCt = this.alfaCt;
                    dst.gammaShear = this.gammaShear;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficient.toObject(this);
                    const dst = PartialCoefficient.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficient = PartialCoefficient;


            export type PartialCoefficients_keys = 'ultimate' | 'accidental' | 'seismic' | 'fire' | 'service';
            export interface PartialCoefficients_createType {
                ultimate?: ng.design.concrete.PartialCoefficient | null,
                accidental?: ng.design.concrete.PartialCoefficient | null,
                seismic?: ng.design.concrete.PartialCoefficient | null,
                fire?: ng.design.concrete.PartialCoefficient | null,
                service?: ng.design.concrete.PartialCoefficient | null,
            }
            export interface PartialCoefficients_json {
                ultimate?: ng.design.concrete.PartialCoefficient_json;
                accidental?: ng.design.concrete.PartialCoefficient_json;
                seismic?: ng.design.concrete.PartialCoefficient_json;
                fire?: ng.design.concrete.PartialCoefficient_json;
                service?: ng.design.concrete.PartialCoefficient_json;
            }
            interface PartialCoefficients_json_in {
                __proto_name?: unknown;
                ultimate?: unknown;
                accidental?: unknown;
                seismic?: unknown;
                fire?: unknown;
                service?: unknown;
            }
            export class PartialCoefficients {
                __proto_name = "ng.design.concrete.PartialCoefficients";
                ultimate: ng.design.concrete.PartialCoefficient | null = null;
                accidental: ng.design.concrete.PartialCoefficient | null = null;
                seismic: ng.design.concrete.PartialCoefficient | null = null;
                fire: ng.design.concrete.PartialCoefficient | null = null;
                service: ng.design.concrete.PartialCoefficient | null = null;

                static fromObject(src_unknown: unknown): PartialCoefficients {
                    const dst = new PartialCoefficients();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficients but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficients_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficients but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ultimate !== undefined && src.ultimate !== null) {
                        dst.ultimate = ng.design.concrete.PartialCoefficient.fromObject(src.ultimate);
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        dst.accidental = ng.design.concrete.PartialCoefficient.fromObject(src.accidental);
                    }
                    if (src.seismic !== undefined && src.seismic !== null) {
                        dst.seismic = ng.design.concrete.PartialCoefficient.fromObject(src.seismic);
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.concrete.PartialCoefficient.fromObject(src.fire);
                    }
                    if (src.service !== undefined && src.service !== null) {
                        dst.service = ng.design.concrete.PartialCoefficient.fromObject(src.service);
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficients | null | undefined): PartialCoefficients_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.PartialCoefficients is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.PartialCoefficients") {
                        console.error('Expected ng.design.concrete.PartialCoefficients but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficients_json = {
                    };
                    if(src.ultimate !== null)
                    {
                        const parsed = ng.design.concrete.PartialCoefficient.toObject(src.ultimate);
                        if(parsed === null) return null;
                        dst.ultimate = parsed;
                    }
                    if(src.accidental !== null)
                    {
                        const parsed = ng.design.concrete.PartialCoefficient.toObject(src.accidental);
                        if(parsed === null) return null;
                        dst.accidental = parsed;
                    }
                    if(src.seismic !== null)
                    {
                        const parsed = ng.design.concrete.PartialCoefficient.toObject(src.seismic);
                        if(parsed === null) return null;
                        dst.seismic = parsed;
                    }
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.concrete.PartialCoefficient.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    if(src.service !== null)
                    {
                        const parsed = ng.design.concrete.PartialCoefficient.toObject(src.service);
                        if(parsed === null) return null;
                        dst.service = parsed;
                    }
                    return dst;
                }

                static create(src?: PartialCoefficients_createType) {
                    const dst = new PartialCoefficients();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ultimate !== undefined) {
                        dst.ultimate = src.ultimate;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    if (src.seismic !== undefined) {
                        dst.seismic = src.seismic;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    if (src.service !== undefined) {
                        dst.service = src.service;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficients();
                    dst.ultimate = this.ultimate;
                    dst.accidental = this.accidental;
                    dst.seismic = this.seismic;
                    dst.fire = this.fire;
                    dst.service = this.service;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficients.toObject(this);
                    const dst = PartialCoefficients.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficients = PartialCoefficients;


            export type CoverAndSpace_keys = 'cover' | 'space' | 'side';
            export interface CoverAndSpace_createType {
                cover?: number,
                space?: number,
                side?: ng.design.concrete.BeamSide,
            }
            export interface CoverAndSpace_json {
                cover?: JsonNumber;
                space?: JsonNumber;
                side?: string;
            }
            interface CoverAndSpace_json_in {
                __proto_name?: unknown;
                cover?: unknown;
                space?: unknown;
                side?: unknown;
            }
            export class CoverAndSpace {
                __proto_name = "ng.design.concrete.CoverAndSpace";
                cover: number = 0;
                space: number = 0;
                side: ng.design.concrete.BeamSide = ng.design.concrete.BeamSide.BEAM_SIDE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): CoverAndSpace {
                    const dst = new CoverAndSpace();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CoverAndSpace but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CoverAndSpace_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CoverAndSpace but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.cover !== undefined && src.cover !== null) {
                        if (typeof src.cover === "number" || src.cover === 'NaN' || src.cover === 'Infinity' || src.cover === '-Infinity') {
                            dst.cover = AsNum(src.cover);
                        }
                        else {
                            console.log('Expected cover of CoverAndSpace to be a number but was ', typeof src.cover, src.cover)
                        }
                    }
                    if (src.space !== undefined && src.space !== null) {
                        if (typeof src.space === "number" || src.space === 'NaN' || src.space === 'Infinity' || src.space === '-Infinity') {
                            dst.space = AsNum(src.space);
                        }
                        else {
                            console.log('Expected space of CoverAndSpace to be a number but was ', typeof src.space, src.space)
                        }
                    }
                    if (src.side !== undefined && src.side !== null) {
                        dst.side = ng.design.concrete.BeamSide_FromObject(src.side);
                    }
                    return dst;
                }

                static toObject(src: CoverAndSpace | null | undefined): CoverAndSpace_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.CoverAndSpace is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.CoverAndSpace") {
                        console.error('Expected ng.design.concrete.CoverAndSpace but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const side_obj = ng.design.concrete.BeamSide_ToObject(src.side);
                    if(side_obj === null) return null;

                    const dst : CoverAndSpace_json = {
                        cover: AsJsonNum(src.cover),
                        space: AsJsonNum(src.space),
                        side: side_obj,
                    };
                    return dst;
                }

                static create(src?: CoverAndSpace_createType) {
                    const dst = new CoverAndSpace();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.cover !== undefined) {
                        dst.cover = src.cover;
                    }
                    if (src.space !== undefined) {
                        dst.space = src.space;
                    }
                    if (src.side !== undefined) {
                        dst.side = src.side;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CoverAndSpace();
                    dst.cover = this.cover;
                    dst.space = this.space;
                    dst.side = this.side;
                    return dst;
                }

                deepClone() {
                    const json = CoverAndSpace.toObject(this);
                    const dst = CoverAndSpace.fromObject(json);
                    return dst;
                }
            }
            export type ICoverAndSpace = CoverAndSpace;


            export type FireBeam_keys = 'upperSide' | 'bottomSide' | 'leftSide' | 'rightSide' | 'fireTime' | 'aggregate' | 'use02Epsilon' | 'manufacturingRebars' | 'manufacturingStrands';
            export interface FireBeam_createType {
                upperSide?: boolean,
                bottomSide?: boolean,
                leftSide?: boolean,
                rightSide?: boolean,
                fireTime?: number,
                aggregate?: ng.design.concrete.Aggregates,
                use02Epsilon?: boolean,
                manufacturingRebars?: ng.design.concrete.ManufacturingType,
                manufacturingStrands?: ng.design.concrete.ManufacturingType,
            }
            export interface FireBeam_json {
                upperSide?: boolean;
                bottomSide?: boolean;
                leftSide?: boolean;
                rightSide?: boolean;
                fireTime?: JsonNumber;
                aggregate?: string;
                use02Epsilon?: boolean;
                manufacturingRebars?: string;
                manufacturingStrands?: string;
            }
            interface FireBeam_json_in {
                __proto_name?: unknown;
                upperSide?: unknown;
                bottomSide?: unknown;
                leftSide?: unknown;
                rightSide?: unknown;
                fireTime?: unknown;
                aggregate?: unknown;
                use02Epsilon?: unknown;
                manufacturingRebars?: unknown;
                manufacturingStrands?: unknown;
            }
            export class FireBeam {
                __proto_name = "ng.design.concrete.FireBeam";
                upperSide: boolean = false;
                bottomSide: boolean = false;
                leftSide: boolean = false;
                rightSide: boolean = false;
                fireTime: number = 0;
                aggregate: ng.design.concrete.Aggregates = ng.design.concrete.Aggregates.AGGREGATE_UNSPECIFIED;
                use02Epsilon: boolean = false;
                manufacturingRebars: ng.design.concrete.ManufacturingType = ng.design.concrete.ManufacturingType.MANUFACTURING_TYPE_UNSPECIFIED;
                manufacturingStrands: ng.design.concrete.ManufacturingType = ng.design.concrete.ManufacturingType.MANUFACTURING_TYPE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): FireBeam {
                    const dst = new FireBeam();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FireBeam but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FireBeam_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FireBeam but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.upperSide !== undefined && src.upperSide !== null) {
                        if (typeof src.upperSide === "boolean") {
                            dst.upperSide = src.upperSide;
                        }
                        else {
                            console.log('Expected upperSide of FireBeam to be a boolean but was ', typeof src.upperSide, src.upperSide)
                        }
                    }
                    if (src.bottomSide !== undefined && src.bottomSide !== null) {
                        if (typeof src.bottomSide === "boolean") {
                            dst.bottomSide = src.bottomSide;
                        }
                        else {
                            console.log('Expected bottomSide of FireBeam to be a boolean but was ', typeof src.bottomSide, src.bottomSide)
                        }
                    }
                    if (src.leftSide !== undefined && src.leftSide !== null) {
                        if (typeof src.leftSide === "boolean") {
                            dst.leftSide = src.leftSide;
                        }
                        else {
                            console.log('Expected leftSide of FireBeam to be a boolean but was ', typeof src.leftSide, src.leftSide)
                        }
                    }
                    if (src.rightSide !== undefined && src.rightSide !== null) {
                        if (typeof src.rightSide === "boolean") {
                            dst.rightSide = src.rightSide;
                        }
                        else {
                            console.log('Expected rightSide of FireBeam to be a boolean but was ', typeof src.rightSide, src.rightSide)
                        }
                    }
                    if (src.fireTime !== undefined && src.fireTime !== null) {
                        if (typeof src.fireTime === "number" || src.fireTime === 'NaN' || src.fireTime === 'Infinity' || src.fireTime === '-Infinity') {
                            dst.fireTime = NumberToInt("ng.design.concrete.FireBeam.fire_time", AsNum(src.fireTime));
                        }
                        else {
                            console.log('Expected fireTime of FireBeam to be a number but was ', typeof src.fireTime, src.fireTime)
                        }
                    }
                    if (src.aggregate !== undefined && src.aggregate !== null) {
                        dst.aggregate = ng.design.concrete.Aggregates_FromObject(src.aggregate);
                    }
                    if (src.use02Epsilon !== undefined && src.use02Epsilon !== null) {
                        if (typeof src.use02Epsilon === "boolean") {
                            dst.use02Epsilon = src.use02Epsilon;
                        }
                        else {
                            console.log('Expected use02Epsilon of FireBeam to be a boolean but was ', typeof src.use02Epsilon, src.use02Epsilon)
                        }
                    }
                    if (src.manufacturingRebars !== undefined && src.manufacturingRebars !== null) {
                        dst.manufacturingRebars = ng.design.concrete.ManufacturingType_FromObject(src.manufacturingRebars);
                    }
                    if (src.manufacturingStrands !== undefined && src.manufacturingStrands !== null) {
                        dst.manufacturingStrands = ng.design.concrete.ManufacturingType_FromObject(src.manufacturingStrands);
                    }
                    return dst;
                }

                static toObject(src: FireBeam | null | undefined): FireBeam_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.FireBeam is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.FireBeam") {
                        console.error('Expected ng.design.concrete.FireBeam but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const aggregate_obj = ng.design.concrete.Aggregates_ToObject(src.aggregate);
                    if(aggregate_obj === null) return null;

                    const manufacturingRebars_obj = ng.design.concrete.ManufacturingType_ToObject(src.manufacturingRebars);
                    if(manufacturingRebars_obj === null) return null;

                    const manufacturingStrands_obj = ng.design.concrete.ManufacturingType_ToObject(src.manufacturingStrands);
                    if(manufacturingStrands_obj === null) return null;

                    const dst : FireBeam_json = {
                        upperSide: src.upperSide,
                        bottomSide: src.bottomSide,
                        leftSide: src.leftSide,
                        rightSide: src.rightSide,
                        fireTime: AsJsonNum(NumberToInt("ng.design.concrete.FireBeam.fire_time", src.fireTime)),
                        aggregate: aggregate_obj,
                        use02Epsilon: src.use02Epsilon,
                        manufacturingRebars: manufacturingRebars_obj,
                        manufacturingStrands: manufacturingStrands_obj,
                    };
                    return dst;
                }

                static create(src?: FireBeam_createType) {
                    const dst = new FireBeam();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.upperSide !== undefined) {
                        dst.upperSide = src.upperSide;
                    }
                    if (src.bottomSide !== undefined) {
                        dst.bottomSide = src.bottomSide;
                    }
                    if (src.leftSide !== undefined) {
                        dst.leftSide = src.leftSide;
                    }
                    if (src.rightSide !== undefined) {
                        dst.rightSide = src.rightSide;
                    }
                    if (src.fireTime !== undefined) {
                        dst.fireTime = src.fireTime;
                    }
                    if (src.aggregate !== undefined) {
                        dst.aggregate = src.aggregate;
                    }
                    if (src.use02Epsilon !== undefined) {
                        dst.use02Epsilon = src.use02Epsilon;
                    }
                    if (src.manufacturingRebars !== undefined) {
                        dst.manufacturingRebars = src.manufacturingRebars;
                    }
                    if (src.manufacturingStrands !== undefined) {
                        dst.manufacturingStrands = src.manufacturingStrands;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FireBeam();
                    dst.upperSide = this.upperSide;
                    dst.bottomSide = this.bottomSide;
                    dst.leftSide = this.leftSide;
                    dst.rightSide = this.rightSide;
                    dst.fireTime = this.fireTime;
                    dst.aggregate = this.aggregate;
                    dst.use02Epsilon = this.use02Epsilon;
                    dst.manufacturingRebars = this.manufacturingRebars;
                    dst.manufacturingStrands = this.manufacturingStrands;
                    return dst;
                }

                deepClone() {
                    const json = FireBeam.toObject(this);
                    const dst = FireBeam.fromObject(json);
                    return dst;
                }
            }
            export type IFireBeam = FireBeam;


            export type Beam_keys = 'surfaceType' | 'shearDesignType' | 'useMinReinf' | 'monolithic' | 'fire' | 'considerAsSlab' | 'secondOrderMethod';
            export interface Beam_createType {
                surfaceType?: ng.design.concrete.SurfaceType,
                shearDesignType?: ng.design.concrete.ShearDesignType,
                useMinReinf?: boolean,
                monolithic?: boolean,
                fire?: ng.design.concrete.FireBeam | null,
                considerAsSlab?: boolean,
                secondOrderMethod?: ng.design.concrete.SecondOrderMethod,
            }
            export interface Beam_json {
                surfaceType?: string;
                shearDesignType?: string;
                useMinReinf?: boolean;
                monolithic?: boolean;
                fire?: ng.design.concrete.FireBeam_json;
                considerAsSlab?: boolean;
                secondOrderMethod?: string;
            }
            interface Beam_json_in {
                __proto_name?: unknown;
                surfaceType?: unknown;
                shearDesignType?: unknown;
                useMinReinf?: unknown;
                monolithic?: unknown;
                fire?: unknown;
                considerAsSlab?: unknown;
                secondOrderMethod?: unknown;
            }
            export class Beam {
                __proto_name = "ng.design.concrete.Beam";
                surfaceType: ng.design.concrete.SurfaceType = ng.design.concrete.SurfaceType.SURFACE_TYPE_UNSPECIFIED;
                shearDesignType: ng.design.concrete.ShearDesignType = ng.design.concrete.ShearDesignType.SHEAR_DESIGN_TYPE_UNSPECIFIED;
                useMinReinf: boolean = false;
                monolithic: boolean = false;
                fire: ng.design.concrete.FireBeam | null = null;
                considerAsSlab: boolean = false;
                secondOrderMethod: ng.design.concrete.SecondOrderMethod = ng.design.concrete.SecondOrderMethod.SECOND_ORDER_METHOD_UNSPECIFIED;

                static fromObject(src_unknown: unknown): Beam {
                    const dst = new Beam();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Beam but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Beam_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Beam but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.surfaceType !== undefined && src.surfaceType !== null) {
                        dst.surfaceType = ng.design.concrete.SurfaceType_FromObject(src.surfaceType);
                    }
                    if (src.shearDesignType !== undefined && src.shearDesignType !== null) {
                        dst.shearDesignType = ng.design.concrete.ShearDesignType_FromObject(src.shearDesignType);
                    }
                    if (src.useMinReinf !== undefined && src.useMinReinf !== null) {
                        if (typeof src.useMinReinf === "boolean") {
                            dst.useMinReinf = src.useMinReinf;
                        }
                        else {
                            console.log('Expected useMinReinf of Beam to be a boolean but was ', typeof src.useMinReinf, src.useMinReinf)
                        }
                    }
                    if (src.monolithic !== undefined && src.monolithic !== null) {
                        if (typeof src.monolithic === "boolean") {
                            dst.monolithic = src.monolithic;
                        }
                        else {
                            console.log('Expected monolithic of Beam to be a boolean but was ', typeof src.monolithic, src.monolithic)
                        }
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.concrete.FireBeam.fromObject(src.fire);
                    }
                    if (src.considerAsSlab !== undefined && src.considerAsSlab !== null) {
                        if (typeof src.considerAsSlab === "boolean") {
                            dst.considerAsSlab = src.considerAsSlab;
                        }
                        else {
                            console.log('Expected considerAsSlab of Beam to be a boolean but was ', typeof src.considerAsSlab, src.considerAsSlab)
                        }
                    }
                    if (src.secondOrderMethod !== undefined && src.secondOrderMethod !== null) {
                        dst.secondOrderMethod = ng.design.concrete.SecondOrderMethod_FromObject(src.secondOrderMethod);
                    }
                    return dst;
                }

                static toObject(src: Beam | null | undefined): Beam_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.Beam is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.Beam") {
                        console.error('Expected ng.design.concrete.Beam but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const surfaceType_obj = ng.design.concrete.SurfaceType_ToObject(src.surfaceType);
                    if(surfaceType_obj === null) return null;

                    const shearDesignType_obj = ng.design.concrete.ShearDesignType_ToObject(src.shearDesignType);
                    if(shearDesignType_obj === null) return null;

                    const secondOrderMethod_obj = ng.design.concrete.SecondOrderMethod_ToObject(src.secondOrderMethod);
                    if(secondOrderMethod_obj === null) return null;

                    const dst : Beam_json = {
                        surfaceType: surfaceType_obj,
                        shearDesignType: shearDesignType_obj,
                        useMinReinf: src.useMinReinf,
                        monolithic: src.monolithic,
                        considerAsSlab: src.considerAsSlab,
                        secondOrderMethod: secondOrderMethod_obj,
                    };
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.concrete.FireBeam.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: Beam_createType) {
                    const dst = new Beam();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.surfaceType !== undefined) {
                        dst.surfaceType = src.surfaceType;
                    }
                    if (src.shearDesignType !== undefined) {
                        dst.shearDesignType = src.shearDesignType;
                    }
                    if (src.useMinReinf !== undefined) {
                        dst.useMinReinf = src.useMinReinf;
                    }
                    if (src.monolithic !== undefined) {
                        dst.monolithic = src.monolithic;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    if (src.considerAsSlab !== undefined) {
                        dst.considerAsSlab = src.considerAsSlab;
                    }
                    if (src.secondOrderMethod !== undefined) {
                        dst.secondOrderMethod = src.secondOrderMethod;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Beam();
                    dst.surfaceType = this.surfaceType;
                    dst.shearDesignType = this.shearDesignType;
                    dst.useMinReinf = this.useMinReinf;
                    dst.monolithic = this.monolithic;
                    dst.fire = this.fire;
                    dst.considerAsSlab = this.considerAsSlab;
                    dst.secondOrderMethod = this.secondOrderMethod;
                    return dst;
                }

                deepClone() {
                    const json = Beam.toObject(this);
                    const dst = Beam.fromObject(json);
                    return dst;
                }
            }
            export type IBeam = Beam;


            export type Column_keys = 'noReinf' | 'useMinReinf' | 'shearDesignType' | 'secondOrderMethod' | 'fire';
            export interface Column_createType {
                noReinf?: boolean,
                useMinReinf?: boolean,
                shearDesignType?: ng.design.concrete.ShearDesignType,
                secondOrderMethod?: ng.design.concrete.SecondOrderMethod,
                fire?: ng.design.concrete.FireBeam | null,
            }
            export interface Column_json {
                noReinf?: boolean;
                useMinReinf?: boolean;
                shearDesignType?: string;
                secondOrderMethod?: string;
                fire?: ng.design.concrete.FireBeam_json;
            }
            interface Column_json_in {
                __proto_name?: unknown;
                noReinf?: unknown;
                useMinReinf?: unknown;
                shearDesignType?: unknown;
                secondOrderMethod?: unknown;
                fire?: unknown;
            }
            export class Column {
                __proto_name = "ng.design.concrete.Column";
                noReinf: boolean = false;
                useMinReinf: boolean = false;
                shearDesignType: ng.design.concrete.ShearDesignType = ng.design.concrete.ShearDesignType.SHEAR_DESIGN_TYPE_UNSPECIFIED;
                secondOrderMethod: ng.design.concrete.SecondOrderMethod = ng.design.concrete.SecondOrderMethod.SECOND_ORDER_METHOD_UNSPECIFIED;
                fire: ng.design.concrete.FireBeam | null = null;

                static fromObject(src_unknown: unknown): Column {
                    const dst = new Column();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Column but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Column_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Column but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.noReinf !== undefined && src.noReinf !== null) {
                        if (typeof src.noReinf === "boolean") {
                            dst.noReinf = src.noReinf;
                        }
                        else {
                            console.log('Expected noReinf of Column to be a boolean but was ', typeof src.noReinf, src.noReinf)
                        }
                    }
                    if (src.useMinReinf !== undefined && src.useMinReinf !== null) {
                        if (typeof src.useMinReinf === "boolean") {
                            dst.useMinReinf = src.useMinReinf;
                        }
                        else {
                            console.log('Expected useMinReinf of Column to be a boolean but was ', typeof src.useMinReinf, src.useMinReinf)
                        }
                    }
                    if (src.shearDesignType !== undefined && src.shearDesignType !== null) {
                        dst.shearDesignType = ng.design.concrete.ShearDesignType_FromObject(src.shearDesignType);
                    }
                    if (src.secondOrderMethod !== undefined && src.secondOrderMethod !== null) {
                        dst.secondOrderMethod = ng.design.concrete.SecondOrderMethod_FromObject(src.secondOrderMethod);
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.concrete.FireBeam.fromObject(src.fire);
                    }
                    return dst;
                }

                static toObject(src: Column | null | undefined): Column_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.Column is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.Column") {
                        console.error('Expected ng.design.concrete.Column but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const shearDesignType_obj = ng.design.concrete.ShearDesignType_ToObject(src.shearDesignType);
                    if(shearDesignType_obj === null) return null;

                    const secondOrderMethod_obj = ng.design.concrete.SecondOrderMethod_ToObject(src.secondOrderMethod);
                    if(secondOrderMethod_obj === null) return null;

                    const dst : Column_json = {
                        noReinf: src.noReinf,
                        useMinReinf: src.useMinReinf,
                        shearDesignType: shearDesignType_obj,
                        secondOrderMethod: secondOrderMethod_obj,
                    };
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.concrete.FireBeam.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: Column_createType) {
                    const dst = new Column();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.noReinf !== undefined) {
                        dst.noReinf = src.noReinf;
                    }
                    if (src.useMinReinf !== undefined) {
                        dst.useMinReinf = src.useMinReinf;
                    }
                    if (src.shearDesignType !== undefined) {
                        dst.shearDesignType = src.shearDesignType;
                    }
                    if (src.secondOrderMethod !== undefined) {
                        dst.secondOrderMethod = src.secondOrderMethod;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Column();
                    dst.noReinf = this.noReinf;
                    dst.useMinReinf = this.useMinReinf;
                    dst.shearDesignType = this.shearDesignType;
                    dst.secondOrderMethod = this.secondOrderMethod;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = Column.toObject(this);
                    const dst = Column.fromObject(json);
                    return dst;
                }
            }
            export type IColumn = Column;


            export type Wall_keys = 'noReinf' | 'useMinReinf' | 'secondOrderMethod' | 'fire';
            export interface Wall_createType {
                noReinf?: boolean,
                useMinReinf?: boolean,
                secondOrderMethod?: ng.design.concrete.SecondOrderMethod,
                fire?: ng.design.concrete.FireBeam | null,
            }
            export interface Wall_json {
                noReinf?: boolean;
                useMinReinf?: boolean;
                secondOrderMethod?: string;
                fire?: ng.design.concrete.FireBeam_json;
            }
            interface Wall_json_in {
                __proto_name?: unknown;
                noReinf?: unknown;
                useMinReinf?: unknown;
                secondOrderMethod?: unknown;
                fire?: unknown;
            }
            export class Wall {
                __proto_name = "ng.design.concrete.Wall";
                noReinf: boolean = false;
                useMinReinf: boolean = false;
                secondOrderMethod: ng.design.concrete.SecondOrderMethod = ng.design.concrete.SecondOrderMethod.SECOND_ORDER_METHOD_UNSPECIFIED;
                fire: ng.design.concrete.FireBeam | null = null;

                static fromObject(src_unknown: unknown): Wall {
                    const dst = new Wall();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Wall but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Wall_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Wall but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.noReinf !== undefined && src.noReinf !== null) {
                        if (typeof src.noReinf === "boolean") {
                            dst.noReinf = src.noReinf;
                        }
                        else {
                            console.log('Expected noReinf of Wall to be a boolean but was ', typeof src.noReinf, src.noReinf)
                        }
                    }
                    if (src.useMinReinf !== undefined && src.useMinReinf !== null) {
                        if (typeof src.useMinReinf === "boolean") {
                            dst.useMinReinf = src.useMinReinf;
                        }
                        else {
                            console.log('Expected useMinReinf of Wall to be a boolean but was ', typeof src.useMinReinf, src.useMinReinf)
                        }
                    }
                    if (src.secondOrderMethod !== undefined && src.secondOrderMethod !== null) {
                        dst.secondOrderMethod = ng.design.concrete.SecondOrderMethod_FromObject(src.secondOrderMethod);
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.concrete.FireBeam.fromObject(src.fire);
                    }
                    return dst;
                }

                static toObject(src: Wall | null | undefined): Wall_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.Wall is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.Wall") {
                        console.error('Expected ng.design.concrete.Wall but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const secondOrderMethod_obj = ng.design.concrete.SecondOrderMethod_ToObject(src.secondOrderMethod);
                    if(secondOrderMethod_obj === null) return null;

                    const dst : Wall_json = {
                        noReinf: src.noReinf,
                        useMinReinf: src.useMinReinf,
                        secondOrderMethod: secondOrderMethod_obj,
                    };
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.concrete.FireBeam.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: Wall_createType) {
                    const dst = new Wall();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.noReinf !== undefined) {
                        dst.noReinf = src.noReinf;
                    }
                    if (src.useMinReinf !== undefined) {
                        dst.useMinReinf = src.useMinReinf;
                    }
                    if (src.secondOrderMethod !== undefined) {
                        dst.secondOrderMethod = src.secondOrderMethod;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Wall();
                    dst.noReinf = this.noReinf;
                    dst.useMinReinf = this.useMinReinf;
                    dst.secondOrderMethod = this.secondOrderMethod;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = Wall.toObject(this);
                    const dst = Wall.fromObject(json);
                    return dst;
                }
            }
            export type IWall = Wall;


            export type PrestressedBeam_keys = 'surfaceType' | 'shearDesignType' | 'useMinReinf' | 'monolithic' | 'limitFyd' | 'fire';
            export interface PrestressedBeam_createType {
                surfaceType?: ng.design.concrete.SurfaceType,
                shearDesignType?: ng.design.concrete.ShearDesignType,
                useMinReinf?: boolean,
                monolithic?: boolean,
                limitFyd?: number,
                fire?: ng.design.concrete.FireBeam | null,
            }
            export interface PrestressedBeam_json {
                surfaceType?: string;
                shearDesignType?: string;
                useMinReinf?: boolean;
                monolithic?: boolean;
                limitFyd?: JsonNumber;
                fire?: ng.design.concrete.FireBeam_json;
            }
            interface PrestressedBeam_json_in {
                __proto_name?: unknown;
                surfaceType?: unknown;
                shearDesignType?: unknown;
                useMinReinf?: unknown;
                monolithic?: unknown;
                limitFyd?: unknown;
                fire?: unknown;
            }
            export class PrestressedBeam {
                __proto_name = "ng.design.concrete.PrestressedBeam";
                surfaceType: ng.design.concrete.SurfaceType = ng.design.concrete.SurfaceType.SURFACE_TYPE_UNSPECIFIED;
                shearDesignType: ng.design.concrete.ShearDesignType = ng.design.concrete.ShearDesignType.SHEAR_DESIGN_TYPE_UNSPECIFIED;
                useMinReinf: boolean = false;
                monolithic: boolean = false;
                limitFyd: number = 0;
                fire: ng.design.concrete.FireBeam | null = null;

                static fromObject(src_unknown: unknown): PrestressedBeam {
                    const dst = new PrestressedBeam();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PrestressedBeam but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PrestressedBeam_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PrestressedBeam but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.surfaceType !== undefined && src.surfaceType !== null) {
                        dst.surfaceType = ng.design.concrete.SurfaceType_FromObject(src.surfaceType);
                    }
                    if (src.shearDesignType !== undefined && src.shearDesignType !== null) {
                        dst.shearDesignType = ng.design.concrete.ShearDesignType_FromObject(src.shearDesignType);
                    }
                    if (src.useMinReinf !== undefined && src.useMinReinf !== null) {
                        if (typeof src.useMinReinf === "boolean") {
                            dst.useMinReinf = src.useMinReinf;
                        }
                        else {
                            console.log('Expected useMinReinf of PrestressedBeam to be a boolean but was ', typeof src.useMinReinf, src.useMinReinf)
                        }
                    }
                    if (src.monolithic !== undefined && src.monolithic !== null) {
                        if (typeof src.monolithic === "boolean") {
                            dst.monolithic = src.monolithic;
                        }
                        else {
                            console.log('Expected monolithic of PrestressedBeam to be a boolean but was ', typeof src.monolithic, src.monolithic)
                        }
                    }
                    if (src.limitFyd !== undefined && src.limitFyd !== null) {
                        if (typeof src.limitFyd === "number" || src.limitFyd === 'NaN' || src.limitFyd === 'Infinity' || src.limitFyd === '-Infinity') {
                            dst.limitFyd = AsNum(src.limitFyd);
                        }
                        else {
                            console.log('Expected limitFyd of PrestressedBeam to be a number but was ', typeof src.limitFyd, src.limitFyd)
                        }
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.concrete.FireBeam.fromObject(src.fire);
                    }
                    return dst;
                }

                static toObject(src: PrestressedBeam | null | undefined): PrestressedBeam_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.PrestressedBeam is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.PrestressedBeam") {
                        console.error('Expected ng.design.concrete.PrestressedBeam but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const surfaceType_obj = ng.design.concrete.SurfaceType_ToObject(src.surfaceType);
                    if(surfaceType_obj === null) return null;

                    const shearDesignType_obj = ng.design.concrete.ShearDesignType_ToObject(src.shearDesignType);
                    if(shearDesignType_obj === null) return null;

                    const dst : PrestressedBeam_json = {
                        surfaceType: surfaceType_obj,
                        shearDesignType: shearDesignType_obj,
                        useMinReinf: src.useMinReinf,
                        monolithic: src.monolithic,
                        limitFyd: AsJsonNum(src.limitFyd),
                    };
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.concrete.FireBeam.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: PrestressedBeam_createType) {
                    const dst = new PrestressedBeam();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.surfaceType !== undefined) {
                        dst.surfaceType = src.surfaceType;
                    }
                    if (src.shearDesignType !== undefined) {
                        dst.shearDesignType = src.shearDesignType;
                    }
                    if (src.useMinReinf !== undefined) {
                        dst.useMinReinf = src.useMinReinf;
                    }
                    if (src.monolithic !== undefined) {
                        dst.monolithic = src.monolithic;
                    }
                    if (src.limitFyd !== undefined) {
                        dst.limitFyd = src.limitFyd;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PrestressedBeam();
                    dst.surfaceType = this.surfaceType;
                    dst.shearDesignType = this.shearDesignType;
                    dst.useMinReinf = this.useMinReinf;
                    dst.monolithic = this.monolithic;
                    dst.limitFyd = this.limitFyd;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = PrestressedBeam.toObject(this);
                    const dst = PrestressedBeam.fromObject(json);
                    return dst;
                }
            }
            export type IPrestressedBeam = PrestressedBeam;


            export type HC_keys = 'considerPunchingEdgeReduction' | 'surfaceType' | 'useShearToppingCap' | 'webShearMethod' | 'fire';
            export interface HC_createType {
                considerPunchingEdgeReduction?: boolean,
                surfaceType?: ng.design.concrete.SurfaceType,
                useShearToppingCap?: boolean,
                webShearMethod?: ng.design.concrete.WebShearCapacityMethod,
                fire?: ng.design.concrete.FireBeam | null,
            }
            export interface HC_json {
                considerPunchingEdgeReduction?: boolean;
                surfaceType?: string;
                useShearToppingCap?: boolean;
                webShearMethod?: string;
                fire?: ng.design.concrete.FireBeam_json;
            }
            interface HC_json_in {
                __proto_name?: unknown;
                considerPunchingEdgeReduction?: unknown;
                surfaceType?: unknown;
                useShearToppingCap?: unknown;
                webShearMethod?: unknown;
                fire?: unknown;
            }
            export class HC {
                __proto_name = "ng.design.concrete.HC";
                considerPunchingEdgeReduction: boolean = false;
                surfaceType: ng.design.concrete.SurfaceType = ng.design.concrete.SurfaceType.SURFACE_TYPE_UNSPECIFIED;
                useShearToppingCap: boolean = false;
                webShearMethod: ng.design.concrete.WebShearCapacityMethod = ng.design.concrete.WebShearCapacityMethod.WEB_SHEAR_CAPACITY_METHOD_UNSPECIFIED;
                fire: ng.design.concrete.FireBeam | null = null;

                static fromObject(src_unknown: unknown): HC {
                    const dst = new HC();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted HC but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as HC_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for HC but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.considerPunchingEdgeReduction !== undefined && src.considerPunchingEdgeReduction !== null) {
                        if (typeof src.considerPunchingEdgeReduction === "boolean") {
                            dst.considerPunchingEdgeReduction = src.considerPunchingEdgeReduction;
                        }
                        else {
                            console.log('Expected considerPunchingEdgeReduction of HC to be a boolean but was ', typeof src.considerPunchingEdgeReduction, src.considerPunchingEdgeReduction)
                        }
                    }
                    if (src.surfaceType !== undefined && src.surfaceType !== null) {
                        dst.surfaceType = ng.design.concrete.SurfaceType_FromObject(src.surfaceType);
                    }
                    if (src.useShearToppingCap !== undefined && src.useShearToppingCap !== null) {
                        if (typeof src.useShearToppingCap === "boolean") {
                            dst.useShearToppingCap = src.useShearToppingCap;
                        }
                        else {
                            console.log('Expected useShearToppingCap of HC to be a boolean but was ', typeof src.useShearToppingCap, src.useShearToppingCap)
                        }
                    }
                    if (src.webShearMethod !== undefined && src.webShearMethod !== null) {
                        dst.webShearMethod = ng.design.concrete.WebShearCapacityMethod_FromObject(src.webShearMethod);
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.concrete.FireBeam.fromObject(src.fire);
                    }
                    return dst;
                }

                static toObject(src: HC | null | undefined): HC_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.HC is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.HC") {
                        console.error('Expected ng.design.concrete.HC but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const surfaceType_obj = ng.design.concrete.SurfaceType_ToObject(src.surfaceType);
                    if(surfaceType_obj === null) return null;

                    const webShearMethod_obj = ng.design.concrete.WebShearCapacityMethod_ToObject(src.webShearMethod);
                    if(webShearMethod_obj === null) return null;

                    const dst : HC_json = {
                        considerPunchingEdgeReduction: src.considerPunchingEdgeReduction,
                        surfaceType: surfaceType_obj,
                        useShearToppingCap: src.useShearToppingCap,
                        webShearMethod: webShearMethod_obj,
                    };
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.concrete.FireBeam.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: HC_createType) {
                    const dst = new HC();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.considerPunchingEdgeReduction !== undefined) {
                        dst.considerPunchingEdgeReduction = src.considerPunchingEdgeReduction;
                    }
                    if (src.surfaceType !== undefined) {
                        dst.surfaceType = src.surfaceType;
                    }
                    if (src.useShearToppingCap !== undefined) {
                        dst.useShearToppingCap = src.useShearToppingCap;
                    }
                    if (src.webShearMethod !== undefined) {
                        dst.webShearMethod = src.webShearMethod;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new HC();
                    dst.considerPunchingEdgeReduction = this.considerPunchingEdgeReduction;
                    dst.surfaceType = this.surfaceType;
                    dst.useShearToppingCap = this.useShearToppingCap;
                    dst.webShearMethod = this.webShearMethod;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = HC.toObject(this);
                    const dst = HC.fromObject(json);
                    return dst;
                }
            }
            export type IHC = HC;


            export type Slab_keys = 'considerPunchingEdgeReduction' | 'surfaceType' | 'fire';
            export interface Slab_createType {
                considerPunchingEdgeReduction?: boolean,
                surfaceType?: ng.design.concrete.SurfaceType,
                fire?: ng.design.concrete.FireBeam | null,
            }
            export interface Slab_json {
                considerPunchingEdgeReduction?: boolean;
                surfaceType?: string;
                fire?: ng.design.concrete.FireBeam_json;
            }
            interface Slab_json_in {
                __proto_name?: unknown;
                considerPunchingEdgeReduction?: unknown;
                surfaceType?: unknown;
                fire?: unknown;
            }
            export class Slab {
                __proto_name = "ng.design.concrete.Slab";
                considerPunchingEdgeReduction: boolean = false;
                surfaceType: ng.design.concrete.SurfaceType = ng.design.concrete.SurfaceType.SURFACE_TYPE_UNSPECIFIED;
                fire: ng.design.concrete.FireBeam | null = null;

                static fromObject(src_unknown: unknown): Slab {
                    const dst = new Slab();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Slab but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Slab_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Slab but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.considerPunchingEdgeReduction !== undefined && src.considerPunchingEdgeReduction !== null) {
                        if (typeof src.considerPunchingEdgeReduction === "boolean") {
                            dst.considerPunchingEdgeReduction = src.considerPunchingEdgeReduction;
                        }
                        else {
                            console.log('Expected considerPunchingEdgeReduction of Slab to be a boolean but was ', typeof src.considerPunchingEdgeReduction, src.considerPunchingEdgeReduction)
                        }
                    }
                    if (src.surfaceType !== undefined && src.surfaceType !== null) {
                        dst.surfaceType = ng.design.concrete.SurfaceType_FromObject(src.surfaceType);
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.concrete.FireBeam.fromObject(src.fire);
                    }
                    return dst;
                }

                static toObject(src: Slab | null | undefined): Slab_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.Slab is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.Slab") {
                        console.error('Expected ng.design.concrete.Slab but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const surfaceType_obj = ng.design.concrete.SurfaceType_ToObject(src.surfaceType);
                    if(surfaceType_obj === null) return null;

                    const dst : Slab_json = {
                        considerPunchingEdgeReduction: src.considerPunchingEdgeReduction,
                        surfaceType: surfaceType_obj,
                    };
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.concrete.FireBeam.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: Slab_createType) {
                    const dst = new Slab();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.considerPunchingEdgeReduction !== undefined) {
                        dst.considerPunchingEdgeReduction = src.considerPunchingEdgeReduction;
                    }
                    if (src.surfaceType !== undefined) {
                        dst.surfaceType = src.surfaceType;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Slab();
                    dst.considerPunchingEdgeReduction = this.considerPunchingEdgeReduction;
                    dst.surfaceType = this.surfaceType;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = Slab.toObject(this);
                    const dst = Slab.fromObject(json);
                    return dst;
                }
            }
            export type ISlab = Slab;


            export type GeneralDesignSettings_keys = 'memberSurfaceEmissivityRc' | 'maxNumIter' | 'crkConv' | 'crackCheck';
            export interface GeneralDesignSettings_createType {
                memberSurfaceEmissivityRc?: number,
                maxNumIter?: number,
                crkConv?: number,
                crackCheck?: boolean,
            }
            export interface GeneralDesignSettings_json {
                memberSurfaceEmissivityRc?: JsonNumber;
                maxNumIter?: JsonNumber;
                crkConv?: JsonNumber;
                crackCheck?: boolean;
            }
            interface GeneralDesignSettings_json_in {
                __proto_name?: unknown;
                memberSurfaceEmissivityRc?: unknown;
                maxNumIter?: unknown;
                crkConv?: unknown;
                crackCheck?: unknown;
            }
            export class GeneralDesignSettings {
                __proto_name = "ng.design.concrete.GeneralDesignSettings";
                memberSurfaceEmissivityRc: number = 0;
                maxNumIter: number = 0;
                crkConv: number = 0;
                crackCheck: boolean = false;

                static fromObject(src_unknown: unknown): GeneralDesignSettings {
                    const dst = new GeneralDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.memberSurfaceEmissivityRc !== undefined && src.memberSurfaceEmissivityRc !== null) {
                        if (typeof src.memberSurfaceEmissivityRc === "number" || src.memberSurfaceEmissivityRc === 'NaN' || src.memberSurfaceEmissivityRc === 'Infinity' || src.memberSurfaceEmissivityRc === '-Infinity') {
                            dst.memberSurfaceEmissivityRc = AsNum(src.memberSurfaceEmissivityRc);
                        }
                        else {
                            console.log('Expected memberSurfaceEmissivityRc of GeneralDesignSettings to be a number but was ', typeof src.memberSurfaceEmissivityRc, src.memberSurfaceEmissivityRc)
                        }
                    }
                    if (src.maxNumIter !== undefined && src.maxNumIter !== null) {
                        if (typeof src.maxNumIter === "number" || src.maxNumIter === 'NaN' || src.maxNumIter === 'Infinity' || src.maxNumIter === '-Infinity') {
                            dst.maxNumIter = NumberToInt("ng.design.concrete.GeneralDesignSettings.max_num_iter", AsNum(src.maxNumIter));
                        }
                        else {
                            console.log('Expected maxNumIter of GeneralDesignSettings to be a number but was ', typeof src.maxNumIter, src.maxNumIter)
                        }
                    }
                    if (src.crkConv !== undefined && src.crkConv !== null) {
                        if (typeof src.crkConv === "number" || src.crkConv === 'NaN' || src.crkConv === 'Infinity' || src.crkConv === '-Infinity') {
                            dst.crkConv = AsNum(src.crkConv);
                        }
                        else {
                            console.log('Expected crkConv of GeneralDesignSettings to be a number but was ', typeof src.crkConv, src.crkConv)
                        }
                    }
                    if (src.crackCheck !== undefined && src.crackCheck !== null) {
                        if (typeof src.crackCheck === "boolean") {
                            dst.crackCheck = src.crackCheck;
                        }
                        else {
                            console.log('Expected crackCheck of GeneralDesignSettings to be a boolean but was ', typeof src.crackCheck, src.crackCheck)
                        }
                    }
                    return dst;
                }

                static toObject(src: GeneralDesignSettings | null | undefined): GeneralDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.GeneralDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.GeneralDesignSettings") {
                        console.error('Expected ng.design.concrete.GeneralDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GeneralDesignSettings_json = {
                        memberSurfaceEmissivityRc: AsJsonNum(src.memberSurfaceEmissivityRc),
                        maxNumIter: AsJsonNum(NumberToInt("ng.design.concrete.GeneralDesignSettings.max_num_iter", src.maxNumIter)),
                        crkConv: AsJsonNum(src.crkConv),
                        crackCheck: src.crackCheck,
                    };
                    return dst;
                }

                static create(src?: GeneralDesignSettings_createType) {
                    const dst = new GeneralDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.memberSurfaceEmissivityRc !== undefined) {
                        dst.memberSurfaceEmissivityRc = src.memberSurfaceEmissivityRc;
                    }
                    if (src.maxNumIter !== undefined) {
                        dst.maxNumIter = src.maxNumIter;
                    }
                    if (src.crkConv !== undefined) {
                        dst.crkConv = src.crkConv;
                    }
                    if (src.crackCheck !== undefined) {
                        dst.crackCheck = src.crackCheck;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralDesignSettings();
                    dst.memberSurfaceEmissivityRc = this.memberSurfaceEmissivityRc;
                    dst.maxNumIter = this.maxNumIter;
                    dst.crkConv = this.crkConv;
                    dst.crackCheck = this.crackCheck;
                    return dst;
                }

                deepClone() {
                    const json = GeneralDesignSettings.toObject(this);
                    const dst = GeneralDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralDesignSettings = GeneralDesignSettings;


            export type ElementDesignSettings_keys = 'partialCoeffs' | 'fabrication' | 'enhancedShear' | 'enhancedQuality' | 'enhancedData' | 'crackedInShear' | 'cot' | 'constructionClass' | 'fctmType' | 'useCompReinf' | 'lowStrengthVariation' | 'largestAggregateSize' | 'smallestAggregateSize' | 'consider2ndOrderEffects' | 'beam' | 'column' | 'wall' | 'ps' | 'hc' | 'slab' | 'additionalCommands';
            export interface ElementDesignSettings_createType {
                partialCoeffs?: ng.design.concrete.PartialCoefficients | null,
                fabrication?: ng.design.concrete.Fabrication,
                enhancedShear?: boolean,
                enhancedQuality?: boolean,
                enhancedData?: boolean,
                crackedInShear?: boolean,
                cot?: number,
                constructionClass?: ng.design.concrete.ConstructionClass,
                fctmType?: ng.design.concrete.FctmType,
                useCompReinf?: boolean,
                lowStrengthVariation?: boolean,
                largestAggregateSize?: number,
                smallestAggregateSize?: number,
                consider2ndOrderEffects?: boolean,
                beam?: ng.design.concrete.Beam | null,
                column?: ng.design.concrete.Column | null,
                wall?: ng.design.concrete.Wall | null,
                ps?: ng.design.concrete.PrestressedBeam | null,
                hc?: ng.design.concrete.HC | null,
                slab?: ng.design.concrete.Slab | null,
                additionalCommands?: ng.design.concrete.Commands[],
            }
            export interface ElementDesignSettings_json {
                partialCoeffs?: ng.design.concrete.PartialCoefficients_json;
                fabrication?: string;
                enhancedShear?: boolean;
                enhancedQuality?: boolean;
                enhancedData?: boolean;
                crackedInShear?: boolean;
                cot?: JsonNumber;
                constructionClass?: string;
                fctmType?: string;
                useCompReinf?: boolean;
                lowStrengthVariation?: boolean;
                largestAggregateSize?: JsonNumber;
                smallestAggregateSize?: JsonNumber;
                consider2ndOrderEffects?: boolean;
                beam?: ng.design.concrete.Beam_json;
                column?: ng.design.concrete.Column_json;
                wall?: ng.design.concrete.Wall_json;
                ps?: ng.design.concrete.PrestressedBeam_json;
                hc?: ng.design.concrete.HC_json;
                slab?: ng.design.concrete.Slab_json;
                additionalCommands: string[];
            }
            interface ElementDesignSettings_json_in {
                __proto_name?: unknown;
                partialCoeffs?: unknown;
                fabrication?: unknown;
                enhancedShear?: unknown;
                enhancedQuality?: unknown;
                enhancedData?: unknown;
                crackedInShear?: unknown;
                cot?: unknown;
                constructionClass?: unknown;
                fctmType?: unknown;
                useCompReinf?: unknown;
                lowStrengthVariation?: unknown;
                largestAggregateSize?: unknown;
                smallestAggregateSize?: unknown;
                consider2ndOrderEffects?: unknown;
                beam?: unknown;
                column?: unknown;
                wall?: unknown;
                ps?: unknown;
                hc?: unknown;
                slab?: unknown;
                additionalCommands?: unknown;
            }
            export class ElementDesignSettings {
                __proto_name = "ng.design.concrete.ElementDesignSettings";
                partialCoeffs: ng.design.concrete.PartialCoefficients | null = null;
                fabrication: ng.design.concrete.Fabrication = ng.design.concrete.Fabrication.FABRICATION_UNSPECIFIED;
                enhancedShear: boolean = false;
                enhancedQuality: boolean = false;
                enhancedData: boolean = false;
                crackedInShear: boolean = false;
                cot: number = 0;
                constructionClass: ng.design.concrete.ConstructionClass = ng.design.concrete.ConstructionClass.CONSTRUCTION_CLASS_UNSPECIFIED;
                fctmType: ng.design.concrete.FctmType = ng.design.concrete.FctmType.FCTM_TYPE_UNSPECIFIED;
                useCompReinf: boolean = false;
                lowStrengthVariation: boolean = false;
                largestAggregateSize: number = 0;
                smallestAggregateSize: number = 0;
                consider2ndOrderEffects: boolean = false;
                // this is a one of
                element_type: {type: 'beam'; beam: ng.design.concrete.Beam} | {type: 'column'; column: ng.design.concrete.Column} | {type: 'wall'; wall: ng.design.concrete.Wall} | {type: 'ps'; ps: ng.design.concrete.PrestressedBeam} | {type: 'hc'; hc: ng.design.concrete.HC} | {type: 'slab'; slab: ng.design.concrete.Slab} | null = null;
                additionalCommands: ng.design.concrete.Commands[] = [];

                /** Gets the `Beam` value (or null) from the oneof `element_type` */
                getBeam(): ng.design.concrete.Beam | null {
                    if(this.element_type === null) return null;
                    if(this.element_type.type !== 'beam') return null;
                    return this.element_type.beam;
                }

                /** Sets the `Beam` value for the oneof `element_type`*/
                setBeam(value: ng.design.concrete.Beam | null) {
                    if(value !== null) {
                        this.element_type = {type: 'beam', beam:value};
                    }
                    else {
                        this.element_type = null;
                    }
                }

                /** Gets the `Column` value (or null) from the oneof `element_type` */
                getColumn(): ng.design.concrete.Column | null {
                    if(this.element_type === null) return null;
                    if(this.element_type.type !== 'column') return null;
                    return this.element_type.column;
                }

                /** Sets the `Column` value for the oneof `element_type`*/
                setColumn(value: ng.design.concrete.Column | null) {
                    if(value !== null) {
                        this.element_type = {type: 'column', column:value};
                    }
                    else {
                        this.element_type = null;
                    }
                }

                /** Gets the `Wall` value (or null) from the oneof `element_type` */
                getWall(): ng.design.concrete.Wall | null {
                    if(this.element_type === null) return null;
                    if(this.element_type.type !== 'wall') return null;
                    return this.element_type.wall;
                }

                /** Sets the `Wall` value for the oneof `element_type`*/
                setWall(value: ng.design.concrete.Wall | null) {
                    if(value !== null) {
                        this.element_type = {type: 'wall', wall:value};
                    }
                    else {
                        this.element_type = null;
                    }
                }

                /** Gets the `Ps` value (or null) from the oneof `element_type` */
                getPs(): ng.design.concrete.PrestressedBeam | null {
                    if(this.element_type === null) return null;
                    if(this.element_type.type !== 'ps') return null;
                    return this.element_type.ps;
                }

                /** Sets the `Ps` value for the oneof `element_type`*/
                setPs(value: ng.design.concrete.PrestressedBeam | null) {
                    if(value !== null) {
                        this.element_type = {type: 'ps', ps:value};
                    }
                    else {
                        this.element_type = null;
                    }
                }

                /** Gets the `Hc` value (or null) from the oneof `element_type` */
                getHc(): ng.design.concrete.HC | null {
                    if(this.element_type === null) return null;
                    if(this.element_type.type !== 'hc') return null;
                    return this.element_type.hc;
                }

                /** Sets the `Hc` value for the oneof `element_type`*/
                setHc(value: ng.design.concrete.HC | null) {
                    if(value !== null) {
                        this.element_type = {type: 'hc', hc:value};
                    }
                    else {
                        this.element_type = null;
                    }
                }

                /** Gets the `Slab` value (or null) from the oneof `element_type` */
                getSlab(): ng.design.concrete.Slab | null {
                    if(this.element_type === null) return null;
                    if(this.element_type.type !== 'slab') return null;
                    return this.element_type.slab;
                }

                /** Sets the `Slab` value for the oneof `element_type`*/
                setSlab(value: ng.design.concrete.Slab | null) {
                    if(value !== null) {
                        this.element_type = {type: 'slab', slab:value};
                    }
                    else {
                        this.element_type = null;
                    }
                }

                static fromObject(src_unknown: unknown): ElementDesignSettings {
                    const dst = new ElementDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ElementDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ElementDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ElementDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined && src.partialCoeffs !== null) {
                        dst.partialCoeffs = ng.design.concrete.PartialCoefficients.fromObject(src.partialCoeffs);
                    }
                    if (src.fabrication !== undefined && src.fabrication !== null) {
                        dst.fabrication = ng.design.concrete.Fabrication_FromObject(src.fabrication);
                    }
                    if (src.enhancedShear !== undefined && src.enhancedShear !== null) {
                        if (typeof src.enhancedShear === "boolean") {
                            dst.enhancedShear = src.enhancedShear;
                        }
                        else {
                            console.log('Expected enhancedShear of ElementDesignSettings to be a boolean but was ', typeof src.enhancedShear, src.enhancedShear)
                        }
                    }
                    if (src.enhancedQuality !== undefined && src.enhancedQuality !== null) {
                        if (typeof src.enhancedQuality === "boolean") {
                            dst.enhancedQuality = src.enhancedQuality;
                        }
                        else {
                            console.log('Expected enhancedQuality of ElementDesignSettings to be a boolean but was ', typeof src.enhancedQuality, src.enhancedQuality)
                        }
                    }
                    if (src.enhancedData !== undefined && src.enhancedData !== null) {
                        if (typeof src.enhancedData === "boolean") {
                            dst.enhancedData = src.enhancedData;
                        }
                        else {
                            console.log('Expected enhancedData of ElementDesignSettings to be a boolean but was ', typeof src.enhancedData, src.enhancedData)
                        }
                    }
                    if (src.crackedInShear !== undefined && src.crackedInShear !== null) {
                        if (typeof src.crackedInShear === "boolean") {
                            dst.crackedInShear = src.crackedInShear;
                        }
                        else {
                            console.log('Expected crackedInShear of ElementDesignSettings to be a boolean but was ', typeof src.crackedInShear, src.crackedInShear)
                        }
                    }
                    if (src.cot !== undefined && src.cot !== null) {
                        if (typeof src.cot === "number" || src.cot === 'NaN' || src.cot === 'Infinity' || src.cot === '-Infinity') {
                            dst.cot = AsNum(src.cot);
                        }
                        else {
                            console.log('Expected cot of ElementDesignSettings to be a number but was ', typeof src.cot, src.cot)
                        }
                    }
                    if (src.constructionClass !== undefined && src.constructionClass !== null) {
                        dst.constructionClass = ng.design.concrete.ConstructionClass_FromObject(src.constructionClass);
                    }
                    if (src.fctmType !== undefined && src.fctmType !== null) {
                        dst.fctmType = ng.design.concrete.FctmType_FromObject(src.fctmType);
                    }
                    if (src.useCompReinf !== undefined && src.useCompReinf !== null) {
                        if (typeof src.useCompReinf === "boolean") {
                            dst.useCompReinf = src.useCompReinf;
                        }
                        else {
                            console.log('Expected useCompReinf of ElementDesignSettings to be a boolean but was ', typeof src.useCompReinf, src.useCompReinf)
                        }
                    }
                    if (src.lowStrengthVariation !== undefined && src.lowStrengthVariation !== null) {
                        if (typeof src.lowStrengthVariation === "boolean") {
                            dst.lowStrengthVariation = src.lowStrengthVariation;
                        }
                        else {
                            console.log('Expected lowStrengthVariation of ElementDesignSettings to be a boolean but was ', typeof src.lowStrengthVariation, src.lowStrengthVariation)
                        }
                    }
                    if (src.largestAggregateSize !== undefined && src.largestAggregateSize !== null) {
                        if (typeof src.largestAggregateSize === "number" || src.largestAggregateSize === 'NaN' || src.largestAggregateSize === 'Infinity' || src.largestAggregateSize === '-Infinity') {
                            dst.largestAggregateSize = AsNum(src.largestAggregateSize);
                        }
                        else {
                            console.log('Expected largestAggregateSize of ElementDesignSettings to be a number but was ', typeof src.largestAggregateSize, src.largestAggregateSize)
                        }
                    }
                    if (src.smallestAggregateSize !== undefined && src.smallestAggregateSize !== null) {
                        if (typeof src.smallestAggregateSize === "number" || src.smallestAggregateSize === 'NaN' || src.smallestAggregateSize === 'Infinity' || src.smallestAggregateSize === '-Infinity') {
                            dst.smallestAggregateSize = AsNum(src.smallestAggregateSize);
                        }
                        else {
                            console.log('Expected smallestAggregateSize of ElementDesignSettings to be a number but was ', typeof src.smallestAggregateSize, src.smallestAggregateSize)
                        }
                    }
                    if (src.consider2ndOrderEffects !== undefined && src.consider2ndOrderEffects !== null) {
                        if (typeof src.consider2ndOrderEffects === "boolean") {
                            dst.consider2ndOrderEffects = src.consider2ndOrderEffects;
                        }
                        else {
                            console.log('Expected consider2ndOrderEffects of ElementDesignSettings to be a boolean but was ', typeof src.consider2ndOrderEffects, src.consider2ndOrderEffects)
                        }
                    }
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(ng.design.concrete.Beam.fromObject(src.beam));
                    }
                    if (src.column !== undefined && src.column !== null) {
                        dst.setColumn(ng.design.concrete.Column.fromObject(src.column));
                    }
                    if (src.wall !== undefined && src.wall !== null) {
                        dst.setWall(ng.design.concrete.Wall.fromObject(src.wall));
                    }
                    if (src.ps !== undefined && src.ps !== null) {
                        dst.setPs(ng.design.concrete.PrestressedBeam.fromObject(src.ps));
                    }
                    if (src.hc !== undefined && src.hc !== null) {
                        dst.setHc(ng.design.concrete.HC.fromObject(src.hc));
                    }
                    if (src.slab !== undefined && src.slab !== null) {
                        dst.setSlab(ng.design.concrete.Slab.fromObject(src.slab));
                    }
                    if (src.additionalCommands !== undefined && src.additionalCommands !== null) {
                        if (Array.isArray(src.additionalCommands)) {
                            for (const element of src.additionalCommands) {
                                dst.additionalCommands.push(ng.design.concrete.Commands_FromObject(element));
                            }
                        }
                        else {
                            console.log('Expected additionalCommands of ElementDesignSettings to be a array but was ', typeof src.additionalCommands, src.additionalCommands)
                        }
                    }
                    return dst;
                }

                static toObject(src: ElementDesignSettings | null | undefined): ElementDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.concrete.ElementDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.concrete.ElementDesignSettings") {
                        console.error('Expected ng.design.concrete.ElementDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const fabrication_obj = ng.design.concrete.Fabrication_ToObject(src.fabrication);
                    if(fabrication_obj === null) return null;

                    const constructionClass_obj = ng.design.concrete.ConstructionClass_ToObject(src.constructionClass);
                    if(constructionClass_obj === null) return null;

                    const fctmType_obj = ng.design.concrete.FctmType_ToObject(src.fctmType);
                    if(fctmType_obj === null) return null;

                    const dst : ElementDesignSettings_json = {
                        fabrication: fabrication_obj,
                        enhancedShear: src.enhancedShear,
                        enhancedQuality: src.enhancedQuality,
                        enhancedData: src.enhancedData,
                        crackedInShear: src.crackedInShear,
                        cot: AsJsonNum(src.cot),
                        constructionClass: constructionClass_obj,
                        fctmType: fctmType_obj,
                        useCompReinf: src.useCompReinf,
                        lowStrengthVariation: src.lowStrengthVariation,
                        largestAggregateSize: AsJsonNum(src.largestAggregateSize),
                        smallestAggregateSize: AsJsonNum(src.smallestAggregateSize),
                        consider2ndOrderEffects: src.consider2ndOrderEffects,
                        additionalCommands: new Array<string>(),
                    };
                    if(src.partialCoeffs !== null)
                    {
                        const parsed = ng.design.concrete.PartialCoefficients.toObject(src.partialCoeffs);
                        if(parsed === null) return null;
                        dst.partialCoeffs = parsed;
                    }
                    const beam = src.getBeam();
                    if(beam !== null)
                    {
                        const parsed = ng.design.concrete.Beam.toObject(beam);
                        if(parsed === null) return null;
                        dst.beam = parsed;
                    }
                    const column = src.getColumn();
                    if(column !== null)
                    {
                        const parsed = ng.design.concrete.Column.toObject(column);
                        if(parsed === null) return null;
                        dst.column = parsed;
                    }
                    const wall = src.getWall();
                    if(wall !== null)
                    {
                        const parsed = ng.design.concrete.Wall.toObject(wall);
                        if(parsed === null) return null;
                        dst.wall = parsed;
                    }
                    const ps = src.getPs();
                    if(ps !== null)
                    {
                        const parsed = ng.design.concrete.PrestressedBeam.toObject(ps);
                        if(parsed === null) return null;
                        dst.ps = parsed;
                    }
                    const hc = src.getHc();
                    if(hc !== null)
                    {
                        const parsed = ng.design.concrete.HC.toObject(hc);
                        if(parsed === null) return null;
                        dst.hc = parsed;
                    }
                    const slab = src.getSlab();
                    if(slab !== null)
                    {
                        const parsed = ng.design.concrete.Slab.toObject(slab);
                        if(parsed === null) return null;
                        dst.slab = parsed;
                    }
                    if (src.additionalCommands !== null) {
                        for (const element of src.additionalCommands) {
                            const parsed = ng.design.concrete.Commands_ToObject(element);
                            if(parsed === null) return null;
                            dst.additionalCommands.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: ElementDesignSettings_createType) {
                    const dst = new ElementDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined) {
                        dst.partialCoeffs = src.partialCoeffs;
                    }
                    if (src.fabrication !== undefined) {
                        dst.fabrication = src.fabrication;
                    }
                    if (src.enhancedShear !== undefined) {
                        dst.enhancedShear = src.enhancedShear;
                    }
                    if (src.enhancedQuality !== undefined) {
                        dst.enhancedQuality = src.enhancedQuality;
                    }
                    if (src.enhancedData !== undefined) {
                        dst.enhancedData = src.enhancedData;
                    }
                    if (src.crackedInShear !== undefined) {
                        dst.crackedInShear = src.crackedInShear;
                    }
                    if (src.cot !== undefined) {
                        dst.cot = src.cot;
                    }
                    if (src.constructionClass !== undefined) {
                        dst.constructionClass = src.constructionClass;
                    }
                    if (src.fctmType !== undefined) {
                        dst.fctmType = src.fctmType;
                    }
                    if (src.useCompReinf !== undefined) {
                        dst.useCompReinf = src.useCompReinf;
                    }
                    if (src.lowStrengthVariation !== undefined) {
                        dst.lowStrengthVariation = src.lowStrengthVariation;
                    }
                    if (src.largestAggregateSize !== undefined) {
                        dst.largestAggregateSize = src.largestAggregateSize;
                    }
                    if (src.smallestAggregateSize !== undefined) {
                        dst.smallestAggregateSize = src.smallestAggregateSize;
                    }
                    if (src.consider2ndOrderEffects !== undefined) {
                        dst.consider2ndOrderEffects = src.consider2ndOrderEffects;
                    }
                    // part of the element_type oneof 
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(src.beam);
                    }
                    // part of the element_type oneof 
                    if (src.column !== undefined && src.column !== null) {
                        dst.setColumn(src.column);
                    }
                    // part of the element_type oneof 
                    if (src.wall !== undefined && src.wall !== null) {
                        dst.setWall(src.wall);
                    }
                    // part of the element_type oneof 
                    if (src.ps !== undefined && src.ps !== null) {
                        dst.setPs(src.ps);
                    }
                    // part of the element_type oneof 
                    if (src.hc !== undefined && src.hc !== null) {
                        dst.setHc(src.hc);
                    }
                    // part of the element_type oneof 
                    if (src.slab !== undefined && src.slab !== null) {
                        dst.setSlab(src.slab);
                    }
                    if (src.additionalCommands !== undefined) {
                        dst.additionalCommands = src.additionalCommands;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ElementDesignSettings();
                    dst.partialCoeffs = this.partialCoeffs;
                    dst.fabrication = this.fabrication;
                    dst.enhancedShear = this.enhancedShear;
                    dst.enhancedQuality = this.enhancedQuality;
                    dst.enhancedData = this.enhancedData;
                    dst.crackedInShear = this.crackedInShear;
                    dst.cot = this.cot;
                    dst.constructionClass = this.constructionClass;
                    dst.fctmType = this.fctmType;
                    dst.useCompReinf = this.useCompReinf;
                    dst.lowStrengthVariation = this.lowStrengthVariation;
                    dst.largestAggregateSize = this.largestAggregateSize;
                    dst.smallestAggregateSize = this.smallestAggregateSize;
                    dst.consider2ndOrderEffects = this.consider2ndOrderEffects;
                    dst.element_type = this.element_type;
                    dst.additionalCommands = this.additionalCommands;
                    return dst;
                }

                deepClone() {
                    const json = ElementDesignSettings.toObject(this);
                    const dst = ElementDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IElementDesignSettings = ElementDesignSettings;
        } // namespace concrete


        // Defined in Design/timber.proto
        export namespace timber {
            export enum SecondOrderAnalysis {
                SECOND_ORDER_ANALYSIS_UNSPECIFIED = 0,
                SECOND_ORDER_ANALYSIS_IGNORE = 1,
                SECOND_ORDER_ANALYSIS_CONSIDER = 2,
                SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN = 3
            }
            export const SecondOrderAnalysis_FromObject = (src: unknown): SecondOrderAnalysis => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SECOND_ORDER_ANALYSIS_UNSPECIFIED':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED;
                    case 1:
                    case 'SECOND_ORDER_ANALYSIS_IGNORE':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_IGNORE;
                    case 2:
                    case 'SECOND_ORDER_ANALYSIS_CONSIDER':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_CONSIDER;
                    case 3:
                    case 'SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN':
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN;
                    default:
                        console.log('Unhandled value for SecondOrderAnalysis:' + src + '. ' + typeof(src));
                        return SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED;
                }
            };
            export const SecondOrderAnalysis_ToObject = (src: SecondOrderAnalysis): string | null => {
                switch (src) {
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED:
                        return 'SECOND_ORDER_ANALYSIS_UNSPECIFIED';
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_IGNORE:
                        return 'SECOND_ORDER_ANALYSIS_IGNORE';
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_CONSIDER:
                        return 'SECOND_ORDER_ANALYSIS_CONSIDER';
                    case SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN:
                        return 'SECOND_ORDER_ANALYSIS_FIRST_ORDER_DESIGN';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SecondOrderAnalysis, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ServiceClass {
                SERVICE_CLASS_UNSPECIFIED = 0,
                SERVICE_CLASS_1 = 1,
                SERVICE_CLASS_2 = 2,
                SERVICE_CLASS_3 = 3
            }
            export const ServiceClass_FromObject = (src: unknown): ServiceClass => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SERVICE_CLASS_UNSPECIFIED':
                        return ServiceClass.SERVICE_CLASS_UNSPECIFIED;
                    case 1:
                    case 'SERVICE_CLASS_1':
                        return ServiceClass.SERVICE_CLASS_1;
                    case 2:
                    case 'SERVICE_CLASS_2':
                        return ServiceClass.SERVICE_CLASS_2;
                    case 3:
                    case 'SERVICE_CLASS_3':
                        return ServiceClass.SERVICE_CLASS_3;
                    default:
                        console.log('Unhandled value for ServiceClass:' + src + '. ' + typeof(src));
                        return ServiceClass.SERVICE_CLASS_UNSPECIFIED;
                }
            };
            export const ServiceClass_ToObject = (src: ServiceClass): string | null => {
                switch (src) {
                    case ServiceClass.SERVICE_CLASS_UNSPECIFIED:
                        return 'SERVICE_CLASS_UNSPECIFIED';
                    case ServiceClass.SERVICE_CLASS_1:
                        return 'SERVICE_CLASS_1';
                    case ServiceClass.SERVICE_CLASS_2:
                        return 'SERVICE_CLASS_2';
                    case ServiceClass.SERVICE_CLASS_3:
                        return 'SERVICE_CLASS_3';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ServiceClass, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PartialCoefficient_keys = 'gammaM' | 'gammaMGl' | 'gammaMLvl' | 'gammaMPlate';
            export interface PartialCoefficient_createType {
                gammaM?: number,
                gammaMGl?: number,
                gammaMLvl?: number,
                gammaMPlate?: number,
            }
            export interface PartialCoefficient_json {
                gammaM?: JsonNumber;
                gammaMGl?: JsonNumber;
                gammaMLvl?: JsonNumber;
                gammaMPlate?: JsonNumber;
            }
            interface PartialCoefficient_json_in {
                __proto_name?: unknown;
                gammaM?: unknown;
                gammaMGl?: unknown;
                gammaMLvl?: unknown;
                gammaMPlate?: unknown;
            }
            export class PartialCoefficient {
                __proto_name = "ng.design.timber.PartialCoefficient";
                gammaM: number = 0;
                gammaMGl: number = 0;
                gammaMLvl: number = 0;
                gammaMPlate: number = 0;

                static fromObject(src_unknown: unknown): PartialCoefficient {
                    const dst = new PartialCoefficient();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficient but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficient_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficient but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaM !== undefined && src.gammaM !== null) {
                        if (typeof src.gammaM === "number" || src.gammaM === 'NaN' || src.gammaM === 'Infinity' || src.gammaM === '-Infinity') {
                            dst.gammaM = AsNum(src.gammaM);
                        }
                        else {
                            console.log('Expected gammaM of PartialCoefficient to be a number but was ', typeof src.gammaM, src.gammaM)
                        }
                    }
                    if (src.gammaMGl !== undefined && src.gammaMGl !== null) {
                        if (typeof src.gammaMGl === "number" || src.gammaMGl === 'NaN' || src.gammaMGl === 'Infinity' || src.gammaMGl === '-Infinity') {
                            dst.gammaMGl = AsNum(src.gammaMGl);
                        }
                        else {
                            console.log('Expected gammaMGl of PartialCoefficient to be a number but was ', typeof src.gammaMGl, src.gammaMGl)
                        }
                    }
                    if (src.gammaMLvl !== undefined && src.gammaMLvl !== null) {
                        if (typeof src.gammaMLvl === "number" || src.gammaMLvl === 'NaN' || src.gammaMLvl === 'Infinity' || src.gammaMLvl === '-Infinity') {
                            dst.gammaMLvl = AsNum(src.gammaMLvl);
                        }
                        else {
                            console.log('Expected gammaMLvl of PartialCoefficient to be a number but was ', typeof src.gammaMLvl, src.gammaMLvl)
                        }
                    }
                    if (src.gammaMPlate !== undefined && src.gammaMPlate !== null) {
                        if (typeof src.gammaMPlate === "number" || src.gammaMPlate === 'NaN' || src.gammaMPlate === 'Infinity' || src.gammaMPlate === '-Infinity') {
                            dst.gammaMPlate = AsNum(src.gammaMPlate);
                        }
                        else {
                            console.log('Expected gammaMPlate of PartialCoefficient to be a number but was ', typeof src.gammaMPlate, src.gammaMPlate)
                        }
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficient | null | undefined): PartialCoefficient_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.PartialCoefficient is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.PartialCoefficient") {
                        console.error('Expected ng.design.timber.PartialCoefficient but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficient_json = {
                        gammaM: AsJsonNum(src.gammaM),
                        gammaMGl: AsJsonNum(src.gammaMGl),
                        gammaMLvl: AsJsonNum(src.gammaMLvl),
                        gammaMPlate: AsJsonNum(src.gammaMPlate),
                    };
                    return dst;
                }

                static create(src?: PartialCoefficient_createType) {
                    const dst = new PartialCoefficient();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaM !== undefined) {
                        dst.gammaM = src.gammaM;
                    }
                    if (src.gammaMGl !== undefined) {
                        dst.gammaMGl = src.gammaMGl;
                    }
                    if (src.gammaMLvl !== undefined) {
                        dst.gammaMLvl = src.gammaMLvl;
                    }
                    if (src.gammaMPlate !== undefined) {
                        dst.gammaMPlate = src.gammaMPlate;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficient();
                    dst.gammaM = this.gammaM;
                    dst.gammaMGl = this.gammaMGl;
                    dst.gammaMLvl = this.gammaMLvl;
                    dst.gammaMPlate = this.gammaMPlate;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficient.toObject(this);
                    const dst = PartialCoefficient.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficient = PartialCoefficient;


            export type PartialCoefficients_keys = 'ultimate' | 'accidental' | 'gammaFire';
            export interface PartialCoefficients_createType {
                ultimate?: ng.design.timber.PartialCoefficient | null,
                accidental?: ng.design.timber.PartialCoefficient | null,
                gammaFire?: number,
            }
            export interface PartialCoefficients_json {
                ultimate?: ng.design.timber.PartialCoefficient_json;
                accidental?: ng.design.timber.PartialCoefficient_json;
                gammaFire?: JsonNumber;
            }
            interface PartialCoefficients_json_in {
                __proto_name?: unknown;
                ultimate?: unknown;
                accidental?: unknown;
                gammaFire?: unknown;
            }
            export class PartialCoefficients {
                __proto_name = "ng.design.timber.PartialCoefficients";
                ultimate: ng.design.timber.PartialCoefficient | null = null;
                accidental: ng.design.timber.PartialCoefficient | null = null;
                gammaFire: number = 0;

                static fromObject(src_unknown: unknown): PartialCoefficients {
                    const dst = new PartialCoefficients();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PartialCoefficients but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PartialCoefficients_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PartialCoefficients but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ultimate !== undefined && src.ultimate !== null) {
                        dst.ultimate = ng.design.timber.PartialCoefficient.fromObject(src.ultimate);
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        dst.accidental = ng.design.timber.PartialCoefficient.fromObject(src.accidental);
                    }
                    if (src.gammaFire !== undefined && src.gammaFire !== null) {
                        if (typeof src.gammaFire === "number" || src.gammaFire === 'NaN' || src.gammaFire === 'Infinity' || src.gammaFire === '-Infinity') {
                            dst.gammaFire = AsNum(src.gammaFire);
                        }
                        else {
                            console.log('Expected gammaFire of PartialCoefficients to be a number but was ', typeof src.gammaFire, src.gammaFire)
                        }
                    }
                    return dst;
                }

                static toObject(src: PartialCoefficients | null | undefined): PartialCoefficients_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.PartialCoefficients is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.PartialCoefficients") {
                        console.error('Expected ng.design.timber.PartialCoefficients but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PartialCoefficients_json = {
                        gammaFire: AsJsonNum(src.gammaFire),
                    };
                    if(src.ultimate !== null)
                    {
                        const parsed = ng.design.timber.PartialCoefficient.toObject(src.ultimate);
                        if(parsed === null) return null;
                        dst.ultimate = parsed;
                    }
                    if(src.accidental !== null)
                    {
                        const parsed = ng.design.timber.PartialCoefficient.toObject(src.accidental);
                        if(parsed === null) return null;
                        dst.accidental = parsed;
                    }
                    return dst;
                }

                static create(src?: PartialCoefficients_createType) {
                    const dst = new PartialCoefficients();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ultimate !== undefined) {
                        dst.ultimate = src.ultimate;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    if (src.gammaFire !== undefined) {
                        dst.gammaFire = src.gammaFire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PartialCoefficients();
                    dst.ultimate = this.ultimate;
                    dst.accidental = this.accidental;
                    dst.gammaFire = this.gammaFire;
                    return dst;
                }

                deepClone() {
                    const json = PartialCoefficients.toObject(this);
                    const dst = PartialCoefficients.fromObject(json);
                    return dst;
                }
            }
            export type IPartialCoefficients = PartialCoefficients;


            export type GeneralDesignSettings_keys = 'partialCoeffs' | 'memberSurfaceEmissivityTimber';
            export interface GeneralDesignSettings_createType {
                partialCoeffs?: ng.design.timber.PartialCoefficients | null,
                memberSurfaceEmissivityTimber?: number,
            }
            export interface GeneralDesignSettings_json {
                partialCoeffs?: ng.design.timber.PartialCoefficients_json;
                memberSurfaceEmissivityTimber?: JsonNumber;
            }
            interface GeneralDesignSettings_json_in {
                __proto_name?: unknown;
                partialCoeffs?: unknown;
                memberSurfaceEmissivityTimber?: unknown;
            }
            export class GeneralDesignSettings {
                __proto_name = "ng.design.timber.GeneralDesignSettings";
                partialCoeffs: ng.design.timber.PartialCoefficients | null = null;
                memberSurfaceEmissivityTimber: number = 0;

                static fromObject(src_unknown: unknown): GeneralDesignSettings {
                    const dst = new GeneralDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined && src.partialCoeffs !== null) {
                        dst.partialCoeffs = ng.design.timber.PartialCoefficients.fromObject(src.partialCoeffs);
                    }
                    if (src.memberSurfaceEmissivityTimber !== undefined && src.memberSurfaceEmissivityTimber !== null) {
                        if (typeof src.memberSurfaceEmissivityTimber === "number" || src.memberSurfaceEmissivityTimber === 'NaN' || src.memberSurfaceEmissivityTimber === 'Infinity' || src.memberSurfaceEmissivityTimber === '-Infinity') {
                            dst.memberSurfaceEmissivityTimber = AsNum(src.memberSurfaceEmissivityTimber);
                        }
                        else {
                            console.log('Expected memberSurfaceEmissivityTimber of GeneralDesignSettings to be a number but was ', typeof src.memberSurfaceEmissivityTimber, src.memberSurfaceEmissivityTimber)
                        }
                    }
                    return dst;
                }

                static toObject(src: GeneralDesignSettings | null | undefined): GeneralDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.GeneralDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.GeneralDesignSettings") {
                        console.error('Expected ng.design.timber.GeneralDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GeneralDesignSettings_json = {
                        memberSurfaceEmissivityTimber: AsJsonNum(src.memberSurfaceEmissivityTimber),
                    };
                    if(src.partialCoeffs !== null)
                    {
                        const parsed = ng.design.timber.PartialCoefficients.toObject(src.partialCoeffs);
                        if(parsed === null) return null;
                        dst.partialCoeffs = parsed;
                    }
                    return dst;
                }

                static create(src?: GeneralDesignSettings_createType) {
                    const dst = new GeneralDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.partialCoeffs !== undefined) {
                        dst.partialCoeffs = src.partialCoeffs;
                    }
                    if (src.memberSurfaceEmissivityTimber !== undefined) {
                        dst.memberSurfaceEmissivityTimber = src.memberSurfaceEmissivityTimber;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralDesignSettings();
                    dst.partialCoeffs = this.partialCoeffs;
                    dst.memberSurfaceEmissivityTimber = this.memberSurfaceEmissivityTimber;
                    return dst;
                }

                deepClone() {
                    const json = GeneralDesignSettings.toObject(this);
                    const dst = GeneralDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralDesignSettings = GeneralDesignSettings;


            export type BeamSettings_keys = 'secondOrderAnalysis' | 'laminationThickness' | 'ksys';
            export interface BeamSettings_createType {
                secondOrderAnalysis?: ng.design.timber.SecondOrderAnalysis,
                laminationThickness?: number,
                ksys?: number,
            }
            export interface BeamSettings_json {
                secondOrderAnalysis?: string;
                laminationThickness?: JsonNumber;
                ksys?: JsonNumber;
            }
            interface BeamSettings_json_in {
                __proto_name?: unknown;
                secondOrderAnalysis?: unknown;
                laminationThickness?: unknown;
                ksys?: unknown;
            }
            export class BeamSettings {
                __proto_name = "ng.design.timber.BeamSettings";
                secondOrderAnalysis: ng.design.timber.SecondOrderAnalysis = ng.design.timber.SecondOrderAnalysis.SECOND_ORDER_ANALYSIS_UNSPECIFIED;
                laminationThickness: number = 0;
                ksys: number = 0;

                static fromObject(src_unknown: unknown): BeamSettings {
                    const dst = new BeamSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BeamSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BeamSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BeamSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.secondOrderAnalysis !== undefined && src.secondOrderAnalysis !== null) {
                        dst.secondOrderAnalysis = ng.design.timber.SecondOrderAnalysis_FromObject(src.secondOrderAnalysis);
                    }
                    if (src.laminationThickness !== undefined && src.laminationThickness !== null) {
                        if (typeof src.laminationThickness === "number" || src.laminationThickness === 'NaN' || src.laminationThickness === 'Infinity' || src.laminationThickness === '-Infinity') {
                            dst.laminationThickness = AsNum(src.laminationThickness);
                        }
                        else {
                            console.log('Expected laminationThickness of BeamSettings to be a number but was ', typeof src.laminationThickness, src.laminationThickness)
                        }
                    }
                    if (src.ksys !== undefined && src.ksys !== null) {
                        if (typeof src.ksys === "number" || src.ksys === 'NaN' || src.ksys === 'Infinity' || src.ksys === '-Infinity') {
                            dst.ksys = AsNum(src.ksys);
                        }
                        else {
                            console.log('Expected ksys of BeamSettings to be a number but was ', typeof src.ksys, src.ksys)
                        }
                    }
                    return dst;
                }

                static toObject(src: BeamSettings | null | undefined): BeamSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.BeamSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.BeamSettings") {
                        console.error('Expected ng.design.timber.BeamSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const secondOrderAnalysis_obj = ng.design.timber.SecondOrderAnalysis_ToObject(src.secondOrderAnalysis);
                    if(secondOrderAnalysis_obj === null) return null;

                    const dst : BeamSettings_json = {
                        secondOrderAnalysis: secondOrderAnalysis_obj,
                        laminationThickness: AsJsonNum(src.laminationThickness),
                        ksys: AsJsonNum(src.ksys),
                    };
                    return dst;
                }

                static create(src?: BeamSettings_createType) {
                    const dst = new BeamSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.secondOrderAnalysis !== undefined) {
                        dst.secondOrderAnalysis = src.secondOrderAnalysis;
                    }
                    if (src.laminationThickness !== undefined) {
                        dst.laminationThickness = src.laminationThickness;
                    }
                    if (src.ksys !== undefined) {
                        dst.ksys = src.ksys;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BeamSettings();
                    dst.secondOrderAnalysis = this.secondOrderAnalysis;
                    dst.laminationThickness = this.laminationThickness;
                    dst.ksys = this.ksys;
                    return dst;
                }

                deepClone() {
                    const json = BeamSettings.toObject(this);
                    const dst = BeamSettings.fromObject(json);
                    return dst;
                }
            }
            export type IBeamSettings = BeamSettings;


            export type CharringRate_keys = 'calculateAuto' | 'betaN';
            export interface CharringRate_createType {
                calculateAuto?: boolean,
                betaN?: number,
            }
            export interface CharringRate_json {
                calculateAuto?: boolean;
                betaN?: JsonNumber;
            }
            interface CharringRate_json_in {
                __proto_name?: unknown;
                calculateAuto?: unknown;
                betaN?: unknown;
            }
            export class CharringRate {
                __proto_name = "ng.design.timber.CharringRate";
                calculateAuto: boolean = false;
                betaN: number = 0;

                static fromObject(src_unknown: unknown): CharringRate {
                    const dst = new CharringRate();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharringRate but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharringRate_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharringRate but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.calculateAuto !== undefined && src.calculateAuto !== null) {
                        if (typeof src.calculateAuto === "boolean") {
                            dst.calculateAuto = src.calculateAuto;
                        }
                        else {
                            console.log('Expected calculateAuto of CharringRate to be a boolean but was ', typeof src.calculateAuto, src.calculateAuto)
                        }
                    }
                    if (src.betaN !== undefined && src.betaN !== null) {
                        if (typeof src.betaN === "number" || src.betaN === 'NaN' || src.betaN === 'Infinity' || src.betaN === '-Infinity') {
                            dst.betaN = AsNum(src.betaN);
                        }
                        else {
                            console.log('Expected betaN of CharringRate to be a number but was ', typeof src.betaN, src.betaN)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharringRate | null | undefined): CharringRate_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.CharringRate is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.CharringRate") {
                        console.error('Expected ng.design.timber.CharringRate but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CharringRate_json = {
                        calculateAuto: src.calculateAuto,
                        betaN: AsJsonNum(src.betaN),
                    };
                    return dst;
                }

                static create(src?: CharringRate_createType) {
                    const dst = new CharringRate();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.calculateAuto !== undefined) {
                        dst.calculateAuto = src.calculateAuto;
                    }
                    if (src.betaN !== undefined) {
                        dst.betaN = src.betaN;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharringRate();
                    dst.calculateAuto = this.calculateAuto;
                    dst.betaN = this.betaN;
                    return dst;
                }

                deepClone() {
                    const json = CharringRate.toObject(this);
                    const dst = CharringRate.fromObject(json);
                    return dst;
                }
            }
            export type ICharringRate = CharringRate;


            export type FireProtection_keys = 'structProtectionTop' | 'structProtectionBottom' | 'structProtectionLeft' | 'structProtectionRight' | 'charringStartTimeTop' | 'charringStartTimeBottom' | 'charringStartTimeLeft' | 'charringStartTimeRight' | 'mtrl';
            export interface FireProtection_createType {
                structProtectionTop?: boolean,
                structProtectionBottom?: boolean,
                structProtectionLeft?: boolean,
                structProtectionRight?: boolean,
                charringStartTimeTop?: number,
                charringStartTimeBottom?: number,
                charringStartTimeLeft?: number,
                charringStartTimeRight?: number,
                mtrl?: ng.fire_protection.timber.Data | null,
            }
            export interface FireProtection_json {
                structProtectionTop?: boolean;
                structProtectionBottom?: boolean;
                structProtectionLeft?: boolean;
                structProtectionRight?: boolean;
                charringStartTimeTop?: JsonNumber;
                charringStartTimeBottom?: JsonNumber;
                charringStartTimeLeft?: JsonNumber;
                charringStartTimeRight?: JsonNumber;
                mtrl?: ng.fire_protection.timber.Data_json;
            }
            interface FireProtection_json_in {
                __proto_name?: unknown;
                structProtectionTop?: unknown;
                structProtectionBottom?: unknown;
                structProtectionLeft?: unknown;
                structProtectionRight?: unknown;
                charringStartTimeTop?: unknown;
                charringStartTimeBottom?: unknown;
                charringStartTimeLeft?: unknown;
                charringStartTimeRight?: unknown;
                mtrl?: unknown;
            }
            export class FireProtection {
                __proto_name = "ng.design.timber.FireProtection";
                structProtectionTop: boolean = false;
                structProtectionBottom: boolean = false;
                structProtectionLeft: boolean = false;
                structProtectionRight: boolean = false;
                charringStartTimeTop: number = 0;
                charringStartTimeBottom: number = 0;
                charringStartTimeLeft: number = 0;
                charringStartTimeRight: number = 0;
                mtrl: ng.fire_protection.timber.Data | null = null;

                static fromObject(src_unknown: unknown): FireProtection {
                    const dst = new FireProtection();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FireProtection but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FireProtection_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FireProtection but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.structProtectionTop !== undefined && src.structProtectionTop !== null) {
                        if (typeof src.structProtectionTop === "boolean") {
                            dst.structProtectionTop = src.structProtectionTop;
                        }
                        else {
                            console.log('Expected structProtectionTop of FireProtection to be a boolean but was ', typeof src.structProtectionTop, src.structProtectionTop)
                        }
                    }
                    if (src.structProtectionBottom !== undefined && src.structProtectionBottom !== null) {
                        if (typeof src.structProtectionBottom === "boolean") {
                            dst.structProtectionBottom = src.structProtectionBottom;
                        }
                        else {
                            console.log('Expected structProtectionBottom of FireProtection to be a boolean but was ', typeof src.structProtectionBottom, src.structProtectionBottom)
                        }
                    }
                    if (src.structProtectionLeft !== undefined && src.structProtectionLeft !== null) {
                        if (typeof src.structProtectionLeft === "boolean") {
                            dst.structProtectionLeft = src.structProtectionLeft;
                        }
                        else {
                            console.log('Expected structProtectionLeft of FireProtection to be a boolean but was ', typeof src.structProtectionLeft, src.structProtectionLeft)
                        }
                    }
                    if (src.structProtectionRight !== undefined && src.structProtectionRight !== null) {
                        if (typeof src.structProtectionRight === "boolean") {
                            dst.structProtectionRight = src.structProtectionRight;
                        }
                        else {
                            console.log('Expected structProtectionRight of FireProtection to be a boolean but was ', typeof src.structProtectionRight, src.structProtectionRight)
                        }
                    }
                    if (src.charringStartTimeTop !== undefined && src.charringStartTimeTop !== null) {
                        if (typeof src.charringStartTimeTop === "number" || src.charringStartTimeTop === 'NaN' || src.charringStartTimeTop === 'Infinity' || src.charringStartTimeTop === '-Infinity') {
                            dst.charringStartTimeTop = AsNum(src.charringStartTimeTop);
                        }
                        else {
                            console.log('Expected charringStartTimeTop of FireProtection to be a number but was ', typeof src.charringStartTimeTop, src.charringStartTimeTop)
                        }
                    }
                    if (src.charringStartTimeBottom !== undefined && src.charringStartTimeBottom !== null) {
                        if (typeof src.charringStartTimeBottom === "number" || src.charringStartTimeBottom === 'NaN' || src.charringStartTimeBottom === 'Infinity' || src.charringStartTimeBottom === '-Infinity') {
                            dst.charringStartTimeBottom = AsNum(src.charringStartTimeBottom);
                        }
                        else {
                            console.log('Expected charringStartTimeBottom of FireProtection to be a number but was ', typeof src.charringStartTimeBottom, src.charringStartTimeBottom)
                        }
                    }
                    if (src.charringStartTimeLeft !== undefined && src.charringStartTimeLeft !== null) {
                        if (typeof src.charringStartTimeLeft === "number" || src.charringStartTimeLeft === 'NaN' || src.charringStartTimeLeft === 'Infinity' || src.charringStartTimeLeft === '-Infinity') {
                            dst.charringStartTimeLeft = AsNum(src.charringStartTimeLeft);
                        }
                        else {
                            console.log('Expected charringStartTimeLeft of FireProtection to be a number but was ', typeof src.charringStartTimeLeft, src.charringStartTimeLeft)
                        }
                    }
                    if (src.charringStartTimeRight !== undefined && src.charringStartTimeRight !== null) {
                        if (typeof src.charringStartTimeRight === "number" || src.charringStartTimeRight === 'NaN' || src.charringStartTimeRight === 'Infinity' || src.charringStartTimeRight === '-Infinity') {
                            dst.charringStartTimeRight = AsNum(src.charringStartTimeRight);
                        }
                        else {
                            console.log('Expected charringStartTimeRight of FireProtection to be a number but was ', typeof src.charringStartTimeRight, src.charringStartTimeRight)
                        }
                    }
                    if (src.mtrl !== undefined && src.mtrl !== null) {
                        dst.mtrl = ng.fire_protection.timber.Data.fromObject(src.mtrl);
                    }
                    return dst;
                }

                static toObject(src: FireProtection | null | undefined): FireProtection_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.FireProtection is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.FireProtection") {
                        console.error('Expected ng.design.timber.FireProtection but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FireProtection_json = {
                        structProtectionTop: src.structProtectionTop,
                        structProtectionBottom: src.structProtectionBottom,
                        structProtectionLeft: src.structProtectionLeft,
                        structProtectionRight: src.structProtectionRight,
                        charringStartTimeTop: AsJsonNum(src.charringStartTimeTop),
                        charringStartTimeBottom: AsJsonNum(src.charringStartTimeBottom),
                        charringStartTimeLeft: AsJsonNum(src.charringStartTimeLeft),
                        charringStartTimeRight: AsJsonNum(src.charringStartTimeRight),
                    };
                    if(src.mtrl !== null)
                    {
                        const parsed = ng.fire_protection.timber.Data.toObject(src.mtrl);
                        if(parsed === null) return null;
                        dst.mtrl = parsed;
                    }
                    return dst;
                }

                static create(src?: FireProtection_createType) {
                    const dst = new FireProtection();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.structProtectionTop !== undefined) {
                        dst.structProtectionTop = src.structProtectionTop;
                    }
                    if (src.structProtectionBottom !== undefined) {
                        dst.structProtectionBottom = src.structProtectionBottom;
                    }
                    if (src.structProtectionLeft !== undefined) {
                        dst.structProtectionLeft = src.structProtectionLeft;
                    }
                    if (src.structProtectionRight !== undefined) {
                        dst.structProtectionRight = src.structProtectionRight;
                    }
                    if (src.charringStartTimeTop !== undefined) {
                        dst.charringStartTimeTop = src.charringStartTimeTop;
                    }
                    if (src.charringStartTimeBottom !== undefined) {
                        dst.charringStartTimeBottom = src.charringStartTimeBottom;
                    }
                    if (src.charringStartTimeLeft !== undefined) {
                        dst.charringStartTimeLeft = src.charringStartTimeLeft;
                    }
                    if (src.charringStartTimeRight !== undefined) {
                        dst.charringStartTimeRight = src.charringStartTimeRight;
                    }
                    if (src.mtrl !== undefined) {
                        dst.mtrl = src.mtrl;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FireProtection();
                    dst.structProtectionTop = this.structProtectionTop;
                    dst.structProtectionBottom = this.structProtectionBottom;
                    dst.structProtectionLeft = this.structProtectionLeft;
                    dst.structProtectionRight = this.structProtectionRight;
                    dst.charringStartTimeTop = this.charringStartTimeTop;
                    dst.charringStartTimeBottom = this.charringStartTimeBottom;
                    dst.charringStartTimeLeft = this.charringStartTimeLeft;
                    dst.charringStartTimeRight = this.charringStartTimeRight;
                    dst.mtrl = this.mtrl;
                    return dst;
                }

                deepClone() {
                    const json = FireProtection.toObject(this);
                    const dst = FireProtection.fromObject(json);
                    return dst;
                }
            }
            export type IFireProtection = FireProtection;


            export type Fire_keys = 'charringRate' | 'protected' | 'protection';
            export interface Fire_createType {
                charringRate?: ng.design.timber.CharringRate | null,
                protected?: boolean,
                protection?: ng.design.timber.FireProtection | null,
            }
            export interface Fire_json {
                charringRate?: ng.design.timber.CharringRate_json;
                protected?: boolean;
                protection?: ng.design.timber.FireProtection_json;
            }
            interface Fire_json_in {
                __proto_name?: unknown;
                charringRate?: unknown;
                protected?: unknown;
                protection?: unknown;
            }
            export class Fire {
                __proto_name = "ng.design.timber.Fire";
                charringRate: ng.design.timber.CharringRate | null = null;
                protected: boolean = false;
                protection: ng.design.timber.FireProtection | null = null;

                static fromObject(src_unknown: unknown): Fire {
                    const dst = new Fire();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Fire but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Fire_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Fire but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.charringRate !== undefined && src.charringRate !== null) {
                        dst.charringRate = ng.design.timber.CharringRate.fromObject(src.charringRate);
                    }
                    if (src.protected !== undefined && src.protected !== null) {
                        if (typeof src.protected === "boolean") {
                            dst.protected = src.protected;
                        }
                        else {
                            console.log('Expected protected of Fire to be a boolean but was ', typeof src.protected, src.protected)
                        }
                    }
                    if (src.protection !== undefined && src.protection !== null) {
                        dst.protection = ng.design.timber.FireProtection.fromObject(src.protection);
                    }
                    return dst;
                }

                static toObject(src: Fire | null | undefined): Fire_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.Fire is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.Fire") {
                        console.error('Expected ng.design.timber.Fire but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Fire_json = {
                        protected: src.protected,
                    };
                    if(src.charringRate !== null)
                    {
                        const parsed = ng.design.timber.CharringRate.toObject(src.charringRate);
                        if(parsed === null) return null;
                        dst.charringRate = parsed;
                    }
                    if(src.protection !== null)
                    {
                        const parsed = ng.design.timber.FireProtection.toObject(src.protection);
                        if(parsed === null) return null;
                        dst.protection = parsed;
                    }
                    return dst;
                }

                static create(src?: Fire_createType) {
                    const dst = new Fire();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.charringRate !== undefined) {
                        dst.charringRate = src.charringRate;
                    }
                    if (src.protected !== undefined) {
                        dst.protected = src.protected;
                    }
                    if (src.protection !== undefined) {
                        dst.protection = src.protection;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Fire();
                    dst.charringRate = this.charringRate;
                    dst.protected = this.protected;
                    dst.protection = this.protection;
                    return dst;
                }

                deepClone() {
                    const json = Fire.toObject(this);
                    const dst = Fire.fromObject(json);
                    return dst;
                }
            }
            export type IFire = Fire;


            export type ElementDesignSettings_keys = 'serviceclass' | 'kdef' | 'beam' | 'kcr' | 'fire';
            export interface ElementDesignSettings_createType {
                serviceclass?: ng.design.timber.ServiceClass,
                kdef?: number,
                beam?: ng.design.timber.BeamSettings | null,
                kcr?: number,
                fire?: ng.design.timber.Fire | null,
            }
            export interface ElementDesignSettings_json {
                serviceclass?: string;
                kdef?: JsonNumber;
                beam?: ng.design.timber.BeamSettings_json;
                kcr?: JsonNumber;
                fire?: ng.design.timber.Fire_json;
            }
            interface ElementDesignSettings_json_in {
                __proto_name?: unknown;
                serviceclass?: unknown;
                kdef?: unknown;
                beam?: unknown;
                kcr?: unknown;
                fire?: unknown;
            }
            export class ElementDesignSettings {
                __proto_name = "ng.design.timber.ElementDesignSettings";
                serviceclass: ng.design.timber.ServiceClass = ng.design.timber.ServiceClass.SERVICE_CLASS_UNSPECIFIED;
                kdef: number = 0;
                // this is a one of
                element: {type: 'beam'; beam: ng.design.timber.BeamSettings} | null = null;
                kcr: number = 0;
                fire: ng.design.timber.Fire | null = null;

                /** Gets the `Beam` value (or null) from the oneof `element` */
                getBeam(): ng.design.timber.BeamSettings | null {
                    if(this.element === null) return null;
                    if(this.element.type !== 'beam') return null;
                    return this.element.beam;
                }

                /** Sets the `Beam` value for the oneof `element`*/
                setBeam(value: ng.design.timber.BeamSettings | null) {
                    if(value !== null) {
                        this.element = {type: 'beam', beam:value};
                    }
                    else {
                        this.element = null;
                    }
                }

                static fromObject(src_unknown: unknown): ElementDesignSettings {
                    const dst = new ElementDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ElementDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ElementDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ElementDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.serviceclass !== undefined && src.serviceclass !== null) {
                        dst.serviceclass = ng.design.timber.ServiceClass_FromObject(src.serviceclass);
                    }
                    if (src.kdef !== undefined && src.kdef !== null) {
                        if (typeof src.kdef === "number" || src.kdef === 'NaN' || src.kdef === 'Infinity' || src.kdef === '-Infinity') {
                            dst.kdef = AsNum(src.kdef);
                        }
                        else {
                            console.log('Expected kdef of ElementDesignSettings to be a number but was ', typeof src.kdef, src.kdef)
                        }
                    }
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(ng.design.timber.BeamSettings.fromObject(src.beam));
                    }
                    if (src.kcr !== undefined && src.kcr !== null) {
                        if (typeof src.kcr === "number" || src.kcr === 'NaN' || src.kcr === 'Infinity' || src.kcr === '-Infinity') {
                            dst.kcr = AsNum(src.kcr);
                        }
                        else {
                            console.log('Expected kcr of ElementDesignSettings to be a number but was ', typeof src.kcr, src.kcr)
                        }
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        dst.fire = ng.design.timber.Fire.fromObject(src.fire);
                    }
                    return dst;
                }

                static toObject(src: ElementDesignSettings | null | undefined): ElementDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.timber.ElementDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.timber.ElementDesignSettings") {
                        console.error('Expected ng.design.timber.ElementDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const serviceclass_obj = ng.design.timber.ServiceClass_ToObject(src.serviceclass);
                    if(serviceclass_obj === null) return null;

                    const dst : ElementDesignSettings_json = {
                        serviceclass: serviceclass_obj,
                        kdef: AsJsonNum(src.kdef),
                        kcr: AsJsonNum(src.kcr),
                    };
                    const beam = src.getBeam();
                    if(beam !== null)
                    {
                        const parsed = ng.design.timber.BeamSettings.toObject(beam);
                        if(parsed === null) return null;
                        dst.beam = parsed;
                    }
                    if(src.fire !== null)
                    {
                        const parsed = ng.design.timber.Fire.toObject(src.fire);
                        if(parsed === null) return null;
                        dst.fire = parsed;
                    }
                    return dst;
                }

                static create(src?: ElementDesignSettings_createType) {
                    const dst = new ElementDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.serviceclass !== undefined) {
                        dst.serviceclass = src.serviceclass;
                    }
                    if (src.kdef !== undefined) {
                        dst.kdef = src.kdef;
                    }
                    // part of the element oneof 
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(src.beam);
                    }
                    if (src.kcr !== undefined) {
                        dst.kcr = src.kcr;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ElementDesignSettings();
                    dst.serviceclass = this.serviceclass;
                    dst.kdef = this.kdef;
                    dst.element = this.element;
                    dst.kcr = this.kcr;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = ElementDesignSettings.toObject(this);
                    const dst = ElementDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IElementDesignSettings = ElementDesignSettings;
        } // namespace timber


        // Defined in Design/load.proto
        export namespace load {
            export type GammaSupInf_keys = 'gammaSup' | 'gammaInf';
            export interface GammaSupInf_createType {
                gammaSup?: ng.design.load.GammaSet | null,
                gammaInf?: ng.design.load.GammaSet | null,
            }
            export interface GammaSupInf_json {
                gammaSup?: ng.design.load.GammaSet_json;
                gammaInf?: ng.design.load.GammaSet_json;
            }
            interface GammaSupInf_json_in {
                __proto_name?: unknown;
                gammaSup?: unknown;
                gammaInf?: unknown;
            }
            export class GammaSupInf {
                __proto_name = "ng.design.load.GammaSupInf";
                gammaSup: ng.design.load.GammaSet | null = null;
                gammaInf: ng.design.load.GammaSet | null = null;

                static fromObject(src_unknown: unknown): GammaSupInf {
                    const dst = new GammaSupInf();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaSupInf but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaSupInf_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaSupInf but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaSup !== undefined && src.gammaSup !== null) {
                        dst.gammaSup = ng.design.load.GammaSet.fromObject(src.gammaSup);
                    }
                    if (src.gammaInf !== undefined && src.gammaInf !== null) {
                        dst.gammaInf = ng.design.load.GammaSet.fromObject(src.gammaInf);
                    }
                    return dst;
                }

                static toObject(src: GammaSupInf | null | undefined): GammaSupInf_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.load.GammaSupInf is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.load.GammaSupInf") {
                        console.error('Expected ng.design.load.GammaSupInf but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaSupInf_json = {
                    };
                    if(src.gammaSup !== null)
                    {
                        const parsed = ng.design.load.GammaSet.toObject(src.gammaSup);
                        if(parsed === null) return null;
                        dst.gammaSup = parsed;
                    }
                    if(src.gammaInf !== null)
                    {
                        const parsed = ng.design.load.GammaSet.toObject(src.gammaInf);
                        if(parsed === null) return null;
                        dst.gammaInf = parsed;
                    }
                    return dst;
                }

                static create(src?: GammaSupInf_createType) {
                    const dst = new GammaSupInf();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaSup !== undefined) {
                        dst.gammaSup = src.gammaSup;
                    }
                    if (src.gammaInf !== undefined) {
                        dst.gammaInf = src.gammaInf;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaSupInf();
                    dst.gammaSup = this.gammaSup;
                    dst.gammaInf = this.gammaInf;
                    return dst;
                }

                deepClone() {
                    const json = GammaSupInf.toObject(this);
                    const dst = GammaSupInf.fromObject(json);
                    return dst;
                }
            }
            export type IGammaSupInf = GammaSupInf;


            export type GammaLoad_keys = 'gammaGj' | 'gammaQ1' | 'gammaQi' | 'gammaAccident';
            export interface GammaLoad_createType {
                gammaGj?: ng.design.load.GammaSupInf | null,
                gammaQ1?: ng.design.load.GammaSupInf | null,
                gammaQi?: ng.design.load.GammaSupInf | null,
                gammaAccident?: ng.design.load.GammaSupInf | null,
            }
            export interface GammaLoad_json {
                gammaGj?: ng.design.load.GammaSupInf_json;
                gammaQ1?: ng.design.load.GammaSupInf_json;
                gammaQi?: ng.design.load.GammaSupInf_json;
                gammaAccident?: ng.design.load.GammaSupInf_json;
            }
            interface GammaLoad_json_in {
                __proto_name?: unknown;
                gammaGj?: unknown;
                gammaQ1?: unknown;
                gammaQi?: unknown;
                gammaAccident?: unknown;
            }
            export class GammaLoad {
                __proto_name = "ng.design.load.GammaLoad";
                gammaGj: ng.design.load.GammaSupInf | null = null;
                gammaQ1: ng.design.load.GammaSupInf | null = null;
                gammaQi: ng.design.load.GammaSupInf | null = null;
                gammaAccident: ng.design.load.GammaSupInf | null = null;

                static fromObject(src_unknown: unknown): GammaLoad {
                    const dst = new GammaLoad();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaLoad but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaLoad_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaLoad but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gammaGj !== undefined && src.gammaGj !== null) {
                        dst.gammaGj = ng.design.load.GammaSupInf.fromObject(src.gammaGj);
                    }
                    if (src.gammaQ1 !== undefined && src.gammaQ1 !== null) {
                        dst.gammaQ1 = ng.design.load.GammaSupInf.fromObject(src.gammaQ1);
                    }
                    if (src.gammaQi !== undefined && src.gammaQi !== null) {
                        dst.gammaQi = ng.design.load.GammaSupInf.fromObject(src.gammaQi);
                    }
                    if (src.gammaAccident !== undefined && src.gammaAccident !== null) {
                        dst.gammaAccident = ng.design.load.GammaSupInf.fromObject(src.gammaAccident);
                    }
                    return dst;
                }

                static toObject(src: GammaLoad | null | undefined): GammaLoad_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.load.GammaLoad is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.load.GammaLoad") {
                        console.error('Expected ng.design.load.GammaLoad but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaLoad_json = {
                    };
                    if(src.gammaGj !== null)
                    {
                        const parsed = ng.design.load.GammaSupInf.toObject(src.gammaGj);
                        if(parsed === null) return null;
                        dst.gammaGj = parsed;
                    }
                    if(src.gammaQ1 !== null)
                    {
                        const parsed = ng.design.load.GammaSupInf.toObject(src.gammaQ1);
                        if(parsed === null) return null;
                        dst.gammaQ1 = parsed;
                    }
                    if(src.gammaQi !== null)
                    {
                        const parsed = ng.design.load.GammaSupInf.toObject(src.gammaQi);
                        if(parsed === null) return null;
                        dst.gammaQi = parsed;
                    }
                    if(src.gammaAccident !== null)
                    {
                        const parsed = ng.design.load.GammaSupInf.toObject(src.gammaAccident);
                        if(parsed === null) return null;
                        dst.gammaAccident = parsed;
                    }
                    return dst;
                }

                static create(src?: GammaLoad_createType) {
                    const dst = new GammaLoad();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gammaGj !== undefined) {
                        dst.gammaGj = src.gammaGj;
                    }
                    if (src.gammaQ1 !== undefined) {
                        dst.gammaQ1 = src.gammaQ1;
                    }
                    if (src.gammaQi !== undefined) {
                        dst.gammaQi = src.gammaQi;
                    }
                    if (src.gammaAccident !== undefined) {
                        dst.gammaAccident = src.gammaAccident;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaLoad();
                    dst.gammaGj = this.gammaGj;
                    dst.gammaQ1 = this.gammaQ1;
                    dst.gammaQi = this.gammaQi;
                    dst.gammaAccident = this.gammaAccident;
                    return dst;
                }

                deepClone() {
                    const json = GammaLoad.toObject(this);
                    const dst = GammaLoad.fromObject(json);
                    return dst;
                }
            }
            export type IGammaLoad = GammaLoad;


            export type GammaSet_keys = 'serviceabilityK' | 'serviceabilityFq' | 'serviceabilityQp' | 'setA' | 'setB610' | 'setB610a' | 'setB610b' | 'setC610' | 'setC6103' | 'setC6104' | 'setC6105' | 'accidental' | 'fire' | 'seismic' | 'set812' | 'set813a' | 'set813b' | 'set814a' | 'set814b' | 'setVC3' | 'setVC4';
            export interface GammaSet_createType {
                serviceabilityK?: ng.loadcombination.Coefficient[],
                serviceabilityFq?: ng.loadcombination.Coefficient[],
                serviceabilityQp?: ng.loadcombination.Coefficient[],
                setA?: ng.loadcombination.Coefficient[],
                setB610?: ng.loadcombination.Coefficient[],
                setB610a?: ng.loadcombination.Coefficient[],
                setB610b?: ng.loadcombination.Coefficient[],
                setC610?: ng.loadcombination.Coefficient[],
                setC6103?: ng.loadcombination.Coefficient[],
                setC6104?: ng.loadcombination.Coefficient[],
                setC6105?: ng.loadcombination.Coefficient[],
                accidental?: ng.loadcombination.Coefficient[],
                fire?: ng.loadcombination.Coefficient[],
                seismic?: ng.loadcombination.Coefficient[],
                set812?: ng.loadcombination.Coefficient[],
                set813a?: ng.loadcombination.Coefficient[],
                set813b?: ng.loadcombination.Coefficient[],
                set814a?: ng.loadcombination.Coefficient[],
                set814b?: ng.loadcombination.Coefficient[],
                setVC3?: ng.loadcombination.Coefficient[],
                setVC4?: ng.loadcombination.Coefficient[],
            }
            export interface GammaSet_json {
                serviceabilityK: ng.loadcombination.Coefficient_json[];
                serviceabilityFq: ng.loadcombination.Coefficient_json[];
                serviceabilityQp: ng.loadcombination.Coefficient_json[];
                setA: ng.loadcombination.Coefficient_json[];
                setB610: ng.loadcombination.Coefficient_json[];
                setB610a: ng.loadcombination.Coefficient_json[];
                setB610b: ng.loadcombination.Coefficient_json[];
                setC610: ng.loadcombination.Coefficient_json[];
                setC6103: ng.loadcombination.Coefficient_json[];
                setC6104: ng.loadcombination.Coefficient_json[];
                setC6105: ng.loadcombination.Coefficient_json[];
                accidental: ng.loadcombination.Coefficient_json[];
                fire: ng.loadcombination.Coefficient_json[];
                seismic: ng.loadcombination.Coefficient_json[];
                set812: ng.loadcombination.Coefficient_json[];
                set813a: ng.loadcombination.Coefficient_json[];
                set813b: ng.loadcombination.Coefficient_json[];
                set814a: ng.loadcombination.Coefficient_json[];
                set814b: ng.loadcombination.Coefficient_json[];
                setVC3: ng.loadcombination.Coefficient_json[];
                setVC4: ng.loadcombination.Coefficient_json[];
            }
            interface GammaSet_json_in {
                __proto_name?: unknown;
                serviceabilityK?: unknown;
                serviceabilityFq?: unknown;
                serviceabilityQp?: unknown;
                setA?: unknown;
                setB610?: unknown;
                setB610a?: unknown;
                setB610b?: unknown;
                setC610?: unknown;
                setC6103?: unknown;
                setC6104?: unknown;
                setC6105?: unknown;
                accidental?: unknown;
                fire?: unknown;
                seismic?: unknown;
                set812?: unknown;
                set813a?: unknown;
                set813b?: unknown;
                set814a?: unknown;
                set814b?: unknown;
                setVC3?: unknown;
                setVC4?: unknown;
            }
            export class GammaSet {
                __proto_name = "ng.design.load.GammaSet";
                serviceabilityK: ng.loadcombination.Coefficient[] = [];
                serviceabilityFq: ng.loadcombination.Coefficient[] = [];
                serviceabilityQp: ng.loadcombination.Coefficient[] = [];
                setA: ng.loadcombination.Coefficient[] = [];
                setB610: ng.loadcombination.Coefficient[] = [];
                setB610a: ng.loadcombination.Coefficient[] = [];
                setB610b: ng.loadcombination.Coefficient[] = [];
                setC610: ng.loadcombination.Coefficient[] = [];
                setC6103: ng.loadcombination.Coefficient[] = [];
                setC6104: ng.loadcombination.Coefficient[] = [];
                setC6105: ng.loadcombination.Coefficient[] = [];
                accidental: ng.loadcombination.Coefficient[] = [];
                fire: ng.loadcombination.Coefficient[] = [];
                seismic: ng.loadcombination.Coefficient[] = [];
                set812: ng.loadcombination.Coefficient[] = [];
                set813a: ng.loadcombination.Coefficient[] = [];
                set813b: ng.loadcombination.Coefficient[] = [];
                set814a: ng.loadcombination.Coefficient[] = [];
                set814b: ng.loadcombination.Coefficient[] = [];
                setVC3: ng.loadcombination.Coefficient[] = [];
                setVC4: ng.loadcombination.Coefficient[] = [];

                static fromObject(src_unknown: unknown): GammaSet {
                    const dst = new GammaSet();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GammaSet but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GammaSet_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GammaSet but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.serviceabilityK !== undefined && src.serviceabilityK !== null) {
                        if (Array.isArray(src.serviceabilityK)) {
                            for (const element of src.serviceabilityK) {
                                dst.serviceabilityK.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected serviceabilityK of GammaSet to be a array but was ', typeof src.serviceabilityK, src.serviceabilityK)
                        }
                    }
                    if (src.serviceabilityFq !== undefined && src.serviceabilityFq !== null) {
                        if (Array.isArray(src.serviceabilityFq)) {
                            for (const element of src.serviceabilityFq) {
                                dst.serviceabilityFq.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected serviceabilityFq of GammaSet to be a array but was ', typeof src.serviceabilityFq, src.serviceabilityFq)
                        }
                    }
                    if (src.serviceabilityQp !== undefined && src.serviceabilityQp !== null) {
                        if (Array.isArray(src.serviceabilityQp)) {
                            for (const element of src.serviceabilityQp) {
                                dst.serviceabilityQp.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected serviceabilityQp of GammaSet to be a array but was ', typeof src.serviceabilityQp, src.serviceabilityQp)
                        }
                    }
                    if (src.setA !== undefined && src.setA !== null) {
                        if (Array.isArray(src.setA)) {
                            for (const element of src.setA) {
                                dst.setA.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setA of GammaSet to be a array but was ', typeof src.setA, src.setA)
                        }
                    }
                    if (src.setB610 !== undefined && src.setB610 !== null) {
                        if (Array.isArray(src.setB610)) {
                            for (const element of src.setB610) {
                                dst.setB610.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setB610 of GammaSet to be a array but was ', typeof src.setB610, src.setB610)
                        }
                    }
                    if (src.setB610a !== undefined && src.setB610a !== null) {
                        if (Array.isArray(src.setB610a)) {
                            for (const element of src.setB610a) {
                                dst.setB610a.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setB610a of GammaSet to be a array but was ', typeof src.setB610a, src.setB610a)
                        }
                    }
                    if (src.setB610b !== undefined && src.setB610b !== null) {
                        if (Array.isArray(src.setB610b)) {
                            for (const element of src.setB610b) {
                                dst.setB610b.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setB610b of GammaSet to be a array but was ', typeof src.setB610b, src.setB610b)
                        }
                    }
                    if (src.setC610 !== undefined && src.setC610 !== null) {
                        if (Array.isArray(src.setC610)) {
                            for (const element of src.setC610) {
                                dst.setC610.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setC610 of GammaSet to be a array but was ', typeof src.setC610, src.setC610)
                        }
                    }
                    if (src.setC6103 !== undefined && src.setC6103 !== null) {
                        if (Array.isArray(src.setC6103)) {
                            for (const element of src.setC6103) {
                                dst.setC6103.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setC6103 of GammaSet to be a array but was ', typeof src.setC6103, src.setC6103)
                        }
                    }
                    if (src.setC6104 !== undefined && src.setC6104 !== null) {
                        if (Array.isArray(src.setC6104)) {
                            for (const element of src.setC6104) {
                                dst.setC6104.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setC6104 of GammaSet to be a array but was ', typeof src.setC6104, src.setC6104)
                        }
                    }
                    if (src.setC6105 !== undefined && src.setC6105 !== null) {
                        if (Array.isArray(src.setC6105)) {
                            for (const element of src.setC6105) {
                                dst.setC6105.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setC6105 of GammaSet to be a array but was ', typeof src.setC6105, src.setC6105)
                        }
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        if (Array.isArray(src.accidental)) {
                            for (const element of src.accidental) {
                                dst.accidental.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected accidental of GammaSet to be a array but was ', typeof src.accidental, src.accidental)
                        }
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        if (Array.isArray(src.fire)) {
                            for (const element of src.fire) {
                                dst.fire.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected fire of GammaSet to be a array but was ', typeof src.fire, src.fire)
                        }
                    }
                    if (src.seismic !== undefined && src.seismic !== null) {
                        if (Array.isArray(src.seismic)) {
                            for (const element of src.seismic) {
                                dst.seismic.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected seismic of GammaSet to be a array but was ', typeof src.seismic, src.seismic)
                        }
                    }
                    if (src.set812 !== undefined && src.set812 !== null) {
                        if (Array.isArray(src.set812)) {
                            for (const element of src.set812) {
                                dst.set812.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected set812 of GammaSet to be a array but was ', typeof src.set812, src.set812)
                        }
                    }
                    if (src.set813a !== undefined && src.set813a !== null) {
                        if (Array.isArray(src.set813a)) {
                            for (const element of src.set813a) {
                                dst.set813a.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected set813a of GammaSet to be a array but was ', typeof src.set813a, src.set813a)
                        }
                    }
                    if (src.set813b !== undefined && src.set813b !== null) {
                        if (Array.isArray(src.set813b)) {
                            for (const element of src.set813b) {
                                dst.set813b.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected set813b of GammaSet to be a array but was ', typeof src.set813b, src.set813b)
                        }
                    }
                    if (src.set814a !== undefined && src.set814a !== null) {
                        if (Array.isArray(src.set814a)) {
                            for (const element of src.set814a) {
                                dst.set814a.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected set814a of GammaSet to be a array but was ', typeof src.set814a, src.set814a)
                        }
                    }
                    if (src.set814b !== undefined && src.set814b !== null) {
                        if (Array.isArray(src.set814b)) {
                            for (const element of src.set814b) {
                                dst.set814b.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected set814b of GammaSet to be a array but was ', typeof src.set814b, src.set814b)
                        }
                    }
                    if (src.setVC3 !== undefined && src.setVC3 !== null) {
                        if (Array.isArray(src.setVC3)) {
                            for (const element of src.setVC3) {
                                dst.setVC3.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setVC3 of GammaSet to be a array but was ', typeof src.setVC3, src.setVC3)
                        }
                    }
                    if (src.setVC4 !== undefined && src.setVC4 !== null) {
                        if (Array.isArray(src.setVC4)) {
                            for (const element of src.setVC4) {
                                dst.setVC4.push(ng.loadcombination.Coefficient.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected setVC4 of GammaSet to be a array but was ', typeof src.setVC4, src.setVC4)
                        }
                    }
                    return dst;
                }

                static toObject(src: GammaSet | null | undefined): GammaSet_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.load.GammaSet is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.load.GammaSet") {
                        console.error('Expected ng.design.load.GammaSet but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GammaSet_json = {
                        serviceabilityK: new Array<ng.loadcombination.Coefficient_json>(),
                        serviceabilityFq: new Array<ng.loadcombination.Coefficient_json>(),
                        serviceabilityQp: new Array<ng.loadcombination.Coefficient_json>(),
                        setA: new Array<ng.loadcombination.Coefficient_json>(),
                        setB610: new Array<ng.loadcombination.Coefficient_json>(),
                        setB610a: new Array<ng.loadcombination.Coefficient_json>(),
                        setB610b: new Array<ng.loadcombination.Coefficient_json>(),
                        setC610: new Array<ng.loadcombination.Coefficient_json>(),
                        setC6103: new Array<ng.loadcombination.Coefficient_json>(),
                        setC6104: new Array<ng.loadcombination.Coefficient_json>(),
                        setC6105: new Array<ng.loadcombination.Coefficient_json>(),
                        accidental: new Array<ng.loadcombination.Coefficient_json>(),
                        fire: new Array<ng.loadcombination.Coefficient_json>(),
                        seismic: new Array<ng.loadcombination.Coefficient_json>(),
                        set812: new Array<ng.loadcombination.Coefficient_json>(),
                        set813a: new Array<ng.loadcombination.Coefficient_json>(),
                        set813b: new Array<ng.loadcombination.Coefficient_json>(),
                        set814a: new Array<ng.loadcombination.Coefficient_json>(),
                        set814b: new Array<ng.loadcombination.Coefficient_json>(),
                        setVC3: new Array<ng.loadcombination.Coefficient_json>(),
                        setVC4: new Array<ng.loadcombination.Coefficient_json>(),
                    };
                    if (src.serviceabilityK !== null) {
                        for (const element of src.serviceabilityK) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.serviceabilityK.push(parsed);
                        }
                    }
                    if (src.serviceabilityFq !== null) {
                        for (const element of src.serviceabilityFq) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.serviceabilityFq.push(parsed);
                        }
                    }
                    if (src.serviceabilityQp !== null) {
                        for (const element of src.serviceabilityQp) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.serviceabilityQp.push(parsed);
                        }
                    }
                    if (src.setA !== null) {
                        for (const element of src.setA) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setA.push(parsed);
                        }
                    }
                    if (src.setB610 !== null) {
                        for (const element of src.setB610) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setB610.push(parsed);
                        }
                    }
                    if (src.setB610a !== null) {
                        for (const element of src.setB610a) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setB610a.push(parsed);
                        }
                    }
                    if (src.setB610b !== null) {
                        for (const element of src.setB610b) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setB610b.push(parsed);
                        }
                    }
                    if (src.setC610 !== null) {
                        for (const element of src.setC610) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setC610.push(parsed);
                        }
                    }
                    if (src.setC6103 !== null) {
                        for (const element of src.setC6103) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setC6103.push(parsed);
                        }
                    }
                    if (src.setC6104 !== null) {
                        for (const element of src.setC6104) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setC6104.push(parsed);
                        }
                    }
                    if (src.setC6105 !== null) {
                        for (const element of src.setC6105) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setC6105.push(parsed);
                        }
                    }
                    if (src.accidental !== null) {
                        for (const element of src.accidental) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.accidental.push(parsed);
                        }
                    }
                    if (src.fire !== null) {
                        for (const element of src.fire) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.fire.push(parsed);
                        }
                    }
                    if (src.seismic !== null) {
                        for (const element of src.seismic) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.seismic.push(parsed);
                        }
                    }
                    if (src.set812 !== null) {
                        for (const element of src.set812) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.set812.push(parsed);
                        }
                    }
                    if (src.set813a !== null) {
                        for (const element of src.set813a) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.set813a.push(parsed);
                        }
                    }
                    if (src.set813b !== null) {
                        for (const element of src.set813b) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.set813b.push(parsed);
                        }
                    }
                    if (src.set814a !== null) {
                        for (const element of src.set814a) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.set814a.push(parsed);
                        }
                    }
                    if (src.set814b !== null) {
                        for (const element of src.set814b) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.set814b.push(parsed);
                        }
                    }
                    if (src.setVC3 !== null) {
                        for (const element of src.setVC3) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setVC3.push(parsed);
                        }
                    }
                    if (src.setVC4 !== null) {
                        for (const element of src.setVC4) {
                            const parsed = ng.loadcombination.Coefficient.toObject(element);
                            if(parsed === null) return null;
                            dst.setVC4.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: GammaSet_createType) {
                    const dst = new GammaSet();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.serviceabilityK !== undefined) {
                        dst.serviceabilityK = src.serviceabilityK;
                    }
                    if (src.serviceabilityFq !== undefined) {
                        dst.serviceabilityFq = src.serviceabilityFq;
                    }
                    if (src.serviceabilityQp !== undefined) {
                        dst.serviceabilityQp = src.serviceabilityQp;
                    }
                    if (src.setA !== undefined) {
                        dst.setA = src.setA;
                    }
                    if (src.setB610 !== undefined) {
                        dst.setB610 = src.setB610;
                    }
                    if (src.setB610a !== undefined) {
                        dst.setB610a = src.setB610a;
                    }
                    if (src.setB610b !== undefined) {
                        dst.setB610b = src.setB610b;
                    }
                    if (src.setC610 !== undefined) {
                        dst.setC610 = src.setC610;
                    }
                    if (src.setC6103 !== undefined) {
                        dst.setC6103 = src.setC6103;
                    }
                    if (src.setC6104 !== undefined) {
                        dst.setC6104 = src.setC6104;
                    }
                    if (src.setC6105 !== undefined) {
                        dst.setC6105 = src.setC6105;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    if (src.seismic !== undefined) {
                        dst.seismic = src.seismic;
                    }
                    if (src.set812 !== undefined) {
                        dst.set812 = src.set812;
                    }
                    if (src.set813a !== undefined) {
                        dst.set813a = src.set813a;
                    }
                    if (src.set813b !== undefined) {
                        dst.set813b = src.set813b;
                    }
                    if (src.set814a !== undefined) {
                        dst.set814a = src.set814a;
                    }
                    if (src.set814b !== undefined) {
                        dst.set814b = src.set814b;
                    }
                    if (src.setVC3 !== undefined) {
                        dst.setVC3 = src.setVC3;
                    }
                    if (src.setVC4 !== undefined) {
                        dst.setVC4 = src.setVC4;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GammaSet();
                    dst.serviceabilityK = this.serviceabilityK;
                    dst.serviceabilityFq = this.serviceabilityFq;
                    dst.serviceabilityQp = this.serviceabilityQp;
                    dst.setA = this.setA;
                    dst.setB610 = this.setB610;
                    dst.setB610a = this.setB610a;
                    dst.setB610b = this.setB610b;
                    dst.setC610 = this.setC610;
                    dst.setC6103 = this.setC6103;
                    dst.setC6104 = this.setC6104;
                    dst.setC6105 = this.setC6105;
                    dst.accidental = this.accidental;
                    dst.fire = this.fire;
                    dst.seismic = this.seismic;
                    dst.set812 = this.set812;
                    dst.set813a = this.set813a;
                    dst.set813b = this.set813b;
                    dst.set814a = this.set814a;
                    dst.set814b = this.set814b;
                    dst.setVC3 = this.setVC3;
                    dst.setVC4 = this.setVC4;
                    return dst;
                }

                deepClone() {
                    const json = GammaSet.toObject(this);
                    const dst = GammaSet.fromObject(json);
                    return dst;
                }
            }
            export type IGammaSet = GammaSet;


            export type GeneralDesignSettings_keys = 'use610ab' | 'usePsi1' | 'gammaLoad';
            export interface GeneralDesignSettings_createType {
                use610ab?: boolean,
                usePsi1?: boolean,
                gammaLoad?: ng.design.load.GammaLoad | null,
            }
            export interface GeneralDesignSettings_json {
                use610ab?: boolean;
                usePsi1?: boolean;
                gammaLoad?: ng.design.load.GammaLoad_json;
            }
            interface GeneralDesignSettings_json_in {
                __proto_name?: unknown;
                use610ab?: unknown;
                usePsi1?: unknown;
                gammaLoad?: unknown;
            }
            export class GeneralDesignSettings {
                __proto_name = "ng.design.load.GeneralDesignSettings";
                use610ab: boolean = false;
                usePsi1: boolean = false;
                gammaLoad: ng.design.load.GammaLoad | null = null;

                static fromObject(src_unknown: unknown): GeneralDesignSettings {
                    const dst = new GeneralDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.use610ab !== undefined && src.use610ab !== null) {
                        if (typeof src.use610ab === "boolean") {
                            dst.use610ab = src.use610ab;
                        }
                        else {
                            console.log('Expected use610ab of GeneralDesignSettings to be a boolean but was ', typeof src.use610ab, src.use610ab)
                        }
                    }
                    if (src.usePsi1 !== undefined && src.usePsi1 !== null) {
                        if (typeof src.usePsi1 === "boolean") {
                            dst.usePsi1 = src.usePsi1;
                        }
                        else {
                            console.log('Expected usePsi1 of GeneralDesignSettings to be a boolean but was ', typeof src.usePsi1, src.usePsi1)
                        }
                    }
                    if (src.gammaLoad !== undefined && src.gammaLoad !== null) {
                        dst.gammaLoad = ng.design.load.GammaLoad.fromObject(src.gammaLoad);
                    }
                    return dst;
                }

                static toObject(src: GeneralDesignSettings | null | undefined): GeneralDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.load.GeneralDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.load.GeneralDesignSettings") {
                        console.error('Expected ng.design.load.GeneralDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GeneralDesignSettings_json = {
                        use610ab: src.use610ab,
                        usePsi1: src.usePsi1,
                    };
                    if(src.gammaLoad !== null)
                    {
                        const parsed = ng.design.load.GammaLoad.toObject(src.gammaLoad);
                        if(parsed === null) return null;
                        dst.gammaLoad = parsed;
                    }
                    return dst;
                }

                static create(src?: GeneralDesignSettings_createType) {
                    const dst = new GeneralDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.use610ab !== undefined) {
                        dst.use610ab = src.use610ab;
                    }
                    if (src.usePsi1 !== undefined) {
                        dst.usePsi1 = src.usePsi1;
                    }
                    if (src.gammaLoad !== undefined) {
                        dst.gammaLoad = src.gammaLoad;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralDesignSettings();
                    dst.use610ab = this.use610ab;
                    dst.usePsi1 = this.usePsi1;
                    dst.gammaLoad = this.gammaLoad;
                    return dst;
                }

                deepClone() {
                    const json = GeneralDesignSettings.toObject(this);
                    const dst = GeneralDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralDesignSettings = GeneralDesignSettings;


            export type ElementDesignSettings_keys = unknown;
            export interface ElementDesignSettings_createType {
            }
            export interface ElementDesignSettings_json {
            }
            interface ElementDesignSettings_json_in {
                __proto_name?: unknown;
            }
            export class ElementDesignSettings {
                __proto_name = "ng.design.load.ElementDesignSettings";

                static fromObject(src_unknown: unknown): ElementDesignSettings {
                    const dst = new ElementDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ElementDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ElementDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ElementDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: ElementDesignSettings | null | undefined): ElementDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.design.load.ElementDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.design.load.ElementDesignSettings") {
                        console.error('Expected ng.design.load.ElementDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ElementDesignSettings_json = {
                    };
                    return dst;
                }

                static create(src?: ElementDesignSettings_createType) {
                    const dst = new ElementDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ElementDesignSettings();
                    return dst;
                }

                deepClone() {
                    const json = ElementDesignSettings.toObject(this);
                    const dst = ElementDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IElementDesignSettings = ElementDesignSettings;
        } // namespace load
    } // namespace design


    // Defined in Print/print.proto
    export namespace print {
        export enum ComponentType {
            COMPONENT_TYPE_UNSPECIFIED = 0,
            COMPONENT_TYPE_TABLE = 1,
            COMPONENT_TYPE_TABLE_PLOT = 2,
            COMPONENT_TYPE_BEAM_PLOT = 3,
            COMPONENT_TYPE_LINE_BREAK = 4,
            COMPONENT_TYPE_TABLE_PLOT_ENVELOPE = 5,
            COMPONENT_TYPE_SECTION = 6,
            COMPONENT_TYPE_LOAD_PLOT = 7,
            COMPONENT_TYPE_MIN_MAX = 8,
            COMPONENT_TYPE_UTILISATION = 9,
            COMPONENT_TYPE_LCA = 10,
            COMPONENT_TYPE_HTML = 11
        }
        export const ComponentType_FromObject = (src: unknown): ComponentType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'COMPONENT_TYPE_UNSPECIFIED':
                    return ComponentType.COMPONENT_TYPE_UNSPECIFIED;
                case 1:
                case 'COMPONENT_TYPE_TABLE':
                    return ComponentType.COMPONENT_TYPE_TABLE;
                case 2:
                case 'COMPONENT_TYPE_TABLE_PLOT':
                    return ComponentType.COMPONENT_TYPE_TABLE_PLOT;
                case 3:
                case 'COMPONENT_TYPE_BEAM_PLOT':
                    return ComponentType.COMPONENT_TYPE_BEAM_PLOT;
                case 4:
                case 'COMPONENT_TYPE_LINE_BREAK':
                    return ComponentType.COMPONENT_TYPE_LINE_BREAK;
                case 5:
                case 'COMPONENT_TYPE_TABLE_PLOT_ENVELOPE':
                    return ComponentType.COMPONENT_TYPE_TABLE_PLOT_ENVELOPE;
                case 6:
                case 'COMPONENT_TYPE_SECTION':
                    return ComponentType.COMPONENT_TYPE_SECTION;
                case 7:
                case 'COMPONENT_TYPE_LOAD_PLOT':
                    return ComponentType.COMPONENT_TYPE_LOAD_PLOT;
                case 8:
                case 'COMPONENT_TYPE_MIN_MAX':
                    return ComponentType.COMPONENT_TYPE_MIN_MAX;
                case 9:
                case 'COMPONENT_TYPE_UTILISATION':
                    return ComponentType.COMPONENT_TYPE_UTILISATION;
                case 10:
                case 'COMPONENT_TYPE_LCA':
                    return ComponentType.COMPONENT_TYPE_LCA;
                case 11:
                case 'COMPONENT_TYPE_HTML':
                    return ComponentType.COMPONENT_TYPE_HTML;
                default:
                    console.log('Unhandled value for ComponentType:' + src + '. ' + typeof(src));
                    return ComponentType.COMPONENT_TYPE_UNSPECIFIED;
            }
        };
        export const ComponentType_ToObject = (src: ComponentType): string | null => {
            switch (src) {
                case ComponentType.COMPONENT_TYPE_UNSPECIFIED:
                    return 'COMPONENT_TYPE_UNSPECIFIED';
                case ComponentType.COMPONENT_TYPE_TABLE:
                    return 'COMPONENT_TYPE_TABLE';
                case ComponentType.COMPONENT_TYPE_TABLE_PLOT:
                    return 'COMPONENT_TYPE_TABLE_PLOT';
                case ComponentType.COMPONENT_TYPE_BEAM_PLOT:
                    return 'COMPONENT_TYPE_BEAM_PLOT';
                case ComponentType.COMPONENT_TYPE_LINE_BREAK:
                    return 'COMPONENT_TYPE_LINE_BREAK';
                case ComponentType.COMPONENT_TYPE_TABLE_PLOT_ENVELOPE:
                    return 'COMPONENT_TYPE_TABLE_PLOT_ENVELOPE';
                case ComponentType.COMPONENT_TYPE_SECTION:
                    return 'COMPONENT_TYPE_SECTION';
                case ComponentType.COMPONENT_TYPE_LOAD_PLOT:
                    return 'COMPONENT_TYPE_LOAD_PLOT';
                case ComponentType.COMPONENT_TYPE_MIN_MAX:
                    return 'COMPONENT_TYPE_MIN_MAX';
                case ComponentType.COMPONENT_TYPE_UTILISATION:
                    return 'COMPONENT_TYPE_UTILISATION';
                case ComponentType.COMPONENT_TYPE_LCA:
                    return 'COMPONENT_TYPE_LCA';
                case ComponentType.COMPONENT_TYPE_HTML:
                    return 'COMPONENT_TYPE_HTML';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for ComponentType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type ResultColumn_keys = 'tag' | 'id' | 'data' | 'userDefined';
        export interface ResultColumn_createType {
            tag?: string,
            id?: string,
            data?: string[],
            userDefined?: string[],
        }
        export interface ResultColumn_json {
            tag?: string;
            id?: string;
            data: string[];
            userDefined: string[];
        }
        interface ResultColumn_json_in {
            __proto_name?: unknown;
            tag?: unknown;
            id?: unknown;
            data?: unknown;
            userDefined?: unknown;
        }
        export class ResultColumn {
            __proto_name = "ng.print.ResultColumn";
            tag: string = "";
            id: string = "";
            data: string[] = [];
            userDefined: string[] = [];

            static fromObject(src_unknown: unknown): ResultColumn {
                const dst = new ResultColumn();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ResultColumn but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ResultColumn_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ResultColumn but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.tag !== undefined && src.tag !== null) {
                    if (typeof src.tag === "string") {
                        dst.tag = src.tag;
                    }
                    else {
                        console.log('Expected tag of ResultColumn to be a string but was ', typeof src.tag, src.tag)
                    }
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of ResultColumn to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.data !== undefined && src.data !== null) {
                    if (Array.isArray(src.data)) {
                        for (const [index, element] of src.data.entries()) {
                            if (typeof element === "string") {
                                dst.data.push(element);
                            }
                            else {
                                console.log('Expected data of ResultColumn[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected data of ResultColumn to be a array but was ', typeof src.data, src.data)
                    }
                }
                if (src.userDefined !== undefined && src.userDefined !== null) {
                    if (Array.isArray(src.userDefined)) {
                        for (const [index, element] of src.userDefined.entries()) {
                            if (typeof element === "string") {
                                dst.userDefined.push(element);
                            }
                            else {
                                console.log('Expected userDefined of ResultColumn[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected userDefined of ResultColumn to be a array but was ', typeof src.userDefined, src.userDefined)
                    }
                }
                return dst;
            }

            static toObject(src: ResultColumn | null | undefined): ResultColumn_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.ResultColumn is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.ResultColumn") {
                    console.error('Expected ng.print.ResultColumn but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ResultColumn_json = {
                    tag: src.tag,
                    id: src.id,
                    data: new Array<string>(),
                    userDefined: new Array<string>(),
                };
                if (src.data !== null) {
                    for (const element of src.data) {
                        dst.data.push(element);
                    }
                }
                if (src.userDefined !== null) {
                    for (const element of src.userDefined) {
                        dst.userDefined.push(element);
                    }
                }
                return dst;
            }

            static create(src?: ResultColumn_createType) {
                const dst = new ResultColumn();
                if (src === undefined) {
                    return dst;
                }
                if (src.tag !== undefined) {
                    dst.tag = src.tag;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                if (src.userDefined !== undefined) {
                    dst.userDefined = src.userDefined;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ResultColumn();
                dst.tag = this.tag;
                dst.id = this.id;
                dst.data = this.data;
                dst.userDefined = this.userDefined;
                return dst;
            }

            deepClone() {
                const json = ResultColumn.toObject(this);
                const dst = ResultColumn.fromObject(json);
                return dst;
            }
        }
        export type IResultColumn = ResultColumn;


        export type ResultTable_keys = 'cols';
        export interface ResultTable_createType {
            cols?: ng.print.ResultColumn[],
        }
        export interface ResultTable_json {
            cols: ng.print.ResultColumn_json[];
        }
        interface ResultTable_json_in {
            __proto_name?: unknown;
            cols?: unknown;
        }
        export class ResultTable {
            __proto_name = "ng.print.ResultTable";
            cols: ng.print.ResultColumn[] = [];

            static fromObject(src_unknown: unknown): ResultTable {
                const dst = new ResultTable();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ResultTable but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ResultTable_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ResultTable but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.cols !== undefined && src.cols !== null) {
                    if (Array.isArray(src.cols)) {
                        for (const element of src.cols) {
                            dst.cols.push(ng.print.ResultColumn.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected cols of ResultTable to be a array but was ', typeof src.cols, src.cols)
                    }
                }
                return dst;
            }

            static toObject(src: ResultTable | null | undefined): ResultTable_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.ResultTable is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.ResultTable") {
                    console.error('Expected ng.print.ResultTable but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ResultTable_json = {
                    cols: new Array<ng.print.ResultColumn_json>(),
                };
                if (src.cols !== null) {
                    for (const element of src.cols) {
                        const parsed = ng.print.ResultColumn.toObject(element);
                        if(parsed === null) return null;
                        dst.cols.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: ResultTable_createType) {
                const dst = new ResultTable();
                if (src === undefined) {
                    return dst;
                }
                if (src.cols !== undefined) {
                    dst.cols = src.cols;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ResultTable();
                dst.cols = this.cols;
                return dst;
            }

            deepClone() {
                const json = ResultTable.toObject(this);
                const dst = ResultTable.fromObject(json);
                return dst;
            }
        }
        export type IResultTable = ResultTable;


        export type LoadcombinationResult_keys = 'limitState' | 'combOfAction' | 'type' | 'id' | 'caption' | 'supportResults' | 'elementResults';
        export interface LoadcombinationResult_createType {
            limitState?: string,
            combOfAction?: string,
            type?: string,
            id?: string,
            caption?: string,
            supportResults?: ng.print.ResultTable | null,
            elementResults?: ng.print.ResultTable | null,
        }
        export interface LoadcombinationResult_json {
            limitState?: string;
            combOfAction?: string;
            type?: string;
            id?: string;
            caption?: string;
            supportResults?: ng.print.ResultTable_json;
            elementResults?: ng.print.ResultTable_json;
        }
        interface LoadcombinationResult_json_in {
            __proto_name?: unknown;
            limitState?: unknown;
            combOfAction?: unknown;
            type?: unknown;
            id?: unknown;
            caption?: unknown;
            supportResults?: unknown;
            elementResults?: unknown;
        }
        export class LoadcombinationResult {
            __proto_name = "ng.print.LoadcombinationResult";
            limitState: string = "";
            combOfAction: string = "";
            type: string = "";
            id: string = "";
            caption: string = "";
            supportResults: ng.print.ResultTable | null = null;
            elementResults: ng.print.ResultTable | null = null;

            static fromObject(src_unknown: unknown): LoadcombinationResult {
                const dst = new LoadcombinationResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LoadcombinationResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LoadcombinationResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LoadcombinationResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.limitState !== undefined && src.limitState !== null) {
                    if (typeof src.limitState === "string") {
                        dst.limitState = src.limitState;
                    }
                    else {
                        console.log('Expected limitState of LoadcombinationResult to be a string but was ', typeof src.limitState, src.limitState)
                    }
                }
                if (src.combOfAction !== undefined && src.combOfAction !== null) {
                    if (typeof src.combOfAction === "string") {
                        dst.combOfAction = src.combOfAction;
                    }
                    else {
                        console.log('Expected combOfAction of LoadcombinationResult to be a string but was ', typeof src.combOfAction, src.combOfAction)
                    }
                }
                if (src.type !== undefined && src.type !== null) {
                    if (typeof src.type === "string") {
                        dst.type = src.type;
                    }
                    else {
                        console.log('Expected type of LoadcombinationResult to be a string but was ', typeof src.type, src.type)
                    }
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of LoadcombinationResult to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of LoadcombinationResult to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.supportResults !== undefined && src.supportResults !== null) {
                    dst.supportResults = ng.print.ResultTable.fromObject(src.supportResults);
                }
                if (src.elementResults !== undefined && src.elementResults !== null) {
                    dst.elementResults = ng.print.ResultTable.fromObject(src.elementResults);
                }
                return dst;
            }

            static toObject(src: LoadcombinationResult | null | undefined): LoadcombinationResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.LoadcombinationResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.LoadcombinationResult") {
                    console.error('Expected ng.print.LoadcombinationResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LoadcombinationResult_json = {
                    limitState: src.limitState,
                    combOfAction: src.combOfAction,
                    type: src.type,
                    id: src.id,
                    caption: src.caption,
                };
                if(src.supportResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.supportResults);
                    if(parsed === null) return null;
                    dst.supportResults = parsed;
                }
                if(src.elementResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.elementResults);
                    if(parsed === null) return null;
                    dst.elementResults = parsed;
                }
                return dst;
            }

            static create(src?: LoadcombinationResult_createType) {
                const dst = new LoadcombinationResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.limitState !== undefined) {
                    dst.limitState = src.limitState;
                }
                if (src.combOfAction !== undefined) {
                    dst.combOfAction = src.combOfAction;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.supportResults !== undefined) {
                    dst.supportResults = src.supportResults;
                }
                if (src.elementResults !== undefined) {
                    dst.elementResults = src.elementResults;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LoadcombinationResult();
                dst.limitState = this.limitState;
                dst.combOfAction = this.combOfAction;
                dst.type = this.type;
                dst.id = this.id;
                dst.caption = this.caption;
                dst.supportResults = this.supportResults;
                dst.elementResults = this.elementResults;
                return dst;
            }

            deepClone() {
                const json = LoadcombinationResult.toObject(this);
                const dst = LoadcombinationResult.fromObject(json);
                return dst;
            }
        }
        export type ILoadcombinationResult = LoadcombinationResult;


        export type LoadcombinationRcResult_keys = 'id' | 'caption' | 'maxUtilisationResults' | 'utilisationResults' | 'capacityResults';
        export interface LoadcombinationRcResult_createType {
            id?: string,
            caption?: string,
            maxUtilisationResults?: ng.print.ResultTable | null,
            utilisationResults?: ng.print.ResultTable | null,
            capacityResults?: ng.print.ResultTable | null,
        }
        export interface LoadcombinationRcResult_json {
            id?: string;
            caption?: string;
            maxUtilisationResults?: ng.print.ResultTable_json;
            utilisationResults?: ng.print.ResultTable_json;
            capacityResults?: ng.print.ResultTable_json;
        }
        interface LoadcombinationRcResult_json_in {
            __proto_name?: unknown;
            id?: unknown;
            caption?: unknown;
            maxUtilisationResults?: unknown;
            utilisationResults?: unknown;
            capacityResults?: unknown;
        }
        export class LoadcombinationRcResult {
            __proto_name = "ng.print.LoadcombinationRcResult";
            id: string = "";
            caption: string = "";
            maxUtilisationResults: ng.print.ResultTable | null = null;
            utilisationResults: ng.print.ResultTable | null = null;
            capacityResults: ng.print.ResultTable | null = null;

            static fromObject(src_unknown: unknown): LoadcombinationRcResult {
                const dst = new LoadcombinationRcResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LoadcombinationRcResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LoadcombinationRcResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LoadcombinationRcResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of LoadcombinationRcResult to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of LoadcombinationRcResult to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.maxUtilisationResults !== undefined && src.maxUtilisationResults !== null) {
                    dst.maxUtilisationResults = ng.print.ResultTable.fromObject(src.maxUtilisationResults);
                }
                if (src.utilisationResults !== undefined && src.utilisationResults !== null) {
                    dst.utilisationResults = ng.print.ResultTable.fromObject(src.utilisationResults);
                }
                if (src.capacityResults !== undefined && src.capacityResults !== null) {
                    dst.capacityResults = ng.print.ResultTable.fromObject(src.capacityResults);
                }
                return dst;
            }

            static toObject(src: LoadcombinationRcResult | null | undefined): LoadcombinationRcResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.LoadcombinationRcResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.LoadcombinationRcResult") {
                    console.error('Expected ng.print.LoadcombinationRcResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LoadcombinationRcResult_json = {
                    id: src.id,
                    caption: src.caption,
                };
                if(src.maxUtilisationResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.maxUtilisationResults);
                    if(parsed === null) return null;
                    dst.maxUtilisationResults = parsed;
                }
                if(src.utilisationResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.utilisationResults);
                    if(parsed === null) return null;
                    dst.utilisationResults = parsed;
                }
                if(src.capacityResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.capacityResults);
                    if(parsed === null) return null;
                    dst.capacityResults = parsed;
                }
                return dst;
            }

            static create(src?: LoadcombinationRcResult_createType) {
                const dst = new LoadcombinationRcResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.maxUtilisationResults !== undefined) {
                    dst.maxUtilisationResults = src.maxUtilisationResults;
                }
                if (src.utilisationResults !== undefined) {
                    dst.utilisationResults = src.utilisationResults;
                }
                if (src.capacityResults !== undefined) {
                    dst.capacityResults = src.capacityResults;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LoadcombinationRcResult();
                dst.id = this.id;
                dst.caption = this.caption;
                dst.maxUtilisationResults = this.maxUtilisationResults;
                dst.utilisationResults = this.utilisationResults;
                dst.capacityResults = this.capacityResults;
                return dst;
            }

            deepClone() {
                const json = LoadcombinationRcResult.toObject(this);
                const dst = LoadcombinationRcResult.fromObject(json);
                return dst;
            }
        }
        export type ILoadcombinationRcResult = LoadcombinationRcResult;


        export type LoadcombinationSteelResult_keys = 'id' | 'caption' | 'maxUtilisationResults' | 'utilisationResults' | 'capacityResults';
        export interface LoadcombinationSteelResult_createType {
            id?: string,
            caption?: string,
            maxUtilisationResults?: ng.print.ResultTable | null,
            utilisationResults?: ng.print.ResultTable | null,
            capacityResults?: ng.print.ResultTable | null,
        }
        export interface LoadcombinationSteelResult_json {
            id?: string;
            caption?: string;
            maxUtilisationResults?: ng.print.ResultTable_json;
            utilisationResults?: ng.print.ResultTable_json;
            capacityResults?: ng.print.ResultTable_json;
        }
        interface LoadcombinationSteelResult_json_in {
            __proto_name?: unknown;
            id?: unknown;
            caption?: unknown;
            maxUtilisationResults?: unknown;
            utilisationResults?: unknown;
            capacityResults?: unknown;
        }
        export class LoadcombinationSteelResult {
            __proto_name = "ng.print.LoadcombinationSteelResult";
            id: string = "";
            caption: string = "";
            maxUtilisationResults: ng.print.ResultTable | null = null;
            utilisationResults: ng.print.ResultTable | null = null;
            capacityResults: ng.print.ResultTable | null = null;

            static fromObject(src_unknown: unknown): LoadcombinationSteelResult {
                const dst = new LoadcombinationSteelResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LoadcombinationSteelResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LoadcombinationSteelResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LoadcombinationSteelResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of LoadcombinationSteelResult to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of LoadcombinationSteelResult to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.maxUtilisationResults !== undefined && src.maxUtilisationResults !== null) {
                    dst.maxUtilisationResults = ng.print.ResultTable.fromObject(src.maxUtilisationResults);
                }
                if (src.utilisationResults !== undefined && src.utilisationResults !== null) {
                    dst.utilisationResults = ng.print.ResultTable.fromObject(src.utilisationResults);
                }
                if (src.capacityResults !== undefined && src.capacityResults !== null) {
                    dst.capacityResults = ng.print.ResultTable.fromObject(src.capacityResults);
                }
                return dst;
            }

            static toObject(src: LoadcombinationSteelResult | null | undefined): LoadcombinationSteelResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.LoadcombinationSteelResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.LoadcombinationSteelResult") {
                    console.error('Expected ng.print.LoadcombinationSteelResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LoadcombinationSteelResult_json = {
                    id: src.id,
                    caption: src.caption,
                };
                if(src.maxUtilisationResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.maxUtilisationResults);
                    if(parsed === null) return null;
                    dst.maxUtilisationResults = parsed;
                }
                if(src.utilisationResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.utilisationResults);
                    if(parsed === null) return null;
                    dst.utilisationResults = parsed;
                }
                if(src.capacityResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.capacityResults);
                    if(parsed === null) return null;
                    dst.capacityResults = parsed;
                }
                return dst;
            }

            static create(src?: LoadcombinationSteelResult_createType) {
                const dst = new LoadcombinationSteelResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.maxUtilisationResults !== undefined) {
                    dst.maxUtilisationResults = src.maxUtilisationResults;
                }
                if (src.utilisationResults !== undefined) {
                    dst.utilisationResults = src.utilisationResults;
                }
                if (src.capacityResults !== undefined) {
                    dst.capacityResults = src.capacityResults;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LoadcombinationSteelResult();
                dst.id = this.id;
                dst.caption = this.caption;
                dst.maxUtilisationResults = this.maxUtilisationResults;
                dst.utilisationResults = this.utilisationResults;
                dst.capacityResults = this.capacityResults;
                return dst;
            }

            deepClone() {
                const json = LoadcombinationSteelResult.toObject(this);
                const dst = LoadcombinationSteelResult.fromObject(json);
                return dst;
            }
        }
        export type ILoadcombinationSteelResult = LoadcombinationSteelResult;


        export type LoadcombinationTimberResult_keys = 'id' | 'caption' | 'maxUtilisationResults' | 'utilisationResults' | 'capacityResults';
        export interface LoadcombinationTimberResult_createType {
            id?: string,
            caption?: string,
            maxUtilisationResults?: ng.print.ResultTable | null,
            utilisationResults?: ng.print.ResultTable | null,
            capacityResults?: ng.print.ResultTable | null,
        }
        export interface LoadcombinationTimberResult_json {
            id?: string;
            caption?: string;
            maxUtilisationResults?: ng.print.ResultTable_json;
            utilisationResults?: ng.print.ResultTable_json;
            capacityResults?: ng.print.ResultTable_json;
        }
        interface LoadcombinationTimberResult_json_in {
            __proto_name?: unknown;
            id?: unknown;
            caption?: unknown;
            maxUtilisationResults?: unknown;
            utilisationResults?: unknown;
            capacityResults?: unknown;
        }
        export class LoadcombinationTimberResult {
            __proto_name = "ng.print.LoadcombinationTimberResult";
            id: string = "";
            caption: string = "";
            maxUtilisationResults: ng.print.ResultTable | null = null;
            utilisationResults: ng.print.ResultTable | null = null;
            capacityResults: ng.print.ResultTable | null = null;

            static fromObject(src_unknown: unknown): LoadcombinationTimberResult {
                const dst = new LoadcombinationTimberResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LoadcombinationTimberResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LoadcombinationTimberResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LoadcombinationTimberResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of LoadcombinationTimberResult to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of LoadcombinationTimberResult to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.maxUtilisationResults !== undefined && src.maxUtilisationResults !== null) {
                    dst.maxUtilisationResults = ng.print.ResultTable.fromObject(src.maxUtilisationResults);
                }
                if (src.utilisationResults !== undefined && src.utilisationResults !== null) {
                    dst.utilisationResults = ng.print.ResultTable.fromObject(src.utilisationResults);
                }
                if (src.capacityResults !== undefined && src.capacityResults !== null) {
                    dst.capacityResults = ng.print.ResultTable.fromObject(src.capacityResults);
                }
                return dst;
            }

            static toObject(src: LoadcombinationTimberResult | null | undefined): LoadcombinationTimberResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.LoadcombinationTimberResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.LoadcombinationTimberResult") {
                    console.error('Expected ng.print.LoadcombinationTimberResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LoadcombinationTimberResult_json = {
                    id: src.id,
                    caption: src.caption,
                };
                if(src.maxUtilisationResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.maxUtilisationResults);
                    if(parsed === null) return null;
                    dst.maxUtilisationResults = parsed;
                }
                if(src.utilisationResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.utilisationResults);
                    if(parsed === null) return null;
                    dst.utilisationResults = parsed;
                }
                if(src.capacityResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.capacityResults);
                    if(parsed === null) return null;
                    dst.capacityResults = parsed;
                }
                return dst;
            }

            static create(src?: LoadcombinationTimberResult_createType) {
                const dst = new LoadcombinationTimberResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.maxUtilisationResults !== undefined) {
                    dst.maxUtilisationResults = src.maxUtilisationResults;
                }
                if (src.utilisationResults !== undefined) {
                    dst.utilisationResults = src.utilisationResults;
                }
                if (src.capacityResults !== undefined) {
                    dst.capacityResults = src.capacityResults;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LoadcombinationTimberResult();
                dst.id = this.id;
                dst.caption = this.caption;
                dst.maxUtilisationResults = this.maxUtilisationResults;
                dst.utilisationResults = this.utilisationResults;
                dst.capacityResults = this.capacityResults;
                return dst;
            }

            deepClone() {
                const json = LoadcombinationTimberResult.toObject(this);
                const dst = LoadcombinationTimberResult.fromObject(json);
                return dst;
            }
        }
        export type ILoadcombinationTimberResult = LoadcombinationTimberResult;


        export type SectionResult_keys = 'material' | 'perimeters' | 'holes' | 'rebars' | 'stirrups';
        export interface SectionResult_createType {
            material?: ng.sections.MaterialCategory,
            perimeters?: ng.geometry.PolyLine3D[],
            holes?: ng.geometry.PolyLine3D[],
            rebars?: ng.print.ResultTable | null,
            stirrups?: ng.print.ResultTable | null,
        }
        export interface SectionResult_json {
            material?: string;
            perimeters: ng.geometry.PolyLine3D_json[];
            holes: ng.geometry.PolyLine3D_json[];
            rebars?: ng.print.ResultTable_json;
            stirrups?: ng.print.ResultTable_json;
        }
        interface SectionResult_json_in {
            __proto_name?: unknown;
            material?: unknown;
            perimeters?: unknown;
            holes?: unknown;
            rebars?: unknown;
            stirrups?: unknown;
        }
        export class SectionResult {
            __proto_name = "ng.print.SectionResult";
            material: ng.sections.MaterialCategory = ng.sections.MaterialCategory.MATERIAL_CATEGORY_UNSPECIFIED;
            perimeters: ng.geometry.PolyLine3D[] = [];
            holes: ng.geometry.PolyLine3D[] = [];
            rebars: ng.print.ResultTable | null = null;
            stirrups: ng.print.ResultTable | null = null;

            static fromObject(src_unknown: unknown): SectionResult {
                const dst = new SectionResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SectionResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SectionResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SectionResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.material !== undefined && src.material !== null) {
                    dst.material = ng.sections.MaterialCategory_FromObject(src.material);
                }
                if (src.perimeters !== undefined && src.perimeters !== null) {
                    if (Array.isArray(src.perimeters)) {
                        for (const element of src.perimeters) {
                            dst.perimeters.push(ng.geometry.PolyLine3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected perimeters of SectionResult to be a array but was ', typeof src.perimeters, src.perimeters)
                    }
                }
                if (src.holes !== undefined && src.holes !== null) {
                    if (Array.isArray(src.holes)) {
                        for (const element of src.holes) {
                            dst.holes.push(ng.geometry.PolyLine3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected holes of SectionResult to be a array but was ', typeof src.holes, src.holes)
                    }
                }
                if (src.rebars !== undefined && src.rebars !== null) {
                    dst.rebars = ng.print.ResultTable.fromObject(src.rebars);
                }
                if (src.stirrups !== undefined && src.stirrups !== null) {
                    dst.stirrups = ng.print.ResultTable.fromObject(src.stirrups);
                }
                return dst;
            }

            static toObject(src: SectionResult | null | undefined): SectionResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.SectionResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.SectionResult") {
                    console.error('Expected ng.print.SectionResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const material_obj = ng.sections.MaterialCategory_ToObject(src.material);
                if(material_obj === null) return null;

                const dst : SectionResult_json = {
                    material: material_obj,
                    perimeters: new Array<ng.geometry.PolyLine3D_json>(),
                    holes: new Array<ng.geometry.PolyLine3D_json>(),
                };
                if (src.perimeters !== null) {
                    for (const element of src.perimeters) {
                        const parsed = ng.geometry.PolyLine3D.toObject(element);
                        if(parsed === null) return null;
                        dst.perimeters.push(parsed);
                    }
                }
                if (src.holes !== null) {
                    for (const element of src.holes) {
                        const parsed = ng.geometry.PolyLine3D.toObject(element);
                        if(parsed === null) return null;
                        dst.holes.push(parsed);
                    }
                }
                if(src.rebars !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.rebars);
                    if(parsed === null) return null;
                    dst.rebars = parsed;
                }
                if(src.stirrups !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.stirrups);
                    if(parsed === null) return null;
                    dst.stirrups = parsed;
                }
                return dst;
            }

            static create(src?: SectionResult_createType) {
                const dst = new SectionResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.material !== undefined) {
                    dst.material = src.material;
                }
                if (src.perimeters !== undefined) {
                    dst.perimeters = src.perimeters;
                }
                if (src.holes !== undefined) {
                    dst.holes = src.holes;
                }
                if (src.rebars !== undefined) {
                    dst.rebars = src.rebars;
                }
                if (src.stirrups !== undefined) {
                    dst.stirrups = src.stirrups;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SectionResult();
                dst.material = this.material;
                dst.perimeters = this.perimeters;
                dst.holes = this.holes;
                dst.rebars = this.rebars;
                dst.stirrups = this.stirrups;
                return dst;
            }

            deepClone() {
                const json = SectionResult.toObject(this);
                const dst = SectionResult.fromObject(json);
                return dst;
            }
        }
        export type ISectionResult = SectionResult;


        export type HtmlResult_keys = 'id' | 'caption' | 'html';
        export interface HtmlResult_createType {
            id?: string,
            caption?: string,
            html?: ng.print.ResultTable | null,
        }
        export interface HtmlResult_json {
            id?: string;
            caption?: string;
            html?: ng.print.ResultTable_json;
        }
        interface HtmlResult_json_in {
            __proto_name?: unknown;
            id?: unknown;
            caption?: unknown;
            html?: unknown;
        }
        export class HtmlResult {
            __proto_name = "ng.print.HtmlResult";
            id: string = "";
            caption: string = "";
            html: ng.print.ResultTable | null = null;

            static fromObject(src_unknown: unknown): HtmlResult {
                const dst = new HtmlResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted HtmlResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as HtmlResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for HtmlResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of HtmlResult to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of HtmlResult to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.html !== undefined && src.html !== null) {
                    dst.html = ng.print.ResultTable.fromObject(src.html);
                }
                return dst;
            }

            static toObject(src: HtmlResult | null | undefined): HtmlResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.HtmlResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.HtmlResult") {
                    console.error('Expected ng.print.HtmlResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : HtmlResult_json = {
                    id: src.id,
                    caption: src.caption,
                };
                if(src.html !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.html);
                    if(parsed === null) return null;
                    dst.html = parsed;
                }
                return dst;
            }

            static create(src?: HtmlResult_createType) {
                const dst = new HtmlResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.html !== undefined) {
                    dst.html = src.html;
                }
                return dst;
            }

            shallowClone() {
                const dst = new HtmlResult();
                dst.id = this.id;
                dst.caption = this.caption;
                dst.html = this.html;
                return dst;
            }

            deepClone() {
                const json = HtmlResult.toObject(this);
                const dst = HtmlResult.fromObject(json);
                return dst;
            }
        }
        export type IHtmlResult = HtmlResult;


        export type Data_keys = 'id' | 'codeSettings' | 'beamProperties' | 'mtrlProperties' | 'supports' | 'pointLoads' | 'distributedForceLoads' | 'distributedMomentLoads' | 'section' | 'loadcases' | 'loadcombinations' | 'loadcombinationResults' | 'loadcombinationRcResults' | 'loadcombinationSteelResults' | 'loadcombinationTimberResults' | 'calculationSections' | 'elementResults' | 'maxMin' | 'reactions' | 'utilisation' | 'maxCodeCheck' | 'maxCodeCheckFire';
        export interface Data_createType {
            id?: string,
            codeSettings?: ng.print.ResultTable | null,
            beamProperties?: ng.print.ResultTable | null,
            mtrlProperties?: ng.print.ResultTable | null,
            supports?: ng.print.ResultTable | null,
            pointLoads?: ng.print.ResultTable | null,
            distributedForceLoads?: ng.print.ResultTable | null,
            distributedMomentLoads?: ng.print.ResultTable | null,
            section?: ng.print.SectionResult | null,
            loadcases?: ng.print.ResultTable | null,
            loadcombinations?: ng.print.ResultTable | null,
            loadcombinationResults?: ng.print.LoadcombinationResult[],
            loadcombinationRcResults?: ng.print.LoadcombinationRcResult[],
            loadcombinationSteelResults?: ng.print.LoadcombinationSteelResult[],
            loadcombinationTimberResults?: ng.print.LoadcombinationTimberResult[],
            calculationSections?: ng.print.ResultColumn | null,
            elementResults?: ng.print.ResultTable | null,
            maxMin?: ng.print.ResultTable | null,
            reactions?: ng.print.ResultTable | null,
            utilisation?: ng.print.ResultTable | null,
            maxCodeCheck?: ng.print.HtmlResult[],
            maxCodeCheckFire?: ng.print.HtmlResult[],
        }
        export interface Data_json {
            id?: string;
            codeSettings?: ng.print.ResultTable_json;
            beamProperties?: ng.print.ResultTable_json;
            mtrlProperties?: ng.print.ResultTable_json;
            supports?: ng.print.ResultTable_json;
            pointLoads?: ng.print.ResultTable_json;
            distributedForceLoads?: ng.print.ResultTable_json;
            distributedMomentLoads?: ng.print.ResultTable_json;
            section?: ng.print.SectionResult_json;
            loadcases?: ng.print.ResultTable_json;
            loadcombinations?: ng.print.ResultTable_json;
            loadcombinationResults: ng.print.LoadcombinationResult_json[];
            loadcombinationRcResults: ng.print.LoadcombinationRcResult_json[];
            loadcombinationSteelResults: ng.print.LoadcombinationSteelResult_json[];
            loadcombinationTimberResults: ng.print.LoadcombinationTimberResult_json[];
            calculationSections?: ng.print.ResultColumn_json;
            elementResults?: ng.print.ResultTable_json;
            maxMin?: ng.print.ResultTable_json;
            reactions?: ng.print.ResultTable_json;
            utilisation?: ng.print.ResultTable_json;
            maxCodeCheck: ng.print.HtmlResult_json[];
            maxCodeCheckFire: ng.print.HtmlResult_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            codeSettings?: unknown;
            beamProperties?: unknown;
            mtrlProperties?: unknown;
            supports?: unknown;
            pointLoads?: unknown;
            distributedForceLoads?: unknown;
            distributedMomentLoads?: unknown;
            section?: unknown;
            loadcases?: unknown;
            loadcombinations?: unknown;
            loadcombinationResults?: unknown;
            loadcombinationRcResults?: unknown;
            loadcombinationSteelResults?: unknown;
            loadcombinationTimberResults?: unknown;
            calculationSections?: unknown;
            elementResults?: unknown;
            maxMin?: unknown;
            reactions?: unknown;
            utilisation?: unknown;
            maxCodeCheck?: unknown;
            maxCodeCheckFire?: unknown;
        }
        export class Data {
            __proto_name = "ng.print.Data";
            id: string = "";
            codeSettings: ng.print.ResultTable | null = null;
            beamProperties: ng.print.ResultTable | null = null;
            mtrlProperties: ng.print.ResultTable | null = null;
            supports: ng.print.ResultTable | null = null;
            pointLoads: ng.print.ResultTable | null = null;
            distributedForceLoads: ng.print.ResultTable | null = null;
            distributedMomentLoads: ng.print.ResultTable | null = null;
            section: ng.print.SectionResult | null = null;
            loadcases: ng.print.ResultTable | null = null;
            loadcombinations: ng.print.ResultTable | null = null;
            loadcombinationResults: ng.print.LoadcombinationResult[] = [];
            loadcombinationRcResults: ng.print.LoadcombinationRcResult[] = [];
            loadcombinationSteelResults: ng.print.LoadcombinationSteelResult[] = [];
            loadcombinationTimberResults: ng.print.LoadcombinationTimberResult[] = [];
            calculationSections: ng.print.ResultColumn | null = null;
            elementResults: ng.print.ResultTable | null = null;
            maxMin: ng.print.ResultTable | null = null;
            reactions: ng.print.ResultTable | null = null;
            utilisation: ng.print.ResultTable | null = null;
            maxCodeCheck: ng.print.HtmlResult[] = [];
            maxCodeCheckFire: ng.print.HtmlResult[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of Data to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.codeSettings !== undefined && src.codeSettings !== null) {
                    dst.codeSettings = ng.print.ResultTable.fromObject(src.codeSettings);
                }
                if (src.beamProperties !== undefined && src.beamProperties !== null) {
                    dst.beamProperties = ng.print.ResultTable.fromObject(src.beamProperties);
                }
                if (src.mtrlProperties !== undefined && src.mtrlProperties !== null) {
                    dst.mtrlProperties = ng.print.ResultTable.fromObject(src.mtrlProperties);
                }
                if (src.supports !== undefined && src.supports !== null) {
                    dst.supports = ng.print.ResultTable.fromObject(src.supports);
                }
                if (src.pointLoads !== undefined && src.pointLoads !== null) {
                    dst.pointLoads = ng.print.ResultTable.fromObject(src.pointLoads);
                }
                if (src.distributedForceLoads !== undefined && src.distributedForceLoads !== null) {
                    dst.distributedForceLoads = ng.print.ResultTable.fromObject(src.distributedForceLoads);
                }
                if (src.distributedMomentLoads !== undefined && src.distributedMomentLoads !== null) {
                    dst.distributedMomentLoads = ng.print.ResultTable.fromObject(src.distributedMomentLoads);
                }
                if (src.section !== undefined && src.section !== null) {
                    dst.section = ng.print.SectionResult.fromObject(src.section);
                }
                if (src.loadcases !== undefined && src.loadcases !== null) {
                    dst.loadcases = ng.print.ResultTable.fromObject(src.loadcases);
                }
                if (src.loadcombinations !== undefined && src.loadcombinations !== null) {
                    dst.loadcombinations = ng.print.ResultTable.fromObject(src.loadcombinations);
                }
                if (src.loadcombinationResults !== undefined && src.loadcombinationResults !== null) {
                    if (Array.isArray(src.loadcombinationResults)) {
                        for (const element of src.loadcombinationResults) {
                            dst.loadcombinationResults.push(ng.print.LoadcombinationResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected loadcombinationResults of Data to be a array but was ', typeof src.loadcombinationResults, src.loadcombinationResults)
                    }
                }
                if (src.loadcombinationRcResults !== undefined && src.loadcombinationRcResults !== null) {
                    if (Array.isArray(src.loadcombinationRcResults)) {
                        for (const element of src.loadcombinationRcResults) {
                            dst.loadcombinationRcResults.push(ng.print.LoadcombinationRcResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected loadcombinationRcResults of Data to be a array but was ', typeof src.loadcombinationRcResults, src.loadcombinationRcResults)
                    }
                }
                if (src.loadcombinationSteelResults !== undefined && src.loadcombinationSteelResults !== null) {
                    if (Array.isArray(src.loadcombinationSteelResults)) {
                        for (const element of src.loadcombinationSteelResults) {
                            dst.loadcombinationSteelResults.push(ng.print.LoadcombinationSteelResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected loadcombinationSteelResults of Data to be a array but was ', typeof src.loadcombinationSteelResults, src.loadcombinationSteelResults)
                    }
                }
                if (src.loadcombinationTimberResults !== undefined && src.loadcombinationTimberResults !== null) {
                    if (Array.isArray(src.loadcombinationTimberResults)) {
                        for (const element of src.loadcombinationTimberResults) {
                            dst.loadcombinationTimberResults.push(ng.print.LoadcombinationTimberResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected loadcombinationTimberResults of Data to be a array but was ', typeof src.loadcombinationTimberResults, src.loadcombinationTimberResults)
                    }
                }
                if (src.calculationSections !== undefined && src.calculationSections !== null) {
                    dst.calculationSections = ng.print.ResultColumn.fromObject(src.calculationSections);
                }
                if (src.elementResults !== undefined && src.elementResults !== null) {
                    dst.elementResults = ng.print.ResultTable.fromObject(src.elementResults);
                }
                if (src.maxMin !== undefined && src.maxMin !== null) {
                    dst.maxMin = ng.print.ResultTable.fromObject(src.maxMin);
                }
                if (src.reactions !== undefined && src.reactions !== null) {
                    dst.reactions = ng.print.ResultTable.fromObject(src.reactions);
                }
                if (src.utilisation !== undefined && src.utilisation !== null) {
                    dst.utilisation = ng.print.ResultTable.fromObject(src.utilisation);
                }
                if (src.maxCodeCheck !== undefined && src.maxCodeCheck !== null) {
                    if (Array.isArray(src.maxCodeCheck)) {
                        for (const element of src.maxCodeCheck) {
                            dst.maxCodeCheck.push(ng.print.HtmlResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected maxCodeCheck of Data to be a array but was ', typeof src.maxCodeCheck, src.maxCodeCheck)
                    }
                }
                if (src.maxCodeCheckFire !== undefined && src.maxCodeCheckFire !== null) {
                    if (Array.isArray(src.maxCodeCheckFire)) {
                        for (const element of src.maxCodeCheckFire) {
                            dst.maxCodeCheckFire.push(ng.print.HtmlResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected maxCodeCheckFire of Data to be a array but was ', typeof src.maxCodeCheckFire, src.maxCodeCheckFire)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.Data") {
                    console.error('Expected ng.print.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    id: src.id,
                    loadcombinationResults: new Array<ng.print.LoadcombinationResult_json>(),
                    loadcombinationRcResults: new Array<ng.print.LoadcombinationRcResult_json>(),
                    loadcombinationSteelResults: new Array<ng.print.LoadcombinationSteelResult_json>(),
                    loadcombinationTimberResults: new Array<ng.print.LoadcombinationTimberResult_json>(),
                    maxCodeCheck: new Array<ng.print.HtmlResult_json>(),
                    maxCodeCheckFire: new Array<ng.print.HtmlResult_json>(),
                };
                if(src.codeSettings !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.codeSettings);
                    if(parsed === null) return null;
                    dst.codeSettings = parsed;
                }
                if(src.beamProperties !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.beamProperties);
                    if(parsed === null) return null;
                    dst.beamProperties = parsed;
                }
                if(src.mtrlProperties !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.mtrlProperties);
                    if(parsed === null) return null;
                    dst.mtrlProperties = parsed;
                }
                if(src.supports !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.supports);
                    if(parsed === null) return null;
                    dst.supports = parsed;
                }
                if(src.pointLoads !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.pointLoads);
                    if(parsed === null) return null;
                    dst.pointLoads = parsed;
                }
                if(src.distributedForceLoads !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.distributedForceLoads);
                    if(parsed === null) return null;
                    dst.distributedForceLoads = parsed;
                }
                if(src.distributedMomentLoads !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.distributedMomentLoads);
                    if(parsed === null) return null;
                    dst.distributedMomentLoads = parsed;
                }
                if(src.section !== null)
                {
                    const parsed = ng.print.SectionResult.toObject(src.section);
                    if(parsed === null) return null;
                    dst.section = parsed;
                }
                if(src.loadcases !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.loadcases);
                    if(parsed === null) return null;
                    dst.loadcases = parsed;
                }
                if(src.loadcombinations !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.loadcombinations);
                    if(parsed === null) return null;
                    dst.loadcombinations = parsed;
                }
                if (src.loadcombinationResults !== null) {
                    for (const element of src.loadcombinationResults) {
                        const parsed = ng.print.LoadcombinationResult.toObject(element);
                        if(parsed === null) return null;
                        dst.loadcombinationResults.push(parsed);
                    }
                }
                if (src.loadcombinationRcResults !== null) {
                    for (const element of src.loadcombinationRcResults) {
                        const parsed = ng.print.LoadcombinationRcResult.toObject(element);
                        if(parsed === null) return null;
                        dst.loadcombinationRcResults.push(parsed);
                    }
                }
                if (src.loadcombinationSteelResults !== null) {
                    for (const element of src.loadcombinationSteelResults) {
                        const parsed = ng.print.LoadcombinationSteelResult.toObject(element);
                        if(parsed === null) return null;
                        dst.loadcombinationSteelResults.push(parsed);
                    }
                }
                if (src.loadcombinationTimberResults !== null) {
                    for (const element of src.loadcombinationTimberResults) {
                        const parsed = ng.print.LoadcombinationTimberResult.toObject(element);
                        if(parsed === null) return null;
                        dst.loadcombinationTimberResults.push(parsed);
                    }
                }
                if(src.calculationSections !== null)
                {
                    const parsed = ng.print.ResultColumn.toObject(src.calculationSections);
                    if(parsed === null) return null;
                    dst.calculationSections = parsed;
                }
                if(src.elementResults !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.elementResults);
                    if(parsed === null) return null;
                    dst.elementResults = parsed;
                }
                if(src.maxMin !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.maxMin);
                    if(parsed === null) return null;
                    dst.maxMin = parsed;
                }
                if(src.reactions !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.reactions);
                    if(parsed === null) return null;
                    dst.reactions = parsed;
                }
                if(src.utilisation !== null)
                {
                    const parsed = ng.print.ResultTable.toObject(src.utilisation);
                    if(parsed === null) return null;
                    dst.utilisation = parsed;
                }
                if (src.maxCodeCheck !== null) {
                    for (const element of src.maxCodeCheck) {
                        const parsed = ng.print.HtmlResult.toObject(element);
                        if(parsed === null) return null;
                        dst.maxCodeCheck.push(parsed);
                    }
                }
                if (src.maxCodeCheckFire !== null) {
                    for (const element of src.maxCodeCheckFire) {
                        const parsed = ng.print.HtmlResult.toObject(element);
                        if(parsed === null) return null;
                        dst.maxCodeCheckFire.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.codeSettings !== undefined) {
                    dst.codeSettings = src.codeSettings;
                }
                if (src.beamProperties !== undefined) {
                    dst.beamProperties = src.beamProperties;
                }
                if (src.mtrlProperties !== undefined) {
                    dst.mtrlProperties = src.mtrlProperties;
                }
                if (src.supports !== undefined) {
                    dst.supports = src.supports;
                }
                if (src.pointLoads !== undefined) {
                    dst.pointLoads = src.pointLoads;
                }
                if (src.distributedForceLoads !== undefined) {
                    dst.distributedForceLoads = src.distributedForceLoads;
                }
                if (src.distributedMomentLoads !== undefined) {
                    dst.distributedMomentLoads = src.distributedMomentLoads;
                }
                if (src.section !== undefined) {
                    dst.section = src.section;
                }
                if (src.loadcases !== undefined) {
                    dst.loadcases = src.loadcases;
                }
                if (src.loadcombinations !== undefined) {
                    dst.loadcombinations = src.loadcombinations;
                }
                if (src.loadcombinationResults !== undefined) {
                    dst.loadcombinationResults = src.loadcombinationResults;
                }
                if (src.loadcombinationRcResults !== undefined) {
                    dst.loadcombinationRcResults = src.loadcombinationRcResults;
                }
                if (src.loadcombinationSteelResults !== undefined) {
                    dst.loadcombinationSteelResults = src.loadcombinationSteelResults;
                }
                if (src.loadcombinationTimberResults !== undefined) {
                    dst.loadcombinationTimberResults = src.loadcombinationTimberResults;
                }
                if (src.calculationSections !== undefined) {
                    dst.calculationSections = src.calculationSections;
                }
                if (src.elementResults !== undefined) {
                    dst.elementResults = src.elementResults;
                }
                if (src.maxMin !== undefined) {
                    dst.maxMin = src.maxMin;
                }
                if (src.reactions !== undefined) {
                    dst.reactions = src.reactions;
                }
                if (src.utilisation !== undefined) {
                    dst.utilisation = src.utilisation;
                }
                if (src.maxCodeCheck !== undefined) {
                    dst.maxCodeCheck = src.maxCodeCheck;
                }
                if (src.maxCodeCheckFire !== undefined) {
                    dst.maxCodeCheckFire = src.maxCodeCheckFire;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.codeSettings = this.codeSettings;
                dst.beamProperties = this.beamProperties;
                dst.mtrlProperties = this.mtrlProperties;
                dst.supports = this.supports;
                dst.pointLoads = this.pointLoads;
                dst.distributedForceLoads = this.distributedForceLoads;
                dst.distributedMomentLoads = this.distributedMomentLoads;
                dst.section = this.section;
                dst.loadcases = this.loadcases;
                dst.loadcombinations = this.loadcombinations;
                dst.loadcombinationResults = this.loadcombinationResults;
                dst.loadcombinationRcResults = this.loadcombinationRcResults;
                dst.loadcombinationSteelResults = this.loadcombinationSteelResults;
                dst.loadcombinationTimberResults = this.loadcombinationTimberResults;
                dst.calculationSections = this.calculationSections;
                dst.elementResults = this.elementResults;
                dst.maxMin = this.maxMin;
                dst.reactions = this.reactions;
                dst.utilisation = this.utilisation;
                dst.maxCodeCheck = this.maxCodeCheck;
                dst.maxCodeCheckFire = this.maxCodeCheckFire;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;


        export type ResultState_keys = 'data';
        export interface ResultState_createType {
            data?: ng.print.Data[],
        }
        export interface ResultState_json {
            data: ng.print.Data_json[];
        }
        interface ResultState_json_in {
            __proto_name?: unknown;
            data?: unknown;
        }
        export class ResultState {
            __proto_name = "ng.print.ResultState";
            data: ng.print.Data[] = [];

            static fromObject(src_unknown: unknown): ResultState {
                const dst = new ResultState();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ResultState but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ResultState_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ResultState but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.data !== undefined && src.data !== null) {
                    if (Array.isArray(src.data)) {
                        for (const element of src.data) {
                            dst.data.push(ng.print.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected data of ResultState to be a array but was ', typeof src.data, src.data)
                    }
                }
                return dst;
            }

            static toObject(src: ResultState | null | undefined): ResultState_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.ResultState is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.ResultState") {
                    console.error('Expected ng.print.ResultState but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ResultState_json = {
                    data: new Array<ng.print.Data_json>(),
                };
                if (src.data !== null) {
                    for (const element of src.data) {
                        const parsed = ng.print.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.data.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: ResultState_createType) {
                const dst = new ResultState();
                if (src === undefined) {
                    return dst;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ResultState();
                dst.data = this.data;
                return dst;
            }

            deepClone() {
                const json = ResultState.toObject(this);
                const dst = ResultState.fromObject(json);
                return dst;
            }
        }
        export type IResultState = ResultState;


        export type PrintResult_keys = 'state';
        export interface PrintResult_createType {
            state?: ng.print.ResultState | null,
        }
        export interface PrintResult_json {
            state?: ng.print.ResultState_json;
        }
        interface PrintResult_json_in {
            __proto_name?: unknown;
            state?: unknown;
        }
        export class PrintResult {
            __proto_name = "ng.print.PrintResult";
            state: ng.print.ResultState | null = null;

            static fromObject(src_unknown: unknown): PrintResult {
                const dst = new PrintResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PrintResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PrintResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PrintResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.state !== undefined && src.state !== null) {
                    dst.state = ng.print.ResultState.fromObject(src.state);
                }
                return dst;
            }

            static toObject(src: PrintResult | null | undefined): PrintResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.PrintResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.PrintResult") {
                    console.error('Expected ng.print.PrintResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PrintResult_json = {
                };
                if(src.state !== null)
                {
                    const parsed = ng.print.ResultState.toObject(src.state);
                    if(parsed === null) return null;
                    dst.state = parsed;
                }
                return dst;
            }

            static create(src?: PrintResult_createType) {
                const dst = new PrintResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.state !== undefined) {
                    dst.state = src.state;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PrintResult();
                dst.state = this.state;
                return dst;
            }

            deepClone() {
                const json = PrintResult.toObject(this);
                const dst = PrintResult.fromObject(json);
                return dst;
            }
        }
        export type IPrintResult = PrintResult;


        export type ComponentSettingsRows_keys = 'col' | 'active' | 'list';
        export interface ComponentSettingsRows_createType {
            col?: string,
            active?: boolean,
            list?: string[],
        }
        export interface ComponentSettingsRows_json {
            col?: string;
            active?: boolean;
            list: string[];
        }
        interface ComponentSettingsRows_json_in {
            __proto_name?: unknown;
            col?: unknown;
            active?: unknown;
            list?: unknown;
        }
        export class ComponentSettingsRows {
            __proto_name = "ng.print.ComponentSettingsRows";
            col: string = "";
            active: boolean = false;
            list: string[] = [];

            static fromObject(src_unknown: unknown): ComponentSettingsRows {
                const dst = new ComponentSettingsRows();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ComponentSettingsRows but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ComponentSettingsRows_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ComponentSettingsRows but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.col !== undefined && src.col !== null) {
                    if (typeof src.col === "string") {
                        dst.col = src.col;
                    }
                    else {
                        console.log('Expected col of ComponentSettingsRows to be a string but was ', typeof src.col, src.col)
                    }
                }
                if (src.active !== undefined && src.active !== null) {
                    if (typeof src.active === "boolean") {
                        dst.active = src.active;
                    }
                    else {
                        console.log('Expected active of ComponentSettingsRows to be a boolean but was ', typeof src.active, src.active)
                    }
                }
                if (src.list !== undefined && src.list !== null) {
                    if (Array.isArray(src.list)) {
                        for (const [index, element] of src.list.entries()) {
                            if (typeof element === "string") {
                                dst.list.push(element);
                            }
                            else {
                                console.log('Expected list of ComponentSettingsRows[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected list of ComponentSettingsRows to be a array but was ', typeof src.list, src.list)
                    }
                }
                return dst;
            }

            static toObject(src: ComponentSettingsRows | null | undefined): ComponentSettingsRows_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.ComponentSettingsRows is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.ComponentSettingsRows") {
                    console.error('Expected ng.print.ComponentSettingsRows but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ComponentSettingsRows_json = {
                    col: src.col,
                    active: src.active,
                    list: new Array<string>(),
                };
                if (src.list !== null) {
                    for (const element of src.list) {
                        dst.list.push(element);
                    }
                }
                return dst;
            }

            static create(src?: ComponentSettingsRows_createType) {
                const dst = new ComponentSettingsRows();
                if (src === undefined) {
                    return dst;
                }
                if (src.col !== undefined) {
                    dst.col = src.col;
                }
                if (src.active !== undefined) {
                    dst.active = src.active;
                }
                if (src.list !== undefined) {
                    dst.list = src.list;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ComponentSettingsRows();
                dst.col = this.col;
                dst.active = this.active;
                dst.list = this.list;
                return dst;
            }

            deepClone() {
                const json = ComponentSettingsRows.toObject(this);
                const dst = ComponentSettingsRows.fromObject(json);
                return dst;
            }
        }
        export type IComponentSettingsRows = ComponentSettingsRows;


        export type ComponentSettings_keys = 'fixHeaders' | 'visibleHeaders' | 'availableHeaders' | 'visibleRows' | 'xAxisKey' | 'menu' | 'legend' | 'minmax' | 'split';
        export interface ComponentSettings_createType {
            fixHeaders?: string[],
            visibleHeaders?: string[],
            availableHeaders?: string[],
            visibleRows?: ng.print.ComponentSettingsRows | null,
            xAxisKey?: string,
            menu?: boolean,
            legend?: boolean,
            minmax?: boolean,
            split?: number,
        }
        export interface ComponentSettings_json {
            fixHeaders: string[];
            visibleHeaders: string[];
            availableHeaders: string[];
            visibleRows?: ng.print.ComponentSettingsRows_json;
            xAxisKey?: string;
            menu?: boolean;
            legend?: boolean;
            minmax?: boolean;
            split?: JsonNumber;
        }
        interface ComponentSettings_json_in {
            __proto_name?: unknown;
            fixHeaders?: unknown;
            visibleHeaders?: unknown;
            availableHeaders?: unknown;
            visibleRows?: unknown;
            xAxisKey?: unknown;
            menu?: unknown;
            legend?: unknown;
            minmax?: unknown;
            split?: unknown;
        }
        export class ComponentSettings {
            __proto_name = "ng.print.ComponentSettings";
            fixHeaders: string[] = [];
            visibleHeaders: string[] = [];
            availableHeaders: string[] = [];
            visibleRows: ng.print.ComponentSettingsRows | null = null;
            xAxisKey: string = "";
            menu: boolean = false;
            legend: boolean = false;
            minmax: boolean = false;
            split: number = 0;

            static fromObject(src_unknown: unknown): ComponentSettings {
                const dst = new ComponentSettings();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ComponentSettings but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ComponentSettings_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ComponentSettings but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.fixHeaders !== undefined && src.fixHeaders !== null) {
                    if (Array.isArray(src.fixHeaders)) {
                        for (const [index, element] of src.fixHeaders.entries()) {
                            if (typeof element === "string") {
                                dst.fixHeaders.push(element);
                            }
                            else {
                                console.log('Expected fixHeaders of ComponentSettings[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected fixHeaders of ComponentSettings to be a array but was ', typeof src.fixHeaders, src.fixHeaders)
                    }
                }
                if (src.visibleHeaders !== undefined && src.visibleHeaders !== null) {
                    if (Array.isArray(src.visibleHeaders)) {
                        for (const [index, element] of src.visibleHeaders.entries()) {
                            if (typeof element === "string") {
                                dst.visibleHeaders.push(element);
                            }
                            else {
                                console.log('Expected visibleHeaders of ComponentSettings[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected visibleHeaders of ComponentSettings to be a array but was ', typeof src.visibleHeaders, src.visibleHeaders)
                    }
                }
                if (src.availableHeaders !== undefined && src.availableHeaders !== null) {
                    if (Array.isArray(src.availableHeaders)) {
                        for (const [index, element] of src.availableHeaders.entries()) {
                            if (typeof element === "string") {
                                dst.availableHeaders.push(element);
                            }
                            else {
                                console.log('Expected availableHeaders of ComponentSettings[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected availableHeaders of ComponentSettings to be a array but was ', typeof src.availableHeaders, src.availableHeaders)
                    }
                }
                if (src.visibleRows !== undefined && src.visibleRows !== null) {
                    dst.visibleRows = ng.print.ComponentSettingsRows.fromObject(src.visibleRows);
                }
                if (src.xAxisKey !== undefined && src.xAxisKey !== null) {
                    if (typeof src.xAxisKey === "string") {
                        dst.xAxisKey = src.xAxisKey;
                    }
                    else {
                        console.log('Expected xAxisKey of ComponentSettings to be a string but was ', typeof src.xAxisKey, src.xAxisKey)
                    }
                }
                if (src.menu !== undefined && src.menu !== null) {
                    if (typeof src.menu === "boolean") {
                        dst.menu = src.menu;
                    }
                    else {
                        console.log('Expected menu of ComponentSettings to be a boolean but was ', typeof src.menu, src.menu)
                    }
                }
                if (src.legend !== undefined && src.legend !== null) {
                    if (typeof src.legend === "boolean") {
                        dst.legend = src.legend;
                    }
                    else {
                        console.log('Expected legend of ComponentSettings to be a boolean but was ', typeof src.legend, src.legend)
                    }
                }
                if (src.minmax !== undefined && src.minmax !== null) {
                    if (typeof src.minmax === "boolean") {
                        dst.minmax = src.minmax;
                    }
                    else {
                        console.log('Expected minmax of ComponentSettings to be a boolean but was ', typeof src.minmax, src.minmax)
                    }
                }
                if (src.split !== undefined && src.split !== null) {
                    if (typeof src.split === "number" || src.split === 'NaN' || src.split === 'Infinity' || src.split === '-Infinity') {
                        dst.split = NumberToInt("ng.print.ComponentSettings.split", AsNum(src.split));
                    }
                    else {
                        console.log('Expected split of ComponentSettings to be a number but was ', typeof src.split, src.split)
                    }
                }
                return dst;
            }

            static toObject(src: ComponentSettings | null | undefined): ComponentSettings_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.ComponentSettings is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.ComponentSettings") {
                    console.error('Expected ng.print.ComponentSettings but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ComponentSettings_json = {
                    fixHeaders: new Array<string>(),
                    visibleHeaders: new Array<string>(),
                    availableHeaders: new Array<string>(),
                    xAxisKey: src.xAxisKey,
                    menu: src.menu,
                    legend: src.legend,
                    minmax: src.minmax,
                    split: AsJsonNum(NumberToInt("ng.print.ComponentSettings.split", src.split)),
                };
                if (src.fixHeaders !== null) {
                    for (const element of src.fixHeaders) {
                        dst.fixHeaders.push(element);
                    }
                }
                if (src.visibleHeaders !== null) {
                    for (const element of src.visibleHeaders) {
                        dst.visibleHeaders.push(element);
                    }
                }
                if (src.availableHeaders !== null) {
                    for (const element of src.availableHeaders) {
                        dst.availableHeaders.push(element);
                    }
                }
                if(src.visibleRows !== null)
                {
                    const parsed = ng.print.ComponentSettingsRows.toObject(src.visibleRows);
                    if(parsed === null) return null;
                    dst.visibleRows = parsed;
                }
                return dst;
            }

            static create(src?: ComponentSettings_createType) {
                const dst = new ComponentSettings();
                if (src === undefined) {
                    return dst;
                }
                if (src.fixHeaders !== undefined) {
                    dst.fixHeaders = src.fixHeaders;
                }
                if (src.visibleHeaders !== undefined) {
                    dst.visibleHeaders = src.visibleHeaders;
                }
                if (src.availableHeaders !== undefined) {
                    dst.availableHeaders = src.availableHeaders;
                }
                if (src.visibleRows !== undefined) {
                    dst.visibleRows = src.visibleRows;
                }
                if (src.xAxisKey !== undefined) {
                    dst.xAxisKey = src.xAxisKey;
                }
                if (src.menu !== undefined) {
                    dst.menu = src.menu;
                }
                if (src.legend !== undefined) {
                    dst.legend = src.legend;
                }
                if (src.minmax !== undefined) {
                    dst.minmax = src.minmax;
                }
                if (src.split !== undefined) {
                    dst.split = src.split;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ComponentSettings();
                dst.fixHeaders = this.fixHeaders;
                dst.visibleHeaders = this.visibleHeaders;
                dst.availableHeaders = this.availableHeaders;
                dst.visibleRows = this.visibleRows;
                dst.xAxisKey = this.xAxisKey;
                dst.menu = this.menu;
                dst.legend = this.legend;
                dst.minmax = this.minmax;
                dst.split = this.split;
                return dst;
            }

            deepClone() {
                const json = ComponentSettings.toObject(this);
                const dst = ComponentSettings.fromObject(json);
                return dst;
            }
        }
        export type IComponentSettings = ComponentSettings;


        export type Component_keys = 'type' | 'id' | 'data' | 'caption' | 'w' | 'h' | 'x' | 'y' | 'settings' | 'static' | 'margin' | 'resizeOnClient';
        export interface Component_createType {
            type?: ng.print.ComponentType,
            id?: string,
            data?: string,
            caption?: string,
            w?: number,
            h?: number,
            x?: number,
            y?: number,
            settings?: ng.print.ComponentSettings | null,
            static?: boolean,
            margin?: number[],
            resizeOnClient?: boolean,
        }
        export interface Component_json {
            type?: string;
            id?: string;
            data?: string;
            caption?: string;
            w?: JsonNumber;
            h?: JsonNumber;
            x?: JsonNumber;
            y?: JsonNumber;
            settings?: ng.print.ComponentSettings_json;
            static?: boolean;
            margin: JsonNumber[];
            resizeOnClient?: boolean;
        }
        interface Component_json_in {
            __proto_name?: unknown;
            type?: unknown;
            id?: unknown;
            data?: unknown;
            caption?: unknown;
            w?: unknown;
            h?: unknown;
            x?: unknown;
            y?: unknown;
            settings?: unknown;
            static?: unknown;
            margin?: unknown;
            resizeOnClient?: unknown;
        }
        export class Component {
            __proto_name = "ng.print.Component";
            type: ng.print.ComponentType = ng.print.ComponentType.COMPONENT_TYPE_UNSPECIFIED;
            id: string = "";
            data: string = "";
            caption: string = "";
            w: number = 0;
            h: number = 0;
            x: number = 0;
            y: number = 0;
            settings: ng.print.ComponentSettings | null = null;
            static: boolean = false;
            margin: number[] = [];
            resizeOnClient: boolean = false;

            static fromObject(src_unknown: unknown): Component {
                const dst = new Component();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Component but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Component_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Component but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.print.ComponentType_FromObject(src.type);
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of Component to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.data !== undefined && src.data !== null) {
                    if (typeof src.data === "string") {
                        dst.data = src.data;
                    }
                    else {
                        console.log('Expected data of Component to be a string but was ', typeof src.data, src.data)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of Component to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.w !== undefined && src.w !== null) {
                    if (typeof src.w === "number" || src.w === 'NaN' || src.w === 'Infinity' || src.w === '-Infinity') {
                        dst.w = AsNum(src.w);
                    }
                    else {
                        console.log('Expected w of Component to be a number but was ', typeof src.w, src.w)
                    }
                }
                if (src.h !== undefined && src.h !== null) {
                    if (typeof src.h === "number" || src.h === 'NaN' || src.h === 'Infinity' || src.h === '-Infinity') {
                        dst.h = AsNum(src.h);
                    }
                    else {
                        console.log('Expected h of Component to be a number but was ', typeof src.h, src.h)
                    }
                }
                if (src.x !== undefined && src.x !== null) {
                    if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                        dst.x = AsNum(src.x);
                    }
                    else {
                        console.log('Expected x of Component to be a number but was ', typeof src.x, src.x)
                    }
                }
                if (src.y !== undefined && src.y !== null) {
                    if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                        dst.y = AsNum(src.y);
                    }
                    else {
                        console.log('Expected y of Component to be a number but was ', typeof src.y, src.y)
                    }
                }
                if (src.settings !== undefined && src.settings !== null) {
                    dst.settings = ng.print.ComponentSettings.fromObject(src.settings);
                }
                if (src.static !== undefined && src.static !== null) {
                    if (typeof src.static === "boolean") {
                        dst.static = src.static;
                    }
                    else {
                        console.log('Expected static of Component to be a boolean but was ', typeof src.static, src.static)
                    }
                }
                if (src.margin !== undefined && src.margin !== null) {
                    if (Array.isArray(src.margin)) {
                        for (const [index, element] of src.margin.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.margin.push(AsNum(element));
                            }
                            else {
                                console.log('Expected margin of Component[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected margin of Component to be a array but was ', typeof src.margin, src.margin)
                    }
                }
                if (src.resizeOnClient !== undefined && src.resizeOnClient !== null) {
                    if (typeof src.resizeOnClient === "boolean") {
                        dst.resizeOnClient = src.resizeOnClient;
                    }
                    else {
                        console.log('Expected resizeOnClient of Component to be a boolean but was ', typeof src.resizeOnClient, src.resizeOnClient)
                    }
                }
                return dst;
            }

            static toObject(src: Component | null | undefined): Component_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.Component is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.Component") {
                    console.error('Expected ng.print.Component but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.print.ComponentType_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : Component_json = {
                    type: type_obj,
                    id: src.id,
                    data: src.data,
                    caption: src.caption,
                    w: AsJsonNum(src.w),
                    h: AsJsonNum(src.h),
                    x: AsJsonNum(src.x),
                    y: AsJsonNum(src.y),
                    static: src.static,
                    margin: new Array<JsonNumber>(),
                    resizeOnClient: src.resizeOnClient,
                };
                if(src.settings !== null)
                {
                    const parsed = ng.print.ComponentSettings.toObject(src.settings);
                    if(parsed === null) return null;
                    dst.settings = parsed;
                }
                if (src.margin !== null) {
                    for (const element of src.margin) {
                        dst.margin.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: Component_createType) {
                const dst = new Component();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.w !== undefined) {
                    dst.w = src.w;
                }
                if (src.h !== undefined) {
                    dst.h = src.h;
                }
                if (src.x !== undefined) {
                    dst.x = src.x;
                }
                if (src.y !== undefined) {
                    dst.y = src.y;
                }
                if (src.settings !== undefined) {
                    dst.settings = src.settings;
                }
                if (src.static !== undefined) {
                    dst.static = src.static;
                }
                if (src.margin !== undefined) {
                    dst.margin = src.margin;
                }
                if (src.resizeOnClient !== undefined) {
                    dst.resizeOnClient = src.resizeOnClient;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Component();
                dst.type = this.type;
                dst.id = this.id;
                dst.data = this.data;
                dst.caption = this.caption;
                dst.w = this.w;
                dst.h = this.h;
                dst.x = this.x;
                dst.y = this.y;
                dst.settings = this.settings;
                dst.static = this.static;
                dst.margin = this.margin;
                dst.resizeOnClient = this.resizeOnClient;
                return dst;
            }

            deepClone() {
                const json = Component.toObject(this);
                const dst = Component.fromObject(json);
                return dst;
            }
        }
        export type IComponent = Component;


        export type Page_keys = 'id' | 'components';
        export interface Page_createType {
            id?: string,
            components?: ng.print.Component[],
        }
        export interface Page_json {
            id?: string;
            components: ng.print.Component_json[];
        }
        interface Page_json_in {
            __proto_name?: unknown;
            id?: unknown;
            components?: unknown;
        }
        export class Page {
            __proto_name = "ng.print.Page";
            id: string = "";
            components: ng.print.Component[] = [];

            static fromObject(src_unknown: unknown): Page {
                const dst = new Page();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Page but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Page_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Page but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of Page to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.components !== undefined && src.components !== null) {
                    if (Array.isArray(src.components)) {
                        for (const element of src.components) {
                            dst.components.push(ng.print.Component.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected components of Page to be a array but was ', typeof src.components, src.components)
                    }
                }
                return dst;
            }

            static toObject(src: Page | null | undefined): Page_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.Page is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.Page") {
                    console.error('Expected ng.print.Page but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Page_json = {
                    id: src.id,
                    components: new Array<ng.print.Component_json>(),
                };
                if (src.components !== null) {
                    for (const element of src.components) {
                        const parsed = ng.print.Component.toObject(element);
                        if(parsed === null) return null;
                        dst.components.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Page_createType) {
                const dst = new Page();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.components !== undefined) {
                    dst.components = src.components;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Page();
                dst.id = this.id;
                dst.components = this.components;
                return dst;
            }

            deepClone() {
                const json = Page.toObject(this);
                const dst = Page.fromObject(json);
                return dst;
            }
        }
        export type IPage = Page;


        export type Section_keys = 'id' | 'caption' | 'data' | 'pages' | 'isExpanded';
        export interface Section_createType {
            id?: string,
            caption?: string,
            data?: string,
            pages?: ng.print.Page[],
            isExpanded?: boolean,
        }
        export interface Section_json {
            id?: string;
            caption?: string;
            data?: string;
            pages: ng.print.Page_json[];
            isExpanded?: boolean;
        }
        interface Section_json_in {
            __proto_name?: unknown;
            id?: unknown;
            caption?: unknown;
            data?: unknown;
            pages?: unknown;
            isExpanded?: unknown;
        }
        export class Section {
            __proto_name = "ng.print.Section";
            id: string = "";
            caption: string = "";
            data: string = "";
            pages: ng.print.Page[] = [];
            isExpanded: boolean = false;

            static fromObject(src_unknown: unknown): Section {
                const dst = new Section();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Section but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Section_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Section but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of Section to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of Section to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.data !== undefined && src.data !== null) {
                    if (typeof src.data === "string") {
                        dst.data = src.data;
                    }
                    else {
                        console.log('Expected data of Section to be a string but was ', typeof src.data, src.data)
                    }
                }
                if (src.pages !== undefined && src.pages !== null) {
                    if (Array.isArray(src.pages)) {
                        for (const element of src.pages) {
                            dst.pages.push(ng.print.Page.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected pages of Section to be a array but was ', typeof src.pages, src.pages)
                    }
                }
                if (src.isExpanded !== undefined && src.isExpanded !== null) {
                    if (typeof src.isExpanded === "boolean") {
                        dst.isExpanded = src.isExpanded;
                    }
                    else {
                        console.log('Expected isExpanded of Section to be a boolean but was ', typeof src.isExpanded, src.isExpanded)
                    }
                }
                return dst;
            }

            static toObject(src: Section | null | undefined): Section_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.Section is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.Section") {
                    console.error('Expected ng.print.Section but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Section_json = {
                    id: src.id,
                    caption: src.caption,
                    data: src.data,
                    pages: new Array<ng.print.Page_json>(),
                    isExpanded: src.isExpanded,
                };
                if (src.pages !== null) {
                    for (const element of src.pages) {
                        const parsed = ng.print.Page.toObject(element);
                        if(parsed === null) return null;
                        dst.pages.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Section_createType) {
                const dst = new Section();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                if (src.pages !== undefined) {
                    dst.pages = src.pages;
                }
                if (src.isExpanded !== undefined) {
                    dst.isExpanded = src.isExpanded;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Section();
                dst.id = this.id;
                dst.caption = this.caption;
                dst.data = this.data;
                dst.pages = this.pages;
                dst.isExpanded = this.isExpanded;
                return dst;
            }

            deepClone() {
                const json = Section.toObject(this);
                const dst = Section.fromObject(json);
                return dst;
            }
        }
        export type ISection = Section;


        export type Layout_keys = 'id' | 'caption' | 'sections' | 'refGuid' | 'isExpanded';
        export interface Layout_createType {
            id?: string,
            caption?: string,
            sections?: ng.print.Section[],
            refGuid?: string,
            isExpanded?: boolean,
        }
        export interface Layout_json {
            id?: string;
            caption?: string;
            sections: ng.print.Section_json[];
            refGuid?: string;
            isExpanded?: boolean;
        }
        interface Layout_json_in {
            __proto_name?: unknown;
            id?: unknown;
            caption?: unknown;
            sections?: unknown;
            refGuid?: unknown;
            isExpanded?: unknown;
        }
        export class Layout {
            __proto_name = "ng.print.Layout";
            id: string = "";
            caption: string = "";
            sections: ng.print.Section[] = [];
            refGuid: string = "";
            isExpanded: boolean = false;

            static fromObject(src_unknown: unknown): Layout {
                const dst = new Layout();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Layout but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Layout_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Layout but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "string") {
                        dst.id = src.id;
                    }
                    else {
                        console.log('Expected id of Layout to be a string but was ', typeof src.id, src.id)
                    }
                }
                if (src.caption !== undefined && src.caption !== null) {
                    if (typeof src.caption === "string") {
                        dst.caption = src.caption;
                    }
                    else {
                        console.log('Expected caption of Layout to be a string but was ', typeof src.caption, src.caption)
                    }
                }
                if (src.sections !== undefined && src.sections !== null) {
                    if (Array.isArray(src.sections)) {
                        for (const element of src.sections) {
                            dst.sections.push(ng.print.Section.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected sections of Layout to be a array but was ', typeof src.sections, src.sections)
                    }
                }
                if (src.refGuid !== undefined && src.refGuid !== null) {
                    if (typeof src.refGuid === "string") {
                        dst.refGuid = src.refGuid;
                    }
                    else {
                        console.log('Expected refGuid of Layout to be a string but was ', typeof src.refGuid, src.refGuid)
                    }
                }
                if (src.isExpanded !== undefined && src.isExpanded !== null) {
                    if (typeof src.isExpanded === "boolean") {
                        dst.isExpanded = src.isExpanded;
                    }
                    else {
                        console.log('Expected isExpanded of Layout to be a boolean but was ', typeof src.isExpanded, src.isExpanded)
                    }
                }
                return dst;
            }

            static toObject(src: Layout | null | undefined): Layout_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.Layout is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.Layout") {
                    console.error('Expected ng.print.Layout but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Layout_json = {
                    id: src.id,
                    caption: src.caption,
                    sections: new Array<ng.print.Section_json>(),
                    refGuid: src.refGuid,
                    isExpanded: src.isExpanded,
                };
                if (src.sections !== null) {
                    for (const element of src.sections) {
                        const parsed = ng.print.Section.toObject(element);
                        if(parsed === null) return null;
                        dst.sections.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Layout_createType) {
                const dst = new Layout();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.caption !== undefined) {
                    dst.caption = src.caption;
                }
                if (src.sections !== undefined) {
                    dst.sections = src.sections;
                }
                if (src.refGuid !== undefined) {
                    dst.refGuid = src.refGuid;
                }
                if (src.isExpanded !== undefined) {
                    dst.isExpanded = src.isExpanded;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Layout();
                dst.id = this.id;
                dst.caption = this.caption;
                dst.sections = this.sections;
                dst.refGuid = this.refGuid;
                dst.isExpanded = this.isExpanded;
                return dst;
            }

            deepClone() {
                const json = Layout.toObject(this);
                const dst = Layout.fromObject(json);
                return dst;
            }
        }
        export type ILayout = Layout;


        export type LayoutState_keys = 'layouts';
        export interface LayoutState_createType {
            layouts?: ng.print.Layout[],
        }
        export interface LayoutState_json {
            layouts: ng.print.Layout_json[];
        }
        interface LayoutState_json_in {
            __proto_name?: unknown;
            layouts?: unknown;
        }
        export class LayoutState {
            __proto_name = "ng.print.LayoutState";
            layouts: ng.print.Layout[] = [];

            static fromObject(src_unknown: unknown): LayoutState {
                const dst = new LayoutState();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LayoutState but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LayoutState_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LayoutState but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.layouts !== undefined && src.layouts !== null) {
                    if (Array.isArray(src.layouts)) {
                        for (const element of src.layouts) {
                            dst.layouts.push(ng.print.Layout.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected layouts of LayoutState to be a array but was ', typeof src.layouts, src.layouts)
                    }
                }
                return dst;
            }

            static toObject(src: LayoutState | null | undefined): LayoutState_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.LayoutState is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.LayoutState") {
                    console.error('Expected ng.print.LayoutState but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LayoutState_json = {
                    layouts: new Array<ng.print.Layout_json>(),
                };
                if (src.layouts !== null) {
                    for (const element of src.layouts) {
                        const parsed = ng.print.Layout.toObject(element);
                        if(parsed === null) return null;
                        dst.layouts.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: LayoutState_createType) {
                const dst = new LayoutState();
                if (src === undefined) {
                    return dst;
                }
                if (src.layouts !== undefined) {
                    dst.layouts = src.layouts;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LayoutState();
                dst.layouts = this.layouts;
                return dst;
            }

            deepClone() {
                const json = LayoutState.toObject(this);
                const dst = LayoutState.fromObject(json);
                return dst;
            }
        }
        export type ILayoutState = LayoutState;


        export type PrintLayout_keys = 'state';
        export interface PrintLayout_createType {
            state?: ng.print.LayoutState | null,
        }
        export interface PrintLayout_json {
            state?: ng.print.LayoutState_json;
        }
        interface PrintLayout_json_in {
            __proto_name?: unknown;
            state?: unknown;
        }
        export class PrintLayout {
            __proto_name = "ng.print.PrintLayout";
            state: ng.print.LayoutState | null = null;

            static fromObject(src_unknown: unknown): PrintLayout {
                const dst = new PrintLayout();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PrintLayout but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PrintLayout_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PrintLayout but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.state !== undefined && src.state !== null) {
                    dst.state = ng.print.LayoutState.fromObject(src.state);
                }
                return dst;
            }

            static toObject(src: PrintLayout | null | undefined): PrintLayout_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.PrintLayout is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.PrintLayout") {
                    console.error('Expected ng.print.PrintLayout but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PrintLayout_json = {
                };
                if(src.state !== null)
                {
                    const parsed = ng.print.LayoutState.toObject(src.state);
                    if(parsed === null) return null;
                    dst.state = parsed;
                }
                return dst;
            }

            static create(src?: PrintLayout_createType) {
                const dst = new PrintLayout();
                if (src === undefined) {
                    return dst;
                }
                if (src.state !== undefined) {
                    dst.state = src.state;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PrintLayout();
                dst.state = this.state;
                return dst;
            }

            deepClone() {
                const json = PrintLayout.toObject(this);
                const dst = PrintLayout.fromObject(json);
                return dst;
            }
        }
        export type IPrintLayout = PrintLayout;


        export type PrintOutput_keys = 'result' | 'layout';
        export interface PrintOutput_createType {
            result?: ng.print.PrintResult | null,
            layout?: ng.print.PrintLayout | null,
        }
        export interface PrintOutput_json {
            result?: ng.print.PrintResult_json;
            layout?: ng.print.PrintLayout_json;
        }
        interface PrintOutput_json_in {
            __proto_name?: unknown;
            result?: unknown;
            layout?: unknown;
        }
        export class PrintOutput {
            __proto_name = "ng.print.PrintOutput";
            result: ng.print.PrintResult | null = null;
            layout: ng.print.PrintLayout | null = null;

            static fromObject(src_unknown: unknown): PrintOutput {
                const dst = new PrintOutput();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PrintOutput but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PrintOutput_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PrintOutput but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.result !== undefined && src.result !== null) {
                    dst.result = ng.print.PrintResult.fromObject(src.result);
                }
                if (src.layout !== undefined && src.layout !== null) {
                    dst.layout = ng.print.PrintLayout.fromObject(src.layout);
                }
                return dst;
            }

            static toObject(src: PrintOutput | null | undefined): PrintOutput_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.print.PrintOutput is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.print.PrintOutput") {
                    console.error('Expected ng.print.PrintOutput but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PrintOutput_json = {
                };
                if(src.result !== null)
                {
                    const parsed = ng.print.PrintResult.toObject(src.result);
                    if(parsed === null) return null;
                    dst.result = parsed;
                }
                if(src.layout !== null)
                {
                    const parsed = ng.print.PrintLayout.toObject(src.layout);
                    if(parsed === null) return null;
                    dst.layout = parsed;
                }
                return dst;
            }

            static create(src?: PrintOutput_createType) {
                const dst = new PrintOutput();
                if (src === undefined) {
                    return dst;
                }
                if (src.result !== undefined) {
                    dst.result = src.result;
                }
                if (src.layout !== undefined) {
                    dst.layout = src.layout;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PrintOutput();
                dst.result = this.result;
                dst.layout = this.layout;
                return dst;
            }

            deepClone() {
                const json = PrintOutput.toObject(this);
                const dst = PrintOutput.fromObject(json);
                return dst;
            }
        }
        export type IPrintOutput = PrintOutput;
    } // namespace print


    // Defined in Geometry/reinf.proto
    export namespace reinf {
        export enum BarProfile {
            BAR_PROFILE_UNSPECIFIED = 0,
            BAR_PROFILE_SMOOTH = 1,
            BAR_PROFILE_RIBBED = 2
        }
        export const BarProfile_FromObject = (src: unknown): BarProfile => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'BAR_PROFILE_UNSPECIFIED':
                    return BarProfile.BAR_PROFILE_UNSPECIFIED;
                case 1:
                case 'BAR_PROFILE_SMOOTH':
                    return BarProfile.BAR_PROFILE_SMOOTH;
                case 2:
                case 'BAR_PROFILE_RIBBED':
                    return BarProfile.BAR_PROFILE_RIBBED;
                default:
                    console.log('Unhandled value for BarProfile:' + src + '. ' + typeof(src));
                    return BarProfile.BAR_PROFILE_UNSPECIFIED;
            }
        };
        export const BarProfile_ToObject = (src: BarProfile): string | null => {
            switch (src) {
                case BarProfile.BAR_PROFILE_UNSPECIFIED:
                    return 'BAR_PROFILE_UNSPECIFIED';
                case BarProfile.BAR_PROFILE_SMOOTH:
                    return 'BAR_PROFILE_SMOOTH';
                case BarProfile.BAR_PROFILE_RIBBED:
                    return 'BAR_PROFILE_RIBBED';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for BarProfile, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum WireProfile {
            WIRE_PROFILE_UNSPECIFIED = 0,
            WIRE_PROFILE_K7 = 1,
            WIRE_PROFILE_SINGLE = 2
        }
        export const WireProfile_FromObject = (src: unknown): WireProfile => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'WIRE_PROFILE_UNSPECIFIED':
                    return WireProfile.WIRE_PROFILE_UNSPECIFIED;
                case 1:
                case 'WIRE_PROFILE_K7':
                    return WireProfile.WIRE_PROFILE_K7;
                case 2:
                case 'WIRE_PROFILE_SINGLE':
                    return WireProfile.WIRE_PROFILE_SINGLE;
                default:
                    console.log('Unhandled value for WireProfile:' + src + '. ' + typeof(src));
                    return WireProfile.WIRE_PROFILE_UNSPECIFIED;
            }
        };
        export const WireProfile_ToObject = (src: WireProfile): string | null => {
            switch (src) {
                case WireProfile.WIRE_PROFILE_UNSPECIFIED:
                    return 'WIRE_PROFILE_UNSPECIFIED';
                case WireProfile.WIRE_PROFILE_K7:
                    return 'WIRE_PROFILE_K7';
                case WireProfile.WIRE_PROFILE_SINGLE:
                    return 'WIRE_PROFILE_SINGLE';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for WireProfile, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum DuctilityClass {
            DUCTILITY_CLASS_UNSPECIFIED = 0,
            DUCTILITY_CLASS_A = 1,
            DUCTILITY_CLASS_B = 2,
            DUCTILITY_CLASS_C = 3,
            DUCTILITY_CLASS_AB = 4
        }
        export const DuctilityClass_FromObject = (src: unknown): DuctilityClass => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DUCTILITY_CLASS_UNSPECIFIED':
                    return DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED;
                case 1:
                case 'DUCTILITY_CLASS_A':
                    return DuctilityClass.DUCTILITY_CLASS_A;
                case 2:
                case 'DUCTILITY_CLASS_B':
                    return DuctilityClass.DUCTILITY_CLASS_B;
                case 3:
                case 'DUCTILITY_CLASS_C':
                    return DuctilityClass.DUCTILITY_CLASS_C;
                case 4:
                case 'DUCTILITY_CLASS_AB':
                    return DuctilityClass.DUCTILITY_CLASS_AB;
                default:
                    console.log('Unhandled value for DuctilityClass:' + src + '. ' + typeof(src));
                    return DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED;
            }
        };
        export const DuctilityClass_ToObject = (src: DuctilityClass): string | null => {
            switch (src) {
                case DuctilityClass.DUCTILITY_CLASS_UNSPECIFIED:
                    return 'DUCTILITY_CLASS_UNSPECIFIED';
                case DuctilityClass.DUCTILITY_CLASS_A:
                    return 'DUCTILITY_CLASS_A';
                case DuctilityClass.DUCTILITY_CLASS_B:
                    return 'DUCTILITY_CLASS_B';
                case DuctilityClass.DUCTILITY_CLASS_C:
                    return 'DUCTILITY_CLASS_C';
                case DuctilityClass.DUCTILITY_CLASS_AB:
                    return 'DUCTILITY_CLASS_AB';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for DuctilityClass, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum VertPos {
            VERT_POS_UNSPECIFIED = 0,
            VERT_POS_BOTTOM = 1,
            VERT_POS_TOP = 2,
            VERT_POS_CENTER = 3
        }
        export const VertPos_FromObject = (src: unknown): VertPos => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'VERT_POS_UNSPECIFIED':
                    return VertPos.VERT_POS_UNSPECIFIED;
                case 1:
                case 'VERT_POS_BOTTOM':
                    return VertPos.VERT_POS_BOTTOM;
                case 2:
                case 'VERT_POS_TOP':
                    return VertPos.VERT_POS_TOP;
                case 3:
                case 'VERT_POS_CENTER':
                    return VertPos.VERT_POS_CENTER;
                default:
                    console.log('Unhandled value for VertPos:' + src + '. ' + typeof(src));
                    return VertPos.VERT_POS_UNSPECIFIED;
            }
        };
        export const VertPos_ToObject = (src: VertPos): string | null => {
            switch (src) {
                case VertPos.VERT_POS_UNSPECIFIED:
                    return 'VERT_POS_UNSPECIFIED';
                case VertPos.VERT_POS_BOTTOM:
                    return 'VERT_POS_BOTTOM';
                case VertPos.VERT_POS_TOP:
                    return 'VERT_POS_TOP';
                case VertPos.VERT_POS_CENTER:
                    return 'VERT_POS_CENTER';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for VertPos, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum Distribution {
            DISTRIBUTION_UNSPECIFIED = 0,
            DISTRIBUTION_EVEN = 1,
            DISTRIBUTION_DENSE_3 = 2,
            DISTRIBUTION_DENSE_2A = 3,
            DISTRIBUTION_DENSE_2B = 4,
            DISTRIBUTION_MID = 5
        }
        export const Distribution_FromObject = (src: unknown): Distribution => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DISTRIBUTION_UNSPECIFIED':
                    return Distribution.DISTRIBUTION_UNSPECIFIED;
                case 1:
                case 'DISTRIBUTION_EVEN':
                    return Distribution.DISTRIBUTION_EVEN;
                case 2:
                case 'DISTRIBUTION_DENSE_3':
                    return Distribution.DISTRIBUTION_DENSE_3;
                case 3:
                case 'DISTRIBUTION_DENSE_2A':
                    return Distribution.DISTRIBUTION_DENSE_2A;
                case 4:
                case 'DISTRIBUTION_DENSE_2B':
                    return Distribution.DISTRIBUTION_DENSE_2B;
                case 5:
                case 'DISTRIBUTION_MID':
                    return Distribution.DISTRIBUTION_MID;
                default:
                    console.log('Unhandled value for Distribution:' + src + '. ' + typeof(src));
                    return Distribution.DISTRIBUTION_UNSPECIFIED;
            }
        };
        export const Distribution_ToObject = (src: Distribution): string | null => {
            switch (src) {
                case Distribution.DISTRIBUTION_UNSPECIFIED:
                    return 'DISTRIBUTION_UNSPECIFIED';
                case Distribution.DISTRIBUTION_EVEN:
                    return 'DISTRIBUTION_EVEN';
                case Distribution.DISTRIBUTION_DENSE_3:
                    return 'DISTRIBUTION_DENSE_3';
                case Distribution.DISTRIBUTION_DENSE_2A:
                    return 'DISTRIBUTION_DENSE_2A';
                case Distribution.DISTRIBUTION_DENSE_2B:
                    return 'DISTRIBUTION_DENSE_2B';
                case Distribution.DISTRIBUTION_MID:
                    return 'DISTRIBUTION_MID';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Distribution, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type HorPos_keys = 'start' | 'end';
        export interface HorPos_createType {
            start?: number,
            end?: number,
        }
        export interface HorPos_json {
            start?: JsonNumber;
            end?: JsonNumber;
        }
        interface HorPos_json_in {
            __proto_name?: unknown;
            start?: unknown;
            end?: unknown;
        }
        export class HorPos {
            __proto_name = "ng.reinf.HorPos";
            start: number = 0;
            end: number = 0;

            static fromObject(src_unknown: unknown): HorPos {
                const dst = new HorPos();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted HorPos but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as HorPos_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for HorPos but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.start !== undefined && src.start !== null) {
                    if (typeof src.start === "number" || src.start === 'NaN' || src.start === 'Infinity' || src.start === '-Infinity') {
                        dst.start = NumberToInt("ng.reinf.HorPos.start", AsNum(src.start));
                    }
                    else {
                        console.log('Expected start of HorPos to be a number but was ', typeof src.start, src.start)
                    }
                }
                if (src.end !== undefined && src.end !== null) {
                    if (typeof src.end === "number" || src.end === 'NaN' || src.end === 'Infinity' || src.end === '-Infinity') {
                        dst.end = NumberToInt("ng.reinf.HorPos.end", AsNum(src.end));
                    }
                    else {
                        console.log('Expected end of HorPos to be a number but was ', typeof src.end, src.end)
                    }
                }
                return dst;
            }

            static toObject(src: HorPos | null | undefined): HorPos_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.reinf.HorPos is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.reinf.HorPos") {
                    console.error('Expected ng.reinf.HorPos but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : HorPos_json = {
                    start: AsJsonNum(NumberToInt("ng.reinf.HorPos.start", src.start)),
                    end: AsJsonNum(NumberToInt("ng.reinf.HorPos.end", src.end)),
                };
                return dst;
            }

            static create(src?: HorPos_createType) {
                const dst = new HorPos();
                if (src === undefined) {
                    return dst;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.end !== undefined) {
                    dst.end = src.end;
                }
                return dst;
            }

            shallowClone() {
                const dst = new HorPos();
                dst.start = this.start;
                dst.end = this.end;
                return dst;
            }

            deepClone() {
                const json = HorPos.toObject(this);
                const dst = HorPos.fromObject(json);
                return dst;
            }
        }
        export type IHorPos = HorPos;


        export type Straight_keys = 'guid' | 'layGuid' | 'vPos' | 'hPos' | 'preStress';
        export interface Straight_createType {
            guid?: string,
            layGuid?: string,
            vPos?: ng.reinf.VertPos,
            hPos?: ng.reinf.HorPos | null,
            preStress?: number,
        }
        export interface Straight_json {
            guid?: string;
            layGuid?: string;
            vPos?: string;
            hPos?: ng.reinf.HorPos_json;
            preStress?: JsonNumber;
        }
        interface Straight_json_in {
            __proto_name?: unknown;
            guid?: unknown;
            layGuid?: unknown;
            vPos?: unknown;
            hPos?: unknown;
            preStress?: unknown;
        }
        export class Straight {
            __proto_name = "ng.reinf.Straight";
            guid: string = "";
            layGuid: string = "";
            vPos: ng.reinf.VertPos = ng.reinf.VertPos.VERT_POS_UNSPECIFIED;
            hPos: ng.reinf.HorPos | null = null;
            preStress: number = 0;

            static fromObject(src_unknown: unknown): Straight {
                const dst = new Straight();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Straight but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Straight_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Straight but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.guid !== undefined && src.guid !== null) {
                    if (typeof src.guid === "string") {
                        dst.guid = src.guid;
                    }
                    else {
                        console.log('Expected guid of Straight to be a string but was ', typeof src.guid, src.guid)
                    }
                }
                if (src.layGuid !== undefined && src.layGuid !== null) {
                    if (typeof src.layGuid === "string") {
                        dst.layGuid = src.layGuid;
                    }
                    else {
                        console.log('Expected layGuid of Straight to be a string but was ', typeof src.layGuid, src.layGuid)
                    }
                }
                if (src.vPos !== undefined && src.vPos !== null) {
                    dst.vPos = ng.reinf.VertPos_FromObject(src.vPos);
                }
                if (src.hPos !== undefined && src.hPos !== null) {
                    dst.hPos = ng.reinf.HorPos.fromObject(src.hPos);
                }
                if (src.preStress !== undefined && src.preStress !== null) {
                    if (typeof src.preStress === "number" || src.preStress === 'NaN' || src.preStress === 'Infinity' || src.preStress === '-Infinity') {
                        dst.preStress = AsNum(src.preStress);
                    }
                    else {
                        console.log('Expected preStress of Straight to be a number but was ', typeof src.preStress, src.preStress)
                    }
                }
                return dst;
            }

            static toObject(src: Straight | null | undefined): Straight_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.reinf.Straight is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.reinf.Straight") {
                    console.error('Expected ng.reinf.Straight but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const vPos_obj = ng.reinf.VertPos_ToObject(src.vPos);
                if(vPos_obj === null) return null;

                const dst : Straight_json = {
                    guid: src.guid,
                    layGuid: src.layGuid,
                    vPos: vPos_obj,
                    preStress: AsJsonNum(src.preStress),
                };
                if(src.hPos !== null)
                {
                    const parsed = ng.reinf.HorPos.toObject(src.hPos);
                    if(parsed === null) return null;
                    dst.hPos = parsed;
                }
                return dst;
            }

            static create(src?: Straight_createType) {
                const dst = new Straight();
                if (src === undefined) {
                    return dst;
                }
                if (src.guid !== undefined) {
                    dst.guid = src.guid;
                }
                if (src.layGuid !== undefined) {
                    dst.layGuid = src.layGuid;
                }
                if (src.vPos !== undefined) {
                    dst.vPos = src.vPos;
                }
                if (src.hPos !== undefined) {
                    dst.hPos = src.hPos;
                }
                if (src.preStress !== undefined) {
                    dst.preStress = src.preStress;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Straight();
                dst.guid = this.guid;
                dst.layGuid = this.layGuid;
                dst.vPos = this.vPos;
                dst.hPos = this.hPos;
                dst.preStress = this.preStress;
                return dst;
            }

            deepClone() {
                const json = Straight.toObject(this);
                const dst = Straight.fromObject(json);
                return dst;
            }
        }
        export type IStraight = Straight;


        export type Group_keys = 'id' | 'direction' | 'start' | 'length' | 'mtrlGuid' | 'diameter' | 'preStress';
        export interface Group_createType {
            id?: ng.utils.ID | null,
            direction?: ng.geometry.Vector3D | null,
            start?: number,
            length?: number,
            mtrlGuid?: string,
            diameter?: number,
            preStress?: number,
        }
        export interface Group_json {
            id?: ng.utils.ID_json;
            direction?: ng.geometry.Vector3D_json;
            start?: JsonNumber;
            length?: JsonNumber;
            mtrlGuid?: string;
            diameter?: JsonNumber;
            preStress?: JsonNumber;
        }
        interface Group_json_in {
            __proto_name?: unknown;
            id?: unknown;
            direction?: unknown;
            start?: unknown;
            length?: unknown;
            mtrlGuid?: unknown;
            diameter?: unknown;
            preStress?: unknown;
        }
        export class Group {
            __proto_name = "ng.reinf.Group";
            id: ng.utils.ID | null = null;
            direction: ng.geometry.Vector3D | null = null;
            start: number = 0;
            length: number = 0;
            mtrlGuid: string = "";
            diameter: number = 0;
            preStress: number = 0;

            static fromObject(src_unknown: unknown): Group {
                const dst = new Group();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Group but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Group_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Group but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.direction !== undefined && src.direction !== null) {
                    dst.direction = ng.geometry.Vector3D.fromObject(src.direction);
                }
                if (src.start !== undefined && src.start !== null) {
                    if (typeof src.start === "number" || src.start === 'NaN' || src.start === 'Infinity' || src.start === '-Infinity') {
                        dst.start = AsNum(src.start);
                    }
                    else {
                        console.log('Expected start of Group to be a number but was ', typeof src.start, src.start)
                    }
                }
                if (src.length !== undefined && src.length !== null) {
                    if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                        dst.length = AsNum(src.length);
                    }
                    else {
                        console.log('Expected length of Group to be a number but was ', typeof src.length, src.length)
                    }
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of Group to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                if (src.diameter !== undefined && src.diameter !== null) {
                    if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                        dst.diameter = AsNum(src.diameter);
                    }
                    else {
                        console.log('Expected diameter of Group to be a number but was ', typeof src.diameter, src.diameter)
                    }
                }
                if (src.preStress !== undefined && src.preStress !== null) {
                    if (typeof src.preStress === "number" || src.preStress === 'NaN' || src.preStress === 'Infinity' || src.preStress === '-Infinity') {
                        dst.preStress = AsNum(src.preStress);
                    }
                    else {
                        console.log('Expected preStress of Group to be a number but was ', typeof src.preStress, src.preStress)
                    }
                }
                return dst;
            }

            static toObject(src: Group | null | undefined): Group_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.reinf.Group is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.reinf.Group") {
                    console.error('Expected ng.reinf.Group but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Group_json = {
                    start: AsJsonNum(src.start),
                    length: AsJsonNum(src.length),
                    mtrlGuid: src.mtrlGuid,
                    diameter: AsJsonNum(src.diameter),
                    preStress: AsJsonNum(src.preStress),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.direction !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.direction);
                    if(parsed === null) return null;
                    dst.direction = parsed;
                }
                return dst;
            }

            static create(src?: Group_createType) {
                const dst = new Group();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.direction !== undefined) {
                    dst.direction = src.direction;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.length !== undefined) {
                    dst.length = src.length;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                if (src.diameter !== undefined) {
                    dst.diameter = src.diameter;
                }
                if (src.preStress !== undefined) {
                    dst.preStress = src.preStress;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Group();
                dst.id = this.id;
                dst.direction = this.direction;
                dst.start = this.start;
                dst.length = this.length;
                dst.mtrlGuid = this.mtrlGuid;
                dst.diameter = this.diameter;
                dst.preStress = this.preStress;
                return dst;
            }

            deepClone() {
                const json = Group.toObject(this);
                const dst = Group.fromObject(json);
                return dst;
            }
        }
        export type IGroup = Group;


        export type Layer_keys = 'id' | 'grpGuid' | 'level' | 'num' | 's' | 'zone' | 'minFreeSpace' | 'd' | 'distr';
        export interface Layer_createType {
            id?: ng.utils.ID | null,
            grpGuid?: string,
            level?: number,
            num?: number,
            s?: number,
            zone?: ng.design.concrete.BeamSide,
            minFreeSpace?: number,
            d?: number,
            distr?: ng.reinf.Distribution,
        }
        export interface Layer_json {
            id?: ng.utils.ID_json;
            grpGuid?: string;
            level?: JsonNumber;
            num?: JsonNumber;
            s?: JsonNumber;
            zone?: string;
            minFreeSpace?: JsonNumber;
            d?: JsonNumber;
            distr?: string;
        }
        interface Layer_json_in {
            __proto_name?: unknown;
            id?: unknown;
            grpGuid?: unknown;
            level?: unknown;
            num?: unknown;
            s?: unknown;
            zone?: unknown;
            minFreeSpace?: unknown;
            d?: unknown;
            distr?: unknown;
        }
        export class Layer {
            __proto_name = "ng.reinf.Layer";
            id: ng.utils.ID | null = null;
            grpGuid: string = "";
            level: number = 0;
            // this is a one of
            numbers: {type: 'num'; num: number} | {type: 's'; s: number} | null = null;
            zone: ng.design.concrete.BeamSide = ng.design.concrete.BeamSide.BEAM_SIDE_UNSPECIFIED;
            minFreeSpace: number = 0;
            d: number = 0;
            distr: ng.reinf.Distribution = ng.reinf.Distribution.DISTRIBUTION_UNSPECIFIED;

            /** Gets the `Num` value (or null) from the oneof `numbers` */
            getNum(): number | null {
                if(this.numbers === null) return null;
                if(this.numbers.type !== 'num') return null;
                return this.numbers.num;
            }

            /** Sets the `Num` value for the oneof `numbers`*/
            setNum(value: number | null) {
                if(value !== null) {
                    this.numbers = {type: 'num', num:value};
                }
                else {
                    this.numbers = null;
                }
            }

            /** Gets the `S` value (or null) from the oneof `numbers` */
            getS(): number | null {
                if(this.numbers === null) return null;
                if(this.numbers.type !== 's') return null;
                return this.numbers.s;
            }

            /** Sets the `S` value for the oneof `numbers`*/
            setS(value: number | null) {
                if(value !== null) {
                    this.numbers = {type: 's', s:value};
                }
                else {
                    this.numbers = null;
                }
            }

            static fromObject(src_unknown: unknown): Layer {
                const dst = new Layer();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Layer but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Layer_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Layer but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.grpGuid !== undefined && src.grpGuid !== null) {
                    if (typeof src.grpGuid === "string") {
                        dst.grpGuid = src.grpGuid;
                    }
                    else {
                        console.log('Expected grpGuid of Layer to be a string but was ', typeof src.grpGuid, src.grpGuid)
                    }
                }
                if (src.level !== undefined && src.level !== null) {
                    if (typeof src.level === "number" || src.level === 'NaN' || src.level === 'Infinity' || src.level === '-Infinity') {
                        dst.level = NumberToInt("ng.reinf.Layer.level", AsNum(src.level));
                    }
                    else {
                        console.log('Expected level of Layer to be a number but was ', typeof src.level, src.level)
                    }
                }
                if (src.num !== undefined && src.num !== null) {
                    if (typeof src.num === "number" || src.num === 'NaN' || src.num === 'Infinity' || src.num === '-Infinity') {
                        dst.setNum(NumberToInt("ng.reinf.Layer.num", AsNum(src.num)));
                    }
                    else {
                        console.log('Expected num of Layer to be a number but was ', typeof src.num, src.num)
                    }
                }
                if (src.s !== undefined && src.s !== null) {
                    if (typeof src.s === "number" || src.s === 'NaN' || src.s === 'Infinity' || src.s === '-Infinity') {
                        dst.setS(NumberToInt("ng.reinf.Layer.s", AsNum(src.s)));
                    }
                    else {
                        console.log('Expected s of Layer to be a number but was ', typeof src.s, src.s)
                    }
                }
                if (src.zone !== undefined && src.zone !== null) {
                    dst.zone = ng.design.concrete.BeamSide_FromObject(src.zone);
                }
                if (src.minFreeSpace !== undefined && src.minFreeSpace !== null) {
                    if (typeof src.minFreeSpace === "number" || src.minFreeSpace === 'NaN' || src.minFreeSpace === 'Infinity' || src.minFreeSpace === '-Infinity') {
                        dst.minFreeSpace = NumberToInt("ng.reinf.Layer.min_free_space", AsNum(src.minFreeSpace));
                    }
                    else {
                        console.log('Expected minFreeSpace of Layer to be a number but was ', typeof src.minFreeSpace, src.minFreeSpace)
                    }
                }
                if (src.d !== undefined && src.d !== null) {
                    if (typeof src.d === "number" || src.d === 'NaN' || src.d === 'Infinity' || src.d === '-Infinity') {
                        dst.d = NumberToInt("ng.reinf.Layer.d", AsNum(src.d));
                    }
                    else {
                        console.log('Expected d of Layer to be a number but was ', typeof src.d, src.d)
                    }
                }
                if (src.distr !== undefined && src.distr !== null) {
                    dst.distr = ng.reinf.Distribution_FromObject(src.distr);
                }
                return dst;
            }

            static toObject(src: Layer | null | undefined): Layer_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.reinf.Layer is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.reinf.Layer") {
                    console.error('Expected ng.reinf.Layer but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const zone_obj = ng.design.concrete.BeamSide_ToObject(src.zone);
                if(zone_obj === null) return null;

                const distr_obj = ng.reinf.Distribution_ToObject(src.distr);
                if(distr_obj === null) return null;

                const dst : Layer_json = {
                    grpGuid: src.grpGuid,
                    level: AsJsonNum(NumberToInt("ng.reinf.Layer.level", src.level)),
                    zone: zone_obj,
                    minFreeSpace: AsJsonNum(NumberToInt("ng.reinf.Layer.min_free_space", src.minFreeSpace)),
                    d: AsJsonNum(NumberToInt("ng.reinf.Layer.d", src.d)),
                    distr: distr_obj,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const num = src.getNum();
                if(num !== null)
                {
                    const parsed = AsJsonNum(NumberToInt("ng.reinf.Layer.num", num));
                    if(parsed === null) return null;
                    dst.num = parsed;
                }
                const s = src.getS();
                if(s !== null)
                {
                    const parsed = AsJsonNum(NumberToInt("ng.reinf.Layer.s", s));
                    if(parsed === null) return null;
                    dst.s = parsed;
                }
                return dst;
            }

            static create(src?: Layer_createType) {
                const dst = new Layer();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.grpGuid !== undefined) {
                    dst.grpGuid = src.grpGuid;
                }
                if (src.level !== undefined) {
                    dst.level = src.level;
                }
                // part of the numbers oneof 
                if (src.num !== undefined && src.num !== null) {
                    dst.setNum(src.num);
                }
                // part of the numbers oneof 
                if (src.s !== undefined && src.s !== null) {
                    dst.setS(src.s);
                }
                if (src.zone !== undefined) {
                    dst.zone = src.zone;
                }
                if (src.minFreeSpace !== undefined) {
                    dst.minFreeSpace = src.minFreeSpace;
                }
                if (src.d !== undefined) {
                    dst.d = src.d;
                }
                if (src.distr !== undefined) {
                    dst.distr = src.distr;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Layer();
                dst.id = this.id;
                dst.grpGuid = this.grpGuid;
                dst.level = this.level;
                dst.numbers = this.numbers;
                dst.zone = this.zone;
                dst.minFreeSpace = this.minFreeSpace;
                dst.d = this.d;
                dst.distr = this.distr;
                return dst;
            }

            deepClone() {
                const json = Layer.toObject(this);
                const dst = Layer.fromObject(json);
                return dst;
            }
        }
        export type ILayer = Layer;


        export type StandAloneBar_keys = 'id' | 'startPoint' | 'endPoint' | 'mtrlGuid' | 'diameter' | 'zone' | 'preStress';
        export interface StandAloneBar_createType {
            id?: ng.utils.ID | null,
            startPoint?: ng.geometry.Point3D | null,
            endPoint?: ng.geometry.Point3D | null,
            mtrlGuid?: string,
            diameter?: number,
            zone?: ng.design.concrete.BeamSide,
            preStress?: number,
        }
        export interface StandAloneBar_json {
            id?: ng.utils.ID_json;
            startPoint?: ng.geometry.Point3D_json;
            endPoint?: ng.geometry.Point3D_json;
            mtrlGuid?: string;
            diameter?: JsonNumber;
            zone?: string;
            preStress?: JsonNumber;
        }
        interface StandAloneBar_json_in {
            __proto_name?: unknown;
            id?: unknown;
            startPoint?: unknown;
            endPoint?: unknown;
            mtrlGuid?: unknown;
            diameter?: unknown;
            zone?: unknown;
            preStress?: unknown;
        }
        export class StandAloneBar {
            __proto_name = "ng.reinf.StandAloneBar";
            id: ng.utils.ID | null = null;
            startPoint: ng.geometry.Point3D | null = null;
            endPoint: ng.geometry.Point3D | null = null;
            mtrlGuid: string = "";
            diameter: number = 0;
            zone: ng.design.concrete.BeamSide = ng.design.concrete.BeamSide.BEAM_SIDE_UNSPECIFIED;
            preStress: number = 0;

            static fromObject(src_unknown: unknown): StandAloneBar {
                const dst = new StandAloneBar();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted StandAloneBar but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as StandAloneBar_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for StandAloneBar but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.startPoint !== undefined && src.startPoint !== null) {
                    dst.startPoint = ng.geometry.Point3D.fromObject(src.startPoint);
                }
                if (src.endPoint !== undefined && src.endPoint !== null) {
                    dst.endPoint = ng.geometry.Point3D.fromObject(src.endPoint);
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of StandAloneBar to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                if (src.diameter !== undefined && src.diameter !== null) {
                    if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                        dst.diameter = AsNum(src.diameter);
                    }
                    else {
                        console.log('Expected diameter of StandAloneBar to be a number but was ', typeof src.diameter, src.diameter)
                    }
                }
                if (src.zone !== undefined && src.zone !== null) {
                    dst.zone = ng.design.concrete.BeamSide_FromObject(src.zone);
                }
                if (src.preStress !== undefined && src.preStress !== null) {
                    if (typeof src.preStress === "number" || src.preStress === 'NaN' || src.preStress === 'Infinity' || src.preStress === '-Infinity') {
                        dst.preStress = AsNum(src.preStress);
                    }
                    else {
                        console.log('Expected preStress of StandAloneBar to be a number but was ', typeof src.preStress, src.preStress)
                    }
                }
                return dst;
            }

            static toObject(src: StandAloneBar | null | undefined): StandAloneBar_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.reinf.StandAloneBar is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.reinf.StandAloneBar") {
                    console.error('Expected ng.reinf.StandAloneBar but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const zone_obj = ng.design.concrete.BeamSide_ToObject(src.zone);
                if(zone_obj === null) return null;

                const dst : StandAloneBar_json = {
                    mtrlGuid: src.mtrlGuid,
                    diameter: AsJsonNum(src.diameter),
                    zone: zone_obj,
                    preStress: AsJsonNum(src.preStress),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.startPoint !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.startPoint);
                    if(parsed === null) return null;
                    dst.startPoint = parsed;
                }
                if(src.endPoint !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.endPoint);
                    if(parsed === null) return null;
                    dst.endPoint = parsed;
                }
                return dst;
            }

            static create(src?: StandAloneBar_createType) {
                const dst = new StandAloneBar();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.startPoint !== undefined) {
                    dst.startPoint = src.startPoint;
                }
                if (src.endPoint !== undefined) {
                    dst.endPoint = src.endPoint;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                if (src.diameter !== undefined) {
                    dst.diameter = src.diameter;
                }
                if (src.zone !== undefined) {
                    dst.zone = src.zone;
                }
                if (src.preStress !== undefined) {
                    dst.preStress = src.preStress;
                }
                return dst;
            }

            shallowClone() {
                const dst = new StandAloneBar();
                dst.id = this.id;
                dst.startPoint = this.startPoint;
                dst.endPoint = this.endPoint;
                dst.mtrlGuid = this.mtrlGuid;
                dst.diameter = this.diameter;
                dst.zone = this.zone;
                dst.preStress = this.preStress;
                return dst;
            }

            deepClone() {
                const json = StandAloneBar.toObject(this);
                const dst = StandAloneBar.fromObject(json);
                return dst;
            }
        }
        export type IStandAloneBar = StandAloneBar;
    } // namespace reinf


    // Defined in Loading/loadgroup.proto
    export namespace loadgroup {
        export enum LoadcaseRelationship {
            unspecified = 0,
            alternative = 1,
            simultaneous = 2,
            entire = 3
        }
        export const LoadcaseRelationship_FromObject = (src: unknown): LoadcaseRelationship => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'unspecified':
                    return LoadcaseRelationship.unspecified;
                case 1:
                case 'alternative':
                    return LoadcaseRelationship.alternative;
                case 2:
                case 'simultaneous':
                    return LoadcaseRelationship.simultaneous;
                case 3:
                case 'entire':
                    return LoadcaseRelationship.entire;
                default:
                    console.log('Unhandled value for LoadcaseRelationship:' + src + '. ' + typeof(src));
                    return LoadcaseRelationship.unspecified;
            }
        };
        export const LoadcaseRelationship_ToObject = (src: LoadcaseRelationship): string | null => {
            switch (src) {
                case LoadcaseRelationship.unspecified:
                    return 'unspecified';
                case LoadcaseRelationship.alternative:
                    return 'alternative';
                case LoadcaseRelationship.simultaneous:
                    return 'simultaneous';
                case LoadcaseRelationship.entire:
                    return 'entire';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for LoadcaseRelationship, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Permanent_keys = 'favourable' | 'unfavourable' | 'xi' | 'accidentFavourable' | 'accidentUnfavourable' | 'includePermanentLoadFavorable';
        export interface Permanent_createType {
            favourable?: number,
            unfavourable?: number,
            xi?: number,
            accidentFavourable?: number,
            accidentUnfavourable?: number,
            includePermanentLoadFavorable?: boolean,
        }
        export interface Permanent_json {
            favourable?: JsonNumber;
            unfavourable?: JsonNumber;
            xi?: JsonNumber;
            accidentFavourable?: JsonNumber;
            accidentUnfavourable?: JsonNumber;
            includePermanentLoadFavorable?: boolean;
        }
        interface Permanent_json_in {
            __proto_name?: unknown;
            favourable?: unknown;
            unfavourable?: unknown;
            xi?: unknown;
            accidentFavourable?: unknown;
            accidentUnfavourable?: unknown;
            includePermanentLoadFavorable?: unknown;
        }
        export class Permanent {
            __proto_name = "ng.loadgroup.Permanent";
            favourable: number = 0;
            unfavourable: number = 0;
            xi: number = 0;
            accidentFavourable: number = 0;
            accidentUnfavourable: number = 0;
            includePermanentLoadFavorable: boolean = false;

            static fromObject(src_unknown: unknown): Permanent {
                const dst = new Permanent();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Permanent but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Permanent_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Permanent but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.favourable !== undefined && src.favourable !== null) {
                    if (typeof src.favourable === "number" || src.favourable === 'NaN' || src.favourable === 'Infinity' || src.favourable === '-Infinity') {
                        dst.favourable = AsNum(src.favourable);
                    }
                    else {
                        console.log('Expected favourable of Permanent to be a number but was ', typeof src.favourable, src.favourable)
                    }
                }
                if (src.unfavourable !== undefined && src.unfavourable !== null) {
                    if (typeof src.unfavourable === "number" || src.unfavourable === 'NaN' || src.unfavourable === 'Infinity' || src.unfavourable === '-Infinity') {
                        dst.unfavourable = AsNum(src.unfavourable);
                    }
                    else {
                        console.log('Expected unfavourable of Permanent to be a number but was ', typeof src.unfavourable, src.unfavourable)
                    }
                }
                if (src.xi !== undefined && src.xi !== null) {
                    if (typeof src.xi === "number" || src.xi === 'NaN' || src.xi === 'Infinity' || src.xi === '-Infinity') {
                        dst.xi = AsNum(src.xi);
                    }
                    else {
                        console.log('Expected xi of Permanent to be a number but was ', typeof src.xi, src.xi)
                    }
                }
                if (src.accidentFavourable !== undefined && src.accidentFavourable !== null) {
                    if (typeof src.accidentFavourable === "number" || src.accidentFavourable === 'NaN' || src.accidentFavourable === 'Infinity' || src.accidentFavourable === '-Infinity') {
                        dst.accidentFavourable = AsNum(src.accidentFavourable);
                    }
                    else {
                        console.log('Expected accidentFavourable of Permanent to be a number but was ', typeof src.accidentFavourable, src.accidentFavourable)
                    }
                }
                if (src.accidentUnfavourable !== undefined && src.accidentUnfavourable !== null) {
                    if (typeof src.accidentUnfavourable === "number" || src.accidentUnfavourable === 'NaN' || src.accidentUnfavourable === 'Infinity' || src.accidentUnfavourable === '-Infinity') {
                        dst.accidentUnfavourable = AsNum(src.accidentUnfavourable);
                    }
                    else {
                        console.log('Expected accidentUnfavourable of Permanent to be a number but was ', typeof src.accidentUnfavourable, src.accidentUnfavourable)
                    }
                }
                if (src.includePermanentLoadFavorable !== undefined && src.includePermanentLoadFavorable !== null) {
                    if (typeof src.includePermanentLoadFavorable === "boolean") {
                        dst.includePermanentLoadFavorable = src.includePermanentLoadFavorable;
                    }
                    else {
                        console.log('Expected includePermanentLoadFavorable of Permanent to be a boolean but was ', typeof src.includePermanentLoadFavorable, src.includePermanentLoadFavorable)
                    }
                }
                return dst;
            }

            static toObject(src: Permanent | null | undefined): Permanent_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Permanent is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Permanent") {
                    console.error('Expected ng.loadgroup.Permanent but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Permanent_json = {
                    favourable: AsJsonNum(src.favourable),
                    unfavourable: AsJsonNum(src.unfavourable),
                    xi: AsJsonNum(src.xi),
                    accidentFavourable: AsJsonNum(src.accidentFavourable),
                    accidentUnfavourable: AsJsonNum(src.accidentUnfavourable),
                    includePermanentLoadFavorable: src.includePermanentLoadFavorable,
                };
                return dst;
            }

            static create(src?: Permanent_createType) {
                const dst = new Permanent();
                if (src === undefined) {
                    return dst;
                }
                if (src.favourable !== undefined) {
                    dst.favourable = src.favourable;
                }
                if (src.unfavourable !== undefined) {
                    dst.unfavourable = src.unfavourable;
                }
                if (src.xi !== undefined) {
                    dst.xi = src.xi;
                }
                if (src.accidentFavourable !== undefined) {
                    dst.accidentFavourable = src.accidentFavourable;
                }
                if (src.accidentUnfavourable !== undefined) {
                    dst.accidentUnfavourable = src.accidentUnfavourable;
                }
                if (src.includePermanentLoadFavorable !== undefined) {
                    dst.includePermanentLoadFavorable = src.includePermanentLoadFavorable;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Permanent();
                dst.favourable = this.favourable;
                dst.unfavourable = this.unfavourable;
                dst.xi = this.xi;
                dst.accidentFavourable = this.accidentFavourable;
                dst.accidentUnfavourable = this.accidentUnfavourable;
                dst.includePermanentLoadFavorable = this.includePermanentLoadFavorable;
                return dst;
            }

            deepClone() {
                const json = Permanent.toObject(this);
                const dst = Permanent.fromObject(json);
                return dst;
            }
        }
        export type IPermanent = Permanent;


        export type Stress_keys = 'standard' | 'Accidental';
        export interface Stress_createType {
            standard?: number,
            Accidental?: number,
        }
        export interface Stress_json {
            standard?: JsonNumber;
            Accidental?: JsonNumber;
        }
        interface Stress_json_in {
            __proto_name?: unknown;
            standard?: unknown;
            Accidental?: unknown;
        }
        export class Stress {
            __proto_name = "ng.loadgroup.Stress";
            standard: number = 0;
            Accidental: number = 0;

            static fromObject(src_unknown: unknown): Stress {
                const dst = new Stress();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Stress but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Stress_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Stress but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.standard !== undefined && src.standard !== null) {
                    if (typeof src.standard === "number" || src.standard === 'NaN' || src.standard === 'Infinity' || src.standard === '-Infinity') {
                        dst.standard = AsNum(src.standard);
                    }
                    else {
                        console.log('Expected standard of Stress to be a number but was ', typeof src.standard, src.standard)
                    }
                }
                if (src.Accidental !== undefined && src.Accidental !== null) {
                    if (typeof src.Accidental === "number" || src.Accidental === 'NaN' || src.Accidental === 'Infinity' || src.Accidental === '-Infinity') {
                        dst.Accidental = AsNum(src.Accidental);
                    }
                    else {
                        console.log('Expected Accidental of Stress to be a number but was ', typeof src.Accidental, src.Accidental)
                    }
                }
                return dst;
            }

            static toObject(src: Stress | null | undefined): Stress_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Stress is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Stress") {
                    console.error('Expected ng.loadgroup.Stress but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Stress_json = {
                    standard: AsJsonNum(src.standard),
                    Accidental: AsJsonNum(src.Accidental),
                };
                return dst;
            }

            static create(src?: Stress_createType) {
                const dst = new Stress();
                if (src === undefined) {
                    return dst;
                }
                if (src.standard !== undefined) {
                    dst.standard = src.standard;
                }
                if (src.Accidental !== undefined) {
                    dst.Accidental = src.Accidental;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Stress();
                dst.standard = this.standard;
                dst.Accidental = this.Accidental;
                return dst;
            }

            deepClone() {
                const json = Stress.toObject(this);
                const dst = Stress.fromObject(json);
                return dst;
            }
        }
        export type IStress = Stress;


        export type Temporary_keys = 'safetyFactor' | 'psi0' | 'psi1' | 'psi2' | 'ignoreInSls' | 'potDominating';
        export interface Temporary_createType {
            safetyFactor?: number,
            psi0?: number,
            psi1?: number,
            psi2?: number,
            ignoreInSls?: boolean,
            potDominating?: boolean,
        }
        export interface Temporary_json {
            safetyFactor?: JsonNumber;
            psi0?: JsonNumber;
            psi1?: JsonNumber;
            psi2?: JsonNumber;
            ignoreInSls?: boolean;
            potDominating?: boolean;
        }
        interface Temporary_json_in {
            __proto_name?: unknown;
            safetyFactor?: unknown;
            psi0?: unknown;
            psi1?: unknown;
            psi2?: unknown;
            ignoreInSls?: unknown;
            potDominating?: unknown;
        }
        export class Temporary {
            __proto_name = "ng.loadgroup.Temporary";
            safetyFactor: number = 0;
            psi0: number = 0;
            psi1: number = 0;
            psi2: number = 0;
            ignoreInSls: boolean = false;
            potDominating: boolean = false;

            static fromObject(src_unknown: unknown): Temporary {
                const dst = new Temporary();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Temporary but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Temporary_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Temporary but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.safetyFactor !== undefined && src.safetyFactor !== null) {
                    if (typeof src.safetyFactor === "number" || src.safetyFactor === 'NaN' || src.safetyFactor === 'Infinity' || src.safetyFactor === '-Infinity') {
                        dst.safetyFactor = AsNum(src.safetyFactor);
                    }
                    else {
                        console.log('Expected safetyFactor of Temporary to be a number but was ', typeof src.safetyFactor, src.safetyFactor)
                    }
                }
                if (src.psi0 !== undefined && src.psi0 !== null) {
                    if (typeof src.psi0 === "number" || src.psi0 === 'NaN' || src.psi0 === 'Infinity' || src.psi0 === '-Infinity') {
                        dst.psi0 = AsNum(src.psi0);
                    }
                    else {
                        console.log('Expected psi0 of Temporary to be a number but was ', typeof src.psi0, src.psi0)
                    }
                }
                if (src.psi1 !== undefined && src.psi1 !== null) {
                    if (typeof src.psi1 === "number" || src.psi1 === 'NaN' || src.psi1 === 'Infinity' || src.psi1 === '-Infinity') {
                        dst.psi1 = AsNum(src.psi1);
                    }
                    else {
                        console.log('Expected psi1 of Temporary to be a number but was ', typeof src.psi1, src.psi1)
                    }
                }
                if (src.psi2 !== undefined && src.psi2 !== null) {
                    if (typeof src.psi2 === "number" || src.psi2 === 'NaN' || src.psi2 === 'Infinity' || src.psi2 === '-Infinity') {
                        dst.psi2 = AsNum(src.psi2);
                    }
                    else {
                        console.log('Expected psi2 of Temporary to be a number but was ', typeof src.psi2, src.psi2)
                    }
                }
                if (src.ignoreInSls !== undefined && src.ignoreInSls !== null) {
                    if (typeof src.ignoreInSls === "boolean") {
                        dst.ignoreInSls = src.ignoreInSls;
                    }
                    else {
                        console.log('Expected ignoreInSls of Temporary to be a boolean but was ', typeof src.ignoreInSls, src.ignoreInSls)
                    }
                }
                if (src.potDominating !== undefined && src.potDominating !== null) {
                    if (typeof src.potDominating === "boolean") {
                        dst.potDominating = src.potDominating;
                    }
                    else {
                        console.log('Expected potDominating of Temporary to be a boolean but was ', typeof src.potDominating, src.potDominating)
                    }
                }
                return dst;
            }

            static toObject(src: Temporary | null | undefined): Temporary_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Temporary is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Temporary") {
                    console.error('Expected ng.loadgroup.Temporary but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Temporary_json = {
                    safetyFactor: AsJsonNum(src.safetyFactor),
                    psi0: AsJsonNum(src.psi0),
                    psi1: AsJsonNum(src.psi1),
                    psi2: AsJsonNum(src.psi2),
                    ignoreInSls: src.ignoreInSls,
                    potDominating: src.potDominating,
                };
                return dst;
            }

            static create(src?: Temporary_createType) {
                const dst = new Temporary();
                if (src === undefined) {
                    return dst;
                }
                if (src.safetyFactor !== undefined) {
                    dst.safetyFactor = src.safetyFactor;
                }
                if (src.psi0 !== undefined) {
                    dst.psi0 = src.psi0;
                }
                if (src.psi1 !== undefined) {
                    dst.psi1 = src.psi1;
                }
                if (src.psi2 !== undefined) {
                    dst.psi2 = src.psi2;
                }
                if (src.ignoreInSls !== undefined) {
                    dst.ignoreInSls = src.ignoreInSls;
                }
                if (src.potDominating !== undefined) {
                    dst.potDominating = src.potDominating;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Temporary();
                dst.safetyFactor = this.safetyFactor;
                dst.psi0 = this.psi0;
                dst.psi1 = this.psi1;
                dst.psi2 = this.psi2;
                dst.ignoreInSls = this.ignoreInSls;
                dst.potDominating = this.potDominating;
                return dst;
            }

            deepClone() {
                const json = Temporary.toObject(this);
                const dst = Temporary.fromObject(json);
                return dst;
            }
        }
        export type ITemporary = Temporary;


        export type Accidental_keys = 'safetyFactor';
        export interface Accidental_createType {
            safetyFactor?: number,
        }
        export interface Accidental_json {
            safetyFactor?: JsonNumber;
        }
        interface Accidental_json_in {
            __proto_name?: unknown;
            safetyFactor?: unknown;
        }
        export class Accidental {
            __proto_name = "ng.loadgroup.Accidental";
            safetyFactor: number = 0;

            static fromObject(src_unknown: unknown): Accidental {
                const dst = new Accidental();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Accidental but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Accidental_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Accidental but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.safetyFactor !== undefined && src.safetyFactor !== null) {
                    if (typeof src.safetyFactor === "number" || src.safetyFactor === 'NaN' || src.safetyFactor === 'Infinity' || src.safetyFactor === '-Infinity') {
                        dst.safetyFactor = AsNum(src.safetyFactor);
                    }
                    else {
                        console.log('Expected safetyFactor of Accidental to be a number but was ', typeof src.safetyFactor, src.safetyFactor)
                    }
                }
                return dst;
            }

            static toObject(src: Accidental | null | undefined): Accidental_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Accidental is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Accidental") {
                    console.error('Expected ng.loadgroup.Accidental but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Accidental_json = {
                    safetyFactor: AsJsonNum(src.safetyFactor),
                };
                return dst;
            }

            static create(src?: Accidental_createType) {
                const dst = new Accidental();
                if (src === undefined) {
                    return dst;
                }
                if (src.safetyFactor !== undefined) {
                    dst.safetyFactor = src.safetyFactor;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Accidental();
                dst.safetyFactor = this.safetyFactor;
                return dst;
            }

            deepClone() {
                const json = Accidental.toObject(this);
                const dst = Accidental.fromObject(json);
                return dst;
            }
        }
        export type IAccidental = Accidental;


        export type Fire_keys = 'safetyFactor';
        export interface Fire_createType {
            safetyFactor?: number,
        }
        export interface Fire_json {
            safetyFactor?: JsonNumber;
        }
        interface Fire_json_in {
            __proto_name?: unknown;
            safetyFactor?: unknown;
        }
        export class Fire {
            __proto_name = "ng.loadgroup.Fire";
            safetyFactor: number = 0;

            static fromObject(src_unknown: unknown): Fire {
                const dst = new Fire();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Fire but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Fire_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Fire but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.safetyFactor !== undefined && src.safetyFactor !== null) {
                    if (typeof src.safetyFactor === "number" || src.safetyFactor === 'NaN' || src.safetyFactor === 'Infinity' || src.safetyFactor === '-Infinity') {
                        dst.safetyFactor = AsNum(src.safetyFactor);
                    }
                    else {
                        console.log('Expected safetyFactor of Fire to be a number but was ', typeof src.safetyFactor, src.safetyFactor)
                    }
                }
                return dst;
            }

            static toObject(src: Fire | null | undefined): Fire_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Fire is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Fire") {
                    console.error('Expected ng.loadgroup.Fire but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Fire_json = {
                    safetyFactor: AsJsonNum(src.safetyFactor),
                };
                return dst;
            }

            static create(src?: Fire_createType) {
                const dst = new Fire();
                if (src === undefined) {
                    return dst;
                }
                if (src.safetyFactor !== undefined) {
                    dst.safetyFactor = src.safetyFactor;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Fire();
                dst.safetyFactor = this.safetyFactor;
                return dst;
            }

            deepClone() {
                const json = Fire.toObject(this);
                const dst = Fire.fromObject(json);
                return dst;
            }
        }
        export type IFire = Fire;


        export type Seismic_keys = 'safetyFactor';
        export interface Seismic_createType {
            safetyFactor?: number,
        }
        export interface Seismic_json {
            safetyFactor?: JsonNumber;
        }
        interface Seismic_json_in {
            __proto_name?: unknown;
            safetyFactor?: unknown;
        }
        export class Seismic {
            __proto_name = "ng.loadgroup.Seismic";
            safetyFactor: number = 0;

            static fromObject(src_unknown: unknown): Seismic {
                const dst = new Seismic();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Seismic but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Seismic_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Seismic but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.safetyFactor !== undefined && src.safetyFactor !== null) {
                    if (typeof src.safetyFactor === "number" || src.safetyFactor === 'NaN' || src.safetyFactor === 'Infinity' || src.safetyFactor === '-Infinity') {
                        dst.safetyFactor = AsNum(src.safetyFactor);
                    }
                    else {
                        console.log('Expected safetyFactor of Seismic to be a number but was ', typeof src.safetyFactor, src.safetyFactor)
                    }
                }
                return dst;
            }

            static toObject(src: Seismic | null | undefined): Seismic_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Seismic is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Seismic") {
                    console.error('Expected ng.loadgroup.Seismic but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Seismic_json = {
                    safetyFactor: AsJsonNum(src.safetyFactor),
                };
                return dst;
            }

            static create(src?: Seismic_createType) {
                const dst = new Seismic();
                if (src === undefined) {
                    return dst;
                }
                if (src.safetyFactor !== undefined) {
                    dst.safetyFactor = src.safetyFactor;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Seismic();
                dst.safetyFactor = this.safetyFactor;
                return dst;
            }

            deepClone() {
                const json = Seismic.toObject(this);
                const dst = Seismic.fromObject(json);
                return dst;
            }
        }
        export type ISeismic = Seismic;


        export type Group_keys = 'id' | 'permanent' | 'stress' | 'temporary' | 'accidental' | 'seismic' | 'loadcaseRelationship' | 'loadcaseId';
        export interface Group_createType {
            id?: ng.utils.ID | null,
            permanent?: ng.loadgroup.Permanent | null,
            stress?: ng.loadgroup.Stress | null,
            temporary?: ng.loadgroup.Temporary | null,
            accidental?: ng.loadgroup.Accidental | null,
            seismic?: ng.loadgroup.Seismic | null,
            loadcaseRelationship?: ng.loadgroup.LoadcaseRelationship,
            loadcaseId?: string[],
        }
        export interface Group_json {
            id?: ng.utils.ID_json;
            permanent?: ng.loadgroup.Permanent_json;
            stress?: ng.loadgroup.Stress_json;
            temporary?: ng.loadgroup.Temporary_json;
            accidental?: ng.loadgroup.Accidental_json;
            seismic?: ng.loadgroup.Seismic_json;
            loadcaseRelationship?: string;
            loadcaseId: string[];
        }
        interface Group_json_in {
            __proto_name?: unknown;
            id?: unknown;
            permanent?: unknown;
            stress?: unknown;
            temporary?: unknown;
            accidental?: unknown;
            seismic?: unknown;
            loadcaseRelationship?: unknown;
            loadcaseId?: unknown;
        }
        export class Group {
            __proto_name = "ng.loadgroup.Group";
            id: ng.utils.ID | null = null;
            // this is a one of
            type: {type: 'permanent'; permanent: ng.loadgroup.Permanent} | {type: 'stress'; stress: ng.loadgroup.Stress} | {type: 'temporary'; temporary: ng.loadgroup.Temporary} | {type: 'accidental'; accidental: ng.loadgroup.Accidental} | {type: 'seismic'; seismic: ng.loadgroup.Seismic} | null = null;
            loadcaseRelationship: ng.loadgroup.LoadcaseRelationship = ng.loadgroup.LoadcaseRelationship.unspecified;
            loadcaseId: string[] = [];

            /** Gets the `Permanent` value (or null) from the oneof `type` */
            getPermanent(): ng.loadgroup.Permanent | null {
                if(this.type === null) return null;
                if(this.type.type !== 'permanent') return null;
                return this.type.permanent;
            }

            /** Sets the `Permanent` value for the oneof `type`*/
            setPermanent(value: ng.loadgroup.Permanent | null) {
                if(value !== null) {
                    this.type = {type: 'permanent', permanent:value};
                }
                else {
                    this.type = null;
                }
            }

            /** Gets the `Stress` value (or null) from the oneof `type` */
            getStress(): ng.loadgroup.Stress | null {
                if(this.type === null) return null;
                if(this.type.type !== 'stress') return null;
                return this.type.stress;
            }

            /** Sets the `Stress` value for the oneof `type`*/
            setStress(value: ng.loadgroup.Stress | null) {
                if(value !== null) {
                    this.type = {type: 'stress', stress:value};
                }
                else {
                    this.type = null;
                }
            }

            /** Gets the `Temporary` value (or null) from the oneof `type` */
            getTemporary(): ng.loadgroup.Temporary | null {
                if(this.type === null) return null;
                if(this.type.type !== 'temporary') return null;
                return this.type.temporary;
            }

            /** Sets the `Temporary` value for the oneof `type`*/
            setTemporary(value: ng.loadgroup.Temporary | null) {
                if(value !== null) {
                    this.type = {type: 'temporary', temporary:value};
                }
                else {
                    this.type = null;
                }
            }

            /** Gets the `Accidental` value (or null) from the oneof `type` */
            getAccidental(): ng.loadgroup.Accidental | null {
                if(this.type === null) return null;
                if(this.type.type !== 'accidental') return null;
                return this.type.accidental;
            }

            /** Sets the `Accidental` value for the oneof `type`*/
            setAccidental(value: ng.loadgroup.Accidental | null) {
                if(value !== null) {
                    this.type = {type: 'accidental', accidental:value};
                }
                else {
                    this.type = null;
                }
            }

            /** Gets the `Seismic` value (or null) from the oneof `type` */
            getSeismic(): ng.loadgroup.Seismic | null {
                if(this.type === null) return null;
                if(this.type.type !== 'seismic') return null;
                return this.type.seismic;
            }

            /** Sets the `Seismic` value for the oneof `type`*/
            setSeismic(value: ng.loadgroup.Seismic | null) {
                if(value !== null) {
                    this.type = {type: 'seismic', seismic:value};
                }
                else {
                    this.type = null;
                }
            }

            static fromObject(src_unknown: unknown): Group {
                const dst = new Group();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Group but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Group_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Group but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.permanent !== undefined && src.permanent !== null) {
                    dst.setPermanent(ng.loadgroup.Permanent.fromObject(src.permanent));
                }
                if (src.stress !== undefined && src.stress !== null) {
                    dst.setStress(ng.loadgroup.Stress.fromObject(src.stress));
                }
                if (src.temporary !== undefined && src.temporary !== null) {
                    dst.setTemporary(ng.loadgroup.Temporary.fromObject(src.temporary));
                }
                if (src.accidental !== undefined && src.accidental !== null) {
                    dst.setAccidental(ng.loadgroup.Accidental.fromObject(src.accidental));
                }
                if (src.seismic !== undefined && src.seismic !== null) {
                    dst.setSeismic(ng.loadgroup.Seismic.fromObject(src.seismic));
                }
                if (src.loadcaseRelationship !== undefined && src.loadcaseRelationship !== null) {
                    dst.loadcaseRelationship = ng.loadgroup.LoadcaseRelationship_FromObject(src.loadcaseRelationship);
                }
                if (src.loadcaseId !== undefined && src.loadcaseId !== null) {
                    if (Array.isArray(src.loadcaseId)) {
                        for (const [index, element] of src.loadcaseId.entries()) {
                            if (typeof element === "string") {
                                dst.loadcaseId.push(element);
                            }
                            else {
                                console.log('Expected loadcaseId of Group[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected loadcaseId of Group to be a array but was ', typeof src.loadcaseId, src.loadcaseId)
                    }
                }
                return dst;
            }

            static toObject(src: Group | null | undefined): Group_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Group is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Group") {
                    console.error('Expected ng.loadgroup.Group but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const loadcaseRelationship_obj = ng.loadgroup.LoadcaseRelationship_ToObject(src.loadcaseRelationship);
                if(loadcaseRelationship_obj === null) return null;

                const dst : Group_json = {
                    loadcaseRelationship: loadcaseRelationship_obj,
                    loadcaseId: new Array<string>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const permanent = src.getPermanent();
                if(permanent !== null)
                {
                    const parsed = ng.loadgroup.Permanent.toObject(permanent);
                    if(parsed === null) return null;
                    dst.permanent = parsed;
                }
                const stress = src.getStress();
                if(stress !== null)
                {
                    const parsed = ng.loadgroup.Stress.toObject(stress);
                    if(parsed === null) return null;
                    dst.stress = parsed;
                }
                const temporary = src.getTemporary();
                if(temporary !== null)
                {
                    const parsed = ng.loadgroup.Temporary.toObject(temporary);
                    if(parsed === null) return null;
                    dst.temporary = parsed;
                }
                const accidental = src.getAccidental();
                if(accidental !== null)
                {
                    const parsed = ng.loadgroup.Accidental.toObject(accidental);
                    if(parsed === null) return null;
                    dst.accidental = parsed;
                }
                const seismic = src.getSeismic();
                if(seismic !== null)
                {
                    const parsed = ng.loadgroup.Seismic.toObject(seismic);
                    if(parsed === null) return null;
                    dst.seismic = parsed;
                }
                if (src.loadcaseId !== null) {
                    for (const element of src.loadcaseId) {
                        dst.loadcaseId.push(element);
                    }
                }
                return dst;
            }

            static create(src?: Group_createType) {
                const dst = new Group();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                // part of the type oneof 
                if (src.permanent !== undefined && src.permanent !== null) {
                    dst.setPermanent(src.permanent);
                }
                // part of the type oneof 
                if (src.stress !== undefined && src.stress !== null) {
                    dst.setStress(src.stress);
                }
                // part of the type oneof 
                if (src.temporary !== undefined && src.temporary !== null) {
                    dst.setTemporary(src.temporary);
                }
                // part of the type oneof 
                if (src.accidental !== undefined && src.accidental !== null) {
                    dst.setAccidental(src.accidental);
                }
                // part of the type oneof 
                if (src.seismic !== undefined && src.seismic !== null) {
                    dst.setSeismic(src.seismic);
                }
                if (src.loadcaseRelationship !== undefined) {
                    dst.loadcaseRelationship = src.loadcaseRelationship;
                }
                if (src.loadcaseId !== undefined) {
                    dst.loadcaseId = src.loadcaseId;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Group();
                dst.id = this.id;
                dst.type = this.type;
                dst.loadcaseRelationship = this.loadcaseRelationship;
                dst.loadcaseId = this.loadcaseId;
                return dst;
            }

            deepClone() {
                const json = Group.toObject(this);
                const dst = Group.fromObject(json);
                return dst;
            }
        }
        export type IGroup = Group;


        export type Groups_keys = 'simpleServiceability' | 'includeMinOneLoadcaseInTempLoadgroup' | 'loadgroups';
        export interface Groups_createType {
            simpleServiceability?: boolean,
            includeMinOneLoadcaseInTempLoadgroup?: boolean,
            loadgroups?: ng.loadgroup.Group[],
        }
        export interface Groups_json {
            simpleServiceability?: boolean;
            includeMinOneLoadcaseInTempLoadgroup?: boolean;
            loadgroups: ng.loadgroup.Group_json[];
        }
        interface Groups_json_in {
            __proto_name?: unknown;
            simpleServiceability?: unknown;
            includeMinOneLoadcaseInTempLoadgroup?: unknown;
            loadgroups?: unknown;
        }
        export class Groups {
            __proto_name = "ng.loadgroup.Groups";
            simpleServiceability: boolean = false;
            includeMinOneLoadcaseInTempLoadgroup: boolean = false;
            loadgroups: ng.loadgroup.Group[] = [];

            static fromObject(src_unknown: unknown): Groups {
                const dst = new Groups();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Groups but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Groups_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Groups but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.simpleServiceability !== undefined && src.simpleServiceability !== null) {
                    if (typeof src.simpleServiceability === "boolean") {
                        dst.simpleServiceability = src.simpleServiceability;
                    }
                    else {
                        console.log('Expected simpleServiceability of Groups to be a boolean but was ', typeof src.simpleServiceability, src.simpleServiceability)
                    }
                }
                if (src.includeMinOneLoadcaseInTempLoadgroup !== undefined && src.includeMinOneLoadcaseInTempLoadgroup !== null) {
                    if (typeof src.includeMinOneLoadcaseInTempLoadgroup === "boolean") {
                        dst.includeMinOneLoadcaseInTempLoadgroup = src.includeMinOneLoadcaseInTempLoadgroup;
                    }
                    else {
                        console.log('Expected includeMinOneLoadcaseInTempLoadgroup of Groups to be a boolean but was ', typeof src.includeMinOneLoadcaseInTempLoadgroup, src.includeMinOneLoadcaseInTempLoadgroup)
                    }
                }
                if (src.loadgroups !== undefined && src.loadgroups !== null) {
                    if (Array.isArray(src.loadgroups)) {
                        for (const element of src.loadgroups) {
                            dst.loadgroups.push(ng.loadgroup.Group.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected loadgroups of Groups to be a array but was ', typeof src.loadgroups, src.loadgroups)
                    }
                }
                return dst;
            }

            static toObject(src: Groups | null | undefined): Groups_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadgroup.Groups is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadgroup.Groups") {
                    console.error('Expected ng.loadgroup.Groups but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Groups_json = {
                    simpleServiceability: src.simpleServiceability,
                    includeMinOneLoadcaseInTempLoadgroup: src.includeMinOneLoadcaseInTempLoadgroup,
                    loadgroups: new Array<ng.loadgroup.Group_json>(),
                };
                if (src.loadgroups !== null) {
                    for (const element of src.loadgroups) {
                        const parsed = ng.loadgroup.Group.toObject(element);
                        if(parsed === null) return null;
                        dst.loadgroups.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Groups_createType) {
                const dst = new Groups();
                if (src === undefined) {
                    return dst;
                }
                if (src.simpleServiceability !== undefined) {
                    dst.simpleServiceability = src.simpleServiceability;
                }
                if (src.includeMinOneLoadcaseInTempLoadgroup !== undefined) {
                    dst.includeMinOneLoadcaseInTempLoadgroup = src.includeMinOneLoadcaseInTempLoadgroup;
                }
                if (src.loadgroups !== undefined) {
                    dst.loadgroups = src.loadgroups;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Groups();
                dst.simpleServiceability = this.simpleServiceability;
                dst.includeMinOneLoadcaseInTempLoadgroup = this.includeMinOneLoadcaseInTempLoadgroup;
                dst.loadgroups = this.loadgroups;
                return dst;
            }

            deepClone() {
                const json = Groups.toObject(this);
                const dst = Groups.fromObject(json);
                return dst;
            }
        }
        export type IGroups = Groups;
    } // namespace loadgroup


    // Defined in structure.proto
    export namespace structure {
        export enum ConsequenceClass {
            CONSEQUENCE_CLASS_UNSPECIFIED = 0,
            CONSEQUENCE_CLASS_1 = 1,
            CONSEQUENCE_CLASS_2 = 2,
            CONSEQUENCE_CLASS_3 = 3
        }
        export const ConsequenceClass_FromObject = (src: unknown): ConsequenceClass => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'CONSEQUENCE_CLASS_UNSPECIFIED':
                    return ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED;
                case 1:
                case 'CONSEQUENCE_CLASS_1':
                    return ConsequenceClass.CONSEQUENCE_CLASS_1;
                case 2:
                case 'CONSEQUENCE_CLASS_2':
                    return ConsequenceClass.CONSEQUENCE_CLASS_2;
                case 3:
                case 'CONSEQUENCE_CLASS_3':
                    return ConsequenceClass.CONSEQUENCE_CLASS_3;
                default:
                    console.log('Unhandled value for ConsequenceClass:' + src + '. ' + typeof(src));
                    return ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED;
            }
        };
        export const ConsequenceClass_ToObject = (src: ConsequenceClass): string | null => {
            switch (src) {
                case ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED:
                    return 'CONSEQUENCE_CLASS_UNSPECIFIED';
                case ConsequenceClass.CONSEQUENCE_CLASS_1:
                    return 'CONSEQUENCE_CLASS_1';
                case ConsequenceClass.CONSEQUENCE_CLASS_2:
                    return 'CONSEQUENCE_CLASS_2';
                case ConsequenceClass.CONSEQUENCE_CLASS_3:
                    return 'CONSEQUENCE_CLASS_3';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for ConsequenceClass, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum ReliabilityClass {
            RELIABILITY_CLASS_UNSPECIFIED = 0,
            RELIABILITY_CLASS_1 = 1,
            RELIABILITY_CLASS_2 = 2,
            RELIABILITY_CLASS_3 = 3
        }
        export const ReliabilityClass_FromObject = (src: unknown): ReliabilityClass => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'RELIABILITY_CLASS_UNSPECIFIED':
                    return ReliabilityClass.RELIABILITY_CLASS_UNSPECIFIED;
                case 1:
                case 'RELIABILITY_CLASS_1':
                    return ReliabilityClass.RELIABILITY_CLASS_1;
                case 2:
                case 'RELIABILITY_CLASS_2':
                    return ReliabilityClass.RELIABILITY_CLASS_2;
                case 3:
                case 'RELIABILITY_CLASS_3':
                    return ReliabilityClass.RELIABILITY_CLASS_3;
                default:
                    console.log('Unhandled value for ReliabilityClass:' + src + '. ' + typeof(src));
                    return ReliabilityClass.RELIABILITY_CLASS_UNSPECIFIED;
            }
        };
        export const ReliabilityClass_ToObject = (src: ReliabilityClass): string | null => {
            switch (src) {
                case ReliabilityClass.RELIABILITY_CLASS_UNSPECIFIED:
                    return 'RELIABILITY_CLASS_UNSPECIFIED';
                case ReliabilityClass.RELIABILITY_CLASS_1:
                    return 'RELIABILITY_CLASS_1';
                case ReliabilityClass.RELIABILITY_CLASS_2:
                    return 'RELIABILITY_CLASS_2';
                case ReliabilityClass.RELIABILITY_CLASS_3:
                    return 'RELIABILITY_CLASS_3';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for ReliabilityClass, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Data_keys = 'id' | 'description' | 'elements' | 'nodes' | 'cons' | 'sups' | 'stages' | 'loading' | 'designSettings' | 'cc' | 'reliabilityClass';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            description?: string,
            elements?: ng.element.Data[],
            nodes?: ng.topology.ElementNode[],
            cons?: ng.topology.ConNode[],
            sups?: ng.support.Data[],
            stages?: ng.stage.Data[],
            loading?: ng.loading.Data | null,
            designSettings?: ng.design.GeneralDesignSettings | null,
            cc?: ng.structure.ConsequenceClass,
            reliabilityClass?: ng.structure.ReliabilityClass,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            description?: string;
            elements: ng.element.Data_json[];
            nodes: ng.topology.ElementNode_json[];
            cons: ng.topology.ConNode_json[];
            sups: ng.support.Data_json[];
            stages: ng.stage.Data_json[];
            loading?: ng.loading.Data_json;
            designSettings?: ng.design.GeneralDesignSettings_json;
            cc?: string;
            reliabilityClass?: string;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            description?: unknown;
            elements?: unknown;
            nodes?: unknown;
            cons?: unknown;
            sups?: unknown;
            stages?: unknown;
            loading?: unknown;
            designSettings?: unknown;
            cc?: unknown;
            reliabilityClass?: unknown;
        }
        export class Data {
            __proto_name = "ng.structure.Data";
            id: ng.utils.ID | null = null;
            description: string = "";
            elements: ng.element.Data[] = [];
            nodes: ng.topology.ElementNode[] = [];
            cons: ng.topology.ConNode[] = [];
            sups: ng.support.Data[] = [];
            stages: ng.stage.Data[] = [];
            loading: ng.loading.Data | null = null;
            designSettings: ng.design.GeneralDesignSettings | null = null;
            cc: ng.structure.ConsequenceClass = ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED;
            reliabilityClass: ng.structure.ReliabilityClass = ng.structure.ReliabilityClass.RELIABILITY_CLASS_UNSPECIFIED;

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.description !== undefined && src.description !== null) {
                    if (typeof src.description === "string") {
                        dst.description = src.description;
                    }
                    else {
                        console.log('Expected description of Data to be a string but was ', typeof src.description, src.description)
                    }
                }
                if (src.elements !== undefined && src.elements !== null) {
                    if (Array.isArray(src.elements)) {
                        for (const element of src.elements) {
                            dst.elements.push(ng.element.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected elements of Data to be a array but was ', typeof src.elements, src.elements)
                    }
                }
                if (src.nodes !== undefined && src.nodes !== null) {
                    if (Array.isArray(src.nodes)) {
                        for (const element of src.nodes) {
                            dst.nodes.push(ng.topology.ElementNode.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected nodes of Data to be a array but was ', typeof src.nodes, src.nodes)
                    }
                }
                if (src.cons !== undefined && src.cons !== null) {
                    if (Array.isArray(src.cons)) {
                        for (const element of src.cons) {
                            dst.cons.push(ng.topology.ConNode.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected cons of Data to be a array but was ', typeof src.cons, src.cons)
                    }
                }
                if (src.sups !== undefined && src.sups !== null) {
                    if (Array.isArray(src.sups)) {
                        for (const element of src.sups) {
                            dst.sups.push(ng.support.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected sups of Data to be a array but was ', typeof src.sups, src.sups)
                    }
                }
                if (src.stages !== undefined && src.stages !== null) {
                    if (Array.isArray(src.stages)) {
                        for (const element of src.stages) {
                            dst.stages.push(ng.stage.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected stages of Data to be a array but was ', typeof src.stages, src.stages)
                    }
                }
                if (src.loading !== undefined && src.loading !== null) {
                    dst.loading = ng.loading.Data.fromObject(src.loading);
                }
                if (src.designSettings !== undefined && src.designSettings !== null) {
                    dst.designSettings = ng.design.GeneralDesignSettings.fromObject(src.designSettings);
                }
                if (src.cc !== undefined && src.cc !== null) {
                    dst.cc = ng.structure.ConsequenceClass_FromObject(src.cc);
                }
                if (src.reliabilityClass !== undefined && src.reliabilityClass !== null) {
                    dst.reliabilityClass = ng.structure.ReliabilityClass_FromObject(src.reliabilityClass);
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.structure.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.structure.Data") {
                    console.error('Expected ng.structure.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const cc_obj = ng.structure.ConsequenceClass_ToObject(src.cc);
                if(cc_obj === null) return null;

                const reliabilityClass_obj = ng.structure.ReliabilityClass_ToObject(src.reliabilityClass);
                if(reliabilityClass_obj === null) return null;

                const dst : Data_json = {
                    description: src.description,
                    elements: new Array<ng.element.Data_json>(),
                    nodes: new Array<ng.topology.ElementNode_json>(),
                    cons: new Array<ng.topology.ConNode_json>(),
                    sups: new Array<ng.support.Data_json>(),
                    stages: new Array<ng.stage.Data_json>(),
                    cc: cc_obj,
                    reliabilityClass: reliabilityClass_obj,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.elements !== null) {
                    for (const element of src.elements) {
                        const parsed = ng.element.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.elements.push(parsed);
                    }
                }
                if (src.nodes !== null) {
                    for (const element of src.nodes) {
                        const parsed = ng.topology.ElementNode.toObject(element);
                        if(parsed === null) return null;
                        dst.nodes.push(parsed);
                    }
                }
                if (src.cons !== null) {
                    for (const element of src.cons) {
                        const parsed = ng.topology.ConNode.toObject(element);
                        if(parsed === null) return null;
                        dst.cons.push(parsed);
                    }
                }
                if (src.sups !== null) {
                    for (const element of src.sups) {
                        const parsed = ng.support.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.sups.push(parsed);
                    }
                }
                if (src.stages !== null) {
                    for (const element of src.stages) {
                        const parsed = ng.stage.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.stages.push(parsed);
                    }
                }
                if(src.loading !== null)
                {
                    const parsed = ng.loading.Data.toObject(src.loading);
                    if(parsed === null) return null;
                    dst.loading = parsed;
                }
                if(src.designSettings !== null)
                {
                    const parsed = ng.design.GeneralDesignSettings.toObject(src.designSettings);
                    if(parsed === null) return null;
                    dst.designSettings = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.description !== undefined) {
                    dst.description = src.description;
                }
                if (src.elements !== undefined) {
                    dst.elements = src.elements;
                }
                if (src.nodes !== undefined) {
                    dst.nodes = src.nodes;
                }
                if (src.cons !== undefined) {
                    dst.cons = src.cons;
                }
                if (src.sups !== undefined) {
                    dst.sups = src.sups;
                }
                if (src.stages !== undefined) {
                    dst.stages = src.stages;
                }
                if (src.loading !== undefined) {
                    dst.loading = src.loading;
                }
                if (src.designSettings !== undefined) {
                    dst.designSettings = src.designSettings;
                }
                if (src.cc !== undefined) {
                    dst.cc = src.cc;
                }
                if (src.reliabilityClass !== undefined) {
                    dst.reliabilityClass = src.reliabilityClass;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.description = this.description;
                dst.elements = this.elements;
                dst.nodes = this.nodes;
                dst.cons = this.cons;
                dst.sups = this.sups;
                dst.stages = this.stages;
                dst.loading = this.loading;
                dst.designSettings = this.designSettings;
                dst.cc = this.cc;
                dst.reliabilityClass = this.reliabilityClass;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace structure


    // Defined in Loading/loadcombination.proto
    export namespace loadcombination {
        export enum Type {
            TYPE_UNSPECIFIED = 0,
            TYPE_CHARACTERISTIC = 1,
            TYPE_FREQUENT = 2,
            TYPE_QUASI_PERMANENT = 3,
            TYPE_ULTIMATE = 4,
            TYPE_ACCIDENTAL = 5,
            TYPE_FIRE = 6,
            TYPE_SEISMIC = 7
        }
        export const Type_FromObject = (src: unknown): Type => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'TYPE_UNSPECIFIED':
                    return Type.TYPE_UNSPECIFIED;
                case 1:
                case 'TYPE_CHARACTERISTIC':
                    return Type.TYPE_CHARACTERISTIC;
                case 2:
                case 'TYPE_FREQUENT':
                    return Type.TYPE_FREQUENT;
                case 3:
                case 'TYPE_QUASI_PERMANENT':
                    return Type.TYPE_QUASI_PERMANENT;
                case 4:
                case 'TYPE_ULTIMATE':
                    return Type.TYPE_ULTIMATE;
                case 5:
                case 'TYPE_ACCIDENTAL':
                    return Type.TYPE_ACCIDENTAL;
                case 6:
                case 'TYPE_FIRE':
                    return Type.TYPE_FIRE;
                case 7:
                case 'TYPE_SEISMIC':
                    return Type.TYPE_SEISMIC;
                default:
                    console.log('Unhandled value for Type:' + src + '. ' + typeof(src));
                    return Type.TYPE_UNSPECIFIED;
            }
        };
        export const Type_ToObject = (src: Type): string | null => {
            switch (src) {
                case Type.TYPE_UNSPECIFIED:
                    return 'TYPE_UNSPECIFIED';
                case Type.TYPE_CHARACTERISTIC:
                    return 'TYPE_CHARACTERISTIC';
                case Type.TYPE_FREQUENT:
                    return 'TYPE_FREQUENT';
                case Type.TYPE_QUASI_PERMANENT:
                    return 'TYPE_QUASI_PERMANENT';
                case Type.TYPE_ULTIMATE:
                    return 'TYPE_ULTIMATE';
                case Type.TYPE_ACCIDENTAL:
                    return 'TYPE_ACCIDENTAL';
                case Type.TYPE_FIRE:
                    return 'TYPE_FIRE';
                case Type.TYPE_SEISMIC:
                    return 'TYPE_SEISMIC';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Type, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum CoefficientType {
            COEFFICIENT_TYPE_UNSPECIFIED = 0,
            COEFFICIENT_TYPE_BASE = 1,
            COEFFICIENT_TYPE_KFI = 2,
            COEFFICIENT_TYPE_ETA = 3,
            COEFFICIENT_TYPE_STOREY = 4,
            COEFFICIENT_TYPE_CHI_FACTOR = 5,
            COEFFICIENT_TYPE_GAMMA = 6,
            COEFFICIENT_TYPE_PSI = 7
        }
        export const CoefficientType_FromObject = (src: unknown): CoefficientType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'COEFFICIENT_TYPE_UNSPECIFIED':
                    return CoefficientType.COEFFICIENT_TYPE_UNSPECIFIED;
                case 1:
                case 'COEFFICIENT_TYPE_BASE':
                    return CoefficientType.COEFFICIENT_TYPE_BASE;
                case 2:
                case 'COEFFICIENT_TYPE_KFI':
                    return CoefficientType.COEFFICIENT_TYPE_KFI;
                case 3:
                case 'COEFFICIENT_TYPE_ETA':
                    return CoefficientType.COEFFICIENT_TYPE_ETA;
                case 4:
                case 'COEFFICIENT_TYPE_STOREY':
                    return CoefficientType.COEFFICIENT_TYPE_STOREY;
                case 5:
                case 'COEFFICIENT_TYPE_CHI_FACTOR':
                    return CoefficientType.COEFFICIENT_TYPE_CHI_FACTOR;
                case 6:
                case 'COEFFICIENT_TYPE_GAMMA':
                    return CoefficientType.COEFFICIENT_TYPE_GAMMA;
                case 7:
                case 'COEFFICIENT_TYPE_PSI':
                    return CoefficientType.COEFFICIENT_TYPE_PSI;
                default:
                    console.log('Unhandled value for CoefficientType:' + src + '. ' + typeof(src));
                    return CoefficientType.COEFFICIENT_TYPE_UNSPECIFIED;
            }
        };
        export const CoefficientType_ToObject = (src: CoefficientType): string | null => {
            switch (src) {
                case CoefficientType.COEFFICIENT_TYPE_UNSPECIFIED:
                    return 'COEFFICIENT_TYPE_UNSPECIFIED';
                case CoefficientType.COEFFICIENT_TYPE_BASE:
                    return 'COEFFICIENT_TYPE_BASE';
                case CoefficientType.COEFFICIENT_TYPE_KFI:
                    return 'COEFFICIENT_TYPE_KFI';
                case CoefficientType.COEFFICIENT_TYPE_ETA:
                    return 'COEFFICIENT_TYPE_ETA';
                case CoefficientType.COEFFICIENT_TYPE_STOREY:
                    return 'COEFFICIENT_TYPE_STOREY';
                case CoefficientType.COEFFICIENT_TYPE_CHI_FACTOR:
                    return 'COEFFICIENT_TYPE_CHI_FACTOR';
                case CoefficientType.COEFFICIENT_TYPE_GAMMA:
                    return 'COEFFICIENT_TYPE_GAMMA';
                case CoefficientType.COEFFICIENT_TYPE_PSI:
                    return 'COEFFICIENT_TYPE_PSI';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for CoefficientType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum LimitState {
            LIMIT_STATE_UNSPECIFIED = 0,
            LIMIT_STATE_STR = 1,
            LIMIT_STATE_GEO = 2,
            LIMIT_STATE_EQU = 3,
            LIMIT_STATE_VC1 = 4,
            LIMIT_STATE_VC2A = 5,
            LIMIT_STATE_VC2B = 6,
            LIMIT_STATE_VC3 = 7,
            LIMIT_STATE_VC4 = 8
        }
        export const LimitState_FromObject = (src: unknown): LimitState => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'LIMIT_STATE_UNSPECIFIED':
                    return LimitState.LIMIT_STATE_UNSPECIFIED;
                case 1:
                case 'LIMIT_STATE_STR':
                    return LimitState.LIMIT_STATE_STR;
                case 2:
                case 'LIMIT_STATE_GEO':
                    return LimitState.LIMIT_STATE_GEO;
                case 3:
                case 'LIMIT_STATE_EQU':
                    return LimitState.LIMIT_STATE_EQU;
                case 4:
                case 'LIMIT_STATE_VC1':
                    return LimitState.LIMIT_STATE_VC1;
                case 5:
                case 'LIMIT_STATE_VC2A':
                    return LimitState.LIMIT_STATE_VC2A;
                case 6:
                case 'LIMIT_STATE_VC2B':
                    return LimitState.LIMIT_STATE_VC2B;
                case 7:
                case 'LIMIT_STATE_VC3':
                    return LimitState.LIMIT_STATE_VC3;
                case 8:
                case 'LIMIT_STATE_VC4':
                    return LimitState.LIMIT_STATE_VC4;
                default:
                    console.log('Unhandled value for LimitState:' + src + '. ' + typeof(src));
                    return LimitState.LIMIT_STATE_UNSPECIFIED;
            }
        };
        export const LimitState_ToObject = (src: LimitState): string | null => {
            switch (src) {
                case LimitState.LIMIT_STATE_UNSPECIFIED:
                    return 'LIMIT_STATE_UNSPECIFIED';
                case LimitState.LIMIT_STATE_STR:
                    return 'LIMIT_STATE_STR';
                case LimitState.LIMIT_STATE_GEO:
                    return 'LIMIT_STATE_GEO';
                case LimitState.LIMIT_STATE_EQU:
                    return 'LIMIT_STATE_EQU';
                case LimitState.LIMIT_STATE_VC1:
                    return 'LIMIT_STATE_VC1';
                case LimitState.LIMIT_STATE_VC2A:
                    return 'LIMIT_STATE_VC2A';
                case LimitState.LIMIT_STATE_VC2B:
                    return 'LIMIT_STATE_VC2B';
                case LimitState.LIMIT_STATE_VC3:
                    return 'LIMIT_STATE_VC3';
                case LimitState.LIMIT_STATE_VC4:
                    return 'LIMIT_STATE_VC4';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for LimitState, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum CoaType {
            COA_TYPE_UNSPECIFIED = 0,
            COA_TYPE_610 = 1,
            COA_TYPE_610A = 2,
            COA_TYPE_610B = 3,
            COA_TYPE_610A3 = 4,
            COA_TYPE_610B4 = 5,
            COA_TYPE_6105 = 6,
            COA_TYPE_611AB = 7,
            COA_TYPE_614B = 8,
            COA_TYPE_615B = 9,
            COA_TYPE_616B = 10,
            COA_TYPE_812 = 11,
            COA_TYPE_813A = 12,
            COA_TYPE_813B = 13,
            COA_TYPE_814A = 14,
            COA_TYPE_814B = 15,
            COA_TYPE_815 = 16,
            COA_TYPE_816 = 17,
            COA_TYPE_829 = 19,
            COA_TYPE_830 = 20,
            COA_TYPE_831 = 21
        }
        export const CoaType_FromObject = (src: unknown): CoaType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'COA_TYPE_UNSPECIFIED':
                    return CoaType.COA_TYPE_UNSPECIFIED;
                case 1:
                case 'COA_TYPE_610':
                    return CoaType.COA_TYPE_610;
                case 2:
                case 'COA_TYPE_610A':
                    return CoaType.COA_TYPE_610A;
                case 3:
                case 'COA_TYPE_610B':
                    return CoaType.COA_TYPE_610B;
                case 4:
                case 'COA_TYPE_610A3':
                    return CoaType.COA_TYPE_610A3;
                case 5:
                case 'COA_TYPE_610B4':
                    return CoaType.COA_TYPE_610B4;
                case 6:
                case 'COA_TYPE_6105':
                    return CoaType.COA_TYPE_6105;
                case 7:
                case 'COA_TYPE_611AB':
                    return CoaType.COA_TYPE_611AB;
                case 8:
                case 'COA_TYPE_614B':
                    return CoaType.COA_TYPE_614B;
                case 9:
                case 'COA_TYPE_615B':
                    return CoaType.COA_TYPE_615B;
                case 10:
                case 'COA_TYPE_616B':
                    return CoaType.COA_TYPE_616B;
                case 11:
                case 'COA_TYPE_812':
                    return CoaType.COA_TYPE_812;
                case 12:
                case 'COA_TYPE_813A':
                    return CoaType.COA_TYPE_813A;
                case 13:
                case 'COA_TYPE_813B':
                    return CoaType.COA_TYPE_813B;
                case 14:
                case 'COA_TYPE_814A':
                    return CoaType.COA_TYPE_814A;
                case 15:
                case 'COA_TYPE_814B':
                    return CoaType.COA_TYPE_814B;
                case 16:
                case 'COA_TYPE_815':
                    return CoaType.COA_TYPE_815;
                case 17:
                case 'COA_TYPE_816':
                    return CoaType.COA_TYPE_816;
                case 19:
                case 'COA_TYPE_829':
                    return CoaType.COA_TYPE_829;
                case 20:
                case 'COA_TYPE_830':
                    return CoaType.COA_TYPE_830;
                case 21:
                case 'COA_TYPE_831':
                    return CoaType.COA_TYPE_831;
                default:
                    console.log('Unhandled value for CoaType:' + src + '. ' + typeof(src));
                    return CoaType.COA_TYPE_UNSPECIFIED;
            }
        };
        export const CoaType_ToObject = (src: CoaType): string | null => {
            switch (src) {
                case CoaType.COA_TYPE_UNSPECIFIED:
                    return 'COA_TYPE_UNSPECIFIED';
                case CoaType.COA_TYPE_610:
                    return 'COA_TYPE_610';
                case CoaType.COA_TYPE_610A:
                    return 'COA_TYPE_610A';
                case CoaType.COA_TYPE_610B:
                    return 'COA_TYPE_610B';
                case CoaType.COA_TYPE_610A3:
                    return 'COA_TYPE_610A3';
                case CoaType.COA_TYPE_610B4:
                    return 'COA_TYPE_610B4';
                case CoaType.COA_TYPE_6105:
                    return 'COA_TYPE_6105';
                case CoaType.COA_TYPE_611AB:
                    return 'COA_TYPE_611AB';
                case CoaType.COA_TYPE_614B:
                    return 'COA_TYPE_614B';
                case CoaType.COA_TYPE_615B:
                    return 'COA_TYPE_615B';
                case CoaType.COA_TYPE_616B:
                    return 'COA_TYPE_616B';
                case CoaType.COA_TYPE_812:
                    return 'COA_TYPE_812';
                case CoaType.COA_TYPE_813A:
                    return 'COA_TYPE_813A';
                case CoaType.COA_TYPE_813B:
                    return 'COA_TYPE_813B';
                case CoaType.COA_TYPE_814A:
                    return 'COA_TYPE_814A';
                case CoaType.COA_TYPE_814B:
                    return 'COA_TYPE_814B';
                case CoaType.COA_TYPE_815:
                    return 'COA_TYPE_815';
                case CoaType.COA_TYPE_816:
                    return 'COA_TYPE_816';
                case CoaType.COA_TYPE_829:
                    return 'COA_TYPE_829';
                case CoaType.COA_TYPE_830:
                    return 'COA_TYPE_830';
                case CoaType.COA_TYPE_831:
                    return 'COA_TYPE_831';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for CoaType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum GeoType {
            GEO_TYPE_UNSPECIFIED = 0,
            GEO_TYPE_1 = 1,
            GEO_TYPE_2 = 2
        }
        export const GeoType_FromObject = (src: unknown): GeoType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'GEO_TYPE_UNSPECIFIED':
                    return GeoType.GEO_TYPE_UNSPECIFIED;
                case 1:
                case 'GEO_TYPE_1':
                    return GeoType.GEO_TYPE_1;
                case 2:
                case 'GEO_TYPE_2':
                    return GeoType.GEO_TYPE_2;
                default:
                    console.log('Unhandled value for GeoType:' + src + '. ' + typeof(src));
                    return GeoType.GEO_TYPE_UNSPECIFIED;
            }
        };
        export const GeoType_ToObject = (src: GeoType): string | null => {
            switch (src) {
                case GeoType.GEO_TYPE_UNSPECIFIED:
                    return 'GEO_TYPE_UNSPECIFIED';
                case GeoType.GEO_TYPE_1:
                    return 'GEO_TYPE_1';
                case GeoType.GEO_TYPE_2:
                    return 'GEO_TYPE_2';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for GeoType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type CombinationPart_keys = 'lcaseGuid' | 'coefficients' | 'favourablePermanentLoad';
        export interface CombinationPart_createType {
            lcaseGuid?: string,
            coefficients?: ng.loadcombination.Coefficient[],
            favourablePermanentLoad?: boolean,
        }
        export interface CombinationPart_json {
            lcaseGuid?: string;
            coefficients: ng.loadcombination.Coefficient_json[];
            favourablePermanentLoad?: boolean;
        }
        interface CombinationPart_json_in {
            __proto_name?: unknown;
            lcaseGuid?: unknown;
            coefficients?: unknown;
            favourablePermanentLoad?: unknown;
        }
        export class CombinationPart {
            __proto_name = "ng.loadcombination.CombinationPart";
            lcaseGuid: string = "";
            coefficients: ng.loadcombination.Coefficient[] = [];
            favourablePermanentLoad: boolean = false;

            static fromObject(src_unknown: unknown): CombinationPart {
                const dst = new CombinationPart();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted CombinationPart but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as CombinationPart_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for CombinationPart but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.lcaseGuid !== undefined && src.lcaseGuid !== null) {
                    if (typeof src.lcaseGuid === "string") {
                        dst.lcaseGuid = src.lcaseGuid;
                    }
                    else {
                        console.log('Expected lcaseGuid of CombinationPart to be a string but was ', typeof src.lcaseGuid, src.lcaseGuid)
                    }
                }
                if (src.coefficients !== undefined && src.coefficients !== null) {
                    if (Array.isArray(src.coefficients)) {
                        for (const element of src.coefficients) {
                            dst.coefficients.push(ng.loadcombination.Coefficient.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected coefficients of CombinationPart to be a array but was ', typeof src.coefficients, src.coefficients)
                    }
                }
                if (src.favourablePermanentLoad !== undefined && src.favourablePermanentLoad !== null) {
                    if (typeof src.favourablePermanentLoad === "boolean") {
                        dst.favourablePermanentLoad = src.favourablePermanentLoad;
                    }
                    else {
                        console.log('Expected favourablePermanentLoad of CombinationPart to be a boolean but was ', typeof src.favourablePermanentLoad, src.favourablePermanentLoad)
                    }
                }
                return dst;
            }

            static toObject(src: CombinationPart | null | undefined): CombinationPart_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.CombinationPart is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.CombinationPart") {
                    console.error('Expected ng.loadcombination.CombinationPart but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : CombinationPart_json = {
                    lcaseGuid: src.lcaseGuid,
                    coefficients: new Array<ng.loadcombination.Coefficient_json>(),
                    favourablePermanentLoad: src.favourablePermanentLoad,
                };
                if (src.coefficients !== null) {
                    for (const element of src.coefficients) {
                        const parsed = ng.loadcombination.Coefficient.toObject(element);
                        if(parsed === null) return null;
                        dst.coefficients.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: CombinationPart_createType) {
                const dst = new CombinationPart();
                if (src === undefined) {
                    return dst;
                }
                if (src.lcaseGuid !== undefined) {
                    dst.lcaseGuid = src.lcaseGuid;
                }
                if (src.coefficients !== undefined) {
                    dst.coefficients = src.coefficients;
                }
                if (src.favourablePermanentLoad !== undefined) {
                    dst.favourablePermanentLoad = src.favourablePermanentLoad;
                }
                return dst;
            }

            shallowClone() {
                const dst = new CombinationPart();
                dst.lcaseGuid = this.lcaseGuid;
                dst.coefficients = this.coefficients;
                dst.favourablePermanentLoad = this.favourablePermanentLoad;
                return dst;
            }

            deepClone() {
                const json = CombinationPart.toObject(this);
                const dst = CombinationPart.fromObject(json);
                return dst;
            }
        }
        export type ICombinationPart = CombinationPart;


        export type BeamConfiguration_keys = 'secondOrder' | 'psi2';
        export interface BeamConfiguration_createType {
            secondOrder?: boolean,
            psi2?: number,
        }
        export interface BeamConfiguration_json {
            secondOrder?: boolean;
            psi2?: JsonNumber;
        }
        interface BeamConfiguration_json_in {
            __proto_name?: unknown;
            secondOrder?: unknown;
            psi2?: unknown;
        }
        export class BeamConfiguration {
            __proto_name = "ng.loadcombination.BeamConfiguration";
            secondOrder: boolean = false;
            psi2: number = 0;

            static fromObject(src_unknown: unknown): BeamConfiguration {
                const dst = new BeamConfiguration();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted BeamConfiguration but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as BeamConfiguration_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for BeamConfiguration but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.secondOrder !== undefined && src.secondOrder !== null) {
                    if (typeof src.secondOrder === "boolean") {
                        dst.secondOrder = src.secondOrder;
                    }
                    else {
                        console.log('Expected secondOrder of BeamConfiguration to be a boolean but was ', typeof src.secondOrder, src.secondOrder)
                    }
                }
                if (src.psi2 !== undefined && src.psi2 !== null) {
                    if (typeof src.psi2 === "number" || src.psi2 === 'NaN' || src.psi2 === 'Infinity' || src.psi2 === '-Infinity') {
                        dst.psi2 = AsNum(src.psi2);
                    }
                    else {
                        console.log('Expected psi2 of BeamConfiguration to be a number but was ', typeof src.psi2, src.psi2)
                    }
                }
                return dst;
            }

            static toObject(src: BeamConfiguration | null | undefined): BeamConfiguration_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.BeamConfiguration is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.BeamConfiguration") {
                    console.error('Expected ng.loadcombination.BeamConfiguration but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : BeamConfiguration_json = {
                    secondOrder: src.secondOrder,
                    psi2: AsJsonNum(src.psi2),
                };
                return dst;
            }

            static create(src?: BeamConfiguration_createType) {
                const dst = new BeamConfiguration();
                if (src === undefined) {
                    return dst;
                }
                if (src.secondOrder !== undefined) {
                    dst.secondOrder = src.secondOrder;
                }
                if (src.psi2 !== undefined) {
                    dst.psi2 = src.psi2;
                }
                return dst;
            }

            shallowClone() {
                const dst = new BeamConfiguration();
                dst.secondOrder = this.secondOrder;
                dst.psi2 = this.psi2;
                return dst;
            }

            deepClone() {
                const json = BeamConfiguration.toObject(this);
                const dst = BeamConfiguration.fromObject(json);
                return dst;
            }
        }
        export type IBeamConfiguration = BeamConfiguration;


        export type FoundationConfiguration_keys = 'groundWaterGuid';
        export interface FoundationConfiguration_createType {
            groundWaterGuid?: string,
        }
        export interface FoundationConfiguration_json {
            groundWaterGuid?: string;
        }
        interface FoundationConfiguration_json_in {
            __proto_name?: unknown;
            groundWaterGuid?: unknown;
        }
        export class FoundationConfiguration {
            __proto_name = "ng.loadcombination.FoundationConfiguration";
            groundWaterGuid: string = "";

            static fromObject(src_unknown: unknown): FoundationConfiguration {
                const dst = new FoundationConfiguration();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted FoundationConfiguration but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as FoundationConfiguration_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for FoundationConfiguration but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.groundWaterGuid !== undefined && src.groundWaterGuid !== null) {
                    if (typeof src.groundWaterGuid === "string") {
                        dst.groundWaterGuid = src.groundWaterGuid;
                    }
                    else {
                        console.log('Expected groundWaterGuid of FoundationConfiguration to be a string but was ', typeof src.groundWaterGuid, src.groundWaterGuid)
                    }
                }
                return dst;
            }

            static toObject(src: FoundationConfiguration | null | undefined): FoundationConfiguration_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.FoundationConfiguration is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.FoundationConfiguration") {
                    console.error('Expected ng.loadcombination.FoundationConfiguration but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : FoundationConfiguration_json = {
                    groundWaterGuid: src.groundWaterGuid,
                };
                return dst;
            }

            static create(src?: FoundationConfiguration_createType) {
                const dst = new FoundationConfiguration();
                if (src === undefined) {
                    return dst;
                }
                if (src.groundWaterGuid !== undefined) {
                    dst.groundWaterGuid = src.groundWaterGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new FoundationConfiguration();
                dst.groundWaterGuid = this.groundWaterGuid;
                return dst;
            }

            deepClone() {
                const json = FoundationConfiguration.toObject(this);
                const dst = FoundationConfiguration.fromObject(json);
                return dst;
            }
        }
        export type IFoundationConfiguration = FoundationConfiguration;


        export type ActiveEarthPressureConfiguration_keys = 'activeEarthPressureType' | 'compaction' | 'overload' | 'activeGroundWaterGuid';
        export interface ActiveEarthPressureConfiguration_createType {
            activeEarthPressureType?: ng.design.soil.ActiveEarthPressureType,
            compaction?: ng.loadcombination.Compaction | null,
            overload?: boolean,
            activeGroundWaterGuid?: string,
        }
        export interface ActiveEarthPressureConfiguration_json {
            activeEarthPressureType?: string;
            compaction?: ng.loadcombination.Compaction_json;
            overload?: boolean;
            activeGroundWaterGuid?: string;
        }
        interface ActiveEarthPressureConfiguration_json_in {
            __proto_name?: unknown;
            activeEarthPressureType?: unknown;
            compaction?: unknown;
            overload?: unknown;
            activeGroundWaterGuid?: unknown;
        }
        export class ActiveEarthPressureConfiguration {
            __proto_name = "ng.loadcombination.ActiveEarthPressureConfiguration";
            activeEarthPressureType: ng.design.soil.ActiveEarthPressureType = ng.design.soil.ActiveEarthPressureType.ACTIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED;
            compaction: ng.loadcombination.Compaction | null = null;
            overload: boolean = false;
            activeGroundWaterGuid: string = "";

            static fromObject(src_unknown: unknown): ActiveEarthPressureConfiguration {
                const dst = new ActiveEarthPressureConfiguration();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ActiveEarthPressureConfiguration but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ActiveEarthPressureConfiguration_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ActiveEarthPressureConfiguration but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.activeEarthPressureType !== undefined && src.activeEarthPressureType !== null) {
                    dst.activeEarthPressureType = ng.design.soil.ActiveEarthPressureType_FromObject(src.activeEarthPressureType);
                }
                if (src.compaction !== undefined && src.compaction !== null) {
                    dst.compaction = ng.loadcombination.Compaction.fromObject(src.compaction);
                }
                if (src.overload !== undefined && src.overload !== null) {
                    if (typeof src.overload === "boolean") {
                        dst.overload = src.overload;
                    }
                    else {
                        console.log('Expected overload of ActiveEarthPressureConfiguration to be a boolean but was ', typeof src.overload, src.overload)
                    }
                }
                if (src.activeGroundWaterGuid !== undefined && src.activeGroundWaterGuid !== null) {
                    if (typeof src.activeGroundWaterGuid === "string") {
                        dst.activeGroundWaterGuid = src.activeGroundWaterGuid;
                    }
                    else {
                        console.log('Expected activeGroundWaterGuid of ActiveEarthPressureConfiguration to be a string but was ', typeof src.activeGroundWaterGuid, src.activeGroundWaterGuid)
                    }
                }
                return dst;
            }

            static toObject(src: ActiveEarthPressureConfiguration | null | undefined): ActiveEarthPressureConfiguration_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.ActiveEarthPressureConfiguration is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.ActiveEarthPressureConfiguration") {
                    console.error('Expected ng.loadcombination.ActiveEarthPressureConfiguration but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const activeEarthPressureType_obj = ng.design.soil.ActiveEarthPressureType_ToObject(src.activeEarthPressureType);
                if(activeEarthPressureType_obj === null) return null;

                const dst : ActiveEarthPressureConfiguration_json = {
                    activeEarthPressureType: activeEarthPressureType_obj,
                    overload: src.overload,
                    activeGroundWaterGuid: src.activeGroundWaterGuid,
                };
                if(src.compaction !== null)
                {
                    const parsed = ng.loadcombination.Compaction.toObject(src.compaction);
                    if(parsed === null) return null;
                    dst.compaction = parsed;
                }
                return dst;
            }

            static create(src?: ActiveEarthPressureConfiguration_createType) {
                const dst = new ActiveEarthPressureConfiguration();
                if (src === undefined) {
                    return dst;
                }
                if (src.activeEarthPressureType !== undefined) {
                    dst.activeEarthPressureType = src.activeEarthPressureType;
                }
                if (src.compaction !== undefined) {
                    dst.compaction = src.compaction;
                }
                if (src.overload !== undefined) {
                    dst.overload = src.overload;
                }
                if (src.activeGroundWaterGuid !== undefined) {
                    dst.activeGroundWaterGuid = src.activeGroundWaterGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ActiveEarthPressureConfiguration();
                dst.activeEarthPressureType = this.activeEarthPressureType;
                dst.compaction = this.compaction;
                dst.overload = this.overload;
                dst.activeGroundWaterGuid = this.activeGroundWaterGuid;
                return dst;
            }

            deepClone() {
                const json = ActiveEarthPressureConfiguration.toObject(this);
                const dst = ActiveEarthPressureConfiguration.fromObject(json);
                return dst;
            }
        }
        export type IActiveEarthPressureConfiguration = ActiveEarthPressureConfiguration;


        export type PassiveEarthPressureConfiguration_keys = 'passiveEarthPressureType' | 'passiveGroundWaterGuid';
        export interface PassiveEarthPressureConfiguration_createType {
            passiveEarthPressureType?: ng.design.soil.PassiveEarthPressureType,
            passiveGroundWaterGuid?: string,
        }
        export interface PassiveEarthPressureConfiguration_json {
            passiveEarthPressureType?: string;
            passiveGroundWaterGuid?: string;
        }
        interface PassiveEarthPressureConfiguration_json_in {
            __proto_name?: unknown;
            passiveEarthPressureType?: unknown;
            passiveGroundWaterGuid?: unknown;
        }
        export class PassiveEarthPressureConfiguration {
            __proto_name = "ng.loadcombination.PassiveEarthPressureConfiguration";
            passiveEarthPressureType: ng.design.soil.PassiveEarthPressureType = ng.design.soil.PassiveEarthPressureType.PASSIVE_EARTH_PRESSURE_TYPE_UNSPECIFIED;
            passiveGroundWaterGuid: string = "";

            static fromObject(src_unknown: unknown): PassiveEarthPressureConfiguration {
                const dst = new PassiveEarthPressureConfiguration();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PassiveEarthPressureConfiguration but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PassiveEarthPressureConfiguration_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PassiveEarthPressureConfiguration but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.passiveEarthPressureType !== undefined && src.passiveEarthPressureType !== null) {
                    dst.passiveEarthPressureType = ng.design.soil.PassiveEarthPressureType_FromObject(src.passiveEarthPressureType);
                }
                if (src.passiveGroundWaterGuid !== undefined && src.passiveGroundWaterGuid !== null) {
                    if (typeof src.passiveGroundWaterGuid === "string") {
                        dst.passiveGroundWaterGuid = src.passiveGroundWaterGuid;
                    }
                    else {
                        console.log('Expected passiveGroundWaterGuid of PassiveEarthPressureConfiguration to be a string but was ', typeof src.passiveGroundWaterGuid, src.passiveGroundWaterGuid)
                    }
                }
                return dst;
            }

            static toObject(src: PassiveEarthPressureConfiguration | null | undefined): PassiveEarthPressureConfiguration_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.PassiveEarthPressureConfiguration is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.PassiveEarthPressureConfiguration") {
                    console.error('Expected ng.loadcombination.PassiveEarthPressureConfiguration but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const passiveEarthPressureType_obj = ng.design.soil.PassiveEarthPressureType_ToObject(src.passiveEarthPressureType);
                if(passiveEarthPressureType_obj === null) return null;

                const dst : PassiveEarthPressureConfiguration_json = {
                    passiveEarthPressureType: passiveEarthPressureType_obj,
                    passiveGroundWaterGuid: src.passiveGroundWaterGuid,
                };
                return dst;
            }

            static create(src?: PassiveEarthPressureConfiguration_createType) {
                const dst = new PassiveEarthPressureConfiguration();
                if (src === undefined) {
                    return dst;
                }
                if (src.passiveEarthPressureType !== undefined) {
                    dst.passiveEarthPressureType = src.passiveEarthPressureType;
                }
                if (src.passiveGroundWaterGuid !== undefined) {
                    dst.passiveGroundWaterGuid = src.passiveGroundWaterGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PassiveEarthPressureConfiguration();
                dst.passiveEarthPressureType = this.passiveEarthPressureType;
                dst.passiveGroundWaterGuid = this.passiveGroundWaterGuid;
                return dst;
            }

            deepClone() {
                const json = PassiveEarthPressureConfiguration.toObject(this);
                const dst = PassiveEarthPressureConfiguration.fromObject(json);
                return dst;
            }
        }
        export type IPassiveEarthPressureConfiguration = PassiveEarthPressureConfiguration;


        export type EarthPressureConfiguration_keys = 'active' | 'passive';
        export interface EarthPressureConfiguration_createType {
            active?: ng.loadcombination.ActiveEarthPressureConfiguration | null,
            passive?: ng.loadcombination.PassiveEarthPressureConfiguration | null,
        }
        export interface EarthPressureConfiguration_json {
            active?: ng.loadcombination.ActiveEarthPressureConfiguration_json;
            passive?: ng.loadcombination.PassiveEarthPressureConfiguration_json;
        }
        interface EarthPressureConfiguration_json_in {
            __proto_name?: unknown;
            active?: unknown;
            passive?: unknown;
        }
        export class EarthPressureConfiguration {
            __proto_name = "ng.loadcombination.EarthPressureConfiguration";
            active: ng.loadcombination.ActiveEarthPressureConfiguration | null = null;
            passive: ng.loadcombination.PassiveEarthPressureConfiguration | null = null;

            static fromObject(src_unknown: unknown): EarthPressureConfiguration {
                const dst = new EarthPressureConfiguration();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted EarthPressureConfiguration but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as EarthPressureConfiguration_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for EarthPressureConfiguration but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.active !== undefined && src.active !== null) {
                    dst.active = ng.loadcombination.ActiveEarthPressureConfiguration.fromObject(src.active);
                }
                if (src.passive !== undefined && src.passive !== null) {
                    dst.passive = ng.loadcombination.PassiveEarthPressureConfiguration.fromObject(src.passive);
                }
                return dst;
            }

            static toObject(src: EarthPressureConfiguration | null | undefined): EarthPressureConfiguration_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.EarthPressureConfiguration is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.EarthPressureConfiguration") {
                    console.error('Expected ng.loadcombination.EarthPressureConfiguration but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : EarthPressureConfiguration_json = {
                };
                if(src.active !== null)
                {
                    const parsed = ng.loadcombination.ActiveEarthPressureConfiguration.toObject(src.active);
                    if(parsed === null) return null;
                    dst.active = parsed;
                }
                if(src.passive !== null)
                {
                    const parsed = ng.loadcombination.PassiveEarthPressureConfiguration.toObject(src.passive);
                    if(parsed === null) return null;
                    dst.passive = parsed;
                }
                return dst;
            }

            static create(src?: EarthPressureConfiguration_createType) {
                const dst = new EarthPressureConfiguration();
                if (src === undefined) {
                    return dst;
                }
                if (src.active !== undefined) {
                    dst.active = src.active;
                }
                if (src.passive !== undefined) {
                    dst.passive = src.passive;
                }
                return dst;
            }

            shallowClone() {
                const dst = new EarthPressureConfiguration();
                dst.active = this.active;
                dst.passive = this.passive;
                return dst;
            }

            deepClone() {
                const json = EarthPressureConfiguration.toObject(this);
                const dst = EarthPressureConfiguration.fromObject(json);
                return dst;
            }
        }
        export type IEarthPressureConfiguration = EarthPressureConfiguration;


        export type PileConfiguration_keys = 'isNegative' | 'groundWaterGuid';
        export interface PileConfiguration_createType {
            isNegative?: boolean,
            groundWaterGuid?: string,
        }
        export interface PileConfiguration_json {
            isNegative?: boolean;
            groundWaterGuid?: string;
        }
        interface PileConfiguration_json_in {
            __proto_name?: unknown;
            isNegative?: unknown;
            groundWaterGuid?: unknown;
        }
        export class PileConfiguration {
            __proto_name = "ng.loadcombination.PileConfiguration";
            isNegative: boolean = false;
            groundWaterGuid: string = "";

            static fromObject(src_unknown: unknown): PileConfiguration {
                const dst = new PileConfiguration();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PileConfiguration but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PileConfiguration_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PileConfiguration but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.isNegative !== undefined && src.isNegative !== null) {
                    if (typeof src.isNegative === "boolean") {
                        dst.isNegative = src.isNegative;
                    }
                    else {
                        console.log('Expected isNegative of PileConfiguration to be a boolean but was ', typeof src.isNegative, src.isNegative)
                    }
                }
                if (src.groundWaterGuid !== undefined && src.groundWaterGuid !== null) {
                    if (typeof src.groundWaterGuid === "string") {
                        dst.groundWaterGuid = src.groundWaterGuid;
                    }
                    else {
                        console.log('Expected groundWaterGuid of PileConfiguration to be a string but was ', typeof src.groundWaterGuid, src.groundWaterGuid)
                    }
                }
                return dst;
            }

            static toObject(src: PileConfiguration | null | undefined): PileConfiguration_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.PileConfiguration is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.PileConfiguration") {
                    console.error('Expected ng.loadcombination.PileConfiguration but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PileConfiguration_json = {
                    isNegative: src.isNegative,
                    groundWaterGuid: src.groundWaterGuid,
                };
                return dst;
            }

            static create(src?: PileConfiguration_createType) {
                const dst = new PileConfiguration();
                if (src === undefined) {
                    return dst;
                }
                if (src.isNegative !== undefined) {
                    dst.isNegative = src.isNegative;
                }
                if (src.groundWaterGuid !== undefined) {
                    dst.groundWaterGuid = src.groundWaterGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PileConfiguration();
                dst.isNegative = this.isNegative;
                dst.groundWaterGuid = this.groundWaterGuid;
                return dst;
            }

            deepClone() {
                const json = PileConfiguration.toObject(this);
                const dst = PileConfiguration.fromObject(json);
                return dst;
            }
        }
        export type IPileConfiguration = PileConfiguration;


        export type Compaction_keys = 'zp' | 'pcmax';
        export interface Compaction_createType {
            zp?: number,
            pcmax?: number,
        }
        export interface Compaction_json {
            zp?: JsonNumber;
            pcmax?: JsonNumber;
        }
        interface Compaction_json_in {
            __proto_name?: unknown;
            zp?: unknown;
            pcmax?: unknown;
        }
        export class Compaction {
            __proto_name = "ng.loadcombination.Compaction";
            zp: number = 0;
            pcmax: number = 0;

            static fromObject(src_unknown: unknown): Compaction {
                const dst = new Compaction();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Compaction but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Compaction_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Compaction but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.zp !== undefined && src.zp !== null) {
                    if (typeof src.zp === "number" || src.zp === 'NaN' || src.zp === 'Infinity' || src.zp === '-Infinity') {
                        dst.zp = AsNum(src.zp);
                    }
                    else {
                        console.log('Expected zp of Compaction to be a number but was ', typeof src.zp, src.zp)
                    }
                }
                if (src.pcmax !== undefined && src.pcmax !== null) {
                    if (typeof src.pcmax === "number" || src.pcmax === 'NaN' || src.pcmax === 'Infinity' || src.pcmax === '-Infinity') {
                        dst.pcmax = AsNum(src.pcmax);
                    }
                    else {
                        console.log('Expected pcmax of Compaction to be a number but was ', typeof src.pcmax, src.pcmax)
                    }
                }
                return dst;
            }

            static toObject(src: Compaction | null | undefined): Compaction_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.Compaction is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.Compaction") {
                    console.error('Expected ng.loadcombination.Compaction but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Compaction_json = {
                    zp: AsJsonNum(src.zp),
                    pcmax: AsJsonNum(src.pcmax),
                };
                return dst;
            }

            static create(src?: Compaction_createType) {
                const dst = new Compaction();
                if (src === undefined) {
                    return dst;
                }
                if (src.zp !== undefined) {
                    dst.zp = src.zp;
                }
                if (src.pcmax !== undefined) {
                    dst.pcmax = src.pcmax;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Compaction();
                dst.zp = this.zp;
                dst.pcmax = this.pcmax;
                return dst;
            }

            deepClone() {
                const json = Compaction.toObject(this);
                const dst = Compaction.fromObject(json);
                return dst;
            }
        }
        export type ICompaction = Compaction;


        export type Coefficient_keys = 'value' | 'type';
        export interface Coefficient_createType {
            value?: number,
            type?: ng.loadcombination.CoefficientType,
        }
        export interface Coefficient_json {
            value?: JsonNumber;
            type?: string;
        }
        interface Coefficient_json_in {
            __proto_name?: unknown;
            value?: unknown;
            type?: unknown;
        }
        export class Coefficient {
            __proto_name = "ng.loadcombination.Coefficient";
            value: number = 0;
            type: ng.loadcombination.CoefficientType = ng.loadcombination.CoefficientType.COEFFICIENT_TYPE_UNSPECIFIED;

            static fromObject(src_unknown: unknown): Coefficient {
                const dst = new Coefficient();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Coefficient but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Coefficient_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Coefficient but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.value !== undefined && src.value !== null) {
                    if (typeof src.value === "number" || src.value === 'NaN' || src.value === 'Infinity' || src.value === '-Infinity') {
                        dst.value = AsNum(src.value);
                    }
                    else {
                        console.log('Expected value of Coefficient to be a number but was ', typeof src.value, src.value)
                    }
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.loadcombination.CoefficientType_FromObject(src.type);
                }
                return dst;
            }

            static toObject(src: Coefficient | null | undefined): Coefficient_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.Coefficient is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.Coefficient") {
                    console.error('Expected ng.loadcombination.Coefficient but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.loadcombination.CoefficientType_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : Coefficient_json = {
                    value: AsJsonNum(src.value),
                    type: type_obj,
                };
                return dst;
            }

            static create(src?: Coefficient_createType) {
                const dst = new Coefficient();
                if (src === undefined) {
                    return dst;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Coefficient();
                dst.value = this.value;
                dst.type = this.type;
                return dst;
            }

            deepClone() {
                const json = Coefficient.toObject(this);
                const dst = Coefficient.fromObject(json);
                return dst;
            }
        }
        export type ICoefficient = Coefficient;


        export type Data_keys = 'id' | 'type' | 'limitState' | 'dependentLcombGuid' | 'parts' | 'coa' | 'deactive' | 'description' | 'geoType' | 'kfi' | 'beamConfig' | 'foundationConfig' | 'earthPressureConfig' | 'pileConfig' | 'dominatingLcaseGuid' | 'userDefined';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            type?: ng.loadcombination.Type,
            limitState?: ng.loadcombination.LimitState,
            dependentLcombGuid?: string,
            parts?: ng.loadcombination.CombinationPart[],
            coa?: ng.loadcombination.CoaType,
            deactive?: boolean,
            description?: string,
            geoType?: ng.loadcombination.GeoType,
            kfi?: number,
            beamConfig?: ng.loadcombination.BeamConfiguration | null,
            foundationConfig?: ng.loadcombination.FoundationConfiguration | null,
            earthPressureConfig?: ng.loadcombination.EarthPressureConfiguration | null,
            pileConfig?: ng.loadcombination.PileConfiguration | null,
            dominatingLcaseGuid?: string,
            userDefined?: boolean,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            type?: string;
            limitState?: string;
            dependentLcombGuid?: string;
            parts: ng.loadcombination.CombinationPart_json[];
            coa?: string;
            deactive?: boolean;
            description?: string;
            geoType?: string;
            kfi?: JsonNumber;
            beamConfig?: ng.loadcombination.BeamConfiguration_json;
            foundationConfig?: ng.loadcombination.FoundationConfiguration_json;
            earthPressureConfig?: ng.loadcombination.EarthPressureConfiguration_json;
            pileConfig?: ng.loadcombination.PileConfiguration_json;
            dominatingLcaseGuid?: string;
            userDefined?: boolean;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            type?: unknown;
            limitState?: unknown;
            dependentLcombGuid?: unknown;
            parts?: unknown;
            coa?: unknown;
            deactive?: unknown;
            description?: unknown;
            geoType?: unknown;
            kfi?: unknown;
            beamConfig?: unknown;
            foundationConfig?: unknown;
            earthPressureConfig?: unknown;
            pileConfig?: unknown;
            dominatingLcaseGuid?: unknown;
            userDefined?: unknown;
        }
        export class Data {
            __proto_name = "ng.loadcombination.Data";
            id: ng.utils.ID | null = null;
            type: ng.loadcombination.Type = ng.loadcombination.Type.TYPE_UNSPECIFIED;
            limitState: ng.loadcombination.LimitState = ng.loadcombination.LimitState.LIMIT_STATE_UNSPECIFIED;
            dependentLcombGuid: string = "";
            parts: ng.loadcombination.CombinationPart[] = [];
            coa: ng.loadcombination.CoaType = ng.loadcombination.CoaType.COA_TYPE_UNSPECIFIED;
            deactive: boolean = false;
            description: string = "";
            geoType: ng.loadcombination.GeoType = ng.loadcombination.GeoType.GEO_TYPE_UNSPECIFIED;
            kfi: number = 0;
            beamConfig: ng.loadcombination.BeamConfiguration | null = null;
            foundationConfig: ng.loadcombination.FoundationConfiguration | null = null;
            earthPressureConfig: ng.loadcombination.EarthPressureConfiguration | null = null;
            pileConfig: ng.loadcombination.PileConfiguration | null = null;
            dominatingLcaseGuid: string = "";
            userDefined: boolean = false;

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.loadcombination.Type_FromObject(src.type);
                }
                if (src.limitState !== undefined && src.limitState !== null) {
                    dst.limitState = ng.loadcombination.LimitState_FromObject(src.limitState);
                }
                if (src.dependentLcombGuid !== undefined && src.dependentLcombGuid !== null) {
                    if (typeof src.dependentLcombGuid === "string") {
                        dst.dependentLcombGuid = src.dependentLcombGuid;
                    }
                    else {
                        console.log('Expected dependentLcombGuid of Data to be a string but was ', typeof src.dependentLcombGuid, src.dependentLcombGuid)
                    }
                }
                if (src.parts !== undefined && src.parts !== null) {
                    if (Array.isArray(src.parts)) {
                        for (const element of src.parts) {
                            dst.parts.push(ng.loadcombination.CombinationPart.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected parts of Data to be a array but was ', typeof src.parts, src.parts)
                    }
                }
                if (src.coa !== undefined && src.coa !== null) {
                    dst.coa = ng.loadcombination.CoaType_FromObject(src.coa);
                }
                if (src.deactive !== undefined && src.deactive !== null) {
                    if (typeof src.deactive === "boolean") {
                        dst.deactive = src.deactive;
                    }
                    else {
                        console.log('Expected deactive of Data to be a boolean but was ', typeof src.deactive, src.deactive)
                    }
                }
                if (src.description !== undefined && src.description !== null) {
                    if (typeof src.description === "string") {
                        dst.description = src.description;
                    }
                    else {
                        console.log('Expected description of Data to be a string but was ', typeof src.description, src.description)
                    }
                }
                if (src.geoType !== undefined && src.geoType !== null) {
                    dst.geoType = ng.loadcombination.GeoType_FromObject(src.geoType);
                }
                if (src.kfi !== undefined && src.kfi !== null) {
                    if (typeof src.kfi === "number" || src.kfi === 'NaN' || src.kfi === 'Infinity' || src.kfi === '-Infinity') {
                        dst.kfi = AsNum(src.kfi);
                    }
                    else {
                        console.log('Expected kfi of Data to be a number but was ', typeof src.kfi, src.kfi)
                    }
                }
                if (src.beamConfig !== undefined && src.beamConfig !== null) {
                    dst.beamConfig = ng.loadcombination.BeamConfiguration.fromObject(src.beamConfig);
                }
                if (src.foundationConfig !== undefined && src.foundationConfig !== null) {
                    dst.foundationConfig = ng.loadcombination.FoundationConfiguration.fromObject(src.foundationConfig);
                }
                if (src.earthPressureConfig !== undefined && src.earthPressureConfig !== null) {
                    dst.earthPressureConfig = ng.loadcombination.EarthPressureConfiguration.fromObject(src.earthPressureConfig);
                }
                if (src.pileConfig !== undefined && src.pileConfig !== null) {
                    dst.pileConfig = ng.loadcombination.PileConfiguration.fromObject(src.pileConfig);
                }
                if (src.dominatingLcaseGuid !== undefined && src.dominatingLcaseGuid !== null) {
                    if (typeof src.dominatingLcaseGuid === "string") {
                        dst.dominatingLcaseGuid = src.dominatingLcaseGuid;
                    }
                    else {
                        console.log('Expected dominatingLcaseGuid of Data to be a string but was ', typeof src.dominatingLcaseGuid, src.dominatingLcaseGuid)
                    }
                }
                if (src.userDefined !== undefined && src.userDefined !== null) {
                    if (typeof src.userDefined === "boolean") {
                        dst.userDefined = src.userDefined;
                    }
                    else {
                        console.log('Expected userDefined of Data to be a boolean but was ', typeof src.userDefined, src.userDefined)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination.Data") {
                    console.error('Expected ng.loadcombination.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.loadcombination.Type_ToObject(src.type);
                if(type_obj === null) return null;

                const limitState_obj = ng.loadcombination.LimitState_ToObject(src.limitState);
                if(limitState_obj === null) return null;

                const coa_obj = ng.loadcombination.CoaType_ToObject(src.coa);
                if(coa_obj === null) return null;

                const geoType_obj = ng.loadcombination.GeoType_ToObject(src.geoType);
                if(geoType_obj === null) return null;

                const dst : Data_json = {
                    type: type_obj,
                    limitState: limitState_obj,
                    dependentLcombGuid: src.dependentLcombGuid,
                    parts: new Array<ng.loadcombination.CombinationPart_json>(),
                    coa: coa_obj,
                    deactive: src.deactive,
                    description: src.description,
                    geoType: geoType_obj,
                    kfi: AsJsonNum(src.kfi),
                    dominatingLcaseGuid: src.dominatingLcaseGuid,
                    userDefined: src.userDefined,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.parts !== null) {
                    for (const element of src.parts) {
                        const parsed = ng.loadcombination.CombinationPart.toObject(element);
                        if(parsed === null) return null;
                        dst.parts.push(parsed);
                    }
                }
                if(src.beamConfig !== null)
                {
                    const parsed = ng.loadcombination.BeamConfiguration.toObject(src.beamConfig);
                    if(parsed === null) return null;
                    dst.beamConfig = parsed;
                }
                if(src.foundationConfig !== null)
                {
                    const parsed = ng.loadcombination.FoundationConfiguration.toObject(src.foundationConfig);
                    if(parsed === null) return null;
                    dst.foundationConfig = parsed;
                }
                if(src.earthPressureConfig !== null)
                {
                    const parsed = ng.loadcombination.EarthPressureConfiguration.toObject(src.earthPressureConfig);
                    if(parsed === null) return null;
                    dst.earthPressureConfig = parsed;
                }
                if(src.pileConfig !== null)
                {
                    const parsed = ng.loadcombination.PileConfiguration.toObject(src.pileConfig);
                    if(parsed === null) return null;
                    dst.pileConfig = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.limitState !== undefined) {
                    dst.limitState = src.limitState;
                }
                if (src.dependentLcombGuid !== undefined) {
                    dst.dependentLcombGuid = src.dependentLcombGuid;
                }
                if (src.parts !== undefined) {
                    dst.parts = src.parts;
                }
                if (src.coa !== undefined) {
                    dst.coa = src.coa;
                }
                if (src.deactive !== undefined) {
                    dst.deactive = src.deactive;
                }
                if (src.description !== undefined) {
                    dst.description = src.description;
                }
                if (src.geoType !== undefined) {
                    dst.geoType = src.geoType;
                }
                if (src.kfi !== undefined) {
                    dst.kfi = src.kfi;
                }
                if (src.beamConfig !== undefined) {
                    dst.beamConfig = src.beamConfig;
                }
                if (src.foundationConfig !== undefined) {
                    dst.foundationConfig = src.foundationConfig;
                }
                if (src.earthPressureConfig !== undefined) {
                    dst.earthPressureConfig = src.earthPressureConfig;
                }
                if (src.pileConfig !== undefined) {
                    dst.pileConfig = src.pileConfig;
                }
                if (src.dominatingLcaseGuid !== undefined) {
                    dst.dominatingLcaseGuid = src.dominatingLcaseGuid;
                }
                if (src.userDefined !== undefined) {
                    dst.userDefined = src.userDefined;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.type = this.type;
                dst.limitState = this.limitState;
                dst.dependentLcombGuid = this.dependentLcombGuid;
                dst.parts = this.parts;
                dst.coa = this.coa;
                dst.deactive = this.deactive;
                dst.description = this.description;
                dst.geoType = this.geoType;
                dst.kfi = this.kfi;
                dst.beamConfig = this.beamConfig;
                dst.foundationConfig = this.foundationConfig;
                dst.earthPressureConfig = this.earthPressureConfig;
                dst.pileConfig = this.pileConfig;
                dst.dominatingLcaseGuid = this.dominatingLcaseGuid;
                dst.userDefined = this.userDefined;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace loadcombination


    // Defined in Loading/loadcase.proto
    export namespace loadcase {
        export enum DurationClass {
            DURATION_CLASS_UNSPECIFIED = 0,
            DURATION_CLASS_PERMANENT = 1,
            DURATION_CLASS_LONG = 2,
            DURATION_CLASS_MEDIUM = 3,
            DURATION_CLASS_SHORT = 4,
            DURATION_CLASS_INSTANTANEOUS = 5
        }
        export const DurationClass_FromObject = (src: unknown): DurationClass => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DURATION_CLASS_UNSPECIFIED':
                    return DurationClass.DURATION_CLASS_UNSPECIFIED;
                case 1:
                case 'DURATION_CLASS_PERMANENT':
                    return DurationClass.DURATION_CLASS_PERMANENT;
                case 2:
                case 'DURATION_CLASS_LONG':
                    return DurationClass.DURATION_CLASS_LONG;
                case 3:
                case 'DURATION_CLASS_MEDIUM':
                    return DurationClass.DURATION_CLASS_MEDIUM;
                case 4:
                case 'DURATION_CLASS_SHORT':
                    return DurationClass.DURATION_CLASS_SHORT;
                case 5:
                case 'DURATION_CLASS_INSTANTANEOUS':
                    return DurationClass.DURATION_CLASS_INSTANTANEOUS;
                default:
                    console.log('Unhandled value for DurationClass:' + src + '. ' + typeof(src));
                    return DurationClass.DURATION_CLASS_UNSPECIFIED;
            }
        };
        export const DurationClass_ToObject = (src: DurationClass): string | null => {
            switch (src) {
                case DurationClass.DURATION_CLASS_UNSPECIFIED:
                    return 'DURATION_CLASS_UNSPECIFIED';
                case DurationClass.DURATION_CLASS_PERMANENT:
                    return 'DURATION_CLASS_PERMANENT';
                case DurationClass.DURATION_CLASS_LONG:
                    return 'DURATION_CLASS_LONG';
                case DurationClass.DURATION_CLASS_MEDIUM:
                    return 'DURATION_CLASS_MEDIUM';
                case DurationClass.DURATION_CLASS_SHORT:
                    return 'DURATION_CLASS_SHORT';
                case DurationClass.DURATION_CLASS_INSTANTANEOUS:
                    return 'DURATION_CLASS_INSTANTANEOUS';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for DurationClass, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum Type {
            TYPE_UNSPECIFIED = 0,
            TYPE_PERMANENT_LOAD = 1,
            TYPE_IMPOSED_LOAD = 2,
            TYPE_WIND_LOAD = 3,
            TYPE_SNOW_LOAD = 4,
            TYPE_ICE_LOAD = 5,
            TYPE_SOIL_LOAD = 6,
            TYPE_ACCIDENT_LOAD = 7,
            TYPE_SEISMIC_LOAD = 8,
            TYPE_TEMPERATURE_LOAD = 9,
            TYPE_SELF_WEIGHT = 10,
            TYPE_SOIL_SELF_WEIGHT = 11,
            TYPE_CONSTRUCTION_LOAD = 12,
            TYPE_PERMANENT_VARIABLE_LOAD = 13
        }
        export const Type_FromObject = (src: unknown): Type => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'TYPE_UNSPECIFIED':
                    return Type.TYPE_UNSPECIFIED;
                case 1:
                case 'TYPE_PERMANENT_LOAD':
                    return Type.TYPE_PERMANENT_LOAD;
                case 2:
                case 'TYPE_IMPOSED_LOAD':
                    return Type.TYPE_IMPOSED_LOAD;
                case 3:
                case 'TYPE_WIND_LOAD':
                    return Type.TYPE_WIND_LOAD;
                case 4:
                case 'TYPE_SNOW_LOAD':
                    return Type.TYPE_SNOW_LOAD;
                case 5:
                case 'TYPE_ICE_LOAD':
                    return Type.TYPE_ICE_LOAD;
                case 6:
                case 'TYPE_SOIL_LOAD':
                    return Type.TYPE_SOIL_LOAD;
                case 7:
                case 'TYPE_ACCIDENT_LOAD':
                    return Type.TYPE_ACCIDENT_LOAD;
                case 8:
                case 'TYPE_SEISMIC_LOAD':
                    return Type.TYPE_SEISMIC_LOAD;
                case 9:
                case 'TYPE_TEMPERATURE_LOAD':
                    return Type.TYPE_TEMPERATURE_LOAD;
                case 10:
                case 'TYPE_SELF_WEIGHT':
                    return Type.TYPE_SELF_WEIGHT;
                case 11:
                case 'TYPE_SOIL_SELF_WEIGHT':
                    return Type.TYPE_SOIL_SELF_WEIGHT;
                case 12:
                case 'TYPE_CONSTRUCTION_LOAD':
                    return Type.TYPE_CONSTRUCTION_LOAD;
                case 13:
                case 'TYPE_PERMANENT_VARIABLE_LOAD':
                    return Type.TYPE_PERMANENT_VARIABLE_LOAD;
                default:
                    console.log('Unhandled value for Type:' + src + '. ' + typeof(src));
                    return Type.TYPE_UNSPECIFIED;
            }
        };
        export const Type_ToObject = (src: Type): string | null => {
            switch (src) {
                case Type.TYPE_UNSPECIFIED:
                    return 'TYPE_UNSPECIFIED';
                case Type.TYPE_PERMANENT_LOAD:
                    return 'TYPE_PERMANENT_LOAD';
                case Type.TYPE_IMPOSED_LOAD:
                    return 'TYPE_IMPOSED_LOAD';
                case Type.TYPE_WIND_LOAD:
                    return 'TYPE_WIND_LOAD';
                case Type.TYPE_SNOW_LOAD:
                    return 'TYPE_SNOW_LOAD';
                case Type.TYPE_ICE_LOAD:
                    return 'TYPE_ICE_LOAD';
                case Type.TYPE_SOIL_LOAD:
                    return 'TYPE_SOIL_LOAD';
                case Type.TYPE_ACCIDENT_LOAD:
                    return 'TYPE_ACCIDENT_LOAD';
                case Type.TYPE_SEISMIC_LOAD:
                    return 'TYPE_SEISMIC_LOAD';
                case Type.TYPE_TEMPERATURE_LOAD:
                    return 'TYPE_TEMPERATURE_LOAD';
                case Type.TYPE_SELF_WEIGHT:
                    return 'TYPE_SELF_WEIGHT';
                case Type.TYPE_SOIL_SELF_WEIGHT:
                    return 'TYPE_SOIL_SELF_WEIGHT';
                case Type.TYPE_CONSTRUCTION_LOAD:
                    return 'TYPE_CONSTRUCTION_LOAD';
                case Type.TYPE_PERMANENT_VARIABLE_LOAD:
                    return 'TYPE_PERMANENT_VARIABLE_LOAD';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Type, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum Category {
            CATEGORY_UNSPECIFIED = 0,
            CATEGORY_A = 1,
            CATEGORY_B = 2,
            CATEGORY_C = 3,
            CATEGORY_D = 4,
            CATEGORY_E = 5,
            CATEGORY_F = 6,
            CATEGORY_G = 7,
            CATEGORY_H = 8,
            CATEGORY_G2 = 9,
            CATEGORY_I1 = 10,
            CATEGORY_I2 = 11,
            CATEGORY_I3 = 12,
            CATEGORY_K = 13,
            CATEGORY_S1 = 14,
            CATEGORY_S2 = 15,
            CATEGORY_S3_C_G = 16,
            CATEGORY_S3_H_K = 17,
            CATEGORY_T = 18
        }
        export const Category_FromObject = (src: unknown): Category => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'CATEGORY_UNSPECIFIED':
                    return Category.CATEGORY_UNSPECIFIED;
                case 1:
                case 'CATEGORY_A':
                    return Category.CATEGORY_A;
                case 2:
                case 'CATEGORY_B':
                    return Category.CATEGORY_B;
                case 3:
                case 'CATEGORY_C':
                    return Category.CATEGORY_C;
                case 4:
                case 'CATEGORY_D':
                    return Category.CATEGORY_D;
                case 5:
                case 'CATEGORY_E':
                    return Category.CATEGORY_E;
                case 6:
                case 'CATEGORY_F':
                    return Category.CATEGORY_F;
                case 7:
                case 'CATEGORY_G':
                    return Category.CATEGORY_G;
                case 8:
                case 'CATEGORY_H':
                    return Category.CATEGORY_H;
                case 9:
                case 'CATEGORY_G2':
                    return Category.CATEGORY_G2;
                case 10:
                case 'CATEGORY_I1':
                    return Category.CATEGORY_I1;
                case 11:
                case 'CATEGORY_I2':
                    return Category.CATEGORY_I2;
                case 12:
                case 'CATEGORY_I3':
                    return Category.CATEGORY_I3;
                case 13:
                case 'CATEGORY_K':
                    return Category.CATEGORY_K;
                case 14:
                case 'CATEGORY_S1':
                    return Category.CATEGORY_S1;
                case 15:
                case 'CATEGORY_S2':
                    return Category.CATEGORY_S2;
                case 16:
                case 'CATEGORY_S3_C_G':
                    return Category.CATEGORY_S3_C_G;
                case 17:
                case 'CATEGORY_S3_H_K':
                    return Category.CATEGORY_S3_H_K;
                case 18:
                case 'CATEGORY_T':
                    return Category.CATEGORY_T;
                default:
                    console.log('Unhandled value for Category:' + src + '. ' + typeof(src));
                    return Category.CATEGORY_UNSPECIFIED;
            }
        };
        export const Category_ToObject = (src: Category): string | null => {
            switch (src) {
                case Category.CATEGORY_UNSPECIFIED:
                    return 'CATEGORY_UNSPECIFIED';
                case Category.CATEGORY_A:
                    return 'CATEGORY_A';
                case Category.CATEGORY_B:
                    return 'CATEGORY_B';
                case Category.CATEGORY_C:
                    return 'CATEGORY_C';
                case Category.CATEGORY_D:
                    return 'CATEGORY_D';
                case Category.CATEGORY_E:
                    return 'CATEGORY_E';
                case Category.CATEGORY_F:
                    return 'CATEGORY_F';
                case Category.CATEGORY_G:
                    return 'CATEGORY_G';
                case Category.CATEGORY_H:
                    return 'CATEGORY_H';
                case Category.CATEGORY_G2:
                    return 'CATEGORY_G2';
                case Category.CATEGORY_I1:
                    return 'CATEGORY_I1';
                case Category.CATEGORY_I2:
                    return 'CATEGORY_I2';
                case Category.CATEGORY_I3:
                    return 'CATEGORY_I3';
                case Category.CATEGORY_K:
                    return 'CATEGORY_K';
                case Category.CATEGORY_S1:
                    return 'CATEGORY_S1';
                case Category.CATEGORY_S2:
                    return 'CATEGORY_S2';
                case Category.CATEGORY_S3_C_G:
                    return 'CATEGORY_S3_C_G';
                case Category.CATEGORY_S3_H_K:
                    return 'CATEGORY_S3_H_K';
                case Category.CATEGORY_T:
                    return 'CATEGORY_T';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Category, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Data_keys = 'id' | 'type' | 'durationClass' | 'category' | 'numberOfStoreys' | 'description';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            type?: ng.loadcase.Type,
            durationClass?: ng.loadcase.DurationClass,
            category?: ng.loadcase.Category,
            numberOfStoreys?: number,
            description?: string,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            type?: string;
            durationClass?: string;
            category?: string;
            numberOfStoreys?: JsonNumber;
            description?: string;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            type?: unknown;
            durationClass?: unknown;
            category?: unknown;
            numberOfStoreys?: unknown;
            description?: unknown;
        }
        export class Data {
            __proto_name = "ng.loadcase.Data";
            id: ng.utils.ID | null = null;
            type: ng.loadcase.Type = ng.loadcase.Type.TYPE_UNSPECIFIED;
            durationClass: ng.loadcase.DurationClass = ng.loadcase.DurationClass.DURATION_CLASS_UNSPECIFIED;
            category: ng.loadcase.Category = ng.loadcase.Category.CATEGORY_UNSPECIFIED;
            numberOfStoreys: number = 0;
            description: string = "";

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.loadcase.Type_FromObject(src.type);
                }
                if (src.durationClass !== undefined && src.durationClass !== null) {
                    dst.durationClass = ng.loadcase.DurationClass_FromObject(src.durationClass);
                }
                if (src.category !== undefined && src.category !== null) {
                    dst.category = ng.loadcase.Category_FromObject(src.category);
                }
                if (src.numberOfStoreys !== undefined && src.numberOfStoreys !== null) {
                    if (typeof src.numberOfStoreys === "number" || src.numberOfStoreys === 'NaN' || src.numberOfStoreys === 'Infinity' || src.numberOfStoreys === '-Infinity') {
                        dst.numberOfStoreys = NumberToInt("ng.loadcase.Data.number_of_storeys", AsNum(src.numberOfStoreys));
                    }
                    else {
                        console.log('Expected numberOfStoreys of Data to be a number but was ', typeof src.numberOfStoreys, src.numberOfStoreys)
                    }
                }
                if (src.description !== undefined && src.description !== null) {
                    if (typeof src.description === "string") {
                        dst.description = src.description;
                    }
                    else {
                        console.log('Expected description of Data to be a string but was ', typeof src.description, src.description)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcase.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcase.Data") {
                    console.error('Expected ng.loadcase.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.loadcase.Type_ToObject(src.type);
                if(type_obj === null) return null;

                const durationClass_obj = ng.loadcase.DurationClass_ToObject(src.durationClass);
                if(durationClass_obj === null) return null;

                const category_obj = ng.loadcase.Category_ToObject(src.category);
                if(category_obj === null) return null;

                const dst : Data_json = {
                    type: type_obj,
                    durationClass: durationClass_obj,
                    category: category_obj,
                    numberOfStoreys: AsJsonNum(NumberToInt("ng.loadcase.Data.number_of_storeys", src.numberOfStoreys)),
                    description: src.description,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.durationClass !== undefined) {
                    dst.durationClass = src.durationClass;
                }
                if (src.category !== undefined) {
                    dst.category = src.category;
                }
                if (src.numberOfStoreys !== undefined) {
                    dst.numberOfStoreys = src.numberOfStoreys;
                }
                if (src.description !== undefined) {
                    dst.description = src.description;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.type = this.type;
                dst.durationClass = this.durationClass;
                dst.category = this.category;
                dst.numberOfStoreys = this.numberOfStoreys;
                dst.description = this.description;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace loadcase


    // Defined in Loading/loadcombinationparameters.proto
    export namespace loadcombination_parameters {
        export enum PsiType {
            PSI_TYPE_UNSPECIFIED = 0,
            PSI_TYPE_0 = 1,
            PSI_TYPE_1 = 2,
            PSI_TYPE_2 = 3
        }
        export const PsiType_FromObject = (src: unknown): PsiType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'PSI_TYPE_UNSPECIFIED':
                    return PsiType.PSI_TYPE_UNSPECIFIED;
                case 1:
                case 'PSI_TYPE_0':
                    return PsiType.PSI_TYPE_0;
                case 2:
                case 'PSI_TYPE_1':
                    return PsiType.PSI_TYPE_1;
                case 3:
                case 'PSI_TYPE_2':
                    return PsiType.PSI_TYPE_2;
                default:
                    console.log('Unhandled value for PsiType:' + src + '. ' + typeof(src));
                    return PsiType.PSI_TYPE_UNSPECIFIED;
            }
        };
        export const PsiType_ToObject = (src: PsiType): string | null => {
            switch (src) {
                case PsiType.PSI_TYPE_UNSPECIFIED:
                    return 'PSI_TYPE_UNSPECIFIED';
                case PsiType.PSI_TYPE_0:
                    return 'PSI_TYPE_0';
                case PsiType.PSI_TYPE_1:
                    return 'PSI_TYPE_1';
                case PsiType.PSI_TYPE_2:
                    return 'PSI_TYPE_2';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for PsiType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum IsDominatingType {
            IS_DOMINATING_TYPE_UNSPECIFIED = 0,
            IS_DOMINATING_TYPE_NONE = 1,
            IS_DOMINATING_TYPE_CAT_E = 2,
            IS_DOMINATING_TYPE_WIND = 3,
            IS_DOMINATING_TYPE_TEMP = 4
        }
        export const IsDominatingType_FromObject = (src: unknown): IsDominatingType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'IS_DOMINATING_TYPE_UNSPECIFIED':
                    return IsDominatingType.IS_DOMINATING_TYPE_UNSPECIFIED;
                case 1:
                case 'IS_DOMINATING_TYPE_NONE':
                    return IsDominatingType.IS_DOMINATING_TYPE_NONE;
                case 2:
                case 'IS_DOMINATING_TYPE_CAT_E':
                    return IsDominatingType.IS_DOMINATING_TYPE_CAT_E;
                case 3:
                case 'IS_DOMINATING_TYPE_WIND':
                    return IsDominatingType.IS_DOMINATING_TYPE_WIND;
                case 4:
                case 'IS_DOMINATING_TYPE_TEMP':
                    return IsDominatingType.IS_DOMINATING_TYPE_TEMP;
                default:
                    console.log('Unhandled value for IsDominatingType:' + src + '. ' + typeof(src));
                    return IsDominatingType.IS_DOMINATING_TYPE_UNSPECIFIED;
            }
        };
        export const IsDominatingType_ToObject = (src: IsDominatingType): string | null => {
            switch (src) {
                case IsDominatingType.IS_DOMINATING_TYPE_UNSPECIFIED:
                    return 'IS_DOMINATING_TYPE_UNSPECIFIED';
                case IsDominatingType.IS_DOMINATING_TYPE_NONE:
                    return 'IS_DOMINATING_TYPE_NONE';
                case IsDominatingType.IS_DOMINATING_TYPE_CAT_E:
                    return 'IS_DOMINATING_TYPE_CAT_E';
                case IsDominatingType.IS_DOMINATING_TYPE_WIND:
                    return 'IS_DOMINATING_TYPE_WIND';
                case IsDominatingType.IS_DOMINATING_TYPE_TEMP:
                    return 'IS_DOMINATING_TYPE_TEMP';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for IsDominatingType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type KFI_keys = 'na' | 'cc' | 'value';
        export interface KFI_createType {
            na?: ng.eurocode.Annex,
            cc?: ng.structure.ConsequenceClass,
            value?: number,
        }
        export interface KFI_json {
            na?: string;
            cc?: string;
            value?: JsonNumber;
        }
        interface KFI_json_in {
            __proto_name?: unknown;
            na?: unknown;
            cc?: unknown;
            value?: unknown;
        }
        export class KFI {
            __proto_name = "ng.loadcombination_parameters.KFI";
            na: ng.eurocode.Annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;
            cc: ng.structure.ConsequenceClass = ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED;
            value: number = 0;

            static fromObject(src_unknown: unknown): KFI {
                const dst = new KFI();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted KFI but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as KFI_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for KFI but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.na !== undefined && src.na !== null) {
                    dst.na = ng.eurocode.Annex_FromObject(src.na);
                }
                if (src.cc !== undefined && src.cc !== null) {
                    dst.cc = ng.structure.ConsequenceClass_FromObject(src.cc);
                }
                if (src.value !== undefined && src.value !== null) {
                    if (typeof src.value === "number" || src.value === 'NaN' || src.value === 'Infinity' || src.value === '-Infinity') {
                        dst.value = AsNum(src.value);
                    }
                    else {
                        console.log('Expected value of KFI to be a number but was ', typeof src.value, src.value)
                    }
                }
                return dst;
            }

            static toObject(src: KFI | null | undefined): KFI_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination_parameters.KFI is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination_parameters.KFI") {
                    console.error('Expected ng.loadcombination_parameters.KFI but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const na_obj = ng.eurocode.Annex_ToObject(src.na);
                if(na_obj === null) return null;

                const cc_obj = ng.structure.ConsequenceClass_ToObject(src.cc);
                if(cc_obj === null) return null;

                const dst : KFI_json = {
                    na: na_obj,
                    cc: cc_obj,
                    value: AsJsonNum(src.value),
                };
                return dst;
            }

            static create(src?: KFI_createType) {
                const dst = new KFI();
                if (src === undefined) {
                    return dst;
                }
                if (src.na !== undefined) {
                    dst.na = src.na;
                }
                if (src.cc !== undefined) {
                    dst.cc = src.cc;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                return dst;
            }

            shallowClone() {
                const dst = new KFI();
                dst.na = this.na;
                dst.cc = this.cc;
                dst.value = this.value;
                return dst;
            }

            deepClone() {
                const json = KFI.toObject(this);
                const dst = KFI.fromObject(json);
                return dst;
            }
        }
        export type IKFI = KFI;


        export type KFIList_keys = 'kfis';
        export interface KFIList_createType {
            kfis?: ng.loadcombination_parameters.KFI[],
        }
        export interface KFIList_json {
            kfis: ng.loadcombination_parameters.KFI_json[];
        }
        interface KFIList_json_in {
            __proto_name?: unknown;
            kfis?: unknown;
        }
        export class KFIList {
            __proto_name = "ng.loadcombination_parameters.KFIList";
            kfis: ng.loadcombination_parameters.KFI[] = [];

            static fromObject(src_unknown: unknown): KFIList {
                const dst = new KFIList();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted KFIList but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as KFIList_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for KFIList but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.kfis !== undefined && src.kfis !== null) {
                    if (Array.isArray(src.kfis)) {
                        for (const element of src.kfis) {
                            dst.kfis.push(ng.loadcombination_parameters.KFI.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected kfis of KFIList to be a array but was ', typeof src.kfis, src.kfis)
                    }
                }
                return dst;
            }

            static toObject(src: KFIList | null | undefined): KFIList_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination_parameters.KFIList is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination_parameters.KFIList") {
                    console.error('Expected ng.loadcombination_parameters.KFIList but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : KFIList_json = {
                    kfis: new Array<ng.loadcombination_parameters.KFI_json>(),
                };
                if (src.kfis !== null) {
                    for (const element of src.kfis) {
                        const parsed = ng.loadcombination_parameters.KFI.toObject(element);
                        if(parsed === null) return null;
                        dst.kfis.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: KFIList_createType) {
                const dst = new KFIList();
                if (src === undefined) {
                    return dst;
                }
                if (src.kfis !== undefined) {
                    dst.kfis = src.kfis;
                }
                return dst;
            }

            shallowClone() {
                const dst = new KFIList();
                dst.kfis = this.kfis;
                return dst;
            }

            deepClone() {
                const json = KFIList.toObject(this);
                const dst = KFIList.fromObject(json);
                return dst;
            }
        }
        export type IKFIList = KFIList;


        export type Kmod_keys = 'lcType' | 'durationClass' | 'value';
        export interface Kmod_createType {
            lcType?: ng.loadcombination.Type,
            durationClass?: ng.loadcase.DurationClass,
            value?: number,
        }
        export interface Kmod_json {
            lcType?: string;
            durationClass?: string;
            value?: JsonNumber;
        }
        interface Kmod_json_in {
            __proto_name?: unknown;
            lcType?: unknown;
            durationClass?: unknown;
            value?: unknown;
        }
        export class Kmod {
            __proto_name = "ng.loadcombination_parameters.Kmod";
            lcType: ng.loadcombination.Type = ng.loadcombination.Type.TYPE_UNSPECIFIED;
            durationClass: ng.loadcase.DurationClass = ng.loadcase.DurationClass.DURATION_CLASS_UNSPECIFIED;
            value: number = 0;

            static fromObject(src_unknown: unknown): Kmod {
                const dst = new Kmod();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Kmod but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Kmod_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Kmod but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.lcType !== undefined && src.lcType !== null) {
                    dst.lcType = ng.loadcombination.Type_FromObject(src.lcType);
                }
                if (src.durationClass !== undefined && src.durationClass !== null) {
                    dst.durationClass = ng.loadcase.DurationClass_FromObject(src.durationClass);
                }
                if (src.value !== undefined && src.value !== null) {
                    if (typeof src.value === "number" || src.value === 'NaN' || src.value === 'Infinity' || src.value === '-Infinity') {
                        dst.value = AsNum(src.value);
                    }
                    else {
                        console.log('Expected value of Kmod to be a number but was ', typeof src.value, src.value)
                    }
                }
                return dst;
            }

            static toObject(src: Kmod | null | undefined): Kmod_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination_parameters.Kmod is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination_parameters.Kmod") {
                    console.error('Expected ng.loadcombination_parameters.Kmod but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const lcType_obj = ng.loadcombination.Type_ToObject(src.lcType);
                if(lcType_obj === null) return null;

                const durationClass_obj = ng.loadcase.DurationClass_ToObject(src.durationClass);
                if(durationClass_obj === null) return null;

                const dst : Kmod_json = {
                    lcType: lcType_obj,
                    durationClass: durationClass_obj,
                    value: AsJsonNum(src.value),
                };
                return dst;
            }

            static create(src?: Kmod_createType) {
                const dst = new Kmod();
                if (src === undefined) {
                    return dst;
                }
                if (src.lcType !== undefined) {
                    dst.lcType = src.lcType;
                }
                if (src.durationClass !== undefined) {
                    dst.durationClass = src.durationClass;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Kmod();
                dst.lcType = this.lcType;
                dst.durationClass = this.durationClass;
                dst.value = this.value;
                return dst;
            }

            deepClone() {
                const json = Kmod.toObject(this);
                const dst = Kmod.fromObject(json);
                return dst;
            }
        }
        export type IKmod = Kmod;


        export type KmodList_keys = 'kmods';
        export interface KmodList_createType {
            kmods?: ng.loadcombination_parameters.Kmod[],
        }
        export interface KmodList_json {
            kmods: ng.loadcombination_parameters.Kmod_json[];
        }
        interface KmodList_json_in {
            __proto_name?: unknown;
            kmods?: unknown;
        }
        export class KmodList {
            __proto_name = "ng.loadcombination_parameters.KmodList";
            kmods: ng.loadcombination_parameters.Kmod[] = [];

            static fromObject(src_unknown: unknown): KmodList {
                const dst = new KmodList();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted KmodList but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as KmodList_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for KmodList but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.kmods !== undefined && src.kmods !== null) {
                    if (Array.isArray(src.kmods)) {
                        for (const element of src.kmods) {
                            dst.kmods.push(ng.loadcombination_parameters.Kmod.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected kmods of KmodList to be a array but was ', typeof src.kmods, src.kmods)
                    }
                }
                return dst;
            }

            static toObject(src: KmodList | null | undefined): KmodList_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination_parameters.KmodList is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination_parameters.KmodList") {
                    console.error('Expected ng.loadcombination_parameters.KmodList but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : KmodList_json = {
                    kmods: new Array<ng.loadcombination_parameters.Kmod_json>(),
                };
                if (src.kmods !== null) {
                    for (const element of src.kmods) {
                        const parsed = ng.loadcombination_parameters.Kmod.toObject(element);
                        if(parsed === null) return null;
                        dst.kmods.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: KmodList_createType) {
                const dst = new KmodList();
                if (src === undefined) {
                    return dst;
                }
                if (src.kmods !== undefined) {
                    dst.kmods = src.kmods;
                }
                return dst;
            }

            shallowClone() {
                const dst = new KmodList();
                dst.kmods = this.kmods;
                return dst;
            }

            deepClone() {
                const json = KmodList.toObject(this);
                const dst = KmodList.fromObject(json);
                return dst;
            }
        }
        export type IKmodList = KmodList;


        export type PsiForLoad_keys = 'na' | 'psi' | 'loadcaseType' | 'dominating' | 'imposedCategory' | 'cenHeightBigger1000' | 'caracteristicSnowLoadType' | 'value';
        export interface PsiForLoad_createType {
            na?: ng.eurocode.Annex,
            psi?: ng.loadcombination_parameters.PsiType,
            loadcaseType?: ng.loadcase.Type,
            dominating?: ng.loadcombination_parameters.IsDominatingType,
            imposedCategory?: ng.loadcase.Category,
            cenHeightBigger1000?: boolean,
            caracteristicSnowLoadType?: number,
            value?: number,
        }
        export interface PsiForLoad_json {
            na?: string;
            psi?: string;
            loadcaseType?: string;
            dominating?: string;
            imposedCategory?: string;
            cenHeightBigger1000?: boolean;
            caracteristicSnowLoadType?: JsonNumber;
            value?: JsonNumber;
        }
        interface PsiForLoad_json_in {
            __proto_name?: unknown;
            na?: unknown;
            psi?: unknown;
            loadcaseType?: unknown;
            dominating?: unknown;
            imposedCategory?: unknown;
            cenHeightBigger1000?: unknown;
            caracteristicSnowLoadType?: unknown;
            value?: unknown;
        }
        export class PsiForLoad {
            __proto_name = "ng.loadcombination_parameters.PsiForLoad";
            na: ng.eurocode.Annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;
            psi: ng.loadcombination_parameters.PsiType = ng.loadcombination_parameters.PsiType.PSI_TYPE_UNSPECIFIED;
            loadcaseType: ng.loadcase.Type = ng.loadcase.Type.TYPE_UNSPECIFIED;
            dominating: ng.loadcombination_parameters.IsDominatingType = ng.loadcombination_parameters.IsDominatingType.IS_DOMINATING_TYPE_UNSPECIFIED;
            imposedCategory: ng.loadcase.Category = ng.loadcase.Category.CATEGORY_UNSPECIFIED;
            cenHeightBigger1000: boolean = false;
            caracteristicSnowLoadType: number = 0;
            value: number = 0;

            static fromObject(src_unknown: unknown): PsiForLoad {
                const dst = new PsiForLoad();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PsiForLoad but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PsiForLoad_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PsiForLoad but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.na !== undefined && src.na !== null) {
                    dst.na = ng.eurocode.Annex_FromObject(src.na);
                }
                if (src.psi !== undefined && src.psi !== null) {
                    dst.psi = ng.loadcombination_parameters.PsiType_FromObject(src.psi);
                }
                if (src.loadcaseType !== undefined && src.loadcaseType !== null) {
                    dst.loadcaseType = ng.loadcase.Type_FromObject(src.loadcaseType);
                }
                if (src.dominating !== undefined && src.dominating !== null) {
                    dst.dominating = ng.loadcombination_parameters.IsDominatingType_FromObject(src.dominating);
                }
                if (src.imposedCategory !== undefined && src.imposedCategory !== null) {
                    dst.imposedCategory = ng.loadcase.Category_FromObject(src.imposedCategory);
                }
                if (src.cenHeightBigger1000 !== undefined && src.cenHeightBigger1000 !== null) {
                    if (typeof src.cenHeightBigger1000 === "boolean") {
                        dst.cenHeightBigger1000 = src.cenHeightBigger1000;
                    }
                    else {
                        console.log('Expected cenHeightBigger1000 of PsiForLoad to be a boolean but was ', typeof src.cenHeightBigger1000, src.cenHeightBigger1000)
                    }
                }
                if (src.caracteristicSnowLoadType !== undefined && src.caracteristicSnowLoadType !== null) {
                    if (typeof src.caracteristicSnowLoadType === "number" || src.caracteristicSnowLoadType === 'NaN' || src.caracteristicSnowLoadType === 'Infinity' || src.caracteristicSnowLoadType === '-Infinity') {
                        dst.caracteristicSnowLoadType = NumberToInt("ng.loadcombination_parameters.PsiForLoad.caracteristic_snow_load_type", AsNum(src.caracteristicSnowLoadType));
                    }
                    else {
                        console.log('Expected caracteristicSnowLoadType of PsiForLoad to be a number but was ', typeof src.caracteristicSnowLoadType, src.caracteristicSnowLoadType)
                    }
                }
                if (src.value !== undefined && src.value !== null) {
                    if (typeof src.value === "number" || src.value === 'NaN' || src.value === 'Infinity' || src.value === '-Infinity') {
                        dst.value = AsNum(src.value);
                    }
                    else {
                        console.log('Expected value of PsiForLoad to be a number but was ', typeof src.value, src.value)
                    }
                }
                return dst;
            }

            static toObject(src: PsiForLoad | null | undefined): PsiForLoad_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination_parameters.PsiForLoad is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination_parameters.PsiForLoad") {
                    console.error('Expected ng.loadcombination_parameters.PsiForLoad but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const na_obj = ng.eurocode.Annex_ToObject(src.na);
                if(na_obj === null) return null;

                const psi_obj = ng.loadcombination_parameters.PsiType_ToObject(src.psi);
                if(psi_obj === null) return null;

                const loadcaseType_obj = ng.loadcase.Type_ToObject(src.loadcaseType);
                if(loadcaseType_obj === null) return null;

                const dominating_obj = ng.loadcombination_parameters.IsDominatingType_ToObject(src.dominating);
                if(dominating_obj === null) return null;

                const imposedCategory_obj = ng.loadcase.Category_ToObject(src.imposedCategory);
                if(imposedCategory_obj === null) return null;

                const dst : PsiForLoad_json = {
                    na: na_obj,
                    psi: psi_obj,
                    loadcaseType: loadcaseType_obj,
                    dominating: dominating_obj,
                    imposedCategory: imposedCategory_obj,
                    cenHeightBigger1000: src.cenHeightBigger1000,
                    caracteristicSnowLoadType: AsJsonNum(NumberToInt("ng.loadcombination_parameters.PsiForLoad.caracteristic_snow_load_type", src.caracteristicSnowLoadType)),
                    value: AsJsonNum(src.value),
                };
                return dst;
            }

            static create(src?: PsiForLoad_createType) {
                const dst = new PsiForLoad();
                if (src === undefined) {
                    return dst;
                }
                if (src.na !== undefined) {
                    dst.na = src.na;
                }
                if (src.psi !== undefined) {
                    dst.psi = src.psi;
                }
                if (src.loadcaseType !== undefined) {
                    dst.loadcaseType = src.loadcaseType;
                }
                if (src.dominating !== undefined) {
                    dst.dominating = src.dominating;
                }
                if (src.imposedCategory !== undefined) {
                    dst.imposedCategory = src.imposedCategory;
                }
                if (src.cenHeightBigger1000 !== undefined) {
                    dst.cenHeightBigger1000 = src.cenHeightBigger1000;
                }
                if (src.caracteristicSnowLoadType !== undefined) {
                    dst.caracteristicSnowLoadType = src.caracteristicSnowLoadType;
                }
                if (src.value !== undefined) {
                    dst.value = src.value;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PsiForLoad();
                dst.na = this.na;
                dst.psi = this.psi;
                dst.loadcaseType = this.loadcaseType;
                dst.dominating = this.dominating;
                dst.imposedCategory = this.imposedCategory;
                dst.cenHeightBigger1000 = this.cenHeightBigger1000;
                dst.caracteristicSnowLoadType = this.caracteristicSnowLoadType;
                dst.value = this.value;
                return dst;
            }

            deepClone() {
                const json = PsiForLoad.toObject(this);
                const dst = PsiForLoad.fromObject(json);
                return dst;
            }
        }
        export type IPsiForLoad = PsiForLoad;


        export type PsiForLoadsList_keys = 'psiForLoads';
        export interface PsiForLoadsList_createType {
            psiForLoads?: ng.loadcombination_parameters.PsiForLoad[],
        }
        export interface PsiForLoadsList_json {
            psiForLoads: ng.loadcombination_parameters.PsiForLoad_json[];
        }
        interface PsiForLoadsList_json_in {
            __proto_name?: unknown;
            psiForLoads?: unknown;
        }
        export class PsiForLoadsList {
            __proto_name = "ng.loadcombination_parameters.PsiForLoadsList";
            psiForLoads: ng.loadcombination_parameters.PsiForLoad[] = [];

            static fromObject(src_unknown: unknown): PsiForLoadsList {
                const dst = new PsiForLoadsList();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PsiForLoadsList but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PsiForLoadsList_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PsiForLoadsList but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.psiForLoads !== undefined && src.psiForLoads !== null) {
                    if (Array.isArray(src.psiForLoads)) {
                        for (const element of src.psiForLoads) {
                            dst.psiForLoads.push(ng.loadcombination_parameters.PsiForLoad.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected psiForLoads of PsiForLoadsList to be a array but was ', typeof src.psiForLoads, src.psiForLoads)
                    }
                }
                return dst;
            }

            static toObject(src: PsiForLoadsList | null | undefined): PsiForLoadsList_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loadcombination_parameters.PsiForLoadsList is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loadcombination_parameters.PsiForLoadsList") {
                    console.error('Expected ng.loadcombination_parameters.PsiForLoadsList but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PsiForLoadsList_json = {
                    psiForLoads: new Array<ng.loadcombination_parameters.PsiForLoad_json>(),
                };
                if (src.psiForLoads !== null) {
                    for (const element of src.psiForLoads) {
                        const parsed = ng.loadcombination_parameters.PsiForLoad.toObject(element);
                        if(parsed === null) return null;
                        dst.psiForLoads.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: PsiForLoadsList_createType) {
                const dst = new PsiForLoadsList();
                if (src === undefined) {
                    return dst;
                }
                if (src.psiForLoads !== undefined) {
                    dst.psiForLoads = src.psiForLoads;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PsiForLoadsList();
                dst.psiForLoads = this.psiForLoads;
                return dst;
            }

            deepClone() {
                const json = PsiForLoadsList.toObject(this);
                const dst = PsiForLoadsList.fromObject(json);
                return dst;
            }
        }
        export type IPsiForLoadsList = PsiForLoadsList;
    } // namespace loadcombination_parameters


    // Defined in Loading/load.proto
    export namespace load {
        export enum Type {
            TYPE_UNSPECIFIED = 0,
            TYPE_FORCE = 1,
            TYPE_MOMENT = 2,
            TYPE_PRESSURE = 3,
            TYPE_BODY_FORCE = 4,
            TYPE_TEMPERATURE = 5,
            TYPE_SOIL_FORCE = 6
        }
        export const Type_FromObject = (src: unknown): Type => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'TYPE_UNSPECIFIED':
                    return Type.TYPE_UNSPECIFIED;
                case 1:
                case 'TYPE_FORCE':
                    return Type.TYPE_FORCE;
                case 2:
                case 'TYPE_MOMENT':
                    return Type.TYPE_MOMENT;
                case 3:
                case 'TYPE_PRESSURE':
                    return Type.TYPE_PRESSURE;
                case 4:
                case 'TYPE_BODY_FORCE':
                    return Type.TYPE_BODY_FORCE;
                case 5:
                case 'TYPE_TEMPERATURE':
                    return Type.TYPE_TEMPERATURE;
                case 6:
                case 'TYPE_SOIL_FORCE':
                    return Type.TYPE_SOIL_FORCE;
                default:
                    console.log('Unhandled value for Type:' + src + '. ' + typeof(src));
                    return Type.TYPE_UNSPECIFIED;
            }
        };
        export const Type_ToObject = (src: Type): string | null => {
            switch (src) {
                case Type.TYPE_UNSPECIFIED:
                    return 'TYPE_UNSPECIFIED';
                case Type.TYPE_FORCE:
                    return 'TYPE_FORCE';
                case Type.TYPE_MOMENT:
                    return 'TYPE_MOMENT';
                case Type.TYPE_PRESSURE:
                    return 'TYPE_PRESSURE';
                case Type.TYPE_BODY_FORCE:
                    return 'TYPE_BODY_FORCE';
                case Type.TYPE_TEMPERATURE:
                    return 'TYPE_TEMPERATURE';
                case Type.TYPE_SOIL_FORCE:
                    return 'TYPE_SOIL_FORCE';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Type, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum DistributionType {
            DISTRIBUTION_TYPE_UNSPECIFIED = 0,
            DISTRIBUTION_TYPE_POINT = 1,
            DISTRIBUTION_TYPE_NODE = 2,
            DISTRIBUTION_TYPE_LINE = 3,
            DISTRIBUTION_TYPE_SURFACE = 4,
            DISTRIBUTION_TYPE_VOLUME = 5
        }
        export const DistributionType_FromObject = (src: unknown): DistributionType => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DISTRIBUTION_TYPE_UNSPECIFIED':
                    return DistributionType.DISTRIBUTION_TYPE_UNSPECIFIED;
                case 1:
                case 'DISTRIBUTION_TYPE_POINT':
                    return DistributionType.DISTRIBUTION_TYPE_POINT;
                case 2:
                case 'DISTRIBUTION_TYPE_NODE':
                    return DistributionType.DISTRIBUTION_TYPE_NODE;
                case 3:
                case 'DISTRIBUTION_TYPE_LINE':
                    return DistributionType.DISTRIBUTION_TYPE_LINE;
                case 4:
                case 'DISTRIBUTION_TYPE_SURFACE':
                    return DistributionType.DISTRIBUTION_TYPE_SURFACE;
                case 5:
                case 'DISTRIBUTION_TYPE_VOLUME':
                    return DistributionType.DISTRIBUTION_TYPE_VOLUME;
                default:
                    console.log('Unhandled value for DistributionType:' + src + '. ' + typeof(src));
                    return DistributionType.DISTRIBUTION_TYPE_UNSPECIFIED;
            }
        };
        export const DistributionType_ToObject = (src: DistributionType): string | null => {
            switch (src) {
                case DistributionType.DISTRIBUTION_TYPE_UNSPECIFIED:
                    return 'DISTRIBUTION_TYPE_UNSPECIFIED';
                case DistributionType.DISTRIBUTION_TYPE_POINT:
                    return 'DISTRIBUTION_TYPE_POINT';
                case DistributionType.DISTRIBUTION_TYPE_NODE:
                    return 'DISTRIBUTION_TYPE_NODE';
                case DistributionType.DISTRIBUTION_TYPE_LINE:
                    return 'DISTRIBUTION_TYPE_LINE';
                case DistributionType.DISTRIBUTION_TYPE_SURFACE:
                    return 'DISTRIBUTION_TYPE_SURFACE';
                case DistributionType.DISTRIBUTION_TYPE_VOLUME:
                    return 'DISTRIBUTION_TYPE_VOLUME';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for DistributionType, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Data_keys = 'id' | 'type' | 'distribution' | 'direction' | 'positions' | 'values' | 'lcaseGuid' | 'assignedObjects';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            type?: ng.load.Type,
            distribution?: ng.load.DistributionType,
            direction?: ng.geometry.Vector3D | null,
            positions?: ng.geometry.Point3D[],
            values?: number[],
            lcaseGuid?: string,
            assignedObjects?: string[],
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            type?: string;
            distribution?: string;
            direction?: ng.geometry.Vector3D_json;
            positions: ng.geometry.Point3D_json[];
            values: JsonNumber[];
            lcaseGuid?: string;
            assignedObjects: string[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            type?: unknown;
            distribution?: unknown;
            direction?: unknown;
            positions?: unknown;
            values?: unknown;
            lcaseGuid?: unknown;
            assignedObjects?: unknown;
        }
        export class Data {
            __proto_name = "ng.load.Data";
            id: ng.utils.ID | null = null;
            type: ng.load.Type = ng.load.Type.TYPE_UNSPECIFIED;
            distribution: ng.load.DistributionType = ng.load.DistributionType.DISTRIBUTION_TYPE_UNSPECIFIED;
            direction: ng.geometry.Vector3D | null = null;
            positions: ng.geometry.Point3D[] = [];
            values: number[] = [];
            lcaseGuid: string = "";
            assignedObjects: string[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.load.Type_FromObject(src.type);
                }
                if (src.distribution !== undefined && src.distribution !== null) {
                    dst.distribution = ng.load.DistributionType_FromObject(src.distribution);
                }
                if (src.direction !== undefined && src.direction !== null) {
                    dst.direction = ng.geometry.Vector3D.fromObject(src.direction);
                }
                if (src.positions !== undefined && src.positions !== null) {
                    if (Array.isArray(src.positions)) {
                        for (const element of src.positions) {
                            dst.positions.push(ng.geometry.Point3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected positions of Data to be a array but was ', typeof src.positions, src.positions)
                    }
                }
                if (src.values !== undefined && src.values !== null) {
                    if (Array.isArray(src.values)) {
                        for (const [index, element] of src.values.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.values.push(AsNum(element));
                            }
                            else {
                                console.log('Expected values of Data[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected values of Data to be a array but was ', typeof src.values, src.values)
                    }
                }
                if (src.lcaseGuid !== undefined && src.lcaseGuid !== null) {
                    if (typeof src.lcaseGuid === "string") {
                        dst.lcaseGuid = src.lcaseGuid;
                    }
                    else {
                        console.log('Expected lcaseGuid of Data to be a string but was ', typeof src.lcaseGuid, src.lcaseGuid)
                    }
                }
                if (src.assignedObjects !== undefined && src.assignedObjects !== null) {
                    if (Array.isArray(src.assignedObjects)) {
                        for (const [index, element] of src.assignedObjects.entries()) {
                            if (typeof element === "string") {
                                dst.assignedObjects.push(element);
                            }
                            else {
                                console.log('Expected assignedObjects of Data[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected assignedObjects of Data to be a array but was ', typeof src.assignedObjects, src.assignedObjects)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.load.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.load.Data") {
                    console.error('Expected ng.load.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.load.Type_ToObject(src.type);
                if(type_obj === null) return null;

                const distribution_obj = ng.load.DistributionType_ToObject(src.distribution);
                if(distribution_obj === null) return null;

                const dst : Data_json = {
                    type: type_obj,
                    distribution: distribution_obj,
                    positions: new Array<ng.geometry.Point3D_json>(),
                    values: new Array<JsonNumber>(),
                    lcaseGuid: src.lcaseGuid,
                    assignedObjects: new Array<string>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.direction !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.direction);
                    if(parsed === null) return null;
                    dst.direction = parsed;
                }
                if (src.positions !== null) {
                    for (const element of src.positions) {
                        const parsed = ng.geometry.Point3D.toObject(element);
                        if(parsed === null) return null;
                        dst.positions.push(parsed);
                    }
                }
                if (src.values !== null) {
                    for (const element of src.values) {
                        dst.values.push(AsJsonNum(element));
                    }
                }
                if (src.assignedObjects !== null) {
                    for (const element of src.assignedObjects) {
                        dst.assignedObjects.push(element);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.distribution !== undefined) {
                    dst.distribution = src.distribution;
                }
                if (src.direction !== undefined) {
                    dst.direction = src.direction;
                }
                if (src.positions !== undefined) {
                    dst.positions = src.positions;
                }
                if (src.values !== undefined) {
                    dst.values = src.values;
                }
                if (src.lcaseGuid !== undefined) {
                    dst.lcaseGuid = src.lcaseGuid;
                }
                if (src.assignedObjects !== undefined) {
                    dst.assignedObjects = src.assignedObjects;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.type = this.type;
                dst.distribution = this.distribution;
                dst.direction = this.direction;
                dst.positions = this.positions;
                dst.values = this.values;
                dst.lcaseGuid = this.lcaseGuid;
                dst.assignedObjects = this.assignedObjects;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace load


    // Defined in Geometry/retainingwall.proto
    export namespace retaining_wall {
        export enum Type {
            TYPE_UNSPECIFIED = 0,
            TYPE_L = 1,
            TYPE_L_WITH_HAUNCH = 3,
            TYPE_T = 2,
            TYPE_T_WITH_HAUNCH = 4
        }
        export const Type_FromObject = (src: unknown): Type => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'TYPE_UNSPECIFIED':
                    return Type.TYPE_UNSPECIFIED;
                case 1:
                case 'TYPE_L':
                    return Type.TYPE_L;
                case 3:
                case 'TYPE_L_WITH_HAUNCH':
                    return Type.TYPE_L_WITH_HAUNCH;
                case 2:
                case 'TYPE_T':
                    return Type.TYPE_T;
                case 4:
                case 'TYPE_T_WITH_HAUNCH':
                    return Type.TYPE_T_WITH_HAUNCH;
                default:
                    console.log('Unhandled value for Type:' + src + '. ' + typeof(src));
                    return Type.TYPE_UNSPECIFIED;
            }
        };
        export const Type_ToObject = (src: Type): string | null => {
            switch (src) {
                case Type.TYPE_UNSPECIFIED:
                    return 'TYPE_UNSPECIFIED';
                case Type.TYPE_L:
                    return 'TYPE_L';
                case Type.TYPE_L_WITH_HAUNCH:
                    return 'TYPE_L_WITH_HAUNCH';
                case Type.TYPE_T:
                    return 'TYPE_T';
                case Type.TYPE_T_WITH_HAUNCH:
                    return 'TYPE_T_WITH_HAUNCH';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Type, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type SimpleGeometry_keys = 'type' | 'toeWidth' | 'heelWidth' | 'toeHeight' | 'toeHeelHeight' | 'heelHeight' | 'haunchHeight' | 'wallHeight' | 'wallHaunchLeftWidth' | 'wallTopWidth' | 'wallRightWidth' | 'haunchRigthWidth' | 'length';
        export interface SimpleGeometry_createType {
            type?: ng.retaining_wall.Type,
            toeWidth?: number,
            heelWidth?: number,
            toeHeight?: number,
            toeHeelHeight?: number,
            heelHeight?: number,
            haunchHeight?: number,
            wallHeight?: number,
            wallHaunchLeftWidth?: number,
            wallTopWidth?: number,
            wallRightWidth?: number,
            haunchRigthWidth?: number,
            length?: number,
        }
        export interface SimpleGeometry_json {
            type?: string;
            toeWidth?: JsonNumber;
            heelWidth?: JsonNumber;
            toeHeight?: JsonNumber;
            toeHeelHeight?: JsonNumber;
            heelHeight?: JsonNumber;
            haunchHeight?: JsonNumber;
            wallHeight?: JsonNumber;
            wallHaunchLeftWidth?: JsonNumber;
            wallTopWidth?: JsonNumber;
            wallRightWidth?: JsonNumber;
            haunchRigthWidth?: JsonNumber;
            length?: JsonNumber;
        }
        interface SimpleGeometry_json_in {
            __proto_name?: unknown;
            type?: unknown;
            toeWidth?: unknown;
            heelWidth?: unknown;
            toeHeight?: unknown;
            toeHeelHeight?: unknown;
            heelHeight?: unknown;
            haunchHeight?: unknown;
            wallHeight?: unknown;
            wallHaunchLeftWidth?: unknown;
            wallTopWidth?: unknown;
            wallRightWidth?: unknown;
            haunchRigthWidth?: unknown;
            length?: unknown;
        }
        export class SimpleGeometry {
            __proto_name = "ng.retaining_wall.SimpleGeometry";
            type: ng.retaining_wall.Type = ng.retaining_wall.Type.TYPE_UNSPECIFIED;
            toeWidth: number = 0;
            heelWidth: number = 0;
            toeHeight: number = 0;
            toeHeelHeight: number = 0;
            heelHeight: number = 0;
            haunchHeight: number = 0;
            wallHeight: number = 0;
            wallHaunchLeftWidth: number = 0;
            wallTopWidth: number = 0;
            wallRightWidth: number = 0;
            haunchRigthWidth: number = 0;
            length: number = 0;

            static fromObject(src_unknown: unknown): SimpleGeometry {
                const dst = new SimpleGeometry();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SimpleGeometry but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SimpleGeometry_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SimpleGeometry but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.retaining_wall.Type_FromObject(src.type);
                }
                if (src.toeWidth !== undefined && src.toeWidth !== null) {
                    if (typeof src.toeWidth === "number" || src.toeWidth === 'NaN' || src.toeWidth === 'Infinity' || src.toeWidth === '-Infinity') {
                        dst.toeWidth = AsNum(src.toeWidth);
                    }
                    else {
                        console.log('Expected toeWidth of SimpleGeometry to be a number but was ', typeof src.toeWidth, src.toeWidth)
                    }
                }
                if (src.heelWidth !== undefined && src.heelWidth !== null) {
                    if (typeof src.heelWidth === "number" || src.heelWidth === 'NaN' || src.heelWidth === 'Infinity' || src.heelWidth === '-Infinity') {
                        dst.heelWidth = AsNum(src.heelWidth);
                    }
                    else {
                        console.log('Expected heelWidth of SimpleGeometry to be a number but was ', typeof src.heelWidth, src.heelWidth)
                    }
                }
                if (src.toeHeight !== undefined && src.toeHeight !== null) {
                    if (typeof src.toeHeight === "number" || src.toeHeight === 'NaN' || src.toeHeight === 'Infinity' || src.toeHeight === '-Infinity') {
                        dst.toeHeight = AsNum(src.toeHeight);
                    }
                    else {
                        console.log('Expected toeHeight of SimpleGeometry to be a number but was ', typeof src.toeHeight, src.toeHeight)
                    }
                }
                if (src.toeHeelHeight !== undefined && src.toeHeelHeight !== null) {
                    if (typeof src.toeHeelHeight === "number" || src.toeHeelHeight === 'NaN' || src.toeHeelHeight === 'Infinity' || src.toeHeelHeight === '-Infinity') {
                        dst.toeHeelHeight = AsNum(src.toeHeelHeight);
                    }
                    else {
                        console.log('Expected toeHeelHeight of SimpleGeometry to be a number but was ', typeof src.toeHeelHeight, src.toeHeelHeight)
                    }
                }
                if (src.heelHeight !== undefined && src.heelHeight !== null) {
                    if (typeof src.heelHeight === "number" || src.heelHeight === 'NaN' || src.heelHeight === 'Infinity' || src.heelHeight === '-Infinity') {
                        dst.heelHeight = AsNum(src.heelHeight);
                    }
                    else {
                        console.log('Expected heelHeight of SimpleGeometry to be a number but was ', typeof src.heelHeight, src.heelHeight)
                    }
                }
                if (src.haunchHeight !== undefined && src.haunchHeight !== null) {
                    if (typeof src.haunchHeight === "number" || src.haunchHeight === 'NaN' || src.haunchHeight === 'Infinity' || src.haunchHeight === '-Infinity') {
                        dst.haunchHeight = AsNum(src.haunchHeight);
                    }
                    else {
                        console.log('Expected haunchHeight of SimpleGeometry to be a number but was ', typeof src.haunchHeight, src.haunchHeight)
                    }
                }
                if (src.wallHeight !== undefined && src.wallHeight !== null) {
                    if (typeof src.wallHeight === "number" || src.wallHeight === 'NaN' || src.wallHeight === 'Infinity' || src.wallHeight === '-Infinity') {
                        dst.wallHeight = AsNum(src.wallHeight);
                    }
                    else {
                        console.log('Expected wallHeight of SimpleGeometry to be a number but was ', typeof src.wallHeight, src.wallHeight)
                    }
                }
                if (src.wallHaunchLeftWidth !== undefined && src.wallHaunchLeftWidth !== null) {
                    if (typeof src.wallHaunchLeftWidth === "number" || src.wallHaunchLeftWidth === 'NaN' || src.wallHaunchLeftWidth === 'Infinity' || src.wallHaunchLeftWidth === '-Infinity') {
                        dst.wallHaunchLeftWidth = AsNum(src.wallHaunchLeftWidth);
                    }
                    else {
                        console.log('Expected wallHaunchLeftWidth of SimpleGeometry to be a number but was ', typeof src.wallHaunchLeftWidth, src.wallHaunchLeftWidth)
                    }
                }
                if (src.wallTopWidth !== undefined && src.wallTopWidth !== null) {
                    if (typeof src.wallTopWidth === "number" || src.wallTopWidth === 'NaN' || src.wallTopWidth === 'Infinity' || src.wallTopWidth === '-Infinity') {
                        dst.wallTopWidth = AsNum(src.wallTopWidth);
                    }
                    else {
                        console.log('Expected wallTopWidth of SimpleGeometry to be a number but was ', typeof src.wallTopWidth, src.wallTopWidth)
                    }
                }
                if (src.wallRightWidth !== undefined && src.wallRightWidth !== null) {
                    if (typeof src.wallRightWidth === "number" || src.wallRightWidth === 'NaN' || src.wallRightWidth === 'Infinity' || src.wallRightWidth === '-Infinity') {
                        dst.wallRightWidth = AsNum(src.wallRightWidth);
                    }
                    else {
                        console.log('Expected wallRightWidth of SimpleGeometry to be a number but was ', typeof src.wallRightWidth, src.wallRightWidth)
                    }
                }
                if (src.haunchRigthWidth !== undefined && src.haunchRigthWidth !== null) {
                    if (typeof src.haunchRigthWidth === "number" || src.haunchRigthWidth === 'NaN' || src.haunchRigthWidth === 'Infinity' || src.haunchRigthWidth === '-Infinity') {
                        dst.haunchRigthWidth = AsNum(src.haunchRigthWidth);
                    }
                    else {
                        console.log('Expected haunchRigthWidth of SimpleGeometry to be a number but was ', typeof src.haunchRigthWidth, src.haunchRigthWidth)
                    }
                }
                if (src.length !== undefined && src.length !== null) {
                    if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                        dst.length = AsNum(src.length);
                    }
                    else {
                        console.log('Expected length of SimpleGeometry to be a number but was ', typeof src.length, src.length)
                    }
                }
                return dst;
            }

            static toObject(src: SimpleGeometry | null | undefined): SimpleGeometry_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.retaining_wall.SimpleGeometry is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.retaining_wall.SimpleGeometry") {
                    console.error('Expected ng.retaining_wall.SimpleGeometry but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.retaining_wall.Type_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : SimpleGeometry_json = {
                    type: type_obj,
                    toeWidth: AsJsonNum(src.toeWidth),
                    heelWidth: AsJsonNum(src.heelWidth),
                    toeHeight: AsJsonNum(src.toeHeight),
                    toeHeelHeight: AsJsonNum(src.toeHeelHeight),
                    heelHeight: AsJsonNum(src.heelHeight),
                    haunchHeight: AsJsonNum(src.haunchHeight),
                    wallHeight: AsJsonNum(src.wallHeight),
                    wallHaunchLeftWidth: AsJsonNum(src.wallHaunchLeftWidth),
                    wallTopWidth: AsJsonNum(src.wallTopWidth),
                    wallRightWidth: AsJsonNum(src.wallRightWidth),
                    haunchRigthWidth: AsJsonNum(src.haunchRigthWidth),
                    length: AsJsonNum(src.length),
                };
                return dst;
            }

            static create(src?: SimpleGeometry_createType) {
                const dst = new SimpleGeometry();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.toeWidth !== undefined) {
                    dst.toeWidth = src.toeWidth;
                }
                if (src.heelWidth !== undefined) {
                    dst.heelWidth = src.heelWidth;
                }
                if (src.toeHeight !== undefined) {
                    dst.toeHeight = src.toeHeight;
                }
                if (src.toeHeelHeight !== undefined) {
                    dst.toeHeelHeight = src.toeHeelHeight;
                }
                if (src.heelHeight !== undefined) {
                    dst.heelHeight = src.heelHeight;
                }
                if (src.haunchHeight !== undefined) {
                    dst.haunchHeight = src.haunchHeight;
                }
                if (src.wallHeight !== undefined) {
                    dst.wallHeight = src.wallHeight;
                }
                if (src.wallHaunchLeftWidth !== undefined) {
                    dst.wallHaunchLeftWidth = src.wallHaunchLeftWidth;
                }
                if (src.wallTopWidth !== undefined) {
                    dst.wallTopWidth = src.wallTopWidth;
                }
                if (src.wallRightWidth !== undefined) {
                    dst.wallRightWidth = src.wallRightWidth;
                }
                if (src.haunchRigthWidth !== undefined) {
                    dst.haunchRigthWidth = src.haunchRigthWidth;
                }
                if (src.length !== undefined) {
                    dst.length = src.length;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SimpleGeometry();
                dst.type = this.type;
                dst.toeWidth = this.toeWidth;
                dst.heelWidth = this.heelWidth;
                dst.toeHeight = this.toeHeight;
                dst.toeHeelHeight = this.toeHeelHeight;
                dst.heelHeight = this.heelHeight;
                dst.haunchHeight = this.haunchHeight;
                dst.wallHeight = this.wallHeight;
                dst.wallHaunchLeftWidth = this.wallHaunchLeftWidth;
                dst.wallTopWidth = this.wallTopWidth;
                dst.wallRightWidth = this.wallRightWidth;
                dst.haunchRigthWidth = this.haunchRigthWidth;
                dst.length = this.length;
                return dst;
            }

            deepClone() {
                const json = SimpleGeometry.toObject(this);
                const dst = SimpleGeometry.fromObject(json);
                return dst;
            }
        }
        export type ISimpleGeometry = SimpleGeometry;


        export type AdvancedGeometry_keys = unknown;
        export interface AdvancedGeometry_createType {
        }
        export interface AdvancedGeometry_json {
        }
        interface AdvancedGeometry_json_in {
            __proto_name?: unknown;
        }
        export class AdvancedGeometry {
            __proto_name = "ng.retaining_wall.AdvancedGeometry";

            static fromObject(src_unknown: unknown): AdvancedGeometry {
                const dst = new AdvancedGeometry();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted AdvancedGeometry but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as AdvancedGeometry_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for AdvancedGeometry but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                return dst;
            }

            static toObject(src: AdvancedGeometry | null | undefined): AdvancedGeometry_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.retaining_wall.AdvancedGeometry is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.retaining_wall.AdvancedGeometry") {
                    console.error('Expected ng.retaining_wall.AdvancedGeometry but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : AdvancedGeometry_json = {
                };
                return dst;
            }

            static create(src?: AdvancedGeometry_createType) {
                const dst = new AdvancedGeometry();
                if (src === undefined) {
                    return dst;
                }
                return dst;
            }

            shallowClone() {
                const dst = new AdvancedGeometry();
                return dst;
            }

            deepClone() {
                const json = AdvancedGeometry.toObject(this);
                const dst = AdvancedGeometry.fromObject(json);
                return dst;
            }
        }
        export type IAdvancedGeometry = AdvancedGeometry;


        export type Elements_keys = 'wallGuid' | 'haunchGuid' | 'toeGuid' | 'heelGuid' | 'toeSectionForces' | 'heelSectionForces' | 'wallSectionForces';
        export interface Elements_createType {
            wallGuid?: string,
            haunchGuid?: string,
            toeGuid?: string,
            heelGuid?: string,
            toeSectionForces?: number[],
            heelSectionForces?: number[],
            wallSectionForces?: number[],
        }
        export interface Elements_json {
            wallGuid?: string;
            haunchGuid?: string;
            toeGuid?: string;
            heelGuid?: string;
            toeSectionForces: JsonNumber[];
            heelSectionForces: JsonNumber[];
            wallSectionForces: JsonNumber[];
        }
        interface Elements_json_in {
            __proto_name?: unknown;
            wallGuid?: unknown;
            haunchGuid?: unknown;
            toeGuid?: unknown;
            heelGuid?: unknown;
            toeSectionForces?: unknown;
            heelSectionForces?: unknown;
            wallSectionForces?: unknown;
        }
        export class Elements {
            __proto_name = "ng.retaining_wall.Elements";
            wallGuid: string = "";
            haunchGuid: string = "";
            toeGuid: string = "";
            heelGuid: string = "";
            toeSectionForces: number[] = [];
            heelSectionForces: number[] = [];
            wallSectionForces: number[] = [];

            static fromObject(src_unknown: unknown): Elements {
                const dst = new Elements();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Elements but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Elements_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Elements but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.wallGuid !== undefined && src.wallGuid !== null) {
                    if (typeof src.wallGuid === "string") {
                        dst.wallGuid = src.wallGuid;
                    }
                    else {
                        console.log('Expected wallGuid of Elements to be a string but was ', typeof src.wallGuid, src.wallGuid)
                    }
                }
                if (src.haunchGuid !== undefined && src.haunchGuid !== null) {
                    if (typeof src.haunchGuid === "string") {
                        dst.haunchGuid = src.haunchGuid;
                    }
                    else {
                        console.log('Expected haunchGuid of Elements to be a string but was ', typeof src.haunchGuid, src.haunchGuid)
                    }
                }
                if (src.toeGuid !== undefined && src.toeGuid !== null) {
                    if (typeof src.toeGuid === "string") {
                        dst.toeGuid = src.toeGuid;
                    }
                    else {
                        console.log('Expected toeGuid of Elements to be a string but was ', typeof src.toeGuid, src.toeGuid)
                    }
                }
                if (src.heelGuid !== undefined && src.heelGuid !== null) {
                    if (typeof src.heelGuid === "string") {
                        dst.heelGuid = src.heelGuid;
                    }
                    else {
                        console.log('Expected heelGuid of Elements to be a string but was ', typeof src.heelGuid, src.heelGuid)
                    }
                }
                if (src.toeSectionForces !== undefined && src.toeSectionForces !== null) {
                    if (Array.isArray(src.toeSectionForces)) {
                        for (const [index, element] of src.toeSectionForces.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.toeSectionForces.push(AsNum(element));
                            }
                            else {
                                console.log('Expected toeSectionForces of Elements[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected toeSectionForces of Elements to be a array but was ', typeof src.toeSectionForces, src.toeSectionForces)
                    }
                }
                if (src.heelSectionForces !== undefined && src.heelSectionForces !== null) {
                    if (Array.isArray(src.heelSectionForces)) {
                        for (const [index, element] of src.heelSectionForces.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.heelSectionForces.push(AsNum(element));
                            }
                            else {
                                console.log('Expected heelSectionForces of Elements[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected heelSectionForces of Elements to be a array but was ', typeof src.heelSectionForces, src.heelSectionForces)
                    }
                }
                if (src.wallSectionForces !== undefined && src.wallSectionForces !== null) {
                    if (Array.isArray(src.wallSectionForces)) {
                        for (const [index, element] of src.wallSectionForces.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.wallSectionForces.push(AsNum(element));
                            }
                            else {
                                console.log('Expected wallSectionForces of Elements[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected wallSectionForces of Elements to be a array but was ', typeof src.wallSectionForces, src.wallSectionForces)
                    }
                }
                return dst;
            }

            static toObject(src: Elements | null | undefined): Elements_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.retaining_wall.Elements is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.retaining_wall.Elements") {
                    console.error('Expected ng.retaining_wall.Elements but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Elements_json = {
                    wallGuid: src.wallGuid,
                    haunchGuid: src.haunchGuid,
                    toeGuid: src.toeGuid,
                    heelGuid: src.heelGuid,
                    toeSectionForces: new Array<JsonNumber>(),
                    heelSectionForces: new Array<JsonNumber>(),
                    wallSectionForces: new Array<JsonNumber>(),
                };
                if (src.toeSectionForces !== null) {
                    for (const element of src.toeSectionForces) {
                        dst.toeSectionForces.push(AsJsonNum(element));
                    }
                }
                if (src.heelSectionForces !== null) {
                    for (const element of src.heelSectionForces) {
                        dst.heelSectionForces.push(AsJsonNum(element));
                    }
                }
                if (src.wallSectionForces !== null) {
                    for (const element of src.wallSectionForces) {
                        dst.wallSectionForces.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: Elements_createType) {
                const dst = new Elements();
                if (src === undefined) {
                    return dst;
                }
                if (src.wallGuid !== undefined) {
                    dst.wallGuid = src.wallGuid;
                }
                if (src.haunchGuid !== undefined) {
                    dst.haunchGuid = src.haunchGuid;
                }
                if (src.toeGuid !== undefined) {
                    dst.toeGuid = src.toeGuid;
                }
                if (src.heelGuid !== undefined) {
                    dst.heelGuid = src.heelGuid;
                }
                if (src.toeSectionForces !== undefined) {
                    dst.toeSectionForces = src.toeSectionForces;
                }
                if (src.heelSectionForces !== undefined) {
                    dst.heelSectionForces = src.heelSectionForces;
                }
                if (src.wallSectionForces !== undefined) {
                    dst.wallSectionForces = src.wallSectionForces;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Elements();
                dst.wallGuid = this.wallGuid;
                dst.haunchGuid = this.haunchGuid;
                dst.toeGuid = this.toeGuid;
                dst.heelGuid = this.heelGuid;
                dst.toeSectionForces = this.toeSectionForces;
                dst.heelSectionForces = this.heelSectionForces;
                dst.wallSectionForces = this.wallSectionForces;
                return dst;
            }

            deepClone() {
                const json = Elements.toObject(this);
                const dst = Elements.fromObject(json);
                return dst;
            }
        }
        export type IElements = Elements;


        export type WallGeometry_keys = 'simple' | 'advanced' | 'center' | 'n';
        export interface WallGeometry_createType {
            simple?: ng.retaining_wall.SimpleGeometry | null,
            advanced?: ng.retaining_wall.AdvancedGeometry | null,
            center?: ng.geometry.Point3D | null,
            n?: ng.geometry.Vector2D | null,
        }
        export interface WallGeometry_json {
            simple?: ng.retaining_wall.SimpleGeometry_json;
            advanced?: ng.retaining_wall.AdvancedGeometry_json;
            center?: ng.geometry.Point3D_json;
            n?: ng.geometry.Vector2D_json;
        }
        interface WallGeometry_json_in {
            __proto_name?: unknown;
            simple?: unknown;
            advanced?: unknown;
            center?: unknown;
            n?: unknown;
        }
        export class WallGeometry {
            __proto_name = "ng.retaining_wall.WallGeometry";
            // this is a one of
            geometry: {type: 'simple'; simple: ng.retaining_wall.SimpleGeometry} | {type: 'advanced'; advanced: ng.retaining_wall.AdvancedGeometry} | null = null;
            center: ng.geometry.Point3D | null = null;
            n: ng.geometry.Vector2D | null = null;

            /** Gets the `Simple` value (or null) from the oneof `geometry` */
            getSimple(): ng.retaining_wall.SimpleGeometry | null {
                if(this.geometry === null) return null;
                if(this.geometry.type !== 'simple') return null;
                return this.geometry.simple;
            }

            /** Sets the `Simple` value for the oneof `geometry`*/
            setSimple(value: ng.retaining_wall.SimpleGeometry | null) {
                if(value !== null) {
                    this.geometry = {type: 'simple', simple:value};
                }
                else {
                    this.geometry = null;
                }
            }

            /** Gets the `Advanced` value (or null) from the oneof `geometry` */
            getAdvanced(): ng.retaining_wall.AdvancedGeometry | null {
                if(this.geometry === null) return null;
                if(this.geometry.type !== 'advanced') return null;
                return this.geometry.advanced;
            }

            /** Sets the `Advanced` value for the oneof `geometry`*/
            setAdvanced(value: ng.retaining_wall.AdvancedGeometry | null) {
                if(value !== null) {
                    this.geometry = {type: 'advanced', advanced:value};
                }
                else {
                    this.geometry = null;
                }
            }

            static fromObject(src_unknown: unknown): WallGeometry {
                const dst = new WallGeometry();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted WallGeometry but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as WallGeometry_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for WallGeometry but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.simple !== undefined && src.simple !== null) {
                    dst.setSimple(ng.retaining_wall.SimpleGeometry.fromObject(src.simple));
                }
                if (src.advanced !== undefined && src.advanced !== null) {
                    dst.setAdvanced(ng.retaining_wall.AdvancedGeometry.fromObject(src.advanced));
                }
                if (src.center !== undefined && src.center !== null) {
                    dst.center = ng.geometry.Point3D.fromObject(src.center);
                }
                if (src.n !== undefined && src.n !== null) {
                    dst.n = ng.geometry.Vector2D.fromObject(src.n);
                }
                return dst;
            }

            static toObject(src: WallGeometry | null | undefined): WallGeometry_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.retaining_wall.WallGeometry is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.retaining_wall.WallGeometry") {
                    console.error('Expected ng.retaining_wall.WallGeometry but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : WallGeometry_json = {
                };
                const simple = src.getSimple();
                if(simple !== null)
                {
                    const parsed = ng.retaining_wall.SimpleGeometry.toObject(simple);
                    if(parsed === null) return null;
                    dst.simple = parsed;
                }
                const advanced = src.getAdvanced();
                if(advanced !== null)
                {
                    const parsed = ng.retaining_wall.AdvancedGeometry.toObject(advanced);
                    if(parsed === null) return null;
                    dst.advanced = parsed;
                }
                if(src.center !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.center);
                    if(parsed === null) return null;
                    dst.center = parsed;
                }
                if(src.n !== null)
                {
                    const parsed = ng.geometry.Vector2D.toObject(src.n);
                    if(parsed === null) return null;
                    dst.n = parsed;
                }
                return dst;
            }

            static create(src?: WallGeometry_createType) {
                const dst = new WallGeometry();
                if (src === undefined) {
                    return dst;
                }
                // part of the geometry oneof 
                if (src.simple !== undefined && src.simple !== null) {
                    dst.setSimple(src.simple);
                }
                // part of the geometry oneof 
                if (src.advanced !== undefined && src.advanced !== null) {
                    dst.setAdvanced(src.advanced);
                }
                if (src.center !== undefined) {
                    dst.center = src.center;
                }
                if (src.n !== undefined) {
                    dst.n = src.n;
                }
                return dst;
            }

            shallowClone() {
                const dst = new WallGeometry();
                dst.geometry = this.geometry;
                dst.center = this.center;
                dst.n = this.n;
                return dst;
            }

            deepClone() {
                const json = WallGeometry.toObject(this);
                const dst = WallGeometry.fromObject(json);
                return dst;
            }
        }
        export type IWallGeometry = WallGeometry;


        export type ConcreteParameters_keys = 'mtrlGuid' | 'rebars' | 'wallRebars';
        export interface ConcreteParameters_createType {
            mtrlGuid?: string,
            rebars?: ng.rebar.Data | null,
            wallRebars?: ng.rebar.Data | null,
        }
        export interface ConcreteParameters_json {
            mtrlGuid?: string;
            rebars?: ng.rebar.Data_json;
            wallRebars?: ng.rebar.Data_json;
        }
        interface ConcreteParameters_json_in {
            __proto_name?: unknown;
            mtrlGuid?: unknown;
            rebars?: unknown;
            wallRebars?: unknown;
        }
        export class ConcreteParameters {
            __proto_name = "ng.retaining_wall.ConcreteParameters";
            mtrlGuid: string = "";
            rebars: ng.rebar.Data | null = null;
            wallRebars: ng.rebar.Data | null = null;

            static fromObject(src_unknown: unknown): ConcreteParameters {
                const dst = new ConcreteParameters();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ConcreteParameters but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ConcreteParameters_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ConcreteParameters but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of ConcreteParameters to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                if (src.rebars !== undefined && src.rebars !== null) {
                    dst.rebars = ng.rebar.Data.fromObject(src.rebars);
                }
                if (src.wallRebars !== undefined && src.wallRebars !== null) {
                    dst.wallRebars = ng.rebar.Data.fromObject(src.wallRebars);
                }
                return dst;
            }

            static toObject(src: ConcreteParameters | null | undefined): ConcreteParameters_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.retaining_wall.ConcreteParameters is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.retaining_wall.ConcreteParameters") {
                    console.error('Expected ng.retaining_wall.ConcreteParameters but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ConcreteParameters_json = {
                    mtrlGuid: src.mtrlGuid,
                };
                if(src.rebars !== null)
                {
                    const parsed = ng.rebar.Data.toObject(src.rebars);
                    if(parsed === null) return null;
                    dst.rebars = parsed;
                }
                if(src.wallRebars !== null)
                {
                    const parsed = ng.rebar.Data.toObject(src.wallRebars);
                    if(parsed === null) return null;
                    dst.wallRebars = parsed;
                }
                return dst;
            }

            static create(src?: ConcreteParameters_createType) {
                const dst = new ConcreteParameters();
                if (src === undefined) {
                    return dst;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                if (src.rebars !== undefined) {
                    dst.rebars = src.rebars;
                }
                if (src.wallRebars !== undefined) {
                    dst.wallRebars = src.wallRebars;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ConcreteParameters();
                dst.mtrlGuid = this.mtrlGuid;
                dst.rebars = this.rebars;
                dst.wallRebars = this.wallRebars;
                return dst;
            }

            deepClone() {
                const json = ConcreteParameters.toObject(this);
                const dst = ConcreteParameters.fromObject(json);
                return dst;
            }
        }
        export type IConcreteParameters = ConcreteParameters;


        export type Data_keys = 'id' | 'bedModule' | 'activeBoreholeGuid' | 'passiveBoreholeGuid' | 'wallGeometry' | 'elements' | 'usePassive' | 'supportGuid' | 'concreteParameters';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            bedModule?: number,
            activeBoreholeGuid?: string,
            passiveBoreholeGuid?: string,
            wallGeometry?: ng.retaining_wall.WallGeometry | null,
            elements?: ng.retaining_wall.Elements | null,
            usePassive?: boolean,
            supportGuid?: string,
            concreteParameters?: ng.retaining_wall.ConcreteParameters | null,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            bedModule?: JsonNumber;
            activeBoreholeGuid?: string;
            passiveBoreholeGuid?: string;
            wallGeometry?: ng.retaining_wall.WallGeometry_json;
            elements?: ng.retaining_wall.Elements_json;
            usePassive?: boolean;
            supportGuid?: string;
            concreteParameters?: ng.retaining_wall.ConcreteParameters_json;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            bedModule?: unknown;
            activeBoreholeGuid?: unknown;
            passiveBoreholeGuid?: unknown;
            wallGeometry?: unknown;
            elements?: unknown;
            usePassive?: unknown;
            supportGuid?: unknown;
            concreteParameters?: unknown;
        }
        export class Data {
            __proto_name = "ng.retaining_wall.Data";
            id: ng.utils.ID | null = null;
            bedModule: number = 0;
            activeBoreholeGuid: string = "";
            passiveBoreholeGuid: string = "";
            wallGeometry: ng.retaining_wall.WallGeometry | null = null;
            elements: ng.retaining_wall.Elements | null = null;
            usePassive: boolean = false;
            supportGuid: string = "";
            concreteParameters: ng.retaining_wall.ConcreteParameters | null = null;

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.bedModule !== undefined && src.bedModule !== null) {
                    if (typeof src.bedModule === "number" || src.bedModule === 'NaN' || src.bedModule === 'Infinity' || src.bedModule === '-Infinity') {
                        dst.bedModule = AsNum(src.bedModule);
                    }
                    else {
                        console.log('Expected bedModule of Data to be a number but was ', typeof src.bedModule, src.bedModule)
                    }
                }
                if (src.activeBoreholeGuid !== undefined && src.activeBoreholeGuid !== null) {
                    if (typeof src.activeBoreholeGuid === "string") {
                        dst.activeBoreholeGuid = src.activeBoreholeGuid;
                    }
                    else {
                        console.log('Expected activeBoreholeGuid of Data to be a string but was ', typeof src.activeBoreholeGuid, src.activeBoreholeGuid)
                    }
                }
                if (src.passiveBoreholeGuid !== undefined && src.passiveBoreholeGuid !== null) {
                    if (typeof src.passiveBoreholeGuid === "string") {
                        dst.passiveBoreholeGuid = src.passiveBoreholeGuid;
                    }
                    else {
                        console.log('Expected passiveBoreholeGuid of Data to be a string but was ', typeof src.passiveBoreholeGuid, src.passiveBoreholeGuid)
                    }
                }
                if (src.wallGeometry !== undefined && src.wallGeometry !== null) {
                    dst.wallGeometry = ng.retaining_wall.WallGeometry.fromObject(src.wallGeometry);
                }
                if (src.elements !== undefined && src.elements !== null) {
                    dst.elements = ng.retaining_wall.Elements.fromObject(src.elements);
                }
                if (src.usePassive !== undefined && src.usePassive !== null) {
                    if (typeof src.usePassive === "boolean") {
                        dst.usePassive = src.usePassive;
                    }
                    else {
                        console.log('Expected usePassive of Data to be a boolean but was ', typeof src.usePassive, src.usePassive)
                    }
                }
                if (src.supportGuid !== undefined && src.supportGuid !== null) {
                    if (typeof src.supportGuid === "string") {
                        dst.supportGuid = src.supportGuid;
                    }
                    else {
                        console.log('Expected supportGuid of Data to be a string but was ', typeof src.supportGuid, src.supportGuid)
                    }
                }
                if (src.concreteParameters !== undefined && src.concreteParameters !== null) {
                    dst.concreteParameters = ng.retaining_wall.ConcreteParameters.fromObject(src.concreteParameters);
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.retaining_wall.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.retaining_wall.Data") {
                    console.error('Expected ng.retaining_wall.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    bedModule: AsJsonNum(src.bedModule),
                    activeBoreholeGuid: src.activeBoreholeGuid,
                    passiveBoreholeGuid: src.passiveBoreholeGuid,
                    usePassive: src.usePassive,
                    supportGuid: src.supportGuid,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.wallGeometry !== null)
                {
                    const parsed = ng.retaining_wall.WallGeometry.toObject(src.wallGeometry);
                    if(parsed === null) return null;
                    dst.wallGeometry = parsed;
                }
                if(src.elements !== null)
                {
                    const parsed = ng.retaining_wall.Elements.toObject(src.elements);
                    if(parsed === null) return null;
                    dst.elements = parsed;
                }
                if(src.concreteParameters !== null)
                {
                    const parsed = ng.retaining_wall.ConcreteParameters.toObject(src.concreteParameters);
                    if(parsed === null) return null;
                    dst.concreteParameters = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.bedModule !== undefined) {
                    dst.bedModule = src.bedModule;
                }
                if (src.activeBoreholeGuid !== undefined) {
                    dst.activeBoreholeGuid = src.activeBoreholeGuid;
                }
                if (src.passiveBoreholeGuid !== undefined) {
                    dst.passiveBoreholeGuid = src.passiveBoreholeGuid;
                }
                if (src.wallGeometry !== undefined) {
                    dst.wallGeometry = src.wallGeometry;
                }
                if (src.elements !== undefined) {
                    dst.elements = src.elements;
                }
                if (src.usePassive !== undefined) {
                    dst.usePassive = src.usePassive;
                }
                if (src.supportGuid !== undefined) {
                    dst.supportGuid = src.supportGuid;
                }
                if (src.concreteParameters !== undefined) {
                    dst.concreteParameters = src.concreteParameters;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.bedModule = this.bedModule;
                dst.activeBoreholeGuid = this.activeBoreholeGuid;
                dst.passiveBoreholeGuid = this.passiveBoreholeGuid;
                dst.wallGeometry = this.wallGeometry;
                dst.elements = this.elements;
                dst.usePassive = this.usePassive;
                dst.supportGuid = this.supportGuid;
                dst.concreteParameters = this.concreteParameters;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace retaining_wall


    // Defined in Geometry/pile.proto
    export namespace pile {
        export enum Type {
            TYPE_UNSPECIFIED = 0,
            TYPE_DRIVEN = 1,
            TYPE_BORED = 2,
            TYPE_CFA = 3
        }
        export const Type_FromObject = (src: unknown): Type => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'TYPE_UNSPECIFIED':
                    return Type.TYPE_UNSPECIFIED;
                case 1:
                case 'TYPE_DRIVEN':
                    return Type.TYPE_DRIVEN;
                case 2:
                case 'TYPE_BORED':
                    return Type.TYPE_BORED;
                case 3:
                case 'TYPE_CFA':
                    return Type.TYPE_CFA;
                default:
                    console.log('Unhandled value for Type:' + src + '. ' + typeof(src));
                    return Type.TYPE_UNSPECIFIED;
            }
        };
        export const Type_ToObject = (src: Type): string | null => {
            switch (src) {
                case Type.TYPE_UNSPECIFIED:
                    return 'TYPE_UNSPECIFIED';
                case Type.TYPE_DRIVEN:
                    return 'TYPE_DRIVEN';
                case Type.TYPE_BORED:
                    return 'TYPE_BORED';
                case Type.TYPE_CFA:
                    return 'TYPE_CFA';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for Type, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Circle_keys = 'diameter';
        export interface Circle_createType {
            diameter?: number,
        }
        export interface Circle_json {
            diameter?: JsonNumber;
        }
        interface Circle_json_in {
            __proto_name?: unknown;
            diameter?: unknown;
        }
        export class Circle {
            __proto_name = "ng.pile.Circle";
            diameter: number = 0;

            static fromObject(src_unknown: unknown): Circle {
                const dst = new Circle();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Circle but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Circle_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Circle but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.diameter !== undefined && src.diameter !== null) {
                    if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                        dst.diameter = AsNum(src.diameter);
                    }
                    else {
                        console.log('Expected diameter of Circle to be a number but was ', typeof src.diameter, src.diameter)
                    }
                }
                return dst;
            }

            static toObject(src: Circle | null | undefined): Circle_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.pile.Circle is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.pile.Circle") {
                    console.error('Expected ng.pile.Circle but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Circle_json = {
                    diameter: AsJsonNum(src.diameter),
                };
                return dst;
            }

            static create(src?: Circle_createType) {
                const dst = new Circle();
                if (src === undefined) {
                    return dst;
                }
                if (src.diameter !== undefined) {
                    dst.diameter = src.diameter;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Circle();
                dst.diameter = this.diameter;
                return dst;
            }

            deepClone() {
                const json = Circle.toObject(this);
                const dst = Circle.fromObject(json);
                return dst;
            }
        }
        export type ICircle = Circle;


        export type Rectangle_keys = 'width' | 'height';
        export interface Rectangle_createType {
            width?: number,
            height?: number,
        }
        export interface Rectangle_json {
            width?: JsonNumber;
            height?: JsonNumber;
        }
        interface Rectangle_json_in {
            __proto_name?: unknown;
            width?: unknown;
            height?: unknown;
        }
        export class Rectangle {
            __proto_name = "ng.pile.Rectangle";
            width: number = 0;
            height: number = 0;

            static fromObject(src_unknown: unknown): Rectangle {
                const dst = new Rectangle();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Rectangle but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Rectangle_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Rectangle but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of Rectangle to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of Rectangle to be a number but was ', typeof src.height, src.height)
                    }
                }
                return dst;
            }

            static toObject(src: Rectangle | null | undefined): Rectangle_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.pile.Rectangle is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.pile.Rectangle") {
                    console.error('Expected ng.pile.Rectangle but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Rectangle_json = {
                    width: AsJsonNum(src.width),
                    height: AsJsonNum(src.height),
                };
                return dst;
            }

            static create(src?: Rectangle_createType) {
                const dst = new Rectangle();
                if (src === undefined) {
                    return dst;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Rectangle();
                dst.width = this.width;
                dst.height = this.height;
                return dst;
            }

            deepClone() {
                const json = Rectangle.toObject(this);
                const dst = Rectangle.fromObject(json);
                return dst;
            }
        }
        export type IRectangle = Rectangle;


        export type Asphalt_keys = 'asphaltTop' | 'asphaltBottom';
        export interface Asphalt_createType {
            asphaltTop?: number,
            asphaltBottom?: number,
        }
        export interface Asphalt_json {
            asphaltTop?: JsonNumber;
            asphaltBottom?: JsonNumber;
        }
        interface Asphalt_json_in {
            __proto_name?: unknown;
            asphaltTop?: unknown;
            asphaltBottom?: unknown;
        }
        export class Asphalt {
            __proto_name = "ng.pile.Asphalt";
            asphaltTop: number = 0;
            asphaltBottom: number = 0;

            static fromObject(src_unknown: unknown): Asphalt {
                const dst = new Asphalt();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Asphalt but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Asphalt_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Asphalt but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.asphaltTop !== undefined && src.asphaltTop !== null) {
                    if (typeof src.asphaltTop === "number" || src.asphaltTop === 'NaN' || src.asphaltTop === 'Infinity' || src.asphaltTop === '-Infinity') {
                        dst.asphaltTop = AsNum(src.asphaltTop);
                    }
                    else {
                        console.log('Expected asphaltTop of Asphalt to be a number but was ', typeof src.asphaltTop, src.asphaltTop)
                    }
                }
                if (src.asphaltBottom !== undefined && src.asphaltBottom !== null) {
                    if (typeof src.asphaltBottom === "number" || src.asphaltBottom === 'NaN' || src.asphaltBottom === 'Infinity' || src.asphaltBottom === '-Infinity') {
                        dst.asphaltBottom = AsNum(src.asphaltBottom);
                    }
                    else {
                        console.log('Expected asphaltBottom of Asphalt to be a number but was ', typeof src.asphaltBottom, src.asphaltBottom)
                    }
                }
                return dst;
            }

            static toObject(src: Asphalt | null | undefined): Asphalt_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.pile.Asphalt is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.pile.Asphalt") {
                    console.error('Expected ng.pile.Asphalt but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Asphalt_json = {
                    asphaltTop: AsJsonNum(src.asphaltTop),
                    asphaltBottom: AsJsonNum(src.asphaltBottom),
                };
                return dst;
            }

            static create(src?: Asphalt_createType) {
                const dst = new Asphalt();
                if (src === undefined) {
                    return dst;
                }
                if (src.asphaltTop !== undefined) {
                    dst.asphaltTop = src.asphaltTop;
                }
                if (src.asphaltBottom !== undefined) {
                    dst.asphaltBottom = src.asphaltBottom;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Asphalt();
                dst.asphaltTop = this.asphaltTop;
                dst.asphaltBottom = this.asphaltBottom;
                return dst;
            }

            deepClone() {
                const json = Asphalt.toObject(this);
                const dst = Asphalt.fromObject(json);
                return dst;
            }
        }
        export type IAsphalt = Asphalt;


        export type Geometry_keys = 'circle' | 'rectangle' | 'sectionGuid' | 'top' | 'bottom' | 'n';
        export interface Geometry_createType {
            circle?: ng.pile.Circle | null,
            rectangle?: ng.pile.Rectangle | null,
            sectionGuid?: string,
            top?: ng.geometry.Point3D | null,
            bottom?: ng.geometry.Point3D | null,
            n?: ng.geometry.Vector2D | null,
        }
        export interface Geometry_json {
            circle?: ng.pile.Circle_json;
            rectangle?: ng.pile.Rectangle_json;
            sectionGuid?: string;
            top?: ng.geometry.Point3D_json;
            bottom?: ng.geometry.Point3D_json;
            n?: ng.geometry.Vector2D_json;
        }
        interface Geometry_json_in {
            __proto_name?: unknown;
            circle?: unknown;
            rectangle?: unknown;
            sectionGuid?: unknown;
            top?: unknown;
            bottom?: unknown;
            n?: unknown;
        }
        export class Geometry {
            __proto_name = "ng.pile.Geometry";
            // this is a one of
            element: {type: 'circle'; circle: ng.pile.Circle} | {type: 'rectangle'; rectangle: ng.pile.Rectangle} | {type: 'sectionGuid'; sectionGuid: string} | null = null;
            top: ng.geometry.Point3D | null = null;
            bottom: ng.geometry.Point3D | null = null;
            n: ng.geometry.Vector2D | null = null;

            /** Gets the `Circle` value (or null) from the oneof `element` */
            getCircle(): ng.pile.Circle | null {
                if(this.element === null) return null;
                if(this.element.type !== 'circle') return null;
                return this.element.circle;
            }

            /** Sets the `Circle` value for the oneof `element`*/
            setCircle(value: ng.pile.Circle | null) {
                if(value !== null) {
                    this.element = {type: 'circle', circle:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Rectangle` value (or null) from the oneof `element` */
            getRectangle(): ng.pile.Rectangle | null {
                if(this.element === null) return null;
                if(this.element.type !== 'rectangle') return null;
                return this.element.rectangle;
            }

            /** Sets the `Rectangle` value for the oneof `element`*/
            setRectangle(value: ng.pile.Rectangle | null) {
                if(value !== null) {
                    this.element = {type: 'rectangle', rectangle:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `SectionGuid` value (or null) from the oneof `element` */
            getSectionGuid(): string | null {
                if(this.element === null) return null;
                if(this.element.type !== 'sectionGuid') return null;
                return this.element.sectionGuid;
            }

            /** Sets the `SectionGuid` value for the oneof `element`*/
            setSectionGuid(value: string | null) {
                if(value !== null) {
                    this.element = {type: 'sectionGuid', sectionGuid:value};
                }
                else {
                    this.element = null;
                }
            }

            static fromObject(src_unknown: unknown): Geometry {
                const dst = new Geometry();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Geometry but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Geometry_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Geometry but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.circle !== undefined && src.circle !== null) {
                    dst.setCircle(ng.pile.Circle.fromObject(src.circle));
                }
                if (src.rectangle !== undefined && src.rectangle !== null) {
                    dst.setRectangle(ng.pile.Rectangle.fromObject(src.rectangle));
                }
                if (src.sectionGuid !== undefined && src.sectionGuid !== null) {
                    if (typeof src.sectionGuid === "string") {
                        dst.setSectionGuid(src.sectionGuid);
                    }
                    else {
                        console.log('Expected sectionGuid of Geometry to be a string but was ', typeof src.sectionGuid, src.sectionGuid)
                    }
                }
                if (src.top !== undefined && src.top !== null) {
                    dst.top = ng.geometry.Point3D.fromObject(src.top);
                }
                if (src.bottom !== undefined && src.bottom !== null) {
                    dst.bottom = ng.geometry.Point3D.fromObject(src.bottom);
                }
                if (src.n !== undefined && src.n !== null) {
                    dst.n = ng.geometry.Vector2D.fromObject(src.n);
                }
                return dst;
            }

            static toObject(src: Geometry | null | undefined): Geometry_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.pile.Geometry is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.pile.Geometry") {
                    console.error('Expected ng.pile.Geometry but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Geometry_json = {
                };
                const circle = src.getCircle();
                if(circle !== null)
                {
                    const parsed = ng.pile.Circle.toObject(circle);
                    if(parsed === null) return null;
                    dst.circle = parsed;
                }
                const rectangle = src.getRectangle();
                if(rectangle !== null)
                {
                    const parsed = ng.pile.Rectangle.toObject(rectangle);
                    if(parsed === null) return null;
                    dst.rectangle = parsed;
                }
                const sectionGuid = src.getSectionGuid();
                if(sectionGuid !== null)
                {
                    const parsed = sectionGuid;
                    if(parsed === null) return null;
                    dst.sectionGuid = parsed;
                }
                if(src.top !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.top);
                    if(parsed === null) return null;
                    dst.top = parsed;
                }
                if(src.bottom !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.bottom);
                    if(parsed === null) return null;
                    dst.bottom = parsed;
                }
                if(src.n !== null)
                {
                    const parsed = ng.geometry.Vector2D.toObject(src.n);
                    if(parsed === null) return null;
                    dst.n = parsed;
                }
                return dst;
            }

            static create(src?: Geometry_createType) {
                const dst = new Geometry();
                if (src === undefined) {
                    return dst;
                }
                // part of the element oneof 
                if (src.circle !== undefined && src.circle !== null) {
                    dst.setCircle(src.circle);
                }
                // part of the element oneof 
                if (src.rectangle !== undefined && src.rectangle !== null) {
                    dst.setRectangle(src.rectangle);
                }
                // part of the element oneof 
                if (src.sectionGuid !== undefined && src.sectionGuid !== null) {
                    dst.setSectionGuid(src.sectionGuid);
                }
                if (src.top !== undefined) {
                    dst.top = src.top;
                }
                if (src.bottom !== undefined) {
                    dst.bottom = src.bottom;
                }
                if (src.n !== undefined) {
                    dst.n = src.n;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Geometry();
                dst.element = this.element;
                dst.top = this.top;
                dst.bottom = this.bottom;
                dst.n = this.n;
                return dst;
            }

            deepClone() {
                const json = Geometry.toObject(this);
                const dst = Geometry.fromObject(json);
                return dst;
            }
        }
        export type IGeometry = Geometry;


        export type Data_keys = 'id' | 'bedModule' | 'boreholeGuid' | 'geometry' | 'supportGuid' | 'asphalt' | 'negativeLevel' | 'maxNegativeForce' | 'pileType' | 'mtrlGuid';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            bedModule?: number,
            boreholeGuid?: string,
            geometry?: ng.pile.Geometry | null,
            supportGuid?: string,
            asphalt?: ng.pile.Asphalt | null,
            negativeLevel?: number,
            maxNegativeForce?: number,
            pileType?: ng.pile.Type,
            mtrlGuid?: string,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            bedModule?: JsonNumber;
            boreholeGuid?: string;
            geometry?: ng.pile.Geometry_json;
            supportGuid?: string;
            asphalt?: ng.pile.Asphalt_json;
            negativeLevel?: JsonNumber;
            maxNegativeForce?: JsonNumber;
            pileType?: string;
            mtrlGuid?: string;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            bedModule?: unknown;
            boreholeGuid?: unknown;
            geometry?: unknown;
            supportGuid?: unknown;
            asphalt?: unknown;
            negativeLevel?: unknown;
            maxNegativeForce?: unknown;
            pileType?: unknown;
            mtrlGuid?: unknown;
        }
        export class Data {
            __proto_name = "ng.pile.Data";
            id: ng.utils.ID | null = null;
            bedModule: number = 0;
            boreholeGuid: string = "";
            geometry: ng.pile.Geometry | null = null;
            supportGuid: string = "";
            asphalt: ng.pile.Asphalt | null = null;
            negativeLevel: number = 0;
            maxNegativeForce: number = 0;
            pileType: ng.pile.Type = ng.pile.Type.TYPE_UNSPECIFIED;
            mtrlGuid: string = "";

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.bedModule !== undefined && src.bedModule !== null) {
                    if (typeof src.bedModule === "number" || src.bedModule === 'NaN' || src.bedModule === 'Infinity' || src.bedModule === '-Infinity') {
                        dst.bedModule = AsNum(src.bedModule);
                    }
                    else {
                        console.log('Expected bedModule of Data to be a number but was ', typeof src.bedModule, src.bedModule)
                    }
                }
                if (src.boreholeGuid !== undefined && src.boreholeGuid !== null) {
                    if (typeof src.boreholeGuid === "string") {
                        dst.boreholeGuid = src.boreholeGuid;
                    }
                    else {
                        console.log('Expected boreholeGuid of Data to be a string but was ', typeof src.boreholeGuid, src.boreholeGuid)
                    }
                }
                if (src.geometry !== undefined && src.geometry !== null) {
                    dst.geometry = ng.pile.Geometry.fromObject(src.geometry);
                }
                if (src.supportGuid !== undefined && src.supportGuid !== null) {
                    if (typeof src.supportGuid === "string") {
                        dst.supportGuid = src.supportGuid;
                    }
                    else {
                        console.log('Expected supportGuid of Data to be a string but was ', typeof src.supportGuid, src.supportGuid)
                    }
                }
                if (src.asphalt !== undefined && src.asphalt !== null) {
                    dst.asphalt = ng.pile.Asphalt.fromObject(src.asphalt);
                }
                if (src.negativeLevel !== undefined && src.negativeLevel !== null) {
                    if (typeof src.negativeLevel === "number" || src.negativeLevel === 'NaN' || src.negativeLevel === 'Infinity' || src.negativeLevel === '-Infinity') {
                        dst.negativeLevel = AsNum(src.negativeLevel);
                    }
                    else {
                        console.log('Expected negativeLevel of Data to be a number but was ', typeof src.negativeLevel, src.negativeLevel)
                    }
                }
                if (src.maxNegativeForce !== undefined && src.maxNegativeForce !== null) {
                    if (typeof src.maxNegativeForce === "number" || src.maxNegativeForce === 'NaN' || src.maxNegativeForce === 'Infinity' || src.maxNegativeForce === '-Infinity') {
                        dst.maxNegativeForce = AsNum(src.maxNegativeForce);
                    }
                    else {
                        console.log('Expected maxNegativeForce of Data to be a number but was ', typeof src.maxNegativeForce, src.maxNegativeForce)
                    }
                }
                if (src.pileType !== undefined && src.pileType !== null) {
                    dst.pileType = ng.pile.Type_FromObject(src.pileType);
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of Data to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.pile.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.pile.Data") {
                    console.error('Expected ng.pile.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const pileType_obj = ng.pile.Type_ToObject(src.pileType);
                if(pileType_obj === null) return null;

                const dst : Data_json = {
                    bedModule: AsJsonNum(src.bedModule),
                    boreholeGuid: src.boreholeGuid,
                    supportGuid: src.supportGuid,
                    negativeLevel: AsJsonNum(src.negativeLevel),
                    maxNegativeForce: AsJsonNum(src.maxNegativeForce),
                    pileType: pileType_obj,
                    mtrlGuid: src.mtrlGuid,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.geometry !== null)
                {
                    const parsed = ng.pile.Geometry.toObject(src.geometry);
                    if(parsed === null) return null;
                    dst.geometry = parsed;
                }
                if(src.asphalt !== null)
                {
                    const parsed = ng.pile.Asphalt.toObject(src.asphalt);
                    if(parsed === null) return null;
                    dst.asphalt = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.bedModule !== undefined) {
                    dst.bedModule = src.bedModule;
                }
                if (src.boreholeGuid !== undefined) {
                    dst.boreholeGuid = src.boreholeGuid;
                }
                if (src.geometry !== undefined) {
                    dst.geometry = src.geometry;
                }
                if (src.supportGuid !== undefined) {
                    dst.supportGuid = src.supportGuid;
                }
                if (src.asphalt !== undefined) {
                    dst.asphalt = src.asphalt;
                }
                if (src.negativeLevel !== undefined) {
                    dst.negativeLevel = src.negativeLevel;
                }
                if (src.maxNegativeForce !== undefined) {
                    dst.maxNegativeForce = src.maxNegativeForce;
                }
                if (src.pileType !== undefined) {
                    dst.pileType = src.pileType;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.bedModule = this.bedModule;
                dst.boreholeGuid = this.boreholeGuid;
                dst.geometry = this.geometry;
                dst.supportGuid = this.supportGuid;
                dst.asphalt = this.asphalt;
                dst.negativeLevel = this.negativeLevel;
                dst.maxNegativeForce = this.maxNegativeForce;
                dst.pileType = this.pileType;
                dst.mtrlGuid = this.mtrlGuid;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace pile


    // Defined in 5 files
    export namespace frontend {
        // Defined in Frontends/basement_wall.proto
        export namespace basement_wall {
            export enum PrintModule {
                PRINT_MODULE_UNSPECIFIED = 0,
                PRINT_MODULE_SUMMARY = 1,
                PRINT_MODULE_INPUT = 2,
                PRINT_MODULE_ANALYSIS = 3,
                PRINT_MODULE_CONCRETE = 4,
                PRINT_MODULE_STEEL = 5,
                PRINT_MODULE_TIMBER = 6
            }
            export const PrintModule_FromObject = (src: unknown): PrintModule => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_MODULE_UNSPECIFIED':
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                    case 1:
                    case 'PRINT_MODULE_SUMMARY':
                        return PrintModule.PRINT_MODULE_SUMMARY;
                    case 2:
                    case 'PRINT_MODULE_INPUT':
                        return PrintModule.PRINT_MODULE_INPUT;
                    case 3:
                    case 'PRINT_MODULE_ANALYSIS':
                        return PrintModule.PRINT_MODULE_ANALYSIS;
                    case 4:
                    case 'PRINT_MODULE_CONCRETE':
                        return PrintModule.PRINT_MODULE_CONCRETE;
                    case 5:
                    case 'PRINT_MODULE_STEEL':
                        return PrintModule.PRINT_MODULE_STEEL;
                    case 6:
                    case 'PRINT_MODULE_TIMBER':
                        return PrintModule.PRINT_MODULE_TIMBER;
                    default:
                        console.log('Unhandled value for PrintModule:' + src + '. ' + typeof(src));
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                }
            };
            export const PrintModule_ToObject = (src: PrintModule): string | null => {
                switch (src) {
                    case PrintModule.PRINT_MODULE_UNSPECIFIED:
                        return 'PRINT_MODULE_UNSPECIFIED';
                    case PrintModule.PRINT_MODULE_SUMMARY:
                        return 'PRINT_MODULE_SUMMARY';
                    case PrintModule.PRINT_MODULE_INPUT:
                        return 'PRINT_MODULE_INPUT';
                    case PrintModule.PRINT_MODULE_ANALYSIS:
                        return 'PRINT_MODULE_ANALYSIS';
                    case PrintModule.PRINT_MODULE_CONCRETE:
                        return 'PRINT_MODULE_CONCRETE';
                    case PrintModule.PRINT_MODULE_STEEL:
                        return 'PRINT_MODULE_STEEL';
                    case PrintModule.PRINT_MODULE_TIMBER:
                        return 'PRINT_MODULE_TIMBER';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintModule, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum PrintExtent {
                PRINT_EXTENT_UNSPECIFIED = 0,
                PRINT_EXTENT_MINIMAL = 1,
                PRINT_EXTENT_NORMAL = 2,
                PRINT_EXTENT_MAXIMAL = 3
            }
            export const PrintExtent_FromObject = (src: unknown): PrintExtent => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_EXTENT_UNSPECIFIED':
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                    case 1:
                    case 'PRINT_EXTENT_MINIMAL':
                        return PrintExtent.PRINT_EXTENT_MINIMAL;
                    case 2:
                    case 'PRINT_EXTENT_NORMAL':
                        return PrintExtent.PRINT_EXTENT_NORMAL;
                    case 3:
                    case 'PRINT_EXTENT_MAXIMAL':
                        return PrintExtent.PRINT_EXTENT_MAXIMAL;
                    default:
                        console.log('Unhandled value for PrintExtent:' + src + '. ' + typeof(src));
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                }
            };
            export const PrintExtent_ToObject = (src: PrintExtent): string | null => {
                switch (src) {
                    case PrintExtent.PRINT_EXTENT_UNSPECIFIED:
                        return 'PRINT_EXTENT_UNSPECIFIED';
                    case PrintExtent.PRINT_EXTENT_MINIMAL:
                        return 'PRINT_EXTENT_MINIMAL';
                    case PrintExtent.PRINT_EXTENT_NORMAL:
                        return 'PRINT_EXTENT_NORMAL';
                    case PrintExtent.PRINT_EXTENT_MAXIMAL:
                        return 'PRINT_EXTENT_MAXIMAL';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintExtent, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Language {
                LANGUAGE_UNSPECIFIED = 0,
                LANGUAGE_ENGLISH = 1,
                LANGUAGE_SWEDISH = 2
            }
            export const Language_FromObject = (src: unknown): Language => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'LANGUAGE_UNSPECIFIED':
                        return Language.LANGUAGE_UNSPECIFIED;
                    case 1:
                    case 'LANGUAGE_ENGLISH':
                        return Language.LANGUAGE_ENGLISH;
                    case 2:
                    case 'LANGUAGE_SWEDISH':
                        return Language.LANGUAGE_SWEDISH;
                    default:
                        console.log('Unhandled value for Language:' + src + '. ' + typeof(src));
                        return Language.LANGUAGE_UNSPECIFIED;
                }
            };
            export const Language_ToObject = (src: Language): string | null => {
                switch (src) {
                    case Language.LANGUAGE_UNSPECIFIED:
                        return 'LANGUAGE_UNSPECIFIED';
                    case Language.LANGUAGE_ENGLISH:
                        return 'LANGUAGE_ENGLISH';
                    case Language.LANGUAGE_SWEDISH:
                        return 'LANGUAGE_SWEDISH';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Language, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PrintSetting_keys = 'module' | 'extent';
            export interface PrintSetting_createType {
                module?: ng.frontend.basement_wall.PrintModule,
                extent?: ng.frontend.basement_wall.PrintExtent,
            }
            export interface PrintSetting_json {
                module?: string;
                extent?: string;
            }
            interface PrintSetting_json_in {
                __proto_name?: unknown;
                module?: unknown;
                extent?: unknown;
            }
            export class PrintSetting {
                __proto_name = "ng.frontend.basement_wall.PrintSetting";
                module: ng.frontend.basement_wall.PrintModule = ng.frontend.basement_wall.PrintModule.PRINT_MODULE_UNSPECIFIED;
                extent: ng.frontend.basement_wall.PrintExtent = ng.frontend.basement_wall.PrintExtent.PRINT_EXTENT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): PrintSetting {
                    const dst = new PrintSetting();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PrintSetting but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PrintSetting_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PrintSetting but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.module !== undefined && src.module !== null) {
                        dst.module = ng.frontend.basement_wall.PrintModule_FromObject(src.module);
                    }
                    if (src.extent !== undefined && src.extent !== null) {
                        dst.extent = ng.frontend.basement_wall.PrintExtent_FromObject(src.extent);
                    }
                    return dst;
                }

                static toObject(src: PrintSetting | null | undefined): PrintSetting_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.PrintSetting is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.PrintSetting") {
                        console.error('Expected ng.frontend.basement_wall.PrintSetting but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const module_obj = ng.frontend.basement_wall.PrintModule_ToObject(src.module);
                    if(module_obj === null) return null;

                    const extent_obj = ng.frontend.basement_wall.PrintExtent_ToObject(src.extent);
                    if(extent_obj === null) return null;

                    const dst : PrintSetting_json = {
                        module: module_obj,
                        extent: extent_obj,
                    };
                    return dst;
                }

                static create(src?: PrintSetting_createType) {
                    const dst = new PrintSetting();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.module !== undefined) {
                        dst.module = src.module;
                    }
                    if (src.extent !== undefined) {
                        dst.extent = src.extent;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PrintSetting();
                    dst.module = this.module;
                    dst.extent = this.extent;
                    return dst;
                }

                deepClone() {
                    const json = PrintSetting.toObject(this);
                    const dst = PrintSetting.fromObject(json);
                    return dst;
                }
            }
            export type IPrintSetting = PrintSetting;


            export type ViewPortSettings_keys = 'gridSquareSize' | 'snapToGrid' | 'centerLine' | 'centerLineSize' | 'analyseOnSave' | 'snapSense' | 'graphScaleFactor' | 'graphNumberDecimal' | 'invertZoomMouse' | 'majorLineWidth' | 'minorLineWidth' | 'majorLineEach' | 'showLcs' | 'showSectionId' | 'showMaterialId' | 'showFoundationId' | 'showSection' | 'supportSymbols' | 'showFoundationRepresentation' | 'proportionalLoads' | 'language';
            export interface ViewPortSettings_createType {
                gridSquareSize?: number,
                snapToGrid?: boolean,
                centerLine?: boolean,
                centerLineSize?: number,
                analyseOnSave?: boolean,
                snapSense?: number,
                graphScaleFactor?: number,
                graphNumberDecimal?: number,
                invertZoomMouse?: boolean,
                majorLineWidth?: number,
                minorLineWidth?: number,
                majorLineEach?: number,
                showLcs?: boolean,
                showSectionId?: boolean,
                showMaterialId?: boolean,
                showFoundationId?: boolean,
                showSection?: boolean,
                supportSymbols?: boolean,
                showFoundationRepresentation?: boolean,
                proportionalLoads?: boolean,
                language?: ng.frontend.basement_wall.Language,
            }
            export interface ViewPortSettings_json {
                gridSquareSize?: JsonNumber;
                snapToGrid?: boolean;
                centerLine?: boolean;
                centerLineSize?: JsonNumber;
                analyseOnSave?: boolean;
                snapSense?: JsonNumber;
                graphScaleFactor?: JsonNumber;
                graphNumberDecimal?: JsonNumber;
                invertZoomMouse?: boolean;
                majorLineWidth?: JsonNumber;
                minorLineWidth?: JsonNumber;
                majorLineEach?: JsonNumber;
                showLcs?: boolean;
                showSectionId?: boolean;
                showMaterialId?: boolean;
                showFoundationId?: boolean;
                showSection?: boolean;
                supportSymbols?: boolean;
                showFoundationRepresentation?: boolean;
                proportionalLoads?: boolean;
                language?: string;
            }
            interface ViewPortSettings_json_in {
                __proto_name?: unknown;
                gridSquareSize?: unknown;
                snapToGrid?: unknown;
                centerLine?: unknown;
                centerLineSize?: unknown;
                analyseOnSave?: unknown;
                snapSense?: unknown;
                graphScaleFactor?: unknown;
                graphNumberDecimal?: unknown;
                invertZoomMouse?: unknown;
                majorLineWidth?: unknown;
                minorLineWidth?: unknown;
                majorLineEach?: unknown;
                showLcs?: unknown;
                showSectionId?: unknown;
                showMaterialId?: unknown;
                showFoundationId?: unknown;
                showSection?: unknown;
                supportSymbols?: unknown;
                showFoundationRepresentation?: unknown;
                proportionalLoads?: unknown;
                language?: unknown;
            }
            export class ViewPortSettings {
                __proto_name = "ng.frontend.basement_wall.ViewPortSettings";
                gridSquareSize: number = 0;
                snapToGrid: boolean = false;
                centerLine: boolean = false;
                centerLineSize: number = 0;
                analyseOnSave: boolean = false;
                snapSense: number = 0;
                graphScaleFactor: number = 0;
                graphNumberDecimal: number = 0;
                invertZoomMouse: boolean = false;
                majorLineWidth: number = 0;
                minorLineWidth: number = 0;
                majorLineEach: number = 0;
                showLcs: boolean = false;
                showSectionId: boolean = false;
                showMaterialId: boolean = false;
                showFoundationId: boolean = false;
                showSection: boolean = false;
                supportSymbols: boolean = false;
                showFoundationRepresentation: boolean = false;
                proportionalLoads: boolean = false;
                language: ng.frontend.basement_wall.Language = ng.frontend.basement_wall.Language.LANGUAGE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): ViewPortSettings {
                    const dst = new ViewPortSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ViewPortSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ViewPortSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ViewPortSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gridSquareSize !== undefined && src.gridSquareSize !== null) {
                        if (typeof src.gridSquareSize === "number" || src.gridSquareSize === 'NaN' || src.gridSquareSize === 'Infinity' || src.gridSquareSize === '-Infinity') {
                            dst.gridSquareSize = NumberToInt("ng.frontend.basement_wall.ViewPortSettings.grid_square_size", AsNum(src.gridSquareSize));
                        }
                        else {
                            console.log('Expected gridSquareSize of ViewPortSettings to be a number but was ', typeof src.gridSquareSize, src.gridSquareSize)
                        }
                    }
                    if (src.snapToGrid !== undefined && src.snapToGrid !== null) {
                        if (typeof src.snapToGrid === "boolean") {
                            dst.snapToGrid = src.snapToGrid;
                        }
                        else {
                            console.log('Expected snapToGrid of ViewPortSettings to be a boolean but was ', typeof src.snapToGrid, src.snapToGrid)
                        }
                    }
                    if (src.centerLine !== undefined && src.centerLine !== null) {
                        if (typeof src.centerLine === "boolean") {
                            dst.centerLine = src.centerLine;
                        }
                        else {
                            console.log('Expected centerLine of ViewPortSettings to be a boolean but was ', typeof src.centerLine, src.centerLine)
                        }
                    }
                    if (src.centerLineSize !== undefined && src.centerLineSize !== null) {
                        if (typeof src.centerLineSize === "number" || src.centerLineSize === 'NaN' || src.centerLineSize === 'Infinity' || src.centerLineSize === '-Infinity') {
                            dst.centerLineSize = AsNum(src.centerLineSize);
                        }
                        else {
                            console.log('Expected centerLineSize of ViewPortSettings to be a number but was ', typeof src.centerLineSize, src.centerLineSize)
                        }
                    }
                    if (src.analyseOnSave !== undefined && src.analyseOnSave !== null) {
                        if (typeof src.analyseOnSave === "boolean") {
                            dst.analyseOnSave = src.analyseOnSave;
                        }
                        else {
                            console.log('Expected analyseOnSave of ViewPortSettings to be a boolean but was ', typeof src.analyseOnSave, src.analyseOnSave)
                        }
                    }
                    if (src.snapSense !== undefined && src.snapSense !== null) {
                        if (typeof src.snapSense === "number" || src.snapSense === 'NaN' || src.snapSense === 'Infinity' || src.snapSense === '-Infinity') {
                            dst.snapSense = NumberToInt("ng.frontend.basement_wall.ViewPortSettings.snap_sense", AsNum(src.snapSense));
                        }
                        else {
                            console.log('Expected snapSense of ViewPortSettings to be a number but was ', typeof src.snapSense, src.snapSense)
                        }
                    }
                    if (src.graphScaleFactor !== undefined && src.graphScaleFactor !== null) {
                        if (typeof src.graphScaleFactor === "number" || src.graphScaleFactor === 'NaN' || src.graphScaleFactor === 'Infinity' || src.graphScaleFactor === '-Infinity') {
                            dst.graphScaleFactor = AsNum(src.graphScaleFactor);
                        }
                        else {
                            console.log('Expected graphScaleFactor of ViewPortSettings to be a number but was ', typeof src.graphScaleFactor, src.graphScaleFactor)
                        }
                    }
                    if (src.graphNumberDecimal !== undefined && src.graphNumberDecimal !== null) {
                        if (typeof src.graphNumberDecimal === "number" || src.graphNumberDecimal === 'NaN' || src.graphNumberDecimal === 'Infinity' || src.graphNumberDecimal === '-Infinity') {
                            dst.graphNumberDecimal = NumberToInt("ng.frontend.basement_wall.ViewPortSettings.graph_number_decimal", AsNum(src.graphNumberDecimal));
                        }
                        else {
                            console.log('Expected graphNumberDecimal of ViewPortSettings to be a number but was ', typeof src.graphNumberDecimal, src.graphNumberDecimal)
                        }
                    }
                    if (src.invertZoomMouse !== undefined && src.invertZoomMouse !== null) {
                        if (typeof src.invertZoomMouse === "boolean") {
                            dst.invertZoomMouse = src.invertZoomMouse;
                        }
                        else {
                            console.log('Expected invertZoomMouse of ViewPortSettings to be a boolean but was ', typeof src.invertZoomMouse, src.invertZoomMouse)
                        }
                    }
                    if (src.majorLineWidth !== undefined && src.majorLineWidth !== null) {
                        if (typeof src.majorLineWidth === "number" || src.majorLineWidth === 'NaN' || src.majorLineWidth === 'Infinity' || src.majorLineWidth === '-Infinity') {
                            dst.majorLineWidth = AsNum(src.majorLineWidth);
                        }
                        else {
                            console.log('Expected majorLineWidth of ViewPortSettings to be a number but was ', typeof src.majorLineWidth, src.majorLineWidth)
                        }
                    }
                    if (src.minorLineWidth !== undefined && src.minorLineWidth !== null) {
                        if (typeof src.minorLineWidth === "number" || src.minorLineWidth === 'NaN' || src.minorLineWidth === 'Infinity' || src.minorLineWidth === '-Infinity') {
                            dst.minorLineWidth = AsNum(src.minorLineWidth);
                        }
                        else {
                            console.log('Expected minorLineWidth of ViewPortSettings to be a number but was ', typeof src.minorLineWidth, src.minorLineWidth)
                        }
                    }
                    if (src.majorLineEach !== undefined && src.majorLineEach !== null) {
                        if (typeof src.majorLineEach === "number" || src.majorLineEach === 'NaN' || src.majorLineEach === 'Infinity' || src.majorLineEach === '-Infinity') {
                            dst.majorLineEach = NumberToInt("ng.frontend.basement_wall.ViewPortSettings.major_line_each", AsNum(src.majorLineEach));
                        }
                        else {
                            console.log('Expected majorLineEach of ViewPortSettings to be a number but was ', typeof src.majorLineEach, src.majorLineEach)
                        }
                    }
                    if (src.showLcs !== undefined && src.showLcs !== null) {
                        if (typeof src.showLcs === "boolean") {
                            dst.showLcs = src.showLcs;
                        }
                        else {
                            console.log('Expected showLcs of ViewPortSettings to be a boolean but was ', typeof src.showLcs, src.showLcs)
                        }
                    }
                    if (src.showSectionId !== undefined && src.showSectionId !== null) {
                        if (typeof src.showSectionId === "boolean") {
                            dst.showSectionId = src.showSectionId;
                        }
                        else {
                            console.log('Expected showSectionId of ViewPortSettings to be a boolean but was ', typeof src.showSectionId, src.showSectionId)
                        }
                    }
                    if (src.showMaterialId !== undefined && src.showMaterialId !== null) {
                        if (typeof src.showMaterialId === "boolean") {
                            dst.showMaterialId = src.showMaterialId;
                        }
                        else {
                            console.log('Expected showMaterialId of ViewPortSettings to be a boolean but was ', typeof src.showMaterialId, src.showMaterialId)
                        }
                    }
                    if (src.showFoundationId !== undefined && src.showFoundationId !== null) {
                        if (typeof src.showFoundationId === "boolean") {
                            dst.showFoundationId = src.showFoundationId;
                        }
                        else {
                            console.log('Expected showFoundationId of ViewPortSettings to be a boolean but was ', typeof src.showFoundationId, src.showFoundationId)
                        }
                    }
                    if (src.showSection !== undefined && src.showSection !== null) {
                        if (typeof src.showSection === "boolean") {
                            dst.showSection = src.showSection;
                        }
                        else {
                            console.log('Expected showSection of ViewPortSettings to be a boolean but was ', typeof src.showSection, src.showSection)
                        }
                    }
                    if (src.supportSymbols !== undefined && src.supportSymbols !== null) {
                        if (typeof src.supportSymbols === "boolean") {
                            dst.supportSymbols = src.supportSymbols;
                        }
                        else {
                            console.log('Expected supportSymbols of ViewPortSettings to be a boolean but was ', typeof src.supportSymbols, src.supportSymbols)
                        }
                    }
                    if (src.showFoundationRepresentation !== undefined && src.showFoundationRepresentation !== null) {
                        if (typeof src.showFoundationRepresentation === "boolean") {
                            dst.showFoundationRepresentation = src.showFoundationRepresentation;
                        }
                        else {
                            console.log('Expected showFoundationRepresentation of ViewPortSettings to be a boolean but was ', typeof src.showFoundationRepresentation, src.showFoundationRepresentation)
                        }
                    }
                    if (src.proportionalLoads !== undefined && src.proportionalLoads !== null) {
                        if (typeof src.proportionalLoads === "boolean") {
                            dst.proportionalLoads = src.proportionalLoads;
                        }
                        else {
                            console.log('Expected proportionalLoads of ViewPortSettings to be a boolean but was ', typeof src.proportionalLoads, src.proportionalLoads)
                        }
                    }
                    if (src.language !== undefined && src.language !== null) {
                        dst.language = ng.frontend.basement_wall.Language_FromObject(src.language);
                    }
                    return dst;
                }

                static toObject(src: ViewPortSettings | null | undefined): ViewPortSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.ViewPortSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.ViewPortSettings") {
                        console.error('Expected ng.frontend.basement_wall.ViewPortSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const language_obj = ng.frontend.basement_wall.Language_ToObject(src.language);
                    if(language_obj === null) return null;

                    const dst : ViewPortSettings_json = {
                        gridSquareSize: AsJsonNum(NumberToInt("ng.frontend.basement_wall.ViewPortSettings.grid_square_size", src.gridSquareSize)),
                        snapToGrid: src.snapToGrid,
                        centerLine: src.centerLine,
                        centerLineSize: AsJsonNum(src.centerLineSize),
                        analyseOnSave: src.analyseOnSave,
                        snapSense: AsJsonNum(NumberToInt("ng.frontend.basement_wall.ViewPortSettings.snap_sense", src.snapSense)),
                        graphScaleFactor: AsJsonNum(src.graphScaleFactor),
                        graphNumberDecimal: AsJsonNum(NumberToInt("ng.frontend.basement_wall.ViewPortSettings.graph_number_decimal", src.graphNumberDecimal)),
                        invertZoomMouse: src.invertZoomMouse,
                        majorLineWidth: AsJsonNum(src.majorLineWidth),
                        minorLineWidth: AsJsonNum(src.minorLineWidth),
                        majorLineEach: AsJsonNum(NumberToInt("ng.frontend.basement_wall.ViewPortSettings.major_line_each", src.majorLineEach)),
                        showLcs: src.showLcs,
                        showSectionId: src.showSectionId,
                        showMaterialId: src.showMaterialId,
                        showFoundationId: src.showFoundationId,
                        showSection: src.showSection,
                        supportSymbols: src.supportSymbols,
                        showFoundationRepresentation: src.showFoundationRepresentation,
                        proportionalLoads: src.proportionalLoads,
                        language: language_obj,
                    };
                    return dst;
                }

                static create(src?: ViewPortSettings_createType) {
                    const dst = new ViewPortSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gridSquareSize !== undefined) {
                        dst.gridSquareSize = src.gridSquareSize;
                    }
                    if (src.snapToGrid !== undefined) {
                        dst.snapToGrid = src.snapToGrid;
                    }
                    if (src.centerLine !== undefined) {
                        dst.centerLine = src.centerLine;
                    }
                    if (src.centerLineSize !== undefined) {
                        dst.centerLineSize = src.centerLineSize;
                    }
                    if (src.analyseOnSave !== undefined) {
                        dst.analyseOnSave = src.analyseOnSave;
                    }
                    if (src.snapSense !== undefined) {
                        dst.snapSense = src.snapSense;
                    }
                    if (src.graphScaleFactor !== undefined) {
                        dst.graphScaleFactor = src.graphScaleFactor;
                    }
                    if (src.graphNumberDecimal !== undefined) {
                        dst.graphNumberDecimal = src.graphNumberDecimal;
                    }
                    if (src.invertZoomMouse !== undefined) {
                        dst.invertZoomMouse = src.invertZoomMouse;
                    }
                    if (src.majorLineWidth !== undefined) {
                        dst.majorLineWidth = src.majorLineWidth;
                    }
                    if (src.minorLineWidth !== undefined) {
                        dst.minorLineWidth = src.minorLineWidth;
                    }
                    if (src.majorLineEach !== undefined) {
                        dst.majorLineEach = src.majorLineEach;
                    }
                    if (src.showLcs !== undefined) {
                        dst.showLcs = src.showLcs;
                    }
                    if (src.showSectionId !== undefined) {
                        dst.showSectionId = src.showSectionId;
                    }
                    if (src.showMaterialId !== undefined) {
                        dst.showMaterialId = src.showMaterialId;
                    }
                    if (src.showFoundationId !== undefined) {
                        dst.showFoundationId = src.showFoundationId;
                    }
                    if (src.showSection !== undefined) {
                        dst.showSection = src.showSection;
                    }
                    if (src.supportSymbols !== undefined) {
                        dst.supportSymbols = src.supportSymbols;
                    }
                    if (src.showFoundationRepresentation !== undefined) {
                        dst.showFoundationRepresentation = src.showFoundationRepresentation;
                    }
                    if (src.proportionalLoads !== undefined) {
                        dst.proportionalLoads = src.proportionalLoads;
                    }
                    if (src.language !== undefined) {
                        dst.language = src.language;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ViewPortSettings();
                    dst.gridSquareSize = this.gridSquareSize;
                    dst.snapToGrid = this.snapToGrid;
                    dst.centerLine = this.centerLine;
                    dst.centerLineSize = this.centerLineSize;
                    dst.analyseOnSave = this.analyseOnSave;
                    dst.snapSense = this.snapSense;
                    dst.graphScaleFactor = this.graphScaleFactor;
                    dst.graphNumberDecimal = this.graphNumberDecimal;
                    dst.invertZoomMouse = this.invertZoomMouse;
                    dst.majorLineWidth = this.majorLineWidth;
                    dst.minorLineWidth = this.minorLineWidth;
                    dst.majorLineEach = this.majorLineEach;
                    dst.showLcs = this.showLcs;
                    dst.showSectionId = this.showSectionId;
                    dst.showMaterialId = this.showMaterialId;
                    dst.showFoundationId = this.showFoundationId;
                    dst.showSection = this.showSection;
                    dst.supportSymbols = this.supportSymbols;
                    dst.showFoundationRepresentation = this.showFoundationRepresentation;
                    dst.proportionalLoads = this.proportionalLoads;
                    dst.language = this.language;
                    return dst;
                }

                deepClone() {
                    const json = ViewPortSettings.toObject(this);
                    const dst = ViewPortSettings.fromObject(json);
                    return dst;
                }
            }
            export type IViewPortSettings = ViewPortSettings;


            export type UnitSettings_keys = 'length' | 'force';
            export interface UnitSettings_createType {
                length?: string,
                force?: string,
            }
            export interface UnitSettings_json {
                length?: string;
                force?: string;
            }
            interface UnitSettings_json_in {
                __proto_name?: unknown;
                length?: unknown;
                force?: unknown;
            }
            export class UnitSettings {
                __proto_name = "ng.frontend.basement_wall.UnitSettings";
                length: string = "";
                force: string = "";

                static fromObject(src_unknown: unknown): UnitSettings {
                    const dst = new UnitSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted UnitSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as UnitSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for UnitSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.length !== undefined && src.length !== null) {
                        if (typeof src.length === "string") {
                            dst.length = src.length;
                        }
                        else {
                            console.log('Expected length of UnitSettings to be a string but was ', typeof src.length, src.length)
                        }
                    }
                    if (src.force !== undefined && src.force !== null) {
                        if (typeof src.force === "string") {
                            dst.force = src.force;
                        }
                        else {
                            console.log('Expected force of UnitSettings to be a string but was ', typeof src.force, src.force)
                        }
                    }
                    return dst;
                }

                static toObject(src: UnitSettings | null | undefined): UnitSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.UnitSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.UnitSettings") {
                        console.error('Expected ng.frontend.basement_wall.UnitSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : UnitSettings_json = {
                        length: src.length,
                        force: src.force,
                    };
                    return dst;
                }

                static create(src?: UnitSettings_createType) {
                    const dst = new UnitSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.length !== undefined) {
                        dst.length = src.length;
                    }
                    if (src.force !== undefined) {
                        dst.force = src.force;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new UnitSettings();
                    dst.length = this.length;
                    dst.force = this.force;
                    return dst;
                }

                deepClone() {
                    const json = UnitSettings.toObject(this);
                    const dst = UnitSettings.fromObject(json);
                    return dst;
                }
            }
            export type IUnitSettings = UnitSettings;


            export type ColorSettings_keys = 'background' | 'gridLinesMajor' | 'gridLinesMinor' | 'graphPositive' | 'graphNegative';
            export interface ColorSettings_createType {
                background?: string,
                gridLinesMajor?: string,
                gridLinesMinor?: string,
                graphPositive?: string,
                graphNegative?: string,
            }
            export interface ColorSettings_json {
                background?: string;
                gridLinesMajor?: string;
                gridLinesMinor?: string;
                graphPositive?: string;
                graphNegative?: string;
            }
            interface ColorSettings_json_in {
                __proto_name?: unknown;
                background?: unknown;
                gridLinesMajor?: unknown;
                gridLinesMinor?: unknown;
                graphPositive?: unknown;
                graphNegative?: unknown;
            }
            export class ColorSettings {
                __proto_name = "ng.frontend.basement_wall.ColorSettings";
                background: string = "";
                gridLinesMajor: string = "";
                gridLinesMinor: string = "";
                graphPositive: string = "";
                graphNegative: string = "";

                static fromObject(src_unknown: unknown): ColorSettings {
                    const dst = new ColorSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ColorSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ColorSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ColorSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.background !== undefined && src.background !== null) {
                        if (typeof src.background === "string") {
                            dst.background = src.background;
                        }
                        else {
                            console.log('Expected background of ColorSettings to be a string but was ', typeof src.background, src.background)
                        }
                    }
                    if (src.gridLinesMajor !== undefined && src.gridLinesMajor !== null) {
                        if (typeof src.gridLinesMajor === "string") {
                            dst.gridLinesMajor = src.gridLinesMajor;
                        }
                        else {
                            console.log('Expected gridLinesMajor of ColorSettings to be a string but was ', typeof src.gridLinesMajor, src.gridLinesMajor)
                        }
                    }
                    if (src.gridLinesMinor !== undefined && src.gridLinesMinor !== null) {
                        if (typeof src.gridLinesMinor === "string") {
                            dst.gridLinesMinor = src.gridLinesMinor;
                        }
                        else {
                            console.log('Expected gridLinesMinor of ColorSettings to be a string but was ', typeof src.gridLinesMinor, src.gridLinesMinor)
                        }
                    }
                    if (src.graphPositive !== undefined && src.graphPositive !== null) {
                        if (typeof src.graphPositive === "string") {
                            dst.graphPositive = src.graphPositive;
                        }
                        else {
                            console.log('Expected graphPositive of ColorSettings to be a string but was ', typeof src.graphPositive, src.graphPositive)
                        }
                    }
                    if (src.graphNegative !== undefined && src.graphNegative !== null) {
                        if (typeof src.graphNegative === "string") {
                            dst.graphNegative = src.graphNegative;
                        }
                        else {
                            console.log('Expected graphNegative of ColorSettings to be a string but was ', typeof src.graphNegative, src.graphNegative)
                        }
                    }
                    return dst;
                }

                static toObject(src: ColorSettings | null | undefined): ColorSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.ColorSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.ColorSettings") {
                        console.error('Expected ng.frontend.basement_wall.ColorSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ColorSettings_json = {
                        background: src.background,
                        gridLinesMajor: src.gridLinesMajor,
                        gridLinesMinor: src.gridLinesMinor,
                        graphPositive: src.graphPositive,
                        graphNegative: src.graphNegative,
                    };
                    return dst;
                }

                static create(src?: ColorSettings_createType) {
                    const dst = new ColorSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.background !== undefined) {
                        dst.background = src.background;
                    }
                    if (src.gridLinesMajor !== undefined) {
                        dst.gridLinesMajor = src.gridLinesMajor;
                    }
                    if (src.gridLinesMinor !== undefined) {
                        dst.gridLinesMinor = src.gridLinesMinor;
                    }
                    if (src.graphPositive !== undefined) {
                        dst.graphPositive = src.graphPositive;
                    }
                    if (src.graphNegative !== undefined) {
                        dst.graphNegative = src.graphNegative;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ColorSettings();
                    dst.background = this.background;
                    dst.gridLinesMajor = this.gridLinesMajor;
                    dst.gridLinesMinor = this.gridLinesMinor;
                    dst.graphPositive = this.graphPositive;
                    dst.graphNegative = this.graphNegative;
                    return dst;
                }

                deepClone() {
                    const json = ColorSettings.toObject(this);
                    const dst = ColorSettings.fromObject(json);
                    return dst;
                }
            }
            export type IColorSettings = ColorSettings;


            export type ResultSettings_keys = 'diagramScale' | 'showNumericalValuesInGraph' | 'showOnlyMinMax';
            export interface ResultSettings_createType {
                diagramScale?: number,
                showNumericalValuesInGraph?: boolean,
                showOnlyMinMax?: boolean,
            }
            export interface ResultSettings_json {
                diagramScale?: JsonNumber;
                showNumericalValuesInGraph?: boolean;
                showOnlyMinMax?: boolean;
            }
            interface ResultSettings_json_in {
                __proto_name?: unknown;
                diagramScale?: unknown;
                showNumericalValuesInGraph?: unknown;
                showOnlyMinMax?: unknown;
            }
            export class ResultSettings {
                __proto_name = "ng.frontend.basement_wall.ResultSettings";
                diagramScale: number = 0;
                showNumericalValuesInGraph: boolean = false;
                showOnlyMinMax: boolean = false;

                static fromObject(src_unknown: unknown): ResultSettings {
                    const dst = new ResultSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ResultSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ResultSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ResultSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.diagramScale !== undefined && src.diagramScale !== null) {
                        if (typeof src.diagramScale === "number" || src.diagramScale === 'NaN' || src.diagramScale === 'Infinity' || src.diagramScale === '-Infinity') {
                            dst.diagramScale = AsNum(src.diagramScale);
                        }
                        else {
                            console.log('Expected diagramScale of ResultSettings to be a number but was ', typeof src.diagramScale, src.diagramScale)
                        }
                    }
                    if (src.showNumericalValuesInGraph !== undefined && src.showNumericalValuesInGraph !== null) {
                        if (typeof src.showNumericalValuesInGraph === "boolean") {
                            dst.showNumericalValuesInGraph = src.showNumericalValuesInGraph;
                        }
                        else {
                            console.log('Expected showNumericalValuesInGraph of ResultSettings to be a boolean but was ', typeof src.showNumericalValuesInGraph, src.showNumericalValuesInGraph)
                        }
                    }
                    if (src.showOnlyMinMax !== undefined && src.showOnlyMinMax !== null) {
                        if (typeof src.showOnlyMinMax === "boolean") {
                            dst.showOnlyMinMax = src.showOnlyMinMax;
                        }
                        else {
                            console.log('Expected showOnlyMinMax of ResultSettings to be a boolean but was ', typeof src.showOnlyMinMax, src.showOnlyMinMax)
                        }
                    }
                    return dst;
                }

                static toObject(src: ResultSettings | null | undefined): ResultSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.ResultSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.ResultSettings") {
                        console.error('Expected ng.frontend.basement_wall.ResultSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ResultSettings_json = {
                        diagramScale: AsJsonNum(src.diagramScale),
                        showNumericalValuesInGraph: src.showNumericalValuesInGraph,
                        showOnlyMinMax: src.showOnlyMinMax,
                    };
                    return dst;
                }

                static create(src?: ResultSettings_createType) {
                    const dst = new ResultSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.diagramScale !== undefined) {
                        dst.diagramScale = src.diagramScale;
                    }
                    if (src.showNumericalValuesInGraph !== undefined) {
                        dst.showNumericalValuesInGraph = src.showNumericalValuesInGraph;
                    }
                    if (src.showOnlyMinMax !== undefined) {
                        dst.showOnlyMinMax = src.showOnlyMinMax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ResultSettings();
                    dst.diagramScale = this.diagramScale;
                    dst.showNumericalValuesInGraph = this.showNumericalValuesInGraph;
                    dst.showOnlyMinMax = this.showOnlyMinMax;
                    return dst;
                }

                deepClone() {
                    const json = ResultSettings.toObject(this);
                    const dst = ResultSettings.fromObject(json);
                    return dst;
                }
            }
            export type IResultSettings = ResultSettings;


            export type GeneralSettings_keys = 'viewport' | 'unit' | 'colors' | 'result';
            export interface GeneralSettings_createType {
                viewport?: ng.frontend.basement_wall.ViewPortSettings | null,
                unit?: ng.frontend.basement_wall.UnitSettings | null,
                colors?: ng.frontend.basement_wall.ColorSettings | null,
                result?: ng.frontend.basement_wall.ResultSettings | null,
            }
            export interface GeneralSettings_json {
                viewport?: ng.frontend.basement_wall.ViewPortSettings_json;
                unit?: ng.frontend.basement_wall.UnitSettings_json;
                colors?: ng.frontend.basement_wall.ColorSettings_json;
                result?: ng.frontend.basement_wall.ResultSettings_json;
            }
            interface GeneralSettings_json_in {
                __proto_name?: unknown;
                viewport?: unknown;
                unit?: unknown;
                colors?: unknown;
                result?: unknown;
            }
            export class GeneralSettings {
                __proto_name = "ng.frontend.basement_wall.GeneralSettings";
                viewport: ng.frontend.basement_wall.ViewPortSettings | null = null;
                unit: ng.frontend.basement_wall.UnitSettings | null = null;
                colors: ng.frontend.basement_wall.ColorSettings | null = null;
                result: ng.frontend.basement_wall.ResultSettings | null = null;

                static fromObject(src_unknown: unknown): GeneralSettings {
                    const dst = new GeneralSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.viewport !== undefined && src.viewport !== null) {
                        dst.viewport = ng.frontend.basement_wall.ViewPortSettings.fromObject(src.viewport);
                    }
                    if (src.unit !== undefined && src.unit !== null) {
                        dst.unit = ng.frontend.basement_wall.UnitSettings.fromObject(src.unit);
                    }
                    if (src.colors !== undefined && src.colors !== null) {
                        dst.colors = ng.frontend.basement_wall.ColorSettings.fromObject(src.colors);
                    }
                    if (src.result !== undefined && src.result !== null) {
                        dst.result = ng.frontend.basement_wall.ResultSettings.fromObject(src.result);
                    }
                    return dst;
                }

                static toObject(src: GeneralSettings | null | undefined): GeneralSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.GeneralSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.GeneralSettings") {
                        console.error('Expected ng.frontend.basement_wall.GeneralSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GeneralSettings_json = {
                    };
                    if(src.viewport !== null)
                    {
                        const parsed = ng.frontend.basement_wall.ViewPortSettings.toObject(src.viewport);
                        if(parsed === null) return null;
                        dst.viewport = parsed;
                    }
                    if(src.unit !== null)
                    {
                        const parsed = ng.frontend.basement_wall.UnitSettings.toObject(src.unit);
                        if(parsed === null) return null;
                        dst.unit = parsed;
                    }
                    if(src.colors !== null)
                    {
                        const parsed = ng.frontend.basement_wall.ColorSettings.toObject(src.colors);
                        if(parsed === null) return null;
                        dst.colors = parsed;
                    }
                    if(src.result !== null)
                    {
                        const parsed = ng.frontend.basement_wall.ResultSettings.toObject(src.result);
                        if(parsed === null) return null;
                        dst.result = parsed;
                    }
                    return dst;
                }

                static create(src?: GeneralSettings_createType) {
                    const dst = new GeneralSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.viewport !== undefined) {
                        dst.viewport = src.viewport;
                    }
                    if (src.unit !== undefined) {
                        dst.unit = src.unit;
                    }
                    if (src.colors !== undefined) {
                        dst.colors = src.colors;
                    }
                    if (src.result !== undefined) {
                        dst.result = src.result;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralSettings();
                    dst.viewport = this.viewport;
                    dst.unit = this.unit;
                    dst.colors = this.colors;
                    dst.result = this.result;
                    return dst;
                }

                deepClone() {
                    const json = GeneralSettings.toObject(this);
                    const dst = GeneralSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralSettings = GeneralSettings;


            export type FrontendData_keys = 'printSettings' | 'apiCreatedLoadcases';
            export interface FrontendData_createType {
                printSettings?: ng.frontend.basement_wall.PrintSetting[],
                apiCreatedLoadcases?: string[],
            }
            export interface FrontendData_json {
                printSettings: ng.frontend.basement_wall.PrintSetting_json[];
                apiCreatedLoadcases: string[];
            }
            interface FrontendData_json_in {
                __proto_name?: unknown;
                printSettings?: unknown;
                apiCreatedLoadcases?: unknown;
            }
            export class FrontendData {
                __proto_name = "ng.frontend.basement_wall.FrontendData";
                printSettings: ng.frontend.basement_wall.PrintSetting[] = [];
                apiCreatedLoadcases: string[] = [];

                static fromObject(src_unknown: unknown): FrontendData {
                    const dst = new FrontendData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FrontendData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FrontendData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FrontendData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.printSettings !== undefined && src.printSettings !== null) {
                        if (Array.isArray(src.printSettings)) {
                            for (const element of src.printSettings) {
                                dst.printSettings.push(ng.frontend.basement_wall.PrintSetting.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected printSettings of FrontendData to be a array but was ', typeof src.printSettings, src.printSettings)
                        }
                    }
                    if (src.apiCreatedLoadcases !== undefined && src.apiCreatedLoadcases !== null) {
                        if (Array.isArray(src.apiCreatedLoadcases)) {
                            for (const [index, element] of src.apiCreatedLoadcases.entries()) {
                                if (typeof element === "string") {
                                    dst.apiCreatedLoadcases.push(element);
                                }
                                else {
                                    console.log('Expected apiCreatedLoadcases of FrontendData[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected apiCreatedLoadcases of FrontendData to be a array but was ', typeof src.apiCreatedLoadcases, src.apiCreatedLoadcases)
                        }
                    }
                    return dst;
                }

                static toObject(src: FrontendData | null | undefined): FrontendData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.FrontendData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.FrontendData") {
                        console.error('Expected ng.frontend.basement_wall.FrontendData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FrontendData_json = {
                        printSettings: new Array<ng.frontend.basement_wall.PrintSetting_json>(),
                        apiCreatedLoadcases: new Array<string>(),
                    };
                    if (src.printSettings !== null) {
                        for (const element of src.printSettings) {
                            const parsed = ng.frontend.basement_wall.PrintSetting.toObject(element);
                            if(parsed === null) return null;
                            dst.printSettings.push(parsed);
                        }
                    }
                    if (src.apiCreatedLoadcases !== null) {
                        for (const element of src.apiCreatedLoadcases) {
                            dst.apiCreatedLoadcases.push(element);
                        }
                    }
                    return dst;
                }

                static create(src?: FrontendData_createType) {
                    const dst = new FrontendData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.printSettings !== undefined) {
                        dst.printSettings = src.printSettings;
                    }
                    if (src.apiCreatedLoadcases !== undefined) {
                        dst.apiCreatedLoadcases = src.apiCreatedLoadcases;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FrontendData();
                    dst.printSettings = this.printSettings;
                    dst.apiCreatedLoadcases = this.apiCreatedLoadcases;
                    return dst;
                }

                deepClone() {
                    const json = FrontendData.toObject(this);
                    const dst = FrontendData.fromObject(json);
                    return dst;
                }
            }
            export type IFrontendData = FrontendData;


            export type ProjectMeta_keys = 'guid' | 'name' | 'eTag' | 'revision' | 'description' | 'author' | 'company' | 'created' | 'signature' | 'comments' | 'keywords' | 'appVersion' | 'buildNumber' | 'lastModified' | 'modifiedBy' | 'location' | 'project' | 'projectNumber' | 'app';
            export interface ProjectMeta_createType {
                guid?: string,
                name?: string,
                eTag?: string,
                revision?: number,
                description?: string,
                author?: string,
                company?: string,
                created?: string,
                signature?: string,
                comments?: string,
                keywords?: string[],
                appVersion?: ng.utils.SemVer | null,
                buildNumber?: string,
                lastModified?: string,
                modifiedBy?: string,
                location?: string,
                project?: string,
                projectNumber?: string,
                app?: ng.frontend.general.SimplexApp,
            }
            export interface ProjectMeta_json {
                guid?: string;
                name?: string;
                eTag?: string;
                revision?: JsonNumber;
                description?: string;
                author?: string;
                company?: string;
                created?: string;
                signature?: string;
                comments?: string;
                keywords: string[];
                appVersion?: ng.utils.SemVer_json;
                buildNumber?: string;
                lastModified?: string;
                modifiedBy?: string;
                location?: string;
                project?: string;
                projectNumber?: string;
                app?: string;
            }
            interface ProjectMeta_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                name?: unknown;
                eTag?: unknown;
                revision?: unknown;
                description?: unknown;
                author?: unknown;
                company?: unknown;
                created?: unknown;
                signature?: unknown;
                comments?: unknown;
                keywords?: unknown;
                appVersion?: unknown;
                buildNumber?: unknown;
                lastModified?: unknown;
                modifiedBy?: unknown;
                location?: unknown;
                project?: unknown;
                projectNumber?: unknown;
                app?: unknown;
            }
            export class ProjectMeta {
                __proto_name = "ng.frontend.basement_wall.ProjectMeta";
                guid: string = "";
                name: string = "";
                eTag: string = "";
                revision: number = 0;
                description: string = "";
                author: string = "";
                company: string = "";
                created: string = "";
                signature: string = "";
                comments: string = "";
                keywords: string[] = [];
                appVersion: ng.utils.SemVer | null = null;
                buildNumber: string = "";
                lastModified: string = "";
                modifiedBy: string = "";
                location: string = "";
                project: string = "";
                projectNumber: string = "";
                app: ng.frontend.general.SimplexApp = ng.frontend.general.SimplexApp.SIMPLEX_APP_UNSPECIFIED;

                static fromObject(src_unknown: unknown): ProjectMeta {
                    const dst = new ProjectMeta();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ProjectMeta but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ProjectMeta_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ProjectMeta but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of ProjectMeta to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.name !== undefined && src.name !== null) {
                        if (typeof src.name === "string") {
                            dst.name = src.name;
                        }
                        else {
                            console.log('Expected name of ProjectMeta to be a string but was ', typeof src.name, src.name)
                        }
                    }
                    if (src.eTag !== undefined && src.eTag !== null) {
                        if (typeof src.eTag === "string") {
                            dst.eTag = src.eTag;
                        }
                        else {
                            console.log('Expected eTag of ProjectMeta to be a string but was ', typeof src.eTag, src.eTag)
                        }
                    }
                    if (src.revision !== undefined && src.revision !== null) {
                        if (typeof src.revision === "number" || src.revision === 'NaN' || src.revision === 'Infinity' || src.revision === '-Infinity') {
                            dst.revision = NumberToInt("ng.frontend.basement_wall.ProjectMeta.revision", AsNum(src.revision));
                        }
                        else {
                            console.log('Expected revision of ProjectMeta to be a number but was ', typeof src.revision, src.revision)
                        }
                    }
                    if (src.description !== undefined && src.description !== null) {
                        if (typeof src.description === "string") {
                            dst.description = src.description;
                        }
                        else {
                            console.log('Expected description of ProjectMeta to be a string but was ', typeof src.description, src.description)
                        }
                    }
                    if (src.author !== undefined && src.author !== null) {
                        if (typeof src.author === "string") {
                            dst.author = src.author;
                        }
                        else {
                            console.log('Expected author of ProjectMeta to be a string but was ', typeof src.author, src.author)
                        }
                    }
                    if (src.company !== undefined && src.company !== null) {
                        if (typeof src.company === "string") {
                            dst.company = src.company;
                        }
                        else {
                            console.log('Expected company of ProjectMeta to be a string but was ', typeof src.company, src.company)
                        }
                    }
                    if (src.created !== undefined && src.created !== null) {
                        if (typeof src.created === "string") {
                            dst.created = src.created;
                        }
                        else {
                            console.log('Expected created of ProjectMeta to be a string but was ', typeof src.created, src.created)
                        }
                    }
                    if (src.signature !== undefined && src.signature !== null) {
                        if (typeof src.signature === "string") {
                            dst.signature = src.signature;
                        }
                        else {
                            console.log('Expected signature of ProjectMeta to be a string but was ', typeof src.signature, src.signature)
                        }
                    }
                    if (src.comments !== undefined && src.comments !== null) {
                        if (typeof src.comments === "string") {
                            dst.comments = src.comments;
                        }
                        else {
                            console.log('Expected comments of ProjectMeta to be a string but was ', typeof src.comments, src.comments)
                        }
                    }
                    if (src.keywords !== undefined && src.keywords !== null) {
                        if (Array.isArray(src.keywords)) {
                            for (const [index, element] of src.keywords.entries()) {
                                if (typeof element === "string") {
                                    dst.keywords.push(element);
                                }
                                else {
                                    console.log('Expected keywords of ProjectMeta[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected keywords of ProjectMeta to be a array but was ', typeof src.keywords, src.keywords)
                        }
                    }
                    if (src.appVersion !== undefined && src.appVersion !== null) {
                        dst.appVersion = ng.utils.SemVer.fromObject(src.appVersion);
                    }
                    if (src.buildNumber !== undefined && src.buildNumber !== null) {
                        if (typeof src.buildNumber === "string") {
                            dst.buildNumber = src.buildNumber;
                        }
                        else {
                            console.log('Expected buildNumber of ProjectMeta to be a string but was ', typeof src.buildNumber, src.buildNumber)
                        }
                    }
                    if (src.lastModified !== undefined && src.lastModified !== null) {
                        if (typeof src.lastModified === "string") {
                            dst.lastModified = src.lastModified;
                        }
                        else {
                            console.log('Expected lastModified of ProjectMeta to be a string but was ', typeof src.lastModified, src.lastModified)
                        }
                    }
                    if (src.modifiedBy !== undefined && src.modifiedBy !== null) {
                        if (typeof src.modifiedBy === "string") {
                            dst.modifiedBy = src.modifiedBy;
                        }
                        else {
                            console.log('Expected modifiedBy of ProjectMeta to be a string but was ', typeof src.modifiedBy, src.modifiedBy)
                        }
                    }
                    if (src.location !== undefined && src.location !== null) {
                        if (typeof src.location === "string") {
                            dst.location = src.location;
                        }
                        else {
                            console.log('Expected location of ProjectMeta to be a string but was ', typeof src.location, src.location)
                        }
                    }
                    if (src.project !== undefined && src.project !== null) {
                        if (typeof src.project === "string") {
                            dst.project = src.project;
                        }
                        else {
                            console.log('Expected project of ProjectMeta to be a string but was ', typeof src.project, src.project)
                        }
                    }
                    if (src.projectNumber !== undefined && src.projectNumber !== null) {
                        if (typeof src.projectNumber === "string") {
                            dst.projectNumber = src.projectNumber;
                        }
                        else {
                            console.log('Expected projectNumber of ProjectMeta to be a string but was ', typeof src.projectNumber, src.projectNumber)
                        }
                    }
                    if (src.app !== undefined && src.app !== null) {
                        dst.app = ng.frontend.general.SimplexApp_FromObject(src.app);
                    }
                    return dst;
                }

                static toObject(src: ProjectMeta | null | undefined): ProjectMeta_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.ProjectMeta is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.ProjectMeta") {
                        console.error('Expected ng.frontend.basement_wall.ProjectMeta but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const app_obj = ng.frontend.general.SimplexApp_ToObject(src.app);
                    if(app_obj === null) return null;

                    const dst : ProjectMeta_json = {
                        guid: src.guid,
                        name: src.name,
                        eTag: src.eTag,
                        revision: AsJsonNum(NumberToInt("ng.frontend.basement_wall.ProjectMeta.revision", src.revision)),
                        description: src.description,
                        author: src.author,
                        company: src.company,
                        created: src.created,
                        signature: src.signature,
                        comments: src.comments,
                        keywords: new Array<string>(),
                        buildNumber: src.buildNumber,
                        lastModified: src.lastModified,
                        modifiedBy: src.modifiedBy,
                        location: src.location,
                        project: src.project,
                        projectNumber: src.projectNumber,
                        app: app_obj,
                    };
                    if (src.keywords !== null) {
                        for (const element of src.keywords) {
                            dst.keywords.push(element);
                        }
                    }
                    if(src.appVersion !== null)
                    {
                        const parsed = ng.utils.SemVer.toObject(src.appVersion);
                        if(parsed === null) return null;
                        dst.appVersion = parsed;
                    }
                    return dst;
                }

                static create(src?: ProjectMeta_createType) {
                    const dst = new ProjectMeta();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.name !== undefined) {
                        dst.name = src.name;
                    }
                    if (src.eTag !== undefined) {
                        dst.eTag = src.eTag;
                    }
                    if (src.revision !== undefined) {
                        dst.revision = src.revision;
                    }
                    if (src.description !== undefined) {
                        dst.description = src.description;
                    }
                    if (src.author !== undefined) {
                        dst.author = src.author;
                    }
                    if (src.company !== undefined) {
                        dst.company = src.company;
                    }
                    if (src.created !== undefined) {
                        dst.created = src.created;
                    }
                    if (src.signature !== undefined) {
                        dst.signature = src.signature;
                    }
                    if (src.comments !== undefined) {
                        dst.comments = src.comments;
                    }
                    if (src.keywords !== undefined) {
                        dst.keywords = src.keywords;
                    }
                    if (src.appVersion !== undefined) {
                        dst.appVersion = src.appVersion;
                    }
                    if (src.buildNumber !== undefined) {
                        dst.buildNumber = src.buildNumber;
                    }
                    if (src.lastModified !== undefined) {
                        dst.lastModified = src.lastModified;
                    }
                    if (src.modifiedBy !== undefined) {
                        dst.modifiedBy = src.modifiedBy;
                    }
                    if (src.location !== undefined) {
                        dst.location = src.location;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.projectNumber !== undefined) {
                        dst.projectNumber = src.projectNumber;
                    }
                    if (src.app !== undefined) {
                        dst.app = src.app;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ProjectMeta();
                    dst.guid = this.guid;
                    dst.name = this.name;
                    dst.eTag = this.eTag;
                    dst.revision = this.revision;
                    dst.description = this.description;
                    dst.author = this.author;
                    dst.company = this.company;
                    dst.created = this.created;
                    dst.signature = this.signature;
                    dst.comments = this.comments;
                    dst.keywords = this.keywords;
                    dst.appVersion = this.appVersion;
                    dst.buildNumber = this.buildNumber;
                    dst.lastModified = this.lastModified;
                    dst.modifiedBy = this.modifiedBy;
                    dst.location = this.location;
                    dst.project = this.project;
                    dst.projectNumber = this.projectNumber;
                    dst.app = this.app;
                    return dst;
                }

                deepClone() {
                    const json = ProjectMeta.toObject(this);
                    const dst = ProjectMeta.fromObject(json);
                    return dst;
                }
            }
            export type IProjectMeta = ProjectMeta;


            export type Project_keys = 'meta' | 'data' | 'settings';
            export interface Project_createType {
                meta?: ng.frontend.basement_wall.ProjectMeta | null,
                data?: ng.project.Data | null,
                settings?: ng.frontend.basement_wall.FrontendData | null,
            }
            export interface Project_json {
                meta?: ng.frontend.basement_wall.ProjectMeta_json;
                data?: ng.project.Data_json;
                settings?: ng.frontend.basement_wall.FrontendData_json;
            }
            interface Project_json_in {
                __proto_name?: unknown;
                meta?: unknown;
                data?: unknown;
                settings?: unknown;
            }
            export class Project {
                __proto_name = "ng.frontend.basement_wall.Project";
                meta: ng.frontend.basement_wall.ProjectMeta | null = null;
                data: ng.project.Data | null = null;
                settings: ng.frontend.basement_wall.FrontendData | null = null;

                static fromObject(src_unknown: unknown): Project {
                    const dst = new Project();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Project but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Project_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Project but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.meta !== undefined && src.meta !== null) {
                        dst.meta = ng.frontend.basement_wall.ProjectMeta.fromObject(src.meta);
                    }
                    if (src.data !== undefined && src.data !== null) {
                        dst.data = ng.project.Data.fromObject(src.data);
                    }
                    if (src.settings !== undefined && src.settings !== null) {
                        dst.settings = ng.frontend.basement_wall.FrontendData.fromObject(src.settings);
                    }
                    return dst;
                }

                static toObject(src: Project | null | undefined): Project_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.basement_wall.Project is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.basement_wall.Project") {
                        console.error('Expected ng.frontend.basement_wall.Project but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Project_json = {
                    };
                    if(src.meta !== null)
                    {
                        const parsed = ng.frontend.basement_wall.ProjectMeta.toObject(src.meta);
                        if(parsed === null) return null;
                        dst.meta = parsed;
                    }
                    if(src.data !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.data);
                        if(parsed === null) return null;
                        dst.data = parsed;
                    }
                    if(src.settings !== null)
                    {
                        const parsed = ng.frontend.basement_wall.FrontendData.toObject(src.settings);
                        if(parsed === null) return null;
                        dst.settings = parsed;
                    }
                    return dst;
                }

                static create(src?: Project_createType) {
                    const dst = new Project();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.meta !== undefined) {
                        dst.meta = src.meta;
                    }
                    if (src.data !== undefined) {
                        dst.data = src.data;
                    }
                    if (src.settings !== undefined) {
                        dst.settings = src.settings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Project();
                    dst.meta = this.meta;
                    dst.data = this.data;
                    dst.settings = this.settings;
                    return dst;
                }

                deepClone() {
                    const json = Project.toObject(this);
                    const dst = Project.fromObject(json);
                    return dst;
                }
            }
            export type IProject = Project;
        } // namespace basement_wall


        // Defined in Frontends/general.proto
        export namespace general {
            export enum SimplexApp {
                SIMPLEX_APP_UNSPECIFIED = 0,
                SIMPLEX_APP_CENTER = 1,
                SIMPLEX_APP_BEAM = 2,
                SIMPLEX_APP_FOUNDATION = 3,
                SIMPLEX_APP_COLUMN = 4,
                SIMPLEX_APP_FRAME = 5,
                SIMPLEX_APP_BASEMENT_WALL = 6,
                SIMPLEX_APP_RETAININGWALL = 7,
                SIMPLEX_APP_SECTION = 8,
                SIMPLEX_APP_PILE = 9,
                SIMPLEX_APP_CPT = 10
            }
            export const SimplexApp_FromObject = (src: unknown): SimplexApp => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SIMPLEX_APP_UNSPECIFIED':
                        return SimplexApp.SIMPLEX_APP_UNSPECIFIED;
                    case 1:
                    case 'SIMPLEX_APP_CENTER':
                        return SimplexApp.SIMPLEX_APP_CENTER;
                    case 2:
                    case 'SIMPLEX_APP_BEAM':
                        return SimplexApp.SIMPLEX_APP_BEAM;
                    case 3:
                    case 'SIMPLEX_APP_FOUNDATION':
                        return SimplexApp.SIMPLEX_APP_FOUNDATION;
                    case 4:
                    case 'SIMPLEX_APP_COLUMN':
                        return SimplexApp.SIMPLEX_APP_COLUMN;
                    case 5:
                    case 'SIMPLEX_APP_FRAME':
                        return SimplexApp.SIMPLEX_APP_FRAME;
                    case 6:
                    case 'SIMPLEX_APP_BASEMENT_WALL':
                        return SimplexApp.SIMPLEX_APP_BASEMENT_WALL;
                    case 7:
                    case 'SIMPLEX_APP_RETAININGWALL':
                        return SimplexApp.SIMPLEX_APP_RETAININGWALL;
                    case 8:
                    case 'SIMPLEX_APP_SECTION':
                        return SimplexApp.SIMPLEX_APP_SECTION;
                    case 9:
                    case 'SIMPLEX_APP_PILE':
                        return SimplexApp.SIMPLEX_APP_PILE;
                    case 10:
                    case 'SIMPLEX_APP_CPT':
                        return SimplexApp.SIMPLEX_APP_CPT;
                    default:
                        console.log('Unhandled value for SimplexApp:' + src + '. ' + typeof(src));
                        return SimplexApp.SIMPLEX_APP_UNSPECIFIED;
                }
            };
            export const SimplexApp_ToObject = (src: SimplexApp): string | null => {
                switch (src) {
                    case SimplexApp.SIMPLEX_APP_UNSPECIFIED:
                        return 'SIMPLEX_APP_UNSPECIFIED';
                    case SimplexApp.SIMPLEX_APP_CENTER:
                        return 'SIMPLEX_APP_CENTER';
                    case SimplexApp.SIMPLEX_APP_BEAM:
                        return 'SIMPLEX_APP_BEAM';
                    case SimplexApp.SIMPLEX_APP_FOUNDATION:
                        return 'SIMPLEX_APP_FOUNDATION';
                    case SimplexApp.SIMPLEX_APP_COLUMN:
                        return 'SIMPLEX_APP_COLUMN';
                    case SimplexApp.SIMPLEX_APP_FRAME:
                        return 'SIMPLEX_APP_FRAME';
                    case SimplexApp.SIMPLEX_APP_BASEMENT_WALL:
                        return 'SIMPLEX_APP_BASEMENT_WALL';
                    case SimplexApp.SIMPLEX_APP_RETAININGWALL:
                        return 'SIMPLEX_APP_RETAININGWALL';
                    case SimplexApp.SIMPLEX_APP_SECTION:
                        return 'SIMPLEX_APP_SECTION';
                    case SimplexApp.SIMPLEX_APP_PILE:
                        return 'SIMPLEX_APP_PILE';
                    case SimplexApp.SIMPLEX_APP_CPT:
                        return 'SIMPLEX_APP_CPT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for SimplexApp, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };
        } // namespace general


        // Defined in Frontends/foundation.proto
        export namespace foundation {
            export enum PrintModule {
                PRINT_MODULE_UNSPECIFIED = 0,
                PRINT_MODULE_SUMMARY = 1,
                PRINT_MODULE_INPUT = 2,
                PRINT_MODULE_ANALYSIS = 3,
                PRINT_MODULE_CONCRETE = 4,
                PRINT_MODULE_STEEL = 5,
                PRINT_MODULE_TIMBER = 6
            }
            export const PrintModule_FromObject = (src: unknown): PrintModule => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_MODULE_UNSPECIFIED':
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                    case 1:
                    case 'PRINT_MODULE_SUMMARY':
                        return PrintModule.PRINT_MODULE_SUMMARY;
                    case 2:
                    case 'PRINT_MODULE_INPUT':
                        return PrintModule.PRINT_MODULE_INPUT;
                    case 3:
                    case 'PRINT_MODULE_ANALYSIS':
                        return PrintModule.PRINT_MODULE_ANALYSIS;
                    case 4:
                    case 'PRINT_MODULE_CONCRETE':
                        return PrintModule.PRINT_MODULE_CONCRETE;
                    case 5:
                    case 'PRINT_MODULE_STEEL':
                        return PrintModule.PRINT_MODULE_STEEL;
                    case 6:
                    case 'PRINT_MODULE_TIMBER':
                        return PrintModule.PRINT_MODULE_TIMBER;
                    default:
                        console.log('Unhandled value for PrintModule:' + src + '. ' + typeof(src));
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                }
            };
            export const PrintModule_ToObject = (src: PrintModule): string | null => {
                switch (src) {
                    case PrintModule.PRINT_MODULE_UNSPECIFIED:
                        return 'PRINT_MODULE_UNSPECIFIED';
                    case PrintModule.PRINT_MODULE_SUMMARY:
                        return 'PRINT_MODULE_SUMMARY';
                    case PrintModule.PRINT_MODULE_INPUT:
                        return 'PRINT_MODULE_INPUT';
                    case PrintModule.PRINT_MODULE_ANALYSIS:
                        return 'PRINT_MODULE_ANALYSIS';
                    case PrintModule.PRINT_MODULE_CONCRETE:
                        return 'PRINT_MODULE_CONCRETE';
                    case PrintModule.PRINT_MODULE_STEEL:
                        return 'PRINT_MODULE_STEEL';
                    case PrintModule.PRINT_MODULE_TIMBER:
                        return 'PRINT_MODULE_TIMBER';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintModule, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum PrintExtent {
                PRINT_EXTENT_UNSPECIFIED = 0,
                PRINT_EXTENT_MINIMAL = 1,
                PRINT_EXTENT_NORMAL = 2,
                PRINT_EXTENT_MAXIMAL = 3
            }
            export const PrintExtent_FromObject = (src: unknown): PrintExtent => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_EXTENT_UNSPECIFIED':
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                    case 1:
                    case 'PRINT_EXTENT_MINIMAL':
                        return PrintExtent.PRINT_EXTENT_MINIMAL;
                    case 2:
                    case 'PRINT_EXTENT_NORMAL':
                        return PrintExtent.PRINT_EXTENT_NORMAL;
                    case 3:
                    case 'PRINT_EXTENT_MAXIMAL':
                        return PrintExtent.PRINT_EXTENT_MAXIMAL;
                    default:
                        console.log('Unhandled value for PrintExtent:' + src + '. ' + typeof(src));
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                }
            };
            export const PrintExtent_ToObject = (src: PrintExtent): string | null => {
                switch (src) {
                    case PrintExtent.PRINT_EXTENT_UNSPECIFIED:
                        return 'PRINT_EXTENT_UNSPECIFIED';
                    case PrintExtent.PRINT_EXTENT_MINIMAL:
                        return 'PRINT_EXTENT_MINIMAL';
                    case PrintExtent.PRINT_EXTENT_NORMAL:
                        return 'PRINT_EXTENT_NORMAL';
                    case PrintExtent.PRINT_EXTENT_MAXIMAL:
                        return 'PRINT_EXTENT_MAXIMAL';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintExtent, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Language {
                LANGUAGE_UNSPECIFIED = 0,
                LANGUAGE_ENGLISH = 1,
                LANGUAGE_SWEDISH = 2
            }
            export const Language_FromObject = (src: unknown): Language => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'LANGUAGE_UNSPECIFIED':
                        return Language.LANGUAGE_UNSPECIFIED;
                    case 1:
                    case 'LANGUAGE_ENGLISH':
                        return Language.LANGUAGE_ENGLISH;
                    case 2:
                    case 'LANGUAGE_SWEDISH':
                        return Language.LANGUAGE_SWEDISH;
                    default:
                        console.log('Unhandled value for Language:' + src + '. ' + typeof(src));
                        return Language.LANGUAGE_UNSPECIFIED;
                }
            };
            export const Language_ToObject = (src: Language): string | null => {
                switch (src) {
                    case Language.LANGUAGE_UNSPECIFIED:
                        return 'LANGUAGE_UNSPECIFIED';
                    case Language.LANGUAGE_ENGLISH:
                        return 'LANGUAGE_ENGLISH';
                    case Language.LANGUAGE_SWEDISH:
                        return 'LANGUAGE_SWEDISH';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Language, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PrintSetting_keys = 'module' | 'extent';
            export interface PrintSetting_createType {
                module?: ng.frontend.foundation.PrintModule,
                extent?: ng.frontend.foundation.PrintExtent,
            }
            export interface PrintSetting_json {
                module?: string;
                extent?: string;
            }
            interface PrintSetting_json_in {
                __proto_name?: unknown;
                module?: unknown;
                extent?: unknown;
            }
            export class PrintSetting {
                __proto_name = "ng.frontend.foundation.PrintSetting";
                module: ng.frontend.foundation.PrintModule = ng.frontend.foundation.PrintModule.PRINT_MODULE_UNSPECIFIED;
                extent: ng.frontend.foundation.PrintExtent = ng.frontend.foundation.PrintExtent.PRINT_EXTENT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): PrintSetting {
                    const dst = new PrintSetting();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PrintSetting but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PrintSetting_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PrintSetting but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.module !== undefined && src.module !== null) {
                        dst.module = ng.frontend.foundation.PrintModule_FromObject(src.module);
                    }
                    if (src.extent !== undefined && src.extent !== null) {
                        dst.extent = ng.frontend.foundation.PrintExtent_FromObject(src.extent);
                    }
                    return dst;
                }

                static toObject(src: PrintSetting | null | undefined): PrintSetting_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.PrintSetting is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.PrintSetting") {
                        console.error('Expected ng.frontend.foundation.PrintSetting but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const module_obj = ng.frontend.foundation.PrintModule_ToObject(src.module);
                    if(module_obj === null) return null;

                    const extent_obj = ng.frontend.foundation.PrintExtent_ToObject(src.extent);
                    if(extent_obj === null) return null;

                    const dst : PrintSetting_json = {
                        module: module_obj,
                        extent: extent_obj,
                    };
                    return dst;
                }

                static create(src?: PrintSetting_createType) {
                    const dst = new PrintSetting();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.module !== undefined) {
                        dst.module = src.module;
                    }
                    if (src.extent !== undefined) {
                        dst.extent = src.extent;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PrintSetting();
                    dst.module = this.module;
                    dst.extent = this.extent;
                    return dst;
                }

                deepClone() {
                    const json = PrintSetting.toObject(this);
                    const dst = PrintSetting.fromObject(json);
                    return dst;
                }
            }
            export type IPrintSetting = PrintSetting;


            export type ViewPortSettings_keys = 'gridSquareSize' | 'snapToGrid' | 'centerLine' | 'centerLineSize' | 'analyseOnSave' | 'snapSense' | 'graphScaleFactor' | 'graphNumberDecimal' | 'invertZoomMouse' | 'majorLineWidth' | 'minorLineWidth' | 'majorLineEach' | 'showLcs' | 'showSectionId' | 'showMaterialId' | 'showFoundationId' | 'showSection' | 'supportSymbols' | 'showFoundationRepresentation' | 'proportionalLoads' | 'language';
            export interface ViewPortSettings_createType {
                gridSquareSize?: number,
                snapToGrid?: boolean,
                centerLine?: boolean,
                centerLineSize?: number,
                analyseOnSave?: boolean,
                snapSense?: number,
                graphScaleFactor?: number,
                graphNumberDecimal?: number,
                invertZoomMouse?: boolean,
                majorLineWidth?: number,
                minorLineWidth?: number,
                majorLineEach?: number,
                showLcs?: boolean,
                showSectionId?: boolean,
                showMaterialId?: boolean,
                showFoundationId?: boolean,
                showSection?: boolean,
                supportSymbols?: boolean,
                showFoundationRepresentation?: boolean,
                proportionalLoads?: boolean,
                language?: ng.frontend.foundation.Language,
            }
            export interface ViewPortSettings_json {
                gridSquareSize?: JsonNumber;
                snapToGrid?: boolean;
                centerLine?: boolean;
                centerLineSize?: JsonNumber;
                analyseOnSave?: boolean;
                snapSense?: JsonNumber;
                graphScaleFactor?: JsonNumber;
                graphNumberDecimal?: JsonNumber;
                invertZoomMouse?: boolean;
                majorLineWidth?: JsonNumber;
                minorLineWidth?: JsonNumber;
                majorLineEach?: JsonNumber;
                showLcs?: boolean;
                showSectionId?: boolean;
                showMaterialId?: boolean;
                showFoundationId?: boolean;
                showSection?: boolean;
                supportSymbols?: boolean;
                showFoundationRepresentation?: boolean;
                proportionalLoads?: boolean;
                language?: string;
            }
            interface ViewPortSettings_json_in {
                __proto_name?: unknown;
                gridSquareSize?: unknown;
                snapToGrid?: unknown;
                centerLine?: unknown;
                centerLineSize?: unknown;
                analyseOnSave?: unknown;
                snapSense?: unknown;
                graphScaleFactor?: unknown;
                graphNumberDecimal?: unknown;
                invertZoomMouse?: unknown;
                majorLineWidth?: unknown;
                minorLineWidth?: unknown;
                majorLineEach?: unknown;
                showLcs?: unknown;
                showSectionId?: unknown;
                showMaterialId?: unknown;
                showFoundationId?: unknown;
                showSection?: unknown;
                supportSymbols?: unknown;
                showFoundationRepresentation?: unknown;
                proportionalLoads?: unknown;
                language?: unknown;
            }
            export class ViewPortSettings {
                __proto_name = "ng.frontend.foundation.ViewPortSettings";
                gridSquareSize: number = 0;
                snapToGrid: boolean = false;
                centerLine: boolean = false;
                centerLineSize: number = 0;
                analyseOnSave: boolean = false;
                snapSense: number = 0;
                graphScaleFactor: number = 0;
                graphNumberDecimal: number = 0;
                invertZoomMouse: boolean = false;
                majorLineWidth: number = 0;
                minorLineWidth: number = 0;
                majorLineEach: number = 0;
                showLcs: boolean = false;
                showSectionId: boolean = false;
                showMaterialId: boolean = false;
                showFoundationId: boolean = false;
                showSection: boolean = false;
                supportSymbols: boolean = false;
                showFoundationRepresentation: boolean = false;
                proportionalLoads: boolean = false;
                language: ng.frontend.foundation.Language = ng.frontend.foundation.Language.LANGUAGE_UNSPECIFIED;

                static fromObject(src_unknown: unknown): ViewPortSettings {
                    const dst = new ViewPortSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ViewPortSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ViewPortSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ViewPortSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gridSquareSize !== undefined && src.gridSquareSize !== null) {
                        if (typeof src.gridSquareSize === "number" || src.gridSquareSize === 'NaN' || src.gridSquareSize === 'Infinity' || src.gridSquareSize === '-Infinity') {
                            dst.gridSquareSize = NumberToInt("ng.frontend.foundation.ViewPortSettings.grid_square_size", AsNum(src.gridSquareSize));
                        }
                        else {
                            console.log('Expected gridSquareSize of ViewPortSettings to be a number but was ', typeof src.gridSquareSize, src.gridSquareSize)
                        }
                    }
                    if (src.snapToGrid !== undefined && src.snapToGrid !== null) {
                        if (typeof src.snapToGrid === "boolean") {
                            dst.snapToGrid = src.snapToGrid;
                        }
                        else {
                            console.log('Expected snapToGrid of ViewPortSettings to be a boolean but was ', typeof src.snapToGrid, src.snapToGrid)
                        }
                    }
                    if (src.centerLine !== undefined && src.centerLine !== null) {
                        if (typeof src.centerLine === "boolean") {
                            dst.centerLine = src.centerLine;
                        }
                        else {
                            console.log('Expected centerLine of ViewPortSettings to be a boolean but was ', typeof src.centerLine, src.centerLine)
                        }
                    }
                    if (src.centerLineSize !== undefined && src.centerLineSize !== null) {
                        if (typeof src.centerLineSize === "number" || src.centerLineSize === 'NaN' || src.centerLineSize === 'Infinity' || src.centerLineSize === '-Infinity') {
                            dst.centerLineSize = AsNum(src.centerLineSize);
                        }
                        else {
                            console.log('Expected centerLineSize of ViewPortSettings to be a number but was ', typeof src.centerLineSize, src.centerLineSize)
                        }
                    }
                    if (src.analyseOnSave !== undefined && src.analyseOnSave !== null) {
                        if (typeof src.analyseOnSave === "boolean") {
                            dst.analyseOnSave = src.analyseOnSave;
                        }
                        else {
                            console.log('Expected analyseOnSave of ViewPortSettings to be a boolean but was ', typeof src.analyseOnSave, src.analyseOnSave)
                        }
                    }
                    if (src.snapSense !== undefined && src.snapSense !== null) {
                        if (typeof src.snapSense === "number" || src.snapSense === 'NaN' || src.snapSense === 'Infinity' || src.snapSense === '-Infinity') {
                            dst.snapSense = NumberToInt("ng.frontend.foundation.ViewPortSettings.snap_sense", AsNum(src.snapSense));
                        }
                        else {
                            console.log('Expected snapSense of ViewPortSettings to be a number but was ', typeof src.snapSense, src.snapSense)
                        }
                    }
                    if (src.graphScaleFactor !== undefined && src.graphScaleFactor !== null) {
                        if (typeof src.graphScaleFactor === "number" || src.graphScaleFactor === 'NaN' || src.graphScaleFactor === 'Infinity' || src.graphScaleFactor === '-Infinity') {
                            dst.graphScaleFactor = AsNum(src.graphScaleFactor);
                        }
                        else {
                            console.log('Expected graphScaleFactor of ViewPortSettings to be a number but was ', typeof src.graphScaleFactor, src.graphScaleFactor)
                        }
                    }
                    if (src.graphNumberDecimal !== undefined && src.graphNumberDecimal !== null) {
                        if (typeof src.graphNumberDecimal === "number" || src.graphNumberDecimal === 'NaN' || src.graphNumberDecimal === 'Infinity' || src.graphNumberDecimal === '-Infinity') {
                            dst.graphNumberDecimal = NumberToInt("ng.frontend.foundation.ViewPortSettings.graph_number_decimal", AsNum(src.graphNumberDecimal));
                        }
                        else {
                            console.log('Expected graphNumberDecimal of ViewPortSettings to be a number but was ', typeof src.graphNumberDecimal, src.graphNumberDecimal)
                        }
                    }
                    if (src.invertZoomMouse !== undefined && src.invertZoomMouse !== null) {
                        if (typeof src.invertZoomMouse === "boolean") {
                            dst.invertZoomMouse = src.invertZoomMouse;
                        }
                        else {
                            console.log('Expected invertZoomMouse of ViewPortSettings to be a boolean but was ', typeof src.invertZoomMouse, src.invertZoomMouse)
                        }
                    }
                    if (src.majorLineWidth !== undefined && src.majorLineWidth !== null) {
                        if (typeof src.majorLineWidth === "number" || src.majorLineWidth === 'NaN' || src.majorLineWidth === 'Infinity' || src.majorLineWidth === '-Infinity') {
                            dst.majorLineWidth = AsNum(src.majorLineWidth);
                        }
                        else {
                            console.log('Expected majorLineWidth of ViewPortSettings to be a number but was ', typeof src.majorLineWidth, src.majorLineWidth)
                        }
                    }
                    if (src.minorLineWidth !== undefined && src.minorLineWidth !== null) {
                        if (typeof src.minorLineWidth === "number" || src.minorLineWidth === 'NaN' || src.minorLineWidth === 'Infinity' || src.minorLineWidth === '-Infinity') {
                            dst.minorLineWidth = AsNum(src.minorLineWidth);
                        }
                        else {
                            console.log('Expected minorLineWidth of ViewPortSettings to be a number but was ', typeof src.minorLineWidth, src.minorLineWidth)
                        }
                    }
                    if (src.majorLineEach !== undefined && src.majorLineEach !== null) {
                        if (typeof src.majorLineEach === "number" || src.majorLineEach === 'NaN' || src.majorLineEach === 'Infinity' || src.majorLineEach === '-Infinity') {
                            dst.majorLineEach = NumberToInt("ng.frontend.foundation.ViewPortSettings.major_line_each", AsNum(src.majorLineEach));
                        }
                        else {
                            console.log('Expected majorLineEach of ViewPortSettings to be a number but was ', typeof src.majorLineEach, src.majorLineEach)
                        }
                    }
                    if (src.showLcs !== undefined && src.showLcs !== null) {
                        if (typeof src.showLcs === "boolean") {
                            dst.showLcs = src.showLcs;
                        }
                        else {
                            console.log('Expected showLcs of ViewPortSettings to be a boolean but was ', typeof src.showLcs, src.showLcs)
                        }
                    }
                    if (src.showSectionId !== undefined && src.showSectionId !== null) {
                        if (typeof src.showSectionId === "boolean") {
                            dst.showSectionId = src.showSectionId;
                        }
                        else {
                            console.log('Expected showSectionId of ViewPortSettings to be a boolean but was ', typeof src.showSectionId, src.showSectionId)
                        }
                    }
                    if (src.showMaterialId !== undefined && src.showMaterialId !== null) {
                        if (typeof src.showMaterialId === "boolean") {
                            dst.showMaterialId = src.showMaterialId;
                        }
                        else {
                            console.log('Expected showMaterialId of ViewPortSettings to be a boolean but was ', typeof src.showMaterialId, src.showMaterialId)
                        }
                    }
                    if (src.showFoundationId !== undefined && src.showFoundationId !== null) {
                        if (typeof src.showFoundationId === "boolean") {
                            dst.showFoundationId = src.showFoundationId;
                        }
                        else {
                            console.log('Expected showFoundationId of ViewPortSettings to be a boolean but was ', typeof src.showFoundationId, src.showFoundationId)
                        }
                    }
                    if (src.showSection !== undefined && src.showSection !== null) {
                        if (typeof src.showSection === "boolean") {
                            dst.showSection = src.showSection;
                        }
                        else {
                            console.log('Expected showSection of ViewPortSettings to be a boolean but was ', typeof src.showSection, src.showSection)
                        }
                    }
                    if (src.supportSymbols !== undefined && src.supportSymbols !== null) {
                        if (typeof src.supportSymbols === "boolean") {
                            dst.supportSymbols = src.supportSymbols;
                        }
                        else {
                            console.log('Expected supportSymbols of ViewPortSettings to be a boolean but was ', typeof src.supportSymbols, src.supportSymbols)
                        }
                    }
                    if (src.showFoundationRepresentation !== undefined && src.showFoundationRepresentation !== null) {
                        if (typeof src.showFoundationRepresentation === "boolean") {
                            dst.showFoundationRepresentation = src.showFoundationRepresentation;
                        }
                        else {
                            console.log('Expected showFoundationRepresentation of ViewPortSettings to be a boolean but was ', typeof src.showFoundationRepresentation, src.showFoundationRepresentation)
                        }
                    }
                    if (src.proportionalLoads !== undefined && src.proportionalLoads !== null) {
                        if (typeof src.proportionalLoads === "boolean") {
                            dst.proportionalLoads = src.proportionalLoads;
                        }
                        else {
                            console.log('Expected proportionalLoads of ViewPortSettings to be a boolean but was ', typeof src.proportionalLoads, src.proportionalLoads)
                        }
                    }
                    if (src.language !== undefined && src.language !== null) {
                        dst.language = ng.frontend.foundation.Language_FromObject(src.language);
                    }
                    return dst;
                }

                static toObject(src: ViewPortSettings | null | undefined): ViewPortSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.ViewPortSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.ViewPortSettings") {
                        console.error('Expected ng.frontend.foundation.ViewPortSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const language_obj = ng.frontend.foundation.Language_ToObject(src.language);
                    if(language_obj === null) return null;

                    const dst : ViewPortSettings_json = {
                        gridSquareSize: AsJsonNum(NumberToInt("ng.frontend.foundation.ViewPortSettings.grid_square_size", src.gridSquareSize)),
                        snapToGrid: src.snapToGrid,
                        centerLine: src.centerLine,
                        centerLineSize: AsJsonNum(src.centerLineSize),
                        analyseOnSave: src.analyseOnSave,
                        snapSense: AsJsonNum(NumberToInt("ng.frontend.foundation.ViewPortSettings.snap_sense", src.snapSense)),
                        graphScaleFactor: AsJsonNum(src.graphScaleFactor),
                        graphNumberDecimal: AsJsonNum(NumberToInt("ng.frontend.foundation.ViewPortSettings.graph_number_decimal", src.graphNumberDecimal)),
                        invertZoomMouse: src.invertZoomMouse,
                        majorLineWidth: AsJsonNum(src.majorLineWidth),
                        minorLineWidth: AsJsonNum(src.minorLineWidth),
                        majorLineEach: AsJsonNum(NumberToInt("ng.frontend.foundation.ViewPortSettings.major_line_each", src.majorLineEach)),
                        showLcs: src.showLcs,
                        showSectionId: src.showSectionId,
                        showMaterialId: src.showMaterialId,
                        showFoundationId: src.showFoundationId,
                        showSection: src.showSection,
                        supportSymbols: src.supportSymbols,
                        showFoundationRepresentation: src.showFoundationRepresentation,
                        proportionalLoads: src.proportionalLoads,
                        language: language_obj,
                    };
                    return dst;
                }

                static create(src?: ViewPortSettings_createType) {
                    const dst = new ViewPortSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gridSquareSize !== undefined) {
                        dst.gridSquareSize = src.gridSquareSize;
                    }
                    if (src.snapToGrid !== undefined) {
                        dst.snapToGrid = src.snapToGrid;
                    }
                    if (src.centerLine !== undefined) {
                        dst.centerLine = src.centerLine;
                    }
                    if (src.centerLineSize !== undefined) {
                        dst.centerLineSize = src.centerLineSize;
                    }
                    if (src.analyseOnSave !== undefined) {
                        dst.analyseOnSave = src.analyseOnSave;
                    }
                    if (src.snapSense !== undefined) {
                        dst.snapSense = src.snapSense;
                    }
                    if (src.graphScaleFactor !== undefined) {
                        dst.graphScaleFactor = src.graphScaleFactor;
                    }
                    if (src.graphNumberDecimal !== undefined) {
                        dst.graphNumberDecimal = src.graphNumberDecimal;
                    }
                    if (src.invertZoomMouse !== undefined) {
                        dst.invertZoomMouse = src.invertZoomMouse;
                    }
                    if (src.majorLineWidth !== undefined) {
                        dst.majorLineWidth = src.majorLineWidth;
                    }
                    if (src.minorLineWidth !== undefined) {
                        dst.minorLineWidth = src.minorLineWidth;
                    }
                    if (src.majorLineEach !== undefined) {
                        dst.majorLineEach = src.majorLineEach;
                    }
                    if (src.showLcs !== undefined) {
                        dst.showLcs = src.showLcs;
                    }
                    if (src.showSectionId !== undefined) {
                        dst.showSectionId = src.showSectionId;
                    }
                    if (src.showMaterialId !== undefined) {
                        dst.showMaterialId = src.showMaterialId;
                    }
                    if (src.showFoundationId !== undefined) {
                        dst.showFoundationId = src.showFoundationId;
                    }
                    if (src.showSection !== undefined) {
                        dst.showSection = src.showSection;
                    }
                    if (src.supportSymbols !== undefined) {
                        dst.supportSymbols = src.supportSymbols;
                    }
                    if (src.showFoundationRepresentation !== undefined) {
                        dst.showFoundationRepresentation = src.showFoundationRepresentation;
                    }
                    if (src.proportionalLoads !== undefined) {
                        dst.proportionalLoads = src.proportionalLoads;
                    }
                    if (src.language !== undefined) {
                        dst.language = src.language;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ViewPortSettings();
                    dst.gridSquareSize = this.gridSquareSize;
                    dst.snapToGrid = this.snapToGrid;
                    dst.centerLine = this.centerLine;
                    dst.centerLineSize = this.centerLineSize;
                    dst.analyseOnSave = this.analyseOnSave;
                    dst.snapSense = this.snapSense;
                    dst.graphScaleFactor = this.graphScaleFactor;
                    dst.graphNumberDecimal = this.graphNumberDecimal;
                    dst.invertZoomMouse = this.invertZoomMouse;
                    dst.majorLineWidth = this.majorLineWidth;
                    dst.minorLineWidth = this.minorLineWidth;
                    dst.majorLineEach = this.majorLineEach;
                    dst.showLcs = this.showLcs;
                    dst.showSectionId = this.showSectionId;
                    dst.showMaterialId = this.showMaterialId;
                    dst.showFoundationId = this.showFoundationId;
                    dst.showSection = this.showSection;
                    dst.supportSymbols = this.supportSymbols;
                    dst.showFoundationRepresentation = this.showFoundationRepresentation;
                    dst.proportionalLoads = this.proportionalLoads;
                    dst.language = this.language;
                    return dst;
                }

                deepClone() {
                    const json = ViewPortSettings.toObject(this);
                    const dst = ViewPortSettings.fromObject(json);
                    return dst;
                }
            }
            export type IViewPortSettings = ViewPortSettings;


            export type UnitSettings_keys = 'length' | 'force';
            export interface UnitSettings_createType {
                length?: string,
                force?: string,
            }
            export interface UnitSettings_json {
                length?: string;
                force?: string;
            }
            interface UnitSettings_json_in {
                __proto_name?: unknown;
                length?: unknown;
                force?: unknown;
            }
            export class UnitSettings {
                __proto_name = "ng.frontend.foundation.UnitSettings";
                length: string = "";
                force: string = "";

                static fromObject(src_unknown: unknown): UnitSettings {
                    const dst = new UnitSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted UnitSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as UnitSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for UnitSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.length !== undefined && src.length !== null) {
                        if (typeof src.length === "string") {
                            dst.length = src.length;
                        }
                        else {
                            console.log('Expected length of UnitSettings to be a string but was ', typeof src.length, src.length)
                        }
                    }
                    if (src.force !== undefined && src.force !== null) {
                        if (typeof src.force === "string") {
                            dst.force = src.force;
                        }
                        else {
                            console.log('Expected force of UnitSettings to be a string but was ', typeof src.force, src.force)
                        }
                    }
                    return dst;
                }

                static toObject(src: UnitSettings | null | undefined): UnitSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.UnitSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.UnitSettings") {
                        console.error('Expected ng.frontend.foundation.UnitSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : UnitSettings_json = {
                        length: src.length,
                        force: src.force,
                    };
                    return dst;
                }

                static create(src?: UnitSettings_createType) {
                    const dst = new UnitSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.length !== undefined) {
                        dst.length = src.length;
                    }
                    if (src.force !== undefined) {
                        dst.force = src.force;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new UnitSettings();
                    dst.length = this.length;
                    dst.force = this.force;
                    return dst;
                }

                deepClone() {
                    const json = UnitSettings.toObject(this);
                    const dst = UnitSettings.fromObject(json);
                    return dst;
                }
            }
            export type IUnitSettings = UnitSettings;


            export type ColorSettings_keys = 'background' | 'gridLinesMajor' | 'gridLinesMinor' | 'graphPositive' | 'graphNegative';
            export interface ColorSettings_createType {
                background?: string,
                gridLinesMajor?: string,
                gridLinesMinor?: string,
                graphPositive?: string,
                graphNegative?: string,
            }
            export interface ColorSettings_json {
                background?: string;
                gridLinesMajor?: string;
                gridLinesMinor?: string;
                graphPositive?: string;
                graphNegative?: string;
            }
            interface ColorSettings_json_in {
                __proto_name?: unknown;
                background?: unknown;
                gridLinesMajor?: unknown;
                gridLinesMinor?: unknown;
                graphPositive?: unknown;
                graphNegative?: unknown;
            }
            export class ColorSettings {
                __proto_name = "ng.frontend.foundation.ColorSettings";
                background: string = "";
                gridLinesMajor: string = "";
                gridLinesMinor: string = "";
                graphPositive: string = "";
                graphNegative: string = "";

                static fromObject(src_unknown: unknown): ColorSettings {
                    const dst = new ColorSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ColorSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ColorSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ColorSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.background !== undefined && src.background !== null) {
                        if (typeof src.background === "string") {
                            dst.background = src.background;
                        }
                        else {
                            console.log('Expected background of ColorSettings to be a string but was ', typeof src.background, src.background)
                        }
                    }
                    if (src.gridLinesMajor !== undefined && src.gridLinesMajor !== null) {
                        if (typeof src.gridLinesMajor === "string") {
                            dst.gridLinesMajor = src.gridLinesMajor;
                        }
                        else {
                            console.log('Expected gridLinesMajor of ColorSettings to be a string but was ', typeof src.gridLinesMajor, src.gridLinesMajor)
                        }
                    }
                    if (src.gridLinesMinor !== undefined && src.gridLinesMinor !== null) {
                        if (typeof src.gridLinesMinor === "string") {
                            dst.gridLinesMinor = src.gridLinesMinor;
                        }
                        else {
                            console.log('Expected gridLinesMinor of ColorSettings to be a string but was ', typeof src.gridLinesMinor, src.gridLinesMinor)
                        }
                    }
                    if (src.graphPositive !== undefined && src.graphPositive !== null) {
                        if (typeof src.graphPositive === "string") {
                            dst.graphPositive = src.graphPositive;
                        }
                        else {
                            console.log('Expected graphPositive of ColorSettings to be a string but was ', typeof src.graphPositive, src.graphPositive)
                        }
                    }
                    if (src.graphNegative !== undefined && src.graphNegative !== null) {
                        if (typeof src.graphNegative === "string") {
                            dst.graphNegative = src.graphNegative;
                        }
                        else {
                            console.log('Expected graphNegative of ColorSettings to be a string but was ', typeof src.graphNegative, src.graphNegative)
                        }
                    }
                    return dst;
                }

                static toObject(src: ColorSettings | null | undefined): ColorSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.ColorSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.ColorSettings") {
                        console.error('Expected ng.frontend.foundation.ColorSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ColorSettings_json = {
                        background: src.background,
                        gridLinesMajor: src.gridLinesMajor,
                        gridLinesMinor: src.gridLinesMinor,
                        graphPositive: src.graphPositive,
                        graphNegative: src.graphNegative,
                    };
                    return dst;
                }

                static create(src?: ColorSettings_createType) {
                    const dst = new ColorSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.background !== undefined) {
                        dst.background = src.background;
                    }
                    if (src.gridLinesMajor !== undefined) {
                        dst.gridLinesMajor = src.gridLinesMajor;
                    }
                    if (src.gridLinesMinor !== undefined) {
                        dst.gridLinesMinor = src.gridLinesMinor;
                    }
                    if (src.graphPositive !== undefined) {
                        dst.graphPositive = src.graphPositive;
                    }
                    if (src.graphNegative !== undefined) {
                        dst.graphNegative = src.graphNegative;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ColorSettings();
                    dst.background = this.background;
                    dst.gridLinesMajor = this.gridLinesMajor;
                    dst.gridLinesMinor = this.gridLinesMinor;
                    dst.graphPositive = this.graphPositive;
                    dst.graphNegative = this.graphNegative;
                    return dst;
                }

                deepClone() {
                    const json = ColorSettings.toObject(this);
                    const dst = ColorSettings.fromObject(json);
                    return dst;
                }
            }
            export type IColorSettings = ColorSettings;


            export type ResultSettings_keys = 'diagramScale' | 'showNumericalValuesInGraph' | 'showOnlyMinMax';
            export interface ResultSettings_createType {
                diagramScale?: number,
                showNumericalValuesInGraph?: boolean,
                showOnlyMinMax?: boolean,
            }
            export interface ResultSettings_json {
                diagramScale?: JsonNumber;
                showNumericalValuesInGraph?: boolean;
                showOnlyMinMax?: boolean;
            }
            interface ResultSettings_json_in {
                __proto_name?: unknown;
                diagramScale?: unknown;
                showNumericalValuesInGraph?: unknown;
                showOnlyMinMax?: unknown;
            }
            export class ResultSettings {
                __proto_name = "ng.frontend.foundation.ResultSettings";
                diagramScale: number = 0;
                showNumericalValuesInGraph: boolean = false;
                showOnlyMinMax: boolean = false;

                static fromObject(src_unknown: unknown): ResultSettings {
                    const dst = new ResultSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ResultSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ResultSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ResultSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.diagramScale !== undefined && src.diagramScale !== null) {
                        if (typeof src.diagramScale === "number" || src.diagramScale === 'NaN' || src.diagramScale === 'Infinity' || src.diagramScale === '-Infinity') {
                            dst.diagramScale = AsNum(src.diagramScale);
                        }
                        else {
                            console.log('Expected diagramScale of ResultSettings to be a number but was ', typeof src.diagramScale, src.diagramScale)
                        }
                    }
                    if (src.showNumericalValuesInGraph !== undefined && src.showNumericalValuesInGraph !== null) {
                        if (typeof src.showNumericalValuesInGraph === "boolean") {
                            dst.showNumericalValuesInGraph = src.showNumericalValuesInGraph;
                        }
                        else {
                            console.log('Expected showNumericalValuesInGraph of ResultSettings to be a boolean but was ', typeof src.showNumericalValuesInGraph, src.showNumericalValuesInGraph)
                        }
                    }
                    if (src.showOnlyMinMax !== undefined && src.showOnlyMinMax !== null) {
                        if (typeof src.showOnlyMinMax === "boolean") {
                            dst.showOnlyMinMax = src.showOnlyMinMax;
                        }
                        else {
                            console.log('Expected showOnlyMinMax of ResultSettings to be a boolean but was ', typeof src.showOnlyMinMax, src.showOnlyMinMax)
                        }
                    }
                    return dst;
                }

                static toObject(src: ResultSettings | null | undefined): ResultSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.ResultSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.ResultSettings") {
                        console.error('Expected ng.frontend.foundation.ResultSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ResultSettings_json = {
                        diagramScale: AsJsonNum(src.diagramScale),
                        showNumericalValuesInGraph: src.showNumericalValuesInGraph,
                        showOnlyMinMax: src.showOnlyMinMax,
                    };
                    return dst;
                }

                static create(src?: ResultSettings_createType) {
                    const dst = new ResultSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.diagramScale !== undefined) {
                        dst.diagramScale = src.diagramScale;
                    }
                    if (src.showNumericalValuesInGraph !== undefined) {
                        dst.showNumericalValuesInGraph = src.showNumericalValuesInGraph;
                    }
                    if (src.showOnlyMinMax !== undefined) {
                        dst.showOnlyMinMax = src.showOnlyMinMax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ResultSettings();
                    dst.diagramScale = this.diagramScale;
                    dst.showNumericalValuesInGraph = this.showNumericalValuesInGraph;
                    dst.showOnlyMinMax = this.showOnlyMinMax;
                    return dst;
                }

                deepClone() {
                    const json = ResultSettings.toObject(this);
                    const dst = ResultSettings.fromObject(json);
                    return dst;
                }
            }
            export type IResultSettings = ResultSettings;


            export type GeneralSettings_keys = 'viewport' | 'unit' | 'colors' | 'result';
            export interface GeneralSettings_createType {
                viewport?: ng.frontend.foundation.ViewPortSettings | null,
                unit?: ng.frontend.foundation.UnitSettings | null,
                colors?: ng.frontend.foundation.ColorSettings | null,
                result?: ng.frontend.foundation.ResultSettings | null,
            }
            export interface GeneralSettings_json {
                viewport?: ng.frontend.foundation.ViewPortSettings_json;
                unit?: ng.frontend.foundation.UnitSettings_json;
                colors?: ng.frontend.foundation.ColorSettings_json;
                result?: ng.frontend.foundation.ResultSettings_json;
            }
            interface GeneralSettings_json_in {
                __proto_name?: unknown;
                viewport?: unknown;
                unit?: unknown;
                colors?: unknown;
                result?: unknown;
            }
            export class GeneralSettings {
                __proto_name = "ng.frontend.foundation.GeneralSettings";
                viewport: ng.frontend.foundation.ViewPortSettings | null = null;
                unit: ng.frontend.foundation.UnitSettings | null = null;
                colors: ng.frontend.foundation.ColorSettings | null = null;
                result: ng.frontend.foundation.ResultSettings | null = null;

                static fromObject(src_unknown: unknown): GeneralSettings {
                    const dst = new GeneralSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GeneralSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GeneralSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GeneralSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.viewport !== undefined && src.viewport !== null) {
                        dst.viewport = ng.frontend.foundation.ViewPortSettings.fromObject(src.viewport);
                    }
                    if (src.unit !== undefined && src.unit !== null) {
                        dst.unit = ng.frontend.foundation.UnitSettings.fromObject(src.unit);
                    }
                    if (src.colors !== undefined && src.colors !== null) {
                        dst.colors = ng.frontend.foundation.ColorSettings.fromObject(src.colors);
                    }
                    if (src.result !== undefined && src.result !== null) {
                        dst.result = ng.frontend.foundation.ResultSettings.fromObject(src.result);
                    }
                    return dst;
                }

                static toObject(src: GeneralSettings | null | undefined): GeneralSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.GeneralSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.GeneralSettings") {
                        console.error('Expected ng.frontend.foundation.GeneralSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GeneralSettings_json = {
                    };
                    if(src.viewport !== null)
                    {
                        const parsed = ng.frontend.foundation.ViewPortSettings.toObject(src.viewport);
                        if(parsed === null) return null;
                        dst.viewport = parsed;
                    }
                    if(src.unit !== null)
                    {
                        const parsed = ng.frontend.foundation.UnitSettings.toObject(src.unit);
                        if(parsed === null) return null;
                        dst.unit = parsed;
                    }
                    if(src.colors !== null)
                    {
                        const parsed = ng.frontend.foundation.ColorSettings.toObject(src.colors);
                        if(parsed === null) return null;
                        dst.colors = parsed;
                    }
                    if(src.result !== null)
                    {
                        const parsed = ng.frontend.foundation.ResultSettings.toObject(src.result);
                        if(parsed === null) return null;
                        dst.result = parsed;
                    }
                    return dst;
                }

                static create(src?: GeneralSettings_createType) {
                    const dst = new GeneralSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.viewport !== undefined) {
                        dst.viewport = src.viewport;
                    }
                    if (src.unit !== undefined) {
                        dst.unit = src.unit;
                    }
                    if (src.colors !== undefined) {
                        dst.colors = src.colors;
                    }
                    if (src.result !== undefined) {
                        dst.result = src.result;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GeneralSettings();
                    dst.viewport = this.viewport;
                    dst.unit = this.unit;
                    dst.colors = this.colors;
                    dst.result = this.result;
                    return dst;
                }

                deepClone() {
                    const json = GeneralSettings.toObject(this);
                    const dst = GeneralSettings.fromObject(json);
                    return dst;
                }
            }
            export type IGeneralSettings = GeneralSettings;


            export type EndPointParamCache_keys = 'autoDesign' | 'placeLayersBasedOnCoverThickness';
            export interface EndPointParamCache_createType {
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign | null,
                placeLayersBasedOnCoverThickness?: boolean,
            }
            export interface EndPointParamCache_json {
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign_json;
                placeLayersBasedOnCoverThickness?: boolean;
            }
            interface EndPointParamCache_json_in {
                __proto_name?: unknown;
                autoDesign?: unknown;
                placeLayersBasedOnCoverThickness?: unknown;
            }
            export class EndPointParamCache {
                __proto_name = "ng.frontend.foundation.EndPointParamCache";
                autoDesign: ng.endpoint_args.common_api_functions.AutoDesign | null = null;
                placeLayersBasedOnCoverThickness: boolean = false;

                static fromObject(src_unknown: unknown): EndPointParamCache {
                    const dst = new EndPointParamCache();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EndPointParamCache but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EndPointParamCache_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EndPointParamCache but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.autoDesign !== undefined && src.autoDesign !== null) {
                        dst.autoDesign = ng.endpoint_args.common_api_functions.AutoDesign.fromObject(src.autoDesign);
                    }
                    if (src.placeLayersBasedOnCoverThickness !== undefined && src.placeLayersBasedOnCoverThickness !== null) {
                        if (typeof src.placeLayersBasedOnCoverThickness === "boolean") {
                            dst.placeLayersBasedOnCoverThickness = src.placeLayersBasedOnCoverThickness;
                        }
                        else {
                            console.log('Expected placeLayersBasedOnCoverThickness of EndPointParamCache to be a boolean but was ', typeof src.placeLayersBasedOnCoverThickness, src.placeLayersBasedOnCoverThickness)
                        }
                    }
                    return dst;
                }

                static toObject(src: EndPointParamCache | null | undefined): EndPointParamCache_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.EndPointParamCache is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.EndPointParamCache") {
                        console.error('Expected ng.frontend.foundation.EndPointParamCache but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EndPointParamCache_json = {
                        placeLayersBasedOnCoverThickness: src.placeLayersBasedOnCoverThickness,
                    };
                    if(src.autoDesign !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesign.toObject(src.autoDesign);
                        if(parsed === null) return null;
                        dst.autoDesign = parsed;
                    }
                    return dst;
                }

                static create(src?: EndPointParamCache_createType) {
                    const dst = new EndPointParamCache();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.autoDesign !== undefined) {
                        dst.autoDesign = src.autoDesign;
                    }
                    if (src.placeLayersBasedOnCoverThickness !== undefined) {
                        dst.placeLayersBasedOnCoverThickness = src.placeLayersBasedOnCoverThickness;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EndPointParamCache();
                    dst.autoDesign = this.autoDesign;
                    dst.placeLayersBasedOnCoverThickness = this.placeLayersBasedOnCoverThickness;
                    return dst;
                }

                deepClone() {
                    const json = EndPointParamCache.toObject(this);
                    const dst = EndPointParamCache.fromObject(json);
                    return dst;
                }
            }
            export type IEndPointParamCache = EndPointParamCache;


            export type FrontendData_keys = 'printSettings' | 'endpointCache';
            export interface FrontendData_createType {
                printSettings?: ng.frontend.foundation.PrintSetting[],
                endpointCache?: ng.frontend.foundation.EndPointParamCache | null,
            }
            export interface FrontendData_json {
                printSettings: ng.frontend.foundation.PrintSetting_json[];
                endpointCache?: ng.frontend.foundation.EndPointParamCache_json;
            }
            interface FrontendData_json_in {
                __proto_name?: unknown;
                printSettings?: unknown;
                endpointCache?: unknown;
            }
            export class FrontendData {
                __proto_name = "ng.frontend.foundation.FrontendData";
                printSettings: ng.frontend.foundation.PrintSetting[] = [];
                endpointCache: ng.frontend.foundation.EndPointParamCache | null = null;

                static fromObject(src_unknown: unknown): FrontendData {
                    const dst = new FrontendData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FrontendData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FrontendData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FrontendData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.printSettings !== undefined && src.printSettings !== null) {
                        if (Array.isArray(src.printSettings)) {
                            for (const element of src.printSettings) {
                                dst.printSettings.push(ng.frontend.foundation.PrintSetting.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected printSettings of FrontendData to be a array but was ', typeof src.printSettings, src.printSettings)
                        }
                    }
                    if (src.endpointCache !== undefined && src.endpointCache !== null) {
                        dst.endpointCache = ng.frontend.foundation.EndPointParamCache.fromObject(src.endpointCache);
                    }
                    return dst;
                }

                static toObject(src: FrontendData | null | undefined): FrontendData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.FrontendData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.FrontendData") {
                        console.error('Expected ng.frontend.foundation.FrontendData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FrontendData_json = {
                        printSettings: new Array<ng.frontend.foundation.PrintSetting_json>(),
                    };
                    if (src.printSettings !== null) {
                        for (const element of src.printSettings) {
                            const parsed = ng.frontend.foundation.PrintSetting.toObject(element);
                            if(parsed === null) return null;
                            dst.printSettings.push(parsed);
                        }
                    }
                    if(src.endpointCache !== null)
                    {
                        const parsed = ng.frontend.foundation.EndPointParamCache.toObject(src.endpointCache);
                        if(parsed === null) return null;
                        dst.endpointCache = parsed;
                    }
                    return dst;
                }

                static create(src?: FrontendData_createType) {
                    const dst = new FrontendData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.printSettings !== undefined) {
                        dst.printSettings = src.printSettings;
                    }
                    if (src.endpointCache !== undefined) {
                        dst.endpointCache = src.endpointCache;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FrontendData();
                    dst.printSettings = this.printSettings;
                    dst.endpointCache = this.endpointCache;
                    return dst;
                }

                deepClone() {
                    const json = FrontendData.toObject(this);
                    const dst = FrontendData.fromObject(json);
                    return dst;
                }
            }
            export type IFrontendData = FrontendData;


            export type ProjectMeta_keys = 'guid' | 'name' | 'eTag' | 'revision' | 'description' | 'author' | 'company' | 'created' | 'signature' | 'comments' | 'keywords' | 'appVersion' | 'buildNumber' | 'lastModified' | 'modifiedBy' | 'location' | 'project' | 'projectNumber' | 'app';
            export interface ProjectMeta_createType {
                guid?: string,
                name?: string,
                eTag?: string,
                revision?: number,
                description?: string,
                author?: string,
                company?: string,
                created?: string,
                signature?: string,
                comments?: string,
                keywords?: string[],
                appVersion?: ng.utils.SemVer | null,
                buildNumber?: string,
                lastModified?: string,
                modifiedBy?: string,
                location?: string,
                project?: string,
                projectNumber?: string,
                app?: ng.frontend.general.SimplexApp,
            }
            export interface ProjectMeta_json {
                guid?: string;
                name?: string;
                eTag?: string;
                revision?: JsonNumber;
                description?: string;
                author?: string;
                company?: string;
                created?: string;
                signature?: string;
                comments?: string;
                keywords: string[];
                appVersion?: ng.utils.SemVer_json;
                buildNumber?: string;
                lastModified?: string;
                modifiedBy?: string;
                location?: string;
                project?: string;
                projectNumber?: string;
                app?: string;
            }
            interface ProjectMeta_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                name?: unknown;
                eTag?: unknown;
                revision?: unknown;
                description?: unknown;
                author?: unknown;
                company?: unknown;
                created?: unknown;
                signature?: unknown;
                comments?: unknown;
                keywords?: unknown;
                appVersion?: unknown;
                buildNumber?: unknown;
                lastModified?: unknown;
                modifiedBy?: unknown;
                location?: unknown;
                project?: unknown;
                projectNumber?: unknown;
                app?: unknown;
            }
            export class ProjectMeta {
                __proto_name = "ng.frontend.foundation.ProjectMeta";
                guid: string = "";
                name: string = "";
                eTag: string = "";
                revision: number = 0;
                description: string = "";
                author: string = "";
                company: string = "";
                created: string = "";
                signature: string = "";
                comments: string = "";
                keywords: string[] = [];
                appVersion: ng.utils.SemVer | null = null;
                buildNumber: string = "";
                lastModified: string = "";
                modifiedBy: string = "";
                location: string = "";
                project: string = "";
                projectNumber: string = "";
                app: ng.frontend.general.SimplexApp = ng.frontend.general.SimplexApp.SIMPLEX_APP_UNSPECIFIED;

                static fromObject(src_unknown: unknown): ProjectMeta {
                    const dst = new ProjectMeta();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ProjectMeta but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ProjectMeta_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ProjectMeta but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of ProjectMeta to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.name !== undefined && src.name !== null) {
                        if (typeof src.name === "string") {
                            dst.name = src.name;
                        }
                        else {
                            console.log('Expected name of ProjectMeta to be a string but was ', typeof src.name, src.name)
                        }
                    }
                    if (src.eTag !== undefined && src.eTag !== null) {
                        if (typeof src.eTag === "string") {
                            dst.eTag = src.eTag;
                        }
                        else {
                            console.log('Expected eTag of ProjectMeta to be a string but was ', typeof src.eTag, src.eTag)
                        }
                    }
                    if (src.revision !== undefined && src.revision !== null) {
                        if (typeof src.revision === "number" || src.revision === 'NaN' || src.revision === 'Infinity' || src.revision === '-Infinity') {
                            dst.revision = NumberToInt("ng.frontend.foundation.ProjectMeta.revision", AsNum(src.revision));
                        }
                        else {
                            console.log('Expected revision of ProjectMeta to be a number but was ', typeof src.revision, src.revision)
                        }
                    }
                    if (src.description !== undefined && src.description !== null) {
                        if (typeof src.description === "string") {
                            dst.description = src.description;
                        }
                        else {
                            console.log('Expected description of ProjectMeta to be a string but was ', typeof src.description, src.description)
                        }
                    }
                    if (src.author !== undefined && src.author !== null) {
                        if (typeof src.author === "string") {
                            dst.author = src.author;
                        }
                        else {
                            console.log('Expected author of ProjectMeta to be a string but was ', typeof src.author, src.author)
                        }
                    }
                    if (src.company !== undefined && src.company !== null) {
                        if (typeof src.company === "string") {
                            dst.company = src.company;
                        }
                        else {
                            console.log('Expected company of ProjectMeta to be a string but was ', typeof src.company, src.company)
                        }
                    }
                    if (src.created !== undefined && src.created !== null) {
                        if (typeof src.created === "string") {
                            dst.created = src.created;
                        }
                        else {
                            console.log('Expected created of ProjectMeta to be a string but was ', typeof src.created, src.created)
                        }
                    }
                    if (src.signature !== undefined && src.signature !== null) {
                        if (typeof src.signature === "string") {
                            dst.signature = src.signature;
                        }
                        else {
                            console.log('Expected signature of ProjectMeta to be a string but was ', typeof src.signature, src.signature)
                        }
                    }
                    if (src.comments !== undefined && src.comments !== null) {
                        if (typeof src.comments === "string") {
                            dst.comments = src.comments;
                        }
                        else {
                            console.log('Expected comments of ProjectMeta to be a string but was ', typeof src.comments, src.comments)
                        }
                    }
                    if (src.keywords !== undefined && src.keywords !== null) {
                        if (Array.isArray(src.keywords)) {
                            for (const [index, element] of src.keywords.entries()) {
                                if (typeof element === "string") {
                                    dst.keywords.push(element);
                                }
                                else {
                                    console.log('Expected keywords of ProjectMeta[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected keywords of ProjectMeta to be a array but was ', typeof src.keywords, src.keywords)
                        }
                    }
                    if (src.appVersion !== undefined && src.appVersion !== null) {
                        dst.appVersion = ng.utils.SemVer.fromObject(src.appVersion);
                    }
                    if (src.buildNumber !== undefined && src.buildNumber !== null) {
                        if (typeof src.buildNumber === "string") {
                            dst.buildNumber = src.buildNumber;
                        }
                        else {
                            console.log('Expected buildNumber of ProjectMeta to be a string but was ', typeof src.buildNumber, src.buildNumber)
                        }
                    }
                    if (src.lastModified !== undefined && src.lastModified !== null) {
                        if (typeof src.lastModified === "string") {
                            dst.lastModified = src.lastModified;
                        }
                        else {
                            console.log('Expected lastModified of ProjectMeta to be a string but was ', typeof src.lastModified, src.lastModified)
                        }
                    }
                    if (src.modifiedBy !== undefined && src.modifiedBy !== null) {
                        if (typeof src.modifiedBy === "string") {
                            dst.modifiedBy = src.modifiedBy;
                        }
                        else {
                            console.log('Expected modifiedBy of ProjectMeta to be a string but was ', typeof src.modifiedBy, src.modifiedBy)
                        }
                    }
                    if (src.location !== undefined && src.location !== null) {
                        if (typeof src.location === "string") {
                            dst.location = src.location;
                        }
                        else {
                            console.log('Expected location of ProjectMeta to be a string but was ', typeof src.location, src.location)
                        }
                    }
                    if (src.project !== undefined && src.project !== null) {
                        if (typeof src.project === "string") {
                            dst.project = src.project;
                        }
                        else {
                            console.log('Expected project of ProjectMeta to be a string but was ', typeof src.project, src.project)
                        }
                    }
                    if (src.projectNumber !== undefined && src.projectNumber !== null) {
                        if (typeof src.projectNumber === "string") {
                            dst.projectNumber = src.projectNumber;
                        }
                        else {
                            console.log('Expected projectNumber of ProjectMeta to be a string but was ', typeof src.projectNumber, src.projectNumber)
                        }
                    }
                    if (src.app !== undefined && src.app !== null) {
                        dst.app = ng.frontend.general.SimplexApp_FromObject(src.app);
                    }
                    return dst;
                }

                static toObject(src: ProjectMeta | null | undefined): ProjectMeta_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.ProjectMeta is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.ProjectMeta") {
                        console.error('Expected ng.frontend.foundation.ProjectMeta but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const app_obj = ng.frontend.general.SimplexApp_ToObject(src.app);
                    if(app_obj === null) return null;

                    const dst : ProjectMeta_json = {
                        guid: src.guid,
                        name: src.name,
                        eTag: src.eTag,
                        revision: AsJsonNum(NumberToInt("ng.frontend.foundation.ProjectMeta.revision", src.revision)),
                        description: src.description,
                        author: src.author,
                        company: src.company,
                        created: src.created,
                        signature: src.signature,
                        comments: src.comments,
                        keywords: new Array<string>(),
                        buildNumber: src.buildNumber,
                        lastModified: src.lastModified,
                        modifiedBy: src.modifiedBy,
                        location: src.location,
                        project: src.project,
                        projectNumber: src.projectNumber,
                        app: app_obj,
                    };
                    if (src.keywords !== null) {
                        for (const element of src.keywords) {
                            dst.keywords.push(element);
                        }
                    }
                    if(src.appVersion !== null)
                    {
                        const parsed = ng.utils.SemVer.toObject(src.appVersion);
                        if(parsed === null) return null;
                        dst.appVersion = parsed;
                    }
                    return dst;
                }

                static create(src?: ProjectMeta_createType) {
                    const dst = new ProjectMeta();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.name !== undefined) {
                        dst.name = src.name;
                    }
                    if (src.eTag !== undefined) {
                        dst.eTag = src.eTag;
                    }
                    if (src.revision !== undefined) {
                        dst.revision = src.revision;
                    }
                    if (src.description !== undefined) {
                        dst.description = src.description;
                    }
                    if (src.author !== undefined) {
                        dst.author = src.author;
                    }
                    if (src.company !== undefined) {
                        dst.company = src.company;
                    }
                    if (src.created !== undefined) {
                        dst.created = src.created;
                    }
                    if (src.signature !== undefined) {
                        dst.signature = src.signature;
                    }
                    if (src.comments !== undefined) {
                        dst.comments = src.comments;
                    }
                    if (src.keywords !== undefined) {
                        dst.keywords = src.keywords;
                    }
                    if (src.appVersion !== undefined) {
                        dst.appVersion = src.appVersion;
                    }
                    if (src.buildNumber !== undefined) {
                        dst.buildNumber = src.buildNumber;
                    }
                    if (src.lastModified !== undefined) {
                        dst.lastModified = src.lastModified;
                    }
                    if (src.modifiedBy !== undefined) {
                        dst.modifiedBy = src.modifiedBy;
                    }
                    if (src.location !== undefined) {
                        dst.location = src.location;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.projectNumber !== undefined) {
                        dst.projectNumber = src.projectNumber;
                    }
                    if (src.app !== undefined) {
                        dst.app = src.app;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ProjectMeta();
                    dst.guid = this.guid;
                    dst.name = this.name;
                    dst.eTag = this.eTag;
                    dst.revision = this.revision;
                    dst.description = this.description;
                    dst.author = this.author;
                    dst.company = this.company;
                    dst.created = this.created;
                    dst.signature = this.signature;
                    dst.comments = this.comments;
                    dst.keywords = this.keywords;
                    dst.appVersion = this.appVersion;
                    dst.buildNumber = this.buildNumber;
                    dst.lastModified = this.lastModified;
                    dst.modifiedBy = this.modifiedBy;
                    dst.location = this.location;
                    dst.project = this.project;
                    dst.projectNumber = this.projectNumber;
                    dst.app = this.app;
                    return dst;
                }

                deepClone() {
                    const json = ProjectMeta.toObject(this);
                    const dst = ProjectMeta.fromObject(json);
                    return dst;
                }
            }
            export type IProjectMeta = ProjectMeta;


            export type Project_keys = 'meta' | 'data' | 'settings';
            export interface Project_createType {
                meta?: ng.frontend.foundation.ProjectMeta | null,
                data?: ng.project.Data | null,
                settings?: ng.frontend.foundation.FrontendData | null,
            }
            export interface Project_json {
                meta?: ng.frontend.foundation.ProjectMeta_json;
                data?: ng.project.Data_json;
                settings?: ng.frontend.foundation.FrontendData_json;
            }
            interface Project_json_in {
                __proto_name?: unknown;
                meta?: unknown;
                data?: unknown;
                settings?: unknown;
            }
            export class Project {
                __proto_name = "ng.frontend.foundation.Project";
                meta: ng.frontend.foundation.ProjectMeta | null = null;
                data: ng.project.Data | null = null;
                settings: ng.frontend.foundation.FrontendData | null = null;

                static fromObject(src_unknown: unknown): Project {
                    const dst = new Project();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Project but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Project_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Project but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.meta !== undefined && src.meta !== null) {
                        dst.meta = ng.frontend.foundation.ProjectMeta.fromObject(src.meta);
                    }
                    if (src.data !== undefined && src.data !== null) {
                        dst.data = ng.project.Data.fromObject(src.data);
                    }
                    if (src.settings !== undefined && src.settings !== null) {
                        dst.settings = ng.frontend.foundation.FrontendData.fromObject(src.settings);
                    }
                    return dst;
                }

                static toObject(src: Project | null | undefined): Project_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.foundation.Project is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.foundation.Project") {
                        console.error('Expected ng.frontend.foundation.Project but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Project_json = {
                    };
                    if(src.meta !== null)
                    {
                        const parsed = ng.frontend.foundation.ProjectMeta.toObject(src.meta);
                        if(parsed === null) return null;
                        dst.meta = parsed;
                    }
                    if(src.data !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.data);
                        if(parsed === null) return null;
                        dst.data = parsed;
                    }
                    if(src.settings !== null)
                    {
                        const parsed = ng.frontend.foundation.FrontendData.toObject(src.settings);
                        if(parsed === null) return null;
                        dst.settings = parsed;
                    }
                    return dst;
                }

                static create(src?: Project_createType) {
                    const dst = new Project();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.meta !== undefined) {
                        dst.meta = src.meta;
                    }
                    if (src.data !== undefined) {
                        dst.data = src.data;
                    }
                    if (src.settings !== undefined) {
                        dst.settings = src.settings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Project();
                    dst.meta = this.meta;
                    dst.data = this.data;
                    dst.settings = this.settings;
                    return dst;
                }

                deepClone() {
                    const json = Project.toObject(this);
                    const dst = Project.fromObject(json);
                    return dst;
                }
            }
            export type IProject = Project;
        } // namespace foundation


        // Defined in Frontends/column.proto
        export namespace column {
            export enum PrintModule {
                PRINT_MODULE_UNSPECIFIED = 0,
                PRINT_MODULE_SUMMARY = 1,
                PRINT_MODULE_INPUT = 2,
                PRINT_MODULE_ANALYSIS = 3,
                PRINT_MODULE_CONCRETE = 4,
                PRINT_MODULE_STEEL = 5,
                PRINT_MODULE_TIMBER = 6,
                PRINT_MODULE_TOC = 7
            }
            export const PrintModule_FromObject = (src: unknown): PrintModule => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_MODULE_UNSPECIFIED':
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                    case 1:
                    case 'PRINT_MODULE_SUMMARY':
                        return PrintModule.PRINT_MODULE_SUMMARY;
                    case 2:
                    case 'PRINT_MODULE_INPUT':
                        return PrintModule.PRINT_MODULE_INPUT;
                    case 3:
                    case 'PRINT_MODULE_ANALYSIS':
                        return PrintModule.PRINT_MODULE_ANALYSIS;
                    case 4:
                    case 'PRINT_MODULE_CONCRETE':
                        return PrintModule.PRINT_MODULE_CONCRETE;
                    case 5:
                    case 'PRINT_MODULE_STEEL':
                        return PrintModule.PRINT_MODULE_STEEL;
                    case 6:
                    case 'PRINT_MODULE_TIMBER':
                        return PrintModule.PRINT_MODULE_TIMBER;
                    case 7:
                    case 'PRINT_MODULE_TOC':
                        return PrintModule.PRINT_MODULE_TOC;
                    default:
                        console.log('Unhandled value for PrintModule:' + src + '. ' + typeof(src));
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                }
            };
            export const PrintModule_ToObject = (src: PrintModule): string | null => {
                switch (src) {
                    case PrintModule.PRINT_MODULE_UNSPECIFIED:
                        return 'PRINT_MODULE_UNSPECIFIED';
                    case PrintModule.PRINT_MODULE_SUMMARY:
                        return 'PRINT_MODULE_SUMMARY';
                    case PrintModule.PRINT_MODULE_INPUT:
                        return 'PRINT_MODULE_INPUT';
                    case PrintModule.PRINT_MODULE_ANALYSIS:
                        return 'PRINT_MODULE_ANALYSIS';
                    case PrintModule.PRINT_MODULE_CONCRETE:
                        return 'PRINT_MODULE_CONCRETE';
                    case PrintModule.PRINT_MODULE_STEEL:
                        return 'PRINT_MODULE_STEEL';
                    case PrintModule.PRINT_MODULE_TIMBER:
                        return 'PRINT_MODULE_TIMBER';
                    case PrintModule.PRINT_MODULE_TOC:
                        return 'PRINT_MODULE_TOC';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintModule, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum PrintExtent {
                PRINT_EXTENT_UNSPECIFIED = 0,
                PRINT_EXTENT_MINIMAL = 1,
                PRINT_EXTENT_NORMAL = 2,
                PRINT_EXTENT_MAXIMAL = 3
            }
            export const PrintExtent_FromObject = (src: unknown): PrintExtent => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_EXTENT_UNSPECIFIED':
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                    case 1:
                    case 'PRINT_EXTENT_MINIMAL':
                        return PrintExtent.PRINT_EXTENT_MINIMAL;
                    case 2:
                    case 'PRINT_EXTENT_NORMAL':
                        return PrintExtent.PRINT_EXTENT_NORMAL;
                    case 3:
                    case 'PRINT_EXTENT_MAXIMAL':
                        return PrintExtent.PRINT_EXTENT_MAXIMAL;
                    default:
                        console.log('Unhandled value for PrintExtent:' + src + '. ' + typeof(src));
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                }
            };
            export const PrintExtent_ToObject = (src: PrintExtent): string | null => {
                switch (src) {
                    case PrintExtent.PRINT_EXTENT_UNSPECIFIED:
                        return 'PRINT_EXTENT_UNSPECIFIED';
                    case PrintExtent.PRINT_EXTENT_MINIMAL:
                        return 'PRINT_EXTENT_MINIMAL';
                    case PrintExtent.PRINT_EXTENT_NORMAL:
                        return 'PRINT_EXTENT_NORMAL';
                    case PrintExtent.PRINT_EXTENT_MAXIMAL:
                        return 'PRINT_EXTENT_MAXIMAL';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintExtent, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PrintSetting_keys = 'module' | 'extent';
            export interface PrintSetting_createType {
                module?: ng.frontend.column.PrintModule,
                extent?: ng.frontend.column.PrintExtent,
            }
            export interface PrintSetting_json {
                module?: string;
                extent?: string;
            }
            interface PrintSetting_json_in {
                __proto_name?: unknown;
                module?: unknown;
                extent?: unknown;
            }
            export class PrintSetting {
                __proto_name = "ng.frontend.column.PrintSetting";
                module: ng.frontend.column.PrintModule = ng.frontend.column.PrintModule.PRINT_MODULE_UNSPECIFIED;
                extent: ng.frontend.column.PrintExtent = ng.frontend.column.PrintExtent.PRINT_EXTENT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): PrintSetting {
                    const dst = new PrintSetting();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PrintSetting but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PrintSetting_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PrintSetting but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.module !== undefined && src.module !== null) {
                        dst.module = ng.frontend.column.PrintModule_FromObject(src.module);
                    }
                    if (src.extent !== undefined && src.extent !== null) {
                        dst.extent = ng.frontend.column.PrintExtent_FromObject(src.extent);
                    }
                    return dst;
                }

                static toObject(src: PrintSetting | null | undefined): PrintSetting_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.PrintSetting is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.PrintSetting") {
                        console.error('Expected ng.frontend.column.PrintSetting but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const module_obj = ng.frontend.column.PrintModule_ToObject(src.module);
                    if(module_obj === null) return null;

                    const extent_obj = ng.frontend.column.PrintExtent_ToObject(src.extent);
                    if(extent_obj === null) return null;

                    const dst : PrintSetting_json = {
                        module: module_obj,
                        extent: extent_obj,
                    };
                    return dst;
                }

                static create(src?: PrintSetting_createType) {
                    const dst = new PrintSetting();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.module !== undefined) {
                        dst.module = src.module;
                    }
                    if (src.extent !== undefined) {
                        dst.extent = src.extent;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PrintSetting();
                    dst.module = this.module;
                    dst.extent = this.extent;
                    return dst;
                }

                deepClone() {
                    const json = PrintSetting.toObject(this);
                    const dst = PrintSetting.fromObject(json);
                    return dst;
                }
            }
            export type IPrintSetting = PrintSetting;


            export type LoadCaseVisuals_keys = 'guid' | 'color' | 'visible';
            export interface LoadCaseVisuals_createType {
                guid?: string,
                color?: string,
                visible?: boolean,
            }
            export interface LoadCaseVisuals_json {
                guid?: string;
                color?: string;
                visible?: boolean;
            }
            interface LoadCaseVisuals_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                color?: unknown;
                visible?: unknown;
            }
            export class LoadCaseVisuals {
                __proto_name = "ng.frontend.column.LoadCaseVisuals";
                guid: string = "";
                color: string = "";
                visible: boolean = false;

                static fromObject(src_unknown: unknown): LoadCaseVisuals {
                    const dst = new LoadCaseVisuals();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCaseVisuals but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCaseVisuals_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCaseVisuals but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of LoadCaseVisuals to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.color !== undefined && src.color !== null) {
                        if (typeof src.color === "string") {
                            dst.color = src.color;
                        }
                        else {
                            console.log('Expected color of LoadCaseVisuals to be a string but was ', typeof src.color, src.color)
                        }
                    }
                    if (src.visible !== undefined && src.visible !== null) {
                        if (typeof src.visible === "boolean") {
                            dst.visible = src.visible;
                        }
                        else {
                            console.log('Expected visible of LoadCaseVisuals to be a boolean but was ', typeof src.visible, src.visible)
                        }
                    }
                    return dst;
                }

                static toObject(src: LoadCaseVisuals | null | undefined): LoadCaseVisuals_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.LoadCaseVisuals is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.LoadCaseVisuals") {
                        console.error('Expected ng.frontend.column.LoadCaseVisuals but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCaseVisuals_json = {
                        guid: src.guid,
                        color: src.color,
                        visible: src.visible,
                    };
                    return dst;
                }

                static create(src?: LoadCaseVisuals_createType) {
                    const dst = new LoadCaseVisuals();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.color !== undefined) {
                        dst.color = src.color;
                    }
                    if (src.visible !== undefined) {
                        dst.visible = src.visible;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCaseVisuals();
                    dst.guid = this.guid;
                    dst.color = this.color;
                    dst.visible = this.visible;
                    return dst;
                }

                deepClone() {
                    const json = LoadCaseVisuals.toObject(this);
                    const dst = LoadCaseVisuals.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCaseVisuals = LoadCaseVisuals;


            export type LoadCombinationVisuals_keys = 'guid' | 'color';
            export interface LoadCombinationVisuals_createType {
                guid?: string,
                color?: string,
            }
            export interface LoadCombinationVisuals_json {
                guid?: string;
                color?: string;
            }
            interface LoadCombinationVisuals_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                color?: unknown;
            }
            export class LoadCombinationVisuals {
                __proto_name = "ng.frontend.column.LoadCombinationVisuals";
                guid: string = "";
                color: string = "";

                static fromObject(src_unknown: unknown): LoadCombinationVisuals {
                    const dst = new LoadCombinationVisuals();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCombinationVisuals but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCombinationVisuals_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCombinationVisuals but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of LoadCombinationVisuals to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.color !== undefined && src.color !== null) {
                        if (typeof src.color === "string") {
                            dst.color = src.color;
                        }
                        else {
                            console.log('Expected color of LoadCombinationVisuals to be a string but was ', typeof src.color, src.color)
                        }
                    }
                    return dst;
                }

                static toObject(src: LoadCombinationVisuals | null | undefined): LoadCombinationVisuals_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.LoadCombinationVisuals is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.LoadCombinationVisuals") {
                        console.error('Expected ng.frontend.column.LoadCombinationVisuals but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCombinationVisuals_json = {
                        guid: src.guid,
                        color: src.color,
                    };
                    return dst;
                }

                static create(src?: LoadCombinationVisuals_createType) {
                    const dst = new LoadCombinationVisuals();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.color !== undefined) {
                        dst.color = src.color;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCombinationVisuals();
                    dst.guid = this.guid;
                    dst.color = this.color;
                    return dst;
                }

                deepClone() {
                    const json = LoadCombinationVisuals.toObject(this);
                    const dst = LoadCombinationVisuals.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCombinationVisuals = LoadCombinationVisuals;


            export type PrintVisuals_keys = 'loadcases' | 'loadcombinations';
            export interface PrintVisuals_createType {
                loadcases?: ng.frontend.column.LoadCaseVisuals[],
                loadcombinations?: ng.frontend.column.LoadCombinationVisuals[],
            }
            export interface PrintVisuals_json {
                loadcases: ng.frontend.column.LoadCaseVisuals_json[];
                loadcombinations: ng.frontend.column.LoadCombinationVisuals_json[];
            }
            interface PrintVisuals_json_in {
                __proto_name?: unknown;
                loadcases?: unknown;
                loadcombinations?: unknown;
            }
            export class PrintVisuals {
                __proto_name = "ng.frontend.column.PrintVisuals";
                loadcases: ng.frontend.column.LoadCaseVisuals[] = [];
                loadcombinations: ng.frontend.column.LoadCombinationVisuals[] = [];

                static fromObject(src_unknown: unknown): PrintVisuals {
                    const dst = new PrintVisuals();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PrintVisuals but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PrintVisuals_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PrintVisuals but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.loadcases !== undefined && src.loadcases !== null) {
                        if (Array.isArray(src.loadcases)) {
                            for (const element of src.loadcases) {
                                dst.loadcases.push(ng.frontend.column.LoadCaseVisuals.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadcases of PrintVisuals to be a array but was ', typeof src.loadcases, src.loadcases)
                        }
                    }
                    if (src.loadcombinations !== undefined && src.loadcombinations !== null) {
                        if (Array.isArray(src.loadcombinations)) {
                            for (const element of src.loadcombinations) {
                                dst.loadcombinations.push(ng.frontend.column.LoadCombinationVisuals.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadcombinations of PrintVisuals to be a array but was ', typeof src.loadcombinations, src.loadcombinations)
                        }
                    }
                    return dst;
                }

                static toObject(src: PrintVisuals | null | undefined): PrintVisuals_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.PrintVisuals is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.PrintVisuals") {
                        console.error('Expected ng.frontend.column.PrintVisuals but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PrintVisuals_json = {
                        loadcases: new Array<ng.frontend.column.LoadCaseVisuals_json>(),
                        loadcombinations: new Array<ng.frontend.column.LoadCombinationVisuals_json>(),
                    };
                    if (src.loadcases !== null) {
                        for (const element of src.loadcases) {
                            const parsed = ng.frontend.column.LoadCaseVisuals.toObject(element);
                            if(parsed === null) return null;
                            dst.loadcases.push(parsed);
                        }
                    }
                    if (src.loadcombinations !== null) {
                        for (const element of src.loadcombinations) {
                            const parsed = ng.frontend.column.LoadCombinationVisuals.toObject(element);
                            if(parsed === null) return null;
                            dst.loadcombinations.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: PrintVisuals_createType) {
                    const dst = new PrintVisuals();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.loadcases !== undefined) {
                        dst.loadcases = src.loadcases;
                    }
                    if (src.loadcombinations !== undefined) {
                        dst.loadcombinations = src.loadcombinations;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PrintVisuals();
                    dst.loadcases = this.loadcases;
                    dst.loadcombinations = this.loadcombinations;
                    return dst;
                }

                deepClone() {
                    const json = PrintVisuals.toObject(this);
                    const dst = PrintVisuals.fromObject(json);
                    return dst;
                }
            }
            export type IPrintVisuals = PrintVisuals;


            export type EndPointParamCache_keys = 'loadCombGenSettings' | 'autoDesign' | 'autoBucklingLength';
            export interface EndPointParamCache_createType {
                loadCombGenSettings?: ng.endpoint_args.eurocode.LoadCombGenSettings | null,
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign | null,
                autoBucklingLength?: boolean,
            }
            export interface EndPointParamCache_json {
                loadCombGenSettings?: ng.endpoint_args.eurocode.LoadCombGenSettings_json;
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign_json;
                autoBucklingLength?: boolean;
            }
            interface EndPointParamCache_json_in {
                __proto_name?: unknown;
                loadCombGenSettings?: unknown;
                autoDesign?: unknown;
                autoBucklingLength?: unknown;
            }
            export class EndPointParamCache {
                __proto_name = "ng.frontend.column.EndPointParamCache";
                loadCombGenSettings: ng.endpoint_args.eurocode.LoadCombGenSettings | null = null;
                autoDesign: ng.endpoint_args.common_api_functions.AutoDesign | null = null;
                autoBucklingLength: boolean = false;

                static fromObject(src_unknown: unknown): EndPointParamCache {
                    const dst = new EndPointParamCache();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EndPointParamCache but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EndPointParamCache_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EndPointParamCache but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.loadCombGenSettings !== undefined && src.loadCombGenSettings !== null) {
                        dst.loadCombGenSettings = ng.endpoint_args.eurocode.LoadCombGenSettings.fromObject(src.loadCombGenSettings);
                    }
                    if (src.autoDesign !== undefined && src.autoDesign !== null) {
                        dst.autoDesign = ng.endpoint_args.common_api_functions.AutoDesign.fromObject(src.autoDesign);
                    }
                    if (src.autoBucklingLength !== undefined && src.autoBucklingLength !== null) {
                        if (typeof src.autoBucklingLength === "boolean") {
                            dst.autoBucklingLength = src.autoBucklingLength;
                        }
                        else {
                            console.log('Expected autoBucklingLength of EndPointParamCache to be a boolean but was ', typeof src.autoBucklingLength, src.autoBucklingLength)
                        }
                    }
                    return dst;
                }

                static toObject(src: EndPointParamCache | null | undefined): EndPointParamCache_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.EndPointParamCache is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.EndPointParamCache") {
                        console.error('Expected ng.frontend.column.EndPointParamCache but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EndPointParamCache_json = {
                        autoBucklingLength: src.autoBucklingLength,
                    };
                    if(src.loadCombGenSettings !== null)
                    {
                        const parsed = ng.endpoint_args.eurocode.LoadCombGenSettings.toObject(src.loadCombGenSettings);
                        if(parsed === null) return null;
                        dst.loadCombGenSettings = parsed;
                    }
                    if(src.autoDesign !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesign.toObject(src.autoDesign);
                        if(parsed === null) return null;
                        dst.autoDesign = parsed;
                    }
                    return dst;
                }

                static create(src?: EndPointParamCache_createType) {
                    const dst = new EndPointParamCache();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.loadCombGenSettings !== undefined) {
                        dst.loadCombGenSettings = src.loadCombGenSettings;
                    }
                    if (src.autoDesign !== undefined) {
                        dst.autoDesign = src.autoDesign;
                    }
                    if (src.autoBucklingLength !== undefined) {
                        dst.autoBucklingLength = src.autoBucklingLength;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EndPointParamCache();
                    dst.loadCombGenSettings = this.loadCombGenSettings;
                    dst.autoDesign = this.autoDesign;
                    dst.autoBucklingLength = this.autoBucklingLength;
                    return dst;
                }

                deepClone() {
                    const json = EndPointParamCache.toObject(this);
                    const dst = EndPointParamCache.fromObject(json);
                    return dst;
                }
            }
            export type IEndPointParamCache = EndPointParamCache;


            export type FrontendData_keys = 'printSettings' | 'visuals' | 'endpointCache';
            export interface FrontendData_createType {
                printSettings?: ng.frontend.column.PrintSetting[],
                visuals?: ng.frontend.column.PrintVisuals | null,
                endpointCache?: ng.frontend.column.EndPointParamCache | null,
            }
            export interface FrontendData_json {
                printSettings: ng.frontend.column.PrintSetting_json[];
                visuals?: ng.frontend.column.PrintVisuals_json;
                endpointCache?: ng.frontend.column.EndPointParamCache_json;
            }
            interface FrontendData_json_in {
                __proto_name?: unknown;
                printSettings?: unknown;
                visuals?: unknown;
                endpointCache?: unknown;
            }
            export class FrontendData {
                __proto_name = "ng.frontend.column.FrontendData";
                printSettings: ng.frontend.column.PrintSetting[] = [];
                visuals: ng.frontend.column.PrintVisuals | null = null;
                endpointCache: ng.frontend.column.EndPointParamCache | null = null;

                static fromObject(src_unknown: unknown): FrontendData {
                    const dst = new FrontendData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FrontendData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FrontendData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FrontendData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.printSettings !== undefined && src.printSettings !== null) {
                        if (Array.isArray(src.printSettings)) {
                            for (const element of src.printSettings) {
                                dst.printSettings.push(ng.frontend.column.PrintSetting.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected printSettings of FrontendData to be a array but was ', typeof src.printSettings, src.printSettings)
                        }
                    }
                    if (src.visuals !== undefined && src.visuals !== null) {
                        dst.visuals = ng.frontend.column.PrintVisuals.fromObject(src.visuals);
                    }
                    if (src.endpointCache !== undefined && src.endpointCache !== null) {
                        dst.endpointCache = ng.frontend.column.EndPointParamCache.fromObject(src.endpointCache);
                    }
                    return dst;
                }

                static toObject(src: FrontendData | null | undefined): FrontendData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.FrontendData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.FrontendData") {
                        console.error('Expected ng.frontend.column.FrontendData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FrontendData_json = {
                        printSettings: new Array<ng.frontend.column.PrintSetting_json>(),
                    };
                    if (src.printSettings !== null) {
                        for (const element of src.printSettings) {
                            const parsed = ng.frontend.column.PrintSetting.toObject(element);
                            if(parsed === null) return null;
                            dst.printSettings.push(parsed);
                        }
                    }
                    if(src.visuals !== null)
                    {
                        const parsed = ng.frontend.column.PrintVisuals.toObject(src.visuals);
                        if(parsed === null) return null;
                        dst.visuals = parsed;
                    }
                    if(src.endpointCache !== null)
                    {
                        const parsed = ng.frontend.column.EndPointParamCache.toObject(src.endpointCache);
                        if(parsed === null) return null;
                        dst.endpointCache = parsed;
                    }
                    return dst;
                }

                static create(src?: FrontendData_createType) {
                    const dst = new FrontendData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.printSettings !== undefined) {
                        dst.printSettings = src.printSettings;
                    }
                    if (src.visuals !== undefined) {
                        dst.visuals = src.visuals;
                    }
                    if (src.endpointCache !== undefined) {
                        dst.endpointCache = src.endpointCache;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FrontendData();
                    dst.printSettings = this.printSettings;
                    dst.visuals = this.visuals;
                    dst.endpointCache = this.endpointCache;
                    return dst;
                }

                deepClone() {
                    const json = FrontendData.toObject(this);
                    const dst = FrontendData.fromObject(json);
                    return dst;
                }
            }
            export type IFrontendData = FrontendData;


            export type ProjectMeta_keys = 'guid' | 'name' | 'eTag' | 'revision' | 'description' | 'author' | 'company' | 'created' | 'signature' | 'comments' | 'keywords' | 'appVersion' | 'buildNumber' | 'lastModified' | 'modifiedBy' | 'location' | 'project' | 'projectNumber' | 'app';
            export interface ProjectMeta_createType {
                guid?: string,
                name?: string,
                eTag?: string,
                revision?: number,
                description?: string,
                author?: string,
                company?: string,
                created?: string,
                signature?: string,
                comments?: string,
                keywords?: string[],
                appVersion?: ng.utils.SemVer | null,
                buildNumber?: string,
                lastModified?: string,
                modifiedBy?: string,
                location?: string,
                project?: string,
                projectNumber?: string,
                app?: ng.frontend.general.SimplexApp,
            }
            export interface ProjectMeta_json {
                guid?: string;
                name?: string;
                eTag?: string;
                revision?: JsonNumber;
                description?: string;
                author?: string;
                company?: string;
                created?: string;
                signature?: string;
                comments?: string;
                keywords: string[];
                appVersion?: ng.utils.SemVer_json;
                buildNumber?: string;
                lastModified?: string;
                modifiedBy?: string;
                location?: string;
                project?: string;
                projectNumber?: string;
                app?: string;
            }
            interface ProjectMeta_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                name?: unknown;
                eTag?: unknown;
                revision?: unknown;
                description?: unknown;
                author?: unknown;
                company?: unknown;
                created?: unknown;
                signature?: unknown;
                comments?: unknown;
                keywords?: unknown;
                appVersion?: unknown;
                buildNumber?: unknown;
                lastModified?: unknown;
                modifiedBy?: unknown;
                location?: unknown;
                project?: unknown;
                projectNumber?: unknown;
                app?: unknown;
            }
            export class ProjectMeta {
                __proto_name = "ng.frontend.column.ProjectMeta";
                guid: string = "";
                name: string = "";
                eTag: string = "";
                revision: number = 0;
                description: string = "";
                author: string = "";
                company: string = "";
                created: string = "";
                signature: string = "";
                comments: string = "";
                keywords: string[] = [];
                appVersion: ng.utils.SemVer | null = null;
                buildNumber: string = "";
                lastModified: string = "";
                modifiedBy: string = "";
                location: string = "";
                project: string = "";
                projectNumber: string = "";
                app: ng.frontend.general.SimplexApp = ng.frontend.general.SimplexApp.SIMPLEX_APP_UNSPECIFIED;

                static fromObject(src_unknown: unknown): ProjectMeta {
                    const dst = new ProjectMeta();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ProjectMeta but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ProjectMeta_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ProjectMeta but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of ProjectMeta to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.name !== undefined && src.name !== null) {
                        if (typeof src.name === "string") {
                            dst.name = src.name;
                        }
                        else {
                            console.log('Expected name of ProjectMeta to be a string but was ', typeof src.name, src.name)
                        }
                    }
                    if (src.eTag !== undefined && src.eTag !== null) {
                        if (typeof src.eTag === "string") {
                            dst.eTag = src.eTag;
                        }
                        else {
                            console.log('Expected eTag of ProjectMeta to be a string but was ', typeof src.eTag, src.eTag)
                        }
                    }
                    if (src.revision !== undefined && src.revision !== null) {
                        if (typeof src.revision === "number" || src.revision === 'NaN' || src.revision === 'Infinity' || src.revision === '-Infinity') {
                            dst.revision = NumberToInt("ng.frontend.column.ProjectMeta.revision", AsNum(src.revision));
                        }
                        else {
                            console.log('Expected revision of ProjectMeta to be a number but was ', typeof src.revision, src.revision)
                        }
                    }
                    if (src.description !== undefined && src.description !== null) {
                        if (typeof src.description === "string") {
                            dst.description = src.description;
                        }
                        else {
                            console.log('Expected description of ProjectMeta to be a string but was ', typeof src.description, src.description)
                        }
                    }
                    if (src.author !== undefined && src.author !== null) {
                        if (typeof src.author === "string") {
                            dst.author = src.author;
                        }
                        else {
                            console.log('Expected author of ProjectMeta to be a string but was ', typeof src.author, src.author)
                        }
                    }
                    if (src.company !== undefined && src.company !== null) {
                        if (typeof src.company === "string") {
                            dst.company = src.company;
                        }
                        else {
                            console.log('Expected company of ProjectMeta to be a string but was ', typeof src.company, src.company)
                        }
                    }
                    if (src.created !== undefined && src.created !== null) {
                        if (typeof src.created === "string") {
                            dst.created = src.created;
                        }
                        else {
                            console.log('Expected created of ProjectMeta to be a string but was ', typeof src.created, src.created)
                        }
                    }
                    if (src.signature !== undefined && src.signature !== null) {
                        if (typeof src.signature === "string") {
                            dst.signature = src.signature;
                        }
                        else {
                            console.log('Expected signature of ProjectMeta to be a string but was ', typeof src.signature, src.signature)
                        }
                    }
                    if (src.comments !== undefined && src.comments !== null) {
                        if (typeof src.comments === "string") {
                            dst.comments = src.comments;
                        }
                        else {
                            console.log('Expected comments of ProjectMeta to be a string but was ', typeof src.comments, src.comments)
                        }
                    }
                    if (src.keywords !== undefined && src.keywords !== null) {
                        if (Array.isArray(src.keywords)) {
                            for (const [index, element] of src.keywords.entries()) {
                                if (typeof element === "string") {
                                    dst.keywords.push(element);
                                }
                                else {
                                    console.log('Expected keywords of ProjectMeta[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected keywords of ProjectMeta to be a array but was ', typeof src.keywords, src.keywords)
                        }
                    }
                    if (src.appVersion !== undefined && src.appVersion !== null) {
                        dst.appVersion = ng.utils.SemVer.fromObject(src.appVersion);
                    }
                    if (src.buildNumber !== undefined && src.buildNumber !== null) {
                        if (typeof src.buildNumber === "string") {
                            dst.buildNumber = src.buildNumber;
                        }
                        else {
                            console.log('Expected buildNumber of ProjectMeta to be a string but was ', typeof src.buildNumber, src.buildNumber)
                        }
                    }
                    if (src.lastModified !== undefined && src.lastModified !== null) {
                        if (typeof src.lastModified === "string") {
                            dst.lastModified = src.lastModified;
                        }
                        else {
                            console.log('Expected lastModified of ProjectMeta to be a string but was ', typeof src.lastModified, src.lastModified)
                        }
                    }
                    if (src.modifiedBy !== undefined && src.modifiedBy !== null) {
                        if (typeof src.modifiedBy === "string") {
                            dst.modifiedBy = src.modifiedBy;
                        }
                        else {
                            console.log('Expected modifiedBy of ProjectMeta to be a string but was ', typeof src.modifiedBy, src.modifiedBy)
                        }
                    }
                    if (src.location !== undefined && src.location !== null) {
                        if (typeof src.location === "string") {
                            dst.location = src.location;
                        }
                        else {
                            console.log('Expected location of ProjectMeta to be a string but was ', typeof src.location, src.location)
                        }
                    }
                    if (src.project !== undefined && src.project !== null) {
                        if (typeof src.project === "string") {
                            dst.project = src.project;
                        }
                        else {
                            console.log('Expected project of ProjectMeta to be a string but was ', typeof src.project, src.project)
                        }
                    }
                    if (src.projectNumber !== undefined && src.projectNumber !== null) {
                        if (typeof src.projectNumber === "string") {
                            dst.projectNumber = src.projectNumber;
                        }
                        else {
                            console.log('Expected projectNumber of ProjectMeta to be a string but was ', typeof src.projectNumber, src.projectNumber)
                        }
                    }
                    if (src.app !== undefined && src.app !== null) {
                        dst.app = ng.frontend.general.SimplexApp_FromObject(src.app);
                    }
                    return dst;
                }

                static toObject(src: ProjectMeta | null | undefined): ProjectMeta_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.ProjectMeta is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.ProjectMeta") {
                        console.error('Expected ng.frontend.column.ProjectMeta but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const app_obj = ng.frontend.general.SimplexApp_ToObject(src.app);
                    if(app_obj === null) return null;

                    const dst : ProjectMeta_json = {
                        guid: src.guid,
                        name: src.name,
                        eTag: src.eTag,
                        revision: AsJsonNum(NumberToInt("ng.frontend.column.ProjectMeta.revision", src.revision)),
                        description: src.description,
                        author: src.author,
                        company: src.company,
                        created: src.created,
                        signature: src.signature,
                        comments: src.comments,
                        keywords: new Array<string>(),
                        buildNumber: src.buildNumber,
                        lastModified: src.lastModified,
                        modifiedBy: src.modifiedBy,
                        location: src.location,
                        project: src.project,
                        projectNumber: src.projectNumber,
                        app: app_obj,
                    };
                    if (src.keywords !== null) {
                        for (const element of src.keywords) {
                            dst.keywords.push(element);
                        }
                    }
                    if(src.appVersion !== null)
                    {
                        const parsed = ng.utils.SemVer.toObject(src.appVersion);
                        if(parsed === null) return null;
                        dst.appVersion = parsed;
                    }
                    return dst;
                }

                static create(src?: ProjectMeta_createType) {
                    const dst = new ProjectMeta();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.name !== undefined) {
                        dst.name = src.name;
                    }
                    if (src.eTag !== undefined) {
                        dst.eTag = src.eTag;
                    }
                    if (src.revision !== undefined) {
                        dst.revision = src.revision;
                    }
                    if (src.description !== undefined) {
                        dst.description = src.description;
                    }
                    if (src.author !== undefined) {
                        dst.author = src.author;
                    }
                    if (src.company !== undefined) {
                        dst.company = src.company;
                    }
                    if (src.created !== undefined) {
                        dst.created = src.created;
                    }
                    if (src.signature !== undefined) {
                        dst.signature = src.signature;
                    }
                    if (src.comments !== undefined) {
                        dst.comments = src.comments;
                    }
                    if (src.keywords !== undefined) {
                        dst.keywords = src.keywords;
                    }
                    if (src.appVersion !== undefined) {
                        dst.appVersion = src.appVersion;
                    }
                    if (src.buildNumber !== undefined) {
                        dst.buildNumber = src.buildNumber;
                    }
                    if (src.lastModified !== undefined) {
                        dst.lastModified = src.lastModified;
                    }
                    if (src.modifiedBy !== undefined) {
                        dst.modifiedBy = src.modifiedBy;
                    }
                    if (src.location !== undefined) {
                        dst.location = src.location;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.projectNumber !== undefined) {
                        dst.projectNumber = src.projectNumber;
                    }
                    if (src.app !== undefined) {
                        dst.app = src.app;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ProjectMeta();
                    dst.guid = this.guid;
                    dst.name = this.name;
                    dst.eTag = this.eTag;
                    dst.revision = this.revision;
                    dst.description = this.description;
                    dst.author = this.author;
                    dst.company = this.company;
                    dst.created = this.created;
                    dst.signature = this.signature;
                    dst.comments = this.comments;
                    dst.keywords = this.keywords;
                    dst.appVersion = this.appVersion;
                    dst.buildNumber = this.buildNumber;
                    dst.lastModified = this.lastModified;
                    dst.modifiedBy = this.modifiedBy;
                    dst.location = this.location;
                    dst.project = this.project;
                    dst.projectNumber = this.projectNumber;
                    dst.app = this.app;
                    return dst;
                }

                deepClone() {
                    const json = ProjectMeta.toObject(this);
                    const dst = ProjectMeta.fromObject(json);
                    return dst;
                }
            }
            export type IProjectMeta = ProjectMeta;


            export type Project_keys = 'meta' | 'data' | 'settings';
            export interface Project_createType {
                meta?: ng.frontend.column.ProjectMeta | null,
                data?: ng.project.Data | null,
                settings?: ng.frontend.column.FrontendData | null,
            }
            export interface Project_json {
                meta?: ng.frontend.column.ProjectMeta_json;
                data?: ng.project.Data_json;
                settings?: ng.frontend.column.FrontendData_json;
            }
            interface Project_json_in {
                __proto_name?: unknown;
                meta?: unknown;
                data?: unknown;
                settings?: unknown;
            }
            export class Project {
                __proto_name = "ng.frontend.column.Project";
                meta: ng.frontend.column.ProjectMeta | null = null;
                data: ng.project.Data | null = null;
                settings: ng.frontend.column.FrontendData | null = null;

                static fromObject(src_unknown: unknown): Project {
                    const dst = new Project();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Project but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Project_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Project but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.meta !== undefined && src.meta !== null) {
                        dst.meta = ng.frontend.column.ProjectMeta.fromObject(src.meta);
                    }
                    if (src.data !== undefined && src.data !== null) {
                        dst.data = ng.project.Data.fromObject(src.data);
                    }
                    if (src.settings !== undefined && src.settings !== null) {
                        dst.settings = ng.frontend.column.FrontendData.fromObject(src.settings);
                    }
                    return dst;
                }

                static toObject(src: Project | null | undefined): Project_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.column.Project is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.column.Project") {
                        console.error('Expected ng.frontend.column.Project but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Project_json = {
                    };
                    if(src.meta !== null)
                    {
                        const parsed = ng.frontend.column.ProjectMeta.toObject(src.meta);
                        if(parsed === null) return null;
                        dst.meta = parsed;
                    }
                    if(src.data !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.data);
                        if(parsed === null) return null;
                        dst.data = parsed;
                    }
                    if(src.settings !== null)
                    {
                        const parsed = ng.frontend.column.FrontendData.toObject(src.settings);
                        if(parsed === null) return null;
                        dst.settings = parsed;
                    }
                    return dst;
                }

                static create(src?: Project_createType) {
                    const dst = new Project();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.meta !== undefined) {
                        dst.meta = src.meta;
                    }
                    if (src.data !== undefined) {
                        dst.data = src.data;
                    }
                    if (src.settings !== undefined) {
                        dst.settings = src.settings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Project();
                    dst.meta = this.meta;
                    dst.data = this.data;
                    dst.settings = this.settings;
                    return dst;
                }

                deepClone() {
                    const json = Project.toObject(this);
                    const dst = Project.fromObject(json);
                    return dst;
                }
            }
            export type IProject = Project;
        } // namespace column


        // Defined in Frontends/beam.proto
        export namespace beam {
            export enum PrintModule {
                PRINT_MODULE_UNSPECIFIED = 0,
                PRINT_MODULE_SUMMARY = 1,
                PRINT_MODULE_INPUT = 2,
                PRINT_MODULE_ANALYSIS = 3,
                PRINT_MODULE_CONCRETE = 4,
                PRINT_MODULE_STEEL = 5,
                PRINT_MODULE_TIMBER = 6,
                PRINT_MODULE_TOC = 7
            }
            export const PrintModule_FromObject = (src: unknown): PrintModule => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_MODULE_UNSPECIFIED':
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                    case 1:
                    case 'PRINT_MODULE_SUMMARY':
                        return PrintModule.PRINT_MODULE_SUMMARY;
                    case 2:
                    case 'PRINT_MODULE_INPUT':
                        return PrintModule.PRINT_MODULE_INPUT;
                    case 3:
                    case 'PRINT_MODULE_ANALYSIS':
                        return PrintModule.PRINT_MODULE_ANALYSIS;
                    case 4:
                    case 'PRINT_MODULE_CONCRETE':
                        return PrintModule.PRINT_MODULE_CONCRETE;
                    case 5:
                    case 'PRINT_MODULE_STEEL':
                        return PrintModule.PRINT_MODULE_STEEL;
                    case 6:
                    case 'PRINT_MODULE_TIMBER':
                        return PrintModule.PRINT_MODULE_TIMBER;
                    case 7:
                    case 'PRINT_MODULE_TOC':
                        return PrintModule.PRINT_MODULE_TOC;
                    default:
                        console.log('Unhandled value for PrintModule:' + src + '. ' + typeof(src));
                        return PrintModule.PRINT_MODULE_UNSPECIFIED;
                }
            };
            export const PrintModule_ToObject = (src: PrintModule): string | null => {
                switch (src) {
                    case PrintModule.PRINT_MODULE_UNSPECIFIED:
                        return 'PRINT_MODULE_UNSPECIFIED';
                    case PrintModule.PRINT_MODULE_SUMMARY:
                        return 'PRINT_MODULE_SUMMARY';
                    case PrintModule.PRINT_MODULE_INPUT:
                        return 'PRINT_MODULE_INPUT';
                    case PrintModule.PRINT_MODULE_ANALYSIS:
                        return 'PRINT_MODULE_ANALYSIS';
                    case PrintModule.PRINT_MODULE_CONCRETE:
                        return 'PRINT_MODULE_CONCRETE';
                    case PrintModule.PRINT_MODULE_STEEL:
                        return 'PRINT_MODULE_STEEL';
                    case PrintModule.PRINT_MODULE_TIMBER:
                        return 'PRINT_MODULE_TIMBER';
                    case PrintModule.PRINT_MODULE_TOC:
                        return 'PRINT_MODULE_TOC';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintModule, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum PrintExtent {
                PRINT_EXTENT_UNSPECIFIED = 0,
                PRINT_EXTENT_MINIMAL = 1,
                PRINT_EXTENT_NORMAL = 2,
                PRINT_EXTENT_MAXIMAL = 3
            }
            export const PrintExtent_FromObject = (src: unknown): PrintExtent => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'PRINT_EXTENT_UNSPECIFIED':
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                    case 1:
                    case 'PRINT_EXTENT_MINIMAL':
                        return PrintExtent.PRINT_EXTENT_MINIMAL;
                    case 2:
                    case 'PRINT_EXTENT_NORMAL':
                        return PrintExtent.PRINT_EXTENT_NORMAL;
                    case 3:
                    case 'PRINT_EXTENT_MAXIMAL':
                        return PrintExtent.PRINT_EXTENT_MAXIMAL;
                    default:
                        console.log('Unhandled value for PrintExtent:' + src + '. ' + typeof(src));
                        return PrintExtent.PRINT_EXTENT_UNSPECIFIED;
                }
            };
            export const PrintExtent_ToObject = (src: PrintExtent): string | null => {
                switch (src) {
                    case PrintExtent.PRINT_EXTENT_UNSPECIFIED:
                        return 'PRINT_EXTENT_UNSPECIFIED';
                    case PrintExtent.PRINT_EXTENT_MINIMAL:
                        return 'PRINT_EXTENT_MINIMAL';
                    case PrintExtent.PRINT_EXTENT_NORMAL:
                        return 'PRINT_EXTENT_NORMAL';
                    case PrintExtent.PRINT_EXTENT_MAXIMAL:
                        return 'PRINT_EXTENT_MAXIMAL';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for PrintExtent, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type PrintSetting_keys = 'module' | 'extent';
            export interface PrintSetting_createType {
                module?: ng.frontend.beam.PrintModule,
                extent?: ng.frontend.beam.PrintExtent,
            }
            export interface PrintSetting_json {
                module?: string;
                extent?: string;
            }
            interface PrintSetting_json_in {
                __proto_name?: unknown;
                module?: unknown;
                extent?: unknown;
            }
            export class PrintSetting {
                __proto_name = "ng.frontend.beam.PrintSetting";
                module: ng.frontend.beam.PrintModule = ng.frontend.beam.PrintModule.PRINT_MODULE_UNSPECIFIED;
                extent: ng.frontend.beam.PrintExtent = ng.frontend.beam.PrintExtent.PRINT_EXTENT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): PrintSetting {
                    const dst = new PrintSetting();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PrintSetting but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PrintSetting_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PrintSetting but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.module !== undefined && src.module !== null) {
                        dst.module = ng.frontend.beam.PrintModule_FromObject(src.module);
                    }
                    if (src.extent !== undefined && src.extent !== null) {
                        dst.extent = ng.frontend.beam.PrintExtent_FromObject(src.extent);
                    }
                    return dst;
                }

                static toObject(src: PrintSetting | null | undefined): PrintSetting_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.PrintSetting is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.PrintSetting") {
                        console.error('Expected ng.frontend.beam.PrintSetting but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const module_obj = ng.frontend.beam.PrintModule_ToObject(src.module);
                    if(module_obj === null) return null;

                    const extent_obj = ng.frontend.beam.PrintExtent_ToObject(src.extent);
                    if(extent_obj === null) return null;

                    const dst : PrintSetting_json = {
                        module: module_obj,
                        extent: extent_obj,
                    };
                    return dst;
                }

                static create(src?: PrintSetting_createType) {
                    const dst = new PrintSetting();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.module !== undefined) {
                        dst.module = src.module;
                    }
                    if (src.extent !== undefined) {
                        dst.extent = src.extent;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PrintSetting();
                    dst.module = this.module;
                    dst.extent = this.extent;
                    return dst;
                }

                deepClone() {
                    const json = PrintSetting.toObject(this);
                    const dst = PrintSetting.fromObject(json);
                    return dst;
                }
            }
            export type IPrintSetting = PrintSetting;


            export type LoadCaseVisuals_keys = 'guid' | 'color' | 'visible';
            export interface LoadCaseVisuals_createType {
                guid?: string,
                color?: string,
                visible?: boolean,
            }
            export interface LoadCaseVisuals_json {
                guid?: string;
                color?: string;
                visible?: boolean;
            }
            interface LoadCaseVisuals_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                color?: unknown;
                visible?: unknown;
            }
            export class LoadCaseVisuals {
                __proto_name = "ng.frontend.beam.LoadCaseVisuals";
                guid: string = "";
                color: string = "";
                visible: boolean = false;

                static fromObject(src_unknown: unknown): LoadCaseVisuals {
                    const dst = new LoadCaseVisuals();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCaseVisuals but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCaseVisuals_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCaseVisuals but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of LoadCaseVisuals to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.color !== undefined && src.color !== null) {
                        if (typeof src.color === "string") {
                            dst.color = src.color;
                        }
                        else {
                            console.log('Expected color of LoadCaseVisuals to be a string but was ', typeof src.color, src.color)
                        }
                    }
                    if (src.visible !== undefined && src.visible !== null) {
                        if (typeof src.visible === "boolean") {
                            dst.visible = src.visible;
                        }
                        else {
                            console.log('Expected visible of LoadCaseVisuals to be a boolean but was ', typeof src.visible, src.visible)
                        }
                    }
                    return dst;
                }

                static toObject(src: LoadCaseVisuals | null | undefined): LoadCaseVisuals_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.LoadCaseVisuals is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.LoadCaseVisuals") {
                        console.error('Expected ng.frontend.beam.LoadCaseVisuals but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCaseVisuals_json = {
                        guid: src.guid,
                        color: src.color,
                        visible: src.visible,
                    };
                    return dst;
                }

                static create(src?: LoadCaseVisuals_createType) {
                    const dst = new LoadCaseVisuals();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.color !== undefined) {
                        dst.color = src.color;
                    }
                    if (src.visible !== undefined) {
                        dst.visible = src.visible;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCaseVisuals();
                    dst.guid = this.guid;
                    dst.color = this.color;
                    dst.visible = this.visible;
                    return dst;
                }

                deepClone() {
                    const json = LoadCaseVisuals.toObject(this);
                    const dst = LoadCaseVisuals.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCaseVisuals = LoadCaseVisuals;


            export type LoadCombinationVisuals_keys = 'guid' | 'color';
            export interface LoadCombinationVisuals_createType {
                guid?: string,
                color?: string,
            }
            export interface LoadCombinationVisuals_json {
                guid?: string;
                color?: string;
            }
            interface LoadCombinationVisuals_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                color?: unknown;
            }
            export class LoadCombinationVisuals {
                __proto_name = "ng.frontend.beam.LoadCombinationVisuals";
                guid: string = "";
                color: string = "";

                static fromObject(src_unknown: unknown): LoadCombinationVisuals {
                    const dst = new LoadCombinationVisuals();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCombinationVisuals but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCombinationVisuals_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCombinationVisuals but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of LoadCombinationVisuals to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.color !== undefined && src.color !== null) {
                        if (typeof src.color === "string") {
                            dst.color = src.color;
                        }
                        else {
                            console.log('Expected color of LoadCombinationVisuals to be a string but was ', typeof src.color, src.color)
                        }
                    }
                    return dst;
                }

                static toObject(src: LoadCombinationVisuals | null | undefined): LoadCombinationVisuals_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.LoadCombinationVisuals is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.LoadCombinationVisuals") {
                        console.error('Expected ng.frontend.beam.LoadCombinationVisuals but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCombinationVisuals_json = {
                        guid: src.guid,
                        color: src.color,
                    };
                    return dst;
                }

                static create(src?: LoadCombinationVisuals_createType) {
                    const dst = new LoadCombinationVisuals();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.color !== undefined) {
                        dst.color = src.color;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCombinationVisuals();
                    dst.guid = this.guid;
                    dst.color = this.color;
                    return dst;
                }

                deepClone() {
                    const json = LoadCombinationVisuals.toObject(this);
                    const dst = LoadCombinationVisuals.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCombinationVisuals = LoadCombinationVisuals;


            export type PrintVisuals_keys = 'loadcases' | 'loadcombinations';
            export interface PrintVisuals_createType {
                loadcases?: ng.frontend.beam.LoadCaseVisuals[],
                loadcombinations?: ng.frontend.beam.LoadCombinationVisuals[],
            }
            export interface PrintVisuals_json {
                loadcases: ng.frontend.beam.LoadCaseVisuals_json[];
                loadcombinations: ng.frontend.beam.LoadCombinationVisuals_json[];
            }
            interface PrintVisuals_json_in {
                __proto_name?: unknown;
                loadcases?: unknown;
                loadcombinations?: unknown;
            }
            export class PrintVisuals {
                __proto_name = "ng.frontend.beam.PrintVisuals";
                loadcases: ng.frontend.beam.LoadCaseVisuals[] = [];
                loadcombinations: ng.frontend.beam.LoadCombinationVisuals[] = [];

                static fromObject(src_unknown: unknown): PrintVisuals {
                    const dst = new PrintVisuals();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PrintVisuals but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PrintVisuals_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PrintVisuals but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.loadcases !== undefined && src.loadcases !== null) {
                        if (Array.isArray(src.loadcases)) {
                            for (const element of src.loadcases) {
                                dst.loadcases.push(ng.frontend.beam.LoadCaseVisuals.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadcases of PrintVisuals to be a array but was ', typeof src.loadcases, src.loadcases)
                        }
                    }
                    if (src.loadcombinations !== undefined && src.loadcombinations !== null) {
                        if (Array.isArray(src.loadcombinations)) {
                            for (const element of src.loadcombinations) {
                                dst.loadcombinations.push(ng.frontend.beam.LoadCombinationVisuals.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadcombinations of PrintVisuals to be a array but was ', typeof src.loadcombinations, src.loadcombinations)
                        }
                    }
                    return dst;
                }

                static toObject(src: PrintVisuals | null | undefined): PrintVisuals_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.PrintVisuals is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.PrintVisuals") {
                        console.error('Expected ng.frontend.beam.PrintVisuals but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PrintVisuals_json = {
                        loadcases: new Array<ng.frontend.beam.LoadCaseVisuals_json>(),
                        loadcombinations: new Array<ng.frontend.beam.LoadCombinationVisuals_json>(),
                    };
                    if (src.loadcases !== null) {
                        for (const element of src.loadcases) {
                            const parsed = ng.frontend.beam.LoadCaseVisuals.toObject(element);
                            if(parsed === null) return null;
                            dst.loadcases.push(parsed);
                        }
                    }
                    if (src.loadcombinations !== null) {
                        for (const element of src.loadcombinations) {
                            const parsed = ng.frontend.beam.LoadCombinationVisuals.toObject(element);
                            if(parsed === null) return null;
                            dst.loadcombinations.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: PrintVisuals_createType) {
                    const dst = new PrintVisuals();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.loadcases !== undefined) {
                        dst.loadcases = src.loadcases;
                    }
                    if (src.loadcombinations !== undefined) {
                        dst.loadcombinations = src.loadcombinations;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PrintVisuals();
                    dst.loadcases = this.loadcases;
                    dst.loadcombinations = this.loadcombinations;
                    return dst;
                }

                deepClone() {
                    const json = PrintVisuals.toObject(this);
                    const dst = PrintVisuals.fromObject(json);
                    return dst;
                }
            }
            export type IPrintVisuals = PrintVisuals;


            export type EndPointParamCache_keys = 'loadCombGenSettings' | 'autoDesign' | 'autoBucklingLength';
            export interface EndPointParamCache_createType {
                loadCombGenSettings?: ng.endpoint_args.eurocode.LoadCombGenSettings | null,
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign | null,
                autoBucklingLength?: boolean,
            }
            export interface EndPointParamCache_json {
                loadCombGenSettings?: ng.endpoint_args.eurocode.LoadCombGenSettings_json;
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign_json;
                autoBucklingLength?: boolean;
            }
            interface EndPointParamCache_json_in {
                __proto_name?: unknown;
                loadCombGenSettings?: unknown;
                autoDesign?: unknown;
                autoBucklingLength?: unknown;
            }
            export class EndPointParamCache {
                __proto_name = "ng.frontend.beam.EndPointParamCache";
                loadCombGenSettings: ng.endpoint_args.eurocode.LoadCombGenSettings | null = null;
                autoDesign: ng.endpoint_args.common_api_functions.AutoDesign | null = null;
                autoBucklingLength: boolean = false;

                static fromObject(src_unknown: unknown): EndPointParamCache {
                    const dst = new EndPointParamCache();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EndPointParamCache but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EndPointParamCache_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EndPointParamCache but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.loadCombGenSettings !== undefined && src.loadCombGenSettings !== null) {
                        dst.loadCombGenSettings = ng.endpoint_args.eurocode.LoadCombGenSettings.fromObject(src.loadCombGenSettings);
                    }
                    if (src.autoDesign !== undefined && src.autoDesign !== null) {
                        dst.autoDesign = ng.endpoint_args.common_api_functions.AutoDesign.fromObject(src.autoDesign);
                    }
                    if (src.autoBucklingLength !== undefined && src.autoBucklingLength !== null) {
                        if (typeof src.autoBucklingLength === "boolean") {
                            dst.autoBucklingLength = src.autoBucklingLength;
                        }
                        else {
                            console.log('Expected autoBucklingLength of EndPointParamCache to be a boolean but was ', typeof src.autoBucklingLength, src.autoBucklingLength)
                        }
                    }
                    return dst;
                }

                static toObject(src: EndPointParamCache | null | undefined): EndPointParamCache_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.EndPointParamCache is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.EndPointParamCache") {
                        console.error('Expected ng.frontend.beam.EndPointParamCache but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EndPointParamCache_json = {
                        autoBucklingLength: src.autoBucklingLength,
                    };
                    if(src.loadCombGenSettings !== null)
                    {
                        const parsed = ng.endpoint_args.eurocode.LoadCombGenSettings.toObject(src.loadCombGenSettings);
                        if(parsed === null) return null;
                        dst.loadCombGenSettings = parsed;
                    }
                    if(src.autoDesign !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesign.toObject(src.autoDesign);
                        if(parsed === null) return null;
                        dst.autoDesign = parsed;
                    }
                    return dst;
                }

                static create(src?: EndPointParamCache_createType) {
                    const dst = new EndPointParamCache();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.loadCombGenSettings !== undefined) {
                        dst.loadCombGenSettings = src.loadCombGenSettings;
                    }
                    if (src.autoDesign !== undefined) {
                        dst.autoDesign = src.autoDesign;
                    }
                    if (src.autoBucklingLength !== undefined) {
                        dst.autoBucklingLength = src.autoBucklingLength;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EndPointParamCache();
                    dst.loadCombGenSettings = this.loadCombGenSettings;
                    dst.autoDesign = this.autoDesign;
                    dst.autoBucklingLength = this.autoBucklingLength;
                    return dst;
                }

                deepClone() {
                    const json = EndPointParamCache.toObject(this);
                    const dst = EndPointParamCache.fromObject(json);
                    return dst;
                }
            }
            export type IEndPointParamCache = EndPointParamCache;


            export type FrontendData_keys = 'printSettings' | 'visuals' | 'endpointCache';
            export interface FrontendData_createType {
                printSettings?: ng.frontend.beam.PrintSetting[],
                visuals?: ng.frontend.beam.PrintVisuals | null,
                endpointCache?: ng.frontend.beam.EndPointParamCache | null,
            }
            export interface FrontendData_json {
                printSettings: ng.frontend.beam.PrintSetting_json[];
                visuals?: ng.frontend.beam.PrintVisuals_json;
                endpointCache?: ng.frontend.beam.EndPointParamCache_json;
            }
            interface FrontendData_json_in {
                __proto_name?: unknown;
                printSettings?: unknown;
                visuals?: unknown;
                endpointCache?: unknown;
            }
            export class FrontendData {
                __proto_name = "ng.frontend.beam.FrontendData";
                printSettings: ng.frontend.beam.PrintSetting[] = [];
                visuals: ng.frontend.beam.PrintVisuals | null = null;
                endpointCache: ng.frontend.beam.EndPointParamCache | null = null;

                static fromObject(src_unknown: unknown): FrontendData {
                    const dst = new FrontendData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FrontendData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FrontendData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FrontendData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.printSettings !== undefined && src.printSettings !== null) {
                        if (Array.isArray(src.printSettings)) {
                            for (const element of src.printSettings) {
                                dst.printSettings.push(ng.frontend.beam.PrintSetting.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected printSettings of FrontendData to be a array but was ', typeof src.printSettings, src.printSettings)
                        }
                    }
                    if (src.visuals !== undefined && src.visuals !== null) {
                        dst.visuals = ng.frontend.beam.PrintVisuals.fromObject(src.visuals);
                    }
                    if (src.endpointCache !== undefined && src.endpointCache !== null) {
                        dst.endpointCache = ng.frontend.beam.EndPointParamCache.fromObject(src.endpointCache);
                    }
                    return dst;
                }

                static toObject(src: FrontendData | null | undefined): FrontendData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.FrontendData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.FrontendData") {
                        console.error('Expected ng.frontend.beam.FrontendData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FrontendData_json = {
                        printSettings: new Array<ng.frontend.beam.PrintSetting_json>(),
                    };
                    if (src.printSettings !== null) {
                        for (const element of src.printSettings) {
                            const parsed = ng.frontend.beam.PrintSetting.toObject(element);
                            if(parsed === null) return null;
                            dst.printSettings.push(parsed);
                        }
                    }
                    if(src.visuals !== null)
                    {
                        const parsed = ng.frontend.beam.PrintVisuals.toObject(src.visuals);
                        if(parsed === null) return null;
                        dst.visuals = parsed;
                    }
                    if(src.endpointCache !== null)
                    {
                        const parsed = ng.frontend.beam.EndPointParamCache.toObject(src.endpointCache);
                        if(parsed === null) return null;
                        dst.endpointCache = parsed;
                    }
                    return dst;
                }

                static create(src?: FrontendData_createType) {
                    const dst = new FrontendData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.printSettings !== undefined) {
                        dst.printSettings = src.printSettings;
                    }
                    if (src.visuals !== undefined) {
                        dst.visuals = src.visuals;
                    }
                    if (src.endpointCache !== undefined) {
                        dst.endpointCache = src.endpointCache;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FrontendData();
                    dst.printSettings = this.printSettings;
                    dst.visuals = this.visuals;
                    dst.endpointCache = this.endpointCache;
                    return dst;
                }

                deepClone() {
                    const json = FrontendData.toObject(this);
                    const dst = FrontendData.fromObject(json);
                    return dst;
                }
            }
            export type IFrontendData = FrontendData;


            export type ProjectMeta_keys = 'guid' | 'name' | 'eTag' | 'revision' | 'description' | 'author' | 'company' | 'created' | 'signature' | 'comments' | 'keywords' | 'appVersion' | 'buildNumber' | 'lastModified' | 'modifiedBy' | 'location' | 'project' | 'projectNumber' | 'app';
            export interface ProjectMeta_createType {
                guid?: string,
                name?: string,
                eTag?: string,
                revision?: number,
                description?: string,
                author?: string,
                company?: string,
                created?: string,
                signature?: string,
                comments?: string,
                keywords?: string[],
                appVersion?: ng.utils.SemVer | null,
                buildNumber?: string,
                lastModified?: string,
                modifiedBy?: string,
                location?: string,
                project?: string,
                projectNumber?: string,
                app?: ng.frontend.general.SimplexApp,
            }
            export interface ProjectMeta_json {
                guid?: string;
                name?: string;
                eTag?: string;
                revision?: JsonNumber;
                description?: string;
                author?: string;
                company?: string;
                created?: string;
                signature?: string;
                comments?: string;
                keywords: string[];
                appVersion?: ng.utils.SemVer_json;
                buildNumber?: string;
                lastModified?: string;
                modifiedBy?: string;
                location?: string;
                project?: string;
                projectNumber?: string;
                app?: string;
            }
            interface ProjectMeta_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                name?: unknown;
                eTag?: unknown;
                revision?: unknown;
                description?: unknown;
                author?: unknown;
                company?: unknown;
                created?: unknown;
                signature?: unknown;
                comments?: unknown;
                keywords?: unknown;
                appVersion?: unknown;
                buildNumber?: unknown;
                lastModified?: unknown;
                modifiedBy?: unknown;
                location?: unknown;
                project?: unknown;
                projectNumber?: unknown;
                app?: unknown;
            }
            export class ProjectMeta {
                __proto_name = "ng.frontend.beam.ProjectMeta";
                guid: string = "";
                name: string = "";
                eTag: string = "";
                revision: number = 0;
                description: string = "";
                author: string = "";
                company: string = "";
                created: string = "";
                signature: string = "";
                comments: string = "";
                keywords: string[] = [];
                appVersion: ng.utils.SemVer | null = null;
                buildNumber: string = "";
                lastModified: string = "";
                modifiedBy: string = "";
                location: string = "";
                project: string = "";
                projectNumber: string = "";
                app: ng.frontend.general.SimplexApp = ng.frontend.general.SimplexApp.SIMPLEX_APP_UNSPECIFIED;

                static fromObject(src_unknown: unknown): ProjectMeta {
                    const dst = new ProjectMeta();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ProjectMeta but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ProjectMeta_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ProjectMeta but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of ProjectMeta to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.name !== undefined && src.name !== null) {
                        if (typeof src.name === "string") {
                            dst.name = src.name;
                        }
                        else {
                            console.log('Expected name of ProjectMeta to be a string but was ', typeof src.name, src.name)
                        }
                    }
                    if (src.eTag !== undefined && src.eTag !== null) {
                        if (typeof src.eTag === "string") {
                            dst.eTag = src.eTag;
                        }
                        else {
                            console.log('Expected eTag of ProjectMeta to be a string but was ', typeof src.eTag, src.eTag)
                        }
                    }
                    if (src.revision !== undefined && src.revision !== null) {
                        if (typeof src.revision === "number" || src.revision === 'NaN' || src.revision === 'Infinity' || src.revision === '-Infinity') {
                            dst.revision = NumberToInt("ng.frontend.beam.ProjectMeta.revision", AsNum(src.revision));
                        }
                        else {
                            console.log('Expected revision of ProjectMeta to be a number but was ', typeof src.revision, src.revision)
                        }
                    }
                    if (src.description !== undefined && src.description !== null) {
                        if (typeof src.description === "string") {
                            dst.description = src.description;
                        }
                        else {
                            console.log('Expected description of ProjectMeta to be a string but was ', typeof src.description, src.description)
                        }
                    }
                    if (src.author !== undefined && src.author !== null) {
                        if (typeof src.author === "string") {
                            dst.author = src.author;
                        }
                        else {
                            console.log('Expected author of ProjectMeta to be a string but was ', typeof src.author, src.author)
                        }
                    }
                    if (src.company !== undefined && src.company !== null) {
                        if (typeof src.company === "string") {
                            dst.company = src.company;
                        }
                        else {
                            console.log('Expected company of ProjectMeta to be a string but was ', typeof src.company, src.company)
                        }
                    }
                    if (src.created !== undefined && src.created !== null) {
                        if (typeof src.created === "string") {
                            dst.created = src.created;
                        }
                        else {
                            console.log('Expected created of ProjectMeta to be a string but was ', typeof src.created, src.created)
                        }
                    }
                    if (src.signature !== undefined && src.signature !== null) {
                        if (typeof src.signature === "string") {
                            dst.signature = src.signature;
                        }
                        else {
                            console.log('Expected signature of ProjectMeta to be a string but was ', typeof src.signature, src.signature)
                        }
                    }
                    if (src.comments !== undefined && src.comments !== null) {
                        if (typeof src.comments === "string") {
                            dst.comments = src.comments;
                        }
                        else {
                            console.log('Expected comments of ProjectMeta to be a string but was ', typeof src.comments, src.comments)
                        }
                    }
                    if (src.keywords !== undefined && src.keywords !== null) {
                        if (Array.isArray(src.keywords)) {
                            for (const [index, element] of src.keywords.entries()) {
                                if (typeof element === "string") {
                                    dst.keywords.push(element);
                                }
                                else {
                                    console.log('Expected keywords of ProjectMeta[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected keywords of ProjectMeta to be a array but was ', typeof src.keywords, src.keywords)
                        }
                    }
                    if (src.appVersion !== undefined && src.appVersion !== null) {
                        dst.appVersion = ng.utils.SemVer.fromObject(src.appVersion);
                    }
                    if (src.buildNumber !== undefined && src.buildNumber !== null) {
                        if (typeof src.buildNumber === "string") {
                            dst.buildNumber = src.buildNumber;
                        }
                        else {
                            console.log('Expected buildNumber of ProjectMeta to be a string but was ', typeof src.buildNumber, src.buildNumber)
                        }
                    }
                    if (src.lastModified !== undefined && src.lastModified !== null) {
                        if (typeof src.lastModified === "string") {
                            dst.lastModified = src.lastModified;
                        }
                        else {
                            console.log('Expected lastModified of ProjectMeta to be a string but was ', typeof src.lastModified, src.lastModified)
                        }
                    }
                    if (src.modifiedBy !== undefined && src.modifiedBy !== null) {
                        if (typeof src.modifiedBy === "string") {
                            dst.modifiedBy = src.modifiedBy;
                        }
                        else {
                            console.log('Expected modifiedBy of ProjectMeta to be a string but was ', typeof src.modifiedBy, src.modifiedBy)
                        }
                    }
                    if (src.location !== undefined && src.location !== null) {
                        if (typeof src.location === "string") {
                            dst.location = src.location;
                        }
                        else {
                            console.log('Expected location of ProjectMeta to be a string but was ', typeof src.location, src.location)
                        }
                    }
                    if (src.project !== undefined && src.project !== null) {
                        if (typeof src.project === "string") {
                            dst.project = src.project;
                        }
                        else {
                            console.log('Expected project of ProjectMeta to be a string but was ', typeof src.project, src.project)
                        }
                    }
                    if (src.projectNumber !== undefined && src.projectNumber !== null) {
                        if (typeof src.projectNumber === "string") {
                            dst.projectNumber = src.projectNumber;
                        }
                        else {
                            console.log('Expected projectNumber of ProjectMeta to be a string but was ', typeof src.projectNumber, src.projectNumber)
                        }
                    }
                    if (src.app !== undefined && src.app !== null) {
                        dst.app = ng.frontend.general.SimplexApp_FromObject(src.app);
                    }
                    return dst;
                }

                static toObject(src: ProjectMeta | null | undefined): ProjectMeta_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.ProjectMeta is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.ProjectMeta") {
                        console.error('Expected ng.frontend.beam.ProjectMeta but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const app_obj = ng.frontend.general.SimplexApp_ToObject(src.app);
                    if(app_obj === null) return null;

                    const dst : ProjectMeta_json = {
                        guid: src.guid,
                        name: src.name,
                        eTag: src.eTag,
                        revision: AsJsonNum(NumberToInt("ng.frontend.beam.ProjectMeta.revision", src.revision)),
                        description: src.description,
                        author: src.author,
                        company: src.company,
                        created: src.created,
                        signature: src.signature,
                        comments: src.comments,
                        keywords: new Array<string>(),
                        buildNumber: src.buildNumber,
                        lastModified: src.lastModified,
                        modifiedBy: src.modifiedBy,
                        location: src.location,
                        project: src.project,
                        projectNumber: src.projectNumber,
                        app: app_obj,
                    };
                    if (src.keywords !== null) {
                        for (const element of src.keywords) {
                            dst.keywords.push(element);
                        }
                    }
                    if(src.appVersion !== null)
                    {
                        const parsed = ng.utils.SemVer.toObject(src.appVersion);
                        if(parsed === null) return null;
                        dst.appVersion = parsed;
                    }
                    return dst;
                }

                static create(src?: ProjectMeta_createType) {
                    const dst = new ProjectMeta();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.name !== undefined) {
                        dst.name = src.name;
                    }
                    if (src.eTag !== undefined) {
                        dst.eTag = src.eTag;
                    }
                    if (src.revision !== undefined) {
                        dst.revision = src.revision;
                    }
                    if (src.description !== undefined) {
                        dst.description = src.description;
                    }
                    if (src.author !== undefined) {
                        dst.author = src.author;
                    }
                    if (src.company !== undefined) {
                        dst.company = src.company;
                    }
                    if (src.created !== undefined) {
                        dst.created = src.created;
                    }
                    if (src.signature !== undefined) {
                        dst.signature = src.signature;
                    }
                    if (src.comments !== undefined) {
                        dst.comments = src.comments;
                    }
                    if (src.keywords !== undefined) {
                        dst.keywords = src.keywords;
                    }
                    if (src.appVersion !== undefined) {
                        dst.appVersion = src.appVersion;
                    }
                    if (src.buildNumber !== undefined) {
                        dst.buildNumber = src.buildNumber;
                    }
                    if (src.lastModified !== undefined) {
                        dst.lastModified = src.lastModified;
                    }
                    if (src.modifiedBy !== undefined) {
                        dst.modifiedBy = src.modifiedBy;
                    }
                    if (src.location !== undefined) {
                        dst.location = src.location;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.projectNumber !== undefined) {
                        dst.projectNumber = src.projectNumber;
                    }
                    if (src.app !== undefined) {
                        dst.app = src.app;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ProjectMeta();
                    dst.guid = this.guid;
                    dst.name = this.name;
                    dst.eTag = this.eTag;
                    dst.revision = this.revision;
                    dst.description = this.description;
                    dst.author = this.author;
                    dst.company = this.company;
                    dst.created = this.created;
                    dst.signature = this.signature;
                    dst.comments = this.comments;
                    dst.keywords = this.keywords;
                    dst.appVersion = this.appVersion;
                    dst.buildNumber = this.buildNumber;
                    dst.lastModified = this.lastModified;
                    dst.modifiedBy = this.modifiedBy;
                    dst.location = this.location;
                    dst.project = this.project;
                    dst.projectNumber = this.projectNumber;
                    dst.app = this.app;
                    return dst;
                }

                deepClone() {
                    const json = ProjectMeta.toObject(this);
                    const dst = ProjectMeta.fromObject(json);
                    return dst;
                }
            }
            export type IProjectMeta = ProjectMeta;


            export type Project_keys = 'meta' | 'data' | 'settings';
            export interface Project_createType {
                meta?: ng.frontend.beam.ProjectMeta | null,
                data?: ng.project.Data | null,
                settings?: ng.frontend.beam.FrontendData | null,
            }
            export interface Project_json {
                meta?: ng.frontend.beam.ProjectMeta_json;
                data?: ng.project.Data_json;
                settings?: ng.frontend.beam.FrontendData_json;
            }
            interface Project_json_in {
                __proto_name?: unknown;
                meta?: unknown;
                data?: unknown;
                settings?: unknown;
            }
            export class Project {
                __proto_name = "ng.frontend.beam.Project";
                meta: ng.frontend.beam.ProjectMeta | null = null;
                data: ng.project.Data | null = null;
                settings: ng.frontend.beam.FrontendData | null = null;

                static fromObject(src_unknown: unknown): Project {
                    const dst = new Project();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Project but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Project_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Project but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.meta !== undefined && src.meta !== null) {
                        dst.meta = ng.frontend.beam.ProjectMeta.fromObject(src.meta);
                    }
                    if (src.data !== undefined && src.data !== null) {
                        dst.data = ng.project.Data.fromObject(src.data);
                    }
                    if (src.settings !== undefined && src.settings !== null) {
                        dst.settings = ng.frontend.beam.FrontendData.fromObject(src.settings);
                    }
                    return dst;
                }

                static toObject(src: Project | null | undefined): Project_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.frontend.beam.Project is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.frontend.beam.Project") {
                        console.error('Expected ng.frontend.beam.Project but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Project_json = {
                    };
                    if(src.meta !== null)
                    {
                        const parsed = ng.frontend.beam.ProjectMeta.toObject(src.meta);
                        if(parsed === null) return null;
                        dst.meta = parsed;
                    }
                    if(src.data !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.data);
                        if(parsed === null) return null;
                        dst.data = parsed;
                    }
                    if(src.settings !== null)
                    {
                        const parsed = ng.frontend.beam.FrontendData.toObject(src.settings);
                        if(parsed === null) return null;
                        dst.settings = parsed;
                    }
                    return dst;
                }

                static create(src?: Project_createType) {
                    const dst = new Project();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.meta !== undefined) {
                        dst.meta = src.meta;
                    }
                    if (src.data !== undefined) {
                        dst.data = src.data;
                    }
                    if (src.settings !== undefined) {
                        dst.settings = src.settings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Project();
                    dst.meta = this.meta;
                    dst.data = this.data;
                    dst.settings = this.settings;
                    return dst;
                }

                deepClone() {
                    const json = Project.toObject(this);
                    const dst = Project.fromObject(json);
                    return dst;
                }
            }
            export type IProject = Project;
        } // namespace beam
    } // namespace frontend


    // Defined in 2 files
    export namespace fire_protection {
        // Defined in FireProtection/timber.proto
        export namespace timber {
            export enum MaterialType {
                MATERIAL_TYPE_UNSPECIFIED = 0,
                MATERIAL_TYPE_WOOD = 1,
                MATERIAL_TYPE_GYPSUM_BOARD_AH1_INTERNAL = 2,
                MATERIAL_TYPE_GYPSUM_BOARD_AH1_OTHER = 3,
                MATERIAL_TYPE_GYPSUM_BOARD_AH2_INTERNAL = 4,
                MATERIAL_TYPE_GYPSUM_BOARD_AH2_OTHER = 5,
                MATERIAL_TYPE_GYPSUM_BOARD_F1_INTERNAL = 6,
                MATERIAL_TYPE_GYPSUM_BOARD_F1_OTHER = 7,
                MATERIAL_TYPE_GYPSUM_BOARD_F2_INTERNAL = 8,
                MATERIAL_TYPE_GYPSUM_BOARD_F2_OTHER = 9,
                MATERIAL_TYPE_ROCK_FIBER = 10,
                MATERIAL_TYPE_USER_DEFINED = 11,
                MATERIAL_TYPE_NONE = 12
            }
            export const MaterialType_FromObject = (src: unknown): MaterialType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'MATERIAL_TYPE_UNSPECIFIED':
                        return MaterialType.MATERIAL_TYPE_UNSPECIFIED;
                    case 1:
                    case 'MATERIAL_TYPE_WOOD':
                        return MaterialType.MATERIAL_TYPE_WOOD;
                    case 2:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_AH1_INTERNAL':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH1_INTERNAL;
                    case 3:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_AH1_OTHER':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH1_OTHER;
                    case 4:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_AH2_INTERNAL':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH2_INTERNAL;
                    case 5:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_AH2_OTHER':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH2_OTHER;
                    case 6:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_F1_INTERNAL':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F1_INTERNAL;
                    case 7:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_F1_OTHER':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F1_OTHER;
                    case 8:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_F2_INTERNAL':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F2_INTERNAL;
                    case 9:
                    case 'MATERIAL_TYPE_GYPSUM_BOARD_F2_OTHER':
                        return MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F2_OTHER;
                    case 10:
                    case 'MATERIAL_TYPE_ROCK_FIBER':
                        return MaterialType.MATERIAL_TYPE_ROCK_FIBER;
                    case 11:
                    case 'MATERIAL_TYPE_USER_DEFINED':
                        return MaterialType.MATERIAL_TYPE_USER_DEFINED;
                    case 12:
                    case 'MATERIAL_TYPE_NONE':
                        return MaterialType.MATERIAL_TYPE_NONE;
                    default:
                        console.log('Unhandled value for MaterialType:' + src + '. ' + typeof(src));
                        return MaterialType.MATERIAL_TYPE_UNSPECIFIED;
                }
            };
            export const MaterialType_ToObject = (src: MaterialType): string | null => {
                switch (src) {
                    case MaterialType.MATERIAL_TYPE_UNSPECIFIED:
                        return 'MATERIAL_TYPE_UNSPECIFIED';
                    case MaterialType.MATERIAL_TYPE_WOOD:
                        return 'MATERIAL_TYPE_WOOD';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH1_INTERNAL:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_AH1_INTERNAL';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH1_OTHER:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_AH1_OTHER';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH2_INTERNAL:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_AH2_INTERNAL';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH2_OTHER:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_AH2_OTHER';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F1_INTERNAL:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_F1_INTERNAL';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F1_OTHER:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_F1_OTHER';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F2_INTERNAL:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_F2_INTERNAL';
                    case MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F2_OTHER:
                        return 'MATERIAL_TYPE_GYPSUM_BOARD_F2_OTHER';
                    case MaterialType.MATERIAL_TYPE_ROCK_FIBER:
                        return 'MATERIAL_TYPE_ROCK_FIBER';
                    case MaterialType.MATERIAL_TYPE_USER_DEFINED:
                        return 'MATERIAL_TYPE_USER_DEFINED';
                    case MaterialType.MATERIAL_TYPE_NONE:
                        return 'MATERIAL_TYPE_NONE';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for MaterialType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type CharacteristicData_keys = 'materialType' | 'thickness' | 'thicknessInner' | 'thicknessOuter' | 'charringRate' | 'failureTime' | 'charringStartTime' | 'charringRateModFactor';
            export interface CharacteristicData_createType {
                materialType?: ng.fire_protection.timber.MaterialType,
                thickness?: number,
                thicknessInner?: number,
                thicknessOuter?: number,
                charringRate?: number,
                failureTime?: number,
                charringStartTime?: number,
                charringRateModFactor?: number,
            }
            export interface CharacteristicData_json {
                materialType?: string;
                thickness?: JsonNumber;
                thicknessInner?: JsonNumber;
                thicknessOuter?: JsonNumber;
                charringRate?: JsonNumber;
                failureTime?: JsonNumber;
                charringStartTime?: JsonNumber;
                charringRateModFactor?: JsonNumber;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                materialType?: unknown;
                thickness?: unknown;
                thicknessInner?: unknown;
                thicknessOuter?: unknown;
                charringRate?: unknown;
                failureTime?: unknown;
                charringStartTime?: unknown;
                charringRateModFactor?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.fire_protection.timber.CharacteristicData";
                materialType: ng.fire_protection.timber.MaterialType = ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_UNSPECIFIED;
                thickness: number = 0;
                thicknessInner: number = 0;
                thicknessOuter: number = 0;
                charringRate: number = 0;
                failureTime: number = 0;
                charringStartTime: number = 0;
                charringRateModFactor: number = 0;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.materialType !== undefined && src.materialType !== null) {
                        dst.materialType = ng.fire_protection.timber.MaterialType_FromObject(src.materialType);
                    }
                    if (src.thickness !== undefined && src.thickness !== null) {
                        if (typeof src.thickness === "number" || src.thickness === 'NaN' || src.thickness === 'Infinity' || src.thickness === '-Infinity') {
                            dst.thickness = AsNum(src.thickness);
                        }
                        else {
                            console.log('Expected thickness of CharacteristicData to be a number but was ', typeof src.thickness, src.thickness)
                        }
                    }
                    if (src.thicknessInner !== undefined && src.thicknessInner !== null) {
                        if (typeof src.thicknessInner === "number" || src.thicknessInner === 'NaN' || src.thicknessInner === 'Infinity' || src.thicknessInner === '-Infinity') {
                            dst.thicknessInner = AsNum(src.thicknessInner);
                        }
                        else {
                            console.log('Expected thicknessInner of CharacteristicData to be a number but was ', typeof src.thicknessInner, src.thicknessInner)
                        }
                    }
                    if (src.thicknessOuter !== undefined && src.thicknessOuter !== null) {
                        if (typeof src.thicknessOuter === "number" || src.thicknessOuter === 'NaN' || src.thicknessOuter === 'Infinity' || src.thicknessOuter === '-Infinity') {
                            dst.thicknessOuter = AsNum(src.thicknessOuter);
                        }
                        else {
                            console.log('Expected thicknessOuter of CharacteristicData to be a number but was ', typeof src.thicknessOuter, src.thicknessOuter)
                        }
                    }
                    if (src.charringRate !== undefined && src.charringRate !== null) {
                        if (typeof src.charringRate === "number" || src.charringRate === 'NaN' || src.charringRate === 'Infinity' || src.charringRate === '-Infinity') {
                            dst.charringRate = AsNum(src.charringRate);
                        }
                        else {
                            console.log('Expected charringRate of CharacteristicData to be a number but was ', typeof src.charringRate, src.charringRate)
                        }
                    }
                    if (src.failureTime !== undefined && src.failureTime !== null) {
                        if (typeof src.failureTime === "number" || src.failureTime === 'NaN' || src.failureTime === 'Infinity' || src.failureTime === '-Infinity') {
                            dst.failureTime = AsNum(src.failureTime);
                        }
                        else {
                            console.log('Expected failureTime of CharacteristicData to be a number but was ', typeof src.failureTime, src.failureTime)
                        }
                    }
                    if (src.charringStartTime !== undefined && src.charringStartTime !== null) {
                        if (typeof src.charringStartTime === "number" || src.charringStartTime === 'NaN' || src.charringStartTime === 'Infinity' || src.charringStartTime === '-Infinity') {
                            dst.charringStartTime = AsNum(src.charringStartTime);
                        }
                        else {
                            console.log('Expected charringStartTime of CharacteristicData to be a number but was ', typeof src.charringStartTime, src.charringStartTime)
                        }
                    }
                    if (src.charringRateModFactor !== undefined && src.charringRateModFactor !== null) {
                        if (typeof src.charringRateModFactor === "number" || src.charringRateModFactor === 'NaN' || src.charringRateModFactor === 'Infinity' || src.charringRateModFactor === '-Infinity') {
                            dst.charringRateModFactor = AsNum(src.charringRateModFactor);
                        }
                        else {
                            console.log('Expected charringRateModFactor of CharacteristicData to be a number but was ', typeof src.charringRateModFactor, src.charringRateModFactor)
                        }
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fire_protection.timber.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fire_protection.timber.CharacteristicData") {
                        console.error('Expected ng.fire_protection.timber.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const materialType_obj = ng.fire_protection.timber.MaterialType_ToObject(src.materialType);
                    if(materialType_obj === null) return null;

                    const dst : CharacteristicData_json = {
                        materialType: materialType_obj,
                        thickness: AsJsonNum(src.thickness),
                        thicknessInner: AsJsonNum(src.thicknessInner),
                        thicknessOuter: AsJsonNum(src.thicknessOuter),
                        charringRate: AsJsonNum(src.charringRate),
                        failureTime: AsJsonNum(src.failureTime),
                        charringStartTime: AsJsonNum(src.charringStartTime),
                        charringRateModFactor: AsJsonNum(src.charringRateModFactor),
                    };
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.materialType !== undefined) {
                        dst.materialType = src.materialType;
                    }
                    if (src.thickness !== undefined) {
                        dst.thickness = src.thickness;
                    }
                    if (src.thicknessInner !== undefined) {
                        dst.thicknessInner = src.thicknessInner;
                    }
                    if (src.thicknessOuter !== undefined) {
                        dst.thicknessOuter = src.thicknessOuter;
                    }
                    if (src.charringRate !== undefined) {
                        dst.charringRate = src.charringRate;
                    }
                    if (src.failureTime !== undefined) {
                        dst.failureTime = src.failureTime;
                    }
                    if (src.charringStartTime !== undefined) {
                        dst.charringStartTime = src.charringStartTime;
                    }
                    if (src.charringRateModFactor !== undefined) {
                        dst.charringRateModFactor = src.charringRateModFactor;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.materialType = this.materialType;
                    dst.thickness = this.thickness;
                    dst.thicknessInner = this.thicknessInner;
                    dst.thicknessOuter = this.thicknessOuter;
                    dst.charringRate = this.charringRate;
                    dst.failureTime = this.failureTime;
                    dst.charringStartTime = this.charringStartTime;
                    dst.charringRateModFactor = this.charringRateModFactor;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type Data_keys = 'id' | 'properties';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                properties?: ng.fire_protection.timber.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                properties?: ng.fire_protection.timber.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                properties?: unknown;
            }
            export class Data {
                __proto_name = "ng.fire_protection.timber.Data";
                id: ng.utils.ID | null = null;
                properties: ng.fire_protection.timber.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.fire_protection.timber.CharacteristicData.fromObject(src.properties);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fire_protection.timber.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fire_protection.timber.Data") {
                        console.error('Expected ng.fire_protection.timber.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.fire_protection.timber.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace timber


        // Defined in FireProtection/steel.proto
        export namespace steel {
            export enum Encasement {
                ENCASEMENT_UNSPECIFIED = 0,
                ENCASEMENT_CONTOUR = 1,
                ENCASEMENT_HOLLOW = 2
            }
            export const Encasement_FromObject = (src: unknown): Encasement => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ENCASEMENT_UNSPECIFIED':
                        return Encasement.ENCASEMENT_UNSPECIFIED;
                    case 1:
                    case 'ENCASEMENT_CONTOUR':
                        return Encasement.ENCASEMENT_CONTOUR;
                    case 2:
                    case 'ENCASEMENT_HOLLOW':
                        return Encasement.ENCASEMENT_HOLLOW;
                    default:
                        console.log('Unhandled value for Encasement:' + src + '. ' + typeof(src));
                        return Encasement.ENCASEMENT_UNSPECIFIED;
                }
            };
            export const Encasement_ToObject = (src: Encasement): string | null => {
                switch (src) {
                    case Encasement.ENCASEMENT_UNSPECIFIED:
                        return 'ENCASEMENT_UNSPECIFIED';
                    case Encasement.ENCASEMENT_CONTOUR:
                        return 'ENCASEMENT_CONTOUR';
                    case Encasement.ENCASEMENT_HOLLOW:
                        return 'ENCASEMENT_HOLLOW';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Encasement, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type CharacteristicData_keys = 'density' | 'specificHeat' | 'thermalConductivity' | 'encasement';
            export interface CharacteristicData_createType {
                density?: number,
                specificHeat?: number,
                thermalConductivity?: number,
                encasement?: ng.fire_protection.steel.Encasement,
            }
            export interface CharacteristicData_json {
                density?: JsonNumber;
                specificHeat?: JsonNumber;
                thermalConductivity?: JsonNumber;
                encasement?: string;
            }
            interface CharacteristicData_json_in {
                __proto_name?: unknown;
                density?: unknown;
                specificHeat?: unknown;
                thermalConductivity?: unknown;
                encasement?: unknown;
            }
            export class CharacteristicData {
                __proto_name = "ng.fire_protection.steel.CharacteristicData";
                density: number = 0;
                specificHeat: number = 0;
                thermalConductivity: number = 0;
                encasement: ng.fire_protection.steel.Encasement = ng.fire_protection.steel.Encasement.ENCASEMENT_UNSPECIFIED;

                static fromObject(src_unknown: unknown): CharacteristicData {
                    const dst = new CharacteristicData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CharacteristicData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CharacteristicData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CharacteristicData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.density !== undefined && src.density !== null) {
                        if (typeof src.density === "number" || src.density === 'NaN' || src.density === 'Infinity' || src.density === '-Infinity') {
                            dst.density = AsNum(src.density);
                        }
                        else {
                            console.log('Expected density of CharacteristicData to be a number but was ', typeof src.density, src.density)
                        }
                    }
                    if (src.specificHeat !== undefined && src.specificHeat !== null) {
                        if (typeof src.specificHeat === "number" || src.specificHeat === 'NaN' || src.specificHeat === 'Infinity' || src.specificHeat === '-Infinity') {
                            dst.specificHeat = AsNum(src.specificHeat);
                        }
                        else {
                            console.log('Expected specificHeat of CharacteristicData to be a number but was ', typeof src.specificHeat, src.specificHeat)
                        }
                    }
                    if (src.thermalConductivity !== undefined && src.thermalConductivity !== null) {
                        if (typeof src.thermalConductivity === "number" || src.thermalConductivity === 'NaN' || src.thermalConductivity === 'Infinity' || src.thermalConductivity === '-Infinity') {
                            dst.thermalConductivity = AsNum(src.thermalConductivity);
                        }
                        else {
                            console.log('Expected thermalConductivity of CharacteristicData to be a number but was ', typeof src.thermalConductivity, src.thermalConductivity)
                        }
                    }
                    if (src.encasement !== undefined && src.encasement !== null) {
                        dst.encasement = ng.fire_protection.steel.Encasement_FromObject(src.encasement);
                    }
                    return dst;
                }

                static toObject(src: CharacteristicData | null | undefined): CharacteristicData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fire_protection.steel.CharacteristicData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fire_protection.steel.CharacteristicData") {
                        console.error('Expected ng.fire_protection.steel.CharacteristicData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const encasement_obj = ng.fire_protection.steel.Encasement_ToObject(src.encasement);
                    if(encasement_obj === null) return null;

                    const dst : CharacteristicData_json = {
                        density: AsJsonNum(src.density),
                        specificHeat: AsJsonNum(src.specificHeat),
                        thermalConductivity: AsJsonNum(src.thermalConductivity),
                        encasement: encasement_obj,
                    };
                    return dst;
                }

                static create(src?: CharacteristicData_createType) {
                    const dst = new CharacteristicData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.density !== undefined) {
                        dst.density = src.density;
                    }
                    if (src.specificHeat !== undefined) {
                        dst.specificHeat = src.specificHeat;
                    }
                    if (src.thermalConductivity !== undefined) {
                        dst.thermalConductivity = src.thermalConductivity;
                    }
                    if (src.encasement !== undefined) {
                        dst.encasement = src.encasement;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CharacteristicData();
                    dst.density = this.density;
                    dst.specificHeat = this.specificHeat;
                    dst.thermalConductivity = this.thermalConductivity;
                    dst.encasement = this.encasement;
                    return dst;
                }

                deepClone() {
                    const json = CharacteristicData.toObject(this);
                    const dst = CharacteristicData.fromObject(json);
                    return dst;
                }
            }
            export type ICharacteristicData = CharacteristicData;


            export type Data_keys = 'id' | 'properties';
            export interface Data_createType {
                id?: ng.utils.ID | null,
                properties?: ng.fire_protection.steel.CharacteristicData | null,
            }
            export interface Data_json {
                id?: ng.utils.ID_json;
                properties?: ng.fire_protection.steel.CharacteristicData_json;
            }
            interface Data_json_in {
                __proto_name?: unknown;
                id?: unknown;
                properties?: unknown;
            }
            export class Data {
                __proto_name = "ng.fire_protection.steel.Data";
                id: ng.utils.ID | null = null;
                properties: ng.fire_protection.steel.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): Data {
                    const dst = new Data();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Data but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Data_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.id !== undefined && src.id !== null) {
                        dst.id = ng.utils.ID.fromObject(src.id);
                    }
                    if (src.properties !== undefined && src.properties !== null) {
                        dst.properties = ng.fire_protection.steel.CharacteristicData.fromObject(src.properties);
                    }
                    return dst;
                }

                static toObject(src: Data | null | undefined): Data_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fire_protection.steel.Data is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fire_protection.steel.Data") {
                        console.error('Expected ng.fire_protection.steel.Data but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Data_json = {
                    };
                    if(src.id !== null)
                    {
                        const parsed = ng.utils.ID.toObject(src.id);
                        if(parsed === null) return null;
                        dst.id = parsed;
                    }
                    if(src.properties !== null)
                    {
                        const parsed = ng.fire_protection.steel.CharacteristicData.toObject(src.properties);
                        if(parsed === null) return null;
                        dst.properties = parsed;
                    }
                    return dst;
                }

                static create(src?: Data_createType) {
                    const dst = new Data();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.id !== undefined) {
                        dst.id = src.id;
                    }
                    if (src.properties !== undefined) {
                        dst.properties = src.properties;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Data();
                    dst.id = this.id;
                    dst.properties = this.properties;
                    return dst;
                }

                deepClone() {
                    const json = Data.toObject(this);
                    const dst = Data.fromObject(json);
                    return dst;
                }
            }
            export type IData = Data;
        } // namespace steel
    } // namespace fire_protection


    // Defined in 6 files
    export namespace fem_design {
        // Defined in FEMDesign/steel_output.proto
        export namespace steel_output {
            export enum BarSectionType {
                BAR_SECTION_TYPE_UNIFORM = 0,
                BAR_SECTION_TYPE_VARIABLE = 1
            }
            export const BarSectionType_FromObject = (src: unknown): BarSectionType => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'BAR_SECTION_TYPE_UNIFORM':
                        return BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                    case 1:
                    case 'BAR_SECTION_TYPE_VARIABLE':
                        return BarSectionType.BAR_SECTION_TYPE_VARIABLE;
                    default:
                        console.log('Unhandled value for BarSectionType:' + src + '. ' + typeof(src));
                        return BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                }
            };
            export const BarSectionType_ToObject = (src: BarSectionType): string | null => {
                switch (src) {
                    case BarSectionType.BAR_SECTION_TYPE_UNIFORM:
                        return 'BAR_SECTION_TYPE_UNIFORM';
                    case BarSectionType.BAR_SECTION_TYPE_VARIABLE:
                        return 'BAR_SECTION_TYPE_VARIABLE';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for BarSectionType, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum LimitState {
                LIMIT_STATE_ULTIMATE = 0,
                LIMIT_STATE_CHARACTERISTIC = 1,
                LIMIT_STATE_ACCIDENTAL = 2,
                LIMIT_STATE_SEISMIC = 3,
                LIMIT_STATE_QUASI_PERMANENT = 4,
                LIMIT_STATE_FREQUENT = 5
            }
            export const LimitState_FromObject = (src: unknown): LimitState => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'LIMIT_STATE_ULTIMATE':
                        return LimitState.LIMIT_STATE_ULTIMATE;
                    case 1:
                    case 'LIMIT_STATE_CHARACTERISTIC':
                        return LimitState.LIMIT_STATE_CHARACTERISTIC;
                    case 2:
                    case 'LIMIT_STATE_ACCIDENTAL':
                        return LimitState.LIMIT_STATE_ACCIDENTAL;
                    case 3:
                    case 'LIMIT_STATE_SEISMIC':
                        return LimitState.LIMIT_STATE_SEISMIC;
                    case 4:
                    case 'LIMIT_STATE_QUASI_PERMANENT':
                        return LimitState.LIMIT_STATE_QUASI_PERMANENT;
                    case 5:
                    case 'LIMIT_STATE_FREQUENT':
                        return LimitState.LIMIT_STATE_FREQUENT;
                    default:
                        console.log('Unhandled value for LimitState:' + src + '. ' + typeof(src));
                        return LimitState.LIMIT_STATE_ULTIMATE;
                }
            };
            export const LimitState_ToObject = (src: LimitState): string | null => {
                switch (src) {
                    case LimitState.LIMIT_STATE_ULTIMATE:
                        return 'LIMIT_STATE_ULTIMATE';
                    case LimitState.LIMIT_STATE_CHARACTERISTIC:
                        return 'LIMIT_STATE_CHARACTERISTIC';
                    case LimitState.LIMIT_STATE_ACCIDENTAL:
                        return 'LIMIT_STATE_ACCIDENTAL';
                    case LimitState.LIMIT_STATE_SEISMIC:
                        return 'LIMIT_STATE_SEISMIC';
                    case LimitState.LIMIT_STATE_QUASI_PERMANENT:
                        return 'LIMIT_STATE_QUASI_PERMANENT';
                    case LimitState.LIMIT_STATE_FREQUENT:
                        return 'LIMIT_STATE_FREQUENT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for LimitState, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum StatSys {
                STAT_SYS_SIMPLE_SUPPORTED = 0,
                STAT_SYS_CANTILEVER = 1
            }
            export const StatSys_FromObject = (src: unknown): StatSys => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'STAT_SYS_SIMPLE_SUPPORTED':
                        return StatSys.STAT_SYS_SIMPLE_SUPPORTED;
                    case 1:
                    case 'STAT_SYS_CANTILEVER':
                        return StatSys.STAT_SYS_CANTILEVER;
                    default:
                        console.log('Unhandled value for StatSys:' + src + '. ' + typeof(src));
                        return StatSys.STAT_SYS_SIMPLE_SUPPORTED;
                }
            };
            export const StatSys_ToObject = (src: StatSys): string | null => {
                switch (src) {
                    case StatSys.STAT_SYS_SIMPLE_SUPPORTED:
                        return 'STAT_SYS_SIMPLE_SUPPORTED';
                    case StatSys.STAT_SYS_CANTILEVER:
                        return 'STAT_SYS_CANTILEVER';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for StatSys, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Alignment {
                ALIGNMENT_TOP = 0,
                ALIGNMENT_CENTER = 1,
                ALIGNMENT_BOTTOM = 2
            }
            export const Alignment_FromObject = (src: unknown): Alignment => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ALIGNMENT_TOP':
                        return Alignment.ALIGNMENT_TOP;
                    case 1:
                    case 'ALIGNMENT_CENTER':
                        return Alignment.ALIGNMENT_CENTER;
                    case 2:
                    case 'ALIGNMENT_BOTTOM':
                        return Alignment.ALIGNMENT_BOTTOM;
                    default:
                        console.log('Unhandled value for Alignment:' + src + '. ' + typeof(src));
                        return Alignment.ALIGNMENT_TOP;
                }
            };
            export const Alignment_ToObject = (src: Alignment): string | null => {
                switch (src) {
                    case Alignment.ALIGNMENT_TOP:
                        return 'ALIGNMENT_TOP';
                    case Alignment.ALIGNMENT_CENTER:
                        return 'ALIGNMENT_CENTER';
                    case Alignment.ALIGNMENT_BOTTOM:
                        return 'ALIGNMENT_BOTTOM';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Alignment, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum Curve {
                CURVE_A0 = 0,
                CURVE_A = 1,
                CURVE_B = 2,
                CURVE_C = 3,
                CURVE_D = 4
            }
            export const Curve_FromObject = (src: unknown): Curve => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CURVE_A0':
                        return Curve.CURVE_A0;
                    case 1:
                    case 'CURVE_A':
                        return Curve.CURVE_A;
                    case 2:
                    case 'CURVE_B':
                        return Curve.CURVE_B;
                    case 3:
                    case 'CURVE_C':
                        return Curve.CURVE_C;
                    case 4:
                    case 'CURVE_D':
                        return Curve.CURVE_D;
                    default:
                        console.log('Unhandled value for Curve:' + src + '. ' + typeof(src));
                        return Curve.CURVE_A0;
                }
            };
            export const Curve_ToObject = (src: Curve): string | null => {
                switch (src) {
                    case Curve.CURVE_A0:
                        return 'CURVE_A0';
                    case Curve.CURVE_A:
                        return 'CURVE_A';
                    case Curve.CURVE_B:
                        return 'CURVE_B';
                    case Curve.CURVE_C:
                        return 'CURVE_C';
                    case Curve.CURVE_D:
                        return 'CURVE_D';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for Curve, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum CurveLT {
                CURVE_L_T_A = 0,
                CURVE_L_T_B = 1,
                CURVE_L_T_C = 2,
                CURVE_L_T_D = 3
            }
            export const CurveLT_FromObject = (src: unknown): CurveLT => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'CURVE_L_T_A':
                        return CurveLT.CURVE_L_T_A;
                    case 1:
                    case 'CURVE_L_T_B':
                        return CurveLT.CURVE_L_T_B;
                    case 2:
                    case 'CURVE_L_T_C':
                        return CurveLT.CURVE_L_T_C;
                    case 3:
                    case 'CURVE_L_T_D':
                        return CurveLT.CURVE_L_T_D;
                    default:
                        console.log('Unhandled value for CurveLT:' + src + '. ' + typeof(src));
                        return CurveLT.CURVE_L_T_A;
                }
            };
            export const CurveLT_ToObject = (src: CurveLT): string | null => {
                switch (src) {
                    case CurveLT.CURVE_L_T_A:
                        return 'CURVE_L_T_A';
                    case CurveLT.CURVE_L_T_B:
                        return 'CURVE_L_T_B';
                    case CurveLT.CURVE_L_T_C:
                        return 'CURVE_L_T_C';
                    case CurveLT.CURVE_L_T_D:
                        return 'CURVE_L_T_D';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for CurveLT, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ShearStressCheckRelevant {
                SHEAR_STRESS_CHECK_RELEVANT_NO = 0,
                SHEAR_STRESS_CHECK_RELEVANT_YES = 1,
                SHEAR_STRESS_CHECK_RELEVANT_NO_BECAUSE_WEB_BUCKLING = 2
            }
            export const ShearStressCheckRelevant_FromObject = (src: unknown): ShearStressCheckRelevant => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SHEAR_STRESS_CHECK_RELEVANT_NO':
                        return ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_NO;
                    case 1:
                    case 'SHEAR_STRESS_CHECK_RELEVANT_YES':
                        return ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_YES;
                    case 2:
                    case 'SHEAR_STRESS_CHECK_RELEVANT_NO_BECAUSE_WEB_BUCKLING':
                        return ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_NO_BECAUSE_WEB_BUCKLING;
                    default:
                        console.log('Unhandled value for ShearStressCheckRelevant:' + src + '. ' + typeof(src));
                        return ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_NO;
                }
            };
            export const ShearStressCheckRelevant_ToObject = (src: ShearStressCheckRelevant): string | null => {
                switch (src) {
                    case ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_NO:
                        return 'SHEAR_STRESS_CHECK_RELEVANT_NO';
                    case ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_YES:
                        return 'SHEAR_STRESS_CHECK_RELEVANT_YES';
                    case ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_NO_BECAUSE_WEB_BUCKLING:
                        return 'SHEAR_STRESS_CHECK_RELEVANT_NO_BECAUSE_WEB_BUCKLING';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ShearStressCheckRelevant, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum ShearResistanceEnum {
                SHEAR_RESISTANCE_UNSPECIFIED = 0,
                SHEAR_RESISTANCE_I_LIKE = 1,
                SHEAR_RESISTANCE_U_LIKE = 2,
                SHEAR_RESISTANCE_HOLLOW = 3
            }
            export const ShearResistanceEnum_FromObject = (src: unknown): ShearResistanceEnum => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'SHEAR_RESISTANCE_UNSPECIFIED':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED;
                    case 1:
                    case 'SHEAR_RESISTANCE_I_LIKE':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_I_LIKE;
                    case 2:
                    case 'SHEAR_RESISTANCE_U_LIKE':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_U_LIKE;
                    case 3:
                    case 'SHEAR_RESISTANCE_HOLLOW':
                        return ShearResistanceEnum.SHEAR_RESISTANCE_HOLLOW;
                    default:
                        console.log('Unhandled value for ShearResistanceEnum:' + src + '. ' + typeof(src));
                        return ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED;
                }
            };
            export const ShearResistanceEnum_ToObject = (src: ShearResistanceEnum): string | null => {
                switch (src) {
                    case ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED:
                        return 'SHEAR_RESISTANCE_UNSPECIFIED';
                    case ShearResistanceEnum.SHEAR_RESISTANCE_I_LIKE:
                        return 'SHEAR_RESISTANCE_I_LIKE';
                    case ShearResistanceEnum.SHEAR_RESISTANCE_U_LIKE:
                        return 'SHEAR_RESISTANCE_U_LIKE';
                    case ShearResistanceEnum.SHEAR_RESISTANCE_HOLLOW:
                        return 'SHEAR_RESISTANCE_HOLLOW';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for ShearResistanceEnum, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum StBarWebRelevant {
                ST_BAR_WEB_RELEVANT_NO = 0,
                ST_BAR_WEB_RELEVANT_YES = 1,
                ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT = 2,
                ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT = 3
            }
            export const StBarWebRelevant_FromObject = (src: unknown): StBarWebRelevant => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'ST_BAR_WEB_RELEVANT_NO':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO;
                    case 1:
                    case 'ST_BAR_WEB_RELEVANT_YES':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_YES;
                    case 2:
                    case 'ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT;
                    case 3:
                    case 'ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT':
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT;
                    default:
                        console.log('Unhandled value for StBarWebRelevant:' + src + '. ' + typeof(src));
                        return StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO;
                }
            };
            export const StBarWebRelevant_ToObject = (src: StBarWebRelevant): string | null => {
                switch (src) {
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO:
                        return 'ST_BAR_WEB_RELEVANT_NO';
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_YES:
                        return 'ST_BAR_WEB_RELEVANT_YES';
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT:
                        return 'ST_BAR_WEB_RELEVANT_NO_STIFF_LIMIT';
                    case StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT:
                        return 'ST_BAR_WEB_RELEVANT_NO_UNSTIFF_LIMIT';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for StBarWebRelevant, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum InteractionMethod {
                INTERACTION_METHOD_1 = 0,
                INTERACTION_METHOD_2 = 1
            }
            export const InteractionMethod_FromObject = (src: unknown): InteractionMethod => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'INTERACTION_METHOD_1':
                        return InteractionMethod.INTERACTION_METHOD_1;
                    case 1:
                    case 'INTERACTION_METHOD_2':
                        return InteractionMethod.INTERACTION_METHOD_2;
                    default:
                        console.log('Unhandled value for InteractionMethod:' + src + '. ' + typeof(src));
                        return InteractionMethod.INTERACTION_METHOD_1;
                }
            };
            export const InteractionMethod_ToObject = (src: InteractionMethod): string | null => {
                switch (src) {
                    case InteractionMethod.INTERACTION_METHOD_1:
                        return 'INTERACTION_METHOD_1';
                    case InteractionMethod.INTERACTION_METHOD_2:
                        return 'INTERACTION_METHOD_2';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for InteractionMethod, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type BucklingShapes_keys = 'flexural1' | 'flexural2' | 'flexuralTorsional' | 'lateralTorsionalTop' | 'lateralTorsionalBottum';
            export interface BucklingShapes_createType {
                flexural1?: ng.fem_design.steel_output.Curve,
                flexural2?: ng.fem_design.steel_output.Curve,
                flexuralTorsional?: ng.fem_design.steel_output.Curve,
                lateralTorsionalTop?: ng.fem_design.steel_output.CurveLT,
                lateralTorsionalBottum?: ng.fem_design.steel_output.CurveLT,
            }
            export interface BucklingShapes_json {
                flexural1?: string;
                flexural2?: string;
                flexuralTorsional?: string;
                lateralTorsionalTop?: string;
                lateralTorsionalBottum?: string;
            }
            interface BucklingShapes_json_in {
                __proto_name?: unknown;
                flexural1?: unknown;
                flexural2?: unknown;
                flexuralTorsional?: unknown;
                lateralTorsionalTop?: unknown;
                lateralTorsionalBottum?: unknown;
            }
            export class BucklingShapes {
                __proto_name = "ng.fem_design.steel_output.BucklingShapes";
                flexural1: ng.fem_design.steel_output.Curve = ng.fem_design.steel_output.Curve.CURVE_A0;
                flexural2: ng.fem_design.steel_output.Curve = ng.fem_design.steel_output.Curve.CURVE_A0;
                flexuralTorsional: ng.fem_design.steel_output.Curve = ng.fem_design.steel_output.Curve.CURVE_A0;
                lateralTorsionalTop: ng.fem_design.steel_output.CurveLT = ng.fem_design.steel_output.CurveLT.CURVE_L_T_A;
                lateralTorsionalBottum: ng.fem_design.steel_output.CurveLT = ng.fem_design.steel_output.CurveLT.CURVE_L_T_A;

                static fromObject(src_unknown: unknown): BucklingShapes {
                    const dst = new BucklingShapes();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BucklingShapes but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BucklingShapes_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BucklingShapes but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.flexural1 !== undefined && src.flexural1 !== null) {
                        dst.flexural1 = ng.fem_design.steel_output.Curve_FromObject(src.flexural1);
                    }
                    if (src.flexural2 !== undefined && src.flexural2 !== null) {
                        dst.flexural2 = ng.fem_design.steel_output.Curve_FromObject(src.flexural2);
                    }
                    if (src.flexuralTorsional !== undefined && src.flexuralTorsional !== null) {
                        dst.flexuralTorsional = ng.fem_design.steel_output.Curve_FromObject(src.flexuralTorsional);
                    }
                    if (src.lateralTorsionalTop !== undefined && src.lateralTorsionalTop !== null) {
                        dst.lateralTorsionalTop = ng.fem_design.steel_output.CurveLT_FromObject(src.lateralTorsionalTop);
                    }
                    if (src.lateralTorsionalBottum !== undefined && src.lateralTorsionalBottum !== null) {
                        dst.lateralTorsionalBottum = ng.fem_design.steel_output.CurveLT_FromObject(src.lateralTorsionalBottum);
                    }
                    return dst;
                }

                static toObject(src: BucklingShapes | null | undefined): BucklingShapes_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.BucklingShapes is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.BucklingShapes") {
                        console.error('Expected ng.fem_design.steel_output.BucklingShapes but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const flexural1_obj = ng.fem_design.steel_output.Curve_ToObject(src.flexural1);
                    if(flexural1_obj === null) return null;

                    const flexural2_obj = ng.fem_design.steel_output.Curve_ToObject(src.flexural2);
                    if(flexural2_obj === null) return null;

                    const flexuralTorsional_obj = ng.fem_design.steel_output.Curve_ToObject(src.flexuralTorsional);
                    if(flexuralTorsional_obj === null) return null;

                    const lateralTorsionalTop_obj = ng.fem_design.steel_output.CurveLT_ToObject(src.lateralTorsionalTop);
                    if(lateralTorsionalTop_obj === null) return null;

                    const lateralTorsionalBottum_obj = ng.fem_design.steel_output.CurveLT_ToObject(src.lateralTorsionalBottum);
                    if(lateralTorsionalBottum_obj === null) return null;

                    const dst : BucklingShapes_json = {
                        flexural1: flexural1_obj,
                        flexural2: flexural2_obj,
                        flexuralTorsional: flexuralTorsional_obj,
                        lateralTorsionalTop: lateralTorsionalTop_obj,
                        lateralTorsionalBottum: lateralTorsionalBottum_obj,
                    };
                    return dst;
                }

                static create(src?: BucklingShapes_createType) {
                    const dst = new BucklingShapes();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.flexural1 !== undefined) {
                        dst.flexural1 = src.flexural1;
                    }
                    if (src.flexural2 !== undefined) {
                        dst.flexural2 = src.flexural2;
                    }
                    if (src.flexuralTorsional !== undefined) {
                        dst.flexuralTorsional = src.flexuralTorsional;
                    }
                    if (src.lateralTorsionalTop !== undefined) {
                        dst.lateralTorsionalTop = src.lateralTorsionalTop;
                    }
                    if (src.lateralTorsionalBottum !== undefined) {
                        dst.lateralTorsionalBottum = src.lateralTorsionalBottum;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BucklingShapes();
                    dst.flexural1 = this.flexural1;
                    dst.flexural2 = this.flexural2;
                    dst.flexuralTorsional = this.flexuralTorsional;
                    dst.lateralTorsionalTop = this.lateralTorsionalTop;
                    dst.lateralTorsionalBottum = this.lateralTorsionalBottum;
                    return dst;
                }

                deepClone() {
                    const json = BucklingShapes.toObject(this);
                    const dst = BucklingShapes.fromObject(json);
                    return dst;
                }
            }
            export type IBucklingShapes = BucklingShapes;


            export type VirtualStiffeners_keys = 'start' | 'end';
            export interface VirtualStiffeners_createType {
                start?: boolean,
                end?: boolean,
            }
            export interface VirtualStiffeners_json {
                start?: boolean;
                end?: boolean;
            }
            interface VirtualStiffeners_json_in {
                __proto_name?: unknown;
                start?: unknown;
                end?: unknown;
            }
            export class VirtualStiffeners {
                __proto_name = "ng.fem_design.steel_output.VirtualStiffeners";
                start: boolean = false;
                end: boolean = false;

                static fromObject(src_unknown: unknown): VirtualStiffeners {
                    const dst = new VirtualStiffeners();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted VirtualStiffeners but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as VirtualStiffeners_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for VirtualStiffeners but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.start !== undefined && src.start !== null) {
                        if (typeof src.start === "boolean") {
                            dst.start = src.start;
                        }
                        else {
                            console.log('Expected start of VirtualStiffeners to be a boolean but was ', typeof src.start, src.start)
                        }
                    }
                    if (src.end !== undefined && src.end !== null) {
                        if (typeof src.end === "boolean") {
                            dst.end = src.end;
                        }
                        else {
                            console.log('Expected end of VirtualStiffeners to be a boolean but was ', typeof src.end, src.end)
                        }
                    }
                    return dst;
                }

                static toObject(src: VirtualStiffeners | null | undefined): VirtualStiffeners_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.VirtualStiffeners is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.VirtualStiffeners") {
                        console.error('Expected ng.fem_design.steel_output.VirtualStiffeners but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : VirtualStiffeners_json = {
                        start: src.start,
                        end: src.end,
                    };
                    return dst;
                }

                static create(src?: VirtualStiffeners_createType) {
                    const dst = new VirtualStiffeners();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.start !== undefined) {
                        dst.start = src.start;
                    }
                    if (src.end !== undefined) {
                        dst.end = src.end;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new VirtualStiffeners();
                    dst.start = this.start;
                    dst.end = this.end;
                    return dst;
                }

                deepClone() {
                    const json = VirtualStiffeners.toObject(this);
                    const dst = VirtualStiffeners.fromObject(json);
                    return dst;
                }
            }
            export type IVirtualStiffeners = VirtualStiffeners;


            export type Boolean2D_keys = 'one' | 'two';
            export interface Boolean2D_createType {
                one?: boolean,
                two?: boolean,
            }
            export interface Boolean2D_json {
                one?: boolean;
                two?: boolean;
            }
            interface Boolean2D_json_in {
                __proto_name?: unknown;
                one?: unknown;
                two?: unknown;
            }
            export class Boolean2D {
                __proto_name = "ng.fem_design.steel_output.Boolean2D";
                one: boolean = false;
                two: boolean = false;

                static fromObject(src_unknown: unknown): Boolean2D {
                    const dst = new Boolean2D();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Boolean2D but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Boolean2D_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Boolean2D but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.one !== undefined && src.one !== null) {
                        if (typeof src.one === "boolean") {
                            dst.one = src.one;
                        }
                        else {
                            console.log('Expected one of Boolean2D to be a boolean but was ', typeof src.one, src.one)
                        }
                    }
                    if (src.two !== undefined && src.two !== null) {
                        if (typeof src.two === "boolean") {
                            dst.two = src.two;
                        }
                        else {
                            console.log('Expected two of Boolean2D to be a boolean but was ', typeof src.two, src.two)
                        }
                    }
                    return dst;
                }

                static toObject(src: Boolean2D | null | undefined): Boolean2D_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.Boolean2D is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.Boolean2D") {
                        console.error('Expected ng.fem_design.steel_output.Boolean2D but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Boolean2D_json = {
                        one: src.one,
                        two: src.two,
                    };
                    return dst;
                }

                static create(src?: Boolean2D_createType) {
                    const dst = new Boolean2D();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.one !== undefined) {
                        dst.one = src.one;
                    }
                    if (src.two !== undefined) {
                        dst.two = src.two;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Boolean2D();
                    dst.one = this.one;
                    dst.two = this.two;
                    return dst;
                }

                deepClone() {
                    const json = Boolean2D.toObject(this);
                    const dst = Boolean2D.fromObject(json);
                    return dst;
                }
            }
            export type IBoolean2D = Boolean2D;


            export type TVPointW_keys = 'numberOfPoints' | 'coordinates';
            export interface TVPointW_createType {
                numberOfPoints?: number,
                coordinates?: ng.fem_design.steel_output.Vector2D[],
            }
            export interface TVPointW_json {
                numberOfPoints?: JsonNumber;
                coordinates: ng.fem_design.steel_output.Vector2D_json[];
            }
            interface TVPointW_json_in {
                __proto_name?: unknown;
                numberOfPoints?: unknown;
                coordinates?: unknown;
            }
            export class TVPointW {
                __proto_name = "ng.fem_design.steel_output.TVPointW";
                numberOfPoints: number = 0;
                coordinates: ng.fem_design.steel_output.Vector2D[] = [];

                static fromObject(src_unknown: unknown): TVPointW {
                    const dst = new TVPointW();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TVPointW but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TVPointW_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TVPointW but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.numberOfPoints !== undefined && src.numberOfPoints !== null) {
                        if (typeof src.numberOfPoints === "number" || src.numberOfPoints === 'NaN' || src.numberOfPoints === 'Infinity' || src.numberOfPoints === '-Infinity') {
                            dst.numberOfPoints = NumberToInt("ng.fem_design.steel_output.TVPointW.number_of_points", AsNum(src.numberOfPoints));
                        }
                        else {
                            console.log('Expected numberOfPoints of TVPointW to be a number but was ', typeof src.numberOfPoints, src.numberOfPoints)
                        }
                    }
                    if (src.coordinates !== undefined && src.coordinates !== null) {
                        if (Array.isArray(src.coordinates)) {
                            for (const element of src.coordinates) {
                                dst.coordinates.push(ng.fem_design.steel_output.Vector2D.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected coordinates of TVPointW to be a array but was ', typeof src.coordinates, src.coordinates)
                        }
                    }
                    return dst;
                }

                static toObject(src: TVPointW | null | undefined): TVPointW_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.TVPointW is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.TVPointW") {
                        console.error('Expected ng.fem_design.steel_output.TVPointW but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : TVPointW_json = {
                        numberOfPoints: AsJsonNum(NumberToInt("ng.fem_design.steel_output.TVPointW.number_of_points", src.numberOfPoints)),
                        coordinates: new Array<ng.fem_design.steel_output.Vector2D_json>(),
                    };
                    if (src.coordinates !== null) {
                        for (const element of src.coordinates) {
                            const parsed = ng.fem_design.steel_output.Vector2D.toObject(element);
                            if(parsed === null) return null;
                            dst.coordinates.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: TVPointW_createType) {
                    const dst = new TVPointW();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.numberOfPoints !== undefined) {
                        dst.numberOfPoints = src.numberOfPoints;
                    }
                    if (src.coordinates !== undefined) {
                        dst.coordinates = src.coordinates;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TVPointW();
                    dst.numberOfPoints = this.numberOfPoints;
                    dst.coordinates = this.coordinates;
                    return dst;
                }

                deepClone() {
                    const json = TVPointW.toObject(this);
                    const dst = TVPointW.fromObject(json);
                    return dst;
                }
            }
            export type ITVPointW = TVPointW;


            export type Vector2D_keys = 'one' | 'two';
            export interface Vector2D_createType {
                one?: number,
                two?: number,
            }
            export interface Vector2D_json {
                one?: JsonNumber;
                two?: JsonNumber;
            }
            interface Vector2D_json_in {
                __proto_name?: unknown;
                one?: unknown;
                two?: unknown;
            }
            export class Vector2D {
                __proto_name = "ng.fem_design.steel_output.Vector2D";
                one: number = 0;
                two: number = 0;

                static fromObject(src_unknown: unknown): Vector2D {
                    const dst = new Vector2D();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Vector2D but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Vector2D_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Vector2D but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.one !== undefined && src.one !== null) {
                        if (typeof src.one === "number" || src.one === 'NaN' || src.one === 'Infinity' || src.one === '-Infinity') {
                            dst.one = AsNum(src.one);
                        }
                        else {
                            console.log('Expected one of Vector2D to be a number but was ', typeof src.one, src.one)
                        }
                    }
                    if (src.two !== undefined && src.two !== null) {
                        if (typeof src.two === "number" || src.two === 'NaN' || src.two === 'Infinity' || src.two === '-Infinity') {
                            dst.two = AsNum(src.two);
                        }
                        else {
                            console.log('Expected two of Vector2D to be a number but was ', typeof src.two, src.two)
                        }
                    }
                    return dst;
                }

                static toObject(src: Vector2D | null | undefined): Vector2D_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.Vector2D is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.Vector2D") {
                        console.error('Expected ng.fem_design.steel_output.Vector2D but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Vector2D_json = {
                        one: AsJsonNum(src.one),
                        two: AsJsonNum(src.two),
                    };
                    return dst;
                }

                static create(src?: Vector2D_createType) {
                    const dst = new Vector2D();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.one !== undefined) {
                        dst.one = src.one;
                    }
                    if (src.two !== undefined) {
                        dst.two = src.two;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Vector2D();
                    dst.one = this.one;
                    dst.two = this.two;
                    return dst;
                }

                deepClone() {
                    const json = Vector2D.toObject(this);
                    const dst = Vector2D.fromObject(json);
                    return dst;
                }
            }
            export type IVector2D = Vector2D;


            export type BooleanYZ_keys = 'y' | 'z';
            export interface BooleanYZ_createType {
                y?: boolean,
                z?: boolean,
            }
            export interface BooleanYZ_json {
                y?: boolean;
                z?: boolean;
            }
            interface BooleanYZ_json_in {
                __proto_name?: unknown;
                y?: unknown;
                z?: unknown;
            }
            export class BooleanYZ {
                __proto_name = "ng.fem_design.steel_output.BooleanYZ";
                y: boolean = false;
                z: boolean = false;

                static fromObject(src_unknown: unknown): BooleanYZ {
                    const dst = new BooleanYZ();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BooleanYZ but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BooleanYZ_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BooleanYZ but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.y !== undefined && src.y !== null) {
                        if (typeof src.y === "boolean") {
                            dst.y = src.y;
                        }
                        else {
                            console.log('Expected y of BooleanYZ to be a boolean but was ', typeof src.y, src.y)
                        }
                    }
                    if (src.z !== undefined && src.z !== null) {
                        if (typeof src.z === "boolean") {
                            dst.z = src.z;
                        }
                        else {
                            console.log('Expected z of BooleanYZ to be a boolean but was ', typeof src.z, src.z)
                        }
                    }
                    return dst;
                }

                static toObject(src: BooleanYZ | null | undefined): BooleanYZ_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.BooleanYZ is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.BooleanYZ") {
                        console.error('Expected ng.fem_design.steel_output.BooleanYZ but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BooleanYZ_json = {
                        y: src.y,
                        z: src.z,
                    };
                    return dst;
                }

                static create(src?: BooleanYZ_createType) {
                    const dst = new BooleanYZ();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.y !== undefined) {
                        dst.y = src.y;
                    }
                    if (src.z !== undefined) {
                        dst.z = src.z;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BooleanYZ();
                    dst.y = this.y;
                    dst.z = this.z;
                    return dst;
                }

                deepClone() {
                    const json = BooleanYZ.toObject(this);
                    const dst = BooleanYZ.fromObject(json);
                    return dst;
                }
            }
            export type IBooleanYZ = BooleanYZ;


            export type Vector4D_keys = 'one' | 'two' | 'three' | 'four';
            export interface Vector4D_createType {
                one?: number,
                two?: number,
                three?: number,
                four?: number,
            }
            export interface Vector4D_json {
                one?: JsonNumber;
                two?: JsonNumber;
                three?: JsonNumber;
                four?: JsonNumber;
            }
            interface Vector4D_json_in {
                __proto_name?: unknown;
                one?: unknown;
                two?: unknown;
                three?: unknown;
                four?: unknown;
            }
            export class Vector4D {
                __proto_name = "ng.fem_design.steel_output.Vector4D";
                one: number = 0;
                two: number = 0;
                three: number = 0;
                four: number = 0;

                static fromObject(src_unknown: unknown): Vector4D {
                    const dst = new Vector4D();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Vector4D but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Vector4D_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Vector4D but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.one !== undefined && src.one !== null) {
                        if (typeof src.one === "number" || src.one === 'NaN' || src.one === 'Infinity' || src.one === '-Infinity') {
                            dst.one = AsNum(src.one);
                        }
                        else {
                            console.log('Expected one of Vector4D to be a number but was ', typeof src.one, src.one)
                        }
                    }
                    if (src.two !== undefined && src.two !== null) {
                        if (typeof src.two === "number" || src.two === 'NaN' || src.two === 'Infinity' || src.two === '-Infinity') {
                            dst.two = AsNum(src.two);
                        }
                        else {
                            console.log('Expected two of Vector4D to be a number but was ', typeof src.two, src.two)
                        }
                    }
                    if (src.three !== undefined && src.three !== null) {
                        if (typeof src.three === "number" || src.three === 'NaN' || src.three === 'Infinity' || src.three === '-Infinity') {
                            dst.three = AsNum(src.three);
                        }
                        else {
                            console.log('Expected three of Vector4D to be a number but was ', typeof src.three, src.three)
                        }
                    }
                    if (src.four !== undefined && src.four !== null) {
                        if (typeof src.four === "number" || src.four === 'NaN' || src.four === 'Infinity' || src.four === '-Infinity') {
                            dst.four = AsNum(src.four);
                        }
                        else {
                            console.log('Expected four of Vector4D to be a number but was ', typeof src.four, src.four)
                        }
                    }
                    return dst;
                }

                static toObject(src: Vector4D | null | undefined): Vector4D_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.Vector4D is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.Vector4D") {
                        console.error('Expected ng.fem_design.steel_output.Vector4D but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Vector4D_json = {
                        one: AsJsonNum(src.one),
                        two: AsJsonNum(src.two),
                        three: AsJsonNum(src.three),
                        four: AsJsonNum(src.four),
                    };
                    return dst;
                }

                static create(src?: Vector4D_createType) {
                    const dst = new Vector4D();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.one !== undefined) {
                        dst.one = src.one;
                    }
                    if (src.two !== undefined) {
                        dst.two = src.two;
                    }
                    if (src.three !== undefined) {
                        dst.three = src.three;
                    }
                    if (src.four !== undefined) {
                        dst.four = src.four;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Vector4D();
                    dst.one = this.one;
                    dst.two = this.two;
                    dst.three = this.three;
                    dst.four = this.four;
                    return dst;
                }

                deepClone() {
                    const json = Vector4D.toObject(this);
                    const dst = Vector4D.fromObject(json);
                    return dst;
                }
            }
            export type IVector4D = Vector4D;


            export type CrossSectionDataRecord_keys = 'rBeta' | 'rP' | 'rA' | 'rIyz' | 'ri12' | 'rIt' | 'rIw' | 'rI' | 'ry0' | 'rz0' | 'rWPl' | 'rW1El' | 'rW2El' | 'lfc' | 'lft' | 'hs' | 'ay' | 'az' | 'hw' | 'tw';
            export interface CrossSectionDataRecord_createType {
                rBeta?: number,
                rP?: number,
                rA?: number,
                rIyz?: ng.fem_design.steel_output.Vector2D | null,
                ri12?: ng.fem_design.steel_output.Vector2D | null,
                rIt?: number,
                rIw?: number,
                rI?: ng.fem_design.steel_output.Vector2D | null,
                ry0?: number,
                rz0?: number,
                rWPl?: ng.fem_design.steel_output.Vector2D | null,
                rW1El?: ng.fem_design.steel_output.Vector2D | null,
                rW2El?: ng.fem_design.steel_output.Vector2D | null,
                lfc?: number,
                lft?: number,
                hs?: number,
                ay?: number,
                az?: number,
                hw?: number,
                tw?: number,
            }
            export interface CrossSectionDataRecord_json {
                rBeta?: JsonNumber;
                rP?: JsonNumber;
                rA?: JsonNumber;
                rIyz?: ng.fem_design.steel_output.Vector2D_json;
                ri12?: ng.fem_design.steel_output.Vector2D_json;
                rIt?: JsonNumber;
                rIw?: JsonNumber;
                rI?: ng.fem_design.steel_output.Vector2D_json;
                ry0?: JsonNumber;
                rz0?: JsonNumber;
                rWPl?: ng.fem_design.steel_output.Vector2D_json;
                rW1El?: ng.fem_design.steel_output.Vector2D_json;
                rW2El?: ng.fem_design.steel_output.Vector2D_json;
                lfc?: JsonNumber;
                lft?: JsonNumber;
                hs?: JsonNumber;
                ay?: JsonNumber;
                az?: JsonNumber;
                hw?: JsonNumber;
                tw?: JsonNumber;
            }
            interface CrossSectionDataRecord_json_in {
                __proto_name?: unknown;
                rBeta?: unknown;
                rP?: unknown;
                rA?: unknown;
                rIyz?: unknown;
                ri12?: unknown;
                rIt?: unknown;
                rIw?: unknown;
                rI?: unknown;
                ry0?: unknown;
                rz0?: unknown;
                rWPl?: unknown;
                rW1El?: unknown;
                rW2El?: unknown;
                lfc?: unknown;
                lft?: unknown;
                hs?: unknown;
                ay?: unknown;
                az?: unknown;
                hw?: unknown;
                tw?: unknown;
            }
            export class CrossSectionDataRecord {
                __proto_name = "ng.fem_design.steel_output.CrossSectionDataRecord";
                rBeta: number = 0;
                rP: number = 0;
                rA: number = 0;
                rIyz: ng.fem_design.steel_output.Vector2D | null = null;
                ri12: ng.fem_design.steel_output.Vector2D | null = null;
                rIt: number = 0;
                rIw: number = 0;
                rI: ng.fem_design.steel_output.Vector2D | null = null;
                ry0: number = 0;
                rz0: number = 0;
                rWPl: ng.fem_design.steel_output.Vector2D | null = null;
                rW1El: ng.fem_design.steel_output.Vector2D | null = null;
                rW2El: ng.fem_design.steel_output.Vector2D | null = null;
                lfc: number = 0;
                lft: number = 0;
                hs: number = 0;
                ay: number = 0;
                az: number = 0;
                hw: number = 0;
                tw: number = 0;

                static fromObject(src_unknown: unknown): CrossSectionDataRecord {
                    const dst = new CrossSectionDataRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CrossSectionDataRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CrossSectionDataRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CrossSectionDataRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rBeta !== undefined && src.rBeta !== null) {
                        if (typeof src.rBeta === "number" || src.rBeta === 'NaN' || src.rBeta === 'Infinity' || src.rBeta === '-Infinity') {
                            dst.rBeta = AsNum(src.rBeta);
                        }
                        else {
                            console.log('Expected rBeta of CrossSectionDataRecord to be a number but was ', typeof src.rBeta, src.rBeta)
                        }
                    }
                    if (src.rP !== undefined && src.rP !== null) {
                        if (typeof src.rP === "number" || src.rP === 'NaN' || src.rP === 'Infinity' || src.rP === '-Infinity') {
                            dst.rP = AsNum(src.rP);
                        }
                        else {
                            console.log('Expected rP of CrossSectionDataRecord to be a number but was ', typeof src.rP, src.rP)
                        }
                    }
                    if (src.rA !== undefined && src.rA !== null) {
                        if (typeof src.rA === "number" || src.rA === 'NaN' || src.rA === 'Infinity' || src.rA === '-Infinity') {
                            dst.rA = AsNum(src.rA);
                        }
                        else {
                            console.log('Expected rA of CrossSectionDataRecord to be a number but was ', typeof src.rA, src.rA)
                        }
                    }
                    if (src.rIyz !== undefined && src.rIyz !== null) {
                        dst.rIyz = ng.fem_design.steel_output.Vector2D.fromObject(src.rIyz);
                    }
                    if (src.ri12 !== undefined && src.ri12 !== null) {
                        dst.ri12 = ng.fem_design.steel_output.Vector2D.fromObject(src.ri12);
                    }
                    if (src.rIt !== undefined && src.rIt !== null) {
                        if (typeof src.rIt === "number" || src.rIt === 'NaN' || src.rIt === 'Infinity' || src.rIt === '-Infinity') {
                            dst.rIt = AsNum(src.rIt);
                        }
                        else {
                            console.log('Expected rIt of CrossSectionDataRecord to be a number but was ', typeof src.rIt, src.rIt)
                        }
                    }
                    if (src.rIw !== undefined && src.rIw !== null) {
                        if (typeof src.rIw === "number" || src.rIw === 'NaN' || src.rIw === 'Infinity' || src.rIw === '-Infinity') {
                            dst.rIw = AsNum(src.rIw);
                        }
                        else {
                            console.log('Expected rIw of CrossSectionDataRecord to be a number but was ', typeof src.rIw, src.rIw)
                        }
                    }
                    if (src.rI !== undefined && src.rI !== null) {
                        dst.rI = ng.fem_design.steel_output.Vector2D.fromObject(src.rI);
                    }
                    if (src.ry0 !== undefined && src.ry0 !== null) {
                        if (typeof src.ry0 === "number" || src.ry0 === 'NaN' || src.ry0 === 'Infinity' || src.ry0 === '-Infinity') {
                            dst.ry0 = AsNum(src.ry0);
                        }
                        else {
                            console.log('Expected ry0 of CrossSectionDataRecord to be a number but was ', typeof src.ry0, src.ry0)
                        }
                    }
                    if (src.rz0 !== undefined && src.rz0 !== null) {
                        if (typeof src.rz0 === "number" || src.rz0 === 'NaN' || src.rz0 === 'Infinity' || src.rz0 === '-Infinity') {
                            dst.rz0 = AsNum(src.rz0);
                        }
                        else {
                            console.log('Expected rz0 of CrossSectionDataRecord to be a number but was ', typeof src.rz0, src.rz0)
                        }
                    }
                    if (src.rWPl !== undefined && src.rWPl !== null) {
                        dst.rWPl = ng.fem_design.steel_output.Vector2D.fromObject(src.rWPl);
                    }
                    if (src.rW1El !== undefined && src.rW1El !== null) {
                        dst.rW1El = ng.fem_design.steel_output.Vector2D.fromObject(src.rW1El);
                    }
                    if (src.rW2El !== undefined && src.rW2El !== null) {
                        dst.rW2El = ng.fem_design.steel_output.Vector2D.fromObject(src.rW2El);
                    }
                    if (src.lfc !== undefined && src.lfc !== null) {
                        if (typeof src.lfc === "number" || src.lfc === 'NaN' || src.lfc === 'Infinity' || src.lfc === '-Infinity') {
                            dst.lfc = AsNum(src.lfc);
                        }
                        else {
                            console.log('Expected lfc of CrossSectionDataRecord to be a number but was ', typeof src.lfc, src.lfc)
                        }
                    }
                    if (src.lft !== undefined && src.lft !== null) {
                        if (typeof src.lft === "number" || src.lft === 'NaN' || src.lft === 'Infinity' || src.lft === '-Infinity') {
                            dst.lft = AsNum(src.lft);
                        }
                        else {
                            console.log('Expected lft of CrossSectionDataRecord to be a number but was ', typeof src.lft, src.lft)
                        }
                    }
                    if (src.hs !== undefined && src.hs !== null) {
                        if (typeof src.hs === "number" || src.hs === 'NaN' || src.hs === 'Infinity' || src.hs === '-Infinity') {
                            dst.hs = AsNum(src.hs);
                        }
                        else {
                            console.log('Expected hs of CrossSectionDataRecord to be a number but was ', typeof src.hs, src.hs)
                        }
                    }
                    if (src.ay !== undefined && src.ay !== null) {
                        if (typeof src.ay === "number" || src.ay === 'NaN' || src.ay === 'Infinity' || src.ay === '-Infinity') {
                            dst.ay = AsNum(src.ay);
                        }
                        else {
                            console.log('Expected ay of CrossSectionDataRecord to be a number but was ', typeof src.ay, src.ay)
                        }
                    }
                    if (src.az !== undefined && src.az !== null) {
                        if (typeof src.az === "number" || src.az === 'NaN' || src.az === 'Infinity' || src.az === '-Infinity') {
                            dst.az = AsNum(src.az);
                        }
                        else {
                            console.log('Expected az of CrossSectionDataRecord to be a number but was ', typeof src.az, src.az)
                        }
                    }
                    if (src.hw !== undefined && src.hw !== null) {
                        if (typeof src.hw === "number" || src.hw === 'NaN' || src.hw === 'Infinity' || src.hw === '-Infinity') {
                            dst.hw = AsNum(src.hw);
                        }
                        else {
                            console.log('Expected hw of CrossSectionDataRecord to be a number but was ', typeof src.hw, src.hw)
                        }
                    }
                    if (src.tw !== undefined && src.tw !== null) {
                        if (typeof src.tw === "number" || src.tw === 'NaN' || src.tw === 'Infinity' || src.tw === '-Infinity') {
                            dst.tw = AsNum(src.tw);
                        }
                        else {
                            console.log('Expected tw of CrossSectionDataRecord to be a number but was ', typeof src.tw, src.tw)
                        }
                    }
                    return dst;
                }

                static toObject(src: CrossSectionDataRecord | null | undefined): CrossSectionDataRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.CrossSectionDataRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.CrossSectionDataRecord") {
                        console.error('Expected ng.fem_design.steel_output.CrossSectionDataRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CrossSectionDataRecord_json = {
                        rBeta: AsJsonNum(src.rBeta),
                        rP: AsJsonNum(src.rP),
                        rA: AsJsonNum(src.rA),
                        rIt: AsJsonNum(src.rIt),
                        rIw: AsJsonNum(src.rIw),
                        ry0: AsJsonNum(src.ry0),
                        rz0: AsJsonNum(src.rz0),
                        lfc: AsJsonNum(src.lfc),
                        lft: AsJsonNum(src.lft),
                        hs: AsJsonNum(src.hs),
                        ay: AsJsonNum(src.ay),
                        az: AsJsonNum(src.az),
                        hw: AsJsonNum(src.hw),
                        tw: AsJsonNum(src.tw),
                    };
                    if(src.rIyz !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rIyz);
                        if(parsed === null) return null;
                        dst.rIyz = parsed;
                    }
                    if(src.ri12 !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.ri12);
                        if(parsed === null) return null;
                        dst.ri12 = parsed;
                    }
                    if(src.rI !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rI);
                        if(parsed === null) return null;
                        dst.rI = parsed;
                    }
                    if(src.rWPl !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rWPl);
                        if(parsed === null) return null;
                        dst.rWPl = parsed;
                    }
                    if(src.rW1El !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rW1El);
                        if(parsed === null) return null;
                        dst.rW1El = parsed;
                    }
                    if(src.rW2El !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rW2El);
                        if(parsed === null) return null;
                        dst.rW2El = parsed;
                    }
                    return dst;
                }

                static create(src?: CrossSectionDataRecord_createType) {
                    const dst = new CrossSectionDataRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rBeta !== undefined) {
                        dst.rBeta = src.rBeta;
                    }
                    if (src.rP !== undefined) {
                        dst.rP = src.rP;
                    }
                    if (src.rA !== undefined) {
                        dst.rA = src.rA;
                    }
                    if (src.rIyz !== undefined) {
                        dst.rIyz = src.rIyz;
                    }
                    if (src.ri12 !== undefined) {
                        dst.ri12 = src.ri12;
                    }
                    if (src.rIt !== undefined) {
                        dst.rIt = src.rIt;
                    }
                    if (src.rIw !== undefined) {
                        dst.rIw = src.rIw;
                    }
                    if (src.rI !== undefined) {
                        dst.rI = src.rI;
                    }
                    if (src.ry0 !== undefined) {
                        dst.ry0 = src.ry0;
                    }
                    if (src.rz0 !== undefined) {
                        dst.rz0 = src.rz0;
                    }
                    if (src.rWPl !== undefined) {
                        dst.rWPl = src.rWPl;
                    }
                    if (src.rW1El !== undefined) {
                        dst.rW1El = src.rW1El;
                    }
                    if (src.rW2El !== undefined) {
                        dst.rW2El = src.rW2El;
                    }
                    if (src.lfc !== undefined) {
                        dst.lfc = src.lfc;
                    }
                    if (src.lft !== undefined) {
                        dst.lft = src.lft;
                    }
                    if (src.hs !== undefined) {
                        dst.hs = src.hs;
                    }
                    if (src.ay !== undefined) {
                        dst.ay = src.ay;
                    }
                    if (src.az !== undefined) {
                        dst.az = src.az;
                    }
                    if (src.hw !== undefined) {
                        dst.hw = src.hw;
                    }
                    if (src.tw !== undefined) {
                        dst.tw = src.tw;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CrossSectionDataRecord();
                    dst.rBeta = this.rBeta;
                    dst.rP = this.rP;
                    dst.rA = this.rA;
                    dst.rIyz = this.rIyz;
                    dst.ri12 = this.ri12;
                    dst.rIt = this.rIt;
                    dst.rIw = this.rIw;
                    dst.rI = this.rI;
                    dst.ry0 = this.ry0;
                    dst.rz0 = this.rz0;
                    dst.rWPl = this.rWPl;
                    dst.rW1El = this.rW1El;
                    dst.rW2El = this.rW2El;
                    dst.lfc = this.lfc;
                    dst.lft = this.lft;
                    dst.hs = this.hs;
                    dst.ay = this.ay;
                    dst.az = this.az;
                    dst.hw = this.hw;
                    dst.tw = this.tw;
                    return dst;
                }

                deepClone() {
                    const json = CrossSectionDataRecord.toObject(this);
                    const dst = CrossSectionDataRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICrossSectionDataRecord = CrossSectionDataRecord;


            export type MaterialDataRecord_keys = 'rfY' | 'repsilon' | 'rLambda1' | 'rE' | 'rG' | 'rGammaM0' | 'rGammaM1' | 'rGammaM2' | 'rGammaFi' | 'kyTheta' | 'kp02Theta' | 'kpTheta' | 'kETheta';
            export interface MaterialDataRecord_createType {
                rfY?: number,
                repsilon?: number,
                rLambda1?: number,
                rE?: number,
                rG?: number,
                rGammaM0?: number,
                rGammaM1?: number,
                rGammaM2?: number,
                rGammaFi?: number,
                kyTheta?: number,
                kp02Theta?: number,
                kpTheta?: number,
                kETheta?: number,
            }
            export interface MaterialDataRecord_json {
                rfY?: JsonNumber;
                repsilon?: JsonNumber;
                rLambda1?: JsonNumber;
                rE?: JsonNumber;
                rG?: JsonNumber;
                rGammaM0?: JsonNumber;
                rGammaM1?: JsonNumber;
                rGammaM2?: JsonNumber;
                rGammaFi?: JsonNumber;
                kyTheta?: JsonNumber;
                kp02Theta?: JsonNumber;
                kpTheta?: JsonNumber;
                kETheta?: JsonNumber;
            }
            interface MaterialDataRecord_json_in {
                __proto_name?: unknown;
                rfY?: unknown;
                repsilon?: unknown;
                rLambda1?: unknown;
                rE?: unknown;
                rG?: unknown;
                rGammaM0?: unknown;
                rGammaM1?: unknown;
                rGammaM2?: unknown;
                rGammaFi?: unknown;
                kyTheta?: unknown;
                kp02Theta?: unknown;
                kpTheta?: unknown;
                kETheta?: unknown;
            }
            export class MaterialDataRecord {
                __proto_name = "ng.fem_design.steel_output.MaterialDataRecord";
                rfY: number = 0;
                repsilon: number = 0;
                rLambda1: number = 0;
                rE: number = 0;
                rG: number = 0;
                rGammaM0: number = 0;
                rGammaM1: number = 0;
                rGammaM2: number = 0;
                rGammaFi: number = 0;
                kyTheta: number = 0;
                kp02Theta: number = 0;
                kpTheta: number = 0;
                kETheta: number = 0;

                static fromObject(src_unknown: unknown): MaterialDataRecord {
                    const dst = new MaterialDataRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MaterialDataRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MaterialDataRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MaterialDataRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rfY !== undefined && src.rfY !== null) {
                        if (typeof src.rfY === "number" || src.rfY === 'NaN' || src.rfY === 'Infinity' || src.rfY === '-Infinity') {
                            dst.rfY = AsNum(src.rfY);
                        }
                        else {
                            console.log('Expected rfY of MaterialDataRecord to be a number but was ', typeof src.rfY, src.rfY)
                        }
                    }
                    if (src.repsilon !== undefined && src.repsilon !== null) {
                        if (typeof src.repsilon === "number" || src.repsilon === 'NaN' || src.repsilon === 'Infinity' || src.repsilon === '-Infinity') {
                            dst.repsilon = AsNum(src.repsilon);
                        }
                        else {
                            console.log('Expected repsilon of MaterialDataRecord to be a number but was ', typeof src.repsilon, src.repsilon)
                        }
                    }
                    if (src.rLambda1 !== undefined && src.rLambda1 !== null) {
                        if (typeof src.rLambda1 === "number" || src.rLambda1 === 'NaN' || src.rLambda1 === 'Infinity' || src.rLambda1 === '-Infinity') {
                            dst.rLambda1 = AsNum(src.rLambda1);
                        }
                        else {
                            console.log('Expected rLambda1 of MaterialDataRecord to be a number but was ', typeof src.rLambda1, src.rLambda1)
                        }
                    }
                    if (src.rE !== undefined && src.rE !== null) {
                        if (typeof src.rE === "number" || src.rE === 'NaN' || src.rE === 'Infinity' || src.rE === '-Infinity') {
                            dst.rE = AsNum(src.rE);
                        }
                        else {
                            console.log('Expected rE of MaterialDataRecord to be a number but was ', typeof src.rE, src.rE)
                        }
                    }
                    if (src.rG !== undefined && src.rG !== null) {
                        if (typeof src.rG === "number" || src.rG === 'NaN' || src.rG === 'Infinity' || src.rG === '-Infinity') {
                            dst.rG = AsNum(src.rG);
                        }
                        else {
                            console.log('Expected rG of MaterialDataRecord to be a number but was ', typeof src.rG, src.rG)
                        }
                    }
                    if (src.rGammaM0 !== undefined && src.rGammaM0 !== null) {
                        if (typeof src.rGammaM0 === "number" || src.rGammaM0 === 'NaN' || src.rGammaM0 === 'Infinity' || src.rGammaM0 === '-Infinity') {
                            dst.rGammaM0 = AsNum(src.rGammaM0);
                        }
                        else {
                            console.log('Expected rGammaM0 of MaterialDataRecord to be a number but was ', typeof src.rGammaM0, src.rGammaM0)
                        }
                    }
                    if (src.rGammaM1 !== undefined && src.rGammaM1 !== null) {
                        if (typeof src.rGammaM1 === "number" || src.rGammaM1 === 'NaN' || src.rGammaM1 === 'Infinity' || src.rGammaM1 === '-Infinity') {
                            dst.rGammaM1 = AsNum(src.rGammaM1);
                        }
                        else {
                            console.log('Expected rGammaM1 of MaterialDataRecord to be a number but was ', typeof src.rGammaM1, src.rGammaM1)
                        }
                    }
                    if (src.rGammaM2 !== undefined && src.rGammaM2 !== null) {
                        if (typeof src.rGammaM2 === "number" || src.rGammaM2 === 'NaN' || src.rGammaM2 === 'Infinity' || src.rGammaM2 === '-Infinity') {
                            dst.rGammaM2 = AsNum(src.rGammaM2);
                        }
                        else {
                            console.log('Expected rGammaM2 of MaterialDataRecord to be a number but was ', typeof src.rGammaM2, src.rGammaM2)
                        }
                    }
                    if (src.rGammaFi !== undefined && src.rGammaFi !== null) {
                        if (typeof src.rGammaFi === "number" || src.rGammaFi === 'NaN' || src.rGammaFi === 'Infinity' || src.rGammaFi === '-Infinity') {
                            dst.rGammaFi = AsNum(src.rGammaFi);
                        }
                        else {
                            console.log('Expected rGammaFi of MaterialDataRecord to be a number but was ', typeof src.rGammaFi, src.rGammaFi)
                        }
                    }
                    if (src.kyTheta !== undefined && src.kyTheta !== null) {
                        if (typeof src.kyTheta === "number" || src.kyTheta === 'NaN' || src.kyTheta === 'Infinity' || src.kyTheta === '-Infinity') {
                            dst.kyTheta = AsNum(src.kyTheta);
                        }
                        else {
                            console.log('Expected kyTheta of MaterialDataRecord to be a number but was ', typeof src.kyTheta, src.kyTheta)
                        }
                    }
                    if (src.kp02Theta !== undefined && src.kp02Theta !== null) {
                        if (typeof src.kp02Theta === "number" || src.kp02Theta === 'NaN' || src.kp02Theta === 'Infinity' || src.kp02Theta === '-Infinity') {
                            dst.kp02Theta = AsNum(src.kp02Theta);
                        }
                        else {
                            console.log('Expected kp02Theta of MaterialDataRecord to be a number but was ', typeof src.kp02Theta, src.kp02Theta)
                        }
                    }
                    if (src.kpTheta !== undefined && src.kpTheta !== null) {
                        if (typeof src.kpTheta === "number" || src.kpTheta === 'NaN' || src.kpTheta === 'Infinity' || src.kpTheta === '-Infinity') {
                            dst.kpTheta = AsNum(src.kpTheta);
                        }
                        else {
                            console.log('Expected kpTheta of MaterialDataRecord to be a number but was ', typeof src.kpTheta, src.kpTheta)
                        }
                    }
                    if (src.kETheta !== undefined && src.kETheta !== null) {
                        if (typeof src.kETheta === "number" || src.kETheta === 'NaN' || src.kETheta === 'Infinity' || src.kETheta === '-Infinity') {
                            dst.kETheta = AsNum(src.kETheta);
                        }
                        else {
                            console.log('Expected kETheta of MaterialDataRecord to be a number but was ', typeof src.kETheta, src.kETheta)
                        }
                    }
                    return dst;
                }

                static toObject(src: MaterialDataRecord | null | undefined): MaterialDataRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.MaterialDataRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.MaterialDataRecord") {
                        console.error('Expected ng.fem_design.steel_output.MaterialDataRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MaterialDataRecord_json = {
                        rfY: AsJsonNum(src.rfY),
                        repsilon: AsJsonNum(src.repsilon),
                        rLambda1: AsJsonNum(src.rLambda1),
                        rE: AsJsonNum(src.rE),
                        rG: AsJsonNum(src.rG),
                        rGammaM0: AsJsonNum(src.rGammaM0),
                        rGammaM1: AsJsonNum(src.rGammaM1),
                        rGammaM2: AsJsonNum(src.rGammaM2),
                        rGammaFi: AsJsonNum(src.rGammaFi),
                        kyTheta: AsJsonNum(src.kyTheta),
                        kp02Theta: AsJsonNum(src.kp02Theta),
                        kpTheta: AsJsonNum(src.kpTheta),
                        kETheta: AsJsonNum(src.kETheta),
                    };
                    return dst;
                }

                static create(src?: MaterialDataRecord_createType) {
                    const dst = new MaterialDataRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rfY !== undefined) {
                        dst.rfY = src.rfY;
                    }
                    if (src.repsilon !== undefined) {
                        dst.repsilon = src.repsilon;
                    }
                    if (src.rLambda1 !== undefined) {
                        dst.rLambda1 = src.rLambda1;
                    }
                    if (src.rE !== undefined) {
                        dst.rE = src.rE;
                    }
                    if (src.rG !== undefined) {
                        dst.rG = src.rG;
                    }
                    if (src.rGammaM0 !== undefined) {
                        dst.rGammaM0 = src.rGammaM0;
                    }
                    if (src.rGammaM1 !== undefined) {
                        dst.rGammaM1 = src.rGammaM1;
                    }
                    if (src.rGammaM2 !== undefined) {
                        dst.rGammaM2 = src.rGammaM2;
                    }
                    if (src.rGammaFi !== undefined) {
                        dst.rGammaFi = src.rGammaFi;
                    }
                    if (src.kyTheta !== undefined) {
                        dst.kyTheta = src.kyTheta;
                    }
                    if (src.kp02Theta !== undefined) {
                        dst.kp02Theta = src.kp02Theta;
                    }
                    if (src.kpTheta !== undefined) {
                        dst.kpTheta = src.kpTheta;
                    }
                    if (src.kETheta !== undefined) {
                        dst.kETheta = src.kETheta;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MaterialDataRecord();
                    dst.rfY = this.rfY;
                    dst.repsilon = this.repsilon;
                    dst.rLambda1 = this.rLambda1;
                    dst.rE = this.rE;
                    dst.rG = this.rG;
                    dst.rGammaM0 = this.rGammaM0;
                    dst.rGammaM1 = this.rGammaM1;
                    dst.rGammaM2 = this.rGammaM2;
                    dst.rGammaFi = this.rGammaFi;
                    dst.kyTheta = this.kyTheta;
                    dst.kp02Theta = this.kp02Theta;
                    dst.kpTheta = this.kpTheta;
                    dst.kETheta = this.kETheta;
                    return dst;
                }

                deepClone() {
                    const json = MaterialDataRecord.toObject(this);
                    const dst = MaterialDataRecord.fromObject(json);
                    return dst;
                }
            }
            export type IMaterialDataRecord = MaterialDataRecord;


            export type GasTemperature_keys = 'temperatureCurve' | 'parametric' | 'vGraphGasTemp' | 'treq' | 'tempGas' | 'sectionExposion';
            export interface GasTemperature_createType {
                temperatureCurve?: number,
                parametric?: ng.fem_design.steel_output.Parametric | null,
                vGraphGasTemp?: ng.fem_design.steel_output.TVPointW | null,
                treq?: number,
                tempGas?: number,
                sectionExposion?: number,
            }
            export interface GasTemperature_json {
                temperatureCurve?: JsonNumber;
                parametric?: ng.fem_design.steel_output.Parametric_json;
                vGraphGasTemp?: ng.fem_design.steel_output.TVPointW_json;
                treq?: JsonNumber;
                tempGas?: JsonNumber;
                sectionExposion?: JsonNumber;
            }
            interface GasTemperature_json_in {
                __proto_name?: unknown;
                temperatureCurve?: unknown;
                parametric?: unknown;
                vGraphGasTemp?: unknown;
                treq?: unknown;
                tempGas?: unknown;
                sectionExposion?: unknown;
            }
            export class GasTemperature {
                __proto_name = "ng.fem_design.steel_output.GasTemperature";
                temperatureCurve: number = 0;
                parametric: ng.fem_design.steel_output.Parametric | null = null;
                vGraphGasTemp: ng.fem_design.steel_output.TVPointW | null = null;
                treq: number = 0;
                tempGas: number = 0;
                sectionExposion: number = 0;

                static fromObject(src_unknown: unknown): GasTemperature {
                    const dst = new GasTemperature();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GasTemperature but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GasTemperature_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GasTemperature but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.temperatureCurve !== undefined && src.temperatureCurve !== null) {
                        if (typeof src.temperatureCurve === "number" || src.temperatureCurve === 'NaN' || src.temperatureCurve === 'Infinity' || src.temperatureCurve === '-Infinity') {
                            dst.temperatureCurve = NumberToInt("ng.fem_design.steel_output.GasTemperature.temperature_curve", AsNum(src.temperatureCurve));
                        }
                        else {
                            console.log('Expected temperatureCurve of GasTemperature to be a number but was ', typeof src.temperatureCurve, src.temperatureCurve)
                        }
                    }
                    if (src.parametric !== undefined && src.parametric !== null) {
                        dst.parametric = ng.fem_design.steel_output.Parametric.fromObject(src.parametric);
                    }
                    if (src.vGraphGasTemp !== undefined && src.vGraphGasTemp !== null) {
                        dst.vGraphGasTemp = ng.fem_design.steel_output.TVPointW.fromObject(src.vGraphGasTemp);
                    }
                    if (src.treq !== undefined && src.treq !== null) {
                        if (typeof src.treq === "number" || src.treq === 'NaN' || src.treq === 'Infinity' || src.treq === '-Infinity') {
                            dst.treq = AsNum(src.treq);
                        }
                        else {
                            console.log('Expected treq of GasTemperature to be a number but was ', typeof src.treq, src.treq)
                        }
                    }
                    if (src.tempGas !== undefined && src.tempGas !== null) {
                        if (typeof src.tempGas === "number" || src.tempGas === 'NaN' || src.tempGas === 'Infinity' || src.tempGas === '-Infinity') {
                            dst.tempGas = AsNum(src.tempGas);
                        }
                        else {
                            console.log('Expected tempGas of GasTemperature to be a number but was ', typeof src.tempGas, src.tempGas)
                        }
                    }
                    if (src.sectionExposion !== undefined && src.sectionExposion !== null) {
                        if (typeof src.sectionExposion === "number" || src.sectionExposion === 'NaN' || src.sectionExposion === 'Infinity' || src.sectionExposion === '-Infinity') {
                            dst.sectionExposion = NumberToInt("ng.fem_design.steel_output.GasTemperature.section_exposion", AsNum(src.sectionExposion));
                        }
                        else {
                            console.log('Expected sectionExposion of GasTemperature to be a number but was ', typeof src.sectionExposion, src.sectionExposion)
                        }
                    }
                    return dst;
                }

                static toObject(src: GasTemperature | null | undefined): GasTemperature_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.GasTemperature is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.GasTemperature") {
                        console.error('Expected ng.fem_design.steel_output.GasTemperature but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GasTemperature_json = {
                        temperatureCurve: AsJsonNum(NumberToInt("ng.fem_design.steel_output.GasTemperature.temperature_curve", src.temperatureCurve)),
                        treq: AsJsonNum(src.treq),
                        tempGas: AsJsonNum(src.tempGas),
                        sectionExposion: AsJsonNum(NumberToInt("ng.fem_design.steel_output.GasTemperature.section_exposion", src.sectionExposion)),
                    };
                    if(src.parametric !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Parametric.toObject(src.parametric);
                        if(parsed === null) return null;
                        dst.parametric = parsed;
                    }
                    if(src.vGraphGasTemp !== null)
                    {
                        const parsed = ng.fem_design.steel_output.TVPointW.toObject(src.vGraphGasTemp);
                        if(parsed === null) return null;
                        dst.vGraphGasTemp = parsed;
                    }
                    return dst;
                }

                static create(src?: GasTemperature_createType) {
                    const dst = new GasTemperature();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.temperatureCurve !== undefined) {
                        dst.temperatureCurve = src.temperatureCurve;
                    }
                    if (src.parametric !== undefined) {
                        dst.parametric = src.parametric;
                    }
                    if (src.vGraphGasTemp !== undefined) {
                        dst.vGraphGasTemp = src.vGraphGasTemp;
                    }
                    if (src.treq !== undefined) {
                        dst.treq = src.treq;
                    }
                    if (src.tempGas !== undefined) {
                        dst.tempGas = src.tempGas;
                    }
                    if (src.sectionExposion !== undefined) {
                        dst.sectionExposion = src.sectionExposion;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GasTemperature();
                    dst.temperatureCurve = this.temperatureCurve;
                    dst.parametric = this.parametric;
                    dst.vGraphGasTemp = this.vGraphGasTemp;
                    dst.treq = this.treq;
                    dst.tempGas = this.tempGas;
                    dst.sectionExposion = this.sectionExposion;
                    return dst;
                }

                deepClone() {
                    const json = GasTemperature.toObject(this);
                    const dst = GasTemperature.fromObject(json);
                    return dst;
                }
            }
            export type IGasTemperature = GasTemperature;


            export type Parametric_keys = 'parametricO' | 'parametricB' | 'parametricQtd' | 'parametricTlim' | 'parametricGamma' | 'parametricTmaxA7' | 'parametricFuelControlled' | 'parametricTmaxAsterisk' | 'parametricThetaMax' | 'parametricOlim' | 'parametricGammaLim' | 'parametricK' | 'parametricTxmaxA12' | 'parametricX';
            export interface Parametric_createType {
                parametricO?: number,
                parametricB?: number,
                parametricQtd?: number,
                parametricTlim?: number,
                parametricGamma?: number,
                parametricTmaxA7?: number,
                parametricFuelControlled?: boolean,
                parametricTmaxAsterisk?: number,
                parametricThetaMax?: number,
                parametricOlim?: number,
                parametricGammaLim?: number,
                parametricK?: number,
                parametricTxmaxA12?: number,
                parametricX?: number,
            }
            export interface Parametric_json {
                parametricO?: JsonNumber;
                parametricB?: JsonNumber;
                parametricQtd?: JsonNumber;
                parametricTlim?: JsonNumber;
                parametricGamma?: JsonNumber;
                parametricTmaxA7?: JsonNumber;
                parametricFuelControlled?: boolean;
                parametricTmaxAsterisk?: JsonNumber;
                parametricThetaMax?: JsonNumber;
                parametricOlim?: JsonNumber;
                parametricGammaLim?: JsonNumber;
                parametricK?: JsonNumber;
                parametricTxmaxA12?: JsonNumber;
                parametricX?: JsonNumber;
            }
            interface Parametric_json_in {
                __proto_name?: unknown;
                parametricO?: unknown;
                parametricB?: unknown;
                parametricQtd?: unknown;
                parametricTlim?: unknown;
                parametricGamma?: unknown;
                parametricTmaxA7?: unknown;
                parametricFuelControlled?: unknown;
                parametricTmaxAsterisk?: unknown;
                parametricThetaMax?: unknown;
                parametricOlim?: unknown;
                parametricGammaLim?: unknown;
                parametricK?: unknown;
                parametricTxmaxA12?: unknown;
                parametricX?: unknown;
            }
            export class Parametric {
                __proto_name = "ng.fem_design.steel_output.Parametric";
                parametricO: number = 0;
                parametricB: number = 0;
                parametricQtd: number = 0;
                parametricTlim: number = 0;
                parametricGamma: number = 0;
                parametricTmaxA7: number = 0;
                parametricFuelControlled: boolean = false;
                parametricTmaxAsterisk: number = 0;
                parametricThetaMax: number = 0;
                parametricOlim: number = 0;
                parametricGammaLim: number = 0;
                parametricK: number = 0;
                parametricTxmaxA12: number = 0;
                parametricX: number = 0;

                static fromObject(src_unknown: unknown): Parametric {
                    const dst = new Parametric();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Parametric but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Parametric_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Parametric but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.parametricO !== undefined && src.parametricO !== null) {
                        if (typeof src.parametricO === "number" || src.parametricO === 'NaN' || src.parametricO === 'Infinity' || src.parametricO === '-Infinity') {
                            dst.parametricO = AsNum(src.parametricO);
                        }
                        else {
                            console.log('Expected parametricO of Parametric to be a number but was ', typeof src.parametricO, src.parametricO)
                        }
                    }
                    if (src.parametricB !== undefined && src.parametricB !== null) {
                        if (typeof src.parametricB === "number" || src.parametricB === 'NaN' || src.parametricB === 'Infinity' || src.parametricB === '-Infinity') {
                            dst.parametricB = AsNum(src.parametricB);
                        }
                        else {
                            console.log('Expected parametricB of Parametric to be a number but was ', typeof src.parametricB, src.parametricB)
                        }
                    }
                    if (src.parametricQtd !== undefined && src.parametricQtd !== null) {
                        if (typeof src.parametricQtd === "number" || src.parametricQtd === 'NaN' || src.parametricQtd === 'Infinity' || src.parametricQtd === '-Infinity') {
                            dst.parametricQtd = AsNum(src.parametricQtd);
                        }
                        else {
                            console.log('Expected parametricQtd of Parametric to be a number but was ', typeof src.parametricQtd, src.parametricQtd)
                        }
                    }
                    if (src.parametricTlim !== undefined && src.parametricTlim !== null) {
                        if (typeof src.parametricTlim === "number" || src.parametricTlim === 'NaN' || src.parametricTlim === 'Infinity' || src.parametricTlim === '-Infinity') {
                            dst.parametricTlim = AsNum(src.parametricTlim);
                        }
                        else {
                            console.log('Expected parametricTlim of Parametric to be a number but was ', typeof src.parametricTlim, src.parametricTlim)
                        }
                    }
                    if (src.parametricGamma !== undefined && src.parametricGamma !== null) {
                        if (typeof src.parametricGamma === "number" || src.parametricGamma === 'NaN' || src.parametricGamma === 'Infinity' || src.parametricGamma === '-Infinity') {
                            dst.parametricGamma = AsNum(src.parametricGamma);
                        }
                        else {
                            console.log('Expected parametricGamma of Parametric to be a number but was ', typeof src.parametricGamma, src.parametricGamma)
                        }
                    }
                    if (src.parametricTmaxA7 !== undefined && src.parametricTmaxA7 !== null) {
                        if (typeof src.parametricTmaxA7 === "number" || src.parametricTmaxA7 === 'NaN' || src.parametricTmaxA7 === 'Infinity' || src.parametricTmaxA7 === '-Infinity') {
                            dst.parametricTmaxA7 = AsNum(src.parametricTmaxA7);
                        }
                        else {
                            console.log('Expected parametricTmaxA7 of Parametric to be a number but was ', typeof src.parametricTmaxA7, src.parametricTmaxA7)
                        }
                    }
                    if (src.parametricFuelControlled !== undefined && src.parametricFuelControlled !== null) {
                        if (typeof src.parametricFuelControlled === "boolean") {
                            dst.parametricFuelControlled = src.parametricFuelControlled;
                        }
                        else {
                            console.log('Expected parametricFuelControlled of Parametric to be a boolean but was ', typeof src.parametricFuelControlled, src.parametricFuelControlled)
                        }
                    }
                    if (src.parametricTmaxAsterisk !== undefined && src.parametricTmaxAsterisk !== null) {
                        if (typeof src.parametricTmaxAsterisk === "number" || src.parametricTmaxAsterisk === 'NaN' || src.parametricTmaxAsterisk === 'Infinity' || src.parametricTmaxAsterisk === '-Infinity') {
                            dst.parametricTmaxAsterisk = AsNum(src.parametricTmaxAsterisk);
                        }
                        else {
                            console.log('Expected parametricTmaxAsterisk of Parametric to be a number but was ', typeof src.parametricTmaxAsterisk, src.parametricTmaxAsterisk)
                        }
                    }
                    if (src.parametricThetaMax !== undefined && src.parametricThetaMax !== null) {
                        if (typeof src.parametricThetaMax === "number" || src.parametricThetaMax === 'NaN' || src.parametricThetaMax === 'Infinity' || src.parametricThetaMax === '-Infinity') {
                            dst.parametricThetaMax = AsNum(src.parametricThetaMax);
                        }
                        else {
                            console.log('Expected parametricThetaMax of Parametric to be a number but was ', typeof src.parametricThetaMax, src.parametricThetaMax)
                        }
                    }
                    if (src.parametricOlim !== undefined && src.parametricOlim !== null) {
                        if (typeof src.parametricOlim === "number" || src.parametricOlim === 'NaN' || src.parametricOlim === 'Infinity' || src.parametricOlim === '-Infinity') {
                            dst.parametricOlim = AsNum(src.parametricOlim);
                        }
                        else {
                            console.log('Expected parametricOlim of Parametric to be a number but was ', typeof src.parametricOlim, src.parametricOlim)
                        }
                    }
                    if (src.parametricGammaLim !== undefined && src.parametricGammaLim !== null) {
                        if (typeof src.parametricGammaLim === "number" || src.parametricGammaLim === 'NaN' || src.parametricGammaLim === 'Infinity' || src.parametricGammaLim === '-Infinity') {
                            dst.parametricGammaLim = AsNum(src.parametricGammaLim);
                        }
                        else {
                            console.log('Expected parametricGammaLim of Parametric to be a number but was ', typeof src.parametricGammaLim, src.parametricGammaLim)
                        }
                    }
                    if (src.parametricK !== undefined && src.parametricK !== null) {
                        if (typeof src.parametricK === "number" || src.parametricK === 'NaN' || src.parametricK === 'Infinity' || src.parametricK === '-Infinity') {
                            dst.parametricK = AsNum(src.parametricK);
                        }
                        else {
                            console.log('Expected parametricK of Parametric to be a number but was ', typeof src.parametricK, src.parametricK)
                        }
                    }
                    if (src.parametricTxmaxA12 !== undefined && src.parametricTxmaxA12 !== null) {
                        if (typeof src.parametricTxmaxA12 === "number" || src.parametricTxmaxA12 === 'NaN' || src.parametricTxmaxA12 === 'Infinity' || src.parametricTxmaxA12 === '-Infinity') {
                            dst.parametricTxmaxA12 = AsNum(src.parametricTxmaxA12);
                        }
                        else {
                            console.log('Expected parametricTxmaxA12 of Parametric to be a number but was ', typeof src.parametricTxmaxA12, src.parametricTxmaxA12)
                        }
                    }
                    if (src.parametricX !== undefined && src.parametricX !== null) {
                        if (typeof src.parametricX === "number" || src.parametricX === 'NaN' || src.parametricX === 'Infinity' || src.parametricX === '-Infinity') {
                            dst.parametricX = AsNum(src.parametricX);
                        }
                        else {
                            console.log('Expected parametricX of Parametric to be a number but was ', typeof src.parametricX, src.parametricX)
                        }
                    }
                    return dst;
                }

                static toObject(src: Parametric | null | undefined): Parametric_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.Parametric is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.Parametric") {
                        console.error('Expected ng.fem_design.steel_output.Parametric but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Parametric_json = {
                        parametricO: AsJsonNum(src.parametricO),
                        parametricB: AsJsonNum(src.parametricB),
                        parametricQtd: AsJsonNum(src.parametricQtd),
                        parametricTlim: AsJsonNum(src.parametricTlim),
                        parametricGamma: AsJsonNum(src.parametricGamma),
                        parametricTmaxA7: AsJsonNum(src.parametricTmaxA7),
                        parametricFuelControlled: src.parametricFuelControlled,
                        parametricTmaxAsterisk: AsJsonNum(src.parametricTmaxAsterisk),
                        parametricThetaMax: AsJsonNum(src.parametricThetaMax),
                        parametricOlim: AsJsonNum(src.parametricOlim),
                        parametricGammaLim: AsJsonNum(src.parametricGammaLim),
                        parametricK: AsJsonNum(src.parametricK),
                        parametricTxmaxA12: AsJsonNum(src.parametricTxmaxA12),
                        parametricX: AsJsonNum(src.parametricX),
                    };
                    return dst;
                }

                static create(src?: Parametric_createType) {
                    const dst = new Parametric();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.parametricO !== undefined) {
                        dst.parametricO = src.parametricO;
                    }
                    if (src.parametricB !== undefined) {
                        dst.parametricB = src.parametricB;
                    }
                    if (src.parametricQtd !== undefined) {
                        dst.parametricQtd = src.parametricQtd;
                    }
                    if (src.parametricTlim !== undefined) {
                        dst.parametricTlim = src.parametricTlim;
                    }
                    if (src.parametricGamma !== undefined) {
                        dst.parametricGamma = src.parametricGamma;
                    }
                    if (src.parametricTmaxA7 !== undefined) {
                        dst.parametricTmaxA7 = src.parametricTmaxA7;
                    }
                    if (src.parametricFuelControlled !== undefined) {
                        dst.parametricFuelControlled = src.parametricFuelControlled;
                    }
                    if (src.parametricTmaxAsterisk !== undefined) {
                        dst.parametricTmaxAsterisk = src.parametricTmaxAsterisk;
                    }
                    if (src.parametricThetaMax !== undefined) {
                        dst.parametricThetaMax = src.parametricThetaMax;
                    }
                    if (src.parametricOlim !== undefined) {
                        dst.parametricOlim = src.parametricOlim;
                    }
                    if (src.parametricGammaLim !== undefined) {
                        dst.parametricGammaLim = src.parametricGammaLim;
                    }
                    if (src.parametricK !== undefined) {
                        dst.parametricK = src.parametricK;
                    }
                    if (src.parametricTxmaxA12 !== undefined) {
                        dst.parametricTxmaxA12 = src.parametricTxmaxA12;
                    }
                    if (src.parametricX !== undefined) {
                        dst.parametricX = src.parametricX;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Parametric();
                    dst.parametricO = this.parametricO;
                    dst.parametricB = this.parametricB;
                    dst.parametricQtd = this.parametricQtd;
                    dst.parametricTlim = this.parametricTlim;
                    dst.parametricGamma = this.parametricGamma;
                    dst.parametricTmaxA7 = this.parametricTmaxA7;
                    dst.parametricFuelControlled = this.parametricFuelControlled;
                    dst.parametricTmaxAsterisk = this.parametricTmaxAsterisk;
                    dst.parametricThetaMax = this.parametricThetaMax;
                    dst.parametricOlim = this.parametricOlim;
                    dst.parametricGammaLim = this.parametricGammaLim;
                    dst.parametricK = this.parametricK;
                    dst.parametricTxmaxA12 = this.parametricTxmaxA12;
                    dst.parametricX = this.parametricX;
                    return dst;
                }

                deepClone() {
                    const json = Parametric.toObject(this);
                    const dst = Parametric.fromObject(json);
                    return dst;
                }
            }
            export type IParametric = Parametric;


            export type MemberTemperatureUnprotechted_keys = 'ksh' | 'am' | 'v' | 'amV' | 'amB' | 'amVB' | 'dt' | 'rhoa' | 'fSectionI' | 'fSectionConvex' | 'epsm' | 'epsf' | 'alphac' | 'phi' | 'fDeflectionCritEssential';
            export interface MemberTemperatureUnprotechted_createType {
                ksh?: number,
                am?: number,
                v?: number,
                amV?: number,
                amB?: number,
                amVB?: number,
                dt?: number,
                rhoa?: number,
                fSectionI?: boolean,
                fSectionConvex?: boolean,
                epsm?: number,
                epsf?: number,
                alphac?: number,
                phi?: number,
                fDeflectionCritEssential?: boolean,
            }
            export interface MemberTemperatureUnprotechted_json {
                ksh?: JsonNumber;
                am?: JsonNumber;
                v?: JsonNumber;
                amV?: JsonNumber;
                amB?: JsonNumber;
                amVB?: JsonNumber;
                dt?: JsonNumber;
                rhoa?: JsonNumber;
                fSectionI?: boolean;
                fSectionConvex?: boolean;
                epsm?: JsonNumber;
                epsf?: JsonNumber;
                alphac?: JsonNumber;
                phi?: JsonNumber;
                fDeflectionCritEssential?: boolean;
            }
            interface MemberTemperatureUnprotechted_json_in {
                __proto_name?: unknown;
                ksh?: unknown;
                am?: unknown;
                v?: unknown;
                amV?: unknown;
                amB?: unknown;
                amVB?: unknown;
                dt?: unknown;
                rhoa?: unknown;
                fSectionI?: unknown;
                fSectionConvex?: unknown;
                epsm?: unknown;
                epsf?: unknown;
                alphac?: unknown;
                phi?: unknown;
                fDeflectionCritEssential?: unknown;
            }
            export class MemberTemperatureUnprotechted {
                __proto_name = "ng.fem_design.steel_output.MemberTemperatureUnprotechted";
                ksh: number = 0;
                am: number = 0;
                v: number = 0;
                amV: number = 0;
                amB: number = 0;
                amVB: number = 0;
                dt: number = 0;
                rhoa: number = 0;
                fSectionI: boolean = false;
                fSectionConvex: boolean = false;
                epsm: number = 0;
                epsf: number = 0;
                alphac: number = 0;
                phi: number = 0;
                fDeflectionCritEssential: boolean = false;

                static fromObject(src_unknown: unknown): MemberTemperatureUnprotechted {
                    const dst = new MemberTemperatureUnprotechted();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MemberTemperatureUnprotechted but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MemberTemperatureUnprotechted_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MemberTemperatureUnprotechted but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ksh !== undefined && src.ksh !== null) {
                        if (typeof src.ksh === "number" || src.ksh === 'NaN' || src.ksh === 'Infinity' || src.ksh === '-Infinity') {
                            dst.ksh = AsNum(src.ksh);
                        }
                        else {
                            console.log('Expected ksh of MemberTemperatureUnprotechted to be a number but was ', typeof src.ksh, src.ksh)
                        }
                    }
                    if (src.am !== undefined && src.am !== null) {
                        if (typeof src.am === "number" || src.am === 'NaN' || src.am === 'Infinity' || src.am === '-Infinity') {
                            dst.am = AsNum(src.am);
                        }
                        else {
                            console.log('Expected am of MemberTemperatureUnprotechted to be a number but was ', typeof src.am, src.am)
                        }
                    }
                    if (src.v !== undefined && src.v !== null) {
                        if (typeof src.v === "number" || src.v === 'NaN' || src.v === 'Infinity' || src.v === '-Infinity') {
                            dst.v = AsNum(src.v);
                        }
                        else {
                            console.log('Expected v of MemberTemperatureUnprotechted to be a number but was ', typeof src.v, src.v)
                        }
                    }
                    if (src.amV !== undefined && src.amV !== null) {
                        if (typeof src.amV === "number" || src.amV === 'NaN' || src.amV === 'Infinity' || src.amV === '-Infinity') {
                            dst.amV = AsNum(src.amV);
                        }
                        else {
                            console.log('Expected amV of MemberTemperatureUnprotechted to be a number but was ', typeof src.amV, src.amV)
                        }
                    }
                    if (src.amB !== undefined && src.amB !== null) {
                        if (typeof src.amB === "number" || src.amB === 'NaN' || src.amB === 'Infinity' || src.amB === '-Infinity') {
                            dst.amB = AsNum(src.amB);
                        }
                        else {
                            console.log('Expected amB of MemberTemperatureUnprotechted to be a number but was ', typeof src.amB, src.amB)
                        }
                    }
                    if (src.amVB !== undefined && src.amVB !== null) {
                        if (typeof src.amVB === "number" || src.amVB === 'NaN' || src.amVB === 'Infinity' || src.amVB === '-Infinity') {
                            dst.amVB = AsNum(src.amVB);
                        }
                        else {
                            console.log('Expected amVB of MemberTemperatureUnprotechted to be a number but was ', typeof src.amVB, src.amVB)
                        }
                    }
                    if (src.dt !== undefined && src.dt !== null) {
                        if (typeof src.dt === "number" || src.dt === 'NaN' || src.dt === 'Infinity' || src.dt === '-Infinity') {
                            dst.dt = AsNum(src.dt);
                        }
                        else {
                            console.log('Expected dt of MemberTemperatureUnprotechted to be a number but was ', typeof src.dt, src.dt)
                        }
                    }
                    if (src.rhoa !== undefined && src.rhoa !== null) {
                        if (typeof src.rhoa === "number" || src.rhoa === 'NaN' || src.rhoa === 'Infinity' || src.rhoa === '-Infinity') {
                            dst.rhoa = AsNum(src.rhoa);
                        }
                        else {
                            console.log('Expected rhoa of MemberTemperatureUnprotechted to be a number but was ', typeof src.rhoa, src.rhoa)
                        }
                    }
                    if (src.fSectionI !== undefined && src.fSectionI !== null) {
                        if (typeof src.fSectionI === "boolean") {
                            dst.fSectionI = src.fSectionI;
                        }
                        else {
                            console.log('Expected fSectionI of MemberTemperatureUnprotechted to be a boolean but was ', typeof src.fSectionI, src.fSectionI)
                        }
                    }
                    if (src.fSectionConvex !== undefined && src.fSectionConvex !== null) {
                        if (typeof src.fSectionConvex === "boolean") {
                            dst.fSectionConvex = src.fSectionConvex;
                        }
                        else {
                            console.log('Expected fSectionConvex of MemberTemperatureUnprotechted to be a boolean but was ', typeof src.fSectionConvex, src.fSectionConvex)
                        }
                    }
                    if (src.epsm !== undefined && src.epsm !== null) {
                        if (typeof src.epsm === "number" || src.epsm === 'NaN' || src.epsm === 'Infinity' || src.epsm === '-Infinity') {
                            dst.epsm = AsNum(src.epsm);
                        }
                        else {
                            console.log('Expected epsm of MemberTemperatureUnprotechted to be a number but was ', typeof src.epsm, src.epsm)
                        }
                    }
                    if (src.epsf !== undefined && src.epsf !== null) {
                        if (typeof src.epsf === "number" || src.epsf === 'NaN' || src.epsf === 'Infinity' || src.epsf === '-Infinity') {
                            dst.epsf = AsNum(src.epsf);
                        }
                        else {
                            console.log('Expected epsf of MemberTemperatureUnprotechted to be a number but was ', typeof src.epsf, src.epsf)
                        }
                    }
                    if (src.alphac !== undefined && src.alphac !== null) {
                        if (typeof src.alphac === "number" || src.alphac === 'NaN' || src.alphac === 'Infinity' || src.alphac === '-Infinity') {
                            dst.alphac = AsNum(src.alphac);
                        }
                        else {
                            console.log('Expected alphac of MemberTemperatureUnprotechted to be a number but was ', typeof src.alphac, src.alphac)
                        }
                    }
                    if (src.phi !== undefined && src.phi !== null) {
                        if (typeof src.phi === "number" || src.phi === 'NaN' || src.phi === 'Infinity' || src.phi === '-Infinity') {
                            dst.phi = AsNum(src.phi);
                        }
                        else {
                            console.log('Expected phi of MemberTemperatureUnprotechted to be a number but was ', typeof src.phi, src.phi)
                        }
                    }
                    if (src.fDeflectionCritEssential !== undefined && src.fDeflectionCritEssential !== null) {
                        if (typeof src.fDeflectionCritEssential === "boolean") {
                            dst.fDeflectionCritEssential = src.fDeflectionCritEssential;
                        }
                        else {
                            console.log('Expected fDeflectionCritEssential of MemberTemperatureUnprotechted to be a boolean but was ', typeof src.fDeflectionCritEssential, src.fDeflectionCritEssential)
                        }
                    }
                    return dst;
                }

                static toObject(src: MemberTemperatureUnprotechted | null | undefined): MemberTemperatureUnprotechted_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.MemberTemperatureUnprotechted is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.MemberTemperatureUnprotechted") {
                        console.error('Expected ng.fem_design.steel_output.MemberTemperatureUnprotechted but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MemberTemperatureUnprotechted_json = {
                        ksh: AsJsonNum(src.ksh),
                        am: AsJsonNum(src.am),
                        v: AsJsonNum(src.v),
                        amV: AsJsonNum(src.amV),
                        amB: AsJsonNum(src.amB),
                        amVB: AsJsonNum(src.amVB),
                        dt: AsJsonNum(src.dt),
                        rhoa: AsJsonNum(src.rhoa),
                        fSectionI: src.fSectionI,
                        fSectionConvex: src.fSectionConvex,
                        epsm: AsJsonNum(src.epsm),
                        epsf: AsJsonNum(src.epsf),
                        alphac: AsJsonNum(src.alphac),
                        phi: AsJsonNum(src.phi),
                        fDeflectionCritEssential: src.fDeflectionCritEssential,
                    };
                    return dst;
                }

                static create(src?: MemberTemperatureUnprotechted_createType) {
                    const dst = new MemberTemperatureUnprotechted();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ksh !== undefined) {
                        dst.ksh = src.ksh;
                    }
                    if (src.am !== undefined) {
                        dst.am = src.am;
                    }
                    if (src.v !== undefined) {
                        dst.v = src.v;
                    }
                    if (src.amV !== undefined) {
                        dst.amV = src.amV;
                    }
                    if (src.amB !== undefined) {
                        dst.amB = src.amB;
                    }
                    if (src.amVB !== undefined) {
                        dst.amVB = src.amVB;
                    }
                    if (src.dt !== undefined) {
                        dst.dt = src.dt;
                    }
                    if (src.rhoa !== undefined) {
                        dst.rhoa = src.rhoa;
                    }
                    if (src.fSectionI !== undefined) {
                        dst.fSectionI = src.fSectionI;
                    }
                    if (src.fSectionConvex !== undefined) {
                        dst.fSectionConvex = src.fSectionConvex;
                    }
                    if (src.epsm !== undefined) {
                        dst.epsm = src.epsm;
                    }
                    if (src.epsf !== undefined) {
                        dst.epsf = src.epsf;
                    }
                    if (src.alphac !== undefined) {
                        dst.alphac = src.alphac;
                    }
                    if (src.phi !== undefined) {
                        dst.phi = src.phi;
                    }
                    if (src.fDeflectionCritEssential !== undefined) {
                        dst.fDeflectionCritEssential = src.fDeflectionCritEssential;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MemberTemperatureUnprotechted();
                    dst.ksh = this.ksh;
                    dst.am = this.am;
                    dst.v = this.v;
                    dst.amV = this.amV;
                    dst.amB = this.amB;
                    dst.amVB = this.amVB;
                    dst.dt = this.dt;
                    dst.rhoa = this.rhoa;
                    dst.fSectionI = this.fSectionI;
                    dst.fSectionConvex = this.fSectionConvex;
                    dst.epsm = this.epsm;
                    dst.epsf = this.epsf;
                    dst.alphac = this.alphac;
                    dst.phi = this.phi;
                    dst.fDeflectionCritEssential = this.fDeflectionCritEssential;
                    return dst;
                }

                deepClone() {
                    const json = MemberTemperatureUnprotechted.toObject(this);
                    const dst = MemberTemperatureUnprotechted.fromObject(json);
                    return dst;
                }
            }
            export type IMemberTemperatureUnprotechted = MemberTemperatureUnprotechted;


            export type MemberTemperatureProtechted_keys = 'dp' | 'encasement' | 'cp' | 'rhop' | 'lambdap' | 'ap' | 'apV' | 'vGraphMemberTemperature' | 'tempMember';
            export interface MemberTemperatureProtechted_createType {
                dp?: number,
                encasement?: number,
                cp?: number,
                rhop?: number,
                lambdap?: number,
                ap?: number,
                apV?: number,
                vGraphMemberTemperature?: ng.fem_design.steel_output.TVPointW | null,
                tempMember?: number,
            }
            export interface MemberTemperatureProtechted_json {
                dp?: JsonNumber;
                encasement?: JsonNumber;
                cp?: JsonNumber;
                rhop?: JsonNumber;
                lambdap?: JsonNumber;
                ap?: JsonNumber;
                apV?: JsonNumber;
                vGraphMemberTemperature?: ng.fem_design.steel_output.TVPointW_json;
                tempMember?: JsonNumber;
            }
            interface MemberTemperatureProtechted_json_in {
                __proto_name?: unknown;
                dp?: unknown;
                encasement?: unknown;
                cp?: unknown;
                rhop?: unknown;
                lambdap?: unknown;
                ap?: unknown;
                apV?: unknown;
                vGraphMemberTemperature?: unknown;
                tempMember?: unknown;
            }
            export class MemberTemperatureProtechted {
                __proto_name = "ng.fem_design.steel_output.MemberTemperatureProtechted";
                dp: number = 0;
                encasement: number = 0;
                cp: number = 0;
                rhop: number = 0;
                lambdap: number = 0;
                ap: number = 0;
                apV: number = 0;
                vGraphMemberTemperature: ng.fem_design.steel_output.TVPointW | null = null;
                tempMember: number = 0;

                static fromObject(src_unknown: unknown): MemberTemperatureProtechted {
                    const dst = new MemberTemperatureProtechted();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted MemberTemperatureProtechted but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as MemberTemperatureProtechted_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for MemberTemperatureProtechted but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.dp !== undefined && src.dp !== null) {
                        if (typeof src.dp === "number" || src.dp === 'NaN' || src.dp === 'Infinity' || src.dp === '-Infinity') {
                            dst.dp = AsNum(src.dp);
                        }
                        else {
                            console.log('Expected dp of MemberTemperatureProtechted to be a number but was ', typeof src.dp, src.dp)
                        }
                    }
                    if (src.encasement !== undefined && src.encasement !== null) {
                        if (typeof src.encasement === "number" || src.encasement === 'NaN' || src.encasement === 'Infinity' || src.encasement === '-Infinity') {
                            dst.encasement = NumberToInt("ng.fem_design.steel_output.MemberTemperatureProtechted.encasement", AsNum(src.encasement));
                        }
                        else {
                            console.log('Expected encasement of MemberTemperatureProtechted to be a number but was ', typeof src.encasement, src.encasement)
                        }
                    }
                    if (src.cp !== undefined && src.cp !== null) {
                        if (typeof src.cp === "number" || src.cp === 'NaN' || src.cp === 'Infinity' || src.cp === '-Infinity') {
                            dst.cp = AsNum(src.cp);
                        }
                        else {
                            console.log('Expected cp of MemberTemperatureProtechted to be a number but was ', typeof src.cp, src.cp)
                        }
                    }
                    if (src.rhop !== undefined && src.rhop !== null) {
                        if (typeof src.rhop === "number" || src.rhop === 'NaN' || src.rhop === 'Infinity' || src.rhop === '-Infinity') {
                            dst.rhop = AsNum(src.rhop);
                        }
                        else {
                            console.log('Expected rhop of MemberTemperatureProtechted to be a number but was ', typeof src.rhop, src.rhop)
                        }
                    }
                    if (src.lambdap !== undefined && src.lambdap !== null) {
                        if (typeof src.lambdap === "number" || src.lambdap === 'NaN' || src.lambdap === 'Infinity' || src.lambdap === '-Infinity') {
                            dst.lambdap = AsNum(src.lambdap);
                        }
                        else {
                            console.log('Expected lambdap of MemberTemperatureProtechted to be a number but was ', typeof src.lambdap, src.lambdap)
                        }
                    }
                    if (src.ap !== undefined && src.ap !== null) {
                        if (typeof src.ap === "number" || src.ap === 'NaN' || src.ap === 'Infinity' || src.ap === '-Infinity') {
                            dst.ap = AsNum(src.ap);
                        }
                        else {
                            console.log('Expected ap of MemberTemperatureProtechted to be a number but was ', typeof src.ap, src.ap)
                        }
                    }
                    if (src.apV !== undefined && src.apV !== null) {
                        if (typeof src.apV === "number" || src.apV === 'NaN' || src.apV === 'Infinity' || src.apV === '-Infinity') {
                            dst.apV = AsNum(src.apV);
                        }
                        else {
                            console.log('Expected apV of MemberTemperatureProtechted to be a number but was ', typeof src.apV, src.apV)
                        }
                    }
                    if (src.vGraphMemberTemperature !== undefined && src.vGraphMemberTemperature !== null) {
                        dst.vGraphMemberTemperature = ng.fem_design.steel_output.TVPointW.fromObject(src.vGraphMemberTemperature);
                    }
                    if (src.tempMember !== undefined && src.tempMember !== null) {
                        if (typeof src.tempMember === "number" || src.tempMember === 'NaN' || src.tempMember === 'Infinity' || src.tempMember === '-Infinity') {
                            dst.tempMember = AsNum(src.tempMember);
                        }
                        else {
                            console.log('Expected tempMember of MemberTemperatureProtechted to be a number but was ', typeof src.tempMember, src.tempMember)
                        }
                    }
                    return dst;
                }

                static toObject(src: MemberTemperatureProtechted | null | undefined): MemberTemperatureProtechted_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.MemberTemperatureProtechted is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.MemberTemperatureProtechted") {
                        console.error('Expected ng.fem_design.steel_output.MemberTemperatureProtechted but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : MemberTemperatureProtechted_json = {
                        dp: AsJsonNum(src.dp),
                        encasement: AsJsonNum(NumberToInt("ng.fem_design.steel_output.MemberTemperatureProtechted.encasement", src.encasement)),
                        cp: AsJsonNum(src.cp),
                        rhop: AsJsonNum(src.rhop),
                        lambdap: AsJsonNum(src.lambdap),
                        ap: AsJsonNum(src.ap),
                        apV: AsJsonNum(src.apV),
                        tempMember: AsJsonNum(src.tempMember),
                    };
                    if(src.vGraphMemberTemperature !== null)
                    {
                        const parsed = ng.fem_design.steel_output.TVPointW.toObject(src.vGraphMemberTemperature);
                        if(parsed === null) return null;
                        dst.vGraphMemberTemperature = parsed;
                    }
                    return dst;
                }

                static create(src?: MemberTemperatureProtechted_createType) {
                    const dst = new MemberTemperatureProtechted();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.dp !== undefined) {
                        dst.dp = src.dp;
                    }
                    if (src.encasement !== undefined) {
                        dst.encasement = src.encasement;
                    }
                    if (src.cp !== undefined) {
                        dst.cp = src.cp;
                    }
                    if (src.rhop !== undefined) {
                        dst.rhop = src.rhop;
                    }
                    if (src.lambdap !== undefined) {
                        dst.lambdap = src.lambdap;
                    }
                    if (src.ap !== undefined) {
                        dst.ap = src.ap;
                    }
                    if (src.apV !== undefined) {
                        dst.apV = src.apV;
                    }
                    if (src.vGraphMemberTemperature !== undefined) {
                        dst.vGraphMemberTemperature = src.vGraphMemberTemperature;
                    }
                    if (src.tempMember !== undefined) {
                        dst.tempMember = src.tempMember;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new MemberTemperatureProtechted();
                    dst.dp = this.dp;
                    dst.encasement = this.encasement;
                    dst.cp = this.cp;
                    dst.rhop = this.rhop;
                    dst.lambdap = this.lambdap;
                    dst.ap = this.ap;
                    dst.apV = this.apV;
                    dst.vGraphMemberTemperature = this.vGraphMemberTemperature;
                    dst.tempMember = this.tempMember;
                    return dst;
                }

                deepClone() {
                    const json = MemberTemperatureProtechted.toObject(this);
                    const dst = MemberTemperatureProtechted.fromObject(json);
                    return dst;
                }
            }
            export type IMemberTemperatureProtechted = MemberTemperatureProtechted;


            export type FireDataRecord_keys = 'gasTemperature' | 'memberTempUnprotechted' | 'memberTempProtechted' | 'adaptionFactors';
            export interface FireDataRecord_createType {
                gasTemperature?: ng.fem_design.steel_output.GasTemperature | null,
                memberTempUnprotechted?: ng.fem_design.steel_output.MemberTemperatureUnprotechted | null,
                memberTempProtechted?: ng.fem_design.steel_output.MemberTemperatureProtechted | null,
                adaptionFactors?: ng.fem_design.steel_output.Vector2D | null,
            }
            export interface FireDataRecord_json {
                gasTemperature?: ng.fem_design.steel_output.GasTemperature_json;
                memberTempUnprotechted?: ng.fem_design.steel_output.MemberTemperatureUnprotechted_json;
                memberTempProtechted?: ng.fem_design.steel_output.MemberTemperatureProtechted_json;
                adaptionFactors?: ng.fem_design.steel_output.Vector2D_json;
            }
            interface FireDataRecord_json_in {
                __proto_name?: unknown;
                gasTemperature?: unknown;
                memberTempUnprotechted?: unknown;
                memberTempProtechted?: unknown;
                adaptionFactors?: unknown;
            }
            export class FireDataRecord {
                __proto_name = "ng.fem_design.steel_output.FireDataRecord";
                gasTemperature: ng.fem_design.steel_output.GasTemperature | null = null;
                memberTempUnprotechted: ng.fem_design.steel_output.MemberTemperatureUnprotechted | null = null;
                memberTempProtechted: ng.fem_design.steel_output.MemberTemperatureProtechted | null = null;
                adaptionFactors: ng.fem_design.steel_output.Vector2D | null = null;

                static fromObject(src_unknown: unknown): FireDataRecord {
                    const dst = new FireDataRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FireDataRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FireDataRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FireDataRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gasTemperature !== undefined && src.gasTemperature !== null) {
                        dst.gasTemperature = ng.fem_design.steel_output.GasTemperature.fromObject(src.gasTemperature);
                    }
                    if (src.memberTempUnprotechted !== undefined && src.memberTempUnprotechted !== null) {
                        dst.memberTempUnprotechted = ng.fem_design.steel_output.MemberTemperatureUnprotechted.fromObject(src.memberTempUnprotechted);
                    }
                    if (src.memberTempProtechted !== undefined && src.memberTempProtechted !== null) {
                        dst.memberTempProtechted = ng.fem_design.steel_output.MemberTemperatureProtechted.fromObject(src.memberTempProtechted);
                    }
                    if (src.adaptionFactors !== undefined && src.adaptionFactors !== null) {
                        dst.adaptionFactors = ng.fem_design.steel_output.Vector2D.fromObject(src.adaptionFactors);
                    }
                    return dst;
                }

                static toObject(src: FireDataRecord | null | undefined): FireDataRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.FireDataRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.FireDataRecord") {
                        console.error('Expected ng.fem_design.steel_output.FireDataRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FireDataRecord_json = {
                    };
                    if(src.gasTemperature !== null)
                    {
                        const parsed = ng.fem_design.steel_output.GasTemperature.toObject(src.gasTemperature);
                        if(parsed === null) return null;
                        dst.gasTemperature = parsed;
                    }
                    if(src.memberTempUnprotechted !== null)
                    {
                        const parsed = ng.fem_design.steel_output.MemberTemperatureUnprotechted.toObject(src.memberTempUnprotechted);
                        if(parsed === null) return null;
                        dst.memberTempUnprotechted = parsed;
                    }
                    if(src.memberTempProtechted !== null)
                    {
                        const parsed = ng.fem_design.steel_output.MemberTemperatureProtechted.toObject(src.memberTempProtechted);
                        if(parsed === null) return null;
                        dst.memberTempProtechted = parsed;
                    }
                    if(src.adaptionFactors !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.adaptionFactors);
                        if(parsed === null) return null;
                        dst.adaptionFactors = parsed;
                    }
                    return dst;
                }

                static create(src?: FireDataRecord_createType) {
                    const dst = new FireDataRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gasTemperature !== undefined) {
                        dst.gasTemperature = src.gasTemperature;
                    }
                    if (src.memberTempUnprotechted !== undefined) {
                        dst.memberTempUnprotechted = src.memberTempUnprotechted;
                    }
                    if (src.memberTempProtechted !== undefined) {
                        dst.memberTempProtechted = src.memberTempProtechted;
                    }
                    if (src.adaptionFactors !== undefined) {
                        dst.adaptionFactors = src.adaptionFactors;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FireDataRecord();
                    dst.gasTemperature = this.gasTemperature;
                    dst.memberTempUnprotechted = this.memberTempUnprotechted;
                    dst.memberTempProtechted = this.memberTempProtechted;
                    dst.adaptionFactors = this.adaptionFactors;
                    return dst;
                }

                deepClone() {
                    const json = FireDataRecord.toObject(this);
                    const dst = FireDataRecord.fromObject(json);
                    return dst;
                }
            }
            export type IFireDataRecord = FireDataRecord;


            export type BarExtraDataRecord_keys = 'crossSectionDataRecord' | 'materialDataRecord' | 'fireDataRecord';
            export interface BarExtraDataRecord_createType {
                crossSectionDataRecord?: ng.fem_design.steel_output.CrossSectionDataRecord | null,
                materialDataRecord?: ng.fem_design.steel_output.MaterialDataRecord | null,
                fireDataRecord?: ng.fem_design.steel_output.FireDataRecord | null,
            }
            export interface BarExtraDataRecord_json {
                crossSectionDataRecord?: ng.fem_design.steel_output.CrossSectionDataRecord_json;
                materialDataRecord?: ng.fem_design.steel_output.MaterialDataRecord_json;
                fireDataRecord?: ng.fem_design.steel_output.FireDataRecord_json;
            }
            interface BarExtraDataRecord_json_in {
                __proto_name?: unknown;
                crossSectionDataRecord?: unknown;
                materialDataRecord?: unknown;
                fireDataRecord?: unknown;
            }
            export class BarExtraDataRecord {
                __proto_name = "ng.fem_design.steel_output.BarExtraDataRecord";
                crossSectionDataRecord: ng.fem_design.steel_output.CrossSectionDataRecord | null = null;
                materialDataRecord: ng.fem_design.steel_output.MaterialDataRecord | null = null;
                fireDataRecord: ng.fem_design.steel_output.FireDataRecord | null = null;

                static fromObject(src_unknown: unknown): BarExtraDataRecord {
                    const dst = new BarExtraDataRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BarExtraDataRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BarExtraDataRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BarExtraDataRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.crossSectionDataRecord !== undefined && src.crossSectionDataRecord !== null) {
                        dst.crossSectionDataRecord = ng.fem_design.steel_output.CrossSectionDataRecord.fromObject(src.crossSectionDataRecord);
                    }
                    if (src.materialDataRecord !== undefined && src.materialDataRecord !== null) {
                        dst.materialDataRecord = ng.fem_design.steel_output.MaterialDataRecord.fromObject(src.materialDataRecord);
                    }
                    if (src.fireDataRecord !== undefined && src.fireDataRecord !== null) {
                        dst.fireDataRecord = ng.fem_design.steel_output.FireDataRecord.fromObject(src.fireDataRecord);
                    }
                    return dst;
                }

                static toObject(src: BarExtraDataRecord | null | undefined): BarExtraDataRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.BarExtraDataRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.BarExtraDataRecord") {
                        console.error('Expected ng.fem_design.steel_output.BarExtraDataRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BarExtraDataRecord_json = {
                    };
                    if(src.crossSectionDataRecord !== null)
                    {
                        const parsed = ng.fem_design.steel_output.CrossSectionDataRecord.toObject(src.crossSectionDataRecord);
                        if(parsed === null) return null;
                        dst.crossSectionDataRecord = parsed;
                    }
                    if(src.materialDataRecord !== null)
                    {
                        const parsed = ng.fem_design.steel_output.MaterialDataRecord.toObject(src.materialDataRecord);
                        if(parsed === null) return null;
                        dst.materialDataRecord = parsed;
                    }
                    if(src.fireDataRecord !== null)
                    {
                        const parsed = ng.fem_design.steel_output.FireDataRecord.toObject(src.fireDataRecord);
                        if(parsed === null) return null;
                        dst.fireDataRecord = parsed;
                    }
                    return dst;
                }

                static create(src?: BarExtraDataRecord_createType) {
                    const dst = new BarExtraDataRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.crossSectionDataRecord !== undefined) {
                        dst.crossSectionDataRecord = src.crossSectionDataRecord;
                    }
                    if (src.materialDataRecord !== undefined) {
                        dst.materialDataRecord = src.materialDataRecord;
                    }
                    if (src.fireDataRecord !== undefined) {
                        dst.fireDataRecord = src.fireDataRecord;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BarExtraDataRecord();
                    dst.crossSectionDataRecord = this.crossSectionDataRecord;
                    dst.materialDataRecord = this.materialDataRecord;
                    dst.fireDataRecord = this.fireDataRecord;
                    return dst;
                }

                deepClone() {
                    const json = BarExtraDataRecord.toObject(this);
                    const dst = BarExtraDataRecord.fromObject(json);
                    return dst;
                }
            }
            export type IBarExtraDataRecord = BarExtraDataRecord;


            export type SectionClassRecord_keys = 'sClassGenN' | 'sClassGenM1' | 'sClassGenM2' | 'sClassGenMax';
            export interface SectionClassRecord_createType {
                sClassGenN?: number,
                sClassGenM1?: number,
                sClassGenM2?: number,
                sClassGenMax?: number,
            }
            export interface SectionClassRecord_json {
                sClassGenN?: JsonNumber;
                sClassGenM1?: JsonNumber;
                sClassGenM2?: JsonNumber;
                sClassGenMax?: JsonNumber;
            }
            interface SectionClassRecord_json_in {
                __proto_name?: unknown;
                sClassGenN?: unknown;
                sClassGenM1?: unknown;
                sClassGenM2?: unknown;
                sClassGenMax?: unknown;
            }
            export class SectionClassRecord {
                __proto_name = "ng.fem_design.steel_output.SectionClassRecord";
                sClassGenN: number = 0;
                sClassGenM1: number = 0;
                sClassGenM2: number = 0;
                sClassGenMax: number = 0;

                static fromObject(src_unknown: unknown): SectionClassRecord {
                    const dst = new SectionClassRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionClassRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionClassRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionClassRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sClassGenN !== undefined && src.sClassGenN !== null) {
                        if (typeof src.sClassGenN === "number" || src.sClassGenN === 'NaN' || src.sClassGenN === 'Infinity' || src.sClassGenN === '-Infinity') {
                            dst.sClassGenN = NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_n", AsNum(src.sClassGenN));
                        }
                        else {
                            console.log('Expected sClassGenN of SectionClassRecord to be a number but was ', typeof src.sClassGenN, src.sClassGenN)
                        }
                    }
                    if (src.sClassGenM1 !== undefined && src.sClassGenM1 !== null) {
                        if (typeof src.sClassGenM1 === "number" || src.sClassGenM1 === 'NaN' || src.sClassGenM1 === 'Infinity' || src.sClassGenM1 === '-Infinity') {
                            dst.sClassGenM1 = NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_m1", AsNum(src.sClassGenM1));
                        }
                        else {
                            console.log('Expected sClassGenM1 of SectionClassRecord to be a number but was ', typeof src.sClassGenM1, src.sClassGenM1)
                        }
                    }
                    if (src.sClassGenM2 !== undefined && src.sClassGenM2 !== null) {
                        if (typeof src.sClassGenM2 === "number" || src.sClassGenM2 === 'NaN' || src.sClassGenM2 === 'Infinity' || src.sClassGenM2 === '-Infinity') {
                            dst.sClassGenM2 = NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_m2", AsNum(src.sClassGenM2));
                        }
                        else {
                            console.log('Expected sClassGenM2 of SectionClassRecord to be a number but was ', typeof src.sClassGenM2, src.sClassGenM2)
                        }
                    }
                    if (src.sClassGenMax !== undefined && src.sClassGenMax !== null) {
                        if (typeof src.sClassGenMax === "number" || src.sClassGenMax === 'NaN' || src.sClassGenMax === 'Infinity' || src.sClassGenMax === '-Infinity') {
                            dst.sClassGenMax = NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_max", AsNum(src.sClassGenMax));
                        }
                        else {
                            console.log('Expected sClassGenMax of SectionClassRecord to be a number but was ', typeof src.sClassGenMax, src.sClassGenMax)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionClassRecord | null | undefined): SectionClassRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.SectionClassRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.SectionClassRecord") {
                        console.error('Expected ng.fem_design.steel_output.SectionClassRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionClassRecord_json = {
                        sClassGenN: AsJsonNum(NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_n", src.sClassGenN)),
                        sClassGenM1: AsJsonNum(NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_m1", src.sClassGenM1)),
                        sClassGenM2: AsJsonNum(NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_m2", src.sClassGenM2)),
                        sClassGenMax: AsJsonNum(NumberToInt("ng.fem_design.steel_output.SectionClassRecord.s_class_gen_max", src.sClassGenMax)),
                    };
                    return dst;
                }

                static create(src?: SectionClassRecord_createType) {
                    const dst = new SectionClassRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sClassGenN !== undefined) {
                        dst.sClassGenN = src.sClassGenN;
                    }
                    if (src.sClassGenM1 !== undefined) {
                        dst.sClassGenM1 = src.sClassGenM1;
                    }
                    if (src.sClassGenM2 !== undefined) {
                        dst.sClassGenM2 = src.sClassGenM2;
                    }
                    if (src.sClassGenMax !== undefined) {
                        dst.sClassGenMax = src.sClassGenMax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionClassRecord();
                    dst.sClassGenN = this.sClassGenN;
                    dst.sClassGenM1 = this.sClassGenM1;
                    dst.sClassGenM2 = this.sClassGenM2;
                    dst.sClassGenMax = this.sClassGenMax;
                    return dst;
                }

                deepClone() {
                    const json = SectionClassRecord.toObject(this);
                    const dst = SectionClassRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionClassRecord = SectionClassRecord;


            export type SectionDesignCalcRecord_keys = 'x' | 'rUtil' | 'idGmaxComb' | 'rUtilV' | 'rUtilTau' | 'rUtilT' | 'rUtilN' | 'rUtilNorm' | 'rUtilSigma' | 'rUtilFB' | 'rUtilFTB' | 'rUtilLTBTop' | 'rUtilLBTBottom' | 'rUtilShear' | 'rUtilIA' | 'rUtilIA2nd' | 'arIntForces' | 'stEffectiveCS' | 'stCSResist' | 'stFlexural' | 'stFlexuralTorsional' | 'stBarTorsionalTop' | 'stBarTorsionalBottom' | 'stBarInteraction' | 'stBarInteraction2nd' | 'stBarWeb';
            export interface SectionDesignCalcRecord_createType {
                x?: number,
                rUtil?: number,
                idGmaxComb?: number,
                rUtilV?: ng.fem_design.steel_output.Vector2D | null,
                rUtilTau?: number,
                rUtilT?: number,
                rUtilN?: number,
                rUtilNorm?: number,
                rUtilSigma?: number,
                rUtilFB?: ng.fem_design.steel_output.Vector2D | null,
                rUtilFTB?: number,
                rUtilLTBTop?: number,
                rUtilLBTBottom?: number,
                rUtilShear?: number,
                rUtilIA?: ng.fem_design.steel_output.Vector2D | null,
                rUtilIA2nd?: number,
                arIntForces?: ng.fem_design.analysis_data.Force | null,
                stEffectiveCS?: ng.fem_design.steel_output.StBarEffectiveCS | null,
                stCSResist?: ng.fem_design.steel_output.StBarCSResist | null,
                stFlexural?: ng.fem_design.steel_output.StBarFlexural | null,
                stFlexuralTorsional?: ng.fem_design.steel_output.StBarFlexuralTorsional | null,
                stBarTorsionalTop?: ng.fem_design.steel_output.StBarTorsional | null,
                stBarTorsionalBottom?: ng.fem_design.steel_output.StBarTorsional | null,
                stBarInteraction?: ng.fem_design.steel_output.StBarInteraction | null,
                stBarInteraction2nd?: ng.fem_design.steel_output.StBarInteraction2nd | null,
                stBarWeb?: ng.fem_design.steel_output.StBarWeb | null,
            }
            export interface SectionDesignCalcRecord_json {
                x?: JsonNumber;
                rUtil?: JsonNumber;
                idGmaxComb?: JsonNumber;
                rUtilV?: ng.fem_design.steel_output.Vector2D_json;
                rUtilTau?: JsonNumber;
                rUtilT?: JsonNumber;
                rUtilN?: JsonNumber;
                rUtilNorm?: JsonNumber;
                rUtilSigma?: JsonNumber;
                rUtilFB?: ng.fem_design.steel_output.Vector2D_json;
                rUtilFTB?: JsonNumber;
                rUtilLTBTop?: JsonNumber;
                rUtilLBTBottom?: JsonNumber;
                rUtilShear?: JsonNumber;
                rUtilIA?: ng.fem_design.steel_output.Vector2D_json;
                rUtilIA2nd?: JsonNumber;
                arIntForces?: ng.fem_design.analysis_data.Force_json;
                stEffectiveCS?: ng.fem_design.steel_output.StBarEffectiveCS_json;
                stCSResist?: ng.fem_design.steel_output.StBarCSResist_json;
                stFlexural?: ng.fem_design.steel_output.StBarFlexural_json;
                stFlexuralTorsional?: ng.fem_design.steel_output.StBarFlexuralTorsional_json;
                stBarTorsionalTop?: ng.fem_design.steel_output.StBarTorsional_json;
                stBarTorsionalBottom?: ng.fem_design.steel_output.StBarTorsional_json;
                stBarInteraction?: ng.fem_design.steel_output.StBarInteraction_json;
                stBarInteraction2nd?: ng.fem_design.steel_output.StBarInteraction2nd_json;
                stBarWeb?: ng.fem_design.steel_output.StBarWeb_json;
            }
            interface SectionDesignCalcRecord_json_in {
                __proto_name?: unknown;
                x?: unknown;
                rUtil?: unknown;
                idGmaxComb?: unknown;
                rUtilV?: unknown;
                rUtilTau?: unknown;
                rUtilT?: unknown;
                rUtilN?: unknown;
                rUtilNorm?: unknown;
                rUtilSigma?: unknown;
                rUtilFB?: unknown;
                rUtilFTB?: unknown;
                rUtilLTBTop?: unknown;
                rUtilLBTBottom?: unknown;
                rUtilShear?: unknown;
                rUtilIA?: unknown;
                rUtilIA2nd?: unknown;
                arIntForces?: unknown;
                stEffectiveCS?: unknown;
                stCSResist?: unknown;
                stFlexural?: unknown;
                stFlexuralTorsional?: unknown;
                stBarTorsionalTop?: unknown;
                stBarTorsionalBottom?: unknown;
                stBarInteraction?: unknown;
                stBarInteraction2nd?: unknown;
                stBarWeb?: unknown;
            }
            export class SectionDesignCalcRecord {
                __proto_name = "ng.fem_design.steel_output.SectionDesignCalcRecord";
                x: number = 0;
                rUtil: number = 0;
                idGmaxComb: number = 0;
                rUtilV: ng.fem_design.steel_output.Vector2D | null = null;
                rUtilTau: number = 0;
                rUtilT: number = 0;
                rUtilN: number = 0;
                rUtilNorm: number = 0;
                rUtilSigma: number = 0;
                rUtilFB: ng.fem_design.steel_output.Vector2D | null = null;
                rUtilFTB: number = 0;
                rUtilLTBTop: number = 0;
                rUtilLBTBottom: number = 0;
                rUtilShear: number = 0;
                rUtilIA: ng.fem_design.steel_output.Vector2D | null = null;
                rUtilIA2nd: number = 0;
                arIntForces: ng.fem_design.analysis_data.Force | null = null;
                stEffectiveCS: ng.fem_design.steel_output.StBarEffectiveCS | null = null;
                stCSResist: ng.fem_design.steel_output.StBarCSResist | null = null;
                stFlexural: ng.fem_design.steel_output.StBarFlexural | null = null;
                stFlexuralTorsional: ng.fem_design.steel_output.StBarFlexuralTorsional | null = null;
                stBarTorsionalTop: ng.fem_design.steel_output.StBarTorsional | null = null;
                stBarTorsionalBottom: ng.fem_design.steel_output.StBarTorsional | null = null;
                stBarInteraction: ng.fem_design.steel_output.StBarInteraction | null = null;
                stBarInteraction2nd: ng.fem_design.steel_output.StBarInteraction2nd | null = null;
                stBarWeb: ng.fem_design.steel_output.StBarWeb | null = null;

                static fromObject(src_unknown: unknown): SectionDesignCalcRecord {
                    const dst = new SectionDesignCalcRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionDesignCalcRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionDesignCalcRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionDesignCalcRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.x !== undefined && src.x !== null) {
                        if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                            dst.x = AsNum(src.x);
                        }
                        else {
                            console.log('Expected x of SectionDesignCalcRecord to be a number but was ', typeof src.x, src.x)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        if (typeof src.rUtil === "number" || src.rUtil === 'NaN' || src.rUtil === 'Infinity' || src.rUtil === '-Infinity') {
                            dst.rUtil = AsNum(src.rUtil);
                        }
                        else {
                            console.log('Expected rUtil of SectionDesignCalcRecord to be a number but was ', typeof src.rUtil, src.rUtil)
                        }
                    }
                    if (src.idGmaxComb !== undefined && src.idGmaxComb !== null) {
                        if (typeof src.idGmaxComb === "number" || src.idGmaxComb === 'NaN' || src.idGmaxComb === 'Infinity' || src.idGmaxComb === '-Infinity') {
                            dst.idGmaxComb = NumberToInt("ng.fem_design.steel_output.SectionDesignCalcRecord.id_gmax_comb", AsNum(src.idGmaxComb));
                        }
                        else {
                            console.log('Expected idGmaxComb of SectionDesignCalcRecord to be a number but was ', typeof src.idGmaxComb, src.idGmaxComb)
                        }
                    }
                    if (src.rUtilV !== undefined && src.rUtilV !== null) {
                        dst.rUtilV = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtilV);
                    }
                    if (src.rUtilTau !== undefined && src.rUtilTau !== null) {
                        if (typeof src.rUtilTau === "number" || src.rUtilTau === 'NaN' || src.rUtilTau === 'Infinity' || src.rUtilTau === '-Infinity') {
                            dst.rUtilTau = AsNum(src.rUtilTau);
                        }
                        else {
                            console.log('Expected rUtilTau of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilTau, src.rUtilTau)
                        }
                    }
                    if (src.rUtilT !== undefined && src.rUtilT !== null) {
                        if (typeof src.rUtilT === "number" || src.rUtilT === 'NaN' || src.rUtilT === 'Infinity' || src.rUtilT === '-Infinity') {
                            dst.rUtilT = AsNum(src.rUtilT);
                        }
                        else {
                            console.log('Expected rUtilT of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilT, src.rUtilT)
                        }
                    }
                    if (src.rUtilN !== undefined && src.rUtilN !== null) {
                        if (typeof src.rUtilN === "number" || src.rUtilN === 'NaN' || src.rUtilN === 'Infinity' || src.rUtilN === '-Infinity') {
                            dst.rUtilN = AsNum(src.rUtilN);
                        }
                        else {
                            console.log('Expected rUtilN of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilN, src.rUtilN)
                        }
                    }
                    if (src.rUtilNorm !== undefined && src.rUtilNorm !== null) {
                        if (typeof src.rUtilNorm === "number" || src.rUtilNorm === 'NaN' || src.rUtilNorm === 'Infinity' || src.rUtilNorm === '-Infinity') {
                            dst.rUtilNorm = AsNum(src.rUtilNorm);
                        }
                        else {
                            console.log('Expected rUtilNorm of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilNorm, src.rUtilNorm)
                        }
                    }
                    if (src.rUtilSigma !== undefined && src.rUtilSigma !== null) {
                        if (typeof src.rUtilSigma === "number" || src.rUtilSigma === 'NaN' || src.rUtilSigma === 'Infinity' || src.rUtilSigma === '-Infinity') {
                            dst.rUtilSigma = AsNum(src.rUtilSigma);
                        }
                        else {
                            console.log('Expected rUtilSigma of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilSigma, src.rUtilSigma)
                        }
                    }
                    if (src.rUtilFB !== undefined && src.rUtilFB !== null) {
                        dst.rUtilFB = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtilFB);
                    }
                    if (src.rUtilFTB !== undefined && src.rUtilFTB !== null) {
                        if (typeof src.rUtilFTB === "number" || src.rUtilFTB === 'NaN' || src.rUtilFTB === 'Infinity' || src.rUtilFTB === '-Infinity') {
                            dst.rUtilFTB = AsNum(src.rUtilFTB);
                        }
                        else {
                            console.log('Expected rUtilFTB of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilFTB, src.rUtilFTB)
                        }
                    }
                    if (src.rUtilLTBTop !== undefined && src.rUtilLTBTop !== null) {
                        if (typeof src.rUtilLTBTop === "number" || src.rUtilLTBTop === 'NaN' || src.rUtilLTBTop === 'Infinity' || src.rUtilLTBTop === '-Infinity') {
                            dst.rUtilLTBTop = AsNum(src.rUtilLTBTop);
                        }
                        else {
                            console.log('Expected rUtilLTBTop of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilLTBTop, src.rUtilLTBTop)
                        }
                    }
                    if (src.rUtilLBTBottom !== undefined && src.rUtilLBTBottom !== null) {
                        if (typeof src.rUtilLBTBottom === "number" || src.rUtilLBTBottom === 'NaN' || src.rUtilLBTBottom === 'Infinity' || src.rUtilLBTBottom === '-Infinity') {
                            dst.rUtilLBTBottom = AsNum(src.rUtilLBTBottom);
                        }
                        else {
                            console.log('Expected rUtilLBTBottom of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilLBTBottom, src.rUtilLBTBottom)
                        }
                    }
                    if (src.rUtilShear !== undefined && src.rUtilShear !== null) {
                        if (typeof src.rUtilShear === "number" || src.rUtilShear === 'NaN' || src.rUtilShear === 'Infinity' || src.rUtilShear === '-Infinity') {
                            dst.rUtilShear = AsNum(src.rUtilShear);
                        }
                        else {
                            console.log('Expected rUtilShear of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilShear, src.rUtilShear)
                        }
                    }
                    if (src.rUtilIA !== undefined && src.rUtilIA !== null) {
                        dst.rUtilIA = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtilIA);
                    }
                    if (src.rUtilIA2nd !== undefined && src.rUtilIA2nd !== null) {
                        if (typeof src.rUtilIA2nd === "number" || src.rUtilIA2nd === 'NaN' || src.rUtilIA2nd === 'Infinity' || src.rUtilIA2nd === '-Infinity') {
                            dst.rUtilIA2nd = AsNum(src.rUtilIA2nd);
                        }
                        else {
                            console.log('Expected rUtilIA2nd of SectionDesignCalcRecord to be a number but was ', typeof src.rUtilIA2nd, src.rUtilIA2nd)
                        }
                    }
                    if (src.arIntForces !== undefined && src.arIntForces !== null) {
                        dst.arIntForces = ng.fem_design.analysis_data.Force.fromObject(src.arIntForces);
                    }
                    if (src.stEffectiveCS !== undefined && src.stEffectiveCS !== null) {
                        dst.stEffectiveCS = ng.fem_design.steel_output.StBarEffectiveCS.fromObject(src.stEffectiveCS);
                    }
                    if (src.stCSResist !== undefined && src.stCSResist !== null) {
                        dst.stCSResist = ng.fem_design.steel_output.StBarCSResist.fromObject(src.stCSResist);
                    }
                    if (src.stFlexural !== undefined && src.stFlexural !== null) {
                        dst.stFlexural = ng.fem_design.steel_output.StBarFlexural.fromObject(src.stFlexural);
                    }
                    if (src.stFlexuralTorsional !== undefined && src.stFlexuralTorsional !== null) {
                        dst.stFlexuralTorsional = ng.fem_design.steel_output.StBarFlexuralTorsional.fromObject(src.stFlexuralTorsional);
                    }
                    if (src.stBarTorsionalTop !== undefined && src.stBarTorsionalTop !== null) {
                        dst.stBarTorsionalTop = ng.fem_design.steel_output.StBarTorsional.fromObject(src.stBarTorsionalTop);
                    }
                    if (src.stBarTorsionalBottom !== undefined && src.stBarTorsionalBottom !== null) {
                        dst.stBarTorsionalBottom = ng.fem_design.steel_output.StBarTorsional.fromObject(src.stBarTorsionalBottom);
                    }
                    if (src.stBarInteraction !== undefined && src.stBarInteraction !== null) {
                        dst.stBarInteraction = ng.fem_design.steel_output.StBarInteraction.fromObject(src.stBarInteraction);
                    }
                    if (src.stBarInteraction2nd !== undefined && src.stBarInteraction2nd !== null) {
                        dst.stBarInteraction2nd = ng.fem_design.steel_output.StBarInteraction2nd.fromObject(src.stBarInteraction2nd);
                    }
                    if (src.stBarWeb !== undefined && src.stBarWeb !== null) {
                        dst.stBarWeb = ng.fem_design.steel_output.StBarWeb.fromObject(src.stBarWeb);
                    }
                    return dst;
                }

                static toObject(src: SectionDesignCalcRecord | null | undefined): SectionDesignCalcRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.SectionDesignCalcRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.SectionDesignCalcRecord") {
                        console.error('Expected ng.fem_design.steel_output.SectionDesignCalcRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionDesignCalcRecord_json = {
                        x: AsJsonNum(src.x),
                        rUtil: AsJsonNum(src.rUtil),
                        idGmaxComb: AsJsonNum(NumberToInt("ng.fem_design.steel_output.SectionDesignCalcRecord.id_gmax_comb", src.idGmaxComb)),
                        rUtilTau: AsJsonNum(src.rUtilTau),
                        rUtilT: AsJsonNum(src.rUtilT),
                        rUtilN: AsJsonNum(src.rUtilN),
                        rUtilNorm: AsJsonNum(src.rUtilNorm),
                        rUtilSigma: AsJsonNum(src.rUtilSigma),
                        rUtilFTB: AsJsonNum(src.rUtilFTB),
                        rUtilLTBTop: AsJsonNum(src.rUtilLTBTop),
                        rUtilLBTBottom: AsJsonNum(src.rUtilLBTBottom),
                        rUtilShear: AsJsonNum(src.rUtilShear),
                        rUtilIA2nd: AsJsonNum(src.rUtilIA2nd),
                    };
                    if(src.rUtilV !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtilV);
                        if(parsed === null) return null;
                        dst.rUtilV = parsed;
                    }
                    if(src.rUtilFB !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtilFB);
                        if(parsed === null) return null;
                        dst.rUtilFB = parsed;
                    }
                    if(src.rUtilIA !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtilIA);
                        if(parsed === null) return null;
                        dst.rUtilIA = parsed;
                    }
                    if(src.arIntForces !== null)
                    {
                        const parsed = ng.fem_design.analysis_data.Force.toObject(src.arIntForces);
                        if(parsed === null) return null;
                        dst.arIntForces = parsed;
                    }
                    if(src.stEffectiveCS !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarEffectiveCS.toObject(src.stEffectiveCS);
                        if(parsed === null) return null;
                        dst.stEffectiveCS = parsed;
                    }
                    if(src.stCSResist !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarCSResist.toObject(src.stCSResist);
                        if(parsed === null) return null;
                        dst.stCSResist = parsed;
                    }
                    if(src.stFlexural !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarFlexural.toObject(src.stFlexural);
                        if(parsed === null) return null;
                        dst.stFlexural = parsed;
                    }
                    if(src.stFlexuralTorsional !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarFlexuralTorsional.toObject(src.stFlexuralTorsional);
                        if(parsed === null) return null;
                        dst.stFlexuralTorsional = parsed;
                    }
                    if(src.stBarTorsionalTop !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarTorsional.toObject(src.stBarTorsionalTop);
                        if(parsed === null) return null;
                        dst.stBarTorsionalTop = parsed;
                    }
                    if(src.stBarTorsionalBottom !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarTorsional.toObject(src.stBarTorsionalBottom);
                        if(parsed === null) return null;
                        dst.stBarTorsionalBottom = parsed;
                    }
                    if(src.stBarInteraction !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarInteraction.toObject(src.stBarInteraction);
                        if(parsed === null) return null;
                        dst.stBarInteraction = parsed;
                    }
                    if(src.stBarInteraction2nd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarInteraction2nd.toObject(src.stBarInteraction2nd);
                        if(parsed === null) return null;
                        dst.stBarInteraction2nd = parsed;
                    }
                    if(src.stBarWeb !== null)
                    {
                        const parsed = ng.fem_design.steel_output.StBarWeb.toObject(src.stBarWeb);
                        if(parsed === null) return null;
                        dst.stBarWeb = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionDesignCalcRecord_createType) {
                    const dst = new SectionDesignCalcRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.x !== undefined) {
                        dst.x = src.x;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    if (src.idGmaxComb !== undefined) {
                        dst.idGmaxComb = src.idGmaxComb;
                    }
                    if (src.rUtilV !== undefined) {
                        dst.rUtilV = src.rUtilV;
                    }
                    if (src.rUtilTau !== undefined) {
                        dst.rUtilTau = src.rUtilTau;
                    }
                    if (src.rUtilT !== undefined) {
                        dst.rUtilT = src.rUtilT;
                    }
                    if (src.rUtilN !== undefined) {
                        dst.rUtilN = src.rUtilN;
                    }
                    if (src.rUtilNorm !== undefined) {
                        dst.rUtilNorm = src.rUtilNorm;
                    }
                    if (src.rUtilSigma !== undefined) {
                        dst.rUtilSigma = src.rUtilSigma;
                    }
                    if (src.rUtilFB !== undefined) {
                        dst.rUtilFB = src.rUtilFB;
                    }
                    if (src.rUtilFTB !== undefined) {
                        dst.rUtilFTB = src.rUtilFTB;
                    }
                    if (src.rUtilLTBTop !== undefined) {
                        dst.rUtilLTBTop = src.rUtilLTBTop;
                    }
                    if (src.rUtilLBTBottom !== undefined) {
                        dst.rUtilLBTBottom = src.rUtilLBTBottom;
                    }
                    if (src.rUtilShear !== undefined) {
                        dst.rUtilShear = src.rUtilShear;
                    }
                    if (src.rUtilIA !== undefined) {
                        dst.rUtilIA = src.rUtilIA;
                    }
                    if (src.rUtilIA2nd !== undefined) {
                        dst.rUtilIA2nd = src.rUtilIA2nd;
                    }
                    if (src.arIntForces !== undefined) {
                        dst.arIntForces = src.arIntForces;
                    }
                    if (src.stEffectiveCS !== undefined) {
                        dst.stEffectiveCS = src.stEffectiveCS;
                    }
                    if (src.stCSResist !== undefined) {
                        dst.stCSResist = src.stCSResist;
                    }
                    if (src.stFlexural !== undefined) {
                        dst.stFlexural = src.stFlexural;
                    }
                    if (src.stFlexuralTorsional !== undefined) {
                        dst.stFlexuralTorsional = src.stFlexuralTorsional;
                    }
                    if (src.stBarTorsionalTop !== undefined) {
                        dst.stBarTorsionalTop = src.stBarTorsionalTop;
                    }
                    if (src.stBarTorsionalBottom !== undefined) {
                        dst.stBarTorsionalBottom = src.stBarTorsionalBottom;
                    }
                    if (src.stBarInteraction !== undefined) {
                        dst.stBarInteraction = src.stBarInteraction;
                    }
                    if (src.stBarInteraction2nd !== undefined) {
                        dst.stBarInteraction2nd = src.stBarInteraction2nd;
                    }
                    if (src.stBarWeb !== undefined) {
                        dst.stBarWeb = src.stBarWeb;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionDesignCalcRecord();
                    dst.x = this.x;
                    dst.rUtil = this.rUtil;
                    dst.idGmaxComb = this.idGmaxComb;
                    dst.rUtilV = this.rUtilV;
                    dst.rUtilTau = this.rUtilTau;
                    dst.rUtilT = this.rUtilT;
                    dst.rUtilN = this.rUtilN;
                    dst.rUtilNorm = this.rUtilNorm;
                    dst.rUtilSigma = this.rUtilSigma;
                    dst.rUtilFB = this.rUtilFB;
                    dst.rUtilFTB = this.rUtilFTB;
                    dst.rUtilLTBTop = this.rUtilLTBTop;
                    dst.rUtilLBTBottom = this.rUtilLBTBottom;
                    dst.rUtilShear = this.rUtilShear;
                    dst.rUtilIA = this.rUtilIA;
                    dst.rUtilIA2nd = this.rUtilIA2nd;
                    dst.arIntForces = this.arIntForces;
                    dst.stEffectiveCS = this.stEffectiveCS;
                    dst.stCSResist = this.stCSResist;
                    dst.stFlexural = this.stFlexural;
                    dst.stFlexuralTorsional = this.stFlexuralTorsional;
                    dst.stBarTorsionalTop = this.stBarTorsionalTop;
                    dst.stBarTorsionalBottom = this.stBarTorsionalBottom;
                    dst.stBarInteraction = this.stBarInteraction;
                    dst.stBarInteraction2nd = this.stBarInteraction2nd;
                    dst.stBarWeb = this.stBarWeb;
                    return dst;
                }

                deepClone() {
                    const json = SectionDesignCalcRecord.toObject(this);
                    const dst = SectionDesignCalcRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionDesignCalcRecord = SectionDesignCalcRecord;


            export type PointStress_keys = 'tauYy' | 'tauYz' | 'tauZy' | 'tauZz' | 'tauXy' | 'tauXz' | 'sZigmaYx' | 'sZigmaZx';
            export interface PointStress_createType {
                tauYy?: number,
                tauYz?: number,
                tauZy?: number,
                tauZz?: number,
                tauXy?: number,
                tauXz?: number,
                sZigmaYx?: number,
                sZigmaZx?: number,
            }
            export interface PointStress_json {
                tauYy?: JsonNumber;
                tauYz?: JsonNumber;
                tauZy?: JsonNumber;
                tauZz?: JsonNumber;
                tauXy?: JsonNumber;
                tauXz?: JsonNumber;
                sZigmaYx?: JsonNumber;
                sZigmaZx?: JsonNumber;
            }
            interface PointStress_json_in {
                __proto_name?: unknown;
                tauYy?: unknown;
                tauYz?: unknown;
                tauZy?: unknown;
                tauZz?: unknown;
                tauXy?: unknown;
                tauXz?: unknown;
                sZigmaYx?: unknown;
                sZigmaZx?: unknown;
            }
            export class PointStress {
                __proto_name = "ng.fem_design.steel_output.PointStress";
                tauYy: number = 0;
                tauYz: number = 0;
                tauZy: number = 0;
                tauZz: number = 0;
                tauXy: number = 0;
                tauXz: number = 0;
                sZigmaYx: number = 0;
                sZigmaZx: number = 0;

                static fromObject(src_unknown: unknown): PointStress {
                    const dst = new PointStress();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted PointStress but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as PointStress_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for PointStress but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.tauYy !== undefined && src.tauYy !== null) {
                        if (typeof src.tauYy === "number" || src.tauYy === 'NaN' || src.tauYy === 'Infinity' || src.tauYy === '-Infinity') {
                            dst.tauYy = AsNum(src.tauYy);
                        }
                        else {
                            console.log('Expected tauYy of PointStress to be a number but was ', typeof src.tauYy, src.tauYy)
                        }
                    }
                    if (src.tauYz !== undefined && src.tauYz !== null) {
                        if (typeof src.tauYz === "number" || src.tauYz === 'NaN' || src.tauYz === 'Infinity' || src.tauYz === '-Infinity') {
                            dst.tauYz = AsNum(src.tauYz);
                        }
                        else {
                            console.log('Expected tauYz of PointStress to be a number but was ', typeof src.tauYz, src.tauYz)
                        }
                    }
                    if (src.tauZy !== undefined && src.tauZy !== null) {
                        if (typeof src.tauZy === "number" || src.tauZy === 'NaN' || src.tauZy === 'Infinity' || src.tauZy === '-Infinity') {
                            dst.tauZy = AsNum(src.tauZy);
                        }
                        else {
                            console.log('Expected tauZy of PointStress to be a number but was ', typeof src.tauZy, src.tauZy)
                        }
                    }
                    if (src.tauZz !== undefined && src.tauZz !== null) {
                        if (typeof src.tauZz === "number" || src.tauZz === 'NaN' || src.tauZz === 'Infinity' || src.tauZz === '-Infinity') {
                            dst.tauZz = AsNum(src.tauZz);
                        }
                        else {
                            console.log('Expected tauZz of PointStress to be a number but was ', typeof src.tauZz, src.tauZz)
                        }
                    }
                    if (src.tauXy !== undefined && src.tauXy !== null) {
                        if (typeof src.tauXy === "number" || src.tauXy === 'NaN' || src.tauXy === 'Infinity' || src.tauXy === '-Infinity') {
                            dst.tauXy = AsNum(src.tauXy);
                        }
                        else {
                            console.log('Expected tauXy of PointStress to be a number but was ', typeof src.tauXy, src.tauXy)
                        }
                    }
                    if (src.tauXz !== undefined && src.tauXz !== null) {
                        if (typeof src.tauXz === "number" || src.tauXz === 'NaN' || src.tauXz === 'Infinity' || src.tauXz === '-Infinity') {
                            dst.tauXz = AsNum(src.tauXz);
                        }
                        else {
                            console.log('Expected tauXz of PointStress to be a number but was ', typeof src.tauXz, src.tauXz)
                        }
                    }
                    if (src.sZigmaYx !== undefined && src.sZigmaYx !== null) {
                        if (typeof src.sZigmaYx === "number" || src.sZigmaYx === 'NaN' || src.sZigmaYx === 'Infinity' || src.sZigmaYx === '-Infinity') {
                            dst.sZigmaYx = AsNum(src.sZigmaYx);
                        }
                        else {
                            console.log('Expected sZigmaYx of PointStress to be a number but was ', typeof src.sZigmaYx, src.sZigmaYx)
                        }
                    }
                    if (src.sZigmaZx !== undefined && src.sZigmaZx !== null) {
                        if (typeof src.sZigmaZx === "number" || src.sZigmaZx === 'NaN' || src.sZigmaZx === 'Infinity' || src.sZigmaZx === '-Infinity') {
                            dst.sZigmaZx = AsNum(src.sZigmaZx);
                        }
                        else {
                            console.log('Expected sZigmaZx of PointStress to be a number but was ', typeof src.sZigmaZx, src.sZigmaZx)
                        }
                    }
                    return dst;
                }

                static toObject(src: PointStress | null | undefined): PointStress_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.PointStress is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.PointStress") {
                        console.error('Expected ng.fem_design.steel_output.PointStress but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : PointStress_json = {
                        tauYy: AsJsonNum(src.tauYy),
                        tauYz: AsJsonNum(src.tauYz),
                        tauZy: AsJsonNum(src.tauZy),
                        tauZz: AsJsonNum(src.tauZz),
                        tauXy: AsJsonNum(src.tauXy),
                        tauXz: AsJsonNum(src.tauXz),
                        sZigmaYx: AsJsonNum(src.sZigmaYx),
                        sZigmaZx: AsJsonNum(src.sZigmaZx),
                    };
                    return dst;
                }

                static create(src?: PointStress_createType) {
                    const dst = new PointStress();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.tauYy !== undefined) {
                        dst.tauYy = src.tauYy;
                    }
                    if (src.tauYz !== undefined) {
                        dst.tauYz = src.tauYz;
                    }
                    if (src.tauZy !== undefined) {
                        dst.tauZy = src.tauZy;
                    }
                    if (src.tauZz !== undefined) {
                        dst.tauZz = src.tauZz;
                    }
                    if (src.tauXy !== undefined) {
                        dst.tauXy = src.tauXy;
                    }
                    if (src.tauXz !== undefined) {
                        dst.tauXz = src.tauXz;
                    }
                    if (src.sZigmaYx !== undefined) {
                        dst.sZigmaYx = src.sZigmaYx;
                    }
                    if (src.sZigmaZx !== undefined) {
                        dst.sZigmaZx = src.sZigmaZx;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new PointStress();
                    dst.tauYy = this.tauYy;
                    dst.tauYz = this.tauYz;
                    dst.tauZy = this.tauZy;
                    dst.tauZz = this.tauZz;
                    dst.tauXy = this.tauXy;
                    dst.tauXz = this.tauXz;
                    dst.sZigmaYx = this.sZigmaYx;
                    dst.sZigmaZx = this.sZigmaZx;
                    return dst;
                }

                deepClone() {
                    const json = PointStress.toObject(this);
                    const dst = PointStress.fromObject(json);
                    return dst;
                }
            }
            export type IPointStress = PointStress;


            export type StBarEffectiveCS_keys = 'fCalculated' | 'rAEff' | 'rlEff' | 'reN' | 'rWEffC' | 'rWEffT';
            export interface StBarEffectiveCS_createType {
                fCalculated?: boolean,
                rAEff?: number,
                rlEff?: ng.fem_design.steel_output.Vector2D | null,
                reN?: ng.fem_design.steel_output.Vector2D | null,
                rWEffC?: ng.fem_design.steel_output.Vector2D | null,
                rWEffT?: ng.fem_design.steel_output.Vector2D | null,
            }
            export interface StBarEffectiveCS_json {
                fCalculated?: boolean;
                rAEff?: JsonNumber;
                rlEff?: ng.fem_design.steel_output.Vector2D_json;
                reN?: ng.fem_design.steel_output.Vector2D_json;
                rWEffC?: ng.fem_design.steel_output.Vector2D_json;
                rWEffT?: ng.fem_design.steel_output.Vector2D_json;
            }
            interface StBarEffectiveCS_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                rAEff?: unknown;
                rlEff?: unknown;
                reN?: unknown;
                rWEffC?: unknown;
                rWEffT?: unknown;
            }
            export class StBarEffectiveCS {
                __proto_name = "ng.fem_design.steel_output.StBarEffectiveCS";
                fCalculated: boolean = false;
                rAEff: number = 0;
                rlEff: ng.fem_design.steel_output.Vector2D | null = null;
                reN: ng.fem_design.steel_output.Vector2D | null = null;
                rWEffC: ng.fem_design.steel_output.Vector2D | null = null;
                rWEffT: ng.fem_design.steel_output.Vector2D | null = null;

                static fromObject(src_unknown: unknown): StBarEffectiveCS {
                    const dst = new StBarEffectiveCS();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarEffectiveCS but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarEffectiveCS_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarEffectiveCS but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarEffectiveCS to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.rAEff !== undefined && src.rAEff !== null) {
                        if (typeof src.rAEff === "number" || src.rAEff === 'NaN' || src.rAEff === 'Infinity' || src.rAEff === '-Infinity') {
                            dst.rAEff = AsNum(src.rAEff);
                        }
                        else {
                            console.log('Expected rAEff of StBarEffectiveCS to be a number but was ', typeof src.rAEff, src.rAEff)
                        }
                    }
                    if (src.rlEff !== undefined && src.rlEff !== null) {
                        dst.rlEff = ng.fem_design.steel_output.Vector2D.fromObject(src.rlEff);
                    }
                    if (src.reN !== undefined && src.reN !== null) {
                        dst.reN = ng.fem_design.steel_output.Vector2D.fromObject(src.reN);
                    }
                    if (src.rWEffC !== undefined && src.rWEffC !== null) {
                        dst.rWEffC = ng.fem_design.steel_output.Vector2D.fromObject(src.rWEffC);
                    }
                    if (src.rWEffT !== undefined && src.rWEffT !== null) {
                        dst.rWEffT = ng.fem_design.steel_output.Vector2D.fromObject(src.rWEffT);
                    }
                    return dst;
                }

                static toObject(src: StBarEffectiveCS | null | undefined): StBarEffectiveCS_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarEffectiveCS is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarEffectiveCS") {
                        console.error('Expected ng.fem_design.steel_output.StBarEffectiveCS but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : StBarEffectiveCS_json = {
                        fCalculated: src.fCalculated,
                        rAEff: AsJsonNum(src.rAEff),
                    };
                    if(src.rlEff !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rlEff);
                        if(parsed === null) return null;
                        dst.rlEff = parsed;
                    }
                    if(src.reN !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.reN);
                        if(parsed === null) return null;
                        dst.reN = parsed;
                    }
                    if(src.rWEffC !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rWEffC);
                        if(parsed === null) return null;
                        dst.rWEffC = parsed;
                    }
                    if(src.rWEffT !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rWEffT);
                        if(parsed === null) return null;
                        dst.rWEffT = parsed;
                    }
                    return dst;
                }

                static create(src?: StBarEffectiveCS_createType) {
                    const dst = new StBarEffectiveCS();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.rAEff !== undefined) {
                        dst.rAEff = src.rAEff;
                    }
                    if (src.rlEff !== undefined) {
                        dst.rlEff = src.rlEff;
                    }
                    if (src.reN !== undefined) {
                        dst.reN = src.reN;
                    }
                    if (src.rWEffC !== undefined) {
                        dst.rWEffC = src.rWEffC;
                    }
                    if (src.rWEffT !== undefined) {
                        dst.rWEffT = src.rWEffT;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarEffectiveCS();
                    dst.fCalculated = this.fCalculated;
                    dst.rAEff = this.rAEff;
                    dst.rlEff = this.rlEff;
                    dst.reN = this.reN;
                    dst.rWEffC = this.rWEffC;
                    dst.rWEffT = this.rWEffT;
                    return dst;
                }

                deepClone() {
                    const json = StBarEffectiveCS.toObject(this);
                    const dst = StBarEffectiveCS.fromObject(json);
                    return dst;
                }
            }
            export type IStBarEffectiveCS = StBarEffectiveCS;


            export type StBarCSResist_keys = 'fCalculated' | 'rUtilV' | 'rUtilTau' | 'rUtilT' | 'rUtilN' | 'rUtilNorm' | 'tau' | 'fV' | 'fSigma' | 'rVEd' | 'rTEd' | 'rVPlTRd' | 'rVPlRd' | 'rTRd' | 'rtauTEd' | 'rtauWEd' | 'rAV' | 'shape' | 'rTauEd' | 'rTauRd' | 'rNEd' | 'rMEd' | 'rMPlRd' | 'rNRd' | 'rMRd' | 'rRho' | 'rSigmaXEd' | 'rTauSEd' | 'fUse641' | 'nPlRd' | 'nPlVRd' | 'nWPlRd' | 'fMNRdReduced' | 'mNRd' | 'alpha' | 'beta' | 'rVPlTRdFi' | 'rVPlRdFi' | 'rTRdFi' | 'rtauRdFi' | 'rNRdFi' | 'rMRdFi';
            export interface StBarCSResist_createType {
                fCalculated?: boolean,
                rUtilV?: ng.fem_design.steel_output.Vector2D | null,
                rUtilTau?: number,
                rUtilT?: number,
                rUtilN?: number,
                rUtilNorm?: number,
                tau?: ng.fem_design.steel_output.ShearStressCheckRelevant,
                fV?: ng.fem_design.steel_output.Boolean2D | null,
                fSigma?: boolean,
                rVEd?: ng.fem_design.steel_output.Vector2D | null,
                rTEd?: number,
                rVPlTRd?: ng.fem_design.steel_output.Vector2D | null,
                rVPlRd?: ng.fem_design.steel_output.Vector2D | null,
                rTRd?: number,
                rtauTEd?: number,
                rtauWEd?: number,
                rAV?: ng.fem_design.steel_output.Vector2D | null,
                shape?: ng.fem_design.steel_output.ShearResistanceEnum,
                rTauEd?: number,
                rTauRd?: number,
                rNEd?: number,
                rMEd?: ng.fem_design.steel_output.Vector2D | null,
                rMPlRd?: ng.fem_design.steel_output.Vector2D | null,
                rNRd?: number,
                rMRd?: ng.fem_design.steel_output.Vector2D | null,
                rRho?: ng.fem_design.steel_output.Vector2D | null,
                rSigmaXEd?: number,
                rTauSEd?: number,
                fUse641?: boolean,
                nPlRd?: number,
                nPlVRd?: number,
                nWPlRd?: number,
                fMNRdReduced?: ng.fem_design.steel_output.BooleanYZ | null,
                mNRd?: ng.fem_design.steel_output.Vector2D | null,
                alpha?: number,
                beta?: number,
                rVPlTRdFi?: ng.fem_design.steel_output.Vector2D | null,
                rVPlRdFi?: ng.fem_design.steel_output.Vector2D | null,
                rTRdFi?: number,
                rtauRdFi?: number,
                rNRdFi?: number,
                rMRdFi?: ng.fem_design.steel_output.Vector2D | null,
            }
            export interface StBarCSResist_json {
                fCalculated?: boolean;
                rUtilV?: ng.fem_design.steel_output.Vector2D_json;
                rUtilTau?: JsonNumber;
                rUtilT?: JsonNumber;
                rUtilN?: JsonNumber;
                rUtilNorm?: JsonNumber;
                tau?: string;
                fV?: ng.fem_design.steel_output.Boolean2D_json;
                fSigma?: boolean;
                rVEd?: ng.fem_design.steel_output.Vector2D_json;
                rTEd?: JsonNumber;
                rVPlTRd?: ng.fem_design.steel_output.Vector2D_json;
                rVPlRd?: ng.fem_design.steel_output.Vector2D_json;
                rTRd?: JsonNumber;
                rtauTEd?: JsonNumber;
                rtauWEd?: JsonNumber;
                rAV?: ng.fem_design.steel_output.Vector2D_json;
                shape?: string;
                rTauEd?: JsonNumber;
                rTauRd?: JsonNumber;
                rNEd?: JsonNumber;
                rMEd?: ng.fem_design.steel_output.Vector2D_json;
                rMPlRd?: ng.fem_design.steel_output.Vector2D_json;
                rNRd?: JsonNumber;
                rMRd?: ng.fem_design.steel_output.Vector2D_json;
                rRho?: ng.fem_design.steel_output.Vector2D_json;
                rSigmaXEd?: JsonNumber;
                rTauSEd?: JsonNumber;
                fUse641?: boolean;
                nPlRd?: JsonNumber;
                nPlVRd?: JsonNumber;
                nWPlRd?: JsonNumber;
                fMNRdReduced?: ng.fem_design.steel_output.BooleanYZ_json;
                mNRd?: ng.fem_design.steel_output.Vector2D_json;
                alpha?: JsonNumber;
                beta?: JsonNumber;
                rVPlTRdFi?: ng.fem_design.steel_output.Vector2D_json;
                rVPlRdFi?: ng.fem_design.steel_output.Vector2D_json;
                rTRdFi?: JsonNumber;
                rtauRdFi?: JsonNumber;
                rNRdFi?: JsonNumber;
                rMRdFi?: ng.fem_design.steel_output.Vector2D_json;
            }
            interface StBarCSResist_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                rUtilV?: unknown;
                rUtilTau?: unknown;
                rUtilT?: unknown;
                rUtilN?: unknown;
                rUtilNorm?: unknown;
                tau?: unknown;
                fV?: unknown;
                fSigma?: unknown;
                rVEd?: unknown;
                rTEd?: unknown;
                rVPlTRd?: unknown;
                rVPlRd?: unknown;
                rTRd?: unknown;
                rtauTEd?: unknown;
                rtauWEd?: unknown;
                rAV?: unknown;
                shape?: unknown;
                rTauEd?: unknown;
                rTauRd?: unknown;
                rNEd?: unknown;
                rMEd?: unknown;
                rMPlRd?: unknown;
                rNRd?: unknown;
                rMRd?: unknown;
                rRho?: unknown;
                rSigmaXEd?: unknown;
                rTauSEd?: unknown;
                fUse641?: unknown;
                nPlRd?: unknown;
                nPlVRd?: unknown;
                nWPlRd?: unknown;
                fMNRdReduced?: unknown;
                mNRd?: unknown;
                alpha?: unknown;
                beta?: unknown;
                rVPlTRdFi?: unknown;
                rVPlRdFi?: unknown;
                rTRdFi?: unknown;
                rtauRdFi?: unknown;
                rNRdFi?: unknown;
                rMRdFi?: unknown;
            }
            export class StBarCSResist {
                __proto_name = "ng.fem_design.steel_output.StBarCSResist";
                fCalculated: boolean = false;
                rUtilV: ng.fem_design.steel_output.Vector2D | null = null;
                rUtilTau: number = 0;
                rUtilT: number = 0;
                rUtilN: number = 0;
                rUtilNorm: number = 0;
                tau: ng.fem_design.steel_output.ShearStressCheckRelevant = ng.fem_design.steel_output.ShearStressCheckRelevant.SHEAR_STRESS_CHECK_RELEVANT_NO;
                fV: ng.fem_design.steel_output.Boolean2D | null = null;
                fSigma: boolean = false;
                rVEd: ng.fem_design.steel_output.Vector2D | null = null;
                rTEd: number = 0;
                rVPlTRd: ng.fem_design.steel_output.Vector2D | null = null;
                rVPlRd: ng.fem_design.steel_output.Vector2D | null = null;
                rTRd: number = 0;
                rtauTEd: number = 0;
                rtauWEd: number = 0;
                rAV: ng.fem_design.steel_output.Vector2D | null = null;
                shape: ng.fem_design.steel_output.ShearResistanceEnum = ng.fem_design.steel_output.ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED;
                rTauEd: number = 0;
                rTauRd: number = 0;
                rNEd: number = 0;
                rMEd: ng.fem_design.steel_output.Vector2D | null = null;
                rMPlRd: ng.fem_design.steel_output.Vector2D | null = null;
                rNRd: number = 0;
                rMRd: ng.fem_design.steel_output.Vector2D | null = null;
                rRho: ng.fem_design.steel_output.Vector2D | null = null;
                rSigmaXEd: number = 0;
                rTauSEd: number = 0;
                fUse641: boolean = false;
                nPlRd: number = 0;
                nPlVRd: number = 0;
                nWPlRd: number = 0;
                fMNRdReduced: ng.fem_design.steel_output.BooleanYZ | null = null;
                mNRd: ng.fem_design.steel_output.Vector2D | null = null;
                alpha: number = 0;
                beta: number = 0;
                rVPlTRdFi: ng.fem_design.steel_output.Vector2D | null = null;
                rVPlRdFi: ng.fem_design.steel_output.Vector2D | null = null;
                rTRdFi: number = 0;
                rtauRdFi: number = 0;
                rNRdFi: number = 0;
                rMRdFi: ng.fem_design.steel_output.Vector2D | null = null;

                static fromObject(src_unknown: unknown): StBarCSResist {
                    const dst = new StBarCSResist();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarCSResist but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarCSResist_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarCSResist but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarCSResist to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.rUtilV !== undefined && src.rUtilV !== null) {
                        dst.rUtilV = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtilV);
                    }
                    if (src.rUtilTau !== undefined && src.rUtilTau !== null) {
                        if (typeof src.rUtilTau === "number" || src.rUtilTau === 'NaN' || src.rUtilTau === 'Infinity' || src.rUtilTau === '-Infinity') {
                            dst.rUtilTau = AsNum(src.rUtilTau);
                        }
                        else {
                            console.log('Expected rUtilTau of StBarCSResist to be a number but was ', typeof src.rUtilTau, src.rUtilTau)
                        }
                    }
                    if (src.rUtilT !== undefined && src.rUtilT !== null) {
                        if (typeof src.rUtilT === "number" || src.rUtilT === 'NaN' || src.rUtilT === 'Infinity' || src.rUtilT === '-Infinity') {
                            dst.rUtilT = AsNum(src.rUtilT);
                        }
                        else {
                            console.log('Expected rUtilT of StBarCSResist to be a number but was ', typeof src.rUtilT, src.rUtilT)
                        }
                    }
                    if (src.rUtilN !== undefined && src.rUtilN !== null) {
                        if (typeof src.rUtilN === "number" || src.rUtilN === 'NaN' || src.rUtilN === 'Infinity' || src.rUtilN === '-Infinity') {
                            dst.rUtilN = AsNum(src.rUtilN);
                        }
                        else {
                            console.log('Expected rUtilN of StBarCSResist to be a number but was ', typeof src.rUtilN, src.rUtilN)
                        }
                    }
                    if (src.rUtilNorm !== undefined && src.rUtilNorm !== null) {
                        if (typeof src.rUtilNorm === "number" || src.rUtilNorm === 'NaN' || src.rUtilNorm === 'Infinity' || src.rUtilNorm === '-Infinity') {
                            dst.rUtilNorm = AsNum(src.rUtilNorm);
                        }
                        else {
                            console.log('Expected rUtilNorm of StBarCSResist to be a number but was ', typeof src.rUtilNorm, src.rUtilNorm)
                        }
                    }
                    if (src.tau !== undefined && src.tau !== null) {
                        dst.tau = ng.fem_design.steel_output.ShearStressCheckRelevant_FromObject(src.tau);
                    }
                    if (src.fV !== undefined && src.fV !== null) {
                        dst.fV = ng.fem_design.steel_output.Boolean2D.fromObject(src.fV);
                    }
                    if (src.fSigma !== undefined && src.fSigma !== null) {
                        if (typeof src.fSigma === "boolean") {
                            dst.fSigma = src.fSigma;
                        }
                        else {
                            console.log('Expected fSigma of StBarCSResist to be a boolean but was ', typeof src.fSigma, src.fSigma)
                        }
                    }
                    if (src.rVEd !== undefined && src.rVEd !== null) {
                        dst.rVEd = ng.fem_design.steel_output.Vector2D.fromObject(src.rVEd);
                    }
                    if (src.rTEd !== undefined && src.rTEd !== null) {
                        if (typeof src.rTEd === "number" || src.rTEd === 'NaN' || src.rTEd === 'Infinity' || src.rTEd === '-Infinity') {
                            dst.rTEd = AsNum(src.rTEd);
                        }
                        else {
                            console.log('Expected rTEd of StBarCSResist to be a number but was ', typeof src.rTEd, src.rTEd)
                        }
                    }
                    if (src.rVPlTRd !== undefined && src.rVPlTRd !== null) {
                        dst.rVPlTRd = ng.fem_design.steel_output.Vector2D.fromObject(src.rVPlTRd);
                    }
                    if (src.rVPlRd !== undefined && src.rVPlRd !== null) {
                        dst.rVPlRd = ng.fem_design.steel_output.Vector2D.fromObject(src.rVPlRd);
                    }
                    if (src.rTRd !== undefined && src.rTRd !== null) {
                        if (typeof src.rTRd === "number" || src.rTRd === 'NaN' || src.rTRd === 'Infinity' || src.rTRd === '-Infinity') {
                            dst.rTRd = AsNum(src.rTRd);
                        }
                        else {
                            console.log('Expected rTRd of StBarCSResist to be a number but was ', typeof src.rTRd, src.rTRd)
                        }
                    }
                    if (src.rtauTEd !== undefined && src.rtauTEd !== null) {
                        if (typeof src.rtauTEd === "number" || src.rtauTEd === 'NaN' || src.rtauTEd === 'Infinity' || src.rtauTEd === '-Infinity') {
                            dst.rtauTEd = AsNum(src.rtauTEd);
                        }
                        else {
                            console.log('Expected rtauTEd of StBarCSResist to be a number but was ', typeof src.rtauTEd, src.rtauTEd)
                        }
                    }
                    if (src.rtauWEd !== undefined && src.rtauWEd !== null) {
                        if (typeof src.rtauWEd === "number" || src.rtauWEd === 'NaN' || src.rtauWEd === 'Infinity' || src.rtauWEd === '-Infinity') {
                            dst.rtauWEd = AsNum(src.rtauWEd);
                        }
                        else {
                            console.log('Expected rtauWEd of StBarCSResist to be a number but was ', typeof src.rtauWEd, src.rtauWEd)
                        }
                    }
                    if (src.rAV !== undefined && src.rAV !== null) {
                        dst.rAV = ng.fem_design.steel_output.Vector2D.fromObject(src.rAV);
                    }
                    if (src.shape !== undefined && src.shape !== null) {
                        dst.shape = ng.fem_design.steel_output.ShearResistanceEnum_FromObject(src.shape);
                    }
                    if (src.rTauEd !== undefined && src.rTauEd !== null) {
                        if (typeof src.rTauEd === "number" || src.rTauEd === 'NaN' || src.rTauEd === 'Infinity' || src.rTauEd === '-Infinity') {
                            dst.rTauEd = AsNum(src.rTauEd);
                        }
                        else {
                            console.log('Expected rTauEd of StBarCSResist to be a number but was ', typeof src.rTauEd, src.rTauEd)
                        }
                    }
                    if (src.rTauRd !== undefined && src.rTauRd !== null) {
                        if (typeof src.rTauRd === "number" || src.rTauRd === 'NaN' || src.rTauRd === 'Infinity' || src.rTauRd === '-Infinity') {
                            dst.rTauRd = AsNum(src.rTauRd);
                        }
                        else {
                            console.log('Expected rTauRd of StBarCSResist to be a number but was ', typeof src.rTauRd, src.rTauRd)
                        }
                    }
                    if (src.rNEd !== undefined && src.rNEd !== null) {
                        if (typeof src.rNEd === "number" || src.rNEd === 'NaN' || src.rNEd === 'Infinity' || src.rNEd === '-Infinity') {
                            dst.rNEd = AsNum(src.rNEd);
                        }
                        else {
                            console.log('Expected rNEd of StBarCSResist to be a number but was ', typeof src.rNEd, src.rNEd)
                        }
                    }
                    if (src.rMEd !== undefined && src.rMEd !== null) {
                        dst.rMEd = ng.fem_design.steel_output.Vector2D.fromObject(src.rMEd);
                    }
                    if (src.rMPlRd !== undefined && src.rMPlRd !== null) {
                        dst.rMPlRd = ng.fem_design.steel_output.Vector2D.fromObject(src.rMPlRd);
                    }
                    if (src.rNRd !== undefined && src.rNRd !== null) {
                        if (typeof src.rNRd === "number" || src.rNRd === 'NaN' || src.rNRd === 'Infinity' || src.rNRd === '-Infinity') {
                            dst.rNRd = AsNum(src.rNRd);
                        }
                        else {
                            console.log('Expected rNRd of StBarCSResist to be a number but was ', typeof src.rNRd, src.rNRd)
                        }
                    }
                    if (src.rMRd !== undefined && src.rMRd !== null) {
                        dst.rMRd = ng.fem_design.steel_output.Vector2D.fromObject(src.rMRd);
                    }
                    if (src.rRho !== undefined && src.rRho !== null) {
                        dst.rRho = ng.fem_design.steel_output.Vector2D.fromObject(src.rRho);
                    }
                    if (src.rSigmaXEd !== undefined && src.rSigmaXEd !== null) {
                        if (typeof src.rSigmaXEd === "number" || src.rSigmaXEd === 'NaN' || src.rSigmaXEd === 'Infinity' || src.rSigmaXEd === '-Infinity') {
                            dst.rSigmaXEd = AsNum(src.rSigmaXEd);
                        }
                        else {
                            console.log('Expected rSigmaXEd of StBarCSResist to be a number but was ', typeof src.rSigmaXEd, src.rSigmaXEd)
                        }
                    }
                    if (src.rTauSEd !== undefined && src.rTauSEd !== null) {
                        if (typeof src.rTauSEd === "number" || src.rTauSEd === 'NaN' || src.rTauSEd === 'Infinity' || src.rTauSEd === '-Infinity') {
                            dst.rTauSEd = AsNum(src.rTauSEd);
                        }
                        else {
                            console.log('Expected rTauSEd of StBarCSResist to be a number but was ', typeof src.rTauSEd, src.rTauSEd)
                        }
                    }
                    if (src.fUse641 !== undefined && src.fUse641 !== null) {
                        if (typeof src.fUse641 === "boolean") {
                            dst.fUse641 = src.fUse641;
                        }
                        else {
                            console.log('Expected fUse641 of StBarCSResist to be a boolean but was ', typeof src.fUse641, src.fUse641)
                        }
                    }
                    if (src.nPlRd !== undefined && src.nPlRd !== null) {
                        if (typeof src.nPlRd === "number" || src.nPlRd === 'NaN' || src.nPlRd === 'Infinity' || src.nPlRd === '-Infinity') {
                            dst.nPlRd = AsNum(src.nPlRd);
                        }
                        else {
                            console.log('Expected nPlRd of StBarCSResist to be a number but was ', typeof src.nPlRd, src.nPlRd)
                        }
                    }
                    if (src.nPlVRd !== undefined && src.nPlVRd !== null) {
                        if (typeof src.nPlVRd === "number" || src.nPlVRd === 'NaN' || src.nPlVRd === 'Infinity' || src.nPlVRd === '-Infinity') {
                            dst.nPlVRd = AsNum(src.nPlVRd);
                        }
                        else {
                            console.log('Expected nPlVRd of StBarCSResist to be a number but was ', typeof src.nPlVRd, src.nPlVRd)
                        }
                    }
                    if (src.nWPlRd !== undefined && src.nWPlRd !== null) {
                        if (typeof src.nWPlRd === "number" || src.nWPlRd === 'NaN' || src.nWPlRd === 'Infinity' || src.nWPlRd === '-Infinity') {
                            dst.nWPlRd = AsNum(src.nWPlRd);
                        }
                        else {
                            console.log('Expected nWPlRd of StBarCSResist to be a number but was ', typeof src.nWPlRd, src.nWPlRd)
                        }
                    }
                    if (src.fMNRdReduced !== undefined && src.fMNRdReduced !== null) {
                        dst.fMNRdReduced = ng.fem_design.steel_output.BooleanYZ.fromObject(src.fMNRdReduced);
                    }
                    if (src.mNRd !== undefined && src.mNRd !== null) {
                        dst.mNRd = ng.fem_design.steel_output.Vector2D.fromObject(src.mNRd);
                    }
                    if (src.alpha !== undefined && src.alpha !== null) {
                        if (typeof src.alpha === "number" || src.alpha === 'NaN' || src.alpha === 'Infinity' || src.alpha === '-Infinity') {
                            dst.alpha = AsNum(src.alpha);
                        }
                        else {
                            console.log('Expected alpha of StBarCSResist to be a number but was ', typeof src.alpha, src.alpha)
                        }
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                            dst.beta = AsNum(src.beta);
                        }
                        else {
                            console.log('Expected beta of StBarCSResist to be a number but was ', typeof src.beta, src.beta)
                        }
                    }
                    if (src.rVPlTRdFi !== undefined && src.rVPlTRdFi !== null) {
                        dst.rVPlTRdFi = ng.fem_design.steel_output.Vector2D.fromObject(src.rVPlTRdFi);
                    }
                    if (src.rVPlRdFi !== undefined && src.rVPlRdFi !== null) {
                        dst.rVPlRdFi = ng.fem_design.steel_output.Vector2D.fromObject(src.rVPlRdFi);
                    }
                    if (src.rTRdFi !== undefined && src.rTRdFi !== null) {
                        if (typeof src.rTRdFi === "number" || src.rTRdFi === 'NaN' || src.rTRdFi === 'Infinity' || src.rTRdFi === '-Infinity') {
                            dst.rTRdFi = AsNum(src.rTRdFi);
                        }
                        else {
                            console.log('Expected rTRdFi of StBarCSResist to be a number but was ', typeof src.rTRdFi, src.rTRdFi)
                        }
                    }
                    if (src.rtauRdFi !== undefined && src.rtauRdFi !== null) {
                        if (typeof src.rtauRdFi === "number" || src.rtauRdFi === 'NaN' || src.rtauRdFi === 'Infinity' || src.rtauRdFi === '-Infinity') {
                            dst.rtauRdFi = AsNum(src.rtauRdFi);
                        }
                        else {
                            console.log('Expected rtauRdFi of StBarCSResist to be a number but was ', typeof src.rtauRdFi, src.rtauRdFi)
                        }
                    }
                    if (src.rNRdFi !== undefined && src.rNRdFi !== null) {
                        if (typeof src.rNRdFi === "number" || src.rNRdFi === 'NaN' || src.rNRdFi === 'Infinity' || src.rNRdFi === '-Infinity') {
                            dst.rNRdFi = AsNum(src.rNRdFi);
                        }
                        else {
                            console.log('Expected rNRdFi of StBarCSResist to be a number but was ', typeof src.rNRdFi, src.rNRdFi)
                        }
                    }
                    if (src.rMRdFi !== undefined && src.rMRdFi !== null) {
                        dst.rMRdFi = ng.fem_design.steel_output.Vector2D.fromObject(src.rMRdFi);
                    }
                    return dst;
                }

                static toObject(src: StBarCSResist | null | undefined): StBarCSResist_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarCSResist is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarCSResist") {
                        console.error('Expected ng.fem_design.steel_output.StBarCSResist but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const tau_obj = ng.fem_design.steel_output.ShearStressCheckRelevant_ToObject(src.tau);
                    if(tau_obj === null) return null;

                    const shape_obj = ng.fem_design.steel_output.ShearResistanceEnum_ToObject(src.shape);
                    if(shape_obj === null) return null;

                    const dst : StBarCSResist_json = {
                        fCalculated: src.fCalculated,
                        rUtilTau: AsJsonNum(src.rUtilTau),
                        rUtilT: AsJsonNum(src.rUtilT),
                        rUtilN: AsJsonNum(src.rUtilN),
                        rUtilNorm: AsJsonNum(src.rUtilNorm),
                        tau: tau_obj,
                        fSigma: src.fSigma,
                        rTEd: AsJsonNum(src.rTEd),
                        rTRd: AsJsonNum(src.rTRd),
                        rtauTEd: AsJsonNum(src.rtauTEd),
                        rtauWEd: AsJsonNum(src.rtauWEd),
                        shape: shape_obj,
                        rTauEd: AsJsonNum(src.rTauEd),
                        rTauRd: AsJsonNum(src.rTauRd),
                        rNEd: AsJsonNum(src.rNEd),
                        rNRd: AsJsonNum(src.rNRd),
                        rSigmaXEd: AsJsonNum(src.rSigmaXEd),
                        rTauSEd: AsJsonNum(src.rTauSEd),
                        fUse641: src.fUse641,
                        nPlRd: AsJsonNum(src.nPlRd),
                        nPlVRd: AsJsonNum(src.nPlVRd),
                        nWPlRd: AsJsonNum(src.nWPlRd),
                        alpha: AsJsonNum(src.alpha),
                        beta: AsJsonNum(src.beta),
                        rTRdFi: AsJsonNum(src.rTRdFi),
                        rtauRdFi: AsJsonNum(src.rtauRdFi),
                        rNRdFi: AsJsonNum(src.rNRdFi),
                    };
                    if(src.rUtilV !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtilV);
                        if(parsed === null) return null;
                        dst.rUtilV = parsed;
                    }
                    if(src.fV !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Boolean2D.toObject(src.fV);
                        if(parsed === null) return null;
                        dst.fV = parsed;
                    }
                    if(src.rVEd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rVEd);
                        if(parsed === null) return null;
                        dst.rVEd = parsed;
                    }
                    if(src.rVPlTRd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rVPlTRd);
                        if(parsed === null) return null;
                        dst.rVPlTRd = parsed;
                    }
                    if(src.rVPlRd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rVPlRd);
                        if(parsed === null) return null;
                        dst.rVPlRd = parsed;
                    }
                    if(src.rAV !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rAV);
                        if(parsed === null) return null;
                        dst.rAV = parsed;
                    }
                    if(src.rMEd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMEd);
                        if(parsed === null) return null;
                        dst.rMEd = parsed;
                    }
                    if(src.rMPlRd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMPlRd);
                        if(parsed === null) return null;
                        dst.rMPlRd = parsed;
                    }
                    if(src.rMRd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMRd);
                        if(parsed === null) return null;
                        dst.rMRd = parsed;
                    }
                    if(src.rRho !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rRho);
                        if(parsed === null) return null;
                        dst.rRho = parsed;
                    }
                    if(src.fMNRdReduced !== null)
                    {
                        const parsed = ng.fem_design.steel_output.BooleanYZ.toObject(src.fMNRdReduced);
                        if(parsed === null) return null;
                        dst.fMNRdReduced = parsed;
                    }
                    if(src.mNRd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.mNRd);
                        if(parsed === null) return null;
                        dst.mNRd = parsed;
                    }
                    if(src.rVPlTRdFi !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rVPlTRdFi);
                        if(parsed === null) return null;
                        dst.rVPlTRdFi = parsed;
                    }
                    if(src.rVPlRdFi !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rVPlRdFi);
                        if(parsed === null) return null;
                        dst.rVPlRdFi = parsed;
                    }
                    if(src.rMRdFi !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMRdFi);
                        if(parsed === null) return null;
                        dst.rMRdFi = parsed;
                    }
                    return dst;
                }

                static create(src?: StBarCSResist_createType) {
                    const dst = new StBarCSResist();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.rUtilV !== undefined) {
                        dst.rUtilV = src.rUtilV;
                    }
                    if (src.rUtilTau !== undefined) {
                        dst.rUtilTau = src.rUtilTau;
                    }
                    if (src.rUtilT !== undefined) {
                        dst.rUtilT = src.rUtilT;
                    }
                    if (src.rUtilN !== undefined) {
                        dst.rUtilN = src.rUtilN;
                    }
                    if (src.rUtilNorm !== undefined) {
                        dst.rUtilNorm = src.rUtilNorm;
                    }
                    if (src.tau !== undefined) {
                        dst.tau = src.tau;
                    }
                    if (src.fV !== undefined) {
                        dst.fV = src.fV;
                    }
                    if (src.fSigma !== undefined) {
                        dst.fSigma = src.fSigma;
                    }
                    if (src.rVEd !== undefined) {
                        dst.rVEd = src.rVEd;
                    }
                    if (src.rTEd !== undefined) {
                        dst.rTEd = src.rTEd;
                    }
                    if (src.rVPlTRd !== undefined) {
                        dst.rVPlTRd = src.rVPlTRd;
                    }
                    if (src.rVPlRd !== undefined) {
                        dst.rVPlRd = src.rVPlRd;
                    }
                    if (src.rTRd !== undefined) {
                        dst.rTRd = src.rTRd;
                    }
                    if (src.rtauTEd !== undefined) {
                        dst.rtauTEd = src.rtauTEd;
                    }
                    if (src.rtauWEd !== undefined) {
                        dst.rtauWEd = src.rtauWEd;
                    }
                    if (src.rAV !== undefined) {
                        dst.rAV = src.rAV;
                    }
                    if (src.shape !== undefined) {
                        dst.shape = src.shape;
                    }
                    if (src.rTauEd !== undefined) {
                        dst.rTauEd = src.rTauEd;
                    }
                    if (src.rTauRd !== undefined) {
                        dst.rTauRd = src.rTauRd;
                    }
                    if (src.rNEd !== undefined) {
                        dst.rNEd = src.rNEd;
                    }
                    if (src.rMEd !== undefined) {
                        dst.rMEd = src.rMEd;
                    }
                    if (src.rMPlRd !== undefined) {
                        dst.rMPlRd = src.rMPlRd;
                    }
                    if (src.rNRd !== undefined) {
                        dst.rNRd = src.rNRd;
                    }
                    if (src.rMRd !== undefined) {
                        dst.rMRd = src.rMRd;
                    }
                    if (src.rRho !== undefined) {
                        dst.rRho = src.rRho;
                    }
                    if (src.rSigmaXEd !== undefined) {
                        dst.rSigmaXEd = src.rSigmaXEd;
                    }
                    if (src.rTauSEd !== undefined) {
                        dst.rTauSEd = src.rTauSEd;
                    }
                    if (src.fUse641 !== undefined) {
                        dst.fUse641 = src.fUse641;
                    }
                    if (src.nPlRd !== undefined) {
                        dst.nPlRd = src.nPlRd;
                    }
                    if (src.nPlVRd !== undefined) {
                        dst.nPlVRd = src.nPlVRd;
                    }
                    if (src.nWPlRd !== undefined) {
                        dst.nWPlRd = src.nWPlRd;
                    }
                    if (src.fMNRdReduced !== undefined) {
                        dst.fMNRdReduced = src.fMNRdReduced;
                    }
                    if (src.mNRd !== undefined) {
                        dst.mNRd = src.mNRd;
                    }
                    if (src.alpha !== undefined) {
                        dst.alpha = src.alpha;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    if (src.rVPlTRdFi !== undefined) {
                        dst.rVPlTRdFi = src.rVPlTRdFi;
                    }
                    if (src.rVPlRdFi !== undefined) {
                        dst.rVPlRdFi = src.rVPlRdFi;
                    }
                    if (src.rTRdFi !== undefined) {
                        dst.rTRdFi = src.rTRdFi;
                    }
                    if (src.rtauRdFi !== undefined) {
                        dst.rtauRdFi = src.rtauRdFi;
                    }
                    if (src.rNRdFi !== undefined) {
                        dst.rNRdFi = src.rNRdFi;
                    }
                    if (src.rMRdFi !== undefined) {
                        dst.rMRdFi = src.rMRdFi;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarCSResist();
                    dst.fCalculated = this.fCalculated;
                    dst.rUtilV = this.rUtilV;
                    dst.rUtilTau = this.rUtilTau;
                    dst.rUtilT = this.rUtilT;
                    dst.rUtilN = this.rUtilN;
                    dst.rUtilNorm = this.rUtilNorm;
                    dst.tau = this.tau;
                    dst.fV = this.fV;
                    dst.fSigma = this.fSigma;
                    dst.rVEd = this.rVEd;
                    dst.rTEd = this.rTEd;
                    dst.rVPlTRd = this.rVPlTRd;
                    dst.rVPlRd = this.rVPlRd;
                    dst.rTRd = this.rTRd;
                    dst.rtauTEd = this.rtauTEd;
                    dst.rtauWEd = this.rtauWEd;
                    dst.rAV = this.rAV;
                    dst.shape = this.shape;
                    dst.rTauEd = this.rTauEd;
                    dst.rTauRd = this.rTauRd;
                    dst.rNEd = this.rNEd;
                    dst.rMEd = this.rMEd;
                    dst.rMPlRd = this.rMPlRd;
                    dst.rNRd = this.rNRd;
                    dst.rMRd = this.rMRd;
                    dst.rRho = this.rRho;
                    dst.rSigmaXEd = this.rSigmaXEd;
                    dst.rTauSEd = this.rTauSEd;
                    dst.fUse641 = this.fUse641;
                    dst.nPlRd = this.nPlRd;
                    dst.nPlVRd = this.nPlVRd;
                    dst.nWPlRd = this.nWPlRd;
                    dst.fMNRdReduced = this.fMNRdReduced;
                    dst.mNRd = this.mNRd;
                    dst.alpha = this.alpha;
                    dst.beta = this.beta;
                    dst.rVPlTRdFi = this.rVPlTRdFi;
                    dst.rVPlRdFi = this.rVPlRdFi;
                    dst.rTRdFi = this.rTRdFi;
                    dst.rtauRdFi = this.rtauRdFi;
                    dst.rNRdFi = this.rNRdFi;
                    dst.rMRdFi = this.rMRdFi;
                    return dst;
                }

                deepClone() {
                    const json = StBarCSResist.toObject(this);
                    const dst = StBarCSResist.fromObject(json);
                    return dst;
                }
            }
            export type IStBarCSResist = StBarCSResist;


            export type StBarFlexural_keys = 'fCalculated' | 'rUtil' | 'rNbRd' | 'rChi' | 'rPhi' | 'rAlfa' | 'rLambdaOver' | 'rLambda' | 'rLcr' | 'rNcr' | 'lambdaTheta' | 'lambdaThetaInteraction';
            export interface StBarFlexural_createType {
                fCalculated?: boolean,
                rUtil?: ng.fem_design.steel_output.Vector2D | null,
                rNbRd?: ng.fem_design.steel_output.Vector2D | null,
                rChi?: ng.fem_design.steel_output.Vector2D | null,
                rPhi?: ng.fem_design.steel_output.Vector2D | null,
                rAlfa?: ng.fem_design.steel_output.Vector2D | null,
                rLambdaOver?: ng.fem_design.steel_output.Vector2D | null,
                rLambda?: ng.fem_design.steel_output.Vector2D | null,
                rLcr?: ng.fem_design.steel_output.Vector2D | null,
                rNcr?: ng.fem_design.steel_output.Vector2D | null,
                lambdaTheta?: ng.fem_design.steel_output.Vector2D | null,
                lambdaThetaInteraction?: number,
            }
            export interface StBarFlexural_json {
                fCalculated?: boolean;
                rUtil?: ng.fem_design.steel_output.Vector2D_json;
                rNbRd?: ng.fem_design.steel_output.Vector2D_json;
                rChi?: ng.fem_design.steel_output.Vector2D_json;
                rPhi?: ng.fem_design.steel_output.Vector2D_json;
                rAlfa?: ng.fem_design.steel_output.Vector2D_json;
                rLambdaOver?: ng.fem_design.steel_output.Vector2D_json;
                rLambda?: ng.fem_design.steel_output.Vector2D_json;
                rLcr?: ng.fem_design.steel_output.Vector2D_json;
                rNcr?: ng.fem_design.steel_output.Vector2D_json;
                lambdaTheta?: ng.fem_design.steel_output.Vector2D_json;
                lambdaThetaInteraction?: JsonNumber;
            }
            interface StBarFlexural_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                rUtil?: unknown;
                rNbRd?: unknown;
                rChi?: unknown;
                rPhi?: unknown;
                rAlfa?: unknown;
                rLambdaOver?: unknown;
                rLambda?: unknown;
                rLcr?: unknown;
                rNcr?: unknown;
                lambdaTheta?: unknown;
                lambdaThetaInteraction?: unknown;
            }
            export class StBarFlexural {
                __proto_name = "ng.fem_design.steel_output.StBarFlexural";
                fCalculated: boolean = false;
                rUtil: ng.fem_design.steel_output.Vector2D | null = null;
                rNbRd: ng.fem_design.steel_output.Vector2D | null = null;
                rChi: ng.fem_design.steel_output.Vector2D | null = null;
                rPhi: ng.fem_design.steel_output.Vector2D | null = null;
                rAlfa: ng.fem_design.steel_output.Vector2D | null = null;
                rLambdaOver: ng.fem_design.steel_output.Vector2D | null = null;
                rLambda: ng.fem_design.steel_output.Vector2D | null = null;
                rLcr: ng.fem_design.steel_output.Vector2D | null = null;
                rNcr: ng.fem_design.steel_output.Vector2D | null = null;
                lambdaTheta: ng.fem_design.steel_output.Vector2D | null = null;
                lambdaThetaInteraction: number = 0;

                static fromObject(src_unknown: unknown): StBarFlexural {
                    const dst = new StBarFlexural();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarFlexural but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarFlexural_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarFlexural but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarFlexural to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        dst.rUtil = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtil);
                    }
                    if (src.rNbRd !== undefined && src.rNbRd !== null) {
                        dst.rNbRd = ng.fem_design.steel_output.Vector2D.fromObject(src.rNbRd);
                    }
                    if (src.rChi !== undefined && src.rChi !== null) {
                        dst.rChi = ng.fem_design.steel_output.Vector2D.fromObject(src.rChi);
                    }
                    if (src.rPhi !== undefined && src.rPhi !== null) {
                        dst.rPhi = ng.fem_design.steel_output.Vector2D.fromObject(src.rPhi);
                    }
                    if (src.rAlfa !== undefined && src.rAlfa !== null) {
                        dst.rAlfa = ng.fem_design.steel_output.Vector2D.fromObject(src.rAlfa);
                    }
                    if (src.rLambdaOver !== undefined && src.rLambdaOver !== null) {
                        dst.rLambdaOver = ng.fem_design.steel_output.Vector2D.fromObject(src.rLambdaOver);
                    }
                    if (src.rLambda !== undefined && src.rLambda !== null) {
                        dst.rLambda = ng.fem_design.steel_output.Vector2D.fromObject(src.rLambda);
                    }
                    if (src.rLcr !== undefined && src.rLcr !== null) {
                        dst.rLcr = ng.fem_design.steel_output.Vector2D.fromObject(src.rLcr);
                    }
                    if (src.rNcr !== undefined && src.rNcr !== null) {
                        dst.rNcr = ng.fem_design.steel_output.Vector2D.fromObject(src.rNcr);
                    }
                    if (src.lambdaTheta !== undefined && src.lambdaTheta !== null) {
                        dst.lambdaTheta = ng.fem_design.steel_output.Vector2D.fromObject(src.lambdaTheta);
                    }
                    if (src.lambdaThetaInteraction !== undefined && src.lambdaThetaInteraction !== null) {
                        if (typeof src.lambdaThetaInteraction === "number" || src.lambdaThetaInteraction === 'NaN' || src.lambdaThetaInteraction === 'Infinity' || src.lambdaThetaInteraction === '-Infinity') {
                            dst.lambdaThetaInteraction = AsNum(src.lambdaThetaInteraction);
                        }
                        else {
                            console.log('Expected lambdaThetaInteraction of StBarFlexural to be a number but was ', typeof src.lambdaThetaInteraction, src.lambdaThetaInteraction)
                        }
                    }
                    return dst;
                }

                static toObject(src: StBarFlexural | null | undefined): StBarFlexural_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarFlexural is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarFlexural") {
                        console.error('Expected ng.fem_design.steel_output.StBarFlexural but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : StBarFlexural_json = {
                        fCalculated: src.fCalculated,
                        lambdaThetaInteraction: AsJsonNum(src.lambdaThetaInteraction),
                    };
                    if(src.rUtil !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtil);
                        if(parsed === null) return null;
                        dst.rUtil = parsed;
                    }
                    if(src.rNbRd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rNbRd);
                        if(parsed === null) return null;
                        dst.rNbRd = parsed;
                    }
                    if(src.rChi !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rChi);
                        if(parsed === null) return null;
                        dst.rChi = parsed;
                    }
                    if(src.rPhi !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rPhi);
                        if(parsed === null) return null;
                        dst.rPhi = parsed;
                    }
                    if(src.rAlfa !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rAlfa);
                        if(parsed === null) return null;
                        dst.rAlfa = parsed;
                    }
                    if(src.rLambdaOver !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rLambdaOver);
                        if(parsed === null) return null;
                        dst.rLambdaOver = parsed;
                    }
                    if(src.rLambda !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rLambda);
                        if(parsed === null) return null;
                        dst.rLambda = parsed;
                    }
                    if(src.rLcr !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rLcr);
                        if(parsed === null) return null;
                        dst.rLcr = parsed;
                    }
                    if(src.rNcr !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rNcr);
                        if(parsed === null) return null;
                        dst.rNcr = parsed;
                    }
                    if(src.lambdaTheta !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.lambdaTheta);
                        if(parsed === null) return null;
                        dst.lambdaTheta = parsed;
                    }
                    return dst;
                }

                static create(src?: StBarFlexural_createType) {
                    const dst = new StBarFlexural();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    if (src.rNbRd !== undefined) {
                        dst.rNbRd = src.rNbRd;
                    }
                    if (src.rChi !== undefined) {
                        dst.rChi = src.rChi;
                    }
                    if (src.rPhi !== undefined) {
                        dst.rPhi = src.rPhi;
                    }
                    if (src.rAlfa !== undefined) {
                        dst.rAlfa = src.rAlfa;
                    }
                    if (src.rLambdaOver !== undefined) {
                        dst.rLambdaOver = src.rLambdaOver;
                    }
                    if (src.rLambda !== undefined) {
                        dst.rLambda = src.rLambda;
                    }
                    if (src.rLcr !== undefined) {
                        dst.rLcr = src.rLcr;
                    }
                    if (src.rNcr !== undefined) {
                        dst.rNcr = src.rNcr;
                    }
                    if (src.lambdaTheta !== undefined) {
                        dst.lambdaTheta = src.lambdaTheta;
                    }
                    if (src.lambdaThetaInteraction !== undefined) {
                        dst.lambdaThetaInteraction = src.lambdaThetaInteraction;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarFlexural();
                    dst.fCalculated = this.fCalculated;
                    dst.rUtil = this.rUtil;
                    dst.rNbRd = this.rNbRd;
                    dst.rChi = this.rChi;
                    dst.rPhi = this.rPhi;
                    dst.rAlfa = this.rAlfa;
                    dst.rLambdaOver = this.rLambdaOver;
                    dst.rLambda = this.rLambda;
                    dst.rLcr = this.rLcr;
                    dst.rNcr = this.rNcr;
                    dst.lambdaTheta = this.lambdaTheta;
                    dst.lambdaThetaInteraction = this.lambdaThetaInteraction;
                    return dst;
                }

                deepClone() {
                    const json = StBarFlexural.toObject(this);
                    const dst = StBarFlexural.fromObject(json);
                    return dst;
                }
            }
            export type IStBarFlexural = StBarFlexural;


            export type StBarFlexuralTorsional_keys = 'fCalculated' | 'rUtil' | 'rNbRd' | 'rChi' | 'rPhi' | 'rAlfa' | 'lambdaTheta' | 'lambdaOver' | 'rLcr' | 'ri02' | 'rNcrT' | 'rNcrTF';
            export interface StBarFlexuralTorsional_createType {
                fCalculated?: boolean,
                rUtil?: number,
                rNbRd?: number,
                rChi?: number,
                rPhi?: number,
                rAlfa?: number,
                lambdaTheta?: number,
                lambdaOver?: number,
                rLcr?: number,
                ri02?: number,
                rNcrT?: number,
                rNcrTF?: number,
            }
            export interface StBarFlexuralTorsional_json {
                fCalculated?: boolean;
                rUtil?: JsonNumber;
                rNbRd?: JsonNumber;
                rChi?: JsonNumber;
                rPhi?: JsonNumber;
                rAlfa?: JsonNumber;
                lambdaTheta?: JsonNumber;
                lambdaOver?: JsonNumber;
                rLcr?: JsonNumber;
                ri02?: JsonNumber;
                rNcrT?: JsonNumber;
                rNcrTF?: JsonNumber;
            }
            interface StBarFlexuralTorsional_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                rUtil?: unknown;
                rNbRd?: unknown;
                rChi?: unknown;
                rPhi?: unknown;
                rAlfa?: unknown;
                lambdaTheta?: unknown;
                lambdaOver?: unknown;
                rLcr?: unknown;
                ri02?: unknown;
                rNcrT?: unknown;
                rNcrTF?: unknown;
            }
            export class StBarFlexuralTorsional {
                __proto_name = "ng.fem_design.steel_output.StBarFlexuralTorsional";
                fCalculated: boolean = false;
                rUtil: number = 0;
                rNbRd: number = 0;
                rChi: number = 0;
                rPhi: number = 0;
                rAlfa: number = 0;
                lambdaTheta: number = 0;
                lambdaOver: number = 0;
                rLcr: number = 0;
                ri02: number = 0;
                rNcrT: number = 0;
                rNcrTF: number = 0;

                static fromObject(src_unknown: unknown): StBarFlexuralTorsional {
                    const dst = new StBarFlexuralTorsional();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarFlexuralTorsional but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarFlexuralTorsional_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarFlexuralTorsional but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarFlexuralTorsional to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        if (typeof src.rUtil === "number" || src.rUtil === 'NaN' || src.rUtil === 'Infinity' || src.rUtil === '-Infinity') {
                            dst.rUtil = AsNum(src.rUtil);
                        }
                        else {
                            console.log('Expected rUtil of StBarFlexuralTorsional to be a number but was ', typeof src.rUtil, src.rUtil)
                        }
                    }
                    if (src.rNbRd !== undefined && src.rNbRd !== null) {
                        if (typeof src.rNbRd === "number" || src.rNbRd === 'NaN' || src.rNbRd === 'Infinity' || src.rNbRd === '-Infinity') {
                            dst.rNbRd = AsNum(src.rNbRd);
                        }
                        else {
                            console.log('Expected rNbRd of StBarFlexuralTorsional to be a number but was ', typeof src.rNbRd, src.rNbRd)
                        }
                    }
                    if (src.rChi !== undefined && src.rChi !== null) {
                        if (typeof src.rChi === "number" || src.rChi === 'NaN' || src.rChi === 'Infinity' || src.rChi === '-Infinity') {
                            dst.rChi = AsNum(src.rChi);
                        }
                        else {
                            console.log('Expected rChi of StBarFlexuralTorsional to be a number but was ', typeof src.rChi, src.rChi)
                        }
                    }
                    if (src.rPhi !== undefined && src.rPhi !== null) {
                        if (typeof src.rPhi === "number" || src.rPhi === 'NaN' || src.rPhi === 'Infinity' || src.rPhi === '-Infinity') {
                            dst.rPhi = AsNum(src.rPhi);
                        }
                        else {
                            console.log('Expected rPhi of StBarFlexuralTorsional to be a number but was ', typeof src.rPhi, src.rPhi)
                        }
                    }
                    if (src.rAlfa !== undefined && src.rAlfa !== null) {
                        if (typeof src.rAlfa === "number" || src.rAlfa === 'NaN' || src.rAlfa === 'Infinity' || src.rAlfa === '-Infinity') {
                            dst.rAlfa = AsNum(src.rAlfa);
                        }
                        else {
                            console.log('Expected rAlfa of StBarFlexuralTorsional to be a number but was ', typeof src.rAlfa, src.rAlfa)
                        }
                    }
                    if (src.lambdaTheta !== undefined && src.lambdaTheta !== null) {
                        if (typeof src.lambdaTheta === "number" || src.lambdaTheta === 'NaN' || src.lambdaTheta === 'Infinity' || src.lambdaTheta === '-Infinity') {
                            dst.lambdaTheta = AsNum(src.lambdaTheta);
                        }
                        else {
                            console.log('Expected lambdaTheta of StBarFlexuralTorsional to be a number but was ', typeof src.lambdaTheta, src.lambdaTheta)
                        }
                    }
                    if (src.lambdaOver !== undefined && src.lambdaOver !== null) {
                        if (typeof src.lambdaOver === "number" || src.lambdaOver === 'NaN' || src.lambdaOver === 'Infinity' || src.lambdaOver === '-Infinity') {
                            dst.lambdaOver = AsNum(src.lambdaOver);
                        }
                        else {
                            console.log('Expected lambdaOver of StBarFlexuralTorsional to be a number but was ', typeof src.lambdaOver, src.lambdaOver)
                        }
                    }
                    if (src.rLcr !== undefined && src.rLcr !== null) {
                        if (typeof src.rLcr === "number" || src.rLcr === 'NaN' || src.rLcr === 'Infinity' || src.rLcr === '-Infinity') {
                            dst.rLcr = AsNum(src.rLcr);
                        }
                        else {
                            console.log('Expected rLcr of StBarFlexuralTorsional to be a number but was ', typeof src.rLcr, src.rLcr)
                        }
                    }
                    if (src.ri02 !== undefined && src.ri02 !== null) {
                        if (typeof src.ri02 === "number" || src.ri02 === 'NaN' || src.ri02 === 'Infinity' || src.ri02 === '-Infinity') {
                            dst.ri02 = AsNum(src.ri02);
                        }
                        else {
                            console.log('Expected ri02 of StBarFlexuralTorsional to be a number but was ', typeof src.ri02, src.ri02)
                        }
                    }
                    if (src.rNcrT !== undefined && src.rNcrT !== null) {
                        if (typeof src.rNcrT === "number" || src.rNcrT === 'NaN' || src.rNcrT === 'Infinity' || src.rNcrT === '-Infinity') {
                            dst.rNcrT = AsNum(src.rNcrT);
                        }
                        else {
                            console.log('Expected rNcrT of StBarFlexuralTorsional to be a number but was ', typeof src.rNcrT, src.rNcrT)
                        }
                    }
                    if (src.rNcrTF !== undefined && src.rNcrTF !== null) {
                        if (typeof src.rNcrTF === "number" || src.rNcrTF === 'NaN' || src.rNcrTF === 'Infinity' || src.rNcrTF === '-Infinity') {
                            dst.rNcrTF = AsNum(src.rNcrTF);
                        }
                        else {
                            console.log('Expected rNcrTF of StBarFlexuralTorsional to be a number but was ', typeof src.rNcrTF, src.rNcrTF)
                        }
                    }
                    return dst;
                }

                static toObject(src: StBarFlexuralTorsional | null | undefined): StBarFlexuralTorsional_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarFlexuralTorsional is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarFlexuralTorsional") {
                        console.error('Expected ng.fem_design.steel_output.StBarFlexuralTorsional but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : StBarFlexuralTorsional_json = {
                        fCalculated: src.fCalculated,
                        rUtil: AsJsonNum(src.rUtil),
                        rNbRd: AsJsonNum(src.rNbRd),
                        rChi: AsJsonNum(src.rChi),
                        rPhi: AsJsonNum(src.rPhi),
                        rAlfa: AsJsonNum(src.rAlfa),
                        lambdaTheta: AsJsonNum(src.lambdaTheta),
                        lambdaOver: AsJsonNum(src.lambdaOver),
                        rLcr: AsJsonNum(src.rLcr),
                        ri02: AsJsonNum(src.ri02),
                        rNcrT: AsJsonNum(src.rNcrT),
                        rNcrTF: AsJsonNum(src.rNcrTF),
                    };
                    return dst;
                }

                static create(src?: StBarFlexuralTorsional_createType) {
                    const dst = new StBarFlexuralTorsional();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    if (src.rNbRd !== undefined) {
                        dst.rNbRd = src.rNbRd;
                    }
                    if (src.rChi !== undefined) {
                        dst.rChi = src.rChi;
                    }
                    if (src.rPhi !== undefined) {
                        dst.rPhi = src.rPhi;
                    }
                    if (src.rAlfa !== undefined) {
                        dst.rAlfa = src.rAlfa;
                    }
                    if (src.lambdaTheta !== undefined) {
                        dst.lambdaTheta = src.lambdaTheta;
                    }
                    if (src.lambdaOver !== undefined) {
                        dst.lambdaOver = src.lambdaOver;
                    }
                    if (src.rLcr !== undefined) {
                        dst.rLcr = src.rLcr;
                    }
                    if (src.ri02 !== undefined) {
                        dst.ri02 = src.ri02;
                    }
                    if (src.rNcrT !== undefined) {
                        dst.rNcrT = src.rNcrT;
                    }
                    if (src.rNcrTF !== undefined) {
                        dst.rNcrTF = src.rNcrTF;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarFlexuralTorsional();
                    dst.fCalculated = this.fCalculated;
                    dst.rUtil = this.rUtil;
                    dst.rNbRd = this.rNbRd;
                    dst.rChi = this.rChi;
                    dst.rPhi = this.rPhi;
                    dst.rAlfa = this.rAlfa;
                    dst.lambdaTheta = this.lambdaTheta;
                    dst.lambdaOver = this.lambdaOver;
                    dst.rLcr = this.rLcr;
                    dst.ri02 = this.ri02;
                    dst.rNcrT = this.rNcrT;
                    dst.rNcrTF = this.rNcrTF;
                    return dst;
                }

                deepClone() {
                    const json = StBarFlexuralTorsional.toObject(this);
                    const dst = StBarFlexuralTorsional.fromObject(json);
                    return dst;
                }
            }
            export type IStBarFlexuralTorsional = StBarFlexuralTorsional;


            export type StBarTorsional_keys = 'fCalculated' | 'fCalculatedNotImplemented' | 'rUtil' | 'fTopComp' | 'rkc' | 'rLcr' | 'rifz' | 'rLambdaF' | 'rMEdMax' | 'rMcRd' | 'rMbRd' | 'rChi' | 'rPhi' | 'rAlfa' | 'curve' | 'fCalcGeneralMethod' | 'fCalcGeneralMethodSpecForl' | 'psi' | 'psiF' | 'c1' | 'c2' | 'c3' | 'kz' | 'kw' | 'loadPos' | 'zg' | 'zj' | 'c2zgC3zj' | 'ncrLT' | 'mcr' | 'rLambdaLT' | 'curveLT' | 'rAlphaLT' | 'rPhiLT' | 'rChiLT' | 'rChiLTBasic' | 'factorf' | 'rLambda0' | 'rLambdaLTFi';
            export interface StBarTorsional_createType {
                fCalculated?: boolean,
                fCalculatedNotImplemented?: boolean,
                rUtil?: number,
                fTopComp?: boolean,
                rkc?: number,
                rLcr?: number,
                rifz?: number,
                rLambdaF?: number,
                rMEdMax?: ng.fem_design.steel_output.Vector2D | null,
                rMcRd?: number,
                rMbRd?: number,
                rChi?: number,
                rPhi?: number,
                rAlfa?: number,
                curve?: ng.fem_design.steel_output.Curve,
                fCalcGeneralMethod?: boolean,
                fCalcGeneralMethodSpecForl?: boolean,
                psi?: number,
                psiF?: number,
                c1?: number,
                c2?: number,
                c3?: number,
                kz?: number,
                kw?: number,
                loadPos?: ng.fem_design.steel_output.Alignment,
                zg?: number,
                zj?: number,
                c2zgC3zj?: number,
                ncrLT?: number,
                mcr?: number,
                rLambdaLT?: number,
                curveLT?: ng.fem_design.steel_output.CurveLT,
                rAlphaLT?: number,
                rPhiLT?: number,
                rChiLT?: number,
                rChiLTBasic?: number,
                factorf?: number,
                rLambda0?: number,
                rLambdaLTFi?: number,
            }
            export interface StBarTorsional_json {
                fCalculated?: boolean;
                fCalculatedNotImplemented?: boolean;
                rUtil?: JsonNumber;
                fTopComp?: boolean;
                rkc?: JsonNumber;
                rLcr?: JsonNumber;
                rifz?: JsonNumber;
                rLambdaF?: JsonNumber;
                rMEdMax?: ng.fem_design.steel_output.Vector2D_json;
                rMcRd?: JsonNumber;
                rMbRd?: JsonNumber;
                rChi?: JsonNumber;
                rPhi?: JsonNumber;
                rAlfa?: JsonNumber;
                curve?: string;
                fCalcGeneralMethod?: boolean;
                fCalcGeneralMethodSpecForl?: boolean;
                psi?: JsonNumber;
                psiF?: JsonNumber;
                c1?: JsonNumber;
                c2?: JsonNumber;
                c3?: JsonNumber;
                kz?: JsonNumber;
                kw?: JsonNumber;
                loadPos?: string;
                zg?: JsonNumber;
                zj?: JsonNumber;
                c2zgC3zj?: JsonNumber;
                ncrLT?: JsonNumber;
                mcr?: JsonNumber;
                rLambdaLT?: JsonNumber;
                curveLT?: string;
                rAlphaLT?: JsonNumber;
                rPhiLT?: JsonNumber;
                rChiLT?: JsonNumber;
                rChiLTBasic?: JsonNumber;
                factorf?: JsonNumber;
                rLambda0?: JsonNumber;
                rLambdaLTFi?: JsonNumber;
            }
            interface StBarTorsional_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                fCalculatedNotImplemented?: unknown;
                rUtil?: unknown;
                fTopComp?: unknown;
                rkc?: unknown;
                rLcr?: unknown;
                rifz?: unknown;
                rLambdaF?: unknown;
                rMEdMax?: unknown;
                rMcRd?: unknown;
                rMbRd?: unknown;
                rChi?: unknown;
                rPhi?: unknown;
                rAlfa?: unknown;
                curve?: unknown;
                fCalcGeneralMethod?: unknown;
                fCalcGeneralMethodSpecForl?: unknown;
                psi?: unknown;
                psiF?: unknown;
                c1?: unknown;
                c2?: unknown;
                c3?: unknown;
                kz?: unknown;
                kw?: unknown;
                loadPos?: unknown;
                zg?: unknown;
                zj?: unknown;
                c2zgC3zj?: unknown;
                ncrLT?: unknown;
                mcr?: unknown;
                rLambdaLT?: unknown;
                curveLT?: unknown;
                rAlphaLT?: unknown;
                rPhiLT?: unknown;
                rChiLT?: unknown;
                rChiLTBasic?: unknown;
                factorf?: unknown;
                rLambda0?: unknown;
                rLambdaLTFi?: unknown;
            }
            export class StBarTorsional {
                __proto_name = "ng.fem_design.steel_output.StBarTorsional";
                fCalculated: boolean = false;
                fCalculatedNotImplemented: boolean = false;
                rUtil: number = 0;
                fTopComp: boolean = false;
                rkc: number = 0;
                rLcr: number = 0;
                rifz: number = 0;
                rLambdaF: number = 0;
                rMEdMax: ng.fem_design.steel_output.Vector2D | null = null;
                rMcRd: number = 0;
                rMbRd: number = 0;
                rChi: number = 0;
                rPhi: number = 0;
                rAlfa: number = 0;
                curve: ng.fem_design.steel_output.Curve = ng.fem_design.steel_output.Curve.CURVE_A0;
                fCalcGeneralMethod: boolean = false;
                fCalcGeneralMethodSpecForl: boolean = false;
                psi: number = 0;
                psiF: number = 0;
                c1: number = 0;
                c2: number = 0;
                c3: number = 0;
                kz: number = 0;
                kw: number = 0;
                loadPos: ng.fem_design.steel_output.Alignment = ng.fem_design.steel_output.Alignment.ALIGNMENT_TOP;
                zg: number = 0;
                zj: number = 0;
                c2zgC3zj: number = 0;
                ncrLT: number = 0;
                mcr: number = 0;
                rLambdaLT: number = 0;
                curveLT: ng.fem_design.steel_output.CurveLT = ng.fem_design.steel_output.CurveLT.CURVE_L_T_A;
                rAlphaLT: number = 0;
                rPhiLT: number = 0;
                rChiLT: number = 0;
                rChiLTBasic: number = 0;
                factorf: number = 0;
                rLambda0: number = 0;
                rLambdaLTFi: number = 0;

                static fromObject(src_unknown: unknown): StBarTorsional {
                    const dst = new StBarTorsional();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarTorsional but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarTorsional_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarTorsional but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarTorsional to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.fCalculatedNotImplemented !== undefined && src.fCalculatedNotImplemented !== null) {
                        if (typeof src.fCalculatedNotImplemented === "boolean") {
                            dst.fCalculatedNotImplemented = src.fCalculatedNotImplemented;
                        }
                        else {
                            console.log('Expected fCalculatedNotImplemented of StBarTorsional to be a boolean but was ', typeof src.fCalculatedNotImplemented, src.fCalculatedNotImplemented)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        if (typeof src.rUtil === "number" || src.rUtil === 'NaN' || src.rUtil === 'Infinity' || src.rUtil === '-Infinity') {
                            dst.rUtil = AsNum(src.rUtil);
                        }
                        else {
                            console.log('Expected rUtil of StBarTorsional to be a number but was ', typeof src.rUtil, src.rUtil)
                        }
                    }
                    if (src.fTopComp !== undefined && src.fTopComp !== null) {
                        if (typeof src.fTopComp === "boolean") {
                            dst.fTopComp = src.fTopComp;
                        }
                        else {
                            console.log('Expected fTopComp of StBarTorsional to be a boolean but was ', typeof src.fTopComp, src.fTopComp)
                        }
                    }
                    if (src.rkc !== undefined && src.rkc !== null) {
                        if (typeof src.rkc === "number" || src.rkc === 'NaN' || src.rkc === 'Infinity' || src.rkc === '-Infinity') {
                            dst.rkc = AsNum(src.rkc);
                        }
                        else {
                            console.log('Expected rkc of StBarTorsional to be a number but was ', typeof src.rkc, src.rkc)
                        }
                    }
                    if (src.rLcr !== undefined && src.rLcr !== null) {
                        if (typeof src.rLcr === "number" || src.rLcr === 'NaN' || src.rLcr === 'Infinity' || src.rLcr === '-Infinity') {
                            dst.rLcr = AsNum(src.rLcr);
                        }
                        else {
                            console.log('Expected rLcr of StBarTorsional to be a number but was ', typeof src.rLcr, src.rLcr)
                        }
                    }
                    if (src.rifz !== undefined && src.rifz !== null) {
                        if (typeof src.rifz === "number" || src.rifz === 'NaN' || src.rifz === 'Infinity' || src.rifz === '-Infinity') {
                            dst.rifz = AsNum(src.rifz);
                        }
                        else {
                            console.log('Expected rifz of StBarTorsional to be a number but was ', typeof src.rifz, src.rifz)
                        }
                    }
                    if (src.rLambdaF !== undefined && src.rLambdaF !== null) {
                        if (typeof src.rLambdaF === "number" || src.rLambdaF === 'NaN' || src.rLambdaF === 'Infinity' || src.rLambdaF === '-Infinity') {
                            dst.rLambdaF = AsNum(src.rLambdaF);
                        }
                        else {
                            console.log('Expected rLambdaF of StBarTorsional to be a number but was ', typeof src.rLambdaF, src.rLambdaF)
                        }
                    }
                    if (src.rMEdMax !== undefined && src.rMEdMax !== null) {
                        dst.rMEdMax = ng.fem_design.steel_output.Vector2D.fromObject(src.rMEdMax);
                    }
                    if (src.rMcRd !== undefined && src.rMcRd !== null) {
                        if (typeof src.rMcRd === "number" || src.rMcRd === 'NaN' || src.rMcRd === 'Infinity' || src.rMcRd === '-Infinity') {
                            dst.rMcRd = AsNum(src.rMcRd);
                        }
                        else {
                            console.log('Expected rMcRd of StBarTorsional to be a number but was ', typeof src.rMcRd, src.rMcRd)
                        }
                    }
                    if (src.rMbRd !== undefined && src.rMbRd !== null) {
                        if (typeof src.rMbRd === "number" || src.rMbRd === 'NaN' || src.rMbRd === 'Infinity' || src.rMbRd === '-Infinity') {
                            dst.rMbRd = AsNum(src.rMbRd);
                        }
                        else {
                            console.log('Expected rMbRd of StBarTorsional to be a number but was ', typeof src.rMbRd, src.rMbRd)
                        }
                    }
                    if (src.rChi !== undefined && src.rChi !== null) {
                        if (typeof src.rChi === "number" || src.rChi === 'NaN' || src.rChi === 'Infinity' || src.rChi === '-Infinity') {
                            dst.rChi = AsNum(src.rChi);
                        }
                        else {
                            console.log('Expected rChi of StBarTorsional to be a number but was ', typeof src.rChi, src.rChi)
                        }
                    }
                    if (src.rPhi !== undefined && src.rPhi !== null) {
                        if (typeof src.rPhi === "number" || src.rPhi === 'NaN' || src.rPhi === 'Infinity' || src.rPhi === '-Infinity') {
                            dst.rPhi = AsNum(src.rPhi);
                        }
                        else {
                            console.log('Expected rPhi of StBarTorsional to be a number but was ', typeof src.rPhi, src.rPhi)
                        }
                    }
                    if (src.rAlfa !== undefined && src.rAlfa !== null) {
                        if (typeof src.rAlfa === "number" || src.rAlfa === 'NaN' || src.rAlfa === 'Infinity' || src.rAlfa === '-Infinity') {
                            dst.rAlfa = AsNum(src.rAlfa);
                        }
                        else {
                            console.log('Expected rAlfa of StBarTorsional to be a number but was ', typeof src.rAlfa, src.rAlfa)
                        }
                    }
                    if (src.curve !== undefined && src.curve !== null) {
                        dst.curve = ng.fem_design.steel_output.Curve_FromObject(src.curve);
                    }
                    if (src.fCalcGeneralMethod !== undefined && src.fCalcGeneralMethod !== null) {
                        if (typeof src.fCalcGeneralMethod === "boolean") {
                            dst.fCalcGeneralMethod = src.fCalcGeneralMethod;
                        }
                        else {
                            console.log('Expected fCalcGeneralMethod of StBarTorsional to be a boolean but was ', typeof src.fCalcGeneralMethod, src.fCalcGeneralMethod)
                        }
                    }
                    if (src.fCalcGeneralMethodSpecForl !== undefined && src.fCalcGeneralMethodSpecForl !== null) {
                        if (typeof src.fCalcGeneralMethodSpecForl === "boolean") {
                            dst.fCalcGeneralMethodSpecForl = src.fCalcGeneralMethodSpecForl;
                        }
                        else {
                            console.log('Expected fCalcGeneralMethodSpecForl of StBarTorsional to be a boolean but was ', typeof src.fCalcGeneralMethodSpecForl, src.fCalcGeneralMethodSpecForl)
                        }
                    }
                    if (src.psi !== undefined && src.psi !== null) {
                        if (typeof src.psi === "number" || src.psi === 'NaN' || src.psi === 'Infinity' || src.psi === '-Infinity') {
                            dst.psi = AsNum(src.psi);
                        }
                        else {
                            console.log('Expected psi of StBarTorsional to be a number but was ', typeof src.psi, src.psi)
                        }
                    }
                    if (src.psiF !== undefined && src.psiF !== null) {
                        if (typeof src.psiF === "number" || src.psiF === 'NaN' || src.psiF === 'Infinity' || src.psiF === '-Infinity') {
                            dst.psiF = AsNum(src.psiF);
                        }
                        else {
                            console.log('Expected psiF of StBarTorsional to be a number but was ', typeof src.psiF, src.psiF)
                        }
                    }
                    if (src.c1 !== undefined && src.c1 !== null) {
                        if (typeof src.c1 === "number" || src.c1 === 'NaN' || src.c1 === 'Infinity' || src.c1 === '-Infinity') {
                            dst.c1 = AsNum(src.c1);
                        }
                        else {
                            console.log('Expected c1 of StBarTorsional to be a number but was ', typeof src.c1, src.c1)
                        }
                    }
                    if (src.c2 !== undefined && src.c2 !== null) {
                        if (typeof src.c2 === "number" || src.c2 === 'NaN' || src.c2 === 'Infinity' || src.c2 === '-Infinity') {
                            dst.c2 = AsNum(src.c2);
                        }
                        else {
                            console.log('Expected c2 of StBarTorsional to be a number but was ', typeof src.c2, src.c2)
                        }
                    }
                    if (src.c3 !== undefined && src.c3 !== null) {
                        if (typeof src.c3 === "number" || src.c3 === 'NaN' || src.c3 === 'Infinity' || src.c3 === '-Infinity') {
                            dst.c3 = AsNum(src.c3);
                        }
                        else {
                            console.log('Expected c3 of StBarTorsional to be a number but was ', typeof src.c3, src.c3)
                        }
                    }
                    if (src.kz !== undefined && src.kz !== null) {
                        if (typeof src.kz === "number" || src.kz === 'NaN' || src.kz === 'Infinity' || src.kz === '-Infinity') {
                            dst.kz = AsNum(src.kz);
                        }
                        else {
                            console.log('Expected kz of StBarTorsional to be a number but was ', typeof src.kz, src.kz)
                        }
                    }
                    if (src.kw !== undefined && src.kw !== null) {
                        if (typeof src.kw === "number" || src.kw === 'NaN' || src.kw === 'Infinity' || src.kw === '-Infinity') {
                            dst.kw = AsNum(src.kw);
                        }
                        else {
                            console.log('Expected kw of StBarTorsional to be a number but was ', typeof src.kw, src.kw)
                        }
                    }
                    if (src.loadPos !== undefined && src.loadPos !== null) {
                        dst.loadPos = ng.fem_design.steel_output.Alignment_FromObject(src.loadPos);
                    }
                    if (src.zg !== undefined && src.zg !== null) {
                        if (typeof src.zg === "number" || src.zg === 'NaN' || src.zg === 'Infinity' || src.zg === '-Infinity') {
                            dst.zg = AsNum(src.zg);
                        }
                        else {
                            console.log('Expected zg of StBarTorsional to be a number but was ', typeof src.zg, src.zg)
                        }
                    }
                    if (src.zj !== undefined && src.zj !== null) {
                        if (typeof src.zj === "number" || src.zj === 'NaN' || src.zj === 'Infinity' || src.zj === '-Infinity') {
                            dst.zj = AsNum(src.zj);
                        }
                        else {
                            console.log('Expected zj of StBarTorsional to be a number but was ', typeof src.zj, src.zj)
                        }
                    }
                    if (src.c2zgC3zj !== undefined && src.c2zgC3zj !== null) {
                        if (typeof src.c2zgC3zj === "number" || src.c2zgC3zj === 'NaN' || src.c2zgC3zj === 'Infinity' || src.c2zgC3zj === '-Infinity') {
                            dst.c2zgC3zj = AsNum(src.c2zgC3zj);
                        }
                        else {
                            console.log('Expected c2zgC3zj of StBarTorsional to be a number but was ', typeof src.c2zgC3zj, src.c2zgC3zj)
                        }
                    }
                    if (src.ncrLT !== undefined && src.ncrLT !== null) {
                        if (typeof src.ncrLT === "number" || src.ncrLT === 'NaN' || src.ncrLT === 'Infinity' || src.ncrLT === '-Infinity') {
                            dst.ncrLT = AsNum(src.ncrLT);
                        }
                        else {
                            console.log('Expected ncrLT of StBarTorsional to be a number but was ', typeof src.ncrLT, src.ncrLT)
                        }
                    }
                    if (src.mcr !== undefined && src.mcr !== null) {
                        if (typeof src.mcr === "number" || src.mcr === 'NaN' || src.mcr === 'Infinity' || src.mcr === '-Infinity') {
                            dst.mcr = AsNum(src.mcr);
                        }
                        else {
                            console.log('Expected mcr of StBarTorsional to be a number but was ', typeof src.mcr, src.mcr)
                        }
                    }
                    if (src.rLambdaLT !== undefined && src.rLambdaLT !== null) {
                        if (typeof src.rLambdaLT === "number" || src.rLambdaLT === 'NaN' || src.rLambdaLT === 'Infinity' || src.rLambdaLT === '-Infinity') {
                            dst.rLambdaLT = AsNum(src.rLambdaLT);
                        }
                        else {
                            console.log('Expected rLambdaLT of StBarTorsional to be a number but was ', typeof src.rLambdaLT, src.rLambdaLT)
                        }
                    }
                    if (src.curveLT !== undefined && src.curveLT !== null) {
                        dst.curveLT = ng.fem_design.steel_output.CurveLT_FromObject(src.curveLT);
                    }
                    if (src.rAlphaLT !== undefined && src.rAlphaLT !== null) {
                        if (typeof src.rAlphaLT === "number" || src.rAlphaLT === 'NaN' || src.rAlphaLT === 'Infinity' || src.rAlphaLT === '-Infinity') {
                            dst.rAlphaLT = AsNum(src.rAlphaLT);
                        }
                        else {
                            console.log('Expected rAlphaLT of StBarTorsional to be a number but was ', typeof src.rAlphaLT, src.rAlphaLT)
                        }
                    }
                    if (src.rPhiLT !== undefined && src.rPhiLT !== null) {
                        if (typeof src.rPhiLT === "number" || src.rPhiLT === 'NaN' || src.rPhiLT === 'Infinity' || src.rPhiLT === '-Infinity') {
                            dst.rPhiLT = AsNum(src.rPhiLT);
                        }
                        else {
                            console.log('Expected rPhiLT of StBarTorsional to be a number but was ', typeof src.rPhiLT, src.rPhiLT)
                        }
                    }
                    if (src.rChiLT !== undefined && src.rChiLT !== null) {
                        if (typeof src.rChiLT === "number" || src.rChiLT === 'NaN' || src.rChiLT === 'Infinity' || src.rChiLT === '-Infinity') {
                            dst.rChiLT = AsNum(src.rChiLT);
                        }
                        else {
                            console.log('Expected rChiLT of StBarTorsional to be a number but was ', typeof src.rChiLT, src.rChiLT)
                        }
                    }
                    if (src.rChiLTBasic !== undefined && src.rChiLTBasic !== null) {
                        if (typeof src.rChiLTBasic === "number" || src.rChiLTBasic === 'NaN' || src.rChiLTBasic === 'Infinity' || src.rChiLTBasic === '-Infinity') {
                            dst.rChiLTBasic = AsNum(src.rChiLTBasic);
                        }
                        else {
                            console.log('Expected rChiLTBasic of StBarTorsional to be a number but was ', typeof src.rChiLTBasic, src.rChiLTBasic)
                        }
                    }
                    if (src.factorf !== undefined && src.factorf !== null) {
                        if (typeof src.factorf === "number" || src.factorf === 'NaN' || src.factorf === 'Infinity' || src.factorf === '-Infinity') {
                            dst.factorf = AsNum(src.factorf);
                        }
                        else {
                            console.log('Expected factorf of StBarTorsional to be a number but was ', typeof src.factorf, src.factorf)
                        }
                    }
                    if (src.rLambda0 !== undefined && src.rLambda0 !== null) {
                        if (typeof src.rLambda0 === "number" || src.rLambda0 === 'NaN' || src.rLambda0 === 'Infinity' || src.rLambda0 === '-Infinity') {
                            dst.rLambda0 = AsNum(src.rLambda0);
                        }
                        else {
                            console.log('Expected rLambda0 of StBarTorsional to be a number but was ', typeof src.rLambda0, src.rLambda0)
                        }
                    }
                    if (src.rLambdaLTFi !== undefined && src.rLambdaLTFi !== null) {
                        if (typeof src.rLambdaLTFi === "number" || src.rLambdaLTFi === 'NaN' || src.rLambdaLTFi === 'Infinity' || src.rLambdaLTFi === '-Infinity') {
                            dst.rLambdaLTFi = AsNum(src.rLambdaLTFi);
                        }
                        else {
                            console.log('Expected rLambdaLTFi of StBarTorsional to be a number but was ', typeof src.rLambdaLTFi, src.rLambdaLTFi)
                        }
                    }
                    return dst;
                }

                static toObject(src: StBarTorsional | null | undefined): StBarTorsional_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarTorsional is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarTorsional") {
                        console.error('Expected ng.fem_design.steel_output.StBarTorsional but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const curve_obj = ng.fem_design.steel_output.Curve_ToObject(src.curve);
                    if(curve_obj === null) return null;

                    const loadPos_obj = ng.fem_design.steel_output.Alignment_ToObject(src.loadPos);
                    if(loadPos_obj === null) return null;

                    const curveLT_obj = ng.fem_design.steel_output.CurveLT_ToObject(src.curveLT);
                    if(curveLT_obj === null) return null;

                    const dst : StBarTorsional_json = {
                        fCalculated: src.fCalculated,
                        fCalculatedNotImplemented: src.fCalculatedNotImplemented,
                        rUtil: AsJsonNum(src.rUtil),
                        fTopComp: src.fTopComp,
                        rkc: AsJsonNum(src.rkc),
                        rLcr: AsJsonNum(src.rLcr),
                        rifz: AsJsonNum(src.rifz),
                        rLambdaF: AsJsonNum(src.rLambdaF),
                        rMcRd: AsJsonNum(src.rMcRd),
                        rMbRd: AsJsonNum(src.rMbRd),
                        rChi: AsJsonNum(src.rChi),
                        rPhi: AsJsonNum(src.rPhi),
                        rAlfa: AsJsonNum(src.rAlfa),
                        curve: curve_obj,
                        fCalcGeneralMethod: src.fCalcGeneralMethod,
                        fCalcGeneralMethodSpecForl: src.fCalcGeneralMethodSpecForl,
                        psi: AsJsonNum(src.psi),
                        psiF: AsJsonNum(src.psiF),
                        c1: AsJsonNum(src.c1),
                        c2: AsJsonNum(src.c2),
                        c3: AsJsonNum(src.c3),
                        kz: AsJsonNum(src.kz),
                        kw: AsJsonNum(src.kw),
                        loadPos: loadPos_obj,
                        zg: AsJsonNum(src.zg),
                        zj: AsJsonNum(src.zj),
                        c2zgC3zj: AsJsonNum(src.c2zgC3zj),
                        ncrLT: AsJsonNum(src.ncrLT),
                        mcr: AsJsonNum(src.mcr),
                        rLambdaLT: AsJsonNum(src.rLambdaLT),
                        curveLT: curveLT_obj,
                        rAlphaLT: AsJsonNum(src.rAlphaLT),
                        rPhiLT: AsJsonNum(src.rPhiLT),
                        rChiLT: AsJsonNum(src.rChiLT),
                        rChiLTBasic: AsJsonNum(src.rChiLTBasic),
                        factorf: AsJsonNum(src.factorf),
                        rLambda0: AsJsonNum(src.rLambda0),
                        rLambdaLTFi: AsJsonNum(src.rLambdaLTFi),
                    };
                    if(src.rMEdMax !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMEdMax);
                        if(parsed === null) return null;
                        dst.rMEdMax = parsed;
                    }
                    return dst;
                }

                static create(src?: StBarTorsional_createType) {
                    const dst = new StBarTorsional();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.fCalculatedNotImplemented !== undefined) {
                        dst.fCalculatedNotImplemented = src.fCalculatedNotImplemented;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    if (src.fTopComp !== undefined) {
                        dst.fTopComp = src.fTopComp;
                    }
                    if (src.rkc !== undefined) {
                        dst.rkc = src.rkc;
                    }
                    if (src.rLcr !== undefined) {
                        dst.rLcr = src.rLcr;
                    }
                    if (src.rifz !== undefined) {
                        dst.rifz = src.rifz;
                    }
                    if (src.rLambdaF !== undefined) {
                        dst.rLambdaF = src.rLambdaF;
                    }
                    if (src.rMEdMax !== undefined) {
                        dst.rMEdMax = src.rMEdMax;
                    }
                    if (src.rMcRd !== undefined) {
                        dst.rMcRd = src.rMcRd;
                    }
                    if (src.rMbRd !== undefined) {
                        dst.rMbRd = src.rMbRd;
                    }
                    if (src.rChi !== undefined) {
                        dst.rChi = src.rChi;
                    }
                    if (src.rPhi !== undefined) {
                        dst.rPhi = src.rPhi;
                    }
                    if (src.rAlfa !== undefined) {
                        dst.rAlfa = src.rAlfa;
                    }
                    if (src.curve !== undefined) {
                        dst.curve = src.curve;
                    }
                    if (src.fCalcGeneralMethod !== undefined) {
                        dst.fCalcGeneralMethod = src.fCalcGeneralMethod;
                    }
                    if (src.fCalcGeneralMethodSpecForl !== undefined) {
                        dst.fCalcGeneralMethodSpecForl = src.fCalcGeneralMethodSpecForl;
                    }
                    if (src.psi !== undefined) {
                        dst.psi = src.psi;
                    }
                    if (src.psiF !== undefined) {
                        dst.psiF = src.psiF;
                    }
                    if (src.c1 !== undefined) {
                        dst.c1 = src.c1;
                    }
                    if (src.c2 !== undefined) {
                        dst.c2 = src.c2;
                    }
                    if (src.c3 !== undefined) {
                        dst.c3 = src.c3;
                    }
                    if (src.kz !== undefined) {
                        dst.kz = src.kz;
                    }
                    if (src.kw !== undefined) {
                        dst.kw = src.kw;
                    }
                    if (src.loadPos !== undefined) {
                        dst.loadPos = src.loadPos;
                    }
                    if (src.zg !== undefined) {
                        dst.zg = src.zg;
                    }
                    if (src.zj !== undefined) {
                        dst.zj = src.zj;
                    }
                    if (src.c2zgC3zj !== undefined) {
                        dst.c2zgC3zj = src.c2zgC3zj;
                    }
                    if (src.ncrLT !== undefined) {
                        dst.ncrLT = src.ncrLT;
                    }
                    if (src.mcr !== undefined) {
                        dst.mcr = src.mcr;
                    }
                    if (src.rLambdaLT !== undefined) {
                        dst.rLambdaLT = src.rLambdaLT;
                    }
                    if (src.curveLT !== undefined) {
                        dst.curveLT = src.curveLT;
                    }
                    if (src.rAlphaLT !== undefined) {
                        dst.rAlphaLT = src.rAlphaLT;
                    }
                    if (src.rPhiLT !== undefined) {
                        dst.rPhiLT = src.rPhiLT;
                    }
                    if (src.rChiLT !== undefined) {
                        dst.rChiLT = src.rChiLT;
                    }
                    if (src.rChiLTBasic !== undefined) {
                        dst.rChiLTBasic = src.rChiLTBasic;
                    }
                    if (src.factorf !== undefined) {
                        dst.factorf = src.factorf;
                    }
                    if (src.rLambda0 !== undefined) {
                        dst.rLambda0 = src.rLambda0;
                    }
                    if (src.rLambdaLTFi !== undefined) {
                        dst.rLambdaLTFi = src.rLambdaLTFi;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarTorsional();
                    dst.fCalculated = this.fCalculated;
                    dst.fCalculatedNotImplemented = this.fCalculatedNotImplemented;
                    dst.rUtil = this.rUtil;
                    dst.fTopComp = this.fTopComp;
                    dst.rkc = this.rkc;
                    dst.rLcr = this.rLcr;
                    dst.rifz = this.rifz;
                    dst.rLambdaF = this.rLambdaF;
                    dst.rMEdMax = this.rMEdMax;
                    dst.rMcRd = this.rMcRd;
                    dst.rMbRd = this.rMbRd;
                    dst.rChi = this.rChi;
                    dst.rPhi = this.rPhi;
                    dst.rAlfa = this.rAlfa;
                    dst.curve = this.curve;
                    dst.fCalcGeneralMethod = this.fCalcGeneralMethod;
                    dst.fCalcGeneralMethodSpecForl = this.fCalcGeneralMethodSpecForl;
                    dst.psi = this.psi;
                    dst.psiF = this.psiF;
                    dst.c1 = this.c1;
                    dst.c2 = this.c2;
                    dst.c3 = this.c3;
                    dst.kz = this.kz;
                    dst.kw = this.kw;
                    dst.loadPos = this.loadPos;
                    dst.zg = this.zg;
                    dst.zj = this.zj;
                    dst.c2zgC3zj = this.c2zgC3zj;
                    dst.ncrLT = this.ncrLT;
                    dst.mcr = this.mcr;
                    dst.rLambdaLT = this.rLambdaLT;
                    dst.curveLT = this.curveLT;
                    dst.rAlphaLT = this.rAlphaLT;
                    dst.rPhiLT = this.rPhiLT;
                    dst.rChiLT = this.rChiLT;
                    dst.rChiLTBasic = this.rChiLTBasic;
                    dst.factorf = this.factorf;
                    dst.rLambda0 = this.rLambda0;
                    dst.rLambdaLTFi = this.rLambdaLTFi;
                    return dst;
                }

                deepClone() {
                    const json = StBarTorsional.toObject(this);
                    const dst = StBarTorsional.fromObject(json);
                    return dst;
                }
            }
            export type IStBarTorsional = StBarTorsional;


            export type StBarWeb_keys = 'fCalculated' | 'rUtil' | 'ra' | 'rkTau' | 'rVBwRd' | 'rVBfRd' | 'rVBRd' | 'rVBwRdFi' | 'rMyEdMax' | 'rMFRd' | 'rMFk' | 'rSigmaE' | 'rTauCr' | 'rLambdaW' | 'rChi' | 'rhw' | 'rt' | 'rAF' | 'rtf' | 'rbf' | 'rc' | 'vzEd' | 'relevant';
            export interface StBarWeb_createType {
                fCalculated?: boolean,
                rUtil?: number,
                ra?: number,
                rkTau?: number,
                rVBwRd?: number,
                rVBfRd?: number,
                rVBRd?: number,
                rVBwRdFi?: number,
                rMyEdMax?: number,
                rMFRd?: number,
                rMFk?: number,
                rSigmaE?: number,
                rTauCr?: number,
                rLambdaW?: number,
                rChi?: number,
                rhw?: number,
                rt?: number,
                rAF?: ng.fem_design.steel_output.Vector2D | null,
                rtf?: number,
                rbf?: number,
                rc?: number,
                vzEd?: number,
                relevant?: ng.fem_design.steel_output.StBarWebRelevant,
            }
            export interface StBarWeb_json {
                fCalculated?: boolean;
                rUtil?: JsonNumber;
                ra?: JsonNumber;
                rkTau?: JsonNumber;
                rVBwRd?: JsonNumber;
                rVBfRd?: JsonNumber;
                rVBRd?: JsonNumber;
                rVBwRdFi?: JsonNumber;
                rMyEdMax?: JsonNumber;
                rMFRd?: JsonNumber;
                rMFk?: JsonNumber;
                rSigmaE?: JsonNumber;
                rTauCr?: JsonNumber;
                rLambdaW?: JsonNumber;
                rChi?: JsonNumber;
                rhw?: JsonNumber;
                rt?: JsonNumber;
                rAF?: ng.fem_design.steel_output.Vector2D_json;
                rtf?: JsonNumber;
                rbf?: JsonNumber;
                rc?: JsonNumber;
                vzEd?: JsonNumber;
                relevant?: string;
            }
            interface StBarWeb_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                rUtil?: unknown;
                ra?: unknown;
                rkTau?: unknown;
                rVBwRd?: unknown;
                rVBfRd?: unknown;
                rVBRd?: unknown;
                rVBwRdFi?: unknown;
                rMyEdMax?: unknown;
                rMFRd?: unknown;
                rMFk?: unknown;
                rSigmaE?: unknown;
                rTauCr?: unknown;
                rLambdaW?: unknown;
                rChi?: unknown;
                rhw?: unknown;
                rt?: unknown;
                rAF?: unknown;
                rtf?: unknown;
                rbf?: unknown;
                rc?: unknown;
                vzEd?: unknown;
                relevant?: unknown;
            }
            export class StBarWeb {
                __proto_name = "ng.fem_design.steel_output.StBarWeb";
                fCalculated: boolean = false;
                rUtil: number = 0;
                ra: number = 0;
                rkTau: number = 0;
                rVBwRd: number = 0;
                rVBfRd: number = 0;
                rVBRd: number = 0;
                rVBwRdFi: number = 0;
                rMyEdMax: number = 0;
                rMFRd: number = 0;
                rMFk: number = 0;
                rSigmaE: number = 0;
                rTauCr: number = 0;
                rLambdaW: number = 0;
                rChi: number = 0;
                rhw: number = 0;
                rt: number = 0;
                rAF: ng.fem_design.steel_output.Vector2D | null = null;
                rtf: number = 0;
                rbf: number = 0;
                rc: number = 0;
                vzEd: number = 0;
                relevant: ng.fem_design.steel_output.StBarWebRelevant = ng.fem_design.steel_output.StBarWebRelevant.ST_BAR_WEB_RELEVANT_NO;

                static fromObject(src_unknown: unknown): StBarWeb {
                    const dst = new StBarWeb();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarWeb but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarWeb_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarWeb but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarWeb to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        if (typeof src.rUtil === "number" || src.rUtil === 'NaN' || src.rUtil === 'Infinity' || src.rUtil === '-Infinity') {
                            dst.rUtil = AsNum(src.rUtil);
                        }
                        else {
                            console.log('Expected rUtil of StBarWeb to be a number but was ', typeof src.rUtil, src.rUtil)
                        }
                    }
                    if (src.ra !== undefined && src.ra !== null) {
                        if (typeof src.ra === "number" || src.ra === 'NaN' || src.ra === 'Infinity' || src.ra === '-Infinity') {
                            dst.ra = AsNum(src.ra);
                        }
                        else {
                            console.log('Expected ra of StBarWeb to be a number but was ', typeof src.ra, src.ra)
                        }
                    }
                    if (src.rkTau !== undefined && src.rkTau !== null) {
                        if (typeof src.rkTau === "number" || src.rkTau === 'NaN' || src.rkTau === 'Infinity' || src.rkTau === '-Infinity') {
                            dst.rkTau = AsNum(src.rkTau);
                        }
                        else {
                            console.log('Expected rkTau of StBarWeb to be a number but was ', typeof src.rkTau, src.rkTau)
                        }
                    }
                    if (src.rVBwRd !== undefined && src.rVBwRd !== null) {
                        if (typeof src.rVBwRd === "number" || src.rVBwRd === 'NaN' || src.rVBwRd === 'Infinity' || src.rVBwRd === '-Infinity') {
                            dst.rVBwRd = AsNum(src.rVBwRd);
                        }
                        else {
                            console.log('Expected rVBwRd of StBarWeb to be a number but was ', typeof src.rVBwRd, src.rVBwRd)
                        }
                    }
                    if (src.rVBfRd !== undefined && src.rVBfRd !== null) {
                        if (typeof src.rVBfRd === "number" || src.rVBfRd === 'NaN' || src.rVBfRd === 'Infinity' || src.rVBfRd === '-Infinity') {
                            dst.rVBfRd = AsNum(src.rVBfRd);
                        }
                        else {
                            console.log('Expected rVBfRd of StBarWeb to be a number but was ', typeof src.rVBfRd, src.rVBfRd)
                        }
                    }
                    if (src.rVBRd !== undefined && src.rVBRd !== null) {
                        if (typeof src.rVBRd === "number" || src.rVBRd === 'NaN' || src.rVBRd === 'Infinity' || src.rVBRd === '-Infinity') {
                            dst.rVBRd = AsNum(src.rVBRd);
                        }
                        else {
                            console.log('Expected rVBRd of StBarWeb to be a number but was ', typeof src.rVBRd, src.rVBRd)
                        }
                    }
                    if (src.rVBwRdFi !== undefined && src.rVBwRdFi !== null) {
                        if (typeof src.rVBwRdFi === "number" || src.rVBwRdFi === 'NaN' || src.rVBwRdFi === 'Infinity' || src.rVBwRdFi === '-Infinity') {
                            dst.rVBwRdFi = AsNum(src.rVBwRdFi);
                        }
                        else {
                            console.log('Expected rVBwRdFi of StBarWeb to be a number but was ', typeof src.rVBwRdFi, src.rVBwRdFi)
                        }
                    }
                    if (src.rMyEdMax !== undefined && src.rMyEdMax !== null) {
                        if (typeof src.rMyEdMax === "number" || src.rMyEdMax === 'NaN' || src.rMyEdMax === 'Infinity' || src.rMyEdMax === '-Infinity') {
                            dst.rMyEdMax = AsNum(src.rMyEdMax);
                        }
                        else {
                            console.log('Expected rMyEdMax of StBarWeb to be a number but was ', typeof src.rMyEdMax, src.rMyEdMax)
                        }
                    }
                    if (src.rMFRd !== undefined && src.rMFRd !== null) {
                        if (typeof src.rMFRd === "number" || src.rMFRd === 'NaN' || src.rMFRd === 'Infinity' || src.rMFRd === '-Infinity') {
                            dst.rMFRd = AsNum(src.rMFRd);
                        }
                        else {
                            console.log('Expected rMFRd of StBarWeb to be a number but was ', typeof src.rMFRd, src.rMFRd)
                        }
                    }
                    if (src.rMFk !== undefined && src.rMFk !== null) {
                        if (typeof src.rMFk === "number" || src.rMFk === 'NaN' || src.rMFk === 'Infinity' || src.rMFk === '-Infinity') {
                            dst.rMFk = AsNum(src.rMFk);
                        }
                        else {
                            console.log('Expected rMFk of StBarWeb to be a number but was ', typeof src.rMFk, src.rMFk)
                        }
                    }
                    if (src.rSigmaE !== undefined && src.rSigmaE !== null) {
                        if (typeof src.rSigmaE === "number" || src.rSigmaE === 'NaN' || src.rSigmaE === 'Infinity' || src.rSigmaE === '-Infinity') {
                            dst.rSigmaE = AsNum(src.rSigmaE);
                        }
                        else {
                            console.log('Expected rSigmaE of StBarWeb to be a number but was ', typeof src.rSigmaE, src.rSigmaE)
                        }
                    }
                    if (src.rTauCr !== undefined && src.rTauCr !== null) {
                        if (typeof src.rTauCr === "number" || src.rTauCr === 'NaN' || src.rTauCr === 'Infinity' || src.rTauCr === '-Infinity') {
                            dst.rTauCr = AsNum(src.rTauCr);
                        }
                        else {
                            console.log('Expected rTauCr of StBarWeb to be a number but was ', typeof src.rTauCr, src.rTauCr)
                        }
                    }
                    if (src.rLambdaW !== undefined && src.rLambdaW !== null) {
                        if (typeof src.rLambdaW === "number" || src.rLambdaW === 'NaN' || src.rLambdaW === 'Infinity' || src.rLambdaW === '-Infinity') {
                            dst.rLambdaW = AsNum(src.rLambdaW);
                        }
                        else {
                            console.log('Expected rLambdaW of StBarWeb to be a number but was ', typeof src.rLambdaW, src.rLambdaW)
                        }
                    }
                    if (src.rChi !== undefined && src.rChi !== null) {
                        if (typeof src.rChi === "number" || src.rChi === 'NaN' || src.rChi === 'Infinity' || src.rChi === '-Infinity') {
                            dst.rChi = AsNum(src.rChi);
                        }
                        else {
                            console.log('Expected rChi of StBarWeb to be a number but was ', typeof src.rChi, src.rChi)
                        }
                    }
                    if (src.rhw !== undefined && src.rhw !== null) {
                        if (typeof src.rhw === "number" || src.rhw === 'NaN' || src.rhw === 'Infinity' || src.rhw === '-Infinity') {
                            dst.rhw = AsNum(src.rhw);
                        }
                        else {
                            console.log('Expected rhw of StBarWeb to be a number but was ', typeof src.rhw, src.rhw)
                        }
                    }
                    if (src.rt !== undefined && src.rt !== null) {
                        if (typeof src.rt === "number" || src.rt === 'NaN' || src.rt === 'Infinity' || src.rt === '-Infinity') {
                            dst.rt = AsNum(src.rt);
                        }
                        else {
                            console.log('Expected rt of StBarWeb to be a number but was ', typeof src.rt, src.rt)
                        }
                    }
                    if (src.rAF !== undefined && src.rAF !== null) {
                        dst.rAF = ng.fem_design.steel_output.Vector2D.fromObject(src.rAF);
                    }
                    if (src.rtf !== undefined && src.rtf !== null) {
                        if (typeof src.rtf === "number" || src.rtf === 'NaN' || src.rtf === 'Infinity' || src.rtf === '-Infinity') {
                            dst.rtf = AsNum(src.rtf);
                        }
                        else {
                            console.log('Expected rtf of StBarWeb to be a number but was ', typeof src.rtf, src.rtf)
                        }
                    }
                    if (src.rbf !== undefined && src.rbf !== null) {
                        if (typeof src.rbf === "number" || src.rbf === 'NaN' || src.rbf === 'Infinity' || src.rbf === '-Infinity') {
                            dst.rbf = AsNum(src.rbf);
                        }
                        else {
                            console.log('Expected rbf of StBarWeb to be a number but was ', typeof src.rbf, src.rbf)
                        }
                    }
                    if (src.rc !== undefined && src.rc !== null) {
                        if (typeof src.rc === "number" || src.rc === 'NaN' || src.rc === 'Infinity' || src.rc === '-Infinity') {
                            dst.rc = AsNum(src.rc);
                        }
                        else {
                            console.log('Expected rc of StBarWeb to be a number but was ', typeof src.rc, src.rc)
                        }
                    }
                    if (src.vzEd !== undefined && src.vzEd !== null) {
                        if (typeof src.vzEd === "number" || src.vzEd === 'NaN' || src.vzEd === 'Infinity' || src.vzEd === '-Infinity') {
                            dst.vzEd = AsNum(src.vzEd);
                        }
                        else {
                            console.log('Expected vzEd of StBarWeb to be a number but was ', typeof src.vzEd, src.vzEd)
                        }
                    }
                    if (src.relevant !== undefined && src.relevant !== null) {
                        dst.relevant = ng.fem_design.steel_output.StBarWebRelevant_FromObject(src.relevant);
                    }
                    return dst;
                }

                static toObject(src: StBarWeb | null | undefined): StBarWeb_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarWeb is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarWeb") {
                        console.error('Expected ng.fem_design.steel_output.StBarWeb but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const relevant_obj = ng.fem_design.steel_output.StBarWebRelevant_ToObject(src.relevant);
                    if(relevant_obj === null) return null;

                    const dst : StBarWeb_json = {
                        fCalculated: src.fCalculated,
                        rUtil: AsJsonNum(src.rUtil),
                        ra: AsJsonNum(src.ra),
                        rkTau: AsJsonNum(src.rkTau),
                        rVBwRd: AsJsonNum(src.rVBwRd),
                        rVBfRd: AsJsonNum(src.rVBfRd),
                        rVBRd: AsJsonNum(src.rVBRd),
                        rVBwRdFi: AsJsonNum(src.rVBwRdFi),
                        rMyEdMax: AsJsonNum(src.rMyEdMax),
                        rMFRd: AsJsonNum(src.rMFRd),
                        rMFk: AsJsonNum(src.rMFk),
                        rSigmaE: AsJsonNum(src.rSigmaE),
                        rTauCr: AsJsonNum(src.rTauCr),
                        rLambdaW: AsJsonNum(src.rLambdaW),
                        rChi: AsJsonNum(src.rChi),
                        rhw: AsJsonNum(src.rhw),
                        rt: AsJsonNum(src.rt),
                        rtf: AsJsonNum(src.rtf),
                        rbf: AsJsonNum(src.rbf),
                        rc: AsJsonNum(src.rc),
                        vzEd: AsJsonNum(src.vzEd),
                        relevant: relevant_obj,
                    };
                    if(src.rAF !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rAF);
                        if(parsed === null) return null;
                        dst.rAF = parsed;
                    }
                    return dst;
                }

                static create(src?: StBarWeb_createType) {
                    const dst = new StBarWeb();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    if (src.ra !== undefined) {
                        dst.ra = src.ra;
                    }
                    if (src.rkTau !== undefined) {
                        dst.rkTau = src.rkTau;
                    }
                    if (src.rVBwRd !== undefined) {
                        dst.rVBwRd = src.rVBwRd;
                    }
                    if (src.rVBfRd !== undefined) {
                        dst.rVBfRd = src.rVBfRd;
                    }
                    if (src.rVBRd !== undefined) {
                        dst.rVBRd = src.rVBRd;
                    }
                    if (src.rVBwRdFi !== undefined) {
                        dst.rVBwRdFi = src.rVBwRdFi;
                    }
                    if (src.rMyEdMax !== undefined) {
                        dst.rMyEdMax = src.rMyEdMax;
                    }
                    if (src.rMFRd !== undefined) {
                        dst.rMFRd = src.rMFRd;
                    }
                    if (src.rMFk !== undefined) {
                        dst.rMFk = src.rMFk;
                    }
                    if (src.rSigmaE !== undefined) {
                        dst.rSigmaE = src.rSigmaE;
                    }
                    if (src.rTauCr !== undefined) {
                        dst.rTauCr = src.rTauCr;
                    }
                    if (src.rLambdaW !== undefined) {
                        dst.rLambdaW = src.rLambdaW;
                    }
                    if (src.rChi !== undefined) {
                        dst.rChi = src.rChi;
                    }
                    if (src.rhw !== undefined) {
                        dst.rhw = src.rhw;
                    }
                    if (src.rt !== undefined) {
                        dst.rt = src.rt;
                    }
                    if (src.rAF !== undefined) {
                        dst.rAF = src.rAF;
                    }
                    if (src.rtf !== undefined) {
                        dst.rtf = src.rtf;
                    }
                    if (src.rbf !== undefined) {
                        dst.rbf = src.rbf;
                    }
                    if (src.rc !== undefined) {
                        dst.rc = src.rc;
                    }
                    if (src.vzEd !== undefined) {
                        dst.vzEd = src.vzEd;
                    }
                    if (src.relevant !== undefined) {
                        dst.relevant = src.relevant;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarWeb();
                    dst.fCalculated = this.fCalculated;
                    dst.rUtil = this.rUtil;
                    dst.ra = this.ra;
                    dst.rkTau = this.rkTau;
                    dst.rVBwRd = this.rVBwRd;
                    dst.rVBfRd = this.rVBfRd;
                    dst.rVBRd = this.rVBRd;
                    dst.rVBwRdFi = this.rVBwRdFi;
                    dst.rMyEdMax = this.rMyEdMax;
                    dst.rMFRd = this.rMFRd;
                    dst.rMFk = this.rMFk;
                    dst.rSigmaE = this.rSigmaE;
                    dst.rTauCr = this.rTauCr;
                    dst.rLambdaW = this.rLambdaW;
                    dst.rChi = this.rChi;
                    dst.rhw = this.rhw;
                    dst.rt = this.rt;
                    dst.rAF = this.rAF;
                    dst.rtf = this.rtf;
                    dst.rbf = this.rbf;
                    dst.rc = this.rc;
                    dst.vzEd = this.vzEd;
                    dst.relevant = this.relevant;
                    return dst;
                }

                deepClone() {
                    const json = StBarWeb.toObject(this);
                    const dst = StBarWeb.fromObject(json);
                    return dst;
                }
            }
            export type IStBarWeb = StBarWeb;


            export type StBarInteraction_keys = 'fCalculated' | 'rUtil' | 'rNRk' | 'rMRk' | 'rMEd' | 'rMEdMax' | 'rDeltaX' | 'psi' | 'rDeltaMEd' | 'rAlpha' | 'rPsi' | 'rCM' | 'rCMLT' | 'c11' | 'c12' | 'c21' | 'c22' | 'rk11' | 'rk12' | 'rk21' | 'rk22' | 'cm10' | 'cm20' | 'betaM';
            export interface StBarInteraction_createType {
                fCalculated?: boolean,
                rUtil?: ng.fem_design.steel_output.Vector2D | null,
                rNRk?: number,
                rMRk?: ng.fem_design.steel_output.Vector2D | null,
                rMEd?: ng.fem_design.steel_output.Vector2D | null,
                rMEdMax?: ng.fem_design.steel_output.Vector2D | null,
                rDeltaX?: ng.fem_design.steel_output.Vector2D | null,
                psi?: ng.fem_design.steel_output.Vector2D | null,
                rDeltaMEd?: ng.fem_design.steel_output.Vector2D | null,
                rAlpha?: ng.fem_design.steel_output.Vector4D | null,
                rPsi?: ng.fem_design.steel_output.Vector4D | null,
                rCM?: ng.fem_design.steel_output.Vector2D | null,
                rCMLT?: ng.fem_design.steel_output.Vector2D | null,
                c11?: number,
                c12?: number,
                c21?: number,
                c22?: number,
                rk11?: number,
                rk12?: number,
                rk21?: number,
                rk22?: number,
                cm10?: number,
                cm20?: number,
                betaM?: ng.fem_design.steel_output.Vector4D | null,
            }
            export interface StBarInteraction_json {
                fCalculated?: boolean;
                rUtil?: ng.fem_design.steel_output.Vector2D_json;
                rNRk?: JsonNumber;
                rMRk?: ng.fem_design.steel_output.Vector2D_json;
                rMEd?: ng.fem_design.steel_output.Vector2D_json;
                rMEdMax?: ng.fem_design.steel_output.Vector2D_json;
                rDeltaX?: ng.fem_design.steel_output.Vector2D_json;
                psi?: ng.fem_design.steel_output.Vector2D_json;
                rDeltaMEd?: ng.fem_design.steel_output.Vector2D_json;
                rAlpha?: ng.fem_design.steel_output.Vector4D_json;
                rPsi?: ng.fem_design.steel_output.Vector4D_json;
                rCM?: ng.fem_design.steel_output.Vector2D_json;
                rCMLT?: ng.fem_design.steel_output.Vector2D_json;
                c11?: JsonNumber;
                c12?: JsonNumber;
                c21?: JsonNumber;
                c22?: JsonNumber;
                rk11?: JsonNumber;
                rk12?: JsonNumber;
                rk21?: JsonNumber;
                rk22?: JsonNumber;
                cm10?: JsonNumber;
                cm20?: JsonNumber;
                betaM?: ng.fem_design.steel_output.Vector4D_json;
            }
            interface StBarInteraction_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                rUtil?: unknown;
                rNRk?: unknown;
                rMRk?: unknown;
                rMEd?: unknown;
                rMEdMax?: unknown;
                rDeltaX?: unknown;
                psi?: unknown;
                rDeltaMEd?: unknown;
                rAlpha?: unknown;
                rPsi?: unknown;
                rCM?: unknown;
                rCMLT?: unknown;
                c11?: unknown;
                c12?: unknown;
                c21?: unknown;
                c22?: unknown;
                rk11?: unknown;
                rk12?: unknown;
                rk21?: unknown;
                rk22?: unknown;
                cm10?: unknown;
                cm20?: unknown;
                betaM?: unknown;
            }
            export class StBarInteraction {
                __proto_name = "ng.fem_design.steel_output.StBarInteraction";
                fCalculated: boolean = false;
                rUtil: ng.fem_design.steel_output.Vector2D | null = null;
                rNRk: number = 0;
                rMRk: ng.fem_design.steel_output.Vector2D | null = null;
                rMEd: ng.fem_design.steel_output.Vector2D | null = null;
                rMEdMax: ng.fem_design.steel_output.Vector2D | null = null;
                rDeltaX: ng.fem_design.steel_output.Vector2D | null = null;
                psi: ng.fem_design.steel_output.Vector2D | null = null;
                rDeltaMEd: ng.fem_design.steel_output.Vector2D | null = null;
                rAlpha: ng.fem_design.steel_output.Vector4D | null = null;
                rPsi: ng.fem_design.steel_output.Vector4D | null = null;
                rCM: ng.fem_design.steel_output.Vector2D | null = null;
                rCMLT: ng.fem_design.steel_output.Vector2D | null = null;
                c11: number = 0;
                c12: number = 0;
                c21: number = 0;
                c22: number = 0;
                rk11: number = 0;
                rk12: number = 0;
                rk21: number = 0;
                rk22: number = 0;
                cm10: number = 0;
                cm20: number = 0;
                betaM: ng.fem_design.steel_output.Vector4D | null = null;

                static fromObject(src_unknown: unknown): StBarInteraction {
                    const dst = new StBarInteraction();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarInteraction but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarInteraction_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarInteraction but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarInteraction to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        dst.rUtil = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtil);
                    }
                    if (src.rNRk !== undefined && src.rNRk !== null) {
                        if (typeof src.rNRk === "number" || src.rNRk === 'NaN' || src.rNRk === 'Infinity' || src.rNRk === '-Infinity') {
                            dst.rNRk = AsNum(src.rNRk);
                        }
                        else {
                            console.log('Expected rNRk of StBarInteraction to be a number but was ', typeof src.rNRk, src.rNRk)
                        }
                    }
                    if (src.rMRk !== undefined && src.rMRk !== null) {
                        dst.rMRk = ng.fem_design.steel_output.Vector2D.fromObject(src.rMRk);
                    }
                    if (src.rMEd !== undefined && src.rMEd !== null) {
                        dst.rMEd = ng.fem_design.steel_output.Vector2D.fromObject(src.rMEd);
                    }
                    if (src.rMEdMax !== undefined && src.rMEdMax !== null) {
                        dst.rMEdMax = ng.fem_design.steel_output.Vector2D.fromObject(src.rMEdMax);
                    }
                    if (src.rDeltaX !== undefined && src.rDeltaX !== null) {
                        dst.rDeltaX = ng.fem_design.steel_output.Vector2D.fromObject(src.rDeltaX);
                    }
                    if (src.psi !== undefined && src.psi !== null) {
                        dst.psi = ng.fem_design.steel_output.Vector2D.fromObject(src.psi);
                    }
                    if (src.rDeltaMEd !== undefined && src.rDeltaMEd !== null) {
                        dst.rDeltaMEd = ng.fem_design.steel_output.Vector2D.fromObject(src.rDeltaMEd);
                    }
                    if (src.rAlpha !== undefined && src.rAlpha !== null) {
                        dst.rAlpha = ng.fem_design.steel_output.Vector4D.fromObject(src.rAlpha);
                    }
                    if (src.rPsi !== undefined && src.rPsi !== null) {
                        dst.rPsi = ng.fem_design.steel_output.Vector4D.fromObject(src.rPsi);
                    }
                    if (src.rCM !== undefined && src.rCM !== null) {
                        dst.rCM = ng.fem_design.steel_output.Vector2D.fromObject(src.rCM);
                    }
                    if (src.rCMLT !== undefined && src.rCMLT !== null) {
                        dst.rCMLT = ng.fem_design.steel_output.Vector2D.fromObject(src.rCMLT);
                    }
                    if (src.c11 !== undefined && src.c11 !== null) {
                        if (typeof src.c11 === "number" || src.c11 === 'NaN' || src.c11 === 'Infinity' || src.c11 === '-Infinity') {
                            dst.c11 = AsNum(src.c11);
                        }
                        else {
                            console.log('Expected c11 of StBarInteraction to be a number but was ', typeof src.c11, src.c11)
                        }
                    }
                    if (src.c12 !== undefined && src.c12 !== null) {
                        if (typeof src.c12 === "number" || src.c12 === 'NaN' || src.c12 === 'Infinity' || src.c12 === '-Infinity') {
                            dst.c12 = AsNum(src.c12);
                        }
                        else {
                            console.log('Expected c12 of StBarInteraction to be a number but was ', typeof src.c12, src.c12)
                        }
                    }
                    if (src.c21 !== undefined && src.c21 !== null) {
                        if (typeof src.c21 === "number" || src.c21 === 'NaN' || src.c21 === 'Infinity' || src.c21 === '-Infinity') {
                            dst.c21 = AsNum(src.c21);
                        }
                        else {
                            console.log('Expected c21 of StBarInteraction to be a number but was ', typeof src.c21, src.c21)
                        }
                    }
                    if (src.c22 !== undefined && src.c22 !== null) {
                        if (typeof src.c22 === "number" || src.c22 === 'NaN' || src.c22 === 'Infinity' || src.c22 === '-Infinity') {
                            dst.c22 = AsNum(src.c22);
                        }
                        else {
                            console.log('Expected c22 of StBarInteraction to be a number but was ', typeof src.c22, src.c22)
                        }
                    }
                    if (src.rk11 !== undefined && src.rk11 !== null) {
                        if (typeof src.rk11 === "number" || src.rk11 === 'NaN' || src.rk11 === 'Infinity' || src.rk11 === '-Infinity') {
                            dst.rk11 = AsNum(src.rk11);
                        }
                        else {
                            console.log('Expected rk11 of StBarInteraction to be a number but was ', typeof src.rk11, src.rk11)
                        }
                    }
                    if (src.rk12 !== undefined && src.rk12 !== null) {
                        if (typeof src.rk12 === "number" || src.rk12 === 'NaN' || src.rk12 === 'Infinity' || src.rk12 === '-Infinity') {
                            dst.rk12 = AsNum(src.rk12);
                        }
                        else {
                            console.log('Expected rk12 of StBarInteraction to be a number but was ', typeof src.rk12, src.rk12)
                        }
                    }
                    if (src.rk21 !== undefined && src.rk21 !== null) {
                        if (typeof src.rk21 === "number" || src.rk21 === 'NaN' || src.rk21 === 'Infinity' || src.rk21 === '-Infinity') {
                            dst.rk21 = AsNum(src.rk21);
                        }
                        else {
                            console.log('Expected rk21 of StBarInteraction to be a number but was ', typeof src.rk21, src.rk21)
                        }
                    }
                    if (src.rk22 !== undefined && src.rk22 !== null) {
                        if (typeof src.rk22 === "number" || src.rk22 === 'NaN' || src.rk22 === 'Infinity' || src.rk22 === '-Infinity') {
                            dst.rk22 = AsNum(src.rk22);
                        }
                        else {
                            console.log('Expected rk22 of StBarInteraction to be a number but was ', typeof src.rk22, src.rk22)
                        }
                    }
                    if (src.cm10 !== undefined && src.cm10 !== null) {
                        if (typeof src.cm10 === "number" || src.cm10 === 'NaN' || src.cm10 === 'Infinity' || src.cm10 === '-Infinity') {
                            dst.cm10 = AsNum(src.cm10);
                        }
                        else {
                            console.log('Expected cm10 of StBarInteraction to be a number but was ', typeof src.cm10, src.cm10)
                        }
                    }
                    if (src.cm20 !== undefined && src.cm20 !== null) {
                        if (typeof src.cm20 === "number" || src.cm20 === 'NaN' || src.cm20 === 'Infinity' || src.cm20 === '-Infinity') {
                            dst.cm20 = AsNum(src.cm20);
                        }
                        else {
                            console.log('Expected cm20 of StBarInteraction to be a number but was ', typeof src.cm20, src.cm20)
                        }
                    }
                    if (src.betaM !== undefined && src.betaM !== null) {
                        dst.betaM = ng.fem_design.steel_output.Vector4D.fromObject(src.betaM);
                    }
                    return dst;
                }

                static toObject(src: StBarInteraction | null | undefined): StBarInteraction_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarInteraction is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarInteraction") {
                        console.error('Expected ng.fem_design.steel_output.StBarInteraction but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : StBarInteraction_json = {
                        fCalculated: src.fCalculated,
                        rNRk: AsJsonNum(src.rNRk),
                        c11: AsJsonNum(src.c11),
                        c12: AsJsonNum(src.c12),
                        c21: AsJsonNum(src.c21),
                        c22: AsJsonNum(src.c22),
                        rk11: AsJsonNum(src.rk11),
                        rk12: AsJsonNum(src.rk12),
                        rk21: AsJsonNum(src.rk21),
                        rk22: AsJsonNum(src.rk22),
                        cm10: AsJsonNum(src.cm10),
                        cm20: AsJsonNum(src.cm20),
                    };
                    if(src.rUtil !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtil);
                        if(parsed === null) return null;
                        dst.rUtil = parsed;
                    }
                    if(src.rMRk !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMRk);
                        if(parsed === null) return null;
                        dst.rMRk = parsed;
                    }
                    if(src.rMEd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMEd);
                        if(parsed === null) return null;
                        dst.rMEd = parsed;
                    }
                    if(src.rMEdMax !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rMEdMax);
                        if(parsed === null) return null;
                        dst.rMEdMax = parsed;
                    }
                    if(src.rDeltaX !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rDeltaX);
                        if(parsed === null) return null;
                        dst.rDeltaX = parsed;
                    }
                    if(src.psi !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.psi);
                        if(parsed === null) return null;
                        dst.psi = parsed;
                    }
                    if(src.rDeltaMEd !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rDeltaMEd);
                        if(parsed === null) return null;
                        dst.rDeltaMEd = parsed;
                    }
                    if(src.rAlpha !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector4D.toObject(src.rAlpha);
                        if(parsed === null) return null;
                        dst.rAlpha = parsed;
                    }
                    if(src.rPsi !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector4D.toObject(src.rPsi);
                        if(parsed === null) return null;
                        dst.rPsi = parsed;
                    }
                    if(src.rCM !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rCM);
                        if(parsed === null) return null;
                        dst.rCM = parsed;
                    }
                    if(src.rCMLT !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rCMLT);
                        if(parsed === null) return null;
                        dst.rCMLT = parsed;
                    }
                    if(src.betaM !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector4D.toObject(src.betaM);
                        if(parsed === null) return null;
                        dst.betaM = parsed;
                    }
                    return dst;
                }

                static create(src?: StBarInteraction_createType) {
                    const dst = new StBarInteraction();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    if (src.rNRk !== undefined) {
                        dst.rNRk = src.rNRk;
                    }
                    if (src.rMRk !== undefined) {
                        dst.rMRk = src.rMRk;
                    }
                    if (src.rMEd !== undefined) {
                        dst.rMEd = src.rMEd;
                    }
                    if (src.rMEdMax !== undefined) {
                        dst.rMEdMax = src.rMEdMax;
                    }
                    if (src.rDeltaX !== undefined) {
                        dst.rDeltaX = src.rDeltaX;
                    }
                    if (src.psi !== undefined) {
                        dst.psi = src.psi;
                    }
                    if (src.rDeltaMEd !== undefined) {
                        dst.rDeltaMEd = src.rDeltaMEd;
                    }
                    if (src.rAlpha !== undefined) {
                        dst.rAlpha = src.rAlpha;
                    }
                    if (src.rPsi !== undefined) {
                        dst.rPsi = src.rPsi;
                    }
                    if (src.rCM !== undefined) {
                        dst.rCM = src.rCM;
                    }
                    if (src.rCMLT !== undefined) {
                        dst.rCMLT = src.rCMLT;
                    }
                    if (src.c11 !== undefined) {
                        dst.c11 = src.c11;
                    }
                    if (src.c12 !== undefined) {
                        dst.c12 = src.c12;
                    }
                    if (src.c21 !== undefined) {
                        dst.c21 = src.c21;
                    }
                    if (src.c22 !== undefined) {
                        dst.c22 = src.c22;
                    }
                    if (src.rk11 !== undefined) {
                        dst.rk11 = src.rk11;
                    }
                    if (src.rk12 !== undefined) {
                        dst.rk12 = src.rk12;
                    }
                    if (src.rk21 !== undefined) {
                        dst.rk21 = src.rk21;
                    }
                    if (src.rk22 !== undefined) {
                        dst.rk22 = src.rk22;
                    }
                    if (src.cm10 !== undefined) {
                        dst.cm10 = src.cm10;
                    }
                    if (src.cm20 !== undefined) {
                        dst.cm20 = src.cm20;
                    }
                    if (src.betaM !== undefined) {
                        dst.betaM = src.betaM;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarInteraction();
                    dst.fCalculated = this.fCalculated;
                    dst.rUtil = this.rUtil;
                    dst.rNRk = this.rNRk;
                    dst.rMRk = this.rMRk;
                    dst.rMEd = this.rMEd;
                    dst.rMEdMax = this.rMEdMax;
                    dst.rDeltaX = this.rDeltaX;
                    dst.psi = this.psi;
                    dst.rDeltaMEd = this.rDeltaMEd;
                    dst.rAlpha = this.rAlpha;
                    dst.rPsi = this.rPsi;
                    dst.rCM = this.rCM;
                    dst.rCMLT = this.rCMLT;
                    dst.c11 = this.c11;
                    dst.c12 = this.c12;
                    dst.c21 = this.c21;
                    dst.c22 = this.c22;
                    dst.rk11 = this.rk11;
                    dst.rk12 = this.rk12;
                    dst.rk21 = this.rk21;
                    dst.rk22 = this.rk22;
                    dst.cm10 = this.cm10;
                    dst.cm20 = this.cm20;
                    dst.betaM = this.betaM;
                    return dst;
                }

                deepClone() {
                    const json = StBarInteraction.toObject(this);
                    const dst = StBarInteraction.fromObject(json);
                    return dst;
                }
            }
            export type IStBarInteraction = StBarInteraction;


            export type StBarInteraction2nd_keys = 'fCalculated' | 'rUtil';
            export interface StBarInteraction2nd_createType {
                fCalculated?: boolean,
                rUtil?: number,
            }
            export interface StBarInteraction2nd_json {
                fCalculated?: boolean;
                rUtil?: JsonNumber;
            }
            interface StBarInteraction2nd_json_in {
                __proto_name?: unknown;
                fCalculated?: unknown;
                rUtil?: unknown;
            }
            export class StBarInteraction2nd {
                __proto_name = "ng.fem_design.steel_output.StBarInteraction2nd";
                fCalculated: boolean = false;
                rUtil: number = 0;

                static fromObject(src_unknown: unknown): StBarInteraction2nd {
                    const dst = new StBarInteraction2nd();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted StBarInteraction2nd but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as StBarInteraction2nd_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for StBarInteraction2nd but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fCalculated !== undefined && src.fCalculated !== null) {
                        if (typeof src.fCalculated === "boolean") {
                            dst.fCalculated = src.fCalculated;
                        }
                        else {
                            console.log('Expected fCalculated of StBarInteraction2nd to be a boolean but was ', typeof src.fCalculated, src.fCalculated)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        if (typeof src.rUtil === "number" || src.rUtil === 'NaN' || src.rUtil === 'Infinity' || src.rUtil === '-Infinity') {
                            dst.rUtil = AsNum(src.rUtil);
                        }
                        else {
                            console.log('Expected rUtil of StBarInteraction2nd to be a number but was ', typeof src.rUtil, src.rUtil)
                        }
                    }
                    return dst;
                }

                static toObject(src: StBarInteraction2nd | null | undefined): StBarInteraction2nd_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.StBarInteraction2nd is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.StBarInteraction2nd") {
                        console.error('Expected ng.fem_design.steel_output.StBarInteraction2nd but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : StBarInteraction2nd_json = {
                        fCalculated: src.fCalculated,
                        rUtil: AsJsonNum(src.rUtil),
                    };
                    return dst;
                }

                static create(src?: StBarInteraction2nd_createType) {
                    const dst = new StBarInteraction2nd();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fCalculated !== undefined) {
                        dst.fCalculated = src.fCalculated;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new StBarInteraction2nd();
                    dst.fCalculated = this.fCalculated;
                    dst.rUtil = this.rUtil;
                    return dst;
                }

                deepClone() {
                    const json = StBarInteraction2nd.toObject(this);
                    const dst = StBarInteraction2nd.fromObject(json);
                    return dst;
                }
            }
            export type IStBarInteraction2nd = StBarInteraction2nd;


            export type CombDesignCalcRecord_keys = 'isNotCalculated' | 'orderNumber' | 'limitState' | 'secondOrder' | 'utilization' | 'gammaM0' | 'gammaM1' | 'gammaM2' | 'gammaMFi' | 'numberOfSections' | 'sectionClass' | 'sectionDesignCalc';
            export interface CombDesignCalcRecord_createType {
                isNotCalculated?: boolean,
                orderNumber?: number,
                limitState?: ng.fem_design.steel_output.LimitState,
                secondOrder?: boolean,
                utilization?: number,
                gammaM0?: number,
                gammaM1?: number,
                gammaM2?: number,
                gammaMFi?: number,
                numberOfSections?: number,
                sectionClass?: ng.fem_design.steel_output.SectionClassRecord[],
                sectionDesignCalc?: ng.fem_design.steel_output.SectionDesignCalcRecord[],
            }
            export interface CombDesignCalcRecord_json {
                isNotCalculated?: boolean;
                orderNumber?: JsonNumber;
                limitState?: string;
                secondOrder?: boolean;
                utilization?: JsonNumber;
                gammaM0?: JsonNumber;
                gammaM1?: JsonNumber;
                gammaM2?: JsonNumber;
                gammaMFi?: JsonNumber;
                numberOfSections?: JsonNumber;
                sectionClass: ng.fem_design.steel_output.SectionClassRecord_json[];
                sectionDesignCalc: ng.fem_design.steel_output.SectionDesignCalcRecord_json[];
            }
            interface CombDesignCalcRecord_json_in {
                __proto_name?: unknown;
                isNotCalculated?: unknown;
                orderNumber?: unknown;
                limitState?: unknown;
                secondOrder?: unknown;
                utilization?: unknown;
                gammaM0?: unknown;
                gammaM1?: unknown;
                gammaM2?: unknown;
                gammaMFi?: unknown;
                numberOfSections?: unknown;
                sectionClass?: unknown;
                sectionDesignCalc?: unknown;
            }
            export class CombDesignCalcRecord {
                __proto_name = "ng.fem_design.steel_output.CombDesignCalcRecord";
                isNotCalculated: boolean = false;
                orderNumber: number = 0;
                limitState: ng.fem_design.steel_output.LimitState = ng.fem_design.steel_output.LimitState.LIMIT_STATE_ULTIMATE;
                secondOrder: boolean = false;
                utilization: number = 0;
                gammaM0: number = 0;
                gammaM1: number = 0;
                gammaM2: number = 0;
                gammaMFi: number = 0;
                numberOfSections: number = 0;
                sectionClass: ng.fem_design.steel_output.SectionClassRecord[] = [];
                sectionDesignCalc: ng.fem_design.steel_output.SectionDesignCalcRecord[] = [];

                static fromObject(src_unknown: unknown): CombDesignCalcRecord {
                    const dst = new CombDesignCalcRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CombDesignCalcRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CombDesignCalcRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CombDesignCalcRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.isNotCalculated !== undefined && src.isNotCalculated !== null) {
                        if (typeof src.isNotCalculated === "boolean") {
                            dst.isNotCalculated = src.isNotCalculated;
                        }
                        else {
                            console.log('Expected isNotCalculated of CombDesignCalcRecord to be a boolean but was ', typeof src.isNotCalculated, src.isNotCalculated)
                        }
                    }
                    if (src.orderNumber !== undefined && src.orderNumber !== null) {
                        if (typeof src.orderNumber === "number" || src.orderNumber === 'NaN' || src.orderNumber === 'Infinity' || src.orderNumber === '-Infinity') {
                            dst.orderNumber = NumberToInt("ng.fem_design.steel_output.CombDesignCalcRecord.order_number", AsNum(src.orderNumber));
                        }
                        else {
                            console.log('Expected orderNumber of CombDesignCalcRecord to be a number but was ', typeof src.orderNumber, src.orderNumber)
                        }
                    }
                    if (src.limitState !== undefined && src.limitState !== null) {
                        dst.limitState = ng.fem_design.steel_output.LimitState_FromObject(src.limitState);
                    }
                    if (src.secondOrder !== undefined && src.secondOrder !== null) {
                        if (typeof src.secondOrder === "boolean") {
                            dst.secondOrder = src.secondOrder;
                        }
                        else {
                            console.log('Expected secondOrder of CombDesignCalcRecord to be a boolean but was ', typeof src.secondOrder, src.secondOrder)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of CombDesignCalcRecord to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    if (src.gammaM0 !== undefined && src.gammaM0 !== null) {
                        if (typeof src.gammaM0 === "number" || src.gammaM0 === 'NaN' || src.gammaM0 === 'Infinity' || src.gammaM0 === '-Infinity') {
                            dst.gammaM0 = AsNum(src.gammaM0);
                        }
                        else {
                            console.log('Expected gammaM0 of CombDesignCalcRecord to be a number but was ', typeof src.gammaM0, src.gammaM0)
                        }
                    }
                    if (src.gammaM1 !== undefined && src.gammaM1 !== null) {
                        if (typeof src.gammaM1 === "number" || src.gammaM1 === 'NaN' || src.gammaM1 === 'Infinity' || src.gammaM1 === '-Infinity') {
                            dst.gammaM1 = AsNum(src.gammaM1);
                        }
                        else {
                            console.log('Expected gammaM1 of CombDesignCalcRecord to be a number but was ', typeof src.gammaM1, src.gammaM1)
                        }
                    }
                    if (src.gammaM2 !== undefined && src.gammaM2 !== null) {
                        if (typeof src.gammaM2 === "number" || src.gammaM2 === 'NaN' || src.gammaM2 === 'Infinity' || src.gammaM2 === '-Infinity') {
                            dst.gammaM2 = AsNum(src.gammaM2);
                        }
                        else {
                            console.log('Expected gammaM2 of CombDesignCalcRecord to be a number but was ', typeof src.gammaM2, src.gammaM2)
                        }
                    }
                    if (src.gammaMFi !== undefined && src.gammaMFi !== null) {
                        if (typeof src.gammaMFi === "number" || src.gammaMFi === 'NaN' || src.gammaMFi === 'Infinity' || src.gammaMFi === '-Infinity') {
                            dst.gammaMFi = AsNum(src.gammaMFi);
                        }
                        else {
                            console.log('Expected gammaMFi of CombDesignCalcRecord to be a number but was ', typeof src.gammaMFi, src.gammaMFi)
                        }
                    }
                    if (src.numberOfSections !== undefined && src.numberOfSections !== null) {
                        if (typeof src.numberOfSections === "number" || src.numberOfSections === 'NaN' || src.numberOfSections === 'Infinity' || src.numberOfSections === '-Infinity') {
                            dst.numberOfSections = NumberToInt("ng.fem_design.steel_output.CombDesignCalcRecord.number_of_sections", AsNum(src.numberOfSections));
                        }
                        else {
                            console.log('Expected numberOfSections of CombDesignCalcRecord to be a number but was ', typeof src.numberOfSections, src.numberOfSections)
                        }
                    }
                    if (src.sectionClass !== undefined && src.sectionClass !== null) {
                        if (Array.isArray(src.sectionClass)) {
                            for (const element of src.sectionClass) {
                                dst.sectionClass.push(ng.fem_design.steel_output.SectionClassRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected sectionClass of CombDesignCalcRecord to be a array but was ', typeof src.sectionClass, src.sectionClass)
                        }
                    }
                    if (src.sectionDesignCalc !== undefined && src.sectionDesignCalc !== null) {
                        if (Array.isArray(src.sectionDesignCalc)) {
                            for (const element of src.sectionDesignCalc) {
                                dst.sectionDesignCalc.push(ng.fem_design.steel_output.SectionDesignCalcRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected sectionDesignCalc of CombDesignCalcRecord to be a array but was ', typeof src.sectionDesignCalc, src.sectionDesignCalc)
                        }
                    }
                    return dst;
                }

                static toObject(src: CombDesignCalcRecord | null | undefined): CombDesignCalcRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.CombDesignCalcRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.CombDesignCalcRecord") {
                        console.error('Expected ng.fem_design.steel_output.CombDesignCalcRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const limitState_obj = ng.fem_design.steel_output.LimitState_ToObject(src.limitState);
                    if(limitState_obj === null) return null;

                    const dst : CombDesignCalcRecord_json = {
                        isNotCalculated: src.isNotCalculated,
                        orderNumber: AsJsonNum(NumberToInt("ng.fem_design.steel_output.CombDesignCalcRecord.order_number", src.orderNumber)),
                        limitState: limitState_obj,
                        secondOrder: src.secondOrder,
                        utilization: AsJsonNum(src.utilization),
                        gammaM0: AsJsonNum(src.gammaM0),
                        gammaM1: AsJsonNum(src.gammaM1),
                        gammaM2: AsJsonNum(src.gammaM2),
                        gammaMFi: AsJsonNum(src.gammaMFi),
                        numberOfSections: AsJsonNum(NumberToInt("ng.fem_design.steel_output.CombDesignCalcRecord.number_of_sections", src.numberOfSections)),
                        sectionClass: new Array<ng.fem_design.steel_output.SectionClassRecord_json>(),
                        sectionDesignCalc: new Array<ng.fem_design.steel_output.SectionDesignCalcRecord_json>(),
                    };
                    if (src.sectionClass !== null) {
                        for (const element of src.sectionClass) {
                            const parsed = ng.fem_design.steel_output.SectionClassRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.sectionClass.push(parsed);
                        }
                    }
                    if (src.sectionDesignCalc !== null) {
                        for (const element of src.sectionDesignCalc) {
                            const parsed = ng.fem_design.steel_output.SectionDesignCalcRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.sectionDesignCalc.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CombDesignCalcRecord_createType) {
                    const dst = new CombDesignCalcRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.isNotCalculated !== undefined) {
                        dst.isNotCalculated = src.isNotCalculated;
                    }
                    if (src.orderNumber !== undefined) {
                        dst.orderNumber = src.orderNumber;
                    }
                    if (src.limitState !== undefined) {
                        dst.limitState = src.limitState;
                    }
                    if (src.secondOrder !== undefined) {
                        dst.secondOrder = src.secondOrder;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    if (src.gammaM0 !== undefined) {
                        dst.gammaM0 = src.gammaM0;
                    }
                    if (src.gammaM1 !== undefined) {
                        dst.gammaM1 = src.gammaM1;
                    }
                    if (src.gammaM2 !== undefined) {
                        dst.gammaM2 = src.gammaM2;
                    }
                    if (src.gammaMFi !== undefined) {
                        dst.gammaMFi = src.gammaMFi;
                    }
                    if (src.numberOfSections !== undefined) {
                        dst.numberOfSections = src.numberOfSections;
                    }
                    if (src.sectionClass !== undefined) {
                        dst.sectionClass = src.sectionClass;
                    }
                    if (src.sectionDesignCalc !== undefined) {
                        dst.sectionDesignCalc = src.sectionDesignCalc;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CombDesignCalcRecord();
                    dst.isNotCalculated = this.isNotCalculated;
                    dst.orderNumber = this.orderNumber;
                    dst.limitState = this.limitState;
                    dst.secondOrder = this.secondOrder;
                    dst.utilization = this.utilization;
                    dst.gammaM0 = this.gammaM0;
                    dst.gammaM1 = this.gammaM1;
                    dst.gammaM2 = this.gammaM2;
                    dst.gammaMFi = this.gammaMFi;
                    dst.numberOfSections = this.numberOfSections;
                    dst.sectionClass = this.sectionClass;
                    dst.sectionDesignCalc = this.sectionDesignCalc;
                    return dst;
                }

                deepClone() {
                    const json = CombDesignCalcRecord.toObject(this);
                    const dst = CombDesignCalcRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICombDesignCalcRecord = CombDesignCalcRecord;


            export type Information_keys = 'barid' | 'maxUtilization' | 'maxLoadcombinationIndex' | 'ncomb' | 'combDesignCalcRecord' | 'varyingBar' | 'barName' | 'sectionName' | 'materialName' | 'virtualStiffeners' | 'bucklingShapes' | 'torsionalSharpe' | 'kfl' | 'etawb' | 'interactionMethod' | 'lambdaLT0' | 'beta' | 'nsec' | 'barExtraDataRecord';
            export interface Information_createType {
                barid?: number,
                maxUtilization?: number,
                maxLoadcombinationIndex?: number,
                ncomb?: number,
                combDesignCalcRecord?: ng.fem_design.steel_output.CombDesignCalcRecord[],
                varyingBar?: ng.fem_design.steel_output.BarSectionType,
                barName?: string,
                sectionName?: string,
                materialName?: string,
                virtualStiffeners?: ng.fem_design.steel_output.VirtualStiffeners | null,
                bucklingShapes?: ng.fem_design.steel_output.BucklingShapes | null,
                torsionalSharpe?: ng.fem_design.steel_output.ShearResistanceEnum,
                kfl?: number,
                etawb?: number,
                interactionMethod?: ng.fem_design.steel_output.InteractionMethod,
                lambdaLT0?: number,
                beta?: number,
                nsec?: number,
                barExtraDataRecord?: ng.fem_design.steel_output.BarExtraDataRecord[],
            }
            export interface Information_json {
                barid?: JsonNumber;
                maxUtilization?: JsonNumber;
                maxLoadcombinationIndex?: JsonNumber;
                ncomb?: JsonNumber;
                combDesignCalcRecord: ng.fem_design.steel_output.CombDesignCalcRecord_json[];
                varyingBar?: string;
                barName?: string;
                sectionName?: string;
                materialName?: string;
                virtualStiffeners?: ng.fem_design.steel_output.VirtualStiffeners_json;
                bucklingShapes?: ng.fem_design.steel_output.BucklingShapes_json;
                torsionalSharpe?: string;
                kfl?: JsonNumber;
                etawb?: JsonNumber;
                interactionMethod?: string;
                lambdaLT0?: JsonNumber;
                beta?: JsonNumber;
                nsec?: JsonNumber;
                barExtraDataRecord: ng.fem_design.steel_output.BarExtraDataRecord_json[];
            }
            interface Information_json_in {
                __proto_name?: unknown;
                barid?: unknown;
                maxUtilization?: unknown;
                maxLoadcombinationIndex?: unknown;
                ncomb?: unknown;
                combDesignCalcRecord?: unknown;
                varyingBar?: unknown;
                barName?: unknown;
                sectionName?: unknown;
                materialName?: unknown;
                virtualStiffeners?: unknown;
                bucklingShapes?: unknown;
                torsionalSharpe?: unknown;
                kfl?: unknown;
                etawb?: unknown;
                interactionMethod?: unknown;
                lambdaLT0?: unknown;
                beta?: unknown;
                nsec?: unknown;
                barExtraDataRecord?: unknown;
            }
            export class Information {
                __proto_name = "ng.fem_design.steel_output.Information";
                barid: number = 0;
                maxUtilization: number = 0;
                maxLoadcombinationIndex: number = 0;
                ncomb: number = 0;
                combDesignCalcRecord: ng.fem_design.steel_output.CombDesignCalcRecord[] = [];
                varyingBar: ng.fem_design.steel_output.BarSectionType = ng.fem_design.steel_output.BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                barName: string = "";
                sectionName: string = "";
                materialName: string = "";
                virtualStiffeners: ng.fem_design.steel_output.VirtualStiffeners | null = null;
                bucklingShapes: ng.fem_design.steel_output.BucklingShapes | null = null;
                torsionalSharpe: ng.fem_design.steel_output.ShearResistanceEnum = ng.fem_design.steel_output.ShearResistanceEnum.SHEAR_RESISTANCE_UNSPECIFIED;
                kfl: number = 0;
                etawb: number = 0;
                interactionMethod: ng.fem_design.steel_output.InteractionMethod = ng.fem_design.steel_output.InteractionMethod.INTERACTION_METHOD_1;
                lambdaLT0: number = 0;
                beta: number = 0;
                nsec: number = 0;
                barExtraDataRecord: ng.fem_design.steel_output.BarExtraDataRecord[] = [];

                static fromObject(src_unknown: unknown): Information {
                    const dst = new Information();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Information but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Information_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Information but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.barid !== undefined && src.barid !== null) {
                        if (typeof src.barid === "number" || src.barid === 'NaN' || src.barid === 'Infinity' || src.barid === '-Infinity') {
                            dst.barid = NumberToInt("ng.fem_design.steel_output.Information.barid", AsNum(src.barid));
                        }
                        else {
                            console.log('Expected barid of Information to be a number but was ', typeof src.barid, src.barid)
                        }
                    }
                    if (src.maxUtilization !== undefined && src.maxUtilization !== null) {
                        if (typeof src.maxUtilization === "number" || src.maxUtilization === 'NaN' || src.maxUtilization === 'Infinity' || src.maxUtilization === '-Infinity') {
                            dst.maxUtilization = AsNum(src.maxUtilization);
                        }
                        else {
                            console.log('Expected maxUtilization of Information to be a number but was ', typeof src.maxUtilization, src.maxUtilization)
                        }
                    }
                    if (src.maxLoadcombinationIndex !== undefined && src.maxLoadcombinationIndex !== null) {
                        if (typeof src.maxLoadcombinationIndex === "number" || src.maxLoadcombinationIndex === 'NaN' || src.maxLoadcombinationIndex === 'Infinity' || src.maxLoadcombinationIndex === '-Infinity') {
                            dst.maxLoadcombinationIndex = NumberToInt("ng.fem_design.steel_output.Information.max_loadcombination_index", AsNum(src.maxLoadcombinationIndex));
                        }
                        else {
                            console.log('Expected maxLoadcombinationIndex of Information to be a number but was ', typeof src.maxLoadcombinationIndex, src.maxLoadcombinationIndex)
                        }
                    }
                    if (src.ncomb !== undefined && src.ncomb !== null) {
                        if (typeof src.ncomb === "number" || src.ncomb === 'NaN' || src.ncomb === 'Infinity' || src.ncomb === '-Infinity') {
                            dst.ncomb = NumberToInt("ng.fem_design.steel_output.Information.ncomb", AsNum(src.ncomb));
                        }
                        else {
                            console.log('Expected ncomb of Information to be a number but was ', typeof src.ncomb, src.ncomb)
                        }
                    }
                    if (src.combDesignCalcRecord !== undefined && src.combDesignCalcRecord !== null) {
                        if (Array.isArray(src.combDesignCalcRecord)) {
                            for (const element of src.combDesignCalcRecord) {
                                dst.combDesignCalcRecord.push(ng.fem_design.steel_output.CombDesignCalcRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected combDesignCalcRecord of Information to be a array but was ', typeof src.combDesignCalcRecord, src.combDesignCalcRecord)
                        }
                    }
                    if (src.varyingBar !== undefined && src.varyingBar !== null) {
                        dst.varyingBar = ng.fem_design.steel_output.BarSectionType_FromObject(src.varyingBar);
                    }
                    if (src.barName !== undefined && src.barName !== null) {
                        if (typeof src.barName === "string") {
                            dst.barName = src.barName;
                        }
                        else {
                            console.log('Expected barName of Information to be a string but was ', typeof src.barName, src.barName)
                        }
                    }
                    if (src.sectionName !== undefined && src.sectionName !== null) {
                        if (typeof src.sectionName === "string") {
                            dst.sectionName = src.sectionName;
                        }
                        else {
                            console.log('Expected sectionName of Information to be a string but was ', typeof src.sectionName, src.sectionName)
                        }
                    }
                    if (src.materialName !== undefined && src.materialName !== null) {
                        if (typeof src.materialName === "string") {
                            dst.materialName = src.materialName;
                        }
                        else {
                            console.log('Expected materialName of Information to be a string but was ', typeof src.materialName, src.materialName)
                        }
                    }
                    if (src.virtualStiffeners !== undefined && src.virtualStiffeners !== null) {
                        dst.virtualStiffeners = ng.fem_design.steel_output.VirtualStiffeners.fromObject(src.virtualStiffeners);
                    }
                    if (src.bucklingShapes !== undefined && src.bucklingShapes !== null) {
                        dst.bucklingShapes = ng.fem_design.steel_output.BucklingShapes.fromObject(src.bucklingShapes);
                    }
                    if (src.torsionalSharpe !== undefined && src.torsionalSharpe !== null) {
                        dst.torsionalSharpe = ng.fem_design.steel_output.ShearResistanceEnum_FromObject(src.torsionalSharpe);
                    }
                    if (src.kfl !== undefined && src.kfl !== null) {
                        if (typeof src.kfl === "number" || src.kfl === 'NaN' || src.kfl === 'Infinity' || src.kfl === '-Infinity') {
                            dst.kfl = AsNum(src.kfl);
                        }
                        else {
                            console.log('Expected kfl of Information to be a number but was ', typeof src.kfl, src.kfl)
                        }
                    }
                    if (src.etawb !== undefined && src.etawb !== null) {
                        if (typeof src.etawb === "number" || src.etawb === 'NaN' || src.etawb === 'Infinity' || src.etawb === '-Infinity') {
                            dst.etawb = AsNum(src.etawb);
                        }
                        else {
                            console.log('Expected etawb of Information to be a number but was ', typeof src.etawb, src.etawb)
                        }
                    }
                    if (src.interactionMethod !== undefined && src.interactionMethod !== null) {
                        dst.interactionMethod = ng.fem_design.steel_output.InteractionMethod_FromObject(src.interactionMethod);
                    }
                    if (src.lambdaLT0 !== undefined && src.lambdaLT0 !== null) {
                        if (typeof src.lambdaLT0 === "number" || src.lambdaLT0 === 'NaN' || src.lambdaLT0 === 'Infinity' || src.lambdaLT0 === '-Infinity') {
                            dst.lambdaLT0 = AsNum(src.lambdaLT0);
                        }
                        else {
                            console.log('Expected lambdaLT0 of Information to be a number but was ', typeof src.lambdaLT0, src.lambdaLT0)
                        }
                    }
                    if (src.beta !== undefined && src.beta !== null) {
                        if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                            dst.beta = AsNum(src.beta);
                        }
                        else {
                            console.log('Expected beta of Information to be a number but was ', typeof src.beta, src.beta)
                        }
                    }
                    if (src.nsec !== undefined && src.nsec !== null) {
                        if (typeof src.nsec === "number" || src.nsec === 'NaN' || src.nsec === 'Infinity' || src.nsec === '-Infinity') {
                            dst.nsec = NumberToInt("ng.fem_design.steel_output.Information.nsec", AsNum(src.nsec));
                        }
                        else {
                            console.log('Expected nsec of Information to be a number but was ', typeof src.nsec, src.nsec)
                        }
                    }
                    if (src.barExtraDataRecord !== undefined && src.barExtraDataRecord !== null) {
                        if (Array.isArray(src.barExtraDataRecord)) {
                            for (const element of src.barExtraDataRecord) {
                                dst.barExtraDataRecord.push(ng.fem_design.steel_output.BarExtraDataRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected barExtraDataRecord of Information to be a array but was ', typeof src.barExtraDataRecord, src.barExtraDataRecord)
                        }
                    }
                    return dst;
                }

                static toObject(src: Information | null | undefined): Information_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.steel_output.Information is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.steel_output.Information") {
                        console.error('Expected ng.fem_design.steel_output.Information but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const varyingBar_obj = ng.fem_design.steel_output.BarSectionType_ToObject(src.varyingBar);
                    if(varyingBar_obj === null) return null;

                    const torsionalSharpe_obj = ng.fem_design.steel_output.ShearResistanceEnum_ToObject(src.torsionalSharpe);
                    if(torsionalSharpe_obj === null) return null;

                    const interactionMethod_obj = ng.fem_design.steel_output.InteractionMethod_ToObject(src.interactionMethod);
                    if(interactionMethod_obj === null) return null;

                    const dst : Information_json = {
                        barid: AsJsonNum(NumberToInt("ng.fem_design.steel_output.Information.barid", src.barid)),
                        maxUtilization: AsJsonNum(src.maxUtilization),
                        maxLoadcombinationIndex: AsJsonNum(NumberToInt("ng.fem_design.steel_output.Information.max_loadcombination_index", src.maxLoadcombinationIndex)),
                        ncomb: AsJsonNum(NumberToInt("ng.fem_design.steel_output.Information.ncomb", src.ncomb)),
                        combDesignCalcRecord: new Array<ng.fem_design.steel_output.CombDesignCalcRecord_json>(),
                        varyingBar: varyingBar_obj,
                        barName: src.barName,
                        sectionName: src.sectionName,
                        materialName: src.materialName,
                        torsionalSharpe: torsionalSharpe_obj,
                        kfl: AsJsonNum(src.kfl),
                        etawb: AsJsonNum(src.etawb),
                        interactionMethod: interactionMethod_obj,
                        lambdaLT0: AsJsonNum(src.lambdaLT0),
                        beta: AsJsonNum(src.beta),
                        nsec: AsJsonNum(NumberToInt("ng.fem_design.steel_output.Information.nsec", src.nsec)),
                        barExtraDataRecord: new Array<ng.fem_design.steel_output.BarExtraDataRecord_json>(),
                    };
                    if (src.combDesignCalcRecord !== null) {
                        for (const element of src.combDesignCalcRecord) {
                            const parsed = ng.fem_design.steel_output.CombDesignCalcRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.combDesignCalcRecord.push(parsed);
                        }
                    }
                    if(src.virtualStiffeners !== null)
                    {
                        const parsed = ng.fem_design.steel_output.VirtualStiffeners.toObject(src.virtualStiffeners);
                        if(parsed === null) return null;
                        dst.virtualStiffeners = parsed;
                    }
                    if(src.bucklingShapes !== null)
                    {
                        const parsed = ng.fem_design.steel_output.BucklingShapes.toObject(src.bucklingShapes);
                        if(parsed === null) return null;
                        dst.bucklingShapes = parsed;
                    }
                    if (src.barExtraDataRecord !== null) {
                        for (const element of src.barExtraDataRecord) {
                            const parsed = ng.fem_design.steel_output.BarExtraDataRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.barExtraDataRecord.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: Information_createType) {
                    const dst = new Information();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.barid !== undefined) {
                        dst.barid = src.barid;
                    }
                    if (src.maxUtilization !== undefined) {
                        dst.maxUtilization = src.maxUtilization;
                    }
                    if (src.maxLoadcombinationIndex !== undefined) {
                        dst.maxLoadcombinationIndex = src.maxLoadcombinationIndex;
                    }
                    if (src.ncomb !== undefined) {
                        dst.ncomb = src.ncomb;
                    }
                    if (src.combDesignCalcRecord !== undefined) {
                        dst.combDesignCalcRecord = src.combDesignCalcRecord;
                    }
                    if (src.varyingBar !== undefined) {
                        dst.varyingBar = src.varyingBar;
                    }
                    if (src.barName !== undefined) {
                        dst.barName = src.barName;
                    }
                    if (src.sectionName !== undefined) {
                        dst.sectionName = src.sectionName;
                    }
                    if (src.materialName !== undefined) {
                        dst.materialName = src.materialName;
                    }
                    if (src.virtualStiffeners !== undefined) {
                        dst.virtualStiffeners = src.virtualStiffeners;
                    }
                    if (src.bucklingShapes !== undefined) {
                        dst.bucklingShapes = src.bucklingShapes;
                    }
                    if (src.torsionalSharpe !== undefined) {
                        dst.torsionalSharpe = src.torsionalSharpe;
                    }
                    if (src.kfl !== undefined) {
                        dst.kfl = src.kfl;
                    }
                    if (src.etawb !== undefined) {
                        dst.etawb = src.etawb;
                    }
                    if (src.interactionMethod !== undefined) {
                        dst.interactionMethod = src.interactionMethod;
                    }
                    if (src.lambdaLT0 !== undefined) {
                        dst.lambdaLT0 = src.lambdaLT0;
                    }
                    if (src.beta !== undefined) {
                        dst.beta = src.beta;
                    }
                    if (src.nsec !== undefined) {
                        dst.nsec = src.nsec;
                    }
                    if (src.barExtraDataRecord !== undefined) {
                        dst.barExtraDataRecord = src.barExtraDataRecord;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Information();
                    dst.barid = this.barid;
                    dst.maxUtilization = this.maxUtilization;
                    dst.maxLoadcombinationIndex = this.maxLoadcombinationIndex;
                    dst.ncomb = this.ncomb;
                    dst.combDesignCalcRecord = this.combDesignCalcRecord;
                    dst.varyingBar = this.varyingBar;
                    dst.barName = this.barName;
                    dst.sectionName = this.sectionName;
                    dst.materialName = this.materialName;
                    dst.virtualStiffeners = this.virtualStiffeners;
                    dst.bucklingShapes = this.bucklingShapes;
                    dst.torsionalSharpe = this.torsionalSharpe;
                    dst.kfl = this.kfl;
                    dst.etawb = this.etawb;
                    dst.interactionMethod = this.interactionMethod;
                    dst.lambdaLT0 = this.lambdaLT0;
                    dst.beta = this.beta;
                    dst.nsec = this.nsec;
                    dst.barExtraDataRecord = this.barExtraDataRecord;
                    return dst;
                }

                deepClone() {
                    const json = Information.toObject(this);
                    const dst = Information.fromObject(json);
                    return dst;
                }
            }
            export type IInformation = Information;
        } // namespace steel_output


        // Defined in FEMDesign/auto_design_output.proto
        export namespace auto_design_output {
            export type AutoDesignData_keys = 'BarGuid' | 'SecGuidStart' | 'SecGuidEnd' | 'FireProtMode' | 'FireProtData';
            export interface AutoDesignData_createType {
                BarGuid?: string,
                SecGuidStart?: string,
                SecGuidEnd?: string,
                FireProtMode?: number,
                FireProtData?: number,
            }
            export interface AutoDesignData_json {
                BarGuid?: string;
                SecGuidStart?: string;
                SecGuidEnd?: string;
                FireProtMode?: JsonNumber;
                FireProtData?: JsonNumber;
            }
            interface AutoDesignData_json_in {
                __proto_name?: unknown;
                BarGuid?: unknown;
                SecGuidStart?: unknown;
                SecGuidEnd?: unknown;
                FireProtMode?: unknown;
                FireProtData?: unknown;
            }
            export class AutoDesignData {
                __proto_name = "ng.fem_design.auto_design_output.AutoDesignData";
                BarGuid: string = "";
                SecGuidStart: string = "";
                SecGuidEnd: string = "";
                FireProtMode: number = 0;
                FireProtData: number = 0;

                static fromObject(src_unknown: unknown): AutoDesignData {
                    const dst = new AutoDesignData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.BarGuid !== undefined && src.BarGuid !== null) {
                        if (typeof src.BarGuid === "string") {
                            dst.BarGuid = src.BarGuid;
                        }
                        else {
                            console.log('Expected BarGuid of AutoDesignData to be a string but was ', typeof src.BarGuid, src.BarGuid)
                        }
                    }
                    if (src.SecGuidStart !== undefined && src.SecGuidStart !== null) {
                        if (typeof src.SecGuidStart === "string") {
                            dst.SecGuidStart = src.SecGuidStart;
                        }
                        else {
                            console.log('Expected SecGuidStart of AutoDesignData to be a string but was ', typeof src.SecGuidStart, src.SecGuidStart)
                        }
                    }
                    if (src.SecGuidEnd !== undefined && src.SecGuidEnd !== null) {
                        if (typeof src.SecGuidEnd === "string") {
                            dst.SecGuidEnd = src.SecGuidEnd;
                        }
                        else {
                            console.log('Expected SecGuidEnd of AutoDesignData to be a string but was ', typeof src.SecGuidEnd, src.SecGuidEnd)
                        }
                    }
                    if (src.FireProtMode !== undefined && src.FireProtMode !== null) {
                        if (typeof src.FireProtMode === "number" || src.FireProtMode === 'NaN' || src.FireProtMode === 'Infinity' || src.FireProtMode === '-Infinity') {
                            dst.FireProtMode = NumberToInt("ng.fem_design.auto_design_output.AutoDesignData.FireProtMode", AsNum(src.FireProtMode));
                        }
                        else {
                            console.log('Expected FireProtMode of AutoDesignData to be a number but was ', typeof src.FireProtMode, src.FireProtMode)
                        }
                    }
                    if (src.FireProtData !== undefined && src.FireProtData !== null) {
                        if (typeof src.FireProtData === "number" || src.FireProtData === 'NaN' || src.FireProtData === 'Infinity' || src.FireProtData === '-Infinity') {
                            dst.FireProtData = AsNum(src.FireProtData);
                        }
                        else {
                            console.log('Expected FireProtData of AutoDesignData to be a number but was ', typeof src.FireProtData, src.FireProtData)
                        }
                    }
                    return dst;
                }

                static toObject(src: AutoDesignData | null | undefined): AutoDesignData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.auto_design_output.AutoDesignData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.auto_design_output.AutoDesignData") {
                        console.error('Expected ng.fem_design.auto_design_output.AutoDesignData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignData_json = {
                        BarGuid: src.BarGuid,
                        SecGuidStart: src.SecGuidStart,
                        SecGuidEnd: src.SecGuidEnd,
                        FireProtMode: AsJsonNum(NumberToInt("ng.fem_design.auto_design_output.AutoDesignData.FireProtMode", src.FireProtMode)),
                        FireProtData: AsJsonNum(src.FireProtData),
                    };
                    return dst;
                }

                static create(src?: AutoDesignData_createType) {
                    const dst = new AutoDesignData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.BarGuid !== undefined) {
                        dst.BarGuid = src.BarGuid;
                    }
                    if (src.SecGuidStart !== undefined) {
                        dst.SecGuidStart = src.SecGuidStart;
                    }
                    if (src.SecGuidEnd !== undefined) {
                        dst.SecGuidEnd = src.SecGuidEnd;
                    }
                    if (src.FireProtMode !== undefined) {
                        dst.FireProtMode = src.FireProtMode;
                    }
                    if (src.FireProtData !== undefined) {
                        dst.FireProtData = src.FireProtData;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignData();
                    dst.BarGuid = this.BarGuid;
                    dst.SecGuidStart = this.SecGuidStart;
                    dst.SecGuidEnd = this.SecGuidEnd;
                    dst.FireProtMode = this.FireProtMode;
                    dst.FireProtData = this.FireProtData;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignData.toObject(this);
                    const dst = AutoDesignData.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignData = AutoDesignData;


            export type AutoDesign_keys = 'version' | 'AutoDesignData';
            export interface AutoDesign_createType {
                version?: string,
                AutoDesignData?: ng.fem_design.auto_design_output.AutoDesignData[],
            }
            export interface AutoDesign_json {
                version?: string;
                AutoDesignData: ng.fem_design.auto_design_output.AutoDesignData_json[];
            }
            interface AutoDesign_json_in {
                __proto_name?: unknown;
                version?: unknown;
                AutoDesignData?: unknown;
            }
            export class AutoDesign {
                __proto_name = "ng.fem_design.auto_design_output.AutoDesign";
                version: string = "";
                AutoDesignData: ng.fem_design.auto_design_output.AutoDesignData[] = [];

                static fromObject(src_unknown: unknown): AutoDesign {
                    const dst = new AutoDesign();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesign but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesign_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesign but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.version !== undefined && src.version !== null) {
                        if (typeof src.version === "string") {
                            dst.version = src.version;
                        }
                        else {
                            console.log('Expected version of AutoDesign to be a string but was ', typeof src.version, src.version)
                        }
                    }
                    if (src.AutoDesignData !== undefined && src.AutoDesignData !== null) {
                        if (Array.isArray(src.AutoDesignData)) {
                            for (const element of src.AutoDesignData) {
                                dst.AutoDesignData.push(ng.fem_design.auto_design_output.AutoDesignData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected AutoDesignData of AutoDesign to be a array but was ', typeof src.AutoDesignData, src.AutoDesignData)
                        }
                    }
                    return dst;
                }

                static toObject(src: AutoDesign | null | undefined): AutoDesign_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.auto_design_output.AutoDesign is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.auto_design_output.AutoDesign") {
                        console.error('Expected ng.fem_design.auto_design_output.AutoDesign but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesign_json = {
                        version: src.version,
                        AutoDesignData: new Array<ng.fem_design.auto_design_output.AutoDesignData_json>(),
                    };
                    if (src.AutoDesignData !== null) {
                        for (const element of src.AutoDesignData) {
                            const parsed = ng.fem_design.auto_design_output.AutoDesignData.toObject(element);
                            if(parsed === null) return null;
                            dst.AutoDesignData.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: AutoDesign_createType) {
                    const dst = new AutoDesign();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.version !== undefined) {
                        dst.version = src.version;
                    }
                    if (src.AutoDesignData !== undefined) {
                        dst.AutoDesignData = src.AutoDesignData;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesign();
                    dst.version = this.version;
                    dst.AutoDesignData = this.AutoDesignData;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesign.toObject(this);
                    const dst = AutoDesign.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesign = AutoDesign;
        } // namespace auto_design_output


        // Defined in FEMDesign/punching_input.proto
        export namespace punching_input {
            export type FDRCPunchingDesignForce_keys = 'limitState' | 'vEd' | 'mEdx' | 'mEdy' | 'sigmacp';
            export interface FDRCPunchingDesignForce_createType {
                limitState?: number,
                vEd?: number,
                mEdx?: number,
                mEdy?: number,
                sigmacp?: number,
            }
            export interface FDRCPunchingDesignForce_json {
                limitState?: JsonNumber;
                vEd?: JsonNumber;
                mEdx?: JsonNumber;
                mEdy?: JsonNumber;
                sigmacp?: JsonNumber;
            }
            interface FDRCPunchingDesignForce_json_in {
                __proto_name?: unknown;
                limitState?: unknown;
                vEd?: unknown;
                mEdx?: unknown;
                mEdy?: unknown;
                sigmacp?: unknown;
            }
            export class FDRCPunchingDesignForce {
                __proto_name = "ng.fem_design.punching_input.FDRCPunchingDesignForce";
                limitState: number = 0;
                vEd: number = 0;
                mEdx: number = 0;
                mEdy: number = 0;
                sigmacp: number = 0;

                static fromObject(src_unknown: unknown): FDRCPunchingDesignForce {
                    const dst = new FDRCPunchingDesignForce();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingDesignForce but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingDesignForce_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingDesignForce but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.limitState !== undefined && src.limitState !== null) {
                        if (typeof src.limitState === "number" || src.limitState === 'NaN' || src.limitState === 'Infinity' || src.limitState === '-Infinity') {
                            dst.limitState = NumberToInt("ng.fem_design.punching_input.FDRCPunchingDesignForce.limit_state", AsNum(src.limitState));
                        }
                        else {
                            console.log('Expected limitState of FDRCPunchingDesignForce to be a number but was ', typeof src.limitState, src.limitState)
                        }
                    }
                    if (src.vEd !== undefined && src.vEd !== null) {
                        if (typeof src.vEd === "number" || src.vEd === 'NaN' || src.vEd === 'Infinity' || src.vEd === '-Infinity') {
                            dst.vEd = AsNum(src.vEd);
                        }
                        else {
                            console.log('Expected vEd of FDRCPunchingDesignForce to be a number but was ', typeof src.vEd, src.vEd)
                        }
                    }
                    if (src.mEdx !== undefined && src.mEdx !== null) {
                        if (typeof src.mEdx === "number" || src.mEdx === 'NaN' || src.mEdx === 'Infinity' || src.mEdx === '-Infinity') {
                            dst.mEdx = AsNum(src.mEdx);
                        }
                        else {
                            console.log('Expected mEdx of FDRCPunchingDesignForce to be a number but was ', typeof src.mEdx, src.mEdx)
                        }
                    }
                    if (src.mEdy !== undefined && src.mEdy !== null) {
                        if (typeof src.mEdy === "number" || src.mEdy === 'NaN' || src.mEdy === 'Infinity' || src.mEdy === '-Infinity') {
                            dst.mEdy = AsNum(src.mEdy);
                        }
                        else {
                            console.log('Expected mEdy of FDRCPunchingDesignForce to be a number but was ', typeof src.mEdy, src.mEdy)
                        }
                    }
                    if (src.sigmacp !== undefined && src.sigmacp !== null) {
                        if (typeof src.sigmacp === "number" || src.sigmacp === 'NaN' || src.sigmacp === 'Infinity' || src.sigmacp === '-Infinity') {
                            dst.sigmacp = AsNum(src.sigmacp);
                        }
                        else {
                            console.log('Expected sigmacp of FDRCPunchingDesignForce to be a number but was ', typeof src.sigmacp, src.sigmacp)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingDesignForce | null | undefined): FDRCPunchingDesignForce_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_input.FDRCPunchingDesignForce is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_input.FDRCPunchingDesignForce") {
                        console.error('Expected ng.fem_design.punching_input.FDRCPunchingDesignForce but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingDesignForce_json = {
                        limitState: AsJsonNum(NumberToInt("ng.fem_design.punching_input.FDRCPunchingDesignForce.limit_state", src.limitState)),
                        vEd: AsJsonNum(src.vEd),
                        mEdx: AsJsonNum(src.mEdx),
                        mEdy: AsJsonNum(src.mEdy),
                        sigmacp: AsJsonNum(src.sigmacp),
                    };
                    return dst;
                }

                static create(src?: FDRCPunchingDesignForce_createType) {
                    const dst = new FDRCPunchingDesignForce();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.limitState !== undefined) {
                        dst.limitState = src.limitState;
                    }
                    if (src.vEd !== undefined) {
                        dst.vEd = src.vEd;
                    }
                    if (src.mEdx !== undefined) {
                        dst.mEdx = src.mEdx;
                    }
                    if (src.mEdy !== undefined) {
                        dst.mEdy = src.mEdy;
                    }
                    if (src.sigmacp !== undefined) {
                        dst.sigmacp = src.sigmacp;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingDesignForce();
                    dst.limitState = this.limitState;
                    dst.vEd = this.vEd;
                    dst.mEdx = this.mEdx;
                    dst.mEdy = this.mEdy;
                    dst.sigmacp = this.sigmacp;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingDesignForce.toObject(this);
                    const dst = FDRCPunchingDesignForce.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingDesignForce = FDRCPunchingDesignForce;


            export type FDRCPunchingEntityDesignForcesView_keys = 'guid' | 'designForcesNo' | 'designForces';
            export interface FDRCPunchingEntityDesignForcesView_createType {
                guid?: string,
                designForcesNo?: number,
                designForces?: ng.fem_design.punching_input.FDRCPunchingDesignForce[],
            }
            export interface FDRCPunchingEntityDesignForcesView_json {
                guid?: string;
                designForcesNo?: JsonNumber;
                designForces: ng.fem_design.punching_input.FDRCPunchingDesignForce_json[];
            }
            interface FDRCPunchingEntityDesignForcesView_json_in {
                __proto_name?: unknown;
                guid?: unknown;
                designForcesNo?: unknown;
                designForces?: unknown;
            }
            export class FDRCPunchingEntityDesignForcesView {
                __proto_name = "ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView";
                guid: string = "";
                designForcesNo: number = 0;
                designForces: ng.fem_design.punching_input.FDRCPunchingDesignForce[] = [];

                static fromObject(src_unknown: unknown): FDRCPunchingEntityDesignForcesView {
                    const dst = new FDRCPunchingEntityDesignForcesView();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingEntityDesignForcesView but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingEntityDesignForcesView_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingEntityDesignForcesView but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of FDRCPunchingEntityDesignForcesView to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.designForcesNo !== undefined && src.designForcesNo !== null) {
                        if (typeof src.designForcesNo === "number" || src.designForcesNo === 'NaN' || src.designForcesNo === 'Infinity' || src.designForcesNo === '-Infinity') {
                            dst.designForcesNo = NumberToInt("ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView.design_forces_no", AsNum(src.designForcesNo));
                        }
                        else {
                            console.log('Expected designForcesNo of FDRCPunchingEntityDesignForcesView to be a number but was ', typeof src.designForcesNo, src.designForcesNo)
                        }
                    }
                    if (src.designForces !== undefined && src.designForces !== null) {
                        if (Array.isArray(src.designForces)) {
                            for (const element of src.designForces) {
                                dst.designForces.push(ng.fem_design.punching_input.FDRCPunchingDesignForce.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected designForces of FDRCPunchingEntityDesignForcesView to be a array but was ', typeof src.designForces, src.designForces)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingEntityDesignForcesView | null | undefined): FDRCPunchingEntityDesignForcesView_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView") {
                        console.error('Expected ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingEntityDesignForcesView_json = {
                        guid: src.guid,
                        designForcesNo: AsJsonNum(NumberToInt("ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView.design_forces_no", src.designForcesNo)),
                        designForces: new Array<ng.fem_design.punching_input.FDRCPunchingDesignForce_json>(),
                    };
                    if (src.designForces !== null) {
                        for (const element of src.designForces) {
                            const parsed = ng.fem_design.punching_input.FDRCPunchingDesignForce.toObject(element);
                            if(parsed === null) return null;
                            dst.designForces.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingEntityDesignForcesView_createType) {
                    const dst = new FDRCPunchingEntityDesignForcesView();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.designForcesNo !== undefined) {
                        dst.designForcesNo = src.designForcesNo;
                    }
                    if (src.designForces !== undefined) {
                        dst.designForces = src.designForces;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingEntityDesignForcesView();
                    dst.guid = this.guid;
                    dst.designForcesNo = this.designForcesNo;
                    dst.designForces = this.designForces;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingEntityDesignForcesView.toObject(this);
                    const dst = FDRCPunchingEntityDesignForcesView.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingEntityDesignForcesView = FDRCPunchingEntityDesignForcesView;


            export type FDRCPunchingDesignForcesDatabaseView_keys = 'SchemaId' | 'EntityDesignForcesNo' | 'entityDesignForces';
            export interface FDRCPunchingDesignForcesDatabaseView_createType {
                SchemaId?: number,
                EntityDesignForcesNo?: number,
                entityDesignForces?: ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView[],
            }
            export interface FDRCPunchingDesignForcesDatabaseView_json {
                SchemaId?: JsonNumber;
                EntityDesignForcesNo?: JsonNumber;
                entityDesignForces: ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView_json[];
            }
            interface FDRCPunchingDesignForcesDatabaseView_json_in {
                __proto_name?: unknown;
                SchemaId?: unknown;
                EntityDesignForcesNo?: unknown;
                entityDesignForces?: unknown;
            }
            export class FDRCPunchingDesignForcesDatabaseView {
                __proto_name = "ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView";
                SchemaId: number = 0;
                EntityDesignForcesNo: number = 0;
                entityDesignForces: ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView[] = [];

                static fromObject(src_unknown: unknown): FDRCPunchingDesignForcesDatabaseView {
                    const dst = new FDRCPunchingDesignForcesDatabaseView();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingDesignForcesDatabaseView but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingDesignForcesDatabaseView_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingDesignForcesDatabaseView but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.SchemaId !== undefined && src.SchemaId !== null) {
                        if (typeof src.SchemaId === "number" || src.SchemaId === 'NaN' || src.SchemaId === 'Infinity' || src.SchemaId === '-Infinity') {
                            dst.SchemaId = NumberToInt("ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView.SchemaId", AsNum(src.SchemaId));
                        }
                        else {
                            console.log('Expected SchemaId of FDRCPunchingDesignForcesDatabaseView to be a number but was ', typeof src.SchemaId, src.SchemaId)
                        }
                    }
                    if (src.EntityDesignForcesNo !== undefined && src.EntityDesignForcesNo !== null) {
                        if (typeof src.EntityDesignForcesNo === "number" || src.EntityDesignForcesNo === 'NaN' || src.EntityDesignForcesNo === 'Infinity' || src.EntityDesignForcesNo === '-Infinity') {
                            dst.EntityDesignForcesNo = NumberToInt("ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView.EntityDesignForcesNo", AsNum(src.EntityDesignForcesNo));
                        }
                        else {
                            console.log('Expected EntityDesignForcesNo of FDRCPunchingDesignForcesDatabaseView to be a number but was ', typeof src.EntityDesignForcesNo, src.EntityDesignForcesNo)
                        }
                    }
                    if (src.entityDesignForces !== undefined && src.entityDesignForces !== null) {
                        if (Array.isArray(src.entityDesignForces)) {
                            for (const element of src.entityDesignForces) {
                                dst.entityDesignForces.push(ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected entityDesignForces of FDRCPunchingDesignForcesDatabaseView to be a array but was ', typeof src.entityDesignForces, src.entityDesignForces)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingDesignForcesDatabaseView | null | undefined): FDRCPunchingDesignForcesDatabaseView_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView") {
                        console.error('Expected ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingDesignForcesDatabaseView_json = {
                        SchemaId: AsJsonNum(NumberToInt("ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView.SchemaId", src.SchemaId)),
                        EntityDesignForcesNo: AsJsonNum(NumberToInt("ng.fem_design.punching_input.FDRCPunchingDesignForcesDatabaseView.EntityDesignForcesNo", src.EntityDesignForcesNo)),
                        entityDesignForces: new Array<ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView_json>(),
                    };
                    if (src.entityDesignForces !== null) {
                        for (const element of src.entityDesignForces) {
                            const parsed = ng.fem_design.punching_input.FDRCPunchingEntityDesignForcesView.toObject(element);
                            if(parsed === null) return null;
                            dst.entityDesignForces.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingDesignForcesDatabaseView_createType) {
                    const dst = new FDRCPunchingDesignForcesDatabaseView();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.SchemaId !== undefined) {
                        dst.SchemaId = src.SchemaId;
                    }
                    if (src.EntityDesignForcesNo !== undefined) {
                        dst.EntityDesignForcesNo = src.EntityDesignForcesNo;
                    }
                    if (src.entityDesignForces !== undefined) {
                        dst.entityDesignForces = src.entityDesignForces;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingDesignForcesDatabaseView();
                    dst.SchemaId = this.SchemaId;
                    dst.EntityDesignForcesNo = this.EntityDesignForcesNo;
                    dst.entityDesignForces = this.entityDesignForces;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingDesignForcesDatabaseView.toObject(this);
                    const dst = FDRCPunchingDesignForcesDatabaseView.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingDesignForcesDatabaseView = FDRCPunchingDesignForcesDatabaseView;
        } // namespace punching_input


        // Defined in FEMDesign/punching_output.proto
        export namespace punching_output {
            export type FDPrimaryKey_keys = 'key';
            export interface FDPrimaryKey_createType {
                key?: number,
            }
            export interface FDPrimaryKey_json {
                key?: JsonNumber;
            }
            interface FDPrimaryKey_json_in {
                __proto_name?: unknown;
                key?: unknown;
            }
            export class FDPrimaryKey {
                __proto_name = "ng.fem_design.punching_output.FDPrimaryKey";
                key: number = 0;

                static fromObject(src_unknown: unknown): FDPrimaryKey {
                    const dst = new FDPrimaryKey();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDPrimaryKey but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDPrimaryKey_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDPrimaryKey but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.key !== undefined && src.key !== null) {
                        if (typeof src.key === "number" || src.key === 'NaN' || src.key === 'Infinity' || src.key === '-Infinity') {
                            dst.key = NumberToInt("ng.fem_design.punching_output.FDPrimaryKey.key", AsNum(src.key));
                        }
                        else {
                            console.log('Expected key of FDPrimaryKey to be a number but was ', typeof src.key, src.key)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDPrimaryKey | null | undefined): FDPrimaryKey_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDPrimaryKey is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDPrimaryKey") {
                        console.error('Expected ng.fem_design.punching_output.FDPrimaryKey but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDPrimaryKey_json = {
                        key: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDPrimaryKey.key", src.key)),
                    };
                    return dst;
                }

                static create(src?: FDPrimaryKey_createType) {
                    const dst = new FDPrimaryKey();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.key !== undefined) {
                        dst.key = src.key;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDPrimaryKey();
                    dst.key = this.key;
                    return dst;
                }

                deepClone() {
                    const json = FDPrimaryKey.toObject(this);
                    const dst = FDPrimaryKey.fromObject(json);
                    return dst;
                }
            }
            export type IFDPrimaryKey = FDPrimaryKey;


            export type FDForeignKey_keys = 'key';
            export interface FDForeignKey_createType {
                key?: number,
            }
            export interface FDForeignKey_json {
                key?: JsonNumber;
            }
            interface FDForeignKey_json_in {
                __proto_name?: unknown;
                key?: unknown;
            }
            export class FDForeignKey {
                __proto_name = "ng.fem_design.punching_output.FDForeignKey";
                key: number = 0;

                static fromObject(src_unknown: unknown): FDForeignKey {
                    const dst = new FDForeignKey();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDForeignKey but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDForeignKey_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDForeignKey but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.key !== undefined && src.key !== null) {
                        if (typeof src.key === "number" || src.key === 'NaN' || src.key === 'Infinity' || src.key === '-Infinity') {
                            dst.key = NumberToInt("ng.fem_design.punching_output.FDForeignKey.key", AsNum(src.key));
                        }
                        else {
                            console.log('Expected key of FDForeignKey to be a number but was ', typeof src.key, src.key)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDForeignKey | null | undefined): FDForeignKey_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDForeignKey is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDForeignKey") {
                        console.error('Expected ng.fem_design.punching_output.FDForeignKey but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDForeignKey_json = {
                        key: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDForeignKey.key", src.key)),
                    };
                    return dst;
                }

                static create(src?: FDForeignKey_createType) {
                    const dst = new FDForeignKey();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.key !== undefined) {
                        dst.key = src.key;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDForeignKey();
                    dst.key = this.key;
                    return dst;
                }

                deepClone() {
                    const json = FDForeignKey.toObject(this);
                    const dst = FDForeignKey.fromObject(json);
                    return dst;
                }
            }
            export type IFDForeignKey = FDForeignKey;


            export type FDSize32_keys = 'key';
            export interface FDSize32_createType {
                key?: number,
            }
            export interface FDSize32_json {
                key?: JsonNumber;
            }
            interface FDSize32_json_in {
                __proto_name?: unknown;
                key?: unknown;
            }
            export class FDSize32 {
                __proto_name = "ng.fem_design.punching_output.FDSize32";
                key: number = 0;

                static fromObject(src_unknown: unknown): FDSize32 {
                    const dst = new FDSize32();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDSize32 but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDSize32_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDSize32 but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.key !== undefined && src.key !== null) {
                        if (typeof src.key === "number" || src.key === 'NaN' || src.key === 'Infinity' || src.key === '-Infinity') {
                            dst.key = NumberToInt("ng.fem_design.punching_output.FDSize32.key", AsNum(src.key));
                        }
                        else {
                            console.log('Expected key of FDSize32 to be a number but was ', typeof src.key, src.key)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDSize32 | null | undefined): FDSize32_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDSize32 is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDSize32") {
                        console.error('Expected ng.fem_design.punching_output.FDSize32 but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDSize32_json = {
                        key: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDSize32.key", src.key)),
                    };
                    return dst;
                }

                static create(src?: FDSize32_createType) {
                    const dst = new FDSize32();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.key !== undefined) {
                        dst.key = src.key;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDSize32();
                    dst.key = this.key;
                    return dst;
                }

                deepClone() {
                    const json = FDSize32.toObject(this);
                    const dst = FDSize32.fromObject(json);
                    return dst;
                }
            }
            export type IFDSize32 = FDSize32;


            export type FDPoint3D_keys = 'x' | 'y' | 'z';
            export interface FDPoint3D_createType {
                x?: number,
                y?: number,
                z?: number,
            }
            export interface FDPoint3D_json {
                x?: JsonNumber;
                y?: JsonNumber;
                z?: JsonNumber;
            }
            interface FDPoint3D_json_in {
                __proto_name?: unknown;
                x?: unknown;
                y?: unknown;
                z?: unknown;
            }
            export class FDPoint3D {
                __proto_name = "ng.fem_design.punching_output.FDPoint3D";
                x: number = 0;
                y: number = 0;
                z: number = 0;

                static fromObject(src_unknown: unknown): FDPoint3D {
                    const dst = new FDPoint3D();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDPoint3D but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDPoint3D_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDPoint3D but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.x !== undefined && src.x !== null) {
                        if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                            dst.x = AsNum(src.x);
                        }
                        else {
                            console.log('Expected x of FDPoint3D to be a number but was ', typeof src.x, src.x)
                        }
                    }
                    if (src.y !== undefined && src.y !== null) {
                        if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                            dst.y = AsNum(src.y);
                        }
                        else {
                            console.log('Expected y of FDPoint3D to be a number but was ', typeof src.y, src.y)
                        }
                    }
                    if (src.z !== undefined && src.z !== null) {
                        if (typeof src.z === "number" || src.z === 'NaN' || src.z === 'Infinity' || src.z === '-Infinity') {
                            dst.z = AsNum(src.z);
                        }
                        else {
                            console.log('Expected z of FDPoint3D to be a number but was ', typeof src.z, src.z)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDPoint3D | null | undefined): FDPoint3D_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDPoint3D is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDPoint3D") {
                        console.error('Expected ng.fem_design.punching_output.FDPoint3D but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDPoint3D_json = {
                        x: AsJsonNum(src.x),
                        y: AsJsonNum(src.y),
                        z: AsJsonNum(src.z),
                    };
                    return dst;
                }

                static create(src?: FDPoint3D_createType) {
                    const dst = new FDPoint3D();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.x !== undefined) {
                        dst.x = src.x;
                    }
                    if (src.y !== undefined) {
                        dst.y = src.y;
                    }
                    if (src.z !== undefined) {
                        dst.z = src.z;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDPoint3D();
                    dst.x = this.x;
                    dst.y = this.y;
                    dst.z = this.z;
                    return dst;
                }

                deepClone() {
                    const json = FDPoint3D.toObject(this);
                    const dst = FDPoint3D.fromObject(json);
                    return dst;
                }
            }
            export type IFDPoint3D = FDPoint3D;


            export type FDRegionPolyline3DView_keys = 'contoursNo' | 'pointsNoOnContours' | 'pointsNo' | 'points';
            export interface FDRegionPolyline3DView_createType {
                contoursNo?: number,
                pointsNoOnContours?: ng.fem_design.punching_output.FDSize32[],
                pointsNo?: ng.fem_design.punching_output.FDSize32 | null,
                points?: ng.fem_design.punching_output.FDPoint3D[],
            }
            export interface FDRegionPolyline3DView_json {
                contoursNo?: JsonNumber;
                pointsNoOnContours: ng.fem_design.punching_output.FDSize32_json[];
                pointsNo?: ng.fem_design.punching_output.FDSize32_json;
                points: ng.fem_design.punching_output.FDPoint3D_json[];
            }
            interface FDRegionPolyline3DView_json_in {
                __proto_name?: unknown;
                contoursNo?: unknown;
                pointsNoOnContours?: unknown;
                pointsNo?: unknown;
                points?: unknown;
            }
            export class FDRegionPolyline3DView {
                __proto_name = "ng.fem_design.punching_output.FDRegionPolyline3DView";
                contoursNo: number = 0;
                pointsNoOnContours: ng.fem_design.punching_output.FDSize32[] = [];
                pointsNo: ng.fem_design.punching_output.FDSize32 | null = null;
                points: ng.fem_design.punching_output.FDPoint3D[] = [];

                static fromObject(src_unknown: unknown): FDRegionPolyline3DView {
                    const dst = new FDRegionPolyline3DView();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRegionPolyline3DView but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRegionPolyline3DView_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRegionPolyline3DView but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.contoursNo !== undefined && src.contoursNo !== null) {
                        if (typeof src.contoursNo === "number" || src.contoursNo === 'NaN' || src.contoursNo === 'Infinity' || src.contoursNo === '-Infinity') {
                            dst.contoursNo = NumberToInt("ng.fem_design.punching_output.FDRegionPolyline3DView.contours_no", AsNum(src.contoursNo));
                        }
                        else {
                            console.log('Expected contoursNo of FDRegionPolyline3DView to be a number but was ', typeof src.contoursNo, src.contoursNo)
                        }
                    }
                    if (src.pointsNoOnContours !== undefined && src.pointsNoOnContours !== null) {
                        if (Array.isArray(src.pointsNoOnContours)) {
                            for (const element of src.pointsNoOnContours) {
                                dst.pointsNoOnContours.push(ng.fem_design.punching_output.FDSize32.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected pointsNoOnContours of FDRegionPolyline3DView to be a array but was ', typeof src.pointsNoOnContours, src.pointsNoOnContours)
                        }
                    }
                    if (src.pointsNo !== undefined && src.pointsNo !== null) {
                        dst.pointsNo = ng.fem_design.punching_output.FDSize32.fromObject(src.pointsNo);
                    }
                    if (src.points !== undefined && src.points !== null) {
                        if (Array.isArray(src.points)) {
                            for (const element of src.points) {
                                dst.points.push(ng.fem_design.punching_output.FDPoint3D.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected points of FDRegionPolyline3DView to be a array but was ', typeof src.points, src.points)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRegionPolyline3DView | null | undefined): FDRegionPolyline3DView_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRegionPolyline3DView is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRegionPolyline3DView") {
                        console.error('Expected ng.fem_design.punching_output.FDRegionPolyline3DView but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRegionPolyline3DView_json = {
                        contoursNo: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRegionPolyline3DView.contours_no", src.contoursNo)),
                        pointsNoOnContours: new Array<ng.fem_design.punching_output.FDSize32_json>(),
                        points: new Array<ng.fem_design.punching_output.FDPoint3D_json>(),
                    };
                    if (src.pointsNoOnContours !== null) {
                        for (const element of src.pointsNoOnContours) {
                            const parsed = ng.fem_design.punching_output.FDSize32.toObject(element);
                            if(parsed === null) return null;
                            dst.pointsNoOnContours.push(parsed);
                        }
                    }
                    if(src.pointsNo !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDSize32.toObject(src.pointsNo);
                        if(parsed === null) return null;
                        dst.pointsNo = parsed;
                    }
                    if (src.points !== null) {
                        for (const element of src.points) {
                            const parsed = ng.fem_design.punching_output.FDPoint3D.toObject(element);
                            if(parsed === null) return null;
                            dst.points.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: FDRegionPolyline3DView_createType) {
                    const dst = new FDRegionPolyline3DView();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.contoursNo !== undefined) {
                        dst.contoursNo = src.contoursNo;
                    }
                    if (src.pointsNoOnContours !== undefined) {
                        dst.pointsNoOnContours = src.pointsNoOnContours;
                    }
                    if (src.pointsNo !== undefined) {
                        dst.pointsNo = src.pointsNo;
                    }
                    if (src.points !== undefined) {
                        dst.points = src.points;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRegionPolyline3DView();
                    dst.contoursNo = this.contoursNo;
                    dst.pointsNoOnContours = this.pointsNoOnContours;
                    dst.pointsNo = this.pointsNo;
                    dst.points = this.points;
                    return dst;
                }

                deepClone() {
                    const json = FDRegionPolyline3DView.toObject(this);
                    const dst = FDRegionPolyline3DView.fromObject(json);
                    return dst;
                }
            }
            export type IFDRegionPolyline3DView = FDRegionPolyline3DView;


            export type FDRegionPolyline3DRecordView_keys = 'idRegion' | 'idEntity' | 'region';
            export interface FDRegionPolyline3DRecordView_createType {
                idRegion?: ng.fem_design.punching_output.FDPrimaryKey | null,
                idEntity?: ng.fem_design.punching_output.FDForeignKey | null,
                region?: ng.fem_design.punching_output.FDRegionPolyline3DView | null,
            }
            export interface FDRegionPolyline3DRecordView_json {
                idRegion?: ng.fem_design.punching_output.FDPrimaryKey_json;
                idEntity?: ng.fem_design.punching_output.FDForeignKey_json;
                region?: ng.fem_design.punching_output.FDRegionPolyline3DView_json;
            }
            interface FDRegionPolyline3DRecordView_json_in {
                __proto_name?: unknown;
                idRegion?: unknown;
                idEntity?: unknown;
                region?: unknown;
            }
            export class FDRegionPolyline3DRecordView {
                __proto_name = "ng.fem_design.punching_output.FDRegionPolyline3DRecordView";
                idRegion: ng.fem_design.punching_output.FDPrimaryKey | null = null;
                idEntity: ng.fem_design.punching_output.FDForeignKey | null = null;
                region: ng.fem_design.punching_output.FDRegionPolyline3DView | null = null;

                static fromObject(src_unknown: unknown): FDRegionPolyline3DRecordView {
                    const dst = new FDRegionPolyline3DRecordView();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRegionPolyline3DRecordView but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRegionPolyline3DRecordView_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRegionPolyline3DRecordView but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.idRegion !== undefined && src.idRegion !== null) {
                        dst.idRegion = ng.fem_design.punching_output.FDPrimaryKey.fromObject(src.idRegion);
                    }
                    if (src.idEntity !== undefined && src.idEntity !== null) {
                        dst.idEntity = ng.fem_design.punching_output.FDForeignKey.fromObject(src.idEntity);
                    }
                    if (src.region !== undefined && src.region !== null) {
                        dst.region = ng.fem_design.punching_output.FDRegionPolyline3DView.fromObject(src.region);
                    }
                    return dst;
                }

                static toObject(src: FDRegionPolyline3DRecordView | null | undefined): FDRegionPolyline3DRecordView_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRegionPolyline3DRecordView is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRegionPolyline3DRecordView") {
                        console.error('Expected ng.fem_design.punching_output.FDRegionPolyline3DRecordView but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRegionPolyline3DRecordView_json = {
                    };
                    if(src.idRegion !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDPrimaryKey.toObject(src.idRegion);
                        if(parsed === null) return null;
                        dst.idRegion = parsed;
                    }
                    if(src.idEntity !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDForeignKey.toObject(src.idEntity);
                        if(parsed === null) return null;
                        dst.idEntity = parsed;
                    }
                    if(src.region !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRegionPolyline3DView.toObject(src.region);
                        if(parsed === null) return null;
                        dst.region = parsed;
                    }
                    return dst;
                }

                static create(src?: FDRegionPolyline3DRecordView_createType) {
                    const dst = new FDRegionPolyline3DRecordView();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.idRegion !== undefined) {
                        dst.idRegion = src.idRegion;
                    }
                    if (src.idEntity !== undefined) {
                        dst.idEntity = src.idEntity;
                    }
                    if (src.region !== undefined) {
                        dst.region = src.region;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRegionPolyline3DRecordView();
                    dst.idRegion = this.idRegion;
                    dst.idEntity = this.idEntity;
                    dst.region = this.region;
                    return dst;
                }

                deepClone() {
                    const json = FDRegionPolyline3DRecordView.toObject(this);
                    const dst = FDRegionPolyline3DRecordView.fromObject(json);
                    return dst;
                }
            }
            export type IFDRegionPolyline3DRecordView = FDRegionPolyline3DRecordView;


            export type FDRCPunchingCheckConcreteCompression_keys = 'rBeta' | 'rdy' | 'rdz' | 'rdeff' | 'ru0' | 'ru1' | 'rnu' | 'rVEd0' | 'rvEd' | 'rvRdmax' | 'rvRdc';
            export interface FDRCPunchingCheckConcreteCompression_createType {
                rBeta?: number,
                rdy?: number,
                rdz?: number,
                rdeff?: number,
                ru0?: number,
                ru1?: number,
                rnu?: number,
                rVEd0?: number,
                rvEd?: number,
                rvRdmax?: number,
                rvRdc?: number,
            }
            export interface FDRCPunchingCheckConcreteCompression_json {
                rBeta?: JsonNumber;
                rdy?: JsonNumber;
                rdz?: JsonNumber;
                rdeff?: JsonNumber;
                ru0?: JsonNumber;
                ru1?: JsonNumber;
                rnu?: JsonNumber;
                rVEd0?: JsonNumber;
                rvEd?: JsonNumber;
                rvRdmax?: JsonNumber;
                rvRdc?: JsonNumber;
            }
            interface FDRCPunchingCheckConcreteCompression_json_in {
                __proto_name?: unknown;
                rBeta?: unknown;
                rdy?: unknown;
                rdz?: unknown;
                rdeff?: unknown;
                ru0?: unknown;
                ru1?: unknown;
                rnu?: unknown;
                rVEd0?: unknown;
                rvEd?: unknown;
                rvRdmax?: unknown;
                rvRdc?: unknown;
            }
            export class FDRCPunchingCheckConcreteCompression {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression";
                rBeta: number = 0;
                rdy: number = 0;
                rdz: number = 0;
                rdeff: number = 0;
                ru0: number = 0;
                ru1: number = 0;
                rnu: number = 0;
                rVEd0: number = 0;
                rvEd: number = 0;
                rvRdmax: number = 0;
                rvRdc: number = 0;

                static fromObject(src_unknown: unknown): FDRCPunchingCheckConcreteCompression {
                    const dst = new FDRCPunchingCheckConcreteCompression();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckConcreteCompression but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckConcreteCompression_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckConcreteCompression but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rBeta !== undefined && src.rBeta !== null) {
                        if (typeof src.rBeta === "number" || src.rBeta === 'NaN' || src.rBeta === 'Infinity' || src.rBeta === '-Infinity') {
                            dst.rBeta = AsNum(src.rBeta);
                        }
                        else {
                            console.log('Expected rBeta of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rBeta, src.rBeta)
                        }
                    }
                    if (src.rdy !== undefined && src.rdy !== null) {
                        if (typeof src.rdy === "number" || src.rdy === 'NaN' || src.rdy === 'Infinity' || src.rdy === '-Infinity') {
                            dst.rdy = AsNum(src.rdy);
                        }
                        else {
                            console.log('Expected rdy of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rdy, src.rdy)
                        }
                    }
                    if (src.rdz !== undefined && src.rdz !== null) {
                        if (typeof src.rdz === "number" || src.rdz === 'NaN' || src.rdz === 'Infinity' || src.rdz === '-Infinity') {
                            dst.rdz = AsNum(src.rdz);
                        }
                        else {
                            console.log('Expected rdz of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rdz, src.rdz)
                        }
                    }
                    if (src.rdeff !== undefined && src.rdeff !== null) {
                        if (typeof src.rdeff === "number" || src.rdeff === 'NaN' || src.rdeff === 'Infinity' || src.rdeff === '-Infinity') {
                            dst.rdeff = AsNum(src.rdeff);
                        }
                        else {
                            console.log('Expected rdeff of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rdeff, src.rdeff)
                        }
                    }
                    if (src.ru0 !== undefined && src.ru0 !== null) {
                        if (typeof src.ru0 === "number" || src.ru0 === 'NaN' || src.ru0 === 'Infinity' || src.ru0 === '-Infinity') {
                            dst.ru0 = AsNum(src.ru0);
                        }
                        else {
                            console.log('Expected ru0 of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.ru0, src.ru0)
                        }
                    }
                    if (src.ru1 !== undefined && src.ru1 !== null) {
                        if (typeof src.ru1 === "number" || src.ru1 === 'NaN' || src.ru1 === 'Infinity' || src.ru1 === '-Infinity') {
                            dst.ru1 = AsNum(src.ru1);
                        }
                        else {
                            console.log('Expected ru1 of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.ru1, src.ru1)
                        }
                    }
                    if (src.rnu !== undefined && src.rnu !== null) {
                        if (typeof src.rnu === "number" || src.rnu === 'NaN' || src.rnu === 'Infinity' || src.rnu === '-Infinity') {
                            dst.rnu = AsNum(src.rnu);
                        }
                        else {
                            console.log('Expected rnu of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rnu, src.rnu)
                        }
                    }
                    if (src.rVEd0 !== undefined && src.rVEd0 !== null) {
                        if (typeof src.rVEd0 === "number" || src.rVEd0 === 'NaN' || src.rVEd0 === 'Infinity' || src.rVEd0 === '-Infinity') {
                            dst.rVEd0 = AsNum(src.rVEd0);
                        }
                        else {
                            console.log('Expected rVEd0 of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rVEd0, src.rVEd0)
                        }
                    }
                    if (src.rvEd !== undefined && src.rvEd !== null) {
                        if (typeof src.rvEd === "number" || src.rvEd === 'NaN' || src.rvEd === 'Infinity' || src.rvEd === '-Infinity') {
                            dst.rvEd = AsNum(src.rvEd);
                        }
                        else {
                            console.log('Expected rvEd of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rvEd, src.rvEd)
                        }
                    }
                    if (src.rvRdmax !== undefined && src.rvRdmax !== null) {
                        if (typeof src.rvRdmax === "number" || src.rvRdmax === 'NaN' || src.rvRdmax === 'Infinity' || src.rvRdmax === '-Infinity') {
                            dst.rvRdmax = AsNum(src.rvRdmax);
                        }
                        else {
                            console.log('Expected rvRdmax of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rvRdmax, src.rvRdmax)
                        }
                    }
                    if (src.rvRdc !== undefined && src.rvRdc !== null) {
                        if (typeof src.rvRdc === "number" || src.rvRdc === 'NaN' || src.rvRdc === 'Infinity' || src.rvRdc === '-Infinity') {
                            dst.rvRdc = AsNum(src.rvRdc);
                        }
                        else {
                            console.log('Expected rvRdc of FDRCPunchingCheckConcreteCompression to be a number but was ', typeof src.rvRdc, src.rvRdc)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckConcreteCompression | null | undefined): FDRCPunchingCheckConcreteCompression_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckConcreteCompression_json = {
                        rBeta: AsJsonNum(src.rBeta),
                        rdy: AsJsonNum(src.rdy),
                        rdz: AsJsonNum(src.rdz),
                        rdeff: AsJsonNum(src.rdeff),
                        ru0: AsJsonNum(src.ru0),
                        ru1: AsJsonNum(src.ru1),
                        rnu: AsJsonNum(src.rnu),
                        rVEd0: AsJsonNum(src.rVEd0),
                        rvEd: AsJsonNum(src.rvEd),
                        rvRdmax: AsJsonNum(src.rvRdmax),
                        rvRdc: AsJsonNum(src.rvRdc),
                    };
                    return dst;
                }

                static create(src?: FDRCPunchingCheckConcreteCompression_createType) {
                    const dst = new FDRCPunchingCheckConcreteCompression();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rBeta !== undefined) {
                        dst.rBeta = src.rBeta;
                    }
                    if (src.rdy !== undefined) {
                        dst.rdy = src.rdy;
                    }
                    if (src.rdz !== undefined) {
                        dst.rdz = src.rdz;
                    }
                    if (src.rdeff !== undefined) {
                        dst.rdeff = src.rdeff;
                    }
                    if (src.ru0 !== undefined) {
                        dst.ru0 = src.ru0;
                    }
                    if (src.ru1 !== undefined) {
                        dst.ru1 = src.ru1;
                    }
                    if (src.rnu !== undefined) {
                        dst.rnu = src.rnu;
                    }
                    if (src.rVEd0 !== undefined) {
                        dst.rVEd0 = src.rVEd0;
                    }
                    if (src.rvEd !== undefined) {
                        dst.rvEd = src.rvEd;
                    }
                    if (src.rvRdmax !== undefined) {
                        dst.rvRdmax = src.rvRdmax;
                    }
                    if (src.rvRdc !== undefined) {
                        dst.rvRdc = src.rvRdc;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckConcreteCompression();
                    dst.rBeta = this.rBeta;
                    dst.rdy = this.rdy;
                    dst.rdz = this.rdz;
                    dst.rdeff = this.rdeff;
                    dst.ru0 = this.ru0;
                    dst.ru1 = this.ru1;
                    dst.rnu = this.rnu;
                    dst.rVEd0 = this.rVEd0;
                    dst.rvEd = this.rvEd;
                    dst.rvRdmax = this.rvRdmax;
                    dst.rvRdc = this.rvRdc;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckConcreteCompression.toObject(this);
                    const dst = FDRCPunchingCheckConcreteCompression.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckConcreteCompression = FDRCPunchingCheckConcreteCompression;


            export type FDRCPunchingCheckConcreteShear_keys = 'rBeta' | 'rdy' | 'rdz' | 'rdeff' | 'ru' | 'rDist' | 'rVEd' | 'rvvEd' | 'rk' | 'rRhol' | 'rRholy' | 'rRholz' | 'rSigmacp' | 'rCRdc' | 'rvmin' | 'rk1' | 'rvRdc' | 'rkmaxPSB' | 'rvRdmax' | 'rVRddow' | 'nPSHSShearSection';
            export interface FDRCPunchingCheckConcreteShear_createType {
                rBeta?: number,
                rdy?: number,
                rdz?: number,
                rdeff?: number,
                ru?: number,
                rDist?: number,
                rVEd?: number,
                rvvEd?: number,
                rk?: number,
                rRhol?: number,
                rRholy?: number,
                rRholz?: number,
                rSigmacp?: number,
                rCRdc?: number,
                rvmin?: number,
                rk1?: number,
                rvRdc?: number,
                rkmaxPSB?: number,
                rvRdmax?: number,
                rVRddow?: number,
                nPSHSShearSection?: number,
            }
            export interface FDRCPunchingCheckConcreteShear_json {
                rBeta?: JsonNumber;
                rdy?: JsonNumber;
                rdz?: JsonNumber;
                rdeff?: JsonNumber;
                ru?: JsonNumber;
                rDist?: JsonNumber;
                rVEd?: JsonNumber;
                rvvEd?: JsonNumber;
                rk?: JsonNumber;
                rRhol?: JsonNumber;
                rRholy?: JsonNumber;
                rRholz?: JsonNumber;
                rSigmacp?: JsonNumber;
                rCRdc?: JsonNumber;
                rvmin?: JsonNumber;
                rk1?: JsonNumber;
                rvRdc?: JsonNumber;
                rkmaxPSB?: JsonNumber;
                rvRdmax?: JsonNumber;
                rVRddow?: JsonNumber;
                nPSHSShearSection?: JsonNumber;
            }
            interface FDRCPunchingCheckConcreteShear_json_in {
                __proto_name?: unknown;
                rBeta?: unknown;
                rdy?: unknown;
                rdz?: unknown;
                rdeff?: unknown;
                ru?: unknown;
                rDist?: unknown;
                rVEd?: unknown;
                rvvEd?: unknown;
                rk?: unknown;
                rRhol?: unknown;
                rRholy?: unknown;
                rRholz?: unknown;
                rSigmacp?: unknown;
                rCRdc?: unknown;
                rvmin?: unknown;
                rk1?: unknown;
                rvRdc?: unknown;
                rkmaxPSB?: unknown;
                rvRdmax?: unknown;
                rVRddow?: unknown;
                nPSHSShearSection?: unknown;
            }
            export class FDRCPunchingCheckConcreteShear {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear";
                rBeta: number = 0;
                rdy: number = 0;
                rdz: number = 0;
                rdeff: number = 0;
                ru: number = 0;
                rDist: number = 0;
                rVEd: number = 0;
                rvvEd: number = 0;
                rk: number = 0;
                rRhol: number = 0;
                rRholy: number = 0;
                rRholz: number = 0;
                rSigmacp: number = 0;
                rCRdc: number = 0;
                rvmin: number = 0;
                rk1: number = 0;
                rvRdc: number = 0;
                rkmaxPSB: number = 0;
                rvRdmax: number = 0;
                rVRddow: number = 0;
                nPSHSShearSection: number = 0;

                static fromObject(src_unknown: unknown): FDRCPunchingCheckConcreteShear {
                    const dst = new FDRCPunchingCheckConcreteShear();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckConcreteShear but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckConcreteShear_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckConcreteShear but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rBeta !== undefined && src.rBeta !== null) {
                        if (typeof src.rBeta === "number" || src.rBeta === 'NaN' || src.rBeta === 'Infinity' || src.rBeta === '-Infinity') {
                            dst.rBeta = AsNum(src.rBeta);
                        }
                        else {
                            console.log('Expected rBeta of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rBeta, src.rBeta)
                        }
                    }
                    if (src.rdy !== undefined && src.rdy !== null) {
                        if (typeof src.rdy === "number" || src.rdy === 'NaN' || src.rdy === 'Infinity' || src.rdy === '-Infinity') {
                            dst.rdy = AsNum(src.rdy);
                        }
                        else {
                            console.log('Expected rdy of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rdy, src.rdy)
                        }
                    }
                    if (src.rdz !== undefined && src.rdz !== null) {
                        if (typeof src.rdz === "number" || src.rdz === 'NaN' || src.rdz === 'Infinity' || src.rdz === '-Infinity') {
                            dst.rdz = AsNum(src.rdz);
                        }
                        else {
                            console.log('Expected rdz of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rdz, src.rdz)
                        }
                    }
                    if (src.rdeff !== undefined && src.rdeff !== null) {
                        if (typeof src.rdeff === "number" || src.rdeff === 'NaN' || src.rdeff === 'Infinity' || src.rdeff === '-Infinity') {
                            dst.rdeff = AsNum(src.rdeff);
                        }
                        else {
                            console.log('Expected rdeff of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rdeff, src.rdeff)
                        }
                    }
                    if (src.ru !== undefined && src.ru !== null) {
                        if (typeof src.ru === "number" || src.ru === 'NaN' || src.ru === 'Infinity' || src.ru === '-Infinity') {
                            dst.ru = AsNum(src.ru);
                        }
                        else {
                            console.log('Expected ru of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.ru, src.ru)
                        }
                    }
                    if (src.rDist !== undefined && src.rDist !== null) {
                        if (typeof src.rDist === "number" || src.rDist === 'NaN' || src.rDist === 'Infinity' || src.rDist === '-Infinity') {
                            dst.rDist = AsNum(src.rDist);
                        }
                        else {
                            console.log('Expected rDist of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rDist, src.rDist)
                        }
                    }
                    if (src.rVEd !== undefined && src.rVEd !== null) {
                        if (typeof src.rVEd === "number" || src.rVEd === 'NaN' || src.rVEd === 'Infinity' || src.rVEd === '-Infinity') {
                            dst.rVEd = AsNum(src.rVEd);
                        }
                        else {
                            console.log('Expected rVEd of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rVEd, src.rVEd)
                        }
                    }
                    if (src.rvvEd !== undefined && src.rvvEd !== null) {
                        if (typeof src.rvvEd === "number" || src.rvvEd === 'NaN' || src.rvvEd === 'Infinity' || src.rvvEd === '-Infinity') {
                            dst.rvvEd = AsNum(src.rvvEd);
                        }
                        else {
                            console.log('Expected rvvEd of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rvvEd, src.rvvEd)
                        }
                    }
                    if (src.rk !== undefined && src.rk !== null) {
                        if (typeof src.rk === "number" || src.rk === 'NaN' || src.rk === 'Infinity' || src.rk === '-Infinity') {
                            dst.rk = AsNum(src.rk);
                        }
                        else {
                            console.log('Expected rk of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rk, src.rk)
                        }
                    }
                    if (src.rRhol !== undefined && src.rRhol !== null) {
                        if (typeof src.rRhol === "number" || src.rRhol === 'NaN' || src.rRhol === 'Infinity' || src.rRhol === '-Infinity') {
                            dst.rRhol = AsNum(src.rRhol);
                        }
                        else {
                            console.log('Expected rRhol of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rRhol, src.rRhol)
                        }
                    }
                    if (src.rRholy !== undefined && src.rRholy !== null) {
                        if (typeof src.rRholy === "number" || src.rRholy === 'NaN' || src.rRholy === 'Infinity' || src.rRholy === '-Infinity') {
                            dst.rRholy = AsNum(src.rRholy);
                        }
                        else {
                            console.log('Expected rRholy of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rRholy, src.rRholy)
                        }
                    }
                    if (src.rRholz !== undefined && src.rRholz !== null) {
                        if (typeof src.rRholz === "number" || src.rRholz === 'NaN' || src.rRholz === 'Infinity' || src.rRholz === '-Infinity') {
                            dst.rRholz = AsNum(src.rRholz);
                        }
                        else {
                            console.log('Expected rRholz of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rRholz, src.rRholz)
                        }
                    }
                    if (src.rSigmacp !== undefined && src.rSigmacp !== null) {
                        if (typeof src.rSigmacp === "number" || src.rSigmacp === 'NaN' || src.rSigmacp === 'Infinity' || src.rSigmacp === '-Infinity') {
                            dst.rSigmacp = AsNum(src.rSigmacp);
                        }
                        else {
                            console.log('Expected rSigmacp of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rSigmacp, src.rSigmacp)
                        }
                    }
                    if (src.rCRdc !== undefined && src.rCRdc !== null) {
                        if (typeof src.rCRdc === "number" || src.rCRdc === 'NaN' || src.rCRdc === 'Infinity' || src.rCRdc === '-Infinity') {
                            dst.rCRdc = AsNum(src.rCRdc);
                        }
                        else {
                            console.log('Expected rCRdc of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rCRdc, src.rCRdc)
                        }
                    }
                    if (src.rvmin !== undefined && src.rvmin !== null) {
                        if (typeof src.rvmin === "number" || src.rvmin === 'NaN' || src.rvmin === 'Infinity' || src.rvmin === '-Infinity') {
                            dst.rvmin = AsNum(src.rvmin);
                        }
                        else {
                            console.log('Expected rvmin of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rvmin, src.rvmin)
                        }
                    }
                    if (src.rk1 !== undefined && src.rk1 !== null) {
                        if (typeof src.rk1 === "number" || src.rk1 === 'NaN' || src.rk1 === 'Infinity' || src.rk1 === '-Infinity') {
                            dst.rk1 = AsNum(src.rk1);
                        }
                        else {
                            console.log('Expected rk1 of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rk1, src.rk1)
                        }
                    }
                    if (src.rvRdc !== undefined && src.rvRdc !== null) {
                        if (typeof src.rvRdc === "number" || src.rvRdc === 'NaN' || src.rvRdc === 'Infinity' || src.rvRdc === '-Infinity') {
                            dst.rvRdc = AsNum(src.rvRdc);
                        }
                        else {
                            console.log('Expected rvRdc of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rvRdc, src.rvRdc)
                        }
                    }
                    if (src.rkmaxPSB !== undefined && src.rkmaxPSB !== null) {
                        if (typeof src.rkmaxPSB === "number" || src.rkmaxPSB === 'NaN' || src.rkmaxPSB === 'Infinity' || src.rkmaxPSB === '-Infinity') {
                            dst.rkmaxPSB = AsNum(src.rkmaxPSB);
                        }
                        else {
                            console.log('Expected rkmaxPSB of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rkmaxPSB, src.rkmaxPSB)
                        }
                    }
                    if (src.rvRdmax !== undefined && src.rvRdmax !== null) {
                        if (typeof src.rvRdmax === "number" || src.rvRdmax === 'NaN' || src.rvRdmax === 'Infinity' || src.rvRdmax === '-Infinity') {
                            dst.rvRdmax = AsNum(src.rvRdmax);
                        }
                        else {
                            console.log('Expected rvRdmax of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rvRdmax, src.rvRdmax)
                        }
                    }
                    if (src.rVRddow !== undefined && src.rVRddow !== null) {
                        if (typeof src.rVRddow === "number" || src.rVRddow === 'NaN' || src.rVRddow === 'Infinity' || src.rVRddow === '-Infinity') {
                            dst.rVRddow = AsNum(src.rVRddow);
                        }
                        else {
                            console.log('Expected rVRddow of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.rVRddow, src.rVRddow)
                        }
                    }
                    if (src.nPSHSShearSection !== undefined && src.nPSHSShearSection !== null) {
                        if (typeof src.nPSHSShearSection === "number" || src.nPSHSShearSection === 'NaN' || src.nPSHSShearSection === 'Infinity' || src.nPSHSShearSection === '-Infinity') {
                            dst.nPSHSShearSection = NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.n_p_s_h_sShear_section", AsNum(src.nPSHSShearSection));
                        }
                        else {
                            console.log('Expected nPSHSShearSection of FDRCPunchingCheckConcreteShear to be a number but was ', typeof src.nPSHSShearSection, src.nPSHSShearSection)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckConcreteShear | null | undefined): FDRCPunchingCheckConcreteShear_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckConcreteShear_json = {
                        rBeta: AsJsonNum(src.rBeta),
                        rdy: AsJsonNum(src.rdy),
                        rdz: AsJsonNum(src.rdz),
                        rdeff: AsJsonNum(src.rdeff),
                        ru: AsJsonNum(src.ru),
                        rDist: AsJsonNum(src.rDist),
                        rVEd: AsJsonNum(src.rVEd),
                        rvvEd: AsJsonNum(src.rvvEd),
                        rk: AsJsonNum(src.rk),
                        rRhol: AsJsonNum(src.rRhol),
                        rRholy: AsJsonNum(src.rRholy),
                        rRholz: AsJsonNum(src.rRholz),
                        rSigmacp: AsJsonNum(src.rSigmacp),
                        rCRdc: AsJsonNum(src.rCRdc),
                        rvmin: AsJsonNum(src.rvmin),
                        rk1: AsJsonNum(src.rk1),
                        rvRdc: AsJsonNum(src.rvRdc),
                        rkmaxPSB: AsJsonNum(src.rkmaxPSB),
                        rvRdmax: AsJsonNum(src.rvRdmax),
                        rVRddow: AsJsonNum(src.rVRddow),
                        nPSHSShearSection: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.n_p_s_h_sShear_section", src.nPSHSShearSection)),
                    };
                    return dst;
                }

                static create(src?: FDRCPunchingCheckConcreteShear_createType) {
                    const dst = new FDRCPunchingCheckConcreteShear();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rBeta !== undefined) {
                        dst.rBeta = src.rBeta;
                    }
                    if (src.rdy !== undefined) {
                        dst.rdy = src.rdy;
                    }
                    if (src.rdz !== undefined) {
                        dst.rdz = src.rdz;
                    }
                    if (src.rdeff !== undefined) {
                        dst.rdeff = src.rdeff;
                    }
                    if (src.ru !== undefined) {
                        dst.ru = src.ru;
                    }
                    if (src.rDist !== undefined) {
                        dst.rDist = src.rDist;
                    }
                    if (src.rVEd !== undefined) {
                        dst.rVEd = src.rVEd;
                    }
                    if (src.rvvEd !== undefined) {
                        dst.rvvEd = src.rvvEd;
                    }
                    if (src.rk !== undefined) {
                        dst.rk = src.rk;
                    }
                    if (src.rRhol !== undefined) {
                        dst.rRhol = src.rRhol;
                    }
                    if (src.rRholy !== undefined) {
                        dst.rRholy = src.rRholy;
                    }
                    if (src.rRholz !== undefined) {
                        dst.rRholz = src.rRholz;
                    }
                    if (src.rSigmacp !== undefined) {
                        dst.rSigmacp = src.rSigmacp;
                    }
                    if (src.rCRdc !== undefined) {
                        dst.rCRdc = src.rCRdc;
                    }
                    if (src.rvmin !== undefined) {
                        dst.rvmin = src.rvmin;
                    }
                    if (src.rk1 !== undefined) {
                        dst.rk1 = src.rk1;
                    }
                    if (src.rvRdc !== undefined) {
                        dst.rvRdc = src.rvRdc;
                    }
                    if (src.rkmaxPSB !== undefined) {
                        dst.rkmaxPSB = src.rkmaxPSB;
                    }
                    if (src.rvRdmax !== undefined) {
                        dst.rvRdmax = src.rvRdmax;
                    }
                    if (src.rVRddow !== undefined) {
                        dst.rVRddow = src.rVRddow;
                    }
                    if (src.nPSHSShearSection !== undefined) {
                        dst.nPSHSShearSection = src.nPSHSShearSection;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckConcreteShear();
                    dst.rBeta = this.rBeta;
                    dst.rdy = this.rdy;
                    dst.rdz = this.rdz;
                    dst.rdeff = this.rdeff;
                    dst.ru = this.ru;
                    dst.rDist = this.rDist;
                    dst.rVEd = this.rVEd;
                    dst.rvvEd = this.rvvEd;
                    dst.rk = this.rk;
                    dst.rRhol = this.rRhol;
                    dst.rRholy = this.rRholy;
                    dst.rRholz = this.rRholz;
                    dst.rSigmacp = this.rSigmacp;
                    dst.rCRdc = this.rCRdc;
                    dst.rvmin = this.rvmin;
                    dst.rk1 = this.rk1;
                    dst.rvRdc = this.rvRdc;
                    dst.rkmaxPSB = this.rkmaxPSB;
                    dst.rvRdmax = this.rvRdmax;
                    dst.rVRddow = this.rVRddow;
                    dst.nPSHSShearSection = this.nPSHSShearSection;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckConcreteShear.toObject(this);
                    const dst = FDRCPunchingCheckConcreteShear.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckConcreteShear = FDRCPunchingCheckConcreteShear;


            export type FDRCPunchingCheckReinforcementShear_keys = 'concShear' | 'rsr' | 'rCapacity' | 'rvRdsw' | 'rvRdcs' | 'rvRdcsw' | 'rCRdcSw';
            export interface FDRCPunchingCheckReinforcementShear_createType {
                concShear?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear | null,
                rsr?: number,
                rCapacity?: number,
                rvRdsw?: number,
                rvRdcs?: number,
                rvRdcsw?: number,
                rCRdcSw?: number,
            }
            export interface FDRCPunchingCheckReinforcementShear_json {
                concShear?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear_json;
                rsr?: JsonNumber;
                rCapacity?: JsonNumber;
                rvRdsw?: JsonNumber;
                rvRdcs?: JsonNumber;
                rvRdcsw?: JsonNumber;
                rCRdcSw?: JsonNumber;
            }
            interface FDRCPunchingCheckReinforcementShear_json_in {
                __proto_name?: unknown;
                concShear?: unknown;
                rsr?: unknown;
                rCapacity?: unknown;
                rvRdsw?: unknown;
                rvRdcs?: unknown;
                rvRdcsw?: unknown;
                rCRdcSw?: unknown;
            }
            export class FDRCPunchingCheckReinforcementShear {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear";
                concShear: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear | null = null;
                rsr: number = 0;
                rCapacity: number = 0;
                rvRdsw: number = 0;
                rvRdcs: number = 0;
                rvRdcsw: number = 0;
                rCRdcSw: number = 0;

                static fromObject(src_unknown: unknown): FDRCPunchingCheckReinforcementShear {
                    const dst = new FDRCPunchingCheckReinforcementShear();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckReinforcementShear but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckReinforcementShear_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckReinforcementShear but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.concShear !== undefined && src.concShear !== null) {
                        dst.concShear = ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.fromObject(src.concShear);
                    }
                    if (src.rsr !== undefined && src.rsr !== null) {
                        if (typeof src.rsr === "number" || src.rsr === 'NaN' || src.rsr === 'Infinity' || src.rsr === '-Infinity') {
                            dst.rsr = AsNum(src.rsr);
                        }
                        else {
                            console.log('Expected rsr of FDRCPunchingCheckReinforcementShear to be a number but was ', typeof src.rsr, src.rsr)
                        }
                    }
                    if (src.rCapacity !== undefined && src.rCapacity !== null) {
                        if (typeof src.rCapacity === "number" || src.rCapacity === 'NaN' || src.rCapacity === 'Infinity' || src.rCapacity === '-Infinity') {
                            dst.rCapacity = AsNum(src.rCapacity);
                        }
                        else {
                            console.log('Expected rCapacity of FDRCPunchingCheckReinforcementShear to be a number but was ', typeof src.rCapacity, src.rCapacity)
                        }
                    }
                    if (src.rvRdsw !== undefined && src.rvRdsw !== null) {
                        if (typeof src.rvRdsw === "number" || src.rvRdsw === 'NaN' || src.rvRdsw === 'Infinity' || src.rvRdsw === '-Infinity') {
                            dst.rvRdsw = AsNum(src.rvRdsw);
                        }
                        else {
                            console.log('Expected rvRdsw of FDRCPunchingCheckReinforcementShear to be a number but was ', typeof src.rvRdsw, src.rvRdsw)
                        }
                    }
                    if (src.rvRdcs !== undefined && src.rvRdcs !== null) {
                        if (typeof src.rvRdcs === "number" || src.rvRdcs === 'NaN' || src.rvRdcs === 'Infinity' || src.rvRdcs === '-Infinity') {
                            dst.rvRdcs = AsNum(src.rvRdcs);
                        }
                        else {
                            console.log('Expected rvRdcs of FDRCPunchingCheckReinforcementShear to be a number but was ', typeof src.rvRdcs, src.rvRdcs)
                        }
                    }
                    if (src.rvRdcsw !== undefined && src.rvRdcsw !== null) {
                        if (typeof src.rvRdcsw === "number" || src.rvRdcsw === 'NaN' || src.rvRdcsw === 'Infinity' || src.rvRdcsw === '-Infinity') {
                            dst.rvRdcsw = AsNum(src.rvRdcsw);
                        }
                        else {
                            console.log('Expected rvRdcsw of FDRCPunchingCheckReinforcementShear to be a number but was ', typeof src.rvRdcsw, src.rvRdcsw)
                        }
                    }
                    if (src.rCRdcSw !== undefined && src.rCRdcSw !== null) {
                        if (typeof src.rCRdcSw === "number" || src.rCRdcSw === 'NaN' || src.rCRdcSw === 'Infinity' || src.rCRdcSw === '-Infinity') {
                            dst.rCRdcSw = AsNum(src.rCRdcSw);
                        }
                        else {
                            console.log('Expected rCRdcSw of FDRCPunchingCheckReinforcementShear to be a number but was ', typeof src.rCRdcSw, src.rCRdcSw)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckReinforcementShear | null | undefined): FDRCPunchingCheckReinforcementShear_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckReinforcementShear_json = {
                        rsr: AsJsonNum(src.rsr),
                        rCapacity: AsJsonNum(src.rCapacity),
                        rvRdsw: AsJsonNum(src.rvRdsw),
                        rvRdcs: AsJsonNum(src.rvRdcs),
                        rvRdcsw: AsJsonNum(src.rvRdcsw),
                        rCRdcSw: AsJsonNum(src.rCRdcSw),
                    };
                    if(src.concShear !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.toObject(src.concShear);
                        if(parsed === null) return null;
                        dst.concShear = parsed;
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingCheckReinforcementShear_createType) {
                    const dst = new FDRCPunchingCheckReinforcementShear();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.concShear !== undefined) {
                        dst.concShear = src.concShear;
                    }
                    if (src.rsr !== undefined) {
                        dst.rsr = src.rsr;
                    }
                    if (src.rCapacity !== undefined) {
                        dst.rCapacity = src.rCapacity;
                    }
                    if (src.rvRdsw !== undefined) {
                        dst.rvRdsw = src.rvRdsw;
                    }
                    if (src.rvRdcs !== undefined) {
                        dst.rvRdcs = src.rvRdcs;
                    }
                    if (src.rvRdcsw !== undefined) {
                        dst.rvRdcsw = src.rvRdcsw;
                    }
                    if (src.rCRdcSw !== undefined) {
                        dst.rCRdcSw = src.rCRdcSw;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckReinforcementShear();
                    dst.concShear = this.concShear;
                    dst.rsr = this.rsr;
                    dst.rCapacity = this.rCapacity;
                    dst.rvRdsw = this.rvRdsw;
                    dst.rvRdcs = this.rvRdcs;
                    dst.rvRdcsw = this.rvRdcsw;
                    dst.rCRdcSw = this.rCRdcSw;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckReinforcementShear.toObject(this);
                    const dst = FDRCPunchingCheckReinforcementShear.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckReinforcementShear = FDRCPunchingCheckReinforcementShear;


            export type FDRCPunchingCheckReinforcementShearPSBRegionC_keys = 'concShear' | 'rsR' | 'nStudRegionC' | 'rfyd' | 'reta' | 'rAsi' | 'rVRdsy';
            export interface FDRCPunchingCheckReinforcementShearPSBRegionC_createType {
                concShear?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear | null,
                rsR?: number,
                nStudRegionC?: number,
                rfyd?: number,
                reta?: number,
                rAsi?: number,
                rVRdsy?: number,
            }
            export interface FDRCPunchingCheckReinforcementShearPSBRegionC_json {
                concShear?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear_json;
                rsR?: JsonNumber;
                nStudRegionC?: JsonNumber;
                rfyd?: JsonNumber;
                reta?: JsonNumber;
                rAsi?: JsonNumber;
                rVRdsy?: JsonNumber;
            }
            interface FDRCPunchingCheckReinforcementShearPSBRegionC_json_in {
                __proto_name?: unknown;
                concShear?: unknown;
                rsR?: unknown;
                nStudRegionC?: unknown;
                rfyd?: unknown;
                reta?: unknown;
                rAsi?: unknown;
                rVRdsy?: unknown;
            }
            export class FDRCPunchingCheckReinforcementShearPSBRegionC {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC";
                concShear: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear | null = null;
                rsR: number = 0;
                nStudRegionC: number = 0;
                rfyd: number = 0;
                reta: number = 0;
                rAsi: number = 0;
                rVRdsy: number = 0;

                static fromObject(src_unknown: unknown): FDRCPunchingCheckReinforcementShearPSBRegionC {
                    const dst = new FDRCPunchingCheckReinforcementShearPSBRegionC();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckReinforcementShearPSBRegionC but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckReinforcementShearPSBRegionC_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckReinforcementShearPSBRegionC but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.concShear !== undefined && src.concShear !== null) {
                        dst.concShear = ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.fromObject(src.concShear);
                    }
                    if (src.rsR !== undefined && src.rsR !== null) {
                        if (typeof src.rsR === "number" || src.rsR === 'NaN' || src.rsR === 'Infinity' || src.rsR === '-Infinity') {
                            dst.rsR = AsNum(src.rsR);
                        }
                        else {
                            console.log('Expected rsR of FDRCPunchingCheckReinforcementShearPSBRegionC to be a number but was ', typeof src.rsR, src.rsR)
                        }
                    }
                    if (src.nStudRegionC !== undefined && src.nStudRegionC !== null) {
                        if (typeof src.nStudRegionC === "number" || src.nStudRegionC === 'NaN' || src.nStudRegionC === 'Infinity' || src.nStudRegionC === '-Infinity') {
                            dst.nStudRegionC = NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC.n_stud_region_c", AsNum(src.nStudRegionC));
                        }
                        else {
                            console.log('Expected nStudRegionC of FDRCPunchingCheckReinforcementShearPSBRegionC to be a number but was ', typeof src.nStudRegionC, src.nStudRegionC)
                        }
                    }
                    if (src.rfyd !== undefined && src.rfyd !== null) {
                        if (typeof src.rfyd === "number" || src.rfyd === 'NaN' || src.rfyd === 'Infinity' || src.rfyd === '-Infinity') {
                            dst.rfyd = AsNum(src.rfyd);
                        }
                        else {
                            console.log('Expected rfyd of FDRCPunchingCheckReinforcementShearPSBRegionC to be a number but was ', typeof src.rfyd, src.rfyd)
                        }
                    }
                    if (src.reta !== undefined && src.reta !== null) {
                        if (typeof src.reta === "number" || src.reta === 'NaN' || src.reta === 'Infinity' || src.reta === '-Infinity') {
                            dst.reta = AsNum(src.reta);
                        }
                        else {
                            console.log('Expected reta of FDRCPunchingCheckReinforcementShearPSBRegionC to be a number but was ', typeof src.reta, src.reta)
                        }
                    }
                    if (src.rAsi !== undefined && src.rAsi !== null) {
                        if (typeof src.rAsi === "number" || src.rAsi === 'NaN' || src.rAsi === 'Infinity' || src.rAsi === '-Infinity') {
                            dst.rAsi = AsNum(src.rAsi);
                        }
                        else {
                            console.log('Expected rAsi of FDRCPunchingCheckReinforcementShearPSBRegionC to be a number but was ', typeof src.rAsi, src.rAsi)
                        }
                    }
                    if (src.rVRdsy !== undefined && src.rVRdsy !== null) {
                        if (typeof src.rVRdsy === "number" || src.rVRdsy === 'NaN' || src.rVRdsy === 'Infinity' || src.rVRdsy === '-Infinity') {
                            dst.rVRdsy = AsNum(src.rVRdsy);
                        }
                        else {
                            console.log('Expected rVRdsy of FDRCPunchingCheckReinforcementShearPSBRegionC to be a number but was ', typeof src.rVRdsy, src.rVRdsy)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckReinforcementShearPSBRegionC | null | undefined): FDRCPunchingCheckReinforcementShearPSBRegionC_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckReinforcementShearPSBRegionC_json = {
                        rsR: AsJsonNum(src.rsR),
                        nStudRegionC: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC.n_stud_region_c", src.nStudRegionC)),
                        rfyd: AsJsonNum(src.rfyd),
                        reta: AsJsonNum(src.reta),
                        rAsi: AsJsonNum(src.rAsi),
                        rVRdsy: AsJsonNum(src.rVRdsy),
                    };
                    if(src.concShear !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.toObject(src.concShear);
                        if(parsed === null) return null;
                        dst.concShear = parsed;
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingCheckReinforcementShearPSBRegionC_createType) {
                    const dst = new FDRCPunchingCheckReinforcementShearPSBRegionC();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.concShear !== undefined) {
                        dst.concShear = src.concShear;
                    }
                    if (src.rsR !== undefined) {
                        dst.rsR = src.rsR;
                    }
                    if (src.nStudRegionC !== undefined) {
                        dst.nStudRegionC = src.nStudRegionC;
                    }
                    if (src.rfyd !== undefined) {
                        dst.rfyd = src.rfyd;
                    }
                    if (src.reta !== undefined) {
                        dst.reta = src.reta;
                    }
                    if (src.rAsi !== undefined) {
                        dst.rAsi = src.rAsi;
                    }
                    if (src.rVRdsy !== undefined) {
                        dst.rVRdsy = src.rVRdsy;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckReinforcementShearPSBRegionC();
                    dst.concShear = this.concShear;
                    dst.rsR = this.rsR;
                    dst.nStudRegionC = this.nStudRegionC;
                    dst.rfyd = this.rfyd;
                    dst.reta = this.reta;
                    dst.rAsi = this.rAsi;
                    dst.rVRdsy = this.rVRdsy;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckReinforcementShearPSBRegionC.toObject(this);
                    const dst = FDRCPunchingCheckReinforcementShearPSBRegionC.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckReinforcementShearPSBRegionC = FDRCPunchingCheckReinforcementShearPSBRegionC;


            export type FDRCPunchingCheckDetail_keys = 'Utilization' | 'IsRelevant' | 'Type' | 'DataTypeId' | 'concreteCompression' | 'concreteShear' | 'ReinforcementShear' | 'PSBReinforcement';
            export interface FDRCPunchingCheckDetail_createType {
                Utilization?: number,
                IsRelevant?: boolean,
                Type?: number,
                DataTypeId?: number,
                concreteCompression?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression | null,
                concreteShear?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear | null,
                ReinforcementShear?: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear | null,
                PSBReinforcement?: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC | null,
            }
            export interface FDRCPunchingCheckDetail_json {
                Utilization?: JsonNumber;
                IsRelevant?: boolean;
                Type?: JsonNumber;
                DataTypeId?: JsonNumber;
                concreteCompression?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression_json;
                concreteShear?: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear_json;
                ReinforcementShear?: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear_json;
                PSBReinforcement?: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC_json;
            }
            interface FDRCPunchingCheckDetail_json_in {
                __proto_name?: unknown;
                Utilization?: unknown;
                IsRelevant?: unknown;
                Type?: unknown;
                DataTypeId?: unknown;
                concreteCompression?: unknown;
                concreteShear?: unknown;
                ReinforcementShear?: unknown;
                PSBReinforcement?: unknown;
            }
            export class FDRCPunchingCheckDetail {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckDetail";
                Utilization: number = 0;
                IsRelevant: boolean = false;
                Type: number = 0;
                DataTypeId: number = 0;
                // this is a one of
                datatype: {type: 'concreteCompression'; concreteCompression: ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression} | {type: 'concreteShear'; concreteShear: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear} | {type: 'ReinforcementShear'; ReinforcementShear: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear} | {type: 'PSBReinforcement'; PSBReinforcement: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC} | null = null;

                /** Gets the `ConcreteCompression` value (or null) from the oneof `datatype` */
                getConcreteCompression(): ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression | null {
                    if(this.datatype === null) return null;
                    if(this.datatype.type !== 'concreteCompression') return null;
                    return this.datatype.concreteCompression;
                }

                /** Sets the `ConcreteCompression` value for the oneof `datatype`*/
                setConcreteCompression(value: ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression | null) {
                    if(value !== null) {
                        this.datatype = {type: 'concreteCompression', concreteCompression:value};
                    }
                    else {
                        this.datatype = null;
                    }
                }

                /** Gets the `ConcreteShear` value (or null) from the oneof `datatype` */
                getConcreteShear(): ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear | null {
                    if(this.datatype === null) return null;
                    if(this.datatype.type !== 'concreteShear') return null;
                    return this.datatype.concreteShear;
                }

                /** Sets the `ConcreteShear` value for the oneof `datatype`*/
                setConcreteShear(value: ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear | null) {
                    if(value !== null) {
                        this.datatype = {type: 'concreteShear', concreteShear:value};
                    }
                    else {
                        this.datatype = null;
                    }
                }

                /** Gets the `ReinforcementShear` value (or null) from the oneof `datatype` */
                getReinforcementShear(): ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear | null {
                    if(this.datatype === null) return null;
                    if(this.datatype.type !== 'ReinforcementShear') return null;
                    return this.datatype.ReinforcementShear;
                }

                /** Sets the `ReinforcementShear` value for the oneof `datatype`*/
                setReinforcementShear(value: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear | null) {
                    if(value !== null) {
                        this.datatype = {type: 'ReinforcementShear', ReinforcementShear:value};
                    }
                    else {
                        this.datatype = null;
                    }
                }

                /** Gets the `PSBReinforcement` value (or null) from the oneof `datatype` */
                getPSBReinforcement(): ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC | null {
                    if(this.datatype === null) return null;
                    if(this.datatype.type !== 'PSBReinforcement') return null;
                    return this.datatype.PSBReinforcement;
                }

                /** Sets the `PSBReinforcement` value for the oneof `datatype`*/
                setPSBReinforcement(value: ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC | null) {
                    if(value !== null) {
                        this.datatype = {type: 'PSBReinforcement', PSBReinforcement:value};
                    }
                    else {
                        this.datatype = null;
                    }
                }

                static fromObject(src_unknown: unknown): FDRCPunchingCheckDetail {
                    const dst = new FDRCPunchingCheckDetail();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckDetail but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckDetail_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckDetail but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.Utilization !== undefined && src.Utilization !== null) {
                        if (typeof src.Utilization === "number" || src.Utilization === 'NaN' || src.Utilization === 'Infinity' || src.Utilization === '-Infinity') {
                            dst.Utilization = AsNum(src.Utilization);
                        }
                        else {
                            console.log('Expected Utilization of FDRCPunchingCheckDetail to be a number but was ', typeof src.Utilization, src.Utilization)
                        }
                    }
                    if (src.IsRelevant !== undefined && src.IsRelevant !== null) {
                        if (typeof src.IsRelevant === "boolean") {
                            dst.IsRelevant = src.IsRelevant;
                        }
                        else {
                            console.log('Expected IsRelevant of FDRCPunchingCheckDetail to be a boolean but was ', typeof src.IsRelevant, src.IsRelevant)
                        }
                    }
                    if (src.Type !== undefined && src.Type !== null) {
                        if (typeof src.Type === "number" || src.Type === 'NaN' || src.Type === 'Infinity' || src.Type === '-Infinity') {
                            dst.Type = NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckDetail.Type", AsNum(src.Type));
                        }
                        else {
                            console.log('Expected Type of FDRCPunchingCheckDetail to be a number but was ', typeof src.Type, src.Type)
                        }
                    }
                    if (src.DataTypeId !== undefined && src.DataTypeId !== null) {
                        if (typeof src.DataTypeId === "number" || src.DataTypeId === 'NaN' || src.DataTypeId === 'Infinity' || src.DataTypeId === '-Infinity') {
                            dst.DataTypeId = NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckDetail.DataTypeId", AsNum(src.DataTypeId));
                        }
                        else {
                            console.log('Expected DataTypeId of FDRCPunchingCheckDetail to be a number but was ', typeof src.DataTypeId, src.DataTypeId)
                        }
                    }
                    if (src.concreteCompression !== undefined && src.concreteCompression !== null) {
                        dst.setConcreteCompression(ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression.fromObject(src.concreteCompression));
                    }
                    if (src.concreteShear !== undefined && src.concreteShear !== null) {
                        dst.setConcreteShear(ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.fromObject(src.concreteShear));
                    }
                    if (src.ReinforcementShear !== undefined && src.ReinforcementShear !== null) {
                        dst.setReinforcementShear(ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear.fromObject(src.ReinforcementShear));
                    }
                    if (src.PSBReinforcement !== undefined && src.PSBReinforcement !== null) {
                        dst.setPSBReinforcement(ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC.fromObject(src.PSBReinforcement));
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckDetail | null | undefined): FDRCPunchingCheckDetail_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckDetail is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckDetail") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckDetail but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckDetail_json = {
                        Utilization: AsJsonNum(src.Utilization),
                        IsRelevant: src.IsRelevant,
                        Type: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckDetail.Type", src.Type)),
                        DataTypeId: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckDetail.DataTypeId", src.DataTypeId)),
                    };
                    const concreteCompression = src.getConcreteCompression();
                    if(concreteCompression !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRCPunchingCheckConcreteCompression.toObject(concreteCompression);
                        if(parsed === null) return null;
                        dst.concreteCompression = parsed;
                    }
                    const concreteShear = src.getConcreteShear();
                    if(concreteShear !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRCPunchingCheckConcreteShear.toObject(concreteShear);
                        if(parsed === null) return null;
                        dst.concreteShear = parsed;
                    }
                    const ReinforcementShear = src.getReinforcementShear();
                    if(ReinforcementShear !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShear.toObject(ReinforcementShear);
                        if(parsed === null) return null;
                        dst.ReinforcementShear = parsed;
                    }
                    const PSBReinforcement = src.getPSBReinforcement();
                    if(PSBReinforcement !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRCPunchingCheckReinforcementShearPSBRegionC.toObject(PSBReinforcement);
                        if(parsed === null) return null;
                        dst.PSBReinforcement = parsed;
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingCheckDetail_createType) {
                    const dst = new FDRCPunchingCheckDetail();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.Utilization !== undefined) {
                        dst.Utilization = src.Utilization;
                    }
                    if (src.IsRelevant !== undefined) {
                        dst.IsRelevant = src.IsRelevant;
                    }
                    if (src.Type !== undefined) {
                        dst.Type = src.Type;
                    }
                    if (src.DataTypeId !== undefined) {
                        dst.DataTypeId = src.DataTypeId;
                    }
                    // part of the datatype oneof 
                    if (src.concreteCompression !== undefined && src.concreteCompression !== null) {
                        dst.setConcreteCompression(src.concreteCompression);
                    }
                    // part of the datatype oneof 
                    if (src.concreteShear !== undefined && src.concreteShear !== null) {
                        dst.setConcreteShear(src.concreteShear);
                    }
                    // part of the datatype oneof 
                    if (src.ReinforcementShear !== undefined && src.ReinforcementShear !== null) {
                        dst.setReinforcementShear(src.ReinforcementShear);
                    }
                    // part of the datatype oneof 
                    if (src.PSBReinforcement !== undefined && src.PSBReinforcement !== null) {
                        dst.setPSBReinforcement(src.PSBReinforcement);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckDetail();
                    dst.Utilization = this.Utilization;
                    dst.IsRelevant = this.IsRelevant;
                    dst.Type = this.Type;
                    dst.DataTypeId = this.DataTypeId;
                    dst.datatype = this.datatype;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckDetail.toObject(this);
                    const dst = FDRCPunchingCheckDetail.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckDetail = FDRCPunchingCheckDetail;


            export type FDRCPunchingCheckDetailRecord_keys = 'idPerimeter' | 'idEntity' | 'idCombination' | 'content';
            export interface FDRCPunchingCheckDetailRecord_createType {
                idPerimeter?: ng.fem_design.punching_output.FDPrimaryKey | null,
                idEntity?: ng.fem_design.punching_output.FDForeignKey | null,
                idCombination?: ng.fem_design.punching_output.FDForeignKey | null,
                content?: ng.fem_design.punching_output.FDRCPunchingCheckDetail | null,
            }
            export interface FDRCPunchingCheckDetailRecord_json {
                idPerimeter?: ng.fem_design.punching_output.FDPrimaryKey_json;
                idEntity?: ng.fem_design.punching_output.FDForeignKey_json;
                idCombination?: ng.fem_design.punching_output.FDForeignKey_json;
                content?: ng.fem_design.punching_output.FDRCPunchingCheckDetail_json;
            }
            interface FDRCPunchingCheckDetailRecord_json_in {
                __proto_name?: unknown;
                idPerimeter?: unknown;
                idEntity?: unknown;
                idCombination?: unknown;
                content?: unknown;
            }
            export class FDRCPunchingCheckDetailRecord {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord";
                idPerimeter: ng.fem_design.punching_output.FDPrimaryKey | null = null;
                idEntity: ng.fem_design.punching_output.FDForeignKey | null = null;
                idCombination: ng.fem_design.punching_output.FDForeignKey | null = null;
                content: ng.fem_design.punching_output.FDRCPunchingCheckDetail | null = null;

                static fromObject(src_unknown: unknown): FDRCPunchingCheckDetailRecord {
                    const dst = new FDRCPunchingCheckDetailRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckDetailRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckDetailRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckDetailRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.idPerimeter !== undefined && src.idPerimeter !== null) {
                        dst.idPerimeter = ng.fem_design.punching_output.FDPrimaryKey.fromObject(src.idPerimeter);
                    }
                    if (src.idEntity !== undefined && src.idEntity !== null) {
                        dst.idEntity = ng.fem_design.punching_output.FDForeignKey.fromObject(src.idEntity);
                    }
                    if (src.idCombination !== undefined && src.idCombination !== null) {
                        dst.idCombination = ng.fem_design.punching_output.FDForeignKey.fromObject(src.idCombination);
                    }
                    if (src.content !== undefined && src.content !== null) {
                        dst.content = ng.fem_design.punching_output.FDRCPunchingCheckDetail.fromObject(src.content);
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckDetailRecord | null | undefined): FDRCPunchingCheckDetailRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckDetailRecord_json = {
                    };
                    if(src.idPerimeter !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDPrimaryKey.toObject(src.idPerimeter);
                        if(parsed === null) return null;
                        dst.idPerimeter = parsed;
                    }
                    if(src.idEntity !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDForeignKey.toObject(src.idEntity);
                        if(parsed === null) return null;
                        dst.idEntity = parsed;
                    }
                    if(src.idCombination !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDForeignKey.toObject(src.idCombination);
                        if(parsed === null) return null;
                        dst.idCombination = parsed;
                    }
                    if(src.content !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDRCPunchingCheckDetail.toObject(src.content);
                        if(parsed === null) return null;
                        dst.content = parsed;
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingCheckDetailRecord_createType) {
                    const dst = new FDRCPunchingCheckDetailRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.idPerimeter !== undefined) {
                        dst.idPerimeter = src.idPerimeter;
                    }
                    if (src.idEntity !== undefined) {
                        dst.idEntity = src.idEntity;
                    }
                    if (src.idCombination !== undefined) {
                        dst.idCombination = src.idCombination;
                    }
                    if (src.content !== undefined) {
                        dst.content = src.content;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckDetailRecord();
                    dst.idPerimeter = this.idPerimeter;
                    dst.idEntity = this.idEntity;
                    dst.idCombination = this.idCombination;
                    dst.content = this.content;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckDetailRecord.toObject(this);
                    const dst = FDRCPunchingCheckDetailRecord.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckDetailRecord = FDRCPunchingCheckDetailRecord;


            export type FDRCPunchingCheckResultCombinationRecord_keys = 'idCombination' | 'idEntity' | 'combinationId' | 'utilization';
            export interface FDRCPunchingCheckResultCombinationRecord_createType {
                idCombination?: ng.fem_design.punching_output.FDPrimaryKey | null,
                idEntity?: ng.fem_design.punching_output.FDForeignKey | null,
                combinationId?: number,
                utilization?: number,
            }
            export interface FDRCPunchingCheckResultCombinationRecord_json {
                idCombination?: ng.fem_design.punching_output.FDPrimaryKey_json;
                idEntity?: ng.fem_design.punching_output.FDForeignKey_json;
                combinationId?: JsonNumber;
                utilization?: JsonNumber;
            }
            interface FDRCPunchingCheckResultCombinationRecord_json_in {
                __proto_name?: unknown;
                idCombination?: unknown;
                idEntity?: unknown;
                combinationId?: unknown;
                utilization?: unknown;
            }
            export class FDRCPunchingCheckResultCombinationRecord {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord";
                idCombination: ng.fem_design.punching_output.FDPrimaryKey | null = null;
                idEntity: ng.fem_design.punching_output.FDForeignKey | null = null;
                combinationId: number = 0;
                utilization: number = 0;

                static fromObject(src_unknown: unknown): FDRCPunchingCheckResultCombinationRecord {
                    const dst = new FDRCPunchingCheckResultCombinationRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckResultCombinationRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckResultCombinationRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckResultCombinationRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.idCombination !== undefined && src.idCombination !== null) {
                        dst.idCombination = ng.fem_design.punching_output.FDPrimaryKey.fromObject(src.idCombination);
                    }
                    if (src.idEntity !== undefined && src.idEntity !== null) {
                        dst.idEntity = ng.fem_design.punching_output.FDForeignKey.fromObject(src.idEntity);
                    }
                    if (src.combinationId !== undefined && src.combinationId !== null) {
                        if (typeof src.combinationId === "number" || src.combinationId === 'NaN' || src.combinationId === 'Infinity' || src.combinationId === '-Infinity') {
                            dst.combinationId = NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord.combination_id", AsNum(src.combinationId));
                        }
                        else {
                            console.log('Expected combinationId of FDRCPunchingCheckResultCombinationRecord to be a number but was ', typeof src.combinationId, src.combinationId)
                        }
                    }
                    if (src.utilization !== undefined && src.utilization !== null) {
                        if (typeof src.utilization === "number" || src.utilization === 'NaN' || src.utilization === 'Infinity' || src.utilization === '-Infinity') {
                            dst.utilization = AsNum(src.utilization);
                        }
                        else {
                            console.log('Expected utilization of FDRCPunchingCheckResultCombinationRecord to be a number but was ', typeof src.utilization, src.utilization)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckResultCombinationRecord | null | undefined): FDRCPunchingCheckResultCombinationRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckResultCombinationRecord_json = {
                        combinationId: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord.combination_id", src.combinationId)),
                        utilization: AsJsonNum(src.utilization),
                    };
                    if(src.idCombination !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDPrimaryKey.toObject(src.idCombination);
                        if(parsed === null) return null;
                        dst.idCombination = parsed;
                    }
                    if(src.idEntity !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDForeignKey.toObject(src.idEntity);
                        if(parsed === null) return null;
                        dst.idEntity = parsed;
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingCheckResultCombinationRecord_createType) {
                    const dst = new FDRCPunchingCheckResultCombinationRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.idCombination !== undefined) {
                        dst.idCombination = src.idCombination;
                    }
                    if (src.idEntity !== undefined) {
                        dst.idEntity = src.idEntity;
                    }
                    if (src.combinationId !== undefined) {
                        dst.combinationId = src.combinationId;
                    }
                    if (src.utilization !== undefined) {
                        dst.utilization = src.utilization;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckResultCombinationRecord();
                    dst.idCombination = this.idCombination;
                    dst.idEntity = this.idEntity;
                    dst.combinationId = this.combinationId;
                    dst.utilization = this.utilization;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckResultCombinationRecord.toObject(this);
                    const dst = FDRCPunchingCheckResultCombinationRecord.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckResultCombinationRecord = FDRCPunchingCheckResultCombinationRecord;


            export type FDRCPunchingCheckResultEntityRecord_keys = 'idEntity' | 'guid' | 'isOk' | 'combinationMaxId' | 'utilizationMax';
            export interface FDRCPunchingCheckResultEntityRecord_createType {
                idEntity?: ng.fem_design.punching_output.FDPrimaryKey | null,
                guid?: string,
                isOk?: boolean,
                combinationMaxId?: number,
                utilizationMax?: number,
            }
            export interface FDRCPunchingCheckResultEntityRecord_json {
                idEntity?: ng.fem_design.punching_output.FDPrimaryKey_json;
                guid?: string;
                isOk?: boolean;
                combinationMaxId?: JsonNumber;
                utilizationMax?: JsonNumber;
            }
            interface FDRCPunchingCheckResultEntityRecord_json_in {
                __proto_name?: unknown;
                idEntity?: unknown;
                guid?: unknown;
                isOk?: unknown;
                combinationMaxId?: unknown;
                utilizationMax?: unknown;
            }
            export class FDRCPunchingCheckResultEntityRecord {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord";
                idEntity: ng.fem_design.punching_output.FDPrimaryKey | null = null;
                guid: string = "";
                isOk: boolean = false;
                combinationMaxId: number = 0;
                utilizationMax: number = 0;

                static fromObject(src_unknown: unknown): FDRCPunchingCheckResultEntityRecord {
                    const dst = new FDRCPunchingCheckResultEntityRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckResultEntityRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckResultEntityRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckResultEntityRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.idEntity !== undefined && src.idEntity !== null) {
                        dst.idEntity = ng.fem_design.punching_output.FDPrimaryKey.fromObject(src.idEntity);
                    }
                    if (src.guid !== undefined && src.guid !== null) {
                        if (typeof src.guid === "string") {
                            dst.guid = src.guid;
                        }
                        else {
                            console.log('Expected guid of FDRCPunchingCheckResultEntityRecord to be a string but was ', typeof src.guid, src.guid)
                        }
                    }
                    if (src.isOk !== undefined && src.isOk !== null) {
                        if (typeof src.isOk === "boolean") {
                            dst.isOk = src.isOk;
                        }
                        else {
                            console.log('Expected isOk of FDRCPunchingCheckResultEntityRecord to be a boolean but was ', typeof src.isOk, src.isOk)
                        }
                    }
                    if (src.combinationMaxId !== undefined && src.combinationMaxId !== null) {
                        if (typeof src.combinationMaxId === "number" || src.combinationMaxId === 'NaN' || src.combinationMaxId === 'Infinity' || src.combinationMaxId === '-Infinity') {
                            dst.combinationMaxId = NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord.combination_max_id", AsNum(src.combinationMaxId));
                        }
                        else {
                            console.log('Expected combinationMaxId of FDRCPunchingCheckResultEntityRecord to be a number but was ', typeof src.combinationMaxId, src.combinationMaxId)
                        }
                    }
                    if (src.utilizationMax !== undefined && src.utilizationMax !== null) {
                        if (typeof src.utilizationMax === "number" || src.utilizationMax === 'NaN' || src.utilizationMax === 'Infinity' || src.utilizationMax === '-Infinity') {
                            dst.utilizationMax = AsNum(src.utilizationMax);
                        }
                        else {
                            console.log('Expected utilizationMax of FDRCPunchingCheckResultEntityRecord to be a number but was ', typeof src.utilizationMax, src.utilizationMax)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckResultEntityRecord | null | undefined): FDRCPunchingCheckResultEntityRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckResultEntityRecord_json = {
                        guid: src.guid,
                        isOk: src.isOk,
                        combinationMaxId: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord.combination_max_id", src.combinationMaxId)),
                        utilizationMax: AsJsonNum(src.utilizationMax),
                    };
                    if(src.idEntity !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDPrimaryKey.toObject(src.idEntity);
                        if(parsed === null) return null;
                        dst.idEntity = parsed;
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingCheckResultEntityRecord_createType) {
                    const dst = new FDRCPunchingCheckResultEntityRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.idEntity !== undefined) {
                        dst.idEntity = src.idEntity;
                    }
                    if (src.guid !== undefined) {
                        dst.guid = src.guid;
                    }
                    if (src.isOk !== undefined) {
                        dst.isOk = src.isOk;
                    }
                    if (src.combinationMaxId !== undefined) {
                        dst.combinationMaxId = src.combinationMaxId;
                    }
                    if (src.utilizationMax !== undefined) {
                        dst.utilizationMax = src.utilizationMax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckResultEntityRecord();
                    dst.idEntity = this.idEntity;
                    dst.guid = this.guid;
                    dst.isOk = this.isOk;
                    dst.combinationMaxId = this.combinationMaxId;
                    dst.utilizationMax = this.utilizationMax;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckResultEntityRecord.toObject(this);
                    const dst = FDRCPunchingCheckResultEntityRecord.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckResultEntityRecord = FDRCPunchingCheckResultEntityRecord;


            export type FDRCPunchingCheckResultDatabaseView_keys = 'SchemaId' | 'entityResultsTableNo' | 'entityResultsTable' | 'combinationTableNo' | 'combinationTable' | 'detailedResultsTableNo' | 'detailedResultsTable' | 'punchingPerimeterRegionsNo' | 'punchingPerimeterRegions';
            export interface FDRCPunchingCheckResultDatabaseView_createType {
                SchemaId?: number,
                entityResultsTableNo?: ng.fem_design.punching_output.FDSize32 | null,
                entityResultsTable?: ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord[],
                combinationTableNo?: ng.fem_design.punching_output.FDSize32 | null,
                combinationTable?: ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord[],
                detailedResultsTableNo?: ng.fem_design.punching_output.FDSize32 | null,
                detailedResultsTable?: ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord[],
                punchingPerimeterRegionsNo?: ng.fem_design.punching_output.FDSize32 | null,
                punchingPerimeterRegions?: ng.fem_design.punching_output.FDRegionPolyline3DRecordView[],
            }
            export interface FDRCPunchingCheckResultDatabaseView_json {
                SchemaId?: JsonNumber;
                entityResultsTableNo?: ng.fem_design.punching_output.FDSize32_json;
                entityResultsTable: ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord_json[];
                combinationTableNo?: ng.fem_design.punching_output.FDSize32_json;
                combinationTable: ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord_json[];
                detailedResultsTableNo?: ng.fem_design.punching_output.FDSize32_json;
                detailedResultsTable: ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord_json[];
                punchingPerimeterRegionsNo?: ng.fem_design.punching_output.FDSize32_json;
                punchingPerimeterRegions: ng.fem_design.punching_output.FDRegionPolyline3DRecordView_json[];
            }
            interface FDRCPunchingCheckResultDatabaseView_json_in {
                __proto_name?: unknown;
                SchemaId?: unknown;
                entityResultsTableNo?: unknown;
                entityResultsTable?: unknown;
                combinationTableNo?: unknown;
                combinationTable?: unknown;
                detailedResultsTableNo?: unknown;
                detailedResultsTable?: unknown;
                punchingPerimeterRegionsNo?: unknown;
                punchingPerimeterRegions?: unknown;
            }
            export class FDRCPunchingCheckResultDatabaseView {
                __proto_name = "ng.fem_design.punching_output.FDRCPunchingCheckResultDatabaseView";
                SchemaId: number = 0;
                entityResultsTableNo: ng.fem_design.punching_output.FDSize32 | null = null;
                entityResultsTable: ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord[] = [];
                combinationTableNo: ng.fem_design.punching_output.FDSize32 | null = null;
                combinationTable: ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord[] = [];
                detailedResultsTableNo: ng.fem_design.punching_output.FDSize32 | null = null;
                detailedResultsTable: ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord[] = [];
                punchingPerimeterRegionsNo: ng.fem_design.punching_output.FDSize32 | null = null;
                punchingPerimeterRegions: ng.fem_design.punching_output.FDRegionPolyline3DRecordView[] = [];

                static fromObject(src_unknown: unknown): FDRCPunchingCheckResultDatabaseView {
                    const dst = new FDRCPunchingCheckResultDatabaseView();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FDRCPunchingCheckResultDatabaseView but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FDRCPunchingCheckResultDatabaseView_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FDRCPunchingCheckResultDatabaseView but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.SchemaId !== undefined && src.SchemaId !== null) {
                        if (typeof src.SchemaId === "number" || src.SchemaId === 'NaN' || src.SchemaId === 'Infinity' || src.SchemaId === '-Infinity') {
                            dst.SchemaId = NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckResultDatabaseView.SchemaId", AsNum(src.SchemaId));
                        }
                        else {
                            console.log('Expected SchemaId of FDRCPunchingCheckResultDatabaseView to be a number but was ', typeof src.SchemaId, src.SchemaId)
                        }
                    }
                    if (src.entityResultsTableNo !== undefined && src.entityResultsTableNo !== null) {
                        dst.entityResultsTableNo = ng.fem_design.punching_output.FDSize32.fromObject(src.entityResultsTableNo);
                    }
                    if (src.entityResultsTable !== undefined && src.entityResultsTable !== null) {
                        if (Array.isArray(src.entityResultsTable)) {
                            for (const element of src.entityResultsTable) {
                                dst.entityResultsTable.push(ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected entityResultsTable of FDRCPunchingCheckResultDatabaseView to be a array but was ', typeof src.entityResultsTable, src.entityResultsTable)
                        }
                    }
                    if (src.combinationTableNo !== undefined && src.combinationTableNo !== null) {
                        dst.combinationTableNo = ng.fem_design.punching_output.FDSize32.fromObject(src.combinationTableNo);
                    }
                    if (src.combinationTable !== undefined && src.combinationTable !== null) {
                        if (Array.isArray(src.combinationTable)) {
                            for (const element of src.combinationTable) {
                                dst.combinationTable.push(ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected combinationTable of FDRCPunchingCheckResultDatabaseView to be a array but was ', typeof src.combinationTable, src.combinationTable)
                        }
                    }
                    if (src.detailedResultsTableNo !== undefined && src.detailedResultsTableNo !== null) {
                        dst.detailedResultsTableNo = ng.fem_design.punching_output.FDSize32.fromObject(src.detailedResultsTableNo);
                    }
                    if (src.detailedResultsTable !== undefined && src.detailedResultsTable !== null) {
                        if (Array.isArray(src.detailedResultsTable)) {
                            for (const element of src.detailedResultsTable) {
                                dst.detailedResultsTable.push(ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected detailedResultsTable of FDRCPunchingCheckResultDatabaseView to be a array but was ', typeof src.detailedResultsTable, src.detailedResultsTable)
                        }
                    }
                    if (src.punchingPerimeterRegionsNo !== undefined && src.punchingPerimeterRegionsNo !== null) {
                        dst.punchingPerimeterRegionsNo = ng.fem_design.punching_output.FDSize32.fromObject(src.punchingPerimeterRegionsNo);
                    }
                    if (src.punchingPerimeterRegions !== undefined && src.punchingPerimeterRegions !== null) {
                        if (Array.isArray(src.punchingPerimeterRegions)) {
                            for (const element of src.punchingPerimeterRegions) {
                                dst.punchingPerimeterRegions.push(ng.fem_design.punching_output.FDRegionPolyline3DRecordView.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected punchingPerimeterRegions of FDRCPunchingCheckResultDatabaseView to be a array but was ', typeof src.punchingPerimeterRegions, src.punchingPerimeterRegions)
                        }
                    }
                    return dst;
                }

                static toObject(src: FDRCPunchingCheckResultDatabaseView | null | undefined): FDRCPunchingCheckResultDatabaseView_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.punching_output.FDRCPunchingCheckResultDatabaseView is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.punching_output.FDRCPunchingCheckResultDatabaseView") {
                        console.error('Expected ng.fem_design.punching_output.FDRCPunchingCheckResultDatabaseView but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FDRCPunchingCheckResultDatabaseView_json = {
                        SchemaId: AsJsonNum(NumberToInt("ng.fem_design.punching_output.FDRCPunchingCheckResultDatabaseView.SchemaId", src.SchemaId)),
                        entityResultsTable: new Array<ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord_json>(),
                        combinationTable: new Array<ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord_json>(),
                        detailedResultsTable: new Array<ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord_json>(),
                        punchingPerimeterRegions: new Array<ng.fem_design.punching_output.FDRegionPolyline3DRecordView_json>(),
                    };
                    if(src.entityResultsTableNo !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDSize32.toObject(src.entityResultsTableNo);
                        if(parsed === null) return null;
                        dst.entityResultsTableNo = parsed;
                    }
                    if (src.entityResultsTable !== null) {
                        for (const element of src.entityResultsTable) {
                            const parsed = ng.fem_design.punching_output.FDRCPunchingCheckResultEntityRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.entityResultsTable.push(parsed);
                        }
                    }
                    if(src.combinationTableNo !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDSize32.toObject(src.combinationTableNo);
                        if(parsed === null) return null;
                        dst.combinationTableNo = parsed;
                    }
                    if (src.combinationTable !== null) {
                        for (const element of src.combinationTable) {
                            const parsed = ng.fem_design.punching_output.FDRCPunchingCheckResultCombinationRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.combinationTable.push(parsed);
                        }
                    }
                    if(src.detailedResultsTableNo !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDSize32.toObject(src.detailedResultsTableNo);
                        if(parsed === null) return null;
                        dst.detailedResultsTableNo = parsed;
                    }
                    if (src.detailedResultsTable !== null) {
                        for (const element of src.detailedResultsTable) {
                            const parsed = ng.fem_design.punching_output.FDRCPunchingCheckDetailRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.detailedResultsTable.push(parsed);
                        }
                    }
                    if(src.punchingPerimeterRegionsNo !== null)
                    {
                        const parsed = ng.fem_design.punching_output.FDSize32.toObject(src.punchingPerimeterRegionsNo);
                        if(parsed === null) return null;
                        dst.punchingPerimeterRegionsNo = parsed;
                    }
                    if (src.punchingPerimeterRegions !== null) {
                        for (const element of src.punchingPerimeterRegions) {
                            const parsed = ng.fem_design.punching_output.FDRegionPolyline3DRecordView.toObject(element);
                            if(parsed === null) return null;
                            dst.punchingPerimeterRegions.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: FDRCPunchingCheckResultDatabaseView_createType) {
                    const dst = new FDRCPunchingCheckResultDatabaseView();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.SchemaId !== undefined) {
                        dst.SchemaId = src.SchemaId;
                    }
                    if (src.entityResultsTableNo !== undefined) {
                        dst.entityResultsTableNo = src.entityResultsTableNo;
                    }
                    if (src.entityResultsTable !== undefined) {
                        dst.entityResultsTable = src.entityResultsTable;
                    }
                    if (src.combinationTableNo !== undefined) {
                        dst.combinationTableNo = src.combinationTableNo;
                    }
                    if (src.combinationTable !== undefined) {
                        dst.combinationTable = src.combinationTable;
                    }
                    if (src.detailedResultsTableNo !== undefined) {
                        dst.detailedResultsTableNo = src.detailedResultsTableNo;
                    }
                    if (src.detailedResultsTable !== undefined) {
                        dst.detailedResultsTable = src.detailedResultsTable;
                    }
                    if (src.punchingPerimeterRegionsNo !== undefined) {
                        dst.punchingPerimeterRegionsNo = src.punchingPerimeterRegionsNo;
                    }
                    if (src.punchingPerimeterRegions !== undefined) {
                        dst.punchingPerimeterRegions = src.punchingPerimeterRegions;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FDRCPunchingCheckResultDatabaseView();
                    dst.SchemaId = this.SchemaId;
                    dst.entityResultsTableNo = this.entityResultsTableNo;
                    dst.entityResultsTable = this.entityResultsTable;
                    dst.combinationTableNo = this.combinationTableNo;
                    dst.combinationTable = this.combinationTable;
                    dst.detailedResultsTableNo = this.detailedResultsTableNo;
                    dst.detailedResultsTable = this.detailedResultsTable;
                    dst.punchingPerimeterRegionsNo = this.punchingPerimeterRegionsNo;
                    dst.punchingPerimeterRegions = this.punchingPerimeterRegions;
                    return dst;
                }

                deepClone() {
                    const json = FDRCPunchingCheckResultDatabaseView.toObject(this);
                    const dst = FDRCPunchingCheckResultDatabaseView.fromObject(json);
                    return dst;
                }
            }
            export type IFDRCPunchingCheckResultDatabaseView = FDRCPunchingCheckResultDatabaseView;
        } // namespace punching_output


        // Defined in FEMDesign/timber_output.proto
        export namespace timber_output {
            export type UniformBar_keys = 'objectUniqueId' | 'overallUtilizationOfTheBar' | 'indexOfCombinationOfTheMaximalUtilizationOfTheBar' | 'numberOfLoadCombination' | 'loadCombinationDesignCalculationResults' | 'barType' | 'isCharredSectionTooSmall' | 'kcr' | 'sectionGeometricalData' | 'kmFactor' | 'ft0k' | 'fm1k' | 'fm2k' | 'apexDataForCurvedBars' | 'numberOfFlexuralBucklingLength1' | 'dataForFlexuralBuckling1' | 'numberOfFlexuralBucklingLength2' | 'dataForFlexuralBuckling2' | 'numberOfTorsionalBucklingLength' | 'dataForTorsionalBuckling';
            export interface UniformBar_createType {
                objectUniqueId?: number,
                overallUtilizationOfTheBar?: number,
                indexOfCombinationOfTheMaximalUtilizationOfTheBar?: number,
                numberOfLoadCombination?: number,
                loadCombinationDesignCalculationResults?: ng.fem_design.timber_output.CombDesignCalcUniformRecord[],
                barType?: ng.fem_design.steel_output.BarSectionType,
                isCharredSectionTooSmall?: boolean,
                kcr?: number,
                sectionGeometricalData?: ng.fem_design.timber_output.SectionGeomData | null,
                kmFactor?: number,
                ft0k?: number,
                fm1k?: number,
                fm2k?: number,
                apexDataForCurvedBars?: ng.fem_design.timber_output.ApexRecord | null,
                numberOfFlexuralBucklingLength1?: number,
                dataForFlexuralBuckling1?: ng.fem_design.timber_output.FlexBucklingRecord[],
                numberOfFlexuralBucklingLength2?: number,
                dataForFlexuralBuckling2?: ng.fem_design.timber_output.FlexBucklingRecord[],
                numberOfTorsionalBucklingLength?: number,
                dataForTorsionalBuckling?: ng.fem_design.timber_output.TorsBucklingRecord[],
            }
            export interface UniformBar_json {
                objectUniqueId?: JsonNumber;
                overallUtilizationOfTheBar?: JsonNumber;
                indexOfCombinationOfTheMaximalUtilizationOfTheBar?: JsonNumber;
                numberOfLoadCombination?: JsonNumber;
                loadCombinationDesignCalculationResults: ng.fem_design.timber_output.CombDesignCalcUniformRecord_json[];
                barType?: string;
                isCharredSectionTooSmall?: boolean;
                kcr?: JsonNumber;
                sectionGeometricalData?: ng.fem_design.timber_output.SectionGeomData_json;
                kmFactor?: JsonNumber;
                ft0k?: JsonNumber;
                fm1k?: JsonNumber;
                fm2k?: JsonNumber;
                apexDataForCurvedBars?: ng.fem_design.timber_output.ApexRecord_json;
                numberOfFlexuralBucklingLength1?: JsonNumber;
                dataForFlexuralBuckling1: ng.fem_design.timber_output.FlexBucklingRecord_json[];
                numberOfFlexuralBucklingLength2?: JsonNumber;
                dataForFlexuralBuckling2: ng.fem_design.timber_output.FlexBucklingRecord_json[];
                numberOfTorsionalBucklingLength?: JsonNumber;
                dataForTorsionalBuckling: ng.fem_design.timber_output.TorsBucklingRecord_json[];
            }
            interface UniformBar_json_in {
                __proto_name?: unknown;
                objectUniqueId?: unknown;
                overallUtilizationOfTheBar?: unknown;
                indexOfCombinationOfTheMaximalUtilizationOfTheBar?: unknown;
                numberOfLoadCombination?: unknown;
                loadCombinationDesignCalculationResults?: unknown;
                barType?: unknown;
                isCharredSectionTooSmall?: unknown;
                kcr?: unknown;
                sectionGeometricalData?: unknown;
                kmFactor?: unknown;
                ft0k?: unknown;
                fm1k?: unknown;
                fm2k?: unknown;
                apexDataForCurvedBars?: unknown;
                numberOfFlexuralBucklingLength1?: unknown;
                dataForFlexuralBuckling1?: unknown;
                numberOfFlexuralBucklingLength2?: unknown;
                dataForFlexuralBuckling2?: unknown;
                numberOfTorsionalBucklingLength?: unknown;
                dataForTorsionalBuckling?: unknown;
            }
            export class UniformBar {
                __proto_name = "ng.fem_design.timber_output.UniformBar";
                objectUniqueId: number = 0;
                overallUtilizationOfTheBar: number = 0;
                indexOfCombinationOfTheMaximalUtilizationOfTheBar: number = 0;
                numberOfLoadCombination: number = 0;
                loadCombinationDesignCalculationResults: ng.fem_design.timber_output.CombDesignCalcUniformRecord[] = [];
                barType: ng.fem_design.steel_output.BarSectionType = ng.fem_design.steel_output.BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                isCharredSectionTooSmall: boolean = false;
                kcr: number = 0;
                sectionGeometricalData: ng.fem_design.timber_output.SectionGeomData | null = null;
                kmFactor: number = 0;
                ft0k: number = 0;
                fm1k: number = 0;
                fm2k: number = 0;
                apexDataForCurvedBars: ng.fem_design.timber_output.ApexRecord | null = null;
                numberOfFlexuralBucklingLength1: number = 0;
                dataForFlexuralBuckling1: ng.fem_design.timber_output.FlexBucklingRecord[] = [];
                numberOfFlexuralBucklingLength2: number = 0;
                dataForFlexuralBuckling2: ng.fem_design.timber_output.FlexBucklingRecord[] = [];
                numberOfTorsionalBucklingLength: number = 0;
                dataForTorsionalBuckling: ng.fem_design.timber_output.TorsBucklingRecord[] = [];

                static fromObject(src_unknown: unknown): UniformBar {
                    const dst = new UniformBar();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted UniformBar but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as UniformBar_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for UniformBar but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.objectUniqueId !== undefined && src.objectUniqueId !== null) {
                        if (typeof src.objectUniqueId === "number" || src.objectUniqueId === 'NaN' || src.objectUniqueId === 'Infinity' || src.objectUniqueId === '-Infinity') {
                            dst.objectUniqueId = NumberToInt("ng.fem_design.timber_output.UniformBar.object_unique_id", AsNum(src.objectUniqueId));
                        }
                        else {
                            console.log('Expected objectUniqueId of UniformBar to be a number but was ', typeof src.objectUniqueId, src.objectUniqueId)
                        }
                    }
                    if (src.overallUtilizationOfTheBar !== undefined && src.overallUtilizationOfTheBar !== null) {
                        if (typeof src.overallUtilizationOfTheBar === "number" || src.overallUtilizationOfTheBar === 'NaN' || src.overallUtilizationOfTheBar === 'Infinity' || src.overallUtilizationOfTheBar === '-Infinity') {
                            dst.overallUtilizationOfTheBar = AsNum(src.overallUtilizationOfTheBar);
                        }
                        else {
                            console.log('Expected overallUtilizationOfTheBar of UniformBar to be a number but was ', typeof src.overallUtilizationOfTheBar, src.overallUtilizationOfTheBar)
                        }
                    }
                    if (src.indexOfCombinationOfTheMaximalUtilizationOfTheBar !== undefined && src.indexOfCombinationOfTheMaximalUtilizationOfTheBar !== null) {
                        if (typeof src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === "number" || src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === 'NaN' || src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === 'Infinity' || src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === '-Infinity') {
                            dst.indexOfCombinationOfTheMaximalUtilizationOfTheBar = NumberToInt("ng.fem_design.timber_output.UniformBar.index_of_combination_of_the_maximal_utilization_of_the_bar", AsNum(src.indexOfCombinationOfTheMaximalUtilizationOfTheBar));
                        }
                        else {
                            console.log('Expected indexOfCombinationOfTheMaximalUtilizationOfTheBar of UniformBar to be a number but was ', typeof src.indexOfCombinationOfTheMaximalUtilizationOfTheBar, src.indexOfCombinationOfTheMaximalUtilizationOfTheBar)
                        }
                    }
                    if (src.numberOfLoadCombination !== undefined && src.numberOfLoadCombination !== null) {
                        if (typeof src.numberOfLoadCombination === "number" || src.numberOfLoadCombination === 'NaN' || src.numberOfLoadCombination === 'Infinity' || src.numberOfLoadCombination === '-Infinity') {
                            dst.numberOfLoadCombination = NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_load_combination", AsNum(src.numberOfLoadCombination));
                        }
                        else {
                            console.log('Expected numberOfLoadCombination of UniformBar to be a number but was ', typeof src.numberOfLoadCombination, src.numberOfLoadCombination)
                        }
                    }
                    if (src.loadCombinationDesignCalculationResults !== undefined && src.loadCombinationDesignCalculationResults !== null) {
                        if (Array.isArray(src.loadCombinationDesignCalculationResults)) {
                            for (const element of src.loadCombinationDesignCalculationResults) {
                                dst.loadCombinationDesignCalculationResults.push(ng.fem_design.timber_output.CombDesignCalcUniformRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadCombinationDesignCalculationResults of UniformBar to be a array but was ', typeof src.loadCombinationDesignCalculationResults, src.loadCombinationDesignCalculationResults)
                        }
                    }
                    if (src.barType !== undefined && src.barType !== null) {
                        dst.barType = ng.fem_design.steel_output.BarSectionType_FromObject(src.barType);
                    }
                    if (src.isCharredSectionTooSmall !== undefined && src.isCharredSectionTooSmall !== null) {
                        if (typeof src.isCharredSectionTooSmall === "boolean") {
                            dst.isCharredSectionTooSmall = src.isCharredSectionTooSmall;
                        }
                        else {
                            console.log('Expected isCharredSectionTooSmall of UniformBar to be a boolean but was ', typeof src.isCharredSectionTooSmall, src.isCharredSectionTooSmall)
                        }
                    }
                    if (src.kcr !== undefined && src.kcr !== null) {
                        if (typeof src.kcr === "number" || src.kcr === 'NaN' || src.kcr === 'Infinity' || src.kcr === '-Infinity') {
                            dst.kcr = AsNum(src.kcr);
                        }
                        else {
                            console.log('Expected kcr of UniformBar to be a number but was ', typeof src.kcr, src.kcr)
                        }
                    }
                    if (src.sectionGeometricalData !== undefined && src.sectionGeometricalData !== null) {
                        dst.sectionGeometricalData = ng.fem_design.timber_output.SectionGeomData.fromObject(src.sectionGeometricalData);
                    }
                    if (src.kmFactor !== undefined && src.kmFactor !== null) {
                        if (typeof src.kmFactor === "number" || src.kmFactor === 'NaN' || src.kmFactor === 'Infinity' || src.kmFactor === '-Infinity') {
                            dst.kmFactor = AsNum(src.kmFactor);
                        }
                        else {
                            console.log('Expected kmFactor of UniformBar to be a number but was ', typeof src.kmFactor, src.kmFactor)
                        }
                    }
                    if (src.ft0k !== undefined && src.ft0k !== null) {
                        if (typeof src.ft0k === "number" || src.ft0k === 'NaN' || src.ft0k === 'Infinity' || src.ft0k === '-Infinity') {
                            dst.ft0k = AsNum(src.ft0k);
                        }
                        else {
                            console.log('Expected ft0k of UniformBar to be a number but was ', typeof src.ft0k, src.ft0k)
                        }
                    }
                    if (src.fm1k !== undefined && src.fm1k !== null) {
                        if (typeof src.fm1k === "number" || src.fm1k === 'NaN' || src.fm1k === 'Infinity' || src.fm1k === '-Infinity') {
                            dst.fm1k = AsNum(src.fm1k);
                        }
                        else {
                            console.log('Expected fm1k of UniformBar to be a number but was ', typeof src.fm1k, src.fm1k)
                        }
                    }
                    if (src.fm2k !== undefined && src.fm2k !== null) {
                        if (typeof src.fm2k === "number" || src.fm2k === 'NaN' || src.fm2k === 'Infinity' || src.fm2k === '-Infinity') {
                            dst.fm2k = AsNum(src.fm2k);
                        }
                        else {
                            console.log('Expected fm2k of UniformBar to be a number but was ', typeof src.fm2k, src.fm2k)
                        }
                    }
                    if (src.apexDataForCurvedBars !== undefined && src.apexDataForCurvedBars !== null) {
                        dst.apexDataForCurvedBars = ng.fem_design.timber_output.ApexRecord.fromObject(src.apexDataForCurvedBars);
                    }
                    if (src.numberOfFlexuralBucklingLength1 !== undefined && src.numberOfFlexuralBucklingLength1 !== null) {
                        if (typeof src.numberOfFlexuralBucklingLength1 === "number" || src.numberOfFlexuralBucklingLength1 === 'NaN' || src.numberOfFlexuralBucklingLength1 === 'Infinity' || src.numberOfFlexuralBucklingLength1 === '-Infinity') {
                            dst.numberOfFlexuralBucklingLength1 = NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_flexural_buckling_length1", AsNum(src.numberOfFlexuralBucklingLength1));
                        }
                        else {
                            console.log('Expected numberOfFlexuralBucklingLength1 of UniformBar to be a number but was ', typeof src.numberOfFlexuralBucklingLength1, src.numberOfFlexuralBucklingLength1)
                        }
                    }
                    if (src.dataForFlexuralBuckling1 !== undefined && src.dataForFlexuralBuckling1 !== null) {
                        if (Array.isArray(src.dataForFlexuralBuckling1)) {
                            for (const element of src.dataForFlexuralBuckling1) {
                                dst.dataForFlexuralBuckling1.push(ng.fem_design.timber_output.FlexBucklingRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected dataForFlexuralBuckling1 of UniformBar to be a array but was ', typeof src.dataForFlexuralBuckling1, src.dataForFlexuralBuckling1)
                        }
                    }
                    if (src.numberOfFlexuralBucklingLength2 !== undefined && src.numberOfFlexuralBucklingLength2 !== null) {
                        if (typeof src.numberOfFlexuralBucklingLength2 === "number" || src.numberOfFlexuralBucklingLength2 === 'NaN' || src.numberOfFlexuralBucklingLength2 === 'Infinity' || src.numberOfFlexuralBucklingLength2 === '-Infinity') {
                            dst.numberOfFlexuralBucklingLength2 = NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_flexural_buckling_length2", AsNum(src.numberOfFlexuralBucklingLength2));
                        }
                        else {
                            console.log('Expected numberOfFlexuralBucklingLength2 of UniformBar to be a number but was ', typeof src.numberOfFlexuralBucklingLength2, src.numberOfFlexuralBucklingLength2)
                        }
                    }
                    if (src.dataForFlexuralBuckling2 !== undefined && src.dataForFlexuralBuckling2 !== null) {
                        if (Array.isArray(src.dataForFlexuralBuckling2)) {
                            for (const element of src.dataForFlexuralBuckling2) {
                                dst.dataForFlexuralBuckling2.push(ng.fem_design.timber_output.FlexBucklingRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected dataForFlexuralBuckling2 of UniformBar to be a array but was ', typeof src.dataForFlexuralBuckling2, src.dataForFlexuralBuckling2)
                        }
                    }
                    if (src.numberOfTorsionalBucklingLength !== undefined && src.numberOfTorsionalBucklingLength !== null) {
                        if (typeof src.numberOfTorsionalBucklingLength === "number" || src.numberOfTorsionalBucklingLength === 'NaN' || src.numberOfTorsionalBucklingLength === 'Infinity' || src.numberOfTorsionalBucklingLength === '-Infinity') {
                            dst.numberOfTorsionalBucklingLength = NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_torsional_buckling_length", AsNum(src.numberOfTorsionalBucklingLength));
                        }
                        else {
                            console.log('Expected numberOfTorsionalBucklingLength of UniformBar to be a number but was ', typeof src.numberOfTorsionalBucklingLength, src.numberOfTorsionalBucklingLength)
                        }
                    }
                    if (src.dataForTorsionalBuckling !== undefined && src.dataForTorsionalBuckling !== null) {
                        if (Array.isArray(src.dataForTorsionalBuckling)) {
                            for (const element of src.dataForTorsionalBuckling) {
                                dst.dataForTorsionalBuckling.push(ng.fem_design.timber_output.TorsBucklingRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected dataForTorsionalBuckling of UniformBar to be a array but was ', typeof src.dataForTorsionalBuckling, src.dataForTorsionalBuckling)
                        }
                    }
                    return dst;
                }

                static toObject(src: UniformBar | null | undefined): UniformBar_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.UniformBar is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.UniformBar") {
                        console.error('Expected ng.fem_design.timber_output.UniformBar but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const barType_obj = ng.fem_design.steel_output.BarSectionType_ToObject(src.barType);
                    if(barType_obj === null) return null;

                    const dst : UniformBar_json = {
                        objectUniqueId: AsJsonNum(NumberToInt("ng.fem_design.timber_output.UniformBar.object_unique_id", src.objectUniqueId)),
                        overallUtilizationOfTheBar: AsJsonNum(src.overallUtilizationOfTheBar),
                        indexOfCombinationOfTheMaximalUtilizationOfTheBar: AsJsonNum(NumberToInt("ng.fem_design.timber_output.UniformBar.index_of_combination_of_the_maximal_utilization_of_the_bar", src.indexOfCombinationOfTheMaximalUtilizationOfTheBar)),
                        numberOfLoadCombination: AsJsonNum(NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_load_combination", src.numberOfLoadCombination)),
                        loadCombinationDesignCalculationResults: new Array<ng.fem_design.timber_output.CombDesignCalcUniformRecord_json>(),
                        barType: barType_obj,
                        isCharredSectionTooSmall: src.isCharredSectionTooSmall,
                        kcr: AsJsonNum(src.kcr),
                        kmFactor: AsJsonNum(src.kmFactor),
                        ft0k: AsJsonNum(src.ft0k),
                        fm1k: AsJsonNum(src.fm1k),
                        fm2k: AsJsonNum(src.fm2k),
                        numberOfFlexuralBucklingLength1: AsJsonNum(NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_flexural_buckling_length1", src.numberOfFlexuralBucklingLength1)),
                        dataForFlexuralBuckling1: new Array<ng.fem_design.timber_output.FlexBucklingRecord_json>(),
                        numberOfFlexuralBucklingLength2: AsJsonNum(NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_flexural_buckling_length2", src.numberOfFlexuralBucklingLength2)),
                        dataForFlexuralBuckling2: new Array<ng.fem_design.timber_output.FlexBucklingRecord_json>(),
                        numberOfTorsionalBucklingLength: AsJsonNum(NumberToInt("ng.fem_design.timber_output.UniformBar.number_of_torsional_buckling_length", src.numberOfTorsionalBucklingLength)),
                        dataForTorsionalBuckling: new Array<ng.fem_design.timber_output.TorsBucklingRecord_json>(),
                    };
                    if (src.loadCombinationDesignCalculationResults !== null) {
                        for (const element of src.loadCombinationDesignCalculationResults) {
                            const parsed = ng.fem_design.timber_output.CombDesignCalcUniformRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.loadCombinationDesignCalculationResults.push(parsed);
                        }
                    }
                    if(src.sectionGeometricalData !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionGeomData.toObject(src.sectionGeometricalData);
                        if(parsed === null) return null;
                        dst.sectionGeometricalData = parsed;
                    }
                    if(src.apexDataForCurvedBars !== null)
                    {
                        const parsed = ng.fem_design.timber_output.ApexRecord.toObject(src.apexDataForCurvedBars);
                        if(parsed === null) return null;
                        dst.apexDataForCurvedBars = parsed;
                    }
                    if (src.dataForFlexuralBuckling1 !== null) {
                        for (const element of src.dataForFlexuralBuckling1) {
                            const parsed = ng.fem_design.timber_output.FlexBucklingRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.dataForFlexuralBuckling1.push(parsed);
                        }
                    }
                    if (src.dataForFlexuralBuckling2 !== null) {
                        for (const element of src.dataForFlexuralBuckling2) {
                            const parsed = ng.fem_design.timber_output.FlexBucklingRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.dataForFlexuralBuckling2.push(parsed);
                        }
                    }
                    if (src.dataForTorsionalBuckling !== null) {
                        for (const element of src.dataForTorsionalBuckling) {
                            const parsed = ng.fem_design.timber_output.TorsBucklingRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.dataForTorsionalBuckling.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: UniformBar_createType) {
                    const dst = new UniformBar();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.objectUniqueId !== undefined) {
                        dst.objectUniqueId = src.objectUniqueId;
                    }
                    if (src.overallUtilizationOfTheBar !== undefined) {
                        dst.overallUtilizationOfTheBar = src.overallUtilizationOfTheBar;
                    }
                    if (src.indexOfCombinationOfTheMaximalUtilizationOfTheBar !== undefined) {
                        dst.indexOfCombinationOfTheMaximalUtilizationOfTheBar = src.indexOfCombinationOfTheMaximalUtilizationOfTheBar;
                    }
                    if (src.numberOfLoadCombination !== undefined) {
                        dst.numberOfLoadCombination = src.numberOfLoadCombination;
                    }
                    if (src.loadCombinationDesignCalculationResults !== undefined) {
                        dst.loadCombinationDesignCalculationResults = src.loadCombinationDesignCalculationResults;
                    }
                    if (src.barType !== undefined) {
                        dst.barType = src.barType;
                    }
                    if (src.isCharredSectionTooSmall !== undefined) {
                        dst.isCharredSectionTooSmall = src.isCharredSectionTooSmall;
                    }
                    if (src.kcr !== undefined) {
                        dst.kcr = src.kcr;
                    }
                    if (src.sectionGeometricalData !== undefined) {
                        dst.sectionGeometricalData = src.sectionGeometricalData;
                    }
                    if (src.kmFactor !== undefined) {
                        dst.kmFactor = src.kmFactor;
                    }
                    if (src.ft0k !== undefined) {
                        dst.ft0k = src.ft0k;
                    }
                    if (src.fm1k !== undefined) {
                        dst.fm1k = src.fm1k;
                    }
                    if (src.fm2k !== undefined) {
                        dst.fm2k = src.fm2k;
                    }
                    if (src.apexDataForCurvedBars !== undefined) {
                        dst.apexDataForCurvedBars = src.apexDataForCurvedBars;
                    }
                    if (src.numberOfFlexuralBucklingLength1 !== undefined) {
                        dst.numberOfFlexuralBucklingLength1 = src.numberOfFlexuralBucklingLength1;
                    }
                    if (src.dataForFlexuralBuckling1 !== undefined) {
                        dst.dataForFlexuralBuckling1 = src.dataForFlexuralBuckling1;
                    }
                    if (src.numberOfFlexuralBucklingLength2 !== undefined) {
                        dst.numberOfFlexuralBucklingLength2 = src.numberOfFlexuralBucklingLength2;
                    }
                    if (src.dataForFlexuralBuckling2 !== undefined) {
                        dst.dataForFlexuralBuckling2 = src.dataForFlexuralBuckling2;
                    }
                    if (src.numberOfTorsionalBucklingLength !== undefined) {
                        dst.numberOfTorsionalBucklingLength = src.numberOfTorsionalBucklingLength;
                    }
                    if (src.dataForTorsionalBuckling !== undefined) {
                        dst.dataForTorsionalBuckling = src.dataForTorsionalBuckling;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new UniformBar();
                    dst.objectUniqueId = this.objectUniqueId;
                    dst.overallUtilizationOfTheBar = this.overallUtilizationOfTheBar;
                    dst.indexOfCombinationOfTheMaximalUtilizationOfTheBar = this.indexOfCombinationOfTheMaximalUtilizationOfTheBar;
                    dst.numberOfLoadCombination = this.numberOfLoadCombination;
                    dst.loadCombinationDesignCalculationResults = this.loadCombinationDesignCalculationResults;
                    dst.barType = this.barType;
                    dst.isCharredSectionTooSmall = this.isCharredSectionTooSmall;
                    dst.kcr = this.kcr;
                    dst.sectionGeometricalData = this.sectionGeometricalData;
                    dst.kmFactor = this.kmFactor;
                    dst.ft0k = this.ft0k;
                    dst.fm1k = this.fm1k;
                    dst.fm2k = this.fm2k;
                    dst.apexDataForCurvedBars = this.apexDataForCurvedBars;
                    dst.numberOfFlexuralBucklingLength1 = this.numberOfFlexuralBucklingLength1;
                    dst.dataForFlexuralBuckling1 = this.dataForFlexuralBuckling1;
                    dst.numberOfFlexuralBucklingLength2 = this.numberOfFlexuralBucklingLength2;
                    dst.dataForFlexuralBuckling2 = this.dataForFlexuralBuckling2;
                    dst.numberOfTorsionalBucklingLength = this.numberOfTorsionalBucklingLength;
                    dst.dataForTorsionalBuckling = this.dataForTorsionalBuckling;
                    return dst;
                }

                deepClone() {
                    const json = UniformBar.toObject(this);
                    const dst = UniformBar.fromObject(json);
                    return dst;
                }
            }
            export type IUniformBar = UniformBar;


            export type VaryingBar_keys = 'objectUniqueId' | 'overallUtilizationOfTheBar' | 'indexOfCombinationOfTheMaximalUtilizationOfTheBar' | 'numberOfLoadCombination' | 'loadCombinationDesignCalculationResults' | 'barType' | 'isCharredSectionTooSmall' | 'kcr' | 'numberOfSections' | 'barSpecificData';
            export interface VaryingBar_createType {
                objectUniqueId?: number,
                overallUtilizationOfTheBar?: number,
                indexOfCombinationOfTheMaximalUtilizationOfTheBar?: number,
                numberOfLoadCombination?: number,
                loadCombinationDesignCalculationResults?: ng.fem_design.timber_output.CombDesignCalcVaryingRecord[],
                barType?: ng.fem_design.steel_output.BarSectionType,
                isCharredSectionTooSmall?: boolean,
                kcr?: number,
                numberOfSections?: number,
                barSpecificData?: ng.fem_design.timber_output.BarExtraDataRecord[],
            }
            export interface VaryingBar_json {
                objectUniqueId?: JsonNumber;
                overallUtilizationOfTheBar?: JsonNumber;
                indexOfCombinationOfTheMaximalUtilizationOfTheBar?: JsonNumber;
                numberOfLoadCombination?: JsonNumber;
                loadCombinationDesignCalculationResults: ng.fem_design.timber_output.CombDesignCalcVaryingRecord_json[];
                barType?: string;
                isCharredSectionTooSmall?: boolean;
                kcr?: JsonNumber;
                numberOfSections?: JsonNumber;
                barSpecificData: ng.fem_design.timber_output.BarExtraDataRecord_json[];
            }
            interface VaryingBar_json_in {
                __proto_name?: unknown;
                objectUniqueId?: unknown;
                overallUtilizationOfTheBar?: unknown;
                indexOfCombinationOfTheMaximalUtilizationOfTheBar?: unknown;
                numberOfLoadCombination?: unknown;
                loadCombinationDesignCalculationResults?: unknown;
                barType?: unknown;
                isCharredSectionTooSmall?: unknown;
                kcr?: unknown;
                numberOfSections?: unknown;
                barSpecificData?: unknown;
            }
            export class VaryingBar {
                __proto_name = "ng.fem_design.timber_output.VaryingBar";
                objectUniqueId: number = 0;
                overallUtilizationOfTheBar: number = 0;
                indexOfCombinationOfTheMaximalUtilizationOfTheBar: number = 0;
                numberOfLoadCombination: number = 0;
                loadCombinationDesignCalculationResults: ng.fem_design.timber_output.CombDesignCalcVaryingRecord[] = [];
                barType: ng.fem_design.steel_output.BarSectionType = ng.fem_design.steel_output.BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                isCharredSectionTooSmall: boolean = false;
                kcr: number = 0;
                numberOfSections: number = 0;
                barSpecificData: ng.fem_design.timber_output.BarExtraDataRecord[] = [];

                static fromObject(src_unknown: unknown): VaryingBar {
                    const dst = new VaryingBar();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted VaryingBar but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as VaryingBar_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for VaryingBar but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.objectUniqueId !== undefined && src.objectUniqueId !== null) {
                        if (typeof src.objectUniqueId === "number" || src.objectUniqueId === 'NaN' || src.objectUniqueId === 'Infinity' || src.objectUniqueId === '-Infinity') {
                            dst.objectUniqueId = NumberToInt("ng.fem_design.timber_output.VaryingBar.object_unique_id", AsNum(src.objectUniqueId));
                        }
                        else {
                            console.log('Expected objectUniqueId of VaryingBar to be a number but was ', typeof src.objectUniqueId, src.objectUniqueId)
                        }
                    }
                    if (src.overallUtilizationOfTheBar !== undefined && src.overallUtilizationOfTheBar !== null) {
                        if (typeof src.overallUtilizationOfTheBar === "number" || src.overallUtilizationOfTheBar === 'NaN' || src.overallUtilizationOfTheBar === 'Infinity' || src.overallUtilizationOfTheBar === '-Infinity') {
                            dst.overallUtilizationOfTheBar = AsNum(src.overallUtilizationOfTheBar);
                        }
                        else {
                            console.log('Expected overallUtilizationOfTheBar of VaryingBar to be a number but was ', typeof src.overallUtilizationOfTheBar, src.overallUtilizationOfTheBar)
                        }
                    }
                    if (src.indexOfCombinationOfTheMaximalUtilizationOfTheBar !== undefined && src.indexOfCombinationOfTheMaximalUtilizationOfTheBar !== null) {
                        if (typeof src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === "number" || src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === 'NaN' || src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === 'Infinity' || src.indexOfCombinationOfTheMaximalUtilizationOfTheBar === '-Infinity') {
                            dst.indexOfCombinationOfTheMaximalUtilizationOfTheBar = NumberToInt("ng.fem_design.timber_output.VaryingBar.index_of_combination_of_the_maximal_utilization_of_the_bar", AsNum(src.indexOfCombinationOfTheMaximalUtilizationOfTheBar));
                        }
                        else {
                            console.log('Expected indexOfCombinationOfTheMaximalUtilizationOfTheBar of VaryingBar to be a number but was ', typeof src.indexOfCombinationOfTheMaximalUtilizationOfTheBar, src.indexOfCombinationOfTheMaximalUtilizationOfTheBar)
                        }
                    }
                    if (src.numberOfLoadCombination !== undefined && src.numberOfLoadCombination !== null) {
                        if (typeof src.numberOfLoadCombination === "number" || src.numberOfLoadCombination === 'NaN' || src.numberOfLoadCombination === 'Infinity' || src.numberOfLoadCombination === '-Infinity') {
                            dst.numberOfLoadCombination = NumberToInt("ng.fem_design.timber_output.VaryingBar.number_of_load_combination", AsNum(src.numberOfLoadCombination));
                        }
                        else {
                            console.log('Expected numberOfLoadCombination of VaryingBar to be a number but was ', typeof src.numberOfLoadCombination, src.numberOfLoadCombination)
                        }
                    }
                    if (src.loadCombinationDesignCalculationResults !== undefined && src.loadCombinationDesignCalculationResults !== null) {
                        if (Array.isArray(src.loadCombinationDesignCalculationResults)) {
                            for (const element of src.loadCombinationDesignCalculationResults) {
                                dst.loadCombinationDesignCalculationResults.push(ng.fem_design.timber_output.CombDesignCalcVaryingRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadCombinationDesignCalculationResults of VaryingBar to be a array but was ', typeof src.loadCombinationDesignCalculationResults, src.loadCombinationDesignCalculationResults)
                        }
                    }
                    if (src.barType !== undefined && src.barType !== null) {
                        dst.barType = ng.fem_design.steel_output.BarSectionType_FromObject(src.barType);
                    }
                    if (src.isCharredSectionTooSmall !== undefined && src.isCharredSectionTooSmall !== null) {
                        if (typeof src.isCharredSectionTooSmall === "boolean") {
                            dst.isCharredSectionTooSmall = src.isCharredSectionTooSmall;
                        }
                        else {
                            console.log('Expected isCharredSectionTooSmall of VaryingBar to be a boolean but was ', typeof src.isCharredSectionTooSmall, src.isCharredSectionTooSmall)
                        }
                    }
                    if (src.kcr !== undefined && src.kcr !== null) {
                        if (typeof src.kcr === "number" || src.kcr === 'NaN' || src.kcr === 'Infinity' || src.kcr === '-Infinity') {
                            dst.kcr = AsNum(src.kcr);
                        }
                        else {
                            console.log('Expected kcr of VaryingBar to be a number but was ', typeof src.kcr, src.kcr)
                        }
                    }
                    if (src.numberOfSections !== undefined && src.numberOfSections !== null) {
                        if (typeof src.numberOfSections === "number" || src.numberOfSections === 'NaN' || src.numberOfSections === 'Infinity' || src.numberOfSections === '-Infinity') {
                            dst.numberOfSections = NumberToInt("ng.fem_design.timber_output.VaryingBar.number_of_sections", AsNum(src.numberOfSections));
                        }
                        else {
                            console.log('Expected numberOfSections of VaryingBar to be a number but was ', typeof src.numberOfSections, src.numberOfSections)
                        }
                    }
                    if (src.barSpecificData !== undefined && src.barSpecificData !== null) {
                        if (Array.isArray(src.barSpecificData)) {
                            for (const element of src.barSpecificData) {
                                dst.barSpecificData.push(ng.fem_design.timber_output.BarExtraDataRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected barSpecificData of VaryingBar to be a array but was ', typeof src.barSpecificData, src.barSpecificData)
                        }
                    }
                    return dst;
                }

                static toObject(src: VaryingBar | null | undefined): VaryingBar_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.VaryingBar is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.VaryingBar") {
                        console.error('Expected ng.fem_design.timber_output.VaryingBar but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const barType_obj = ng.fem_design.steel_output.BarSectionType_ToObject(src.barType);
                    if(barType_obj === null) return null;

                    const dst : VaryingBar_json = {
                        objectUniqueId: AsJsonNum(NumberToInt("ng.fem_design.timber_output.VaryingBar.object_unique_id", src.objectUniqueId)),
                        overallUtilizationOfTheBar: AsJsonNum(src.overallUtilizationOfTheBar),
                        indexOfCombinationOfTheMaximalUtilizationOfTheBar: AsJsonNum(NumberToInt("ng.fem_design.timber_output.VaryingBar.index_of_combination_of_the_maximal_utilization_of_the_bar", src.indexOfCombinationOfTheMaximalUtilizationOfTheBar)),
                        numberOfLoadCombination: AsJsonNum(NumberToInt("ng.fem_design.timber_output.VaryingBar.number_of_load_combination", src.numberOfLoadCombination)),
                        loadCombinationDesignCalculationResults: new Array<ng.fem_design.timber_output.CombDesignCalcVaryingRecord_json>(),
                        barType: barType_obj,
                        isCharredSectionTooSmall: src.isCharredSectionTooSmall,
                        kcr: AsJsonNum(src.kcr),
                        numberOfSections: AsJsonNum(NumberToInt("ng.fem_design.timber_output.VaryingBar.number_of_sections", src.numberOfSections)),
                        barSpecificData: new Array<ng.fem_design.timber_output.BarExtraDataRecord_json>(),
                    };
                    if (src.loadCombinationDesignCalculationResults !== null) {
                        for (const element of src.loadCombinationDesignCalculationResults) {
                            const parsed = ng.fem_design.timber_output.CombDesignCalcVaryingRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.loadCombinationDesignCalculationResults.push(parsed);
                        }
                    }
                    if (src.barSpecificData !== null) {
                        for (const element of src.barSpecificData) {
                            const parsed = ng.fem_design.timber_output.BarExtraDataRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.barSpecificData.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: VaryingBar_createType) {
                    const dst = new VaryingBar();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.objectUniqueId !== undefined) {
                        dst.objectUniqueId = src.objectUniqueId;
                    }
                    if (src.overallUtilizationOfTheBar !== undefined) {
                        dst.overallUtilizationOfTheBar = src.overallUtilizationOfTheBar;
                    }
                    if (src.indexOfCombinationOfTheMaximalUtilizationOfTheBar !== undefined) {
                        dst.indexOfCombinationOfTheMaximalUtilizationOfTheBar = src.indexOfCombinationOfTheMaximalUtilizationOfTheBar;
                    }
                    if (src.numberOfLoadCombination !== undefined) {
                        dst.numberOfLoadCombination = src.numberOfLoadCombination;
                    }
                    if (src.loadCombinationDesignCalculationResults !== undefined) {
                        dst.loadCombinationDesignCalculationResults = src.loadCombinationDesignCalculationResults;
                    }
                    if (src.barType !== undefined) {
                        dst.barType = src.barType;
                    }
                    if (src.isCharredSectionTooSmall !== undefined) {
                        dst.isCharredSectionTooSmall = src.isCharredSectionTooSmall;
                    }
                    if (src.kcr !== undefined) {
                        dst.kcr = src.kcr;
                    }
                    if (src.numberOfSections !== undefined) {
                        dst.numberOfSections = src.numberOfSections;
                    }
                    if (src.barSpecificData !== undefined) {
                        dst.barSpecificData = src.barSpecificData;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new VaryingBar();
                    dst.objectUniqueId = this.objectUniqueId;
                    dst.overallUtilizationOfTheBar = this.overallUtilizationOfTheBar;
                    dst.indexOfCombinationOfTheMaximalUtilizationOfTheBar = this.indexOfCombinationOfTheMaximalUtilizationOfTheBar;
                    dst.numberOfLoadCombination = this.numberOfLoadCombination;
                    dst.loadCombinationDesignCalculationResults = this.loadCombinationDesignCalculationResults;
                    dst.barType = this.barType;
                    dst.isCharredSectionTooSmall = this.isCharredSectionTooSmall;
                    dst.kcr = this.kcr;
                    dst.numberOfSections = this.numberOfSections;
                    dst.barSpecificData = this.barSpecificData;
                    return dst;
                }

                deepClone() {
                    const json = VaryingBar.toObject(this);
                    const dst = VaryingBar.fromObject(json);
                    return dst;
                }
            }
            export type IVaryingBar = VaryingBar;


            export type CombDesignCalcUniformRecord_keys = 'isTheCombinationNotCalculated' | 'orderNumberOfTheCalculation' | 'limitStateOfCombination' | 'isCombination2ndOrder' | 'maximumUtilizationOfLoadCombination' | 'barType' | 'kmod' | 'designStrengthData' | 'numberOfTorsionalBucklingLengths' | 'torsionalBucklingCalculationResults' | 'numberOfSections' | 'resultsOfCalculatedSections';
            export interface CombDesignCalcUniformRecord_createType {
                isTheCombinationNotCalculated?: boolean,
                orderNumberOfTheCalculation?: number,
                limitStateOfCombination?: ng.fem_design.steel_output.LimitState,
                isCombination2ndOrder?: boolean,
                maximumUtilizationOfLoadCombination?: number,
                barType?: ng.fem_design.steel_output.BarSectionType,
                kmod?: number,
                designStrengthData?: ng.fem_design.timber_output.CombDesignStrengthRecord | null,
                numberOfTorsionalBucklingLengths?: number,
                torsionalBucklingCalculationResults?: ng.fem_design.timber_output.CombTorsBucklingRecord[],
                numberOfSections?: number,
                resultsOfCalculatedSections?: ng.fem_design.timber_output.SectionDesignCalcRecord[],
            }
            export interface CombDesignCalcUniformRecord_json {
                isTheCombinationNotCalculated?: boolean;
                orderNumberOfTheCalculation?: JsonNumber;
                limitStateOfCombination?: string;
                isCombination2ndOrder?: boolean;
                maximumUtilizationOfLoadCombination?: JsonNumber;
                barType?: string;
                kmod?: JsonNumber;
                designStrengthData?: ng.fem_design.timber_output.CombDesignStrengthRecord_json;
                numberOfTorsionalBucklingLengths?: JsonNumber;
                torsionalBucklingCalculationResults: ng.fem_design.timber_output.CombTorsBucklingRecord_json[];
                numberOfSections?: JsonNumber;
                resultsOfCalculatedSections: ng.fem_design.timber_output.SectionDesignCalcRecord_json[];
            }
            interface CombDesignCalcUniformRecord_json_in {
                __proto_name?: unknown;
                isTheCombinationNotCalculated?: unknown;
                orderNumberOfTheCalculation?: unknown;
                limitStateOfCombination?: unknown;
                isCombination2ndOrder?: unknown;
                maximumUtilizationOfLoadCombination?: unknown;
                barType?: unknown;
                kmod?: unknown;
                designStrengthData?: unknown;
                numberOfTorsionalBucklingLengths?: unknown;
                torsionalBucklingCalculationResults?: unknown;
                numberOfSections?: unknown;
                resultsOfCalculatedSections?: unknown;
            }
            export class CombDesignCalcUniformRecord {
                __proto_name = "ng.fem_design.timber_output.CombDesignCalcUniformRecord";
                isTheCombinationNotCalculated: boolean = false;
                orderNumberOfTheCalculation: number = 0;
                limitStateOfCombination: ng.fem_design.steel_output.LimitState = ng.fem_design.steel_output.LimitState.LIMIT_STATE_ULTIMATE;
                isCombination2ndOrder: boolean = false;
                maximumUtilizationOfLoadCombination: number = 0;
                barType: ng.fem_design.steel_output.BarSectionType = ng.fem_design.steel_output.BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                kmod: number = 0;
                designStrengthData: ng.fem_design.timber_output.CombDesignStrengthRecord | null = null;
                numberOfTorsionalBucklingLengths: number = 0;
                torsionalBucklingCalculationResults: ng.fem_design.timber_output.CombTorsBucklingRecord[] = [];
                numberOfSections: number = 0;
                resultsOfCalculatedSections: ng.fem_design.timber_output.SectionDesignCalcRecord[] = [];

                static fromObject(src_unknown: unknown): CombDesignCalcUniformRecord {
                    const dst = new CombDesignCalcUniformRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CombDesignCalcUniformRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CombDesignCalcUniformRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CombDesignCalcUniformRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.isTheCombinationNotCalculated !== undefined && src.isTheCombinationNotCalculated !== null) {
                        if (typeof src.isTheCombinationNotCalculated === "boolean") {
                            dst.isTheCombinationNotCalculated = src.isTheCombinationNotCalculated;
                        }
                        else {
                            console.log('Expected isTheCombinationNotCalculated of CombDesignCalcUniformRecord to be a boolean but was ', typeof src.isTheCombinationNotCalculated, src.isTheCombinationNotCalculated)
                        }
                    }
                    if (src.orderNumberOfTheCalculation !== undefined && src.orderNumberOfTheCalculation !== null) {
                        if (typeof src.orderNumberOfTheCalculation === "number" || src.orderNumberOfTheCalculation === 'NaN' || src.orderNumberOfTheCalculation === 'Infinity' || src.orderNumberOfTheCalculation === '-Infinity') {
                            dst.orderNumberOfTheCalculation = NumberToInt("ng.fem_design.timber_output.CombDesignCalcUniformRecord.order_number_of_the_calculation", AsNum(src.orderNumberOfTheCalculation));
                        }
                        else {
                            console.log('Expected orderNumberOfTheCalculation of CombDesignCalcUniformRecord to be a number but was ', typeof src.orderNumberOfTheCalculation, src.orderNumberOfTheCalculation)
                        }
                    }
                    if (src.limitStateOfCombination !== undefined && src.limitStateOfCombination !== null) {
                        dst.limitStateOfCombination = ng.fem_design.steel_output.LimitState_FromObject(src.limitStateOfCombination);
                    }
                    if (src.isCombination2ndOrder !== undefined && src.isCombination2ndOrder !== null) {
                        if (typeof src.isCombination2ndOrder === "boolean") {
                            dst.isCombination2ndOrder = src.isCombination2ndOrder;
                        }
                        else {
                            console.log('Expected isCombination2ndOrder of CombDesignCalcUniformRecord to be a boolean but was ', typeof src.isCombination2ndOrder, src.isCombination2ndOrder)
                        }
                    }
                    if (src.maximumUtilizationOfLoadCombination !== undefined && src.maximumUtilizationOfLoadCombination !== null) {
                        if (typeof src.maximumUtilizationOfLoadCombination === "number" || src.maximumUtilizationOfLoadCombination === 'NaN' || src.maximumUtilizationOfLoadCombination === 'Infinity' || src.maximumUtilizationOfLoadCombination === '-Infinity') {
                            dst.maximumUtilizationOfLoadCombination = AsNum(src.maximumUtilizationOfLoadCombination);
                        }
                        else {
                            console.log('Expected maximumUtilizationOfLoadCombination of CombDesignCalcUniformRecord to be a number but was ', typeof src.maximumUtilizationOfLoadCombination, src.maximumUtilizationOfLoadCombination)
                        }
                    }
                    if (src.barType !== undefined && src.barType !== null) {
                        dst.barType = ng.fem_design.steel_output.BarSectionType_FromObject(src.barType);
                    }
                    if (src.kmod !== undefined && src.kmod !== null) {
                        if (typeof src.kmod === "number" || src.kmod === 'NaN' || src.kmod === 'Infinity' || src.kmod === '-Infinity') {
                            dst.kmod = AsNum(src.kmod);
                        }
                        else {
                            console.log('Expected kmod of CombDesignCalcUniformRecord to be a number but was ', typeof src.kmod, src.kmod)
                        }
                    }
                    if (src.designStrengthData !== undefined && src.designStrengthData !== null) {
                        dst.designStrengthData = ng.fem_design.timber_output.CombDesignStrengthRecord.fromObject(src.designStrengthData);
                    }
                    if (src.numberOfTorsionalBucklingLengths !== undefined && src.numberOfTorsionalBucklingLengths !== null) {
                        if (typeof src.numberOfTorsionalBucklingLengths === "number" || src.numberOfTorsionalBucklingLengths === 'NaN' || src.numberOfTorsionalBucklingLengths === 'Infinity' || src.numberOfTorsionalBucklingLengths === '-Infinity') {
                            dst.numberOfTorsionalBucklingLengths = NumberToInt("ng.fem_design.timber_output.CombDesignCalcUniformRecord.number_of_torsional_buckling_lengths", AsNum(src.numberOfTorsionalBucklingLengths));
                        }
                        else {
                            console.log('Expected numberOfTorsionalBucklingLengths of CombDesignCalcUniformRecord to be a number but was ', typeof src.numberOfTorsionalBucklingLengths, src.numberOfTorsionalBucklingLengths)
                        }
                    }
                    if (src.torsionalBucklingCalculationResults !== undefined && src.torsionalBucklingCalculationResults !== null) {
                        if (Array.isArray(src.torsionalBucklingCalculationResults)) {
                            for (const element of src.torsionalBucklingCalculationResults) {
                                dst.torsionalBucklingCalculationResults.push(ng.fem_design.timber_output.CombTorsBucklingRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected torsionalBucklingCalculationResults of CombDesignCalcUniformRecord to be a array but was ', typeof src.torsionalBucklingCalculationResults, src.torsionalBucklingCalculationResults)
                        }
                    }
                    if (src.numberOfSections !== undefined && src.numberOfSections !== null) {
                        if (typeof src.numberOfSections === "number" || src.numberOfSections === 'NaN' || src.numberOfSections === 'Infinity' || src.numberOfSections === '-Infinity') {
                            dst.numberOfSections = NumberToInt("ng.fem_design.timber_output.CombDesignCalcUniformRecord.number_of_sections", AsNum(src.numberOfSections));
                        }
                        else {
                            console.log('Expected numberOfSections of CombDesignCalcUniformRecord to be a number but was ', typeof src.numberOfSections, src.numberOfSections)
                        }
                    }
                    if (src.resultsOfCalculatedSections !== undefined && src.resultsOfCalculatedSections !== null) {
                        if (Array.isArray(src.resultsOfCalculatedSections)) {
                            for (const element of src.resultsOfCalculatedSections) {
                                dst.resultsOfCalculatedSections.push(ng.fem_design.timber_output.SectionDesignCalcRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultsOfCalculatedSections of CombDesignCalcUniformRecord to be a array but was ', typeof src.resultsOfCalculatedSections, src.resultsOfCalculatedSections)
                        }
                    }
                    return dst;
                }

                static toObject(src: CombDesignCalcUniformRecord | null | undefined): CombDesignCalcUniformRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.CombDesignCalcUniformRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.CombDesignCalcUniformRecord") {
                        console.error('Expected ng.fem_design.timber_output.CombDesignCalcUniformRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const limitStateOfCombination_obj = ng.fem_design.steel_output.LimitState_ToObject(src.limitStateOfCombination);
                    if(limitStateOfCombination_obj === null) return null;

                    const barType_obj = ng.fem_design.steel_output.BarSectionType_ToObject(src.barType);
                    if(barType_obj === null) return null;

                    const dst : CombDesignCalcUniformRecord_json = {
                        isTheCombinationNotCalculated: src.isTheCombinationNotCalculated,
                        orderNumberOfTheCalculation: AsJsonNum(NumberToInt("ng.fem_design.timber_output.CombDesignCalcUniformRecord.order_number_of_the_calculation", src.orderNumberOfTheCalculation)),
                        limitStateOfCombination: limitStateOfCombination_obj,
                        isCombination2ndOrder: src.isCombination2ndOrder,
                        maximumUtilizationOfLoadCombination: AsJsonNum(src.maximumUtilizationOfLoadCombination),
                        barType: barType_obj,
                        kmod: AsJsonNum(src.kmod),
                        numberOfTorsionalBucklingLengths: AsJsonNum(NumberToInt("ng.fem_design.timber_output.CombDesignCalcUniformRecord.number_of_torsional_buckling_lengths", src.numberOfTorsionalBucklingLengths)),
                        torsionalBucklingCalculationResults: new Array<ng.fem_design.timber_output.CombTorsBucklingRecord_json>(),
                        numberOfSections: AsJsonNum(NumberToInt("ng.fem_design.timber_output.CombDesignCalcUniformRecord.number_of_sections", src.numberOfSections)),
                        resultsOfCalculatedSections: new Array<ng.fem_design.timber_output.SectionDesignCalcRecord_json>(),
                    };
                    if(src.designStrengthData !== null)
                    {
                        const parsed = ng.fem_design.timber_output.CombDesignStrengthRecord.toObject(src.designStrengthData);
                        if(parsed === null) return null;
                        dst.designStrengthData = parsed;
                    }
                    if (src.torsionalBucklingCalculationResults !== null) {
                        for (const element of src.torsionalBucklingCalculationResults) {
                            const parsed = ng.fem_design.timber_output.CombTorsBucklingRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.torsionalBucklingCalculationResults.push(parsed);
                        }
                    }
                    if (src.resultsOfCalculatedSections !== null) {
                        for (const element of src.resultsOfCalculatedSections) {
                            const parsed = ng.fem_design.timber_output.SectionDesignCalcRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.resultsOfCalculatedSections.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CombDesignCalcUniformRecord_createType) {
                    const dst = new CombDesignCalcUniformRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.isTheCombinationNotCalculated !== undefined) {
                        dst.isTheCombinationNotCalculated = src.isTheCombinationNotCalculated;
                    }
                    if (src.orderNumberOfTheCalculation !== undefined) {
                        dst.orderNumberOfTheCalculation = src.orderNumberOfTheCalculation;
                    }
                    if (src.limitStateOfCombination !== undefined) {
                        dst.limitStateOfCombination = src.limitStateOfCombination;
                    }
                    if (src.isCombination2ndOrder !== undefined) {
                        dst.isCombination2ndOrder = src.isCombination2ndOrder;
                    }
                    if (src.maximumUtilizationOfLoadCombination !== undefined) {
                        dst.maximumUtilizationOfLoadCombination = src.maximumUtilizationOfLoadCombination;
                    }
                    if (src.barType !== undefined) {
                        dst.barType = src.barType;
                    }
                    if (src.kmod !== undefined) {
                        dst.kmod = src.kmod;
                    }
                    if (src.designStrengthData !== undefined) {
                        dst.designStrengthData = src.designStrengthData;
                    }
                    if (src.numberOfTorsionalBucklingLengths !== undefined) {
                        dst.numberOfTorsionalBucklingLengths = src.numberOfTorsionalBucklingLengths;
                    }
                    if (src.torsionalBucklingCalculationResults !== undefined) {
                        dst.torsionalBucklingCalculationResults = src.torsionalBucklingCalculationResults;
                    }
                    if (src.numberOfSections !== undefined) {
                        dst.numberOfSections = src.numberOfSections;
                    }
                    if (src.resultsOfCalculatedSections !== undefined) {
                        dst.resultsOfCalculatedSections = src.resultsOfCalculatedSections;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CombDesignCalcUniformRecord();
                    dst.isTheCombinationNotCalculated = this.isTheCombinationNotCalculated;
                    dst.orderNumberOfTheCalculation = this.orderNumberOfTheCalculation;
                    dst.limitStateOfCombination = this.limitStateOfCombination;
                    dst.isCombination2ndOrder = this.isCombination2ndOrder;
                    dst.maximumUtilizationOfLoadCombination = this.maximumUtilizationOfLoadCombination;
                    dst.barType = this.barType;
                    dst.kmod = this.kmod;
                    dst.designStrengthData = this.designStrengthData;
                    dst.numberOfTorsionalBucklingLengths = this.numberOfTorsionalBucklingLengths;
                    dst.torsionalBucklingCalculationResults = this.torsionalBucklingCalculationResults;
                    dst.numberOfSections = this.numberOfSections;
                    dst.resultsOfCalculatedSections = this.resultsOfCalculatedSections;
                    return dst;
                }

                deepClone() {
                    const json = CombDesignCalcUniformRecord.toObject(this);
                    const dst = CombDesignCalcUniformRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICombDesignCalcUniformRecord = CombDesignCalcUniformRecord;


            export type CombDesignCalcVaryingRecord_keys = 'isTheCombinationNotCalculated' | 'orderNumberOfTheCalculation' | 'limitStateOfCombination' | 'isCombination2ndOrder' | 'maximumUtilizationOfLoadCombination' | 'barType' | 'kmod' | 'numberOfSectionsStrength' | 'designSectionData' | 'numberOfSections' | 'resultsOfCalculatedSections';
            export interface CombDesignCalcVaryingRecord_createType {
                isTheCombinationNotCalculated?: boolean,
                orderNumberOfTheCalculation?: number,
                limitStateOfCombination?: ng.fem_design.steel_output.LimitState,
                isCombination2ndOrder?: boolean,
                maximumUtilizationOfLoadCombination?: number,
                barType?: ng.fem_design.steel_output.BarSectionType,
                kmod?: number,
                numberOfSectionsStrength?: number,
                designSectionData?: ng.fem_design.timber_output.CombDesignSectionRecord[],
                numberOfSections?: number,
                resultsOfCalculatedSections?: ng.fem_design.timber_output.SectionDesignCalcRecord[],
            }
            export interface CombDesignCalcVaryingRecord_json {
                isTheCombinationNotCalculated?: boolean;
                orderNumberOfTheCalculation?: JsonNumber;
                limitStateOfCombination?: string;
                isCombination2ndOrder?: boolean;
                maximumUtilizationOfLoadCombination?: JsonNumber;
                barType?: string;
                kmod?: JsonNumber;
                numberOfSectionsStrength?: JsonNumber;
                designSectionData: ng.fem_design.timber_output.CombDesignSectionRecord_json[];
                numberOfSections?: JsonNumber;
                resultsOfCalculatedSections: ng.fem_design.timber_output.SectionDesignCalcRecord_json[];
            }
            interface CombDesignCalcVaryingRecord_json_in {
                __proto_name?: unknown;
                isTheCombinationNotCalculated?: unknown;
                orderNumberOfTheCalculation?: unknown;
                limitStateOfCombination?: unknown;
                isCombination2ndOrder?: unknown;
                maximumUtilizationOfLoadCombination?: unknown;
                barType?: unknown;
                kmod?: unknown;
                numberOfSectionsStrength?: unknown;
                designSectionData?: unknown;
                numberOfSections?: unknown;
                resultsOfCalculatedSections?: unknown;
            }
            export class CombDesignCalcVaryingRecord {
                __proto_name = "ng.fem_design.timber_output.CombDesignCalcVaryingRecord";
                isTheCombinationNotCalculated: boolean = false;
                orderNumberOfTheCalculation: number = 0;
                limitStateOfCombination: ng.fem_design.steel_output.LimitState = ng.fem_design.steel_output.LimitState.LIMIT_STATE_ULTIMATE;
                isCombination2ndOrder: boolean = false;
                maximumUtilizationOfLoadCombination: number = 0;
                barType: ng.fem_design.steel_output.BarSectionType = ng.fem_design.steel_output.BarSectionType.BAR_SECTION_TYPE_UNIFORM;
                kmod: number = 0;
                numberOfSectionsStrength: number = 0;
                designSectionData: ng.fem_design.timber_output.CombDesignSectionRecord[] = [];
                numberOfSections: number = 0;
                resultsOfCalculatedSections: ng.fem_design.timber_output.SectionDesignCalcRecord[] = [];

                static fromObject(src_unknown: unknown): CombDesignCalcVaryingRecord {
                    const dst = new CombDesignCalcVaryingRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CombDesignCalcVaryingRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CombDesignCalcVaryingRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CombDesignCalcVaryingRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.isTheCombinationNotCalculated !== undefined && src.isTheCombinationNotCalculated !== null) {
                        if (typeof src.isTheCombinationNotCalculated === "boolean") {
                            dst.isTheCombinationNotCalculated = src.isTheCombinationNotCalculated;
                        }
                        else {
                            console.log('Expected isTheCombinationNotCalculated of CombDesignCalcVaryingRecord to be a boolean but was ', typeof src.isTheCombinationNotCalculated, src.isTheCombinationNotCalculated)
                        }
                    }
                    if (src.orderNumberOfTheCalculation !== undefined && src.orderNumberOfTheCalculation !== null) {
                        if (typeof src.orderNumberOfTheCalculation === "number" || src.orderNumberOfTheCalculation === 'NaN' || src.orderNumberOfTheCalculation === 'Infinity' || src.orderNumberOfTheCalculation === '-Infinity') {
                            dst.orderNumberOfTheCalculation = NumberToInt("ng.fem_design.timber_output.CombDesignCalcVaryingRecord.order_number_of_the_calculation", AsNum(src.orderNumberOfTheCalculation));
                        }
                        else {
                            console.log('Expected orderNumberOfTheCalculation of CombDesignCalcVaryingRecord to be a number but was ', typeof src.orderNumberOfTheCalculation, src.orderNumberOfTheCalculation)
                        }
                    }
                    if (src.limitStateOfCombination !== undefined && src.limitStateOfCombination !== null) {
                        dst.limitStateOfCombination = ng.fem_design.steel_output.LimitState_FromObject(src.limitStateOfCombination);
                    }
                    if (src.isCombination2ndOrder !== undefined && src.isCombination2ndOrder !== null) {
                        if (typeof src.isCombination2ndOrder === "boolean") {
                            dst.isCombination2ndOrder = src.isCombination2ndOrder;
                        }
                        else {
                            console.log('Expected isCombination2ndOrder of CombDesignCalcVaryingRecord to be a boolean but was ', typeof src.isCombination2ndOrder, src.isCombination2ndOrder)
                        }
                    }
                    if (src.maximumUtilizationOfLoadCombination !== undefined && src.maximumUtilizationOfLoadCombination !== null) {
                        if (typeof src.maximumUtilizationOfLoadCombination === "number" || src.maximumUtilizationOfLoadCombination === 'NaN' || src.maximumUtilizationOfLoadCombination === 'Infinity' || src.maximumUtilizationOfLoadCombination === '-Infinity') {
                            dst.maximumUtilizationOfLoadCombination = AsNum(src.maximumUtilizationOfLoadCombination);
                        }
                        else {
                            console.log('Expected maximumUtilizationOfLoadCombination of CombDesignCalcVaryingRecord to be a number but was ', typeof src.maximumUtilizationOfLoadCombination, src.maximumUtilizationOfLoadCombination)
                        }
                    }
                    if (src.barType !== undefined && src.barType !== null) {
                        dst.barType = ng.fem_design.steel_output.BarSectionType_FromObject(src.barType);
                    }
                    if (src.kmod !== undefined && src.kmod !== null) {
                        if (typeof src.kmod === "number" || src.kmod === 'NaN' || src.kmod === 'Infinity' || src.kmod === '-Infinity') {
                            dst.kmod = AsNum(src.kmod);
                        }
                        else {
                            console.log('Expected kmod of CombDesignCalcVaryingRecord to be a number but was ', typeof src.kmod, src.kmod)
                        }
                    }
                    if (src.numberOfSectionsStrength !== undefined && src.numberOfSectionsStrength !== null) {
                        if (typeof src.numberOfSectionsStrength === "number" || src.numberOfSectionsStrength === 'NaN' || src.numberOfSectionsStrength === 'Infinity' || src.numberOfSectionsStrength === '-Infinity') {
                            dst.numberOfSectionsStrength = NumberToInt("ng.fem_design.timber_output.CombDesignCalcVaryingRecord.number_of_sections_strength", AsNum(src.numberOfSectionsStrength));
                        }
                        else {
                            console.log('Expected numberOfSectionsStrength of CombDesignCalcVaryingRecord to be a number but was ', typeof src.numberOfSectionsStrength, src.numberOfSectionsStrength)
                        }
                    }
                    if (src.designSectionData !== undefined && src.designSectionData !== null) {
                        if (Array.isArray(src.designSectionData)) {
                            for (const element of src.designSectionData) {
                                dst.designSectionData.push(ng.fem_design.timber_output.CombDesignSectionRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected designSectionData of CombDesignCalcVaryingRecord to be a array but was ', typeof src.designSectionData, src.designSectionData)
                        }
                    }
                    if (src.numberOfSections !== undefined && src.numberOfSections !== null) {
                        if (typeof src.numberOfSections === "number" || src.numberOfSections === 'NaN' || src.numberOfSections === 'Infinity' || src.numberOfSections === '-Infinity') {
                            dst.numberOfSections = NumberToInt("ng.fem_design.timber_output.CombDesignCalcVaryingRecord.number_of_sections", AsNum(src.numberOfSections));
                        }
                        else {
                            console.log('Expected numberOfSections of CombDesignCalcVaryingRecord to be a number but was ', typeof src.numberOfSections, src.numberOfSections)
                        }
                    }
                    if (src.resultsOfCalculatedSections !== undefined && src.resultsOfCalculatedSections !== null) {
                        if (Array.isArray(src.resultsOfCalculatedSections)) {
                            for (const element of src.resultsOfCalculatedSections) {
                                dst.resultsOfCalculatedSections.push(ng.fem_design.timber_output.SectionDesignCalcRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultsOfCalculatedSections of CombDesignCalcVaryingRecord to be a array but was ', typeof src.resultsOfCalculatedSections, src.resultsOfCalculatedSections)
                        }
                    }
                    return dst;
                }

                static toObject(src: CombDesignCalcVaryingRecord | null | undefined): CombDesignCalcVaryingRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.CombDesignCalcVaryingRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.CombDesignCalcVaryingRecord") {
                        console.error('Expected ng.fem_design.timber_output.CombDesignCalcVaryingRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const limitStateOfCombination_obj = ng.fem_design.steel_output.LimitState_ToObject(src.limitStateOfCombination);
                    if(limitStateOfCombination_obj === null) return null;

                    const barType_obj = ng.fem_design.steel_output.BarSectionType_ToObject(src.barType);
                    if(barType_obj === null) return null;

                    const dst : CombDesignCalcVaryingRecord_json = {
                        isTheCombinationNotCalculated: src.isTheCombinationNotCalculated,
                        orderNumberOfTheCalculation: AsJsonNum(NumberToInt("ng.fem_design.timber_output.CombDesignCalcVaryingRecord.order_number_of_the_calculation", src.orderNumberOfTheCalculation)),
                        limitStateOfCombination: limitStateOfCombination_obj,
                        isCombination2ndOrder: src.isCombination2ndOrder,
                        maximumUtilizationOfLoadCombination: AsJsonNum(src.maximumUtilizationOfLoadCombination),
                        barType: barType_obj,
                        kmod: AsJsonNum(src.kmod),
                        numberOfSectionsStrength: AsJsonNum(NumberToInt("ng.fem_design.timber_output.CombDesignCalcVaryingRecord.number_of_sections_strength", src.numberOfSectionsStrength)),
                        designSectionData: new Array<ng.fem_design.timber_output.CombDesignSectionRecord_json>(),
                        numberOfSections: AsJsonNum(NumberToInt("ng.fem_design.timber_output.CombDesignCalcVaryingRecord.number_of_sections", src.numberOfSections)),
                        resultsOfCalculatedSections: new Array<ng.fem_design.timber_output.SectionDesignCalcRecord_json>(),
                    };
                    if (src.designSectionData !== null) {
                        for (const element of src.designSectionData) {
                            const parsed = ng.fem_design.timber_output.CombDesignSectionRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.designSectionData.push(parsed);
                        }
                    }
                    if (src.resultsOfCalculatedSections !== null) {
                        for (const element of src.resultsOfCalculatedSections) {
                            const parsed = ng.fem_design.timber_output.SectionDesignCalcRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.resultsOfCalculatedSections.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CombDesignCalcVaryingRecord_createType) {
                    const dst = new CombDesignCalcVaryingRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.isTheCombinationNotCalculated !== undefined) {
                        dst.isTheCombinationNotCalculated = src.isTheCombinationNotCalculated;
                    }
                    if (src.orderNumberOfTheCalculation !== undefined) {
                        dst.orderNumberOfTheCalculation = src.orderNumberOfTheCalculation;
                    }
                    if (src.limitStateOfCombination !== undefined) {
                        dst.limitStateOfCombination = src.limitStateOfCombination;
                    }
                    if (src.isCombination2ndOrder !== undefined) {
                        dst.isCombination2ndOrder = src.isCombination2ndOrder;
                    }
                    if (src.maximumUtilizationOfLoadCombination !== undefined) {
                        dst.maximumUtilizationOfLoadCombination = src.maximumUtilizationOfLoadCombination;
                    }
                    if (src.barType !== undefined) {
                        dst.barType = src.barType;
                    }
                    if (src.kmod !== undefined) {
                        dst.kmod = src.kmod;
                    }
                    if (src.numberOfSectionsStrength !== undefined) {
                        dst.numberOfSectionsStrength = src.numberOfSectionsStrength;
                    }
                    if (src.designSectionData !== undefined) {
                        dst.designSectionData = src.designSectionData;
                    }
                    if (src.numberOfSections !== undefined) {
                        dst.numberOfSections = src.numberOfSections;
                    }
                    if (src.resultsOfCalculatedSections !== undefined) {
                        dst.resultsOfCalculatedSections = src.resultsOfCalculatedSections;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CombDesignCalcVaryingRecord();
                    dst.isTheCombinationNotCalculated = this.isTheCombinationNotCalculated;
                    dst.orderNumberOfTheCalculation = this.orderNumberOfTheCalculation;
                    dst.limitStateOfCombination = this.limitStateOfCombination;
                    dst.isCombination2ndOrder = this.isCombination2ndOrder;
                    dst.maximumUtilizationOfLoadCombination = this.maximumUtilizationOfLoadCombination;
                    dst.barType = this.barType;
                    dst.kmod = this.kmod;
                    dst.numberOfSectionsStrength = this.numberOfSectionsStrength;
                    dst.designSectionData = this.designSectionData;
                    dst.numberOfSections = this.numberOfSections;
                    dst.resultsOfCalculatedSections = this.resultsOfCalculatedSections;
                    return dst;
                }

                deepClone() {
                    const json = CombDesignCalcVaryingRecord.toObject(this);
                    const dst = CombDesignCalcVaryingRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICombDesignCalcVaryingRecord = CombDesignCalcVaryingRecord;


            export type SectionGeomData_keys = 'rW' | 'rH' | 'rA' | 'rW1' | 'rW2' | 'rBeta' | 'rIr1' | 'rIr2' | 'rI1' | 'rI2' | 'rIt' | 'kShape';
            export interface SectionGeomData_createType {
                rW?: number,
                rH?: number,
                rA?: number,
                rW1?: number,
                rW2?: number,
                rBeta?: number,
                rIr1?: number,
                rIr2?: number,
                rI1?: number,
                rI2?: number,
                rIt?: number,
                kShape?: number,
            }
            export interface SectionGeomData_json {
                rW?: JsonNumber;
                rH?: JsonNumber;
                rA?: JsonNumber;
                rW1?: JsonNumber;
                rW2?: JsonNumber;
                rBeta?: JsonNumber;
                rIr1?: JsonNumber;
                rIr2?: JsonNumber;
                rI1?: JsonNumber;
                rI2?: JsonNumber;
                rIt?: JsonNumber;
                kShape?: JsonNumber;
            }
            interface SectionGeomData_json_in {
                __proto_name?: unknown;
                rW?: unknown;
                rH?: unknown;
                rA?: unknown;
                rW1?: unknown;
                rW2?: unknown;
                rBeta?: unknown;
                rIr1?: unknown;
                rIr2?: unknown;
                rI1?: unknown;
                rI2?: unknown;
                rIt?: unknown;
                kShape?: unknown;
            }
            export class SectionGeomData {
                __proto_name = "ng.fem_design.timber_output.SectionGeomData";
                rW: number = 0;
                rH: number = 0;
                rA: number = 0;
                rW1: number = 0;
                rW2: number = 0;
                rBeta: number = 0;
                rIr1: number = 0;
                rIr2: number = 0;
                rI1: number = 0;
                rI2: number = 0;
                rIt: number = 0;
                kShape: number = 0;

                static fromObject(src_unknown: unknown): SectionGeomData {
                    const dst = new SectionGeomData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionGeomData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionGeomData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionGeomData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rW !== undefined && src.rW !== null) {
                        if (typeof src.rW === "number" || src.rW === 'NaN' || src.rW === 'Infinity' || src.rW === '-Infinity') {
                            dst.rW = AsNum(src.rW);
                        }
                        else {
                            console.log('Expected rW of SectionGeomData to be a number but was ', typeof src.rW, src.rW)
                        }
                    }
                    if (src.rH !== undefined && src.rH !== null) {
                        if (typeof src.rH === "number" || src.rH === 'NaN' || src.rH === 'Infinity' || src.rH === '-Infinity') {
                            dst.rH = AsNum(src.rH);
                        }
                        else {
                            console.log('Expected rH of SectionGeomData to be a number but was ', typeof src.rH, src.rH)
                        }
                    }
                    if (src.rA !== undefined && src.rA !== null) {
                        if (typeof src.rA === "number" || src.rA === 'NaN' || src.rA === 'Infinity' || src.rA === '-Infinity') {
                            dst.rA = AsNum(src.rA);
                        }
                        else {
                            console.log('Expected rA of SectionGeomData to be a number but was ', typeof src.rA, src.rA)
                        }
                    }
                    if (src.rW1 !== undefined && src.rW1 !== null) {
                        if (typeof src.rW1 === "number" || src.rW1 === 'NaN' || src.rW1 === 'Infinity' || src.rW1 === '-Infinity') {
                            dst.rW1 = AsNum(src.rW1);
                        }
                        else {
                            console.log('Expected rW1 of SectionGeomData to be a number but was ', typeof src.rW1, src.rW1)
                        }
                    }
                    if (src.rW2 !== undefined && src.rW2 !== null) {
                        if (typeof src.rW2 === "number" || src.rW2 === 'NaN' || src.rW2 === 'Infinity' || src.rW2 === '-Infinity') {
                            dst.rW2 = AsNum(src.rW2);
                        }
                        else {
                            console.log('Expected rW2 of SectionGeomData to be a number but was ', typeof src.rW2, src.rW2)
                        }
                    }
                    if (src.rBeta !== undefined && src.rBeta !== null) {
                        if (typeof src.rBeta === "number" || src.rBeta === 'NaN' || src.rBeta === 'Infinity' || src.rBeta === '-Infinity') {
                            dst.rBeta = AsNum(src.rBeta);
                        }
                        else {
                            console.log('Expected rBeta of SectionGeomData to be a number but was ', typeof src.rBeta, src.rBeta)
                        }
                    }
                    if (src.rIr1 !== undefined && src.rIr1 !== null) {
                        if (typeof src.rIr1 === "number" || src.rIr1 === 'NaN' || src.rIr1 === 'Infinity' || src.rIr1 === '-Infinity') {
                            dst.rIr1 = AsNum(src.rIr1);
                        }
                        else {
                            console.log('Expected rIr1 of SectionGeomData to be a number but was ', typeof src.rIr1, src.rIr1)
                        }
                    }
                    if (src.rIr2 !== undefined && src.rIr2 !== null) {
                        if (typeof src.rIr2 === "number" || src.rIr2 === 'NaN' || src.rIr2 === 'Infinity' || src.rIr2 === '-Infinity') {
                            dst.rIr2 = AsNum(src.rIr2);
                        }
                        else {
                            console.log('Expected rIr2 of SectionGeomData to be a number but was ', typeof src.rIr2, src.rIr2)
                        }
                    }
                    if (src.rI1 !== undefined && src.rI1 !== null) {
                        if (typeof src.rI1 === "number" || src.rI1 === 'NaN' || src.rI1 === 'Infinity' || src.rI1 === '-Infinity') {
                            dst.rI1 = AsNum(src.rI1);
                        }
                        else {
                            console.log('Expected rI1 of SectionGeomData to be a number but was ', typeof src.rI1, src.rI1)
                        }
                    }
                    if (src.rI2 !== undefined && src.rI2 !== null) {
                        if (typeof src.rI2 === "number" || src.rI2 === 'NaN' || src.rI2 === 'Infinity' || src.rI2 === '-Infinity') {
                            dst.rI2 = AsNum(src.rI2);
                        }
                        else {
                            console.log('Expected rI2 of SectionGeomData to be a number but was ', typeof src.rI2, src.rI2)
                        }
                    }
                    if (src.rIt !== undefined && src.rIt !== null) {
                        if (typeof src.rIt === "number" || src.rIt === 'NaN' || src.rIt === 'Infinity' || src.rIt === '-Infinity') {
                            dst.rIt = AsNum(src.rIt);
                        }
                        else {
                            console.log('Expected rIt of SectionGeomData to be a number but was ', typeof src.rIt, src.rIt)
                        }
                    }
                    if (src.kShape !== undefined && src.kShape !== null) {
                        if (typeof src.kShape === "number" || src.kShape === 'NaN' || src.kShape === 'Infinity' || src.kShape === '-Infinity') {
                            dst.kShape = AsNum(src.kShape);
                        }
                        else {
                            console.log('Expected kShape of SectionGeomData to be a number but was ', typeof src.kShape, src.kShape)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionGeomData | null | undefined): SectionGeomData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionGeomData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionGeomData") {
                        console.error('Expected ng.fem_design.timber_output.SectionGeomData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionGeomData_json = {
                        rW: AsJsonNum(src.rW),
                        rH: AsJsonNum(src.rH),
                        rA: AsJsonNum(src.rA),
                        rW1: AsJsonNum(src.rW1),
                        rW2: AsJsonNum(src.rW2),
                        rBeta: AsJsonNum(src.rBeta),
                        rIr1: AsJsonNum(src.rIr1),
                        rIr2: AsJsonNum(src.rIr2),
                        rI1: AsJsonNum(src.rI1),
                        rI2: AsJsonNum(src.rI2),
                        rIt: AsJsonNum(src.rIt),
                        kShape: AsJsonNum(src.kShape),
                    };
                    return dst;
                }

                static create(src?: SectionGeomData_createType) {
                    const dst = new SectionGeomData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rW !== undefined) {
                        dst.rW = src.rW;
                    }
                    if (src.rH !== undefined) {
                        dst.rH = src.rH;
                    }
                    if (src.rA !== undefined) {
                        dst.rA = src.rA;
                    }
                    if (src.rW1 !== undefined) {
                        dst.rW1 = src.rW1;
                    }
                    if (src.rW2 !== undefined) {
                        dst.rW2 = src.rW2;
                    }
                    if (src.rBeta !== undefined) {
                        dst.rBeta = src.rBeta;
                    }
                    if (src.rIr1 !== undefined) {
                        dst.rIr1 = src.rIr1;
                    }
                    if (src.rIr2 !== undefined) {
                        dst.rIr2 = src.rIr2;
                    }
                    if (src.rI1 !== undefined) {
                        dst.rI1 = src.rI1;
                    }
                    if (src.rI2 !== undefined) {
                        dst.rI2 = src.rI2;
                    }
                    if (src.rIt !== undefined) {
                        dst.rIt = src.rIt;
                    }
                    if (src.kShape !== undefined) {
                        dst.kShape = src.kShape;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionGeomData();
                    dst.rW = this.rW;
                    dst.rH = this.rH;
                    dst.rA = this.rA;
                    dst.rW1 = this.rW1;
                    dst.rW2 = this.rW2;
                    dst.rBeta = this.rBeta;
                    dst.rIr1 = this.rIr1;
                    dst.rIr2 = this.rIr2;
                    dst.rI1 = this.rI1;
                    dst.rI2 = this.rI2;
                    dst.rIt = this.rIt;
                    dst.kShape = this.kShape;
                    return dst;
                }

                deepClone() {
                    const json = SectionGeomData.toObject(this);
                    const dst = SectionGeomData.fromObject(json);
                    return dst;
                }
            }
            export type ISectionGeomData = SectionGeomData;


            export type ApexRecord_keys = 'fPositiveMomentCausesTension' | 'rAlphaAp' | 'rHAp' | 'rB' | 'rKr' | 'rKl' | 'rKdis' | 'rKvol' | 'rKp' | 'rK' | 'rVolumeAp' | 'rIn' | 'r';
            export interface ApexRecord_createType {
                fPositiveMomentCausesTension?: boolean,
                rAlphaAp?: number,
                rHAp?: number,
                rB?: number,
                rKr?: number,
                rKl?: number,
                rKdis?: number,
                rKvol?: number,
                rKp?: number,
                rK?: number[],
                rVolumeAp?: number,
                rIn?: number,
                r?: number,
            }
            export interface ApexRecord_json {
                fPositiveMomentCausesTension?: boolean;
                rAlphaAp?: JsonNumber;
                rHAp?: JsonNumber;
                rB?: JsonNumber;
                rKr?: JsonNumber;
                rKl?: JsonNumber;
                rKdis?: JsonNumber;
                rKvol?: JsonNumber;
                rKp?: JsonNumber;
                rK: JsonNumber[];
                rVolumeAp?: JsonNumber;
                rIn?: JsonNumber;
                r?: JsonNumber;
            }
            interface ApexRecord_json_in {
                __proto_name?: unknown;
                fPositiveMomentCausesTension?: unknown;
                rAlphaAp?: unknown;
                rHAp?: unknown;
                rB?: unknown;
                rKr?: unknown;
                rKl?: unknown;
                rKdis?: unknown;
                rKvol?: unknown;
                rKp?: unknown;
                rK?: unknown;
                rVolumeAp?: unknown;
                rIn?: unknown;
                r?: unknown;
            }
            export class ApexRecord {
                __proto_name = "ng.fem_design.timber_output.ApexRecord";
                fPositiveMomentCausesTension: boolean = false;
                rAlphaAp: number = 0;
                rHAp: number = 0;
                rB: number = 0;
                rKr: number = 0;
                rKl: number = 0;
                rKdis: number = 0;
                rKvol: number = 0;
                rKp: number = 0;
                rK: number[] = [];
                rVolumeAp: number = 0;
                rIn: number = 0;
                r: number = 0;

                static fromObject(src_unknown: unknown): ApexRecord {
                    const dst = new ApexRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ApexRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ApexRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ApexRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fPositiveMomentCausesTension !== undefined && src.fPositiveMomentCausesTension !== null) {
                        if (typeof src.fPositiveMomentCausesTension === "boolean") {
                            dst.fPositiveMomentCausesTension = src.fPositiveMomentCausesTension;
                        }
                        else {
                            console.log('Expected fPositiveMomentCausesTension of ApexRecord to be a boolean but was ', typeof src.fPositiveMomentCausesTension, src.fPositiveMomentCausesTension)
                        }
                    }
                    if (src.rAlphaAp !== undefined && src.rAlphaAp !== null) {
                        if (typeof src.rAlphaAp === "number" || src.rAlphaAp === 'NaN' || src.rAlphaAp === 'Infinity' || src.rAlphaAp === '-Infinity') {
                            dst.rAlphaAp = AsNum(src.rAlphaAp);
                        }
                        else {
                            console.log('Expected rAlphaAp of ApexRecord to be a number but was ', typeof src.rAlphaAp, src.rAlphaAp)
                        }
                    }
                    if (src.rHAp !== undefined && src.rHAp !== null) {
                        if (typeof src.rHAp === "number" || src.rHAp === 'NaN' || src.rHAp === 'Infinity' || src.rHAp === '-Infinity') {
                            dst.rHAp = AsNum(src.rHAp);
                        }
                        else {
                            console.log('Expected rHAp of ApexRecord to be a number but was ', typeof src.rHAp, src.rHAp)
                        }
                    }
                    if (src.rB !== undefined && src.rB !== null) {
                        if (typeof src.rB === "number" || src.rB === 'NaN' || src.rB === 'Infinity' || src.rB === '-Infinity') {
                            dst.rB = AsNum(src.rB);
                        }
                        else {
                            console.log('Expected rB of ApexRecord to be a number but was ', typeof src.rB, src.rB)
                        }
                    }
                    if (src.rKr !== undefined && src.rKr !== null) {
                        if (typeof src.rKr === "number" || src.rKr === 'NaN' || src.rKr === 'Infinity' || src.rKr === '-Infinity') {
                            dst.rKr = AsNum(src.rKr);
                        }
                        else {
                            console.log('Expected rKr of ApexRecord to be a number but was ', typeof src.rKr, src.rKr)
                        }
                    }
                    if (src.rKl !== undefined && src.rKl !== null) {
                        if (typeof src.rKl === "number" || src.rKl === 'NaN' || src.rKl === 'Infinity' || src.rKl === '-Infinity') {
                            dst.rKl = AsNum(src.rKl);
                        }
                        else {
                            console.log('Expected rKl of ApexRecord to be a number but was ', typeof src.rKl, src.rKl)
                        }
                    }
                    if (src.rKdis !== undefined && src.rKdis !== null) {
                        if (typeof src.rKdis === "number" || src.rKdis === 'NaN' || src.rKdis === 'Infinity' || src.rKdis === '-Infinity') {
                            dst.rKdis = AsNum(src.rKdis);
                        }
                        else {
                            console.log('Expected rKdis of ApexRecord to be a number but was ', typeof src.rKdis, src.rKdis)
                        }
                    }
                    if (src.rKvol !== undefined && src.rKvol !== null) {
                        if (typeof src.rKvol === "number" || src.rKvol === 'NaN' || src.rKvol === 'Infinity' || src.rKvol === '-Infinity') {
                            dst.rKvol = AsNum(src.rKvol);
                        }
                        else {
                            console.log('Expected rKvol of ApexRecord to be a number but was ', typeof src.rKvol, src.rKvol)
                        }
                    }
                    if (src.rKp !== undefined && src.rKp !== null) {
                        if (typeof src.rKp === "number" || src.rKp === 'NaN' || src.rKp === 'Infinity' || src.rKp === '-Infinity') {
                            dst.rKp = AsNum(src.rKp);
                        }
                        else {
                            console.log('Expected rKp of ApexRecord to be a number but was ', typeof src.rKp, src.rKp)
                        }
                    }
                    if (src.rK !== undefined && src.rK !== null) {
                        if (Array.isArray(src.rK)) {
                            for (const [index, element] of src.rK.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.rK.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected rK of ApexRecord[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected rK of ApexRecord to be a array but was ', typeof src.rK, src.rK)
                        }
                    }
                    if (src.rVolumeAp !== undefined && src.rVolumeAp !== null) {
                        if (typeof src.rVolumeAp === "number" || src.rVolumeAp === 'NaN' || src.rVolumeAp === 'Infinity' || src.rVolumeAp === '-Infinity') {
                            dst.rVolumeAp = AsNum(src.rVolumeAp);
                        }
                        else {
                            console.log('Expected rVolumeAp of ApexRecord to be a number but was ', typeof src.rVolumeAp, src.rVolumeAp)
                        }
                    }
                    if (src.rIn !== undefined && src.rIn !== null) {
                        if (typeof src.rIn === "number" || src.rIn === 'NaN' || src.rIn === 'Infinity' || src.rIn === '-Infinity') {
                            dst.rIn = AsNum(src.rIn);
                        }
                        else {
                            console.log('Expected rIn of ApexRecord to be a number but was ', typeof src.rIn, src.rIn)
                        }
                    }
                    if (src.r !== undefined && src.r !== null) {
                        if (typeof src.r === "number" || src.r === 'NaN' || src.r === 'Infinity' || src.r === '-Infinity') {
                            dst.r = AsNum(src.r);
                        }
                        else {
                            console.log('Expected r of ApexRecord to be a number but was ', typeof src.r, src.r)
                        }
                    }
                    return dst;
                }

                static toObject(src: ApexRecord | null | undefined): ApexRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.ApexRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.ApexRecord") {
                        console.error('Expected ng.fem_design.timber_output.ApexRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ApexRecord_json = {
                        fPositiveMomentCausesTension: src.fPositiveMomentCausesTension,
                        rAlphaAp: AsJsonNum(src.rAlphaAp),
                        rHAp: AsJsonNum(src.rHAp),
                        rB: AsJsonNum(src.rB),
                        rKr: AsJsonNum(src.rKr),
                        rKl: AsJsonNum(src.rKl),
                        rKdis: AsJsonNum(src.rKdis),
                        rKvol: AsJsonNum(src.rKvol),
                        rKp: AsJsonNum(src.rKp),
                        rK: new Array<JsonNumber>(),
                        rVolumeAp: AsJsonNum(src.rVolumeAp),
                        rIn: AsJsonNum(src.rIn),
                        r: AsJsonNum(src.r),
                    };
                    if (src.rK !== null) {
                        for (const element of src.rK) {
                            dst.rK.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: ApexRecord_createType) {
                    const dst = new ApexRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fPositiveMomentCausesTension !== undefined) {
                        dst.fPositiveMomentCausesTension = src.fPositiveMomentCausesTension;
                    }
                    if (src.rAlphaAp !== undefined) {
                        dst.rAlphaAp = src.rAlphaAp;
                    }
                    if (src.rHAp !== undefined) {
                        dst.rHAp = src.rHAp;
                    }
                    if (src.rB !== undefined) {
                        dst.rB = src.rB;
                    }
                    if (src.rKr !== undefined) {
                        dst.rKr = src.rKr;
                    }
                    if (src.rKl !== undefined) {
                        dst.rKl = src.rKl;
                    }
                    if (src.rKdis !== undefined) {
                        dst.rKdis = src.rKdis;
                    }
                    if (src.rKvol !== undefined) {
                        dst.rKvol = src.rKvol;
                    }
                    if (src.rKp !== undefined) {
                        dst.rKp = src.rKp;
                    }
                    if (src.rK !== undefined) {
                        dst.rK = src.rK;
                    }
                    if (src.rVolumeAp !== undefined) {
                        dst.rVolumeAp = src.rVolumeAp;
                    }
                    if (src.rIn !== undefined) {
                        dst.rIn = src.rIn;
                    }
                    if (src.r !== undefined) {
                        dst.r = src.r;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ApexRecord();
                    dst.fPositiveMomentCausesTension = this.fPositiveMomentCausesTension;
                    dst.rAlphaAp = this.rAlphaAp;
                    dst.rHAp = this.rHAp;
                    dst.rB = this.rB;
                    dst.rKr = this.rKr;
                    dst.rKl = this.rKl;
                    dst.rKdis = this.rKdis;
                    dst.rKvol = this.rKvol;
                    dst.rKp = this.rKp;
                    dst.rK = this.rK;
                    dst.rVolumeAp = this.rVolumeAp;
                    dst.rIn = this.rIn;
                    dst.r = this.r;
                    return dst;
                }

                deepClone() {
                    const json = ApexRecord.toObject(this);
                    const dst = ApexRecord.fromObject(json);
                    return dst;
                }
            }
            export type IApexRecord = ApexRecord;


            export type TaperRecord_keys = 'rAlphaTap' | 'rH' | 'rB';
            export interface TaperRecord_createType {
                rAlphaTap?: number,
                rH?: number,
                rB?: number,
            }
            export interface TaperRecord_json {
                rAlphaTap?: JsonNumber;
                rH?: JsonNumber;
                rB?: JsonNumber;
            }
            interface TaperRecord_json_in {
                __proto_name?: unknown;
                rAlphaTap?: unknown;
                rH?: unknown;
                rB?: unknown;
            }
            export class TaperRecord {
                __proto_name = "ng.fem_design.timber_output.TaperRecord";
                rAlphaTap: number = 0;
                rH: number = 0;
                rB: number = 0;

                static fromObject(src_unknown: unknown): TaperRecord {
                    const dst = new TaperRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TaperRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TaperRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TaperRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rAlphaTap !== undefined && src.rAlphaTap !== null) {
                        if (typeof src.rAlphaTap === "number" || src.rAlphaTap === 'NaN' || src.rAlphaTap === 'Infinity' || src.rAlphaTap === '-Infinity') {
                            dst.rAlphaTap = AsNum(src.rAlphaTap);
                        }
                        else {
                            console.log('Expected rAlphaTap of TaperRecord to be a number but was ', typeof src.rAlphaTap, src.rAlphaTap)
                        }
                    }
                    if (src.rH !== undefined && src.rH !== null) {
                        if (typeof src.rH === "number" || src.rH === 'NaN' || src.rH === 'Infinity' || src.rH === '-Infinity') {
                            dst.rH = AsNum(src.rH);
                        }
                        else {
                            console.log('Expected rH of TaperRecord to be a number but was ', typeof src.rH, src.rH)
                        }
                    }
                    if (src.rB !== undefined && src.rB !== null) {
                        if (typeof src.rB === "number" || src.rB === 'NaN' || src.rB === 'Infinity' || src.rB === '-Infinity') {
                            dst.rB = AsNum(src.rB);
                        }
                        else {
                            console.log('Expected rB of TaperRecord to be a number but was ', typeof src.rB, src.rB)
                        }
                    }
                    return dst;
                }

                static toObject(src: TaperRecord | null | undefined): TaperRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.TaperRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.TaperRecord") {
                        console.error('Expected ng.fem_design.timber_output.TaperRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : TaperRecord_json = {
                        rAlphaTap: AsJsonNum(src.rAlphaTap),
                        rH: AsJsonNum(src.rH),
                        rB: AsJsonNum(src.rB),
                    };
                    return dst;
                }

                static create(src?: TaperRecord_createType) {
                    const dst = new TaperRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rAlphaTap !== undefined) {
                        dst.rAlphaTap = src.rAlphaTap;
                    }
                    if (src.rH !== undefined) {
                        dst.rH = src.rH;
                    }
                    if (src.rB !== undefined) {
                        dst.rB = src.rB;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TaperRecord();
                    dst.rAlphaTap = this.rAlphaTap;
                    dst.rH = this.rH;
                    dst.rB = this.rB;
                    return dst;
                }

                deepClone() {
                    const json = TaperRecord.toObject(this);
                    const dst = TaperRecord.fromObject(json);
                    return dst;
                }
            }
            export type ITaperRecord = TaperRecord;


            export type FlexBucklingRecord_keys = 'xs' | 'xe' | 'rL0' | 'rI0' | 'rLambda' | 'rLambdaRel' | 'rBetac' | 'rK' | 'rKc';
            export interface FlexBucklingRecord_createType {
                xs?: number,
                xe?: number,
                rL0?: number,
                rI0?: number,
                rLambda?: number,
                rLambdaRel?: number,
                rBetac?: number,
                rK?: number,
                rKc?: number,
            }
            export interface FlexBucklingRecord_json {
                xs?: JsonNumber;
                xe?: JsonNumber;
                rL0?: JsonNumber;
                rI0?: JsonNumber;
                rLambda?: JsonNumber;
                rLambdaRel?: JsonNumber;
                rBetac?: JsonNumber;
                rK?: JsonNumber;
                rKc?: JsonNumber;
            }
            interface FlexBucklingRecord_json_in {
                __proto_name?: unknown;
                xs?: unknown;
                xe?: unknown;
                rL0?: unknown;
                rI0?: unknown;
                rLambda?: unknown;
                rLambdaRel?: unknown;
                rBetac?: unknown;
                rK?: unknown;
                rKc?: unknown;
            }
            export class FlexBucklingRecord {
                __proto_name = "ng.fem_design.timber_output.FlexBucklingRecord";
                xs: number = 0;
                xe: number = 0;
                rL0: number = 0;
                rI0: number = 0;
                rLambda: number = 0;
                rLambdaRel: number = 0;
                rBetac: number = 0;
                rK: number = 0;
                rKc: number = 0;

                static fromObject(src_unknown: unknown): FlexBucklingRecord {
                    const dst = new FlexBucklingRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted FlexBucklingRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as FlexBucklingRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for FlexBucklingRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.xs !== undefined && src.xs !== null) {
                        if (typeof src.xs === "number" || src.xs === 'NaN' || src.xs === 'Infinity' || src.xs === '-Infinity') {
                            dst.xs = AsNum(src.xs);
                        }
                        else {
                            console.log('Expected xs of FlexBucklingRecord to be a number but was ', typeof src.xs, src.xs)
                        }
                    }
                    if (src.xe !== undefined && src.xe !== null) {
                        if (typeof src.xe === "number" || src.xe === 'NaN' || src.xe === 'Infinity' || src.xe === '-Infinity') {
                            dst.xe = AsNum(src.xe);
                        }
                        else {
                            console.log('Expected xe of FlexBucklingRecord to be a number but was ', typeof src.xe, src.xe)
                        }
                    }
                    if (src.rL0 !== undefined && src.rL0 !== null) {
                        if (typeof src.rL0 === "number" || src.rL0 === 'NaN' || src.rL0 === 'Infinity' || src.rL0 === '-Infinity') {
                            dst.rL0 = AsNum(src.rL0);
                        }
                        else {
                            console.log('Expected rL0 of FlexBucklingRecord to be a number but was ', typeof src.rL0, src.rL0)
                        }
                    }
                    if (src.rI0 !== undefined && src.rI0 !== null) {
                        if (typeof src.rI0 === "number" || src.rI0 === 'NaN' || src.rI0 === 'Infinity' || src.rI0 === '-Infinity') {
                            dst.rI0 = AsNum(src.rI0);
                        }
                        else {
                            console.log('Expected rI0 of FlexBucklingRecord to be a number but was ', typeof src.rI0, src.rI0)
                        }
                    }
                    if (src.rLambda !== undefined && src.rLambda !== null) {
                        if (typeof src.rLambda === "number" || src.rLambda === 'NaN' || src.rLambda === 'Infinity' || src.rLambda === '-Infinity') {
                            dst.rLambda = AsNum(src.rLambda);
                        }
                        else {
                            console.log('Expected rLambda of FlexBucklingRecord to be a number but was ', typeof src.rLambda, src.rLambda)
                        }
                    }
                    if (src.rLambdaRel !== undefined && src.rLambdaRel !== null) {
                        if (typeof src.rLambdaRel === "number" || src.rLambdaRel === 'NaN' || src.rLambdaRel === 'Infinity' || src.rLambdaRel === '-Infinity') {
                            dst.rLambdaRel = AsNum(src.rLambdaRel);
                        }
                        else {
                            console.log('Expected rLambdaRel of FlexBucklingRecord to be a number but was ', typeof src.rLambdaRel, src.rLambdaRel)
                        }
                    }
                    if (src.rBetac !== undefined && src.rBetac !== null) {
                        if (typeof src.rBetac === "number" || src.rBetac === 'NaN' || src.rBetac === 'Infinity' || src.rBetac === '-Infinity') {
                            dst.rBetac = AsNum(src.rBetac);
                        }
                        else {
                            console.log('Expected rBetac of FlexBucklingRecord to be a number but was ', typeof src.rBetac, src.rBetac)
                        }
                    }
                    if (src.rK !== undefined && src.rK !== null) {
                        if (typeof src.rK === "number" || src.rK === 'NaN' || src.rK === 'Infinity' || src.rK === '-Infinity') {
                            dst.rK = AsNum(src.rK);
                        }
                        else {
                            console.log('Expected rK of FlexBucklingRecord to be a number but was ', typeof src.rK, src.rK)
                        }
                    }
                    if (src.rKc !== undefined && src.rKc !== null) {
                        if (typeof src.rKc === "number" || src.rKc === 'NaN' || src.rKc === 'Infinity' || src.rKc === '-Infinity') {
                            dst.rKc = AsNum(src.rKc);
                        }
                        else {
                            console.log('Expected rKc of FlexBucklingRecord to be a number but was ', typeof src.rKc, src.rKc)
                        }
                    }
                    return dst;
                }

                static toObject(src: FlexBucklingRecord | null | undefined): FlexBucklingRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.FlexBucklingRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.FlexBucklingRecord") {
                        console.error('Expected ng.fem_design.timber_output.FlexBucklingRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : FlexBucklingRecord_json = {
                        xs: AsJsonNum(src.xs),
                        xe: AsJsonNum(src.xe),
                        rL0: AsJsonNum(src.rL0),
                        rI0: AsJsonNum(src.rI0),
                        rLambda: AsJsonNum(src.rLambda),
                        rLambdaRel: AsJsonNum(src.rLambdaRel),
                        rBetac: AsJsonNum(src.rBetac),
                        rK: AsJsonNum(src.rK),
                        rKc: AsJsonNum(src.rKc),
                    };
                    return dst;
                }

                static create(src?: FlexBucklingRecord_createType) {
                    const dst = new FlexBucklingRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.xs !== undefined) {
                        dst.xs = src.xs;
                    }
                    if (src.xe !== undefined) {
                        dst.xe = src.xe;
                    }
                    if (src.rL0 !== undefined) {
                        dst.rL0 = src.rL0;
                    }
                    if (src.rI0 !== undefined) {
                        dst.rI0 = src.rI0;
                    }
                    if (src.rLambda !== undefined) {
                        dst.rLambda = src.rLambda;
                    }
                    if (src.rLambdaRel !== undefined) {
                        dst.rLambdaRel = src.rLambdaRel;
                    }
                    if (src.rBetac !== undefined) {
                        dst.rBetac = src.rBetac;
                    }
                    if (src.rK !== undefined) {
                        dst.rK = src.rK;
                    }
                    if (src.rKc !== undefined) {
                        dst.rKc = src.rKc;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new FlexBucklingRecord();
                    dst.xs = this.xs;
                    dst.xe = this.xe;
                    dst.rL0 = this.rL0;
                    dst.rI0 = this.rI0;
                    dst.rLambda = this.rLambda;
                    dst.rLambdaRel = this.rLambdaRel;
                    dst.rBetac = this.rBetac;
                    dst.rK = this.rK;
                    dst.rKc = this.rKc;
                    return dst;
                }

                deepClone() {
                    const json = FlexBucklingRecord.toObject(this);
                    const dst = FlexBucklingRecord.fromObject(json);
                    return dst;
                }
            }
            export type IFlexBucklingRecord = FlexBucklingRecord;


            export type TorsBucklingRecord_keys = 'xs' | 'xe' | 'fRelevant' | 'statSys' | 'loadPos';
            export interface TorsBucklingRecord_createType {
                xs?: number,
                xe?: number,
                fRelevant?: boolean,
                statSys?: ng.fem_design.steel_output.StatSys,
                loadPos?: ng.fem_design.steel_output.Alignment,
            }
            export interface TorsBucklingRecord_json {
                xs?: JsonNumber;
                xe?: JsonNumber;
                fRelevant?: boolean;
                statSys?: string;
                loadPos?: string;
            }
            interface TorsBucklingRecord_json_in {
                __proto_name?: unknown;
                xs?: unknown;
                xe?: unknown;
                fRelevant?: unknown;
                statSys?: unknown;
                loadPos?: unknown;
            }
            export class TorsBucklingRecord {
                __proto_name = "ng.fem_design.timber_output.TorsBucklingRecord";
                xs: number = 0;
                xe: number = 0;
                fRelevant: boolean = false;
                statSys: ng.fem_design.steel_output.StatSys = ng.fem_design.steel_output.StatSys.STAT_SYS_SIMPLE_SUPPORTED;
                loadPos: ng.fem_design.steel_output.Alignment = ng.fem_design.steel_output.Alignment.ALIGNMENT_TOP;

                static fromObject(src_unknown: unknown): TorsBucklingRecord {
                    const dst = new TorsBucklingRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted TorsBucklingRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as TorsBucklingRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for TorsBucklingRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.xs !== undefined && src.xs !== null) {
                        if (typeof src.xs === "number" || src.xs === 'NaN' || src.xs === 'Infinity' || src.xs === '-Infinity') {
                            dst.xs = AsNum(src.xs);
                        }
                        else {
                            console.log('Expected xs of TorsBucklingRecord to be a number but was ', typeof src.xs, src.xs)
                        }
                    }
                    if (src.xe !== undefined && src.xe !== null) {
                        if (typeof src.xe === "number" || src.xe === 'NaN' || src.xe === 'Infinity' || src.xe === '-Infinity') {
                            dst.xe = AsNum(src.xe);
                        }
                        else {
                            console.log('Expected xe of TorsBucklingRecord to be a number but was ', typeof src.xe, src.xe)
                        }
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of TorsBucklingRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.statSys !== undefined && src.statSys !== null) {
                        dst.statSys = ng.fem_design.steel_output.StatSys_FromObject(src.statSys);
                    }
                    if (src.loadPos !== undefined && src.loadPos !== null) {
                        dst.loadPos = ng.fem_design.steel_output.Alignment_FromObject(src.loadPos);
                    }
                    return dst;
                }

                static toObject(src: TorsBucklingRecord | null | undefined): TorsBucklingRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.TorsBucklingRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.TorsBucklingRecord") {
                        console.error('Expected ng.fem_design.timber_output.TorsBucklingRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const statSys_obj = ng.fem_design.steel_output.StatSys_ToObject(src.statSys);
                    if(statSys_obj === null) return null;

                    const loadPos_obj = ng.fem_design.steel_output.Alignment_ToObject(src.loadPos);
                    if(loadPos_obj === null) return null;

                    const dst : TorsBucklingRecord_json = {
                        xs: AsJsonNum(src.xs),
                        xe: AsJsonNum(src.xe),
                        fRelevant: src.fRelevant,
                        statSys: statSys_obj,
                        loadPos: loadPos_obj,
                    };
                    return dst;
                }

                static create(src?: TorsBucklingRecord_createType) {
                    const dst = new TorsBucklingRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.xs !== undefined) {
                        dst.xs = src.xs;
                    }
                    if (src.xe !== undefined) {
                        dst.xe = src.xe;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.statSys !== undefined) {
                        dst.statSys = src.statSys;
                    }
                    if (src.loadPos !== undefined) {
                        dst.loadPos = src.loadPos;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new TorsBucklingRecord();
                    dst.xs = this.xs;
                    dst.xe = this.xe;
                    dst.fRelevant = this.fRelevant;
                    dst.statSys = this.statSys;
                    dst.loadPos = this.loadPos;
                    return dst;
                }

                deepClone() {
                    const json = TorsBucklingRecord.toObject(this);
                    const dst = TorsBucklingRecord.fromObject(json);
                    return dst;
                }
            }
            export type ITorsBucklingRecord = TorsBucklingRecord;


            export type BarExtraDataRecord_keys = 'sectionDistanceStart' | 'sectionGeometricalData' | 'km' | 'ft0k' | 'fm1k' | 'fm2k' | 'flexuralBucklingData1' | 'flexuralBucklingData2' | 'torsionalBucklingData' | 'taperData' | 'apexData';
            export interface BarExtraDataRecord_createType {
                sectionDistanceStart?: number,
                sectionGeometricalData?: ng.fem_design.timber_output.SectionGeomData | null,
                km?: number,
                ft0k?: number,
                fm1k?: number,
                fm2k?: number,
                flexuralBucklingData1?: ng.fem_design.timber_output.FlexBucklingRecord | null,
                flexuralBucklingData2?: ng.fem_design.timber_output.FlexBucklingRecord | null,
                torsionalBucklingData?: ng.fem_design.timber_output.TorsBucklingRecord | null,
                taperData?: ng.fem_design.timber_output.TaperRecord | null,
                apexData?: ng.fem_design.timber_output.ApexRecord | null,
            }
            export interface BarExtraDataRecord_json {
                sectionDistanceStart?: JsonNumber;
                sectionGeometricalData?: ng.fem_design.timber_output.SectionGeomData_json;
                km?: JsonNumber;
                ft0k?: JsonNumber;
                fm1k?: JsonNumber;
                fm2k?: JsonNumber;
                flexuralBucklingData1?: ng.fem_design.timber_output.FlexBucklingRecord_json;
                flexuralBucklingData2?: ng.fem_design.timber_output.FlexBucklingRecord_json;
                torsionalBucklingData?: ng.fem_design.timber_output.TorsBucklingRecord_json;
                taperData?: ng.fem_design.timber_output.TaperRecord_json;
                apexData?: ng.fem_design.timber_output.ApexRecord_json;
            }
            interface BarExtraDataRecord_json_in {
                __proto_name?: unknown;
                sectionDistanceStart?: unknown;
                sectionGeometricalData?: unknown;
                km?: unknown;
                ft0k?: unknown;
                fm1k?: unknown;
                fm2k?: unknown;
                flexuralBucklingData1?: unknown;
                flexuralBucklingData2?: unknown;
                torsionalBucklingData?: unknown;
                taperData?: unknown;
                apexData?: unknown;
            }
            export class BarExtraDataRecord {
                __proto_name = "ng.fem_design.timber_output.BarExtraDataRecord";
                sectionDistanceStart: number = 0;
                sectionGeometricalData: ng.fem_design.timber_output.SectionGeomData | null = null;
                km: number = 0;
                ft0k: number = 0;
                fm1k: number = 0;
                fm2k: number = 0;
                flexuralBucklingData1: ng.fem_design.timber_output.FlexBucklingRecord | null = null;
                flexuralBucklingData2: ng.fem_design.timber_output.FlexBucklingRecord | null = null;
                torsionalBucklingData: ng.fem_design.timber_output.TorsBucklingRecord | null = null;
                taperData: ng.fem_design.timber_output.TaperRecord | null = null;
                apexData: ng.fem_design.timber_output.ApexRecord | null = null;

                static fromObject(src_unknown: unknown): BarExtraDataRecord {
                    const dst = new BarExtraDataRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BarExtraDataRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BarExtraDataRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BarExtraDataRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sectionDistanceStart !== undefined && src.sectionDistanceStart !== null) {
                        if (typeof src.sectionDistanceStart === "number" || src.sectionDistanceStart === 'NaN' || src.sectionDistanceStart === 'Infinity' || src.sectionDistanceStart === '-Infinity') {
                            dst.sectionDistanceStart = AsNum(src.sectionDistanceStart);
                        }
                        else {
                            console.log('Expected sectionDistanceStart of BarExtraDataRecord to be a number but was ', typeof src.sectionDistanceStart, src.sectionDistanceStart)
                        }
                    }
                    if (src.sectionGeometricalData !== undefined && src.sectionGeometricalData !== null) {
                        dst.sectionGeometricalData = ng.fem_design.timber_output.SectionGeomData.fromObject(src.sectionGeometricalData);
                    }
                    if (src.km !== undefined && src.km !== null) {
                        if (typeof src.km === "number" || src.km === 'NaN' || src.km === 'Infinity' || src.km === '-Infinity') {
                            dst.km = AsNum(src.km);
                        }
                        else {
                            console.log('Expected km of BarExtraDataRecord to be a number but was ', typeof src.km, src.km)
                        }
                    }
                    if (src.ft0k !== undefined && src.ft0k !== null) {
                        if (typeof src.ft0k === "number" || src.ft0k === 'NaN' || src.ft0k === 'Infinity' || src.ft0k === '-Infinity') {
                            dst.ft0k = AsNum(src.ft0k);
                        }
                        else {
                            console.log('Expected ft0k of BarExtraDataRecord to be a number but was ', typeof src.ft0k, src.ft0k)
                        }
                    }
                    if (src.fm1k !== undefined && src.fm1k !== null) {
                        if (typeof src.fm1k === "number" || src.fm1k === 'NaN' || src.fm1k === 'Infinity' || src.fm1k === '-Infinity') {
                            dst.fm1k = AsNum(src.fm1k);
                        }
                        else {
                            console.log('Expected fm1k of BarExtraDataRecord to be a number but was ', typeof src.fm1k, src.fm1k)
                        }
                    }
                    if (src.fm2k !== undefined && src.fm2k !== null) {
                        if (typeof src.fm2k === "number" || src.fm2k === 'NaN' || src.fm2k === 'Infinity' || src.fm2k === '-Infinity') {
                            dst.fm2k = AsNum(src.fm2k);
                        }
                        else {
                            console.log('Expected fm2k of BarExtraDataRecord to be a number but was ', typeof src.fm2k, src.fm2k)
                        }
                    }
                    if (src.flexuralBucklingData1 !== undefined && src.flexuralBucklingData1 !== null) {
                        dst.flexuralBucklingData1 = ng.fem_design.timber_output.FlexBucklingRecord.fromObject(src.flexuralBucklingData1);
                    }
                    if (src.flexuralBucklingData2 !== undefined && src.flexuralBucklingData2 !== null) {
                        dst.flexuralBucklingData2 = ng.fem_design.timber_output.FlexBucklingRecord.fromObject(src.flexuralBucklingData2);
                    }
                    if (src.torsionalBucklingData !== undefined && src.torsionalBucklingData !== null) {
                        dst.torsionalBucklingData = ng.fem_design.timber_output.TorsBucklingRecord.fromObject(src.torsionalBucklingData);
                    }
                    if (src.taperData !== undefined && src.taperData !== null) {
                        dst.taperData = ng.fem_design.timber_output.TaperRecord.fromObject(src.taperData);
                    }
                    if (src.apexData !== undefined && src.apexData !== null) {
                        dst.apexData = ng.fem_design.timber_output.ApexRecord.fromObject(src.apexData);
                    }
                    return dst;
                }

                static toObject(src: BarExtraDataRecord | null | undefined): BarExtraDataRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.BarExtraDataRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.BarExtraDataRecord") {
                        console.error('Expected ng.fem_design.timber_output.BarExtraDataRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BarExtraDataRecord_json = {
                        sectionDistanceStart: AsJsonNum(src.sectionDistanceStart),
                        km: AsJsonNum(src.km),
                        ft0k: AsJsonNum(src.ft0k),
                        fm1k: AsJsonNum(src.fm1k),
                        fm2k: AsJsonNum(src.fm2k),
                    };
                    if(src.sectionGeometricalData !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionGeomData.toObject(src.sectionGeometricalData);
                        if(parsed === null) return null;
                        dst.sectionGeometricalData = parsed;
                    }
                    if(src.flexuralBucklingData1 !== null)
                    {
                        const parsed = ng.fem_design.timber_output.FlexBucklingRecord.toObject(src.flexuralBucklingData1);
                        if(parsed === null) return null;
                        dst.flexuralBucklingData1 = parsed;
                    }
                    if(src.flexuralBucklingData2 !== null)
                    {
                        const parsed = ng.fem_design.timber_output.FlexBucklingRecord.toObject(src.flexuralBucklingData2);
                        if(parsed === null) return null;
                        dst.flexuralBucklingData2 = parsed;
                    }
                    if(src.torsionalBucklingData !== null)
                    {
                        const parsed = ng.fem_design.timber_output.TorsBucklingRecord.toObject(src.torsionalBucklingData);
                        if(parsed === null) return null;
                        dst.torsionalBucklingData = parsed;
                    }
                    if(src.taperData !== null)
                    {
                        const parsed = ng.fem_design.timber_output.TaperRecord.toObject(src.taperData);
                        if(parsed === null) return null;
                        dst.taperData = parsed;
                    }
                    if(src.apexData !== null)
                    {
                        const parsed = ng.fem_design.timber_output.ApexRecord.toObject(src.apexData);
                        if(parsed === null) return null;
                        dst.apexData = parsed;
                    }
                    return dst;
                }

                static create(src?: BarExtraDataRecord_createType) {
                    const dst = new BarExtraDataRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sectionDistanceStart !== undefined) {
                        dst.sectionDistanceStart = src.sectionDistanceStart;
                    }
                    if (src.sectionGeometricalData !== undefined) {
                        dst.sectionGeometricalData = src.sectionGeometricalData;
                    }
                    if (src.km !== undefined) {
                        dst.km = src.km;
                    }
                    if (src.ft0k !== undefined) {
                        dst.ft0k = src.ft0k;
                    }
                    if (src.fm1k !== undefined) {
                        dst.fm1k = src.fm1k;
                    }
                    if (src.fm2k !== undefined) {
                        dst.fm2k = src.fm2k;
                    }
                    if (src.flexuralBucklingData1 !== undefined) {
                        dst.flexuralBucklingData1 = src.flexuralBucklingData1;
                    }
                    if (src.flexuralBucklingData2 !== undefined) {
                        dst.flexuralBucklingData2 = src.flexuralBucklingData2;
                    }
                    if (src.torsionalBucklingData !== undefined) {
                        dst.torsionalBucklingData = src.torsionalBucklingData;
                    }
                    if (src.taperData !== undefined) {
                        dst.taperData = src.taperData;
                    }
                    if (src.apexData !== undefined) {
                        dst.apexData = src.apexData;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BarExtraDataRecord();
                    dst.sectionDistanceStart = this.sectionDistanceStart;
                    dst.sectionGeometricalData = this.sectionGeometricalData;
                    dst.km = this.km;
                    dst.ft0k = this.ft0k;
                    dst.fm1k = this.fm1k;
                    dst.fm2k = this.fm2k;
                    dst.flexuralBucklingData1 = this.flexuralBucklingData1;
                    dst.flexuralBucklingData2 = this.flexuralBucklingData2;
                    dst.torsionalBucklingData = this.torsionalBucklingData;
                    dst.taperData = this.taperData;
                    dst.apexData = this.apexData;
                    return dst;
                }

                deepClone() {
                    const json = BarExtraDataRecord.toObject(this);
                    const dst = BarExtraDataRecord.fromObject(json);
                    return dst;
                }
            }
            export type IBarExtraDataRecord = BarExtraDataRecord;


            export type CombDesignStrengthRecord_keys = 'rFt0d' | 'rFt90d' | 'rFc0d' | 'rFc90d' | 'rFm1d' | 'rFm2d' | 'rFvd';
            export interface CombDesignStrengthRecord_createType {
                rFt0d?: number,
                rFt90d?: number,
                rFc0d?: number,
                rFc90d?: number,
                rFm1d?: number,
                rFm2d?: number,
                rFvd?: number,
            }
            export interface CombDesignStrengthRecord_json {
                rFt0d?: JsonNumber;
                rFt90d?: JsonNumber;
                rFc0d?: JsonNumber;
                rFc90d?: JsonNumber;
                rFm1d?: JsonNumber;
                rFm2d?: JsonNumber;
                rFvd?: JsonNumber;
            }
            interface CombDesignStrengthRecord_json_in {
                __proto_name?: unknown;
                rFt0d?: unknown;
                rFt90d?: unknown;
                rFc0d?: unknown;
                rFc90d?: unknown;
                rFm1d?: unknown;
                rFm2d?: unknown;
                rFvd?: unknown;
            }
            export class CombDesignStrengthRecord {
                __proto_name = "ng.fem_design.timber_output.CombDesignStrengthRecord";
                rFt0d: number = 0;
                rFt90d: number = 0;
                rFc0d: number = 0;
                rFc90d: number = 0;
                rFm1d: number = 0;
                rFm2d: number = 0;
                rFvd: number = 0;

                static fromObject(src_unknown: unknown): CombDesignStrengthRecord {
                    const dst = new CombDesignStrengthRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CombDesignStrengthRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CombDesignStrengthRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CombDesignStrengthRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rFt0d !== undefined && src.rFt0d !== null) {
                        if (typeof src.rFt0d === "number" || src.rFt0d === 'NaN' || src.rFt0d === 'Infinity' || src.rFt0d === '-Infinity') {
                            dst.rFt0d = AsNum(src.rFt0d);
                        }
                        else {
                            console.log('Expected rFt0d of CombDesignStrengthRecord to be a number but was ', typeof src.rFt0d, src.rFt0d)
                        }
                    }
                    if (src.rFt90d !== undefined && src.rFt90d !== null) {
                        if (typeof src.rFt90d === "number" || src.rFt90d === 'NaN' || src.rFt90d === 'Infinity' || src.rFt90d === '-Infinity') {
                            dst.rFt90d = AsNum(src.rFt90d);
                        }
                        else {
                            console.log('Expected rFt90d of CombDesignStrengthRecord to be a number but was ', typeof src.rFt90d, src.rFt90d)
                        }
                    }
                    if (src.rFc0d !== undefined && src.rFc0d !== null) {
                        if (typeof src.rFc0d === "number" || src.rFc0d === 'NaN' || src.rFc0d === 'Infinity' || src.rFc0d === '-Infinity') {
                            dst.rFc0d = AsNum(src.rFc0d);
                        }
                        else {
                            console.log('Expected rFc0d of CombDesignStrengthRecord to be a number but was ', typeof src.rFc0d, src.rFc0d)
                        }
                    }
                    if (src.rFc90d !== undefined && src.rFc90d !== null) {
                        if (typeof src.rFc90d === "number" || src.rFc90d === 'NaN' || src.rFc90d === 'Infinity' || src.rFc90d === '-Infinity') {
                            dst.rFc90d = AsNum(src.rFc90d);
                        }
                        else {
                            console.log('Expected rFc90d of CombDesignStrengthRecord to be a number but was ', typeof src.rFc90d, src.rFc90d)
                        }
                    }
                    if (src.rFm1d !== undefined && src.rFm1d !== null) {
                        if (typeof src.rFm1d === "number" || src.rFm1d === 'NaN' || src.rFm1d === 'Infinity' || src.rFm1d === '-Infinity') {
                            dst.rFm1d = AsNum(src.rFm1d);
                        }
                        else {
                            console.log('Expected rFm1d of CombDesignStrengthRecord to be a number but was ', typeof src.rFm1d, src.rFm1d)
                        }
                    }
                    if (src.rFm2d !== undefined && src.rFm2d !== null) {
                        if (typeof src.rFm2d === "number" || src.rFm2d === 'NaN' || src.rFm2d === 'Infinity' || src.rFm2d === '-Infinity') {
                            dst.rFm2d = AsNum(src.rFm2d);
                        }
                        else {
                            console.log('Expected rFm2d of CombDesignStrengthRecord to be a number but was ', typeof src.rFm2d, src.rFm2d)
                        }
                    }
                    if (src.rFvd !== undefined && src.rFvd !== null) {
                        if (typeof src.rFvd === "number" || src.rFvd === 'NaN' || src.rFvd === 'Infinity' || src.rFvd === '-Infinity') {
                            dst.rFvd = AsNum(src.rFvd);
                        }
                        else {
                            console.log('Expected rFvd of CombDesignStrengthRecord to be a number but was ', typeof src.rFvd, src.rFvd)
                        }
                    }
                    return dst;
                }

                static toObject(src: CombDesignStrengthRecord | null | undefined): CombDesignStrengthRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.CombDesignStrengthRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.CombDesignStrengthRecord") {
                        console.error('Expected ng.fem_design.timber_output.CombDesignStrengthRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CombDesignStrengthRecord_json = {
                        rFt0d: AsJsonNum(src.rFt0d),
                        rFt90d: AsJsonNum(src.rFt90d),
                        rFc0d: AsJsonNum(src.rFc0d),
                        rFc90d: AsJsonNum(src.rFc90d),
                        rFm1d: AsJsonNum(src.rFm1d),
                        rFm2d: AsJsonNum(src.rFm2d),
                        rFvd: AsJsonNum(src.rFvd),
                    };
                    return dst;
                }

                static create(src?: CombDesignStrengthRecord_createType) {
                    const dst = new CombDesignStrengthRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rFt0d !== undefined) {
                        dst.rFt0d = src.rFt0d;
                    }
                    if (src.rFt90d !== undefined) {
                        dst.rFt90d = src.rFt90d;
                    }
                    if (src.rFc0d !== undefined) {
                        dst.rFc0d = src.rFc0d;
                    }
                    if (src.rFc90d !== undefined) {
                        dst.rFc90d = src.rFc90d;
                    }
                    if (src.rFm1d !== undefined) {
                        dst.rFm1d = src.rFm1d;
                    }
                    if (src.rFm2d !== undefined) {
                        dst.rFm2d = src.rFm2d;
                    }
                    if (src.rFvd !== undefined) {
                        dst.rFvd = src.rFvd;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CombDesignStrengthRecord();
                    dst.rFt0d = this.rFt0d;
                    dst.rFt90d = this.rFt90d;
                    dst.rFc0d = this.rFc0d;
                    dst.rFc90d = this.rFc90d;
                    dst.rFm1d = this.rFm1d;
                    dst.rFm2d = this.rFm2d;
                    dst.rFvd = this.rFvd;
                    return dst;
                }

                deepClone() {
                    const json = CombDesignStrengthRecord.toObject(this);
                    const dst = CombDesignStrengthRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICombDesignStrengthRecord = CombDesignStrengthRecord;


            export type CombTorsBucklingRecord_keys = 'fRelevant' | 'statSys' | 'loadPos' | 'rMMax' | 'rM' | 'rBeta' | 'rH' | 'rLef' | 'rSigmamcrit' | 'rLambdarelm' | 'rKcrit';
            export interface CombTorsBucklingRecord_createType {
                fRelevant?: boolean,
                statSys?: ng.fem_design.steel_output.StatSys,
                loadPos?: ng.fem_design.steel_output.Alignment,
                rMMax?: number,
                rM?: number[],
                rBeta?: number,
                rH?: number,
                rLef?: number,
                rSigmamcrit?: number,
                rLambdarelm?: number,
                rKcrit?: number,
            }
            export interface CombTorsBucklingRecord_json {
                fRelevant?: boolean;
                statSys?: string;
                loadPos?: string;
                rMMax?: JsonNumber;
                rM: JsonNumber[];
                rBeta?: JsonNumber;
                rH?: JsonNumber;
                rLef?: JsonNumber;
                rSigmamcrit?: JsonNumber;
                rLambdarelm?: JsonNumber;
                rKcrit?: JsonNumber;
            }
            interface CombTorsBucklingRecord_json_in {
                __proto_name?: unknown;
                fRelevant?: unknown;
                statSys?: unknown;
                loadPos?: unknown;
                rMMax?: unknown;
                rM?: unknown;
                rBeta?: unknown;
                rH?: unknown;
                rLef?: unknown;
                rSigmamcrit?: unknown;
                rLambdarelm?: unknown;
                rKcrit?: unknown;
            }
            export class CombTorsBucklingRecord {
                __proto_name = "ng.fem_design.timber_output.CombTorsBucklingRecord";
                fRelevant: boolean = false;
                statSys: ng.fem_design.steel_output.StatSys = ng.fem_design.steel_output.StatSys.STAT_SYS_SIMPLE_SUPPORTED;
                loadPos: ng.fem_design.steel_output.Alignment = ng.fem_design.steel_output.Alignment.ALIGNMENT_TOP;
                rMMax: number = 0;
                rM: number[] = [];
                rBeta: number = 0;
                rH: number = 0;
                rLef: number = 0;
                rSigmamcrit: number = 0;
                rLambdarelm: number = 0;
                rKcrit: number = 0;

                static fromObject(src_unknown: unknown): CombTorsBucklingRecord {
                    const dst = new CombTorsBucklingRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CombTorsBucklingRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CombTorsBucklingRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CombTorsBucklingRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of CombTorsBucklingRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.statSys !== undefined && src.statSys !== null) {
                        dst.statSys = ng.fem_design.steel_output.StatSys_FromObject(src.statSys);
                    }
                    if (src.loadPos !== undefined && src.loadPos !== null) {
                        dst.loadPos = ng.fem_design.steel_output.Alignment_FromObject(src.loadPos);
                    }
                    if (src.rMMax !== undefined && src.rMMax !== null) {
                        if (typeof src.rMMax === "number" || src.rMMax === 'NaN' || src.rMMax === 'Infinity' || src.rMMax === '-Infinity') {
                            dst.rMMax = AsNum(src.rMMax);
                        }
                        else {
                            console.log('Expected rMMax of CombTorsBucklingRecord to be a number but was ', typeof src.rMMax, src.rMMax)
                        }
                    }
                    if (src.rM !== undefined && src.rM !== null) {
                        if (Array.isArray(src.rM)) {
                            for (const [index, element] of src.rM.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.rM.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected rM of CombTorsBucklingRecord[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected rM of CombTorsBucklingRecord to be a array but was ', typeof src.rM, src.rM)
                        }
                    }
                    if (src.rBeta !== undefined && src.rBeta !== null) {
                        if (typeof src.rBeta === "number" || src.rBeta === 'NaN' || src.rBeta === 'Infinity' || src.rBeta === '-Infinity') {
                            dst.rBeta = AsNum(src.rBeta);
                        }
                        else {
                            console.log('Expected rBeta of CombTorsBucklingRecord to be a number but was ', typeof src.rBeta, src.rBeta)
                        }
                    }
                    if (src.rH !== undefined && src.rH !== null) {
                        if (typeof src.rH === "number" || src.rH === 'NaN' || src.rH === 'Infinity' || src.rH === '-Infinity') {
                            dst.rH = AsNum(src.rH);
                        }
                        else {
                            console.log('Expected rH of CombTorsBucklingRecord to be a number but was ', typeof src.rH, src.rH)
                        }
                    }
                    if (src.rLef !== undefined && src.rLef !== null) {
                        if (typeof src.rLef === "number" || src.rLef === 'NaN' || src.rLef === 'Infinity' || src.rLef === '-Infinity') {
                            dst.rLef = AsNum(src.rLef);
                        }
                        else {
                            console.log('Expected rLef of CombTorsBucklingRecord to be a number but was ', typeof src.rLef, src.rLef)
                        }
                    }
                    if (src.rSigmamcrit !== undefined && src.rSigmamcrit !== null) {
                        if (typeof src.rSigmamcrit === "number" || src.rSigmamcrit === 'NaN' || src.rSigmamcrit === 'Infinity' || src.rSigmamcrit === '-Infinity') {
                            dst.rSigmamcrit = AsNum(src.rSigmamcrit);
                        }
                        else {
                            console.log('Expected rSigmamcrit of CombTorsBucklingRecord to be a number but was ', typeof src.rSigmamcrit, src.rSigmamcrit)
                        }
                    }
                    if (src.rLambdarelm !== undefined && src.rLambdarelm !== null) {
                        if (typeof src.rLambdarelm === "number" || src.rLambdarelm === 'NaN' || src.rLambdarelm === 'Infinity' || src.rLambdarelm === '-Infinity') {
                            dst.rLambdarelm = AsNum(src.rLambdarelm);
                        }
                        else {
                            console.log('Expected rLambdarelm of CombTorsBucklingRecord to be a number but was ', typeof src.rLambdarelm, src.rLambdarelm)
                        }
                    }
                    if (src.rKcrit !== undefined && src.rKcrit !== null) {
                        if (typeof src.rKcrit === "number" || src.rKcrit === 'NaN' || src.rKcrit === 'Infinity' || src.rKcrit === '-Infinity') {
                            dst.rKcrit = AsNum(src.rKcrit);
                        }
                        else {
                            console.log('Expected rKcrit of CombTorsBucklingRecord to be a number but was ', typeof src.rKcrit, src.rKcrit)
                        }
                    }
                    return dst;
                }

                static toObject(src: CombTorsBucklingRecord | null | undefined): CombTorsBucklingRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.CombTorsBucklingRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.CombTorsBucklingRecord") {
                        console.error('Expected ng.fem_design.timber_output.CombTorsBucklingRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const statSys_obj = ng.fem_design.steel_output.StatSys_ToObject(src.statSys);
                    if(statSys_obj === null) return null;

                    const loadPos_obj = ng.fem_design.steel_output.Alignment_ToObject(src.loadPos);
                    if(loadPos_obj === null) return null;

                    const dst : CombTorsBucklingRecord_json = {
                        fRelevant: src.fRelevant,
                        statSys: statSys_obj,
                        loadPos: loadPos_obj,
                        rMMax: AsJsonNum(src.rMMax),
                        rM: new Array<JsonNumber>(),
                        rBeta: AsJsonNum(src.rBeta),
                        rH: AsJsonNum(src.rH),
                        rLef: AsJsonNum(src.rLef),
                        rSigmamcrit: AsJsonNum(src.rSigmamcrit),
                        rLambdarelm: AsJsonNum(src.rLambdarelm),
                        rKcrit: AsJsonNum(src.rKcrit),
                    };
                    if (src.rM !== null) {
                        for (const element of src.rM) {
                            dst.rM.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: CombTorsBucklingRecord_createType) {
                    const dst = new CombTorsBucklingRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.statSys !== undefined) {
                        dst.statSys = src.statSys;
                    }
                    if (src.loadPos !== undefined) {
                        dst.loadPos = src.loadPos;
                    }
                    if (src.rMMax !== undefined) {
                        dst.rMMax = src.rMMax;
                    }
                    if (src.rM !== undefined) {
                        dst.rM = src.rM;
                    }
                    if (src.rBeta !== undefined) {
                        dst.rBeta = src.rBeta;
                    }
                    if (src.rH !== undefined) {
                        dst.rH = src.rH;
                    }
                    if (src.rLef !== undefined) {
                        dst.rLef = src.rLef;
                    }
                    if (src.rSigmamcrit !== undefined) {
                        dst.rSigmamcrit = src.rSigmamcrit;
                    }
                    if (src.rLambdarelm !== undefined) {
                        dst.rLambdarelm = src.rLambdarelm;
                    }
                    if (src.rKcrit !== undefined) {
                        dst.rKcrit = src.rKcrit;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CombTorsBucklingRecord();
                    dst.fRelevant = this.fRelevant;
                    dst.statSys = this.statSys;
                    dst.loadPos = this.loadPos;
                    dst.rMMax = this.rMMax;
                    dst.rM = this.rM;
                    dst.rBeta = this.rBeta;
                    dst.rH = this.rH;
                    dst.rLef = this.rLef;
                    dst.rSigmamcrit = this.rSigmamcrit;
                    dst.rLambdarelm = this.rLambdarelm;
                    dst.rKcrit = this.rKcrit;
                    return dst;
                }

                deepClone() {
                    const json = CombTorsBucklingRecord.toObject(this);
                    const dst = CombTorsBucklingRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICombTorsBucklingRecord = CombTorsBucklingRecord;


            export type CombDesignSectionRecord_keys = 'designStregthData' | 'torsionalBucklingCalculationResults';
            export interface CombDesignSectionRecord_createType {
                designStregthData?: ng.fem_design.timber_output.CombDesignStrengthRecord | null,
                torsionalBucklingCalculationResults?: ng.fem_design.timber_output.CombTorsBucklingRecord | null,
            }
            export interface CombDesignSectionRecord_json {
                designStregthData?: ng.fem_design.timber_output.CombDesignStrengthRecord_json;
                torsionalBucklingCalculationResults?: ng.fem_design.timber_output.CombTorsBucklingRecord_json;
            }
            interface CombDesignSectionRecord_json_in {
                __proto_name?: unknown;
                designStregthData?: unknown;
                torsionalBucklingCalculationResults?: unknown;
            }
            export class CombDesignSectionRecord {
                __proto_name = "ng.fem_design.timber_output.CombDesignSectionRecord";
                designStregthData: ng.fem_design.timber_output.CombDesignStrengthRecord | null = null;
                torsionalBucklingCalculationResults: ng.fem_design.timber_output.CombTorsBucklingRecord | null = null;

                static fromObject(src_unknown: unknown): CombDesignSectionRecord {
                    const dst = new CombDesignSectionRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CombDesignSectionRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CombDesignSectionRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CombDesignSectionRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.designStregthData !== undefined && src.designStregthData !== null) {
                        dst.designStregthData = ng.fem_design.timber_output.CombDesignStrengthRecord.fromObject(src.designStregthData);
                    }
                    if (src.torsionalBucklingCalculationResults !== undefined && src.torsionalBucklingCalculationResults !== null) {
                        dst.torsionalBucklingCalculationResults = ng.fem_design.timber_output.CombTorsBucklingRecord.fromObject(src.torsionalBucklingCalculationResults);
                    }
                    return dst;
                }

                static toObject(src: CombDesignSectionRecord | null | undefined): CombDesignSectionRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.CombDesignSectionRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.CombDesignSectionRecord") {
                        console.error('Expected ng.fem_design.timber_output.CombDesignSectionRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CombDesignSectionRecord_json = {
                    };
                    if(src.designStregthData !== null)
                    {
                        const parsed = ng.fem_design.timber_output.CombDesignStrengthRecord.toObject(src.designStregthData);
                        if(parsed === null) return null;
                        dst.designStregthData = parsed;
                    }
                    if(src.torsionalBucklingCalculationResults !== null)
                    {
                        const parsed = ng.fem_design.timber_output.CombTorsBucklingRecord.toObject(src.torsionalBucklingCalculationResults);
                        if(parsed === null) return null;
                        dst.torsionalBucklingCalculationResults = parsed;
                    }
                    return dst;
                }

                static create(src?: CombDesignSectionRecord_createType) {
                    const dst = new CombDesignSectionRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.designStregthData !== undefined) {
                        dst.designStregthData = src.designStregthData;
                    }
                    if (src.torsionalBucklingCalculationResults !== undefined) {
                        dst.torsionalBucklingCalculationResults = src.torsionalBucklingCalculationResults;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CombDesignSectionRecord();
                    dst.designStregthData = this.designStregthData;
                    dst.torsionalBucklingCalculationResults = this.torsionalBucklingCalculationResults;
                    return dst;
                }

                deepClone() {
                    const json = CombDesignSectionRecord.toObject(this);
                    const dst = CombDesignSectionRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICombDesignSectionRecord = CombDesignSectionRecord;


            export type SectionDesignCalcRecord_keys = 'sectionDistanceFromBarStartPoint' | 'ulilization' | 'idGmaxComb' | 'sectionAlignment' | 'sigmad0' | 'sigmayd' | 'sigmaz0' | 'tensionResults' | 'compressionResults' | 'shearResults' | 'flexuralBucklingResults1' | 'flexuralBucklingResults2' | 'torsionalBucklingResults' | 'taperResults' | 'apexResults';
            export interface SectionDesignCalcRecord_createType {
                sectionDistanceFromBarStartPoint?: number,
                ulilization?: number,
                idGmaxComb?: number,
                sectionAlignment?: ng.fem_design.steel_output.Alignment,
                sigmad0?: number,
                sigmayd?: number,
                sigmaz0?: number,
                tensionResults?: ng.fem_design.timber_output.SectionTensionResultRecord | null,
                compressionResults?: ng.fem_design.timber_output.SectionCompressionResultRecord | null,
                shearResults?: ng.fem_design.timber_output.SectionShearResultRecord | null,
                flexuralBucklingResults1?: ng.fem_design.timber_output.SectionFlexBucklingResultRecord | null,
                flexuralBucklingResults2?: ng.fem_design.timber_output.SectionFlexBucklingResultRecord | null,
                torsionalBucklingResults?: ng.fem_design.timber_output.SectionTorsBucklingResultRecord | null,
                taperResults?: ng.fem_design.timber_output.SectionTaperResultRecord | null,
                apexResults?: ng.fem_design.timber_output.SectionApexResultRecord | null,
            }
            export interface SectionDesignCalcRecord_json {
                sectionDistanceFromBarStartPoint?: JsonNumber;
                ulilization?: JsonNumber;
                idGmaxComb?: JsonNumber;
                sectionAlignment?: string;
                sigmad0?: JsonNumber;
                sigmayd?: JsonNumber;
                sigmaz0?: JsonNumber;
                tensionResults?: ng.fem_design.timber_output.SectionTensionResultRecord_json;
                compressionResults?: ng.fem_design.timber_output.SectionCompressionResultRecord_json;
                shearResults?: ng.fem_design.timber_output.SectionShearResultRecord_json;
                flexuralBucklingResults1?: ng.fem_design.timber_output.SectionFlexBucklingResultRecord_json;
                flexuralBucklingResults2?: ng.fem_design.timber_output.SectionFlexBucklingResultRecord_json;
                torsionalBucklingResults?: ng.fem_design.timber_output.SectionTorsBucklingResultRecord_json;
                taperResults?: ng.fem_design.timber_output.SectionTaperResultRecord_json;
                apexResults?: ng.fem_design.timber_output.SectionApexResultRecord_json;
            }
            interface SectionDesignCalcRecord_json_in {
                __proto_name?: unknown;
                sectionDistanceFromBarStartPoint?: unknown;
                ulilization?: unknown;
                idGmaxComb?: unknown;
                sectionAlignment?: unknown;
                sigmad0?: unknown;
                sigmayd?: unknown;
                sigmaz0?: unknown;
                tensionResults?: unknown;
                compressionResults?: unknown;
                shearResults?: unknown;
                flexuralBucklingResults1?: unknown;
                flexuralBucklingResults2?: unknown;
                torsionalBucklingResults?: unknown;
                taperResults?: unknown;
                apexResults?: unknown;
            }
            export class SectionDesignCalcRecord {
                __proto_name = "ng.fem_design.timber_output.SectionDesignCalcRecord";
                sectionDistanceFromBarStartPoint: number = 0;
                ulilization: number = 0;
                idGmaxComb: number = 0;
                sectionAlignment: ng.fem_design.steel_output.Alignment = ng.fem_design.steel_output.Alignment.ALIGNMENT_TOP;
                sigmad0: number = 0;
                sigmayd: number = 0;
                sigmaz0: number = 0;
                tensionResults: ng.fem_design.timber_output.SectionTensionResultRecord | null = null;
                compressionResults: ng.fem_design.timber_output.SectionCompressionResultRecord | null = null;
                shearResults: ng.fem_design.timber_output.SectionShearResultRecord | null = null;
                flexuralBucklingResults1: ng.fem_design.timber_output.SectionFlexBucklingResultRecord | null = null;
                flexuralBucklingResults2: ng.fem_design.timber_output.SectionFlexBucklingResultRecord | null = null;
                torsionalBucklingResults: ng.fem_design.timber_output.SectionTorsBucklingResultRecord | null = null;
                taperResults: ng.fem_design.timber_output.SectionTaperResultRecord | null = null;
                apexResults: ng.fem_design.timber_output.SectionApexResultRecord | null = null;

                static fromObject(src_unknown: unknown): SectionDesignCalcRecord {
                    const dst = new SectionDesignCalcRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionDesignCalcRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionDesignCalcRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionDesignCalcRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sectionDistanceFromBarStartPoint !== undefined && src.sectionDistanceFromBarStartPoint !== null) {
                        if (typeof src.sectionDistanceFromBarStartPoint === "number" || src.sectionDistanceFromBarStartPoint === 'NaN' || src.sectionDistanceFromBarStartPoint === 'Infinity' || src.sectionDistanceFromBarStartPoint === '-Infinity') {
                            dst.sectionDistanceFromBarStartPoint = AsNum(src.sectionDistanceFromBarStartPoint);
                        }
                        else {
                            console.log('Expected sectionDistanceFromBarStartPoint of SectionDesignCalcRecord to be a number but was ', typeof src.sectionDistanceFromBarStartPoint, src.sectionDistanceFromBarStartPoint)
                        }
                    }
                    if (src.ulilization !== undefined && src.ulilization !== null) {
                        if (typeof src.ulilization === "number" || src.ulilization === 'NaN' || src.ulilization === 'Infinity' || src.ulilization === '-Infinity') {
                            dst.ulilization = AsNum(src.ulilization);
                        }
                        else {
                            console.log('Expected ulilization of SectionDesignCalcRecord to be a number but was ', typeof src.ulilization, src.ulilization)
                        }
                    }
                    if (src.idGmaxComb !== undefined && src.idGmaxComb !== null) {
                        if (typeof src.idGmaxComb === "number" || src.idGmaxComb === 'NaN' || src.idGmaxComb === 'Infinity' || src.idGmaxComb === '-Infinity') {
                            dst.idGmaxComb = NumberToInt("ng.fem_design.timber_output.SectionDesignCalcRecord.id_gmax_comb", AsNum(src.idGmaxComb));
                        }
                        else {
                            console.log('Expected idGmaxComb of SectionDesignCalcRecord to be a number but was ', typeof src.idGmaxComb, src.idGmaxComb)
                        }
                    }
                    if (src.sectionAlignment !== undefined && src.sectionAlignment !== null) {
                        dst.sectionAlignment = ng.fem_design.steel_output.Alignment_FromObject(src.sectionAlignment);
                    }
                    if (src.sigmad0 !== undefined && src.sigmad0 !== null) {
                        if (typeof src.sigmad0 === "number" || src.sigmad0 === 'NaN' || src.sigmad0 === 'Infinity' || src.sigmad0 === '-Infinity') {
                            dst.sigmad0 = AsNum(src.sigmad0);
                        }
                        else {
                            console.log('Expected sigmad0 of SectionDesignCalcRecord to be a number but was ', typeof src.sigmad0, src.sigmad0)
                        }
                    }
                    if (src.sigmayd !== undefined && src.sigmayd !== null) {
                        if (typeof src.sigmayd === "number" || src.sigmayd === 'NaN' || src.sigmayd === 'Infinity' || src.sigmayd === '-Infinity') {
                            dst.sigmayd = AsNum(src.sigmayd);
                        }
                        else {
                            console.log('Expected sigmayd of SectionDesignCalcRecord to be a number but was ', typeof src.sigmayd, src.sigmayd)
                        }
                    }
                    if (src.sigmaz0 !== undefined && src.sigmaz0 !== null) {
                        if (typeof src.sigmaz0 === "number" || src.sigmaz0 === 'NaN' || src.sigmaz0 === 'Infinity' || src.sigmaz0 === '-Infinity') {
                            dst.sigmaz0 = AsNum(src.sigmaz0);
                        }
                        else {
                            console.log('Expected sigmaz0 of SectionDesignCalcRecord to be a number but was ', typeof src.sigmaz0, src.sigmaz0)
                        }
                    }
                    if (src.tensionResults !== undefined && src.tensionResults !== null) {
                        dst.tensionResults = ng.fem_design.timber_output.SectionTensionResultRecord.fromObject(src.tensionResults);
                    }
                    if (src.compressionResults !== undefined && src.compressionResults !== null) {
                        dst.compressionResults = ng.fem_design.timber_output.SectionCompressionResultRecord.fromObject(src.compressionResults);
                    }
                    if (src.shearResults !== undefined && src.shearResults !== null) {
                        dst.shearResults = ng.fem_design.timber_output.SectionShearResultRecord.fromObject(src.shearResults);
                    }
                    if (src.flexuralBucklingResults1 !== undefined && src.flexuralBucklingResults1 !== null) {
                        dst.flexuralBucklingResults1 = ng.fem_design.timber_output.SectionFlexBucklingResultRecord.fromObject(src.flexuralBucklingResults1);
                    }
                    if (src.flexuralBucklingResults2 !== undefined && src.flexuralBucklingResults2 !== null) {
                        dst.flexuralBucklingResults2 = ng.fem_design.timber_output.SectionFlexBucklingResultRecord.fromObject(src.flexuralBucklingResults2);
                    }
                    if (src.torsionalBucklingResults !== undefined && src.torsionalBucklingResults !== null) {
                        dst.torsionalBucklingResults = ng.fem_design.timber_output.SectionTorsBucklingResultRecord.fromObject(src.torsionalBucklingResults);
                    }
                    if (src.taperResults !== undefined && src.taperResults !== null) {
                        dst.taperResults = ng.fem_design.timber_output.SectionTaperResultRecord.fromObject(src.taperResults);
                    }
                    if (src.apexResults !== undefined && src.apexResults !== null) {
                        dst.apexResults = ng.fem_design.timber_output.SectionApexResultRecord.fromObject(src.apexResults);
                    }
                    return dst;
                }

                static toObject(src: SectionDesignCalcRecord | null | undefined): SectionDesignCalcRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionDesignCalcRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionDesignCalcRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionDesignCalcRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const sectionAlignment_obj = ng.fem_design.steel_output.Alignment_ToObject(src.sectionAlignment);
                    if(sectionAlignment_obj === null) return null;

                    const dst : SectionDesignCalcRecord_json = {
                        sectionDistanceFromBarStartPoint: AsJsonNum(src.sectionDistanceFromBarStartPoint),
                        ulilization: AsJsonNum(src.ulilization),
                        idGmaxComb: AsJsonNum(NumberToInt("ng.fem_design.timber_output.SectionDesignCalcRecord.id_gmax_comb", src.idGmaxComb)),
                        sectionAlignment: sectionAlignment_obj,
                        sigmad0: AsJsonNum(src.sigmad0),
                        sigmayd: AsJsonNum(src.sigmayd),
                        sigmaz0: AsJsonNum(src.sigmaz0),
                    };
                    if(src.tensionResults !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionTensionResultRecord.toObject(src.tensionResults);
                        if(parsed === null) return null;
                        dst.tensionResults = parsed;
                    }
                    if(src.compressionResults !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionCompressionResultRecord.toObject(src.compressionResults);
                        if(parsed === null) return null;
                        dst.compressionResults = parsed;
                    }
                    if(src.shearResults !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionShearResultRecord.toObject(src.shearResults);
                        if(parsed === null) return null;
                        dst.shearResults = parsed;
                    }
                    if(src.flexuralBucklingResults1 !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionFlexBucklingResultRecord.toObject(src.flexuralBucklingResults1);
                        if(parsed === null) return null;
                        dst.flexuralBucklingResults1 = parsed;
                    }
                    if(src.flexuralBucklingResults2 !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionFlexBucklingResultRecord.toObject(src.flexuralBucklingResults2);
                        if(parsed === null) return null;
                        dst.flexuralBucklingResults2 = parsed;
                    }
                    if(src.torsionalBucklingResults !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionTorsBucklingResultRecord.toObject(src.torsionalBucklingResults);
                        if(parsed === null) return null;
                        dst.torsionalBucklingResults = parsed;
                    }
                    if(src.taperResults !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionTaperResultRecord.toObject(src.taperResults);
                        if(parsed === null) return null;
                        dst.taperResults = parsed;
                    }
                    if(src.apexResults !== null)
                    {
                        const parsed = ng.fem_design.timber_output.SectionApexResultRecord.toObject(src.apexResults);
                        if(parsed === null) return null;
                        dst.apexResults = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionDesignCalcRecord_createType) {
                    const dst = new SectionDesignCalcRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sectionDistanceFromBarStartPoint !== undefined) {
                        dst.sectionDistanceFromBarStartPoint = src.sectionDistanceFromBarStartPoint;
                    }
                    if (src.ulilization !== undefined) {
                        dst.ulilization = src.ulilization;
                    }
                    if (src.idGmaxComb !== undefined) {
                        dst.idGmaxComb = src.idGmaxComb;
                    }
                    if (src.sectionAlignment !== undefined) {
                        dst.sectionAlignment = src.sectionAlignment;
                    }
                    if (src.sigmad0 !== undefined) {
                        dst.sigmad0 = src.sigmad0;
                    }
                    if (src.sigmayd !== undefined) {
                        dst.sigmayd = src.sigmayd;
                    }
                    if (src.sigmaz0 !== undefined) {
                        dst.sigmaz0 = src.sigmaz0;
                    }
                    if (src.tensionResults !== undefined) {
                        dst.tensionResults = src.tensionResults;
                    }
                    if (src.compressionResults !== undefined) {
                        dst.compressionResults = src.compressionResults;
                    }
                    if (src.shearResults !== undefined) {
                        dst.shearResults = src.shearResults;
                    }
                    if (src.flexuralBucklingResults1 !== undefined) {
                        dst.flexuralBucklingResults1 = src.flexuralBucklingResults1;
                    }
                    if (src.flexuralBucklingResults2 !== undefined) {
                        dst.flexuralBucklingResults2 = src.flexuralBucklingResults2;
                    }
                    if (src.torsionalBucklingResults !== undefined) {
                        dst.torsionalBucklingResults = src.torsionalBucklingResults;
                    }
                    if (src.taperResults !== undefined) {
                        dst.taperResults = src.taperResults;
                    }
                    if (src.apexResults !== undefined) {
                        dst.apexResults = src.apexResults;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionDesignCalcRecord();
                    dst.sectionDistanceFromBarStartPoint = this.sectionDistanceFromBarStartPoint;
                    dst.ulilization = this.ulilization;
                    dst.idGmaxComb = this.idGmaxComb;
                    dst.sectionAlignment = this.sectionAlignment;
                    dst.sigmad0 = this.sigmad0;
                    dst.sigmayd = this.sigmayd;
                    dst.sigmaz0 = this.sigmaz0;
                    dst.tensionResults = this.tensionResults;
                    dst.compressionResults = this.compressionResults;
                    dst.shearResults = this.shearResults;
                    dst.flexuralBucklingResults1 = this.flexuralBucklingResults1;
                    dst.flexuralBucklingResults2 = this.flexuralBucklingResults2;
                    dst.torsionalBucklingResults = this.torsionalBucklingResults;
                    dst.taperResults = this.taperResults;
                    dst.apexResults = this.apexResults;
                    return dst;
                }

                deepClone() {
                    const json = SectionDesignCalcRecord.toObject(this);
                    const dst = SectionDesignCalcRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionDesignCalcRecord = SectionDesignCalcRecord;


            export type SectionTensionResultRecord_keys = 'fRelevant' | 'rUtilMy' | 'rUtilMz';
            export interface SectionTensionResultRecord_createType {
                fRelevant?: boolean,
                rUtilMy?: number,
                rUtilMz?: number,
            }
            export interface SectionTensionResultRecord_json {
                fRelevant?: boolean;
                rUtilMy?: JsonNumber;
                rUtilMz?: JsonNumber;
            }
            interface SectionTensionResultRecord_json_in {
                __proto_name?: unknown;
                fRelevant?: unknown;
                rUtilMy?: unknown;
                rUtilMz?: unknown;
            }
            export class SectionTensionResultRecord {
                __proto_name = "ng.fem_design.timber_output.SectionTensionResultRecord";
                fRelevant: boolean = false;
                rUtilMy: number = 0;
                rUtilMz: number = 0;

                static fromObject(src_unknown: unknown): SectionTensionResultRecord {
                    const dst = new SectionTensionResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionTensionResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionTensionResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionTensionResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of SectionTensionResultRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.rUtilMy !== undefined && src.rUtilMy !== null) {
                        if (typeof src.rUtilMy === "number" || src.rUtilMy === 'NaN' || src.rUtilMy === 'Infinity' || src.rUtilMy === '-Infinity') {
                            dst.rUtilMy = AsNum(src.rUtilMy);
                        }
                        else {
                            console.log('Expected rUtilMy of SectionTensionResultRecord to be a number but was ', typeof src.rUtilMy, src.rUtilMy)
                        }
                    }
                    if (src.rUtilMz !== undefined && src.rUtilMz !== null) {
                        if (typeof src.rUtilMz === "number" || src.rUtilMz === 'NaN' || src.rUtilMz === 'Infinity' || src.rUtilMz === '-Infinity') {
                            dst.rUtilMz = AsNum(src.rUtilMz);
                        }
                        else {
                            console.log('Expected rUtilMz of SectionTensionResultRecord to be a number but was ', typeof src.rUtilMz, src.rUtilMz)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionTensionResultRecord | null | undefined): SectionTensionResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionTensionResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionTensionResultRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionTensionResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionTensionResultRecord_json = {
                        fRelevant: src.fRelevant,
                        rUtilMy: AsJsonNum(src.rUtilMy),
                        rUtilMz: AsJsonNum(src.rUtilMz),
                    };
                    return dst;
                }

                static create(src?: SectionTensionResultRecord_createType) {
                    const dst = new SectionTensionResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.rUtilMy !== undefined) {
                        dst.rUtilMy = src.rUtilMy;
                    }
                    if (src.rUtilMz !== undefined) {
                        dst.rUtilMz = src.rUtilMz;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionTensionResultRecord();
                    dst.fRelevant = this.fRelevant;
                    dst.rUtilMy = this.rUtilMy;
                    dst.rUtilMz = this.rUtilMz;
                    return dst;
                }

                deepClone() {
                    const json = SectionTensionResultRecord.toObject(this);
                    const dst = SectionTensionResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionTensionResultRecord = SectionTensionResultRecord;


            export type SectionCompressionResultRecord_keys = 'fRelevant' | 'rUtilN' | 'rUtilMy' | 'rUtilMz';
            export interface SectionCompressionResultRecord_createType {
                fRelevant?: boolean,
                rUtilN?: number,
                rUtilMy?: number,
                rUtilMz?: number,
            }
            export interface SectionCompressionResultRecord_json {
                fRelevant?: boolean;
                rUtilN?: JsonNumber;
                rUtilMy?: JsonNumber;
                rUtilMz?: JsonNumber;
            }
            interface SectionCompressionResultRecord_json_in {
                __proto_name?: unknown;
                fRelevant?: unknown;
                rUtilN?: unknown;
                rUtilMy?: unknown;
                rUtilMz?: unknown;
            }
            export class SectionCompressionResultRecord {
                __proto_name = "ng.fem_design.timber_output.SectionCompressionResultRecord";
                fRelevant: boolean = false;
                rUtilN: number = 0;
                rUtilMy: number = 0;
                rUtilMz: number = 0;

                static fromObject(src_unknown: unknown): SectionCompressionResultRecord {
                    const dst = new SectionCompressionResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionCompressionResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionCompressionResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionCompressionResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of SectionCompressionResultRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.rUtilN !== undefined && src.rUtilN !== null) {
                        if (typeof src.rUtilN === "number" || src.rUtilN === 'NaN' || src.rUtilN === 'Infinity' || src.rUtilN === '-Infinity') {
                            dst.rUtilN = AsNum(src.rUtilN);
                        }
                        else {
                            console.log('Expected rUtilN of SectionCompressionResultRecord to be a number but was ', typeof src.rUtilN, src.rUtilN)
                        }
                    }
                    if (src.rUtilMy !== undefined && src.rUtilMy !== null) {
                        if (typeof src.rUtilMy === "number" || src.rUtilMy === 'NaN' || src.rUtilMy === 'Infinity' || src.rUtilMy === '-Infinity') {
                            dst.rUtilMy = AsNum(src.rUtilMy);
                        }
                        else {
                            console.log('Expected rUtilMy of SectionCompressionResultRecord to be a number but was ', typeof src.rUtilMy, src.rUtilMy)
                        }
                    }
                    if (src.rUtilMz !== undefined && src.rUtilMz !== null) {
                        if (typeof src.rUtilMz === "number" || src.rUtilMz === 'NaN' || src.rUtilMz === 'Infinity' || src.rUtilMz === '-Infinity') {
                            dst.rUtilMz = AsNum(src.rUtilMz);
                        }
                        else {
                            console.log('Expected rUtilMz of SectionCompressionResultRecord to be a number but was ', typeof src.rUtilMz, src.rUtilMz)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionCompressionResultRecord | null | undefined): SectionCompressionResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionCompressionResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionCompressionResultRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionCompressionResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionCompressionResultRecord_json = {
                        fRelevant: src.fRelevant,
                        rUtilN: AsJsonNum(src.rUtilN),
                        rUtilMy: AsJsonNum(src.rUtilMy),
                        rUtilMz: AsJsonNum(src.rUtilMz),
                    };
                    return dst;
                }

                static create(src?: SectionCompressionResultRecord_createType) {
                    const dst = new SectionCompressionResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.rUtilN !== undefined) {
                        dst.rUtilN = src.rUtilN;
                    }
                    if (src.rUtilMy !== undefined) {
                        dst.rUtilMy = src.rUtilMy;
                    }
                    if (src.rUtilMz !== undefined) {
                        dst.rUtilMz = src.rUtilMz;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionCompressionResultRecord();
                    dst.fRelevant = this.fRelevant;
                    dst.rUtilN = this.rUtilN;
                    dst.rUtilMy = this.rUtilMy;
                    dst.rUtilMz = this.rUtilMz;
                    return dst;
                }

                deepClone() {
                    const json = SectionCompressionResultRecord.toObject(this);
                    const dst = SectionCompressionResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionCompressionResultRecord = SectionCompressionResultRecord;


            export type SectionShearResultRecord_keys = 'fRelevant' | 'rUtil' | 'rTauVyxy' | 'rTauVzxy' | 'rTauMtxy' | 'rTauVyxz' | 'rTauVzxz' | 'rTauMtxz' | 'rTauVd';
            export interface SectionShearResultRecord_createType {
                fRelevant?: boolean,
                rUtil?: number,
                rTauVyxy?: number,
                rTauVzxy?: number,
                rTauMtxy?: number,
                rTauVyxz?: number,
                rTauVzxz?: number,
                rTauMtxz?: number,
                rTauVd?: number,
            }
            export interface SectionShearResultRecord_json {
                fRelevant?: boolean;
                rUtil?: JsonNumber;
                rTauVyxy?: JsonNumber;
                rTauVzxy?: JsonNumber;
                rTauMtxy?: JsonNumber;
                rTauVyxz?: JsonNumber;
                rTauVzxz?: JsonNumber;
                rTauMtxz?: JsonNumber;
                rTauVd?: JsonNumber;
            }
            interface SectionShearResultRecord_json_in {
                __proto_name?: unknown;
                fRelevant?: unknown;
                rUtil?: unknown;
                rTauVyxy?: unknown;
                rTauVzxy?: unknown;
                rTauMtxy?: unknown;
                rTauVyxz?: unknown;
                rTauVzxz?: unknown;
                rTauMtxz?: unknown;
                rTauVd?: unknown;
            }
            export class SectionShearResultRecord {
                __proto_name = "ng.fem_design.timber_output.SectionShearResultRecord";
                fRelevant: boolean = false;
                rUtil: number = 0;
                rTauVyxy: number = 0;
                rTauVzxy: number = 0;
                rTauMtxy: number = 0;
                rTauVyxz: number = 0;
                rTauVzxz: number = 0;
                rTauMtxz: number = 0;
                rTauVd: number = 0;

                static fromObject(src_unknown: unknown): SectionShearResultRecord {
                    const dst = new SectionShearResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionShearResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionShearResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionShearResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of SectionShearResultRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        if (typeof src.rUtil === "number" || src.rUtil === 'NaN' || src.rUtil === 'Infinity' || src.rUtil === '-Infinity') {
                            dst.rUtil = AsNum(src.rUtil);
                        }
                        else {
                            console.log('Expected rUtil of SectionShearResultRecord to be a number but was ', typeof src.rUtil, src.rUtil)
                        }
                    }
                    if (src.rTauVyxy !== undefined && src.rTauVyxy !== null) {
                        if (typeof src.rTauVyxy === "number" || src.rTauVyxy === 'NaN' || src.rTauVyxy === 'Infinity' || src.rTauVyxy === '-Infinity') {
                            dst.rTauVyxy = AsNum(src.rTauVyxy);
                        }
                        else {
                            console.log('Expected rTauVyxy of SectionShearResultRecord to be a number but was ', typeof src.rTauVyxy, src.rTauVyxy)
                        }
                    }
                    if (src.rTauVzxy !== undefined && src.rTauVzxy !== null) {
                        if (typeof src.rTauVzxy === "number" || src.rTauVzxy === 'NaN' || src.rTauVzxy === 'Infinity' || src.rTauVzxy === '-Infinity') {
                            dst.rTauVzxy = AsNum(src.rTauVzxy);
                        }
                        else {
                            console.log('Expected rTauVzxy of SectionShearResultRecord to be a number but was ', typeof src.rTauVzxy, src.rTauVzxy)
                        }
                    }
                    if (src.rTauMtxy !== undefined && src.rTauMtxy !== null) {
                        if (typeof src.rTauMtxy === "number" || src.rTauMtxy === 'NaN' || src.rTauMtxy === 'Infinity' || src.rTauMtxy === '-Infinity') {
                            dst.rTauMtxy = AsNum(src.rTauMtxy);
                        }
                        else {
                            console.log('Expected rTauMtxy of SectionShearResultRecord to be a number but was ', typeof src.rTauMtxy, src.rTauMtxy)
                        }
                    }
                    if (src.rTauVyxz !== undefined && src.rTauVyxz !== null) {
                        if (typeof src.rTauVyxz === "number" || src.rTauVyxz === 'NaN' || src.rTauVyxz === 'Infinity' || src.rTauVyxz === '-Infinity') {
                            dst.rTauVyxz = AsNum(src.rTauVyxz);
                        }
                        else {
                            console.log('Expected rTauVyxz of SectionShearResultRecord to be a number but was ', typeof src.rTauVyxz, src.rTauVyxz)
                        }
                    }
                    if (src.rTauVzxz !== undefined && src.rTauVzxz !== null) {
                        if (typeof src.rTauVzxz === "number" || src.rTauVzxz === 'NaN' || src.rTauVzxz === 'Infinity' || src.rTauVzxz === '-Infinity') {
                            dst.rTauVzxz = AsNum(src.rTauVzxz);
                        }
                        else {
                            console.log('Expected rTauVzxz of SectionShearResultRecord to be a number but was ', typeof src.rTauVzxz, src.rTauVzxz)
                        }
                    }
                    if (src.rTauMtxz !== undefined && src.rTauMtxz !== null) {
                        if (typeof src.rTauMtxz === "number" || src.rTauMtxz === 'NaN' || src.rTauMtxz === 'Infinity' || src.rTauMtxz === '-Infinity') {
                            dst.rTauMtxz = AsNum(src.rTauMtxz);
                        }
                        else {
                            console.log('Expected rTauMtxz of SectionShearResultRecord to be a number but was ', typeof src.rTauMtxz, src.rTauMtxz)
                        }
                    }
                    if (src.rTauVd !== undefined && src.rTauVd !== null) {
                        if (typeof src.rTauVd === "number" || src.rTauVd === 'NaN' || src.rTauVd === 'Infinity' || src.rTauVd === '-Infinity') {
                            dst.rTauVd = AsNum(src.rTauVd);
                        }
                        else {
                            console.log('Expected rTauVd of SectionShearResultRecord to be a number but was ', typeof src.rTauVd, src.rTauVd)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionShearResultRecord | null | undefined): SectionShearResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionShearResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionShearResultRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionShearResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionShearResultRecord_json = {
                        fRelevant: src.fRelevant,
                        rUtil: AsJsonNum(src.rUtil),
                        rTauVyxy: AsJsonNum(src.rTauVyxy),
                        rTauVzxy: AsJsonNum(src.rTauVzxy),
                        rTauMtxy: AsJsonNum(src.rTauMtxy),
                        rTauVyxz: AsJsonNum(src.rTauVyxz),
                        rTauVzxz: AsJsonNum(src.rTauVzxz),
                        rTauMtxz: AsJsonNum(src.rTauMtxz),
                        rTauVd: AsJsonNum(src.rTauVd),
                    };
                    return dst;
                }

                static create(src?: SectionShearResultRecord_createType) {
                    const dst = new SectionShearResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    if (src.rTauVyxy !== undefined) {
                        dst.rTauVyxy = src.rTauVyxy;
                    }
                    if (src.rTauVzxy !== undefined) {
                        dst.rTauVzxy = src.rTauVzxy;
                    }
                    if (src.rTauMtxy !== undefined) {
                        dst.rTauMtxy = src.rTauMtxy;
                    }
                    if (src.rTauVyxz !== undefined) {
                        dst.rTauVyxz = src.rTauVyxz;
                    }
                    if (src.rTauVzxz !== undefined) {
                        dst.rTauVzxz = src.rTauVzxz;
                    }
                    if (src.rTauMtxz !== undefined) {
                        dst.rTauMtxz = src.rTauMtxz;
                    }
                    if (src.rTauVd !== undefined) {
                        dst.rTauVd = src.rTauVd;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionShearResultRecord();
                    dst.fRelevant = this.fRelevant;
                    dst.rUtil = this.rUtil;
                    dst.rTauVyxy = this.rTauVyxy;
                    dst.rTauVzxy = this.rTauVzxy;
                    dst.rTauMtxy = this.rTauMtxy;
                    dst.rTauVyxz = this.rTauVyxz;
                    dst.rTauVzxz = this.rTauVzxz;
                    dst.rTauMtxz = this.rTauMtxz;
                    dst.rTauVd = this.rTauVd;
                    return dst;
                }

                deepClone() {
                    const json = SectionShearResultRecord.toObject(this);
                    const dst = SectionShearResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionShearResultRecord = SectionShearResultRecord;


            export type SectionFlexBucklingResultRecord_keys = 'fRelevant' | 'rKc' | 'rUtil';
            export interface SectionFlexBucklingResultRecord_createType {
                fRelevant?: boolean,
                rKc?: number,
                rUtil?: number,
            }
            export interface SectionFlexBucklingResultRecord_json {
                fRelevant?: boolean;
                rKc?: JsonNumber;
                rUtil?: JsonNumber;
            }
            interface SectionFlexBucklingResultRecord_json_in {
                __proto_name?: unknown;
                fRelevant?: unknown;
                rKc?: unknown;
                rUtil?: unknown;
            }
            export class SectionFlexBucklingResultRecord {
                __proto_name = "ng.fem_design.timber_output.SectionFlexBucklingResultRecord";
                fRelevant: boolean = false;
                rKc: number = 0;
                rUtil: number = 0;

                static fromObject(src_unknown: unknown): SectionFlexBucklingResultRecord {
                    const dst = new SectionFlexBucklingResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionFlexBucklingResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionFlexBucklingResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionFlexBucklingResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of SectionFlexBucklingResultRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.rKc !== undefined && src.rKc !== null) {
                        if (typeof src.rKc === "number" || src.rKc === 'NaN' || src.rKc === 'Infinity' || src.rKc === '-Infinity') {
                            dst.rKc = AsNum(src.rKc);
                        }
                        else {
                            console.log('Expected rKc of SectionFlexBucklingResultRecord to be a number but was ', typeof src.rKc, src.rKc)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        if (typeof src.rUtil === "number" || src.rUtil === 'NaN' || src.rUtil === 'Infinity' || src.rUtil === '-Infinity') {
                            dst.rUtil = AsNum(src.rUtil);
                        }
                        else {
                            console.log('Expected rUtil of SectionFlexBucklingResultRecord to be a number but was ', typeof src.rUtil, src.rUtil)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionFlexBucklingResultRecord | null | undefined): SectionFlexBucklingResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionFlexBucklingResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionFlexBucklingResultRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionFlexBucklingResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionFlexBucklingResultRecord_json = {
                        fRelevant: src.fRelevant,
                        rKc: AsJsonNum(src.rKc),
                        rUtil: AsJsonNum(src.rUtil),
                    };
                    return dst;
                }

                static create(src?: SectionFlexBucklingResultRecord_createType) {
                    const dst = new SectionFlexBucklingResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.rKc !== undefined) {
                        dst.rKc = src.rKc;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionFlexBucklingResultRecord();
                    dst.fRelevant = this.fRelevant;
                    dst.rKc = this.rKc;
                    dst.rUtil = this.rUtil;
                    return dst;
                }

                deepClone() {
                    const json = SectionFlexBucklingResultRecord.toObject(this);
                    const dst = SectionFlexBucklingResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionFlexBucklingResultRecord = SectionFlexBucklingResultRecord;


            export type SectionTorsBucklingResultRecord_keys = 'fRelevant' | 'rKcrit' | 'rUtil';
            export interface SectionTorsBucklingResultRecord_createType {
                fRelevant?: boolean,
                rKcrit?: number,
                rUtil?: ng.fem_design.steel_output.Vector2D | null,
            }
            export interface SectionTorsBucklingResultRecord_json {
                fRelevant?: boolean;
                rKcrit?: JsonNumber;
                rUtil?: ng.fem_design.steel_output.Vector2D_json;
            }
            interface SectionTorsBucklingResultRecord_json_in {
                __proto_name?: unknown;
                fRelevant?: unknown;
                rKcrit?: unknown;
                rUtil?: unknown;
            }
            export class SectionTorsBucklingResultRecord {
                __proto_name = "ng.fem_design.timber_output.SectionTorsBucklingResultRecord";
                fRelevant: boolean = false;
                rKcrit: number = 0;
                rUtil: ng.fem_design.steel_output.Vector2D | null = null;

                static fromObject(src_unknown: unknown): SectionTorsBucklingResultRecord {
                    const dst = new SectionTorsBucklingResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionTorsBucklingResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionTorsBucklingResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionTorsBucklingResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of SectionTorsBucklingResultRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.rKcrit !== undefined && src.rKcrit !== null) {
                        if (typeof src.rKcrit === "number" || src.rKcrit === 'NaN' || src.rKcrit === 'Infinity' || src.rKcrit === '-Infinity') {
                            dst.rKcrit = AsNum(src.rKcrit);
                        }
                        else {
                            console.log('Expected rKcrit of SectionTorsBucklingResultRecord to be a number but was ', typeof src.rKcrit, src.rKcrit)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        dst.rUtil = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtil);
                    }
                    return dst;
                }

                static toObject(src: SectionTorsBucklingResultRecord | null | undefined): SectionTorsBucklingResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionTorsBucklingResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionTorsBucklingResultRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionTorsBucklingResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionTorsBucklingResultRecord_json = {
                        fRelevant: src.fRelevant,
                        rKcrit: AsJsonNum(src.rKcrit),
                    };
                    if(src.rUtil !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtil);
                        if(parsed === null) return null;
                        dst.rUtil = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionTorsBucklingResultRecord_createType) {
                    const dst = new SectionTorsBucklingResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.rKcrit !== undefined) {
                        dst.rKcrit = src.rKcrit;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionTorsBucklingResultRecord();
                    dst.fRelevant = this.fRelevant;
                    dst.rKcrit = this.rKcrit;
                    dst.rUtil = this.rUtil;
                    return dst;
                }

                deepClone() {
                    const json = SectionTorsBucklingResultRecord.toObject(this);
                    const dst = SectionTorsBucklingResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionTorsBucklingResultRecord = SectionTorsBucklingResultRecord;


            export type SectionTaperResultRecord_keys = 'fRelevant' | 'rKmalpha';
            export interface SectionTaperResultRecord_createType {
                fRelevant?: boolean,
                rKmalpha?: number,
            }
            export interface SectionTaperResultRecord_json {
                fRelevant?: boolean;
                rKmalpha?: JsonNumber;
            }
            interface SectionTaperResultRecord_json_in {
                __proto_name?: unknown;
                fRelevant?: unknown;
                rKmalpha?: unknown;
            }
            export class SectionTaperResultRecord {
                __proto_name = "ng.fem_design.timber_output.SectionTaperResultRecord";
                fRelevant: boolean = false;
                rKmalpha: number = 0;

                static fromObject(src_unknown: unknown): SectionTaperResultRecord {
                    const dst = new SectionTaperResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionTaperResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionTaperResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionTaperResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevant !== undefined && src.fRelevant !== null) {
                        if (typeof src.fRelevant === "boolean") {
                            dst.fRelevant = src.fRelevant;
                        }
                        else {
                            console.log('Expected fRelevant of SectionTaperResultRecord to be a boolean but was ', typeof src.fRelevant, src.fRelevant)
                        }
                    }
                    if (src.rKmalpha !== undefined && src.rKmalpha !== null) {
                        if (typeof src.rKmalpha === "number" || src.rKmalpha === 'NaN' || src.rKmalpha === 'Infinity' || src.rKmalpha === '-Infinity') {
                            dst.rKmalpha = AsNum(src.rKmalpha);
                        }
                        else {
                            console.log('Expected rKmalpha of SectionTaperResultRecord to be a number but was ', typeof src.rKmalpha, src.rKmalpha)
                        }
                    }
                    return dst;
                }

                static toObject(src: SectionTaperResultRecord | null | undefined): SectionTaperResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionTaperResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionTaperResultRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionTaperResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionTaperResultRecord_json = {
                        fRelevant: src.fRelevant,
                        rKmalpha: AsJsonNum(src.rKmalpha),
                    };
                    return dst;
                }

                static create(src?: SectionTaperResultRecord_createType) {
                    const dst = new SectionTaperResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevant !== undefined) {
                        dst.fRelevant = src.fRelevant;
                    }
                    if (src.rKmalpha !== undefined) {
                        dst.rKmalpha = src.rKmalpha;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionTaperResultRecord();
                    dst.fRelevant = this.fRelevant;
                    dst.rKmalpha = this.rKmalpha;
                    return dst;
                }

                deepClone() {
                    const json = SectionTaperResultRecord.toObject(this);
                    const dst = SectionTaperResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionTaperResultRecord = SectionTaperResultRecord;


            export type SectionApexResultRecord_keys = 'fRelevantBending' | 'fRelevantTension' | 'rMAp' | 'rSigmamd' | 'rSigmat90d' | 'rUtil';
            export interface SectionApexResultRecord_createType {
                fRelevantBending?: boolean,
                fRelevantTension?: boolean,
                rMAp?: number,
                rSigmamd?: number,
                rSigmat90d?: number,
                rUtil?: ng.fem_design.steel_output.Vector2D | null,
            }
            export interface SectionApexResultRecord_json {
                fRelevantBending?: boolean;
                fRelevantTension?: boolean;
                rMAp?: JsonNumber;
                rSigmamd?: JsonNumber;
                rSigmat90d?: JsonNumber;
                rUtil?: ng.fem_design.steel_output.Vector2D_json;
            }
            interface SectionApexResultRecord_json_in {
                __proto_name?: unknown;
                fRelevantBending?: unknown;
                fRelevantTension?: unknown;
                rMAp?: unknown;
                rSigmamd?: unknown;
                rSigmat90d?: unknown;
                rUtil?: unknown;
            }
            export class SectionApexResultRecord {
                __proto_name = "ng.fem_design.timber_output.SectionApexResultRecord";
                fRelevantBending: boolean = false;
                fRelevantTension: boolean = false;
                rMAp: number = 0;
                rSigmamd: number = 0;
                rSigmat90d: number = 0;
                rUtil: ng.fem_design.steel_output.Vector2D | null = null;

                static fromObject(src_unknown: unknown): SectionApexResultRecord {
                    const dst = new SectionApexResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionApexResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionApexResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionApexResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fRelevantBending !== undefined && src.fRelevantBending !== null) {
                        if (typeof src.fRelevantBending === "boolean") {
                            dst.fRelevantBending = src.fRelevantBending;
                        }
                        else {
                            console.log('Expected fRelevantBending of SectionApexResultRecord to be a boolean but was ', typeof src.fRelevantBending, src.fRelevantBending)
                        }
                    }
                    if (src.fRelevantTension !== undefined && src.fRelevantTension !== null) {
                        if (typeof src.fRelevantTension === "boolean") {
                            dst.fRelevantTension = src.fRelevantTension;
                        }
                        else {
                            console.log('Expected fRelevantTension of SectionApexResultRecord to be a boolean but was ', typeof src.fRelevantTension, src.fRelevantTension)
                        }
                    }
                    if (src.rMAp !== undefined && src.rMAp !== null) {
                        if (typeof src.rMAp === "number" || src.rMAp === 'NaN' || src.rMAp === 'Infinity' || src.rMAp === '-Infinity') {
                            dst.rMAp = AsNum(src.rMAp);
                        }
                        else {
                            console.log('Expected rMAp of SectionApexResultRecord to be a number but was ', typeof src.rMAp, src.rMAp)
                        }
                    }
                    if (src.rSigmamd !== undefined && src.rSigmamd !== null) {
                        if (typeof src.rSigmamd === "number" || src.rSigmamd === 'NaN' || src.rSigmamd === 'Infinity' || src.rSigmamd === '-Infinity') {
                            dst.rSigmamd = AsNum(src.rSigmamd);
                        }
                        else {
                            console.log('Expected rSigmamd of SectionApexResultRecord to be a number but was ', typeof src.rSigmamd, src.rSigmamd)
                        }
                    }
                    if (src.rSigmat90d !== undefined && src.rSigmat90d !== null) {
                        if (typeof src.rSigmat90d === "number" || src.rSigmat90d === 'NaN' || src.rSigmat90d === 'Infinity' || src.rSigmat90d === '-Infinity') {
                            dst.rSigmat90d = AsNum(src.rSigmat90d);
                        }
                        else {
                            console.log('Expected rSigmat90d of SectionApexResultRecord to be a number but was ', typeof src.rSigmat90d, src.rSigmat90d)
                        }
                    }
                    if (src.rUtil !== undefined && src.rUtil !== null) {
                        dst.rUtil = ng.fem_design.steel_output.Vector2D.fromObject(src.rUtil);
                    }
                    return dst;
                }

                static toObject(src: SectionApexResultRecord | null | undefined): SectionApexResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.timber_output.SectionApexResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.timber_output.SectionApexResultRecord") {
                        console.error('Expected ng.fem_design.timber_output.SectionApexResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionApexResultRecord_json = {
                        fRelevantBending: src.fRelevantBending,
                        fRelevantTension: src.fRelevantTension,
                        rMAp: AsJsonNum(src.rMAp),
                        rSigmamd: AsJsonNum(src.rSigmamd),
                        rSigmat90d: AsJsonNum(src.rSigmat90d),
                    };
                    if(src.rUtil !== null)
                    {
                        const parsed = ng.fem_design.steel_output.Vector2D.toObject(src.rUtil);
                        if(parsed === null) return null;
                        dst.rUtil = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionApexResultRecord_createType) {
                    const dst = new SectionApexResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fRelevantBending !== undefined) {
                        dst.fRelevantBending = src.fRelevantBending;
                    }
                    if (src.fRelevantTension !== undefined) {
                        dst.fRelevantTension = src.fRelevantTension;
                    }
                    if (src.rMAp !== undefined) {
                        dst.rMAp = src.rMAp;
                    }
                    if (src.rSigmamd !== undefined) {
                        dst.rSigmamd = src.rSigmamd;
                    }
                    if (src.rSigmat90d !== undefined) {
                        dst.rSigmat90d = src.rSigmat90d;
                    }
                    if (src.rUtil !== undefined) {
                        dst.rUtil = src.rUtil;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionApexResultRecord();
                    dst.fRelevantBending = this.fRelevantBending;
                    dst.fRelevantTension = this.fRelevantTension;
                    dst.rMAp = this.rMAp;
                    dst.rSigmamd = this.rSigmamd;
                    dst.rSigmat90d = this.rSigmat90d;
                    dst.rUtil = this.rUtil;
                    return dst;
                }

                deepClone() {
                    const json = SectionApexResultRecord.toObject(this);
                    const dst = SectionApexResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionApexResultRecord = SectionApexResultRecord;
        } // namespace timber_output


        // Defined in FEMDesign/analysis_data.proto
        export namespace analysis_data {
            export type Displacement_keys = 'ex' | 'ey' | 'ez';
            export interface Displacement_createType {
                ex?: number,
                ey?: number,
                ez?: number,
            }
            export interface Displacement_json {
                ex?: JsonNumber;
                ey?: JsonNumber;
                ez?: JsonNumber;
            }
            interface Displacement_json_in {
                __proto_name?: unknown;
                ex?: unknown;
                ey?: unknown;
                ez?: unknown;
            }
            export class Displacement {
                __proto_name = "ng.fem_design.analysis_data.Displacement";
                ex: number = 0;
                ey: number = 0;
                ez: number = 0;

                static fromObject(src_unknown: unknown): Displacement {
                    const dst = new Displacement();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Displacement but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Displacement_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Displacement but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.ex !== undefined && src.ex !== null) {
                        if (typeof src.ex === "number" || src.ex === 'NaN' || src.ex === 'Infinity' || src.ex === '-Infinity') {
                            dst.ex = AsNum(src.ex);
                        }
                        else {
                            console.log('Expected ex of Displacement to be a number but was ', typeof src.ex, src.ex)
                        }
                    }
                    if (src.ey !== undefined && src.ey !== null) {
                        if (typeof src.ey === "number" || src.ey === 'NaN' || src.ey === 'Infinity' || src.ey === '-Infinity') {
                            dst.ey = AsNum(src.ey);
                        }
                        else {
                            console.log('Expected ey of Displacement to be a number but was ', typeof src.ey, src.ey)
                        }
                    }
                    if (src.ez !== undefined && src.ez !== null) {
                        if (typeof src.ez === "number" || src.ez === 'NaN' || src.ez === 'Infinity' || src.ez === '-Infinity') {
                            dst.ez = AsNum(src.ez);
                        }
                        else {
                            console.log('Expected ez of Displacement to be a number but was ', typeof src.ez, src.ez)
                        }
                    }
                    return dst;
                }

                static toObject(src: Displacement | null | undefined): Displacement_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.Displacement is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.Displacement") {
                        console.error('Expected ng.fem_design.analysis_data.Displacement but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Displacement_json = {
                        ex: AsJsonNum(src.ex),
                        ey: AsJsonNum(src.ey),
                        ez: AsJsonNum(src.ez),
                    };
                    return dst;
                }

                static create(src?: Displacement_createType) {
                    const dst = new Displacement();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.ex !== undefined) {
                        dst.ex = src.ex;
                    }
                    if (src.ey !== undefined) {
                        dst.ey = src.ey;
                    }
                    if (src.ez !== undefined) {
                        dst.ez = src.ez;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Displacement();
                    dst.ex = this.ex;
                    dst.ey = this.ey;
                    dst.ez = this.ez;
                    return dst;
                }

                deepClone() {
                    const json = Displacement.toObject(this);
                    const dst = Displacement.fromObject(json);
                    return dst;
                }
            }
            export type IDisplacement = Displacement;


            export type Force_keys = 'n' | 'ty' | 'tz' | 'mx' | 'my' | 'mz';
            export interface Force_createType {
                n?: number,
                ty?: number,
                tz?: number,
                mx?: number,
                my?: number,
                mz?: number,
            }
            export interface Force_json {
                n?: JsonNumber;
                ty?: JsonNumber;
                tz?: JsonNumber;
                mx?: JsonNumber;
                my?: JsonNumber;
                mz?: JsonNumber;
            }
            interface Force_json_in {
                __proto_name?: unknown;
                n?: unknown;
                ty?: unknown;
                tz?: unknown;
                mx?: unknown;
                my?: unknown;
                mz?: unknown;
            }
            export class Force {
                __proto_name = "ng.fem_design.analysis_data.Force";
                n: number = 0;
                ty: number = 0;
                tz: number = 0;
                mx: number = 0;
                my: number = 0;
                mz: number = 0;

                static fromObject(src_unknown: unknown): Force {
                    const dst = new Force();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Force but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Force_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Force but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.n !== undefined && src.n !== null) {
                        if (typeof src.n === "number" || src.n === 'NaN' || src.n === 'Infinity' || src.n === '-Infinity') {
                            dst.n = AsNum(src.n);
                        }
                        else {
                            console.log('Expected n of Force to be a number but was ', typeof src.n, src.n)
                        }
                    }
                    if (src.ty !== undefined && src.ty !== null) {
                        if (typeof src.ty === "number" || src.ty === 'NaN' || src.ty === 'Infinity' || src.ty === '-Infinity') {
                            dst.ty = AsNum(src.ty);
                        }
                        else {
                            console.log('Expected ty of Force to be a number but was ', typeof src.ty, src.ty)
                        }
                    }
                    if (src.tz !== undefined && src.tz !== null) {
                        if (typeof src.tz === "number" || src.tz === 'NaN' || src.tz === 'Infinity' || src.tz === '-Infinity') {
                            dst.tz = AsNum(src.tz);
                        }
                        else {
                            console.log('Expected tz of Force to be a number but was ', typeof src.tz, src.tz)
                        }
                    }
                    if (src.mx !== undefined && src.mx !== null) {
                        if (typeof src.mx === "number" || src.mx === 'NaN' || src.mx === 'Infinity' || src.mx === '-Infinity') {
                            dst.mx = AsNum(src.mx);
                        }
                        else {
                            console.log('Expected mx of Force to be a number but was ', typeof src.mx, src.mx)
                        }
                    }
                    if (src.my !== undefined && src.my !== null) {
                        if (typeof src.my === "number" || src.my === 'NaN' || src.my === 'Infinity' || src.my === '-Infinity') {
                            dst.my = AsNum(src.my);
                        }
                        else {
                            console.log('Expected my of Force to be a number but was ', typeof src.my, src.my)
                        }
                    }
                    if (src.mz !== undefined && src.mz !== null) {
                        if (typeof src.mz === "number" || src.mz === 'NaN' || src.mz === 'Infinity' || src.mz === '-Infinity') {
                            dst.mz = AsNum(src.mz);
                        }
                        else {
                            console.log('Expected mz of Force to be a number but was ', typeof src.mz, src.mz)
                        }
                    }
                    return dst;
                }

                static toObject(src: Force | null | undefined): Force_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.Force is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.Force") {
                        console.error('Expected ng.fem_design.analysis_data.Force but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Force_json = {
                        n: AsJsonNum(src.n),
                        ty: AsJsonNum(src.ty),
                        tz: AsJsonNum(src.tz),
                        mx: AsJsonNum(src.mx),
                        my: AsJsonNum(src.my),
                        mz: AsJsonNum(src.mz),
                    };
                    return dst;
                }

                static create(src?: Force_createType) {
                    const dst = new Force();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.n !== undefined) {
                        dst.n = src.n;
                    }
                    if (src.ty !== undefined) {
                        dst.ty = src.ty;
                    }
                    if (src.tz !== undefined) {
                        dst.tz = src.tz;
                    }
                    if (src.mx !== undefined) {
                        dst.mx = src.mx;
                    }
                    if (src.my !== undefined) {
                        dst.my = src.my;
                    }
                    if (src.mz !== undefined) {
                        dst.mz = src.mz;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Force();
                    dst.n = this.n;
                    dst.ty = this.ty;
                    dst.tz = this.tz;
                    dst.mx = this.mx;
                    dst.my = this.my;
                    dst.mz = this.mz;
                    return dst;
                }

                deepClone() {
                    const json = Force.toObject(this);
                    const dst = Force.fromObject(json);
                    return dst;
                }
            }
            export type IForce = Force;


            export type SectionResultRecord_keys = 'sectionDistanceStart' | 'displacement' | 'force';
            export interface SectionResultRecord_createType {
                sectionDistanceStart?: number,
                displacement?: ng.fem_design.analysis_data.Displacement | null,
                force?: ng.fem_design.analysis_data.Force | null,
            }
            export interface SectionResultRecord_json {
                sectionDistanceStart?: JsonNumber;
                displacement?: ng.fem_design.analysis_data.Displacement_json;
                force?: ng.fem_design.analysis_data.Force_json;
            }
            interface SectionResultRecord_json_in {
                __proto_name?: unknown;
                sectionDistanceStart?: unknown;
                displacement?: unknown;
                force?: unknown;
            }
            export class SectionResultRecord {
                __proto_name = "ng.fem_design.analysis_data.SectionResultRecord";
                sectionDistanceStart: number = 0;
                displacement: ng.fem_design.analysis_data.Displacement | null = null;
                force: ng.fem_design.analysis_data.Force | null = null;

                static fromObject(src_unknown: unknown): SectionResultRecord {
                    const dst = new SectionResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sectionDistanceStart !== undefined && src.sectionDistanceStart !== null) {
                        if (typeof src.sectionDistanceStart === "number" || src.sectionDistanceStart === 'NaN' || src.sectionDistanceStart === 'Infinity' || src.sectionDistanceStart === '-Infinity') {
                            dst.sectionDistanceStart = AsNum(src.sectionDistanceStart);
                        }
                        else {
                            console.log('Expected sectionDistanceStart of SectionResultRecord to be a number but was ', typeof src.sectionDistanceStart, src.sectionDistanceStart)
                        }
                    }
                    if (src.displacement !== undefined && src.displacement !== null) {
                        dst.displacement = ng.fem_design.analysis_data.Displacement.fromObject(src.displacement);
                    }
                    if (src.force !== undefined && src.force !== null) {
                        dst.force = ng.fem_design.analysis_data.Force.fromObject(src.force);
                    }
                    return dst;
                }

                static toObject(src: SectionResultRecord | null | undefined): SectionResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.SectionResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.SectionResultRecord") {
                        console.error('Expected ng.fem_design.analysis_data.SectionResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionResultRecord_json = {
                        sectionDistanceStart: AsJsonNum(src.sectionDistanceStart),
                    };
                    if(src.displacement !== null)
                    {
                        const parsed = ng.fem_design.analysis_data.Displacement.toObject(src.displacement);
                        if(parsed === null) return null;
                        dst.displacement = parsed;
                    }
                    if(src.force !== null)
                    {
                        const parsed = ng.fem_design.analysis_data.Force.toObject(src.force);
                        if(parsed === null) return null;
                        dst.force = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionResultRecord_createType) {
                    const dst = new SectionResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sectionDistanceStart !== undefined) {
                        dst.sectionDistanceStart = src.sectionDistanceStart;
                    }
                    if (src.displacement !== undefined) {
                        dst.displacement = src.displacement;
                    }
                    if (src.force !== undefined) {
                        dst.force = src.force;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionResultRecord();
                    dst.sectionDistanceStart = this.sectionDistanceStart;
                    dst.displacement = this.displacement;
                    dst.force = this.force;
                    return dst;
                }

                deepClone() {
                    const json = SectionResultRecord.toObject(this);
                    const dst = SectionResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ISectionResultRecord = SectionResultRecord;


            export type CombResultRecord_keys = 'sectionResult';
            export interface CombResultRecord_createType {
                sectionResult?: ng.fem_design.analysis_data.SectionResultRecord[],
            }
            export interface CombResultRecord_json {
                sectionResult: ng.fem_design.analysis_data.SectionResultRecord_json[];
            }
            interface CombResultRecord_json_in {
                __proto_name?: unknown;
                sectionResult?: unknown;
            }
            export class CombResultRecord {
                __proto_name = "ng.fem_design.analysis_data.CombResultRecord";
                sectionResult: ng.fem_design.analysis_data.SectionResultRecord[] = [];

                static fromObject(src_unknown: unknown): CombResultRecord {
                    const dst = new CombResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CombResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CombResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CombResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sectionResult !== undefined && src.sectionResult !== null) {
                        if (Array.isArray(src.sectionResult)) {
                            for (const element of src.sectionResult) {
                                dst.sectionResult.push(ng.fem_design.analysis_data.SectionResultRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected sectionResult of CombResultRecord to be a array but was ', typeof src.sectionResult, src.sectionResult)
                        }
                    }
                    return dst;
                }

                static toObject(src: CombResultRecord | null | undefined): CombResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.CombResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.CombResultRecord") {
                        console.error('Expected ng.fem_design.analysis_data.CombResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CombResultRecord_json = {
                        sectionResult: new Array<ng.fem_design.analysis_data.SectionResultRecord_json>(),
                    };
                    if (src.sectionResult !== null) {
                        for (const element of src.sectionResult) {
                            const parsed = ng.fem_design.analysis_data.SectionResultRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.sectionResult.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CombResultRecord_createType) {
                    const dst = new CombResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sectionResult !== undefined) {
                        dst.sectionResult = src.sectionResult;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CombResultRecord();
                    dst.sectionResult = this.sectionResult;
                    return dst;
                }

                deepClone() {
                    const json = CombResultRecord.toObject(this);
                    const dst = CombResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type ICombResultRecord = CombResultRecord;


            export type BarResultRecord_keys = 'numberOfSections' | 'combResult';
            export interface BarResultRecord_createType {
                numberOfSections?: number,
                combResult?: ng.fem_design.analysis_data.CombResultRecord[],
            }
            export interface BarResultRecord_json {
                numberOfSections?: JsonNumber;
                combResult: ng.fem_design.analysis_data.CombResultRecord_json[];
            }
            interface BarResultRecord_json_in {
                __proto_name?: unknown;
                numberOfSections?: unknown;
                combResult?: unknown;
            }
            export class BarResultRecord {
                __proto_name = "ng.fem_design.analysis_data.BarResultRecord";
                numberOfSections: number = 0;
                combResult: ng.fem_design.analysis_data.CombResultRecord[] = [];

                static fromObject(src_unknown: unknown): BarResultRecord {
                    const dst = new BarResultRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BarResultRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BarResultRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BarResultRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.numberOfSections !== undefined && src.numberOfSections !== null) {
                        if (typeof src.numberOfSections === "number" || src.numberOfSections === 'NaN' || src.numberOfSections === 'Infinity' || src.numberOfSections === '-Infinity') {
                            dst.numberOfSections = NumberToInt("ng.fem_design.analysis_data.BarResultRecord.number_of_sections", AsNum(src.numberOfSections));
                        }
                        else {
                            console.log('Expected numberOfSections of BarResultRecord to be a number but was ', typeof src.numberOfSections, src.numberOfSections)
                        }
                    }
                    if (src.combResult !== undefined && src.combResult !== null) {
                        if (Array.isArray(src.combResult)) {
                            for (const element of src.combResult) {
                                dst.combResult.push(ng.fem_design.analysis_data.CombResultRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected combResult of BarResultRecord to be a array but was ', typeof src.combResult, src.combResult)
                        }
                    }
                    return dst;
                }

                static toObject(src: BarResultRecord | null | undefined): BarResultRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.BarResultRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.BarResultRecord") {
                        console.error('Expected ng.fem_design.analysis_data.BarResultRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BarResultRecord_json = {
                        numberOfSections: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.BarResultRecord.number_of_sections", src.numberOfSections)),
                        combResult: new Array<ng.fem_design.analysis_data.CombResultRecord_json>(),
                    };
                    if (src.combResult !== null) {
                        for (const element of src.combResult) {
                            const parsed = ng.fem_design.analysis_data.CombResultRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.combResult.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: BarResultRecord_createType) {
                    const dst = new BarResultRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.numberOfSections !== undefined) {
                        dst.numberOfSections = src.numberOfSections;
                    }
                    if (src.combResult !== undefined) {
                        dst.combResult = src.combResult;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BarResultRecord();
                    dst.numberOfSections = this.numberOfSections;
                    dst.combResult = this.combResult;
                    return dst;
                }

                deepClone() {
                    const json = BarResultRecord.toObject(this);
                    const dst = BarResultRecord.fromObject(json);
                    return dst;
                }
            }
            export type IBarResultRecord = BarResultRecord;


            export type LoadCombRecord_keys = 'secondOrder' | 'accidental' | 'fire';
            export interface LoadCombRecord_createType {
                secondOrder?: boolean,
                accidental?: boolean,
                fire?: boolean,
            }
            export interface LoadCombRecord_json {
                secondOrder?: boolean;
                accidental?: boolean;
                fire?: boolean;
            }
            interface LoadCombRecord_json_in {
                __proto_name?: unknown;
                secondOrder?: unknown;
                accidental?: unknown;
                fire?: unknown;
            }
            export class LoadCombRecord {
                __proto_name = "ng.fem_design.analysis_data.LoadCombRecord";
                secondOrder: boolean = false;
                accidental: boolean = false;
                fire: boolean = false;

                static fromObject(src_unknown: unknown): LoadCombRecord {
                    const dst = new LoadCombRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCombRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCombRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCombRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.secondOrder !== undefined && src.secondOrder !== null) {
                        if (typeof src.secondOrder === "boolean") {
                            dst.secondOrder = src.secondOrder;
                        }
                        else {
                            console.log('Expected secondOrder of LoadCombRecord to be a boolean but was ', typeof src.secondOrder, src.secondOrder)
                        }
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        if (typeof src.accidental === "boolean") {
                            dst.accidental = src.accidental;
                        }
                        else {
                            console.log('Expected accidental of LoadCombRecord to be a boolean but was ', typeof src.accidental, src.accidental)
                        }
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        if (typeof src.fire === "boolean") {
                            dst.fire = src.fire;
                        }
                        else {
                            console.log('Expected fire of LoadCombRecord to be a boolean but was ', typeof src.fire, src.fire)
                        }
                    }
                    return dst;
                }

                static toObject(src: LoadCombRecord | null | undefined): LoadCombRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.LoadCombRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.LoadCombRecord") {
                        console.error('Expected ng.fem_design.analysis_data.LoadCombRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCombRecord_json = {
                        secondOrder: src.secondOrder,
                        accidental: src.accidental,
                        fire: src.fire,
                    };
                    return dst;
                }

                static create(src?: LoadCombRecord_createType) {
                    const dst = new LoadCombRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.secondOrder !== undefined) {
                        dst.secondOrder = src.secondOrder;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCombRecord();
                    dst.secondOrder = this.secondOrder;
                    dst.accidental = this.accidental;
                    dst.fire = this.fire;
                    return dst;
                }

                deepClone() {
                    const json = LoadCombRecord.toObject(this);
                    const dst = LoadCombRecord.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCombRecord = LoadCombRecord;


            export type LoadCombTimberRecord_keys = 'secondOrder' | 'accidental' | 'fire' | 'durationClass';
            export interface LoadCombTimberRecord_createType {
                secondOrder?: boolean,
                accidental?: boolean,
                fire?: boolean,
                durationClass?: number,
            }
            export interface LoadCombTimberRecord_json {
                secondOrder?: boolean;
                accidental?: boolean;
                fire?: boolean;
                durationClass?: JsonNumber;
            }
            interface LoadCombTimberRecord_json_in {
                __proto_name?: unknown;
                secondOrder?: unknown;
                accidental?: unknown;
                fire?: unknown;
                durationClass?: unknown;
            }
            export class LoadCombTimberRecord {
                __proto_name = "ng.fem_design.analysis_data.LoadCombTimberRecord";
                secondOrder: boolean = false;
                accidental: boolean = false;
                fire: boolean = false;
                durationClass: number = 0;

                static fromObject(src_unknown: unknown): LoadCombTimberRecord {
                    const dst = new LoadCombTimberRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCombTimberRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCombTimberRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCombTimberRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.secondOrder !== undefined && src.secondOrder !== null) {
                        if (typeof src.secondOrder === "boolean") {
                            dst.secondOrder = src.secondOrder;
                        }
                        else {
                            console.log('Expected secondOrder of LoadCombTimberRecord to be a boolean but was ', typeof src.secondOrder, src.secondOrder)
                        }
                    }
                    if (src.accidental !== undefined && src.accidental !== null) {
                        if (typeof src.accidental === "boolean") {
                            dst.accidental = src.accidental;
                        }
                        else {
                            console.log('Expected accidental of LoadCombTimberRecord to be a boolean but was ', typeof src.accidental, src.accidental)
                        }
                    }
                    if (src.fire !== undefined && src.fire !== null) {
                        if (typeof src.fire === "boolean") {
                            dst.fire = src.fire;
                        }
                        else {
                            console.log('Expected fire of LoadCombTimberRecord to be a boolean but was ', typeof src.fire, src.fire)
                        }
                    }
                    if (src.durationClass !== undefined && src.durationClass !== null) {
                        if (typeof src.durationClass === "number" || src.durationClass === 'NaN' || src.durationClass === 'Infinity' || src.durationClass === '-Infinity') {
                            dst.durationClass = NumberToInt("ng.fem_design.analysis_data.LoadCombTimberRecord.duration_class", AsNum(src.durationClass));
                        }
                        else {
                            console.log('Expected durationClass of LoadCombTimberRecord to be a number but was ', typeof src.durationClass, src.durationClass)
                        }
                    }
                    return dst;
                }

                static toObject(src: LoadCombTimberRecord | null | undefined): LoadCombTimberRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.LoadCombTimberRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.LoadCombTimberRecord") {
                        console.error('Expected ng.fem_design.analysis_data.LoadCombTimberRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCombTimberRecord_json = {
                        secondOrder: src.secondOrder,
                        accidental: src.accidental,
                        fire: src.fire,
                        durationClass: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.LoadCombTimberRecord.duration_class", src.durationClass)),
                    };
                    return dst;
                }

                static create(src?: LoadCombTimberRecord_createType) {
                    const dst = new LoadCombTimberRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.secondOrder !== undefined) {
                        dst.secondOrder = src.secondOrder;
                    }
                    if (src.accidental !== undefined) {
                        dst.accidental = src.accidental;
                    }
                    if (src.fire !== undefined) {
                        dst.fire = src.fire;
                    }
                    if (src.durationClass !== undefined) {
                        dst.durationClass = src.durationClass;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCombTimberRecord();
                    dst.secondOrder = this.secondOrder;
                    dst.accidental = this.accidental;
                    dst.fire = this.fire;
                    dst.durationClass = this.durationClass;
                    return dst;
                }

                deepClone() {
                    const json = LoadCombTimberRecord.toObject(this);
                    const dst = LoadCombTimberRecord.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCombTimberRecord = LoadCombTimberRecord;


            export type BarSteelFireProtRecord_keys = 'mode' | 'unitMass' | 'specificHeat' | 'thermalConductivity' | 'encasement' | 'thickness' | 'maxTemperature';
            export interface BarSteelFireProtRecord_createType {
                mode?: number,
                unitMass?: number,
                specificHeat?: number,
                thermalConductivity?: number,
                encasement?: number,
                thickness?: number,
                maxTemperature?: number,
            }
            export interface BarSteelFireProtRecord_json {
                mode?: JsonNumber;
                unitMass?: JsonNumber;
                specificHeat?: JsonNumber;
                thermalConductivity?: JsonNumber;
                encasement?: JsonNumber;
                thickness?: JsonNumber;
                maxTemperature?: JsonNumber;
            }
            interface BarSteelFireProtRecord_json_in {
                __proto_name?: unknown;
                mode?: unknown;
                unitMass?: unknown;
                specificHeat?: unknown;
                thermalConductivity?: unknown;
                encasement?: unknown;
                thickness?: unknown;
                maxTemperature?: unknown;
            }
            export class BarSteelFireProtRecord {
                __proto_name = "ng.fem_design.analysis_data.BarSteelFireProtRecord";
                mode: number = 0;
                unitMass: number = 0;
                specificHeat: number = 0;
                thermalConductivity: number = 0;
                encasement: number = 0;
                thickness: number = 0;
                maxTemperature: number = 0;

                static fromObject(src_unknown: unknown): BarSteelFireProtRecord {
                    const dst = new BarSteelFireProtRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BarSteelFireProtRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BarSteelFireProtRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BarSteelFireProtRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.mode !== undefined && src.mode !== null) {
                        if (typeof src.mode === "number" || src.mode === 'NaN' || src.mode === 'Infinity' || src.mode === '-Infinity') {
                            dst.mode = NumberToInt("ng.fem_design.analysis_data.BarSteelFireProtRecord.mode", AsNum(src.mode));
                        }
                        else {
                            console.log('Expected mode of BarSteelFireProtRecord to be a number but was ', typeof src.mode, src.mode)
                        }
                    }
                    if (src.unitMass !== undefined && src.unitMass !== null) {
                        if (typeof src.unitMass === "number" || src.unitMass === 'NaN' || src.unitMass === 'Infinity' || src.unitMass === '-Infinity') {
                            dst.unitMass = AsNum(src.unitMass);
                        }
                        else {
                            console.log('Expected unitMass of BarSteelFireProtRecord to be a number but was ', typeof src.unitMass, src.unitMass)
                        }
                    }
                    if (src.specificHeat !== undefined && src.specificHeat !== null) {
                        if (typeof src.specificHeat === "number" || src.specificHeat === 'NaN' || src.specificHeat === 'Infinity' || src.specificHeat === '-Infinity') {
                            dst.specificHeat = AsNum(src.specificHeat);
                        }
                        else {
                            console.log('Expected specificHeat of BarSteelFireProtRecord to be a number but was ', typeof src.specificHeat, src.specificHeat)
                        }
                    }
                    if (src.thermalConductivity !== undefined && src.thermalConductivity !== null) {
                        if (typeof src.thermalConductivity === "number" || src.thermalConductivity === 'NaN' || src.thermalConductivity === 'Infinity' || src.thermalConductivity === '-Infinity') {
                            dst.thermalConductivity = AsNum(src.thermalConductivity);
                        }
                        else {
                            console.log('Expected thermalConductivity of BarSteelFireProtRecord to be a number but was ', typeof src.thermalConductivity, src.thermalConductivity)
                        }
                    }
                    if (src.encasement !== undefined && src.encasement !== null) {
                        if (typeof src.encasement === "number" || src.encasement === 'NaN' || src.encasement === 'Infinity' || src.encasement === '-Infinity') {
                            dst.encasement = NumberToInt("ng.fem_design.analysis_data.BarSteelFireProtRecord.encasement", AsNum(src.encasement));
                        }
                        else {
                            console.log('Expected encasement of BarSteelFireProtRecord to be a number but was ', typeof src.encasement, src.encasement)
                        }
                    }
                    if (src.thickness !== undefined && src.thickness !== null) {
                        if (typeof src.thickness === "number" || src.thickness === 'NaN' || src.thickness === 'Infinity' || src.thickness === '-Infinity') {
                            dst.thickness = AsNum(src.thickness);
                        }
                        else {
                            console.log('Expected thickness of BarSteelFireProtRecord to be a number but was ', typeof src.thickness, src.thickness)
                        }
                    }
                    if (src.maxTemperature !== undefined && src.maxTemperature !== null) {
                        if (typeof src.maxTemperature === "number" || src.maxTemperature === 'NaN' || src.maxTemperature === 'Infinity' || src.maxTemperature === '-Infinity') {
                            dst.maxTemperature = AsNum(src.maxTemperature);
                        }
                        else {
                            console.log('Expected maxTemperature of BarSteelFireProtRecord to be a number but was ', typeof src.maxTemperature, src.maxTemperature)
                        }
                    }
                    return dst;
                }

                static toObject(src: BarSteelFireProtRecord | null | undefined): BarSteelFireProtRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.BarSteelFireProtRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.BarSteelFireProtRecord") {
                        console.error('Expected ng.fem_design.analysis_data.BarSteelFireProtRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BarSteelFireProtRecord_json = {
                        mode: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.BarSteelFireProtRecord.mode", src.mode)),
                        unitMass: AsJsonNum(src.unitMass),
                        specificHeat: AsJsonNum(src.specificHeat),
                        thermalConductivity: AsJsonNum(src.thermalConductivity),
                        encasement: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.BarSteelFireProtRecord.encasement", src.encasement)),
                        thickness: AsJsonNum(src.thickness),
                        maxTemperature: AsJsonNum(src.maxTemperature),
                    };
                    return dst;
                }

                static create(src?: BarSteelFireProtRecord_createType) {
                    const dst = new BarSteelFireProtRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.mode !== undefined) {
                        dst.mode = src.mode;
                    }
                    if (src.unitMass !== undefined) {
                        dst.unitMass = src.unitMass;
                    }
                    if (src.specificHeat !== undefined) {
                        dst.specificHeat = src.specificHeat;
                    }
                    if (src.thermalConductivity !== undefined) {
                        dst.thermalConductivity = src.thermalConductivity;
                    }
                    if (src.encasement !== undefined) {
                        dst.encasement = src.encasement;
                    }
                    if (src.thickness !== undefined) {
                        dst.thickness = src.thickness;
                    }
                    if (src.maxTemperature !== undefined) {
                        dst.maxTemperature = src.maxTemperature;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BarSteelFireProtRecord();
                    dst.mode = this.mode;
                    dst.unitMass = this.unitMass;
                    dst.specificHeat = this.specificHeat;
                    dst.thermalConductivity = this.thermalConductivity;
                    dst.encasement = this.encasement;
                    dst.thickness = this.thickness;
                    dst.maxTemperature = this.maxTemperature;
                    return dst;
                }

                deepClone() {
                    const json = BarSteelFireProtRecord.toObject(this);
                    const dst = BarSteelFireProtRecord.fromObject(json);
                    return dst;
                }
            }
            export type IBarSteelFireProtRecord = BarSteelFireProtRecord;


            export type BarTimberFireProtRecord_keys = 'mode' | 'materialType' | 'innerLayerThickness' | 'outerLayerThickness' | 'charringRate' | 'failureTime' | 'charringStartTime' | 'charringRateModFactor';
            export interface BarTimberFireProtRecord_createType {
                mode?: number,
                materialType?: number,
                innerLayerThickness?: number,
                outerLayerThickness?: number,
                charringRate?: number,
                failureTime?: number,
                charringStartTime?: number,
                charringRateModFactor?: number,
            }
            export interface BarTimberFireProtRecord_json {
                mode?: JsonNumber;
                materialType?: JsonNumber;
                innerLayerThickness?: JsonNumber;
                outerLayerThickness?: JsonNumber;
                charringRate?: JsonNumber;
                failureTime?: JsonNumber;
                charringStartTime?: JsonNumber;
                charringRateModFactor?: JsonNumber;
            }
            interface BarTimberFireProtRecord_json_in {
                __proto_name?: unknown;
                mode?: unknown;
                materialType?: unknown;
                innerLayerThickness?: unknown;
                outerLayerThickness?: unknown;
                charringRate?: unknown;
                failureTime?: unknown;
                charringStartTime?: unknown;
                charringRateModFactor?: unknown;
            }
            export class BarTimberFireProtRecord {
                __proto_name = "ng.fem_design.analysis_data.BarTimberFireProtRecord";
                mode: number = 0;
                materialType: number = 0;
                innerLayerThickness: number = 0;
                outerLayerThickness: number = 0;
                charringRate: number = 0;
                failureTime: number = 0;
                charringStartTime: number = 0;
                charringRateModFactor: number = 0;

                static fromObject(src_unknown: unknown): BarTimberFireProtRecord {
                    const dst = new BarTimberFireProtRecord();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BarTimberFireProtRecord but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BarTimberFireProtRecord_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BarTimberFireProtRecord but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.mode !== undefined && src.mode !== null) {
                        if (typeof src.mode === "number" || src.mode === 'NaN' || src.mode === 'Infinity' || src.mode === '-Infinity') {
                            dst.mode = NumberToInt("ng.fem_design.analysis_data.BarTimberFireProtRecord.mode", AsNum(src.mode));
                        }
                        else {
                            console.log('Expected mode of BarTimberFireProtRecord to be a number but was ', typeof src.mode, src.mode)
                        }
                    }
                    if (src.materialType !== undefined && src.materialType !== null) {
                        if (typeof src.materialType === "number" || src.materialType === 'NaN' || src.materialType === 'Infinity' || src.materialType === '-Infinity') {
                            dst.materialType = NumberToInt("ng.fem_design.analysis_data.BarTimberFireProtRecord.material_type", AsNum(src.materialType));
                        }
                        else {
                            console.log('Expected materialType of BarTimberFireProtRecord to be a number but was ', typeof src.materialType, src.materialType)
                        }
                    }
                    if (src.innerLayerThickness !== undefined && src.innerLayerThickness !== null) {
                        if (typeof src.innerLayerThickness === "number" || src.innerLayerThickness === 'NaN' || src.innerLayerThickness === 'Infinity' || src.innerLayerThickness === '-Infinity') {
                            dst.innerLayerThickness = AsNum(src.innerLayerThickness);
                        }
                        else {
                            console.log('Expected innerLayerThickness of BarTimberFireProtRecord to be a number but was ', typeof src.innerLayerThickness, src.innerLayerThickness)
                        }
                    }
                    if (src.outerLayerThickness !== undefined && src.outerLayerThickness !== null) {
                        if (typeof src.outerLayerThickness === "number" || src.outerLayerThickness === 'NaN' || src.outerLayerThickness === 'Infinity' || src.outerLayerThickness === '-Infinity') {
                            dst.outerLayerThickness = AsNum(src.outerLayerThickness);
                        }
                        else {
                            console.log('Expected outerLayerThickness of BarTimberFireProtRecord to be a number but was ', typeof src.outerLayerThickness, src.outerLayerThickness)
                        }
                    }
                    if (src.charringRate !== undefined && src.charringRate !== null) {
                        if (typeof src.charringRate === "number" || src.charringRate === 'NaN' || src.charringRate === 'Infinity' || src.charringRate === '-Infinity') {
                            dst.charringRate = AsNum(src.charringRate);
                        }
                        else {
                            console.log('Expected charringRate of BarTimberFireProtRecord to be a number but was ', typeof src.charringRate, src.charringRate)
                        }
                    }
                    if (src.failureTime !== undefined && src.failureTime !== null) {
                        if (typeof src.failureTime === "number" || src.failureTime === 'NaN' || src.failureTime === 'Infinity' || src.failureTime === '-Infinity') {
                            dst.failureTime = AsNum(src.failureTime);
                        }
                        else {
                            console.log('Expected failureTime of BarTimberFireProtRecord to be a number but was ', typeof src.failureTime, src.failureTime)
                        }
                    }
                    if (src.charringStartTime !== undefined && src.charringStartTime !== null) {
                        if (typeof src.charringStartTime === "number" || src.charringStartTime === 'NaN' || src.charringStartTime === 'Infinity' || src.charringStartTime === '-Infinity') {
                            dst.charringStartTime = AsNum(src.charringStartTime);
                        }
                        else {
                            console.log('Expected charringStartTime of BarTimberFireProtRecord to be a number but was ', typeof src.charringStartTime, src.charringStartTime)
                        }
                    }
                    if (src.charringRateModFactor !== undefined && src.charringRateModFactor !== null) {
                        if (typeof src.charringRateModFactor === "number" || src.charringRateModFactor === 'NaN' || src.charringRateModFactor === 'Infinity' || src.charringRateModFactor === '-Infinity') {
                            dst.charringRateModFactor = AsNum(src.charringRateModFactor);
                        }
                        else {
                            console.log('Expected charringRateModFactor of BarTimberFireProtRecord to be a number but was ', typeof src.charringRateModFactor, src.charringRateModFactor)
                        }
                    }
                    return dst;
                }

                static toObject(src: BarTimberFireProtRecord | null | undefined): BarTimberFireProtRecord_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.BarTimberFireProtRecord is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.BarTimberFireProtRecord") {
                        console.error('Expected ng.fem_design.analysis_data.BarTimberFireProtRecord but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BarTimberFireProtRecord_json = {
                        mode: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.BarTimberFireProtRecord.mode", src.mode)),
                        materialType: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.BarTimberFireProtRecord.material_type", src.materialType)),
                        innerLayerThickness: AsJsonNum(src.innerLayerThickness),
                        outerLayerThickness: AsJsonNum(src.outerLayerThickness),
                        charringRate: AsJsonNum(src.charringRate),
                        failureTime: AsJsonNum(src.failureTime),
                        charringStartTime: AsJsonNum(src.charringStartTime),
                        charringRateModFactor: AsJsonNum(src.charringRateModFactor),
                    };
                    return dst;
                }

                static create(src?: BarTimberFireProtRecord_createType) {
                    const dst = new BarTimberFireProtRecord();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.mode !== undefined) {
                        dst.mode = src.mode;
                    }
                    if (src.materialType !== undefined) {
                        dst.materialType = src.materialType;
                    }
                    if (src.innerLayerThickness !== undefined) {
                        dst.innerLayerThickness = src.innerLayerThickness;
                    }
                    if (src.outerLayerThickness !== undefined) {
                        dst.outerLayerThickness = src.outerLayerThickness;
                    }
                    if (src.charringRate !== undefined) {
                        dst.charringRate = src.charringRate;
                    }
                    if (src.failureTime !== undefined) {
                        dst.failureTime = src.failureTime;
                    }
                    if (src.charringStartTime !== undefined) {
                        dst.charringStartTime = src.charringStartTime;
                    }
                    if (src.charringRateModFactor !== undefined) {
                        dst.charringRateModFactor = src.charringRateModFactor;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BarTimberFireProtRecord();
                    dst.mode = this.mode;
                    dst.materialType = this.materialType;
                    dst.innerLayerThickness = this.innerLayerThickness;
                    dst.outerLayerThickness = this.outerLayerThickness;
                    dst.charringRate = this.charringRate;
                    dst.failureTime = this.failureTime;
                    dst.charringStartTime = this.charringStartTime;
                    dst.charringRateModFactor = this.charringRateModFactor;
                    return dst;
                }

                deepClone() {
                    const json = BarTimberFireProtRecord.toObject(this);
                    const dst = BarTimberFireProtRecord.fromObject(json);
                    return dst;
                }
            }
            export type IBarTimberFireProtRecord = BarTimberFireProtRecord;


            export type InformationSteel_keys = 'version' | 'nbar' | 'ncomb' | 'loadComb' | 'barResult' | 'barFireProt';
            export interface InformationSteel_createType {
                version?: number,
                nbar?: number,
                ncomb?: number,
                loadComb?: ng.fem_design.analysis_data.LoadCombRecord[],
                barResult?: ng.fem_design.analysis_data.BarResultRecord[],
                barFireProt?: ng.fem_design.analysis_data.BarSteelFireProtRecord[],
            }
            export interface InformationSteel_json {
                version?: JsonNumber;
                nbar?: JsonNumber;
                ncomb?: JsonNumber;
                loadComb: ng.fem_design.analysis_data.LoadCombRecord_json[];
                barResult: ng.fem_design.analysis_data.BarResultRecord_json[];
                barFireProt: ng.fem_design.analysis_data.BarSteelFireProtRecord_json[];
            }
            interface InformationSteel_json_in {
                __proto_name?: unknown;
                version?: unknown;
                nbar?: unknown;
                ncomb?: unknown;
                loadComb?: unknown;
                barResult?: unknown;
                barFireProt?: unknown;
            }
            export class InformationSteel {
                __proto_name = "ng.fem_design.analysis_data.InformationSteel";
                version: number = 0;
                nbar: number = 0;
                ncomb: number = 0;
                loadComb: ng.fem_design.analysis_data.LoadCombRecord[] = [];
                barResult: ng.fem_design.analysis_data.BarResultRecord[] = [];
                barFireProt: ng.fem_design.analysis_data.BarSteelFireProtRecord[] = [];

                static fromObject(src_unknown: unknown): InformationSteel {
                    const dst = new InformationSteel();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted InformationSteel but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as InformationSteel_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for InformationSteel but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.version !== undefined && src.version !== null) {
                        if (typeof src.version === "number" || src.version === 'NaN' || src.version === 'Infinity' || src.version === '-Infinity') {
                            dst.version = NumberToInt("ng.fem_design.analysis_data.InformationSteel.version", AsNum(src.version));
                        }
                        else {
                            console.log('Expected version of InformationSteel to be a number but was ', typeof src.version, src.version)
                        }
                    }
                    if (src.nbar !== undefined && src.nbar !== null) {
                        if (typeof src.nbar === "number" || src.nbar === 'NaN' || src.nbar === 'Infinity' || src.nbar === '-Infinity') {
                            dst.nbar = NumberToInt("ng.fem_design.analysis_data.InformationSteel.nbar", AsNum(src.nbar));
                        }
                        else {
                            console.log('Expected nbar of InformationSteel to be a number but was ', typeof src.nbar, src.nbar)
                        }
                    }
                    if (src.ncomb !== undefined && src.ncomb !== null) {
                        if (typeof src.ncomb === "number" || src.ncomb === 'NaN' || src.ncomb === 'Infinity' || src.ncomb === '-Infinity') {
                            dst.ncomb = NumberToInt("ng.fem_design.analysis_data.InformationSteel.ncomb", AsNum(src.ncomb));
                        }
                        else {
                            console.log('Expected ncomb of InformationSteel to be a number but was ', typeof src.ncomb, src.ncomb)
                        }
                    }
                    if (src.loadComb !== undefined && src.loadComb !== null) {
                        if (Array.isArray(src.loadComb)) {
                            for (const element of src.loadComb) {
                                dst.loadComb.push(ng.fem_design.analysis_data.LoadCombRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadComb of InformationSteel to be a array but was ', typeof src.loadComb, src.loadComb)
                        }
                    }
                    if (src.barResult !== undefined && src.barResult !== null) {
                        if (Array.isArray(src.barResult)) {
                            for (const element of src.barResult) {
                                dst.barResult.push(ng.fem_design.analysis_data.BarResultRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected barResult of InformationSteel to be a array but was ', typeof src.barResult, src.barResult)
                        }
                    }
                    if (src.barFireProt !== undefined && src.barFireProt !== null) {
                        if (Array.isArray(src.barFireProt)) {
                            for (const element of src.barFireProt) {
                                dst.barFireProt.push(ng.fem_design.analysis_data.BarSteelFireProtRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected barFireProt of InformationSteel to be a array but was ', typeof src.barFireProt, src.barFireProt)
                        }
                    }
                    return dst;
                }

                static toObject(src: InformationSteel | null | undefined): InformationSteel_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.InformationSteel is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.InformationSteel") {
                        console.error('Expected ng.fem_design.analysis_data.InformationSteel but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : InformationSteel_json = {
                        version: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.InformationSteel.version", src.version)),
                        nbar: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.InformationSteel.nbar", src.nbar)),
                        ncomb: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.InformationSteel.ncomb", src.ncomb)),
                        loadComb: new Array<ng.fem_design.analysis_data.LoadCombRecord_json>(),
                        barResult: new Array<ng.fem_design.analysis_data.BarResultRecord_json>(),
                        barFireProt: new Array<ng.fem_design.analysis_data.BarSteelFireProtRecord_json>(),
                    };
                    if (src.loadComb !== null) {
                        for (const element of src.loadComb) {
                            const parsed = ng.fem_design.analysis_data.LoadCombRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.loadComb.push(parsed);
                        }
                    }
                    if (src.barResult !== null) {
                        for (const element of src.barResult) {
                            const parsed = ng.fem_design.analysis_data.BarResultRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.barResult.push(parsed);
                        }
                    }
                    if (src.barFireProt !== null) {
                        for (const element of src.barFireProt) {
                            const parsed = ng.fem_design.analysis_data.BarSteelFireProtRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.barFireProt.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: InformationSteel_createType) {
                    const dst = new InformationSteel();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.version !== undefined) {
                        dst.version = src.version;
                    }
                    if (src.nbar !== undefined) {
                        dst.nbar = src.nbar;
                    }
                    if (src.ncomb !== undefined) {
                        dst.ncomb = src.ncomb;
                    }
                    if (src.loadComb !== undefined) {
                        dst.loadComb = src.loadComb;
                    }
                    if (src.barResult !== undefined) {
                        dst.barResult = src.barResult;
                    }
                    if (src.barFireProt !== undefined) {
                        dst.barFireProt = src.barFireProt;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new InformationSteel();
                    dst.version = this.version;
                    dst.nbar = this.nbar;
                    dst.ncomb = this.ncomb;
                    dst.loadComb = this.loadComb;
                    dst.barResult = this.barResult;
                    dst.barFireProt = this.barFireProt;
                    return dst;
                }

                deepClone() {
                    const json = InformationSteel.toObject(this);
                    const dst = InformationSteel.fromObject(json);
                    return dst;
                }
            }
            export type IInformationSteel = InformationSteel;


            export type InformationTimber_keys = 'version' | 'nbar' | 'ncomb' | 'loadComb' | 'barResult' | 'barFireProt';
            export interface InformationTimber_createType {
                version?: number,
                nbar?: number,
                ncomb?: number,
                loadComb?: ng.fem_design.analysis_data.LoadCombTimberRecord[],
                barResult?: ng.fem_design.analysis_data.BarResultRecord[],
                barFireProt?: ng.fem_design.analysis_data.BarTimberFireProtRecord[],
            }
            export interface InformationTimber_json {
                version?: JsonNumber;
                nbar?: JsonNumber;
                ncomb?: JsonNumber;
                loadComb: ng.fem_design.analysis_data.LoadCombTimberRecord_json[];
                barResult: ng.fem_design.analysis_data.BarResultRecord_json[];
                barFireProt: ng.fem_design.analysis_data.BarTimberFireProtRecord_json[];
            }
            interface InformationTimber_json_in {
                __proto_name?: unknown;
                version?: unknown;
                nbar?: unknown;
                ncomb?: unknown;
                loadComb?: unknown;
                barResult?: unknown;
                barFireProt?: unknown;
            }
            export class InformationTimber {
                __proto_name = "ng.fem_design.analysis_data.InformationTimber";
                version: number = 0;
                nbar: number = 0;
                ncomb: number = 0;
                loadComb: ng.fem_design.analysis_data.LoadCombTimberRecord[] = [];
                barResult: ng.fem_design.analysis_data.BarResultRecord[] = [];
                barFireProt: ng.fem_design.analysis_data.BarTimberFireProtRecord[] = [];

                static fromObject(src_unknown: unknown): InformationTimber {
                    const dst = new InformationTimber();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted InformationTimber but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as InformationTimber_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for InformationTimber but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.version !== undefined && src.version !== null) {
                        if (typeof src.version === "number" || src.version === 'NaN' || src.version === 'Infinity' || src.version === '-Infinity') {
                            dst.version = NumberToInt("ng.fem_design.analysis_data.InformationTimber.version", AsNum(src.version));
                        }
                        else {
                            console.log('Expected version of InformationTimber to be a number but was ', typeof src.version, src.version)
                        }
                    }
                    if (src.nbar !== undefined && src.nbar !== null) {
                        if (typeof src.nbar === "number" || src.nbar === 'NaN' || src.nbar === 'Infinity' || src.nbar === '-Infinity') {
                            dst.nbar = NumberToInt("ng.fem_design.analysis_data.InformationTimber.nbar", AsNum(src.nbar));
                        }
                        else {
                            console.log('Expected nbar of InformationTimber to be a number but was ', typeof src.nbar, src.nbar)
                        }
                    }
                    if (src.ncomb !== undefined && src.ncomb !== null) {
                        if (typeof src.ncomb === "number" || src.ncomb === 'NaN' || src.ncomb === 'Infinity' || src.ncomb === '-Infinity') {
                            dst.ncomb = NumberToInt("ng.fem_design.analysis_data.InformationTimber.ncomb", AsNum(src.ncomb));
                        }
                        else {
                            console.log('Expected ncomb of InformationTimber to be a number but was ', typeof src.ncomb, src.ncomb)
                        }
                    }
                    if (src.loadComb !== undefined && src.loadComb !== null) {
                        if (Array.isArray(src.loadComb)) {
                            for (const element of src.loadComb) {
                                dst.loadComb.push(ng.fem_design.analysis_data.LoadCombTimberRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadComb of InformationTimber to be a array but was ', typeof src.loadComb, src.loadComb)
                        }
                    }
                    if (src.barResult !== undefined && src.barResult !== null) {
                        if (Array.isArray(src.barResult)) {
                            for (const element of src.barResult) {
                                dst.barResult.push(ng.fem_design.analysis_data.BarResultRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected barResult of InformationTimber to be a array but was ', typeof src.barResult, src.barResult)
                        }
                    }
                    if (src.barFireProt !== undefined && src.barFireProt !== null) {
                        if (Array.isArray(src.barFireProt)) {
                            for (const element of src.barFireProt) {
                                dst.barFireProt.push(ng.fem_design.analysis_data.BarTimberFireProtRecord.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected barFireProt of InformationTimber to be a array but was ', typeof src.barFireProt, src.barFireProt)
                        }
                    }
                    return dst;
                }

                static toObject(src: InformationTimber | null | undefined): InformationTimber_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.fem_design.analysis_data.InformationTimber is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.fem_design.analysis_data.InformationTimber") {
                        console.error('Expected ng.fem_design.analysis_data.InformationTimber but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : InformationTimber_json = {
                        version: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.InformationTimber.version", src.version)),
                        nbar: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.InformationTimber.nbar", src.nbar)),
                        ncomb: AsJsonNum(NumberToInt("ng.fem_design.analysis_data.InformationTimber.ncomb", src.ncomb)),
                        loadComb: new Array<ng.fem_design.analysis_data.LoadCombTimberRecord_json>(),
                        barResult: new Array<ng.fem_design.analysis_data.BarResultRecord_json>(),
                        barFireProt: new Array<ng.fem_design.analysis_data.BarTimberFireProtRecord_json>(),
                    };
                    if (src.loadComb !== null) {
                        for (const element of src.loadComb) {
                            const parsed = ng.fem_design.analysis_data.LoadCombTimberRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.loadComb.push(parsed);
                        }
                    }
                    if (src.barResult !== null) {
                        for (const element of src.barResult) {
                            const parsed = ng.fem_design.analysis_data.BarResultRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.barResult.push(parsed);
                        }
                    }
                    if (src.barFireProt !== null) {
                        for (const element of src.barFireProt) {
                            const parsed = ng.fem_design.analysis_data.BarTimberFireProtRecord.toObject(element);
                            if(parsed === null) return null;
                            dst.barFireProt.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: InformationTimber_createType) {
                    const dst = new InformationTimber();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.version !== undefined) {
                        dst.version = src.version;
                    }
                    if (src.nbar !== undefined) {
                        dst.nbar = src.nbar;
                    }
                    if (src.ncomb !== undefined) {
                        dst.ncomb = src.ncomb;
                    }
                    if (src.loadComb !== undefined) {
                        dst.loadComb = src.loadComb;
                    }
                    if (src.barResult !== undefined) {
                        dst.barResult = src.barResult;
                    }
                    if (src.barFireProt !== undefined) {
                        dst.barFireProt = src.barFireProt;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new InformationTimber();
                    dst.version = this.version;
                    dst.nbar = this.nbar;
                    dst.ncomb = this.ncomb;
                    dst.loadComb = this.loadComb;
                    dst.barResult = this.barResult;
                    dst.barFireProt = this.barFireProt;
                    return dst;
                }

                deepClone() {
                    const json = InformationTimber.toObject(this);
                    const dst = InformationTimber.fromObject(json);
                    return dst;
                }
            }
            export type IInformationTimber = InformationTimber;
        } // namespace analysis_data
    } // namespace fem_design


    // Defined in 7 files
    export namespace endpoint_args {
        // Defined in EndPointArguments/common_api_functions.proto
        export namespace common_api_functions {
            export enum HealthCheckStatus {
                HEALTH_CHECK_STATUS_UNSPECIFIED = 0,
                HEALTH_CHECK_STATUS_UNHEALTHY = 1,
                HEALTH_CHECK_STATUS_DEGRADED = 2,
                HEALTH_CHECK_STATUS_HEALTHY = 3
            }
            export const HealthCheckStatus_FromObject = (src: unknown): HealthCheckStatus => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'HEALTH_CHECK_STATUS_UNSPECIFIED':
                        return HealthCheckStatus.HEALTH_CHECK_STATUS_UNSPECIFIED;
                    case 1:
                    case 'HEALTH_CHECK_STATUS_UNHEALTHY':
                        return HealthCheckStatus.HEALTH_CHECK_STATUS_UNHEALTHY;
                    case 2:
                    case 'HEALTH_CHECK_STATUS_DEGRADED':
                        return HealthCheckStatus.HEALTH_CHECK_STATUS_DEGRADED;
                    case 3:
                    case 'HEALTH_CHECK_STATUS_HEALTHY':
                        return HealthCheckStatus.HEALTH_CHECK_STATUS_HEALTHY;
                    default:
                        console.log('Unhandled value for HealthCheckStatus:' + src + '. ' + typeof(src));
                        return HealthCheckStatus.HEALTH_CHECK_STATUS_UNSPECIFIED;
                }
            };
            export const HealthCheckStatus_ToObject = (src: HealthCheckStatus): string | null => {
                switch (src) {
                    case HealthCheckStatus.HEALTH_CHECK_STATUS_UNSPECIFIED:
                        return 'HEALTH_CHECK_STATUS_UNSPECIFIED';
                    case HealthCheckStatus.HEALTH_CHECK_STATUS_UNHEALTHY:
                        return 'HEALTH_CHECK_STATUS_UNHEALTHY';
                    case HealthCheckStatus.HEALTH_CHECK_STATUS_DEGRADED:
                        return 'HEALTH_CHECK_STATUS_DEGRADED';
                    case HealthCheckStatus.HEALTH_CHECK_STATUS_HEALTHY:
                        return 'HEALTH_CHECK_STATUS_HEALTHY';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for HealthCheckStatus, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum DetailingOption {
                DETAILING_OPTION_UNSPECIFIED = 0,
                DETAILING_OPTION_BIAXIAL_SYMMETRY = 1,
                DETAILING_OPTION_UNIAXIAL_SYMMETRY = 2
            }
            export const DetailingOption_FromObject = (src: unknown): DetailingOption => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'DETAILING_OPTION_UNSPECIFIED':
                        return DetailingOption.DETAILING_OPTION_UNSPECIFIED;
                    case 1:
                    case 'DETAILING_OPTION_BIAXIAL_SYMMETRY':
                        return DetailingOption.DETAILING_OPTION_BIAXIAL_SYMMETRY;
                    case 2:
                    case 'DETAILING_OPTION_UNIAXIAL_SYMMETRY':
                        return DetailingOption.DETAILING_OPTION_UNIAXIAL_SYMMETRY;
                    default:
                        console.log('Unhandled value for DetailingOption:' + src + '. ' + typeof(src));
                        return DetailingOption.DETAILING_OPTION_UNSPECIFIED;
                }
            };
            export const DetailingOption_ToObject = (src: DetailingOption): string | null => {
                switch (src) {
                    case DetailingOption.DETAILING_OPTION_UNSPECIFIED:
                        return 'DETAILING_OPTION_UNSPECIFIED';
                    case DetailingOption.DETAILING_OPTION_BIAXIAL_SYMMETRY:
                        return 'DETAILING_OPTION_BIAXIAL_SYMMETRY';
                    case DetailingOption.DETAILING_OPTION_UNIAXIAL_SYMMETRY:
                        return 'DETAILING_OPTION_UNIAXIAL_SYMMETRY';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for DetailingOption, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export enum CodeCheckResultRequest {
                BASELINE = 0,
                RC = 100,
                RC_BEND_SLS = 101,
                RC_BEND_SLS_CONTROLS = 102,
                RC_BEND_ULS = 103,
                RC_BEND_ULS_CONTROLS = 104,
                RC_SHEAR = 105,
                RC_SHEAR_CONTROLS = 106,
                RC_STIRRUP = 107,
                RC_STIRRUP_CONTROLS = 108,
                RC_TORSION = 109,
                RC_TORSION_CONTROLS = 110,
                RC_TOPPING = 111,
                RC_TOPPING_CONTROLS = 112,
                STEEL = 200,
                STEEL_SECTION_CLASS = 201,
                STEEL_SR = 202,
                STEEL_SR_CONTROLS = 203,
                STEEL_SR_EFFECTIVE_CLASS_FOUR = 204,
                STEEL_SR_SHEAR_1 = 205,
                STEEL_SR_SHEAR_2 = 206,
                STEEL_SR_TORSIONAL = 207,
                STEEL_SR_SHEAR_STRESS = 208,
                STEEL_SR_NORMAL_STRESS = 209,
                STEEL_SR_PURE_NORMAL_RES = 210,
                STEEL_SR_NORMAL = 211,
                STEEL_SR_FLEXURAL_1 = 212,
                STEEL_SR_FLEXURAL_2 = 213,
                STEEL_SR_FLEXURAL_TORSIONAL = 214,
                STEEL_SR_LATERAL_TORSIONAL_TOP = 215,
                STEEL_SR_LATERAL_TORSIONAL_BOTTOM = 216,
                STEEL_SR_INTERACTION_1 = 217,
                STEEL_SR_INTERACTION_2 = 218,
                STEEL_SR_INTERACTION_2ND = 219,
                STEEL_SR_WEB = 220,
                TIMBER = 300,
                TIMBER_SR = 301,
                TIMBER_SR_CONTROLS = 302,
                TIMBER_SR_TENSION = 303,
                TIMBER_SR_COMPRESSION = 304,
                TIMBER_SR_SHEAR = 305,
                TIMBER_SR_FLEXURAL_BUCKLING_1 = 306,
                TIMBER_SR_FLEXURAL_BUCKLING_2 = 307,
                TIMBER_SR_TORSIONAL_BUCKLING = 308,
                TIMBER_SR_APEX = 309,
                TIMBER_SR_TAPER = 310,
                TIMBER_SR_DESIGN_STRENGTH = 311,
                FOUNDATION = 400,
                FOUNDATION_RESULT_ANALYSIS = 401,
                FOUNDATION_RESULT_DESIGN = 402,
                FOUNDATION_RESULT_PUNCHING = 403,
                FOUNDATION_RESULT_UNREINFORCED = 404,
                FOUNDATION_DSSSE = 405
            }
            export const CodeCheckResultRequest_FromObject = (src: unknown): CodeCheckResultRequest => {
                if (typeof src == 'string') { src = src.trim(); }
                switch (src) {
                    case 0:
                    case 'BASELINE':
                        return CodeCheckResultRequest.BASELINE;
                    case 100:
                    case 'RC':
                        return CodeCheckResultRequest.RC;
                    case 101:
                    case 'RC_BEND_SLS':
                        return CodeCheckResultRequest.RC_BEND_SLS;
                    case 102:
                    case 'RC_BEND_SLS_CONTROLS':
                        return CodeCheckResultRequest.RC_BEND_SLS_CONTROLS;
                    case 103:
                    case 'RC_BEND_ULS':
                        return CodeCheckResultRequest.RC_BEND_ULS;
                    case 104:
                    case 'RC_BEND_ULS_CONTROLS':
                        return CodeCheckResultRequest.RC_BEND_ULS_CONTROLS;
                    case 105:
                    case 'RC_SHEAR':
                        return CodeCheckResultRequest.RC_SHEAR;
                    case 106:
                    case 'RC_SHEAR_CONTROLS':
                        return CodeCheckResultRequest.RC_SHEAR_CONTROLS;
                    case 107:
                    case 'RC_STIRRUP':
                        return CodeCheckResultRequest.RC_STIRRUP;
                    case 108:
                    case 'RC_STIRRUP_CONTROLS':
                        return CodeCheckResultRequest.RC_STIRRUP_CONTROLS;
                    case 109:
                    case 'RC_TORSION':
                        return CodeCheckResultRequest.RC_TORSION;
                    case 110:
                    case 'RC_TORSION_CONTROLS':
                        return CodeCheckResultRequest.RC_TORSION_CONTROLS;
                    case 111:
                    case 'RC_TOPPING':
                        return CodeCheckResultRequest.RC_TOPPING;
                    case 112:
                    case 'RC_TOPPING_CONTROLS':
                        return CodeCheckResultRequest.RC_TOPPING_CONTROLS;
                    case 200:
                    case 'STEEL':
                        return CodeCheckResultRequest.STEEL;
                    case 201:
                    case 'STEEL_SECTION_CLASS':
                        return CodeCheckResultRequest.STEEL_SECTION_CLASS;
                    case 202:
                    case 'STEEL_SR':
                        return CodeCheckResultRequest.STEEL_SR;
                    case 203:
                    case 'STEEL_SR_CONTROLS':
                        return CodeCheckResultRequest.STEEL_SR_CONTROLS;
                    case 204:
                    case 'STEEL_SR_EFFECTIVE_CLASS_FOUR':
                        return CodeCheckResultRequest.STEEL_SR_EFFECTIVE_CLASS_FOUR;
                    case 205:
                    case 'STEEL_SR_SHEAR_1':
                        return CodeCheckResultRequest.STEEL_SR_SHEAR_1;
                    case 206:
                    case 'STEEL_SR_SHEAR_2':
                        return CodeCheckResultRequest.STEEL_SR_SHEAR_2;
                    case 207:
                    case 'STEEL_SR_TORSIONAL':
                        return CodeCheckResultRequest.STEEL_SR_TORSIONAL;
                    case 208:
                    case 'STEEL_SR_SHEAR_STRESS':
                        return CodeCheckResultRequest.STEEL_SR_SHEAR_STRESS;
                    case 209:
                    case 'STEEL_SR_NORMAL_STRESS':
                        return CodeCheckResultRequest.STEEL_SR_NORMAL_STRESS;
                    case 210:
                    case 'STEEL_SR_PURE_NORMAL_RES':
                        return CodeCheckResultRequest.STEEL_SR_PURE_NORMAL_RES;
                    case 211:
                    case 'STEEL_SR_NORMAL':
                        return CodeCheckResultRequest.STEEL_SR_NORMAL;
                    case 212:
                    case 'STEEL_SR_FLEXURAL_1':
                        return CodeCheckResultRequest.STEEL_SR_FLEXURAL_1;
                    case 213:
                    case 'STEEL_SR_FLEXURAL_2':
                        return CodeCheckResultRequest.STEEL_SR_FLEXURAL_2;
                    case 214:
                    case 'STEEL_SR_FLEXURAL_TORSIONAL':
                        return CodeCheckResultRequest.STEEL_SR_FLEXURAL_TORSIONAL;
                    case 215:
                    case 'STEEL_SR_LATERAL_TORSIONAL_TOP':
                        return CodeCheckResultRequest.STEEL_SR_LATERAL_TORSIONAL_TOP;
                    case 216:
                    case 'STEEL_SR_LATERAL_TORSIONAL_BOTTOM':
                        return CodeCheckResultRequest.STEEL_SR_LATERAL_TORSIONAL_BOTTOM;
                    case 217:
                    case 'STEEL_SR_INTERACTION_1':
                        return CodeCheckResultRequest.STEEL_SR_INTERACTION_1;
                    case 218:
                    case 'STEEL_SR_INTERACTION_2':
                        return CodeCheckResultRequest.STEEL_SR_INTERACTION_2;
                    case 219:
                    case 'STEEL_SR_INTERACTION_2ND':
                        return CodeCheckResultRequest.STEEL_SR_INTERACTION_2ND;
                    case 220:
                    case 'STEEL_SR_WEB':
                        return CodeCheckResultRequest.STEEL_SR_WEB;
                    case 300:
                    case 'TIMBER':
                        return CodeCheckResultRequest.TIMBER;
                    case 301:
                    case 'TIMBER_SR':
                        return CodeCheckResultRequest.TIMBER_SR;
                    case 302:
                    case 'TIMBER_SR_CONTROLS':
                        return CodeCheckResultRequest.TIMBER_SR_CONTROLS;
                    case 303:
                    case 'TIMBER_SR_TENSION':
                        return CodeCheckResultRequest.TIMBER_SR_TENSION;
                    case 304:
                    case 'TIMBER_SR_COMPRESSION':
                        return CodeCheckResultRequest.TIMBER_SR_COMPRESSION;
                    case 305:
                    case 'TIMBER_SR_SHEAR':
                        return CodeCheckResultRequest.TIMBER_SR_SHEAR;
                    case 306:
                    case 'TIMBER_SR_FLEXURAL_BUCKLING_1':
                        return CodeCheckResultRequest.TIMBER_SR_FLEXURAL_BUCKLING_1;
                    case 307:
                    case 'TIMBER_SR_FLEXURAL_BUCKLING_2':
                        return CodeCheckResultRequest.TIMBER_SR_FLEXURAL_BUCKLING_2;
                    case 308:
                    case 'TIMBER_SR_TORSIONAL_BUCKLING':
                        return CodeCheckResultRequest.TIMBER_SR_TORSIONAL_BUCKLING;
                    case 309:
                    case 'TIMBER_SR_APEX':
                        return CodeCheckResultRequest.TIMBER_SR_APEX;
                    case 310:
                    case 'TIMBER_SR_TAPER':
                        return CodeCheckResultRequest.TIMBER_SR_TAPER;
                    case 311:
                    case 'TIMBER_SR_DESIGN_STRENGTH':
                        return CodeCheckResultRequest.TIMBER_SR_DESIGN_STRENGTH;
                    case 400:
                    case 'FOUNDATION':
                        return CodeCheckResultRequest.FOUNDATION;
                    case 401:
                    case 'FOUNDATION_RESULT_ANALYSIS':
                        return CodeCheckResultRequest.FOUNDATION_RESULT_ANALYSIS;
                    case 402:
                    case 'FOUNDATION_RESULT_DESIGN':
                        return CodeCheckResultRequest.FOUNDATION_RESULT_DESIGN;
                    case 403:
                    case 'FOUNDATION_RESULT_PUNCHING':
                        return CodeCheckResultRequest.FOUNDATION_RESULT_PUNCHING;
                    case 404:
                    case 'FOUNDATION_RESULT_UNREINFORCED':
                        return CodeCheckResultRequest.FOUNDATION_RESULT_UNREINFORCED;
                    case 405:
                    case 'FOUNDATION_DSSSE':
                        return CodeCheckResultRequest.FOUNDATION_DSSSE;
                    default:
                        console.log('Unhandled value for CodeCheckResultRequest:' + src + '. ' + typeof(src));
                        return CodeCheckResultRequest.BASELINE;
                }
            };
            export const CodeCheckResultRequest_ToObject = (src: CodeCheckResultRequest): string | null => {
                switch (src) {
                    case CodeCheckResultRequest.BASELINE:
                        return 'BASELINE';
                    case CodeCheckResultRequest.RC:
                        return 'RC';
                    case CodeCheckResultRequest.RC_BEND_SLS:
                        return 'RC_BEND_SLS';
                    case CodeCheckResultRequest.RC_BEND_SLS_CONTROLS:
                        return 'RC_BEND_SLS_CONTROLS';
                    case CodeCheckResultRequest.RC_BEND_ULS:
                        return 'RC_BEND_ULS';
                    case CodeCheckResultRequest.RC_BEND_ULS_CONTROLS:
                        return 'RC_BEND_ULS_CONTROLS';
                    case CodeCheckResultRequest.RC_SHEAR:
                        return 'RC_SHEAR';
                    case CodeCheckResultRequest.RC_SHEAR_CONTROLS:
                        return 'RC_SHEAR_CONTROLS';
                    case CodeCheckResultRequest.RC_STIRRUP:
                        return 'RC_STIRRUP';
                    case CodeCheckResultRequest.RC_STIRRUP_CONTROLS:
                        return 'RC_STIRRUP_CONTROLS';
                    case CodeCheckResultRequest.RC_TORSION:
                        return 'RC_TORSION';
                    case CodeCheckResultRequest.RC_TORSION_CONTROLS:
                        return 'RC_TORSION_CONTROLS';
                    case CodeCheckResultRequest.RC_TOPPING:
                        return 'RC_TOPPING';
                    case CodeCheckResultRequest.RC_TOPPING_CONTROLS:
                        return 'RC_TOPPING_CONTROLS';
                    case CodeCheckResultRequest.STEEL:
                        return 'STEEL';
                    case CodeCheckResultRequest.STEEL_SECTION_CLASS:
                        return 'STEEL_SECTION_CLASS';
                    case CodeCheckResultRequest.STEEL_SR:
                        return 'STEEL_SR';
                    case CodeCheckResultRequest.STEEL_SR_CONTROLS:
                        return 'STEEL_SR_CONTROLS';
                    case CodeCheckResultRequest.STEEL_SR_EFFECTIVE_CLASS_FOUR:
                        return 'STEEL_SR_EFFECTIVE_CLASS_FOUR';
                    case CodeCheckResultRequest.STEEL_SR_SHEAR_1:
                        return 'STEEL_SR_SHEAR_1';
                    case CodeCheckResultRequest.STEEL_SR_SHEAR_2:
                        return 'STEEL_SR_SHEAR_2';
                    case CodeCheckResultRequest.STEEL_SR_TORSIONAL:
                        return 'STEEL_SR_TORSIONAL';
                    case CodeCheckResultRequest.STEEL_SR_SHEAR_STRESS:
                        return 'STEEL_SR_SHEAR_STRESS';
                    case CodeCheckResultRequest.STEEL_SR_NORMAL_STRESS:
                        return 'STEEL_SR_NORMAL_STRESS';
                    case CodeCheckResultRequest.STEEL_SR_PURE_NORMAL_RES:
                        return 'STEEL_SR_PURE_NORMAL_RES';
                    case CodeCheckResultRequest.STEEL_SR_NORMAL:
                        return 'STEEL_SR_NORMAL';
                    case CodeCheckResultRequest.STEEL_SR_FLEXURAL_1:
                        return 'STEEL_SR_FLEXURAL_1';
                    case CodeCheckResultRequest.STEEL_SR_FLEXURAL_2:
                        return 'STEEL_SR_FLEXURAL_2';
                    case CodeCheckResultRequest.STEEL_SR_FLEXURAL_TORSIONAL:
                        return 'STEEL_SR_FLEXURAL_TORSIONAL';
                    case CodeCheckResultRequest.STEEL_SR_LATERAL_TORSIONAL_TOP:
                        return 'STEEL_SR_LATERAL_TORSIONAL_TOP';
                    case CodeCheckResultRequest.STEEL_SR_LATERAL_TORSIONAL_BOTTOM:
                        return 'STEEL_SR_LATERAL_TORSIONAL_BOTTOM';
                    case CodeCheckResultRequest.STEEL_SR_INTERACTION_1:
                        return 'STEEL_SR_INTERACTION_1';
                    case CodeCheckResultRequest.STEEL_SR_INTERACTION_2:
                        return 'STEEL_SR_INTERACTION_2';
                    case CodeCheckResultRequest.STEEL_SR_INTERACTION_2ND:
                        return 'STEEL_SR_INTERACTION_2ND';
                    case CodeCheckResultRequest.STEEL_SR_WEB:
                        return 'STEEL_SR_WEB';
                    case CodeCheckResultRequest.TIMBER:
                        return 'TIMBER';
                    case CodeCheckResultRequest.TIMBER_SR:
                        return 'TIMBER_SR';
                    case CodeCheckResultRequest.TIMBER_SR_CONTROLS:
                        return 'TIMBER_SR_CONTROLS';
                    case CodeCheckResultRequest.TIMBER_SR_TENSION:
                        return 'TIMBER_SR_TENSION';
                    case CodeCheckResultRequest.TIMBER_SR_COMPRESSION:
                        return 'TIMBER_SR_COMPRESSION';
                    case CodeCheckResultRequest.TIMBER_SR_SHEAR:
                        return 'TIMBER_SR_SHEAR';
                    case CodeCheckResultRequest.TIMBER_SR_FLEXURAL_BUCKLING_1:
                        return 'TIMBER_SR_FLEXURAL_BUCKLING_1';
                    case CodeCheckResultRequest.TIMBER_SR_FLEXURAL_BUCKLING_2:
                        return 'TIMBER_SR_FLEXURAL_BUCKLING_2';
                    case CodeCheckResultRequest.TIMBER_SR_TORSIONAL_BUCKLING:
                        return 'TIMBER_SR_TORSIONAL_BUCKLING';
                    case CodeCheckResultRequest.TIMBER_SR_APEX:
                        return 'TIMBER_SR_APEX';
                    case CodeCheckResultRequest.TIMBER_SR_TAPER:
                        return 'TIMBER_SR_TAPER';
                    case CodeCheckResultRequest.TIMBER_SR_DESIGN_STRENGTH:
                        return 'TIMBER_SR_DESIGN_STRENGTH';
                    case CodeCheckResultRequest.FOUNDATION:
                        return 'FOUNDATION';
                    case CodeCheckResultRequest.FOUNDATION_RESULT_ANALYSIS:
                        return 'FOUNDATION_RESULT_ANALYSIS';
                    case CodeCheckResultRequest.FOUNDATION_RESULT_DESIGN:
                        return 'FOUNDATION_RESULT_DESIGN';
                    case CodeCheckResultRequest.FOUNDATION_RESULT_PUNCHING:
                        return 'FOUNDATION_RESULT_PUNCHING';
                    case CodeCheckResultRequest.FOUNDATION_RESULT_UNREINFORCED:
                        return 'FOUNDATION_RESULT_UNREINFORCED';
                    case CodeCheckResultRequest.FOUNDATION_DSSSE:
                        return 'FOUNDATION_DSSSE';
                    default:
                        console.error(`BUG TYPE ERROR: Expected enum for CodeCheckResultRequest, but got [${src}] a ${typeof src}!!!!`);
                        return null;
                }
            };


            export type HealthCheckDuration_keys = 'days' | 'hours' | 'minutes' | 'seconds' | 'milliseconds';
            export interface HealthCheckDuration_createType {
                days?: number,
                hours?: number,
                minutes?: number,
                seconds?: number,
                milliseconds?: number,
            }
            export interface HealthCheckDuration_json {
                days?: JsonNumber;
                hours?: JsonNumber;
                minutes?: JsonNumber;
                seconds?: JsonNumber;
                milliseconds?: JsonNumber;
            }
            interface HealthCheckDuration_json_in {
                __proto_name?: unknown;
                days?: unknown;
                hours?: unknown;
                minutes?: unknown;
                seconds?: unknown;
                milliseconds?: unknown;
            }
            export class HealthCheckDuration {
                __proto_name = "ng.endpoint_args.common_api_functions.HealthCheckDuration";
                days: number = 0;
                hours: number = 0;
                minutes: number = 0;
                seconds: number = 0;
                milliseconds: number = 0;

                static fromObject(src_unknown: unknown): HealthCheckDuration {
                    const dst = new HealthCheckDuration();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted HealthCheckDuration but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as HealthCheckDuration_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for HealthCheckDuration but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.days !== undefined && src.days !== null) {
                        if (typeof src.days === "number" || src.days === 'NaN' || src.days === 'Infinity' || src.days === '-Infinity') {
                            dst.days = NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.days", AsNum(src.days));
                        }
                        else {
                            console.log('Expected days of HealthCheckDuration to be a number but was ', typeof src.days, src.days)
                        }
                    }
                    if (src.hours !== undefined && src.hours !== null) {
                        if (typeof src.hours === "number" || src.hours === 'NaN' || src.hours === 'Infinity' || src.hours === '-Infinity') {
                            dst.hours = NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.hours", AsNum(src.hours));
                        }
                        else {
                            console.log('Expected hours of HealthCheckDuration to be a number but was ', typeof src.hours, src.hours)
                        }
                    }
                    if (src.minutes !== undefined && src.minutes !== null) {
                        if (typeof src.minutes === "number" || src.minutes === 'NaN' || src.minutes === 'Infinity' || src.minutes === '-Infinity') {
                            dst.minutes = NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.minutes", AsNum(src.minutes));
                        }
                        else {
                            console.log('Expected minutes of HealthCheckDuration to be a number but was ', typeof src.minutes, src.minutes)
                        }
                    }
                    if (src.seconds !== undefined && src.seconds !== null) {
                        if (typeof src.seconds === "number" || src.seconds === 'NaN' || src.seconds === 'Infinity' || src.seconds === '-Infinity') {
                            dst.seconds = NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.seconds", AsNum(src.seconds));
                        }
                        else {
                            console.log('Expected seconds of HealthCheckDuration to be a number but was ', typeof src.seconds, src.seconds)
                        }
                    }
                    if (src.milliseconds !== undefined && src.milliseconds !== null) {
                        if (typeof src.milliseconds === "number" || src.milliseconds === 'NaN' || src.milliseconds === 'Infinity' || src.milliseconds === '-Infinity') {
                            dst.milliseconds = NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.milliseconds", AsNum(src.milliseconds));
                        }
                        else {
                            console.log('Expected milliseconds of HealthCheckDuration to be a number but was ', typeof src.milliseconds, src.milliseconds)
                        }
                    }
                    return dst;
                }

                static toObject(src: HealthCheckDuration | null | undefined): HealthCheckDuration_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.HealthCheckDuration is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.HealthCheckDuration") {
                        console.error('Expected ng.endpoint_args.common_api_functions.HealthCheckDuration but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : HealthCheckDuration_json = {
                        days: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.days", src.days)),
                        hours: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.hours", src.hours)),
                        minutes: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.minutes", src.minutes)),
                        seconds: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.seconds", src.seconds)),
                        milliseconds: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.HealthCheckDuration.milliseconds", src.milliseconds)),
                    };
                    return dst;
                }

                static create(src?: HealthCheckDuration_createType) {
                    const dst = new HealthCheckDuration();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.days !== undefined) {
                        dst.days = src.days;
                    }
                    if (src.hours !== undefined) {
                        dst.hours = src.hours;
                    }
                    if (src.minutes !== undefined) {
                        dst.minutes = src.minutes;
                    }
                    if (src.seconds !== undefined) {
                        dst.seconds = src.seconds;
                    }
                    if (src.milliseconds !== undefined) {
                        dst.milliseconds = src.milliseconds;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new HealthCheckDuration();
                    dst.days = this.days;
                    dst.hours = this.hours;
                    dst.minutes = this.minutes;
                    dst.seconds = this.seconds;
                    dst.milliseconds = this.milliseconds;
                    return dst;
                }

                deepClone() {
                    const json = HealthCheckDuration.toObject(this);
                    const dst = HealthCheckDuration.fromObject(json);
                    return dst;
                }
            }
            export type IHealthCheckDuration = HealthCheckDuration;


            export type HealthCheckData_keys = 'key' | 'value';
            export interface HealthCheckData_createType {
                key?: string,
                value?: string,
            }
            export interface HealthCheckData_json {
                key?: string;
                value?: string;
            }
            interface HealthCheckData_json_in {
                __proto_name?: unknown;
                key?: unknown;
                value?: unknown;
            }
            export class HealthCheckData {
                __proto_name = "ng.endpoint_args.common_api_functions.HealthCheckData";
                key: string = "";
                value: string = "";

                static fromObject(src_unknown: unknown): HealthCheckData {
                    const dst = new HealthCheckData();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted HealthCheckData but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as HealthCheckData_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for HealthCheckData but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.key !== undefined && src.key !== null) {
                        if (typeof src.key === "string") {
                            dst.key = src.key;
                        }
                        else {
                            console.log('Expected key of HealthCheckData to be a string but was ', typeof src.key, src.key)
                        }
                    }
                    if (src.value !== undefined && src.value !== null) {
                        if (typeof src.value === "string") {
                            dst.value = src.value;
                        }
                        else {
                            console.log('Expected value of HealthCheckData to be a string but was ', typeof src.value, src.value)
                        }
                    }
                    return dst;
                }

                static toObject(src: HealthCheckData | null | undefined): HealthCheckData_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.HealthCheckData is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.HealthCheckData") {
                        console.error('Expected ng.endpoint_args.common_api_functions.HealthCheckData but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : HealthCheckData_json = {
                        key: src.key,
                        value: src.value,
                    };
                    return dst;
                }

                static create(src?: HealthCheckData_createType) {
                    const dst = new HealthCheckData();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.key !== undefined) {
                        dst.key = src.key;
                    }
                    if (src.value !== undefined) {
                        dst.value = src.value;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new HealthCheckData();
                    dst.key = this.key;
                    dst.value = this.value;
                    return dst;
                }

                deepClone() {
                    const json = HealthCheckData.toObject(this);
                    const dst = HealthCheckData.fromObject(json);
                    return dst;
                }
            }
            export type IHealthCheckData = HealthCheckData;


            export type HealthCheckEntry_keys = 'name' | 'status' | 'description' | 'duration' | 'data';
            export interface HealthCheckEntry_createType {
                name?: string,
                status?: ng.endpoint_args.common_api_functions.HealthCheckStatus,
                description?: string,
                duration?: ng.endpoint_args.common_api_functions.HealthCheckDuration | null,
                data?: ng.endpoint_args.common_api_functions.HealthCheckData[],
            }
            export interface HealthCheckEntry_json {
                name?: string;
                status?: string;
                description?: string;
                duration?: ng.endpoint_args.common_api_functions.HealthCheckDuration_json;
                data: ng.endpoint_args.common_api_functions.HealthCheckData_json[];
            }
            interface HealthCheckEntry_json_in {
                __proto_name?: unknown;
                name?: unknown;
                status?: unknown;
                description?: unknown;
                duration?: unknown;
                data?: unknown;
            }
            export class HealthCheckEntry {
                __proto_name = "ng.endpoint_args.common_api_functions.HealthCheckEntry";
                name: string = "";
                status: ng.endpoint_args.common_api_functions.HealthCheckStatus = ng.endpoint_args.common_api_functions.HealthCheckStatus.HEALTH_CHECK_STATUS_UNSPECIFIED;
                description: string = "";
                duration: ng.endpoint_args.common_api_functions.HealthCheckDuration | null = null;
                data: ng.endpoint_args.common_api_functions.HealthCheckData[] = [];

                static fromObject(src_unknown: unknown): HealthCheckEntry {
                    const dst = new HealthCheckEntry();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted HealthCheckEntry but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as HealthCheckEntry_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for HealthCheckEntry but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.name !== undefined && src.name !== null) {
                        if (typeof src.name === "string") {
                            dst.name = src.name;
                        }
                        else {
                            console.log('Expected name of HealthCheckEntry to be a string but was ', typeof src.name, src.name)
                        }
                    }
                    if (src.status !== undefined && src.status !== null) {
                        dst.status = ng.endpoint_args.common_api_functions.HealthCheckStatus_FromObject(src.status);
                    }
                    if (src.description !== undefined && src.description !== null) {
                        if (typeof src.description === "string") {
                            dst.description = src.description;
                        }
                        else {
                            console.log('Expected description of HealthCheckEntry to be a string but was ', typeof src.description, src.description)
                        }
                    }
                    if (src.duration !== undefined && src.duration !== null) {
                        dst.duration = ng.endpoint_args.common_api_functions.HealthCheckDuration.fromObject(src.duration);
                    }
                    if (src.data !== undefined && src.data !== null) {
                        if (Array.isArray(src.data)) {
                            for (const element of src.data) {
                                dst.data.push(ng.endpoint_args.common_api_functions.HealthCheckData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected data of HealthCheckEntry to be a array but was ', typeof src.data, src.data)
                        }
                    }
                    return dst;
                }

                static toObject(src: HealthCheckEntry | null | undefined): HealthCheckEntry_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.HealthCheckEntry is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.HealthCheckEntry") {
                        console.error('Expected ng.endpoint_args.common_api_functions.HealthCheckEntry but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const status_obj = ng.endpoint_args.common_api_functions.HealthCheckStatus_ToObject(src.status);
                    if(status_obj === null) return null;

                    const dst : HealthCheckEntry_json = {
                        name: src.name,
                        status: status_obj,
                        description: src.description,
                        data: new Array<ng.endpoint_args.common_api_functions.HealthCheckData_json>(),
                    };
                    if(src.duration !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.HealthCheckDuration.toObject(src.duration);
                        if(parsed === null) return null;
                        dst.duration = parsed;
                    }
                    if (src.data !== null) {
                        for (const element of src.data) {
                            const parsed = ng.endpoint_args.common_api_functions.HealthCheckData.toObject(element);
                            if(parsed === null) return null;
                            dst.data.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: HealthCheckEntry_createType) {
                    const dst = new HealthCheckEntry();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.name !== undefined) {
                        dst.name = src.name;
                    }
                    if (src.status !== undefined) {
                        dst.status = src.status;
                    }
                    if (src.description !== undefined) {
                        dst.description = src.description;
                    }
                    if (src.duration !== undefined) {
                        dst.duration = src.duration;
                    }
                    if (src.data !== undefined) {
                        dst.data = src.data;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new HealthCheckEntry();
                    dst.name = this.name;
                    dst.status = this.status;
                    dst.description = this.description;
                    dst.duration = this.duration;
                    dst.data = this.data;
                    return dst;
                }

                deepClone() {
                    const json = HealthCheckEntry.toObject(this);
                    const dst = HealthCheckEntry.fromObject(json);
                    return dst;
                }
            }
            export type IHealthCheckEntry = HealthCheckEntry;


            export type HealthCheckResponse_keys = 'status' | 'totalDuration' | 'entries';
            export interface HealthCheckResponse_createType {
                status?: ng.endpoint_args.common_api_functions.HealthCheckStatus,
                totalDuration?: ng.endpoint_args.common_api_functions.HealthCheckDuration | null,
                entries?: ng.endpoint_args.common_api_functions.HealthCheckEntry[],
            }
            export interface HealthCheckResponse_json {
                status?: string;
                totalDuration?: ng.endpoint_args.common_api_functions.HealthCheckDuration_json;
                entries: ng.endpoint_args.common_api_functions.HealthCheckEntry_json[];
            }
            interface HealthCheckResponse_json_in {
                __proto_name?: unknown;
                status?: unknown;
                totalDuration?: unknown;
                entries?: unknown;
            }
            export class HealthCheckResponse {
                __proto_name = "ng.endpoint_args.common_api_functions.HealthCheckResponse";
                status: ng.endpoint_args.common_api_functions.HealthCheckStatus = ng.endpoint_args.common_api_functions.HealthCheckStatus.HEALTH_CHECK_STATUS_UNSPECIFIED;
                totalDuration: ng.endpoint_args.common_api_functions.HealthCheckDuration | null = null;
                entries: ng.endpoint_args.common_api_functions.HealthCheckEntry[] = [];

                static fromObject(src_unknown: unknown): HealthCheckResponse {
                    const dst = new HealthCheckResponse();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted HealthCheckResponse but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as HealthCheckResponse_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for HealthCheckResponse but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.status !== undefined && src.status !== null) {
                        dst.status = ng.endpoint_args.common_api_functions.HealthCheckStatus_FromObject(src.status);
                    }
                    if (src.totalDuration !== undefined && src.totalDuration !== null) {
                        dst.totalDuration = ng.endpoint_args.common_api_functions.HealthCheckDuration.fromObject(src.totalDuration);
                    }
                    if (src.entries !== undefined && src.entries !== null) {
                        if (Array.isArray(src.entries)) {
                            for (const element of src.entries) {
                                dst.entries.push(ng.endpoint_args.common_api_functions.HealthCheckEntry.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected entries of HealthCheckResponse to be a array but was ', typeof src.entries, src.entries)
                        }
                    }
                    return dst;
                }

                static toObject(src: HealthCheckResponse | null | undefined): HealthCheckResponse_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.HealthCheckResponse is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.HealthCheckResponse") {
                        console.error('Expected ng.endpoint_args.common_api_functions.HealthCheckResponse but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const status_obj = ng.endpoint_args.common_api_functions.HealthCheckStatus_ToObject(src.status);
                    if(status_obj === null) return null;

                    const dst : HealthCheckResponse_json = {
                        status: status_obj,
                        entries: new Array<ng.endpoint_args.common_api_functions.HealthCheckEntry_json>(),
                    };
                    if(src.totalDuration !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.HealthCheckDuration.toObject(src.totalDuration);
                        if(parsed === null) return null;
                        dst.totalDuration = parsed;
                    }
                    if (src.entries !== null) {
                        for (const element of src.entries) {
                            const parsed = ng.endpoint_args.common_api_functions.HealthCheckEntry.toObject(element);
                            if(parsed === null) return null;
                            dst.entries.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: HealthCheckResponse_createType) {
                    const dst = new HealthCheckResponse();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.status !== undefined) {
                        dst.status = src.status;
                    }
                    if (src.totalDuration !== undefined) {
                        dst.totalDuration = src.totalDuration;
                    }
                    if (src.entries !== undefined) {
                        dst.entries = src.entries;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new HealthCheckResponse();
                    dst.status = this.status;
                    dst.totalDuration = this.totalDuration;
                    dst.entries = this.entries;
                    return dst;
                }

                deepClone() {
                    const json = HealthCheckResponse.toObject(this);
                    const dst = HealthCheckResponse.fromObject(json);
                    return dst;
                }
            }
            export type IHealthCheckResponse = HealthCheckResponse;


            export type AdminReport_keys = 'name' | 'calculationTime' | 'errorEntries' | 'callCount';
            export interface AdminReport_createType {
                name?: string,
                calculationTime?: ng.endpoint_args.common_api_functions.AdminReport.CalculationTime | null,
                errorEntries?: ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry[],
                callCount?: ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry[],
            }
            export interface AdminReport_json {
                name?: string;
                calculationTime?: ng.endpoint_args.common_api_functions.AdminReport.CalculationTime_json;
                errorEntries: ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry_json[];
                callCount: ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry_json[];
            }
            interface AdminReport_json_in {
                __proto_name?: unknown;
                name?: unknown;
                calculationTime?: unknown;
                errorEntries?: unknown;
                callCount?: unknown;
            }
            export class AdminReport {
                __proto_name = "ng.endpoint_args.common_api_functions.AdminReport";
                name: string = "";
                calculationTime: ng.endpoint_args.common_api_functions.AdminReport.CalculationTime | null = null;
                errorEntries: ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry[] = [];
                callCount: ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry[] = [];

                static fromObject(src_unknown: unknown): AdminReport {
                    const dst = new AdminReport();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AdminReport but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AdminReport_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AdminReport but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.name !== undefined && src.name !== null) {
                        if (typeof src.name === "string") {
                            dst.name = src.name;
                        }
                        else {
                            console.log('Expected name of AdminReport to be a string but was ', typeof src.name, src.name)
                        }
                    }
                    if (src.calculationTime !== undefined && src.calculationTime !== null) {
                        dst.calculationTime = ng.endpoint_args.common_api_functions.AdminReport.CalculationTime.fromObject(src.calculationTime);
                    }
                    if (src.errorEntries !== undefined && src.errorEntries !== null) {
                        if (Array.isArray(src.errorEntries)) {
                            for (const element of src.errorEntries) {
                                dst.errorEntries.push(ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected errorEntries of AdminReport to be a array but was ', typeof src.errorEntries, src.errorEntries)
                        }
                    }
                    if (src.callCount !== undefined && src.callCount !== null) {
                        if (Array.isArray(src.callCount)) {
                            for (const element of src.callCount) {
                                dst.callCount.push(ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected callCount of AdminReport to be a array but was ', typeof src.callCount, src.callCount)
                        }
                    }
                    return dst;
                }

                static toObject(src: AdminReport | null | undefined): AdminReport_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AdminReport is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AdminReport") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AdminReport but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AdminReport_json = {
                        name: src.name,
                        errorEntries: new Array<ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry_json>(),
                        callCount: new Array<ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry_json>(),
                    };
                    if(src.calculationTime !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AdminReport.CalculationTime.toObject(src.calculationTime);
                        if(parsed === null) return null;
                        dst.calculationTime = parsed;
                    }
                    if (src.errorEntries !== null) {
                        for (const element of src.errorEntries) {
                            const parsed = ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry.toObject(element);
                            if(parsed === null) return null;
                            dst.errorEntries.push(parsed);
                        }
                    }
                    if (src.callCount !== null) {
                        for (const element of src.callCount) {
                            const parsed = ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry.toObject(element);
                            if(parsed === null) return null;
                            dst.callCount.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: AdminReport_createType) {
                    const dst = new AdminReport();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.name !== undefined) {
                        dst.name = src.name;
                    }
                    if (src.calculationTime !== undefined) {
                        dst.calculationTime = src.calculationTime;
                    }
                    if (src.errorEntries !== undefined) {
                        dst.errorEntries = src.errorEntries;
                    }
                    if (src.callCount !== undefined) {
                        dst.callCount = src.callCount;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AdminReport();
                    dst.name = this.name;
                    dst.calculationTime = this.calculationTime;
                    dst.errorEntries = this.errorEntries;
                    dst.callCount = this.callCount;
                    return dst;
                }

                deepClone() {
                    const json = AdminReport.toObject(this);
                    const dst = AdminReport.fromObject(json);
                    return dst;
                }
            }
            export type IAdminReport = AdminReport;


            export type ProtectingMaterial_keys = 'thicknessStep' | 'thicknessMin' | 'thicknessMax';
            export interface ProtectingMaterial_createType {
                thicknessStep?: number,
                thicknessMin?: number,
                thicknessMax?: number,
            }
            export interface ProtectingMaterial_json {
                thicknessStep?: JsonNumber;
                thicknessMin?: JsonNumber;
                thicknessMax?: JsonNumber;
            }
            interface ProtectingMaterial_json_in {
                __proto_name?: unknown;
                thicknessStep?: unknown;
                thicknessMin?: unknown;
                thicknessMax?: unknown;
            }
            export class ProtectingMaterial {
                __proto_name = "ng.endpoint_args.common_api_functions.ProtectingMaterial";
                thicknessStep: number = 0;
                thicknessMin: number = 0;
                thicknessMax: number = 0;

                static fromObject(src_unknown: unknown): ProtectingMaterial {
                    const dst = new ProtectingMaterial();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ProtectingMaterial but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ProtectingMaterial_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ProtectingMaterial but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.thicknessStep !== undefined && src.thicknessStep !== null) {
                        if (typeof src.thicknessStep === "number" || src.thicknessStep === 'NaN' || src.thicknessStep === 'Infinity' || src.thicknessStep === '-Infinity') {
                            dst.thicknessStep = AsNum(src.thicknessStep);
                        }
                        else {
                            console.log('Expected thicknessStep of ProtectingMaterial to be a number but was ', typeof src.thicknessStep, src.thicknessStep)
                        }
                    }
                    if (src.thicknessMin !== undefined && src.thicknessMin !== null) {
                        if (typeof src.thicknessMin === "number" || src.thicknessMin === 'NaN' || src.thicknessMin === 'Infinity' || src.thicknessMin === '-Infinity') {
                            dst.thicknessMin = AsNum(src.thicknessMin);
                        }
                        else {
                            console.log('Expected thicknessMin of ProtectingMaterial to be a number but was ', typeof src.thicknessMin, src.thicknessMin)
                        }
                    }
                    if (src.thicknessMax !== undefined && src.thicknessMax !== null) {
                        if (typeof src.thicknessMax === "number" || src.thicknessMax === 'NaN' || src.thicknessMax === 'Infinity' || src.thicknessMax === '-Infinity') {
                            dst.thicknessMax = AsNum(src.thicknessMax);
                        }
                        else {
                            console.log('Expected thicknessMax of ProtectingMaterial to be a number but was ', typeof src.thicknessMax, src.thicknessMax)
                        }
                    }
                    return dst;
                }

                static toObject(src: ProtectingMaterial | null | undefined): ProtectingMaterial_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.ProtectingMaterial is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.ProtectingMaterial") {
                        console.error('Expected ng.endpoint_args.common_api_functions.ProtectingMaterial but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ProtectingMaterial_json = {
                        thicknessStep: AsJsonNum(src.thicknessStep),
                        thicknessMin: AsJsonNum(src.thicknessMin),
                        thicknessMax: AsJsonNum(src.thicknessMax),
                    };
                    return dst;
                }

                static create(src?: ProtectingMaterial_createType) {
                    const dst = new ProtectingMaterial();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.thicknessStep !== undefined) {
                        dst.thicknessStep = src.thicknessStep;
                    }
                    if (src.thicknessMin !== undefined) {
                        dst.thicknessMin = src.thicknessMin;
                    }
                    if (src.thicknessMax !== undefined) {
                        dst.thicknessMax = src.thicknessMax;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ProtectingMaterial();
                    dst.thicknessStep = this.thicknessStep;
                    dst.thicknessMin = this.thicknessMin;
                    dst.thicknessMax = this.thicknessMax;
                    return dst;
                }

                deepClone() {
                    const json = ProtectingMaterial.toObject(this);
                    const dst = ProtectingMaterial.fromObject(json);
                    return dst;
                }
            }
            export type IProtectingMaterial = ProtectingMaterial;


            export type AutoDesignTimberFire_keys = 'protectingMaterial';
            export interface AutoDesignTimberFire_createType {
                protectingMaterial?: ng.endpoint_args.common_api_functions.ProtectingMaterial | null,
            }
            export interface AutoDesignTimberFire_json {
                protectingMaterial?: ng.endpoint_args.common_api_functions.ProtectingMaterial_json;
            }
            interface AutoDesignTimberFire_json_in {
                __proto_name?: unknown;
                protectingMaterial?: unknown;
            }
            export class AutoDesignTimberFire {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignTimberFire";
                protectingMaterial: ng.endpoint_args.common_api_functions.ProtectingMaterial | null = null;

                static fromObject(src_unknown: unknown): AutoDesignTimberFire {
                    const dst = new AutoDesignTimberFire();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignTimberFire but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignTimberFire_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignTimberFire but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.protectingMaterial = ng.endpoint_args.common_api_functions.ProtectingMaterial.fromObject(src.protectingMaterial);
                    }
                    return dst;
                }

                static toObject(src: AutoDesignTimberFire | null | undefined): AutoDesignTimberFire_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignTimberFire is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignTimberFire") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignTimberFire but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignTimberFire_json = {
                    };
                    if(src.protectingMaterial !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.ProtectingMaterial.toObject(src.protectingMaterial);
                        if(parsed === null) return null;
                        dst.protectingMaterial = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignTimberFire_createType) {
                    const dst = new AutoDesignTimberFire();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.protectingMaterial !== undefined) {
                        dst.protectingMaterial = src.protectingMaterial;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignTimberFire();
                    dst.protectingMaterial = this.protectingMaterial;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignTimberFire.toObject(this);
                    const dst = AutoDesignTimberFire.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignTimberFire = AutoDesignTimberFire;


            export type AutoDesignSteelFire_keys = 'protectingMaterial' | 'temperatureStep';
            export interface AutoDesignSteelFire_createType {
                protectingMaterial?: ng.endpoint_args.common_api_functions.ProtectingMaterial | null,
                temperatureStep?: number,
            }
            export interface AutoDesignSteelFire_json {
                protectingMaterial?: ng.endpoint_args.common_api_functions.ProtectingMaterial_json;
                temperatureStep?: JsonNumber;
            }
            interface AutoDesignSteelFire_json_in {
                __proto_name?: unknown;
                protectingMaterial?: unknown;
                temperatureStep?: unknown;
            }
            export class AutoDesignSteelFire {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSteelFire";
                // this is a one of
                protection_type: {type: 'protectingMaterial'; protectingMaterial: ng.endpoint_args.common_api_functions.ProtectingMaterial} | {type: 'temperatureStep'; temperatureStep: number} | null = null;

                /** Gets the `ProtectingMaterial` value (or null) from the oneof `protection_type` */
                getProtectingMaterial(): ng.endpoint_args.common_api_functions.ProtectingMaterial | null {
                    if(this.protection_type === null) return null;
                    if(this.protection_type.type !== 'protectingMaterial') return null;
                    return this.protection_type.protectingMaterial;
                }

                /** Sets the `ProtectingMaterial` value for the oneof `protection_type`*/
                setProtectingMaterial(value: ng.endpoint_args.common_api_functions.ProtectingMaterial | null) {
                    if(value !== null) {
                        this.protection_type = {type: 'protectingMaterial', protectingMaterial:value};
                    }
                    else {
                        this.protection_type = null;
                    }
                }

                /** Gets the `TemperatureStep` value (or null) from the oneof `protection_type` */
                getTemperatureStep(): number | null {
                    if(this.protection_type === null) return null;
                    if(this.protection_type.type !== 'temperatureStep') return null;
                    return this.protection_type.temperatureStep;
                }

                /** Sets the `TemperatureStep` value for the oneof `protection_type`*/
                setTemperatureStep(value: number | null) {
                    if(value !== null) {
                        this.protection_type = {type: 'temperatureStep', temperatureStep:value};
                    }
                    else {
                        this.protection_type = null;
                    }
                }

                static fromObject(src_unknown: unknown): AutoDesignSteelFire {
                    const dst = new AutoDesignSteelFire();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSteelFire but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSteelFire_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSteelFire but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.setProtectingMaterial(ng.endpoint_args.common_api_functions.ProtectingMaterial.fromObject(src.protectingMaterial));
                    }
                    if (src.temperatureStep !== undefined && src.temperatureStep !== null) {
                        if (typeof src.temperatureStep === "number" || src.temperatureStep === 'NaN' || src.temperatureStep === 'Infinity' || src.temperatureStep === '-Infinity') {
                            dst.setTemperatureStep(AsNum(src.temperatureStep));
                        }
                        else {
                            console.log('Expected temperatureStep of AutoDesignSteelFire to be a number but was ', typeof src.temperatureStep, src.temperatureStep)
                        }
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSteelFire | null | undefined): AutoDesignSteelFire_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSteelFire is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSteelFire") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSteelFire but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSteelFire_json = {
                    };
                    const protectingMaterial = src.getProtectingMaterial();
                    if(protectingMaterial !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.ProtectingMaterial.toObject(protectingMaterial);
                        if(parsed === null) return null;
                        dst.protectingMaterial = parsed;
                    }
                    const temperatureStep = src.getTemperatureStep();
                    if(temperatureStep !== null)
                    {
                        const parsed = AsJsonNum(temperatureStep);
                        if(parsed === null) return null;
                        dst.temperatureStep = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignSteelFire_createType) {
                    const dst = new AutoDesignSteelFire();
                    if (src === undefined) {
                        return dst;
                    }
                    // part of the protection_type oneof 
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.setProtectingMaterial(src.protectingMaterial);
                    }
                    // part of the protection_type oneof 
                    if (src.temperatureStep !== undefined && src.temperatureStep !== null) {
                        dst.setTemperatureStep(src.temperatureStep);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSteelFire();
                    dst.protection_type = this.protection_type;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSteelFire.toObject(this);
                    const dst = AutoDesignSteelFire.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSteelFire = AutoDesignSteelFire;


            export type AutoDesignValue_keys = 'min' | 'max' | 'step';
            export interface AutoDesignValue_createType {
                min?: number,
                max?: number,
                step?: number,
            }
            export interface AutoDesignValue_json {
                min?: JsonNumber;
                max?: JsonNumber;
                step?: JsonNumber;
            }
            interface AutoDesignValue_json_in {
                __proto_name?: unknown;
                min?: unknown;
                max?: unknown;
                step?: unknown;
            }
            export class AutoDesignValue {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignValue";
                min: number = 0;
                max: number = 0;
                step: number = 0;

                static fromObject(src_unknown: unknown): AutoDesignValue {
                    const dst = new AutoDesignValue();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignValue but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignValue_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignValue but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.min !== undefined && src.min !== null) {
                        if (typeof src.min === "number" || src.min === 'NaN' || src.min === 'Infinity' || src.min === '-Infinity') {
                            dst.min = AsNum(src.min);
                        }
                        else {
                            console.log('Expected min of AutoDesignValue to be a number but was ', typeof src.min, src.min)
                        }
                    }
                    if (src.max !== undefined && src.max !== null) {
                        if (typeof src.max === "number" || src.max === 'NaN' || src.max === 'Infinity' || src.max === '-Infinity') {
                            dst.max = AsNum(src.max);
                        }
                        else {
                            console.log('Expected max of AutoDesignValue to be a number but was ', typeof src.max, src.max)
                        }
                    }
                    if (src.step !== undefined && src.step !== null) {
                        if (typeof src.step === "number" || src.step === 'NaN' || src.step === 'Infinity' || src.step === '-Infinity') {
                            dst.step = AsNum(src.step);
                        }
                        else {
                            console.log('Expected step of AutoDesignValue to be a number but was ', typeof src.step, src.step)
                        }
                    }
                    return dst;
                }

                static toObject(src: AutoDesignValue | null | undefined): AutoDesignValue_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignValue is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignValue") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignValue but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignValue_json = {
                        min: AsJsonNum(src.min),
                        max: AsJsonNum(src.max),
                        step: AsJsonNum(src.step),
                    };
                    return dst;
                }

                static create(src?: AutoDesignValue_createType) {
                    const dst = new AutoDesignValue();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.min !== undefined) {
                        dst.min = src.min;
                    }
                    if (src.max !== undefined) {
                        dst.max = src.max;
                    }
                    if (src.step !== undefined) {
                        dst.step = src.step;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignValue();
                    dst.min = this.min;
                    dst.max = this.max;
                    dst.step = this.step;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignValue.toObject(this);
                    const dst = AutoDesignValue.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignValue = AutoDesignValue;


            export type AutoDesignSteel_keys = 'fireSettings';
            export interface AutoDesignSteel_createType {
                fireSettings?: ng.endpoint_args.common_api_functions.AutoDesignSteelFire | null,
            }
            export interface AutoDesignSteel_json {
                fireSettings?: ng.endpoint_args.common_api_functions.AutoDesignSteelFire_json;
            }
            interface AutoDesignSteel_json_in {
                __proto_name?: unknown;
                fireSettings?: unknown;
            }
            export class AutoDesignSteel {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSteel";
                fireSettings: ng.endpoint_args.common_api_functions.AutoDesignSteelFire | null = null;

                static fromObject(src_unknown: unknown): AutoDesignSteel {
                    const dst = new AutoDesignSteel();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSteel but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSteel_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSteel but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fireSettings !== undefined && src.fireSettings !== null) {
                        dst.fireSettings = ng.endpoint_args.common_api_functions.AutoDesignSteelFire.fromObject(src.fireSettings);
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSteel | null | undefined): AutoDesignSteel_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSteel is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSteel") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSteel but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSteel_json = {
                    };
                    if(src.fireSettings !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSteelFire.toObject(src.fireSettings);
                        if(parsed === null) return null;
                        dst.fireSettings = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignSteel_createType) {
                    const dst = new AutoDesignSteel();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fireSettings !== undefined) {
                        dst.fireSettings = src.fireSettings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSteel();
                    dst.fireSettings = this.fireSettings;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSteel.toObject(this);
                    const dst = AutoDesignSteel.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSteel = AutoDesignSteel;


            export type AutoDesignTimber_keys = 'fireSettings';
            export interface AutoDesignTimber_createType {
                fireSettings?: ng.endpoint_args.common_api_functions.AutoDesignTimberFire | null,
            }
            export interface AutoDesignTimber_json {
                fireSettings?: ng.endpoint_args.common_api_functions.AutoDesignTimberFire_json;
            }
            interface AutoDesignTimber_json_in {
                __proto_name?: unknown;
                fireSettings?: unknown;
            }
            export class AutoDesignTimber {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignTimber";
                fireSettings: ng.endpoint_args.common_api_functions.AutoDesignTimberFire | null = null;

                static fromObject(src_unknown: unknown): AutoDesignTimber {
                    const dst = new AutoDesignTimber();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignTimber but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignTimber_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignTimber but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.fireSettings !== undefined && src.fireSettings !== null) {
                        dst.fireSettings = ng.endpoint_args.common_api_functions.AutoDesignTimberFire.fromObject(src.fireSettings);
                    }
                    return dst;
                }

                static toObject(src: AutoDesignTimber | null | undefined): AutoDesignTimber_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignTimber is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignTimber") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignTimber but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignTimber_json = {
                    };
                    if(src.fireSettings !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignTimberFire.toObject(src.fireSettings);
                        if(parsed === null) return null;
                        dst.fireSettings = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignTimber_createType) {
                    const dst = new AutoDesignTimber();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.fireSettings !== undefined) {
                        dst.fireSettings = src.fireSettings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignTimber();
                    dst.fireSettings = this.fireSettings;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignTimber.toObject(this);
                    const dst = AutoDesignTimber.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignTimber = AutoDesignTimber;


            export type AutoDesignConcrete_keys = 'btmDia' | 'topDia' | 'linkDia' | 'longDia' | 'btmDiaMtrlGuid' | 'topDiaMtrlGuid' | 'linkDiaMtrlGuid' | 'longDiaMtrlGuid' | 'concLst' | 'distances' | 'coverDeviation' | 'vibSpace' | 'maxAggregateSize' | 'regularSpacing' | 'maxNumberOfBarsY' | 'maxNumberOfBarsZ' | 'freeSpaceBetweenStirrups' | 'nbrOfLegsForEndStirrups' | 'stirrupsSlope' | 'spacingLimits' | 'detailingOptions' | 'minSectionWidth' | 'maxSectionWidth' | 'minSectionHeight' | 'maxSectionHeight' | 'codeControl';
            export interface AutoDesignConcrete_createType {
                btmDia?: number[],
                topDia?: number[],
                linkDia?: number[],
                longDia?: number[],
                btmDiaMtrlGuid?: string,
                topDiaMtrlGuid?: string,
                linkDiaMtrlGuid?: string,
                longDiaMtrlGuid?: string,
                concLst?: string[],
                distances?: ng.design.concrete.CoverAndSpace[],
                coverDeviation?: number,
                vibSpace?: number,
                maxAggregateSize?: number,
                regularSpacing?: boolean,
                maxNumberOfBarsY?: number,
                maxNumberOfBarsZ?: number,
                freeSpaceBetweenStirrups?: number,
                nbrOfLegsForEndStirrups?: number,
                stirrupsSlope?: number,
                spacingLimits?: ng.endpoint_args.common_api_functions.AutoDesignValue | null,
                detailingOptions?: ng.endpoint_args.common_api_functions.DetailingOption[],
                minSectionWidth?: number,
                maxSectionWidth?: number,
                minSectionHeight?: number,
                maxSectionHeight?: number,
                codeControl?: boolean,
            }
            export interface AutoDesignConcrete_json {
                btmDia: JsonNumber[];
                topDia: JsonNumber[];
                linkDia: JsonNumber[];
                longDia: JsonNumber[];
                btmDiaMtrlGuid?: string;
                topDiaMtrlGuid?: string;
                linkDiaMtrlGuid?: string;
                longDiaMtrlGuid?: string;
                concLst: string[];
                distances: ng.design.concrete.CoverAndSpace_json[];
                coverDeviation?: JsonNumber;
                vibSpace?: JsonNumber;
                maxAggregateSize?: JsonNumber;
                regularSpacing?: boolean;
                maxNumberOfBarsY?: JsonNumber;
                maxNumberOfBarsZ?: JsonNumber;
                freeSpaceBetweenStirrups?: JsonNumber;
                nbrOfLegsForEndStirrups?: JsonNumber;
                stirrupsSlope?: JsonNumber;
                spacingLimits?: ng.endpoint_args.common_api_functions.AutoDesignValue_json;
                detailingOptions: string[];
                minSectionWidth?: JsonNumber;
                maxSectionWidth?: JsonNumber;
                minSectionHeight?: JsonNumber;
                maxSectionHeight?: JsonNumber;
                codeControl?: boolean;
            }
            interface AutoDesignConcrete_json_in {
                __proto_name?: unknown;
                btmDia?: unknown;
                topDia?: unknown;
                linkDia?: unknown;
                longDia?: unknown;
                btmDiaMtrlGuid?: unknown;
                topDiaMtrlGuid?: unknown;
                linkDiaMtrlGuid?: unknown;
                longDiaMtrlGuid?: unknown;
                concLst?: unknown;
                distances?: unknown;
                coverDeviation?: unknown;
                vibSpace?: unknown;
                maxAggregateSize?: unknown;
                regularSpacing?: unknown;
                maxNumberOfBarsY?: unknown;
                maxNumberOfBarsZ?: unknown;
                freeSpaceBetweenStirrups?: unknown;
                nbrOfLegsForEndStirrups?: unknown;
                stirrupsSlope?: unknown;
                spacingLimits?: unknown;
                detailingOptions?: unknown;
                minSectionWidth?: unknown;
                maxSectionWidth?: unknown;
                minSectionHeight?: unknown;
                maxSectionHeight?: unknown;
                codeControl?: unknown;
            }
            export class AutoDesignConcrete {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignConcrete";
                btmDia: number[] = [];
                topDia: number[] = [];
                linkDia: number[] = [];
                longDia: number[] = [];
                btmDiaMtrlGuid: string = "";
                topDiaMtrlGuid: string = "";
                linkDiaMtrlGuid: string = "";
                longDiaMtrlGuid: string = "";
                concLst: string[] = [];
                distances: ng.design.concrete.CoverAndSpace[] = [];
                coverDeviation: number = 0;
                vibSpace: number = 0;
                maxAggregateSize: number = 0;
                regularSpacing: boolean = false;
                maxNumberOfBarsY: number = 0;
                maxNumberOfBarsZ: number = 0;
                freeSpaceBetweenStirrups: number = 0;
                nbrOfLegsForEndStirrups: number = 0;
                stirrupsSlope: number = 0;
                spacingLimits: ng.endpoint_args.common_api_functions.AutoDesignValue | null = null;
                detailingOptions: ng.endpoint_args.common_api_functions.DetailingOption[] = [];
                minSectionWidth: number = 0;
                maxSectionWidth: number = 0;
                minSectionHeight: number = 0;
                maxSectionHeight: number = 0;
                codeControl: boolean = false;

                static fromObject(src_unknown: unknown): AutoDesignConcrete {
                    const dst = new AutoDesignConcrete();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignConcrete but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignConcrete_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignConcrete but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.btmDia !== undefined && src.btmDia !== null) {
                        if (Array.isArray(src.btmDia)) {
                            for (const [index, element] of src.btmDia.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.btmDia.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected btmDia of AutoDesignConcrete[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected btmDia of AutoDesignConcrete to be a array but was ', typeof src.btmDia, src.btmDia)
                        }
                    }
                    if (src.topDia !== undefined && src.topDia !== null) {
                        if (Array.isArray(src.topDia)) {
                            for (const [index, element] of src.topDia.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.topDia.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected topDia of AutoDesignConcrete[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected topDia of AutoDesignConcrete to be a array but was ', typeof src.topDia, src.topDia)
                        }
                    }
                    if (src.linkDia !== undefined && src.linkDia !== null) {
                        if (Array.isArray(src.linkDia)) {
                            for (const [index, element] of src.linkDia.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.linkDia.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected linkDia of AutoDesignConcrete[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected linkDia of AutoDesignConcrete to be a array but was ', typeof src.linkDia, src.linkDia)
                        }
                    }
                    if (src.longDia !== undefined && src.longDia !== null) {
                        if (Array.isArray(src.longDia)) {
                            for (const [index, element] of src.longDia.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.longDia.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected longDia of AutoDesignConcrete[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected longDia of AutoDesignConcrete to be a array but was ', typeof src.longDia, src.longDia)
                        }
                    }
                    if (src.btmDiaMtrlGuid !== undefined && src.btmDiaMtrlGuid !== null) {
                        if (typeof src.btmDiaMtrlGuid === "string") {
                            dst.btmDiaMtrlGuid = src.btmDiaMtrlGuid;
                        }
                        else {
                            console.log('Expected btmDiaMtrlGuid of AutoDesignConcrete to be a string but was ', typeof src.btmDiaMtrlGuid, src.btmDiaMtrlGuid)
                        }
                    }
                    if (src.topDiaMtrlGuid !== undefined && src.topDiaMtrlGuid !== null) {
                        if (typeof src.topDiaMtrlGuid === "string") {
                            dst.topDiaMtrlGuid = src.topDiaMtrlGuid;
                        }
                        else {
                            console.log('Expected topDiaMtrlGuid of AutoDesignConcrete to be a string but was ', typeof src.topDiaMtrlGuid, src.topDiaMtrlGuid)
                        }
                    }
                    if (src.linkDiaMtrlGuid !== undefined && src.linkDiaMtrlGuid !== null) {
                        if (typeof src.linkDiaMtrlGuid === "string") {
                            dst.linkDiaMtrlGuid = src.linkDiaMtrlGuid;
                        }
                        else {
                            console.log('Expected linkDiaMtrlGuid of AutoDesignConcrete to be a string but was ', typeof src.linkDiaMtrlGuid, src.linkDiaMtrlGuid)
                        }
                    }
                    if (src.longDiaMtrlGuid !== undefined && src.longDiaMtrlGuid !== null) {
                        if (typeof src.longDiaMtrlGuid === "string") {
                            dst.longDiaMtrlGuid = src.longDiaMtrlGuid;
                        }
                        else {
                            console.log('Expected longDiaMtrlGuid of AutoDesignConcrete to be a string but was ', typeof src.longDiaMtrlGuid, src.longDiaMtrlGuid)
                        }
                    }
                    if (src.concLst !== undefined && src.concLst !== null) {
                        if (Array.isArray(src.concLst)) {
                            for (const [index, element] of src.concLst.entries()) {
                                if (typeof element === "string") {
                                    dst.concLst.push(element);
                                }
                                else {
                                    console.log('Expected concLst of AutoDesignConcrete[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected concLst of AutoDesignConcrete to be a array but was ', typeof src.concLst, src.concLst)
                        }
                    }
                    if (src.distances !== undefined && src.distances !== null) {
                        if (Array.isArray(src.distances)) {
                            for (const element of src.distances) {
                                dst.distances.push(ng.design.concrete.CoverAndSpace.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected distances of AutoDesignConcrete to be a array but was ', typeof src.distances, src.distances)
                        }
                    }
                    if (src.coverDeviation !== undefined && src.coverDeviation !== null) {
                        if (typeof src.coverDeviation === "number" || src.coverDeviation === 'NaN' || src.coverDeviation === 'Infinity' || src.coverDeviation === '-Infinity') {
                            dst.coverDeviation = AsNum(src.coverDeviation);
                        }
                        else {
                            console.log('Expected coverDeviation of AutoDesignConcrete to be a number but was ', typeof src.coverDeviation, src.coverDeviation)
                        }
                    }
                    if (src.vibSpace !== undefined && src.vibSpace !== null) {
                        if (typeof src.vibSpace === "number" || src.vibSpace === 'NaN' || src.vibSpace === 'Infinity' || src.vibSpace === '-Infinity') {
                            dst.vibSpace = AsNum(src.vibSpace);
                        }
                        else {
                            console.log('Expected vibSpace of AutoDesignConcrete to be a number but was ', typeof src.vibSpace, src.vibSpace)
                        }
                    }
                    if (src.maxAggregateSize !== undefined && src.maxAggregateSize !== null) {
                        if (typeof src.maxAggregateSize === "number" || src.maxAggregateSize === 'NaN' || src.maxAggregateSize === 'Infinity' || src.maxAggregateSize === '-Infinity') {
                            dst.maxAggregateSize = AsNum(src.maxAggregateSize);
                        }
                        else {
                            console.log('Expected maxAggregateSize of AutoDesignConcrete to be a number but was ', typeof src.maxAggregateSize, src.maxAggregateSize)
                        }
                    }
                    if (src.regularSpacing !== undefined && src.regularSpacing !== null) {
                        if (typeof src.regularSpacing === "boolean") {
                            dst.regularSpacing = src.regularSpacing;
                        }
                        else {
                            console.log('Expected regularSpacing of AutoDesignConcrete to be a boolean but was ', typeof src.regularSpacing, src.regularSpacing)
                        }
                    }
                    if (src.maxNumberOfBarsY !== undefined && src.maxNumberOfBarsY !== null) {
                        if (typeof src.maxNumberOfBarsY === "number" || src.maxNumberOfBarsY === 'NaN' || src.maxNumberOfBarsY === 'Infinity' || src.maxNumberOfBarsY === '-Infinity') {
                            dst.maxNumberOfBarsY = NumberToInt("ng.endpoint_args.common_api_functions.AutoDesignConcrete.max_number_of_bars_y", AsNum(src.maxNumberOfBarsY));
                        }
                        else {
                            console.log('Expected maxNumberOfBarsY of AutoDesignConcrete to be a number but was ', typeof src.maxNumberOfBarsY, src.maxNumberOfBarsY)
                        }
                    }
                    if (src.maxNumberOfBarsZ !== undefined && src.maxNumberOfBarsZ !== null) {
                        if (typeof src.maxNumberOfBarsZ === "number" || src.maxNumberOfBarsZ === 'NaN' || src.maxNumberOfBarsZ === 'Infinity' || src.maxNumberOfBarsZ === '-Infinity') {
                            dst.maxNumberOfBarsZ = NumberToInt("ng.endpoint_args.common_api_functions.AutoDesignConcrete.max_number_of_bars_z", AsNum(src.maxNumberOfBarsZ));
                        }
                        else {
                            console.log('Expected maxNumberOfBarsZ of AutoDesignConcrete to be a number but was ', typeof src.maxNumberOfBarsZ, src.maxNumberOfBarsZ)
                        }
                    }
                    if (src.freeSpaceBetweenStirrups !== undefined && src.freeSpaceBetweenStirrups !== null) {
                        if (typeof src.freeSpaceBetweenStirrups === "number" || src.freeSpaceBetweenStirrups === 'NaN' || src.freeSpaceBetweenStirrups === 'Infinity' || src.freeSpaceBetweenStirrups === '-Infinity') {
                            dst.freeSpaceBetweenStirrups = AsNum(src.freeSpaceBetweenStirrups);
                        }
                        else {
                            console.log('Expected freeSpaceBetweenStirrups of AutoDesignConcrete to be a number but was ', typeof src.freeSpaceBetweenStirrups, src.freeSpaceBetweenStirrups)
                        }
                    }
                    if (src.nbrOfLegsForEndStirrups !== undefined && src.nbrOfLegsForEndStirrups !== null) {
                        if (typeof src.nbrOfLegsForEndStirrups === "number" || src.nbrOfLegsForEndStirrups === 'NaN' || src.nbrOfLegsForEndStirrups === 'Infinity' || src.nbrOfLegsForEndStirrups === '-Infinity') {
                            dst.nbrOfLegsForEndStirrups = NumberToInt("ng.endpoint_args.common_api_functions.AutoDesignConcrete.nbr_of_legs_for_end_stirrups", AsNum(src.nbrOfLegsForEndStirrups));
                        }
                        else {
                            console.log('Expected nbrOfLegsForEndStirrups of AutoDesignConcrete to be a number but was ', typeof src.nbrOfLegsForEndStirrups, src.nbrOfLegsForEndStirrups)
                        }
                    }
                    if (src.stirrupsSlope !== undefined && src.stirrupsSlope !== null) {
                        if (typeof src.stirrupsSlope === "number" || src.stirrupsSlope === 'NaN' || src.stirrupsSlope === 'Infinity' || src.stirrupsSlope === '-Infinity') {
                            dst.stirrupsSlope = AsNum(src.stirrupsSlope);
                        }
                        else {
                            console.log('Expected stirrupsSlope of AutoDesignConcrete to be a number but was ', typeof src.stirrupsSlope, src.stirrupsSlope)
                        }
                    }
                    if (src.spacingLimits !== undefined && src.spacingLimits !== null) {
                        dst.spacingLimits = ng.endpoint_args.common_api_functions.AutoDesignValue.fromObject(src.spacingLimits);
                    }
                    if (src.detailingOptions !== undefined && src.detailingOptions !== null) {
                        if (Array.isArray(src.detailingOptions)) {
                            for (const element of src.detailingOptions) {
                                dst.detailingOptions.push(ng.endpoint_args.common_api_functions.DetailingOption_FromObject(element));
                            }
                        }
                        else {
                            console.log('Expected detailingOptions of AutoDesignConcrete to be a array but was ', typeof src.detailingOptions, src.detailingOptions)
                        }
                    }
                    if (src.minSectionWidth !== undefined && src.minSectionWidth !== null) {
                        if (typeof src.minSectionWidth === "number" || src.minSectionWidth === 'NaN' || src.minSectionWidth === 'Infinity' || src.minSectionWidth === '-Infinity') {
                            dst.minSectionWidth = AsNum(src.minSectionWidth);
                        }
                        else {
                            console.log('Expected minSectionWidth of AutoDesignConcrete to be a number but was ', typeof src.minSectionWidth, src.minSectionWidth)
                        }
                    }
                    if (src.maxSectionWidth !== undefined && src.maxSectionWidth !== null) {
                        if (typeof src.maxSectionWidth === "number" || src.maxSectionWidth === 'NaN' || src.maxSectionWidth === 'Infinity' || src.maxSectionWidth === '-Infinity') {
                            dst.maxSectionWidth = AsNum(src.maxSectionWidth);
                        }
                        else {
                            console.log('Expected maxSectionWidth of AutoDesignConcrete to be a number but was ', typeof src.maxSectionWidth, src.maxSectionWidth)
                        }
                    }
                    if (src.minSectionHeight !== undefined && src.minSectionHeight !== null) {
                        if (typeof src.minSectionHeight === "number" || src.minSectionHeight === 'NaN' || src.minSectionHeight === 'Infinity' || src.minSectionHeight === '-Infinity') {
                            dst.minSectionHeight = AsNum(src.minSectionHeight);
                        }
                        else {
                            console.log('Expected minSectionHeight of AutoDesignConcrete to be a number but was ', typeof src.minSectionHeight, src.minSectionHeight)
                        }
                    }
                    if (src.maxSectionHeight !== undefined && src.maxSectionHeight !== null) {
                        if (typeof src.maxSectionHeight === "number" || src.maxSectionHeight === 'NaN' || src.maxSectionHeight === 'Infinity' || src.maxSectionHeight === '-Infinity') {
                            dst.maxSectionHeight = AsNum(src.maxSectionHeight);
                        }
                        else {
                            console.log('Expected maxSectionHeight of AutoDesignConcrete to be a number but was ', typeof src.maxSectionHeight, src.maxSectionHeight)
                        }
                    }
                    if (src.codeControl !== undefined && src.codeControl !== null) {
                        if (typeof src.codeControl === "boolean") {
                            dst.codeControl = src.codeControl;
                        }
                        else {
                            console.log('Expected codeControl of AutoDesignConcrete to be a boolean but was ', typeof src.codeControl, src.codeControl)
                        }
                    }
                    return dst;
                }

                static toObject(src: AutoDesignConcrete | null | undefined): AutoDesignConcrete_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignConcrete is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignConcrete") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignConcrete but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignConcrete_json = {
                        btmDia: new Array<JsonNumber>(),
                        topDia: new Array<JsonNumber>(),
                        linkDia: new Array<JsonNumber>(),
                        longDia: new Array<JsonNumber>(),
                        btmDiaMtrlGuid: src.btmDiaMtrlGuid,
                        topDiaMtrlGuid: src.topDiaMtrlGuid,
                        linkDiaMtrlGuid: src.linkDiaMtrlGuid,
                        longDiaMtrlGuid: src.longDiaMtrlGuid,
                        concLst: new Array<string>(),
                        distances: new Array<ng.design.concrete.CoverAndSpace_json>(),
                        coverDeviation: AsJsonNum(src.coverDeviation),
                        vibSpace: AsJsonNum(src.vibSpace),
                        maxAggregateSize: AsJsonNum(src.maxAggregateSize),
                        regularSpacing: src.regularSpacing,
                        maxNumberOfBarsY: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.AutoDesignConcrete.max_number_of_bars_y", src.maxNumberOfBarsY)),
                        maxNumberOfBarsZ: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.AutoDesignConcrete.max_number_of_bars_z", src.maxNumberOfBarsZ)),
                        freeSpaceBetweenStirrups: AsJsonNum(src.freeSpaceBetweenStirrups),
                        nbrOfLegsForEndStirrups: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.AutoDesignConcrete.nbr_of_legs_for_end_stirrups", src.nbrOfLegsForEndStirrups)),
                        stirrupsSlope: AsJsonNum(src.stirrupsSlope),
                        detailingOptions: new Array<string>(),
                        minSectionWidth: AsJsonNum(src.minSectionWidth),
                        maxSectionWidth: AsJsonNum(src.maxSectionWidth),
                        minSectionHeight: AsJsonNum(src.minSectionHeight),
                        maxSectionHeight: AsJsonNum(src.maxSectionHeight),
                        codeControl: src.codeControl,
                    };
                    if (src.btmDia !== null) {
                        for (const element of src.btmDia) {
                            dst.btmDia.push(AsJsonNum(element));
                        }
                    }
                    if (src.topDia !== null) {
                        for (const element of src.topDia) {
                            dst.topDia.push(AsJsonNum(element));
                        }
                    }
                    if (src.linkDia !== null) {
                        for (const element of src.linkDia) {
                            dst.linkDia.push(AsJsonNum(element));
                        }
                    }
                    if (src.longDia !== null) {
                        for (const element of src.longDia) {
                            dst.longDia.push(AsJsonNum(element));
                        }
                    }
                    if (src.concLst !== null) {
                        for (const element of src.concLst) {
                            dst.concLst.push(element);
                        }
                    }
                    if (src.distances !== null) {
                        for (const element of src.distances) {
                            const parsed = ng.design.concrete.CoverAndSpace.toObject(element);
                            if(parsed === null) return null;
                            dst.distances.push(parsed);
                        }
                    }
                    if(src.spacingLimits !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignValue.toObject(src.spacingLimits);
                        if(parsed === null) return null;
                        dst.spacingLimits = parsed;
                    }
                    if (src.detailingOptions !== null) {
                        for (const element of src.detailingOptions) {
                            const parsed = ng.endpoint_args.common_api_functions.DetailingOption_ToObject(element);
                            if(parsed === null) return null;
                            dst.detailingOptions.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: AutoDesignConcrete_createType) {
                    const dst = new AutoDesignConcrete();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.btmDia !== undefined) {
                        dst.btmDia = src.btmDia;
                    }
                    if (src.topDia !== undefined) {
                        dst.topDia = src.topDia;
                    }
                    if (src.linkDia !== undefined) {
                        dst.linkDia = src.linkDia;
                    }
                    if (src.longDia !== undefined) {
                        dst.longDia = src.longDia;
                    }
                    if (src.btmDiaMtrlGuid !== undefined) {
                        dst.btmDiaMtrlGuid = src.btmDiaMtrlGuid;
                    }
                    if (src.topDiaMtrlGuid !== undefined) {
                        dst.topDiaMtrlGuid = src.topDiaMtrlGuid;
                    }
                    if (src.linkDiaMtrlGuid !== undefined) {
                        dst.linkDiaMtrlGuid = src.linkDiaMtrlGuid;
                    }
                    if (src.longDiaMtrlGuid !== undefined) {
                        dst.longDiaMtrlGuid = src.longDiaMtrlGuid;
                    }
                    if (src.concLst !== undefined) {
                        dst.concLst = src.concLst;
                    }
                    if (src.distances !== undefined) {
                        dst.distances = src.distances;
                    }
                    if (src.coverDeviation !== undefined) {
                        dst.coverDeviation = src.coverDeviation;
                    }
                    if (src.vibSpace !== undefined) {
                        dst.vibSpace = src.vibSpace;
                    }
                    if (src.maxAggregateSize !== undefined) {
                        dst.maxAggregateSize = src.maxAggregateSize;
                    }
                    if (src.regularSpacing !== undefined) {
                        dst.regularSpacing = src.regularSpacing;
                    }
                    if (src.maxNumberOfBarsY !== undefined) {
                        dst.maxNumberOfBarsY = src.maxNumberOfBarsY;
                    }
                    if (src.maxNumberOfBarsZ !== undefined) {
                        dst.maxNumberOfBarsZ = src.maxNumberOfBarsZ;
                    }
                    if (src.freeSpaceBetweenStirrups !== undefined) {
                        dst.freeSpaceBetweenStirrups = src.freeSpaceBetweenStirrups;
                    }
                    if (src.nbrOfLegsForEndStirrups !== undefined) {
                        dst.nbrOfLegsForEndStirrups = src.nbrOfLegsForEndStirrups;
                    }
                    if (src.stirrupsSlope !== undefined) {
                        dst.stirrupsSlope = src.stirrupsSlope;
                    }
                    if (src.spacingLimits !== undefined) {
                        dst.spacingLimits = src.spacingLimits;
                    }
                    if (src.detailingOptions !== undefined) {
                        dst.detailingOptions = src.detailingOptions;
                    }
                    if (src.minSectionWidth !== undefined) {
                        dst.minSectionWidth = src.minSectionWidth;
                    }
                    if (src.maxSectionWidth !== undefined) {
                        dst.maxSectionWidth = src.maxSectionWidth;
                    }
                    if (src.minSectionHeight !== undefined) {
                        dst.minSectionHeight = src.minSectionHeight;
                    }
                    if (src.maxSectionHeight !== undefined) {
                        dst.maxSectionHeight = src.maxSectionHeight;
                    }
                    if (src.codeControl !== undefined) {
                        dst.codeControl = src.codeControl;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignConcrete();
                    dst.btmDia = this.btmDia;
                    dst.topDia = this.topDia;
                    dst.linkDia = this.linkDia;
                    dst.longDia = this.longDia;
                    dst.btmDiaMtrlGuid = this.btmDiaMtrlGuid;
                    dst.topDiaMtrlGuid = this.topDiaMtrlGuid;
                    dst.linkDiaMtrlGuid = this.linkDiaMtrlGuid;
                    dst.longDiaMtrlGuid = this.longDiaMtrlGuid;
                    dst.concLst = this.concLst;
                    dst.distances = this.distances;
                    dst.coverDeviation = this.coverDeviation;
                    dst.vibSpace = this.vibSpace;
                    dst.maxAggregateSize = this.maxAggregateSize;
                    dst.regularSpacing = this.regularSpacing;
                    dst.maxNumberOfBarsY = this.maxNumberOfBarsY;
                    dst.maxNumberOfBarsZ = this.maxNumberOfBarsZ;
                    dst.freeSpaceBetweenStirrups = this.freeSpaceBetweenStirrups;
                    dst.nbrOfLegsForEndStirrups = this.nbrOfLegsForEndStirrups;
                    dst.stirrupsSlope = this.stirrupsSlope;
                    dst.spacingLimits = this.spacingLimits;
                    dst.detailingOptions = this.detailingOptions;
                    dst.minSectionWidth = this.minSectionWidth;
                    dst.maxSectionWidth = this.maxSectionWidth;
                    dst.minSectionHeight = this.minSectionHeight;
                    dst.maxSectionHeight = this.maxSectionHeight;
                    dst.codeControl = this.codeControl;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignConcrete.toObject(this);
                    const dst = AutoDesignConcrete.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignConcrete = AutoDesignConcrete;


            export type AutoDesignBeam_keys = unknown;
            export interface AutoDesignBeam_createType {
            }
            export interface AutoDesignBeam_json {
            }
            interface AutoDesignBeam_json_in {
                __proto_name?: unknown;
            }
            export class AutoDesignBeam {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignBeam";

                static fromObject(src_unknown: unknown): AutoDesignBeam {
                    const dst = new AutoDesignBeam();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignBeam but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignBeam_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignBeam but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: AutoDesignBeam | null | undefined): AutoDesignBeam_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignBeam is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignBeam") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignBeam but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignBeam_json = {
                    };
                    return dst;
                }

                static create(src?: AutoDesignBeam_createType) {
                    const dst = new AutoDesignBeam();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignBeam();
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignBeam.toObject(this);
                    const dst = AutoDesignBeam.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignBeam = AutoDesignBeam;


            export type AutoDesignColumn_keys = unknown;
            export interface AutoDesignColumn_createType {
            }
            export interface AutoDesignColumn_json {
            }
            interface AutoDesignColumn_json_in {
                __proto_name?: unknown;
            }
            export class AutoDesignColumn {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignColumn";

                static fromObject(src_unknown: unknown): AutoDesignColumn {
                    const dst = new AutoDesignColumn();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignColumn but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignColumn_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignColumn but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: AutoDesignColumn | null | undefined): AutoDesignColumn_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignColumn is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignColumn") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignColumn but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignColumn_json = {
                    };
                    return dst;
                }

                static create(src?: AutoDesignColumn_createType) {
                    const dst = new AutoDesignColumn();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignColumn();
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignColumn.toObject(this);
                    const dst = AutoDesignColumn.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignColumn = AutoDesignColumn;


            export type AutoDesignFoundation_keys = 'lengthWidthRatio' | 'width' | 'length' | 'height';
            export interface AutoDesignFoundation_createType {
                lengthWidthRatio?: number,
                width?: ng.endpoint_args.common_api_functions.AutoDesignValue | null,
                length?: ng.endpoint_args.common_api_functions.AutoDesignValue | null,
                height?: ng.endpoint_args.common_api_functions.AutoDesignValue | null,
            }
            export interface AutoDesignFoundation_json {
                lengthWidthRatio?: JsonNumber;
                width?: ng.endpoint_args.common_api_functions.AutoDesignValue_json;
                length?: ng.endpoint_args.common_api_functions.AutoDesignValue_json;
                height?: ng.endpoint_args.common_api_functions.AutoDesignValue_json;
            }
            interface AutoDesignFoundation_json_in {
                __proto_name?: unknown;
                lengthWidthRatio?: unknown;
                width?: unknown;
                length?: unknown;
                height?: unknown;
            }
            export class AutoDesignFoundation {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignFoundation";
                lengthWidthRatio: number = 0;
                width: ng.endpoint_args.common_api_functions.AutoDesignValue | null = null;
                length: ng.endpoint_args.common_api_functions.AutoDesignValue | null = null;
                height: ng.endpoint_args.common_api_functions.AutoDesignValue | null = null;

                static fromObject(src_unknown: unknown): AutoDesignFoundation {
                    const dst = new AutoDesignFoundation();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignFoundation but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignFoundation_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignFoundation but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.lengthWidthRatio !== undefined && src.lengthWidthRatio !== null) {
                        if (typeof src.lengthWidthRatio === "number" || src.lengthWidthRatio === 'NaN' || src.lengthWidthRatio === 'Infinity' || src.lengthWidthRatio === '-Infinity') {
                            dst.lengthWidthRatio = AsNum(src.lengthWidthRatio);
                        }
                        else {
                            console.log('Expected lengthWidthRatio of AutoDesignFoundation to be a number but was ', typeof src.lengthWidthRatio, src.lengthWidthRatio)
                        }
                    }
                    if (src.width !== undefined && src.width !== null) {
                        dst.width = ng.endpoint_args.common_api_functions.AutoDesignValue.fromObject(src.width);
                    }
                    if (src.length !== undefined && src.length !== null) {
                        dst.length = ng.endpoint_args.common_api_functions.AutoDesignValue.fromObject(src.length);
                    }
                    if (src.height !== undefined && src.height !== null) {
                        dst.height = ng.endpoint_args.common_api_functions.AutoDesignValue.fromObject(src.height);
                    }
                    return dst;
                }

                static toObject(src: AutoDesignFoundation | null | undefined): AutoDesignFoundation_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignFoundation is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignFoundation") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignFoundation but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignFoundation_json = {
                        lengthWidthRatio: AsJsonNum(src.lengthWidthRatio),
                    };
                    if(src.width !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignValue.toObject(src.width);
                        if(parsed === null) return null;
                        dst.width = parsed;
                    }
                    if(src.length !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignValue.toObject(src.length);
                        if(parsed === null) return null;
                        dst.length = parsed;
                    }
                    if(src.height !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignValue.toObject(src.height);
                        if(parsed === null) return null;
                        dst.height = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignFoundation_createType) {
                    const dst = new AutoDesignFoundation();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.lengthWidthRatio !== undefined) {
                        dst.lengthWidthRatio = src.lengthWidthRatio;
                    }
                    if (src.width !== undefined) {
                        dst.width = src.width;
                    }
                    if (src.length !== undefined) {
                        dst.length = src.length;
                    }
                    if (src.height !== undefined) {
                        dst.height = src.height;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignFoundation();
                    dst.lengthWidthRatio = this.lengthWidthRatio;
                    dst.width = this.width;
                    dst.length = this.length;
                    dst.height = this.height;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignFoundation.toObject(this);
                    const dst = AutoDesignFoundation.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignFoundation = AutoDesignFoundation;


            export type AutoDesignSettings_keys = 'elementGuid' | 'sectionGuids' | 'limitUtilization' | 'steel' | 'timber' | 'concrete' | 'beam' | 'column' | 'foundation';
            export interface AutoDesignSettings_createType {
                elementGuid?: string,
                sectionGuids?: string[],
                limitUtilization?: number,
                steel?: ng.endpoint_args.common_api_functions.AutoDesignSteel | null,
                timber?: ng.endpoint_args.common_api_functions.AutoDesignTimber | null,
                concrete?: ng.endpoint_args.common_api_functions.AutoDesignConcrete | null,
                beam?: ng.endpoint_args.common_api_functions.AutoDesignBeam | null,
                column?: ng.endpoint_args.common_api_functions.AutoDesignColumn | null,
                foundation?: ng.endpoint_args.common_api_functions.AutoDesignFoundation | null,
            }
            export interface AutoDesignSettings_json {
                elementGuid?: string;
                sectionGuids: string[];
                limitUtilization?: JsonNumber;
                steel?: ng.endpoint_args.common_api_functions.AutoDesignSteel_json;
                timber?: ng.endpoint_args.common_api_functions.AutoDesignTimber_json;
                concrete?: ng.endpoint_args.common_api_functions.AutoDesignConcrete_json;
                beam?: ng.endpoint_args.common_api_functions.AutoDesignBeam_json;
                column?: ng.endpoint_args.common_api_functions.AutoDesignColumn_json;
                foundation?: ng.endpoint_args.common_api_functions.AutoDesignFoundation_json;
            }
            interface AutoDesignSettings_json_in {
                __proto_name?: unknown;
                elementGuid?: unknown;
                sectionGuids?: unknown;
                limitUtilization?: unknown;
                steel?: unknown;
                timber?: unknown;
                concrete?: unknown;
                beam?: unknown;
                column?: unknown;
                foundation?: unknown;
            }
            export class AutoDesignSettings {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSettings";
                elementGuid: string = "";
                sectionGuids: string[] = [];
                limitUtilization: number = 0;
                // this is a one of
                material: {type: 'steel'; steel: ng.endpoint_args.common_api_functions.AutoDesignSteel} | {type: 'timber'; timber: ng.endpoint_args.common_api_functions.AutoDesignTimber} | {type: 'concrete'; concrete: ng.endpoint_args.common_api_functions.AutoDesignConcrete} | null = null;
                // this is a one of
                geometry: {type: 'beam'; beam: ng.endpoint_args.common_api_functions.AutoDesignBeam} | {type: 'column'; column: ng.endpoint_args.common_api_functions.AutoDesignColumn} | {type: 'foundation'; foundation: ng.endpoint_args.common_api_functions.AutoDesignFoundation} | null = null;

                /** Gets the `Steel` value (or null) from the oneof `material` */
                getSteel(): ng.endpoint_args.common_api_functions.AutoDesignSteel | null {
                    if(this.material === null) return null;
                    if(this.material.type !== 'steel') return null;
                    return this.material.steel;
                }

                /** Sets the `Steel` value for the oneof `material`*/
                setSteel(value: ng.endpoint_args.common_api_functions.AutoDesignSteel | null) {
                    if(value !== null) {
                        this.material = {type: 'steel', steel:value};
                    }
                    else {
                        this.material = null;
                    }
                }

                /** Gets the `Timber` value (or null) from the oneof `material` */
                getTimber(): ng.endpoint_args.common_api_functions.AutoDesignTimber | null {
                    if(this.material === null) return null;
                    if(this.material.type !== 'timber') return null;
                    return this.material.timber;
                }

                /** Sets the `Timber` value for the oneof `material`*/
                setTimber(value: ng.endpoint_args.common_api_functions.AutoDesignTimber | null) {
                    if(value !== null) {
                        this.material = {type: 'timber', timber:value};
                    }
                    else {
                        this.material = null;
                    }
                }

                /** Gets the `Concrete` value (or null) from the oneof `material` */
                getConcrete(): ng.endpoint_args.common_api_functions.AutoDesignConcrete | null {
                    if(this.material === null) return null;
                    if(this.material.type !== 'concrete') return null;
                    return this.material.concrete;
                }

                /** Sets the `Concrete` value for the oneof `material`*/
                setConcrete(value: ng.endpoint_args.common_api_functions.AutoDesignConcrete | null) {
                    if(value !== null) {
                        this.material = {type: 'concrete', concrete:value};
                    }
                    else {
                        this.material = null;
                    }
                }
                /** Gets the `Beam` value (or null) from the oneof `geometry` */
                getBeam(): ng.endpoint_args.common_api_functions.AutoDesignBeam | null {
                    if(this.geometry === null) return null;
                    if(this.geometry.type !== 'beam') return null;
                    return this.geometry.beam;
                }

                /** Sets the `Beam` value for the oneof `geometry`*/
                setBeam(value: ng.endpoint_args.common_api_functions.AutoDesignBeam | null) {
                    if(value !== null) {
                        this.geometry = {type: 'beam', beam:value};
                    }
                    else {
                        this.geometry = null;
                    }
                }

                /** Gets the `Column` value (or null) from the oneof `geometry` */
                getColumn(): ng.endpoint_args.common_api_functions.AutoDesignColumn | null {
                    if(this.geometry === null) return null;
                    if(this.geometry.type !== 'column') return null;
                    return this.geometry.column;
                }

                /** Sets the `Column` value for the oneof `geometry`*/
                setColumn(value: ng.endpoint_args.common_api_functions.AutoDesignColumn | null) {
                    if(value !== null) {
                        this.geometry = {type: 'column', column:value};
                    }
                    else {
                        this.geometry = null;
                    }
                }

                /** Gets the `Foundation` value (or null) from the oneof `geometry` */
                getFoundation(): ng.endpoint_args.common_api_functions.AutoDesignFoundation | null {
                    if(this.geometry === null) return null;
                    if(this.geometry.type !== 'foundation') return null;
                    return this.geometry.foundation;
                }

                /** Sets the `Foundation` value for the oneof `geometry`*/
                setFoundation(value: ng.endpoint_args.common_api_functions.AutoDesignFoundation | null) {
                    if(value !== null) {
                        this.geometry = {type: 'foundation', foundation:value};
                    }
                    else {
                        this.geometry = null;
                    }
                }

                static fromObject(src_unknown: unknown): AutoDesignSettings {
                    const dst = new AutoDesignSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.elementGuid !== undefined && src.elementGuid !== null) {
                        if (typeof src.elementGuid === "string") {
                            dst.elementGuid = src.elementGuid;
                        }
                        else {
                            console.log('Expected elementGuid of AutoDesignSettings to be a string but was ', typeof src.elementGuid, src.elementGuid)
                        }
                    }
                    if (src.sectionGuids !== undefined && src.sectionGuids !== null) {
                        if (Array.isArray(src.sectionGuids)) {
                            for (const [index, element] of src.sectionGuids.entries()) {
                                if (typeof element === "string") {
                                    dst.sectionGuids.push(element);
                                }
                                else {
                                    console.log('Expected sectionGuids of AutoDesignSettings[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected sectionGuids of AutoDesignSettings to be a array but was ', typeof src.sectionGuids, src.sectionGuids)
                        }
                    }
                    if (src.limitUtilization !== undefined && src.limitUtilization !== null) {
                        if (typeof src.limitUtilization === "number" || src.limitUtilization === 'NaN' || src.limitUtilization === 'Infinity' || src.limitUtilization === '-Infinity') {
                            dst.limitUtilization = AsNum(src.limitUtilization);
                        }
                        else {
                            console.log('Expected limitUtilization of AutoDesignSettings to be a number but was ', typeof src.limitUtilization, src.limitUtilization)
                        }
                    }
                    if (src.steel !== undefined && src.steel !== null) {
                        dst.setSteel(ng.endpoint_args.common_api_functions.AutoDesignSteel.fromObject(src.steel));
                    }
                    if (src.timber !== undefined && src.timber !== null) {
                        dst.setTimber(ng.endpoint_args.common_api_functions.AutoDesignTimber.fromObject(src.timber));
                    }
                    if (src.concrete !== undefined && src.concrete !== null) {
                        dst.setConcrete(ng.endpoint_args.common_api_functions.AutoDesignConcrete.fromObject(src.concrete));
                    }
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(ng.endpoint_args.common_api_functions.AutoDesignBeam.fromObject(src.beam));
                    }
                    if (src.column !== undefined && src.column !== null) {
                        dst.setColumn(ng.endpoint_args.common_api_functions.AutoDesignColumn.fromObject(src.column));
                    }
                    if (src.foundation !== undefined && src.foundation !== null) {
                        dst.setFoundation(ng.endpoint_args.common_api_functions.AutoDesignFoundation.fromObject(src.foundation));
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSettings | null | undefined): AutoDesignSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSettings") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSettings_json = {
                        elementGuid: src.elementGuid,
                        sectionGuids: new Array<string>(),
                        limitUtilization: AsJsonNum(src.limitUtilization),
                    };
                    if (src.sectionGuids !== null) {
                        for (const element of src.sectionGuids) {
                            dst.sectionGuids.push(element);
                        }
                    }
                    const steel = src.getSteel();
                    if(steel !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSteel.toObject(steel);
                        if(parsed === null) return null;
                        dst.steel = parsed;
                    }
                    const timber = src.getTimber();
                    if(timber !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignTimber.toObject(timber);
                        if(parsed === null) return null;
                        dst.timber = parsed;
                    }
                    const concrete = src.getConcrete();
                    if(concrete !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignConcrete.toObject(concrete);
                        if(parsed === null) return null;
                        dst.concrete = parsed;
                    }
                    const beam = src.getBeam();
                    if(beam !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignBeam.toObject(beam);
                        if(parsed === null) return null;
                        dst.beam = parsed;
                    }
                    const column = src.getColumn();
                    if(column !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignColumn.toObject(column);
                        if(parsed === null) return null;
                        dst.column = parsed;
                    }
                    const foundation = src.getFoundation();
                    if(foundation !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignFoundation.toObject(foundation);
                        if(parsed === null) return null;
                        dst.foundation = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignSettings_createType) {
                    const dst = new AutoDesignSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.elementGuid !== undefined) {
                        dst.elementGuid = src.elementGuid;
                    }
                    if (src.sectionGuids !== undefined) {
                        dst.sectionGuids = src.sectionGuids;
                    }
                    if (src.limitUtilization !== undefined) {
                        dst.limitUtilization = src.limitUtilization;
                    }
                    // part of the material oneof 
                    if (src.steel !== undefined && src.steel !== null) {
                        dst.setSteel(src.steel);
                    }
                    // part of the material oneof 
                    if (src.timber !== undefined && src.timber !== null) {
                        dst.setTimber(src.timber);
                    }
                    // part of the material oneof 
                    if (src.concrete !== undefined && src.concrete !== null) {
                        dst.setConcrete(src.concrete);
                    }
                    // part of the geometry oneof 
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(src.beam);
                    }
                    // part of the geometry oneof 
                    if (src.column !== undefined && src.column !== null) {
                        dst.setColumn(src.column);
                    }
                    // part of the geometry oneof 
                    if (src.foundation !== undefined && src.foundation !== null) {
                        dst.setFoundation(src.foundation);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSettings();
                    dst.elementGuid = this.elementGuid;
                    dst.sectionGuids = this.sectionGuids;
                    dst.limitUtilization = this.limitUtilization;
                    dst.material = this.material;
                    dst.geometry = this.geometry;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSettings.toObject(this);
                    const dst = AutoDesignSettings.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSettings = AutoDesignSettings;


            export type AutoDesign_keys = 'active' | 'secDb' | 'mtrlDb' | 'settings';
            export interface AutoDesign_createType {
                active?: boolean,
                secDb?: ng.sections.Section[],
                mtrlDb?: ng.material.Data[],
                settings?: ng.endpoint_args.common_api_functions.AutoDesignSettings[],
            }
            export interface AutoDesign_json {
                active?: boolean;
                secDb: ng.sections.Section_json[];
                mtrlDb: ng.material.Data_json[];
                settings: ng.endpoint_args.common_api_functions.AutoDesignSettings_json[];
            }
            interface AutoDesign_json_in {
                __proto_name?: unknown;
                active?: unknown;
                secDb?: unknown;
                mtrlDb?: unknown;
                settings?: unknown;
            }
            export class AutoDesign {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesign";
                active: boolean = false;
                secDb: ng.sections.Section[] = [];
                mtrlDb: ng.material.Data[] = [];
                settings: ng.endpoint_args.common_api_functions.AutoDesignSettings[] = [];

                static fromObject(src_unknown: unknown): AutoDesign {
                    const dst = new AutoDesign();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesign but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesign_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesign but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.active !== undefined && src.active !== null) {
                        if (typeof src.active === "boolean") {
                            dst.active = src.active;
                        }
                        else {
                            console.log('Expected active of AutoDesign to be a boolean but was ', typeof src.active, src.active)
                        }
                    }
                    if (src.secDb !== undefined && src.secDb !== null) {
                        if (Array.isArray(src.secDb)) {
                            for (const element of src.secDb) {
                                dst.secDb.push(ng.sections.Section.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected secDb of AutoDesign to be a array but was ', typeof src.secDb, src.secDb)
                        }
                    }
                    if (src.mtrlDb !== undefined && src.mtrlDb !== null) {
                        if (Array.isArray(src.mtrlDb)) {
                            for (const element of src.mtrlDb) {
                                dst.mtrlDb.push(ng.material.Data.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected mtrlDb of AutoDesign to be a array but was ', typeof src.mtrlDb, src.mtrlDb)
                        }
                    }
                    if (src.settings !== undefined && src.settings !== null) {
                        if (Array.isArray(src.settings)) {
                            for (const element of src.settings) {
                                dst.settings.push(ng.endpoint_args.common_api_functions.AutoDesignSettings.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected settings of AutoDesign to be a array but was ', typeof src.settings, src.settings)
                        }
                    }
                    return dst;
                }

                static toObject(src: AutoDesign | null | undefined): AutoDesign_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesign is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesign") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesign but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesign_json = {
                        active: src.active,
                        secDb: new Array<ng.sections.Section_json>(),
                        mtrlDb: new Array<ng.material.Data_json>(),
                        settings: new Array<ng.endpoint_args.common_api_functions.AutoDesignSettings_json>(),
                    };
                    if (src.secDb !== null) {
                        for (const element of src.secDb) {
                            const parsed = ng.sections.Section.toObject(element);
                            if(parsed === null) return null;
                            dst.secDb.push(parsed);
                        }
                    }
                    if (src.mtrlDb !== null) {
                        for (const element of src.mtrlDb) {
                            const parsed = ng.material.Data.toObject(element);
                            if(parsed === null) return null;
                            dst.mtrlDb.push(parsed);
                        }
                    }
                    if (src.settings !== null) {
                        for (const element of src.settings) {
                            const parsed = ng.endpoint_args.common_api_functions.AutoDesignSettings.toObject(element);
                            if(parsed === null) return null;
                            dst.settings.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: AutoDesign_createType) {
                    const dst = new AutoDesign();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.active !== undefined) {
                        dst.active = src.active;
                    }
                    if (src.secDb !== undefined) {
                        dst.secDb = src.secDb;
                    }
                    if (src.mtrlDb !== undefined) {
                        dst.mtrlDb = src.mtrlDb;
                    }
                    if (src.settings !== undefined) {
                        dst.settings = src.settings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesign();
                    dst.active = this.active;
                    dst.secDb = this.secDb;
                    dst.mtrlDb = this.mtrlDb;
                    dst.settings = this.settings;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesign.toObject(this);
                    const dst = AutoDesign.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesign = AutoDesign;


            export type AutoDesignSuggestionSteel_keys = 'protectingMaterial' | 'temperature';
            export interface AutoDesignSuggestionSteel_createType {
                protectingMaterial?: ng.design.steel.ProtectingMaterial | null,
                temperature?: number,
            }
            export interface AutoDesignSuggestionSteel_json {
                protectingMaterial?: ng.design.steel.ProtectingMaterial_json;
                temperature?: JsonNumber;
            }
            interface AutoDesignSuggestionSteel_json_in {
                __proto_name?: unknown;
                protectingMaterial?: unknown;
                temperature?: unknown;
            }
            export class AutoDesignSuggestionSteel {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel";
                // this is a one of
                protection_type: {type: 'protectingMaterial'; protectingMaterial: ng.design.steel.ProtectingMaterial} | {type: 'temperature'; temperature: number} | null = null;

                /** Gets the `ProtectingMaterial` value (or null) from the oneof `protection_type` */
                getProtectingMaterial(): ng.design.steel.ProtectingMaterial | null {
                    if(this.protection_type === null) return null;
                    if(this.protection_type.type !== 'protectingMaterial') return null;
                    return this.protection_type.protectingMaterial;
                }

                /** Sets the `ProtectingMaterial` value for the oneof `protection_type`*/
                setProtectingMaterial(value: ng.design.steel.ProtectingMaterial | null) {
                    if(value !== null) {
                        this.protection_type = {type: 'protectingMaterial', protectingMaterial:value};
                    }
                    else {
                        this.protection_type = null;
                    }
                }

                /** Gets the `Temperature` value (or null) from the oneof `protection_type` */
                getTemperature(): number | null {
                    if(this.protection_type === null) return null;
                    if(this.protection_type.type !== 'temperature') return null;
                    return this.protection_type.temperature;
                }

                /** Sets the `Temperature` value for the oneof `protection_type`*/
                setTemperature(value: number | null) {
                    if(value !== null) {
                        this.protection_type = {type: 'temperature', temperature:value};
                    }
                    else {
                        this.protection_type = null;
                    }
                }

                static fromObject(src_unknown: unknown): AutoDesignSuggestionSteel {
                    const dst = new AutoDesignSuggestionSteel();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSuggestionSteel but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSuggestionSteel_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSuggestionSteel but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.setProtectingMaterial(ng.design.steel.ProtectingMaterial.fromObject(src.protectingMaterial));
                    }
                    if (src.temperature !== undefined && src.temperature !== null) {
                        if (typeof src.temperature === "number" || src.temperature === 'NaN' || src.temperature === 'Infinity' || src.temperature === '-Infinity') {
                            dst.setTemperature(AsNum(src.temperature));
                        }
                        else {
                            console.log('Expected temperature of AutoDesignSuggestionSteel to be a number but was ', typeof src.temperature, src.temperature)
                        }
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSuggestionSteel | null | undefined): AutoDesignSuggestionSteel_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSuggestionSteel_json = {
                    };
                    const protectingMaterial = src.getProtectingMaterial();
                    if(protectingMaterial !== null)
                    {
                        const parsed = ng.design.steel.ProtectingMaterial.toObject(protectingMaterial);
                        if(parsed === null) return null;
                        dst.protectingMaterial = parsed;
                    }
                    const temperature = src.getTemperature();
                    if(temperature !== null)
                    {
                        const parsed = AsJsonNum(temperature);
                        if(parsed === null) return null;
                        dst.temperature = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignSuggestionSteel_createType) {
                    const dst = new AutoDesignSuggestionSteel();
                    if (src === undefined) {
                        return dst;
                    }
                    // part of the protection_type oneof 
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.setProtectingMaterial(src.protectingMaterial);
                    }
                    // part of the protection_type oneof 
                    if (src.temperature !== undefined && src.temperature !== null) {
                        dst.setTemperature(src.temperature);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSuggestionSteel();
                    dst.protection_type = this.protection_type;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSuggestionSteel.toObject(this);
                    const dst = AutoDesignSuggestionSteel.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSuggestionSteel = AutoDesignSuggestionSteel;


            export type AutoDesignSuggestionTimber_keys = 'protectingMaterial';
            export interface AutoDesignSuggestionTimber_createType {
                protectingMaterial?: ng.fire_protection.timber.CharacteristicData | null,
            }
            export interface AutoDesignSuggestionTimber_json {
                protectingMaterial?: ng.fire_protection.timber.CharacteristicData_json;
            }
            interface AutoDesignSuggestionTimber_json_in {
                __proto_name?: unknown;
                protectingMaterial?: unknown;
            }
            export class AutoDesignSuggestionTimber {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber";
                protectingMaterial: ng.fire_protection.timber.CharacteristicData | null = null;

                static fromObject(src_unknown: unknown): AutoDesignSuggestionTimber {
                    const dst = new AutoDesignSuggestionTimber();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSuggestionTimber but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSuggestionTimber_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSuggestionTimber but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.protectingMaterial !== undefined && src.protectingMaterial !== null) {
                        dst.protectingMaterial = ng.fire_protection.timber.CharacteristicData.fromObject(src.protectingMaterial);
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSuggestionTimber | null | undefined): AutoDesignSuggestionTimber_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSuggestionTimber_json = {
                    };
                    if(src.protectingMaterial !== null)
                    {
                        const parsed = ng.fire_protection.timber.CharacteristicData.toObject(src.protectingMaterial);
                        if(parsed === null) return null;
                        dst.protectingMaterial = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignSuggestionTimber_createType) {
                    const dst = new AutoDesignSuggestionTimber();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.protectingMaterial !== undefined) {
                        dst.protectingMaterial = src.protectingMaterial;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSuggestionTimber();
                    dst.protectingMaterial = this.protectingMaterial;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSuggestionTimber.toObject(this);
                    const dst = AutoDesignSuggestionTimber.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSuggestionTimber = AutoDesignSuggestionTimber;


            export type AutoDesignSuggestionConcrete_keys = 'rebars' | 'strands' | 'links';
            export interface AutoDesignSuggestionConcrete_createType {
                rebars?: ng.rebar.Data | null,
                strands?: ng.strand.Data | null,
                links?: ng.link.Data | null,
            }
            export interface AutoDesignSuggestionConcrete_json {
                rebars?: ng.rebar.Data_json;
                strands?: ng.strand.Data_json;
                links?: ng.link.Data_json;
            }
            interface AutoDesignSuggestionConcrete_json_in {
                __proto_name?: unknown;
                rebars?: unknown;
                strands?: unknown;
                links?: unknown;
            }
            export class AutoDesignSuggestionConcrete {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete";
                rebars: ng.rebar.Data | null = null;
                strands: ng.strand.Data | null = null;
                links: ng.link.Data | null = null;

                static fromObject(src_unknown: unknown): AutoDesignSuggestionConcrete {
                    const dst = new AutoDesignSuggestionConcrete();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSuggestionConcrete but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSuggestionConcrete_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSuggestionConcrete but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.rebars !== undefined && src.rebars !== null) {
                        dst.rebars = ng.rebar.Data.fromObject(src.rebars);
                    }
                    if (src.strands !== undefined && src.strands !== null) {
                        dst.strands = ng.strand.Data.fromObject(src.strands);
                    }
                    if (src.links !== undefined && src.links !== null) {
                        dst.links = ng.link.Data.fromObject(src.links);
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSuggestionConcrete | null | undefined): AutoDesignSuggestionConcrete_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSuggestionConcrete_json = {
                    };
                    if(src.rebars !== null)
                    {
                        const parsed = ng.rebar.Data.toObject(src.rebars);
                        if(parsed === null) return null;
                        dst.rebars = parsed;
                    }
                    if(src.strands !== null)
                    {
                        const parsed = ng.strand.Data.toObject(src.strands);
                        if(parsed === null) return null;
                        dst.strands = parsed;
                    }
                    if(src.links !== null)
                    {
                        const parsed = ng.link.Data.toObject(src.links);
                        if(parsed === null) return null;
                        dst.links = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignSuggestionConcrete_createType) {
                    const dst = new AutoDesignSuggestionConcrete();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.rebars !== undefined) {
                        dst.rebars = src.rebars;
                    }
                    if (src.strands !== undefined) {
                        dst.strands = src.strands;
                    }
                    if (src.links !== undefined) {
                        dst.links = src.links;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSuggestionConcrete();
                    dst.rebars = this.rebars;
                    dst.strands = this.strands;
                    dst.links = this.links;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSuggestionConcrete.toObject(this);
                    const dst = AutoDesignSuggestionConcrete.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSuggestionConcrete = AutoDesignSuggestionConcrete;


            export type AutoDesignSuggestionBeam_keys = unknown;
            export interface AutoDesignSuggestionBeam_createType {
            }
            export interface AutoDesignSuggestionBeam_json {
            }
            interface AutoDesignSuggestionBeam_json_in {
                __proto_name?: unknown;
            }
            export class AutoDesignSuggestionBeam {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam";

                static fromObject(src_unknown: unknown): AutoDesignSuggestionBeam {
                    const dst = new AutoDesignSuggestionBeam();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSuggestionBeam but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSuggestionBeam_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSuggestionBeam but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSuggestionBeam | null | undefined): AutoDesignSuggestionBeam_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSuggestionBeam_json = {
                    };
                    return dst;
                }

                static create(src?: AutoDesignSuggestionBeam_createType) {
                    const dst = new AutoDesignSuggestionBeam();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSuggestionBeam();
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSuggestionBeam.toObject(this);
                    const dst = AutoDesignSuggestionBeam.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSuggestionBeam = AutoDesignSuggestionBeam;


            export type AutoDesignSuggestionColumn_keys = unknown;
            export interface AutoDesignSuggestionColumn_createType {
            }
            export interface AutoDesignSuggestionColumn_json {
            }
            interface AutoDesignSuggestionColumn_json_in {
                __proto_name?: unknown;
            }
            export class AutoDesignSuggestionColumn {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn";

                static fromObject(src_unknown: unknown): AutoDesignSuggestionColumn {
                    const dst = new AutoDesignSuggestionColumn();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSuggestionColumn but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSuggestionColumn_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSuggestionColumn but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSuggestionColumn | null | undefined): AutoDesignSuggestionColumn_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSuggestionColumn_json = {
                    };
                    return dst;
                }

                static create(src?: AutoDesignSuggestionColumn_createType) {
                    const dst = new AutoDesignSuggestionColumn();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSuggestionColumn();
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSuggestionColumn.toObject(this);
                    const dst = AutoDesignSuggestionColumn.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSuggestionColumn = AutoDesignSuggestionColumn;


            export type AutoDesignSuggestionFoundation_keys = unknown;
            export interface AutoDesignSuggestionFoundation_createType {
            }
            export interface AutoDesignSuggestionFoundation_json {
            }
            interface AutoDesignSuggestionFoundation_json_in {
                __proto_name?: unknown;
            }
            export class AutoDesignSuggestionFoundation {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation";

                static fromObject(src_unknown: unknown): AutoDesignSuggestionFoundation {
                    const dst = new AutoDesignSuggestionFoundation();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSuggestionFoundation but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSuggestionFoundation_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSuggestionFoundation but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSuggestionFoundation | null | undefined): AutoDesignSuggestionFoundation_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSuggestionFoundation_json = {
                    };
                    return dst;
                }

                static create(src?: AutoDesignSuggestionFoundation_createType) {
                    const dst = new AutoDesignSuggestionFoundation();
                    if (src === undefined) {
                        return dst;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSuggestionFoundation();
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSuggestionFoundation.toObject(this);
                    const dst = AutoDesignSuggestionFoundation.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSuggestionFoundation = AutoDesignSuggestionFoundation;


            export type AutoDesignSuggestion_keys = 'isRecommended' | 'sectionGuid' | 'materialGuid' | 'controls' | 'steel' | 'timber' | 'concrete' | 'beam' | 'column' | 'foundation';
            export interface AutoDesignSuggestion_createType {
                isRecommended?: boolean,
                sectionGuid?: string,
                materialGuid?: string,
                controls?: ng.result.control.ControlData[],
                steel?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel | null,
                timber?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber | null,
                concrete?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete | null,
                beam?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam | null,
                column?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn | null,
                foundation?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation | null,
            }
            export interface AutoDesignSuggestion_json {
                isRecommended?: boolean;
                sectionGuid?: string;
                materialGuid?: string;
                controls: ng.result.control.ControlData_json[];
                steel?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel_json;
                timber?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber_json;
                concrete?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete_json;
                beam?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam_json;
                column?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn_json;
                foundation?: ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation_json;
            }
            interface AutoDesignSuggestion_json_in {
                __proto_name?: unknown;
                isRecommended?: unknown;
                sectionGuid?: unknown;
                materialGuid?: unknown;
                controls?: unknown;
                steel?: unknown;
                timber?: unknown;
                concrete?: unknown;
                beam?: unknown;
                column?: unknown;
                foundation?: unknown;
            }
            export class AutoDesignSuggestion {
                __proto_name = "ng.endpoint_args.common_api_functions.AutoDesignSuggestion";
                isRecommended: boolean = false;
                sectionGuid: string = "";
                materialGuid: string = "";
                controls: ng.result.control.ControlData[] = [];
                // this is a one of
                material: {type: 'steel'; steel: ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel} | {type: 'timber'; timber: ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber} | {type: 'concrete'; concrete: ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete} | null = null;
                // this is a one of
                geometry: {type: 'beam'; beam: ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam} | {type: 'column'; column: ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn} | {type: 'foundation'; foundation: ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation} | null = null;

                /** Gets the `Steel` value (or null) from the oneof `material` */
                getSteel(): ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel | null {
                    if(this.material === null) return null;
                    if(this.material.type !== 'steel') return null;
                    return this.material.steel;
                }

                /** Sets the `Steel` value for the oneof `material`*/
                setSteel(value: ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel | null) {
                    if(value !== null) {
                        this.material = {type: 'steel', steel:value};
                    }
                    else {
                        this.material = null;
                    }
                }

                /** Gets the `Timber` value (or null) from the oneof `material` */
                getTimber(): ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber | null {
                    if(this.material === null) return null;
                    if(this.material.type !== 'timber') return null;
                    return this.material.timber;
                }

                /** Sets the `Timber` value for the oneof `material`*/
                setTimber(value: ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber | null) {
                    if(value !== null) {
                        this.material = {type: 'timber', timber:value};
                    }
                    else {
                        this.material = null;
                    }
                }

                /** Gets the `Concrete` value (or null) from the oneof `material` */
                getConcrete(): ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete | null {
                    if(this.material === null) return null;
                    if(this.material.type !== 'concrete') return null;
                    return this.material.concrete;
                }

                /** Sets the `Concrete` value for the oneof `material`*/
                setConcrete(value: ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete | null) {
                    if(value !== null) {
                        this.material = {type: 'concrete', concrete:value};
                    }
                    else {
                        this.material = null;
                    }
                }
                /** Gets the `Beam` value (or null) from the oneof `geometry` */
                getBeam(): ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam | null {
                    if(this.geometry === null) return null;
                    if(this.geometry.type !== 'beam') return null;
                    return this.geometry.beam;
                }

                /** Sets the `Beam` value for the oneof `geometry`*/
                setBeam(value: ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam | null) {
                    if(value !== null) {
                        this.geometry = {type: 'beam', beam:value};
                    }
                    else {
                        this.geometry = null;
                    }
                }

                /** Gets the `Column` value (or null) from the oneof `geometry` */
                getColumn(): ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn | null {
                    if(this.geometry === null) return null;
                    if(this.geometry.type !== 'column') return null;
                    return this.geometry.column;
                }

                /** Sets the `Column` value for the oneof `geometry`*/
                setColumn(value: ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn | null) {
                    if(value !== null) {
                        this.geometry = {type: 'column', column:value};
                    }
                    else {
                        this.geometry = null;
                    }
                }

                /** Gets the `Foundation` value (or null) from the oneof `geometry` */
                getFoundation(): ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation | null {
                    if(this.geometry === null) return null;
                    if(this.geometry.type !== 'foundation') return null;
                    return this.geometry.foundation;
                }

                /** Sets the `Foundation` value for the oneof `geometry`*/
                setFoundation(value: ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation | null) {
                    if(value !== null) {
                        this.geometry = {type: 'foundation', foundation:value};
                    }
                    else {
                        this.geometry = null;
                    }
                }

                static fromObject(src_unknown: unknown): AutoDesignSuggestion {
                    const dst = new AutoDesignSuggestion();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AutoDesignSuggestion but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AutoDesignSuggestion_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AutoDesignSuggestion but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.isRecommended !== undefined && src.isRecommended !== null) {
                        if (typeof src.isRecommended === "boolean") {
                            dst.isRecommended = src.isRecommended;
                        }
                        else {
                            console.log('Expected isRecommended of AutoDesignSuggestion to be a boolean but was ', typeof src.isRecommended, src.isRecommended)
                        }
                    }
                    if (src.sectionGuid !== undefined && src.sectionGuid !== null) {
                        if (typeof src.sectionGuid === "string") {
                            dst.sectionGuid = src.sectionGuid;
                        }
                        else {
                            console.log('Expected sectionGuid of AutoDesignSuggestion to be a string but was ', typeof src.sectionGuid, src.sectionGuid)
                        }
                    }
                    if (src.materialGuid !== undefined && src.materialGuid !== null) {
                        if (typeof src.materialGuid === "string") {
                            dst.materialGuid = src.materialGuid;
                        }
                        else {
                            console.log('Expected materialGuid of AutoDesignSuggestion to be a string but was ', typeof src.materialGuid, src.materialGuid)
                        }
                    }
                    if (src.controls !== undefined && src.controls !== null) {
                        if (Array.isArray(src.controls)) {
                            for (const element of src.controls) {
                                dst.controls.push(ng.result.control.ControlData.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected controls of AutoDesignSuggestion to be a array but was ', typeof src.controls, src.controls)
                        }
                    }
                    if (src.steel !== undefined && src.steel !== null) {
                        dst.setSteel(ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel.fromObject(src.steel));
                    }
                    if (src.timber !== undefined && src.timber !== null) {
                        dst.setTimber(ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber.fromObject(src.timber));
                    }
                    if (src.concrete !== undefined && src.concrete !== null) {
                        dst.setConcrete(ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete.fromObject(src.concrete));
                    }
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam.fromObject(src.beam));
                    }
                    if (src.column !== undefined && src.column !== null) {
                        dst.setColumn(ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn.fromObject(src.column));
                    }
                    if (src.foundation !== undefined && src.foundation !== null) {
                        dst.setFoundation(ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation.fromObject(src.foundation));
                    }
                    return dst;
                }

                static toObject(src: AutoDesignSuggestion | null | undefined): AutoDesignSuggestion_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AutoDesignSuggestion is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AutoDesignSuggestion") {
                        console.error('Expected ng.endpoint_args.common_api_functions.AutoDesignSuggestion but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AutoDesignSuggestion_json = {
                        isRecommended: src.isRecommended,
                        sectionGuid: src.sectionGuid,
                        materialGuid: src.materialGuid,
                        controls: new Array<ng.result.control.ControlData_json>(),
                    };
                    if (src.controls !== null) {
                        for (const element of src.controls) {
                            const parsed = ng.result.control.ControlData.toObject(element);
                            if(parsed === null) return null;
                            dst.controls.push(parsed);
                        }
                    }
                    const steel = src.getSteel();
                    if(steel !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSuggestionSteel.toObject(steel);
                        if(parsed === null) return null;
                        dst.steel = parsed;
                    }
                    const timber = src.getTimber();
                    if(timber !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSuggestionTimber.toObject(timber);
                        if(parsed === null) return null;
                        dst.timber = parsed;
                    }
                    const concrete = src.getConcrete();
                    if(concrete !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSuggestionConcrete.toObject(concrete);
                        if(parsed === null) return null;
                        dst.concrete = parsed;
                    }
                    const beam = src.getBeam();
                    if(beam !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSuggestionBeam.toObject(beam);
                        if(parsed === null) return null;
                        dst.beam = parsed;
                    }
                    const column = src.getColumn();
                    if(column !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSuggestionColumn.toObject(column);
                        if(parsed === null) return null;
                        dst.column = parsed;
                    }
                    const foundation = src.getFoundation();
                    if(foundation !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesignSuggestionFoundation.toObject(foundation);
                        if(parsed === null) return null;
                        dst.foundation = parsed;
                    }
                    return dst;
                }

                static create(src?: AutoDesignSuggestion_createType) {
                    const dst = new AutoDesignSuggestion();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.isRecommended !== undefined) {
                        dst.isRecommended = src.isRecommended;
                    }
                    if (src.sectionGuid !== undefined) {
                        dst.sectionGuid = src.sectionGuid;
                    }
                    if (src.materialGuid !== undefined) {
                        dst.materialGuid = src.materialGuid;
                    }
                    if (src.controls !== undefined) {
                        dst.controls = src.controls;
                    }
                    // part of the material oneof 
                    if (src.steel !== undefined && src.steel !== null) {
                        dst.setSteel(src.steel);
                    }
                    // part of the material oneof 
                    if (src.timber !== undefined && src.timber !== null) {
                        dst.setTimber(src.timber);
                    }
                    // part of the material oneof 
                    if (src.concrete !== undefined && src.concrete !== null) {
                        dst.setConcrete(src.concrete);
                    }
                    // part of the geometry oneof 
                    if (src.beam !== undefined && src.beam !== null) {
                        dst.setBeam(src.beam);
                    }
                    // part of the geometry oneof 
                    if (src.column !== undefined && src.column !== null) {
                        dst.setColumn(src.column);
                    }
                    // part of the geometry oneof 
                    if (src.foundation !== undefined && src.foundation !== null) {
                        dst.setFoundation(src.foundation);
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AutoDesignSuggestion();
                    dst.isRecommended = this.isRecommended;
                    dst.sectionGuid = this.sectionGuid;
                    dst.materialGuid = this.materialGuid;
                    dst.controls = this.controls;
                    dst.material = this.material;
                    dst.geometry = this.geometry;
                    return dst;
                }

                deepClone() {
                    const json = AutoDesignSuggestion.toObject(this);
                    const dst = AutoDesignSuggestion.fromObject(json);
                    return dst;
                }
            }
            export type IAutoDesignSuggestion = AutoDesignSuggestion;


            export type CodeCheckInput_keys = 'project' | 'lcombGuids' | 'mathml' | 'mathmlmax' | 'autoDesign' | 'resultRequests';
            export interface CodeCheckInput_createType {
                project?: ng.project.Data | null,
                lcombGuids?: string[],
                mathml?: boolean,
                mathmlmax?: boolean,
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign | null,
                resultRequests?: ng.endpoint_args.common_api_functions.CodeCheckResultRequest[],
            }
            export interface CodeCheckInput_json {
                project?: ng.project.Data_json;
                lcombGuids: string[];
                mathml?: boolean;
                mathmlmax?: boolean;
                autoDesign?: ng.endpoint_args.common_api_functions.AutoDesign_json;
                resultRequests: string[];
            }
            interface CodeCheckInput_json_in {
                __proto_name?: unknown;
                project?: unknown;
                lcombGuids?: unknown;
                mathml?: unknown;
                mathmlmax?: unknown;
                autoDesign?: unknown;
                resultRequests?: unknown;
            }
            export class CodeCheckInput {
                __proto_name = "ng.endpoint_args.common_api_functions.CodeCheckInput";
                project: ng.project.Data | null = null;
                lcombGuids: string[] = [];
                mathml: boolean = false;
                mathmlmax: boolean = false;
                autoDesign: ng.endpoint_args.common_api_functions.AutoDesign | null = null;
                resultRequests: ng.endpoint_args.common_api_functions.CodeCheckResultRequest[] = [];

                static fromObject(src_unknown: unknown): CodeCheckInput {
                    const dst = new CodeCheckInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CodeCheckInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CodeCheckInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CodeCheckInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.project !== undefined && src.project !== null) {
                        dst.project = ng.project.Data.fromObject(src.project);
                    }
                    if (src.lcombGuids !== undefined && src.lcombGuids !== null) {
                        if (Array.isArray(src.lcombGuids)) {
                            for (const [index, element] of src.lcombGuids.entries()) {
                                if (typeof element === "string") {
                                    dst.lcombGuids.push(element);
                                }
                                else {
                                    console.log('Expected lcombGuids of CodeCheckInput[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected lcombGuids of CodeCheckInput to be a array but was ', typeof src.lcombGuids, src.lcombGuids)
                        }
                    }
                    if (src.mathml !== undefined && src.mathml !== null) {
                        if (typeof src.mathml === "boolean") {
                            dst.mathml = src.mathml;
                        }
                        else {
                            console.log('Expected mathml of CodeCheckInput to be a boolean but was ', typeof src.mathml, src.mathml)
                        }
                    }
                    if (src.mathmlmax !== undefined && src.mathmlmax !== null) {
                        if (typeof src.mathmlmax === "boolean") {
                            dst.mathmlmax = src.mathmlmax;
                        }
                        else {
                            console.log('Expected mathmlmax of CodeCheckInput to be a boolean but was ', typeof src.mathmlmax, src.mathmlmax)
                        }
                    }
                    if (src.autoDesign !== undefined && src.autoDesign !== null) {
                        dst.autoDesign = ng.endpoint_args.common_api_functions.AutoDesign.fromObject(src.autoDesign);
                    }
                    if (src.resultRequests !== undefined && src.resultRequests !== null) {
                        if (Array.isArray(src.resultRequests)) {
                            for (const element of src.resultRequests) {
                                dst.resultRequests.push(ng.endpoint_args.common_api_functions.CodeCheckResultRequest_FromObject(element));
                            }
                        }
                        else {
                            console.log('Expected resultRequests of CodeCheckInput to be a array but was ', typeof src.resultRequests, src.resultRequests)
                        }
                    }
                    return dst;
                }

                static toObject(src: CodeCheckInput | null | undefined): CodeCheckInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.CodeCheckInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.CodeCheckInput") {
                        console.error('Expected ng.endpoint_args.common_api_functions.CodeCheckInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CodeCheckInput_json = {
                        lcombGuids: new Array<string>(),
                        mathml: src.mathml,
                        mathmlmax: src.mathmlmax,
                        resultRequests: new Array<string>(),
                    };
                    if(src.project !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.project);
                        if(parsed === null) return null;
                        dst.project = parsed;
                    }
                    if (src.lcombGuids !== null) {
                        for (const element of src.lcombGuids) {
                            dst.lcombGuids.push(element);
                        }
                    }
                    if(src.autoDesign !== null)
                    {
                        const parsed = ng.endpoint_args.common_api_functions.AutoDesign.toObject(src.autoDesign);
                        if(parsed === null) return null;
                        dst.autoDesign = parsed;
                    }
                    if (src.resultRequests !== null) {
                        for (const element of src.resultRequests) {
                            const parsed = ng.endpoint_args.common_api_functions.CodeCheckResultRequest_ToObject(element);
                            if(parsed === null) return null;
                            dst.resultRequests.push(parsed);
                        }
                    }
                    return dst;
                }

                static create(src?: CodeCheckInput_createType) {
                    const dst = new CodeCheckInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.lcombGuids !== undefined) {
                        dst.lcombGuids = src.lcombGuids;
                    }
                    if (src.mathml !== undefined) {
                        dst.mathml = src.mathml;
                    }
                    if (src.mathmlmax !== undefined) {
                        dst.mathmlmax = src.mathmlmax;
                    }
                    if (src.autoDesign !== undefined) {
                        dst.autoDesign = src.autoDesign;
                    }
                    if (src.resultRequests !== undefined) {
                        dst.resultRequests = src.resultRequests;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CodeCheckInput();
                    dst.project = this.project;
                    dst.lcombGuids = this.lcombGuids;
                    dst.mathml = this.mathml;
                    dst.mathmlmax = this.mathmlmax;
                    dst.autoDesign = this.autoDesign;
                    dst.resultRequests = this.resultRequests;
                    return dst;
                }

                deepClone() {
                    const json = CodeCheckInput.toObject(this);
                    const dst = CodeCheckInput.fromObject(json);
                    return dst;
                }
            }
            export type ICodeCheckInput = CodeCheckInput;


            export type CodeCheckOutput_keys = 'project' | 'suggestions' | 'log';
            export interface CodeCheckOutput_createType {
                project?: ng.project.Data | null,
                suggestions?: ng.endpoint_args.common_api_functions.AutoDesignSuggestion[],
                log?: ng.log.Log | null,
            }
            export interface CodeCheckOutput_json {
                project?: ng.project.Data_json;
                suggestions: ng.endpoint_args.common_api_functions.AutoDesignSuggestion_json[];
                log?: ng.log.Log_json;
            }
            interface CodeCheckOutput_json_in {
                __proto_name?: unknown;
                project?: unknown;
                suggestions?: unknown;
                log?: unknown;
            }
            export class CodeCheckOutput {
                __proto_name = "ng.endpoint_args.common_api_functions.CodeCheckOutput";
                project: ng.project.Data | null = null;
                suggestions: ng.endpoint_args.common_api_functions.AutoDesignSuggestion[] = [];
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): CodeCheckOutput {
                    const dst = new CodeCheckOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CodeCheckOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CodeCheckOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CodeCheckOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.project !== undefined && src.project !== null) {
                        dst.project = ng.project.Data.fromObject(src.project);
                    }
                    if (src.suggestions !== undefined && src.suggestions !== null) {
                        if (Array.isArray(src.suggestions)) {
                            for (const element of src.suggestions) {
                                dst.suggestions.push(ng.endpoint_args.common_api_functions.AutoDesignSuggestion.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected suggestions of CodeCheckOutput to be a array but was ', typeof src.suggestions, src.suggestions)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: CodeCheckOutput | null | undefined): CodeCheckOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.CodeCheckOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.CodeCheckOutput") {
                        console.error('Expected ng.endpoint_args.common_api_functions.CodeCheckOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CodeCheckOutput_json = {
                        suggestions: new Array<ng.endpoint_args.common_api_functions.AutoDesignSuggestion_json>(),
                    };
                    if(src.project !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.project);
                        if(parsed === null) return null;
                        dst.project = parsed;
                    }
                    if (src.suggestions !== null) {
                        for (const element of src.suggestions) {
                            const parsed = ng.endpoint_args.common_api_functions.AutoDesignSuggestion.toObject(element);
                            if(parsed === null) return null;
                            dst.suggestions.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: CodeCheckOutput_createType) {
                    const dst = new CodeCheckOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.suggestions !== undefined) {
                        dst.suggestions = src.suggestions;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CodeCheckOutput();
                    dst.project = this.project;
                    dst.suggestions = this.suggestions;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = CodeCheckOutput.toObject(this);
                    const dst = CodeCheckOutput.fromObject(json);
                    return dst;
                }
            }
            export type ICodeCheckOutput = CodeCheckOutput;


            export type CarbonFootPrintInput_keys = 'input';
            export interface CarbonFootPrintInput_createType {
                input?: ng.input.Data | null,
            }
            export interface CarbonFootPrintInput_json {
                input?: ng.input.Data_json;
            }
            interface CarbonFootPrintInput_json_in {
                __proto_name?: unknown;
                input?: unknown;
            }
            export class CarbonFootPrintInput {
                __proto_name = "ng.endpoint_args.common_api_functions.CarbonFootPrintInput";
                input: ng.input.Data | null = null;

                static fromObject(src_unknown: unknown): CarbonFootPrintInput {
                    const dst = new CarbonFootPrintInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CarbonFootPrintInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CarbonFootPrintInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CarbonFootPrintInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.input !== undefined && src.input !== null) {
                        dst.input = ng.input.Data.fromObject(src.input);
                    }
                    return dst;
                }

                static toObject(src: CarbonFootPrintInput | null | undefined): CarbonFootPrintInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.CarbonFootPrintInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.CarbonFootPrintInput") {
                        console.error('Expected ng.endpoint_args.common_api_functions.CarbonFootPrintInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CarbonFootPrintInput_json = {
                    };
                    if(src.input !== null)
                    {
                        const parsed = ng.input.Data.toObject(src.input);
                        if(parsed === null) return null;
                        dst.input = parsed;
                    }
                    return dst;
                }

                static create(src?: CarbonFootPrintInput_createType) {
                    const dst = new CarbonFootPrintInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.input !== undefined) {
                        dst.input = src.input;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CarbonFootPrintInput();
                    dst.input = this.input;
                    return dst;
                }

                deepClone() {
                    const json = CarbonFootPrintInput.toObject(this);
                    const dst = CarbonFootPrintInput.fromObject(json);
                    return dst;
                }
            }
            export type ICarbonFootPrintInput = CarbonFootPrintInput;


            export type CarbonFootPrintOutput_keys = 'carbon' | 'log';
            export interface CarbonFootPrintOutput_createType {
                carbon?: ng.environmental_parameters.ElementCarbonFootprint[],
                log?: ng.log.Log | null,
            }
            export interface CarbonFootPrintOutput_json {
                carbon: ng.environmental_parameters.ElementCarbonFootprint_json[];
                log?: ng.log.Log_json;
            }
            interface CarbonFootPrintOutput_json_in {
                __proto_name?: unknown;
                carbon?: unknown;
                log?: unknown;
            }
            export class CarbonFootPrintOutput {
                __proto_name = "ng.endpoint_args.common_api_functions.CarbonFootPrintOutput";
                carbon: ng.environmental_parameters.ElementCarbonFootprint[] = [];
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): CarbonFootPrintOutput {
                    const dst = new CarbonFootPrintOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CarbonFootPrintOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CarbonFootPrintOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CarbonFootPrintOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.carbon !== undefined && src.carbon !== null) {
                        if (Array.isArray(src.carbon)) {
                            for (const element of src.carbon) {
                                dst.carbon.push(ng.environmental_parameters.ElementCarbonFootprint.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected carbon of CarbonFootPrintOutput to be a array but was ', typeof src.carbon, src.carbon)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: CarbonFootPrintOutput | null | undefined): CarbonFootPrintOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.CarbonFootPrintOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.common_api_functions.CarbonFootPrintOutput") {
                        console.error('Expected ng.endpoint_args.common_api_functions.CarbonFootPrintOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CarbonFootPrintOutput_json = {
                        carbon: new Array<ng.environmental_parameters.ElementCarbonFootprint_json>(),
                    };
                    if (src.carbon !== null) {
                        for (const element of src.carbon) {
                            const parsed = ng.environmental_parameters.ElementCarbonFootprint.toObject(element);
                            if(parsed === null) return null;
                            dst.carbon.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: CarbonFootPrintOutput_createType) {
                    const dst = new CarbonFootPrintOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.carbon !== undefined) {
                        dst.carbon = src.carbon;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CarbonFootPrintOutput();
                    dst.carbon = this.carbon;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = CarbonFootPrintOutput.toObject(this);
                    const dst = CarbonFootPrintOutput.fromObject(json);
                    return dst;
                }
            }
            export type ICarbonFootPrintOutput = CarbonFootPrintOutput;


            // Defined in EndPointArguments/common_api_functions.proto
            export namespace AdminReport {
                export type CalculationTime_keys = 'average' | 'median' | 'max' | 'min';
                export interface CalculationTime_createType {
                    average?: string,
                    median?: string,
                    max?: string,
                    min?: string,
                }
                export interface CalculationTime_json {
                    average?: string;
                    median?: string;
                    max?: string;
                    min?: string;
                }
                interface CalculationTime_json_in {
                    __proto_name?: unknown;
                    average?: unknown;
                    median?: unknown;
                    max?: unknown;
                    min?: unknown;
                }
                export class CalculationTime {
                    __proto_name = "ng.endpoint_args.common_api_functions.AdminReport.CalculationTime";
                    average: string = "";
                    median: string = "";
                    max: string = "";
                    min: string = "";

                    static fromObject(src_unknown: unknown): CalculationTime {
                        const dst = new CalculationTime();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted CalculationTime but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as CalculationTime_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for CalculationTime but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.average !== undefined && src.average !== null) {
                            if (typeof src.average === "string") {
                                dst.average = src.average;
                            }
                            else {
                                console.log('Expected average of CalculationTime to be a string but was ', typeof src.average, src.average)
                            }
                        }
                        if (src.median !== undefined && src.median !== null) {
                            if (typeof src.median === "string") {
                                dst.median = src.median;
                            }
                            else {
                                console.log('Expected median of CalculationTime to be a string but was ', typeof src.median, src.median)
                            }
                        }
                        if (src.max !== undefined && src.max !== null) {
                            if (typeof src.max === "string") {
                                dst.max = src.max;
                            }
                            else {
                                console.log('Expected max of CalculationTime to be a string but was ', typeof src.max, src.max)
                            }
                        }
                        if (src.min !== undefined && src.min !== null) {
                            if (typeof src.min === "string") {
                                dst.min = src.min;
                            }
                            else {
                                console.log('Expected min of CalculationTime to be a string but was ', typeof src.min, src.min)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: CalculationTime | null | undefined): CalculationTime_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AdminReport.CalculationTime is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AdminReport.CalculationTime") {
                            console.error('Expected ng.endpoint_args.common_api_functions.AdminReport.CalculationTime but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : CalculationTime_json = {
                            average: src.average,
                            median: src.median,
                            max: src.max,
                            min: src.min,
                        };
                        return dst;
                    }

                    static create(src?: CalculationTime_createType) {
                        const dst = new CalculationTime();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.average !== undefined) {
                            dst.average = src.average;
                        }
                        if (src.median !== undefined) {
                            dst.median = src.median;
                        }
                        if (src.max !== undefined) {
                            dst.max = src.max;
                        }
                        if (src.min !== undefined) {
                            dst.min = src.min;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new CalculationTime();
                        dst.average = this.average;
                        dst.median = this.median;
                        dst.max = this.max;
                        dst.min = this.min;
                        return dst;
                    }

                    deepClone() {
                        const json = CalculationTime.toObject(this);
                        const dst = CalculationTime.fromObject(json);
                        return dst;
                    }
                }
                export type ICalculationTime = CalculationTime;


                export type ErrorEntry_keys = 'message' | 'count';
                export interface ErrorEntry_createType {
                    message?: string,
                    count?: number,
                }
                export interface ErrorEntry_json {
                    message?: string;
                    count?: JsonNumber;
                }
                interface ErrorEntry_json_in {
                    __proto_name?: unknown;
                    message?: unknown;
                    count?: unknown;
                }
                export class ErrorEntry {
                    __proto_name = "ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry";
                    message: string = "";
                    count: number = 0;

                    static fromObject(src_unknown: unknown): ErrorEntry {
                        const dst = new ErrorEntry();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted ErrorEntry but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as ErrorEntry_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for ErrorEntry but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.message !== undefined && src.message !== null) {
                            if (typeof src.message === "string") {
                                dst.message = src.message;
                            }
                            else {
                                console.log('Expected message of ErrorEntry to be a string but was ', typeof src.message, src.message)
                            }
                        }
                        if (src.count !== undefined && src.count !== null) {
                            if (typeof src.count === "number" || src.count === 'NaN' || src.count === 'Infinity' || src.count === '-Infinity') {
                                dst.count = NumberToInt("ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry.count", AsNum(src.count));
                            }
                            else {
                                console.log('Expected count of ErrorEntry to be a number but was ', typeof src.count, src.count)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: ErrorEntry | null | undefined): ErrorEntry_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry") {
                            console.error('Expected ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : ErrorEntry_json = {
                            message: src.message,
                            count: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.AdminReport.ErrorEntry.count", src.count)),
                        };
                        return dst;
                    }

                    static create(src?: ErrorEntry_createType) {
                        const dst = new ErrorEntry();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.message !== undefined) {
                            dst.message = src.message;
                        }
                        if (src.count !== undefined) {
                            dst.count = src.count;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new ErrorEntry();
                        dst.message = this.message;
                        dst.count = this.count;
                        return dst;
                    }

                    deepClone() {
                        const json = ErrorEntry.toObject(this);
                        const dst = ErrorEntry.fromObject(json);
                        return dst;
                    }
                }
                export type IErrorEntry = ErrorEntry;


                export type CallCountEntry_keys = 'count' | 'type' | 'material';
                export interface CallCountEntry_createType {
                    count?: number,
                    type?: string,
                    material?: ng.material.Mtrl,
                }
                export interface CallCountEntry_json {
                    count?: JsonNumber;
                    type?: string;
                    material?: string;
                }
                interface CallCountEntry_json_in {
                    __proto_name?: unknown;
                    count?: unknown;
                    type?: unknown;
                    material?: unknown;
                }
                export class CallCountEntry {
                    __proto_name = "ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry";
                    count: number = 0;
                    type: string = "";
                    material: ng.material.Mtrl = ng.material.Mtrl.MTRL_UNSPECIFIED;

                    static fromObject(src_unknown: unknown): CallCountEntry {
                        const dst = new CallCountEntry();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted CallCountEntry but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as CallCountEntry_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for CallCountEntry but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.count !== undefined && src.count !== null) {
                            if (typeof src.count === "number" || src.count === 'NaN' || src.count === 'Infinity' || src.count === '-Infinity') {
                                dst.count = NumberToInt("ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry.count", AsNum(src.count));
                            }
                            else {
                                console.log('Expected count of CallCountEntry to be a number but was ', typeof src.count, src.count)
                            }
                        }
                        if (src.type !== undefined && src.type !== null) {
                            if (typeof src.type === "string") {
                                dst.type = src.type;
                            }
                            else {
                                console.log('Expected type of CallCountEntry to be a string but was ', typeof src.type, src.type)
                            }
                        }
                        if (src.material !== undefined && src.material !== null) {
                            dst.material = ng.material.Mtrl_FromObject(src.material);
                        }
                        return dst;
                    }

                    static toObject(src: CallCountEntry | null | undefined): CallCountEntry_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry") {
                            console.error('Expected ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const material_obj = ng.material.Mtrl_ToObject(src.material);
                        if(material_obj === null) return null;

                        const dst : CallCountEntry_json = {
                            count: AsJsonNum(NumberToInt("ng.endpoint_args.common_api_functions.AdminReport.CallCountEntry.count", src.count)),
                            type: src.type,
                            material: material_obj,
                        };
                        return dst;
                    }

                    static create(src?: CallCountEntry_createType) {
                        const dst = new CallCountEntry();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.count !== undefined) {
                            dst.count = src.count;
                        }
                        if (src.type !== undefined) {
                            dst.type = src.type;
                        }
                        if (src.material !== undefined) {
                            dst.material = src.material;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new CallCountEntry();
                        dst.count = this.count;
                        dst.type = this.type;
                        dst.material = this.material;
                        return dst;
                    }

                    deepClone() {
                        const json = CallCountEntry.toObject(this);
                        const dst = CallCountEntry.fromObject(json);
                        return dst;
                    }
                }
                export type ICallCountEntry = CallCountEntry;
            } // namespace AdminReport
        } // namespace common_api_functions


        // Defined in EndPointArguments/utilities.proto
        export namespace utilities {
            export type LayoutInput_keys = 'project';
            export interface LayoutInput_createType {
                project?: ng.frontend.beam.Project | null,
            }
            export interface LayoutInput_json {
                project?: ng.frontend.beam.Project_json;
            }
            interface LayoutInput_json_in {
                __proto_name?: unknown;
                project?: unknown;
            }
            export class LayoutInput {
                __proto_name = "ng.endpoint_args.utilities.LayoutInput";
                project: ng.frontend.beam.Project | null = null;

                static fromObject(src_unknown: unknown): LayoutInput {
                    const dst = new LayoutInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LayoutInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LayoutInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LayoutInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.project !== undefined && src.project !== null) {
                        dst.project = ng.frontend.beam.Project.fromObject(src.project);
                    }
                    return dst;
                }

                static toObject(src: LayoutInput | null | undefined): LayoutInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.utilities.LayoutInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.utilities.LayoutInput") {
                        console.error('Expected ng.endpoint_args.utilities.LayoutInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LayoutInput_json = {
                    };
                    if(src.project !== null)
                    {
                        const parsed = ng.frontend.beam.Project.toObject(src.project);
                        if(parsed === null) return null;
                        dst.project = parsed;
                    }
                    return dst;
                }

                static create(src?: LayoutInput_createType) {
                    const dst = new LayoutInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LayoutInput();
                    dst.project = this.project;
                    return dst;
                }

                deepClone() {
                    const json = LayoutInput.toObject(this);
                    const dst = LayoutInput.fromObject(json);
                    return dst;
                }
            }
            export type ILayoutInput = LayoutInput;
        } // namespace utilities


        // Defined in EndPointArguments/section_analysis.proto
        export namespace section_analysis {
            export type SectionAnalysis_keys = 'parts' | 'log';
            export interface SectionAnalysis_createType {
                parts?: ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart | null,
                log?: ng.log.Log | null,
            }
            export interface SectionAnalysis_json {
                parts?: ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart_json;
                log?: ng.log.Log_json;
            }
            interface SectionAnalysis_json_in {
                __proto_name?: unknown;
                parts?: unknown;
                log?: unknown;
            }
            export class SectionAnalysis {
                __proto_name = "ng.endpoint_args.section_analysis.SectionAnalysis";
                parts: ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart | null = null;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): SectionAnalysis {
                    const dst = new SectionAnalysis();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SectionAnalysis but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SectionAnalysis_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SectionAnalysis but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.parts !== undefined && src.parts !== null) {
                        dst.parts = ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart.fromObject(src.parts);
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: SectionAnalysis | null | undefined): SectionAnalysis_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.section_analysis.SectionAnalysis is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.section_analysis.SectionAnalysis") {
                        console.error('Expected ng.endpoint_args.section_analysis.SectionAnalysis but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SectionAnalysis_json = {
                    };
                    if(src.parts !== null)
                    {
                        const parsed = ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart.toObject(src.parts);
                        if(parsed === null) return null;
                        dst.parts = parsed;
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: SectionAnalysis_createType) {
                    const dst = new SectionAnalysis();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.parts !== undefined) {
                        dst.parts = src.parts;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SectionAnalysis();
                    dst.parts = this.parts;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = SectionAnalysis.toObject(this);
                    const dst = SectionAnalysis.fromObject(json);
                    return dst;
                }
            }
            export type ISectionAnalysis = SectionAnalysis;


            // Defined in EndPointArguments/section_analysis.proto
            export namespace SectionAnalysis {
                export type SectionPart_keys = 'part';
                export interface SectionPart_createType {
                    part?: ng.sections.Section | null,
                }
                export interface SectionPart_json {
                    part?: ng.sections.Section_json;
                }
                interface SectionPart_json_in {
                    __proto_name?: unknown;
                    part?: unknown;
                }
                export class SectionPart {
                    __proto_name = "ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart";
                    part: ng.sections.Section | null = null;

                    static fromObject(src_unknown: unknown): SectionPart {
                        const dst = new SectionPart();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted SectionPart but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as SectionPart_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for SectionPart but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.part !== undefined && src.part !== null) {
                            dst.part = ng.sections.Section.fromObject(src.part);
                        }
                        return dst;
                    }

                    static toObject(src: SectionPart | null | undefined): SectionPart_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart") {
                            console.error('Expected ng.endpoint_args.section_analysis.SectionAnalysis.SectionPart but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : SectionPart_json = {
                        };
                        if(src.part !== null)
                        {
                            const parsed = ng.sections.Section.toObject(src.part);
                            if(parsed === null) return null;
                            dst.part = parsed;
                        }
                        return dst;
                    }

                    static create(src?: SectionPart_createType) {
                        const dst = new SectionPart();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.part !== undefined) {
                            dst.part = src.part;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new SectionPart();
                        dst.part = this.part;
                        return dst;
                    }

                    deepClone() {
                        const json = SectionPart.toObject(this);
                        const dst = SectionPart.fromObject(json);
                        return dst;
                    }
                }
                export type ISectionPart = SectionPart;
            } // namespace SectionAnalysis
        } // namespace section_analysis


        // Defined in EndPointArguments/rc_design.proto
        export namespace rc_design {
            export type RcOutput_keys = 'geoElems' | 'meshUpdate' | 'log';
            export interface RcOutput_createType {
                geoElems?: ng.endpoint_args.rc_design.RcOutput.GeoElement[],
                meshUpdate?: boolean,
                log?: ng.log.Log | null,
            }
            export interface RcOutput_json {
                geoElems: ng.endpoint_args.rc_design.RcOutput.GeoElement_json[];
                meshUpdate?: boolean;
                log?: ng.log.Log_json;
            }
            interface RcOutput_json_in {
                __proto_name?: unknown;
                geoElems?: unknown;
                meshUpdate?: unknown;
                log?: unknown;
            }
            export class RcOutput {
                __proto_name = "ng.endpoint_args.rc_design.RcOutput";
                geoElems: ng.endpoint_args.rc_design.RcOutput.GeoElement[] = [];
                meshUpdate: boolean = false;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): RcOutput {
                    const dst = new RcOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted RcOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as RcOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for RcOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.geoElems !== undefined && src.geoElems !== null) {
                        if (Array.isArray(src.geoElems)) {
                            for (const element of src.geoElems) {
                                dst.geoElems.push(ng.endpoint_args.rc_design.RcOutput.GeoElement.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected geoElems of RcOutput to be a array but was ', typeof src.geoElems, src.geoElems)
                        }
                    }
                    if (src.meshUpdate !== undefined && src.meshUpdate !== null) {
                        if (typeof src.meshUpdate === "boolean") {
                            dst.meshUpdate = src.meshUpdate;
                        }
                        else {
                            console.log('Expected meshUpdate of RcOutput to be a boolean but was ', typeof src.meshUpdate, src.meshUpdate)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: RcOutput | null | undefined): RcOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.rc_design.RcOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.rc_design.RcOutput") {
                        console.error('Expected ng.endpoint_args.rc_design.RcOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : RcOutput_json = {
                        geoElems: new Array<ng.endpoint_args.rc_design.RcOutput.GeoElement_json>(),
                        meshUpdate: src.meshUpdate,
                    };
                    if (src.geoElems !== null) {
                        for (const element of src.geoElems) {
                            const parsed = ng.endpoint_args.rc_design.RcOutput.GeoElement.toObject(element);
                            if(parsed === null) return null;
                            dst.geoElems.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: RcOutput_createType) {
                    const dst = new RcOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.geoElems !== undefined) {
                        dst.geoElems = src.geoElems;
                    }
                    if (src.meshUpdate !== undefined) {
                        dst.meshUpdate = src.meshUpdate;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new RcOutput();
                    dst.geoElems = this.geoElems;
                    dst.meshUpdate = this.meshUpdate;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = RcOutput.toObject(this);
                    const dst = RcOutput.fromObject(json);
                    return dst;
                }
            }
            export type IRcOutput = RcOutput;


            export type CoverSpaceInput_keys = 'input' | 'barDiameters' | 'stirrupDiameters';
            export interface CoverSpaceInput_createType {
                input?: ng.input.Data | null,
                barDiameters?: number[],
                stirrupDiameters?: number[],
            }
            export interface CoverSpaceInput_json {
                input?: ng.input.Data_json;
                barDiameters: JsonNumber[];
                stirrupDiameters: JsonNumber[];
            }
            interface CoverSpaceInput_json_in {
                __proto_name?: unknown;
                input?: unknown;
                barDiameters?: unknown;
                stirrupDiameters?: unknown;
            }
            export class CoverSpaceInput {
                __proto_name = "ng.endpoint_args.rc_design.CoverSpaceInput";
                input: ng.input.Data | null = null;
                barDiameters: number[] = [];
                stirrupDiameters: number[] = [];

                static fromObject(src_unknown: unknown): CoverSpaceInput {
                    const dst = new CoverSpaceInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CoverSpaceInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CoverSpaceInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CoverSpaceInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.input !== undefined && src.input !== null) {
                        dst.input = ng.input.Data.fromObject(src.input);
                    }
                    if (src.barDiameters !== undefined && src.barDiameters !== null) {
                        if (Array.isArray(src.barDiameters)) {
                            for (const [index, element] of src.barDiameters.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.barDiameters.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected barDiameters of CoverSpaceInput[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected barDiameters of CoverSpaceInput to be a array but was ', typeof src.barDiameters, src.barDiameters)
                        }
                    }
                    if (src.stirrupDiameters !== undefined && src.stirrupDiameters !== null) {
                        if (Array.isArray(src.stirrupDiameters)) {
                            for (const [index, element] of src.stirrupDiameters.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.stirrupDiameters.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected stirrupDiameters of CoverSpaceInput[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected stirrupDiameters of CoverSpaceInput to be a array but was ', typeof src.stirrupDiameters, src.stirrupDiameters)
                        }
                    }
                    return dst;
                }

                static toObject(src: CoverSpaceInput | null | undefined): CoverSpaceInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.rc_design.CoverSpaceInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.rc_design.CoverSpaceInput") {
                        console.error('Expected ng.endpoint_args.rc_design.CoverSpaceInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CoverSpaceInput_json = {
                        barDiameters: new Array<JsonNumber>(),
                        stirrupDiameters: new Array<JsonNumber>(),
                    };
                    if(src.input !== null)
                    {
                        const parsed = ng.input.Data.toObject(src.input);
                        if(parsed === null) return null;
                        dst.input = parsed;
                    }
                    if (src.barDiameters !== null) {
                        for (const element of src.barDiameters) {
                            dst.barDiameters.push(AsJsonNum(element));
                        }
                    }
                    if (src.stirrupDiameters !== null) {
                        for (const element of src.stirrupDiameters) {
                            dst.stirrupDiameters.push(AsJsonNum(element));
                        }
                    }
                    return dst;
                }

                static create(src?: CoverSpaceInput_createType) {
                    const dst = new CoverSpaceInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.input !== undefined) {
                        dst.input = src.input;
                    }
                    if (src.barDiameters !== undefined) {
                        dst.barDiameters = src.barDiameters;
                    }
                    if (src.stirrupDiameters !== undefined) {
                        dst.stirrupDiameters = src.stirrupDiameters;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CoverSpaceInput();
                    dst.input = this.input;
                    dst.barDiameters = this.barDiameters;
                    dst.stirrupDiameters = this.stirrupDiameters;
                    return dst;
                }

                deepClone() {
                    const json = CoverSpaceInput.toObject(this);
                    const dst = CoverSpaceInput.fromObject(json);
                    return dst;
                }
            }
            export type ICoverSpaceInput = CoverSpaceInput;


            export type CoverSpaceOutput_keys = 'minBarDistances' | 'minStirrupDistances' | 'maxBarSpacingInLayer' | 'log';
            export interface CoverSpaceOutput_createType {
                minBarDistances?: ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace[],
                minStirrupDistances?: ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace[],
                maxBarSpacingInLayer?: number,
                log?: ng.log.Log | null,
            }
            export interface CoverSpaceOutput_json {
                minBarDistances: ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace_json[];
                minStirrupDistances: ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace_json[];
                maxBarSpacingInLayer?: JsonNumber;
                log?: ng.log.Log_json;
            }
            interface CoverSpaceOutput_json_in {
                __proto_name?: unknown;
                minBarDistances?: unknown;
                minStirrupDistances?: unknown;
                maxBarSpacingInLayer?: unknown;
                log?: unknown;
            }
            export class CoverSpaceOutput {
                __proto_name = "ng.endpoint_args.rc_design.CoverSpaceOutput";
                minBarDistances: ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace[] = [];
                minStirrupDistances: ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace[] = [];
                maxBarSpacingInLayer: number = 0;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): CoverSpaceOutput {
                    const dst = new CoverSpaceOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted CoverSpaceOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as CoverSpaceOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for CoverSpaceOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.minBarDistances !== undefined && src.minBarDistances !== null) {
                        if (Array.isArray(src.minBarDistances)) {
                            for (const element of src.minBarDistances) {
                                dst.minBarDistances.push(ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected minBarDistances of CoverSpaceOutput to be a array but was ', typeof src.minBarDistances, src.minBarDistances)
                        }
                    }
                    if (src.minStirrupDistances !== undefined && src.minStirrupDistances !== null) {
                        if (Array.isArray(src.minStirrupDistances)) {
                            for (const element of src.minStirrupDistances) {
                                dst.minStirrupDistances.push(ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected minStirrupDistances of CoverSpaceOutput to be a array but was ', typeof src.minStirrupDistances, src.minStirrupDistances)
                        }
                    }
                    if (src.maxBarSpacingInLayer !== undefined && src.maxBarSpacingInLayer !== null) {
                        if (typeof src.maxBarSpacingInLayer === "number" || src.maxBarSpacingInLayer === 'NaN' || src.maxBarSpacingInLayer === 'Infinity' || src.maxBarSpacingInLayer === '-Infinity') {
                            dst.maxBarSpacingInLayer = AsNum(src.maxBarSpacingInLayer);
                        }
                        else {
                            console.log('Expected maxBarSpacingInLayer of CoverSpaceOutput to be a number but was ', typeof src.maxBarSpacingInLayer, src.maxBarSpacingInLayer)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: CoverSpaceOutput | null | undefined): CoverSpaceOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.rc_design.CoverSpaceOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.rc_design.CoverSpaceOutput") {
                        console.error('Expected ng.endpoint_args.rc_design.CoverSpaceOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : CoverSpaceOutput_json = {
                        minBarDistances: new Array<ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace_json>(),
                        minStirrupDistances: new Array<ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace_json>(),
                        maxBarSpacingInLayer: AsJsonNum(src.maxBarSpacingInLayer),
                    };
                    if (src.minBarDistances !== null) {
                        for (const element of src.minBarDistances) {
                            const parsed = ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace.toObject(element);
                            if(parsed === null) return null;
                            dst.minBarDistances.push(parsed);
                        }
                    }
                    if (src.minStirrupDistances !== null) {
                        for (const element of src.minStirrupDistances) {
                            const parsed = ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace.toObject(element);
                            if(parsed === null) return null;
                            dst.minStirrupDistances.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: CoverSpaceOutput_createType) {
                    const dst = new CoverSpaceOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.minBarDistances !== undefined) {
                        dst.minBarDistances = src.minBarDistances;
                    }
                    if (src.minStirrupDistances !== undefined) {
                        dst.minStirrupDistances = src.minStirrupDistances;
                    }
                    if (src.maxBarSpacingInLayer !== undefined) {
                        dst.maxBarSpacingInLayer = src.maxBarSpacingInLayer;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new CoverSpaceOutput();
                    dst.minBarDistances = this.minBarDistances;
                    dst.minStirrupDistances = this.minStirrupDistances;
                    dst.maxBarSpacingInLayer = this.maxBarSpacingInLayer;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = CoverSpaceOutput.toObject(this);
                    const dst = CoverSpaceOutput.fromObject(json);
                    return dst;
                }
            }
            export type ICoverSpaceOutput = CoverSpaceOutput;


            export type RcDesignControlInput_keys = 'proj' | 'model';
            export interface RcDesignControlInput_createType {
                proj?: ng.project.Data | null,
                model?: SOLVE.Model | null,
            }
            export interface RcDesignControlInput_json {
                proj?: ng.project.Data_json;
                model?: SOLVE.Model_json;
            }
            interface RcDesignControlInput_json_in {
                __proto_name?: unknown;
                proj?: unknown;
                model?: unknown;
            }
            export class RcDesignControlInput {
                __proto_name = "ng.endpoint_args.rc_design.RcDesignControlInput";
                proj: ng.project.Data | null = null;
                model: SOLVE.Model | null = null;

                static fromObject(src_unknown: unknown): RcDesignControlInput {
                    const dst = new RcDesignControlInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted RcDesignControlInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as RcDesignControlInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for RcDesignControlInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.proj !== undefined && src.proj !== null) {
                        dst.proj = ng.project.Data.fromObject(src.proj);
                    }
                    if (src.model !== undefined && src.model !== null) {
                        dst.model = SOLVE.Model.fromObject(src.model);
                    }
                    return dst;
                }

                static toObject(src: RcDesignControlInput | null | undefined): RcDesignControlInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.rc_design.RcDesignControlInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.rc_design.RcDesignControlInput") {
                        console.error('Expected ng.endpoint_args.rc_design.RcDesignControlInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : RcDesignControlInput_json = {
                    };
                    if(src.proj !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.proj);
                        if(parsed === null) return null;
                        dst.proj = parsed;
                    }
                    if(src.model !== null)
                    {
                        const parsed = SOLVE.Model.toObject(src.model);
                        if(parsed === null) return null;
                        dst.model = parsed;
                    }
                    return dst;
                }

                static create(src?: RcDesignControlInput_createType) {
                    const dst = new RcDesignControlInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.proj !== undefined) {
                        dst.proj = src.proj;
                    }
                    if (src.model !== undefined) {
                        dst.model = src.model;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new RcDesignControlInput();
                    dst.proj = this.proj;
                    dst.model = this.model;
                    return dst;
                }

                deepClone() {
                    const json = RcDesignControlInput.toObject(this);
                    const dst = RcDesignControlInput.fromObject(json);
                    return dst;
                }
            }
            export type IRcDesignControlInput = RcDesignControlInput;


            export type InteractionDiagramOutput_keys = 'results' | 'log';
            export interface InteractionDiagramOutput_createType {
                results?: ng.result.interaction_diagram.Result[],
                log?: ng.log.Log | null,
            }
            export interface InteractionDiagramOutput_json {
                results: ng.result.interaction_diagram.Result_json[];
                log?: ng.log.Log_json;
            }
            interface InteractionDiagramOutput_json_in {
                __proto_name?: unknown;
                results?: unknown;
                log?: unknown;
            }
            export class InteractionDiagramOutput {
                __proto_name = "ng.endpoint_args.rc_design.InteractionDiagramOutput";
                results: ng.result.interaction_diagram.Result[] = [];
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): InteractionDiagramOutput {
                    const dst = new InteractionDiagramOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted InteractionDiagramOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as InteractionDiagramOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for InteractionDiagramOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.results !== undefined && src.results !== null) {
                        if (Array.isArray(src.results)) {
                            for (const element of src.results) {
                                dst.results.push(ng.result.interaction_diagram.Result.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected results of InteractionDiagramOutput to be a array but was ', typeof src.results, src.results)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: InteractionDiagramOutput | null | undefined): InteractionDiagramOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.rc_design.InteractionDiagramOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.rc_design.InteractionDiagramOutput") {
                        console.error('Expected ng.endpoint_args.rc_design.InteractionDiagramOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : InteractionDiagramOutput_json = {
                        results: new Array<ng.result.interaction_diagram.Result_json>(),
                    };
                    if (src.results !== null) {
                        for (const element of src.results) {
                            const parsed = ng.result.interaction_diagram.Result.toObject(element);
                            if(parsed === null) return null;
                            dst.results.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: InteractionDiagramOutput_createType) {
                    const dst = new InteractionDiagramOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.results !== undefined) {
                        dst.results = src.results;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new InteractionDiagramOutput();
                    dst.results = this.results;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = InteractionDiagramOutput.toObject(this);
                    const dst = InteractionDiagramOutput.fromObject(json);
                    return dst;
                }
            }
            export type IInteractionDiagramOutput = InteractionDiagramOutput;


            // Defined in EndPointArguments/rc_design.proto
            export namespace RcOutput {
                export type SubElemProp_keys = 'ind' | 'x' | 'aEff' | 'i1Eff' | 'i2Eff' | 'i12Eff' | 'jEff' | 'cracked' | 'side' | 'e';
                export interface SubElemProp_createType {
                    ind?: number,
                    x?: number,
                    aEff?: number,
                    i1Eff?: number,
                    i2Eff?: number,
                    i12Eff?: number,
                    jEff?: number,
                    cracked?: boolean,
                    side?: number,
                    e?: number,
                }
                export interface SubElemProp_json {
                    ind?: JsonNumber;
                    x?: JsonNumber;
                    aEff?: JsonNumber;
                    i1Eff?: JsonNumber;
                    i2Eff?: JsonNumber;
                    i12Eff?: JsonNumber;
                    jEff?: JsonNumber;
                    cracked?: boolean;
                    side?: JsonNumber;
                    e?: JsonNumber;
                }
                interface SubElemProp_json_in {
                    __proto_name?: unknown;
                    ind?: unknown;
                    x?: unknown;
                    aEff?: unknown;
                    i1Eff?: unknown;
                    i2Eff?: unknown;
                    i12Eff?: unknown;
                    jEff?: unknown;
                    cracked?: unknown;
                    side?: unknown;
                    e?: unknown;
                }
                export class SubElemProp {
                    __proto_name = "ng.endpoint_args.rc_design.RcOutput.SubElemProp";
                    ind: number = 0;
                    x: number = 0;
                    aEff: number = 0;
                    i1Eff: number = 0;
                    i2Eff: number = 0;
                    i12Eff: number = 0;
                    jEff: number = 0;
                    cracked: boolean = false;
                    side: number = 0;
                    e: number = 0;

                    static fromObject(src_unknown: unknown): SubElemProp {
                        const dst = new SubElemProp();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted SubElemProp but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as SubElemProp_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for SubElemProp but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.ind !== undefined && src.ind !== null) {
                            if (typeof src.ind === "number" || src.ind === 'NaN' || src.ind === 'Infinity' || src.ind === '-Infinity') {
                                dst.ind = NumberToInt("ng.endpoint_args.rc_design.RcOutput.SubElemProp.ind", AsNum(src.ind));
                            }
                            else {
                                console.log('Expected ind of SubElemProp to be a number but was ', typeof src.ind, src.ind)
                            }
                        }
                        if (src.x !== undefined && src.x !== null) {
                            if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                                dst.x = AsNum(src.x);
                            }
                            else {
                                console.log('Expected x of SubElemProp to be a number but was ', typeof src.x, src.x)
                            }
                        }
                        if (src.aEff !== undefined && src.aEff !== null) {
                            if (typeof src.aEff === "number" || src.aEff === 'NaN' || src.aEff === 'Infinity' || src.aEff === '-Infinity') {
                                dst.aEff = AsNum(src.aEff);
                            }
                            else {
                                console.log('Expected aEff of SubElemProp to be a number but was ', typeof src.aEff, src.aEff)
                            }
                        }
                        if (src.i1Eff !== undefined && src.i1Eff !== null) {
                            if (typeof src.i1Eff === "number" || src.i1Eff === 'NaN' || src.i1Eff === 'Infinity' || src.i1Eff === '-Infinity') {
                                dst.i1Eff = AsNum(src.i1Eff);
                            }
                            else {
                                console.log('Expected i1Eff of SubElemProp to be a number but was ', typeof src.i1Eff, src.i1Eff)
                            }
                        }
                        if (src.i2Eff !== undefined && src.i2Eff !== null) {
                            if (typeof src.i2Eff === "number" || src.i2Eff === 'NaN' || src.i2Eff === 'Infinity' || src.i2Eff === '-Infinity') {
                                dst.i2Eff = AsNum(src.i2Eff);
                            }
                            else {
                                console.log('Expected i2Eff of SubElemProp to be a number but was ', typeof src.i2Eff, src.i2Eff)
                            }
                        }
                        if (src.i12Eff !== undefined && src.i12Eff !== null) {
                            if (typeof src.i12Eff === "number" || src.i12Eff === 'NaN' || src.i12Eff === 'Infinity' || src.i12Eff === '-Infinity') {
                                dst.i12Eff = AsNum(src.i12Eff);
                            }
                            else {
                                console.log('Expected i12Eff of SubElemProp to be a number but was ', typeof src.i12Eff, src.i12Eff)
                            }
                        }
                        if (src.jEff !== undefined && src.jEff !== null) {
                            if (typeof src.jEff === "number" || src.jEff === 'NaN' || src.jEff === 'Infinity' || src.jEff === '-Infinity') {
                                dst.jEff = AsNum(src.jEff);
                            }
                            else {
                                console.log('Expected jEff of SubElemProp to be a number but was ', typeof src.jEff, src.jEff)
                            }
                        }
                        if (src.cracked !== undefined && src.cracked !== null) {
                            if (typeof src.cracked === "boolean") {
                                dst.cracked = src.cracked;
                            }
                            else {
                                console.log('Expected cracked of SubElemProp to be a boolean but was ', typeof src.cracked, src.cracked)
                            }
                        }
                        if (src.side !== undefined && src.side !== null) {
                            if (typeof src.side === "number" || src.side === 'NaN' || src.side === 'Infinity' || src.side === '-Infinity') {
                                dst.side = NumberToInt("ng.endpoint_args.rc_design.RcOutput.SubElemProp.side", AsNum(src.side));
                            }
                            else {
                                console.log('Expected side of SubElemProp to be a number but was ', typeof src.side, src.side)
                            }
                        }
                        if (src.e !== undefined && src.e !== null) {
                            if (typeof src.e === "number" || src.e === 'NaN' || src.e === 'Infinity' || src.e === '-Infinity') {
                                dst.e = AsNum(src.e);
                            }
                            else {
                                console.log('Expected e of SubElemProp to be a number but was ', typeof src.e, src.e)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: SubElemProp | null | undefined): SubElemProp_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.rc_design.RcOutput.SubElemProp is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.rc_design.RcOutput.SubElemProp") {
                            console.error('Expected ng.endpoint_args.rc_design.RcOutput.SubElemProp but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : SubElemProp_json = {
                            ind: AsJsonNum(NumberToInt("ng.endpoint_args.rc_design.RcOutput.SubElemProp.ind", src.ind)),
                            x: AsJsonNum(src.x),
                            aEff: AsJsonNum(src.aEff),
                            i1Eff: AsJsonNum(src.i1Eff),
                            i2Eff: AsJsonNum(src.i2Eff),
                            i12Eff: AsJsonNum(src.i12Eff),
                            jEff: AsJsonNum(src.jEff),
                            cracked: src.cracked,
                            side: AsJsonNum(NumberToInt("ng.endpoint_args.rc_design.RcOutput.SubElemProp.side", src.side)),
                            e: AsJsonNum(src.e),
                        };
                        return dst;
                    }

                    static create(src?: SubElemProp_createType) {
                        const dst = new SubElemProp();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.ind !== undefined) {
                            dst.ind = src.ind;
                        }
                        if (src.x !== undefined) {
                            dst.x = src.x;
                        }
                        if (src.aEff !== undefined) {
                            dst.aEff = src.aEff;
                        }
                        if (src.i1Eff !== undefined) {
                            dst.i1Eff = src.i1Eff;
                        }
                        if (src.i2Eff !== undefined) {
                            dst.i2Eff = src.i2Eff;
                        }
                        if (src.i12Eff !== undefined) {
                            dst.i12Eff = src.i12Eff;
                        }
                        if (src.jEff !== undefined) {
                            dst.jEff = src.jEff;
                        }
                        if (src.cracked !== undefined) {
                            dst.cracked = src.cracked;
                        }
                        if (src.side !== undefined) {
                            dst.side = src.side;
                        }
                        if (src.e !== undefined) {
                            dst.e = src.e;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new SubElemProp();
                        dst.ind = this.ind;
                        dst.x = this.x;
                        dst.aEff = this.aEff;
                        dst.i1Eff = this.i1Eff;
                        dst.i2Eff = this.i2Eff;
                        dst.i12Eff = this.i12Eff;
                        dst.jEff = this.jEff;
                        dst.cracked = this.cracked;
                        dst.side = this.side;
                        dst.e = this.e;
                        return dst;
                    }

                    deepClone() {
                        const json = SubElemProp.toObject(this);
                        const dst = SubElemProp.fromObject(json);
                        return dst;
                    }
                }
                export type ISubElemProp = SubElemProp;


                export type GeoElement_keys = 'guid' | 'subElemProps' | 'fixForces';
                export interface GeoElement_createType {
                    guid?: string,
                    subElemProps?: ng.endpoint_args.rc_design.RcOutput.SubElemProp[],
                    fixForces?: number[],
                }
                export interface GeoElement_json {
                    guid?: string;
                    subElemProps: ng.endpoint_args.rc_design.RcOutput.SubElemProp_json[];
                    fixForces: JsonNumber[];
                }
                interface GeoElement_json_in {
                    __proto_name?: unknown;
                    guid?: unknown;
                    subElemProps?: unknown;
                    fixForces?: unknown;
                }
                export class GeoElement {
                    __proto_name = "ng.endpoint_args.rc_design.RcOutput.GeoElement";
                    guid: string = "";
                    subElemProps: ng.endpoint_args.rc_design.RcOutput.SubElemProp[] = [];
                    fixForces: number[] = [];

                    static fromObject(src_unknown: unknown): GeoElement {
                        const dst = new GeoElement();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted GeoElement but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as GeoElement_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for GeoElement but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.guid !== undefined && src.guid !== null) {
                            if (typeof src.guid === "string") {
                                dst.guid = src.guid;
                            }
                            else {
                                console.log('Expected guid of GeoElement to be a string but was ', typeof src.guid, src.guid)
                            }
                        }
                        if (src.subElemProps !== undefined && src.subElemProps !== null) {
                            if (Array.isArray(src.subElemProps)) {
                                for (const element of src.subElemProps) {
                                    dst.subElemProps.push(ng.endpoint_args.rc_design.RcOutput.SubElemProp.fromObject(element));
                                }
                            }
                            else {
                                console.log('Expected subElemProps of GeoElement to be a array but was ', typeof src.subElemProps, src.subElemProps)
                            }
                        }
                        if (src.fixForces !== undefined && src.fixForces !== null) {
                            if (Array.isArray(src.fixForces)) {
                                for (const [index, element] of src.fixForces.entries()) {
                                    if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                        dst.fixForces.push(AsNum(element));
                                    }
                                    else {
                                        console.log('Expected fixForces of GeoElement[', index, '] to be a number but was ', typeof element, element)
                                    }
                                }
                            }
                            else {
                                console.log('Expected fixForces of GeoElement to be a array but was ', typeof src.fixForces, src.fixForces)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: GeoElement | null | undefined): GeoElement_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.rc_design.RcOutput.GeoElement is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.rc_design.RcOutput.GeoElement") {
                            console.error('Expected ng.endpoint_args.rc_design.RcOutput.GeoElement but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : GeoElement_json = {
                            guid: src.guid,
                            subElemProps: new Array<ng.endpoint_args.rc_design.RcOutput.SubElemProp_json>(),
                            fixForces: new Array<JsonNumber>(),
                        };
                        if (src.subElemProps !== null) {
                            for (const element of src.subElemProps) {
                                const parsed = ng.endpoint_args.rc_design.RcOutput.SubElemProp.toObject(element);
                                if(parsed === null) return null;
                                dst.subElemProps.push(parsed);
                            }
                        }
                        if (src.fixForces !== null) {
                            for (const element of src.fixForces) {
                                dst.fixForces.push(AsJsonNum(element));
                            }
                        }
                        return dst;
                    }

                    static create(src?: GeoElement_createType) {
                        const dst = new GeoElement();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.guid !== undefined) {
                            dst.guid = src.guid;
                        }
                        if (src.subElemProps !== undefined) {
                            dst.subElemProps = src.subElemProps;
                        }
                        if (src.fixForces !== undefined) {
                            dst.fixForces = src.fixForces;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new GeoElement();
                        dst.guid = this.guid;
                        dst.subElemProps = this.subElemProps;
                        dst.fixForces = this.fixForces;
                        return dst;
                    }

                    deepClone() {
                        const json = GeoElement.toObject(this);
                        const dst = GeoElement.fromObject(json);
                        return dst;
                    }
                }
                export type IGeoElement = GeoElement;
            } // namespace RcOutput


            // Defined in EndPointArguments/rc_design.proto
            export namespace CoverSpaceOutput {
                export type RebarCoverSpace_keys = 'diameter' | 'cover' | 'spaceInLayer' | 'spaceBetweenLayer';
                export interface RebarCoverSpace_createType {
                    diameter?: number,
                    cover?: number,
                    spaceInLayer?: number,
                    spaceBetweenLayer?: number,
                }
                export interface RebarCoverSpace_json {
                    diameter?: JsonNumber;
                    cover?: JsonNumber;
                    spaceInLayer?: JsonNumber;
                    spaceBetweenLayer?: JsonNumber;
                }
                interface RebarCoverSpace_json_in {
                    __proto_name?: unknown;
                    diameter?: unknown;
                    cover?: unknown;
                    spaceInLayer?: unknown;
                    spaceBetweenLayer?: unknown;
                }
                export class RebarCoverSpace {
                    __proto_name = "ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace";
                    diameter: number = 0;
                    cover: number = 0;
                    spaceInLayer: number = 0;
                    spaceBetweenLayer: number = 0;

                    static fromObject(src_unknown: unknown): RebarCoverSpace {
                        const dst = new RebarCoverSpace();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted RebarCoverSpace but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as RebarCoverSpace_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for RebarCoverSpace but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.diameter !== undefined && src.diameter !== null) {
                            if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                                dst.diameter = AsNum(src.diameter);
                            }
                            else {
                                console.log('Expected diameter of RebarCoverSpace to be a number but was ', typeof src.diameter, src.diameter)
                            }
                        }
                        if (src.cover !== undefined && src.cover !== null) {
                            if (typeof src.cover === "number" || src.cover === 'NaN' || src.cover === 'Infinity' || src.cover === '-Infinity') {
                                dst.cover = AsNum(src.cover);
                            }
                            else {
                                console.log('Expected cover of RebarCoverSpace to be a number but was ', typeof src.cover, src.cover)
                            }
                        }
                        if (src.spaceInLayer !== undefined && src.spaceInLayer !== null) {
                            if (typeof src.spaceInLayer === "number" || src.spaceInLayer === 'NaN' || src.spaceInLayer === 'Infinity' || src.spaceInLayer === '-Infinity') {
                                dst.spaceInLayer = AsNum(src.spaceInLayer);
                            }
                            else {
                                console.log('Expected spaceInLayer of RebarCoverSpace to be a number but was ', typeof src.spaceInLayer, src.spaceInLayer)
                            }
                        }
                        if (src.spaceBetweenLayer !== undefined && src.spaceBetweenLayer !== null) {
                            if (typeof src.spaceBetweenLayer === "number" || src.spaceBetweenLayer === 'NaN' || src.spaceBetweenLayer === 'Infinity' || src.spaceBetweenLayer === '-Infinity') {
                                dst.spaceBetweenLayer = AsNum(src.spaceBetweenLayer);
                            }
                            else {
                                console.log('Expected spaceBetweenLayer of RebarCoverSpace to be a number but was ', typeof src.spaceBetweenLayer, src.spaceBetweenLayer)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: RebarCoverSpace | null | undefined): RebarCoverSpace_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace") {
                            console.error('Expected ng.endpoint_args.rc_design.CoverSpaceOutput.RebarCoverSpace but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : RebarCoverSpace_json = {
                            diameter: AsJsonNum(src.diameter),
                            cover: AsJsonNum(src.cover),
                            spaceInLayer: AsJsonNum(src.spaceInLayer),
                            spaceBetweenLayer: AsJsonNum(src.spaceBetweenLayer),
                        };
                        return dst;
                    }

                    static create(src?: RebarCoverSpace_createType) {
                        const dst = new RebarCoverSpace();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.diameter !== undefined) {
                            dst.diameter = src.diameter;
                        }
                        if (src.cover !== undefined) {
                            dst.cover = src.cover;
                        }
                        if (src.spaceInLayer !== undefined) {
                            dst.spaceInLayer = src.spaceInLayer;
                        }
                        if (src.spaceBetweenLayer !== undefined) {
                            dst.spaceBetweenLayer = src.spaceBetweenLayer;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new RebarCoverSpace();
                        dst.diameter = this.diameter;
                        dst.cover = this.cover;
                        dst.spaceInLayer = this.spaceInLayer;
                        dst.spaceBetweenLayer = this.spaceBetweenLayer;
                        return dst;
                    }

                    deepClone() {
                        const json = RebarCoverSpace.toObject(this);
                        const dst = RebarCoverSpace.fromObject(json);
                        return dst;
                    }
                }
                export type IRebarCoverSpace = RebarCoverSpace;


                export type StirrupCoverSpace_keys = 'diameter' | 'coverEnd' | 'spacing';
                export interface StirrupCoverSpace_createType {
                    diameter?: number,
                    coverEnd?: number,
                    spacing?: number,
                }
                export interface StirrupCoverSpace_json {
                    diameter?: JsonNumber;
                    coverEnd?: JsonNumber;
                    spacing?: JsonNumber;
                }
                interface StirrupCoverSpace_json_in {
                    __proto_name?: unknown;
                    diameter?: unknown;
                    coverEnd?: unknown;
                    spacing?: unknown;
                }
                export class StirrupCoverSpace {
                    __proto_name = "ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace";
                    diameter: number = 0;
                    coverEnd: number = 0;
                    spacing: number = 0;

                    static fromObject(src_unknown: unknown): StirrupCoverSpace {
                        const dst = new StirrupCoverSpace();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted StirrupCoverSpace but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as StirrupCoverSpace_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for StirrupCoverSpace but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.diameter !== undefined && src.diameter !== null) {
                            if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                                dst.diameter = AsNum(src.diameter);
                            }
                            else {
                                console.log('Expected diameter of StirrupCoverSpace to be a number but was ', typeof src.diameter, src.diameter)
                            }
                        }
                        if (src.coverEnd !== undefined && src.coverEnd !== null) {
                            if (typeof src.coverEnd === "number" || src.coverEnd === 'NaN' || src.coverEnd === 'Infinity' || src.coverEnd === '-Infinity') {
                                dst.coverEnd = AsNum(src.coverEnd);
                            }
                            else {
                                console.log('Expected coverEnd of StirrupCoverSpace to be a number but was ', typeof src.coverEnd, src.coverEnd)
                            }
                        }
                        if (src.spacing !== undefined && src.spacing !== null) {
                            if (typeof src.spacing === "number" || src.spacing === 'NaN' || src.spacing === 'Infinity' || src.spacing === '-Infinity') {
                                dst.spacing = AsNum(src.spacing);
                            }
                            else {
                                console.log('Expected spacing of StirrupCoverSpace to be a number but was ', typeof src.spacing, src.spacing)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: StirrupCoverSpace | null | undefined): StirrupCoverSpace_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace") {
                            console.error('Expected ng.endpoint_args.rc_design.CoverSpaceOutput.StirrupCoverSpace but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : StirrupCoverSpace_json = {
                            diameter: AsJsonNum(src.diameter),
                            coverEnd: AsJsonNum(src.coverEnd),
                            spacing: AsJsonNum(src.spacing),
                        };
                        return dst;
                    }

                    static create(src?: StirrupCoverSpace_createType) {
                        const dst = new StirrupCoverSpace();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.diameter !== undefined) {
                            dst.diameter = src.diameter;
                        }
                        if (src.coverEnd !== undefined) {
                            dst.coverEnd = src.coverEnd;
                        }
                        if (src.spacing !== undefined) {
                            dst.spacing = src.spacing;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new StirrupCoverSpace();
                        dst.diameter = this.diameter;
                        dst.coverEnd = this.coverEnd;
                        dst.spacing = this.spacing;
                        return dst;
                    }

                    deepClone() {
                        const json = StirrupCoverSpace.toObject(this);
                        const dst = StirrupCoverSpace.fromObject(json);
                        return dst;
                    }
                }
                export type IStirrupCoverSpace = StirrupCoverSpace;
            } // namespace CoverSpaceOutput
        } // namespace rc_design


        // Defined in EndPointArguments/eurocode.proto
        export namespace eurocode {
            export type EN1990Gamma0ArgsIn_keys = 'nationalAnnex' | 'consequencesClass' | 'combinationOfActions' | 'generation';
            export interface EN1990Gamma0ArgsIn_createType {
                nationalAnnex?: ng.eurocode.Annex,
                consequencesClass?: ng.structure.ConsequenceClass,
                combinationOfActions?: ng.loadcombination.CoaType,
                generation?: ng.eurocode.Generation,
            }
            export interface EN1990Gamma0ArgsIn_json {
                nationalAnnex?: string;
                consequencesClass?: string;
                combinationOfActions?: string;
                generation?: string;
            }
            interface EN1990Gamma0ArgsIn_json_in {
                __proto_name?: unknown;
                nationalAnnex?: unknown;
                consequencesClass?: unknown;
                combinationOfActions?: unknown;
                generation?: unknown;
            }
            export class EN1990Gamma0ArgsIn {
                __proto_name = "ng.endpoint_args.eurocode.EN1990Gamma0ArgsIn";
                nationalAnnex: ng.eurocode.Annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;
                consequencesClass: ng.structure.ConsequenceClass = ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED;
                combinationOfActions: ng.loadcombination.CoaType = ng.loadcombination.CoaType.COA_TYPE_UNSPECIFIED;
                generation: ng.eurocode.Generation = ng.eurocode.Generation.GENERATION_UNSPECIFIED;

                static fromObject(src_unknown: unknown): EN1990Gamma0ArgsIn {
                    const dst = new EN1990Gamma0ArgsIn();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EN1990Gamma0ArgsIn but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EN1990Gamma0ArgsIn_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EN1990Gamma0ArgsIn but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.nationalAnnex !== undefined && src.nationalAnnex !== null) {
                        dst.nationalAnnex = ng.eurocode.Annex_FromObject(src.nationalAnnex);
                    }
                    if (src.consequencesClass !== undefined && src.consequencesClass !== null) {
                        dst.consequencesClass = ng.structure.ConsequenceClass_FromObject(src.consequencesClass);
                    }
                    if (src.combinationOfActions !== undefined && src.combinationOfActions !== null) {
                        dst.combinationOfActions = ng.loadcombination.CoaType_FromObject(src.combinationOfActions);
                    }
                    if (src.generation !== undefined && src.generation !== null) {
                        dst.generation = ng.eurocode.Generation_FromObject(src.generation);
                    }
                    return dst;
                }

                static toObject(src: EN1990Gamma0ArgsIn | null | undefined): EN1990Gamma0ArgsIn_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.EN1990Gamma0ArgsIn is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.EN1990Gamma0ArgsIn") {
                        console.error('Expected ng.endpoint_args.eurocode.EN1990Gamma0ArgsIn but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const nationalAnnex_obj = ng.eurocode.Annex_ToObject(src.nationalAnnex);
                    if(nationalAnnex_obj === null) return null;

                    const consequencesClass_obj = ng.structure.ConsequenceClass_ToObject(src.consequencesClass);
                    if(consequencesClass_obj === null) return null;

                    const combinationOfActions_obj = ng.loadcombination.CoaType_ToObject(src.combinationOfActions);
                    if(combinationOfActions_obj === null) return null;

                    const generation_obj = ng.eurocode.Generation_ToObject(src.generation);
                    if(generation_obj === null) return null;

                    const dst : EN1990Gamma0ArgsIn_json = {
                        nationalAnnex: nationalAnnex_obj,
                        consequencesClass: consequencesClass_obj,
                        combinationOfActions: combinationOfActions_obj,
                        generation: generation_obj,
                    };
                    return dst;
                }

                static create(src?: EN1990Gamma0ArgsIn_createType) {
                    const dst = new EN1990Gamma0ArgsIn();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.nationalAnnex !== undefined) {
                        dst.nationalAnnex = src.nationalAnnex;
                    }
                    if (src.consequencesClass !== undefined) {
                        dst.consequencesClass = src.consequencesClass;
                    }
                    if (src.combinationOfActions !== undefined) {
                        dst.combinationOfActions = src.combinationOfActions;
                    }
                    if (src.generation !== undefined) {
                        dst.generation = src.generation;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EN1990Gamma0ArgsIn();
                    dst.nationalAnnex = this.nationalAnnex;
                    dst.consequencesClass = this.consequencesClass;
                    dst.combinationOfActions = this.combinationOfActions;
                    dst.generation = this.generation;
                    return dst;
                }

                deepClone() {
                    const json = EN1990Gamma0ArgsIn.toObject(this);
                    const dst = EN1990Gamma0ArgsIn.fromObject(json);
                    return dst;
                }
            }
            export type IEN1990Gamma0ArgsIn = EN1990Gamma0ArgsIn;


            export type EN1990Gamma0ArgsOut_keys = 'gamma0' | 'log';
            export interface EN1990Gamma0ArgsOut_createType {
                gamma0?: number,
                log?: ng.log.Log | null,
            }
            export interface EN1990Gamma0ArgsOut_json {
                gamma0?: JsonNumber;
                log?: ng.log.Log_json;
            }
            interface EN1990Gamma0ArgsOut_json_in {
                __proto_name?: unknown;
                gamma0?: unknown;
                log?: unknown;
            }
            export class EN1990Gamma0ArgsOut {
                __proto_name = "ng.endpoint_args.eurocode.EN1990Gamma0ArgsOut";
                gamma0: number = 0;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): EN1990Gamma0ArgsOut {
                    const dst = new EN1990Gamma0ArgsOut();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EN1990Gamma0ArgsOut but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EN1990Gamma0ArgsOut_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EN1990Gamma0ArgsOut but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.gamma0 !== undefined && src.gamma0 !== null) {
                        if (typeof src.gamma0 === "number" || src.gamma0 === 'NaN' || src.gamma0 === 'Infinity' || src.gamma0 === '-Infinity') {
                            dst.gamma0 = AsNum(src.gamma0);
                        }
                        else {
                            console.log('Expected gamma0 of EN1990Gamma0ArgsOut to be a number but was ', typeof src.gamma0, src.gamma0)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: EN1990Gamma0ArgsOut | null | undefined): EN1990Gamma0ArgsOut_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.EN1990Gamma0ArgsOut is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.EN1990Gamma0ArgsOut") {
                        console.error('Expected ng.endpoint_args.eurocode.EN1990Gamma0ArgsOut but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EN1990Gamma0ArgsOut_json = {
                        gamma0: AsJsonNum(src.gamma0),
                    };
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: EN1990Gamma0ArgsOut_createType) {
                    const dst = new EN1990Gamma0ArgsOut();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.gamma0 !== undefined) {
                        dst.gamma0 = src.gamma0;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EN1990Gamma0ArgsOut();
                    dst.gamma0 = this.gamma0;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = EN1990Gamma0ArgsOut.toObject(this);
                    const dst = EN1990Gamma0ArgsOut.fromObject(json);
                    return dst;
                }
            }
            export type IEN1990Gamma0ArgsOut = EN1990Gamma0ArgsOut;


            export type LoadCombGenSettings_keys = 'lcTypes' | 'structureguid' | 'allLoadcases' | 'loadcases' | 'simple' | 'advanced' | 'removeDuplex' | 'geotechnical';
            export interface LoadCombGenSettings_createType {
                lcTypes?: ng.loadcombination.Type[],
                structureguid?: string,
                allLoadcases?: boolean,
                loadcases?: string[],
                simple?: ng.endpoint_args.eurocode.Simple | null,
                advanced?: ng.endpoint_args.eurocode.Advanced | null,
                removeDuplex?: boolean,
                geotechnical?: ng.endpoint_args.eurocode.Geotechnical | null,
            }
            export interface LoadCombGenSettings_json {
                lcTypes: string[];
                structureguid?: string;
                allLoadcases?: boolean;
                loadcases: string[];
                simple?: ng.endpoint_args.eurocode.Simple_json;
                advanced?: ng.endpoint_args.eurocode.Advanced_json;
                removeDuplex?: boolean;
                geotechnical?: ng.endpoint_args.eurocode.Geotechnical_json;
            }
            interface LoadCombGenSettings_json_in {
                __proto_name?: unknown;
                lcTypes?: unknown;
                structureguid?: unknown;
                allLoadcases?: unknown;
                loadcases?: unknown;
                simple?: unknown;
                advanced?: unknown;
                removeDuplex?: unknown;
                geotechnical?: unknown;
            }
            export class LoadCombGenSettings {
                __proto_name = "ng.endpoint_args.eurocode.LoadCombGenSettings";
                lcTypes: ng.loadcombination.Type[] = [];
                structureguid: string = "";
                allLoadcases: boolean = false;
                loadcases: string[] = [];
                // this is a one of
                groups: {type: 'simple'; simple: ng.endpoint_args.eurocode.Simple} | {type: 'advanced'; advanced: ng.endpoint_args.eurocode.Advanced} | null = null;
                removeDuplex: boolean = false;
                geotechnical: ng.endpoint_args.eurocode.Geotechnical | null = null;

                /** Gets the `Simple` value (or null) from the oneof `groups` */
                getSimple(): ng.endpoint_args.eurocode.Simple | null {
                    if(this.groups === null) return null;
                    if(this.groups.type !== 'simple') return null;
                    return this.groups.simple;
                }

                /** Sets the `Simple` value for the oneof `groups`*/
                setSimple(value: ng.endpoint_args.eurocode.Simple | null) {
                    if(value !== null) {
                        this.groups = {type: 'simple', simple:value};
                    }
                    else {
                        this.groups = null;
                    }
                }

                /** Gets the `Advanced` value (or null) from the oneof `groups` */
                getAdvanced(): ng.endpoint_args.eurocode.Advanced | null {
                    if(this.groups === null) return null;
                    if(this.groups.type !== 'advanced') return null;
                    return this.groups.advanced;
                }

                /** Sets the `Advanced` value for the oneof `groups`*/
                setAdvanced(value: ng.endpoint_args.eurocode.Advanced | null) {
                    if(value !== null) {
                        this.groups = {type: 'advanced', advanced:value};
                    }
                    else {
                        this.groups = null;
                    }
                }

                static fromObject(src_unknown: unknown): LoadCombGenSettings {
                    const dst = new LoadCombGenSettings();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCombGenSettings but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCombGenSettings_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCombGenSettings but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.lcTypes !== undefined && src.lcTypes !== null) {
                        if (Array.isArray(src.lcTypes)) {
                            for (const element of src.lcTypes) {
                                dst.lcTypes.push(ng.loadcombination.Type_FromObject(element));
                            }
                        }
                        else {
                            console.log('Expected lcTypes of LoadCombGenSettings to be a array but was ', typeof src.lcTypes, src.lcTypes)
                        }
                    }
                    if (src.structureguid !== undefined && src.structureguid !== null) {
                        if (typeof src.structureguid === "string") {
                            dst.structureguid = src.structureguid;
                        }
                        else {
                            console.log('Expected structureguid of LoadCombGenSettings to be a string but was ', typeof src.structureguid, src.structureguid)
                        }
                    }
                    if (src.allLoadcases !== undefined && src.allLoadcases !== null) {
                        if (typeof src.allLoadcases === "boolean") {
                            dst.allLoadcases = src.allLoadcases;
                        }
                        else {
                            console.log('Expected allLoadcases of LoadCombGenSettings to be a boolean but was ', typeof src.allLoadcases, src.allLoadcases)
                        }
                    }
                    if (src.loadcases !== undefined && src.loadcases !== null) {
                        if (Array.isArray(src.loadcases)) {
                            for (const [index, element] of src.loadcases.entries()) {
                                if (typeof element === "string") {
                                    dst.loadcases.push(element);
                                }
                                else {
                                    console.log('Expected loadcases of LoadCombGenSettings[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected loadcases of LoadCombGenSettings to be a array but was ', typeof src.loadcases, src.loadcases)
                        }
                    }
                    if (src.simple !== undefined && src.simple !== null) {
                        dst.setSimple(ng.endpoint_args.eurocode.Simple.fromObject(src.simple));
                    }
                    if (src.advanced !== undefined && src.advanced !== null) {
                        dst.setAdvanced(ng.endpoint_args.eurocode.Advanced.fromObject(src.advanced));
                    }
                    if (src.removeDuplex !== undefined && src.removeDuplex !== null) {
                        if (typeof src.removeDuplex === "boolean") {
                            dst.removeDuplex = src.removeDuplex;
                        }
                        else {
                            console.log('Expected removeDuplex of LoadCombGenSettings to be a boolean but was ', typeof src.removeDuplex, src.removeDuplex)
                        }
                    }
                    if (src.geotechnical !== undefined && src.geotechnical !== null) {
                        dst.geotechnical = ng.endpoint_args.eurocode.Geotechnical.fromObject(src.geotechnical);
                    }
                    return dst;
                }

                static toObject(src: LoadCombGenSettings | null | undefined): LoadCombGenSettings_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.LoadCombGenSettings is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.LoadCombGenSettings") {
                        console.error('Expected ng.endpoint_args.eurocode.LoadCombGenSettings but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCombGenSettings_json = {
                        lcTypes: new Array<string>(),
                        structureguid: src.structureguid,
                        allLoadcases: src.allLoadcases,
                        loadcases: new Array<string>(),
                        removeDuplex: src.removeDuplex,
                    };
                    if (src.lcTypes !== null) {
                        for (const element of src.lcTypes) {
                            const parsed = ng.loadcombination.Type_ToObject(element);
                            if(parsed === null) return null;
                            dst.lcTypes.push(parsed);
                        }
                    }
                    if (src.loadcases !== null) {
                        for (const element of src.loadcases) {
                            dst.loadcases.push(element);
                        }
                    }
                    const simple = src.getSimple();
                    if(simple !== null)
                    {
                        const parsed = ng.endpoint_args.eurocode.Simple.toObject(simple);
                        if(parsed === null) return null;
                        dst.simple = parsed;
                    }
                    const advanced = src.getAdvanced();
                    if(advanced !== null)
                    {
                        const parsed = ng.endpoint_args.eurocode.Advanced.toObject(advanced);
                        if(parsed === null) return null;
                        dst.advanced = parsed;
                    }
                    if(src.geotechnical !== null)
                    {
                        const parsed = ng.endpoint_args.eurocode.Geotechnical.toObject(src.geotechnical);
                        if(parsed === null) return null;
                        dst.geotechnical = parsed;
                    }
                    return dst;
                }

                static create(src?: LoadCombGenSettings_createType) {
                    const dst = new LoadCombGenSettings();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.lcTypes !== undefined) {
                        dst.lcTypes = src.lcTypes;
                    }
                    if (src.structureguid !== undefined) {
                        dst.structureguid = src.structureguid;
                    }
                    if (src.allLoadcases !== undefined) {
                        dst.allLoadcases = src.allLoadcases;
                    }
                    if (src.loadcases !== undefined) {
                        dst.loadcases = src.loadcases;
                    }
                    // part of the groups oneof 
                    if (src.simple !== undefined && src.simple !== null) {
                        dst.setSimple(src.simple);
                    }
                    // part of the groups oneof 
                    if (src.advanced !== undefined && src.advanced !== null) {
                        dst.setAdvanced(src.advanced);
                    }
                    if (src.removeDuplex !== undefined) {
                        dst.removeDuplex = src.removeDuplex;
                    }
                    if (src.geotechnical !== undefined) {
                        dst.geotechnical = src.geotechnical;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCombGenSettings();
                    dst.lcTypes = this.lcTypes;
                    dst.structureguid = this.structureguid;
                    dst.allLoadcases = this.allLoadcases;
                    dst.loadcases = this.loadcases;
                    dst.groups = this.groups;
                    dst.removeDuplex = this.removeDuplex;
                    dst.geotechnical = this.geotechnical;
                    return dst;
                }

                deepClone() {
                    const json = LoadCombGenSettings.toObject(this);
                    const dst = LoadCombGenSettings.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCombGenSettings = LoadCombGenSettings;


            export type Simple_keys = 'timber' | 'includePermanentLoadFavorable';
            export interface Simple_createType {
                timber?: boolean,
                includePermanentLoadFavorable?: boolean,
            }
            export interface Simple_json {
                timber?: boolean;
                includePermanentLoadFavorable?: boolean;
            }
            interface Simple_json_in {
                __proto_name?: unknown;
                timber?: unknown;
                includePermanentLoadFavorable?: unknown;
            }
            export class Simple {
                __proto_name = "ng.endpoint_args.eurocode.Simple";
                timber: boolean = false;
                includePermanentLoadFavorable: boolean = false;

                static fromObject(src_unknown: unknown): Simple {
                    const dst = new Simple();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Simple but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Simple_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Simple but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.timber !== undefined && src.timber !== null) {
                        if (typeof src.timber === "boolean") {
                            dst.timber = src.timber;
                        }
                        else {
                            console.log('Expected timber of Simple to be a boolean but was ', typeof src.timber, src.timber)
                        }
                    }
                    if (src.includePermanentLoadFavorable !== undefined && src.includePermanentLoadFavorable !== null) {
                        if (typeof src.includePermanentLoadFavorable === "boolean") {
                            dst.includePermanentLoadFavorable = src.includePermanentLoadFavorable;
                        }
                        else {
                            console.log('Expected includePermanentLoadFavorable of Simple to be a boolean but was ', typeof src.includePermanentLoadFavorable, src.includePermanentLoadFavorable)
                        }
                    }
                    return dst;
                }

                static toObject(src: Simple | null | undefined): Simple_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.Simple is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.Simple") {
                        console.error('Expected ng.endpoint_args.eurocode.Simple but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Simple_json = {
                        timber: src.timber,
                        includePermanentLoadFavorable: src.includePermanentLoadFavorable,
                    };
                    return dst;
                }

                static create(src?: Simple_createType) {
                    const dst = new Simple();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.timber !== undefined) {
                        dst.timber = src.timber;
                    }
                    if (src.includePermanentLoadFavorable !== undefined) {
                        dst.includePermanentLoadFavorable = src.includePermanentLoadFavorable;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Simple();
                    dst.timber = this.timber;
                    dst.includePermanentLoadFavorable = this.includePermanentLoadFavorable;
                    return dst;
                }

                deepClone() {
                    const json = Simple.toObject(this);
                    const dst = Simple.fromObject(json);
                    return dst;
                }
            }
            export type ISimple = Simple;


            export type Advanced_keys = 'allLoadgroups' | 'loadgroups';
            export interface Advanced_createType {
                allLoadgroups?: boolean,
                loadgroups?: string[],
            }
            export interface Advanced_json {
                allLoadgroups?: boolean;
                loadgroups: string[];
            }
            interface Advanced_json_in {
                __proto_name?: unknown;
                allLoadgroups?: unknown;
                loadgroups?: unknown;
            }
            export class Advanced {
                __proto_name = "ng.endpoint_args.eurocode.Advanced";
                allLoadgroups: boolean = false;
                loadgroups: string[] = [];

                static fromObject(src_unknown: unknown): Advanced {
                    const dst = new Advanced();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Advanced but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Advanced_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Advanced but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.allLoadgroups !== undefined && src.allLoadgroups !== null) {
                        if (typeof src.allLoadgroups === "boolean") {
                            dst.allLoadgroups = src.allLoadgroups;
                        }
                        else {
                            console.log('Expected allLoadgroups of Advanced to be a boolean but was ', typeof src.allLoadgroups, src.allLoadgroups)
                        }
                    }
                    if (src.loadgroups !== undefined && src.loadgroups !== null) {
                        if (Array.isArray(src.loadgroups)) {
                            for (const [index, element] of src.loadgroups.entries()) {
                                if (typeof element === "string") {
                                    dst.loadgroups.push(element);
                                }
                                else {
                                    console.log('Expected loadgroups of Advanced[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected loadgroups of Advanced to be a array but was ', typeof src.loadgroups, src.loadgroups)
                        }
                    }
                    return dst;
                }

                static toObject(src: Advanced | null | undefined): Advanced_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.Advanced is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.Advanced") {
                        console.error('Expected ng.endpoint_args.eurocode.Advanced but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : Advanced_json = {
                        allLoadgroups: src.allLoadgroups,
                        loadgroups: new Array<string>(),
                    };
                    if (src.loadgroups !== null) {
                        for (const element of src.loadgroups) {
                            dst.loadgroups.push(element);
                        }
                    }
                    return dst;
                }

                static create(src?: Advanced_createType) {
                    const dst = new Advanced();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.allLoadgroups !== undefined) {
                        dst.allLoadgroups = src.allLoadgroups;
                    }
                    if (src.loadgroups !== undefined) {
                        dst.loadgroups = src.loadgroups;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Advanced();
                    dst.allLoadgroups = this.allLoadgroups;
                    dst.loadgroups = this.loadgroups;
                    return dst;
                }

                deepClone() {
                    const json = Advanced.toObject(this);
                    const dst = Advanced.fromObject(json);
                    return dst;
                }
            }
            export type IAdvanced = Advanced;


            export type Geotechnical_keys = 'designApproach';
            export interface Geotechnical_createType {
                designApproach?: ng.design.soil.DesignApproach,
            }
            export interface Geotechnical_json {
                designApproach?: string;
            }
            interface Geotechnical_json_in {
                __proto_name?: unknown;
                designApproach?: unknown;
            }
            export class Geotechnical {
                __proto_name = "ng.endpoint_args.eurocode.Geotechnical";
                designApproach: ng.design.soil.DesignApproach = ng.design.soil.DesignApproach.DESIGN_APPROACH_UNSPECIFIED;

                static fromObject(src_unknown: unknown): Geotechnical {
                    const dst = new Geotechnical();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted Geotechnical but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as Geotechnical_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for Geotechnical but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.designApproach !== undefined && src.designApproach !== null) {
                        dst.designApproach = ng.design.soil.DesignApproach_FromObject(src.designApproach);
                    }
                    return dst;
                }

                static toObject(src: Geotechnical | null | undefined): Geotechnical_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.Geotechnical is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.Geotechnical") {
                        console.error('Expected ng.endpoint_args.eurocode.Geotechnical but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const designApproach_obj = ng.design.soil.DesignApproach_ToObject(src.designApproach);
                    if(designApproach_obj === null) return null;

                    const dst : Geotechnical_json = {
                        designApproach: designApproach_obj,
                    };
                    return dst;
                }

                static create(src?: Geotechnical_createType) {
                    const dst = new Geotechnical();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.designApproach !== undefined) {
                        dst.designApproach = src.designApproach;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new Geotechnical();
                    dst.designApproach = this.designApproach;
                    return dst;
                }

                deepClone() {
                    const json = Geotechnical.toObject(this);
                    const dst = Geotechnical.fromObject(json);
                    return dst;
                }
            }
            export type IGeotechnical = Geotechnical;


            export type UpdateFactorsArgsIn_keys = 'input';
            export interface UpdateFactorsArgsIn_createType {
                input?: ng.input.Data | null,
            }
            export interface UpdateFactorsArgsIn_json {
                input?: ng.input.Data_json;
            }
            interface UpdateFactorsArgsIn_json_in {
                __proto_name?: unknown;
                input?: unknown;
            }
            export class UpdateFactorsArgsIn {
                __proto_name = "ng.endpoint_args.eurocode.UpdateFactorsArgsIn";
                input: ng.input.Data | null = null;

                static fromObject(src_unknown: unknown): UpdateFactorsArgsIn {
                    const dst = new UpdateFactorsArgsIn();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted UpdateFactorsArgsIn but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as UpdateFactorsArgsIn_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for UpdateFactorsArgsIn but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.input !== undefined && src.input !== null) {
                        dst.input = ng.input.Data.fromObject(src.input);
                    }
                    return dst;
                }

                static toObject(src: UpdateFactorsArgsIn | null | undefined): UpdateFactorsArgsIn_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.UpdateFactorsArgsIn is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.UpdateFactorsArgsIn") {
                        console.error('Expected ng.endpoint_args.eurocode.UpdateFactorsArgsIn but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : UpdateFactorsArgsIn_json = {
                    };
                    if(src.input !== null)
                    {
                        const parsed = ng.input.Data.toObject(src.input);
                        if(parsed === null) return null;
                        dst.input = parsed;
                    }
                    return dst;
                }

                static create(src?: UpdateFactorsArgsIn_createType) {
                    const dst = new UpdateFactorsArgsIn();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.input !== undefined) {
                        dst.input = src.input;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new UpdateFactorsArgsIn();
                    dst.input = this.input;
                    return dst;
                }

                deepClone() {
                    const json = UpdateFactorsArgsIn.toObject(this);
                    const dst = UpdateFactorsArgsIn.fromObject(json);
                    return dst;
                }
            }
            export type IUpdateFactorsArgsIn = UpdateFactorsArgsIn;


            export type UpdateFactorsArgsOut_keys = 'updatedInput' | 'log';
            export interface UpdateFactorsArgsOut_createType {
                updatedInput?: ng.input.Data | null,
                log?: ng.log.Log | null,
            }
            export interface UpdateFactorsArgsOut_json {
                updatedInput?: ng.input.Data_json;
                log?: ng.log.Log_json;
            }
            interface UpdateFactorsArgsOut_json_in {
                __proto_name?: unknown;
                updatedInput?: unknown;
                log?: unknown;
            }
            export class UpdateFactorsArgsOut {
                __proto_name = "ng.endpoint_args.eurocode.UpdateFactorsArgsOut";
                updatedInput: ng.input.Data | null = null;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): UpdateFactorsArgsOut {
                    const dst = new UpdateFactorsArgsOut();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted UpdateFactorsArgsOut but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as UpdateFactorsArgsOut_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for UpdateFactorsArgsOut but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.updatedInput !== undefined && src.updatedInput !== null) {
                        dst.updatedInput = ng.input.Data.fromObject(src.updatedInput);
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: UpdateFactorsArgsOut | null | undefined): UpdateFactorsArgsOut_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.UpdateFactorsArgsOut is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.UpdateFactorsArgsOut") {
                        console.error('Expected ng.endpoint_args.eurocode.UpdateFactorsArgsOut but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : UpdateFactorsArgsOut_json = {
                    };
                    if(src.updatedInput !== null)
                    {
                        const parsed = ng.input.Data.toObject(src.updatedInput);
                        if(parsed === null) return null;
                        dst.updatedInput = parsed;
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: UpdateFactorsArgsOut_createType) {
                    const dst = new UpdateFactorsArgsOut();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.updatedInput !== undefined) {
                        dst.updatedInput = src.updatedInput;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new UpdateFactorsArgsOut();
                    dst.updatedInput = this.updatedInput;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = UpdateFactorsArgsOut.toObject(this);
                    const dst = UpdateFactorsArgsOut.fromObject(json);
                    return dst;
                }
            }
            export type IUpdateFactorsArgsOut = UpdateFactorsArgsOut;


            export type LoadCombGenArgsIn_keys = 'projectData' | 'settings';
            export interface LoadCombGenArgsIn_createType {
                projectData?: ng.input.Data | null,
                settings?: ng.endpoint_args.eurocode.LoadCombGenSettings | null,
            }
            export interface LoadCombGenArgsIn_json {
                projectData?: ng.input.Data_json;
                settings?: ng.endpoint_args.eurocode.LoadCombGenSettings_json;
            }
            interface LoadCombGenArgsIn_json_in {
                __proto_name?: unknown;
                projectData?: unknown;
                settings?: unknown;
            }
            export class LoadCombGenArgsIn {
                __proto_name = "ng.endpoint_args.eurocode.LoadCombGenArgsIn";
                projectData: ng.input.Data | null = null;
                settings: ng.endpoint_args.eurocode.LoadCombGenSettings | null = null;

                static fromObject(src_unknown: unknown): LoadCombGenArgsIn {
                    const dst = new LoadCombGenArgsIn();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCombGenArgsIn but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCombGenArgsIn_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCombGenArgsIn but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.projectData !== undefined && src.projectData !== null) {
                        dst.projectData = ng.input.Data.fromObject(src.projectData);
                    }
                    if (src.settings !== undefined && src.settings !== null) {
                        dst.settings = ng.endpoint_args.eurocode.LoadCombGenSettings.fromObject(src.settings);
                    }
                    return dst;
                }

                static toObject(src: LoadCombGenArgsIn | null | undefined): LoadCombGenArgsIn_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.LoadCombGenArgsIn is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.LoadCombGenArgsIn") {
                        console.error('Expected ng.endpoint_args.eurocode.LoadCombGenArgsIn but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCombGenArgsIn_json = {
                    };
                    if(src.projectData !== null)
                    {
                        const parsed = ng.input.Data.toObject(src.projectData);
                        if(parsed === null) return null;
                        dst.projectData = parsed;
                    }
                    if(src.settings !== null)
                    {
                        const parsed = ng.endpoint_args.eurocode.LoadCombGenSettings.toObject(src.settings);
                        if(parsed === null) return null;
                        dst.settings = parsed;
                    }
                    return dst;
                }

                static create(src?: LoadCombGenArgsIn_createType) {
                    const dst = new LoadCombGenArgsIn();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.projectData !== undefined) {
                        dst.projectData = src.projectData;
                    }
                    if (src.settings !== undefined) {
                        dst.settings = src.settings;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCombGenArgsIn();
                    dst.projectData = this.projectData;
                    dst.settings = this.settings;
                    return dst;
                }

                deepClone() {
                    const json = LoadCombGenArgsIn.toObject(this);
                    const dst = LoadCombGenArgsIn.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCombGenArgsIn = LoadCombGenArgsIn;


            export type LoadCombGenArgsOut_keys = 'loadcombinations' | 'log';
            export interface LoadCombGenArgsOut_createType {
                loadcombinations?: ng.loadcombination.Data[],
                log?: ng.log.Log | null,
            }
            export interface LoadCombGenArgsOut_json {
                loadcombinations: ng.loadcombination.Data_json[];
                log?: ng.log.Log_json;
            }
            interface LoadCombGenArgsOut_json_in {
                __proto_name?: unknown;
                loadcombinations?: unknown;
                log?: unknown;
            }
            export class LoadCombGenArgsOut {
                __proto_name = "ng.endpoint_args.eurocode.LoadCombGenArgsOut";
                loadcombinations: ng.loadcombination.Data[] = [];
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): LoadCombGenArgsOut {
                    const dst = new LoadCombGenArgsOut();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted LoadCombGenArgsOut but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as LoadCombGenArgsOut_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for LoadCombGenArgsOut but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.loadcombinations !== undefined && src.loadcombinations !== null) {
                        if (Array.isArray(src.loadcombinations)) {
                            for (const element of src.loadcombinations) {
                                dst.loadcombinations.push(ng.loadcombination.Data.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected loadcombinations of LoadCombGenArgsOut to be a array but was ', typeof src.loadcombinations, src.loadcombinations)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: LoadCombGenArgsOut | null | undefined): LoadCombGenArgsOut_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.LoadCombGenArgsOut is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.LoadCombGenArgsOut") {
                        console.error('Expected ng.endpoint_args.eurocode.LoadCombGenArgsOut but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : LoadCombGenArgsOut_json = {
                        loadcombinations: new Array<ng.loadcombination.Data_json>(),
                    };
                    if (src.loadcombinations !== null) {
                        for (const element of src.loadcombinations) {
                            const parsed = ng.loadcombination.Data.toObject(element);
                            if(parsed === null) return null;
                            dst.loadcombinations.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: LoadCombGenArgsOut_createType) {
                    const dst = new LoadCombGenArgsOut();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.loadcombinations !== undefined) {
                        dst.loadcombinations = src.loadcombinations;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new LoadCombGenArgsOut();
                    dst.loadcombinations = this.loadcombinations;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = LoadCombGenArgsOut.toObject(this);
                    const dst = LoadCombGenArgsOut.fromObject(json);
                    return dst;
                }
            }
            export type ILoadCombGenArgsOut = LoadCombGenArgsOut;


            export type EN1992GammaArgsIn_keys = 'nationalAnnex' | 'element' | 'lightConcrete' | 'consequencesClass' | 'combinationOfActions' | 'generation';
            export interface EN1992GammaArgsIn_createType {
                nationalAnnex?: ng.eurocode.Annex,
                element?: ng.element.Data | null,
                lightConcrete?: boolean,
                consequencesClass?: ng.structure.ConsequenceClass,
                combinationOfActions?: ng.loadcombination.CoaType,
                generation?: ng.eurocode.Generation,
            }
            export interface EN1992GammaArgsIn_json {
                nationalAnnex?: string;
                element?: ng.element.Data_json;
                lightConcrete?: boolean;
                consequencesClass?: string;
                combinationOfActions?: string;
                generation?: string;
            }
            interface EN1992GammaArgsIn_json_in {
                __proto_name?: unknown;
                nationalAnnex?: unknown;
                element?: unknown;
                lightConcrete?: unknown;
                consequencesClass?: unknown;
                combinationOfActions?: unknown;
                generation?: unknown;
            }
            export class EN1992GammaArgsIn {
                __proto_name = "ng.endpoint_args.eurocode.EN1992GammaArgsIn";
                nationalAnnex: ng.eurocode.Annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;
                element: ng.element.Data | null = null;
                lightConcrete: boolean = false;
                consequencesClass: ng.structure.ConsequenceClass = ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED;
                combinationOfActions: ng.loadcombination.CoaType = ng.loadcombination.CoaType.COA_TYPE_UNSPECIFIED;
                generation: ng.eurocode.Generation = ng.eurocode.Generation.GENERATION_UNSPECIFIED;

                static fromObject(src_unknown: unknown): EN1992GammaArgsIn {
                    const dst = new EN1992GammaArgsIn();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EN1992GammaArgsIn but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EN1992GammaArgsIn_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EN1992GammaArgsIn but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.nationalAnnex !== undefined && src.nationalAnnex !== null) {
                        dst.nationalAnnex = ng.eurocode.Annex_FromObject(src.nationalAnnex);
                    }
                    if (src.element !== undefined && src.element !== null) {
                        dst.element = ng.element.Data.fromObject(src.element);
                    }
                    if (src.lightConcrete !== undefined && src.lightConcrete !== null) {
                        if (typeof src.lightConcrete === "boolean") {
                            dst.lightConcrete = src.lightConcrete;
                        }
                        else {
                            console.log('Expected lightConcrete of EN1992GammaArgsIn to be a boolean but was ', typeof src.lightConcrete, src.lightConcrete)
                        }
                    }
                    if (src.consequencesClass !== undefined && src.consequencesClass !== null) {
                        dst.consequencesClass = ng.structure.ConsequenceClass_FromObject(src.consequencesClass);
                    }
                    if (src.combinationOfActions !== undefined && src.combinationOfActions !== null) {
                        dst.combinationOfActions = ng.loadcombination.CoaType_FromObject(src.combinationOfActions);
                    }
                    if (src.generation !== undefined && src.generation !== null) {
                        dst.generation = ng.eurocode.Generation_FromObject(src.generation);
                    }
                    return dst;
                }

                static toObject(src: EN1992GammaArgsIn | null | undefined): EN1992GammaArgsIn_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.EN1992GammaArgsIn is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.EN1992GammaArgsIn") {
                        console.error('Expected ng.endpoint_args.eurocode.EN1992GammaArgsIn but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const nationalAnnex_obj = ng.eurocode.Annex_ToObject(src.nationalAnnex);
                    if(nationalAnnex_obj === null) return null;

                    const consequencesClass_obj = ng.structure.ConsequenceClass_ToObject(src.consequencesClass);
                    if(consequencesClass_obj === null) return null;

                    const combinationOfActions_obj = ng.loadcombination.CoaType_ToObject(src.combinationOfActions);
                    if(combinationOfActions_obj === null) return null;

                    const generation_obj = ng.eurocode.Generation_ToObject(src.generation);
                    if(generation_obj === null) return null;

                    const dst : EN1992GammaArgsIn_json = {
                        nationalAnnex: nationalAnnex_obj,
                        lightConcrete: src.lightConcrete,
                        consequencesClass: consequencesClass_obj,
                        combinationOfActions: combinationOfActions_obj,
                        generation: generation_obj,
                    };
                    if(src.element !== null)
                    {
                        const parsed = ng.element.Data.toObject(src.element);
                        if(parsed === null) return null;
                        dst.element = parsed;
                    }
                    return dst;
                }

                static create(src?: EN1992GammaArgsIn_createType) {
                    const dst = new EN1992GammaArgsIn();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.nationalAnnex !== undefined) {
                        dst.nationalAnnex = src.nationalAnnex;
                    }
                    if (src.element !== undefined) {
                        dst.element = src.element;
                    }
                    if (src.lightConcrete !== undefined) {
                        dst.lightConcrete = src.lightConcrete;
                    }
                    if (src.consequencesClass !== undefined) {
                        dst.consequencesClass = src.consequencesClass;
                    }
                    if (src.combinationOfActions !== undefined) {
                        dst.combinationOfActions = src.combinationOfActions;
                    }
                    if (src.generation !== undefined) {
                        dst.generation = src.generation;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EN1992GammaArgsIn();
                    dst.nationalAnnex = this.nationalAnnex;
                    dst.element = this.element;
                    dst.lightConcrete = this.lightConcrete;
                    dst.consequencesClass = this.consequencesClass;
                    dst.combinationOfActions = this.combinationOfActions;
                    dst.generation = this.generation;
                    return dst;
                }

                deepClone() {
                    const json = EN1992GammaArgsIn.toObject(this);
                    const dst = EN1992GammaArgsIn.fromObject(json);
                    return dst;
                }
            }
            export type IEN1992GammaArgsIn = EN1992GammaArgsIn;


            export type EN1992GammaArgsOut_keys = 'coeff' | 'log';
            export interface EN1992GammaArgsOut_createType {
                coeff?: ng.design.concrete.PartialCoefficient | null,
                log?: ng.log.Log | null,
            }
            export interface EN1992GammaArgsOut_json {
                coeff?: ng.design.concrete.PartialCoefficient_json;
                log?: ng.log.Log_json;
            }
            interface EN1992GammaArgsOut_json_in {
                __proto_name?: unknown;
                coeff?: unknown;
                log?: unknown;
            }
            export class EN1992GammaArgsOut {
                __proto_name = "ng.endpoint_args.eurocode.EN1992GammaArgsOut";
                coeff: ng.design.concrete.PartialCoefficient | null = null;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): EN1992GammaArgsOut {
                    const dst = new EN1992GammaArgsOut();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted EN1992GammaArgsOut but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as EN1992GammaArgsOut_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for EN1992GammaArgsOut but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.coeff !== undefined && src.coeff !== null) {
                        dst.coeff = ng.design.concrete.PartialCoefficient.fromObject(src.coeff);
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: EN1992GammaArgsOut | null | undefined): EN1992GammaArgsOut_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.eurocode.EN1992GammaArgsOut is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.eurocode.EN1992GammaArgsOut") {
                        console.error('Expected ng.endpoint_args.eurocode.EN1992GammaArgsOut but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : EN1992GammaArgsOut_json = {
                    };
                    if(src.coeff !== null)
                    {
                        const parsed = ng.design.concrete.PartialCoefficient.toObject(src.coeff);
                        if(parsed === null) return null;
                        dst.coeff = parsed;
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: EN1992GammaArgsOut_createType) {
                    const dst = new EN1992GammaArgsOut();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.coeff !== undefined) {
                        dst.coeff = src.coeff;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new EN1992GammaArgsOut();
                    dst.coeff = this.coeff;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = EN1992GammaArgsOut.toObject(this);
                    const dst = EN1992GammaArgsOut.fromObject(json);
                    return dst;
                }
            }
            export type IEN1992GammaArgsOut = EN1992GammaArgsOut;
        } // namespace eurocode


        // Defined in EndPointArguments/cpt_api.proto
        export namespace cpt {
            export type ImportGefOutput_keys = 'member' | 'log';
            export interface ImportGefOutput_createType {
                member?: ng.geotechnical.cpt.CptMember | null,
                log?: ng.log.Log | null,
            }
            export interface ImportGefOutput_json {
                member?: ng.geotechnical.cpt.CptMember_json;
                log?: ng.log.Log_json;
            }
            interface ImportGefOutput_json_in {
                __proto_name?: unknown;
                member?: unknown;
                log?: unknown;
            }
            export class ImportGefOutput {
                __proto_name = "ng.endpoint_args.cpt.ImportGefOutput";
                member: ng.geotechnical.cpt.CptMember | null = null;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): ImportGefOutput {
                    const dst = new ImportGefOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ImportGefOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ImportGefOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ImportGefOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.member !== undefined && src.member !== null) {
                        dst.member = ng.geotechnical.cpt.CptMember.fromObject(src.member);
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: ImportGefOutput | null | undefined): ImportGefOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.cpt.ImportGefOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.cpt.ImportGefOutput") {
                        console.error('Expected ng.endpoint_args.cpt.ImportGefOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ImportGefOutput_json = {
                    };
                    if(src.member !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptMember.toObject(src.member);
                        if(parsed === null) return null;
                        dst.member = parsed;
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: ImportGefOutput_createType) {
                    const dst = new ImportGefOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.member !== undefined) {
                        dst.member = src.member;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ImportGefOutput();
                    dst.member = this.member;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = ImportGefOutput.toObject(this);
                    const dst = ImportGefOutput.fromObject(json);
                    return dst;
                }
            }
            export type IImportGefOutput = ImportGefOutput;


            export type GenerateSoilInput_keys = 'member' | 'settings' | 'regionGuid';
            export interface GenerateSoilInput_createType {
                member?: ng.geotechnical.cpt.CptMember | null,
                settings?: ng.geotechnical.cpt.CptSettings | null,
                regionGuid?: string,
            }
            export interface GenerateSoilInput_json {
                member?: ng.geotechnical.cpt.CptMember_json;
                settings?: ng.geotechnical.cpt.CptSettings_json;
                regionGuid?: string;
            }
            interface GenerateSoilInput_json_in {
                __proto_name?: unknown;
                member?: unknown;
                settings?: unknown;
                regionGuid?: unknown;
            }
            export class GenerateSoilInput {
                __proto_name = "ng.endpoint_args.cpt.GenerateSoilInput";
                member: ng.geotechnical.cpt.CptMember | null = null;
                settings: ng.geotechnical.cpt.CptSettings | null = null;
                regionGuid: string = "";

                static fromObject(src_unknown: unknown): GenerateSoilInput {
                    const dst = new GenerateSoilInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GenerateSoilInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GenerateSoilInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GenerateSoilInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.member !== undefined && src.member !== null) {
                        dst.member = ng.geotechnical.cpt.CptMember.fromObject(src.member);
                    }
                    if (src.settings !== undefined && src.settings !== null) {
                        dst.settings = ng.geotechnical.cpt.CptSettings.fromObject(src.settings);
                    }
                    if (src.regionGuid !== undefined && src.regionGuid !== null) {
                        if (typeof src.regionGuid === "string") {
                            dst.regionGuid = src.regionGuid;
                        }
                        else {
                            console.log('Expected regionGuid of GenerateSoilInput to be a string but was ', typeof src.regionGuid, src.regionGuid)
                        }
                    }
                    return dst;
                }

                static toObject(src: GenerateSoilInput | null | undefined): GenerateSoilInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.cpt.GenerateSoilInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.cpt.GenerateSoilInput") {
                        console.error('Expected ng.endpoint_args.cpt.GenerateSoilInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GenerateSoilInput_json = {
                        regionGuid: src.regionGuid,
                    };
                    if(src.member !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptMember.toObject(src.member);
                        if(parsed === null) return null;
                        dst.member = parsed;
                    }
                    if(src.settings !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptSettings.toObject(src.settings);
                        if(parsed === null) return null;
                        dst.settings = parsed;
                    }
                    return dst;
                }

                static create(src?: GenerateSoilInput_createType) {
                    const dst = new GenerateSoilInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.member !== undefined) {
                        dst.member = src.member;
                    }
                    if (src.settings !== undefined) {
                        dst.settings = src.settings;
                    }
                    if (src.regionGuid !== undefined) {
                        dst.regionGuid = src.regionGuid;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GenerateSoilInput();
                    dst.member = this.member;
                    dst.settings = this.settings;
                    dst.regionGuid = this.regionGuid;
                    return dst;
                }

                deepClone() {
                    const json = GenerateSoilInput.toObject(this);
                    const dst = GenerateSoilInput.fromObject(json);
                    return dst;
                }
            }
            export type IGenerateSoilInput = GenerateSoilInput;


            export type GenerateSoilOutput_keys = 'member' | 'soilProfile' | 'log';
            export interface GenerateSoilOutput_createType {
                member?: ng.geotechnical.cpt.CptMember | null,
                soilProfile?: ng.geotechnical.cpt.CptSoilLayer[],
                log?: ng.log.Log | null,
            }
            export interface GenerateSoilOutput_json {
                member?: ng.geotechnical.cpt.CptMember_json;
                soilProfile: ng.geotechnical.cpt.CptSoilLayer_json[];
                log?: ng.log.Log_json;
            }
            interface GenerateSoilOutput_json_in {
                __proto_name?: unknown;
                member?: unknown;
                soilProfile?: unknown;
                log?: unknown;
            }
            export class GenerateSoilOutput {
                __proto_name = "ng.endpoint_args.cpt.GenerateSoilOutput";
                member: ng.geotechnical.cpt.CptMember | null = null;
                soilProfile: ng.geotechnical.cpt.CptSoilLayer[] = [];
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): GenerateSoilOutput {
                    const dst = new GenerateSoilOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted GenerateSoilOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as GenerateSoilOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for GenerateSoilOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.member !== undefined && src.member !== null) {
                        dst.member = ng.geotechnical.cpt.CptMember.fromObject(src.member);
                    }
                    if (src.soilProfile !== undefined && src.soilProfile !== null) {
                        if (Array.isArray(src.soilProfile)) {
                            for (const element of src.soilProfile) {
                                dst.soilProfile.push(ng.geotechnical.cpt.CptSoilLayer.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected soilProfile of GenerateSoilOutput to be a array but was ', typeof src.soilProfile, src.soilProfile)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: GenerateSoilOutput | null | undefined): GenerateSoilOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.cpt.GenerateSoilOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.cpt.GenerateSoilOutput") {
                        console.error('Expected ng.endpoint_args.cpt.GenerateSoilOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : GenerateSoilOutput_json = {
                        soilProfile: new Array<ng.geotechnical.cpt.CptSoilLayer_json>(),
                    };
                    if(src.member !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptMember.toObject(src.member);
                        if(parsed === null) return null;
                        dst.member = parsed;
                    }
                    if (src.soilProfile !== null) {
                        for (const element of src.soilProfile) {
                            const parsed = ng.geotechnical.cpt.CptSoilLayer.toObject(element);
                            if(parsed === null) return null;
                            dst.soilProfile.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: GenerateSoilOutput_createType) {
                    const dst = new GenerateSoilOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.member !== undefined) {
                        dst.member = src.member;
                    }
                    if (src.soilProfile !== undefined) {
                        dst.soilProfile = src.soilProfile;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new GenerateSoilOutput();
                    dst.member = this.member;
                    dst.soilProfile = this.soilProfile;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = GenerateSoilOutput.toObject(this);
                    const dst = GenerateSoilOutput.fromObject(json);
                    return dst;
                }
            }
            export type IGenerateSoilOutput = GenerateSoilOutput;


            export type ModifyDiagramInput_keys = 'member' | 'soilProfile' | 'modification';
            export interface ModifyDiagramInput_createType {
                member?: ng.geotechnical.cpt.CptMember | null,
                soilProfile?: ng.geotechnical.cpt.CptSoilLayer[],
                modification?: ng.geotechnical.cpt.DiagramModificationSettings | null,
            }
            export interface ModifyDiagramInput_json {
                member?: ng.geotechnical.cpt.CptMember_json;
                soilProfile: ng.geotechnical.cpt.CptSoilLayer_json[];
                modification?: ng.geotechnical.cpt.DiagramModificationSettings_json;
            }
            interface ModifyDiagramInput_json_in {
                __proto_name?: unknown;
                member?: unknown;
                soilProfile?: unknown;
                modification?: unknown;
            }
            export class ModifyDiagramInput {
                __proto_name = "ng.endpoint_args.cpt.ModifyDiagramInput";
                member: ng.geotechnical.cpt.CptMember | null = null;
                soilProfile: ng.geotechnical.cpt.CptSoilLayer[] = [];
                modification: ng.geotechnical.cpt.DiagramModificationSettings | null = null;

                static fromObject(src_unknown: unknown): ModifyDiagramInput {
                    const dst = new ModifyDiagramInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ModifyDiagramInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ModifyDiagramInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ModifyDiagramInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.member !== undefined && src.member !== null) {
                        dst.member = ng.geotechnical.cpt.CptMember.fromObject(src.member);
                    }
                    if (src.soilProfile !== undefined && src.soilProfile !== null) {
                        if (Array.isArray(src.soilProfile)) {
                            for (const element of src.soilProfile) {
                                dst.soilProfile.push(ng.geotechnical.cpt.CptSoilLayer.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected soilProfile of ModifyDiagramInput to be a array but was ', typeof src.soilProfile, src.soilProfile)
                        }
                    }
                    if (src.modification !== undefined && src.modification !== null) {
                        dst.modification = ng.geotechnical.cpt.DiagramModificationSettings.fromObject(src.modification);
                    }
                    return dst;
                }

                static toObject(src: ModifyDiagramInput | null | undefined): ModifyDiagramInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.cpt.ModifyDiagramInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.cpt.ModifyDiagramInput") {
                        console.error('Expected ng.endpoint_args.cpt.ModifyDiagramInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ModifyDiagramInput_json = {
                        soilProfile: new Array<ng.geotechnical.cpt.CptSoilLayer_json>(),
                    };
                    if(src.member !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptMember.toObject(src.member);
                        if(parsed === null) return null;
                        dst.member = parsed;
                    }
                    if (src.soilProfile !== null) {
                        for (const element of src.soilProfile) {
                            const parsed = ng.geotechnical.cpt.CptSoilLayer.toObject(element);
                            if(parsed === null) return null;
                            dst.soilProfile.push(parsed);
                        }
                    }
                    if(src.modification !== null)
                    {
                        const parsed = ng.geotechnical.cpt.DiagramModificationSettings.toObject(src.modification);
                        if(parsed === null) return null;
                        dst.modification = parsed;
                    }
                    return dst;
                }

                static create(src?: ModifyDiagramInput_createType) {
                    const dst = new ModifyDiagramInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.member !== undefined) {
                        dst.member = src.member;
                    }
                    if (src.soilProfile !== undefined) {
                        dst.soilProfile = src.soilProfile;
                    }
                    if (src.modification !== undefined) {
                        dst.modification = src.modification;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ModifyDiagramInput();
                    dst.member = this.member;
                    dst.soilProfile = this.soilProfile;
                    dst.modification = this.modification;
                    return dst;
                }

                deepClone() {
                    const json = ModifyDiagramInput.toObject(this);
                    const dst = ModifyDiagramInput.fromObject(json);
                    return dst;
                }
            }
            export type IModifyDiagramInput = ModifyDiagramInput;


            export type ModifyDiagramOutput_keys = 'member' | 'log';
            export interface ModifyDiagramOutput_createType {
                member?: ng.geotechnical.cpt.CptMember | null,
                log?: ng.log.Log | null,
            }
            export interface ModifyDiagramOutput_json {
                member?: ng.geotechnical.cpt.CptMember_json;
                log?: ng.log.Log_json;
            }
            interface ModifyDiagramOutput_json_in {
                __proto_name?: unknown;
                member?: unknown;
                log?: unknown;
            }
            export class ModifyDiagramOutput {
                __proto_name = "ng.endpoint_args.cpt.ModifyDiagramOutput";
                member: ng.geotechnical.cpt.CptMember | null = null;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): ModifyDiagramOutput {
                    const dst = new ModifyDiagramOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted ModifyDiagramOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as ModifyDiagramOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for ModifyDiagramOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.member !== undefined && src.member !== null) {
                        dst.member = ng.geotechnical.cpt.CptMember.fromObject(src.member);
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: ModifyDiagramOutput | null | undefined): ModifyDiagramOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.cpt.ModifyDiagramOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.cpt.ModifyDiagramOutput") {
                        console.error('Expected ng.endpoint_args.cpt.ModifyDiagramOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : ModifyDiagramOutput_json = {
                    };
                    if(src.member !== null)
                    {
                        const parsed = ng.geotechnical.cpt.CptMember.toObject(src.member);
                        if(parsed === null) return null;
                        dst.member = parsed;
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: ModifyDiagramOutput_createType) {
                    const dst = new ModifyDiagramOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.member !== undefined) {
                        dst.member = src.member;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new ModifyDiagramOutput();
                    dst.member = this.member;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = ModifyDiagramOutput.toObject(this);
                    const dst = ModifyDiagramOutput.fromObject(json);
                    return dst;
                }
            }
            export type IModifyDiagramOutput = ModifyDiagramOutput;
        } // namespace cpt


        // Defined in EndPointArguments/analysis.proto
        export namespace analysis {
            export type AnalysisInput_keys = 'project' | 'lcombGuids';
            export interface AnalysisInput_createType {
                project?: ng.project.Data | null,
                lcombGuids?: string[],
            }
            export interface AnalysisInput_json {
                project?: ng.project.Data_json;
                lcombGuids: string[];
            }
            interface AnalysisInput_json_in {
                __proto_name?: unknown;
                project?: unknown;
                lcombGuids?: unknown;
            }
            export class AnalysisInput {
                __proto_name = "ng.endpoint_args.analysis.AnalysisInput";
                project: ng.project.Data | null = null;
                lcombGuids: string[] = [];

                static fromObject(src_unknown: unknown): AnalysisInput {
                    const dst = new AnalysisInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AnalysisInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AnalysisInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AnalysisInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.project !== undefined && src.project !== null) {
                        dst.project = ng.project.Data.fromObject(src.project);
                    }
                    if (src.lcombGuids !== undefined && src.lcombGuids !== null) {
                        if (Array.isArray(src.lcombGuids)) {
                            for (const [index, element] of src.lcombGuids.entries()) {
                                if (typeof element === "string") {
                                    dst.lcombGuids.push(element);
                                }
                                else {
                                    console.log('Expected lcombGuids of AnalysisInput[', index, '] to be a string but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected lcombGuids of AnalysisInput to be a array but was ', typeof src.lcombGuids, src.lcombGuids)
                        }
                    }
                    return dst;
                }

                static toObject(src: AnalysisInput | null | undefined): AnalysisInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.analysis.AnalysisInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.analysis.AnalysisInput") {
                        console.error('Expected ng.endpoint_args.analysis.AnalysisInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AnalysisInput_json = {
                        lcombGuids: new Array<string>(),
                    };
                    if(src.project !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.project);
                        if(parsed === null) return null;
                        dst.project = parsed;
                    }
                    if (src.lcombGuids !== null) {
                        for (const element of src.lcombGuids) {
                            dst.lcombGuids.push(element);
                        }
                    }
                    return dst;
                }

                static create(src?: AnalysisInput_createType) {
                    const dst = new AnalysisInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.lcombGuids !== undefined) {
                        dst.lcombGuids = src.lcombGuids;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AnalysisInput();
                    dst.project = this.project;
                    dst.lcombGuids = this.lcombGuids;
                    return dst;
                }

                deepClone() {
                    const json = AnalysisInput.toObject(this);
                    const dst = AnalysisInput.fromObject(json);
                    return dst;
                }
            }
            export type IAnalysisInput = AnalysisInput;


            export type AnalysisOutput_keys = 'project' | 'log';
            export interface AnalysisOutput_createType {
                project?: ng.project.Data | null,
                log?: ng.log.Log | null,
            }
            export interface AnalysisOutput_json {
                project?: ng.project.Data_json;
                log?: ng.log.Log_json;
            }
            interface AnalysisOutput_json_in {
                __proto_name?: unknown;
                project?: unknown;
                log?: unknown;
            }
            export class AnalysisOutput {
                __proto_name = "ng.endpoint_args.analysis.AnalysisOutput";
                project: ng.project.Data | null = null;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): AnalysisOutput {
                    const dst = new AnalysisOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted AnalysisOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as AnalysisOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for AnalysisOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.project !== undefined && src.project !== null) {
                        dst.project = ng.project.Data.fromObject(src.project);
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: AnalysisOutput | null | undefined): AnalysisOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.analysis.AnalysisOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.analysis.AnalysisOutput") {
                        console.error('Expected ng.endpoint_args.analysis.AnalysisOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : AnalysisOutput_json = {
                    };
                    if(src.project !== null)
                    {
                        const parsed = ng.project.Data.toObject(src.project);
                        if(parsed === null) return null;
                        dst.project = parsed;
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: AnalysisOutput_createType) {
                    const dst = new AnalysisOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.project !== undefined) {
                        dst.project = src.project;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new AnalysisOutput();
                    dst.project = this.project;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = AnalysisOutput.toObject(this);
                    const dst = AnalysisOutput.fromObject(json);
                    return dst;
                }
            }
            export type IAnalysisOutput = AnalysisOutput;


            export type SelfWeightInput_keys = 'sections' | 'segments' | 'rho1' | 'rho2' | 'grav' | 'reinfs';
            export interface SelfWeightInput_createType {
                sections?: ng.sections.Section[],
                segments?: ng.beam.Segment[],
                rho1?: number,
                rho2?: number,
                grav?: number,
                reinfs?: ng.rebar.Data | null,
            }
            export interface SelfWeightInput_json {
                sections: ng.sections.Section_json[];
                segments: ng.beam.Segment_json[];
                rho1?: JsonNumber;
                rho2?: JsonNumber;
                grav?: JsonNumber;
                reinfs?: ng.rebar.Data_json;
            }
            interface SelfWeightInput_json_in {
                __proto_name?: unknown;
                sections?: unknown;
                segments?: unknown;
                rho1?: unknown;
                rho2?: unknown;
                grav?: unknown;
                reinfs?: unknown;
            }
            export class SelfWeightInput {
                __proto_name = "ng.endpoint_args.analysis.SelfWeightInput";
                sections: ng.sections.Section[] = [];
                segments: ng.beam.Segment[] = [];
                rho1: number = 0;
                rho2: number = 0;
                grav: number = 0;
                reinfs: ng.rebar.Data | null = null;

                static fromObject(src_unknown: unknown): SelfWeightInput {
                    const dst = new SelfWeightInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SelfWeightInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SelfWeightInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SelfWeightInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.sections !== undefined && src.sections !== null) {
                        if (Array.isArray(src.sections)) {
                            for (const element of src.sections) {
                                dst.sections.push(ng.sections.Section.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected sections of SelfWeightInput to be a array but was ', typeof src.sections, src.sections)
                        }
                    }
                    if (src.segments !== undefined && src.segments !== null) {
                        if (Array.isArray(src.segments)) {
                            for (const element of src.segments) {
                                dst.segments.push(ng.beam.Segment.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected segments of SelfWeightInput to be a array but was ', typeof src.segments, src.segments)
                        }
                    }
                    if (src.rho1 !== undefined && src.rho1 !== null) {
                        if (typeof src.rho1 === "number" || src.rho1 === 'NaN' || src.rho1 === 'Infinity' || src.rho1 === '-Infinity') {
                            dst.rho1 = AsNum(src.rho1);
                        }
                        else {
                            console.log('Expected rho1 of SelfWeightInput to be a number but was ', typeof src.rho1, src.rho1)
                        }
                    }
                    if (src.rho2 !== undefined && src.rho2 !== null) {
                        if (typeof src.rho2 === "number" || src.rho2 === 'NaN' || src.rho2 === 'Infinity' || src.rho2 === '-Infinity') {
                            dst.rho2 = AsNum(src.rho2);
                        }
                        else {
                            console.log('Expected rho2 of SelfWeightInput to be a number but was ', typeof src.rho2, src.rho2)
                        }
                    }
                    if (src.grav !== undefined && src.grav !== null) {
                        if (typeof src.grav === "number" || src.grav === 'NaN' || src.grav === 'Infinity' || src.grav === '-Infinity') {
                            dst.grav = AsNum(src.grav);
                        }
                        else {
                            console.log('Expected grav of SelfWeightInput to be a number but was ', typeof src.grav, src.grav)
                        }
                    }
                    if (src.reinfs !== undefined && src.reinfs !== null) {
                        dst.reinfs = ng.rebar.Data.fromObject(src.reinfs);
                    }
                    return dst;
                }

                static toObject(src: SelfWeightInput | null | undefined): SelfWeightInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.analysis.SelfWeightInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.analysis.SelfWeightInput") {
                        console.error('Expected ng.endpoint_args.analysis.SelfWeightInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SelfWeightInput_json = {
                        sections: new Array<ng.sections.Section_json>(),
                        segments: new Array<ng.beam.Segment_json>(),
                        rho1: AsJsonNum(src.rho1),
                        rho2: AsJsonNum(src.rho2),
                        grav: AsJsonNum(src.grav),
                    };
                    if (src.sections !== null) {
                        for (const element of src.sections) {
                            const parsed = ng.sections.Section.toObject(element);
                            if(parsed === null) return null;
                            dst.sections.push(parsed);
                        }
                    }
                    if (src.segments !== null) {
                        for (const element of src.segments) {
                            const parsed = ng.beam.Segment.toObject(element);
                            if(parsed === null) return null;
                            dst.segments.push(parsed);
                        }
                    }
                    if(src.reinfs !== null)
                    {
                        const parsed = ng.rebar.Data.toObject(src.reinfs);
                        if(parsed === null) return null;
                        dst.reinfs = parsed;
                    }
                    return dst;
                }

                static create(src?: SelfWeightInput_createType) {
                    const dst = new SelfWeightInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.sections !== undefined) {
                        dst.sections = src.sections;
                    }
                    if (src.segments !== undefined) {
                        dst.segments = src.segments;
                    }
                    if (src.rho1 !== undefined) {
                        dst.rho1 = src.rho1;
                    }
                    if (src.rho2 !== undefined) {
                        dst.rho2 = src.rho2;
                    }
                    if (src.grav !== undefined) {
                        dst.grav = src.grav;
                    }
                    if (src.reinfs !== undefined) {
                        dst.reinfs = src.reinfs;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SelfWeightInput();
                    dst.sections = this.sections;
                    dst.segments = this.segments;
                    dst.rho1 = this.rho1;
                    dst.rho2 = this.rho2;
                    dst.grav = this.grav;
                    dst.reinfs = this.reinfs;
                    return dst;
                }

                deepClone() {
                    const json = SelfWeightInput.toObject(this);
                    const dst = SelfWeightInput.fromObject(json);
                    return dst;
                }
            }
            export type ISelfWeightInput = SelfWeightInput;


            export type SelfWeightOutput_keys = 'loads' | 'pos' | 'weight' | 'log';
            export interface SelfWeightOutput_createType {
                loads?: number[],
                pos?: number[],
                weight?: number,
                log?: ng.log.Log | null,
            }
            export interface SelfWeightOutput_json {
                loads: JsonNumber[];
                pos: JsonNumber[];
                weight?: JsonNumber;
                log?: ng.log.Log_json;
            }
            interface SelfWeightOutput_json_in {
                __proto_name?: unknown;
                loads?: unknown;
                pos?: unknown;
                weight?: unknown;
                log?: unknown;
            }
            export class SelfWeightOutput {
                __proto_name = "ng.endpoint_args.analysis.SelfWeightOutput";
                loads: number[] = [];
                pos: number[] = [];
                weight: number = 0;
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): SelfWeightOutput {
                    const dst = new SelfWeightOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted SelfWeightOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as SelfWeightOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for SelfWeightOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.loads !== undefined && src.loads !== null) {
                        if (Array.isArray(src.loads)) {
                            for (const [index, element] of src.loads.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.loads.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected loads of SelfWeightOutput[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected loads of SelfWeightOutput to be a array but was ', typeof src.loads, src.loads)
                        }
                    }
                    if (src.pos !== undefined && src.pos !== null) {
                        if (Array.isArray(src.pos)) {
                            for (const [index, element] of src.pos.entries()) {
                                if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                    dst.pos.push(AsNum(element));
                                }
                                else {
                                    console.log('Expected pos of SelfWeightOutput[', index, '] to be a number but was ', typeof element, element)
                                }
                            }
                        }
                        else {
                            console.log('Expected pos of SelfWeightOutput to be a array but was ', typeof src.pos, src.pos)
                        }
                    }
                    if (src.weight !== undefined && src.weight !== null) {
                        if (typeof src.weight === "number" || src.weight === 'NaN' || src.weight === 'Infinity' || src.weight === '-Infinity') {
                            dst.weight = AsNum(src.weight);
                        }
                        else {
                            console.log('Expected weight of SelfWeightOutput to be a number but was ', typeof src.weight, src.weight)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: SelfWeightOutput | null | undefined): SelfWeightOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.analysis.SelfWeightOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.analysis.SelfWeightOutput") {
                        console.error('Expected ng.endpoint_args.analysis.SelfWeightOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : SelfWeightOutput_json = {
                        loads: new Array<JsonNumber>(),
                        pos: new Array<JsonNumber>(),
                        weight: AsJsonNum(src.weight),
                    };
                    if (src.loads !== null) {
                        for (const element of src.loads) {
                            dst.loads.push(AsJsonNum(element));
                        }
                    }
                    if (src.pos !== null) {
                        for (const element of src.pos) {
                            dst.pos.push(AsJsonNum(element));
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: SelfWeightOutput_createType) {
                    const dst = new SelfWeightOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.loads !== undefined) {
                        dst.loads = src.loads;
                    }
                    if (src.pos !== undefined) {
                        dst.pos = src.pos;
                    }
                    if (src.weight !== undefined) {
                        dst.weight = src.weight;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new SelfWeightOutput();
                    dst.loads = this.loads;
                    dst.pos = this.pos;
                    dst.weight = this.weight;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = SelfWeightOutput.toObject(this);
                    const dst = SelfWeightOutput.fromObject(json);
                    return dst;
                }
            }
            export type ISelfWeightOutput = SelfWeightOutput;


            export type BucklingInput_keys = 'input' | 'plane';
            export interface BucklingInput_createType {
                input?: ng.input.Data | null,
                plane?: number,
            }
            export interface BucklingInput_json {
                input?: ng.input.Data_json;
                plane?: JsonNumber;
            }
            interface BucklingInput_json_in {
                __proto_name?: unknown;
                input?: unknown;
                plane?: unknown;
            }
            export class BucklingInput {
                __proto_name = "ng.endpoint_args.analysis.BucklingInput";
                input: ng.input.Data | null = null;
                plane: number = 0;

                static fromObject(src_unknown: unknown): BucklingInput {
                    const dst = new BucklingInput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BucklingInput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BucklingInput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BucklingInput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.input !== undefined && src.input !== null) {
                        dst.input = ng.input.Data.fromObject(src.input);
                    }
                    if (src.plane !== undefined && src.plane !== null) {
                        if (typeof src.plane === "number" || src.plane === 'NaN' || src.plane === 'Infinity' || src.plane === '-Infinity') {
                            dst.plane = NumberToInt("ng.endpoint_args.analysis.BucklingInput.plane", AsNum(src.plane));
                        }
                        else {
                            console.log('Expected plane of BucklingInput to be a number but was ', typeof src.plane, src.plane)
                        }
                    }
                    return dst;
                }

                static toObject(src: BucklingInput | null | undefined): BucklingInput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.analysis.BucklingInput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.analysis.BucklingInput") {
                        console.error('Expected ng.endpoint_args.analysis.BucklingInput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BucklingInput_json = {
                        plane: AsJsonNum(NumberToInt("ng.endpoint_args.analysis.BucklingInput.plane", src.plane)),
                    };
                    if(src.input !== null)
                    {
                        const parsed = ng.input.Data.toObject(src.input);
                        if(parsed === null) return null;
                        dst.input = parsed;
                    }
                    return dst;
                }

                static create(src?: BucklingInput_createType) {
                    const dst = new BucklingInput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.input !== undefined) {
                        dst.input = src.input;
                    }
                    if (src.plane !== undefined) {
                        dst.plane = src.plane;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BucklingInput();
                    dst.input = this.input;
                    dst.plane = this.plane;
                    return dst;
                }

                deepClone() {
                    const json = BucklingInput.toObject(this);
                    const dst = BucklingInput.fromObject(json);
                    return dst;
                }
            }
            export type IBucklingInput = BucklingInput;


            export type BucklingOutput_keys = 'bucklingRes' | 'log';
            export interface BucklingOutput_createType {
                bucklingRes?: ng.endpoint_args.analysis.BucklingOutput.BucklingRes[],
                log?: ng.log.Log | null,
            }
            export interface BucklingOutput_json {
                bucklingRes: ng.endpoint_args.analysis.BucklingOutput.BucklingRes_json[];
                log?: ng.log.Log_json;
            }
            interface BucklingOutput_json_in {
                __proto_name?: unknown;
                bucklingRes?: unknown;
                log?: unknown;
            }
            export class BucklingOutput {
                __proto_name = "ng.endpoint_args.analysis.BucklingOutput";
                bucklingRes: ng.endpoint_args.analysis.BucklingOutput.BucklingRes[] = [];
                log: ng.log.Log | null = null;

                static fromObject(src_unknown: unknown): BucklingOutput {
                    const dst = new BucklingOutput();
                    if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                        console.log('Wanted BucklingOutput but it was not a object: ', src_unknown);
                        return dst;
                    }
                    const src = src_unknown as BucklingOutput_json_in;
                    if (src.__proto_name !== undefined) {
                        console.log('Wanted a generic json structure for BucklingOutput but found a ', src.__proto_name);
                        console.trace();
                        return dst;
                    }
                    if (src.bucklingRes !== undefined && src.bucklingRes !== null) {
                        if (Array.isArray(src.bucklingRes)) {
                            for (const element of src.bucklingRes) {
                                dst.bucklingRes.push(ng.endpoint_args.analysis.BucklingOutput.BucklingRes.fromObject(element));
                            }
                        }
                        else {
                            console.log('Expected bucklingRes of BucklingOutput to be a array but was ', typeof src.bucklingRes, src.bucklingRes)
                        }
                    }
                    if (src.log !== undefined && src.log !== null) {
                        dst.log = ng.log.Log.fromObject(src.log);
                    }
                    return dst;
                }

                static toObject(src: BucklingOutput | null | undefined): BucklingOutput_json | null {
                    if (src === null) { return null; }
                    if (src === undefined) { console.warn('ng.endpoint_args.analysis.BucklingOutput is undefined!!!'); return null; }
                    if (src.__proto_name !== "ng.endpoint_args.analysis.BucklingOutput") {
                        console.error('Expected ng.endpoint_args.analysis.BucklingOutput but got ', src.__proto_name);
                        console.trace();
                        return null;
                    }
                    const dst : BucklingOutput_json = {
                        bucklingRes: new Array<ng.endpoint_args.analysis.BucklingOutput.BucklingRes_json>(),
                    };
                    if (src.bucklingRes !== null) {
                        for (const element of src.bucklingRes) {
                            const parsed = ng.endpoint_args.analysis.BucklingOutput.BucklingRes.toObject(element);
                            if(parsed === null) return null;
                            dst.bucklingRes.push(parsed);
                        }
                    }
                    if(src.log !== null)
                    {
                        const parsed = ng.log.Log.toObject(src.log);
                        if(parsed === null) return null;
                        dst.log = parsed;
                    }
                    return dst;
                }

                static create(src?: BucklingOutput_createType) {
                    const dst = new BucklingOutput();
                    if (src === undefined) {
                        return dst;
                    }
                    if (src.bucklingRes !== undefined) {
                        dst.bucklingRes = src.bucklingRes;
                    }
                    if (src.log !== undefined) {
                        dst.log = src.log;
                    }
                    return dst;
                }

                shallowClone() {
                    const dst = new BucklingOutput();
                    dst.bucklingRes = this.bucklingRes;
                    dst.log = this.log;
                    return dst;
                }

                deepClone() {
                    const json = BucklingOutput.toObject(this);
                    const dst = BucklingOutput.fromObject(json);
                    return dst;
                }
            }
            export type IBucklingOutput = BucklingOutput;


            // Defined in EndPointArguments/analysis.proto
            export namespace BucklingOutput {
                export type BucklingRes_keys = 'bucklingLoad' | 'vals' | 'modes' | 'freqs' | 'dofs' | 'elementGuid' | 'spans';
                export interface BucklingRes_createType {
                    bucklingLoad?: number,
                    vals?: number[],
                    modes?: ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode[],
                    freqs?: number[],
                    dofs?: number[],
                    elementGuid?: string,
                    spans?: ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span[],
                }
                export interface BucklingRes_json {
                    bucklingLoad?: JsonNumber;
                    vals: JsonNumber[];
                    modes: ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode_json[];
                    freqs: JsonNumber[];
                    dofs: JsonNumber[];
                    elementGuid?: string;
                    spans: ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span_json[];
                }
                interface BucklingRes_json_in {
                    __proto_name?: unknown;
                    bucklingLoad?: unknown;
                    vals?: unknown;
                    modes?: unknown;
                    freqs?: unknown;
                    dofs?: unknown;
                    elementGuid?: unknown;
                    spans?: unknown;
                }
                export class BucklingRes {
                    __proto_name = "ng.endpoint_args.analysis.BucklingOutput.BucklingRes";
                    bucklingLoad: number = 0;
                    vals: number[] = [];
                    modes: ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode[] = [];
                    freqs: number[] = [];
                    dofs: number[] = [];
                    elementGuid: string = "";
                    spans: ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span[] = [];

                    static fromObject(src_unknown: unknown): BucklingRes {
                        const dst = new BucklingRes();
                        if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                            console.log('Wanted BucklingRes but it was not a object: ', src_unknown);
                            return dst;
                        }
                        const src = src_unknown as BucklingRes_json_in;
                        if (src.__proto_name !== undefined) {
                            console.log('Wanted a generic json structure for BucklingRes but found a ', src.__proto_name);
                            console.trace();
                            return dst;
                        }
                        if (src.bucklingLoad !== undefined && src.bucklingLoad !== null) {
                            if (typeof src.bucklingLoad === "number" || src.bucklingLoad === 'NaN' || src.bucklingLoad === 'Infinity' || src.bucklingLoad === '-Infinity') {
                                dst.bucklingLoad = AsNum(src.bucklingLoad);
                            }
                            else {
                                console.log('Expected bucklingLoad of BucklingRes to be a number but was ', typeof src.bucklingLoad, src.bucklingLoad)
                            }
                        }
                        if (src.vals !== undefined && src.vals !== null) {
                            if (Array.isArray(src.vals)) {
                                for (const [index, element] of src.vals.entries()) {
                                    if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                        dst.vals.push(AsNum(element));
                                    }
                                    else {
                                        console.log('Expected vals of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                                    }
                                }
                            }
                            else {
                                console.log('Expected vals of BucklingRes to be a array but was ', typeof src.vals, src.vals)
                            }
                        }
                        if (src.modes !== undefined && src.modes !== null) {
                            if (Array.isArray(src.modes)) {
                                for (const element of src.modes) {
                                    dst.modes.push(ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode.fromObject(element));
                                }
                            }
                            else {
                                console.log('Expected modes of BucklingRes to be a array but was ', typeof src.modes, src.modes)
                            }
                        }
                        if (src.freqs !== undefined && src.freqs !== null) {
                            if (Array.isArray(src.freqs)) {
                                for (const [index, element] of src.freqs.entries()) {
                                    if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                        dst.freqs.push(AsNum(element));
                                    }
                                    else {
                                        console.log('Expected freqs of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                                    }
                                }
                            }
                            else {
                                console.log('Expected freqs of BucklingRes to be a array but was ', typeof src.freqs, src.freqs)
                            }
                        }
                        if (src.dofs !== undefined && src.dofs !== null) {
                            if (Array.isArray(src.dofs)) {
                                for (const [index, element] of src.dofs.entries()) {
                                    if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                        dst.dofs.push(NumberToInt("ng.endpoint_args.analysis.BucklingOutput.BucklingRes.dofs", AsNum(element)));
                                    }
                                    else {
                                        console.log('Expected dofs of BucklingRes[', index, '] to be a number but was ', typeof element, element)
                                    }
                                }
                            }
                            else {
                                console.log('Expected dofs of BucklingRes to be a array but was ', typeof src.dofs, src.dofs)
                            }
                        }
                        if (src.elementGuid !== undefined && src.elementGuid !== null) {
                            if (typeof src.elementGuid === "string") {
                                dst.elementGuid = src.elementGuid;
                            }
                            else {
                                console.log('Expected elementGuid of BucklingRes to be a string but was ', typeof src.elementGuid, src.elementGuid)
                            }
                        }
                        if (src.spans !== undefined && src.spans !== null) {
                            if (Array.isArray(src.spans)) {
                                for (const element of src.spans) {
                                    dst.spans.push(ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span.fromObject(element));
                                }
                            }
                            else {
                                console.log('Expected spans of BucklingRes to be a array but was ', typeof src.spans, src.spans)
                            }
                        }
                        return dst;
                    }

                    static toObject(src: BucklingRes | null | undefined): BucklingRes_json | null {
                        if (src === null) { return null; }
                        if (src === undefined) { console.warn('ng.endpoint_args.analysis.BucklingOutput.BucklingRes is undefined!!!'); return null; }
                        if (src.__proto_name !== "ng.endpoint_args.analysis.BucklingOutput.BucklingRes") {
                            console.error('Expected ng.endpoint_args.analysis.BucklingOutput.BucklingRes but got ', src.__proto_name);
                            console.trace();
                            return null;
                        }
                        const dst : BucklingRes_json = {
                            bucklingLoad: AsJsonNum(src.bucklingLoad),
                            vals: new Array<JsonNumber>(),
                            modes: new Array<ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode_json>(),
                            freqs: new Array<JsonNumber>(),
                            dofs: new Array<JsonNumber>(),
                            elementGuid: src.elementGuid,
                            spans: new Array<ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span_json>(),
                        };
                        if (src.vals !== null) {
                            for (const element of src.vals) {
                                dst.vals.push(AsJsonNum(element));
                            }
                        }
                        if (src.modes !== null) {
                            for (const element of src.modes) {
                                const parsed = ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode.toObject(element);
                                if(parsed === null) return null;
                                dst.modes.push(parsed);
                            }
                        }
                        if (src.freqs !== null) {
                            for (const element of src.freqs) {
                                dst.freqs.push(AsJsonNum(element));
                            }
                        }
                        if (src.dofs !== null) {
                            for (const element of src.dofs) {
                                dst.dofs.push(AsJsonNum(NumberToInt("ng.endpoint_args.analysis.BucklingOutput.BucklingRes.dofs", element)));
                            }
                        }
                        if (src.spans !== null) {
                            for (const element of src.spans) {
                                const parsed = ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span.toObject(element);
                                if(parsed === null) return null;
                                dst.spans.push(parsed);
                            }
                        }
                        return dst;
                    }

                    static create(src?: BucklingRes_createType) {
                        const dst = new BucklingRes();
                        if (src === undefined) {
                            return dst;
                        }
                        if (src.bucklingLoad !== undefined) {
                            dst.bucklingLoad = src.bucklingLoad;
                        }
                        if (src.vals !== undefined) {
                            dst.vals = src.vals;
                        }
                        if (src.modes !== undefined) {
                            dst.modes = src.modes;
                        }
                        if (src.freqs !== undefined) {
                            dst.freqs = src.freqs;
                        }
                        if (src.dofs !== undefined) {
                            dst.dofs = src.dofs;
                        }
                        if (src.elementGuid !== undefined) {
                            dst.elementGuid = src.elementGuid;
                        }
                        if (src.spans !== undefined) {
                            dst.spans = src.spans;
                        }
                        return dst;
                    }

                    shallowClone() {
                        const dst = new BucklingRes();
                        dst.bucklingLoad = this.bucklingLoad;
                        dst.vals = this.vals;
                        dst.modes = this.modes;
                        dst.freqs = this.freqs;
                        dst.dofs = this.dofs;
                        dst.elementGuid = this.elementGuid;
                        dst.spans = this.spans;
                        return dst;
                    }

                    deepClone() {
                        const json = BucklingRes.toObject(this);
                        const dst = BucklingRes.fromObject(json);
                        return dst;
                    }
                }
                export type IBucklingRes = BucklingRes;


                // Defined in EndPointArguments/analysis.proto
                export namespace BucklingRes {
                    export type mode_keys = 'v' | 'r' | 'x';
                    export interface mode_createType {
                        v?: number[],
                        r?: number[],
                        x?: number[],
                    }
                    export interface mode_json {
                        v: JsonNumber[];
                        r: JsonNumber[];
                        x: JsonNumber[];
                    }
                    interface mode_json_in {
                        __proto_name?: unknown;
                        v?: unknown;
                        r?: unknown;
                        x?: unknown;
                    }
                    export class mode {
                        __proto_name = "ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode";
                        v: number[] = [];
                        r: number[] = [];
                        x: number[] = [];

                        static fromObject(src_unknown: unknown): mode {
                            const dst = new mode();
                            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                                console.log('Wanted mode but it was not a object: ', src_unknown);
                                return dst;
                            }
                            const src = src_unknown as mode_json_in;
                            if (src.__proto_name !== undefined) {
                                console.log('Wanted a generic json structure for mode but found a ', src.__proto_name);
                                console.trace();
                                return dst;
                            }
                            if (src.v !== undefined && src.v !== null) {
                                if (Array.isArray(src.v)) {
                                    for (const [index, element] of src.v.entries()) {
                                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                            dst.v.push(AsNum(element));
                                        }
                                        else {
                                            console.log('Expected v of mode[', index, '] to be a number but was ', typeof element, element)
                                        }
                                    }
                                }
                                else {
                                    console.log('Expected v of mode to be a array but was ', typeof src.v, src.v)
                                }
                            }
                            if (src.r !== undefined && src.r !== null) {
                                if (Array.isArray(src.r)) {
                                    for (const [index, element] of src.r.entries()) {
                                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                            dst.r.push(AsNum(element));
                                        }
                                        else {
                                            console.log('Expected r of mode[', index, '] to be a number but was ', typeof element, element)
                                        }
                                    }
                                }
                                else {
                                    console.log('Expected r of mode to be a array but was ', typeof src.r, src.r)
                                }
                            }
                            if (src.x !== undefined && src.x !== null) {
                                if (Array.isArray(src.x)) {
                                    for (const [index, element] of src.x.entries()) {
                                        if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                            dst.x.push(AsNum(element));
                                        }
                                        else {
                                            console.log('Expected x of mode[', index, '] to be a number but was ', typeof element, element)
                                        }
                                    }
                                }
                                else {
                                    console.log('Expected x of mode to be a array but was ', typeof src.x, src.x)
                                }
                            }
                            return dst;
                        }

                        static toObject(src: mode | null | undefined): mode_json | null {
                            if (src === null) { return null; }
                            if (src === undefined) { console.warn('ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode is undefined!!!'); return null; }
                            if (src.__proto_name !== "ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode") {
                                console.error('Expected ng.endpoint_args.analysis.BucklingOutput.BucklingRes.mode but got ', src.__proto_name);
                                console.trace();
                                return null;
                            }
                            const dst : mode_json = {
                                v: new Array<JsonNumber>(),
                                r: new Array<JsonNumber>(),
                                x: new Array<JsonNumber>(),
                            };
                            if (src.v !== null) {
                                for (const element of src.v) {
                                    dst.v.push(AsJsonNum(element));
                                }
                            }
                            if (src.r !== null) {
                                for (const element of src.r) {
                                    dst.r.push(AsJsonNum(element));
                                }
                            }
                            if (src.x !== null) {
                                for (const element of src.x) {
                                    dst.x.push(AsJsonNum(element));
                                }
                            }
                            return dst;
                        }

                        static create(src?: mode_createType) {
                            const dst = new mode();
                            if (src === undefined) {
                                return dst;
                            }
                            if (src.v !== undefined) {
                                dst.v = src.v;
                            }
                            if (src.r !== undefined) {
                                dst.r = src.r;
                            }
                            if (src.x !== undefined) {
                                dst.x = src.x;
                            }
                            return dst;
                        }

                        shallowClone() {
                            const dst = new mode();
                            dst.v = this.v;
                            dst.r = this.r;
                            dst.x = this.x;
                            return dst;
                        }

                        deepClone() {
                            const json = mode.toObject(this);
                            const dst = mode.fromObject(json);
                            return dst;
                        }
                    }
                    export type Imode = mode;


                    export type span_keys = 'start' | 'end' | 'beta';
                    export interface span_createType {
                        start?: number,
                        end?: number,
                        beta?: number,
                    }
                    export interface span_json {
                        start?: JsonNumber;
                        end?: JsonNumber;
                        beta?: JsonNumber;
                    }
                    interface span_json_in {
                        __proto_name?: unknown;
                        start?: unknown;
                        end?: unknown;
                        beta?: unknown;
                    }
                    export class span {
                        __proto_name = "ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span";
                        start: number = 0;
                        end: number = 0;
                        beta: number = 0;

                        static fromObject(src_unknown: unknown): span {
                            const dst = new span();
                            if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                                console.log('Wanted span but it was not a object: ', src_unknown);
                                return dst;
                            }
                            const src = src_unknown as span_json_in;
                            if (src.__proto_name !== undefined) {
                                console.log('Wanted a generic json structure for span but found a ', src.__proto_name);
                                console.trace();
                                return dst;
                            }
                            if (src.start !== undefined && src.start !== null) {
                                if (typeof src.start === "number" || src.start === 'NaN' || src.start === 'Infinity' || src.start === '-Infinity') {
                                    dst.start = AsNum(src.start);
                                }
                                else {
                                    console.log('Expected start of span to be a number but was ', typeof src.start, src.start)
                                }
                            }
                            if (src.end !== undefined && src.end !== null) {
                                if (typeof src.end === "number" || src.end === 'NaN' || src.end === 'Infinity' || src.end === '-Infinity') {
                                    dst.end = AsNum(src.end);
                                }
                                else {
                                    console.log('Expected end of span to be a number but was ', typeof src.end, src.end)
                                }
                            }
                            if (src.beta !== undefined && src.beta !== null) {
                                if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                                    dst.beta = AsNum(src.beta);
                                }
                                else {
                                    console.log('Expected beta of span to be a number but was ', typeof src.beta, src.beta)
                                }
                            }
                            return dst;
                        }

                        static toObject(src: span | null | undefined): span_json | null {
                            if (src === null) { return null; }
                            if (src === undefined) { console.warn('ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span is undefined!!!'); return null; }
                            if (src.__proto_name !== "ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span") {
                                console.error('Expected ng.endpoint_args.analysis.BucklingOutput.BucklingRes.span but got ', src.__proto_name);
                                console.trace();
                                return null;
                            }
                            const dst : span_json = {
                                start: AsJsonNum(src.start),
                                end: AsJsonNum(src.end),
                                beta: AsJsonNum(src.beta),
                            };
                            return dst;
                        }

                        static create(src?: span_createType) {
                            const dst = new span();
                            if (src === undefined) {
                                return dst;
                            }
                            if (src.start !== undefined) {
                                dst.start = src.start;
                            }
                            if (src.end !== undefined) {
                                dst.end = src.end;
                            }
                            if (src.beta !== undefined) {
                                dst.beta = src.beta;
                            }
                            return dst;
                        }

                        shallowClone() {
                            const dst = new span();
                            dst.start = this.start;
                            dst.end = this.end;
                            dst.beta = this.beta;
                            return dst;
                        }

                        deepClone() {
                            const json = span.toObject(this);
                            const dst = span.fromObject(json);
                            return dst;
                        }
                    }
                    export type Ispan = span;
                } // namespace BucklingRes
            } // namespace BucklingOutput
        } // namespace analysis
    } // namespace endpoint_args


    // Defined in Design/env_param.proto
    export namespace environmental_parameters {
        export enum DeclaredUnit {
            DECLARED_UNIT_UNSPECIFIED = 0,
            DECLARED_UNIT_KG = 1,
            DECLARED_UNIT_M3 = 2,
            DECLARED_UNIT_M2 = 3,
            DECLARED_UNIT_M = 4
        }
        export const DeclaredUnit_FromObject = (src: unknown): DeclaredUnit => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DECLARED_UNIT_UNSPECIFIED':
                    return DeclaredUnit.DECLARED_UNIT_UNSPECIFIED;
                case 1:
                case 'DECLARED_UNIT_KG':
                    return DeclaredUnit.DECLARED_UNIT_KG;
                case 2:
                case 'DECLARED_UNIT_M3':
                    return DeclaredUnit.DECLARED_UNIT_M3;
                case 3:
                case 'DECLARED_UNIT_M2':
                    return DeclaredUnit.DECLARED_UNIT_M2;
                case 4:
                case 'DECLARED_UNIT_M':
                    return DeclaredUnit.DECLARED_UNIT_M;
                default:
                    console.log('Unhandled value for DeclaredUnit:' + src + '. ' + typeof(src));
                    return DeclaredUnit.DECLARED_UNIT_UNSPECIFIED;
            }
        };
        export const DeclaredUnit_ToObject = (src: DeclaredUnit): string | null => {
            switch (src) {
                case DeclaredUnit.DECLARED_UNIT_UNSPECIFIED:
                    return 'DECLARED_UNIT_UNSPECIFIED';
                case DeclaredUnit.DECLARED_UNIT_KG:
                    return 'DECLARED_UNIT_KG';
                case DeclaredUnit.DECLARED_UNIT_M3:
                    return 'DECLARED_UNIT_M3';
                case DeclaredUnit.DECLARED_UNIT_M2:
                    return 'DECLARED_UNIT_M2';
                case DeclaredUnit.DECLARED_UNIT_M:
                    return 'DECLARED_UNIT_M';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for DeclaredUnit, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type CarbonItem_keys = 'type' | 'materialId' | 'quantity' | 'unit' | 'factor' | 'gwp' | 'gwpBiogenic';
        export interface CarbonItem_createType {
            type?: ng.material.Mtrl,
            materialId?: ng.utils.ID | null,
            quantity?: number,
            unit?: ng.environmental_parameters.DeclaredUnit,
            factor?: number,
            gwp?: number,
            gwpBiogenic?: number,
        }
        export interface CarbonItem_json {
            type?: string;
            materialId?: ng.utils.ID_json;
            quantity?: JsonNumber;
            unit?: string;
            factor?: JsonNumber;
            gwp?: JsonNumber;
            gwpBiogenic?: JsonNumber;
        }
        interface CarbonItem_json_in {
            __proto_name?: unknown;
            type?: unknown;
            materialId?: unknown;
            quantity?: unknown;
            unit?: unknown;
            factor?: unknown;
            gwp?: unknown;
            gwpBiogenic?: unknown;
        }
        export class CarbonItem {
            __proto_name = "ng.environmental_parameters.CarbonItem";
            type: ng.material.Mtrl = ng.material.Mtrl.MTRL_UNSPECIFIED;
            materialId: ng.utils.ID | null = null;
            quantity: number = 0;
            unit: ng.environmental_parameters.DeclaredUnit = ng.environmental_parameters.DeclaredUnit.DECLARED_UNIT_UNSPECIFIED;
            factor: number = 0;
            gwp: number = 0;
            gwpBiogenic: number = 0;

            static fromObject(src_unknown: unknown): CarbonItem {
                const dst = new CarbonItem();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted CarbonItem but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as CarbonItem_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for CarbonItem but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.material.Mtrl_FromObject(src.type);
                }
                if (src.materialId !== undefined && src.materialId !== null) {
                    dst.materialId = ng.utils.ID.fromObject(src.materialId);
                }
                if (src.quantity !== undefined && src.quantity !== null) {
                    if (typeof src.quantity === "number" || src.quantity === 'NaN' || src.quantity === 'Infinity' || src.quantity === '-Infinity') {
                        dst.quantity = AsNum(src.quantity);
                    }
                    else {
                        console.log('Expected quantity of CarbonItem to be a number but was ', typeof src.quantity, src.quantity)
                    }
                }
                if (src.unit !== undefined && src.unit !== null) {
                    dst.unit = ng.environmental_parameters.DeclaredUnit_FromObject(src.unit);
                }
                if (src.factor !== undefined && src.factor !== null) {
                    if (typeof src.factor === "number" || src.factor === 'NaN' || src.factor === 'Infinity' || src.factor === '-Infinity') {
                        dst.factor = AsNum(src.factor);
                    }
                    else {
                        console.log('Expected factor of CarbonItem to be a number but was ', typeof src.factor, src.factor)
                    }
                }
                if (src.gwp !== undefined && src.gwp !== null) {
                    if (typeof src.gwp === "number" || src.gwp === 'NaN' || src.gwp === 'Infinity' || src.gwp === '-Infinity') {
                        dst.gwp = AsNum(src.gwp);
                    }
                    else {
                        console.log('Expected gwp of CarbonItem to be a number but was ', typeof src.gwp, src.gwp)
                    }
                }
                if (src.gwpBiogenic !== undefined && src.gwpBiogenic !== null) {
                    if (typeof src.gwpBiogenic === "number" || src.gwpBiogenic === 'NaN' || src.gwpBiogenic === 'Infinity' || src.gwpBiogenic === '-Infinity') {
                        dst.gwpBiogenic = AsNum(src.gwpBiogenic);
                    }
                    else {
                        console.log('Expected gwpBiogenic of CarbonItem to be a number but was ', typeof src.gwpBiogenic, src.gwpBiogenic)
                    }
                }
                return dst;
            }

            static toObject(src: CarbonItem | null | undefined): CarbonItem_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.environmental_parameters.CarbonItem is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.environmental_parameters.CarbonItem") {
                    console.error('Expected ng.environmental_parameters.CarbonItem but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const type_obj = ng.material.Mtrl_ToObject(src.type);
                if(type_obj === null) return null;

                const unit_obj = ng.environmental_parameters.DeclaredUnit_ToObject(src.unit);
                if(unit_obj === null) return null;

                const dst : CarbonItem_json = {
                    type: type_obj,
                    quantity: AsJsonNum(src.quantity),
                    unit: unit_obj,
                    factor: AsJsonNum(src.factor),
                    gwp: AsJsonNum(src.gwp),
                    gwpBiogenic: AsJsonNum(src.gwpBiogenic),
                };
                if(src.materialId !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.materialId);
                    if(parsed === null) return null;
                    dst.materialId = parsed;
                }
                return dst;
            }

            static create(src?: CarbonItem_createType) {
                const dst = new CarbonItem();
                if (src === undefined) {
                    return dst;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.materialId !== undefined) {
                    dst.materialId = src.materialId;
                }
                if (src.quantity !== undefined) {
                    dst.quantity = src.quantity;
                }
                if (src.unit !== undefined) {
                    dst.unit = src.unit;
                }
                if (src.factor !== undefined) {
                    dst.factor = src.factor;
                }
                if (src.gwp !== undefined) {
                    dst.gwp = src.gwp;
                }
                if (src.gwpBiogenic !== undefined) {
                    dst.gwpBiogenic = src.gwpBiogenic;
                }
                return dst;
            }

            shallowClone() {
                const dst = new CarbonItem();
                dst.type = this.type;
                dst.materialId = this.materialId;
                dst.quantity = this.quantity;
                dst.unit = this.unit;
                dst.factor = this.factor;
                dst.gwp = this.gwp;
                dst.gwpBiogenic = this.gwpBiogenic;
                return dst;
            }

            deepClone() {
                const json = CarbonItem.toObject(this);
                const dst = CarbonItem.fromObject(json);
                return dst;
            }
        }
        export type ICarbonItem = CarbonItem;


        export type CarbonFootprint_keys = 'gwp' | 'gwpBiogenic' | 'items' | 'source' | 'hasMissingData';
        export interface CarbonFootprint_createType {
            gwp?: number,
            gwpBiogenic?: number,
            items?: ng.environmental_parameters.CarbonItem[],
            source?: string,
            hasMissingData?: boolean,
        }
        export interface CarbonFootprint_json {
            gwp?: JsonNumber;
            gwpBiogenic?: JsonNumber;
            items: ng.environmental_parameters.CarbonItem_json[];
            source?: string;
            hasMissingData?: boolean;
        }
        interface CarbonFootprint_json_in {
            __proto_name?: unknown;
            gwp?: unknown;
            gwpBiogenic?: unknown;
            items?: unknown;
            source?: unknown;
            hasMissingData?: unknown;
        }
        export class CarbonFootprint {
            __proto_name = "ng.environmental_parameters.CarbonFootprint";
            gwp: number = 0;
            gwpBiogenic: number = 0;
            items: ng.environmental_parameters.CarbonItem[] = [];
            source: string = "";
            hasMissingData: boolean = false;

            static fromObject(src_unknown: unknown): CarbonFootprint {
                const dst = new CarbonFootprint();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted CarbonFootprint but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as CarbonFootprint_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for CarbonFootprint but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.gwp !== undefined && src.gwp !== null) {
                    if (typeof src.gwp === "number" || src.gwp === 'NaN' || src.gwp === 'Infinity' || src.gwp === '-Infinity') {
                        dst.gwp = AsNum(src.gwp);
                    }
                    else {
                        console.log('Expected gwp of CarbonFootprint to be a number but was ', typeof src.gwp, src.gwp)
                    }
                }
                if (src.gwpBiogenic !== undefined && src.gwpBiogenic !== null) {
                    if (typeof src.gwpBiogenic === "number" || src.gwpBiogenic === 'NaN' || src.gwpBiogenic === 'Infinity' || src.gwpBiogenic === '-Infinity') {
                        dst.gwpBiogenic = AsNum(src.gwpBiogenic);
                    }
                    else {
                        console.log('Expected gwpBiogenic of CarbonFootprint to be a number but was ', typeof src.gwpBiogenic, src.gwpBiogenic)
                    }
                }
                if (src.items !== undefined && src.items !== null) {
                    if (Array.isArray(src.items)) {
                        for (const element of src.items) {
                            dst.items.push(ng.environmental_parameters.CarbonItem.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected items of CarbonFootprint to be a array but was ', typeof src.items, src.items)
                    }
                }
                if (src.source !== undefined && src.source !== null) {
                    if (typeof src.source === "string") {
                        dst.source = src.source;
                    }
                    else {
                        console.log('Expected source of CarbonFootprint to be a string but was ', typeof src.source, src.source)
                    }
                }
                if (src.hasMissingData !== undefined && src.hasMissingData !== null) {
                    if (typeof src.hasMissingData === "boolean") {
                        dst.hasMissingData = src.hasMissingData;
                    }
                    else {
                        console.log('Expected hasMissingData of CarbonFootprint to be a boolean but was ', typeof src.hasMissingData, src.hasMissingData)
                    }
                }
                return dst;
            }

            static toObject(src: CarbonFootprint | null | undefined): CarbonFootprint_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.environmental_parameters.CarbonFootprint is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.environmental_parameters.CarbonFootprint") {
                    console.error('Expected ng.environmental_parameters.CarbonFootprint but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : CarbonFootprint_json = {
                    gwp: AsJsonNum(src.gwp),
                    gwpBiogenic: AsJsonNum(src.gwpBiogenic),
                    items: new Array<ng.environmental_parameters.CarbonItem_json>(),
                    source: src.source,
                    hasMissingData: src.hasMissingData,
                };
                if (src.items !== null) {
                    for (const element of src.items) {
                        const parsed = ng.environmental_parameters.CarbonItem.toObject(element);
                        if(parsed === null) return null;
                        dst.items.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: CarbonFootprint_createType) {
                const dst = new CarbonFootprint();
                if (src === undefined) {
                    return dst;
                }
                if (src.gwp !== undefined) {
                    dst.gwp = src.gwp;
                }
                if (src.gwpBiogenic !== undefined) {
                    dst.gwpBiogenic = src.gwpBiogenic;
                }
                if (src.items !== undefined) {
                    dst.items = src.items;
                }
                if (src.source !== undefined) {
                    dst.source = src.source;
                }
                if (src.hasMissingData !== undefined) {
                    dst.hasMissingData = src.hasMissingData;
                }
                return dst;
            }

            shallowClone() {
                const dst = new CarbonFootprint();
                dst.gwp = this.gwp;
                dst.gwpBiogenic = this.gwpBiogenic;
                dst.items = this.items;
                dst.source = this.source;
                dst.hasMissingData = this.hasMissingData;
                return dst;
            }

            deepClone() {
                const json = CarbonFootprint.toObject(this);
                const dst = CarbonFootprint.fromObject(json);
                return dst;
            }
        }
        export type ICarbonFootprint = CarbonFootprint;


        export type ElementCarbonFootprint_keys = 'elemGuid' | 'carbon';
        export interface ElementCarbonFootprint_createType {
            elemGuid?: string,
            carbon?: ng.environmental_parameters.CarbonFootprint | null,
        }
        export interface ElementCarbonFootprint_json {
            elemGuid?: string;
            carbon?: ng.environmental_parameters.CarbonFootprint_json;
        }
        interface ElementCarbonFootprint_json_in {
            __proto_name?: unknown;
            elemGuid?: unknown;
            carbon?: unknown;
        }
        export class ElementCarbonFootprint {
            __proto_name = "ng.environmental_parameters.ElementCarbonFootprint";
            elemGuid: string = "";
            carbon: ng.environmental_parameters.CarbonFootprint | null = null;

            static fromObject(src_unknown: unknown): ElementCarbonFootprint {
                const dst = new ElementCarbonFootprint();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ElementCarbonFootprint but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ElementCarbonFootprint_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ElementCarbonFootprint but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.elemGuid !== undefined && src.elemGuid !== null) {
                    if (typeof src.elemGuid === "string") {
                        dst.elemGuid = src.elemGuid;
                    }
                    else {
                        console.log('Expected elemGuid of ElementCarbonFootprint to be a string but was ', typeof src.elemGuid, src.elemGuid)
                    }
                }
                if (src.carbon !== undefined && src.carbon !== null) {
                    dst.carbon = ng.environmental_parameters.CarbonFootprint.fromObject(src.carbon);
                }
                return dst;
            }

            static toObject(src: ElementCarbonFootprint | null | undefined): ElementCarbonFootprint_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.environmental_parameters.ElementCarbonFootprint is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.environmental_parameters.ElementCarbonFootprint") {
                    console.error('Expected ng.environmental_parameters.ElementCarbonFootprint but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ElementCarbonFootprint_json = {
                    elemGuid: src.elemGuid,
                };
                if(src.carbon !== null)
                {
                    const parsed = ng.environmental_parameters.CarbonFootprint.toObject(src.carbon);
                    if(parsed === null) return null;
                    dst.carbon = parsed;
                }
                return dst;
            }

            static create(src?: ElementCarbonFootprint_createType) {
                const dst = new ElementCarbonFootprint();
                if (src === undefined) {
                    return dst;
                }
                if (src.elemGuid !== undefined) {
                    dst.elemGuid = src.elemGuid;
                }
                if (src.carbon !== undefined) {
                    dst.carbon = src.carbon;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ElementCarbonFootprint();
                dst.elemGuid = this.elemGuid;
                dst.carbon = this.carbon;
                return dst;
            }

            deepClone() {
                const json = ElementCarbonFootprint.toObject(this);
                const dst = ElementCarbonFootprint.fromObject(json);
                return dst;
            }
        }
        export type IElementCarbonFootprint = ElementCarbonFootprint;
    } // namespace environmental_parameters


    // Defined in stage.proto
    export namespace stage {
        export enum ExposureClass {
            EXPOSURE_CLASS_UNSPECIFIED = 0,
            EXPOSURE_CLASS_X0 = 1,
            EXPOSURE_CLASS_XC1 = 2,
            EXPOSURE_CLASS_XC2 = 3,
            EXPOSURE_CLASS_XC3 = 4,
            EXPOSURE_CLASS_XC4 = 5,
            EXPOSURE_CLASS_XD1 = 6,
            EXPOSURE_CLASS_XD2 = 7,
            EXPOSURE_CLASS_XD3 = 8,
            EXPOSURE_CLASS_XS1 = 9,
            EXPOSURE_CLASS_XS2 = 10,
            EXPOSURE_CLASS_XS3 = 11,
            EXPOSURE_CLASS_XA1 = 12,
            EXPOSURE_CLASS_XA2 = 13,
            EXPOSURE_CLASS_XA3 = 14,
            EXPOSURE_CLASS_XF1 = 15,
            EXPOSURE_CLASS_XF2 = 16,
            EXPOSURE_CLASS_XF3 = 17,
            EXPOSURE_CLASS_XF4 = 18
        }
        export const ExposureClass_FromObject = (src: unknown): ExposureClass => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'EXPOSURE_CLASS_UNSPECIFIED':
                    return ExposureClass.EXPOSURE_CLASS_UNSPECIFIED;
                case 1:
                case 'EXPOSURE_CLASS_X0':
                    return ExposureClass.EXPOSURE_CLASS_X0;
                case 2:
                case 'EXPOSURE_CLASS_XC1':
                    return ExposureClass.EXPOSURE_CLASS_XC1;
                case 3:
                case 'EXPOSURE_CLASS_XC2':
                    return ExposureClass.EXPOSURE_CLASS_XC2;
                case 4:
                case 'EXPOSURE_CLASS_XC3':
                    return ExposureClass.EXPOSURE_CLASS_XC3;
                case 5:
                case 'EXPOSURE_CLASS_XC4':
                    return ExposureClass.EXPOSURE_CLASS_XC4;
                case 6:
                case 'EXPOSURE_CLASS_XD1':
                    return ExposureClass.EXPOSURE_CLASS_XD1;
                case 7:
                case 'EXPOSURE_CLASS_XD2':
                    return ExposureClass.EXPOSURE_CLASS_XD2;
                case 8:
                case 'EXPOSURE_CLASS_XD3':
                    return ExposureClass.EXPOSURE_CLASS_XD3;
                case 9:
                case 'EXPOSURE_CLASS_XS1':
                    return ExposureClass.EXPOSURE_CLASS_XS1;
                case 10:
                case 'EXPOSURE_CLASS_XS2':
                    return ExposureClass.EXPOSURE_CLASS_XS2;
                case 11:
                case 'EXPOSURE_CLASS_XS3':
                    return ExposureClass.EXPOSURE_CLASS_XS3;
                case 12:
                case 'EXPOSURE_CLASS_XA1':
                    return ExposureClass.EXPOSURE_CLASS_XA1;
                case 13:
                case 'EXPOSURE_CLASS_XA2':
                    return ExposureClass.EXPOSURE_CLASS_XA2;
                case 14:
                case 'EXPOSURE_CLASS_XA3':
                    return ExposureClass.EXPOSURE_CLASS_XA3;
                case 15:
                case 'EXPOSURE_CLASS_XF1':
                    return ExposureClass.EXPOSURE_CLASS_XF1;
                case 16:
                case 'EXPOSURE_CLASS_XF2':
                    return ExposureClass.EXPOSURE_CLASS_XF2;
                case 17:
                case 'EXPOSURE_CLASS_XF3':
                    return ExposureClass.EXPOSURE_CLASS_XF3;
                case 18:
                case 'EXPOSURE_CLASS_XF4':
                    return ExposureClass.EXPOSURE_CLASS_XF4;
                default:
                    console.log('Unhandled value for ExposureClass:' + src + '. ' + typeof(src));
                    return ExposureClass.EXPOSURE_CLASS_UNSPECIFIED;
            }
        };
        export const ExposureClass_ToObject = (src: ExposureClass): string | null => {
            switch (src) {
                case ExposureClass.EXPOSURE_CLASS_UNSPECIFIED:
                    return 'EXPOSURE_CLASS_UNSPECIFIED';
                case ExposureClass.EXPOSURE_CLASS_X0:
                    return 'EXPOSURE_CLASS_X0';
                case ExposureClass.EXPOSURE_CLASS_XC1:
                    return 'EXPOSURE_CLASS_XC1';
                case ExposureClass.EXPOSURE_CLASS_XC2:
                    return 'EXPOSURE_CLASS_XC2';
                case ExposureClass.EXPOSURE_CLASS_XC3:
                    return 'EXPOSURE_CLASS_XC3';
                case ExposureClass.EXPOSURE_CLASS_XC4:
                    return 'EXPOSURE_CLASS_XC4';
                case ExposureClass.EXPOSURE_CLASS_XD1:
                    return 'EXPOSURE_CLASS_XD1';
                case ExposureClass.EXPOSURE_CLASS_XD2:
                    return 'EXPOSURE_CLASS_XD2';
                case ExposureClass.EXPOSURE_CLASS_XD3:
                    return 'EXPOSURE_CLASS_XD3';
                case ExposureClass.EXPOSURE_CLASS_XS1:
                    return 'EXPOSURE_CLASS_XS1';
                case ExposureClass.EXPOSURE_CLASS_XS2:
                    return 'EXPOSURE_CLASS_XS2';
                case ExposureClass.EXPOSURE_CLASS_XS3:
                    return 'EXPOSURE_CLASS_XS3';
                case ExposureClass.EXPOSURE_CLASS_XA1:
                    return 'EXPOSURE_CLASS_XA1';
                case ExposureClass.EXPOSURE_CLASS_XA2:
                    return 'EXPOSURE_CLASS_XA2';
                case ExposureClass.EXPOSURE_CLASS_XA3:
                    return 'EXPOSURE_CLASS_XA3';
                case ExposureClass.EXPOSURE_CLASS_XF1:
                    return 'EXPOSURE_CLASS_XF1';
                case ExposureClass.EXPOSURE_CLASS_XF2:
                    return 'EXPOSURE_CLASS_XF2';
                case ExposureClass.EXPOSURE_CLASS_XF3:
                    return 'EXPOSURE_CLASS_XF3';
                case ExposureClass.EXPOSURE_CLASS_XF4:
                    return 'EXPOSURE_CLASS_XF4';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for ExposureClass, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum EnvironmentalClass {
            ENVIROMENTAL_CLASS_UNSPECIFIED = 0,
            ENVIROMENTAL_CLASS_PASSIVE = 1,
            ENVIROMENTAL_CLASS_MODERATE = 2,
            ENVIROMENTAL_CLASS_AGGRESSIVE = 3,
            ENVIROMENTAL_CLASS_EXTRA_AGGRESSIVE = 4
        }
        export const EnvironmentalClass_FromObject = (src: unknown): EnvironmentalClass => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'ENVIROMENTAL_CLASS_UNSPECIFIED':
                    return EnvironmentalClass.ENVIROMENTAL_CLASS_UNSPECIFIED;
                case 1:
                case 'ENVIROMENTAL_CLASS_PASSIVE':
                    return EnvironmentalClass.ENVIROMENTAL_CLASS_PASSIVE;
                case 2:
                case 'ENVIROMENTAL_CLASS_MODERATE':
                    return EnvironmentalClass.ENVIROMENTAL_CLASS_MODERATE;
                case 3:
                case 'ENVIROMENTAL_CLASS_AGGRESSIVE':
                    return EnvironmentalClass.ENVIROMENTAL_CLASS_AGGRESSIVE;
                case 4:
                case 'ENVIROMENTAL_CLASS_EXTRA_AGGRESSIVE':
                    return EnvironmentalClass.ENVIROMENTAL_CLASS_EXTRA_AGGRESSIVE;
                default:
                    console.log('Unhandled value for EnvironmentalClass:' + src + '. ' + typeof(src));
                    return EnvironmentalClass.ENVIROMENTAL_CLASS_UNSPECIFIED;
            }
        };
        export const EnvironmentalClass_ToObject = (src: EnvironmentalClass): string | null => {
            switch (src) {
                case EnvironmentalClass.ENVIROMENTAL_CLASS_UNSPECIFIED:
                    return 'ENVIROMENTAL_CLASS_UNSPECIFIED';
                case EnvironmentalClass.ENVIROMENTAL_CLASS_PASSIVE:
                    return 'ENVIROMENTAL_CLASS_PASSIVE';
                case EnvironmentalClass.ENVIROMENTAL_CLASS_MODERATE:
                    return 'ENVIROMENTAL_CLASS_MODERATE';
                case EnvironmentalClass.ENVIROMENTAL_CLASS_AGGRESSIVE:
                    return 'ENVIROMENTAL_CLASS_AGGRESSIVE';
                case EnvironmentalClass.ENVIROMENTAL_CLASS_EXTRA_AGGRESSIVE:
                    return 'ENVIROMENTAL_CLASS_EXTRA_AGGRESSIVE';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for EnvironmentalClass, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum LifeCategory {
            LIFE_CATEGORY_UNSPECIFIED = 0,
            LIFE_CATEGORY_L20 = 1,
            LIFE_CATEGORY_L50 = 2,
            LIFE_CATEGORY_L100 = 3
        }
        export const LifeCategory_FromObject = (src: unknown): LifeCategory => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'LIFE_CATEGORY_UNSPECIFIED':
                    return LifeCategory.LIFE_CATEGORY_UNSPECIFIED;
                case 1:
                case 'LIFE_CATEGORY_L20':
                    return LifeCategory.LIFE_CATEGORY_L20;
                case 2:
                case 'LIFE_CATEGORY_L50':
                    return LifeCategory.LIFE_CATEGORY_L50;
                case 3:
                case 'LIFE_CATEGORY_L100':
                    return LifeCategory.LIFE_CATEGORY_L100;
                default:
                    console.log('Unhandled value for LifeCategory:' + src + '. ' + typeof(src));
                    return LifeCategory.LIFE_CATEGORY_UNSPECIFIED;
            }
        };
        export const LifeCategory_ToObject = (src: LifeCategory): string | null => {
            switch (src) {
                case LifeCategory.LIFE_CATEGORY_UNSPECIFIED:
                    return 'LIFE_CATEGORY_UNSPECIFIED';
                case LifeCategory.LIFE_CATEGORY_L20:
                    return 'LIFE_CATEGORY_L20';
                case LifeCategory.LIFE_CATEGORY_L50:
                    return 'LIFE_CATEGORY_L50';
                case LifeCategory.LIFE_CATEGORY_L100:
                    return 'LIFE_CATEGORY_L100';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for LifeCategory, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export enum SupportLevel {
            SUPPORT_LEVEL_UNSPECIFIED = 0,
            SUPPORT_LEVEL_BOTTOM = 1,
            SUPPORT_LEVEL_TOP = 2,
            SUPPORT_LEVEL_CENTER = 3
        }
        export const SupportLevel_FromObject = (src: unknown): SupportLevel => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'SUPPORT_LEVEL_UNSPECIFIED':
                    return SupportLevel.SUPPORT_LEVEL_UNSPECIFIED;
                case 1:
                case 'SUPPORT_LEVEL_BOTTOM':
                    return SupportLevel.SUPPORT_LEVEL_BOTTOM;
                case 2:
                case 'SUPPORT_LEVEL_TOP':
                    return SupportLevel.SUPPORT_LEVEL_TOP;
                case 3:
                case 'SUPPORT_LEVEL_CENTER':
                    return SupportLevel.SUPPORT_LEVEL_CENTER;
                default:
                    console.log('Unhandled value for SupportLevel:' + src + '. ' + typeof(src));
                    return SupportLevel.SUPPORT_LEVEL_UNSPECIFIED;
            }
        };
        export const SupportLevel_ToObject = (src: SupportLevel): string | null => {
            switch (src) {
                case SupportLevel.SUPPORT_LEVEL_UNSPECIFIED:
                    return 'SUPPORT_LEVEL_UNSPECIFIED';
                case SupportLevel.SUPPORT_LEVEL_BOTTOM:
                    return 'SUPPORT_LEVEL_BOTTOM';
                case SupportLevel.SUPPORT_LEVEL_TOP:
                    return 'SUPPORT_LEVEL_TOP';
                case SupportLevel.SUPPORT_LEVEL_CENTER:
                    return 'SUPPORT_LEVEL_CENTER';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for SupportLevel, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Data_keys = 'id' | 'dependentStageGuid' | 'elems' | 'sups' | 'lcombGuids';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            dependentStageGuid?: string,
            elems?: ng.stage.Element[],
            sups?: ng.stage.Support[],
            lcombGuids?: string[],
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            dependentStageGuid?: string;
            elems: ng.stage.Element_json[];
            sups: ng.stage.Support_json[];
            lcombGuids: string[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            dependentStageGuid?: unknown;
            elems?: unknown;
            sups?: unknown;
            lcombGuids?: unknown;
        }
        export class Data {
            __proto_name = "ng.stage.Data";
            id: ng.utils.ID | null = null;
            dependentStageGuid: string = "";
            elems: ng.stage.Element[] = [];
            sups: ng.stage.Support[] = [];
            lcombGuids: string[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.dependentStageGuid !== undefined && src.dependentStageGuid !== null) {
                    if (typeof src.dependentStageGuid === "string") {
                        dst.dependentStageGuid = src.dependentStageGuid;
                    }
                    else {
                        console.log('Expected dependentStageGuid of Data to be a string but was ', typeof src.dependentStageGuid, src.dependentStageGuid)
                    }
                }
                if (src.elems !== undefined && src.elems !== null) {
                    if (Array.isArray(src.elems)) {
                        for (const element of src.elems) {
                            dst.elems.push(ng.stage.Element.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected elems of Data to be a array but was ', typeof src.elems, src.elems)
                    }
                }
                if (src.sups !== undefined && src.sups !== null) {
                    if (Array.isArray(src.sups)) {
                        for (const element of src.sups) {
                            dst.sups.push(ng.stage.Support.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected sups of Data to be a array but was ', typeof src.sups, src.sups)
                    }
                }
                if (src.lcombGuids !== undefined && src.lcombGuids !== null) {
                    if (Array.isArray(src.lcombGuids)) {
                        for (const [index, element] of src.lcombGuids.entries()) {
                            if (typeof element === "string") {
                                dst.lcombGuids.push(element);
                            }
                            else {
                                console.log('Expected lcombGuids of Data[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected lcombGuids of Data to be a array but was ', typeof src.lcombGuids, src.lcombGuids)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.Data") {
                    console.error('Expected ng.stage.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    dependentStageGuid: src.dependentStageGuid,
                    elems: new Array<ng.stage.Element_json>(),
                    sups: new Array<ng.stage.Support_json>(),
                    lcombGuids: new Array<string>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.elems !== null) {
                    for (const element of src.elems) {
                        const parsed = ng.stage.Element.toObject(element);
                        if(parsed === null) return null;
                        dst.elems.push(parsed);
                    }
                }
                if (src.sups !== null) {
                    for (const element of src.sups) {
                        const parsed = ng.stage.Support.toObject(element);
                        if(parsed === null) return null;
                        dst.sups.push(parsed);
                    }
                }
                if (src.lcombGuids !== null) {
                    for (const element of src.lcombGuids) {
                        dst.lcombGuids.push(element);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.dependentStageGuid !== undefined) {
                    dst.dependentStageGuid = src.dependentStageGuid;
                }
                if (src.elems !== undefined) {
                    dst.elems = src.elems;
                }
                if (src.sups !== undefined) {
                    dst.sups = src.sups;
                }
                if (src.lcombGuids !== undefined) {
                    dst.lcombGuids = src.lcombGuids;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.dependentStageGuid = this.dependentStageGuid;
                dst.elems = this.elems;
                dst.sups = this.sups;
                dst.lcombGuids = this.lcombGuids;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;


        export type Beam_keys = 'fraction' | 'positions' | 'startCon' | 'endCon' | 'autogenOutputEnd';
        export interface Beam_createType {
            fraction?: boolean,
            positions?: number[],
            startCon?: ng.topology.Connectivity | null,
            endCon?: ng.topology.Connectivity | null,
            autogenOutputEnd?: boolean,
        }
        export interface Beam_json {
            fraction?: boolean;
            positions: JsonNumber[];
            startCon?: ng.topology.Connectivity_json;
            endCon?: ng.topology.Connectivity_json;
            autogenOutputEnd?: boolean;
        }
        interface Beam_json_in {
            __proto_name?: unknown;
            fraction?: unknown;
            positions?: unknown;
            startCon?: unknown;
            endCon?: unknown;
            autogenOutputEnd?: unknown;
        }
        export class Beam {
            __proto_name = "ng.stage.Beam";
            fraction: boolean = false;
            positions: number[] = [];
            startCon: ng.topology.Connectivity | null = null;
            endCon: ng.topology.Connectivity | null = null;
            autogenOutputEnd: boolean = false;

            static fromObject(src_unknown: unknown): Beam {
                const dst = new Beam();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Beam but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Beam_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Beam but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.fraction !== undefined && src.fraction !== null) {
                    if (typeof src.fraction === "boolean") {
                        dst.fraction = src.fraction;
                    }
                    else {
                        console.log('Expected fraction of Beam to be a boolean but was ', typeof src.fraction, src.fraction)
                    }
                }
                if (src.positions !== undefined && src.positions !== null) {
                    if (Array.isArray(src.positions)) {
                        for (const [index, element] of src.positions.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.positions.push(AsNum(element));
                            }
                            else {
                                console.log('Expected positions of Beam[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected positions of Beam to be a array but was ', typeof src.positions, src.positions)
                    }
                }
                if (src.startCon !== undefined && src.startCon !== null) {
                    dst.startCon = ng.topology.Connectivity.fromObject(src.startCon);
                }
                if (src.endCon !== undefined && src.endCon !== null) {
                    dst.endCon = ng.topology.Connectivity.fromObject(src.endCon);
                }
                if (src.autogenOutputEnd !== undefined && src.autogenOutputEnd !== null) {
                    if (typeof src.autogenOutputEnd === "boolean") {
                        dst.autogenOutputEnd = src.autogenOutputEnd;
                    }
                    else {
                        console.log('Expected autogenOutputEnd of Beam to be a boolean but was ', typeof src.autogenOutputEnd, src.autogenOutputEnd)
                    }
                }
                return dst;
            }

            static toObject(src: Beam | null | undefined): Beam_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.Beam is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.Beam") {
                    console.error('Expected ng.stage.Beam but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Beam_json = {
                    fraction: src.fraction,
                    positions: new Array<JsonNumber>(),
                    autogenOutputEnd: src.autogenOutputEnd,
                };
                if (src.positions !== null) {
                    for (const element of src.positions) {
                        dst.positions.push(AsJsonNum(element));
                    }
                }
                if(src.startCon !== null)
                {
                    const parsed = ng.topology.Connectivity.toObject(src.startCon);
                    if(parsed === null) return null;
                    dst.startCon = parsed;
                }
                if(src.endCon !== null)
                {
                    const parsed = ng.topology.Connectivity.toObject(src.endCon);
                    if(parsed === null) return null;
                    dst.endCon = parsed;
                }
                return dst;
            }

            static create(src?: Beam_createType) {
                const dst = new Beam();
                if (src === undefined) {
                    return dst;
                }
                if (src.fraction !== undefined) {
                    dst.fraction = src.fraction;
                }
                if (src.positions !== undefined) {
                    dst.positions = src.positions;
                }
                if (src.startCon !== undefined) {
                    dst.startCon = src.startCon;
                }
                if (src.endCon !== undefined) {
                    dst.endCon = src.endCon;
                }
                if (src.autogenOutputEnd !== undefined) {
                    dst.autogenOutputEnd = src.autogenOutputEnd;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Beam();
                dst.fraction = this.fraction;
                dst.positions = this.positions;
                dst.startCon = this.startCon;
                dst.endCon = this.endCon;
                dst.autogenOutputEnd = this.autogenOutputEnd;
                return dst;
            }

            deepClone() {
                const json = Beam.toObject(this);
                const dst = Beam.fromObject(json);
                return dst;
            }
        }
        export type IBeam = Beam;


        export type Foundation_keys = 'referencePoint' | 'positions';
        export interface Foundation_createType {
            referencePoint?: ng.geometry.Point3D | null,
            positions?: ng.geometry.Point3D[],
        }
        export interface Foundation_json {
            referencePoint?: ng.geometry.Point3D_json;
            positions: ng.geometry.Point3D_json[];
        }
        interface Foundation_json_in {
            __proto_name?: unknown;
            referencePoint?: unknown;
            positions?: unknown;
        }
        export class Foundation {
            __proto_name = "ng.stage.Foundation";
            referencePoint: ng.geometry.Point3D | null = null;
            positions: ng.geometry.Point3D[] = [];

            static fromObject(src_unknown: unknown): Foundation {
                const dst = new Foundation();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Foundation but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Foundation_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Foundation but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.referencePoint !== undefined && src.referencePoint !== null) {
                    dst.referencePoint = ng.geometry.Point3D.fromObject(src.referencePoint);
                }
                if (src.positions !== undefined && src.positions !== null) {
                    if (Array.isArray(src.positions)) {
                        for (const element of src.positions) {
                            dst.positions.push(ng.geometry.Point3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected positions of Foundation to be a array but was ', typeof src.positions, src.positions)
                    }
                }
                return dst;
            }

            static toObject(src: Foundation | null | undefined): Foundation_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.Foundation is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.Foundation") {
                    console.error('Expected ng.stage.Foundation but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Foundation_json = {
                    positions: new Array<ng.geometry.Point3D_json>(),
                };
                if(src.referencePoint !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.referencePoint);
                    if(parsed === null) return null;
                    dst.referencePoint = parsed;
                }
                if (src.positions !== null) {
                    for (const element of src.positions) {
                        const parsed = ng.geometry.Point3D.toObject(element);
                        if(parsed === null) return null;
                        dst.positions.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Foundation_createType) {
                const dst = new Foundation();
                if (src === undefined) {
                    return dst;
                }
                if (src.referencePoint !== undefined) {
                    dst.referencePoint = src.referencePoint;
                }
                if (src.positions !== undefined) {
                    dst.positions = src.positions;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Foundation();
                dst.referencePoint = this.referencePoint;
                dst.positions = this.positions;
                return dst;
            }

            deepClone() {
                const json = Foundation.toObject(this);
                const dst = Foundation.fromObject(json);
                return dst;
            }
        }
        export type IFoundation = Foundation;


        export type RetainingWall_keys = 'referencePoint' | 'positions';
        export interface RetainingWall_createType {
            referencePoint?: ng.geometry.Point3D | null,
            positions?: ng.geometry.Point3D[],
        }
        export interface RetainingWall_json {
            referencePoint?: ng.geometry.Point3D_json;
            positions: ng.geometry.Point3D_json[];
        }
        interface RetainingWall_json_in {
            __proto_name?: unknown;
            referencePoint?: unknown;
            positions?: unknown;
        }
        export class RetainingWall {
            __proto_name = "ng.stage.RetainingWall";
            referencePoint: ng.geometry.Point3D | null = null;
            positions: ng.geometry.Point3D[] = [];

            static fromObject(src_unknown: unknown): RetainingWall {
                const dst = new RetainingWall();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted RetainingWall but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as RetainingWall_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for RetainingWall but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.referencePoint !== undefined && src.referencePoint !== null) {
                    dst.referencePoint = ng.geometry.Point3D.fromObject(src.referencePoint);
                }
                if (src.positions !== undefined && src.positions !== null) {
                    if (Array.isArray(src.positions)) {
                        for (const element of src.positions) {
                            dst.positions.push(ng.geometry.Point3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected positions of RetainingWall to be a array but was ', typeof src.positions, src.positions)
                    }
                }
                return dst;
            }

            static toObject(src: RetainingWall | null | undefined): RetainingWall_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.RetainingWall is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.RetainingWall") {
                    console.error('Expected ng.stage.RetainingWall but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : RetainingWall_json = {
                    positions: new Array<ng.geometry.Point3D_json>(),
                };
                if(src.referencePoint !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.referencePoint);
                    if(parsed === null) return null;
                    dst.referencePoint = parsed;
                }
                if (src.positions !== null) {
                    for (const element of src.positions) {
                        const parsed = ng.geometry.Point3D.toObject(element);
                        if(parsed === null) return null;
                        dst.positions.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: RetainingWall_createType) {
                const dst = new RetainingWall();
                if (src === undefined) {
                    return dst;
                }
                if (src.referencePoint !== undefined) {
                    dst.referencePoint = src.referencePoint;
                }
                if (src.positions !== undefined) {
                    dst.positions = src.positions;
                }
                return dst;
            }

            shallowClone() {
                const dst = new RetainingWall();
                dst.referencePoint = this.referencePoint;
                dst.positions = this.positions;
                return dst;
            }

            deepClone() {
                const json = RetainingWall.toObject(this);
                const dst = RetainingWall.fromObject(json);
                return dst;
            }
        }
        export type IRetainingWall = RetainingWall;


        export type Pile_keys = 'referencePoint' | 'positions';
        export interface Pile_createType {
            referencePoint?: ng.geometry.Point3D | null,
            positions?: ng.geometry.Point3D[],
        }
        export interface Pile_json {
            referencePoint?: ng.geometry.Point3D_json;
            positions: ng.geometry.Point3D_json[];
        }
        interface Pile_json_in {
            __proto_name?: unknown;
            referencePoint?: unknown;
            positions?: unknown;
        }
        export class Pile {
            __proto_name = "ng.stage.Pile";
            referencePoint: ng.geometry.Point3D | null = null;
            positions: ng.geometry.Point3D[] = [];

            static fromObject(src_unknown: unknown): Pile {
                const dst = new Pile();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Pile but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Pile_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Pile but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.referencePoint !== undefined && src.referencePoint !== null) {
                    dst.referencePoint = ng.geometry.Point3D.fromObject(src.referencePoint);
                }
                if (src.positions !== undefined && src.positions !== null) {
                    if (Array.isArray(src.positions)) {
                        for (const element of src.positions) {
                            dst.positions.push(ng.geometry.Point3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected positions of Pile to be a array but was ', typeof src.positions, src.positions)
                    }
                }
                return dst;
            }

            static toObject(src: Pile | null | undefined): Pile_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.Pile is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.Pile") {
                    console.error('Expected ng.stage.Pile but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Pile_json = {
                    positions: new Array<ng.geometry.Point3D_json>(),
                };
                if(src.referencePoint !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.referencePoint);
                    if(parsed === null) return null;
                    dst.referencePoint = parsed;
                }
                if (src.positions !== null) {
                    for (const element of src.positions) {
                        const parsed = ng.geometry.Point3D.toObject(element);
                        if(parsed === null) return null;
                        dst.positions.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Pile_createType) {
                const dst = new Pile();
                if (src === undefined) {
                    return dst;
                }
                if (src.referencePoint !== undefined) {
                    dst.referencePoint = src.referencePoint;
                }
                if (src.positions !== undefined) {
                    dst.positions = src.positions;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Pile();
                dst.referencePoint = this.referencePoint;
                dst.positions = this.positions;
                return dst;
            }

            deepClone() {
                const json = Pile.toObject(this);
                const dst = Pile.fromObject(json);
                return dst;
            }
        }
        export type IPile = Pile;


        export type Element_keys = 'guid' | 'beam' | 'foundation' | 'retainingWall' | 'pile' | 'rc' | 'steel' | 'timber' | 'soil' | 'autogenOutputLoad';
        export interface Element_createType {
            guid?: string,
            beam?: ng.stage.Beam | null,
            foundation?: ng.stage.Foundation | null,
            retainingWall?: ng.stage.RetainingWall | null,
            pile?: ng.stage.Pile | null,
            rc?: ng.stage.RC | null,
            steel?: ng.stage.SteelSpecific | null,
            timber?: ng.stage.TimberSpecific | null,
            soil?: ng.stage.SoilSpecific | null,
            autogenOutputLoad?: boolean,
        }
        export interface Element_json {
            guid?: string;
            beam?: ng.stage.Beam_json;
            foundation?: ng.stage.Foundation_json;
            retainingWall?: ng.stage.RetainingWall_json;
            pile?: ng.stage.Pile_json;
            rc?: ng.stage.RC_json;
            steel?: ng.stage.SteelSpecific_json;
            timber?: ng.stage.TimberSpecific_json;
            soil?: ng.stage.SoilSpecific_json;
            autogenOutputLoad?: boolean;
        }
        interface Element_json_in {
            __proto_name?: unknown;
            guid?: unknown;
            beam?: unknown;
            foundation?: unknown;
            retainingWall?: unknown;
            pile?: unknown;
            rc?: unknown;
            steel?: unknown;
            timber?: unknown;
            soil?: unknown;
            autogenOutputLoad?: unknown;
        }
        export class Element {
            __proto_name = "ng.stage.Element";
            guid: string = "";
            // this is a one of
            element: {type: 'beam'; beam: ng.stage.Beam} | {type: 'foundation'; foundation: ng.stage.Foundation} | {type: 'retainingWall'; retainingWall: ng.stage.RetainingWall} | {type: 'pile'; pile: ng.stage.Pile} | null = null;
            // this is a one of
            material_specific: {type: 'rc'; rc: ng.stage.RC} | {type: 'steel'; steel: ng.stage.SteelSpecific} | {type: 'timber'; timber: ng.stage.TimberSpecific} | {type: 'soil'; soil: ng.stage.SoilSpecific} | null = null;
            autogenOutputLoad: boolean = false;

            /** Gets the `Beam` value (or null) from the oneof `element` */
            getBeam(): ng.stage.Beam | null {
                if(this.element === null) return null;
                if(this.element.type !== 'beam') return null;
                return this.element.beam;
            }

            /** Sets the `Beam` value for the oneof `element`*/
            setBeam(value: ng.stage.Beam | null) {
                if(value !== null) {
                    this.element = {type: 'beam', beam:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Foundation` value (or null) from the oneof `element` */
            getFoundation(): ng.stage.Foundation | null {
                if(this.element === null) return null;
                if(this.element.type !== 'foundation') return null;
                return this.element.foundation;
            }

            /** Sets the `Foundation` value for the oneof `element`*/
            setFoundation(value: ng.stage.Foundation | null) {
                if(value !== null) {
                    this.element = {type: 'foundation', foundation:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `RetainingWall` value (or null) from the oneof `element` */
            getRetainingWall(): ng.stage.RetainingWall | null {
                if(this.element === null) return null;
                if(this.element.type !== 'retainingWall') return null;
                return this.element.retainingWall;
            }

            /** Sets the `RetainingWall` value for the oneof `element`*/
            setRetainingWall(value: ng.stage.RetainingWall | null) {
                if(value !== null) {
                    this.element = {type: 'retainingWall', retainingWall:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Pile` value (or null) from the oneof `element` */
            getPile(): ng.stage.Pile | null {
                if(this.element === null) return null;
                if(this.element.type !== 'pile') return null;
                return this.element.pile;
            }

            /** Sets the `Pile` value for the oneof `element`*/
            setPile(value: ng.stage.Pile | null) {
                if(value !== null) {
                    this.element = {type: 'pile', pile:value};
                }
                else {
                    this.element = null;
                }
            }
            /** Gets the `Rc` value (or null) from the oneof `material_specific` */
            getRc(): ng.stage.RC | null {
                if(this.material_specific === null) return null;
                if(this.material_specific.type !== 'rc') return null;
                return this.material_specific.rc;
            }

            /** Sets the `Rc` value for the oneof `material_specific`*/
            setRc(value: ng.stage.RC | null) {
                if(value !== null) {
                    this.material_specific = {type: 'rc', rc:value};
                }
                else {
                    this.material_specific = null;
                }
            }

            /** Gets the `Steel` value (or null) from the oneof `material_specific` */
            getSteel(): ng.stage.SteelSpecific | null {
                if(this.material_specific === null) return null;
                if(this.material_specific.type !== 'steel') return null;
                return this.material_specific.steel;
            }

            /** Sets the `Steel` value for the oneof `material_specific`*/
            setSteel(value: ng.stage.SteelSpecific | null) {
                if(value !== null) {
                    this.material_specific = {type: 'steel', steel:value};
                }
                else {
                    this.material_specific = null;
                }
            }

            /** Gets the `Timber` value (or null) from the oneof `material_specific` */
            getTimber(): ng.stage.TimberSpecific | null {
                if(this.material_specific === null) return null;
                if(this.material_specific.type !== 'timber') return null;
                return this.material_specific.timber;
            }

            /** Sets the `Timber` value for the oneof `material_specific`*/
            setTimber(value: ng.stage.TimberSpecific | null) {
                if(value !== null) {
                    this.material_specific = {type: 'timber', timber:value};
                }
                else {
                    this.material_specific = null;
                }
            }

            /** Gets the `Soil` value (or null) from the oneof `material_specific` */
            getSoil(): ng.stage.SoilSpecific | null {
                if(this.material_specific === null) return null;
                if(this.material_specific.type !== 'soil') return null;
                return this.material_specific.soil;
            }

            /** Sets the `Soil` value for the oneof `material_specific`*/
            setSoil(value: ng.stage.SoilSpecific | null) {
                if(value !== null) {
                    this.material_specific = {type: 'soil', soil:value};
                }
                else {
                    this.material_specific = null;
                }
            }

            static fromObject(src_unknown: unknown): Element {
                const dst = new Element();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Element but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Element_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Element but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.guid !== undefined && src.guid !== null) {
                    if (typeof src.guid === "string") {
                        dst.guid = src.guid;
                    }
                    else {
                        console.log('Expected guid of Element to be a string but was ', typeof src.guid, src.guid)
                    }
                }
                if (src.beam !== undefined && src.beam !== null) {
                    dst.setBeam(ng.stage.Beam.fromObject(src.beam));
                }
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(ng.stage.Foundation.fromObject(src.foundation));
                }
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(ng.stage.RetainingWall.fromObject(src.retainingWall));
                }
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(ng.stage.Pile.fromObject(src.pile));
                }
                if (src.rc !== undefined && src.rc !== null) {
                    dst.setRc(ng.stage.RC.fromObject(src.rc));
                }
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(ng.stage.SteelSpecific.fromObject(src.steel));
                }
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(ng.stage.TimberSpecific.fromObject(src.timber));
                }
                if (src.soil !== undefined && src.soil !== null) {
                    dst.setSoil(ng.stage.SoilSpecific.fromObject(src.soil));
                }
                if (src.autogenOutputLoad !== undefined && src.autogenOutputLoad !== null) {
                    if (typeof src.autogenOutputLoad === "boolean") {
                        dst.autogenOutputLoad = src.autogenOutputLoad;
                    }
                    else {
                        console.log('Expected autogenOutputLoad of Element to be a boolean but was ', typeof src.autogenOutputLoad, src.autogenOutputLoad)
                    }
                }
                return dst;
            }

            static toObject(src: Element | null | undefined): Element_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.Element is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.Element") {
                    console.error('Expected ng.stage.Element but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Element_json = {
                    guid: src.guid,
                    autogenOutputLoad: src.autogenOutputLoad,
                };
                const beam = src.getBeam();
                if(beam !== null)
                {
                    const parsed = ng.stage.Beam.toObject(beam);
                    if(parsed === null) return null;
                    dst.beam = parsed;
                }
                const foundation = src.getFoundation();
                if(foundation !== null)
                {
                    const parsed = ng.stage.Foundation.toObject(foundation);
                    if(parsed === null) return null;
                    dst.foundation = parsed;
                }
                const retainingWall = src.getRetainingWall();
                if(retainingWall !== null)
                {
                    const parsed = ng.stage.RetainingWall.toObject(retainingWall);
                    if(parsed === null) return null;
                    dst.retainingWall = parsed;
                }
                const pile = src.getPile();
                if(pile !== null)
                {
                    const parsed = ng.stage.Pile.toObject(pile);
                    if(parsed === null) return null;
                    dst.pile = parsed;
                }
                const rc = src.getRc();
                if(rc !== null)
                {
                    const parsed = ng.stage.RC.toObject(rc);
                    if(parsed === null) return null;
                    dst.rc = parsed;
                }
                const steel = src.getSteel();
                if(steel !== null)
                {
                    const parsed = ng.stage.SteelSpecific.toObject(steel);
                    if(parsed === null) return null;
                    dst.steel = parsed;
                }
                const timber = src.getTimber();
                if(timber !== null)
                {
                    const parsed = ng.stage.TimberSpecific.toObject(timber);
                    if(parsed === null) return null;
                    dst.timber = parsed;
                }
                const soil = src.getSoil();
                if(soil !== null)
                {
                    const parsed = ng.stage.SoilSpecific.toObject(soil);
                    if(parsed === null) return null;
                    dst.soil = parsed;
                }
                return dst;
            }

            static create(src?: Element_createType) {
                const dst = new Element();
                if (src === undefined) {
                    return dst;
                }
                if (src.guid !== undefined) {
                    dst.guid = src.guid;
                }
                // part of the element oneof 
                if (src.beam !== undefined && src.beam !== null) {
                    dst.setBeam(src.beam);
                }
                // part of the element oneof 
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(src.foundation);
                }
                // part of the element oneof 
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(src.retainingWall);
                }
                // part of the element oneof 
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(src.pile);
                }
                // part of the material_specific oneof 
                if (src.rc !== undefined && src.rc !== null) {
                    dst.setRc(src.rc);
                }
                // part of the material_specific oneof 
                if (src.steel !== undefined && src.steel !== null) {
                    dst.setSteel(src.steel);
                }
                // part of the material_specific oneof 
                if (src.timber !== undefined && src.timber !== null) {
                    dst.setTimber(src.timber);
                }
                // part of the material_specific oneof 
                if (src.soil !== undefined && src.soil !== null) {
                    dst.setSoil(src.soil);
                }
                if (src.autogenOutputLoad !== undefined) {
                    dst.autogenOutputLoad = src.autogenOutputLoad;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Element();
                dst.guid = this.guid;
                dst.element = this.element;
                dst.material_specific = this.material_specific;
                dst.autogenOutputLoad = this.autogenOutputLoad;
                return dst;
            }

            deepClone() {
                const json = Element.toObject(this);
                const dst = Element.fromObject(json);
                return dst;
            }
        }
        export type IElement = Element;


        export type RCSpecific_keys = 'guid' | 'age' | 'creep' | 'shrinkage' | 'waterCementRatioIndex' | 'exposureClass' | 'environmentalClass' | 'wet' | 'effectiveCreep';
        export interface RCSpecific_createType {
            guid?: string,
            age?: number,
            creep?: number,
            shrinkage?: number,
            waterCementRatioIndex?: number,
            exposureClass?: ng.stage.ExposureClass,
            environmentalClass?: ng.stage.EnvironmentalClass,
            wet?: boolean,
            effectiveCreep?: number,
        }
        export interface RCSpecific_json {
            guid?: string;
            age?: JsonNumber;
            creep?: JsonNumber;
            shrinkage?: JsonNumber;
            waterCementRatioIndex?: JsonNumber;
            exposureClass?: string;
            environmentalClass?: string;
            wet?: boolean;
            effectiveCreep?: JsonNumber;
        }
        interface RCSpecific_json_in {
            __proto_name?: unknown;
            guid?: unknown;
            age?: unknown;
            creep?: unknown;
            shrinkage?: unknown;
            waterCementRatioIndex?: unknown;
            exposureClass?: unknown;
            environmentalClass?: unknown;
            wet?: unknown;
            effectiveCreep?: unknown;
        }
        export class RCSpecific {
            __proto_name = "ng.stage.RCSpecific";
            guid: string = "";
            age: number = 0;
            creep: number = 0;
            shrinkage: number = 0;
            waterCementRatioIndex: number = 0;
            // this is a one of
            climate: {type: 'exposureClass'; exposureClass: ng.stage.ExposureClass} | {type: 'environmentalClass'; environmentalClass: ng.stage.EnvironmentalClass} | null = null;
            wet: boolean = false;
            effectiveCreep: number = 0;

            /** Gets the `ExposureClass` value (or null) from the oneof `climate` */
            getExposureClass(): ng.stage.ExposureClass | null {
                if(this.climate === null) return null;
                if(this.climate.type !== 'exposureClass') return null;
                return this.climate.exposureClass;
            }

            /** Sets the `ExposureClass` value for the oneof `climate`*/
            setExposureClass(value: ng.stage.ExposureClass | null) {
                if(value !== null) {
                    this.climate = {type: 'exposureClass', exposureClass:value};
                }
                else {
                    this.climate = null;
                }
            }

            /** Gets the `EnvironmentalClass` value (or null) from the oneof `climate` */
            getEnvironmentalClass(): ng.stage.EnvironmentalClass | null {
                if(this.climate === null) return null;
                if(this.climate.type !== 'environmentalClass') return null;
                return this.climate.environmentalClass;
            }

            /** Sets the `EnvironmentalClass` value for the oneof `climate`*/
            setEnvironmentalClass(value: ng.stage.EnvironmentalClass | null) {
                if(value !== null) {
                    this.climate = {type: 'environmentalClass', environmentalClass:value};
                }
                else {
                    this.climate = null;
                }
            }

            static fromObject(src_unknown: unknown): RCSpecific {
                const dst = new RCSpecific();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted RCSpecific but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as RCSpecific_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for RCSpecific but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.guid !== undefined && src.guid !== null) {
                    if (typeof src.guid === "string") {
                        dst.guid = src.guid;
                    }
                    else {
                        console.log('Expected guid of RCSpecific to be a string but was ', typeof src.guid, src.guid)
                    }
                }
                if (src.age !== undefined && src.age !== null) {
                    if (typeof src.age === "number" || src.age === 'NaN' || src.age === 'Infinity' || src.age === '-Infinity') {
                        dst.age = NumberToInt("ng.stage.RCSpecific.age", AsNum(src.age));
                    }
                    else {
                        console.log('Expected age of RCSpecific to be a number but was ', typeof src.age, src.age)
                    }
                }
                if (src.creep !== undefined && src.creep !== null) {
                    if (typeof src.creep === "number" || src.creep === 'NaN' || src.creep === 'Infinity' || src.creep === '-Infinity') {
                        dst.creep = AsNum(src.creep);
                    }
                    else {
                        console.log('Expected creep of RCSpecific to be a number but was ', typeof src.creep, src.creep)
                    }
                }
                if (src.shrinkage !== undefined && src.shrinkage !== null) {
                    if (typeof src.shrinkage === "number" || src.shrinkage === 'NaN' || src.shrinkage === 'Infinity' || src.shrinkage === '-Infinity') {
                        dst.shrinkage = AsNum(src.shrinkage);
                    }
                    else {
                        console.log('Expected shrinkage of RCSpecific to be a number but was ', typeof src.shrinkage, src.shrinkage)
                    }
                }
                if (src.waterCementRatioIndex !== undefined && src.waterCementRatioIndex !== null) {
                    if (typeof src.waterCementRatioIndex === "number" || src.waterCementRatioIndex === 'NaN' || src.waterCementRatioIndex === 'Infinity' || src.waterCementRatioIndex === '-Infinity') {
                        dst.waterCementRatioIndex = NumberToInt("ng.stage.RCSpecific.water_cement_ratio_index", AsNum(src.waterCementRatioIndex));
                    }
                    else {
                        console.log('Expected waterCementRatioIndex of RCSpecific to be a number but was ', typeof src.waterCementRatioIndex, src.waterCementRatioIndex)
                    }
                }
                if (src.exposureClass !== undefined && src.exposureClass !== null) {
                    dst.setExposureClass(ng.stage.ExposureClass_FromObject(src.exposureClass));
                }
                if (src.environmentalClass !== undefined && src.environmentalClass !== null) {
                    dst.setEnvironmentalClass(ng.stage.EnvironmentalClass_FromObject(src.environmentalClass));
                }
                if (src.wet !== undefined && src.wet !== null) {
                    if (typeof src.wet === "boolean") {
                        dst.wet = src.wet;
                    }
                    else {
                        console.log('Expected wet of RCSpecific to be a boolean but was ', typeof src.wet, src.wet)
                    }
                }
                if (src.effectiveCreep !== undefined && src.effectiveCreep !== null) {
                    if (typeof src.effectiveCreep === "number" || src.effectiveCreep === 'NaN' || src.effectiveCreep === 'Infinity' || src.effectiveCreep === '-Infinity') {
                        dst.effectiveCreep = AsNum(src.effectiveCreep);
                    }
                    else {
                        console.log('Expected effectiveCreep of RCSpecific to be a number but was ', typeof src.effectiveCreep, src.effectiveCreep)
                    }
                }
                return dst;
            }

            static toObject(src: RCSpecific | null | undefined): RCSpecific_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.RCSpecific is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.RCSpecific") {
                    console.error('Expected ng.stage.RCSpecific but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : RCSpecific_json = {
                    guid: src.guid,
                    age: AsJsonNum(NumberToInt("ng.stage.RCSpecific.age", src.age)),
                    creep: AsJsonNum(src.creep),
                    shrinkage: AsJsonNum(src.shrinkage),
                    waterCementRatioIndex: AsJsonNum(NumberToInt("ng.stage.RCSpecific.water_cement_ratio_index", src.waterCementRatioIndex)),
                    wet: src.wet,
                    effectiveCreep: AsJsonNum(src.effectiveCreep),
                };
                const exposureClass = src.getExposureClass();
                if(exposureClass !== null)
                {
                    const parsed = ng.stage.ExposureClass_ToObject(exposureClass);
                    if(parsed === null) return null;
                    dst.exposureClass = parsed;
                }
                const environmentalClass = src.getEnvironmentalClass();
                if(environmentalClass !== null)
                {
                    const parsed = ng.stage.EnvironmentalClass_ToObject(environmentalClass);
                    if(parsed === null) return null;
                    dst.environmentalClass = parsed;
                }
                return dst;
            }

            static create(src?: RCSpecific_createType) {
                const dst = new RCSpecific();
                if (src === undefined) {
                    return dst;
                }
                if (src.guid !== undefined) {
                    dst.guid = src.guid;
                }
                if (src.age !== undefined) {
                    dst.age = src.age;
                }
                if (src.creep !== undefined) {
                    dst.creep = src.creep;
                }
                if (src.shrinkage !== undefined) {
                    dst.shrinkage = src.shrinkage;
                }
                if (src.waterCementRatioIndex !== undefined) {
                    dst.waterCementRatioIndex = src.waterCementRatioIndex;
                }
                // part of the climate oneof 
                if (src.exposureClass !== undefined && src.exposureClass !== null) {
                    dst.setExposureClass(src.exposureClass);
                }
                // part of the climate oneof 
                if (src.environmentalClass !== undefined && src.environmentalClass !== null) {
                    dst.setEnvironmentalClass(src.environmentalClass);
                }
                if (src.wet !== undefined) {
                    dst.wet = src.wet;
                }
                if (src.effectiveCreep !== undefined) {
                    dst.effectiveCreep = src.effectiveCreep;
                }
                return dst;
            }

            shallowClone() {
                const dst = new RCSpecific();
                dst.guid = this.guid;
                dst.age = this.age;
                dst.creep = this.creep;
                dst.shrinkage = this.shrinkage;
                dst.waterCementRatioIndex = this.waterCementRatioIndex;
                dst.climate = this.climate;
                dst.wet = this.wet;
                dst.effectiveCreep = this.effectiveCreep;
                return dst;
            }

            deepClone() {
                const json = RCSpecific.toObject(this);
                const dst = RCSpecific.fromObject(json);
                return dst;
            }
        }
        export type IRCSpecific = RCSpecific;


        export type RC_keys = 'rcSpecifics' | 'lifeCategory';
        export interface RC_createType {
            rcSpecifics?: ng.stage.RCSpecific[],
            lifeCategory?: ng.stage.LifeCategory,
        }
        export interface RC_json {
            rcSpecifics: ng.stage.RCSpecific_json[];
            lifeCategory?: string;
        }
        interface RC_json_in {
            __proto_name?: unknown;
            rcSpecifics?: unknown;
            lifeCategory?: unknown;
        }
        export class RC {
            __proto_name = "ng.stage.RC";
            rcSpecifics: ng.stage.RCSpecific[] = [];
            lifeCategory: ng.stage.LifeCategory = ng.stage.LifeCategory.LIFE_CATEGORY_UNSPECIFIED;

            static fromObject(src_unknown: unknown): RC {
                const dst = new RC();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted RC but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as RC_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for RC but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.rcSpecifics !== undefined && src.rcSpecifics !== null) {
                    if (Array.isArray(src.rcSpecifics)) {
                        for (const element of src.rcSpecifics) {
                            dst.rcSpecifics.push(ng.stage.RCSpecific.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected rcSpecifics of RC to be a array but was ', typeof src.rcSpecifics, src.rcSpecifics)
                    }
                }
                if (src.lifeCategory !== undefined && src.lifeCategory !== null) {
                    dst.lifeCategory = ng.stage.LifeCategory_FromObject(src.lifeCategory);
                }
                return dst;
            }

            static toObject(src: RC | null | undefined): RC_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.RC is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.RC") {
                    console.error('Expected ng.stage.RC but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const lifeCategory_obj = ng.stage.LifeCategory_ToObject(src.lifeCategory);
                if(lifeCategory_obj === null) return null;

                const dst : RC_json = {
                    rcSpecifics: new Array<ng.stage.RCSpecific_json>(),
                    lifeCategory: lifeCategory_obj,
                };
                if (src.rcSpecifics !== null) {
                    for (const element of src.rcSpecifics) {
                        const parsed = ng.stage.RCSpecific.toObject(element);
                        if(parsed === null) return null;
                        dst.rcSpecifics.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: RC_createType) {
                const dst = new RC();
                if (src === undefined) {
                    return dst;
                }
                if (src.rcSpecifics !== undefined) {
                    dst.rcSpecifics = src.rcSpecifics;
                }
                if (src.lifeCategory !== undefined) {
                    dst.lifeCategory = src.lifeCategory;
                }
                return dst;
            }

            shallowClone() {
                const dst = new RC();
                dst.rcSpecifics = this.rcSpecifics;
                dst.lifeCategory = this.lifeCategory;
                return dst;
            }

            deepClone() {
                const json = RC.toObject(this);
                const dst = RC.fromObject(json);
                return dst;
            }
        }
        export type IRC = RC;


        export type SteelSpecific_keys = unknown;
        export interface SteelSpecific_createType {
        }
        export interface SteelSpecific_json {
        }
        interface SteelSpecific_json_in {
            __proto_name?: unknown;
        }
        export class SteelSpecific {
            __proto_name = "ng.stage.SteelSpecific";

            static fromObject(src_unknown: unknown): SteelSpecific {
                const dst = new SteelSpecific();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SteelSpecific but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SteelSpecific_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SteelSpecific but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                return dst;
            }

            static toObject(src: SteelSpecific | null | undefined): SteelSpecific_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.SteelSpecific is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.SteelSpecific") {
                    console.error('Expected ng.stage.SteelSpecific but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SteelSpecific_json = {
                };
                return dst;
            }

            static create(src?: SteelSpecific_createType) {
                const dst = new SteelSpecific();
                if (src === undefined) {
                    return dst;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SteelSpecific();
                return dst;
            }

            deepClone() {
                const json = SteelSpecific.toObject(this);
                const dst = SteelSpecific.fromObject(json);
                return dst;
            }
        }
        export type ISteelSpecific = SteelSpecific;


        export type TimberSpecific_keys = unknown;
        export interface TimberSpecific_createType {
        }
        export interface TimberSpecific_json {
        }
        interface TimberSpecific_json_in {
            __proto_name?: unknown;
        }
        export class TimberSpecific {
            __proto_name = "ng.stage.TimberSpecific";

            static fromObject(src_unknown: unknown): TimberSpecific {
                const dst = new TimberSpecific();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted TimberSpecific but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as TimberSpecific_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for TimberSpecific but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                return dst;
            }

            static toObject(src: TimberSpecific | null | undefined): TimberSpecific_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.TimberSpecific is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.TimberSpecific") {
                    console.error('Expected ng.stage.TimberSpecific but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : TimberSpecific_json = {
                };
                return dst;
            }

            static create(src?: TimberSpecific_createType) {
                const dst = new TimberSpecific();
                if (src === undefined) {
                    return dst;
                }
                return dst;
            }

            shallowClone() {
                const dst = new TimberSpecific();
                return dst;
            }

            deepClone() {
                const json = TimberSpecific.toObject(this);
                const dst = TimberSpecific.fromObject(json);
                return dst;
            }
        }
        export type ITimberSpecific = TimberSpecific;


        export type SoilSpecific_keys = unknown;
        export interface SoilSpecific_createType {
        }
        export interface SoilSpecific_json {
        }
        interface SoilSpecific_json_in {
            __proto_name?: unknown;
        }
        export class SoilSpecific {
            __proto_name = "ng.stage.SoilSpecific";

            static fromObject(src_unknown: unknown): SoilSpecific {
                const dst = new SoilSpecific();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SoilSpecific but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SoilSpecific_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SoilSpecific but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                return dst;
            }

            static toObject(src: SoilSpecific | null | undefined): SoilSpecific_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.SoilSpecific is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.SoilSpecific") {
                    console.error('Expected ng.stage.SoilSpecific but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SoilSpecific_json = {
                };
                return dst;
            }

            static create(src?: SoilSpecific_createType) {
                const dst = new SoilSpecific();
                if (src === undefined) {
                    return dst;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SoilSpecific();
                return dst;
            }

            deepClone() {
                const json = SoilSpecific.toObject(this);
                const dst = SoilSpecific.fromObject(json);
                return dst;
            }
        }
        export type ISoilSpecific = SoilSpecific;


        export type SupportElementConnection_keys = 'elementGuid' | 'position';
        export interface SupportElementConnection_createType {
            elementGuid?: string,
            position?: number,
        }
        export interface SupportElementConnection_json {
            elementGuid?: string;
            position?: JsonNumber;
        }
        interface SupportElementConnection_json_in {
            __proto_name?: unknown;
            elementGuid?: unknown;
            position?: unknown;
        }
        export class SupportElementConnection {
            __proto_name = "ng.stage.SupportElementConnection";
            elementGuid: string = "";
            position: number = 0;

            static fromObject(src_unknown: unknown): SupportElementConnection {
                const dst = new SupportElementConnection();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SupportElementConnection but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SupportElementConnection_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SupportElementConnection but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.elementGuid !== undefined && src.elementGuid !== null) {
                    if (typeof src.elementGuid === "string") {
                        dst.elementGuid = src.elementGuid;
                    }
                    else {
                        console.log('Expected elementGuid of SupportElementConnection to be a string but was ', typeof src.elementGuid, src.elementGuid)
                    }
                }
                if (src.position !== undefined && src.position !== null) {
                    if (typeof src.position === "number" || src.position === 'NaN' || src.position === 'Infinity' || src.position === '-Infinity') {
                        dst.position = AsNum(src.position);
                    }
                    else {
                        console.log('Expected position of SupportElementConnection to be a number but was ', typeof src.position, src.position)
                    }
                }
                return dst;
            }

            static toObject(src: SupportElementConnection | null | undefined): SupportElementConnection_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.SupportElementConnection is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.SupportElementConnection") {
                    console.error('Expected ng.stage.SupportElementConnection but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SupportElementConnection_json = {
                    elementGuid: src.elementGuid,
                    position: AsJsonNum(src.position),
                };
                return dst;
            }

            static create(src?: SupportElementConnection_createType) {
                const dst = new SupportElementConnection();
                if (src === undefined) {
                    return dst;
                }
                if (src.elementGuid !== undefined) {
                    dst.elementGuid = src.elementGuid;
                }
                if (src.position !== undefined) {
                    dst.position = src.position;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SupportElementConnection();
                dst.elementGuid = this.elementGuid;
                dst.position = this.position;
                return dst;
            }

            deepClone() {
                const json = SupportElementConnection.toObject(this);
                const dst = SupportElementConnection.fromObject(json);
                return dst;
            }
        }
        export type ISupportElementConnection = SupportElementConnection;


        export type Support_keys = 'guid' | 'coord' | 'conGuid' | 'elemCon' | 'con' | 'lateral' | 'supportLevel';
        export interface Support_createType {
            guid?: string,
            coord?: ng.geometry.Point3D | null,
            conGuid?: string,
            elemCon?: ng.stage.SupportElementConnection | null,
            con?: ng.topology.Connectivity | null,
            lateral?: boolean,
            supportLevel?: ng.stage.SupportLevel,
        }
        export interface Support_json {
            guid?: string;
            coord?: ng.geometry.Point3D_json;
            conGuid?: string;
            elemCon?: ng.stage.SupportElementConnection_json;
            con?: ng.topology.Connectivity_json;
            lateral?: boolean;
            supportLevel?: string;
        }
        interface Support_json_in {
            __proto_name?: unknown;
            guid?: unknown;
            coord?: unknown;
            conGuid?: unknown;
            elemCon?: unknown;
            con?: unknown;
            lateral?: unknown;
            supportLevel?: unknown;
        }
        export class Support {
            __proto_name = "ng.stage.Support";
            guid: string = "";
            // this is a one of
            position: {type: 'coord'; coord: ng.geometry.Point3D} | {type: 'conGuid'; conGuid: string} | {type: 'elemCon'; elemCon: ng.stage.SupportElementConnection} | null = null;
            con: ng.topology.Connectivity | null = null;
            lateral: boolean = false;
            supportLevel: ng.stage.SupportLevel = ng.stage.SupportLevel.SUPPORT_LEVEL_UNSPECIFIED;

            /** Gets the `Coord` value (or null) from the oneof `position` */
            getCoord(): ng.geometry.Point3D | null {
                if(this.position === null) return null;
                if(this.position.type !== 'coord') return null;
                return this.position.coord;
            }

            /** Sets the `Coord` value for the oneof `position`*/
            setCoord(value: ng.geometry.Point3D | null) {
                if(value !== null) {
                    this.position = {type: 'coord', coord:value};
                }
                else {
                    this.position = null;
                }
            }

            /** Gets the `ConGuid` value (or null) from the oneof `position` */
            getConGuid(): string | null {
                if(this.position === null) return null;
                if(this.position.type !== 'conGuid') return null;
                return this.position.conGuid;
            }

            /** Sets the `ConGuid` value for the oneof `position`*/
            setConGuid(value: string | null) {
                if(value !== null) {
                    this.position = {type: 'conGuid', conGuid:value};
                }
                else {
                    this.position = null;
                }
            }

            /** Gets the `ElemCon` value (or null) from the oneof `position` */
            getElemCon(): ng.stage.SupportElementConnection | null {
                if(this.position === null) return null;
                if(this.position.type !== 'elemCon') return null;
                return this.position.elemCon;
            }

            /** Sets the `ElemCon` value for the oneof `position`*/
            setElemCon(value: ng.stage.SupportElementConnection | null) {
                if(value !== null) {
                    this.position = {type: 'elemCon', elemCon:value};
                }
                else {
                    this.position = null;
                }
            }

            static fromObject(src_unknown: unknown): Support {
                const dst = new Support();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Support but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Support_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Support but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.guid !== undefined && src.guid !== null) {
                    if (typeof src.guid === "string") {
                        dst.guid = src.guid;
                    }
                    else {
                        console.log('Expected guid of Support to be a string but was ', typeof src.guid, src.guid)
                    }
                }
                if (src.coord !== undefined && src.coord !== null) {
                    dst.setCoord(ng.geometry.Point3D.fromObject(src.coord));
                }
                if (src.conGuid !== undefined && src.conGuid !== null) {
                    if (typeof src.conGuid === "string") {
                        dst.setConGuid(src.conGuid);
                    }
                    else {
                        console.log('Expected conGuid of Support to be a string but was ', typeof src.conGuid, src.conGuid)
                    }
                }
                if (src.elemCon !== undefined && src.elemCon !== null) {
                    dst.setElemCon(ng.stage.SupportElementConnection.fromObject(src.elemCon));
                }
                if (src.con !== undefined && src.con !== null) {
                    dst.con = ng.topology.Connectivity.fromObject(src.con);
                }
                if (src.lateral !== undefined && src.lateral !== null) {
                    if (typeof src.lateral === "boolean") {
                        dst.lateral = src.lateral;
                    }
                    else {
                        console.log('Expected lateral of Support to be a boolean but was ', typeof src.lateral, src.lateral)
                    }
                }
                if (src.supportLevel !== undefined && src.supportLevel !== null) {
                    dst.supportLevel = ng.stage.SupportLevel_FromObject(src.supportLevel);
                }
                return dst;
            }

            static toObject(src: Support | null | undefined): Support_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.stage.Support is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.stage.Support") {
                    console.error('Expected ng.stage.Support but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const supportLevel_obj = ng.stage.SupportLevel_ToObject(src.supportLevel);
                if(supportLevel_obj === null) return null;

                const dst : Support_json = {
                    guid: src.guid,
                    lateral: src.lateral,
                    supportLevel: supportLevel_obj,
                };
                const coord = src.getCoord();
                if(coord !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(coord);
                    if(parsed === null) return null;
                    dst.coord = parsed;
                }
                const conGuid = src.getConGuid();
                if(conGuid !== null)
                {
                    const parsed = conGuid;
                    if(parsed === null) return null;
                    dst.conGuid = parsed;
                }
                const elemCon = src.getElemCon();
                if(elemCon !== null)
                {
                    const parsed = ng.stage.SupportElementConnection.toObject(elemCon);
                    if(parsed === null) return null;
                    dst.elemCon = parsed;
                }
                if(src.con !== null)
                {
                    const parsed = ng.topology.Connectivity.toObject(src.con);
                    if(parsed === null) return null;
                    dst.con = parsed;
                }
                return dst;
            }

            static create(src?: Support_createType) {
                const dst = new Support();
                if (src === undefined) {
                    return dst;
                }
                if (src.guid !== undefined) {
                    dst.guid = src.guid;
                }
                // part of the position oneof 
                if (src.coord !== undefined && src.coord !== null) {
                    dst.setCoord(src.coord);
                }
                // part of the position oneof 
                if (src.conGuid !== undefined && src.conGuid !== null) {
                    dst.setConGuid(src.conGuid);
                }
                // part of the position oneof 
                if (src.elemCon !== undefined && src.elemCon !== null) {
                    dst.setElemCon(src.elemCon);
                }
                if (src.con !== undefined) {
                    dst.con = src.con;
                }
                if (src.lateral !== undefined) {
                    dst.lateral = src.lateral;
                }
                if (src.supportLevel !== undefined) {
                    dst.supportLevel = src.supportLevel;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Support();
                dst.guid = this.guid;
                dst.position = this.position;
                dst.con = this.con;
                dst.lateral = this.lateral;
                dst.supportLevel = this.supportLevel;
                return dst;
            }

            deepClone() {
                const json = Support.toObject(this);
                const dst = Support.fromObject(json);
                return dst;
            }
        }
        export type ISupport = Support;
    } // namespace stage


    // Defined in output.proto
    export namespace output {
        export enum BowImperfectionDirection {
            DIR_UNSPECIFIED = 0,
            DIR_X = 1,
            DIR_Y = 2,
            DIR_Z = 3
        }
        export const BowImperfectionDirection_FromObject = (src: unknown): BowImperfectionDirection => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'DIR_UNSPECIFIED':
                    return BowImperfectionDirection.DIR_UNSPECIFIED;
                case 1:
                case 'DIR_X':
                    return BowImperfectionDirection.DIR_X;
                case 2:
                case 'DIR_Y':
                    return BowImperfectionDirection.DIR_Y;
                case 3:
                case 'DIR_Z':
                    return BowImperfectionDirection.DIR_Z;
                default:
                    console.log('Unhandled value for BowImperfectionDirection:' + src + '. ' + typeof(src));
                    return BowImperfectionDirection.DIR_UNSPECIFIED;
            }
        };
        export const BowImperfectionDirection_ToObject = (src: BowImperfectionDirection): string | null => {
            switch (src) {
                case BowImperfectionDirection.DIR_UNSPECIFIED:
                    return 'DIR_UNSPECIFIED';
                case BowImperfectionDirection.DIR_X:
                    return 'DIR_X';
                case BowImperfectionDirection.DIR_Y:
                    return 'DIR_Y';
                case BowImperfectionDirection.DIR_Z:
                    return 'DIR_Z';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for BowImperfectionDirection, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Data_keys = 'lcombs' | 'rc' | 'steel' | 'timber' | 'foundation' | 'retainingWall' | 'pile' | 'carbon';
        export interface Data_createType {
            lcombs?: ng.output.LoadCombinationOutput[],
            rc?: ng.result.concrete.DesignSummary[],
            steel?: ng.result.steel.DesignSummary[],
            timber?: ng.result.timber.DesignSummary[],
            foundation?: ng.result.foundation.DesignSummary[],
            retainingWall?: ng.result.retaining_wall.DesignSummary[],
            pile?: ng.result.pile.DesignSummary[],
            carbon?: ng.environmental_parameters.ElementCarbonFootprint[],
        }
        export interface Data_json {
            lcombs: ng.output.LoadCombinationOutput_json[];
            rc: ng.result.concrete.DesignSummary_json[];
            steel: ng.result.steel.DesignSummary_json[];
            timber: ng.result.timber.DesignSummary_json[];
            foundation: ng.result.foundation.DesignSummary_json[];
            retainingWall: ng.result.retaining_wall.DesignSummary_json[];
            pile: ng.result.pile.DesignSummary_json[];
            carbon: ng.environmental_parameters.ElementCarbonFootprint_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            lcombs?: unknown;
            rc?: unknown;
            steel?: unknown;
            timber?: unknown;
            foundation?: unknown;
            retainingWall?: unknown;
            pile?: unknown;
            carbon?: unknown;
        }
        export class Data {
            __proto_name = "ng.output.Data";
            lcombs: ng.output.LoadCombinationOutput[] = [];
            rc: ng.result.concrete.DesignSummary[] = [];
            steel: ng.result.steel.DesignSummary[] = [];
            timber: ng.result.timber.DesignSummary[] = [];
            foundation: ng.result.foundation.DesignSummary[] = [];
            retainingWall: ng.result.retaining_wall.DesignSummary[] = [];
            pile: ng.result.pile.DesignSummary[] = [];
            carbon: ng.environmental_parameters.ElementCarbonFootprint[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.lcombs !== undefined && src.lcombs !== null) {
                    if (Array.isArray(src.lcombs)) {
                        for (const element of src.lcombs) {
                            dst.lcombs.push(ng.output.LoadCombinationOutput.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected lcombs of Data to be a array but was ', typeof src.lcombs, src.lcombs)
                    }
                }
                if (src.rc !== undefined && src.rc !== null) {
                    if (Array.isArray(src.rc)) {
                        for (const element of src.rc) {
                            dst.rc.push(ng.result.concrete.DesignSummary.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected rc of Data to be a array but was ', typeof src.rc, src.rc)
                    }
                }
                if (src.steel !== undefined && src.steel !== null) {
                    if (Array.isArray(src.steel)) {
                        for (const element of src.steel) {
                            dst.steel.push(ng.result.steel.DesignSummary.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected steel of Data to be a array but was ', typeof src.steel, src.steel)
                    }
                }
                if (src.timber !== undefined && src.timber !== null) {
                    if (Array.isArray(src.timber)) {
                        for (const element of src.timber) {
                            dst.timber.push(ng.result.timber.DesignSummary.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected timber of Data to be a array but was ', typeof src.timber, src.timber)
                    }
                }
                if (src.foundation !== undefined && src.foundation !== null) {
                    if (Array.isArray(src.foundation)) {
                        for (const element of src.foundation) {
                            dst.foundation.push(ng.result.foundation.DesignSummary.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected foundation of Data to be a array but was ', typeof src.foundation, src.foundation)
                    }
                }
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    if (Array.isArray(src.retainingWall)) {
                        for (const element of src.retainingWall) {
                            dst.retainingWall.push(ng.result.retaining_wall.DesignSummary.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected retainingWall of Data to be a array but was ', typeof src.retainingWall, src.retainingWall)
                    }
                }
                if (src.pile !== undefined && src.pile !== null) {
                    if (Array.isArray(src.pile)) {
                        for (const element of src.pile) {
                            dst.pile.push(ng.result.pile.DesignSummary.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected pile of Data to be a array but was ', typeof src.pile, src.pile)
                    }
                }
                if (src.carbon !== undefined && src.carbon !== null) {
                    if (Array.isArray(src.carbon)) {
                        for (const element of src.carbon) {
                            dst.carbon.push(ng.environmental_parameters.ElementCarbonFootprint.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected carbon of Data to be a array but was ', typeof src.carbon, src.carbon)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.output.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.output.Data") {
                    console.error('Expected ng.output.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    lcombs: new Array<ng.output.LoadCombinationOutput_json>(),
                    rc: new Array<ng.result.concrete.DesignSummary_json>(),
                    steel: new Array<ng.result.steel.DesignSummary_json>(),
                    timber: new Array<ng.result.timber.DesignSummary_json>(),
                    foundation: new Array<ng.result.foundation.DesignSummary_json>(),
                    retainingWall: new Array<ng.result.retaining_wall.DesignSummary_json>(),
                    pile: new Array<ng.result.pile.DesignSummary_json>(),
                    carbon: new Array<ng.environmental_parameters.ElementCarbonFootprint_json>(),
                };
                if (src.lcombs !== null) {
                    for (const element of src.lcombs) {
                        const parsed = ng.output.LoadCombinationOutput.toObject(element);
                        if(parsed === null) return null;
                        dst.lcombs.push(parsed);
                    }
                }
                if (src.rc !== null) {
                    for (const element of src.rc) {
                        const parsed = ng.result.concrete.DesignSummary.toObject(element);
                        if(parsed === null) return null;
                        dst.rc.push(parsed);
                    }
                }
                if (src.steel !== null) {
                    for (const element of src.steel) {
                        const parsed = ng.result.steel.DesignSummary.toObject(element);
                        if(parsed === null) return null;
                        dst.steel.push(parsed);
                    }
                }
                if (src.timber !== null) {
                    for (const element of src.timber) {
                        const parsed = ng.result.timber.DesignSummary.toObject(element);
                        if(parsed === null) return null;
                        dst.timber.push(parsed);
                    }
                }
                if (src.foundation !== null) {
                    for (const element of src.foundation) {
                        const parsed = ng.result.foundation.DesignSummary.toObject(element);
                        if(parsed === null) return null;
                        dst.foundation.push(parsed);
                    }
                }
                if (src.retainingWall !== null) {
                    for (const element of src.retainingWall) {
                        const parsed = ng.result.retaining_wall.DesignSummary.toObject(element);
                        if(parsed === null) return null;
                        dst.retainingWall.push(parsed);
                    }
                }
                if (src.pile !== null) {
                    for (const element of src.pile) {
                        const parsed = ng.result.pile.DesignSummary.toObject(element);
                        if(parsed === null) return null;
                        dst.pile.push(parsed);
                    }
                }
                if (src.carbon !== null) {
                    for (const element of src.carbon) {
                        const parsed = ng.environmental_parameters.ElementCarbonFootprint.toObject(element);
                        if(parsed === null) return null;
                        dst.carbon.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.lcombs !== undefined) {
                    dst.lcombs = src.lcombs;
                }
                if (src.rc !== undefined) {
                    dst.rc = src.rc;
                }
                if (src.steel !== undefined) {
                    dst.steel = src.steel;
                }
                if (src.timber !== undefined) {
                    dst.timber = src.timber;
                }
                if (src.foundation !== undefined) {
                    dst.foundation = src.foundation;
                }
                if (src.retainingWall !== undefined) {
                    dst.retainingWall = src.retainingWall;
                }
                if (src.pile !== undefined) {
                    dst.pile = src.pile;
                }
                if (src.carbon !== undefined) {
                    dst.carbon = src.carbon;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.lcombs = this.lcombs;
                dst.rc = this.rc;
                dst.steel = this.steel;
                dst.timber = this.timber;
                dst.foundation = this.foundation;
                dst.retainingWall = this.retainingWall;
                dst.pile = this.pile;
                dst.carbon = this.carbon;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;


        export type LoadCombinationOutput_keys = 'lcombGuid' | 'supportResults' | 'elementResults' | 'dirForBowImp' | 'interactionDiagrams';
        export interface LoadCombinationOutput_createType {
            lcombGuid?: string,
            supportResults?: ng.output.SupportResult[],
            elementResults?: ng.output.ElementResult[],
            dirForBowImp?: ng.output.BowImperfectionDirection,
            interactionDiagrams?: ng.result.interaction_diagram.Result[],
        }
        export interface LoadCombinationOutput_json {
            lcombGuid?: string;
            supportResults: ng.output.SupportResult_json[];
            elementResults: ng.output.ElementResult_json[];
            dirForBowImp?: string;
            interactionDiagrams: ng.result.interaction_diagram.Result_json[];
        }
        interface LoadCombinationOutput_json_in {
            __proto_name?: unknown;
            lcombGuid?: unknown;
            supportResults?: unknown;
            elementResults?: unknown;
            dirForBowImp?: unknown;
            interactionDiagrams?: unknown;
        }
        export class LoadCombinationOutput {
            __proto_name = "ng.output.LoadCombinationOutput";
            lcombGuid: string = "";
            supportResults: ng.output.SupportResult[] = [];
            elementResults: ng.output.ElementResult[] = [];
            dirForBowImp: ng.output.BowImperfectionDirection = ng.output.BowImperfectionDirection.DIR_UNSPECIFIED;
            interactionDiagrams: ng.result.interaction_diagram.Result[] = [];

            static fromObject(src_unknown: unknown): LoadCombinationOutput {
                const dst = new LoadCombinationOutput();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LoadCombinationOutput but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LoadCombinationOutput_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LoadCombinationOutput but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.lcombGuid !== undefined && src.lcombGuid !== null) {
                    if (typeof src.lcombGuid === "string") {
                        dst.lcombGuid = src.lcombGuid;
                    }
                    else {
                        console.log('Expected lcombGuid of LoadCombinationOutput to be a string but was ', typeof src.lcombGuid, src.lcombGuid)
                    }
                }
                if (src.supportResults !== undefined && src.supportResults !== null) {
                    if (Array.isArray(src.supportResults)) {
                        for (const element of src.supportResults) {
                            dst.supportResults.push(ng.output.SupportResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected supportResults of LoadCombinationOutput to be a array but was ', typeof src.supportResults, src.supportResults)
                    }
                }
                if (src.elementResults !== undefined && src.elementResults !== null) {
                    if (Array.isArray(src.elementResults)) {
                        for (const element of src.elementResults) {
                            dst.elementResults.push(ng.output.ElementResult.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected elementResults of LoadCombinationOutput to be a array but was ', typeof src.elementResults, src.elementResults)
                    }
                }
                if (src.dirForBowImp !== undefined && src.dirForBowImp !== null) {
                    dst.dirForBowImp = ng.output.BowImperfectionDirection_FromObject(src.dirForBowImp);
                }
                if (src.interactionDiagrams !== undefined && src.interactionDiagrams !== null) {
                    if (Array.isArray(src.interactionDiagrams)) {
                        for (const element of src.interactionDiagrams) {
                            dst.interactionDiagrams.push(ng.result.interaction_diagram.Result.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected interactionDiagrams of LoadCombinationOutput to be a array but was ', typeof src.interactionDiagrams, src.interactionDiagrams)
                    }
                }
                return dst;
            }

            static toObject(src: LoadCombinationOutput | null | undefined): LoadCombinationOutput_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.output.LoadCombinationOutput is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.output.LoadCombinationOutput") {
                    console.error('Expected ng.output.LoadCombinationOutput but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dirForBowImp_obj = ng.output.BowImperfectionDirection_ToObject(src.dirForBowImp);
                if(dirForBowImp_obj === null) return null;

                const dst : LoadCombinationOutput_json = {
                    lcombGuid: src.lcombGuid,
                    supportResults: new Array<ng.output.SupportResult_json>(),
                    elementResults: new Array<ng.output.ElementResult_json>(),
                    dirForBowImp: dirForBowImp_obj,
                    interactionDiagrams: new Array<ng.result.interaction_diagram.Result_json>(),
                };
                if (src.supportResults !== null) {
                    for (const element of src.supportResults) {
                        const parsed = ng.output.SupportResult.toObject(element);
                        if(parsed === null) return null;
                        dst.supportResults.push(parsed);
                    }
                }
                if (src.elementResults !== null) {
                    for (const element of src.elementResults) {
                        const parsed = ng.output.ElementResult.toObject(element);
                        if(parsed === null) return null;
                        dst.elementResults.push(parsed);
                    }
                }
                if (src.interactionDiagrams !== null) {
                    for (const element of src.interactionDiagrams) {
                        const parsed = ng.result.interaction_diagram.Result.toObject(element);
                        if(parsed === null) return null;
                        dst.interactionDiagrams.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: LoadCombinationOutput_createType) {
                const dst = new LoadCombinationOutput();
                if (src === undefined) {
                    return dst;
                }
                if (src.lcombGuid !== undefined) {
                    dst.lcombGuid = src.lcombGuid;
                }
                if (src.supportResults !== undefined) {
                    dst.supportResults = src.supportResults;
                }
                if (src.elementResults !== undefined) {
                    dst.elementResults = src.elementResults;
                }
                if (src.dirForBowImp !== undefined) {
                    dst.dirForBowImp = src.dirForBowImp;
                }
                if (src.interactionDiagrams !== undefined) {
                    dst.interactionDiagrams = src.interactionDiagrams;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LoadCombinationOutput();
                dst.lcombGuid = this.lcombGuid;
                dst.supportResults = this.supportResults;
                dst.elementResults = this.elementResults;
                dst.dirForBowImp = this.dirForBowImp;
                dst.interactionDiagrams = this.interactionDiagrams;
                return dst;
            }

            deepClone() {
                const json = LoadCombinationOutput.toObject(this);
                const dst = LoadCombinationOutput.fromObject(json);
                return dst;
            }
        }
        export type ILoadCombinationOutput = LoadCombinationOutput;


        export type SupportResult_keys = 'supGuid' | 'result';
        export interface SupportResult_createType {
            supGuid?: string,
            result?: ng.result.Node | null,
        }
        export interface SupportResult_json {
            supGuid?: string;
            result?: ng.result.Node_json;
        }
        interface SupportResult_json_in {
            __proto_name?: unknown;
            supGuid?: unknown;
            result?: unknown;
        }
        export class SupportResult {
            __proto_name = "ng.output.SupportResult";
            supGuid: string = "";
            result: ng.result.Node | null = null;

            static fromObject(src_unknown: unknown): SupportResult {
                const dst = new SupportResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SupportResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SupportResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SupportResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.supGuid !== undefined && src.supGuid !== null) {
                    if (typeof src.supGuid === "string") {
                        dst.supGuid = src.supGuid;
                    }
                    else {
                        console.log('Expected supGuid of SupportResult to be a string but was ', typeof src.supGuid, src.supGuid)
                    }
                }
                if (src.result !== undefined && src.result !== null) {
                    dst.result = ng.result.Node.fromObject(src.result);
                }
                return dst;
            }

            static toObject(src: SupportResult | null | undefined): SupportResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.output.SupportResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.output.SupportResult") {
                    console.error('Expected ng.output.SupportResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SupportResult_json = {
                    supGuid: src.supGuid,
                };
                if(src.result !== null)
                {
                    const parsed = ng.result.Node.toObject(src.result);
                    if(parsed === null) return null;
                    dst.result = parsed;
                }
                return dst;
            }

            static create(src?: SupportResult_createType) {
                const dst = new SupportResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.supGuid !== undefined) {
                    dst.supGuid = src.supGuid;
                }
                if (src.result !== undefined) {
                    dst.result = src.result;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SupportResult();
                dst.supGuid = this.supGuid;
                dst.result = this.result;
                return dst;
            }

            deepClone() {
                const json = SupportResult.toObject(this);
                const dst = SupportResult.fromObject(json);
                return dst;
            }
        }
        export type ISupportResult = SupportResult;


        export type ElementResult_keys = 'elemGuid' | 'result';
        export interface ElementResult_createType {
            elemGuid?: string,
            result?: ng.result.Element | null,
        }
        export interface ElementResult_json {
            elemGuid?: string;
            result?: ng.result.Element_json;
        }
        interface ElementResult_json_in {
            __proto_name?: unknown;
            elemGuid?: unknown;
            result?: unknown;
        }
        export class ElementResult {
            __proto_name = "ng.output.ElementResult";
            elemGuid: string = "";
            result: ng.result.Element | null = null;

            static fromObject(src_unknown: unknown): ElementResult {
                const dst = new ElementResult();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ElementResult but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ElementResult_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ElementResult but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.elemGuid !== undefined && src.elemGuid !== null) {
                    if (typeof src.elemGuid === "string") {
                        dst.elemGuid = src.elemGuid;
                    }
                    else {
                        console.log('Expected elemGuid of ElementResult to be a string but was ', typeof src.elemGuid, src.elemGuid)
                    }
                }
                if (src.result !== undefined && src.result !== null) {
                    dst.result = ng.result.Element.fromObject(src.result);
                }
                return dst;
            }

            static toObject(src: ElementResult | null | undefined): ElementResult_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.output.ElementResult is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.output.ElementResult") {
                    console.error('Expected ng.output.ElementResult but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ElementResult_json = {
                    elemGuid: src.elemGuid,
                };
                if(src.result !== null)
                {
                    const parsed = ng.result.Element.toObject(src.result);
                    if(parsed === null) return null;
                    dst.result = parsed;
                }
                return dst;
            }

            static create(src?: ElementResult_createType) {
                const dst = new ElementResult();
                if (src === undefined) {
                    return dst;
                }
                if (src.elemGuid !== undefined) {
                    dst.elemGuid = src.elemGuid;
                }
                if (src.result !== undefined) {
                    dst.result = src.result;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ElementResult();
                dst.elemGuid = this.elemGuid;
                dst.result = this.result;
                return dst;
            }

            deepClone() {
                const json = ElementResult.toObject(this);
                const dst = ElementResult.fromObject(json);
                return dst;
            }
        }
        export type IElementResult = ElementResult;
    } // namespace output


    // Defined in element.proto
    export namespace element {
        export enum InspectionLevel {
            INSPECTION_LEVEL_UNSPECIFIED = 0,
            INSPECTION_LEVEL_RELAXED = 1,
            INSPECTION_LEVEL_NORMAL = 2,
            INSPECTION_LEVEL_TIGHTENED = 3
        }
        export const InspectionLevel_FromObject = (src: unknown): InspectionLevel => {
            if (typeof src == 'string') { src = src.trim(); }
            switch (src) {
                case 0:
                case 'INSPECTION_LEVEL_UNSPECIFIED':
                    return InspectionLevel.INSPECTION_LEVEL_UNSPECIFIED;
                case 1:
                case 'INSPECTION_LEVEL_RELAXED':
                    return InspectionLevel.INSPECTION_LEVEL_RELAXED;
                case 2:
                case 'INSPECTION_LEVEL_NORMAL':
                    return InspectionLevel.INSPECTION_LEVEL_NORMAL;
                case 3:
                case 'INSPECTION_LEVEL_TIGHTENED':
                    return InspectionLevel.INSPECTION_LEVEL_TIGHTENED;
                default:
                    console.log('Unhandled value for InspectionLevel:' + src + '. ' + typeof(src));
                    return InspectionLevel.INSPECTION_LEVEL_UNSPECIFIED;
            }
        };
        export const InspectionLevel_ToObject = (src: InspectionLevel): string | null => {
            switch (src) {
                case InspectionLevel.INSPECTION_LEVEL_UNSPECIFIED:
                    return 'INSPECTION_LEVEL_UNSPECIFIED';
                case InspectionLevel.INSPECTION_LEVEL_RELAXED:
                    return 'INSPECTION_LEVEL_RELAXED';
                case InspectionLevel.INSPECTION_LEVEL_NORMAL:
                    return 'INSPECTION_LEVEL_NORMAL';
                case InspectionLevel.INSPECTION_LEVEL_TIGHTENED:
                    return 'INSPECTION_LEVEL_TIGHTENED';
                default:
                    console.error(`BUG TYPE ERROR: Expected enum for InspectionLevel, but got [${src}] a ${typeof src}!!!!`);
                    return null;
            }
        };


        export type Data_keys = 'id' | 'beam' | 'foundation' | 'retainingWall' | 'pile' | 'inspectionLevel' | 'critical' | 'designSettings' | 'performControlOnly';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            beam?: ng.beam.Data | null,
            foundation?: ng.foundation.Data | null,
            retainingWall?: ng.retaining_wall.Data | null,
            pile?: ng.pile.Data | null,
            inspectionLevel?: ng.element.InspectionLevel,
            critical?: boolean,
            designSettings?: ng.design.ElementDesignSettings | null,
            performControlOnly?: boolean,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            beam?: ng.beam.Data_json;
            foundation?: ng.foundation.Data_json;
            retainingWall?: ng.retaining_wall.Data_json;
            pile?: ng.pile.Data_json;
            inspectionLevel?: string;
            critical?: boolean;
            designSettings?: ng.design.ElementDesignSettings_json;
            performControlOnly?: boolean;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            beam?: unknown;
            foundation?: unknown;
            retainingWall?: unknown;
            pile?: unknown;
            inspectionLevel?: unknown;
            critical?: unknown;
            designSettings?: unknown;
            performControlOnly?: unknown;
        }
        export class Data {
            __proto_name = "ng.element.Data";
            id: ng.utils.ID | null = null;
            // this is a one of
            element: {type: 'beam'; beam: ng.beam.Data} | {type: 'foundation'; foundation: ng.foundation.Data} | {type: 'retainingWall'; retainingWall: ng.retaining_wall.Data} | {type: 'pile'; pile: ng.pile.Data} | null = null;
            inspectionLevel: ng.element.InspectionLevel = ng.element.InspectionLevel.INSPECTION_LEVEL_UNSPECIFIED;
            critical: boolean = false;
            designSettings: ng.design.ElementDesignSettings | null = null;
            performControlOnly: boolean = false;

            /** Gets the `Beam` value (or null) from the oneof `element` */
            getBeam(): ng.beam.Data | null {
                if(this.element === null) return null;
                if(this.element.type !== 'beam') return null;
                return this.element.beam;
            }

            /** Sets the `Beam` value for the oneof `element`*/
            setBeam(value: ng.beam.Data | null) {
                if(value !== null) {
                    this.element = {type: 'beam', beam:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Foundation` value (or null) from the oneof `element` */
            getFoundation(): ng.foundation.Data | null {
                if(this.element === null) return null;
                if(this.element.type !== 'foundation') return null;
                return this.element.foundation;
            }

            /** Sets the `Foundation` value for the oneof `element`*/
            setFoundation(value: ng.foundation.Data | null) {
                if(value !== null) {
                    this.element = {type: 'foundation', foundation:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `RetainingWall` value (or null) from the oneof `element` */
            getRetainingWall(): ng.retaining_wall.Data | null {
                if(this.element === null) return null;
                if(this.element.type !== 'retainingWall') return null;
                return this.element.retainingWall;
            }

            /** Sets the `RetainingWall` value for the oneof `element`*/
            setRetainingWall(value: ng.retaining_wall.Data | null) {
                if(value !== null) {
                    this.element = {type: 'retainingWall', retainingWall:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Pile` value (or null) from the oneof `element` */
            getPile(): ng.pile.Data | null {
                if(this.element === null) return null;
                if(this.element.type !== 'pile') return null;
                return this.element.pile;
            }

            /** Sets the `Pile` value for the oneof `element`*/
            setPile(value: ng.pile.Data | null) {
                if(value !== null) {
                    this.element = {type: 'pile', pile:value};
                }
                else {
                    this.element = null;
                }
            }

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.beam !== undefined && src.beam !== null) {
                    dst.setBeam(ng.beam.Data.fromObject(src.beam));
                }
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(ng.foundation.Data.fromObject(src.foundation));
                }
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(ng.retaining_wall.Data.fromObject(src.retainingWall));
                }
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(ng.pile.Data.fromObject(src.pile));
                }
                if (src.inspectionLevel !== undefined && src.inspectionLevel !== null) {
                    dst.inspectionLevel = ng.element.InspectionLevel_FromObject(src.inspectionLevel);
                }
                if (src.critical !== undefined && src.critical !== null) {
                    if (typeof src.critical === "boolean") {
                        dst.critical = src.critical;
                    }
                    else {
                        console.log('Expected critical of Data to be a boolean but was ', typeof src.critical, src.critical)
                    }
                }
                if (src.designSettings !== undefined && src.designSettings !== null) {
                    dst.designSettings = ng.design.ElementDesignSettings.fromObject(src.designSettings);
                }
                if (src.performControlOnly !== undefined && src.performControlOnly !== null) {
                    if (typeof src.performControlOnly === "boolean") {
                        dst.performControlOnly = src.performControlOnly;
                    }
                    else {
                        console.log('Expected performControlOnly of Data to be a boolean but was ', typeof src.performControlOnly, src.performControlOnly)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.element.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.element.Data") {
                    console.error('Expected ng.element.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const inspectionLevel_obj = ng.element.InspectionLevel_ToObject(src.inspectionLevel);
                if(inspectionLevel_obj === null) return null;

                const dst : Data_json = {
                    inspectionLevel: inspectionLevel_obj,
                    critical: src.critical,
                    performControlOnly: src.performControlOnly,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const beam = src.getBeam();
                if(beam !== null)
                {
                    const parsed = ng.beam.Data.toObject(beam);
                    if(parsed === null) return null;
                    dst.beam = parsed;
                }
                const foundation = src.getFoundation();
                if(foundation !== null)
                {
                    const parsed = ng.foundation.Data.toObject(foundation);
                    if(parsed === null) return null;
                    dst.foundation = parsed;
                }
                const retainingWall = src.getRetainingWall();
                if(retainingWall !== null)
                {
                    const parsed = ng.retaining_wall.Data.toObject(retainingWall);
                    if(parsed === null) return null;
                    dst.retainingWall = parsed;
                }
                const pile = src.getPile();
                if(pile !== null)
                {
                    const parsed = ng.pile.Data.toObject(pile);
                    if(parsed === null) return null;
                    dst.pile = parsed;
                }
                if(src.designSettings !== null)
                {
                    const parsed = ng.design.ElementDesignSettings.toObject(src.designSettings);
                    if(parsed === null) return null;
                    dst.designSettings = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                // part of the element oneof 
                if (src.beam !== undefined && src.beam !== null) {
                    dst.setBeam(src.beam);
                }
                // part of the element oneof 
                if (src.foundation !== undefined && src.foundation !== null) {
                    dst.setFoundation(src.foundation);
                }
                // part of the element oneof 
                if (src.retainingWall !== undefined && src.retainingWall !== null) {
                    dst.setRetainingWall(src.retainingWall);
                }
                // part of the element oneof 
                if (src.pile !== undefined && src.pile !== null) {
                    dst.setPile(src.pile);
                }
                if (src.inspectionLevel !== undefined) {
                    dst.inspectionLevel = src.inspectionLevel;
                }
                if (src.critical !== undefined) {
                    dst.critical = src.critical;
                }
                if (src.designSettings !== undefined) {
                    dst.designSettings = src.designSettings;
                }
                if (src.performControlOnly !== undefined) {
                    dst.performControlOnly = src.performControlOnly;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.element = this.element;
                dst.inspectionLevel = this.inspectionLevel;
                dst.critical = this.critical;
                dst.designSettings = this.designSettings;
                dst.performControlOnly = this.performControlOnly;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace element


    // Defined in Utils/asset_database.proto
    export namespace assets {
        export type MaterialDbRecord_keys = 'guid' | 'eTag' | 'majorVersion' | 'minorVersion' | 'patchVersion' | 'ownerType' | 'ownerName' | 'id' | 'annex' | 'name' | 'type' | 'data' | 'conProduct' | 'steelProduct' | 'timberProduct' | 'soilProduct' | 'masonryProduct' | 'customProduct';
        export interface MaterialDbRecord_createType {
            guid?: string,
            eTag?: string,
            majorVersion?: number,
            minorVersion?: number,
            patchVersion?: number,
            ownerType?: ng.utils.Owner,
            ownerName?: string,
            id?: number,
            annex?: ng.eurocode.Annex,
            name?: string,
            type?: ng.material.Mtrl,
            data?: ng.material.Data | null,
            conProduct?: ng.material.concrete.Type,
            steelProduct?: ng.material.steel.Product,
            timberProduct?: ng.material.timber.ProductType,
            soilProduct?: ng.material.soil.Behaviour,
            masonryProduct?: ng.material.masonry.Product,
            customProduct?: string,
        }
        export interface MaterialDbRecord_json {
            guid?: string;
            eTag?: string;
            majorVersion?: JsonNumber;
            minorVersion?: JsonNumber;
            patchVersion?: JsonNumber;
            ownerType?: string;
            ownerName?: string;
            id?: JsonNumber;
            annex?: string;
            name?: string;
            type?: string;
            data?: ng.material.Data_json;
            conProduct?: string;
            steelProduct?: string;
            timberProduct?: string;
            soilProduct?: string;
            masonryProduct?: string;
            customProduct?: string;
        }
        interface MaterialDbRecord_json_in {
            __proto_name?: unknown;
            guid?: unknown;
            eTag?: unknown;
            majorVersion?: unknown;
            minorVersion?: unknown;
            patchVersion?: unknown;
            ownerType?: unknown;
            ownerName?: unknown;
            id?: unknown;
            annex?: unknown;
            name?: unknown;
            type?: unknown;
            data?: unknown;
            conProduct?: unknown;
            steelProduct?: unknown;
            timberProduct?: unknown;
            soilProduct?: unknown;
            masonryProduct?: unknown;
            customProduct?: unknown;
        }
        export class MaterialDbRecord {
            __proto_name = "ng.assets.MaterialDbRecord";
            guid: string = "";
            eTag: string = "";
            majorVersion: number = 0;
            minorVersion: number = 0;
            patchVersion: number = 0;
            ownerType: ng.utils.Owner = ng.utils.Owner.OWNER_UNSPECIFIED;
            ownerName: string = "";
            id: number = 0;
            annex: ng.eurocode.Annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;
            name: string = "";
            type: ng.material.Mtrl = ng.material.Mtrl.MTRL_UNSPECIFIED;
            data: ng.material.Data | null = null;
            // this is a one of
            product: {type: 'conProduct'; conProduct: ng.material.concrete.Type} | {type: 'steelProduct'; steelProduct: ng.material.steel.Product} | {type: 'timberProduct'; timberProduct: ng.material.timber.ProductType} | {type: 'soilProduct'; soilProduct: ng.material.soil.Behaviour} | {type: 'masonryProduct'; masonryProduct: ng.material.masonry.Product} | {type: 'customProduct'; customProduct: string} | null = null;

            /** Gets the `ConProduct` value (or null) from the oneof `product` */
            getConProduct(): ng.material.concrete.Type | null {
                if(this.product === null) return null;
                if(this.product.type !== 'conProduct') return null;
                return this.product.conProduct;
            }

            /** Sets the `ConProduct` value for the oneof `product`*/
            setConProduct(value: ng.material.concrete.Type | null) {
                if(value !== null) {
                    this.product = {type: 'conProduct', conProduct:value};
                }
                else {
                    this.product = null;
                }
            }

            /** Gets the `SteelProduct` value (or null) from the oneof `product` */
            getSteelProduct(): ng.material.steel.Product | null {
                if(this.product === null) return null;
                if(this.product.type !== 'steelProduct') return null;
                return this.product.steelProduct;
            }

            /** Sets the `SteelProduct` value for the oneof `product`*/
            setSteelProduct(value: ng.material.steel.Product | null) {
                if(value !== null) {
                    this.product = {type: 'steelProduct', steelProduct:value};
                }
                else {
                    this.product = null;
                }
            }

            /** Gets the `TimberProduct` value (or null) from the oneof `product` */
            getTimberProduct(): ng.material.timber.ProductType | null {
                if(this.product === null) return null;
                if(this.product.type !== 'timberProduct') return null;
                return this.product.timberProduct;
            }

            /** Sets the `TimberProduct` value for the oneof `product`*/
            setTimberProduct(value: ng.material.timber.ProductType | null) {
                if(value !== null) {
                    this.product = {type: 'timberProduct', timberProduct:value};
                }
                else {
                    this.product = null;
                }
            }

            /** Gets the `SoilProduct` value (or null) from the oneof `product` */
            getSoilProduct(): ng.material.soil.Behaviour | null {
                if(this.product === null) return null;
                if(this.product.type !== 'soilProduct') return null;
                return this.product.soilProduct;
            }

            /** Sets the `SoilProduct` value for the oneof `product`*/
            setSoilProduct(value: ng.material.soil.Behaviour | null) {
                if(value !== null) {
                    this.product = {type: 'soilProduct', soilProduct:value};
                }
                else {
                    this.product = null;
                }
            }

            /** Gets the `MasonryProduct` value (or null) from the oneof `product` */
            getMasonryProduct(): ng.material.masonry.Product | null {
                if(this.product === null) return null;
                if(this.product.type !== 'masonryProduct') return null;
                return this.product.masonryProduct;
            }

            /** Sets the `MasonryProduct` value for the oneof `product`*/
            setMasonryProduct(value: ng.material.masonry.Product | null) {
                if(value !== null) {
                    this.product = {type: 'masonryProduct', masonryProduct:value};
                }
                else {
                    this.product = null;
                }
            }

            /** Gets the `CustomProduct` value (or null) from the oneof `product` */
            getCustomProduct(): string | null {
                if(this.product === null) return null;
                if(this.product.type !== 'customProduct') return null;
                return this.product.customProduct;
            }

            /** Sets the `CustomProduct` value for the oneof `product`*/
            setCustomProduct(value: string | null) {
                if(value !== null) {
                    this.product = {type: 'customProduct', customProduct:value};
                }
                else {
                    this.product = null;
                }
            }

            static fromObject(src_unknown: unknown): MaterialDbRecord {
                const dst = new MaterialDbRecord();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted MaterialDbRecord but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as MaterialDbRecord_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for MaterialDbRecord but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.guid !== undefined && src.guid !== null) {
                    if (typeof src.guid === "string") {
                        dst.guid = src.guid;
                    }
                    else {
                        console.log('Expected guid of MaterialDbRecord to be a string but was ', typeof src.guid, src.guid)
                    }
                }
                if (src.eTag !== undefined && src.eTag !== null) {
                    if (typeof src.eTag === "string") {
                        dst.eTag = src.eTag;
                    }
                    else {
                        console.log('Expected eTag of MaterialDbRecord to be a string but was ', typeof src.eTag, src.eTag)
                    }
                }
                if (src.majorVersion !== undefined && src.majorVersion !== null) {
                    if (typeof src.majorVersion === "number" || src.majorVersion === 'NaN' || src.majorVersion === 'Infinity' || src.majorVersion === '-Infinity') {
                        dst.majorVersion = NumberToInt("ng.assets.MaterialDbRecord.major_version", AsNum(src.majorVersion));
                    }
                    else {
                        console.log('Expected majorVersion of MaterialDbRecord to be a number but was ', typeof src.majorVersion, src.majorVersion)
                    }
                }
                if (src.minorVersion !== undefined && src.minorVersion !== null) {
                    if (typeof src.minorVersion === "number" || src.minorVersion === 'NaN' || src.minorVersion === 'Infinity' || src.minorVersion === '-Infinity') {
                        dst.minorVersion = NumberToInt("ng.assets.MaterialDbRecord.minor_version", AsNum(src.minorVersion));
                    }
                    else {
                        console.log('Expected minorVersion of MaterialDbRecord to be a number but was ', typeof src.minorVersion, src.minorVersion)
                    }
                }
                if (src.patchVersion !== undefined && src.patchVersion !== null) {
                    if (typeof src.patchVersion === "number" || src.patchVersion === 'NaN' || src.patchVersion === 'Infinity' || src.patchVersion === '-Infinity') {
                        dst.patchVersion = NumberToInt("ng.assets.MaterialDbRecord.patch_version", AsNum(src.patchVersion));
                    }
                    else {
                        console.log('Expected patchVersion of MaterialDbRecord to be a number but was ', typeof src.patchVersion, src.patchVersion)
                    }
                }
                if (src.ownerType !== undefined && src.ownerType !== null) {
                    dst.ownerType = ng.utils.Owner_FromObject(src.ownerType);
                }
                if (src.ownerName !== undefined && src.ownerName !== null) {
                    if (typeof src.ownerName === "string") {
                        dst.ownerName = src.ownerName;
                    }
                    else {
                        console.log('Expected ownerName of MaterialDbRecord to be a string but was ', typeof src.ownerName, src.ownerName)
                    }
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "number" || src.id === 'NaN' || src.id === 'Infinity' || src.id === '-Infinity') {
                        dst.id = NumberToInt("ng.assets.MaterialDbRecord.id", AsNum(src.id));
                    }
                    else {
                        console.log('Expected id of MaterialDbRecord to be a number but was ', typeof src.id, src.id)
                    }
                }
                if (src.annex !== undefined && src.annex !== null) {
                    dst.annex = ng.eurocode.Annex_FromObject(src.annex);
                }
                if (src.name !== undefined && src.name !== null) {
                    if (typeof src.name === "string") {
                        dst.name = src.name;
                    }
                    else {
                        console.log('Expected name of MaterialDbRecord to be a string but was ', typeof src.name, src.name)
                    }
                }
                if (src.type !== undefined && src.type !== null) {
                    dst.type = ng.material.Mtrl_FromObject(src.type);
                }
                if (src.data !== undefined && src.data !== null) {
                    dst.data = ng.material.Data.fromObject(src.data);
                }
                if (src.conProduct !== undefined && src.conProduct !== null) {
                    dst.setConProduct(ng.material.concrete.Type_FromObject(src.conProduct));
                }
                if (src.steelProduct !== undefined && src.steelProduct !== null) {
                    dst.setSteelProduct(ng.material.steel.Product_FromObject(src.steelProduct));
                }
                if (src.timberProduct !== undefined && src.timberProduct !== null) {
                    dst.setTimberProduct(ng.material.timber.ProductType_FromObject(src.timberProduct));
                }
                if (src.soilProduct !== undefined && src.soilProduct !== null) {
                    dst.setSoilProduct(ng.material.soil.Behaviour_FromObject(src.soilProduct));
                }
                if (src.masonryProduct !== undefined && src.masonryProduct !== null) {
                    dst.setMasonryProduct(ng.material.masonry.Product_FromObject(src.masonryProduct));
                }
                if (src.customProduct !== undefined && src.customProduct !== null) {
                    if (typeof src.customProduct === "string") {
                        dst.setCustomProduct(src.customProduct);
                    }
                    else {
                        console.log('Expected customProduct of MaterialDbRecord to be a string but was ', typeof src.customProduct, src.customProduct)
                    }
                }
                return dst;
            }

            static toObject(src: MaterialDbRecord | null | undefined): MaterialDbRecord_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.assets.MaterialDbRecord is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.assets.MaterialDbRecord") {
                    console.error('Expected ng.assets.MaterialDbRecord but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const ownerType_obj = ng.utils.Owner_ToObject(src.ownerType);
                if(ownerType_obj === null) return null;

                const annex_obj = ng.eurocode.Annex_ToObject(src.annex);
                if(annex_obj === null) return null;

                const type_obj = ng.material.Mtrl_ToObject(src.type);
                if(type_obj === null) return null;

                const dst : MaterialDbRecord_json = {
                    guid: src.guid,
                    eTag: src.eTag,
                    majorVersion: AsJsonNum(NumberToInt("ng.assets.MaterialDbRecord.major_version", src.majorVersion)),
                    minorVersion: AsJsonNum(NumberToInt("ng.assets.MaterialDbRecord.minor_version", src.minorVersion)),
                    patchVersion: AsJsonNum(NumberToInt("ng.assets.MaterialDbRecord.patch_version", src.patchVersion)),
                    ownerType: ownerType_obj,
                    ownerName: src.ownerName,
                    id: AsJsonNum(NumberToInt("ng.assets.MaterialDbRecord.id", src.id)),
                    annex: annex_obj,
                    name: src.name,
                    type: type_obj,
                };
                if(src.data !== null)
                {
                    const parsed = ng.material.Data.toObject(src.data);
                    if(parsed === null) return null;
                    dst.data = parsed;
                }
                const conProduct = src.getConProduct();
                if(conProduct !== null)
                {
                    const parsed = ng.material.concrete.Type_ToObject(conProduct);
                    if(parsed === null) return null;
                    dst.conProduct = parsed;
                }
                const steelProduct = src.getSteelProduct();
                if(steelProduct !== null)
                {
                    const parsed = ng.material.steel.Product_ToObject(steelProduct);
                    if(parsed === null) return null;
                    dst.steelProduct = parsed;
                }
                const timberProduct = src.getTimberProduct();
                if(timberProduct !== null)
                {
                    const parsed = ng.material.timber.ProductType_ToObject(timberProduct);
                    if(parsed === null) return null;
                    dst.timberProduct = parsed;
                }
                const soilProduct = src.getSoilProduct();
                if(soilProduct !== null)
                {
                    const parsed = ng.material.soil.Behaviour_ToObject(soilProduct);
                    if(parsed === null) return null;
                    dst.soilProduct = parsed;
                }
                const masonryProduct = src.getMasonryProduct();
                if(masonryProduct !== null)
                {
                    const parsed = ng.material.masonry.Product_ToObject(masonryProduct);
                    if(parsed === null) return null;
                    dst.masonryProduct = parsed;
                }
                const customProduct = src.getCustomProduct();
                if(customProduct !== null)
                {
                    const parsed = customProduct;
                    if(parsed === null) return null;
                    dst.customProduct = parsed;
                }
                return dst;
            }

            static create(src?: MaterialDbRecord_createType) {
                const dst = new MaterialDbRecord();
                if (src === undefined) {
                    return dst;
                }
                if (src.guid !== undefined) {
                    dst.guid = src.guid;
                }
                if (src.eTag !== undefined) {
                    dst.eTag = src.eTag;
                }
                if (src.majorVersion !== undefined) {
                    dst.majorVersion = src.majorVersion;
                }
                if (src.minorVersion !== undefined) {
                    dst.minorVersion = src.minorVersion;
                }
                if (src.patchVersion !== undefined) {
                    dst.patchVersion = src.patchVersion;
                }
                if (src.ownerType !== undefined) {
                    dst.ownerType = src.ownerType;
                }
                if (src.ownerName !== undefined) {
                    dst.ownerName = src.ownerName;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.annex !== undefined) {
                    dst.annex = src.annex;
                }
                if (src.name !== undefined) {
                    dst.name = src.name;
                }
                if (src.type !== undefined) {
                    dst.type = src.type;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                // part of the product oneof 
                if (src.conProduct !== undefined && src.conProduct !== null) {
                    dst.setConProduct(src.conProduct);
                }
                // part of the product oneof 
                if (src.steelProduct !== undefined && src.steelProduct !== null) {
                    dst.setSteelProduct(src.steelProduct);
                }
                // part of the product oneof 
                if (src.timberProduct !== undefined && src.timberProduct !== null) {
                    dst.setTimberProduct(src.timberProduct);
                }
                // part of the product oneof 
                if (src.soilProduct !== undefined && src.soilProduct !== null) {
                    dst.setSoilProduct(src.soilProduct);
                }
                // part of the product oneof 
                if (src.masonryProduct !== undefined && src.masonryProduct !== null) {
                    dst.setMasonryProduct(src.masonryProduct);
                }
                // part of the product oneof 
                if (src.customProduct !== undefined && src.customProduct !== null) {
                    dst.setCustomProduct(src.customProduct);
                }
                return dst;
            }

            shallowClone() {
                const dst = new MaterialDbRecord();
                dst.guid = this.guid;
                dst.eTag = this.eTag;
                dst.majorVersion = this.majorVersion;
                dst.minorVersion = this.minorVersion;
                dst.patchVersion = this.patchVersion;
                dst.ownerType = this.ownerType;
                dst.ownerName = this.ownerName;
                dst.id = this.id;
                dst.annex = this.annex;
                dst.name = this.name;
                dst.type = this.type;
                dst.data = this.data;
                dst.product = this.product;
                return dst;
            }

            deepClone() {
                const json = MaterialDbRecord.toObject(this);
                const dst = MaterialDbRecord.fromObject(json);
                return dst;
            }
        }
        export type IMaterialDbRecord = MaterialDbRecord;


        export type SectionDbRecord_keys = 'guid' | 'eTag' | 'majorVersion' | 'minorVersion' | 'patchVersion' | 'ownerType' | 'ownerName' | 'id' | 'annex' | 'name' | 'material' | 'family' | 'data';
        export interface SectionDbRecord_createType {
            guid?: string,
            eTag?: string,
            majorVersion?: number,
            minorVersion?: number,
            patchVersion?: number,
            ownerType?: ng.utils.Owner,
            ownerName?: string,
            id?: number,
            annex?: ng.eurocode.Annex,
            name?: string,
            material?: ng.sections.MaterialCategory,
            family?: ng.sections.SectionType,
            data?: ng.sections.Section | null,
        }
        export interface SectionDbRecord_json {
            guid?: string;
            eTag?: string;
            majorVersion?: JsonNumber;
            minorVersion?: JsonNumber;
            patchVersion?: JsonNumber;
            ownerType?: string;
            ownerName?: string;
            id?: JsonNumber;
            annex?: string;
            name?: string;
            material?: string;
            family?: string;
            data?: ng.sections.Section_json;
        }
        interface SectionDbRecord_json_in {
            __proto_name?: unknown;
            guid?: unknown;
            eTag?: unknown;
            majorVersion?: unknown;
            minorVersion?: unknown;
            patchVersion?: unknown;
            ownerType?: unknown;
            ownerName?: unknown;
            id?: unknown;
            annex?: unknown;
            name?: unknown;
            material?: unknown;
            family?: unknown;
            data?: unknown;
        }
        export class SectionDbRecord {
            __proto_name = "ng.assets.SectionDbRecord";
            guid: string = "";
            eTag: string = "";
            majorVersion: number = 0;
            minorVersion: number = 0;
            patchVersion: number = 0;
            ownerType: ng.utils.Owner = ng.utils.Owner.OWNER_UNSPECIFIED;
            ownerName: string = "";
            id: number = 0;
            annex: ng.eurocode.Annex = ng.eurocode.Annex.ANNEX_UNSPECIFIED;
            name: string = "";
            material: ng.sections.MaterialCategory = ng.sections.MaterialCategory.MATERIAL_CATEGORY_UNSPECIFIED;
            family: ng.sections.SectionType = ng.sections.SectionType.SECTION_TYPE_UNSPECIFIED;
            data: ng.sections.Section | null = null;

            static fromObject(src_unknown: unknown): SectionDbRecord {
                const dst = new SectionDbRecord();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SectionDbRecord but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SectionDbRecord_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SectionDbRecord but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.guid !== undefined && src.guid !== null) {
                    if (typeof src.guid === "string") {
                        dst.guid = src.guid;
                    }
                    else {
                        console.log('Expected guid of SectionDbRecord to be a string but was ', typeof src.guid, src.guid)
                    }
                }
                if (src.eTag !== undefined && src.eTag !== null) {
                    if (typeof src.eTag === "string") {
                        dst.eTag = src.eTag;
                    }
                    else {
                        console.log('Expected eTag of SectionDbRecord to be a string but was ', typeof src.eTag, src.eTag)
                    }
                }
                if (src.majorVersion !== undefined && src.majorVersion !== null) {
                    if (typeof src.majorVersion === "number" || src.majorVersion === 'NaN' || src.majorVersion === 'Infinity' || src.majorVersion === '-Infinity') {
                        dst.majorVersion = NumberToInt("ng.assets.SectionDbRecord.major_version", AsNum(src.majorVersion));
                    }
                    else {
                        console.log('Expected majorVersion of SectionDbRecord to be a number but was ', typeof src.majorVersion, src.majorVersion)
                    }
                }
                if (src.minorVersion !== undefined && src.minorVersion !== null) {
                    if (typeof src.minorVersion === "number" || src.minorVersion === 'NaN' || src.minorVersion === 'Infinity' || src.minorVersion === '-Infinity') {
                        dst.minorVersion = NumberToInt("ng.assets.SectionDbRecord.minor_version", AsNum(src.minorVersion));
                    }
                    else {
                        console.log('Expected minorVersion of SectionDbRecord to be a number but was ', typeof src.minorVersion, src.minorVersion)
                    }
                }
                if (src.patchVersion !== undefined && src.patchVersion !== null) {
                    if (typeof src.patchVersion === "number" || src.patchVersion === 'NaN' || src.patchVersion === 'Infinity' || src.patchVersion === '-Infinity') {
                        dst.patchVersion = NumberToInt("ng.assets.SectionDbRecord.patch_version", AsNum(src.patchVersion));
                    }
                    else {
                        console.log('Expected patchVersion of SectionDbRecord to be a number but was ', typeof src.patchVersion, src.patchVersion)
                    }
                }
                if (src.ownerType !== undefined && src.ownerType !== null) {
                    dst.ownerType = ng.utils.Owner_FromObject(src.ownerType);
                }
                if (src.ownerName !== undefined && src.ownerName !== null) {
                    if (typeof src.ownerName === "string") {
                        dst.ownerName = src.ownerName;
                    }
                    else {
                        console.log('Expected ownerName of SectionDbRecord to be a string but was ', typeof src.ownerName, src.ownerName)
                    }
                }
                if (src.id !== undefined && src.id !== null) {
                    if (typeof src.id === "number" || src.id === 'NaN' || src.id === 'Infinity' || src.id === '-Infinity') {
                        dst.id = NumberToInt("ng.assets.SectionDbRecord.id", AsNum(src.id));
                    }
                    else {
                        console.log('Expected id of SectionDbRecord to be a number but was ', typeof src.id, src.id)
                    }
                }
                if (src.annex !== undefined && src.annex !== null) {
                    dst.annex = ng.eurocode.Annex_FromObject(src.annex);
                }
                if (src.name !== undefined && src.name !== null) {
                    if (typeof src.name === "string") {
                        dst.name = src.name;
                    }
                    else {
                        console.log('Expected name of SectionDbRecord to be a string but was ', typeof src.name, src.name)
                    }
                }
                if (src.material !== undefined && src.material !== null) {
                    dst.material = ng.sections.MaterialCategory_FromObject(src.material);
                }
                if (src.family !== undefined && src.family !== null) {
                    dst.family = ng.sections.SectionType_FromObject(src.family);
                }
                if (src.data !== undefined && src.data !== null) {
                    dst.data = ng.sections.Section.fromObject(src.data);
                }
                return dst;
            }

            static toObject(src: SectionDbRecord | null | undefined): SectionDbRecord_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.assets.SectionDbRecord is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.assets.SectionDbRecord") {
                    console.error('Expected ng.assets.SectionDbRecord but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const ownerType_obj = ng.utils.Owner_ToObject(src.ownerType);
                if(ownerType_obj === null) return null;

                const annex_obj = ng.eurocode.Annex_ToObject(src.annex);
                if(annex_obj === null) return null;

                const material_obj = ng.sections.MaterialCategory_ToObject(src.material);
                if(material_obj === null) return null;

                const family_obj = ng.sections.SectionType_ToObject(src.family);
                if(family_obj === null) return null;

                const dst : SectionDbRecord_json = {
                    guid: src.guid,
                    eTag: src.eTag,
                    majorVersion: AsJsonNum(NumberToInt("ng.assets.SectionDbRecord.major_version", src.majorVersion)),
                    minorVersion: AsJsonNum(NumberToInt("ng.assets.SectionDbRecord.minor_version", src.minorVersion)),
                    patchVersion: AsJsonNum(NumberToInt("ng.assets.SectionDbRecord.patch_version", src.patchVersion)),
                    ownerType: ownerType_obj,
                    ownerName: src.ownerName,
                    id: AsJsonNum(NumberToInt("ng.assets.SectionDbRecord.id", src.id)),
                    annex: annex_obj,
                    name: src.name,
                    material: material_obj,
                    family: family_obj,
                };
                if(src.data !== null)
                {
                    const parsed = ng.sections.Section.toObject(src.data);
                    if(parsed === null) return null;
                    dst.data = parsed;
                }
                return dst;
            }

            static create(src?: SectionDbRecord_createType) {
                const dst = new SectionDbRecord();
                if (src === undefined) {
                    return dst;
                }
                if (src.guid !== undefined) {
                    dst.guid = src.guid;
                }
                if (src.eTag !== undefined) {
                    dst.eTag = src.eTag;
                }
                if (src.majorVersion !== undefined) {
                    dst.majorVersion = src.majorVersion;
                }
                if (src.minorVersion !== undefined) {
                    dst.minorVersion = src.minorVersion;
                }
                if (src.patchVersion !== undefined) {
                    dst.patchVersion = src.patchVersion;
                }
                if (src.ownerType !== undefined) {
                    dst.ownerType = src.ownerType;
                }
                if (src.ownerName !== undefined) {
                    dst.ownerName = src.ownerName;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.annex !== undefined) {
                    dst.annex = src.annex;
                }
                if (src.name !== undefined) {
                    dst.name = src.name;
                }
                if (src.material !== undefined) {
                    dst.material = src.material;
                }
                if (src.family !== undefined) {
                    dst.family = src.family;
                }
                if (src.data !== undefined) {
                    dst.data = src.data;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SectionDbRecord();
                dst.guid = this.guid;
                dst.eTag = this.eTag;
                dst.majorVersion = this.majorVersion;
                dst.minorVersion = this.minorVersion;
                dst.patchVersion = this.patchVersion;
                dst.ownerType = this.ownerType;
                dst.ownerName = this.ownerName;
                dst.id = this.id;
                dst.annex = this.annex;
                dst.name = this.name;
                dst.material = this.material;
                dst.family = this.family;
                dst.data = this.data;
                return dst;
            }

            deepClone() {
                const json = SectionDbRecord.toObject(this);
                const dst = SectionDbRecord.fromObject(json);
                return dst;
            }
        }
        export type ISectionDbRecord = SectionDbRecord;


        export type MaterialDbRecordList_keys = 'materials';
        export interface MaterialDbRecordList_createType {
            materials?: ng.assets.MaterialDbRecord[],
        }
        export interface MaterialDbRecordList_json {
            materials: ng.assets.MaterialDbRecord_json[];
        }
        interface MaterialDbRecordList_json_in {
            __proto_name?: unknown;
            materials?: unknown;
        }
        export class MaterialDbRecordList {
            __proto_name = "ng.assets.MaterialDbRecordList";
            materials: ng.assets.MaterialDbRecord[] = [];

            static fromObject(src_unknown: unknown): MaterialDbRecordList {
                const dst = new MaterialDbRecordList();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted MaterialDbRecordList but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as MaterialDbRecordList_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for MaterialDbRecordList but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.materials !== undefined && src.materials !== null) {
                    if (Array.isArray(src.materials)) {
                        for (const element of src.materials) {
                            dst.materials.push(ng.assets.MaterialDbRecord.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected materials of MaterialDbRecordList to be a array but was ', typeof src.materials, src.materials)
                    }
                }
                return dst;
            }

            static toObject(src: MaterialDbRecordList | null | undefined): MaterialDbRecordList_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.assets.MaterialDbRecordList is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.assets.MaterialDbRecordList") {
                    console.error('Expected ng.assets.MaterialDbRecordList but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : MaterialDbRecordList_json = {
                    materials: new Array<ng.assets.MaterialDbRecord_json>(),
                };
                if (src.materials !== null) {
                    for (const element of src.materials) {
                        const parsed = ng.assets.MaterialDbRecord.toObject(element);
                        if(parsed === null) return null;
                        dst.materials.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: MaterialDbRecordList_createType) {
                const dst = new MaterialDbRecordList();
                if (src === undefined) {
                    return dst;
                }
                if (src.materials !== undefined) {
                    dst.materials = src.materials;
                }
                return dst;
            }

            shallowClone() {
                const dst = new MaterialDbRecordList();
                dst.materials = this.materials;
                return dst;
            }

            deepClone() {
                const json = MaterialDbRecordList.toObject(this);
                const dst = MaterialDbRecordList.fromObject(json);
                return dst;
            }
        }
        export type IMaterialDbRecordList = MaterialDbRecordList;


        export type SectionDbRecordList_keys = 'sections';
        export interface SectionDbRecordList_createType {
            sections?: ng.assets.SectionDbRecord[],
        }
        export interface SectionDbRecordList_json {
            sections: ng.assets.SectionDbRecord_json[];
        }
        interface SectionDbRecordList_json_in {
            __proto_name?: unknown;
            sections?: unknown;
        }
        export class SectionDbRecordList {
            __proto_name = "ng.assets.SectionDbRecordList";
            sections: ng.assets.SectionDbRecord[] = [];

            static fromObject(src_unknown: unknown): SectionDbRecordList {
                const dst = new SectionDbRecordList();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SectionDbRecordList but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SectionDbRecordList_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SectionDbRecordList but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.sections !== undefined && src.sections !== null) {
                    if (Array.isArray(src.sections)) {
                        for (const element of src.sections) {
                            dst.sections.push(ng.assets.SectionDbRecord.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected sections of SectionDbRecordList to be a array but was ', typeof src.sections, src.sections)
                    }
                }
                return dst;
            }

            static toObject(src: SectionDbRecordList | null | undefined): SectionDbRecordList_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.assets.SectionDbRecordList is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.assets.SectionDbRecordList") {
                    console.error('Expected ng.assets.SectionDbRecordList but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SectionDbRecordList_json = {
                    sections: new Array<ng.assets.SectionDbRecord_json>(),
                };
                if (src.sections !== null) {
                    for (const element of src.sections) {
                        const parsed = ng.assets.SectionDbRecord.toObject(element);
                        if(parsed === null) return null;
                        dst.sections.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: SectionDbRecordList_createType) {
                const dst = new SectionDbRecordList();
                if (src === undefined) {
                    return dst;
                }
                if (src.sections !== undefined) {
                    dst.sections = src.sections;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SectionDbRecordList();
                dst.sections = this.sections;
                return dst;
            }

            deepClone() {
                const json = SectionDbRecordList.toObject(this);
                const dst = SectionDbRecordList.fromObject(json);
                return dst;
            }
        }
        export type ISectionDbRecordList = SectionDbRecordList;


        export type Database_keys = 'materialList' | 'sectionList';
        export interface Database_createType {
            materialList?: ng.assets.MaterialDbRecordList | null,
            sectionList?: ng.assets.SectionDbRecordList | null,
        }
        export interface Database_json {
            materialList?: ng.assets.MaterialDbRecordList_json;
            sectionList?: ng.assets.SectionDbRecordList_json;
        }
        interface Database_json_in {
            __proto_name?: unknown;
            materialList?: unknown;
            sectionList?: unknown;
        }
        export class Database {
            __proto_name = "ng.assets.Database";
            materialList: ng.assets.MaterialDbRecordList | null = null;
            sectionList: ng.assets.SectionDbRecordList | null = null;

            static fromObject(src_unknown: unknown): Database {
                const dst = new Database();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Database but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Database_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Database but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.materialList !== undefined && src.materialList !== null) {
                    dst.materialList = ng.assets.MaterialDbRecordList.fromObject(src.materialList);
                }
                if (src.sectionList !== undefined && src.sectionList !== null) {
                    dst.sectionList = ng.assets.SectionDbRecordList.fromObject(src.sectionList);
                }
                return dst;
            }

            static toObject(src: Database | null | undefined): Database_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.assets.Database is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.assets.Database") {
                    console.error('Expected ng.assets.Database but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Database_json = {
                };
                if(src.materialList !== null)
                {
                    const parsed = ng.assets.MaterialDbRecordList.toObject(src.materialList);
                    if(parsed === null) return null;
                    dst.materialList = parsed;
                }
                if(src.sectionList !== null)
                {
                    const parsed = ng.assets.SectionDbRecordList.toObject(src.sectionList);
                    if(parsed === null) return null;
                    dst.sectionList = parsed;
                }
                return dst;
            }

            static create(src?: Database_createType) {
                const dst = new Database();
                if (src === undefined) {
                    return dst;
                }
                if (src.materialList !== undefined) {
                    dst.materialList = src.materialList;
                }
                if (src.sectionList !== undefined) {
                    dst.sectionList = src.sectionList;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Database();
                dst.materialList = this.materialList;
                dst.sectionList = this.sectionList;
                return dst;
            }

            deepClone() {
                const json = Database.toObject(this);
                const dst = Database.fromObject(json);
                return dst;
            }
        }
        export type IDatabase = Database;
    } // namespace assets


    // Defined in Soilmodel/soil_model.proto
    export namespace soil_model {
        export type Soil_keys = 'id' | 'performSoilCalculations' | 'limitDepth' | 'defaultFillingGuid' | 'groundWaterGuids' | 'soilStratumGuids' | 'allowedSoilPressure';
        export interface Soil_createType {
            id?: ng.utils.ID | null,
            performSoilCalculations?: boolean,
            limitDepth?: number,
            defaultFillingGuid?: string,
            groundWaterGuids?: string[],
            soilStratumGuids?: string[],
            allowedSoilPressure?: ng.soil_model.AllowedSoilPressure | null,
        }
        export interface Soil_json {
            id?: ng.utils.ID_json;
            performSoilCalculations?: boolean;
            limitDepth?: JsonNumber;
            defaultFillingGuid?: string;
            groundWaterGuids: string[];
            soilStratumGuids: string[];
            allowedSoilPressure?: ng.soil_model.AllowedSoilPressure_json;
        }
        interface Soil_json_in {
            __proto_name?: unknown;
            id?: unknown;
            performSoilCalculations?: unknown;
            limitDepth?: unknown;
            defaultFillingGuid?: unknown;
            groundWaterGuids?: unknown;
            soilStratumGuids?: unknown;
            allowedSoilPressure?: unknown;
        }
        export class Soil {
            __proto_name = "ng.soil_model.Soil";
            id: ng.utils.ID | null = null;
            performSoilCalculations: boolean = false;
            limitDepth: number = 0;
            defaultFillingGuid: string = "";
            groundWaterGuids: string[] = [];
            soilStratumGuids: string[] = [];
            allowedSoilPressure: ng.soil_model.AllowedSoilPressure | null = null;

            static fromObject(src_unknown: unknown): Soil {
                const dst = new Soil();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Soil but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Soil_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Soil but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.performSoilCalculations !== undefined && src.performSoilCalculations !== null) {
                    if (typeof src.performSoilCalculations === "boolean") {
                        dst.performSoilCalculations = src.performSoilCalculations;
                    }
                    else {
                        console.log('Expected performSoilCalculations of Soil to be a boolean but was ', typeof src.performSoilCalculations, src.performSoilCalculations)
                    }
                }
                if (src.limitDepth !== undefined && src.limitDepth !== null) {
                    if (typeof src.limitDepth === "number" || src.limitDepth === 'NaN' || src.limitDepth === 'Infinity' || src.limitDepth === '-Infinity') {
                        dst.limitDepth = AsNum(src.limitDepth);
                    }
                    else {
                        console.log('Expected limitDepth of Soil to be a number but was ', typeof src.limitDepth, src.limitDepth)
                    }
                }
                if (src.defaultFillingGuid !== undefined && src.defaultFillingGuid !== null) {
                    if (typeof src.defaultFillingGuid === "string") {
                        dst.defaultFillingGuid = src.defaultFillingGuid;
                    }
                    else {
                        console.log('Expected defaultFillingGuid of Soil to be a string but was ', typeof src.defaultFillingGuid, src.defaultFillingGuid)
                    }
                }
                if (src.groundWaterGuids !== undefined && src.groundWaterGuids !== null) {
                    if (Array.isArray(src.groundWaterGuids)) {
                        for (const [index, element] of src.groundWaterGuids.entries()) {
                            if (typeof element === "string") {
                                dst.groundWaterGuids.push(element);
                            }
                            else {
                                console.log('Expected groundWaterGuids of Soil[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected groundWaterGuids of Soil to be a array but was ', typeof src.groundWaterGuids, src.groundWaterGuids)
                    }
                }
                if (src.soilStratumGuids !== undefined && src.soilStratumGuids !== null) {
                    if (Array.isArray(src.soilStratumGuids)) {
                        for (const [index, element] of src.soilStratumGuids.entries()) {
                            if (typeof element === "string") {
                                dst.soilStratumGuids.push(element);
                            }
                            else {
                                console.log('Expected soilStratumGuids of Soil[', index, '] to be a string but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected soilStratumGuids of Soil to be a array but was ', typeof src.soilStratumGuids, src.soilStratumGuids)
                    }
                }
                if (src.allowedSoilPressure !== undefined && src.allowedSoilPressure !== null) {
                    dst.allowedSoilPressure = ng.soil_model.AllowedSoilPressure.fromObject(src.allowedSoilPressure);
                }
                return dst;
            }

            static toObject(src: Soil | null | undefined): Soil_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.soil_model.Soil is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.soil_model.Soil") {
                    console.error('Expected ng.soil_model.Soil but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Soil_json = {
                    performSoilCalculations: src.performSoilCalculations,
                    limitDepth: AsJsonNum(src.limitDepth),
                    defaultFillingGuid: src.defaultFillingGuid,
                    groundWaterGuids: new Array<string>(),
                    soilStratumGuids: new Array<string>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.groundWaterGuids !== null) {
                    for (const element of src.groundWaterGuids) {
                        dst.groundWaterGuids.push(element);
                    }
                }
                if (src.soilStratumGuids !== null) {
                    for (const element of src.soilStratumGuids) {
                        dst.soilStratumGuids.push(element);
                    }
                }
                if(src.allowedSoilPressure !== null)
                {
                    const parsed = ng.soil_model.AllowedSoilPressure.toObject(src.allowedSoilPressure);
                    if(parsed === null) return null;
                    dst.allowedSoilPressure = parsed;
                }
                return dst;
            }

            static create(src?: Soil_createType) {
                const dst = new Soil();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.performSoilCalculations !== undefined) {
                    dst.performSoilCalculations = src.performSoilCalculations;
                }
                if (src.limitDepth !== undefined) {
                    dst.limitDepth = src.limitDepth;
                }
                if (src.defaultFillingGuid !== undefined) {
                    dst.defaultFillingGuid = src.defaultFillingGuid;
                }
                if (src.groundWaterGuids !== undefined) {
                    dst.groundWaterGuids = src.groundWaterGuids;
                }
                if (src.soilStratumGuids !== undefined) {
                    dst.soilStratumGuids = src.soilStratumGuids;
                }
                if (src.allowedSoilPressure !== undefined) {
                    dst.allowedSoilPressure = src.allowedSoilPressure;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Soil();
                dst.id = this.id;
                dst.performSoilCalculations = this.performSoilCalculations;
                dst.limitDepth = this.limitDepth;
                dst.defaultFillingGuid = this.defaultFillingGuid;
                dst.groundWaterGuids = this.groundWaterGuids;
                dst.soilStratumGuids = this.soilStratumGuids;
                dst.allowedSoilPressure = this.allowedSoilPressure;
                return dst;
            }

            deepClone() {
                const json = Soil.toObject(this);
                const dst = Soil.fromObject(json);
                return dst;
            }
        }
        export type ISoil = Soil;


        export type Borehole_keys = 'id' | 'soilGuid' | 'placement' | 'finalGroundLevel' | 'beta' | 'topOfSlopeFinalGroundLevel' | 'groundWaterLevels' | 'soilStratumTopLevels';
        export interface Borehole_createType {
            id?: ng.utils.ID | null,
            soilGuid?: string,
            placement?: ng.geometry.Point2D | null,
            finalGroundLevel?: number,
            beta?: number,
            topOfSlopeFinalGroundLevel?: number,
            groundWaterLevels?: number[],
            soilStratumTopLevels?: number[],
        }
        export interface Borehole_json {
            id?: ng.utils.ID_json;
            soilGuid?: string;
            placement?: ng.geometry.Point2D_json;
            finalGroundLevel?: JsonNumber;
            beta?: JsonNumber;
            topOfSlopeFinalGroundLevel?: JsonNumber;
            groundWaterLevels: JsonNumber[];
            soilStratumTopLevels: JsonNumber[];
        }
        interface Borehole_json_in {
            __proto_name?: unknown;
            id?: unknown;
            soilGuid?: unknown;
            placement?: unknown;
            finalGroundLevel?: unknown;
            beta?: unknown;
            topOfSlopeFinalGroundLevel?: unknown;
            groundWaterLevels?: unknown;
            soilStratumTopLevels?: unknown;
        }
        export class Borehole {
            __proto_name = "ng.soil_model.Borehole";
            id: ng.utils.ID | null = null;
            soilGuid: string = "";
            placement: ng.geometry.Point2D | null = null;
            finalGroundLevel: number = 0;
            beta: number = 0;
            topOfSlopeFinalGroundLevel: number = 0;
            groundWaterLevels: number[] = [];
            soilStratumTopLevels: number[] = [];

            static fromObject(src_unknown: unknown): Borehole {
                const dst = new Borehole();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Borehole but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Borehole_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Borehole but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.soilGuid !== undefined && src.soilGuid !== null) {
                    if (typeof src.soilGuid === "string") {
                        dst.soilGuid = src.soilGuid;
                    }
                    else {
                        console.log('Expected soilGuid of Borehole to be a string but was ', typeof src.soilGuid, src.soilGuid)
                    }
                }
                if (src.placement !== undefined && src.placement !== null) {
                    dst.placement = ng.geometry.Point2D.fromObject(src.placement);
                }
                if (src.finalGroundLevel !== undefined && src.finalGroundLevel !== null) {
                    if (typeof src.finalGroundLevel === "number" || src.finalGroundLevel === 'NaN' || src.finalGroundLevel === 'Infinity' || src.finalGroundLevel === '-Infinity') {
                        dst.finalGroundLevel = AsNum(src.finalGroundLevel);
                    }
                    else {
                        console.log('Expected finalGroundLevel of Borehole to be a number but was ', typeof src.finalGroundLevel, src.finalGroundLevel)
                    }
                }
                if (src.beta !== undefined && src.beta !== null) {
                    if (typeof src.beta === "number" || src.beta === 'NaN' || src.beta === 'Infinity' || src.beta === '-Infinity') {
                        dst.beta = AsNum(src.beta);
                    }
                    else {
                        console.log('Expected beta of Borehole to be a number but was ', typeof src.beta, src.beta)
                    }
                }
                if (src.topOfSlopeFinalGroundLevel !== undefined && src.topOfSlopeFinalGroundLevel !== null) {
                    if (typeof src.topOfSlopeFinalGroundLevel === "number" || src.topOfSlopeFinalGroundLevel === 'NaN' || src.topOfSlopeFinalGroundLevel === 'Infinity' || src.topOfSlopeFinalGroundLevel === '-Infinity') {
                        dst.topOfSlopeFinalGroundLevel = AsNum(src.topOfSlopeFinalGroundLevel);
                    }
                    else {
                        console.log('Expected topOfSlopeFinalGroundLevel of Borehole to be a number but was ', typeof src.topOfSlopeFinalGroundLevel, src.topOfSlopeFinalGroundLevel)
                    }
                }
                if (src.groundWaterLevels !== undefined && src.groundWaterLevels !== null) {
                    if (Array.isArray(src.groundWaterLevels)) {
                        for (const [index, element] of src.groundWaterLevels.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.groundWaterLevels.push(AsNum(element));
                            }
                            else {
                                console.log('Expected groundWaterLevels of Borehole[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected groundWaterLevels of Borehole to be a array but was ', typeof src.groundWaterLevels, src.groundWaterLevels)
                    }
                }
                if (src.soilStratumTopLevels !== undefined && src.soilStratumTopLevels !== null) {
                    if (Array.isArray(src.soilStratumTopLevels)) {
                        for (const [index, element] of src.soilStratumTopLevels.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.soilStratumTopLevels.push(AsNum(element));
                            }
                            else {
                                console.log('Expected soilStratumTopLevels of Borehole[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected soilStratumTopLevels of Borehole to be a array but was ', typeof src.soilStratumTopLevels, src.soilStratumTopLevels)
                    }
                }
                return dst;
            }

            static toObject(src: Borehole | null | undefined): Borehole_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.soil_model.Borehole is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.soil_model.Borehole") {
                    console.error('Expected ng.soil_model.Borehole but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Borehole_json = {
                    soilGuid: src.soilGuid,
                    finalGroundLevel: AsJsonNum(src.finalGroundLevel),
                    beta: AsJsonNum(src.beta),
                    topOfSlopeFinalGroundLevel: AsJsonNum(src.topOfSlopeFinalGroundLevel),
                    groundWaterLevels: new Array<JsonNumber>(),
                    soilStratumTopLevels: new Array<JsonNumber>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.placement !== null)
                {
                    const parsed = ng.geometry.Point2D.toObject(src.placement);
                    if(parsed === null) return null;
                    dst.placement = parsed;
                }
                if (src.groundWaterLevels !== null) {
                    for (const element of src.groundWaterLevels) {
                        dst.groundWaterLevels.push(AsJsonNum(element));
                    }
                }
                if (src.soilStratumTopLevels !== null) {
                    for (const element of src.soilStratumTopLevels) {
                        dst.soilStratumTopLevels.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: Borehole_createType) {
                const dst = new Borehole();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.soilGuid !== undefined) {
                    dst.soilGuid = src.soilGuid;
                }
                if (src.placement !== undefined) {
                    dst.placement = src.placement;
                }
                if (src.finalGroundLevel !== undefined) {
                    dst.finalGroundLevel = src.finalGroundLevel;
                }
                if (src.beta !== undefined) {
                    dst.beta = src.beta;
                }
                if (src.topOfSlopeFinalGroundLevel !== undefined) {
                    dst.topOfSlopeFinalGroundLevel = src.topOfSlopeFinalGroundLevel;
                }
                if (src.groundWaterLevels !== undefined) {
                    dst.groundWaterLevels = src.groundWaterLevels;
                }
                if (src.soilStratumTopLevels !== undefined) {
                    dst.soilStratumTopLevels = src.soilStratumTopLevels;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Borehole();
                dst.id = this.id;
                dst.soilGuid = this.soilGuid;
                dst.placement = this.placement;
                dst.finalGroundLevel = this.finalGroundLevel;
                dst.beta = this.beta;
                dst.topOfSlopeFinalGroundLevel = this.topOfSlopeFinalGroundLevel;
                dst.groundWaterLevels = this.groundWaterLevels;
                dst.soilStratumTopLevels = this.soilStratumTopLevels;
                return dst;
            }

            deepClone() {
                const json = Borehole.toObject(this);
                const dst = Borehole.fromObject(json);
                return dst;
            }
        }
        export type IBorehole = Borehole;


        export type GroundWater_keys = 'id';
        export interface GroundWater_createType {
            id?: ng.utils.ID | null,
        }
        export interface GroundWater_json {
            id?: ng.utils.ID_json;
        }
        interface GroundWater_json_in {
            __proto_name?: unknown;
            id?: unknown;
        }
        export class GroundWater {
            __proto_name = "ng.soil_model.GroundWater";
            id: ng.utils.ID | null = null;

            static fromObject(src_unknown: unknown): GroundWater {
                const dst = new GroundWater();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted GroundWater but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as GroundWater_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for GroundWater but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                return dst;
            }

            static toObject(src: GroundWater | null | undefined): GroundWater_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.soil_model.GroundWater is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.soil_model.GroundWater") {
                    console.error('Expected ng.soil_model.GroundWater but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : GroundWater_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                return dst;
            }

            static create(src?: GroundWater_createType) {
                const dst = new GroundWater();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                return dst;
            }

            shallowClone() {
                const dst = new GroundWater();
                dst.id = this.id;
                return dst;
            }

            deepClone() {
                const json = GroundWater.toObject(this);
                const dst = GroundWater.fromObject(json);
                return dst;
            }
        }
        export type IGroundWater = GroundWater;


        export type SoilStratum_keys = 'id' | 'soilMaterialGuid';
        export interface SoilStratum_createType {
            id?: ng.utils.ID | null,
            soilMaterialGuid?: string,
        }
        export interface SoilStratum_json {
            id?: ng.utils.ID_json;
            soilMaterialGuid?: string;
        }
        interface SoilStratum_json_in {
            __proto_name?: unknown;
            id?: unknown;
            soilMaterialGuid?: unknown;
        }
        export class SoilStratum {
            __proto_name = "ng.soil_model.SoilStratum";
            id: ng.utils.ID | null = null;
            soilMaterialGuid: string = "";

            static fromObject(src_unknown: unknown): SoilStratum {
                const dst = new SoilStratum();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SoilStratum but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SoilStratum_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SoilStratum but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.soilMaterialGuid !== undefined && src.soilMaterialGuid !== null) {
                    if (typeof src.soilMaterialGuid === "string") {
                        dst.soilMaterialGuid = src.soilMaterialGuid;
                    }
                    else {
                        console.log('Expected soilMaterialGuid of SoilStratum to be a string but was ', typeof src.soilMaterialGuid, src.soilMaterialGuid)
                    }
                }
                return dst;
            }

            static toObject(src: SoilStratum | null | undefined): SoilStratum_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.soil_model.SoilStratum is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.soil_model.SoilStratum") {
                    console.error('Expected ng.soil_model.SoilStratum but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SoilStratum_json = {
                    soilMaterialGuid: src.soilMaterialGuid,
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                return dst;
            }

            static create(src?: SoilStratum_createType) {
                const dst = new SoilStratum();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.soilMaterialGuid !== undefined) {
                    dst.soilMaterialGuid = src.soilMaterialGuid;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SoilStratum();
                dst.id = this.id;
                dst.soilMaterialGuid = this.soilMaterialGuid;
                return dst;
            }

            deepClone() {
                const json = SoilStratum.toObject(this);
                const dst = SoilStratum.fromObject(json);
                return dst;
            }
        }
        export type ISoilStratum = SoilStratum;


        export type AllowedSoilPressure_keys = 'allowedSoilPressureSls' | 'allowedSoilPressureUls' | 'frictionCoef';
        export interface AllowedSoilPressure_createType {
            allowedSoilPressureSls?: number,
            allowedSoilPressureUls?: number,
            frictionCoef?: number,
        }
        export interface AllowedSoilPressure_json {
            allowedSoilPressureSls?: JsonNumber;
            allowedSoilPressureUls?: JsonNumber;
            frictionCoef?: JsonNumber;
        }
        interface AllowedSoilPressure_json_in {
            __proto_name?: unknown;
            allowedSoilPressureSls?: unknown;
            allowedSoilPressureUls?: unknown;
            frictionCoef?: unknown;
        }
        export class AllowedSoilPressure {
            __proto_name = "ng.soil_model.AllowedSoilPressure";
            allowedSoilPressureSls: number = 0;
            allowedSoilPressureUls: number = 0;
            frictionCoef: number = 0;

            static fromObject(src_unknown: unknown): AllowedSoilPressure {
                const dst = new AllowedSoilPressure();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted AllowedSoilPressure but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as AllowedSoilPressure_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for AllowedSoilPressure but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.allowedSoilPressureSls !== undefined && src.allowedSoilPressureSls !== null) {
                    if (typeof src.allowedSoilPressureSls === "number" || src.allowedSoilPressureSls === 'NaN' || src.allowedSoilPressureSls === 'Infinity' || src.allowedSoilPressureSls === '-Infinity') {
                        dst.allowedSoilPressureSls = AsNum(src.allowedSoilPressureSls);
                    }
                    else {
                        console.log('Expected allowedSoilPressureSls of AllowedSoilPressure to be a number but was ', typeof src.allowedSoilPressureSls, src.allowedSoilPressureSls)
                    }
                }
                if (src.allowedSoilPressureUls !== undefined && src.allowedSoilPressureUls !== null) {
                    if (typeof src.allowedSoilPressureUls === "number" || src.allowedSoilPressureUls === 'NaN' || src.allowedSoilPressureUls === 'Infinity' || src.allowedSoilPressureUls === '-Infinity') {
                        dst.allowedSoilPressureUls = AsNum(src.allowedSoilPressureUls);
                    }
                    else {
                        console.log('Expected allowedSoilPressureUls of AllowedSoilPressure to be a number but was ', typeof src.allowedSoilPressureUls, src.allowedSoilPressureUls)
                    }
                }
                if (src.frictionCoef !== undefined && src.frictionCoef !== null) {
                    if (typeof src.frictionCoef === "number" || src.frictionCoef === 'NaN' || src.frictionCoef === 'Infinity' || src.frictionCoef === '-Infinity') {
                        dst.frictionCoef = AsNum(src.frictionCoef);
                    }
                    else {
                        console.log('Expected frictionCoef of AllowedSoilPressure to be a number but was ', typeof src.frictionCoef, src.frictionCoef)
                    }
                }
                return dst;
            }

            static toObject(src: AllowedSoilPressure | null | undefined): AllowedSoilPressure_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.soil_model.AllowedSoilPressure is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.soil_model.AllowedSoilPressure") {
                    console.error('Expected ng.soil_model.AllowedSoilPressure but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : AllowedSoilPressure_json = {
                    allowedSoilPressureSls: AsJsonNum(src.allowedSoilPressureSls),
                    allowedSoilPressureUls: AsJsonNum(src.allowedSoilPressureUls),
                    frictionCoef: AsJsonNum(src.frictionCoef),
                };
                return dst;
            }

            static create(src?: AllowedSoilPressure_createType) {
                const dst = new AllowedSoilPressure();
                if (src === undefined) {
                    return dst;
                }
                if (src.allowedSoilPressureSls !== undefined) {
                    dst.allowedSoilPressureSls = src.allowedSoilPressureSls;
                }
                if (src.allowedSoilPressureUls !== undefined) {
                    dst.allowedSoilPressureUls = src.allowedSoilPressureUls;
                }
                if (src.frictionCoef !== undefined) {
                    dst.frictionCoef = src.frictionCoef;
                }
                return dst;
            }

            shallowClone() {
                const dst = new AllowedSoilPressure();
                dst.allowedSoilPressureSls = this.allowedSoilPressureSls;
                dst.allowedSoilPressureUls = this.allowedSoilPressureUls;
                dst.frictionCoef = this.frictionCoef;
                return dst;
            }

            deepClone() {
                const json = AllowedSoilPressure.toObject(this);
                const dst = AllowedSoilPressure.fromObject(json);
                return dst;
            }
        }
        export type IAllowedSoilPressure = AllowedSoilPressure;


        export type Data_keys = 'soils' | 'boreHoles' | 'soilStratums' | 'groundWaters';
        export interface Data_createType {
            soils?: ng.soil_model.Soil[],
            boreHoles?: ng.soil_model.Borehole[],
            soilStratums?: ng.soil_model.SoilStratum[],
            groundWaters?: ng.soil_model.GroundWater[],
        }
        export interface Data_json {
            soils: ng.soil_model.Soil_json[];
            boreHoles: ng.soil_model.Borehole_json[];
            soilStratums: ng.soil_model.SoilStratum_json[];
            groundWaters: ng.soil_model.GroundWater_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            soils?: unknown;
            boreHoles?: unknown;
            soilStratums?: unknown;
            groundWaters?: unknown;
        }
        export class Data {
            __proto_name = "ng.soil_model.Data";
            soils: ng.soil_model.Soil[] = [];
            boreHoles: ng.soil_model.Borehole[] = [];
            soilStratums: ng.soil_model.SoilStratum[] = [];
            groundWaters: ng.soil_model.GroundWater[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.soils !== undefined && src.soils !== null) {
                    if (Array.isArray(src.soils)) {
                        for (const element of src.soils) {
                            dst.soils.push(ng.soil_model.Soil.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected soils of Data to be a array but was ', typeof src.soils, src.soils)
                    }
                }
                if (src.boreHoles !== undefined && src.boreHoles !== null) {
                    if (Array.isArray(src.boreHoles)) {
                        for (const element of src.boreHoles) {
                            dst.boreHoles.push(ng.soil_model.Borehole.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected boreHoles of Data to be a array but was ', typeof src.boreHoles, src.boreHoles)
                    }
                }
                if (src.soilStratums !== undefined && src.soilStratums !== null) {
                    if (Array.isArray(src.soilStratums)) {
                        for (const element of src.soilStratums) {
                            dst.soilStratums.push(ng.soil_model.SoilStratum.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected soilStratums of Data to be a array but was ', typeof src.soilStratums, src.soilStratums)
                    }
                }
                if (src.groundWaters !== undefined && src.groundWaters !== null) {
                    if (Array.isArray(src.groundWaters)) {
                        for (const element of src.groundWaters) {
                            dst.groundWaters.push(ng.soil_model.GroundWater.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected groundWaters of Data to be a array but was ', typeof src.groundWaters, src.groundWaters)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.soil_model.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.soil_model.Data") {
                    console.error('Expected ng.soil_model.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    soils: new Array<ng.soil_model.Soil_json>(),
                    boreHoles: new Array<ng.soil_model.Borehole_json>(),
                    soilStratums: new Array<ng.soil_model.SoilStratum_json>(),
                    groundWaters: new Array<ng.soil_model.GroundWater_json>(),
                };
                if (src.soils !== null) {
                    for (const element of src.soils) {
                        const parsed = ng.soil_model.Soil.toObject(element);
                        if(parsed === null) return null;
                        dst.soils.push(parsed);
                    }
                }
                if (src.boreHoles !== null) {
                    for (const element of src.boreHoles) {
                        const parsed = ng.soil_model.Borehole.toObject(element);
                        if(parsed === null) return null;
                        dst.boreHoles.push(parsed);
                    }
                }
                if (src.soilStratums !== null) {
                    for (const element of src.soilStratums) {
                        const parsed = ng.soil_model.SoilStratum.toObject(element);
                        if(parsed === null) return null;
                        dst.soilStratums.push(parsed);
                    }
                }
                if (src.groundWaters !== null) {
                    for (const element of src.groundWaters) {
                        const parsed = ng.soil_model.GroundWater.toObject(element);
                        if(parsed === null) return null;
                        dst.groundWaters.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.soils !== undefined) {
                    dst.soils = src.soils;
                }
                if (src.boreHoles !== undefined) {
                    dst.boreHoles = src.boreHoles;
                }
                if (src.soilStratums !== undefined) {
                    dst.soilStratums = src.soilStratums;
                }
                if (src.groundWaters !== undefined) {
                    dst.groundWaters = src.groundWaters;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.soils = this.soils;
                dst.boreHoles = this.boreHoles;
                dst.soilStratums = this.soilStratums;
                dst.groundWaters = this.groundWaters;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace soil_model


    // Defined in Loading/loading.proto
    export namespace loading {
        export type Data_keys = 'loads' | 'loadcases' | 'loadgroups' | 'combinations';
        export interface Data_createType {
            loads?: ng.load.Data[],
            loadcases?: ng.loadcase.Data[],
            loadgroups?: ng.loadgroup.Groups | null,
            combinations?: ng.loadcombination.Data[],
        }
        export interface Data_json {
            loads: ng.load.Data_json[];
            loadcases: ng.loadcase.Data_json[];
            loadgroups?: ng.loadgroup.Groups_json;
            combinations: ng.loadcombination.Data_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            loads?: unknown;
            loadcases?: unknown;
            loadgroups?: unknown;
            combinations?: unknown;
        }
        export class Data {
            __proto_name = "ng.loading.Data";
            loads: ng.load.Data[] = [];
            loadcases: ng.loadcase.Data[] = [];
            loadgroups: ng.loadgroup.Groups | null = null;
            combinations: ng.loadcombination.Data[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.loads !== undefined && src.loads !== null) {
                    if (Array.isArray(src.loads)) {
                        for (const element of src.loads) {
                            dst.loads.push(ng.load.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected loads of Data to be a array but was ', typeof src.loads, src.loads)
                    }
                }
                if (src.loadcases !== undefined && src.loadcases !== null) {
                    if (Array.isArray(src.loadcases)) {
                        for (const element of src.loadcases) {
                            dst.loadcases.push(ng.loadcase.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected loadcases of Data to be a array but was ', typeof src.loadcases, src.loadcases)
                    }
                }
                if (src.loadgroups !== undefined && src.loadgroups !== null) {
                    dst.loadgroups = ng.loadgroup.Groups.fromObject(src.loadgroups);
                }
                if (src.combinations !== undefined && src.combinations !== null) {
                    if (Array.isArray(src.combinations)) {
                        for (const element of src.combinations) {
                            dst.combinations.push(ng.loadcombination.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected combinations of Data to be a array but was ', typeof src.combinations, src.combinations)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.loading.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.loading.Data") {
                    console.error('Expected ng.loading.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    loads: new Array<ng.load.Data_json>(),
                    loadcases: new Array<ng.loadcase.Data_json>(),
                    combinations: new Array<ng.loadcombination.Data_json>(),
                };
                if (src.loads !== null) {
                    for (const element of src.loads) {
                        const parsed = ng.load.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.loads.push(parsed);
                    }
                }
                if (src.loadcases !== null) {
                    for (const element of src.loadcases) {
                        const parsed = ng.loadcase.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.loadcases.push(parsed);
                    }
                }
                if(src.loadgroups !== null)
                {
                    const parsed = ng.loadgroup.Groups.toObject(src.loadgroups);
                    if(parsed === null) return null;
                    dst.loadgroups = parsed;
                }
                if (src.combinations !== null) {
                    for (const element of src.combinations) {
                        const parsed = ng.loadcombination.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.combinations.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.loads !== undefined) {
                    dst.loads = src.loads;
                }
                if (src.loadcases !== undefined) {
                    dst.loadcases = src.loadcases;
                }
                if (src.loadgroups !== undefined) {
                    dst.loadgroups = src.loadgroups;
                }
                if (src.combinations !== undefined) {
                    dst.combinations = src.combinations;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.loads = this.loads;
                dst.loadcases = this.loadcases;
                dst.loadgroups = this.loadgroups;
                dst.combinations = this.combinations;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace loading


    // Defined in Geometry/strand.proto
    export namespace strand {
        export type Data_keys = 'exactStrandCoordinates' | 'standaloneStrands' | 'strands' | 'grps' | 'lays';
        export interface Data_createType {
            exactStrandCoordinates?: boolean,
            standaloneStrands?: ng.reinf.StandAloneBar[],
            strands?: ng.reinf.Straight[],
            grps?: ng.reinf.Group[],
            lays?: ng.reinf.Layer[],
        }
        export interface Data_json {
            exactStrandCoordinates?: boolean;
            standaloneStrands: ng.reinf.StandAloneBar_json[];
            strands: ng.reinf.Straight_json[];
            grps: ng.reinf.Group_json[];
            lays: ng.reinf.Layer_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            exactStrandCoordinates?: unknown;
            standaloneStrands?: unknown;
            strands?: unknown;
            grps?: unknown;
            lays?: unknown;
        }
        export class Data {
            __proto_name = "ng.strand.Data";
            exactStrandCoordinates: boolean = false;
            standaloneStrands: ng.reinf.StandAloneBar[] = [];
            strands: ng.reinf.Straight[] = [];
            grps: ng.reinf.Group[] = [];
            lays: ng.reinf.Layer[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.exactStrandCoordinates !== undefined && src.exactStrandCoordinates !== null) {
                    if (typeof src.exactStrandCoordinates === "boolean") {
                        dst.exactStrandCoordinates = src.exactStrandCoordinates;
                    }
                    else {
                        console.log('Expected exactStrandCoordinates of Data to be a boolean but was ', typeof src.exactStrandCoordinates, src.exactStrandCoordinates)
                    }
                }
                if (src.standaloneStrands !== undefined && src.standaloneStrands !== null) {
                    if (Array.isArray(src.standaloneStrands)) {
                        for (const element of src.standaloneStrands) {
                            dst.standaloneStrands.push(ng.reinf.StandAloneBar.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected standaloneStrands of Data to be a array but was ', typeof src.standaloneStrands, src.standaloneStrands)
                    }
                }
                if (src.strands !== undefined && src.strands !== null) {
                    if (Array.isArray(src.strands)) {
                        for (const element of src.strands) {
                            dst.strands.push(ng.reinf.Straight.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected strands of Data to be a array but was ', typeof src.strands, src.strands)
                    }
                }
                if (src.grps !== undefined && src.grps !== null) {
                    if (Array.isArray(src.grps)) {
                        for (const element of src.grps) {
                            dst.grps.push(ng.reinf.Group.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected grps of Data to be a array but was ', typeof src.grps, src.grps)
                    }
                }
                if (src.lays !== undefined && src.lays !== null) {
                    if (Array.isArray(src.lays)) {
                        for (const element of src.lays) {
                            dst.lays.push(ng.reinf.Layer.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected lays of Data to be a array but was ', typeof src.lays, src.lays)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.strand.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.strand.Data") {
                    console.error('Expected ng.strand.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    exactStrandCoordinates: src.exactStrandCoordinates,
                    standaloneStrands: new Array<ng.reinf.StandAloneBar_json>(),
                    strands: new Array<ng.reinf.Straight_json>(),
                    grps: new Array<ng.reinf.Group_json>(),
                    lays: new Array<ng.reinf.Layer_json>(),
                };
                if (src.standaloneStrands !== null) {
                    for (const element of src.standaloneStrands) {
                        const parsed = ng.reinf.StandAloneBar.toObject(element);
                        if(parsed === null) return null;
                        dst.standaloneStrands.push(parsed);
                    }
                }
                if (src.strands !== null) {
                    for (const element of src.strands) {
                        const parsed = ng.reinf.Straight.toObject(element);
                        if(parsed === null) return null;
                        dst.strands.push(parsed);
                    }
                }
                if (src.grps !== null) {
                    for (const element of src.grps) {
                        const parsed = ng.reinf.Group.toObject(element);
                        if(parsed === null) return null;
                        dst.grps.push(parsed);
                    }
                }
                if (src.lays !== null) {
                    for (const element of src.lays) {
                        const parsed = ng.reinf.Layer.toObject(element);
                        if(parsed === null) return null;
                        dst.lays.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.exactStrandCoordinates !== undefined) {
                    dst.exactStrandCoordinates = src.exactStrandCoordinates;
                }
                if (src.standaloneStrands !== undefined) {
                    dst.standaloneStrands = src.standaloneStrands;
                }
                if (src.strands !== undefined) {
                    dst.strands = src.strands;
                }
                if (src.grps !== undefined) {
                    dst.grps = src.grps;
                }
                if (src.lays !== undefined) {
                    dst.lays = src.lays;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.exactStrandCoordinates = this.exactStrandCoordinates;
                dst.standaloneStrands = this.standaloneStrands;
                dst.strands = this.strands;
                dst.grps = this.grps;
                dst.lays = this.lays;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace strand


    // Defined in Geometry/rebar.proto
    export namespace rebar {
        export type Data_keys = 'exactBarCoordinates' | 'standaloneBars' | 'bars' | 'grps' | 'lays';
        export interface Data_createType {
            exactBarCoordinates?: boolean,
            standaloneBars?: ng.reinf.StandAloneBar[],
            bars?: ng.reinf.Straight[],
            grps?: ng.reinf.Group[],
            lays?: ng.reinf.Layer[],
        }
        export interface Data_json {
            exactBarCoordinates?: boolean;
            standaloneBars: ng.reinf.StandAloneBar_json[];
            bars: ng.reinf.Straight_json[];
            grps: ng.reinf.Group_json[];
            lays: ng.reinf.Layer_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            exactBarCoordinates?: unknown;
            standaloneBars?: unknown;
            bars?: unknown;
            grps?: unknown;
            lays?: unknown;
        }
        export class Data {
            __proto_name = "ng.rebar.Data";
            exactBarCoordinates: boolean = false;
            standaloneBars: ng.reinf.StandAloneBar[] = [];
            bars: ng.reinf.Straight[] = [];
            grps: ng.reinf.Group[] = [];
            lays: ng.reinf.Layer[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.exactBarCoordinates !== undefined && src.exactBarCoordinates !== null) {
                    if (typeof src.exactBarCoordinates === "boolean") {
                        dst.exactBarCoordinates = src.exactBarCoordinates;
                    }
                    else {
                        console.log('Expected exactBarCoordinates of Data to be a boolean but was ', typeof src.exactBarCoordinates, src.exactBarCoordinates)
                    }
                }
                if (src.standaloneBars !== undefined && src.standaloneBars !== null) {
                    if (Array.isArray(src.standaloneBars)) {
                        for (const element of src.standaloneBars) {
                            dst.standaloneBars.push(ng.reinf.StandAloneBar.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected standaloneBars of Data to be a array but was ', typeof src.standaloneBars, src.standaloneBars)
                    }
                }
                if (src.bars !== undefined && src.bars !== null) {
                    if (Array.isArray(src.bars)) {
                        for (const element of src.bars) {
                            dst.bars.push(ng.reinf.Straight.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected bars of Data to be a array but was ', typeof src.bars, src.bars)
                    }
                }
                if (src.grps !== undefined && src.grps !== null) {
                    if (Array.isArray(src.grps)) {
                        for (const element of src.grps) {
                            dst.grps.push(ng.reinf.Group.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected grps of Data to be a array but was ', typeof src.grps, src.grps)
                    }
                }
                if (src.lays !== undefined && src.lays !== null) {
                    if (Array.isArray(src.lays)) {
                        for (const element of src.lays) {
                            dst.lays.push(ng.reinf.Layer.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected lays of Data to be a array but was ', typeof src.lays, src.lays)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.rebar.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.rebar.Data") {
                    console.error('Expected ng.rebar.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    exactBarCoordinates: src.exactBarCoordinates,
                    standaloneBars: new Array<ng.reinf.StandAloneBar_json>(),
                    bars: new Array<ng.reinf.Straight_json>(),
                    grps: new Array<ng.reinf.Group_json>(),
                    lays: new Array<ng.reinf.Layer_json>(),
                };
                if (src.standaloneBars !== null) {
                    for (const element of src.standaloneBars) {
                        const parsed = ng.reinf.StandAloneBar.toObject(element);
                        if(parsed === null) return null;
                        dst.standaloneBars.push(parsed);
                    }
                }
                if (src.bars !== null) {
                    for (const element of src.bars) {
                        const parsed = ng.reinf.Straight.toObject(element);
                        if(parsed === null) return null;
                        dst.bars.push(parsed);
                    }
                }
                if (src.grps !== null) {
                    for (const element of src.grps) {
                        const parsed = ng.reinf.Group.toObject(element);
                        if(parsed === null) return null;
                        dst.grps.push(parsed);
                    }
                }
                if (src.lays !== null) {
                    for (const element of src.lays) {
                        const parsed = ng.reinf.Layer.toObject(element);
                        if(parsed === null) return null;
                        dst.lays.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.exactBarCoordinates !== undefined) {
                    dst.exactBarCoordinates = src.exactBarCoordinates;
                }
                if (src.standaloneBars !== undefined) {
                    dst.standaloneBars = src.standaloneBars;
                }
                if (src.bars !== undefined) {
                    dst.bars = src.bars;
                }
                if (src.grps !== undefined) {
                    dst.grps = src.grps;
                }
                if (src.lays !== undefined) {
                    dst.lays = src.lays;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.exactBarCoordinates = this.exactBarCoordinates;
                dst.standaloneBars = this.standaloneBars;
                dst.bars = this.bars;
                dst.grps = this.grps;
                dst.lays = this.lays;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace rebar


    // Defined in Geometry/link.proto
    export namespace link {
        export type Group_keys = 'id' | 'direction' | 'start' | 's' | 'length' | 'mtrlGuid' | 'diameter' | 'shape' | 'legs' | 'angle';
        export interface Group_createType {
            id?: ng.utils.ID | null,
            direction?: ng.geometry.Vector3D | null,
            start?: number,
            s?: number,
            length?: number,
            mtrlGuid?: string,
            diameter?: number,
            shape?: ng.geometry.Point2D[],
            legs?: number,
            angle?: number,
        }
        export interface Group_json {
            id?: ng.utils.ID_json;
            direction?: ng.geometry.Vector3D_json;
            start?: JsonNumber;
            s?: JsonNumber;
            length?: JsonNumber;
            mtrlGuid?: string;
            diameter?: JsonNumber;
            shape: ng.geometry.Point2D_json[];
            legs?: JsonNumber;
            angle?: JsonNumber;
        }
        interface Group_json_in {
            __proto_name?: unknown;
            id?: unknown;
            direction?: unknown;
            start?: unknown;
            s?: unknown;
            length?: unknown;
            mtrlGuid?: unknown;
            diameter?: unknown;
            shape?: unknown;
            legs?: unknown;
            angle?: unknown;
        }
        export class Group {
            __proto_name = "ng.link.Group";
            id: ng.utils.ID | null = null;
            direction: ng.geometry.Vector3D | null = null;
            start: number = 0;
            s: number = 0;
            length: number = 0;
            mtrlGuid: string = "";
            diameter: number = 0;
            shape: ng.geometry.Point2D[] = [];
            legs: number = 0;
            angle: number = 0;

            static fromObject(src_unknown: unknown): Group {
                const dst = new Group();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Group but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Group_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Group but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.direction !== undefined && src.direction !== null) {
                    dst.direction = ng.geometry.Vector3D.fromObject(src.direction);
                }
                if (src.start !== undefined && src.start !== null) {
                    if (typeof src.start === "number" || src.start === 'NaN' || src.start === 'Infinity' || src.start === '-Infinity') {
                        dst.start = AsNum(src.start);
                    }
                    else {
                        console.log('Expected start of Group to be a number but was ', typeof src.start, src.start)
                    }
                }
                if (src.s !== undefined && src.s !== null) {
                    if (typeof src.s === "number" || src.s === 'NaN' || src.s === 'Infinity' || src.s === '-Infinity') {
                        dst.s = AsNum(src.s);
                    }
                    else {
                        console.log('Expected s of Group to be a number but was ', typeof src.s, src.s)
                    }
                }
                if (src.length !== undefined && src.length !== null) {
                    if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                        dst.length = AsNum(src.length);
                    }
                    else {
                        console.log('Expected length of Group to be a number but was ', typeof src.length, src.length)
                    }
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of Group to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                if (src.diameter !== undefined && src.diameter !== null) {
                    if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                        dst.diameter = AsNum(src.diameter);
                    }
                    else {
                        console.log('Expected diameter of Group to be a number but was ', typeof src.diameter, src.diameter)
                    }
                }
                if (src.shape !== undefined && src.shape !== null) {
                    if (Array.isArray(src.shape)) {
                        for (const element of src.shape) {
                            dst.shape.push(ng.geometry.Point2D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected shape of Group to be a array but was ', typeof src.shape, src.shape)
                    }
                }
                if (src.legs !== undefined && src.legs !== null) {
                    if (typeof src.legs === "number" || src.legs === 'NaN' || src.legs === 'Infinity' || src.legs === '-Infinity') {
                        dst.legs = NumberToInt("ng.link.Group.legs", AsNum(src.legs));
                    }
                    else {
                        console.log('Expected legs of Group to be a number but was ', typeof src.legs, src.legs)
                    }
                }
                if (src.angle !== undefined && src.angle !== null) {
                    if (typeof src.angle === "number" || src.angle === 'NaN' || src.angle === 'Infinity' || src.angle === '-Infinity') {
                        dst.angle = AsNum(src.angle);
                    }
                    else {
                        console.log('Expected angle of Group to be a number but was ', typeof src.angle, src.angle)
                    }
                }
                return dst;
            }

            static toObject(src: Group | null | undefined): Group_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.link.Group is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.link.Group") {
                    console.error('Expected ng.link.Group but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Group_json = {
                    start: AsJsonNum(src.start),
                    s: AsJsonNum(src.s),
                    length: AsJsonNum(src.length),
                    mtrlGuid: src.mtrlGuid,
                    diameter: AsJsonNum(src.diameter),
                    shape: new Array<ng.geometry.Point2D_json>(),
                    legs: AsJsonNum(NumberToInt("ng.link.Group.legs", src.legs)),
                    angle: AsJsonNum(src.angle),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.direction !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.direction);
                    if(parsed === null) return null;
                    dst.direction = parsed;
                }
                if (src.shape !== null) {
                    for (const element of src.shape) {
                        const parsed = ng.geometry.Point2D.toObject(element);
                        if(parsed === null) return null;
                        dst.shape.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Group_createType) {
                const dst = new Group();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.direction !== undefined) {
                    dst.direction = src.direction;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.s !== undefined) {
                    dst.s = src.s;
                }
                if (src.length !== undefined) {
                    dst.length = src.length;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                if (src.diameter !== undefined) {
                    dst.diameter = src.diameter;
                }
                if (src.shape !== undefined) {
                    dst.shape = src.shape;
                }
                if (src.legs !== undefined) {
                    dst.legs = src.legs;
                }
                if (src.angle !== undefined) {
                    dst.angle = src.angle;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Group();
                dst.id = this.id;
                dst.direction = this.direction;
                dst.start = this.start;
                dst.s = this.s;
                dst.length = this.length;
                dst.mtrlGuid = this.mtrlGuid;
                dst.diameter = this.diameter;
                dst.shape = this.shape;
                dst.legs = this.legs;
                dst.angle = this.angle;
                return dst;
            }

            deepClone() {
                const json = Group.toObject(this);
                const dst = Group.fromObject(json);
                return dst;
            }
        }
        export type IGroup = Group;


        export type Data_keys = 'linkGrps';
        export interface Data_createType {
            linkGrps?: ng.link.Group[],
        }
        export interface Data_json {
            linkGrps: ng.link.Group_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            linkGrps?: unknown;
        }
        export class Data {
            __proto_name = "ng.link.Data";
            linkGrps: ng.link.Group[] = [];

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.linkGrps !== undefined && src.linkGrps !== null) {
                    if (Array.isArray(src.linkGrps)) {
                        for (const element of src.linkGrps) {
                            dst.linkGrps.push(ng.link.Group.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected linkGrps of Data to be a array but was ', typeof src.linkGrps, src.linkGrps)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.link.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.link.Data") {
                    console.error('Expected ng.link.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    linkGrps: new Array<ng.link.Group_json>(),
                };
                if (src.linkGrps !== null) {
                    for (const element of src.linkGrps) {
                        const parsed = ng.link.Group.toObject(element);
                        if(parsed === null) return null;
                        dst.linkGrps.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.linkGrps !== undefined) {
                    dst.linkGrps = src.linkGrps;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.linkGrps = this.linkGrps;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace link


    // Defined in Geometry/geometry.proto
    export namespace geometry {
        export type Vector2D_keys = 'one' | 'two';
        export interface Vector2D_createType {
            one?: number,
            two?: number,
        }
        export interface Vector2D_json {
            one?: JsonNumber;
            two?: JsonNumber;
        }
        interface Vector2D_json_in {
            __proto_name?: unknown;
            one?: unknown;
            two?: unknown;
        }
        export class Vector2D {
            __proto_name = "ng.geometry.Vector2D";
            one: number = 0;
            two: number = 0;

            static fromObject(src_unknown: unknown): Vector2D {
                const dst = new Vector2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Vector2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Vector2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Vector2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.one !== undefined && src.one !== null) {
                    if (typeof src.one === "number" || src.one === 'NaN' || src.one === 'Infinity' || src.one === '-Infinity') {
                        dst.one = AsNum(src.one);
                    }
                    else {
                        console.log('Expected one of Vector2D to be a number but was ', typeof src.one, src.one)
                    }
                }
                if (src.two !== undefined && src.two !== null) {
                    if (typeof src.two === "number" || src.two === 'NaN' || src.two === 'Infinity' || src.two === '-Infinity') {
                        dst.two = AsNum(src.two);
                    }
                    else {
                        console.log('Expected two of Vector2D to be a number but was ', typeof src.two, src.two)
                    }
                }
                return dst;
            }

            static toObject(src: Vector2D | null | undefined): Vector2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Vector2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Vector2D") {
                    console.error('Expected ng.geometry.Vector2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Vector2D_json = {
                    one: AsJsonNum(src.one),
                    two: AsJsonNum(src.two),
                };
                return dst;
            }

            static create(src?: Vector2D_createType) {
                const dst = new Vector2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.one !== undefined) {
                    dst.one = src.one;
                }
                if (src.two !== undefined) {
                    dst.two = src.two;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Vector2D();
                dst.one = this.one;
                dst.two = this.two;
                return dst;
            }

            deepClone() {
                const json = Vector2D.toObject(this);
                const dst = Vector2D.fromObject(json);
                return dst;
            }
        }
        export type IVector2D = Vector2D;


        export type VectorYZ_keys = 'y' | 'z';
        export interface VectorYZ_createType {
            y?: number,
            z?: number,
        }
        export interface VectorYZ_json {
            y?: JsonNumber;
            z?: JsonNumber;
        }
        interface VectorYZ_json_in {
            __proto_name?: unknown;
            y?: unknown;
            z?: unknown;
        }
        export class VectorYZ {
            __proto_name = "ng.geometry.VectorYZ";
            y: number = 0;
            z: number = 0;

            static fromObject(src_unknown: unknown): VectorYZ {
                const dst = new VectorYZ();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted VectorYZ but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as VectorYZ_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for VectorYZ but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.y !== undefined && src.y !== null) {
                    if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                        dst.y = AsNum(src.y);
                    }
                    else {
                        console.log('Expected y of VectorYZ to be a number but was ', typeof src.y, src.y)
                    }
                }
                if (src.z !== undefined && src.z !== null) {
                    if (typeof src.z === "number" || src.z === 'NaN' || src.z === 'Infinity' || src.z === '-Infinity') {
                        dst.z = AsNum(src.z);
                    }
                    else {
                        console.log('Expected z of VectorYZ to be a number but was ', typeof src.z, src.z)
                    }
                }
                return dst;
            }

            static toObject(src: VectorYZ | null | undefined): VectorYZ_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.VectorYZ is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.VectorYZ") {
                    console.error('Expected ng.geometry.VectorYZ but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : VectorYZ_json = {
                    y: AsJsonNum(src.y),
                    z: AsJsonNum(src.z),
                };
                return dst;
            }

            static create(src?: VectorYZ_createType) {
                const dst = new VectorYZ();
                if (src === undefined) {
                    return dst;
                }
                if (src.y !== undefined) {
                    dst.y = src.y;
                }
                if (src.z !== undefined) {
                    dst.z = src.z;
                }
                return dst;
            }

            shallowClone() {
                const dst = new VectorYZ();
                dst.y = this.y;
                dst.z = this.z;
                return dst;
            }

            deepClone() {
                const json = VectorYZ.toObject(this);
                const dst = VectorYZ.fromObject(json);
                return dst;
            }
        }
        export type IVectorYZ = VectorYZ;


        export type VectorYZLT_keys = 'y' | 'z' | 'lT';
        export interface VectorYZLT_createType {
            y?: number,
            z?: number,
            lT?: number,
        }
        export interface VectorYZLT_json {
            y?: JsonNumber;
            z?: JsonNumber;
            lT?: JsonNumber;
        }
        interface VectorYZLT_json_in {
            __proto_name?: unknown;
            y?: unknown;
            z?: unknown;
            lT?: unknown;
        }
        export class VectorYZLT {
            __proto_name = "ng.geometry.VectorYZLT";
            y: number = 0;
            z: number = 0;
            lT: number = 0;

            static fromObject(src_unknown: unknown): VectorYZLT {
                const dst = new VectorYZLT();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted VectorYZLT but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as VectorYZLT_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for VectorYZLT but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.y !== undefined && src.y !== null) {
                    if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                        dst.y = AsNum(src.y);
                    }
                    else {
                        console.log('Expected y of VectorYZLT to be a number but was ', typeof src.y, src.y)
                    }
                }
                if (src.z !== undefined && src.z !== null) {
                    if (typeof src.z === "number" || src.z === 'NaN' || src.z === 'Infinity' || src.z === '-Infinity') {
                        dst.z = AsNum(src.z);
                    }
                    else {
                        console.log('Expected z of VectorYZLT to be a number but was ', typeof src.z, src.z)
                    }
                }
                if (src.lT !== undefined && src.lT !== null) {
                    if (typeof src.lT === "number" || src.lT === 'NaN' || src.lT === 'Infinity' || src.lT === '-Infinity') {
                        dst.lT = AsNum(src.lT);
                    }
                    else {
                        console.log('Expected lT of VectorYZLT to be a number but was ', typeof src.lT, src.lT)
                    }
                }
                return dst;
            }

            static toObject(src: VectorYZLT | null | undefined): VectorYZLT_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.VectorYZLT is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.VectorYZLT") {
                    console.error('Expected ng.geometry.VectorYZLT but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : VectorYZLT_json = {
                    y: AsJsonNum(src.y),
                    z: AsJsonNum(src.z),
                    lT: AsJsonNum(src.lT),
                };
                return dst;
            }

            static create(src?: VectorYZLT_createType) {
                const dst = new VectorYZLT();
                if (src === undefined) {
                    return dst;
                }
                if (src.y !== undefined) {
                    dst.y = src.y;
                }
                if (src.z !== undefined) {
                    dst.z = src.z;
                }
                if (src.lT !== undefined) {
                    dst.lT = src.lT;
                }
                return dst;
            }

            shallowClone() {
                const dst = new VectorYZLT();
                dst.y = this.y;
                dst.z = this.z;
                dst.lT = this.lT;
                return dst;
            }

            deepClone() {
                const json = VectorYZLT.toObject(this);
                const dst = VectorYZLT.fromObject(json);
                return dst;
            }
        }
        export type IVectorYZLT = VectorYZLT;


        export type Point2D_keys = 'x' | 'y';
        export interface Point2D_createType {
            x?: number,
            y?: number,
        }
        export interface Point2D_json {
            x?: JsonNumber;
            y?: JsonNumber;
        }
        interface Point2D_json_in {
            __proto_name?: unknown;
            x?: unknown;
            y?: unknown;
        }
        export class Point2D {
            __proto_name = "ng.geometry.Point2D";
            x: number = 0;
            y: number = 0;

            static fromObject(src_unknown: unknown): Point2D {
                const dst = new Point2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Point2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Point2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Point2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.x !== undefined && src.x !== null) {
                    if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                        dst.x = AsNum(src.x);
                    }
                    else {
                        console.log('Expected x of Point2D to be a number but was ', typeof src.x, src.x)
                    }
                }
                if (src.y !== undefined && src.y !== null) {
                    if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                        dst.y = AsNum(src.y);
                    }
                    else {
                        console.log('Expected y of Point2D to be a number but was ', typeof src.y, src.y)
                    }
                }
                return dst;
            }

            static toObject(src: Point2D | null | undefined): Point2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Point2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Point2D") {
                    console.error('Expected ng.geometry.Point2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Point2D_json = {
                    x: AsJsonNum(src.x),
                    y: AsJsonNum(src.y),
                };
                return dst;
            }

            static create(src?: Point2D_createType) {
                const dst = new Point2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.x !== undefined) {
                    dst.x = src.x;
                }
                if (src.y !== undefined) {
                    dst.y = src.y;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Point2D();
                dst.x = this.x;
                dst.y = this.y;
                return dst;
            }

            deepClone() {
                const json = Point2D.toObject(this);
                const dst = Point2D.fromObject(json);
                return dst;
            }
        }
        export type IPoint2D = Point2D;


        export type Line2D_keys = 'id' | 'start' | 'end';
        export interface Line2D_createType {
            id?: ng.utils.ID | null,
            start?: ng.geometry.Point2D | null,
            end?: ng.geometry.Point2D | null,
        }
        export interface Line2D_json {
            id?: ng.utils.ID_json;
            start?: ng.geometry.Point2D_json;
            end?: ng.geometry.Point2D_json;
        }
        interface Line2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            start?: unknown;
            end?: unknown;
        }
        export class Line2D {
            __proto_name = "ng.geometry.Line2D";
            id: ng.utils.ID | null = null;
            start: ng.geometry.Point2D | null = null;
            end: ng.geometry.Point2D | null = null;

            static fromObject(src_unknown: unknown): Line2D {
                const dst = new Line2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Line2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Line2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Line2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.start !== undefined && src.start !== null) {
                    dst.start = ng.geometry.Point2D.fromObject(src.start);
                }
                if (src.end !== undefined && src.end !== null) {
                    dst.end = ng.geometry.Point2D.fromObject(src.end);
                }
                return dst;
            }

            static toObject(src: Line2D | null | undefined): Line2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Line2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Line2D") {
                    console.error('Expected ng.geometry.Line2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Line2D_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.start !== null)
                {
                    const parsed = ng.geometry.Point2D.toObject(src.start);
                    if(parsed === null) return null;
                    dst.start = parsed;
                }
                if(src.end !== null)
                {
                    const parsed = ng.geometry.Point2D.toObject(src.end);
                    if(parsed === null) return null;
                    dst.end = parsed;
                }
                return dst;
            }

            static create(src?: Line2D_createType) {
                const dst = new Line2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.end !== undefined) {
                    dst.end = src.end;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Line2D();
                dst.id = this.id;
                dst.start = this.start;
                dst.end = this.end;
                return dst;
            }

            deepClone() {
                const json = Line2D.toObject(this);
                const dst = Line2D.fromObject(json);
                return dst;
            }
        }
        export type ILine2D = Line2D;


        export type Arc2D_keys = 'id' | 'center' | 'radius' | 'startAngle' | 'endAngle';
        export interface Arc2D_createType {
            id?: ng.utils.ID | null,
            center?: ng.geometry.Point2D | null,
            radius?: number,
            startAngle?: number,
            endAngle?: number,
        }
        export interface Arc2D_json {
            id?: ng.utils.ID_json;
            center?: ng.geometry.Point2D_json;
            radius?: JsonNumber;
            startAngle?: JsonNumber;
            endAngle?: JsonNumber;
        }
        interface Arc2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            center?: unknown;
            radius?: unknown;
            startAngle?: unknown;
            endAngle?: unknown;
        }
        export class Arc2D {
            __proto_name = "ng.geometry.Arc2D";
            id: ng.utils.ID | null = null;
            center: ng.geometry.Point2D | null = null;
            radius: number = 0;
            startAngle: number = 0;
            endAngle: number = 0;

            static fromObject(src_unknown: unknown): Arc2D {
                const dst = new Arc2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Arc2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Arc2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Arc2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.center !== undefined && src.center !== null) {
                    dst.center = ng.geometry.Point2D.fromObject(src.center);
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of Arc2D to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                if (src.startAngle !== undefined && src.startAngle !== null) {
                    if (typeof src.startAngle === "number" || src.startAngle === 'NaN' || src.startAngle === 'Infinity' || src.startAngle === '-Infinity') {
                        dst.startAngle = AsNum(src.startAngle);
                    }
                    else {
                        console.log('Expected startAngle of Arc2D to be a number but was ', typeof src.startAngle, src.startAngle)
                    }
                }
                if (src.endAngle !== undefined && src.endAngle !== null) {
                    if (typeof src.endAngle === "number" || src.endAngle === 'NaN' || src.endAngle === 'Infinity' || src.endAngle === '-Infinity') {
                        dst.endAngle = AsNum(src.endAngle);
                    }
                    else {
                        console.log('Expected endAngle of Arc2D to be a number but was ', typeof src.endAngle, src.endAngle)
                    }
                }
                return dst;
            }

            static toObject(src: Arc2D | null | undefined): Arc2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Arc2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Arc2D") {
                    console.error('Expected ng.geometry.Arc2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Arc2D_json = {
                    radius: AsJsonNum(src.radius),
                    startAngle: AsJsonNum(src.startAngle),
                    endAngle: AsJsonNum(src.endAngle),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.center !== null)
                {
                    const parsed = ng.geometry.Point2D.toObject(src.center);
                    if(parsed === null) return null;
                    dst.center = parsed;
                }
                return dst;
            }

            static create(src?: Arc2D_createType) {
                const dst = new Arc2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.center !== undefined) {
                    dst.center = src.center;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                if (src.startAngle !== undefined) {
                    dst.startAngle = src.startAngle;
                }
                if (src.endAngle !== undefined) {
                    dst.endAngle = src.endAngle;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Arc2D();
                dst.id = this.id;
                dst.center = this.center;
                dst.radius = this.radius;
                dst.startAngle = this.startAngle;
                dst.endAngle = this.endAngle;
                return dst;
            }

            deepClone() {
                const json = Arc2D.toObject(this);
                const dst = Arc2D.fromObject(json);
                return dst;
            }
        }
        export type IArc2D = Arc2D;


        export type Circle2D_keys = 'id' | 'center' | 'radius';
        export interface Circle2D_createType {
            id?: ng.utils.ID | null,
            center?: ng.geometry.Point2D | null,
            radius?: number,
        }
        export interface Circle2D_json {
            id?: ng.utils.ID_json;
            center?: ng.geometry.Point2D_json;
            radius?: JsonNumber;
        }
        interface Circle2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            center?: unknown;
            radius?: unknown;
        }
        export class Circle2D {
            __proto_name = "ng.geometry.Circle2D";
            id: ng.utils.ID | null = null;
            center: ng.geometry.Point2D | null = null;
            radius: number = 0;

            static fromObject(src_unknown: unknown): Circle2D {
                const dst = new Circle2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Circle2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Circle2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Circle2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.center !== undefined && src.center !== null) {
                    dst.center = ng.geometry.Point2D.fromObject(src.center);
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of Circle2D to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                return dst;
            }

            static toObject(src: Circle2D | null | undefined): Circle2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Circle2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Circle2D") {
                    console.error('Expected ng.geometry.Circle2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Circle2D_json = {
                    radius: AsJsonNum(src.radius),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.center !== null)
                {
                    const parsed = ng.geometry.Point2D.toObject(src.center);
                    if(parsed === null) return null;
                    dst.center = parsed;
                }
                return dst;
            }

            static create(src?: Circle2D_createType) {
                const dst = new Circle2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.center !== undefined) {
                    dst.center = src.center;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Circle2D();
                dst.id = this.id;
                dst.center = this.center;
                dst.radius = this.radius;
                return dst;
            }

            deepClone() {
                const json = Circle2D.toObject(this);
                const dst = Circle2D.fromObject(json);
                return dst;
            }
        }
        export type ICircle2D = Circle2D;


        export type Curve2D_keys = 'id' | 'arcSegment' | 'circleSegment' | 'lineSegment';
        export interface Curve2D_createType {
            id?: ng.utils.ID | null,
            arcSegment?: ng.geometry.Arc2D | null,
            circleSegment?: ng.geometry.Circle2D | null,
            lineSegment?: ng.geometry.Line2D | null,
        }
        export interface Curve2D_json {
            id?: ng.utils.ID_json;
            arcSegment?: ng.geometry.Arc2D_json;
            circleSegment?: ng.geometry.Circle2D_json;
            lineSegment?: ng.geometry.Line2D_json;
        }
        interface Curve2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            arcSegment?: unknown;
            circleSegment?: unknown;
            lineSegment?: unknown;
        }
        export class Curve2D {
            __proto_name = "ng.geometry.Curve2D";
            id: ng.utils.ID | null = null;
            // this is a one of
            segment: {type: 'arcSegment'; arcSegment: ng.geometry.Arc2D} | {type: 'circleSegment'; circleSegment: ng.geometry.Circle2D} | {type: 'lineSegment'; lineSegment: ng.geometry.Line2D} | null = null;

            /** Gets the `ArcSegment` value (or null) from the oneof `segment` */
            getArcSegment(): ng.geometry.Arc2D | null {
                if(this.segment === null) return null;
                if(this.segment.type !== 'arcSegment') return null;
                return this.segment.arcSegment;
            }

            /** Sets the `ArcSegment` value for the oneof `segment`*/
            setArcSegment(value: ng.geometry.Arc2D | null) {
                if(value !== null) {
                    this.segment = {type: 'arcSegment', arcSegment:value};
                }
                else {
                    this.segment = null;
                }
            }

            /** Gets the `CircleSegment` value (or null) from the oneof `segment` */
            getCircleSegment(): ng.geometry.Circle2D | null {
                if(this.segment === null) return null;
                if(this.segment.type !== 'circleSegment') return null;
                return this.segment.circleSegment;
            }

            /** Sets the `CircleSegment` value for the oneof `segment`*/
            setCircleSegment(value: ng.geometry.Circle2D | null) {
                if(value !== null) {
                    this.segment = {type: 'circleSegment', circleSegment:value};
                }
                else {
                    this.segment = null;
                }
            }

            /** Gets the `LineSegment` value (or null) from the oneof `segment` */
            getLineSegment(): ng.geometry.Line2D | null {
                if(this.segment === null) return null;
                if(this.segment.type !== 'lineSegment') return null;
                return this.segment.lineSegment;
            }

            /** Sets the `LineSegment` value for the oneof `segment`*/
            setLineSegment(value: ng.geometry.Line2D | null) {
                if(value !== null) {
                    this.segment = {type: 'lineSegment', lineSegment:value};
                }
                else {
                    this.segment = null;
                }
            }

            static fromObject(src_unknown: unknown): Curve2D {
                const dst = new Curve2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Curve2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Curve2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Curve2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.arcSegment !== undefined && src.arcSegment !== null) {
                    dst.setArcSegment(ng.geometry.Arc2D.fromObject(src.arcSegment));
                }
                if (src.circleSegment !== undefined && src.circleSegment !== null) {
                    dst.setCircleSegment(ng.geometry.Circle2D.fromObject(src.circleSegment));
                }
                if (src.lineSegment !== undefined && src.lineSegment !== null) {
                    dst.setLineSegment(ng.geometry.Line2D.fromObject(src.lineSegment));
                }
                return dst;
            }

            static toObject(src: Curve2D | null | undefined): Curve2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Curve2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Curve2D") {
                    console.error('Expected ng.geometry.Curve2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Curve2D_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const arcSegment = src.getArcSegment();
                if(arcSegment !== null)
                {
                    const parsed = ng.geometry.Arc2D.toObject(arcSegment);
                    if(parsed === null) return null;
                    dst.arcSegment = parsed;
                }
                const circleSegment = src.getCircleSegment();
                if(circleSegment !== null)
                {
                    const parsed = ng.geometry.Circle2D.toObject(circleSegment);
                    if(parsed === null) return null;
                    dst.circleSegment = parsed;
                }
                const lineSegment = src.getLineSegment();
                if(lineSegment !== null)
                {
                    const parsed = ng.geometry.Line2D.toObject(lineSegment);
                    if(parsed === null) return null;
                    dst.lineSegment = parsed;
                }
                return dst;
            }

            static create(src?: Curve2D_createType) {
                const dst = new Curve2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                // part of the segment oneof 
                if (src.arcSegment !== undefined && src.arcSegment !== null) {
                    dst.setArcSegment(src.arcSegment);
                }
                // part of the segment oneof 
                if (src.circleSegment !== undefined && src.circleSegment !== null) {
                    dst.setCircleSegment(src.circleSegment);
                }
                // part of the segment oneof 
                if (src.lineSegment !== undefined && src.lineSegment !== null) {
                    dst.setLineSegment(src.lineSegment);
                }
                return dst;
            }

            shallowClone() {
                const dst = new Curve2D();
                dst.id = this.id;
                dst.segment = this.segment;
                return dst;
            }

            deepClone() {
                const json = Curve2D.toObject(this);
                const dst = Curve2D.fromObject(json);
                return dst;
            }
        }
        export type ICurve2D = Curve2D;


        export type PolyLine2D_keys = 'id' | 'points';
        export interface PolyLine2D_createType {
            id?: ng.utils.ID | null,
            points?: ng.geometry.Point2D[],
        }
        export interface PolyLine2D_json {
            id?: ng.utils.ID_json;
            points: ng.geometry.Point2D_json[];
        }
        interface PolyLine2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            points?: unknown;
        }
        export class PolyLine2D {
            __proto_name = "ng.geometry.PolyLine2D";
            id: ng.utils.ID | null = null;
            points: ng.geometry.Point2D[] = [];

            static fromObject(src_unknown: unknown): PolyLine2D {
                const dst = new PolyLine2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PolyLine2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PolyLine2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PolyLine2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.points !== undefined && src.points !== null) {
                    if (Array.isArray(src.points)) {
                        for (const element of src.points) {
                            dst.points.push(ng.geometry.Point2D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected points of PolyLine2D to be a array but was ', typeof src.points, src.points)
                    }
                }
                return dst;
            }

            static toObject(src: PolyLine2D | null | undefined): PolyLine2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.PolyLine2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.PolyLine2D") {
                    console.error('Expected ng.geometry.PolyLine2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PolyLine2D_json = {
                    points: new Array<ng.geometry.Point2D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.points !== null) {
                    for (const element of src.points) {
                        const parsed = ng.geometry.Point2D.toObject(element);
                        if(parsed === null) return null;
                        dst.points.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: PolyLine2D_createType) {
                const dst = new PolyLine2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.points !== undefined) {
                    dst.points = src.points;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PolyLine2D();
                dst.id = this.id;
                dst.points = this.points;
                return dst;
            }

            deepClone() {
                const json = PolyLine2D.toObject(this);
                const dst = PolyLine2D.fromObject(json);
                return dst;
            }
        }
        export type IPolyLine2D = PolyLine2D;


        export type PolyCurve2D_keys = 'id' | 'curves';
        export interface PolyCurve2D_createType {
            id?: ng.utils.ID | null,
            curves?: ng.geometry.Curve2D[],
        }
        export interface PolyCurve2D_json {
            id?: ng.utils.ID_json;
            curves: ng.geometry.Curve2D_json[];
        }
        interface PolyCurve2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            curves?: unknown;
        }
        export class PolyCurve2D {
            __proto_name = "ng.geometry.PolyCurve2D";
            id: ng.utils.ID | null = null;
            curves: ng.geometry.Curve2D[] = [];

            static fromObject(src_unknown: unknown): PolyCurve2D {
                const dst = new PolyCurve2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PolyCurve2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PolyCurve2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PolyCurve2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.curves !== undefined && src.curves !== null) {
                    if (Array.isArray(src.curves)) {
                        for (const element of src.curves) {
                            dst.curves.push(ng.geometry.Curve2D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected curves of PolyCurve2D to be a array but was ', typeof src.curves, src.curves)
                    }
                }
                return dst;
            }

            static toObject(src: PolyCurve2D | null | undefined): PolyCurve2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.PolyCurve2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.PolyCurve2D") {
                    console.error('Expected ng.geometry.PolyCurve2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PolyCurve2D_json = {
                    curves: new Array<ng.geometry.Curve2D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.curves !== null) {
                    for (const element of src.curves) {
                        const parsed = ng.geometry.Curve2D.toObject(element);
                        if(parsed === null) return null;
                        dst.curves.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: PolyCurve2D_createType) {
                const dst = new PolyCurve2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.curves !== undefined) {
                    dst.curves = src.curves;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PolyCurve2D();
                dst.id = this.id;
                dst.curves = this.curves;
                return dst;
            }

            deepClone() {
                const json = PolyCurve2D.toObject(this);
                const dst = PolyCurve2D.fromObject(json);
                return dst;
            }
        }
        export type IPolyCurve2D = PolyCurve2D;


        export type LineFace2D_keys = 'id' | 'perimeter' | 'holes' | 'additionalPerimeters';
        export interface LineFace2D_createType {
            id?: ng.utils.ID | null,
            perimeter?: ng.geometry.PolyLine2D | null,
            holes?: ng.geometry.PolyLine2D[],
            additionalPerimeters?: ng.geometry.PolyLine2D[],
        }
        export interface LineFace2D_json {
            id?: ng.utils.ID_json;
            perimeter?: ng.geometry.PolyLine2D_json;
            holes: ng.geometry.PolyLine2D_json[];
            additionalPerimeters: ng.geometry.PolyLine2D_json[];
        }
        interface LineFace2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            perimeter?: unknown;
            holes?: unknown;
            additionalPerimeters?: unknown;
        }
        export class LineFace2D {
            __proto_name = "ng.geometry.LineFace2D";
            id: ng.utils.ID | null = null;
            perimeter: ng.geometry.PolyLine2D | null = null;
            holes: ng.geometry.PolyLine2D[] = [];
            additionalPerimeters: ng.geometry.PolyLine2D[] = [];

            static fromObject(src_unknown: unknown): LineFace2D {
                const dst = new LineFace2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LineFace2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LineFace2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LineFace2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.perimeter !== undefined && src.perimeter !== null) {
                    dst.perimeter = ng.geometry.PolyLine2D.fromObject(src.perimeter);
                }
                if (src.holes !== undefined && src.holes !== null) {
                    if (Array.isArray(src.holes)) {
                        for (const element of src.holes) {
                            dst.holes.push(ng.geometry.PolyLine2D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected holes of LineFace2D to be a array but was ', typeof src.holes, src.holes)
                    }
                }
                if (src.additionalPerimeters !== undefined && src.additionalPerimeters !== null) {
                    if (Array.isArray(src.additionalPerimeters)) {
                        for (const element of src.additionalPerimeters) {
                            dst.additionalPerimeters.push(ng.geometry.PolyLine2D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected additionalPerimeters of LineFace2D to be a array but was ', typeof src.additionalPerimeters, src.additionalPerimeters)
                    }
                }
                return dst;
            }

            static toObject(src: LineFace2D | null | undefined): LineFace2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.LineFace2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.LineFace2D") {
                    console.error('Expected ng.geometry.LineFace2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LineFace2D_json = {
                    holes: new Array<ng.geometry.PolyLine2D_json>(),
                    additionalPerimeters: new Array<ng.geometry.PolyLine2D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.perimeter !== null)
                {
                    const parsed = ng.geometry.PolyLine2D.toObject(src.perimeter);
                    if(parsed === null) return null;
                    dst.perimeter = parsed;
                }
                if (src.holes !== null) {
                    for (const element of src.holes) {
                        const parsed = ng.geometry.PolyLine2D.toObject(element);
                        if(parsed === null) return null;
                        dst.holes.push(parsed);
                    }
                }
                if (src.additionalPerimeters !== null) {
                    for (const element of src.additionalPerimeters) {
                        const parsed = ng.geometry.PolyLine2D.toObject(element);
                        if(parsed === null) return null;
                        dst.additionalPerimeters.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: LineFace2D_createType) {
                const dst = new LineFace2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.perimeter !== undefined) {
                    dst.perimeter = src.perimeter;
                }
                if (src.holes !== undefined) {
                    dst.holes = src.holes;
                }
                if (src.additionalPerimeters !== undefined) {
                    dst.additionalPerimeters = src.additionalPerimeters;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LineFace2D();
                dst.id = this.id;
                dst.perimeter = this.perimeter;
                dst.holes = this.holes;
                dst.additionalPerimeters = this.additionalPerimeters;
                return dst;
            }

            deepClone() {
                const json = LineFace2D.toObject(this);
                const dst = LineFace2D.fromObject(json);
                return dst;
            }
        }
        export type ILineFace2D = LineFace2D;


        export type CurveFace2D_keys = 'id' | 'perimeter' | 'holes' | 'additionalPerimeters';
        export interface CurveFace2D_createType {
            id?: ng.utils.ID | null,
            perimeter?: ng.geometry.PolyCurve2D | null,
            holes?: ng.geometry.PolyCurve2D[],
            additionalPerimeters?: ng.geometry.PolyCurve2D[],
        }
        export interface CurveFace2D_json {
            id?: ng.utils.ID_json;
            perimeter?: ng.geometry.PolyCurve2D_json;
            holes: ng.geometry.PolyCurve2D_json[];
            additionalPerimeters: ng.geometry.PolyCurve2D_json[];
        }
        interface CurveFace2D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            perimeter?: unknown;
            holes?: unknown;
            additionalPerimeters?: unknown;
        }
        export class CurveFace2D {
            __proto_name = "ng.geometry.CurveFace2D";
            id: ng.utils.ID | null = null;
            perimeter: ng.geometry.PolyCurve2D | null = null;
            holes: ng.geometry.PolyCurve2D[] = [];
            additionalPerimeters: ng.geometry.PolyCurve2D[] = [];

            static fromObject(src_unknown: unknown): CurveFace2D {
                const dst = new CurveFace2D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted CurveFace2D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as CurveFace2D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for CurveFace2D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.perimeter !== undefined && src.perimeter !== null) {
                    dst.perimeter = ng.geometry.PolyCurve2D.fromObject(src.perimeter);
                }
                if (src.holes !== undefined && src.holes !== null) {
                    if (Array.isArray(src.holes)) {
                        for (const element of src.holes) {
                            dst.holes.push(ng.geometry.PolyCurve2D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected holes of CurveFace2D to be a array but was ', typeof src.holes, src.holes)
                    }
                }
                if (src.additionalPerimeters !== undefined && src.additionalPerimeters !== null) {
                    if (Array.isArray(src.additionalPerimeters)) {
                        for (const element of src.additionalPerimeters) {
                            dst.additionalPerimeters.push(ng.geometry.PolyCurve2D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected additionalPerimeters of CurveFace2D to be a array but was ', typeof src.additionalPerimeters, src.additionalPerimeters)
                    }
                }
                return dst;
            }

            static toObject(src: CurveFace2D | null | undefined): CurveFace2D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.CurveFace2D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.CurveFace2D") {
                    console.error('Expected ng.geometry.CurveFace2D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : CurveFace2D_json = {
                    holes: new Array<ng.geometry.PolyCurve2D_json>(),
                    additionalPerimeters: new Array<ng.geometry.PolyCurve2D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.perimeter !== null)
                {
                    const parsed = ng.geometry.PolyCurve2D.toObject(src.perimeter);
                    if(parsed === null) return null;
                    dst.perimeter = parsed;
                }
                if (src.holes !== null) {
                    for (const element of src.holes) {
                        const parsed = ng.geometry.PolyCurve2D.toObject(element);
                        if(parsed === null) return null;
                        dst.holes.push(parsed);
                    }
                }
                if (src.additionalPerimeters !== null) {
                    for (const element of src.additionalPerimeters) {
                        const parsed = ng.geometry.PolyCurve2D.toObject(element);
                        if(parsed === null) return null;
                        dst.additionalPerimeters.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: CurveFace2D_createType) {
                const dst = new CurveFace2D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.perimeter !== undefined) {
                    dst.perimeter = src.perimeter;
                }
                if (src.holes !== undefined) {
                    dst.holes = src.holes;
                }
                if (src.additionalPerimeters !== undefined) {
                    dst.additionalPerimeters = src.additionalPerimeters;
                }
                return dst;
            }

            shallowClone() {
                const dst = new CurveFace2D();
                dst.id = this.id;
                dst.perimeter = this.perimeter;
                dst.holes = this.holes;
                dst.additionalPerimeters = this.additionalPerimeters;
                return dst;
            }

            deepClone() {
                const json = CurveFace2D.toObject(this);
                const dst = CurveFace2D.fromObject(json);
                return dst;
            }
        }
        export type ICurveFace2D = CurveFace2D;


        export type Vector3D_keys = 'x' | 'y' | 'z';
        export interface Vector3D_createType {
            x?: number,
            y?: number,
            z?: number,
        }
        export interface Vector3D_json {
            x?: JsonNumber;
            y?: JsonNumber;
            z?: JsonNumber;
        }
        interface Vector3D_json_in {
            __proto_name?: unknown;
            x?: unknown;
            y?: unknown;
            z?: unknown;
        }
        export class Vector3D {
            __proto_name = "ng.geometry.Vector3D";
            x: number = 0;
            y: number = 0;
            z: number = 0;

            static fromObject(src_unknown: unknown): Vector3D {
                const dst = new Vector3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Vector3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Vector3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Vector3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.x !== undefined && src.x !== null) {
                    if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                        dst.x = AsNum(src.x);
                    }
                    else {
                        console.log('Expected x of Vector3D to be a number but was ', typeof src.x, src.x)
                    }
                }
                if (src.y !== undefined && src.y !== null) {
                    if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                        dst.y = AsNum(src.y);
                    }
                    else {
                        console.log('Expected y of Vector3D to be a number but was ', typeof src.y, src.y)
                    }
                }
                if (src.z !== undefined && src.z !== null) {
                    if (typeof src.z === "number" || src.z === 'NaN' || src.z === 'Infinity' || src.z === '-Infinity') {
                        dst.z = AsNum(src.z);
                    }
                    else {
                        console.log('Expected z of Vector3D to be a number but was ', typeof src.z, src.z)
                    }
                }
                return dst;
            }

            static toObject(src: Vector3D | null | undefined): Vector3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Vector3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Vector3D") {
                    console.error('Expected ng.geometry.Vector3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Vector3D_json = {
                    x: AsJsonNum(src.x),
                    y: AsJsonNum(src.y),
                    z: AsJsonNum(src.z),
                };
                return dst;
            }

            static create(src?: Vector3D_createType) {
                const dst = new Vector3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.x !== undefined) {
                    dst.x = src.x;
                }
                if (src.y !== undefined) {
                    dst.y = src.y;
                }
                if (src.z !== undefined) {
                    dst.z = src.z;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Vector3D();
                dst.x = this.x;
                dst.y = this.y;
                dst.z = this.z;
                return dst;
            }

            deepClone() {
                const json = Vector3D.toObject(this);
                const dst = Vector3D.fromObject(json);
                return dst;
            }
        }
        export type IVector3D = Vector3D;


        export type Point3D_keys = 'x' | 'y' | 'z';
        export interface Point3D_createType {
            x?: number,
            y?: number,
            z?: number,
        }
        export interface Point3D_json {
            x?: JsonNumber;
            y?: JsonNumber;
            z?: JsonNumber;
        }
        interface Point3D_json_in {
            __proto_name?: unknown;
            x?: unknown;
            y?: unknown;
            z?: unknown;
        }
        export class Point3D {
            __proto_name = "ng.geometry.Point3D";
            x: number = 0;
            y: number = 0;
            z: number = 0;

            static fromObject(src_unknown: unknown): Point3D {
                const dst = new Point3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Point3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Point3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Point3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.x !== undefined && src.x !== null) {
                    if (typeof src.x === "number" || src.x === 'NaN' || src.x === 'Infinity' || src.x === '-Infinity') {
                        dst.x = AsNum(src.x);
                    }
                    else {
                        console.log('Expected x of Point3D to be a number but was ', typeof src.x, src.x)
                    }
                }
                if (src.y !== undefined && src.y !== null) {
                    if (typeof src.y === "number" || src.y === 'NaN' || src.y === 'Infinity' || src.y === '-Infinity') {
                        dst.y = AsNum(src.y);
                    }
                    else {
                        console.log('Expected y of Point3D to be a number but was ', typeof src.y, src.y)
                    }
                }
                if (src.z !== undefined && src.z !== null) {
                    if (typeof src.z === "number" || src.z === 'NaN' || src.z === 'Infinity' || src.z === '-Infinity') {
                        dst.z = AsNum(src.z);
                    }
                    else {
                        console.log('Expected z of Point3D to be a number but was ', typeof src.z, src.z)
                    }
                }
                return dst;
            }

            static toObject(src: Point3D | null | undefined): Point3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Point3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Point3D") {
                    console.error('Expected ng.geometry.Point3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Point3D_json = {
                    x: AsJsonNum(src.x),
                    y: AsJsonNum(src.y),
                    z: AsJsonNum(src.z),
                };
                return dst;
            }

            static create(src?: Point3D_createType) {
                const dst = new Point3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.x !== undefined) {
                    dst.x = src.x;
                }
                if (src.y !== undefined) {
                    dst.y = src.y;
                }
                if (src.z !== undefined) {
                    dst.z = src.z;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Point3D();
                dst.x = this.x;
                dst.y = this.y;
                dst.z = this.z;
                return dst;
            }

            deepClone() {
                const json = Point3D.toObject(this);
                const dst = Point3D.fromObject(json);
                return dst;
            }
        }
        export type IPoint3D = Point3D;


        export type Orientation_keys = 'xDir' | 'yDir' | 'zDir';
        export interface Orientation_createType {
            xDir?: ng.geometry.Vector3D | null,
            yDir?: ng.geometry.Vector3D | null,
            zDir?: ng.geometry.Vector3D | null,
        }
        export interface Orientation_json {
            xDir?: ng.geometry.Vector3D_json;
            yDir?: ng.geometry.Vector3D_json;
            zDir?: ng.geometry.Vector3D_json;
        }
        interface Orientation_json_in {
            __proto_name?: unknown;
            xDir?: unknown;
            yDir?: unknown;
            zDir?: unknown;
        }
        export class Orientation {
            __proto_name = "ng.geometry.Orientation";
            xDir: ng.geometry.Vector3D | null = null;
            yDir: ng.geometry.Vector3D | null = null;
            zDir: ng.geometry.Vector3D | null = null;

            static fromObject(src_unknown: unknown): Orientation {
                const dst = new Orientation();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Orientation but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Orientation_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Orientation but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.xDir !== undefined && src.xDir !== null) {
                    dst.xDir = ng.geometry.Vector3D.fromObject(src.xDir);
                }
                if (src.yDir !== undefined && src.yDir !== null) {
                    dst.yDir = ng.geometry.Vector3D.fromObject(src.yDir);
                }
                if (src.zDir !== undefined && src.zDir !== null) {
                    dst.zDir = ng.geometry.Vector3D.fromObject(src.zDir);
                }
                return dst;
            }

            static toObject(src: Orientation | null | undefined): Orientation_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Orientation is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Orientation") {
                    console.error('Expected ng.geometry.Orientation but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Orientation_json = {
                };
                if(src.xDir !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.xDir);
                    if(parsed === null) return null;
                    dst.xDir = parsed;
                }
                if(src.yDir !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.yDir);
                    if(parsed === null) return null;
                    dst.yDir = parsed;
                }
                if(src.zDir !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.zDir);
                    if(parsed === null) return null;
                    dst.zDir = parsed;
                }
                return dst;
            }

            static create(src?: Orientation_createType) {
                const dst = new Orientation();
                if (src === undefined) {
                    return dst;
                }
                if (src.xDir !== undefined) {
                    dst.xDir = src.xDir;
                }
                if (src.yDir !== undefined) {
                    dst.yDir = src.yDir;
                }
                if (src.zDir !== undefined) {
                    dst.zDir = src.zDir;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Orientation();
                dst.xDir = this.xDir;
                dst.yDir = this.yDir;
                dst.zDir = this.zDir;
                return dst;
            }

            deepClone() {
                const json = Orientation.toObject(this);
                const dst = Orientation.fromObject(json);
                return dst;
            }
        }
        export type IOrientation = Orientation;


        export type Line3D_keys = 'id' | 'start' | 'end';
        export interface Line3D_createType {
            id?: ng.utils.ID | null,
            start?: ng.geometry.Point3D | null,
            end?: ng.geometry.Point3D | null,
        }
        export interface Line3D_json {
            id?: ng.utils.ID_json;
            start?: ng.geometry.Point3D_json;
            end?: ng.geometry.Point3D_json;
        }
        interface Line3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            start?: unknown;
            end?: unknown;
        }
        export class Line3D {
            __proto_name = "ng.geometry.Line3D";
            id: ng.utils.ID | null = null;
            start: ng.geometry.Point3D | null = null;
            end: ng.geometry.Point3D | null = null;

            static fromObject(src_unknown: unknown): Line3D {
                const dst = new Line3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Line3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Line3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Line3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.start !== undefined && src.start !== null) {
                    dst.start = ng.geometry.Point3D.fromObject(src.start);
                }
                if (src.end !== undefined && src.end !== null) {
                    dst.end = ng.geometry.Point3D.fromObject(src.end);
                }
                return dst;
            }

            static toObject(src: Line3D | null | undefined): Line3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Line3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Line3D") {
                    console.error('Expected ng.geometry.Line3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Line3D_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.start !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.start);
                    if(parsed === null) return null;
                    dst.start = parsed;
                }
                if(src.end !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.end);
                    if(parsed === null) return null;
                    dst.end = parsed;
                }
                return dst;
            }

            static create(src?: Line3D_createType) {
                const dst = new Line3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.start !== undefined) {
                    dst.start = src.start;
                }
                if (src.end !== undefined) {
                    dst.end = src.end;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Line3D();
                dst.id = this.id;
                dst.start = this.start;
                dst.end = this.end;
                return dst;
            }

            deepClone() {
                const json = Line3D.toObject(this);
                const dst = Line3D.fromObject(json);
                return dst;
            }
        }
        export type ILine3D = Line3D;


        export type Arc3D_keys = 'id' | 'center' | 'normal' | 'radius' | 'startAngle' | 'endAngle';
        export interface Arc3D_createType {
            id?: ng.utils.ID | null,
            center?: ng.geometry.Point3D | null,
            normal?: ng.geometry.Vector3D | null,
            radius?: number,
            startAngle?: number,
            endAngle?: number,
        }
        export interface Arc3D_json {
            id?: ng.utils.ID_json;
            center?: ng.geometry.Point3D_json;
            normal?: ng.geometry.Vector3D_json;
            radius?: JsonNumber;
            startAngle?: JsonNumber;
            endAngle?: JsonNumber;
        }
        interface Arc3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            center?: unknown;
            normal?: unknown;
            radius?: unknown;
            startAngle?: unknown;
            endAngle?: unknown;
        }
        export class Arc3D {
            __proto_name = "ng.geometry.Arc3D";
            id: ng.utils.ID | null = null;
            center: ng.geometry.Point3D | null = null;
            normal: ng.geometry.Vector3D | null = null;
            radius: number = 0;
            startAngle: number = 0;
            endAngle: number = 0;

            static fromObject(src_unknown: unknown): Arc3D {
                const dst = new Arc3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Arc3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Arc3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Arc3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.center !== undefined && src.center !== null) {
                    dst.center = ng.geometry.Point3D.fromObject(src.center);
                }
                if (src.normal !== undefined && src.normal !== null) {
                    dst.normal = ng.geometry.Vector3D.fromObject(src.normal);
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of Arc3D to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                if (src.startAngle !== undefined && src.startAngle !== null) {
                    if (typeof src.startAngle === "number" || src.startAngle === 'NaN' || src.startAngle === 'Infinity' || src.startAngle === '-Infinity') {
                        dst.startAngle = AsNum(src.startAngle);
                    }
                    else {
                        console.log('Expected startAngle of Arc3D to be a number but was ', typeof src.startAngle, src.startAngle)
                    }
                }
                if (src.endAngle !== undefined && src.endAngle !== null) {
                    if (typeof src.endAngle === "number" || src.endAngle === 'NaN' || src.endAngle === 'Infinity' || src.endAngle === '-Infinity') {
                        dst.endAngle = AsNum(src.endAngle);
                    }
                    else {
                        console.log('Expected endAngle of Arc3D to be a number but was ', typeof src.endAngle, src.endAngle)
                    }
                }
                return dst;
            }

            static toObject(src: Arc3D | null | undefined): Arc3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Arc3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Arc3D") {
                    console.error('Expected ng.geometry.Arc3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Arc3D_json = {
                    radius: AsJsonNum(src.radius),
                    startAngle: AsJsonNum(src.startAngle),
                    endAngle: AsJsonNum(src.endAngle),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.center !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.center);
                    if(parsed === null) return null;
                    dst.center = parsed;
                }
                if(src.normal !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.normal);
                    if(parsed === null) return null;
                    dst.normal = parsed;
                }
                return dst;
            }

            static create(src?: Arc3D_createType) {
                const dst = new Arc3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.center !== undefined) {
                    dst.center = src.center;
                }
                if (src.normal !== undefined) {
                    dst.normal = src.normal;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                if (src.startAngle !== undefined) {
                    dst.startAngle = src.startAngle;
                }
                if (src.endAngle !== undefined) {
                    dst.endAngle = src.endAngle;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Arc3D();
                dst.id = this.id;
                dst.center = this.center;
                dst.normal = this.normal;
                dst.radius = this.radius;
                dst.startAngle = this.startAngle;
                dst.endAngle = this.endAngle;
                return dst;
            }

            deepClone() {
                const json = Arc3D.toObject(this);
                const dst = Arc3D.fromObject(json);
                return dst;
            }
        }
        export type IArc3D = Arc3D;


        export type Circle3D_keys = 'id' | 'center' | 'normal' | 'radius';
        export interface Circle3D_createType {
            id?: ng.utils.ID | null,
            center?: ng.geometry.Point3D | null,
            normal?: ng.geometry.Vector3D | null,
            radius?: number,
        }
        export interface Circle3D_json {
            id?: ng.utils.ID_json;
            center?: ng.geometry.Point3D_json;
            normal?: ng.geometry.Vector3D_json;
            radius?: JsonNumber;
        }
        interface Circle3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            center?: unknown;
            normal?: unknown;
            radius?: unknown;
        }
        export class Circle3D {
            __proto_name = "ng.geometry.Circle3D";
            id: ng.utils.ID | null = null;
            center: ng.geometry.Point3D | null = null;
            normal: ng.geometry.Vector3D | null = null;
            radius: number = 0;

            static fromObject(src_unknown: unknown): Circle3D {
                const dst = new Circle3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Circle3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Circle3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Circle3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.center !== undefined && src.center !== null) {
                    dst.center = ng.geometry.Point3D.fromObject(src.center);
                }
                if (src.normal !== undefined && src.normal !== null) {
                    dst.normal = ng.geometry.Vector3D.fromObject(src.normal);
                }
                if (src.radius !== undefined && src.radius !== null) {
                    if (typeof src.radius === "number" || src.radius === 'NaN' || src.radius === 'Infinity' || src.radius === '-Infinity') {
                        dst.radius = AsNum(src.radius);
                    }
                    else {
                        console.log('Expected radius of Circle3D to be a number but was ', typeof src.radius, src.radius)
                    }
                }
                return dst;
            }

            static toObject(src: Circle3D | null | undefined): Circle3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Circle3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Circle3D") {
                    console.error('Expected ng.geometry.Circle3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Circle3D_json = {
                    radius: AsJsonNum(src.radius),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.center !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.center);
                    if(parsed === null) return null;
                    dst.center = parsed;
                }
                if(src.normal !== null)
                {
                    const parsed = ng.geometry.Vector3D.toObject(src.normal);
                    if(parsed === null) return null;
                    dst.normal = parsed;
                }
                return dst;
            }

            static create(src?: Circle3D_createType) {
                const dst = new Circle3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.center !== undefined) {
                    dst.center = src.center;
                }
                if (src.normal !== undefined) {
                    dst.normal = src.normal;
                }
                if (src.radius !== undefined) {
                    dst.radius = src.radius;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Circle3D();
                dst.id = this.id;
                dst.center = this.center;
                dst.normal = this.normal;
                dst.radius = this.radius;
                return dst;
            }

            deepClone() {
                const json = Circle3D.toObject(this);
                const dst = Circle3D.fromObject(json);
                return dst;
            }
        }
        export type ICircle3D = Circle3D;


        export type Curve3D_keys = 'id' | 'arcSegment' | 'circleSegments' | 'lineSegment';
        export interface Curve3D_createType {
            id?: ng.utils.ID | null,
            arcSegment?: ng.geometry.Arc3D | null,
            circleSegments?: ng.geometry.Circle3D | null,
            lineSegment?: ng.geometry.Line3D | null,
        }
        export interface Curve3D_json {
            id?: ng.utils.ID_json;
            arcSegment?: ng.geometry.Arc3D_json;
            circleSegments?: ng.geometry.Circle3D_json;
            lineSegment?: ng.geometry.Line3D_json;
        }
        interface Curve3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            arcSegment?: unknown;
            circleSegments?: unknown;
            lineSegment?: unknown;
        }
        export class Curve3D {
            __proto_name = "ng.geometry.Curve3D";
            id: ng.utils.ID | null = null;
            // this is a one of
            segment: {type: 'arcSegment'; arcSegment: ng.geometry.Arc3D} | {type: 'circleSegments'; circleSegments: ng.geometry.Circle3D} | {type: 'lineSegment'; lineSegment: ng.geometry.Line3D} | null = null;

            /** Gets the `ArcSegment` value (or null) from the oneof `segment` */
            getArcSegment(): ng.geometry.Arc3D | null {
                if(this.segment === null) return null;
                if(this.segment.type !== 'arcSegment') return null;
                return this.segment.arcSegment;
            }

            /** Sets the `ArcSegment` value for the oneof `segment`*/
            setArcSegment(value: ng.geometry.Arc3D | null) {
                if(value !== null) {
                    this.segment = {type: 'arcSegment', arcSegment:value};
                }
                else {
                    this.segment = null;
                }
            }

            /** Gets the `CircleSegments` value (or null) from the oneof `segment` */
            getCircleSegments(): ng.geometry.Circle3D | null {
                if(this.segment === null) return null;
                if(this.segment.type !== 'circleSegments') return null;
                return this.segment.circleSegments;
            }

            /** Sets the `CircleSegments` value for the oneof `segment`*/
            setCircleSegments(value: ng.geometry.Circle3D | null) {
                if(value !== null) {
                    this.segment = {type: 'circleSegments', circleSegments:value};
                }
                else {
                    this.segment = null;
                }
            }

            /** Gets the `LineSegment` value (or null) from the oneof `segment` */
            getLineSegment(): ng.geometry.Line3D | null {
                if(this.segment === null) return null;
                if(this.segment.type !== 'lineSegment') return null;
                return this.segment.lineSegment;
            }

            /** Sets the `LineSegment` value for the oneof `segment`*/
            setLineSegment(value: ng.geometry.Line3D | null) {
                if(value !== null) {
                    this.segment = {type: 'lineSegment', lineSegment:value};
                }
                else {
                    this.segment = null;
                }
            }

            static fromObject(src_unknown: unknown): Curve3D {
                const dst = new Curve3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Curve3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Curve3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Curve3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.arcSegment !== undefined && src.arcSegment !== null) {
                    dst.setArcSegment(ng.geometry.Arc3D.fromObject(src.arcSegment));
                }
                if (src.circleSegments !== undefined && src.circleSegments !== null) {
                    dst.setCircleSegments(ng.geometry.Circle3D.fromObject(src.circleSegments));
                }
                if (src.lineSegment !== undefined && src.lineSegment !== null) {
                    dst.setLineSegment(ng.geometry.Line3D.fromObject(src.lineSegment));
                }
                return dst;
            }

            static toObject(src: Curve3D | null | undefined): Curve3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Curve3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Curve3D") {
                    console.error('Expected ng.geometry.Curve3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Curve3D_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const arcSegment = src.getArcSegment();
                if(arcSegment !== null)
                {
                    const parsed = ng.geometry.Arc3D.toObject(arcSegment);
                    if(parsed === null) return null;
                    dst.arcSegment = parsed;
                }
                const circleSegments = src.getCircleSegments();
                if(circleSegments !== null)
                {
                    const parsed = ng.geometry.Circle3D.toObject(circleSegments);
                    if(parsed === null) return null;
                    dst.circleSegments = parsed;
                }
                const lineSegment = src.getLineSegment();
                if(lineSegment !== null)
                {
                    const parsed = ng.geometry.Line3D.toObject(lineSegment);
                    if(parsed === null) return null;
                    dst.lineSegment = parsed;
                }
                return dst;
            }

            static create(src?: Curve3D_createType) {
                const dst = new Curve3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                // part of the segment oneof 
                if (src.arcSegment !== undefined && src.arcSegment !== null) {
                    dst.setArcSegment(src.arcSegment);
                }
                // part of the segment oneof 
                if (src.circleSegments !== undefined && src.circleSegments !== null) {
                    dst.setCircleSegments(src.circleSegments);
                }
                // part of the segment oneof 
                if (src.lineSegment !== undefined && src.lineSegment !== null) {
                    dst.setLineSegment(src.lineSegment);
                }
                return dst;
            }

            shallowClone() {
                const dst = new Curve3D();
                dst.id = this.id;
                dst.segment = this.segment;
                return dst;
            }

            deepClone() {
                const json = Curve3D.toObject(this);
                const dst = Curve3D.fromObject(json);
                return dst;
            }
        }
        export type ICurve3D = Curve3D;


        export type PolyLine3D_keys = 'id' | 'points';
        export interface PolyLine3D_createType {
            id?: ng.utils.ID | null,
            points?: ng.geometry.Point3D[],
        }
        export interface PolyLine3D_json {
            id?: ng.utils.ID_json;
            points: ng.geometry.Point3D_json[];
        }
        interface PolyLine3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            points?: unknown;
        }
        export class PolyLine3D {
            __proto_name = "ng.geometry.PolyLine3D";
            id: ng.utils.ID | null = null;
            points: ng.geometry.Point3D[] = [];

            static fromObject(src_unknown: unknown): PolyLine3D {
                const dst = new PolyLine3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PolyLine3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PolyLine3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PolyLine3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.points !== undefined && src.points !== null) {
                    if (Array.isArray(src.points)) {
                        for (const element of src.points) {
                            dst.points.push(ng.geometry.Point3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected points of PolyLine3D to be a array but was ', typeof src.points, src.points)
                    }
                }
                return dst;
            }

            static toObject(src: PolyLine3D | null | undefined): PolyLine3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.PolyLine3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.PolyLine3D") {
                    console.error('Expected ng.geometry.PolyLine3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PolyLine3D_json = {
                    points: new Array<ng.geometry.Point3D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.points !== null) {
                    for (const element of src.points) {
                        const parsed = ng.geometry.Point3D.toObject(element);
                        if(parsed === null) return null;
                        dst.points.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: PolyLine3D_createType) {
                const dst = new PolyLine3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.points !== undefined) {
                    dst.points = src.points;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PolyLine3D();
                dst.id = this.id;
                dst.points = this.points;
                return dst;
            }

            deepClone() {
                const json = PolyLine3D.toObject(this);
                const dst = PolyLine3D.fromObject(json);
                return dst;
            }
        }
        export type IPolyLine3D = PolyLine3D;


        export type PolyCurve3D_keys = 'id' | 'curves';
        export interface PolyCurve3D_createType {
            id?: ng.utils.ID | null,
            curves?: ng.geometry.Curve3D[],
        }
        export interface PolyCurve3D_json {
            id?: ng.utils.ID_json;
            curves: ng.geometry.Curve3D_json[];
        }
        interface PolyCurve3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            curves?: unknown;
        }
        export class PolyCurve3D {
            __proto_name = "ng.geometry.PolyCurve3D";
            id: ng.utils.ID | null = null;
            curves: ng.geometry.Curve3D[] = [];

            static fromObject(src_unknown: unknown): PolyCurve3D {
                const dst = new PolyCurve3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PolyCurve3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PolyCurve3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PolyCurve3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.curves !== undefined && src.curves !== null) {
                    if (Array.isArray(src.curves)) {
                        for (const element of src.curves) {
                            dst.curves.push(ng.geometry.Curve3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected curves of PolyCurve3D to be a array but was ', typeof src.curves, src.curves)
                    }
                }
                return dst;
            }

            static toObject(src: PolyCurve3D | null | undefined): PolyCurve3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.PolyCurve3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.PolyCurve3D") {
                    console.error('Expected ng.geometry.PolyCurve3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PolyCurve3D_json = {
                    curves: new Array<ng.geometry.Curve3D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.curves !== null) {
                    for (const element of src.curves) {
                        const parsed = ng.geometry.Curve3D.toObject(element);
                        if(parsed === null) return null;
                        dst.curves.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: PolyCurve3D_createType) {
                const dst = new PolyCurve3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.curves !== undefined) {
                    dst.curves = src.curves;
                }
                return dst;
            }

            shallowClone() {
                const dst = new PolyCurve3D();
                dst.id = this.id;
                dst.curves = this.curves;
                return dst;
            }

            deepClone() {
                const json = PolyCurve3D.toObject(this);
                const dst = PolyCurve3D.fromObject(json);
                return dst;
            }
        }
        export type IPolyCurve3D = PolyCurve3D;


        export type LineFace3D_keys = 'id' | 'perimeter' | 'holes';
        export interface LineFace3D_createType {
            id?: ng.utils.ID | null,
            perimeter?: ng.geometry.PolyLine3D | null,
            holes?: ng.geometry.PolyLine3D[],
        }
        export interface LineFace3D_json {
            id?: ng.utils.ID_json;
            perimeter?: ng.geometry.PolyLine3D_json;
            holes: ng.geometry.PolyLine3D_json[];
        }
        interface LineFace3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            perimeter?: unknown;
            holes?: unknown;
        }
        export class LineFace3D {
            __proto_name = "ng.geometry.LineFace3D";
            id: ng.utils.ID | null = null;
            perimeter: ng.geometry.PolyLine3D | null = null;
            holes: ng.geometry.PolyLine3D[] = [];

            static fromObject(src_unknown: unknown): LineFace3D {
                const dst = new LineFace3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LineFace3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LineFace3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LineFace3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.perimeter !== undefined && src.perimeter !== null) {
                    dst.perimeter = ng.geometry.PolyLine3D.fromObject(src.perimeter);
                }
                if (src.holes !== undefined && src.holes !== null) {
                    if (Array.isArray(src.holes)) {
                        for (const element of src.holes) {
                            dst.holes.push(ng.geometry.PolyLine3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected holes of LineFace3D to be a array but was ', typeof src.holes, src.holes)
                    }
                }
                return dst;
            }

            static toObject(src: LineFace3D | null | undefined): LineFace3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.LineFace3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.LineFace3D") {
                    console.error('Expected ng.geometry.LineFace3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LineFace3D_json = {
                    holes: new Array<ng.geometry.PolyLine3D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.perimeter !== null)
                {
                    const parsed = ng.geometry.PolyLine3D.toObject(src.perimeter);
                    if(parsed === null) return null;
                    dst.perimeter = parsed;
                }
                if (src.holes !== null) {
                    for (const element of src.holes) {
                        const parsed = ng.geometry.PolyLine3D.toObject(element);
                        if(parsed === null) return null;
                        dst.holes.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: LineFace3D_createType) {
                const dst = new LineFace3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.perimeter !== undefined) {
                    dst.perimeter = src.perimeter;
                }
                if (src.holes !== undefined) {
                    dst.holes = src.holes;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LineFace3D();
                dst.id = this.id;
                dst.perimeter = this.perimeter;
                dst.holes = this.holes;
                return dst;
            }

            deepClone() {
                const json = LineFace3D.toObject(this);
                const dst = LineFace3D.fromObject(json);
                return dst;
            }
        }
        export type ILineFace3D = LineFace3D;


        export type CurveFace3D_keys = 'id' | 'perimeter' | 'holes';
        export interface CurveFace3D_createType {
            id?: ng.utils.ID | null,
            perimeter?: ng.geometry.PolyCurve3D | null,
            holes?: ng.geometry.PolyCurve3D[],
        }
        export interface CurveFace3D_json {
            id?: ng.utils.ID_json;
            perimeter?: ng.geometry.PolyCurve3D_json;
            holes: ng.geometry.PolyCurve3D_json[];
        }
        interface CurveFace3D_json_in {
            __proto_name?: unknown;
            id?: unknown;
            perimeter?: unknown;
            holes?: unknown;
        }
        export class CurveFace3D {
            __proto_name = "ng.geometry.CurveFace3D";
            id: ng.utils.ID | null = null;
            perimeter: ng.geometry.PolyCurve3D | null = null;
            holes: ng.geometry.PolyCurve3D[] = [];

            static fromObject(src_unknown: unknown): CurveFace3D {
                const dst = new CurveFace3D();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted CurveFace3D but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as CurveFace3D_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for CurveFace3D but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.perimeter !== undefined && src.perimeter !== null) {
                    dst.perimeter = ng.geometry.PolyCurve3D.fromObject(src.perimeter);
                }
                if (src.holes !== undefined && src.holes !== null) {
                    if (Array.isArray(src.holes)) {
                        for (const element of src.holes) {
                            dst.holes.push(ng.geometry.PolyCurve3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected holes of CurveFace3D to be a array but was ', typeof src.holes, src.holes)
                    }
                }
                return dst;
            }

            static toObject(src: CurveFace3D | null | undefined): CurveFace3D_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.CurveFace3D is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.CurveFace3D") {
                    console.error('Expected ng.geometry.CurveFace3D but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : CurveFace3D_json = {
                    holes: new Array<ng.geometry.PolyCurve3D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if(src.perimeter !== null)
                {
                    const parsed = ng.geometry.PolyCurve3D.toObject(src.perimeter);
                    if(parsed === null) return null;
                    dst.perimeter = parsed;
                }
                if (src.holes !== null) {
                    for (const element of src.holes) {
                        const parsed = ng.geometry.PolyCurve3D.toObject(element);
                        if(parsed === null) return null;
                        dst.holes.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: CurveFace3D_createType) {
                const dst = new CurveFace3D();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.perimeter !== undefined) {
                    dst.perimeter = src.perimeter;
                }
                if (src.holes !== undefined) {
                    dst.holes = src.holes;
                }
                return dst;
            }

            shallowClone() {
                const dst = new CurveFace3D();
                dst.id = this.id;
                dst.perimeter = this.perimeter;
                dst.holes = this.holes;
                return dst;
            }

            deepClone() {
                const json = CurveFace3D.toObject(this);
                const dst = CurveFace3D.fromObject(json);
                return dst;
            }
        }
        export type ICurveFace3D = CurveFace3D;


        export type Block_keys = 'id' | 'surfaces';
        export interface Block_createType {
            id?: ng.utils.ID | null,
            surfaces?: ng.geometry.LineFace3D[],
        }
        export interface Block_json {
            id?: ng.utils.ID_json;
            surfaces: ng.geometry.LineFace3D_json[];
        }
        interface Block_json_in {
            __proto_name?: unknown;
            id?: unknown;
            surfaces?: unknown;
        }
        export class Block {
            __proto_name = "ng.geometry.Block";
            id: ng.utils.ID | null = null;
            surfaces: ng.geometry.LineFace3D[] = [];

            static fromObject(src_unknown: unknown): Block {
                const dst = new Block();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Block but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Block_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Block but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.surfaces !== undefined && src.surfaces !== null) {
                    if (Array.isArray(src.surfaces)) {
                        for (const element of src.surfaces) {
                            dst.surfaces.push(ng.geometry.LineFace3D.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected surfaces of Block to be a array but was ', typeof src.surfaces, src.surfaces)
                    }
                }
                return dst;
            }

            static toObject(src: Block | null | undefined): Block_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.geometry.Block is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.geometry.Block") {
                    console.error('Expected ng.geometry.Block but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Block_json = {
                    surfaces: new Array<ng.geometry.LineFace3D_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.surfaces !== null) {
                    for (const element of src.surfaces) {
                        const parsed = ng.geometry.LineFace3D.toObject(element);
                        if(parsed === null) return null;
                        dst.surfaces.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Block_createType) {
                const dst = new Block();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.surfaces !== undefined) {
                    dst.surfaces = src.surfaces;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Block();
                dst.id = this.id;
                dst.surfaces = this.surfaces;
                return dst;
            }

            deepClone() {
                const json = Block.toObject(this);
                const dst = Block.fromObject(json);
                return dst;
            }
        }
        export type IBlock = Block;
    } // namespace geometry


    // Defined in Geometry/foundation.proto
    export namespace foundation {
        export type PointFoundation_keys = 'circle' | 'rectangle';
        export interface PointFoundation_createType {
            circle?: ng.foundation.Circle | null,
            rectangle?: ng.foundation.Rectangle | null,
        }
        export interface PointFoundation_json {
            circle?: ng.foundation.Circle_json;
            rectangle?: ng.foundation.Rectangle_json;
        }
        interface PointFoundation_json_in {
            __proto_name?: unknown;
            circle?: unknown;
            rectangle?: unknown;
        }
        export class PointFoundation {
            __proto_name = "ng.foundation.PointFoundation";
            // this is a one of
            element: {type: 'circle'; circle: ng.foundation.Circle} | {type: 'rectangle'; rectangle: ng.foundation.Rectangle} | null = null;

            /** Gets the `Circle` value (or null) from the oneof `element` */
            getCircle(): ng.foundation.Circle | null {
                if(this.element === null) return null;
                if(this.element.type !== 'circle') return null;
                return this.element.circle;
            }

            /** Sets the `Circle` value for the oneof `element`*/
            setCircle(value: ng.foundation.Circle | null) {
                if(value !== null) {
                    this.element = {type: 'circle', circle:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `Rectangle` value (or null) from the oneof `element` */
            getRectangle(): ng.foundation.Rectangle | null {
                if(this.element === null) return null;
                if(this.element.type !== 'rectangle') return null;
                return this.element.rectangle;
            }

            /** Sets the `Rectangle` value for the oneof `element`*/
            setRectangle(value: ng.foundation.Rectangle | null) {
                if(value !== null) {
                    this.element = {type: 'rectangle', rectangle:value};
                }
                else {
                    this.element = null;
                }
            }

            static fromObject(src_unknown: unknown): PointFoundation {
                const dst = new PointFoundation();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted PointFoundation but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as PointFoundation_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for PointFoundation but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.circle !== undefined && src.circle !== null) {
                    dst.setCircle(ng.foundation.Circle.fromObject(src.circle));
                }
                if (src.rectangle !== undefined && src.rectangle !== null) {
                    dst.setRectangle(ng.foundation.Rectangle.fromObject(src.rectangle));
                }
                return dst;
            }

            static toObject(src: PointFoundation | null | undefined): PointFoundation_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.PointFoundation is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.PointFoundation") {
                    console.error('Expected ng.foundation.PointFoundation but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : PointFoundation_json = {
                };
                const circle = src.getCircle();
                if(circle !== null)
                {
                    const parsed = ng.foundation.Circle.toObject(circle);
                    if(parsed === null) return null;
                    dst.circle = parsed;
                }
                const rectangle = src.getRectangle();
                if(rectangle !== null)
                {
                    const parsed = ng.foundation.Rectangle.toObject(rectangle);
                    if(parsed === null) return null;
                    dst.rectangle = parsed;
                }
                return dst;
            }

            static create(src?: PointFoundation_createType) {
                const dst = new PointFoundation();
                if (src === undefined) {
                    return dst;
                }
                // part of the element oneof 
                if (src.circle !== undefined && src.circle !== null) {
                    dst.setCircle(src.circle);
                }
                // part of the element oneof 
                if (src.rectangle !== undefined && src.rectangle !== null) {
                    dst.setRectangle(src.rectangle);
                }
                return dst;
            }

            shallowClone() {
                const dst = new PointFoundation();
                dst.element = this.element;
                return dst;
            }

            deepClone() {
                const json = PointFoundation.toObject(this);
                const dst = PointFoundation.fromObject(json);
                return dst;
            }
        }
        export type IPointFoundation = PointFoundation;


        export type LineFoundation_keys = 'width' | 'widthTop' | 'eccentricityWidthTop';
        export interface LineFoundation_createType {
            width?: number,
            widthTop?: number,
            eccentricityWidthTop?: number,
        }
        export interface LineFoundation_json {
            width?: JsonNumber;
            widthTop?: JsonNumber;
            eccentricityWidthTop?: JsonNumber;
        }
        interface LineFoundation_json_in {
            __proto_name?: unknown;
            width?: unknown;
            widthTop?: unknown;
            eccentricityWidthTop?: unknown;
        }
        export class LineFoundation {
            __proto_name = "ng.foundation.LineFoundation";
            width: number = 0;
            widthTop: number = 0;
            eccentricityWidthTop: number = 0;

            static fromObject(src_unknown: unknown): LineFoundation {
                const dst = new LineFoundation();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted LineFoundation but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as LineFoundation_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for LineFoundation but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of LineFoundation to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.widthTop !== undefined && src.widthTop !== null) {
                    if (typeof src.widthTop === "number" || src.widthTop === 'NaN' || src.widthTop === 'Infinity' || src.widthTop === '-Infinity') {
                        dst.widthTop = AsNum(src.widthTop);
                    }
                    else {
                        console.log('Expected widthTop of LineFoundation to be a number but was ', typeof src.widthTop, src.widthTop)
                    }
                }
                if (src.eccentricityWidthTop !== undefined && src.eccentricityWidthTop !== null) {
                    if (typeof src.eccentricityWidthTop === "number" || src.eccentricityWidthTop === 'NaN' || src.eccentricityWidthTop === 'Infinity' || src.eccentricityWidthTop === '-Infinity') {
                        dst.eccentricityWidthTop = AsNum(src.eccentricityWidthTop);
                    }
                    else {
                        console.log('Expected eccentricityWidthTop of LineFoundation to be a number but was ', typeof src.eccentricityWidthTop, src.eccentricityWidthTop)
                    }
                }
                return dst;
            }

            static toObject(src: LineFoundation | null | undefined): LineFoundation_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.LineFoundation is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.LineFoundation") {
                    console.error('Expected ng.foundation.LineFoundation but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : LineFoundation_json = {
                    width: AsJsonNum(src.width),
                    widthTop: AsJsonNum(src.widthTop),
                    eccentricityWidthTop: AsJsonNum(src.eccentricityWidthTop),
                };
                return dst;
            }

            static create(src?: LineFoundation_createType) {
                const dst = new LineFoundation();
                if (src === undefined) {
                    return dst;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.widthTop !== undefined) {
                    dst.widthTop = src.widthTop;
                }
                if (src.eccentricityWidthTop !== undefined) {
                    dst.eccentricityWidthTop = src.eccentricityWidthTop;
                }
                return dst;
            }

            shallowClone() {
                const dst = new LineFoundation();
                dst.width = this.width;
                dst.widthTop = this.widthTop;
                dst.eccentricityWidthTop = this.eccentricityWidthTop;
                return dst;
            }

            deepClone() {
                const json = LineFoundation.toObject(this);
                const dst = LineFoundation.fromObject(json);
                return dst;
            }
        }
        export type ILineFoundation = LineFoundation;


        export type Circle_keys = 'diameter' | 'diameterTop';
        export interface Circle_createType {
            diameter?: number,
            diameterTop?: number,
        }
        export interface Circle_json {
            diameter?: JsonNumber;
            diameterTop?: JsonNumber;
        }
        interface Circle_json_in {
            __proto_name?: unknown;
            diameter?: unknown;
            diameterTop?: unknown;
        }
        export class Circle {
            __proto_name = "ng.foundation.Circle";
            diameter: number = 0;
            diameterTop: number = 0;

            static fromObject(src_unknown: unknown): Circle {
                const dst = new Circle();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Circle but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Circle_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Circle but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.diameter !== undefined && src.diameter !== null) {
                    if (typeof src.diameter === "number" || src.diameter === 'NaN' || src.diameter === 'Infinity' || src.diameter === '-Infinity') {
                        dst.diameter = AsNum(src.diameter);
                    }
                    else {
                        console.log('Expected diameter of Circle to be a number but was ', typeof src.diameter, src.diameter)
                    }
                }
                if (src.diameterTop !== undefined && src.diameterTop !== null) {
                    if (typeof src.diameterTop === "number" || src.diameterTop === 'NaN' || src.diameterTop === 'Infinity' || src.diameterTop === '-Infinity') {
                        dst.diameterTop = AsNum(src.diameterTop);
                    }
                    else {
                        console.log('Expected diameterTop of Circle to be a number but was ', typeof src.diameterTop, src.diameterTop)
                    }
                }
                return dst;
            }

            static toObject(src: Circle | null | undefined): Circle_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.Circle is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.Circle") {
                    console.error('Expected ng.foundation.Circle but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Circle_json = {
                    diameter: AsJsonNum(src.diameter),
                    diameterTop: AsJsonNum(src.diameterTop),
                };
                return dst;
            }

            static create(src?: Circle_createType) {
                const dst = new Circle();
                if (src === undefined) {
                    return dst;
                }
                if (src.diameter !== undefined) {
                    dst.diameter = src.diameter;
                }
                if (src.diameterTop !== undefined) {
                    dst.diameterTop = src.diameterTop;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Circle();
                dst.diameter = this.diameter;
                dst.diameterTop = this.diameterTop;
                return dst;
            }

            deepClone() {
                const json = Circle.toObject(this);
                const dst = Circle.fromObject(json);
                return dst;
            }
        }
        export type ICircle = Circle;


        export type Rectangle_keys = 'width' | 'length' | 'widthTop' | 'lengthTop' | 'eccentricityWidthTop' | 'eccentricityLengthTop';
        export interface Rectangle_createType {
            width?: number,
            length?: number,
            widthTop?: number,
            lengthTop?: number,
            eccentricityWidthTop?: number,
            eccentricityLengthTop?: number,
        }
        export interface Rectangle_json {
            width?: JsonNumber;
            length?: JsonNumber;
            widthTop?: JsonNumber;
            lengthTop?: JsonNumber;
            eccentricityWidthTop?: JsonNumber;
            eccentricityLengthTop?: JsonNumber;
        }
        interface Rectangle_json_in {
            __proto_name?: unknown;
            width?: unknown;
            length?: unknown;
            widthTop?: unknown;
            lengthTop?: unknown;
            eccentricityWidthTop?: unknown;
            eccentricityLengthTop?: unknown;
        }
        export class Rectangle {
            __proto_name = "ng.foundation.Rectangle";
            width: number = 0;
            length: number = 0;
            widthTop: number = 0;
            lengthTop: number = 0;
            eccentricityWidthTop: number = 0;
            eccentricityLengthTop: number = 0;

            static fromObject(src_unknown: unknown): Rectangle {
                const dst = new Rectangle();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Rectangle but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Rectangle_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Rectangle but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.width !== undefined && src.width !== null) {
                    if (typeof src.width === "number" || src.width === 'NaN' || src.width === 'Infinity' || src.width === '-Infinity') {
                        dst.width = AsNum(src.width);
                    }
                    else {
                        console.log('Expected width of Rectangle to be a number but was ', typeof src.width, src.width)
                    }
                }
                if (src.length !== undefined && src.length !== null) {
                    if (typeof src.length === "number" || src.length === 'NaN' || src.length === 'Infinity' || src.length === '-Infinity') {
                        dst.length = AsNum(src.length);
                    }
                    else {
                        console.log('Expected length of Rectangle to be a number but was ', typeof src.length, src.length)
                    }
                }
                if (src.widthTop !== undefined && src.widthTop !== null) {
                    if (typeof src.widthTop === "number" || src.widthTop === 'NaN' || src.widthTop === 'Infinity' || src.widthTop === '-Infinity') {
                        dst.widthTop = AsNum(src.widthTop);
                    }
                    else {
                        console.log('Expected widthTop of Rectangle to be a number but was ', typeof src.widthTop, src.widthTop)
                    }
                }
                if (src.lengthTop !== undefined && src.lengthTop !== null) {
                    if (typeof src.lengthTop === "number" || src.lengthTop === 'NaN' || src.lengthTop === 'Infinity' || src.lengthTop === '-Infinity') {
                        dst.lengthTop = AsNum(src.lengthTop);
                    }
                    else {
                        console.log('Expected lengthTop of Rectangle to be a number but was ', typeof src.lengthTop, src.lengthTop)
                    }
                }
                if (src.eccentricityWidthTop !== undefined && src.eccentricityWidthTop !== null) {
                    if (typeof src.eccentricityWidthTop === "number" || src.eccentricityWidthTop === 'NaN' || src.eccentricityWidthTop === 'Infinity' || src.eccentricityWidthTop === '-Infinity') {
                        dst.eccentricityWidthTop = AsNum(src.eccentricityWidthTop);
                    }
                    else {
                        console.log('Expected eccentricityWidthTop of Rectangle to be a number but was ', typeof src.eccentricityWidthTop, src.eccentricityWidthTop)
                    }
                }
                if (src.eccentricityLengthTop !== undefined && src.eccentricityLengthTop !== null) {
                    if (typeof src.eccentricityLengthTop === "number" || src.eccentricityLengthTop === 'NaN' || src.eccentricityLengthTop === 'Infinity' || src.eccentricityLengthTop === '-Infinity') {
                        dst.eccentricityLengthTop = AsNum(src.eccentricityLengthTop);
                    }
                    else {
                        console.log('Expected eccentricityLengthTop of Rectangle to be a number but was ', typeof src.eccentricityLengthTop, src.eccentricityLengthTop)
                    }
                }
                return dst;
            }

            static toObject(src: Rectangle | null | undefined): Rectangle_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.Rectangle is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.Rectangle") {
                    console.error('Expected ng.foundation.Rectangle but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Rectangle_json = {
                    width: AsJsonNum(src.width),
                    length: AsJsonNum(src.length),
                    widthTop: AsJsonNum(src.widthTop),
                    lengthTop: AsJsonNum(src.lengthTop),
                    eccentricityWidthTop: AsJsonNum(src.eccentricityWidthTop),
                    eccentricityLengthTop: AsJsonNum(src.eccentricityLengthTop),
                };
                return dst;
            }

            static create(src?: Rectangle_createType) {
                const dst = new Rectangle();
                if (src === undefined) {
                    return dst;
                }
                if (src.width !== undefined) {
                    dst.width = src.width;
                }
                if (src.length !== undefined) {
                    dst.length = src.length;
                }
                if (src.widthTop !== undefined) {
                    dst.widthTop = src.widthTop;
                }
                if (src.lengthTop !== undefined) {
                    dst.lengthTop = src.lengthTop;
                }
                if (src.eccentricityWidthTop !== undefined) {
                    dst.eccentricityWidthTop = src.eccentricityWidthTop;
                }
                if (src.eccentricityLengthTop !== undefined) {
                    dst.eccentricityLengthTop = src.eccentricityLengthTop;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Rectangle();
                dst.width = this.width;
                dst.length = this.length;
                dst.widthTop = this.widthTop;
                dst.lengthTop = this.lengthTop;
                dst.eccentricityWidthTop = this.eccentricityWidthTop;
                dst.eccentricityLengthTop = this.eccentricityLengthTop;
                return dst;
            }

            deepClone() {
                const json = Rectangle.toObject(this);
                const dst = Rectangle.fromObject(json);
                return dst;
            }
        }
        export type IRectangle = Rectangle;


        export type Elements_keys = 'topGuid' | 'widthGuid' | 'lengthGuid' | 'widthSectionForces' | 'lengthSectionForces';
        export interface Elements_createType {
            topGuid?: string,
            widthGuid?: string,
            lengthGuid?: string,
            widthSectionForces?: number[],
            lengthSectionForces?: number[],
        }
        export interface Elements_json {
            topGuid?: string;
            widthGuid?: string;
            lengthGuid?: string;
            widthSectionForces: JsonNumber[];
            lengthSectionForces: JsonNumber[];
        }
        interface Elements_json_in {
            __proto_name?: unknown;
            topGuid?: unknown;
            widthGuid?: unknown;
            lengthGuid?: unknown;
            widthSectionForces?: unknown;
            lengthSectionForces?: unknown;
        }
        export class Elements {
            __proto_name = "ng.foundation.Elements";
            topGuid: string = "";
            widthGuid: string = "";
            lengthGuid: string = "";
            widthSectionForces: number[] = [];
            lengthSectionForces: number[] = [];

            static fromObject(src_unknown: unknown): Elements {
                const dst = new Elements();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Elements but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Elements_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Elements but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.topGuid !== undefined && src.topGuid !== null) {
                    if (typeof src.topGuid === "string") {
                        dst.topGuid = src.topGuid;
                    }
                    else {
                        console.log('Expected topGuid of Elements to be a string but was ', typeof src.topGuid, src.topGuid)
                    }
                }
                if (src.widthGuid !== undefined && src.widthGuid !== null) {
                    if (typeof src.widthGuid === "string") {
                        dst.widthGuid = src.widthGuid;
                    }
                    else {
                        console.log('Expected widthGuid of Elements to be a string but was ', typeof src.widthGuid, src.widthGuid)
                    }
                }
                if (src.lengthGuid !== undefined && src.lengthGuid !== null) {
                    if (typeof src.lengthGuid === "string") {
                        dst.lengthGuid = src.lengthGuid;
                    }
                    else {
                        console.log('Expected lengthGuid of Elements to be a string but was ', typeof src.lengthGuid, src.lengthGuid)
                    }
                }
                if (src.widthSectionForces !== undefined && src.widthSectionForces !== null) {
                    if (Array.isArray(src.widthSectionForces)) {
                        for (const [index, element] of src.widthSectionForces.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.widthSectionForces.push(AsNum(element));
                            }
                            else {
                                console.log('Expected widthSectionForces of Elements[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected widthSectionForces of Elements to be a array but was ', typeof src.widthSectionForces, src.widthSectionForces)
                    }
                }
                if (src.lengthSectionForces !== undefined && src.lengthSectionForces !== null) {
                    if (Array.isArray(src.lengthSectionForces)) {
                        for (const [index, element] of src.lengthSectionForces.entries()) {
                            if (typeof element === "number" || element === 'NaN' || element === 'Infinity' || element === '-Infinity') {
                                dst.lengthSectionForces.push(AsNum(element));
                            }
                            else {
                                console.log('Expected lengthSectionForces of Elements[', index, '] to be a number but was ', typeof element, element)
                            }
                        }
                    }
                    else {
                        console.log('Expected lengthSectionForces of Elements to be a array but was ', typeof src.lengthSectionForces, src.lengthSectionForces)
                    }
                }
                return dst;
            }

            static toObject(src: Elements | null | undefined): Elements_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.Elements is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.Elements") {
                    console.error('Expected ng.foundation.Elements but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Elements_json = {
                    topGuid: src.topGuid,
                    widthGuid: src.widthGuid,
                    lengthGuid: src.lengthGuid,
                    widthSectionForces: new Array<JsonNumber>(),
                    lengthSectionForces: new Array<JsonNumber>(),
                };
                if (src.widthSectionForces !== null) {
                    for (const element of src.widthSectionForces) {
                        dst.widthSectionForces.push(AsJsonNum(element));
                    }
                }
                if (src.lengthSectionForces !== null) {
                    for (const element of src.lengthSectionForces) {
                        dst.lengthSectionForces.push(AsJsonNum(element));
                    }
                }
                return dst;
            }

            static create(src?: Elements_createType) {
                const dst = new Elements();
                if (src === undefined) {
                    return dst;
                }
                if (src.topGuid !== undefined) {
                    dst.topGuid = src.topGuid;
                }
                if (src.widthGuid !== undefined) {
                    dst.widthGuid = src.widthGuid;
                }
                if (src.lengthGuid !== undefined) {
                    dst.lengthGuid = src.lengthGuid;
                }
                if (src.widthSectionForces !== undefined) {
                    dst.widthSectionForces = src.widthSectionForces;
                }
                if (src.lengthSectionForces !== undefined) {
                    dst.lengthSectionForces = src.lengthSectionForces;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Elements();
                dst.topGuid = this.topGuid;
                dst.widthGuid = this.widthGuid;
                dst.lengthGuid = this.lengthGuid;
                dst.widthSectionForces = this.widthSectionForces;
                dst.lengthSectionForces = this.lengthSectionForces;
                return dst;
            }

            deepClone() {
                const json = Elements.toObject(this);
                const dst = Elements.fromObject(json);
                return dst;
            }
        }
        export type IElements = Elements;


        export type FoundationGeometry_keys = 'height' | 'pointFoundation' | 'lineFoundation' | 'center' | 'n';
        export interface FoundationGeometry_createType {
            height?: number,
            pointFoundation?: ng.foundation.PointFoundation | null,
            lineFoundation?: ng.foundation.LineFoundation | null,
            center?: ng.geometry.Point3D | null,
            n?: ng.geometry.Vector2D | null,
        }
        export interface FoundationGeometry_json {
            height?: JsonNumber;
            pointFoundation?: ng.foundation.PointFoundation_json;
            lineFoundation?: ng.foundation.LineFoundation_json;
            center?: ng.geometry.Point3D_json;
            n?: ng.geometry.Vector2D_json;
        }
        interface FoundationGeometry_json_in {
            __proto_name?: unknown;
            height?: unknown;
            pointFoundation?: unknown;
            lineFoundation?: unknown;
            center?: unknown;
            n?: unknown;
        }
        export class FoundationGeometry {
            __proto_name = "ng.foundation.FoundationGeometry";
            height: number = 0;
            // this is a one of
            shape: {type: 'pointFoundation'; pointFoundation: ng.foundation.PointFoundation} | {type: 'lineFoundation'; lineFoundation: ng.foundation.LineFoundation} | null = null;
            center: ng.geometry.Point3D | null = null;
            n: ng.geometry.Vector2D | null = null;

            /** Gets the `PointFoundation` value (or null) from the oneof `shape` */
            getPointFoundation(): ng.foundation.PointFoundation | null {
                if(this.shape === null) return null;
                if(this.shape.type !== 'pointFoundation') return null;
                return this.shape.pointFoundation;
            }

            /** Sets the `PointFoundation` value for the oneof `shape`*/
            setPointFoundation(value: ng.foundation.PointFoundation | null) {
                if(value !== null) {
                    this.shape = {type: 'pointFoundation', pointFoundation:value};
                }
                else {
                    this.shape = null;
                }
            }

            /** Gets the `LineFoundation` value (or null) from the oneof `shape` */
            getLineFoundation(): ng.foundation.LineFoundation | null {
                if(this.shape === null) return null;
                if(this.shape.type !== 'lineFoundation') return null;
                return this.shape.lineFoundation;
            }

            /** Sets the `LineFoundation` value for the oneof `shape`*/
            setLineFoundation(value: ng.foundation.LineFoundation | null) {
                if(value !== null) {
                    this.shape = {type: 'lineFoundation', lineFoundation:value};
                }
                else {
                    this.shape = null;
                }
            }

            static fromObject(src_unknown: unknown): FoundationGeometry {
                const dst = new FoundationGeometry();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted FoundationGeometry but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as FoundationGeometry_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for FoundationGeometry but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.height !== undefined && src.height !== null) {
                    if (typeof src.height === "number" || src.height === 'NaN' || src.height === 'Infinity' || src.height === '-Infinity') {
                        dst.height = AsNum(src.height);
                    }
                    else {
                        console.log('Expected height of FoundationGeometry to be a number but was ', typeof src.height, src.height)
                    }
                }
                if (src.pointFoundation !== undefined && src.pointFoundation !== null) {
                    dst.setPointFoundation(ng.foundation.PointFoundation.fromObject(src.pointFoundation));
                }
                if (src.lineFoundation !== undefined && src.lineFoundation !== null) {
                    dst.setLineFoundation(ng.foundation.LineFoundation.fromObject(src.lineFoundation));
                }
                if (src.center !== undefined && src.center !== null) {
                    dst.center = ng.geometry.Point3D.fromObject(src.center);
                }
                if (src.n !== undefined && src.n !== null) {
                    dst.n = ng.geometry.Vector2D.fromObject(src.n);
                }
                return dst;
            }

            static toObject(src: FoundationGeometry | null | undefined): FoundationGeometry_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.FoundationGeometry is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.FoundationGeometry") {
                    console.error('Expected ng.foundation.FoundationGeometry but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : FoundationGeometry_json = {
                    height: AsJsonNum(src.height),
                };
                const pointFoundation = src.getPointFoundation();
                if(pointFoundation !== null)
                {
                    const parsed = ng.foundation.PointFoundation.toObject(pointFoundation);
                    if(parsed === null) return null;
                    dst.pointFoundation = parsed;
                }
                const lineFoundation = src.getLineFoundation();
                if(lineFoundation !== null)
                {
                    const parsed = ng.foundation.LineFoundation.toObject(lineFoundation);
                    if(parsed === null) return null;
                    dst.lineFoundation = parsed;
                }
                if(src.center !== null)
                {
                    const parsed = ng.geometry.Point3D.toObject(src.center);
                    if(parsed === null) return null;
                    dst.center = parsed;
                }
                if(src.n !== null)
                {
                    const parsed = ng.geometry.Vector2D.toObject(src.n);
                    if(parsed === null) return null;
                    dst.n = parsed;
                }
                return dst;
            }

            static create(src?: FoundationGeometry_createType) {
                const dst = new FoundationGeometry();
                if (src === undefined) {
                    return dst;
                }
                if (src.height !== undefined) {
                    dst.height = src.height;
                }
                // part of the shape oneof 
                if (src.pointFoundation !== undefined && src.pointFoundation !== null) {
                    dst.setPointFoundation(src.pointFoundation);
                }
                // part of the shape oneof 
                if (src.lineFoundation !== undefined && src.lineFoundation !== null) {
                    dst.setLineFoundation(src.lineFoundation);
                }
                if (src.center !== undefined) {
                    dst.center = src.center;
                }
                if (src.n !== undefined) {
                    dst.n = src.n;
                }
                return dst;
            }

            shallowClone() {
                const dst = new FoundationGeometry();
                dst.height = this.height;
                dst.shape = this.shape;
                dst.center = this.center;
                dst.n = this.n;
                return dst;
            }

            deepClone() {
                const json = FoundationGeometry.toObject(this);
                const dst = FoundationGeometry.fromObject(json);
                return dst;
            }
        }
        export type IFoundationGeometry = FoundationGeometry;


        export type ConcreteParameters_keys = 'mtrlGuid' | 'rebars';
        export interface ConcreteParameters_createType {
            mtrlGuid?: string,
            rebars?: ng.rebar.Data | null,
        }
        export interface ConcreteParameters_json {
            mtrlGuid?: string;
            rebars?: ng.rebar.Data_json;
        }
        interface ConcreteParameters_json_in {
            __proto_name?: unknown;
            mtrlGuid?: unknown;
            rebars?: unknown;
        }
        export class ConcreteParameters {
            __proto_name = "ng.foundation.ConcreteParameters";
            mtrlGuid: string = "";
            rebars: ng.rebar.Data | null = null;

            static fromObject(src_unknown: unknown): ConcreteParameters {
                const dst = new ConcreteParameters();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted ConcreteParameters but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as ConcreteParameters_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for ConcreteParameters but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.mtrlGuid !== undefined && src.mtrlGuid !== null) {
                    if (typeof src.mtrlGuid === "string") {
                        dst.mtrlGuid = src.mtrlGuid;
                    }
                    else {
                        console.log('Expected mtrlGuid of ConcreteParameters to be a string but was ', typeof src.mtrlGuid, src.mtrlGuid)
                    }
                }
                if (src.rebars !== undefined && src.rebars !== null) {
                    dst.rebars = ng.rebar.Data.fromObject(src.rebars);
                }
                return dst;
            }

            static toObject(src: ConcreteParameters | null | undefined): ConcreteParameters_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.ConcreteParameters is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.ConcreteParameters") {
                    console.error('Expected ng.foundation.ConcreteParameters but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : ConcreteParameters_json = {
                    mtrlGuid: src.mtrlGuid,
                };
                if(src.rebars !== null)
                {
                    const parsed = ng.rebar.Data.toObject(src.rebars);
                    if(parsed === null) return null;
                    dst.rebars = parsed;
                }
                return dst;
            }

            static create(src?: ConcreteParameters_createType) {
                const dst = new ConcreteParameters();
                if (src === undefined) {
                    return dst;
                }
                if (src.mtrlGuid !== undefined) {
                    dst.mtrlGuid = src.mtrlGuid;
                }
                if (src.rebars !== undefined) {
                    dst.rebars = src.rebars;
                }
                return dst;
            }

            shallowClone() {
                const dst = new ConcreteParameters();
                dst.mtrlGuid = this.mtrlGuid;
                dst.rebars = this.rebars;
                return dst;
            }

            deepClone() {
                const json = ConcreteParameters.toObject(this);
                const dst = ConcreteParameters.fromObject(json);
                return dst;
            }
        }
        export type IConcreteParameters = ConcreteParameters;


        export type SimpleFoundation_keys = 'bedModule' | 'boreholeGuid' | 'geometry' | 'elements' | 'supportGuid' | 'concreteParameters';
        export interface SimpleFoundation_createType {
            bedModule?: number,
            boreholeGuid?: string,
            geometry?: ng.foundation.FoundationGeometry | null,
            elements?: ng.foundation.Elements | null,
            supportGuid?: string,
            concreteParameters?: ng.foundation.ConcreteParameters | null,
        }
        export interface SimpleFoundation_json {
            bedModule?: JsonNumber;
            boreholeGuid?: string;
            geometry?: ng.foundation.FoundationGeometry_json;
            elements?: ng.foundation.Elements_json;
            supportGuid?: string;
            concreteParameters?: ng.foundation.ConcreteParameters_json;
        }
        interface SimpleFoundation_json_in {
            __proto_name?: unknown;
            bedModule?: unknown;
            boreholeGuid?: unknown;
            geometry?: unknown;
            elements?: unknown;
            supportGuid?: unknown;
            concreteParameters?: unknown;
        }
        export class SimpleFoundation {
            __proto_name = "ng.foundation.SimpleFoundation";
            bedModule: number = 0;
            boreholeGuid: string = "";
            geometry: ng.foundation.FoundationGeometry | null = null;
            elements: ng.foundation.Elements | null = null;
            supportGuid: string = "";
            concreteParameters: ng.foundation.ConcreteParameters | null = null;

            static fromObject(src_unknown: unknown): SimpleFoundation {
                const dst = new SimpleFoundation();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted SimpleFoundation but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as SimpleFoundation_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for SimpleFoundation but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.bedModule !== undefined && src.bedModule !== null) {
                    if (typeof src.bedModule === "number" || src.bedModule === 'NaN' || src.bedModule === 'Infinity' || src.bedModule === '-Infinity') {
                        dst.bedModule = AsNum(src.bedModule);
                    }
                    else {
                        console.log('Expected bedModule of SimpleFoundation to be a number but was ', typeof src.bedModule, src.bedModule)
                    }
                }
                if (src.boreholeGuid !== undefined && src.boreholeGuid !== null) {
                    if (typeof src.boreholeGuid === "string") {
                        dst.boreholeGuid = src.boreholeGuid;
                    }
                    else {
                        console.log('Expected boreholeGuid of SimpleFoundation to be a string but was ', typeof src.boreholeGuid, src.boreholeGuid)
                    }
                }
                if (src.geometry !== undefined && src.geometry !== null) {
                    dst.geometry = ng.foundation.FoundationGeometry.fromObject(src.geometry);
                }
                if (src.elements !== undefined && src.elements !== null) {
                    dst.elements = ng.foundation.Elements.fromObject(src.elements);
                }
                if (src.supportGuid !== undefined && src.supportGuid !== null) {
                    if (typeof src.supportGuid === "string") {
                        dst.supportGuid = src.supportGuid;
                    }
                    else {
                        console.log('Expected supportGuid of SimpleFoundation to be a string but was ', typeof src.supportGuid, src.supportGuid)
                    }
                }
                if (src.concreteParameters !== undefined && src.concreteParameters !== null) {
                    dst.concreteParameters = ng.foundation.ConcreteParameters.fromObject(src.concreteParameters);
                }
                return dst;
            }

            static toObject(src: SimpleFoundation | null | undefined): SimpleFoundation_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.SimpleFoundation is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.SimpleFoundation") {
                    console.error('Expected ng.foundation.SimpleFoundation but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : SimpleFoundation_json = {
                    bedModule: AsJsonNum(src.bedModule),
                    boreholeGuid: src.boreholeGuid,
                    supportGuid: src.supportGuid,
                };
                if(src.geometry !== null)
                {
                    const parsed = ng.foundation.FoundationGeometry.toObject(src.geometry);
                    if(parsed === null) return null;
                    dst.geometry = parsed;
                }
                if(src.elements !== null)
                {
                    const parsed = ng.foundation.Elements.toObject(src.elements);
                    if(parsed === null) return null;
                    dst.elements = parsed;
                }
                if(src.concreteParameters !== null)
                {
                    const parsed = ng.foundation.ConcreteParameters.toObject(src.concreteParameters);
                    if(parsed === null) return null;
                    dst.concreteParameters = parsed;
                }
                return dst;
            }

            static create(src?: SimpleFoundation_createType) {
                const dst = new SimpleFoundation();
                if (src === undefined) {
                    return dst;
                }
                if (src.bedModule !== undefined) {
                    dst.bedModule = src.bedModule;
                }
                if (src.boreholeGuid !== undefined) {
                    dst.boreholeGuid = src.boreholeGuid;
                }
                if (src.geometry !== undefined) {
                    dst.geometry = src.geometry;
                }
                if (src.elements !== undefined) {
                    dst.elements = src.elements;
                }
                if (src.supportGuid !== undefined) {
                    dst.supportGuid = src.supportGuid;
                }
                if (src.concreteParameters !== undefined) {
                    dst.concreteParameters = src.concreteParameters;
                }
                return dst;
            }

            shallowClone() {
                const dst = new SimpleFoundation();
                dst.bedModule = this.bedModule;
                dst.boreholeGuid = this.boreholeGuid;
                dst.geometry = this.geometry;
                dst.elements = this.elements;
                dst.supportGuid = this.supportGuid;
                dst.concreteParameters = this.concreteParameters;
                return dst;
            }

            deepClone() {
                const json = SimpleFoundation.toObject(this);
                const dst = SimpleFoundation.fromObject(json);
                return dst;
            }
        }
        export type ISimpleFoundation = SimpleFoundation;


        export type AdvancedFoundation_keys = unknown;
        export interface AdvancedFoundation_createType {
        }
        export interface AdvancedFoundation_json {
        }
        interface AdvancedFoundation_json_in {
            __proto_name?: unknown;
        }
        export class AdvancedFoundation {
            __proto_name = "ng.foundation.AdvancedFoundation";

            static fromObject(src_unknown: unknown): AdvancedFoundation {
                const dst = new AdvancedFoundation();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted AdvancedFoundation but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as AdvancedFoundation_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for AdvancedFoundation but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                return dst;
            }

            static toObject(src: AdvancedFoundation | null | undefined): AdvancedFoundation_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.AdvancedFoundation is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.AdvancedFoundation") {
                    console.error('Expected ng.foundation.AdvancedFoundation but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : AdvancedFoundation_json = {
                };
                return dst;
            }

            static create(src?: AdvancedFoundation_createType) {
                const dst = new AdvancedFoundation();
                if (src === undefined) {
                    return dst;
                }
                return dst;
            }

            shallowClone() {
                const dst = new AdvancedFoundation();
                return dst;
            }

            deepClone() {
                const json = AdvancedFoundation.toObject(this);
                const dst = AdvancedFoundation.fromObject(json);
                return dst;
            }
        }
        export type IAdvancedFoundation = AdvancedFoundation;


        export type Data_keys = 'id' | 'simpleFoundation' | 'advancedFoundation';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            simpleFoundation?: ng.foundation.SimpleFoundation | null,
            advancedFoundation?: ng.foundation.AdvancedFoundation | null,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            simpleFoundation?: ng.foundation.SimpleFoundation_json;
            advancedFoundation?: ng.foundation.AdvancedFoundation_json;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            simpleFoundation?: unknown;
            advancedFoundation?: unknown;
        }
        export class Data {
            __proto_name = "ng.foundation.Data";
            id: ng.utils.ID | null = null;
            // this is a one of
            element: {type: 'simpleFoundation'; simpleFoundation: ng.foundation.SimpleFoundation} | {type: 'advancedFoundation'; advancedFoundation: ng.foundation.AdvancedFoundation} | null = null;

            /** Gets the `SimpleFoundation` value (or null) from the oneof `element` */
            getSimpleFoundation(): ng.foundation.SimpleFoundation | null {
                if(this.element === null) return null;
                if(this.element.type !== 'simpleFoundation') return null;
                return this.element.simpleFoundation;
            }

            /** Sets the `SimpleFoundation` value for the oneof `element`*/
            setSimpleFoundation(value: ng.foundation.SimpleFoundation | null) {
                if(value !== null) {
                    this.element = {type: 'simpleFoundation', simpleFoundation:value};
                }
                else {
                    this.element = null;
                }
            }

            /** Gets the `AdvancedFoundation` value (or null) from the oneof `element` */
            getAdvancedFoundation(): ng.foundation.AdvancedFoundation | null {
                if(this.element === null) return null;
                if(this.element.type !== 'advancedFoundation') return null;
                return this.element.advancedFoundation;
            }

            /** Sets the `AdvancedFoundation` value for the oneof `element`*/
            setAdvancedFoundation(value: ng.foundation.AdvancedFoundation | null) {
                if(value !== null) {
                    this.element = {type: 'advancedFoundation', advancedFoundation:value};
                }
                else {
                    this.element = null;
                }
            }

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.simpleFoundation !== undefined && src.simpleFoundation !== null) {
                    dst.setSimpleFoundation(ng.foundation.SimpleFoundation.fromObject(src.simpleFoundation));
                }
                if (src.advancedFoundation !== undefined && src.advancedFoundation !== null) {
                    dst.setAdvancedFoundation(ng.foundation.AdvancedFoundation.fromObject(src.advancedFoundation));
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.foundation.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.foundation.Data") {
                    console.error('Expected ng.foundation.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                const simpleFoundation = src.getSimpleFoundation();
                if(simpleFoundation !== null)
                {
                    const parsed = ng.foundation.SimpleFoundation.toObject(simpleFoundation);
                    if(parsed === null) return null;
                    dst.simpleFoundation = parsed;
                }
                const advancedFoundation = src.getAdvancedFoundation();
                if(advancedFoundation !== null)
                {
                    const parsed = ng.foundation.AdvancedFoundation.toObject(advancedFoundation);
                    if(parsed === null) return null;
                    dst.advancedFoundation = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                // part of the element oneof 
                if (src.simpleFoundation !== undefined && src.simpleFoundation !== null) {
                    dst.setSimpleFoundation(src.simpleFoundation);
                }
                // part of the element oneof 
                if (src.advancedFoundation !== undefined && src.advancedFoundation !== null) {
                    dst.setAdvancedFoundation(src.advancedFoundation);
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.element = this.element;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace foundation


    // Defined in support.proto
    export namespace support {
        export type Data_keys = 'id';
        export interface Data_createType {
            id?: ng.utils.ID | null,
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
        }
        export class Data {
            __proto_name = "ng.support.Data";
            id: ng.utils.ID | null = null;

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.support.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.support.Data") {
                    console.error('Expected ng.support.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace support


    // Defined in project.proto
    export namespace project {
        export type Data_keys = 'input' | 'output' | 'log';
        export interface Data_createType {
            input?: ng.input.Data | null,
            output?: ng.output.Data | null,
            log?: ng.log.Log | null,
        }
        export interface Data_json {
            input?: ng.input.Data_json;
            output?: ng.output.Data_json;
            log?: ng.log.Log_json;
        }
        interface Data_json_in {
            __proto_name?: unknown;
            input?: unknown;
            output?: unknown;
            log?: unknown;
        }
        export class Data {
            __proto_name = "ng.project.Data";
            input: ng.input.Data | null = null;
            output: ng.output.Data | null = null;
            log: ng.log.Log | null = null;

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.input !== undefined && src.input !== null) {
                    dst.input = ng.input.Data.fromObject(src.input);
                }
                if (src.output !== undefined && src.output !== null) {
                    dst.output = ng.output.Data.fromObject(src.output);
                }
                if (src.log !== undefined && src.log !== null) {
                    dst.log = ng.log.Log.fromObject(src.log);
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.project.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.project.Data") {
                    console.error('Expected ng.project.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                };
                if(src.input !== null)
                {
                    const parsed = ng.input.Data.toObject(src.input);
                    if(parsed === null) return null;
                    dst.input = parsed;
                }
                if(src.output !== null)
                {
                    const parsed = ng.output.Data.toObject(src.output);
                    if(parsed === null) return null;
                    dst.output = parsed;
                }
                if(src.log !== null)
                {
                    const parsed = ng.log.Log.toObject(src.log);
                    if(parsed === null) return null;
                    dst.log = parsed;
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.input !== undefined) {
                    dst.input = src.input;
                }
                if (src.output !== undefined) {
                    dst.output = src.output;
                }
                if (src.log !== undefined) {
                    dst.log = src.log;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.input = this.input;
                dst.output = this.output;
                dst.log = this.log;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace project


    // Defined in input.proto
    export namespace input {
        export type Data_keys = 'id' | 'description' | 'structures' | 'mtrlDb' | 'secDb' | 'ec' | 'consolidate' | 'soilModel' | 'cptMembers';
        export interface Data_createType {
            id?: ng.utils.ID | null,
            description?: string,
            structures?: ng.structure.Data[],
            mtrlDb?: ng.material.Data[],
            secDb?: ng.sections.Section[],
            ec?: ng.eurocode.DesignConfiguration | null,
            consolidate?: boolean,
            soilModel?: ng.soil_model.Data | null,
            cptMembers?: ng.geotechnical.cpt.CptMember[],
        }
        export interface Data_json {
            id?: ng.utils.ID_json;
            description?: string;
            structures: ng.structure.Data_json[];
            mtrlDb: ng.material.Data_json[];
            secDb: ng.sections.Section_json[];
            ec?: ng.eurocode.DesignConfiguration_json;
            consolidate?: boolean;
            soilModel?: ng.soil_model.Data_json;
            cptMembers: ng.geotechnical.cpt.CptMember_json[];
        }
        interface Data_json_in {
            __proto_name?: unknown;
            id?: unknown;
            description?: unknown;
            structures?: unknown;
            mtrlDb?: unknown;
            secDb?: unknown;
            ec?: unknown;
            consolidate?: unknown;
            soilModel?: unknown;
            cptMembers?: unknown;
        }
        export class Data {
            __proto_name = "ng.input.Data";
            id: ng.utils.ID | null = null;
            description: string = "";
            structures: ng.structure.Data[] = [];
            mtrlDb: ng.material.Data[] = [];
            secDb: ng.sections.Section[] = [];
            // this is a one of
            code: {type: 'ec'; ec: ng.eurocode.DesignConfiguration} | null = null;
            consolidate: boolean = false;
            soilModel: ng.soil_model.Data | null = null;
            cptMembers: ng.geotechnical.cpt.CptMember[] = [];

            /** Gets the `Ec` value (or null) from the oneof `code` */
            getEc(): ng.eurocode.DesignConfiguration | null {
                if(this.code === null) return null;
                if(this.code.type !== 'ec') return null;
                return this.code.ec;
            }

            /** Sets the `Ec` value for the oneof `code`*/
            setEc(value: ng.eurocode.DesignConfiguration | null) {
                if(value !== null) {
                    this.code = {type: 'ec', ec:value};
                }
                else {
                    this.code = null;
                }
            }

            static fromObject(src_unknown: unknown): Data {
                const dst = new Data();
                if (src_unknown === null || src_unknown === undefined || typeof src_unknown !== 'object') {
                    console.log('Wanted Data but it was not a object: ', src_unknown);
                    return dst;
                }
                const src = src_unknown as Data_json_in;
                if (src.__proto_name !== undefined) {
                    console.log('Wanted a generic json structure for Data but found a ', src.__proto_name);
                    console.trace();
                    return dst;
                }
                if (src.id !== undefined && src.id !== null) {
                    dst.id = ng.utils.ID.fromObject(src.id);
                }
                if (src.description !== undefined && src.description !== null) {
                    if (typeof src.description === "string") {
                        dst.description = src.description;
                    }
                    else {
                        console.log('Expected description of Data to be a string but was ', typeof src.description, src.description)
                    }
                }
                if (src.structures !== undefined && src.structures !== null) {
                    if (Array.isArray(src.structures)) {
                        for (const element of src.structures) {
                            dst.structures.push(ng.structure.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected structures of Data to be a array but was ', typeof src.structures, src.structures)
                    }
                }
                if (src.mtrlDb !== undefined && src.mtrlDb !== null) {
                    if (Array.isArray(src.mtrlDb)) {
                        for (const element of src.mtrlDb) {
                            dst.mtrlDb.push(ng.material.Data.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected mtrlDb of Data to be a array but was ', typeof src.mtrlDb, src.mtrlDb)
                    }
                }
                if (src.secDb !== undefined && src.secDb !== null) {
                    if (Array.isArray(src.secDb)) {
                        for (const element of src.secDb) {
                            dst.secDb.push(ng.sections.Section.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected secDb of Data to be a array but was ', typeof src.secDb, src.secDb)
                    }
                }
                if (src.ec !== undefined && src.ec !== null) {
                    dst.setEc(ng.eurocode.DesignConfiguration.fromObject(src.ec));
                }
                if (src.consolidate !== undefined && src.consolidate !== null) {
                    if (typeof src.consolidate === "boolean") {
                        dst.consolidate = src.consolidate;
                    }
                    else {
                        console.log('Expected consolidate of Data to be a boolean but was ', typeof src.consolidate, src.consolidate)
                    }
                }
                if (src.soilModel !== undefined && src.soilModel !== null) {
                    dst.soilModel = ng.soil_model.Data.fromObject(src.soilModel);
                }
                if (src.cptMembers !== undefined && src.cptMembers !== null) {
                    if (Array.isArray(src.cptMembers)) {
                        for (const element of src.cptMembers) {
                            dst.cptMembers.push(ng.geotechnical.cpt.CptMember.fromObject(element));
                        }
                    }
                    else {
                        console.log('Expected cptMembers of Data to be a array but was ', typeof src.cptMembers, src.cptMembers)
                    }
                }
                return dst;
            }

            static toObject(src: Data | null | undefined): Data_json | null {
                if (src === null) { return null; }
                if (src === undefined) { console.warn('ng.input.Data is undefined!!!'); return null; }
                if (src.__proto_name !== "ng.input.Data") {
                    console.error('Expected ng.input.Data but got ', src.__proto_name);
                    console.trace();
                    return null;
                }
                const dst : Data_json = {
                    description: src.description,
                    structures: new Array<ng.structure.Data_json>(),
                    mtrlDb: new Array<ng.material.Data_json>(),
                    secDb: new Array<ng.sections.Section_json>(),
                    consolidate: src.consolidate,
                    cptMembers: new Array<ng.geotechnical.cpt.CptMember_json>(),
                };
                if(src.id !== null)
                {
                    const parsed = ng.utils.ID.toObject(src.id);
                    if(parsed === null) return null;
                    dst.id = parsed;
                }
                if (src.structures !== null) {
                    for (const element of src.structures) {
                        const parsed = ng.structure.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.structures.push(parsed);
                    }
                }
                if (src.mtrlDb !== null) {
                    for (const element of src.mtrlDb) {
                        const parsed = ng.material.Data.toObject(element);
                        if(parsed === null) return null;
                        dst.mtrlDb.push(parsed);
                    }
                }
                if (src.secDb !== null) {
                    for (const element of src.secDb) {
                        const parsed = ng.sections.Section.toObject(element);
                        if(parsed === null) return null;
                        dst.secDb.push(parsed);
                    }
                }
                const ec = src.getEc();
                if(ec !== null)
                {
                    const parsed = ng.eurocode.DesignConfiguration.toObject(ec);
                    if(parsed === null) return null;
                    dst.ec = parsed;
                }
                if(src.soilModel !== null)
                {
                    const parsed = ng.soil_model.Data.toObject(src.soilModel);
                    if(parsed === null) return null;
                    dst.soilModel = parsed;
                }
                if (src.cptMembers !== null) {
                    for (const element of src.cptMembers) {
                        const parsed = ng.geotechnical.cpt.CptMember.toObject(element);
                        if(parsed === null) return null;
                        dst.cptMembers.push(parsed);
                    }
                }
                return dst;
            }

            static create(src?: Data_createType) {
                const dst = new Data();
                if (src === undefined) {
                    return dst;
                }
                if (src.id !== undefined) {
                    dst.id = src.id;
                }
                if (src.description !== undefined) {
                    dst.description = src.description;
                }
                if (src.structures !== undefined) {
                    dst.structures = src.structures;
                }
                if (src.mtrlDb !== undefined) {
                    dst.mtrlDb = src.mtrlDb;
                }
                if (src.secDb !== undefined) {
                    dst.secDb = src.secDb;
                }
                // part of the code oneof 
                if (src.ec !== undefined && src.ec !== null) {
                    dst.setEc(src.ec);
                }
                if (src.consolidate !== undefined) {
                    dst.consolidate = src.consolidate;
                }
                if (src.soilModel !== undefined) {
                    dst.soilModel = src.soilModel;
                }
                if (src.cptMembers !== undefined) {
                    dst.cptMembers = src.cptMembers;
                }
                return dst;
            }

            shallowClone() {
                const dst = new Data();
                dst.id = this.id;
                dst.description = this.description;
                dst.structures = this.structures;
                dst.mtrlDb = this.mtrlDb;
                dst.secDb = this.secDb;
                dst.code = this.code;
                dst.consolidate = this.consolidate;
                dst.soilModel = this.soilModel;
                dst.cptMembers = this.cptMembers;
                return dst;
            }

            deepClone() {
                const json = Data.toObject(this);
                const dst = Data.fromObject(json);
                return dst;
            }
        }
        export type IData = Data;
    } // namespace input
} // namespace ng
